// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("data:image/svg+xml,%3csvg xmlns=%27http://www.w3.org/2000/svg%27 viewBox=%270 0 16 16%27%3e%3cpath fill=%27none%27 stroke=%27%237E8299%27 stroke-linecap=%27round%27 stroke-linejoin=%27round%27 stroke-width=%272%27 d=%27m2 5 6 6 6-6%27/%3e%3c/svg%3e", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_1___ = new URL("data:image/svg+xml,%3csvg xmlns=%27http://www.w3.org/2000/svg%27 viewBox=%270 0 16 16%27%3e%3cpath fill=%27none%27 stroke=%27%236D6D80%27 stroke-linecap=%27round%27 stroke-linejoin=%27round%27 stroke-width=%272%27 d=%27m2 5 6 6 6-6%27/%3e%3c/svg%3e", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_2___ = new URL("data:image/svg+xml,%3csvg xmlns=%27http://www.w3.org/2000/svg%27 viewBox=%270 0 13 11%27 width=%2713%27 height=%2711%27 fill=%27none%27%3e%3cpath d=%27M11.0426 1.02893C11.3258 0.695792 11.8254 0.655283 12.1585 0.938451C12.4917 1.22162 12.5322 1.72124 12.249 2.05437L5.51985 9.97104C5.23224 10.3094 4.72261 10.3451 4.3907 10.05L0.828197 6.88335C0.50141 6.59288 0.471975 6.09249 0.762452 5.7657C1.05293 5.43891 1.55332 5.40948 1.88011 5.69995L4.83765 8.32889L11.0426 1.02893Z%27 fill=%27%23ffffff%27/%3e%3c/svg%3e", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_3___ = new URL("data:image/svg+xml,%3csvg xmlns=%27http://www.w3.org/2000/svg%27 viewBox=%27-4 -4 8 8%27%3e%3ccircle r=%272%27 fill=%27%23ffffff%27/%3e%3c/svg%3e", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_4___ = new URL("data:image/svg+xml,%3csvg xmlns=%27http://www.w3.org/2000/svg%27 viewBox=%270 0 20 20%27%3e%3cpath fill=%27none%27 stroke=%27%23ffffff%27 stroke-linecap=%27round%27 stroke-linejoin=%27round%27 stroke-width=%273%27 d=%27M6 10h8%27/%3e%3c/svg%3e", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_5___ = new URL("data:image/svg+xml,%3csvg xmlns=%27http://www.w3.org/2000/svg%27 viewBox=%27-4 -4 8 8%27%3e%3ccircle r=%273%27 fill=%27rgba%280, 0, 0, 0.25%29%27/%3e%3c/svg%3e", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_6___ = new URL("data:image/svg+xml,%3csvg xmlns=%27http://www.w3.org/2000/svg%27 viewBox=%27-4 -4 8 8%27%3e%3ccircle r=%273%27 fill=%27%23ffffff%27/%3e%3c/svg%3e", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_7___ = new URL("data:image/svg+xml,%3csvg xmlns=%27http://www.w3.org/2000/svg%27 viewBox=%27-4 -4 8 8%27%3e%3ccircle r=%273%27 fill=%27rgba%28255, 255, 255, 0.25%29%27/%3e%3c/svg%3e", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_8___ = new URL("data:image/svg+xml,%3csvg xmlns=%27http://www.w3.org/2000/svg%27 viewBox=%270 0 8 8%27%3e%3cpath fill=%27%2350cd89%27 d=%27M2.3 6.73.6 4.53c-.4-1.04.46-1.4 1.1-.8l1.1 1.4 3.4-3.8c.6-.63 1.6-.27 1.2.7l-4 4.6c-.43.5-.8.4-1.1.1z%27/%3e%3c/svg%3e", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_9___ = new URL("data:image/svg+xml,%3csvg xmlns=%27http://www.w3.org/2000/svg%27 viewBox=%270 0 12 12%27 width=%2712%27 height=%2712%27 fill=%27none%27 stroke=%27%23f1416c%27%3e%3ccircle cx=%276%27 cy=%276%27 r=%274.5%27/%3e%3cpath stroke-linejoin=%27round%27 d=%27M5.8 3.6h.4L6 6.5z%27/%3e%3ccircle cx=%276%27 cy=%278.2%27 r=%27.6%27 fill=%27%23f1416c%27 stroke=%27none%27/%3e%3c/svg%3e", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_10___ = new URL("data:image/svg+xml,%3csvg xmlns=%27http://www.w3.org/2000/svg%27 viewBox=%270 0 30 30%27%3e%3cpath stroke=%27rgba%2824, 28, 50, 0.75%29%27 stroke-linecap=%27round%27 stroke-miterlimit=%2710%27 stroke-width=%272%27 d=%27M4 7h22M4 15h22M4 23h22%27/%3e%3c/svg%3e", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_11___ = new URL("data:image/svg+xml,%3csvg xmlns=%27http://www.w3.org/2000/svg%27 viewBox=%270 0 30 30%27%3e%3cpath stroke=%27rgba%28255, 255, 255, 0.55%29%27 stroke-linecap=%27round%27 stroke-miterlimit=%2710%27 stroke-width=%272%27 d=%27M4 7h22M4 15h22M4 23h22%27/%3e%3c/svg%3e", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_12___ = new URL("data:image/svg+xml,%3csvg xmlns=%27http://www.w3.org/2000/svg%27 viewBox=%270 0 16 16%27 fill=%27%23181C32%27%3e%3cpath fill-rule=%27evenodd%27 d=%27M1.646 4.646a.5.5 0 0 1 .708 0L8 10.293l5.646-5.647a.5.5 0 0 1 .708.708l-6 6a.5.5 0 0 1-.708 0l-6-6a.5.5 0 0 1 0-.708z%27/%3e%3c/svg%3e", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_13___ = new URL("data:image/svg+xml,%3csvg xmlns=%27http://www.w3.org/2000/svg%27 viewBox=%270 0 16 16%27 fill=%27%23009ef7%27%3e%3cpath fill-rule=%27evenodd%27 d=%27M1.646 4.646a.5.5 0 0 1 .708 0L8 10.293l5.646-5.647a.5.5 0 0 1 .708.708l-6 6a.5.5 0 0 1-.708 0l-6-6a.5.5 0 0 1 0-.708z%27/%3e%3c/svg%3e", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_14___ = new URL("data:image/svg+xml,%3csvg xmlns=%27http://www.w3.org/2000/svg%27 viewBox=%270 0 16 16%27 fill=%27%23FFFFFF%27%3e%3cpath fill-rule=%27evenodd%27 d=%27M1.646 4.646a.5.5 0 0 1 .708 0L8 10.293l5.646-5.647a.5.5 0 0 1 .708.708l-6 6a.5.5 0 0 1-.708 0l-6-6a.5.5 0 0 1 0-.708z%27/%3e%3c/svg%3e", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_15___ = new URL("data:image/svg+xml,%3csvg xmlns=%27http://www.w3.org/2000/svg%27 viewBox=%270 0 16 16%27 fill=%27%23000000%27%3e%3cpath d=%27M.293.293a1 1 0 0 1 1.414 0L8 6.586 14.293.293a1 1 0 1 1 1.414 1.414L9.414 8l6.293 6.293a1 1 0 0 1-1.414 1.414L8 9.414l-6.293 6.293a1 1 0 0 1-1.414-1.414L6.586 8 .293 1.707a1 1 0 0 1 0-1.414z%27/%3e%3c/svg%3e", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_16___ = new URL("data:image/svg+xml,%3csvg xmlns=%27http://www.w3.org/2000/svg%27 viewBox=%270 0 16 16%27 fill=%27%23ffffff%27%3e%3cpath d=%27M11.354 1.646a.5.5 0 0 1 0 .708L5.707 8l5.647 5.646a.5.5 0 0 1-.708.708l-6-6a.5.5 0 0 1 0-.708l6-6a.5.5 0 0 1 .708 0z%27/%3e%3c/svg%3e", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_17___ = new URL("data:image/svg+xml,%3csvg xmlns=%27http://www.w3.org/2000/svg%27 viewBox=%270 0 16 16%27 fill=%27%23ffffff%27%3e%3cpath d=%27M4.646 1.646a.5.5 0 0 1 .708 0l6 6a.5.5 0 0 1 0 .708l-6 6a.5.5 0 0 1-.708-.708L10.293 8 4.646 2.354a.5.5 0 0 1 0-.708z%27/%3e%3c/svg%3e", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_18___ = new URL("data:image/svg+xml,%3csvg xmlns=%27http://www.w3.org/2000/svg%27 viewBox=%270 0 6 6%27 fill=%27var%28--bs-gray-700%29%27%3e%3cpath d=%27M2.72011 2.76429L4.46358 1.02083C4.63618 0.848244 4.63617 0.568419 4.46358 0.395831C4.29099 0.223244 4.01118 0.223244 3.83861 0.395831L1.52904 2.70537C1.36629 2.86808 1.36629 3.13191 1.52904 3.29462L3.83861 5.60419C4.01117 5.77675 4.29099 5.77675 4.46358 5.60419C4.63617 5.43156 4.63617 5.15175 4.46358 4.97919L2.72011 3.23571C2.58994 3.10554 2.58994 2.89446 2.72011 2.76429Z%27/%3e%3c/svg%3e", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_19___ = new URL("data:image/svg+xml,%3csvg xmlns=%27http://www.w3.org/2000/svg%27 viewBox=%270 0 6 6%27 fill=%27var%28--bs-gray-700%29%27%3e%3cpath d=%27M3.27989 3.23571L1.53642 4.97917C1.36382 5.15176 1.36383 5.43158 1.53642 5.60417C1.70901 5.77676 1.98882 5.77676 2.16139 5.60417L4.47096 3.29463C4.63371 3.13192 4.63371 2.86809 4.47096 2.70538L2.16139 0.395812C1.98883 0.22325 1.70901 0.22325 1.53642 0.395812C1.36383 0.568437 1.36383 0.84825 1.53642 1.02081L3.27989 2.76429C3.41006 2.89446 3.41006 3.10554 3.27989 3.23571Z%27/%3e%3c/svg%3e", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_20___ = new URL("data:image/svg+xml,%3csvg xmlns=%27http://www.w3.org/2000/svg%27 viewBox=%270 0 6 6%27 fill=%27var%28--bs-pagination-focus-color%29%27%3e%3cpath d=%27M2.72011 2.76429L4.46358 1.02083C4.63618 0.848244 4.63617 0.568419 4.46358 0.395831C4.29099 0.223244 4.01118 0.223244 3.83861 0.395831L1.52904 2.70537C1.36629 2.86808 1.36629 3.13191 1.52904 3.29462L3.83861 5.60419C4.01117 5.77675 4.29099 5.77675 4.46358 5.60419C4.63617 5.43156 4.63617 5.15175 4.46358 4.97919L2.72011 3.23571C2.58994 3.10554 2.58994 2.89446 2.72011 2.76429Z%27/%3e%3c/svg%3e", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_21___ = new URL("data:image/svg+xml,%3csvg xmlns=%27http://www.w3.org/2000/svg%27 viewBox=%270 0 6 6%27 fill=%27var%28--bs-pagination-focus-color%29%27%3e%3cpath d=%27M3.27989 3.23571L1.53642 4.97917C1.36382 5.15176 1.36383 5.43158 1.53642 5.60417C1.70901 5.77676 1.98882 5.77676 2.16139 5.60417L4.47096 3.29463C4.63371 3.13192 4.63371 2.86809 4.47096 2.70538L2.16139 0.395812C1.98883 0.22325 1.70901 0.22325 1.53642 0.395812C1.36383 0.568437 1.36383 0.84825 1.53642 1.02081L3.27989 2.76429C3.41006 2.89446 3.41006 3.10554 3.27989 3.23571Z%27/%3e%3c/svg%3e", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_22___ = new URL("data:image/svg+xml,%3csvg xmlns=%27http://www.w3.org/2000/svg%27 viewBox=%270 0 6 6%27 fill=%27var%28--bs-pagination-hover-color%29%27%3e%3cpath d=%27M2.72011 2.76429L4.46358 1.02083C4.63618 0.848244 4.63617 0.568419 4.46358 0.395831C4.29099 0.223244 4.01118 0.223244 3.83861 0.395831L1.52904 2.70537C1.36629 2.86808 1.36629 3.13191 1.52904 3.29462L3.83861 5.60419C4.01117 5.77675 4.29099 5.77675 4.46358 5.60419C4.63617 5.43156 4.63617 5.15175 4.46358 4.97919L2.72011 3.23571C2.58994 3.10554 2.58994 2.89446 2.72011 2.76429Z%27/%3e%3c/svg%3e", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_23___ = new URL("data:image/svg+xml,%3csvg xmlns=%27http://www.w3.org/2000/svg%27 viewBox=%270 0 6 6%27 fill=%27var%28--bs-pagination-hover-color%29%27%3e%3cpath d=%27M3.27989 3.23571L1.53642 4.97917C1.36382 5.15176 1.36383 5.43158 1.53642 5.60417C1.70901 5.77676 1.98882 5.77676 2.16139 5.60417L4.47096 3.29463C4.63371 3.13192 4.63371 2.86809 4.47096 2.70538L2.16139 0.395812C1.98883 0.22325 1.70901 0.22325 1.53642 0.395812C1.36383 0.568437 1.36383 0.84825 1.53642 1.02081L3.27989 2.76429C3.41006 2.89446 3.41006 3.10554 3.27989 3.23571Z%27/%3e%3c/svg%3e", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_24___ = new URL("data:image/svg+xml,%3csvg xmlns=%27http://www.w3.org/2000/svg%27 viewBox=%270 0 6 6%27 fill=%27var%28--bs-pagination-active-color%29%27%3e%3cpath d=%27M2.72011 2.76429L4.46358 1.02083C4.63618 0.848244 4.63617 0.568419 4.46358 0.395831C4.29099 0.223244 4.01118 0.223244 3.83861 0.395831L1.52904 2.70537C1.36629 2.86808 1.36629 3.13191 1.52904 3.29462L3.83861 5.60419C4.01117 5.77675 4.29099 5.77675 4.46358 5.60419C4.63617 5.43156 4.63617 5.15175 4.46358 4.97919L2.72011 3.23571C2.58994 3.10554 2.58994 2.89446 2.72011 2.76429Z%27/%3e%3c/svg%3e", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_25___ = new URL("data:image/svg+xml,%3csvg xmlns=%27http://www.w3.org/2000/svg%27 viewBox=%270 0 6 6%27 fill=%27var%28--bs-pagination-active-color%29%27%3e%3cpath d=%27M3.27989 3.23571L1.53642 4.97917C1.36382 5.15176 1.36383 5.43158 1.53642 5.60417C1.70901 5.77676 1.98882 5.77676 2.16139 5.60417L4.47096 3.29463C4.63371 3.13192 4.63371 2.86809 4.47096 2.70538L2.16139 0.395812C1.98883 0.22325 1.70901 0.22325 1.53642 0.395812C1.36383 0.568437 1.36383 0.84825 1.53642 1.02081L3.27989 2.76429C3.41006 2.89446 3.41006 3.10554 3.27989 3.23571Z%27/%3e%3c/svg%3e", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_26___ = new URL("data:image/svg+xml,%3csvg xmlns=%27http://www.w3.org/2000/svg%27 viewBox=%270 0 6 6%27 fill=%27var%28--bs-pagination-disabled-color%29%27%3e%3cpath d=%27M2.72011 2.76429L4.46358 1.02083C4.63618 0.848244 4.63617 0.568419 4.46358 0.395831C4.29099 0.223244 4.01118 0.223244 3.83861 0.395831L1.52904 2.70537C1.36629 2.86808 1.36629 3.13191 1.52904 3.29462L3.83861 5.60419C4.01117 5.77675 4.29099 5.77675 4.46358 5.60419C4.63617 5.43156 4.63617 5.15175 4.46358 4.97919L2.72011 3.23571C2.58994 3.10554 2.58994 2.89446 2.72011 2.76429Z%27/%3e%3c/svg%3e", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_27___ = new URL("data:image/svg+xml,%3csvg xmlns=%27http://www.w3.org/2000/svg%27 viewBox=%270 0 6 6%27 fill=%27var%28--bs-pagination-disabled-color%29%27%3e%3cpath d=%27M3.27989 3.23571L1.53642 4.97917C1.36382 5.15176 1.36383 5.43158 1.53642 5.60417C1.70901 5.77676 1.98882 5.77676 2.16139 5.60417L4.47096 3.29463C4.63371 3.13192 4.63371 2.86809 4.47096 2.70538L2.16139 0.395812C1.98883 0.22325 1.70901 0.22325 1.53642 0.395812C1.36383 0.568437 1.36383 0.84825 1.53642 1.02081L3.27989 2.76429C3.41006 2.89446 3.41006 3.10554 3.27989 3.23571Z%27/%3e%3c/svg%3e", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_28___ = new URL("data:image/svg+xml,%3csvg xmlns=%27http://www.w3.org/2000/svg%27 viewBox=%270 0 6 6%27 fill=%27var%28--bs-text-muted%29%27%3e%3cpath d=%27M2.72011 2.76429L4.46358 1.02083C4.63618 0.848244 4.63617 0.568419 4.46358 0.395831C4.29099 0.223244 4.01118 0.223244 3.83861 0.395831L1.52904 2.70537C1.36629 2.86808 1.36629 3.13191 1.52904 3.29462L3.83861 5.60419C4.01117 5.77675 4.29099 5.77675 4.46358 5.60419C4.63617 5.43156 4.63617 5.15175 4.46358 4.97919L2.72011 3.23571C2.58994 3.10554 2.58994 2.89446 2.72011 2.76429Z%27/%3e%3c/svg%3e", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_29___ = new URL("data:image/svg+xml,%3csvg xmlns=%27http://www.w3.org/2000/svg%27 viewBox=%270 0 6 6%27 fill=%27var%28--bs-text-muted%29%27%3e%3cpath d=%27M3.27989 3.23571L1.53642 4.97917C1.36382 5.15176 1.36383 5.43158 1.53642 5.60417C1.70901 5.77676 1.98882 5.77676 2.16139 5.60417L4.47096 3.29463C4.63371 3.13192 4.63371 2.86809 4.47096 2.70538L2.16139 0.395812C1.98883 0.22325 1.70901 0.22325 1.53642 0.395812C1.36383 0.568437 1.36383 0.84825 1.53642 1.02081L3.27989 2.76429C3.41006 2.89446 3.41006 3.10554 3.27989 3.23571Z%27/%3e%3c/svg%3e", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_30___ = new URL("data:image/svg+xml,%3csvg xmlns=%27http://www.w3.org/2000/svg%27 viewBox=%270 0 6 6%27 fill=%27var%28--bs-white%29%27%3e%3cpath d=%27M2.72011 2.76429L4.46358 1.02083C4.63618 0.848244 4.63617 0.568419 4.46358 0.395831C4.29099 0.223244 4.01118 0.223244 3.83861 0.395831L1.52904 2.70537C1.36629 2.86808 1.36629 3.13191 1.52904 3.29462L3.83861 5.60419C4.01117 5.77675 4.29099 5.77675 4.46358 5.60419C4.63617 5.43156 4.63617 5.15175 4.46358 4.97919L2.72011 3.23571C2.58994 3.10554 2.58994 2.89446 2.72011 2.76429Z%27/%3e%3c/svg%3e", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_31___ = new URL("data:image/svg+xml,%3csvg xmlns=%27http://www.w3.org/2000/svg%27 viewBox=%270 0 6 6%27 fill=%27var%28--bs-white%29%27%3e%3cpath d=%27M3.27989 3.23571L1.53642 4.97917C1.36382 5.15176 1.36383 5.43158 1.53642 5.60417C1.70901 5.77676 1.98882 5.77676 2.16139 5.60417L4.47096 3.29463C4.63371 3.13192 4.63371 2.86809 4.47096 2.70538L2.16139 0.395812C1.98883 0.22325 1.70901 0.22325 1.53642 0.395812C1.36383 0.568437 1.36383 0.84825 1.53642 1.02081L3.27989 2.76429C3.41006 2.89446 3.41006 3.10554 3.27989 3.23571Z%27/%3e%3c/svg%3e", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_32___ = new URL("data:image/svg+xml,%3csvg xmlns=%27http://www.w3.org/2000/svg%27 viewBox=%270 0 6 6%27 fill=%27var%28--bs-text-white%29%27%3e%3cpath d=%27M2.72011 2.76429L4.46358 1.02083C4.63618 0.848244 4.63617 0.568419 4.46358 0.395831C4.29099 0.223244 4.01118 0.223244 3.83861 0.395831L1.52904 2.70537C1.36629 2.86808 1.36629 3.13191 1.52904 3.29462L3.83861 5.60419C4.01117 5.77675 4.29099 5.77675 4.46358 5.60419C4.63617 5.43156 4.63617 5.15175 4.46358 4.97919L2.72011 3.23571C2.58994 3.10554 2.58994 2.89446 2.72011 2.76429Z%27/%3e%3c/svg%3e", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_33___ = new URL("data:image/svg+xml,%3csvg xmlns=%27http://www.w3.org/2000/svg%27 viewBox=%270 0 6 6%27 fill=%27var%28--bs-text-white%29%27%3e%3cpath d=%27M3.27989 3.23571L1.53642 4.97917C1.36382 5.15176 1.36383 5.43158 1.53642 5.60417C1.70901 5.77676 1.98882 5.77676 2.16139 5.60417L4.47096 3.29463C4.63371 3.13192 4.63371 2.86809 4.47096 2.70538L2.16139 0.395812C1.98883 0.22325 1.70901 0.22325 1.53642 0.395812C1.36383 0.568437 1.36383 0.84825 1.53642 1.02081L3.27989 2.76429C3.41006 2.89446 3.41006 3.10554 3.27989 3.23571Z%27/%3e%3c/svg%3e", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_34___ = new URL("data:image/svg+xml,%3csvg xmlns=%27http://www.w3.org/2000/svg%27 viewBox=%270 0 6 6%27 fill=%27var%28--bs-primary%29%27%3e%3cpath d=%27M2.72011 2.76429L4.46358 1.02083C4.63618 0.848244 4.63617 0.568419 4.46358 0.395831C4.29099 0.223244 4.01118 0.223244 3.83861 0.395831L1.52904 2.70537C1.36629 2.86808 1.36629 3.13191 1.52904 3.29462L3.83861 5.60419C4.01117 5.77675 4.29099 5.77675 4.46358 5.60419C4.63617 5.43156 4.63617 5.15175 4.46358 4.97919L2.72011 3.23571C2.58994 3.10554 2.58994 2.89446 2.72011 2.76429Z%27/%3e%3c/svg%3e", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_35___ = new URL("data:image/svg+xml,%3csvg xmlns=%27http://www.w3.org/2000/svg%27 viewBox=%270 0 6 6%27 fill=%27var%28--bs-primary%29%27%3e%3cpath d=%27M3.27989 3.23571L1.53642 4.97917C1.36382 5.15176 1.36383 5.43158 1.53642 5.60417C1.70901 5.77676 1.98882 5.77676 2.16139 5.60417L4.47096 3.29463C4.63371 3.13192 4.63371 2.86809 4.47096 2.70538L2.16139 0.395812C1.98883 0.22325 1.70901 0.22325 1.53642 0.395812C1.36383 0.568437 1.36383 0.84825 1.53642 1.02081L3.27989 2.76429C3.41006 2.89446 3.41006 3.10554 3.27989 3.23571Z%27/%3e%3c/svg%3e", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_36___ = new URL("data:image/svg+xml,%3csvg xmlns=%27http://www.w3.org/2000/svg%27 viewBox=%270 0 6 6%27 fill=%27var%28--bs-text-primary%29%27%3e%3cpath d=%27M2.72011 2.76429L4.46358 1.02083C4.63618 0.848244 4.63617 0.568419 4.46358 0.395831C4.29099 0.223244 4.01118 0.223244 3.83861 0.395831L1.52904 2.70537C1.36629 2.86808 1.36629 3.13191 1.52904 3.29462L3.83861 5.60419C4.01117 5.77675 4.29099 5.77675 4.46358 5.60419C4.63617 5.43156 4.63617 5.15175 4.46358 4.97919L2.72011 3.23571C2.58994 3.10554 2.58994 2.89446 2.72011 2.76429Z%27/%3e%3c/svg%3e", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_37___ = new URL("data:image/svg+xml,%3csvg xmlns=%27http://www.w3.org/2000/svg%27 viewBox=%270 0 6 6%27 fill=%27var%28--bs-text-primary%29%27%3e%3cpath d=%27M3.27989 3.23571L1.53642 4.97917C1.36382 5.15176 1.36383 5.43158 1.53642 5.60417C1.70901 5.77676 1.98882 5.77676 2.16139 5.60417L4.47096 3.29463C4.63371 3.13192 4.63371 2.86809 4.47096 2.70538L2.16139 0.395812C1.98883 0.22325 1.70901 0.22325 1.53642 0.395812C1.36383 0.568437 1.36383 0.84825 1.53642 1.02081L3.27989 2.76429C3.41006 2.89446 3.41006 3.10554 3.27989 3.23571Z%27/%3e%3c/svg%3e", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_38___ = new URL("data:image/svg+xml,%3csvg xmlns=%27http://www.w3.org/2000/svg%27 viewBox=%270 0 6 6%27 fill=%27var%28--bs-secondary%29%27%3e%3cpath d=%27M2.72011 2.76429L4.46358 1.02083C4.63618 0.848244 4.63617 0.568419 4.46358 0.395831C4.29099 0.223244 4.01118 0.223244 3.83861 0.395831L1.52904 2.70537C1.36629 2.86808 1.36629 3.13191 1.52904 3.29462L3.83861 5.60419C4.01117 5.77675 4.29099 5.77675 4.46358 5.60419C4.63617 5.43156 4.63617 5.15175 4.46358 4.97919L2.72011 3.23571C2.58994 3.10554 2.58994 2.89446 2.72011 2.76429Z%27/%3e%3c/svg%3e", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_39___ = new URL("data:image/svg+xml,%3csvg xmlns=%27http://www.w3.org/2000/svg%27 viewBox=%270 0 6 6%27 fill=%27var%28--bs-secondary%29%27%3e%3cpath d=%27M3.27989 3.23571L1.53642 4.97917C1.36382 5.15176 1.36383 5.43158 1.53642 5.60417C1.70901 5.77676 1.98882 5.77676 2.16139 5.60417L4.47096 3.29463C4.63371 3.13192 4.63371 2.86809 4.47096 2.70538L2.16139 0.395812C1.98883 0.22325 1.70901 0.22325 1.53642 0.395812C1.36383 0.568437 1.36383 0.84825 1.53642 1.02081L3.27989 2.76429C3.41006 2.89446 3.41006 3.10554 3.27989 3.23571Z%27/%3e%3c/svg%3e", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_40___ = new URL("data:image/svg+xml,%3csvg xmlns=%27http://www.w3.org/2000/svg%27 viewBox=%270 0 6 6%27 fill=%27var%28--bs-text-secondary%29%27%3e%3cpath d=%27M2.72011 2.76429L4.46358 1.02083C4.63618 0.848244 4.63617 0.568419 4.46358 0.395831C4.29099 0.223244 4.01118 0.223244 3.83861 0.395831L1.52904 2.70537C1.36629 2.86808 1.36629 3.13191 1.52904 3.29462L3.83861 5.60419C4.01117 5.77675 4.29099 5.77675 4.46358 5.60419C4.63617 5.43156 4.63617 5.15175 4.46358 4.97919L2.72011 3.23571C2.58994 3.10554 2.58994 2.89446 2.72011 2.76429Z%27/%3e%3c/svg%3e", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_41___ = new URL("data:image/svg+xml,%3csvg xmlns=%27http://www.w3.org/2000/svg%27 viewBox=%270 0 6 6%27 fill=%27var%28--bs-text-secondary%29%27%3e%3cpath d=%27M3.27989 3.23571L1.53642 4.97917C1.36382 5.15176 1.36383 5.43158 1.53642 5.60417C1.70901 5.77676 1.98882 5.77676 2.16139 5.60417L4.47096 3.29463C4.63371 3.13192 4.63371 2.86809 4.47096 2.70538L2.16139 0.395812C1.98883 0.22325 1.70901 0.22325 1.53642 0.395812C1.36383 0.568437 1.36383 0.84825 1.53642 1.02081L3.27989 2.76429C3.41006 2.89446 3.41006 3.10554 3.27989 3.23571Z%27/%3e%3c/svg%3e", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_42___ = new URL("data:image/svg+xml,%3csvg xmlns=%27http://www.w3.org/2000/svg%27 viewBox=%270 0 6 6%27 fill=%27var%28--bs-light%29%27%3e%3cpath d=%27M2.72011 2.76429L4.46358 1.02083C4.63618 0.848244 4.63617 0.568419 4.46358 0.395831C4.29099 0.223244 4.01118 0.223244 3.83861 0.395831L1.52904 2.70537C1.36629 2.86808 1.36629 3.13191 1.52904 3.29462L3.83861 5.60419C4.01117 5.77675 4.29099 5.77675 4.46358 5.60419C4.63617 5.43156 4.63617 5.15175 4.46358 4.97919L2.72011 3.23571C2.58994 3.10554 2.58994 2.89446 2.72011 2.76429Z%27/%3e%3c/svg%3e", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_43___ = new URL("data:image/svg+xml,%3csvg xmlns=%27http://www.w3.org/2000/svg%27 viewBox=%270 0 6 6%27 fill=%27var%28--bs-light%29%27%3e%3cpath d=%27M3.27989 3.23571L1.53642 4.97917C1.36382 5.15176 1.36383 5.43158 1.53642 5.60417C1.70901 5.77676 1.98882 5.77676 2.16139 5.60417L4.47096 3.29463C4.63371 3.13192 4.63371 2.86809 4.47096 2.70538L2.16139 0.395812C1.98883 0.22325 1.70901 0.22325 1.53642 0.395812C1.36383 0.568437 1.36383 0.84825 1.53642 1.02081L3.27989 2.76429C3.41006 2.89446 3.41006 3.10554 3.27989 3.23571Z%27/%3e%3c/svg%3e", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_44___ = new URL("data:image/svg+xml,%3csvg xmlns=%27http://www.w3.org/2000/svg%27 viewBox=%270 0 6 6%27 fill=%27var%28--bs-text-light%29%27%3e%3cpath d=%27M2.72011 2.76429L4.46358 1.02083C4.63618 0.848244 4.63617 0.568419 4.46358 0.395831C4.29099 0.223244 4.01118 0.223244 3.83861 0.395831L1.52904 2.70537C1.36629 2.86808 1.36629 3.13191 1.52904 3.29462L3.83861 5.60419C4.01117 5.77675 4.29099 5.77675 4.46358 5.60419C4.63617 5.43156 4.63617 5.15175 4.46358 4.97919L2.72011 3.23571C2.58994 3.10554 2.58994 2.89446 2.72011 2.76429Z%27/%3e%3c/svg%3e", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_45___ = new URL("data:image/svg+xml,%3csvg xmlns=%27http://www.w3.org/2000/svg%27 viewBox=%270 0 6 6%27 fill=%27var%28--bs-text-light%29%27%3e%3cpath d=%27M3.27989 3.23571L1.53642 4.97917C1.36382 5.15176 1.36383 5.43158 1.53642 5.60417C1.70901 5.77676 1.98882 5.77676 2.16139 5.60417L4.47096 3.29463C4.63371 3.13192 4.63371 2.86809 4.47096 2.70538L2.16139 0.395812C1.98883 0.22325 1.70901 0.22325 1.53642 0.395812C1.36383 0.568437 1.36383 0.84825 1.53642 1.02081L3.27989 2.76429C3.41006 2.89446 3.41006 3.10554 3.27989 3.23571Z%27/%3e%3c/svg%3e", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_46___ = new URL("data:image/svg+xml,%3csvg xmlns=%27http://www.w3.org/2000/svg%27 viewBox=%270 0 6 6%27 fill=%27var%28--bs-success%29%27%3e%3cpath d=%27M2.72011 2.76429L4.46358 1.02083C4.63618 0.848244 4.63617 0.568419 4.46358 0.395831C4.29099 0.223244 4.01118 0.223244 3.83861 0.395831L1.52904 2.70537C1.36629 2.86808 1.36629 3.13191 1.52904 3.29462L3.83861 5.60419C4.01117 5.77675 4.29099 5.77675 4.46358 5.60419C4.63617 5.43156 4.63617 5.15175 4.46358 4.97919L2.72011 3.23571C2.58994 3.10554 2.58994 2.89446 2.72011 2.76429Z%27/%3e%3c/svg%3e", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_47___ = new URL("data:image/svg+xml,%3csvg xmlns=%27http://www.w3.org/2000/svg%27 viewBox=%270 0 6 6%27 fill=%27var%28--bs-success%29%27%3e%3cpath d=%27M3.27989 3.23571L1.53642 4.97917C1.36382 5.15176 1.36383 5.43158 1.53642 5.60417C1.70901 5.77676 1.98882 5.77676 2.16139 5.60417L4.47096 3.29463C4.63371 3.13192 4.63371 2.86809 4.47096 2.70538L2.16139 0.395812C1.98883 0.22325 1.70901 0.22325 1.53642 0.395812C1.36383 0.568437 1.36383 0.84825 1.53642 1.02081L3.27989 2.76429C3.41006 2.89446 3.41006 3.10554 3.27989 3.23571Z%27/%3e%3c/svg%3e", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_48___ = new URL("data:image/svg+xml,%3csvg xmlns=%27http://www.w3.org/2000/svg%27 viewBox=%270 0 6 6%27 fill=%27var%28--bs-text-success%29%27%3e%3cpath d=%27M2.72011 2.76429L4.46358 1.02083C4.63618 0.848244 4.63617 0.568419 4.46358 0.395831C4.29099 0.223244 4.01118 0.223244 3.83861 0.395831L1.52904 2.70537C1.36629 2.86808 1.36629 3.13191 1.52904 3.29462L3.83861 5.60419C4.01117 5.77675 4.29099 5.77675 4.46358 5.60419C4.63617 5.43156 4.63617 5.15175 4.46358 4.97919L2.72011 3.23571C2.58994 3.10554 2.58994 2.89446 2.72011 2.76429Z%27/%3e%3c/svg%3e", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_49___ = new URL("data:image/svg+xml,%3csvg xmlns=%27http://www.w3.org/2000/svg%27 viewBox=%270 0 6 6%27 fill=%27var%28--bs-text-success%29%27%3e%3cpath d=%27M3.27989 3.23571L1.53642 4.97917C1.36382 5.15176 1.36383 5.43158 1.53642 5.60417C1.70901 5.77676 1.98882 5.77676 2.16139 5.60417L4.47096 3.29463C4.63371 3.13192 4.63371 2.86809 4.47096 2.70538L2.16139 0.395812C1.98883 0.22325 1.70901 0.22325 1.53642 0.395812C1.36383 0.568437 1.36383 0.84825 1.53642 1.02081L3.27989 2.76429C3.41006 2.89446 3.41006 3.10554 3.27989 3.23571Z%27/%3e%3c/svg%3e", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_50___ = new URL("data:image/svg+xml,%3csvg xmlns=%27http://www.w3.org/2000/svg%27 viewBox=%270 0 6 6%27 fill=%27var%28--bs-info%29%27%3e%3cpath d=%27M2.72011 2.76429L4.46358 1.02083C4.63618 0.848244 4.63617 0.568419 4.46358 0.395831C4.29099 0.223244 4.01118 0.223244 3.83861 0.395831L1.52904 2.70537C1.36629 2.86808 1.36629 3.13191 1.52904 3.29462L3.83861 5.60419C4.01117 5.77675 4.29099 5.77675 4.46358 5.60419C4.63617 5.43156 4.63617 5.15175 4.46358 4.97919L2.72011 3.23571C2.58994 3.10554 2.58994 2.89446 2.72011 2.76429Z%27/%3e%3c/svg%3e", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_51___ = new URL("data:image/svg+xml,%3csvg xmlns=%27http://www.w3.org/2000/svg%27 viewBox=%270 0 6 6%27 fill=%27var%28--bs-info%29%27%3e%3cpath d=%27M3.27989 3.23571L1.53642 4.97917C1.36382 5.15176 1.36383 5.43158 1.53642 5.60417C1.70901 5.77676 1.98882 5.77676 2.16139 5.60417L4.47096 3.29463C4.63371 3.13192 4.63371 2.86809 4.47096 2.70538L2.16139 0.395812C1.98883 0.22325 1.70901 0.22325 1.53642 0.395812C1.36383 0.568437 1.36383 0.84825 1.53642 1.02081L3.27989 2.76429C3.41006 2.89446 3.41006 3.10554 3.27989 3.23571Z%27/%3e%3c/svg%3e", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_52___ = new URL("data:image/svg+xml,%3csvg xmlns=%27http://www.w3.org/2000/svg%27 viewBox=%270 0 6 6%27 fill=%27var%28--bs-text-info%29%27%3e%3cpath d=%27M2.72011 2.76429L4.46358 1.02083C4.63618 0.848244 4.63617 0.568419 4.46358 0.395831C4.29099 0.223244 4.01118 0.223244 3.83861 0.395831L1.52904 2.70537C1.36629 2.86808 1.36629 3.13191 1.52904 3.29462L3.83861 5.60419C4.01117 5.77675 4.29099 5.77675 4.46358 5.60419C4.63617 5.43156 4.63617 5.15175 4.46358 4.97919L2.72011 3.23571C2.58994 3.10554 2.58994 2.89446 2.72011 2.76429Z%27/%3e%3c/svg%3e", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_53___ = new URL("data:image/svg+xml,%3csvg xmlns=%27http://www.w3.org/2000/svg%27 viewBox=%270 0 6 6%27 fill=%27var%28--bs-text-info%29%27%3e%3cpath d=%27M3.27989 3.23571L1.53642 4.97917C1.36382 5.15176 1.36383 5.43158 1.53642 5.60417C1.70901 5.77676 1.98882 5.77676 2.16139 5.60417L4.47096 3.29463C4.63371 3.13192 4.63371 2.86809 4.47096 2.70538L2.16139 0.395812C1.98883 0.22325 1.70901 0.22325 1.53642 0.395812C1.36383 0.568437 1.36383 0.84825 1.53642 1.02081L3.27989 2.76429C3.41006 2.89446 3.41006 3.10554 3.27989 3.23571Z%27/%3e%3c/svg%3e", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_54___ = new URL("data:image/svg+xml,%3csvg xmlns=%27http://www.w3.org/2000/svg%27 viewBox=%270 0 6 6%27 fill=%27var%28--bs-warning%29%27%3e%3cpath d=%27M2.72011 2.76429L4.46358 1.02083C4.63618 0.848244 4.63617 0.568419 4.46358 0.395831C4.29099 0.223244 4.01118 0.223244 3.83861 0.395831L1.52904 2.70537C1.36629 2.86808 1.36629 3.13191 1.52904 3.29462L3.83861 5.60419C4.01117 5.77675 4.29099 5.77675 4.46358 5.60419C4.63617 5.43156 4.63617 5.15175 4.46358 4.97919L2.72011 3.23571C2.58994 3.10554 2.58994 2.89446 2.72011 2.76429Z%27/%3e%3c/svg%3e", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_55___ = new URL("data:image/svg+xml,%3csvg xmlns=%27http://www.w3.org/2000/svg%27 viewBox=%270 0 6 6%27 fill=%27var%28--bs-warning%29%27%3e%3cpath d=%27M3.27989 3.23571L1.53642 4.97917C1.36382 5.15176 1.36383 5.43158 1.53642 5.60417C1.70901 5.77676 1.98882 5.77676 2.16139 5.60417L4.47096 3.29463C4.63371 3.13192 4.63371 2.86809 4.47096 2.70538L2.16139 0.395812C1.98883 0.22325 1.70901 0.22325 1.53642 0.395812C1.36383 0.568437 1.36383 0.84825 1.53642 1.02081L3.27989 2.76429C3.41006 2.89446 3.41006 3.10554 3.27989 3.23571Z%27/%3e%3c/svg%3e", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_56___ = new URL("data:image/svg+xml,%3csvg xmlns=%27http://www.w3.org/2000/svg%27 viewBox=%270 0 6 6%27 fill=%27var%28--bs-text-warning%29%27%3e%3cpath d=%27M2.72011 2.76429L4.46358 1.02083C4.63618 0.848244 4.63617 0.568419 4.46358 0.395831C4.29099 0.223244 4.01118 0.223244 3.83861 0.395831L1.52904 2.70537C1.36629 2.86808 1.36629 3.13191 1.52904 3.29462L3.83861 5.60419C4.01117 5.77675 4.29099 5.77675 4.46358 5.60419C4.63617 5.43156 4.63617 5.15175 4.46358 4.97919L2.72011 3.23571C2.58994 3.10554 2.58994 2.89446 2.72011 2.76429Z%27/%3e%3c/svg%3e", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_57___ = new URL("data:image/svg+xml,%3csvg xmlns=%27http://www.w3.org/2000/svg%27 viewBox=%270 0 6 6%27 fill=%27var%28--bs-text-warning%29%27%3e%3cpath d=%27M3.27989 3.23571L1.53642 4.97917C1.36382 5.15176 1.36383 5.43158 1.53642 5.60417C1.70901 5.77676 1.98882 5.77676 2.16139 5.60417L4.47096 3.29463C4.63371 3.13192 4.63371 2.86809 4.47096 2.70538L2.16139 0.395812C1.98883 0.22325 1.70901 0.22325 1.53642 0.395812C1.36383 0.568437 1.36383 0.84825 1.53642 1.02081L3.27989 2.76429C3.41006 2.89446 3.41006 3.10554 3.27989 3.23571Z%27/%3e%3c/svg%3e", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_58___ = new URL("data:image/svg+xml,%3csvg xmlns=%27http://www.w3.org/2000/svg%27 viewBox=%270 0 6 6%27 fill=%27var%28--bs-danger%29%27%3e%3cpath d=%27M2.72011 2.76429L4.46358 1.02083C4.63618 0.848244 4.63617 0.568419 4.46358 0.395831C4.29099 0.223244 4.01118 0.223244 3.83861 0.395831L1.52904 2.70537C1.36629 2.86808 1.36629 3.13191 1.52904 3.29462L3.83861 5.60419C4.01117 5.77675 4.29099 5.77675 4.46358 5.60419C4.63617 5.43156 4.63617 5.15175 4.46358 4.97919L2.72011 3.23571C2.58994 3.10554 2.58994 2.89446 2.72011 2.76429Z%27/%3e%3c/svg%3e", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_59___ = new URL("data:image/svg+xml,%3csvg xmlns=%27http://www.w3.org/2000/svg%27 viewBox=%270 0 6 6%27 fill=%27var%28--bs-danger%29%27%3e%3cpath d=%27M3.27989 3.23571L1.53642 4.97917C1.36382 5.15176 1.36383 5.43158 1.53642 5.60417C1.70901 5.77676 1.98882 5.77676 2.16139 5.60417L4.47096 3.29463C4.63371 3.13192 4.63371 2.86809 4.47096 2.70538L2.16139 0.395812C1.98883 0.22325 1.70901 0.22325 1.53642 0.395812C1.36383 0.568437 1.36383 0.84825 1.53642 1.02081L3.27989 2.76429C3.41006 2.89446 3.41006 3.10554 3.27989 3.23571Z%27/%3e%3c/svg%3e", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_60___ = new URL("data:image/svg+xml,%3csvg xmlns=%27http://www.w3.org/2000/svg%27 viewBox=%270 0 6 6%27 fill=%27var%28--bs-text-danger%29%27%3e%3cpath d=%27M2.72011 2.76429L4.46358 1.02083C4.63618 0.848244 4.63617 0.568419 4.46358 0.395831C4.29099 0.223244 4.01118 0.223244 3.83861 0.395831L1.52904 2.70537C1.36629 2.86808 1.36629 3.13191 1.52904 3.29462L3.83861 5.60419C4.01117 5.77675 4.29099 5.77675 4.46358 5.60419C4.63617 5.43156 4.63617 5.15175 4.46358 4.97919L2.72011 3.23571C2.58994 3.10554 2.58994 2.89446 2.72011 2.76429Z%27/%3e%3c/svg%3e", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_61___ = new URL("data:image/svg+xml,%3csvg xmlns=%27http://www.w3.org/2000/svg%27 viewBox=%270 0 6 6%27 fill=%27var%28--bs-text-danger%29%27%3e%3cpath d=%27M3.27989 3.23571L1.53642 4.97917C1.36382 5.15176 1.36383 5.43158 1.53642 5.60417C1.70901 5.77676 1.98882 5.77676 2.16139 5.60417L4.47096 3.29463C4.63371 3.13192 4.63371 2.86809 4.47096 2.70538L2.16139 0.395812C1.98883 0.22325 1.70901 0.22325 1.53642 0.395812C1.36383 0.568437 1.36383 0.84825 1.53642 1.02081L3.27989 2.76429C3.41006 2.89446 3.41006 3.10554 3.27989 3.23571Z%27/%3e%3c/svg%3e", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_62___ = new URL("data:image/svg+xml,%3csvg xmlns=%27http://www.w3.org/2000/svg%27 viewBox=%270 0 6 6%27 fill=%27var%28--bs-dark%29%27%3e%3cpath d=%27M2.72011 2.76429L4.46358 1.02083C4.63618 0.848244 4.63617 0.568419 4.46358 0.395831C4.29099 0.223244 4.01118 0.223244 3.83861 0.395831L1.52904 2.70537C1.36629 2.86808 1.36629 3.13191 1.52904 3.29462L3.83861 5.60419C4.01117 5.77675 4.29099 5.77675 4.46358 5.60419C4.63617 5.43156 4.63617 5.15175 4.46358 4.97919L2.72011 3.23571C2.58994 3.10554 2.58994 2.89446 2.72011 2.76429Z%27/%3e%3c/svg%3e", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_63___ = new URL("data:image/svg+xml,%3csvg xmlns=%27http://www.w3.org/2000/svg%27 viewBox=%270 0 6 6%27 fill=%27var%28--bs-dark%29%27%3e%3cpath d=%27M3.27989 3.23571L1.53642 4.97917C1.36382 5.15176 1.36383 5.43158 1.53642 5.60417C1.70901 5.77676 1.98882 5.77676 2.16139 5.60417L4.47096 3.29463C4.63371 3.13192 4.63371 2.86809 4.47096 2.70538L2.16139 0.395812C1.98883 0.22325 1.70901 0.22325 1.53642 0.395812C1.36383 0.568437 1.36383 0.84825 1.53642 1.02081L3.27989 2.76429C3.41006 2.89446 3.41006 3.10554 3.27989 3.23571Z%27/%3e%3c/svg%3e", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_64___ = new URL("data:image/svg+xml,%3csvg xmlns=%27http://www.w3.org/2000/svg%27 viewBox=%270 0 6 6%27 fill=%27var%28--bs-text-dark%29%27%3e%3cpath d=%27M2.72011 2.76429L4.46358 1.02083C4.63618 0.848244 4.63617 0.568419 4.46358 0.395831C4.29099 0.223244 4.01118 0.223244 3.83861 0.395831L1.52904 2.70537C1.36629 2.86808 1.36629 3.13191 1.52904 3.29462L3.83861 5.60419C4.01117 5.77675 4.29099 5.77675 4.46358 5.60419C4.63617 5.43156 4.63617 5.15175 4.46358 4.97919L2.72011 3.23571C2.58994 3.10554 2.58994 2.89446 2.72011 2.76429Z%27/%3e%3c/svg%3e", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_65___ = new URL("data:image/svg+xml,%3csvg xmlns=%27http://www.w3.org/2000/svg%27 viewBox=%270 0 6 6%27 fill=%27var%28--bs-text-dark%29%27%3e%3cpath d=%27M3.27989 3.23571L1.53642 4.97917C1.36382 5.15176 1.36383 5.43158 1.53642 5.60417C1.70901 5.77676 1.98882 5.77676 2.16139 5.60417L4.47096 3.29463C4.63371 3.13192 4.63371 2.86809 4.47096 2.70538L2.16139 0.395812C1.98883 0.22325 1.70901 0.22325 1.53642 0.395812C1.36383 0.568437 1.36383 0.84825 1.53642 1.02081L3.27989 2.76429C3.41006 2.89446 3.41006 3.10554 3.27989 3.23571Z%27/%3e%3c/svg%3e", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_66___ = new URL("data:image/svg+xml,%3csvg xmlns=%27http://www.w3.org/2000/svg%27 viewBox=%270 0 6 6%27 fill=%27var%28--bs-muted%29%27%3e%3cpath d=%27M2.72011 2.76429L4.46358 1.02083C4.63618 0.848244 4.63617 0.568419 4.46358 0.395831C4.29099 0.223244 4.01118 0.223244 3.83861 0.395831L1.52904 2.70537C1.36629 2.86808 1.36629 3.13191 1.52904 3.29462L3.83861 5.60419C4.01117 5.77675 4.29099 5.77675 4.46358 5.60419C4.63617 5.43156 4.63617 5.15175 4.46358 4.97919L2.72011 3.23571C2.58994 3.10554 2.58994 2.89446 2.72011 2.76429Z%27/%3e%3c/svg%3e", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_67___ = new URL("data:image/svg+xml,%3csvg xmlns=%27http://www.w3.org/2000/svg%27 viewBox=%270 0 6 6%27 fill=%27var%28--bs-muted%29%27%3e%3cpath d=%27M3.27989 3.23571L1.53642 4.97917C1.36382 5.15176 1.36383 5.43158 1.53642 5.60417C1.70901 5.77676 1.98882 5.77676 2.16139 5.60417L4.47096 3.29463C4.63371 3.13192 4.63371 2.86809 4.47096 2.70538L2.16139 0.395812C1.98883 0.22325 1.70901 0.22325 1.53642 0.395812C1.36383 0.568437 1.36383 0.84825 1.53642 1.02081L3.27989 2.76429C3.41006 2.89446 3.41006 3.10554 3.27989 3.23571Z%27/%3e%3c/svg%3e", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_68___ = new URL("data:image/svg+xml,%3csvg xmlns=%27http://www.w3.org/2000/svg%27 viewBox=%270 0 6 6%27 fill=%27var%28--bs-gray-100%29%27%3e%3cpath d=%27M2.72011 2.76429L4.46358 1.02083C4.63618 0.848244 4.63617 0.568419 4.46358 0.395831C4.29099 0.223244 4.01118 0.223244 3.83861 0.395831L1.52904 2.70537C1.36629 2.86808 1.36629 3.13191 1.52904 3.29462L3.83861 5.60419C4.01117 5.77675 4.29099 5.77675 4.46358 5.60419C4.63617 5.43156 4.63617 5.15175 4.46358 4.97919L2.72011 3.23571C2.58994 3.10554 2.58994 2.89446 2.72011 2.76429Z%27/%3e%3c/svg%3e", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_69___ = new URL("data:image/svg+xml,%3csvg xmlns=%27http://www.w3.org/2000/svg%27 viewBox=%270 0 6 6%27 fill=%27var%28--bs-gray-100%29%27%3e%3cpath d=%27M3.27989 3.23571L1.53642 4.97917C1.36382 5.15176 1.36383 5.43158 1.53642 5.60417C1.70901 5.77676 1.98882 5.77676 2.16139 5.60417L4.47096 3.29463C4.63371 3.13192 4.63371 2.86809 4.47096 2.70538L2.16139 0.395812C1.98883 0.22325 1.70901 0.22325 1.53642 0.395812C1.36383 0.568437 1.36383 0.84825 1.53642 1.02081L3.27989 2.76429C3.41006 2.89446 3.41006 3.10554 3.27989 3.23571Z%27/%3e%3c/svg%3e", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_70___ = new URL("data:image/svg+xml,%3csvg xmlns=%27http://www.w3.org/2000/svg%27 viewBox=%270 0 6 6%27 fill=%27var%28--bs-text-gray-100%29%27%3e%3cpath d=%27M2.72011 2.76429L4.46358 1.02083C4.63618 0.848244 4.63617 0.568419 4.46358 0.395831C4.29099 0.223244 4.01118 0.223244 3.83861 0.395831L1.52904 2.70537C1.36629 2.86808 1.36629 3.13191 1.52904 3.29462L3.83861 5.60419C4.01117 5.77675 4.29099 5.77675 4.46358 5.60419C4.63617 5.43156 4.63617 5.15175 4.46358 4.97919L2.72011 3.23571C2.58994 3.10554 2.58994 2.89446 2.72011 2.76429Z%27/%3e%3c/svg%3e", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_71___ = new URL("data:image/svg+xml,%3csvg xmlns=%27http://www.w3.org/2000/svg%27 viewBox=%270 0 6 6%27 fill=%27var%28--bs-text-gray-100%29%27%3e%3cpath d=%27M3.27989 3.23571L1.53642 4.97917C1.36382 5.15176 1.36383 5.43158 1.53642 5.60417C1.70901 5.77676 1.98882 5.77676 2.16139 5.60417L4.47096 3.29463C4.63371 3.13192 4.63371 2.86809 4.47096 2.70538L2.16139 0.395812C1.98883 0.22325 1.70901 0.22325 1.53642 0.395812C1.36383 0.568437 1.36383 0.84825 1.53642 1.02081L3.27989 2.76429C3.41006 2.89446 3.41006 3.10554 3.27989 3.23571Z%27/%3e%3c/svg%3e", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_72___ = new URL("data:image/svg+xml,%3csvg xmlns=%27http://www.w3.org/2000/svg%27 viewBox=%270 0 6 6%27 fill=%27var%28--bs-gray-200%29%27%3e%3cpath d=%27M2.72011 2.76429L4.46358 1.02083C4.63618 0.848244 4.63617 0.568419 4.46358 0.395831C4.29099 0.223244 4.01118 0.223244 3.83861 0.395831L1.52904 2.70537C1.36629 2.86808 1.36629 3.13191 1.52904 3.29462L3.83861 5.60419C4.01117 5.77675 4.29099 5.77675 4.46358 5.60419C4.63617 5.43156 4.63617 5.15175 4.46358 4.97919L2.72011 3.23571C2.58994 3.10554 2.58994 2.89446 2.72011 2.76429Z%27/%3e%3c/svg%3e", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_73___ = new URL("data:image/svg+xml,%3csvg xmlns=%27http://www.w3.org/2000/svg%27 viewBox=%270 0 6 6%27 fill=%27var%28--bs-gray-200%29%27%3e%3cpath d=%27M3.27989 3.23571L1.53642 4.97917C1.36382 5.15176 1.36383 5.43158 1.53642 5.60417C1.70901 5.77676 1.98882 5.77676 2.16139 5.60417L4.47096 3.29463C4.63371 3.13192 4.63371 2.86809 4.47096 2.70538L2.16139 0.395812C1.98883 0.22325 1.70901 0.22325 1.53642 0.395812C1.36383 0.568437 1.36383 0.84825 1.53642 1.02081L3.27989 2.76429C3.41006 2.89446 3.41006 3.10554 3.27989 3.23571Z%27/%3e%3c/svg%3e", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_74___ = new URL("data:image/svg+xml,%3csvg xmlns=%27http://www.w3.org/2000/svg%27 viewBox=%270 0 6 6%27 fill=%27var%28--bs-text-gray-200%29%27%3e%3cpath d=%27M2.72011 2.76429L4.46358 1.02083C4.63618 0.848244 4.63617 0.568419 4.46358 0.395831C4.29099 0.223244 4.01118 0.223244 3.83861 0.395831L1.52904 2.70537C1.36629 2.86808 1.36629 3.13191 1.52904 3.29462L3.83861 5.60419C4.01117 5.77675 4.29099 5.77675 4.46358 5.60419C4.63617 5.43156 4.63617 5.15175 4.46358 4.97919L2.72011 3.23571C2.58994 3.10554 2.58994 2.89446 2.72011 2.76429Z%27/%3e%3c/svg%3e", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_75___ = new URL("data:image/svg+xml,%3csvg xmlns=%27http://www.w3.org/2000/svg%27 viewBox=%270 0 6 6%27 fill=%27var%28--bs-text-gray-200%29%27%3e%3cpath d=%27M3.27989 3.23571L1.53642 4.97917C1.36382 5.15176 1.36383 5.43158 1.53642 5.60417C1.70901 5.77676 1.98882 5.77676 2.16139 5.60417L4.47096 3.29463C4.63371 3.13192 4.63371 2.86809 4.47096 2.70538L2.16139 0.395812C1.98883 0.22325 1.70901 0.22325 1.53642 0.395812C1.36383 0.568437 1.36383 0.84825 1.53642 1.02081L3.27989 2.76429C3.41006 2.89446 3.41006 3.10554 3.27989 3.23571Z%27/%3e%3c/svg%3e", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_76___ = new URL("data:image/svg+xml,%3csvg xmlns=%27http://www.w3.org/2000/svg%27 viewBox=%270 0 6 6%27 fill=%27var%28--bs-gray-300%29%27%3e%3cpath d=%27M2.72011 2.76429L4.46358 1.02083C4.63618 0.848244 4.63617 0.568419 4.46358 0.395831C4.29099 0.223244 4.01118 0.223244 3.83861 0.395831L1.52904 2.70537C1.36629 2.86808 1.36629 3.13191 1.52904 3.29462L3.83861 5.60419C4.01117 5.77675 4.29099 5.77675 4.46358 5.60419C4.63617 5.43156 4.63617 5.15175 4.46358 4.97919L2.72011 3.23571C2.58994 3.10554 2.58994 2.89446 2.72011 2.76429Z%27/%3e%3c/svg%3e", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_77___ = new URL("data:image/svg+xml,%3csvg xmlns=%27http://www.w3.org/2000/svg%27 viewBox=%270 0 6 6%27 fill=%27var%28--bs-gray-300%29%27%3e%3cpath d=%27M3.27989 3.23571L1.53642 4.97917C1.36382 5.15176 1.36383 5.43158 1.53642 5.60417C1.70901 5.77676 1.98882 5.77676 2.16139 5.60417L4.47096 3.29463C4.63371 3.13192 4.63371 2.86809 4.47096 2.70538L2.16139 0.395812C1.98883 0.22325 1.70901 0.22325 1.53642 0.395812C1.36383 0.568437 1.36383 0.84825 1.53642 1.02081L3.27989 2.76429C3.41006 2.89446 3.41006 3.10554 3.27989 3.23571Z%27/%3e%3c/svg%3e", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_78___ = new URL("data:image/svg+xml,%3csvg xmlns=%27http://www.w3.org/2000/svg%27 viewBox=%270 0 6 6%27 fill=%27var%28--bs-text-gray-300%29%27%3e%3cpath d=%27M2.72011 2.76429L4.46358 1.02083C4.63618 0.848244 4.63617 0.568419 4.46358 0.395831C4.29099 0.223244 4.01118 0.223244 3.83861 0.395831L1.52904 2.70537C1.36629 2.86808 1.36629 3.13191 1.52904 3.29462L3.83861 5.60419C4.01117 5.77675 4.29099 5.77675 4.46358 5.60419C4.63617 5.43156 4.63617 5.15175 4.46358 4.97919L2.72011 3.23571C2.58994 3.10554 2.58994 2.89446 2.72011 2.76429Z%27/%3e%3c/svg%3e", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_79___ = new URL("data:image/svg+xml,%3csvg xmlns=%27http://www.w3.org/2000/svg%27 viewBox=%270 0 6 6%27 fill=%27var%28--bs-text-gray-300%29%27%3e%3cpath d=%27M3.27989 3.23571L1.53642 4.97917C1.36382 5.15176 1.36383 5.43158 1.53642 5.60417C1.70901 5.77676 1.98882 5.77676 2.16139 5.60417L4.47096 3.29463C4.63371 3.13192 4.63371 2.86809 4.47096 2.70538L2.16139 0.395812C1.98883 0.22325 1.70901 0.22325 1.53642 0.395812C1.36383 0.568437 1.36383 0.84825 1.53642 1.02081L3.27989 2.76429C3.41006 2.89446 3.41006 3.10554 3.27989 3.23571Z%27/%3e%3c/svg%3e", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_80___ = new URL("data:image/svg+xml,%3csvg xmlns=%27http://www.w3.org/2000/svg%27 viewBox=%270 0 6 6%27 fill=%27var%28--bs-gray-400%29%27%3e%3cpath d=%27M2.72011 2.76429L4.46358 1.02083C4.63618 0.848244 4.63617 0.568419 4.46358 0.395831C4.29099 0.223244 4.01118 0.223244 3.83861 0.395831L1.52904 2.70537C1.36629 2.86808 1.36629 3.13191 1.52904 3.29462L3.83861 5.60419C4.01117 5.77675 4.29099 5.77675 4.46358 5.60419C4.63617 5.43156 4.63617 5.15175 4.46358 4.97919L2.72011 3.23571C2.58994 3.10554 2.58994 2.89446 2.72011 2.76429Z%27/%3e%3c/svg%3e", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_81___ = new URL("data:image/svg+xml,%3csvg xmlns=%27http://www.w3.org/2000/svg%27 viewBox=%270 0 6 6%27 fill=%27var%28--bs-gray-400%29%27%3e%3cpath d=%27M3.27989 3.23571L1.53642 4.97917C1.36382 5.15176 1.36383 5.43158 1.53642 5.60417C1.70901 5.77676 1.98882 5.77676 2.16139 5.60417L4.47096 3.29463C4.63371 3.13192 4.63371 2.86809 4.47096 2.70538L2.16139 0.395812C1.98883 0.22325 1.70901 0.22325 1.53642 0.395812C1.36383 0.568437 1.36383 0.84825 1.53642 1.02081L3.27989 2.76429C3.41006 2.89446 3.41006 3.10554 3.27989 3.23571Z%27/%3e%3c/svg%3e", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_82___ = new URL("data:image/svg+xml,%3csvg xmlns=%27http://www.w3.org/2000/svg%27 viewBox=%270 0 6 6%27 fill=%27var%28--bs-text-gray-400%29%27%3e%3cpath d=%27M2.72011 2.76429L4.46358 1.02083C4.63618 0.848244 4.63617 0.568419 4.46358 0.395831C4.29099 0.223244 4.01118 0.223244 3.83861 0.395831L1.52904 2.70537C1.36629 2.86808 1.36629 3.13191 1.52904 3.29462L3.83861 5.60419C4.01117 5.77675 4.29099 5.77675 4.46358 5.60419C4.63617 5.43156 4.63617 5.15175 4.46358 4.97919L2.72011 3.23571C2.58994 3.10554 2.58994 2.89446 2.72011 2.76429Z%27/%3e%3c/svg%3e", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_83___ = new URL("data:image/svg+xml,%3csvg xmlns=%27http://www.w3.org/2000/svg%27 viewBox=%270 0 6 6%27 fill=%27var%28--bs-text-gray-400%29%27%3e%3cpath d=%27M3.27989 3.23571L1.53642 4.97917C1.36382 5.15176 1.36383 5.43158 1.53642 5.60417C1.70901 5.77676 1.98882 5.77676 2.16139 5.60417L4.47096 3.29463C4.63371 3.13192 4.63371 2.86809 4.47096 2.70538L2.16139 0.395812C1.98883 0.22325 1.70901 0.22325 1.53642 0.395812C1.36383 0.568437 1.36383 0.84825 1.53642 1.02081L3.27989 2.76429C3.41006 2.89446 3.41006 3.10554 3.27989 3.23571Z%27/%3e%3c/svg%3e", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_84___ = new URL("data:image/svg+xml,%3csvg xmlns=%27http://www.w3.org/2000/svg%27 viewBox=%270 0 6 6%27 fill=%27var%28--bs-gray-500%29%27%3e%3cpath d=%27M2.72011 2.76429L4.46358 1.02083C4.63618 0.848244 4.63617 0.568419 4.46358 0.395831C4.29099 0.223244 4.01118 0.223244 3.83861 0.395831L1.52904 2.70537C1.36629 2.86808 1.36629 3.13191 1.52904 3.29462L3.83861 5.60419C4.01117 5.77675 4.29099 5.77675 4.46358 5.60419C4.63617 5.43156 4.63617 5.15175 4.46358 4.97919L2.72011 3.23571C2.58994 3.10554 2.58994 2.89446 2.72011 2.76429Z%27/%3e%3c/svg%3e", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_85___ = new URL("data:image/svg+xml,%3csvg xmlns=%27http://www.w3.org/2000/svg%27 viewBox=%270 0 6 6%27 fill=%27var%28--bs-gray-500%29%27%3e%3cpath d=%27M3.27989 3.23571L1.53642 4.97917C1.36382 5.15176 1.36383 5.43158 1.53642 5.60417C1.70901 5.77676 1.98882 5.77676 2.16139 5.60417L4.47096 3.29463C4.63371 3.13192 4.63371 2.86809 4.47096 2.70538L2.16139 0.395812C1.98883 0.22325 1.70901 0.22325 1.53642 0.395812C1.36383 0.568437 1.36383 0.84825 1.53642 1.02081L3.27989 2.76429C3.41006 2.89446 3.41006 3.10554 3.27989 3.23571Z%27/%3e%3c/svg%3e", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_86___ = new URL("data:image/svg+xml,%3csvg xmlns=%27http://www.w3.org/2000/svg%27 viewBox=%270 0 6 6%27 fill=%27var%28--bs-text-gray-500%29%27%3e%3cpath d=%27M2.72011 2.76429L4.46358 1.02083C4.63618 0.848244 4.63617 0.568419 4.46358 0.395831C4.29099 0.223244 4.01118 0.223244 3.83861 0.395831L1.52904 2.70537C1.36629 2.86808 1.36629 3.13191 1.52904 3.29462L3.83861 5.60419C4.01117 5.77675 4.29099 5.77675 4.46358 5.60419C4.63617 5.43156 4.63617 5.15175 4.46358 4.97919L2.72011 3.23571C2.58994 3.10554 2.58994 2.89446 2.72011 2.76429Z%27/%3e%3c/svg%3e", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_87___ = new URL("data:image/svg+xml,%3csvg xmlns=%27http://www.w3.org/2000/svg%27 viewBox=%270 0 6 6%27 fill=%27var%28--bs-text-gray-500%29%27%3e%3cpath d=%27M3.27989 3.23571L1.53642 4.97917C1.36382 5.15176 1.36383 5.43158 1.53642 5.60417C1.70901 5.77676 1.98882 5.77676 2.16139 5.60417L4.47096 3.29463C4.63371 3.13192 4.63371 2.86809 4.47096 2.70538L2.16139 0.395812C1.98883 0.22325 1.70901 0.22325 1.53642 0.395812C1.36383 0.568437 1.36383 0.84825 1.53642 1.02081L3.27989 2.76429C3.41006 2.89446 3.41006 3.10554 3.27989 3.23571Z%27/%3e%3c/svg%3e", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_88___ = new URL("data:image/svg+xml,%3csvg xmlns=%27http://www.w3.org/2000/svg%27 viewBox=%270 0 6 6%27 fill=%27var%28--bs-gray-600%29%27%3e%3cpath d=%27M2.72011 2.76429L4.46358 1.02083C4.63618 0.848244 4.63617 0.568419 4.46358 0.395831C4.29099 0.223244 4.01118 0.223244 3.83861 0.395831L1.52904 2.70537C1.36629 2.86808 1.36629 3.13191 1.52904 3.29462L3.83861 5.60419C4.01117 5.77675 4.29099 5.77675 4.46358 5.60419C4.63617 5.43156 4.63617 5.15175 4.46358 4.97919L2.72011 3.23571C2.58994 3.10554 2.58994 2.89446 2.72011 2.76429Z%27/%3e%3c/svg%3e", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_89___ = new URL("data:image/svg+xml,%3csvg xmlns=%27http://www.w3.org/2000/svg%27 viewBox=%270 0 6 6%27 fill=%27var%28--bs-gray-600%29%27%3e%3cpath d=%27M3.27989 3.23571L1.53642 4.97917C1.36382 5.15176 1.36383 5.43158 1.53642 5.60417C1.70901 5.77676 1.98882 5.77676 2.16139 5.60417L4.47096 3.29463C4.63371 3.13192 4.63371 2.86809 4.47096 2.70538L2.16139 0.395812C1.98883 0.22325 1.70901 0.22325 1.53642 0.395812C1.36383 0.568437 1.36383 0.84825 1.53642 1.02081L3.27989 2.76429C3.41006 2.89446 3.41006 3.10554 3.27989 3.23571Z%27/%3e%3c/svg%3e", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_90___ = new URL("data:image/svg+xml,%3csvg xmlns=%27http://www.w3.org/2000/svg%27 viewBox=%270 0 6 6%27 fill=%27var%28--bs-text-gray-600%29%27%3e%3cpath d=%27M2.72011 2.76429L4.46358 1.02083C4.63618 0.848244 4.63617 0.568419 4.46358 0.395831C4.29099 0.223244 4.01118 0.223244 3.83861 0.395831L1.52904 2.70537C1.36629 2.86808 1.36629 3.13191 1.52904 3.29462L3.83861 5.60419C4.01117 5.77675 4.29099 5.77675 4.46358 5.60419C4.63617 5.43156 4.63617 5.15175 4.46358 4.97919L2.72011 3.23571C2.58994 3.10554 2.58994 2.89446 2.72011 2.76429Z%27/%3e%3c/svg%3e", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_91___ = new URL("data:image/svg+xml,%3csvg xmlns=%27http://www.w3.org/2000/svg%27 viewBox=%270 0 6 6%27 fill=%27var%28--bs-text-gray-600%29%27%3e%3cpath d=%27M3.27989 3.23571L1.53642 4.97917C1.36382 5.15176 1.36383 5.43158 1.53642 5.60417C1.70901 5.77676 1.98882 5.77676 2.16139 5.60417L4.47096 3.29463C4.63371 3.13192 4.63371 2.86809 4.47096 2.70538L2.16139 0.395812C1.98883 0.22325 1.70901 0.22325 1.53642 0.395812C1.36383 0.568437 1.36383 0.84825 1.53642 1.02081L3.27989 2.76429C3.41006 2.89446 3.41006 3.10554 3.27989 3.23571Z%27/%3e%3c/svg%3e", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_92___ = new URL("data:image/svg+xml,%3csvg xmlns=%27http://www.w3.org/2000/svg%27 viewBox=%270 0 6 6%27 fill=%27var%28--bs-text-gray-700%29%27%3e%3cpath d=%27M2.72011 2.76429L4.46358 1.02083C4.63618 0.848244 4.63617 0.568419 4.46358 0.395831C4.29099 0.223244 4.01118 0.223244 3.83861 0.395831L1.52904 2.70537C1.36629 2.86808 1.36629 3.13191 1.52904 3.29462L3.83861 5.60419C4.01117 5.77675 4.29099 5.77675 4.46358 5.60419C4.63617 5.43156 4.63617 5.15175 4.46358 4.97919L2.72011 3.23571C2.58994 3.10554 2.58994 2.89446 2.72011 2.76429Z%27/%3e%3c/svg%3e", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_93___ = new URL("data:image/svg+xml,%3csvg xmlns=%27http://www.w3.org/2000/svg%27 viewBox=%270 0 6 6%27 fill=%27var%28--bs-text-gray-700%29%27%3e%3cpath d=%27M3.27989 3.23571L1.53642 4.97917C1.36382 5.15176 1.36383 5.43158 1.53642 5.60417C1.70901 5.77676 1.98882 5.77676 2.16139 5.60417L4.47096 3.29463C4.63371 3.13192 4.63371 2.86809 4.47096 2.70538L2.16139 0.395812C1.98883 0.22325 1.70901 0.22325 1.53642 0.395812C1.36383 0.568437 1.36383 0.84825 1.53642 1.02081L3.27989 2.76429C3.41006 2.89446 3.41006 3.10554 3.27989 3.23571Z%27/%3e%3c/svg%3e", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_94___ = new URL("data:image/svg+xml,%3csvg xmlns=%27http://www.w3.org/2000/svg%27 viewBox=%270 0 6 6%27 fill=%27var%28--bs-gray-800%29%27%3e%3cpath d=%27M2.72011 2.76429L4.46358 1.02083C4.63618 0.848244 4.63617 0.568419 4.46358 0.395831C4.29099 0.223244 4.01118 0.223244 3.83861 0.395831L1.52904 2.70537C1.36629 2.86808 1.36629 3.13191 1.52904 3.29462L3.83861 5.60419C4.01117 5.77675 4.29099 5.77675 4.46358 5.60419C4.63617 5.43156 4.63617 5.15175 4.46358 4.97919L2.72011 3.23571C2.58994 3.10554 2.58994 2.89446 2.72011 2.76429Z%27/%3e%3c/svg%3e", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_95___ = new URL("data:image/svg+xml,%3csvg xmlns=%27http://www.w3.org/2000/svg%27 viewBox=%270 0 6 6%27 fill=%27var%28--bs-gray-800%29%27%3e%3cpath d=%27M3.27989 3.23571L1.53642 4.97917C1.36382 5.15176 1.36383 5.43158 1.53642 5.60417C1.70901 5.77676 1.98882 5.77676 2.16139 5.60417L4.47096 3.29463C4.63371 3.13192 4.63371 2.86809 4.47096 2.70538L2.16139 0.395812C1.98883 0.22325 1.70901 0.22325 1.53642 0.395812C1.36383 0.568437 1.36383 0.84825 1.53642 1.02081L3.27989 2.76429C3.41006 2.89446 3.41006 3.10554 3.27989 3.23571Z%27/%3e%3c/svg%3e", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_96___ = new URL("data:image/svg+xml,%3csvg xmlns=%27http://www.w3.org/2000/svg%27 viewBox=%270 0 6 6%27 fill=%27var%28--bs-text-gray-800%29%27%3e%3cpath d=%27M2.72011 2.76429L4.46358 1.02083C4.63618 0.848244 4.63617 0.568419 4.46358 0.395831C4.29099 0.223244 4.01118 0.223244 3.83861 0.395831L1.52904 2.70537C1.36629 2.86808 1.36629 3.13191 1.52904 3.29462L3.83861 5.60419C4.01117 5.77675 4.29099 5.77675 4.46358 5.60419C4.63617 5.43156 4.63617 5.15175 4.46358 4.97919L2.72011 3.23571C2.58994 3.10554 2.58994 2.89446 2.72011 2.76429Z%27/%3e%3c/svg%3e", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_97___ = new URL("data:image/svg+xml,%3csvg xmlns=%27http://www.w3.org/2000/svg%27 viewBox=%270 0 6 6%27 fill=%27var%28--bs-text-gray-800%29%27%3e%3cpath d=%27M3.27989 3.23571L1.53642 4.97917C1.36382 5.15176 1.36383 5.43158 1.53642 5.60417C1.70901 5.77676 1.98882 5.77676 2.16139 5.60417L4.47096 3.29463C4.63371 3.13192 4.63371 2.86809 4.47096 2.70538L2.16139 0.395812C1.98883 0.22325 1.70901 0.22325 1.53642 0.395812C1.36383 0.568437 1.36383 0.84825 1.53642 1.02081L3.27989 2.76429C3.41006 2.89446 3.41006 3.10554 3.27989 3.23571Z%27/%3e%3c/svg%3e", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_98___ = new URL("data:image/svg+xml,%3csvg xmlns=%27http://www.w3.org/2000/svg%27 viewBox=%270 0 6 6%27 fill=%27var%28--bs-gray-900%29%27%3e%3cpath d=%27M2.72011 2.76429L4.46358 1.02083C4.63618 0.848244 4.63617 0.568419 4.46358 0.395831C4.29099 0.223244 4.01118 0.223244 3.83861 0.395831L1.52904 2.70537C1.36629 2.86808 1.36629 3.13191 1.52904 3.29462L3.83861 5.60419C4.01117 5.77675 4.29099 5.77675 4.46358 5.60419C4.63617 5.43156 4.63617 5.15175 4.46358 4.97919L2.72011 3.23571C2.58994 3.10554 2.58994 2.89446 2.72011 2.76429Z%27/%3e%3c/svg%3e", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_99___ = new URL("data:image/svg+xml,%3csvg xmlns=%27http://www.w3.org/2000/svg%27 viewBox=%270 0 6 6%27 fill=%27var%28--bs-gray-900%29%27%3e%3cpath d=%27M3.27989 3.23571L1.53642 4.97917C1.36382 5.15176 1.36383 5.43158 1.53642 5.60417C1.70901 5.77676 1.98882 5.77676 2.16139 5.60417L4.47096 3.29463C4.63371 3.13192 4.63371 2.86809 4.47096 2.70538L2.16139 0.395812C1.98883 0.22325 1.70901 0.22325 1.53642 0.395812C1.36383 0.568437 1.36383 0.84825 1.53642 1.02081L3.27989 2.76429C3.41006 2.89446 3.41006 3.10554 3.27989 3.23571Z%27/%3e%3c/svg%3e", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_100___ = new URL("data:image/svg+xml,%3csvg xmlns=%27http://www.w3.org/2000/svg%27 viewBox=%270 0 6 6%27 fill=%27var%28--bs-text-gray-900%29%27%3e%3cpath d=%27M2.72011 2.76429L4.46358 1.02083C4.63618 0.848244 4.63617 0.568419 4.46358 0.395831C4.29099 0.223244 4.01118 0.223244 3.83861 0.395831L1.52904 2.70537C1.36629 2.86808 1.36629 3.13191 1.52904 3.29462L3.83861 5.60419C4.01117 5.77675 4.29099 5.77675 4.46358 5.60419C4.63617 5.43156 4.63617 5.15175 4.46358 4.97919L2.72011 3.23571C2.58994 3.10554 2.58994 2.89446 2.72011 2.76429Z%27/%3e%3c/svg%3e", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_101___ = new URL("data:image/svg+xml,%3csvg xmlns=%27http://www.w3.org/2000/svg%27 viewBox=%270 0 6 6%27 fill=%27var%28--bs-text-gray-900%29%27%3e%3cpath d=%27M3.27989 3.23571L1.53642 4.97917C1.36382 5.15176 1.36383 5.43158 1.53642 5.60417C1.70901 5.77676 1.98882 5.77676 2.16139 5.60417L4.47096 3.29463C4.63371 3.13192 4.63371 2.86809 4.47096 2.70538L2.16139 0.395812C1.98883 0.22325 1.70901 0.22325 1.53642 0.395812C1.36383 0.568437 1.36383 0.84825 1.53642 1.02081L3.27989 2.76429C3.41006 2.89446 3.41006 3.10554 3.27989 3.23571Z%27/%3e%3c/svg%3e", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_102___ = new URL("data:image/svg+xml,%3csvg xmlns=%27http://www.w3.org/2000/svg%27 viewBox=%270 0 6 6%27 fill=%27var%28--bs-menu-link-color-hover%29%27%3e%3cpath d=%27M2.72011 2.76429L4.46358 1.02083C4.63618 0.848244 4.63617 0.568419 4.46358 0.395831C4.29099 0.223244 4.01118 0.223244 3.83861 0.395831L1.52904 2.70537C1.36629 2.86808 1.36629 3.13191 1.52904 3.29462L3.83861 5.60419C4.01117 5.77675 4.29099 5.77675 4.46358 5.60419C4.63617 5.43156 4.63617 5.15175 4.46358 4.97919L2.72011 3.23571C2.58994 3.10554 2.58994 2.89446 2.72011 2.76429Z%27/%3e%3c/svg%3e", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_103___ = new URL("data:image/svg+xml,%3csvg xmlns=%27http://www.w3.org/2000/svg%27 viewBox=%270 0 6 6%27 fill=%27var%28--bs-menu-link-color-hover%29%27%3e%3cpath d=%27M3.27989 3.23571L1.53642 4.97917C1.36382 5.15176 1.36383 5.43158 1.53642 5.60417C1.70901 5.77676 1.98882 5.77676 2.16139 5.60417L4.47096 3.29463C4.63371 3.13192 4.63371 2.86809 4.47096 2.70538L2.16139 0.395812C1.98883 0.22325 1.70901 0.22325 1.53642 0.395812C1.36383 0.568437 1.36383 0.84825 1.53642 1.02081L3.27989 2.76429C3.41006 2.89446 3.41006 3.10554 3.27989 3.23571Z%27/%3e%3c/svg%3e", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_104___ = new URL("data:image/svg+xml,%3csvg xmlns=%27http://www.w3.org/2000/svg%27 viewBox=%270 0 6 6%27 fill=%27var%28--bs-menu-link-color-here%29%27%3e%3cpath d=%27M2.72011 2.76429L4.46358 1.02083C4.63618 0.848244 4.63617 0.568419 4.46358 0.395831C4.29099 0.223244 4.01118 0.223244 3.83861 0.395831L1.52904 2.70537C1.36629 2.86808 1.36629 3.13191 1.52904 3.29462L3.83861 5.60419C4.01117 5.77675 4.29099 5.77675 4.46358 5.60419C4.63617 5.43156 4.63617 5.15175 4.46358 4.97919L2.72011 3.23571C2.58994 3.10554 2.58994 2.89446 2.72011 2.76429Z%27/%3e%3c/svg%3e", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_105___ = new URL("data:image/svg+xml,%3csvg xmlns=%27http://www.w3.org/2000/svg%27 viewBox=%270 0 6 6%27 fill=%27var%28--bs-menu-link-color-here%29%27%3e%3cpath d=%27M3.27989 3.23571L1.53642 4.97917C1.36382 5.15176 1.36383 5.43158 1.53642 5.60417C1.70901 5.77676 1.98882 5.77676 2.16139 5.60417L4.47096 3.29463C4.63371 3.13192 4.63371 2.86809 4.47096 2.70538L2.16139 0.395812C1.98883 0.22325 1.70901 0.22325 1.53642 0.395812C1.36383 0.568437 1.36383 0.84825 1.53642 1.02081L3.27989 2.76429C3.41006 2.89446 3.41006 3.10554 3.27989 3.23571Z%27/%3e%3c/svg%3e", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_106___ = new URL("data:image/svg+xml,%3csvg xmlns=%27http://www.w3.org/2000/svg%27 viewBox=%270 0 6 6%27 fill=%27var%28--bs-menu-link-color-show%29%27%3e%3cpath d=%27M2.72011 2.76429L4.46358 1.02083C4.63618 0.848244 4.63617 0.568419 4.46358 0.395831C4.29099 0.223244 4.01118 0.223244 3.83861 0.395831L1.52904 2.70537C1.36629 2.86808 1.36629 3.13191 1.52904 3.29462L3.83861 5.60419C4.01117 5.77675 4.29099 5.77675 4.46358 5.60419C4.63617 5.43156 4.63617 5.15175 4.46358 4.97919L2.72011 3.23571C2.58994 3.10554 2.58994 2.89446 2.72011 2.76429Z%27/%3e%3c/svg%3e", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_107___ = new URL("data:image/svg+xml,%3csvg xmlns=%27http://www.w3.org/2000/svg%27 viewBox=%270 0 6 6%27 fill=%27var%28--bs-menu-link-color-show%29%27%3e%3cpath d=%27M3.27989 3.23571L1.53642 4.97917C1.36382 5.15176 1.36383 5.43158 1.53642 5.60417C1.70901 5.77676 1.98882 5.77676 2.16139 5.60417L4.47096 3.29463C4.63371 3.13192 4.63371 2.86809 4.47096 2.70538L2.16139 0.395812C1.98883 0.22325 1.70901 0.22325 1.53642 0.395812C1.36383 0.568437 1.36383 0.84825 1.53642 1.02081L3.27989 2.76429C3.41006 2.89446 3.41006 3.10554 3.27989 3.23571Z%27/%3e%3c/svg%3e", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_108___ = new URL("data:image/svg+xml,%3csvg xmlns=%27http://www.w3.org/2000/svg%27 viewBox=%270 0 6 6%27 fill=%27var%28--bs-menu-link-color-active%29%27%3e%3cpath d=%27M2.72011 2.76429L4.46358 1.02083C4.63618 0.848244 4.63617 0.568419 4.46358 0.395831C4.29099 0.223244 4.01118 0.223244 3.83861 0.395831L1.52904 2.70537C1.36629 2.86808 1.36629 3.13191 1.52904 3.29462L3.83861 5.60419C4.01117 5.77675 4.29099 5.77675 4.46358 5.60419C4.63617 5.43156 4.63617 5.15175 4.46358 4.97919L2.72011 3.23571C2.58994 3.10554 2.58994 2.89446 2.72011 2.76429Z%27/%3e%3c/svg%3e", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_109___ = new URL("data:image/svg+xml,%3csvg xmlns=%27http://www.w3.org/2000/svg%27 viewBox=%270 0 6 6%27 fill=%27var%28--bs-menu-link-color-active%29%27%3e%3cpath d=%27M3.27989 3.23571L1.53642 4.97917C1.36382 5.15176 1.36383 5.43158 1.53642 5.60417C1.70901 5.77676 1.98882 5.77676 2.16139 5.60417L4.47096 3.29463C4.63371 3.13192 4.63371 2.86809 4.47096 2.70538L2.16139 0.395812C1.98883 0.22325 1.70901 0.22325 1.53642 0.395812C1.36383 0.568437 1.36383 0.84825 1.53642 1.02081L3.27989 2.76429C3.41006 2.89446 3.41006 3.10554 3.27989 3.23571Z%27/%3e%3c/svg%3e", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_110___ = new URL("data:image/svg+xml,%3csvg xmlns=%27http://www.w3.org/2000/svg%27 viewBox=%270 0 6 6%27 fill=%27var%28--bs-primary-inverse%29%27%3e%3cpath d=%27M2.72011 2.76429L4.46358 1.02083C4.63618 0.848244 4.63617 0.568419 4.46358 0.395831C4.29099 0.223244 4.01118 0.223244 3.83861 0.395831L1.52904 2.70537C1.36629 2.86808 1.36629 3.13191 1.52904 3.29462L3.83861 5.60419C4.01117 5.77675 4.29099 5.77675 4.46358 5.60419C4.63617 5.43156 4.63617 5.15175 4.46358 4.97919L2.72011 3.23571C2.58994 3.10554 2.58994 2.89446 2.72011 2.76429Z%27/%3e%3c/svg%3e", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_111___ = new URL("data:image/svg+xml,%3csvg xmlns=%27http://www.w3.org/2000/svg%27 viewBox=%270 0 6 6%27 fill=%27var%28--bs-primary-inverse%29%27%3e%3cpath d=%27M3.27989 3.23571L1.53642 4.97917C1.36382 5.15176 1.36383 5.43158 1.53642 5.60417C1.70901 5.77676 1.98882 5.77676 2.16139 5.60417L4.47096 3.29463C4.63371 3.13192 4.63371 2.86809 4.47096 2.70538L2.16139 0.395812C1.98883 0.22325 1.70901 0.22325 1.53642 0.395812C1.36383 0.568437 1.36383 0.84825 1.53642 1.02081L3.27989 2.76429C3.41006 2.89446 3.41006 3.10554 3.27989 3.23571Z%27/%3e%3c/svg%3e", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_112___ = new URL("data:image/svg+xml,%3csvg xmlns=%27http://www.w3.org/2000/svg%27 viewBox=%270 0 6 6%27 fill=%27var%28--bs-text-muted%29%27%3e%3cpath d=%27M3.23571 2.72011L4.97917 4.46358C5.15176 4.63618 5.43158 4.63617 5.60417 4.46358C5.77676 4.29099 5.77676 4.01118 5.60417 3.83861L3.29463 1.52904C3.13192 1.36629 2.86809 1.36629 2.70538 1.52904L0.395812 3.83861C0.22325 4.01117 0.22325 4.29099 0.395812 4.46358C0.568437 4.63617 0.84825 4.63617 1.02081 4.46358L2.76429 2.72011C2.89446 2.58994 3.10554 2.58994 3.23571 2.72011Z%27/%3e%3c/svg%3e", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_113___ = new URL("data:image/svg+xml,%3csvg xmlns=%27http://www.w3.org/2000/svg%27 viewBox=%270 0 6 6%27 fill=%27var%28--bs-text-muted%29%27%3e%3cpath d=%27M2.76429 3.27989L1.02083 1.53642C0.848244 1.36382 0.568419 1.36383 0.395831 1.53642C0.223244 1.70901 0.223244 1.98882 0.395831 2.16139L2.70537 4.47096C2.86808 4.63371 3.13191 4.63371 3.29462 4.47096L5.60419 2.16139C5.77675 1.98883 5.77675 1.70901 5.60419 1.53642C5.43156 1.36383 5.15175 1.36383 4.97919 1.53642L3.23571 3.27989C3.10554 3.41006 2.89446 3.41006 2.76429 3.27989Z%27/%3e%3c/svg%3e", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_114___ = new URL("data:image/svg+xml,%3csvg xmlns=%27http://www.w3.org/2000/svg%27 viewBox=%270 0 16 16%27 fill=%27var%28--bs-gray-500%29%27%3e%3cpath d=%27M.293.293a1 1 0 011.414 0L8 6.586 14.293.293a1 1 0 111.414 1.414L9.414 8l6.293 6.293a1 1 0 01-1.414 1.414L8 9.414l-6.293 6.293a1 1 0 01-1.414-1.414L6.586 8 .293 1.707a1 1 0 010-1.414z%27/%3e%3c/svg%3e", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_115___ = new URL("data:image/svg+xml,%3csvg xmlns=%27http://www.w3.org/2000/svg%27 viewBox=%270 0 6 6%27 fill=%27%23787887%27%3e%3cpath d=%27M2.72011 2.76429L4.46358 1.02083C4.63618 0.848244 4.63617 0.568419 4.46358 0.395831C4.29099 0.223244 4.01118 0.223244 3.83861 0.395831L1.52904 2.70537C1.36629 2.86808 1.36629 3.13191 1.52904 3.29462L3.83861 5.60419C4.01117 5.77675 4.29099 5.77675 4.46358 5.60419C4.63617 5.43156 4.63617 5.15175 4.46358 4.97919L2.72011 3.23571C2.58994 3.10554 2.58994 2.89446 2.72011 2.76429Z%27/%3e%3c/svg%3e", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_116___ = new URL("data:image/svg+xml,%3csvg xmlns=%27http://www.w3.org/2000/svg%27 viewBox=%270 0 6 6%27 fill=%27%23787887%27%3e%3cpath d=%27M3.27989 3.23571L1.53642 4.97917C1.36382 5.15176 1.36383 5.43158 1.53642 5.60417C1.70901 5.77676 1.98882 5.77676 2.16139 5.60417L4.47096 3.29463C4.63371 3.13192 4.63371 2.86809 4.47096 2.70538L2.16139 0.395812C1.98883 0.22325 1.70901 0.22325 1.53642 0.395812C1.36383 0.568437 1.36383 0.84825 1.53642 1.02081L3.27989 2.76429C3.41006 2.89446 3.41006 3.10554 3.27989 3.23571Z%27/%3e%3c/svg%3e", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
var ___CSS_LOADER_URL_REPLACEMENT_1___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_1___);
var ___CSS_LOADER_URL_REPLACEMENT_2___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_2___);
var ___CSS_LOADER_URL_REPLACEMENT_3___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_3___);
var ___CSS_LOADER_URL_REPLACEMENT_4___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_4___);
var ___CSS_LOADER_URL_REPLACEMENT_5___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_5___);
var ___CSS_LOADER_URL_REPLACEMENT_6___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_6___);
var ___CSS_LOADER_URL_REPLACEMENT_7___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_7___);
var ___CSS_LOADER_URL_REPLACEMENT_8___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_8___);
var ___CSS_LOADER_URL_REPLACEMENT_9___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_9___);
var ___CSS_LOADER_URL_REPLACEMENT_10___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_10___);
var ___CSS_LOADER_URL_REPLACEMENT_11___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_11___);
var ___CSS_LOADER_URL_REPLACEMENT_12___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_12___);
var ___CSS_LOADER_URL_REPLACEMENT_13___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_13___);
var ___CSS_LOADER_URL_REPLACEMENT_14___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_14___);
var ___CSS_LOADER_URL_REPLACEMENT_15___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_15___);
var ___CSS_LOADER_URL_REPLACEMENT_16___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_16___);
var ___CSS_LOADER_URL_REPLACEMENT_17___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_17___);
var ___CSS_LOADER_URL_REPLACEMENT_18___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_18___);
var ___CSS_LOADER_URL_REPLACEMENT_19___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_19___);
var ___CSS_LOADER_URL_REPLACEMENT_20___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_20___);
var ___CSS_LOADER_URL_REPLACEMENT_21___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_21___);
var ___CSS_LOADER_URL_REPLACEMENT_22___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_22___);
var ___CSS_LOADER_URL_REPLACEMENT_23___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_23___);
var ___CSS_LOADER_URL_REPLACEMENT_24___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_24___);
var ___CSS_LOADER_URL_REPLACEMENT_25___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_25___);
var ___CSS_LOADER_URL_REPLACEMENT_26___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_26___);
var ___CSS_LOADER_URL_REPLACEMENT_27___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_27___);
var ___CSS_LOADER_URL_REPLACEMENT_28___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_28___);
var ___CSS_LOADER_URL_REPLACEMENT_29___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_29___);
var ___CSS_LOADER_URL_REPLACEMENT_30___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_30___);
var ___CSS_LOADER_URL_REPLACEMENT_31___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_31___);
var ___CSS_LOADER_URL_REPLACEMENT_32___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_32___);
var ___CSS_LOADER_URL_REPLACEMENT_33___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_33___);
var ___CSS_LOADER_URL_REPLACEMENT_34___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_34___);
var ___CSS_LOADER_URL_REPLACEMENT_35___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_35___);
var ___CSS_LOADER_URL_REPLACEMENT_36___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_36___);
var ___CSS_LOADER_URL_REPLACEMENT_37___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_37___);
var ___CSS_LOADER_URL_REPLACEMENT_38___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_38___);
var ___CSS_LOADER_URL_REPLACEMENT_39___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_39___);
var ___CSS_LOADER_URL_REPLACEMENT_40___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_40___);
var ___CSS_LOADER_URL_REPLACEMENT_41___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_41___);
var ___CSS_LOADER_URL_REPLACEMENT_42___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_42___);
var ___CSS_LOADER_URL_REPLACEMENT_43___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_43___);
var ___CSS_LOADER_URL_REPLACEMENT_44___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_44___);
var ___CSS_LOADER_URL_REPLACEMENT_45___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_45___);
var ___CSS_LOADER_URL_REPLACEMENT_46___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_46___);
var ___CSS_LOADER_URL_REPLACEMENT_47___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_47___);
var ___CSS_LOADER_URL_REPLACEMENT_48___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_48___);
var ___CSS_LOADER_URL_REPLACEMENT_49___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_49___);
var ___CSS_LOADER_URL_REPLACEMENT_50___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_50___);
var ___CSS_LOADER_URL_REPLACEMENT_51___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_51___);
var ___CSS_LOADER_URL_REPLACEMENT_52___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_52___);
var ___CSS_LOADER_URL_REPLACEMENT_53___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_53___);
var ___CSS_LOADER_URL_REPLACEMENT_54___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_54___);
var ___CSS_LOADER_URL_REPLACEMENT_55___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_55___);
var ___CSS_LOADER_URL_REPLACEMENT_56___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_56___);
var ___CSS_LOADER_URL_REPLACEMENT_57___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_57___);
var ___CSS_LOADER_URL_REPLACEMENT_58___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_58___);
var ___CSS_LOADER_URL_REPLACEMENT_59___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_59___);
var ___CSS_LOADER_URL_REPLACEMENT_60___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_60___);
var ___CSS_LOADER_URL_REPLACEMENT_61___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_61___);
var ___CSS_LOADER_URL_REPLACEMENT_62___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_62___);
var ___CSS_LOADER_URL_REPLACEMENT_63___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_63___);
var ___CSS_LOADER_URL_REPLACEMENT_64___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_64___);
var ___CSS_LOADER_URL_REPLACEMENT_65___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_65___);
var ___CSS_LOADER_URL_REPLACEMENT_66___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_66___);
var ___CSS_LOADER_URL_REPLACEMENT_67___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_67___);
var ___CSS_LOADER_URL_REPLACEMENT_68___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_68___);
var ___CSS_LOADER_URL_REPLACEMENT_69___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_69___);
var ___CSS_LOADER_URL_REPLACEMENT_70___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_70___);
var ___CSS_LOADER_URL_REPLACEMENT_71___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_71___);
var ___CSS_LOADER_URL_REPLACEMENT_72___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_72___);
var ___CSS_LOADER_URL_REPLACEMENT_73___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_73___);
var ___CSS_LOADER_URL_REPLACEMENT_74___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_74___);
var ___CSS_LOADER_URL_REPLACEMENT_75___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_75___);
var ___CSS_LOADER_URL_REPLACEMENT_76___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_76___);
var ___CSS_LOADER_URL_REPLACEMENT_77___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_77___);
var ___CSS_LOADER_URL_REPLACEMENT_78___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_78___);
var ___CSS_LOADER_URL_REPLACEMENT_79___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_79___);
var ___CSS_LOADER_URL_REPLACEMENT_80___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_80___);
var ___CSS_LOADER_URL_REPLACEMENT_81___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_81___);
var ___CSS_LOADER_URL_REPLACEMENT_82___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_82___);
var ___CSS_LOADER_URL_REPLACEMENT_83___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_83___);
var ___CSS_LOADER_URL_REPLACEMENT_84___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_84___);
var ___CSS_LOADER_URL_REPLACEMENT_85___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_85___);
var ___CSS_LOADER_URL_REPLACEMENT_86___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_86___);
var ___CSS_LOADER_URL_REPLACEMENT_87___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_87___);
var ___CSS_LOADER_URL_REPLACEMENT_88___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_88___);
var ___CSS_LOADER_URL_REPLACEMENT_89___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_89___);
var ___CSS_LOADER_URL_REPLACEMENT_90___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_90___);
var ___CSS_LOADER_URL_REPLACEMENT_91___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_91___);
var ___CSS_LOADER_URL_REPLACEMENT_92___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_92___);
var ___CSS_LOADER_URL_REPLACEMENT_93___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_93___);
var ___CSS_LOADER_URL_REPLACEMENT_94___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_94___);
var ___CSS_LOADER_URL_REPLACEMENT_95___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_95___);
var ___CSS_LOADER_URL_REPLACEMENT_96___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_96___);
var ___CSS_LOADER_URL_REPLACEMENT_97___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_97___);
var ___CSS_LOADER_URL_REPLACEMENT_98___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_98___);
var ___CSS_LOADER_URL_REPLACEMENT_99___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_99___);
var ___CSS_LOADER_URL_REPLACEMENT_100___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_100___);
var ___CSS_LOADER_URL_REPLACEMENT_101___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_101___);
var ___CSS_LOADER_URL_REPLACEMENT_102___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_102___);
var ___CSS_LOADER_URL_REPLACEMENT_103___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_103___);
var ___CSS_LOADER_URL_REPLACEMENT_104___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_104___);
var ___CSS_LOADER_URL_REPLACEMENT_105___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_105___);
var ___CSS_LOADER_URL_REPLACEMENT_106___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_106___);
var ___CSS_LOADER_URL_REPLACEMENT_107___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_107___);
var ___CSS_LOADER_URL_REPLACEMENT_108___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_108___);
var ___CSS_LOADER_URL_REPLACEMENT_109___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_109___);
var ___CSS_LOADER_URL_REPLACEMENT_110___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_110___);
var ___CSS_LOADER_URL_REPLACEMENT_111___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_111___);
var ___CSS_LOADER_URL_REPLACEMENT_112___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_112___);
var ___CSS_LOADER_URL_REPLACEMENT_113___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_113___);
var ___CSS_LOADER_URL_REPLACEMENT_114___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_114___);
var ___CSS_LOADER_URL_REPLACEMENT_115___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_115___);
var ___CSS_LOADER_URL_REPLACEMENT_116___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_116___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `@charset "UTF-8";
/*!
 * Bootstrap  v5.3.0-alpha1 (https://getbootstrap.com/)
 * Copyright 2011-2022 The Bootstrap Authors
 * Licensed under MIT (https://github.com/twbs/bootstrap/blob/main/LICENSE)
 */
:root {
  --bs-blue: #0d6efd;
  --bs-indigo: #6610f2;
  --bs-purple: #6f42c1;
  --bs-pink: #d63384;
  --bs-red: #dc3545;
  --bs-orange: #fd7e14;
  --bs-yellow: #ffc107;
  --bs-green: #198754;
  --bs-teal: #20c997;
  --bs-cyan: #0dcaf0;
  --bs-black: #000000;
  --bs-gray: #7E8299;
  --bs-gray-dark: #3F4254;
  --bs-gray-100: #F9F9F9;
  --bs-gray-200: #F4F4F4;
  --bs-gray-300: #E1E3EA;
  --bs-gray-400: #B5B5C3;
  --bs-gray-500: #A1A5B7;
  --bs-gray-600: #7E8299;
  --bs-gray-700: #5E6278;
  --bs-gray-800: #3F4254;
  --bs-gray-900: #181C32;
  --bs-light: #F9F9F9;
  --bs-secondary: #E1E3EA;
  --bs-dark: #181C32;
  --bs-light-rgb: 249, 249, 249;
  --bs-secondary-rgb: 225, 227, 234;
  --bs-dark-rgb: 24, 28, 50;
  --bs-primary-text: #0a58ca;
  --bs-secondary-text: #7E8299;
  --bs-success-text: #146c43;
  --bs-info-text: #087990;
  --bs-warning-text: #997404;
  --bs-danger-text: #b02a37;
  --bs-light-text: #7E8299;
  --bs-dark-text: #5E6278;
  --bs-primary-bg-subtle: #cfe2ff;
  --bs-secondary-bg-subtle: #F9F9F9;
  --bs-success-bg-subtle: #d1e7dd;
  --bs-info-bg-subtle: #cff4fc;
  --bs-warning-bg-subtle: #fff3cd;
  --bs-danger-bg-subtle: #f8d7da;
  --bs-light-bg-subtle: #fcfcfc;
  --bs-dark-bg-subtle: #B5B5C3;
  --bs-primary-border-subtle: #9ec5fe;
  --bs-secondary-border-subtle: #F4F4F4;
  --bs-success-border-subtle: #a3cfbb;
  --bs-info-border-subtle: #9eeaf9;
  --bs-warning-border-subtle: #ffe69c;
  --bs-danger-border-subtle: #f1aeb5;
  --bs-light-border-subtle: #F4F4F4;
  --bs-dark-border-subtle: #A1A5B7;
  --bs-black-rgb: 0, 0, 0;
  --bs-body-color-rgb: 24, 28, 50;
  --bs-font-sans-serif: Inter, Helvetica, "sans-serif";
  --bs-font-monospace: SFMono-Regular, Menlo, Monaco, Consolas, "Liberation Mono", "Courier New", monospace;
  --bs-gradient: linear-gradient(180deg, rgba(255, 255, 255, 0.15), rgba(255, 255, 255, 0));
  --bs-body-font-family: var(--bs-font-sans-serif);
  --bs-body-font-size: 1rem;
  --bs-body-font-weight: 400;
  --bs-body-line-height: 1.5;
  --bs-body-color: #181C32;
  --bs-emphasis-color-rgb: 0, 0, 0;
  --bs-secondary-color: rgba(24, 28, 50, 0.75);
  --bs-secondary-color-rgb: 24, 28, 50;
  --bs-secondary-bg: #F4F4F4;
  --bs-secondary-bg-rgb: 244, 244, 244;
  --bs-tertiary-color: rgba(24, 28, 50, 0.5);
  --bs-tertiary-color-rgb: 24, 28, 50;
  --bs-tertiary-bg: #F9F9F9;
  --bs-tertiary-bg-rgb: 249, 249, 249;
  --bs-body-bg: #ffffff;
  --bs-body-bg-rgb: 255, 255, 255;
  --bs-heading-color: #181C32;
  --bs-link-decoration: none;
  --bs-link-hover-color: #0095e8;
  --bs-link-hover-color-rgb: 0, 149, 232;
  --bs-link-hover-decoration: none;
  --bs-border-width: 1px;
  --bs-border-style: solid;
  --bs-border-color: #F4F4F4;
  --bs-border-color-translucent: rgba(0, 0, 0, 0.175);
  --bs-border-radius: 0.475rem;
  --bs-border-radius-sm: 0.425rem;
  --bs-border-radius-lg: 0.625rem;
  --bs-border-radius-xl: 1rem;
  --bs-border-radius-2xl: 2rem;
  --bs-border-radius-pill: 50rem;
  --bs-box-shadow-inset: inset 0 1px 2px rgba(0, 0, 0, 0.075);
  --bs-emphasis-color: #000000;
  --bs-form-control-bg: var(--bs-body-bg);
  --bs-form-control-disabled-bg: var(--bs-secondary-bg);
  --bs-highlight-bg: #fff3cd;
  --bs-breakpoint-xs: 0;
  --bs-breakpoint-sm: 576px;
  --bs-breakpoint-md: 768px;
  --bs-breakpoint-lg: 992px;
  --bs-breakpoint-xl: 1200px;
  --bs-breakpoint-xxl: 1400px;
  --bs-body-color: #FFFFFF;
  --bs-body-color-rgb: 255, 255, 255;
  --bs-body-bg: #1e1e2d;
  --bs-body-bg-rgb: 30, 30, 45;
  --bs-emphasis-color: #F9F9F9;
  --bs-emphasis-color-rgb: 249, 249, 249;
  --bs-secondary-color: rgba(255, 255, 255, 0.75);
  --bs-secondary-color-rgb: 255, 255, 255;
  --bs-secondary-bg: #3F4254;
  --bs-secondary-bg-rgb: 63, 66, 84;
  --bs-tertiary-color: rgba(255, 255, 255, 0.5);
  --bs-tertiary-color-rgb: 255, 255, 255;
  --bs-tertiary-bg: #2c2f43;
  --bs-tertiary-bg-rgb: 44, 47, 67;
  --bs-emphasis-color: #ffffff;
  --bs-primary-text: #6ea8fe;
  --bs-secondary-text: #E1E3EA;
  --bs-success-text: #75b798;
  --bs-info-text: #6edff6;
  --bs-warning-text: #ffda6a;
  --bs-danger-text: #ea868f;
  --bs-light-text: #F9F9F9;
  --bs-dark-text: #E1E3EA;
  --bs-primary-bg-subtle: #031633;
  --bs-secondary-bg-subtle: #181C32;
  --bs-success-bg-subtle: #051b11;
  --bs-info-bg-subtle: #032830;
  --bs-warning-bg-subtle: #332701;
  --bs-danger-bg-subtle: #2c0b0e;
  --bs-light-bg-subtle: #3F4254;
  --bs-dark-bg-subtle: #20212a;
  --bs-primary-border-subtle: #084298;
  --bs-secondary-border-subtle: #5E6278;
  --bs-success-border-subtle: #0f5132;
  --bs-info-border-subtle: #055160;
  --bs-warning-border-subtle: #664d03;
  --bs-danger-border-subtle: #842029;
  --bs-light-border-subtle: #5E6278;
  --bs-dark-border-subtle: #3F4254;
  --bs-heading-color: #FFFFFF;
  --bs-link-color: #009ef7;
  --bs-link-hover-color: #9ec5fe;
  --bs-link-color-rgb: 0, 158, 247;
  --bs-link-hover-color-rgb: 158, 197, 254;
  --bs-border-color-translucent: rgba(255, 255, 255, 0.15);
  --bs-xs:0;
  --bs-sm:576px;
  --bs-md:768px;
  --bs-lg:992px;
  --bs-xl:1200px;
  --bs-xxl:1400px;
  --bs-scrollbar-size: 5px;
  --bs-scrollbar-overlay-size: 19px;
  --bs-scrollbar-overlay-space: 7px;
  --bs-white-bg-rgb: 255, 255, 255;
  --bs-black-bg-rgb: 0, 0, 0;
  --bs-gray-100: #1b1b29;
  --bs-gray-100-rgb: 27, 27, 41;
  --bs-gray-200: #2B2B40;
  --bs-gray-200-rgb: 43, 43, 64;
  --bs-gray-300: #323248;
  --bs-gray-300-rgb: 50, 50, 72;
  --bs-gray-400: #474761;
  --bs-gray-400-rgb: 71, 71, 97;
  --bs-gray-500: #565674;
  --bs-gray-500-rgb: 86, 86, 116;
  --bs-gray-600: #6D6D80;
  --bs-gray-600-rgb: 109, 109, 128;
  --bs-gray-700: #92929F;
  --bs-gray-700-rgb: 146, 146, 159;
  --bs-gray-800: #CDCDDE;
  --bs-gray-800-rgb: 205, 205, 222;
  --bs-gray-900: #FFFFFF;
  --bs-gray-900-rgb: 255, 255, 255;
  --bs-white: #ffffff;
  --bs-light: #2B2B40;
  --bs-primary: #009ef7;
  --bs-success: #50cd89;
  --bs-info: #7239ea;
  --bs-warning: #ffc700;
  --bs-danger: #f1416c;
  --bs-dark: #FFFFFF;
  --bs-secondary: #323248;
  --bs-primary-active: #0095e8;
  --bs-secondary-active: #474761;
  --bs-light-active: #323248;
  --bs-success-active: #47be7d;
  --bs-info-active: #5014d0;
  --bs-warning-active: #f1bc00;
  --bs-danger-active: #d9214e;
  --bs-dark-active: white;
  --bs-primary-light: #82a6c9;
  --bs-success-light: #1c3238;
  --bs-info-light: #4870a0;
  --bs-warning-light: #392f28;
  --bs-danger-light: #3a2434;
  --bs-dark-light: #2B2B40;
  --bs-secondary-light: #1b1b29;
  --bs-primary-inverse: #ffffff;
  --bs-secondary-inverse: #92929F;
  --bs-light-inverse: #7E8299;
  --bs-success-inverse: #ffffff;
  --bs-info-inverse: #ffffff;
  --bs-warning-inverse: #ffffff;
  --bs-danger-inverse: #ffffff;
  --bs-dark-inverse: #1b1b29;
  --bs-white-rgb: 255, 255, 255;
  --bs-light-rgb: 43, 43, 64;
  --bs-primary-rgb: 0, 158, 247;
  --bs-success-rgb: 80, 205, 137;
  --bs-info-rgb: 114, 57, 234;
  --bs-warning-rgb: 255, 199, 0;
  --bs-danger-rgb: 241, 65, 108;
  --bs-dark-rgb: 255, 255, 255;
  --bs-secondary-rgb: 50, 50, 72;
  --bs-text-white: #ffffff;
  --bs-text-primary: #009ef7;
  --bs-text-secondary: #323248;
  --bs-text-light: #2B2B40;
  --bs-text-success: #50cd89;
  --bs-text-info: #7239ea;
  --bs-text-warning: #ffc700;
  --bs-text-danger: #f1416c;
  --bs-text-dark: #FFFFFF;
  --bs-text-muted: #565674;
  --bs-text-gray-100: #1b1b29;
  --bs-text-gray-200: #2B2B40;
  --bs-text-gray-300: #323248;
  --bs-text-gray-400: #474761;
  --bs-text-gray-500: #565674;
  --bs-text-gray-600: #6D6D80;
  --bs-text-gray-700: #92929F;
  --bs-text-gray-800: #CDCDDE;
  --bs-text-gray-900: #FFFFFF;
  --bs-border-color: #2B2B40;
  --bs-border-dashed-color: #323248;
  --bs-component-active-color: #ffffff;
  --bs-component-active-bg: #009ef7;
  --bs-component-hover-color: #009ef7;
  --bs-component-hover-bg: #1b1b29;
  --bs-component-checked-color: #ffffff;
  --bs-component-checked-bg: #009ef7;
  --bs-box-shadow-xs: 0 0.1rem 0.75rem 0.25rem rgba(0, 0, 0, 0.05);
  --bs-box-shadow-sm: 0 0.1rem 1rem 0.25rem rgba(0, 0, 0, 0.05);
  --bs-box-shadow: 0 0.5rem 1.5rem 0.5rem rgba(0, 0, 0, 0.075);
  --bs-box-shadow-lg: 0 1rem 2rem 1rem rgba(0, 0, 0, 0.1);
  --bs-input-color: var(--bs-gray-700);
  --bs-input-bg: var(--bs-body-bg);
  --bs-input-solid-color: var(--bs-gray-700);
  --bs-input-solid-bg: var(--bs-gray-100);
  --bs-input-solid-bg-focus: var(--bs-gray-200);
  --bs-input-solid-placeholder-color: var(--bs-gray-500);
  --bs-tooltip-box-shadow: 0px 0px 30px rgba(0, 0, 0, 0.15);
  --bs-card-box-shadow: ;
  --bs-table-striped-bg: rgba(27, 27, 41, 0.75);
  --bs-table-loading-message-box-shadow: 0px 0px 30px rgba(0, 0, 0, 0.3);
  --bs-dropdown-bg: #1e1e2d;
  --bs-dropdown-box-shadow: 0px 0px 30px rgba(0, 0, 0, 0.3);
  --bs-code-bg: #2B2B40;
  --bs-code-box-shadow: 0px 3px 9px rgba(0, 0, 0, 0.08);
  --bs-code-color: #b93993;
  --bs-symbol-label-color: #CDCDDE;
  --bs-symbol-label-bg: #1b1b29;
  --bs-symbol-border-color: rgba(255, 255, 255, 0.5);
  --bs-bullet-bg-color: #474761;
  --bs-scrolltop-opacity: 0;
  --bs-scrolltop-opacity-on: 0.3;
  --bs-scrolltop-opacity-hover: 1;
  --bs-scrolltop-box-shadow: 0 0.5rem 1.5rem 0.5rem rgba(0, 0, 0, 0.075);
  --bs-scrolltop-bg-color: #009ef7;
  --bs-scrolltop-bg-color-hover: #009ef7;
  --bs-scrolltop-icon-color: #ffffff;
  --bs-scrolltop-icon-color-hover: #ffffff;
  --bs-drawer-box-shadow: 0px 0px 30px rgba(0, 0, 0, 0.1);
  --bs-drawer-bg-color: #1e1e2d;
  --bs-drawer-overlay-bg-color: rgba(0, 0, 0, 0.4);
  --bs-menu-dropdown-box-shadow: 0px 0px 30px rgba(0, 0, 0, 0.3);
  --bs-menu-dropdown-bg-color: #1e1e2d;
  --bs-menu-heading-color: #565674;
  --bs-menu-link-color-hover: #009ef7;
  --bs-menu-link-color-show: #009ef7;
  --bs-menu-link-color-here: #009ef7;
  --bs-menu-link-color-active: #009ef7;
  --bs-menu-link-bg-color-hover: #1b1b29;
  --bs-menu-link-bg-color-show: #1b1b29;
  --bs-menu-link-bg-color-here: #1b1b29;
  --bs-menu-link-bg-color-active: #1b1b29;
  --bs-scrollbar-color: #2B2B40;
  --bs-scrollbar-hover-color: #27273a;
  --bs-overlay-bg: rgba(255, 255, 255, 0.05);
  --bs-blockui-overlay-bg: rgba(255, 255, 255, 0.05);
  --bs-rating-color-default: #474761;
  --bs-rating-color-active: #FFAD0F;
  --bs-ribbon-label-box-shadow: 0px -1px 5px 0px rgba(255, 255, 255, 0.1);
  --bs-ribbon-label-bg: #009ef7;
  --bs-ribbon-label-border-color: #005d91;
  --bs-ribbon-clip-bg: #F9F9F9;
  --bs-engage-btn-bg: #2B2B40;
  --bs-engage-btn-box-shadow: 0px 0px 30px rgba(0, 0, 0, 0.3);
  --bs-engage-btn-border-color: #2B2B40;
  --bs-engage-btn-color: #CDCDDE;
  --bs-engage-btn-icon-color: #6D6D80;
  --bs-engage-btn-color-active: #CDCDDE;
}

*,
*::before,
*::after {
  box-sizing: border-box;
}

body {
  margin: 0;
  font-family: var(--bs-body-font-family);
  font-size: var(--bs-body-font-size);
  font-weight: var(--bs-body-font-weight);
  line-height: var(--bs-body-line-height);
  color: var(--bs-body-color);
  text-align: var(--bs-body-text-align);
  background-color: var(--bs-body-bg);
  -webkit-text-size-adjust: 100%;
  -webkit-tap-highlight-color: rgba(0, 0, 0, 0);
}

hr {
  margin: 1rem 0;
  color: inherit;
  border: 0;
  border-top: var(--bs-border-width) solid;
  opacity: 0.25;
}

h6, .h6, h5, .h5, h4, .h4, h3, .h3, h2, .h2, h1, .h1 {
  margin-top: 0;
  margin-bottom: 0.5rem;
  font-weight: 600;
  line-height: 1.2;
  color: var(--bs-heading-color, inherit);
}

h1, .h1 {
  font-size: calc(1.3rem + 0.6vw);
}

@media (min-width: 1200px) {
  h1, .h1 {
    font-size: 1.75rem;
  }
}
h2, .h2 {
  font-size: calc(1.275rem + 0.3vw);
}

@media (min-width: 1200px) {
  h2, .h2 {
    font-size: 1.5rem;
  }
}
h3, .h3 {
  font-size: calc(1.26rem + 0.12vw);
}

@media (min-width: 1200px) {
  h3, .h3 {
    font-size: 1.35rem;
  }
}
h4, .h4 {
  font-size: 1.25rem;
}

h5, .h5 {
  font-size: 1.15rem;
}

h6, .h6 {
  font-size: 1.075rem;
}

p {
  margin-top: 0;
  margin-bottom: 1rem;
}

abbr[title] {
  -webkit-text-decoration: underline dotted;
          text-decoration: underline dotted;
  cursor: help;
  text-decoration-skip-ink: none;
}

address {
  margin-bottom: 1rem;
  font-style: normal;
  line-height: inherit;
}

ol,
ul {
  padding-left: 2rem;
}

ol,
ul,
dl {
  margin-top: 0;
  margin-bottom: 1rem;
}

ol ol,
ul ul,
ol ul,
ul ol {
  margin-bottom: 0;
}

dt {
  font-weight: 600;
}

dd {
  margin-bottom: 0.5rem;
  margin-left: 0;
}

blockquote {
  margin: 0 0 1rem;
}

b,
strong {
  font-weight: 700;
}

small, .small {
  font-size: 0.875em;
}

mark, .mark {
  padding: 0.1875em;
  background-color: var(--bs-highlight-bg);
}

sub,
sup {
  position: relative;
  font-size: 0.75em;
  line-height: 0;
  vertical-align: baseline;
}

sub {
  bottom: -0.25em;
}

sup {
  top: -0.5em;
}

a {
  color: rgba(var(--bs-link-color-rgb), var(--bs-link-opacity, 1));
  text-decoration: none;
}

a:hover {
  --bs-link-color-rgb: var(--bs-link-hover-color-rgb);
  text-decoration: none;
}

a:not([href]):not([class]), a:not([href]):not([class]):hover {
  color: inherit;
  text-decoration: none;
}

pre,
code,
kbd,
samp {
  font-family: var(--bs-font-monospace);
  font-size: 1em;
}

pre {
  display: block;
  margin-top: 0;
  margin-bottom: 1rem;
  overflow: auto;
  font-size: 0.875em;
}

pre code {
  font-size: inherit;
  color: inherit;
  word-break: normal;
}

code {
  font-size: 0.875em;
  color: var(--bs-code-color);
  word-wrap: break-word;
}

a > code {
  color: inherit;
}

kbd {
  padding: 0.1875rem 0.375rem;
  font-size: 0.875em;
  color: var(--bs-body-bg);
  background-color: var(--bs-body-color);
  border-radius: 0.425rem;
}

kbd kbd {
  padding: 0;
  font-size: 1em;
}

figure {
  margin: 0 0 1rem;
}

img,
svg {
  vertical-align: middle;
}

table {
  caption-side: bottom;
  border-collapse: collapse;
}

caption {
  padding-top: 0.75rem;
  padding-bottom: 0.75rem;
  color: #A1A5B7;
  text-align: left;
}

th {
  text-align: inherit;
  text-align: -webkit-match-parent;
}

thead,
tbody,
tfoot,
tr,
td,
th {
  border-color: inherit;
  border-style: solid;
  border-width: 0;
}

label {
  display: inline-block;
}

button {
  border-radius: 0;
}

button:focus:not(:focus-visible) {
  outline: 0;
}

input,
button,
select,
optgroup,
textarea {
  margin: 0;
  font-family: inherit;
  font-size: inherit;
  line-height: inherit;
}

button,
select {
  text-transform: none;
}

[role=button] {
  cursor: pointer;
}

select {
  word-wrap: normal;
}

select:disabled {
  opacity: 1;
}

[list]:not([type=date]):not([type=datetime-local]):not([type=month]):not([type=week]):not([type=time])::-webkit-calendar-picker-indicator {
  display: none !important;
}

button,
[type=button],
[type=reset],
[type=submit] {
  -webkit-appearance: button;
}

button:not(:disabled),
[type=button]:not(:disabled),
[type=reset]:not(:disabled),
[type=submit]:not(:disabled) {
  cursor: pointer;
}

::-moz-focus-inner {
  padding: 0;
  border-style: none;
}

textarea {
  resize: vertical;
}

fieldset {
  min-width: 0;
  padding: 0;
  margin: 0;
  border: 0;
}

legend {
  float: left;
  width: 100%;
  padding: 0;
  margin-bottom: 0.5rem;
  font-size: calc(1.275rem + 0.3vw);
  line-height: inherit;
}

@media (min-width: 1200px) {
  legend {
    font-size: 1.5rem;
  }
}
legend + * {
  clear: left;
}

::-webkit-datetime-edit-fields-wrapper,
::-webkit-datetime-edit-text,
::-webkit-datetime-edit-minute,
::-webkit-datetime-edit-hour-field,
::-webkit-datetime-edit-day-field,
::-webkit-datetime-edit-month-field,
::-webkit-datetime-edit-year-field {
  padding: 0;
}

::-webkit-inner-spin-button {
  height: auto;
}

[type=search] {
  outline-offset: -2px;
  -webkit-appearance: textfield;
}

/* rtl:raw:
[type="tel"],
[type="url"],
[type="email"],
[type="number"] {
  direction: ltr;
}
*/
::-webkit-search-decoration {
  -webkit-appearance: none;
}

::-webkit-color-swatch-wrapper {
  padding: 0;
}

::file-selector-button {
  font: inherit;
  -webkit-appearance: button;
}

output {
  display: inline-block;
}

iframe {
  border: 0;
}

summary {
  display: list-item;
  cursor: pointer;
}

progress {
  vertical-align: baseline;
}

[hidden] {
  display: none !important;
}

.lead {
  font-size: 1.25rem;
  font-weight: 300;
}

.display-1 {
  font-size: calc(1.625rem + 4.5vw);
  font-weight: 700;
  line-height: 1.2;
}

@media (min-width: 1200px) {
  .display-1 {
    font-size: 5rem;
  }
}
.display-2 {
  font-size: calc(1.575rem + 3.9vw);
  font-weight: 700;
  line-height: 1.2;
}

@media (min-width: 1200px) {
  .display-2 {
    font-size: 4.5rem;
  }
}
.display-3 {
  font-size: calc(1.525rem + 3.3vw);
  font-weight: 700;
  line-height: 1.2;
}

@media (min-width: 1200px) {
  .display-3 {
    font-size: 4rem;
  }
}
.display-4 {
  font-size: calc(1.475rem + 2.7vw);
  font-weight: 700;
  line-height: 1.2;
}

@media (min-width: 1200px) {
  .display-4 {
    font-size: 3.5rem;
  }
}
.display-5 {
  font-size: calc(1.425rem + 2.1vw);
  font-weight: 700;
  line-height: 1.2;
}

@media (min-width: 1200px) {
  .display-5 {
    font-size: 3rem;
  }
}
.display-6 {
  font-size: calc(1.375rem + 1.5vw);
  font-weight: 700;
  line-height: 1.2;
}

@media (min-width: 1200px) {
  .display-6 {
    font-size: 2.5rem;
  }
}
.list-unstyled {
  padding-left: 0;
  list-style: none;
}

.list-inline {
  padding-left: 0;
  list-style: none;
}

.list-inline-item {
  display: inline-block;
}

.list-inline-item:not(:last-child) {
  margin-right: 0.5rem;
}

.initialism {
  font-size: 0.875em;
  text-transform: uppercase;
}

.blockquote {
  margin-bottom: 1rem;
  font-size: 1.25rem;
}

.blockquote > :last-child {
  margin-bottom: 0;
}

.blockquote-footer {
  margin-top: -1rem;
  margin-bottom: 1rem;
  font-size: 0.875em;
  color: #7E8299;
}

.blockquote-footer::before {
  content: "— ";
}

.img-fluid {
  max-width: 100%;
  height: auto;
}

.img-thumbnail {
  padding: 0.25rem;
  background-color: var(--bs-body-bg);
  border: var(--bs-border-width) solid var(--bs-border-color);
  border-radius: var(--bs-border-radius);
  box-shadow: var(--bs-box-shadow-sm);
  max-width: 100%;
  height: auto;
}

.figure {
  display: inline-block;
}

.figure-img {
  margin-bottom: 0.5rem;
  line-height: 1;
}

.figure-caption {
  font-size: 0.875em;
  color: var(--bs-gray-600);
}

.container,
.container-fluid,
.container-xxl,
.container-xl,
.container-lg,
.container-md,
.container-sm {
  --bs-gutter-x: 1.5rem;
  --bs-gutter-y: 0;
  width: 100%;
  padding-right: calc(var(--bs-gutter-x) * 0.5);
  padding-left: calc(var(--bs-gutter-x) * 0.5);
  margin-right: auto;
  margin-left: auto;
}

@media (min-width: 576px) {
  .container-sm, .container {
    max-width: 540px;
  }
}
@media (min-width: 768px) {
  .container-md, .container-sm, .container {
    max-width: 720px;
  }
}
@media (min-width: 992px) {
  .container-lg, .container-md, .container-sm, .container {
    max-width: 960px;
  }
}
@media (min-width: 1200px) {
  .container-xl, .container-lg, .container-md, .container-sm, .container {
    max-width: 1140px;
  }
}
@media (min-width: 1400px) {
  .container-xxl, .container-xl, .container-lg, .container-md, .container-sm, .container {
    max-width: 1320px;
  }
}
.row {
  --bs-gutter-x: 1.5rem;
  --bs-gutter-y: 0;
  display: flex;
  flex-wrap: wrap;
  margin-top: calc(-1 * var(--bs-gutter-y));
  margin-right: calc(-0.5 * var(--bs-gutter-x));
  margin-left: calc(-0.5 * var(--bs-gutter-x));
}

.row > * {
  flex-shrink: 0;
  width: 100%;
  max-width: 100%;
  padding-right: calc(var(--bs-gutter-x) * 0.5);
  padding-left: calc(var(--bs-gutter-x) * 0.5);
  margin-top: var(--bs-gutter-y);
}

.col {
  flex: 1 0;
}

.row-cols-auto > * {
  flex: 0 0 auto;
  width: auto;
}

.row-cols-1 > * {
  flex: 0 0 auto;
  width: 100%;
}

.row-cols-2 > * {
  flex: 0 0 auto;
  width: 50%;
}

.row-cols-3 > * {
  flex: 0 0 auto;
  width: 33.3333333333%;
}

.row-cols-4 > * {
  flex: 0 0 auto;
  width: 25%;
}

.row-cols-5 > * {
  flex: 0 0 auto;
  width: 20%;
}

.row-cols-6 > * {
  flex: 0 0 auto;
  width: 16.6666666667%;
}

.col-auto {
  flex: 0 0 auto;
  width: auto;
}

.col-1 {
  flex: 0 0 auto;
  width: 8.33333333%;
}

.col-2 {
  flex: 0 0 auto;
  width: 16.66666667%;
}

.col-3 {
  flex: 0 0 auto;
  width: 25%;
}

.col-4 {
  flex: 0 0 auto;
  width: 33.33333333%;
}

.col-5 {
  flex: 0 0 auto;
  width: 41.66666667%;
}

.col-6 {
  flex: 0 0 auto;
  width: 50%;
}

.col-7 {
  flex: 0 0 auto;
  width: 58.33333333%;
}

.col-8 {
  flex: 0 0 auto;
  width: 66.66666667%;
}

.col-9 {
  flex: 0 0 auto;
  width: 75%;
}

.col-10 {
  flex: 0 0 auto;
  width: 83.33333333%;
}

.col-11 {
  flex: 0 0 auto;
  width: 91.66666667%;
}

.col-12 {
  flex: 0 0 auto;
  width: 100%;
}

.offset-1 {
  margin-left: 8.33333333%;
}

.offset-2 {
  margin-left: 16.66666667%;
}

.offset-3 {
  margin-left: 25%;
}

.offset-4 {
  margin-left: 33.33333333%;
}

.offset-5 {
  margin-left: 41.66666667%;
}

.offset-6 {
  margin-left: 50%;
}

.offset-7 {
  margin-left: 58.33333333%;
}

.offset-8 {
  margin-left: 66.66666667%;
}

.offset-9 {
  margin-left: 75%;
}

.offset-10 {
  margin-left: 83.33333333%;
}

.offset-11 {
  margin-left: 91.66666667%;
}

.g-0,
.gx-0 {
  --bs-gutter-x: 0rem;
}

.g-0,
.gy-0 {
  --bs-gutter-y: 0rem;
}

.g-1,
.gx-1 {
  --bs-gutter-x: 0.25rem;
}

.g-1,
.gy-1 {
  --bs-gutter-y: 0.25rem;
}

.g-2,
.gx-2 {
  --bs-gutter-x: 0.5rem;
}

.g-2,
.gy-2 {
  --bs-gutter-y: 0.5rem;
}

.g-3,
.gx-3 {
  --bs-gutter-x: 0.75rem;
}

.g-3,
.gy-3 {
  --bs-gutter-y: 0.75rem;
}

.g-4,
.gx-4 {
  --bs-gutter-x: 1rem;
}

.g-4,
.gy-4 {
  --bs-gutter-y: 1rem;
}

.g-5,
.gx-5 {
  --bs-gutter-x: 1.25rem;
}

.g-5,
.gy-5 {
  --bs-gutter-y: 1.25rem;
}

.g-6,
.gx-6 {
  --bs-gutter-x: 1.5rem;
}

.g-6,
.gy-6 {
  --bs-gutter-y: 1.5rem;
}

.g-7,
.gx-7 {
  --bs-gutter-x: 1.75rem;
}

.g-7,
.gy-7 {
  --bs-gutter-y: 1.75rem;
}

.g-8,
.gx-8 {
  --bs-gutter-x: 2rem;
}

.g-8,
.gy-8 {
  --bs-gutter-y: 2rem;
}

.g-9,
.gx-9 {
  --bs-gutter-x: 2.25rem;
}

.g-9,
.gy-9 {
  --bs-gutter-y: 2.25rem;
}

.g-10,
.gx-10 {
  --bs-gutter-x: 2.5rem;
}

.g-10,
.gy-10 {
  --bs-gutter-y: 2.5rem;
}

@media (min-width: 576px) {
  .col-sm {
    flex: 1 0;
  }
  .row-cols-sm-auto > * {
    flex: 0 0 auto;
    width: auto;
  }
  .row-cols-sm-1 > * {
    flex: 0 0 auto;
    width: 100%;
  }
  .row-cols-sm-2 > * {
    flex: 0 0 auto;
    width: 50%;
  }
  .row-cols-sm-3 > * {
    flex: 0 0 auto;
    width: 33.3333333333%;
  }
  .row-cols-sm-4 > * {
    flex: 0 0 auto;
    width: 25%;
  }
  .row-cols-sm-5 > * {
    flex: 0 0 auto;
    width: 20%;
  }
  .row-cols-sm-6 > * {
    flex: 0 0 auto;
    width: 16.6666666667%;
  }
  .col-sm-auto {
    flex: 0 0 auto;
    width: auto;
  }
  .col-sm-1 {
    flex: 0 0 auto;
    width: 8.33333333%;
  }
  .col-sm-2 {
    flex: 0 0 auto;
    width: 16.66666667%;
  }
  .col-sm-3 {
    flex: 0 0 auto;
    width: 25%;
  }
  .col-sm-4 {
    flex: 0 0 auto;
    width: 33.33333333%;
  }
  .col-sm-5 {
    flex: 0 0 auto;
    width: 41.66666667%;
  }
  .col-sm-6 {
    flex: 0 0 auto;
    width: 50%;
  }
  .col-sm-7 {
    flex: 0 0 auto;
    width: 58.33333333%;
  }
  .col-sm-8 {
    flex: 0 0 auto;
    width: 66.66666667%;
  }
  .col-sm-9 {
    flex: 0 0 auto;
    width: 75%;
  }
  .col-sm-10 {
    flex: 0 0 auto;
    width: 83.33333333%;
  }
  .col-sm-11 {
    flex: 0 0 auto;
    width: 91.66666667%;
  }
  .col-sm-12 {
    flex: 0 0 auto;
    width: 100%;
  }
  .offset-sm-0 {
    margin-left: 0;
  }
  .offset-sm-1 {
    margin-left: 8.33333333%;
  }
  .offset-sm-2 {
    margin-left: 16.66666667%;
  }
  .offset-sm-3 {
    margin-left: 25%;
  }
  .offset-sm-4 {
    margin-left: 33.33333333%;
  }
  .offset-sm-5 {
    margin-left: 41.66666667%;
  }
  .offset-sm-6 {
    margin-left: 50%;
  }
  .offset-sm-7 {
    margin-left: 58.33333333%;
  }
  .offset-sm-8 {
    margin-left: 66.66666667%;
  }
  .offset-sm-9 {
    margin-left: 75%;
  }
  .offset-sm-10 {
    margin-left: 83.33333333%;
  }
  .offset-sm-11 {
    margin-left: 91.66666667%;
  }
  .g-sm-0,
  .gx-sm-0 {
    --bs-gutter-x: 0rem;
  }
  .g-sm-0,
  .gy-sm-0 {
    --bs-gutter-y: 0rem;
  }
  .g-sm-1,
  .gx-sm-1 {
    --bs-gutter-x: 0.25rem;
  }
  .g-sm-1,
  .gy-sm-1 {
    --bs-gutter-y: 0.25rem;
  }
  .g-sm-2,
  .gx-sm-2 {
    --bs-gutter-x: 0.5rem;
  }
  .g-sm-2,
  .gy-sm-2 {
    --bs-gutter-y: 0.5rem;
  }
  .g-sm-3,
  .gx-sm-3 {
    --bs-gutter-x: 0.75rem;
  }
  .g-sm-3,
  .gy-sm-3 {
    --bs-gutter-y: 0.75rem;
  }
  .g-sm-4,
  .gx-sm-4 {
    --bs-gutter-x: 1rem;
  }
  .g-sm-4,
  .gy-sm-4 {
    --bs-gutter-y: 1rem;
  }
  .g-sm-5,
  .gx-sm-5 {
    --bs-gutter-x: 1.25rem;
  }
  .g-sm-5,
  .gy-sm-5 {
    --bs-gutter-y: 1.25rem;
  }
  .g-sm-6,
  .gx-sm-6 {
    --bs-gutter-x: 1.5rem;
  }
  .g-sm-6,
  .gy-sm-6 {
    --bs-gutter-y: 1.5rem;
  }
  .g-sm-7,
  .gx-sm-7 {
    --bs-gutter-x: 1.75rem;
  }
  .g-sm-7,
  .gy-sm-7 {
    --bs-gutter-y: 1.75rem;
  }
  .g-sm-8,
  .gx-sm-8 {
    --bs-gutter-x: 2rem;
  }
  .g-sm-8,
  .gy-sm-8 {
    --bs-gutter-y: 2rem;
  }
  .g-sm-9,
  .gx-sm-9 {
    --bs-gutter-x: 2.25rem;
  }
  .g-sm-9,
  .gy-sm-9 {
    --bs-gutter-y: 2.25rem;
  }
  .g-sm-10,
  .gx-sm-10 {
    --bs-gutter-x: 2.5rem;
  }
  .g-sm-10,
  .gy-sm-10 {
    --bs-gutter-y: 2.5rem;
  }
}
@media (min-width: 768px) {
  .col-md {
    flex: 1 0;
  }
  .row-cols-md-auto > * {
    flex: 0 0 auto;
    width: auto;
  }
  .row-cols-md-1 > * {
    flex: 0 0 auto;
    width: 100%;
  }
  .row-cols-md-2 > * {
    flex: 0 0 auto;
    width: 50%;
  }
  .row-cols-md-3 > * {
    flex: 0 0 auto;
    width: 33.3333333333%;
  }
  .row-cols-md-4 > * {
    flex: 0 0 auto;
    width: 25%;
  }
  .row-cols-md-5 > * {
    flex: 0 0 auto;
    width: 20%;
  }
  .row-cols-md-6 > * {
    flex: 0 0 auto;
    width: 16.6666666667%;
  }
  .col-md-auto {
    flex: 0 0 auto;
    width: auto;
  }
  .col-md-1 {
    flex: 0 0 auto;
    width: 8.33333333%;
  }
  .col-md-2 {
    flex: 0 0 auto;
    width: 16.66666667%;
  }
  .col-md-3 {
    flex: 0 0 auto;
    width: 25%;
  }
  .col-md-4 {
    flex: 0 0 auto;
    width: 33.33333333%;
  }
  .col-md-5 {
    flex: 0 0 auto;
    width: 41.66666667%;
  }
  .col-md-6 {
    flex: 0 0 auto;
    width: 50%;
  }
  .col-md-7 {
    flex: 0 0 auto;
    width: 58.33333333%;
  }
  .col-md-8 {
    flex: 0 0 auto;
    width: 66.66666667%;
  }
  .col-md-9 {
    flex: 0 0 auto;
    width: 75%;
  }
  .col-md-10 {
    flex: 0 0 auto;
    width: 83.33333333%;
  }
  .col-md-11 {
    flex: 0 0 auto;
    width: 91.66666667%;
  }
  .col-md-12 {
    flex: 0 0 auto;
    width: 100%;
  }
  .offset-md-0 {
    margin-left: 0;
  }
  .offset-md-1 {
    margin-left: 8.33333333%;
  }
  .offset-md-2 {
    margin-left: 16.66666667%;
  }
  .offset-md-3 {
    margin-left: 25%;
  }
  .offset-md-4 {
    margin-left: 33.33333333%;
  }
  .offset-md-5 {
    margin-left: 41.66666667%;
  }
  .offset-md-6 {
    margin-left: 50%;
  }
  .offset-md-7 {
    margin-left: 58.33333333%;
  }
  .offset-md-8 {
    margin-left: 66.66666667%;
  }
  .offset-md-9 {
    margin-left: 75%;
  }
  .offset-md-10 {
    margin-left: 83.33333333%;
  }
  .offset-md-11 {
    margin-left: 91.66666667%;
  }
  .g-md-0,
  .gx-md-0 {
    --bs-gutter-x: 0rem;
  }
  .g-md-0,
  .gy-md-0 {
    --bs-gutter-y: 0rem;
  }
  .g-md-1,
  .gx-md-1 {
    --bs-gutter-x: 0.25rem;
  }
  .g-md-1,
  .gy-md-1 {
    --bs-gutter-y: 0.25rem;
  }
  .g-md-2,
  .gx-md-2 {
    --bs-gutter-x: 0.5rem;
  }
  .g-md-2,
  .gy-md-2 {
    --bs-gutter-y: 0.5rem;
  }
  .g-md-3,
  .gx-md-3 {
    --bs-gutter-x: 0.75rem;
  }
  .g-md-3,
  .gy-md-3 {
    --bs-gutter-y: 0.75rem;
  }
  .g-md-4,
  .gx-md-4 {
    --bs-gutter-x: 1rem;
  }
  .g-md-4,
  .gy-md-4 {
    --bs-gutter-y: 1rem;
  }
  .g-md-5,
  .gx-md-5 {
    --bs-gutter-x: 1.25rem;
  }
  .g-md-5,
  .gy-md-5 {
    --bs-gutter-y: 1.25rem;
  }
  .g-md-6,
  .gx-md-6 {
    --bs-gutter-x: 1.5rem;
  }
  .g-md-6,
  .gy-md-6 {
    --bs-gutter-y: 1.5rem;
  }
  .g-md-7,
  .gx-md-7 {
    --bs-gutter-x: 1.75rem;
  }
  .g-md-7,
  .gy-md-7 {
    --bs-gutter-y: 1.75rem;
  }
  .g-md-8,
  .gx-md-8 {
    --bs-gutter-x: 2rem;
  }
  .g-md-8,
  .gy-md-8 {
    --bs-gutter-y: 2rem;
  }
  .g-md-9,
  .gx-md-9 {
    --bs-gutter-x: 2.25rem;
  }
  .g-md-9,
  .gy-md-9 {
    --bs-gutter-y: 2.25rem;
  }
  .g-md-10,
  .gx-md-10 {
    --bs-gutter-x: 2.5rem;
  }
  .g-md-10,
  .gy-md-10 {
    --bs-gutter-y: 2.5rem;
  }
}
@media (min-width: 992px) {
  .col-lg {
    flex: 1 0;
  }
  .row-cols-lg-auto > * {
    flex: 0 0 auto;
    width: auto;
  }
  .row-cols-lg-1 > * {
    flex: 0 0 auto;
    width: 100%;
  }
  .row-cols-lg-2 > * {
    flex: 0 0 auto;
    width: 50%;
  }
  .row-cols-lg-3 > * {
    flex: 0 0 auto;
    width: 33.3333333333%;
  }
  .row-cols-lg-4 > * {
    flex: 0 0 auto;
    width: 25%;
  }
  .row-cols-lg-5 > * {
    flex: 0 0 auto;
    width: 20%;
  }
  .row-cols-lg-6 > * {
    flex: 0 0 auto;
    width: 16.6666666667%;
  }
  .col-lg-auto {
    flex: 0 0 auto;
    width: auto;
  }
  .col-lg-1 {
    flex: 0 0 auto;
    width: 8.33333333%;
  }
  .col-lg-2 {
    flex: 0 0 auto;
    width: 16.66666667%;
  }
  .col-lg-3 {
    flex: 0 0 auto;
    width: 25%;
  }
  .col-lg-4 {
    flex: 0 0 auto;
    width: 33.33333333%;
  }
  .col-lg-5 {
    flex: 0 0 auto;
    width: 41.66666667%;
  }
  .col-lg-6 {
    flex: 0 0 auto;
    width: 50%;
  }
  .col-lg-7 {
    flex: 0 0 auto;
    width: 58.33333333%;
  }
  .col-lg-8 {
    flex: 0 0 auto;
    width: 66.66666667%;
  }
  .col-lg-9 {
    flex: 0 0 auto;
    width: 75%;
  }
  .col-lg-10 {
    flex: 0 0 auto;
    width: 83.33333333%;
  }
  .col-lg-11 {
    flex: 0 0 auto;
    width: 91.66666667%;
  }
  .col-lg-12 {
    flex: 0 0 auto;
    width: 100%;
  }
  .offset-lg-0 {
    margin-left: 0;
  }
  .offset-lg-1 {
    margin-left: 8.33333333%;
  }
  .offset-lg-2 {
    margin-left: 16.66666667%;
  }
  .offset-lg-3 {
    margin-left: 25%;
  }
  .offset-lg-4 {
    margin-left: 33.33333333%;
  }
  .offset-lg-5 {
    margin-left: 41.66666667%;
  }
  .offset-lg-6 {
    margin-left: 50%;
  }
  .offset-lg-7 {
    margin-left: 58.33333333%;
  }
  .offset-lg-8 {
    margin-left: 66.66666667%;
  }
  .offset-lg-9 {
    margin-left: 75%;
  }
  .offset-lg-10 {
    margin-left: 83.33333333%;
  }
  .offset-lg-11 {
    margin-left: 91.66666667%;
  }
  .g-lg-0,
  .gx-lg-0 {
    --bs-gutter-x: 0rem;
  }
  .g-lg-0,
  .gy-lg-0 {
    --bs-gutter-y: 0rem;
  }
  .g-lg-1,
  .gx-lg-1 {
    --bs-gutter-x: 0.25rem;
  }
  .g-lg-1,
  .gy-lg-1 {
    --bs-gutter-y: 0.25rem;
  }
  .g-lg-2,
  .gx-lg-2 {
    --bs-gutter-x: 0.5rem;
  }
  .g-lg-2,
  .gy-lg-2 {
    --bs-gutter-y: 0.5rem;
  }
  .g-lg-3,
  .gx-lg-3 {
    --bs-gutter-x: 0.75rem;
  }
  .g-lg-3,
  .gy-lg-3 {
    --bs-gutter-y: 0.75rem;
  }
  .g-lg-4,
  .gx-lg-4 {
    --bs-gutter-x: 1rem;
  }
  .g-lg-4,
  .gy-lg-4 {
    --bs-gutter-y: 1rem;
  }
  .g-lg-5,
  .gx-lg-5 {
    --bs-gutter-x: 1.25rem;
  }
  .g-lg-5,
  .gy-lg-5 {
    --bs-gutter-y: 1.25rem;
  }
  .g-lg-6,
  .gx-lg-6 {
    --bs-gutter-x: 1.5rem;
  }
  .g-lg-6,
  .gy-lg-6 {
    --bs-gutter-y: 1.5rem;
  }
  .g-lg-7,
  .gx-lg-7 {
    --bs-gutter-x: 1.75rem;
  }
  .g-lg-7,
  .gy-lg-7 {
    --bs-gutter-y: 1.75rem;
  }
  .g-lg-8,
  .gx-lg-8 {
    --bs-gutter-x: 2rem;
  }
  .g-lg-8,
  .gy-lg-8 {
    --bs-gutter-y: 2rem;
  }
  .g-lg-9,
  .gx-lg-9 {
    --bs-gutter-x: 2.25rem;
  }
  .g-lg-9,
  .gy-lg-9 {
    --bs-gutter-y: 2.25rem;
  }
  .g-lg-10,
  .gx-lg-10 {
    --bs-gutter-x: 2.5rem;
  }
  .g-lg-10,
  .gy-lg-10 {
    --bs-gutter-y: 2.5rem;
  }
}
@media (min-width: 1200px) {
  .col-xl {
    flex: 1 0;
  }
  .row-cols-xl-auto > * {
    flex: 0 0 auto;
    width: auto;
  }
  .row-cols-xl-1 > * {
    flex: 0 0 auto;
    width: 100%;
  }
  .row-cols-xl-2 > * {
    flex: 0 0 auto;
    width: 50%;
  }
  .row-cols-xl-3 > * {
    flex: 0 0 auto;
    width: 33.3333333333%;
  }
  .row-cols-xl-4 > * {
    flex: 0 0 auto;
    width: 25%;
  }
  .row-cols-xl-5 > * {
    flex: 0 0 auto;
    width: 20%;
  }
  .row-cols-xl-6 > * {
    flex: 0 0 auto;
    width: 16.6666666667%;
  }
  .col-xl-auto {
    flex: 0 0 auto;
    width: auto;
  }
  .col-xl-1 {
    flex: 0 0 auto;
    width: 8.33333333%;
  }
  .col-xl-2 {
    flex: 0 0 auto;
    width: 16.66666667%;
  }
  .col-xl-3 {
    flex: 0 0 auto;
    width: 25%;
  }
  .col-xl-4 {
    flex: 0 0 auto;
    width: 33.33333333%;
  }
  .col-xl-5 {
    flex: 0 0 auto;
    width: 41.66666667%;
  }
  .col-xl-6 {
    flex: 0 0 auto;
    width: 50%;
  }
  .col-xl-7 {
    flex: 0 0 auto;
    width: 58.33333333%;
  }
  .col-xl-8 {
    flex: 0 0 auto;
    width: 66.66666667%;
  }
  .col-xl-9 {
    flex: 0 0 auto;
    width: 75%;
  }
  .col-xl-10 {
    flex: 0 0 auto;
    width: 83.33333333%;
  }
  .col-xl-11 {
    flex: 0 0 auto;
    width: 91.66666667%;
  }
  .col-xl-12 {
    flex: 0 0 auto;
    width: 100%;
  }
  .offset-xl-0 {
    margin-left: 0;
  }
  .offset-xl-1 {
    margin-left: 8.33333333%;
  }
  .offset-xl-2 {
    margin-left: 16.66666667%;
  }
  .offset-xl-3 {
    margin-left: 25%;
  }
  .offset-xl-4 {
    margin-left: 33.33333333%;
  }
  .offset-xl-5 {
    margin-left: 41.66666667%;
  }
  .offset-xl-6 {
    margin-left: 50%;
  }
  .offset-xl-7 {
    margin-left: 58.33333333%;
  }
  .offset-xl-8 {
    margin-left: 66.66666667%;
  }
  .offset-xl-9 {
    margin-left: 75%;
  }
  .offset-xl-10 {
    margin-left: 83.33333333%;
  }
  .offset-xl-11 {
    margin-left: 91.66666667%;
  }
  .g-xl-0,
  .gx-xl-0 {
    --bs-gutter-x: 0rem;
  }
  .g-xl-0,
  .gy-xl-0 {
    --bs-gutter-y: 0rem;
  }
  .g-xl-1,
  .gx-xl-1 {
    --bs-gutter-x: 0.25rem;
  }
  .g-xl-1,
  .gy-xl-1 {
    --bs-gutter-y: 0.25rem;
  }
  .g-xl-2,
  .gx-xl-2 {
    --bs-gutter-x: 0.5rem;
  }
  .g-xl-2,
  .gy-xl-2 {
    --bs-gutter-y: 0.5rem;
  }
  .g-xl-3,
  .gx-xl-3 {
    --bs-gutter-x: 0.75rem;
  }
  .g-xl-3,
  .gy-xl-3 {
    --bs-gutter-y: 0.75rem;
  }
  .g-xl-4,
  .gx-xl-4 {
    --bs-gutter-x: 1rem;
  }
  .g-xl-4,
  .gy-xl-4 {
    --bs-gutter-y: 1rem;
  }
  .g-xl-5,
  .gx-xl-5 {
    --bs-gutter-x: 1.25rem;
  }
  .g-xl-5,
  .gy-xl-5 {
    --bs-gutter-y: 1.25rem;
  }
  .g-xl-6,
  .gx-xl-6 {
    --bs-gutter-x: 1.5rem;
  }
  .g-xl-6,
  .gy-xl-6 {
    --bs-gutter-y: 1.5rem;
  }
  .g-xl-7,
  .gx-xl-7 {
    --bs-gutter-x: 1.75rem;
  }
  .g-xl-7,
  .gy-xl-7 {
    --bs-gutter-y: 1.75rem;
  }
  .g-xl-8,
  .gx-xl-8 {
    --bs-gutter-x: 2rem;
  }
  .g-xl-8,
  .gy-xl-8 {
    --bs-gutter-y: 2rem;
  }
  .g-xl-9,
  .gx-xl-9 {
    --bs-gutter-x: 2.25rem;
  }
  .g-xl-9,
  .gy-xl-9 {
    --bs-gutter-y: 2.25rem;
  }
  .g-xl-10,
  .gx-xl-10 {
    --bs-gutter-x: 2.5rem;
  }
  .g-xl-10,
  .gy-xl-10 {
    --bs-gutter-y: 2.5rem;
  }
}
@media (min-width: 1400px) {
  .col-xxl {
    flex: 1 0;
  }
  .row-cols-xxl-auto > * {
    flex: 0 0 auto;
    width: auto;
  }
  .row-cols-xxl-1 > * {
    flex: 0 0 auto;
    width: 100%;
  }
  .row-cols-xxl-2 > * {
    flex: 0 0 auto;
    width: 50%;
  }
  .row-cols-xxl-3 > * {
    flex: 0 0 auto;
    width: 33.3333333333%;
  }
  .row-cols-xxl-4 > * {
    flex: 0 0 auto;
    width: 25%;
  }
  .row-cols-xxl-5 > * {
    flex: 0 0 auto;
    width: 20%;
  }
  .row-cols-xxl-6 > * {
    flex: 0 0 auto;
    width: 16.6666666667%;
  }
  .col-xxl-auto {
    flex: 0 0 auto;
    width: auto;
  }
  .col-xxl-1 {
    flex: 0 0 auto;
    width: 8.33333333%;
  }
  .col-xxl-2 {
    flex: 0 0 auto;
    width: 16.66666667%;
  }
  .col-xxl-3 {
    flex: 0 0 auto;
    width: 25%;
  }
  .col-xxl-4 {
    flex: 0 0 auto;
    width: 33.33333333%;
  }
  .col-xxl-5 {
    flex: 0 0 auto;
    width: 41.66666667%;
  }
  .col-xxl-6 {
    flex: 0 0 auto;
    width: 50%;
  }
  .col-xxl-7 {
    flex: 0 0 auto;
    width: 58.33333333%;
  }
  .col-xxl-8 {
    flex: 0 0 auto;
    width: 66.66666667%;
  }
  .col-xxl-9 {
    flex: 0 0 auto;
    width: 75%;
  }
  .col-xxl-10 {
    flex: 0 0 auto;
    width: 83.33333333%;
  }
  .col-xxl-11 {
    flex: 0 0 auto;
    width: 91.66666667%;
  }
  .col-xxl-12 {
    flex: 0 0 auto;
    width: 100%;
  }
  .offset-xxl-0 {
    margin-left: 0;
  }
  .offset-xxl-1 {
    margin-left: 8.33333333%;
  }
  .offset-xxl-2 {
    margin-left: 16.66666667%;
  }
  .offset-xxl-3 {
    margin-left: 25%;
  }
  .offset-xxl-4 {
    margin-left: 33.33333333%;
  }
  .offset-xxl-5 {
    margin-left: 41.66666667%;
  }
  .offset-xxl-6 {
    margin-left: 50%;
  }
  .offset-xxl-7 {
    margin-left: 58.33333333%;
  }
  .offset-xxl-8 {
    margin-left: 66.66666667%;
  }
  .offset-xxl-9 {
    margin-left: 75%;
  }
  .offset-xxl-10 {
    margin-left: 83.33333333%;
  }
  .offset-xxl-11 {
    margin-left: 91.66666667%;
  }
  .g-xxl-0,
  .gx-xxl-0 {
    --bs-gutter-x: 0rem;
  }
  .g-xxl-0,
  .gy-xxl-0 {
    --bs-gutter-y: 0rem;
  }
  .g-xxl-1,
  .gx-xxl-1 {
    --bs-gutter-x: 0.25rem;
  }
  .g-xxl-1,
  .gy-xxl-1 {
    --bs-gutter-y: 0.25rem;
  }
  .g-xxl-2,
  .gx-xxl-2 {
    --bs-gutter-x: 0.5rem;
  }
  .g-xxl-2,
  .gy-xxl-2 {
    --bs-gutter-y: 0.5rem;
  }
  .g-xxl-3,
  .gx-xxl-3 {
    --bs-gutter-x: 0.75rem;
  }
  .g-xxl-3,
  .gy-xxl-3 {
    --bs-gutter-y: 0.75rem;
  }
  .g-xxl-4,
  .gx-xxl-4 {
    --bs-gutter-x: 1rem;
  }
  .g-xxl-4,
  .gy-xxl-4 {
    --bs-gutter-y: 1rem;
  }
  .g-xxl-5,
  .gx-xxl-5 {
    --bs-gutter-x: 1.25rem;
  }
  .g-xxl-5,
  .gy-xxl-5 {
    --bs-gutter-y: 1.25rem;
  }
  .g-xxl-6,
  .gx-xxl-6 {
    --bs-gutter-x: 1.5rem;
  }
  .g-xxl-6,
  .gy-xxl-6 {
    --bs-gutter-y: 1.5rem;
  }
  .g-xxl-7,
  .gx-xxl-7 {
    --bs-gutter-x: 1.75rem;
  }
  .g-xxl-7,
  .gy-xxl-7 {
    --bs-gutter-y: 1.75rem;
  }
  .g-xxl-8,
  .gx-xxl-8 {
    --bs-gutter-x: 2rem;
  }
  .g-xxl-8,
  .gy-xxl-8 {
    --bs-gutter-y: 2rem;
  }
  .g-xxl-9,
  .gx-xxl-9 {
    --bs-gutter-x: 2.25rem;
  }
  .g-xxl-9,
  .gy-xxl-9 {
    --bs-gutter-y: 2.25rem;
  }
  .g-xxl-10,
  .gx-xxl-10 {
    --bs-gutter-x: 2.5rem;
  }
  .g-xxl-10,
  .gy-xxl-10 {
    --bs-gutter-y: 2.5rem;
  }
}
.table {
  --bs-table-color: var(--bs-body-color);
  --bs-table-bg: transparent;
  --bs-table-border-color: var(--bs-border-color);
  --bs-table-accent-bg: transparent;
  --bs-table-striped-color: var(--bs-body-color);
  --bs-table-striped-bg: rgba(var(--bs-gray-100-rgb), 0.75);
  --bs-table-active-color: var(--bs-body-color);
  --bs-table-active-bg: var(--bs-gray-100);
  --bs-table-hover-color: var(--bs-body-color);
  --bs-table-hover-bg: var(--bs-gray-100);
  width: 100%;
  margin-bottom: 1rem;
  color: var(--bs-table-color);
  vertical-align: top;
  border-color: var(--bs-table-border-color);
}

.table > :not(caption) > * > * {
  padding: 0.75rem 0.75rem;
  background-color: var(--bs-table-bg);
  border-bottom-width: 1px;
  box-shadow: inset 0 0 0 9999px var(--bs-table-accent-bg);
}

.table > tbody {
  vertical-align: inherit;
}

.table > thead {
  vertical-align: bottom;
}

.table-group-divider {
  border-top: 2px solid currentcolor;
}

.caption-top {
  caption-side: top;
}

.table-sm > :not(caption) > * > * {
  padding: 0.5rem 0.5rem;
}

.table-bordered > :not(caption) > * {
  border-width: 1px 0;
}

.table-bordered > :not(caption) > * > * {
  border-width: 0 1px;
}

.table-borderless > :not(caption) > * > * {
  border-bottom-width: 0;
}

.table-borderless > :not(:first-child) {
  border-top-width: 0;
}

.table-striped > tbody > tr:nth-of-type(odd) > * {
  --bs-table-accent-bg: var(--bs-table-striped-bg);
  color: var(--bs-table-striped-color);
}

.table-striped-columns > :not(caption) > tr > :nth-child(even) {
  --bs-table-accent-bg: var(--bs-table-striped-bg);
  color: var(--bs-table-striped-color);
}

.table-active {
  --bs-table-accent-bg: var(--bs-table-active-bg);
  color: var(--bs-table-active-color);
}

.table-hover > tbody > tr:hover > * {
  --bs-table-accent-bg: var(--bs-table-hover-bg);
  color: var(--bs-table-hover-color);
}

.table-primary {
  --bs-table-color: #000000;
  --bs-table-bg: #ccecfd;
  --bs-table-border-color: #b8d4e4;
  --bs-table-striped-bg: #c2e0f0;
  --bs-table-striped-color: #000000;
  --bs-table-active-bg: #b8d4e4;
  --bs-table-active-color: #000000;
  --bs-table-hover-bg: #bddaea;
  --bs-table-hover-color: #000000;
  color: var(--bs-table-color);
  border-color: var(--bs-table-border-color);
}

.table-secondary {
  --bs-table-color: #000000;
  --bs-table-bg: #f9f9fb;
  --bs-table-border-color: #e0e0e2;
  --bs-table-striped-bg: #ededee;
  --bs-table-striped-color: #000000;
  --bs-table-active-bg: #e0e0e2;
  --bs-table-active-color: #000000;
  --bs-table-hover-bg: #e6e6e8;
  --bs-table-hover-color: #000000;
  color: var(--bs-table-color);
  border-color: var(--bs-table-border-color);
}

.table-success {
  --bs-table-color: #000000;
  --bs-table-bg: #dcf5e7;
  --bs-table-border-color: #c6ddd0;
  --bs-table-striped-bg: #d1e9db;
  --bs-table-striped-color: #000000;
  --bs-table-active-bg: #c6ddd0;
  --bs-table-active-color: #000000;
  --bs-table-hover-bg: #cce3d6;
  --bs-table-hover-color: #000000;
  color: var(--bs-table-color);
  border-color: var(--bs-table-border-color);
}

.table-info {
  --bs-table-color: #000000;
  --bs-table-bg: #e3d7fb;
  --bs-table-border-color: #ccc2e2;
  --bs-table-striped-bg: #d8ccee;
  --bs-table-striped-color: #000000;
  --bs-table-active-bg: #ccc2e2;
  --bs-table-active-color: #000000;
  --bs-table-hover-bg: #d2c7e8;
  --bs-table-hover-color: #000000;
  color: var(--bs-table-color);
  border-color: var(--bs-table-border-color);
}

.table-warning {
  --bs-table-color: #000000;
  --bs-table-bg: #fff4cc;
  --bs-table-border-color: #e6dcb8;
  --bs-table-striped-bg: #f2e8c2;
  --bs-table-striped-color: #000000;
  --bs-table-active-bg: #e6dcb8;
  --bs-table-active-color: #000000;
  --bs-table-hover-bg: #ece2bd;
  --bs-table-hover-color: #000000;
  color: var(--bs-table-color);
  border-color: var(--bs-table-border-color);
}

.table-danger {
  --bs-table-color: #000000;
  --bs-table-bg: #fcd9e2;
  --bs-table-border-color: #e3c3cb;
  --bs-table-striped-bg: #efced7;
  --bs-table-striped-color: #000000;
  --bs-table-active-bg: #e3c3cb;
  --bs-table-active-color: #000000;
  --bs-table-hover-bg: #e9c9d1;
  --bs-table-hover-color: #000000;
  color: var(--bs-table-color);
  border-color: var(--bs-table-border-color);
}

.table-light {
  --bs-table-color: #000000;
  --bs-table-bg: #F9F9F9;
  --bs-table-border-color: #e0e0e0;
  --bs-table-striped-bg: #ededed;
  --bs-table-striped-color: #000000;
  --bs-table-active-bg: #e0e0e0;
  --bs-table-active-color: #000000;
  --bs-table-hover-bg: #e6e6e6;
  --bs-table-hover-color: #000000;
  color: var(--bs-table-color);
  border-color: var(--bs-table-border-color);
}

.table-dark {
  --bs-table-color: #ffffff;
  --bs-table-bg: #181C32;
  --bs-table-border-color: #2f3347;
  --bs-table-striped-bg: #24273c;
  --bs-table-striped-color: #ffffff;
  --bs-table-active-bg: #2f3347;
  --bs-table-active-color: #ffffff;
  --bs-table-hover-bg: #292d41;
  --bs-table-hover-color: #ffffff;
  color: var(--bs-table-color);
  border-color: var(--bs-table-border-color);
}

.table-responsive {
  overflow-x: auto;
  -webkit-overflow-scrolling: touch;
}

@media (max-width: 575.98px) {
  .table-responsive-sm {
    overflow-x: auto;
    -webkit-overflow-scrolling: touch;
  }
}
@media (max-width: 767.98px) {
  .table-responsive-md {
    overflow-x: auto;
    -webkit-overflow-scrolling: touch;
  }
}
@media (max-width: 991.98px) {
  .table-responsive-lg {
    overflow-x: auto;
    -webkit-overflow-scrolling: touch;
  }
}
@media (max-width: 1199.98px) {
  .table-responsive-xl {
    overflow-x: auto;
    -webkit-overflow-scrolling: touch;
  }
}
@media (max-width: 1399.98px) {
  .table-responsive-xxl {
    overflow-x: auto;
    -webkit-overflow-scrolling: touch;
  }
}
.form-label {
  margin-bottom: 0.5rem;
  font-size: 1.05rem;
  font-weight: 500;
  color: var(--bs-gray-800);
}

.col-form-label {
  padding-top: calc(0.775rem + 1px);
  padding-bottom: calc(0.775rem + 1px);
  margin-bottom: 0;
  font-size: inherit;
  font-weight: 500;
  line-height: 1.5;
  color: var(--bs-gray-800);
}

.col-form-label-lg {
  padding-top: calc(0.825rem + 1px);
  padding-bottom: calc(0.825rem + 1px);
  font-size: 1.15rem;
}

.col-form-label-sm {
  padding-top: calc(0.55rem + 1px);
  padding-bottom: calc(0.55rem + 1px);
  font-size: 0.95rem;
}

.form-text {
  margin-top: 0.5rem;
  font-size: 0.95rem;
  color: var(--bs-text-muted);
}

.form-control {
  display: block;
  width: 100%;
  padding: 0.775rem 1rem;
  font-size: 1.1rem;
  font-weight: 500;
  line-height: 1.5;
  color: var(--bs-gray-700);
  background-color: var(--bs-body-bg);
  background-clip: padding-box;
  border: 1px solid var(--bs-gray-300);
  appearance: none;
  border-radius: 0.475rem;
  box-shadow: false;
  transition: border-color 0.15s ease-in-out, box-shadow 0.15s ease-in-out;
}

@media (prefers-reduced-motion: reduce) {
  .form-control {
    transition: none;
  }
}
.form-control[type=file] {
  overflow: hidden;
}

.form-control[type=file]:not(:disabled):not([readonly]) {
  cursor: pointer;
}

.form-control:focus {
  color: var(--bs-gray-700);
  background-color: var(--bs-body-bg);
  border-color: var(--bs-gray-400);
  outline: 0;
  box-shadow: false, 0 0 0 0.25rem rgba(var(--bs-component-active-bg), 0.25);
}

.form-control::-webkit-date-and-time-value {
  height: 1.5em;
}

.form-control::-webkit-datetime-edit {
  display: block;
  padding: 0;
}

.form-control::placeholder {
  color: var(--bs-gray-500);
  opacity: 1;
}

.form-control:disabled {
  color: var(--bs-gray-500);
  background-color: var(--bs-gray-200);
  border-color: var(--bs-gray-300);
  opacity: 1;
}

.form-control::file-selector-button {
  padding: 0.775rem 1rem;
  margin: -0.775rem -1rem;
  margin-inline-end: 1rem;
  color: var(--bs-gray-700);
  background-color: var(--bs-gray-100);
  pointer-events: none;
  border-color: inherit;
  border-style: solid;
  border-width: 0;
  border-inline-end-width: 1px;
  border-radius: 0;
  transition: color 0.15s ease-in-out, background-color 0.15s ease-in-out, border-color 0.15s ease-in-out, box-shadow 0.15s ease-in-out;
}

@media (prefers-reduced-motion: reduce) {
  .form-control::file-selector-button {
    transition: none;
  }
}
.form-control:hover:not(:disabled):not([readonly])::file-selector-button {
  background-color: shade-color(var(--bs-gray-100), 5%);
}

.form-control-plaintext {
  display: block;
  width: 100%;
  padding: 0.775rem 0;
  margin-bottom: 0;
  line-height: 1.5;
  color: var(--bs-gray-700);
  background-color: transparent;
  border: solid transparent;
  border-width: 1px 0;
}

.form-control-plaintext:focus {
  outline: 0;
}

.form-control-plaintext.form-control-sm, .form-control-plaintext.form-control-lg {
  padding-right: 0;
  padding-left: 0;
}

.form-control-sm {
  min-height: calc(1.5em + 1.1rem + 2px);
  padding: 0.55rem 0.75rem;
  font-size: 0.95rem;
  border-radius: 0.425rem;
}

.form-control-sm::file-selector-button {
  padding: 0.55rem 0.75rem;
  margin: -0.55rem -0.75rem;
  margin-inline-end: 0.75rem;
}

.form-control-lg {
  min-height: calc(1.5em + 1.65rem + 2px);
  padding: 0.825rem 1.5rem;
  font-size: 1.15rem;
  border-radius: 0.625rem;
}

.form-control-lg::file-selector-button {
  padding: 0.825rem 1.5rem;
  margin: -0.825rem -1.5rem;
  margin-inline-end: 1.5rem;
}

textarea.form-control {
  min-height: calc(1.5em + 1.55rem + 2px);
}

textarea.form-control-sm {
  min-height: calc(1.5em + 1.1rem + 2px);
}

textarea.form-control-lg {
  min-height: calc(1.5em + 1.65rem + 2px);
}

.form-control-color {
  width: 3rem;
  height: calc(1.5em + 1.55rem + 2px);
  padding: 0.775rem;
}

.form-control-color:not(:disabled):not([readonly]) {
  cursor: pointer;
}

.form-control-color::-moz-color-swatch {
  border: 0 !important;
  border-radius: 0.475rem;
}

.form-control-color::-webkit-color-swatch {
  border-radius: 0.475rem;
}

.form-control-color.form-control-sm {
  height: calc(1.5em + 1.1rem + 2px);
}

.form-control-color.form-control-lg {
  height: calc(1.5em + 1.65rem + 2px);
}

.form-select {
  --bs-form-select-bg-img: url(${___CSS_LOADER_URL_REPLACEMENT_0___});
  display: block;
  width: 100%;
  padding: 0.775rem 3rem 0.775rem 1rem;
  -moz-padding-start: calc(1rem - 3px);
  font-size: 1.1rem;
  font-weight: 500;
  line-height: 1.5;
  color: var(--bs-gray-700);
  background-color: var(--bs-body-bg);
  background-image: var(--bs-form-select-bg-img), var(--bs-form-select-bg-icon, none);
  background-repeat: no-repeat;
  background-position: right 1rem center;
  background-size: 16px 12px;
  border: 1px solid var(--bs-gray-300);
  border-radius: 0.475rem;
  box-shadow: false;
  transition: border-color 0.15s ease-in-out, box-shadow 0.15s ease-in-out;
  appearance: none;
}

@media (prefers-reduced-motion: reduce) {
  .form-select {
    transition: none;
  }
}
.form-select:focus {
  border-color: var(--bs-gray-400);
  outline: 0;
  box-shadow: false, 0 0 0 0.25rem rgba(var(--bs-component-active-bg), 0.25);
}

.form-select[multiple], .form-select[size]:not([size="1"]) {
  padding-right: 1rem;
  background-image: none;
}

.form-select:disabled {
  color: var(--bs-gray-500);
  background-color: var(--bs-gray-200);
  border-color: var(--bs-gray-300);
}

.form-select:-moz-focusring {
  color: transparent;
  text-shadow: 0 0 0 var(--bs-gray-700);
}

.form-select-sm {
  padding-top: 0.55rem;
  padding-bottom: 0.55rem;
  padding-left: 0.75rem;
  font-size: 0.95rem;
  border-radius: 0.425rem;
}

.form-select-lg {
  padding-top: 0.825rem;
  padding-bottom: 0.825rem;
  padding-left: 1.5rem;
  font-size: 1.15rem;
  border-radius: 0.625rem;
}

[data-bs-theme=dark] .form-select {
  --bs-form-select-bg-img: url(${___CSS_LOADER_URL_REPLACEMENT_1___});
}

.form-check {
  display: block;
  min-height: 1.5rem;
  padding-left: 2.25rem;
  margin-bottom: 0.125rem;
}

.form-check .form-check-input {
  float: left;
  margin-left: -2.25rem;
}

.form-check-reverse {
  padding-right: 2.25rem;
  padding-left: 0;
  text-align: right;
}

.form-check-reverse .form-check-input {
  float: right;
  margin-right: -2.25rem;
  margin-left: 0;
}

.form-check-input {
  --bs-form-check-bg: transparent;
  width: 1.75rem;
  height: 1.75rem;
  margin-top: -0.125rem;
  vertical-align: top;
  background-color: var(--bs-form-check-bg);
  background-image: var(--bs-form-check-bg-image);
  background-repeat: no-repeat;
  background-position: center;
  background-size: contain;
  border: 1px solid var(--bs-gray-300);
  appearance: none;
  -webkit-print-color-adjust: exact;
          print-color-adjust: exact;
}

.form-check-input[type=checkbox] {
  border-radius: 0.45em;
}

.form-check-input[type=radio] {
  border-radius: 50%;
}

.form-check-input:active {
  filter: brightness(90%);
}

.form-check-input:focus {
  border-color: var(--bs-gray-400);
  outline: 0;
  box-shadow: none;
}

.form-check-input:checked {
  background-color: #009ef7;
  border-color: #009ef7;
}

.form-check-input:checked[type=checkbox] {
  --bs-form-check-bg-image: url(${___CSS_LOADER_URL_REPLACEMENT_2___});
}

.form-check-input:checked[type=radio] {
  --bs-form-check-bg-image: url(${___CSS_LOADER_URL_REPLACEMENT_3___});
}

.form-check-input[type=checkbox]:indeterminate {
  background-color: #009ef7;
  border-color: #009ef7;
  --bs-form-check-bg-image: url(${___CSS_LOADER_URL_REPLACEMENT_4___});
}

.form-check-input:disabled {
  pointer-events: none;
  filter: none;
  opacity: 0.5;
}

.form-check-input[disabled] ~ .form-check-label, .form-check-input:disabled ~ .form-check-label {
  cursor: default;
  opacity: 0.5;
}

.form-check-label {
  color: var(--bs-gray-500);
}

.form-switch {
  padding-left: 3.75rem;
}

.form-switch .form-check-input {
  --bs-form-switch-bg: url(${___CSS_LOADER_URL_REPLACEMENT_5___});
  width: 3.25rem;
  margin-left: -3.75rem;
  background-image: var(--bs-form-switch-bg);
  background-position: left center;
  border-radius: 3.25rem;
  transition: background-position 0.15s ease-in-out;
}

@media (prefers-reduced-motion: reduce) {
  .form-switch .form-check-input {
    transition: none;
  }
}
.form-switch .form-check-input:focus {
  --bs-form-switch-bg: url(${___CSS_LOADER_URL_REPLACEMENT_5___});
}

.form-switch .form-check-input:checked {
  background-position: right center;
  --bs-form-switch-bg: url(${___CSS_LOADER_URL_REPLACEMENT_6___});
}

.form-switch.form-check-reverse {
  padding-right: 3.75rem;
  padding-left: 0;
}

.form-switch.form-check-reverse .form-check-input {
  margin-right: -3.75rem;
  margin-left: 0;
}

.form-check-inline {
  display: inline-block;
  margin-right: 1rem;
}

.btn-check {
  position: absolute;
  clip: rect(0, 0, 0, 0);
  pointer-events: none;
}

.btn-check[disabled] + .btn, .btn-check:disabled + .btn {
  pointer-events: none;
  filter: none;
  opacity: 0.65;
}

[data-bs-theme=dark] .form-switch .form-check-input:not(:checked):not(:focus) {
  --bs-form-switch-bg: url(${___CSS_LOADER_URL_REPLACEMENT_7___});
}

.form-range {
  width: 100%;
  height: 1.5rem;
  padding: 0;
  background-color: transparent;
  appearance: none;
}

.form-range:focus {
  outline: 0;
}

.form-range:focus::-webkit-slider-thumb {
  box-shadow: 0 0 0 1px #ffffff, 0 0 0 0.25rem rgba(var(--bs-component-active-bg), 0.25);
}

.form-range:focus::-moz-range-thumb {
  box-shadow: 0 0 0 1px #ffffff, 0 0 0 0.25rem rgba(var(--bs-component-active-bg), 0.25);
}

.form-range::-moz-focus-outer {
  border: 0;
}

.form-range::-webkit-slider-thumb {
  width: 1rem;
  height: 1rem;
  margin-top: -0.25rem;
  background-color: #009ef7;
  border: 0;
  border-radius: 1rem;
  box-shadow: 0 0.1rem 0.25rem rgba(0, 0, 0, 0.1);
  -webkit-transition: background-color 0.15s ease-in-out, border-color 0.15s ease-in-out, box-shadow 0.15s ease-in-out;
  transition: background-color 0.15s ease-in-out, border-color 0.15s ease-in-out, box-shadow 0.15s ease-in-out;
  appearance: none;
}

@media (prefers-reduced-motion: reduce) {
  .form-range::-webkit-slider-thumb {
    -webkit-transition: none;
    transition: none;
  }
}
.form-range::-webkit-slider-thumb:active {
  background-color: #b3e2fd;
}

.form-range::-webkit-slider-runnable-track {
  width: 100%;
  height: 0.5rem;
  color: transparent;
  cursor: pointer;
  background-color: var(--bs-gray-300);
  border-color: transparent;
  border-radius: 0.475rem;
  box-shadow: inset 0 1px 2px rgba(0, 0, 0, 0.075);
}

.form-range::-moz-range-thumb {
  width: 1rem;
  height: 1rem;
  background-color: #009ef7;
  border: 0;
  border-radius: 1rem;
  box-shadow: 0 0.1rem 0.25rem rgba(0, 0, 0, 0.1);
  -moz-transition: background-color 0.15s ease-in-out, border-color 0.15s ease-in-out, box-shadow 0.15s ease-in-out;
  transition: background-color 0.15s ease-in-out, border-color 0.15s ease-in-out, box-shadow 0.15s ease-in-out;
  appearance: none;
}

@media (prefers-reduced-motion: reduce) {
  .form-range::-moz-range-thumb {
    -moz-transition: none;
    transition: none;
  }
}
.form-range::-moz-range-thumb:active {
  background-color: #b3e2fd;
}

.form-range::-moz-range-track {
  width: 100%;
  height: 0.5rem;
  color: transparent;
  cursor: pointer;
  background-color: var(--bs-gray-300);
  border-color: transparent;
  border-radius: 0.475rem;
  box-shadow: inset 0 1px 2px rgba(0, 0, 0, 0.075);
}

.form-range:disabled {
  pointer-events: none;
}

.form-range:disabled::-webkit-slider-thumb {
  background-color: var(--bs-gray-500);
}

.form-range:disabled::-moz-range-thumb {
  background-color: var(--bs-gray-500);
}

.form-floating {
  position: relative;
}

.form-floating::before:not(.form-control:disabled) {
  position: absolute;
  top: 1px;
  left: 1px;
  width: calc(100% - (0.375em + 0.3875rem + 0.75em + 0.775rem));
  height: 1.875em;
  content: "";
  background-color: var(--bs-body-bg);
  border-radius: 0.475rem;
}

.form-floating > .form-control,
.form-floating > .form-control-plaintext,
.form-floating > .form-select {
  height: calc(3.75rem + 2px);
  line-height: 1.25;
}

.form-floating > label {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  padding: 1rem 1rem;
  overflow: hidden;
  text-align: start;
  text-overflow: ellipsis;
  white-space: nowrap;
  pointer-events: none;
  border: 1px solid transparent;
  transform-origin: 0 0;
  transition: opacity 0.1s ease-in-out, transform 0.1s ease-in-out;
}

@media (prefers-reduced-motion: reduce) {
  .form-floating > label {
    transition: none;
  }
}
.form-floating > .form-control,
.form-floating > .form-control-plaintext {
  padding: 1rem 1rem;
}

.form-floating > .form-control::placeholder,
.form-floating > .form-control-plaintext::placeholder {
  color: transparent;
}

.form-floating > .form-control:focus, .form-floating > .form-control:not(:placeholder-shown),
.form-floating > .form-control-plaintext:focus,
.form-floating > .form-control-plaintext:not(:placeholder-shown) {
  padding-top: 1.85rem;
  padding-bottom: 0.625rem;
}

.form-floating > .form-control:-webkit-autofill,
.form-floating > .form-control-plaintext:-webkit-autofill {
  padding-top: 1.85rem;
  padding-bottom: 0.625rem;
}

.form-floating > .form-select {
  padding-top: 1.85rem;
  padding-bottom: 0.625rem;
}

.form-floating > .form-control:focus ~ label,
.form-floating > .form-control:not(:placeholder-shown) ~ label,
.form-floating > .form-control-plaintext ~ label,
.form-floating > .form-select ~ label {
  opacity: 0.65;
  transform: scale(0.85) translateY(-0.5rem) translateX(0.15rem);
}

.form-floating > .form-control:-webkit-autofill ~ label {
  opacity: 0.65;
  transform: scale(0.85) translateY(-0.5rem) translateX(0.15rem);
}

.form-floating > .form-control-plaintext ~ label {
  border-width: 1px 0;
}

.form-floating > .form-control:disabled ~ label {
  color: #7E8299;
}

.input-group {
  position: relative;
  display: flex;
  flex-wrap: wrap;
  align-items: stretch;
  width: 100%;
}

.input-group > .form-control,
.input-group > .form-select,
.input-group > .form-floating {
  position: relative;
  flex: 1 1 auto;
  width: 1%;
  min-width: 0;
}

.input-group > .form-control:focus,
.input-group > .form-select:focus,
.input-group > .form-floating:focus-within {
  z-index: 5;
}

.input-group .btn {
  position: relative;
  z-index: 2;
}

.input-group .btn:focus {
  z-index: 5;
}

.input-group-text {
  display: flex;
  align-items: center;
  padding: 0.775rem 1rem;
  font-size: 1.1rem;
  font-weight: 500;
  line-height: 1.5;
  color: var(--bs-gray-700);
  text-align: center;
  white-space: nowrap;
  background-color: var(--bs-gray-100);
  border: 1px solid var(--bs-gray-300);
  border-radius: 0.475rem;
}

.input-group-lg > .form-control,
.input-group-lg > .form-select,
.input-group-lg > .input-group-text,
.input-group-lg > .btn {
  padding: 0.825rem 1.5rem;
  font-size: 1.15rem;
  border-radius: 0.625rem;
}

.input-group-sm > .form-control,
.input-group-sm > .form-select,
.input-group-sm > .input-group-text,
.input-group-sm > .btn {
  padding: 0.55rem 0.75rem;
  font-size: 0.95rem;
  border-radius: 0.425rem;
}

.input-group-lg > .form-select,
.input-group-sm > .form-select {
  padding-right: 4rem;
}

.input-group:not(.has-validation) > :not(:last-child):not(.dropdown-toggle):not(.dropdown-menu):not(.form-floating),
.input-group:not(.has-validation) > .dropdown-toggle:nth-last-child(n+3),
.input-group:not(.has-validation) > .form-floating:not(:last-child) > .form-control,
.input-group:not(.has-validation) > .form-floating:not(:last-child) > .form-select {
  border-top-right-radius: 0;
  border-bottom-right-radius: 0;
}

.input-group.has-validation > :nth-last-child(n+3):not(.dropdown-toggle):not(.dropdown-menu):not(.form-floating),
.input-group.has-validation > .dropdown-toggle:nth-last-child(n+4),
.input-group.has-validation > .form-floating:nth-last-child(n+3) > .form-control,
.input-group.has-validation > .form-floating:nth-last-child(n+3) > .form-select {
  border-top-right-radius: 0;
  border-bottom-right-radius: 0;
}

.input-group > :not(:first-child):not(.dropdown-menu):not(.valid-tooltip):not(.valid-feedback):not(.invalid-tooltip):not(.invalid-feedback) {
  margin-left: -1px;
  border-top-left-radius: 0;
  border-bottom-left-radius: 0;
}

.input-group > .form-floating:not(:first-child) > .form-control,
.input-group > .form-floating:not(:first-child) > .form-select {
  border-top-left-radius: 0;
  border-bottom-left-radius: 0;
}

.valid-feedback {
  display: none;
  width: 100%;
  margin-top: 0.5rem;
  font-size: 0.95rem;
  color: var(--bs-success-text);
}

.valid-tooltip {
  position: absolute;
  top: 100%;
  z-index: 5;
  display: none;
  max-width: 100%;
  padding: 0.75rem 1rem;
  margin-top: 0.1rem;
  font-size: 1rem;
  color: #fff;
  background-color: var(--bs-success);
  border-radius: 0.475rem;
}

.was-validated :valid ~ .valid-feedback,
.was-validated :valid ~ .valid-tooltip,
.is-valid ~ .valid-feedback,
.is-valid ~ .valid-tooltip {
  display: block;
}

.was-validated .form-control:valid, .form-control.is-valid {
  border-color: var(--bs-success);
  padding-right: calc(1.5em + 1.55rem);
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_8___});
  background-repeat: no-repeat;
  background-position: right calc(0.375em + 0.3875rem) center;
  background-size: calc(0.75em + 0.775rem) calc(0.75em + 0.775rem);
}

.was-validated .form-control:valid:focus, .form-control.is-valid:focus {
  border-color: var(--bs-success);
  box-shadow: 0 0 0 0.25rem rgba(var(--bs-success-rgb), 0.25);
}

.was-validated textarea.form-control:valid, textarea.form-control.is-valid {
  padding-right: calc(1.5em + 1.55rem);
  background-position: top calc(0.375em + 0.3875rem) right calc(0.375em + 0.3875rem);
}

.was-validated .form-select:valid, .form-select.is-valid {
  border-color: var(--bs-success);
}

.was-validated .form-select:valid:not([multiple]):not([size]), .was-validated .form-select:valid:not([multiple])[size="1"], .form-select.is-valid:not([multiple]):not([size]), .form-select.is-valid:not([multiple])[size="1"] {
  --bs-form-select-bg-icon: url(${___CSS_LOADER_URL_REPLACEMENT_8___});
  padding-right: 5.5rem;
  background-position: right 1rem center, center right 3rem;
  background-size: 16px 12px, calc(0.75em + 0.775rem) calc(0.75em + 0.775rem);
}

.was-validated .form-select:valid:focus, .form-select.is-valid:focus {
  border-color: var(--bs-success);
  box-shadow: 0 0 0 0.25rem rgba(var(--bs-success-rgb), 0.25);
}

.was-validated .form-control-color:valid, .form-control-color.is-valid {
  width: calc(3rem + 1.5em + 1.55rem);
}

.was-validated .form-check-input:valid, .form-check-input.is-valid {
  border-color: var(--bs-success);
}

.was-validated .form-check-input:valid:checked, .form-check-input.is-valid:checked {
  background-color: var(--bs-success-text);
}

.was-validated .form-check-input:valid:focus, .form-check-input.is-valid:focus {
  box-shadow: 0 0 0 0.25rem rgba(var(--bs-success-rgb), 0.25);
}

.was-validated .form-check-input:valid ~ .form-check-label, .form-check-input.is-valid ~ .form-check-label {
  color: var(--bs-success-text);
}

.form-check-inline .form-check-input ~ .valid-feedback {
  margin-left: 0.5em;
}

.was-validated .input-group > .form-control:not(:focus):valid, .input-group > .form-control:not(:focus).is-valid,
.was-validated .input-group > .form-select:not(:focus):valid,
.input-group > .form-select:not(:focus).is-valid,
.was-validated .input-group > .form-floating:not(:focus-within):valid,
.input-group > .form-floating:not(:focus-within).is-valid {
  z-index: 3;
}

.invalid-feedback {
  display: none;
  width: 100%;
  margin-top: 0.5rem;
  font-size: 0.95rem;
  color: var(--bs-danger-text);
}

.invalid-tooltip {
  position: absolute;
  top: 100%;
  z-index: 5;
  display: none;
  max-width: 100%;
  padding: 0.75rem 1rem;
  margin-top: 0.1rem;
  font-size: 1rem;
  color: #fff;
  background-color: var(--bs-danger);
  border-radius: 0.475rem;
}

.was-validated :invalid ~ .invalid-feedback,
.was-validated :invalid ~ .invalid-tooltip,
.is-invalid ~ .invalid-feedback,
.is-invalid ~ .invalid-tooltip {
  display: block;
}

.was-validated .form-control:invalid, .form-control.is-invalid {
  border-color: var(--bs-danger);
  padding-right: calc(1.5em + 1.55rem);
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_9___});
  background-repeat: no-repeat;
  background-position: right calc(0.375em + 0.3875rem) center;
  background-size: calc(0.75em + 0.775rem) calc(0.75em + 0.775rem);
}

.was-validated .form-control:invalid:focus, .form-control.is-invalid:focus {
  border-color: var(--bs-danger);
  box-shadow: 0 0 0 0.25rem rgba(var(--bs-danger-rgb), 0.25);
}

.was-validated textarea.form-control:invalid, textarea.form-control.is-invalid {
  padding-right: calc(1.5em + 1.55rem);
  background-position: top calc(0.375em + 0.3875rem) right calc(0.375em + 0.3875rem);
}

.was-validated .form-select:invalid, .form-select.is-invalid {
  border-color: var(--bs-danger);
}

.was-validated .form-select:invalid:not([multiple]):not([size]), .was-validated .form-select:invalid:not([multiple])[size="1"], .form-select.is-invalid:not([multiple]):not([size]), .form-select.is-invalid:not([multiple])[size="1"] {
  --bs-form-select-bg-icon: url(${___CSS_LOADER_URL_REPLACEMENT_9___});
  padding-right: 5.5rem;
  background-position: right 1rem center, center right 3rem;
  background-size: 16px 12px, calc(0.75em + 0.775rem) calc(0.75em + 0.775rem);
}

.was-validated .form-select:invalid:focus, .form-select.is-invalid:focus {
  border-color: var(--bs-danger);
  box-shadow: 0 0 0 0.25rem rgba(var(--bs-danger-rgb), 0.25);
}

.was-validated .form-control-color:invalid, .form-control-color.is-invalid {
  width: calc(3rem + 1.5em + 1.55rem);
}

.was-validated .form-check-input:invalid, .form-check-input.is-invalid {
  border-color: var(--bs-danger);
}

.was-validated .form-check-input:invalid:checked, .form-check-input.is-invalid:checked {
  background-color: var(--bs-danger-text);
}

.was-validated .form-check-input:invalid:focus, .form-check-input.is-invalid:focus {
  box-shadow: 0 0 0 0.25rem rgba(var(--bs-danger-rgb), 0.25);
}

.was-validated .form-check-input:invalid ~ .form-check-label, .form-check-input.is-invalid ~ .form-check-label {
  color: var(--bs-danger-text);
}

.form-check-inline .form-check-input ~ .invalid-feedback {
  margin-left: 0.5em;
}

.was-validated .input-group > .form-control:not(:focus):invalid, .input-group > .form-control:not(:focus).is-invalid,
.was-validated .input-group > .form-select:not(:focus):invalid,
.input-group > .form-select:not(:focus).is-invalid,
.was-validated .input-group > .form-floating:not(:focus-within):invalid,
.input-group > .form-floating:not(:focus-within).is-invalid {
  z-index: 4;
}

.btn {
  --bs-btn-padding-x: 1.5rem;
  --bs-btn-padding-y: 0.775rem;
  --bs-btn-font-family: ;
  --bs-btn-font-size: 1.1rem;
  --bs-btn-font-weight: 500;
  --bs-btn-line-height: 1.5;
  --bs-btn-color: #181C32;
  --bs-btn-bg: transparent;
  --bs-btn-border-width: 1px;
  --bs-btn-border-color: transparent;
  --bs-btn-border-radius: 0.475rem;
  --bs-btn-hover-border-color: transparent;
  --bs-btn-box-shadow: inset 0 1px 0 rgba(255, 255, 255, 0.15), 0 1px 1px rgba(0, 0, 0, 0.075);
  --bs-btn-disabled-opacity: 0.65;
  --bs-btn-focus-box-shadow: 0 0 0 0.25rem rgba(var(--bs-btn-focus-shadow-rgb), .5);
  display: inline-block;
  padding: var(--bs-btn-padding-y) var(--bs-btn-padding-x);
  font-family: var(--bs-btn-font-family);
  font-size: var(--bs-btn-font-size);
  font-weight: var(--bs-btn-font-weight);
  line-height: var(--bs-btn-line-height);
  color: var(--bs-btn-color);
  text-align: center;
  vertical-align: middle;
  cursor: pointer;
  -webkit-user-select: none;
          user-select: none;
  border: var(--bs-btn-border-width) solid var(--bs-btn-border-color);
  border-radius: var(--bs-btn-border-radius);
  background-color: var(--bs-btn-bg);
  box-shadow: var(--bs-btn-box-shadow);
  transition: color 0.15s ease-in-out, background-color 0.15s ease-in-out, border-color 0.15s ease-in-out, box-shadow 0.15s ease-in-out;
}

@media (prefers-reduced-motion: reduce) {
  .btn {
    transition: none;
  }
}
.btn:hover {
  color: var(--bs-btn-hover-color);
  background-color: var(--bs-btn-hover-bg);
  border-color: var(--bs-btn-hover-border-color);
}

.btn-check + .btn:hover {
  color: var(--bs-btn-color);
  background-color: var(--bs-btn-bg);
  border-color: var(--bs-btn-border-color);
}

.btn:focus-visible {
  color: var(--bs-btn-hover-color);
  background-color: var(--bs-btn-hover-bg);
  border-color: var(--bs-btn-hover-border-color);
  outline: 0;
  box-shadow: var(--bs-btn-box-shadow), var(--bs-btn-focus-box-shadow);
}

.btn-check:focus-visible + .btn {
  border-color: var(--bs-btn-hover-border-color);
  outline: 0;
  box-shadow: var(--bs-btn-box-shadow), var(--bs-btn-focus-box-shadow);
}

.btn-check:checked + .btn, :not(.btn-check) + .btn:active, .btn:first-child:active, .btn.active, .btn.show {
  color: var(--bs-btn-active-color);
  background-color: var(--bs-btn-active-bg);
  border-color: var(--bs-btn-active-border-color);
  box-shadow: var(--bs-btn-active-shadow);
}

.btn-check:checked + .btn:focus-visible, :not(.btn-check) + .btn:active:focus-visible, .btn:first-child:active:focus-visible, .btn.active:focus-visible, .btn.show:focus-visible {
  box-shadow: var(--bs-btn-active-shadow), var(--bs-btn-focus-box-shadow);
}

.btn:disabled, .btn.disabled, fieldset:disabled .btn {
  color: var(--bs-btn-disabled-color);
  pointer-events: none;
  background-color: var(--bs-btn-disabled-bg);
  border-color: var(--bs-btn-disabled-border-color);
  opacity: var(--bs-btn-disabled-opacity);
  box-shadow: none;
}

.btn-light {
  --bs-btn-color: #000000;
  --bs-btn-bg: #F9F9F9;
  --bs-btn-border-color: #F9F9F9;
  --bs-btn-hover-color: #000000;
  --bs-btn-hover-bg: #d4d4d4;
  --bs-btn-hover-border-color: #c7c7c7;
  --bs-btn-focus-shadow-rgb: 212, 212, 212;
  --bs-btn-active-color: #000000;
  --bs-btn-active-bg: #c7c7c7;
  --bs-btn-active-border-color: #bbbbbb;
  --bs-btn-active-shadow: inset 0 3px 5px rgba(0, 0, 0, 0.125);
  --bs-btn-disabled-color: #000000;
  --bs-btn-disabled-bg: #F9F9F9;
  --bs-btn-disabled-border-color: #F9F9F9;
}

.btn-primary {
  --bs-btn-color: #000000;
  --bs-btn-bg: #009ef7;
  --bs-btn-border-color: #009ef7;
  --bs-btn-hover-color: #000000;
  --bs-btn-hover-bg: #26adf8;
  --bs-btn-hover-border-color: #1aa8f8;
  --bs-btn-focus-shadow-rgb: 0, 134, 210;
  --bs-btn-active-color: #000000;
  --bs-btn-active-bg: #33b1f9;
  --bs-btn-active-border-color: #1aa8f8;
  --bs-btn-active-shadow: inset 0 3px 5px rgba(0, 0, 0, 0.125);
  --bs-btn-disabled-color: #000000;
  --bs-btn-disabled-bg: #009ef7;
  --bs-btn-disabled-border-color: #009ef7;
}

.btn-secondary {
  --bs-btn-color: #000000;
  --bs-btn-bg: #E1E3EA;
  --bs-btn-border-color: #E1E3EA;
  --bs-btn-hover-color: #000000;
  --bs-btn-hover-bg: #e6e7ed;
  --bs-btn-hover-border-color: #e4e6ec;
  --bs-btn-focus-shadow-rgb: 191, 193, 199;
  --bs-btn-active-color: #000000;
  --bs-btn-active-bg: #e7e9ee;
  --bs-btn-active-border-color: #e4e6ec;
  --bs-btn-active-shadow: inset 0 3px 5px rgba(0, 0, 0, 0.125);
  --bs-btn-disabled-color: #000000;
  --bs-btn-disabled-bg: #E1E3EA;
  --bs-btn-disabled-border-color: #E1E3EA;
}

.btn-success {
  --bs-btn-color: #000000;
  --bs-btn-bg: #50cd89;
  --bs-btn-border-color: #50cd89;
  --bs-btn-hover-color: #000000;
  --bs-btn-hover-bg: #6ad59b;
  --bs-btn-hover-border-color: #62d295;
  --bs-btn-focus-shadow-rgb: 68, 174, 116;
  --bs-btn-active-color: #000000;
  --bs-btn-active-bg: #73d7a1;
  --bs-btn-active-border-color: #62d295;
  --bs-btn-active-shadow: inset 0 3px 5px rgba(0, 0, 0, 0.125);
  --bs-btn-disabled-color: #000000;
  --bs-btn-disabled-bg: #50cd89;
  --bs-btn-disabled-border-color: #50cd89;
}

.btn-info {
  --bs-btn-color: #ffffff;
  --bs-btn-bg: #7239ea;
  --bs-btn-border-color: #7239ea;
  --bs-btn-hover-color: #ffffff;
  --bs-btn-hover-bg: #6130c7;
  --bs-btn-hover-border-color: #5b2ebb;
  --bs-btn-focus-shadow-rgb: 135, 87, 237;
  --bs-btn-active-color: #ffffff;
  --bs-btn-active-bg: #5b2ebb;
  --bs-btn-active-border-color: #562bb0;
  --bs-btn-active-shadow: inset 0 3px 5px rgba(0, 0, 0, 0.125);
  --bs-btn-disabled-color: #ffffff;
  --bs-btn-disabled-bg: #7239ea;
  --bs-btn-disabled-border-color: #7239ea;
}

.btn-warning {
  --bs-btn-color: #000000;
  --bs-btn-bg: #ffc700;
  --bs-btn-border-color: #ffc700;
  --bs-btn-hover-color: #000000;
  --bs-btn-hover-bg: #ffcf26;
  --bs-btn-hover-border-color: #ffcd1a;
  --bs-btn-focus-shadow-rgb: 217, 169, 0;
  --bs-btn-active-color: #000000;
  --bs-btn-active-bg: #ffd233;
  --bs-btn-active-border-color: #ffcd1a;
  --bs-btn-active-shadow: inset 0 3px 5px rgba(0, 0, 0, 0.125);
  --bs-btn-disabled-color: #000000;
  --bs-btn-disabled-bg: #ffc700;
  --bs-btn-disabled-border-color: #ffc700;
}

.btn-danger {
  --bs-btn-color: #000000;
  --bs-btn-bg: #f1416c;
  --bs-btn-border-color: #f1416c;
  --bs-btn-hover-color: #000000;
  --bs-btn-hover-bg: #f35e82;
  --bs-btn-hover-border-color: #f2547b;
  --bs-btn-focus-shadow-rgb: 205, 55, 92;
  --bs-btn-active-color: #000000;
  --bs-btn-active-bg: #f46789;
  --bs-btn-active-border-color: #f2547b;
  --bs-btn-active-shadow: inset 0 3px 5px rgba(0, 0, 0, 0.125);
  --bs-btn-disabled-color: #000000;
  --bs-btn-disabled-bg: #f1416c;
  --bs-btn-disabled-border-color: #f1416c;
}

.btn-dark {
  --bs-btn-color: #ffffff;
  --bs-btn-bg: #181C32;
  --bs-btn-border-color: #181C32;
  --bs-btn-hover-color: #ffffff;
  --bs-btn-hover-bg: #3b3e51;
  --bs-btn-hover-border-color: #2f3347;
  --bs-btn-focus-shadow-rgb: 59, 62, 81;
  --bs-btn-active-color: #ffffff;
  --bs-btn-active-bg: #46495b;
  --bs-btn-active-border-color: #2f3347;
  --bs-btn-active-shadow: inset 0 3px 5px rgba(0, 0, 0, 0.125);
  --bs-btn-disabled-color: #ffffff;
  --bs-btn-disabled-bg: #181C32;
  --bs-btn-disabled-border-color: #181C32;
}

.btn-outline-light {
  --bs-btn-color: #F9F9F9;
  --bs-btn-border-color: #F9F9F9;
  --bs-btn-hover-color: #000000;
  --bs-btn-hover-bg: #F9F9F9;
  --bs-btn-hover-border-color: #F9F9F9;
  --bs-btn-focus-shadow-rgb: 249, 249, 249;
  --bs-btn-active-color: #000000;
  --bs-btn-active-bg: #F9F9F9;
  --bs-btn-active-border-color: #F9F9F9;
  --bs-btn-active-shadow: inset 0 3px 5px rgba(0, 0, 0, 0.125);
  --bs-btn-disabled-color: #F9F9F9;
  --bs-btn-disabled-bg: transparent;
  --bs-btn-disabled-border-color: #F9F9F9;
  --bs-gradient: none;
}

.btn-outline-primary {
  --bs-btn-color: #009ef7;
  --bs-btn-border-color: #009ef7;
  --bs-btn-hover-color: #000000;
  --bs-btn-hover-bg: #009ef7;
  --bs-btn-hover-border-color: #009ef7;
  --bs-btn-focus-shadow-rgb: 0, 158, 247;
  --bs-btn-active-color: #000000;
  --bs-btn-active-bg: #009ef7;
  --bs-btn-active-border-color: #009ef7;
  --bs-btn-active-shadow: inset 0 3px 5px rgba(0, 0, 0, 0.125);
  --bs-btn-disabled-color: #009ef7;
  --bs-btn-disabled-bg: transparent;
  --bs-btn-disabled-border-color: #009ef7;
  --bs-gradient: none;
}

.btn-outline-secondary {
  --bs-btn-color: #E1E3EA;
  --bs-btn-border-color: #E1E3EA;
  --bs-btn-hover-color: #000000;
  --bs-btn-hover-bg: #E1E3EA;
  --bs-btn-hover-border-color: #E1E3EA;
  --bs-btn-focus-shadow-rgb: 225, 227, 234;
  --bs-btn-active-color: #000000;
  --bs-btn-active-bg: #E1E3EA;
  --bs-btn-active-border-color: #E1E3EA;
  --bs-btn-active-shadow: inset 0 3px 5px rgba(0, 0, 0, 0.125);
  --bs-btn-disabled-color: #E1E3EA;
  --bs-btn-disabled-bg: transparent;
  --bs-btn-disabled-border-color: #E1E3EA;
  --bs-gradient: none;
}

.btn-outline-success {
  --bs-btn-color: #50cd89;
  --bs-btn-border-color: #50cd89;
  --bs-btn-hover-color: #000000;
  --bs-btn-hover-bg: #50cd89;
  --bs-btn-hover-border-color: #50cd89;
  --bs-btn-focus-shadow-rgb: 80, 205, 137;
  --bs-btn-active-color: #000000;
  --bs-btn-active-bg: #50cd89;
  --bs-btn-active-border-color: #50cd89;
  --bs-btn-active-shadow: inset 0 3px 5px rgba(0, 0, 0, 0.125);
  --bs-btn-disabled-color: #50cd89;
  --bs-btn-disabled-bg: transparent;
  --bs-btn-disabled-border-color: #50cd89;
  --bs-gradient: none;
}

.btn-outline-info {
  --bs-btn-color: #7239ea;
  --bs-btn-border-color: #7239ea;
  --bs-btn-hover-color: #ffffff;
  --bs-btn-hover-bg: #7239ea;
  --bs-btn-hover-border-color: #7239ea;
  --bs-btn-focus-shadow-rgb: 114, 57, 234;
  --bs-btn-active-color: #ffffff;
  --bs-btn-active-bg: #7239ea;
  --bs-btn-active-border-color: #7239ea;
  --bs-btn-active-shadow: inset 0 3px 5px rgba(0, 0, 0, 0.125);
  --bs-btn-disabled-color: #7239ea;
  --bs-btn-disabled-bg: transparent;
  --bs-btn-disabled-border-color: #7239ea;
  --bs-gradient: none;
}

.btn-outline-warning {
  --bs-btn-color: #ffc700;
  --bs-btn-border-color: #ffc700;
  --bs-btn-hover-color: #000000;
  --bs-btn-hover-bg: #ffc700;
  --bs-btn-hover-border-color: #ffc700;
  --bs-btn-focus-shadow-rgb: 255, 199, 0;
  --bs-btn-active-color: #000000;
  --bs-btn-active-bg: #ffc700;
  --bs-btn-active-border-color: #ffc700;
  --bs-btn-active-shadow: inset 0 3px 5px rgba(0, 0, 0, 0.125);
  --bs-btn-disabled-color: #ffc700;
  --bs-btn-disabled-bg: transparent;
  --bs-btn-disabled-border-color: #ffc700;
  --bs-gradient: none;
}

.btn-outline-danger {
  --bs-btn-color: #f1416c;
  --bs-btn-border-color: #f1416c;
  --bs-btn-hover-color: #000000;
  --bs-btn-hover-bg: #f1416c;
  --bs-btn-hover-border-color: #f1416c;
  --bs-btn-focus-shadow-rgb: 241, 65, 108;
  --bs-btn-active-color: #000000;
  --bs-btn-active-bg: #f1416c;
  --bs-btn-active-border-color: #f1416c;
  --bs-btn-active-shadow: inset 0 3px 5px rgba(0, 0, 0, 0.125);
  --bs-btn-disabled-color: #f1416c;
  --bs-btn-disabled-bg: transparent;
  --bs-btn-disabled-border-color: #f1416c;
  --bs-gradient: none;
}

.btn-outline-dark {
  --bs-btn-color: #181C32;
  --bs-btn-border-color: #181C32;
  --bs-btn-hover-color: #ffffff;
  --bs-btn-hover-bg: #181C32;
  --bs-btn-hover-border-color: #181C32;
  --bs-btn-focus-shadow-rgb: 24, 28, 50;
  --bs-btn-active-color: #ffffff;
  --bs-btn-active-bg: #181C32;
  --bs-btn-active-border-color: #181C32;
  --bs-btn-active-shadow: inset 0 3px 5px rgba(0, 0, 0, 0.125);
  --bs-btn-disabled-color: #181C32;
  --bs-btn-disabled-bg: transparent;
  --bs-btn-disabled-border-color: #181C32;
  --bs-gradient: none;
}

.btn-link {
  --bs-btn-font-weight: 400;
  --bs-btn-color: var(--bs-link-color);
  --bs-btn-bg: transparent;
  --bs-btn-border-color: transparent;
  --bs-btn-hover-color: var(--bs-link-hover-color);
  --bs-btn-hover-border-color: transparent;
  --bs-btn-active-color: var(--bs-link-hover-color);
  --bs-btn-active-border-color: transparent;
  --bs-btn-disabled-color: var(--bs-gray-600);
  --bs-btn-disabled-border-color: transparent;
  --bs-btn-box-shadow: none;
  --bs-btn-focus-shadow-rgb: 0, 134, 210;
  text-decoration: none;
}

.btn-link:hover, .btn-link:focus-visible {
  text-decoration: none;
}

.btn-link:focus-visible {
  color: var(--bs-btn-color);
}

.btn-link:hover {
  color: var(--bs-btn-hover-color);
}

.btn-lg, .btn-group-lg > .btn {
  --bs-btn-padding-y: 0.825rem;
  --bs-btn-padding-x: 1.75rem;
  --bs-btn-font-size: 1.15rem;
  --bs-btn-border-radius: 0.625rem;
}

.btn-sm, .btn-group-sm > .btn {
  --bs-btn-padding-y: 0.55rem;
  --bs-btn-padding-x: 1.25rem;
  --bs-btn-font-size: 0.95rem;
  --bs-btn-border-radius: 0.425rem;
}

.fade {
  transition: opacity 0.15s linear;
}

@media (prefers-reduced-motion: reduce) {
  .fade {
    transition: none;
  }
}
.fade:not(.show) {
  opacity: 0;
}

.collapse:not(.show) {
  display: none;
}

.collapsing {
  height: 0;
  overflow: hidden;
  transition: height 0.35s ease;
}

@media (prefers-reduced-motion: reduce) {
  .collapsing {
    transition: none;
  }
}
.collapsing.collapse-horizontal {
  width: 0;
  height: auto;
  transition: width 0.35s ease;
}

@media (prefers-reduced-motion: reduce) {
  .collapsing.collapse-horizontal {
    transition: none;
  }
}
.dropup,
.dropend,
.dropdown,
.dropstart,
.dropup-center,
.dropdown-center {
  position: relative;
}

.dropdown-toggle {
  white-space: nowrap;
}

.dropdown-toggle::after {
  display: inline-block;
  margin-left: 0.255em;
  vertical-align: 0.255em;
  content: "";
  border-top: 0.3em solid;
  border-right: 0.3em solid transparent;
  border-bottom: 0;
  border-left: 0.3em solid transparent;
}

.dropdown-toggle:empty::after {
  margin-left: 0;
}

.dropdown-menu {
  --bs-dropdown-zindex: 1000;
  --bs-dropdown-min-width: 10rem;
  --bs-dropdown-padding-x: 0;
  --bs-dropdown-padding-y: 0.5rem;
  --bs-dropdown-spacer: 0.125rem;
  --bs-dropdown-font-size: 1rem;
  --bs-dropdown-color: var(--bs-body-color);
  --bs-dropdown-bg: var(--bs-body-bg);
  --bs-dropdown-border-color: var(--bs-border-color-translucent);
  --bs-dropdown-border-radius: 0.475rem;
  --bs-dropdown-border-width: 0rem;
  --bs-dropdown-inner-border-radius: 0.475rem;
  --bs-dropdown-divider-bg: var(--bs-gray-100);
  --bs-dropdown-divider-margin-y: 0.5rem;
  --bs-dropdown-box-shadow: 0px 0px 50px 0px rgba(82, 63, 105, 0.15);
  --bs-dropdown-link-color: var(--bs-gray-900);
  --bs-dropdown-link-hover-color: var(--bs-gray-900);
  --bs-dropdown-link-hover-bg: var(--bs-tertiary-bg);
  --bs-dropdown-link-active-color: var(--bs-component-hover-color);
  --bs-dropdown-link-active-bg: var(--bs-component-hover-bg);
  --bs-dropdown-link-disabled-color: var(--bs-gray-500);
  --bs-dropdown-item-padding-x: 0.85rem;
  --bs-dropdown-item-padding-y: 0.65rem;
  --bs-dropdown-header-color: var(--bs-gray-600);
  --bs-dropdown-header-padding-x: 0.85rem;
  --bs-dropdown-header-padding-y: 0.5rem;
  position: absolute;
  z-index: var(--bs-dropdown-zindex);
  display: none;
  min-width: var(--bs-dropdown-min-width);
  padding: var(--bs-dropdown-padding-y) var(--bs-dropdown-padding-x);
  margin: 0;
  font-size: var(--bs-dropdown-font-size);
  color: var(--bs-dropdown-color);
  text-align: left;
  list-style: none;
  background-color: var(--bs-dropdown-bg);
  background-clip: padding-box;
  border: var(--bs-dropdown-border-width) solid var(--bs-dropdown-border-color);
  border-radius: var(--bs-dropdown-border-radius);
  box-shadow: var(--bs-dropdown-box-shadow);
}

.dropdown-menu[data-bs-popper] {
  top: 100%;
  left: 0;
  margin-top: var(--bs-dropdown-spacer);
}

.dropdown-menu-start {
  --bs-position: start;
}

.dropdown-menu-start[data-bs-popper] {
  right: auto;
  left: 0;
}

.dropdown-menu-end {
  --bs-position: end;
}

.dropdown-menu-end[data-bs-popper] {
  right: 0;
  left: auto;
}

@media (min-width: 576px) {
  .dropdown-menu-sm-start {
    --bs-position: start;
  }
  .dropdown-menu-sm-start[data-bs-popper] {
    right: auto;
    left: 0;
  }
  .dropdown-menu-sm-end {
    --bs-position: end;
  }
  .dropdown-menu-sm-end[data-bs-popper] {
    right: 0;
    left: auto;
  }
}
@media (min-width: 768px) {
  .dropdown-menu-md-start {
    --bs-position: start;
  }
  .dropdown-menu-md-start[data-bs-popper] {
    right: auto;
    left: 0;
  }
  .dropdown-menu-md-end {
    --bs-position: end;
  }
  .dropdown-menu-md-end[data-bs-popper] {
    right: 0;
    left: auto;
  }
}
@media (min-width: 992px) {
  .dropdown-menu-lg-start {
    --bs-position: start;
  }
  .dropdown-menu-lg-start[data-bs-popper] {
    right: auto;
    left: 0;
  }
  .dropdown-menu-lg-end {
    --bs-position: end;
  }
  .dropdown-menu-lg-end[data-bs-popper] {
    right: 0;
    left: auto;
  }
}
@media (min-width: 1200px) {
  .dropdown-menu-xl-start {
    --bs-position: start;
  }
  .dropdown-menu-xl-start[data-bs-popper] {
    right: auto;
    left: 0;
  }
  .dropdown-menu-xl-end {
    --bs-position: end;
  }
  .dropdown-menu-xl-end[data-bs-popper] {
    right: 0;
    left: auto;
  }
}
@media (min-width: 1400px) {
  .dropdown-menu-xxl-start {
    --bs-position: start;
  }
  .dropdown-menu-xxl-start[data-bs-popper] {
    right: auto;
    left: 0;
  }
  .dropdown-menu-xxl-end {
    --bs-position: end;
  }
  .dropdown-menu-xxl-end[data-bs-popper] {
    right: 0;
    left: auto;
  }
}
.dropup .dropdown-menu[data-bs-popper] {
  top: auto;
  bottom: 100%;
  margin-top: 0;
  margin-bottom: var(--bs-dropdown-spacer);
}

.dropup .dropdown-toggle::after {
  display: inline-block;
  margin-left: 0.255em;
  vertical-align: 0.255em;
  content: "";
  border-top: 0;
  border-right: 0.3em solid transparent;
  border-bottom: 0.3em solid;
  border-left: 0.3em solid transparent;
}

.dropup .dropdown-toggle:empty::after {
  margin-left: 0;
}

.dropend .dropdown-menu[data-bs-popper] {
  top: 0;
  right: auto;
  left: 100%;
  margin-top: 0;
  margin-left: var(--bs-dropdown-spacer);
}

.dropend .dropdown-toggle::after {
  display: inline-block;
  margin-left: 0.255em;
  vertical-align: 0.255em;
  content: "";
  border-top: 0.3em solid transparent;
  border-right: 0;
  border-bottom: 0.3em solid transparent;
  border-left: 0.3em solid;
}

.dropend .dropdown-toggle:empty::after {
  margin-left: 0;
}

.dropend .dropdown-toggle::after {
  vertical-align: 0;
}

.dropstart .dropdown-menu[data-bs-popper] {
  top: 0;
  right: 100%;
  left: auto;
  margin-top: 0;
  margin-right: var(--bs-dropdown-spacer);
}

.dropstart .dropdown-toggle::after {
  display: inline-block;
  margin-left: 0.255em;
  vertical-align: 0.255em;
  content: "";
  display: none;
}

.dropstart .dropdown-toggle::before {
  display: inline-block;
  margin-right: 0.255em;
  vertical-align: 0.255em;
  content: "";
  border-top: 0.3em solid transparent;
  border-right: 0.3em solid;
  border-bottom: 0.3em solid transparent;
}

.dropstart .dropdown-toggle:empty::after {
  margin-left: 0;
}

.dropstart .dropdown-toggle::before {
  vertical-align: 0;
}

.dropdown-divider {
  height: 0;
  margin: var(--bs-dropdown-divider-margin-y) 0;
  overflow: hidden;
  border-top: 1px solid var(--bs-dropdown-divider-bg);
  opacity: 1;
}

.dropdown-item {
  display: block;
  width: 100%;
  padding: var(--bs-dropdown-item-padding-y) var(--bs-dropdown-item-padding-x);
  clear: both;
  font-weight: 400;
  color: var(--bs-dropdown-link-color);
  text-align: inherit;
  white-space: nowrap;
  background-color: transparent;
  border: 0;
  border-radius: var(--bs-dropdown-item-border-radius, 0);
}

.dropdown-item:hover, .dropdown-item:focus {
  color: var(--bs-dropdown-link-hover-color);
  background-color: var(--bs-dropdown-link-hover-bg);
}

.dropdown-item.active, .dropdown-item:active {
  color: var(--bs-dropdown-link-active-color);
  text-decoration: none;
  background-color: var(--bs-dropdown-link-active-bg);
}

.dropdown-item.disabled, .dropdown-item:disabled {
  color: var(--bs-dropdown-link-disabled-color);
  pointer-events: none;
  background-color: transparent;
}

.dropdown-menu.show {
  display: block;
}

.dropdown-header {
  display: block;
  padding: var(--bs-dropdown-header-padding-y) var(--bs-dropdown-header-padding-x);
  margin-bottom: 0;
  font-size: 0.95rem;
  color: var(--bs-dropdown-header-color);
  white-space: nowrap;
}

.dropdown-item-text {
  display: block;
  padding: var(--bs-dropdown-item-padding-y) var(--bs-dropdown-item-padding-x);
  color: var(--bs-dropdown-link-color);
}

.dropdown-menu-dark {
  --bs-dropdown-color: #E1E3EA;
  --bs-dropdown-bg: #3F4254;
  --bs-dropdown-border-color: var(--bs-border-color-translucent);
  --bs-dropdown-box-shadow: ;
  --bs-dropdown-link-color: #E1E3EA;
  --bs-dropdown-link-hover-color: #ffffff;
  --bs-dropdown-divider-bg: var(--bs-gray-100);
  --bs-dropdown-link-hover-bg: rgba(255, 255, 255, 0.15);
  --bs-dropdown-link-active-color: var(--bs-component-hover-color);
  --bs-dropdown-link-active-bg: var(--bs-component-hover-bg);
  --bs-dropdown-link-disabled-color: #A1A5B7;
  --bs-dropdown-header-color: #A1A5B7;
}

.btn-group,
.btn-group-vertical {
  position: relative;
  display: inline-flex;
  vertical-align: middle;
}

.btn-group > .btn,
.btn-group-vertical > .btn {
  position: relative;
  flex: 1 1 auto;
}

.btn-group > .btn-check:checked + .btn,
.btn-group > .btn-check:focus + .btn,
.btn-group > .btn:hover,
.btn-group > .btn:focus,
.btn-group > .btn:active,
.btn-group > .btn.active,
.btn-group-vertical > .btn-check:checked + .btn,
.btn-group-vertical > .btn-check:focus + .btn,
.btn-group-vertical > .btn:hover,
.btn-group-vertical > .btn:focus,
.btn-group-vertical > .btn:active,
.btn-group-vertical > .btn.active {
  z-index: 1;
}

.btn-toolbar {
  display: flex;
  flex-wrap: wrap;
  justify-content: flex-start;
}

.btn-toolbar .input-group {
  width: auto;
}

.btn-group {
  border-radius: 0.475rem;
}

.btn-group > :not(.btn-check:first-child) + .btn,
.btn-group > .btn-group:not(:first-child) {
  margin-left: -1px;
}

.btn-group > .btn:not(:last-child):not(.dropdown-toggle),
.btn-group > .btn.dropdown-toggle-split:first-child,
.btn-group > .btn-group:not(:last-child) > .btn {
  border-top-right-radius: 0;
  border-bottom-right-radius: 0;
}

.btn-group > .btn:nth-child(n+3),
.btn-group > :not(.btn-check) + .btn,
.btn-group > .btn-group:not(:first-child) > .btn {
  border-top-left-radius: 0;
  border-bottom-left-radius: 0;
}

.dropdown-toggle-split {
  padding-right: 1.125rem;
  padding-left: 1.125rem;
}

.dropdown-toggle-split::after, .dropup .dropdown-toggle-split::after, .dropend .dropdown-toggle-split::after {
  margin-left: 0;
}

.dropstart .dropdown-toggle-split::before {
  margin-right: 0;
}

.btn-sm + .dropdown-toggle-split, .btn-group-sm > .btn + .dropdown-toggle-split {
  padding-right: 0.9375rem;
  padding-left: 0.9375rem;
}

.btn-lg + .dropdown-toggle-split, .btn-group-lg > .btn + .dropdown-toggle-split {
  padding-right: 1.3125rem;
  padding-left: 1.3125rem;
}

.btn-group.show .dropdown-toggle {
  box-shadow: inset 0 3px 5px rgba(0, 0, 0, 0.125);
}

.btn-group.show .dropdown-toggle.btn-link {
  box-shadow: none;
}

.btn-group-vertical {
  flex-direction: column;
  align-items: flex-start;
  justify-content: center;
}

.btn-group-vertical > .btn,
.btn-group-vertical > .btn-group {
  width: 100%;
}

.btn-group-vertical > .btn:not(:first-child),
.btn-group-vertical > .btn-group:not(:first-child) {
  margin-top: -1px;
}

.btn-group-vertical > .btn:not(:last-child):not(.dropdown-toggle),
.btn-group-vertical > .btn-group:not(:last-child) > .btn {
  border-bottom-right-radius: 0;
  border-bottom-left-radius: 0;
}

.btn-group-vertical > .btn ~ .btn,
.btn-group-vertical > .btn-group:not(:first-child) > .btn {
  border-top-left-radius: 0;
  border-top-right-radius: 0;
}

.nav {
  --bs-nav-link-padding-x: 1rem;
  --bs-nav-link-padding-y: 0.5rem;
  --bs-nav-link-font-weight: ;
  --bs-nav-link-color: var(--bs-link-color);
  --bs-nav-link-hover-color: var(--bs-link-hover-color);
  --bs-nav-link-disabled-color: var(--bs-secondary-color);
  display: flex;
  flex-wrap: wrap;
  padding-left: 0;
  margin-bottom: 0;
  list-style: none;
}

.nav-link {
  display: block;
  padding: var(--bs-nav-link-padding-y) var(--bs-nav-link-padding-x);
  font-size: var(--bs-nav-link-font-size);
  font-weight: var(--bs-nav-link-font-weight);
  color: var(--bs-nav-link-color);
  transition: color 0.15s ease-in-out;
}

@media (prefers-reduced-motion: reduce) {
  .nav-link {
    transition: none;
  }
}
.nav-link:hover, .nav-link:focus {
  color: var(--bs-nav-link-hover-color);
}

.nav-link.disabled {
  color: var(--bs-nav-link-disabled-color);
  pointer-events: none;
  cursor: default;
}

.nav-tabs {
  --bs-nav-tabs-border-width: var(--bs-border-width);
  --bs-nav-tabs-border-color: var(--bs-border-color);
  --bs-nav-tabs-border-radius: var(--bs-border-radius);
  --bs-nav-tabs-link-hover-border-color: var(--bs-secondary-bg) var(--bs-secondary-bg) var(--bs-border-color);
  --bs-nav-tabs-link-active-color: var(--bs-emphasis-color);
  --bs-nav-tabs-link-active-bg: var(--bs-body-bg);
  --bs-nav-tabs-link-active-border-color: var(--bs-border-color) var(--bs-border-color) var(--bs-body-bg);
  border-bottom: var(--bs-nav-tabs-border-width) solid var(--bs-nav-tabs-border-color);
}

.nav-tabs .nav-link {
  margin-bottom: calc(-1 * var(--bs-nav-tabs-border-width));
  background: none;
  border: var(--bs-nav-tabs-border-width) solid transparent;
  border-top-left-radius: var(--bs-nav-tabs-border-radius);
  border-top-right-radius: var(--bs-nav-tabs-border-radius);
}

.nav-tabs .nav-link:hover, .nav-tabs .nav-link:focus {
  isolation: isolate;
  border-color: var(--bs-nav-tabs-link-hover-border-color);
}

.nav-tabs .nav-link.disabled, .nav-tabs .nav-link:disabled {
  color: var(--bs-nav-link-disabled-color);
  background-color: transparent;
  border-color: transparent;
}

.nav-tabs .nav-link.active,
.nav-tabs .nav-item.show .nav-link {
  color: var(--bs-nav-tabs-link-active-color);
  background-color: var(--bs-nav-tabs-link-active-bg);
  border-color: var(--bs-nav-tabs-link-active-border-color);
}

.nav-tabs .dropdown-menu {
  margin-top: calc(-1 * var(--bs-nav-tabs-border-width));
  border-top-left-radius: 0;
  border-top-right-radius: 0;
}

.nav-pills {
  --bs-nav-pills-border-radius: 0.475rem;
  --bs-nav-pills-link-active-color: #ffffff;
  --bs-nav-pills-link-active-bg: #009ef7;
}

.nav-pills .nav-link {
  background: none;
  border: 0;
  border-radius: var(--bs-nav-pills-border-radius);
}

.nav-pills .nav-link:disabled {
  color: var(--bs-nav-link-disabled-color);
  background-color: transparent;
  border-color: transparent;
}

.nav-pills .nav-link.active,
.nav-pills .show > .nav-link {
  color: var(--bs-nav-pills-link-active-color);
  background-color: var(--bs-nav-pills-link-active-bg);
}

.nav-fill > .nav-link,
.nav-fill .nav-item {
  flex: 1 1 auto;
  text-align: center;
}

.nav-justified > .nav-link,
.nav-justified .nav-item {
  flex-basis: 0;
  flex-grow: 1;
  text-align: center;
}

.nav-fill .nav-item .nav-link,
.nav-justified .nav-item .nav-link {
  width: 100%;
}

.tab-content > .tab-pane {
  display: none;
}

.tab-content > .active {
  display: block;
}

.navbar {
  --bs-navbar-padding-x: 0;
  --bs-navbar-padding-y: 0.5rem;
  --bs-navbar-color: rgba(var(--bs-emphasis-color-rgb), 0.65);
  --bs-navbar-hover-color: rgba(var(--bs-emphasis-color-rgb), 0.8);
  --bs-navbar-disabled-color: rgba(var(--bs-emphasis-color-rgb), 0.3);
  --bs-navbar-active-color: rgba(var(--bs-emphasis-color-rgb), 1);
  --bs-navbar-brand-padding-y: 0.44375rem;
  --bs-navbar-brand-margin-end: 1rem;
  --bs-navbar-brand-font-size: 1.075rem;
  --bs-navbar-brand-color: rgba(var(--bs-emphasis-color-rgb), 1);
  --bs-navbar-brand-hover-color: rgba(var(--bs-emphasis-color-rgb), 1);
  --bs-navbar-nav-link-padding-x: 0.5rem;
  --bs-navbar-toggler-padding-y: 0.25rem;
  --bs-navbar-toggler-padding-x: 0.75rem;
  --bs-navbar-toggler-font-size: 1.075rem;
  --bs-navbar-toggler-icon-bg: url(${___CSS_LOADER_URL_REPLACEMENT_10___});
  --bs-navbar-toggler-border-color: rgba(var(--bs-emphasis-color-rgb), 0.15);
  --bs-navbar-toggler-border-radius: 0.475rem;
  --bs-navbar-toggler-focus-width: 0.25rem;
  --bs-navbar-toggler-transition: box-shadow 0.15s ease-in-out;
  position: relative;
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  justify-content: space-between;
  padding: var(--bs-navbar-padding-y) var(--bs-navbar-padding-x);
}

.navbar > .container,
.navbar > .container-fluid,
.navbar > .container-sm,
.navbar > .container-md,
.navbar > .container-lg,
.navbar > .container-xl,
.navbar > .container-xxl {
  display: flex;
  flex-wrap: inherit;
  align-items: center;
  justify-content: space-between;
}

.navbar-brand {
  padding-top: var(--bs-navbar-brand-padding-y);
  padding-bottom: var(--bs-navbar-brand-padding-y);
  margin-right: var(--bs-navbar-brand-margin-end);
  font-size: var(--bs-navbar-brand-font-size);
  color: var(--bs-navbar-brand-color);
  white-space: nowrap;
}

.navbar-brand:hover, .navbar-brand:focus {
  color: var(--bs-navbar-brand-hover-color);
}

.navbar-nav {
  --bs-nav-link-padding-x: 0;
  --bs-nav-link-padding-y: 0.5rem;
  --bs-nav-link-font-weight: ;
  --bs-nav-link-color: var(--bs-navbar-color);
  --bs-nav-link-hover-color: var(--bs-navbar-hover-color);
  --bs-nav-link-disabled-color: var(--bs-navbar-disabled-color);
  display: flex;
  flex-direction: column;
  padding-left: 0;
  margin-bottom: 0;
  list-style: none;
}

.navbar-nav .show > .nav-link,
.navbar-nav .nav-link.active {
  color: var(--bs-navbar-active-color);
}

.navbar-nav .dropdown-menu {
  position: static;
}

.navbar-text {
  padding-top: 0.5rem;
  padding-bottom: 0.5rem;
  color: var(--bs-navbar-color);
}

.navbar-text a,
.navbar-text a:hover,
.navbar-text a:focus {
  color: var(--bs-navbar-active-color);
}

.navbar-collapse {
  flex-basis: 100%;
  flex-grow: 1;
  align-items: center;
}

.navbar-toggler {
  padding: var(--bs-navbar-toggler-padding-y) var(--bs-navbar-toggler-padding-x);
  font-size: var(--bs-navbar-toggler-font-size);
  line-height: 1;
  color: var(--bs-navbar-color);
  background-color: transparent;
  border: var(--bs-border-width) solid var(--bs-navbar-toggler-border-color);
  border-radius: var(--bs-navbar-toggler-border-radius);
  transition: var(--bs-navbar-toggler-transition);
}

@media (prefers-reduced-motion: reduce) {
  .navbar-toggler {
    transition: none;
  }
}
.navbar-toggler:hover {
  text-decoration: none;
}

.navbar-toggler:focus {
  text-decoration: none;
  outline: 0;
  box-shadow: 0 0 0 var(--bs-navbar-toggler-focus-width);
}

.navbar-toggler-icon {
  display: inline-block;
  width: 1.5em;
  height: 1.5em;
  vertical-align: middle;
  background-image: var(--bs-navbar-toggler-icon-bg);
  background-repeat: no-repeat;
  background-position: center;
  background-size: 100%;
}

.navbar-nav-scroll {
  max-height: var(--bs-scroll-height, 75vh);
  overflow-y: auto;
}

@media (min-width: 576px) {
  .navbar-expand-sm {
    flex-wrap: nowrap;
    justify-content: flex-start;
  }
  .navbar-expand-sm .navbar-nav {
    flex-direction: row;
  }
  .navbar-expand-sm .navbar-nav .dropdown-menu {
    position: absolute;
  }
  .navbar-expand-sm .navbar-nav .nav-link {
    padding-right: var(--bs-navbar-nav-link-padding-x);
    padding-left: var(--bs-navbar-nav-link-padding-x);
  }
  .navbar-expand-sm .navbar-nav-scroll {
    overflow: visible;
  }
  .navbar-expand-sm .navbar-collapse {
    display: flex !important;
    flex-basis: auto;
  }
  .navbar-expand-sm .navbar-toggler {
    display: none;
  }
  .navbar-expand-sm .offcanvas {
    position: static;
    z-index: auto;
    flex-grow: 1;
    width: auto !important;
    height: auto !important;
    visibility: visible !important;
    background-color: transparent !important;
    border: 0 !important;
    transform: none !important;
    box-shadow: none;
    transition: none;
  }
  .navbar-expand-sm .offcanvas .offcanvas-header {
    display: none;
  }
  .navbar-expand-sm .offcanvas .offcanvas-body {
    display: flex;
    flex-grow: 0;
    padding: 0;
    overflow-y: visible;
  }
}
@media (min-width: 768px) {
  .navbar-expand-md {
    flex-wrap: nowrap;
    justify-content: flex-start;
  }
  .navbar-expand-md .navbar-nav {
    flex-direction: row;
  }
  .navbar-expand-md .navbar-nav .dropdown-menu {
    position: absolute;
  }
  .navbar-expand-md .navbar-nav .nav-link {
    padding-right: var(--bs-navbar-nav-link-padding-x);
    padding-left: var(--bs-navbar-nav-link-padding-x);
  }
  .navbar-expand-md .navbar-nav-scroll {
    overflow: visible;
  }
  .navbar-expand-md .navbar-collapse {
    display: flex !important;
    flex-basis: auto;
  }
  .navbar-expand-md .navbar-toggler {
    display: none;
  }
  .navbar-expand-md .offcanvas {
    position: static;
    z-index: auto;
    flex-grow: 1;
    width: auto !important;
    height: auto !important;
    visibility: visible !important;
    background-color: transparent !important;
    border: 0 !important;
    transform: none !important;
    box-shadow: none;
    transition: none;
  }
  .navbar-expand-md .offcanvas .offcanvas-header {
    display: none;
  }
  .navbar-expand-md .offcanvas .offcanvas-body {
    display: flex;
    flex-grow: 0;
    padding: 0;
    overflow-y: visible;
  }
}
@media (min-width: 992px) {
  .navbar-expand-lg {
    flex-wrap: nowrap;
    justify-content: flex-start;
  }
  .navbar-expand-lg .navbar-nav {
    flex-direction: row;
  }
  .navbar-expand-lg .navbar-nav .dropdown-menu {
    position: absolute;
  }
  .navbar-expand-lg .navbar-nav .nav-link {
    padding-right: var(--bs-navbar-nav-link-padding-x);
    padding-left: var(--bs-navbar-nav-link-padding-x);
  }
  .navbar-expand-lg .navbar-nav-scroll {
    overflow: visible;
  }
  .navbar-expand-lg .navbar-collapse {
    display: flex !important;
    flex-basis: auto;
  }
  .navbar-expand-lg .navbar-toggler {
    display: none;
  }
  .navbar-expand-lg .offcanvas {
    position: static;
    z-index: auto;
    flex-grow: 1;
    width: auto !important;
    height: auto !important;
    visibility: visible !important;
    background-color: transparent !important;
    border: 0 !important;
    transform: none !important;
    box-shadow: none;
    transition: none;
  }
  .navbar-expand-lg .offcanvas .offcanvas-header {
    display: none;
  }
  .navbar-expand-lg .offcanvas .offcanvas-body {
    display: flex;
    flex-grow: 0;
    padding: 0;
    overflow-y: visible;
  }
}
@media (min-width: 1200px) {
  .navbar-expand-xl {
    flex-wrap: nowrap;
    justify-content: flex-start;
  }
  .navbar-expand-xl .navbar-nav {
    flex-direction: row;
  }
  .navbar-expand-xl .navbar-nav .dropdown-menu {
    position: absolute;
  }
  .navbar-expand-xl .navbar-nav .nav-link {
    padding-right: var(--bs-navbar-nav-link-padding-x);
    padding-left: var(--bs-navbar-nav-link-padding-x);
  }
  .navbar-expand-xl .navbar-nav-scroll {
    overflow: visible;
  }
  .navbar-expand-xl .navbar-collapse {
    display: flex !important;
    flex-basis: auto;
  }
  .navbar-expand-xl .navbar-toggler {
    display: none;
  }
  .navbar-expand-xl .offcanvas {
    position: static;
    z-index: auto;
    flex-grow: 1;
    width: auto !important;
    height: auto !important;
    visibility: visible !important;
    background-color: transparent !important;
    border: 0 !important;
    transform: none !important;
    box-shadow: none;
    transition: none;
  }
  .navbar-expand-xl .offcanvas .offcanvas-header {
    display: none;
  }
  .navbar-expand-xl .offcanvas .offcanvas-body {
    display: flex;
    flex-grow: 0;
    padding: 0;
    overflow-y: visible;
  }
}
@media (min-width: 1400px) {
  .navbar-expand-xxl {
    flex-wrap: nowrap;
    justify-content: flex-start;
  }
  .navbar-expand-xxl .navbar-nav {
    flex-direction: row;
  }
  .navbar-expand-xxl .navbar-nav .dropdown-menu {
    position: absolute;
  }
  .navbar-expand-xxl .navbar-nav .nav-link {
    padding-right: var(--bs-navbar-nav-link-padding-x);
    padding-left: var(--bs-navbar-nav-link-padding-x);
  }
  .navbar-expand-xxl .navbar-nav-scroll {
    overflow: visible;
  }
  .navbar-expand-xxl .navbar-collapse {
    display: flex !important;
    flex-basis: auto;
  }
  .navbar-expand-xxl .navbar-toggler {
    display: none;
  }
  .navbar-expand-xxl .offcanvas {
    position: static;
    z-index: auto;
    flex-grow: 1;
    width: auto !important;
    height: auto !important;
    visibility: visible !important;
    background-color: transparent !important;
    border: 0 !important;
    transform: none !important;
    box-shadow: none;
    transition: none;
  }
  .navbar-expand-xxl .offcanvas .offcanvas-header {
    display: none;
  }
  .navbar-expand-xxl .offcanvas .offcanvas-body {
    display: flex;
    flex-grow: 0;
    padding: 0;
    overflow-y: visible;
  }
}
.navbar-expand {
  flex-wrap: nowrap;
  justify-content: flex-start;
}

.navbar-expand .navbar-nav {
  flex-direction: row;
}

.navbar-expand .navbar-nav .dropdown-menu {
  position: absolute;
}

.navbar-expand .navbar-nav .nav-link {
  padding-right: var(--bs-navbar-nav-link-padding-x);
  padding-left: var(--bs-navbar-nav-link-padding-x);
}

.navbar-expand .navbar-nav-scroll {
  overflow: visible;
}

.navbar-expand .navbar-collapse {
  display: flex !important;
  flex-basis: auto;
}

.navbar-expand .navbar-toggler {
  display: none;
}

.navbar-expand .offcanvas {
  position: static;
  z-index: auto;
  flex-grow: 1;
  width: auto !important;
  height: auto !important;
  visibility: visible !important;
  background-color: transparent !important;
  border: 0 !important;
  transform: none !important;
  box-shadow: none;
  transition: none;
}

.navbar-expand .offcanvas .offcanvas-header {
  display: none;
}

.navbar-expand .offcanvas .offcanvas-body {
  display: flex;
  flex-grow: 0;
  padding: 0;
  overflow-y: visible;
}

.navbar-dark {
  --bs-navbar-color: rgba(255, 255, 255, 0.55);
  --bs-navbar-hover-color: rgba(255, 255, 255, 0.75);
  --bs-navbar-disabled-color: rgba(255, 255, 255, 0.25);
  --bs-navbar-active-color: #ffffff;
  --bs-navbar-brand-color: #ffffff;
  --bs-navbar-brand-hover-color: #ffffff;
  --bs-navbar-toggler-border-color: rgba(255, 255, 255, 0.1);
  --bs-navbar-toggler-icon-bg: url(${___CSS_LOADER_URL_REPLACEMENT_11___});
}

[data-bs-theme=dark] .navbar {
  --bs-navbar-toggler-icon-bg: url(${___CSS_LOADER_URL_REPLACEMENT_11___});
}

.card {
  --bs-card-spacer-y: 1rem;
  --bs-card-spacer-x: 1rem;
  --bs-card-title-spacer-y: 0.5rem;
  --bs-card-title-color: ;
  --bs-card-subtitle-color: ;
  --bs-card-border-width: 1px;
  --bs-card-border-color: var(--bs-border-color);
  --bs-card-border-radius: 0.625rem;
  --bs-card-box-shadow: 0px 0px 20px 0px rgba(76, 87, 125, 0.02);
  --bs-card-inner-border-radius: calc(0.625rem - 1px);
  --bs-card-cap-padding-y: 0.5rem;
  --bs-card-cap-padding-x: 1rem;
  --bs-card-cap-bg: transparent;
  --bs-card-cap-color: ;
  --bs-card-height: ;
  --bs-card-color: ;
  --bs-card-bg: var(--bs-body-bg);
  --bs-card-img-overlay-padding: 1rem;
  --bs-card-group-margin: 0.75rem;
  position: relative;
  display: flex;
  flex-direction: column;
  min-width: 0;
  height: var(--bs-card-height);
  word-wrap: break-word;
  background-color: var(--bs-card-bg);
  background-clip: border-box;
  border: var(--bs-card-border-width) solid var(--bs-card-border-color);
  border-radius: var(--bs-card-border-radius);
  box-shadow: var(--bs-card-box-shadow);
}

.card > hr {
  margin-right: 0;
  margin-left: 0;
}

.card > .list-group {
  border-top: inherit;
  border-bottom: inherit;
}

.card > .list-group:first-child {
  border-top-width: 0;
  border-top-left-radius: var(--bs-card-inner-border-radius);
  border-top-right-radius: var(--bs-card-inner-border-radius);
}

.card > .list-group:last-child {
  border-bottom-width: 0;
  border-bottom-right-radius: var(--bs-card-inner-border-radius);
  border-bottom-left-radius: var(--bs-card-inner-border-radius);
}

.card > .card-header + .list-group,
.card > .list-group + .card-footer {
  border-top: 0;
}

.card-body {
  flex: 1 1 auto;
  padding: var(--bs-card-spacer-y) var(--bs-card-spacer-x);
  color: var(--bs-card-color);
}

.card-title {
  margin-bottom: var(--bs-card-title-spacer-y);
  color: var(--bs-card-title-color);
}

.card-subtitle {
  margin-top: calc(-0.5 * var(--bs-card-title-spacer-y));
  margin-bottom: 0;
  color: var(--bs-card-subtitle-color);
}

.card-text:last-child {
  margin-bottom: 0;
}

.card-link + .card-link {
  margin-left: var(--bs-card-spacer-x);
}

.card-header {
  padding: var(--bs-card-cap-padding-y) var(--bs-card-cap-padding-x);
  margin-bottom: 0;
  color: var(--bs-card-cap-color);
  background-color: var(--bs-card-cap-bg);
  border-bottom: var(--bs-card-border-width) solid var(--bs-card-border-color);
}

.card-header:first-child {
  border-radius: var(--bs-card-inner-border-radius) var(--bs-card-inner-border-radius) 0 0;
}

.card-footer {
  padding: var(--bs-card-cap-padding-y) var(--bs-card-cap-padding-x);
  color: var(--bs-card-cap-color);
  background-color: var(--bs-card-cap-bg);
  border-top: var(--bs-card-border-width) solid var(--bs-card-border-color);
}

.card-footer:last-child {
  border-radius: 0 0 var(--bs-card-inner-border-radius) var(--bs-card-inner-border-radius);
}

.card-header-tabs {
  margin-right: calc(-0.5 * var(--bs-card-cap-padding-x));
  margin-bottom: calc(-1 * var(--bs-card-cap-padding-y));
  margin-left: calc(-0.5 * var(--bs-card-cap-padding-x));
  border-bottom: 0;
}

.card-header-tabs .nav-link.active {
  background-color: var(--bs-card-bg);
  border-bottom-color: var(--bs-card-bg);
}

.card-header-pills {
  margin-right: calc(-0.5 * var(--bs-card-cap-padding-x));
  margin-left: calc(-0.5 * var(--bs-card-cap-padding-x));
}

.card-img-overlay {
  position: absolute;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
  padding: var(--bs-card-img-overlay-padding);
  border-radius: var(--bs-card-inner-border-radius);
}

.card-img,
.card-img-top,
.card-img-bottom {
  width: 100%;
}

.card-img,
.card-img-top {
  border-top-left-radius: var(--bs-card-inner-border-radius);
  border-top-right-radius: var(--bs-card-inner-border-radius);
}

.card-img,
.card-img-bottom {
  border-bottom-right-radius: var(--bs-card-inner-border-radius);
  border-bottom-left-radius: var(--bs-card-inner-border-radius);
}

.card-group > .card {
  margin-bottom: var(--bs-card-group-margin);
}

@media (min-width: 576px) {
  .card-group {
    display: flex;
    flex-flow: row wrap;
  }
  .card-group > .card {
    flex: 1 0;
    margin-bottom: 0;
  }
  .card-group > .card + .card {
    margin-left: 0;
    border-left: 0;
  }
  .card-group > .card:not(:last-child) {
    border-top-right-radius: 0;
    border-bottom-right-radius: 0;
  }
  .card-group > .card:not(:last-child) .card-img-top,
  .card-group > .card:not(:last-child) .card-header {
    border-top-right-radius: 0;
  }
  .card-group > .card:not(:last-child) .card-img-bottom,
  .card-group > .card:not(:last-child) .card-footer {
    border-bottom-right-radius: 0;
  }
  .card-group > .card:not(:first-child) {
    border-top-left-radius: 0;
    border-bottom-left-radius: 0;
  }
  .card-group > .card:not(:first-child) .card-img-top,
  .card-group > .card:not(:first-child) .card-header {
    border-top-left-radius: 0;
  }
  .card-group > .card:not(:first-child) .card-img-bottom,
  .card-group > .card:not(:first-child) .card-footer {
    border-bottom-left-radius: 0;
  }
}
.accordion {
  --bs-accordion-color: var(--bs-body-color);
  --bs-accordion-bg: var(--bs-body-bg);
  --bs-accordion-transition: color 0.15s ease-in-out, background-color 0.15s ease-in-out, border-color 0.15s ease-in-out, box-shadow 0.15s ease-in-out, border-radius 0.15s ease;
  --bs-accordion-border-color: var(--bs-border-color);
  --bs-accordion-border-width: var(--bs-border-width);
  --bs-accordion-border-radius: 0.475rem;
  --bs-accordion-inner-border-radius: calc(0.475rem - (var(--bs-border-width)));
  --bs-accordion-btn-padding-x: 1.5rem;
  --bs-accordion-btn-padding-y: 1.5rem;
  --bs-accordion-btn-color: var(--bs-body-color);
  --bs-accordion-btn-bg: var(--bs-body-bg);
  --bs-accordion-btn-icon: url(${___CSS_LOADER_URL_REPLACEMENT_12___});
  --bs-accordion-btn-icon-width: 1.15rem;
  --bs-accordion-btn-icon-transform: rotate(-180deg);
  --bs-accordion-btn-icon-transition: transform 0.2s ease-in-out;
  --bs-accordion-btn-active-icon: url(${___CSS_LOADER_URL_REPLACEMENT_13___});
  --bs-accordion-btn-focus-border-color: var(--bs-border-color);
  --bs-accordion-btn-focus-box-shadow: none;
  --bs-accordion-body-padding-x: 1.5rem;
  --bs-accordion-body-padding-y: 1.5rem;
  --bs-accordion-active-color: var(--bs-primary);
  --bs-accordion-active-bg: var(--bs-gray-100);
}

.accordion-button {
  position: relative;
  display: flex;
  align-items: center;
  width: 100%;
  padding: var(--bs-accordion-btn-padding-y) var(--bs-accordion-btn-padding-x);
  font-size: 1rem;
  color: var(--bs-accordion-btn-color);
  text-align: left;
  background-color: var(--bs-accordion-btn-bg);
  border: 0;
  border-radius: 0;
  overflow-anchor: none;
  transition: var(--bs-accordion-transition);
}

@media (prefers-reduced-motion: reduce) {
  .accordion-button {
    transition: none;
  }
}
.accordion-button:not(.collapsed) {
  color: var(--bs-accordion-active-color);
  background-color: var(--bs-accordion-active-bg);
  box-shadow: inset 0 calc(-1 * var(--bs-accordion-border-width)) 0 var(--bs-accordion-border-color);
}

.accordion-button:not(.collapsed)::after {
  background-image: var(--bs-accordion-btn-active-icon);
  transform: var(--bs-accordion-btn-icon-transform);
}

.accordion-button::after {
  flex-shrink: 0;
  width: var(--bs-accordion-btn-icon-width);
  height: var(--bs-accordion-btn-icon-width);
  margin-left: auto;
  content: "";
  background-image: var(--bs-accordion-btn-icon);
  background-repeat: no-repeat;
  background-size: var(--bs-accordion-btn-icon-width);
  transition: var(--bs-accordion-btn-icon-transition);
}

@media (prefers-reduced-motion: reduce) {
  .accordion-button::after {
    transition: none;
  }
}
.accordion-button:hover {
  z-index: 2;
}

.accordion-button:focus {
  z-index: 3;
  border-color: var(--bs-accordion-btn-focus-border-color);
  outline: 0;
  box-shadow: var(--bs-accordion-btn-focus-box-shadow);
}

.accordion-header {
  margin-bottom: 0;
}

.accordion-item {
  color: var(--bs-accordion-color);
  background-color: var(--bs-accordion-bg);
  border: var(--bs-accordion-border-width) solid var(--bs-accordion-border-color);
}

.accordion-item:first-of-type {
  border-top-left-radius: var(--bs-accordion-border-radius);
  border-top-right-radius: var(--bs-accordion-border-radius);
}

.accordion-item:first-of-type .accordion-button {
  border-top-left-radius: var(--bs-accordion-inner-border-radius);
  border-top-right-radius: var(--bs-accordion-inner-border-radius);
}

.accordion-item:not(:first-of-type) {
  border-top: 0;
}

.accordion-item:last-of-type {
  border-bottom-right-radius: var(--bs-accordion-border-radius);
  border-bottom-left-radius: var(--bs-accordion-border-radius);
}

.accordion-item:last-of-type .accordion-button.collapsed {
  border-bottom-right-radius: var(--bs-accordion-inner-border-radius);
  border-bottom-left-radius: var(--bs-accordion-inner-border-radius);
}

.accordion-item:last-of-type .accordion-collapse {
  border-bottom-right-radius: var(--bs-accordion-border-radius);
  border-bottom-left-radius: var(--bs-accordion-border-radius);
}

.accordion-body {
  padding: var(--bs-accordion-body-padding-y) var(--bs-accordion-body-padding-x);
}

.accordion-flush .accordion-collapse {
  border-width: 0;
}

.accordion-flush .accordion-item {
  border-right: 0;
  border-left: 0;
  border-radius: 0;
}

.accordion-flush .accordion-item:first-child {
  border-top: 0;
}

.accordion-flush .accordion-item:last-child {
  border-bottom: 0;
}

.accordion-flush .accordion-item .accordion-button, .accordion-flush .accordion-item .accordion-button.collapsed {
  border-radius: 0;
}

[data-bs-theme=dark] .accordion-button::after {
  --bs-accordion-btn-icon: url(${___CSS_LOADER_URL_REPLACEMENT_14___});
  --bs-accordion-btn-active-icon: url(${___CSS_LOADER_URL_REPLACEMENT_13___});
}

.breadcrumb {
  --bs-breadcrumb-padding-x: 0;
  --bs-breadcrumb-padding-y: 0;
  --bs-breadcrumb-margin-bottom: 1rem;
  --bs-breadcrumb-bg: ;
  --bs-breadcrumb-border-radius: ;
  --bs-breadcrumb-divider-color: var(--bs-gray-600);
  --bs-breadcrumb-item-padding-x: 0.5rem;
  --bs-breadcrumb-item-active-color: var(--bs-primary);
  display: flex;
  flex-wrap: wrap;
  padding: var(--bs-breadcrumb-padding-y) var(--bs-breadcrumb-padding-x);
  margin-bottom: var(--bs-breadcrumb-margin-bottom);
  font-size: var(--bs-breadcrumb-font-size);
  list-style: none;
  background-color: var(--bs-breadcrumb-bg);
  border-radius: var(--bs-breadcrumb-border-radius);
}

.breadcrumb-item + .breadcrumb-item {
  padding-left: var(--bs-breadcrumb-item-padding-x);
}

.breadcrumb-item + .breadcrumb-item::before {
  float: left;
  padding-right: var(--bs-breadcrumb-item-padding-x);
  color: var(--bs-breadcrumb-divider-color);
  content: var(--bs-breadcrumb-divider, "/");
}

.breadcrumb-item.active {
  color: var(--bs-breadcrumb-item-active-color);
}

.pagination {
  --bs-pagination-padding-x: 0.75rem;
  --bs-pagination-padding-y: 0.375rem;
  --bs-pagination-font-size: 1.075rem;
  --bs-pagination-color: var(--bs-gray-700);
  --bs-pagination-bg: transparent;
  --bs-pagination-border-width: 0;
  --bs-pagination-border-color: transparent;
  --bs-pagination-border-radius: 0.475rem;
  --bs-pagination-hover-color: var(--bs-component-hover-color);
  --bs-pagination-hover-bg: var(--bs-component-hover-bg);
  --bs-pagination-hover-border-color: transparent;
  --bs-pagination-focus-color: var(--bs-component-hover-color);
  --bs-pagination-focus-bg: var(--bs-component-hover-bg);
  --bs-pagination-focus-box-shadow: none;
  --bs-pagination-active-color: var(--bs-component-active-color);
  --bs-pagination-active-bg: var(--bs-component-active-bg);
  --bs-pagination-active-border-color: transparent;
  --bs-pagination-disabled-color: var(--bs-gray-400);
  --bs-pagination-disabled-bg: transparent;
  --bs-pagination-disabled-border-color: transparent;
  display: flex;
  padding-left: 0;
  list-style: none;
}

.page-link {
  position: relative;
  display: block;
  padding: var(--bs-pagination-padding-y) var(--bs-pagination-padding-x);
  font-size: var(--bs-pagination-font-size);
  color: var(--bs-pagination-color);
  background-color: var(--bs-pagination-bg);
  border: var(--bs-pagination-border-width) solid var(--bs-pagination-border-color);
  transition: color 0.15s ease-in-out, background-color 0.15s ease-in-out, border-color 0.15s ease-in-out, box-shadow 0.15s ease-in-out;
}

@media (prefers-reduced-motion: reduce) {
  .page-link {
    transition: none;
  }
}
.page-link:hover {
  z-index: 2;
  color: var(--bs-pagination-hover-color);
  background-color: var(--bs-pagination-hover-bg);
  border-color: var(--bs-pagination-hover-border-color);
}

.page-link:focus {
  z-index: 3;
  color: var(--bs-pagination-focus-color);
  background-color: var(--bs-pagination-focus-bg);
  outline: 0;
  box-shadow: var(--bs-pagination-focus-box-shadow);
}

.page-link.active, .active > .page-link {
  z-index: 3;
  color: var(--bs-pagination-active-color);
  background-color: var(--bs-pagination-active-bg);
  border-color: var(--bs-pagination-active-border-color);
}

.page-link.disabled, .disabled > .page-link {
  color: var(--bs-pagination-disabled-color);
  pointer-events: none;
  background-color: var(--bs-pagination-disabled-bg);
  border-color: var(--bs-pagination-disabled-border-color);
}

.page-item:not(:first-child) .page-link {
  margin-left: 0;
}

.page-item:first-child .page-link {
  border-top-left-radius: var(--bs-pagination-border-radius);
  border-bottom-left-radius: var(--bs-pagination-border-radius);
}

.page-item:last-child .page-link {
  border-top-right-radius: var(--bs-pagination-border-radius);
  border-bottom-right-radius: var(--bs-pagination-border-radius);
}

.pagination-lg {
  --bs-pagination-padding-x: 1.5rem;
  --bs-pagination-padding-y: 0.75rem;
  --bs-pagination-font-size: 1.075rem;
  --bs-pagination-border-radius: 0.625rem;
}

.pagination-sm {
  --bs-pagination-padding-x: 0.5rem;
  --bs-pagination-padding-y: 0.25rem;
  --bs-pagination-font-size: 0.95rem;
  --bs-pagination-border-radius: 0.425rem;
}

.badge {
  --bs-badge-padding-x: 0.5rem;
  --bs-badge-padding-y: 0.325rem;
  --bs-badge-font-size: 0.85rem;
  --bs-badge-font-weight: 600;
  --bs-badge-color: var(--bs-body-color);
  --bs-badge-border-radius: 0.425rem;
  display: inline-block;
  padding: var(--bs-badge-padding-y) var(--bs-badge-padding-x);
  font-size: var(--bs-badge-font-size);
  font-weight: var(--bs-badge-font-weight);
  line-height: 1;
  color: var(--bs-badge-color);
  text-align: center;
  white-space: nowrap;
  vertical-align: baseline;
  border-radius: var(--bs-badge-border-radius);
}

.badge:empty {
  display: none;
}

.btn .badge {
  position: relative;
  top: -1px;
}

.alert {
  --bs-alert-bg: transparent;
  --bs-alert-padding-x: 1rem;
  --bs-alert-padding-y: 1rem;
  --bs-alert-margin-bottom: 1rem;
  --bs-alert-color: inherit;
  --bs-alert-border-color: transparent;
  --bs-alert-border: var(--bs-border-width) solid var(--bs-alert-border-color);
  --bs-alert-border-radius: 0.475rem;
  --bs-alert-link-color: inherit;
  position: relative;
  padding: var(--bs-alert-padding-y) var(--bs-alert-padding-x);
  margin-bottom: var(--bs-alert-margin-bottom);
  color: var(--bs-alert-color);
  background-color: var(--bs-alert-bg);
  border: var(--bs-alert-border);
  border-radius: var(--bs-alert-border-radius);
}

.alert-heading {
  color: inherit;
}

.alert-link {
  font-weight: 600;
  color: var(--bs-alert-link-color);
}

.alert-dismissible {
  padding-right: 3rem;
}

.alert-dismissible .btn-close {
  position: absolute;
  top: 0;
  right: 0;
  z-index: 2;
  padding: 1.25rem 1rem;
}

.alert-light {
  --bs-alert-color: var(--bs-light-text);
  --bs-alert-bg: var(--bs-light-bg-subtle);
  --bs-alert-border-color: var(--bs-light-border-subtle);
  --bs-alert-link-color: var(--bs-light-text);
}

.alert-primary {
  --bs-alert-color: var(--bs-primary-text);
  --bs-alert-bg: var(--bs-primary-bg-subtle);
  --bs-alert-border-color: var(--bs-primary-border-subtle);
  --bs-alert-link-color: var(--bs-primary-text);
}

.alert-secondary {
  --bs-alert-color: var(--bs-secondary-text);
  --bs-alert-bg: var(--bs-secondary-bg-subtle);
  --bs-alert-border-color: var(--bs-secondary-border-subtle);
  --bs-alert-link-color: var(--bs-secondary-text);
}

.alert-success {
  --bs-alert-color: var(--bs-success-text);
  --bs-alert-bg: var(--bs-success-bg-subtle);
  --bs-alert-border-color: var(--bs-success-border-subtle);
  --bs-alert-link-color: var(--bs-success-text);
}

.alert-info {
  --bs-alert-color: var(--bs-info-text);
  --bs-alert-bg: var(--bs-info-bg-subtle);
  --bs-alert-border-color: var(--bs-info-border-subtle);
  --bs-alert-link-color: var(--bs-info-text);
}

.alert-warning {
  --bs-alert-color: var(--bs-warning-text);
  --bs-alert-bg: var(--bs-warning-bg-subtle);
  --bs-alert-border-color: var(--bs-warning-border-subtle);
  --bs-alert-link-color: var(--bs-warning-text);
}

.alert-danger {
  --bs-alert-color: var(--bs-danger-text);
  --bs-alert-bg: var(--bs-danger-bg-subtle);
  --bs-alert-border-color: var(--bs-danger-border-subtle);
  --bs-alert-link-color: var(--bs-danger-text);
}

.alert-dark {
  --bs-alert-color: var(--bs-dark-text);
  --bs-alert-bg: var(--bs-dark-bg-subtle);
  --bs-alert-border-color: var(--bs-dark-border-subtle);
  --bs-alert-link-color: var(--bs-dark-text);
}

@keyframes progress-bar-stripes {
  0% {
    background-position-x: 1rem;
  }
}
.progress,
.progress-stacked {
  --bs-progress-height: 1rem;
  --bs-progress-font-size: 0.75rem;
  --bs-progress-bg: var(--bs-gray-100);
  --bs-progress-border-radius: 6px;
  --bs-progress-box-shadow: none;
  --bs-progress-bar-color: #ffffff;
  --bs-progress-bar-bg: #009ef7;
  --bs-progress-bar-transition: width 0.6s ease;
  display: flex;
  height: var(--bs-progress-height);
  overflow: hidden;
  font-size: var(--bs-progress-font-size);
  background-color: var(--bs-progress-bg);
  border-radius: var(--bs-progress-border-radius);
  box-shadow: var(--bs-progress-box-shadow);
}

.progress-bar {
  display: flex;
  flex-direction: column;
  justify-content: center;
  overflow: hidden;
  color: var(--bs-progress-bar-color);
  text-align: center;
  white-space: nowrap;
  background-color: var(--bs-progress-bar-bg);
  transition: var(--bs-progress-bar-transition);
}

@media (prefers-reduced-motion: reduce) {
  .progress-bar {
    transition: none;
  }
}
.progress-bar-striped {
  background-image: linear-gradient(45deg, rgba(255, 255, 255, 0.15) 25%, transparent 25%, transparent 50%, rgba(255, 255, 255, 0.15) 50%, rgba(255, 255, 255, 0.15) 75%, transparent 75%, transparent);
  background-size: var(--bs-progress-height) var(--bs-progress-height);
}

.progress-stacked > .progress {
  overflow: visible;
}

.progress-stacked > .progress > .progress-bar {
  width: 100%;
}

.progress-bar-animated {
  animation: 1s linear infinite progress-bar-stripes;
}

@media (prefers-reduced-motion: reduce) {
  .progress-bar-animated {
    animation: none;
  }
}
.list-group {
  --bs-list-group-color: var(--bs-gray-900);
  --bs-list-group-bg: #ffffff;
  --bs-list-group-border-color: rgba(0, 0, 0, 0.125);
  --bs-list-group-border-width: var(--bs-border-width);
  --bs-list-group-border-radius: var(--bs-border-radius);
  --bs-list-group-item-padding-x: 1rem;
  --bs-list-group-item-padding-y: 0.5rem;
  --bs-list-group-action-color: var(--bs-gray-700);
  --bs-list-group-action-hover-color: var(--bs-gray-700);
  --bs-list-group-action-hover-bg: var(--bs-gray-100);
  --bs-list-group-action-active-color: var(--bs-body-color);
  --bs-list-group-action-active-bg: var(--bs-gray-200);
  --bs-list-group-disabled-color: var(--bs-gray-600);
  --bs-list-group-disabled-bg: #ffffff;
  --bs-list-group-active-color: var(--bs-component-active-color);
  --bs-list-group-active-bg: var(--bs-component-active-bg);
  --bs-list-group-active-border-color: var(--bs-component-active-bg);
  display: flex;
  flex-direction: column;
  padding-left: 0;
  margin-bottom: 0;
  border-radius: var(--bs-list-group-border-radius);
}

.list-group-numbered {
  list-style-type: none;
  counter-reset: section;
}

.list-group-numbered > .list-group-item::before {
  content: counters(section, ".") ". ";
  counter-increment: section;
}

.list-group-item-action {
  width: 100%;
  color: var(--bs-list-group-action-color);
  text-align: inherit;
}

.list-group-item-action:hover, .list-group-item-action:focus {
  z-index: 1;
  color: var(--bs-list-group-action-hover-color);
  text-decoration: none;
  background-color: var(--bs-list-group-action-hover-bg);
}

.list-group-item-action:active {
  color: var(--bs-list-group-action-active-color);
  background-color: var(--bs-list-group-action-active-bg);
}

.list-group-item {
  position: relative;
  display: block;
  padding: var(--bs-list-group-item-padding-y) var(--bs-list-group-item-padding-x);
  color: var(--bs-list-group-color);
  background-color: var(--bs-list-group-bg);
  border: var(--bs-list-group-border-width) solid var(--bs-list-group-border-color);
}

.list-group-item:first-child {
  border-top-left-radius: inherit;
  border-top-right-radius: inherit;
}

.list-group-item:last-child {
  border-bottom-right-radius: inherit;
  border-bottom-left-radius: inherit;
}

.list-group-item.disabled, .list-group-item:disabled {
  color: var(--bs-list-group-disabled-color);
  pointer-events: none;
  background-color: var(--bs-list-group-disabled-bg);
}

.list-group-item.active {
  z-index: 2;
  color: var(--bs-list-group-active-color);
  background-color: var(--bs-list-group-active-bg);
  border-color: var(--bs-list-group-active-border-color);
}

.list-group-item + .list-group-item {
  border-top-width: 0;
}

.list-group-item + .list-group-item.active {
  margin-top: calc(-1 * var(--bs-list-group-border-width));
  border-top-width: var(--bs-list-group-border-width);
}

.list-group-horizontal {
  flex-direction: row;
}

.list-group-horizontal > .list-group-item:first-child:not(:last-child) {
  border-bottom-left-radius: var(--bs-list-group-border-radius);
  border-top-right-radius: 0;
}

.list-group-horizontal > .list-group-item:last-child:not(:first-child) {
  border-top-right-radius: var(--bs-list-group-border-radius);
  border-bottom-left-radius: 0;
}

.list-group-horizontal > .list-group-item.active {
  margin-top: 0;
}

.list-group-horizontal > .list-group-item + .list-group-item {
  border-top-width: var(--bs-list-group-border-width);
  border-left-width: 0;
}

.list-group-horizontal > .list-group-item + .list-group-item.active {
  margin-left: calc(-1 * var(--bs-list-group-border-width));
  border-left-width: var(--bs-list-group-border-width);
}

@media (min-width: 576px) {
  .list-group-horizontal-sm {
    flex-direction: row;
  }
  .list-group-horizontal-sm > .list-group-item:first-child:not(:last-child) {
    border-bottom-left-radius: var(--bs-list-group-border-radius);
    border-top-right-radius: 0;
  }
  .list-group-horizontal-sm > .list-group-item:last-child:not(:first-child) {
    border-top-right-radius: var(--bs-list-group-border-radius);
    border-bottom-left-radius: 0;
  }
  .list-group-horizontal-sm > .list-group-item.active {
    margin-top: 0;
  }
  .list-group-horizontal-sm > .list-group-item + .list-group-item {
    border-top-width: var(--bs-list-group-border-width);
    border-left-width: 0;
  }
  .list-group-horizontal-sm > .list-group-item + .list-group-item.active {
    margin-left: calc(-1 * var(--bs-list-group-border-width));
    border-left-width: var(--bs-list-group-border-width);
  }
}
@media (min-width: 768px) {
  .list-group-horizontal-md {
    flex-direction: row;
  }
  .list-group-horizontal-md > .list-group-item:first-child:not(:last-child) {
    border-bottom-left-radius: var(--bs-list-group-border-radius);
    border-top-right-radius: 0;
  }
  .list-group-horizontal-md > .list-group-item:last-child:not(:first-child) {
    border-top-right-radius: var(--bs-list-group-border-radius);
    border-bottom-left-radius: 0;
  }
  .list-group-horizontal-md > .list-group-item.active {
    margin-top: 0;
  }
  .list-group-horizontal-md > .list-group-item + .list-group-item {
    border-top-width: var(--bs-list-group-border-width);
    border-left-width: 0;
  }
  .list-group-horizontal-md > .list-group-item + .list-group-item.active {
    margin-left: calc(-1 * var(--bs-list-group-border-width));
    border-left-width: var(--bs-list-group-border-width);
  }
}
@media (min-width: 992px) {
  .list-group-horizontal-lg {
    flex-direction: row;
  }
  .list-group-horizontal-lg > .list-group-item:first-child:not(:last-child) {
    border-bottom-left-radius: var(--bs-list-group-border-radius);
    border-top-right-radius: 0;
  }
  .list-group-horizontal-lg > .list-group-item:last-child:not(:first-child) {
    border-top-right-radius: var(--bs-list-group-border-radius);
    border-bottom-left-radius: 0;
  }
  .list-group-horizontal-lg > .list-group-item.active {
    margin-top: 0;
  }
  .list-group-horizontal-lg > .list-group-item + .list-group-item {
    border-top-width: var(--bs-list-group-border-width);
    border-left-width: 0;
  }
  .list-group-horizontal-lg > .list-group-item + .list-group-item.active {
    margin-left: calc(-1 * var(--bs-list-group-border-width));
    border-left-width: var(--bs-list-group-border-width);
  }
}
@media (min-width: 1200px) {
  .list-group-horizontal-xl {
    flex-direction: row;
  }
  .list-group-horizontal-xl > .list-group-item:first-child:not(:last-child) {
    border-bottom-left-radius: var(--bs-list-group-border-radius);
    border-top-right-radius: 0;
  }
  .list-group-horizontal-xl > .list-group-item:last-child:not(:first-child) {
    border-top-right-radius: var(--bs-list-group-border-radius);
    border-bottom-left-radius: 0;
  }
  .list-group-horizontal-xl > .list-group-item.active {
    margin-top: 0;
  }
  .list-group-horizontal-xl > .list-group-item + .list-group-item {
    border-top-width: var(--bs-list-group-border-width);
    border-left-width: 0;
  }
  .list-group-horizontal-xl > .list-group-item + .list-group-item.active {
    margin-left: calc(-1 * var(--bs-list-group-border-width));
    border-left-width: var(--bs-list-group-border-width);
  }
}
@media (min-width: 1400px) {
  .list-group-horizontal-xxl {
    flex-direction: row;
  }
  .list-group-horizontal-xxl > .list-group-item:first-child:not(:last-child) {
    border-bottom-left-radius: var(--bs-list-group-border-radius);
    border-top-right-radius: 0;
  }
  .list-group-horizontal-xxl > .list-group-item:last-child:not(:first-child) {
    border-top-right-radius: var(--bs-list-group-border-radius);
    border-bottom-left-radius: 0;
  }
  .list-group-horizontal-xxl > .list-group-item.active {
    margin-top: 0;
  }
  .list-group-horizontal-xxl > .list-group-item + .list-group-item {
    border-top-width: var(--bs-list-group-border-width);
    border-left-width: 0;
  }
  .list-group-horizontal-xxl > .list-group-item + .list-group-item.active {
    margin-left: calc(-1 * var(--bs-list-group-border-width));
    border-left-width: var(--bs-list-group-border-width);
  }
}
.list-group-flush {
  border-radius: 0;
}

.list-group-flush > .list-group-item {
  border-width: 0 0 var(--bs-list-group-border-width);
}

.list-group-flush > .list-group-item:last-child {
  border-bottom-width: 0;
}

.list-group-item-light {
  --bs-list-group-color: var(--bs-light-text);
  --bs-list-group-bg: var(--bs-light-bg-subtle);
  --bs-list-group-border-color: var(--bs-light-border-subtle);
}

.list-group-item-light.list-group-item-action:hover, .list-group-item-light.list-group-item-action:focus {
  --bs-list-group-action-hover-color: var(--bs-emphasis-color);
  --bs-list-group-action-hover-bg: var(--bs-light-border-subtle);
}

.list-group-item-light.list-group-item-action:active {
  --bs-list-group-active-color: var(--bs-emphasis-color);
  --bs-list-group-active-bg: var(--bs-light-text);
  --bs-list-group-active-border-color: var(--bs-light-text);
}

.list-group-item-primary {
  --bs-list-group-color: var(--bs-primary-text);
  --bs-list-group-bg: var(--bs-primary-bg-subtle);
  --bs-list-group-border-color: var(--bs-primary-border-subtle);
}

.list-group-item-primary.list-group-item-action:hover, .list-group-item-primary.list-group-item-action:focus {
  --bs-list-group-action-hover-color: var(--bs-emphasis-color);
  --bs-list-group-action-hover-bg: var(--bs-primary-border-subtle);
}

.list-group-item-primary.list-group-item-action:active {
  --bs-list-group-active-color: var(--bs-emphasis-color);
  --bs-list-group-active-bg: var(--bs-primary-text);
  --bs-list-group-active-border-color: var(--bs-primary-text);
}

.list-group-item-secondary {
  --bs-list-group-color: var(--bs-secondary-text);
  --bs-list-group-bg: var(--bs-secondary-bg-subtle);
  --bs-list-group-border-color: var(--bs-secondary-border-subtle);
}

.list-group-item-secondary.list-group-item-action:hover, .list-group-item-secondary.list-group-item-action:focus {
  --bs-list-group-action-hover-color: var(--bs-emphasis-color);
  --bs-list-group-action-hover-bg: var(--bs-secondary-border-subtle);
}

.list-group-item-secondary.list-group-item-action:active {
  --bs-list-group-active-color: var(--bs-emphasis-color);
  --bs-list-group-active-bg: var(--bs-secondary-text);
  --bs-list-group-active-border-color: var(--bs-secondary-text);
}

.list-group-item-success {
  --bs-list-group-color: var(--bs-success-text);
  --bs-list-group-bg: var(--bs-success-bg-subtle);
  --bs-list-group-border-color: var(--bs-success-border-subtle);
}

.list-group-item-success.list-group-item-action:hover, .list-group-item-success.list-group-item-action:focus {
  --bs-list-group-action-hover-color: var(--bs-emphasis-color);
  --bs-list-group-action-hover-bg: var(--bs-success-border-subtle);
}

.list-group-item-success.list-group-item-action:active {
  --bs-list-group-active-color: var(--bs-emphasis-color);
  --bs-list-group-active-bg: var(--bs-success-text);
  --bs-list-group-active-border-color: var(--bs-success-text);
}

.list-group-item-info {
  --bs-list-group-color: var(--bs-info-text);
  --bs-list-group-bg: var(--bs-info-bg-subtle);
  --bs-list-group-border-color: var(--bs-info-border-subtle);
}

.list-group-item-info.list-group-item-action:hover, .list-group-item-info.list-group-item-action:focus {
  --bs-list-group-action-hover-color: var(--bs-emphasis-color);
  --bs-list-group-action-hover-bg: var(--bs-info-border-subtle);
}

.list-group-item-info.list-group-item-action:active {
  --bs-list-group-active-color: var(--bs-emphasis-color);
  --bs-list-group-active-bg: var(--bs-info-text);
  --bs-list-group-active-border-color: var(--bs-info-text);
}

.list-group-item-warning {
  --bs-list-group-color: var(--bs-warning-text);
  --bs-list-group-bg: var(--bs-warning-bg-subtle);
  --bs-list-group-border-color: var(--bs-warning-border-subtle);
}

.list-group-item-warning.list-group-item-action:hover, .list-group-item-warning.list-group-item-action:focus {
  --bs-list-group-action-hover-color: var(--bs-emphasis-color);
  --bs-list-group-action-hover-bg: var(--bs-warning-border-subtle);
}

.list-group-item-warning.list-group-item-action:active {
  --bs-list-group-active-color: var(--bs-emphasis-color);
  --bs-list-group-active-bg: var(--bs-warning-text);
  --bs-list-group-active-border-color: var(--bs-warning-text);
}

.list-group-item-danger {
  --bs-list-group-color: var(--bs-danger-text);
  --bs-list-group-bg: var(--bs-danger-bg-subtle);
  --bs-list-group-border-color: var(--bs-danger-border-subtle);
}

.list-group-item-danger.list-group-item-action:hover, .list-group-item-danger.list-group-item-action:focus {
  --bs-list-group-action-hover-color: var(--bs-emphasis-color);
  --bs-list-group-action-hover-bg: var(--bs-danger-border-subtle);
}

.list-group-item-danger.list-group-item-action:active {
  --bs-list-group-active-color: var(--bs-emphasis-color);
  --bs-list-group-active-bg: var(--bs-danger-text);
  --bs-list-group-active-border-color: var(--bs-danger-text);
}

.list-group-item-dark {
  --bs-list-group-color: var(--bs-dark-text);
  --bs-list-group-bg: var(--bs-dark-bg-subtle);
  --bs-list-group-border-color: var(--bs-dark-border-subtle);
}

.list-group-item-dark.list-group-item-action:hover, .list-group-item-dark.list-group-item-action:focus {
  --bs-list-group-action-hover-color: var(--bs-emphasis-color);
  --bs-list-group-action-hover-bg: var(--bs-dark-border-subtle);
}

.list-group-item-dark.list-group-item-action:active {
  --bs-list-group-active-color: var(--bs-emphasis-color);
  --bs-list-group-active-bg: var(--bs-dark-text);
  --bs-list-group-active-border-color: var(--bs-dark-text);
}

.btn-close {
  --bs-btn-close-color: #000000;
  --bs-btn-close-bg: url(${___CSS_LOADER_URL_REPLACEMENT_15___});
  --bs-btn-close-opacity: 0.5;
  --bs-btn-close-hover-opacity: 0.75;
  --bs-btn-close-focus-shadow: none;
  --bs-btn-close-focus-opacity: 1;
  --bs-btn-close-disabled-opacity: 0.25;
  --bs-btn-close-white-filter: invert(1) grayscale(100%) brightness(200%);
  box-sizing: content-box;
  width: 0.75rem;
  height: 0.75rem;
  padding: 0.25em 0.25em;
  color: var(--bs-btn-close-color);
  background: transparent var(--bs-btn-close-bg) center/0.75rem auto no-repeat;
  border: 0;
  border-radius: 0.475rem;
  opacity: var(--bs-btn-close-opacity);
}

.btn-close:hover {
  color: var(--bs-btn-close-color);
  text-decoration: none;
  opacity: var(--bs-btn-close-hover-opacity);
}

.btn-close:focus {
  outline: 0;
  box-shadow: var(--bs-btn-close-focus-shadow);
  opacity: var(--bs-btn-close-focus-opacity);
}

.btn-close:disabled, .btn-close.disabled {
  pointer-events: none;
  -webkit-user-select: none;
          user-select: none;
  opacity: var(--bs-btn-close-disabled-opacity);
}

.btn-close-white {
  filter: var(--bs-btn-close-white-filter);
}

[data-bs-theme=dark] .btn-close {
  filter: var(--bs-btn-close-white-filter);
}

.toast {
  --bs-toast-zindex: 1090;
  --bs-toast-padding-x: 0.75rem;
  --bs-toast-padding-y: 0.5rem;
  --bs-toast-spacing: 1.5rem;
  --bs-toast-max-width: 350px;
  --bs-toast-font-size: 0.875rem;
  --bs-toast-color: var(--bs-gray-700);
  --bs-toast-bg: var(--bs-body-bg);
  --bs-toast-border-width: var(--bs-border-width);
  --bs-toast-border-color: transparent;
  --bs-toast-border-radius: var(--bs-border-radius);
  --bs-toast-box-shadow: var(--bs-box-shadow);
  --bs-toast-header-color: var(--bs-gray-700);
  --bs-toast-header-bg: var(--bs-body-bg);
  --bs-toast-header-border-color: var(--bs-border-color);
  width: var(--bs-toast-max-width);
  max-width: 100%;
  font-size: var(--bs-toast-font-size);
  color: var(--bs-toast-color);
  pointer-events: auto;
  background-color: var(--bs-toast-bg);
  background-clip: padding-box;
  border: var(--bs-toast-border-width) solid var(--bs-toast-border-color);
  box-shadow: var(--bs-toast-box-shadow);
  border-radius: var(--bs-toast-border-radius);
}

.toast.showing {
  opacity: 0;
}

.toast:not(.show) {
  display: none;
}

.toast-container {
  --bs-toast-zindex: 1090;
  position: absolute;
  z-index: var(--bs-toast-zindex);
  width: max-content;
  max-width: 100%;
  pointer-events: none;
}

.toast-container > :not(:last-child) {
  margin-bottom: var(--bs-toast-spacing);
}

.toast-header {
  display: flex;
  align-items: center;
  padding: var(--bs-toast-padding-y) var(--bs-toast-padding-x);
  color: var(--bs-toast-header-color);
  background-color: var(--bs-toast-header-bg);
  background-clip: padding-box;
  border-bottom: var(--bs-toast-border-width) solid var(--bs-toast-header-border-color);
  border-top-left-radius: calc(var(--bs-toast-border-radius) - var(--bs-toast-border-width));
  border-top-right-radius: calc(var(--bs-toast-border-radius) - var(--bs-toast-border-width));
}

.toast-header .btn-close {
  margin-right: calc(-0.5 * var(--bs-toast-padding-x));
  margin-left: var(--bs-toast-padding-x);
}

.toast-body {
  padding: var(--bs-toast-padding-x);
  word-wrap: break-word;
}

.modal {
  --bs-modal-zindex: 1055;
  --bs-modal-width: 500px;
  --bs-modal-padding: 1.75rem;
  --bs-modal-margin: 0.5rem;
  --bs-modal-color: ;
  --bs-modal-bg: var(--bs-body-bg);
  --bs-modal-border-color: var(--bs-border-color-translucent);
  --bs-modal-border-width: 0;
  --bs-modal-border-radius: 0.475rem;
  --bs-modal-box-shadow: 0 0.25rem 0.5rem rgba(0, 0, 0, 0.1);
  --bs-modal-inner-border-radius: 0.475rem;
  --bs-modal-header-padding-x: 1.75rem;
  --bs-modal-header-padding-y: 1.75rem;
  --bs-modal-header-padding: 1.75rem 1.75rem;
  --bs-modal-header-border-color: var(--bs-border-color);
  --bs-modal-header-border-width: 1px;
  --bs-modal-title-line-height: 1.5;
  --bs-modal-footer-gap: 0.5rem;
  --bs-modal-footer-bg: ;
  --bs-modal-footer-border-color: var(--bs-border-color);
  --bs-modal-footer-border-width: 1px;
  position: fixed;
  top: 0;
  left: 0;
  z-index: var(--bs-modal-zindex);
  display: none;
  width: 100%;
  height: 100%;
  overflow-x: hidden;
  overflow-y: auto;
  outline: 0;
}

.modal-dialog {
  position: relative;
  width: auto;
  margin: var(--bs-modal-margin);
  pointer-events: none;
}

.modal.fade .modal-dialog {
  transition: transform 0.3s ease-out;
  transform: translate(0, -50px);
}

@media (prefers-reduced-motion: reduce) {
  .modal.fade .modal-dialog {
    transition: none;
  }
}
.modal.show .modal-dialog {
  transform: none;
}

.modal.modal-static .modal-dialog {
  transform: scale(1.02);
}

.modal-dialog-scrollable {
  height: calc(100% - var(--bs-modal-margin) * 2);
}

.modal-dialog-scrollable .modal-content {
  max-height: 100%;
  overflow: hidden;
}

.modal-dialog-scrollable .modal-body {
  overflow-y: auto;
}

.modal-dialog-centered {
  display: flex;
  align-items: center;
  min-height: calc(100% - var(--bs-modal-margin) * 2);
}

.modal-content {
  position: relative;
  display: flex;
  flex-direction: column;
  width: 100%;
  color: var(--bs-modal-color);
  pointer-events: auto;
  background-color: var(--bs-modal-bg);
  background-clip: padding-box;
  border: var(--bs-modal-border-width) solid var(--bs-modal-border-color);
  border-radius: var(--bs-modal-border-radius);
  box-shadow: var(--bs-modal-box-shadow);
  outline: 0;
}

.modal-backdrop {
  --bs-backdrop-zindex: 1050;
  --bs-backdrop-bg: #000000;
  --bs-backdrop-opacity: 0.4;
  position: fixed;
  top: 0;
  left: 0;
  z-index: var(--bs-backdrop-zindex);
  width: 100vw;
  height: 100vh;
  background-color: var(--bs-backdrop-bg);
}

.modal-backdrop.fade {
  opacity: 0;
}

.modal-backdrop.show {
  opacity: var(--bs-backdrop-opacity);
}

.modal-header {
  display: flex;
  flex-shrink: 0;
  align-items: center;
  justify-content: space-between;
  padding: var(--bs-modal-header-padding);
  border-bottom: var(--bs-modal-header-border-width) solid var(--bs-modal-header-border-color);
  border-top-left-radius: var(--bs-modal-inner-border-radius);
  border-top-right-radius: var(--bs-modal-inner-border-radius);
}

.modal-header .btn-close {
  padding: calc(var(--bs-modal-header-padding-y) * 0.5) calc(var(--bs-modal-header-padding-x) * 0.5);
  margin: calc(-0.5 * var(--bs-modal-header-padding-y)) calc(-0.5 * var(--bs-modal-header-padding-x)) calc(-0.5 * var(--bs-modal-header-padding-y)) auto;
}

.modal-title {
  margin-bottom: 0;
  line-height: var(--bs-modal-title-line-height);
}

.modal-body {
  position: relative;
  flex: 1 1 auto;
  padding: var(--bs-modal-padding);
}

.modal-footer {
  display: flex;
  flex-shrink: 0;
  flex-wrap: wrap;
  align-items: center;
  justify-content: flex-end;
  padding: calc(var(--bs-modal-padding) - var(--bs-modal-footer-gap) * 0.5);
  background-color: var(--bs-modal-footer-bg);
  border-top: var(--bs-modal-footer-border-width) solid var(--bs-modal-footer-border-color);
  border-bottom-right-radius: var(--bs-modal-inner-border-radius);
  border-bottom-left-radius: var(--bs-modal-inner-border-radius);
}

.modal-footer > * {
  margin: calc(var(--bs-modal-footer-gap) * 0.5);
}

@media (min-width: 576px) {
  .modal {
    --bs-modal-margin: 1.75rem;
    --bs-modal-box-shadow: 0 0.5rem 1rem rgba(0, 0, 0, 0.1);
  }
  .modal-dialog {
    max-width: var(--bs-modal-width);
    margin-right: auto;
    margin-left: auto;
  }
  .modal-sm {
    --bs-modal-width: 300px;
  }
}
@media (min-width: 992px) {
  .modal-lg,
  .modal-xl {
    --bs-modal-width: 800px;
  }
}
@media (min-width: 1200px) {
  .modal-xl {
    --bs-modal-width: 1140px;
  }
}
.modal-fullscreen {
  width: 100vw;
  max-width: none;
  height: 100%;
  margin: 0;
}

.modal-fullscreen .modal-content {
  height: 100%;
  border: 0;
  border-radius: 0;
}

.modal-fullscreen .modal-header,
.modal-fullscreen .modal-footer {
  border-radius: 0;
}

.modal-fullscreen .modal-body {
  overflow-y: auto;
}

@media (max-width: 575.98px) {
  .modal-fullscreen-sm-down {
    width: 100vw;
    max-width: none;
    height: 100%;
    margin: 0;
  }
  .modal-fullscreen-sm-down .modal-content {
    height: 100%;
    border: 0;
    border-radius: 0;
  }
  .modal-fullscreen-sm-down .modal-header,
  .modal-fullscreen-sm-down .modal-footer {
    border-radius: 0;
  }
  .modal-fullscreen-sm-down .modal-body {
    overflow-y: auto;
  }
}
@media (max-width: 767.98px) {
  .modal-fullscreen-md-down {
    width: 100vw;
    max-width: none;
    height: 100%;
    margin: 0;
  }
  .modal-fullscreen-md-down .modal-content {
    height: 100%;
    border: 0;
    border-radius: 0;
  }
  .modal-fullscreen-md-down .modal-header,
  .modal-fullscreen-md-down .modal-footer {
    border-radius: 0;
  }
  .modal-fullscreen-md-down .modal-body {
    overflow-y: auto;
  }
}
@media (max-width: 991.98px) {
  .modal-fullscreen-lg-down {
    width: 100vw;
    max-width: none;
    height: 100%;
    margin: 0;
  }
  .modal-fullscreen-lg-down .modal-content {
    height: 100%;
    border: 0;
    border-radius: 0;
  }
  .modal-fullscreen-lg-down .modal-header,
  .modal-fullscreen-lg-down .modal-footer {
    border-radius: 0;
  }
  .modal-fullscreen-lg-down .modal-body {
    overflow-y: auto;
  }
}
@media (max-width: 1199.98px) {
  .modal-fullscreen-xl-down {
    width: 100vw;
    max-width: none;
    height: 100%;
    margin: 0;
  }
  .modal-fullscreen-xl-down .modal-content {
    height: 100%;
    border: 0;
    border-radius: 0;
  }
  .modal-fullscreen-xl-down .modal-header,
  .modal-fullscreen-xl-down .modal-footer {
    border-radius: 0;
  }
  .modal-fullscreen-xl-down .modal-body {
    overflow-y: auto;
  }
}
@media (max-width: 1399.98px) {
  .modal-fullscreen-xxl-down {
    width: 100vw;
    max-width: none;
    height: 100%;
    margin: 0;
  }
  .modal-fullscreen-xxl-down .modal-content {
    height: 100%;
    border: 0;
    border-radius: 0;
  }
  .modal-fullscreen-xxl-down .modal-header,
  .modal-fullscreen-xxl-down .modal-footer {
    border-radius: 0;
  }
  .modal-fullscreen-xxl-down .modal-body {
    overflow-y: auto;
  }
}
.tooltip {
  --bs-tooltip-zindex: 1080;
  --bs-tooltip-max-width: 200px;
  --bs-tooltip-padding-x: 1rem;
  --bs-tooltip-padding-y: 0.75rem;
  --bs-tooltip-margin: 0;
  --bs-tooltip-font-size: 1rem;
  --bs-tooltip-color: var(--bs-gray-800);
  --bs-tooltip-bg: var(--bs-body-bg);
  --bs-tooltip-border-radius: 0.475rem;
  --bs-tooltip-opacity: 1;
  --bs-tooltip-arrow-width: 0.8rem;
  --bs-tooltip-arrow-height: 0.4rem;
  z-index: var(--bs-tooltip-zindex);
  display: block;
  padding: var(--bs-tooltip-arrow-height);
  margin: var(--bs-tooltip-margin);
  font-family: var(--bs-font-sans-serif);
  font-style: normal;
  font-weight: 400;
  line-height: 1.5;
  text-align: left;
  text-align: start;
  text-decoration: none;
  text-shadow: none;
  text-transform: none;
  letter-spacing: normal;
  word-break: normal;
  white-space: normal;
  word-spacing: normal;
  line-break: auto;
  font-size: var(--bs-tooltip-font-size);
  word-wrap: break-word;
  opacity: 0;
}

.tooltip.show {
  opacity: var(--bs-tooltip-opacity);
}

.tooltip .tooltip-arrow {
  display: block;
  width: var(--bs-tooltip-arrow-width);
  height: var(--bs-tooltip-arrow-height);
}

.tooltip .tooltip-arrow::before {
  position: absolute;
  content: "";
  border-color: transparent;
  border-style: solid;
}

.bs-tooltip-top .tooltip-arrow, .bs-tooltip-auto[data-popper-placement^=top] .tooltip-arrow {
  bottom: 0;
}

.bs-tooltip-top .tooltip-arrow::before, .bs-tooltip-auto[data-popper-placement^=top] .tooltip-arrow::before {
  top: -1px;
  border-width: var(--bs-tooltip-arrow-height) calc(var(--bs-tooltip-arrow-width) * 0.5) 0;
  border-top-color: var(--bs-tooltip-bg);
}

/* rtl:begin:ignore */
.bs-tooltip-end .tooltip-arrow, .bs-tooltip-auto[data-popper-placement^=right] .tooltip-arrow {
  left: 0;
  width: var(--bs-tooltip-arrow-height);
  height: var(--bs-tooltip-arrow-width);
}

.bs-tooltip-end .tooltip-arrow::before, .bs-tooltip-auto[data-popper-placement^=right] .tooltip-arrow::before {
  right: -1px;
  border-width: calc(var(--bs-tooltip-arrow-width) * 0.5) var(--bs-tooltip-arrow-height) calc(var(--bs-tooltip-arrow-width) * 0.5) 0;
  border-right-color: var(--bs-tooltip-bg);
}

/* rtl:end:ignore */
.bs-tooltip-bottom .tooltip-arrow, .bs-tooltip-auto[data-popper-placement^=bottom] .tooltip-arrow {
  top: 0;
}

.bs-tooltip-bottom .tooltip-arrow::before, .bs-tooltip-auto[data-popper-placement^=bottom] .tooltip-arrow::before {
  bottom: -1px;
  border-width: 0 calc(var(--bs-tooltip-arrow-width) * 0.5) var(--bs-tooltip-arrow-height);
  border-bottom-color: var(--bs-tooltip-bg);
}

/* rtl:begin:ignore */
.bs-tooltip-start .tooltip-arrow, .bs-tooltip-auto[data-popper-placement^=left] .tooltip-arrow {
  right: 0;
  width: var(--bs-tooltip-arrow-height);
  height: var(--bs-tooltip-arrow-width);
}

.bs-tooltip-start .tooltip-arrow::before, .bs-tooltip-auto[data-popper-placement^=left] .tooltip-arrow::before {
  left: -1px;
  border-width: calc(var(--bs-tooltip-arrow-width) * 0.5) 0 calc(var(--bs-tooltip-arrow-width) * 0.5) var(--bs-tooltip-arrow-height);
  border-left-color: var(--bs-tooltip-bg);
}

/* rtl:end:ignore */
.tooltip-inner {
  max-width: var(--bs-tooltip-max-width);
  padding: var(--bs-tooltip-padding-y) var(--bs-tooltip-padding-x);
  color: var(--bs-tooltip-color);
  text-align: center;
  background-color: var(--bs-tooltip-bg);
  border-radius: var(--bs-tooltip-border-radius);
}

.popover {
  --bs-popover-zindex: 1070;
  --bs-popover-max-width: 276px;
  --bs-popover-font-size: 1rem;
  --bs-popover-bg: #ffffff;
  --bs-popover-border-width: var(--bs-border-width);
  --bs-popover-border-color: #ffffff;
  --bs-popover-border-radius: 0.475rem;
  --bs-popover-inner-border-radius: 0.475rem;
  --bs-popover-box-shadow: 0px 0px 50px 0px rgba(82, 63, 105, 0.15);
  --bs-popover-header-padding-x: 1.25rem;
  --bs-popover-header-padding-y: 1rem;
  --bs-popover-header-font-size: 1rem;
  --bs-popover-header-color: var(--bs-gray-800);
  --bs-popover-header-bg: #ffffff;
  --bs-popover-body-padding-x: 1.25rem;
  --bs-popover-body-padding-y: 1.25rem;
  --bs-popover-body-color: var(--bs-gray-800);
  --bs-popover-arrow-width: 1rem;
  --bs-popover-arrow-height: 0.5rem;
  --bs-popover-arrow-border: var(--bs-popover-border-color);
  z-index: var(--bs-popover-zindex);
  display: block;
  max-width: var(--bs-popover-max-width);
  font-family: var(--bs-font-sans-serif);
  font-style: normal;
  font-weight: 400;
  line-height: 1.5;
  text-align: left;
  text-align: start;
  text-decoration: none;
  text-shadow: none;
  text-transform: none;
  letter-spacing: normal;
  word-break: normal;
  white-space: normal;
  word-spacing: normal;
  line-break: auto;
  font-size: var(--bs-popover-font-size);
  word-wrap: break-word;
  background-color: var(--bs-popover-bg);
  background-clip: padding-box;
  border: var(--bs-popover-border-width) solid var(--bs-popover-border-color);
  border-radius: var(--bs-popover-border-radius);
  box-shadow: var(--bs-popover-box-shadow);
}

.popover .popover-arrow {
  display: block;
  width: var(--bs-popover-arrow-width);
  height: var(--bs-popover-arrow-height);
}

.popover .popover-arrow::before, .popover .popover-arrow::after {
  position: absolute;
  display: block;
  content: "";
  border-color: transparent;
  border-style: solid;
  border-width: 0;
}

.bs-popover-top > .popover-arrow, .bs-popover-auto[data-popper-placement^=top] > .popover-arrow {
  bottom: calc(-1 * (var(--bs-popover-arrow-height)) - var(--bs-popover-border-width));
}

.bs-popover-top > .popover-arrow::before, .bs-popover-auto[data-popper-placement^=top] > .popover-arrow::before, .bs-popover-top > .popover-arrow::after, .bs-popover-auto[data-popper-placement^=top] > .popover-arrow::after {
  border-width: var(--bs-popover-arrow-height) calc(var(--bs-popover-arrow-width) * 0.5) 0;
}

.bs-popover-top > .popover-arrow::before, .bs-popover-auto[data-popper-placement^=top] > .popover-arrow::before {
  bottom: 0;
  border-top-color: var(--bs-popover-arrow-border);
}

.bs-popover-top > .popover-arrow::after, .bs-popover-auto[data-popper-placement^=top] > .popover-arrow::after {
  bottom: var(--bs-popover-border-width);
  border-top-color: var(--bs-popover-bg);
}

/* rtl:begin:ignore */
.bs-popover-end > .popover-arrow, .bs-popover-auto[data-popper-placement^=right] > .popover-arrow {
  left: calc(-1 * (var(--bs-popover-arrow-height)) - var(--bs-popover-border-width));
  width: var(--bs-popover-arrow-height);
  height: var(--bs-popover-arrow-width);
}

.bs-popover-end > .popover-arrow::before, .bs-popover-auto[data-popper-placement^=right] > .popover-arrow::before, .bs-popover-end > .popover-arrow::after, .bs-popover-auto[data-popper-placement^=right] > .popover-arrow::after {
  border-width: calc(var(--bs-popover-arrow-width) * 0.5) var(--bs-popover-arrow-height) calc(var(--bs-popover-arrow-width) * 0.5) 0;
}

.bs-popover-end > .popover-arrow::before, .bs-popover-auto[data-popper-placement^=right] > .popover-arrow::before {
  left: 0;
  border-right-color: var(--bs-popover-arrow-border);
}

.bs-popover-end > .popover-arrow::after, .bs-popover-auto[data-popper-placement^=right] > .popover-arrow::after {
  left: var(--bs-popover-border-width);
  border-right-color: var(--bs-popover-bg);
}

/* rtl:end:ignore */
.bs-popover-bottom > .popover-arrow, .bs-popover-auto[data-popper-placement^=bottom] > .popover-arrow {
  top: calc(-1 * (var(--bs-popover-arrow-height)) - var(--bs-popover-border-width));
}

.bs-popover-bottom > .popover-arrow::before, .bs-popover-auto[data-popper-placement^=bottom] > .popover-arrow::before, .bs-popover-bottom > .popover-arrow::after, .bs-popover-auto[data-popper-placement^=bottom] > .popover-arrow::after {
  border-width: 0 calc(var(--bs-popover-arrow-width) * 0.5) var(--bs-popover-arrow-height);
}

.bs-popover-bottom > .popover-arrow::before, .bs-popover-auto[data-popper-placement^=bottom] > .popover-arrow::before {
  top: 0;
  border-bottom-color: var(--bs-popover-arrow-border);
}

.bs-popover-bottom > .popover-arrow::after, .bs-popover-auto[data-popper-placement^=bottom] > .popover-arrow::after {
  top: var(--bs-popover-border-width);
  border-bottom-color: var(--bs-popover-bg);
}

.bs-popover-bottom .popover-header::before, .bs-popover-auto[data-popper-placement^=bottom] .popover-header::before {
  position: absolute;
  top: 0;
  left: 50%;
  display: block;
  width: var(--bs-popover-arrow-width);
  margin-left: calc(-0.5 * var(--bs-popover-arrow-width));
  content: "";
  border-bottom: var(--bs-popover-border-width) solid var(--bs-popover-header-bg);
}

/* rtl:begin:ignore */
.bs-popover-start > .popover-arrow, .bs-popover-auto[data-popper-placement^=left] > .popover-arrow {
  right: calc(-1 * (var(--bs-popover-arrow-height)) - var(--bs-popover-border-width));
  width: var(--bs-popover-arrow-height);
  height: var(--bs-popover-arrow-width);
}

.bs-popover-start > .popover-arrow::before, .bs-popover-auto[data-popper-placement^=left] > .popover-arrow::before, .bs-popover-start > .popover-arrow::after, .bs-popover-auto[data-popper-placement^=left] > .popover-arrow::after {
  border-width: calc(var(--bs-popover-arrow-width) * 0.5) 0 calc(var(--bs-popover-arrow-width) * 0.5) var(--bs-popover-arrow-height);
}

.bs-popover-start > .popover-arrow::before, .bs-popover-auto[data-popper-placement^=left] > .popover-arrow::before {
  right: 0;
  border-left-color: var(--bs-popover-arrow-border);
}

.bs-popover-start > .popover-arrow::after, .bs-popover-auto[data-popper-placement^=left] > .popover-arrow::after {
  right: var(--bs-popover-border-width);
  border-left-color: var(--bs-popover-bg);
}

/* rtl:end:ignore */
.popover-header {
  padding: var(--bs-popover-header-padding-y) var(--bs-popover-header-padding-x);
  margin-bottom: 0;
  font-size: var(--bs-popover-header-font-size);
  color: var(--bs-popover-header-color);
  background-color: var(--bs-popover-header-bg);
  border-bottom: var(--bs-popover-border-width) solid var(--bs-popover-border-color);
  border-top-left-radius: var(--bs-popover-inner-border-radius);
  border-top-right-radius: var(--bs-popover-inner-border-radius);
}

.popover-header:empty {
  display: none;
}

.popover-body {
  padding: var(--bs-popover-body-padding-y) var(--bs-popover-body-padding-x);
  color: var(--bs-popover-body-color);
}

.carousel {
  position: relative;
}

.carousel.pointer-event {
  touch-action: pan-y;
}

.carousel-inner {
  position: relative;
  width: 100%;
  overflow: hidden;
}

.carousel-inner::after {
  display: block;
  clear: both;
  content: "";
}

.carousel-item {
  position: relative;
  display: none;
  float: left;
  width: 100%;
  margin-right: -100%;
  backface-visibility: hidden;
  transition: transform 0.6s ease-in-out;
}

@media (prefers-reduced-motion: reduce) {
  .carousel-item {
    transition: none;
  }
}
.carousel-item.active,
.carousel-item-next,
.carousel-item-prev {
  display: block;
}

.carousel-item-next:not(.carousel-item-start),
.active.carousel-item-end {
  transform: translateX(100%);
}

.carousel-item-prev:not(.carousel-item-end),
.active.carousel-item-start {
  transform: translateX(-100%);
}

.carousel-fade .carousel-item {
  opacity: 0;
  transition-property: opacity;
  transform: none;
}

.carousel-fade .carousel-item.active,
.carousel-fade .carousel-item-next.carousel-item-start,
.carousel-fade .carousel-item-prev.carousel-item-end {
  z-index: 1;
  opacity: 1;
}

.carousel-fade .active.carousel-item-start,
.carousel-fade .active.carousel-item-end {
  z-index: 0;
  opacity: 0;
  transition: opacity 0s 0.6s;
}

@media (prefers-reduced-motion: reduce) {
  .carousel-fade .active.carousel-item-start,
  .carousel-fade .active.carousel-item-end {
    transition: none;
  }
}
.carousel-control-prev,
.carousel-control-next {
  position: absolute;
  top: 0;
  bottom: 0;
  z-index: 1;
  display: flex;
  align-items: center;
  justify-content: center;
  width: 15%;
  padding: 0;
  color: #ffffff;
  text-align: center;
  background: none;
  border: 0;
  opacity: 0.5;
  transition: opacity 0.15s ease;
}

@media (prefers-reduced-motion: reduce) {
  .carousel-control-prev,
  .carousel-control-next {
    transition: none;
  }
}
.carousel-control-prev:hover, .carousel-control-prev:focus,
.carousel-control-next:hover,
.carousel-control-next:focus {
  color: #ffffff;
  text-decoration: none;
  outline: 0;
  opacity: 0.9;
}

.carousel-control-prev {
  left: 0;
}

.carousel-control-next {
  right: 0;
}

.carousel-control-prev-icon,
.carousel-control-next-icon {
  display: inline-block;
  width: 2rem;
  height: 2rem;
  background-repeat: no-repeat;
  background-position: 50%;
  background-size: 100% 100%;
}

/* rtl:options: {
  "autoRename": true,
  "stringMap":[ {
    "name"    : "prev-next",
    "search"  : "prev",
    "replace" : "next"
  } ]
} */
.carousel-control-prev-icon {
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_16___});
}

.carousel-control-next-icon {
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_17___});
}

.carousel-indicators {
  position: absolute;
  right: 0;
  bottom: 0;
  left: 0;
  z-index: 2;
  display: flex;
  justify-content: center;
  padding: 0;
  margin-right: 15%;
  margin-bottom: 1rem;
  margin-left: 15%;
  list-style: none;
}

.carousel-indicators [data-bs-target] {
  box-sizing: content-box;
  flex: 0 1 auto;
  width: 30px;
  height: 3px;
  padding: 0;
  margin-right: 3px;
  margin-left: 3px;
  text-indent: -999px;
  cursor: pointer;
  background-color: #ffffff;
  background-clip: padding-box;
  border: 0;
  border-top: 10px solid transparent;
  border-bottom: 10px solid transparent;
  opacity: 0.5;
  transition: opacity 0.6s ease;
}

@media (prefers-reduced-motion: reduce) {
  .carousel-indicators [data-bs-target] {
    transition: none;
  }
}
.carousel-indicators .active {
  opacity: 1;
}

.carousel-caption {
  position: absolute;
  right: 15%;
  bottom: 1.25rem;
  left: 15%;
  padding-top: 1.25rem;
  padding-bottom: 1.25rem;
  color: #ffffff;
  text-align: center;
}

.carousel-dark .carousel-control-prev-icon,
.carousel-dark .carousel-control-next-icon {
  filter: invert(1) grayscale(100);
}

.carousel-dark .carousel-indicators [data-bs-target] {
  background-color: #000000;
}

.carousel-dark .carousel-caption {
  color: #000000;
}

[data-bs-theme=dark] .carousel .carousel-control-prev-icon,
[data-bs-theme=dark] .carousel .carousel-control-next-icon {
  filter: invert(1) grayscale(100);
}

[data-bs-theme=dark] .carousel .carousel-indicators [data-bs-target] {
  background-color: #000000;
}

[data-bs-theme=dark] .carousel .carousel-caption {
  color: #000000;
}

.spinner-grow,
.spinner-border {
  display: inline-block;
  width: var(--bs-spinner-width);
  height: var(--bs-spinner-height);
  vertical-align: var(--bs-spinner-vertical-align);
  border-radius: 50%;
  animation: var(--bs-spinner-animation-speed) linear infinite var(--bs-spinner-animation-name);
}

@keyframes spinner-border {
  to {
    transform: rotate(360deg);
  }
}
.spinner-border {
  --bs-spinner-width: 2rem;
  --bs-spinner-height: 2rem;
  --bs-spinner-vertical-align: -0.125em;
  --bs-spinner-border-width: 0.185rem;
  --bs-spinner-animation-speed: 0.65s;
  --bs-spinner-animation-name: spinner-border;
  border: var(--bs-spinner-border-width) solid currentcolor;
  border-right-color: transparent;
}

.spinner-border-sm {
  --bs-spinner-width: 1rem;
  --bs-spinner-height: 1rem;
  --bs-spinner-border-width: 0.145em;
}

@keyframes spinner-grow {
  0% {
    transform: scale(0);
  }
  50% {
    opacity: 1;
    transform: none;
  }
}
.spinner-grow {
  --bs-spinner-width: 2rem;
  --bs-spinner-height: 2rem;
  --bs-spinner-vertical-align: -0.125em;
  --bs-spinner-animation-speed: 0.65s;
  --bs-spinner-animation-name: spinner-grow;
  background-color: currentcolor;
  opacity: 0;
}

.spinner-grow-sm {
  --bs-spinner-width: 1rem;
  --bs-spinner-height: 1rem;
}

@media (prefers-reduced-motion: reduce) {
  .spinner-border,
  .spinner-grow {
    --bs-spinner-animation-speed: 1.3s;
  }
}
.offcanvas, .offcanvas-xxl, .offcanvas-xl, .offcanvas-lg, .offcanvas-md, .offcanvas-sm {
  --bs-offcanvas-zindex: 1045;
  --bs-offcanvas-width: 400px;
  --bs-offcanvas-height: 30vh;
  --bs-offcanvas-padding-x: 1.75rem;
  --bs-offcanvas-padding-y: 1.75rem;
  --bs-offcanvas-color: var(--bs-body-color);
  --bs-offcanvas-bg: var(--bs-body-bg);
  --bs-offcanvas-border-width: 0;
  --bs-offcanvas-border-color: var(--bs-border-color-translucent);
  --bs-offcanvas-box-shadow: 0 0.25rem 0.5rem rgba(0, 0, 0, 0.1);
  --bs-offcanvas-transition: transform 0.3s ease-in-out;
  --bs-offcanvas-title-line-height: 1.5;
}

@media (max-width: 575.98px) {
  .offcanvas-sm {
    position: fixed;
    bottom: 0;
    z-index: var(--bs-offcanvas-zindex);
    display: flex;
    flex-direction: column;
    max-width: 100%;
    color: var(--bs-offcanvas-color);
    visibility: hidden;
    background-color: var(--bs-offcanvas-bg);
    background-clip: padding-box;
    outline: 0;
    box-shadow: var(--bs-offcanvas-box-shadow);
    transition: var(--bs-offcanvas-transition);
  }
}
@media (max-width: 575.98px) and (prefers-reduced-motion: reduce) {
  .offcanvas-sm {
    transition: none;
  }
}
@media (max-width: 575.98px) {
  .offcanvas-sm.offcanvas-start {
    top: 0;
    left: 0;
    width: var(--bs-offcanvas-width);
    border-right: var(--bs-offcanvas-border-width) solid var(--bs-offcanvas-border-color);
    transform: translateX(-100%);
  }
  .offcanvas-sm.offcanvas-end {
    top: 0;
    right: 0;
    width: var(--bs-offcanvas-width);
    border-left: var(--bs-offcanvas-border-width) solid var(--bs-offcanvas-border-color);
    transform: translateX(100%);
  }
  .offcanvas-sm.offcanvas-top {
    top: 0;
    right: 0;
    left: 0;
    height: var(--bs-offcanvas-height);
    max-height: 100%;
    border-bottom: var(--bs-offcanvas-border-width) solid var(--bs-offcanvas-border-color);
    transform: translateY(-100%);
  }
  .offcanvas-sm.offcanvas-bottom {
    right: 0;
    left: 0;
    height: var(--bs-offcanvas-height);
    max-height: 100%;
    border-top: var(--bs-offcanvas-border-width) solid var(--bs-offcanvas-border-color);
    transform: translateY(100%);
  }
  .offcanvas-sm.showing, .offcanvas-sm.show:not(.hiding) {
    transform: none;
  }
  .offcanvas-sm.showing, .offcanvas-sm.hiding, .offcanvas-sm.show {
    visibility: visible;
  }
}
@media (min-width: 576px) {
  .offcanvas-sm {
    --bs-offcanvas-height: auto;
    --bs-offcanvas-border-width: 0;
    background-color: transparent !important;
  }
  .offcanvas-sm .offcanvas-header {
    display: none;
  }
  .offcanvas-sm .offcanvas-body {
    display: flex;
    flex-grow: 0;
    padding: 0;
    overflow-y: visible;
    background-color: transparent !important;
  }
}
@media (max-width: 767.98px) {
  .offcanvas-md {
    position: fixed;
    bottom: 0;
    z-index: var(--bs-offcanvas-zindex);
    display: flex;
    flex-direction: column;
    max-width: 100%;
    color: var(--bs-offcanvas-color);
    visibility: hidden;
    background-color: var(--bs-offcanvas-bg);
    background-clip: padding-box;
    outline: 0;
    box-shadow: var(--bs-offcanvas-box-shadow);
    transition: var(--bs-offcanvas-transition);
  }
}
@media (max-width: 767.98px) and (prefers-reduced-motion: reduce) {
  .offcanvas-md {
    transition: none;
  }
}
@media (max-width: 767.98px) {
  .offcanvas-md.offcanvas-start {
    top: 0;
    left: 0;
    width: var(--bs-offcanvas-width);
    border-right: var(--bs-offcanvas-border-width) solid var(--bs-offcanvas-border-color);
    transform: translateX(-100%);
  }
  .offcanvas-md.offcanvas-end {
    top: 0;
    right: 0;
    width: var(--bs-offcanvas-width);
    border-left: var(--bs-offcanvas-border-width) solid var(--bs-offcanvas-border-color);
    transform: translateX(100%);
  }
  .offcanvas-md.offcanvas-top {
    top: 0;
    right: 0;
    left: 0;
    height: var(--bs-offcanvas-height);
    max-height: 100%;
    border-bottom: var(--bs-offcanvas-border-width) solid var(--bs-offcanvas-border-color);
    transform: translateY(-100%);
  }
  .offcanvas-md.offcanvas-bottom {
    right: 0;
    left: 0;
    height: var(--bs-offcanvas-height);
    max-height: 100%;
    border-top: var(--bs-offcanvas-border-width) solid var(--bs-offcanvas-border-color);
    transform: translateY(100%);
  }
  .offcanvas-md.showing, .offcanvas-md.show:not(.hiding) {
    transform: none;
  }
  .offcanvas-md.showing, .offcanvas-md.hiding, .offcanvas-md.show {
    visibility: visible;
  }
}
@media (min-width: 768px) {
  .offcanvas-md {
    --bs-offcanvas-height: auto;
    --bs-offcanvas-border-width: 0;
    background-color: transparent !important;
  }
  .offcanvas-md .offcanvas-header {
    display: none;
  }
  .offcanvas-md .offcanvas-body {
    display: flex;
    flex-grow: 0;
    padding: 0;
    overflow-y: visible;
    background-color: transparent !important;
  }
}
@media (max-width: 991.98px) {
  .offcanvas-lg {
    position: fixed;
    bottom: 0;
    z-index: var(--bs-offcanvas-zindex);
    display: flex;
    flex-direction: column;
    max-width: 100%;
    color: var(--bs-offcanvas-color);
    visibility: hidden;
    background-color: var(--bs-offcanvas-bg);
    background-clip: padding-box;
    outline: 0;
    box-shadow: var(--bs-offcanvas-box-shadow);
    transition: var(--bs-offcanvas-transition);
  }
}
@media (max-width: 991.98px) and (prefers-reduced-motion: reduce) {
  .offcanvas-lg {
    transition: none;
  }
}
@media (max-width: 991.98px) {
  .offcanvas-lg.offcanvas-start {
    top: 0;
    left: 0;
    width: var(--bs-offcanvas-width);
    border-right: var(--bs-offcanvas-border-width) solid var(--bs-offcanvas-border-color);
    transform: translateX(-100%);
  }
  .offcanvas-lg.offcanvas-end {
    top: 0;
    right: 0;
    width: var(--bs-offcanvas-width);
    border-left: var(--bs-offcanvas-border-width) solid var(--bs-offcanvas-border-color);
    transform: translateX(100%);
  }
  .offcanvas-lg.offcanvas-top {
    top: 0;
    right: 0;
    left: 0;
    height: var(--bs-offcanvas-height);
    max-height: 100%;
    border-bottom: var(--bs-offcanvas-border-width) solid var(--bs-offcanvas-border-color);
    transform: translateY(-100%);
  }
  .offcanvas-lg.offcanvas-bottom {
    right: 0;
    left: 0;
    height: var(--bs-offcanvas-height);
    max-height: 100%;
    border-top: var(--bs-offcanvas-border-width) solid var(--bs-offcanvas-border-color);
    transform: translateY(100%);
  }
  .offcanvas-lg.showing, .offcanvas-lg.show:not(.hiding) {
    transform: none;
  }
  .offcanvas-lg.showing, .offcanvas-lg.hiding, .offcanvas-lg.show {
    visibility: visible;
  }
}
@media (min-width: 992px) {
  .offcanvas-lg {
    --bs-offcanvas-height: auto;
    --bs-offcanvas-border-width: 0;
    background-color: transparent !important;
  }
  .offcanvas-lg .offcanvas-header {
    display: none;
  }
  .offcanvas-lg .offcanvas-body {
    display: flex;
    flex-grow: 0;
    padding: 0;
    overflow-y: visible;
    background-color: transparent !important;
  }
}
@media (max-width: 1199.98px) {
  .offcanvas-xl {
    position: fixed;
    bottom: 0;
    z-index: var(--bs-offcanvas-zindex);
    display: flex;
    flex-direction: column;
    max-width: 100%;
    color: var(--bs-offcanvas-color);
    visibility: hidden;
    background-color: var(--bs-offcanvas-bg);
    background-clip: padding-box;
    outline: 0;
    box-shadow: var(--bs-offcanvas-box-shadow);
    transition: var(--bs-offcanvas-transition);
  }
}
@media (max-width: 1199.98px) and (prefers-reduced-motion: reduce) {
  .offcanvas-xl {
    transition: none;
  }
}
@media (max-width: 1199.98px) {
  .offcanvas-xl.offcanvas-start {
    top: 0;
    left: 0;
    width: var(--bs-offcanvas-width);
    border-right: var(--bs-offcanvas-border-width) solid var(--bs-offcanvas-border-color);
    transform: translateX(-100%);
  }
  .offcanvas-xl.offcanvas-end {
    top: 0;
    right: 0;
    width: var(--bs-offcanvas-width);
    border-left: var(--bs-offcanvas-border-width) solid var(--bs-offcanvas-border-color);
    transform: translateX(100%);
  }
  .offcanvas-xl.offcanvas-top {
    top: 0;
    right: 0;
    left: 0;
    height: var(--bs-offcanvas-height);
    max-height: 100%;
    border-bottom: var(--bs-offcanvas-border-width) solid var(--bs-offcanvas-border-color);
    transform: translateY(-100%);
  }
  .offcanvas-xl.offcanvas-bottom {
    right: 0;
    left: 0;
    height: var(--bs-offcanvas-height);
    max-height: 100%;
    border-top: var(--bs-offcanvas-border-width) solid var(--bs-offcanvas-border-color);
    transform: translateY(100%);
  }
  .offcanvas-xl.showing, .offcanvas-xl.show:not(.hiding) {
    transform: none;
  }
  .offcanvas-xl.showing, .offcanvas-xl.hiding, .offcanvas-xl.show {
    visibility: visible;
  }
}
@media (min-width: 1200px) {
  .offcanvas-xl {
    --bs-offcanvas-height: auto;
    --bs-offcanvas-border-width: 0;
    background-color: transparent !important;
  }
  .offcanvas-xl .offcanvas-header {
    display: none;
  }
  .offcanvas-xl .offcanvas-body {
    display: flex;
    flex-grow: 0;
    padding: 0;
    overflow-y: visible;
    background-color: transparent !important;
  }
}
@media (max-width: 1399.98px) {
  .offcanvas-xxl {
    position: fixed;
    bottom: 0;
    z-index: var(--bs-offcanvas-zindex);
    display: flex;
    flex-direction: column;
    max-width: 100%;
    color: var(--bs-offcanvas-color);
    visibility: hidden;
    background-color: var(--bs-offcanvas-bg);
    background-clip: padding-box;
    outline: 0;
    box-shadow: var(--bs-offcanvas-box-shadow);
    transition: var(--bs-offcanvas-transition);
  }
}
@media (max-width: 1399.98px) and (prefers-reduced-motion: reduce) {
  .offcanvas-xxl {
    transition: none;
  }
}
@media (max-width: 1399.98px) {
  .offcanvas-xxl.offcanvas-start {
    top: 0;
    left: 0;
    width: var(--bs-offcanvas-width);
    border-right: var(--bs-offcanvas-border-width) solid var(--bs-offcanvas-border-color);
    transform: translateX(-100%);
  }
  .offcanvas-xxl.offcanvas-end {
    top: 0;
    right: 0;
    width: var(--bs-offcanvas-width);
    border-left: var(--bs-offcanvas-border-width) solid var(--bs-offcanvas-border-color);
    transform: translateX(100%);
  }
  .offcanvas-xxl.offcanvas-top {
    top: 0;
    right: 0;
    left: 0;
    height: var(--bs-offcanvas-height);
    max-height: 100%;
    border-bottom: var(--bs-offcanvas-border-width) solid var(--bs-offcanvas-border-color);
    transform: translateY(-100%);
  }
  .offcanvas-xxl.offcanvas-bottom {
    right: 0;
    left: 0;
    height: var(--bs-offcanvas-height);
    max-height: 100%;
    border-top: var(--bs-offcanvas-border-width) solid var(--bs-offcanvas-border-color);
    transform: translateY(100%);
  }
  .offcanvas-xxl.showing, .offcanvas-xxl.show:not(.hiding) {
    transform: none;
  }
  .offcanvas-xxl.showing, .offcanvas-xxl.hiding, .offcanvas-xxl.show {
    visibility: visible;
  }
}
@media (min-width: 1400px) {
  .offcanvas-xxl {
    --bs-offcanvas-height: auto;
    --bs-offcanvas-border-width: 0;
    background-color: transparent !important;
  }
  .offcanvas-xxl .offcanvas-header {
    display: none;
  }
  .offcanvas-xxl .offcanvas-body {
    display: flex;
    flex-grow: 0;
    padding: 0;
    overflow-y: visible;
    background-color: transparent !important;
  }
}
.offcanvas {
  position: fixed;
  bottom: 0;
  z-index: var(--bs-offcanvas-zindex);
  display: flex;
  flex-direction: column;
  max-width: 100%;
  color: var(--bs-offcanvas-color);
  visibility: hidden;
  background-color: var(--bs-offcanvas-bg);
  background-clip: padding-box;
  outline: 0;
  box-shadow: var(--bs-offcanvas-box-shadow);
  transition: var(--bs-offcanvas-transition);
}

@media (prefers-reduced-motion: reduce) {
  .offcanvas {
    transition: none;
  }
}
.offcanvas.offcanvas-start {
  top: 0;
  left: 0;
  width: var(--bs-offcanvas-width);
  border-right: var(--bs-offcanvas-border-width) solid var(--bs-offcanvas-border-color);
  transform: translateX(-100%);
}

.offcanvas.offcanvas-end {
  top: 0;
  right: 0;
  width: var(--bs-offcanvas-width);
  border-left: var(--bs-offcanvas-border-width) solid var(--bs-offcanvas-border-color);
  transform: translateX(100%);
}

.offcanvas.offcanvas-top {
  top: 0;
  right: 0;
  left: 0;
  height: var(--bs-offcanvas-height);
  max-height: 100%;
  border-bottom: var(--bs-offcanvas-border-width) solid var(--bs-offcanvas-border-color);
  transform: translateY(-100%);
}

.offcanvas.offcanvas-bottom {
  right: 0;
  left: 0;
  height: var(--bs-offcanvas-height);
  max-height: 100%;
  border-top: var(--bs-offcanvas-border-width) solid var(--bs-offcanvas-border-color);
  transform: translateY(100%);
}

.offcanvas.showing, .offcanvas.show:not(.hiding) {
  transform: none;
}

.offcanvas.showing, .offcanvas.hiding, .offcanvas.show {
  visibility: visible;
}

.offcanvas-backdrop {
  position: fixed;
  top: 0;
  left: 0;
  z-index: 1040;
  width: 100vw;
  height: 100vh;
  background-color: #000000;
}

.offcanvas-backdrop.fade {
  opacity: 0;
}

.offcanvas-backdrop.show {
  opacity: 0.4;
}

.offcanvas-header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: var(--bs-offcanvas-padding-y) var(--bs-offcanvas-padding-x);
}

.offcanvas-header .btn-close {
  padding: calc(var(--bs-offcanvas-padding-y) * 0.5) calc(var(--bs-offcanvas-padding-x) * 0.5);
  margin-top: calc(-0.5 * var(--bs-offcanvas-padding-y));
  margin-right: calc(-0.5 * var(--bs-offcanvas-padding-x));
  margin-bottom: calc(-0.5 * var(--bs-offcanvas-padding-y));
}

.offcanvas-title {
  margin-bottom: 0;
  line-height: var(--bs-offcanvas-title-line-height);
}

.offcanvas-body {
  flex-grow: 1;
  padding: var(--bs-offcanvas-padding-y) var(--bs-offcanvas-padding-x);
  overflow-y: auto;
}

.placeholder {
  display: inline-block;
  min-height: 1em;
  vertical-align: middle;
  cursor: wait;
  background-color: currentcolor;
  opacity: 0.5;
}

.placeholder.btn::before {
  display: inline-block;
  content: "";
}

.placeholder-xs {
  min-height: 0.6em;
}

.placeholder-sm {
  min-height: 0.8em;
}

.placeholder-lg {
  min-height: 1.2em;
}

.placeholder-glow .placeholder {
  animation: placeholder-glow 2s ease-in-out infinite;
}

@keyframes placeholder-glow {
  50% {
    opacity: 0.2;
  }
}
.placeholder-wave {
  mask-image: linear-gradient(130deg, #000000 55%, rgba(0, 0, 0, 0.8) 75%, #000000 95%);
  mask-size: 200% 100%;
  animation: placeholder-wave 2s linear infinite;
}

@keyframes placeholder-wave {
  100% {
    mask-position: -200% 0%;
  }
}
.clearfix::after {
  display: block;
  clear: both;
  content: "";
}

.text-bg-light {
  color: #000000 !important;
  background-color: RGBA(249, 249, 249, var(--bs-bg-opacity, 1)) !important;
}

.text-bg-primary {
  color: #000000 !important;
  background-color: RGBA(0, 158, 247, var(--bs-bg-opacity, 1)) !important;
}

.text-bg-secondary {
  color: #000000 !important;
  background-color: RGBA(225, 227, 234, var(--bs-bg-opacity, 1)) !important;
}

.text-bg-success {
  color: #000000 !important;
  background-color: RGBA(80, 205, 137, var(--bs-bg-opacity, 1)) !important;
}

.text-bg-info {
  color: #ffffff !important;
  background-color: RGBA(114, 57, 234, var(--bs-bg-opacity, 1)) !important;
}

.text-bg-warning {
  color: #000000 !important;
  background-color: RGBA(255, 199, 0, var(--bs-bg-opacity, 1)) !important;
}

.text-bg-danger {
  color: #000000 !important;
  background-color: RGBA(241, 65, 108, var(--bs-bg-opacity, 1)) !important;
}

.text-bg-dark {
  color: #ffffff !important;
  background-color: RGBA(24, 28, 50, var(--bs-bg-opacity, 1)) !important;
}

.link-light {
  color: #F9F9F9 !important;
}

.link-light:hover, .link-light:focus {
  color: #fafafa !important;
}

.link-primary {
  color: #009ef7 !important;
}

.link-primary:hover, .link-primary:focus {
  color: #33b1f9 !important;
}

.link-secondary {
  color: #E1E3EA !important;
}

.link-secondary:hover, .link-secondary:focus {
  color: #e7e9ee !important;
}

.link-success {
  color: #50cd89 !important;
}

.link-success:hover, .link-success:focus {
  color: #73d7a1 !important;
}

.link-info {
  color: #7239ea !important;
}

.link-info:hover, .link-info:focus {
  color: #5b2ebb !important;
}

.link-warning {
  color: #ffc700 !important;
}

.link-warning:hover, .link-warning:focus {
  color: #ffd233 !important;
}

.link-danger {
  color: #f1416c !important;
}

.link-danger:hover, .link-danger:focus {
  color: #f46789 !important;
}

.link-dark {
  color: #181C32 !important;
}

.link-dark:hover, .link-dark:focus {
  color: #131628 !important;
}

.ratio {
  position: relative;
  width: 100%;
}

.ratio::before {
  display: block;
  padding-top: var(--bs-aspect-ratio);
  content: "";
}

.ratio > * {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
}

.ratio-1x1 {
  --bs-aspect-ratio: 100%;
}

.ratio-4x3 {
  --bs-aspect-ratio: 75%;
}

.ratio-16x9 {
  --bs-aspect-ratio: 56.25%;
}

.ratio-21x9 {
  --bs-aspect-ratio: 42.8571428571%;
}

.fixed-top {
  position: fixed;
  top: 0;
  right: 0;
  left: 0;
  z-index: 1030;
}

.fixed-bottom {
  position: fixed;
  right: 0;
  bottom: 0;
  left: 0;
  z-index: 1030;
}

.sticky-top {
  position: sticky;
  top: 0;
  z-index: 1020;
}

.sticky-bottom {
  position: sticky;
  bottom: 0;
  z-index: 1020;
}

@media (min-width: 576px) {
  .sticky-sm-top {
    position: sticky;
    top: 0;
    z-index: 1020;
  }
  .sticky-sm-bottom {
    position: sticky;
    bottom: 0;
    z-index: 1020;
  }
}
@media (min-width: 768px) {
  .sticky-md-top {
    position: sticky;
    top: 0;
    z-index: 1020;
  }
  .sticky-md-bottom {
    position: sticky;
    bottom: 0;
    z-index: 1020;
  }
}
@media (min-width: 992px) {
  .sticky-lg-top {
    position: sticky;
    top: 0;
    z-index: 1020;
  }
  .sticky-lg-bottom {
    position: sticky;
    bottom: 0;
    z-index: 1020;
  }
}
@media (min-width: 1200px) {
  .sticky-xl-top {
    position: sticky;
    top: 0;
    z-index: 1020;
  }
  .sticky-xl-bottom {
    position: sticky;
    bottom: 0;
    z-index: 1020;
  }
}
@media (min-width: 1400px) {
  .sticky-xxl-top {
    position: sticky;
    top: 0;
    z-index: 1020;
  }
  .sticky-xxl-bottom {
    position: sticky;
    bottom: 0;
    z-index: 1020;
  }
}
.hstack {
  display: flex;
  flex-direction: row;
  align-items: center;
  align-self: stretch;
}

.vstack {
  display: flex;
  flex: 1 1 auto;
  flex-direction: column;
  align-self: stretch;
}

.visually-hidden,
.visually-hidden-focusable:not(:focus):not(:focus-within) {
  position: absolute !important;
  width: 1px !important;
  height: 1px !important;
  padding: 0 !important;
  margin: -1px !important;
  overflow: hidden !important;
  clip: rect(0, 0, 0, 0) !important;
  white-space: nowrap !important;
  border: 0 !important;
}

.stretched-link::after {
  position: absolute;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
  z-index: 1;
  content: "";
}

.text-truncate {
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.vr {
  display: inline-block;
  align-self: stretch;
  width: 1px;
  min-height: 1em;
  background-color: currentcolor;
  opacity: 0.25;
}

.align-baseline {
  vertical-align: baseline !important;
}

.align-top {
  vertical-align: top !important;
}

.align-middle {
  vertical-align: middle !important;
}

.align-bottom {
  vertical-align: bottom !important;
}

.align-text-bottom {
  vertical-align: text-bottom !important;
}

.align-text-top {
  vertical-align: text-top !important;
}

.float-start {
  float: left !important;
}

.float-end {
  float: right !important;
}

.float-none {
  float: none !important;
}

.object-fit-contain {
  object-fit: contain !important;
}

.object-fit-cover {
  object-fit: cover !important;
}

.object-fit-fill {
  object-fit: fill !important;
}

.object-fit-scale {
  object-fit: scale-down !important;
}

.object-fit-none {
  object-fit: none !important;
}

.opacity-0 {
  opacity: 0 !important;
}

.opacity-5 {
  opacity: 0.05 !important;
}

.opacity-10 {
  opacity: 0.1 !important;
}

.opacity-15 {
  opacity: 0.15 !important;
}

.opacity-20 {
  opacity: 0.2 !important;
}

.opacity-25 {
  opacity: 0.25 !important;
}

.opacity-50 {
  opacity: 0.5 !important;
}

.opacity-75 {
  opacity: 0.75 !important;
}

.opacity-100 {
  opacity: 1 !important;
}

.overflow-auto {
  overflow: auto !important;
}

.overflow-hidden {
  overflow: hidden !important;
}

.overflow-visible {
  overflow: visible !important;
}

.overflow-scroll {
  overflow: scroll !important;
}

.overflow-x-auto {
  overflow-x: auto !important;
}

.overflow-x-hidden {
  overflow-x: hidden !important;
}

.overflow-x-visible {
  overflow-x: visible !important;
}

.overflow-x-scroll {
  overflow-x: scroll !important;
}

.overflow-y-auto {
  overflow-y: auto !important;
}

.overflow-y-hidden {
  overflow-y: hidden !important;
}

.overflow-y-visible {
  overflow-y: visible !important;
}

.overflow-y-scroll {
  overflow-y: scroll !important;
}

.d-inline {
  display: inline !important;
}

.d-inline-block {
  display: inline-block !important;
}

.d-block {
  display: block !important;
}

.d-grid {
  display: grid !important;
}

.d-table {
  display: table !important;
}

.d-table-row {
  display: table-row !important;
}

.d-table-cell {
  display: table-cell !important;
}

.d-flex {
  display: flex !important;
}

.d-inline-flex {
  display: inline-flex !important;
}

.d-none {
  display: none !important;
}

.shadow {
  box-shadow: 0 0.5rem 1.5rem 0.5rem rgba(0, 0, 0, 0.075) !important;
}

.shadow-sm {
  box-shadow: 0 0.1rem 1rem 0.25rem rgba(0, 0, 0, 0.05) !important;
}

.shadow-lg {
  box-shadow: 0 1rem 2rem 1rem rgba(0, 0, 0, 0.1) !important;
}

.shadow-none {
  box-shadow: none !important;
}

.position-static {
  position: static !important;
}

.position-relative {
  position: relative !important;
}

.position-absolute {
  position: absolute !important;
}

.position-fixed {
  position: fixed !important;
}

.position-sticky {
  position: sticky !important;
}

.top-0 {
  top: 0 !important;
}

.top-25 {
  top: 25% !important;
}

.top-50 {
  top: 50% !important;
}

.top-75 {
  top: 75% !important;
}

.top-100 {
  top: 100% !important;
}

.bottom-0 {
  bottom: 0 !important;
}

.bottom-25 {
  bottom: 25% !important;
}

.bottom-50 {
  bottom: 50% !important;
}

.bottom-75 {
  bottom: 75% !important;
}

.bottom-100 {
  bottom: 100% !important;
}

.start-0 {
  left: 0 !important;
}

.start-25 {
  left: 25% !important;
}

.start-50 {
  left: 50% !important;
}

.start-75 {
  left: 75% !important;
}

.start-100 {
  left: 100% !important;
}

.end-0 {
  right: 0 !important;
}

.end-25 {
  right: 25% !important;
}

.end-50 {
  right: 50% !important;
}

.end-75 {
  right: 75% !important;
}

.end-100 {
  right: 100% !important;
}

.translate-middle {
  transform: translate(-50%, -50%) !important;
}

.translate-middle-x {
  transform: translateX(-50%) !important;
}

.translate-middle-y {
  transform: translateY(-50%) !important;
}

.border {
  border: var(--bs-border-width) var(--bs-border-style) var(--bs-border-color) !important;
}

.border-0 {
  border: 0 !important;
}

.border-top {
  border-top: var(--bs-border-width) var(--bs-border-style) var(--bs-border-color) !important;
}

.border-top-0 {
  border-top: 0 !important;
}

.border-end {
  border-right: var(--bs-border-width) var(--bs-border-style) var(--bs-border-color) !important;
}

.border-end-0 {
  border-right: 0 !important;
}

.border-bottom {
  border-bottom: var(--bs-border-width) var(--bs-border-style) var(--bs-border-color) !important;
}

.border-bottom-0 {
  border-bottom: 0 !important;
}

.border-start {
  border-left: var(--bs-border-width) var(--bs-border-style) var(--bs-border-color) !important;
}

.border-start-0 {
  border-left: 0 !important;
}

.border-light {
  --bs-border-opacity: 1;
  border-color: rgba(var(--bs-light-rgb), var(--bs-border-opacity)) !important;
}

.border-primary {
  --bs-border-opacity: 1;
  border-color: rgba(var(--bs-primary-rgb), var(--bs-border-opacity)) !important;
}

.border-secondary {
  --bs-border-opacity: 1;
  border-color: rgba(var(--bs-secondary-rgb), var(--bs-border-opacity)) !important;
}

.border-success {
  --bs-border-opacity: 1;
  border-color: rgba(var(--bs-success-rgb), var(--bs-border-opacity)) !important;
}

.border-info {
  --bs-border-opacity: 1;
  border-color: rgba(var(--bs-info-rgb), var(--bs-border-opacity)) !important;
}

.border-warning {
  --bs-border-opacity: 1;
  border-color: rgba(var(--bs-warning-rgb), var(--bs-border-opacity)) !important;
}

.border-danger {
  --bs-border-opacity: 1;
  border-color: rgba(var(--bs-danger-rgb), var(--bs-border-opacity)) !important;
}

.border-dark {
  --bs-border-opacity: 1;
  border-color: rgba(var(--bs-dark-rgb), var(--bs-border-opacity)) !important;
}

.border-white {
  --bs-border-opacity: 1;
  border-color: rgba(var(--bs-white-rgb), var(--bs-border-opacity)) !important;
}

.border-primary-subtle {
  border-color: var(--bs-primary-border-subtle) !important;
}

.border-secondary-subtle {
  border-color: var(--bs-secondary-border-subtle) !important;
}

.border-success-subtle {
  border-color: var(--bs-success-border-subtle) !important;
}

.border-info-subtle {
  border-color: var(--bs-info-border-subtle) !important;
}

.border-warning-subtle {
  border-color: var(--bs-warning-border-subtle) !important;
}

.border-danger-subtle {
  border-color: var(--bs-danger-border-subtle) !important;
}

.border-light-subtle {
  border-color: var(--bs-light-border-subtle) !important;
}

.border-dark-subtle {
  border-color: var(--bs-dark-border-subtle) !important;
}

.border-0 {
  --bs-border-width: 0;
}

.border-1 {
  --bs-border-width: 1px;
}

.border-2 {
  --bs-border-width: 2px;
}

.border-3 {
  --bs-border-width: 3px;
}

.border-4 {
  --bs-border-width: 4px;
}

.border-5 {
  --bs-border-width: 5px;
}

.border-opacity-10 {
  --bs-border-opacity: 0.1;
}

.border-opacity-25 {
  --bs-border-opacity: 0.25;
}

.border-opacity-50 {
  --bs-border-opacity: 0.5;
}

.border-opacity-75 {
  --bs-border-opacity: 0.75;
}

.border-opacity-100 {
  --bs-border-opacity: 1;
}

.w-unset {
  width: unset !important;
}

.w-25 {
  width: 25% !important;
}

.w-50 {
  width: 50% !important;
}

.w-75 {
  width: 75% !important;
}

.w-100 {
  width: 100% !important;
}

.w-auto {
  width: auto !important;
}

.w-1px {
  width: 1px !important;
}

.w-2px {
  width: 2px !important;
}

.w-3px {
  width: 3px !important;
}

.w-4px {
  width: 4px !important;
}

.w-5px {
  width: 5px !important;
}

.w-6px {
  width: 6px !important;
}

.w-7px {
  width: 7px !important;
}

.w-8px {
  width: 8px !important;
}

.w-9px {
  width: 9px !important;
}

.w-10px {
  width: 10px !important;
}

.w-15px {
  width: 15px !important;
}

.w-20px {
  width: 20px !important;
}

.w-25px {
  width: 25px !important;
}

.w-30px {
  width: 30px !important;
}

.w-35px {
  width: 35px !important;
}

.w-40px {
  width: 40px !important;
}

.w-45px {
  width: 45px !important;
}

.w-50px {
  width: 50px !important;
}

.w-55px {
  width: 55px !important;
}

.w-60px {
  width: 60px !important;
}

.w-65px {
  width: 65px !important;
}

.w-70px {
  width: 70px !important;
}

.w-75px {
  width: 75px !important;
}

.w-80px {
  width: 80px !important;
}

.w-85px {
  width: 85px !important;
}

.w-90px {
  width: 90px !important;
}

.w-95px {
  width: 95px !important;
}

.w-100px {
  width: 100px !important;
}

.w-125px {
  width: 125px !important;
}

.w-150px {
  width: 150px !important;
}

.w-175px {
  width: 175px !important;
}

.w-200px {
  width: 200px !important;
}

.w-225px {
  width: 225px !important;
}

.w-250px {
  width: 250px !important;
}

.w-275px {
  width: 275px !important;
}

.w-300px {
  width: 300px !important;
}

.w-325px {
  width: 325px !important;
}

.w-350px {
  width: 350px !important;
}

.w-375px {
  width: 375px !important;
}

.w-400px {
  width: 400px !important;
}

.w-425px {
  width: 425px !important;
}

.w-450px {
  width: 450px !important;
}

.w-475px {
  width: 475px !important;
}

.w-500px {
  width: 500px !important;
}

.w-550px {
  width: 550px !important;
}

.w-600px {
  width: 600px !important;
}

.w-650px {
  width: 650px !important;
}

.w-700px {
  width: 700px !important;
}

.w-750px {
  width: 750px !important;
}

.w-800px {
  width: 800px !important;
}

.w-850px {
  width: 850px !important;
}

.w-900px {
  width: 900px !important;
}

.w-950px {
  width: 950px !important;
}

.w-1000px {
  width: 1000px !important;
}

.mw-unset {
  max-width: unset !important;
}

.mw-25 {
  max-width: 25% !important;
}

.mw-50 {
  max-width: 50% !important;
}

.mw-75 {
  max-width: 75% !important;
}

.mw-100 {
  max-width: 100% !important;
}

.mw-auto {
  max-width: auto !important;
}

.mw-1px {
  max-width: 1px !important;
}

.mw-2px {
  max-width: 2px !important;
}

.mw-3px {
  max-width: 3px !important;
}

.mw-4px {
  max-width: 4px !important;
}

.mw-5px {
  max-width: 5px !important;
}

.mw-6px {
  max-width: 6px !important;
}

.mw-7px {
  max-width: 7px !important;
}

.mw-8px {
  max-width: 8px !important;
}

.mw-9px {
  max-width: 9px !important;
}

.mw-10px {
  max-width: 10px !important;
}

.mw-15px {
  max-width: 15px !important;
}

.mw-20px {
  max-width: 20px !important;
}

.mw-25px {
  max-width: 25px !important;
}

.mw-30px {
  max-width: 30px !important;
}

.mw-35px {
  max-width: 35px !important;
}

.mw-40px {
  max-width: 40px !important;
}

.mw-45px {
  max-width: 45px !important;
}

.mw-50px {
  max-width: 50px !important;
}

.mw-55px {
  max-width: 55px !important;
}

.mw-60px {
  max-width: 60px !important;
}

.mw-65px {
  max-width: 65px !important;
}

.mw-70px {
  max-width: 70px !important;
}

.mw-75px {
  max-width: 75px !important;
}

.mw-80px {
  max-width: 80px !important;
}

.mw-85px {
  max-width: 85px !important;
}

.mw-90px {
  max-width: 90px !important;
}

.mw-95px {
  max-width: 95px !important;
}

.mw-100px {
  max-width: 100px !important;
}

.mw-125px {
  max-width: 125px !important;
}

.mw-150px {
  max-width: 150px !important;
}

.mw-175px {
  max-width: 175px !important;
}

.mw-200px {
  max-width: 200px !important;
}

.mw-225px {
  max-width: 225px !important;
}

.mw-250px {
  max-width: 250px !important;
}

.mw-275px {
  max-width: 275px !important;
}

.mw-300px {
  max-width: 300px !important;
}

.mw-325px {
  max-width: 325px !important;
}

.mw-350px {
  max-width: 350px !important;
}

.mw-375px {
  max-width: 375px !important;
}

.mw-400px {
  max-width: 400px !important;
}

.mw-425px {
  max-width: 425px !important;
}

.mw-450px {
  max-width: 450px !important;
}

.mw-475px {
  max-width: 475px !important;
}

.mw-500px {
  max-width: 500px !important;
}

.mw-550px {
  max-width: 550px !important;
}

.mw-600px {
  max-width: 600px !important;
}

.mw-650px {
  max-width: 650px !important;
}

.mw-700px {
  max-width: 700px !important;
}

.mw-750px {
  max-width: 750px !important;
}

.mw-800px {
  max-width: 800px !important;
}

.mw-850px {
  max-width: 850px !important;
}

.mw-900px {
  max-width: 900px !important;
}

.mw-950px {
  max-width: 950px !important;
}

.mw-1000px {
  max-width: 1000px !important;
}

.vw-100 {
  width: 100vw !important;
}

.min-vw-100 {
  min-width: 100vw !important;
}

.h-unset {
  height: unset !important;
}

.h-25 {
  height: 25% !important;
}

.h-50 {
  height: 50% !important;
}

.h-75 {
  height: 75% !important;
}

.h-100 {
  height: 100% !important;
}

.h-auto {
  height: auto !important;
}

.h-1px {
  height: 1px !important;
}

.h-2px {
  height: 2px !important;
}

.h-3px {
  height: 3px !important;
}

.h-4px {
  height: 4px !important;
}

.h-5px {
  height: 5px !important;
}

.h-6px {
  height: 6px !important;
}

.h-7px {
  height: 7px !important;
}

.h-8px {
  height: 8px !important;
}

.h-9px {
  height: 9px !important;
}

.h-10px {
  height: 10px !important;
}

.h-15px {
  height: 15px !important;
}

.h-20px {
  height: 20px !important;
}

.h-25px {
  height: 25px !important;
}

.h-30px {
  height: 30px !important;
}

.h-35px {
  height: 35px !important;
}

.h-40px {
  height: 40px !important;
}

.h-45px {
  height: 45px !important;
}

.h-50px {
  height: 50px !important;
}

.h-55px {
  height: 55px !important;
}

.h-60px {
  height: 60px !important;
}

.h-65px {
  height: 65px !important;
}

.h-70px {
  height: 70px !important;
}

.h-75px {
  height: 75px !important;
}

.h-80px {
  height: 80px !important;
}

.h-85px {
  height: 85px !important;
}

.h-90px {
  height: 90px !important;
}

.h-95px {
  height: 95px !important;
}

.h-100px {
  height: 100px !important;
}

.h-125px {
  height: 125px !important;
}

.h-150px {
  height: 150px !important;
}

.h-175px {
  height: 175px !important;
}

.h-200px {
  height: 200px !important;
}

.h-225px {
  height: 225px !important;
}

.h-250px {
  height: 250px !important;
}

.h-275px {
  height: 275px !important;
}

.h-300px {
  height: 300px !important;
}

.h-325px {
  height: 325px !important;
}

.h-350px {
  height: 350px !important;
}

.h-375px {
  height: 375px !important;
}

.h-400px {
  height: 400px !important;
}

.h-425px {
  height: 425px !important;
}

.h-450px {
  height: 450px !important;
}

.h-475px {
  height: 475px !important;
}

.h-500px {
  height: 500px !important;
}

.h-550px {
  height: 550px !important;
}

.h-600px {
  height: 600px !important;
}

.h-650px {
  height: 650px !important;
}

.h-700px {
  height: 700px !important;
}

.h-750px {
  height: 750px !important;
}

.h-800px {
  height: 800px !important;
}

.h-850px {
  height: 850px !important;
}

.h-900px {
  height: 900px !important;
}

.h-950px {
  height: 950px !important;
}

.h-1000px {
  height: 1000px !important;
}

.mh-unset {
  max-height: unset !important;
}

.mh-25 {
  max-height: 25% !important;
}

.mh-50 {
  max-height: 50% !important;
}

.mh-75 {
  max-height: 75% !important;
}

.mh-100 {
  max-height: 100% !important;
}

.mh-auto {
  max-height: auto !important;
}

.mh-1px {
  max-height: 1px !important;
}

.mh-2px {
  max-height: 2px !important;
}

.mh-3px {
  max-height: 3px !important;
}

.mh-4px {
  max-height: 4px !important;
}

.mh-5px {
  max-height: 5px !important;
}

.mh-6px {
  max-height: 6px !important;
}

.mh-7px {
  max-height: 7px !important;
}

.mh-8px {
  max-height: 8px !important;
}

.mh-9px {
  max-height: 9px !important;
}

.mh-10px {
  max-height: 10px !important;
}

.mh-15px {
  max-height: 15px !important;
}

.mh-20px {
  max-height: 20px !important;
}

.mh-25px {
  max-height: 25px !important;
}

.mh-30px {
  max-height: 30px !important;
}

.mh-35px {
  max-height: 35px !important;
}

.mh-40px {
  max-height: 40px !important;
}

.mh-45px {
  max-height: 45px !important;
}

.mh-50px {
  max-height: 50px !important;
}

.mh-55px {
  max-height: 55px !important;
}

.mh-60px {
  max-height: 60px !important;
}

.mh-65px {
  max-height: 65px !important;
}

.mh-70px {
  max-height: 70px !important;
}

.mh-75px {
  max-height: 75px !important;
}

.mh-80px {
  max-height: 80px !important;
}

.mh-85px {
  max-height: 85px !important;
}

.mh-90px {
  max-height: 90px !important;
}

.mh-95px {
  max-height: 95px !important;
}

.mh-100px {
  max-height: 100px !important;
}

.mh-125px {
  max-height: 125px !important;
}

.mh-150px {
  max-height: 150px !important;
}

.mh-175px {
  max-height: 175px !important;
}

.mh-200px {
  max-height: 200px !important;
}

.mh-225px {
  max-height: 225px !important;
}

.mh-250px {
  max-height: 250px !important;
}

.mh-275px {
  max-height: 275px !important;
}

.mh-300px {
  max-height: 300px !important;
}

.mh-325px {
  max-height: 325px !important;
}

.mh-350px {
  max-height: 350px !important;
}

.mh-375px {
  max-height: 375px !important;
}

.mh-400px {
  max-height: 400px !important;
}

.mh-425px {
  max-height: 425px !important;
}

.mh-450px {
  max-height: 450px !important;
}

.mh-475px {
  max-height: 475px !important;
}

.mh-500px {
  max-height: 500px !important;
}

.mh-550px {
  max-height: 550px !important;
}

.mh-600px {
  max-height: 600px !important;
}

.mh-650px {
  max-height: 650px !important;
}

.mh-700px {
  max-height: 700px !important;
}

.mh-750px {
  max-height: 750px !important;
}

.mh-800px {
  max-height: 800px !important;
}

.mh-850px {
  max-height: 850px !important;
}

.mh-900px {
  max-height: 900px !important;
}

.mh-950px {
  max-height: 950px !important;
}

.mh-1000px {
  max-height: 1000px !important;
}

.vh-100 {
  height: 100vh !important;
}

.min-vh-100 {
  min-height: 100vh !important;
}

.flex-fill {
  flex: 1 1 auto !important;
}

.flex-row {
  flex-direction: row !important;
}

.flex-column {
  flex-direction: column !important;
}

.flex-row-reverse {
  flex-direction: row-reverse !important;
}

.flex-column-reverse {
  flex-direction: column-reverse !important;
}

.flex-grow-0 {
  flex-grow: 0 !important;
}

.flex-grow-1 {
  flex-grow: 1 !important;
}

.flex-shrink-0 {
  flex-shrink: 0 !important;
}

.flex-shrink-1 {
  flex-shrink: 1 !important;
}

.flex-wrap {
  flex-wrap: wrap !important;
}

.flex-nowrap {
  flex-wrap: nowrap !important;
}

.flex-wrap-reverse {
  flex-wrap: wrap-reverse !important;
}

.justify-content-start {
  justify-content: flex-start !important;
}

.justify-content-end {
  justify-content: flex-end !important;
}

.justify-content-center {
  justify-content: center !important;
}

.justify-content-between {
  justify-content: space-between !important;
}

.justify-content-around {
  justify-content: space-around !important;
}

.justify-content-evenly {
  justify-content: space-evenly !important;
}

.align-items-start {
  align-items: flex-start !important;
}

.align-items-end {
  align-items: flex-end !important;
}

.align-items-center {
  align-items: center !important;
}

.align-items-baseline {
  align-items: baseline !important;
}

.align-items-stretch {
  align-items: stretch !important;
}

.align-content-start {
  align-content: flex-start !important;
}

.align-content-end {
  align-content: flex-end !important;
}

.align-content-center {
  align-content: center !important;
}

.align-content-between {
  align-content: space-between !important;
}

.align-content-around {
  align-content: space-around !important;
}

.align-content-stretch {
  align-content: stretch !important;
}

.align-self-auto {
  align-self: auto !important;
}

.align-self-start {
  align-self: flex-start !important;
}

.align-self-end {
  align-self: flex-end !important;
}

.align-self-center {
  align-self: center !important;
}

.align-self-baseline {
  align-self: baseline !important;
}

.align-self-stretch {
  align-self: stretch !important;
}

.order-first {
  order: -1 !important;
}

.order-0 {
  order: 0 !important;
}

.order-1 {
  order: 1 !important;
}

.order-2 {
  order: 2 !important;
}

.order-3 {
  order: 3 !important;
}

.order-4 {
  order: 4 !important;
}

.order-5 {
  order: 5 !important;
}

.order-last {
  order: 6 !important;
}

.m-0 {
  margin: 0 !important;
}

.m-1 {
  margin: 0.25rem !important;
}

.m-2 {
  margin: 0.5rem !important;
}

.m-3 {
  margin: 0.75rem !important;
}

.m-4 {
  margin: 1rem !important;
}

.m-5 {
  margin: 1.25rem !important;
}

.m-6 {
  margin: 1.5rem !important;
}

.m-7 {
  margin: 1.75rem !important;
}

.m-8 {
  margin: 2rem !important;
}

.m-9 {
  margin: 2.25rem !important;
}

.m-10 {
  margin: 2.5rem !important;
}

.m-11 {
  margin: 2.75rem !important;
}

.m-12 {
  margin: 3rem !important;
}

.m-13 {
  margin: 3.25rem !important;
}

.m-14 {
  margin: 3.5rem !important;
}

.m-15 {
  margin: 3.75rem !important;
}

.m-16 {
  margin: 4rem !important;
}

.m-17 {
  margin: 4.25rem !important;
}

.m-18 {
  margin: 4.5rem !important;
}

.m-19 {
  margin: 4.75rem !important;
}

.m-20 {
  margin: 5rem !important;
}

.m-auto {
  margin: auto !important;
}

.mx-0 {
  margin-right: 0 !important;
  margin-left: 0 !important;
}

.mx-1 {
  margin-right: 0.25rem !important;
  margin-left: 0.25rem !important;
}

.mx-2 {
  margin-right: 0.5rem !important;
  margin-left: 0.5rem !important;
}

.mx-3 {
  margin-right: 0.75rem !important;
  margin-left: 0.75rem !important;
}

.mx-4 {
  margin-right: 1rem !important;
  margin-left: 1rem !important;
}

.mx-5 {
  margin-right: 1.25rem !important;
  margin-left: 1.25rem !important;
}

.mx-6 {
  margin-right: 1.5rem !important;
  margin-left: 1.5rem !important;
}

.mx-7 {
  margin-right: 1.75rem !important;
  margin-left: 1.75rem !important;
}

.mx-8 {
  margin-right: 2rem !important;
  margin-left: 2rem !important;
}

.mx-9 {
  margin-right: 2.25rem !important;
  margin-left: 2.25rem !important;
}

.mx-10 {
  margin-right: 2.5rem !important;
  margin-left: 2.5rem !important;
}

.mx-11 {
  margin-right: 2.75rem !important;
  margin-left: 2.75rem !important;
}

.mx-12 {
  margin-right: 3rem !important;
  margin-left: 3rem !important;
}

.mx-13 {
  margin-right: 3.25rem !important;
  margin-left: 3.25rem !important;
}

.mx-14 {
  margin-right: 3.5rem !important;
  margin-left: 3.5rem !important;
}

.mx-15 {
  margin-right: 3.75rem !important;
  margin-left: 3.75rem !important;
}

.mx-16 {
  margin-right: 4rem !important;
  margin-left: 4rem !important;
}

.mx-17 {
  margin-right: 4.25rem !important;
  margin-left: 4.25rem !important;
}

.mx-18 {
  margin-right: 4.5rem !important;
  margin-left: 4.5rem !important;
}

.mx-19 {
  margin-right: 4.75rem !important;
  margin-left: 4.75rem !important;
}

.mx-20 {
  margin-right: 5rem !important;
  margin-left: 5rem !important;
}

.mx-auto {
  margin-right: auto !important;
  margin-left: auto !important;
}

.my-0 {
  margin-top: 0 !important;
  margin-bottom: 0 !important;
}

.my-1 {
  margin-top: 0.25rem !important;
  margin-bottom: 0.25rem !important;
}

.my-2 {
  margin-top: 0.5rem !important;
  margin-bottom: 0.5rem !important;
}

.my-3 {
  margin-top: 0.75rem !important;
  margin-bottom: 0.75rem !important;
}

.my-4 {
  margin-top: 1rem !important;
  margin-bottom: 1rem !important;
}

.my-5 {
  margin-top: 1.25rem !important;
  margin-bottom: 1.25rem !important;
}

.my-6 {
  margin-top: 1.5rem !important;
  margin-bottom: 1.5rem !important;
}

.my-7 {
  margin-top: 1.75rem !important;
  margin-bottom: 1.75rem !important;
}

.my-8 {
  margin-top: 2rem !important;
  margin-bottom: 2rem !important;
}

.my-9 {
  margin-top: 2.25rem !important;
  margin-bottom: 2.25rem !important;
}

.my-10 {
  margin-top: 2.5rem !important;
  margin-bottom: 2.5rem !important;
}

.my-11 {
  margin-top: 2.75rem !important;
  margin-bottom: 2.75rem !important;
}

.my-12 {
  margin-top: 3rem !important;
  margin-bottom: 3rem !important;
}

.my-13 {
  margin-top: 3.25rem !important;
  margin-bottom: 3.25rem !important;
}

.my-14 {
  margin-top: 3.5rem !important;
  margin-bottom: 3.5rem !important;
}

.my-15 {
  margin-top: 3.75rem !important;
  margin-bottom: 3.75rem !important;
}

.my-16 {
  margin-top: 4rem !important;
  margin-bottom: 4rem !important;
}

.my-17 {
  margin-top: 4.25rem !important;
  margin-bottom: 4.25rem !important;
}

.my-18 {
  margin-top: 4.5rem !important;
  margin-bottom: 4.5rem !important;
}

.my-19 {
  margin-top: 4.75rem !important;
  margin-bottom: 4.75rem !important;
}

.my-20 {
  margin-top: 5rem !important;
  margin-bottom: 5rem !important;
}

.my-auto {
  margin-top: auto !important;
  margin-bottom: auto !important;
}

.mt-0 {
  margin-top: 0 !important;
}

.mt-1 {
  margin-top: 0.25rem !important;
}

.mt-2 {
  margin-top: 0.5rem !important;
}

.mt-3 {
  margin-top: 0.75rem !important;
}

.mt-4 {
  margin-top: 1rem !important;
}

.mt-5 {
  margin-top: 1.25rem !important;
}

.mt-6 {
  margin-top: 1.5rem !important;
}

.mt-7 {
  margin-top: 1.75rem !important;
}

.mt-8 {
  margin-top: 2rem !important;
}

.mt-9 {
  margin-top: 2.25rem !important;
}

.mt-10 {
  margin-top: 2.5rem !important;
}

.mt-11 {
  margin-top: 2.75rem !important;
}

.mt-12 {
  margin-top: 3rem !important;
}

.mt-13 {
  margin-top: 3.25rem !important;
}

.mt-14 {
  margin-top: 3.5rem !important;
}

.mt-15 {
  margin-top: 3.75rem !important;
}

.mt-16 {
  margin-top: 4rem !important;
}

.mt-17 {
  margin-top: 4.25rem !important;
}

.mt-18 {
  margin-top: 4.5rem !important;
}

.mt-19 {
  margin-top: 4.75rem !important;
}

.mt-20 {
  margin-top: 5rem !important;
}

.mt-auto {
  margin-top: auto !important;
}

.me-0 {
  margin-right: 0 !important;
}

.me-1 {
  margin-right: 0.25rem !important;
}

.me-2 {
  margin-right: 0.5rem !important;
}

.me-3 {
  margin-right: 0.75rem !important;
}

.me-4 {
  margin-right: 1rem !important;
}

.me-5 {
  margin-right: 1.25rem !important;
}

.me-6 {
  margin-right: 1.5rem !important;
}

.me-7 {
  margin-right: 1.75rem !important;
}

.me-8 {
  margin-right: 2rem !important;
}

.me-9 {
  margin-right: 2.25rem !important;
}

.me-10 {
  margin-right: 2.5rem !important;
}

.me-11 {
  margin-right: 2.75rem !important;
}

.me-12 {
  margin-right: 3rem !important;
}

.me-13 {
  margin-right: 3.25rem !important;
}

.me-14 {
  margin-right: 3.5rem !important;
}

.me-15 {
  margin-right: 3.75rem !important;
}

.me-16 {
  margin-right: 4rem !important;
}

.me-17 {
  margin-right: 4.25rem !important;
}

.me-18 {
  margin-right: 4.5rem !important;
}

.me-19 {
  margin-right: 4.75rem !important;
}

.me-20 {
  margin-right: 5rem !important;
}

.me-auto {
  margin-right: auto !important;
}

.mb-0 {
  margin-bottom: 0 !important;
}

.mb-1 {
  margin-bottom: 0.25rem !important;
}

.mb-2 {
  margin-bottom: 0.5rem !important;
}

.mb-3 {
  margin-bottom: 0.75rem !important;
}

.mb-4 {
  margin-bottom: 1rem !important;
}

.mb-5 {
  margin-bottom: 1.25rem !important;
}

.mb-6 {
  margin-bottom: 1.5rem !important;
}

.mb-7 {
  margin-bottom: 1.75rem !important;
}

.mb-8 {
  margin-bottom: 2rem !important;
}

.mb-9 {
  margin-bottom: 2.25rem !important;
}

.mb-10 {
  margin-bottom: 2.5rem !important;
}

.mb-11 {
  margin-bottom: 2.75rem !important;
}

.mb-12 {
  margin-bottom: 3rem !important;
}

.mb-13 {
  margin-bottom: 3.25rem !important;
}

.mb-14 {
  margin-bottom: 3.5rem !important;
}

.mb-15 {
  margin-bottom: 3.75rem !important;
}

.mb-16 {
  margin-bottom: 4rem !important;
}

.mb-17 {
  margin-bottom: 4.25rem !important;
}

.mb-18 {
  margin-bottom: 4.5rem !important;
}

.mb-19 {
  margin-bottom: 4.75rem !important;
}

.mb-20 {
  margin-bottom: 5rem !important;
}

.mb-auto {
  margin-bottom: auto !important;
}

.ms-0 {
  margin-left: 0 !important;
}

.ms-1 {
  margin-left: 0.25rem !important;
}

.ms-2 {
  margin-left: 0.5rem !important;
}

.ms-3 {
  margin-left: 0.75rem !important;
}

.ms-4 {
  margin-left: 1rem !important;
}

.ms-5 {
  margin-left: 1.25rem !important;
}

.ms-6 {
  margin-left: 1.5rem !important;
}

.ms-7 {
  margin-left: 1.75rem !important;
}

.ms-8 {
  margin-left: 2rem !important;
}

.ms-9 {
  margin-left: 2.25rem !important;
}

.ms-10 {
  margin-left: 2.5rem !important;
}

.ms-11 {
  margin-left: 2.75rem !important;
}

.ms-12 {
  margin-left: 3rem !important;
}

.ms-13 {
  margin-left: 3.25rem !important;
}

.ms-14 {
  margin-left: 3.5rem !important;
}

.ms-15 {
  margin-left: 3.75rem !important;
}

.ms-16 {
  margin-left: 4rem !important;
}

.ms-17 {
  margin-left: 4.25rem !important;
}

.ms-18 {
  margin-left: 4.5rem !important;
}

.ms-19 {
  margin-left: 4.75rem !important;
}

.ms-20 {
  margin-left: 5rem !important;
}

.ms-auto {
  margin-left: auto !important;
}

.m-n1 {
  margin: -0.25rem !important;
}

.m-n2 {
  margin: -0.5rem !important;
}

.m-n3 {
  margin: -0.75rem !important;
}

.m-n4 {
  margin: -1rem !important;
}

.m-n5 {
  margin: -1.25rem !important;
}

.m-n6 {
  margin: -1.5rem !important;
}

.m-n7 {
  margin: -1.75rem !important;
}

.m-n8 {
  margin: -2rem !important;
}

.m-n9 {
  margin: -2.25rem !important;
}

.m-n10 {
  margin: -2.5rem !important;
}

.m-n11 {
  margin: -2.75rem !important;
}

.m-n12 {
  margin: -3rem !important;
}

.m-n13 {
  margin: -3.25rem !important;
}

.m-n14 {
  margin: -3.5rem !important;
}

.m-n15 {
  margin: -3.75rem !important;
}

.m-n16 {
  margin: -4rem !important;
}

.m-n17 {
  margin: -4.25rem !important;
}

.m-n18 {
  margin: -4.5rem !important;
}

.m-n19 {
  margin: -4.75rem !important;
}

.m-n20 {
  margin: -5rem !important;
}

.mx-n1 {
  margin-right: -0.25rem !important;
  margin-left: -0.25rem !important;
}

.mx-n2 {
  margin-right: -0.5rem !important;
  margin-left: -0.5rem !important;
}

.mx-n3 {
  margin-right: -0.75rem !important;
  margin-left: -0.75rem !important;
}

.mx-n4 {
  margin-right: -1rem !important;
  margin-left: -1rem !important;
}

.mx-n5 {
  margin-right: -1.25rem !important;
  margin-left: -1.25rem !important;
}

.mx-n6 {
  margin-right: -1.5rem !important;
  margin-left: -1.5rem !important;
}

.mx-n7 {
  margin-right: -1.75rem !important;
  margin-left: -1.75rem !important;
}

.mx-n8 {
  margin-right: -2rem !important;
  margin-left: -2rem !important;
}

.mx-n9 {
  margin-right: -2.25rem !important;
  margin-left: -2.25rem !important;
}

.mx-n10 {
  margin-right: -2.5rem !important;
  margin-left: -2.5rem !important;
}

.mx-n11 {
  margin-right: -2.75rem !important;
  margin-left: -2.75rem !important;
}

.mx-n12 {
  margin-right: -3rem !important;
  margin-left: -3rem !important;
}

.mx-n13 {
  margin-right: -3.25rem !important;
  margin-left: -3.25rem !important;
}

.mx-n14 {
  margin-right: -3.5rem !important;
  margin-left: -3.5rem !important;
}

.mx-n15 {
  margin-right: -3.75rem !important;
  margin-left: -3.75rem !important;
}

.mx-n16 {
  margin-right: -4rem !important;
  margin-left: -4rem !important;
}

.mx-n17 {
  margin-right: -4.25rem !important;
  margin-left: -4.25rem !important;
}

.mx-n18 {
  margin-right: -4.5rem !important;
  margin-left: -4.5rem !important;
}

.mx-n19 {
  margin-right: -4.75rem !important;
  margin-left: -4.75rem !important;
}

.mx-n20 {
  margin-right: -5rem !important;
  margin-left: -5rem !important;
}

.my-n1 {
  margin-top: -0.25rem !important;
  margin-bottom: -0.25rem !important;
}

.my-n2 {
  margin-top: -0.5rem !important;
  margin-bottom: -0.5rem !important;
}

.my-n3 {
  margin-top: -0.75rem !important;
  margin-bottom: -0.75rem !important;
}

.my-n4 {
  margin-top: -1rem !important;
  margin-bottom: -1rem !important;
}

.my-n5 {
  margin-top: -1.25rem !important;
  margin-bottom: -1.25rem !important;
}

.my-n6 {
  margin-top: -1.5rem !important;
  margin-bottom: -1.5rem !important;
}

.my-n7 {
  margin-top: -1.75rem !important;
  margin-bottom: -1.75rem !important;
}

.my-n8 {
  margin-top: -2rem !important;
  margin-bottom: -2rem !important;
}

.my-n9 {
  margin-top: -2.25rem !important;
  margin-bottom: -2.25rem !important;
}

.my-n10 {
  margin-top: -2.5rem !important;
  margin-bottom: -2.5rem !important;
}

.my-n11 {
  margin-top: -2.75rem !important;
  margin-bottom: -2.75rem !important;
}

.my-n12 {
  margin-top: -3rem !important;
  margin-bottom: -3rem !important;
}

.my-n13 {
  margin-top: -3.25rem !important;
  margin-bottom: -3.25rem !important;
}

.my-n14 {
  margin-top: -3.5rem !important;
  margin-bottom: -3.5rem !important;
}

.my-n15 {
  margin-top: -3.75rem !important;
  margin-bottom: -3.75rem !important;
}

.my-n16 {
  margin-top: -4rem !important;
  margin-bottom: -4rem !important;
}

.my-n17 {
  margin-top: -4.25rem !important;
  margin-bottom: -4.25rem !important;
}

.my-n18 {
  margin-top: -4.5rem !important;
  margin-bottom: -4.5rem !important;
}

.my-n19 {
  margin-top: -4.75rem !important;
  margin-bottom: -4.75rem !important;
}

.my-n20 {
  margin-top: -5rem !important;
  margin-bottom: -5rem !important;
}

.mt-n1 {
  margin-top: -0.25rem !important;
}

.mt-n2 {
  margin-top: -0.5rem !important;
}

.mt-n3 {
  margin-top: -0.75rem !important;
}

.mt-n4 {
  margin-top: -1rem !important;
}

.mt-n5 {
  margin-top: -1.25rem !important;
}

.mt-n6 {
  margin-top: -1.5rem !important;
}

.mt-n7 {
  margin-top: -1.75rem !important;
}

.mt-n8 {
  margin-top: -2rem !important;
}

.mt-n9 {
  margin-top: -2.25rem !important;
}

.mt-n10 {
  margin-top: -2.5rem !important;
}

.mt-n11 {
  margin-top: -2.75rem !important;
}

.mt-n12 {
  margin-top: -3rem !important;
}

.mt-n13 {
  margin-top: -3.25rem !important;
}

.mt-n14 {
  margin-top: -3.5rem !important;
}

.mt-n15 {
  margin-top: -3.75rem !important;
}

.mt-n16 {
  margin-top: -4rem !important;
}

.mt-n17 {
  margin-top: -4.25rem !important;
}

.mt-n18 {
  margin-top: -4.5rem !important;
}

.mt-n19 {
  margin-top: -4.75rem !important;
}

.mt-n20 {
  margin-top: -5rem !important;
}

.me-n1 {
  margin-right: -0.25rem !important;
}

.me-n2 {
  margin-right: -0.5rem !important;
}

.me-n3 {
  margin-right: -0.75rem !important;
}

.me-n4 {
  margin-right: -1rem !important;
}

.me-n5 {
  margin-right: -1.25rem !important;
}

.me-n6 {
  margin-right: -1.5rem !important;
}

.me-n7 {
  margin-right: -1.75rem !important;
}

.me-n8 {
  margin-right: -2rem !important;
}

.me-n9 {
  margin-right: -2.25rem !important;
}

.me-n10 {
  margin-right: -2.5rem !important;
}

.me-n11 {
  margin-right: -2.75rem !important;
}

.me-n12 {
  margin-right: -3rem !important;
}

.me-n13 {
  margin-right: -3.25rem !important;
}

.me-n14 {
  margin-right: -3.5rem !important;
}

.me-n15 {
  margin-right: -3.75rem !important;
}

.me-n16 {
  margin-right: -4rem !important;
}

.me-n17 {
  margin-right: -4.25rem !important;
}

.me-n18 {
  margin-right: -4.5rem !important;
}

.me-n19 {
  margin-right: -4.75rem !important;
}

.me-n20 {
  margin-right: -5rem !important;
}

.mb-n1 {
  margin-bottom: -0.25rem !important;
}

.mb-n2 {
  margin-bottom: -0.5rem !important;
}

.mb-n3 {
  margin-bottom: -0.75rem !important;
}

.mb-n4 {
  margin-bottom: -1rem !important;
}

.mb-n5 {
  margin-bottom: -1.25rem !important;
}

.mb-n6 {
  margin-bottom: -1.5rem !important;
}

.mb-n7 {
  margin-bottom: -1.75rem !important;
}

.mb-n8 {
  margin-bottom: -2rem !important;
}

.mb-n9 {
  margin-bottom: -2.25rem !important;
}

.mb-n10 {
  margin-bottom: -2.5rem !important;
}

.mb-n11 {
  margin-bottom: -2.75rem !important;
}

.mb-n12 {
  margin-bottom: -3rem !important;
}

.mb-n13 {
  margin-bottom: -3.25rem !important;
}

.mb-n14 {
  margin-bottom: -3.5rem !important;
}

.mb-n15 {
  margin-bottom: -3.75rem !important;
}

.mb-n16 {
  margin-bottom: -4rem !important;
}

.mb-n17 {
  margin-bottom: -4.25rem !important;
}

.mb-n18 {
  margin-bottom: -4.5rem !important;
}

.mb-n19 {
  margin-bottom: -4.75rem !important;
}

.mb-n20 {
  margin-bottom: -5rem !important;
}

.ms-n1 {
  margin-left: -0.25rem !important;
}

.ms-n2 {
  margin-left: -0.5rem !important;
}

.ms-n3 {
  margin-left: -0.75rem !important;
}

.ms-n4 {
  margin-left: -1rem !important;
}

.ms-n5 {
  margin-left: -1.25rem !important;
}

.ms-n6 {
  margin-left: -1.5rem !important;
}

.ms-n7 {
  margin-left: -1.75rem !important;
}

.ms-n8 {
  margin-left: -2rem !important;
}

.ms-n9 {
  margin-left: -2.25rem !important;
}

.ms-n10 {
  margin-left: -2.5rem !important;
}

.ms-n11 {
  margin-left: -2.75rem !important;
}

.ms-n12 {
  margin-left: -3rem !important;
}

.ms-n13 {
  margin-left: -3.25rem !important;
}

.ms-n14 {
  margin-left: -3.5rem !important;
}

.ms-n15 {
  margin-left: -3.75rem !important;
}

.ms-n16 {
  margin-left: -4rem !important;
}

.ms-n17 {
  margin-left: -4.25rem !important;
}

.ms-n18 {
  margin-left: -4.5rem !important;
}

.ms-n19 {
  margin-left: -4.75rem !important;
}

.ms-n20 {
  margin-left: -5rem !important;
}

.p-0 {
  padding: 0 !important;
}

.p-1 {
  padding: 0.25rem !important;
}

.p-2 {
  padding: 0.5rem !important;
}

.p-3 {
  padding: 0.75rem !important;
}

.p-4 {
  padding: 1rem !important;
}

.p-5 {
  padding: 1.25rem !important;
}

.p-6 {
  padding: 1.5rem !important;
}

.p-7 {
  padding: 1.75rem !important;
}

.p-8 {
  padding: 2rem !important;
}

.p-9 {
  padding: 2.25rem !important;
}

.p-10 {
  padding: 2.5rem !important;
}

.p-11 {
  padding: 2.75rem !important;
}

.p-12 {
  padding: 3rem !important;
}

.p-13 {
  padding: 3.25rem !important;
}

.p-14 {
  padding: 3.5rem !important;
}

.p-15 {
  padding: 3.75rem !important;
}

.p-16 {
  padding: 4rem !important;
}

.p-17 {
  padding: 4.25rem !important;
}

.p-18 {
  padding: 4.5rem !important;
}

.p-19 {
  padding: 4.75rem !important;
}

.p-20 {
  padding: 5rem !important;
}

.px-0 {
  padding-right: 0 !important;
  padding-left: 0 !important;
}

.px-1 {
  padding-right: 0.25rem !important;
  padding-left: 0.25rem !important;
}

.px-2 {
  padding-right: 0.5rem !important;
  padding-left: 0.5rem !important;
}

.px-3 {
  padding-right: 0.75rem !important;
  padding-left: 0.75rem !important;
}

.px-4 {
  padding-right: 1rem !important;
  padding-left: 1rem !important;
}

.px-5 {
  padding-right: 1.25rem !important;
  padding-left: 1.25rem !important;
}

.px-6 {
  padding-right: 1.5rem !important;
  padding-left: 1.5rem !important;
}

.px-7 {
  padding-right: 1.75rem !important;
  padding-left: 1.75rem !important;
}

.px-8 {
  padding-right: 2rem !important;
  padding-left: 2rem !important;
}

.px-9 {
  padding-right: 2.25rem !important;
  padding-left: 2.25rem !important;
}

.px-10 {
  padding-right: 2.5rem !important;
  padding-left: 2.5rem !important;
}

.px-11 {
  padding-right: 2.75rem !important;
  padding-left: 2.75rem !important;
}

.px-12 {
  padding-right: 3rem !important;
  padding-left: 3rem !important;
}

.px-13 {
  padding-right: 3.25rem !important;
  padding-left: 3.25rem !important;
}

.px-14 {
  padding-right: 3.5rem !important;
  padding-left: 3.5rem !important;
}

.px-15 {
  padding-right: 3.75rem !important;
  padding-left: 3.75rem !important;
}

.px-16 {
  padding-right: 4rem !important;
  padding-left: 4rem !important;
}

.px-17 {
  padding-right: 4.25rem !important;
  padding-left: 4.25rem !important;
}

.px-18 {
  padding-right: 4.5rem !important;
  padding-left: 4.5rem !important;
}

.px-19 {
  padding-right: 4.75rem !important;
  padding-left: 4.75rem !important;
}

.px-20 {
  padding-right: 5rem !important;
  padding-left: 5rem !important;
}

.py-0 {
  padding-top: 0 !important;
  padding-bottom: 0 !important;
}

.py-1 {
  padding-top: 0.25rem !important;
  padding-bottom: 0.25rem !important;
}

.py-2 {
  padding-top: 0.5rem !important;
  padding-bottom: 0.5rem !important;
}

.py-3 {
  padding-top: 0.75rem !important;
  padding-bottom: 0.75rem !important;
}

.py-4 {
  padding-top: 1rem !important;
  padding-bottom: 1rem !important;
}

.py-5 {
  padding-top: 1.25rem !important;
  padding-bottom: 1.25rem !important;
}

.py-6 {
  padding-top: 1.5rem !important;
  padding-bottom: 1.5rem !important;
}

.py-7 {
  padding-top: 1.75rem !important;
  padding-bottom: 1.75rem !important;
}

.py-8 {
  padding-top: 2rem !important;
  padding-bottom: 2rem !important;
}

.py-9 {
  padding-top: 2.25rem !important;
  padding-bottom: 2.25rem !important;
}

.py-10 {
  padding-top: 2.5rem !important;
  padding-bottom: 2.5rem !important;
}

.py-11 {
  padding-top: 2.75rem !important;
  padding-bottom: 2.75rem !important;
}

.py-12 {
  padding-top: 3rem !important;
  padding-bottom: 3rem !important;
}

.py-13 {
  padding-top: 3.25rem !important;
  padding-bottom: 3.25rem !important;
}

.py-14 {
  padding-top: 3.5rem !important;
  padding-bottom: 3.5rem !important;
}

.py-15 {
  padding-top: 3.75rem !important;
  padding-bottom: 3.75rem !important;
}

.py-16 {
  padding-top: 4rem !important;
  padding-bottom: 4rem !important;
}

.py-17 {
  padding-top: 4.25rem !important;
  padding-bottom: 4.25rem !important;
}

.py-18 {
  padding-top: 4.5rem !important;
  padding-bottom: 4.5rem !important;
}

.py-19 {
  padding-top: 4.75rem !important;
  padding-bottom: 4.75rem !important;
}

.py-20 {
  padding-top: 5rem !important;
  padding-bottom: 5rem !important;
}

.pt-0 {
  padding-top: 0 !important;
}

.pt-1 {
  padding-top: 0.25rem !important;
}

.pt-2 {
  padding-top: 0.5rem !important;
}

.pt-3 {
  padding-top: 0.75rem !important;
}

.pt-4 {
  padding-top: 1rem !important;
}

.pt-5 {
  padding-top: 1.25rem !important;
}

.pt-6 {
  padding-top: 1.5rem !important;
}

.pt-7 {
  padding-top: 1.75rem !important;
}

.pt-8 {
  padding-top: 2rem !important;
}

.pt-9 {
  padding-top: 2.25rem !important;
}

.pt-10 {
  padding-top: 2.5rem !important;
}

.pt-11 {
  padding-top: 2.75rem !important;
}

.pt-12 {
  padding-top: 3rem !important;
}

.pt-13 {
  padding-top: 3.25rem !important;
}

.pt-14 {
  padding-top: 3.5rem !important;
}

.pt-15 {
  padding-top: 3.75rem !important;
}

.pt-16 {
  padding-top: 4rem !important;
}

.pt-17 {
  padding-top: 4.25rem !important;
}

.pt-18 {
  padding-top: 4.5rem !important;
}

.pt-19 {
  padding-top: 4.75rem !important;
}

.pt-20 {
  padding-top: 5rem !important;
}

.pe-0 {
  padding-right: 0 !important;
}

.pe-1 {
  padding-right: 0.25rem !important;
}

.pe-2 {
  padding-right: 0.5rem !important;
}

.pe-3 {
  padding-right: 0.75rem !important;
}

.pe-4 {
  padding-right: 1rem !important;
}

.pe-5 {
  padding-right: 1.25rem !important;
}

.pe-6 {
  padding-right: 1.5rem !important;
}

.pe-7 {
  padding-right: 1.75rem !important;
}

.pe-8 {
  padding-right: 2rem !important;
}

.pe-9 {
  padding-right: 2.25rem !important;
}

.pe-10 {
  padding-right: 2.5rem !important;
}

.pe-11 {
  padding-right: 2.75rem !important;
}

.pe-12 {
  padding-right: 3rem !important;
}

.pe-13 {
  padding-right: 3.25rem !important;
}

.pe-14 {
  padding-right: 3.5rem !important;
}

.pe-15 {
  padding-right: 3.75rem !important;
}

.pe-16 {
  padding-right: 4rem !important;
}

.pe-17 {
  padding-right: 4.25rem !important;
}

.pe-18 {
  padding-right: 4.5rem !important;
}

.pe-19 {
  padding-right: 4.75rem !important;
}

.pe-20 {
  padding-right: 5rem !important;
}

.pb-0 {
  padding-bottom: 0 !important;
}

.pb-1 {
  padding-bottom: 0.25rem !important;
}

.pb-2 {
  padding-bottom: 0.5rem !important;
}

.pb-3 {
  padding-bottom: 0.75rem !important;
}

.pb-4 {
  padding-bottom: 1rem !important;
}

.pb-5 {
  padding-bottom: 1.25rem !important;
}

.pb-6 {
  padding-bottom: 1.5rem !important;
}

.pb-7 {
  padding-bottom: 1.75rem !important;
}

.pb-8 {
  padding-bottom: 2rem !important;
}

.pb-9 {
  padding-bottom: 2.25rem !important;
}

.pb-10 {
  padding-bottom: 2.5rem !important;
}

.pb-11 {
  padding-bottom: 2.75rem !important;
}

.pb-12 {
  padding-bottom: 3rem !important;
}

.pb-13 {
  padding-bottom: 3.25rem !important;
}

.pb-14 {
  padding-bottom: 3.5rem !important;
}

.pb-15 {
  padding-bottom: 3.75rem !important;
}

.pb-16 {
  padding-bottom: 4rem !important;
}

.pb-17 {
  padding-bottom: 4.25rem !important;
}

.pb-18 {
  padding-bottom: 4.5rem !important;
}

.pb-19 {
  padding-bottom: 4.75rem !important;
}

.pb-20 {
  padding-bottom: 5rem !important;
}

.ps-0 {
  padding-left: 0 !important;
}

.ps-1 {
  padding-left: 0.25rem !important;
}

.ps-2 {
  padding-left: 0.5rem !important;
}

.ps-3 {
  padding-left: 0.75rem !important;
}

.ps-4 {
  padding-left: 1rem !important;
}

.ps-5 {
  padding-left: 1.25rem !important;
}

.ps-6 {
  padding-left: 1.5rem !important;
}

.ps-7 {
  padding-left: 1.75rem !important;
}

.ps-8 {
  padding-left: 2rem !important;
}

.ps-9 {
  padding-left: 2.25rem !important;
}

.ps-10 {
  padding-left: 2.5rem !important;
}

.ps-11 {
  padding-left: 2.75rem !important;
}

.ps-12 {
  padding-left: 3rem !important;
}

.ps-13 {
  padding-left: 3.25rem !important;
}

.ps-14 {
  padding-left: 3.5rem !important;
}

.ps-15 {
  padding-left: 3.75rem !important;
}

.ps-16 {
  padding-left: 4rem !important;
}

.ps-17 {
  padding-left: 4.25rem !important;
}

.ps-18 {
  padding-left: 4.5rem !important;
}

.ps-19 {
  padding-left: 4.75rem !important;
}

.ps-20 {
  padding-left: 5rem !important;
}

.gap-0 {
  gap: 0 !important;
}

.gap-1 {
  gap: 0.25rem !important;
}

.gap-2 {
  gap: 0.5rem !important;
}

.gap-3 {
  gap: 0.75rem !important;
}

.gap-4 {
  gap: 1rem !important;
}

.gap-5 {
  gap: 1.25rem !important;
}

.gap-6 {
  gap: 1.5rem !important;
}

.gap-7 {
  gap: 1.75rem !important;
}

.gap-8 {
  gap: 2rem !important;
}

.gap-9 {
  gap: 2.25rem !important;
}

.gap-10 {
  gap: 2.5rem !important;
}

.gap-11 {
  gap: 2.75rem !important;
}

.gap-12 {
  gap: 3rem !important;
}

.gap-13 {
  gap: 3.25rem !important;
}

.gap-14 {
  gap: 3.5rem !important;
}

.gap-15 {
  gap: 3.75rem !important;
}

.gap-16 {
  gap: 4rem !important;
}

.gap-17 {
  gap: 4.25rem !important;
}

.gap-18 {
  gap: 4.5rem !important;
}

.gap-19 {
  gap: 4.75rem !important;
}

.gap-20 {
  gap: 5rem !important;
}

.row-gap-0 {
  row-gap: 0 !important;
}

.row-gap-1 {
  row-gap: 0.25rem !important;
}

.row-gap-2 {
  row-gap: 0.5rem !important;
}

.row-gap-3 {
  row-gap: 0.75rem !important;
}

.row-gap-4 {
  row-gap: 1rem !important;
}

.row-gap-5 {
  row-gap: 1.25rem !important;
}

.row-gap-6 {
  row-gap: 1.5rem !important;
}

.row-gap-7 {
  row-gap: 1.75rem !important;
}

.row-gap-8 {
  row-gap: 2rem !important;
}

.row-gap-9 {
  row-gap: 2.25rem !important;
}

.row-gap-10 {
  row-gap: 2.5rem !important;
}

.row-gap-11 {
  row-gap: 2.75rem !important;
}

.row-gap-12 {
  row-gap: 3rem !important;
}

.row-gap-13 {
  row-gap: 3.25rem !important;
}

.row-gap-14 {
  row-gap: 3.5rem !important;
}

.row-gap-15 {
  row-gap: 3.75rem !important;
}

.row-gap-16 {
  row-gap: 4rem !important;
}

.row-gap-17 {
  row-gap: 4.25rem !important;
}

.row-gap-18 {
  row-gap: 4.5rem !important;
}

.row-gap-19 {
  row-gap: 4.75rem !important;
}

.row-gap-20 {
  row-gap: 5rem !important;
}

.column-gap-0 {
  column-gap: 0 !important;
}

.column-gap-1 {
  column-gap: 0.25rem !important;
}

.column-gap-2 {
  column-gap: 0.5rem !important;
}

.column-gap-3 {
  column-gap: 0.75rem !important;
}

.column-gap-4 {
  column-gap: 1rem !important;
}

.column-gap-5 {
  column-gap: 1.25rem !important;
}

.column-gap-6 {
  column-gap: 1.5rem !important;
}

.column-gap-7 {
  column-gap: 1.75rem !important;
}

.column-gap-8 {
  column-gap: 2rem !important;
}

.column-gap-9 {
  column-gap: 2.25rem !important;
}

.column-gap-10 {
  column-gap: 2.5rem !important;
}

.column-gap-11 {
  column-gap: 2.75rem !important;
}

.column-gap-12 {
  column-gap: 3rem !important;
}

.column-gap-13 {
  column-gap: 3.25rem !important;
}

.column-gap-14 {
  column-gap: 3.5rem !important;
}

.column-gap-15 {
  column-gap: 3.75rem !important;
}

.column-gap-16 {
  column-gap: 4rem !important;
}

.column-gap-17 {
  column-gap: 4.25rem !important;
}

.column-gap-18 {
  column-gap: 4.5rem !important;
}

.column-gap-19 {
  column-gap: 4.75rem !important;
}

.column-gap-20 {
  column-gap: 5rem !important;
}

.font-monospace {
  font-family: var(--bs-font-monospace) !important;
}

.fs-1 {
  font-size: calc(1.3rem + 0.6vw) !important;
}

.fs-2 {
  font-size: calc(1.275rem + 0.3vw) !important;
}

.fs-3 {
  font-size: calc(1.26rem + 0.12vw) !important;
}

.fs-4 {
  font-size: 1.25rem !important;
}

.fs-5 {
  font-size: 1.15rem !important;
}

.fs-6 {
  font-size: 1.075rem !important;
}

.fs-7 {
  font-size: 0.95rem !important;
}

.fs-8 {
  font-size: 0.85rem !important;
}

.fs-9 {
  font-size: 0.75rem !important;
}

.fs-10 {
  font-size: 0.5rem !important;
}

.fs-base {
  font-size: 1rem !important;
}

.fs-fluid {
  font-size: 100% !important;
}

.fs-2x {
  font-size: calc(1.325rem + 0.9vw) !important;
}

.fs-2qx {
  font-size: calc(1.35rem + 1.2vw) !important;
}

.fs-2hx {
  font-size: calc(1.375rem + 1.5vw) !important;
}

.fs-2tx {
  font-size: calc(1.4rem + 1.8vw) !important;
}

.fs-3x {
  font-size: calc(1.425rem + 2.1vw) !important;
}

.fs-3qx {
  font-size: calc(1.45rem + 2.4vw) !important;
}

.fs-3hx {
  font-size: calc(1.475rem + 2.7vw) !important;
}

.fs-3tx {
  font-size: calc(1.5rem + 3vw) !important;
}

.fs-4x {
  font-size: calc(1.525rem + 3.3vw) !important;
}

.fs-4qx {
  font-size: calc(1.55rem + 3.6vw) !important;
}

.fs-4hx {
  font-size: calc(1.575rem + 3.9vw) !important;
}

.fs-4tx {
  font-size: calc(1.6rem + 4.2vw) !important;
}

.fs-5x {
  font-size: calc(1.625rem + 4.5vw) !important;
}

.fs-5qx {
  font-size: calc(1.65rem + 4.8vw) !important;
}

.fs-5hx {
  font-size: calc(1.675rem + 5.1vw) !important;
}

.fs-5tx {
  font-size: calc(1.7rem + 5.4vw) !important;
}

.fs-6x {
  font-size: calc(1.725rem + 5.7vw) !important;
}

.fs-6qx {
  font-size: calc(1.75rem + 6vw) !important;
}

.fs-6hx {
  font-size: calc(1.775rem + 6.3vw) !important;
}

.fs-6tx {
  font-size: calc(1.8rem + 6.6vw) !important;
}

.fs-7x {
  font-size: calc(1.825rem + 6.9vw) !important;
}

.fs-7qx {
  font-size: calc(1.85rem + 7.2vw) !important;
}

.fs-7hx {
  font-size: calc(1.875rem + 7.5vw) !important;
}

.fs-7tx {
  font-size: calc(1.9rem + 7.8vw) !important;
}

.fst-italic {
  font-style: italic !important;
}

.fst-normal {
  font-style: normal !important;
}

.fw-lighter {
  font-weight: lighter !important;
}

.fw-light {
  font-weight: 300 !important;
}

.fw-normal {
  font-weight: 400 !important;
}

.fw-medium {
  font-weight: 500 !important;
}

.fw-semibold {
  font-weight: 500 !important;
}

.fw-bold {
  font-weight: 600 !important;
}

.fw-bolder {
  font-weight: 700 !important;
}

.lh-0 {
  line-height: 0 !important;
}

.lh-1 {
  line-height: 1 !important;
}

.lh-sm {
  line-height: 1.25 !important;
}

.lh-base {
  line-height: 1.5 !important;
}

.lh-lg {
  line-height: 1.75 !important;
}

.lh-xl {
  line-height: 2 !important;
}

.lh-xxl {
  line-height: 2.25 !important;
}

.text-start {
  text-align: left !important;
}

.text-end {
  text-align: right !important;
}

.text-center {
  text-align: center !important;
}

.text-decoration-none {
  text-decoration: none !important;
}

.text-decoration-underline {
  text-decoration: underline !important;
}

.text-decoration-line-through {
  text-decoration: line-through !important;
}

.text-lowercase {
  text-transform: lowercase !important;
}

.text-uppercase {
  text-transform: uppercase !important;
}

.text-capitalize {
  text-transform: capitalize !important;
}

.text-wrap {
  white-space: normal !important;
}

.text-nowrap {
  white-space: nowrap !important;
}

/* rtl:begin:remove */
.text-break {
  word-wrap: break-word !important;
  word-break: break-word !important;
}

/* rtl:end:remove */
.text-light {
  --bs-text-opacity: 1;
  color: rgba(var(--bs-light-rgb), var(--bs-text-opacity)) !important;
}

.text-primary {
  --bs-text-opacity: 1;
  color: rgba(var(--bs-primary-rgb), var(--bs-text-opacity)) !important;
}

.text-secondary {
  --bs-text-opacity: 1;
  color: rgba(var(--bs-secondary-rgb), var(--bs-text-opacity)) !important;
}

.text-success {
  --bs-text-opacity: 1;
  color: rgba(var(--bs-success-rgb), var(--bs-text-opacity)) !important;
}

.text-info {
  --bs-text-opacity: 1;
  color: rgba(var(--bs-info-rgb), var(--bs-text-opacity)) !important;
}

.text-warning {
  --bs-text-opacity: 1;
  color: rgba(var(--bs-warning-rgb), var(--bs-text-opacity)) !important;
}

.text-danger {
  --bs-text-opacity: 1;
  color: rgba(var(--bs-danger-rgb), var(--bs-text-opacity)) !important;
}

.text-dark {
  --bs-text-opacity: 1;
  color: rgba(var(--bs-dark-rgb), var(--bs-text-opacity)) !important;
}

.text-black {
  --bs-text-opacity: 1;
  color: rgba(var(--bs-black-rgb), var(--bs-text-opacity)) !important;
}

.text-white {
  --bs-text-opacity: 1;
  color: rgba(var(--bs-white-rgb), var(--bs-text-opacity)) !important;
}

.text-body {
  --bs-text-opacity: 1;
  color: rgba(var(--bs-body-color-rgb), var(--bs-text-opacity)) !important;
}

.text-muted {
  --bs-text-opacity: 1;
  color: #A1A5B7 !important;
}

.text-black-50 {
  --bs-text-opacity: 1;
  color: rgba(0, 0, 0, 0.5) !important;
}

.text-white-50 {
  --bs-text-opacity: 1;
  color: rgba(255, 255, 255, 0.5) !important;
}

.text-body-secondary {
  --bs-text-opacity: 1;
  color: var(--bs-secondary-color) !important;
}

.text-body-tertiary {
  --bs-text-opacity: 1;
  color: var(--bs-tertiary-color) !important;
}

.text-body-emphasis {
  --bs-text-opacity: 1;
  color: var(--bs-emphasis-color) !important;
}

.text-reset {
  --bs-text-opacity: 1;
  color: inherit !important;
}

.text-opacity-25 {
  --bs-text-opacity: 0.25;
}

.text-opacity-50 {
  --bs-text-opacity: 0.5;
}

.text-opacity-75 {
  --bs-text-opacity: 0.75;
}

.text-opacity-100 {
  --bs-text-opacity: 1;
}

.text-primary-emphasis {
  color: var(--bs-primary-text) !important;
}

.text-secondary-emphasis {
  color: var(--bs-secondary-text) !important;
}

.text-success-emphasis {
  color: var(--bs-success-text) !important;
}

.text-info-emphasis {
  color: var(--bs-info-text) !important;
}

.text-warning-emphasis {
  color: var(--bs-warning-text) !important;
}

.text-danger-emphasis {
  color: var(--bs-danger-text) !important;
}

.text-light-emphasis {
  color: var(--bs-light-text) !important;
}

.text-dark-emphasis {
  color: var(--bs-dark-text) !important;
}

.bg-light {
  --bs-bg-opacity: 1;
  background-color: rgba(var(--bs-light-rgb), var(--bs-bg-opacity)) !important;
}

.bg-primary {
  --bs-bg-opacity: 1;
  background-color: rgba(var(--bs-primary-rgb), var(--bs-bg-opacity)) !important;
}

.bg-secondary {
  --bs-bg-opacity: 1;
  background-color: rgba(var(--bs-secondary-rgb), var(--bs-bg-opacity)) !important;
}

.bg-success {
  --bs-bg-opacity: 1;
  background-color: rgba(var(--bs-success-rgb), var(--bs-bg-opacity)) !important;
}

.bg-info {
  --bs-bg-opacity: 1;
  background-color: rgba(var(--bs-info-rgb), var(--bs-bg-opacity)) !important;
}

.bg-warning {
  --bs-bg-opacity: 1;
  background-color: rgba(var(--bs-warning-rgb), var(--bs-bg-opacity)) !important;
}

.bg-danger {
  --bs-bg-opacity: 1;
  background-color: rgba(var(--bs-danger-rgb), var(--bs-bg-opacity)) !important;
}

.bg-dark {
  --bs-bg-opacity: 1;
  background-color: rgba(var(--bs-dark-rgb), var(--bs-bg-opacity)) !important;
}

.bg-black {
  --bs-bg-opacity: 1;
  background-color: rgba(var(--bs-black-rgb), var(--bs-bg-opacity)) !important;
}

.bg-white {
  --bs-bg-opacity: 1;
  background-color: rgba(var(--bs-white-rgb), var(--bs-bg-opacity)) !important;
}

.bg-body {
  --bs-bg-opacity: 1;
  background-color: rgba(var(--bs-body-bg-rgb), var(--bs-bg-opacity)) !important;
}

.bg-transparent {
  --bs-bg-opacity: 1;
  background-color: transparent !important;
}

.bg-body-secondary {
  --bs-bg-opacity: 1;
  background-color: rgba(var(--bs-secondary-bg-rgb), var(--bs-bg-opacity)) !important;
}

.bg-body-tertiary {
  --bs-bg-opacity: 1;
  background-color: rgba(var(--bs-tertiary-bg-rgb), var(--bs-bg-opacity)) !important;
}

.bg-body-emphasis {
  --bs-bg-opacity: 1;
  background-color: rgba(var(--bs-emphasis-bg-rgb), var(--bs-bg-opacity)) !important;
}

.bg-opacity-10 {
  --bs-bg-opacity: 0.1;
}

.bg-opacity-25 {
  --bs-bg-opacity: 0.25;
}

.bg-opacity-50 {
  --bs-bg-opacity: 0.5;
}

.bg-opacity-75 {
  --bs-bg-opacity: 0.75;
}

.bg-opacity-100 {
  --bs-bg-opacity: 1;
}

.bg-primary-subtle {
  background-color: var(--bs-primary-bg-subtle) !important;
}

.bg-secondary-subtle {
  background-color: var(--bs-secondary-bg-subtle) !important;
}

.bg-success-subtle {
  background-color: var(--bs-success-bg-subtle) !important;
}

.bg-info-subtle {
  background-color: var(--bs-info-bg-subtle) !important;
}

.bg-warning-subtle {
  background-color: var(--bs-warning-bg-subtle) !important;
}

.bg-danger-subtle {
  background-color: var(--bs-danger-bg-subtle) !important;
}

.bg-light-subtle {
  background-color: var(--bs-light-bg-subtle) !important;
}

.bg-dark-subtle {
  background-color: var(--bs-dark-bg-subtle) !important;
}

.bg-gradient {
  background-image: var(--bs-gradient) !important;
}

.user-select-all {
  -webkit-user-select: all !important;
          user-select: all !important;
}

.user-select-auto {
  -webkit-user-select: auto !important;
          user-select: auto !important;
}

.user-select-none {
  -webkit-user-select: none !important;
          user-select: none !important;
}

.pe-none {
  pointer-events: none !important;
}

.pe-auto {
  pointer-events: auto !important;
}

.rounded {
  border-radius: 0.475rem !important;
}

.rounded-0 {
  border-radius: 0 !important;
}

.rounded-1 {
  border-radius: 0.425rem !important;
}

.rounded-2 {
  border-radius: 0.475rem !important;
}

.rounded-3 {
  border-radius: 0.625rem !important;
}

.rounded-4 {
  border-radius: 1rem !important;
}

.rounded-circle {
  border-radius: 50% !important;
}

.rounded-pill {
  border-radius: 50rem !important;
}

.rounded-top {
  border-top-left-radius: var(--bs-border-radius) !important;
  border-top-right-radius: var(--bs-border-radius) !important;
}

.rounded-top-0 {
  border-top-left-radius: 0 !important;
  border-top-right-radius: 0 !important;
}

.rounded-top-1 {
  border-top-left-radius: var(--bs-border-radius-sm) !important;
  border-top-right-radius: var(--bs-border-radius-sm) !important;
}

.rounded-top-2 {
  border-top-left-radius: var(--bs-border-radius) !important;
  border-top-right-radius: var(--bs-border-radius) !important;
}

.rounded-top-3 {
  border-top-left-radius: var(--bs-border-radius-lg) !important;
  border-top-right-radius: var(--bs-border-radius-lg) !important;
}

.rounded-top-4 {
  border-top-left-radius: var(--bs-border-radius-xl) !important;
  border-top-right-radius: var(--bs-border-radius-xl) !important;
}

.rounded-top-5 {
  border-top-left-radius: var(--bs-border-radius-2xl) !important;
  border-top-right-radius: var(--bs-border-radius-2xl) !important;
}

.rounded-top-circle {
  border-top-left-radius: 50% !important;
  border-top-right-radius: 50% !important;
}

.rounded-top-pill {
  border-top-left-radius: var(--bs-border-radius-pill) !important;
  border-top-right-radius: var(--bs-border-radius-pill) !important;
}

.rounded-end {
  border-top-right-radius: var(--bs-border-radius) !important;
  border-bottom-right-radius: var(--bs-border-radius) !important;
}

.rounded-end-0 {
  border-top-right-radius: 0 !important;
  border-bottom-right-radius: 0 !important;
}

.rounded-end-1 {
  border-top-right-radius: var(--bs-border-radius-sm) !important;
  border-bottom-right-radius: var(--bs-border-radius-sm) !important;
}

.rounded-end-2 {
  border-top-right-radius: var(--bs-border-radius) !important;
  border-bottom-right-radius: var(--bs-border-radius) !important;
}

.rounded-end-3 {
  border-top-right-radius: var(--bs-border-radius-lg) !important;
  border-bottom-right-radius: var(--bs-border-radius-lg) !important;
}

.rounded-end-4 {
  border-top-right-radius: var(--bs-border-radius-xl) !important;
  border-bottom-right-radius: var(--bs-border-radius-xl) !important;
}

.rounded-end-5 {
  border-top-right-radius: var(--bs-border-radius-2xl) !important;
  border-bottom-right-radius: var(--bs-border-radius-2xl) !important;
}

.rounded-end-circle {
  border-top-right-radius: 50% !important;
  border-bottom-right-radius: 50% !important;
}

.rounded-end-pill {
  border-top-right-radius: var(--bs-border-radius-pill) !important;
  border-bottom-right-radius: var(--bs-border-radius-pill) !important;
}

.rounded-bottom {
  border-bottom-right-radius: var(--bs-border-radius) !important;
  border-bottom-left-radius: var(--bs-border-radius) !important;
}

.rounded-bottom-0 {
  border-bottom-right-radius: 0 !important;
  border-bottom-left-radius: 0 !important;
}

.rounded-bottom-1 {
  border-bottom-right-radius: var(--bs-border-radius-sm) !important;
  border-bottom-left-radius: var(--bs-border-radius-sm) !important;
}

.rounded-bottom-2 {
  border-bottom-right-radius: var(--bs-border-radius) !important;
  border-bottom-left-radius: var(--bs-border-radius) !important;
}

.rounded-bottom-3 {
  border-bottom-right-radius: var(--bs-border-radius-lg) !important;
  border-bottom-left-radius: var(--bs-border-radius-lg) !important;
}

.rounded-bottom-4 {
  border-bottom-right-radius: var(--bs-border-radius-xl) !important;
  border-bottom-left-radius: var(--bs-border-radius-xl) !important;
}

.rounded-bottom-5 {
  border-bottom-right-radius: var(--bs-border-radius-2xl) !important;
  border-bottom-left-radius: var(--bs-border-radius-2xl) !important;
}

.rounded-bottom-circle {
  border-bottom-right-radius: 50% !important;
  border-bottom-left-radius: 50% !important;
}

.rounded-bottom-pill {
  border-bottom-right-radius: var(--bs-border-radius-pill) !important;
  border-bottom-left-radius: var(--bs-border-radius-pill) !important;
}

.rounded-start {
  border-bottom-left-radius: var(--bs-border-radius) !important;
  border-top-left-radius: var(--bs-border-radius) !important;
}

.rounded-start-0 {
  border-bottom-left-radius: 0 !important;
  border-top-left-radius: 0 !important;
}

.rounded-start-1 {
  border-bottom-left-radius: var(--bs-border-radius-sm) !important;
  border-top-left-radius: var(--bs-border-radius-sm) !important;
}

.rounded-start-2 {
  border-bottom-left-radius: var(--bs-border-radius) !important;
  border-top-left-radius: var(--bs-border-radius) !important;
}

.rounded-start-3 {
  border-bottom-left-radius: var(--bs-border-radius-lg) !important;
  border-top-left-radius: var(--bs-border-radius-lg) !important;
}

.rounded-start-4 {
  border-bottom-left-radius: var(--bs-border-radius-xl) !important;
  border-top-left-radius: var(--bs-border-radius-xl) !important;
}

.rounded-start-5 {
  border-bottom-left-radius: var(--bs-border-radius-2xl) !important;
  border-top-left-radius: var(--bs-border-radius-2xl) !important;
}

.rounded-start-circle {
  border-bottom-left-radius: 50% !important;
  border-top-left-radius: 50% !important;
}

.rounded-start-pill {
  border-bottom-left-radius: var(--bs-border-radius-pill) !important;
  border-top-left-radius: var(--bs-border-radius-pill) !important;
}

.visible {
  visibility: visible !important;
}

.invisible {
  visibility: hidden !important;
}

.z-index-n1 {
  z-index: -1 !important;
}

.z-index-n2 {
  z-index: -2 !important;
}

.z-index-0 {
  z-index: 0 !important;
}

.z-index-1 {
  z-index: 1 !important;
}

.z-index-2 {
  z-index: 2 !important;
}

.z-index-3 {
  z-index: 3 !important;
}

.opacity-0 {
  opacity: 0 !important;
}

.opacity-0-hover:hover {
  opacity: 0 !important;
}

.opacity-5 {
  opacity: 0.05 !important;
}

.opacity-5-hover:hover {
  opacity: 0.05 !important;
}

.opacity-10 {
  opacity: 0.1 !important;
}

.opacity-10-hover:hover {
  opacity: 0.1 !important;
}

.opacity-15 {
  opacity: 0.15 !important;
}

.opacity-15-hover:hover {
  opacity: 0.15 !important;
}

.opacity-20 {
  opacity: 0.2 !important;
}

.opacity-20-hover:hover {
  opacity: 0.2 !important;
}

.opacity-25 {
  opacity: 0.25 !important;
}

.opacity-25-hover:hover {
  opacity: 0.25 !important;
}

.opacity-50 {
  opacity: 0.5 !important;
}

.opacity-50-hover:hover {
  opacity: 0.5 !important;
}

.opacity-75 {
  opacity: 0.75 !important;
}

.opacity-75-hover:hover {
  opacity: 0.75 !important;
}

.opacity-100 {
  opacity: 1 !important;
}

.opacity-100-hover:hover {
  opacity: 1 !important;
}

.min-w-unset {
  min-width: unset !important;
}

.min-w-25 {
  min-width: 25% !important;
}

.min-w-50 {
  min-width: 50% !important;
}

.min-w-75 {
  min-width: 75% !important;
}

.min-w-100 {
  min-width: 100% !important;
}

.min-w-auto {
  min-width: auto !important;
}

.min-w-1px {
  min-width: 1px !important;
}

.min-w-2px {
  min-width: 2px !important;
}

.min-w-3px {
  min-width: 3px !important;
}

.min-w-4px {
  min-width: 4px !important;
}

.min-w-5px {
  min-width: 5px !important;
}

.min-w-6px {
  min-width: 6px !important;
}

.min-w-7px {
  min-width: 7px !important;
}

.min-w-8px {
  min-width: 8px !important;
}

.min-w-9px {
  min-width: 9px !important;
}

.min-w-10px {
  min-width: 10px !important;
}

.min-w-15px {
  min-width: 15px !important;
}

.min-w-20px {
  min-width: 20px !important;
}

.min-w-25px {
  min-width: 25px !important;
}

.min-w-30px {
  min-width: 30px !important;
}

.min-w-35px {
  min-width: 35px !important;
}

.min-w-40px {
  min-width: 40px !important;
}

.min-w-45px {
  min-width: 45px !important;
}

.min-w-50px {
  min-width: 50px !important;
}

.min-w-55px {
  min-width: 55px !important;
}

.min-w-60px {
  min-width: 60px !important;
}

.min-w-65px {
  min-width: 65px !important;
}

.min-w-70px {
  min-width: 70px !important;
}

.min-w-75px {
  min-width: 75px !important;
}

.min-w-80px {
  min-width: 80px !important;
}

.min-w-85px {
  min-width: 85px !important;
}

.min-w-90px {
  min-width: 90px !important;
}

.min-w-95px {
  min-width: 95px !important;
}

.min-w-100px {
  min-width: 100px !important;
}

.min-w-125px {
  min-width: 125px !important;
}

.min-w-150px {
  min-width: 150px !important;
}

.min-w-175px {
  min-width: 175px !important;
}

.min-w-200px {
  min-width: 200px !important;
}

.min-w-225px {
  min-width: 225px !important;
}

.min-w-250px {
  min-width: 250px !important;
}

.min-w-275px {
  min-width: 275px !important;
}

.min-w-300px {
  min-width: 300px !important;
}

.min-w-325px {
  min-width: 325px !important;
}

.min-w-350px {
  min-width: 350px !important;
}

.min-w-375px {
  min-width: 375px !important;
}

.min-w-400px {
  min-width: 400px !important;
}

.min-w-425px {
  min-width: 425px !important;
}

.min-w-450px {
  min-width: 450px !important;
}

.min-w-475px {
  min-width: 475px !important;
}

.min-w-500px {
  min-width: 500px !important;
}

.min-w-550px {
  min-width: 550px !important;
}

.min-w-600px {
  min-width: 600px !important;
}

.min-w-650px {
  min-width: 650px !important;
}

.min-w-700px {
  min-width: 700px !important;
}

.min-w-750px {
  min-width: 750px !important;
}

.min-w-800px {
  min-width: 800px !important;
}

.min-w-850px {
  min-width: 850px !important;
}

.min-w-900px {
  min-width: 900px !important;
}

.min-w-950px {
  min-width: 950px !important;
}

.min-w-1000px {
  min-width: 1000px !important;
}

.min-h-unset {
  min-height: unset !important;
}

.min-h-25 {
  min-height: 25% !important;
}

.min-h-50 {
  min-height: 50% !important;
}

.min-h-75 {
  min-height: 75% !important;
}

.min-h-100 {
  min-height: 100% !important;
}

.min-h-auto {
  min-height: auto !important;
}

.min-h-1px {
  min-height: 1px !important;
}

.min-h-2px {
  min-height: 2px !important;
}

.min-h-3px {
  min-height: 3px !important;
}

.min-h-4px {
  min-height: 4px !important;
}

.min-h-5px {
  min-height: 5px !important;
}

.min-h-6px {
  min-height: 6px !important;
}

.min-h-7px {
  min-height: 7px !important;
}

.min-h-8px {
  min-height: 8px !important;
}

.min-h-9px {
  min-height: 9px !important;
}

.min-h-10px {
  min-height: 10px !important;
}

.min-h-15px {
  min-height: 15px !important;
}

.min-h-20px {
  min-height: 20px !important;
}

.min-h-25px {
  min-height: 25px !important;
}

.min-h-30px {
  min-height: 30px !important;
}

.min-h-35px {
  min-height: 35px !important;
}

.min-h-40px {
  min-height: 40px !important;
}

.min-h-45px {
  min-height: 45px !important;
}

.min-h-50px {
  min-height: 50px !important;
}

.min-h-55px {
  min-height: 55px !important;
}

.min-h-60px {
  min-height: 60px !important;
}

.min-h-65px {
  min-height: 65px !important;
}

.min-h-70px {
  min-height: 70px !important;
}

.min-h-75px {
  min-height: 75px !important;
}

.min-h-80px {
  min-height: 80px !important;
}

.min-h-85px {
  min-height: 85px !important;
}

.min-h-90px {
  min-height: 90px !important;
}

.min-h-95px {
  min-height: 95px !important;
}

.min-h-100px {
  min-height: 100px !important;
}

.min-h-125px {
  min-height: 125px !important;
}

.min-h-150px {
  min-height: 150px !important;
}

.min-h-175px {
  min-height: 175px !important;
}

.min-h-200px {
  min-height: 200px !important;
}

.min-h-225px {
  min-height: 225px !important;
}

.min-h-250px {
  min-height: 250px !important;
}

.min-h-275px {
  min-height: 275px !important;
}

.min-h-300px {
  min-height: 300px !important;
}

.min-h-325px {
  min-height: 325px !important;
}

.min-h-350px {
  min-height: 350px !important;
}

.min-h-375px {
  min-height: 375px !important;
}

.min-h-400px {
  min-height: 400px !important;
}

.min-h-425px {
  min-height: 425px !important;
}

.min-h-450px {
  min-height: 450px !important;
}

.min-h-475px {
  min-height: 475px !important;
}

.min-h-500px {
  min-height: 500px !important;
}

.min-h-550px {
  min-height: 550px !important;
}

.min-h-600px {
  min-height: 600px !important;
}

.min-h-650px {
  min-height: 650px !important;
}

.min-h-700px {
  min-height: 700px !important;
}

.min-h-750px {
  min-height: 750px !important;
}

.min-h-800px {
  min-height: 800px !important;
}

.min-h-850px {
  min-height: 850px !important;
}

.min-h-900px {
  min-height: 900px !important;
}

.min-h-950px {
  min-height: 950px !important;
}

.min-h-1000px {
  min-height: 1000px !important;
}

.border-top-0 {
  border-top-width: 0 !important;
}

.border-top-1 {
  border-top-width: 1px !important;
}

.border-top-2 {
  border-top-width: 2px !important;
}

.border-top-3 {
  border-top-width: 3px !important;
}

.border-top-4 {
  border-top-width: 4px !important;
}

.border-top-5 {
  border-top-width: 5px !important;
}

.border-bottom-0 {
  border-bottom-width: 0 !important;
}

.border-bottom-1 {
  border-bottom-width: 1px !important;
}

.border-bottom-2 {
  border-bottom-width: 2px !important;
}

.border-bottom-3 {
  border-bottom-width: 3px !important;
}

.border-bottom-4 {
  border-bottom-width: 4px !important;
}

.border-bottom-5 {
  border-bottom-width: 5px !important;
}

.border-right-0 {
  border-right-width: 0 !important;
}

.border-right-1 {
  border-right-width: 1px !important;
}

.border-right-2 {
  border-right-width: 2px !important;
}

.border-right-3 {
  border-right-width: 3px !important;
}

.border-right-4 {
  border-right-width: 4px !important;
}

.border-right-5 {
  border-right-width: 5px !important;
}

.border-left-0 {
  border-left-width: 0 !important;
}

.border-left-1 {
  border-left-width: 1px !important;
}

.border-left-2 {
  border-left-width: 2px !important;
}

.border-left-3 {
  border-left-width: 3px !important;
}

.border-left-4 {
  border-left-width: 4px !important;
}

.border-left-5 {
  border-left-width: 5px !important;
}

.ls-1 {
  letter-spacing: 0.1rem !important;
}

.ls-2 {
  letter-spacing: 0.115rem !important;
}

.ls-3 {
  letter-spacing: 0.125rem !important;
}

.ls-4 {
  letter-spacing: 0.25rem !important;
}

.ls-5 {
  letter-spacing: 0.5rem !important;
}

.ls-n1 {
  letter-spacing: -0.1rem !important;
}

.ls-n2 {
  letter-spacing: -0.115rem !important;
}

.ls-n3 {
  letter-spacing: -0.125rem !important;
}

.ls-n4 {
  letter-spacing: -0.25rem !important;
}

.ls-n5 {
  letter-spacing: -0.5rem !important;
}

@media (min-width: 576px) {
  .float-sm-start {
    float: left !important;
  }
  .float-sm-end {
    float: right !important;
  }
  .float-sm-none {
    float: none !important;
  }
  .object-fit-sm-contain {
    object-fit: contain !important;
  }
  .object-fit-sm-cover {
    object-fit: cover !important;
  }
  .object-fit-sm-fill {
    object-fit: fill !important;
  }
  .object-fit-sm-scale {
    object-fit: scale-down !important;
  }
  .object-fit-sm-none {
    object-fit: none !important;
  }
  .overflow-sm-auto {
    overflow: auto !important;
  }
  .overflow-sm-hidden {
    overflow: hidden !important;
  }
  .overflow-sm-visible {
    overflow: visible !important;
  }
  .overflow-sm-scroll {
    overflow: scroll !important;
  }
  .d-sm-inline {
    display: inline !important;
  }
  .d-sm-inline-block {
    display: inline-block !important;
  }
  .d-sm-block {
    display: block !important;
  }
  .d-sm-grid {
    display: grid !important;
  }
  .d-sm-table {
    display: table !important;
  }
  .d-sm-table-row {
    display: table-row !important;
  }
  .d-sm-table-cell {
    display: table-cell !important;
  }
  .d-sm-flex {
    display: flex !important;
  }
  .d-sm-inline-flex {
    display: inline-flex !important;
  }
  .d-sm-none {
    display: none !important;
  }
  .position-sm-static {
    position: static !important;
  }
  .position-sm-relative {
    position: relative !important;
  }
  .position-sm-absolute {
    position: absolute !important;
  }
  .position-sm-fixed {
    position: fixed !important;
  }
  .position-sm-sticky {
    position: sticky !important;
  }
  .w-sm-unset {
    width: unset !important;
  }
  .w-sm-25 {
    width: 25% !important;
  }
  .w-sm-50 {
    width: 50% !important;
  }
  .w-sm-75 {
    width: 75% !important;
  }
  .w-sm-100 {
    width: 100% !important;
  }
  .w-sm-auto {
    width: auto !important;
  }
  .w-sm-1px {
    width: 1px !important;
  }
  .w-sm-2px {
    width: 2px !important;
  }
  .w-sm-3px {
    width: 3px !important;
  }
  .w-sm-4px {
    width: 4px !important;
  }
  .w-sm-5px {
    width: 5px !important;
  }
  .w-sm-6px {
    width: 6px !important;
  }
  .w-sm-7px {
    width: 7px !important;
  }
  .w-sm-8px {
    width: 8px !important;
  }
  .w-sm-9px {
    width: 9px !important;
  }
  .w-sm-10px {
    width: 10px !important;
  }
  .w-sm-15px {
    width: 15px !important;
  }
  .w-sm-20px {
    width: 20px !important;
  }
  .w-sm-25px {
    width: 25px !important;
  }
  .w-sm-30px {
    width: 30px !important;
  }
  .w-sm-35px {
    width: 35px !important;
  }
  .w-sm-40px {
    width: 40px !important;
  }
  .w-sm-45px {
    width: 45px !important;
  }
  .w-sm-50px {
    width: 50px !important;
  }
  .w-sm-55px {
    width: 55px !important;
  }
  .w-sm-60px {
    width: 60px !important;
  }
  .w-sm-65px {
    width: 65px !important;
  }
  .w-sm-70px {
    width: 70px !important;
  }
  .w-sm-75px {
    width: 75px !important;
  }
  .w-sm-80px {
    width: 80px !important;
  }
  .w-sm-85px {
    width: 85px !important;
  }
  .w-sm-90px {
    width: 90px !important;
  }
  .w-sm-95px {
    width: 95px !important;
  }
  .w-sm-100px {
    width: 100px !important;
  }
  .w-sm-125px {
    width: 125px !important;
  }
  .w-sm-150px {
    width: 150px !important;
  }
  .w-sm-175px {
    width: 175px !important;
  }
  .w-sm-200px {
    width: 200px !important;
  }
  .w-sm-225px {
    width: 225px !important;
  }
  .w-sm-250px {
    width: 250px !important;
  }
  .w-sm-275px {
    width: 275px !important;
  }
  .w-sm-300px {
    width: 300px !important;
  }
  .w-sm-325px {
    width: 325px !important;
  }
  .w-sm-350px {
    width: 350px !important;
  }
  .w-sm-375px {
    width: 375px !important;
  }
  .w-sm-400px {
    width: 400px !important;
  }
  .w-sm-425px {
    width: 425px !important;
  }
  .w-sm-450px {
    width: 450px !important;
  }
  .w-sm-475px {
    width: 475px !important;
  }
  .w-sm-500px {
    width: 500px !important;
  }
  .w-sm-550px {
    width: 550px !important;
  }
  .w-sm-600px {
    width: 600px !important;
  }
  .w-sm-650px {
    width: 650px !important;
  }
  .w-sm-700px {
    width: 700px !important;
  }
  .w-sm-750px {
    width: 750px !important;
  }
  .w-sm-800px {
    width: 800px !important;
  }
  .w-sm-850px {
    width: 850px !important;
  }
  .w-sm-900px {
    width: 900px !important;
  }
  .w-sm-950px {
    width: 950px !important;
  }
  .w-sm-1000px {
    width: 1000px !important;
  }
  .mw-sm-unset {
    max-width: unset !important;
  }
  .mw-sm-25 {
    max-width: 25% !important;
  }
  .mw-sm-50 {
    max-width: 50% !important;
  }
  .mw-sm-75 {
    max-width: 75% !important;
  }
  .mw-sm-100 {
    max-width: 100% !important;
  }
  .mw-sm-auto {
    max-width: auto !important;
  }
  .mw-sm-1px {
    max-width: 1px !important;
  }
  .mw-sm-2px {
    max-width: 2px !important;
  }
  .mw-sm-3px {
    max-width: 3px !important;
  }
  .mw-sm-4px {
    max-width: 4px !important;
  }
  .mw-sm-5px {
    max-width: 5px !important;
  }
  .mw-sm-6px {
    max-width: 6px !important;
  }
  .mw-sm-7px {
    max-width: 7px !important;
  }
  .mw-sm-8px {
    max-width: 8px !important;
  }
  .mw-sm-9px {
    max-width: 9px !important;
  }
  .mw-sm-10px {
    max-width: 10px !important;
  }
  .mw-sm-15px {
    max-width: 15px !important;
  }
  .mw-sm-20px {
    max-width: 20px !important;
  }
  .mw-sm-25px {
    max-width: 25px !important;
  }
  .mw-sm-30px {
    max-width: 30px !important;
  }
  .mw-sm-35px {
    max-width: 35px !important;
  }
  .mw-sm-40px {
    max-width: 40px !important;
  }
  .mw-sm-45px {
    max-width: 45px !important;
  }
  .mw-sm-50px {
    max-width: 50px !important;
  }
  .mw-sm-55px {
    max-width: 55px !important;
  }
  .mw-sm-60px {
    max-width: 60px !important;
  }
  .mw-sm-65px {
    max-width: 65px !important;
  }
  .mw-sm-70px {
    max-width: 70px !important;
  }
  .mw-sm-75px {
    max-width: 75px !important;
  }
  .mw-sm-80px {
    max-width: 80px !important;
  }
  .mw-sm-85px {
    max-width: 85px !important;
  }
  .mw-sm-90px {
    max-width: 90px !important;
  }
  .mw-sm-95px {
    max-width: 95px !important;
  }
  .mw-sm-100px {
    max-width: 100px !important;
  }
  .mw-sm-125px {
    max-width: 125px !important;
  }
  .mw-sm-150px {
    max-width: 150px !important;
  }
  .mw-sm-175px {
    max-width: 175px !important;
  }
  .mw-sm-200px {
    max-width: 200px !important;
  }
  .mw-sm-225px {
    max-width: 225px !important;
  }
  .mw-sm-250px {
    max-width: 250px !important;
  }
  .mw-sm-275px {
    max-width: 275px !important;
  }
  .mw-sm-300px {
    max-width: 300px !important;
  }
  .mw-sm-325px {
    max-width: 325px !important;
  }
  .mw-sm-350px {
    max-width: 350px !important;
  }
  .mw-sm-375px {
    max-width: 375px !important;
  }
  .mw-sm-400px {
    max-width: 400px !important;
  }
  .mw-sm-425px {
    max-width: 425px !important;
  }
  .mw-sm-450px {
    max-width: 450px !important;
  }
  .mw-sm-475px {
    max-width: 475px !important;
  }
  .mw-sm-500px {
    max-width: 500px !important;
  }
  .mw-sm-550px {
    max-width: 550px !important;
  }
  .mw-sm-600px {
    max-width: 600px !important;
  }
  .mw-sm-650px {
    max-width: 650px !important;
  }
  .mw-sm-700px {
    max-width: 700px !important;
  }
  .mw-sm-750px {
    max-width: 750px !important;
  }
  .mw-sm-800px {
    max-width: 800px !important;
  }
  .mw-sm-850px {
    max-width: 850px !important;
  }
  .mw-sm-900px {
    max-width: 900px !important;
  }
  .mw-sm-950px {
    max-width: 950px !important;
  }
  .mw-sm-1000px {
    max-width: 1000px !important;
  }
  .h-sm-unset {
    height: unset !important;
  }
  .h-sm-25 {
    height: 25% !important;
  }
  .h-sm-50 {
    height: 50% !important;
  }
  .h-sm-75 {
    height: 75% !important;
  }
  .h-sm-100 {
    height: 100% !important;
  }
  .h-sm-auto {
    height: auto !important;
  }
  .h-sm-1px {
    height: 1px !important;
  }
  .h-sm-2px {
    height: 2px !important;
  }
  .h-sm-3px {
    height: 3px !important;
  }
  .h-sm-4px {
    height: 4px !important;
  }
  .h-sm-5px {
    height: 5px !important;
  }
  .h-sm-6px {
    height: 6px !important;
  }
  .h-sm-7px {
    height: 7px !important;
  }
  .h-sm-8px {
    height: 8px !important;
  }
  .h-sm-9px {
    height: 9px !important;
  }
  .h-sm-10px {
    height: 10px !important;
  }
  .h-sm-15px {
    height: 15px !important;
  }
  .h-sm-20px {
    height: 20px !important;
  }
  .h-sm-25px {
    height: 25px !important;
  }
  .h-sm-30px {
    height: 30px !important;
  }
  .h-sm-35px {
    height: 35px !important;
  }
  .h-sm-40px {
    height: 40px !important;
  }
  .h-sm-45px {
    height: 45px !important;
  }
  .h-sm-50px {
    height: 50px !important;
  }
  .h-sm-55px {
    height: 55px !important;
  }
  .h-sm-60px {
    height: 60px !important;
  }
  .h-sm-65px {
    height: 65px !important;
  }
  .h-sm-70px {
    height: 70px !important;
  }
  .h-sm-75px {
    height: 75px !important;
  }
  .h-sm-80px {
    height: 80px !important;
  }
  .h-sm-85px {
    height: 85px !important;
  }
  .h-sm-90px {
    height: 90px !important;
  }
  .h-sm-95px {
    height: 95px !important;
  }
  .h-sm-100px {
    height: 100px !important;
  }
  .h-sm-125px {
    height: 125px !important;
  }
  .h-sm-150px {
    height: 150px !important;
  }
  .h-sm-175px {
    height: 175px !important;
  }
  .h-sm-200px {
    height: 200px !important;
  }
  .h-sm-225px {
    height: 225px !important;
  }
  .h-sm-250px {
    height: 250px !important;
  }
  .h-sm-275px {
    height: 275px !important;
  }
  .h-sm-300px {
    height: 300px !important;
  }
  .h-sm-325px {
    height: 325px !important;
  }
  .h-sm-350px {
    height: 350px !important;
  }
  .h-sm-375px {
    height: 375px !important;
  }
  .h-sm-400px {
    height: 400px !important;
  }
  .h-sm-425px {
    height: 425px !important;
  }
  .h-sm-450px {
    height: 450px !important;
  }
  .h-sm-475px {
    height: 475px !important;
  }
  .h-sm-500px {
    height: 500px !important;
  }
  .h-sm-550px {
    height: 550px !important;
  }
  .h-sm-600px {
    height: 600px !important;
  }
  .h-sm-650px {
    height: 650px !important;
  }
  .h-sm-700px {
    height: 700px !important;
  }
  .h-sm-750px {
    height: 750px !important;
  }
  .h-sm-800px {
    height: 800px !important;
  }
  .h-sm-850px {
    height: 850px !important;
  }
  .h-sm-900px {
    height: 900px !important;
  }
  .h-sm-950px {
    height: 950px !important;
  }
  .h-sm-1000px {
    height: 1000px !important;
  }
  .mh-sm-unset {
    max-height: unset !important;
  }
  .mh-sm-25 {
    max-height: 25% !important;
  }
  .mh-sm-50 {
    max-height: 50% !important;
  }
  .mh-sm-75 {
    max-height: 75% !important;
  }
  .mh-sm-100 {
    max-height: 100% !important;
  }
  .mh-sm-auto {
    max-height: auto !important;
  }
  .mh-sm-1px {
    max-height: 1px !important;
  }
  .mh-sm-2px {
    max-height: 2px !important;
  }
  .mh-sm-3px {
    max-height: 3px !important;
  }
  .mh-sm-4px {
    max-height: 4px !important;
  }
  .mh-sm-5px {
    max-height: 5px !important;
  }
  .mh-sm-6px {
    max-height: 6px !important;
  }
  .mh-sm-7px {
    max-height: 7px !important;
  }
  .mh-sm-8px {
    max-height: 8px !important;
  }
  .mh-sm-9px {
    max-height: 9px !important;
  }
  .mh-sm-10px {
    max-height: 10px !important;
  }
  .mh-sm-15px {
    max-height: 15px !important;
  }
  .mh-sm-20px {
    max-height: 20px !important;
  }
  .mh-sm-25px {
    max-height: 25px !important;
  }
  .mh-sm-30px {
    max-height: 30px !important;
  }
  .mh-sm-35px {
    max-height: 35px !important;
  }
  .mh-sm-40px {
    max-height: 40px !important;
  }
  .mh-sm-45px {
    max-height: 45px !important;
  }
  .mh-sm-50px {
    max-height: 50px !important;
  }
  .mh-sm-55px {
    max-height: 55px !important;
  }
  .mh-sm-60px {
    max-height: 60px !important;
  }
  .mh-sm-65px {
    max-height: 65px !important;
  }
  .mh-sm-70px {
    max-height: 70px !important;
  }
  .mh-sm-75px {
    max-height: 75px !important;
  }
  .mh-sm-80px {
    max-height: 80px !important;
  }
  .mh-sm-85px {
    max-height: 85px !important;
  }
  .mh-sm-90px {
    max-height: 90px !important;
  }
  .mh-sm-95px {
    max-height: 95px !important;
  }
  .mh-sm-100px {
    max-height: 100px !important;
  }
  .mh-sm-125px {
    max-height: 125px !important;
  }
  .mh-sm-150px {
    max-height: 150px !important;
  }
  .mh-sm-175px {
    max-height: 175px !important;
  }
  .mh-sm-200px {
    max-height: 200px !important;
  }
  .mh-sm-225px {
    max-height: 225px !important;
  }
  .mh-sm-250px {
    max-height: 250px !important;
  }
  .mh-sm-275px {
    max-height: 275px !important;
  }
  .mh-sm-300px {
    max-height: 300px !important;
  }
  .mh-sm-325px {
    max-height: 325px !important;
  }
  .mh-sm-350px {
    max-height: 350px !important;
  }
  .mh-sm-375px {
    max-height: 375px !important;
  }
  .mh-sm-400px {
    max-height: 400px !important;
  }
  .mh-sm-425px {
    max-height: 425px !important;
  }
  .mh-sm-450px {
    max-height: 450px !important;
  }
  .mh-sm-475px {
    max-height: 475px !important;
  }
  .mh-sm-500px {
    max-height: 500px !important;
  }
  .mh-sm-550px {
    max-height: 550px !important;
  }
  .mh-sm-600px {
    max-height: 600px !important;
  }
  .mh-sm-650px {
    max-height: 650px !important;
  }
  .mh-sm-700px {
    max-height: 700px !important;
  }
  .mh-sm-750px {
    max-height: 750px !important;
  }
  .mh-sm-800px {
    max-height: 800px !important;
  }
  .mh-sm-850px {
    max-height: 850px !important;
  }
  .mh-sm-900px {
    max-height: 900px !important;
  }
  .mh-sm-950px {
    max-height: 950px !important;
  }
  .mh-sm-1000px {
    max-height: 1000px !important;
  }
  .flex-sm-fill {
    flex: 1 1 auto !important;
  }
  .flex-sm-row {
    flex-direction: row !important;
  }
  .flex-sm-column {
    flex-direction: column !important;
  }
  .flex-sm-row-reverse {
    flex-direction: row-reverse !important;
  }
  .flex-sm-column-reverse {
    flex-direction: column-reverse !important;
  }
  .flex-sm-grow-0 {
    flex-grow: 0 !important;
  }
  .flex-sm-grow-1 {
    flex-grow: 1 !important;
  }
  .flex-sm-shrink-0 {
    flex-shrink: 0 !important;
  }
  .flex-sm-shrink-1 {
    flex-shrink: 1 !important;
  }
  .flex-sm-wrap {
    flex-wrap: wrap !important;
  }
  .flex-sm-nowrap {
    flex-wrap: nowrap !important;
  }
  .flex-sm-wrap-reverse {
    flex-wrap: wrap-reverse !important;
  }
  .justify-content-sm-start {
    justify-content: flex-start !important;
  }
  .justify-content-sm-end {
    justify-content: flex-end !important;
  }
  .justify-content-sm-center {
    justify-content: center !important;
  }
  .justify-content-sm-between {
    justify-content: space-between !important;
  }
  .justify-content-sm-around {
    justify-content: space-around !important;
  }
  .justify-content-sm-evenly {
    justify-content: space-evenly !important;
  }
  .align-items-sm-start {
    align-items: flex-start !important;
  }
  .align-items-sm-end {
    align-items: flex-end !important;
  }
  .align-items-sm-center {
    align-items: center !important;
  }
  .align-items-sm-baseline {
    align-items: baseline !important;
  }
  .align-items-sm-stretch {
    align-items: stretch !important;
  }
  .align-content-sm-start {
    align-content: flex-start !important;
  }
  .align-content-sm-end {
    align-content: flex-end !important;
  }
  .align-content-sm-center {
    align-content: center !important;
  }
  .align-content-sm-between {
    align-content: space-between !important;
  }
  .align-content-sm-around {
    align-content: space-around !important;
  }
  .align-content-sm-stretch {
    align-content: stretch !important;
  }
  .align-self-sm-auto {
    align-self: auto !important;
  }
  .align-self-sm-start {
    align-self: flex-start !important;
  }
  .align-self-sm-end {
    align-self: flex-end !important;
  }
  .align-self-sm-center {
    align-self: center !important;
  }
  .align-self-sm-baseline {
    align-self: baseline !important;
  }
  .align-self-sm-stretch {
    align-self: stretch !important;
  }
  .order-sm-first {
    order: -1 !important;
  }
  .order-sm-0 {
    order: 0 !important;
  }
  .order-sm-1 {
    order: 1 !important;
  }
  .order-sm-2 {
    order: 2 !important;
  }
  .order-sm-3 {
    order: 3 !important;
  }
  .order-sm-4 {
    order: 4 !important;
  }
  .order-sm-5 {
    order: 5 !important;
  }
  .order-sm-last {
    order: 6 !important;
  }
  .m-sm-0 {
    margin: 0 !important;
  }
  .m-sm-1 {
    margin: 0.25rem !important;
  }
  .m-sm-2 {
    margin: 0.5rem !important;
  }
  .m-sm-3 {
    margin: 0.75rem !important;
  }
  .m-sm-4 {
    margin: 1rem !important;
  }
  .m-sm-5 {
    margin: 1.25rem !important;
  }
  .m-sm-6 {
    margin: 1.5rem !important;
  }
  .m-sm-7 {
    margin: 1.75rem !important;
  }
  .m-sm-8 {
    margin: 2rem !important;
  }
  .m-sm-9 {
    margin: 2.25rem !important;
  }
  .m-sm-10 {
    margin: 2.5rem !important;
  }
  .m-sm-11 {
    margin: 2.75rem !important;
  }
  .m-sm-12 {
    margin: 3rem !important;
  }
  .m-sm-13 {
    margin: 3.25rem !important;
  }
  .m-sm-14 {
    margin: 3.5rem !important;
  }
  .m-sm-15 {
    margin: 3.75rem !important;
  }
  .m-sm-16 {
    margin: 4rem !important;
  }
  .m-sm-17 {
    margin: 4.25rem !important;
  }
  .m-sm-18 {
    margin: 4.5rem !important;
  }
  .m-sm-19 {
    margin: 4.75rem !important;
  }
  .m-sm-20 {
    margin: 5rem !important;
  }
  .m-sm-auto {
    margin: auto !important;
  }
  .mx-sm-0 {
    margin-right: 0 !important;
    margin-left: 0 !important;
  }
  .mx-sm-1 {
    margin-right: 0.25rem !important;
    margin-left: 0.25rem !important;
  }
  .mx-sm-2 {
    margin-right: 0.5rem !important;
    margin-left: 0.5rem !important;
  }
  .mx-sm-3 {
    margin-right: 0.75rem !important;
    margin-left: 0.75rem !important;
  }
  .mx-sm-4 {
    margin-right: 1rem !important;
    margin-left: 1rem !important;
  }
  .mx-sm-5 {
    margin-right: 1.25rem !important;
    margin-left: 1.25rem !important;
  }
  .mx-sm-6 {
    margin-right: 1.5rem !important;
    margin-left: 1.5rem !important;
  }
  .mx-sm-7 {
    margin-right: 1.75rem !important;
    margin-left: 1.75rem !important;
  }
  .mx-sm-8 {
    margin-right: 2rem !important;
    margin-left: 2rem !important;
  }
  .mx-sm-9 {
    margin-right: 2.25rem !important;
    margin-left: 2.25rem !important;
  }
  .mx-sm-10 {
    margin-right: 2.5rem !important;
    margin-left: 2.5rem !important;
  }
  .mx-sm-11 {
    margin-right: 2.75rem !important;
    margin-left: 2.75rem !important;
  }
  .mx-sm-12 {
    margin-right: 3rem !important;
    margin-left: 3rem !important;
  }
  .mx-sm-13 {
    margin-right: 3.25rem !important;
    margin-left: 3.25rem !important;
  }
  .mx-sm-14 {
    margin-right: 3.5rem !important;
    margin-left: 3.5rem !important;
  }
  .mx-sm-15 {
    margin-right: 3.75rem !important;
    margin-left: 3.75rem !important;
  }
  .mx-sm-16 {
    margin-right: 4rem !important;
    margin-left: 4rem !important;
  }
  .mx-sm-17 {
    margin-right: 4.25rem !important;
    margin-left: 4.25rem !important;
  }
  .mx-sm-18 {
    margin-right: 4.5rem !important;
    margin-left: 4.5rem !important;
  }
  .mx-sm-19 {
    margin-right: 4.75rem !important;
    margin-left: 4.75rem !important;
  }
  .mx-sm-20 {
    margin-right: 5rem !important;
    margin-left: 5rem !important;
  }
  .mx-sm-auto {
    margin-right: auto !important;
    margin-left: auto !important;
  }
  .my-sm-0 {
    margin-top: 0 !important;
    margin-bottom: 0 !important;
  }
  .my-sm-1 {
    margin-top: 0.25rem !important;
    margin-bottom: 0.25rem !important;
  }
  .my-sm-2 {
    margin-top: 0.5rem !important;
    margin-bottom: 0.5rem !important;
  }
  .my-sm-3 {
    margin-top: 0.75rem !important;
    margin-bottom: 0.75rem !important;
  }
  .my-sm-4 {
    margin-top: 1rem !important;
    margin-bottom: 1rem !important;
  }
  .my-sm-5 {
    margin-top: 1.25rem !important;
    margin-bottom: 1.25rem !important;
  }
  .my-sm-6 {
    margin-top: 1.5rem !important;
    margin-bottom: 1.5rem !important;
  }
  .my-sm-7 {
    margin-top: 1.75rem !important;
    margin-bottom: 1.75rem !important;
  }
  .my-sm-8 {
    margin-top: 2rem !important;
    margin-bottom: 2rem !important;
  }
  .my-sm-9 {
    margin-top: 2.25rem !important;
    margin-bottom: 2.25rem !important;
  }
  .my-sm-10 {
    margin-top: 2.5rem !important;
    margin-bottom: 2.5rem !important;
  }
  .my-sm-11 {
    margin-top: 2.75rem !important;
    margin-bottom: 2.75rem !important;
  }
  .my-sm-12 {
    margin-top: 3rem !important;
    margin-bottom: 3rem !important;
  }
  .my-sm-13 {
    margin-top: 3.25rem !important;
    margin-bottom: 3.25rem !important;
  }
  .my-sm-14 {
    margin-top: 3.5rem !important;
    margin-bottom: 3.5rem !important;
  }
  .my-sm-15 {
    margin-top: 3.75rem !important;
    margin-bottom: 3.75rem !important;
  }
  .my-sm-16 {
    margin-top: 4rem !important;
    margin-bottom: 4rem !important;
  }
  .my-sm-17 {
    margin-top: 4.25rem !important;
    margin-bottom: 4.25rem !important;
  }
  .my-sm-18 {
    margin-top: 4.5rem !important;
    margin-bottom: 4.5rem !important;
  }
  .my-sm-19 {
    margin-top: 4.75rem !important;
    margin-bottom: 4.75rem !important;
  }
  .my-sm-20 {
    margin-top: 5rem !important;
    margin-bottom: 5rem !important;
  }
  .my-sm-auto {
    margin-top: auto !important;
    margin-bottom: auto !important;
  }
  .mt-sm-0 {
    margin-top: 0 !important;
  }
  .mt-sm-1 {
    margin-top: 0.25rem !important;
  }
  .mt-sm-2 {
    margin-top: 0.5rem !important;
  }
  .mt-sm-3 {
    margin-top: 0.75rem !important;
  }
  .mt-sm-4 {
    margin-top: 1rem !important;
  }
  .mt-sm-5 {
    margin-top: 1.25rem !important;
  }
  .mt-sm-6 {
    margin-top: 1.5rem !important;
  }
  .mt-sm-7 {
    margin-top: 1.75rem !important;
  }
  .mt-sm-8 {
    margin-top: 2rem !important;
  }
  .mt-sm-9 {
    margin-top: 2.25rem !important;
  }
  .mt-sm-10 {
    margin-top: 2.5rem !important;
  }
  .mt-sm-11 {
    margin-top: 2.75rem !important;
  }
  .mt-sm-12 {
    margin-top: 3rem !important;
  }
  .mt-sm-13 {
    margin-top: 3.25rem !important;
  }
  .mt-sm-14 {
    margin-top: 3.5rem !important;
  }
  .mt-sm-15 {
    margin-top: 3.75rem !important;
  }
  .mt-sm-16 {
    margin-top: 4rem !important;
  }
  .mt-sm-17 {
    margin-top: 4.25rem !important;
  }
  .mt-sm-18 {
    margin-top: 4.5rem !important;
  }
  .mt-sm-19 {
    margin-top: 4.75rem !important;
  }
  .mt-sm-20 {
    margin-top: 5rem !important;
  }
  .mt-sm-auto {
    margin-top: auto !important;
  }
  .me-sm-0 {
    margin-right: 0 !important;
  }
  .me-sm-1 {
    margin-right: 0.25rem !important;
  }
  .me-sm-2 {
    margin-right: 0.5rem !important;
  }
  .me-sm-3 {
    margin-right: 0.75rem !important;
  }
  .me-sm-4 {
    margin-right: 1rem !important;
  }
  .me-sm-5 {
    margin-right: 1.25rem !important;
  }
  .me-sm-6 {
    margin-right: 1.5rem !important;
  }
  .me-sm-7 {
    margin-right: 1.75rem !important;
  }
  .me-sm-8 {
    margin-right: 2rem !important;
  }
  .me-sm-9 {
    margin-right: 2.25rem !important;
  }
  .me-sm-10 {
    margin-right: 2.5rem !important;
  }
  .me-sm-11 {
    margin-right: 2.75rem !important;
  }
  .me-sm-12 {
    margin-right: 3rem !important;
  }
  .me-sm-13 {
    margin-right: 3.25rem !important;
  }
  .me-sm-14 {
    margin-right: 3.5rem !important;
  }
  .me-sm-15 {
    margin-right: 3.75rem !important;
  }
  .me-sm-16 {
    margin-right: 4rem !important;
  }
  .me-sm-17 {
    margin-right: 4.25rem !important;
  }
  .me-sm-18 {
    margin-right: 4.5rem !important;
  }
  .me-sm-19 {
    margin-right: 4.75rem !important;
  }
  .me-sm-20 {
    margin-right: 5rem !important;
  }
  .me-sm-auto {
    margin-right: auto !important;
  }
  .mb-sm-0 {
    margin-bottom: 0 !important;
  }
  .mb-sm-1 {
    margin-bottom: 0.25rem !important;
  }
  .mb-sm-2 {
    margin-bottom: 0.5rem !important;
  }
  .mb-sm-3 {
    margin-bottom: 0.75rem !important;
  }
  .mb-sm-4 {
    margin-bottom: 1rem !important;
  }
  .mb-sm-5 {
    margin-bottom: 1.25rem !important;
  }
  .mb-sm-6 {
    margin-bottom: 1.5rem !important;
  }
  .mb-sm-7 {
    margin-bottom: 1.75rem !important;
  }
  .mb-sm-8 {
    margin-bottom: 2rem !important;
  }
  .mb-sm-9 {
    margin-bottom: 2.25rem !important;
  }
  .mb-sm-10 {
    margin-bottom: 2.5rem !important;
  }
  .mb-sm-11 {
    margin-bottom: 2.75rem !important;
  }
  .mb-sm-12 {
    margin-bottom: 3rem !important;
  }
  .mb-sm-13 {
    margin-bottom: 3.25rem !important;
  }
  .mb-sm-14 {
    margin-bottom: 3.5rem !important;
  }
  .mb-sm-15 {
    margin-bottom: 3.75rem !important;
  }
  .mb-sm-16 {
    margin-bottom: 4rem !important;
  }
  .mb-sm-17 {
    margin-bottom: 4.25rem !important;
  }
  .mb-sm-18 {
    margin-bottom: 4.5rem !important;
  }
  .mb-sm-19 {
    margin-bottom: 4.75rem !important;
  }
  .mb-sm-20 {
    margin-bottom: 5rem !important;
  }
  .mb-sm-auto {
    margin-bottom: auto !important;
  }
  .ms-sm-0 {
    margin-left: 0 !important;
  }
  .ms-sm-1 {
    margin-left: 0.25rem !important;
  }
  .ms-sm-2 {
    margin-left: 0.5rem !important;
  }
  .ms-sm-3 {
    margin-left: 0.75rem !important;
  }
  .ms-sm-4 {
    margin-left: 1rem !important;
  }
  .ms-sm-5 {
    margin-left: 1.25rem !important;
  }
  .ms-sm-6 {
    margin-left: 1.5rem !important;
  }
  .ms-sm-7 {
    margin-left: 1.75rem !important;
  }
  .ms-sm-8 {
    margin-left: 2rem !important;
  }
  .ms-sm-9 {
    margin-left: 2.25rem !important;
  }
  .ms-sm-10 {
    margin-left: 2.5rem !important;
  }
  .ms-sm-11 {
    margin-left: 2.75rem !important;
  }
  .ms-sm-12 {
    margin-left: 3rem !important;
  }
  .ms-sm-13 {
    margin-left: 3.25rem !important;
  }
  .ms-sm-14 {
    margin-left: 3.5rem !important;
  }
  .ms-sm-15 {
    margin-left: 3.75rem !important;
  }
  .ms-sm-16 {
    margin-left: 4rem !important;
  }
  .ms-sm-17 {
    margin-left: 4.25rem !important;
  }
  .ms-sm-18 {
    margin-left: 4.5rem !important;
  }
  .ms-sm-19 {
    margin-left: 4.75rem !important;
  }
  .ms-sm-20 {
    margin-left: 5rem !important;
  }
  .ms-sm-auto {
    margin-left: auto !important;
  }
  .m-sm-n1 {
    margin: -0.25rem !important;
  }
  .m-sm-n2 {
    margin: -0.5rem !important;
  }
  .m-sm-n3 {
    margin: -0.75rem !important;
  }
  .m-sm-n4 {
    margin: -1rem !important;
  }
  .m-sm-n5 {
    margin: -1.25rem !important;
  }
  .m-sm-n6 {
    margin: -1.5rem !important;
  }
  .m-sm-n7 {
    margin: -1.75rem !important;
  }
  .m-sm-n8 {
    margin: -2rem !important;
  }
  .m-sm-n9 {
    margin: -2.25rem !important;
  }
  .m-sm-n10 {
    margin: -2.5rem !important;
  }
  .m-sm-n11 {
    margin: -2.75rem !important;
  }
  .m-sm-n12 {
    margin: -3rem !important;
  }
  .m-sm-n13 {
    margin: -3.25rem !important;
  }
  .m-sm-n14 {
    margin: -3.5rem !important;
  }
  .m-sm-n15 {
    margin: -3.75rem !important;
  }
  .m-sm-n16 {
    margin: -4rem !important;
  }
  .m-sm-n17 {
    margin: -4.25rem !important;
  }
  .m-sm-n18 {
    margin: -4.5rem !important;
  }
  .m-sm-n19 {
    margin: -4.75rem !important;
  }
  .m-sm-n20 {
    margin: -5rem !important;
  }
  .mx-sm-n1 {
    margin-right: -0.25rem !important;
    margin-left: -0.25rem !important;
  }
  .mx-sm-n2 {
    margin-right: -0.5rem !important;
    margin-left: -0.5rem !important;
  }
  .mx-sm-n3 {
    margin-right: -0.75rem !important;
    margin-left: -0.75rem !important;
  }
  .mx-sm-n4 {
    margin-right: -1rem !important;
    margin-left: -1rem !important;
  }
  .mx-sm-n5 {
    margin-right: -1.25rem !important;
    margin-left: -1.25rem !important;
  }
  .mx-sm-n6 {
    margin-right: -1.5rem !important;
    margin-left: -1.5rem !important;
  }
  .mx-sm-n7 {
    margin-right: -1.75rem !important;
    margin-left: -1.75rem !important;
  }
  .mx-sm-n8 {
    margin-right: -2rem !important;
    margin-left: -2rem !important;
  }
  .mx-sm-n9 {
    margin-right: -2.25rem !important;
    margin-left: -2.25rem !important;
  }
  .mx-sm-n10 {
    margin-right: -2.5rem !important;
    margin-left: -2.5rem !important;
  }
  .mx-sm-n11 {
    margin-right: -2.75rem !important;
    margin-left: -2.75rem !important;
  }
  .mx-sm-n12 {
    margin-right: -3rem !important;
    margin-left: -3rem !important;
  }
  .mx-sm-n13 {
    margin-right: -3.25rem !important;
    margin-left: -3.25rem !important;
  }
  .mx-sm-n14 {
    margin-right: -3.5rem !important;
    margin-left: -3.5rem !important;
  }
  .mx-sm-n15 {
    margin-right: -3.75rem !important;
    margin-left: -3.75rem !important;
  }
  .mx-sm-n16 {
    margin-right: -4rem !important;
    margin-left: -4rem !important;
  }
  .mx-sm-n17 {
    margin-right: -4.25rem !important;
    margin-left: -4.25rem !important;
  }
  .mx-sm-n18 {
    margin-right: -4.5rem !important;
    margin-left: -4.5rem !important;
  }
  .mx-sm-n19 {
    margin-right: -4.75rem !important;
    margin-left: -4.75rem !important;
  }
  .mx-sm-n20 {
    margin-right: -5rem !important;
    margin-left: -5rem !important;
  }
  .my-sm-n1 {
    margin-top: -0.25rem !important;
    margin-bottom: -0.25rem !important;
  }
  .my-sm-n2 {
    margin-top: -0.5rem !important;
    margin-bottom: -0.5rem !important;
  }
  .my-sm-n3 {
    margin-top: -0.75rem !important;
    margin-bottom: -0.75rem !important;
  }
  .my-sm-n4 {
    margin-top: -1rem !important;
    margin-bottom: -1rem !important;
  }
  .my-sm-n5 {
    margin-top: -1.25rem !important;
    margin-bottom: -1.25rem !important;
  }
  .my-sm-n6 {
    margin-top: -1.5rem !important;
    margin-bottom: -1.5rem !important;
  }
  .my-sm-n7 {
    margin-top: -1.75rem !important;
    margin-bottom: -1.75rem !important;
  }
  .my-sm-n8 {
    margin-top: -2rem !important;
    margin-bottom: -2rem !important;
  }
  .my-sm-n9 {
    margin-top: -2.25rem !important;
    margin-bottom: -2.25rem !important;
  }
  .my-sm-n10 {
    margin-top: -2.5rem !important;
    margin-bottom: -2.5rem !important;
  }
  .my-sm-n11 {
    margin-top: -2.75rem !important;
    margin-bottom: -2.75rem !important;
  }
  .my-sm-n12 {
    margin-top: -3rem !important;
    margin-bottom: -3rem !important;
  }
  .my-sm-n13 {
    margin-top: -3.25rem !important;
    margin-bottom: -3.25rem !important;
  }
  .my-sm-n14 {
    margin-top: -3.5rem !important;
    margin-bottom: -3.5rem !important;
  }
  .my-sm-n15 {
    margin-top: -3.75rem !important;
    margin-bottom: -3.75rem !important;
  }
  .my-sm-n16 {
    margin-top: -4rem !important;
    margin-bottom: -4rem !important;
  }
  .my-sm-n17 {
    margin-top: -4.25rem !important;
    margin-bottom: -4.25rem !important;
  }
  .my-sm-n18 {
    margin-top: -4.5rem !important;
    margin-bottom: -4.5rem !important;
  }
  .my-sm-n19 {
    margin-top: -4.75rem !important;
    margin-bottom: -4.75rem !important;
  }
  .my-sm-n20 {
    margin-top: -5rem !important;
    margin-bottom: -5rem !important;
  }
  .mt-sm-n1 {
    margin-top: -0.25rem !important;
  }
  .mt-sm-n2 {
    margin-top: -0.5rem !important;
  }
  .mt-sm-n3 {
    margin-top: -0.75rem !important;
  }
  .mt-sm-n4 {
    margin-top: -1rem !important;
  }
  .mt-sm-n5 {
    margin-top: -1.25rem !important;
  }
  .mt-sm-n6 {
    margin-top: -1.5rem !important;
  }
  .mt-sm-n7 {
    margin-top: -1.75rem !important;
  }
  .mt-sm-n8 {
    margin-top: -2rem !important;
  }
  .mt-sm-n9 {
    margin-top: -2.25rem !important;
  }
  .mt-sm-n10 {
    margin-top: -2.5rem !important;
  }
  .mt-sm-n11 {
    margin-top: -2.75rem !important;
  }
  .mt-sm-n12 {
    margin-top: -3rem !important;
  }
  .mt-sm-n13 {
    margin-top: -3.25rem !important;
  }
  .mt-sm-n14 {
    margin-top: -3.5rem !important;
  }
  .mt-sm-n15 {
    margin-top: -3.75rem !important;
  }
  .mt-sm-n16 {
    margin-top: -4rem !important;
  }
  .mt-sm-n17 {
    margin-top: -4.25rem !important;
  }
  .mt-sm-n18 {
    margin-top: -4.5rem !important;
  }
  .mt-sm-n19 {
    margin-top: -4.75rem !important;
  }
  .mt-sm-n20 {
    margin-top: -5rem !important;
  }
  .me-sm-n1 {
    margin-right: -0.25rem !important;
  }
  .me-sm-n2 {
    margin-right: -0.5rem !important;
  }
  .me-sm-n3 {
    margin-right: -0.75rem !important;
  }
  .me-sm-n4 {
    margin-right: -1rem !important;
  }
  .me-sm-n5 {
    margin-right: -1.25rem !important;
  }
  .me-sm-n6 {
    margin-right: -1.5rem !important;
  }
  .me-sm-n7 {
    margin-right: -1.75rem !important;
  }
  .me-sm-n8 {
    margin-right: -2rem !important;
  }
  .me-sm-n9 {
    margin-right: -2.25rem !important;
  }
  .me-sm-n10 {
    margin-right: -2.5rem !important;
  }
  .me-sm-n11 {
    margin-right: -2.75rem !important;
  }
  .me-sm-n12 {
    margin-right: -3rem !important;
  }
  .me-sm-n13 {
    margin-right: -3.25rem !important;
  }
  .me-sm-n14 {
    margin-right: -3.5rem !important;
  }
  .me-sm-n15 {
    margin-right: -3.75rem !important;
  }
  .me-sm-n16 {
    margin-right: -4rem !important;
  }
  .me-sm-n17 {
    margin-right: -4.25rem !important;
  }
  .me-sm-n18 {
    margin-right: -4.5rem !important;
  }
  .me-sm-n19 {
    margin-right: -4.75rem !important;
  }
  .me-sm-n20 {
    margin-right: -5rem !important;
  }
  .mb-sm-n1 {
    margin-bottom: -0.25rem !important;
  }
  .mb-sm-n2 {
    margin-bottom: -0.5rem !important;
  }
  .mb-sm-n3 {
    margin-bottom: -0.75rem !important;
  }
  .mb-sm-n4 {
    margin-bottom: -1rem !important;
  }
  .mb-sm-n5 {
    margin-bottom: -1.25rem !important;
  }
  .mb-sm-n6 {
    margin-bottom: -1.5rem !important;
  }
  .mb-sm-n7 {
    margin-bottom: -1.75rem !important;
  }
  .mb-sm-n8 {
    margin-bottom: -2rem !important;
  }
  .mb-sm-n9 {
    margin-bottom: -2.25rem !important;
  }
  .mb-sm-n10 {
    margin-bottom: -2.5rem !important;
  }
  .mb-sm-n11 {
    margin-bottom: -2.75rem !important;
  }
  .mb-sm-n12 {
    margin-bottom: -3rem !important;
  }
  .mb-sm-n13 {
    margin-bottom: -3.25rem !important;
  }
  .mb-sm-n14 {
    margin-bottom: -3.5rem !important;
  }
  .mb-sm-n15 {
    margin-bottom: -3.75rem !important;
  }
  .mb-sm-n16 {
    margin-bottom: -4rem !important;
  }
  .mb-sm-n17 {
    margin-bottom: -4.25rem !important;
  }
  .mb-sm-n18 {
    margin-bottom: -4.5rem !important;
  }
  .mb-sm-n19 {
    margin-bottom: -4.75rem !important;
  }
  .mb-sm-n20 {
    margin-bottom: -5rem !important;
  }
  .ms-sm-n1 {
    margin-left: -0.25rem !important;
  }
  .ms-sm-n2 {
    margin-left: -0.5rem !important;
  }
  .ms-sm-n3 {
    margin-left: -0.75rem !important;
  }
  .ms-sm-n4 {
    margin-left: -1rem !important;
  }
  .ms-sm-n5 {
    margin-left: -1.25rem !important;
  }
  .ms-sm-n6 {
    margin-left: -1.5rem !important;
  }
  .ms-sm-n7 {
    margin-left: -1.75rem !important;
  }
  .ms-sm-n8 {
    margin-left: -2rem !important;
  }
  .ms-sm-n9 {
    margin-left: -2.25rem !important;
  }
  .ms-sm-n10 {
    margin-left: -2.5rem !important;
  }
  .ms-sm-n11 {
    margin-left: -2.75rem !important;
  }
  .ms-sm-n12 {
    margin-left: -3rem !important;
  }
  .ms-sm-n13 {
    margin-left: -3.25rem !important;
  }
  .ms-sm-n14 {
    margin-left: -3.5rem !important;
  }
  .ms-sm-n15 {
    margin-left: -3.75rem !important;
  }
  .ms-sm-n16 {
    margin-left: -4rem !important;
  }
  .ms-sm-n17 {
    margin-left: -4.25rem !important;
  }
  .ms-sm-n18 {
    margin-left: -4.5rem !important;
  }
  .ms-sm-n19 {
    margin-left: -4.75rem !important;
  }
  .ms-sm-n20 {
    margin-left: -5rem !important;
  }
  .p-sm-0 {
    padding: 0 !important;
  }
  .p-sm-1 {
    padding: 0.25rem !important;
  }
  .p-sm-2 {
    padding: 0.5rem !important;
  }
  .p-sm-3 {
    padding: 0.75rem !important;
  }
  .p-sm-4 {
    padding: 1rem !important;
  }
  .p-sm-5 {
    padding: 1.25rem !important;
  }
  .p-sm-6 {
    padding: 1.5rem !important;
  }
  .p-sm-7 {
    padding: 1.75rem !important;
  }
  .p-sm-8 {
    padding: 2rem !important;
  }
  .p-sm-9 {
    padding: 2.25rem !important;
  }
  .p-sm-10 {
    padding: 2.5rem !important;
  }
  .p-sm-11 {
    padding: 2.75rem !important;
  }
  .p-sm-12 {
    padding: 3rem !important;
  }
  .p-sm-13 {
    padding: 3.25rem !important;
  }
  .p-sm-14 {
    padding: 3.5rem !important;
  }
  .p-sm-15 {
    padding: 3.75rem !important;
  }
  .p-sm-16 {
    padding: 4rem !important;
  }
  .p-sm-17 {
    padding: 4.25rem !important;
  }
  .p-sm-18 {
    padding: 4.5rem !important;
  }
  .p-sm-19 {
    padding: 4.75rem !important;
  }
  .p-sm-20 {
    padding: 5rem !important;
  }
  .px-sm-0 {
    padding-right: 0 !important;
    padding-left: 0 !important;
  }
  .px-sm-1 {
    padding-right: 0.25rem !important;
    padding-left: 0.25rem !important;
  }
  .px-sm-2 {
    padding-right: 0.5rem !important;
    padding-left: 0.5rem !important;
  }
  .px-sm-3 {
    padding-right: 0.75rem !important;
    padding-left: 0.75rem !important;
  }
  .px-sm-4 {
    padding-right: 1rem !important;
    padding-left: 1rem !important;
  }
  .px-sm-5 {
    padding-right: 1.25rem !important;
    padding-left: 1.25rem !important;
  }
  .px-sm-6 {
    padding-right: 1.5rem !important;
    padding-left: 1.5rem !important;
  }
  .px-sm-7 {
    padding-right: 1.75rem !important;
    padding-left: 1.75rem !important;
  }
  .px-sm-8 {
    padding-right: 2rem !important;
    padding-left: 2rem !important;
  }
  .px-sm-9 {
    padding-right: 2.25rem !important;
    padding-left: 2.25rem !important;
  }
  .px-sm-10 {
    padding-right: 2.5rem !important;
    padding-left: 2.5rem !important;
  }
  .px-sm-11 {
    padding-right: 2.75rem !important;
    padding-left: 2.75rem !important;
  }
  .px-sm-12 {
    padding-right: 3rem !important;
    padding-left: 3rem !important;
  }
  .px-sm-13 {
    padding-right: 3.25rem !important;
    padding-left: 3.25rem !important;
  }
  .px-sm-14 {
    padding-right: 3.5rem !important;
    padding-left: 3.5rem !important;
  }
  .px-sm-15 {
    padding-right: 3.75rem !important;
    padding-left: 3.75rem !important;
  }
  .px-sm-16 {
    padding-right: 4rem !important;
    padding-left: 4rem !important;
  }
  .px-sm-17 {
    padding-right: 4.25rem !important;
    padding-left: 4.25rem !important;
  }
  .px-sm-18 {
    padding-right: 4.5rem !important;
    padding-left: 4.5rem !important;
  }
  .px-sm-19 {
    padding-right: 4.75rem !important;
    padding-left: 4.75rem !important;
  }
  .px-sm-20 {
    padding-right: 5rem !important;
    padding-left: 5rem !important;
  }
  .py-sm-0 {
    padding-top: 0 !important;
    padding-bottom: 0 !important;
  }
  .py-sm-1 {
    padding-top: 0.25rem !important;
    padding-bottom: 0.25rem !important;
  }
  .py-sm-2 {
    padding-top: 0.5rem !important;
    padding-bottom: 0.5rem !important;
  }
  .py-sm-3 {
    padding-top: 0.75rem !important;
    padding-bottom: 0.75rem !important;
  }
  .py-sm-4 {
    padding-top: 1rem !important;
    padding-bottom: 1rem !important;
  }
  .py-sm-5 {
    padding-top: 1.25rem !important;
    padding-bottom: 1.25rem !important;
  }
  .py-sm-6 {
    padding-top: 1.5rem !important;
    padding-bottom: 1.5rem !important;
  }
  .py-sm-7 {
    padding-top: 1.75rem !important;
    padding-bottom: 1.75rem !important;
  }
  .py-sm-8 {
    padding-top: 2rem !important;
    padding-bottom: 2rem !important;
  }
  .py-sm-9 {
    padding-top: 2.25rem !important;
    padding-bottom: 2.25rem !important;
  }
  .py-sm-10 {
    padding-top: 2.5rem !important;
    padding-bottom: 2.5rem !important;
  }
  .py-sm-11 {
    padding-top: 2.75rem !important;
    padding-bottom: 2.75rem !important;
  }
  .py-sm-12 {
    padding-top: 3rem !important;
    padding-bottom: 3rem !important;
  }
  .py-sm-13 {
    padding-top: 3.25rem !important;
    padding-bottom: 3.25rem !important;
  }
  .py-sm-14 {
    padding-top: 3.5rem !important;
    padding-bottom: 3.5rem !important;
  }
  .py-sm-15 {
    padding-top: 3.75rem !important;
    padding-bottom: 3.75rem !important;
  }
  .py-sm-16 {
    padding-top: 4rem !important;
    padding-bottom: 4rem !important;
  }
  .py-sm-17 {
    padding-top: 4.25rem !important;
    padding-bottom: 4.25rem !important;
  }
  .py-sm-18 {
    padding-top: 4.5rem !important;
    padding-bottom: 4.5rem !important;
  }
  .py-sm-19 {
    padding-top: 4.75rem !important;
    padding-bottom: 4.75rem !important;
  }
  .py-sm-20 {
    padding-top: 5rem !important;
    padding-bottom: 5rem !important;
  }
  .pt-sm-0 {
    padding-top: 0 !important;
  }
  .pt-sm-1 {
    padding-top: 0.25rem !important;
  }
  .pt-sm-2 {
    padding-top: 0.5rem !important;
  }
  .pt-sm-3 {
    padding-top: 0.75rem !important;
  }
  .pt-sm-4 {
    padding-top: 1rem !important;
  }
  .pt-sm-5 {
    padding-top: 1.25rem !important;
  }
  .pt-sm-6 {
    padding-top: 1.5rem !important;
  }
  .pt-sm-7 {
    padding-top: 1.75rem !important;
  }
  .pt-sm-8 {
    padding-top: 2rem !important;
  }
  .pt-sm-9 {
    padding-top: 2.25rem !important;
  }
  .pt-sm-10 {
    padding-top: 2.5rem !important;
  }
  .pt-sm-11 {
    padding-top: 2.75rem !important;
  }
  .pt-sm-12 {
    padding-top: 3rem !important;
  }
  .pt-sm-13 {
    padding-top: 3.25rem !important;
  }
  .pt-sm-14 {
    padding-top: 3.5rem !important;
  }
  .pt-sm-15 {
    padding-top: 3.75rem !important;
  }
  .pt-sm-16 {
    padding-top: 4rem !important;
  }
  .pt-sm-17 {
    padding-top: 4.25rem !important;
  }
  .pt-sm-18 {
    padding-top: 4.5rem !important;
  }
  .pt-sm-19 {
    padding-top: 4.75rem !important;
  }
  .pt-sm-20 {
    padding-top: 5rem !important;
  }
  .pe-sm-0 {
    padding-right: 0 !important;
  }
  .pe-sm-1 {
    padding-right: 0.25rem !important;
  }
  .pe-sm-2 {
    padding-right: 0.5rem !important;
  }
  .pe-sm-3 {
    padding-right: 0.75rem !important;
  }
  .pe-sm-4 {
    padding-right: 1rem !important;
  }
  .pe-sm-5 {
    padding-right: 1.25rem !important;
  }
  .pe-sm-6 {
    padding-right: 1.5rem !important;
  }
  .pe-sm-7 {
    padding-right: 1.75rem !important;
  }
  .pe-sm-8 {
    padding-right: 2rem !important;
  }
  .pe-sm-9 {
    padding-right: 2.25rem !important;
  }
  .pe-sm-10 {
    padding-right: 2.5rem !important;
  }
  .pe-sm-11 {
    padding-right: 2.75rem !important;
  }
  .pe-sm-12 {
    padding-right: 3rem !important;
  }
  .pe-sm-13 {
    padding-right: 3.25rem !important;
  }
  .pe-sm-14 {
    padding-right: 3.5rem !important;
  }
  .pe-sm-15 {
    padding-right: 3.75rem !important;
  }
  .pe-sm-16 {
    padding-right: 4rem !important;
  }
  .pe-sm-17 {
    padding-right: 4.25rem !important;
  }
  .pe-sm-18 {
    padding-right: 4.5rem !important;
  }
  .pe-sm-19 {
    padding-right: 4.75rem !important;
  }
  .pe-sm-20 {
    padding-right: 5rem !important;
  }
  .pb-sm-0 {
    padding-bottom: 0 !important;
  }
  .pb-sm-1 {
    padding-bottom: 0.25rem !important;
  }
  .pb-sm-2 {
    padding-bottom: 0.5rem !important;
  }
  .pb-sm-3 {
    padding-bottom: 0.75rem !important;
  }
  .pb-sm-4 {
    padding-bottom: 1rem !important;
  }
  .pb-sm-5 {
    padding-bottom: 1.25rem !important;
  }
  .pb-sm-6 {
    padding-bottom: 1.5rem !important;
  }
  .pb-sm-7 {
    padding-bottom: 1.75rem !important;
  }
  .pb-sm-8 {
    padding-bottom: 2rem !important;
  }
  .pb-sm-9 {
    padding-bottom: 2.25rem !important;
  }
  .pb-sm-10 {
    padding-bottom: 2.5rem !important;
  }
  .pb-sm-11 {
    padding-bottom: 2.75rem !important;
  }
  .pb-sm-12 {
    padding-bottom: 3rem !important;
  }
  .pb-sm-13 {
    padding-bottom: 3.25rem !important;
  }
  .pb-sm-14 {
    padding-bottom: 3.5rem !important;
  }
  .pb-sm-15 {
    padding-bottom: 3.75rem !important;
  }
  .pb-sm-16 {
    padding-bottom: 4rem !important;
  }
  .pb-sm-17 {
    padding-bottom: 4.25rem !important;
  }
  .pb-sm-18 {
    padding-bottom: 4.5rem !important;
  }
  .pb-sm-19 {
    padding-bottom: 4.75rem !important;
  }
  .pb-sm-20 {
    padding-bottom: 5rem !important;
  }
  .ps-sm-0 {
    padding-left: 0 !important;
  }
  .ps-sm-1 {
    padding-left: 0.25rem !important;
  }
  .ps-sm-2 {
    padding-left: 0.5rem !important;
  }
  .ps-sm-3 {
    padding-left: 0.75rem !important;
  }
  .ps-sm-4 {
    padding-left: 1rem !important;
  }
  .ps-sm-5 {
    padding-left: 1.25rem !important;
  }
  .ps-sm-6 {
    padding-left: 1.5rem !important;
  }
  .ps-sm-7 {
    padding-left: 1.75rem !important;
  }
  .ps-sm-8 {
    padding-left: 2rem !important;
  }
  .ps-sm-9 {
    padding-left: 2.25rem !important;
  }
  .ps-sm-10 {
    padding-left: 2.5rem !important;
  }
  .ps-sm-11 {
    padding-left: 2.75rem !important;
  }
  .ps-sm-12 {
    padding-left: 3rem !important;
  }
  .ps-sm-13 {
    padding-left: 3.25rem !important;
  }
  .ps-sm-14 {
    padding-left: 3.5rem !important;
  }
  .ps-sm-15 {
    padding-left: 3.75rem !important;
  }
  .ps-sm-16 {
    padding-left: 4rem !important;
  }
  .ps-sm-17 {
    padding-left: 4.25rem !important;
  }
  .ps-sm-18 {
    padding-left: 4.5rem !important;
  }
  .ps-sm-19 {
    padding-left: 4.75rem !important;
  }
  .ps-sm-20 {
    padding-left: 5rem !important;
  }
  .gap-sm-0 {
    gap: 0 !important;
  }
  .gap-sm-1 {
    gap: 0.25rem !important;
  }
  .gap-sm-2 {
    gap: 0.5rem !important;
  }
  .gap-sm-3 {
    gap: 0.75rem !important;
  }
  .gap-sm-4 {
    gap: 1rem !important;
  }
  .gap-sm-5 {
    gap: 1.25rem !important;
  }
  .gap-sm-6 {
    gap: 1.5rem !important;
  }
  .gap-sm-7 {
    gap: 1.75rem !important;
  }
  .gap-sm-8 {
    gap: 2rem !important;
  }
  .gap-sm-9 {
    gap: 2.25rem !important;
  }
  .gap-sm-10 {
    gap: 2.5rem !important;
  }
  .gap-sm-11 {
    gap: 2.75rem !important;
  }
  .gap-sm-12 {
    gap: 3rem !important;
  }
  .gap-sm-13 {
    gap: 3.25rem !important;
  }
  .gap-sm-14 {
    gap: 3.5rem !important;
  }
  .gap-sm-15 {
    gap: 3.75rem !important;
  }
  .gap-sm-16 {
    gap: 4rem !important;
  }
  .gap-sm-17 {
    gap: 4.25rem !important;
  }
  .gap-sm-18 {
    gap: 4.5rem !important;
  }
  .gap-sm-19 {
    gap: 4.75rem !important;
  }
  .gap-sm-20 {
    gap: 5rem !important;
  }
  .row-gap-sm-0 {
    row-gap: 0 !important;
  }
  .row-gap-sm-1 {
    row-gap: 0.25rem !important;
  }
  .row-gap-sm-2 {
    row-gap: 0.5rem !important;
  }
  .row-gap-sm-3 {
    row-gap: 0.75rem !important;
  }
  .row-gap-sm-4 {
    row-gap: 1rem !important;
  }
  .row-gap-sm-5 {
    row-gap: 1.25rem !important;
  }
  .row-gap-sm-6 {
    row-gap: 1.5rem !important;
  }
  .row-gap-sm-7 {
    row-gap: 1.75rem !important;
  }
  .row-gap-sm-8 {
    row-gap: 2rem !important;
  }
  .row-gap-sm-9 {
    row-gap: 2.25rem !important;
  }
  .row-gap-sm-10 {
    row-gap: 2.5rem !important;
  }
  .row-gap-sm-11 {
    row-gap: 2.75rem !important;
  }
  .row-gap-sm-12 {
    row-gap: 3rem !important;
  }
  .row-gap-sm-13 {
    row-gap: 3.25rem !important;
  }
  .row-gap-sm-14 {
    row-gap: 3.5rem !important;
  }
  .row-gap-sm-15 {
    row-gap: 3.75rem !important;
  }
  .row-gap-sm-16 {
    row-gap: 4rem !important;
  }
  .row-gap-sm-17 {
    row-gap: 4.25rem !important;
  }
  .row-gap-sm-18 {
    row-gap: 4.5rem !important;
  }
  .row-gap-sm-19 {
    row-gap: 4.75rem !important;
  }
  .row-gap-sm-20 {
    row-gap: 5rem !important;
  }
  .column-gap-sm-0 {
    column-gap: 0 !important;
  }
  .column-gap-sm-1 {
    column-gap: 0.25rem !important;
  }
  .column-gap-sm-2 {
    column-gap: 0.5rem !important;
  }
  .column-gap-sm-3 {
    column-gap: 0.75rem !important;
  }
  .column-gap-sm-4 {
    column-gap: 1rem !important;
  }
  .column-gap-sm-5 {
    column-gap: 1.25rem !important;
  }
  .column-gap-sm-6 {
    column-gap: 1.5rem !important;
  }
  .column-gap-sm-7 {
    column-gap: 1.75rem !important;
  }
  .column-gap-sm-8 {
    column-gap: 2rem !important;
  }
  .column-gap-sm-9 {
    column-gap: 2.25rem !important;
  }
  .column-gap-sm-10 {
    column-gap: 2.5rem !important;
  }
  .column-gap-sm-11 {
    column-gap: 2.75rem !important;
  }
  .column-gap-sm-12 {
    column-gap: 3rem !important;
  }
  .column-gap-sm-13 {
    column-gap: 3.25rem !important;
  }
  .column-gap-sm-14 {
    column-gap: 3.5rem !important;
  }
  .column-gap-sm-15 {
    column-gap: 3.75rem !important;
  }
  .column-gap-sm-16 {
    column-gap: 4rem !important;
  }
  .column-gap-sm-17 {
    column-gap: 4.25rem !important;
  }
  .column-gap-sm-18 {
    column-gap: 4.5rem !important;
  }
  .column-gap-sm-19 {
    column-gap: 4.75rem !important;
  }
  .column-gap-sm-20 {
    column-gap: 5rem !important;
  }
  .fs-sm-1 {
    font-size: calc(1.3rem + 0.6vw) !important;
  }
  .fs-sm-2 {
    font-size: calc(1.275rem + 0.3vw) !important;
  }
  .fs-sm-3 {
    font-size: calc(1.26rem + 0.12vw) !important;
  }
  .fs-sm-4 {
    font-size: 1.25rem !important;
  }
  .fs-sm-5 {
    font-size: 1.15rem !important;
  }
  .fs-sm-6 {
    font-size: 1.075rem !important;
  }
  .fs-sm-7 {
    font-size: 0.95rem !important;
  }
  .fs-sm-8 {
    font-size: 0.85rem !important;
  }
  .fs-sm-9 {
    font-size: 0.75rem !important;
  }
  .fs-sm-10 {
    font-size: 0.5rem !important;
  }
  .fs-sm-base {
    font-size: 1rem !important;
  }
  .fs-sm-fluid {
    font-size: 100% !important;
  }
  .fs-sm-2x {
    font-size: calc(1.325rem + 0.9vw) !important;
  }
  .fs-sm-2qx {
    font-size: calc(1.35rem + 1.2vw) !important;
  }
  .fs-sm-2hx {
    font-size: calc(1.375rem + 1.5vw) !important;
  }
  .fs-sm-2tx {
    font-size: calc(1.4rem + 1.8vw) !important;
  }
  .fs-sm-3x {
    font-size: calc(1.425rem + 2.1vw) !important;
  }
  .fs-sm-3qx {
    font-size: calc(1.45rem + 2.4vw) !important;
  }
  .fs-sm-3hx {
    font-size: calc(1.475rem + 2.7vw) !important;
  }
  .fs-sm-3tx {
    font-size: calc(1.5rem + 3vw) !important;
  }
  .fs-sm-4x {
    font-size: calc(1.525rem + 3.3vw) !important;
  }
  .fs-sm-4qx {
    font-size: calc(1.55rem + 3.6vw) !important;
  }
  .fs-sm-4hx {
    font-size: calc(1.575rem + 3.9vw) !important;
  }
  .fs-sm-4tx {
    font-size: calc(1.6rem + 4.2vw) !important;
  }
  .fs-sm-5x {
    font-size: calc(1.625rem + 4.5vw) !important;
  }
  .fs-sm-5qx {
    font-size: calc(1.65rem + 4.8vw) !important;
  }
  .fs-sm-5hx {
    font-size: calc(1.675rem + 5.1vw) !important;
  }
  .fs-sm-5tx {
    font-size: calc(1.7rem + 5.4vw) !important;
  }
  .fs-sm-6x {
    font-size: calc(1.725rem + 5.7vw) !important;
  }
  .fs-sm-6qx {
    font-size: calc(1.75rem + 6vw) !important;
  }
  .fs-sm-6hx {
    font-size: calc(1.775rem + 6.3vw) !important;
  }
  .fs-sm-6tx {
    font-size: calc(1.8rem + 6.6vw) !important;
  }
  .fs-sm-7x {
    font-size: calc(1.825rem + 6.9vw) !important;
  }
  .fs-sm-7qx {
    font-size: calc(1.85rem + 7.2vw) !important;
  }
  .fs-sm-7hx {
    font-size: calc(1.875rem + 7.5vw) !important;
  }
  .fs-sm-7tx {
    font-size: calc(1.9rem + 7.8vw) !important;
  }
  .text-sm-start {
    text-align: left !important;
  }
  .text-sm-end {
    text-align: right !important;
  }
  .text-sm-center {
    text-align: center !important;
  }
  .min-w-sm-unset {
    min-width: unset !important;
  }
  .min-w-sm-25 {
    min-width: 25% !important;
  }
  .min-w-sm-50 {
    min-width: 50% !important;
  }
  .min-w-sm-75 {
    min-width: 75% !important;
  }
  .min-w-sm-100 {
    min-width: 100% !important;
  }
  .min-w-sm-auto {
    min-width: auto !important;
  }
  .min-w-sm-1px {
    min-width: 1px !important;
  }
  .min-w-sm-2px {
    min-width: 2px !important;
  }
  .min-w-sm-3px {
    min-width: 3px !important;
  }
  .min-w-sm-4px {
    min-width: 4px !important;
  }
  .min-w-sm-5px {
    min-width: 5px !important;
  }
  .min-w-sm-6px {
    min-width: 6px !important;
  }
  .min-w-sm-7px {
    min-width: 7px !important;
  }
  .min-w-sm-8px {
    min-width: 8px !important;
  }
  .min-w-sm-9px {
    min-width: 9px !important;
  }
  .min-w-sm-10px {
    min-width: 10px !important;
  }
  .min-w-sm-15px {
    min-width: 15px !important;
  }
  .min-w-sm-20px {
    min-width: 20px !important;
  }
  .min-w-sm-25px {
    min-width: 25px !important;
  }
  .min-w-sm-30px {
    min-width: 30px !important;
  }
  .min-w-sm-35px {
    min-width: 35px !important;
  }
  .min-w-sm-40px {
    min-width: 40px !important;
  }
  .min-w-sm-45px {
    min-width: 45px !important;
  }
  .min-w-sm-50px {
    min-width: 50px !important;
  }
  .min-w-sm-55px {
    min-width: 55px !important;
  }
  .min-w-sm-60px {
    min-width: 60px !important;
  }
  .min-w-sm-65px {
    min-width: 65px !important;
  }
  .min-w-sm-70px {
    min-width: 70px !important;
  }
  .min-w-sm-75px {
    min-width: 75px !important;
  }
  .min-w-sm-80px {
    min-width: 80px !important;
  }
  .min-w-sm-85px {
    min-width: 85px !important;
  }
  .min-w-sm-90px {
    min-width: 90px !important;
  }
  .min-w-sm-95px {
    min-width: 95px !important;
  }
  .min-w-sm-100px {
    min-width: 100px !important;
  }
  .min-w-sm-125px {
    min-width: 125px !important;
  }
  .min-w-sm-150px {
    min-width: 150px !important;
  }
  .min-w-sm-175px {
    min-width: 175px !important;
  }
  .min-w-sm-200px {
    min-width: 200px !important;
  }
  .min-w-sm-225px {
    min-width: 225px !important;
  }
  .min-w-sm-250px {
    min-width: 250px !important;
  }
  .min-w-sm-275px {
    min-width: 275px !important;
  }
  .min-w-sm-300px {
    min-width: 300px !important;
  }
  .min-w-sm-325px {
    min-width: 325px !important;
  }
  .min-w-sm-350px {
    min-width: 350px !important;
  }
  .min-w-sm-375px {
    min-width: 375px !important;
  }
  .min-w-sm-400px {
    min-width: 400px !important;
  }
  .min-w-sm-425px {
    min-width: 425px !important;
  }
  .min-w-sm-450px {
    min-width: 450px !important;
  }
  .min-w-sm-475px {
    min-width: 475px !important;
  }
  .min-w-sm-500px {
    min-width: 500px !important;
  }
  .min-w-sm-550px {
    min-width: 550px !important;
  }
  .min-w-sm-600px {
    min-width: 600px !important;
  }
  .min-w-sm-650px {
    min-width: 650px !important;
  }
  .min-w-sm-700px {
    min-width: 700px !important;
  }
  .min-w-sm-750px {
    min-width: 750px !important;
  }
  .min-w-sm-800px {
    min-width: 800px !important;
  }
  .min-w-sm-850px {
    min-width: 850px !important;
  }
  .min-w-sm-900px {
    min-width: 900px !important;
  }
  .min-w-sm-950px {
    min-width: 950px !important;
  }
  .min-w-sm-1000px {
    min-width: 1000px !important;
  }
  .min-h-sm-unset {
    min-height: unset !important;
  }
  .min-h-sm-25 {
    min-height: 25% !important;
  }
  .min-h-sm-50 {
    min-height: 50% !important;
  }
  .min-h-sm-75 {
    min-height: 75% !important;
  }
  .min-h-sm-100 {
    min-height: 100% !important;
  }
  .min-h-sm-auto {
    min-height: auto !important;
  }
  .min-h-sm-1px {
    min-height: 1px !important;
  }
  .min-h-sm-2px {
    min-height: 2px !important;
  }
  .min-h-sm-3px {
    min-height: 3px !important;
  }
  .min-h-sm-4px {
    min-height: 4px !important;
  }
  .min-h-sm-5px {
    min-height: 5px !important;
  }
  .min-h-sm-6px {
    min-height: 6px !important;
  }
  .min-h-sm-7px {
    min-height: 7px !important;
  }
  .min-h-sm-8px {
    min-height: 8px !important;
  }
  .min-h-sm-9px {
    min-height: 9px !important;
  }
  .min-h-sm-10px {
    min-height: 10px !important;
  }
  .min-h-sm-15px {
    min-height: 15px !important;
  }
  .min-h-sm-20px {
    min-height: 20px !important;
  }
  .min-h-sm-25px {
    min-height: 25px !important;
  }
  .min-h-sm-30px {
    min-height: 30px !important;
  }
  .min-h-sm-35px {
    min-height: 35px !important;
  }
  .min-h-sm-40px {
    min-height: 40px !important;
  }
  .min-h-sm-45px {
    min-height: 45px !important;
  }
  .min-h-sm-50px {
    min-height: 50px !important;
  }
  .min-h-sm-55px {
    min-height: 55px !important;
  }
  .min-h-sm-60px {
    min-height: 60px !important;
  }
  .min-h-sm-65px {
    min-height: 65px !important;
  }
  .min-h-sm-70px {
    min-height: 70px !important;
  }
  .min-h-sm-75px {
    min-height: 75px !important;
  }
  .min-h-sm-80px {
    min-height: 80px !important;
  }
  .min-h-sm-85px {
    min-height: 85px !important;
  }
  .min-h-sm-90px {
    min-height: 90px !important;
  }
  .min-h-sm-95px {
    min-height: 95px !important;
  }
  .min-h-sm-100px {
    min-height: 100px !important;
  }
  .min-h-sm-125px {
    min-height: 125px !important;
  }
  .min-h-sm-150px {
    min-height: 150px !important;
  }
  .min-h-sm-175px {
    min-height: 175px !important;
  }
  .min-h-sm-200px {
    min-height: 200px !important;
  }
  .min-h-sm-225px {
    min-height: 225px !important;
  }
  .min-h-sm-250px {
    min-height: 250px !important;
  }
  .min-h-sm-275px {
    min-height: 275px !important;
  }
  .min-h-sm-300px {
    min-height: 300px !important;
  }
  .min-h-sm-325px {
    min-height: 325px !important;
  }
  .min-h-sm-350px {
    min-height: 350px !important;
  }
  .min-h-sm-375px {
    min-height: 375px !important;
  }
  .min-h-sm-400px {
    min-height: 400px !important;
  }
  .min-h-sm-425px {
    min-height: 425px !important;
  }
  .min-h-sm-450px {
    min-height: 450px !important;
  }
  .min-h-sm-475px {
    min-height: 475px !important;
  }
  .min-h-sm-500px {
    min-height: 500px !important;
  }
  .min-h-sm-550px {
    min-height: 550px !important;
  }
  .min-h-sm-600px {
    min-height: 600px !important;
  }
  .min-h-sm-650px {
    min-height: 650px !important;
  }
  .min-h-sm-700px {
    min-height: 700px !important;
  }
  .min-h-sm-750px {
    min-height: 750px !important;
  }
  .min-h-sm-800px {
    min-height: 800px !important;
  }
  .min-h-sm-850px {
    min-height: 850px !important;
  }
  .min-h-sm-900px {
    min-height: 900px !important;
  }
  .min-h-sm-950px {
    min-height: 950px !important;
  }
  .min-h-sm-1000px {
    min-height: 1000px !important;
  }
}
@media (min-width: 768px) {
  .float-md-start {
    float: left !important;
  }
  .float-md-end {
    float: right !important;
  }
  .float-md-none {
    float: none !important;
  }
  .object-fit-md-contain {
    object-fit: contain !important;
  }
  .object-fit-md-cover {
    object-fit: cover !important;
  }
  .object-fit-md-fill {
    object-fit: fill !important;
  }
  .object-fit-md-scale {
    object-fit: scale-down !important;
  }
  .object-fit-md-none {
    object-fit: none !important;
  }
  .overflow-md-auto {
    overflow: auto !important;
  }
  .overflow-md-hidden {
    overflow: hidden !important;
  }
  .overflow-md-visible {
    overflow: visible !important;
  }
  .overflow-md-scroll {
    overflow: scroll !important;
  }
  .d-md-inline {
    display: inline !important;
  }
  .d-md-inline-block {
    display: inline-block !important;
  }
  .d-md-block {
    display: block !important;
  }
  .d-md-grid {
    display: grid !important;
  }
  .d-md-table {
    display: table !important;
  }
  .d-md-table-row {
    display: table-row !important;
  }
  .d-md-table-cell {
    display: table-cell !important;
  }
  .d-md-flex {
    display: flex !important;
  }
  .d-md-inline-flex {
    display: inline-flex !important;
  }
  .d-md-none {
    display: none !important;
  }
  .position-md-static {
    position: static !important;
  }
  .position-md-relative {
    position: relative !important;
  }
  .position-md-absolute {
    position: absolute !important;
  }
  .position-md-fixed {
    position: fixed !important;
  }
  .position-md-sticky {
    position: sticky !important;
  }
  .w-md-unset {
    width: unset !important;
  }
  .w-md-25 {
    width: 25% !important;
  }
  .w-md-50 {
    width: 50% !important;
  }
  .w-md-75 {
    width: 75% !important;
  }
  .w-md-100 {
    width: 100% !important;
  }
  .w-md-auto {
    width: auto !important;
  }
  .w-md-1px {
    width: 1px !important;
  }
  .w-md-2px {
    width: 2px !important;
  }
  .w-md-3px {
    width: 3px !important;
  }
  .w-md-4px {
    width: 4px !important;
  }
  .w-md-5px {
    width: 5px !important;
  }
  .w-md-6px {
    width: 6px !important;
  }
  .w-md-7px {
    width: 7px !important;
  }
  .w-md-8px {
    width: 8px !important;
  }
  .w-md-9px {
    width: 9px !important;
  }
  .w-md-10px {
    width: 10px !important;
  }
  .w-md-15px {
    width: 15px !important;
  }
  .w-md-20px {
    width: 20px !important;
  }
  .w-md-25px {
    width: 25px !important;
  }
  .w-md-30px {
    width: 30px !important;
  }
  .w-md-35px {
    width: 35px !important;
  }
  .w-md-40px {
    width: 40px !important;
  }
  .w-md-45px {
    width: 45px !important;
  }
  .w-md-50px {
    width: 50px !important;
  }
  .w-md-55px {
    width: 55px !important;
  }
  .w-md-60px {
    width: 60px !important;
  }
  .w-md-65px {
    width: 65px !important;
  }
  .w-md-70px {
    width: 70px !important;
  }
  .w-md-75px {
    width: 75px !important;
  }
  .w-md-80px {
    width: 80px !important;
  }
  .w-md-85px {
    width: 85px !important;
  }
  .w-md-90px {
    width: 90px !important;
  }
  .w-md-95px {
    width: 95px !important;
  }
  .w-md-100px {
    width: 100px !important;
  }
  .w-md-125px {
    width: 125px !important;
  }
  .w-md-150px {
    width: 150px !important;
  }
  .w-md-175px {
    width: 175px !important;
  }
  .w-md-200px {
    width: 200px !important;
  }
  .w-md-225px {
    width: 225px !important;
  }
  .w-md-250px {
    width: 250px !important;
  }
  .w-md-275px {
    width: 275px !important;
  }
  .w-md-300px {
    width: 300px !important;
  }
  .w-md-325px {
    width: 325px !important;
  }
  .w-md-350px {
    width: 350px !important;
  }
  .w-md-375px {
    width: 375px !important;
  }
  .w-md-400px {
    width: 400px !important;
  }
  .w-md-425px {
    width: 425px !important;
  }
  .w-md-450px {
    width: 450px !important;
  }
  .w-md-475px {
    width: 475px !important;
  }
  .w-md-500px {
    width: 500px !important;
  }
  .w-md-550px {
    width: 550px !important;
  }
  .w-md-600px {
    width: 600px !important;
  }
  .w-md-650px {
    width: 650px !important;
  }
  .w-md-700px {
    width: 700px !important;
  }
  .w-md-750px {
    width: 750px !important;
  }
  .w-md-800px {
    width: 800px !important;
  }
  .w-md-850px {
    width: 850px !important;
  }
  .w-md-900px {
    width: 900px !important;
  }
  .w-md-950px {
    width: 950px !important;
  }
  .w-md-1000px {
    width: 1000px !important;
  }
  .mw-md-unset {
    max-width: unset !important;
  }
  .mw-md-25 {
    max-width: 25% !important;
  }
  .mw-md-50 {
    max-width: 50% !important;
  }
  .mw-md-75 {
    max-width: 75% !important;
  }
  .mw-md-100 {
    max-width: 100% !important;
  }
  .mw-md-auto {
    max-width: auto !important;
  }
  .mw-md-1px {
    max-width: 1px !important;
  }
  .mw-md-2px {
    max-width: 2px !important;
  }
  .mw-md-3px {
    max-width: 3px !important;
  }
  .mw-md-4px {
    max-width: 4px !important;
  }
  .mw-md-5px {
    max-width: 5px !important;
  }
  .mw-md-6px {
    max-width: 6px !important;
  }
  .mw-md-7px {
    max-width: 7px !important;
  }
  .mw-md-8px {
    max-width: 8px !important;
  }
  .mw-md-9px {
    max-width: 9px !important;
  }
  .mw-md-10px {
    max-width: 10px !important;
  }
  .mw-md-15px {
    max-width: 15px !important;
  }
  .mw-md-20px {
    max-width: 20px !important;
  }
  .mw-md-25px {
    max-width: 25px !important;
  }
  .mw-md-30px {
    max-width: 30px !important;
  }
  .mw-md-35px {
    max-width: 35px !important;
  }
  .mw-md-40px {
    max-width: 40px !important;
  }
  .mw-md-45px {
    max-width: 45px !important;
  }
  .mw-md-50px {
    max-width: 50px !important;
  }
  .mw-md-55px {
    max-width: 55px !important;
  }
  .mw-md-60px {
    max-width: 60px !important;
  }
  .mw-md-65px {
    max-width: 65px !important;
  }
  .mw-md-70px {
    max-width: 70px !important;
  }
  .mw-md-75px {
    max-width: 75px !important;
  }
  .mw-md-80px {
    max-width: 80px !important;
  }
  .mw-md-85px {
    max-width: 85px !important;
  }
  .mw-md-90px {
    max-width: 90px !important;
  }
  .mw-md-95px {
    max-width: 95px !important;
  }
  .mw-md-100px {
    max-width: 100px !important;
  }
  .mw-md-125px {
    max-width: 125px !important;
  }
  .mw-md-150px {
    max-width: 150px !important;
  }
  .mw-md-175px {
    max-width: 175px !important;
  }
  .mw-md-200px {
    max-width: 200px !important;
  }
  .mw-md-225px {
    max-width: 225px !important;
  }
  .mw-md-250px {
    max-width: 250px !important;
  }
  .mw-md-275px {
    max-width: 275px !important;
  }
  .mw-md-300px {
    max-width: 300px !important;
  }
  .mw-md-325px {
    max-width: 325px !important;
  }
  .mw-md-350px {
    max-width: 350px !important;
  }
  .mw-md-375px {
    max-width: 375px !important;
  }
  .mw-md-400px {
    max-width: 400px !important;
  }
  .mw-md-425px {
    max-width: 425px !important;
  }
  .mw-md-450px {
    max-width: 450px !important;
  }
  .mw-md-475px {
    max-width: 475px !important;
  }
  .mw-md-500px {
    max-width: 500px !important;
  }
  .mw-md-550px {
    max-width: 550px !important;
  }
  .mw-md-600px {
    max-width: 600px !important;
  }
  .mw-md-650px {
    max-width: 650px !important;
  }
  .mw-md-700px {
    max-width: 700px !important;
  }
  .mw-md-750px {
    max-width: 750px !important;
  }
  .mw-md-800px {
    max-width: 800px !important;
  }
  .mw-md-850px {
    max-width: 850px !important;
  }
  .mw-md-900px {
    max-width: 900px !important;
  }
  .mw-md-950px {
    max-width: 950px !important;
  }
  .mw-md-1000px {
    max-width: 1000px !important;
  }
  .h-md-unset {
    height: unset !important;
  }
  .h-md-25 {
    height: 25% !important;
  }
  .h-md-50 {
    height: 50% !important;
  }
  .h-md-75 {
    height: 75% !important;
  }
  .h-md-100 {
    height: 100% !important;
  }
  .h-md-auto {
    height: auto !important;
  }
  .h-md-1px {
    height: 1px !important;
  }
  .h-md-2px {
    height: 2px !important;
  }
  .h-md-3px {
    height: 3px !important;
  }
  .h-md-4px {
    height: 4px !important;
  }
  .h-md-5px {
    height: 5px !important;
  }
  .h-md-6px {
    height: 6px !important;
  }
  .h-md-7px {
    height: 7px !important;
  }
  .h-md-8px {
    height: 8px !important;
  }
  .h-md-9px {
    height: 9px !important;
  }
  .h-md-10px {
    height: 10px !important;
  }
  .h-md-15px {
    height: 15px !important;
  }
  .h-md-20px {
    height: 20px !important;
  }
  .h-md-25px {
    height: 25px !important;
  }
  .h-md-30px {
    height: 30px !important;
  }
  .h-md-35px {
    height: 35px !important;
  }
  .h-md-40px {
    height: 40px !important;
  }
  .h-md-45px {
    height: 45px !important;
  }
  .h-md-50px {
    height: 50px !important;
  }
  .h-md-55px {
    height: 55px !important;
  }
  .h-md-60px {
    height: 60px !important;
  }
  .h-md-65px {
    height: 65px !important;
  }
  .h-md-70px {
    height: 70px !important;
  }
  .h-md-75px {
    height: 75px !important;
  }
  .h-md-80px {
    height: 80px !important;
  }
  .h-md-85px {
    height: 85px !important;
  }
  .h-md-90px {
    height: 90px !important;
  }
  .h-md-95px {
    height: 95px !important;
  }
  .h-md-100px {
    height: 100px !important;
  }
  .h-md-125px {
    height: 125px !important;
  }
  .h-md-150px {
    height: 150px !important;
  }
  .h-md-175px {
    height: 175px !important;
  }
  .h-md-200px {
    height: 200px !important;
  }
  .h-md-225px {
    height: 225px !important;
  }
  .h-md-250px {
    height: 250px !important;
  }
  .h-md-275px {
    height: 275px !important;
  }
  .h-md-300px {
    height: 300px !important;
  }
  .h-md-325px {
    height: 325px !important;
  }
  .h-md-350px {
    height: 350px !important;
  }
  .h-md-375px {
    height: 375px !important;
  }
  .h-md-400px {
    height: 400px !important;
  }
  .h-md-425px {
    height: 425px !important;
  }
  .h-md-450px {
    height: 450px !important;
  }
  .h-md-475px {
    height: 475px !important;
  }
  .h-md-500px {
    height: 500px !important;
  }
  .h-md-550px {
    height: 550px !important;
  }
  .h-md-600px {
    height: 600px !important;
  }
  .h-md-650px {
    height: 650px !important;
  }
  .h-md-700px {
    height: 700px !important;
  }
  .h-md-750px {
    height: 750px !important;
  }
  .h-md-800px {
    height: 800px !important;
  }
  .h-md-850px {
    height: 850px !important;
  }
  .h-md-900px {
    height: 900px !important;
  }
  .h-md-950px {
    height: 950px !important;
  }
  .h-md-1000px {
    height: 1000px !important;
  }
  .mh-md-unset {
    max-height: unset !important;
  }
  .mh-md-25 {
    max-height: 25% !important;
  }
  .mh-md-50 {
    max-height: 50% !important;
  }
  .mh-md-75 {
    max-height: 75% !important;
  }
  .mh-md-100 {
    max-height: 100% !important;
  }
  .mh-md-auto {
    max-height: auto !important;
  }
  .mh-md-1px {
    max-height: 1px !important;
  }
  .mh-md-2px {
    max-height: 2px !important;
  }
  .mh-md-3px {
    max-height: 3px !important;
  }
  .mh-md-4px {
    max-height: 4px !important;
  }
  .mh-md-5px {
    max-height: 5px !important;
  }
  .mh-md-6px {
    max-height: 6px !important;
  }
  .mh-md-7px {
    max-height: 7px !important;
  }
  .mh-md-8px {
    max-height: 8px !important;
  }
  .mh-md-9px {
    max-height: 9px !important;
  }
  .mh-md-10px {
    max-height: 10px !important;
  }
  .mh-md-15px {
    max-height: 15px !important;
  }
  .mh-md-20px {
    max-height: 20px !important;
  }
  .mh-md-25px {
    max-height: 25px !important;
  }
  .mh-md-30px {
    max-height: 30px !important;
  }
  .mh-md-35px {
    max-height: 35px !important;
  }
  .mh-md-40px {
    max-height: 40px !important;
  }
  .mh-md-45px {
    max-height: 45px !important;
  }
  .mh-md-50px {
    max-height: 50px !important;
  }
  .mh-md-55px {
    max-height: 55px !important;
  }
  .mh-md-60px {
    max-height: 60px !important;
  }
  .mh-md-65px {
    max-height: 65px !important;
  }
  .mh-md-70px {
    max-height: 70px !important;
  }
  .mh-md-75px {
    max-height: 75px !important;
  }
  .mh-md-80px {
    max-height: 80px !important;
  }
  .mh-md-85px {
    max-height: 85px !important;
  }
  .mh-md-90px {
    max-height: 90px !important;
  }
  .mh-md-95px {
    max-height: 95px !important;
  }
  .mh-md-100px {
    max-height: 100px !important;
  }
  .mh-md-125px {
    max-height: 125px !important;
  }
  .mh-md-150px {
    max-height: 150px !important;
  }
  .mh-md-175px {
    max-height: 175px !important;
  }
  .mh-md-200px {
    max-height: 200px !important;
  }
  .mh-md-225px {
    max-height: 225px !important;
  }
  .mh-md-250px {
    max-height: 250px !important;
  }
  .mh-md-275px {
    max-height: 275px !important;
  }
  .mh-md-300px {
    max-height: 300px !important;
  }
  .mh-md-325px {
    max-height: 325px !important;
  }
  .mh-md-350px {
    max-height: 350px !important;
  }
  .mh-md-375px {
    max-height: 375px !important;
  }
  .mh-md-400px {
    max-height: 400px !important;
  }
  .mh-md-425px {
    max-height: 425px !important;
  }
  .mh-md-450px {
    max-height: 450px !important;
  }
  .mh-md-475px {
    max-height: 475px !important;
  }
  .mh-md-500px {
    max-height: 500px !important;
  }
  .mh-md-550px {
    max-height: 550px !important;
  }
  .mh-md-600px {
    max-height: 600px !important;
  }
  .mh-md-650px {
    max-height: 650px !important;
  }
  .mh-md-700px {
    max-height: 700px !important;
  }
  .mh-md-750px {
    max-height: 750px !important;
  }
  .mh-md-800px {
    max-height: 800px !important;
  }
  .mh-md-850px {
    max-height: 850px !important;
  }
  .mh-md-900px {
    max-height: 900px !important;
  }
  .mh-md-950px {
    max-height: 950px !important;
  }
  .mh-md-1000px {
    max-height: 1000px !important;
  }
  .flex-md-fill {
    flex: 1 1 auto !important;
  }
  .flex-md-row {
    flex-direction: row !important;
  }
  .flex-md-column {
    flex-direction: column !important;
  }
  .flex-md-row-reverse {
    flex-direction: row-reverse !important;
  }
  .flex-md-column-reverse {
    flex-direction: column-reverse !important;
  }
  .flex-md-grow-0 {
    flex-grow: 0 !important;
  }
  .flex-md-grow-1 {
    flex-grow: 1 !important;
  }
  .flex-md-shrink-0 {
    flex-shrink: 0 !important;
  }
  .flex-md-shrink-1 {
    flex-shrink: 1 !important;
  }
  .flex-md-wrap {
    flex-wrap: wrap !important;
  }
  .flex-md-nowrap {
    flex-wrap: nowrap !important;
  }
  .flex-md-wrap-reverse {
    flex-wrap: wrap-reverse !important;
  }
  .justify-content-md-start {
    justify-content: flex-start !important;
  }
  .justify-content-md-end {
    justify-content: flex-end !important;
  }
  .justify-content-md-center {
    justify-content: center !important;
  }
  .justify-content-md-between {
    justify-content: space-between !important;
  }
  .justify-content-md-around {
    justify-content: space-around !important;
  }
  .justify-content-md-evenly {
    justify-content: space-evenly !important;
  }
  .align-items-md-start {
    align-items: flex-start !important;
  }
  .align-items-md-end {
    align-items: flex-end !important;
  }
  .align-items-md-center {
    align-items: center !important;
  }
  .align-items-md-baseline {
    align-items: baseline !important;
  }
  .align-items-md-stretch {
    align-items: stretch !important;
  }
  .align-content-md-start {
    align-content: flex-start !important;
  }
  .align-content-md-end {
    align-content: flex-end !important;
  }
  .align-content-md-center {
    align-content: center !important;
  }
  .align-content-md-between {
    align-content: space-between !important;
  }
  .align-content-md-around {
    align-content: space-around !important;
  }
  .align-content-md-stretch {
    align-content: stretch !important;
  }
  .align-self-md-auto {
    align-self: auto !important;
  }
  .align-self-md-start {
    align-self: flex-start !important;
  }
  .align-self-md-end {
    align-self: flex-end !important;
  }
  .align-self-md-center {
    align-self: center !important;
  }
  .align-self-md-baseline {
    align-self: baseline !important;
  }
  .align-self-md-stretch {
    align-self: stretch !important;
  }
  .order-md-first {
    order: -1 !important;
  }
  .order-md-0 {
    order: 0 !important;
  }
  .order-md-1 {
    order: 1 !important;
  }
  .order-md-2 {
    order: 2 !important;
  }
  .order-md-3 {
    order: 3 !important;
  }
  .order-md-4 {
    order: 4 !important;
  }
  .order-md-5 {
    order: 5 !important;
  }
  .order-md-last {
    order: 6 !important;
  }
  .m-md-0 {
    margin: 0 !important;
  }
  .m-md-1 {
    margin: 0.25rem !important;
  }
  .m-md-2 {
    margin: 0.5rem !important;
  }
  .m-md-3 {
    margin: 0.75rem !important;
  }
  .m-md-4 {
    margin: 1rem !important;
  }
  .m-md-5 {
    margin: 1.25rem !important;
  }
  .m-md-6 {
    margin: 1.5rem !important;
  }
  .m-md-7 {
    margin: 1.75rem !important;
  }
  .m-md-8 {
    margin: 2rem !important;
  }
  .m-md-9 {
    margin: 2.25rem !important;
  }
  .m-md-10 {
    margin: 2.5rem !important;
  }
  .m-md-11 {
    margin: 2.75rem !important;
  }
  .m-md-12 {
    margin: 3rem !important;
  }
  .m-md-13 {
    margin: 3.25rem !important;
  }
  .m-md-14 {
    margin: 3.5rem !important;
  }
  .m-md-15 {
    margin: 3.75rem !important;
  }
  .m-md-16 {
    margin: 4rem !important;
  }
  .m-md-17 {
    margin: 4.25rem !important;
  }
  .m-md-18 {
    margin: 4.5rem !important;
  }
  .m-md-19 {
    margin: 4.75rem !important;
  }
  .m-md-20 {
    margin: 5rem !important;
  }
  .m-md-auto {
    margin: auto !important;
  }
  .mx-md-0 {
    margin-right: 0 !important;
    margin-left: 0 !important;
  }
  .mx-md-1 {
    margin-right: 0.25rem !important;
    margin-left: 0.25rem !important;
  }
  .mx-md-2 {
    margin-right: 0.5rem !important;
    margin-left: 0.5rem !important;
  }
  .mx-md-3 {
    margin-right: 0.75rem !important;
    margin-left: 0.75rem !important;
  }
  .mx-md-4 {
    margin-right: 1rem !important;
    margin-left: 1rem !important;
  }
  .mx-md-5 {
    margin-right: 1.25rem !important;
    margin-left: 1.25rem !important;
  }
  .mx-md-6 {
    margin-right: 1.5rem !important;
    margin-left: 1.5rem !important;
  }
  .mx-md-7 {
    margin-right: 1.75rem !important;
    margin-left: 1.75rem !important;
  }
  .mx-md-8 {
    margin-right: 2rem !important;
    margin-left: 2rem !important;
  }
  .mx-md-9 {
    margin-right: 2.25rem !important;
    margin-left: 2.25rem !important;
  }
  .mx-md-10 {
    margin-right: 2.5rem !important;
    margin-left: 2.5rem !important;
  }
  .mx-md-11 {
    margin-right: 2.75rem !important;
    margin-left: 2.75rem !important;
  }
  .mx-md-12 {
    margin-right: 3rem !important;
    margin-left: 3rem !important;
  }
  .mx-md-13 {
    margin-right: 3.25rem !important;
    margin-left: 3.25rem !important;
  }
  .mx-md-14 {
    margin-right: 3.5rem !important;
    margin-left: 3.5rem !important;
  }
  .mx-md-15 {
    margin-right: 3.75rem !important;
    margin-left: 3.75rem !important;
  }
  .mx-md-16 {
    margin-right: 4rem !important;
    margin-left: 4rem !important;
  }
  .mx-md-17 {
    margin-right: 4.25rem !important;
    margin-left: 4.25rem !important;
  }
  .mx-md-18 {
    margin-right: 4.5rem !important;
    margin-left: 4.5rem !important;
  }
  .mx-md-19 {
    margin-right: 4.75rem !important;
    margin-left: 4.75rem !important;
  }
  .mx-md-20 {
    margin-right: 5rem !important;
    margin-left: 5rem !important;
  }
  .mx-md-auto {
    margin-right: auto !important;
    margin-left: auto !important;
  }
  .my-md-0 {
    margin-top: 0 !important;
    margin-bottom: 0 !important;
  }
  .my-md-1 {
    margin-top: 0.25rem !important;
    margin-bottom: 0.25rem !important;
  }
  .my-md-2 {
    margin-top: 0.5rem !important;
    margin-bottom: 0.5rem !important;
  }
  .my-md-3 {
    margin-top: 0.75rem !important;
    margin-bottom: 0.75rem !important;
  }
  .my-md-4 {
    margin-top: 1rem !important;
    margin-bottom: 1rem !important;
  }
  .my-md-5 {
    margin-top: 1.25rem !important;
    margin-bottom: 1.25rem !important;
  }
  .my-md-6 {
    margin-top: 1.5rem !important;
    margin-bottom: 1.5rem !important;
  }
  .my-md-7 {
    margin-top: 1.75rem !important;
    margin-bottom: 1.75rem !important;
  }
  .my-md-8 {
    margin-top: 2rem !important;
    margin-bottom: 2rem !important;
  }
  .my-md-9 {
    margin-top: 2.25rem !important;
    margin-bottom: 2.25rem !important;
  }
  .my-md-10 {
    margin-top: 2.5rem !important;
    margin-bottom: 2.5rem !important;
  }
  .my-md-11 {
    margin-top: 2.75rem !important;
    margin-bottom: 2.75rem !important;
  }
  .my-md-12 {
    margin-top: 3rem !important;
    margin-bottom: 3rem !important;
  }
  .my-md-13 {
    margin-top: 3.25rem !important;
    margin-bottom: 3.25rem !important;
  }
  .my-md-14 {
    margin-top: 3.5rem !important;
    margin-bottom: 3.5rem !important;
  }
  .my-md-15 {
    margin-top: 3.75rem !important;
    margin-bottom: 3.75rem !important;
  }
  .my-md-16 {
    margin-top: 4rem !important;
    margin-bottom: 4rem !important;
  }
  .my-md-17 {
    margin-top: 4.25rem !important;
    margin-bottom: 4.25rem !important;
  }
  .my-md-18 {
    margin-top: 4.5rem !important;
    margin-bottom: 4.5rem !important;
  }
  .my-md-19 {
    margin-top: 4.75rem !important;
    margin-bottom: 4.75rem !important;
  }
  .my-md-20 {
    margin-top: 5rem !important;
    margin-bottom: 5rem !important;
  }
  .my-md-auto {
    margin-top: auto !important;
    margin-bottom: auto !important;
  }
  .mt-md-0 {
    margin-top: 0 !important;
  }
  .mt-md-1 {
    margin-top: 0.25rem !important;
  }
  .mt-md-2 {
    margin-top: 0.5rem !important;
  }
  .mt-md-3 {
    margin-top: 0.75rem !important;
  }
  .mt-md-4 {
    margin-top: 1rem !important;
  }
  .mt-md-5 {
    margin-top: 1.25rem !important;
  }
  .mt-md-6 {
    margin-top: 1.5rem !important;
  }
  .mt-md-7 {
    margin-top: 1.75rem !important;
  }
  .mt-md-8 {
    margin-top: 2rem !important;
  }
  .mt-md-9 {
    margin-top: 2.25rem !important;
  }
  .mt-md-10 {
    margin-top: 2.5rem !important;
  }
  .mt-md-11 {
    margin-top: 2.75rem !important;
  }
  .mt-md-12 {
    margin-top: 3rem !important;
  }
  .mt-md-13 {
    margin-top: 3.25rem !important;
  }
  .mt-md-14 {
    margin-top: 3.5rem !important;
  }
  .mt-md-15 {
    margin-top: 3.75rem !important;
  }
  .mt-md-16 {
    margin-top: 4rem !important;
  }
  .mt-md-17 {
    margin-top: 4.25rem !important;
  }
  .mt-md-18 {
    margin-top: 4.5rem !important;
  }
  .mt-md-19 {
    margin-top: 4.75rem !important;
  }
  .mt-md-20 {
    margin-top: 5rem !important;
  }
  .mt-md-auto {
    margin-top: auto !important;
  }
  .me-md-0 {
    margin-right: 0 !important;
  }
  .me-md-1 {
    margin-right: 0.25rem !important;
  }
  .me-md-2 {
    margin-right: 0.5rem !important;
  }
  .me-md-3 {
    margin-right: 0.75rem !important;
  }
  .me-md-4 {
    margin-right: 1rem !important;
  }
  .me-md-5 {
    margin-right: 1.25rem !important;
  }
  .me-md-6 {
    margin-right: 1.5rem !important;
  }
  .me-md-7 {
    margin-right: 1.75rem !important;
  }
  .me-md-8 {
    margin-right: 2rem !important;
  }
  .me-md-9 {
    margin-right: 2.25rem !important;
  }
  .me-md-10 {
    margin-right: 2.5rem !important;
  }
  .me-md-11 {
    margin-right: 2.75rem !important;
  }
  .me-md-12 {
    margin-right: 3rem !important;
  }
  .me-md-13 {
    margin-right: 3.25rem !important;
  }
  .me-md-14 {
    margin-right: 3.5rem !important;
  }
  .me-md-15 {
    margin-right: 3.75rem !important;
  }
  .me-md-16 {
    margin-right: 4rem !important;
  }
  .me-md-17 {
    margin-right: 4.25rem !important;
  }
  .me-md-18 {
    margin-right: 4.5rem !important;
  }
  .me-md-19 {
    margin-right: 4.75rem !important;
  }
  .me-md-20 {
    margin-right: 5rem !important;
  }
  .me-md-auto {
    margin-right: auto !important;
  }
  .mb-md-0 {
    margin-bottom: 0 !important;
  }
  .mb-md-1 {
    margin-bottom: 0.25rem !important;
  }
  .mb-md-2 {
    margin-bottom: 0.5rem !important;
  }
  .mb-md-3 {
    margin-bottom: 0.75rem !important;
  }
  .mb-md-4 {
    margin-bottom: 1rem !important;
  }
  .mb-md-5 {
    margin-bottom: 1.25rem !important;
  }
  .mb-md-6 {
    margin-bottom: 1.5rem !important;
  }
  .mb-md-7 {
    margin-bottom: 1.75rem !important;
  }
  .mb-md-8 {
    margin-bottom: 2rem !important;
  }
  .mb-md-9 {
    margin-bottom: 2.25rem !important;
  }
  .mb-md-10 {
    margin-bottom: 2.5rem !important;
  }
  .mb-md-11 {
    margin-bottom: 2.75rem !important;
  }
  .mb-md-12 {
    margin-bottom: 3rem !important;
  }
  .mb-md-13 {
    margin-bottom: 3.25rem !important;
  }
  .mb-md-14 {
    margin-bottom: 3.5rem !important;
  }
  .mb-md-15 {
    margin-bottom: 3.75rem !important;
  }
  .mb-md-16 {
    margin-bottom: 4rem !important;
  }
  .mb-md-17 {
    margin-bottom: 4.25rem !important;
  }
  .mb-md-18 {
    margin-bottom: 4.5rem !important;
  }
  .mb-md-19 {
    margin-bottom: 4.75rem !important;
  }
  .mb-md-20 {
    margin-bottom: 5rem !important;
  }
  .mb-md-auto {
    margin-bottom: auto !important;
  }
  .ms-md-0 {
    margin-left: 0 !important;
  }
  .ms-md-1 {
    margin-left: 0.25rem !important;
  }
  .ms-md-2 {
    margin-left: 0.5rem !important;
  }
  .ms-md-3 {
    margin-left: 0.75rem !important;
  }
  .ms-md-4 {
    margin-left: 1rem !important;
  }
  .ms-md-5 {
    margin-left: 1.25rem !important;
  }
  .ms-md-6 {
    margin-left: 1.5rem !important;
  }
  .ms-md-7 {
    margin-left: 1.75rem !important;
  }
  .ms-md-8 {
    margin-left: 2rem !important;
  }
  .ms-md-9 {
    margin-left: 2.25rem !important;
  }
  .ms-md-10 {
    margin-left: 2.5rem !important;
  }
  .ms-md-11 {
    margin-left: 2.75rem !important;
  }
  .ms-md-12 {
    margin-left: 3rem !important;
  }
  .ms-md-13 {
    margin-left: 3.25rem !important;
  }
  .ms-md-14 {
    margin-left: 3.5rem !important;
  }
  .ms-md-15 {
    margin-left: 3.75rem !important;
  }
  .ms-md-16 {
    margin-left: 4rem !important;
  }
  .ms-md-17 {
    margin-left: 4.25rem !important;
  }
  .ms-md-18 {
    margin-left: 4.5rem !important;
  }
  .ms-md-19 {
    margin-left: 4.75rem !important;
  }
  .ms-md-20 {
    margin-left: 5rem !important;
  }
  .ms-md-auto {
    margin-left: auto !important;
  }
  .m-md-n1 {
    margin: -0.25rem !important;
  }
  .m-md-n2 {
    margin: -0.5rem !important;
  }
  .m-md-n3 {
    margin: -0.75rem !important;
  }
  .m-md-n4 {
    margin: -1rem !important;
  }
  .m-md-n5 {
    margin: -1.25rem !important;
  }
  .m-md-n6 {
    margin: -1.5rem !important;
  }
  .m-md-n7 {
    margin: -1.75rem !important;
  }
  .m-md-n8 {
    margin: -2rem !important;
  }
  .m-md-n9 {
    margin: -2.25rem !important;
  }
  .m-md-n10 {
    margin: -2.5rem !important;
  }
  .m-md-n11 {
    margin: -2.75rem !important;
  }
  .m-md-n12 {
    margin: -3rem !important;
  }
  .m-md-n13 {
    margin: -3.25rem !important;
  }
  .m-md-n14 {
    margin: -3.5rem !important;
  }
  .m-md-n15 {
    margin: -3.75rem !important;
  }
  .m-md-n16 {
    margin: -4rem !important;
  }
  .m-md-n17 {
    margin: -4.25rem !important;
  }
  .m-md-n18 {
    margin: -4.5rem !important;
  }
  .m-md-n19 {
    margin: -4.75rem !important;
  }
  .m-md-n20 {
    margin: -5rem !important;
  }
  .mx-md-n1 {
    margin-right: -0.25rem !important;
    margin-left: -0.25rem !important;
  }
  .mx-md-n2 {
    margin-right: -0.5rem !important;
    margin-left: -0.5rem !important;
  }
  .mx-md-n3 {
    margin-right: -0.75rem !important;
    margin-left: -0.75rem !important;
  }
  .mx-md-n4 {
    margin-right: -1rem !important;
    margin-left: -1rem !important;
  }
  .mx-md-n5 {
    margin-right: -1.25rem !important;
    margin-left: -1.25rem !important;
  }
  .mx-md-n6 {
    margin-right: -1.5rem !important;
    margin-left: -1.5rem !important;
  }
  .mx-md-n7 {
    margin-right: -1.75rem !important;
    margin-left: -1.75rem !important;
  }
  .mx-md-n8 {
    margin-right: -2rem !important;
    margin-left: -2rem !important;
  }
  .mx-md-n9 {
    margin-right: -2.25rem !important;
    margin-left: -2.25rem !important;
  }
  .mx-md-n10 {
    margin-right: -2.5rem !important;
    margin-left: -2.5rem !important;
  }
  .mx-md-n11 {
    margin-right: -2.75rem !important;
    margin-left: -2.75rem !important;
  }
  .mx-md-n12 {
    margin-right: -3rem !important;
    margin-left: -3rem !important;
  }
  .mx-md-n13 {
    margin-right: -3.25rem !important;
    margin-left: -3.25rem !important;
  }
  .mx-md-n14 {
    margin-right: -3.5rem !important;
    margin-left: -3.5rem !important;
  }
  .mx-md-n15 {
    margin-right: -3.75rem !important;
    margin-left: -3.75rem !important;
  }
  .mx-md-n16 {
    margin-right: -4rem !important;
    margin-left: -4rem !important;
  }
  .mx-md-n17 {
    margin-right: -4.25rem !important;
    margin-left: -4.25rem !important;
  }
  .mx-md-n18 {
    margin-right: -4.5rem !important;
    margin-left: -4.5rem !important;
  }
  .mx-md-n19 {
    margin-right: -4.75rem !important;
    margin-left: -4.75rem !important;
  }
  .mx-md-n20 {
    margin-right: -5rem !important;
    margin-left: -5rem !important;
  }
  .my-md-n1 {
    margin-top: -0.25rem !important;
    margin-bottom: -0.25rem !important;
  }
  .my-md-n2 {
    margin-top: -0.5rem !important;
    margin-bottom: -0.5rem !important;
  }
  .my-md-n3 {
    margin-top: -0.75rem !important;
    margin-bottom: -0.75rem !important;
  }
  .my-md-n4 {
    margin-top: -1rem !important;
    margin-bottom: -1rem !important;
  }
  .my-md-n5 {
    margin-top: -1.25rem !important;
    margin-bottom: -1.25rem !important;
  }
  .my-md-n6 {
    margin-top: -1.5rem !important;
    margin-bottom: -1.5rem !important;
  }
  .my-md-n7 {
    margin-top: -1.75rem !important;
    margin-bottom: -1.75rem !important;
  }
  .my-md-n8 {
    margin-top: -2rem !important;
    margin-bottom: -2rem !important;
  }
  .my-md-n9 {
    margin-top: -2.25rem !important;
    margin-bottom: -2.25rem !important;
  }
  .my-md-n10 {
    margin-top: -2.5rem !important;
    margin-bottom: -2.5rem !important;
  }
  .my-md-n11 {
    margin-top: -2.75rem !important;
    margin-bottom: -2.75rem !important;
  }
  .my-md-n12 {
    margin-top: -3rem !important;
    margin-bottom: -3rem !important;
  }
  .my-md-n13 {
    margin-top: -3.25rem !important;
    margin-bottom: -3.25rem !important;
  }
  .my-md-n14 {
    margin-top: -3.5rem !important;
    margin-bottom: -3.5rem !important;
  }
  .my-md-n15 {
    margin-top: -3.75rem !important;
    margin-bottom: -3.75rem !important;
  }
  .my-md-n16 {
    margin-top: -4rem !important;
    margin-bottom: -4rem !important;
  }
  .my-md-n17 {
    margin-top: -4.25rem !important;
    margin-bottom: -4.25rem !important;
  }
  .my-md-n18 {
    margin-top: -4.5rem !important;
    margin-bottom: -4.5rem !important;
  }
  .my-md-n19 {
    margin-top: -4.75rem !important;
    margin-bottom: -4.75rem !important;
  }
  .my-md-n20 {
    margin-top: -5rem !important;
    margin-bottom: -5rem !important;
  }
  .mt-md-n1 {
    margin-top: -0.25rem !important;
  }
  .mt-md-n2 {
    margin-top: -0.5rem !important;
  }
  .mt-md-n3 {
    margin-top: -0.75rem !important;
  }
  .mt-md-n4 {
    margin-top: -1rem !important;
  }
  .mt-md-n5 {
    margin-top: -1.25rem !important;
  }
  .mt-md-n6 {
    margin-top: -1.5rem !important;
  }
  .mt-md-n7 {
    margin-top: -1.75rem !important;
  }
  .mt-md-n8 {
    margin-top: -2rem !important;
  }
  .mt-md-n9 {
    margin-top: -2.25rem !important;
  }
  .mt-md-n10 {
    margin-top: -2.5rem !important;
  }
  .mt-md-n11 {
    margin-top: -2.75rem !important;
  }
  .mt-md-n12 {
    margin-top: -3rem !important;
  }
  .mt-md-n13 {
    margin-top: -3.25rem !important;
  }
  .mt-md-n14 {
    margin-top: -3.5rem !important;
  }
  .mt-md-n15 {
    margin-top: -3.75rem !important;
  }
  .mt-md-n16 {
    margin-top: -4rem !important;
  }
  .mt-md-n17 {
    margin-top: -4.25rem !important;
  }
  .mt-md-n18 {
    margin-top: -4.5rem !important;
  }
  .mt-md-n19 {
    margin-top: -4.75rem !important;
  }
  .mt-md-n20 {
    margin-top: -5rem !important;
  }
  .me-md-n1 {
    margin-right: -0.25rem !important;
  }
  .me-md-n2 {
    margin-right: -0.5rem !important;
  }
  .me-md-n3 {
    margin-right: -0.75rem !important;
  }
  .me-md-n4 {
    margin-right: -1rem !important;
  }
  .me-md-n5 {
    margin-right: -1.25rem !important;
  }
  .me-md-n6 {
    margin-right: -1.5rem !important;
  }
  .me-md-n7 {
    margin-right: -1.75rem !important;
  }
  .me-md-n8 {
    margin-right: -2rem !important;
  }
  .me-md-n9 {
    margin-right: -2.25rem !important;
  }
  .me-md-n10 {
    margin-right: -2.5rem !important;
  }
  .me-md-n11 {
    margin-right: -2.75rem !important;
  }
  .me-md-n12 {
    margin-right: -3rem !important;
  }
  .me-md-n13 {
    margin-right: -3.25rem !important;
  }
  .me-md-n14 {
    margin-right: -3.5rem !important;
  }
  .me-md-n15 {
    margin-right: -3.75rem !important;
  }
  .me-md-n16 {
    margin-right: -4rem !important;
  }
  .me-md-n17 {
    margin-right: -4.25rem !important;
  }
  .me-md-n18 {
    margin-right: -4.5rem !important;
  }
  .me-md-n19 {
    margin-right: -4.75rem !important;
  }
  .me-md-n20 {
    margin-right: -5rem !important;
  }
  .mb-md-n1 {
    margin-bottom: -0.25rem !important;
  }
  .mb-md-n2 {
    margin-bottom: -0.5rem !important;
  }
  .mb-md-n3 {
    margin-bottom: -0.75rem !important;
  }
  .mb-md-n4 {
    margin-bottom: -1rem !important;
  }
  .mb-md-n5 {
    margin-bottom: -1.25rem !important;
  }
  .mb-md-n6 {
    margin-bottom: -1.5rem !important;
  }
  .mb-md-n7 {
    margin-bottom: -1.75rem !important;
  }
  .mb-md-n8 {
    margin-bottom: -2rem !important;
  }
  .mb-md-n9 {
    margin-bottom: -2.25rem !important;
  }
  .mb-md-n10 {
    margin-bottom: -2.5rem !important;
  }
  .mb-md-n11 {
    margin-bottom: -2.75rem !important;
  }
  .mb-md-n12 {
    margin-bottom: -3rem !important;
  }
  .mb-md-n13 {
    margin-bottom: -3.25rem !important;
  }
  .mb-md-n14 {
    margin-bottom: -3.5rem !important;
  }
  .mb-md-n15 {
    margin-bottom: -3.75rem !important;
  }
  .mb-md-n16 {
    margin-bottom: -4rem !important;
  }
  .mb-md-n17 {
    margin-bottom: -4.25rem !important;
  }
  .mb-md-n18 {
    margin-bottom: -4.5rem !important;
  }
  .mb-md-n19 {
    margin-bottom: -4.75rem !important;
  }
  .mb-md-n20 {
    margin-bottom: -5rem !important;
  }
  .ms-md-n1 {
    margin-left: -0.25rem !important;
  }
  .ms-md-n2 {
    margin-left: -0.5rem !important;
  }
  .ms-md-n3 {
    margin-left: -0.75rem !important;
  }
  .ms-md-n4 {
    margin-left: -1rem !important;
  }
  .ms-md-n5 {
    margin-left: -1.25rem !important;
  }
  .ms-md-n6 {
    margin-left: -1.5rem !important;
  }
  .ms-md-n7 {
    margin-left: -1.75rem !important;
  }
  .ms-md-n8 {
    margin-left: -2rem !important;
  }
  .ms-md-n9 {
    margin-left: -2.25rem !important;
  }
  .ms-md-n10 {
    margin-left: -2.5rem !important;
  }
  .ms-md-n11 {
    margin-left: -2.75rem !important;
  }
  .ms-md-n12 {
    margin-left: -3rem !important;
  }
  .ms-md-n13 {
    margin-left: -3.25rem !important;
  }
  .ms-md-n14 {
    margin-left: -3.5rem !important;
  }
  .ms-md-n15 {
    margin-left: -3.75rem !important;
  }
  .ms-md-n16 {
    margin-left: -4rem !important;
  }
  .ms-md-n17 {
    margin-left: -4.25rem !important;
  }
  .ms-md-n18 {
    margin-left: -4.5rem !important;
  }
  .ms-md-n19 {
    margin-left: -4.75rem !important;
  }
  .ms-md-n20 {
    margin-left: -5rem !important;
  }
  .p-md-0 {
    padding: 0 !important;
  }
  .p-md-1 {
    padding: 0.25rem !important;
  }
  .p-md-2 {
    padding: 0.5rem !important;
  }
  .p-md-3 {
    padding: 0.75rem !important;
  }
  .p-md-4 {
    padding: 1rem !important;
  }
  .p-md-5 {
    padding: 1.25rem !important;
  }
  .p-md-6 {
    padding: 1.5rem !important;
  }
  .p-md-7 {
    padding: 1.75rem !important;
  }
  .p-md-8 {
    padding: 2rem !important;
  }
  .p-md-9 {
    padding: 2.25rem !important;
  }
  .p-md-10 {
    padding: 2.5rem !important;
  }
  .p-md-11 {
    padding: 2.75rem !important;
  }
  .p-md-12 {
    padding: 3rem !important;
  }
  .p-md-13 {
    padding: 3.25rem !important;
  }
  .p-md-14 {
    padding: 3.5rem !important;
  }
  .p-md-15 {
    padding: 3.75rem !important;
  }
  .p-md-16 {
    padding: 4rem !important;
  }
  .p-md-17 {
    padding: 4.25rem !important;
  }
  .p-md-18 {
    padding: 4.5rem !important;
  }
  .p-md-19 {
    padding: 4.75rem !important;
  }
  .p-md-20 {
    padding: 5rem !important;
  }
  .px-md-0 {
    padding-right: 0 !important;
    padding-left: 0 !important;
  }
  .px-md-1 {
    padding-right: 0.25rem !important;
    padding-left: 0.25rem !important;
  }
  .px-md-2 {
    padding-right: 0.5rem !important;
    padding-left: 0.5rem !important;
  }
  .px-md-3 {
    padding-right: 0.75rem !important;
    padding-left: 0.75rem !important;
  }
  .px-md-4 {
    padding-right: 1rem !important;
    padding-left: 1rem !important;
  }
  .px-md-5 {
    padding-right: 1.25rem !important;
    padding-left: 1.25rem !important;
  }
  .px-md-6 {
    padding-right: 1.5rem !important;
    padding-left: 1.5rem !important;
  }
  .px-md-7 {
    padding-right: 1.75rem !important;
    padding-left: 1.75rem !important;
  }
  .px-md-8 {
    padding-right: 2rem !important;
    padding-left: 2rem !important;
  }
  .px-md-9 {
    padding-right: 2.25rem !important;
    padding-left: 2.25rem !important;
  }
  .px-md-10 {
    padding-right: 2.5rem !important;
    padding-left: 2.5rem !important;
  }
  .px-md-11 {
    padding-right: 2.75rem !important;
    padding-left: 2.75rem !important;
  }
  .px-md-12 {
    padding-right: 3rem !important;
    padding-left: 3rem !important;
  }
  .px-md-13 {
    padding-right: 3.25rem !important;
    padding-left: 3.25rem !important;
  }
  .px-md-14 {
    padding-right: 3.5rem !important;
    padding-left: 3.5rem !important;
  }
  .px-md-15 {
    padding-right: 3.75rem !important;
    padding-left: 3.75rem !important;
  }
  .px-md-16 {
    padding-right: 4rem !important;
    padding-left: 4rem !important;
  }
  .px-md-17 {
    padding-right: 4.25rem !important;
    padding-left: 4.25rem !important;
  }
  .px-md-18 {
    padding-right: 4.5rem !important;
    padding-left: 4.5rem !important;
  }
  .px-md-19 {
    padding-right: 4.75rem !important;
    padding-left: 4.75rem !important;
  }
  .px-md-20 {
    padding-right: 5rem !important;
    padding-left: 5rem !important;
  }
  .py-md-0 {
    padding-top: 0 !important;
    padding-bottom: 0 !important;
  }
  .py-md-1 {
    padding-top: 0.25rem !important;
    padding-bottom: 0.25rem !important;
  }
  .py-md-2 {
    padding-top: 0.5rem !important;
    padding-bottom: 0.5rem !important;
  }
  .py-md-3 {
    padding-top: 0.75rem !important;
    padding-bottom: 0.75rem !important;
  }
  .py-md-4 {
    padding-top: 1rem !important;
    padding-bottom: 1rem !important;
  }
  .py-md-5 {
    padding-top: 1.25rem !important;
    padding-bottom: 1.25rem !important;
  }
  .py-md-6 {
    padding-top: 1.5rem !important;
    padding-bottom: 1.5rem !important;
  }
  .py-md-7 {
    padding-top: 1.75rem !important;
    padding-bottom: 1.75rem !important;
  }
  .py-md-8 {
    padding-top: 2rem !important;
    padding-bottom: 2rem !important;
  }
  .py-md-9 {
    padding-top: 2.25rem !important;
    padding-bottom: 2.25rem !important;
  }
  .py-md-10 {
    padding-top: 2.5rem !important;
    padding-bottom: 2.5rem !important;
  }
  .py-md-11 {
    padding-top: 2.75rem !important;
    padding-bottom: 2.75rem !important;
  }
  .py-md-12 {
    padding-top: 3rem !important;
    padding-bottom: 3rem !important;
  }
  .py-md-13 {
    padding-top: 3.25rem !important;
    padding-bottom: 3.25rem !important;
  }
  .py-md-14 {
    padding-top: 3.5rem !important;
    padding-bottom: 3.5rem !important;
  }
  .py-md-15 {
    padding-top: 3.75rem !important;
    padding-bottom: 3.75rem !important;
  }
  .py-md-16 {
    padding-top: 4rem !important;
    padding-bottom: 4rem !important;
  }
  .py-md-17 {
    padding-top: 4.25rem !important;
    padding-bottom: 4.25rem !important;
  }
  .py-md-18 {
    padding-top: 4.5rem !important;
    padding-bottom: 4.5rem !important;
  }
  .py-md-19 {
    padding-top: 4.75rem !important;
    padding-bottom: 4.75rem !important;
  }
  .py-md-20 {
    padding-top: 5rem !important;
    padding-bottom: 5rem !important;
  }
  .pt-md-0 {
    padding-top: 0 !important;
  }
  .pt-md-1 {
    padding-top: 0.25rem !important;
  }
  .pt-md-2 {
    padding-top: 0.5rem !important;
  }
  .pt-md-3 {
    padding-top: 0.75rem !important;
  }
  .pt-md-4 {
    padding-top: 1rem !important;
  }
  .pt-md-5 {
    padding-top: 1.25rem !important;
  }
  .pt-md-6 {
    padding-top: 1.5rem !important;
  }
  .pt-md-7 {
    padding-top: 1.75rem !important;
  }
  .pt-md-8 {
    padding-top: 2rem !important;
  }
  .pt-md-9 {
    padding-top: 2.25rem !important;
  }
  .pt-md-10 {
    padding-top: 2.5rem !important;
  }
  .pt-md-11 {
    padding-top: 2.75rem !important;
  }
  .pt-md-12 {
    padding-top: 3rem !important;
  }
  .pt-md-13 {
    padding-top: 3.25rem !important;
  }
  .pt-md-14 {
    padding-top: 3.5rem !important;
  }
  .pt-md-15 {
    padding-top: 3.75rem !important;
  }
  .pt-md-16 {
    padding-top: 4rem !important;
  }
  .pt-md-17 {
    padding-top: 4.25rem !important;
  }
  .pt-md-18 {
    padding-top: 4.5rem !important;
  }
  .pt-md-19 {
    padding-top: 4.75rem !important;
  }
  .pt-md-20 {
    padding-top: 5rem !important;
  }
  .pe-md-0 {
    padding-right: 0 !important;
  }
  .pe-md-1 {
    padding-right: 0.25rem !important;
  }
  .pe-md-2 {
    padding-right: 0.5rem !important;
  }
  .pe-md-3 {
    padding-right: 0.75rem !important;
  }
  .pe-md-4 {
    padding-right: 1rem !important;
  }
  .pe-md-5 {
    padding-right: 1.25rem !important;
  }
  .pe-md-6 {
    padding-right: 1.5rem !important;
  }
  .pe-md-7 {
    padding-right: 1.75rem !important;
  }
  .pe-md-8 {
    padding-right: 2rem !important;
  }
  .pe-md-9 {
    padding-right: 2.25rem !important;
  }
  .pe-md-10 {
    padding-right: 2.5rem !important;
  }
  .pe-md-11 {
    padding-right: 2.75rem !important;
  }
  .pe-md-12 {
    padding-right: 3rem !important;
  }
  .pe-md-13 {
    padding-right: 3.25rem !important;
  }
  .pe-md-14 {
    padding-right: 3.5rem !important;
  }
  .pe-md-15 {
    padding-right: 3.75rem !important;
  }
  .pe-md-16 {
    padding-right: 4rem !important;
  }
  .pe-md-17 {
    padding-right: 4.25rem !important;
  }
  .pe-md-18 {
    padding-right: 4.5rem !important;
  }
  .pe-md-19 {
    padding-right: 4.75rem !important;
  }
  .pe-md-20 {
    padding-right: 5rem !important;
  }
  .pb-md-0 {
    padding-bottom: 0 !important;
  }
  .pb-md-1 {
    padding-bottom: 0.25rem !important;
  }
  .pb-md-2 {
    padding-bottom: 0.5rem !important;
  }
  .pb-md-3 {
    padding-bottom: 0.75rem !important;
  }
  .pb-md-4 {
    padding-bottom: 1rem !important;
  }
  .pb-md-5 {
    padding-bottom: 1.25rem !important;
  }
  .pb-md-6 {
    padding-bottom: 1.5rem !important;
  }
  .pb-md-7 {
    padding-bottom: 1.75rem !important;
  }
  .pb-md-8 {
    padding-bottom: 2rem !important;
  }
  .pb-md-9 {
    padding-bottom: 2.25rem !important;
  }
  .pb-md-10 {
    padding-bottom: 2.5rem !important;
  }
  .pb-md-11 {
    padding-bottom: 2.75rem !important;
  }
  .pb-md-12 {
    padding-bottom: 3rem !important;
  }
  .pb-md-13 {
    padding-bottom: 3.25rem !important;
  }
  .pb-md-14 {
    padding-bottom: 3.5rem !important;
  }
  .pb-md-15 {
    padding-bottom: 3.75rem !important;
  }
  .pb-md-16 {
    padding-bottom: 4rem !important;
  }
  .pb-md-17 {
    padding-bottom: 4.25rem !important;
  }
  .pb-md-18 {
    padding-bottom: 4.5rem !important;
  }
  .pb-md-19 {
    padding-bottom: 4.75rem !important;
  }
  .pb-md-20 {
    padding-bottom: 5rem !important;
  }
  .ps-md-0 {
    padding-left: 0 !important;
  }
  .ps-md-1 {
    padding-left: 0.25rem !important;
  }
  .ps-md-2 {
    padding-left: 0.5rem !important;
  }
  .ps-md-3 {
    padding-left: 0.75rem !important;
  }
  .ps-md-4 {
    padding-left: 1rem !important;
  }
  .ps-md-5 {
    padding-left: 1.25rem !important;
  }
  .ps-md-6 {
    padding-left: 1.5rem !important;
  }
  .ps-md-7 {
    padding-left: 1.75rem !important;
  }
  .ps-md-8 {
    padding-left: 2rem !important;
  }
  .ps-md-9 {
    padding-left: 2.25rem !important;
  }
  .ps-md-10 {
    padding-left: 2.5rem !important;
  }
  .ps-md-11 {
    padding-left: 2.75rem !important;
  }
  .ps-md-12 {
    padding-left: 3rem !important;
  }
  .ps-md-13 {
    padding-left: 3.25rem !important;
  }
  .ps-md-14 {
    padding-left: 3.5rem !important;
  }
  .ps-md-15 {
    padding-left: 3.75rem !important;
  }
  .ps-md-16 {
    padding-left: 4rem !important;
  }
  .ps-md-17 {
    padding-left: 4.25rem !important;
  }
  .ps-md-18 {
    padding-left: 4.5rem !important;
  }
  .ps-md-19 {
    padding-left: 4.75rem !important;
  }
  .ps-md-20 {
    padding-left: 5rem !important;
  }
  .gap-md-0 {
    gap: 0 !important;
  }
  .gap-md-1 {
    gap: 0.25rem !important;
  }
  .gap-md-2 {
    gap: 0.5rem !important;
  }
  .gap-md-3 {
    gap: 0.75rem !important;
  }
  .gap-md-4 {
    gap: 1rem !important;
  }
  .gap-md-5 {
    gap: 1.25rem !important;
  }
  .gap-md-6 {
    gap: 1.5rem !important;
  }
  .gap-md-7 {
    gap: 1.75rem !important;
  }
  .gap-md-8 {
    gap: 2rem !important;
  }
  .gap-md-9 {
    gap: 2.25rem !important;
  }
  .gap-md-10 {
    gap: 2.5rem !important;
  }
  .gap-md-11 {
    gap: 2.75rem !important;
  }
  .gap-md-12 {
    gap: 3rem !important;
  }
  .gap-md-13 {
    gap: 3.25rem !important;
  }
  .gap-md-14 {
    gap: 3.5rem !important;
  }
  .gap-md-15 {
    gap: 3.75rem !important;
  }
  .gap-md-16 {
    gap: 4rem !important;
  }
  .gap-md-17 {
    gap: 4.25rem !important;
  }
  .gap-md-18 {
    gap: 4.5rem !important;
  }
  .gap-md-19 {
    gap: 4.75rem !important;
  }
  .gap-md-20 {
    gap: 5rem !important;
  }
  .row-gap-md-0 {
    row-gap: 0 !important;
  }
  .row-gap-md-1 {
    row-gap: 0.25rem !important;
  }
  .row-gap-md-2 {
    row-gap: 0.5rem !important;
  }
  .row-gap-md-3 {
    row-gap: 0.75rem !important;
  }
  .row-gap-md-4 {
    row-gap: 1rem !important;
  }
  .row-gap-md-5 {
    row-gap: 1.25rem !important;
  }
  .row-gap-md-6 {
    row-gap: 1.5rem !important;
  }
  .row-gap-md-7 {
    row-gap: 1.75rem !important;
  }
  .row-gap-md-8 {
    row-gap: 2rem !important;
  }
  .row-gap-md-9 {
    row-gap: 2.25rem !important;
  }
  .row-gap-md-10 {
    row-gap: 2.5rem !important;
  }
  .row-gap-md-11 {
    row-gap: 2.75rem !important;
  }
  .row-gap-md-12 {
    row-gap: 3rem !important;
  }
  .row-gap-md-13 {
    row-gap: 3.25rem !important;
  }
  .row-gap-md-14 {
    row-gap: 3.5rem !important;
  }
  .row-gap-md-15 {
    row-gap: 3.75rem !important;
  }
  .row-gap-md-16 {
    row-gap: 4rem !important;
  }
  .row-gap-md-17 {
    row-gap: 4.25rem !important;
  }
  .row-gap-md-18 {
    row-gap: 4.5rem !important;
  }
  .row-gap-md-19 {
    row-gap: 4.75rem !important;
  }
  .row-gap-md-20 {
    row-gap: 5rem !important;
  }
  .column-gap-md-0 {
    column-gap: 0 !important;
  }
  .column-gap-md-1 {
    column-gap: 0.25rem !important;
  }
  .column-gap-md-2 {
    column-gap: 0.5rem !important;
  }
  .column-gap-md-3 {
    column-gap: 0.75rem !important;
  }
  .column-gap-md-4 {
    column-gap: 1rem !important;
  }
  .column-gap-md-5 {
    column-gap: 1.25rem !important;
  }
  .column-gap-md-6 {
    column-gap: 1.5rem !important;
  }
  .column-gap-md-7 {
    column-gap: 1.75rem !important;
  }
  .column-gap-md-8 {
    column-gap: 2rem !important;
  }
  .column-gap-md-9 {
    column-gap: 2.25rem !important;
  }
  .column-gap-md-10 {
    column-gap: 2.5rem !important;
  }
  .column-gap-md-11 {
    column-gap: 2.75rem !important;
  }
  .column-gap-md-12 {
    column-gap: 3rem !important;
  }
  .column-gap-md-13 {
    column-gap: 3.25rem !important;
  }
  .column-gap-md-14 {
    column-gap: 3.5rem !important;
  }
  .column-gap-md-15 {
    column-gap: 3.75rem !important;
  }
  .column-gap-md-16 {
    column-gap: 4rem !important;
  }
  .column-gap-md-17 {
    column-gap: 4.25rem !important;
  }
  .column-gap-md-18 {
    column-gap: 4.5rem !important;
  }
  .column-gap-md-19 {
    column-gap: 4.75rem !important;
  }
  .column-gap-md-20 {
    column-gap: 5rem !important;
  }
  .fs-md-1 {
    font-size: calc(1.3rem + 0.6vw) !important;
  }
  .fs-md-2 {
    font-size: calc(1.275rem + 0.3vw) !important;
  }
  .fs-md-3 {
    font-size: calc(1.26rem + 0.12vw) !important;
  }
  .fs-md-4 {
    font-size: 1.25rem !important;
  }
  .fs-md-5 {
    font-size: 1.15rem !important;
  }
  .fs-md-6 {
    font-size: 1.075rem !important;
  }
  .fs-md-7 {
    font-size: 0.95rem !important;
  }
  .fs-md-8 {
    font-size: 0.85rem !important;
  }
  .fs-md-9 {
    font-size: 0.75rem !important;
  }
  .fs-md-10 {
    font-size: 0.5rem !important;
  }
  .fs-md-base {
    font-size: 1rem !important;
  }
  .fs-md-fluid {
    font-size: 100% !important;
  }
  .fs-md-2x {
    font-size: calc(1.325rem + 0.9vw) !important;
  }
  .fs-md-2qx {
    font-size: calc(1.35rem + 1.2vw) !important;
  }
  .fs-md-2hx {
    font-size: calc(1.375rem + 1.5vw) !important;
  }
  .fs-md-2tx {
    font-size: calc(1.4rem + 1.8vw) !important;
  }
  .fs-md-3x {
    font-size: calc(1.425rem + 2.1vw) !important;
  }
  .fs-md-3qx {
    font-size: calc(1.45rem + 2.4vw) !important;
  }
  .fs-md-3hx {
    font-size: calc(1.475rem + 2.7vw) !important;
  }
  .fs-md-3tx {
    font-size: calc(1.5rem + 3vw) !important;
  }
  .fs-md-4x {
    font-size: calc(1.525rem + 3.3vw) !important;
  }
  .fs-md-4qx {
    font-size: calc(1.55rem + 3.6vw) !important;
  }
  .fs-md-4hx {
    font-size: calc(1.575rem + 3.9vw) !important;
  }
  .fs-md-4tx {
    font-size: calc(1.6rem + 4.2vw) !important;
  }
  .fs-md-5x {
    font-size: calc(1.625rem + 4.5vw) !important;
  }
  .fs-md-5qx {
    font-size: calc(1.65rem + 4.8vw) !important;
  }
  .fs-md-5hx {
    font-size: calc(1.675rem + 5.1vw) !important;
  }
  .fs-md-5tx {
    font-size: calc(1.7rem + 5.4vw) !important;
  }
  .fs-md-6x {
    font-size: calc(1.725rem + 5.7vw) !important;
  }
  .fs-md-6qx {
    font-size: calc(1.75rem + 6vw) !important;
  }
  .fs-md-6hx {
    font-size: calc(1.775rem + 6.3vw) !important;
  }
  .fs-md-6tx {
    font-size: calc(1.8rem + 6.6vw) !important;
  }
  .fs-md-7x {
    font-size: calc(1.825rem + 6.9vw) !important;
  }
  .fs-md-7qx {
    font-size: calc(1.85rem + 7.2vw) !important;
  }
  .fs-md-7hx {
    font-size: calc(1.875rem + 7.5vw) !important;
  }
  .fs-md-7tx {
    font-size: calc(1.9rem + 7.8vw) !important;
  }
  .text-md-start {
    text-align: left !important;
  }
  .text-md-end {
    text-align: right !important;
  }
  .text-md-center {
    text-align: center !important;
  }
  .min-w-md-unset {
    min-width: unset !important;
  }
  .min-w-md-25 {
    min-width: 25% !important;
  }
  .min-w-md-50 {
    min-width: 50% !important;
  }
  .min-w-md-75 {
    min-width: 75% !important;
  }
  .min-w-md-100 {
    min-width: 100% !important;
  }
  .min-w-md-auto {
    min-width: auto !important;
  }
  .min-w-md-1px {
    min-width: 1px !important;
  }
  .min-w-md-2px {
    min-width: 2px !important;
  }
  .min-w-md-3px {
    min-width: 3px !important;
  }
  .min-w-md-4px {
    min-width: 4px !important;
  }
  .min-w-md-5px {
    min-width: 5px !important;
  }
  .min-w-md-6px {
    min-width: 6px !important;
  }
  .min-w-md-7px {
    min-width: 7px !important;
  }
  .min-w-md-8px {
    min-width: 8px !important;
  }
  .min-w-md-9px {
    min-width: 9px !important;
  }
  .min-w-md-10px {
    min-width: 10px !important;
  }
  .min-w-md-15px {
    min-width: 15px !important;
  }
  .min-w-md-20px {
    min-width: 20px !important;
  }
  .min-w-md-25px {
    min-width: 25px !important;
  }
  .min-w-md-30px {
    min-width: 30px !important;
  }
  .min-w-md-35px {
    min-width: 35px !important;
  }
  .min-w-md-40px {
    min-width: 40px !important;
  }
  .min-w-md-45px {
    min-width: 45px !important;
  }
  .min-w-md-50px {
    min-width: 50px !important;
  }
  .min-w-md-55px {
    min-width: 55px !important;
  }
  .min-w-md-60px {
    min-width: 60px !important;
  }
  .min-w-md-65px {
    min-width: 65px !important;
  }
  .min-w-md-70px {
    min-width: 70px !important;
  }
  .min-w-md-75px {
    min-width: 75px !important;
  }
  .min-w-md-80px {
    min-width: 80px !important;
  }
  .min-w-md-85px {
    min-width: 85px !important;
  }
  .min-w-md-90px {
    min-width: 90px !important;
  }
  .min-w-md-95px {
    min-width: 95px !important;
  }
  .min-w-md-100px {
    min-width: 100px !important;
  }
  .min-w-md-125px {
    min-width: 125px !important;
  }
  .min-w-md-150px {
    min-width: 150px !important;
  }
  .min-w-md-175px {
    min-width: 175px !important;
  }
  .min-w-md-200px {
    min-width: 200px !important;
  }
  .min-w-md-225px {
    min-width: 225px !important;
  }
  .min-w-md-250px {
    min-width: 250px !important;
  }
  .min-w-md-275px {
    min-width: 275px !important;
  }
  .min-w-md-300px {
    min-width: 300px !important;
  }
  .min-w-md-325px {
    min-width: 325px !important;
  }
  .min-w-md-350px {
    min-width: 350px !important;
  }
  .min-w-md-375px {
    min-width: 375px !important;
  }
  .min-w-md-400px {
    min-width: 400px !important;
  }
  .min-w-md-425px {
    min-width: 425px !important;
  }
  .min-w-md-450px {
    min-width: 450px !important;
  }
  .min-w-md-475px {
    min-width: 475px !important;
  }
  .min-w-md-500px {
    min-width: 500px !important;
  }
  .min-w-md-550px {
    min-width: 550px !important;
  }
  .min-w-md-600px {
    min-width: 600px !important;
  }
  .min-w-md-650px {
    min-width: 650px !important;
  }
  .min-w-md-700px {
    min-width: 700px !important;
  }
  .min-w-md-750px {
    min-width: 750px !important;
  }
  .min-w-md-800px {
    min-width: 800px !important;
  }
  .min-w-md-850px {
    min-width: 850px !important;
  }
  .min-w-md-900px {
    min-width: 900px !important;
  }
  .min-w-md-950px {
    min-width: 950px !important;
  }
  .min-w-md-1000px {
    min-width: 1000px !important;
  }
  .min-h-md-unset {
    min-height: unset !important;
  }
  .min-h-md-25 {
    min-height: 25% !important;
  }
  .min-h-md-50 {
    min-height: 50% !important;
  }
  .min-h-md-75 {
    min-height: 75% !important;
  }
  .min-h-md-100 {
    min-height: 100% !important;
  }
  .min-h-md-auto {
    min-height: auto !important;
  }
  .min-h-md-1px {
    min-height: 1px !important;
  }
  .min-h-md-2px {
    min-height: 2px !important;
  }
  .min-h-md-3px {
    min-height: 3px !important;
  }
  .min-h-md-4px {
    min-height: 4px !important;
  }
  .min-h-md-5px {
    min-height: 5px !important;
  }
  .min-h-md-6px {
    min-height: 6px !important;
  }
  .min-h-md-7px {
    min-height: 7px !important;
  }
  .min-h-md-8px {
    min-height: 8px !important;
  }
  .min-h-md-9px {
    min-height: 9px !important;
  }
  .min-h-md-10px {
    min-height: 10px !important;
  }
  .min-h-md-15px {
    min-height: 15px !important;
  }
  .min-h-md-20px {
    min-height: 20px !important;
  }
  .min-h-md-25px {
    min-height: 25px !important;
  }
  .min-h-md-30px {
    min-height: 30px !important;
  }
  .min-h-md-35px {
    min-height: 35px !important;
  }
  .min-h-md-40px {
    min-height: 40px !important;
  }
  .min-h-md-45px {
    min-height: 45px !important;
  }
  .min-h-md-50px {
    min-height: 50px !important;
  }
  .min-h-md-55px {
    min-height: 55px !important;
  }
  .min-h-md-60px {
    min-height: 60px !important;
  }
  .min-h-md-65px {
    min-height: 65px !important;
  }
  .min-h-md-70px {
    min-height: 70px !important;
  }
  .min-h-md-75px {
    min-height: 75px !important;
  }
  .min-h-md-80px {
    min-height: 80px !important;
  }
  .min-h-md-85px {
    min-height: 85px !important;
  }
  .min-h-md-90px {
    min-height: 90px !important;
  }
  .min-h-md-95px {
    min-height: 95px !important;
  }
  .min-h-md-100px {
    min-height: 100px !important;
  }
  .min-h-md-125px {
    min-height: 125px !important;
  }
  .min-h-md-150px {
    min-height: 150px !important;
  }
  .min-h-md-175px {
    min-height: 175px !important;
  }
  .min-h-md-200px {
    min-height: 200px !important;
  }
  .min-h-md-225px {
    min-height: 225px !important;
  }
  .min-h-md-250px {
    min-height: 250px !important;
  }
  .min-h-md-275px {
    min-height: 275px !important;
  }
  .min-h-md-300px {
    min-height: 300px !important;
  }
  .min-h-md-325px {
    min-height: 325px !important;
  }
  .min-h-md-350px {
    min-height: 350px !important;
  }
  .min-h-md-375px {
    min-height: 375px !important;
  }
  .min-h-md-400px {
    min-height: 400px !important;
  }
  .min-h-md-425px {
    min-height: 425px !important;
  }
  .min-h-md-450px {
    min-height: 450px !important;
  }
  .min-h-md-475px {
    min-height: 475px !important;
  }
  .min-h-md-500px {
    min-height: 500px !important;
  }
  .min-h-md-550px {
    min-height: 550px !important;
  }
  .min-h-md-600px {
    min-height: 600px !important;
  }
  .min-h-md-650px {
    min-height: 650px !important;
  }
  .min-h-md-700px {
    min-height: 700px !important;
  }
  .min-h-md-750px {
    min-height: 750px !important;
  }
  .min-h-md-800px {
    min-height: 800px !important;
  }
  .min-h-md-850px {
    min-height: 850px !important;
  }
  .min-h-md-900px {
    min-height: 900px !important;
  }
  .min-h-md-950px {
    min-height: 950px !important;
  }
  .min-h-md-1000px {
    min-height: 1000px !important;
  }
}
@media (min-width: 992px) {
  .float-lg-start {
    float: left !important;
  }
  .float-lg-end {
    float: right !important;
  }
  .float-lg-none {
    float: none !important;
  }
  .object-fit-lg-contain {
    object-fit: contain !important;
  }
  .object-fit-lg-cover {
    object-fit: cover !important;
  }
  .object-fit-lg-fill {
    object-fit: fill !important;
  }
  .object-fit-lg-scale {
    object-fit: scale-down !important;
  }
  .object-fit-lg-none {
    object-fit: none !important;
  }
  .overflow-lg-auto {
    overflow: auto !important;
  }
  .overflow-lg-hidden {
    overflow: hidden !important;
  }
  .overflow-lg-visible {
    overflow: visible !important;
  }
  .overflow-lg-scroll {
    overflow: scroll !important;
  }
  .d-lg-inline {
    display: inline !important;
  }
  .d-lg-inline-block {
    display: inline-block !important;
  }
  .d-lg-block {
    display: block !important;
  }
  .d-lg-grid {
    display: grid !important;
  }
  .d-lg-table {
    display: table !important;
  }
  .d-lg-table-row {
    display: table-row !important;
  }
  .d-lg-table-cell {
    display: table-cell !important;
  }
  .d-lg-flex {
    display: flex !important;
  }
  .d-lg-inline-flex {
    display: inline-flex !important;
  }
  .d-lg-none {
    display: none !important;
  }
  .position-lg-static {
    position: static !important;
  }
  .position-lg-relative {
    position: relative !important;
  }
  .position-lg-absolute {
    position: absolute !important;
  }
  .position-lg-fixed {
    position: fixed !important;
  }
  .position-lg-sticky {
    position: sticky !important;
  }
  .w-lg-unset {
    width: unset !important;
  }
  .w-lg-25 {
    width: 25% !important;
  }
  .w-lg-50 {
    width: 50% !important;
  }
  .w-lg-75 {
    width: 75% !important;
  }
  .w-lg-100 {
    width: 100% !important;
  }
  .w-lg-auto {
    width: auto !important;
  }
  .w-lg-1px {
    width: 1px !important;
  }
  .w-lg-2px {
    width: 2px !important;
  }
  .w-lg-3px {
    width: 3px !important;
  }
  .w-lg-4px {
    width: 4px !important;
  }
  .w-lg-5px {
    width: 5px !important;
  }
  .w-lg-6px {
    width: 6px !important;
  }
  .w-lg-7px {
    width: 7px !important;
  }
  .w-lg-8px {
    width: 8px !important;
  }
  .w-lg-9px {
    width: 9px !important;
  }
  .w-lg-10px {
    width: 10px !important;
  }
  .w-lg-15px {
    width: 15px !important;
  }
  .w-lg-20px {
    width: 20px !important;
  }
  .w-lg-25px {
    width: 25px !important;
  }
  .w-lg-30px {
    width: 30px !important;
  }
  .w-lg-35px {
    width: 35px !important;
  }
  .w-lg-40px {
    width: 40px !important;
  }
  .w-lg-45px {
    width: 45px !important;
  }
  .w-lg-50px {
    width: 50px !important;
  }
  .w-lg-55px {
    width: 55px !important;
  }
  .w-lg-60px {
    width: 60px !important;
  }
  .w-lg-65px {
    width: 65px !important;
  }
  .w-lg-70px {
    width: 70px !important;
  }
  .w-lg-75px {
    width: 75px !important;
  }
  .w-lg-80px {
    width: 80px !important;
  }
  .w-lg-85px {
    width: 85px !important;
  }
  .w-lg-90px {
    width: 90px !important;
  }
  .w-lg-95px {
    width: 95px !important;
  }
  .w-lg-100px {
    width: 100px !important;
  }
  .w-lg-125px {
    width: 125px !important;
  }
  .w-lg-150px {
    width: 150px !important;
  }
  .w-lg-175px {
    width: 175px !important;
  }
  .w-lg-200px {
    width: 200px !important;
  }
  .w-lg-225px {
    width: 225px !important;
  }
  .w-lg-250px {
    width: 250px !important;
  }
  .w-lg-275px {
    width: 275px !important;
  }
  .w-lg-300px {
    width: 300px !important;
  }
  .w-lg-325px {
    width: 325px !important;
  }
  .w-lg-350px {
    width: 350px !important;
  }
  .w-lg-375px {
    width: 375px !important;
  }
  .w-lg-400px {
    width: 400px !important;
  }
  .w-lg-425px {
    width: 425px !important;
  }
  .w-lg-450px {
    width: 450px !important;
  }
  .w-lg-475px {
    width: 475px !important;
  }
  .w-lg-500px {
    width: 500px !important;
  }
  .w-lg-550px {
    width: 550px !important;
  }
  .w-lg-600px {
    width: 600px !important;
  }
  .w-lg-650px {
    width: 650px !important;
  }
  .w-lg-700px {
    width: 700px !important;
  }
  .w-lg-750px {
    width: 750px !important;
  }
  .w-lg-800px {
    width: 800px !important;
  }
  .w-lg-850px {
    width: 850px !important;
  }
  .w-lg-900px {
    width: 900px !important;
  }
  .w-lg-950px {
    width: 950px !important;
  }
  .w-lg-1000px {
    width: 1000px !important;
  }
  .mw-lg-unset {
    max-width: unset !important;
  }
  .mw-lg-25 {
    max-width: 25% !important;
  }
  .mw-lg-50 {
    max-width: 50% !important;
  }
  .mw-lg-75 {
    max-width: 75% !important;
  }
  .mw-lg-100 {
    max-width: 100% !important;
  }
  .mw-lg-auto {
    max-width: auto !important;
  }
  .mw-lg-1px {
    max-width: 1px !important;
  }
  .mw-lg-2px {
    max-width: 2px !important;
  }
  .mw-lg-3px {
    max-width: 3px !important;
  }
  .mw-lg-4px {
    max-width: 4px !important;
  }
  .mw-lg-5px {
    max-width: 5px !important;
  }
  .mw-lg-6px {
    max-width: 6px !important;
  }
  .mw-lg-7px {
    max-width: 7px !important;
  }
  .mw-lg-8px {
    max-width: 8px !important;
  }
  .mw-lg-9px {
    max-width: 9px !important;
  }
  .mw-lg-10px {
    max-width: 10px !important;
  }
  .mw-lg-15px {
    max-width: 15px !important;
  }
  .mw-lg-20px {
    max-width: 20px !important;
  }
  .mw-lg-25px {
    max-width: 25px !important;
  }
  .mw-lg-30px {
    max-width: 30px !important;
  }
  .mw-lg-35px {
    max-width: 35px !important;
  }
  .mw-lg-40px {
    max-width: 40px !important;
  }
  .mw-lg-45px {
    max-width: 45px !important;
  }
  .mw-lg-50px {
    max-width: 50px !important;
  }
  .mw-lg-55px {
    max-width: 55px !important;
  }
  .mw-lg-60px {
    max-width: 60px !important;
  }
  .mw-lg-65px {
    max-width: 65px !important;
  }
  .mw-lg-70px {
    max-width: 70px !important;
  }
  .mw-lg-75px {
    max-width: 75px !important;
  }
  .mw-lg-80px {
    max-width: 80px !important;
  }
  .mw-lg-85px {
    max-width: 85px !important;
  }
  .mw-lg-90px {
    max-width: 90px !important;
  }
  .mw-lg-95px {
    max-width: 95px !important;
  }
  .mw-lg-100px {
    max-width: 100px !important;
  }
  .mw-lg-125px {
    max-width: 125px !important;
  }
  .mw-lg-150px {
    max-width: 150px !important;
  }
  .mw-lg-175px {
    max-width: 175px !important;
  }
  .mw-lg-200px {
    max-width: 200px !important;
  }
  .mw-lg-225px {
    max-width: 225px !important;
  }
  .mw-lg-250px {
    max-width: 250px !important;
  }
  .mw-lg-275px {
    max-width: 275px !important;
  }
  .mw-lg-300px {
    max-width: 300px !important;
  }
  .mw-lg-325px {
    max-width: 325px !important;
  }
  .mw-lg-350px {
    max-width: 350px !important;
  }
  .mw-lg-375px {
    max-width: 375px !important;
  }
  .mw-lg-400px {
    max-width: 400px !important;
  }
  .mw-lg-425px {
    max-width: 425px !important;
  }
  .mw-lg-450px {
    max-width: 450px !important;
  }
  .mw-lg-475px {
    max-width: 475px !important;
  }
  .mw-lg-500px {
    max-width: 500px !important;
  }
  .mw-lg-550px {
    max-width: 550px !important;
  }
  .mw-lg-600px {
    max-width: 600px !important;
  }
  .mw-lg-650px {
    max-width: 650px !important;
  }
  .mw-lg-700px {
    max-width: 700px !important;
  }
  .mw-lg-750px {
    max-width: 750px !important;
  }
  .mw-lg-800px {
    max-width: 800px !important;
  }
  .mw-lg-850px {
    max-width: 850px !important;
  }
  .mw-lg-900px {
    max-width: 900px !important;
  }
  .mw-lg-950px {
    max-width: 950px !important;
  }
  .mw-lg-1000px {
    max-width: 1000px !important;
  }
  .h-lg-unset {
    height: unset !important;
  }
  .h-lg-25 {
    height: 25% !important;
  }
  .h-lg-50 {
    height: 50% !important;
  }
  .h-lg-75 {
    height: 75% !important;
  }
  .h-lg-100 {
    height: 100% !important;
  }
  .h-lg-auto {
    height: auto !important;
  }
  .h-lg-1px {
    height: 1px !important;
  }
  .h-lg-2px {
    height: 2px !important;
  }
  .h-lg-3px {
    height: 3px !important;
  }
  .h-lg-4px {
    height: 4px !important;
  }
  .h-lg-5px {
    height: 5px !important;
  }
  .h-lg-6px {
    height: 6px !important;
  }
  .h-lg-7px {
    height: 7px !important;
  }
  .h-lg-8px {
    height: 8px !important;
  }
  .h-lg-9px {
    height: 9px !important;
  }
  .h-lg-10px {
    height: 10px !important;
  }
  .h-lg-15px {
    height: 15px !important;
  }
  .h-lg-20px {
    height: 20px !important;
  }
  .h-lg-25px {
    height: 25px !important;
  }
  .h-lg-30px {
    height: 30px !important;
  }
  .h-lg-35px {
    height: 35px !important;
  }
  .h-lg-40px {
    height: 40px !important;
  }
  .h-lg-45px {
    height: 45px !important;
  }
  .h-lg-50px {
    height: 50px !important;
  }
  .h-lg-55px {
    height: 55px !important;
  }
  .h-lg-60px {
    height: 60px !important;
  }
  .h-lg-65px {
    height: 65px !important;
  }
  .h-lg-70px {
    height: 70px !important;
  }
  .h-lg-75px {
    height: 75px !important;
  }
  .h-lg-80px {
    height: 80px !important;
  }
  .h-lg-85px {
    height: 85px !important;
  }
  .h-lg-90px {
    height: 90px !important;
  }
  .h-lg-95px {
    height: 95px !important;
  }
  .h-lg-100px {
    height: 100px !important;
  }
  .h-lg-125px {
    height: 125px !important;
  }
  .h-lg-150px {
    height: 150px !important;
  }
  .h-lg-175px {
    height: 175px !important;
  }
  .h-lg-200px {
    height: 200px !important;
  }
  .h-lg-225px {
    height: 225px !important;
  }
  .h-lg-250px {
    height: 250px !important;
  }
  .h-lg-275px {
    height: 275px !important;
  }
  .h-lg-300px {
    height: 300px !important;
  }
  .h-lg-325px {
    height: 325px !important;
  }
  .h-lg-350px {
    height: 350px !important;
  }
  .h-lg-375px {
    height: 375px !important;
  }
  .h-lg-400px {
    height: 400px !important;
  }
  .h-lg-425px {
    height: 425px !important;
  }
  .h-lg-450px {
    height: 450px !important;
  }
  .h-lg-475px {
    height: 475px !important;
  }
  .h-lg-500px {
    height: 500px !important;
  }
  .h-lg-550px {
    height: 550px !important;
  }
  .h-lg-600px {
    height: 600px !important;
  }
  .h-lg-650px {
    height: 650px !important;
  }
  .h-lg-700px {
    height: 700px !important;
  }
  .h-lg-750px {
    height: 750px !important;
  }
  .h-lg-800px {
    height: 800px !important;
  }
  .h-lg-850px {
    height: 850px !important;
  }
  .h-lg-900px {
    height: 900px !important;
  }
  .h-lg-950px {
    height: 950px !important;
  }
  .h-lg-1000px {
    height: 1000px !important;
  }
  .mh-lg-unset {
    max-height: unset !important;
  }
  .mh-lg-25 {
    max-height: 25% !important;
  }
  .mh-lg-50 {
    max-height: 50% !important;
  }
  .mh-lg-75 {
    max-height: 75% !important;
  }
  .mh-lg-100 {
    max-height: 100% !important;
  }
  .mh-lg-auto {
    max-height: auto !important;
  }
  .mh-lg-1px {
    max-height: 1px !important;
  }
  .mh-lg-2px {
    max-height: 2px !important;
  }
  .mh-lg-3px {
    max-height: 3px !important;
  }
  .mh-lg-4px {
    max-height: 4px !important;
  }
  .mh-lg-5px {
    max-height: 5px !important;
  }
  .mh-lg-6px {
    max-height: 6px !important;
  }
  .mh-lg-7px {
    max-height: 7px !important;
  }
  .mh-lg-8px {
    max-height: 8px !important;
  }
  .mh-lg-9px {
    max-height: 9px !important;
  }
  .mh-lg-10px {
    max-height: 10px !important;
  }
  .mh-lg-15px {
    max-height: 15px !important;
  }
  .mh-lg-20px {
    max-height: 20px !important;
  }
  .mh-lg-25px {
    max-height: 25px !important;
  }
  .mh-lg-30px {
    max-height: 30px !important;
  }
  .mh-lg-35px {
    max-height: 35px !important;
  }
  .mh-lg-40px {
    max-height: 40px !important;
  }
  .mh-lg-45px {
    max-height: 45px !important;
  }
  .mh-lg-50px {
    max-height: 50px !important;
  }
  .mh-lg-55px {
    max-height: 55px !important;
  }
  .mh-lg-60px {
    max-height: 60px !important;
  }
  .mh-lg-65px {
    max-height: 65px !important;
  }
  .mh-lg-70px {
    max-height: 70px !important;
  }
  .mh-lg-75px {
    max-height: 75px !important;
  }
  .mh-lg-80px {
    max-height: 80px !important;
  }
  .mh-lg-85px {
    max-height: 85px !important;
  }
  .mh-lg-90px {
    max-height: 90px !important;
  }
  .mh-lg-95px {
    max-height: 95px !important;
  }
  .mh-lg-100px {
    max-height: 100px !important;
  }
  .mh-lg-125px {
    max-height: 125px !important;
  }
  .mh-lg-150px {
    max-height: 150px !important;
  }
  .mh-lg-175px {
    max-height: 175px !important;
  }
  .mh-lg-200px {
    max-height: 200px !important;
  }
  .mh-lg-225px {
    max-height: 225px !important;
  }
  .mh-lg-250px {
    max-height: 250px !important;
  }
  .mh-lg-275px {
    max-height: 275px !important;
  }
  .mh-lg-300px {
    max-height: 300px !important;
  }
  .mh-lg-325px {
    max-height: 325px !important;
  }
  .mh-lg-350px {
    max-height: 350px !important;
  }
  .mh-lg-375px {
    max-height: 375px !important;
  }
  .mh-lg-400px {
    max-height: 400px !important;
  }
  .mh-lg-425px {
    max-height: 425px !important;
  }
  .mh-lg-450px {
    max-height: 450px !important;
  }
  .mh-lg-475px {
    max-height: 475px !important;
  }
  .mh-lg-500px {
    max-height: 500px !important;
  }
  .mh-lg-550px {
    max-height: 550px !important;
  }
  .mh-lg-600px {
    max-height: 600px !important;
  }
  .mh-lg-650px {
    max-height: 650px !important;
  }
  .mh-lg-700px {
    max-height: 700px !important;
  }
  .mh-lg-750px {
    max-height: 750px !important;
  }
  .mh-lg-800px {
    max-height: 800px !important;
  }
  .mh-lg-850px {
    max-height: 850px !important;
  }
  .mh-lg-900px {
    max-height: 900px !important;
  }
  .mh-lg-950px {
    max-height: 950px !important;
  }
  .mh-lg-1000px {
    max-height: 1000px !important;
  }
  .flex-lg-fill {
    flex: 1 1 auto !important;
  }
  .flex-lg-row {
    flex-direction: row !important;
  }
  .flex-lg-column {
    flex-direction: column !important;
  }
  .flex-lg-row-reverse {
    flex-direction: row-reverse !important;
  }
  .flex-lg-column-reverse {
    flex-direction: column-reverse !important;
  }
  .flex-lg-grow-0 {
    flex-grow: 0 !important;
  }
  .flex-lg-grow-1 {
    flex-grow: 1 !important;
  }
  .flex-lg-shrink-0 {
    flex-shrink: 0 !important;
  }
  .flex-lg-shrink-1 {
    flex-shrink: 1 !important;
  }
  .flex-lg-wrap {
    flex-wrap: wrap !important;
  }
  .flex-lg-nowrap {
    flex-wrap: nowrap !important;
  }
  .flex-lg-wrap-reverse {
    flex-wrap: wrap-reverse !important;
  }
  .justify-content-lg-start {
    justify-content: flex-start !important;
  }
  .justify-content-lg-end {
    justify-content: flex-end !important;
  }
  .justify-content-lg-center {
    justify-content: center !important;
  }
  .justify-content-lg-between {
    justify-content: space-between !important;
  }
  .justify-content-lg-around {
    justify-content: space-around !important;
  }
  .justify-content-lg-evenly {
    justify-content: space-evenly !important;
  }
  .align-items-lg-start {
    align-items: flex-start !important;
  }
  .align-items-lg-end {
    align-items: flex-end !important;
  }
  .align-items-lg-center {
    align-items: center !important;
  }
  .align-items-lg-baseline {
    align-items: baseline !important;
  }
  .align-items-lg-stretch {
    align-items: stretch !important;
  }
  .align-content-lg-start {
    align-content: flex-start !important;
  }
  .align-content-lg-end {
    align-content: flex-end !important;
  }
  .align-content-lg-center {
    align-content: center !important;
  }
  .align-content-lg-between {
    align-content: space-between !important;
  }
  .align-content-lg-around {
    align-content: space-around !important;
  }
  .align-content-lg-stretch {
    align-content: stretch !important;
  }
  .align-self-lg-auto {
    align-self: auto !important;
  }
  .align-self-lg-start {
    align-self: flex-start !important;
  }
  .align-self-lg-end {
    align-self: flex-end !important;
  }
  .align-self-lg-center {
    align-self: center !important;
  }
  .align-self-lg-baseline {
    align-self: baseline !important;
  }
  .align-self-lg-stretch {
    align-self: stretch !important;
  }
  .order-lg-first {
    order: -1 !important;
  }
  .order-lg-0 {
    order: 0 !important;
  }
  .order-lg-1 {
    order: 1 !important;
  }
  .order-lg-2 {
    order: 2 !important;
  }
  .order-lg-3 {
    order: 3 !important;
  }
  .order-lg-4 {
    order: 4 !important;
  }
  .order-lg-5 {
    order: 5 !important;
  }
  .order-lg-last {
    order: 6 !important;
  }
  .m-lg-0 {
    margin: 0 !important;
  }
  .m-lg-1 {
    margin: 0.25rem !important;
  }
  .m-lg-2 {
    margin: 0.5rem !important;
  }
  .m-lg-3 {
    margin: 0.75rem !important;
  }
  .m-lg-4 {
    margin: 1rem !important;
  }
  .m-lg-5 {
    margin: 1.25rem !important;
  }
  .m-lg-6 {
    margin: 1.5rem !important;
  }
  .m-lg-7 {
    margin: 1.75rem !important;
  }
  .m-lg-8 {
    margin: 2rem !important;
  }
  .m-lg-9 {
    margin: 2.25rem !important;
  }
  .m-lg-10 {
    margin: 2.5rem !important;
  }
  .m-lg-11 {
    margin: 2.75rem !important;
  }
  .m-lg-12 {
    margin: 3rem !important;
  }
  .m-lg-13 {
    margin: 3.25rem !important;
  }
  .m-lg-14 {
    margin: 3.5rem !important;
  }
  .m-lg-15 {
    margin: 3.75rem !important;
  }
  .m-lg-16 {
    margin: 4rem !important;
  }
  .m-lg-17 {
    margin: 4.25rem !important;
  }
  .m-lg-18 {
    margin: 4.5rem !important;
  }
  .m-lg-19 {
    margin: 4.75rem !important;
  }
  .m-lg-20 {
    margin: 5rem !important;
  }
  .m-lg-auto {
    margin: auto !important;
  }
  .mx-lg-0 {
    margin-right: 0 !important;
    margin-left: 0 !important;
  }
  .mx-lg-1 {
    margin-right: 0.25rem !important;
    margin-left: 0.25rem !important;
  }
  .mx-lg-2 {
    margin-right: 0.5rem !important;
    margin-left: 0.5rem !important;
  }
  .mx-lg-3 {
    margin-right: 0.75rem !important;
    margin-left: 0.75rem !important;
  }
  .mx-lg-4 {
    margin-right: 1rem !important;
    margin-left: 1rem !important;
  }
  .mx-lg-5 {
    margin-right: 1.25rem !important;
    margin-left: 1.25rem !important;
  }
  .mx-lg-6 {
    margin-right: 1.5rem !important;
    margin-left: 1.5rem !important;
  }
  .mx-lg-7 {
    margin-right: 1.75rem !important;
    margin-left: 1.75rem !important;
  }
  .mx-lg-8 {
    margin-right: 2rem !important;
    margin-left: 2rem !important;
  }
  .mx-lg-9 {
    margin-right: 2.25rem !important;
    margin-left: 2.25rem !important;
  }
  .mx-lg-10 {
    margin-right: 2.5rem !important;
    margin-left: 2.5rem !important;
  }
  .mx-lg-11 {
    margin-right: 2.75rem !important;
    margin-left: 2.75rem !important;
  }
  .mx-lg-12 {
    margin-right: 3rem !important;
    margin-left: 3rem !important;
  }
  .mx-lg-13 {
    margin-right: 3.25rem !important;
    margin-left: 3.25rem !important;
  }
  .mx-lg-14 {
    margin-right: 3.5rem !important;
    margin-left: 3.5rem !important;
  }
  .mx-lg-15 {
    margin-right: 3.75rem !important;
    margin-left: 3.75rem !important;
  }
  .mx-lg-16 {
    margin-right: 4rem !important;
    margin-left: 4rem !important;
  }
  .mx-lg-17 {
    margin-right: 4.25rem !important;
    margin-left: 4.25rem !important;
  }
  .mx-lg-18 {
    margin-right: 4.5rem !important;
    margin-left: 4.5rem !important;
  }
  .mx-lg-19 {
    margin-right: 4.75rem !important;
    margin-left: 4.75rem !important;
  }
  .mx-lg-20 {
    margin-right: 5rem !important;
    margin-left: 5rem !important;
  }
  .mx-lg-auto {
    margin-right: auto !important;
    margin-left: auto !important;
  }
  .my-lg-0 {
    margin-top: 0 !important;
    margin-bottom: 0 !important;
  }
  .my-lg-1 {
    margin-top: 0.25rem !important;
    margin-bottom: 0.25rem !important;
  }
  .my-lg-2 {
    margin-top: 0.5rem !important;
    margin-bottom: 0.5rem !important;
  }
  .my-lg-3 {
    margin-top: 0.75rem !important;
    margin-bottom: 0.75rem !important;
  }
  .my-lg-4 {
    margin-top: 1rem !important;
    margin-bottom: 1rem !important;
  }
  .my-lg-5 {
    margin-top: 1.25rem !important;
    margin-bottom: 1.25rem !important;
  }
  .my-lg-6 {
    margin-top: 1.5rem !important;
    margin-bottom: 1.5rem !important;
  }
  .my-lg-7 {
    margin-top: 1.75rem !important;
    margin-bottom: 1.75rem !important;
  }
  .my-lg-8 {
    margin-top: 2rem !important;
    margin-bottom: 2rem !important;
  }
  .my-lg-9 {
    margin-top: 2.25rem !important;
    margin-bottom: 2.25rem !important;
  }
  .my-lg-10 {
    margin-top: 2.5rem !important;
    margin-bottom: 2.5rem !important;
  }
  .my-lg-11 {
    margin-top: 2.75rem !important;
    margin-bottom: 2.75rem !important;
  }
  .my-lg-12 {
    margin-top: 3rem !important;
    margin-bottom: 3rem !important;
  }
  .my-lg-13 {
    margin-top: 3.25rem !important;
    margin-bottom: 3.25rem !important;
  }
  .my-lg-14 {
    margin-top: 3.5rem !important;
    margin-bottom: 3.5rem !important;
  }
  .my-lg-15 {
    margin-top: 3.75rem !important;
    margin-bottom: 3.75rem !important;
  }
  .my-lg-16 {
    margin-top: 4rem !important;
    margin-bottom: 4rem !important;
  }
  .my-lg-17 {
    margin-top: 4.25rem !important;
    margin-bottom: 4.25rem !important;
  }
  .my-lg-18 {
    margin-top: 4.5rem !important;
    margin-bottom: 4.5rem !important;
  }
  .my-lg-19 {
    margin-top: 4.75rem !important;
    margin-bottom: 4.75rem !important;
  }
  .my-lg-20 {
    margin-top: 5rem !important;
    margin-bottom: 5rem !important;
  }
  .my-lg-auto {
    margin-top: auto !important;
    margin-bottom: auto !important;
  }
  .mt-lg-0 {
    margin-top: 0 !important;
  }
  .mt-lg-1 {
    margin-top: 0.25rem !important;
  }
  .mt-lg-2 {
    margin-top: 0.5rem !important;
  }
  .mt-lg-3 {
    margin-top: 0.75rem !important;
  }
  .mt-lg-4 {
    margin-top: 1rem !important;
  }
  .mt-lg-5 {
    margin-top: 1.25rem !important;
  }
  .mt-lg-6 {
    margin-top: 1.5rem !important;
  }
  .mt-lg-7 {
    margin-top: 1.75rem !important;
  }
  .mt-lg-8 {
    margin-top: 2rem !important;
  }
  .mt-lg-9 {
    margin-top: 2.25rem !important;
  }
  .mt-lg-10 {
    margin-top: 2.5rem !important;
  }
  .mt-lg-11 {
    margin-top: 2.75rem !important;
  }
  .mt-lg-12 {
    margin-top: 3rem !important;
  }
  .mt-lg-13 {
    margin-top: 3.25rem !important;
  }
  .mt-lg-14 {
    margin-top: 3.5rem !important;
  }
  .mt-lg-15 {
    margin-top: 3.75rem !important;
  }
  .mt-lg-16 {
    margin-top: 4rem !important;
  }
  .mt-lg-17 {
    margin-top: 4.25rem !important;
  }
  .mt-lg-18 {
    margin-top: 4.5rem !important;
  }
  .mt-lg-19 {
    margin-top: 4.75rem !important;
  }
  .mt-lg-20 {
    margin-top: 5rem !important;
  }
  .mt-lg-auto {
    margin-top: auto !important;
  }
  .me-lg-0 {
    margin-right: 0 !important;
  }
  .me-lg-1 {
    margin-right: 0.25rem !important;
  }
  .me-lg-2 {
    margin-right: 0.5rem !important;
  }
  .me-lg-3 {
    margin-right: 0.75rem !important;
  }
  .me-lg-4 {
    margin-right: 1rem !important;
  }
  .me-lg-5 {
    margin-right: 1.25rem !important;
  }
  .me-lg-6 {
    margin-right: 1.5rem !important;
  }
  .me-lg-7 {
    margin-right: 1.75rem !important;
  }
  .me-lg-8 {
    margin-right: 2rem !important;
  }
  .me-lg-9 {
    margin-right: 2.25rem !important;
  }
  .me-lg-10 {
    margin-right: 2.5rem !important;
  }
  .me-lg-11 {
    margin-right: 2.75rem !important;
  }
  .me-lg-12 {
    margin-right: 3rem !important;
  }
  .me-lg-13 {
    margin-right: 3.25rem !important;
  }
  .me-lg-14 {
    margin-right: 3.5rem !important;
  }
  .me-lg-15 {
    margin-right: 3.75rem !important;
  }
  .me-lg-16 {
    margin-right: 4rem !important;
  }
  .me-lg-17 {
    margin-right: 4.25rem !important;
  }
  .me-lg-18 {
    margin-right: 4.5rem !important;
  }
  .me-lg-19 {
    margin-right: 4.75rem !important;
  }
  .me-lg-20 {
    margin-right: 5rem !important;
  }
  .me-lg-auto {
    margin-right: auto !important;
  }
  .mb-lg-0 {
    margin-bottom: 0 !important;
  }
  .mb-lg-1 {
    margin-bottom: 0.25rem !important;
  }
  .mb-lg-2 {
    margin-bottom: 0.5rem !important;
  }
  .mb-lg-3 {
    margin-bottom: 0.75rem !important;
  }
  .mb-lg-4 {
    margin-bottom: 1rem !important;
  }
  .mb-lg-5 {
    margin-bottom: 1.25rem !important;
  }
  .mb-lg-6 {
    margin-bottom: 1.5rem !important;
  }
  .mb-lg-7 {
    margin-bottom: 1.75rem !important;
  }
  .mb-lg-8 {
    margin-bottom: 2rem !important;
  }
  .mb-lg-9 {
    margin-bottom: 2.25rem !important;
  }
  .mb-lg-10 {
    margin-bottom: 2.5rem !important;
  }
  .mb-lg-11 {
    margin-bottom: 2.75rem !important;
  }
  .mb-lg-12 {
    margin-bottom: 3rem !important;
  }
  .mb-lg-13 {
    margin-bottom: 3.25rem !important;
  }
  .mb-lg-14 {
    margin-bottom: 3.5rem !important;
  }
  .mb-lg-15 {
    margin-bottom: 3.75rem !important;
  }
  .mb-lg-16 {
    margin-bottom: 4rem !important;
  }
  .mb-lg-17 {
    margin-bottom: 4.25rem !important;
  }
  .mb-lg-18 {
    margin-bottom: 4.5rem !important;
  }
  .mb-lg-19 {
    margin-bottom: 4.75rem !important;
  }
  .mb-lg-20 {
    margin-bottom: 5rem !important;
  }
  .mb-lg-auto {
    margin-bottom: auto !important;
  }
  .ms-lg-0 {
    margin-left: 0 !important;
  }
  .ms-lg-1 {
    margin-left: 0.25rem !important;
  }
  .ms-lg-2 {
    margin-left: 0.5rem !important;
  }
  .ms-lg-3 {
    margin-left: 0.75rem !important;
  }
  .ms-lg-4 {
    margin-left: 1rem !important;
  }
  .ms-lg-5 {
    margin-left: 1.25rem !important;
  }
  .ms-lg-6 {
    margin-left: 1.5rem !important;
  }
  .ms-lg-7 {
    margin-left: 1.75rem !important;
  }
  .ms-lg-8 {
    margin-left: 2rem !important;
  }
  .ms-lg-9 {
    margin-left: 2.25rem !important;
  }
  .ms-lg-10 {
    margin-left: 2.5rem !important;
  }
  .ms-lg-11 {
    margin-left: 2.75rem !important;
  }
  .ms-lg-12 {
    margin-left: 3rem !important;
  }
  .ms-lg-13 {
    margin-left: 3.25rem !important;
  }
  .ms-lg-14 {
    margin-left: 3.5rem !important;
  }
  .ms-lg-15 {
    margin-left: 3.75rem !important;
  }
  .ms-lg-16 {
    margin-left: 4rem !important;
  }
  .ms-lg-17 {
    margin-left: 4.25rem !important;
  }
  .ms-lg-18 {
    margin-left: 4.5rem !important;
  }
  .ms-lg-19 {
    margin-left: 4.75rem !important;
  }
  .ms-lg-20 {
    margin-left: 5rem !important;
  }
  .ms-lg-auto {
    margin-left: auto !important;
  }
  .m-lg-n1 {
    margin: -0.25rem !important;
  }
  .m-lg-n2 {
    margin: -0.5rem !important;
  }
  .m-lg-n3 {
    margin: -0.75rem !important;
  }
  .m-lg-n4 {
    margin: -1rem !important;
  }
  .m-lg-n5 {
    margin: -1.25rem !important;
  }
  .m-lg-n6 {
    margin: -1.5rem !important;
  }
  .m-lg-n7 {
    margin: -1.75rem !important;
  }
  .m-lg-n8 {
    margin: -2rem !important;
  }
  .m-lg-n9 {
    margin: -2.25rem !important;
  }
  .m-lg-n10 {
    margin: -2.5rem !important;
  }
  .m-lg-n11 {
    margin: -2.75rem !important;
  }
  .m-lg-n12 {
    margin: -3rem !important;
  }
  .m-lg-n13 {
    margin: -3.25rem !important;
  }
  .m-lg-n14 {
    margin: -3.5rem !important;
  }
  .m-lg-n15 {
    margin: -3.75rem !important;
  }
  .m-lg-n16 {
    margin: -4rem !important;
  }
  .m-lg-n17 {
    margin: -4.25rem !important;
  }
  .m-lg-n18 {
    margin: -4.5rem !important;
  }
  .m-lg-n19 {
    margin: -4.75rem !important;
  }
  .m-lg-n20 {
    margin: -5rem !important;
  }
  .mx-lg-n1 {
    margin-right: -0.25rem !important;
    margin-left: -0.25rem !important;
  }
  .mx-lg-n2 {
    margin-right: -0.5rem !important;
    margin-left: -0.5rem !important;
  }
  .mx-lg-n3 {
    margin-right: -0.75rem !important;
    margin-left: -0.75rem !important;
  }
  .mx-lg-n4 {
    margin-right: -1rem !important;
    margin-left: -1rem !important;
  }
  .mx-lg-n5 {
    margin-right: -1.25rem !important;
    margin-left: -1.25rem !important;
  }
  .mx-lg-n6 {
    margin-right: -1.5rem !important;
    margin-left: -1.5rem !important;
  }
  .mx-lg-n7 {
    margin-right: -1.75rem !important;
    margin-left: -1.75rem !important;
  }
  .mx-lg-n8 {
    margin-right: -2rem !important;
    margin-left: -2rem !important;
  }
  .mx-lg-n9 {
    margin-right: -2.25rem !important;
    margin-left: -2.25rem !important;
  }
  .mx-lg-n10 {
    margin-right: -2.5rem !important;
    margin-left: -2.5rem !important;
  }
  .mx-lg-n11 {
    margin-right: -2.75rem !important;
    margin-left: -2.75rem !important;
  }
  .mx-lg-n12 {
    margin-right: -3rem !important;
    margin-left: -3rem !important;
  }
  .mx-lg-n13 {
    margin-right: -3.25rem !important;
    margin-left: -3.25rem !important;
  }
  .mx-lg-n14 {
    margin-right: -3.5rem !important;
    margin-left: -3.5rem !important;
  }
  .mx-lg-n15 {
    margin-right: -3.75rem !important;
    margin-left: -3.75rem !important;
  }
  .mx-lg-n16 {
    margin-right: -4rem !important;
    margin-left: -4rem !important;
  }
  .mx-lg-n17 {
    margin-right: -4.25rem !important;
    margin-left: -4.25rem !important;
  }
  .mx-lg-n18 {
    margin-right: -4.5rem !important;
    margin-left: -4.5rem !important;
  }
  .mx-lg-n19 {
    margin-right: -4.75rem !important;
    margin-left: -4.75rem !important;
  }
  .mx-lg-n20 {
    margin-right: -5rem !important;
    margin-left: -5rem !important;
  }
  .my-lg-n1 {
    margin-top: -0.25rem !important;
    margin-bottom: -0.25rem !important;
  }
  .my-lg-n2 {
    margin-top: -0.5rem !important;
    margin-bottom: -0.5rem !important;
  }
  .my-lg-n3 {
    margin-top: -0.75rem !important;
    margin-bottom: -0.75rem !important;
  }
  .my-lg-n4 {
    margin-top: -1rem !important;
    margin-bottom: -1rem !important;
  }
  .my-lg-n5 {
    margin-top: -1.25rem !important;
    margin-bottom: -1.25rem !important;
  }
  .my-lg-n6 {
    margin-top: -1.5rem !important;
    margin-bottom: -1.5rem !important;
  }
  .my-lg-n7 {
    margin-top: -1.75rem !important;
    margin-bottom: -1.75rem !important;
  }
  .my-lg-n8 {
    margin-top: -2rem !important;
    margin-bottom: -2rem !important;
  }
  .my-lg-n9 {
    margin-top: -2.25rem !important;
    margin-bottom: -2.25rem !important;
  }
  .my-lg-n10 {
    margin-top: -2.5rem !important;
    margin-bottom: -2.5rem !important;
  }
  .my-lg-n11 {
    margin-top: -2.75rem !important;
    margin-bottom: -2.75rem !important;
  }
  .my-lg-n12 {
    margin-top: -3rem !important;
    margin-bottom: -3rem !important;
  }
  .my-lg-n13 {
    margin-top: -3.25rem !important;
    margin-bottom: -3.25rem !important;
  }
  .my-lg-n14 {
    margin-top: -3.5rem !important;
    margin-bottom: -3.5rem !important;
  }
  .my-lg-n15 {
    margin-top: -3.75rem !important;
    margin-bottom: -3.75rem !important;
  }
  .my-lg-n16 {
    margin-top: -4rem !important;
    margin-bottom: -4rem !important;
  }
  .my-lg-n17 {
    margin-top: -4.25rem !important;
    margin-bottom: -4.25rem !important;
  }
  .my-lg-n18 {
    margin-top: -4.5rem !important;
    margin-bottom: -4.5rem !important;
  }
  .my-lg-n19 {
    margin-top: -4.75rem !important;
    margin-bottom: -4.75rem !important;
  }
  .my-lg-n20 {
    margin-top: -5rem !important;
    margin-bottom: -5rem !important;
  }
  .mt-lg-n1 {
    margin-top: -0.25rem !important;
  }
  .mt-lg-n2 {
    margin-top: -0.5rem !important;
  }
  .mt-lg-n3 {
    margin-top: -0.75rem !important;
  }
  .mt-lg-n4 {
    margin-top: -1rem !important;
  }
  .mt-lg-n5 {
    margin-top: -1.25rem !important;
  }
  .mt-lg-n6 {
    margin-top: -1.5rem !important;
  }
  .mt-lg-n7 {
    margin-top: -1.75rem !important;
  }
  .mt-lg-n8 {
    margin-top: -2rem !important;
  }
  .mt-lg-n9 {
    margin-top: -2.25rem !important;
  }
  .mt-lg-n10 {
    margin-top: -2.5rem !important;
  }
  .mt-lg-n11 {
    margin-top: -2.75rem !important;
  }
  .mt-lg-n12 {
    margin-top: -3rem !important;
  }
  .mt-lg-n13 {
    margin-top: -3.25rem !important;
  }
  .mt-lg-n14 {
    margin-top: -3.5rem !important;
  }
  .mt-lg-n15 {
    margin-top: -3.75rem !important;
  }
  .mt-lg-n16 {
    margin-top: -4rem !important;
  }
  .mt-lg-n17 {
    margin-top: -4.25rem !important;
  }
  .mt-lg-n18 {
    margin-top: -4.5rem !important;
  }
  .mt-lg-n19 {
    margin-top: -4.75rem !important;
  }
  .mt-lg-n20 {
    margin-top: -5rem !important;
  }
  .me-lg-n1 {
    margin-right: -0.25rem !important;
  }
  .me-lg-n2 {
    margin-right: -0.5rem !important;
  }
  .me-lg-n3 {
    margin-right: -0.75rem !important;
  }
  .me-lg-n4 {
    margin-right: -1rem !important;
  }
  .me-lg-n5 {
    margin-right: -1.25rem !important;
  }
  .me-lg-n6 {
    margin-right: -1.5rem !important;
  }
  .me-lg-n7 {
    margin-right: -1.75rem !important;
  }
  .me-lg-n8 {
    margin-right: -2rem !important;
  }
  .me-lg-n9 {
    margin-right: -2.25rem !important;
  }
  .me-lg-n10 {
    margin-right: -2.5rem !important;
  }
  .me-lg-n11 {
    margin-right: -2.75rem !important;
  }
  .me-lg-n12 {
    margin-right: -3rem !important;
  }
  .me-lg-n13 {
    margin-right: -3.25rem !important;
  }
  .me-lg-n14 {
    margin-right: -3.5rem !important;
  }
  .me-lg-n15 {
    margin-right: -3.75rem !important;
  }
  .me-lg-n16 {
    margin-right: -4rem !important;
  }
  .me-lg-n17 {
    margin-right: -4.25rem !important;
  }
  .me-lg-n18 {
    margin-right: -4.5rem !important;
  }
  .me-lg-n19 {
    margin-right: -4.75rem !important;
  }
  .me-lg-n20 {
    margin-right: -5rem !important;
  }
  .mb-lg-n1 {
    margin-bottom: -0.25rem !important;
  }
  .mb-lg-n2 {
    margin-bottom: -0.5rem !important;
  }
  .mb-lg-n3 {
    margin-bottom: -0.75rem !important;
  }
  .mb-lg-n4 {
    margin-bottom: -1rem !important;
  }
  .mb-lg-n5 {
    margin-bottom: -1.25rem !important;
  }
  .mb-lg-n6 {
    margin-bottom: -1.5rem !important;
  }
  .mb-lg-n7 {
    margin-bottom: -1.75rem !important;
  }
  .mb-lg-n8 {
    margin-bottom: -2rem !important;
  }
  .mb-lg-n9 {
    margin-bottom: -2.25rem !important;
  }
  .mb-lg-n10 {
    margin-bottom: -2.5rem !important;
  }
  .mb-lg-n11 {
    margin-bottom: -2.75rem !important;
  }
  .mb-lg-n12 {
    margin-bottom: -3rem !important;
  }
  .mb-lg-n13 {
    margin-bottom: -3.25rem !important;
  }
  .mb-lg-n14 {
    margin-bottom: -3.5rem !important;
  }
  .mb-lg-n15 {
    margin-bottom: -3.75rem !important;
  }
  .mb-lg-n16 {
    margin-bottom: -4rem !important;
  }
  .mb-lg-n17 {
    margin-bottom: -4.25rem !important;
  }
  .mb-lg-n18 {
    margin-bottom: -4.5rem !important;
  }
  .mb-lg-n19 {
    margin-bottom: -4.75rem !important;
  }
  .mb-lg-n20 {
    margin-bottom: -5rem !important;
  }
  .ms-lg-n1 {
    margin-left: -0.25rem !important;
  }
  .ms-lg-n2 {
    margin-left: -0.5rem !important;
  }
  .ms-lg-n3 {
    margin-left: -0.75rem !important;
  }
  .ms-lg-n4 {
    margin-left: -1rem !important;
  }
  .ms-lg-n5 {
    margin-left: -1.25rem !important;
  }
  .ms-lg-n6 {
    margin-left: -1.5rem !important;
  }
  .ms-lg-n7 {
    margin-left: -1.75rem !important;
  }
  .ms-lg-n8 {
    margin-left: -2rem !important;
  }
  .ms-lg-n9 {
    margin-left: -2.25rem !important;
  }
  .ms-lg-n10 {
    margin-left: -2.5rem !important;
  }
  .ms-lg-n11 {
    margin-left: -2.75rem !important;
  }
  .ms-lg-n12 {
    margin-left: -3rem !important;
  }
  .ms-lg-n13 {
    margin-left: -3.25rem !important;
  }
  .ms-lg-n14 {
    margin-left: -3.5rem !important;
  }
  .ms-lg-n15 {
    margin-left: -3.75rem !important;
  }
  .ms-lg-n16 {
    margin-left: -4rem !important;
  }
  .ms-lg-n17 {
    margin-left: -4.25rem !important;
  }
  .ms-lg-n18 {
    margin-left: -4.5rem !important;
  }
  .ms-lg-n19 {
    margin-left: -4.75rem !important;
  }
  .ms-lg-n20 {
    margin-left: -5rem !important;
  }
  .p-lg-0 {
    padding: 0 !important;
  }
  .p-lg-1 {
    padding: 0.25rem !important;
  }
  .p-lg-2 {
    padding: 0.5rem !important;
  }
  .p-lg-3 {
    padding: 0.75rem !important;
  }
  .p-lg-4 {
    padding: 1rem !important;
  }
  .p-lg-5 {
    padding: 1.25rem !important;
  }
  .p-lg-6 {
    padding: 1.5rem !important;
  }
  .p-lg-7 {
    padding: 1.75rem !important;
  }
  .p-lg-8 {
    padding: 2rem !important;
  }
  .p-lg-9 {
    padding: 2.25rem !important;
  }
  .p-lg-10 {
    padding: 2.5rem !important;
  }
  .p-lg-11 {
    padding: 2.75rem !important;
  }
  .p-lg-12 {
    padding: 3rem !important;
  }
  .p-lg-13 {
    padding: 3.25rem !important;
  }
  .p-lg-14 {
    padding: 3.5rem !important;
  }
  .p-lg-15 {
    padding: 3.75rem !important;
  }
  .p-lg-16 {
    padding: 4rem !important;
  }
  .p-lg-17 {
    padding: 4.25rem !important;
  }
  .p-lg-18 {
    padding: 4.5rem !important;
  }
  .p-lg-19 {
    padding: 4.75rem !important;
  }
  .p-lg-20 {
    padding: 5rem !important;
  }
  .px-lg-0 {
    padding-right: 0 !important;
    padding-left: 0 !important;
  }
  .px-lg-1 {
    padding-right: 0.25rem !important;
    padding-left: 0.25rem !important;
  }
  .px-lg-2 {
    padding-right: 0.5rem !important;
    padding-left: 0.5rem !important;
  }
  .px-lg-3 {
    padding-right: 0.75rem !important;
    padding-left: 0.75rem !important;
  }
  .px-lg-4 {
    padding-right: 1rem !important;
    padding-left: 1rem !important;
  }
  .px-lg-5 {
    padding-right: 1.25rem !important;
    padding-left: 1.25rem !important;
  }
  .px-lg-6 {
    padding-right: 1.5rem !important;
    padding-left: 1.5rem !important;
  }
  .px-lg-7 {
    padding-right: 1.75rem !important;
    padding-left: 1.75rem !important;
  }
  .px-lg-8 {
    padding-right: 2rem !important;
    padding-left: 2rem !important;
  }
  .px-lg-9 {
    padding-right: 2.25rem !important;
    padding-left: 2.25rem !important;
  }
  .px-lg-10 {
    padding-right: 2.5rem !important;
    padding-left: 2.5rem !important;
  }
  .px-lg-11 {
    padding-right: 2.75rem !important;
    padding-left: 2.75rem !important;
  }
  .px-lg-12 {
    padding-right: 3rem !important;
    padding-left: 3rem !important;
  }
  .px-lg-13 {
    padding-right: 3.25rem !important;
    padding-left: 3.25rem !important;
  }
  .px-lg-14 {
    padding-right: 3.5rem !important;
    padding-left: 3.5rem !important;
  }
  .px-lg-15 {
    padding-right: 3.75rem !important;
    padding-left: 3.75rem !important;
  }
  .px-lg-16 {
    padding-right: 4rem !important;
    padding-left: 4rem !important;
  }
  .px-lg-17 {
    padding-right: 4.25rem !important;
    padding-left: 4.25rem !important;
  }
  .px-lg-18 {
    padding-right: 4.5rem !important;
    padding-left: 4.5rem !important;
  }
  .px-lg-19 {
    padding-right: 4.75rem !important;
    padding-left: 4.75rem !important;
  }
  .px-lg-20 {
    padding-right: 5rem !important;
    padding-left: 5rem !important;
  }
  .py-lg-0 {
    padding-top: 0 !important;
    padding-bottom: 0 !important;
  }
  .py-lg-1 {
    padding-top: 0.25rem !important;
    padding-bottom: 0.25rem !important;
  }
  .py-lg-2 {
    padding-top: 0.5rem !important;
    padding-bottom: 0.5rem !important;
  }
  .py-lg-3 {
    padding-top: 0.75rem !important;
    padding-bottom: 0.75rem !important;
  }
  .py-lg-4 {
    padding-top: 1rem !important;
    padding-bottom: 1rem !important;
  }
  .py-lg-5 {
    padding-top: 1.25rem !important;
    padding-bottom: 1.25rem !important;
  }
  .py-lg-6 {
    padding-top: 1.5rem !important;
    padding-bottom: 1.5rem !important;
  }
  .py-lg-7 {
    padding-top: 1.75rem !important;
    padding-bottom: 1.75rem !important;
  }
  .py-lg-8 {
    padding-top: 2rem !important;
    padding-bottom: 2rem !important;
  }
  .py-lg-9 {
    padding-top: 2.25rem !important;
    padding-bottom: 2.25rem !important;
  }
  .py-lg-10 {
    padding-top: 2.5rem !important;
    padding-bottom: 2.5rem !important;
  }
  .py-lg-11 {
    padding-top: 2.75rem !important;
    padding-bottom: 2.75rem !important;
  }
  .py-lg-12 {
    padding-top: 3rem !important;
    padding-bottom: 3rem !important;
  }
  .py-lg-13 {
    padding-top: 3.25rem !important;
    padding-bottom: 3.25rem !important;
  }
  .py-lg-14 {
    padding-top: 3.5rem !important;
    padding-bottom: 3.5rem !important;
  }
  .py-lg-15 {
    padding-top: 3.75rem !important;
    padding-bottom: 3.75rem !important;
  }
  .py-lg-16 {
    padding-top: 4rem !important;
    padding-bottom: 4rem !important;
  }
  .py-lg-17 {
    padding-top: 4.25rem !important;
    padding-bottom: 4.25rem !important;
  }
  .py-lg-18 {
    padding-top: 4.5rem !important;
    padding-bottom: 4.5rem !important;
  }
  .py-lg-19 {
    padding-top: 4.75rem !important;
    padding-bottom: 4.75rem !important;
  }
  .py-lg-20 {
    padding-top: 5rem !important;
    padding-bottom: 5rem !important;
  }
  .pt-lg-0 {
    padding-top: 0 !important;
  }
  .pt-lg-1 {
    padding-top: 0.25rem !important;
  }
  .pt-lg-2 {
    padding-top: 0.5rem !important;
  }
  .pt-lg-3 {
    padding-top: 0.75rem !important;
  }
  .pt-lg-4 {
    padding-top: 1rem !important;
  }
  .pt-lg-5 {
    padding-top: 1.25rem !important;
  }
  .pt-lg-6 {
    padding-top: 1.5rem !important;
  }
  .pt-lg-7 {
    padding-top: 1.75rem !important;
  }
  .pt-lg-8 {
    padding-top: 2rem !important;
  }
  .pt-lg-9 {
    padding-top: 2.25rem !important;
  }
  .pt-lg-10 {
    padding-top: 2.5rem !important;
  }
  .pt-lg-11 {
    padding-top: 2.75rem !important;
  }
  .pt-lg-12 {
    padding-top: 3rem !important;
  }
  .pt-lg-13 {
    padding-top: 3.25rem !important;
  }
  .pt-lg-14 {
    padding-top: 3.5rem !important;
  }
  .pt-lg-15 {
    padding-top: 3.75rem !important;
  }
  .pt-lg-16 {
    padding-top: 4rem !important;
  }
  .pt-lg-17 {
    padding-top: 4.25rem !important;
  }
  .pt-lg-18 {
    padding-top: 4.5rem !important;
  }
  .pt-lg-19 {
    padding-top: 4.75rem !important;
  }
  .pt-lg-20 {
    padding-top: 5rem !important;
  }
  .pe-lg-0 {
    padding-right: 0 !important;
  }
  .pe-lg-1 {
    padding-right: 0.25rem !important;
  }
  .pe-lg-2 {
    padding-right: 0.5rem !important;
  }
  .pe-lg-3 {
    padding-right: 0.75rem !important;
  }
  .pe-lg-4 {
    padding-right: 1rem !important;
  }
  .pe-lg-5 {
    padding-right: 1.25rem !important;
  }
  .pe-lg-6 {
    padding-right: 1.5rem !important;
  }
  .pe-lg-7 {
    padding-right: 1.75rem !important;
  }
  .pe-lg-8 {
    padding-right: 2rem !important;
  }
  .pe-lg-9 {
    padding-right: 2.25rem !important;
  }
  .pe-lg-10 {
    padding-right: 2.5rem !important;
  }
  .pe-lg-11 {
    padding-right: 2.75rem !important;
  }
  .pe-lg-12 {
    padding-right: 3rem !important;
  }
  .pe-lg-13 {
    padding-right: 3.25rem !important;
  }
  .pe-lg-14 {
    padding-right: 3.5rem !important;
  }
  .pe-lg-15 {
    padding-right: 3.75rem !important;
  }
  .pe-lg-16 {
    padding-right: 4rem !important;
  }
  .pe-lg-17 {
    padding-right: 4.25rem !important;
  }
  .pe-lg-18 {
    padding-right: 4.5rem !important;
  }
  .pe-lg-19 {
    padding-right: 4.75rem !important;
  }
  .pe-lg-20 {
    padding-right: 5rem !important;
  }
  .pb-lg-0 {
    padding-bottom: 0 !important;
  }
  .pb-lg-1 {
    padding-bottom: 0.25rem !important;
  }
  .pb-lg-2 {
    padding-bottom: 0.5rem !important;
  }
  .pb-lg-3 {
    padding-bottom: 0.75rem !important;
  }
  .pb-lg-4 {
    padding-bottom: 1rem !important;
  }
  .pb-lg-5 {
    padding-bottom: 1.25rem !important;
  }
  .pb-lg-6 {
    padding-bottom: 1.5rem !important;
  }
  .pb-lg-7 {
    padding-bottom: 1.75rem !important;
  }
  .pb-lg-8 {
    padding-bottom: 2rem !important;
  }
  .pb-lg-9 {
    padding-bottom: 2.25rem !important;
  }
  .pb-lg-10 {
    padding-bottom: 2.5rem !important;
  }
  .pb-lg-11 {
    padding-bottom: 2.75rem !important;
  }
  .pb-lg-12 {
    padding-bottom: 3rem !important;
  }
  .pb-lg-13 {
    padding-bottom: 3.25rem !important;
  }
  .pb-lg-14 {
    padding-bottom: 3.5rem !important;
  }
  .pb-lg-15 {
    padding-bottom: 3.75rem !important;
  }
  .pb-lg-16 {
    padding-bottom: 4rem !important;
  }
  .pb-lg-17 {
    padding-bottom: 4.25rem !important;
  }
  .pb-lg-18 {
    padding-bottom: 4.5rem !important;
  }
  .pb-lg-19 {
    padding-bottom: 4.75rem !important;
  }
  .pb-lg-20 {
    padding-bottom: 5rem !important;
  }
  .ps-lg-0 {
    padding-left: 0 !important;
  }
  .ps-lg-1 {
    padding-left: 0.25rem !important;
  }
  .ps-lg-2 {
    padding-left: 0.5rem !important;
  }
  .ps-lg-3 {
    padding-left: 0.75rem !important;
  }
  .ps-lg-4 {
    padding-left: 1rem !important;
  }
  .ps-lg-5 {
    padding-left: 1.25rem !important;
  }
  .ps-lg-6 {
    padding-left: 1.5rem !important;
  }
  .ps-lg-7 {
    padding-left: 1.75rem !important;
  }
  .ps-lg-8 {
    padding-left: 2rem !important;
  }
  .ps-lg-9 {
    padding-left: 2.25rem !important;
  }
  .ps-lg-10 {
    padding-left: 2.5rem !important;
  }
  .ps-lg-11 {
    padding-left: 2.75rem !important;
  }
  .ps-lg-12 {
    padding-left: 3rem !important;
  }
  .ps-lg-13 {
    padding-left: 3.25rem !important;
  }
  .ps-lg-14 {
    padding-left: 3.5rem !important;
  }
  .ps-lg-15 {
    padding-left: 3.75rem !important;
  }
  .ps-lg-16 {
    padding-left: 4rem !important;
  }
  .ps-lg-17 {
    padding-left: 4.25rem !important;
  }
  .ps-lg-18 {
    padding-left: 4.5rem !important;
  }
  .ps-lg-19 {
    padding-left: 4.75rem !important;
  }
  .ps-lg-20 {
    padding-left: 5rem !important;
  }
  .gap-lg-0 {
    gap: 0 !important;
  }
  .gap-lg-1 {
    gap: 0.25rem !important;
  }
  .gap-lg-2 {
    gap: 0.5rem !important;
  }
  .gap-lg-3 {
    gap: 0.75rem !important;
  }
  .gap-lg-4 {
    gap: 1rem !important;
  }
  .gap-lg-5 {
    gap: 1.25rem !important;
  }
  .gap-lg-6 {
    gap: 1.5rem !important;
  }
  .gap-lg-7 {
    gap: 1.75rem !important;
  }
  .gap-lg-8 {
    gap: 2rem !important;
  }
  .gap-lg-9 {
    gap: 2.25rem !important;
  }
  .gap-lg-10 {
    gap: 2.5rem !important;
  }
  .gap-lg-11 {
    gap: 2.75rem !important;
  }
  .gap-lg-12 {
    gap: 3rem !important;
  }
  .gap-lg-13 {
    gap: 3.25rem !important;
  }
  .gap-lg-14 {
    gap: 3.5rem !important;
  }
  .gap-lg-15 {
    gap: 3.75rem !important;
  }
  .gap-lg-16 {
    gap: 4rem !important;
  }
  .gap-lg-17 {
    gap: 4.25rem !important;
  }
  .gap-lg-18 {
    gap: 4.5rem !important;
  }
  .gap-lg-19 {
    gap: 4.75rem !important;
  }
  .gap-lg-20 {
    gap: 5rem !important;
  }
  .row-gap-lg-0 {
    row-gap: 0 !important;
  }
  .row-gap-lg-1 {
    row-gap: 0.25rem !important;
  }
  .row-gap-lg-2 {
    row-gap: 0.5rem !important;
  }
  .row-gap-lg-3 {
    row-gap: 0.75rem !important;
  }
  .row-gap-lg-4 {
    row-gap: 1rem !important;
  }
  .row-gap-lg-5 {
    row-gap: 1.25rem !important;
  }
  .row-gap-lg-6 {
    row-gap: 1.5rem !important;
  }
  .row-gap-lg-7 {
    row-gap: 1.75rem !important;
  }
  .row-gap-lg-8 {
    row-gap: 2rem !important;
  }
  .row-gap-lg-9 {
    row-gap: 2.25rem !important;
  }
  .row-gap-lg-10 {
    row-gap: 2.5rem !important;
  }
  .row-gap-lg-11 {
    row-gap: 2.75rem !important;
  }
  .row-gap-lg-12 {
    row-gap: 3rem !important;
  }
  .row-gap-lg-13 {
    row-gap: 3.25rem !important;
  }
  .row-gap-lg-14 {
    row-gap: 3.5rem !important;
  }
  .row-gap-lg-15 {
    row-gap: 3.75rem !important;
  }
  .row-gap-lg-16 {
    row-gap: 4rem !important;
  }
  .row-gap-lg-17 {
    row-gap: 4.25rem !important;
  }
  .row-gap-lg-18 {
    row-gap: 4.5rem !important;
  }
  .row-gap-lg-19 {
    row-gap: 4.75rem !important;
  }
  .row-gap-lg-20 {
    row-gap: 5rem !important;
  }
  .column-gap-lg-0 {
    column-gap: 0 !important;
  }
  .column-gap-lg-1 {
    column-gap: 0.25rem !important;
  }
  .column-gap-lg-2 {
    column-gap: 0.5rem !important;
  }
  .column-gap-lg-3 {
    column-gap: 0.75rem !important;
  }
  .column-gap-lg-4 {
    column-gap: 1rem !important;
  }
  .column-gap-lg-5 {
    column-gap: 1.25rem !important;
  }
  .column-gap-lg-6 {
    column-gap: 1.5rem !important;
  }
  .column-gap-lg-7 {
    column-gap: 1.75rem !important;
  }
  .column-gap-lg-8 {
    column-gap: 2rem !important;
  }
  .column-gap-lg-9 {
    column-gap: 2.25rem !important;
  }
  .column-gap-lg-10 {
    column-gap: 2.5rem !important;
  }
  .column-gap-lg-11 {
    column-gap: 2.75rem !important;
  }
  .column-gap-lg-12 {
    column-gap: 3rem !important;
  }
  .column-gap-lg-13 {
    column-gap: 3.25rem !important;
  }
  .column-gap-lg-14 {
    column-gap: 3.5rem !important;
  }
  .column-gap-lg-15 {
    column-gap: 3.75rem !important;
  }
  .column-gap-lg-16 {
    column-gap: 4rem !important;
  }
  .column-gap-lg-17 {
    column-gap: 4.25rem !important;
  }
  .column-gap-lg-18 {
    column-gap: 4.5rem !important;
  }
  .column-gap-lg-19 {
    column-gap: 4.75rem !important;
  }
  .column-gap-lg-20 {
    column-gap: 5rem !important;
  }
  .fs-lg-1 {
    font-size: calc(1.3rem + 0.6vw) !important;
  }
  .fs-lg-2 {
    font-size: calc(1.275rem + 0.3vw) !important;
  }
  .fs-lg-3 {
    font-size: calc(1.26rem + 0.12vw) !important;
  }
  .fs-lg-4 {
    font-size: 1.25rem !important;
  }
  .fs-lg-5 {
    font-size: 1.15rem !important;
  }
  .fs-lg-6 {
    font-size: 1.075rem !important;
  }
  .fs-lg-7 {
    font-size: 0.95rem !important;
  }
  .fs-lg-8 {
    font-size: 0.85rem !important;
  }
  .fs-lg-9 {
    font-size: 0.75rem !important;
  }
  .fs-lg-10 {
    font-size: 0.5rem !important;
  }
  .fs-lg-base {
    font-size: 1rem !important;
  }
  .fs-lg-fluid {
    font-size: 100% !important;
  }
  .fs-lg-2x {
    font-size: calc(1.325rem + 0.9vw) !important;
  }
  .fs-lg-2qx {
    font-size: calc(1.35rem + 1.2vw) !important;
  }
  .fs-lg-2hx {
    font-size: calc(1.375rem + 1.5vw) !important;
  }
  .fs-lg-2tx {
    font-size: calc(1.4rem + 1.8vw) !important;
  }
  .fs-lg-3x {
    font-size: calc(1.425rem + 2.1vw) !important;
  }
  .fs-lg-3qx {
    font-size: calc(1.45rem + 2.4vw) !important;
  }
  .fs-lg-3hx {
    font-size: calc(1.475rem + 2.7vw) !important;
  }
  .fs-lg-3tx {
    font-size: calc(1.5rem + 3vw) !important;
  }
  .fs-lg-4x {
    font-size: calc(1.525rem + 3.3vw) !important;
  }
  .fs-lg-4qx {
    font-size: calc(1.55rem + 3.6vw) !important;
  }
  .fs-lg-4hx {
    font-size: calc(1.575rem + 3.9vw) !important;
  }
  .fs-lg-4tx {
    font-size: calc(1.6rem + 4.2vw) !important;
  }
  .fs-lg-5x {
    font-size: calc(1.625rem + 4.5vw) !important;
  }
  .fs-lg-5qx {
    font-size: calc(1.65rem + 4.8vw) !important;
  }
  .fs-lg-5hx {
    font-size: calc(1.675rem + 5.1vw) !important;
  }
  .fs-lg-5tx {
    font-size: calc(1.7rem + 5.4vw) !important;
  }
  .fs-lg-6x {
    font-size: calc(1.725rem + 5.7vw) !important;
  }
  .fs-lg-6qx {
    font-size: calc(1.75rem + 6vw) !important;
  }
  .fs-lg-6hx {
    font-size: calc(1.775rem + 6.3vw) !important;
  }
  .fs-lg-6tx {
    font-size: calc(1.8rem + 6.6vw) !important;
  }
  .fs-lg-7x {
    font-size: calc(1.825rem + 6.9vw) !important;
  }
  .fs-lg-7qx {
    font-size: calc(1.85rem + 7.2vw) !important;
  }
  .fs-lg-7hx {
    font-size: calc(1.875rem + 7.5vw) !important;
  }
  .fs-lg-7tx {
    font-size: calc(1.9rem + 7.8vw) !important;
  }
  .text-lg-start {
    text-align: left !important;
  }
  .text-lg-end {
    text-align: right !important;
  }
  .text-lg-center {
    text-align: center !important;
  }
  .min-w-lg-unset {
    min-width: unset !important;
  }
  .min-w-lg-25 {
    min-width: 25% !important;
  }
  .min-w-lg-50 {
    min-width: 50% !important;
  }
  .min-w-lg-75 {
    min-width: 75% !important;
  }
  .min-w-lg-100 {
    min-width: 100% !important;
  }
  .min-w-lg-auto {
    min-width: auto !important;
  }
  .min-w-lg-1px {
    min-width: 1px !important;
  }
  .min-w-lg-2px {
    min-width: 2px !important;
  }
  .min-w-lg-3px {
    min-width: 3px !important;
  }
  .min-w-lg-4px {
    min-width: 4px !important;
  }
  .min-w-lg-5px {
    min-width: 5px !important;
  }
  .min-w-lg-6px {
    min-width: 6px !important;
  }
  .min-w-lg-7px {
    min-width: 7px !important;
  }
  .min-w-lg-8px {
    min-width: 8px !important;
  }
  .min-w-lg-9px {
    min-width: 9px !important;
  }
  .min-w-lg-10px {
    min-width: 10px !important;
  }
  .min-w-lg-15px {
    min-width: 15px !important;
  }
  .min-w-lg-20px {
    min-width: 20px !important;
  }
  .min-w-lg-25px {
    min-width: 25px !important;
  }
  .min-w-lg-30px {
    min-width: 30px !important;
  }
  .min-w-lg-35px {
    min-width: 35px !important;
  }
  .min-w-lg-40px {
    min-width: 40px !important;
  }
  .min-w-lg-45px {
    min-width: 45px !important;
  }
  .min-w-lg-50px {
    min-width: 50px !important;
  }
  .min-w-lg-55px {
    min-width: 55px !important;
  }
  .min-w-lg-60px {
    min-width: 60px !important;
  }
  .min-w-lg-65px {
    min-width: 65px !important;
  }
  .min-w-lg-70px {
    min-width: 70px !important;
  }
  .min-w-lg-75px {
    min-width: 75px !important;
  }
  .min-w-lg-80px {
    min-width: 80px !important;
  }
  .min-w-lg-85px {
    min-width: 85px !important;
  }
  .min-w-lg-90px {
    min-width: 90px !important;
  }
  .min-w-lg-95px {
    min-width: 95px !important;
  }
  .min-w-lg-100px {
    min-width: 100px !important;
  }
  .min-w-lg-125px {
    min-width: 125px !important;
  }
  .min-w-lg-150px {
    min-width: 150px !important;
  }
  .min-w-lg-175px {
    min-width: 175px !important;
  }
  .min-w-lg-200px {
    min-width: 200px !important;
  }
  .min-w-lg-225px {
    min-width: 225px !important;
  }
  .min-w-lg-250px {
    min-width: 250px !important;
  }
  .min-w-lg-275px {
    min-width: 275px !important;
  }
  .min-w-lg-300px {
    min-width: 300px !important;
  }
  .min-w-lg-325px {
    min-width: 325px !important;
  }
  .min-w-lg-350px {
    min-width: 350px !important;
  }
  .min-w-lg-375px {
    min-width: 375px !important;
  }
  .min-w-lg-400px {
    min-width: 400px !important;
  }
  .min-w-lg-425px {
    min-width: 425px !important;
  }
  .min-w-lg-450px {
    min-width: 450px !important;
  }
  .min-w-lg-475px {
    min-width: 475px !important;
  }
  .min-w-lg-500px {
    min-width: 500px !important;
  }
  .min-w-lg-550px {
    min-width: 550px !important;
  }
  .min-w-lg-600px {
    min-width: 600px !important;
  }
  .min-w-lg-650px {
    min-width: 650px !important;
  }
  .min-w-lg-700px {
    min-width: 700px !important;
  }
  .min-w-lg-750px {
    min-width: 750px !important;
  }
  .min-w-lg-800px {
    min-width: 800px !important;
  }
  .min-w-lg-850px {
    min-width: 850px !important;
  }
  .min-w-lg-900px {
    min-width: 900px !important;
  }
  .min-w-lg-950px {
    min-width: 950px !important;
  }
  .min-w-lg-1000px {
    min-width: 1000px !important;
  }
  .min-h-lg-unset {
    min-height: unset !important;
  }
  .min-h-lg-25 {
    min-height: 25% !important;
  }
  .min-h-lg-50 {
    min-height: 50% !important;
  }
  .min-h-lg-75 {
    min-height: 75% !important;
  }
  .min-h-lg-100 {
    min-height: 100% !important;
  }
  .min-h-lg-auto {
    min-height: auto !important;
  }
  .min-h-lg-1px {
    min-height: 1px !important;
  }
  .min-h-lg-2px {
    min-height: 2px !important;
  }
  .min-h-lg-3px {
    min-height: 3px !important;
  }
  .min-h-lg-4px {
    min-height: 4px !important;
  }
  .min-h-lg-5px {
    min-height: 5px !important;
  }
  .min-h-lg-6px {
    min-height: 6px !important;
  }
  .min-h-lg-7px {
    min-height: 7px !important;
  }
  .min-h-lg-8px {
    min-height: 8px !important;
  }
  .min-h-lg-9px {
    min-height: 9px !important;
  }
  .min-h-lg-10px {
    min-height: 10px !important;
  }
  .min-h-lg-15px {
    min-height: 15px !important;
  }
  .min-h-lg-20px {
    min-height: 20px !important;
  }
  .min-h-lg-25px {
    min-height: 25px !important;
  }
  .min-h-lg-30px {
    min-height: 30px !important;
  }
  .min-h-lg-35px {
    min-height: 35px !important;
  }
  .min-h-lg-40px {
    min-height: 40px !important;
  }
  .min-h-lg-45px {
    min-height: 45px !important;
  }
  .min-h-lg-50px {
    min-height: 50px !important;
  }
  .min-h-lg-55px {
    min-height: 55px !important;
  }
  .min-h-lg-60px {
    min-height: 60px !important;
  }
  .min-h-lg-65px {
    min-height: 65px !important;
  }
  .min-h-lg-70px {
    min-height: 70px !important;
  }
  .min-h-lg-75px {
    min-height: 75px !important;
  }
  .min-h-lg-80px {
    min-height: 80px !important;
  }
  .min-h-lg-85px {
    min-height: 85px !important;
  }
  .min-h-lg-90px {
    min-height: 90px !important;
  }
  .min-h-lg-95px {
    min-height: 95px !important;
  }
  .min-h-lg-100px {
    min-height: 100px !important;
  }
  .min-h-lg-125px {
    min-height: 125px !important;
  }
  .min-h-lg-150px {
    min-height: 150px !important;
  }
  .min-h-lg-175px {
    min-height: 175px !important;
  }
  .min-h-lg-200px {
    min-height: 200px !important;
  }
  .min-h-lg-225px {
    min-height: 225px !important;
  }
  .min-h-lg-250px {
    min-height: 250px !important;
  }
  .min-h-lg-275px {
    min-height: 275px !important;
  }
  .min-h-lg-300px {
    min-height: 300px !important;
  }
  .min-h-lg-325px {
    min-height: 325px !important;
  }
  .min-h-lg-350px {
    min-height: 350px !important;
  }
  .min-h-lg-375px {
    min-height: 375px !important;
  }
  .min-h-lg-400px {
    min-height: 400px !important;
  }
  .min-h-lg-425px {
    min-height: 425px !important;
  }
  .min-h-lg-450px {
    min-height: 450px !important;
  }
  .min-h-lg-475px {
    min-height: 475px !important;
  }
  .min-h-lg-500px {
    min-height: 500px !important;
  }
  .min-h-lg-550px {
    min-height: 550px !important;
  }
  .min-h-lg-600px {
    min-height: 600px !important;
  }
  .min-h-lg-650px {
    min-height: 650px !important;
  }
  .min-h-lg-700px {
    min-height: 700px !important;
  }
  .min-h-lg-750px {
    min-height: 750px !important;
  }
  .min-h-lg-800px {
    min-height: 800px !important;
  }
  .min-h-lg-850px {
    min-height: 850px !important;
  }
  .min-h-lg-900px {
    min-height: 900px !important;
  }
  .min-h-lg-950px {
    min-height: 950px !important;
  }
  .min-h-lg-1000px {
    min-height: 1000px !important;
  }
}
@media (min-width: 1200px) {
  .float-xl-start {
    float: left !important;
  }
  .float-xl-end {
    float: right !important;
  }
  .float-xl-none {
    float: none !important;
  }
  .object-fit-xl-contain {
    object-fit: contain !important;
  }
  .object-fit-xl-cover {
    object-fit: cover !important;
  }
  .object-fit-xl-fill {
    object-fit: fill !important;
  }
  .object-fit-xl-scale {
    object-fit: scale-down !important;
  }
  .object-fit-xl-none {
    object-fit: none !important;
  }
  .overflow-xl-auto {
    overflow: auto !important;
  }
  .overflow-xl-hidden {
    overflow: hidden !important;
  }
  .overflow-xl-visible {
    overflow: visible !important;
  }
  .overflow-xl-scroll {
    overflow: scroll !important;
  }
  .d-xl-inline {
    display: inline !important;
  }
  .d-xl-inline-block {
    display: inline-block !important;
  }
  .d-xl-block {
    display: block !important;
  }
  .d-xl-grid {
    display: grid !important;
  }
  .d-xl-table {
    display: table !important;
  }
  .d-xl-table-row {
    display: table-row !important;
  }
  .d-xl-table-cell {
    display: table-cell !important;
  }
  .d-xl-flex {
    display: flex !important;
  }
  .d-xl-inline-flex {
    display: inline-flex !important;
  }
  .d-xl-none {
    display: none !important;
  }
  .position-xl-static {
    position: static !important;
  }
  .position-xl-relative {
    position: relative !important;
  }
  .position-xl-absolute {
    position: absolute !important;
  }
  .position-xl-fixed {
    position: fixed !important;
  }
  .position-xl-sticky {
    position: sticky !important;
  }
  .w-xl-unset {
    width: unset !important;
  }
  .w-xl-25 {
    width: 25% !important;
  }
  .w-xl-50 {
    width: 50% !important;
  }
  .w-xl-75 {
    width: 75% !important;
  }
  .w-xl-100 {
    width: 100% !important;
  }
  .w-xl-auto {
    width: auto !important;
  }
  .w-xl-1px {
    width: 1px !important;
  }
  .w-xl-2px {
    width: 2px !important;
  }
  .w-xl-3px {
    width: 3px !important;
  }
  .w-xl-4px {
    width: 4px !important;
  }
  .w-xl-5px {
    width: 5px !important;
  }
  .w-xl-6px {
    width: 6px !important;
  }
  .w-xl-7px {
    width: 7px !important;
  }
  .w-xl-8px {
    width: 8px !important;
  }
  .w-xl-9px {
    width: 9px !important;
  }
  .w-xl-10px {
    width: 10px !important;
  }
  .w-xl-15px {
    width: 15px !important;
  }
  .w-xl-20px {
    width: 20px !important;
  }
  .w-xl-25px {
    width: 25px !important;
  }
  .w-xl-30px {
    width: 30px !important;
  }
  .w-xl-35px {
    width: 35px !important;
  }
  .w-xl-40px {
    width: 40px !important;
  }
  .w-xl-45px {
    width: 45px !important;
  }
  .w-xl-50px {
    width: 50px !important;
  }
  .w-xl-55px {
    width: 55px !important;
  }
  .w-xl-60px {
    width: 60px !important;
  }
  .w-xl-65px {
    width: 65px !important;
  }
  .w-xl-70px {
    width: 70px !important;
  }
  .w-xl-75px {
    width: 75px !important;
  }
  .w-xl-80px {
    width: 80px !important;
  }
  .w-xl-85px {
    width: 85px !important;
  }
  .w-xl-90px {
    width: 90px !important;
  }
  .w-xl-95px {
    width: 95px !important;
  }
  .w-xl-100px {
    width: 100px !important;
  }
  .w-xl-125px {
    width: 125px !important;
  }
  .w-xl-150px {
    width: 150px !important;
  }
  .w-xl-175px {
    width: 175px !important;
  }
  .w-xl-200px {
    width: 200px !important;
  }
  .w-xl-225px {
    width: 225px !important;
  }
  .w-xl-250px {
    width: 250px !important;
  }
  .w-xl-275px {
    width: 275px !important;
  }
  .w-xl-300px {
    width: 300px !important;
  }
  .w-xl-325px {
    width: 325px !important;
  }
  .w-xl-350px {
    width: 350px !important;
  }
  .w-xl-375px {
    width: 375px !important;
  }
  .w-xl-400px {
    width: 400px !important;
  }
  .w-xl-425px {
    width: 425px !important;
  }
  .w-xl-450px {
    width: 450px !important;
  }
  .w-xl-475px {
    width: 475px !important;
  }
  .w-xl-500px {
    width: 500px !important;
  }
  .w-xl-550px {
    width: 550px !important;
  }
  .w-xl-600px {
    width: 600px !important;
  }
  .w-xl-650px {
    width: 650px !important;
  }
  .w-xl-700px {
    width: 700px !important;
  }
  .w-xl-750px {
    width: 750px !important;
  }
  .w-xl-800px {
    width: 800px !important;
  }
  .w-xl-850px {
    width: 850px !important;
  }
  .w-xl-900px {
    width: 900px !important;
  }
  .w-xl-950px {
    width: 950px !important;
  }
  .w-xl-1000px {
    width: 1000px !important;
  }
  .mw-xl-unset {
    max-width: unset !important;
  }
  .mw-xl-25 {
    max-width: 25% !important;
  }
  .mw-xl-50 {
    max-width: 50% !important;
  }
  .mw-xl-75 {
    max-width: 75% !important;
  }
  .mw-xl-100 {
    max-width: 100% !important;
  }
  .mw-xl-auto {
    max-width: auto !important;
  }
  .mw-xl-1px {
    max-width: 1px !important;
  }
  .mw-xl-2px {
    max-width: 2px !important;
  }
  .mw-xl-3px {
    max-width: 3px !important;
  }
  .mw-xl-4px {
    max-width: 4px !important;
  }
  .mw-xl-5px {
    max-width: 5px !important;
  }
  .mw-xl-6px {
    max-width: 6px !important;
  }
  .mw-xl-7px {
    max-width: 7px !important;
  }
  .mw-xl-8px {
    max-width: 8px !important;
  }
  .mw-xl-9px {
    max-width: 9px !important;
  }
  .mw-xl-10px {
    max-width: 10px !important;
  }
  .mw-xl-15px {
    max-width: 15px !important;
  }
  .mw-xl-20px {
    max-width: 20px !important;
  }
  .mw-xl-25px {
    max-width: 25px !important;
  }
  .mw-xl-30px {
    max-width: 30px !important;
  }
  .mw-xl-35px {
    max-width: 35px !important;
  }
  .mw-xl-40px {
    max-width: 40px !important;
  }
  .mw-xl-45px {
    max-width: 45px !important;
  }
  .mw-xl-50px {
    max-width: 50px !important;
  }
  .mw-xl-55px {
    max-width: 55px !important;
  }
  .mw-xl-60px {
    max-width: 60px !important;
  }
  .mw-xl-65px {
    max-width: 65px !important;
  }
  .mw-xl-70px {
    max-width: 70px !important;
  }
  .mw-xl-75px {
    max-width: 75px !important;
  }
  .mw-xl-80px {
    max-width: 80px !important;
  }
  .mw-xl-85px {
    max-width: 85px !important;
  }
  .mw-xl-90px {
    max-width: 90px !important;
  }
  .mw-xl-95px {
    max-width: 95px !important;
  }
  .mw-xl-100px {
    max-width: 100px !important;
  }
  .mw-xl-125px {
    max-width: 125px !important;
  }
  .mw-xl-150px {
    max-width: 150px !important;
  }
  .mw-xl-175px {
    max-width: 175px !important;
  }
  .mw-xl-200px {
    max-width: 200px !important;
  }
  .mw-xl-225px {
    max-width: 225px !important;
  }
  .mw-xl-250px {
    max-width: 250px !important;
  }
  .mw-xl-275px {
    max-width: 275px !important;
  }
  .mw-xl-300px {
    max-width: 300px !important;
  }
  .mw-xl-325px {
    max-width: 325px !important;
  }
  .mw-xl-350px {
    max-width: 350px !important;
  }
  .mw-xl-375px {
    max-width: 375px !important;
  }
  .mw-xl-400px {
    max-width: 400px !important;
  }
  .mw-xl-425px {
    max-width: 425px !important;
  }
  .mw-xl-450px {
    max-width: 450px !important;
  }
  .mw-xl-475px {
    max-width: 475px !important;
  }
  .mw-xl-500px {
    max-width: 500px !important;
  }
  .mw-xl-550px {
    max-width: 550px !important;
  }
  .mw-xl-600px {
    max-width: 600px !important;
  }
  .mw-xl-650px {
    max-width: 650px !important;
  }
  .mw-xl-700px {
    max-width: 700px !important;
  }
  .mw-xl-750px {
    max-width: 750px !important;
  }
  .mw-xl-800px {
    max-width: 800px !important;
  }
  .mw-xl-850px {
    max-width: 850px !important;
  }
  .mw-xl-900px {
    max-width: 900px !important;
  }
  .mw-xl-950px {
    max-width: 950px !important;
  }
  .mw-xl-1000px {
    max-width: 1000px !important;
  }
  .h-xl-unset {
    height: unset !important;
  }
  .h-xl-25 {
    height: 25% !important;
  }
  .h-xl-50 {
    height: 50% !important;
  }
  .h-xl-75 {
    height: 75% !important;
  }
  .h-xl-100 {
    height: 100% !important;
  }
  .h-xl-auto {
    height: auto !important;
  }
  .h-xl-1px {
    height: 1px !important;
  }
  .h-xl-2px {
    height: 2px !important;
  }
  .h-xl-3px {
    height: 3px !important;
  }
  .h-xl-4px {
    height: 4px !important;
  }
  .h-xl-5px {
    height: 5px !important;
  }
  .h-xl-6px {
    height: 6px !important;
  }
  .h-xl-7px {
    height: 7px !important;
  }
  .h-xl-8px {
    height: 8px !important;
  }
  .h-xl-9px {
    height: 9px !important;
  }
  .h-xl-10px {
    height: 10px !important;
  }
  .h-xl-15px {
    height: 15px !important;
  }
  .h-xl-20px {
    height: 20px !important;
  }
  .h-xl-25px {
    height: 25px !important;
  }
  .h-xl-30px {
    height: 30px !important;
  }
  .h-xl-35px {
    height: 35px !important;
  }
  .h-xl-40px {
    height: 40px !important;
  }
  .h-xl-45px {
    height: 45px !important;
  }
  .h-xl-50px {
    height: 50px !important;
  }
  .h-xl-55px {
    height: 55px !important;
  }
  .h-xl-60px {
    height: 60px !important;
  }
  .h-xl-65px {
    height: 65px !important;
  }
  .h-xl-70px {
    height: 70px !important;
  }
  .h-xl-75px {
    height: 75px !important;
  }
  .h-xl-80px {
    height: 80px !important;
  }
  .h-xl-85px {
    height: 85px !important;
  }
  .h-xl-90px {
    height: 90px !important;
  }
  .h-xl-95px {
    height: 95px !important;
  }
  .h-xl-100px {
    height: 100px !important;
  }
  .h-xl-125px {
    height: 125px !important;
  }
  .h-xl-150px {
    height: 150px !important;
  }
  .h-xl-175px {
    height: 175px !important;
  }
  .h-xl-200px {
    height: 200px !important;
  }
  .h-xl-225px {
    height: 225px !important;
  }
  .h-xl-250px {
    height: 250px !important;
  }
  .h-xl-275px {
    height: 275px !important;
  }
  .h-xl-300px {
    height: 300px !important;
  }
  .h-xl-325px {
    height: 325px !important;
  }
  .h-xl-350px {
    height: 350px !important;
  }
  .h-xl-375px {
    height: 375px !important;
  }
  .h-xl-400px {
    height: 400px !important;
  }
  .h-xl-425px {
    height: 425px !important;
  }
  .h-xl-450px {
    height: 450px !important;
  }
  .h-xl-475px {
    height: 475px !important;
  }
  .h-xl-500px {
    height: 500px !important;
  }
  .h-xl-550px {
    height: 550px !important;
  }
  .h-xl-600px {
    height: 600px !important;
  }
  .h-xl-650px {
    height: 650px !important;
  }
  .h-xl-700px {
    height: 700px !important;
  }
  .h-xl-750px {
    height: 750px !important;
  }
  .h-xl-800px {
    height: 800px !important;
  }
  .h-xl-850px {
    height: 850px !important;
  }
  .h-xl-900px {
    height: 900px !important;
  }
  .h-xl-950px {
    height: 950px !important;
  }
  .h-xl-1000px {
    height: 1000px !important;
  }
  .mh-xl-unset {
    max-height: unset !important;
  }
  .mh-xl-25 {
    max-height: 25% !important;
  }
  .mh-xl-50 {
    max-height: 50% !important;
  }
  .mh-xl-75 {
    max-height: 75% !important;
  }
  .mh-xl-100 {
    max-height: 100% !important;
  }
  .mh-xl-auto {
    max-height: auto !important;
  }
  .mh-xl-1px {
    max-height: 1px !important;
  }
  .mh-xl-2px {
    max-height: 2px !important;
  }
  .mh-xl-3px {
    max-height: 3px !important;
  }
  .mh-xl-4px {
    max-height: 4px !important;
  }
  .mh-xl-5px {
    max-height: 5px !important;
  }
  .mh-xl-6px {
    max-height: 6px !important;
  }
  .mh-xl-7px {
    max-height: 7px !important;
  }
  .mh-xl-8px {
    max-height: 8px !important;
  }
  .mh-xl-9px {
    max-height: 9px !important;
  }
  .mh-xl-10px {
    max-height: 10px !important;
  }
  .mh-xl-15px {
    max-height: 15px !important;
  }
  .mh-xl-20px {
    max-height: 20px !important;
  }
  .mh-xl-25px {
    max-height: 25px !important;
  }
  .mh-xl-30px {
    max-height: 30px !important;
  }
  .mh-xl-35px {
    max-height: 35px !important;
  }
  .mh-xl-40px {
    max-height: 40px !important;
  }
  .mh-xl-45px {
    max-height: 45px !important;
  }
  .mh-xl-50px {
    max-height: 50px !important;
  }
  .mh-xl-55px {
    max-height: 55px !important;
  }
  .mh-xl-60px {
    max-height: 60px !important;
  }
  .mh-xl-65px {
    max-height: 65px !important;
  }
  .mh-xl-70px {
    max-height: 70px !important;
  }
  .mh-xl-75px {
    max-height: 75px !important;
  }
  .mh-xl-80px {
    max-height: 80px !important;
  }
  .mh-xl-85px {
    max-height: 85px !important;
  }
  .mh-xl-90px {
    max-height: 90px !important;
  }
  .mh-xl-95px {
    max-height: 95px !important;
  }
  .mh-xl-100px {
    max-height: 100px !important;
  }
  .mh-xl-125px {
    max-height: 125px !important;
  }
  .mh-xl-150px {
    max-height: 150px !important;
  }
  .mh-xl-175px {
    max-height: 175px !important;
  }
  .mh-xl-200px {
    max-height: 200px !important;
  }
  .mh-xl-225px {
    max-height: 225px !important;
  }
  .mh-xl-250px {
    max-height: 250px !important;
  }
  .mh-xl-275px {
    max-height: 275px !important;
  }
  .mh-xl-300px {
    max-height: 300px !important;
  }
  .mh-xl-325px {
    max-height: 325px !important;
  }
  .mh-xl-350px {
    max-height: 350px !important;
  }
  .mh-xl-375px {
    max-height: 375px !important;
  }
  .mh-xl-400px {
    max-height: 400px !important;
  }
  .mh-xl-425px {
    max-height: 425px !important;
  }
  .mh-xl-450px {
    max-height: 450px !important;
  }
  .mh-xl-475px {
    max-height: 475px !important;
  }
  .mh-xl-500px {
    max-height: 500px !important;
  }
  .mh-xl-550px {
    max-height: 550px !important;
  }
  .mh-xl-600px {
    max-height: 600px !important;
  }
  .mh-xl-650px {
    max-height: 650px !important;
  }
  .mh-xl-700px {
    max-height: 700px !important;
  }
  .mh-xl-750px {
    max-height: 750px !important;
  }
  .mh-xl-800px {
    max-height: 800px !important;
  }
  .mh-xl-850px {
    max-height: 850px !important;
  }
  .mh-xl-900px {
    max-height: 900px !important;
  }
  .mh-xl-950px {
    max-height: 950px !important;
  }
  .mh-xl-1000px {
    max-height: 1000px !important;
  }
  .flex-xl-fill {
    flex: 1 1 auto !important;
  }
  .flex-xl-row {
    flex-direction: row !important;
  }
  .flex-xl-column {
    flex-direction: column !important;
  }
  .flex-xl-row-reverse {
    flex-direction: row-reverse !important;
  }
  .flex-xl-column-reverse {
    flex-direction: column-reverse !important;
  }
  .flex-xl-grow-0 {
    flex-grow: 0 !important;
  }
  .flex-xl-grow-1 {
    flex-grow: 1 !important;
  }
  .flex-xl-shrink-0 {
    flex-shrink: 0 !important;
  }
  .flex-xl-shrink-1 {
    flex-shrink: 1 !important;
  }
  .flex-xl-wrap {
    flex-wrap: wrap !important;
  }
  .flex-xl-nowrap {
    flex-wrap: nowrap !important;
  }
  .flex-xl-wrap-reverse {
    flex-wrap: wrap-reverse !important;
  }
  .justify-content-xl-start {
    justify-content: flex-start !important;
  }
  .justify-content-xl-end {
    justify-content: flex-end !important;
  }
  .justify-content-xl-center {
    justify-content: center !important;
  }
  .justify-content-xl-between {
    justify-content: space-between !important;
  }
  .justify-content-xl-around {
    justify-content: space-around !important;
  }
  .justify-content-xl-evenly {
    justify-content: space-evenly !important;
  }
  .align-items-xl-start {
    align-items: flex-start !important;
  }
  .align-items-xl-end {
    align-items: flex-end !important;
  }
  .align-items-xl-center {
    align-items: center !important;
  }
  .align-items-xl-baseline {
    align-items: baseline !important;
  }
  .align-items-xl-stretch {
    align-items: stretch !important;
  }
  .align-content-xl-start {
    align-content: flex-start !important;
  }
  .align-content-xl-end {
    align-content: flex-end !important;
  }
  .align-content-xl-center {
    align-content: center !important;
  }
  .align-content-xl-between {
    align-content: space-between !important;
  }
  .align-content-xl-around {
    align-content: space-around !important;
  }
  .align-content-xl-stretch {
    align-content: stretch !important;
  }
  .align-self-xl-auto {
    align-self: auto !important;
  }
  .align-self-xl-start {
    align-self: flex-start !important;
  }
  .align-self-xl-end {
    align-self: flex-end !important;
  }
  .align-self-xl-center {
    align-self: center !important;
  }
  .align-self-xl-baseline {
    align-self: baseline !important;
  }
  .align-self-xl-stretch {
    align-self: stretch !important;
  }
  .order-xl-first {
    order: -1 !important;
  }
  .order-xl-0 {
    order: 0 !important;
  }
  .order-xl-1 {
    order: 1 !important;
  }
  .order-xl-2 {
    order: 2 !important;
  }
  .order-xl-3 {
    order: 3 !important;
  }
  .order-xl-4 {
    order: 4 !important;
  }
  .order-xl-5 {
    order: 5 !important;
  }
  .order-xl-last {
    order: 6 !important;
  }
  .m-xl-0 {
    margin: 0 !important;
  }
  .m-xl-1 {
    margin: 0.25rem !important;
  }
  .m-xl-2 {
    margin: 0.5rem !important;
  }
  .m-xl-3 {
    margin: 0.75rem !important;
  }
  .m-xl-4 {
    margin: 1rem !important;
  }
  .m-xl-5 {
    margin: 1.25rem !important;
  }
  .m-xl-6 {
    margin: 1.5rem !important;
  }
  .m-xl-7 {
    margin: 1.75rem !important;
  }
  .m-xl-8 {
    margin: 2rem !important;
  }
  .m-xl-9 {
    margin: 2.25rem !important;
  }
  .m-xl-10 {
    margin: 2.5rem !important;
  }
  .m-xl-11 {
    margin: 2.75rem !important;
  }
  .m-xl-12 {
    margin: 3rem !important;
  }
  .m-xl-13 {
    margin: 3.25rem !important;
  }
  .m-xl-14 {
    margin: 3.5rem !important;
  }
  .m-xl-15 {
    margin: 3.75rem !important;
  }
  .m-xl-16 {
    margin: 4rem !important;
  }
  .m-xl-17 {
    margin: 4.25rem !important;
  }
  .m-xl-18 {
    margin: 4.5rem !important;
  }
  .m-xl-19 {
    margin: 4.75rem !important;
  }
  .m-xl-20 {
    margin: 5rem !important;
  }
  .m-xl-auto {
    margin: auto !important;
  }
  .mx-xl-0 {
    margin-right: 0 !important;
    margin-left: 0 !important;
  }
  .mx-xl-1 {
    margin-right: 0.25rem !important;
    margin-left: 0.25rem !important;
  }
  .mx-xl-2 {
    margin-right: 0.5rem !important;
    margin-left: 0.5rem !important;
  }
  .mx-xl-3 {
    margin-right: 0.75rem !important;
    margin-left: 0.75rem !important;
  }
  .mx-xl-4 {
    margin-right: 1rem !important;
    margin-left: 1rem !important;
  }
  .mx-xl-5 {
    margin-right: 1.25rem !important;
    margin-left: 1.25rem !important;
  }
  .mx-xl-6 {
    margin-right: 1.5rem !important;
    margin-left: 1.5rem !important;
  }
  .mx-xl-7 {
    margin-right: 1.75rem !important;
    margin-left: 1.75rem !important;
  }
  .mx-xl-8 {
    margin-right: 2rem !important;
    margin-left: 2rem !important;
  }
  .mx-xl-9 {
    margin-right: 2.25rem !important;
    margin-left: 2.25rem !important;
  }
  .mx-xl-10 {
    margin-right: 2.5rem !important;
    margin-left: 2.5rem !important;
  }
  .mx-xl-11 {
    margin-right: 2.75rem !important;
    margin-left: 2.75rem !important;
  }
  .mx-xl-12 {
    margin-right: 3rem !important;
    margin-left: 3rem !important;
  }
  .mx-xl-13 {
    margin-right: 3.25rem !important;
    margin-left: 3.25rem !important;
  }
  .mx-xl-14 {
    margin-right: 3.5rem !important;
    margin-left: 3.5rem !important;
  }
  .mx-xl-15 {
    margin-right: 3.75rem !important;
    margin-left: 3.75rem !important;
  }
  .mx-xl-16 {
    margin-right: 4rem !important;
    margin-left: 4rem !important;
  }
  .mx-xl-17 {
    margin-right: 4.25rem !important;
    margin-left: 4.25rem !important;
  }
  .mx-xl-18 {
    margin-right: 4.5rem !important;
    margin-left: 4.5rem !important;
  }
  .mx-xl-19 {
    margin-right: 4.75rem !important;
    margin-left: 4.75rem !important;
  }
  .mx-xl-20 {
    margin-right: 5rem !important;
    margin-left: 5rem !important;
  }
  .mx-xl-auto {
    margin-right: auto !important;
    margin-left: auto !important;
  }
  .my-xl-0 {
    margin-top: 0 !important;
    margin-bottom: 0 !important;
  }
  .my-xl-1 {
    margin-top: 0.25rem !important;
    margin-bottom: 0.25rem !important;
  }
  .my-xl-2 {
    margin-top: 0.5rem !important;
    margin-bottom: 0.5rem !important;
  }
  .my-xl-3 {
    margin-top: 0.75rem !important;
    margin-bottom: 0.75rem !important;
  }
  .my-xl-4 {
    margin-top: 1rem !important;
    margin-bottom: 1rem !important;
  }
  .my-xl-5 {
    margin-top: 1.25rem !important;
    margin-bottom: 1.25rem !important;
  }
  .my-xl-6 {
    margin-top: 1.5rem !important;
    margin-bottom: 1.5rem !important;
  }
  .my-xl-7 {
    margin-top: 1.75rem !important;
    margin-bottom: 1.75rem !important;
  }
  .my-xl-8 {
    margin-top: 2rem !important;
    margin-bottom: 2rem !important;
  }
  .my-xl-9 {
    margin-top: 2.25rem !important;
    margin-bottom: 2.25rem !important;
  }
  .my-xl-10 {
    margin-top: 2.5rem !important;
    margin-bottom: 2.5rem !important;
  }
  .my-xl-11 {
    margin-top: 2.75rem !important;
    margin-bottom: 2.75rem !important;
  }
  .my-xl-12 {
    margin-top: 3rem !important;
    margin-bottom: 3rem !important;
  }
  .my-xl-13 {
    margin-top: 3.25rem !important;
    margin-bottom: 3.25rem !important;
  }
  .my-xl-14 {
    margin-top: 3.5rem !important;
    margin-bottom: 3.5rem !important;
  }
  .my-xl-15 {
    margin-top: 3.75rem !important;
    margin-bottom: 3.75rem !important;
  }
  .my-xl-16 {
    margin-top: 4rem !important;
    margin-bottom: 4rem !important;
  }
  .my-xl-17 {
    margin-top: 4.25rem !important;
    margin-bottom: 4.25rem !important;
  }
  .my-xl-18 {
    margin-top: 4.5rem !important;
    margin-bottom: 4.5rem !important;
  }
  .my-xl-19 {
    margin-top: 4.75rem !important;
    margin-bottom: 4.75rem !important;
  }
  .my-xl-20 {
    margin-top: 5rem !important;
    margin-bottom: 5rem !important;
  }
  .my-xl-auto {
    margin-top: auto !important;
    margin-bottom: auto !important;
  }
  .mt-xl-0 {
    margin-top: 0 !important;
  }
  .mt-xl-1 {
    margin-top: 0.25rem !important;
  }
  .mt-xl-2 {
    margin-top: 0.5rem !important;
  }
  .mt-xl-3 {
    margin-top: 0.75rem !important;
  }
  .mt-xl-4 {
    margin-top: 1rem !important;
  }
  .mt-xl-5 {
    margin-top: 1.25rem !important;
  }
  .mt-xl-6 {
    margin-top: 1.5rem !important;
  }
  .mt-xl-7 {
    margin-top: 1.75rem !important;
  }
  .mt-xl-8 {
    margin-top: 2rem !important;
  }
  .mt-xl-9 {
    margin-top: 2.25rem !important;
  }
  .mt-xl-10 {
    margin-top: 2.5rem !important;
  }
  .mt-xl-11 {
    margin-top: 2.75rem !important;
  }
  .mt-xl-12 {
    margin-top: 3rem !important;
  }
  .mt-xl-13 {
    margin-top: 3.25rem !important;
  }
  .mt-xl-14 {
    margin-top: 3.5rem !important;
  }
  .mt-xl-15 {
    margin-top: 3.75rem !important;
  }
  .mt-xl-16 {
    margin-top: 4rem !important;
  }
  .mt-xl-17 {
    margin-top: 4.25rem !important;
  }
  .mt-xl-18 {
    margin-top: 4.5rem !important;
  }
  .mt-xl-19 {
    margin-top: 4.75rem !important;
  }
  .mt-xl-20 {
    margin-top: 5rem !important;
  }
  .mt-xl-auto {
    margin-top: auto !important;
  }
  .me-xl-0 {
    margin-right: 0 !important;
  }
  .me-xl-1 {
    margin-right: 0.25rem !important;
  }
  .me-xl-2 {
    margin-right: 0.5rem !important;
  }
  .me-xl-3 {
    margin-right: 0.75rem !important;
  }
  .me-xl-4 {
    margin-right: 1rem !important;
  }
  .me-xl-5 {
    margin-right: 1.25rem !important;
  }
  .me-xl-6 {
    margin-right: 1.5rem !important;
  }
  .me-xl-7 {
    margin-right: 1.75rem !important;
  }
  .me-xl-8 {
    margin-right: 2rem !important;
  }
  .me-xl-9 {
    margin-right: 2.25rem !important;
  }
  .me-xl-10 {
    margin-right: 2.5rem !important;
  }
  .me-xl-11 {
    margin-right: 2.75rem !important;
  }
  .me-xl-12 {
    margin-right: 3rem !important;
  }
  .me-xl-13 {
    margin-right: 3.25rem !important;
  }
  .me-xl-14 {
    margin-right: 3.5rem !important;
  }
  .me-xl-15 {
    margin-right: 3.75rem !important;
  }
  .me-xl-16 {
    margin-right: 4rem !important;
  }
  .me-xl-17 {
    margin-right: 4.25rem !important;
  }
  .me-xl-18 {
    margin-right: 4.5rem !important;
  }
  .me-xl-19 {
    margin-right: 4.75rem !important;
  }
  .me-xl-20 {
    margin-right: 5rem !important;
  }
  .me-xl-auto {
    margin-right: auto !important;
  }
  .mb-xl-0 {
    margin-bottom: 0 !important;
  }
  .mb-xl-1 {
    margin-bottom: 0.25rem !important;
  }
  .mb-xl-2 {
    margin-bottom: 0.5rem !important;
  }
  .mb-xl-3 {
    margin-bottom: 0.75rem !important;
  }
  .mb-xl-4 {
    margin-bottom: 1rem !important;
  }
  .mb-xl-5 {
    margin-bottom: 1.25rem !important;
  }
  .mb-xl-6 {
    margin-bottom: 1.5rem !important;
  }
  .mb-xl-7 {
    margin-bottom: 1.75rem !important;
  }
  .mb-xl-8 {
    margin-bottom: 2rem !important;
  }
  .mb-xl-9 {
    margin-bottom: 2.25rem !important;
  }
  .mb-xl-10 {
    margin-bottom: 2.5rem !important;
  }
  .mb-xl-11 {
    margin-bottom: 2.75rem !important;
  }
  .mb-xl-12 {
    margin-bottom: 3rem !important;
  }
  .mb-xl-13 {
    margin-bottom: 3.25rem !important;
  }
  .mb-xl-14 {
    margin-bottom: 3.5rem !important;
  }
  .mb-xl-15 {
    margin-bottom: 3.75rem !important;
  }
  .mb-xl-16 {
    margin-bottom: 4rem !important;
  }
  .mb-xl-17 {
    margin-bottom: 4.25rem !important;
  }
  .mb-xl-18 {
    margin-bottom: 4.5rem !important;
  }
  .mb-xl-19 {
    margin-bottom: 4.75rem !important;
  }
  .mb-xl-20 {
    margin-bottom: 5rem !important;
  }
  .mb-xl-auto {
    margin-bottom: auto !important;
  }
  .ms-xl-0 {
    margin-left: 0 !important;
  }
  .ms-xl-1 {
    margin-left: 0.25rem !important;
  }
  .ms-xl-2 {
    margin-left: 0.5rem !important;
  }
  .ms-xl-3 {
    margin-left: 0.75rem !important;
  }
  .ms-xl-4 {
    margin-left: 1rem !important;
  }
  .ms-xl-5 {
    margin-left: 1.25rem !important;
  }
  .ms-xl-6 {
    margin-left: 1.5rem !important;
  }
  .ms-xl-7 {
    margin-left: 1.75rem !important;
  }
  .ms-xl-8 {
    margin-left: 2rem !important;
  }
  .ms-xl-9 {
    margin-left: 2.25rem !important;
  }
  .ms-xl-10 {
    margin-left: 2.5rem !important;
  }
  .ms-xl-11 {
    margin-left: 2.75rem !important;
  }
  .ms-xl-12 {
    margin-left: 3rem !important;
  }
  .ms-xl-13 {
    margin-left: 3.25rem !important;
  }
  .ms-xl-14 {
    margin-left: 3.5rem !important;
  }
  .ms-xl-15 {
    margin-left: 3.75rem !important;
  }
  .ms-xl-16 {
    margin-left: 4rem !important;
  }
  .ms-xl-17 {
    margin-left: 4.25rem !important;
  }
  .ms-xl-18 {
    margin-left: 4.5rem !important;
  }
  .ms-xl-19 {
    margin-left: 4.75rem !important;
  }
  .ms-xl-20 {
    margin-left: 5rem !important;
  }
  .ms-xl-auto {
    margin-left: auto !important;
  }
  .m-xl-n1 {
    margin: -0.25rem !important;
  }
  .m-xl-n2 {
    margin: -0.5rem !important;
  }
  .m-xl-n3 {
    margin: -0.75rem !important;
  }
  .m-xl-n4 {
    margin: -1rem !important;
  }
  .m-xl-n5 {
    margin: -1.25rem !important;
  }
  .m-xl-n6 {
    margin: -1.5rem !important;
  }
  .m-xl-n7 {
    margin: -1.75rem !important;
  }
  .m-xl-n8 {
    margin: -2rem !important;
  }
  .m-xl-n9 {
    margin: -2.25rem !important;
  }
  .m-xl-n10 {
    margin: -2.5rem !important;
  }
  .m-xl-n11 {
    margin: -2.75rem !important;
  }
  .m-xl-n12 {
    margin: -3rem !important;
  }
  .m-xl-n13 {
    margin: -3.25rem !important;
  }
  .m-xl-n14 {
    margin: -3.5rem !important;
  }
  .m-xl-n15 {
    margin: -3.75rem !important;
  }
  .m-xl-n16 {
    margin: -4rem !important;
  }
  .m-xl-n17 {
    margin: -4.25rem !important;
  }
  .m-xl-n18 {
    margin: -4.5rem !important;
  }
  .m-xl-n19 {
    margin: -4.75rem !important;
  }
  .m-xl-n20 {
    margin: -5rem !important;
  }
  .mx-xl-n1 {
    margin-right: -0.25rem !important;
    margin-left: -0.25rem !important;
  }
  .mx-xl-n2 {
    margin-right: -0.5rem !important;
    margin-left: -0.5rem !important;
  }
  .mx-xl-n3 {
    margin-right: -0.75rem !important;
    margin-left: -0.75rem !important;
  }
  .mx-xl-n4 {
    margin-right: -1rem !important;
    margin-left: -1rem !important;
  }
  .mx-xl-n5 {
    margin-right: -1.25rem !important;
    margin-left: -1.25rem !important;
  }
  .mx-xl-n6 {
    margin-right: -1.5rem !important;
    margin-left: -1.5rem !important;
  }
  .mx-xl-n7 {
    margin-right: -1.75rem !important;
    margin-left: -1.75rem !important;
  }
  .mx-xl-n8 {
    margin-right: -2rem !important;
    margin-left: -2rem !important;
  }
  .mx-xl-n9 {
    margin-right: -2.25rem !important;
    margin-left: -2.25rem !important;
  }
  .mx-xl-n10 {
    margin-right: -2.5rem !important;
    margin-left: -2.5rem !important;
  }
  .mx-xl-n11 {
    margin-right: -2.75rem !important;
    margin-left: -2.75rem !important;
  }
  .mx-xl-n12 {
    margin-right: -3rem !important;
    margin-left: -3rem !important;
  }
  .mx-xl-n13 {
    margin-right: -3.25rem !important;
    margin-left: -3.25rem !important;
  }
  .mx-xl-n14 {
    margin-right: -3.5rem !important;
    margin-left: -3.5rem !important;
  }
  .mx-xl-n15 {
    margin-right: -3.75rem !important;
    margin-left: -3.75rem !important;
  }
  .mx-xl-n16 {
    margin-right: -4rem !important;
    margin-left: -4rem !important;
  }
  .mx-xl-n17 {
    margin-right: -4.25rem !important;
    margin-left: -4.25rem !important;
  }
  .mx-xl-n18 {
    margin-right: -4.5rem !important;
    margin-left: -4.5rem !important;
  }
  .mx-xl-n19 {
    margin-right: -4.75rem !important;
    margin-left: -4.75rem !important;
  }
  .mx-xl-n20 {
    margin-right: -5rem !important;
    margin-left: -5rem !important;
  }
  .my-xl-n1 {
    margin-top: -0.25rem !important;
    margin-bottom: -0.25rem !important;
  }
  .my-xl-n2 {
    margin-top: -0.5rem !important;
    margin-bottom: -0.5rem !important;
  }
  .my-xl-n3 {
    margin-top: -0.75rem !important;
    margin-bottom: -0.75rem !important;
  }
  .my-xl-n4 {
    margin-top: -1rem !important;
    margin-bottom: -1rem !important;
  }
  .my-xl-n5 {
    margin-top: -1.25rem !important;
    margin-bottom: -1.25rem !important;
  }
  .my-xl-n6 {
    margin-top: -1.5rem !important;
    margin-bottom: -1.5rem !important;
  }
  .my-xl-n7 {
    margin-top: -1.75rem !important;
    margin-bottom: -1.75rem !important;
  }
  .my-xl-n8 {
    margin-top: -2rem !important;
    margin-bottom: -2rem !important;
  }
  .my-xl-n9 {
    margin-top: -2.25rem !important;
    margin-bottom: -2.25rem !important;
  }
  .my-xl-n10 {
    margin-top: -2.5rem !important;
    margin-bottom: -2.5rem !important;
  }
  .my-xl-n11 {
    margin-top: -2.75rem !important;
    margin-bottom: -2.75rem !important;
  }
  .my-xl-n12 {
    margin-top: -3rem !important;
    margin-bottom: -3rem !important;
  }
  .my-xl-n13 {
    margin-top: -3.25rem !important;
    margin-bottom: -3.25rem !important;
  }
  .my-xl-n14 {
    margin-top: -3.5rem !important;
    margin-bottom: -3.5rem !important;
  }
  .my-xl-n15 {
    margin-top: -3.75rem !important;
    margin-bottom: -3.75rem !important;
  }
  .my-xl-n16 {
    margin-top: -4rem !important;
    margin-bottom: -4rem !important;
  }
  .my-xl-n17 {
    margin-top: -4.25rem !important;
    margin-bottom: -4.25rem !important;
  }
  .my-xl-n18 {
    margin-top: -4.5rem !important;
    margin-bottom: -4.5rem !important;
  }
  .my-xl-n19 {
    margin-top: -4.75rem !important;
    margin-bottom: -4.75rem !important;
  }
  .my-xl-n20 {
    margin-top: -5rem !important;
    margin-bottom: -5rem !important;
  }
  .mt-xl-n1 {
    margin-top: -0.25rem !important;
  }
  .mt-xl-n2 {
    margin-top: -0.5rem !important;
  }
  .mt-xl-n3 {
    margin-top: -0.75rem !important;
  }
  .mt-xl-n4 {
    margin-top: -1rem !important;
  }
  .mt-xl-n5 {
    margin-top: -1.25rem !important;
  }
  .mt-xl-n6 {
    margin-top: -1.5rem !important;
  }
  .mt-xl-n7 {
    margin-top: -1.75rem !important;
  }
  .mt-xl-n8 {
    margin-top: -2rem !important;
  }
  .mt-xl-n9 {
    margin-top: -2.25rem !important;
  }
  .mt-xl-n10 {
    margin-top: -2.5rem !important;
  }
  .mt-xl-n11 {
    margin-top: -2.75rem !important;
  }
  .mt-xl-n12 {
    margin-top: -3rem !important;
  }
  .mt-xl-n13 {
    margin-top: -3.25rem !important;
  }
  .mt-xl-n14 {
    margin-top: -3.5rem !important;
  }
  .mt-xl-n15 {
    margin-top: -3.75rem !important;
  }
  .mt-xl-n16 {
    margin-top: -4rem !important;
  }
  .mt-xl-n17 {
    margin-top: -4.25rem !important;
  }
  .mt-xl-n18 {
    margin-top: -4.5rem !important;
  }
  .mt-xl-n19 {
    margin-top: -4.75rem !important;
  }
  .mt-xl-n20 {
    margin-top: -5rem !important;
  }
  .me-xl-n1 {
    margin-right: -0.25rem !important;
  }
  .me-xl-n2 {
    margin-right: -0.5rem !important;
  }
  .me-xl-n3 {
    margin-right: -0.75rem !important;
  }
  .me-xl-n4 {
    margin-right: -1rem !important;
  }
  .me-xl-n5 {
    margin-right: -1.25rem !important;
  }
  .me-xl-n6 {
    margin-right: -1.5rem !important;
  }
  .me-xl-n7 {
    margin-right: -1.75rem !important;
  }
  .me-xl-n8 {
    margin-right: -2rem !important;
  }
  .me-xl-n9 {
    margin-right: -2.25rem !important;
  }
  .me-xl-n10 {
    margin-right: -2.5rem !important;
  }
  .me-xl-n11 {
    margin-right: -2.75rem !important;
  }
  .me-xl-n12 {
    margin-right: -3rem !important;
  }
  .me-xl-n13 {
    margin-right: -3.25rem !important;
  }
  .me-xl-n14 {
    margin-right: -3.5rem !important;
  }
  .me-xl-n15 {
    margin-right: -3.75rem !important;
  }
  .me-xl-n16 {
    margin-right: -4rem !important;
  }
  .me-xl-n17 {
    margin-right: -4.25rem !important;
  }
  .me-xl-n18 {
    margin-right: -4.5rem !important;
  }
  .me-xl-n19 {
    margin-right: -4.75rem !important;
  }
  .me-xl-n20 {
    margin-right: -5rem !important;
  }
  .mb-xl-n1 {
    margin-bottom: -0.25rem !important;
  }
  .mb-xl-n2 {
    margin-bottom: -0.5rem !important;
  }
  .mb-xl-n3 {
    margin-bottom: -0.75rem !important;
  }
  .mb-xl-n4 {
    margin-bottom: -1rem !important;
  }
  .mb-xl-n5 {
    margin-bottom: -1.25rem !important;
  }
  .mb-xl-n6 {
    margin-bottom: -1.5rem !important;
  }
  .mb-xl-n7 {
    margin-bottom: -1.75rem !important;
  }
  .mb-xl-n8 {
    margin-bottom: -2rem !important;
  }
  .mb-xl-n9 {
    margin-bottom: -2.25rem !important;
  }
  .mb-xl-n10 {
    margin-bottom: -2.5rem !important;
  }
  .mb-xl-n11 {
    margin-bottom: -2.75rem !important;
  }
  .mb-xl-n12 {
    margin-bottom: -3rem !important;
  }
  .mb-xl-n13 {
    margin-bottom: -3.25rem !important;
  }
  .mb-xl-n14 {
    margin-bottom: -3.5rem !important;
  }
  .mb-xl-n15 {
    margin-bottom: -3.75rem !important;
  }
  .mb-xl-n16 {
    margin-bottom: -4rem !important;
  }
  .mb-xl-n17 {
    margin-bottom: -4.25rem !important;
  }
  .mb-xl-n18 {
    margin-bottom: -4.5rem !important;
  }
  .mb-xl-n19 {
    margin-bottom: -4.75rem !important;
  }
  .mb-xl-n20 {
    margin-bottom: -5rem !important;
  }
  .ms-xl-n1 {
    margin-left: -0.25rem !important;
  }
  .ms-xl-n2 {
    margin-left: -0.5rem !important;
  }
  .ms-xl-n3 {
    margin-left: -0.75rem !important;
  }
  .ms-xl-n4 {
    margin-left: -1rem !important;
  }
  .ms-xl-n5 {
    margin-left: -1.25rem !important;
  }
  .ms-xl-n6 {
    margin-left: -1.5rem !important;
  }
  .ms-xl-n7 {
    margin-left: -1.75rem !important;
  }
  .ms-xl-n8 {
    margin-left: -2rem !important;
  }
  .ms-xl-n9 {
    margin-left: -2.25rem !important;
  }
  .ms-xl-n10 {
    margin-left: -2.5rem !important;
  }
  .ms-xl-n11 {
    margin-left: -2.75rem !important;
  }
  .ms-xl-n12 {
    margin-left: -3rem !important;
  }
  .ms-xl-n13 {
    margin-left: -3.25rem !important;
  }
  .ms-xl-n14 {
    margin-left: -3.5rem !important;
  }
  .ms-xl-n15 {
    margin-left: -3.75rem !important;
  }
  .ms-xl-n16 {
    margin-left: -4rem !important;
  }
  .ms-xl-n17 {
    margin-left: -4.25rem !important;
  }
  .ms-xl-n18 {
    margin-left: -4.5rem !important;
  }
  .ms-xl-n19 {
    margin-left: -4.75rem !important;
  }
  .ms-xl-n20 {
    margin-left: -5rem !important;
  }
  .p-xl-0 {
    padding: 0 !important;
  }
  .p-xl-1 {
    padding: 0.25rem !important;
  }
  .p-xl-2 {
    padding: 0.5rem !important;
  }
  .p-xl-3 {
    padding: 0.75rem !important;
  }
  .p-xl-4 {
    padding: 1rem !important;
  }
  .p-xl-5 {
    padding: 1.25rem !important;
  }
  .p-xl-6 {
    padding: 1.5rem !important;
  }
  .p-xl-7 {
    padding: 1.75rem !important;
  }
  .p-xl-8 {
    padding: 2rem !important;
  }
  .p-xl-9 {
    padding: 2.25rem !important;
  }
  .p-xl-10 {
    padding: 2.5rem !important;
  }
  .p-xl-11 {
    padding: 2.75rem !important;
  }
  .p-xl-12 {
    padding: 3rem !important;
  }
  .p-xl-13 {
    padding: 3.25rem !important;
  }
  .p-xl-14 {
    padding: 3.5rem !important;
  }
  .p-xl-15 {
    padding: 3.75rem !important;
  }
  .p-xl-16 {
    padding: 4rem !important;
  }
  .p-xl-17 {
    padding: 4.25rem !important;
  }
  .p-xl-18 {
    padding: 4.5rem !important;
  }
  .p-xl-19 {
    padding: 4.75rem !important;
  }
  .p-xl-20 {
    padding: 5rem !important;
  }
  .px-xl-0 {
    padding-right: 0 !important;
    padding-left: 0 !important;
  }
  .px-xl-1 {
    padding-right: 0.25rem !important;
    padding-left: 0.25rem !important;
  }
  .px-xl-2 {
    padding-right: 0.5rem !important;
    padding-left: 0.5rem !important;
  }
  .px-xl-3 {
    padding-right: 0.75rem !important;
    padding-left: 0.75rem !important;
  }
  .px-xl-4 {
    padding-right: 1rem !important;
    padding-left: 1rem !important;
  }
  .px-xl-5 {
    padding-right: 1.25rem !important;
    padding-left: 1.25rem !important;
  }
  .px-xl-6 {
    padding-right: 1.5rem !important;
    padding-left: 1.5rem !important;
  }
  .px-xl-7 {
    padding-right: 1.75rem !important;
    padding-left: 1.75rem !important;
  }
  .px-xl-8 {
    padding-right: 2rem !important;
    padding-left: 2rem !important;
  }
  .px-xl-9 {
    padding-right: 2.25rem !important;
    padding-left: 2.25rem !important;
  }
  .px-xl-10 {
    padding-right: 2.5rem !important;
    padding-left: 2.5rem !important;
  }
  .px-xl-11 {
    padding-right: 2.75rem !important;
    padding-left: 2.75rem !important;
  }
  .px-xl-12 {
    padding-right: 3rem !important;
    padding-left: 3rem !important;
  }
  .px-xl-13 {
    padding-right: 3.25rem !important;
    padding-left: 3.25rem !important;
  }
  .px-xl-14 {
    padding-right: 3.5rem !important;
    padding-left: 3.5rem !important;
  }
  .px-xl-15 {
    padding-right: 3.75rem !important;
    padding-left: 3.75rem !important;
  }
  .px-xl-16 {
    padding-right: 4rem !important;
    padding-left: 4rem !important;
  }
  .px-xl-17 {
    padding-right: 4.25rem !important;
    padding-left: 4.25rem !important;
  }
  .px-xl-18 {
    padding-right: 4.5rem !important;
    padding-left: 4.5rem !important;
  }
  .px-xl-19 {
    padding-right: 4.75rem !important;
    padding-left: 4.75rem !important;
  }
  .px-xl-20 {
    padding-right: 5rem !important;
    padding-left: 5rem !important;
  }
  .py-xl-0 {
    padding-top: 0 !important;
    padding-bottom: 0 !important;
  }
  .py-xl-1 {
    padding-top: 0.25rem !important;
    padding-bottom: 0.25rem !important;
  }
  .py-xl-2 {
    padding-top: 0.5rem !important;
    padding-bottom: 0.5rem !important;
  }
  .py-xl-3 {
    padding-top: 0.75rem !important;
    padding-bottom: 0.75rem !important;
  }
  .py-xl-4 {
    padding-top: 1rem !important;
    padding-bottom: 1rem !important;
  }
  .py-xl-5 {
    padding-top: 1.25rem !important;
    padding-bottom: 1.25rem !important;
  }
  .py-xl-6 {
    padding-top: 1.5rem !important;
    padding-bottom: 1.5rem !important;
  }
  .py-xl-7 {
    padding-top: 1.75rem !important;
    padding-bottom: 1.75rem !important;
  }
  .py-xl-8 {
    padding-top: 2rem !important;
    padding-bottom: 2rem !important;
  }
  .py-xl-9 {
    padding-top: 2.25rem !important;
    padding-bottom: 2.25rem !important;
  }
  .py-xl-10 {
    padding-top: 2.5rem !important;
    padding-bottom: 2.5rem !important;
  }
  .py-xl-11 {
    padding-top: 2.75rem !important;
    padding-bottom: 2.75rem !important;
  }
  .py-xl-12 {
    padding-top: 3rem !important;
    padding-bottom: 3rem !important;
  }
  .py-xl-13 {
    padding-top: 3.25rem !important;
    padding-bottom: 3.25rem !important;
  }
  .py-xl-14 {
    padding-top: 3.5rem !important;
    padding-bottom: 3.5rem !important;
  }
  .py-xl-15 {
    padding-top: 3.75rem !important;
    padding-bottom: 3.75rem !important;
  }
  .py-xl-16 {
    padding-top: 4rem !important;
    padding-bottom: 4rem !important;
  }
  .py-xl-17 {
    padding-top: 4.25rem !important;
    padding-bottom: 4.25rem !important;
  }
  .py-xl-18 {
    padding-top: 4.5rem !important;
    padding-bottom: 4.5rem !important;
  }
  .py-xl-19 {
    padding-top: 4.75rem !important;
    padding-bottom: 4.75rem !important;
  }
  .py-xl-20 {
    padding-top: 5rem !important;
    padding-bottom: 5rem !important;
  }
  .pt-xl-0 {
    padding-top: 0 !important;
  }
  .pt-xl-1 {
    padding-top: 0.25rem !important;
  }
  .pt-xl-2 {
    padding-top: 0.5rem !important;
  }
  .pt-xl-3 {
    padding-top: 0.75rem !important;
  }
  .pt-xl-4 {
    padding-top: 1rem !important;
  }
  .pt-xl-5 {
    padding-top: 1.25rem !important;
  }
  .pt-xl-6 {
    padding-top: 1.5rem !important;
  }
  .pt-xl-7 {
    padding-top: 1.75rem !important;
  }
  .pt-xl-8 {
    padding-top: 2rem !important;
  }
  .pt-xl-9 {
    padding-top: 2.25rem !important;
  }
  .pt-xl-10 {
    padding-top: 2.5rem !important;
  }
  .pt-xl-11 {
    padding-top: 2.75rem !important;
  }
  .pt-xl-12 {
    padding-top: 3rem !important;
  }
  .pt-xl-13 {
    padding-top: 3.25rem !important;
  }
  .pt-xl-14 {
    padding-top: 3.5rem !important;
  }
  .pt-xl-15 {
    padding-top: 3.75rem !important;
  }
  .pt-xl-16 {
    padding-top: 4rem !important;
  }
  .pt-xl-17 {
    padding-top: 4.25rem !important;
  }
  .pt-xl-18 {
    padding-top: 4.5rem !important;
  }
  .pt-xl-19 {
    padding-top: 4.75rem !important;
  }
  .pt-xl-20 {
    padding-top: 5rem !important;
  }
  .pe-xl-0 {
    padding-right: 0 !important;
  }
  .pe-xl-1 {
    padding-right: 0.25rem !important;
  }
  .pe-xl-2 {
    padding-right: 0.5rem !important;
  }
  .pe-xl-3 {
    padding-right: 0.75rem !important;
  }
  .pe-xl-4 {
    padding-right: 1rem !important;
  }
  .pe-xl-5 {
    padding-right: 1.25rem !important;
  }
  .pe-xl-6 {
    padding-right: 1.5rem !important;
  }
  .pe-xl-7 {
    padding-right: 1.75rem !important;
  }
  .pe-xl-8 {
    padding-right: 2rem !important;
  }
  .pe-xl-9 {
    padding-right: 2.25rem !important;
  }
  .pe-xl-10 {
    padding-right: 2.5rem !important;
  }
  .pe-xl-11 {
    padding-right: 2.75rem !important;
  }
  .pe-xl-12 {
    padding-right: 3rem !important;
  }
  .pe-xl-13 {
    padding-right: 3.25rem !important;
  }
  .pe-xl-14 {
    padding-right: 3.5rem !important;
  }
  .pe-xl-15 {
    padding-right: 3.75rem !important;
  }
  .pe-xl-16 {
    padding-right: 4rem !important;
  }
  .pe-xl-17 {
    padding-right: 4.25rem !important;
  }
  .pe-xl-18 {
    padding-right: 4.5rem !important;
  }
  .pe-xl-19 {
    padding-right: 4.75rem !important;
  }
  .pe-xl-20 {
    padding-right: 5rem !important;
  }
  .pb-xl-0 {
    padding-bottom: 0 !important;
  }
  .pb-xl-1 {
    padding-bottom: 0.25rem !important;
  }
  .pb-xl-2 {
    padding-bottom: 0.5rem !important;
  }
  .pb-xl-3 {
    padding-bottom: 0.75rem !important;
  }
  .pb-xl-4 {
    padding-bottom: 1rem !important;
  }
  .pb-xl-5 {
    padding-bottom: 1.25rem !important;
  }
  .pb-xl-6 {
    padding-bottom: 1.5rem !important;
  }
  .pb-xl-7 {
    padding-bottom: 1.75rem !important;
  }
  .pb-xl-8 {
    padding-bottom: 2rem !important;
  }
  .pb-xl-9 {
    padding-bottom: 2.25rem !important;
  }
  .pb-xl-10 {
    padding-bottom: 2.5rem !important;
  }
  .pb-xl-11 {
    padding-bottom: 2.75rem !important;
  }
  .pb-xl-12 {
    padding-bottom: 3rem !important;
  }
  .pb-xl-13 {
    padding-bottom: 3.25rem !important;
  }
  .pb-xl-14 {
    padding-bottom: 3.5rem !important;
  }
  .pb-xl-15 {
    padding-bottom: 3.75rem !important;
  }
  .pb-xl-16 {
    padding-bottom: 4rem !important;
  }
  .pb-xl-17 {
    padding-bottom: 4.25rem !important;
  }
  .pb-xl-18 {
    padding-bottom: 4.5rem !important;
  }
  .pb-xl-19 {
    padding-bottom: 4.75rem !important;
  }
  .pb-xl-20 {
    padding-bottom: 5rem !important;
  }
  .ps-xl-0 {
    padding-left: 0 !important;
  }
  .ps-xl-1 {
    padding-left: 0.25rem !important;
  }
  .ps-xl-2 {
    padding-left: 0.5rem !important;
  }
  .ps-xl-3 {
    padding-left: 0.75rem !important;
  }
  .ps-xl-4 {
    padding-left: 1rem !important;
  }
  .ps-xl-5 {
    padding-left: 1.25rem !important;
  }
  .ps-xl-6 {
    padding-left: 1.5rem !important;
  }
  .ps-xl-7 {
    padding-left: 1.75rem !important;
  }
  .ps-xl-8 {
    padding-left: 2rem !important;
  }
  .ps-xl-9 {
    padding-left: 2.25rem !important;
  }
  .ps-xl-10 {
    padding-left: 2.5rem !important;
  }
  .ps-xl-11 {
    padding-left: 2.75rem !important;
  }
  .ps-xl-12 {
    padding-left: 3rem !important;
  }
  .ps-xl-13 {
    padding-left: 3.25rem !important;
  }
  .ps-xl-14 {
    padding-left: 3.5rem !important;
  }
  .ps-xl-15 {
    padding-left: 3.75rem !important;
  }
  .ps-xl-16 {
    padding-left: 4rem !important;
  }
  .ps-xl-17 {
    padding-left: 4.25rem !important;
  }
  .ps-xl-18 {
    padding-left: 4.5rem !important;
  }
  .ps-xl-19 {
    padding-left: 4.75rem !important;
  }
  .ps-xl-20 {
    padding-left: 5rem !important;
  }
  .gap-xl-0 {
    gap: 0 !important;
  }
  .gap-xl-1 {
    gap: 0.25rem !important;
  }
  .gap-xl-2 {
    gap: 0.5rem !important;
  }
  .gap-xl-3 {
    gap: 0.75rem !important;
  }
  .gap-xl-4 {
    gap: 1rem !important;
  }
  .gap-xl-5 {
    gap: 1.25rem !important;
  }
  .gap-xl-6 {
    gap: 1.5rem !important;
  }
  .gap-xl-7 {
    gap: 1.75rem !important;
  }
  .gap-xl-8 {
    gap: 2rem !important;
  }
  .gap-xl-9 {
    gap: 2.25rem !important;
  }
  .gap-xl-10 {
    gap: 2.5rem !important;
  }
  .gap-xl-11 {
    gap: 2.75rem !important;
  }
  .gap-xl-12 {
    gap: 3rem !important;
  }
  .gap-xl-13 {
    gap: 3.25rem !important;
  }
  .gap-xl-14 {
    gap: 3.5rem !important;
  }
  .gap-xl-15 {
    gap: 3.75rem !important;
  }
  .gap-xl-16 {
    gap: 4rem !important;
  }
  .gap-xl-17 {
    gap: 4.25rem !important;
  }
  .gap-xl-18 {
    gap: 4.5rem !important;
  }
  .gap-xl-19 {
    gap: 4.75rem !important;
  }
  .gap-xl-20 {
    gap: 5rem !important;
  }
  .row-gap-xl-0 {
    row-gap: 0 !important;
  }
  .row-gap-xl-1 {
    row-gap: 0.25rem !important;
  }
  .row-gap-xl-2 {
    row-gap: 0.5rem !important;
  }
  .row-gap-xl-3 {
    row-gap: 0.75rem !important;
  }
  .row-gap-xl-4 {
    row-gap: 1rem !important;
  }
  .row-gap-xl-5 {
    row-gap: 1.25rem !important;
  }
  .row-gap-xl-6 {
    row-gap: 1.5rem !important;
  }
  .row-gap-xl-7 {
    row-gap: 1.75rem !important;
  }
  .row-gap-xl-8 {
    row-gap: 2rem !important;
  }
  .row-gap-xl-9 {
    row-gap: 2.25rem !important;
  }
  .row-gap-xl-10 {
    row-gap: 2.5rem !important;
  }
  .row-gap-xl-11 {
    row-gap: 2.75rem !important;
  }
  .row-gap-xl-12 {
    row-gap: 3rem !important;
  }
  .row-gap-xl-13 {
    row-gap: 3.25rem !important;
  }
  .row-gap-xl-14 {
    row-gap: 3.5rem !important;
  }
  .row-gap-xl-15 {
    row-gap: 3.75rem !important;
  }
  .row-gap-xl-16 {
    row-gap: 4rem !important;
  }
  .row-gap-xl-17 {
    row-gap: 4.25rem !important;
  }
  .row-gap-xl-18 {
    row-gap: 4.5rem !important;
  }
  .row-gap-xl-19 {
    row-gap: 4.75rem !important;
  }
  .row-gap-xl-20 {
    row-gap: 5rem !important;
  }
  .column-gap-xl-0 {
    column-gap: 0 !important;
  }
  .column-gap-xl-1 {
    column-gap: 0.25rem !important;
  }
  .column-gap-xl-2 {
    column-gap: 0.5rem !important;
  }
  .column-gap-xl-3 {
    column-gap: 0.75rem !important;
  }
  .column-gap-xl-4 {
    column-gap: 1rem !important;
  }
  .column-gap-xl-5 {
    column-gap: 1.25rem !important;
  }
  .column-gap-xl-6 {
    column-gap: 1.5rem !important;
  }
  .column-gap-xl-7 {
    column-gap: 1.75rem !important;
  }
  .column-gap-xl-8 {
    column-gap: 2rem !important;
  }
  .column-gap-xl-9 {
    column-gap: 2.25rem !important;
  }
  .column-gap-xl-10 {
    column-gap: 2.5rem !important;
  }
  .column-gap-xl-11 {
    column-gap: 2.75rem !important;
  }
  .column-gap-xl-12 {
    column-gap: 3rem !important;
  }
  .column-gap-xl-13 {
    column-gap: 3.25rem !important;
  }
  .column-gap-xl-14 {
    column-gap: 3.5rem !important;
  }
  .column-gap-xl-15 {
    column-gap: 3.75rem !important;
  }
  .column-gap-xl-16 {
    column-gap: 4rem !important;
  }
  .column-gap-xl-17 {
    column-gap: 4.25rem !important;
  }
  .column-gap-xl-18 {
    column-gap: 4.5rem !important;
  }
  .column-gap-xl-19 {
    column-gap: 4.75rem !important;
  }
  .column-gap-xl-20 {
    column-gap: 5rem !important;
  }
  .fs-xl-1 {
    font-size: calc(1.3rem + 0.6vw) !important;
  }
  .fs-xl-2 {
    font-size: calc(1.275rem + 0.3vw) !important;
  }
  .fs-xl-3 {
    font-size: calc(1.26rem + 0.12vw) !important;
  }
  .fs-xl-4 {
    font-size: 1.25rem !important;
  }
  .fs-xl-5 {
    font-size: 1.15rem !important;
  }
  .fs-xl-6 {
    font-size: 1.075rem !important;
  }
  .fs-xl-7 {
    font-size: 0.95rem !important;
  }
  .fs-xl-8 {
    font-size: 0.85rem !important;
  }
  .fs-xl-9 {
    font-size: 0.75rem !important;
  }
  .fs-xl-10 {
    font-size: 0.5rem !important;
  }
  .fs-xl-base {
    font-size: 1rem !important;
  }
  .fs-xl-fluid {
    font-size: 100% !important;
  }
  .fs-xl-2x {
    font-size: calc(1.325rem + 0.9vw) !important;
  }
  .fs-xl-2qx {
    font-size: calc(1.35rem + 1.2vw) !important;
  }
  .fs-xl-2hx {
    font-size: calc(1.375rem + 1.5vw) !important;
  }
  .fs-xl-2tx {
    font-size: calc(1.4rem + 1.8vw) !important;
  }
  .fs-xl-3x {
    font-size: calc(1.425rem + 2.1vw) !important;
  }
  .fs-xl-3qx {
    font-size: calc(1.45rem + 2.4vw) !important;
  }
  .fs-xl-3hx {
    font-size: calc(1.475rem + 2.7vw) !important;
  }
  .fs-xl-3tx {
    font-size: calc(1.5rem + 3vw) !important;
  }
  .fs-xl-4x {
    font-size: calc(1.525rem + 3.3vw) !important;
  }
  .fs-xl-4qx {
    font-size: calc(1.55rem + 3.6vw) !important;
  }
  .fs-xl-4hx {
    font-size: calc(1.575rem + 3.9vw) !important;
  }
  .fs-xl-4tx {
    font-size: calc(1.6rem + 4.2vw) !important;
  }
  .fs-xl-5x {
    font-size: calc(1.625rem + 4.5vw) !important;
  }
  .fs-xl-5qx {
    font-size: calc(1.65rem + 4.8vw) !important;
  }
  .fs-xl-5hx {
    font-size: calc(1.675rem + 5.1vw) !important;
  }
  .fs-xl-5tx {
    font-size: calc(1.7rem + 5.4vw) !important;
  }
  .fs-xl-6x {
    font-size: calc(1.725rem + 5.7vw) !important;
  }
  .fs-xl-6qx {
    font-size: calc(1.75rem + 6vw) !important;
  }
  .fs-xl-6hx {
    font-size: calc(1.775rem + 6.3vw) !important;
  }
  .fs-xl-6tx {
    font-size: calc(1.8rem + 6.6vw) !important;
  }
  .fs-xl-7x {
    font-size: calc(1.825rem + 6.9vw) !important;
  }
  .fs-xl-7qx {
    font-size: calc(1.85rem + 7.2vw) !important;
  }
  .fs-xl-7hx {
    font-size: calc(1.875rem + 7.5vw) !important;
  }
  .fs-xl-7tx {
    font-size: calc(1.9rem + 7.8vw) !important;
  }
  .text-xl-start {
    text-align: left !important;
  }
  .text-xl-end {
    text-align: right !important;
  }
  .text-xl-center {
    text-align: center !important;
  }
  .min-w-xl-unset {
    min-width: unset !important;
  }
  .min-w-xl-25 {
    min-width: 25% !important;
  }
  .min-w-xl-50 {
    min-width: 50% !important;
  }
  .min-w-xl-75 {
    min-width: 75% !important;
  }
  .min-w-xl-100 {
    min-width: 100% !important;
  }
  .min-w-xl-auto {
    min-width: auto !important;
  }
  .min-w-xl-1px {
    min-width: 1px !important;
  }
  .min-w-xl-2px {
    min-width: 2px !important;
  }
  .min-w-xl-3px {
    min-width: 3px !important;
  }
  .min-w-xl-4px {
    min-width: 4px !important;
  }
  .min-w-xl-5px {
    min-width: 5px !important;
  }
  .min-w-xl-6px {
    min-width: 6px !important;
  }
  .min-w-xl-7px {
    min-width: 7px !important;
  }
  .min-w-xl-8px {
    min-width: 8px !important;
  }
  .min-w-xl-9px {
    min-width: 9px !important;
  }
  .min-w-xl-10px {
    min-width: 10px !important;
  }
  .min-w-xl-15px {
    min-width: 15px !important;
  }
  .min-w-xl-20px {
    min-width: 20px !important;
  }
  .min-w-xl-25px {
    min-width: 25px !important;
  }
  .min-w-xl-30px {
    min-width: 30px !important;
  }
  .min-w-xl-35px {
    min-width: 35px !important;
  }
  .min-w-xl-40px {
    min-width: 40px !important;
  }
  .min-w-xl-45px {
    min-width: 45px !important;
  }
  .min-w-xl-50px {
    min-width: 50px !important;
  }
  .min-w-xl-55px {
    min-width: 55px !important;
  }
  .min-w-xl-60px {
    min-width: 60px !important;
  }
  .min-w-xl-65px {
    min-width: 65px !important;
  }
  .min-w-xl-70px {
    min-width: 70px !important;
  }
  .min-w-xl-75px {
    min-width: 75px !important;
  }
  .min-w-xl-80px {
    min-width: 80px !important;
  }
  .min-w-xl-85px {
    min-width: 85px !important;
  }
  .min-w-xl-90px {
    min-width: 90px !important;
  }
  .min-w-xl-95px {
    min-width: 95px !important;
  }
  .min-w-xl-100px {
    min-width: 100px !important;
  }
  .min-w-xl-125px {
    min-width: 125px !important;
  }
  .min-w-xl-150px {
    min-width: 150px !important;
  }
  .min-w-xl-175px {
    min-width: 175px !important;
  }
  .min-w-xl-200px {
    min-width: 200px !important;
  }
  .min-w-xl-225px {
    min-width: 225px !important;
  }
  .min-w-xl-250px {
    min-width: 250px !important;
  }
  .min-w-xl-275px {
    min-width: 275px !important;
  }
  .min-w-xl-300px {
    min-width: 300px !important;
  }
  .min-w-xl-325px {
    min-width: 325px !important;
  }
  .min-w-xl-350px {
    min-width: 350px !important;
  }
  .min-w-xl-375px {
    min-width: 375px !important;
  }
  .min-w-xl-400px {
    min-width: 400px !important;
  }
  .min-w-xl-425px {
    min-width: 425px !important;
  }
  .min-w-xl-450px {
    min-width: 450px !important;
  }
  .min-w-xl-475px {
    min-width: 475px !important;
  }
  .min-w-xl-500px {
    min-width: 500px !important;
  }
  .min-w-xl-550px {
    min-width: 550px !important;
  }
  .min-w-xl-600px {
    min-width: 600px !important;
  }
  .min-w-xl-650px {
    min-width: 650px !important;
  }
  .min-w-xl-700px {
    min-width: 700px !important;
  }
  .min-w-xl-750px {
    min-width: 750px !important;
  }
  .min-w-xl-800px {
    min-width: 800px !important;
  }
  .min-w-xl-850px {
    min-width: 850px !important;
  }
  .min-w-xl-900px {
    min-width: 900px !important;
  }
  .min-w-xl-950px {
    min-width: 950px !important;
  }
  .min-w-xl-1000px {
    min-width: 1000px !important;
  }
  .min-h-xl-unset {
    min-height: unset !important;
  }
  .min-h-xl-25 {
    min-height: 25% !important;
  }
  .min-h-xl-50 {
    min-height: 50% !important;
  }
  .min-h-xl-75 {
    min-height: 75% !important;
  }
  .min-h-xl-100 {
    min-height: 100% !important;
  }
  .min-h-xl-auto {
    min-height: auto !important;
  }
  .min-h-xl-1px {
    min-height: 1px !important;
  }
  .min-h-xl-2px {
    min-height: 2px !important;
  }
  .min-h-xl-3px {
    min-height: 3px !important;
  }
  .min-h-xl-4px {
    min-height: 4px !important;
  }
  .min-h-xl-5px {
    min-height: 5px !important;
  }
  .min-h-xl-6px {
    min-height: 6px !important;
  }
  .min-h-xl-7px {
    min-height: 7px !important;
  }
  .min-h-xl-8px {
    min-height: 8px !important;
  }
  .min-h-xl-9px {
    min-height: 9px !important;
  }
  .min-h-xl-10px {
    min-height: 10px !important;
  }
  .min-h-xl-15px {
    min-height: 15px !important;
  }
  .min-h-xl-20px {
    min-height: 20px !important;
  }
  .min-h-xl-25px {
    min-height: 25px !important;
  }
  .min-h-xl-30px {
    min-height: 30px !important;
  }
  .min-h-xl-35px {
    min-height: 35px !important;
  }
  .min-h-xl-40px {
    min-height: 40px !important;
  }
  .min-h-xl-45px {
    min-height: 45px !important;
  }
  .min-h-xl-50px {
    min-height: 50px !important;
  }
  .min-h-xl-55px {
    min-height: 55px !important;
  }
  .min-h-xl-60px {
    min-height: 60px !important;
  }
  .min-h-xl-65px {
    min-height: 65px !important;
  }
  .min-h-xl-70px {
    min-height: 70px !important;
  }
  .min-h-xl-75px {
    min-height: 75px !important;
  }
  .min-h-xl-80px {
    min-height: 80px !important;
  }
  .min-h-xl-85px {
    min-height: 85px !important;
  }
  .min-h-xl-90px {
    min-height: 90px !important;
  }
  .min-h-xl-95px {
    min-height: 95px !important;
  }
  .min-h-xl-100px {
    min-height: 100px !important;
  }
  .min-h-xl-125px {
    min-height: 125px !important;
  }
  .min-h-xl-150px {
    min-height: 150px !important;
  }
  .min-h-xl-175px {
    min-height: 175px !important;
  }
  .min-h-xl-200px {
    min-height: 200px !important;
  }
  .min-h-xl-225px {
    min-height: 225px !important;
  }
  .min-h-xl-250px {
    min-height: 250px !important;
  }
  .min-h-xl-275px {
    min-height: 275px !important;
  }
  .min-h-xl-300px {
    min-height: 300px !important;
  }
  .min-h-xl-325px {
    min-height: 325px !important;
  }
  .min-h-xl-350px {
    min-height: 350px !important;
  }
  .min-h-xl-375px {
    min-height: 375px !important;
  }
  .min-h-xl-400px {
    min-height: 400px !important;
  }
  .min-h-xl-425px {
    min-height: 425px !important;
  }
  .min-h-xl-450px {
    min-height: 450px !important;
  }
  .min-h-xl-475px {
    min-height: 475px !important;
  }
  .min-h-xl-500px {
    min-height: 500px !important;
  }
  .min-h-xl-550px {
    min-height: 550px !important;
  }
  .min-h-xl-600px {
    min-height: 600px !important;
  }
  .min-h-xl-650px {
    min-height: 650px !important;
  }
  .min-h-xl-700px {
    min-height: 700px !important;
  }
  .min-h-xl-750px {
    min-height: 750px !important;
  }
  .min-h-xl-800px {
    min-height: 800px !important;
  }
  .min-h-xl-850px {
    min-height: 850px !important;
  }
  .min-h-xl-900px {
    min-height: 900px !important;
  }
  .min-h-xl-950px {
    min-height: 950px !important;
  }
  .min-h-xl-1000px {
    min-height: 1000px !important;
  }
}
@media (min-width: 1400px) {
  .float-xxl-start {
    float: left !important;
  }
  .float-xxl-end {
    float: right !important;
  }
  .float-xxl-none {
    float: none !important;
  }
  .object-fit-xxl-contain {
    object-fit: contain !important;
  }
  .object-fit-xxl-cover {
    object-fit: cover !important;
  }
  .object-fit-xxl-fill {
    object-fit: fill !important;
  }
  .object-fit-xxl-scale {
    object-fit: scale-down !important;
  }
  .object-fit-xxl-none {
    object-fit: none !important;
  }
  .overflow-xxl-auto {
    overflow: auto !important;
  }
  .overflow-xxl-hidden {
    overflow: hidden !important;
  }
  .overflow-xxl-visible {
    overflow: visible !important;
  }
  .overflow-xxl-scroll {
    overflow: scroll !important;
  }
  .d-xxl-inline {
    display: inline !important;
  }
  .d-xxl-inline-block {
    display: inline-block !important;
  }
  .d-xxl-block {
    display: block !important;
  }
  .d-xxl-grid {
    display: grid !important;
  }
  .d-xxl-table {
    display: table !important;
  }
  .d-xxl-table-row {
    display: table-row !important;
  }
  .d-xxl-table-cell {
    display: table-cell !important;
  }
  .d-xxl-flex {
    display: flex !important;
  }
  .d-xxl-inline-flex {
    display: inline-flex !important;
  }
  .d-xxl-none {
    display: none !important;
  }
  .position-xxl-static {
    position: static !important;
  }
  .position-xxl-relative {
    position: relative !important;
  }
  .position-xxl-absolute {
    position: absolute !important;
  }
  .position-xxl-fixed {
    position: fixed !important;
  }
  .position-xxl-sticky {
    position: sticky !important;
  }
  .w-xxl-unset {
    width: unset !important;
  }
  .w-xxl-25 {
    width: 25% !important;
  }
  .w-xxl-50 {
    width: 50% !important;
  }
  .w-xxl-75 {
    width: 75% !important;
  }
  .w-xxl-100 {
    width: 100% !important;
  }
  .w-xxl-auto {
    width: auto !important;
  }
  .w-xxl-1px {
    width: 1px !important;
  }
  .w-xxl-2px {
    width: 2px !important;
  }
  .w-xxl-3px {
    width: 3px !important;
  }
  .w-xxl-4px {
    width: 4px !important;
  }
  .w-xxl-5px {
    width: 5px !important;
  }
  .w-xxl-6px {
    width: 6px !important;
  }
  .w-xxl-7px {
    width: 7px !important;
  }
  .w-xxl-8px {
    width: 8px !important;
  }
  .w-xxl-9px {
    width: 9px !important;
  }
  .w-xxl-10px {
    width: 10px !important;
  }
  .w-xxl-15px {
    width: 15px !important;
  }
  .w-xxl-20px {
    width: 20px !important;
  }
  .w-xxl-25px {
    width: 25px !important;
  }
  .w-xxl-30px {
    width: 30px !important;
  }
  .w-xxl-35px {
    width: 35px !important;
  }
  .w-xxl-40px {
    width: 40px !important;
  }
  .w-xxl-45px {
    width: 45px !important;
  }
  .w-xxl-50px {
    width: 50px !important;
  }
  .w-xxl-55px {
    width: 55px !important;
  }
  .w-xxl-60px {
    width: 60px !important;
  }
  .w-xxl-65px {
    width: 65px !important;
  }
  .w-xxl-70px {
    width: 70px !important;
  }
  .w-xxl-75px {
    width: 75px !important;
  }
  .w-xxl-80px {
    width: 80px !important;
  }
  .w-xxl-85px {
    width: 85px !important;
  }
  .w-xxl-90px {
    width: 90px !important;
  }
  .w-xxl-95px {
    width: 95px !important;
  }
  .w-xxl-100px {
    width: 100px !important;
  }
  .w-xxl-125px {
    width: 125px !important;
  }
  .w-xxl-150px {
    width: 150px !important;
  }
  .w-xxl-175px {
    width: 175px !important;
  }
  .w-xxl-200px {
    width: 200px !important;
  }
  .w-xxl-225px {
    width: 225px !important;
  }
  .w-xxl-250px {
    width: 250px !important;
  }
  .w-xxl-275px {
    width: 275px !important;
  }
  .w-xxl-300px {
    width: 300px !important;
  }
  .w-xxl-325px {
    width: 325px !important;
  }
  .w-xxl-350px {
    width: 350px !important;
  }
  .w-xxl-375px {
    width: 375px !important;
  }
  .w-xxl-400px {
    width: 400px !important;
  }
  .w-xxl-425px {
    width: 425px !important;
  }
  .w-xxl-450px {
    width: 450px !important;
  }
  .w-xxl-475px {
    width: 475px !important;
  }
  .w-xxl-500px {
    width: 500px !important;
  }
  .w-xxl-550px {
    width: 550px !important;
  }
  .w-xxl-600px {
    width: 600px !important;
  }
  .w-xxl-650px {
    width: 650px !important;
  }
  .w-xxl-700px {
    width: 700px !important;
  }
  .w-xxl-750px {
    width: 750px !important;
  }
  .w-xxl-800px {
    width: 800px !important;
  }
  .w-xxl-850px {
    width: 850px !important;
  }
  .w-xxl-900px {
    width: 900px !important;
  }
  .w-xxl-950px {
    width: 950px !important;
  }
  .w-xxl-1000px {
    width: 1000px !important;
  }
  .mw-xxl-unset {
    max-width: unset !important;
  }
  .mw-xxl-25 {
    max-width: 25% !important;
  }
  .mw-xxl-50 {
    max-width: 50% !important;
  }
  .mw-xxl-75 {
    max-width: 75% !important;
  }
  .mw-xxl-100 {
    max-width: 100% !important;
  }
  .mw-xxl-auto {
    max-width: auto !important;
  }
  .mw-xxl-1px {
    max-width: 1px !important;
  }
  .mw-xxl-2px {
    max-width: 2px !important;
  }
  .mw-xxl-3px {
    max-width: 3px !important;
  }
  .mw-xxl-4px {
    max-width: 4px !important;
  }
  .mw-xxl-5px {
    max-width: 5px !important;
  }
  .mw-xxl-6px {
    max-width: 6px !important;
  }
  .mw-xxl-7px {
    max-width: 7px !important;
  }
  .mw-xxl-8px {
    max-width: 8px !important;
  }
  .mw-xxl-9px {
    max-width: 9px !important;
  }
  .mw-xxl-10px {
    max-width: 10px !important;
  }
  .mw-xxl-15px {
    max-width: 15px !important;
  }
  .mw-xxl-20px {
    max-width: 20px !important;
  }
  .mw-xxl-25px {
    max-width: 25px !important;
  }
  .mw-xxl-30px {
    max-width: 30px !important;
  }
  .mw-xxl-35px {
    max-width: 35px !important;
  }
  .mw-xxl-40px {
    max-width: 40px !important;
  }
  .mw-xxl-45px {
    max-width: 45px !important;
  }
  .mw-xxl-50px {
    max-width: 50px !important;
  }
  .mw-xxl-55px {
    max-width: 55px !important;
  }
  .mw-xxl-60px {
    max-width: 60px !important;
  }
  .mw-xxl-65px {
    max-width: 65px !important;
  }
  .mw-xxl-70px {
    max-width: 70px !important;
  }
  .mw-xxl-75px {
    max-width: 75px !important;
  }
  .mw-xxl-80px {
    max-width: 80px !important;
  }
  .mw-xxl-85px {
    max-width: 85px !important;
  }
  .mw-xxl-90px {
    max-width: 90px !important;
  }
  .mw-xxl-95px {
    max-width: 95px !important;
  }
  .mw-xxl-100px {
    max-width: 100px !important;
  }
  .mw-xxl-125px {
    max-width: 125px !important;
  }
  .mw-xxl-150px {
    max-width: 150px !important;
  }
  .mw-xxl-175px {
    max-width: 175px !important;
  }
  .mw-xxl-200px {
    max-width: 200px !important;
  }
  .mw-xxl-225px {
    max-width: 225px !important;
  }
  .mw-xxl-250px {
    max-width: 250px !important;
  }
  .mw-xxl-275px {
    max-width: 275px !important;
  }
  .mw-xxl-300px {
    max-width: 300px !important;
  }
  .mw-xxl-325px {
    max-width: 325px !important;
  }
  .mw-xxl-350px {
    max-width: 350px !important;
  }
  .mw-xxl-375px {
    max-width: 375px !important;
  }
  .mw-xxl-400px {
    max-width: 400px !important;
  }
  .mw-xxl-425px {
    max-width: 425px !important;
  }
  .mw-xxl-450px {
    max-width: 450px !important;
  }
  .mw-xxl-475px {
    max-width: 475px !important;
  }
  .mw-xxl-500px {
    max-width: 500px !important;
  }
  .mw-xxl-550px {
    max-width: 550px !important;
  }
  .mw-xxl-600px {
    max-width: 600px !important;
  }
  .mw-xxl-650px {
    max-width: 650px !important;
  }
  .mw-xxl-700px {
    max-width: 700px !important;
  }
  .mw-xxl-750px {
    max-width: 750px !important;
  }
  .mw-xxl-800px {
    max-width: 800px !important;
  }
  .mw-xxl-850px {
    max-width: 850px !important;
  }
  .mw-xxl-900px {
    max-width: 900px !important;
  }
  .mw-xxl-950px {
    max-width: 950px !important;
  }
  .mw-xxl-1000px {
    max-width: 1000px !important;
  }
  .h-xxl-unset {
    height: unset !important;
  }
  .h-xxl-25 {
    height: 25% !important;
  }
  .h-xxl-50 {
    height: 50% !important;
  }
  .h-xxl-75 {
    height: 75% !important;
  }
  .h-xxl-100 {
    height: 100% !important;
  }
  .h-xxl-auto {
    height: auto !important;
  }
  .h-xxl-1px {
    height: 1px !important;
  }
  .h-xxl-2px {
    height: 2px !important;
  }
  .h-xxl-3px {
    height: 3px !important;
  }
  .h-xxl-4px {
    height: 4px !important;
  }
  .h-xxl-5px {
    height: 5px !important;
  }
  .h-xxl-6px {
    height: 6px !important;
  }
  .h-xxl-7px {
    height: 7px !important;
  }
  .h-xxl-8px {
    height: 8px !important;
  }
  .h-xxl-9px {
    height: 9px !important;
  }
  .h-xxl-10px {
    height: 10px !important;
  }
  .h-xxl-15px {
    height: 15px !important;
  }
  .h-xxl-20px {
    height: 20px !important;
  }
  .h-xxl-25px {
    height: 25px !important;
  }
  .h-xxl-30px {
    height: 30px !important;
  }
  .h-xxl-35px {
    height: 35px !important;
  }
  .h-xxl-40px {
    height: 40px !important;
  }
  .h-xxl-45px {
    height: 45px !important;
  }
  .h-xxl-50px {
    height: 50px !important;
  }
  .h-xxl-55px {
    height: 55px !important;
  }
  .h-xxl-60px {
    height: 60px !important;
  }
  .h-xxl-65px {
    height: 65px !important;
  }
  .h-xxl-70px {
    height: 70px !important;
  }
  .h-xxl-75px {
    height: 75px !important;
  }
  .h-xxl-80px {
    height: 80px !important;
  }
  .h-xxl-85px {
    height: 85px !important;
  }
  .h-xxl-90px {
    height: 90px !important;
  }
  .h-xxl-95px {
    height: 95px !important;
  }
  .h-xxl-100px {
    height: 100px !important;
  }
  .h-xxl-125px {
    height: 125px !important;
  }
  .h-xxl-150px {
    height: 150px !important;
  }
  .h-xxl-175px {
    height: 175px !important;
  }
  .h-xxl-200px {
    height: 200px !important;
  }
  .h-xxl-225px {
    height: 225px !important;
  }
  .h-xxl-250px {
    height: 250px !important;
  }
  .h-xxl-275px {
    height: 275px !important;
  }
  .h-xxl-300px {
    height: 300px !important;
  }
  .h-xxl-325px {
    height: 325px !important;
  }
  .h-xxl-350px {
    height: 350px !important;
  }
  .h-xxl-375px {
    height: 375px !important;
  }
  .h-xxl-400px {
    height: 400px !important;
  }
  .h-xxl-425px {
    height: 425px !important;
  }
  .h-xxl-450px {
    height: 450px !important;
  }
  .h-xxl-475px {
    height: 475px !important;
  }
  .h-xxl-500px {
    height: 500px !important;
  }
  .h-xxl-550px {
    height: 550px !important;
  }
  .h-xxl-600px {
    height: 600px !important;
  }
  .h-xxl-650px {
    height: 650px !important;
  }
  .h-xxl-700px {
    height: 700px !important;
  }
  .h-xxl-750px {
    height: 750px !important;
  }
  .h-xxl-800px {
    height: 800px !important;
  }
  .h-xxl-850px {
    height: 850px !important;
  }
  .h-xxl-900px {
    height: 900px !important;
  }
  .h-xxl-950px {
    height: 950px !important;
  }
  .h-xxl-1000px {
    height: 1000px !important;
  }
  .mh-xxl-unset {
    max-height: unset !important;
  }
  .mh-xxl-25 {
    max-height: 25% !important;
  }
  .mh-xxl-50 {
    max-height: 50% !important;
  }
  .mh-xxl-75 {
    max-height: 75% !important;
  }
  .mh-xxl-100 {
    max-height: 100% !important;
  }
  .mh-xxl-auto {
    max-height: auto !important;
  }
  .mh-xxl-1px {
    max-height: 1px !important;
  }
  .mh-xxl-2px {
    max-height: 2px !important;
  }
  .mh-xxl-3px {
    max-height: 3px !important;
  }
  .mh-xxl-4px {
    max-height: 4px !important;
  }
  .mh-xxl-5px {
    max-height: 5px !important;
  }
  .mh-xxl-6px {
    max-height: 6px !important;
  }
  .mh-xxl-7px {
    max-height: 7px !important;
  }
  .mh-xxl-8px {
    max-height: 8px !important;
  }
  .mh-xxl-9px {
    max-height: 9px !important;
  }
  .mh-xxl-10px {
    max-height: 10px !important;
  }
  .mh-xxl-15px {
    max-height: 15px !important;
  }
  .mh-xxl-20px {
    max-height: 20px !important;
  }
  .mh-xxl-25px {
    max-height: 25px !important;
  }
  .mh-xxl-30px {
    max-height: 30px !important;
  }
  .mh-xxl-35px {
    max-height: 35px !important;
  }
  .mh-xxl-40px {
    max-height: 40px !important;
  }
  .mh-xxl-45px {
    max-height: 45px !important;
  }
  .mh-xxl-50px {
    max-height: 50px !important;
  }
  .mh-xxl-55px {
    max-height: 55px !important;
  }
  .mh-xxl-60px {
    max-height: 60px !important;
  }
  .mh-xxl-65px {
    max-height: 65px !important;
  }
  .mh-xxl-70px {
    max-height: 70px !important;
  }
  .mh-xxl-75px {
    max-height: 75px !important;
  }
  .mh-xxl-80px {
    max-height: 80px !important;
  }
  .mh-xxl-85px {
    max-height: 85px !important;
  }
  .mh-xxl-90px {
    max-height: 90px !important;
  }
  .mh-xxl-95px {
    max-height: 95px !important;
  }
  .mh-xxl-100px {
    max-height: 100px !important;
  }
  .mh-xxl-125px {
    max-height: 125px !important;
  }
  .mh-xxl-150px {
    max-height: 150px !important;
  }
  .mh-xxl-175px {
    max-height: 175px !important;
  }
  .mh-xxl-200px {
    max-height: 200px !important;
  }
  .mh-xxl-225px {
    max-height: 225px !important;
  }
  .mh-xxl-250px {
    max-height: 250px !important;
  }
  .mh-xxl-275px {
    max-height: 275px !important;
  }
  .mh-xxl-300px {
    max-height: 300px !important;
  }
  .mh-xxl-325px {
    max-height: 325px !important;
  }
  .mh-xxl-350px {
    max-height: 350px !important;
  }
  .mh-xxl-375px {
    max-height: 375px !important;
  }
  .mh-xxl-400px {
    max-height: 400px !important;
  }
  .mh-xxl-425px {
    max-height: 425px !important;
  }
  .mh-xxl-450px {
    max-height: 450px !important;
  }
  .mh-xxl-475px {
    max-height: 475px !important;
  }
  .mh-xxl-500px {
    max-height: 500px !important;
  }
  .mh-xxl-550px {
    max-height: 550px !important;
  }
  .mh-xxl-600px {
    max-height: 600px !important;
  }
  .mh-xxl-650px {
    max-height: 650px !important;
  }
  .mh-xxl-700px {
    max-height: 700px !important;
  }
  .mh-xxl-750px {
    max-height: 750px !important;
  }
  .mh-xxl-800px {
    max-height: 800px !important;
  }
  .mh-xxl-850px {
    max-height: 850px !important;
  }
  .mh-xxl-900px {
    max-height: 900px !important;
  }
  .mh-xxl-950px {
    max-height: 950px !important;
  }
  .mh-xxl-1000px {
    max-height: 1000px !important;
  }
  .flex-xxl-fill {
    flex: 1 1 auto !important;
  }
  .flex-xxl-row {
    flex-direction: row !important;
  }
  .flex-xxl-column {
    flex-direction: column !important;
  }
  .flex-xxl-row-reverse {
    flex-direction: row-reverse !important;
  }
  .flex-xxl-column-reverse {
    flex-direction: column-reverse !important;
  }
  .flex-xxl-grow-0 {
    flex-grow: 0 !important;
  }
  .flex-xxl-grow-1 {
    flex-grow: 1 !important;
  }
  .flex-xxl-shrink-0 {
    flex-shrink: 0 !important;
  }
  .flex-xxl-shrink-1 {
    flex-shrink: 1 !important;
  }
  .flex-xxl-wrap {
    flex-wrap: wrap !important;
  }
  .flex-xxl-nowrap {
    flex-wrap: nowrap !important;
  }
  .flex-xxl-wrap-reverse {
    flex-wrap: wrap-reverse !important;
  }
  .justify-content-xxl-start {
    justify-content: flex-start !important;
  }
  .justify-content-xxl-end {
    justify-content: flex-end !important;
  }
  .justify-content-xxl-center {
    justify-content: center !important;
  }
  .justify-content-xxl-between {
    justify-content: space-between !important;
  }
  .justify-content-xxl-around {
    justify-content: space-around !important;
  }
  .justify-content-xxl-evenly {
    justify-content: space-evenly !important;
  }
  .align-items-xxl-start {
    align-items: flex-start !important;
  }
  .align-items-xxl-end {
    align-items: flex-end !important;
  }
  .align-items-xxl-center {
    align-items: center !important;
  }
  .align-items-xxl-baseline {
    align-items: baseline !important;
  }
  .align-items-xxl-stretch {
    align-items: stretch !important;
  }
  .align-content-xxl-start {
    align-content: flex-start !important;
  }
  .align-content-xxl-end {
    align-content: flex-end !important;
  }
  .align-content-xxl-center {
    align-content: center !important;
  }
  .align-content-xxl-between {
    align-content: space-between !important;
  }
  .align-content-xxl-around {
    align-content: space-around !important;
  }
  .align-content-xxl-stretch {
    align-content: stretch !important;
  }
  .align-self-xxl-auto {
    align-self: auto !important;
  }
  .align-self-xxl-start {
    align-self: flex-start !important;
  }
  .align-self-xxl-end {
    align-self: flex-end !important;
  }
  .align-self-xxl-center {
    align-self: center !important;
  }
  .align-self-xxl-baseline {
    align-self: baseline !important;
  }
  .align-self-xxl-stretch {
    align-self: stretch !important;
  }
  .order-xxl-first {
    order: -1 !important;
  }
  .order-xxl-0 {
    order: 0 !important;
  }
  .order-xxl-1 {
    order: 1 !important;
  }
  .order-xxl-2 {
    order: 2 !important;
  }
  .order-xxl-3 {
    order: 3 !important;
  }
  .order-xxl-4 {
    order: 4 !important;
  }
  .order-xxl-5 {
    order: 5 !important;
  }
  .order-xxl-last {
    order: 6 !important;
  }
  .m-xxl-0 {
    margin: 0 !important;
  }
  .m-xxl-1 {
    margin: 0.25rem !important;
  }
  .m-xxl-2 {
    margin: 0.5rem !important;
  }
  .m-xxl-3 {
    margin: 0.75rem !important;
  }
  .m-xxl-4 {
    margin: 1rem !important;
  }
  .m-xxl-5 {
    margin: 1.25rem !important;
  }
  .m-xxl-6 {
    margin: 1.5rem !important;
  }
  .m-xxl-7 {
    margin: 1.75rem !important;
  }
  .m-xxl-8 {
    margin: 2rem !important;
  }
  .m-xxl-9 {
    margin: 2.25rem !important;
  }
  .m-xxl-10 {
    margin: 2.5rem !important;
  }
  .m-xxl-11 {
    margin: 2.75rem !important;
  }
  .m-xxl-12 {
    margin: 3rem !important;
  }
  .m-xxl-13 {
    margin: 3.25rem !important;
  }
  .m-xxl-14 {
    margin: 3.5rem !important;
  }
  .m-xxl-15 {
    margin: 3.75rem !important;
  }
  .m-xxl-16 {
    margin: 4rem !important;
  }
  .m-xxl-17 {
    margin: 4.25rem !important;
  }
  .m-xxl-18 {
    margin: 4.5rem !important;
  }
  .m-xxl-19 {
    margin: 4.75rem !important;
  }
  .m-xxl-20 {
    margin: 5rem !important;
  }
  .m-xxl-auto {
    margin: auto !important;
  }
  .mx-xxl-0 {
    margin-right: 0 !important;
    margin-left: 0 !important;
  }
  .mx-xxl-1 {
    margin-right: 0.25rem !important;
    margin-left: 0.25rem !important;
  }
  .mx-xxl-2 {
    margin-right: 0.5rem !important;
    margin-left: 0.5rem !important;
  }
  .mx-xxl-3 {
    margin-right: 0.75rem !important;
    margin-left: 0.75rem !important;
  }
  .mx-xxl-4 {
    margin-right: 1rem !important;
    margin-left: 1rem !important;
  }
  .mx-xxl-5 {
    margin-right: 1.25rem !important;
    margin-left: 1.25rem !important;
  }
  .mx-xxl-6 {
    margin-right: 1.5rem !important;
    margin-left: 1.5rem !important;
  }
  .mx-xxl-7 {
    margin-right: 1.75rem !important;
    margin-left: 1.75rem !important;
  }
  .mx-xxl-8 {
    margin-right: 2rem !important;
    margin-left: 2rem !important;
  }
  .mx-xxl-9 {
    margin-right: 2.25rem !important;
    margin-left: 2.25rem !important;
  }
  .mx-xxl-10 {
    margin-right: 2.5rem !important;
    margin-left: 2.5rem !important;
  }
  .mx-xxl-11 {
    margin-right: 2.75rem !important;
    margin-left: 2.75rem !important;
  }
  .mx-xxl-12 {
    margin-right: 3rem !important;
    margin-left: 3rem !important;
  }
  .mx-xxl-13 {
    margin-right: 3.25rem !important;
    margin-left: 3.25rem !important;
  }
  .mx-xxl-14 {
    margin-right: 3.5rem !important;
    margin-left: 3.5rem !important;
  }
  .mx-xxl-15 {
    margin-right: 3.75rem !important;
    margin-left: 3.75rem !important;
  }
  .mx-xxl-16 {
    margin-right: 4rem !important;
    margin-left: 4rem !important;
  }
  .mx-xxl-17 {
    margin-right: 4.25rem !important;
    margin-left: 4.25rem !important;
  }
  .mx-xxl-18 {
    margin-right: 4.5rem !important;
    margin-left: 4.5rem !important;
  }
  .mx-xxl-19 {
    margin-right: 4.75rem !important;
    margin-left: 4.75rem !important;
  }
  .mx-xxl-20 {
    margin-right: 5rem !important;
    margin-left: 5rem !important;
  }
  .mx-xxl-auto {
    margin-right: auto !important;
    margin-left: auto !important;
  }
  .my-xxl-0 {
    margin-top: 0 !important;
    margin-bottom: 0 !important;
  }
  .my-xxl-1 {
    margin-top: 0.25rem !important;
    margin-bottom: 0.25rem !important;
  }
  .my-xxl-2 {
    margin-top: 0.5rem !important;
    margin-bottom: 0.5rem !important;
  }
  .my-xxl-3 {
    margin-top: 0.75rem !important;
    margin-bottom: 0.75rem !important;
  }
  .my-xxl-4 {
    margin-top: 1rem !important;
    margin-bottom: 1rem !important;
  }
  .my-xxl-5 {
    margin-top: 1.25rem !important;
    margin-bottom: 1.25rem !important;
  }
  .my-xxl-6 {
    margin-top: 1.5rem !important;
    margin-bottom: 1.5rem !important;
  }
  .my-xxl-7 {
    margin-top: 1.75rem !important;
    margin-bottom: 1.75rem !important;
  }
  .my-xxl-8 {
    margin-top: 2rem !important;
    margin-bottom: 2rem !important;
  }
  .my-xxl-9 {
    margin-top: 2.25rem !important;
    margin-bottom: 2.25rem !important;
  }
  .my-xxl-10 {
    margin-top: 2.5rem !important;
    margin-bottom: 2.5rem !important;
  }
  .my-xxl-11 {
    margin-top: 2.75rem !important;
    margin-bottom: 2.75rem !important;
  }
  .my-xxl-12 {
    margin-top: 3rem !important;
    margin-bottom: 3rem !important;
  }
  .my-xxl-13 {
    margin-top: 3.25rem !important;
    margin-bottom: 3.25rem !important;
  }
  .my-xxl-14 {
    margin-top: 3.5rem !important;
    margin-bottom: 3.5rem !important;
  }
  .my-xxl-15 {
    margin-top: 3.75rem !important;
    margin-bottom: 3.75rem !important;
  }
  .my-xxl-16 {
    margin-top: 4rem !important;
    margin-bottom: 4rem !important;
  }
  .my-xxl-17 {
    margin-top: 4.25rem !important;
    margin-bottom: 4.25rem !important;
  }
  .my-xxl-18 {
    margin-top: 4.5rem !important;
    margin-bottom: 4.5rem !important;
  }
  .my-xxl-19 {
    margin-top: 4.75rem !important;
    margin-bottom: 4.75rem !important;
  }
  .my-xxl-20 {
    margin-top: 5rem !important;
    margin-bottom: 5rem !important;
  }
  .my-xxl-auto {
    margin-top: auto !important;
    margin-bottom: auto !important;
  }
  .mt-xxl-0 {
    margin-top: 0 !important;
  }
  .mt-xxl-1 {
    margin-top: 0.25rem !important;
  }
  .mt-xxl-2 {
    margin-top: 0.5rem !important;
  }
  .mt-xxl-3 {
    margin-top: 0.75rem !important;
  }
  .mt-xxl-4 {
    margin-top: 1rem !important;
  }
  .mt-xxl-5 {
    margin-top: 1.25rem !important;
  }
  .mt-xxl-6 {
    margin-top: 1.5rem !important;
  }
  .mt-xxl-7 {
    margin-top: 1.75rem !important;
  }
  .mt-xxl-8 {
    margin-top: 2rem !important;
  }
  .mt-xxl-9 {
    margin-top: 2.25rem !important;
  }
  .mt-xxl-10 {
    margin-top: 2.5rem !important;
  }
  .mt-xxl-11 {
    margin-top: 2.75rem !important;
  }
  .mt-xxl-12 {
    margin-top: 3rem !important;
  }
  .mt-xxl-13 {
    margin-top: 3.25rem !important;
  }
  .mt-xxl-14 {
    margin-top: 3.5rem !important;
  }
  .mt-xxl-15 {
    margin-top: 3.75rem !important;
  }
  .mt-xxl-16 {
    margin-top: 4rem !important;
  }
  .mt-xxl-17 {
    margin-top: 4.25rem !important;
  }
  .mt-xxl-18 {
    margin-top: 4.5rem !important;
  }
  .mt-xxl-19 {
    margin-top: 4.75rem !important;
  }
  .mt-xxl-20 {
    margin-top: 5rem !important;
  }
  .mt-xxl-auto {
    margin-top: auto !important;
  }
  .me-xxl-0 {
    margin-right: 0 !important;
  }
  .me-xxl-1 {
    margin-right: 0.25rem !important;
  }
  .me-xxl-2 {
    margin-right: 0.5rem !important;
  }
  .me-xxl-3 {
    margin-right: 0.75rem !important;
  }
  .me-xxl-4 {
    margin-right: 1rem !important;
  }
  .me-xxl-5 {
    margin-right: 1.25rem !important;
  }
  .me-xxl-6 {
    margin-right: 1.5rem !important;
  }
  .me-xxl-7 {
    margin-right: 1.75rem !important;
  }
  .me-xxl-8 {
    margin-right: 2rem !important;
  }
  .me-xxl-9 {
    margin-right: 2.25rem !important;
  }
  .me-xxl-10 {
    margin-right: 2.5rem !important;
  }
  .me-xxl-11 {
    margin-right: 2.75rem !important;
  }
  .me-xxl-12 {
    margin-right: 3rem !important;
  }
  .me-xxl-13 {
    margin-right: 3.25rem !important;
  }
  .me-xxl-14 {
    margin-right: 3.5rem !important;
  }
  .me-xxl-15 {
    margin-right: 3.75rem !important;
  }
  .me-xxl-16 {
    margin-right: 4rem !important;
  }
  .me-xxl-17 {
    margin-right: 4.25rem !important;
  }
  .me-xxl-18 {
    margin-right: 4.5rem !important;
  }
  .me-xxl-19 {
    margin-right: 4.75rem !important;
  }
  .me-xxl-20 {
    margin-right: 5rem !important;
  }
  .me-xxl-auto {
    margin-right: auto !important;
  }
  .mb-xxl-0 {
    margin-bottom: 0 !important;
  }
  .mb-xxl-1 {
    margin-bottom: 0.25rem !important;
  }
  .mb-xxl-2 {
    margin-bottom: 0.5rem !important;
  }
  .mb-xxl-3 {
    margin-bottom: 0.75rem !important;
  }
  .mb-xxl-4 {
    margin-bottom: 1rem !important;
  }
  .mb-xxl-5 {
    margin-bottom: 1.25rem !important;
  }
  .mb-xxl-6 {
    margin-bottom: 1.5rem !important;
  }
  .mb-xxl-7 {
    margin-bottom: 1.75rem !important;
  }
  .mb-xxl-8 {
    margin-bottom: 2rem !important;
  }
  .mb-xxl-9 {
    margin-bottom: 2.25rem !important;
  }
  .mb-xxl-10 {
    margin-bottom: 2.5rem !important;
  }
  .mb-xxl-11 {
    margin-bottom: 2.75rem !important;
  }
  .mb-xxl-12 {
    margin-bottom: 3rem !important;
  }
  .mb-xxl-13 {
    margin-bottom: 3.25rem !important;
  }
  .mb-xxl-14 {
    margin-bottom: 3.5rem !important;
  }
  .mb-xxl-15 {
    margin-bottom: 3.75rem !important;
  }
  .mb-xxl-16 {
    margin-bottom: 4rem !important;
  }
  .mb-xxl-17 {
    margin-bottom: 4.25rem !important;
  }
  .mb-xxl-18 {
    margin-bottom: 4.5rem !important;
  }
  .mb-xxl-19 {
    margin-bottom: 4.75rem !important;
  }
  .mb-xxl-20 {
    margin-bottom: 5rem !important;
  }
  .mb-xxl-auto {
    margin-bottom: auto !important;
  }
  .ms-xxl-0 {
    margin-left: 0 !important;
  }
  .ms-xxl-1 {
    margin-left: 0.25rem !important;
  }
  .ms-xxl-2 {
    margin-left: 0.5rem !important;
  }
  .ms-xxl-3 {
    margin-left: 0.75rem !important;
  }
  .ms-xxl-4 {
    margin-left: 1rem !important;
  }
  .ms-xxl-5 {
    margin-left: 1.25rem !important;
  }
  .ms-xxl-6 {
    margin-left: 1.5rem !important;
  }
  .ms-xxl-7 {
    margin-left: 1.75rem !important;
  }
  .ms-xxl-8 {
    margin-left: 2rem !important;
  }
  .ms-xxl-9 {
    margin-left: 2.25rem !important;
  }
  .ms-xxl-10 {
    margin-left: 2.5rem !important;
  }
  .ms-xxl-11 {
    margin-left: 2.75rem !important;
  }
  .ms-xxl-12 {
    margin-left: 3rem !important;
  }
  .ms-xxl-13 {
    margin-left: 3.25rem !important;
  }
  .ms-xxl-14 {
    margin-left: 3.5rem !important;
  }
  .ms-xxl-15 {
    margin-left: 3.75rem !important;
  }
  .ms-xxl-16 {
    margin-left: 4rem !important;
  }
  .ms-xxl-17 {
    margin-left: 4.25rem !important;
  }
  .ms-xxl-18 {
    margin-left: 4.5rem !important;
  }
  .ms-xxl-19 {
    margin-left: 4.75rem !important;
  }
  .ms-xxl-20 {
    margin-left: 5rem !important;
  }
  .ms-xxl-auto {
    margin-left: auto !important;
  }
  .m-xxl-n1 {
    margin: -0.25rem !important;
  }
  .m-xxl-n2 {
    margin: -0.5rem !important;
  }
  .m-xxl-n3 {
    margin: -0.75rem !important;
  }
  .m-xxl-n4 {
    margin: -1rem !important;
  }
  .m-xxl-n5 {
    margin: -1.25rem !important;
  }
  .m-xxl-n6 {
    margin: -1.5rem !important;
  }
  .m-xxl-n7 {
    margin: -1.75rem !important;
  }
  .m-xxl-n8 {
    margin: -2rem !important;
  }
  .m-xxl-n9 {
    margin: -2.25rem !important;
  }
  .m-xxl-n10 {
    margin: -2.5rem !important;
  }
  .m-xxl-n11 {
    margin: -2.75rem !important;
  }
  .m-xxl-n12 {
    margin: -3rem !important;
  }
  .m-xxl-n13 {
    margin: -3.25rem !important;
  }
  .m-xxl-n14 {
    margin: -3.5rem !important;
  }
  .m-xxl-n15 {
    margin: -3.75rem !important;
  }
  .m-xxl-n16 {
    margin: -4rem !important;
  }
  .m-xxl-n17 {
    margin: -4.25rem !important;
  }
  .m-xxl-n18 {
    margin: -4.5rem !important;
  }
  .m-xxl-n19 {
    margin: -4.75rem !important;
  }
  .m-xxl-n20 {
    margin: -5rem !important;
  }
  .mx-xxl-n1 {
    margin-right: -0.25rem !important;
    margin-left: -0.25rem !important;
  }
  .mx-xxl-n2 {
    margin-right: -0.5rem !important;
    margin-left: -0.5rem !important;
  }
  .mx-xxl-n3 {
    margin-right: -0.75rem !important;
    margin-left: -0.75rem !important;
  }
  .mx-xxl-n4 {
    margin-right: -1rem !important;
    margin-left: -1rem !important;
  }
  .mx-xxl-n5 {
    margin-right: -1.25rem !important;
    margin-left: -1.25rem !important;
  }
  .mx-xxl-n6 {
    margin-right: -1.5rem !important;
    margin-left: -1.5rem !important;
  }
  .mx-xxl-n7 {
    margin-right: -1.75rem !important;
    margin-left: -1.75rem !important;
  }
  .mx-xxl-n8 {
    margin-right: -2rem !important;
    margin-left: -2rem !important;
  }
  .mx-xxl-n9 {
    margin-right: -2.25rem !important;
    margin-left: -2.25rem !important;
  }
  .mx-xxl-n10 {
    margin-right: -2.5rem !important;
    margin-left: -2.5rem !important;
  }
  .mx-xxl-n11 {
    margin-right: -2.75rem !important;
    margin-left: -2.75rem !important;
  }
  .mx-xxl-n12 {
    margin-right: -3rem !important;
    margin-left: -3rem !important;
  }
  .mx-xxl-n13 {
    margin-right: -3.25rem !important;
    margin-left: -3.25rem !important;
  }
  .mx-xxl-n14 {
    margin-right: -3.5rem !important;
    margin-left: -3.5rem !important;
  }
  .mx-xxl-n15 {
    margin-right: -3.75rem !important;
    margin-left: -3.75rem !important;
  }
  .mx-xxl-n16 {
    margin-right: -4rem !important;
    margin-left: -4rem !important;
  }
  .mx-xxl-n17 {
    margin-right: -4.25rem !important;
    margin-left: -4.25rem !important;
  }
  .mx-xxl-n18 {
    margin-right: -4.5rem !important;
    margin-left: -4.5rem !important;
  }
  .mx-xxl-n19 {
    margin-right: -4.75rem !important;
    margin-left: -4.75rem !important;
  }
  .mx-xxl-n20 {
    margin-right: -5rem !important;
    margin-left: -5rem !important;
  }
  .my-xxl-n1 {
    margin-top: -0.25rem !important;
    margin-bottom: -0.25rem !important;
  }
  .my-xxl-n2 {
    margin-top: -0.5rem !important;
    margin-bottom: -0.5rem !important;
  }
  .my-xxl-n3 {
    margin-top: -0.75rem !important;
    margin-bottom: -0.75rem !important;
  }
  .my-xxl-n4 {
    margin-top: -1rem !important;
    margin-bottom: -1rem !important;
  }
  .my-xxl-n5 {
    margin-top: -1.25rem !important;
    margin-bottom: -1.25rem !important;
  }
  .my-xxl-n6 {
    margin-top: -1.5rem !important;
    margin-bottom: -1.5rem !important;
  }
  .my-xxl-n7 {
    margin-top: -1.75rem !important;
    margin-bottom: -1.75rem !important;
  }
  .my-xxl-n8 {
    margin-top: -2rem !important;
    margin-bottom: -2rem !important;
  }
  .my-xxl-n9 {
    margin-top: -2.25rem !important;
    margin-bottom: -2.25rem !important;
  }
  .my-xxl-n10 {
    margin-top: -2.5rem !important;
    margin-bottom: -2.5rem !important;
  }
  .my-xxl-n11 {
    margin-top: -2.75rem !important;
    margin-bottom: -2.75rem !important;
  }
  .my-xxl-n12 {
    margin-top: -3rem !important;
    margin-bottom: -3rem !important;
  }
  .my-xxl-n13 {
    margin-top: -3.25rem !important;
    margin-bottom: -3.25rem !important;
  }
  .my-xxl-n14 {
    margin-top: -3.5rem !important;
    margin-bottom: -3.5rem !important;
  }
  .my-xxl-n15 {
    margin-top: -3.75rem !important;
    margin-bottom: -3.75rem !important;
  }
  .my-xxl-n16 {
    margin-top: -4rem !important;
    margin-bottom: -4rem !important;
  }
  .my-xxl-n17 {
    margin-top: -4.25rem !important;
    margin-bottom: -4.25rem !important;
  }
  .my-xxl-n18 {
    margin-top: -4.5rem !important;
    margin-bottom: -4.5rem !important;
  }
  .my-xxl-n19 {
    margin-top: -4.75rem !important;
    margin-bottom: -4.75rem !important;
  }
  .my-xxl-n20 {
    margin-top: -5rem !important;
    margin-bottom: -5rem !important;
  }
  .mt-xxl-n1 {
    margin-top: -0.25rem !important;
  }
  .mt-xxl-n2 {
    margin-top: -0.5rem !important;
  }
  .mt-xxl-n3 {
    margin-top: -0.75rem !important;
  }
  .mt-xxl-n4 {
    margin-top: -1rem !important;
  }
  .mt-xxl-n5 {
    margin-top: -1.25rem !important;
  }
  .mt-xxl-n6 {
    margin-top: -1.5rem !important;
  }
  .mt-xxl-n7 {
    margin-top: -1.75rem !important;
  }
  .mt-xxl-n8 {
    margin-top: -2rem !important;
  }
  .mt-xxl-n9 {
    margin-top: -2.25rem !important;
  }
  .mt-xxl-n10 {
    margin-top: -2.5rem !important;
  }
  .mt-xxl-n11 {
    margin-top: -2.75rem !important;
  }
  .mt-xxl-n12 {
    margin-top: -3rem !important;
  }
  .mt-xxl-n13 {
    margin-top: -3.25rem !important;
  }
  .mt-xxl-n14 {
    margin-top: -3.5rem !important;
  }
  .mt-xxl-n15 {
    margin-top: -3.75rem !important;
  }
  .mt-xxl-n16 {
    margin-top: -4rem !important;
  }
  .mt-xxl-n17 {
    margin-top: -4.25rem !important;
  }
  .mt-xxl-n18 {
    margin-top: -4.5rem !important;
  }
  .mt-xxl-n19 {
    margin-top: -4.75rem !important;
  }
  .mt-xxl-n20 {
    margin-top: -5rem !important;
  }
  .me-xxl-n1 {
    margin-right: -0.25rem !important;
  }
  .me-xxl-n2 {
    margin-right: -0.5rem !important;
  }
  .me-xxl-n3 {
    margin-right: -0.75rem !important;
  }
  .me-xxl-n4 {
    margin-right: -1rem !important;
  }
  .me-xxl-n5 {
    margin-right: -1.25rem !important;
  }
  .me-xxl-n6 {
    margin-right: -1.5rem !important;
  }
  .me-xxl-n7 {
    margin-right: -1.75rem !important;
  }
  .me-xxl-n8 {
    margin-right: -2rem !important;
  }
  .me-xxl-n9 {
    margin-right: -2.25rem !important;
  }
  .me-xxl-n10 {
    margin-right: -2.5rem !important;
  }
  .me-xxl-n11 {
    margin-right: -2.75rem !important;
  }
  .me-xxl-n12 {
    margin-right: -3rem !important;
  }
  .me-xxl-n13 {
    margin-right: -3.25rem !important;
  }
  .me-xxl-n14 {
    margin-right: -3.5rem !important;
  }
  .me-xxl-n15 {
    margin-right: -3.75rem !important;
  }
  .me-xxl-n16 {
    margin-right: -4rem !important;
  }
  .me-xxl-n17 {
    margin-right: -4.25rem !important;
  }
  .me-xxl-n18 {
    margin-right: -4.5rem !important;
  }
  .me-xxl-n19 {
    margin-right: -4.75rem !important;
  }
  .me-xxl-n20 {
    margin-right: -5rem !important;
  }
  .mb-xxl-n1 {
    margin-bottom: -0.25rem !important;
  }
  .mb-xxl-n2 {
    margin-bottom: -0.5rem !important;
  }
  .mb-xxl-n3 {
    margin-bottom: -0.75rem !important;
  }
  .mb-xxl-n4 {
    margin-bottom: -1rem !important;
  }
  .mb-xxl-n5 {
    margin-bottom: -1.25rem !important;
  }
  .mb-xxl-n6 {
    margin-bottom: -1.5rem !important;
  }
  .mb-xxl-n7 {
    margin-bottom: -1.75rem !important;
  }
  .mb-xxl-n8 {
    margin-bottom: -2rem !important;
  }
  .mb-xxl-n9 {
    margin-bottom: -2.25rem !important;
  }
  .mb-xxl-n10 {
    margin-bottom: -2.5rem !important;
  }
  .mb-xxl-n11 {
    margin-bottom: -2.75rem !important;
  }
  .mb-xxl-n12 {
    margin-bottom: -3rem !important;
  }
  .mb-xxl-n13 {
    margin-bottom: -3.25rem !important;
  }
  .mb-xxl-n14 {
    margin-bottom: -3.5rem !important;
  }
  .mb-xxl-n15 {
    margin-bottom: -3.75rem !important;
  }
  .mb-xxl-n16 {
    margin-bottom: -4rem !important;
  }
  .mb-xxl-n17 {
    margin-bottom: -4.25rem !important;
  }
  .mb-xxl-n18 {
    margin-bottom: -4.5rem !important;
  }
  .mb-xxl-n19 {
    margin-bottom: -4.75rem !important;
  }
  .mb-xxl-n20 {
    margin-bottom: -5rem !important;
  }
  .ms-xxl-n1 {
    margin-left: -0.25rem !important;
  }
  .ms-xxl-n2 {
    margin-left: -0.5rem !important;
  }
  .ms-xxl-n3 {
    margin-left: -0.75rem !important;
  }
  .ms-xxl-n4 {
    margin-left: -1rem !important;
  }
  .ms-xxl-n5 {
    margin-left: -1.25rem !important;
  }
  .ms-xxl-n6 {
    margin-left: -1.5rem !important;
  }
  .ms-xxl-n7 {
    margin-left: -1.75rem !important;
  }
  .ms-xxl-n8 {
    margin-left: -2rem !important;
  }
  .ms-xxl-n9 {
    margin-left: -2.25rem !important;
  }
  .ms-xxl-n10 {
    margin-left: -2.5rem !important;
  }
  .ms-xxl-n11 {
    margin-left: -2.75rem !important;
  }
  .ms-xxl-n12 {
    margin-left: -3rem !important;
  }
  .ms-xxl-n13 {
    margin-left: -3.25rem !important;
  }
  .ms-xxl-n14 {
    margin-left: -3.5rem !important;
  }
  .ms-xxl-n15 {
    margin-left: -3.75rem !important;
  }
  .ms-xxl-n16 {
    margin-left: -4rem !important;
  }
  .ms-xxl-n17 {
    margin-left: -4.25rem !important;
  }
  .ms-xxl-n18 {
    margin-left: -4.5rem !important;
  }
  .ms-xxl-n19 {
    margin-left: -4.75rem !important;
  }
  .ms-xxl-n20 {
    margin-left: -5rem !important;
  }
  .p-xxl-0 {
    padding: 0 !important;
  }
  .p-xxl-1 {
    padding: 0.25rem !important;
  }
  .p-xxl-2 {
    padding: 0.5rem !important;
  }
  .p-xxl-3 {
    padding: 0.75rem !important;
  }
  .p-xxl-4 {
    padding: 1rem !important;
  }
  .p-xxl-5 {
    padding: 1.25rem !important;
  }
  .p-xxl-6 {
    padding: 1.5rem !important;
  }
  .p-xxl-7 {
    padding: 1.75rem !important;
  }
  .p-xxl-8 {
    padding: 2rem !important;
  }
  .p-xxl-9 {
    padding: 2.25rem !important;
  }
  .p-xxl-10 {
    padding: 2.5rem !important;
  }
  .p-xxl-11 {
    padding: 2.75rem !important;
  }
  .p-xxl-12 {
    padding: 3rem !important;
  }
  .p-xxl-13 {
    padding: 3.25rem !important;
  }
  .p-xxl-14 {
    padding: 3.5rem !important;
  }
  .p-xxl-15 {
    padding: 3.75rem !important;
  }
  .p-xxl-16 {
    padding: 4rem !important;
  }
  .p-xxl-17 {
    padding: 4.25rem !important;
  }
  .p-xxl-18 {
    padding: 4.5rem !important;
  }
  .p-xxl-19 {
    padding: 4.75rem !important;
  }
  .p-xxl-20 {
    padding: 5rem !important;
  }
  .px-xxl-0 {
    padding-right: 0 !important;
    padding-left: 0 !important;
  }
  .px-xxl-1 {
    padding-right: 0.25rem !important;
    padding-left: 0.25rem !important;
  }
  .px-xxl-2 {
    padding-right: 0.5rem !important;
    padding-left: 0.5rem !important;
  }
  .px-xxl-3 {
    padding-right: 0.75rem !important;
    padding-left: 0.75rem !important;
  }
  .px-xxl-4 {
    padding-right: 1rem !important;
    padding-left: 1rem !important;
  }
  .px-xxl-5 {
    padding-right: 1.25rem !important;
    padding-left: 1.25rem !important;
  }
  .px-xxl-6 {
    padding-right: 1.5rem !important;
    padding-left: 1.5rem !important;
  }
  .px-xxl-7 {
    padding-right: 1.75rem !important;
    padding-left: 1.75rem !important;
  }
  .px-xxl-8 {
    padding-right: 2rem !important;
    padding-left: 2rem !important;
  }
  .px-xxl-9 {
    padding-right: 2.25rem !important;
    padding-left: 2.25rem !important;
  }
  .px-xxl-10 {
    padding-right: 2.5rem !important;
    padding-left: 2.5rem !important;
  }
  .px-xxl-11 {
    padding-right: 2.75rem !important;
    padding-left: 2.75rem !important;
  }
  .px-xxl-12 {
    padding-right: 3rem !important;
    padding-left: 3rem !important;
  }
  .px-xxl-13 {
    padding-right: 3.25rem !important;
    padding-left: 3.25rem !important;
  }
  .px-xxl-14 {
    padding-right: 3.5rem !important;
    padding-left: 3.5rem !important;
  }
  .px-xxl-15 {
    padding-right: 3.75rem !important;
    padding-left: 3.75rem !important;
  }
  .px-xxl-16 {
    padding-right: 4rem !important;
    padding-left: 4rem !important;
  }
  .px-xxl-17 {
    padding-right: 4.25rem !important;
    padding-left: 4.25rem !important;
  }
  .px-xxl-18 {
    padding-right: 4.5rem !important;
    padding-left: 4.5rem !important;
  }
  .px-xxl-19 {
    padding-right: 4.75rem !important;
    padding-left: 4.75rem !important;
  }
  .px-xxl-20 {
    padding-right: 5rem !important;
    padding-left: 5rem !important;
  }
  .py-xxl-0 {
    padding-top: 0 !important;
    padding-bottom: 0 !important;
  }
  .py-xxl-1 {
    padding-top: 0.25rem !important;
    padding-bottom: 0.25rem !important;
  }
  .py-xxl-2 {
    padding-top: 0.5rem !important;
    padding-bottom: 0.5rem !important;
  }
  .py-xxl-3 {
    padding-top: 0.75rem !important;
    padding-bottom: 0.75rem !important;
  }
  .py-xxl-4 {
    padding-top: 1rem !important;
    padding-bottom: 1rem !important;
  }
  .py-xxl-5 {
    padding-top: 1.25rem !important;
    padding-bottom: 1.25rem !important;
  }
  .py-xxl-6 {
    padding-top: 1.5rem !important;
    padding-bottom: 1.5rem !important;
  }
  .py-xxl-7 {
    padding-top: 1.75rem !important;
    padding-bottom: 1.75rem !important;
  }
  .py-xxl-8 {
    padding-top: 2rem !important;
    padding-bottom: 2rem !important;
  }
  .py-xxl-9 {
    padding-top: 2.25rem !important;
    padding-bottom: 2.25rem !important;
  }
  .py-xxl-10 {
    padding-top: 2.5rem !important;
    padding-bottom: 2.5rem !important;
  }
  .py-xxl-11 {
    padding-top: 2.75rem !important;
    padding-bottom: 2.75rem !important;
  }
  .py-xxl-12 {
    padding-top: 3rem !important;
    padding-bottom: 3rem !important;
  }
  .py-xxl-13 {
    padding-top: 3.25rem !important;
    padding-bottom: 3.25rem !important;
  }
  .py-xxl-14 {
    padding-top: 3.5rem !important;
    padding-bottom: 3.5rem !important;
  }
  .py-xxl-15 {
    padding-top: 3.75rem !important;
    padding-bottom: 3.75rem !important;
  }
  .py-xxl-16 {
    padding-top: 4rem !important;
    padding-bottom: 4rem !important;
  }
  .py-xxl-17 {
    padding-top: 4.25rem !important;
    padding-bottom: 4.25rem !important;
  }
  .py-xxl-18 {
    padding-top: 4.5rem !important;
    padding-bottom: 4.5rem !important;
  }
  .py-xxl-19 {
    padding-top: 4.75rem !important;
    padding-bottom: 4.75rem !important;
  }
  .py-xxl-20 {
    padding-top: 5rem !important;
    padding-bottom: 5rem !important;
  }
  .pt-xxl-0 {
    padding-top: 0 !important;
  }
  .pt-xxl-1 {
    padding-top: 0.25rem !important;
  }
  .pt-xxl-2 {
    padding-top: 0.5rem !important;
  }
  .pt-xxl-3 {
    padding-top: 0.75rem !important;
  }
  .pt-xxl-4 {
    padding-top: 1rem !important;
  }
  .pt-xxl-5 {
    padding-top: 1.25rem !important;
  }
  .pt-xxl-6 {
    padding-top: 1.5rem !important;
  }
  .pt-xxl-7 {
    padding-top: 1.75rem !important;
  }
  .pt-xxl-8 {
    padding-top: 2rem !important;
  }
  .pt-xxl-9 {
    padding-top: 2.25rem !important;
  }
  .pt-xxl-10 {
    padding-top: 2.5rem !important;
  }
  .pt-xxl-11 {
    padding-top: 2.75rem !important;
  }
  .pt-xxl-12 {
    padding-top: 3rem !important;
  }
  .pt-xxl-13 {
    padding-top: 3.25rem !important;
  }
  .pt-xxl-14 {
    padding-top: 3.5rem !important;
  }
  .pt-xxl-15 {
    padding-top: 3.75rem !important;
  }
  .pt-xxl-16 {
    padding-top: 4rem !important;
  }
  .pt-xxl-17 {
    padding-top: 4.25rem !important;
  }
  .pt-xxl-18 {
    padding-top: 4.5rem !important;
  }
  .pt-xxl-19 {
    padding-top: 4.75rem !important;
  }
  .pt-xxl-20 {
    padding-top: 5rem !important;
  }
  .pe-xxl-0 {
    padding-right: 0 !important;
  }
  .pe-xxl-1 {
    padding-right: 0.25rem !important;
  }
  .pe-xxl-2 {
    padding-right: 0.5rem !important;
  }
  .pe-xxl-3 {
    padding-right: 0.75rem !important;
  }
  .pe-xxl-4 {
    padding-right: 1rem !important;
  }
  .pe-xxl-5 {
    padding-right: 1.25rem !important;
  }
  .pe-xxl-6 {
    padding-right: 1.5rem !important;
  }
  .pe-xxl-7 {
    padding-right: 1.75rem !important;
  }
  .pe-xxl-8 {
    padding-right: 2rem !important;
  }
  .pe-xxl-9 {
    padding-right: 2.25rem !important;
  }
  .pe-xxl-10 {
    padding-right: 2.5rem !important;
  }
  .pe-xxl-11 {
    padding-right: 2.75rem !important;
  }
  .pe-xxl-12 {
    padding-right: 3rem !important;
  }
  .pe-xxl-13 {
    padding-right: 3.25rem !important;
  }
  .pe-xxl-14 {
    padding-right: 3.5rem !important;
  }
  .pe-xxl-15 {
    padding-right: 3.75rem !important;
  }
  .pe-xxl-16 {
    padding-right: 4rem !important;
  }
  .pe-xxl-17 {
    padding-right: 4.25rem !important;
  }
  .pe-xxl-18 {
    padding-right: 4.5rem !important;
  }
  .pe-xxl-19 {
    padding-right: 4.75rem !important;
  }
  .pe-xxl-20 {
    padding-right: 5rem !important;
  }
  .pb-xxl-0 {
    padding-bottom: 0 !important;
  }
  .pb-xxl-1 {
    padding-bottom: 0.25rem !important;
  }
  .pb-xxl-2 {
    padding-bottom: 0.5rem !important;
  }
  .pb-xxl-3 {
    padding-bottom: 0.75rem !important;
  }
  .pb-xxl-4 {
    padding-bottom: 1rem !important;
  }
  .pb-xxl-5 {
    padding-bottom: 1.25rem !important;
  }
  .pb-xxl-6 {
    padding-bottom: 1.5rem !important;
  }
  .pb-xxl-7 {
    padding-bottom: 1.75rem !important;
  }
  .pb-xxl-8 {
    padding-bottom: 2rem !important;
  }
  .pb-xxl-9 {
    padding-bottom: 2.25rem !important;
  }
  .pb-xxl-10 {
    padding-bottom: 2.5rem !important;
  }
  .pb-xxl-11 {
    padding-bottom: 2.75rem !important;
  }
  .pb-xxl-12 {
    padding-bottom: 3rem !important;
  }
  .pb-xxl-13 {
    padding-bottom: 3.25rem !important;
  }
  .pb-xxl-14 {
    padding-bottom: 3.5rem !important;
  }
  .pb-xxl-15 {
    padding-bottom: 3.75rem !important;
  }
  .pb-xxl-16 {
    padding-bottom: 4rem !important;
  }
  .pb-xxl-17 {
    padding-bottom: 4.25rem !important;
  }
  .pb-xxl-18 {
    padding-bottom: 4.5rem !important;
  }
  .pb-xxl-19 {
    padding-bottom: 4.75rem !important;
  }
  .pb-xxl-20 {
    padding-bottom: 5rem !important;
  }
  .ps-xxl-0 {
    padding-left: 0 !important;
  }
  .ps-xxl-1 {
    padding-left: 0.25rem !important;
  }
  .ps-xxl-2 {
    padding-left: 0.5rem !important;
  }
  .ps-xxl-3 {
    padding-left: 0.75rem !important;
  }
  .ps-xxl-4 {
    padding-left: 1rem !important;
  }
  .ps-xxl-5 {
    padding-left: 1.25rem !important;
  }
  .ps-xxl-6 {
    padding-left: 1.5rem !important;
  }
  .ps-xxl-7 {
    padding-left: 1.75rem !important;
  }
  .ps-xxl-8 {
    padding-left: 2rem !important;
  }
  .ps-xxl-9 {
    padding-left: 2.25rem !important;
  }
  .ps-xxl-10 {
    padding-left: 2.5rem !important;
  }
  .ps-xxl-11 {
    padding-left: 2.75rem !important;
  }
  .ps-xxl-12 {
    padding-left: 3rem !important;
  }
  .ps-xxl-13 {
    padding-left: 3.25rem !important;
  }
  .ps-xxl-14 {
    padding-left: 3.5rem !important;
  }
  .ps-xxl-15 {
    padding-left: 3.75rem !important;
  }
  .ps-xxl-16 {
    padding-left: 4rem !important;
  }
  .ps-xxl-17 {
    padding-left: 4.25rem !important;
  }
  .ps-xxl-18 {
    padding-left: 4.5rem !important;
  }
  .ps-xxl-19 {
    padding-left: 4.75rem !important;
  }
  .ps-xxl-20 {
    padding-left: 5rem !important;
  }
  .gap-xxl-0 {
    gap: 0 !important;
  }
  .gap-xxl-1 {
    gap: 0.25rem !important;
  }
  .gap-xxl-2 {
    gap: 0.5rem !important;
  }
  .gap-xxl-3 {
    gap: 0.75rem !important;
  }
  .gap-xxl-4 {
    gap: 1rem !important;
  }
  .gap-xxl-5 {
    gap: 1.25rem !important;
  }
  .gap-xxl-6 {
    gap: 1.5rem !important;
  }
  .gap-xxl-7 {
    gap: 1.75rem !important;
  }
  .gap-xxl-8 {
    gap: 2rem !important;
  }
  .gap-xxl-9 {
    gap: 2.25rem !important;
  }
  .gap-xxl-10 {
    gap: 2.5rem !important;
  }
  .gap-xxl-11 {
    gap: 2.75rem !important;
  }
  .gap-xxl-12 {
    gap: 3rem !important;
  }
  .gap-xxl-13 {
    gap: 3.25rem !important;
  }
  .gap-xxl-14 {
    gap: 3.5rem !important;
  }
  .gap-xxl-15 {
    gap: 3.75rem !important;
  }
  .gap-xxl-16 {
    gap: 4rem !important;
  }
  .gap-xxl-17 {
    gap: 4.25rem !important;
  }
  .gap-xxl-18 {
    gap: 4.5rem !important;
  }
  .gap-xxl-19 {
    gap: 4.75rem !important;
  }
  .gap-xxl-20 {
    gap: 5rem !important;
  }
  .row-gap-xxl-0 {
    row-gap: 0 !important;
  }
  .row-gap-xxl-1 {
    row-gap: 0.25rem !important;
  }
  .row-gap-xxl-2 {
    row-gap: 0.5rem !important;
  }
  .row-gap-xxl-3 {
    row-gap: 0.75rem !important;
  }
  .row-gap-xxl-4 {
    row-gap: 1rem !important;
  }
  .row-gap-xxl-5 {
    row-gap: 1.25rem !important;
  }
  .row-gap-xxl-6 {
    row-gap: 1.5rem !important;
  }
  .row-gap-xxl-7 {
    row-gap: 1.75rem !important;
  }
  .row-gap-xxl-8 {
    row-gap: 2rem !important;
  }
  .row-gap-xxl-9 {
    row-gap: 2.25rem !important;
  }
  .row-gap-xxl-10 {
    row-gap: 2.5rem !important;
  }
  .row-gap-xxl-11 {
    row-gap: 2.75rem !important;
  }
  .row-gap-xxl-12 {
    row-gap: 3rem !important;
  }
  .row-gap-xxl-13 {
    row-gap: 3.25rem !important;
  }
  .row-gap-xxl-14 {
    row-gap: 3.5rem !important;
  }
  .row-gap-xxl-15 {
    row-gap: 3.75rem !important;
  }
  .row-gap-xxl-16 {
    row-gap: 4rem !important;
  }
  .row-gap-xxl-17 {
    row-gap: 4.25rem !important;
  }
  .row-gap-xxl-18 {
    row-gap: 4.5rem !important;
  }
  .row-gap-xxl-19 {
    row-gap: 4.75rem !important;
  }
  .row-gap-xxl-20 {
    row-gap: 5rem !important;
  }
  .column-gap-xxl-0 {
    column-gap: 0 !important;
  }
  .column-gap-xxl-1 {
    column-gap: 0.25rem !important;
  }
  .column-gap-xxl-2 {
    column-gap: 0.5rem !important;
  }
  .column-gap-xxl-3 {
    column-gap: 0.75rem !important;
  }
  .column-gap-xxl-4 {
    column-gap: 1rem !important;
  }
  .column-gap-xxl-5 {
    column-gap: 1.25rem !important;
  }
  .column-gap-xxl-6 {
    column-gap: 1.5rem !important;
  }
  .column-gap-xxl-7 {
    column-gap: 1.75rem !important;
  }
  .column-gap-xxl-8 {
    column-gap: 2rem !important;
  }
  .column-gap-xxl-9 {
    column-gap: 2.25rem !important;
  }
  .column-gap-xxl-10 {
    column-gap: 2.5rem !important;
  }
  .column-gap-xxl-11 {
    column-gap: 2.75rem !important;
  }
  .column-gap-xxl-12 {
    column-gap: 3rem !important;
  }
  .column-gap-xxl-13 {
    column-gap: 3.25rem !important;
  }
  .column-gap-xxl-14 {
    column-gap: 3.5rem !important;
  }
  .column-gap-xxl-15 {
    column-gap: 3.75rem !important;
  }
  .column-gap-xxl-16 {
    column-gap: 4rem !important;
  }
  .column-gap-xxl-17 {
    column-gap: 4.25rem !important;
  }
  .column-gap-xxl-18 {
    column-gap: 4.5rem !important;
  }
  .column-gap-xxl-19 {
    column-gap: 4.75rem !important;
  }
  .column-gap-xxl-20 {
    column-gap: 5rem !important;
  }
  .fs-xxl-1 {
    font-size: calc(1.3rem + 0.6vw) !important;
  }
  .fs-xxl-2 {
    font-size: calc(1.275rem + 0.3vw) !important;
  }
  .fs-xxl-3 {
    font-size: calc(1.26rem + 0.12vw) !important;
  }
  .fs-xxl-4 {
    font-size: 1.25rem !important;
  }
  .fs-xxl-5 {
    font-size: 1.15rem !important;
  }
  .fs-xxl-6 {
    font-size: 1.075rem !important;
  }
  .fs-xxl-7 {
    font-size: 0.95rem !important;
  }
  .fs-xxl-8 {
    font-size: 0.85rem !important;
  }
  .fs-xxl-9 {
    font-size: 0.75rem !important;
  }
  .fs-xxl-10 {
    font-size: 0.5rem !important;
  }
  .fs-xxl-base {
    font-size: 1rem !important;
  }
  .fs-xxl-fluid {
    font-size: 100% !important;
  }
  .fs-xxl-2x {
    font-size: calc(1.325rem + 0.9vw) !important;
  }
  .fs-xxl-2qx {
    font-size: calc(1.35rem + 1.2vw) !important;
  }
  .fs-xxl-2hx {
    font-size: calc(1.375rem + 1.5vw) !important;
  }
  .fs-xxl-2tx {
    font-size: calc(1.4rem + 1.8vw) !important;
  }
  .fs-xxl-3x {
    font-size: calc(1.425rem + 2.1vw) !important;
  }
  .fs-xxl-3qx {
    font-size: calc(1.45rem + 2.4vw) !important;
  }
  .fs-xxl-3hx {
    font-size: calc(1.475rem + 2.7vw) !important;
  }
  .fs-xxl-3tx {
    font-size: calc(1.5rem + 3vw) !important;
  }
  .fs-xxl-4x {
    font-size: calc(1.525rem + 3.3vw) !important;
  }
  .fs-xxl-4qx {
    font-size: calc(1.55rem + 3.6vw) !important;
  }
  .fs-xxl-4hx {
    font-size: calc(1.575rem + 3.9vw) !important;
  }
  .fs-xxl-4tx {
    font-size: calc(1.6rem + 4.2vw) !important;
  }
  .fs-xxl-5x {
    font-size: calc(1.625rem + 4.5vw) !important;
  }
  .fs-xxl-5qx {
    font-size: calc(1.65rem + 4.8vw) !important;
  }
  .fs-xxl-5hx {
    font-size: calc(1.675rem + 5.1vw) !important;
  }
  .fs-xxl-5tx {
    font-size: calc(1.7rem + 5.4vw) !important;
  }
  .fs-xxl-6x {
    font-size: calc(1.725rem + 5.7vw) !important;
  }
  .fs-xxl-6qx {
    font-size: calc(1.75rem + 6vw) !important;
  }
  .fs-xxl-6hx {
    font-size: calc(1.775rem + 6.3vw) !important;
  }
  .fs-xxl-6tx {
    font-size: calc(1.8rem + 6.6vw) !important;
  }
  .fs-xxl-7x {
    font-size: calc(1.825rem + 6.9vw) !important;
  }
  .fs-xxl-7qx {
    font-size: calc(1.85rem + 7.2vw) !important;
  }
  .fs-xxl-7hx {
    font-size: calc(1.875rem + 7.5vw) !important;
  }
  .fs-xxl-7tx {
    font-size: calc(1.9rem + 7.8vw) !important;
  }
  .text-xxl-start {
    text-align: left !important;
  }
  .text-xxl-end {
    text-align: right !important;
  }
  .text-xxl-center {
    text-align: center !important;
  }
  .min-w-xxl-unset {
    min-width: unset !important;
  }
  .min-w-xxl-25 {
    min-width: 25% !important;
  }
  .min-w-xxl-50 {
    min-width: 50% !important;
  }
  .min-w-xxl-75 {
    min-width: 75% !important;
  }
  .min-w-xxl-100 {
    min-width: 100% !important;
  }
  .min-w-xxl-auto {
    min-width: auto !important;
  }
  .min-w-xxl-1px {
    min-width: 1px !important;
  }
  .min-w-xxl-2px {
    min-width: 2px !important;
  }
  .min-w-xxl-3px {
    min-width: 3px !important;
  }
  .min-w-xxl-4px {
    min-width: 4px !important;
  }
  .min-w-xxl-5px {
    min-width: 5px !important;
  }
  .min-w-xxl-6px {
    min-width: 6px !important;
  }
  .min-w-xxl-7px {
    min-width: 7px !important;
  }
  .min-w-xxl-8px {
    min-width: 8px !important;
  }
  .min-w-xxl-9px {
    min-width: 9px !important;
  }
  .min-w-xxl-10px {
    min-width: 10px !important;
  }
  .min-w-xxl-15px {
    min-width: 15px !important;
  }
  .min-w-xxl-20px {
    min-width: 20px !important;
  }
  .min-w-xxl-25px {
    min-width: 25px !important;
  }
  .min-w-xxl-30px {
    min-width: 30px !important;
  }
  .min-w-xxl-35px {
    min-width: 35px !important;
  }
  .min-w-xxl-40px {
    min-width: 40px !important;
  }
  .min-w-xxl-45px {
    min-width: 45px !important;
  }
  .min-w-xxl-50px {
    min-width: 50px !important;
  }
  .min-w-xxl-55px {
    min-width: 55px !important;
  }
  .min-w-xxl-60px {
    min-width: 60px !important;
  }
  .min-w-xxl-65px {
    min-width: 65px !important;
  }
  .min-w-xxl-70px {
    min-width: 70px !important;
  }
  .min-w-xxl-75px {
    min-width: 75px !important;
  }
  .min-w-xxl-80px {
    min-width: 80px !important;
  }
  .min-w-xxl-85px {
    min-width: 85px !important;
  }
  .min-w-xxl-90px {
    min-width: 90px !important;
  }
  .min-w-xxl-95px {
    min-width: 95px !important;
  }
  .min-w-xxl-100px {
    min-width: 100px !important;
  }
  .min-w-xxl-125px {
    min-width: 125px !important;
  }
  .min-w-xxl-150px {
    min-width: 150px !important;
  }
  .min-w-xxl-175px {
    min-width: 175px !important;
  }
  .min-w-xxl-200px {
    min-width: 200px !important;
  }
  .min-w-xxl-225px {
    min-width: 225px !important;
  }
  .min-w-xxl-250px {
    min-width: 250px !important;
  }
  .min-w-xxl-275px {
    min-width: 275px !important;
  }
  .min-w-xxl-300px {
    min-width: 300px !important;
  }
  .min-w-xxl-325px {
    min-width: 325px !important;
  }
  .min-w-xxl-350px {
    min-width: 350px !important;
  }
  .min-w-xxl-375px {
    min-width: 375px !important;
  }
  .min-w-xxl-400px {
    min-width: 400px !important;
  }
  .min-w-xxl-425px {
    min-width: 425px !important;
  }
  .min-w-xxl-450px {
    min-width: 450px !important;
  }
  .min-w-xxl-475px {
    min-width: 475px !important;
  }
  .min-w-xxl-500px {
    min-width: 500px !important;
  }
  .min-w-xxl-550px {
    min-width: 550px !important;
  }
  .min-w-xxl-600px {
    min-width: 600px !important;
  }
  .min-w-xxl-650px {
    min-width: 650px !important;
  }
  .min-w-xxl-700px {
    min-width: 700px !important;
  }
  .min-w-xxl-750px {
    min-width: 750px !important;
  }
  .min-w-xxl-800px {
    min-width: 800px !important;
  }
  .min-w-xxl-850px {
    min-width: 850px !important;
  }
  .min-w-xxl-900px {
    min-width: 900px !important;
  }
  .min-w-xxl-950px {
    min-width: 950px !important;
  }
  .min-w-xxl-1000px {
    min-width: 1000px !important;
  }
  .min-h-xxl-unset {
    min-height: unset !important;
  }
  .min-h-xxl-25 {
    min-height: 25% !important;
  }
  .min-h-xxl-50 {
    min-height: 50% !important;
  }
  .min-h-xxl-75 {
    min-height: 75% !important;
  }
  .min-h-xxl-100 {
    min-height: 100% !important;
  }
  .min-h-xxl-auto {
    min-height: auto !important;
  }
  .min-h-xxl-1px {
    min-height: 1px !important;
  }
  .min-h-xxl-2px {
    min-height: 2px !important;
  }
  .min-h-xxl-3px {
    min-height: 3px !important;
  }
  .min-h-xxl-4px {
    min-height: 4px !important;
  }
  .min-h-xxl-5px {
    min-height: 5px !important;
  }
  .min-h-xxl-6px {
    min-height: 6px !important;
  }
  .min-h-xxl-7px {
    min-height: 7px !important;
  }
  .min-h-xxl-8px {
    min-height: 8px !important;
  }
  .min-h-xxl-9px {
    min-height: 9px !important;
  }
  .min-h-xxl-10px {
    min-height: 10px !important;
  }
  .min-h-xxl-15px {
    min-height: 15px !important;
  }
  .min-h-xxl-20px {
    min-height: 20px !important;
  }
  .min-h-xxl-25px {
    min-height: 25px !important;
  }
  .min-h-xxl-30px {
    min-height: 30px !important;
  }
  .min-h-xxl-35px {
    min-height: 35px !important;
  }
  .min-h-xxl-40px {
    min-height: 40px !important;
  }
  .min-h-xxl-45px {
    min-height: 45px !important;
  }
  .min-h-xxl-50px {
    min-height: 50px !important;
  }
  .min-h-xxl-55px {
    min-height: 55px !important;
  }
  .min-h-xxl-60px {
    min-height: 60px !important;
  }
  .min-h-xxl-65px {
    min-height: 65px !important;
  }
  .min-h-xxl-70px {
    min-height: 70px !important;
  }
  .min-h-xxl-75px {
    min-height: 75px !important;
  }
  .min-h-xxl-80px {
    min-height: 80px !important;
  }
  .min-h-xxl-85px {
    min-height: 85px !important;
  }
  .min-h-xxl-90px {
    min-height: 90px !important;
  }
  .min-h-xxl-95px {
    min-height: 95px !important;
  }
  .min-h-xxl-100px {
    min-height: 100px !important;
  }
  .min-h-xxl-125px {
    min-height: 125px !important;
  }
  .min-h-xxl-150px {
    min-height: 150px !important;
  }
  .min-h-xxl-175px {
    min-height: 175px !important;
  }
  .min-h-xxl-200px {
    min-height: 200px !important;
  }
  .min-h-xxl-225px {
    min-height: 225px !important;
  }
  .min-h-xxl-250px {
    min-height: 250px !important;
  }
  .min-h-xxl-275px {
    min-height: 275px !important;
  }
  .min-h-xxl-300px {
    min-height: 300px !important;
  }
  .min-h-xxl-325px {
    min-height: 325px !important;
  }
  .min-h-xxl-350px {
    min-height: 350px !important;
  }
  .min-h-xxl-375px {
    min-height: 375px !important;
  }
  .min-h-xxl-400px {
    min-height: 400px !important;
  }
  .min-h-xxl-425px {
    min-height: 425px !important;
  }
  .min-h-xxl-450px {
    min-height: 450px !important;
  }
  .min-h-xxl-475px {
    min-height: 475px !important;
  }
  .min-h-xxl-500px {
    min-height: 500px !important;
  }
  .min-h-xxl-550px {
    min-height: 550px !important;
  }
  .min-h-xxl-600px {
    min-height: 600px !important;
  }
  .min-h-xxl-650px {
    min-height: 650px !important;
  }
  .min-h-xxl-700px {
    min-height: 700px !important;
  }
  .min-h-xxl-750px {
    min-height: 750px !important;
  }
  .min-h-xxl-800px {
    min-height: 800px !important;
  }
  .min-h-xxl-850px {
    min-height: 850px !important;
  }
  .min-h-xxl-900px {
    min-height: 900px !important;
  }
  .min-h-xxl-950px {
    min-height: 950px !important;
  }
  .min-h-xxl-1000px {
    min-height: 1000px !important;
  }
}
@media (min-width: 1200px) {
  .fs-1 {
    font-size: 1.75rem !important;
  }
  .fs-2 {
    font-size: 1.5rem !important;
  }
  .fs-3 {
    font-size: 1.35rem !important;
  }
  .fs-2x {
    font-size: 2rem !important;
  }
  .fs-2qx {
    font-size: 2.25rem !important;
  }
  .fs-2hx {
    font-size: 2.5rem !important;
  }
  .fs-2tx {
    font-size: 2.75rem !important;
  }
  .fs-3x {
    font-size: 3rem !important;
  }
  .fs-3qx {
    font-size: 3.25rem !important;
  }
  .fs-3hx {
    font-size: 3.5rem !important;
  }
  .fs-3tx {
    font-size: 3.75rem !important;
  }
  .fs-4x {
    font-size: 4rem !important;
  }
  .fs-4qx {
    font-size: 4.25rem !important;
  }
  .fs-4hx {
    font-size: 4.5rem !important;
  }
  .fs-4tx {
    font-size: 4.75rem !important;
  }
  .fs-5x {
    font-size: 5rem !important;
  }
  .fs-5qx {
    font-size: 5.25rem !important;
  }
  .fs-5hx {
    font-size: 5.5rem !important;
  }
  .fs-5tx {
    font-size: 5.75rem !important;
  }
  .fs-6x {
    font-size: 6rem !important;
  }
  .fs-6qx {
    font-size: 6.25rem !important;
  }
  .fs-6hx {
    font-size: 6.5rem !important;
  }
  .fs-6tx {
    font-size: 6.75rem !important;
  }
  .fs-7x {
    font-size: 7rem !important;
  }
  .fs-7qx {
    font-size: 7.25rem !important;
  }
  .fs-7hx {
    font-size: 7.5rem !important;
  }
  .fs-7tx {
    font-size: 7.75rem !important;
  }
  .fs-sm-1 {
    font-size: 1.75rem !important;
  }
  .fs-sm-2 {
    font-size: 1.5rem !important;
  }
  .fs-sm-3 {
    font-size: 1.35rem !important;
  }
  .fs-sm-2x {
    font-size: 2rem !important;
  }
  .fs-sm-2qx {
    font-size: 2.25rem !important;
  }
  .fs-sm-2hx {
    font-size: 2.5rem !important;
  }
  .fs-sm-2tx {
    font-size: 2.75rem !important;
  }
  .fs-sm-3x {
    font-size: 3rem !important;
  }
  .fs-sm-3qx {
    font-size: 3.25rem !important;
  }
  .fs-sm-3hx {
    font-size: 3.5rem !important;
  }
  .fs-sm-3tx {
    font-size: 3.75rem !important;
  }
  .fs-sm-4x {
    font-size: 4rem !important;
  }
  .fs-sm-4qx {
    font-size: 4.25rem !important;
  }
  .fs-sm-4hx {
    font-size: 4.5rem !important;
  }
  .fs-sm-4tx {
    font-size: 4.75rem !important;
  }
  .fs-sm-5x {
    font-size: 5rem !important;
  }
  .fs-sm-5qx {
    font-size: 5.25rem !important;
  }
  .fs-sm-5hx {
    font-size: 5.5rem !important;
  }
  .fs-sm-5tx {
    font-size: 5.75rem !important;
  }
  .fs-sm-6x {
    font-size: 6rem !important;
  }
  .fs-sm-6qx {
    font-size: 6.25rem !important;
  }
  .fs-sm-6hx {
    font-size: 6.5rem !important;
  }
  .fs-sm-6tx {
    font-size: 6.75rem !important;
  }
  .fs-sm-7x {
    font-size: 7rem !important;
  }
  .fs-sm-7qx {
    font-size: 7.25rem !important;
  }
  .fs-sm-7hx {
    font-size: 7.5rem !important;
  }
  .fs-sm-7tx {
    font-size: 7.75rem !important;
  }
  .fs-md-1 {
    font-size: 1.75rem !important;
  }
  .fs-md-2 {
    font-size: 1.5rem !important;
  }
  .fs-md-3 {
    font-size: 1.35rem !important;
  }
  .fs-md-2x {
    font-size: 2rem !important;
  }
  .fs-md-2qx {
    font-size: 2.25rem !important;
  }
  .fs-md-2hx {
    font-size: 2.5rem !important;
  }
  .fs-md-2tx {
    font-size: 2.75rem !important;
  }
  .fs-md-3x {
    font-size: 3rem !important;
  }
  .fs-md-3qx {
    font-size: 3.25rem !important;
  }
  .fs-md-3hx {
    font-size: 3.5rem !important;
  }
  .fs-md-3tx {
    font-size: 3.75rem !important;
  }
  .fs-md-4x {
    font-size: 4rem !important;
  }
  .fs-md-4qx {
    font-size: 4.25rem !important;
  }
  .fs-md-4hx {
    font-size: 4.5rem !important;
  }
  .fs-md-4tx {
    font-size: 4.75rem !important;
  }
  .fs-md-5x {
    font-size: 5rem !important;
  }
  .fs-md-5qx {
    font-size: 5.25rem !important;
  }
  .fs-md-5hx {
    font-size: 5.5rem !important;
  }
  .fs-md-5tx {
    font-size: 5.75rem !important;
  }
  .fs-md-6x {
    font-size: 6rem !important;
  }
  .fs-md-6qx {
    font-size: 6.25rem !important;
  }
  .fs-md-6hx {
    font-size: 6.5rem !important;
  }
  .fs-md-6tx {
    font-size: 6.75rem !important;
  }
  .fs-md-7x {
    font-size: 7rem !important;
  }
  .fs-md-7qx {
    font-size: 7.25rem !important;
  }
  .fs-md-7hx {
    font-size: 7.5rem !important;
  }
  .fs-md-7tx {
    font-size: 7.75rem !important;
  }
  .fs-lg-1 {
    font-size: 1.75rem !important;
  }
  .fs-lg-2 {
    font-size: 1.5rem !important;
  }
  .fs-lg-3 {
    font-size: 1.35rem !important;
  }
  .fs-lg-2x {
    font-size: 2rem !important;
  }
  .fs-lg-2qx {
    font-size: 2.25rem !important;
  }
  .fs-lg-2hx {
    font-size: 2.5rem !important;
  }
  .fs-lg-2tx {
    font-size: 2.75rem !important;
  }
  .fs-lg-3x {
    font-size: 3rem !important;
  }
  .fs-lg-3qx {
    font-size: 3.25rem !important;
  }
  .fs-lg-3hx {
    font-size: 3.5rem !important;
  }
  .fs-lg-3tx {
    font-size: 3.75rem !important;
  }
  .fs-lg-4x {
    font-size: 4rem !important;
  }
  .fs-lg-4qx {
    font-size: 4.25rem !important;
  }
  .fs-lg-4hx {
    font-size: 4.5rem !important;
  }
  .fs-lg-4tx {
    font-size: 4.75rem !important;
  }
  .fs-lg-5x {
    font-size: 5rem !important;
  }
  .fs-lg-5qx {
    font-size: 5.25rem !important;
  }
  .fs-lg-5hx {
    font-size: 5.5rem !important;
  }
  .fs-lg-5tx {
    font-size: 5.75rem !important;
  }
  .fs-lg-6x {
    font-size: 6rem !important;
  }
  .fs-lg-6qx {
    font-size: 6.25rem !important;
  }
  .fs-lg-6hx {
    font-size: 6.5rem !important;
  }
  .fs-lg-6tx {
    font-size: 6.75rem !important;
  }
  .fs-lg-7x {
    font-size: 7rem !important;
  }
  .fs-lg-7qx {
    font-size: 7.25rem !important;
  }
  .fs-lg-7hx {
    font-size: 7.5rem !important;
  }
  .fs-lg-7tx {
    font-size: 7.75rem !important;
  }
}
@media print {
  .d-print-inline {
    display: inline !important;
  }
  .d-print-inline-block {
    display: inline-block !important;
  }
  .d-print-block {
    display: block !important;
  }
  .d-print-grid {
    display: grid !important;
  }
  .d-print-table {
    display: table !important;
  }
  .d-print-table-row {
    display: table-row !important;
  }
  .d-print-table-cell {
    display: table-cell !important;
  }
  .d-print-flex {
    display: flex !important;
  }
  .d-print-inline-flex {
    display: inline-flex !important;
  }
  .d-print-none {
    display: none !important;
  }
}
h1, .h1, h2, .h2, h3, .h3, h4, .h4, h5, .h5, h6, .h6 {
  outline: 0;
}

.blockquote-footer {
  color: var(--bs-blockquote-footer-color);
}

.list-style-none {
  list-style: none;
}

[data-kt-theme-mode-switching=true] * {
  transition: none !important;
}

[data-bs-theme=light] .theme-dark-show {
  display: none !important;
}

[data-bs-theme=light] .theme-light-bg-transparent {
  background-color: transparent !important;
}

[data-bs-theme=light] .theme-light-bg-body {
  background-color: var(--bs-body-bg) !important;
}

[data-bs-theme=dark] .theme-light-show {
  display: none !important;
}

[data-bs-theme=dark] .theme-dark-bg-transparent {
  background-color: transparent !important;
}

[data-bs-theme=dark] .theme-dark-bg-body {
  background-color: var(--bs-body-bg) !important;
}

.animation {
  animation-duration: 1s;
  animation-fill-mode: both;
}

@keyframes animationSlideInDown {
  from {
    transform: translate3d(0, -100%, 0);
    visibility: visible;
  }
  to {
    transform: translate3d(0, 0, 0);
  }
}
.animation-slide-in-down {
  animation-name: animationSlideInDown;
}

@keyframes animationSlideInUp {
  from {
    transform: translate3d(0, 100%, 0);
    visibility: visible;
  }
  to {
    transform: translate3d(0, 0, 0);
  }
}
.animation-slide-in-up {
  animation-name: animationSlideInUp;
}

@keyframes animationFadeIn {
  from {
    opacity: 0;
  }
  to {
    opacity: 1;
  }
}
.animation-fade-in {
  animation-name: animationFadeIn;
}

@keyframes animationFadeOut {
  from {
    opacity: 1;
  }
  to {
    opacity: 0;
  }
}
.animation-fade-out {
  animation-name: animationFadeOut;
}

.animation-blink {
  animation: animationBlink 1s steps(5, start) infinite;
}

@keyframes animationBlink {
  to {
    visibility: hidden;
  }
}
.alert-light {
  color: var(--bs-light);
  border-color: var(--bs-light);
  background-color: var(--bs-light-light);
}

.alert-light .alert-link {
  color: var(--bs-light);
}

.alert-primary {
  color: var(--bs-primary);
  border-color: var(--bs-primary);
  background-color: var(--bs-primary-light);
}

.alert-primary .alert-link {
  color: var(--bs-primary);
}

.alert-secondary {
  color: var(--bs-secondary);
  border-color: var(--bs-secondary);
  background-color: var(--bs-secondary-light);
}

.alert-secondary .alert-link {
  color: var(--bs-secondary);
}

.alert-success {
  color: var(--bs-success);
  border-color: var(--bs-success);
  background-color: var(--bs-success-light);
}

.alert-success .alert-link {
  color: var(--bs-success);
}

.alert-info {
  color: var(--bs-info);
  border-color: var(--bs-info);
  background-color: var(--bs-info-light);
}

.alert-info .alert-link {
  color: var(--bs-info);
}

.alert-warning {
  color: var(--bs-warning);
  border-color: var(--bs-warning);
  background-color: var(--bs-warning-light);
}

.alert-warning .alert-link {
  color: var(--bs-warning);
}

.alert-danger {
  color: var(--bs-danger);
  border-color: var(--bs-danger);
  background-color: var(--bs-danger-light);
}

.alert-danger .alert-link {
  color: var(--bs-danger);
}

.alert-dark {
  color: var(--bs-dark);
  border-color: var(--bs-dark);
  background-color: var(--bs-dark-light);
}

.alert-dark .alert-link {
  color: var(--bs-dark);
}

[data-bs-theme=dark] .dropdown-menu {
  box-shadow: 0px 0px 30px rgba(0, 0, 0, 0.3);
}

.toast .toast-header .btn-close {
  margin-right: 0;
}

[data-bs-theme=dark] .toast {
  --bs-toast-bg: #2B2B40;
  --bs-toast-header-bg: #2B2B40;
  --bs-toast-header-border-color: #323248;
}

.nav-pills .nav-item {
  margin-right: 0.5rem;
}

.nav-pills .nav-item:last-child {
  margin-right: 0;
}

.nav-stretch {
  align-items: stretch;
  padding-top: 0 !important;
  padding-bottom: 0 !important;
}

.nav-stretch .nav-item {
  display: flex;
  align-items: stretch;
  padding-top: 0 !important;
  padding-bottom: 0 !important;
}

.nav-stretch .nav-link {
  display: flex;
  align-items: center;
}

.nav-group {
  padding: 0.35rem;
  border-radius: 0.475rem;
  background-color: var(--bs-gray-100);
}

.nav-group.nav-group-outline {
  background-color: transparent;
  border: 1px solid var(--bs-border-color);
}

.nav-group.nav-group-fluid {
  display: flex;
}

.nav-group.nav-group-fluid > label,
.nav-group.nav-group-fluid > .btn {
  position: relative;
  flex-shrink: 0;
  flex-grow: 1;
  flex-basis: 0;
}

.nav-group.nav-group-fluid > label {
  margin-right: 0.1rem;
}

.nav-group.nav-group-fluid > label > .btn {
  width: 100%;
}

.nav-group.nav-group-fluid > label:last-child {
  margin-right: 0;
}

.nav-line-tabs {
  border-bottom-width: 1px;
  border-bottom-style: solid;
  border-bottom-color: var(--bs-border-color);
}

.nav-line-tabs .nav-item {
  margin-bottom: -1px;
}

.nav-line-tabs .nav-item .nav-link {
  color: var(--bs-gray-500);
  border: 0;
  border-bottom: 1px solid transparent;
  transition: color 0.2s ease;
  padding: 0.5rem 0;
  margin: 0 1rem;
}

.nav-line-tabs .nav-item:first-child .nav-link {
  margin-left: 0;
}

.nav-line-tabs .nav-item:last-child .nav-link {
  margin-right: 0;
}

.nav-line-tabs .nav-item .nav-link.active,
.nav-line-tabs .nav-item.show .nav-link,
.nav-line-tabs .nav-item .nav-link:hover:not(.disabled) {
  background-color: transparent;
  border: 0;
  border-bottom: 1px solid var(--bs-primary);
  transition: color 0.2s ease;
}

.nav-line-tabs.nav-line-tabs-2x {
  border-bottom-width: 2px;
}

.nav-line-tabs.nav-line-tabs-2x .nav-item {
  margin-bottom: -2px;
}

.nav-line-tabs.nav-line-tabs-2x .nav-item .nav-link {
  border-bottom-width: 2px;
}

.nav-line-tabs.nav-line-tabs-2x .nav-item .nav-link.active,
.nav-line-tabs.nav-line-tabs-2x .nav-item.show .nav-link,
.nav-line-tabs.nav-line-tabs-2x .nav-item .nav-link:hover:not(.disabled) {
  border-bottom-width: 2px;
}

.nav.nav-pills.nav-pills-custom .show > .nav-link,
.nav.nav-pills.nav-pills-custom .nav-link {
  border: 1px dashed var(--bs-border-dashed-color);
  border-radius: 0.625rem;
}

.nav.nav-pills.nav-pills-custom .show > .nav-link.nav-link-border-solid,
.nav.nav-pills.nav-pills-custom .nav-link.nav-link-border-solid {
  border: 3px solid var(--bs-border-dashed-color);
}

.nav.nav-pills.nav-pills-custom .show > .nav-link.nav-link-border-solid.active,
.nav.nav-pills.nav-pills-custom .nav-link.nav-link-border-solid.active {
  border: 3px solid var(--bs-primary);
}

.nav.nav-pills.nav-pills-custom .show > .nav-link .nav-icon img,
.nav.nav-pills.nav-pills-custom .nav-link .nav-icon img {
  width: 30px;
  transition: color 0.2s ease;
}

.nav.nav-pills.nav-pills-custom .show > .nav-link .nav-icon img.default,
.nav.nav-pills.nav-pills-custom .nav-link .nav-icon img.default {
  display: inline-block;
}

.nav.nav-pills.nav-pills-custom .show > .nav-link .nav-icon img.active,
.nav.nav-pills.nav-pills-custom .nav-link .nav-icon img.active {
  display: none;
}

.nav.nav-pills.nav-pills-custom .show > .nav-link.active,
.nav.nav-pills.nav-pills-custom .nav-link.active {
  background-color: transparent;
  border: 1px solid var(--bs-border-dashed-color);
  transition-duration: 1ms;
  position: relative;
}

.nav.nav-pills.nav-pills-custom .show > .nav-link.active .nav-text,
.nav.nav-pills.nav-pills-custom .nav-link.active .nav-text {
  color: var(--bs-gray-800) !important;
  transition: color 0.2s ease;
}

.nav.nav-pills.nav-pills-custom .show > .nav-link.active .bullet-custom,
.nav.nav-pills.nav-pills-custom .nav-link.active .bullet-custom {
  display: block;
}

.nav.nav-pills.nav-pills-custom .show > .nav-link .bullet-custom,
.nav.nav-pills.nav-pills-custom .nav-link .bullet-custom {
  display: none;
}

.nav.nav-pills.nav-pills-custom.nav-pills-active-custom .nav-item .nav-link:not(:active) span:nth-child(1) {
  color: #B5B5C3;
}

.nav.nav-pills.nav-pills-custom.nav-pills-active-custom .nav-item .nav-link:not(:active) span:nth-child(2) {
  color: #3F4254;
}

.nav.nav-pills.nav-pills-custom.nav-pills-active-custom .nav-item .nav-link:hover span:nth-child(1) {
  color: #ffffff !important;
}

.nav.nav-pills.nav-pills-custom.nav-pills-active-custom .nav-item .nav-link:hover span:nth-child(2) {
  color: #ffffff !important;
}

.nav.nav-pills.nav-pills-custom.nav-pills-active-custom .nav-item .nav-link.active span:nth-child(1) {
  color: #ffffff !important;
}

.nav.nav-pills.nav-pills-custom.nav-pills-active-custom .nav-item .nav-link.active span:nth-child(2) {
  color: #ffffff !important;
}

.pagination {
  display: flex;
  flex-wrap: wrap;
  justify-content: center;
  margin: 0;
}

.pagination.pagination-circle .page-link {
  border-radius: 50%;
}

.pagination.pagination-outline .page-link {
  border: 1px solid var(--bs-border-color);
}

.pagination.pagination-outline .page-item:hover:not(.disabled) .page-link, .pagination.pagination-outline .page-item.active .page-link {
  border-color: var(--bs-primary-light);
}

.page-item {
  margin-right: 0.5rem;
  /*rtl:end:ignore*/
}

.page-item:last-child {
  margin-right: 0;
}

.page-item .page-link {
  display: flex;
  justify-content: center;
  align-items: center;
  border-radius: 0.475rem;
  height: 2.5rem;
  min-width: 2.5rem;
  font-weight: 500;
  font-size: 1.075rem;
  /*rtl:options:{"autoRename":false}*/
  /*rtl:end:ignore*/
  /*rtl:options:{"autoRename":false}*/
}

.page-item .page-link i {
  font-size: 0.85rem;
}

.page-item .page-link .previous,
.page-item .page-link .next {
  display: block;
  height: 0.875rem;
  width: 0.875rem;
  /*rtl:raw:transform: rotateZ(-180deg);*/
}

.page-item .page-link .previous {
  mask-repeat: no-repeat;
  mask-position: center;
  -webkit-mask-repeat: no-repeat;
  -webkit-mask-position: center;
  background-color: var(--bs-gray-700);
  mask-image: url(${___CSS_LOADER_URL_REPLACEMENT_18___});
}

.page-item .page-link .next {
  mask-repeat: no-repeat;
  mask-position: center;
  -webkit-mask-repeat: no-repeat;
  -webkit-mask-position: center;
  background-color: var(--bs-gray-700);
  mask-image: url(${___CSS_LOADER_URL_REPLACEMENT_19___});
}

.page-item:focus .page-link {
  color: var(--bs-pagination-focus-color);
  /*rtl:options:{"autoRename":false}*/
}

.page-item:focus .page-link .svg-icon,
.page-item:focus .page-link i {
  color: var(--bs-pagination-focus-color);
}

.page-item:focus .page-link .previous {
  mask-repeat: no-repeat;
  mask-position: center;
  -webkit-mask-repeat: no-repeat;
  -webkit-mask-position: center;
  background-color: var(--bs-pagination-focus-color);
  mask-image: url(${___CSS_LOADER_URL_REPLACEMENT_20___});
}

.page-item:focus .page-link .next {
  mask-repeat: no-repeat;
  mask-position: center;
  -webkit-mask-repeat: no-repeat;
  -webkit-mask-position: center;
  background-color: var(--bs-pagination-focus-color);
  mask-image: url(${___CSS_LOADER_URL_REPLACEMENT_21___});
}

.page-item:hover:not(.active):not(.offset):not(.disabled) .page-link {
  color: var(--bs-pagination-hover-color);
  /*rtl:options:{"autoRename":false}*/
}

.page-item:hover:not(.active):not(.offset):not(.disabled) .page-link.page-text {
  background-color: transparent;
}

.page-item:hover:not(.active):not(.offset):not(.disabled) .page-link .svg-icon,
.page-item:hover:not(.active):not(.offset):not(.disabled) .page-link i {
  color: var(--bs-pagination-hover-color);
}

.page-item:hover:not(.active):not(.offset):not(.disabled) .page-link .previous {
  mask-repeat: no-repeat;
  mask-position: center;
  -webkit-mask-repeat: no-repeat;
  -webkit-mask-position: center;
  background-color: var(--bs-pagination-hover-color);
  mask-image: url(${___CSS_LOADER_URL_REPLACEMENT_22___});
}

.page-item:hover:not(.active):not(.offset):not(.disabled) .page-link .next {
  mask-repeat: no-repeat;
  mask-position: center;
  -webkit-mask-repeat: no-repeat;
  -webkit-mask-position: center;
  background-color: var(--bs-pagination-hover-color);
  mask-image: url(${___CSS_LOADER_URL_REPLACEMENT_23___});
}

.page-item.active .page-link {
  color: var(--bs-pagination-active-color);
  /*rtl:options:{"autoRename":false}*/
}

.page-item.active .page-link.page-text {
  background-color: transparent;
}

.page-item.active .page-link .svg-icon,
.page-item.active .page-link i {
  color: var(--bs-pagination-active-color);
}

.page-item.active .page-link .previous {
  mask-repeat: no-repeat;
  mask-position: center;
  -webkit-mask-repeat: no-repeat;
  -webkit-mask-position: center;
  background-color: var(--bs-pagination-active-color);
  mask-image: url(${___CSS_LOADER_URL_REPLACEMENT_24___});
}

.page-item.active .page-link .next {
  mask-repeat: no-repeat;
  mask-position: center;
  -webkit-mask-repeat: no-repeat;
  -webkit-mask-position: center;
  background-color: var(--bs-pagination-active-color);
  mask-image: url(${___CSS_LOADER_URL_REPLACEMENT_25___});
}

.page-item.disabled .page-link {
  color: var(--bs-pagination-disabled-color);
  /*rtl:options:{"autoRename":false}*/
}

.page-item.disabled .page-link .svg-icon,
.page-item.disabled .page-link i {
  color: var(--bs-pagination-disabled-color);
}

.page-item.disabled .page-link .previous {
  mask-repeat: no-repeat;
  mask-position: center;
  -webkit-mask-repeat: no-repeat;
  -webkit-mask-position: center;
  background-color: var(--bs-pagination-disabled-color);
  mask-image: url(${___CSS_LOADER_URL_REPLACEMENT_26___});
}

.page-item.disabled .page-link .next {
  mask-repeat: no-repeat;
  mask-position: center;
  -webkit-mask-repeat: no-repeat;
  -webkit-mask-position: center;
  background-color: var(--bs-pagination-disabled-color);
  mask-image: url(${___CSS_LOADER_URL_REPLACEMENT_27___});
}

@media (max-width: 991.98px) {
  .page-item {
    margin-right: 0.25rem;
  }
  .page-item:last-child {
    margin-right: 0;
  }
}
.separator {
  display: block;
  height: 0;
  border-bottom: 1px solid var(--bs-border-color);
}

.separator.separator-dotted {
  border-bottom-style: dotted;
  border-bottom-color: var(--bs-border-dashed-color);
}

.separator.separator-dashed {
  border-bottom-style: dashed;
  border-bottom-color: var(--bs-border-dashed-color);
}

.separator.separator-content {
  display: flex;
  align-items: center;
  border-bottom: 0;
  text-align: center;
}

.separator.separator-content::before, .separator.separator-content::after {
  content: " ";
  width: 50%;
  border-bottom: 1px solid var(--bs-border-color);
}

.separator.separator-content::before {
  margin-right: 1.25rem;
}

.separator.separator-content::after {
  margin-left: 1.25rem;
}

.separator.separator-content.separator-dotted::before, .separator.separator-content.separator-dotted::after {
  border-bottom-style: dotted;
  border-bottom-color: var(--bs-border-dashed-color);
}

.separator.separator-content.separator-dashed::before, .separator.separator-content.separator-dashed::after {
  border-bottom-style: dashed;
  border-bottom-color: var(--bs-border-dashed-color);
}

.separator.separator-content.border-light::before, .separator.separator-content.border-light::after {
  border-color: #F9F9F9 !important;
}

.separator.separator-content.border-primary::before, .separator.separator-content.border-primary::after {
  border-color: #009ef7 !important;
}

.separator.separator-content.border-secondary::before, .separator.separator-content.border-secondary::after {
  border-color: #E1E3EA !important;
}

.separator.separator-content.border-success::before, .separator.separator-content.border-success::after {
  border-color: #50cd89 !important;
}

.separator.separator-content.border-info::before, .separator.separator-content.border-info::after {
  border-color: #7239ea !important;
}

.separator.separator-content.border-warning::before, .separator.separator-content.border-warning::after {
  border-color: #ffc700 !important;
}

.separator.separator-content.border-danger::before, .separator.separator-content.border-danger::after {
  border-color: #f1416c !important;
}

.separator.separator-content.border-dark::before, .separator.separator-content.border-dark::after {
  border-color: #181C32 !important;
}

.carousel-custom .carousel-indicators {
  align-items: center;
  position: static;
  z-index: auto;
  margin: 0;
  padding: 0;
  list-style: none;
}

.carousel-custom .carousel-indicators li {
  transform: none;
  opacity: 1;
}

.carousel-custom .carousel-indicators li.active {
  transform: none;
  opacity: 1;
}

.carousel-custom .carousel-indicators.carousel-indicators-dots li {
  border-radius: 0;
  background-color: transparent !important;
  height: 13px;
  width: 13px;
  display: flex;
  align-items: center;
  justify-content: center;
  text-align: center;
}

.carousel-custom .carousel-indicators.carousel-indicators-dots li:after {
  display: inline-block;
  content: " ";
  border-radius: 50%;
  transition: all 0.3s ease;
  background-color: var(--bs-gray-200);
  height: 9px;
  width: 9px;
}

.carousel-custom .carousel-indicators.carousel-indicators-dots li.active {
  background-color: transparent;
}

.carousel-custom .carousel-indicators.carousel-indicators-dots li.active:after {
  transition: all 0.3s ease;
  height: 13px;
  width: 13px;
  background-color: var(--bs-gray-400);
}

.carousel-custom .carousel-indicators.carousel-indicators-bullet li {
  transition: all 0.3s ease;
  background-color: transparent !important;
  border-radius: 6px;
  height: 6px;
  width: 6px;
  display: flex;
  align-items: center;
  justify-content: center;
  text-align: center;
}

.carousel-custom .carousel-indicators.carousel-indicators-bullet li:after {
  display: inline-block;
  content: " ";
  transition: all 0.3s ease;
  background-color: var(--bs-gray-400);
  border-radius: 6px;
  height: 6px;
  width: 6px;
}

.carousel-custom .carousel-indicators.carousel-indicators-bullet li.active {
  transition: all 0.3s ease;
  background-color: transparent;
  height: 6px;
  width: 16px;
}

.carousel-custom .carousel-indicators.carousel-indicators-bullet li.active:after {
  transition: all 0.3s ease;
  height: 6px;
  width: 16px;
  background-color: var(--bs-gray-600);
}

.carousel-custom .carousel-indicators-active-light li.active:after {
  background-color: var(--bs-light) !important;
}

.carousel-custom .carousel-indicators-active-primary li.active:after {
  background-color: var(--bs-primary) !important;
}

.carousel-custom .carousel-indicators-active-secondary li.active:after {
  background-color: var(--bs-secondary) !important;
}

.carousel-custom .carousel-indicators-active-success li.active:after {
  background-color: var(--bs-success) !important;
}

.carousel-custom .carousel-indicators-active-info li.active:after {
  background-color: var(--bs-info) !important;
}

.carousel-custom .carousel-indicators-active-warning li.active:after {
  background-color: var(--bs-warning) !important;
}

.carousel-custom .carousel-indicators-active-danger li.active:after {
  background-color: var(--bs-danger) !important;
}

.carousel-custom .carousel-indicators-active-dark li.active:after {
  background-color: var(--bs-dark) !important;
}

.carousel-custom.carousel-stretch {
  height: 100%;
  display: flex;
  flex-direction: column;
}

.carousel-custom.carousel-stretch .carousel-inner {
  flex-grow: 1;
}

.carousel-custom.carousel-stretch .carousel-item {
  height: 100%;
}

.carousel-custom.carousel-stretch .carousel-wrapper {
  display: flex;
  flex-direction: column;
  height: 100%;
}

.menu-group {
  display: flex;
}

.menu,
.menu-wrapper {
  display: flex;
  padding: 0;
  margin: 0;
  list-style: none;
}

.menu-inner {
  padding: 0;
  margin: 0;
  list-style: none;
}

.menu-sub {
  display: none;
  padding: 0;
  margin: 0;
  list-style: none;
  flex-direction: column;
}

.menu-item {
  display: block;
  padding: 0.15rem 0;
}

.menu-item .menu-link {
  cursor: pointer;
  display: flex;
  align-items: center;
  padding: 0;
  flex: 0 0 100%;
  padding: 0.65rem 1rem;
  transition: none;
  outline: none !important;
}

.menu-item .menu-link .menu-icon {
  flex-shrink: 0;
  display: flex;
  align-items: center;
  justify-content: center;
  width: 2rem;
  margin-right: 0.5rem;
}

.menu-item .menu-link .menu-icon i,
.menu-item .menu-link .menu-icon .svg-icon {
  line-height: 1;
}

.menu-item .menu-link .menu-bullet {
  flex-shrink: 0;
  display: flex;
  align-items: center;
  justify-content: center;
  width: 1.25rem;
  margin-right: 0.5rem;
}

.menu-item .menu-link .menu-title {
  display: flex;
  align-items: center;
  flex-grow: 1;
}

.menu-item .menu-link .menu-badge {
  display: flex;
  align-items: center;
  flex-shrink: 0;
  margin-left: 0.5rem;
}

.menu-item .menu-link .menu-arrow {
  display: flex;
  align-items: stretch;
  position: relative;
  overflow: hidden;
  flex-shrink: 0;
  margin-left: 5px;
  width: 9px;
  height: 9px;
}

.menu-item .menu-link .menu-arrow:after {
  display: block;
  width: 100%;
  content: " ";
  will-change: transform;
  background-size: 100% 100%;
  mask-image: url(${___CSS_LOADER_URL_REPLACEMENT_28___});
  /*rtl:begin:remove*/
  mask-repeat: no-repeat;
  mask-position: center;
  -webkit-mask-repeat: no-repeat;
  -webkit-mask-position: center;
  background-color: var(--bs-text-muted);
  mask-image: url(${___CSS_LOADER_URL_REPLACEMENT_29___});
  /*rtl:end:remove*/
}

.menu-item .menu-content {
  padding: 0.65rem 1rem;
}

.menu-item.show .menu-link .menu-arrow:after {
  backface-visibility: hidden;
  transition: transform 0.3s ease;
}

.menu-center {
  justify-content: center;
}

.menu-heading {
  color: var(--bs-menu-heading-color);
}

.menu-item.menu-accordion .menu-arrow:after {
  /*rtl:ignore*/
  transform: rotateZ(-90deg);
  /*rtl:remove*/
  transform: rotateZ(90deg);
  transition: transform 0.3s ease;
}

.menu-item.menu-accordion.showing:not(.menu-dropdown) > .menu-link .menu-arrow:after, .menu-item.menu-accordion.show:not(.hiding):not(.menu-dropdown) > .menu-link .menu-arrow:after {
  /*rtl:ignore*/
  transform: rotateZ(90deg);
  /*rtl:remove*/
  transform: rotateZ(-90deg);
  transition: transform 0.3s ease;
}

.menu-sub-dropdown {
  display: none;
  border-radius: 0.475rem;
  background-color: var(--bs-menu-dropdown-bg-color);
  box-shadow: var(--bs-menu-dropdown-box-shadow);
  z-index: 107;
}

.show.menu-dropdown > .menu-sub-dropdown, .menu-sub-dropdown.menu.show, .menu-sub-dropdown.show[data-popper-placement] {
  display: flex;
  will-change: transform;
  animation: menu-sub-dropdown-animation-fade-in 0.3s ease 1, menu-sub-dropdown-animation-move-up 0.3s ease 1;
}

.menu-sub-accordion {
  display: none;
}

.show:not(.menu-dropdown) > .menu-sub-accordion, .menu-sub-accordion.show {
  display: flex;
}

.menu-sub-indention .menu-sub:not([data-popper-placement]) {
  margin-left: 1rem;
}

.menu-sub-indention .menu-item .menu-item .menu-link.active {
  margin-right: 1rem;
}

.menu-inline {
  display: flex;
}

.menu-fit > .menu-item > .menu-content,
.menu-fit > .menu-item > .menu-link {
  padding-left: 0 !important;
  padding-right: 0 !important;
}

.menu-column {
  flex-direction: column;
  width: 100%;
}

.menu-row {
  flex-direction: row;
}

.menu-row > .menu-item {
  display: flex;
  align-items: center;
}

.menu-row > .menu-item > .menu-link .menu-arrow:after {
  /*rtl:ignore*/
  transform: rotateZ(-90deg);
  /*rtl:remove*/
  transform: rotateZ(90deg);
  transition: transform 0.3s ease;
}

.menu-rounded .menu-link {
  border-radius: 0.475rem;
}

.menu-pill .menu-link {
  border-radius: 50px;
}

.menu-rounded-0 .menu-link {
  border-radius: 0 !important;
}

@media (min-width: 576px) {
  .menu-item.menu-sm-accordion .menu-arrow:after {
    /*rtl:ignore*/
    transform: rotateZ(-90deg);
    /*rtl:remove*/
    transform: rotateZ(90deg);
    transition: transform 0.3s ease;
  }
  .menu-item.menu-sm-accordion.showing:not(.menu-dropdown) > .menu-link .menu-arrow:after, .menu-item.menu-sm-accordion.show:not(.hiding):not(.menu-dropdown) > .menu-link .menu-arrow:after {
    /*rtl:ignore*/
    transform: rotateZ(90deg);
    /*rtl:remove*/
    transform: rotateZ(-90deg);
    transition: transform 0.3s ease;
  }
  .menu-sub-sm-dropdown {
    display: none;
    border-radius: 0.475rem;
    background-color: var(--bs-menu-dropdown-bg-color);
    box-shadow: var(--bs-menu-dropdown-box-shadow);
    z-index: 107;
  }
  .show.menu-dropdown > .menu-sub-sm-dropdown, .menu-sub-sm-dropdown.menu.show, .menu-sub-sm-dropdown.show[data-popper-placement] {
    display: flex;
    will-change: transform;
    animation: menu-sub-dropdown-animation-fade-in 0.3s ease 1, menu-sub-dropdown-animation-move-up 0.3s ease 1;
  }
  .menu-sub-sm-accordion {
    display: none;
  }
  .show:not(.menu-dropdown) > .menu-sub-sm-accordion, .menu-sub-sm-accordion.show {
    display: flex;
  }
  .menu-sub-sm-indention .menu-sub:not([data-popper-placement]) {
    margin-left: 1rem;
  }
  .menu-sub-sm-indention .menu-item .menu-item .menu-link.active {
    margin-right: 1rem;
  }
  .menu-sm-inline {
    display: flex;
  }
  .menu-sm-fit > .menu-item > .menu-content,
  .menu-sm-fit > .menu-item > .menu-link {
    padding-left: 0 !important;
    padding-right: 0 !important;
  }
  .menu-sm-column {
    flex-direction: column;
    width: 100%;
  }
  .menu-sm-row {
    flex-direction: row;
  }
  .menu-sm-row > .menu-item {
    display: flex;
    align-items: center;
  }
  .menu-sm-row > .menu-item > .menu-link .menu-arrow:after {
    /*rtl:ignore*/
    transform: rotateZ(-90deg);
    /*rtl:remove*/
    transform: rotateZ(90deg);
    transition: transform 0.3s ease;
  }
  .menu-sm-rounded .menu-link {
    border-radius: 0.475rem;
  }
  .menu-sm-pill .menu-link {
    border-radius: 50px;
  }
  .menu-sm-rounded-0 .menu-link {
    border-radius: 0 !important;
  }
}
@media (min-width: 768px) {
  .menu-item.menu-md-accordion .menu-arrow:after {
    /*rtl:ignore*/
    transform: rotateZ(-90deg);
    /*rtl:remove*/
    transform: rotateZ(90deg);
    transition: transform 0.3s ease;
  }
  .menu-item.menu-md-accordion.showing:not(.menu-dropdown) > .menu-link .menu-arrow:after, .menu-item.menu-md-accordion.show:not(.hiding):not(.menu-dropdown) > .menu-link .menu-arrow:after {
    /*rtl:ignore*/
    transform: rotateZ(90deg);
    /*rtl:remove*/
    transform: rotateZ(-90deg);
    transition: transform 0.3s ease;
  }
  .menu-sub-md-dropdown {
    display: none;
    border-radius: 0.475rem;
    background-color: var(--bs-menu-dropdown-bg-color);
    box-shadow: var(--bs-menu-dropdown-box-shadow);
    z-index: 107;
  }
  .show.menu-dropdown > .menu-sub-md-dropdown, .menu-sub-md-dropdown.menu.show, .menu-sub-md-dropdown.show[data-popper-placement] {
    display: flex;
    will-change: transform;
    animation: menu-sub-dropdown-animation-fade-in 0.3s ease 1, menu-sub-dropdown-animation-move-up 0.3s ease 1;
  }
  .menu-sub-md-accordion {
    display: none;
  }
  .show:not(.menu-dropdown) > .menu-sub-md-accordion, .menu-sub-md-accordion.show {
    display: flex;
  }
  .menu-sub-md-indention .menu-sub:not([data-popper-placement]) {
    margin-left: 1rem;
  }
  .menu-sub-md-indention .menu-item .menu-item .menu-link.active {
    margin-right: 1rem;
  }
  .menu-md-inline {
    display: flex;
  }
  .menu-md-fit > .menu-item > .menu-content,
  .menu-md-fit > .menu-item > .menu-link {
    padding-left: 0 !important;
    padding-right: 0 !important;
  }
  .menu-md-column {
    flex-direction: column;
    width: 100%;
  }
  .menu-md-row {
    flex-direction: row;
  }
  .menu-md-row > .menu-item {
    display: flex;
    align-items: center;
  }
  .menu-md-row > .menu-item > .menu-link .menu-arrow:after {
    /*rtl:ignore*/
    transform: rotateZ(-90deg);
    /*rtl:remove*/
    transform: rotateZ(90deg);
    transition: transform 0.3s ease;
  }
  .menu-md-rounded .menu-link {
    border-radius: 0.475rem;
  }
  .menu-md-pill .menu-link {
    border-radius: 50px;
  }
  .menu-md-rounded-0 .menu-link {
    border-radius: 0 !important;
  }
}
@media (min-width: 992px) {
  .menu-item.menu-lg-accordion .menu-arrow:after {
    /*rtl:ignore*/
    transform: rotateZ(-90deg);
    /*rtl:remove*/
    transform: rotateZ(90deg);
    transition: transform 0.3s ease;
  }
  .menu-item.menu-lg-accordion.showing:not(.menu-dropdown) > .menu-link .menu-arrow:after, .menu-item.menu-lg-accordion.show:not(.hiding):not(.menu-dropdown) > .menu-link .menu-arrow:after {
    /*rtl:ignore*/
    transform: rotateZ(90deg);
    /*rtl:remove*/
    transform: rotateZ(-90deg);
    transition: transform 0.3s ease;
  }
  .menu-sub-lg-dropdown {
    display: none;
    border-radius: 0.475rem;
    background-color: var(--bs-menu-dropdown-bg-color);
    box-shadow: var(--bs-menu-dropdown-box-shadow);
    z-index: 107;
  }
  .show.menu-dropdown > .menu-sub-lg-dropdown, .menu-sub-lg-dropdown.menu.show, .menu-sub-lg-dropdown.show[data-popper-placement] {
    display: flex;
    will-change: transform;
    animation: menu-sub-dropdown-animation-fade-in 0.3s ease 1, menu-sub-dropdown-animation-move-up 0.3s ease 1;
  }
  .menu-sub-lg-accordion {
    display: none;
  }
  .show:not(.menu-dropdown) > .menu-sub-lg-accordion, .menu-sub-lg-accordion.show {
    display: flex;
  }
  .menu-sub-lg-indention .menu-sub:not([data-popper-placement]) {
    margin-left: 1rem;
  }
  .menu-sub-lg-indention .menu-item .menu-item .menu-link.active {
    margin-right: 1rem;
  }
  .menu-lg-inline {
    display: flex;
  }
  .menu-lg-fit > .menu-item > .menu-content,
  .menu-lg-fit > .menu-item > .menu-link {
    padding-left: 0 !important;
    padding-right: 0 !important;
  }
  .menu-lg-column {
    flex-direction: column;
    width: 100%;
  }
  .menu-lg-row {
    flex-direction: row;
  }
  .menu-lg-row > .menu-item {
    display: flex;
    align-items: center;
  }
  .menu-lg-row > .menu-item > .menu-link .menu-arrow:after {
    /*rtl:ignore*/
    transform: rotateZ(-90deg);
    /*rtl:remove*/
    transform: rotateZ(90deg);
    transition: transform 0.3s ease;
  }
  .menu-lg-rounded .menu-link {
    border-radius: 0.475rem;
  }
  .menu-lg-pill .menu-link {
    border-radius: 50px;
  }
  .menu-lg-rounded-0 .menu-link {
    border-radius: 0 !important;
  }
}
@media (min-width: 1200px) {
  .menu-item.menu-xl-accordion .menu-arrow:after {
    /*rtl:ignore*/
    transform: rotateZ(-90deg);
    /*rtl:remove*/
    transform: rotateZ(90deg);
    transition: transform 0.3s ease;
  }
  .menu-item.menu-xl-accordion.showing:not(.menu-dropdown) > .menu-link .menu-arrow:after, .menu-item.menu-xl-accordion.show:not(.hiding):not(.menu-dropdown) > .menu-link .menu-arrow:after {
    /*rtl:ignore*/
    transform: rotateZ(90deg);
    /*rtl:remove*/
    transform: rotateZ(-90deg);
    transition: transform 0.3s ease;
  }
  .menu-sub-xl-dropdown {
    display: none;
    border-radius: 0.475rem;
    background-color: var(--bs-menu-dropdown-bg-color);
    box-shadow: var(--bs-menu-dropdown-box-shadow);
    z-index: 107;
  }
  .show.menu-dropdown > .menu-sub-xl-dropdown, .menu-sub-xl-dropdown.menu.show, .menu-sub-xl-dropdown.show[data-popper-placement] {
    display: flex;
    will-change: transform;
    animation: menu-sub-dropdown-animation-fade-in 0.3s ease 1, menu-sub-dropdown-animation-move-up 0.3s ease 1;
  }
  .menu-sub-xl-accordion {
    display: none;
  }
  .show:not(.menu-dropdown) > .menu-sub-xl-accordion, .menu-sub-xl-accordion.show {
    display: flex;
  }
  .menu-sub-xl-indention .menu-sub:not([data-popper-placement]) {
    margin-left: 1rem;
  }
  .menu-sub-xl-indention .menu-item .menu-item .menu-link.active {
    margin-right: 1rem;
  }
  .menu-xl-inline {
    display: flex;
  }
  .menu-xl-fit > .menu-item > .menu-content,
  .menu-xl-fit > .menu-item > .menu-link {
    padding-left: 0 !important;
    padding-right: 0 !important;
  }
  .menu-xl-column {
    flex-direction: column;
    width: 100%;
  }
  .menu-xl-row {
    flex-direction: row;
  }
  .menu-xl-row > .menu-item {
    display: flex;
    align-items: center;
  }
  .menu-xl-row > .menu-item > .menu-link .menu-arrow:after {
    /*rtl:ignore*/
    transform: rotateZ(-90deg);
    /*rtl:remove*/
    transform: rotateZ(90deg);
    transition: transform 0.3s ease;
  }
  .menu-xl-rounded .menu-link {
    border-radius: 0.475rem;
  }
  .menu-xl-pill .menu-link {
    border-radius: 50px;
  }
  .menu-xl-rounded-0 .menu-link {
    border-radius: 0 !important;
  }
}
@media (min-width: 1400px) {
  .menu-item.menu-xxl-accordion .menu-arrow:after {
    /*rtl:ignore*/
    transform: rotateZ(-90deg);
    /*rtl:remove*/
    transform: rotateZ(90deg);
    transition: transform 0.3s ease;
  }
  .menu-item.menu-xxl-accordion.showing:not(.menu-dropdown) > .menu-link .menu-arrow:after, .menu-item.menu-xxl-accordion.show:not(.hiding):not(.menu-dropdown) > .menu-link .menu-arrow:after {
    /*rtl:ignore*/
    transform: rotateZ(90deg);
    /*rtl:remove*/
    transform: rotateZ(-90deg);
    transition: transform 0.3s ease;
  }
  .menu-sub-xxl-dropdown {
    display: none;
    border-radius: 0.475rem;
    background-color: var(--bs-menu-dropdown-bg-color);
    box-shadow: var(--bs-menu-dropdown-box-shadow);
    z-index: 107;
  }
  .show.menu-dropdown > .menu-sub-xxl-dropdown, .menu-sub-xxl-dropdown.menu.show, .menu-sub-xxl-dropdown.show[data-popper-placement] {
    display: flex;
    will-change: transform;
    animation: menu-sub-dropdown-animation-fade-in 0.3s ease 1, menu-sub-dropdown-animation-move-up 0.3s ease 1;
  }
  .menu-sub-xxl-accordion {
    display: none;
  }
  .show:not(.menu-dropdown) > .menu-sub-xxl-accordion, .menu-sub-xxl-accordion.show {
    display: flex;
  }
  .menu-sub-xxl-indention .menu-sub:not([data-popper-placement]) {
    margin-left: 1rem;
  }
  .menu-sub-xxl-indention .menu-item .menu-item .menu-link.active {
    margin-right: 1rem;
  }
  .menu-xxl-inline {
    display: flex;
  }
  .menu-xxl-fit > .menu-item > .menu-content,
  .menu-xxl-fit > .menu-item > .menu-link {
    padding-left: 0 !important;
    padding-right: 0 !important;
  }
  .menu-xxl-column {
    flex-direction: column;
    width: 100%;
  }
  .menu-xxl-row {
    flex-direction: row;
  }
  .menu-xxl-row > .menu-item {
    display: flex;
    align-items: center;
  }
  .menu-xxl-row > .menu-item > .menu-link .menu-arrow:after {
    /*rtl:ignore*/
    transform: rotateZ(-90deg);
    /*rtl:remove*/
    transform: rotateZ(90deg);
    transition: transform 0.3s ease;
  }
  .menu-xxl-rounded .menu-link {
    border-radius: 0.475rem;
  }
  .menu-xxl-pill .menu-link {
    border-radius: 50px;
  }
  .menu-xxl-rounded-0 .menu-link {
    border-radius: 0 !important;
  }
}
@media (max-width: 575.98px) {
  .menu-item.menu-sm-down-accordion .menu-arrow:after {
    /*rtl:ignore*/
    transform: rotateZ(-90deg);
    /*rtl:remove*/
    transform: rotateZ(90deg);
    transition: transform 0.3s ease;
  }
  .menu-item.menu-sm-down-accordion.showing:not(.menu-dropdown) > .menu-link .menu-arrow:after, .menu-item.menu-sm-down-accordion.show:not(.hiding):not(.menu-dropdown) > .menu-link .menu-arrow:after {
    /*rtl:ignore*/
    transform: rotateZ(90deg);
    /*rtl:remove*/
    transform: rotateZ(-90deg);
    transition: transform 0.3s ease;
  }
  .menu-sub-sm-down-dropdown {
    display: none;
    border-radius: 0.475rem;
    background-color: var(--bs-menu-dropdown-bg-color);
    box-shadow: var(--bs-menu-dropdown-box-shadow);
    z-index: 107;
  }
  .show.menu-dropdown > .menu-sub-sm-down-dropdown, .menu-sub-sm-down-dropdown.menu.show, .menu-sub-sm-down-dropdown.show[data-popper-placement] {
    display: flex;
    will-change: transform;
    animation: menu-sub-dropdown-animation-fade-in 0.3s ease 1, menu-sub-dropdown-animation-move-up 0.3s ease 1;
  }
  .menu-sub-sm-down-accordion {
    display: none;
  }
  .show:not(.menu-dropdown) > .menu-sub-sm-down-accordion, .menu-sub-sm-down-accordion.show {
    display: flex;
  }
  .menu-sub-sm-down-indention .menu-sub:not([data-popper-placement]) {
    margin-left: 1rem;
  }
  .menu-sub-sm-down-indention .menu-item .menu-item .menu-link.active {
    margin-right: 1rem;
  }
  .menu-sm-down-inline {
    display: flex;
  }
  .menu-sm-down-fit > .menu-item > .menu-content,
  .menu-sm-down-fit > .menu-item > .menu-link {
    padding-left: 0 !important;
    padding-right: 0 !important;
  }
  .menu-sm-down-column {
    flex-direction: column;
    width: 100%;
  }
  .menu-sm-down-row {
    flex-direction: row;
  }
  .menu-sm-down-row > .menu-item {
    display: flex;
    align-items: center;
  }
  .menu-sm-down-row > .menu-item > .menu-link .menu-arrow:after {
    /*rtl:ignore*/
    transform: rotateZ(-90deg);
    /*rtl:remove*/
    transform: rotateZ(90deg);
    transition: transform 0.3s ease;
  }
  .menu-sm-down-rounded .menu-link {
    border-radius: 0.475rem;
  }
  .menu-sm-down-pill .menu-link {
    border-radius: 50px;
  }
  .menu-sm-down-rounded-0 .menu-link {
    border-radius: 0 !important;
  }
}
@media (max-width: 767.98px) {
  .menu-item.menu-md-down-accordion .menu-arrow:after {
    /*rtl:ignore*/
    transform: rotateZ(-90deg);
    /*rtl:remove*/
    transform: rotateZ(90deg);
    transition: transform 0.3s ease;
  }
  .menu-item.menu-md-down-accordion.showing:not(.menu-dropdown) > .menu-link .menu-arrow:after, .menu-item.menu-md-down-accordion.show:not(.hiding):not(.menu-dropdown) > .menu-link .menu-arrow:after {
    /*rtl:ignore*/
    transform: rotateZ(90deg);
    /*rtl:remove*/
    transform: rotateZ(-90deg);
    transition: transform 0.3s ease;
  }
  .menu-sub-md-down-dropdown {
    display: none;
    border-radius: 0.475rem;
    background-color: var(--bs-menu-dropdown-bg-color);
    box-shadow: var(--bs-menu-dropdown-box-shadow);
    z-index: 107;
  }
  .show.menu-dropdown > .menu-sub-md-down-dropdown, .menu-sub-md-down-dropdown.menu.show, .menu-sub-md-down-dropdown.show[data-popper-placement] {
    display: flex;
    will-change: transform;
    animation: menu-sub-dropdown-animation-fade-in 0.3s ease 1, menu-sub-dropdown-animation-move-up 0.3s ease 1;
  }
  .menu-sub-md-down-accordion {
    display: none;
  }
  .show:not(.menu-dropdown) > .menu-sub-md-down-accordion, .menu-sub-md-down-accordion.show {
    display: flex;
  }
  .menu-sub-md-down-indention .menu-sub:not([data-popper-placement]) {
    margin-left: 1rem;
  }
  .menu-sub-md-down-indention .menu-item .menu-item .menu-link.active {
    margin-right: 1rem;
  }
  .menu-md-down-inline {
    display: flex;
  }
  .menu-md-down-fit > .menu-item > .menu-content,
  .menu-md-down-fit > .menu-item > .menu-link {
    padding-left: 0 !important;
    padding-right: 0 !important;
  }
  .menu-md-down-column {
    flex-direction: column;
    width: 100%;
  }
  .menu-md-down-row {
    flex-direction: row;
  }
  .menu-md-down-row > .menu-item {
    display: flex;
    align-items: center;
  }
  .menu-md-down-row > .menu-item > .menu-link .menu-arrow:after {
    /*rtl:ignore*/
    transform: rotateZ(-90deg);
    /*rtl:remove*/
    transform: rotateZ(90deg);
    transition: transform 0.3s ease;
  }
  .menu-md-down-rounded .menu-link {
    border-radius: 0.475rem;
  }
  .menu-md-down-pill .menu-link {
    border-radius: 50px;
  }
  .menu-md-down-rounded-0 .menu-link {
    border-radius: 0 !important;
  }
}
@media (max-width: 991.98px) {
  .menu-item.menu-lg-down-accordion .menu-arrow:after {
    /*rtl:ignore*/
    transform: rotateZ(-90deg);
    /*rtl:remove*/
    transform: rotateZ(90deg);
    transition: transform 0.3s ease;
  }
  .menu-item.menu-lg-down-accordion.showing:not(.menu-dropdown) > .menu-link .menu-arrow:after, .menu-item.menu-lg-down-accordion.show:not(.hiding):not(.menu-dropdown) > .menu-link .menu-arrow:after {
    /*rtl:ignore*/
    transform: rotateZ(90deg);
    /*rtl:remove*/
    transform: rotateZ(-90deg);
    transition: transform 0.3s ease;
  }
  .menu-sub-lg-down-dropdown {
    display: none;
    border-radius: 0.475rem;
    background-color: var(--bs-menu-dropdown-bg-color);
    box-shadow: var(--bs-menu-dropdown-box-shadow);
    z-index: 107;
  }
  .show.menu-dropdown > .menu-sub-lg-down-dropdown, .menu-sub-lg-down-dropdown.menu.show, .menu-sub-lg-down-dropdown.show[data-popper-placement] {
    display: flex;
    will-change: transform;
    animation: menu-sub-dropdown-animation-fade-in 0.3s ease 1, menu-sub-dropdown-animation-move-up 0.3s ease 1;
  }
  .menu-sub-lg-down-accordion {
    display: none;
  }
  .show:not(.menu-dropdown) > .menu-sub-lg-down-accordion, .menu-sub-lg-down-accordion.show {
    display: flex;
  }
  .menu-sub-lg-down-indention .menu-sub:not([data-popper-placement]) {
    margin-left: 1rem;
  }
  .menu-sub-lg-down-indention .menu-item .menu-item .menu-link.active {
    margin-right: 1rem;
  }
  .menu-lg-down-inline {
    display: flex;
  }
  .menu-lg-down-fit > .menu-item > .menu-content,
  .menu-lg-down-fit > .menu-item > .menu-link {
    padding-left: 0 !important;
    padding-right: 0 !important;
  }
  .menu-lg-down-column {
    flex-direction: column;
    width: 100%;
  }
  .menu-lg-down-row {
    flex-direction: row;
  }
  .menu-lg-down-row > .menu-item {
    display: flex;
    align-items: center;
  }
  .menu-lg-down-row > .menu-item > .menu-link .menu-arrow:after {
    /*rtl:ignore*/
    transform: rotateZ(-90deg);
    /*rtl:remove*/
    transform: rotateZ(90deg);
    transition: transform 0.3s ease;
  }
  .menu-lg-down-rounded .menu-link {
    border-radius: 0.475rem;
  }
  .menu-lg-down-pill .menu-link {
    border-radius: 50px;
  }
  .menu-lg-down-rounded-0 .menu-link {
    border-radius: 0 !important;
  }
}
@media (max-width: 1199.98px) {
  .menu-item.menu-xl-down-accordion .menu-arrow:after {
    /*rtl:ignore*/
    transform: rotateZ(-90deg);
    /*rtl:remove*/
    transform: rotateZ(90deg);
    transition: transform 0.3s ease;
  }
  .menu-item.menu-xl-down-accordion.showing:not(.menu-dropdown) > .menu-link .menu-arrow:after, .menu-item.menu-xl-down-accordion.show:not(.hiding):not(.menu-dropdown) > .menu-link .menu-arrow:after {
    /*rtl:ignore*/
    transform: rotateZ(90deg);
    /*rtl:remove*/
    transform: rotateZ(-90deg);
    transition: transform 0.3s ease;
  }
  .menu-sub-xl-down-dropdown {
    display: none;
    border-radius: 0.475rem;
    background-color: var(--bs-menu-dropdown-bg-color);
    box-shadow: var(--bs-menu-dropdown-box-shadow);
    z-index: 107;
  }
  .show.menu-dropdown > .menu-sub-xl-down-dropdown, .menu-sub-xl-down-dropdown.menu.show, .menu-sub-xl-down-dropdown.show[data-popper-placement] {
    display: flex;
    will-change: transform;
    animation: menu-sub-dropdown-animation-fade-in 0.3s ease 1, menu-sub-dropdown-animation-move-up 0.3s ease 1;
  }
  .menu-sub-xl-down-accordion {
    display: none;
  }
  .show:not(.menu-dropdown) > .menu-sub-xl-down-accordion, .menu-sub-xl-down-accordion.show {
    display: flex;
  }
  .menu-sub-xl-down-indention .menu-sub:not([data-popper-placement]) {
    margin-left: 1rem;
  }
  .menu-sub-xl-down-indention .menu-item .menu-item .menu-link.active {
    margin-right: 1rem;
  }
  .menu-xl-down-inline {
    display: flex;
  }
  .menu-xl-down-fit > .menu-item > .menu-content,
  .menu-xl-down-fit > .menu-item > .menu-link {
    padding-left: 0 !important;
    padding-right: 0 !important;
  }
  .menu-xl-down-column {
    flex-direction: column;
    width: 100%;
  }
  .menu-xl-down-row {
    flex-direction: row;
  }
  .menu-xl-down-row > .menu-item {
    display: flex;
    align-items: center;
  }
  .menu-xl-down-row > .menu-item > .menu-link .menu-arrow:after {
    /*rtl:ignore*/
    transform: rotateZ(-90deg);
    /*rtl:remove*/
    transform: rotateZ(90deg);
    transition: transform 0.3s ease;
  }
  .menu-xl-down-rounded .menu-link {
    border-radius: 0.475rem;
  }
  .menu-xl-down-pill .menu-link {
    border-radius: 50px;
  }
  .menu-xl-down-rounded-0 .menu-link {
    border-radius: 0 !important;
  }
}
@media (max-width: 1399.98px) {
  .menu-item.menu-xxl-down-accordion .menu-arrow:after {
    /*rtl:ignore*/
    transform: rotateZ(-90deg);
    /*rtl:remove*/
    transform: rotateZ(90deg);
    transition: transform 0.3s ease;
  }
  .menu-item.menu-xxl-down-accordion.showing:not(.menu-dropdown) > .menu-link .menu-arrow:after, .menu-item.menu-xxl-down-accordion.show:not(.hiding):not(.menu-dropdown) > .menu-link .menu-arrow:after {
    /*rtl:ignore*/
    transform: rotateZ(90deg);
    /*rtl:remove*/
    transform: rotateZ(-90deg);
    transition: transform 0.3s ease;
  }
  .menu-sub-xxl-down-dropdown {
    display: none;
    border-radius: 0.475rem;
    background-color: var(--bs-menu-dropdown-bg-color);
    box-shadow: var(--bs-menu-dropdown-box-shadow);
    z-index: 107;
  }
  .show.menu-dropdown > .menu-sub-xxl-down-dropdown, .menu-sub-xxl-down-dropdown.menu.show, .menu-sub-xxl-down-dropdown.show[data-popper-placement] {
    display: flex;
    will-change: transform;
    animation: menu-sub-dropdown-animation-fade-in 0.3s ease 1, menu-sub-dropdown-animation-move-up 0.3s ease 1;
  }
  .menu-sub-xxl-down-accordion {
    display: none;
  }
  .show:not(.menu-dropdown) > .menu-sub-xxl-down-accordion, .menu-sub-xxl-down-accordion.show {
    display: flex;
  }
  .menu-sub-xxl-down-indention .menu-sub:not([data-popper-placement]) {
    margin-left: 1rem;
  }
  .menu-sub-xxl-down-indention .menu-item .menu-item .menu-link.active {
    margin-right: 1rem;
  }
  .menu-xxl-down-inline {
    display: flex;
  }
  .menu-xxl-down-fit > .menu-item > .menu-content,
  .menu-xxl-down-fit > .menu-item > .menu-link {
    padding-left: 0 !important;
    padding-right: 0 !important;
  }
  .menu-xxl-down-column {
    flex-direction: column;
    width: 100%;
  }
  .menu-xxl-down-row {
    flex-direction: row;
  }
  .menu-xxl-down-row > .menu-item {
    display: flex;
    align-items: center;
  }
  .menu-xxl-down-row > .menu-item > .menu-link .menu-arrow:after {
    /*rtl:ignore*/
    transform: rotateZ(-90deg);
    /*rtl:remove*/
    transform: rotateZ(90deg);
    transition: transform 0.3s ease;
  }
  .menu-xxl-down-rounded .menu-link {
    border-radius: 0.475rem;
  }
  .menu-xxl-down-pill .menu-link {
    border-radius: 50px;
  }
  .menu-xxl-down-rounded-0 .menu-link {
    border-radius: 0 !important;
  }
}
.menu-link-indention .menu-item {
  padding-top: 0;
  padding-bottom: 0;
}

.menu-link-indention .menu-sub:not([data-popper-placement]) > .menu-item > .menu-content,
.menu-link-indention .menu-sub:not([data-popper-placement]) > .menu-item > .menu-link,
.menu-link-indention .menu-sub:not([data-popper-placement]) > .menu-inner > .menu-item > .menu-content,
.menu-link-indention .menu-sub:not([data-popper-placement]) > .menu-inner > .menu-item > .menu-link {
  padding-left: 2rem;
}

.menu-link-indention .menu-sub:not([data-popper-placement]) > .menu-item > .menu-sub:not([data-popper-placement]) > .menu-item > .menu-content,
.menu-link-indention .menu-sub:not([data-popper-placement]) > .menu-item > .menu-sub:not([data-popper-placement]) > .menu-item > .menu-link,
.menu-link-indention .menu-sub:not([data-popper-placement]) > .menu-item > .menu-sub:not([data-popper-placement]) > .menu-inner > .menu-item > .menu-content,
.menu-link-indention .menu-sub:not([data-popper-placement]) > .menu-item > .menu-sub:not([data-popper-placement]) > .menu-inner > .menu-item > .menu-link,
.menu-link-indention .menu-sub:not([data-popper-placement]) > .menu-inner > .menu-item > .menu-sub:not([data-popper-placement]) > .menu-item > .menu-content,
.menu-link-indention .menu-sub:not([data-popper-placement]) > .menu-inner > .menu-item > .menu-sub:not([data-popper-placement]) > .menu-item > .menu-link,
.menu-link-indention .menu-sub:not([data-popper-placement]) > .menu-inner > .menu-item > .menu-sub:not([data-popper-placement]) > .menu-inner > .menu-item > .menu-content,
.menu-link-indention .menu-sub:not([data-popper-placement]) > .menu-inner > .menu-item > .menu-sub:not([data-popper-placement]) > .menu-inner > .menu-item > .menu-link {
  padding-left: 3rem;
}

.menu-link-indention .menu-sub:not([data-popper-placement]) > .menu-item > .menu-sub:not([data-popper-placement]) > .menu-item > .menu-sub:not([data-popper-placement]) > .menu-item > .menu-content,
.menu-link-indention .menu-sub:not([data-popper-placement]) > .menu-item > .menu-sub:not([data-popper-placement]) > .menu-item > .menu-sub:not([data-popper-placement]) > .menu-item > .menu-link,
.menu-link-indention .menu-sub:not([data-popper-placement]) > .menu-item > .menu-sub:not([data-popper-placement]) > .menu-item > .menu-sub:not([data-popper-placement]) > .menu-inner > .menu-item > .menu-content,
.menu-link-indention .menu-sub:not([data-popper-placement]) > .menu-item > .menu-sub:not([data-popper-placement]) > .menu-item > .menu-sub:not([data-popper-placement]) > .menu-inner > .menu-item > .menu-link,
.menu-link-indention .menu-sub:not([data-popper-placement]) > .menu-item > .menu-sub:not([data-popper-placement]) > .menu-inner > .menu-item > .menu-sub:not([data-popper-placement]) > .menu-item > .menu-content,
.menu-link-indention .menu-sub:not([data-popper-placement]) > .menu-item > .menu-sub:not([data-popper-placement]) > .menu-inner > .menu-item > .menu-sub:not([data-popper-placement]) > .menu-item > .menu-link,
.menu-link-indention .menu-sub:not([data-popper-placement]) > .menu-item > .menu-sub:not([data-popper-placement]) > .menu-inner > .menu-item > .menu-sub:not([data-popper-placement]) > .menu-inner > .menu-item > .menu-content,
.menu-link-indention .menu-sub:not([data-popper-placement]) > .menu-item > .menu-sub:not([data-popper-placement]) > .menu-inner > .menu-item > .menu-sub:not([data-popper-placement]) > .menu-inner > .menu-item > .menu-link,
.menu-link-indention .menu-sub:not([data-popper-placement]) > .menu-inner > .menu-item > .menu-sub:not([data-popper-placement]) > .menu-item > .menu-sub:not([data-popper-placement]) > .menu-item > .menu-content,
.menu-link-indention .menu-sub:not([data-popper-placement]) > .menu-inner > .menu-item > .menu-sub:not([data-popper-placement]) > .menu-item > .menu-sub:not([data-popper-placement]) > .menu-item > .menu-link,
.menu-link-indention .menu-sub:not([data-popper-placement]) > .menu-inner > .menu-item > .menu-sub:not([data-popper-placement]) > .menu-item > .menu-sub:not([data-popper-placement]) > .menu-inner > .menu-item > .menu-content,
.menu-link-indention .menu-sub:not([data-popper-placement]) > .menu-inner > .menu-item > .menu-sub:not([data-popper-placement]) > .menu-item > .menu-sub:not([data-popper-placement]) > .menu-inner > .menu-item > .menu-link,
.menu-link-indention .menu-sub:not([data-popper-placement]) > .menu-inner > .menu-item > .menu-sub:not([data-popper-placement]) > .menu-inner > .menu-item > .menu-sub:not([data-popper-placement]) > .menu-item > .menu-content,
.menu-link-indention .menu-sub:not([data-popper-placement]) > .menu-inner > .menu-item > .menu-sub:not([data-popper-placement]) > .menu-inner > .menu-item > .menu-sub:not([data-popper-placement]) > .menu-item > .menu-link,
.menu-link-indention .menu-sub:not([data-popper-placement]) > .menu-inner > .menu-item > .menu-sub:not([data-popper-placement]) > .menu-inner > .menu-item > .menu-sub:not([data-popper-placement]) > .menu-inner > .menu-item > .menu-content,
.menu-link-indention .menu-sub:not([data-popper-placement]) > .menu-inner > .menu-item > .menu-sub:not([data-popper-placement]) > .menu-inner > .menu-item > .menu-sub:not([data-popper-placement]) > .menu-inner > .menu-item > .menu-link {
  padding-left: 4rem;
}

.menu-link-indention .menu-sub:not([data-popper-placement]) > .menu-item > .menu-sub:not([data-popper-placement]) > .menu-item > .menu-sub:not([data-popper-placement]) > .menu-item > .menu-sub:not([data-popper-placement]) > .menu-item > .menu-content,
.menu-link-indention .menu-sub:not([data-popper-placement]) > .menu-item > .menu-sub:not([data-popper-placement]) > .menu-item > .menu-sub:not([data-popper-placement]) > .menu-item > .menu-sub:not([data-popper-placement]) > .menu-item > .menu-link,
.menu-link-indention .menu-sub:not([data-popper-placement]) > .menu-item > .menu-sub:not([data-popper-placement]) > .menu-item > .menu-sub:not([data-popper-placement]) > .menu-item > .menu-sub:not([data-popper-placement]) > .menu-inner > .menu-item > .menu-content,
.menu-link-indention .menu-sub:not([data-popper-placement]) > .menu-item > .menu-sub:not([data-popper-placement]) > .menu-item > .menu-sub:not([data-popper-placement]) > .menu-item > .menu-sub:not([data-popper-placement]) > .menu-inner > .menu-item > .menu-link,
.menu-link-indention .menu-sub:not([data-popper-placement]) > .menu-item > .menu-sub:not([data-popper-placement]) > .menu-item > .menu-sub:not([data-popper-placement]) > .menu-inner > .menu-item > .menu-sub:not([data-popper-placement]) > .menu-item > .menu-content,
.menu-link-indention .menu-sub:not([data-popper-placement]) > .menu-item > .menu-sub:not([data-popper-placement]) > .menu-item > .menu-sub:not([data-popper-placement]) > .menu-inner > .menu-item > .menu-sub:not([data-popper-placement]) > .menu-item > .menu-link,
.menu-link-indention .menu-sub:not([data-popper-placement]) > .menu-item > .menu-sub:not([data-popper-placement]) > .menu-item > .menu-sub:not([data-popper-placement]) > .menu-inner > .menu-item > .menu-sub:not([data-popper-placement]) > .menu-inner > .menu-item > .menu-content,
.menu-link-indention .menu-sub:not([data-popper-placement]) > .menu-item > .menu-sub:not([data-popper-placement]) > .menu-item > .menu-sub:not([data-popper-placement]) > .menu-inner > .menu-item > .menu-sub:not([data-popper-placement]) > .menu-inner > .menu-item > .menu-link,
.menu-link-indention .menu-sub:not([data-popper-placement]) > .menu-item > .menu-sub:not([data-popper-placement]) > .menu-inner > .menu-item > .menu-sub:not([data-popper-placement]) > .menu-item > .menu-sub:not([data-popper-placement]) > .menu-item > .menu-content,
.menu-link-indention .menu-sub:not([data-popper-placement]) > .menu-item > .menu-sub:not([data-popper-placement]) > .menu-inner > .menu-item > .menu-sub:not([data-popper-placement]) > .menu-item > .menu-sub:not([data-popper-placement]) > .menu-item > .menu-link,
.menu-link-indention .menu-sub:not([data-popper-placement]) > .menu-item > .menu-sub:not([data-popper-placement]) > .menu-inner > .menu-item > .menu-sub:not([data-popper-placement]) > .menu-item > .menu-sub:not([data-popper-placement]) > .menu-inner > .menu-item > .menu-content,
.menu-link-indention .menu-sub:not([data-popper-placement]) > .menu-item > .menu-sub:not([data-popper-placement]) > .menu-inner > .menu-item > .menu-sub:not([data-popper-placement]) > .menu-item > .menu-sub:not([data-popper-placement]) > .menu-inner > .menu-item > .menu-link,
.menu-link-indention .menu-sub:not([data-popper-placement]) > .menu-item > .menu-sub:not([data-popper-placement]) > .menu-inner > .menu-item > .menu-sub:not([data-popper-placement]) > .menu-inner > .menu-item > .menu-sub:not([data-popper-placement]) > .menu-item > .menu-content,
.menu-link-indention .menu-sub:not([data-popper-placement]) > .menu-item > .menu-sub:not([data-popper-placement]) > .menu-inner > .menu-item > .menu-sub:not([data-popper-placement]) > .menu-inner > .menu-item > .menu-sub:not([data-popper-placement]) > .menu-item > .menu-link,
.menu-link-indention .menu-sub:not([data-popper-placement]) > .menu-item > .menu-sub:not([data-popper-placement]) > .menu-inner > .menu-item > .menu-sub:not([data-popper-placement]) > .menu-inner > .menu-item > .menu-sub:not([data-popper-placement]) > .menu-inner > .menu-item > .menu-content,
.menu-link-indention .menu-sub:not([data-popper-placement]) > .menu-item > .menu-sub:not([data-popper-placement]) > .menu-inner > .menu-item > .menu-sub:not([data-popper-placement]) > .menu-inner > .menu-item > .menu-sub:not([data-popper-placement]) > .menu-inner > .menu-item > .menu-link,
.menu-link-indention .menu-sub:not([data-popper-placement]) > .menu-inner > .menu-item > .menu-sub:not([data-popper-placement]) > .menu-item > .menu-sub:not([data-popper-placement]) > .menu-item > .menu-sub:not([data-popper-placement]) > .menu-item > .menu-content,
.menu-link-indention .menu-sub:not([data-popper-placement]) > .menu-inner > .menu-item > .menu-sub:not([data-popper-placement]) > .menu-item > .menu-sub:not([data-popper-placement]) > .menu-item > .menu-sub:not([data-popper-placement]) > .menu-item > .menu-link,
.menu-link-indention .menu-sub:not([data-popper-placement]) > .menu-inner > .menu-item > .menu-sub:not([data-popper-placement]) > .menu-item > .menu-sub:not([data-popper-placement]) > .menu-item > .menu-sub:not([data-popper-placement]) > .menu-inner > .menu-item > .menu-content,
.menu-link-indention .menu-sub:not([data-popper-placement]) > .menu-inner > .menu-item > .menu-sub:not([data-popper-placement]) > .menu-item > .menu-sub:not([data-popper-placement]) > .menu-item > .menu-sub:not([data-popper-placement]) > .menu-inner > .menu-item > .menu-link,
.menu-link-indention .menu-sub:not([data-popper-placement]) > .menu-inner > .menu-item > .menu-sub:not([data-popper-placement]) > .menu-item > .menu-sub:not([data-popper-placement]) > .menu-inner > .menu-item > .menu-sub:not([data-popper-placement]) > .menu-item > .menu-content,
.menu-link-indention .menu-sub:not([data-popper-placement]) > .menu-inner > .menu-item > .menu-sub:not([data-popper-placement]) > .menu-item > .menu-sub:not([data-popper-placement]) > .menu-inner > .menu-item > .menu-sub:not([data-popper-placement]) > .menu-item > .menu-link,
.menu-link-indention .menu-sub:not([data-popper-placement]) > .menu-inner > .menu-item > .menu-sub:not([data-popper-placement]) > .menu-item > .menu-sub:not([data-popper-placement]) > .menu-inner > .menu-item > .menu-sub:not([data-popper-placement]) > .menu-inner > .menu-item > .menu-content,
.menu-link-indention .menu-sub:not([data-popper-placement]) > .menu-inner > .menu-item > .menu-sub:not([data-popper-placement]) > .menu-item > .menu-sub:not([data-popper-placement]) > .menu-inner > .menu-item > .menu-sub:not([data-popper-placement]) > .menu-inner > .menu-item > .menu-link,
.menu-link-indention .menu-sub:not([data-popper-placement]) > .menu-inner > .menu-item > .menu-sub:not([data-popper-placement]) > .menu-inner > .menu-item > .menu-sub:not([data-popper-placement]) > .menu-item > .menu-sub:not([data-popper-placement]) > .menu-item > .menu-content,
.menu-link-indention .menu-sub:not([data-popper-placement]) > .menu-inner > .menu-item > .menu-sub:not([data-popper-placement]) > .menu-inner > .menu-item > .menu-sub:not([data-popper-placement]) > .menu-item > .menu-sub:not([data-popper-placement]) > .menu-item > .menu-link,
.menu-link-indention .menu-sub:not([data-popper-placement]) > .menu-inner > .menu-item > .menu-sub:not([data-popper-placement]) > .menu-inner > .menu-item > .menu-sub:not([data-popper-placement]) > .menu-item > .menu-sub:not([data-popper-placement]) > .menu-inner > .menu-item > .menu-content,
.menu-link-indention .menu-sub:not([data-popper-placement]) > .menu-inner > .menu-item > .menu-sub:not([data-popper-placement]) > .menu-inner > .menu-item > .menu-sub:not([data-popper-placement]) > .menu-item > .menu-sub:not([data-popper-placement]) > .menu-inner > .menu-item > .menu-link,
.menu-link-indention .menu-sub:not([data-popper-placement]) > .menu-inner > .menu-item > .menu-sub:not([data-popper-placement]) > .menu-inner > .menu-item > .menu-sub:not([data-popper-placement]) > .menu-inner > .menu-item > .menu-sub:not([data-popper-placement]) > .menu-item > .menu-content,
.menu-link-indention .menu-sub:not([data-popper-placement]) > .menu-inner > .menu-item > .menu-sub:not([data-popper-placement]) > .menu-inner > .menu-item > .menu-sub:not([data-popper-placement]) > .menu-inner > .menu-item > .menu-sub:not([data-popper-placement]) > .menu-item > .menu-link,
.menu-link-indention .menu-sub:not([data-popper-placement]) > .menu-inner > .menu-item > .menu-sub:not([data-popper-placement]) > .menu-inner > .menu-item > .menu-sub:not([data-popper-placement]) > .menu-inner > .menu-item > .menu-sub:not([data-popper-placement]) > .menu-inner > .menu-item > .menu-content,
.menu-link-indention .menu-sub:not([data-popper-placement]) > .menu-inner > .menu-item > .menu-sub:not([data-popper-placement]) > .menu-inner > .menu-item > .menu-sub:not([data-popper-placement]) > .menu-inner > .menu-item > .menu-sub:not([data-popper-placement]) > .menu-inner > .menu-item > .menu-link {
  padding-left: 5rem;
}

.menu-link-indention.menu-fit .menu-sub:not([data-popper-placement]) > .menu-item > .menu-content,
.menu-link-indention.menu-fit .menu-sub:not([data-popper-placement]) > .menu-item > .menu-link,
.menu-link-indention.menu-fit .menu-sub:not([data-popper-placement]) > .menu-inner > .menu-item > .menu-content,
.menu-link-indention.menu-fit .menu-sub:not([data-popper-placement]) > .menu-inner > .menu-item > .menu-link {
  padding-left: 1rem;
  padding-right: 0;
}

.menu-link-indention.menu-fit .menu-sub:not([data-popper-placement]) > .menu-item > .menu-sub:not([data-popper-placement]) > .menu-item > .menu-content,
.menu-link-indention.menu-fit .menu-sub:not([data-popper-placement]) > .menu-item > .menu-sub:not([data-popper-placement]) > .menu-item > .menu-link,
.menu-link-indention.menu-fit .menu-sub:not([data-popper-placement]) > .menu-item > .menu-sub:not([data-popper-placement]) > .menu-inner > .menu-item > .menu-content,
.menu-link-indention.menu-fit .menu-sub:not([data-popper-placement]) > .menu-item > .menu-sub:not([data-popper-placement]) > .menu-inner > .menu-item > .menu-link,
.menu-link-indention.menu-fit .menu-sub:not([data-popper-placement]) > .menu-inner > .menu-item > .menu-sub:not([data-popper-placement]) > .menu-item > .menu-content,
.menu-link-indention.menu-fit .menu-sub:not([data-popper-placement]) > .menu-inner > .menu-item > .menu-sub:not([data-popper-placement]) > .menu-item > .menu-link,
.menu-link-indention.menu-fit .menu-sub:not([data-popper-placement]) > .menu-inner > .menu-item > .menu-sub:not([data-popper-placement]) > .menu-inner > .menu-item > .menu-content,
.menu-link-indention.menu-fit .menu-sub:not([data-popper-placement]) > .menu-inner > .menu-item > .menu-sub:not([data-popper-placement]) > .menu-inner > .menu-item > .menu-link {
  padding-left: 2rem;
  padding-right: 0;
}

.menu-link-indention.menu-fit .menu-sub:not([data-popper-placement]) > .menu-item > .menu-sub:not([data-popper-placement]) > .menu-item > .menu-sub:not([data-popper-placement]) > .menu-item > .menu-content,
.menu-link-indention.menu-fit .menu-sub:not([data-popper-placement]) > .menu-item > .menu-sub:not([data-popper-placement]) > .menu-item > .menu-sub:not([data-popper-placement]) > .menu-item > .menu-link,
.menu-link-indention.menu-fit .menu-sub:not([data-popper-placement]) > .menu-item > .menu-sub:not([data-popper-placement]) > .menu-item > .menu-sub:not([data-popper-placement]) > .menu-inner > .menu-item > .menu-content,
.menu-link-indention.menu-fit .menu-sub:not([data-popper-placement]) > .menu-item > .menu-sub:not([data-popper-placement]) > .menu-item > .menu-sub:not([data-popper-placement]) > .menu-inner > .menu-item > .menu-link,
.menu-link-indention.menu-fit .menu-sub:not([data-popper-placement]) > .menu-item > .menu-sub:not([data-popper-placement]) > .menu-inner > .menu-item > .menu-sub:not([data-popper-placement]) > .menu-item > .menu-content,
.menu-link-indention.menu-fit .menu-sub:not([data-popper-placement]) > .menu-item > .menu-sub:not([data-popper-placement]) > .menu-inner > .menu-item > .menu-sub:not([data-popper-placement]) > .menu-item > .menu-link,
.menu-link-indention.menu-fit .menu-sub:not([data-popper-placement]) > .menu-item > .menu-sub:not([data-popper-placement]) > .menu-inner > .menu-item > .menu-sub:not([data-popper-placement]) > .menu-inner > .menu-item > .menu-content,
.menu-link-indention.menu-fit .menu-sub:not([data-popper-placement]) > .menu-item > .menu-sub:not([data-popper-placement]) > .menu-inner > .menu-item > .menu-sub:not([data-popper-placement]) > .menu-inner > .menu-item > .menu-link,
.menu-link-indention.menu-fit .menu-sub:not([data-popper-placement]) > .menu-inner > .menu-item > .menu-sub:not([data-popper-placement]) > .menu-item > .menu-sub:not([data-popper-placement]) > .menu-item > .menu-content,
.menu-link-indention.menu-fit .menu-sub:not([data-popper-placement]) > .menu-inner > .menu-item > .menu-sub:not([data-popper-placement]) > .menu-item > .menu-sub:not([data-popper-placement]) > .menu-item > .menu-link,
.menu-link-indention.menu-fit .menu-sub:not([data-popper-placement]) > .menu-inner > .menu-item > .menu-sub:not([data-popper-placement]) > .menu-item > .menu-sub:not([data-popper-placement]) > .menu-inner > .menu-item > .menu-content,
.menu-link-indention.menu-fit .menu-sub:not([data-popper-placement]) > .menu-inner > .menu-item > .menu-sub:not([data-popper-placement]) > .menu-item > .menu-sub:not([data-popper-placement]) > .menu-inner > .menu-item > .menu-link,
.menu-link-indention.menu-fit .menu-sub:not([data-popper-placement]) > .menu-inner > .menu-item > .menu-sub:not([data-popper-placement]) > .menu-inner > .menu-item > .menu-sub:not([data-popper-placement]) > .menu-item > .menu-content,
.menu-link-indention.menu-fit .menu-sub:not([data-popper-placement]) > .menu-inner > .menu-item > .menu-sub:not([data-popper-placement]) > .menu-inner > .menu-item > .menu-sub:not([data-popper-placement]) > .menu-item > .menu-link,
.menu-link-indention.menu-fit .menu-sub:not([data-popper-placement]) > .menu-inner > .menu-item > .menu-sub:not([data-popper-placement]) > .menu-inner > .menu-item > .menu-sub:not([data-popper-placement]) > .menu-inner > .menu-item > .menu-content,
.menu-link-indention.menu-fit .menu-sub:not([data-popper-placement]) > .menu-inner > .menu-item > .menu-sub:not([data-popper-placement]) > .menu-inner > .menu-item > .menu-sub:not([data-popper-placement]) > .menu-inner > .menu-item > .menu-link {
  padding-left: 3rem;
  padding-right: 0;
}

.menu-link-indention.menu-fit .menu-sub:not([data-popper-placement]) > .menu-item > .menu-sub:not([data-popper-placement]) > .menu-item > .menu-sub:not([data-popper-placement]) > .menu-item > .menu-sub:not([data-popper-placement]) > .menu-item > .menu-content,
.menu-link-indention.menu-fit .menu-sub:not([data-popper-placement]) > .menu-item > .menu-sub:not([data-popper-placement]) > .menu-item > .menu-sub:not([data-popper-placement]) > .menu-item > .menu-sub:not([data-popper-placement]) > .menu-item > .menu-link,
.menu-link-indention.menu-fit .menu-sub:not([data-popper-placement]) > .menu-item > .menu-sub:not([data-popper-placement]) > .menu-item > .menu-sub:not([data-popper-placement]) > .menu-item > .menu-sub:not([data-popper-placement]) > .menu-inner > .menu-item > .menu-content,
.menu-link-indention.menu-fit .menu-sub:not([data-popper-placement]) > .menu-item > .menu-sub:not([data-popper-placement]) > .menu-item > .menu-sub:not([data-popper-placement]) > .menu-item > .menu-sub:not([data-popper-placement]) > .menu-inner > .menu-item > .menu-link,
.menu-link-indention.menu-fit .menu-sub:not([data-popper-placement]) > .menu-item > .menu-sub:not([data-popper-placement]) > .menu-item > .menu-sub:not([data-popper-placement]) > .menu-inner > .menu-item > .menu-sub:not([data-popper-placement]) > .menu-item > .menu-content,
.menu-link-indention.menu-fit .menu-sub:not([data-popper-placement]) > .menu-item > .menu-sub:not([data-popper-placement]) > .menu-item > .menu-sub:not([data-popper-placement]) > .menu-inner > .menu-item > .menu-sub:not([data-popper-placement]) > .menu-item > .menu-link,
.menu-link-indention.menu-fit .menu-sub:not([data-popper-placement]) > .menu-item > .menu-sub:not([data-popper-placement]) > .menu-item > .menu-sub:not([data-popper-placement]) > .menu-inner > .menu-item > .menu-sub:not([data-popper-placement]) > .menu-inner > .menu-item > .menu-content,
.menu-link-indention.menu-fit .menu-sub:not([data-popper-placement]) > .menu-item > .menu-sub:not([data-popper-placement]) > .menu-item > .menu-sub:not([data-popper-placement]) > .menu-inner > .menu-item > .menu-sub:not([data-popper-placement]) > .menu-inner > .menu-item > .menu-link,
.menu-link-indention.menu-fit .menu-sub:not([data-popper-placement]) > .menu-item > .menu-sub:not([data-popper-placement]) > .menu-inner > .menu-item > .menu-sub:not([data-popper-placement]) > .menu-item > .menu-sub:not([data-popper-placement]) > .menu-item > .menu-content,
.menu-link-indention.menu-fit .menu-sub:not([data-popper-placement]) > .menu-item > .menu-sub:not([data-popper-placement]) > .menu-inner > .menu-item > .menu-sub:not([data-popper-placement]) > .menu-item > .menu-sub:not([data-popper-placement]) > .menu-item > .menu-link,
.menu-link-indention.menu-fit .menu-sub:not([data-popper-placement]) > .menu-item > .menu-sub:not([data-popper-placement]) > .menu-inner > .menu-item > .menu-sub:not([data-popper-placement]) > .menu-item > .menu-sub:not([data-popper-placement]) > .menu-inner > .menu-item > .menu-content,
.menu-link-indention.menu-fit .menu-sub:not([data-popper-placement]) > .menu-item > .menu-sub:not([data-popper-placement]) > .menu-inner > .menu-item > .menu-sub:not([data-popper-placement]) > .menu-item > .menu-sub:not([data-popper-placement]) > .menu-inner > .menu-item > .menu-link,
.menu-link-indention.menu-fit .menu-sub:not([data-popper-placement]) > .menu-item > .menu-sub:not([data-popper-placement]) > .menu-inner > .menu-item > .menu-sub:not([data-popper-placement]) > .menu-inner > .menu-item > .menu-sub:not([data-popper-placement]) > .menu-item > .menu-content,
.menu-link-indention.menu-fit .menu-sub:not([data-popper-placement]) > .menu-item > .menu-sub:not([data-popper-placement]) > .menu-inner > .menu-item > .menu-sub:not([data-popper-placement]) > .menu-inner > .menu-item > .menu-sub:not([data-popper-placement]) > .menu-item > .menu-link,
.menu-link-indention.menu-fit .menu-sub:not([data-popper-placement]) > .menu-item > .menu-sub:not([data-popper-placement]) > .menu-inner > .menu-item > .menu-sub:not([data-popper-placement]) > .menu-inner > .menu-item > .menu-sub:not([data-popper-placement]) > .menu-inner > .menu-item > .menu-content,
.menu-link-indention.menu-fit .menu-sub:not([data-popper-placement]) > .menu-item > .menu-sub:not([data-popper-placement]) > .menu-inner > .menu-item > .menu-sub:not([data-popper-placement]) > .menu-inner > .menu-item > .menu-sub:not([data-popper-placement]) > .menu-inner > .menu-item > .menu-link,
.menu-link-indention.menu-fit .menu-sub:not([data-popper-placement]) > .menu-inner > .menu-item > .menu-sub:not([data-popper-placement]) > .menu-item > .menu-sub:not([data-popper-placement]) > .menu-item > .menu-sub:not([data-popper-placement]) > .menu-item > .menu-content,
.menu-link-indention.menu-fit .menu-sub:not([data-popper-placement]) > .menu-inner > .menu-item > .menu-sub:not([data-popper-placement]) > .menu-item > .menu-sub:not([data-popper-placement]) > .menu-item > .menu-sub:not([data-popper-placement]) > .menu-item > .menu-link,
.menu-link-indention.menu-fit .menu-sub:not([data-popper-placement]) > .menu-inner > .menu-item > .menu-sub:not([data-popper-placement]) > .menu-item > .menu-sub:not([data-popper-placement]) > .menu-item > .menu-sub:not([data-popper-placement]) > .menu-inner > .menu-item > .menu-content,
.menu-link-indention.menu-fit .menu-sub:not([data-popper-placement]) > .menu-inner > .menu-item > .menu-sub:not([data-popper-placement]) > .menu-item > .menu-sub:not([data-popper-placement]) > .menu-item > .menu-sub:not([data-popper-placement]) > .menu-inner > .menu-item > .menu-link,
.menu-link-indention.menu-fit .menu-sub:not([data-popper-placement]) > .menu-inner > .menu-item > .menu-sub:not([data-popper-placement]) > .menu-item > .menu-sub:not([data-popper-placement]) > .menu-inner > .menu-item > .menu-sub:not([data-popper-placement]) > .menu-item > .menu-content,
.menu-link-indention.menu-fit .menu-sub:not([data-popper-placement]) > .menu-inner > .menu-item > .menu-sub:not([data-popper-placement]) > .menu-item > .menu-sub:not([data-popper-placement]) > .menu-inner > .menu-item > .menu-sub:not([data-popper-placement]) > .menu-item > .menu-link,
.menu-link-indention.menu-fit .menu-sub:not([data-popper-placement]) > .menu-inner > .menu-item > .menu-sub:not([data-popper-placement]) > .menu-item > .menu-sub:not([data-popper-placement]) > .menu-inner > .menu-item > .menu-sub:not([data-popper-placement]) > .menu-inner > .menu-item > .menu-content,
.menu-link-indention.menu-fit .menu-sub:not([data-popper-placement]) > .menu-inner > .menu-item > .menu-sub:not([data-popper-placement]) > .menu-item > .menu-sub:not([data-popper-placement]) > .menu-inner > .menu-item > .menu-sub:not([data-popper-placement]) > .menu-inner > .menu-item > .menu-link,
.menu-link-indention.menu-fit .menu-sub:not([data-popper-placement]) > .menu-inner > .menu-item > .menu-sub:not([data-popper-placement]) > .menu-inner > .menu-item > .menu-sub:not([data-popper-placement]) > .menu-item > .menu-sub:not([data-popper-placement]) > .menu-item > .menu-content,
.menu-link-indention.menu-fit .menu-sub:not([data-popper-placement]) > .menu-inner > .menu-item > .menu-sub:not([data-popper-placement]) > .menu-inner > .menu-item > .menu-sub:not([data-popper-placement]) > .menu-item > .menu-sub:not([data-popper-placement]) > .menu-item > .menu-link,
.menu-link-indention.menu-fit .menu-sub:not([data-popper-placement]) > .menu-inner > .menu-item > .menu-sub:not([data-popper-placement]) > .menu-inner > .menu-item > .menu-sub:not([data-popper-placement]) > .menu-item > .menu-sub:not([data-popper-placement]) > .menu-inner > .menu-item > .menu-content,
.menu-link-indention.menu-fit .menu-sub:not([data-popper-placement]) > .menu-inner > .menu-item > .menu-sub:not([data-popper-placement]) > .menu-inner > .menu-item > .menu-sub:not([data-popper-placement]) > .menu-item > .menu-sub:not([data-popper-placement]) > .menu-inner > .menu-item > .menu-link,
.menu-link-indention.menu-fit .menu-sub:not([data-popper-placement]) > .menu-inner > .menu-item > .menu-sub:not([data-popper-placement]) > .menu-inner > .menu-item > .menu-sub:not([data-popper-placement]) > .menu-inner > .menu-item > .menu-sub:not([data-popper-placement]) > .menu-item > .menu-content,
.menu-link-indention.menu-fit .menu-sub:not([data-popper-placement]) > .menu-inner > .menu-item > .menu-sub:not([data-popper-placement]) > .menu-inner > .menu-item > .menu-sub:not([data-popper-placement]) > .menu-inner > .menu-item > .menu-sub:not([data-popper-placement]) > .menu-item > .menu-link,
.menu-link-indention.menu-fit .menu-sub:not([data-popper-placement]) > .menu-inner > .menu-item > .menu-sub:not([data-popper-placement]) > .menu-inner > .menu-item > .menu-sub:not([data-popper-placement]) > .menu-inner > .menu-item > .menu-sub:not([data-popper-placement]) > .menu-inner > .menu-item > .menu-content,
.menu-link-indention.menu-fit .menu-sub:not([data-popper-placement]) > .menu-inner > .menu-item > .menu-sub:not([data-popper-placement]) > .menu-inner > .menu-item > .menu-sub:not([data-popper-placement]) > .menu-inner > .menu-item > .menu-sub:not([data-popper-placement]) > .menu-inner > .menu-item > .menu-link {
  padding-left: 4rem;
  padding-right: 0;
}

@keyframes menu-sub-dropdown-animation-fade-in {
  from {
    opacity: 0;
  }
  to {
    opacity: 1;
  }
}
@keyframes menu-sub-dropdown-animation-move-up {
  from {
    margin-top: 0.75rem;
  }
  to {
    margin-top: 0;
  }
}
@keyframes menu-sub-dropdown-animation-move-down {
  from {
    margin-bottom: 0.75rem;
  }
  to {
    margin-bottom: 0;
  }
}
.menu-white .menu-item .menu-link {
  color: var(--bs-white);
}

.menu-white .menu-item .menu-link .menu-title {
  color: var(--bs-white);
}

.menu-white .menu-item .menu-link .menu-icon,
.menu-white .menu-item .menu-link .menu-icon .svg-icon,
.menu-white .menu-item .menu-link .menu-icon i {
  color: var(--bs-white);
}

.menu-white .menu-item .menu-link .menu-bullet .bullet {
  background-color: var(--bs-white);
}

.menu-white .menu-item .menu-link .menu-arrow:after {
  mask-image: url(${___CSS_LOADER_URL_REPLACEMENT_30___});
  /*rtl:begin:remove*/
  mask-repeat: no-repeat;
  mask-position: center;
  -webkit-mask-repeat: no-repeat;
  -webkit-mask-position: center;
  background-color: var(--bs-white);
  mask-image: url(${___CSS_LOADER_URL_REPLACEMENT_31___});
  /*rtl:end:remove*/
}

.menu-title-white .menu-item .menu-link {
  color: var(--bs-text-white);
}

.menu-title-white .menu-item .menu-link .menu-title {
  color: var(--bs-text-white);
}

.menu-icon-white .menu-item .menu-link .menu-icon,
.menu-icon-white .menu-item .menu-link .menu-icon .svg-icon,
.menu-icon-white .menu-item .menu-link .menu-icon i {
  color: var(--bs-text-white);
}

.menu-bullet-white .menu-item .menu-link .menu-bullet .bullet {
  background-color: var(--bs-text-white);
}

.menu-arrow-white .menu-item .menu-link .menu-arrow:after {
  mask-image: url(${___CSS_LOADER_URL_REPLACEMENT_32___});
  /*rtl:begin:remove*/
  mask-repeat: no-repeat;
  mask-position: center;
  -webkit-mask-repeat: no-repeat;
  -webkit-mask-position: center;
  background-color: var(--bs-text-white);
  mask-image: url(${___CSS_LOADER_URL_REPLACEMENT_33___});
  /*rtl:end:remove*/
}

.menu-primary .menu-item .menu-link {
  color: var(--bs-primary);
}

.menu-primary .menu-item .menu-link .menu-title {
  color: var(--bs-primary);
}

.menu-primary .menu-item .menu-link .menu-icon,
.menu-primary .menu-item .menu-link .menu-icon .svg-icon,
.menu-primary .menu-item .menu-link .menu-icon i {
  color: var(--bs-primary);
}

.menu-primary .menu-item .menu-link .menu-bullet .bullet {
  background-color: var(--bs-primary);
}

.menu-primary .menu-item .menu-link .menu-arrow:after {
  mask-image: url(${___CSS_LOADER_URL_REPLACEMENT_34___});
  /*rtl:begin:remove*/
  mask-repeat: no-repeat;
  mask-position: center;
  -webkit-mask-repeat: no-repeat;
  -webkit-mask-position: center;
  background-color: var(--bs-primary);
  mask-image: url(${___CSS_LOADER_URL_REPLACEMENT_35___});
  /*rtl:end:remove*/
}

.menu-title-primary .menu-item .menu-link {
  color: var(--bs-text-primary);
}

.menu-title-primary .menu-item .menu-link .menu-title {
  color: var(--bs-text-primary);
}

.menu-icon-primary .menu-item .menu-link .menu-icon,
.menu-icon-primary .menu-item .menu-link .menu-icon .svg-icon,
.menu-icon-primary .menu-item .menu-link .menu-icon i {
  color: var(--bs-text-primary);
}

.menu-bullet-primary .menu-item .menu-link .menu-bullet .bullet {
  background-color: var(--bs-text-primary);
}

.menu-arrow-primary .menu-item .menu-link .menu-arrow:after {
  mask-image: url(${___CSS_LOADER_URL_REPLACEMENT_36___});
  /*rtl:begin:remove*/
  mask-repeat: no-repeat;
  mask-position: center;
  -webkit-mask-repeat: no-repeat;
  -webkit-mask-position: center;
  background-color: var(--bs-text-primary);
  mask-image: url(${___CSS_LOADER_URL_REPLACEMENT_37___});
  /*rtl:end:remove*/
}

.menu-secondary .menu-item .menu-link {
  color: var(--bs-secondary);
}

.menu-secondary .menu-item .menu-link .menu-title {
  color: var(--bs-secondary);
}

.menu-secondary .menu-item .menu-link .menu-icon,
.menu-secondary .menu-item .menu-link .menu-icon .svg-icon,
.menu-secondary .menu-item .menu-link .menu-icon i {
  color: var(--bs-secondary);
}

.menu-secondary .menu-item .menu-link .menu-bullet .bullet {
  background-color: var(--bs-secondary);
}

.menu-secondary .menu-item .menu-link .menu-arrow:after {
  mask-image: url(${___CSS_LOADER_URL_REPLACEMENT_38___});
  /*rtl:begin:remove*/
  mask-repeat: no-repeat;
  mask-position: center;
  -webkit-mask-repeat: no-repeat;
  -webkit-mask-position: center;
  background-color: var(--bs-secondary);
  mask-image: url(${___CSS_LOADER_URL_REPLACEMENT_39___});
  /*rtl:end:remove*/
}

.menu-title-secondary .menu-item .menu-link {
  color: var(--bs-text-secondary);
}

.menu-title-secondary .menu-item .menu-link .menu-title {
  color: var(--bs-text-secondary);
}

.menu-icon-secondary .menu-item .menu-link .menu-icon,
.menu-icon-secondary .menu-item .menu-link .menu-icon .svg-icon,
.menu-icon-secondary .menu-item .menu-link .menu-icon i {
  color: var(--bs-text-secondary);
}

.menu-bullet-secondary .menu-item .menu-link .menu-bullet .bullet {
  background-color: var(--bs-text-secondary);
}

.menu-arrow-secondary .menu-item .menu-link .menu-arrow:after {
  mask-image: url(${___CSS_LOADER_URL_REPLACEMENT_40___});
  /*rtl:begin:remove*/
  mask-repeat: no-repeat;
  mask-position: center;
  -webkit-mask-repeat: no-repeat;
  -webkit-mask-position: center;
  background-color: var(--bs-text-secondary);
  mask-image: url(${___CSS_LOADER_URL_REPLACEMENT_41___});
  /*rtl:end:remove*/
}

.menu-light .menu-item .menu-link {
  color: var(--bs-light);
}

.menu-light .menu-item .menu-link .menu-title {
  color: var(--bs-light);
}

.menu-light .menu-item .menu-link .menu-icon,
.menu-light .menu-item .menu-link .menu-icon .svg-icon,
.menu-light .menu-item .menu-link .menu-icon i {
  color: var(--bs-light);
}

.menu-light .menu-item .menu-link .menu-bullet .bullet {
  background-color: var(--bs-light);
}

.menu-light .menu-item .menu-link .menu-arrow:after {
  mask-image: url(${___CSS_LOADER_URL_REPLACEMENT_42___});
  /*rtl:begin:remove*/
  mask-repeat: no-repeat;
  mask-position: center;
  -webkit-mask-repeat: no-repeat;
  -webkit-mask-position: center;
  background-color: var(--bs-light);
  mask-image: url(${___CSS_LOADER_URL_REPLACEMENT_43___});
  /*rtl:end:remove*/
}

.menu-title-light .menu-item .menu-link {
  color: var(--bs-text-light);
}

.menu-title-light .menu-item .menu-link .menu-title {
  color: var(--bs-text-light);
}

.menu-icon-light .menu-item .menu-link .menu-icon,
.menu-icon-light .menu-item .menu-link .menu-icon .svg-icon,
.menu-icon-light .menu-item .menu-link .menu-icon i {
  color: var(--bs-text-light);
}

.menu-bullet-light .menu-item .menu-link .menu-bullet .bullet {
  background-color: var(--bs-text-light);
}

.menu-arrow-light .menu-item .menu-link .menu-arrow:after {
  mask-image: url(${___CSS_LOADER_URL_REPLACEMENT_44___});
  /*rtl:begin:remove*/
  mask-repeat: no-repeat;
  mask-position: center;
  -webkit-mask-repeat: no-repeat;
  -webkit-mask-position: center;
  background-color: var(--bs-text-light);
  mask-image: url(${___CSS_LOADER_URL_REPLACEMENT_45___});
  /*rtl:end:remove*/
}

.menu-success .menu-item .menu-link {
  color: var(--bs-success);
}

.menu-success .menu-item .menu-link .menu-title {
  color: var(--bs-success);
}

.menu-success .menu-item .menu-link .menu-icon,
.menu-success .menu-item .menu-link .menu-icon .svg-icon,
.menu-success .menu-item .menu-link .menu-icon i {
  color: var(--bs-success);
}

.menu-success .menu-item .menu-link .menu-bullet .bullet {
  background-color: var(--bs-success);
}

.menu-success .menu-item .menu-link .menu-arrow:after {
  mask-image: url(${___CSS_LOADER_URL_REPLACEMENT_46___});
  /*rtl:begin:remove*/
  mask-repeat: no-repeat;
  mask-position: center;
  -webkit-mask-repeat: no-repeat;
  -webkit-mask-position: center;
  background-color: var(--bs-success);
  mask-image: url(${___CSS_LOADER_URL_REPLACEMENT_47___});
  /*rtl:end:remove*/
}

.menu-title-success .menu-item .menu-link {
  color: var(--bs-text-success);
}

.menu-title-success .menu-item .menu-link .menu-title {
  color: var(--bs-text-success);
}

.menu-icon-success .menu-item .menu-link .menu-icon,
.menu-icon-success .menu-item .menu-link .menu-icon .svg-icon,
.menu-icon-success .menu-item .menu-link .menu-icon i {
  color: var(--bs-text-success);
}

.menu-bullet-success .menu-item .menu-link .menu-bullet .bullet {
  background-color: var(--bs-text-success);
}

.menu-arrow-success .menu-item .menu-link .menu-arrow:after {
  mask-image: url(${___CSS_LOADER_URL_REPLACEMENT_48___});
  /*rtl:begin:remove*/
  mask-repeat: no-repeat;
  mask-position: center;
  -webkit-mask-repeat: no-repeat;
  -webkit-mask-position: center;
  background-color: var(--bs-text-success);
  mask-image: url(${___CSS_LOADER_URL_REPLACEMENT_49___});
  /*rtl:end:remove*/
}

.menu-info .menu-item .menu-link {
  color: var(--bs-info);
}

.menu-info .menu-item .menu-link .menu-title {
  color: var(--bs-info);
}

.menu-info .menu-item .menu-link .menu-icon,
.menu-info .menu-item .menu-link .menu-icon .svg-icon,
.menu-info .menu-item .menu-link .menu-icon i {
  color: var(--bs-info);
}

.menu-info .menu-item .menu-link .menu-bullet .bullet {
  background-color: var(--bs-info);
}

.menu-info .menu-item .menu-link .menu-arrow:after {
  mask-image: url(${___CSS_LOADER_URL_REPLACEMENT_50___});
  /*rtl:begin:remove*/
  mask-repeat: no-repeat;
  mask-position: center;
  -webkit-mask-repeat: no-repeat;
  -webkit-mask-position: center;
  background-color: var(--bs-info);
  mask-image: url(${___CSS_LOADER_URL_REPLACEMENT_51___});
  /*rtl:end:remove*/
}

.menu-title-info .menu-item .menu-link {
  color: var(--bs-text-info);
}

.menu-title-info .menu-item .menu-link .menu-title {
  color: var(--bs-text-info);
}

.menu-icon-info .menu-item .menu-link .menu-icon,
.menu-icon-info .menu-item .menu-link .menu-icon .svg-icon,
.menu-icon-info .menu-item .menu-link .menu-icon i {
  color: var(--bs-text-info);
}

.menu-bullet-info .menu-item .menu-link .menu-bullet .bullet {
  background-color: var(--bs-text-info);
}

.menu-arrow-info .menu-item .menu-link .menu-arrow:after {
  mask-image: url(${___CSS_LOADER_URL_REPLACEMENT_52___});
  /*rtl:begin:remove*/
  mask-repeat: no-repeat;
  mask-position: center;
  -webkit-mask-repeat: no-repeat;
  -webkit-mask-position: center;
  background-color: var(--bs-text-info);
  mask-image: url(${___CSS_LOADER_URL_REPLACEMENT_53___});
  /*rtl:end:remove*/
}

.menu-warning .menu-item .menu-link {
  color: var(--bs-warning);
}

.menu-warning .menu-item .menu-link .menu-title {
  color: var(--bs-warning);
}

.menu-warning .menu-item .menu-link .menu-icon,
.menu-warning .menu-item .menu-link .menu-icon .svg-icon,
.menu-warning .menu-item .menu-link .menu-icon i {
  color: var(--bs-warning);
}

.menu-warning .menu-item .menu-link .menu-bullet .bullet {
  background-color: var(--bs-warning);
}

.menu-warning .menu-item .menu-link .menu-arrow:after {
  mask-image: url(${___CSS_LOADER_URL_REPLACEMENT_54___});
  /*rtl:begin:remove*/
  mask-repeat: no-repeat;
  mask-position: center;
  -webkit-mask-repeat: no-repeat;
  -webkit-mask-position: center;
  background-color: var(--bs-warning);
  mask-image: url(${___CSS_LOADER_URL_REPLACEMENT_55___});
  /*rtl:end:remove*/
}

.menu-title-warning .menu-item .menu-link {
  color: var(--bs-text-warning);
}

.menu-title-warning .menu-item .menu-link .menu-title {
  color: var(--bs-text-warning);
}

.menu-icon-warning .menu-item .menu-link .menu-icon,
.menu-icon-warning .menu-item .menu-link .menu-icon .svg-icon,
.menu-icon-warning .menu-item .menu-link .menu-icon i {
  color: var(--bs-text-warning);
}

.menu-bullet-warning .menu-item .menu-link .menu-bullet .bullet {
  background-color: var(--bs-text-warning);
}

.menu-arrow-warning .menu-item .menu-link .menu-arrow:after {
  mask-image: url(${___CSS_LOADER_URL_REPLACEMENT_56___});
  /*rtl:begin:remove*/
  mask-repeat: no-repeat;
  mask-position: center;
  -webkit-mask-repeat: no-repeat;
  -webkit-mask-position: center;
  background-color: var(--bs-text-warning);
  mask-image: url(${___CSS_LOADER_URL_REPLACEMENT_57___});
  /*rtl:end:remove*/
}

.menu-danger .menu-item .menu-link {
  color: var(--bs-danger);
}

.menu-danger .menu-item .menu-link .menu-title {
  color: var(--bs-danger);
}

.menu-danger .menu-item .menu-link .menu-icon,
.menu-danger .menu-item .menu-link .menu-icon .svg-icon,
.menu-danger .menu-item .menu-link .menu-icon i {
  color: var(--bs-danger);
}

.menu-danger .menu-item .menu-link .menu-bullet .bullet {
  background-color: var(--bs-danger);
}

.menu-danger .menu-item .menu-link .menu-arrow:after {
  mask-image: url(${___CSS_LOADER_URL_REPLACEMENT_58___});
  /*rtl:begin:remove*/
  mask-repeat: no-repeat;
  mask-position: center;
  -webkit-mask-repeat: no-repeat;
  -webkit-mask-position: center;
  background-color: var(--bs-danger);
  mask-image: url(${___CSS_LOADER_URL_REPLACEMENT_59___});
  /*rtl:end:remove*/
}

.menu-title-danger .menu-item .menu-link {
  color: var(--bs-text-danger);
}

.menu-title-danger .menu-item .menu-link .menu-title {
  color: var(--bs-text-danger);
}

.menu-icon-danger .menu-item .menu-link .menu-icon,
.menu-icon-danger .menu-item .menu-link .menu-icon .svg-icon,
.menu-icon-danger .menu-item .menu-link .menu-icon i {
  color: var(--bs-text-danger);
}

.menu-bullet-danger .menu-item .menu-link .menu-bullet .bullet {
  background-color: var(--bs-text-danger);
}

.menu-arrow-danger .menu-item .menu-link .menu-arrow:after {
  mask-image: url(${___CSS_LOADER_URL_REPLACEMENT_60___});
  /*rtl:begin:remove*/
  mask-repeat: no-repeat;
  mask-position: center;
  -webkit-mask-repeat: no-repeat;
  -webkit-mask-position: center;
  background-color: var(--bs-text-danger);
  mask-image: url(${___CSS_LOADER_URL_REPLACEMENT_61___});
  /*rtl:end:remove*/
}

.menu-dark .menu-item .menu-link {
  color: var(--bs-dark);
}

.menu-dark .menu-item .menu-link .menu-title {
  color: var(--bs-dark);
}

.menu-dark .menu-item .menu-link .menu-icon,
.menu-dark .menu-item .menu-link .menu-icon .svg-icon,
.menu-dark .menu-item .menu-link .menu-icon i {
  color: var(--bs-dark);
}

.menu-dark .menu-item .menu-link .menu-bullet .bullet {
  background-color: var(--bs-dark);
}

.menu-dark .menu-item .menu-link .menu-arrow:after {
  mask-image: url(${___CSS_LOADER_URL_REPLACEMENT_62___});
  /*rtl:begin:remove*/
  mask-repeat: no-repeat;
  mask-position: center;
  -webkit-mask-repeat: no-repeat;
  -webkit-mask-position: center;
  background-color: var(--bs-dark);
  mask-image: url(${___CSS_LOADER_URL_REPLACEMENT_63___});
  /*rtl:end:remove*/
}

.menu-title-dark .menu-item .menu-link {
  color: var(--bs-text-dark);
}

.menu-title-dark .menu-item .menu-link .menu-title {
  color: var(--bs-text-dark);
}

.menu-icon-dark .menu-item .menu-link .menu-icon,
.menu-icon-dark .menu-item .menu-link .menu-icon .svg-icon,
.menu-icon-dark .menu-item .menu-link .menu-icon i {
  color: var(--bs-text-dark);
}

.menu-bullet-dark .menu-item .menu-link .menu-bullet .bullet {
  background-color: var(--bs-text-dark);
}

.menu-arrow-dark .menu-item .menu-link .menu-arrow:after {
  mask-image: url(${___CSS_LOADER_URL_REPLACEMENT_64___});
  /*rtl:begin:remove*/
  mask-repeat: no-repeat;
  mask-position: center;
  -webkit-mask-repeat: no-repeat;
  -webkit-mask-position: center;
  background-color: var(--bs-text-dark);
  mask-image: url(${___CSS_LOADER_URL_REPLACEMENT_65___});
  /*rtl:end:remove*/
}

.menu-muted .menu-item .menu-link {
  color: var(--bs-muted);
}

.menu-muted .menu-item .menu-link .menu-title {
  color: var(--bs-muted);
}

.menu-muted .menu-item .menu-link .menu-icon,
.menu-muted .menu-item .menu-link .menu-icon .svg-icon,
.menu-muted .menu-item .menu-link .menu-icon i {
  color: var(--bs-muted);
}

.menu-muted .menu-item .menu-link .menu-bullet .bullet {
  background-color: var(--bs-muted);
}

.menu-muted .menu-item .menu-link .menu-arrow:after {
  mask-image: url(${___CSS_LOADER_URL_REPLACEMENT_66___});
  /*rtl:begin:remove*/
  mask-repeat: no-repeat;
  mask-position: center;
  -webkit-mask-repeat: no-repeat;
  -webkit-mask-position: center;
  background-color: var(--bs-muted);
  mask-image: url(${___CSS_LOADER_URL_REPLACEMENT_67___});
  /*rtl:end:remove*/
}

.menu-title-muted .menu-item .menu-link {
  color: var(--bs-text-muted);
}

.menu-title-muted .menu-item .menu-link .menu-title {
  color: var(--bs-text-muted);
}

.menu-icon-muted .menu-item .menu-link .menu-icon,
.menu-icon-muted .menu-item .menu-link .menu-icon .svg-icon,
.menu-icon-muted .menu-item .menu-link .menu-icon i {
  color: var(--bs-text-muted);
}

.menu-bullet-muted .menu-item .menu-link .menu-bullet .bullet {
  background-color: var(--bs-text-muted);
}

.menu-arrow-muted .menu-item .menu-link .menu-arrow:after {
  mask-image: url(${___CSS_LOADER_URL_REPLACEMENT_28___});
  /*rtl:begin:remove*/
  mask-repeat: no-repeat;
  mask-position: center;
  -webkit-mask-repeat: no-repeat;
  -webkit-mask-position: center;
  background-color: var(--bs-text-muted);
  mask-image: url(${___CSS_LOADER_URL_REPLACEMENT_29___});
  /*rtl:end:remove*/
}

.menu-gray-100 .menu-item .menu-link {
  color: var(--bs-gray-100);
}

.menu-gray-100 .menu-item .menu-link .menu-title {
  color: var(--bs-gray-100);
}

.menu-gray-100 .menu-item .menu-link .menu-icon,
.menu-gray-100 .menu-item .menu-link .menu-icon .svg-icon,
.menu-gray-100 .menu-item .menu-link .menu-icon i {
  color: var(--bs-gray-100);
}

.menu-gray-100 .menu-item .menu-link .menu-bullet .bullet {
  background-color: var(--bs-gray-100);
}

.menu-gray-100 .menu-item .menu-link .menu-arrow:after {
  mask-image: url(${___CSS_LOADER_URL_REPLACEMENT_68___});
  /*rtl:begin:remove*/
  mask-repeat: no-repeat;
  mask-position: center;
  -webkit-mask-repeat: no-repeat;
  -webkit-mask-position: center;
  background-color: var(--bs-gray-100);
  mask-image: url(${___CSS_LOADER_URL_REPLACEMENT_69___});
  /*rtl:end:remove*/
}

.menu-title-gray-100 .menu-item .menu-link {
  color: var(--bs-text-gray-100);
}

.menu-title-gray-100 .menu-item .menu-link .menu-title {
  color: var(--bs-text-gray-100);
}

.menu-icon-gray-100 .menu-item .menu-link .menu-icon,
.menu-icon-gray-100 .menu-item .menu-link .menu-icon .svg-icon,
.menu-icon-gray-100 .menu-item .menu-link .menu-icon i {
  color: var(--bs-text-gray-100);
}

.menu-bullet-gray-100 .menu-item .menu-link .menu-bullet .bullet {
  background-color: var(--bs-text-gray-100);
}

.menu-arrow-gray-100 .menu-item .menu-link .menu-arrow:after {
  mask-image: url(${___CSS_LOADER_URL_REPLACEMENT_70___});
  /*rtl:begin:remove*/
  mask-repeat: no-repeat;
  mask-position: center;
  -webkit-mask-repeat: no-repeat;
  -webkit-mask-position: center;
  background-color: var(--bs-text-gray-100);
  mask-image: url(${___CSS_LOADER_URL_REPLACEMENT_71___});
  /*rtl:end:remove*/
}

.menu-gray-200 .menu-item .menu-link {
  color: var(--bs-gray-200);
}

.menu-gray-200 .menu-item .menu-link .menu-title {
  color: var(--bs-gray-200);
}

.menu-gray-200 .menu-item .menu-link .menu-icon,
.menu-gray-200 .menu-item .menu-link .menu-icon .svg-icon,
.menu-gray-200 .menu-item .menu-link .menu-icon i {
  color: var(--bs-gray-200);
}

.menu-gray-200 .menu-item .menu-link .menu-bullet .bullet {
  background-color: var(--bs-gray-200);
}

.menu-gray-200 .menu-item .menu-link .menu-arrow:after {
  mask-image: url(${___CSS_LOADER_URL_REPLACEMENT_72___});
  /*rtl:begin:remove*/
  mask-repeat: no-repeat;
  mask-position: center;
  -webkit-mask-repeat: no-repeat;
  -webkit-mask-position: center;
  background-color: var(--bs-gray-200);
  mask-image: url(${___CSS_LOADER_URL_REPLACEMENT_73___});
  /*rtl:end:remove*/
}

.menu-title-gray-200 .menu-item .menu-link {
  color: var(--bs-text-gray-200);
}

.menu-title-gray-200 .menu-item .menu-link .menu-title {
  color: var(--bs-text-gray-200);
}

.menu-icon-gray-200 .menu-item .menu-link .menu-icon,
.menu-icon-gray-200 .menu-item .menu-link .menu-icon .svg-icon,
.menu-icon-gray-200 .menu-item .menu-link .menu-icon i {
  color: var(--bs-text-gray-200);
}

.menu-bullet-gray-200 .menu-item .menu-link .menu-bullet .bullet {
  background-color: var(--bs-text-gray-200);
}

.menu-arrow-gray-200 .menu-item .menu-link .menu-arrow:after {
  mask-image: url(${___CSS_LOADER_URL_REPLACEMENT_74___});
  /*rtl:begin:remove*/
  mask-repeat: no-repeat;
  mask-position: center;
  -webkit-mask-repeat: no-repeat;
  -webkit-mask-position: center;
  background-color: var(--bs-text-gray-200);
  mask-image: url(${___CSS_LOADER_URL_REPLACEMENT_75___});
  /*rtl:end:remove*/
}

.menu-gray-300 .menu-item .menu-link {
  color: var(--bs-gray-300);
}

.menu-gray-300 .menu-item .menu-link .menu-title {
  color: var(--bs-gray-300);
}

.menu-gray-300 .menu-item .menu-link .menu-icon,
.menu-gray-300 .menu-item .menu-link .menu-icon .svg-icon,
.menu-gray-300 .menu-item .menu-link .menu-icon i {
  color: var(--bs-gray-300);
}

.menu-gray-300 .menu-item .menu-link .menu-bullet .bullet {
  background-color: var(--bs-gray-300);
}

.menu-gray-300 .menu-item .menu-link .menu-arrow:after {
  mask-image: url(${___CSS_LOADER_URL_REPLACEMENT_76___});
  /*rtl:begin:remove*/
  mask-repeat: no-repeat;
  mask-position: center;
  -webkit-mask-repeat: no-repeat;
  -webkit-mask-position: center;
  background-color: var(--bs-gray-300);
  mask-image: url(${___CSS_LOADER_URL_REPLACEMENT_77___});
  /*rtl:end:remove*/
}

.menu-title-gray-300 .menu-item .menu-link {
  color: var(--bs-text-gray-300);
}

.menu-title-gray-300 .menu-item .menu-link .menu-title {
  color: var(--bs-text-gray-300);
}

.menu-icon-gray-300 .menu-item .menu-link .menu-icon,
.menu-icon-gray-300 .menu-item .menu-link .menu-icon .svg-icon,
.menu-icon-gray-300 .menu-item .menu-link .menu-icon i {
  color: var(--bs-text-gray-300);
}

.menu-bullet-gray-300 .menu-item .menu-link .menu-bullet .bullet {
  background-color: var(--bs-text-gray-300);
}

.menu-arrow-gray-300 .menu-item .menu-link .menu-arrow:after {
  mask-image: url(${___CSS_LOADER_URL_REPLACEMENT_78___});
  /*rtl:begin:remove*/
  mask-repeat: no-repeat;
  mask-position: center;
  -webkit-mask-repeat: no-repeat;
  -webkit-mask-position: center;
  background-color: var(--bs-text-gray-300);
  mask-image: url(${___CSS_LOADER_URL_REPLACEMENT_79___});
  /*rtl:end:remove*/
}

.menu-gray-400 .menu-item .menu-link {
  color: var(--bs-gray-400);
}

.menu-gray-400 .menu-item .menu-link .menu-title {
  color: var(--bs-gray-400);
}

.menu-gray-400 .menu-item .menu-link .menu-icon,
.menu-gray-400 .menu-item .menu-link .menu-icon .svg-icon,
.menu-gray-400 .menu-item .menu-link .menu-icon i {
  color: var(--bs-gray-400);
}

.menu-gray-400 .menu-item .menu-link .menu-bullet .bullet {
  background-color: var(--bs-gray-400);
}

.menu-gray-400 .menu-item .menu-link .menu-arrow:after {
  mask-image: url(${___CSS_LOADER_URL_REPLACEMENT_80___});
  /*rtl:begin:remove*/
  mask-repeat: no-repeat;
  mask-position: center;
  -webkit-mask-repeat: no-repeat;
  -webkit-mask-position: center;
  background-color: var(--bs-gray-400);
  mask-image: url(${___CSS_LOADER_URL_REPLACEMENT_81___});
  /*rtl:end:remove*/
}

.menu-title-gray-400 .menu-item .menu-link {
  color: var(--bs-text-gray-400);
}

.menu-title-gray-400 .menu-item .menu-link .menu-title {
  color: var(--bs-text-gray-400);
}

.menu-icon-gray-400 .menu-item .menu-link .menu-icon,
.menu-icon-gray-400 .menu-item .menu-link .menu-icon .svg-icon,
.menu-icon-gray-400 .menu-item .menu-link .menu-icon i {
  color: var(--bs-text-gray-400);
}

.menu-bullet-gray-400 .menu-item .menu-link .menu-bullet .bullet {
  background-color: var(--bs-text-gray-400);
}

.menu-arrow-gray-400 .menu-item .menu-link .menu-arrow:after {
  mask-image: url(${___CSS_LOADER_URL_REPLACEMENT_82___});
  /*rtl:begin:remove*/
  mask-repeat: no-repeat;
  mask-position: center;
  -webkit-mask-repeat: no-repeat;
  -webkit-mask-position: center;
  background-color: var(--bs-text-gray-400);
  mask-image: url(${___CSS_LOADER_URL_REPLACEMENT_83___});
  /*rtl:end:remove*/
}

.menu-gray-500 .menu-item .menu-link {
  color: var(--bs-gray-500);
}

.menu-gray-500 .menu-item .menu-link .menu-title {
  color: var(--bs-gray-500);
}

.menu-gray-500 .menu-item .menu-link .menu-icon,
.menu-gray-500 .menu-item .menu-link .menu-icon .svg-icon,
.menu-gray-500 .menu-item .menu-link .menu-icon i {
  color: var(--bs-gray-500);
}

.menu-gray-500 .menu-item .menu-link .menu-bullet .bullet {
  background-color: var(--bs-gray-500);
}

.menu-gray-500 .menu-item .menu-link .menu-arrow:after {
  mask-image: url(${___CSS_LOADER_URL_REPLACEMENT_84___});
  /*rtl:begin:remove*/
  mask-repeat: no-repeat;
  mask-position: center;
  -webkit-mask-repeat: no-repeat;
  -webkit-mask-position: center;
  background-color: var(--bs-gray-500);
  mask-image: url(${___CSS_LOADER_URL_REPLACEMENT_85___});
  /*rtl:end:remove*/
}

.menu-title-gray-500 .menu-item .menu-link {
  color: var(--bs-text-gray-500);
}

.menu-title-gray-500 .menu-item .menu-link .menu-title {
  color: var(--bs-text-gray-500);
}

.menu-icon-gray-500 .menu-item .menu-link .menu-icon,
.menu-icon-gray-500 .menu-item .menu-link .menu-icon .svg-icon,
.menu-icon-gray-500 .menu-item .menu-link .menu-icon i {
  color: var(--bs-text-gray-500);
}

.menu-bullet-gray-500 .menu-item .menu-link .menu-bullet .bullet {
  background-color: var(--bs-text-gray-500);
}

.menu-arrow-gray-500 .menu-item .menu-link .menu-arrow:after {
  mask-image: url(${___CSS_LOADER_URL_REPLACEMENT_86___});
  /*rtl:begin:remove*/
  mask-repeat: no-repeat;
  mask-position: center;
  -webkit-mask-repeat: no-repeat;
  -webkit-mask-position: center;
  background-color: var(--bs-text-gray-500);
  mask-image: url(${___CSS_LOADER_URL_REPLACEMENT_87___});
  /*rtl:end:remove*/
}

.menu-gray-600 .menu-item .menu-link {
  color: var(--bs-gray-600);
}

.menu-gray-600 .menu-item .menu-link .menu-title {
  color: var(--bs-gray-600);
}

.menu-gray-600 .menu-item .menu-link .menu-icon,
.menu-gray-600 .menu-item .menu-link .menu-icon .svg-icon,
.menu-gray-600 .menu-item .menu-link .menu-icon i {
  color: var(--bs-gray-600);
}

.menu-gray-600 .menu-item .menu-link .menu-bullet .bullet {
  background-color: var(--bs-gray-600);
}

.menu-gray-600 .menu-item .menu-link .menu-arrow:after {
  mask-image: url(${___CSS_LOADER_URL_REPLACEMENT_88___});
  /*rtl:begin:remove*/
  mask-repeat: no-repeat;
  mask-position: center;
  -webkit-mask-repeat: no-repeat;
  -webkit-mask-position: center;
  background-color: var(--bs-gray-600);
  mask-image: url(${___CSS_LOADER_URL_REPLACEMENT_89___});
  /*rtl:end:remove*/
}

.menu-title-gray-600 .menu-item .menu-link {
  color: var(--bs-text-gray-600);
}

.menu-title-gray-600 .menu-item .menu-link .menu-title {
  color: var(--bs-text-gray-600);
}

.menu-icon-gray-600 .menu-item .menu-link .menu-icon,
.menu-icon-gray-600 .menu-item .menu-link .menu-icon .svg-icon,
.menu-icon-gray-600 .menu-item .menu-link .menu-icon i {
  color: var(--bs-text-gray-600);
}

.menu-bullet-gray-600 .menu-item .menu-link .menu-bullet .bullet {
  background-color: var(--bs-text-gray-600);
}

.menu-arrow-gray-600 .menu-item .menu-link .menu-arrow:after {
  mask-image: url(${___CSS_LOADER_URL_REPLACEMENT_90___});
  /*rtl:begin:remove*/
  mask-repeat: no-repeat;
  mask-position: center;
  -webkit-mask-repeat: no-repeat;
  -webkit-mask-position: center;
  background-color: var(--bs-text-gray-600);
  mask-image: url(${___CSS_LOADER_URL_REPLACEMENT_91___});
  /*rtl:end:remove*/
}

.menu-gray-700 .menu-item .menu-link {
  color: var(--bs-gray-700);
}

.menu-gray-700 .menu-item .menu-link .menu-title {
  color: var(--bs-gray-700);
}

.menu-gray-700 .menu-item .menu-link .menu-icon,
.menu-gray-700 .menu-item .menu-link .menu-icon .svg-icon,
.menu-gray-700 .menu-item .menu-link .menu-icon i {
  color: var(--bs-gray-700);
}

.menu-gray-700 .menu-item .menu-link .menu-bullet .bullet {
  background-color: var(--bs-gray-700);
}

.menu-gray-700 .menu-item .menu-link .menu-arrow:after {
  mask-image: url(${___CSS_LOADER_URL_REPLACEMENT_18___});
  /*rtl:begin:remove*/
  mask-repeat: no-repeat;
  mask-position: center;
  -webkit-mask-repeat: no-repeat;
  -webkit-mask-position: center;
  background-color: var(--bs-gray-700);
  mask-image: url(${___CSS_LOADER_URL_REPLACEMENT_19___});
  /*rtl:end:remove*/
}

.menu-title-gray-700 .menu-item .menu-link {
  color: var(--bs-text-gray-700);
}

.menu-title-gray-700 .menu-item .menu-link .menu-title {
  color: var(--bs-text-gray-700);
}

.menu-icon-gray-700 .menu-item .menu-link .menu-icon,
.menu-icon-gray-700 .menu-item .menu-link .menu-icon .svg-icon,
.menu-icon-gray-700 .menu-item .menu-link .menu-icon i {
  color: var(--bs-text-gray-700);
}

.menu-bullet-gray-700 .menu-item .menu-link .menu-bullet .bullet {
  background-color: var(--bs-text-gray-700);
}

.menu-arrow-gray-700 .menu-item .menu-link .menu-arrow:after {
  mask-image: url(${___CSS_LOADER_URL_REPLACEMENT_92___});
  /*rtl:begin:remove*/
  mask-repeat: no-repeat;
  mask-position: center;
  -webkit-mask-repeat: no-repeat;
  -webkit-mask-position: center;
  background-color: var(--bs-text-gray-700);
  mask-image: url(${___CSS_LOADER_URL_REPLACEMENT_93___});
  /*rtl:end:remove*/
}

.menu-gray-800 .menu-item .menu-link {
  color: var(--bs-gray-800);
}

.menu-gray-800 .menu-item .menu-link .menu-title {
  color: var(--bs-gray-800);
}

.menu-gray-800 .menu-item .menu-link .menu-icon,
.menu-gray-800 .menu-item .menu-link .menu-icon .svg-icon,
.menu-gray-800 .menu-item .menu-link .menu-icon i {
  color: var(--bs-gray-800);
}

.menu-gray-800 .menu-item .menu-link .menu-bullet .bullet {
  background-color: var(--bs-gray-800);
}

.menu-gray-800 .menu-item .menu-link .menu-arrow:after {
  mask-image: url(${___CSS_LOADER_URL_REPLACEMENT_94___});
  /*rtl:begin:remove*/
  mask-repeat: no-repeat;
  mask-position: center;
  -webkit-mask-repeat: no-repeat;
  -webkit-mask-position: center;
  background-color: var(--bs-gray-800);
  mask-image: url(${___CSS_LOADER_URL_REPLACEMENT_95___});
  /*rtl:end:remove*/
}

.menu-title-gray-800 .menu-item .menu-link {
  color: var(--bs-text-gray-800);
}

.menu-title-gray-800 .menu-item .menu-link .menu-title {
  color: var(--bs-text-gray-800);
}

.menu-icon-gray-800 .menu-item .menu-link .menu-icon,
.menu-icon-gray-800 .menu-item .menu-link .menu-icon .svg-icon,
.menu-icon-gray-800 .menu-item .menu-link .menu-icon i {
  color: var(--bs-text-gray-800);
}

.menu-bullet-gray-800 .menu-item .menu-link .menu-bullet .bullet {
  background-color: var(--bs-text-gray-800);
}

.menu-arrow-gray-800 .menu-item .menu-link .menu-arrow:after {
  mask-image: url(${___CSS_LOADER_URL_REPLACEMENT_96___});
  /*rtl:begin:remove*/
  mask-repeat: no-repeat;
  mask-position: center;
  -webkit-mask-repeat: no-repeat;
  -webkit-mask-position: center;
  background-color: var(--bs-text-gray-800);
  mask-image: url(${___CSS_LOADER_URL_REPLACEMENT_97___});
  /*rtl:end:remove*/
}

.menu-gray-900 .menu-item .menu-link {
  color: var(--bs-gray-900);
}

.menu-gray-900 .menu-item .menu-link .menu-title {
  color: var(--bs-gray-900);
}

.menu-gray-900 .menu-item .menu-link .menu-icon,
.menu-gray-900 .menu-item .menu-link .menu-icon .svg-icon,
.menu-gray-900 .menu-item .menu-link .menu-icon i {
  color: var(--bs-gray-900);
}

.menu-gray-900 .menu-item .menu-link .menu-bullet .bullet {
  background-color: var(--bs-gray-900);
}

.menu-gray-900 .menu-item .menu-link .menu-arrow:after {
  mask-image: url(${___CSS_LOADER_URL_REPLACEMENT_98___});
  /*rtl:begin:remove*/
  mask-repeat: no-repeat;
  mask-position: center;
  -webkit-mask-repeat: no-repeat;
  -webkit-mask-position: center;
  background-color: var(--bs-gray-900);
  mask-image: url(${___CSS_LOADER_URL_REPLACEMENT_99___});
  /*rtl:end:remove*/
}

.menu-title-gray-900 .menu-item .menu-link {
  color: var(--bs-text-gray-900);
}

.menu-title-gray-900 .menu-item .menu-link .menu-title {
  color: var(--bs-text-gray-900);
}

.menu-icon-gray-900 .menu-item .menu-link .menu-icon,
.menu-icon-gray-900 .menu-item .menu-link .menu-icon .svg-icon,
.menu-icon-gray-900 .menu-item .menu-link .menu-icon i {
  color: var(--bs-text-gray-900);
}

.menu-bullet-gray-900 .menu-item .menu-link .menu-bullet .bullet {
  background-color: var(--bs-text-gray-900);
}

.menu-arrow-gray-900 .menu-item .menu-link .menu-arrow:after {
  mask-image: url(${___CSS_LOADER_URL_REPLACEMENT_100___});
  /*rtl:begin:remove*/
  mask-repeat: no-repeat;
  mask-position: center;
  -webkit-mask-repeat: no-repeat;
  -webkit-mask-position: center;
  background-color: var(--bs-text-gray-900);
  mask-image: url(${___CSS_LOADER_URL_REPLACEMENT_101___});
  /*rtl:end:remove*/
}

.menu-hover-bg .menu-item.hover:not(.here) > .menu-link:not(.disabled):not(.active):not(.here), .menu-hover-bg .menu-item:not(.here) .menu-link:hover:not(.disabled):not(.active):not(.here) {
  transition: color 0.2s ease;
  background-color: var(--bs-menu-link-bg-color-hover);
  color: var(--bs-menu-link-color-hover);
}

.menu-hover-bg .menu-item.hover:not(.here) > .menu-link:not(.disabled):not(.active):not(.here) .menu-title, .menu-hover-bg .menu-item:not(.here) .menu-link:hover:not(.disabled):not(.active):not(.here) .menu-title {
  color: var(--bs-menu-link-color-hover);
}

.menu-hover-bg .menu-item.hover:not(.here) > .menu-link:not(.disabled):not(.active):not(.here) .menu-icon,
.menu-hover-bg .menu-item.hover:not(.here) > .menu-link:not(.disabled):not(.active):not(.here) .menu-icon .svg-icon,
.menu-hover-bg .menu-item.hover:not(.here) > .menu-link:not(.disabled):not(.active):not(.here) .menu-icon i, .menu-hover-bg .menu-item:not(.here) .menu-link:hover:not(.disabled):not(.active):not(.here) .menu-icon,
.menu-hover-bg .menu-item:not(.here) .menu-link:hover:not(.disabled):not(.active):not(.here) .menu-icon .svg-icon,
.menu-hover-bg .menu-item:not(.here) .menu-link:hover:not(.disabled):not(.active):not(.here) .menu-icon i {
  color: var(--bs-menu-link-color-hover);
}

.menu-hover-bg .menu-item.hover:not(.here) > .menu-link:not(.disabled):not(.active):not(.here) .menu-bullet .bullet, .menu-hover-bg .menu-item:not(.here) .menu-link:hover:not(.disabled):not(.active):not(.here) .menu-bullet .bullet {
  background-color: var(--bs-menu-link-color-hover);
}

.menu-hover-bg .menu-item.hover:not(.here) > .menu-link:not(.disabled):not(.active):not(.here) .menu-arrow:after, .menu-hover-bg .menu-item:not(.here) .menu-link:hover:not(.disabled):not(.active):not(.here) .menu-arrow:after {
  mask-image: url(${___CSS_LOADER_URL_REPLACEMENT_102___});
  /*rtl:begin:remove*/
  mask-repeat: no-repeat;
  mask-position: center;
  -webkit-mask-repeat: no-repeat;
  -webkit-mask-position: center;
  background-color: var(--bs-menu-link-color-hover);
  mask-image: url(${___CSS_LOADER_URL_REPLACEMENT_103___});
  /*rtl:end:remove*/
}

.menu-here-bg .menu-item.here > .menu-link {
  transition: color 0.2s ease;
  background-color: var(--bs-menu-link-bg-color-here);
  color: var(--bs-menu-link-color-here);
}

.menu-here-bg .menu-item.here > .menu-link .menu-title {
  color: var(--bs-menu-link-color-here);
}

.menu-here-bg .menu-item.here > .menu-link .menu-icon,
.menu-here-bg .menu-item.here > .menu-link .menu-icon .svg-icon,
.menu-here-bg .menu-item.here > .menu-link .menu-icon i {
  color: var(--bs-menu-link-color-here);
}

.menu-here-bg .menu-item.here > .menu-link .menu-bullet .bullet {
  background-color: var(--bs-menu-link-color-here);
}

.menu-here-bg .menu-item.here > .menu-link .menu-arrow:after {
  mask-image: url(${___CSS_LOADER_URL_REPLACEMENT_104___});
  /*rtl:begin:remove*/
  mask-repeat: no-repeat;
  mask-position: center;
  -webkit-mask-repeat: no-repeat;
  -webkit-mask-position: center;
  background-color: var(--bs-menu-link-color-here);
  mask-image: url(${___CSS_LOADER_URL_REPLACEMENT_105___});
  /*rtl:end:remove*/
}

.menu-root-here-bg > .menu-item.here > .menu-link {
  transition: color 0.2s ease;
  background-color: var(--bs-menu-link-bg-color-here);
  color: var(--bs-menu-link-color-here);
}

.menu-root-here-bg > .menu-item.here > .menu-link .menu-title {
  color: var(--bs-menu-link-color-here);
}

.menu-root-here-bg > .menu-item.here > .menu-link .menu-icon,
.menu-root-here-bg > .menu-item.here > .menu-link .menu-icon .svg-icon,
.menu-root-here-bg > .menu-item.here > .menu-link .menu-icon i {
  color: var(--bs-menu-link-color-here);
}

.menu-root-here-bg > .menu-item.here > .menu-link .menu-bullet .bullet {
  background-color: var(--bs-menu-link-color-here);
}

.menu-root-here-bg > .menu-item.here > .menu-link .menu-arrow:after {
  mask-image: url(${___CSS_LOADER_URL_REPLACEMENT_104___});
  /*rtl:begin:remove*/
  mask-repeat: no-repeat;
  mask-position: center;
  -webkit-mask-repeat: no-repeat;
  -webkit-mask-position: center;
  background-color: var(--bs-menu-link-color-here);
  mask-image: url(${___CSS_LOADER_URL_REPLACEMENT_105___});
  /*rtl:end:remove*/
}

@media (min-width: 992px) {
  .menu-root-here-bg-desktop > .menu-item.here > .menu-link {
    transition: color 0.2s ease;
    background-color: var(--bs-menu-link-bg-color-here);
    color: var(--bs-menu-link-color-here);
  }
  .menu-root-here-bg-desktop > .menu-item.here > .menu-link .menu-title {
    color: var(--bs-menu-link-color-here);
  }
  .menu-root-here-bg-desktop > .menu-item.here > .menu-link .menu-icon,
  .menu-root-here-bg-desktop > .menu-item.here > .menu-link .menu-icon .svg-icon,
  .menu-root-here-bg-desktop > .menu-item.here > .menu-link .menu-icon i {
    color: var(--bs-menu-link-color-here);
  }
  .menu-root-here-bg-desktop > .menu-item.here > .menu-link .menu-bullet .bullet {
    background-color: var(--bs-menu-link-color-here);
  }
  .menu-root-here-bg-desktop > .menu-item.here > .menu-link .menu-arrow:after {
    mask-image: url(${___CSS_LOADER_URL_REPLACEMENT_104___});
    /*rtl:begin:remove*/
    mask-repeat: no-repeat;
    mask-position: center;
    -webkit-mask-repeat: no-repeat;
    -webkit-mask-position: center;
    background-color: var(--bs-menu-link-color-here);
    mask-image: url(${___CSS_LOADER_URL_REPLACEMENT_105___});
    /*rtl:end:remove*/
  }
}
.menu-show-bg .menu-item.show > .menu-link {
  transition: color 0.2s ease;
  background-color: var(--bs-menu-link-bg-color-show);
  color: var(--bs-menu-link-color-show);
}

.menu-show-bg .menu-item.show > .menu-link .menu-title {
  color: var(--bs-menu-link-color-show);
}

.menu-show-bg .menu-item.show > .menu-link .menu-icon,
.menu-show-bg .menu-item.show > .menu-link .menu-icon .svg-icon,
.menu-show-bg .menu-item.show > .menu-link .menu-icon i {
  color: var(--bs-menu-link-color-show);
}

.menu-show-bg .menu-item.show > .menu-link .menu-bullet .bullet {
  background-color: var(--bs-menu-link-color-show);
}

.menu-show-bg .menu-item.show > .menu-link .menu-arrow:after {
  mask-image: url(${___CSS_LOADER_URL_REPLACEMENT_106___});
  /*rtl:begin:remove*/
  mask-repeat: no-repeat;
  mask-position: center;
  -webkit-mask-repeat: no-repeat;
  -webkit-mask-position: center;
  background-color: var(--bs-menu-link-color-show);
  mask-image: url(${___CSS_LOADER_URL_REPLACEMENT_107___});
  /*rtl:end:remove*/
}

.menu-active-bg .menu-item .menu-link.active {
  transition: color 0.2s ease;
  background-color: var(--bs-menu-link-bg-color-active);
  color: var(--bs-menu-link-color-active);
}

.menu-active-bg .menu-item .menu-link.active .menu-title {
  color: var(--bs-menu-link-color-active);
}

.menu-active-bg .menu-item .menu-link.active .menu-icon,
.menu-active-bg .menu-item .menu-link.active .menu-icon .svg-icon,
.menu-active-bg .menu-item .menu-link.active .menu-icon i {
  color: var(--bs-menu-link-color-active);
}

.menu-active-bg .menu-item .menu-link.active .menu-bullet .bullet {
  background-color: var(--bs-menu-link-color-active);
}

.menu-active-bg .menu-item .menu-link.active .menu-arrow:after {
  mask-image: url(${___CSS_LOADER_URL_REPLACEMENT_108___});
  /*rtl:begin:remove*/
  mask-repeat: no-repeat;
  mask-position: center;
  -webkit-mask-repeat: no-repeat;
  -webkit-mask-position: center;
  background-color: var(--bs-menu-link-color-active);
  mask-image: url(${___CSS_LOADER_URL_REPLACEMENT_109___});
  /*rtl:end:remove*/
}

.menu-state-bg .menu-item.hover:not(.here) > .menu-link:not(.disabled):not(.active):not(.here), .menu-state-bg .menu-item:not(.here) .menu-link:hover:not(.disabled):not(.active):not(.here) {
  transition: color 0.2s ease;
  background-color: var(--bs-menu-link-bg-color-hover);
  color: var(--bs-menu-link-color-hover);
}

.menu-state-bg .menu-item.hover:not(.here) > .menu-link:not(.disabled):not(.active):not(.here) .menu-title, .menu-state-bg .menu-item:not(.here) .menu-link:hover:not(.disabled):not(.active):not(.here) .menu-title {
  color: var(--bs-menu-link-color-hover);
}

.menu-state-bg .menu-item.hover:not(.here) > .menu-link:not(.disabled):not(.active):not(.here) .menu-icon,
.menu-state-bg .menu-item.hover:not(.here) > .menu-link:not(.disabled):not(.active):not(.here) .menu-icon .svg-icon,
.menu-state-bg .menu-item.hover:not(.here) > .menu-link:not(.disabled):not(.active):not(.here) .menu-icon i, .menu-state-bg .menu-item:not(.here) .menu-link:hover:not(.disabled):not(.active):not(.here) .menu-icon,
.menu-state-bg .menu-item:not(.here) .menu-link:hover:not(.disabled):not(.active):not(.here) .menu-icon .svg-icon,
.menu-state-bg .menu-item:not(.here) .menu-link:hover:not(.disabled):not(.active):not(.here) .menu-icon i {
  color: var(--bs-menu-link-color-hover);
}

.menu-state-bg .menu-item.hover:not(.here) > .menu-link:not(.disabled):not(.active):not(.here) .menu-bullet .bullet, .menu-state-bg .menu-item:not(.here) .menu-link:hover:not(.disabled):not(.active):not(.here) .menu-bullet .bullet {
  background-color: var(--bs-menu-link-color-hover);
}

.menu-state-bg .menu-item.hover:not(.here) > .menu-link:not(.disabled):not(.active):not(.here) .menu-arrow:after, .menu-state-bg .menu-item:not(.here) .menu-link:hover:not(.disabled):not(.active):not(.here) .menu-arrow:after {
  mask-image: url(${___CSS_LOADER_URL_REPLACEMENT_102___});
  /*rtl:begin:remove*/
  mask-repeat: no-repeat;
  mask-position: center;
  -webkit-mask-repeat: no-repeat;
  -webkit-mask-position: center;
  background-color: var(--bs-menu-link-color-hover);
  mask-image: url(${___CSS_LOADER_URL_REPLACEMENT_103___});
  /*rtl:end:remove*/
}

.menu-state-bg .menu-item.here > .menu-link {
  transition: color 0.2s ease;
  background-color: var(--bs-menu-link-bg-color-here);
  color: var(--bs-menu-link-color-here);
}

.menu-state-bg .menu-item.here > .menu-link .menu-title {
  color: var(--bs-menu-link-color-here);
}

.menu-state-bg .menu-item.here > .menu-link .menu-icon,
.menu-state-bg .menu-item.here > .menu-link .menu-icon .svg-icon,
.menu-state-bg .menu-item.here > .menu-link .menu-icon i {
  color: var(--bs-menu-link-color-here);
}

.menu-state-bg .menu-item.here > .menu-link .menu-bullet .bullet {
  background-color: var(--bs-menu-link-color-here);
}

.menu-state-bg .menu-item.here > .menu-link .menu-arrow:after {
  mask-image: url(${___CSS_LOADER_URL_REPLACEMENT_104___});
  /*rtl:begin:remove*/
  mask-repeat: no-repeat;
  mask-position: center;
  -webkit-mask-repeat: no-repeat;
  -webkit-mask-position: center;
  background-color: var(--bs-menu-link-color-here);
  mask-image: url(${___CSS_LOADER_URL_REPLACEMENT_105___});
  /*rtl:end:remove*/
}

.menu-state-bg .menu-item.show > .menu-link {
  transition: color 0.2s ease;
  background-color: var(--bs-menu-link-bg-color-show);
  color: var(--bs-menu-link-color-show);
}

.menu-state-bg .menu-item.show > .menu-link .menu-title {
  color: var(--bs-menu-link-color-show);
}

.menu-state-bg .menu-item.show > .menu-link .menu-icon,
.menu-state-bg .menu-item.show > .menu-link .menu-icon .svg-icon,
.menu-state-bg .menu-item.show > .menu-link .menu-icon i {
  color: var(--bs-menu-link-color-show);
}

.menu-state-bg .menu-item.show > .menu-link .menu-bullet .bullet {
  background-color: var(--bs-menu-link-color-show);
}

.menu-state-bg .menu-item.show > .menu-link .menu-arrow:after {
  mask-image: url(${___CSS_LOADER_URL_REPLACEMENT_106___});
  /*rtl:begin:remove*/
  mask-repeat: no-repeat;
  mask-position: center;
  -webkit-mask-repeat: no-repeat;
  -webkit-mask-position: center;
  background-color: var(--bs-menu-link-color-show);
  mask-image: url(${___CSS_LOADER_URL_REPLACEMENT_107___});
  /*rtl:end:remove*/
}

.menu-state-bg .menu-item .menu-link.active {
  transition: color 0.2s ease;
  background-color: var(--bs-menu-link-bg-color-active);
  color: var(--bs-menu-link-color-active);
}

.menu-state-bg .menu-item .menu-link.active .menu-title {
  color: var(--bs-menu-link-color-active);
}

.menu-state-bg .menu-item .menu-link.active .menu-icon,
.menu-state-bg .menu-item .menu-link.active .menu-icon .svg-icon,
.menu-state-bg .menu-item .menu-link.active .menu-icon i {
  color: var(--bs-menu-link-color-active);
}

.menu-state-bg .menu-item .menu-link.active .menu-bullet .bullet {
  background-color: var(--bs-menu-link-color-active);
}

.menu-state-bg .menu-item .menu-link.active .menu-arrow:after {
  mask-image: url(${___CSS_LOADER_URL_REPLACEMENT_108___});
  /*rtl:begin:remove*/
  mask-repeat: no-repeat;
  mask-position: center;
  -webkit-mask-repeat: no-repeat;
  -webkit-mask-position: center;
  background-color: var(--bs-menu-link-color-active);
  mask-image: url(${___CSS_LOADER_URL_REPLACEMENT_109___});
  /*rtl:end:remove*/
}

.menu-state-color .menu-item.hover:not(.here) > .menu-link:not(.disabled):not(.active):not(.here), .menu-state-color .menu-item:not(.here) .menu-link:hover:not(.disabled):not(.active):not(.here) {
  transition: color 0.2s ease;
  color: var(--bs-menu-link-color-hover);
}

.menu-state-color .menu-item.hover:not(.here) > .menu-link:not(.disabled):not(.active):not(.here) .menu-title, .menu-state-color .menu-item:not(.here) .menu-link:hover:not(.disabled):not(.active):not(.here) .menu-title {
  color: var(--bs-menu-link-color-hover);
}

.menu-state-color .menu-item.hover:not(.here) > .menu-link:not(.disabled):not(.active):not(.here) .menu-icon,
.menu-state-color .menu-item.hover:not(.here) > .menu-link:not(.disabled):not(.active):not(.here) .menu-icon .svg-icon,
.menu-state-color .menu-item.hover:not(.here) > .menu-link:not(.disabled):not(.active):not(.here) .menu-icon i, .menu-state-color .menu-item:not(.here) .menu-link:hover:not(.disabled):not(.active):not(.here) .menu-icon,
.menu-state-color .menu-item:not(.here) .menu-link:hover:not(.disabled):not(.active):not(.here) .menu-icon .svg-icon,
.menu-state-color .menu-item:not(.here) .menu-link:hover:not(.disabled):not(.active):not(.here) .menu-icon i {
  color: var(--bs-menu-link-color-hover);
}

.menu-state-color .menu-item.hover:not(.here) > .menu-link:not(.disabled):not(.active):not(.here) .menu-bullet .bullet, .menu-state-color .menu-item:not(.here) .menu-link:hover:not(.disabled):not(.active):not(.here) .menu-bullet .bullet {
  background-color: var(--bs-menu-link-color-hover);
}

.menu-state-color .menu-item.hover:not(.here) > .menu-link:not(.disabled):not(.active):not(.here) .menu-arrow:after, .menu-state-color .menu-item:not(.here) .menu-link:hover:not(.disabled):not(.active):not(.here) .menu-arrow:after {
  mask-image: url(${___CSS_LOADER_URL_REPLACEMENT_102___});
  /*rtl:begin:remove*/
  mask-repeat: no-repeat;
  mask-position: center;
  -webkit-mask-repeat: no-repeat;
  -webkit-mask-position: center;
  background-color: var(--bs-menu-link-color-hover);
  mask-image: url(${___CSS_LOADER_URL_REPLACEMENT_103___});
  /*rtl:end:remove*/
}

.menu-state-color .menu-item.here > .menu-link {
  transition: color 0.2s ease;
  color: var(--bs-menu-link-color-here);
}

.menu-state-color .menu-item.here > .menu-link .menu-title {
  color: var(--bs-menu-link-color-here);
}

.menu-state-color .menu-item.here > .menu-link .menu-icon,
.menu-state-color .menu-item.here > .menu-link .menu-icon .svg-icon,
.menu-state-color .menu-item.here > .menu-link .menu-icon i {
  color: var(--bs-menu-link-color-here);
}

.menu-state-color .menu-item.here > .menu-link .menu-bullet .bullet {
  background-color: var(--bs-menu-link-color-here);
}

.menu-state-color .menu-item.here > .menu-link .menu-arrow:after {
  mask-image: url(${___CSS_LOADER_URL_REPLACEMENT_104___});
  /*rtl:begin:remove*/
  mask-repeat: no-repeat;
  mask-position: center;
  -webkit-mask-repeat: no-repeat;
  -webkit-mask-position: center;
  background-color: var(--bs-menu-link-color-here);
  mask-image: url(${___CSS_LOADER_URL_REPLACEMENT_105___});
  /*rtl:end:remove*/
}

.menu-state-color .menu-item.show > .menu-link {
  transition: color 0.2s ease;
  color: var(--bs-menu-link-color-show);
}

.menu-state-color .menu-item.show > .menu-link .menu-title {
  color: var(--bs-menu-link-color-show);
}

.menu-state-color .menu-item.show > .menu-link .menu-icon,
.menu-state-color .menu-item.show > .menu-link .menu-icon .svg-icon,
.menu-state-color .menu-item.show > .menu-link .menu-icon i {
  color: var(--bs-menu-link-color-show);
}

.menu-state-color .menu-item.show > .menu-link .menu-bullet .bullet {
  background-color: var(--bs-menu-link-color-show);
}

.menu-state-color .menu-item.show > .menu-link .menu-arrow:after {
  mask-image: url(${___CSS_LOADER_URL_REPLACEMENT_106___});
  /*rtl:begin:remove*/
  mask-repeat: no-repeat;
  mask-position: center;
  -webkit-mask-repeat: no-repeat;
  -webkit-mask-position: center;
  background-color: var(--bs-menu-link-color-show);
  mask-image: url(${___CSS_LOADER_URL_REPLACEMENT_107___});
  /*rtl:end:remove*/
}

.menu-state-color .menu-item .menu-link.active {
  transition: color 0.2s ease;
  color: var(--bs-menu-link-color-active);
}

.menu-state-color .menu-item .menu-link.active .menu-title {
  color: var(--bs-menu-link-color-active);
}

.menu-state-color .menu-item .menu-link.active .menu-icon,
.menu-state-color .menu-item .menu-link.active .menu-icon .svg-icon,
.menu-state-color .menu-item .menu-link.active .menu-icon i {
  color: var(--bs-menu-link-color-active);
}

.menu-state-color .menu-item .menu-link.active .menu-bullet .bullet {
  background-color: var(--bs-menu-link-color-active);
}

.menu-state-color .menu-item .menu-link.active .menu-arrow:after {
  mask-image: url(${___CSS_LOADER_URL_REPLACEMENT_108___});
  /*rtl:begin:remove*/
  mask-repeat: no-repeat;
  mask-position: center;
  -webkit-mask-repeat: no-repeat;
  -webkit-mask-position: center;
  background-color: var(--bs-menu-link-color-active);
  mask-image: url(${___CSS_LOADER_URL_REPLACEMENT_109___});
  /*rtl:end:remove*/
}

.menu-hover-bg-primary .menu-item.hover:not(.here) > .menu-link:not(.disabled):not(.active):not(.here), .menu-hover-bg-primary .menu-item:not(.here) .menu-link:hover:not(.disabled):not(.active):not(.here) {
  transition: color 0.2s ease;
  background-color: var(--bs-primary);
  color: var(--bs-primary-inverse);
}

.menu-hover-bg-primary .menu-item.hover:not(.here) > .menu-link:not(.disabled):not(.active):not(.here) .menu-title, .menu-hover-bg-primary .menu-item:not(.here) .menu-link:hover:not(.disabled):not(.active):not(.here) .menu-title {
  color: var(--bs-primary-inverse);
}

.menu-hover-bg-primary .menu-item.hover:not(.here) > .menu-link:not(.disabled):not(.active):not(.here) .menu-icon,
.menu-hover-bg-primary .menu-item.hover:not(.here) > .menu-link:not(.disabled):not(.active):not(.here) .menu-icon .svg-icon,
.menu-hover-bg-primary .menu-item.hover:not(.here) > .menu-link:not(.disabled):not(.active):not(.here) .menu-icon i, .menu-hover-bg-primary .menu-item:not(.here) .menu-link:hover:not(.disabled):not(.active):not(.here) .menu-icon,
.menu-hover-bg-primary .menu-item:not(.here) .menu-link:hover:not(.disabled):not(.active):not(.here) .menu-icon .svg-icon,
.menu-hover-bg-primary .menu-item:not(.here) .menu-link:hover:not(.disabled):not(.active):not(.here) .menu-icon i {
  color: var(--bs-primary-inverse);
}

.menu-hover-bg-primary .menu-item.hover:not(.here) > .menu-link:not(.disabled):not(.active):not(.here) .menu-bullet .bullet, .menu-hover-bg-primary .menu-item:not(.here) .menu-link:hover:not(.disabled):not(.active):not(.here) .menu-bullet .bullet {
  background-color: var(--bs-primary-inverse);
}

.menu-hover-bg-primary .menu-item.hover:not(.here) > .menu-link:not(.disabled):not(.active):not(.here) .menu-arrow:after, .menu-hover-bg-primary .menu-item:not(.here) .menu-link:hover:not(.disabled):not(.active):not(.here) .menu-arrow:after {
  mask-image: url(${___CSS_LOADER_URL_REPLACEMENT_110___});
  /*rtl:begin:remove*/
  mask-repeat: no-repeat;
  mask-position: center;
  -webkit-mask-repeat: no-repeat;
  -webkit-mask-position: center;
  background-color: var(--bs-primary-inverse);
  mask-image: url(${___CSS_LOADER_URL_REPLACEMENT_111___});
  /*rtl:end:remove*/
}

.menu-show-bg-primary .menu-item.show > .menu-link {
  transition: color 0.2s ease;
  background-color: var(--bs-primary);
  color: var(--bs-primary-inverse);
}

.menu-show-bg-primary .menu-item.show > .menu-link .menu-title {
  color: var(--bs-primary-inverse);
}

.menu-show-bg-primary .menu-item.show > .menu-link .menu-icon,
.menu-show-bg-primary .menu-item.show > .menu-link .menu-icon .svg-icon,
.menu-show-bg-primary .menu-item.show > .menu-link .menu-icon i {
  color: var(--bs-primary-inverse);
}

.menu-show-bg-primary .menu-item.show > .menu-link .menu-bullet .bullet {
  background-color: var(--bs-primary-inverse);
}

.menu-show-bg-primary .menu-item.show > .menu-link .menu-arrow:after {
  mask-image: url(${___CSS_LOADER_URL_REPLACEMENT_110___});
  /*rtl:begin:remove*/
  mask-repeat: no-repeat;
  mask-position: center;
  -webkit-mask-repeat: no-repeat;
  -webkit-mask-position: center;
  background-color: var(--bs-primary-inverse);
  mask-image: url(${___CSS_LOADER_URL_REPLACEMENT_111___});
  /*rtl:end:remove*/
}

.menu-here-bg-primary .menu-item.here > .menu-link {
  transition: color 0.2s ease;
  background-color: var(--bs-primary);
  color: var(--bs-primary-inverse);
}

.menu-here-bg-primary .menu-item.here > .menu-link .menu-title {
  color: var(--bs-primary-inverse);
}

.menu-here-bg-primary .menu-item.here > .menu-link .menu-icon,
.menu-here-bg-primary .menu-item.here > .menu-link .menu-icon .svg-icon,
.menu-here-bg-primary .menu-item.here > .menu-link .menu-icon i {
  color: var(--bs-primary-inverse);
}

.menu-here-bg-primary .menu-item.here > .menu-link .menu-bullet .bullet {
  background-color: var(--bs-primary-inverse);
}

.menu-here-bg-primary .menu-item.here > .menu-link .menu-arrow:after {
  mask-image: url(${___CSS_LOADER_URL_REPLACEMENT_110___});
  /*rtl:begin:remove*/
  mask-repeat: no-repeat;
  mask-position: center;
  -webkit-mask-repeat: no-repeat;
  -webkit-mask-position: center;
  background-color: var(--bs-primary-inverse);
  mask-image: url(${___CSS_LOADER_URL_REPLACEMENT_111___});
  /*rtl:end:remove*/
}

.menu-active-bg-primary .menu-item .menu-link.active {
  transition: color 0.2s ease;
  background-color: var(--bs-primary);
  color: var(--bs-primary-inverse);
}

.menu-active-bg-primary .menu-item .menu-link.active .menu-title {
  color: var(--bs-primary-inverse);
}

.menu-active-bg-primary .menu-item .menu-link.active .menu-icon,
.menu-active-bg-primary .menu-item .menu-link.active .menu-icon .svg-icon,
.menu-active-bg-primary .menu-item .menu-link.active .menu-icon i {
  color: var(--bs-primary-inverse);
}

.menu-active-bg-primary .menu-item .menu-link.active .menu-bullet .bullet {
  background-color: var(--bs-primary-inverse);
}

.menu-active-bg-primary .menu-item .menu-link.active .menu-arrow:after {
  mask-image: url(${___CSS_LOADER_URL_REPLACEMENT_110___});
  /*rtl:begin:remove*/
  mask-repeat: no-repeat;
  mask-position: center;
  -webkit-mask-repeat: no-repeat;
  -webkit-mask-position: center;
  background-color: var(--bs-primary-inverse);
  mask-image: url(${___CSS_LOADER_URL_REPLACEMENT_111___});
  /*rtl:end:remove*/
}

.menu-state-bg-primary .menu-item.hover:not(.here) > .menu-link:not(.disabled):not(.active):not(.here), .menu-state-bg-primary .menu-item:not(.here) .menu-link:hover:not(.disabled):not(.active):not(.here) {
  transition: color 0.2s ease;
  background-color: var(--bs-primary);
  color: var(--bs-primary-inverse);
}

.menu-state-bg-primary .menu-item.hover:not(.here) > .menu-link:not(.disabled):not(.active):not(.here) .menu-title, .menu-state-bg-primary .menu-item:not(.here) .menu-link:hover:not(.disabled):not(.active):not(.here) .menu-title {
  color: var(--bs-primary-inverse);
}

.menu-state-bg-primary .menu-item.hover:not(.here) > .menu-link:not(.disabled):not(.active):not(.here) .menu-icon,
.menu-state-bg-primary .menu-item.hover:not(.here) > .menu-link:not(.disabled):not(.active):not(.here) .menu-icon .svg-icon,
.menu-state-bg-primary .menu-item.hover:not(.here) > .menu-link:not(.disabled):not(.active):not(.here) .menu-icon i, .menu-state-bg-primary .menu-item:not(.here) .menu-link:hover:not(.disabled):not(.active):not(.here) .menu-icon,
.menu-state-bg-primary .menu-item:not(.here) .menu-link:hover:not(.disabled):not(.active):not(.here) .menu-icon .svg-icon,
.menu-state-bg-primary .menu-item:not(.here) .menu-link:hover:not(.disabled):not(.active):not(.here) .menu-icon i {
  color: var(--bs-primary-inverse);
}

.menu-state-bg-primary .menu-item.hover:not(.here) > .menu-link:not(.disabled):not(.active):not(.here) .menu-bullet .bullet, .menu-state-bg-primary .menu-item:not(.here) .menu-link:hover:not(.disabled):not(.active):not(.here) .menu-bullet .bullet {
  background-color: var(--bs-primary-inverse);
}

.menu-state-bg-primary .menu-item.hover:not(.here) > .menu-link:not(.disabled):not(.active):not(.here) .menu-arrow:after, .menu-state-bg-primary .menu-item:not(.here) .menu-link:hover:not(.disabled):not(.active):not(.here) .menu-arrow:after {
  mask-image: url(${___CSS_LOADER_URL_REPLACEMENT_110___});
  /*rtl:begin:remove*/
  mask-repeat: no-repeat;
  mask-position: center;
  -webkit-mask-repeat: no-repeat;
  -webkit-mask-position: center;
  background-color: var(--bs-primary-inverse);
  mask-image: url(${___CSS_LOADER_URL_REPLACEMENT_111___});
  /*rtl:end:remove*/
}

.menu-state-bg-primary .menu-item.show > .menu-link {
  transition: color 0.2s ease;
  background-color: var(--bs-primary);
  color: var(--bs-primary-inverse);
}

.menu-state-bg-primary .menu-item.show > .menu-link .menu-title {
  color: var(--bs-primary-inverse);
}

.menu-state-bg-primary .menu-item.show > .menu-link .menu-icon,
.menu-state-bg-primary .menu-item.show > .menu-link .menu-icon .svg-icon,
.menu-state-bg-primary .menu-item.show > .menu-link .menu-icon i {
  color: var(--bs-primary-inverse);
}

.menu-state-bg-primary .menu-item.show > .menu-link .menu-bullet .bullet {
  background-color: var(--bs-primary-inverse);
}

.menu-state-bg-primary .menu-item.show > .menu-link .menu-arrow:after {
  mask-image: url(${___CSS_LOADER_URL_REPLACEMENT_110___});
  /*rtl:begin:remove*/
  mask-repeat: no-repeat;
  mask-position: center;
  -webkit-mask-repeat: no-repeat;
  -webkit-mask-position: center;
  background-color: var(--bs-primary-inverse);
  mask-image: url(${___CSS_LOADER_URL_REPLACEMENT_111___});
  /*rtl:end:remove*/
}

.menu-state-bg-primary .menu-item.here > .menu-link {
  transition: color 0.2s ease;
  background-color: var(--bs-primary);
  color: var(--bs-primary-inverse);
}

.menu-state-bg-primary .menu-item.here > .menu-link .menu-title {
  color: var(--bs-primary-inverse);
}

.menu-state-bg-primary .menu-item.here > .menu-link .menu-icon,
.menu-state-bg-primary .menu-item.here > .menu-link .menu-icon .svg-icon,
.menu-state-bg-primary .menu-item.here > .menu-link .menu-icon i {
  color: var(--bs-primary-inverse);
}

.menu-state-bg-primary .menu-item.here > .menu-link .menu-bullet .bullet {
  background-color: var(--bs-primary-inverse);
}

.menu-state-bg-primary .menu-item.here > .menu-link .menu-arrow:after {
  mask-image: url(${___CSS_LOADER_URL_REPLACEMENT_110___});
  /*rtl:begin:remove*/
  mask-repeat: no-repeat;
  mask-position: center;
  -webkit-mask-repeat: no-repeat;
  -webkit-mask-position: center;
  background-color: var(--bs-primary-inverse);
  mask-image: url(${___CSS_LOADER_URL_REPLACEMENT_111___});
  /*rtl:end:remove*/
}

.menu-state-bg-primary .menu-item .menu-link.active {
  transition: color 0.2s ease;
  background-color: var(--bs-primary);
  color: var(--bs-primary-inverse);
}

.menu-state-bg-primary .menu-item .menu-link.active .menu-title {
  color: var(--bs-primary-inverse);
}

.menu-state-bg-primary .menu-item .menu-link.active .menu-icon,
.menu-state-bg-primary .menu-item .menu-link.active .menu-icon .svg-icon,
.menu-state-bg-primary .menu-item .menu-link.active .menu-icon i {
  color: var(--bs-primary-inverse);
}

.menu-state-bg-primary .menu-item .menu-link.active .menu-bullet .bullet {
  background-color: var(--bs-primary-inverse);
}

.menu-state-bg-primary .menu-item .menu-link.active .menu-arrow:after {
  mask-image: url(${___CSS_LOADER_URL_REPLACEMENT_110___});
  /*rtl:begin:remove*/
  mask-repeat: no-repeat;
  mask-position: center;
  -webkit-mask-repeat: no-repeat;
  -webkit-mask-position: center;
  background-color: var(--bs-primary-inverse);
  mask-image: url(${___CSS_LOADER_URL_REPLACEMENT_111___});
  /*rtl:end:remove*/
}

.menu-state-bg-primary .menu-item.show > .menu-link {
  transition: color 0.2s ease;
  background-color: var(--bs-primary);
  color: var(--bs-primary-inverse);
}

.menu-state-bg-primary .menu-item.show > .menu-link .menu-title {
  color: var(--bs-primary-inverse);
}

.menu-state-bg-primary .menu-item.show > .menu-link .menu-icon,
.menu-state-bg-primary .menu-item.show > .menu-link .menu-icon .svg-icon,
.menu-state-bg-primary .menu-item.show > .menu-link .menu-icon i {
  color: var(--bs-primary-inverse);
}

.menu-state-bg-primary .menu-item.show > .menu-link .menu-bullet .bullet {
  background-color: var(--bs-primary-inverse);
}

.menu-state-bg-primary .menu-item.show > .menu-link .menu-arrow:after {
  mask-image: url(${___CSS_LOADER_URL_REPLACEMENT_110___});
  /*rtl:begin:remove*/
  mask-repeat: no-repeat;
  mask-position: center;
  -webkit-mask-repeat: no-repeat;
  -webkit-mask-position: center;
  background-color: var(--bs-primary-inverse);
  mask-image: url(${___CSS_LOADER_URL_REPLACEMENT_111___});
  /*rtl:end:remove*/
}

.menu-show-bg-light-primary .menu-item.show > .menu-link {
  transition: color 0.2s ease;
  background-color: var(--bs-primary-light);
  color: var(--bs-primary);
}

.menu-show-bg-light-primary .menu-item.show > .menu-link .menu-title {
  color: var(--bs-primary);
}

.menu-show-bg-light-primary .menu-item.show > .menu-link .menu-icon,
.menu-show-bg-light-primary .menu-item.show > .menu-link .menu-icon .svg-icon,
.menu-show-bg-light-primary .menu-item.show > .menu-link .menu-icon i {
  color: var(--bs-primary);
}

.menu-show-bg-light-primary .menu-item.show > .menu-link .menu-bullet .bullet {
  background-color: var(--bs-primary);
}

.menu-show-bg-light-primary .menu-item.show > .menu-link .menu-arrow:after {
  mask-image: url(${___CSS_LOADER_URL_REPLACEMENT_34___});
  /*rtl:begin:remove*/
  mask-repeat: no-repeat;
  mask-position: center;
  -webkit-mask-repeat: no-repeat;
  -webkit-mask-position: center;
  background-color: var(--bs-primary);
  mask-image: url(${___CSS_LOADER_URL_REPLACEMENT_35___});
  /*rtl:end:remove*/
}

.menu-here-bg-light-primary .menu-item.here > .menu-link {
  transition: color 0.2s ease;
  background-color: var(--bs-primary-light);
  color: var(--bs-primary);
}

.menu-here-bg-light-primary .menu-item.here > .menu-link .menu-title {
  color: var(--bs-primary);
}

.menu-here-bg-light-primary .menu-item.here > .menu-link .menu-icon,
.menu-here-bg-light-primary .menu-item.here > .menu-link .menu-icon .svg-icon,
.menu-here-bg-light-primary .menu-item.here > .menu-link .menu-icon i {
  color: var(--bs-primary);
}

.menu-here-bg-light-primary .menu-item.here > .menu-link .menu-bullet .bullet {
  background-color: var(--bs-primary);
}

.menu-here-bg-light-primary .menu-item.here > .menu-link .menu-arrow:after {
  mask-image: url(${___CSS_LOADER_URL_REPLACEMENT_34___});
  /*rtl:begin:remove*/
  mask-repeat: no-repeat;
  mask-position: center;
  -webkit-mask-repeat: no-repeat;
  -webkit-mask-position: center;
  background-color: var(--bs-primary);
  mask-image: url(${___CSS_LOADER_URL_REPLACEMENT_35___});
  /*rtl:end:remove*/
}

.menu-hover-bg-light-primary .menu-item.hover:not(.here) > .menu-link:not(.disabled):not(.active):not(.here), .menu-hover-bg-light-primary .menu-item:not(.here) .menu-link:hover:not(.disabled):not(.active):not(.here) {
  transition: color 0.2s ease;
  background-color: var(--bs-primary-light);
  color: var(--bs-primary);
}

.menu-hover-bg-light-primary .menu-item.hover:not(.here) > .menu-link:not(.disabled):not(.active):not(.here) .menu-title, .menu-hover-bg-light-primary .menu-item:not(.here) .menu-link:hover:not(.disabled):not(.active):not(.here) .menu-title {
  color: var(--bs-primary);
}

.menu-hover-bg-light-primary .menu-item.hover:not(.here) > .menu-link:not(.disabled):not(.active):not(.here) .menu-icon,
.menu-hover-bg-light-primary .menu-item.hover:not(.here) > .menu-link:not(.disabled):not(.active):not(.here) .menu-icon .svg-icon,
.menu-hover-bg-light-primary .menu-item.hover:not(.here) > .menu-link:not(.disabled):not(.active):not(.here) .menu-icon i, .menu-hover-bg-light-primary .menu-item:not(.here) .menu-link:hover:not(.disabled):not(.active):not(.here) .menu-icon,
.menu-hover-bg-light-primary .menu-item:not(.here) .menu-link:hover:not(.disabled):not(.active):not(.here) .menu-icon .svg-icon,
.menu-hover-bg-light-primary .menu-item:not(.here) .menu-link:hover:not(.disabled):not(.active):not(.here) .menu-icon i {
  color: var(--bs-primary);
}

.menu-hover-bg-light-primary .menu-item.hover:not(.here) > .menu-link:not(.disabled):not(.active):not(.here) .menu-bullet .bullet, .menu-hover-bg-light-primary .menu-item:not(.here) .menu-link:hover:not(.disabled):not(.active):not(.here) .menu-bullet .bullet {
  background-color: var(--bs-primary);
}

.menu-hover-bg-light-primary .menu-item.hover:not(.here) > .menu-link:not(.disabled):not(.active):not(.here) .menu-arrow:after, .menu-hover-bg-light-primary .menu-item:not(.here) .menu-link:hover:not(.disabled):not(.active):not(.here) .menu-arrow:after {
  mask-image: url(${___CSS_LOADER_URL_REPLACEMENT_34___});
  /*rtl:begin:remove*/
  mask-repeat: no-repeat;
  mask-position: center;
  -webkit-mask-repeat: no-repeat;
  -webkit-mask-position: center;
  background-color: var(--bs-primary);
  mask-image: url(${___CSS_LOADER_URL_REPLACEMENT_35___});
  /*rtl:end:remove*/
}

.menu-active-bg-light-primary .menu-item .menu-link.active {
  transition: color 0.2s ease;
  background-color: var(--bs-primary-light);
  color: var(--bs-primary);
}

.menu-active-bg-light-primary .menu-item .menu-link.active .menu-title {
  color: var(--bs-primary);
}

.menu-active-bg-light-primary .menu-item .menu-link.active .menu-icon,
.menu-active-bg-light-primary .menu-item .menu-link.active .menu-icon .svg-icon,
.menu-active-bg-light-primary .menu-item .menu-link.active .menu-icon i {
  color: var(--bs-primary);
}

.menu-active-bg-light-primary .menu-item .menu-link.active .menu-bullet .bullet {
  background-color: var(--bs-primary);
}

.menu-active-bg-light-primary .menu-item .menu-link.active .menu-arrow:after {
  mask-image: url(${___CSS_LOADER_URL_REPLACEMENT_34___});
  /*rtl:begin:remove*/
  mask-repeat: no-repeat;
  mask-position: center;
  -webkit-mask-repeat: no-repeat;
  -webkit-mask-position: center;
  background-color: var(--bs-primary);
  mask-image: url(${___CSS_LOADER_URL_REPLACEMENT_35___});
  /*rtl:end:remove*/
}

.menu-state-bg-light-primary .menu-item.show > .menu-link {
  transition: color 0.2s ease;
  background-color: var(--bs-primary-light);
  color: var(--bs-primary);
}

.menu-state-bg-light-primary .menu-item.show > .menu-link .menu-title {
  color: var(--bs-primary);
}

.menu-state-bg-light-primary .menu-item.show > .menu-link .menu-icon,
.menu-state-bg-light-primary .menu-item.show > .menu-link .menu-icon .svg-icon,
.menu-state-bg-light-primary .menu-item.show > .menu-link .menu-icon i {
  color: var(--bs-primary);
}

.menu-state-bg-light-primary .menu-item.show > .menu-link .menu-bullet .bullet {
  background-color: var(--bs-primary);
}

.menu-state-bg-light-primary .menu-item.show > .menu-link .menu-arrow:after {
  mask-image: url(${___CSS_LOADER_URL_REPLACEMENT_34___});
  /*rtl:begin:remove*/
  mask-repeat: no-repeat;
  mask-position: center;
  -webkit-mask-repeat: no-repeat;
  -webkit-mask-position: center;
  background-color: var(--bs-primary);
  mask-image: url(${___CSS_LOADER_URL_REPLACEMENT_35___});
  /*rtl:end:remove*/
}

.menu-state-bg-light-primary .menu-item.here > .menu-link {
  transition: color 0.2s ease;
  background-color: var(--bs-primary-light);
  color: var(--bs-primary);
}

.menu-state-bg-light-primary .menu-item.here > .menu-link .menu-title {
  color: var(--bs-primary);
}

.menu-state-bg-light-primary .menu-item.here > .menu-link .menu-icon,
.menu-state-bg-light-primary .menu-item.here > .menu-link .menu-icon .svg-icon,
.menu-state-bg-light-primary .menu-item.here > .menu-link .menu-icon i {
  color: var(--bs-primary);
}

.menu-state-bg-light-primary .menu-item.here > .menu-link .menu-bullet .bullet {
  background-color: var(--bs-primary);
}

.menu-state-bg-light-primary .menu-item.here > .menu-link .menu-arrow:after {
  mask-image: url(${___CSS_LOADER_URL_REPLACEMENT_34___});
  /*rtl:begin:remove*/
  mask-repeat: no-repeat;
  mask-position: center;
  -webkit-mask-repeat: no-repeat;
  -webkit-mask-position: center;
  background-color: var(--bs-primary);
  mask-image: url(${___CSS_LOADER_URL_REPLACEMENT_35___});
  /*rtl:end:remove*/
}

.menu-state-bg-light-primary .menu-item.hover:not(.here) > .menu-link:not(.disabled):not(.active):not(.here), .menu-state-bg-light-primary .menu-item:not(.here) .menu-link:hover:not(.disabled):not(.active):not(.here) {
  transition: color 0.2s ease;
  background-color: var(--bs-primary-light);
  color: var(--bs-primary);
}

.menu-state-bg-light-primary .menu-item.hover:not(.here) > .menu-link:not(.disabled):not(.active):not(.here) .menu-title, .menu-state-bg-light-primary .menu-item:not(.here) .menu-link:hover:not(.disabled):not(.active):not(.here) .menu-title {
  color: var(--bs-primary);
}

.menu-state-bg-light-primary .menu-item.hover:not(.here) > .menu-link:not(.disabled):not(.active):not(.here) .menu-icon,
.menu-state-bg-light-primary .menu-item.hover:not(.here) > .menu-link:not(.disabled):not(.active):not(.here) .menu-icon .svg-icon,
.menu-state-bg-light-primary .menu-item.hover:not(.here) > .menu-link:not(.disabled):not(.active):not(.here) .menu-icon i, .menu-state-bg-light-primary .menu-item:not(.here) .menu-link:hover:not(.disabled):not(.active):not(.here) .menu-icon,
.menu-state-bg-light-primary .menu-item:not(.here) .menu-link:hover:not(.disabled):not(.active):not(.here) .menu-icon .svg-icon,
.menu-state-bg-light-primary .menu-item:not(.here) .menu-link:hover:not(.disabled):not(.active):not(.here) .menu-icon i {
  color: var(--bs-primary);
}

.menu-state-bg-light-primary .menu-item.hover:not(.here) > .menu-link:not(.disabled):not(.active):not(.here) .menu-bullet .bullet, .menu-state-bg-light-primary .menu-item:not(.here) .menu-link:hover:not(.disabled):not(.active):not(.here) .menu-bullet .bullet {
  background-color: var(--bs-primary);
}

.menu-state-bg-light-primary .menu-item.hover:not(.here) > .menu-link:not(.disabled):not(.active):not(.here) .menu-arrow:after, .menu-state-bg-light-primary .menu-item:not(.here) .menu-link:hover:not(.disabled):not(.active):not(.here) .menu-arrow:after {
  mask-image: url(${___CSS_LOADER_URL_REPLACEMENT_34___});
  /*rtl:begin:remove*/
  mask-repeat: no-repeat;
  mask-position: center;
  -webkit-mask-repeat: no-repeat;
  -webkit-mask-position: center;
  background-color: var(--bs-primary);
  mask-image: url(${___CSS_LOADER_URL_REPLACEMENT_35___});
  /*rtl:end:remove*/
}

.menu-state-bg-light-primary .menu-item .menu-link.active {
  transition: color 0.2s ease;
  background-color: var(--bs-primary-light);
  color: var(--bs-primary);
}

.menu-state-bg-light-primary .menu-item .menu-link.active .menu-title {
  color: var(--bs-primary);
}

.menu-state-bg-light-primary .menu-item .menu-link.active .menu-icon,
.menu-state-bg-light-primary .menu-item .menu-link.active .menu-icon .svg-icon,
.menu-state-bg-light-primary .menu-item .menu-link.active .menu-icon i {
  color: var(--bs-primary);
}

.menu-state-bg-light-primary .menu-item .menu-link.active .menu-bullet .bullet {
  background-color: var(--bs-primary);
}

.menu-state-bg-light-primary .menu-item .menu-link.active .menu-arrow:after {
  mask-image: url(${___CSS_LOADER_URL_REPLACEMENT_34___});
  /*rtl:begin:remove*/
  mask-repeat: no-repeat;
  mask-position: center;
  -webkit-mask-repeat: no-repeat;
  -webkit-mask-position: center;
  background-color: var(--bs-primary);
  mask-image: url(${___CSS_LOADER_URL_REPLACEMENT_35___});
  /*rtl:end:remove*/
}

.menu-hover-primary .menu-item.hover:not(.here) > .menu-link:not(.disabled):not(.active):not(.here), .menu-hover-primary .menu-item:not(.here) .menu-link:hover:not(.disabled):not(.active):not(.here) {
  transition: color 0.2s ease;
  color: var(--bs-primary);
}

.menu-hover-primary .menu-item.hover:not(.here) > .menu-link:not(.disabled):not(.active):not(.here) .menu-title, .menu-hover-primary .menu-item:not(.here) .menu-link:hover:not(.disabled):not(.active):not(.here) .menu-title {
  color: var(--bs-primary);
}

.menu-hover-primary .menu-item.hover:not(.here) > .menu-link:not(.disabled):not(.active):not(.here) .menu-icon,
.menu-hover-primary .menu-item.hover:not(.here) > .menu-link:not(.disabled):not(.active):not(.here) .menu-icon .svg-icon,
.menu-hover-primary .menu-item.hover:not(.here) > .menu-link:not(.disabled):not(.active):not(.here) .menu-icon i, .menu-hover-primary .menu-item:not(.here) .menu-link:hover:not(.disabled):not(.active):not(.here) .menu-icon,
.menu-hover-primary .menu-item:not(.here) .menu-link:hover:not(.disabled):not(.active):not(.here) .menu-icon .svg-icon,
.menu-hover-primary .menu-item:not(.here) .menu-link:hover:not(.disabled):not(.active):not(.here) .menu-icon i {
  color: var(--bs-primary);
}

.menu-hover-primary .menu-item.hover:not(.here) > .menu-link:not(.disabled):not(.active):not(.here) .menu-bullet .bullet, .menu-hover-primary .menu-item:not(.here) .menu-link:hover:not(.disabled):not(.active):not(.here) .menu-bullet .bullet {
  background-color: var(--bs-primary);
}

.menu-hover-primary .menu-item.hover:not(.here) > .menu-link:not(.disabled):not(.active):not(.here) .menu-arrow:after, .menu-hover-primary .menu-item:not(.here) .menu-link:hover:not(.disabled):not(.active):not(.here) .menu-arrow:after {
  mask-image: url(${___CSS_LOADER_URL_REPLACEMENT_34___});
  /*rtl:begin:remove*/
  mask-repeat: no-repeat;
  mask-position: center;
  -webkit-mask-repeat: no-repeat;
  -webkit-mask-position: center;
  background-color: var(--bs-primary);
  mask-image: url(${___CSS_LOADER_URL_REPLACEMENT_35___});
  /*rtl:end:remove*/
}

.menu-show-primary .menu-item.show > .menu-link {
  transition: color 0.2s ease;
  color: var(--bs-primary);
}

.menu-show-primary .menu-item.show > .menu-link .menu-title {
  color: var(--bs-primary);
}

.menu-show-primary .menu-item.show > .menu-link .menu-icon,
.menu-show-primary .menu-item.show > .menu-link .menu-icon .svg-icon,
.menu-show-primary .menu-item.show > .menu-link .menu-icon i {
  color: var(--bs-primary);
}

.menu-show-primary .menu-item.show > .menu-link .menu-bullet .bullet {
  background-color: var(--bs-primary);
}

.menu-show-primary .menu-item.show > .menu-link .menu-arrow:after {
  mask-image: url(${___CSS_LOADER_URL_REPLACEMENT_34___});
  /*rtl:begin:remove*/
  mask-repeat: no-repeat;
  mask-position: center;
  -webkit-mask-repeat: no-repeat;
  -webkit-mask-position: center;
  background-color: var(--bs-primary);
  mask-image: url(${___CSS_LOADER_URL_REPLACEMENT_35___});
  /*rtl:end:remove*/
}

.menu-here-primary .menu-item.here > .menu-link {
  transition: color 0.2s ease;
  color: var(--bs-primary);
}

.menu-here-primary .menu-item.here > .menu-link .menu-title {
  color: var(--bs-primary);
}

.menu-here-primary .menu-item.here > .menu-link .menu-icon,
.menu-here-primary .menu-item.here > .menu-link .menu-icon .svg-icon,
.menu-here-primary .menu-item.here > .menu-link .menu-icon i {
  color: var(--bs-primary);
}

.menu-here-primary .menu-item.here > .menu-link .menu-bullet .bullet {
  background-color: var(--bs-primary);
}

.menu-here-primary .menu-item.here > .menu-link .menu-arrow:after {
  mask-image: url(${___CSS_LOADER_URL_REPLACEMENT_34___});
  /*rtl:begin:remove*/
  mask-repeat: no-repeat;
  mask-position: center;
  -webkit-mask-repeat: no-repeat;
  -webkit-mask-position: center;
  background-color: var(--bs-primary);
  mask-image: url(${___CSS_LOADER_URL_REPLACEMENT_35___});
  /*rtl:end:remove*/
}

.menu-active-primary .menu-item .menu-link.active {
  transition: color 0.2s ease;
  color: var(--bs-primary);
}

.menu-active-primary .menu-item .menu-link.active .menu-title {
  color: var(--bs-primary);
}

.menu-active-primary .menu-item .menu-link.active .menu-icon,
.menu-active-primary .menu-item .menu-link.active .menu-icon .svg-icon,
.menu-active-primary .menu-item .menu-link.active .menu-icon i {
  color: var(--bs-primary);
}

.menu-active-primary .menu-item .menu-link.active .menu-bullet .bullet {
  background-color: var(--bs-primary);
}

.menu-active-primary .menu-item .menu-link.active .menu-arrow:after {
  mask-image: url(${___CSS_LOADER_URL_REPLACEMENT_34___});
  /*rtl:begin:remove*/
  mask-repeat: no-repeat;
  mask-position: center;
  -webkit-mask-repeat: no-repeat;
  -webkit-mask-position: center;
  background-color: var(--bs-primary);
  mask-image: url(${___CSS_LOADER_URL_REPLACEMENT_35___});
  /*rtl:end:remove*/
}

.menu-state-primary .menu-item.hover:not(.here) > .menu-link:not(.disabled):not(.active):not(.here), .menu-state-primary .menu-item:not(.here) .menu-link:hover:not(.disabled):not(.active):not(.here) {
  transition: color 0.2s ease;
  color: var(--bs-primary);
}

.menu-state-primary .menu-item.hover:not(.here) > .menu-link:not(.disabled):not(.active):not(.here) .menu-title, .menu-state-primary .menu-item:not(.here) .menu-link:hover:not(.disabled):not(.active):not(.here) .menu-title {
  color: var(--bs-primary);
}

.menu-state-primary .menu-item.hover:not(.here) > .menu-link:not(.disabled):not(.active):not(.here) .menu-icon,
.menu-state-primary .menu-item.hover:not(.here) > .menu-link:not(.disabled):not(.active):not(.here) .menu-icon .svg-icon,
.menu-state-primary .menu-item.hover:not(.here) > .menu-link:not(.disabled):not(.active):not(.here) .menu-icon i, .menu-state-primary .menu-item:not(.here) .menu-link:hover:not(.disabled):not(.active):not(.here) .menu-icon,
.menu-state-primary .menu-item:not(.here) .menu-link:hover:not(.disabled):not(.active):not(.here) .menu-icon .svg-icon,
.menu-state-primary .menu-item:not(.here) .menu-link:hover:not(.disabled):not(.active):not(.here) .menu-icon i {
  color: var(--bs-primary);
}

.menu-state-primary .menu-item.hover:not(.here) > .menu-link:not(.disabled):not(.active):not(.here) .menu-bullet .bullet, .menu-state-primary .menu-item:not(.here) .menu-link:hover:not(.disabled):not(.active):not(.here) .menu-bullet .bullet {
  background-color: var(--bs-primary);
}

.menu-state-primary .menu-item.hover:not(.here) > .menu-link:not(.disabled):not(.active):not(.here) .menu-arrow:after, .menu-state-primary .menu-item:not(.here) .menu-link:hover:not(.disabled):not(.active):not(.here) .menu-arrow:after {
  mask-image: url(${___CSS_LOADER_URL_REPLACEMENT_34___});
  /*rtl:begin:remove*/
  mask-repeat: no-repeat;
  mask-position: center;
  -webkit-mask-repeat: no-repeat;
  -webkit-mask-position: center;
  background-color: var(--bs-primary);
  mask-image: url(${___CSS_LOADER_URL_REPLACEMENT_35___});
  /*rtl:end:remove*/
}

.menu-state-primary .menu-item.show > .menu-link {
  transition: color 0.2s ease;
  color: var(--bs-primary);
}

.menu-state-primary .menu-item.show > .menu-link .menu-title {
  color: var(--bs-primary);
}

.menu-state-primary .menu-item.show > .menu-link .menu-icon,
.menu-state-primary .menu-item.show > .menu-link .menu-icon .svg-icon,
.menu-state-primary .menu-item.show > .menu-link .menu-icon i {
  color: var(--bs-primary);
}

.menu-state-primary .menu-item.show > .menu-link .menu-bullet .bullet {
  background-color: var(--bs-primary);
}

.menu-state-primary .menu-item.show > .menu-link .menu-arrow:after {
  mask-image: url(${___CSS_LOADER_URL_REPLACEMENT_34___});
  /*rtl:begin:remove*/
  mask-repeat: no-repeat;
  mask-position: center;
  -webkit-mask-repeat: no-repeat;
  -webkit-mask-position: center;
  background-color: var(--bs-primary);
  mask-image: url(${___CSS_LOADER_URL_REPLACEMENT_35___});
  /*rtl:end:remove*/
}

.menu-state-primary .menu-item.here > .menu-link {
  transition: color 0.2s ease;
  color: var(--bs-primary);
}

.menu-state-primary .menu-item.here > .menu-link .menu-title {
  color: var(--bs-primary);
}

.menu-state-primary .menu-item.here > .menu-link .menu-icon,
.menu-state-primary .menu-item.here > .menu-link .menu-icon .svg-icon,
.menu-state-primary .menu-item.here > .menu-link .menu-icon i {
  color: var(--bs-primary);
}

.menu-state-primary .menu-item.here > .menu-link .menu-bullet .bullet {
  background-color: var(--bs-primary);
}

.menu-state-primary .menu-item.here > .menu-link .menu-arrow:after {
  mask-image: url(${___CSS_LOADER_URL_REPLACEMENT_34___});
  /*rtl:begin:remove*/
  mask-repeat: no-repeat;
  mask-position: center;
  -webkit-mask-repeat: no-repeat;
  -webkit-mask-position: center;
  background-color: var(--bs-primary);
  mask-image: url(${___CSS_LOADER_URL_REPLACEMENT_35___});
  /*rtl:end:remove*/
}

.menu-state-primary .menu-item .menu-link.active {
  transition: color 0.2s ease;
  color: var(--bs-primary);
}

.menu-state-primary .menu-item .menu-link.active .menu-title {
  color: var(--bs-primary);
}

.menu-state-primary .menu-item .menu-link.active .menu-icon,
.menu-state-primary .menu-item .menu-link.active .menu-icon .svg-icon,
.menu-state-primary .menu-item .menu-link.active .menu-icon i {
  color: var(--bs-primary);
}

.menu-state-primary .menu-item .menu-link.active .menu-bullet .bullet {
  background-color: var(--bs-primary);
}

.menu-state-primary .menu-item .menu-link.active .menu-arrow:after {
  mask-image: url(${___CSS_LOADER_URL_REPLACEMENT_34___});
  /*rtl:begin:remove*/
  mask-repeat: no-repeat;
  mask-position: center;
  -webkit-mask-repeat: no-repeat;
  -webkit-mask-position: center;
  background-color: var(--bs-primary);
  mask-image: url(${___CSS_LOADER_URL_REPLACEMENT_35___});
  /*rtl:end:remove*/
}

.menu-state-dark .menu-item.hover:not(.here) > .menu-link:not(.disabled):not(.active):not(.here), .menu-state-dark .menu-item:not(.here) .menu-link:hover:not(.disabled):not(.active):not(.here) {
  transition: color 0.2s ease;
  color: var(--bs-dark);
}

.menu-state-dark .menu-item.hover:not(.here) > .menu-link:not(.disabled):not(.active):not(.here) .menu-title, .menu-state-dark .menu-item:not(.here) .menu-link:hover:not(.disabled):not(.active):not(.here) .menu-title {
  color: var(--bs-dark);
}

.menu-state-dark .menu-item.hover:not(.here) > .menu-link:not(.disabled):not(.active):not(.here) .menu-icon,
.menu-state-dark .menu-item.hover:not(.here) > .menu-link:not(.disabled):not(.active):not(.here) .menu-icon .svg-icon,
.menu-state-dark .menu-item.hover:not(.here) > .menu-link:not(.disabled):not(.active):not(.here) .menu-icon i, .menu-state-dark .menu-item:not(.here) .menu-link:hover:not(.disabled):not(.active):not(.here) .menu-icon,
.menu-state-dark .menu-item:not(.here) .menu-link:hover:not(.disabled):not(.active):not(.here) .menu-icon .svg-icon,
.menu-state-dark .menu-item:not(.here) .menu-link:hover:not(.disabled):not(.active):not(.here) .menu-icon i {
  color: var(--bs-dark);
}

.menu-state-dark .menu-item.hover:not(.here) > .menu-link:not(.disabled):not(.active):not(.here) .menu-bullet .bullet, .menu-state-dark .menu-item:not(.here) .menu-link:hover:not(.disabled):not(.active):not(.here) .menu-bullet .bullet {
  background-color: var(--bs-dark);
}

.menu-state-dark .menu-item.hover:not(.here) > .menu-link:not(.disabled):not(.active):not(.here) .menu-arrow:after, .menu-state-dark .menu-item:not(.here) .menu-link:hover:not(.disabled):not(.active):not(.here) .menu-arrow:after {
  mask-image: url(${___CSS_LOADER_URL_REPLACEMENT_62___});
  /*rtl:begin:remove*/
  mask-repeat: no-repeat;
  mask-position: center;
  -webkit-mask-repeat: no-repeat;
  -webkit-mask-position: center;
  background-color: var(--bs-dark);
  mask-image: url(${___CSS_LOADER_URL_REPLACEMENT_63___});
  /*rtl:end:remove*/
}

.menu-state-dark .menu-item.show > .menu-link {
  transition: color 0.2s ease;
  color: var(--bs-dark);
}

.menu-state-dark .menu-item.show > .menu-link .menu-title {
  color: var(--bs-dark);
}

.menu-state-dark .menu-item.show > .menu-link .menu-icon,
.menu-state-dark .menu-item.show > .menu-link .menu-icon .svg-icon,
.menu-state-dark .menu-item.show > .menu-link .menu-icon i {
  color: var(--bs-dark);
}

.menu-state-dark .menu-item.show > .menu-link .menu-bullet .bullet {
  background-color: var(--bs-dark);
}

.menu-state-dark .menu-item.show > .menu-link .menu-arrow:after {
  mask-image: url(${___CSS_LOADER_URL_REPLACEMENT_62___});
  /*rtl:begin:remove*/
  mask-repeat: no-repeat;
  mask-position: center;
  -webkit-mask-repeat: no-repeat;
  -webkit-mask-position: center;
  background-color: var(--bs-dark);
  mask-image: url(${___CSS_LOADER_URL_REPLACEMENT_63___});
  /*rtl:end:remove*/
}

.menu-state-dark .menu-item.here > .menu-link {
  transition: color 0.2s ease;
  color: var(--bs-dark);
}

.menu-state-dark .menu-item.here > .menu-link .menu-title {
  color: var(--bs-dark);
}

.menu-state-dark .menu-item.here > .menu-link .menu-icon,
.menu-state-dark .menu-item.here > .menu-link .menu-icon .svg-icon,
.menu-state-dark .menu-item.here > .menu-link .menu-icon i {
  color: var(--bs-dark);
}

.menu-state-dark .menu-item.here > .menu-link .menu-bullet .bullet {
  background-color: var(--bs-dark);
}

.menu-state-dark .menu-item.here > .menu-link .menu-arrow:after {
  mask-image: url(${___CSS_LOADER_URL_REPLACEMENT_62___});
  /*rtl:begin:remove*/
  mask-repeat: no-repeat;
  mask-position: center;
  -webkit-mask-repeat: no-repeat;
  -webkit-mask-position: center;
  background-color: var(--bs-dark);
  mask-image: url(${___CSS_LOADER_URL_REPLACEMENT_63___});
  /*rtl:end:remove*/
}

.menu-state-dark .menu-item .menu-link.active {
  transition: color 0.2s ease;
  color: var(--bs-dark);
}

.menu-state-dark .menu-item .menu-link.active .menu-title {
  color: var(--bs-dark);
}

.menu-state-dark .menu-item .menu-link.active .menu-icon,
.menu-state-dark .menu-item .menu-link.active .menu-icon .svg-icon,
.menu-state-dark .menu-item .menu-link.active .menu-icon i {
  color: var(--bs-dark);
}

.menu-state-dark .menu-item .menu-link.active .menu-bullet .bullet {
  background-color: var(--bs-dark);
}

.menu-state-dark .menu-item .menu-link.active .menu-arrow:after {
  mask-image: url(${___CSS_LOADER_URL_REPLACEMENT_62___});
  /*rtl:begin:remove*/
  mask-repeat: no-repeat;
  mask-position: center;
  -webkit-mask-repeat: no-repeat;
  -webkit-mask-position: center;
  background-color: var(--bs-dark);
  mask-image: url(${___CSS_LOADER_URL_REPLACEMENT_63___});
  /*rtl:end:remove*/
}

.menu-hover-title-primary .menu-item.hover:not(.here) > .menu-link:not(.disabled):not(.active):not(.here), .menu-hover-title-primary .menu-item:not(.here) .menu-link:hover:not(.disabled):not(.active):not(.here) {
  transition: color 0.2s ease;
  color: var(--bs-primary);
}

.menu-hover-title-primary .menu-item.hover:not(.here) > .menu-link:not(.disabled):not(.active):not(.here) .menu-title, .menu-hover-title-primary .menu-item:not(.here) .menu-link:hover:not(.disabled):not(.active):not(.here) .menu-title {
  color: var(--bs-primary);
}

.menu-here-title-primary .menu-item.here > .menu-link {
  transition: color 0.2s ease;
  color: var(--bs-primary);
}

.menu-here-title-primary .menu-item.here > .menu-link .menu-title {
  color: var(--bs-primary);
}

.menu-show-title-primary .menu-item.show > .menu-link {
  transition: color 0.2s ease;
  color: var(--bs-primary);
}

.menu-show-title-primary .menu-item.show > .menu-link .menu-title {
  color: var(--bs-primary);
}

.menu-active-title-primary .menu-item .menu-link.active {
  transition: color 0.2s ease;
  color: var(--bs-primary);
}

.menu-active-title-primary .menu-item .menu-link.active .menu-title {
  color: var(--bs-primary);
}

.menu-state-title-primary .menu-item.hover:not(.here) > .menu-link:not(.disabled):not(.active):not(.here), .menu-state-title-primary .menu-item:not(.here) .menu-link:hover:not(.disabled):not(.active):not(.here) {
  transition: color 0.2s ease;
  color: var(--bs-primary);
}

.menu-state-title-primary .menu-item.hover:not(.here) > .menu-link:not(.disabled):not(.active):not(.here) .menu-title, .menu-state-title-primary .menu-item:not(.here) .menu-link:hover:not(.disabled):not(.active):not(.here) .menu-title {
  color: var(--bs-primary);
}

.menu-state-title-primary .menu-item.here > .menu-link {
  transition: color 0.2s ease;
  color: var(--bs-primary);
}

.menu-state-title-primary .menu-item.here > .menu-link .menu-title {
  color: var(--bs-primary);
}

.menu-state-title-primary .menu-item.show > .menu-link {
  transition: color 0.2s ease;
  color: var(--bs-primary);
}

.menu-state-title-primary .menu-item.show > .menu-link .menu-title {
  color: var(--bs-primary);
}

.menu-state-title-primary .menu-item .menu-link.active {
  transition: color 0.2s ease;
  color: var(--bs-primary);
}

.menu-state-title-primary .menu-item .menu-link.active .menu-title {
  color: var(--bs-primary);
}

.menu-hover-icon-primary .menu-item.hover:not(.here) > .menu-link:not(.disabled):not(.active):not(.here), .menu-hover-icon-primary .menu-item:not(.here) .menu-link:hover:not(.disabled):not(.active):not(.here) {
  transition: color 0.2s ease;
}

.menu-hover-icon-primary .menu-item.hover:not(.here) > .menu-link:not(.disabled):not(.active):not(.here) .menu-icon,
.menu-hover-icon-primary .menu-item.hover:not(.here) > .menu-link:not(.disabled):not(.active):not(.here) .menu-icon .svg-icon,
.menu-hover-icon-primary .menu-item.hover:not(.here) > .menu-link:not(.disabled):not(.active):not(.here) .menu-icon i, .menu-hover-icon-primary .menu-item:not(.here) .menu-link:hover:not(.disabled):not(.active):not(.here) .menu-icon,
.menu-hover-icon-primary .menu-item:not(.here) .menu-link:hover:not(.disabled):not(.active):not(.here) .menu-icon .svg-icon,
.menu-hover-icon-primary .menu-item:not(.here) .menu-link:hover:not(.disabled):not(.active):not(.here) .menu-icon i {
  color: var(--bs-primary);
}

.menu-here-icon-primary .menu-item.here > .menu-link {
  transition: color 0.2s ease;
}

.menu-here-icon-primary .menu-item.here > .menu-link .menu-icon,
.menu-here-icon-primary .menu-item.here > .menu-link .menu-icon .svg-icon,
.menu-here-icon-primary .menu-item.here > .menu-link .menu-icon i {
  color: var(--bs-primary);
}

.menu-show-icon-primary .menu-item.show > .menu-link {
  transition: color 0.2s ease;
}

.menu-show-icon-primary .menu-item.show > .menu-link .menu-icon,
.menu-show-icon-primary .menu-item.show > .menu-link .menu-icon .svg-icon,
.menu-show-icon-primary .menu-item.show > .menu-link .menu-icon i {
  color: var(--bs-primary);
}

.menu-active-icon-primary .menu-item .menu-link.active {
  transition: color 0.2s ease;
}

.menu-active-icon-primary .menu-item .menu-link.active .menu-icon,
.menu-active-icon-primary .menu-item .menu-link.active .menu-icon .svg-icon,
.menu-active-icon-primary .menu-item .menu-link.active .menu-icon i {
  color: var(--bs-primary);
}

.menu-state-icon-primary .menu-item.hover:not(.here) > .menu-link:not(.disabled):not(.active):not(.here), .menu-state-icon-primary .menu-item:not(.here) .menu-link:hover:not(.disabled):not(.active):not(.here) {
  transition: color 0.2s ease;
}

.menu-state-icon-primary .menu-item.hover:not(.here) > .menu-link:not(.disabled):not(.active):not(.here) .menu-icon,
.menu-state-icon-primary .menu-item.hover:not(.here) > .menu-link:not(.disabled):not(.active):not(.here) .menu-icon .svg-icon,
.menu-state-icon-primary .menu-item.hover:not(.here) > .menu-link:not(.disabled):not(.active):not(.here) .menu-icon i, .menu-state-icon-primary .menu-item:not(.here) .menu-link:hover:not(.disabled):not(.active):not(.here) .menu-icon,
.menu-state-icon-primary .menu-item:not(.here) .menu-link:hover:not(.disabled):not(.active):not(.here) .menu-icon .svg-icon,
.menu-state-icon-primary .menu-item:not(.here) .menu-link:hover:not(.disabled):not(.active):not(.here) .menu-icon i {
  color: var(--bs-primary);
}

.menu-state-icon-primary .menu-item.here > .menu-link {
  transition: color 0.2s ease;
}

.menu-state-icon-primary .menu-item.here > .menu-link .menu-icon,
.menu-state-icon-primary .menu-item.here > .menu-link .menu-icon .svg-icon,
.menu-state-icon-primary .menu-item.here > .menu-link .menu-icon i {
  color: var(--bs-primary);
}

.menu-state-icon-primary .menu-item.show > .menu-link {
  transition: color 0.2s ease;
}

.menu-state-icon-primary .menu-item.show > .menu-link .menu-icon,
.menu-state-icon-primary .menu-item.show > .menu-link .menu-icon .svg-icon,
.menu-state-icon-primary .menu-item.show > .menu-link .menu-icon i {
  color: var(--bs-primary);
}

.menu-state-icon-primary .menu-item .menu-link.active {
  transition: color 0.2s ease;
}

.menu-state-icon-primary .menu-item .menu-link.active .menu-icon,
.menu-state-icon-primary .menu-item .menu-link.active .menu-icon .svg-icon,
.menu-state-icon-primary .menu-item .menu-link.active .menu-icon i {
  color: var(--bs-primary);
}

.menu-hover-bullet-primary .menu-item.hover:not(.here) > .menu-link:not(.disabled):not(.active):not(.here), .menu-hover-bullet-primary .menu-item:not(.here) .menu-link:hover:not(.disabled):not(.active):not(.here) {
  transition: color 0.2s ease;
}

.menu-hover-bullet-primary .menu-item.hover:not(.here) > .menu-link:not(.disabled):not(.active):not(.here) .menu-bullet .bullet, .menu-hover-bullet-primary .menu-item:not(.here) .menu-link:hover:not(.disabled):not(.active):not(.here) .menu-bullet .bullet {
  background-color: var(--bs-primary);
}

.menu-show-bullet-primary .menu-item.show > .menu-link {
  transition: color 0.2s ease;
}

.menu-show-bullet-primary .menu-item.show > .menu-link .menu-bullet .bullet {
  background-color: var(--bs-primary);
}

.menu-here-bullet-primary .menu-item.here > .menu-link {
  transition: color 0.2s ease;
}

.menu-here-bullet-primary .menu-item.here > .menu-link .menu-bullet .bullet {
  background-color: var(--bs-primary);
}

.menu-active-bullet-primary .menu-item .menu-link.active {
  transition: color 0.2s ease;
}

.menu-active-bullet-primary .menu-item .menu-link.active .menu-bullet .bullet {
  background-color: var(--bs-primary);
}

.menu-state-bullet-primary .menu-item.hover:not(.here) > .menu-link:not(.disabled):not(.active):not(.here), .menu-state-bullet-primary .menu-item:not(.here) .menu-link:hover:not(.disabled):not(.active):not(.here) {
  transition: color 0.2s ease;
}

.menu-state-bullet-primary .menu-item.hover:not(.here) > .menu-link:not(.disabled):not(.active):not(.here) .menu-bullet .bullet, .menu-state-bullet-primary .menu-item:not(.here) .menu-link:hover:not(.disabled):not(.active):not(.here) .menu-bullet .bullet {
  background-color: var(--bs-primary);
}

.menu-state-bullet-primary .menu-item.here > .menu-link {
  transition: color 0.2s ease;
}

.menu-state-bullet-primary .menu-item.here > .menu-link .menu-bullet .bullet {
  background-color: var(--bs-primary);
}

.menu-state-bullet-primary .menu-item.show > .menu-link {
  transition: color 0.2s ease;
}

.menu-state-bullet-primary .menu-item.show > .menu-link .menu-bullet .bullet {
  background-color: var(--bs-primary);
}

.menu-state-bullet-primary .menu-item .menu-link.active {
  transition: color 0.2s ease;
}

.menu-state-bullet-primary .menu-item .menu-link.active .menu-bullet .bullet {
  background-color: var(--bs-primary);
}

.menu-hover-arrow-primary .menu-item.hover:not(.here) > .menu-link:not(.disabled):not(.active):not(.here), .menu-hover-arrow-primary .menu-item:not(.here) .menu-link:hover:not(.disabled):not(.active):not(.here) {
  transition: color 0.2s ease;
}

.menu-hover-arrow-primary .menu-item.hover:not(.here) > .menu-link:not(.disabled):not(.active):not(.here) .menu-arrow:after, .menu-hover-arrow-primary .menu-item:not(.here) .menu-link:hover:not(.disabled):not(.active):not(.here) .menu-arrow:after {
  mask-image: url(${___CSS_LOADER_URL_REPLACEMENT_34___});
  /*rtl:begin:remove*/
  mask-repeat: no-repeat;
  mask-position: center;
  -webkit-mask-repeat: no-repeat;
  -webkit-mask-position: center;
  background-color: var(--bs-primary);
  mask-image: url(${___CSS_LOADER_URL_REPLACEMENT_35___});
  /*rtl:end:remove*/
}

.menu-here-arrow-primary .menu-item.here > .menu-link {
  transition: color 0.2s ease;
}

.menu-here-arrow-primary .menu-item.here > .menu-link .menu-arrow:after {
  mask-image: url(${___CSS_LOADER_URL_REPLACEMENT_34___});
  /*rtl:begin:remove*/
  mask-repeat: no-repeat;
  mask-position: center;
  -webkit-mask-repeat: no-repeat;
  -webkit-mask-position: center;
  background-color: var(--bs-primary);
  mask-image: url(${___CSS_LOADER_URL_REPLACEMENT_35___});
  /*rtl:end:remove*/
}

.menu-show-arrow-primary .menu-item.show > .menu-link {
  transition: color 0.2s ease;
}

.menu-show-arrow-primary .menu-item.show > .menu-link .menu-arrow:after {
  mask-image: url(${___CSS_LOADER_URL_REPLACEMENT_34___});
  /*rtl:begin:remove*/
  mask-repeat: no-repeat;
  mask-position: center;
  -webkit-mask-repeat: no-repeat;
  -webkit-mask-position: center;
  background-color: var(--bs-primary);
  mask-image: url(${___CSS_LOADER_URL_REPLACEMENT_35___});
  /*rtl:end:remove*/
}

.menu-active-arrow-primary .menu-item .menu-link.active {
  transition: color 0.2s ease;
}

.menu-active-arrow-primary .menu-item .menu-link.active .menu-arrow:after {
  mask-image: url(${___CSS_LOADER_URL_REPLACEMENT_34___});
  /*rtl:begin:remove*/
  mask-repeat: no-repeat;
  mask-position: center;
  -webkit-mask-repeat: no-repeat;
  -webkit-mask-position: center;
  background-color: var(--bs-primary);
  mask-image: url(${___CSS_LOADER_URL_REPLACEMENT_35___});
  /*rtl:end:remove*/
}

.menu-state-arrow-primary .menu-item.hover:not(.here) > .menu-link:not(.disabled):not(.active):not(.here), .menu-state-arrow-primary .menu-item:not(.here) .menu-link:hover:not(.disabled):not(.active):not(.here) {
  transition: color 0.2s ease;
}

.menu-state-arrow-primary .menu-item.hover:not(.here) > .menu-link:not(.disabled):not(.active):not(.here) .menu-arrow:after, .menu-state-arrow-primary .menu-item:not(.here) .menu-link:hover:not(.disabled):not(.active):not(.here) .menu-arrow:after {
  mask-image: url(${___CSS_LOADER_URL_REPLACEMENT_34___});
  /*rtl:begin:remove*/
  mask-repeat: no-repeat;
  mask-position: center;
  -webkit-mask-repeat: no-repeat;
  -webkit-mask-position: center;
  background-color: var(--bs-primary);
  mask-image: url(${___CSS_LOADER_URL_REPLACEMENT_35___});
  /*rtl:end:remove*/
}

.menu-state-arrow-primary .menu-item.here > .menu-link {
  transition: color 0.2s ease;
}

.menu-state-arrow-primary .menu-item.here > .menu-link .menu-arrow:after {
  mask-image: url(${___CSS_LOADER_URL_REPLACEMENT_34___});
  /*rtl:begin:remove*/
  mask-repeat: no-repeat;
  mask-position: center;
  -webkit-mask-repeat: no-repeat;
  -webkit-mask-position: center;
  background-color: var(--bs-primary);
  mask-image: url(${___CSS_LOADER_URL_REPLACEMENT_35___});
  /*rtl:end:remove*/
}

.menu-state-arrow-primary .menu-item.show > .menu-link {
  transition: color 0.2s ease;
}

.menu-state-arrow-primary .menu-item.show > .menu-link .menu-arrow:after {
  mask-image: url(${___CSS_LOADER_URL_REPLACEMENT_34___});
  /*rtl:begin:remove*/
  mask-repeat: no-repeat;
  mask-position: center;
  -webkit-mask-repeat: no-repeat;
  -webkit-mask-position: center;
  background-color: var(--bs-primary);
  mask-image: url(${___CSS_LOADER_URL_REPLACEMENT_35___});
  /*rtl:end:remove*/
}

.menu-state-arrow-primary .menu-item .menu-link.active {
  transition: color 0.2s ease;
}

.menu-state-arrow-primary .menu-item .menu-link.active .menu-arrow:after {
  mask-image: url(${___CSS_LOADER_URL_REPLACEMENT_34___});
  /*rtl:begin:remove*/
  mask-repeat: no-repeat;
  mask-position: center;
  -webkit-mask-repeat: no-repeat;
  -webkit-mask-position: center;
  background-color: var(--bs-primary);
  mask-image: url(${___CSS_LOADER_URL_REPLACEMENT_35___});
  /*rtl:end:remove*/
}

.anchor {
  display: flex;
  align-items: center;
}

.anchor a {
  position: relative;
  display: none;
  align-items: center;
  justify-content: flex-start;
  height: 1em;
  width: 1.25em;
  margin-left: -1.25em;
  font-weight: 500;
  font-size: 0.8em;
  color: var(--bs-text-muted);
  transition: all 0.2s ease-in-out;
}

.anchor a:before {
  content: "#";
}

.anchor:hover a {
  display: flex;
}

.anchor:hover a:hover {
  color: var(--bs-primary);
  transition: all 0.2s ease-in-out;
}

.card {
  /* border: 0; */
}

.card .card-header {
  display: flex;
  justify-content: space-between;
  align-items: stretch;
  flex-wrap: wrap;
  min-height: 70px;
  padding: 0 2.25rem;
  color: var(--bs-card-cap-color);
  background-color: #ce7d22 !important;
  border-bottom: 1px solid var(--bs-card-border-color);
}

.card .card-header .card-title {
  display: flex;
  align-items: center;
  margin: 0.5rem;
  margin-left: 0;
}

.card .card-header .card-title.flex-column {
  align-items: flex-start;
  justify-content: center;
}

.card .card-header .card-title .card-icon {
  margin-right: 0.75rem;
  line-height: 0;
}

.card .card-header .card-title .card-icon i {
  font-size: 1.25rem;
  color: var(--bs-gray-600);
  line-height: 0;
}

.card .card-header .card-title .card-icon i:after, .card .card-header .card-title .card-icon i:before {
  line-height: 0;
}

.card .card-header .card-title .card-icon .svg-icon {
  color: var(--bs-gray-600);
}

.card .card-header .card-title .card-icon .svg-icon svg {
  height: 24px;
  width: 24px;
}

.card .card-header .card-title,
.card .card-header .card-title .card-label {
  font-weight: 500;
  font-size: 1.275rem;
  color: var(--bs-text-dark);
}

.card .card-header .card-title .card-label {
  margin: 0 0.75rem 0 0;
  flex-wrap: wrap;
}

.card .card-header .card-title small, .card .card-header .card-title .small {
  color: var(--bs-text-muted);
  font-size: 1rem;
}

.card .card-header .card-title h1, .card .card-header .card-title .h1, .card .card-header .card-title h2, .card .card-header .card-title .h2, .card .card-header .card-title h3, .card .card-header .card-title .h3, .card .card-header .card-title h4, .card .card-header .card-title .h4, .card .card-header .card-title h5, .card .card-header .card-title .h5, .card .card-header .card-title h6, .card .card-header .card-title .h6 {
  margin-bottom: 0;
}

.card .card-header .card-toolbar {
  display: flex;
  align-items: center;
  margin: 0.5rem 0;
  flex-wrap: wrap;
}

.card .card-body {
  padding: 2rem 2.25rem;
  color: var(--bs-card-color);
  background-color: #b79e82;
}

.card .card-footer {
  padding: 2rem 2.25rem;
  color: var(--bs-card-cap-color);
  background-color: var(--bs-card-cap-bg);
  border-top: 1px solid var(--bs-card-border-color);
}

.card .card-scroll {
  position: relative;
  overflow: auto;
}

.card.card-px-0 .card-header,
.card.card-px-0 .card-body,
.card.card-px-0 .card-footer {
  padding-left: 0;
  padding-right: 0;
}

.card.card-py-0 .card-header,
.card.card-py-0 .card-body,
.card.card-py-0 .card-footer {
  padding-top: 0;
  padding-bottom: 0;
}

.card.card-p-0 .card-header,
.card.card-p-0 .card-body,
.card.card-p-0 .card-footer {
  padding: 0;
}

.card.card-dashed {
  box-shadow: none;
  border: 1px dashed var(--bs-border-dashed-color);
}

.card.card-dashed > .card-header {
  border-bottom: 1px dashed var(--bs-border-dashed-color);
}

.card.card-dashed > .card-footer {
  border-top: 1px dashed var(--bs-border-dashed-color);
}

.card.card-bordered {
  box-shadow: none;
  border: 1px solid var(--bs-border-color);
}

.card.card-flush > .card-header {
  border-bottom: 0 !important;
}

.card.card-flush > .card-footer {
  border-top: 0 !important;
}

.card.card-shadow {
  box-shadow: var(--bs-card-box-shadow);
  border: 0;
}

.card.card-reset {
  border: 0 !important;
  box-shadow: none !important;
  background-color: transparent !important;
}

.card.card-reset > .card-header {
  border-bottom: 0 !important;
}

.card.card-reset > .card-footer {
  border-top: 0 !important;
}

.card.card-borderless {
  border: 0 !important;
}

.card.card-borderless > .card-header {
  border-bottom: 0 !important;
}

.card.card-borderless > .card-footer {
  border-top: 0 !important;
}

.card.card-border-0 {
  border: 0 !important;
}

.card.card-stretch {
  height: calc(100% - var(--bs-gutter-y));
}

.card.card-stretch-75 {
  height: calc(75% - var(--bs-gutter-y));
}

.card.card-stretch-50 {
  height: calc(50% - var(--bs-gutter-y));
}

.card.card-stretch-33 {
  height: calc(33.333% - var(--bs-gutter-y));
}

.card.card-stretch-25 {
  height: calc(25% - var(--bs-gutter-y));
}

.card .card-header-stretch {
  padding-top: 0 !important;
  padding-bottom: 0 !important;
  align-items: stretch;
}

.card .card-header-stretch .card-toolbar {
  margin: 0;
  align-items: stretch;
}

@media (min-width: 576px) {
  .card.card-sm-stretch {
    height: calc(100% - var(--bs-gutter-y));
  }
  .card.card-sm-stretch-75 {
    height: calc(75% - var(--bs-gutter-y));
  }
  .card.card-sm-stretch-50 {
    height: calc(50% - var(--bs-gutter-y));
  }
  .card.card-sm-stretch-33 {
    height: calc(33.333% - var(--bs-gutter-y));
  }
  .card.card-sm-stretch-25 {
    height: calc(25% - var(--bs-gutter-y));
  }
  .card .card-header-sm-stretch {
    padding-top: 0 !important;
    padding-bottom: 0 !important;
    align-items: stretch;
  }
  .card .card-header-sm-stretch .card-toolbar {
    margin: 0;
    align-items: stretch;
  }
}
@media (min-width: 768px) {
  .card.card-md-stretch {
    height: calc(100% - var(--bs-gutter-y));
  }
  .card.card-md-stretch-75 {
    height: calc(75% - var(--bs-gutter-y));
  }
  .card.card-md-stretch-50 {
    height: calc(50% - var(--bs-gutter-y));
  }
  .card.card-md-stretch-33 {
    height: calc(33.333% - var(--bs-gutter-y));
  }
  .card.card-md-stretch-25 {
    height: calc(25% - var(--bs-gutter-y));
  }
  .card .card-header-md-stretch {
    padding-top: 0 !important;
    padding-bottom: 0 !important;
    align-items: stretch;
  }
  .card .card-header-md-stretch .card-toolbar {
    margin: 0;
    align-items: stretch;
  }
}
@media (min-width: 992px) {
  .card.card-lg-stretch {
    height: calc(100% - var(--bs-gutter-y));
  }
  .card.card-lg-stretch-75 {
    height: calc(75% - var(--bs-gutter-y));
  }
  .card.card-lg-stretch-50 {
    height: calc(50% - var(--bs-gutter-y));
  }
  .card.card-lg-stretch-33 {
    height: calc(33.333% - var(--bs-gutter-y));
  }
  .card.card-lg-stretch-25 {
    height: calc(25% - var(--bs-gutter-y));
  }
  .card .card-header-lg-stretch {
    padding-top: 0 !important;
    padding-bottom: 0 !important;
    align-items: stretch;
  }
  .card .card-header-lg-stretch .card-toolbar {
    margin: 0;
    align-items: stretch;
  }
}
@media (min-width: 1200px) {
  .card.card-xl-stretch {
    height: calc(100% - var(--bs-gutter-y));
  }
  .card.card-xl-stretch-75 {
    height: calc(75% - var(--bs-gutter-y));
  }
  .card.card-xl-stretch-50 {
    height: calc(50% - var(--bs-gutter-y));
  }
  .card.card-xl-stretch-33 {
    height: calc(33.333% - var(--bs-gutter-y));
  }
  .card.card-xl-stretch-25 {
    height: calc(25% - var(--bs-gutter-y));
  }
  .card .card-header-xl-stretch {
    padding-top: 0 !important;
    padding-bottom: 0 !important;
    align-items: stretch;
  }
  .card .card-header-xl-stretch .card-toolbar {
    margin: 0;
    align-items: stretch;
  }
}
@media (min-width: 1400px) {
  .card.card-xxl-stretch {
    height: calc(100% - var(--bs-gutter-y));
  }
  .card.card-xxl-stretch-75 {
    height: calc(75% - var(--bs-gutter-y));
  }
  .card.card-xxl-stretch-50 {
    height: calc(50% - var(--bs-gutter-y));
  }
  .card.card-xxl-stretch-33 {
    height: calc(33.333% - var(--bs-gutter-y));
  }
  .card.card-xxl-stretch-25 {
    height: calc(25% - var(--bs-gutter-y));
  }
  .card .card-header-xxl-stretch {
    padding-top: 0 !important;
    padding-bottom: 0 !important;
    align-items: stretch;
  }
  .card .card-header-xxl-stretch .card-toolbar {
    margin: 0;
    align-items: stretch;
  }
}
.card-p {
  padding: 2rem 2.25rem !important;
}

.card-px {
  padding-left: 2.25rem !important;
  padding-right: 2.25rem !important;
}

.card-shadow {
  box-shadow: var(--bs-card-box-shadow);
}

.card-py {
  padding-top: 2rem !important;
  padding-bottom: 2rem !important;
}

.card-rounded {
  border-radius: 0.625rem;
}

.card-rounded-start {
  border-top-left-radius: 0.625rem;
  border-bottom-left-radius: 0.625rem;
}

.card-rounded-end {
  border-top-right-radius: 0.625rem;
  border-bottom-right-radius: 0.625rem;
}

.card-rounded-top {
  border-top-left-radius: 0.625rem;
  border-top-right-radius: 0.625rem;
}

.card-rounded-bottom {
  border-bottom-left-radius: 0.625rem;
  border-bottom-right-radius: 0.625rem;
}

@media (max-width: 767.98px) {
  .card > .card-header:not(.flex-nowrap) {
    padding-top: 0.5rem;
    padding-bottom: 0.5rem;
  }
}
[data-bs-theme=dark] .card {
  --bs-card-box-shadow: ;
}

.breadcrumb {
  display: flex;
  align-items: center;
  background-color: transparent;
  padding: 0;
  margin: 0;
}

.breadcrumb .breadcrumb-item {
  display: flex;
  align-items: center;
  padding-left: 0.5rem;
}

.breadcrumb .breadcrumb-item:last-child {
  padding-right: 0;
}

.breadcrumb .breadcrumb-item:after {
  padding-left: 0.5rem;
  content: "/";
}

.breadcrumb .breadcrumb-item:before {
  display: none;
}

.breadcrumb .breadcrumb-item:first-child {
  padding-left: 0;
}

.breadcrumb .breadcrumb-item:last-child:after {
  display: none;
}

.breadcrumb-line .breadcrumb-item:after {
  content: "-";
}

.breadcrumb-dot .breadcrumb-item:after {
  content: "•";
}

.breadcrumb-separatorless .breadcrumb-item:after {
  display: none;
}

.btn {
  --bs-btn-color: var(--bs-body-color);
  outline: none !important;
}

.btn:not(.btn-shadow):not(.shadow):not(.shadow-sm):not(.shadow-lg):not(.shadow-xs) {
  box-shadow: none;
}

.btn:not(.btn-outline):not(.btn-dashed):not(.border-hover):not(.border-active):not(.btn-flush):not(.btn-icon) {
  border: 0;
  padding: calc(0.775rem + 1px) calc(1.5rem + 1px);
}

.btn:not(.btn-outline):not(.btn-dashed):not(.border-hover):not(.border-active):not(.btn-flush):not(.btn-icon).btn-lg, .btn-group-lg > .btn:not(.btn-outline):not(.btn-dashed):not(.border-hover):not(.border-active):not(.btn-flush):not(.btn-icon) {
  padding: calc(0.825rem + 1px) calc(1.75rem + 1px);
}

.btn:not(.btn-outline):not(.btn-dashed):not(.border-hover):not(.border-active):not(.btn-flush):not(.btn-icon).btn-sm, .btn-group-sm > .btn:not(.btn-outline):not(.btn-dashed):not(.border-hover):not(.border-active):not(.btn-flush):not(.btn-icon) {
  padding: calc(0.55rem + 1px) calc(1.25rem + 1px);
}

.btn.btn-link {
  border: 0;
  border-radius: 0;
  padding-left: 0 !important;
  padding-right: 0 !important;
  text-decoration: none;
  font-weight: 500;
}

.btn.btn-outline:not(.btn-outline-dashed) {
  border: 1px solid var(--bs-gray-300);
}

.btn.btn-outline-dashed {
  border: 1px dashed var(--bs-gray-300);
}

.btn.btn-flush {
  appearance: none;
  box-shadow: none;
  border-radius: 0;
  border: none;
  cursor: pointer;
  background-color: transparent;
  outline: none !important;
  margin: 0;
  padding: 0;
}

.btn.btn-flex {
  display: inline-flex;
  align-items: center;
}

.btn.btn-trim-start {
  justify-content: flex-start !important;
  padding-left: 0 !important;
}

.btn.btn-trim-end {
  justify-content: flex-end !important;
  padding-right: 0 !important;
}

.btn-reset {
  background-color: transparent;
  border: 0;
  box-shadow: none;
  -webkit-user-select: none;
          user-select: none;
  outline: none;
}

.btn > i {
  display: inline-flex;
  font-size: 1rem;
  padding-right: 0.35rem;
  vertical-align: middle;
}

.btn .svg-icon {
  flex-shrink: 0;
  line-height: 0;
  margin-right: 0.5rem;
}

.btn.btn-icon {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  padding: 0;
  height: calc(1.5em + 1.55rem + 2px);
  width: calc(1.5em + 1.55rem + 2px);
}

.btn.btn-icon:not(.btn-outline):not(.btn-dashed):not(.border-hover):not(.border-active):not(.btn-flush) {
  border: 0;
}

.btn.btn-icon.btn-sm, .btn-group-sm > .btn.btn-icon {
  height: calc(1.5em + 1.1rem + 2px);
  width: calc(1.5em + 1.1rem + 2px);
}

.btn.btn-icon.btn-lg, .btn-group-lg > .btn.btn-icon {
  height: calc(1.5em + 1.65rem + 2px);
  width: calc(1.5em + 1.65rem + 2px);
}

.btn.btn-icon.btn-circle {
  border-radius: 50%;
}

.btn.btn-icon i,
.btn.btn-icon .svg-icon {
  padding: 0;
  margin: 0;
  line-height: 1;
}

.btn.btn-outline.btn-outline-dashed {
  border-width: 1px;
  border-style: dashed;
}

.btn-check:checked + .btn.btn-outline.btn-outline-dashed, .btn-check:active + .btn.btn-outline.btn-outline-dashed, .btn.btn-outline.btn-outline-dashed:focus:not(.btn-active), .btn.btn-outline.btn-outline-dashed:hover:not(.btn-active), .btn.btn-outline.btn-outline-dashed:active:not(.btn-active), .btn.btn-outline.btn-outline-dashed.active, .btn.btn-outline.btn-outline-dashed.show, .show > .btn.btn-outline.btn-outline-dashed {
  border-color: var(--bs-primary);
}

.btn.btn-light {
  color: var(--bs-light-inverse);
  border-color: var(--bs-light);
  background-color: var(--bs-light);
}

.btn.btn-light i,
.btn.btn-light .svg-icon {
  color: var(--bs-light-inverse);
}

.btn.btn-light.dropdown-toggle:after {
  color: var(--bs-light-inverse);
}

.btn-check:checked + .btn.btn-light, .btn-check:active + .btn.btn-light, .btn.btn-light:focus:not(.btn-active), .btn.btn-light:hover:not(.btn-active), .btn.btn-light:active:not(.btn-active), .btn.btn-light.active, .btn.btn-light.show, .show > .btn.btn-light {
  color: var(--bs-light-inverse);
  border-color: var(--bs-light-active);
  background-color: var(--bs-light-active) !important;
}

.btn-check:checked + .btn.btn-light i,
.btn-check:checked + .btn.btn-light .svg-icon, .btn-check:active + .btn.btn-light i,
.btn-check:active + .btn.btn-light .svg-icon, .btn.btn-light:focus:not(.btn-active) i,
.btn.btn-light:focus:not(.btn-active) .svg-icon, .btn.btn-light:hover:not(.btn-active) i,
.btn.btn-light:hover:not(.btn-active) .svg-icon, .btn.btn-light:active:not(.btn-active) i,
.btn.btn-light:active:not(.btn-active) .svg-icon, .btn.btn-light.active i,
.btn.btn-light.active .svg-icon, .btn.btn-light.show i,
.btn.btn-light.show .svg-icon, .show > .btn.btn-light i,
.show > .btn.btn-light .svg-icon {
  color: var(--bs-light-inverse);
}

.btn-check:checked + .btn.btn-light.dropdown-toggle:after, .btn-check:active + .btn.btn-light.dropdown-toggle:after, .btn.btn-light:focus:not(.btn-active).dropdown-toggle:after, .btn.btn-light:hover:not(.btn-active).dropdown-toggle:after, .btn.btn-light:active:not(.btn-active).dropdown-toggle:after, .btn.btn-light.active.dropdown-toggle:after, .btn.btn-light.show.dropdown-toggle:after, .show > .btn.btn-light.dropdown-toggle:after {
  color: var(--bs-light-inverse);
}

.btn.btn-bg-light {
  border-color: var(--bs-light);
  background-color: var(--bs-light);
}

.btn-check:checked + .btn.btn-active-light, .btn-check:active + .btn.btn-active-light, .btn.btn-active-light:focus:not(.btn-active), .btn.btn-active-light:hover:not(.btn-active), .btn.btn-active-light:active:not(.btn-active), .btn.btn-active-light.active, .btn.btn-active-light.show, .show > .btn.btn-active-light {
  color: var(--bs-light-inverse);
  border-color: var(--bs-light);
  background-color: var(--bs-light) !important;
}

.btn-check:checked + .btn.btn-active-light i,
.btn-check:checked + .btn.btn-active-light .svg-icon, .btn-check:active + .btn.btn-active-light i,
.btn-check:active + .btn.btn-active-light .svg-icon, .btn.btn-active-light:focus:not(.btn-active) i,
.btn.btn-active-light:focus:not(.btn-active) .svg-icon, .btn.btn-active-light:hover:not(.btn-active) i,
.btn.btn-active-light:hover:not(.btn-active) .svg-icon, .btn.btn-active-light:active:not(.btn-active) i,
.btn.btn-active-light:active:not(.btn-active) .svg-icon, .btn.btn-active-light.active i,
.btn.btn-active-light.active .svg-icon, .btn.btn-active-light.show i,
.btn.btn-active-light.show .svg-icon, .show > .btn.btn-active-light i,
.show > .btn.btn-active-light .svg-icon {
  color: var(--bs-light-inverse);
}

.btn-check:checked + .btn.btn-active-light.dropdown-toggle:after, .btn-check:active + .btn.btn-active-light.dropdown-toggle:after, .btn.btn-active-light:focus:not(.btn-active).dropdown-toggle:after, .btn.btn-active-light:hover:not(.btn-active).dropdown-toggle:after, .btn.btn-active-light:active:not(.btn-active).dropdown-toggle:after, .btn.btn-active-light.active.dropdown-toggle:after, .btn.btn-active-light.show.dropdown-toggle:after, .show > .btn.btn-active-light.dropdown-toggle:after {
  color: var(--bs-light-inverse);
}

.btn.btn-outline.btn-outline-light {
  color: var(--bs-light);
  border-color: var(--bs-light);
  background-color: transparent;
}

.btn.btn-outline.btn-outline-light i,
.btn.btn-outline.btn-outline-light .svg-icon {
  color: var(--bs-light);
}

.btn.btn-outline.btn-outline-light.dropdown-toggle:after {
  color: var(--bs-light);
}

.btn-check:checked + .btn.btn-outline.btn-outline-light, .btn-check:active + .btn.btn-outline.btn-outline-light, .btn.btn-outline.btn-outline-light:focus:not(.btn-active), .btn.btn-outline.btn-outline-light:hover:not(.btn-active), .btn.btn-outline.btn-outline-light:active:not(.btn-active), .btn.btn-outline.btn-outline-light.active, .btn.btn-outline.btn-outline-light.show, .show > .btn.btn-outline.btn-outline-light {
  color: var(--bs-light-active);
  border-color: var(--bs-light);
  background-color: var(--bs-light-light) !important;
}

.btn-check:checked + .btn.btn-outline.btn-outline-light i,
.btn-check:checked + .btn.btn-outline.btn-outline-light .svg-icon, .btn-check:active + .btn.btn-outline.btn-outline-light i,
.btn-check:active + .btn.btn-outline.btn-outline-light .svg-icon, .btn.btn-outline.btn-outline-light:focus:not(.btn-active) i,
.btn.btn-outline.btn-outline-light:focus:not(.btn-active) .svg-icon, .btn.btn-outline.btn-outline-light:hover:not(.btn-active) i,
.btn.btn-outline.btn-outline-light:hover:not(.btn-active) .svg-icon, .btn.btn-outline.btn-outline-light:active:not(.btn-active) i,
.btn.btn-outline.btn-outline-light:active:not(.btn-active) .svg-icon, .btn.btn-outline.btn-outline-light.active i,
.btn.btn-outline.btn-outline-light.active .svg-icon, .btn.btn-outline.btn-outline-light.show i,
.btn.btn-outline.btn-outline-light.show .svg-icon, .show > .btn.btn-outline.btn-outline-light i,
.show > .btn.btn-outline.btn-outline-light .svg-icon {
  color: var(--bs-light-active);
}

.btn-check:checked + .btn.btn-outline.btn-outline-light.dropdown-toggle:after, .btn-check:active + .btn.btn-outline.btn-outline-light.dropdown-toggle:after, .btn.btn-outline.btn-outline-light:focus:not(.btn-active).dropdown-toggle:after, .btn.btn-outline.btn-outline-light:hover:not(.btn-active).dropdown-toggle:after, .btn.btn-outline.btn-outline-light:active:not(.btn-active).dropdown-toggle:after, .btn.btn-outline.btn-outline-light.active.dropdown-toggle:after, .btn.btn-outline.btn-outline-light.show.dropdown-toggle:after, .show > .btn.btn-outline.btn-outline-light.dropdown-toggle:after {
  color: var(--bs-light-active);
}

.btn.btn-primary {
  color: var(--bs-primary-inverse);
  border-color: var(--bs-primary);
  background-color: var(--bs-primary);
}

.btn.btn-primary i,
.btn.btn-primary .svg-icon {
  color: var(--bs-primary-inverse);
}

.btn.btn-primary.dropdown-toggle:after {
  color: var(--bs-primary-inverse);
}

.btn-check:checked + .btn.btn-primary, .btn-check:active + .btn.btn-primary, .btn.btn-primary:focus:not(.btn-active), .btn.btn-primary:hover:not(.btn-active), .btn.btn-primary:active:not(.btn-active), .btn.btn-primary.active, .btn.btn-primary.show, .show > .btn.btn-primary {
  color: var(--bs-primary-inverse);
  border-color: var(--bs-primary-active);
  background-color: var(--bs-primary-active) !important;
}

.btn-check:checked + .btn.btn-primary i,
.btn-check:checked + .btn.btn-primary .svg-icon, .btn-check:active + .btn.btn-primary i,
.btn-check:active + .btn.btn-primary .svg-icon, .btn.btn-primary:focus:not(.btn-active) i,
.btn.btn-primary:focus:not(.btn-active) .svg-icon, .btn.btn-primary:hover:not(.btn-active) i,
.btn.btn-primary:hover:not(.btn-active) .svg-icon, .btn.btn-primary:active:not(.btn-active) i,
.btn.btn-primary:active:not(.btn-active) .svg-icon, .btn.btn-primary.active i,
.btn.btn-primary.active .svg-icon, .btn.btn-primary.show i,
.btn.btn-primary.show .svg-icon, .show > .btn.btn-primary i,
.show > .btn.btn-primary .svg-icon {
  color: var(--bs-primary-inverse);
}

.btn-check:checked + .btn.btn-primary.dropdown-toggle:after, .btn-check:active + .btn.btn-primary.dropdown-toggle:after, .btn.btn-primary:focus:not(.btn-active).dropdown-toggle:after, .btn.btn-primary:hover:not(.btn-active).dropdown-toggle:after, .btn.btn-primary:active:not(.btn-active).dropdown-toggle:after, .btn.btn-primary.active.dropdown-toggle:after, .btn.btn-primary.show.dropdown-toggle:after, .show > .btn.btn-primary.dropdown-toggle:after {
  color: var(--bs-primary-inverse);
}

.btn.btn-light-primary {
  color: var(--bs-primary);
  border-color: var(--bs-primary-light);
  background-color: var(--bs-primary-light);
}

.btn.btn-light-primary i,
.btn.btn-light-primary .svg-icon {
  color: var(--bs-primary);
}

.btn.btn-light-primary.dropdown-toggle:after {
  color: var(--bs-primary);
}

.btn-check:checked + .btn.btn-light-primary, .btn-check:active + .btn.btn-light-primary, .btn.btn-light-primary:focus:not(.btn-active), .btn.btn-light-primary:hover:not(.btn-active), .btn.btn-light-primary:active:not(.btn-active), .btn.btn-light-primary.active, .btn.btn-light-primary.show, .show > .btn.btn-light-primary {
  color: var(--bs-primary-inverse);
  border-color: var(--bs-primary);
  background-color: var(--bs-primary) !important;
}

.btn-check:checked + .btn.btn-light-primary i,
.btn-check:checked + .btn.btn-light-primary .svg-icon, .btn-check:active + .btn.btn-light-primary i,
.btn-check:active + .btn.btn-light-primary .svg-icon, .btn.btn-light-primary:focus:not(.btn-active) i,
.btn.btn-light-primary:focus:not(.btn-active) .svg-icon, .btn.btn-light-primary:hover:not(.btn-active) i,
.btn.btn-light-primary:hover:not(.btn-active) .svg-icon, .btn.btn-light-primary:active:not(.btn-active) i,
.btn.btn-light-primary:active:not(.btn-active) .svg-icon, .btn.btn-light-primary.active i,
.btn.btn-light-primary.active .svg-icon, .btn.btn-light-primary.show i,
.btn.btn-light-primary.show .svg-icon, .show > .btn.btn-light-primary i,
.show > .btn.btn-light-primary .svg-icon {
  color: var(--bs-primary-inverse);
}

.btn-check:checked + .btn.btn-light-primary.dropdown-toggle:after, .btn-check:active + .btn.btn-light-primary.dropdown-toggle:after, .btn.btn-light-primary:focus:not(.btn-active).dropdown-toggle:after, .btn.btn-light-primary:hover:not(.btn-active).dropdown-toggle:after, .btn.btn-light-primary:active:not(.btn-active).dropdown-toggle:after, .btn.btn-light-primary.active.dropdown-toggle:after, .btn.btn-light-primary.show.dropdown-toggle:after, .show > .btn.btn-light-primary.dropdown-toggle:after {
  color: var(--bs-primary-inverse);
}

.btn.btn-bg-primary {
  border-color: var(--bs-primary);
  background-color: var(--bs-primary);
}

.btn-check:checked + .btn.btn-active-primary, .btn-check:active + .btn.btn-active-primary, .btn.btn-active-primary:focus:not(.btn-active), .btn.btn-active-primary:hover:not(.btn-active), .btn.btn-active-primary:active:not(.btn-active), .btn.btn-active-primary.active, .btn.btn-active-primary.show, .show > .btn.btn-active-primary {
  color: var(--bs-primary-inverse);
  border-color: var(--bs-primary);
  background-color: var(--bs-primary) !important;
}

.btn-check:checked + .btn.btn-active-primary i,
.btn-check:checked + .btn.btn-active-primary .svg-icon, .btn-check:active + .btn.btn-active-primary i,
.btn-check:active + .btn.btn-active-primary .svg-icon, .btn.btn-active-primary:focus:not(.btn-active) i,
.btn.btn-active-primary:focus:not(.btn-active) .svg-icon, .btn.btn-active-primary:hover:not(.btn-active) i,
.btn.btn-active-primary:hover:not(.btn-active) .svg-icon, .btn.btn-active-primary:active:not(.btn-active) i,
.btn.btn-active-primary:active:not(.btn-active) .svg-icon, .btn.btn-active-primary.active i,
.btn.btn-active-primary.active .svg-icon, .btn.btn-active-primary.show i,
.btn.btn-active-primary.show .svg-icon, .show > .btn.btn-active-primary i,
.show > .btn.btn-active-primary .svg-icon {
  color: var(--bs-primary-inverse);
}

.btn-check:checked + .btn.btn-active-primary.dropdown-toggle:after, .btn-check:active + .btn.btn-active-primary.dropdown-toggle:after, .btn.btn-active-primary:focus:not(.btn-active).dropdown-toggle:after, .btn.btn-active-primary:hover:not(.btn-active).dropdown-toggle:after, .btn.btn-active-primary:active:not(.btn-active).dropdown-toggle:after, .btn.btn-active-primary.active.dropdown-toggle:after, .btn.btn-active-primary.show.dropdown-toggle:after, .show > .btn.btn-active-primary.dropdown-toggle:after {
  color: var(--bs-primary-inverse);
}

.btn-check:checked + .btn.btn-active-light-primary, .btn-check:active + .btn.btn-active-light-primary, .btn.btn-active-light-primary:focus:not(.btn-active), .btn.btn-active-light-primary:hover:not(.btn-active), .btn.btn-active-light-primary:active:not(.btn-active), .btn.btn-active-light-primary.active, .btn.btn-active-light-primary.show, .show > .btn.btn-active-light-primary {
  color: var(--bs-primary);
  border-color: var(--bs-primary-light);
  background-color: var(--bs-primary-light) !important;
}

.btn-check:checked + .btn.btn-active-light-primary i,
.btn-check:checked + .btn.btn-active-light-primary .svg-icon, .btn-check:active + .btn.btn-active-light-primary i,
.btn-check:active + .btn.btn-active-light-primary .svg-icon, .btn.btn-active-light-primary:focus:not(.btn-active) i,
.btn.btn-active-light-primary:focus:not(.btn-active) .svg-icon, .btn.btn-active-light-primary:hover:not(.btn-active) i,
.btn.btn-active-light-primary:hover:not(.btn-active) .svg-icon, .btn.btn-active-light-primary:active:not(.btn-active) i,
.btn.btn-active-light-primary:active:not(.btn-active) .svg-icon, .btn.btn-active-light-primary.active i,
.btn.btn-active-light-primary.active .svg-icon, .btn.btn-active-light-primary.show i,
.btn.btn-active-light-primary.show .svg-icon, .show > .btn.btn-active-light-primary i,
.show > .btn.btn-active-light-primary .svg-icon {
  color: var(--bs-primary);
}

.btn-check:checked + .btn.btn-active-light-primary.dropdown-toggle:after, .btn-check:active + .btn.btn-active-light-primary.dropdown-toggle:after, .btn.btn-active-light-primary:focus:not(.btn-active).dropdown-toggle:after, .btn.btn-active-light-primary:hover:not(.btn-active).dropdown-toggle:after, .btn.btn-active-light-primary:active:not(.btn-active).dropdown-toggle:after, .btn.btn-active-light-primary.active.dropdown-toggle:after, .btn.btn-active-light-primary.show.dropdown-toggle:after, .show > .btn.btn-active-light-primary.dropdown-toggle:after {
  color: var(--bs-primary);
}

.btn.btn-outline.btn-outline-primary {
  color: var(--bs-primary);
  border-color: var(--bs-primary);
  background-color: transparent;
}

.btn.btn-outline.btn-outline-primary i,
.btn.btn-outline.btn-outline-primary .svg-icon {
  color: var(--bs-primary);
}

.btn.btn-outline.btn-outline-primary.dropdown-toggle:after {
  color: var(--bs-primary);
}

.btn-check:checked + .btn.btn-outline.btn-outline-primary, .btn-check:active + .btn.btn-outline.btn-outline-primary, .btn.btn-outline.btn-outline-primary:focus:not(.btn-active), .btn.btn-outline.btn-outline-primary:hover:not(.btn-active), .btn.btn-outline.btn-outline-primary:active:not(.btn-active), .btn.btn-outline.btn-outline-primary.active, .btn.btn-outline.btn-outline-primary.show, .show > .btn.btn-outline.btn-outline-primary {
  color: var(--bs-primary-active);
  border-color: var(--bs-primary);
  background-color: var(--bs-primary-light) !important;
}

.btn-check:checked + .btn.btn-outline.btn-outline-primary i,
.btn-check:checked + .btn.btn-outline.btn-outline-primary .svg-icon, .btn-check:active + .btn.btn-outline.btn-outline-primary i,
.btn-check:active + .btn.btn-outline.btn-outline-primary .svg-icon, .btn.btn-outline.btn-outline-primary:focus:not(.btn-active) i,
.btn.btn-outline.btn-outline-primary:focus:not(.btn-active) .svg-icon, .btn.btn-outline.btn-outline-primary:hover:not(.btn-active) i,
.btn.btn-outline.btn-outline-primary:hover:not(.btn-active) .svg-icon, .btn.btn-outline.btn-outline-primary:active:not(.btn-active) i,
.btn.btn-outline.btn-outline-primary:active:not(.btn-active) .svg-icon, .btn.btn-outline.btn-outline-primary.active i,
.btn.btn-outline.btn-outline-primary.active .svg-icon, .btn.btn-outline.btn-outline-primary.show i,
.btn.btn-outline.btn-outline-primary.show .svg-icon, .show > .btn.btn-outline.btn-outline-primary i,
.show > .btn.btn-outline.btn-outline-primary .svg-icon {
  color: var(--bs-primary-active);
}

.btn-check:checked + .btn.btn-outline.btn-outline-primary.dropdown-toggle:after, .btn-check:active + .btn.btn-outline.btn-outline-primary.dropdown-toggle:after, .btn.btn-outline.btn-outline-primary:focus:not(.btn-active).dropdown-toggle:after, .btn.btn-outline.btn-outline-primary:hover:not(.btn-active).dropdown-toggle:after, .btn.btn-outline.btn-outline-primary:active:not(.btn-active).dropdown-toggle:after, .btn.btn-outline.btn-outline-primary.active.dropdown-toggle:after, .btn.btn-outline.btn-outline-primary.show.dropdown-toggle:after, .show > .btn.btn-outline.btn-outline-primary.dropdown-toggle:after {
  color: var(--bs-primary-active);
}

.btn.btn-secondary {
  color: var(--bs-secondary-inverse);
  border-color: var(--bs-secondary);
  background-color: var(--bs-secondary);
}

.btn.btn-secondary i,
.btn.btn-secondary .svg-icon {
  color: var(--bs-secondary-inverse);
}

.btn.btn-secondary.dropdown-toggle:after {
  color: var(--bs-secondary-inverse);
}

.btn-check:checked + .btn.btn-secondary, .btn-check:active + .btn.btn-secondary, .btn.btn-secondary:focus:not(.btn-active), .btn.btn-secondary:hover:not(.btn-active), .btn.btn-secondary:active:not(.btn-active), .btn.btn-secondary.active, .btn.btn-secondary.show, .show > .btn.btn-secondary {
  color: var(--bs-secondary-inverse);
  border-color: var(--bs-secondary-active);
  background-color: var(--bs-secondary-active) !important;
}

.btn-check:checked + .btn.btn-secondary i,
.btn-check:checked + .btn.btn-secondary .svg-icon, .btn-check:active + .btn.btn-secondary i,
.btn-check:active + .btn.btn-secondary .svg-icon, .btn.btn-secondary:focus:not(.btn-active) i,
.btn.btn-secondary:focus:not(.btn-active) .svg-icon, .btn.btn-secondary:hover:not(.btn-active) i,
.btn.btn-secondary:hover:not(.btn-active) .svg-icon, .btn.btn-secondary:active:not(.btn-active) i,
.btn.btn-secondary:active:not(.btn-active) .svg-icon, .btn.btn-secondary.active i,
.btn.btn-secondary.active .svg-icon, .btn.btn-secondary.show i,
.btn.btn-secondary.show .svg-icon, .show > .btn.btn-secondary i,
.show > .btn.btn-secondary .svg-icon {
  color: var(--bs-secondary-inverse);
}

.btn-check:checked + .btn.btn-secondary.dropdown-toggle:after, .btn-check:active + .btn.btn-secondary.dropdown-toggle:after, .btn.btn-secondary:focus:not(.btn-active).dropdown-toggle:after, .btn.btn-secondary:hover:not(.btn-active).dropdown-toggle:after, .btn.btn-secondary:active:not(.btn-active).dropdown-toggle:after, .btn.btn-secondary.active.dropdown-toggle:after, .btn.btn-secondary.show.dropdown-toggle:after, .show > .btn.btn-secondary.dropdown-toggle:after {
  color: var(--bs-secondary-inverse);
}

.btn.btn-light-secondary {
  color: var(--bs-secondary);
  border-color: var(--bs-secondary-light);
  background-color: var(--bs-secondary-light);
}

.btn.btn-light-secondary i,
.btn.btn-light-secondary .svg-icon {
  color: var(--bs-secondary);
}

.btn.btn-light-secondary.dropdown-toggle:after {
  color: var(--bs-secondary);
}

.btn-check:checked + .btn.btn-light-secondary, .btn-check:active + .btn.btn-light-secondary, .btn.btn-light-secondary:focus:not(.btn-active), .btn.btn-light-secondary:hover:not(.btn-active), .btn.btn-light-secondary:active:not(.btn-active), .btn.btn-light-secondary.active, .btn.btn-light-secondary.show, .show > .btn.btn-light-secondary {
  color: var(--bs-secondary-inverse);
  border-color: var(--bs-secondary);
  background-color: var(--bs-secondary) !important;
}

.btn-check:checked + .btn.btn-light-secondary i,
.btn-check:checked + .btn.btn-light-secondary .svg-icon, .btn-check:active + .btn.btn-light-secondary i,
.btn-check:active + .btn.btn-light-secondary .svg-icon, .btn.btn-light-secondary:focus:not(.btn-active) i,
.btn.btn-light-secondary:focus:not(.btn-active) .svg-icon, .btn.btn-light-secondary:hover:not(.btn-active) i,
.btn.btn-light-secondary:hover:not(.btn-active) .svg-icon, .btn.btn-light-secondary:active:not(.btn-active) i,
.btn.btn-light-secondary:active:not(.btn-active) .svg-icon, .btn.btn-light-secondary.active i,
.btn.btn-light-secondary.active .svg-icon, .btn.btn-light-secondary.show i,
.btn.btn-light-secondary.show .svg-icon, .show > .btn.btn-light-secondary i,
.show > .btn.btn-light-secondary .svg-icon {
  color: var(--bs-secondary-inverse);
}

.btn-check:checked + .btn.btn-light-secondary.dropdown-toggle:after, .btn-check:active + .btn.btn-light-secondary.dropdown-toggle:after, .btn.btn-light-secondary:focus:not(.btn-active).dropdown-toggle:after, .btn.btn-light-secondary:hover:not(.btn-active).dropdown-toggle:after, .btn.btn-light-secondary:active:not(.btn-active).dropdown-toggle:after, .btn.btn-light-secondary.active.dropdown-toggle:after, .btn.btn-light-secondary.show.dropdown-toggle:after, .show > .btn.btn-light-secondary.dropdown-toggle:after {
  color: var(--bs-secondary-inverse);
}

.btn.btn-bg-secondary {
  border-color: var(--bs-secondary);
  background-color: var(--bs-secondary);
}

.btn-check:checked + .btn.btn-active-secondary, .btn-check:active + .btn.btn-active-secondary, .btn.btn-active-secondary:focus:not(.btn-active), .btn.btn-active-secondary:hover:not(.btn-active), .btn.btn-active-secondary:active:not(.btn-active), .btn.btn-active-secondary.active, .btn.btn-active-secondary.show, .show > .btn.btn-active-secondary {
  color: var(--bs-secondary-inverse);
  border-color: var(--bs-secondary);
  background-color: var(--bs-secondary) !important;
}

.btn-check:checked + .btn.btn-active-secondary i,
.btn-check:checked + .btn.btn-active-secondary .svg-icon, .btn-check:active + .btn.btn-active-secondary i,
.btn-check:active + .btn.btn-active-secondary .svg-icon, .btn.btn-active-secondary:focus:not(.btn-active) i,
.btn.btn-active-secondary:focus:not(.btn-active) .svg-icon, .btn.btn-active-secondary:hover:not(.btn-active) i,
.btn.btn-active-secondary:hover:not(.btn-active) .svg-icon, .btn.btn-active-secondary:active:not(.btn-active) i,
.btn.btn-active-secondary:active:not(.btn-active) .svg-icon, .btn.btn-active-secondary.active i,
.btn.btn-active-secondary.active .svg-icon, .btn.btn-active-secondary.show i,
.btn.btn-active-secondary.show .svg-icon, .show > .btn.btn-active-secondary i,
.show > .btn.btn-active-secondary .svg-icon {
  color: var(--bs-secondary-inverse);
}

.btn-check:checked + .btn.btn-active-secondary.dropdown-toggle:after, .btn-check:active + .btn.btn-active-secondary.dropdown-toggle:after, .btn.btn-active-secondary:focus:not(.btn-active).dropdown-toggle:after, .btn.btn-active-secondary:hover:not(.btn-active).dropdown-toggle:after, .btn.btn-active-secondary:active:not(.btn-active).dropdown-toggle:after, .btn.btn-active-secondary.active.dropdown-toggle:after, .btn.btn-active-secondary.show.dropdown-toggle:after, .show > .btn.btn-active-secondary.dropdown-toggle:after {
  color: var(--bs-secondary-inverse);
}

.btn-check:checked + .btn.btn-active-light-secondary, .btn-check:active + .btn.btn-active-light-secondary, .btn.btn-active-light-secondary:focus:not(.btn-active), .btn.btn-active-light-secondary:hover:not(.btn-active), .btn.btn-active-light-secondary:active:not(.btn-active), .btn.btn-active-light-secondary.active, .btn.btn-active-light-secondary.show, .show > .btn.btn-active-light-secondary {
  color: var(--bs-secondary);
  border-color: var(--bs-secondary-light);
  background-color: var(--bs-secondary-light) !important;
}

.btn-check:checked + .btn.btn-active-light-secondary i,
.btn-check:checked + .btn.btn-active-light-secondary .svg-icon, .btn-check:active + .btn.btn-active-light-secondary i,
.btn-check:active + .btn.btn-active-light-secondary .svg-icon, .btn.btn-active-light-secondary:focus:not(.btn-active) i,
.btn.btn-active-light-secondary:focus:not(.btn-active) .svg-icon, .btn.btn-active-light-secondary:hover:not(.btn-active) i,
.btn.btn-active-light-secondary:hover:not(.btn-active) .svg-icon, .btn.btn-active-light-secondary:active:not(.btn-active) i,
.btn.btn-active-light-secondary:active:not(.btn-active) .svg-icon, .btn.btn-active-light-secondary.active i,
.btn.btn-active-light-secondary.active .svg-icon, .btn.btn-active-light-secondary.show i,
.btn.btn-active-light-secondary.show .svg-icon, .show > .btn.btn-active-light-secondary i,
.show > .btn.btn-active-light-secondary .svg-icon {
  color: var(--bs-secondary);
}

.btn-check:checked + .btn.btn-active-light-secondary.dropdown-toggle:after, .btn-check:active + .btn.btn-active-light-secondary.dropdown-toggle:after, .btn.btn-active-light-secondary:focus:not(.btn-active).dropdown-toggle:after, .btn.btn-active-light-secondary:hover:not(.btn-active).dropdown-toggle:after, .btn.btn-active-light-secondary:active:not(.btn-active).dropdown-toggle:after, .btn.btn-active-light-secondary.active.dropdown-toggle:after, .btn.btn-active-light-secondary.show.dropdown-toggle:after, .show > .btn.btn-active-light-secondary.dropdown-toggle:after {
  color: var(--bs-secondary);
}

.btn.btn-outline.btn-outline-secondary {
  color: var(--bs-secondary);
  border-color: var(--bs-secondary);
  background-color: transparent;
}

.btn.btn-outline.btn-outline-secondary i,
.btn.btn-outline.btn-outline-secondary .svg-icon {
  color: var(--bs-secondary);
}

.btn.btn-outline.btn-outline-secondary.dropdown-toggle:after {
  color: var(--bs-secondary);
}

.btn-check:checked + .btn.btn-outline.btn-outline-secondary, .btn-check:active + .btn.btn-outline.btn-outline-secondary, .btn.btn-outline.btn-outline-secondary:focus:not(.btn-active), .btn.btn-outline.btn-outline-secondary:hover:not(.btn-active), .btn.btn-outline.btn-outline-secondary:active:not(.btn-active), .btn.btn-outline.btn-outline-secondary.active, .btn.btn-outline.btn-outline-secondary.show, .show > .btn.btn-outline.btn-outline-secondary {
  color: var(--bs-secondary-active);
  border-color: var(--bs-secondary);
  background-color: var(--bs-secondary-light) !important;
}

.btn-check:checked + .btn.btn-outline.btn-outline-secondary i,
.btn-check:checked + .btn.btn-outline.btn-outline-secondary .svg-icon, .btn-check:active + .btn.btn-outline.btn-outline-secondary i,
.btn-check:active + .btn.btn-outline.btn-outline-secondary .svg-icon, .btn.btn-outline.btn-outline-secondary:focus:not(.btn-active) i,
.btn.btn-outline.btn-outline-secondary:focus:not(.btn-active) .svg-icon, .btn.btn-outline.btn-outline-secondary:hover:not(.btn-active) i,
.btn.btn-outline.btn-outline-secondary:hover:not(.btn-active) .svg-icon, .btn.btn-outline.btn-outline-secondary:active:not(.btn-active) i,
.btn.btn-outline.btn-outline-secondary:active:not(.btn-active) .svg-icon, .btn.btn-outline.btn-outline-secondary.active i,
.btn.btn-outline.btn-outline-secondary.active .svg-icon, .btn.btn-outline.btn-outline-secondary.show i,
.btn.btn-outline.btn-outline-secondary.show .svg-icon, .show > .btn.btn-outline.btn-outline-secondary i,
.show > .btn.btn-outline.btn-outline-secondary .svg-icon {
  color: var(--bs-secondary-active);
}

.btn-check:checked + .btn.btn-outline.btn-outline-secondary.dropdown-toggle:after, .btn-check:active + .btn.btn-outline.btn-outline-secondary.dropdown-toggle:after, .btn.btn-outline.btn-outline-secondary:focus:not(.btn-active).dropdown-toggle:after, .btn.btn-outline.btn-outline-secondary:hover:not(.btn-active).dropdown-toggle:after, .btn.btn-outline.btn-outline-secondary:active:not(.btn-active).dropdown-toggle:after, .btn.btn-outline.btn-outline-secondary.active.dropdown-toggle:after, .btn.btn-outline.btn-outline-secondary.show.dropdown-toggle:after, .show > .btn.btn-outline.btn-outline-secondary.dropdown-toggle:after {
  color: var(--bs-secondary-active);
}

.btn.btn-success {
  color: var(--bs-success-inverse);
  border-color: var(--bs-success);
  background-color: var(--bs-success);
}

.btn.btn-success i,
.btn.btn-success .svg-icon {
  color: var(--bs-success-inverse);
}

.btn.btn-success.dropdown-toggle:after {
  color: var(--bs-success-inverse);
}

.btn-check:checked + .btn.btn-success, .btn-check:active + .btn.btn-success, .btn.btn-success:focus:not(.btn-active), .btn.btn-success:hover:not(.btn-active), .btn.btn-success:active:not(.btn-active), .btn.btn-success.active, .btn.btn-success.show, .show > .btn.btn-success {
  color: var(--bs-success-inverse);
  border-color: var(--bs-success-active);
  background-color: var(--bs-success-active) !important;
}

.btn-check:checked + .btn.btn-success i,
.btn-check:checked + .btn.btn-success .svg-icon, .btn-check:active + .btn.btn-success i,
.btn-check:active + .btn.btn-success .svg-icon, .btn.btn-success:focus:not(.btn-active) i,
.btn.btn-success:focus:not(.btn-active) .svg-icon, .btn.btn-success:hover:not(.btn-active) i,
.btn.btn-success:hover:not(.btn-active) .svg-icon, .btn.btn-success:active:not(.btn-active) i,
.btn.btn-success:active:not(.btn-active) .svg-icon, .btn.btn-success.active i,
.btn.btn-success.active .svg-icon, .btn.btn-success.show i,
.btn.btn-success.show .svg-icon, .show > .btn.btn-success i,
.show > .btn.btn-success .svg-icon {
  color: var(--bs-success-inverse);
}

.btn-check:checked + .btn.btn-success.dropdown-toggle:after, .btn-check:active + .btn.btn-success.dropdown-toggle:after, .btn.btn-success:focus:not(.btn-active).dropdown-toggle:after, .btn.btn-success:hover:not(.btn-active).dropdown-toggle:after, .btn.btn-success:active:not(.btn-active).dropdown-toggle:after, .btn.btn-success.active.dropdown-toggle:after, .btn.btn-success.show.dropdown-toggle:after, .show > .btn.btn-success.dropdown-toggle:after {
  color: var(--bs-success-inverse);
}

.btn.btn-light-success {
  color: var(--bs-success);
  border-color: var(--bs-success-light);
  background-color: var(--bs-success-light);
}

.btn.btn-light-success i,
.btn.btn-light-success .svg-icon {
  color: var(--bs-success);
}

.btn.btn-light-success.dropdown-toggle:after {
  color: var(--bs-success);
}

.btn-check:checked + .btn.btn-light-success, .btn-check:active + .btn.btn-light-success, .btn.btn-light-success:focus:not(.btn-active), .btn.btn-light-success:hover:not(.btn-active), .btn.btn-light-success:active:not(.btn-active), .btn.btn-light-success.active, .btn.btn-light-success.show, .show > .btn.btn-light-success {
  color: var(--bs-success-inverse);
  border-color: var(--bs-success);
  background-color: var(--bs-success) !important;
}

.btn-check:checked + .btn.btn-light-success i,
.btn-check:checked + .btn.btn-light-success .svg-icon, .btn-check:active + .btn.btn-light-success i,
.btn-check:active + .btn.btn-light-success .svg-icon, .btn.btn-light-success:focus:not(.btn-active) i,
.btn.btn-light-success:focus:not(.btn-active) .svg-icon, .btn.btn-light-success:hover:not(.btn-active) i,
.btn.btn-light-success:hover:not(.btn-active) .svg-icon, .btn.btn-light-success:active:not(.btn-active) i,
.btn.btn-light-success:active:not(.btn-active) .svg-icon, .btn.btn-light-success.active i,
.btn.btn-light-success.active .svg-icon, .btn.btn-light-success.show i,
.btn.btn-light-success.show .svg-icon, .show > .btn.btn-light-success i,
.show > .btn.btn-light-success .svg-icon {
  color: var(--bs-success-inverse);
}

.btn-check:checked + .btn.btn-light-success.dropdown-toggle:after, .btn-check:active + .btn.btn-light-success.dropdown-toggle:after, .btn.btn-light-success:focus:not(.btn-active).dropdown-toggle:after, .btn.btn-light-success:hover:not(.btn-active).dropdown-toggle:after, .btn.btn-light-success:active:not(.btn-active).dropdown-toggle:after, .btn.btn-light-success.active.dropdown-toggle:after, .btn.btn-light-success.show.dropdown-toggle:after, .show > .btn.btn-light-success.dropdown-toggle:after {
  color: var(--bs-success-inverse);
}

.btn.btn-bg-success {
  border-color: var(--bs-success);
  background-color: var(--bs-success);
}

.btn-check:checked + .btn.btn-active-success, .btn-check:active + .btn.btn-active-success, .btn.btn-active-success:focus:not(.btn-active), .btn.btn-active-success:hover:not(.btn-active), .btn.btn-active-success:active:not(.btn-active), .btn.btn-active-success.active, .btn.btn-active-success.show, .show > .btn.btn-active-success {
  color: var(--bs-success-inverse);
  border-color: var(--bs-success);
  background-color: var(--bs-success) !important;
}

.btn-check:checked + .btn.btn-active-success i,
.btn-check:checked + .btn.btn-active-success .svg-icon, .btn-check:active + .btn.btn-active-success i,
.btn-check:active + .btn.btn-active-success .svg-icon, .btn.btn-active-success:focus:not(.btn-active) i,
.btn.btn-active-success:focus:not(.btn-active) .svg-icon, .btn.btn-active-success:hover:not(.btn-active) i,
.btn.btn-active-success:hover:not(.btn-active) .svg-icon, .btn.btn-active-success:active:not(.btn-active) i,
.btn.btn-active-success:active:not(.btn-active) .svg-icon, .btn.btn-active-success.active i,
.btn.btn-active-success.active .svg-icon, .btn.btn-active-success.show i,
.btn.btn-active-success.show .svg-icon, .show > .btn.btn-active-success i,
.show > .btn.btn-active-success .svg-icon {
  color: var(--bs-success-inverse);
}

.btn-check:checked + .btn.btn-active-success.dropdown-toggle:after, .btn-check:active + .btn.btn-active-success.dropdown-toggle:after, .btn.btn-active-success:focus:not(.btn-active).dropdown-toggle:after, .btn.btn-active-success:hover:not(.btn-active).dropdown-toggle:after, .btn.btn-active-success:active:not(.btn-active).dropdown-toggle:after, .btn.btn-active-success.active.dropdown-toggle:after, .btn.btn-active-success.show.dropdown-toggle:after, .show > .btn.btn-active-success.dropdown-toggle:after {
  color: var(--bs-success-inverse);
}

.btn-check:checked + .btn.btn-active-light-success, .btn-check:active + .btn.btn-active-light-success, .btn.btn-active-light-success:focus:not(.btn-active), .btn.btn-active-light-success:hover:not(.btn-active), .btn.btn-active-light-success:active:not(.btn-active), .btn.btn-active-light-success.active, .btn.btn-active-light-success.show, .show > .btn.btn-active-light-success {
  color: var(--bs-success);
  border-color: var(--bs-success-light);
  background-color: var(--bs-success-light) !important;
}

.btn-check:checked + .btn.btn-active-light-success i,
.btn-check:checked + .btn.btn-active-light-success .svg-icon, .btn-check:active + .btn.btn-active-light-success i,
.btn-check:active + .btn.btn-active-light-success .svg-icon, .btn.btn-active-light-success:focus:not(.btn-active) i,
.btn.btn-active-light-success:focus:not(.btn-active) .svg-icon, .btn.btn-active-light-success:hover:not(.btn-active) i,
.btn.btn-active-light-success:hover:not(.btn-active) .svg-icon, .btn.btn-active-light-success:active:not(.btn-active) i,
.btn.btn-active-light-success:active:not(.btn-active) .svg-icon, .btn.btn-active-light-success.active i,
.btn.btn-active-light-success.active .svg-icon, .btn.btn-active-light-success.show i,
.btn.btn-active-light-success.show .svg-icon, .show > .btn.btn-active-light-success i,
.show > .btn.btn-active-light-success .svg-icon {
  color: var(--bs-success);
}

.btn-check:checked + .btn.btn-active-light-success.dropdown-toggle:after, .btn-check:active + .btn.btn-active-light-success.dropdown-toggle:after, .btn.btn-active-light-success:focus:not(.btn-active).dropdown-toggle:after, .btn.btn-active-light-success:hover:not(.btn-active).dropdown-toggle:after, .btn.btn-active-light-success:active:not(.btn-active).dropdown-toggle:after, .btn.btn-active-light-success.active.dropdown-toggle:after, .btn.btn-active-light-success.show.dropdown-toggle:after, .show > .btn.btn-active-light-success.dropdown-toggle:after {
  color: var(--bs-success);
}

.btn.btn-outline.btn-outline-success {
  color: var(--bs-success);
  border-color: var(--bs-success);
  background-color: transparent;
}

.btn.btn-outline.btn-outline-success i,
.btn.btn-outline.btn-outline-success .svg-icon {
  color: var(--bs-success);
}

.btn.btn-outline.btn-outline-success.dropdown-toggle:after {
  color: var(--bs-success);
}

.btn-check:checked + .btn.btn-outline.btn-outline-success, .btn-check:active + .btn.btn-outline.btn-outline-success, .btn.btn-outline.btn-outline-success:focus:not(.btn-active), .btn.btn-outline.btn-outline-success:hover:not(.btn-active), .btn.btn-outline.btn-outline-success:active:not(.btn-active), .btn.btn-outline.btn-outline-success.active, .btn.btn-outline.btn-outline-success.show, .show > .btn.btn-outline.btn-outline-success {
  color: var(--bs-success-active);
  border-color: var(--bs-success);
  background-color: var(--bs-success-light) !important;
}

.btn-check:checked + .btn.btn-outline.btn-outline-success i,
.btn-check:checked + .btn.btn-outline.btn-outline-success .svg-icon, .btn-check:active + .btn.btn-outline.btn-outline-success i,
.btn-check:active + .btn.btn-outline.btn-outline-success .svg-icon, .btn.btn-outline.btn-outline-success:focus:not(.btn-active) i,
.btn.btn-outline.btn-outline-success:focus:not(.btn-active) .svg-icon, .btn.btn-outline.btn-outline-success:hover:not(.btn-active) i,
.btn.btn-outline.btn-outline-success:hover:not(.btn-active) .svg-icon, .btn.btn-outline.btn-outline-success:active:not(.btn-active) i,
.btn.btn-outline.btn-outline-success:active:not(.btn-active) .svg-icon, .btn.btn-outline.btn-outline-success.active i,
.btn.btn-outline.btn-outline-success.active .svg-icon, .btn.btn-outline.btn-outline-success.show i,
.btn.btn-outline.btn-outline-success.show .svg-icon, .show > .btn.btn-outline.btn-outline-success i,
.show > .btn.btn-outline.btn-outline-success .svg-icon {
  color: var(--bs-success-active);
}

.btn-check:checked + .btn.btn-outline.btn-outline-success.dropdown-toggle:after, .btn-check:active + .btn.btn-outline.btn-outline-success.dropdown-toggle:after, .btn.btn-outline.btn-outline-success:focus:not(.btn-active).dropdown-toggle:after, .btn.btn-outline.btn-outline-success:hover:not(.btn-active).dropdown-toggle:after, .btn.btn-outline.btn-outline-success:active:not(.btn-active).dropdown-toggle:after, .btn.btn-outline.btn-outline-success.active.dropdown-toggle:after, .btn.btn-outline.btn-outline-success.show.dropdown-toggle:after, .show > .btn.btn-outline.btn-outline-success.dropdown-toggle:after {
  color: var(--bs-success-active);
}

.btn.btn-info {
  color: var(--bs-info-inverse);
  border-color: var(--bs-info);
  background-color: var(--bs-info);
}

.btn.btn-info i,
.btn.btn-info .svg-icon {
  color: var(--bs-info-inverse);
}

.btn.btn-info.dropdown-toggle:after {
  color: var(--bs-info-inverse);
}

.btn-check:checked + .btn.btn-info, .btn-check:active + .btn.btn-info, .btn.btn-info:focus:not(.btn-active), .btn.btn-info:hover:not(.btn-active), .btn.btn-info:active:not(.btn-active), .btn.btn-info.active, .btn.btn-info.show, .show > .btn.btn-info {
  color: var(--bs-info-inverse);
  border-color: var(--bs-info-active);
  background-color: var(--bs-info-active) !important;
}

.btn-check:checked + .btn.btn-info i,
.btn-check:checked + .btn.btn-info .svg-icon, .btn-check:active + .btn.btn-info i,
.btn-check:active + .btn.btn-info .svg-icon, .btn.btn-info:focus:not(.btn-active) i,
.btn.btn-info:focus:not(.btn-active) .svg-icon, .btn.btn-info:hover:not(.btn-active) i,
.btn.btn-info:hover:not(.btn-active) .svg-icon, .btn.btn-info:active:not(.btn-active) i,
.btn.btn-info:active:not(.btn-active) .svg-icon, .btn.btn-info.active i,
.btn.btn-info.active .svg-icon, .btn.btn-info.show i,
.btn.btn-info.show .svg-icon, .show > .btn.btn-info i,
.show > .btn.btn-info .svg-icon {
  color: var(--bs-info-inverse);
}

.btn-check:checked + .btn.btn-info.dropdown-toggle:after, .btn-check:active + .btn.btn-info.dropdown-toggle:after, .btn.btn-info:focus:not(.btn-active).dropdown-toggle:after, .btn.btn-info:hover:not(.btn-active).dropdown-toggle:after, .btn.btn-info:active:not(.btn-active).dropdown-toggle:after, .btn.btn-info.active.dropdown-toggle:after, .btn.btn-info.show.dropdown-toggle:after, .show > .btn.btn-info.dropdown-toggle:after {
  color: var(--bs-info-inverse);
}

.btn.btn-light-info {
  color: var(--bs-info);
  border-color: var(--bs-info-light);
  background-color: var(--bs-info-light);
}

.btn.btn-light-info i,
.btn.btn-light-info .svg-icon {
  color: var(--bs-info);
}

.btn.btn-light-info.dropdown-toggle:after {
  color: var(--bs-info);
}

.btn-check:checked + .btn.btn-light-info, .btn-check:active + .btn.btn-light-info, .btn.btn-light-info:focus:not(.btn-active), .btn.btn-light-info:hover:not(.btn-active), .btn.btn-light-info:active:not(.btn-active), .btn.btn-light-info.active, .btn.btn-light-info.show, .show > .btn.btn-light-info {
  color: var(--bs-info-inverse);
  border-color: var(--bs-info);
  background-color: var(--bs-info) !important;
}

.btn-check:checked + .btn.btn-light-info i,
.btn-check:checked + .btn.btn-light-info .svg-icon, .btn-check:active + .btn.btn-light-info i,
.btn-check:active + .btn.btn-light-info .svg-icon, .btn.btn-light-info:focus:not(.btn-active) i,
.btn.btn-light-info:focus:not(.btn-active) .svg-icon, .btn.btn-light-info:hover:not(.btn-active) i,
.btn.btn-light-info:hover:not(.btn-active) .svg-icon, .btn.btn-light-info:active:not(.btn-active) i,
.btn.btn-light-info:active:not(.btn-active) .svg-icon, .btn.btn-light-info.active i,
.btn.btn-light-info.active .svg-icon, .btn.btn-light-info.show i,
.btn.btn-light-info.show .svg-icon, .show > .btn.btn-light-info i,
.show > .btn.btn-light-info .svg-icon {
  color: var(--bs-info-inverse);
}

.btn-check:checked + .btn.btn-light-info.dropdown-toggle:after, .btn-check:active + .btn.btn-light-info.dropdown-toggle:after, .btn.btn-light-info:focus:not(.btn-active).dropdown-toggle:after, .btn.btn-light-info:hover:not(.btn-active).dropdown-toggle:after, .btn.btn-light-info:active:not(.btn-active).dropdown-toggle:after, .btn.btn-light-info.active.dropdown-toggle:after, .btn.btn-light-info.show.dropdown-toggle:after, .show > .btn.btn-light-info.dropdown-toggle:after {
  color: var(--bs-info-inverse);
}

.btn.btn-bg-info {
  border-color: var(--bs-info);
  background-color: var(--bs-info);
}

.btn-check:checked + .btn.btn-active-info, .btn-check:active + .btn.btn-active-info, .btn.btn-active-info:focus:not(.btn-active), .btn.btn-active-info:hover:not(.btn-active), .btn.btn-active-info:active:not(.btn-active), .btn.btn-active-info.active, .btn.btn-active-info.show, .show > .btn.btn-active-info {
  color: var(--bs-info-inverse);
  border-color: var(--bs-info);
  background-color: var(--bs-info) !important;
}

.btn-check:checked + .btn.btn-active-info i,
.btn-check:checked + .btn.btn-active-info .svg-icon, .btn-check:active + .btn.btn-active-info i,
.btn-check:active + .btn.btn-active-info .svg-icon, .btn.btn-active-info:focus:not(.btn-active) i,
.btn.btn-active-info:focus:not(.btn-active) .svg-icon, .btn.btn-active-info:hover:not(.btn-active) i,
.btn.btn-active-info:hover:not(.btn-active) .svg-icon, .btn.btn-active-info:active:not(.btn-active) i,
.btn.btn-active-info:active:not(.btn-active) .svg-icon, .btn.btn-active-info.active i,
.btn.btn-active-info.active .svg-icon, .btn.btn-active-info.show i,
.btn.btn-active-info.show .svg-icon, .show > .btn.btn-active-info i,
.show > .btn.btn-active-info .svg-icon {
  color: var(--bs-info-inverse);
}

.btn-check:checked + .btn.btn-active-info.dropdown-toggle:after, .btn-check:active + .btn.btn-active-info.dropdown-toggle:after, .btn.btn-active-info:focus:not(.btn-active).dropdown-toggle:after, .btn.btn-active-info:hover:not(.btn-active).dropdown-toggle:after, .btn.btn-active-info:active:not(.btn-active).dropdown-toggle:after, .btn.btn-active-info.active.dropdown-toggle:after, .btn.btn-active-info.show.dropdown-toggle:after, .show > .btn.btn-active-info.dropdown-toggle:after {
  color: var(--bs-info-inverse);
}

.btn-check:checked + .btn.btn-active-light-info, .btn-check:active + .btn.btn-active-light-info, .btn.btn-active-light-info:focus:not(.btn-active), .btn.btn-active-light-info:hover:not(.btn-active), .btn.btn-active-light-info:active:not(.btn-active), .btn.btn-active-light-info.active, .btn.btn-active-light-info.show, .show > .btn.btn-active-light-info {
  color: var(--bs-info);
  border-color: var(--bs-info-light);
  background-color: var(--bs-info-light) !important;
}

.btn-check:checked + .btn.btn-active-light-info i,
.btn-check:checked + .btn.btn-active-light-info .svg-icon, .btn-check:active + .btn.btn-active-light-info i,
.btn-check:active + .btn.btn-active-light-info .svg-icon, .btn.btn-active-light-info:focus:not(.btn-active) i,
.btn.btn-active-light-info:focus:not(.btn-active) .svg-icon, .btn.btn-active-light-info:hover:not(.btn-active) i,
.btn.btn-active-light-info:hover:not(.btn-active) .svg-icon, .btn.btn-active-light-info:active:not(.btn-active) i,
.btn.btn-active-light-info:active:not(.btn-active) .svg-icon, .btn.btn-active-light-info.active i,
.btn.btn-active-light-info.active .svg-icon, .btn.btn-active-light-info.show i,
.btn.btn-active-light-info.show .svg-icon, .show > .btn.btn-active-light-info i,
.show > .btn.btn-active-light-info .svg-icon {
  color: var(--bs-info);
}

.btn-check:checked + .btn.btn-active-light-info.dropdown-toggle:after, .btn-check:active + .btn.btn-active-light-info.dropdown-toggle:after, .btn.btn-active-light-info:focus:not(.btn-active).dropdown-toggle:after, .btn.btn-active-light-info:hover:not(.btn-active).dropdown-toggle:after, .btn.btn-active-light-info:active:not(.btn-active).dropdown-toggle:after, .btn.btn-active-light-info.active.dropdown-toggle:after, .btn.btn-active-light-info.show.dropdown-toggle:after, .show > .btn.btn-active-light-info.dropdown-toggle:after {
  color: var(--bs-info);
}

.btn.btn-outline.btn-outline-info {
  color: var(--bs-info);
  border-color: var(--bs-info);
  background-color: transparent;
}

.btn.btn-outline.btn-outline-info i,
.btn.btn-outline.btn-outline-info .svg-icon {
  color: var(--bs-info);
}

.btn.btn-outline.btn-outline-info.dropdown-toggle:after {
  color: var(--bs-info);
}

.btn-check:checked + .btn.btn-outline.btn-outline-info, .btn-check:active + .btn.btn-outline.btn-outline-info, .btn.btn-outline.btn-outline-info:focus:not(.btn-active), .btn.btn-outline.btn-outline-info:hover:not(.btn-active), .btn.btn-outline.btn-outline-info:active:not(.btn-active), .btn.btn-outline.btn-outline-info.active, .btn.btn-outline.btn-outline-info.show, .show > .btn.btn-outline.btn-outline-info {
  color: var(--bs-info-active);
  border-color: var(--bs-info);
  background-color: var(--bs-info-light) !important;
}

.btn-check:checked + .btn.btn-outline.btn-outline-info i,
.btn-check:checked + .btn.btn-outline.btn-outline-info .svg-icon, .btn-check:active + .btn.btn-outline.btn-outline-info i,
.btn-check:active + .btn.btn-outline.btn-outline-info .svg-icon, .btn.btn-outline.btn-outline-info:focus:not(.btn-active) i,
.btn.btn-outline.btn-outline-info:focus:not(.btn-active) .svg-icon, .btn.btn-outline.btn-outline-info:hover:not(.btn-active) i,
.btn.btn-outline.btn-outline-info:hover:not(.btn-active) .svg-icon, .btn.btn-outline.btn-outline-info:active:not(.btn-active) i,
.btn.btn-outline.btn-outline-info:active:not(.btn-active) .svg-icon, .btn.btn-outline.btn-outline-info.active i,
.btn.btn-outline.btn-outline-info.active .svg-icon, .btn.btn-outline.btn-outline-info.show i,
.btn.btn-outline.btn-outline-info.show .svg-icon, .show > .btn.btn-outline.btn-outline-info i,
.show > .btn.btn-outline.btn-outline-info .svg-icon {
  color: var(--bs-info-active);
}

.btn-check:checked + .btn.btn-outline.btn-outline-info.dropdown-toggle:after, .btn-check:active + .btn.btn-outline.btn-outline-info.dropdown-toggle:after, .btn.btn-outline.btn-outline-info:focus:not(.btn-active).dropdown-toggle:after, .btn.btn-outline.btn-outline-info:hover:not(.btn-active).dropdown-toggle:after, .btn.btn-outline.btn-outline-info:active:not(.btn-active).dropdown-toggle:after, .btn.btn-outline.btn-outline-info.active.dropdown-toggle:after, .btn.btn-outline.btn-outline-info.show.dropdown-toggle:after, .show > .btn.btn-outline.btn-outline-info.dropdown-toggle:after {
  color: var(--bs-info-active);
}

.btn.btn-warning {
  color: var(--bs-warning-inverse);
  border-color: var(--bs-warning);
  background-color: var(--bs-warning);
}

.btn.btn-warning i,
.btn.btn-warning .svg-icon {
  color: var(--bs-warning-inverse);
}

.btn.btn-warning.dropdown-toggle:after {
  color: var(--bs-warning-inverse);
}

.btn-check:checked + .btn.btn-warning, .btn-check:active + .btn.btn-warning, .btn.btn-warning:focus:not(.btn-active), .btn.btn-warning:hover:not(.btn-active), .btn.btn-warning:active:not(.btn-active), .btn.btn-warning.active, .btn.btn-warning.show, .show > .btn.btn-warning {
  color: var(--bs-warning-inverse);
  border-color: var(--bs-warning-active);
  background-color: var(--bs-warning-active) !important;
}

.btn-check:checked + .btn.btn-warning i,
.btn-check:checked + .btn.btn-warning .svg-icon, .btn-check:active + .btn.btn-warning i,
.btn-check:active + .btn.btn-warning .svg-icon, .btn.btn-warning:focus:not(.btn-active) i,
.btn.btn-warning:focus:not(.btn-active) .svg-icon, .btn.btn-warning:hover:not(.btn-active) i,
.btn.btn-warning:hover:not(.btn-active) .svg-icon, .btn.btn-warning:active:not(.btn-active) i,
.btn.btn-warning:active:not(.btn-active) .svg-icon, .btn.btn-warning.active i,
.btn.btn-warning.active .svg-icon, .btn.btn-warning.show i,
.btn.btn-warning.show .svg-icon, .show > .btn.btn-warning i,
.show > .btn.btn-warning .svg-icon {
  color: var(--bs-warning-inverse);
}

.btn-check:checked + .btn.btn-warning.dropdown-toggle:after, .btn-check:active + .btn.btn-warning.dropdown-toggle:after, .btn.btn-warning:focus:not(.btn-active).dropdown-toggle:after, .btn.btn-warning:hover:not(.btn-active).dropdown-toggle:after, .btn.btn-warning:active:not(.btn-active).dropdown-toggle:after, .btn.btn-warning.active.dropdown-toggle:after, .btn.btn-warning.show.dropdown-toggle:after, .show > .btn.btn-warning.dropdown-toggle:after {
  color: var(--bs-warning-inverse);
}

.btn.btn-light-warning {
  color: var(--bs-warning);
  border-color: var(--bs-warning-light);
  background-color: var(--bs-warning-light);
}

.btn.btn-light-warning i,
.btn.btn-light-warning .svg-icon {
  color: var(--bs-warning);
}

.btn.btn-light-warning.dropdown-toggle:after {
  color: var(--bs-warning);
}

.btn-check:checked + .btn.btn-light-warning, .btn-check:active + .btn.btn-light-warning, .btn.btn-light-warning:focus:not(.btn-active), .btn.btn-light-warning:hover:not(.btn-active), .btn.btn-light-warning:active:not(.btn-active), .btn.btn-light-warning.active, .btn.btn-light-warning.show, .show > .btn.btn-light-warning {
  color: var(--bs-warning-inverse);
  border-color: var(--bs-warning);
  background-color: var(--bs-warning) !important;
}

.btn-check:checked + .btn.btn-light-warning i,
.btn-check:checked + .btn.btn-light-warning .svg-icon, .btn-check:active + .btn.btn-light-warning i,
.btn-check:active + .btn.btn-light-warning .svg-icon, .btn.btn-light-warning:focus:not(.btn-active) i,
.btn.btn-light-warning:focus:not(.btn-active) .svg-icon, .btn.btn-light-warning:hover:not(.btn-active) i,
.btn.btn-light-warning:hover:not(.btn-active) .svg-icon, .btn.btn-light-warning:active:not(.btn-active) i,
.btn.btn-light-warning:active:not(.btn-active) .svg-icon, .btn.btn-light-warning.active i,
.btn.btn-light-warning.active .svg-icon, .btn.btn-light-warning.show i,
.btn.btn-light-warning.show .svg-icon, .show > .btn.btn-light-warning i,
.show > .btn.btn-light-warning .svg-icon {
  color: var(--bs-warning-inverse);
}

.btn-check:checked + .btn.btn-light-warning.dropdown-toggle:after, .btn-check:active + .btn.btn-light-warning.dropdown-toggle:after, .btn.btn-light-warning:focus:not(.btn-active).dropdown-toggle:after, .btn.btn-light-warning:hover:not(.btn-active).dropdown-toggle:after, .btn.btn-light-warning:active:not(.btn-active).dropdown-toggle:after, .btn.btn-light-warning.active.dropdown-toggle:after, .btn.btn-light-warning.show.dropdown-toggle:after, .show > .btn.btn-light-warning.dropdown-toggle:after {
  color: var(--bs-warning-inverse);
}

.btn.btn-bg-warning {
  border-color: var(--bs-warning);
  background-color: var(--bs-warning);
}

.btn-check:checked + .btn.btn-active-warning, .btn-check:active + .btn.btn-active-warning, .btn.btn-active-warning:focus:not(.btn-active), .btn.btn-active-warning:hover:not(.btn-active), .btn.btn-active-warning:active:not(.btn-active), .btn.btn-active-warning.active, .btn.btn-active-warning.show, .show > .btn.btn-active-warning {
  color: var(--bs-warning-inverse);
  border-color: var(--bs-warning);
  background-color: var(--bs-warning) !important;
}

.btn-check:checked + .btn.btn-active-warning i,
.btn-check:checked + .btn.btn-active-warning .svg-icon, .btn-check:active + .btn.btn-active-warning i,
.btn-check:active + .btn.btn-active-warning .svg-icon, .btn.btn-active-warning:focus:not(.btn-active) i,
.btn.btn-active-warning:focus:not(.btn-active) .svg-icon, .btn.btn-active-warning:hover:not(.btn-active) i,
.btn.btn-active-warning:hover:not(.btn-active) .svg-icon, .btn.btn-active-warning:active:not(.btn-active) i,
.btn.btn-active-warning:active:not(.btn-active) .svg-icon, .btn.btn-active-warning.active i,
.btn.btn-active-warning.active .svg-icon, .btn.btn-active-warning.show i,
.btn.btn-active-warning.show .svg-icon, .show > .btn.btn-active-warning i,
.show > .btn.btn-active-warning .svg-icon {
  color: var(--bs-warning-inverse);
}

.btn-check:checked + .btn.btn-active-warning.dropdown-toggle:after, .btn-check:active + .btn.btn-active-warning.dropdown-toggle:after, .btn.btn-active-warning:focus:not(.btn-active).dropdown-toggle:after, .btn.btn-active-warning:hover:not(.btn-active).dropdown-toggle:after, .btn.btn-active-warning:active:not(.btn-active).dropdown-toggle:after, .btn.btn-active-warning.active.dropdown-toggle:after, .btn.btn-active-warning.show.dropdown-toggle:after, .show > .btn.btn-active-warning.dropdown-toggle:after {
  color: var(--bs-warning-inverse);
}

.btn-check:checked + .btn.btn-active-light-warning, .btn-check:active + .btn.btn-active-light-warning, .btn.btn-active-light-warning:focus:not(.btn-active), .btn.btn-active-light-warning:hover:not(.btn-active), .btn.btn-active-light-warning:active:not(.btn-active), .btn.btn-active-light-warning.active, .btn.btn-active-light-warning.show, .show > .btn.btn-active-light-warning {
  color: var(--bs-warning);
  border-color: var(--bs-warning-light);
  background-color: var(--bs-warning-light) !important;
}

.btn-check:checked + .btn.btn-active-light-warning i,
.btn-check:checked + .btn.btn-active-light-warning .svg-icon, .btn-check:active + .btn.btn-active-light-warning i,
.btn-check:active + .btn.btn-active-light-warning .svg-icon, .btn.btn-active-light-warning:focus:not(.btn-active) i,
.btn.btn-active-light-warning:focus:not(.btn-active) .svg-icon, .btn.btn-active-light-warning:hover:not(.btn-active) i,
.btn.btn-active-light-warning:hover:not(.btn-active) .svg-icon, .btn.btn-active-light-warning:active:not(.btn-active) i,
.btn.btn-active-light-warning:active:not(.btn-active) .svg-icon, .btn.btn-active-light-warning.active i,
.btn.btn-active-light-warning.active .svg-icon, .btn.btn-active-light-warning.show i,
.btn.btn-active-light-warning.show .svg-icon, .show > .btn.btn-active-light-warning i,
.show > .btn.btn-active-light-warning .svg-icon {
  color: var(--bs-warning);
}

.btn-check:checked + .btn.btn-active-light-warning.dropdown-toggle:after, .btn-check:active + .btn.btn-active-light-warning.dropdown-toggle:after, .btn.btn-active-light-warning:focus:not(.btn-active).dropdown-toggle:after, .btn.btn-active-light-warning:hover:not(.btn-active).dropdown-toggle:after, .btn.btn-active-light-warning:active:not(.btn-active).dropdown-toggle:after, .btn.btn-active-light-warning.active.dropdown-toggle:after, .btn.btn-active-light-warning.show.dropdown-toggle:after, .show > .btn.btn-active-light-warning.dropdown-toggle:after {
  color: var(--bs-warning);
}

.btn.btn-outline.btn-outline-warning {
  color: var(--bs-warning);
  border-color: var(--bs-warning);
  background-color: transparent;
}

.btn.btn-outline.btn-outline-warning i,
.btn.btn-outline.btn-outline-warning .svg-icon {
  color: var(--bs-warning);
}

.btn.btn-outline.btn-outline-warning.dropdown-toggle:after {
  color: var(--bs-warning);
}

.btn-check:checked + .btn.btn-outline.btn-outline-warning, .btn-check:active + .btn.btn-outline.btn-outline-warning, .btn.btn-outline.btn-outline-warning:focus:not(.btn-active), .btn.btn-outline.btn-outline-warning:hover:not(.btn-active), .btn.btn-outline.btn-outline-warning:active:not(.btn-active), .btn.btn-outline.btn-outline-warning.active, .btn.btn-outline.btn-outline-warning.show, .show > .btn.btn-outline.btn-outline-warning {
  color: var(--bs-warning-active);
  border-color: var(--bs-warning);
  background-color: var(--bs-warning-light) !important;
}

.btn-check:checked + .btn.btn-outline.btn-outline-warning i,
.btn-check:checked + .btn.btn-outline.btn-outline-warning .svg-icon, .btn-check:active + .btn.btn-outline.btn-outline-warning i,
.btn-check:active + .btn.btn-outline.btn-outline-warning .svg-icon, .btn.btn-outline.btn-outline-warning:focus:not(.btn-active) i,
.btn.btn-outline.btn-outline-warning:focus:not(.btn-active) .svg-icon, .btn.btn-outline.btn-outline-warning:hover:not(.btn-active) i,
.btn.btn-outline.btn-outline-warning:hover:not(.btn-active) .svg-icon, .btn.btn-outline.btn-outline-warning:active:not(.btn-active) i,
.btn.btn-outline.btn-outline-warning:active:not(.btn-active) .svg-icon, .btn.btn-outline.btn-outline-warning.active i,
.btn.btn-outline.btn-outline-warning.active .svg-icon, .btn.btn-outline.btn-outline-warning.show i,
.btn.btn-outline.btn-outline-warning.show .svg-icon, .show > .btn.btn-outline.btn-outline-warning i,
.show > .btn.btn-outline.btn-outline-warning .svg-icon {
  color: var(--bs-warning-active);
}

.btn-check:checked + .btn.btn-outline.btn-outline-warning.dropdown-toggle:after, .btn-check:active + .btn.btn-outline.btn-outline-warning.dropdown-toggle:after, .btn.btn-outline.btn-outline-warning:focus:not(.btn-active).dropdown-toggle:after, .btn.btn-outline.btn-outline-warning:hover:not(.btn-active).dropdown-toggle:after, .btn.btn-outline.btn-outline-warning:active:not(.btn-active).dropdown-toggle:after, .btn.btn-outline.btn-outline-warning.active.dropdown-toggle:after, .btn.btn-outline.btn-outline-warning.show.dropdown-toggle:after, .show > .btn.btn-outline.btn-outline-warning.dropdown-toggle:after {
  color: var(--bs-warning-active);
}

.btn.btn-danger {
  color: var(--bs-danger-inverse);
  border-color: var(--bs-danger);
  background-color: var(--bs-danger);
}

.btn.btn-danger i,
.btn.btn-danger .svg-icon {
  color: var(--bs-danger-inverse);
}

.btn.btn-danger.dropdown-toggle:after {
  color: var(--bs-danger-inverse);
}

.btn-check:checked + .btn.btn-danger, .btn-check:active + .btn.btn-danger, .btn.btn-danger:focus:not(.btn-active), .btn.btn-danger:hover:not(.btn-active), .btn.btn-danger:active:not(.btn-active), .btn.btn-danger.active, .btn.btn-danger.show, .show > .btn.btn-danger {
  color: var(--bs-danger-inverse);
  border-color: var(--bs-danger-active);
  background-color: var(--bs-danger-active) !important;
}

.btn-check:checked + .btn.btn-danger i,
.btn-check:checked + .btn.btn-danger .svg-icon, .btn-check:active + .btn.btn-danger i,
.btn-check:active + .btn.btn-danger .svg-icon, .btn.btn-danger:focus:not(.btn-active) i,
.btn.btn-danger:focus:not(.btn-active) .svg-icon, .btn.btn-danger:hover:not(.btn-active) i,
.btn.btn-danger:hover:not(.btn-active) .svg-icon, .btn.btn-danger:active:not(.btn-active) i,
.btn.btn-danger:active:not(.btn-active) .svg-icon, .btn.btn-danger.active i,
.btn.btn-danger.active .svg-icon, .btn.btn-danger.show i,
.btn.btn-danger.show .svg-icon, .show > .btn.btn-danger i,
.show > .btn.btn-danger .svg-icon {
  color: var(--bs-danger-inverse);
}

.btn-check:checked + .btn.btn-danger.dropdown-toggle:after, .btn-check:active + .btn.btn-danger.dropdown-toggle:after, .btn.btn-danger:focus:not(.btn-active).dropdown-toggle:after, .btn.btn-danger:hover:not(.btn-active).dropdown-toggle:after, .btn.btn-danger:active:not(.btn-active).dropdown-toggle:after, .btn.btn-danger.active.dropdown-toggle:after, .btn.btn-danger.show.dropdown-toggle:after, .show > .btn.btn-danger.dropdown-toggle:after {
  color: var(--bs-danger-inverse);
}

.btn.btn-light-danger {
  color: var(--bs-danger);
  border-color: var(--bs-danger-light);
  background-color: var(--bs-danger-light);
}

.btn.btn-light-danger i,
.btn.btn-light-danger .svg-icon {
  color: var(--bs-danger);
}

.btn.btn-light-danger.dropdown-toggle:after {
  color: var(--bs-danger);
}

.btn-check:checked + .btn.btn-light-danger, .btn-check:active + .btn.btn-light-danger, .btn.btn-light-danger:focus:not(.btn-active), .btn.btn-light-danger:hover:not(.btn-active), .btn.btn-light-danger:active:not(.btn-active), .btn.btn-light-danger.active, .btn.btn-light-danger.show, .show > .btn.btn-light-danger {
  color: var(--bs-danger-inverse);
  border-color: var(--bs-danger);
  background-color: var(--bs-danger) !important;
}

.btn-check:checked + .btn.btn-light-danger i,
.btn-check:checked + .btn.btn-light-danger .svg-icon, .btn-check:active + .btn.btn-light-danger i,
.btn-check:active + .btn.btn-light-danger .svg-icon, .btn.btn-light-danger:focus:not(.btn-active) i,
.btn.btn-light-danger:focus:not(.btn-active) .svg-icon, .btn.btn-light-danger:hover:not(.btn-active) i,
.btn.btn-light-danger:hover:not(.btn-active) .svg-icon, .btn.btn-light-danger:active:not(.btn-active) i,
.btn.btn-light-danger:active:not(.btn-active) .svg-icon, .btn.btn-light-danger.active i,
.btn.btn-light-danger.active .svg-icon, .btn.btn-light-danger.show i,
.btn.btn-light-danger.show .svg-icon, .show > .btn.btn-light-danger i,
.show > .btn.btn-light-danger .svg-icon {
  color: var(--bs-danger-inverse);
}

.btn-check:checked + .btn.btn-light-danger.dropdown-toggle:after, .btn-check:active + .btn.btn-light-danger.dropdown-toggle:after, .btn.btn-light-danger:focus:not(.btn-active).dropdown-toggle:after, .btn.btn-light-danger:hover:not(.btn-active).dropdown-toggle:after, .btn.btn-light-danger:active:not(.btn-active).dropdown-toggle:after, .btn.btn-light-danger.active.dropdown-toggle:after, .btn.btn-light-danger.show.dropdown-toggle:after, .show > .btn.btn-light-danger.dropdown-toggle:after {
  color: var(--bs-danger-inverse);
}

.btn.btn-bg-danger {
  border-color: var(--bs-danger);
  background-color: var(--bs-danger);
}

.btn-check:checked + .btn.btn-active-danger, .btn-check:active + .btn.btn-active-danger, .btn.btn-active-danger:focus:not(.btn-active), .btn.btn-active-danger:hover:not(.btn-active), .btn.btn-active-danger:active:not(.btn-active), .btn.btn-active-danger.active, .btn.btn-active-danger.show, .show > .btn.btn-active-danger {
  color: var(--bs-danger-inverse);
  border-color: var(--bs-danger);
  background-color: var(--bs-danger) !important;
}

.btn-check:checked + .btn.btn-active-danger i,
.btn-check:checked + .btn.btn-active-danger .svg-icon, .btn-check:active + .btn.btn-active-danger i,
.btn-check:active + .btn.btn-active-danger .svg-icon, .btn.btn-active-danger:focus:not(.btn-active) i,
.btn.btn-active-danger:focus:not(.btn-active) .svg-icon, .btn.btn-active-danger:hover:not(.btn-active) i,
.btn.btn-active-danger:hover:not(.btn-active) .svg-icon, .btn.btn-active-danger:active:not(.btn-active) i,
.btn.btn-active-danger:active:not(.btn-active) .svg-icon, .btn.btn-active-danger.active i,
.btn.btn-active-danger.active .svg-icon, .btn.btn-active-danger.show i,
.btn.btn-active-danger.show .svg-icon, .show > .btn.btn-active-danger i,
.show > .btn.btn-active-danger .svg-icon {
  color: var(--bs-danger-inverse);
}

.btn-check:checked + .btn.btn-active-danger.dropdown-toggle:after, .btn-check:active + .btn.btn-active-danger.dropdown-toggle:after, .btn.btn-active-danger:focus:not(.btn-active).dropdown-toggle:after, .btn.btn-active-danger:hover:not(.btn-active).dropdown-toggle:after, .btn.btn-active-danger:active:not(.btn-active).dropdown-toggle:after, .btn.btn-active-danger.active.dropdown-toggle:after, .btn.btn-active-danger.show.dropdown-toggle:after, .show > .btn.btn-active-danger.dropdown-toggle:after {
  color: var(--bs-danger-inverse);
}

.btn-check:checked + .btn.btn-active-light-danger, .btn-check:active + .btn.btn-active-light-danger, .btn.btn-active-light-danger:focus:not(.btn-active), .btn.btn-active-light-danger:hover:not(.btn-active), .btn.btn-active-light-danger:active:not(.btn-active), .btn.btn-active-light-danger.active, .btn.btn-active-light-danger.show, .show > .btn.btn-active-light-danger {
  color: var(--bs-danger);
  border-color: var(--bs-danger-light);
  background-color: var(--bs-danger-light) !important;
}

.btn-check:checked + .btn.btn-active-light-danger i,
.btn-check:checked + .btn.btn-active-light-danger .svg-icon, .btn-check:active + .btn.btn-active-light-danger i,
.btn-check:active + .btn.btn-active-light-danger .svg-icon, .btn.btn-active-light-danger:focus:not(.btn-active) i,
.btn.btn-active-light-danger:focus:not(.btn-active) .svg-icon, .btn.btn-active-light-danger:hover:not(.btn-active) i,
.btn.btn-active-light-danger:hover:not(.btn-active) .svg-icon, .btn.btn-active-light-danger:active:not(.btn-active) i,
.btn.btn-active-light-danger:active:not(.btn-active) .svg-icon, .btn.btn-active-light-danger.active i,
.btn.btn-active-light-danger.active .svg-icon, .btn.btn-active-light-danger.show i,
.btn.btn-active-light-danger.show .svg-icon, .show > .btn.btn-active-light-danger i,
.show > .btn.btn-active-light-danger .svg-icon {
  color: var(--bs-danger);
}

.btn-check:checked + .btn.btn-active-light-danger.dropdown-toggle:after, .btn-check:active + .btn.btn-active-light-danger.dropdown-toggle:after, .btn.btn-active-light-danger:focus:not(.btn-active).dropdown-toggle:after, .btn.btn-active-light-danger:hover:not(.btn-active).dropdown-toggle:after, .btn.btn-active-light-danger:active:not(.btn-active).dropdown-toggle:after, .btn.btn-active-light-danger.active.dropdown-toggle:after, .btn.btn-active-light-danger.show.dropdown-toggle:after, .show > .btn.btn-active-light-danger.dropdown-toggle:after {
  color: var(--bs-danger);
}

.btn.btn-outline.btn-outline-danger {
  color: var(--bs-danger);
  border-color: var(--bs-danger);
  background-color: transparent;
}

.btn.btn-outline.btn-outline-danger i,
.btn.btn-outline.btn-outline-danger .svg-icon {
  color: var(--bs-danger);
}

.btn.btn-outline.btn-outline-danger.dropdown-toggle:after {
  color: var(--bs-danger);
}

.btn-check:checked + .btn.btn-outline.btn-outline-danger, .btn-check:active + .btn.btn-outline.btn-outline-danger, .btn.btn-outline.btn-outline-danger:focus:not(.btn-active), .btn.btn-outline.btn-outline-danger:hover:not(.btn-active), .btn.btn-outline.btn-outline-danger:active:not(.btn-active), .btn.btn-outline.btn-outline-danger.active, .btn.btn-outline.btn-outline-danger.show, .show > .btn.btn-outline.btn-outline-danger {
  color: var(--bs-danger-active);
  border-color: var(--bs-danger);
  background-color: var(--bs-danger-light) !important;
}

.btn-check:checked + .btn.btn-outline.btn-outline-danger i,
.btn-check:checked + .btn.btn-outline.btn-outline-danger .svg-icon, .btn-check:active + .btn.btn-outline.btn-outline-danger i,
.btn-check:active + .btn.btn-outline.btn-outline-danger .svg-icon, .btn.btn-outline.btn-outline-danger:focus:not(.btn-active) i,
.btn.btn-outline.btn-outline-danger:focus:not(.btn-active) .svg-icon, .btn.btn-outline.btn-outline-danger:hover:not(.btn-active) i,
.btn.btn-outline.btn-outline-danger:hover:not(.btn-active) .svg-icon, .btn.btn-outline.btn-outline-danger:active:not(.btn-active) i,
.btn.btn-outline.btn-outline-danger:active:not(.btn-active) .svg-icon, .btn.btn-outline.btn-outline-danger.active i,
.btn.btn-outline.btn-outline-danger.active .svg-icon, .btn.btn-outline.btn-outline-danger.show i,
.btn.btn-outline.btn-outline-danger.show .svg-icon, .show > .btn.btn-outline.btn-outline-danger i,
.show > .btn.btn-outline.btn-outline-danger .svg-icon {
  color: var(--bs-danger-active);
}

.btn-check:checked + .btn.btn-outline.btn-outline-danger.dropdown-toggle:after, .btn-check:active + .btn.btn-outline.btn-outline-danger.dropdown-toggle:after, .btn.btn-outline.btn-outline-danger:focus:not(.btn-active).dropdown-toggle:after, .btn.btn-outline.btn-outline-danger:hover:not(.btn-active).dropdown-toggle:after, .btn.btn-outline.btn-outline-danger:active:not(.btn-active).dropdown-toggle:after, .btn.btn-outline.btn-outline-danger.active.dropdown-toggle:after, .btn.btn-outline.btn-outline-danger.show.dropdown-toggle:after, .show > .btn.btn-outline.btn-outline-danger.dropdown-toggle:after {
  color: var(--bs-danger-active);
}

.btn.btn-dark {
  color: var(--bs-dark-inverse);
  border-color: var(--bs-dark);
  background-color: var(--bs-dark);
}

.btn.btn-dark i,
.btn.btn-dark .svg-icon {
  color: var(--bs-dark-inverse);
}

.btn.btn-dark.dropdown-toggle:after {
  color: var(--bs-dark-inverse);
}

.btn-check:checked + .btn.btn-dark, .btn-check:active + .btn.btn-dark, .btn.btn-dark:focus:not(.btn-active), .btn.btn-dark:hover:not(.btn-active), .btn.btn-dark:active:not(.btn-active), .btn.btn-dark.active, .btn.btn-dark.show, .show > .btn.btn-dark {
  color: var(--bs-dark-inverse);
  border-color: var(--bs-dark-active);
  background-color: var(--bs-dark-active) !important;
}

.btn-check:checked + .btn.btn-dark i,
.btn-check:checked + .btn.btn-dark .svg-icon, .btn-check:active + .btn.btn-dark i,
.btn-check:active + .btn.btn-dark .svg-icon, .btn.btn-dark:focus:not(.btn-active) i,
.btn.btn-dark:focus:not(.btn-active) .svg-icon, .btn.btn-dark:hover:not(.btn-active) i,
.btn.btn-dark:hover:not(.btn-active) .svg-icon, .btn.btn-dark:active:not(.btn-active) i,
.btn.btn-dark:active:not(.btn-active) .svg-icon, .btn.btn-dark.active i,
.btn.btn-dark.active .svg-icon, .btn.btn-dark.show i,
.btn.btn-dark.show .svg-icon, .show > .btn.btn-dark i,
.show > .btn.btn-dark .svg-icon {
  color: var(--bs-dark-inverse);
}

.btn-check:checked + .btn.btn-dark.dropdown-toggle:after, .btn-check:active + .btn.btn-dark.dropdown-toggle:after, .btn.btn-dark:focus:not(.btn-active).dropdown-toggle:after, .btn.btn-dark:hover:not(.btn-active).dropdown-toggle:after, .btn.btn-dark:active:not(.btn-active).dropdown-toggle:after, .btn.btn-dark.active.dropdown-toggle:after, .btn.btn-dark.show.dropdown-toggle:after, .show > .btn.btn-dark.dropdown-toggle:after {
  color: var(--bs-dark-inverse);
}

.btn.btn-light-dark {
  color: var(--bs-dark);
  border-color: var(--bs-dark-light);
  background-color: var(--bs-dark-light);
}

.btn.btn-light-dark i,
.btn.btn-light-dark .svg-icon {
  color: var(--bs-dark);
}

.btn.btn-light-dark.dropdown-toggle:after {
  color: var(--bs-dark);
}

.btn-check:checked + .btn.btn-light-dark, .btn-check:active + .btn.btn-light-dark, .btn.btn-light-dark:focus:not(.btn-active), .btn.btn-light-dark:hover:not(.btn-active), .btn.btn-light-dark:active:not(.btn-active), .btn.btn-light-dark.active, .btn.btn-light-dark.show, .show > .btn.btn-light-dark {
  color: var(--bs-dark-inverse);
  border-color: var(--bs-dark);
  background-color: var(--bs-dark) !important;
}

.btn-check:checked + .btn.btn-light-dark i,
.btn-check:checked + .btn.btn-light-dark .svg-icon, .btn-check:active + .btn.btn-light-dark i,
.btn-check:active + .btn.btn-light-dark .svg-icon, .btn.btn-light-dark:focus:not(.btn-active) i,
.btn.btn-light-dark:focus:not(.btn-active) .svg-icon, .btn.btn-light-dark:hover:not(.btn-active) i,
.btn.btn-light-dark:hover:not(.btn-active) .svg-icon, .btn.btn-light-dark:active:not(.btn-active) i,
.btn.btn-light-dark:active:not(.btn-active) .svg-icon, .btn.btn-light-dark.active i,
.btn.btn-light-dark.active .svg-icon, .btn.btn-light-dark.show i,
.btn.btn-light-dark.show .svg-icon, .show > .btn.btn-light-dark i,
.show > .btn.btn-light-dark .svg-icon {
  color: var(--bs-dark-inverse);
}

.btn-check:checked + .btn.btn-light-dark.dropdown-toggle:after, .btn-check:active + .btn.btn-light-dark.dropdown-toggle:after, .btn.btn-light-dark:focus:not(.btn-active).dropdown-toggle:after, .btn.btn-light-dark:hover:not(.btn-active).dropdown-toggle:after, .btn.btn-light-dark:active:not(.btn-active).dropdown-toggle:after, .btn.btn-light-dark.active.dropdown-toggle:after, .btn.btn-light-dark.show.dropdown-toggle:after, .show > .btn.btn-light-dark.dropdown-toggle:after {
  color: var(--bs-dark-inverse);
}

.btn.btn-bg-dark {
  border-color: var(--bs-dark);
  background-color: var(--bs-dark);
}

.btn-check:checked + .btn.btn-active-dark, .btn-check:active + .btn.btn-active-dark, .btn.btn-active-dark:focus:not(.btn-active), .btn.btn-active-dark:hover:not(.btn-active), .btn.btn-active-dark:active:not(.btn-active), .btn.btn-active-dark.active, .btn.btn-active-dark.show, .show > .btn.btn-active-dark {
  color: var(--bs-dark-inverse);
  border-color: var(--bs-dark);
  background-color: var(--bs-dark) !important;
}

.btn-check:checked + .btn.btn-active-dark i,
.btn-check:checked + .btn.btn-active-dark .svg-icon, .btn-check:active + .btn.btn-active-dark i,
.btn-check:active + .btn.btn-active-dark .svg-icon, .btn.btn-active-dark:focus:not(.btn-active) i,
.btn.btn-active-dark:focus:not(.btn-active) .svg-icon, .btn.btn-active-dark:hover:not(.btn-active) i,
.btn.btn-active-dark:hover:not(.btn-active) .svg-icon, .btn.btn-active-dark:active:not(.btn-active) i,
.btn.btn-active-dark:active:not(.btn-active) .svg-icon, .btn.btn-active-dark.active i,
.btn.btn-active-dark.active .svg-icon, .btn.btn-active-dark.show i,
.btn.btn-active-dark.show .svg-icon, .show > .btn.btn-active-dark i,
.show > .btn.btn-active-dark .svg-icon {
  color: var(--bs-dark-inverse);
}

.btn-check:checked + .btn.btn-active-dark.dropdown-toggle:after, .btn-check:active + .btn.btn-active-dark.dropdown-toggle:after, .btn.btn-active-dark:focus:not(.btn-active).dropdown-toggle:after, .btn.btn-active-dark:hover:not(.btn-active).dropdown-toggle:after, .btn.btn-active-dark:active:not(.btn-active).dropdown-toggle:after, .btn.btn-active-dark.active.dropdown-toggle:after, .btn.btn-active-dark.show.dropdown-toggle:after, .show > .btn.btn-active-dark.dropdown-toggle:after {
  color: var(--bs-dark-inverse);
}

.btn-check:checked + .btn.btn-active-light-dark, .btn-check:active + .btn.btn-active-light-dark, .btn.btn-active-light-dark:focus:not(.btn-active), .btn.btn-active-light-dark:hover:not(.btn-active), .btn.btn-active-light-dark:active:not(.btn-active), .btn.btn-active-light-dark.active, .btn.btn-active-light-dark.show, .show > .btn.btn-active-light-dark {
  color: var(--bs-dark);
  border-color: var(--bs-dark-light);
  background-color: var(--bs-dark-light) !important;
}

.btn-check:checked + .btn.btn-active-light-dark i,
.btn-check:checked + .btn.btn-active-light-dark .svg-icon, .btn-check:active + .btn.btn-active-light-dark i,
.btn-check:active + .btn.btn-active-light-dark .svg-icon, .btn.btn-active-light-dark:focus:not(.btn-active) i,
.btn.btn-active-light-dark:focus:not(.btn-active) .svg-icon, .btn.btn-active-light-dark:hover:not(.btn-active) i,
.btn.btn-active-light-dark:hover:not(.btn-active) .svg-icon, .btn.btn-active-light-dark:active:not(.btn-active) i,
.btn.btn-active-light-dark:active:not(.btn-active) .svg-icon, .btn.btn-active-light-dark.active i,
.btn.btn-active-light-dark.active .svg-icon, .btn.btn-active-light-dark.show i,
.btn.btn-active-light-dark.show .svg-icon, .show > .btn.btn-active-light-dark i,
.show > .btn.btn-active-light-dark .svg-icon {
  color: var(--bs-dark);
}

.btn-check:checked + .btn.btn-active-light-dark.dropdown-toggle:after, .btn-check:active + .btn.btn-active-light-dark.dropdown-toggle:after, .btn.btn-active-light-dark:focus:not(.btn-active).dropdown-toggle:after, .btn.btn-active-light-dark:hover:not(.btn-active).dropdown-toggle:after, .btn.btn-active-light-dark:active:not(.btn-active).dropdown-toggle:after, .btn.btn-active-light-dark.active.dropdown-toggle:after, .btn.btn-active-light-dark.show.dropdown-toggle:after, .show > .btn.btn-active-light-dark.dropdown-toggle:after {
  color: var(--bs-dark);
}

.btn.btn-outline.btn-outline-dark {
  color: var(--bs-dark);
  border-color: var(--bs-dark);
  background-color: transparent;
}

.btn.btn-outline.btn-outline-dark i,
.btn.btn-outline.btn-outline-dark .svg-icon {
  color: var(--bs-dark);
}

.btn.btn-outline.btn-outline-dark.dropdown-toggle:after {
  color: var(--bs-dark);
}

.btn-check:checked + .btn.btn-outline.btn-outline-dark, .btn-check:active + .btn.btn-outline.btn-outline-dark, .btn.btn-outline.btn-outline-dark:focus:not(.btn-active), .btn.btn-outline.btn-outline-dark:hover:not(.btn-active), .btn.btn-outline.btn-outline-dark:active:not(.btn-active), .btn.btn-outline.btn-outline-dark.active, .btn.btn-outline.btn-outline-dark.show, .show > .btn.btn-outline.btn-outline-dark {
  color: var(--bs-dark-active);
  border-color: var(--bs-dark);
  background-color: var(--bs-dark-light) !important;
}

.btn-check:checked + .btn.btn-outline.btn-outline-dark i,
.btn-check:checked + .btn.btn-outline.btn-outline-dark .svg-icon, .btn-check:active + .btn.btn-outline.btn-outline-dark i,
.btn-check:active + .btn.btn-outline.btn-outline-dark .svg-icon, .btn.btn-outline.btn-outline-dark:focus:not(.btn-active) i,
.btn.btn-outline.btn-outline-dark:focus:not(.btn-active) .svg-icon, .btn.btn-outline.btn-outline-dark:hover:not(.btn-active) i,
.btn.btn-outline.btn-outline-dark:hover:not(.btn-active) .svg-icon, .btn.btn-outline.btn-outline-dark:active:not(.btn-active) i,
.btn.btn-outline.btn-outline-dark:active:not(.btn-active) .svg-icon, .btn.btn-outline.btn-outline-dark.active i,
.btn.btn-outline.btn-outline-dark.active .svg-icon, .btn.btn-outline.btn-outline-dark.show i,
.btn.btn-outline.btn-outline-dark.show .svg-icon, .show > .btn.btn-outline.btn-outline-dark i,
.show > .btn.btn-outline.btn-outline-dark .svg-icon {
  color: var(--bs-dark-active);
}

.btn-check:checked + .btn.btn-outline.btn-outline-dark.dropdown-toggle:after, .btn-check:active + .btn.btn-outline.btn-outline-dark.dropdown-toggle:after, .btn.btn-outline.btn-outline-dark:focus:not(.btn-active).dropdown-toggle:after, .btn.btn-outline.btn-outline-dark:hover:not(.btn-active).dropdown-toggle:after, .btn.btn-outline.btn-outline-dark:active:not(.btn-active).dropdown-toggle:after, .btn.btn-outline.btn-outline-dark.active.dropdown-toggle:after, .btn.btn-outline.btn-outline-dark.show.dropdown-toggle:after, .show > .btn.btn-outline.btn-outline-dark.dropdown-toggle:after {
  color: var(--bs-dark-active);
}

.btn.btn-color-white {
  color: var(--bs-text-white);
}

.btn.btn-color-white i,
.btn.btn-color-white .svg-icon {
  color: var(--bs-text-white);
}

.btn.btn-color-white.dropdown-toggle:after {
  color: var(--bs-text-white);
}

.btn-check:checked + .btn.btn-active-color-white, .btn-check:active + .btn.btn-active-color-white, .btn.btn-active-color-white:focus:not(.btn-active), .btn.btn-active-color-white:hover:not(.btn-active), .btn.btn-active-color-white:active:not(.btn-active), .btn.btn-active-color-white.active, .btn.btn-active-color-white.show, .show > .btn.btn-active-color-white {
  color: var(--bs-text-white);
}

.btn-check:checked + .btn.btn-active-color-white i,
.btn-check:checked + .btn.btn-active-color-white .svg-icon, .btn-check:active + .btn.btn-active-color-white i,
.btn-check:active + .btn.btn-active-color-white .svg-icon, .btn.btn-active-color-white:focus:not(.btn-active) i,
.btn.btn-active-color-white:focus:not(.btn-active) .svg-icon, .btn.btn-active-color-white:hover:not(.btn-active) i,
.btn.btn-active-color-white:hover:not(.btn-active) .svg-icon, .btn.btn-active-color-white:active:not(.btn-active) i,
.btn.btn-active-color-white:active:not(.btn-active) .svg-icon, .btn.btn-active-color-white.active i,
.btn.btn-active-color-white.active .svg-icon, .btn.btn-active-color-white.show i,
.btn.btn-active-color-white.show .svg-icon, .show > .btn.btn-active-color-white i,
.show > .btn.btn-active-color-white .svg-icon {
  color: var(--bs-text-white);
}

.btn-check:checked + .btn.btn-active-color-white.dropdown-toggle:after, .btn-check:active + .btn.btn-active-color-white.dropdown-toggle:after, .btn.btn-active-color-white:focus:not(.btn-active).dropdown-toggle:after, .btn.btn-active-color-white:hover:not(.btn-active).dropdown-toggle:after, .btn.btn-active-color-white:active:not(.btn-active).dropdown-toggle:after, .btn.btn-active-color-white.active.dropdown-toggle:after, .btn.btn-active-color-white.show.dropdown-toggle:after, .show > .btn.btn-active-color-white.dropdown-toggle:after {
  color: var(--bs-text-white);
}

.btn.btn-icon-white i,
.btn.btn-icon-white .svg-icon {
  color: var(--bs-text-white);
}

.btn.btn-icon-white.dropdown-toggle:after {
  color: var(--bs-text-white);
}

.btn-check:checked + .btn.btn-active-icon-white i,
.btn-check:checked + .btn.btn-active-icon-white .svg-icon, .btn-check:active + .btn.btn-active-icon-white i,
.btn-check:active + .btn.btn-active-icon-white .svg-icon, .btn.btn-active-icon-white:focus:not(.btn-active) i,
.btn.btn-active-icon-white:focus:not(.btn-active) .svg-icon, .btn.btn-active-icon-white:hover:not(.btn-active) i,
.btn.btn-active-icon-white:hover:not(.btn-active) .svg-icon, .btn.btn-active-icon-white:active:not(.btn-active) i,
.btn.btn-active-icon-white:active:not(.btn-active) .svg-icon, .btn.btn-active-icon-white.active i,
.btn.btn-active-icon-white.active .svg-icon, .btn.btn-active-icon-white.show i,
.btn.btn-active-icon-white.show .svg-icon, .show > .btn.btn-active-icon-white i,
.show > .btn.btn-active-icon-white .svg-icon {
  color: var(--bs-text-white);
}

.btn-check:checked + .btn.btn-active-icon-white.dropdown-toggle:after, .btn-check:active + .btn.btn-active-icon-white.dropdown-toggle:after, .btn.btn-active-icon-white:focus:not(.btn-active).dropdown-toggle:after, .btn.btn-active-icon-white:hover:not(.btn-active).dropdown-toggle:after, .btn.btn-active-icon-white:active:not(.btn-active).dropdown-toggle:after, .btn.btn-active-icon-white.active.dropdown-toggle:after, .btn.btn-active-icon-white.show.dropdown-toggle:after, .show > .btn.btn-active-icon-white.dropdown-toggle:after {
  color: var(--bs-text-white);
}

.btn.btn-text-white {
  color: var(--bs-text-white);
}

.btn-check:checked + .btn.btn-active-text-white, .btn-check:active + .btn.btn-active-text-white, .btn.btn-active-text-white:focus:not(.btn-active), .btn.btn-active-text-white:hover:not(.btn-active), .btn.btn-active-text-white:active:not(.btn-active), .btn.btn-active-text-white.active, .btn.btn-active-text-white.show, .show > .btn.btn-active-text-white {
  color: var(--bs-text-white);
}

.btn.btn-color-primary {
  color: var(--bs-text-primary);
}

.btn.btn-color-primary i,
.btn.btn-color-primary .svg-icon {
  color: var(--bs-text-primary);
}

.btn.btn-color-primary.dropdown-toggle:after {
  color: var(--bs-text-primary);
}

.btn-check:checked + .btn.btn-active-color-primary, .btn-check:active + .btn.btn-active-color-primary, .btn.btn-active-color-primary:focus:not(.btn-active), .btn.btn-active-color-primary:hover:not(.btn-active), .btn.btn-active-color-primary:active:not(.btn-active), .btn.btn-active-color-primary.active, .btn.btn-active-color-primary.show, .show > .btn.btn-active-color-primary {
  color: var(--bs-text-primary);
}

.btn-check:checked + .btn.btn-active-color-primary i,
.btn-check:checked + .btn.btn-active-color-primary .svg-icon, .btn-check:active + .btn.btn-active-color-primary i,
.btn-check:active + .btn.btn-active-color-primary .svg-icon, .btn.btn-active-color-primary:focus:not(.btn-active) i,
.btn.btn-active-color-primary:focus:not(.btn-active) .svg-icon, .btn.btn-active-color-primary:hover:not(.btn-active) i,
.btn.btn-active-color-primary:hover:not(.btn-active) .svg-icon, .btn.btn-active-color-primary:active:not(.btn-active) i,
.btn.btn-active-color-primary:active:not(.btn-active) .svg-icon, .btn.btn-active-color-primary.active i,
.btn.btn-active-color-primary.active .svg-icon, .btn.btn-active-color-primary.show i,
.btn.btn-active-color-primary.show .svg-icon, .show > .btn.btn-active-color-primary i,
.show > .btn.btn-active-color-primary .svg-icon {
  color: var(--bs-text-primary);
}

.btn-check:checked + .btn.btn-active-color-primary.dropdown-toggle:after, .btn-check:active + .btn.btn-active-color-primary.dropdown-toggle:after, .btn.btn-active-color-primary:focus:not(.btn-active).dropdown-toggle:after, .btn.btn-active-color-primary:hover:not(.btn-active).dropdown-toggle:after, .btn.btn-active-color-primary:active:not(.btn-active).dropdown-toggle:after, .btn.btn-active-color-primary.active.dropdown-toggle:after, .btn.btn-active-color-primary.show.dropdown-toggle:after, .show > .btn.btn-active-color-primary.dropdown-toggle:after {
  color: var(--bs-text-primary);
}

.btn.btn-icon-primary i,
.btn.btn-icon-primary .svg-icon {
  color: var(--bs-text-primary);
}

.btn.btn-icon-primary.dropdown-toggle:after {
  color: var(--bs-text-primary);
}

.btn-check:checked + .btn.btn-active-icon-primary i,
.btn-check:checked + .btn.btn-active-icon-primary .svg-icon, .btn-check:active + .btn.btn-active-icon-primary i,
.btn-check:active + .btn.btn-active-icon-primary .svg-icon, .btn.btn-active-icon-primary:focus:not(.btn-active) i,
.btn.btn-active-icon-primary:focus:not(.btn-active) .svg-icon, .btn.btn-active-icon-primary:hover:not(.btn-active) i,
.btn.btn-active-icon-primary:hover:not(.btn-active) .svg-icon, .btn.btn-active-icon-primary:active:not(.btn-active) i,
.btn.btn-active-icon-primary:active:not(.btn-active) .svg-icon, .btn.btn-active-icon-primary.active i,
.btn.btn-active-icon-primary.active .svg-icon, .btn.btn-active-icon-primary.show i,
.btn.btn-active-icon-primary.show .svg-icon, .show > .btn.btn-active-icon-primary i,
.show > .btn.btn-active-icon-primary .svg-icon {
  color: var(--bs-text-primary);
}

.btn-check:checked + .btn.btn-active-icon-primary.dropdown-toggle:after, .btn-check:active + .btn.btn-active-icon-primary.dropdown-toggle:after, .btn.btn-active-icon-primary:focus:not(.btn-active).dropdown-toggle:after, .btn.btn-active-icon-primary:hover:not(.btn-active).dropdown-toggle:after, .btn.btn-active-icon-primary:active:not(.btn-active).dropdown-toggle:after, .btn.btn-active-icon-primary.active.dropdown-toggle:after, .btn.btn-active-icon-primary.show.dropdown-toggle:after, .show > .btn.btn-active-icon-primary.dropdown-toggle:after {
  color: var(--bs-text-primary);
}

.btn.btn-text-primary {
  color: var(--bs-text-primary);
}

.btn-check:checked + .btn.btn-active-text-primary, .btn-check:active + .btn.btn-active-text-primary, .btn.btn-active-text-primary:focus:not(.btn-active), .btn.btn-active-text-primary:hover:not(.btn-active), .btn.btn-active-text-primary:active:not(.btn-active), .btn.btn-active-text-primary.active, .btn.btn-active-text-primary.show, .show > .btn.btn-active-text-primary {
  color: var(--bs-text-primary);
}

.btn.btn-color-secondary {
  color: var(--bs-text-secondary);
}

.btn.btn-color-secondary i,
.btn.btn-color-secondary .svg-icon {
  color: var(--bs-text-secondary);
}

.btn.btn-color-secondary.dropdown-toggle:after {
  color: var(--bs-text-secondary);
}

.btn-check:checked + .btn.btn-active-color-secondary, .btn-check:active + .btn.btn-active-color-secondary, .btn.btn-active-color-secondary:focus:not(.btn-active), .btn.btn-active-color-secondary:hover:not(.btn-active), .btn.btn-active-color-secondary:active:not(.btn-active), .btn.btn-active-color-secondary.active, .btn.btn-active-color-secondary.show, .show > .btn.btn-active-color-secondary {
  color: var(--bs-text-secondary);
}

.btn-check:checked + .btn.btn-active-color-secondary i,
.btn-check:checked + .btn.btn-active-color-secondary .svg-icon, .btn-check:active + .btn.btn-active-color-secondary i,
.btn-check:active + .btn.btn-active-color-secondary .svg-icon, .btn.btn-active-color-secondary:focus:not(.btn-active) i,
.btn.btn-active-color-secondary:focus:not(.btn-active) .svg-icon, .btn.btn-active-color-secondary:hover:not(.btn-active) i,
.btn.btn-active-color-secondary:hover:not(.btn-active) .svg-icon, .btn.btn-active-color-secondary:active:not(.btn-active) i,
.btn.btn-active-color-secondary:active:not(.btn-active) .svg-icon, .btn.btn-active-color-secondary.active i,
.btn.btn-active-color-secondary.active .svg-icon, .btn.btn-active-color-secondary.show i,
.btn.btn-active-color-secondary.show .svg-icon, .show > .btn.btn-active-color-secondary i,
.show > .btn.btn-active-color-secondary .svg-icon {
  color: var(--bs-text-secondary);
}

.btn-check:checked + .btn.btn-active-color-secondary.dropdown-toggle:after, .btn-check:active + .btn.btn-active-color-secondary.dropdown-toggle:after, .btn.btn-active-color-secondary:focus:not(.btn-active).dropdown-toggle:after, .btn.btn-active-color-secondary:hover:not(.btn-active).dropdown-toggle:after, .btn.btn-active-color-secondary:active:not(.btn-active).dropdown-toggle:after, .btn.btn-active-color-secondary.active.dropdown-toggle:after, .btn.btn-active-color-secondary.show.dropdown-toggle:after, .show > .btn.btn-active-color-secondary.dropdown-toggle:after {
  color: var(--bs-text-secondary);
}

.btn.btn-icon-secondary i,
.btn.btn-icon-secondary .svg-icon {
  color: var(--bs-text-secondary);
}

.btn.btn-icon-secondary.dropdown-toggle:after {
  color: var(--bs-text-secondary);
}

.btn-check:checked + .btn.btn-active-icon-secondary i,
.btn-check:checked + .btn.btn-active-icon-secondary .svg-icon, .btn-check:active + .btn.btn-active-icon-secondary i,
.btn-check:active + .btn.btn-active-icon-secondary .svg-icon, .btn.btn-active-icon-secondary:focus:not(.btn-active) i,
.btn.btn-active-icon-secondary:focus:not(.btn-active) .svg-icon, .btn.btn-active-icon-secondary:hover:not(.btn-active) i,
.btn.btn-active-icon-secondary:hover:not(.btn-active) .svg-icon, .btn.btn-active-icon-secondary:active:not(.btn-active) i,
.btn.btn-active-icon-secondary:active:not(.btn-active) .svg-icon, .btn.btn-active-icon-secondary.active i,
.btn.btn-active-icon-secondary.active .svg-icon, .btn.btn-active-icon-secondary.show i,
.btn.btn-active-icon-secondary.show .svg-icon, .show > .btn.btn-active-icon-secondary i,
.show > .btn.btn-active-icon-secondary .svg-icon {
  color: var(--bs-text-secondary);
}

.btn-check:checked + .btn.btn-active-icon-secondary.dropdown-toggle:after, .btn-check:active + .btn.btn-active-icon-secondary.dropdown-toggle:after, .btn.btn-active-icon-secondary:focus:not(.btn-active).dropdown-toggle:after, .btn.btn-active-icon-secondary:hover:not(.btn-active).dropdown-toggle:after, .btn.btn-active-icon-secondary:active:not(.btn-active).dropdown-toggle:after, .btn.btn-active-icon-secondary.active.dropdown-toggle:after, .btn.btn-active-icon-secondary.show.dropdown-toggle:after, .show > .btn.btn-active-icon-secondary.dropdown-toggle:after {
  color: var(--bs-text-secondary);
}

.btn.btn-text-secondary {
  color: var(--bs-text-secondary);
}

.btn-check:checked + .btn.btn-active-text-secondary, .btn-check:active + .btn.btn-active-text-secondary, .btn.btn-active-text-secondary:focus:not(.btn-active), .btn.btn-active-text-secondary:hover:not(.btn-active), .btn.btn-active-text-secondary:active:not(.btn-active), .btn.btn-active-text-secondary.active, .btn.btn-active-text-secondary.show, .show > .btn.btn-active-text-secondary {
  color: var(--bs-text-secondary);
}

.btn.btn-color-light {
  color: var(--bs-text-light);
}

.btn.btn-color-light i,
.btn.btn-color-light .svg-icon {
  color: var(--bs-text-light);
}

.btn.btn-color-light.dropdown-toggle:after {
  color: var(--bs-text-light);
}

.btn-check:checked + .btn.btn-active-color-light, .btn-check:active + .btn.btn-active-color-light, .btn.btn-active-color-light:focus:not(.btn-active), .btn.btn-active-color-light:hover:not(.btn-active), .btn.btn-active-color-light:active:not(.btn-active), .btn.btn-active-color-light.active, .btn.btn-active-color-light.show, .show > .btn.btn-active-color-light {
  color: var(--bs-text-light);
}

.btn-check:checked + .btn.btn-active-color-light i,
.btn-check:checked + .btn.btn-active-color-light .svg-icon, .btn-check:active + .btn.btn-active-color-light i,
.btn-check:active + .btn.btn-active-color-light .svg-icon, .btn.btn-active-color-light:focus:not(.btn-active) i,
.btn.btn-active-color-light:focus:not(.btn-active) .svg-icon, .btn.btn-active-color-light:hover:not(.btn-active) i,
.btn.btn-active-color-light:hover:not(.btn-active) .svg-icon, .btn.btn-active-color-light:active:not(.btn-active) i,
.btn.btn-active-color-light:active:not(.btn-active) .svg-icon, .btn.btn-active-color-light.active i,
.btn.btn-active-color-light.active .svg-icon, .btn.btn-active-color-light.show i,
.btn.btn-active-color-light.show .svg-icon, .show > .btn.btn-active-color-light i,
.show > .btn.btn-active-color-light .svg-icon {
  color: var(--bs-text-light);
}

.btn-check:checked + .btn.btn-active-color-light.dropdown-toggle:after, .btn-check:active + .btn.btn-active-color-light.dropdown-toggle:after, .btn.btn-active-color-light:focus:not(.btn-active).dropdown-toggle:after, .btn.btn-active-color-light:hover:not(.btn-active).dropdown-toggle:after, .btn.btn-active-color-light:active:not(.btn-active).dropdown-toggle:after, .btn.btn-active-color-light.active.dropdown-toggle:after, .btn.btn-active-color-light.show.dropdown-toggle:after, .show > .btn.btn-active-color-light.dropdown-toggle:after {
  color: var(--bs-text-light);
}

.btn.btn-icon-light i,
.btn.btn-icon-light .svg-icon {
  color: var(--bs-text-light);
}

.btn.btn-icon-light.dropdown-toggle:after {
  color: var(--bs-text-light);
}

.btn-check:checked + .btn.btn-active-icon-light i,
.btn-check:checked + .btn.btn-active-icon-light .svg-icon, .btn-check:active + .btn.btn-active-icon-light i,
.btn-check:active + .btn.btn-active-icon-light .svg-icon, .btn.btn-active-icon-light:focus:not(.btn-active) i,
.btn.btn-active-icon-light:focus:not(.btn-active) .svg-icon, .btn.btn-active-icon-light:hover:not(.btn-active) i,
.btn.btn-active-icon-light:hover:not(.btn-active) .svg-icon, .btn.btn-active-icon-light:active:not(.btn-active) i,
.btn.btn-active-icon-light:active:not(.btn-active) .svg-icon, .btn.btn-active-icon-light.active i,
.btn.btn-active-icon-light.active .svg-icon, .btn.btn-active-icon-light.show i,
.btn.btn-active-icon-light.show .svg-icon, .show > .btn.btn-active-icon-light i,
.show > .btn.btn-active-icon-light .svg-icon {
  color: var(--bs-text-light);
}

.btn-check:checked + .btn.btn-active-icon-light.dropdown-toggle:after, .btn-check:active + .btn.btn-active-icon-light.dropdown-toggle:after, .btn.btn-active-icon-light:focus:not(.btn-active).dropdown-toggle:after, .btn.btn-active-icon-light:hover:not(.btn-active).dropdown-toggle:after, .btn.btn-active-icon-light:active:not(.btn-active).dropdown-toggle:after, .btn.btn-active-icon-light.active.dropdown-toggle:after, .btn.btn-active-icon-light.show.dropdown-toggle:after, .show > .btn.btn-active-icon-light.dropdown-toggle:after {
  color: var(--bs-text-light);
}

.btn.btn-text-light {
  color: var(--bs-text-light);
}

.btn-check:checked + .btn.btn-active-text-light, .btn-check:active + .btn.btn-active-text-light, .btn.btn-active-text-light:focus:not(.btn-active), .btn.btn-active-text-light:hover:not(.btn-active), .btn.btn-active-text-light:active:not(.btn-active), .btn.btn-active-text-light.active, .btn.btn-active-text-light.show, .show > .btn.btn-active-text-light {
  color: var(--bs-text-light);
}

.btn.btn-color-success {
  color: var(--bs-text-success);
}

.btn.btn-color-success i,
.btn.btn-color-success .svg-icon {
  color: var(--bs-text-success);
}

.btn.btn-color-success.dropdown-toggle:after {
  color: var(--bs-text-success);
}

.btn-check:checked + .btn.btn-active-color-success, .btn-check:active + .btn.btn-active-color-success, .btn.btn-active-color-success:focus:not(.btn-active), .btn.btn-active-color-success:hover:not(.btn-active), .btn.btn-active-color-success:active:not(.btn-active), .btn.btn-active-color-success.active, .btn.btn-active-color-success.show, .show > .btn.btn-active-color-success {
  color: var(--bs-text-success);
}

.btn-check:checked + .btn.btn-active-color-success i,
.btn-check:checked + .btn.btn-active-color-success .svg-icon, .btn-check:active + .btn.btn-active-color-success i,
.btn-check:active + .btn.btn-active-color-success .svg-icon, .btn.btn-active-color-success:focus:not(.btn-active) i,
.btn.btn-active-color-success:focus:not(.btn-active) .svg-icon, .btn.btn-active-color-success:hover:not(.btn-active) i,
.btn.btn-active-color-success:hover:not(.btn-active) .svg-icon, .btn.btn-active-color-success:active:not(.btn-active) i,
.btn.btn-active-color-success:active:not(.btn-active) .svg-icon, .btn.btn-active-color-success.active i,
.btn.btn-active-color-success.active .svg-icon, .btn.btn-active-color-success.show i,
.btn.btn-active-color-success.show .svg-icon, .show > .btn.btn-active-color-success i,
.show > .btn.btn-active-color-success .svg-icon {
  color: var(--bs-text-success);
}

.btn-check:checked + .btn.btn-active-color-success.dropdown-toggle:after, .btn-check:active + .btn.btn-active-color-success.dropdown-toggle:after, .btn.btn-active-color-success:focus:not(.btn-active).dropdown-toggle:after, .btn.btn-active-color-success:hover:not(.btn-active).dropdown-toggle:after, .btn.btn-active-color-success:active:not(.btn-active).dropdown-toggle:after, .btn.btn-active-color-success.active.dropdown-toggle:after, .btn.btn-active-color-success.show.dropdown-toggle:after, .show > .btn.btn-active-color-success.dropdown-toggle:after {
  color: var(--bs-text-success);
}

.btn.btn-icon-success i,
.btn.btn-icon-success .svg-icon {
  color: var(--bs-text-success);
}

.btn.btn-icon-success.dropdown-toggle:after {
  color: var(--bs-text-success);
}

.btn-check:checked + .btn.btn-active-icon-success i,
.btn-check:checked + .btn.btn-active-icon-success .svg-icon, .btn-check:active + .btn.btn-active-icon-success i,
.btn-check:active + .btn.btn-active-icon-success .svg-icon, .btn.btn-active-icon-success:focus:not(.btn-active) i,
.btn.btn-active-icon-success:focus:not(.btn-active) .svg-icon, .btn.btn-active-icon-success:hover:not(.btn-active) i,
.btn.btn-active-icon-success:hover:not(.btn-active) .svg-icon, .btn.btn-active-icon-success:active:not(.btn-active) i,
.btn.btn-active-icon-success:active:not(.btn-active) .svg-icon, .btn.btn-active-icon-success.active i,
.btn.btn-active-icon-success.active .svg-icon, .btn.btn-active-icon-success.show i,
.btn.btn-active-icon-success.show .svg-icon, .show > .btn.btn-active-icon-success i,
.show > .btn.btn-active-icon-success .svg-icon {
  color: var(--bs-text-success);
}

.btn-check:checked + .btn.btn-active-icon-success.dropdown-toggle:after, .btn-check:active + .btn.btn-active-icon-success.dropdown-toggle:after, .btn.btn-active-icon-success:focus:not(.btn-active).dropdown-toggle:after, .btn.btn-active-icon-success:hover:not(.btn-active).dropdown-toggle:after, .btn.btn-active-icon-success:active:not(.btn-active).dropdown-toggle:after, .btn.btn-active-icon-success.active.dropdown-toggle:after, .btn.btn-active-icon-success.show.dropdown-toggle:after, .show > .btn.btn-active-icon-success.dropdown-toggle:after {
  color: var(--bs-text-success);
}

.btn.btn-text-success {
  color: var(--bs-text-success);
}

.btn-check:checked + .btn.btn-active-text-success, .btn-check:active + .btn.btn-active-text-success, .btn.btn-active-text-success:focus:not(.btn-active), .btn.btn-active-text-success:hover:not(.btn-active), .btn.btn-active-text-success:active:not(.btn-active), .btn.btn-active-text-success.active, .btn.btn-active-text-success.show, .show > .btn.btn-active-text-success {
  color: var(--bs-text-success);
}

.btn.btn-color-info {
  color: var(--bs-text-info);
}

.btn.btn-color-info i,
.btn.btn-color-info .svg-icon {
  color: var(--bs-text-info);
}

.btn.btn-color-info.dropdown-toggle:after {
  color: var(--bs-text-info);
}

.btn-check:checked + .btn.btn-active-color-info, .btn-check:active + .btn.btn-active-color-info, .btn.btn-active-color-info:focus:not(.btn-active), .btn.btn-active-color-info:hover:not(.btn-active), .btn.btn-active-color-info:active:not(.btn-active), .btn.btn-active-color-info.active, .btn.btn-active-color-info.show, .show > .btn.btn-active-color-info {
  color: var(--bs-text-info);
}

.btn-check:checked + .btn.btn-active-color-info i,
.btn-check:checked + .btn.btn-active-color-info .svg-icon, .btn-check:active + .btn.btn-active-color-info i,
.btn-check:active + .btn.btn-active-color-info .svg-icon, .btn.btn-active-color-info:focus:not(.btn-active) i,
.btn.btn-active-color-info:focus:not(.btn-active) .svg-icon, .btn.btn-active-color-info:hover:not(.btn-active) i,
.btn.btn-active-color-info:hover:not(.btn-active) .svg-icon, .btn.btn-active-color-info:active:not(.btn-active) i,
.btn.btn-active-color-info:active:not(.btn-active) .svg-icon, .btn.btn-active-color-info.active i,
.btn.btn-active-color-info.active .svg-icon, .btn.btn-active-color-info.show i,
.btn.btn-active-color-info.show .svg-icon, .show > .btn.btn-active-color-info i,
.show > .btn.btn-active-color-info .svg-icon {
  color: var(--bs-text-info);
}

.btn-check:checked + .btn.btn-active-color-info.dropdown-toggle:after, .btn-check:active + .btn.btn-active-color-info.dropdown-toggle:after, .btn.btn-active-color-info:focus:not(.btn-active).dropdown-toggle:after, .btn.btn-active-color-info:hover:not(.btn-active).dropdown-toggle:after, .btn.btn-active-color-info:active:not(.btn-active).dropdown-toggle:after, .btn.btn-active-color-info.active.dropdown-toggle:after, .btn.btn-active-color-info.show.dropdown-toggle:after, .show > .btn.btn-active-color-info.dropdown-toggle:after {
  color: var(--bs-text-info);
}

.btn.btn-icon-info i,
.btn.btn-icon-info .svg-icon {
  color: var(--bs-text-info);
}

.btn.btn-icon-info.dropdown-toggle:after {
  color: var(--bs-text-info);
}

.btn-check:checked + .btn.btn-active-icon-info i,
.btn-check:checked + .btn.btn-active-icon-info .svg-icon, .btn-check:active + .btn.btn-active-icon-info i,
.btn-check:active + .btn.btn-active-icon-info .svg-icon, .btn.btn-active-icon-info:focus:not(.btn-active) i,
.btn.btn-active-icon-info:focus:not(.btn-active) .svg-icon, .btn.btn-active-icon-info:hover:not(.btn-active) i,
.btn.btn-active-icon-info:hover:not(.btn-active) .svg-icon, .btn.btn-active-icon-info:active:not(.btn-active) i,
.btn.btn-active-icon-info:active:not(.btn-active) .svg-icon, .btn.btn-active-icon-info.active i,
.btn.btn-active-icon-info.active .svg-icon, .btn.btn-active-icon-info.show i,
.btn.btn-active-icon-info.show .svg-icon, .show > .btn.btn-active-icon-info i,
.show > .btn.btn-active-icon-info .svg-icon {
  color: var(--bs-text-info);
}

.btn-check:checked + .btn.btn-active-icon-info.dropdown-toggle:after, .btn-check:active + .btn.btn-active-icon-info.dropdown-toggle:after, .btn.btn-active-icon-info:focus:not(.btn-active).dropdown-toggle:after, .btn.btn-active-icon-info:hover:not(.btn-active).dropdown-toggle:after, .btn.btn-active-icon-info:active:not(.btn-active).dropdown-toggle:after, .btn.btn-active-icon-info.active.dropdown-toggle:after, .btn.btn-active-icon-info.show.dropdown-toggle:after, .show > .btn.btn-active-icon-info.dropdown-toggle:after {
  color: var(--bs-text-info);
}

.btn.btn-text-info {
  color: var(--bs-text-info);
}

.btn-check:checked + .btn.btn-active-text-info, .btn-check:active + .btn.btn-active-text-info, .btn.btn-active-text-info:focus:not(.btn-active), .btn.btn-active-text-info:hover:not(.btn-active), .btn.btn-active-text-info:active:not(.btn-active), .btn.btn-active-text-info.active, .btn.btn-active-text-info.show, .show > .btn.btn-active-text-info {
  color: var(--bs-text-info);
}

.btn.btn-color-warning {
  color: var(--bs-text-warning);
}

.btn.btn-color-warning i,
.btn.btn-color-warning .svg-icon {
  color: var(--bs-text-warning);
}

.btn.btn-color-warning.dropdown-toggle:after {
  color: var(--bs-text-warning);
}

.btn-check:checked + .btn.btn-active-color-warning, .btn-check:active + .btn.btn-active-color-warning, .btn.btn-active-color-warning:focus:not(.btn-active), .btn.btn-active-color-warning:hover:not(.btn-active), .btn.btn-active-color-warning:active:not(.btn-active), .btn.btn-active-color-warning.active, .btn.btn-active-color-warning.show, .show > .btn.btn-active-color-warning {
  color: var(--bs-text-warning);
}

.btn-check:checked + .btn.btn-active-color-warning i,
.btn-check:checked + .btn.btn-active-color-warning .svg-icon, .btn-check:active + .btn.btn-active-color-warning i,
.btn-check:active + .btn.btn-active-color-warning .svg-icon, .btn.btn-active-color-warning:focus:not(.btn-active) i,
.btn.btn-active-color-warning:focus:not(.btn-active) .svg-icon, .btn.btn-active-color-warning:hover:not(.btn-active) i,
.btn.btn-active-color-warning:hover:not(.btn-active) .svg-icon, .btn.btn-active-color-warning:active:not(.btn-active) i,
.btn.btn-active-color-warning:active:not(.btn-active) .svg-icon, .btn.btn-active-color-warning.active i,
.btn.btn-active-color-warning.active .svg-icon, .btn.btn-active-color-warning.show i,
.btn.btn-active-color-warning.show .svg-icon, .show > .btn.btn-active-color-warning i,
.show > .btn.btn-active-color-warning .svg-icon {
  color: var(--bs-text-warning);
}

.btn-check:checked + .btn.btn-active-color-warning.dropdown-toggle:after, .btn-check:active + .btn.btn-active-color-warning.dropdown-toggle:after, .btn.btn-active-color-warning:focus:not(.btn-active).dropdown-toggle:after, .btn.btn-active-color-warning:hover:not(.btn-active).dropdown-toggle:after, .btn.btn-active-color-warning:active:not(.btn-active).dropdown-toggle:after, .btn.btn-active-color-warning.active.dropdown-toggle:after, .btn.btn-active-color-warning.show.dropdown-toggle:after, .show > .btn.btn-active-color-warning.dropdown-toggle:after {
  color: var(--bs-text-warning);
}

.btn.btn-icon-warning i,
.btn.btn-icon-warning .svg-icon {
  color: var(--bs-text-warning);
}

.btn.btn-icon-warning.dropdown-toggle:after {
  color: var(--bs-text-warning);
}

.btn-check:checked + .btn.btn-active-icon-warning i,
.btn-check:checked + .btn.btn-active-icon-warning .svg-icon, .btn-check:active + .btn.btn-active-icon-warning i,
.btn-check:active + .btn.btn-active-icon-warning .svg-icon, .btn.btn-active-icon-warning:focus:not(.btn-active) i,
.btn.btn-active-icon-warning:focus:not(.btn-active) .svg-icon, .btn.btn-active-icon-warning:hover:not(.btn-active) i,
.btn.btn-active-icon-warning:hover:not(.btn-active) .svg-icon, .btn.btn-active-icon-warning:active:not(.btn-active) i,
.btn.btn-active-icon-warning:active:not(.btn-active) .svg-icon, .btn.btn-active-icon-warning.active i,
.btn.btn-active-icon-warning.active .svg-icon, .btn.btn-active-icon-warning.show i,
.btn.btn-active-icon-warning.show .svg-icon, .show > .btn.btn-active-icon-warning i,
.show > .btn.btn-active-icon-warning .svg-icon {
  color: var(--bs-text-warning);
}

.btn-check:checked + .btn.btn-active-icon-warning.dropdown-toggle:after, .btn-check:active + .btn.btn-active-icon-warning.dropdown-toggle:after, .btn.btn-active-icon-warning:focus:not(.btn-active).dropdown-toggle:after, .btn.btn-active-icon-warning:hover:not(.btn-active).dropdown-toggle:after, .btn.btn-active-icon-warning:active:not(.btn-active).dropdown-toggle:after, .btn.btn-active-icon-warning.active.dropdown-toggle:after, .btn.btn-active-icon-warning.show.dropdown-toggle:after, .show > .btn.btn-active-icon-warning.dropdown-toggle:after {
  color: var(--bs-text-warning);
}

.btn.btn-text-warning {
  color: var(--bs-text-warning);
}

.btn-check:checked + .btn.btn-active-text-warning, .btn-check:active + .btn.btn-active-text-warning, .btn.btn-active-text-warning:focus:not(.btn-active), .btn.btn-active-text-warning:hover:not(.btn-active), .btn.btn-active-text-warning:active:not(.btn-active), .btn.btn-active-text-warning.active, .btn.btn-active-text-warning.show, .show > .btn.btn-active-text-warning {
  color: var(--bs-text-warning);
}

.btn.btn-color-danger {
  color: var(--bs-text-danger);
}

.btn.btn-color-danger i,
.btn.btn-color-danger .svg-icon {
  color: var(--bs-text-danger);
}

.btn.btn-color-danger.dropdown-toggle:after {
  color: var(--bs-text-danger);
}

.btn-check:checked + .btn.btn-active-color-danger, .btn-check:active + .btn.btn-active-color-danger, .btn.btn-active-color-danger:focus:not(.btn-active), .btn.btn-active-color-danger:hover:not(.btn-active), .btn.btn-active-color-danger:active:not(.btn-active), .btn.btn-active-color-danger.active, .btn.btn-active-color-danger.show, .show > .btn.btn-active-color-danger {
  color: var(--bs-text-danger);
}

.btn-check:checked + .btn.btn-active-color-danger i,
.btn-check:checked + .btn.btn-active-color-danger .svg-icon, .btn-check:active + .btn.btn-active-color-danger i,
.btn-check:active + .btn.btn-active-color-danger .svg-icon, .btn.btn-active-color-danger:focus:not(.btn-active) i,
.btn.btn-active-color-danger:focus:not(.btn-active) .svg-icon, .btn.btn-active-color-danger:hover:not(.btn-active) i,
.btn.btn-active-color-danger:hover:not(.btn-active) .svg-icon, .btn.btn-active-color-danger:active:not(.btn-active) i,
.btn.btn-active-color-danger:active:not(.btn-active) .svg-icon, .btn.btn-active-color-danger.active i,
.btn.btn-active-color-danger.active .svg-icon, .btn.btn-active-color-danger.show i,
.btn.btn-active-color-danger.show .svg-icon, .show > .btn.btn-active-color-danger i,
.show > .btn.btn-active-color-danger .svg-icon {
  color: var(--bs-text-danger);
}

.btn-check:checked + .btn.btn-active-color-danger.dropdown-toggle:after, .btn-check:active + .btn.btn-active-color-danger.dropdown-toggle:after, .btn.btn-active-color-danger:focus:not(.btn-active).dropdown-toggle:after, .btn.btn-active-color-danger:hover:not(.btn-active).dropdown-toggle:after, .btn.btn-active-color-danger:active:not(.btn-active).dropdown-toggle:after, .btn.btn-active-color-danger.active.dropdown-toggle:after, .btn.btn-active-color-danger.show.dropdown-toggle:after, .show > .btn.btn-active-color-danger.dropdown-toggle:after {
  color: var(--bs-text-danger);
}

.btn.btn-icon-danger i,
.btn.btn-icon-danger .svg-icon {
  color: var(--bs-text-danger);
}

.btn.btn-icon-danger.dropdown-toggle:after {
  color: var(--bs-text-danger);
}

.btn-check:checked + .btn.btn-active-icon-danger i,
.btn-check:checked + .btn.btn-active-icon-danger .svg-icon, .btn-check:active + .btn.btn-active-icon-danger i,
.btn-check:active + .btn.btn-active-icon-danger .svg-icon, .btn.btn-active-icon-danger:focus:not(.btn-active) i,
.btn.btn-active-icon-danger:focus:not(.btn-active) .svg-icon, .btn.btn-active-icon-danger:hover:not(.btn-active) i,
.btn.btn-active-icon-danger:hover:not(.btn-active) .svg-icon, .btn.btn-active-icon-danger:active:not(.btn-active) i,
.btn.btn-active-icon-danger:active:not(.btn-active) .svg-icon, .btn.btn-active-icon-danger.active i,
.btn.btn-active-icon-danger.active .svg-icon, .btn.btn-active-icon-danger.show i,
.btn.btn-active-icon-danger.show .svg-icon, .show > .btn.btn-active-icon-danger i,
.show > .btn.btn-active-icon-danger .svg-icon {
  color: var(--bs-text-danger);
}

.btn-check:checked + .btn.btn-active-icon-danger.dropdown-toggle:after, .btn-check:active + .btn.btn-active-icon-danger.dropdown-toggle:after, .btn.btn-active-icon-danger:focus:not(.btn-active).dropdown-toggle:after, .btn.btn-active-icon-danger:hover:not(.btn-active).dropdown-toggle:after, .btn.btn-active-icon-danger:active:not(.btn-active).dropdown-toggle:after, .btn.btn-active-icon-danger.active.dropdown-toggle:after, .btn.btn-active-icon-danger.show.dropdown-toggle:after, .show > .btn.btn-active-icon-danger.dropdown-toggle:after {
  color: var(--bs-text-danger);
}

.btn.btn-text-danger {
  color: var(--bs-text-danger);
}

.btn-check:checked + .btn.btn-active-text-danger, .btn-check:active + .btn.btn-active-text-danger, .btn.btn-active-text-danger:focus:not(.btn-active), .btn.btn-active-text-danger:hover:not(.btn-active), .btn.btn-active-text-danger:active:not(.btn-active), .btn.btn-active-text-danger.active, .btn.btn-active-text-danger.show, .show > .btn.btn-active-text-danger {
  color: var(--bs-text-danger);
}

.btn.btn-color-dark {
  color: var(--bs-text-dark);
}

.btn.btn-color-dark i,
.btn.btn-color-dark .svg-icon {
  color: var(--bs-text-dark);
}

.btn.btn-color-dark.dropdown-toggle:after {
  color: var(--bs-text-dark);
}

.btn-check:checked + .btn.btn-active-color-dark, .btn-check:active + .btn.btn-active-color-dark, .btn.btn-active-color-dark:focus:not(.btn-active), .btn.btn-active-color-dark:hover:not(.btn-active), .btn.btn-active-color-dark:active:not(.btn-active), .btn.btn-active-color-dark.active, .btn.btn-active-color-dark.show, .show > .btn.btn-active-color-dark {
  color: var(--bs-text-dark);
}

.btn-check:checked + .btn.btn-active-color-dark i,
.btn-check:checked + .btn.btn-active-color-dark .svg-icon, .btn-check:active + .btn.btn-active-color-dark i,
.btn-check:active + .btn.btn-active-color-dark .svg-icon, .btn.btn-active-color-dark:focus:not(.btn-active) i,
.btn.btn-active-color-dark:focus:not(.btn-active) .svg-icon, .btn.btn-active-color-dark:hover:not(.btn-active) i,
.btn.btn-active-color-dark:hover:not(.btn-active) .svg-icon, .btn.btn-active-color-dark:active:not(.btn-active) i,
.btn.btn-active-color-dark:active:not(.btn-active) .svg-icon, .btn.btn-active-color-dark.active i,
.btn.btn-active-color-dark.active .svg-icon, .btn.btn-active-color-dark.show i,
.btn.btn-active-color-dark.show .svg-icon, .show > .btn.btn-active-color-dark i,
.show > .btn.btn-active-color-dark .svg-icon {
  color: var(--bs-text-dark);
}

.btn-check:checked + .btn.btn-active-color-dark.dropdown-toggle:after, .btn-check:active + .btn.btn-active-color-dark.dropdown-toggle:after, .btn.btn-active-color-dark:focus:not(.btn-active).dropdown-toggle:after, .btn.btn-active-color-dark:hover:not(.btn-active).dropdown-toggle:after, .btn.btn-active-color-dark:active:not(.btn-active).dropdown-toggle:after, .btn.btn-active-color-dark.active.dropdown-toggle:after, .btn.btn-active-color-dark.show.dropdown-toggle:after, .show > .btn.btn-active-color-dark.dropdown-toggle:after {
  color: var(--bs-text-dark);
}

.btn.btn-icon-dark i,
.btn.btn-icon-dark .svg-icon {
  color: var(--bs-text-dark);
}

.btn.btn-icon-dark.dropdown-toggle:after {
  color: var(--bs-text-dark);
}

.btn-check:checked + .btn.btn-active-icon-dark i,
.btn-check:checked + .btn.btn-active-icon-dark .svg-icon, .btn-check:active + .btn.btn-active-icon-dark i,
.btn-check:active + .btn.btn-active-icon-dark .svg-icon, .btn.btn-active-icon-dark:focus:not(.btn-active) i,
.btn.btn-active-icon-dark:focus:not(.btn-active) .svg-icon, .btn.btn-active-icon-dark:hover:not(.btn-active) i,
.btn.btn-active-icon-dark:hover:not(.btn-active) .svg-icon, .btn.btn-active-icon-dark:active:not(.btn-active) i,
.btn.btn-active-icon-dark:active:not(.btn-active) .svg-icon, .btn.btn-active-icon-dark.active i,
.btn.btn-active-icon-dark.active .svg-icon, .btn.btn-active-icon-dark.show i,
.btn.btn-active-icon-dark.show .svg-icon, .show > .btn.btn-active-icon-dark i,
.show > .btn.btn-active-icon-dark .svg-icon {
  color: var(--bs-text-dark);
}

.btn-check:checked + .btn.btn-active-icon-dark.dropdown-toggle:after, .btn-check:active + .btn.btn-active-icon-dark.dropdown-toggle:after, .btn.btn-active-icon-dark:focus:not(.btn-active).dropdown-toggle:after, .btn.btn-active-icon-dark:hover:not(.btn-active).dropdown-toggle:after, .btn.btn-active-icon-dark:active:not(.btn-active).dropdown-toggle:after, .btn.btn-active-icon-dark.active.dropdown-toggle:after, .btn.btn-active-icon-dark.show.dropdown-toggle:after, .show > .btn.btn-active-icon-dark.dropdown-toggle:after {
  color: var(--bs-text-dark);
}

.btn.btn-text-dark {
  color: var(--bs-text-dark);
}

.btn-check:checked + .btn.btn-active-text-dark, .btn-check:active + .btn.btn-active-text-dark, .btn.btn-active-text-dark:focus:not(.btn-active), .btn.btn-active-text-dark:hover:not(.btn-active), .btn.btn-active-text-dark:active:not(.btn-active), .btn.btn-active-text-dark.active, .btn.btn-active-text-dark.show, .show > .btn.btn-active-text-dark {
  color: var(--bs-text-dark);
}

.btn.btn-color-muted {
  color: var(--bs-text-muted);
}

.btn.btn-color-muted i,
.btn.btn-color-muted .svg-icon {
  color: var(--bs-text-muted);
}

.btn.btn-color-muted.dropdown-toggle:after {
  color: var(--bs-text-muted);
}

.btn-check:checked + .btn.btn-active-color-muted, .btn-check:active + .btn.btn-active-color-muted, .btn.btn-active-color-muted:focus:not(.btn-active), .btn.btn-active-color-muted:hover:not(.btn-active), .btn.btn-active-color-muted:active:not(.btn-active), .btn.btn-active-color-muted.active, .btn.btn-active-color-muted.show, .show > .btn.btn-active-color-muted {
  color: var(--bs-text-muted);
}

.btn-check:checked + .btn.btn-active-color-muted i,
.btn-check:checked + .btn.btn-active-color-muted .svg-icon, .btn-check:active + .btn.btn-active-color-muted i,
.btn-check:active + .btn.btn-active-color-muted .svg-icon, .btn.btn-active-color-muted:focus:not(.btn-active) i,
.btn.btn-active-color-muted:focus:not(.btn-active) .svg-icon, .btn.btn-active-color-muted:hover:not(.btn-active) i,
.btn.btn-active-color-muted:hover:not(.btn-active) .svg-icon, .btn.btn-active-color-muted:active:not(.btn-active) i,
.btn.btn-active-color-muted:active:not(.btn-active) .svg-icon, .btn.btn-active-color-muted.active i,
.btn.btn-active-color-muted.active .svg-icon, .btn.btn-active-color-muted.show i,
.btn.btn-active-color-muted.show .svg-icon, .show > .btn.btn-active-color-muted i,
.show > .btn.btn-active-color-muted .svg-icon {
  color: var(--bs-text-muted);
}

.btn-check:checked + .btn.btn-active-color-muted.dropdown-toggle:after, .btn-check:active + .btn.btn-active-color-muted.dropdown-toggle:after, .btn.btn-active-color-muted:focus:not(.btn-active).dropdown-toggle:after, .btn.btn-active-color-muted:hover:not(.btn-active).dropdown-toggle:after, .btn.btn-active-color-muted:active:not(.btn-active).dropdown-toggle:after, .btn.btn-active-color-muted.active.dropdown-toggle:after, .btn.btn-active-color-muted.show.dropdown-toggle:after, .show > .btn.btn-active-color-muted.dropdown-toggle:after {
  color: var(--bs-text-muted);
}

.btn.btn-icon-muted i,
.btn.btn-icon-muted .svg-icon {
  color: var(--bs-text-muted);
}

.btn.btn-icon-muted.dropdown-toggle:after {
  color: var(--bs-text-muted);
}

.btn-check:checked + .btn.btn-active-icon-muted i,
.btn-check:checked + .btn.btn-active-icon-muted .svg-icon, .btn-check:active + .btn.btn-active-icon-muted i,
.btn-check:active + .btn.btn-active-icon-muted .svg-icon, .btn.btn-active-icon-muted:focus:not(.btn-active) i,
.btn.btn-active-icon-muted:focus:not(.btn-active) .svg-icon, .btn.btn-active-icon-muted:hover:not(.btn-active) i,
.btn.btn-active-icon-muted:hover:not(.btn-active) .svg-icon, .btn.btn-active-icon-muted:active:not(.btn-active) i,
.btn.btn-active-icon-muted:active:not(.btn-active) .svg-icon, .btn.btn-active-icon-muted.active i,
.btn.btn-active-icon-muted.active .svg-icon, .btn.btn-active-icon-muted.show i,
.btn.btn-active-icon-muted.show .svg-icon, .show > .btn.btn-active-icon-muted i,
.show > .btn.btn-active-icon-muted .svg-icon {
  color: var(--bs-text-muted);
}

.btn-check:checked + .btn.btn-active-icon-muted.dropdown-toggle:after, .btn-check:active + .btn.btn-active-icon-muted.dropdown-toggle:after, .btn.btn-active-icon-muted:focus:not(.btn-active).dropdown-toggle:after, .btn.btn-active-icon-muted:hover:not(.btn-active).dropdown-toggle:after, .btn.btn-active-icon-muted:active:not(.btn-active).dropdown-toggle:after, .btn.btn-active-icon-muted.active.dropdown-toggle:after, .btn.btn-active-icon-muted.show.dropdown-toggle:after, .show > .btn.btn-active-icon-muted.dropdown-toggle:after {
  color: var(--bs-text-muted);
}

.btn.btn-text-muted {
  color: var(--bs-text-muted);
}

.btn-check:checked + .btn.btn-active-text-muted, .btn-check:active + .btn.btn-active-text-muted, .btn.btn-active-text-muted:focus:not(.btn-active), .btn.btn-active-text-muted:hover:not(.btn-active), .btn.btn-active-text-muted:active:not(.btn-active), .btn.btn-active-text-muted.active, .btn.btn-active-text-muted.show, .show > .btn.btn-active-text-muted {
  color: var(--bs-text-muted);
}

.btn.btn-color-gray-100 {
  color: var(--bs-text-gray-100);
}

.btn.btn-color-gray-100 i,
.btn.btn-color-gray-100 .svg-icon {
  color: var(--bs-text-gray-100);
}

.btn.btn-color-gray-100.dropdown-toggle:after {
  color: var(--bs-text-gray-100);
}

.btn-check:checked + .btn.btn-active-color-gray-100, .btn-check:active + .btn.btn-active-color-gray-100, .btn.btn-active-color-gray-100:focus:not(.btn-active), .btn.btn-active-color-gray-100:hover:not(.btn-active), .btn.btn-active-color-gray-100:active:not(.btn-active), .btn.btn-active-color-gray-100.active, .btn.btn-active-color-gray-100.show, .show > .btn.btn-active-color-gray-100 {
  color: var(--bs-text-gray-100);
}

.btn-check:checked + .btn.btn-active-color-gray-100 i,
.btn-check:checked + .btn.btn-active-color-gray-100 .svg-icon, .btn-check:active + .btn.btn-active-color-gray-100 i,
.btn-check:active + .btn.btn-active-color-gray-100 .svg-icon, .btn.btn-active-color-gray-100:focus:not(.btn-active) i,
.btn.btn-active-color-gray-100:focus:not(.btn-active) .svg-icon, .btn.btn-active-color-gray-100:hover:not(.btn-active) i,
.btn.btn-active-color-gray-100:hover:not(.btn-active) .svg-icon, .btn.btn-active-color-gray-100:active:not(.btn-active) i,
.btn.btn-active-color-gray-100:active:not(.btn-active) .svg-icon, .btn.btn-active-color-gray-100.active i,
.btn.btn-active-color-gray-100.active .svg-icon, .btn.btn-active-color-gray-100.show i,
.btn.btn-active-color-gray-100.show .svg-icon, .show > .btn.btn-active-color-gray-100 i,
.show > .btn.btn-active-color-gray-100 .svg-icon {
  color: var(--bs-text-gray-100);
}

.btn-check:checked + .btn.btn-active-color-gray-100.dropdown-toggle:after, .btn-check:active + .btn.btn-active-color-gray-100.dropdown-toggle:after, .btn.btn-active-color-gray-100:focus:not(.btn-active).dropdown-toggle:after, .btn.btn-active-color-gray-100:hover:not(.btn-active).dropdown-toggle:after, .btn.btn-active-color-gray-100:active:not(.btn-active).dropdown-toggle:after, .btn.btn-active-color-gray-100.active.dropdown-toggle:after, .btn.btn-active-color-gray-100.show.dropdown-toggle:after, .show > .btn.btn-active-color-gray-100.dropdown-toggle:after {
  color: var(--bs-text-gray-100);
}

.btn.btn-icon-gray-100 i,
.btn.btn-icon-gray-100 .svg-icon {
  color: var(--bs-text-gray-100);
}

.btn.btn-icon-gray-100.dropdown-toggle:after {
  color: var(--bs-text-gray-100);
}

.btn-check:checked + .btn.btn-active-icon-gray-100 i,
.btn-check:checked + .btn.btn-active-icon-gray-100 .svg-icon, .btn-check:active + .btn.btn-active-icon-gray-100 i,
.btn-check:active + .btn.btn-active-icon-gray-100 .svg-icon, .btn.btn-active-icon-gray-100:focus:not(.btn-active) i,
.btn.btn-active-icon-gray-100:focus:not(.btn-active) .svg-icon, .btn.btn-active-icon-gray-100:hover:not(.btn-active) i,
.btn.btn-active-icon-gray-100:hover:not(.btn-active) .svg-icon, .btn.btn-active-icon-gray-100:active:not(.btn-active) i,
.btn.btn-active-icon-gray-100:active:not(.btn-active) .svg-icon, .btn.btn-active-icon-gray-100.active i,
.btn.btn-active-icon-gray-100.active .svg-icon, .btn.btn-active-icon-gray-100.show i,
.btn.btn-active-icon-gray-100.show .svg-icon, .show > .btn.btn-active-icon-gray-100 i,
.show > .btn.btn-active-icon-gray-100 .svg-icon {
  color: var(--bs-text-gray-100);
}

.btn-check:checked + .btn.btn-active-icon-gray-100.dropdown-toggle:after, .btn-check:active + .btn.btn-active-icon-gray-100.dropdown-toggle:after, .btn.btn-active-icon-gray-100:focus:not(.btn-active).dropdown-toggle:after, .btn.btn-active-icon-gray-100:hover:not(.btn-active).dropdown-toggle:after, .btn.btn-active-icon-gray-100:active:not(.btn-active).dropdown-toggle:after, .btn.btn-active-icon-gray-100.active.dropdown-toggle:after, .btn.btn-active-icon-gray-100.show.dropdown-toggle:after, .show > .btn.btn-active-icon-gray-100.dropdown-toggle:after {
  color: var(--bs-text-gray-100);
}

.btn.btn-text-gray-100 {
  color: var(--bs-text-gray-100);
}

.btn-check:checked + .btn.btn-active-text-gray-100, .btn-check:active + .btn.btn-active-text-gray-100, .btn.btn-active-text-gray-100:focus:not(.btn-active), .btn.btn-active-text-gray-100:hover:not(.btn-active), .btn.btn-active-text-gray-100:active:not(.btn-active), .btn.btn-active-text-gray-100.active, .btn.btn-active-text-gray-100.show, .show > .btn.btn-active-text-gray-100 {
  color: var(--bs-text-gray-100);
}

.btn.btn-color-gray-200 {
  color: var(--bs-text-gray-200);
}

.btn.btn-color-gray-200 i,
.btn.btn-color-gray-200 .svg-icon {
  color: var(--bs-text-gray-200);
}

.btn.btn-color-gray-200.dropdown-toggle:after {
  color: var(--bs-text-gray-200);
}

.btn-check:checked + .btn.btn-active-color-gray-200, .btn-check:active + .btn.btn-active-color-gray-200, .btn.btn-active-color-gray-200:focus:not(.btn-active), .btn.btn-active-color-gray-200:hover:not(.btn-active), .btn.btn-active-color-gray-200:active:not(.btn-active), .btn.btn-active-color-gray-200.active, .btn.btn-active-color-gray-200.show, .show > .btn.btn-active-color-gray-200 {
  color: var(--bs-text-gray-200);
}

.btn-check:checked + .btn.btn-active-color-gray-200 i,
.btn-check:checked + .btn.btn-active-color-gray-200 .svg-icon, .btn-check:active + .btn.btn-active-color-gray-200 i,
.btn-check:active + .btn.btn-active-color-gray-200 .svg-icon, .btn.btn-active-color-gray-200:focus:not(.btn-active) i,
.btn.btn-active-color-gray-200:focus:not(.btn-active) .svg-icon, .btn.btn-active-color-gray-200:hover:not(.btn-active) i,
.btn.btn-active-color-gray-200:hover:not(.btn-active) .svg-icon, .btn.btn-active-color-gray-200:active:not(.btn-active) i,
.btn.btn-active-color-gray-200:active:not(.btn-active) .svg-icon, .btn.btn-active-color-gray-200.active i,
.btn.btn-active-color-gray-200.active .svg-icon, .btn.btn-active-color-gray-200.show i,
.btn.btn-active-color-gray-200.show .svg-icon, .show > .btn.btn-active-color-gray-200 i,
.show > .btn.btn-active-color-gray-200 .svg-icon {
  color: var(--bs-text-gray-200);
}

.btn-check:checked + .btn.btn-active-color-gray-200.dropdown-toggle:after, .btn-check:active + .btn.btn-active-color-gray-200.dropdown-toggle:after, .btn.btn-active-color-gray-200:focus:not(.btn-active).dropdown-toggle:after, .btn.btn-active-color-gray-200:hover:not(.btn-active).dropdown-toggle:after, .btn.btn-active-color-gray-200:active:not(.btn-active).dropdown-toggle:after, .btn.btn-active-color-gray-200.active.dropdown-toggle:after, .btn.btn-active-color-gray-200.show.dropdown-toggle:after, .show > .btn.btn-active-color-gray-200.dropdown-toggle:after {
  color: var(--bs-text-gray-200);
}

.btn.btn-icon-gray-200 i,
.btn.btn-icon-gray-200 .svg-icon {
  color: var(--bs-text-gray-200);
}

.btn.btn-icon-gray-200.dropdown-toggle:after {
  color: var(--bs-text-gray-200);
}

.btn-check:checked + .btn.btn-active-icon-gray-200 i,
.btn-check:checked + .btn.btn-active-icon-gray-200 .svg-icon, .btn-check:active + .btn.btn-active-icon-gray-200 i,
.btn-check:active + .btn.btn-active-icon-gray-200 .svg-icon, .btn.btn-active-icon-gray-200:focus:not(.btn-active) i,
.btn.btn-active-icon-gray-200:focus:not(.btn-active) .svg-icon, .btn.btn-active-icon-gray-200:hover:not(.btn-active) i,
.btn.btn-active-icon-gray-200:hover:not(.btn-active) .svg-icon, .btn.btn-active-icon-gray-200:active:not(.btn-active) i,
.btn.btn-active-icon-gray-200:active:not(.btn-active) .svg-icon, .btn.btn-active-icon-gray-200.active i,
.btn.btn-active-icon-gray-200.active .svg-icon, .btn.btn-active-icon-gray-200.show i,
.btn.btn-active-icon-gray-200.show .svg-icon, .show > .btn.btn-active-icon-gray-200 i,
.show > .btn.btn-active-icon-gray-200 .svg-icon {
  color: var(--bs-text-gray-200);
}

.btn-check:checked + .btn.btn-active-icon-gray-200.dropdown-toggle:after, .btn-check:active + .btn.btn-active-icon-gray-200.dropdown-toggle:after, .btn.btn-active-icon-gray-200:focus:not(.btn-active).dropdown-toggle:after, .btn.btn-active-icon-gray-200:hover:not(.btn-active).dropdown-toggle:after, .btn.btn-active-icon-gray-200:active:not(.btn-active).dropdown-toggle:after, .btn.btn-active-icon-gray-200.active.dropdown-toggle:after, .btn.btn-active-icon-gray-200.show.dropdown-toggle:after, .show > .btn.btn-active-icon-gray-200.dropdown-toggle:after {
  color: var(--bs-text-gray-200);
}

.btn.btn-text-gray-200 {
  color: var(--bs-text-gray-200);
}

.btn-check:checked + .btn.btn-active-text-gray-200, .btn-check:active + .btn.btn-active-text-gray-200, .btn.btn-active-text-gray-200:focus:not(.btn-active), .btn.btn-active-text-gray-200:hover:not(.btn-active), .btn.btn-active-text-gray-200:active:not(.btn-active), .btn.btn-active-text-gray-200.active, .btn.btn-active-text-gray-200.show, .show > .btn.btn-active-text-gray-200 {
  color: var(--bs-text-gray-200);
}

.btn.btn-color-gray-300 {
  color: var(--bs-text-gray-300);
}

.btn.btn-color-gray-300 i,
.btn.btn-color-gray-300 .svg-icon {
  color: var(--bs-text-gray-300);
}

.btn.btn-color-gray-300.dropdown-toggle:after {
  color: var(--bs-text-gray-300);
}

.btn-check:checked + .btn.btn-active-color-gray-300, .btn-check:active + .btn.btn-active-color-gray-300, .btn.btn-active-color-gray-300:focus:not(.btn-active), .btn.btn-active-color-gray-300:hover:not(.btn-active), .btn.btn-active-color-gray-300:active:not(.btn-active), .btn.btn-active-color-gray-300.active, .btn.btn-active-color-gray-300.show, .show > .btn.btn-active-color-gray-300 {
  color: var(--bs-text-gray-300);
}

.btn-check:checked + .btn.btn-active-color-gray-300 i,
.btn-check:checked + .btn.btn-active-color-gray-300 .svg-icon, .btn-check:active + .btn.btn-active-color-gray-300 i,
.btn-check:active + .btn.btn-active-color-gray-300 .svg-icon, .btn.btn-active-color-gray-300:focus:not(.btn-active) i,
.btn.btn-active-color-gray-300:focus:not(.btn-active) .svg-icon, .btn.btn-active-color-gray-300:hover:not(.btn-active) i,
.btn.btn-active-color-gray-300:hover:not(.btn-active) .svg-icon, .btn.btn-active-color-gray-300:active:not(.btn-active) i,
.btn.btn-active-color-gray-300:active:not(.btn-active) .svg-icon, .btn.btn-active-color-gray-300.active i,
.btn.btn-active-color-gray-300.active .svg-icon, .btn.btn-active-color-gray-300.show i,
.btn.btn-active-color-gray-300.show .svg-icon, .show > .btn.btn-active-color-gray-300 i,
.show > .btn.btn-active-color-gray-300 .svg-icon {
  color: var(--bs-text-gray-300);
}

.btn-check:checked + .btn.btn-active-color-gray-300.dropdown-toggle:after, .btn-check:active + .btn.btn-active-color-gray-300.dropdown-toggle:after, .btn.btn-active-color-gray-300:focus:not(.btn-active).dropdown-toggle:after, .btn.btn-active-color-gray-300:hover:not(.btn-active).dropdown-toggle:after, .btn.btn-active-color-gray-300:active:not(.btn-active).dropdown-toggle:after, .btn.btn-active-color-gray-300.active.dropdown-toggle:after, .btn.btn-active-color-gray-300.show.dropdown-toggle:after, .show > .btn.btn-active-color-gray-300.dropdown-toggle:after {
  color: var(--bs-text-gray-300);
}

.btn.btn-icon-gray-300 i,
.btn.btn-icon-gray-300 .svg-icon {
  color: var(--bs-text-gray-300);
}

.btn.btn-icon-gray-300.dropdown-toggle:after {
  color: var(--bs-text-gray-300);
}

.btn-check:checked + .btn.btn-active-icon-gray-300 i,
.btn-check:checked + .btn.btn-active-icon-gray-300 .svg-icon, .btn-check:active + .btn.btn-active-icon-gray-300 i,
.btn-check:active + .btn.btn-active-icon-gray-300 .svg-icon, .btn.btn-active-icon-gray-300:focus:not(.btn-active) i,
.btn.btn-active-icon-gray-300:focus:not(.btn-active) .svg-icon, .btn.btn-active-icon-gray-300:hover:not(.btn-active) i,
.btn.btn-active-icon-gray-300:hover:not(.btn-active) .svg-icon, .btn.btn-active-icon-gray-300:active:not(.btn-active) i,
.btn.btn-active-icon-gray-300:active:not(.btn-active) .svg-icon, .btn.btn-active-icon-gray-300.active i,
.btn.btn-active-icon-gray-300.active .svg-icon, .btn.btn-active-icon-gray-300.show i,
.btn.btn-active-icon-gray-300.show .svg-icon, .show > .btn.btn-active-icon-gray-300 i,
.show > .btn.btn-active-icon-gray-300 .svg-icon {
  color: var(--bs-text-gray-300);
}

.btn-check:checked + .btn.btn-active-icon-gray-300.dropdown-toggle:after, .btn-check:active + .btn.btn-active-icon-gray-300.dropdown-toggle:after, .btn.btn-active-icon-gray-300:focus:not(.btn-active).dropdown-toggle:after, .btn.btn-active-icon-gray-300:hover:not(.btn-active).dropdown-toggle:after, .btn.btn-active-icon-gray-300:active:not(.btn-active).dropdown-toggle:after, .btn.btn-active-icon-gray-300.active.dropdown-toggle:after, .btn.btn-active-icon-gray-300.show.dropdown-toggle:after, .show > .btn.btn-active-icon-gray-300.dropdown-toggle:after {
  color: var(--bs-text-gray-300);
}

.btn.btn-text-gray-300 {
  color: var(--bs-text-gray-300);
}

.btn-check:checked + .btn.btn-active-text-gray-300, .btn-check:active + .btn.btn-active-text-gray-300, .btn.btn-active-text-gray-300:focus:not(.btn-active), .btn.btn-active-text-gray-300:hover:not(.btn-active), .btn.btn-active-text-gray-300:active:not(.btn-active), .btn.btn-active-text-gray-300.active, .btn.btn-active-text-gray-300.show, .show > .btn.btn-active-text-gray-300 {
  color: var(--bs-text-gray-300);
}

.btn.btn-color-gray-400 {
  color: var(--bs-text-gray-400);
}

.btn.btn-color-gray-400 i,
.btn.btn-color-gray-400 .svg-icon {
  color: var(--bs-text-gray-400);
}

.btn.btn-color-gray-400.dropdown-toggle:after {
  color: var(--bs-text-gray-400);
}

.btn-check:checked + .btn.btn-active-color-gray-400, .btn-check:active + .btn.btn-active-color-gray-400, .btn.btn-active-color-gray-400:focus:not(.btn-active), .btn.btn-active-color-gray-400:hover:not(.btn-active), .btn.btn-active-color-gray-400:active:not(.btn-active), .btn.btn-active-color-gray-400.active, .btn.btn-active-color-gray-400.show, .show > .btn.btn-active-color-gray-400 {
  color: var(--bs-text-gray-400);
}

.btn-check:checked + .btn.btn-active-color-gray-400 i,
.btn-check:checked + .btn.btn-active-color-gray-400 .svg-icon, .btn-check:active + .btn.btn-active-color-gray-400 i,
.btn-check:active + .btn.btn-active-color-gray-400 .svg-icon, .btn.btn-active-color-gray-400:focus:not(.btn-active) i,
.btn.btn-active-color-gray-400:focus:not(.btn-active) .svg-icon, .btn.btn-active-color-gray-400:hover:not(.btn-active) i,
.btn.btn-active-color-gray-400:hover:not(.btn-active) .svg-icon, .btn.btn-active-color-gray-400:active:not(.btn-active) i,
.btn.btn-active-color-gray-400:active:not(.btn-active) .svg-icon, .btn.btn-active-color-gray-400.active i,
.btn.btn-active-color-gray-400.active .svg-icon, .btn.btn-active-color-gray-400.show i,
.btn.btn-active-color-gray-400.show .svg-icon, .show > .btn.btn-active-color-gray-400 i,
.show > .btn.btn-active-color-gray-400 .svg-icon {
  color: var(--bs-text-gray-400);
}

.btn-check:checked + .btn.btn-active-color-gray-400.dropdown-toggle:after, .btn-check:active + .btn.btn-active-color-gray-400.dropdown-toggle:after, .btn.btn-active-color-gray-400:focus:not(.btn-active).dropdown-toggle:after, .btn.btn-active-color-gray-400:hover:not(.btn-active).dropdown-toggle:after, .btn.btn-active-color-gray-400:active:not(.btn-active).dropdown-toggle:after, .btn.btn-active-color-gray-400.active.dropdown-toggle:after, .btn.btn-active-color-gray-400.show.dropdown-toggle:after, .show > .btn.btn-active-color-gray-400.dropdown-toggle:after {
  color: var(--bs-text-gray-400);
}

.btn.btn-icon-gray-400 i,
.btn.btn-icon-gray-400 .svg-icon {
  color: var(--bs-text-gray-400);
}

.btn.btn-icon-gray-400.dropdown-toggle:after {
  color: var(--bs-text-gray-400);
}

.btn-check:checked + .btn.btn-active-icon-gray-400 i,
.btn-check:checked + .btn.btn-active-icon-gray-400 .svg-icon, .btn-check:active + .btn.btn-active-icon-gray-400 i,
.btn-check:active + .btn.btn-active-icon-gray-400 .svg-icon, .btn.btn-active-icon-gray-400:focus:not(.btn-active) i,
.btn.btn-active-icon-gray-400:focus:not(.btn-active) .svg-icon, .btn.btn-active-icon-gray-400:hover:not(.btn-active) i,
.btn.btn-active-icon-gray-400:hover:not(.btn-active) .svg-icon, .btn.btn-active-icon-gray-400:active:not(.btn-active) i,
.btn.btn-active-icon-gray-400:active:not(.btn-active) .svg-icon, .btn.btn-active-icon-gray-400.active i,
.btn.btn-active-icon-gray-400.active .svg-icon, .btn.btn-active-icon-gray-400.show i,
.btn.btn-active-icon-gray-400.show .svg-icon, .show > .btn.btn-active-icon-gray-400 i,
.show > .btn.btn-active-icon-gray-400 .svg-icon {
  color: var(--bs-text-gray-400);
}

.btn-check:checked + .btn.btn-active-icon-gray-400.dropdown-toggle:after, .btn-check:active + .btn.btn-active-icon-gray-400.dropdown-toggle:after, .btn.btn-active-icon-gray-400:focus:not(.btn-active).dropdown-toggle:after, .btn.btn-active-icon-gray-400:hover:not(.btn-active).dropdown-toggle:after, .btn.btn-active-icon-gray-400:active:not(.btn-active).dropdown-toggle:after, .btn.btn-active-icon-gray-400.active.dropdown-toggle:after, .btn.btn-active-icon-gray-400.show.dropdown-toggle:after, .show > .btn.btn-active-icon-gray-400.dropdown-toggle:after {
  color: var(--bs-text-gray-400);
}

.btn.btn-text-gray-400 {
  color: var(--bs-text-gray-400);
}

.btn-check:checked + .btn.btn-active-text-gray-400, .btn-check:active + .btn.btn-active-text-gray-400, .btn.btn-active-text-gray-400:focus:not(.btn-active), .btn.btn-active-text-gray-400:hover:not(.btn-active), .btn.btn-active-text-gray-400:active:not(.btn-active), .btn.btn-active-text-gray-400.active, .btn.btn-active-text-gray-400.show, .show > .btn.btn-active-text-gray-400 {
  color: var(--bs-text-gray-400);
}

.btn.btn-color-gray-500 {
  color: var(--bs-text-gray-500);
}

.btn.btn-color-gray-500 i,
.btn.btn-color-gray-500 .svg-icon {
  color: var(--bs-text-gray-500);
}

.btn.btn-color-gray-500.dropdown-toggle:after {
  color: var(--bs-text-gray-500);
}

.btn-check:checked + .btn.btn-active-color-gray-500, .btn-check:active + .btn.btn-active-color-gray-500, .btn.btn-active-color-gray-500:focus:not(.btn-active), .btn.btn-active-color-gray-500:hover:not(.btn-active), .btn.btn-active-color-gray-500:active:not(.btn-active), .btn.btn-active-color-gray-500.active, .btn.btn-active-color-gray-500.show, .show > .btn.btn-active-color-gray-500 {
  color: var(--bs-text-gray-500);
}

.btn-check:checked + .btn.btn-active-color-gray-500 i,
.btn-check:checked + .btn.btn-active-color-gray-500 .svg-icon, .btn-check:active + .btn.btn-active-color-gray-500 i,
.btn-check:active + .btn.btn-active-color-gray-500 .svg-icon, .btn.btn-active-color-gray-500:focus:not(.btn-active) i,
.btn.btn-active-color-gray-500:focus:not(.btn-active) .svg-icon, .btn.btn-active-color-gray-500:hover:not(.btn-active) i,
.btn.btn-active-color-gray-500:hover:not(.btn-active) .svg-icon, .btn.btn-active-color-gray-500:active:not(.btn-active) i,
.btn.btn-active-color-gray-500:active:not(.btn-active) .svg-icon, .btn.btn-active-color-gray-500.active i,
.btn.btn-active-color-gray-500.active .svg-icon, .btn.btn-active-color-gray-500.show i,
.btn.btn-active-color-gray-500.show .svg-icon, .show > .btn.btn-active-color-gray-500 i,
.show > .btn.btn-active-color-gray-500 .svg-icon {
  color: var(--bs-text-gray-500);
}

.btn-check:checked + .btn.btn-active-color-gray-500.dropdown-toggle:after, .btn-check:active + .btn.btn-active-color-gray-500.dropdown-toggle:after, .btn.btn-active-color-gray-500:focus:not(.btn-active).dropdown-toggle:after, .btn.btn-active-color-gray-500:hover:not(.btn-active).dropdown-toggle:after, .btn.btn-active-color-gray-500:active:not(.btn-active).dropdown-toggle:after, .btn.btn-active-color-gray-500.active.dropdown-toggle:after, .btn.btn-active-color-gray-500.show.dropdown-toggle:after, .show > .btn.btn-active-color-gray-500.dropdown-toggle:after {
  color: var(--bs-text-gray-500);
}

.btn.btn-icon-gray-500 i,
.btn.btn-icon-gray-500 .svg-icon {
  color: var(--bs-text-gray-500);
}

.btn.btn-icon-gray-500.dropdown-toggle:after {
  color: var(--bs-text-gray-500);
}

.btn-check:checked + .btn.btn-active-icon-gray-500 i,
.btn-check:checked + .btn.btn-active-icon-gray-500 .svg-icon, .btn-check:active + .btn.btn-active-icon-gray-500 i,
.btn-check:active + .btn.btn-active-icon-gray-500 .svg-icon, .btn.btn-active-icon-gray-500:focus:not(.btn-active) i,
.btn.btn-active-icon-gray-500:focus:not(.btn-active) .svg-icon, .btn.btn-active-icon-gray-500:hover:not(.btn-active) i,
.btn.btn-active-icon-gray-500:hover:not(.btn-active) .svg-icon, .btn.btn-active-icon-gray-500:active:not(.btn-active) i,
.btn.btn-active-icon-gray-500:active:not(.btn-active) .svg-icon, .btn.btn-active-icon-gray-500.active i,
.btn.btn-active-icon-gray-500.active .svg-icon, .btn.btn-active-icon-gray-500.show i,
.btn.btn-active-icon-gray-500.show .svg-icon, .show > .btn.btn-active-icon-gray-500 i,
.show > .btn.btn-active-icon-gray-500 .svg-icon {
  color: var(--bs-text-gray-500);
}

.btn-check:checked + .btn.btn-active-icon-gray-500.dropdown-toggle:after, .btn-check:active + .btn.btn-active-icon-gray-500.dropdown-toggle:after, .btn.btn-active-icon-gray-500:focus:not(.btn-active).dropdown-toggle:after, .btn.btn-active-icon-gray-500:hover:not(.btn-active).dropdown-toggle:after, .btn.btn-active-icon-gray-500:active:not(.btn-active).dropdown-toggle:after, .btn.btn-active-icon-gray-500.active.dropdown-toggle:after, .btn.btn-active-icon-gray-500.show.dropdown-toggle:after, .show > .btn.btn-active-icon-gray-500.dropdown-toggle:after {
  color: var(--bs-text-gray-500);
}

.btn.btn-text-gray-500 {
  color: var(--bs-text-gray-500);
}

.btn-check:checked + .btn.btn-active-text-gray-500, .btn-check:active + .btn.btn-active-text-gray-500, .btn.btn-active-text-gray-500:focus:not(.btn-active), .btn.btn-active-text-gray-500:hover:not(.btn-active), .btn.btn-active-text-gray-500:active:not(.btn-active), .btn.btn-active-text-gray-500.active, .btn.btn-active-text-gray-500.show, .show > .btn.btn-active-text-gray-500 {
  color: var(--bs-text-gray-500);
}

.btn.btn-color-gray-600 {
  color: var(--bs-text-gray-600);
}

.btn.btn-color-gray-600 i,
.btn.btn-color-gray-600 .svg-icon {
  color: var(--bs-text-gray-600);
}

.btn.btn-color-gray-600.dropdown-toggle:after {
  color: var(--bs-text-gray-600);
}

.btn-check:checked + .btn.btn-active-color-gray-600, .btn-check:active + .btn.btn-active-color-gray-600, .btn.btn-active-color-gray-600:focus:not(.btn-active), .btn.btn-active-color-gray-600:hover:not(.btn-active), .btn.btn-active-color-gray-600:active:not(.btn-active), .btn.btn-active-color-gray-600.active, .btn.btn-active-color-gray-600.show, .show > .btn.btn-active-color-gray-600 {
  color: var(--bs-text-gray-600);
}

.btn-check:checked + .btn.btn-active-color-gray-600 i,
.btn-check:checked + .btn.btn-active-color-gray-600 .svg-icon, .btn-check:active + .btn.btn-active-color-gray-600 i,
.btn-check:active + .btn.btn-active-color-gray-600 .svg-icon, .btn.btn-active-color-gray-600:focus:not(.btn-active) i,
.btn.btn-active-color-gray-600:focus:not(.btn-active) .svg-icon, .btn.btn-active-color-gray-600:hover:not(.btn-active) i,
.btn.btn-active-color-gray-600:hover:not(.btn-active) .svg-icon, .btn.btn-active-color-gray-600:active:not(.btn-active) i,
.btn.btn-active-color-gray-600:active:not(.btn-active) .svg-icon, .btn.btn-active-color-gray-600.active i,
.btn.btn-active-color-gray-600.active .svg-icon, .btn.btn-active-color-gray-600.show i,
.btn.btn-active-color-gray-600.show .svg-icon, .show > .btn.btn-active-color-gray-600 i,
.show > .btn.btn-active-color-gray-600 .svg-icon {
  color: var(--bs-text-gray-600);
}

.btn-check:checked + .btn.btn-active-color-gray-600.dropdown-toggle:after, .btn-check:active + .btn.btn-active-color-gray-600.dropdown-toggle:after, .btn.btn-active-color-gray-600:focus:not(.btn-active).dropdown-toggle:after, .btn.btn-active-color-gray-600:hover:not(.btn-active).dropdown-toggle:after, .btn.btn-active-color-gray-600:active:not(.btn-active).dropdown-toggle:after, .btn.btn-active-color-gray-600.active.dropdown-toggle:after, .btn.btn-active-color-gray-600.show.dropdown-toggle:after, .show > .btn.btn-active-color-gray-600.dropdown-toggle:after {
  color: var(--bs-text-gray-600);
}

.btn.btn-icon-gray-600 i,
.btn.btn-icon-gray-600 .svg-icon {
  color: var(--bs-text-gray-600);
}

.btn.btn-icon-gray-600.dropdown-toggle:after {
  color: var(--bs-text-gray-600);
}

.btn-check:checked + .btn.btn-active-icon-gray-600 i,
.btn-check:checked + .btn.btn-active-icon-gray-600 .svg-icon, .btn-check:active + .btn.btn-active-icon-gray-600 i,
.btn-check:active + .btn.btn-active-icon-gray-600 .svg-icon, .btn.btn-active-icon-gray-600:focus:not(.btn-active) i,
.btn.btn-active-icon-gray-600:focus:not(.btn-active) .svg-icon, .btn.btn-active-icon-gray-600:hover:not(.btn-active) i,
.btn.btn-active-icon-gray-600:hover:not(.btn-active) .svg-icon, .btn.btn-active-icon-gray-600:active:not(.btn-active) i,
.btn.btn-active-icon-gray-600:active:not(.btn-active) .svg-icon, .btn.btn-active-icon-gray-600.active i,
.btn.btn-active-icon-gray-600.active .svg-icon, .btn.btn-active-icon-gray-600.show i,
.btn.btn-active-icon-gray-600.show .svg-icon, .show > .btn.btn-active-icon-gray-600 i,
.show > .btn.btn-active-icon-gray-600 .svg-icon {
  color: var(--bs-text-gray-600);
}

.btn-check:checked + .btn.btn-active-icon-gray-600.dropdown-toggle:after, .btn-check:active + .btn.btn-active-icon-gray-600.dropdown-toggle:after, .btn.btn-active-icon-gray-600:focus:not(.btn-active).dropdown-toggle:after, .btn.btn-active-icon-gray-600:hover:not(.btn-active).dropdown-toggle:after, .btn.btn-active-icon-gray-600:active:not(.btn-active).dropdown-toggle:after, .btn.btn-active-icon-gray-600.active.dropdown-toggle:after, .btn.btn-active-icon-gray-600.show.dropdown-toggle:after, .show > .btn.btn-active-icon-gray-600.dropdown-toggle:after {
  color: var(--bs-text-gray-600);
}

.btn.btn-text-gray-600 {
  color: var(--bs-text-gray-600);
}

.btn-check:checked + .btn.btn-active-text-gray-600, .btn-check:active + .btn.btn-active-text-gray-600, .btn.btn-active-text-gray-600:focus:not(.btn-active), .btn.btn-active-text-gray-600:hover:not(.btn-active), .btn.btn-active-text-gray-600:active:not(.btn-active), .btn.btn-active-text-gray-600.active, .btn.btn-active-text-gray-600.show, .show > .btn.btn-active-text-gray-600 {
  color: var(--bs-text-gray-600);
}

.btn.btn-color-gray-700 {
  color: var(--bs-text-gray-700);
}

.btn.btn-color-gray-700 i,
.btn.btn-color-gray-700 .svg-icon {
  color: var(--bs-text-gray-700);
}

.btn.btn-color-gray-700.dropdown-toggle:after {
  color: var(--bs-text-gray-700);
}

.btn-check:checked + .btn.btn-active-color-gray-700, .btn-check:active + .btn.btn-active-color-gray-700, .btn.btn-active-color-gray-700:focus:not(.btn-active), .btn.btn-active-color-gray-700:hover:not(.btn-active), .btn.btn-active-color-gray-700:active:not(.btn-active), .btn.btn-active-color-gray-700.active, .btn.btn-active-color-gray-700.show, .show > .btn.btn-active-color-gray-700 {
  color: var(--bs-text-gray-700);
}

.btn-check:checked + .btn.btn-active-color-gray-700 i,
.btn-check:checked + .btn.btn-active-color-gray-700 .svg-icon, .btn-check:active + .btn.btn-active-color-gray-700 i,
.btn-check:active + .btn.btn-active-color-gray-700 .svg-icon, .btn.btn-active-color-gray-700:focus:not(.btn-active) i,
.btn.btn-active-color-gray-700:focus:not(.btn-active) .svg-icon, .btn.btn-active-color-gray-700:hover:not(.btn-active) i,
.btn.btn-active-color-gray-700:hover:not(.btn-active) .svg-icon, .btn.btn-active-color-gray-700:active:not(.btn-active) i,
.btn.btn-active-color-gray-700:active:not(.btn-active) .svg-icon, .btn.btn-active-color-gray-700.active i,
.btn.btn-active-color-gray-700.active .svg-icon, .btn.btn-active-color-gray-700.show i,
.btn.btn-active-color-gray-700.show .svg-icon, .show > .btn.btn-active-color-gray-700 i,
.show > .btn.btn-active-color-gray-700 .svg-icon {
  color: var(--bs-text-gray-700);
}

.btn-check:checked + .btn.btn-active-color-gray-700.dropdown-toggle:after, .btn-check:active + .btn.btn-active-color-gray-700.dropdown-toggle:after, .btn.btn-active-color-gray-700:focus:not(.btn-active).dropdown-toggle:after, .btn.btn-active-color-gray-700:hover:not(.btn-active).dropdown-toggle:after, .btn.btn-active-color-gray-700:active:not(.btn-active).dropdown-toggle:after, .btn.btn-active-color-gray-700.active.dropdown-toggle:after, .btn.btn-active-color-gray-700.show.dropdown-toggle:after, .show > .btn.btn-active-color-gray-700.dropdown-toggle:after {
  color: var(--bs-text-gray-700);
}

.btn.btn-icon-gray-700 i,
.btn.btn-icon-gray-700 .svg-icon {
  color: var(--bs-text-gray-700);
}

.btn.btn-icon-gray-700.dropdown-toggle:after {
  color: var(--bs-text-gray-700);
}

.btn-check:checked + .btn.btn-active-icon-gray-700 i,
.btn-check:checked + .btn.btn-active-icon-gray-700 .svg-icon, .btn-check:active + .btn.btn-active-icon-gray-700 i,
.btn-check:active + .btn.btn-active-icon-gray-700 .svg-icon, .btn.btn-active-icon-gray-700:focus:not(.btn-active) i,
.btn.btn-active-icon-gray-700:focus:not(.btn-active) .svg-icon, .btn.btn-active-icon-gray-700:hover:not(.btn-active) i,
.btn.btn-active-icon-gray-700:hover:not(.btn-active) .svg-icon, .btn.btn-active-icon-gray-700:active:not(.btn-active) i,
.btn.btn-active-icon-gray-700:active:not(.btn-active) .svg-icon, .btn.btn-active-icon-gray-700.active i,
.btn.btn-active-icon-gray-700.active .svg-icon, .btn.btn-active-icon-gray-700.show i,
.btn.btn-active-icon-gray-700.show .svg-icon, .show > .btn.btn-active-icon-gray-700 i,
.show > .btn.btn-active-icon-gray-700 .svg-icon {
  color: var(--bs-text-gray-700);
}

.btn-check:checked + .btn.btn-active-icon-gray-700.dropdown-toggle:after, .btn-check:active + .btn.btn-active-icon-gray-700.dropdown-toggle:after, .btn.btn-active-icon-gray-700:focus:not(.btn-active).dropdown-toggle:after, .btn.btn-active-icon-gray-700:hover:not(.btn-active).dropdown-toggle:after, .btn.btn-active-icon-gray-700:active:not(.btn-active).dropdown-toggle:after, .btn.btn-active-icon-gray-700.active.dropdown-toggle:after, .btn.btn-active-icon-gray-700.show.dropdown-toggle:after, .show > .btn.btn-active-icon-gray-700.dropdown-toggle:after {
  color: var(--bs-text-gray-700);
}

.btn.btn-text-gray-700 {
  color: var(--bs-text-gray-700);
}

.btn-check:checked + .btn.btn-active-text-gray-700, .btn-check:active + .btn.btn-active-text-gray-700, .btn.btn-active-text-gray-700:focus:not(.btn-active), .btn.btn-active-text-gray-700:hover:not(.btn-active), .btn.btn-active-text-gray-700:active:not(.btn-active), .btn.btn-active-text-gray-700.active, .btn.btn-active-text-gray-700.show, .show > .btn.btn-active-text-gray-700 {
  color: var(--bs-text-gray-700);
}

.btn.btn-color-gray-800 {
  color: var(--bs-text-gray-800);
}

.btn.btn-color-gray-800 i,
.btn.btn-color-gray-800 .svg-icon {
  color: var(--bs-text-gray-800);
}

.btn.btn-color-gray-800.dropdown-toggle:after {
  color: var(--bs-text-gray-800);
}

.btn-check:checked + .btn.btn-active-color-gray-800, .btn-check:active + .btn.btn-active-color-gray-800, .btn.btn-active-color-gray-800:focus:not(.btn-active), .btn.btn-active-color-gray-800:hover:not(.btn-active), .btn.btn-active-color-gray-800:active:not(.btn-active), .btn.btn-active-color-gray-800.active, .btn.btn-active-color-gray-800.show, .show > .btn.btn-active-color-gray-800 {
  color: var(--bs-text-gray-800);
}

.btn-check:checked + .btn.btn-active-color-gray-800 i,
.btn-check:checked + .btn.btn-active-color-gray-800 .svg-icon, .btn-check:active + .btn.btn-active-color-gray-800 i,
.btn-check:active + .btn.btn-active-color-gray-800 .svg-icon, .btn.btn-active-color-gray-800:focus:not(.btn-active) i,
.btn.btn-active-color-gray-800:focus:not(.btn-active) .svg-icon, .btn.btn-active-color-gray-800:hover:not(.btn-active) i,
.btn.btn-active-color-gray-800:hover:not(.btn-active) .svg-icon, .btn.btn-active-color-gray-800:active:not(.btn-active) i,
.btn.btn-active-color-gray-800:active:not(.btn-active) .svg-icon, .btn.btn-active-color-gray-800.active i,
.btn.btn-active-color-gray-800.active .svg-icon, .btn.btn-active-color-gray-800.show i,
.btn.btn-active-color-gray-800.show .svg-icon, .show > .btn.btn-active-color-gray-800 i,
.show > .btn.btn-active-color-gray-800 .svg-icon {
  color: var(--bs-text-gray-800);
}

.btn-check:checked + .btn.btn-active-color-gray-800.dropdown-toggle:after, .btn-check:active + .btn.btn-active-color-gray-800.dropdown-toggle:after, .btn.btn-active-color-gray-800:focus:not(.btn-active).dropdown-toggle:after, .btn.btn-active-color-gray-800:hover:not(.btn-active).dropdown-toggle:after, .btn.btn-active-color-gray-800:active:not(.btn-active).dropdown-toggle:after, .btn.btn-active-color-gray-800.active.dropdown-toggle:after, .btn.btn-active-color-gray-800.show.dropdown-toggle:after, .show > .btn.btn-active-color-gray-800.dropdown-toggle:after {
  color: var(--bs-text-gray-800);
}

.btn.btn-icon-gray-800 i,
.btn.btn-icon-gray-800 .svg-icon {
  color: var(--bs-text-gray-800);
}

.btn.btn-icon-gray-800.dropdown-toggle:after {
  color: var(--bs-text-gray-800);
}

.btn-check:checked + .btn.btn-active-icon-gray-800 i,
.btn-check:checked + .btn.btn-active-icon-gray-800 .svg-icon, .btn-check:active + .btn.btn-active-icon-gray-800 i,
.btn-check:active + .btn.btn-active-icon-gray-800 .svg-icon, .btn.btn-active-icon-gray-800:focus:not(.btn-active) i,
.btn.btn-active-icon-gray-800:focus:not(.btn-active) .svg-icon, .btn.btn-active-icon-gray-800:hover:not(.btn-active) i,
.btn.btn-active-icon-gray-800:hover:not(.btn-active) .svg-icon, .btn.btn-active-icon-gray-800:active:not(.btn-active) i,
.btn.btn-active-icon-gray-800:active:not(.btn-active) .svg-icon, .btn.btn-active-icon-gray-800.active i,
.btn.btn-active-icon-gray-800.active .svg-icon, .btn.btn-active-icon-gray-800.show i,
.btn.btn-active-icon-gray-800.show .svg-icon, .show > .btn.btn-active-icon-gray-800 i,
.show > .btn.btn-active-icon-gray-800 .svg-icon {
  color: var(--bs-text-gray-800);
}

.btn-check:checked + .btn.btn-active-icon-gray-800.dropdown-toggle:after, .btn-check:active + .btn.btn-active-icon-gray-800.dropdown-toggle:after, .btn.btn-active-icon-gray-800:focus:not(.btn-active).dropdown-toggle:after, .btn.btn-active-icon-gray-800:hover:not(.btn-active).dropdown-toggle:after, .btn.btn-active-icon-gray-800:active:not(.btn-active).dropdown-toggle:after, .btn.btn-active-icon-gray-800.active.dropdown-toggle:after, .btn.btn-active-icon-gray-800.show.dropdown-toggle:after, .show > .btn.btn-active-icon-gray-800.dropdown-toggle:after {
  color: var(--bs-text-gray-800);
}

.btn.btn-text-gray-800 {
  color: var(--bs-text-gray-800);
}

.btn-check:checked + .btn.btn-active-text-gray-800, .btn-check:active + .btn.btn-active-text-gray-800, .btn.btn-active-text-gray-800:focus:not(.btn-active), .btn.btn-active-text-gray-800:hover:not(.btn-active), .btn.btn-active-text-gray-800:active:not(.btn-active), .btn.btn-active-text-gray-800.active, .btn.btn-active-text-gray-800.show, .show > .btn.btn-active-text-gray-800 {
  color: var(--bs-text-gray-800);
}

.btn.btn-color-gray-900 {
  color: var(--bs-text-gray-900);
}

.btn.btn-color-gray-900 i,
.btn.btn-color-gray-900 .svg-icon {
  color: var(--bs-text-gray-900);
}

.btn.btn-color-gray-900.dropdown-toggle:after {
  color: var(--bs-text-gray-900);
}

.btn-check:checked + .btn.btn-active-color-gray-900, .btn-check:active + .btn.btn-active-color-gray-900, .btn.btn-active-color-gray-900:focus:not(.btn-active), .btn.btn-active-color-gray-900:hover:not(.btn-active), .btn.btn-active-color-gray-900:active:not(.btn-active), .btn.btn-active-color-gray-900.active, .btn.btn-active-color-gray-900.show, .show > .btn.btn-active-color-gray-900 {
  color: var(--bs-text-gray-900);
}

.btn-check:checked + .btn.btn-active-color-gray-900 i,
.btn-check:checked + .btn.btn-active-color-gray-900 .svg-icon, .btn-check:active + .btn.btn-active-color-gray-900 i,
.btn-check:active + .btn.btn-active-color-gray-900 .svg-icon, .btn.btn-active-color-gray-900:focus:not(.btn-active) i,
.btn.btn-active-color-gray-900:focus:not(.btn-active) .svg-icon, .btn.btn-active-color-gray-900:hover:not(.btn-active) i,
.btn.btn-active-color-gray-900:hover:not(.btn-active) .svg-icon, .btn.btn-active-color-gray-900:active:not(.btn-active) i,
.btn.btn-active-color-gray-900:active:not(.btn-active) .svg-icon, .btn.btn-active-color-gray-900.active i,
.btn.btn-active-color-gray-900.active .svg-icon, .btn.btn-active-color-gray-900.show i,
.btn.btn-active-color-gray-900.show .svg-icon, .show > .btn.btn-active-color-gray-900 i,
.show > .btn.btn-active-color-gray-900 .svg-icon {
  color: var(--bs-text-gray-900);
}

.btn-check:checked + .btn.btn-active-color-gray-900.dropdown-toggle:after, .btn-check:active + .btn.btn-active-color-gray-900.dropdown-toggle:after, .btn.btn-active-color-gray-900:focus:not(.btn-active).dropdown-toggle:after, .btn.btn-active-color-gray-900:hover:not(.btn-active).dropdown-toggle:after, .btn.btn-active-color-gray-900:active:not(.btn-active).dropdown-toggle:after, .btn.btn-active-color-gray-900.active.dropdown-toggle:after, .btn.btn-active-color-gray-900.show.dropdown-toggle:after, .show > .btn.btn-active-color-gray-900.dropdown-toggle:after {
  color: var(--bs-text-gray-900);
}

.btn.btn-icon-gray-900 i,
.btn.btn-icon-gray-900 .svg-icon {
  color: var(--bs-text-gray-900);
}

.btn.btn-icon-gray-900.dropdown-toggle:after {
  color: var(--bs-text-gray-900);
}

.btn-check:checked + .btn.btn-active-icon-gray-900 i,
.btn-check:checked + .btn.btn-active-icon-gray-900 .svg-icon, .btn-check:active + .btn.btn-active-icon-gray-900 i,
.btn-check:active + .btn.btn-active-icon-gray-900 .svg-icon, .btn.btn-active-icon-gray-900:focus:not(.btn-active) i,
.btn.btn-active-icon-gray-900:focus:not(.btn-active) .svg-icon, .btn.btn-active-icon-gray-900:hover:not(.btn-active) i,
.btn.btn-active-icon-gray-900:hover:not(.btn-active) .svg-icon, .btn.btn-active-icon-gray-900:active:not(.btn-active) i,
.btn.btn-active-icon-gray-900:active:not(.btn-active) .svg-icon, .btn.btn-active-icon-gray-900.active i,
.btn.btn-active-icon-gray-900.active .svg-icon, .btn.btn-active-icon-gray-900.show i,
.btn.btn-active-icon-gray-900.show .svg-icon, .show > .btn.btn-active-icon-gray-900 i,
.show > .btn.btn-active-icon-gray-900 .svg-icon {
  color: var(--bs-text-gray-900);
}

.btn-check:checked + .btn.btn-active-icon-gray-900.dropdown-toggle:after, .btn-check:active + .btn.btn-active-icon-gray-900.dropdown-toggle:after, .btn.btn-active-icon-gray-900:focus:not(.btn-active).dropdown-toggle:after, .btn.btn-active-icon-gray-900:hover:not(.btn-active).dropdown-toggle:after, .btn.btn-active-icon-gray-900:active:not(.btn-active).dropdown-toggle:after, .btn.btn-active-icon-gray-900.active.dropdown-toggle:after, .btn.btn-active-icon-gray-900.show.dropdown-toggle:after, .show > .btn.btn-active-icon-gray-900.dropdown-toggle:after {
  color: var(--bs-text-gray-900);
}

.btn.btn-text-gray-900 {
  color: var(--bs-text-gray-900);
}

.btn-check:checked + .btn.btn-active-text-gray-900, .btn-check:active + .btn.btn-active-text-gray-900, .btn.btn-active-text-gray-900:focus:not(.btn-active), .btn.btn-active-text-gray-900:hover:not(.btn-active), .btn.btn-active-text-gray-900:active:not(.btn-active), .btn.btn-active-text-gray-900.active, .btn.btn-active-text-gray-900.show, .show > .btn.btn-active-text-gray-900 {
  color: var(--bs-text-gray-900);
}

.btn.btn-facebook {
  color: #ffffff;
  border-color: #3b5998;
  background-color: #3b5998;
}

.btn.btn-facebook i,
.btn.btn-facebook .svg-icon {
  color: #ffffff;
}

.btn.btn-facebook.dropdown-toggle:after {
  color: #ffffff;
}

.btn-check:checked + .btn.btn-facebook, .btn-check:active + .btn.btn-facebook, .btn.btn-facebook:focus:not(.btn-active), .btn.btn-facebook:hover:not(.btn-active), .btn.btn-facebook:active:not(.btn-active), .btn.btn-facebook.active, .btn.btn-facebook.show, .show > .btn.btn-facebook {
  border-color: #30497c;
  background-color: #30497c !important;
}

.btn.btn-light-facebook {
  color: #3b5998;
  border-color: rgba(59, 89, 152, 0.1);
  background-color: rgba(59, 89, 152, 0.1);
}

.btn.btn-light-facebook i,
.btn.btn-light-facebook .svg-icon {
  color: #3b5998;
}

.btn.btn-light-facebook.dropdown-toggle:after {
  color: #3b5998;
}

.btn-check:checked + .btn.btn-light-facebook, .btn-check:active + .btn.btn-light-facebook, .btn.btn-light-facebook:focus:not(.btn-active), .btn.btn-light-facebook:hover:not(.btn-active), .btn.btn-light-facebook:active:not(.btn-active), .btn.btn-light-facebook.active, .btn.btn-light-facebook.show, .show > .btn.btn-light-facebook {
  color: #ffffff;
  border-color: #3b5998;
  background-color: #3b5998 !important;
}

.btn-check:checked + .btn.btn-light-facebook i,
.btn-check:checked + .btn.btn-light-facebook .svg-icon, .btn-check:active + .btn.btn-light-facebook i,
.btn-check:active + .btn.btn-light-facebook .svg-icon, .btn.btn-light-facebook:focus:not(.btn-active) i,
.btn.btn-light-facebook:focus:not(.btn-active) .svg-icon, .btn.btn-light-facebook:hover:not(.btn-active) i,
.btn.btn-light-facebook:hover:not(.btn-active) .svg-icon, .btn.btn-light-facebook:active:not(.btn-active) i,
.btn.btn-light-facebook:active:not(.btn-active) .svg-icon, .btn.btn-light-facebook.active i,
.btn.btn-light-facebook.active .svg-icon, .btn.btn-light-facebook.show i,
.btn.btn-light-facebook.show .svg-icon, .show > .btn.btn-light-facebook i,
.show > .btn.btn-light-facebook .svg-icon {
  color: #ffffff;
}

.btn-check:checked + .btn.btn-light-facebook.dropdown-toggle:after, .btn-check:active + .btn.btn-light-facebook.dropdown-toggle:after, .btn.btn-light-facebook:focus:not(.btn-active).dropdown-toggle:after, .btn.btn-light-facebook:hover:not(.btn-active).dropdown-toggle:after, .btn.btn-light-facebook:active:not(.btn-active).dropdown-toggle:after, .btn.btn-light-facebook.active.dropdown-toggle:after, .btn.btn-light-facebook.show.dropdown-toggle:after, .show > .btn.btn-light-facebook.dropdown-toggle:after {
  color: #ffffff;
}

.btn.btn-google {
  color: #ffffff;
  border-color: #dd4b39;
  background-color: #dd4b39;
}

.btn.btn-google i,
.btn.btn-google .svg-icon {
  color: #ffffff;
}

.btn.btn-google.dropdown-toggle:after {
  color: #ffffff;
}

.btn-check:checked + .btn.btn-google, .btn-check:active + .btn.btn-google, .btn.btn-google:focus:not(.btn-active), .btn.btn-google:hover:not(.btn-active), .btn.btn-google:active:not(.btn-active), .btn.btn-google.active, .btn.btn-google.show, .show > .btn.btn-google {
  border-color: #cd3623;
  background-color: #cd3623 !important;
}

.btn.btn-light-google {
  color: #dd4b39;
  border-color: rgba(221, 75, 57, 0.1);
  background-color: rgba(221, 75, 57, 0.1);
}

.btn.btn-light-google i,
.btn.btn-light-google .svg-icon {
  color: #dd4b39;
}

.btn.btn-light-google.dropdown-toggle:after {
  color: #dd4b39;
}

.btn-check:checked + .btn.btn-light-google, .btn-check:active + .btn.btn-light-google, .btn.btn-light-google:focus:not(.btn-active), .btn.btn-light-google:hover:not(.btn-active), .btn.btn-light-google:active:not(.btn-active), .btn.btn-light-google.active, .btn.btn-light-google.show, .show > .btn.btn-light-google {
  color: #ffffff;
  border-color: #dd4b39;
  background-color: #dd4b39 !important;
}

.btn-check:checked + .btn.btn-light-google i,
.btn-check:checked + .btn.btn-light-google .svg-icon, .btn-check:active + .btn.btn-light-google i,
.btn-check:active + .btn.btn-light-google .svg-icon, .btn.btn-light-google:focus:not(.btn-active) i,
.btn.btn-light-google:focus:not(.btn-active) .svg-icon, .btn.btn-light-google:hover:not(.btn-active) i,
.btn.btn-light-google:hover:not(.btn-active) .svg-icon, .btn.btn-light-google:active:not(.btn-active) i,
.btn.btn-light-google:active:not(.btn-active) .svg-icon, .btn.btn-light-google.active i,
.btn.btn-light-google.active .svg-icon, .btn.btn-light-google.show i,
.btn.btn-light-google.show .svg-icon, .show > .btn.btn-light-google i,
.show > .btn.btn-light-google .svg-icon {
  color: #ffffff;
}

.btn-check:checked + .btn.btn-light-google.dropdown-toggle:after, .btn-check:active + .btn.btn-light-google.dropdown-toggle:after, .btn.btn-light-google:focus:not(.btn-active).dropdown-toggle:after, .btn.btn-light-google:hover:not(.btn-active).dropdown-toggle:after, .btn.btn-light-google:active:not(.btn-active).dropdown-toggle:after, .btn.btn-light-google.active.dropdown-toggle:after, .btn.btn-light-google.show.dropdown-toggle:after, .show > .btn.btn-light-google.dropdown-toggle:after {
  color: #ffffff;
}

.btn.btn-twitter {
  color: #ffffff;
  border-color: #1da1f2;
  background-color: #1da1f2;
}

.btn.btn-twitter i,
.btn.btn-twitter .svg-icon {
  color: #ffffff;
}

.btn.btn-twitter.dropdown-toggle:after {
  color: #ffffff;
}

.btn-check:checked + .btn.btn-twitter, .btn-check:active + .btn.btn-twitter, .btn.btn-twitter:focus:not(.btn-active), .btn.btn-twitter:hover:not(.btn-active), .btn.btn-twitter:active:not(.btn-active), .btn.btn-twitter.active, .btn.btn-twitter.show, .show > .btn.btn-twitter {
  border-color: #0d8ddc;
  background-color: #0d8ddc !important;
}

.btn.btn-light-twitter {
  color: #1da1f2;
  border-color: rgba(29, 161, 242, 0.1);
  background-color: rgba(29, 161, 242, 0.1);
}

.btn.btn-light-twitter i,
.btn.btn-light-twitter .svg-icon {
  color: #1da1f2;
}

.btn.btn-light-twitter.dropdown-toggle:after {
  color: #1da1f2;
}

.btn-check:checked + .btn.btn-light-twitter, .btn-check:active + .btn.btn-light-twitter, .btn.btn-light-twitter:focus:not(.btn-active), .btn.btn-light-twitter:hover:not(.btn-active), .btn.btn-light-twitter:active:not(.btn-active), .btn.btn-light-twitter.active, .btn.btn-light-twitter.show, .show > .btn.btn-light-twitter {
  color: #ffffff;
  border-color: #1da1f2;
  background-color: #1da1f2 !important;
}

.btn-check:checked + .btn.btn-light-twitter i,
.btn-check:checked + .btn.btn-light-twitter .svg-icon, .btn-check:active + .btn.btn-light-twitter i,
.btn-check:active + .btn.btn-light-twitter .svg-icon, .btn.btn-light-twitter:focus:not(.btn-active) i,
.btn.btn-light-twitter:focus:not(.btn-active) .svg-icon, .btn.btn-light-twitter:hover:not(.btn-active) i,
.btn.btn-light-twitter:hover:not(.btn-active) .svg-icon, .btn.btn-light-twitter:active:not(.btn-active) i,
.btn.btn-light-twitter:active:not(.btn-active) .svg-icon, .btn.btn-light-twitter.active i,
.btn.btn-light-twitter.active .svg-icon, .btn.btn-light-twitter.show i,
.btn.btn-light-twitter.show .svg-icon, .show > .btn.btn-light-twitter i,
.show > .btn.btn-light-twitter .svg-icon {
  color: #ffffff;
}

.btn-check:checked + .btn.btn-light-twitter.dropdown-toggle:after, .btn-check:active + .btn.btn-light-twitter.dropdown-toggle:after, .btn.btn-light-twitter:focus:not(.btn-active).dropdown-toggle:after, .btn.btn-light-twitter:hover:not(.btn-active).dropdown-toggle:after, .btn.btn-light-twitter:active:not(.btn-active).dropdown-toggle:after, .btn.btn-light-twitter.active.dropdown-toggle:after, .btn.btn-light-twitter.show.dropdown-toggle:after, .show > .btn.btn-light-twitter.dropdown-toggle:after {
  color: #ffffff;
}

.btn.btn-instagram {
  color: #ffffff;
  border-color: #e1306c;
  background-color: #e1306c;
}

.btn.btn-instagram i,
.btn.btn-instagram .svg-icon {
  color: #ffffff;
}

.btn.btn-instagram.dropdown-toggle:after {
  color: #ffffff;
}

.btn-check:checked + .btn.btn-instagram, .btn-check:active + .btn.btn-instagram, .btn.btn-instagram:focus:not(.btn-active), .btn.btn-instagram:hover:not(.btn-active), .btn.btn-instagram:active:not(.btn-active), .btn.btn-instagram.active, .btn.btn-instagram.show, .show > .btn.btn-instagram {
  border-color: #cd1e59;
  background-color: #cd1e59 !important;
}

.btn.btn-light-instagram {
  color: #e1306c;
  border-color: rgba(225, 48, 108, 0.1);
  background-color: rgba(225, 48, 108, 0.1);
}

.btn.btn-light-instagram i,
.btn.btn-light-instagram .svg-icon {
  color: #e1306c;
}

.btn.btn-light-instagram.dropdown-toggle:after {
  color: #e1306c;
}

.btn-check:checked + .btn.btn-light-instagram, .btn-check:active + .btn.btn-light-instagram, .btn.btn-light-instagram:focus:not(.btn-active), .btn.btn-light-instagram:hover:not(.btn-active), .btn.btn-light-instagram:active:not(.btn-active), .btn.btn-light-instagram.active, .btn.btn-light-instagram.show, .show > .btn.btn-light-instagram {
  color: #ffffff;
  border-color: #e1306c;
  background-color: #e1306c !important;
}

.btn-check:checked + .btn.btn-light-instagram i,
.btn-check:checked + .btn.btn-light-instagram .svg-icon, .btn-check:active + .btn.btn-light-instagram i,
.btn-check:active + .btn.btn-light-instagram .svg-icon, .btn.btn-light-instagram:focus:not(.btn-active) i,
.btn.btn-light-instagram:focus:not(.btn-active) .svg-icon, .btn.btn-light-instagram:hover:not(.btn-active) i,
.btn.btn-light-instagram:hover:not(.btn-active) .svg-icon, .btn.btn-light-instagram:active:not(.btn-active) i,
.btn.btn-light-instagram:active:not(.btn-active) .svg-icon, .btn.btn-light-instagram.active i,
.btn.btn-light-instagram.active .svg-icon, .btn.btn-light-instagram.show i,
.btn.btn-light-instagram.show .svg-icon, .show > .btn.btn-light-instagram i,
.show > .btn.btn-light-instagram .svg-icon {
  color: #ffffff;
}

.btn-check:checked + .btn.btn-light-instagram.dropdown-toggle:after, .btn-check:active + .btn.btn-light-instagram.dropdown-toggle:after, .btn.btn-light-instagram:focus:not(.btn-active).dropdown-toggle:after, .btn.btn-light-instagram:hover:not(.btn-active).dropdown-toggle:after, .btn.btn-light-instagram:active:not(.btn-active).dropdown-toggle:after, .btn.btn-light-instagram.active.dropdown-toggle:after, .btn.btn-light-instagram.show.dropdown-toggle:after, .show > .btn.btn-light-instagram.dropdown-toggle:after {
  color: #ffffff;
}

.btn.btn-youtube {
  color: #ffffff;
  border-color: #ff0000;
  background-color: #ff0000;
}

.btn.btn-youtube i,
.btn.btn-youtube .svg-icon {
  color: #ffffff;
}

.btn.btn-youtube.dropdown-toggle:after {
  color: #ffffff;
}

.btn-check:checked + .btn.btn-youtube, .btn-check:active + .btn.btn-youtube, .btn.btn-youtube:focus:not(.btn-active), .btn.btn-youtube:hover:not(.btn-active), .btn.btn-youtube:active:not(.btn-active), .btn.btn-youtube.active, .btn.btn-youtube.show, .show > .btn.btn-youtube {
  border-color: #d90000;
  background-color: #d90000 !important;
}

.btn.btn-light-youtube {
  color: #ff0000;
  border-color: rgba(255, 0, 0, 0.1);
  background-color: rgba(255, 0, 0, 0.1);
}

.btn.btn-light-youtube i,
.btn.btn-light-youtube .svg-icon {
  color: #ff0000;
}

.btn.btn-light-youtube.dropdown-toggle:after {
  color: #ff0000;
}

.btn-check:checked + .btn.btn-light-youtube, .btn-check:active + .btn.btn-light-youtube, .btn.btn-light-youtube:focus:not(.btn-active), .btn.btn-light-youtube:hover:not(.btn-active), .btn.btn-light-youtube:active:not(.btn-active), .btn.btn-light-youtube.active, .btn.btn-light-youtube.show, .show > .btn.btn-light-youtube {
  color: #ffffff;
  border-color: #ff0000;
  background-color: #ff0000 !important;
}

.btn-check:checked + .btn.btn-light-youtube i,
.btn-check:checked + .btn.btn-light-youtube .svg-icon, .btn-check:active + .btn.btn-light-youtube i,
.btn-check:active + .btn.btn-light-youtube .svg-icon, .btn.btn-light-youtube:focus:not(.btn-active) i,
.btn.btn-light-youtube:focus:not(.btn-active) .svg-icon, .btn.btn-light-youtube:hover:not(.btn-active) i,
.btn.btn-light-youtube:hover:not(.btn-active) .svg-icon, .btn.btn-light-youtube:active:not(.btn-active) i,
.btn.btn-light-youtube:active:not(.btn-active) .svg-icon, .btn.btn-light-youtube.active i,
.btn.btn-light-youtube.active .svg-icon, .btn.btn-light-youtube.show i,
.btn.btn-light-youtube.show .svg-icon, .show > .btn.btn-light-youtube i,
.show > .btn.btn-light-youtube .svg-icon {
  color: #ffffff;
}

.btn-check:checked + .btn.btn-light-youtube.dropdown-toggle:after, .btn-check:active + .btn.btn-light-youtube.dropdown-toggle:after, .btn.btn-light-youtube:focus:not(.btn-active).dropdown-toggle:after, .btn.btn-light-youtube:hover:not(.btn-active).dropdown-toggle:after, .btn.btn-light-youtube:active:not(.btn-active).dropdown-toggle:after, .btn.btn-light-youtube.active.dropdown-toggle:after, .btn.btn-light-youtube.show.dropdown-toggle:after, .show > .btn.btn-light-youtube.dropdown-toggle:after {
  color: #ffffff;
}

.btn.btn-linkedin {
  color: #ffffff;
  border-color: #0077b5;
  background-color: #0077b5;
}

.btn.btn-linkedin i,
.btn.btn-linkedin .svg-icon {
  color: #ffffff;
}

.btn.btn-linkedin.dropdown-toggle:after {
  color: #ffffff;
}

.btn-check:checked + .btn.btn-linkedin, .btn-check:active + .btn.btn-linkedin, .btn.btn-linkedin:focus:not(.btn-active), .btn.btn-linkedin:hover:not(.btn-active), .btn.btn-linkedin:active:not(.btn-active), .btn.btn-linkedin.active, .btn.btn-linkedin.show, .show > .btn.btn-linkedin {
  border-color: #005e8f;
  background-color: #005e8f !important;
}

.btn.btn-light-linkedin {
  color: #0077b5;
  border-color: rgba(0, 119, 181, 0.1);
  background-color: rgba(0, 119, 181, 0.1);
}

.btn.btn-light-linkedin i,
.btn.btn-light-linkedin .svg-icon {
  color: #0077b5;
}

.btn.btn-light-linkedin.dropdown-toggle:after {
  color: #0077b5;
}

.btn-check:checked + .btn.btn-light-linkedin, .btn-check:active + .btn.btn-light-linkedin, .btn.btn-light-linkedin:focus:not(.btn-active), .btn.btn-light-linkedin:hover:not(.btn-active), .btn.btn-light-linkedin:active:not(.btn-active), .btn.btn-light-linkedin.active, .btn.btn-light-linkedin.show, .show > .btn.btn-light-linkedin {
  color: #ffffff;
  border-color: #0077b5;
  background-color: #0077b5 !important;
}

.btn-check:checked + .btn.btn-light-linkedin i,
.btn-check:checked + .btn.btn-light-linkedin .svg-icon, .btn-check:active + .btn.btn-light-linkedin i,
.btn-check:active + .btn.btn-light-linkedin .svg-icon, .btn.btn-light-linkedin:focus:not(.btn-active) i,
.btn.btn-light-linkedin:focus:not(.btn-active) .svg-icon, .btn.btn-light-linkedin:hover:not(.btn-active) i,
.btn.btn-light-linkedin:hover:not(.btn-active) .svg-icon, .btn.btn-light-linkedin:active:not(.btn-active) i,
.btn.btn-light-linkedin:active:not(.btn-active) .svg-icon, .btn.btn-light-linkedin.active i,
.btn.btn-light-linkedin.active .svg-icon, .btn.btn-light-linkedin.show i,
.btn.btn-light-linkedin.show .svg-icon, .show > .btn.btn-light-linkedin i,
.show > .btn.btn-light-linkedin .svg-icon {
  color: #ffffff;
}

.btn-check:checked + .btn.btn-light-linkedin.dropdown-toggle:after, .btn-check:active + .btn.btn-light-linkedin.dropdown-toggle:after, .btn.btn-light-linkedin:focus:not(.btn-active).dropdown-toggle:after, .btn.btn-light-linkedin:hover:not(.btn-active).dropdown-toggle:after, .btn.btn-light-linkedin:active:not(.btn-active).dropdown-toggle:after, .btn.btn-light-linkedin.active.dropdown-toggle:after, .btn.btn-light-linkedin.show.dropdown-toggle:after, .show > .btn.btn-light-linkedin.dropdown-toggle:after {
  color: #ffffff;
}

.modal-rounded {
  border-radius: 0.475rem !important;
}

code:not([class*=language-]) {
  font-weight: 400;
  color: var(--bs-code-color);
  line-height: inherit;
  font-size: inherit;
  background-color: var(--bs-code-bg);
  padding: 0.1rem 0.4rem;
  margin: 0 0.5rem;
  box-shadow: var(--bs-code-box-shadow);
  border-radius: 0.3rem;
}

.col-form-label {
  font-size: 1.05rem;
}

.form-control.form-control-transparent {
  background-color: transparent;
  border-color: transparent;
}

.dropdown.show > .form-control.form-control-transparent, .form-control.form-control-transparent:active, .form-control.form-control-transparent.active, .form-control.form-control-transparent:focus, .form-control.form-control-transparent.focus {
  background-color: transparent;
  border-color: transparent;
}

.form-control.form-control-flush {
  border: 0;
  background-color: transparent;
  outline: none !important;
  box-shadow: none;
  border-radius: 0;
}

.form-control.form-control-solid {
  background-color: var(--bs-gray-100);
  border-color: var(--bs-gray-100);
  color: var(--bs-gray-700);
  transition: color 0.2s ease;
}

.form-control.form-control-solid::placeholder {
  color: var(--bs-gray-500);
}

.form-control.form-control-solid::-moz-placeholder {
  color: var(--bs-gray-500);
  opacity: 1;
}

.dropdown.show > .form-control.form-control-solid, .form-control.form-control-solid:active, .form-control.form-control-solid.active, .form-control.form-control-solid:focus, .form-control.form-control-solid.focus {
  background-color: var(--bs-gray-200);
  border-color: var(--bs-gray-200);
  color: var(--bs-gray-700);
  transition: color 0.2s ease;
}

.form-control-solid-bg {
  background-color: var(--bs-gray-100);
}

.form-control-plaintext {
  color: var(--bs-gray-700);
}

.placeholder-gray-500::placeholder {
  color: var(--bs-gray-500);
}

.placeholder-white::placeholder {
  color: #ffffff;
}

.placeholder-white::-moz-placeholder {
  color: #ffffff;
  opacity: 1;
}

.resize-none {
  resize: none;
}

.form-floating .form-control.form-control-solid::placeholder {
  color: transparent;
}

.form-select {
  appearance: none;
}

.form-select:focus {
  border-color: var(--bs-gray-400);
  box-shadow: false, 0 0 0 0.25rem rgba(var(--bs-component-active-bg), 0.25);
}

.form-select:disabled {
  color: var(--bs-gray-500);
  background-color: var(--bs-gray-200);
  border-color: var(--bs-gray-300);
}

.form-select:-moz-focusring {
  text-shadow: 0 0 0 var(--bs-gray-700);
}

.form-select.form-select-solid {
  background-color: var(--bs-gray-100);
  border-color: var(--bs-gray-100);
  color: var(--bs-gray-700);
  transition: color 0.2s ease;
}

.form-select.form-select-solid::placeholder {
  color: var(--bs-gray-500);
}

.form-select.form-select-solid::-moz-placeholder {
  color: var(--bs-gray-500);
  opacity: 1;
}

.dropdown.show > .form-select.form-select-solid, .form-select.form-select-solid:active, .form-select.form-select-solid.active, .form-select.form-select-solid:focus, .form-select.form-select-solid.focus {
  background-color: var(--bs-gray-200);
  border-color: var(--bs-gray-200) !important;
  color: var(--bs-gray-700);
  transition: color 0.2s ease;
}

.form-select.form-select-transparent {
  background-color: transparent;
  border-color: transparent;
  color: var(--bs-gray-700);
}

.form-select.form-select-transparent::placeholder {
  color: var(--bs-gray-500);
}

.form-select.form-select-transparent::-moz-placeholder {
  color: var(--bs-gray-500);
  opacity: 1;
}

.dropdown.show > .form-select.form-select-transparent, .form-select.form-select-transparent:active, .form-select.form-select-transparent.active, .form-select.form-select-transparent:focus, .form-select.form-select-transparent.focus {
  background-color: transparent;
  border-color: transparent !important;
  color: var(--bs-gray-700);
}

.form-check:not(.form-switch) .form-check-input[type=checkbox] {
  background-size: 60% 60%;
}

.form-check.form-check-sm .form-check-input {
  height: 1.55rem;
  width: 1.55rem;
}

.form-check.form-check-lg .form-check-input {
  height: 2.25rem;
  width: 2.25rem;
}

.form-check.form-check-inline {
  display: inline-block;
  margin-right: 1rem;
}

.form-check.form-check-solid .form-check-input {
  border: 0;
}

.form-check.form-check-solid .form-check-input:not(:checked) {
  background-color: var(--bs-gray-200);
}

.form-check.form-check-solid .form-check-input[type=checkbox]:indeterminate {
  background-color: #009ef7;
}

.form-check.form-check-success .form-check-input:checked {
  background-color: var(--bs-success);
}

.form-check.form-check-danger .form-check-input:checked {
  background-color: var(--bs-danger);
}

.form-check.form-check-warning .form-check-input:checked {
  background-color: var(--bs-warning);
}

.form-check-custom {
  display: flex;
  align-items: center;
  padding-left: 0;
  margin: 0;
}

.form-check-custom .form-check-input {
  margin: 0;
  float: none;
  flex-shrink: 0;
}

.form-check-custom .form-check-label {
  margin-left: 0.55rem;
}

.form-switch.form-check-custom .form-check-input {
  height: 2.25rem;
}

.form-switch.form-check-custom.form-switch-sm .form-check-input {
  height: 1.5rem;
  width: 2.5rem;
}

.form-switch.form-check-custom.form-switch-lg .form-check-input {
  height: 2.75rem;
  width: 3.75rem;
}

.form-switch.form-check-solid .form-check-input {
  --bs-form-switch-bg: url(${___CSS_LOADER_URL_REPLACEMENT_6___});
}

.form-switch.form-check-solid .form-check-input:not(:checked) {
  background-color: var(--bs-gray-200);
}

[data-bs-theme=dark] .form-switch .form-check-input:focus:not(:checked) {
  --bs-form-switch-bg: url(${___CSS_LOADER_URL_REPLACEMENT_7___});
}

.form-check-image {
  position: relative;
  overflow: hidden;
}

.form-check-image img {
  max-width: 100%;
}

.form-check-image .form-check-wrapper {
  border-radius: 0.625rem;
  border: 2px solid transparent;
  transition: all 0.2s ease-in-out;
  cursor: pointer;
  overflow: hidden;
  margin-bottom: 0.75rem;
}

.form-check-image .form-check-rounded {
  border-radius: 0.625rem;
}

.form-check-image .form-check-label {
  font-weight: 600;
  margin-left: 0.5rem;
}

.form-check-image.active:not(.form-check-success):not(.form-check-danger) .form-check-wrapper {
  border-color: var(--bs-primary) !important;
}

.form-check-image.form-check-success.active .form-check-wrapper {
  border-color: var(--bs-success) !important;
}

.form-check-image.form-check-danger.active .form-check-wrapper {
  border-color: var(--bs-danger) !important;
}

.form-check-image.disabled {
  opacity: 0.65;
}

.input-group.input-group-solid {
  border-radius: 0.475rem;
}

.input-group.input-group-solid.input-group-sm {
  border-radius: 0.425rem;
}

.input-group.input-group-solid.input-group-lg {
  border-radius: 0.625rem;
}

.input-group.input-group-solid .input-group-text {
  background-color: var(--bs-gray-100);
  border-color: var(--bs-gray-100);
}

.input-group.input-group-solid .input-group-text + .form-control {
  border-left-color: var(--bs-gray-300);
}

.input-group.input-group-solid .form-control {
  background-color: var(--bs-gray-100);
  border-color: var(--bs-gray-100);
}

.input-group.input-group-solid .form-control + .input-group-text {
  border-left-color: var(--bs-gray-300);
}

.form-floating .form-control.form-control-solid::placeholder {
  color: transparent;
}

.required:after {
  content: "*";
  position: relative;
  font-size: inherit;
  color: var(--bs-danger);
  padding-left: 0.25rem;
  font-weight: 600;
}

.progress-vertical {
  display: flex;
  align-items: stretch;
  justify-content: space-between;
}

.progress-vertical .progress {
  height: 100%;
  border-radius: 0.475rem;
  display: flex;
  align-items: flex-end;
  margin-right: 1rem;
}

.progress-vertical .progress:last-child {
  margin-right: 0;
}

.progress-vertical .progress .progress-bar {
  width: 8px;
  border-radius: 0.475rem;
}

.table:not(.table-bordered) > :not(:first-child) {
  border-color: transparent;
  border-width: 0;
  border-style: none;
}

.table:not(.table-bordered) > :not(:last-child) > :last-child > * {
  border-bottom-color: inherit;
}

.table:not(.table-bordered) tr, .table:not(.table-bordered) th, .table:not(.table-bordered) td {
  border-color: inherit;
  border-width: inherit;
  border-style: inherit;
  text-transform: inherit;
  font-weight: inherit;
  font-size: inherit;
  color: inherit;
  height: inherit;
  min-height: inherit;
}

.table:not(.table-bordered) tr:first-child, .table:not(.table-bordered) th:first-child, .table:not(.table-bordered) td:first-child {
  padding-left: 0;
}

.table:not(.table-bordered) tr:last-child, .table:not(.table-bordered) th:last-child, .table:not(.table-bordered) td:last-child {
  padding-right: 0;
}

.table:not(.table-bordered) tfoot tr:last-child,
.table:not(.table-bordered) tbody tr:last-child {
  border-bottom: 0 !important;
}

.table:not(.table-bordered) tfoot tr:last-child th, .table:not(.table-bordered) tfoot tr:last-child td,
.table:not(.table-bordered) tbody tr:last-child th,
.table:not(.table-bordered) tbody tr:last-child td {
  border-bottom: 0 !important;
}

.table:not(.table-bordered) tfoot th, .table:not(.table-bordered) tfoot td {
  border-top: inherit;
}

.table:not(.table-bordered).table-rounded {
  border-radius: 0.475rem;
  border-spacing: 0;
  border-collapse: separate;
}

.table:not(.table-bordered).table-flush tr, .table:not(.table-bordered).table-flush th, .table:not(.table-bordered).table-flush td {
  padding: inherit;
}

.table:not(.table-bordered).table-row-bordered tr {
  border-bottom-width: 1px;
  border-bottom-style: solid;
  border-bottom-color: var(--bs-border-color);
}

.table:not(.table-bordered).table-row-bordered tfoot th, .table:not(.table-bordered).table-row-bordered tfoot td {
  border-top-width: 1px !important;
}

.table:not(.table-bordered).table-row-dashed tr {
  border-bottom-width: 1px;
  border-bottom-style: dashed;
  border-bottom-color: var(--bs-border-color);
}

.table:not(.table-bordered).table-row-dashed tfoot th, .table:not(.table-bordered).table-row-dashed tfoot td {
  border-top-width: 1px !important;
}

.table:not(.table-bordered).table-row-gray-100 tr {
  border-bottom-color: var(--bs-gray-100);
}

.table:not(.table-bordered).table-row-gray-200 tr {
  border-bottom-color: var(--bs-gray-200);
}

.table:not(.table-bordered).table-row-gray-300 tr {
  border-bottom-color: var(--bs-gray-300);
}

.table:not(.table-bordered).table-row-gray-400 tr {
  border-bottom-color: var(--bs-gray-400);
}

.table:not(.table-bordered).table-row-gray-500 tr {
  border-bottom-color: var(--bs-gray-500);
}

.table:not(.table-bordered).table-row-gray-600 tr {
  border-bottom-color: var(--bs-gray-600);
}

.table:not(.table-bordered).table-row-gray-700 tr {
  border-bottom-color: var(--bs-gray-700);
}

.table:not(.table-bordered).table-row-gray-800 tr {
  border-bottom-color: var(--bs-gray-800);
}

.table:not(.table-bordered).table-row-gray-900 tr {
  border-bottom-color: var(--bs-gray-900);
}

.table-layout-fixed {
  table-layout: fixed;
}

.table-sort:after {
  opacity: 0;
}

.table-sort,
.table-sort-asc,
.table-sort-desc {
  vertical-align: middle;
}

.table-sort:after,
.table-sort-asc:after,
.table-sort-desc:after {
  position: relative;
  display: inline-block;
  width: 0.75rem;
  height: 0.75rem;
  content: " ";
  bottom: auto;
  right: auto;
  left: auto;
  margin-left: 0.5rem;
}

.table-sort-asc:after {
  opacity: 1;
  mask-repeat: no-repeat;
  mask-position: center;
  -webkit-mask-repeat: no-repeat;
  -webkit-mask-position: center;
  background-color: var(--bs-text-muted);
  mask-image: url(${___CSS_LOADER_URL_REPLACEMENT_112___});
}

.table-sort-desc:after {
  opacity: 1;
  mask-repeat: no-repeat;
  mask-position: center;
  -webkit-mask-repeat: no-repeat;
  -webkit-mask-position: center;
  background-color: var(--bs-text-muted);
  mask-image: url(${___CSS_LOADER_URL_REPLACEMENT_113___});
}

.table-loading-message {
  display: none;
  position: absolute;
  top: 50%;
  left: 50%;
  border-radius: 0.475rem;
  box-shadow: var(--bs-table-loading-message-box-shadow);
  background-color: var(--bs-body-bg);
  color: var(--bs-gray-700);
  font-weight: 600;
  margin: 0 !important;
  width: auto;
  padding: 0.85rem 2rem !important;
  transform: translateX(-50%) translateY(-50%);
}

.table-loading {
  position: relative;
}

.table-loading .table-loading-message {
  display: block;
}

.table.g-0 th, .table.g-0 td {
  padding: 0rem;
}

.table.g-0 th.dtr-control, .table.g-0 td.dtr-control {
  padding-left: 0rem !important;
}

.table.gy-0 th, .table.gy-0 td {
  padding-top: 0rem;
  padding-bottom: 0rem;
}

.table.gx-0 th, .table.gx-0 td {
  padding-left: 0rem;
  padding-right: 0rem;
}

.table.gx-0 th.dtr-control, .table.gx-0 td.dtr-control {
  padding-left: 0rem !important;
}

.table.gs-0 th:first-child, .table.gs-0 td:first-child {
  padding-left: 0rem;
}

.table.gs-0 th:last-child, .table.gs-0 td:last-child {
  padding-right: 0rem;
}

.table.gs-0 th.dtr-control:first-child, .table.gs-0 td.dtr-control:first-child {
  padding-left: 0rem !important;
}

.table.g-1 th, .table.g-1 td {
  padding: 0.25rem;
}

.table.g-1 th.dtr-control, .table.g-1 td.dtr-control {
  padding-left: 0.25rem !important;
}

.table.gy-1 th, .table.gy-1 td {
  padding-top: 0.25rem;
  padding-bottom: 0.25rem;
}

.table.gx-1 th, .table.gx-1 td {
  padding-left: 0.25rem;
  padding-right: 0.25rem;
}

.table.gx-1 th.dtr-control, .table.gx-1 td.dtr-control {
  padding-left: 0.25rem !important;
}

.table.gs-1 th:first-child, .table.gs-1 td:first-child {
  padding-left: 0.25rem;
}

.table.gs-1 th:last-child, .table.gs-1 td:last-child {
  padding-right: 0.25rem;
}

.table.gs-1 th.dtr-control:first-child, .table.gs-1 td.dtr-control:first-child {
  padding-left: 0.25rem !important;
}

.table.g-2 th, .table.g-2 td {
  padding: 0.5rem;
}

.table.g-2 th.dtr-control, .table.g-2 td.dtr-control {
  padding-left: 0.5rem !important;
}

.table.gy-2 th, .table.gy-2 td {
  padding-top: 0.5rem;
  padding-bottom: 0.5rem;
}

.table.gx-2 th, .table.gx-2 td {
  padding-left: 0.5rem;
  padding-right: 0.5rem;
}

.table.gx-2 th.dtr-control, .table.gx-2 td.dtr-control {
  padding-left: 0.5rem !important;
}

.table.gs-2 th:first-child, .table.gs-2 td:first-child {
  padding-left: 0.5rem;
}

.table.gs-2 th:last-child, .table.gs-2 td:last-child {
  padding-right: 0.5rem;
}

.table.gs-2 th.dtr-control:first-child, .table.gs-2 td.dtr-control:first-child {
  padding-left: 0.5rem !important;
}

.table.g-3 th, .table.g-3 td {
  padding: 0.75rem;
}

.table.g-3 th.dtr-control, .table.g-3 td.dtr-control {
  padding-left: 0.75rem !important;
}

.table.gy-3 th, .table.gy-3 td {
  padding-top: 0.75rem;
  padding-bottom: 0.75rem;
}

.table.gx-3 th, .table.gx-3 td {
  padding-left: 0.75rem;
  padding-right: 0.75rem;
}

.table.gx-3 th.dtr-control, .table.gx-3 td.dtr-control {
  padding-left: 0.75rem !important;
}

.table.gs-3 th:first-child, .table.gs-3 td:first-child {
  padding-left: 0.75rem;
}

.table.gs-3 th:last-child, .table.gs-3 td:last-child {
  padding-right: 0.75rem;
}

.table.gs-3 th.dtr-control:first-child, .table.gs-3 td.dtr-control:first-child {
  padding-left: 0.75rem !important;
}

.table.g-4 th, .table.g-4 td {
  padding: 1rem;
}

.table.g-4 th.dtr-control, .table.g-4 td.dtr-control {
  padding-left: 1rem !important;
}

.table.gy-4 th, .table.gy-4 td {
  padding-top: 1rem;
  padding-bottom: 1rem;
}

.table.gx-4 th, .table.gx-4 td {
  padding-left: 1rem;
  padding-right: 1rem;
}

.table.gx-4 th.dtr-control, .table.gx-4 td.dtr-control {
  padding-left: 1rem !important;
}

.table.gs-4 th:first-child, .table.gs-4 td:first-child {
  padding-left: 1rem;
}

.table.gs-4 th:last-child, .table.gs-4 td:last-child {
  padding-right: 1rem;
}

.table.gs-4 th.dtr-control:first-child, .table.gs-4 td.dtr-control:first-child {
  padding-left: 1rem !important;
}

.table.g-5 th, .table.g-5 td {
  padding: 1.25rem;
}

.table.g-5 th.dtr-control, .table.g-5 td.dtr-control {
  padding-left: 1.25rem !important;
}

.table.gy-5 th, .table.gy-5 td {
  padding-top: 1.25rem;
  padding-bottom: 1.25rem;
}

.table.gx-5 th, .table.gx-5 td {
  padding-left: 1.25rem;
  padding-right: 1.25rem;
}

.table.gx-5 th.dtr-control, .table.gx-5 td.dtr-control {
  padding-left: 1.25rem !important;
}

.table.gs-5 th:first-child, .table.gs-5 td:first-child {
  padding-left: 1.25rem;
}

.table.gs-5 th:last-child, .table.gs-5 td:last-child {
  padding-right: 1.25rem;
}

.table.gs-5 th.dtr-control:first-child, .table.gs-5 td.dtr-control:first-child {
  padding-left: 1.25rem !important;
}

.table.g-6 th, .table.g-6 td {
  padding: 1.5rem;
}

.table.g-6 th.dtr-control, .table.g-6 td.dtr-control {
  padding-left: 1.5rem !important;
}

.table.gy-6 th, .table.gy-6 td {
  padding-top: 1.5rem;
  padding-bottom: 1.5rem;
}

.table.gx-6 th, .table.gx-6 td {
  padding-left: 1.5rem;
  padding-right: 1.5rem;
}

.table.gx-6 th.dtr-control, .table.gx-6 td.dtr-control {
  padding-left: 1.5rem !important;
}

.table.gs-6 th:first-child, .table.gs-6 td:first-child {
  padding-left: 1.5rem;
}

.table.gs-6 th:last-child, .table.gs-6 td:last-child {
  padding-right: 1.5rem;
}

.table.gs-6 th.dtr-control:first-child, .table.gs-6 td.dtr-control:first-child {
  padding-left: 1.5rem !important;
}

.table.g-7 th, .table.g-7 td {
  padding: 1.75rem;
}

.table.g-7 th.dtr-control, .table.g-7 td.dtr-control {
  padding-left: 1.75rem !important;
}

.table.gy-7 th, .table.gy-7 td {
  padding-top: 1.75rem;
  padding-bottom: 1.75rem;
}

.table.gx-7 th, .table.gx-7 td {
  padding-left: 1.75rem;
  padding-right: 1.75rem;
}

.table.gx-7 th.dtr-control, .table.gx-7 td.dtr-control {
  padding-left: 1.75rem !important;
}

.table.gs-7 th:first-child, .table.gs-7 td:first-child {
  padding-left: 1.75rem;
}

.table.gs-7 th:last-child, .table.gs-7 td:last-child {
  padding-right: 1.75rem;
}

.table.gs-7 th.dtr-control:first-child, .table.gs-7 td.dtr-control:first-child {
  padding-left: 1.75rem !important;
}

.table.g-8 th, .table.g-8 td {
  padding: 2rem;
}

.table.g-8 th.dtr-control, .table.g-8 td.dtr-control {
  padding-left: 2rem !important;
}

.table.gy-8 th, .table.gy-8 td {
  padding-top: 2rem;
  padding-bottom: 2rem;
}

.table.gx-8 th, .table.gx-8 td {
  padding-left: 2rem;
  padding-right: 2rem;
}

.table.gx-8 th.dtr-control, .table.gx-8 td.dtr-control {
  padding-left: 2rem !important;
}

.table.gs-8 th:first-child, .table.gs-8 td:first-child {
  padding-left: 2rem;
}

.table.gs-8 th:last-child, .table.gs-8 td:last-child {
  padding-right: 2rem;
}

.table.gs-8 th.dtr-control:first-child, .table.gs-8 td.dtr-control:first-child {
  padding-left: 2rem !important;
}

.table.g-9 th, .table.g-9 td {
  padding: 2.25rem;
}

.table.g-9 th.dtr-control, .table.g-9 td.dtr-control {
  padding-left: 2.25rem !important;
}

.table.gy-9 th, .table.gy-9 td {
  padding-top: 2.25rem;
  padding-bottom: 2.25rem;
}

.table.gx-9 th, .table.gx-9 td {
  padding-left: 2.25rem;
  padding-right: 2.25rem;
}

.table.gx-9 th.dtr-control, .table.gx-9 td.dtr-control {
  padding-left: 2.25rem !important;
}

.table.gs-9 th:first-child, .table.gs-9 td:first-child {
  padding-left: 2.25rem;
}

.table.gs-9 th:last-child, .table.gs-9 td:last-child {
  padding-right: 2.25rem;
}

.table.gs-9 th.dtr-control:first-child, .table.gs-9 td.dtr-control:first-child {
  padding-left: 2.25rem !important;
}

.table.g-10 th, .table.g-10 td {
  padding: 2.5rem;
}

.table.g-10 th.dtr-control, .table.g-10 td.dtr-control {
  padding-left: 2.5rem !important;
}

.table.gy-10 th, .table.gy-10 td {
  padding-top: 2.5rem;
  padding-bottom: 2.5rem;
}

.table.gx-10 th, .table.gx-10 td {
  padding-left: 2.5rem;
  padding-right: 2.5rem;
}

.table.gx-10 th.dtr-control, .table.gx-10 td.dtr-control {
  padding-left: 2.5rem !important;
}

.table.gs-10 th:first-child, .table.gs-10 td:first-child {
  padding-left: 2.5rem;
}

.table.gs-10 th:last-child, .table.gs-10 td:last-child {
  padding-right: 2.5rem;
}

.table.gs-10 th.dtr-control:first-child, .table.gs-10 td.dtr-control:first-child {
  padding-left: 2.5rem !important;
}

@media (min-width: 576px) {
  .table.g-sm-0 th, .table.g-sm-0 td {
    padding: 0rem;
  }
  .table.g-sm-0 th.dtr-control, .table.g-sm-0 td.dtr-control {
    padding-left: 0rem !important;
  }
  .table.gy-sm-0 th, .table.gy-sm-0 td {
    padding-top: 0rem;
    padding-bottom: 0rem;
  }
  .table.gx-sm-0 th, .table.gx-sm-0 td {
    padding-left: 0rem;
    padding-right: 0rem;
  }
  .table.gx-sm-0 th.dtr-control, .table.gx-sm-0 td.dtr-control {
    padding-left: 0rem !important;
  }
  .table.gs-sm-0 th:first-child, .table.gs-sm-0 td:first-child {
    padding-left: 0rem;
  }
  .table.gs-sm-0 th:last-child, .table.gs-sm-0 td:last-child {
    padding-right: 0rem;
  }
  .table.gs-sm-0 th.dtr-control:first-child, .table.gs-sm-0 td.dtr-control:first-child {
    padding-left: 0rem !important;
  }
  .table.g-sm-1 th, .table.g-sm-1 td {
    padding: 0.25rem;
  }
  .table.g-sm-1 th.dtr-control, .table.g-sm-1 td.dtr-control {
    padding-left: 0.25rem !important;
  }
  .table.gy-sm-1 th, .table.gy-sm-1 td {
    padding-top: 0.25rem;
    padding-bottom: 0.25rem;
  }
  .table.gx-sm-1 th, .table.gx-sm-1 td {
    padding-left: 0.25rem;
    padding-right: 0.25rem;
  }
  .table.gx-sm-1 th.dtr-control, .table.gx-sm-1 td.dtr-control {
    padding-left: 0.25rem !important;
  }
  .table.gs-sm-1 th:first-child, .table.gs-sm-1 td:first-child {
    padding-left: 0.25rem;
  }
  .table.gs-sm-1 th:last-child, .table.gs-sm-1 td:last-child {
    padding-right: 0.25rem;
  }
  .table.gs-sm-1 th.dtr-control:first-child, .table.gs-sm-1 td.dtr-control:first-child {
    padding-left: 0.25rem !important;
  }
  .table.g-sm-2 th, .table.g-sm-2 td {
    padding: 0.5rem;
  }
  .table.g-sm-2 th.dtr-control, .table.g-sm-2 td.dtr-control {
    padding-left: 0.5rem !important;
  }
  .table.gy-sm-2 th, .table.gy-sm-2 td {
    padding-top: 0.5rem;
    padding-bottom: 0.5rem;
  }
  .table.gx-sm-2 th, .table.gx-sm-2 td {
    padding-left: 0.5rem;
    padding-right: 0.5rem;
  }
  .table.gx-sm-2 th.dtr-control, .table.gx-sm-2 td.dtr-control {
    padding-left: 0.5rem !important;
  }
  .table.gs-sm-2 th:first-child, .table.gs-sm-2 td:first-child {
    padding-left: 0.5rem;
  }
  .table.gs-sm-2 th:last-child, .table.gs-sm-2 td:last-child {
    padding-right: 0.5rem;
  }
  .table.gs-sm-2 th.dtr-control:first-child, .table.gs-sm-2 td.dtr-control:first-child {
    padding-left: 0.5rem !important;
  }
  .table.g-sm-3 th, .table.g-sm-3 td {
    padding: 0.75rem;
  }
  .table.g-sm-3 th.dtr-control, .table.g-sm-3 td.dtr-control {
    padding-left: 0.75rem !important;
  }
  .table.gy-sm-3 th, .table.gy-sm-3 td {
    padding-top: 0.75rem;
    padding-bottom: 0.75rem;
  }
  .table.gx-sm-3 th, .table.gx-sm-3 td {
    padding-left: 0.75rem;
    padding-right: 0.75rem;
  }
  .table.gx-sm-3 th.dtr-control, .table.gx-sm-3 td.dtr-control {
    padding-left: 0.75rem !important;
  }
  .table.gs-sm-3 th:first-child, .table.gs-sm-3 td:first-child {
    padding-left: 0.75rem;
  }
  .table.gs-sm-3 th:last-child, .table.gs-sm-3 td:last-child {
    padding-right: 0.75rem;
  }
  .table.gs-sm-3 th.dtr-control:first-child, .table.gs-sm-3 td.dtr-control:first-child {
    padding-left: 0.75rem !important;
  }
  .table.g-sm-4 th, .table.g-sm-4 td {
    padding: 1rem;
  }
  .table.g-sm-4 th.dtr-control, .table.g-sm-4 td.dtr-control {
    padding-left: 1rem !important;
  }
  .table.gy-sm-4 th, .table.gy-sm-4 td {
    padding-top: 1rem;
    padding-bottom: 1rem;
  }
  .table.gx-sm-4 th, .table.gx-sm-4 td {
    padding-left: 1rem;
    padding-right: 1rem;
  }
  .table.gx-sm-4 th.dtr-control, .table.gx-sm-4 td.dtr-control {
    padding-left: 1rem !important;
  }
  .table.gs-sm-4 th:first-child, .table.gs-sm-4 td:first-child {
    padding-left: 1rem;
  }
  .table.gs-sm-4 th:last-child, .table.gs-sm-4 td:last-child {
    padding-right: 1rem;
  }
  .table.gs-sm-4 th.dtr-control:first-child, .table.gs-sm-4 td.dtr-control:first-child {
    padding-left: 1rem !important;
  }
  .table.g-sm-5 th, .table.g-sm-5 td {
    padding: 1.25rem;
  }
  .table.g-sm-5 th.dtr-control, .table.g-sm-5 td.dtr-control {
    padding-left: 1.25rem !important;
  }
  .table.gy-sm-5 th, .table.gy-sm-5 td {
    padding-top: 1.25rem;
    padding-bottom: 1.25rem;
  }
  .table.gx-sm-5 th, .table.gx-sm-5 td {
    padding-left: 1.25rem;
    padding-right: 1.25rem;
  }
  .table.gx-sm-5 th.dtr-control, .table.gx-sm-5 td.dtr-control {
    padding-left: 1.25rem !important;
  }
  .table.gs-sm-5 th:first-child, .table.gs-sm-5 td:first-child {
    padding-left: 1.25rem;
  }
  .table.gs-sm-5 th:last-child, .table.gs-sm-5 td:last-child {
    padding-right: 1.25rem;
  }
  .table.gs-sm-5 th.dtr-control:first-child, .table.gs-sm-5 td.dtr-control:first-child {
    padding-left: 1.25rem !important;
  }
  .table.g-sm-6 th, .table.g-sm-6 td {
    padding: 1.5rem;
  }
  .table.g-sm-6 th.dtr-control, .table.g-sm-6 td.dtr-control {
    padding-left: 1.5rem !important;
  }
  .table.gy-sm-6 th, .table.gy-sm-6 td {
    padding-top: 1.5rem;
    padding-bottom: 1.5rem;
  }
  .table.gx-sm-6 th, .table.gx-sm-6 td {
    padding-left: 1.5rem;
    padding-right: 1.5rem;
  }
  .table.gx-sm-6 th.dtr-control, .table.gx-sm-6 td.dtr-control {
    padding-left: 1.5rem !important;
  }
  .table.gs-sm-6 th:first-child, .table.gs-sm-6 td:first-child {
    padding-left: 1.5rem;
  }
  .table.gs-sm-6 th:last-child, .table.gs-sm-6 td:last-child {
    padding-right: 1.5rem;
  }
  .table.gs-sm-6 th.dtr-control:first-child, .table.gs-sm-6 td.dtr-control:first-child {
    padding-left: 1.5rem !important;
  }
  .table.g-sm-7 th, .table.g-sm-7 td {
    padding: 1.75rem;
  }
  .table.g-sm-7 th.dtr-control, .table.g-sm-7 td.dtr-control {
    padding-left: 1.75rem !important;
  }
  .table.gy-sm-7 th, .table.gy-sm-7 td {
    padding-top: 1.75rem;
    padding-bottom: 1.75rem;
  }
  .table.gx-sm-7 th, .table.gx-sm-7 td {
    padding-left: 1.75rem;
    padding-right: 1.75rem;
  }
  .table.gx-sm-7 th.dtr-control, .table.gx-sm-7 td.dtr-control {
    padding-left: 1.75rem !important;
  }
  .table.gs-sm-7 th:first-child, .table.gs-sm-7 td:first-child {
    padding-left: 1.75rem;
  }
  .table.gs-sm-7 th:last-child, .table.gs-sm-7 td:last-child {
    padding-right: 1.75rem;
  }
  .table.gs-sm-7 th.dtr-control:first-child, .table.gs-sm-7 td.dtr-control:first-child {
    padding-left: 1.75rem !important;
  }
  .table.g-sm-8 th, .table.g-sm-8 td {
    padding: 2rem;
  }
  .table.g-sm-8 th.dtr-control, .table.g-sm-8 td.dtr-control {
    padding-left: 2rem !important;
  }
  .table.gy-sm-8 th, .table.gy-sm-8 td {
    padding-top: 2rem;
    padding-bottom: 2rem;
  }
  .table.gx-sm-8 th, .table.gx-sm-8 td {
    padding-left: 2rem;
    padding-right: 2rem;
  }
  .table.gx-sm-8 th.dtr-control, .table.gx-sm-8 td.dtr-control {
    padding-left: 2rem !important;
  }
  .table.gs-sm-8 th:first-child, .table.gs-sm-8 td:first-child {
    padding-left: 2rem;
  }
  .table.gs-sm-8 th:last-child, .table.gs-sm-8 td:last-child {
    padding-right: 2rem;
  }
  .table.gs-sm-8 th.dtr-control:first-child, .table.gs-sm-8 td.dtr-control:first-child {
    padding-left: 2rem !important;
  }
  .table.g-sm-9 th, .table.g-sm-9 td {
    padding: 2.25rem;
  }
  .table.g-sm-9 th.dtr-control, .table.g-sm-9 td.dtr-control {
    padding-left: 2.25rem !important;
  }
  .table.gy-sm-9 th, .table.gy-sm-9 td {
    padding-top: 2.25rem;
    padding-bottom: 2.25rem;
  }
  .table.gx-sm-9 th, .table.gx-sm-9 td {
    padding-left: 2.25rem;
    padding-right: 2.25rem;
  }
  .table.gx-sm-9 th.dtr-control, .table.gx-sm-9 td.dtr-control {
    padding-left: 2.25rem !important;
  }
  .table.gs-sm-9 th:first-child, .table.gs-sm-9 td:first-child {
    padding-left: 2.25rem;
  }
  .table.gs-sm-9 th:last-child, .table.gs-sm-9 td:last-child {
    padding-right: 2.25rem;
  }
  .table.gs-sm-9 th.dtr-control:first-child, .table.gs-sm-9 td.dtr-control:first-child {
    padding-left: 2.25rem !important;
  }
  .table.g-sm-10 th, .table.g-sm-10 td {
    padding: 2.5rem;
  }
  .table.g-sm-10 th.dtr-control, .table.g-sm-10 td.dtr-control {
    padding-left: 2.5rem !important;
  }
  .table.gy-sm-10 th, .table.gy-sm-10 td {
    padding-top: 2.5rem;
    padding-bottom: 2.5rem;
  }
  .table.gx-sm-10 th, .table.gx-sm-10 td {
    padding-left: 2.5rem;
    padding-right: 2.5rem;
  }
  .table.gx-sm-10 th.dtr-control, .table.gx-sm-10 td.dtr-control {
    padding-left: 2.5rem !important;
  }
  .table.gs-sm-10 th:first-child, .table.gs-sm-10 td:first-child {
    padding-left: 2.5rem;
  }
  .table.gs-sm-10 th:last-child, .table.gs-sm-10 td:last-child {
    padding-right: 2.5rem;
  }
  .table.gs-sm-10 th.dtr-control:first-child, .table.gs-sm-10 td.dtr-control:first-child {
    padding-left: 2.5rem !important;
  }
}
@media (min-width: 768px) {
  .table.g-md-0 th, .table.g-md-0 td {
    padding: 0rem;
  }
  .table.g-md-0 th.dtr-control, .table.g-md-0 td.dtr-control {
    padding-left: 0rem !important;
  }
  .table.gy-md-0 th, .table.gy-md-0 td {
    padding-top: 0rem;
    padding-bottom: 0rem;
  }
  .table.gx-md-0 th, .table.gx-md-0 td {
    padding-left: 0rem;
    padding-right: 0rem;
  }
  .table.gx-md-0 th.dtr-control, .table.gx-md-0 td.dtr-control {
    padding-left: 0rem !important;
  }
  .table.gs-md-0 th:first-child, .table.gs-md-0 td:first-child {
    padding-left: 0rem;
  }
  .table.gs-md-0 th:last-child, .table.gs-md-0 td:last-child {
    padding-right: 0rem;
  }
  .table.gs-md-0 th.dtr-control:first-child, .table.gs-md-0 td.dtr-control:first-child {
    padding-left: 0rem !important;
  }
  .table.g-md-1 th, .table.g-md-1 td {
    padding: 0.25rem;
  }
  .table.g-md-1 th.dtr-control, .table.g-md-1 td.dtr-control {
    padding-left: 0.25rem !important;
  }
  .table.gy-md-1 th, .table.gy-md-1 td {
    padding-top: 0.25rem;
    padding-bottom: 0.25rem;
  }
  .table.gx-md-1 th, .table.gx-md-1 td {
    padding-left: 0.25rem;
    padding-right: 0.25rem;
  }
  .table.gx-md-1 th.dtr-control, .table.gx-md-1 td.dtr-control {
    padding-left: 0.25rem !important;
  }
  .table.gs-md-1 th:first-child, .table.gs-md-1 td:first-child {
    padding-left: 0.25rem;
  }
  .table.gs-md-1 th:last-child, .table.gs-md-1 td:last-child {
    padding-right: 0.25rem;
  }
  .table.gs-md-1 th.dtr-control:first-child, .table.gs-md-1 td.dtr-control:first-child {
    padding-left: 0.25rem !important;
  }
  .table.g-md-2 th, .table.g-md-2 td {
    padding: 0.5rem;
  }
  .table.g-md-2 th.dtr-control, .table.g-md-2 td.dtr-control {
    padding-left: 0.5rem !important;
  }
  .table.gy-md-2 th, .table.gy-md-2 td {
    padding-top: 0.5rem;
    padding-bottom: 0.5rem;
  }
  .table.gx-md-2 th, .table.gx-md-2 td {
    padding-left: 0.5rem;
    padding-right: 0.5rem;
  }
  .table.gx-md-2 th.dtr-control, .table.gx-md-2 td.dtr-control {
    padding-left: 0.5rem !important;
  }
  .table.gs-md-2 th:first-child, .table.gs-md-2 td:first-child {
    padding-left: 0.5rem;
  }
  .table.gs-md-2 th:last-child, .table.gs-md-2 td:last-child {
    padding-right: 0.5rem;
  }
  .table.gs-md-2 th.dtr-control:first-child, .table.gs-md-2 td.dtr-control:first-child {
    padding-left: 0.5rem !important;
  }
  .table.g-md-3 th, .table.g-md-3 td {
    padding: 0.75rem;
  }
  .table.g-md-3 th.dtr-control, .table.g-md-3 td.dtr-control {
    padding-left: 0.75rem !important;
  }
  .table.gy-md-3 th, .table.gy-md-3 td {
    padding-top: 0.75rem;
    padding-bottom: 0.75rem;
  }
  .table.gx-md-3 th, .table.gx-md-3 td {
    padding-left: 0.75rem;
    padding-right: 0.75rem;
  }
  .table.gx-md-3 th.dtr-control, .table.gx-md-3 td.dtr-control {
    padding-left: 0.75rem !important;
  }
  .table.gs-md-3 th:first-child, .table.gs-md-3 td:first-child {
    padding-left: 0.75rem;
  }
  .table.gs-md-3 th:last-child, .table.gs-md-3 td:last-child {
    padding-right: 0.75rem;
  }
  .table.gs-md-3 th.dtr-control:first-child, .table.gs-md-3 td.dtr-control:first-child {
    padding-left: 0.75rem !important;
  }
  .table.g-md-4 th, .table.g-md-4 td {
    padding: 1rem;
  }
  .table.g-md-4 th.dtr-control, .table.g-md-4 td.dtr-control {
    padding-left: 1rem !important;
  }
  .table.gy-md-4 th, .table.gy-md-4 td {
    padding-top: 1rem;
    padding-bottom: 1rem;
  }
  .table.gx-md-4 th, .table.gx-md-4 td {
    padding-left: 1rem;
    padding-right: 1rem;
  }
  .table.gx-md-4 th.dtr-control, .table.gx-md-4 td.dtr-control {
    padding-left: 1rem !important;
  }
  .table.gs-md-4 th:first-child, .table.gs-md-4 td:first-child {
    padding-left: 1rem;
  }
  .table.gs-md-4 th:last-child, .table.gs-md-4 td:last-child {
    padding-right: 1rem;
  }
  .table.gs-md-4 th.dtr-control:first-child, .table.gs-md-4 td.dtr-control:first-child {
    padding-left: 1rem !important;
  }
  .table.g-md-5 th, .table.g-md-5 td {
    padding: 1.25rem;
  }
  .table.g-md-5 th.dtr-control, .table.g-md-5 td.dtr-control {
    padding-left: 1.25rem !important;
  }
  .table.gy-md-5 th, .table.gy-md-5 td {
    padding-top: 1.25rem;
    padding-bottom: 1.25rem;
  }
  .table.gx-md-5 th, .table.gx-md-5 td {
    padding-left: 1.25rem;
    padding-right: 1.25rem;
  }
  .table.gx-md-5 th.dtr-control, .table.gx-md-5 td.dtr-control {
    padding-left: 1.25rem !important;
  }
  .table.gs-md-5 th:first-child, .table.gs-md-5 td:first-child {
    padding-left: 1.25rem;
  }
  .table.gs-md-5 th:last-child, .table.gs-md-5 td:last-child {
    padding-right: 1.25rem;
  }
  .table.gs-md-5 th.dtr-control:first-child, .table.gs-md-5 td.dtr-control:first-child {
    padding-left: 1.25rem !important;
  }
  .table.g-md-6 th, .table.g-md-6 td {
    padding: 1.5rem;
  }
  .table.g-md-6 th.dtr-control, .table.g-md-6 td.dtr-control {
    padding-left: 1.5rem !important;
  }
  .table.gy-md-6 th, .table.gy-md-6 td {
    padding-top: 1.5rem;
    padding-bottom: 1.5rem;
  }
  .table.gx-md-6 th, .table.gx-md-6 td {
    padding-left: 1.5rem;
    padding-right: 1.5rem;
  }
  .table.gx-md-6 th.dtr-control, .table.gx-md-6 td.dtr-control {
    padding-left: 1.5rem !important;
  }
  .table.gs-md-6 th:first-child, .table.gs-md-6 td:first-child {
    padding-left: 1.5rem;
  }
  .table.gs-md-6 th:last-child, .table.gs-md-6 td:last-child {
    padding-right: 1.5rem;
  }
  .table.gs-md-6 th.dtr-control:first-child, .table.gs-md-6 td.dtr-control:first-child {
    padding-left: 1.5rem !important;
  }
  .table.g-md-7 th, .table.g-md-7 td {
    padding: 1.75rem;
  }
  .table.g-md-7 th.dtr-control, .table.g-md-7 td.dtr-control {
    padding-left: 1.75rem !important;
  }
  .table.gy-md-7 th, .table.gy-md-7 td {
    padding-top: 1.75rem;
    padding-bottom: 1.75rem;
  }
  .table.gx-md-7 th, .table.gx-md-7 td {
    padding-left: 1.75rem;
    padding-right: 1.75rem;
  }
  .table.gx-md-7 th.dtr-control, .table.gx-md-7 td.dtr-control {
    padding-left: 1.75rem !important;
  }
  .table.gs-md-7 th:first-child, .table.gs-md-7 td:first-child {
    padding-left: 1.75rem;
  }
  .table.gs-md-7 th:last-child, .table.gs-md-7 td:last-child {
    padding-right: 1.75rem;
  }
  .table.gs-md-7 th.dtr-control:first-child, .table.gs-md-7 td.dtr-control:first-child {
    padding-left: 1.75rem !important;
  }
  .table.g-md-8 th, .table.g-md-8 td {
    padding: 2rem;
  }
  .table.g-md-8 th.dtr-control, .table.g-md-8 td.dtr-control {
    padding-left: 2rem !important;
  }
  .table.gy-md-8 th, .table.gy-md-8 td {
    padding-top: 2rem;
    padding-bottom: 2rem;
  }
  .table.gx-md-8 th, .table.gx-md-8 td {
    padding-left: 2rem;
    padding-right: 2rem;
  }
  .table.gx-md-8 th.dtr-control, .table.gx-md-8 td.dtr-control {
    padding-left: 2rem !important;
  }
  .table.gs-md-8 th:first-child, .table.gs-md-8 td:first-child {
    padding-left: 2rem;
  }
  .table.gs-md-8 th:last-child, .table.gs-md-8 td:last-child {
    padding-right: 2rem;
  }
  .table.gs-md-8 th.dtr-control:first-child, .table.gs-md-8 td.dtr-control:first-child {
    padding-left: 2rem !important;
  }
  .table.g-md-9 th, .table.g-md-9 td {
    padding: 2.25rem;
  }
  .table.g-md-9 th.dtr-control, .table.g-md-9 td.dtr-control {
    padding-left: 2.25rem !important;
  }
  .table.gy-md-9 th, .table.gy-md-9 td {
    padding-top: 2.25rem;
    padding-bottom: 2.25rem;
  }
  .table.gx-md-9 th, .table.gx-md-9 td {
    padding-left: 2.25rem;
    padding-right: 2.25rem;
  }
  .table.gx-md-9 th.dtr-control, .table.gx-md-9 td.dtr-control {
    padding-left: 2.25rem !important;
  }
  .table.gs-md-9 th:first-child, .table.gs-md-9 td:first-child {
    padding-left: 2.25rem;
  }
  .table.gs-md-9 th:last-child, .table.gs-md-9 td:last-child {
    padding-right: 2.25rem;
  }
  .table.gs-md-9 th.dtr-control:first-child, .table.gs-md-9 td.dtr-control:first-child {
    padding-left: 2.25rem !important;
  }
  .table.g-md-10 th, .table.g-md-10 td {
    padding: 2.5rem;
  }
  .table.g-md-10 th.dtr-control, .table.g-md-10 td.dtr-control {
    padding-left: 2.5rem !important;
  }
  .table.gy-md-10 th, .table.gy-md-10 td {
    padding-top: 2.5rem;
    padding-bottom: 2.5rem;
  }
  .table.gx-md-10 th, .table.gx-md-10 td {
    padding-left: 2.5rem;
    padding-right: 2.5rem;
  }
  .table.gx-md-10 th.dtr-control, .table.gx-md-10 td.dtr-control {
    padding-left: 2.5rem !important;
  }
  .table.gs-md-10 th:first-child, .table.gs-md-10 td:first-child {
    padding-left: 2.5rem;
  }
  .table.gs-md-10 th:last-child, .table.gs-md-10 td:last-child {
    padding-right: 2.5rem;
  }
  .table.gs-md-10 th.dtr-control:first-child, .table.gs-md-10 td.dtr-control:first-child {
    padding-left: 2.5rem !important;
  }
}
@media (min-width: 992px) {
  .table.g-lg-0 th, .table.g-lg-0 td {
    padding: 0rem;
  }
  .table.g-lg-0 th.dtr-control, .table.g-lg-0 td.dtr-control {
    padding-left: 0rem !important;
  }
  .table.gy-lg-0 th, .table.gy-lg-0 td {
    padding-top: 0rem;
    padding-bottom: 0rem;
  }
  .table.gx-lg-0 th, .table.gx-lg-0 td {
    padding-left: 0rem;
    padding-right: 0rem;
  }
  .table.gx-lg-0 th.dtr-control, .table.gx-lg-0 td.dtr-control {
    padding-left: 0rem !important;
  }
  .table.gs-lg-0 th:first-child, .table.gs-lg-0 td:first-child {
    padding-left: 0rem;
  }
  .table.gs-lg-0 th:last-child, .table.gs-lg-0 td:last-child {
    padding-right: 0rem;
  }
  .table.gs-lg-0 th.dtr-control:first-child, .table.gs-lg-0 td.dtr-control:first-child {
    padding-left: 0rem !important;
  }
  .table.g-lg-1 th, .table.g-lg-1 td {
    padding: 0.25rem;
  }
  .table.g-lg-1 th.dtr-control, .table.g-lg-1 td.dtr-control {
    padding-left: 0.25rem !important;
  }
  .table.gy-lg-1 th, .table.gy-lg-1 td {
    padding-top: 0.25rem;
    padding-bottom: 0.25rem;
  }
  .table.gx-lg-1 th, .table.gx-lg-1 td {
    padding-left: 0.25rem;
    padding-right: 0.25rem;
  }
  .table.gx-lg-1 th.dtr-control, .table.gx-lg-1 td.dtr-control {
    padding-left: 0.25rem !important;
  }
  .table.gs-lg-1 th:first-child, .table.gs-lg-1 td:first-child {
    padding-left: 0.25rem;
  }
  .table.gs-lg-1 th:last-child, .table.gs-lg-1 td:last-child {
    padding-right: 0.25rem;
  }
  .table.gs-lg-1 th.dtr-control:first-child, .table.gs-lg-1 td.dtr-control:first-child {
    padding-left: 0.25rem !important;
  }
  .table.g-lg-2 th, .table.g-lg-2 td {
    padding: 0.5rem;
  }
  .table.g-lg-2 th.dtr-control, .table.g-lg-2 td.dtr-control {
    padding-left: 0.5rem !important;
  }
  .table.gy-lg-2 th, .table.gy-lg-2 td {
    padding-top: 0.5rem;
    padding-bottom: 0.5rem;
  }
  .table.gx-lg-2 th, .table.gx-lg-2 td {
    padding-left: 0.5rem;
    padding-right: 0.5rem;
  }
  .table.gx-lg-2 th.dtr-control, .table.gx-lg-2 td.dtr-control {
    padding-left: 0.5rem !important;
  }
  .table.gs-lg-2 th:first-child, .table.gs-lg-2 td:first-child {
    padding-left: 0.5rem;
  }
  .table.gs-lg-2 th:last-child, .table.gs-lg-2 td:last-child {
    padding-right: 0.5rem;
  }
  .table.gs-lg-2 th.dtr-control:first-child, .table.gs-lg-2 td.dtr-control:first-child {
    padding-left: 0.5rem !important;
  }
  .table.g-lg-3 th, .table.g-lg-3 td {
    padding: 0.75rem;
  }
  .table.g-lg-3 th.dtr-control, .table.g-lg-3 td.dtr-control {
    padding-left: 0.75rem !important;
  }
  .table.gy-lg-3 th, .table.gy-lg-3 td {
    padding-top: 0.75rem;
    padding-bottom: 0.75rem;
  }
  .table.gx-lg-3 th, .table.gx-lg-3 td {
    padding-left: 0.75rem;
    padding-right: 0.75rem;
  }
  .table.gx-lg-3 th.dtr-control, .table.gx-lg-3 td.dtr-control {
    padding-left: 0.75rem !important;
  }
  .table.gs-lg-3 th:first-child, .table.gs-lg-3 td:first-child {
    padding-left: 0.75rem;
  }
  .table.gs-lg-3 th:last-child, .table.gs-lg-3 td:last-child {
    padding-right: 0.75rem;
  }
  .table.gs-lg-3 th.dtr-control:first-child, .table.gs-lg-3 td.dtr-control:first-child {
    padding-left: 0.75rem !important;
  }
  .table.g-lg-4 th, .table.g-lg-4 td {
    padding: 1rem;
  }
  .table.g-lg-4 th.dtr-control, .table.g-lg-4 td.dtr-control {
    padding-left: 1rem !important;
  }
  .table.gy-lg-4 th, .table.gy-lg-4 td {
    padding-top: 1rem;
    padding-bottom: 1rem;
  }
  .table.gx-lg-4 th, .table.gx-lg-4 td {
    padding-left: 1rem;
    padding-right: 1rem;
  }
  .table.gx-lg-4 th.dtr-control, .table.gx-lg-4 td.dtr-control {
    padding-left: 1rem !important;
  }
  .table.gs-lg-4 th:first-child, .table.gs-lg-4 td:first-child {
    padding-left: 1rem;
  }
  .table.gs-lg-4 th:last-child, .table.gs-lg-4 td:last-child {
    padding-right: 1rem;
  }
  .table.gs-lg-4 th.dtr-control:first-child, .table.gs-lg-4 td.dtr-control:first-child {
    padding-left: 1rem !important;
  }
  .table.g-lg-5 th, .table.g-lg-5 td {
    padding: 1.25rem;
  }
  .table.g-lg-5 th.dtr-control, .table.g-lg-5 td.dtr-control {
    padding-left: 1.25rem !important;
  }
  .table.gy-lg-5 th, .table.gy-lg-5 td {
    padding-top: 1.25rem;
    padding-bottom: 1.25rem;
  }
  .table.gx-lg-5 th, .table.gx-lg-5 td {
    padding-left: 1.25rem;
    padding-right: 1.25rem;
  }
  .table.gx-lg-5 th.dtr-control, .table.gx-lg-5 td.dtr-control {
    padding-left: 1.25rem !important;
  }
  .table.gs-lg-5 th:first-child, .table.gs-lg-5 td:first-child {
    padding-left: 1.25rem;
  }
  .table.gs-lg-5 th:last-child, .table.gs-lg-5 td:last-child {
    padding-right: 1.25rem;
  }
  .table.gs-lg-5 th.dtr-control:first-child, .table.gs-lg-5 td.dtr-control:first-child {
    padding-left: 1.25rem !important;
  }
  .table.g-lg-6 th, .table.g-lg-6 td {
    padding: 1.5rem;
  }
  .table.g-lg-6 th.dtr-control, .table.g-lg-6 td.dtr-control {
    padding-left: 1.5rem !important;
  }
  .table.gy-lg-6 th, .table.gy-lg-6 td {
    padding-top: 1.5rem;
    padding-bottom: 1.5rem;
  }
  .table.gx-lg-6 th, .table.gx-lg-6 td {
    padding-left: 1.5rem;
    padding-right: 1.5rem;
  }
  .table.gx-lg-6 th.dtr-control, .table.gx-lg-6 td.dtr-control {
    padding-left: 1.5rem !important;
  }
  .table.gs-lg-6 th:first-child, .table.gs-lg-6 td:first-child {
    padding-left: 1.5rem;
  }
  .table.gs-lg-6 th:last-child, .table.gs-lg-6 td:last-child {
    padding-right: 1.5rem;
  }
  .table.gs-lg-6 th.dtr-control:first-child, .table.gs-lg-6 td.dtr-control:first-child {
    padding-left: 1.5rem !important;
  }
  .table.g-lg-7 th, .table.g-lg-7 td {
    padding: 1.75rem;
  }
  .table.g-lg-7 th.dtr-control, .table.g-lg-7 td.dtr-control {
    padding-left: 1.75rem !important;
  }
  .table.gy-lg-7 th, .table.gy-lg-7 td {
    padding-top: 1.75rem;
    padding-bottom: 1.75rem;
  }
  .table.gx-lg-7 th, .table.gx-lg-7 td {
    padding-left: 1.75rem;
    padding-right: 1.75rem;
  }
  .table.gx-lg-7 th.dtr-control, .table.gx-lg-7 td.dtr-control {
    padding-left: 1.75rem !important;
  }
  .table.gs-lg-7 th:first-child, .table.gs-lg-7 td:first-child {
    padding-left: 1.75rem;
  }
  .table.gs-lg-7 th:last-child, .table.gs-lg-7 td:last-child {
    padding-right: 1.75rem;
  }
  .table.gs-lg-7 th.dtr-control:first-child, .table.gs-lg-7 td.dtr-control:first-child {
    padding-left: 1.75rem !important;
  }
  .table.g-lg-8 th, .table.g-lg-8 td {
    padding: 2rem;
  }
  .table.g-lg-8 th.dtr-control, .table.g-lg-8 td.dtr-control {
    padding-left: 2rem !important;
  }
  .table.gy-lg-8 th, .table.gy-lg-8 td {
    padding-top: 2rem;
    padding-bottom: 2rem;
  }
  .table.gx-lg-8 th, .table.gx-lg-8 td {
    padding-left: 2rem;
    padding-right: 2rem;
  }
  .table.gx-lg-8 th.dtr-control, .table.gx-lg-8 td.dtr-control {
    padding-left: 2rem !important;
  }
  .table.gs-lg-8 th:first-child, .table.gs-lg-8 td:first-child {
    padding-left: 2rem;
  }
  .table.gs-lg-8 th:last-child, .table.gs-lg-8 td:last-child {
    padding-right: 2rem;
  }
  .table.gs-lg-8 th.dtr-control:first-child, .table.gs-lg-8 td.dtr-control:first-child {
    padding-left: 2rem !important;
  }
  .table.g-lg-9 th, .table.g-lg-9 td {
    padding: 2.25rem;
  }
  .table.g-lg-9 th.dtr-control, .table.g-lg-9 td.dtr-control {
    padding-left: 2.25rem !important;
  }
  .table.gy-lg-9 th, .table.gy-lg-9 td {
    padding-top: 2.25rem;
    padding-bottom: 2.25rem;
  }
  .table.gx-lg-9 th, .table.gx-lg-9 td {
    padding-left: 2.25rem;
    padding-right: 2.25rem;
  }
  .table.gx-lg-9 th.dtr-control, .table.gx-lg-9 td.dtr-control {
    padding-left: 2.25rem !important;
  }
  .table.gs-lg-9 th:first-child, .table.gs-lg-9 td:first-child {
    padding-left: 2.25rem;
  }
  .table.gs-lg-9 th:last-child, .table.gs-lg-9 td:last-child {
    padding-right: 2.25rem;
  }
  .table.gs-lg-9 th.dtr-control:first-child, .table.gs-lg-9 td.dtr-control:first-child {
    padding-left: 2.25rem !important;
  }
  .table.g-lg-10 th, .table.g-lg-10 td {
    padding: 2.5rem;
  }
  .table.g-lg-10 th.dtr-control, .table.g-lg-10 td.dtr-control {
    padding-left: 2.5rem !important;
  }
  .table.gy-lg-10 th, .table.gy-lg-10 td {
    padding-top: 2.5rem;
    padding-bottom: 2.5rem;
  }
  .table.gx-lg-10 th, .table.gx-lg-10 td {
    padding-left: 2.5rem;
    padding-right: 2.5rem;
  }
  .table.gx-lg-10 th.dtr-control, .table.gx-lg-10 td.dtr-control {
    padding-left: 2.5rem !important;
  }
  .table.gs-lg-10 th:first-child, .table.gs-lg-10 td:first-child {
    padding-left: 2.5rem;
  }
  .table.gs-lg-10 th:last-child, .table.gs-lg-10 td:last-child {
    padding-right: 2.5rem;
  }
  .table.gs-lg-10 th.dtr-control:first-child, .table.gs-lg-10 td.dtr-control:first-child {
    padding-left: 2.5rem !important;
  }
}
@media (min-width: 1200px) {
  .table.g-xl-0 th, .table.g-xl-0 td {
    padding: 0rem;
  }
  .table.g-xl-0 th.dtr-control, .table.g-xl-0 td.dtr-control {
    padding-left: 0rem !important;
  }
  .table.gy-xl-0 th, .table.gy-xl-0 td {
    padding-top: 0rem;
    padding-bottom: 0rem;
  }
  .table.gx-xl-0 th, .table.gx-xl-0 td {
    padding-left: 0rem;
    padding-right: 0rem;
  }
  .table.gx-xl-0 th.dtr-control, .table.gx-xl-0 td.dtr-control {
    padding-left: 0rem !important;
  }
  .table.gs-xl-0 th:first-child, .table.gs-xl-0 td:first-child {
    padding-left: 0rem;
  }
  .table.gs-xl-0 th:last-child, .table.gs-xl-0 td:last-child {
    padding-right: 0rem;
  }
  .table.gs-xl-0 th.dtr-control:first-child, .table.gs-xl-0 td.dtr-control:first-child {
    padding-left: 0rem !important;
  }
  .table.g-xl-1 th, .table.g-xl-1 td {
    padding: 0.25rem;
  }
  .table.g-xl-1 th.dtr-control, .table.g-xl-1 td.dtr-control {
    padding-left: 0.25rem !important;
  }
  .table.gy-xl-1 th, .table.gy-xl-1 td {
    padding-top: 0.25rem;
    padding-bottom: 0.25rem;
  }
  .table.gx-xl-1 th, .table.gx-xl-1 td {
    padding-left: 0.25rem;
    padding-right: 0.25rem;
  }
  .table.gx-xl-1 th.dtr-control, .table.gx-xl-1 td.dtr-control {
    padding-left: 0.25rem !important;
  }
  .table.gs-xl-1 th:first-child, .table.gs-xl-1 td:first-child {
    padding-left: 0.25rem;
  }
  .table.gs-xl-1 th:last-child, .table.gs-xl-1 td:last-child {
    padding-right: 0.25rem;
  }
  .table.gs-xl-1 th.dtr-control:first-child, .table.gs-xl-1 td.dtr-control:first-child {
    padding-left: 0.25rem !important;
  }
  .table.g-xl-2 th, .table.g-xl-2 td {
    padding: 0.5rem;
  }
  .table.g-xl-2 th.dtr-control, .table.g-xl-2 td.dtr-control {
    padding-left: 0.5rem !important;
  }
  .table.gy-xl-2 th, .table.gy-xl-2 td {
    padding-top: 0.5rem;
    padding-bottom: 0.5rem;
  }
  .table.gx-xl-2 th, .table.gx-xl-2 td {
    padding-left: 0.5rem;
    padding-right: 0.5rem;
  }
  .table.gx-xl-2 th.dtr-control, .table.gx-xl-2 td.dtr-control {
    padding-left: 0.5rem !important;
  }
  .table.gs-xl-2 th:first-child, .table.gs-xl-2 td:first-child {
    padding-left: 0.5rem;
  }
  .table.gs-xl-2 th:last-child, .table.gs-xl-2 td:last-child {
    padding-right: 0.5rem;
  }
  .table.gs-xl-2 th.dtr-control:first-child, .table.gs-xl-2 td.dtr-control:first-child {
    padding-left: 0.5rem !important;
  }
  .table.g-xl-3 th, .table.g-xl-3 td {
    padding: 0.75rem;
  }
  .table.g-xl-3 th.dtr-control, .table.g-xl-3 td.dtr-control {
    padding-left: 0.75rem !important;
  }
  .table.gy-xl-3 th, .table.gy-xl-3 td {
    padding-top: 0.75rem;
    padding-bottom: 0.75rem;
  }
  .table.gx-xl-3 th, .table.gx-xl-3 td {
    padding-left: 0.75rem;
    padding-right: 0.75rem;
  }
  .table.gx-xl-3 th.dtr-control, .table.gx-xl-3 td.dtr-control {
    padding-left: 0.75rem !important;
  }
  .table.gs-xl-3 th:first-child, .table.gs-xl-3 td:first-child {
    padding-left: 0.75rem;
  }
  .table.gs-xl-3 th:last-child, .table.gs-xl-3 td:last-child {
    padding-right: 0.75rem;
  }
  .table.gs-xl-3 th.dtr-control:first-child, .table.gs-xl-3 td.dtr-control:first-child {
    padding-left: 0.75rem !important;
  }
  .table.g-xl-4 th, .table.g-xl-4 td {
    padding: 1rem;
  }
  .table.g-xl-4 th.dtr-control, .table.g-xl-4 td.dtr-control {
    padding-left: 1rem !important;
  }
  .table.gy-xl-4 th, .table.gy-xl-4 td {
    padding-top: 1rem;
    padding-bottom: 1rem;
  }
  .table.gx-xl-4 th, .table.gx-xl-4 td {
    padding-left: 1rem;
    padding-right: 1rem;
  }
  .table.gx-xl-4 th.dtr-control, .table.gx-xl-4 td.dtr-control {
    padding-left: 1rem !important;
  }
  .table.gs-xl-4 th:first-child, .table.gs-xl-4 td:first-child {
    padding-left: 1rem;
  }
  .table.gs-xl-4 th:last-child, .table.gs-xl-4 td:last-child {
    padding-right: 1rem;
  }
  .table.gs-xl-4 th.dtr-control:first-child, .table.gs-xl-4 td.dtr-control:first-child {
    padding-left: 1rem !important;
  }
  .table.g-xl-5 th, .table.g-xl-5 td {
    padding: 1.25rem;
  }
  .table.g-xl-5 th.dtr-control, .table.g-xl-5 td.dtr-control {
    padding-left: 1.25rem !important;
  }
  .table.gy-xl-5 th, .table.gy-xl-5 td {
    padding-top: 1.25rem;
    padding-bottom: 1.25rem;
  }
  .table.gx-xl-5 th, .table.gx-xl-5 td {
    padding-left: 1.25rem;
    padding-right: 1.25rem;
  }
  .table.gx-xl-5 th.dtr-control, .table.gx-xl-5 td.dtr-control {
    padding-left: 1.25rem !important;
  }
  .table.gs-xl-5 th:first-child, .table.gs-xl-5 td:first-child {
    padding-left: 1.25rem;
  }
  .table.gs-xl-5 th:last-child, .table.gs-xl-5 td:last-child {
    padding-right: 1.25rem;
  }
  .table.gs-xl-5 th.dtr-control:first-child, .table.gs-xl-5 td.dtr-control:first-child {
    padding-left: 1.25rem !important;
  }
  .table.g-xl-6 th, .table.g-xl-6 td {
    padding: 1.5rem;
  }
  .table.g-xl-6 th.dtr-control, .table.g-xl-6 td.dtr-control {
    padding-left: 1.5rem !important;
  }
  .table.gy-xl-6 th, .table.gy-xl-6 td {
    padding-top: 1.5rem;
    padding-bottom: 1.5rem;
  }
  .table.gx-xl-6 th, .table.gx-xl-6 td {
    padding-left: 1.5rem;
    padding-right: 1.5rem;
  }
  .table.gx-xl-6 th.dtr-control, .table.gx-xl-6 td.dtr-control {
    padding-left: 1.5rem !important;
  }
  .table.gs-xl-6 th:first-child, .table.gs-xl-6 td:first-child {
    padding-left: 1.5rem;
  }
  .table.gs-xl-6 th:last-child, .table.gs-xl-6 td:last-child {
    padding-right: 1.5rem;
  }
  .table.gs-xl-6 th.dtr-control:first-child, .table.gs-xl-6 td.dtr-control:first-child {
    padding-left: 1.5rem !important;
  }
  .table.g-xl-7 th, .table.g-xl-7 td {
    padding: 1.75rem;
  }
  .table.g-xl-7 th.dtr-control, .table.g-xl-7 td.dtr-control {
    padding-left: 1.75rem !important;
  }
  .table.gy-xl-7 th, .table.gy-xl-7 td {
    padding-top: 1.75rem;
    padding-bottom: 1.75rem;
  }
  .table.gx-xl-7 th, .table.gx-xl-7 td {
    padding-left: 1.75rem;
    padding-right: 1.75rem;
  }
  .table.gx-xl-7 th.dtr-control, .table.gx-xl-7 td.dtr-control {
    padding-left: 1.75rem !important;
  }
  .table.gs-xl-7 th:first-child, .table.gs-xl-7 td:first-child {
    padding-left: 1.75rem;
  }
  .table.gs-xl-7 th:last-child, .table.gs-xl-7 td:last-child {
    padding-right: 1.75rem;
  }
  .table.gs-xl-7 th.dtr-control:first-child, .table.gs-xl-7 td.dtr-control:first-child {
    padding-left: 1.75rem !important;
  }
  .table.g-xl-8 th, .table.g-xl-8 td {
    padding: 2rem;
  }
  .table.g-xl-8 th.dtr-control, .table.g-xl-8 td.dtr-control {
    padding-left: 2rem !important;
  }
  .table.gy-xl-8 th, .table.gy-xl-8 td {
    padding-top: 2rem;
    padding-bottom: 2rem;
  }
  .table.gx-xl-8 th, .table.gx-xl-8 td {
    padding-left: 2rem;
    padding-right: 2rem;
  }
  .table.gx-xl-8 th.dtr-control, .table.gx-xl-8 td.dtr-control {
    padding-left: 2rem !important;
  }
  .table.gs-xl-8 th:first-child, .table.gs-xl-8 td:first-child {
    padding-left: 2rem;
  }
  .table.gs-xl-8 th:last-child, .table.gs-xl-8 td:last-child {
    padding-right: 2rem;
  }
  .table.gs-xl-8 th.dtr-control:first-child, .table.gs-xl-8 td.dtr-control:first-child {
    padding-left: 2rem !important;
  }
  .table.g-xl-9 th, .table.g-xl-9 td {
    padding: 2.25rem;
  }
  .table.g-xl-9 th.dtr-control, .table.g-xl-9 td.dtr-control {
    padding-left: 2.25rem !important;
  }
  .table.gy-xl-9 th, .table.gy-xl-9 td {
    padding-top: 2.25rem;
    padding-bottom: 2.25rem;
  }
  .table.gx-xl-9 th, .table.gx-xl-9 td {
    padding-left: 2.25rem;
    padding-right: 2.25rem;
  }
  .table.gx-xl-9 th.dtr-control, .table.gx-xl-9 td.dtr-control {
    padding-left: 2.25rem !important;
  }
  .table.gs-xl-9 th:first-child, .table.gs-xl-9 td:first-child {
    padding-left: 2.25rem;
  }
  .table.gs-xl-9 th:last-child, .table.gs-xl-9 td:last-child {
    padding-right: 2.25rem;
  }
  .table.gs-xl-9 th.dtr-control:first-child, .table.gs-xl-9 td.dtr-control:first-child {
    padding-left: 2.25rem !important;
  }
  .table.g-xl-10 th, .table.g-xl-10 td {
    padding: 2.5rem;
  }
  .table.g-xl-10 th.dtr-control, .table.g-xl-10 td.dtr-control {
    padding-left: 2.5rem !important;
  }
  .table.gy-xl-10 th, .table.gy-xl-10 td {
    padding-top: 2.5rem;
    padding-bottom: 2.5rem;
  }
  .table.gx-xl-10 th, .table.gx-xl-10 td {
    padding-left: 2.5rem;
    padding-right: 2.5rem;
  }
  .table.gx-xl-10 th.dtr-control, .table.gx-xl-10 td.dtr-control {
    padding-left: 2.5rem !important;
  }
  .table.gs-xl-10 th:first-child, .table.gs-xl-10 td:first-child {
    padding-left: 2.5rem;
  }
  .table.gs-xl-10 th:last-child, .table.gs-xl-10 td:last-child {
    padding-right: 2.5rem;
  }
  .table.gs-xl-10 th.dtr-control:first-child, .table.gs-xl-10 td.dtr-control:first-child {
    padding-left: 2.5rem !important;
  }
}
@media (min-width: 1400px) {
  .table.g-xxl-0 th, .table.g-xxl-0 td {
    padding: 0rem;
  }
  .table.g-xxl-0 th.dtr-control, .table.g-xxl-0 td.dtr-control {
    padding-left: 0rem !important;
  }
  .table.gy-xxl-0 th, .table.gy-xxl-0 td {
    padding-top: 0rem;
    padding-bottom: 0rem;
  }
  .table.gx-xxl-0 th, .table.gx-xxl-0 td {
    padding-left: 0rem;
    padding-right: 0rem;
  }
  .table.gx-xxl-0 th.dtr-control, .table.gx-xxl-0 td.dtr-control {
    padding-left: 0rem !important;
  }
  .table.gs-xxl-0 th:first-child, .table.gs-xxl-0 td:first-child {
    padding-left: 0rem;
  }
  .table.gs-xxl-0 th:last-child, .table.gs-xxl-0 td:last-child {
    padding-right: 0rem;
  }
  .table.gs-xxl-0 th.dtr-control:first-child, .table.gs-xxl-0 td.dtr-control:first-child {
    padding-left: 0rem !important;
  }
  .table.g-xxl-1 th, .table.g-xxl-1 td {
    padding: 0.25rem;
  }
  .table.g-xxl-1 th.dtr-control, .table.g-xxl-1 td.dtr-control {
    padding-left: 0.25rem !important;
  }
  .table.gy-xxl-1 th, .table.gy-xxl-1 td {
    padding-top: 0.25rem;
    padding-bottom: 0.25rem;
  }
  .table.gx-xxl-1 th, .table.gx-xxl-1 td {
    padding-left: 0.25rem;
    padding-right: 0.25rem;
  }
  .table.gx-xxl-1 th.dtr-control, .table.gx-xxl-1 td.dtr-control {
    padding-left: 0.25rem !important;
  }
  .table.gs-xxl-1 th:first-child, .table.gs-xxl-1 td:first-child {
    padding-left: 0.25rem;
  }
  .table.gs-xxl-1 th:last-child, .table.gs-xxl-1 td:last-child {
    padding-right: 0.25rem;
  }
  .table.gs-xxl-1 th.dtr-control:first-child, .table.gs-xxl-1 td.dtr-control:first-child {
    padding-left: 0.25rem !important;
  }
  .table.g-xxl-2 th, .table.g-xxl-2 td {
    padding: 0.5rem;
  }
  .table.g-xxl-2 th.dtr-control, .table.g-xxl-2 td.dtr-control {
    padding-left: 0.5rem !important;
  }
  .table.gy-xxl-2 th, .table.gy-xxl-2 td {
    padding-top: 0.5rem;
    padding-bottom: 0.5rem;
  }
  .table.gx-xxl-2 th, .table.gx-xxl-2 td {
    padding-left: 0.5rem;
    padding-right: 0.5rem;
  }
  .table.gx-xxl-2 th.dtr-control, .table.gx-xxl-2 td.dtr-control {
    padding-left: 0.5rem !important;
  }
  .table.gs-xxl-2 th:first-child, .table.gs-xxl-2 td:first-child {
    padding-left: 0.5rem;
  }
  .table.gs-xxl-2 th:last-child, .table.gs-xxl-2 td:last-child {
    padding-right: 0.5rem;
  }
  .table.gs-xxl-2 th.dtr-control:first-child, .table.gs-xxl-2 td.dtr-control:first-child {
    padding-left: 0.5rem !important;
  }
  .table.g-xxl-3 th, .table.g-xxl-3 td {
    padding: 0.75rem;
  }
  .table.g-xxl-3 th.dtr-control, .table.g-xxl-3 td.dtr-control {
    padding-left: 0.75rem !important;
  }
  .table.gy-xxl-3 th, .table.gy-xxl-3 td {
    padding-top: 0.75rem;
    padding-bottom: 0.75rem;
  }
  .table.gx-xxl-3 th, .table.gx-xxl-3 td {
    padding-left: 0.75rem;
    padding-right: 0.75rem;
  }
  .table.gx-xxl-3 th.dtr-control, .table.gx-xxl-3 td.dtr-control {
    padding-left: 0.75rem !important;
  }
  .table.gs-xxl-3 th:first-child, .table.gs-xxl-3 td:first-child {
    padding-left: 0.75rem;
  }
  .table.gs-xxl-3 th:last-child, .table.gs-xxl-3 td:last-child {
    padding-right: 0.75rem;
  }
  .table.gs-xxl-3 th.dtr-control:first-child, .table.gs-xxl-3 td.dtr-control:first-child {
    padding-left: 0.75rem !important;
  }
  .table.g-xxl-4 th, .table.g-xxl-4 td {
    padding: 1rem;
  }
  .table.g-xxl-4 th.dtr-control, .table.g-xxl-4 td.dtr-control {
    padding-left: 1rem !important;
  }
  .table.gy-xxl-4 th, .table.gy-xxl-4 td {
    padding-top: 1rem;
    padding-bottom: 1rem;
  }
  .table.gx-xxl-4 th, .table.gx-xxl-4 td {
    padding-left: 1rem;
    padding-right: 1rem;
  }
  .table.gx-xxl-4 th.dtr-control, .table.gx-xxl-4 td.dtr-control {
    padding-left: 1rem !important;
  }
  .table.gs-xxl-4 th:first-child, .table.gs-xxl-4 td:first-child {
    padding-left: 1rem;
  }
  .table.gs-xxl-4 th:last-child, .table.gs-xxl-4 td:last-child {
    padding-right: 1rem;
  }
  .table.gs-xxl-4 th.dtr-control:first-child, .table.gs-xxl-4 td.dtr-control:first-child {
    padding-left: 1rem !important;
  }
  .table.g-xxl-5 th, .table.g-xxl-5 td {
    padding: 1.25rem;
  }
  .table.g-xxl-5 th.dtr-control, .table.g-xxl-5 td.dtr-control {
    padding-left: 1.25rem !important;
  }
  .table.gy-xxl-5 th, .table.gy-xxl-5 td {
    padding-top: 1.25rem;
    padding-bottom: 1.25rem;
  }
  .table.gx-xxl-5 th, .table.gx-xxl-5 td {
    padding-left: 1.25rem;
    padding-right: 1.25rem;
  }
  .table.gx-xxl-5 th.dtr-control, .table.gx-xxl-5 td.dtr-control {
    padding-left: 1.25rem !important;
  }
  .table.gs-xxl-5 th:first-child, .table.gs-xxl-5 td:first-child {
    padding-left: 1.25rem;
  }
  .table.gs-xxl-5 th:last-child, .table.gs-xxl-5 td:last-child {
    padding-right: 1.25rem;
  }
  .table.gs-xxl-5 th.dtr-control:first-child, .table.gs-xxl-5 td.dtr-control:first-child {
    padding-left: 1.25rem !important;
  }
  .table.g-xxl-6 th, .table.g-xxl-6 td {
    padding: 1.5rem;
  }
  .table.g-xxl-6 th.dtr-control, .table.g-xxl-6 td.dtr-control {
    padding-left: 1.5rem !important;
  }
  .table.gy-xxl-6 th, .table.gy-xxl-6 td {
    padding-top: 1.5rem;
    padding-bottom: 1.5rem;
  }
  .table.gx-xxl-6 th, .table.gx-xxl-6 td {
    padding-left: 1.5rem;
    padding-right: 1.5rem;
  }
  .table.gx-xxl-6 th.dtr-control, .table.gx-xxl-6 td.dtr-control {
    padding-left: 1.5rem !important;
  }
  .table.gs-xxl-6 th:first-child, .table.gs-xxl-6 td:first-child {
    padding-left: 1.5rem;
  }
  .table.gs-xxl-6 th:last-child, .table.gs-xxl-6 td:last-child {
    padding-right: 1.5rem;
  }
  .table.gs-xxl-6 th.dtr-control:first-child, .table.gs-xxl-6 td.dtr-control:first-child {
    padding-left: 1.5rem !important;
  }
  .table.g-xxl-7 th, .table.g-xxl-7 td {
    padding: 1.75rem;
  }
  .table.g-xxl-7 th.dtr-control, .table.g-xxl-7 td.dtr-control {
    padding-left: 1.75rem !important;
  }
  .table.gy-xxl-7 th, .table.gy-xxl-7 td {
    padding-top: 1.75rem;
    padding-bottom: 1.75rem;
  }
  .table.gx-xxl-7 th, .table.gx-xxl-7 td {
    padding-left: 1.75rem;
    padding-right: 1.75rem;
  }
  .table.gx-xxl-7 th.dtr-control, .table.gx-xxl-7 td.dtr-control {
    padding-left: 1.75rem !important;
  }
  .table.gs-xxl-7 th:first-child, .table.gs-xxl-7 td:first-child {
    padding-left: 1.75rem;
  }
  .table.gs-xxl-7 th:last-child, .table.gs-xxl-7 td:last-child {
    padding-right: 1.75rem;
  }
  .table.gs-xxl-7 th.dtr-control:first-child, .table.gs-xxl-7 td.dtr-control:first-child {
    padding-left: 1.75rem !important;
  }
  .table.g-xxl-8 th, .table.g-xxl-8 td {
    padding: 2rem;
  }
  .table.g-xxl-8 th.dtr-control, .table.g-xxl-8 td.dtr-control {
    padding-left: 2rem !important;
  }
  .table.gy-xxl-8 th, .table.gy-xxl-8 td {
    padding-top: 2rem;
    padding-bottom: 2rem;
  }
  .table.gx-xxl-8 th, .table.gx-xxl-8 td {
    padding-left: 2rem;
    padding-right: 2rem;
  }
  .table.gx-xxl-8 th.dtr-control, .table.gx-xxl-8 td.dtr-control {
    padding-left: 2rem !important;
  }
  .table.gs-xxl-8 th:first-child, .table.gs-xxl-8 td:first-child {
    padding-left: 2rem;
  }
  .table.gs-xxl-8 th:last-child, .table.gs-xxl-8 td:last-child {
    padding-right: 2rem;
  }
  .table.gs-xxl-8 th.dtr-control:first-child, .table.gs-xxl-8 td.dtr-control:first-child {
    padding-left: 2rem !important;
  }
  .table.g-xxl-9 th, .table.g-xxl-9 td {
    padding: 2.25rem;
  }
  .table.g-xxl-9 th.dtr-control, .table.g-xxl-9 td.dtr-control {
    padding-left: 2.25rem !important;
  }
  .table.gy-xxl-9 th, .table.gy-xxl-9 td {
    padding-top: 2.25rem;
    padding-bottom: 2.25rem;
  }
  .table.gx-xxl-9 th, .table.gx-xxl-9 td {
    padding-left: 2.25rem;
    padding-right: 2.25rem;
  }
  .table.gx-xxl-9 th.dtr-control, .table.gx-xxl-9 td.dtr-control {
    padding-left: 2.25rem !important;
  }
  .table.gs-xxl-9 th:first-child, .table.gs-xxl-9 td:first-child {
    padding-left: 2.25rem;
  }
  .table.gs-xxl-9 th:last-child, .table.gs-xxl-9 td:last-child {
    padding-right: 2.25rem;
  }
  .table.gs-xxl-9 th.dtr-control:first-child, .table.gs-xxl-9 td.dtr-control:first-child {
    padding-left: 2.25rem !important;
  }
  .table.g-xxl-10 th, .table.g-xxl-10 td {
    padding: 2.5rem;
  }
  .table.g-xxl-10 th.dtr-control, .table.g-xxl-10 td.dtr-control {
    padding-left: 2.5rem !important;
  }
  .table.gy-xxl-10 th, .table.gy-xxl-10 td {
    padding-top: 2.5rem;
    padding-bottom: 2.5rem;
  }
  .table.gx-xxl-10 th, .table.gx-xxl-10 td {
    padding-left: 2.5rem;
    padding-right: 2.5rem;
  }
  .table.gx-xxl-10 th.dtr-control, .table.gx-xxl-10 td.dtr-control {
    padding-left: 2.5rem !important;
  }
  .table.gs-xxl-10 th:first-child, .table.gs-xxl-10 td:first-child {
    padding-left: 2.5rem;
  }
  .table.gs-xxl-10 th:last-child, .table.gs-xxl-10 td:last-child {
    padding-right: 2.5rem;
  }
  .table.gs-xxl-10 th.dtr-control:first-child, .table.gs-xxl-10 td.dtr-control:first-child {
    padding-left: 2.5rem !important;
  }
}
.popover {
  --bs-popover-header-border-color: #F4F4F4;
}

.popover .popover-header {
  font-size: 1rem;
  font-weight: 500;
  border-bottom: 1px solid var(--bs-popover-header-border-color);
}

.popover .popover-dismiss {
  position: absolute;
  top: 0.85rem;
  right: 0.85rem;
  height: 1.25rem;
  width: 1.25rem;
  mask-repeat: no-repeat;
  mask-position: center;
  -webkit-mask-repeat: no-repeat;
  -webkit-mask-position: center;
  background-color: var(--bs-gray-500);
  mask-image: url(${___CSS_LOADER_URL_REPLACEMENT_114___});
  mask-size: 50%;
  -webkit-mask-size: 50%;
}

.popover .popover-dismiss:hover {
  background-color: var(--bs-primary);
}

.popover .popover-dismiss + .popover-header {
  padding-right: 2.5rem;
}

.popover-inverse {
  --bs-popover-bg: var(--bs-gray-900);
  --bs-popover-border-color: var(--bs-gray-900);
  --bs-popover-box-shadow: 0px 0px 30px rgba(0, 0, 0, 0.3);
  --bs-popover-header-color: var(--bs-gray-200);
  --bs-popover-header-bg: var(--bs-gray-900);
  --bs-popover-body-color: var(--bs-gray-400);
  --bs-popover-arrow-border: transparent;
  --bs-popover-header-border-color: var(--bs-gray-800);
}

[data-bs-theme=dark] .popover:not(.popover-inverse) {
  --bs-popover-bg: #2B2B40;
  --bs-popover-border-color: #2B2B40;
  --bs-popover-header-bg: #2B2B40;
  --bs-popover-box-shadow: 0px 0px 30px rgba(0, 0, 0, 0.3);
  --bs-popover-header-border-color: #323248;
}

.tooltip .tooltip-inner {
  box-shadow: var(--bs-tooltip-box-shadow);
}

.tooltip.tooltop-auto-width .tooltip-inner {
  white-space: nowrap;
  max-width: none;
}

.tooltip.tooltip-inverse {
  --bs-tooltip-color: var(--bs-dark-inverse);
  --bs-tooltip-bg: var(--bs-dark);
}

[data-bs-theme=dark] .tooltip:not(.tooltip-inverse) {
  --bs-tooltip-bg: #2B2B40;
  --bs-tooltip-box-shadow: 0px 0px 30px rgba(0, 0, 0, 0.15);
}

.accordion .accordion-header {
  cursor: pointer;
}

.accordion.accordion-icon-toggle .accordion-icon {
  display: flex;
  flex-shrink: 0;
  transition: all 0.2s ease-in-out;
  transform: rotate(90deg);
  align-items: center;
  justify-content: center;
}

.accordion.accordion-icon-toggle .accordion-icon i,
.accordion.accordion-icon-toggle .accordion-icon .svg-icon {
  color: var(--bs-primary);
}

.accordion.accordion-icon-toggle .collapsed .accordion-icon {
  transition: all 0.2s ease-in-out;
  transform: rotate(0);
}

.accordion.accordion-icon-toggle .collapsed .accordion-icon i,
.accordion.accordion-icon-toggle .collapsed .accordion-icon .svg-icon {
  color: var(--bs-text-muted);
}

.accordion.accordion-icon-collapse .accordion-icon {
  display: flex;
  flex-shrink: 0;
  align-items: center;
  justify-content: center;
  transition: all 0.2s ease-in-out;
}

.accordion.accordion-icon-collapse .accordion-icon .accordion-icon-on {
  display: inline-flex;
}

.accordion.accordion-icon-collapse .accordion-icon .accordion-icon-off {
  display: none;
}

.accordion.accordion-icon-collapse .accordion-icon i,
.accordion.accordion-icon-collapse .accordion-icon .svg-icon {
  color: var(--bs-primary);
}

.accordion.accordion-icon-collapse .collapsed .accordion-icon {
  transition: all 0.2s ease-in-out;
}

.accordion.accordion-icon-collapse .collapsed .accordion-icon .accordion-icon-on {
  display: none;
}

.accordion.accordion-icon-collapse .collapsed .accordion-icon .accordion-icon-off {
  display: inline-flex;
}

.accordion.accordion-icon-collapse .collapsed .accordion-icon i,
.accordion.accordion-icon-collapse .collapsed .accordion-icon .svg-icon {
  color: var(--bs-text-muted);
}

.accordion.accordion-borderless .accordion-item {
  border: 0;
}

.accordion.accordion-flush .accordion-item {
  background-color: transparent;
  border: 0;
  border-radius: 0;
  padding-left: 0;
  padding-right: 0;
}

.image-input {
  position: relative;
  display: inline-block;
  border-radius: 0.475rem;
  background-repeat: no-repeat;
  background-size: cover;
}

.image-input:not(.image-input-empty) {
  background-image: none !important;
}

.image-input .image-input-wrapper {
  width: 120px;
  height: 120px;
  border-radius: 0.475rem;
  background-repeat: no-repeat;
  background-size: cover;
}

.image-input [data-kt-image-input-action] {
  cursor: pointer;
  position: absolute;
  transform: translate(-50%, -50%);
}

.image-input [data-kt-image-input-action=change] {
  left: 100%;
  top: 0;
}

.image-input [data-kt-image-input-action=change] input {
  width: 0 !important;
  height: 0 !important;
  overflow: hidden;
  opacity: 0;
}

.image-input [data-kt-image-input-action=cancel],
.image-input [data-kt-image-input-action=remove] {
  position: absolute;
  left: 100%;
  top: 100%;
}

.image-input [data-kt-image-input-action=cancel] {
  display: none;
}

.image-input.image-input-changed [data-kt-image-input-action=cancel] {
  display: flex;
}

.image-input.image-input-changed [data-kt-image-input-action=remove] {
  display: none;
}

.image-input.image-input-empty [data-kt-image-input-action=remove],
.image-input.image-input-empty [data-kt-image-input-action=cancel] {
  display: none;
}

.image-input.image-input-circle {
  border-radius: 50%;
}

.image-input.image-input-circle .image-input-wrapper {
  border-radius: 50%;
}

.image-input.image-input-circle [data-kt-image-input-action=change] {
  left: 100%;
  top: 0;
  transform: translate(-100%, 0%);
}

.image-input.image-input-circle [data-kt-image-input-action=cancel],
.image-input.image-input-circle [data-kt-image-input-action=remove] {
  left: 100%;
  top: 100%;
  transform: translate(-100%, -100%);
}

.image-input.image-input-outline .image-input-wrapper {
  border: 3px solid var(--bs-body-bg);
  box-shadow: var(--bs-box-shadow);
}

.symbol {
  display: inline-block;
  flex-shrink: 0;
  position: relative;
  border-radius: 0.475rem;
}

.symbol .symbol-label {
  display: flex;
  align-items: center;
  justify-content: center;
  font-weight: 500;
  color: var(--bs-symbol-label-color);
  background-color: var(--bs-symbol-label-bg);
  background-repeat: no-repeat;
  background-position: center center;
  background-size: cover;
  border-radius: 0.475rem;
}

.symbol .symbol-label:after {
  border-radius: 0.475rem;
}

.symbol .symbol-badge {
  position: absolute;
  border-radius: 100%;
  top: 0;
  left: 50%;
  transform: translateX(-50%) translateY(-50%) !important;
}

.symbol > img {
  width: 100%;
  flex-shrink: 0;
  display: inline-block;
  border-radius: 0.475rem;
}

.symbol.symbol-square,
.symbol.symbol-square > img,
.symbol.symbol-square .symbol-label {
  border-radius: 0 !important;
}

.symbol.symbol-circle,
.symbol.symbol-circle > img,
.symbol.symbol-circle .symbol-label {
  border-radius: 50%;
}

.symbol.symbol-circle:after,
.symbol.symbol-circle > img:after,
.symbol.symbol-circle .symbol-label:after {
  border-radius: 50%;
}

.symbol > img {
  width: 50px;
  height: 50px;
}

.symbol .symbol-label {
  width: 50px;
  height: 50px;
}

.symbol.symbol-fixed .symbol-label {
  width: 50px;
  height: 50px;
}

.symbol.symbol-fixed > img {
  width: 50px;
  height: 50px;
  max-width: none;
}

.symbol.symbol-2by3 .symbol-label {
  height: 50px;
  width: 75px;
}

.symbol.symbol-2by3 > img {
  height: 50px;
  width: 75px;
  max-width: none;
}

.symbol.symbol-20px > img {
  width: 20px;
  height: 20px;
}

.symbol.symbol-20px .symbol-label {
  width: 20px;
  height: 20px;
}

.symbol.symbol-20px.symbol-fixed .symbol-label {
  width: 20px;
  height: 20px;
}

.symbol.symbol-20px.symbol-fixed > img {
  width: 20px;
  height: 20px;
  max-width: none;
}

.symbol.symbol-20px.symbol-2by3 .symbol-label {
  height: 20px;
  width: 30px;
}

.symbol.symbol-20px.symbol-2by3 > img {
  height: 20px;
  width: 30px;
  max-width: none;
}

.symbol.symbol-25px > img {
  width: 25px;
  height: 25px;
}

.symbol.symbol-25px .symbol-label {
  width: 25px;
  height: 25px;
}

.symbol.symbol-25px.symbol-fixed .symbol-label {
  width: 25px;
  height: 25px;
}

.symbol.symbol-25px.symbol-fixed > img {
  width: 25px;
  height: 25px;
  max-width: none;
}

.symbol.symbol-25px.symbol-2by3 .symbol-label {
  height: 25px;
  width: 37.5px;
}

.symbol.symbol-25px.symbol-2by3 > img {
  height: 25px;
  width: 37.5px;
  max-width: none;
}

.symbol.symbol-30px > img {
  width: 30px;
  height: 30px;
}

.symbol.symbol-30px .symbol-label {
  width: 30px;
  height: 30px;
}

.symbol.symbol-30px.symbol-fixed .symbol-label {
  width: 30px;
  height: 30px;
}

.symbol.symbol-30px.symbol-fixed > img {
  width: 30px;
  height: 30px;
  max-width: none;
}

.symbol.symbol-30px.symbol-2by3 .symbol-label {
  height: 30px;
  width: 45px;
}

.symbol.symbol-30px.symbol-2by3 > img {
  height: 30px;
  width: 45px;
  max-width: none;
}

.symbol.symbol-35px > img {
  width: 35px;
  height: 35px;
}

.symbol.symbol-35px .symbol-label {
  width: 35px;
  height: 35px;
}

.symbol.symbol-35px.symbol-fixed .symbol-label {
  width: 35px;
  height: 35px;
}

.symbol.symbol-35px.symbol-fixed > img {
  width: 35px;
  height: 35px;
  max-width: none;
}

.symbol.symbol-35px.symbol-2by3 .symbol-label {
  height: 35px;
  width: 52.5px;
}

.symbol.symbol-35px.symbol-2by3 > img {
  height: 35px;
  width: 52.5px;
  max-width: none;
}

.symbol.symbol-40px > img {
  width: 40px;
  height: 40px;
}

.symbol.symbol-40px .symbol-label {
  width: 40px;
  height: 40px;
}

.symbol.symbol-40px.symbol-fixed .symbol-label {
  width: 40px;
  height: 40px;
}

.symbol.symbol-40px.symbol-fixed > img {
  width: 40px;
  height: 40px;
  max-width: none;
}

.symbol.symbol-40px.symbol-2by3 .symbol-label {
  height: 40px;
  width: 60px;
}

.symbol.symbol-40px.symbol-2by3 > img {
  height: 40px;
  width: 60px;
  max-width: none;
}

.symbol.symbol-45px > img {
  width: 45px;
  height: 45px;
}

.symbol.symbol-45px .symbol-label {
  width: 45px;
  height: 45px;
}

.symbol.symbol-45px.symbol-fixed .symbol-label {
  width: 45px;
  height: 45px;
}

.symbol.symbol-45px.symbol-fixed > img {
  width: 45px;
  height: 45px;
  max-width: none;
}

.symbol.symbol-45px.symbol-2by3 .symbol-label {
  height: 45px;
  width: 67.5px;
}

.symbol.symbol-45px.symbol-2by3 > img {
  height: 45px;
  width: 67.5px;
  max-width: none;
}

.symbol.symbol-50px > img {
  width: 50px;
  height: 50px;
}

.symbol.symbol-50px .symbol-label {
  width: 50px;
  height: 50px;
}

.symbol.symbol-50px.symbol-fixed .symbol-label {
  width: 50px;
  height: 50px;
}

.symbol.symbol-50px.symbol-fixed > img {
  width: 50px;
  height: 50px;
  max-width: none;
}

.symbol.symbol-50px.symbol-2by3 .symbol-label {
  height: 50px;
  width: 75px;
}

.symbol.symbol-50px.symbol-2by3 > img {
  height: 50px;
  width: 75px;
  max-width: none;
}

.symbol.symbol-55px > img {
  width: 55px;
  height: 55px;
}

.symbol.symbol-55px .symbol-label {
  width: 55px;
  height: 55px;
}

.symbol.symbol-55px.symbol-fixed .symbol-label {
  width: 55px;
  height: 55px;
}

.symbol.symbol-55px.symbol-fixed > img {
  width: 55px;
  height: 55px;
  max-width: none;
}

.symbol.symbol-55px.symbol-2by3 .symbol-label {
  height: 55px;
  width: 82.5px;
}

.symbol.symbol-55px.symbol-2by3 > img {
  height: 55px;
  width: 82.5px;
  max-width: none;
}

.symbol.symbol-60px > img {
  width: 60px;
  height: 60px;
}

.symbol.symbol-60px .symbol-label {
  width: 60px;
  height: 60px;
}

.symbol.symbol-60px.symbol-fixed .symbol-label {
  width: 60px;
  height: 60px;
}

.symbol.symbol-60px.symbol-fixed > img {
  width: 60px;
  height: 60px;
  max-width: none;
}

.symbol.symbol-60px.symbol-2by3 .symbol-label {
  height: 60px;
  width: 90px;
}

.symbol.symbol-60px.symbol-2by3 > img {
  height: 60px;
  width: 90px;
  max-width: none;
}

.symbol.symbol-65px > img {
  width: 65px;
  height: 65px;
}

.symbol.symbol-65px .symbol-label {
  width: 65px;
  height: 65px;
}

.symbol.symbol-65px.symbol-fixed .symbol-label {
  width: 65px;
  height: 65px;
}

.symbol.symbol-65px.symbol-fixed > img {
  width: 65px;
  height: 65px;
  max-width: none;
}

.symbol.symbol-65px.symbol-2by3 .symbol-label {
  height: 65px;
  width: 97.5px;
}

.symbol.symbol-65px.symbol-2by3 > img {
  height: 65px;
  width: 97.5px;
  max-width: none;
}

.symbol.symbol-70px > img {
  width: 70px;
  height: 70px;
}

.symbol.symbol-70px .symbol-label {
  width: 70px;
  height: 70px;
}

.symbol.symbol-70px.symbol-fixed .symbol-label {
  width: 70px;
  height: 70px;
}

.symbol.symbol-70px.symbol-fixed > img {
  width: 70px;
  height: 70px;
  max-width: none;
}

.symbol.symbol-70px.symbol-2by3 .symbol-label {
  height: 70px;
  width: 105px;
}

.symbol.symbol-70px.symbol-2by3 > img {
  height: 70px;
  width: 105px;
  max-width: none;
}

.symbol.symbol-75px > img {
  width: 75px;
  height: 75px;
}

.symbol.symbol-75px .symbol-label {
  width: 75px;
  height: 75px;
}

.symbol.symbol-75px.symbol-fixed .symbol-label {
  width: 75px;
  height: 75px;
}

.symbol.symbol-75px.symbol-fixed > img {
  width: 75px;
  height: 75px;
  max-width: none;
}

.symbol.symbol-75px.symbol-2by3 .symbol-label {
  height: 75px;
  width: 112.5px;
}

.symbol.symbol-75px.symbol-2by3 > img {
  height: 75px;
  width: 112.5px;
  max-width: none;
}

.symbol.symbol-90px > img {
  width: 90px;
  height: 90px;
}

.symbol.symbol-90px .symbol-label {
  width: 90px;
  height: 90px;
}

.symbol.symbol-90px.symbol-fixed .symbol-label {
  width: 90px;
  height: 90px;
}

.symbol.symbol-90px.symbol-fixed > img {
  width: 90px;
  height: 90px;
  max-width: none;
}

.symbol.symbol-90px.symbol-2by3 .symbol-label {
  height: 90px;
  width: 135px;
}

.symbol.symbol-90px.symbol-2by3 > img {
  height: 90px;
  width: 135px;
  max-width: none;
}

.symbol.symbol-100px > img {
  width: 100px;
  height: 100px;
}

.symbol.symbol-100px .symbol-label {
  width: 100px;
  height: 100px;
}

.symbol.symbol-100px.symbol-fixed .symbol-label {
  width: 100px;
  height: 100px;
}

.symbol.symbol-100px.symbol-fixed > img {
  width: 100px;
  height: 100px;
  max-width: none;
}

.symbol.symbol-100px.symbol-2by3 .symbol-label {
  height: 100px;
  width: 150px;
}

.symbol.symbol-100px.symbol-2by3 > img {
  height: 100px;
  width: 150px;
  max-width: none;
}

.symbol.symbol-125px > img {
  width: 125px;
  height: 125px;
}

.symbol.symbol-125px .symbol-label {
  width: 125px;
  height: 125px;
}

.symbol.symbol-125px.symbol-fixed .symbol-label {
  width: 125px;
  height: 125px;
}

.symbol.symbol-125px.symbol-fixed > img {
  width: 125px;
  height: 125px;
  max-width: none;
}

.symbol.symbol-125px.symbol-2by3 .symbol-label {
  height: 125px;
  width: 187.5px;
}

.symbol.symbol-125px.symbol-2by3 > img {
  height: 125px;
  width: 187.5px;
  max-width: none;
}

.symbol.symbol-150px > img {
  width: 150px;
  height: 150px;
}

.symbol.symbol-150px .symbol-label {
  width: 150px;
  height: 150px;
}

.symbol.symbol-150px.symbol-fixed .symbol-label {
  width: 150px;
  height: 150px;
}

.symbol.symbol-150px.symbol-fixed > img {
  width: 150px;
  height: 150px;
  max-width: none;
}

.symbol.symbol-150px.symbol-2by3 .symbol-label {
  height: 150px;
  width: 225px;
}

.symbol.symbol-150px.symbol-2by3 > img {
  height: 150px;
  width: 225px;
  max-width: none;
}

.symbol.symbol-160px > img {
  width: 160px;
  height: 160px;
}

.symbol.symbol-160px .symbol-label {
  width: 160px;
  height: 160px;
}

.symbol.symbol-160px.symbol-fixed .symbol-label {
  width: 160px;
  height: 160px;
}

.symbol.symbol-160px.symbol-fixed > img {
  width: 160px;
  height: 160px;
  max-width: none;
}

.symbol.symbol-160px.symbol-2by3 .symbol-label {
  height: 160px;
  width: 240px;
}

.symbol.symbol-160px.symbol-2by3 > img {
  height: 160px;
  width: 240px;
  max-width: none;
}

.symbol.symbol-175px > img {
  width: 175px;
  height: 175px;
}

.symbol.symbol-175px .symbol-label {
  width: 175px;
  height: 175px;
}

.symbol.symbol-175px.symbol-fixed .symbol-label {
  width: 175px;
  height: 175px;
}

.symbol.symbol-175px.symbol-fixed > img {
  width: 175px;
  height: 175px;
  max-width: none;
}

.symbol.symbol-175px.symbol-2by3 .symbol-label {
  height: 175px;
  width: 262.5px;
}

.symbol.symbol-175px.symbol-2by3 > img {
  height: 175px;
  width: 262.5px;
  max-width: none;
}

.symbol.symbol-200px > img {
  width: 200px;
  height: 200px;
}

.symbol.symbol-200px .symbol-label {
  width: 200px;
  height: 200px;
}

.symbol.symbol-200px.symbol-fixed .symbol-label {
  width: 200px;
  height: 200px;
}

.symbol.symbol-200px.symbol-fixed > img {
  width: 200px;
  height: 200px;
  max-width: none;
}

.symbol.symbol-200px.symbol-2by3 .symbol-label {
  height: 200px;
  width: 300px;
}

.symbol.symbol-200px.symbol-2by3 > img {
  height: 200px;
  width: 300px;
  max-width: none;
}

@media (min-width: 576px) {
  .symbol.symbol-sm-20px > img {
    width: 20px;
    height: 20px;
  }
  .symbol.symbol-sm-20px .symbol-label {
    width: 20px;
    height: 20px;
  }
  .symbol.symbol-sm-20px.symbol-fixed .symbol-label {
    width: 20px;
    height: 20px;
  }
  .symbol.symbol-sm-20px.symbol-fixed > img {
    width: 20px;
    height: 20px;
    max-width: none;
  }
  .symbol.symbol-sm-20px.symbol-2by3 .symbol-label {
    height: 20px;
    width: 30px;
  }
  .symbol.symbol-sm-20px.symbol-2by3 > img {
    height: 20px;
    width: 30px;
    max-width: none;
  }
  .symbol.symbol-sm-25px > img {
    width: 25px;
    height: 25px;
  }
  .symbol.symbol-sm-25px .symbol-label {
    width: 25px;
    height: 25px;
  }
  .symbol.symbol-sm-25px.symbol-fixed .symbol-label {
    width: 25px;
    height: 25px;
  }
  .symbol.symbol-sm-25px.symbol-fixed > img {
    width: 25px;
    height: 25px;
    max-width: none;
  }
  .symbol.symbol-sm-25px.symbol-2by3 .symbol-label {
    height: 25px;
    width: 37.5px;
  }
  .symbol.symbol-sm-25px.symbol-2by3 > img {
    height: 25px;
    width: 37.5px;
    max-width: none;
  }
  .symbol.symbol-sm-30px > img {
    width: 30px;
    height: 30px;
  }
  .symbol.symbol-sm-30px .symbol-label {
    width: 30px;
    height: 30px;
  }
  .symbol.symbol-sm-30px.symbol-fixed .symbol-label {
    width: 30px;
    height: 30px;
  }
  .symbol.symbol-sm-30px.symbol-fixed > img {
    width: 30px;
    height: 30px;
    max-width: none;
  }
  .symbol.symbol-sm-30px.symbol-2by3 .symbol-label {
    height: 30px;
    width: 45px;
  }
  .symbol.symbol-sm-30px.symbol-2by3 > img {
    height: 30px;
    width: 45px;
    max-width: none;
  }
  .symbol.symbol-sm-35px > img {
    width: 35px;
    height: 35px;
  }
  .symbol.symbol-sm-35px .symbol-label {
    width: 35px;
    height: 35px;
  }
  .symbol.symbol-sm-35px.symbol-fixed .symbol-label {
    width: 35px;
    height: 35px;
  }
  .symbol.symbol-sm-35px.symbol-fixed > img {
    width: 35px;
    height: 35px;
    max-width: none;
  }
  .symbol.symbol-sm-35px.symbol-2by3 .symbol-label {
    height: 35px;
    width: 52.5px;
  }
  .symbol.symbol-sm-35px.symbol-2by3 > img {
    height: 35px;
    width: 52.5px;
    max-width: none;
  }
  .symbol.symbol-sm-40px > img {
    width: 40px;
    height: 40px;
  }
  .symbol.symbol-sm-40px .symbol-label {
    width: 40px;
    height: 40px;
  }
  .symbol.symbol-sm-40px.symbol-fixed .symbol-label {
    width: 40px;
    height: 40px;
  }
  .symbol.symbol-sm-40px.symbol-fixed > img {
    width: 40px;
    height: 40px;
    max-width: none;
  }
  .symbol.symbol-sm-40px.symbol-2by3 .symbol-label {
    height: 40px;
    width: 60px;
  }
  .symbol.symbol-sm-40px.symbol-2by3 > img {
    height: 40px;
    width: 60px;
    max-width: none;
  }
  .symbol.symbol-sm-45px > img {
    width: 45px;
    height: 45px;
  }
  .symbol.symbol-sm-45px .symbol-label {
    width: 45px;
    height: 45px;
  }
  .symbol.symbol-sm-45px.symbol-fixed .symbol-label {
    width: 45px;
    height: 45px;
  }
  .symbol.symbol-sm-45px.symbol-fixed > img {
    width: 45px;
    height: 45px;
    max-width: none;
  }
  .symbol.symbol-sm-45px.symbol-2by3 .symbol-label {
    height: 45px;
    width: 67.5px;
  }
  .symbol.symbol-sm-45px.symbol-2by3 > img {
    height: 45px;
    width: 67.5px;
    max-width: none;
  }
  .symbol.symbol-sm-50px > img {
    width: 50px;
    height: 50px;
  }
  .symbol.symbol-sm-50px .symbol-label {
    width: 50px;
    height: 50px;
  }
  .symbol.symbol-sm-50px.symbol-fixed .symbol-label {
    width: 50px;
    height: 50px;
  }
  .symbol.symbol-sm-50px.symbol-fixed > img {
    width: 50px;
    height: 50px;
    max-width: none;
  }
  .symbol.symbol-sm-50px.symbol-2by3 .symbol-label {
    height: 50px;
    width: 75px;
  }
  .symbol.symbol-sm-50px.symbol-2by3 > img {
    height: 50px;
    width: 75px;
    max-width: none;
  }
  .symbol.symbol-sm-55px > img {
    width: 55px;
    height: 55px;
  }
  .symbol.symbol-sm-55px .symbol-label {
    width: 55px;
    height: 55px;
  }
  .symbol.symbol-sm-55px.symbol-fixed .symbol-label {
    width: 55px;
    height: 55px;
  }
  .symbol.symbol-sm-55px.symbol-fixed > img {
    width: 55px;
    height: 55px;
    max-width: none;
  }
  .symbol.symbol-sm-55px.symbol-2by3 .symbol-label {
    height: 55px;
    width: 82.5px;
  }
  .symbol.symbol-sm-55px.symbol-2by3 > img {
    height: 55px;
    width: 82.5px;
    max-width: none;
  }
  .symbol.symbol-sm-60px > img {
    width: 60px;
    height: 60px;
  }
  .symbol.symbol-sm-60px .symbol-label {
    width: 60px;
    height: 60px;
  }
  .symbol.symbol-sm-60px.symbol-fixed .symbol-label {
    width: 60px;
    height: 60px;
  }
  .symbol.symbol-sm-60px.symbol-fixed > img {
    width: 60px;
    height: 60px;
    max-width: none;
  }
  .symbol.symbol-sm-60px.symbol-2by3 .symbol-label {
    height: 60px;
    width: 90px;
  }
  .symbol.symbol-sm-60px.symbol-2by3 > img {
    height: 60px;
    width: 90px;
    max-width: none;
  }
  .symbol.symbol-sm-65px > img {
    width: 65px;
    height: 65px;
  }
  .symbol.symbol-sm-65px .symbol-label {
    width: 65px;
    height: 65px;
  }
  .symbol.symbol-sm-65px.symbol-fixed .symbol-label {
    width: 65px;
    height: 65px;
  }
  .symbol.symbol-sm-65px.symbol-fixed > img {
    width: 65px;
    height: 65px;
    max-width: none;
  }
  .symbol.symbol-sm-65px.symbol-2by3 .symbol-label {
    height: 65px;
    width: 97.5px;
  }
  .symbol.symbol-sm-65px.symbol-2by3 > img {
    height: 65px;
    width: 97.5px;
    max-width: none;
  }
  .symbol.symbol-sm-70px > img {
    width: 70px;
    height: 70px;
  }
  .symbol.symbol-sm-70px .symbol-label {
    width: 70px;
    height: 70px;
  }
  .symbol.symbol-sm-70px.symbol-fixed .symbol-label {
    width: 70px;
    height: 70px;
  }
  .symbol.symbol-sm-70px.symbol-fixed > img {
    width: 70px;
    height: 70px;
    max-width: none;
  }
  .symbol.symbol-sm-70px.symbol-2by3 .symbol-label {
    height: 70px;
    width: 105px;
  }
  .symbol.symbol-sm-70px.symbol-2by3 > img {
    height: 70px;
    width: 105px;
    max-width: none;
  }
  .symbol.symbol-sm-75px > img {
    width: 75px;
    height: 75px;
  }
  .symbol.symbol-sm-75px .symbol-label {
    width: 75px;
    height: 75px;
  }
  .symbol.symbol-sm-75px.symbol-fixed .symbol-label {
    width: 75px;
    height: 75px;
  }
  .symbol.symbol-sm-75px.symbol-fixed > img {
    width: 75px;
    height: 75px;
    max-width: none;
  }
  .symbol.symbol-sm-75px.symbol-2by3 .symbol-label {
    height: 75px;
    width: 112.5px;
  }
  .symbol.symbol-sm-75px.symbol-2by3 > img {
    height: 75px;
    width: 112.5px;
    max-width: none;
  }
  .symbol.symbol-sm-90px > img {
    width: 90px;
    height: 90px;
  }
  .symbol.symbol-sm-90px .symbol-label {
    width: 90px;
    height: 90px;
  }
  .symbol.symbol-sm-90px.symbol-fixed .symbol-label {
    width: 90px;
    height: 90px;
  }
  .symbol.symbol-sm-90px.symbol-fixed > img {
    width: 90px;
    height: 90px;
    max-width: none;
  }
  .symbol.symbol-sm-90px.symbol-2by3 .symbol-label {
    height: 90px;
    width: 135px;
  }
  .symbol.symbol-sm-90px.symbol-2by3 > img {
    height: 90px;
    width: 135px;
    max-width: none;
  }
  .symbol.symbol-sm-100px > img {
    width: 100px;
    height: 100px;
  }
  .symbol.symbol-sm-100px .symbol-label {
    width: 100px;
    height: 100px;
  }
  .symbol.symbol-sm-100px.symbol-fixed .symbol-label {
    width: 100px;
    height: 100px;
  }
  .symbol.symbol-sm-100px.symbol-fixed > img {
    width: 100px;
    height: 100px;
    max-width: none;
  }
  .symbol.symbol-sm-100px.symbol-2by3 .symbol-label {
    height: 100px;
    width: 150px;
  }
  .symbol.symbol-sm-100px.symbol-2by3 > img {
    height: 100px;
    width: 150px;
    max-width: none;
  }
  .symbol.symbol-sm-125px > img {
    width: 125px;
    height: 125px;
  }
  .symbol.symbol-sm-125px .symbol-label {
    width: 125px;
    height: 125px;
  }
  .symbol.symbol-sm-125px.symbol-fixed .symbol-label {
    width: 125px;
    height: 125px;
  }
  .symbol.symbol-sm-125px.symbol-fixed > img {
    width: 125px;
    height: 125px;
    max-width: none;
  }
  .symbol.symbol-sm-125px.symbol-2by3 .symbol-label {
    height: 125px;
    width: 187.5px;
  }
  .symbol.symbol-sm-125px.symbol-2by3 > img {
    height: 125px;
    width: 187.5px;
    max-width: none;
  }
  .symbol.symbol-sm-150px > img {
    width: 150px;
    height: 150px;
  }
  .symbol.symbol-sm-150px .symbol-label {
    width: 150px;
    height: 150px;
  }
  .symbol.symbol-sm-150px.symbol-fixed .symbol-label {
    width: 150px;
    height: 150px;
  }
  .symbol.symbol-sm-150px.symbol-fixed > img {
    width: 150px;
    height: 150px;
    max-width: none;
  }
  .symbol.symbol-sm-150px.symbol-2by3 .symbol-label {
    height: 150px;
    width: 225px;
  }
  .symbol.symbol-sm-150px.symbol-2by3 > img {
    height: 150px;
    width: 225px;
    max-width: none;
  }
  .symbol.symbol-sm-160px > img {
    width: 160px;
    height: 160px;
  }
  .symbol.symbol-sm-160px .symbol-label {
    width: 160px;
    height: 160px;
  }
  .symbol.symbol-sm-160px.symbol-fixed .symbol-label {
    width: 160px;
    height: 160px;
  }
  .symbol.symbol-sm-160px.symbol-fixed > img {
    width: 160px;
    height: 160px;
    max-width: none;
  }
  .symbol.symbol-sm-160px.symbol-2by3 .symbol-label {
    height: 160px;
    width: 240px;
  }
  .symbol.symbol-sm-160px.symbol-2by3 > img {
    height: 160px;
    width: 240px;
    max-width: none;
  }
  .symbol.symbol-sm-175px > img {
    width: 175px;
    height: 175px;
  }
  .symbol.symbol-sm-175px .symbol-label {
    width: 175px;
    height: 175px;
  }
  .symbol.symbol-sm-175px.symbol-fixed .symbol-label {
    width: 175px;
    height: 175px;
  }
  .symbol.symbol-sm-175px.symbol-fixed > img {
    width: 175px;
    height: 175px;
    max-width: none;
  }
  .symbol.symbol-sm-175px.symbol-2by3 .symbol-label {
    height: 175px;
    width: 262.5px;
  }
  .symbol.symbol-sm-175px.symbol-2by3 > img {
    height: 175px;
    width: 262.5px;
    max-width: none;
  }
  .symbol.symbol-sm-200px > img {
    width: 200px;
    height: 200px;
  }
  .symbol.symbol-sm-200px .symbol-label {
    width: 200px;
    height: 200px;
  }
  .symbol.symbol-sm-200px.symbol-fixed .symbol-label {
    width: 200px;
    height: 200px;
  }
  .symbol.symbol-sm-200px.symbol-fixed > img {
    width: 200px;
    height: 200px;
    max-width: none;
  }
  .symbol.symbol-sm-200px.symbol-2by3 .symbol-label {
    height: 200px;
    width: 300px;
  }
  .symbol.symbol-sm-200px.symbol-2by3 > img {
    height: 200px;
    width: 300px;
    max-width: none;
  }
}
@media (min-width: 768px) {
  .symbol.symbol-md-20px > img {
    width: 20px;
    height: 20px;
  }
  .symbol.symbol-md-20px .symbol-label {
    width: 20px;
    height: 20px;
  }
  .symbol.symbol-md-20px.symbol-fixed .symbol-label {
    width: 20px;
    height: 20px;
  }
  .symbol.symbol-md-20px.symbol-fixed > img {
    width: 20px;
    height: 20px;
    max-width: none;
  }
  .symbol.symbol-md-20px.symbol-2by3 .symbol-label {
    height: 20px;
    width: 30px;
  }
  .symbol.symbol-md-20px.symbol-2by3 > img {
    height: 20px;
    width: 30px;
    max-width: none;
  }
  .symbol.symbol-md-25px > img {
    width: 25px;
    height: 25px;
  }
  .symbol.symbol-md-25px .symbol-label {
    width: 25px;
    height: 25px;
  }
  .symbol.symbol-md-25px.symbol-fixed .symbol-label {
    width: 25px;
    height: 25px;
  }
  .symbol.symbol-md-25px.symbol-fixed > img {
    width: 25px;
    height: 25px;
    max-width: none;
  }
  .symbol.symbol-md-25px.symbol-2by3 .symbol-label {
    height: 25px;
    width: 37.5px;
  }
  .symbol.symbol-md-25px.symbol-2by3 > img {
    height: 25px;
    width: 37.5px;
    max-width: none;
  }
  .symbol.symbol-md-30px > img {
    width: 30px;
    height: 30px;
  }
  .symbol.symbol-md-30px .symbol-label {
    width: 30px;
    height: 30px;
  }
  .symbol.symbol-md-30px.symbol-fixed .symbol-label {
    width: 30px;
    height: 30px;
  }
  .symbol.symbol-md-30px.symbol-fixed > img {
    width: 30px;
    height: 30px;
    max-width: none;
  }
  .symbol.symbol-md-30px.symbol-2by3 .symbol-label {
    height: 30px;
    width: 45px;
  }
  .symbol.symbol-md-30px.symbol-2by3 > img {
    height: 30px;
    width: 45px;
    max-width: none;
  }
  .symbol.symbol-md-35px > img {
    width: 35px;
    height: 35px;
  }
  .symbol.symbol-md-35px .symbol-label {
    width: 35px;
    height: 35px;
  }
  .symbol.symbol-md-35px.symbol-fixed .symbol-label {
    width: 35px;
    height: 35px;
  }
  .symbol.symbol-md-35px.symbol-fixed > img {
    width: 35px;
    height: 35px;
    max-width: none;
  }
  .symbol.symbol-md-35px.symbol-2by3 .symbol-label {
    height: 35px;
    width: 52.5px;
  }
  .symbol.symbol-md-35px.symbol-2by3 > img {
    height: 35px;
    width: 52.5px;
    max-width: none;
  }
  .symbol.symbol-md-40px > img {
    width: 40px;
    height: 40px;
  }
  .symbol.symbol-md-40px .symbol-label {
    width: 40px;
    height: 40px;
  }
  .symbol.symbol-md-40px.symbol-fixed .symbol-label {
    width: 40px;
    height: 40px;
  }
  .symbol.symbol-md-40px.symbol-fixed > img {
    width: 40px;
    height: 40px;
    max-width: none;
  }
  .symbol.symbol-md-40px.symbol-2by3 .symbol-label {
    height: 40px;
    width: 60px;
  }
  .symbol.symbol-md-40px.symbol-2by3 > img {
    height: 40px;
    width: 60px;
    max-width: none;
  }
  .symbol.symbol-md-45px > img {
    width: 45px;
    height: 45px;
  }
  .symbol.symbol-md-45px .symbol-label {
    width: 45px;
    height: 45px;
  }
  .symbol.symbol-md-45px.symbol-fixed .symbol-label {
    width: 45px;
    height: 45px;
  }
  .symbol.symbol-md-45px.symbol-fixed > img {
    width: 45px;
    height: 45px;
    max-width: none;
  }
  .symbol.symbol-md-45px.symbol-2by3 .symbol-label {
    height: 45px;
    width: 67.5px;
  }
  .symbol.symbol-md-45px.symbol-2by3 > img {
    height: 45px;
    width: 67.5px;
    max-width: none;
  }
  .symbol.symbol-md-50px > img {
    width: 50px;
    height: 50px;
  }
  .symbol.symbol-md-50px .symbol-label {
    width: 50px;
    height: 50px;
  }
  .symbol.symbol-md-50px.symbol-fixed .symbol-label {
    width: 50px;
    height: 50px;
  }
  .symbol.symbol-md-50px.symbol-fixed > img {
    width: 50px;
    height: 50px;
    max-width: none;
  }
  .symbol.symbol-md-50px.symbol-2by3 .symbol-label {
    height: 50px;
    width: 75px;
  }
  .symbol.symbol-md-50px.symbol-2by3 > img {
    height: 50px;
    width: 75px;
    max-width: none;
  }
  .symbol.symbol-md-55px > img {
    width: 55px;
    height: 55px;
  }
  .symbol.symbol-md-55px .symbol-label {
    width: 55px;
    height: 55px;
  }
  .symbol.symbol-md-55px.symbol-fixed .symbol-label {
    width: 55px;
    height: 55px;
  }
  .symbol.symbol-md-55px.symbol-fixed > img {
    width: 55px;
    height: 55px;
    max-width: none;
  }
  .symbol.symbol-md-55px.symbol-2by3 .symbol-label {
    height: 55px;
    width: 82.5px;
  }
  .symbol.symbol-md-55px.symbol-2by3 > img {
    height: 55px;
    width: 82.5px;
    max-width: none;
  }
  .symbol.symbol-md-60px > img {
    width: 60px;
    height: 60px;
  }
  .symbol.symbol-md-60px .symbol-label {
    width: 60px;
    height: 60px;
  }
  .symbol.symbol-md-60px.symbol-fixed .symbol-label {
    width: 60px;
    height: 60px;
  }
  .symbol.symbol-md-60px.symbol-fixed > img {
    width: 60px;
    height: 60px;
    max-width: none;
  }
  .symbol.symbol-md-60px.symbol-2by3 .symbol-label {
    height: 60px;
    width: 90px;
  }
  .symbol.symbol-md-60px.symbol-2by3 > img {
    height: 60px;
    width: 90px;
    max-width: none;
  }
  .symbol.symbol-md-65px > img {
    width: 65px;
    height: 65px;
  }
  .symbol.symbol-md-65px .symbol-label {
    width: 65px;
    height: 65px;
  }
  .symbol.symbol-md-65px.symbol-fixed .symbol-label {
    width: 65px;
    height: 65px;
  }
  .symbol.symbol-md-65px.symbol-fixed > img {
    width: 65px;
    height: 65px;
    max-width: none;
  }
  .symbol.symbol-md-65px.symbol-2by3 .symbol-label {
    height: 65px;
    width: 97.5px;
  }
  .symbol.symbol-md-65px.symbol-2by3 > img {
    height: 65px;
    width: 97.5px;
    max-width: none;
  }
  .symbol.symbol-md-70px > img {
    width: 70px;
    height: 70px;
  }
  .symbol.symbol-md-70px .symbol-label {
    width: 70px;
    height: 70px;
  }
  .symbol.symbol-md-70px.symbol-fixed .symbol-label {
    width: 70px;
    height: 70px;
  }
  .symbol.symbol-md-70px.symbol-fixed > img {
    width: 70px;
    height: 70px;
    max-width: none;
  }
  .symbol.symbol-md-70px.symbol-2by3 .symbol-label {
    height: 70px;
    width: 105px;
  }
  .symbol.symbol-md-70px.symbol-2by3 > img {
    height: 70px;
    width: 105px;
    max-width: none;
  }
  .symbol.symbol-md-75px > img {
    width: 75px;
    height: 75px;
  }
  .symbol.symbol-md-75px .symbol-label {
    width: 75px;
    height: 75px;
  }
  .symbol.symbol-md-75px.symbol-fixed .symbol-label {
    width: 75px;
    height: 75px;
  }
  .symbol.symbol-md-75px.symbol-fixed > img {
    width: 75px;
    height: 75px;
    max-width: none;
  }
  .symbol.symbol-md-75px.symbol-2by3 .symbol-label {
    height: 75px;
    width: 112.5px;
  }
  .symbol.symbol-md-75px.symbol-2by3 > img {
    height: 75px;
    width: 112.5px;
    max-width: none;
  }
  .symbol.symbol-md-90px > img {
    width: 90px;
    height: 90px;
  }
  .symbol.symbol-md-90px .symbol-label {
    width: 90px;
    height: 90px;
  }
  .symbol.symbol-md-90px.symbol-fixed .symbol-label {
    width: 90px;
    height: 90px;
  }
  .symbol.symbol-md-90px.symbol-fixed > img {
    width: 90px;
    height: 90px;
    max-width: none;
  }
  .symbol.symbol-md-90px.symbol-2by3 .symbol-label {
    height: 90px;
    width: 135px;
  }
  .symbol.symbol-md-90px.symbol-2by3 > img {
    height: 90px;
    width: 135px;
    max-width: none;
  }
  .symbol.symbol-md-100px > img {
    width: 100px;
    height: 100px;
  }
  .symbol.symbol-md-100px .symbol-label {
    width: 100px;
    height: 100px;
  }
  .symbol.symbol-md-100px.symbol-fixed .symbol-label {
    width: 100px;
    height: 100px;
  }
  .symbol.symbol-md-100px.symbol-fixed > img {
    width: 100px;
    height: 100px;
    max-width: none;
  }
  .symbol.symbol-md-100px.symbol-2by3 .symbol-label {
    height: 100px;
    width: 150px;
  }
  .symbol.symbol-md-100px.symbol-2by3 > img {
    height: 100px;
    width: 150px;
    max-width: none;
  }
  .symbol.symbol-md-125px > img {
    width: 125px;
    height: 125px;
  }
  .symbol.symbol-md-125px .symbol-label {
    width: 125px;
    height: 125px;
  }
  .symbol.symbol-md-125px.symbol-fixed .symbol-label {
    width: 125px;
    height: 125px;
  }
  .symbol.symbol-md-125px.symbol-fixed > img {
    width: 125px;
    height: 125px;
    max-width: none;
  }
  .symbol.symbol-md-125px.symbol-2by3 .symbol-label {
    height: 125px;
    width: 187.5px;
  }
  .symbol.symbol-md-125px.symbol-2by3 > img {
    height: 125px;
    width: 187.5px;
    max-width: none;
  }
  .symbol.symbol-md-150px > img {
    width: 150px;
    height: 150px;
  }
  .symbol.symbol-md-150px .symbol-label {
    width: 150px;
    height: 150px;
  }
  .symbol.symbol-md-150px.symbol-fixed .symbol-label {
    width: 150px;
    height: 150px;
  }
  .symbol.symbol-md-150px.symbol-fixed > img {
    width: 150px;
    height: 150px;
    max-width: none;
  }
  .symbol.symbol-md-150px.symbol-2by3 .symbol-label {
    height: 150px;
    width: 225px;
  }
  .symbol.symbol-md-150px.symbol-2by3 > img {
    height: 150px;
    width: 225px;
    max-width: none;
  }
  .symbol.symbol-md-160px > img {
    width: 160px;
    height: 160px;
  }
  .symbol.symbol-md-160px .symbol-label {
    width: 160px;
    height: 160px;
  }
  .symbol.symbol-md-160px.symbol-fixed .symbol-label {
    width: 160px;
    height: 160px;
  }
  .symbol.symbol-md-160px.symbol-fixed > img {
    width: 160px;
    height: 160px;
    max-width: none;
  }
  .symbol.symbol-md-160px.symbol-2by3 .symbol-label {
    height: 160px;
    width: 240px;
  }
  .symbol.symbol-md-160px.symbol-2by3 > img {
    height: 160px;
    width: 240px;
    max-width: none;
  }
  .symbol.symbol-md-175px > img {
    width: 175px;
    height: 175px;
  }
  .symbol.symbol-md-175px .symbol-label {
    width: 175px;
    height: 175px;
  }
  .symbol.symbol-md-175px.symbol-fixed .symbol-label {
    width: 175px;
    height: 175px;
  }
  .symbol.symbol-md-175px.symbol-fixed > img {
    width: 175px;
    height: 175px;
    max-width: none;
  }
  .symbol.symbol-md-175px.symbol-2by3 .symbol-label {
    height: 175px;
    width: 262.5px;
  }
  .symbol.symbol-md-175px.symbol-2by3 > img {
    height: 175px;
    width: 262.5px;
    max-width: none;
  }
  .symbol.symbol-md-200px > img {
    width: 200px;
    height: 200px;
  }
  .symbol.symbol-md-200px .symbol-label {
    width: 200px;
    height: 200px;
  }
  .symbol.symbol-md-200px.symbol-fixed .symbol-label {
    width: 200px;
    height: 200px;
  }
  .symbol.symbol-md-200px.symbol-fixed > img {
    width: 200px;
    height: 200px;
    max-width: none;
  }
  .symbol.symbol-md-200px.symbol-2by3 .symbol-label {
    height: 200px;
    width: 300px;
  }
  .symbol.symbol-md-200px.symbol-2by3 > img {
    height: 200px;
    width: 300px;
    max-width: none;
  }
}
@media (min-width: 992px) {
  .symbol.symbol-lg-20px > img {
    width: 20px;
    height: 20px;
  }
  .symbol.symbol-lg-20px .symbol-label {
    width: 20px;
    height: 20px;
  }
  .symbol.symbol-lg-20px.symbol-fixed .symbol-label {
    width: 20px;
    height: 20px;
  }
  .symbol.symbol-lg-20px.symbol-fixed > img {
    width: 20px;
    height: 20px;
    max-width: none;
  }
  .symbol.symbol-lg-20px.symbol-2by3 .symbol-label {
    height: 20px;
    width: 30px;
  }
  .symbol.symbol-lg-20px.symbol-2by3 > img {
    height: 20px;
    width: 30px;
    max-width: none;
  }
  .symbol.symbol-lg-25px > img {
    width: 25px;
    height: 25px;
  }
  .symbol.symbol-lg-25px .symbol-label {
    width: 25px;
    height: 25px;
  }
  .symbol.symbol-lg-25px.symbol-fixed .symbol-label {
    width: 25px;
    height: 25px;
  }
  .symbol.symbol-lg-25px.symbol-fixed > img {
    width: 25px;
    height: 25px;
    max-width: none;
  }
  .symbol.symbol-lg-25px.symbol-2by3 .symbol-label {
    height: 25px;
    width: 37.5px;
  }
  .symbol.symbol-lg-25px.symbol-2by3 > img {
    height: 25px;
    width: 37.5px;
    max-width: none;
  }
  .symbol.symbol-lg-30px > img {
    width: 30px;
    height: 30px;
  }
  .symbol.symbol-lg-30px .symbol-label {
    width: 30px;
    height: 30px;
  }
  .symbol.symbol-lg-30px.symbol-fixed .symbol-label {
    width: 30px;
    height: 30px;
  }
  .symbol.symbol-lg-30px.symbol-fixed > img {
    width: 30px;
    height: 30px;
    max-width: none;
  }
  .symbol.symbol-lg-30px.symbol-2by3 .symbol-label {
    height: 30px;
    width: 45px;
  }
  .symbol.symbol-lg-30px.symbol-2by3 > img {
    height: 30px;
    width: 45px;
    max-width: none;
  }
  .symbol.symbol-lg-35px > img {
    width: 35px;
    height: 35px;
  }
  .symbol.symbol-lg-35px .symbol-label {
    width: 35px;
    height: 35px;
  }
  .symbol.symbol-lg-35px.symbol-fixed .symbol-label {
    width: 35px;
    height: 35px;
  }
  .symbol.symbol-lg-35px.symbol-fixed > img {
    width: 35px;
    height: 35px;
    max-width: none;
  }
  .symbol.symbol-lg-35px.symbol-2by3 .symbol-label {
    height: 35px;
    width: 52.5px;
  }
  .symbol.symbol-lg-35px.symbol-2by3 > img {
    height: 35px;
    width: 52.5px;
    max-width: none;
  }
  .symbol.symbol-lg-40px > img {
    width: 40px;
    height: 40px;
  }
  .symbol.symbol-lg-40px .symbol-label {
    width: 40px;
    height: 40px;
  }
  .symbol.symbol-lg-40px.symbol-fixed .symbol-label {
    width: 40px;
    height: 40px;
  }
  .symbol.symbol-lg-40px.symbol-fixed > img {
    width: 40px;
    height: 40px;
    max-width: none;
  }
  .symbol.symbol-lg-40px.symbol-2by3 .symbol-label {
    height: 40px;
    width: 60px;
  }
  .symbol.symbol-lg-40px.symbol-2by3 > img {
    height: 40px;
    width: 60px;
    max-width: none;
  }
  .symbol.symbol-lg-45px > img {
    width: 45px;
    height: 45px;
  }
  .symbol.symbol-lg-45px .symbol-label {
    width: 45px;
    height: 45px;
  }
  .symbol.symbol-lg-45px.symbol-fixed .symbol-label {
    width: 45px;
    height: 45px;
  }
  .symbol.symbol-lg-45px.symbol-fixed > img {
    width: 45px;
    height: 45px;
    max-width: none;
  }
  .symbol.symbol-lg-45px.symbol-2by3 .symbol-label {
    height: 45px;
    width: 67.5px;
  }
  .symbol.symbol-lg-45px.symbol-2by3 > img {
    height: 45px;
    width: 67.5px;
    max-width: none;
  }
  .symbol.symbol-lg-50px > img {
    width: 50px;
    height: 50px;
  }
  .symbol.symbol-lg-50px .symbol-label {
    width: 50px;
    height: 50px;
  }
  .symbol.symbol-lg-50px.symbol-fixed .symbol-label {
    width: 50px;
    height: 50px;
  }
  .symbol.symbol-lg-50px.symbol-fixed > img {
    width: 50px;
    height: 50px;
    max-width: none;
  }
  .symbol.symbol-lg-50px.symbol-2by3 .symbol-label {
    height: 50px;
    width: 75px;
  }
  .symbol.symbol-lg-50px.symbol-2by3 > img {
    height: 50px;
    width: 75px;
    max-width: none;
  }
  .symbol.symbol-lg-55px > img {
    width: 55px;
    height: 55px;
  }
  .symbol.symbol-lg-55px .symbol-label {
    width: 55px;
    height: 55px;
  }
  .symbol.symbol-lg-55px.symbol-fixed .symbol-label {
    width: 55px;
    height: 55px;
  }
  .symbol.symbol-lg-55px.symbol-fixed > img {
    width: 55px;
    height: 55px;
    max-width: none;
  }
  .symbol.symbol-lg-55px.symbol-2by3 .symbol-label {
    height: 55px;
    width: 82.5px;
  }
  .symbol.symbol-lg-55px.symbol-2by3 > img {
    height: 55px;
    width: 82.5px;
    max-width: none;
  }
  .symbol.symbol-lg-60px > img {
    width: 60px;
    height: 60px;
  }
  .symbol.symbol-lg-60px .symbol-label {
    width: 60px;
    height: 60px;
  }
  .symbol.symbol-lg-60px.symbol-fixed .symbol-label {
    width: 60px;
    height: 60px;
  }
  .symbol.symbol-lg-60px.symbol-fixed > img {
    width: 60px;
    height: 60px;
    max-width: none;
  }
  .symbol.symbol-lg-60px.symbol-2by3 .symbol-label {
    height: 60px;
    width: 90px;
  }
  .symbol.symbol-lg-60px.symbol-2by3 > img {
    height: 60px;
    width: 90px;
    max-width: none;
  }
  .symbol.symbol-lg-65px > img {
    width: 65px;
    height: 65px;
  }
  .symbol.symbol-lg-65px .symbol-label {
    width: 65px;
    height: 65px;
  }
  .symbol.symbol-lg-65px.symbol-fixed .symbol-label {
    width: 65px;
    height: 65px;
  }
  .symbol.symbol-lg-65px.symbol-fixed > img {
    width: 65px;
    height: 65px;
    max-width: none;
  }
  .symbol.symbol-lg-65px.symbol-2by3 .symbol-label {
    height: 65px;
    width: 97.5px;
  }
  .symbol.symbol-lg-65px.symbol-2by3 > img {
    height: 65px;
    width: 97.5px;
    max-width: none;
  }
  .symbol.symbol-lg-70px > img {
    width: 70px;
    height: 70px;
  }
  .symbol.symbol-lg-70px .symbol-label {
    width: 70px;
    height: 70px;
  }
  .symbol.symbol-lg-70px.symbol-fixed .symbol-label {
    width: 70px;
    height: 70px;
  }
  .symbol.symbol-lg-70px.symbol-fixed > img {
    width: 70px;
    height: 70px;
    max-width: none;
  }
  .symbol.symbol-lg-70px.symbol-2by3 .symbol-label {
    height: 70px;
    width: 105px;
  }
  .symbol.symbol-lg-70px.symbol-2by3 > img {
    height: 70px;
    width: 105px;
    max-width: none;
  }
  .symbol.symbol-lg-75px > img {
    width: 75px;
    height: 75px;
  }
  .symbol.symbol-lg-75px .symbol-label {
    width: 75px;
    height: 75px;
  }
  .symbol.symbol-lg-75px.symbol-fixed .symbol-label {
    width: 75px;
    height: 75px;
  }
  .symbol.symbol-lg-75px.symbol-fixed > img {
    width: 75px;
    height: 75px;
    max-width: none;
  }
  .symbol.symbol-lg-75px.symbol-2by3 .symbol-label {
    height: 75px;
    width: 112.5px;
  }
  .symbol.symbol-lg-75px.symbol-2by3 > img {
    height: 75px;
    width: 112.5px;
    max-width: none;
  }
  .symbol.symbol-lg-90px > img {
    width: 90px;
    height: 90px;
  }
  .symbol.symbol-lg-90px .symbol-label {
    width: 90px;
    height: 90px;
  }
  .symbol.symbol-lg-90px.symbol-fixed .symbol-label {
    width: 90px;
    height: 90px;
  }
  .symbol.symbol-lg-90px.symbol-fixed > img {
    width: 90px;
    height: 90px;
    max-width: none;
  }
  .symbol.symbol-lg-90px.symbol-2by3 .symbol-label {
    height: 90px;
    width: 135px;
  }
  .symbol.symbol-lg-90px.symbol-2by3 > img {
    height: 90px;
    width: 135px;
    max-width: none;
  }
  .symbol.symbol-lg-100px > img {
    width: 100px;
    height: 100px;
  }
  .symbol.symbol-lg-100px .symbol-label {
    width: 100px;
    height: 100px;
  }
  .symbol.symbol-lg-100px.symbol-fixed .symbol-label {
    width: 100px;
    height: 100px;
  }
  .symbol.symbol-lg-100px.symbol-fixed > img {
    width: 100px;
    height: 100px;
    max-width: none;
  }
  .symbol.symbol-lg-100px.symbol-2by3 .symbol-label {
    height: 100px;
    width: 150px;
  }
  .symbol.symbol-lg-100px.symbol-2by3 > img {
    height: 100px;
    width: 150px;
    max-width: none;
  }
  .symbol.symbol-lg-125px > img {
    width: 125px;
    height: 125px;
  }
  .symbol.symbol-lg-125px .symbol-label {
    width: 125px;
    height: 125px;
  }
  .symbol.symbol-lg-125px.symbol-fixed .symbol-label {
    width: 125px;
    height: 125px;
  }
  .symbol.symbol-lg-125px.symbol-fixed > img {
    width: 125px;
    height: 125px;
    max-width: none;
  }
  .symbol.symbol-lg-125px.symbol-2by3 .symbol-label {
    height: 125px;
    width: 187.5px;
  }
  .symbol.symbol-lg-125px.symbol-2by3 > img {
    height: 125px;
    width: 187.5px;
    max-width: none;
  }
  .symbol.symbol-lg-150px > img {
    width: 150px;
    height: 150px;
  }
  .symbol.symbol-lg-150px .symbol-label {
    width: 150px;
    height: 150px;
  }
  .symbol.symbol-lg-150px.symbol-fixed .symbol-label {
    width: 150px;
    height: 150px;
  }
  .symbol.symbol-lg-150px.symbol-fixed > img {
    width: 150px;
    height: 150px;
    max-width: none;
  }
  .symbol.symbol-lg-150px.symbol-2by3 .symbol-label {
    height: 150px;
    width: 225px;
  }
  .symbol.symbol-lg-150px.symbol-2by3 > img {
    height: 150px;
    width: 225px;
    max-width: none;
  }
  .symbol.symbol-lg-160px > img {
    width: 160px;
    height: 160px;
  }
  .symbol.symbol-lg-160px .symbol-label {
    width: 160px;
    height: 160px;
  }
  .symbol.symbol-lg-160px.symbol-fixed .symbol-label {
    width: 160px;
    height: 160px;
  }
  .symbol.symbol-lg-160px.symbol-fixed > img {
    width: 160px;
    height: 160px;
    max-width: none;
  }
  .symbol.symbol-lg-160px.symbol-2by3 .symbol-label {
    height: 160px;
    width: 240px;
  }
  .symbol.symbol-lg-160px.symbol-2by3 > img {
    height: 160px;
    width: 240px;
    max-width: none;
  }
  .symbol.symbol-lg-175px > img {
    width: 175px;
    height: 175px;
  }
  .symbol.symbol-lg-175px .symbol-label {
    width: 175px;
    height: 175px;
  }
  .symbol.symbol-lg-175px.symbol-fixed .symbol-label {
    width: 175px;
    height: 175px;
  }
  .symbol.symbol-lg-175px.symbol-fixed > img {
    width: 175px;
    height: 175px;
    max-width: none;
  }
  .symbol.symbol-lg-175px.symbol-2by3 .symbol-label {
    height: 175px;
    width: 262.5px;
  }
  .symbol.symbol-lg-175px.symbol-2by3 > img {
    height: 175px;
    width: 262.5px;
    max-width: none;
  }
  .symbol.symbol-lg-200px > img {
    width: 200px;
    height: 200px;
  }
  .symbol.symbol-lg-200px .symbol-label {
    width: 200px;
    height: 200px;
  }
  .symbol.symbol-lg-200px.symbol-fixed .symbol-label {
    width: 200px;
    height: 200px;
  }
  .symbol.symbol-lg-200px.symbol-fixed > img {
    width: 200px;
    height: 200px;
    max-width: none;
  }
  .symbol.symbol-lg-200px.symbol-2by3 .symbol-label {
    height: 200px;
    width: 300px;
  }
  .symbol.symbol-lg-200px.symbol-2by3 > img {
    height: 200px;
    width: 300px;
    max-width: none;
  }
}
@media (min-width: 1200px) {
  .symbol.symbol-xl-20px > img {
    width: 20px;
    height: 20px;
  }
  .symbol.symbol-xl-20px .symbol-label {
    width: 20px;
    height: 20px;
  }
  .symbol.symbol-xl-20px.symbol-fixed .symbol-label {
    width: 20px;
    height: 20px;
  }
  .symbol.symbol-xl-20px.symbol-fixed > img {
    width: 20px;
    height: 20px;
    max-width: none;
  }
  .symbol.symbol-xl-20px.symbol-2by3 .symbol-label {
    height: 20px;
    width: 30px;
  }
  .symbol.symbol-xl-20px.symbol-2by3 > img {
    height: 20px;
    width: 30px;
    max-width: none;
  }
  .symbol.symbol-xl-25px > img {
    width: 25px;
    height: 25px;
  }
  .symbol.symbol-xl-25px .symbol-label {
    width: 25px;
    height: 25px;
  }
  .symbol.symbol-xl-25px.symbol-fixed .symbol-label {
    width: 25px;
    height: 25px;
  }
  .symbol.symbol-xl-25px.symbol-fixed > img {
    width: 25px;
    height: 25px;
    max-width: none;
  }
  .symbol.symbol-xl-25px.symbol-2by3 .symbol-label {
    height: 25px;
    width: 37.5px;
  }
  .symbol.symbol-xl-25px.symbol-2by3 > img {
    height: 25px;
    width: 37.5px;
    max-width: none;
  }
  .symbol.symbol-xl-30px > img {
    width: 30px;
    height: 30px;
  }
  .symbol.symbol-xl-30px .symbol-label {
    width: 30px;
    height: 30px;
  }
  .symbol.symbol-xl-30px.symbol-fixed .symbol-label {
    width: 30px;
    height: 30px;
  }
  .symbol.symbol-xl-30px.symbol-fixed > img {
    width: 30px;
    height: 30px;
    max-width: none;
  }
  .symbol.symbol-xl-30px.symbol-2by3 .symbol-label {
    height: 30px;
    width: 45px;
  }
  .symbol.symbol-xl-30px.symbol-2by3 > img {
    height: 30px;
    width: 45px;
    max-width: none;
  }
  .symbol.symbol-xl-35px > img {
    width: 35px;
    height: 35px;
  }
  .symbol.symbol-xl-35px .symbol-label {
    width: 35px;
    height: 35px;
  }
  .symbol.symbol-xl-35px.symbol-fixed .symbol-label {
    width: 35px;
    height: 35px;
  }
  .symbol.symbol-xl-35px.symbol-fixed > img {
    width: 35px;
    height: 35px;
    max-width: none;
  }
  .symbol.symbol-xl-35px.symbol-2by3 .symbol-label {
    height: 35px;
    width: 52.5px;
  }
  .symbol.symbol-xl-35px.symbol-2by3 > img {
    height: 35px;
    width: 52.5px;
    max-width: none;
  }
  .symbol.symbol-xl-40px > img {
    width: 40px;
    height: 40px;
  }
  .symbol.symbol-xl-40px .symbol-label {
    width: 40px;
    height: 40px;
  }
  .symbol.symbol-xl-40px.symbol-fixed .symbol-label {
    width: 40px;
    height: 40px;
  }
  .symbol.symbol-xl-40px.symbol-fixed > img {
    width: 40px;
    height: 40px;
    max-width: none;
  }
  .symbol.symbol-xl-40px.symbol-2by3 .symbol-label {
    height: 40px;
    width: 60px;
  }
  .symbol.symbol-xl-40px.symbol-2by3 > img {
    height: 40px;
    width: 60px;
    max-width: none;
  }
  .symbol.symbol-xl-45px > img {
    width: 45px;
    height: 45px;
  }
  .symbol.symbol-xl-45px .symbol-label {
    width: 45px;
    height: 45px;
  }
  .symbol.symbol-xl-45px.symbol-fixed .symbol-label {
    width: 45px;
    height: 45px;
  }
  .symbol.symbol-xl-45px.symbol-fixed > img {
    width: 45px;
    height: 45px;
    max-width: none;
  }
  .symbol.symbol-xl-45px.symbol-2by3 .symbol-label {
    height: 45px;
    width: 67.5px;
  }
  .symbol.symbol-xl-45px.symbol-2by3 > img {
    height: 45px;
    width: 67.5px;
    max-width: none;
  }
  .symbol.symbol-xl-50px > img {
    width: 50px;
    height: 50px;
  }
  .symbol.symbol-xl-50px .symbol-label {
    width: 50px;
    height: 50px;
  }
  .symbol.symbol-xl-50px.symbol-fixed .symbol-label {
    width: 50px;
    height: 50px;
  }
  .symbol.symbol-xl-50px.symbol-fixed > img {
    width: 50px;
    height: 50px;
    max-width: none;
  }
  .symbol.symbol-xl-50px.symbol-2by3 .symbol-label {
    height: 50px;
    width: 75px;
  }
  .symbol.symbol-xl-50px.symbol-2by3 > img {
    height: 50px;
    width: 75px;
    max-width: none;
  }
  .symbol.symbol-xl-55px > img {
    width: 55px;
    height: 55px;
  }
  .symbol.symbol-xl-55px .symbol-label {
    width: 55px;
    height: 55px;
  }
  .symbol.symbol-xl-55px.symbol-fixed .symbol-label {
    width: 55px;
    height: 55px;
  }
  .symbol.symbol-xl-55px.symbol-fixed > img {
    width: 55px;
    height: 55px;
    max-width: none;
  }
  .symbol.symbol-xl-55px.symbol-2by3 .symbol-label {
    height: 55px;
    width: 82.5px;
  }
  .symbol.symbol-xl-55px.symbol-2by3 > img {
    height: 55px;
    width: 82.5px;
    max-width: none;
  }
  .symbol.symbol-xl-60px > img {
    width: 60px;
    height: 60px;
  }
  .symbol.symbol-xl-60px .symbol-label {
    width: 60px;
    height: 60px;
  }
  .symbol.symbol-xl-60px.symbol-fixed .symbol-label {
    width: 60px;
    height: 60px;
  }
  .symbol.symbol-xl-60px.symbol-fixed > img {
    width: 60px;
    height: 60px;
    max-width: none;
  }
  .symbol.symbol-xl-60px.symbol-2by3 .symbol-label {
    height: 60px;
    width: 90px;
  }
  .symbol.symbol-xl-60px.symbol-2by3 > img {
    height: 60px;
    width: 90px;
    max-width: none;
  }
  .symbol.symbol-xl-65px > img {
    width: 65px;
    height: 65px;
  }
  .symbol.symbol-xl-65px .symbol-label {
    width: 65px;
    height: 65px;
  }
  .symbol.symbol-xl-65px.symbol-fixed .symbol-label {
    width: 65px;
    height: 65px;
  }
  .symbol.symbol-xl-65px.symbol-fixed > img {
    width: 65px;
    height: 65px;
    max-width: none;
  }
  .symbol.symbol-xl-65px.symbol-2by3 .symbol-label {
    height: 65px;
    width: 97.5px;
  }
  .symbol.symbol-xl-65px.symbol-2by3 > img {
    height: 65px;
    width: 97.5px;
    max-width: none;
  }
  .symbol.symbol-xl-70px > img {
    width: 70px;
    height: 70px;
  }
  .symbol.symbol-xl-70px .symbol-label {
    width: 70px;
    height: 70px;
  }
  .symbol.symbol-xl-70px.symbol-fixed .symbol-label {
    width: 70px;
    height: 70px;
  }
  .symbol.symbol-xl-70px.symbol-fixed > img {
    width: 70px;
    height: 70px;
    max-width: none;
  }
  .symbol.symbol-xl-70px.symbol-2by3 .symbol-label {
    height: 70px;
    width: 105px;
  }
  .symbol.symbol-xl-70px.symbol-2by3 > img {
    height: 70px;
    width: 105px;
    max-width: none;
  }
  .symbol.symbol-xl-75px > img {
    width: 75px;
    height: 75px;
  }
  .symbol.symbol-xl-75px .symbol-label {
    width: 75px;
    height: 75px;
  }
  .symbol.symbol-xl-75px.symbol-fixed .symbol-label {
    width: 75px;
    height: 75px;
  }
  .symbol.symbol-xl-75px.symbol-fixed > img {
    width: 75px;
    height: 75px;
    max-width: none;
  }
  .symbol.symbol-xl-75px.symbol-2by3 .symbol-label {
    height: 75px;
    width: 112.5px;
  }
  .symbol.symbol-xl-75px.symbol-2by3 > img {
    height: 75px;
    width: 112.5px;
    max-width: none;
  }
  .symbol.symbol-xl-90px > img {
    width: 90px;
    height: 90px;
  }
  .symbol.symbol-xl-90px .symbol-label {
    width: 90px;
    height: 90px;
  }
  .symbol.symbol-xl-90px.symbol-fixed .symbol-label {
    width: 90px;
    height: 90px;
  }
  .symbol.symbol-xl-90px.symbol-fixed > img {
    width: 90px;
    height: 90px;
    max-width: none;
  }
  .symbol.symbol-xl-90px.symbol-2by3 .symbol-label {
    height: 90px;
    width: 135px;
  }
  .symbol.symbol-xl-90px.symbol-2by3 > img {
    height: 90px;
    width: 135px;
    max-width: none;
  }
  .symbol.symbol-xl-100px > img {
    width: 100px;
    height: 100px;
  }
  .symbol.symbol-xl-100px .symbol-label {
    width: 100px;
    height: 100px;
  }
  .symbol.symbol-xl-100px.symbol-fixed .symbol-label {
    width: 100px;
    height: 100px;
  }
  .symbol.symbol-xl-100px.symbol-fixed > img {
    width: 100px;
    height: 100px;
    max-width: none;
  }
  .symbol.symbol-xl-100px.symbol-2by3 .symbol-label {
    height: 100px;
    width: 150px;
  }
  .symbol.symbol-xl-100px.symbol-2by3 > img {
    height: 100px;
    width: 150px;
    max-width: none;
  }
  .symbol.symbol-xl-125px > img {
    width: 125px;
    height: 125px;
  }
  .symbol.symbol-xl-125px .symbol-label {
    width: 125px;
    height: 125px;
  }
  .symbol.symbol-xl-125px.symbol-fixed .symbol-label {
    width: 125px;
    height: 125px;
  }
  .symbol.symbol-xl-125px.symbol-fixed > img {
    width: 125px;
    height: 125px;
    max-width: none;
  }
  .symbol.symbol-xl-125px.symbol-2by3 .symbol-label {
    height: 125px;
    width: 187.5px;
  }
  .symbol.symbol-xl-125px.symbol-2by3 > img {
    height: 125px;
    width: 187.5px;
    max-width: none;
  }
  .symbol.symbol-xl-150px > img {
    width: 150px;
    height: 150px;
  }
  .symbol.symbol-xl-150px .symbol-label {
    width: 150px;
    height: 150px;
  }
  .symbol.symbol-xl-150px.symbol-fixed .symbol-label {
    width: 150px;
    height: 150px;
  }
  .symbol.symbol-xl-150px.symbol-fixed > img {
    width: 150px;
    height: 150px;
    max-width: none;
  }
  .symbol.symbol-xl-150px.symbol-2by3 .symbol-label {
    height: 150px;
    width: 225px;
  }
  .symbol.symbol-xl-150px.symbol-2by3 > img {
    height: 150px;
    width: 225px;
    max-width: none;
  }
  .symbol.symbol-xl-160px > img {
    width: 160px;
    height: 160px;
  }
  .symbol.symbol-xl-160px .symbol-label {
    width: 160px;
    height: 160px;
  }
  .symbol.symbol-xl-160px.symbol-fixed .symbol-label {
    width: 160px;
    height: 160px;
  }
  .symbol.symbol-xl-160px.symbol-fixed > img {
    width: 160px;
    height: 160px;
    max-width: none;
  }
  .symbol.symbol-xl-160px.symbol-2by3 .symbol-label {
    height: 160px;
    width: 240px;
  }
  .symbol.symbol-xl-160px.symbol-2by3 > img {
    height: 160px;
    width: 240px;
    max-width: none;
  }
  .symbol.symbol-xl-175px > img {
    width: 175px;
    height: 175px;
  }
  .symbol.symbol-xl-175px .symbol-label {
    width: 175px;
    height: 175px;
  }
  .symbol.symbol-xl-175px.symbol-fixed .symbol-label {
    width: 175px;
    height: 175px;
  }
  .symbol.symbol-xl-175px.symbol-fixed > img {
    width: 175px;
    height: 175px;
    max-width: none;
  }
  .symbol.symbol-xl-175px.symbol-2by3 .symbol-label {
    height: 175px;
    width: 262.5px;
  }
  .symbol.symbol-xl-175px.symbol-2by3 > img {
    height: 175px;
    width: 262.5px;
    max-width: none;
  }
  .symbol.symbol-xl-200px > img {
    width: 200px;
    height: 200px;
  }
  .symbol.symbol-xl-200px .symbol-label {
    width: 200px;
    height: 200px;
  }
  .symbol.symbol-xl-200px.symbol-fixed .symbol-label {
    width: 200px;
    height: 200px;
  }
  .symbol.symbol-xl-200px.symbol-fixed > img {
    width: 200px;
    height: 200px;
    max-width: none;
  }
  .symbol.symbol-xl-200px.symbol-2by3 .symbol-label {
    height: 200px;
    width: 300px;
  }
  .symbol.symbol-xl-200px.symbol-2by3 > img {
    height: 200px;
    width: 300px;
    max-width: none;
  }
}
@media (min-width: 1400px) {
  .symbol.symbol-xxl-20px > img {
    width: 20px;
    height: 20px;
  }
  .symbol.symbol-xxl-20px .symbol-label {
    width: 20px;
    height: 20px;
  }
  .symbol.symbol-xxl-20px.symbol-fixed .symbol-label {
    width: 20px;
    height: 20px;
  }
  .symbol.symbol-xxl-20px.symbol-fixed > img {
    width: 20px;
    height: 20px;
    max-width: none;
  }
  .symbol.symbol-xxl-20px.symbol-2by3 .symbol-label {
    height: 20px;
    width: 30px;
  }
  .symbol.symbol-xxl-20px.symbol-2by3 > img {
    height: 20px;
    width: 30px;
    max-width: none;
  }
  .symbol.symbol-xxl-25px > img {
    width: 25px;
    height: 25px;
  }
  .symbol.symbol-xxl-25px .symbol-label {
    width: 25px;
    height: 25px;
  }
  .symbol.symbol-xxl-25px.symbol-fixed .symbol-label {
    width: 25px;
    height: 25px;
  }
  .symbol.symbol-xxl-25px.symbol-fixed > img {
    width: 25px;
    height: 25px;
    max-width: none;
  }
  .symbol.symbol-xxl-25px.symbol-2by3 .symbol-label {
    height: 25px;
    width: 37.5px;
  }
  .symbol.symbol-xxl-25px.symbol-2by3 > img {
    height: 25px;
    width: 37.5px;
    max-width: none;
  }
  .symbol.symbol-xxl-30px > img {
    width: 30px;
    height: 30px;
  }
  .symbol.symbol-xxl-30px .symbol-label {
    width: 30px;
    height: 30px;
  }
  .symbol.symbol-xxl-30px.symbol-fixed .symbol-label {
    width: 30px;
    height: 30px;
  }
  .symbol.symbol-xxl-30px.symbol-fixed > img {
    width: 30px;
    height: 30px;
    max-width: none;
  }
  .symbol.symbol-xxl-30px.symbol-2by3 .symbol-label {
    height: 30px;
    width: 45px;
  }
  .symbol.symbol-xxl-30px.symbol-2by3 > img {
    height: 30px;
    width: 45px;
    max-width: none;
  }
  .symbol.symbol-xxl-35px > img {
    width: 35px;
    height: 35px;
  }
  .symbol.symbol-xxl-35px .symbol-label {
    width: 35px;
    height: 35px;
  }
  .symbol.symbol-xxl-35px.symbol-fixed .symbol-label {
    width: 35px;
    height: 35px;
  }
  .symbol.symbol-xxl-35px.symbol-fixed > img {
    width: 35px;
    height: 35px;
    max-width: none;
  }
  .symbol.symbol-xxl-35px.symbol-2by3 .symbol-label {
    height: 35px;
    width: 52.5px;
  }
  .symbol.symbol-xxl-35px.symbol-2by3 > img {
    height: 35px;
    width: 52.5px;
    max-width: none;
  }
  .symbol.symbol-xxl-40px > img {
    width: 40px;
    height: 40px;
  }
  .symbol.symbol-xxl-40px .symbol-label {
    width: 40px;
    height: 40px;
  }
  .symbol.symbol-xxl-40px.symbol-fixed .symbol-label {
    width: 40px;
    height: 40px;
  }
  .symbol.symbol-xxl-40px.symbol-fixed > img {
    width: 40px;
    height: 40px;
    max-width: none;
  }
  .symbol.symbol-xxl-40px.symbol-2by3 .symbol-label {
    height: 40px;
    width: 60px;
  }
  .symbol.symbol-xxl-40px.symbol-2by3 > img {
    height: 40px;
    width: 60px;
    max-width: none;
  }
  .symbol.symbol-xxl-45px > img {
    width: 45px;
    height: 45px;
  }
  .symbol.symbol-xxl-45px .symbol-label {
    width: 45px;
    height: 45px;
  }
  .symbol.symbol-xxl-45px.symbol-fixed .symbol-label {
    width: 45px;
    height: 45px;
  }
  .symbol.symbol-xxl-45px.symbol-fixed > img {
    width: 45px;
    height: 45px;
    max-width: none;
  }
  .symbol.symbol-xxl-45px.symbol-2by3 .symbol-label {
    height: 45px;
    width: 67.5px;
  }
  .symbol.symbol-xxl-45px.symbol-2by3 > img {
    height: 45px;
    width: 67.5px;
    max-width: none;
  }
  .symbol.symbol-xxl-50px > img {
    width: 50px;
    height: 50px;
  }
  .symbol.symbol-xxl-50px .symbol-label {
    width: 50px;
    height: 50px;
  }
  .symbol.symbol-xxl-50px.symbol-fixed .symbol-label {
    width: 50px;
    height: 50px;
  }
  .symbol.symbol-xxl-50px.symbol-fixed > img {
    width: 50px;
    height: 50px;
    max-width: none;
  }
  .symbol.symbol-xxl-50px.symbol-2by3 .symbol-label {
    height: 50px;
    width: 75px;
  }
  .symbol.symbol-xxl-50px.symbol-2by3 > img {
    height: 50px;
    width: 75px;
    max-width: none;
  }
  .symbol.symbol-xxl-55px > img {
    width: 55px;
    height: 55px;
  }
  .symbol.symbol-xxl-55px .symbol-label {
    width: 55px;
    height: 55px;
  }
  .symbol.symbol-xxl-55px.symbol-fixed .symbol-label {
    width: 55px;
    height: 55px;
  }
  .symbol.symbol-xxl-55px.symbol-fixed > img {
    width: 55px;
    height: 55px;
    max-width: none;
  }
  .symbol.symbol-xxl-55px.symbol-2by3 .symbol-label {
    height: 55px;
    width: 82.5px;
  }
  .symbol.symbol-xxl-55px.symbol-2by3 > img {
    height: 55px;
    width: 82.5px;
    max-width: none;
  }
  .symbol.symbol-xxl-60px > img {
    width: 60px;
    height: 60px;
  }
  .symbol.symbol-xxl-60px .symbol-label {
    width: 60px;
    height: 60px;
  }
  .symbol.symbol-xxl-60px.symbol-fixed .symbol-label {
    width: 60px;
    height: 60px;
  }
  .symbol.symbol-xxl-60px.symbol-fixed > img {
    width: 60px;
    height: 60px;
    max-width: none;
  }
  .symbol.symbol-xxl-60px.symbol-2by3 .symbol-label {
    height: 60px;
    width: 90px;
  }
  .symbol.symbol-xxl-60px.symbol-2by3 > img {
    height: 60px;
    width: 90px;
    max-width: none;
  }
  .symbol.symbol-xxl-65px > img {
    width: 65px;
    height: 65px;
  }
  .symbol.symbol-xxl-65px .symbol-label {
    width: 65px;
    height: 65px;
  }
  .symbol.symbol-xxl-65px.symbol-fixed .symbol-label {
    width: 65px;
    height: 65px;
  }
  .symbol.symbol-xxl-65px.symbol-fixed > img {
    width: 65px;
    height: 65px;
    max-width: none;
  }
  .symbol.symbol-xxl-65px.symbol-2by3 .symbol-label {
    height: 65px;
    width: 97.5px;
  }
  .symbol.symbol-xxl-65px.symbol-2by3 > img {
    height: 65px;
    width: 97.5px;
    max-width: none;
  }
  .symbol.symbol-xxl-70px > img {
    width: 70px;
    height: 70px;
  }
  .symbol.symbol-xxl-70px .symbol-label {
    width: 70px;
    height: 70px;
  }
  .symbol.symbol-xxl-70px.symbol-fixed .symbol-label {
    width: 70px;
    height: 70px;
  }
  .symbol.symbol-xxl-70px.symbol-fixed > img {
    width: 70px;
    height: 70px;
    max-width: none;
  }
  .symbol.symbol-xxl-70px.symbol-2by3 .symbol-label {
    height: 70px;
    width: 105px;
  }
  .symbol.symbol-xxl-70px.symbol-2by3 > img {
    height: 70px;
    width: 105px;
    max-width: none;
  }
  .symbol.symbol-xxl-75px > img {
    width: 75px;
    height: 75px;
  }
  .symbol.symbol-xxl-75px .symbol-label {
    width: 75px;
    height: 75px;
  }
  .symbol.symbol-xxl-75px.symbol-fixed .symbol-label {
    width: 75px;
    height: 75px;
  }
  .symbol.symbol-xxl-75px.symbol-fixed > img {
    width: 75px;
    height: 75px;
    max-width: none;
  }
  .symbol.symbol-xxl-75px.symbol-2by3 .symbol-label {
    height: 75px;
    width: 112.5px;
  }
  .symbol.symbol-xxl-75px.symbol-2by3 > img {
    height: 75px;
    width: 112.5px;
    max-width: none;
  }
  .symbol.symbol-xxl-90px > img {
    width: 90px;
    height: 90px;
  }
  .symbol.symbol-xxl-90px .symbol-label {
    width: 90px;
    height: 90px;
  }
  .symbol.symbol-xxl-90px.symbol-fixed .symbol-label {
    width: 90px;
    height: 90px;
  }
  .symbol.symbol-xxl-90px.symbol-fixed > img {
    width: 90px;
    height: 90px;
    max-width: none;
  }
  .symbol.symbol-xxl-90px.symbol-2by3 .symbol-label {
    height: 90px;
    width: 135px;
  }
  .symbol.symbol-xxl-90px.symbol-2by3 > img {
    height: 90px;
    width: 135px;
    max-width: none;
  }
  .symbol.symbol-xxl-100px > img {
    width: 100px;
    height: 100px;
  }
  .symbol.symbol-xxl-100px .symbol-label {
    width: 100px;
    height: 100px;
  }
  .symbol.symbol-xxl-100px.symbol-fixed .symbol-label {
    width: 100px;
    height: 100px;
  }
  .symbol.symbol-xxl-100px.symbol-fixed > img {
    width: 100px;
    height: 100px;
    max-width: none;
  }
  .symbol.symbol-xxl-100px.symbol-2by3 .symbol-label {
    height: 100px;
    width: 150px;
  }
  .symbol.symbol-xxl-100px.symbol-2by3 > img {
    height: 100px;
    width: 150px;
    max-width: none;
  }
  .symbol.symbol-xxl-125px > img {
    width: 125px;
    height: 125px;
  }
  .symbol.symbol-xxl-125px .symbol-label {
    width: 125px;
    height: 125px;
  }
  .symbol.symbol-xxl-125px.symbol-fixed .symbol-label {
    width: 125px;
    height: 125px;
  }
  .symbol.symbol-xxl-125px.symbol-fixed > img {
    width: 125px;
    height: 125px;
    max-width: none;
  }
  .symbol.symbol-xxl-125px.symbol-2by3 .symbol-label {
    height: 125px;
    width: 187.5px;
  }
  .symbol.symbol-xxl-125px.symbol-2by3 > img {
    height: 125px;
    width: 187.5px;
    max-width: none;
  }
  .symbol.symbol-xxl-150px > img {
    width: 150px;
    height: 150px;
  }
  .symbol.symbol-xxl-150px .symbol-label {
    width: 150px;
    height: 150px;
  }
  .symbol.symbol-xxl-150px.symbol-fixed .symbol-label {
    width: 150px;
    height: 150px;
  }
  .symbol.symbol-xxl-150px.symbol-fixed > img {
    width: 150px;
    height: 150px;
    max-width: none;
  }
  .symbol.symbol-xxl-150px.symbol-2by3 .symbol-label {
    height: 150px;
    width: 225px;
  }
  .symbol.symbol-xxl-150px.symbol-2by3 > img {
    height: 150px;
    width: 225px;
    max-width: none;
  }
  .symbol.symbol-xxl-160px > img {
    width: 160px;
    height: 160px;
  }
  .symbol.symbol-xxl-160px .symbol-label {
    width: 160px;
    height: 160px;
  }
  .symbol.symbol-xxl-160px.symbol-fixed .symbol-label {
    width: 160px;
    height: 160px;
  }
  .symbol.symbol-xxl-160px.symbol-fixed > img {
    width: 160px;
    height: 160px;
    max-width: none;
  }
  .symbol.symbol-xxl-160px.symbol-2by3 .symbol-label {
    height: 160px;
    width: 240px;
  }
  .symbol.symbol-xxl-160px.symbol-2by3 > img {
    height: 160px;
    width: 240px;
    max-width: none;
  }
  .symbol.symbol-xxl-175px > img {
    width: 175px;
    height: 175px;
  }
  .symbol.symbol-xxl-175px .symbol-label {
    width: 175px;
    height: 175px;
  }
  .symbol.symbol-xxl-175px.symbol-fixed .symbol-label {
    width: 175px;
    height: 175px;
  }
  .symbol.symbol-xxl-175px.symbol-fixed > img {
    width: 175px;
    height: 175px;
    max-width: none;
  }
  .symbol.symbol-xxl-175px.symbol-2by3 .symbol-label {
    height: 175px;
    width: 262.5px;
  }
  .symbol.symbol-xxl-175px.symbol-2by3 > img {
    height: 175px;
    width: 262.5px;
    max-width: none;
  }
  .symbol.symbol-xxl-200px > img {
    width: 200px;
    height: 200px;
  }
  .symbol.symbol-xxl-200px .symbol-label {
    width: 200px;
    height: 200px;
  }
  .symbol.symbol-xxl-200px.symbol-fixed .symbol-label {
    width: 200px;
    height: 200px;
  }
  .symbol.symbol-xxl-200px.symbol-fixed > img {
    width: 200px;
    height: 200px;
    max-width: none;
  }
  .symbol.symbol-xxl-200px.symbol-2by3 .symbol-label {
    height: 200px;
    width: 300px;
  }
  .symbol.symbol-xxl-200px.symbol-2by3 > img {
    height: 200px;
    width: 300px;
    max-width: none;
  }
}
.symbol-group {
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  margin-left: 10px;
}

.symbol-group .symbol {
  position: relative;
  z-index: 0;
  margin-left: -10px;
  transition: all 0.3s ease;
}

.symbol-group .symbol:hover {
  transition: all 0.3s ease;
  z-index: 1;
}

.symbol-group .symbol-badge {
  border: 2px solid var(--bs-body-bg);
}

.symbol-group .symbol-label {
  position: relative;
}

.symbol-group .symbol-label:after {
  display: block;
  content: " ";
  border-radius: inherit;
  position: absolute;
  top: 0;
  right: 0;
  left: 0;
  bottom: 0;
  border: 2px solid var(--bs-symbol-border-color); /* for Safari */
  background-clip: padding-box; /* for IE9+, Firefox 4+, Opera, Chrome */
}

.symbol-group.symbol-hover .symbol {
  cursor: pointer;
}

.pulse {
  position: relative;
}

.pulse.pulse-light .pulse-ring {
  border-color: var(--bs-light);
}

.pulse.pulse-primary .pulse-ring {
  border-color: var(--bs-primary);
}

.pulse.pulse-secondary .pulse-ring {
  border-color: var(--bs-secondary);
}

.pulse.pulse-success .pulse-ring {
  border-color: var(--bs-success);
}

.pulse.pulse-info .pulse-ring {
  border-color: var(--bs-info);
}

.pulse.pulse-warning .pulse-ring {
  border-color: var(--bs-warning);
}

.pulse.pulse-danger .pulse-ring {
  border-color: var(--bs-danger);
}

.pulse.pulse-dark .pulse-ring {
  border-color: var(--bs-dark);
}

.pulse-ring {
  display: block;
  border-radius: 40px;
  height: 40px;
  width: 40px;
  position: absolute;
  animation: animation-pulse 3.5s ease-out;
  animation-iteration-count: infinite;
  opacity: 0;
  border-width: 3px;
  border-style: solid;
  border-color: var(--bs-gray-500);
}

@keyframes animation-pulse {
  0% {
    -webkit-transform: scale(0.1, 0.1);
    opacity: 0;
  }
  60% {
    -webkit-transform: scale(0.1, 0.1);
    opacity: 0;
  }
  65% {
    opacity: 1;
  }
  100% {
    -webkit-transform: scale(1.2, 1.2);
    opacity: 0;
  }
}
[data-kt-app-page-loading=on] *,
.page-loading * {
  transition: none !important;
}

.page-loader {
  background-color: var(--bs-body-bg);
  position: fixed;
  top: 0;
  bottom: 0;
  left: 0;
  right: 0;
  z-index: 10000;
  display: none;
}

[data-kt-app-page-loading=on] .page-loader, .page-loading .page-loader {
  display: flex;
  justify-content: center;
  align-items: center;
}

.scrolltop {
  position: fixed;
  display: none;
  cursor: pointer;
  z-index: 105;
  justify-content: center;
  align-items: center;
  width: 36px;
  height: 36px;
  bottom: 43px;
  right: 7px;
  background-color: var(--bs-scrolltop-bg-color);
  box-shadow: var(--bs-scrolltop-box-shadow);
  opacity: 0;
  transition: color 0.2s ease;
  border-radius: 0.475rem;
}

.scrolltop .svg-icon {
  color: var(--bs-scrolltop-icon-color);
}

.scrolltop .svg-icon svg {
  height: 24px;
  width: 24px;
}

.scrolltop > i {
  font-size: 1.3rem;
  color: var(--bs-scrolltop-icon-color);
}

.scrolltop:hover {
  background-color: var(--bs-scrolltop-bg-color-hover);
}

.scrolltop:hover .svg-icon,
.scrolltop:hover i {
  color: var(--bs-scrolltop-icon-color-hover);
}

[data-kt-scrolltop=on] .scrolltop {
  opacity: var(--bs-scrolltop-opacity-on);
  animation: animation-scrolltop 0.4s ease-out 1;
  display: flex;
}

[data-kt-scrolltop=on] .scrolltop:hover {
  transition: color 0.2s ease;
  opacity: var(--bs-scrolltop-opacity-hover);
}

@media (max-width: 991.98px) {
  .scrolltop {
    bottom: 23px;
    right: 5px;
    width: 30px;
    height: 30px;
  }
}
@keyframes animation-scrolltop {
  from {
    margin-bottom: -15px;
  }
  to {
    margin-bottom: 0;
  }
}
.svg-icon {
  line-height: 1;
  color: var(--bs-text-muted);
}

.svg-icon svg {
  height: 1.15rem;
  width: 1.15rem;
}

.svg-icon.svg-icon-white {
  color: var(--bs-text-white);
}

.svg-icon.svg-icon-primary {
  color: var(--bs-text-primary);
}

.svg-icon.svg-icon-secondary {
  color: var(--bs-text-secondary);
}

.svg-icon.svg-icon-light {
  color: var(--bs-text-light);
}

.svg-icon.svg-icon-success {
  color: var(--bs-text-success);
}

.svg-icon.svg-icon-info {
  color: var(--bs-text-info);
}

.svg-icon.svg-icon-warning {
  color: var(--bs-text-warning);
}

.svg-icon.svg-icon-danger {
  color: var(--bs-text-danger);
}

.svg-icon.svg-icon-dark {
  color: var(--bs-text-dark);
}

.svg-icon.svg-icon-muted {
  color: var(--bs-text-muted);
}

.svg-icon.svg-icon-gray-100 {
  color: var(--bs-text-gray-100);
}

.svg-icon.svg-icon-gray-200 {
  color: var(--bs-text-gray-200);
}

.svg-icon.svg-icon-gray-300 {
  color: var(--bs-text-gray-300);
}

.svg-icon.svg-icon-gray-400 {
  color: var(--bs-text-gray-400);
}

.svg-icon.svg-icon-gray-500 {
  color: var(--bs-text-gray-500);
}

.svg-icon.svg-icon-gray-600 {
  color: var(--bs-text-gray-600);
}

.svg-icon.svg-icon-gray-700 {
  color: var(--bs-text-gray-700);
}

.svg-icon.svg-icon-gray-800 {
  color: var(--bs-text-gray-800);
}

.svg-icon.svg-icon-gray-900 {
  color: var(--bs-text-gray-900);
}

.svg-icon.svg-icon-1 svg {
  height: 1.75rem !important;
  width: 1.75rem !important;
}

.svg-icon.svg-icon-2 svg {
  height: 1.5rem !important;
  width: 1.5rem !important;
}

.svg-icon.svg-icon-3 svg {
  height: 1.35rem !important;
  width: 1.35rem !important;
}

.svg-icon.svg-icon-4 svg {
  height: 1.25rem !important;
  width: 1.25rem !important;
}

.svg-icon.svg-icon-5 svg {
  height: 1.15rem !important;
  width: 1.15rem !important;
}

.svg-icon.svg-icon-6 svg {
  height: 1.075rem !important;
  width: 1.075rem !important;
}

.svg-icon.svg-icon-7 svg {
  height: 0.95rem !important;
  width: 0.95rem !important;
}

.svg-icon.svg-icon-8 svg {
  height: 0.85rem !important;
  width: 0.85rem !important;
}

.svg-icon.svg-icon-9 svg {
  height: 0.75rem !important;
  width: 0.75rem !important;
}

.svg-icon.svg-icon-10 svg {
  height: 0.5rem !important;
  width: 0.5rem !important;
}

.svg-icon.svg-icon-base svg {
  height: 1rem !important;
  width: 1rem !important;
}

.svg-icon.svg-icon-fluid svg {
  height: 100% !important;
  width: 100% !important;
}

.svg-icon.svg-icon-2x svg {
  height: 2rem !important;
  width: 2rem !important;
}

.svg-icon.svg-icon-2qx svg {
  height: 2.25rem !important;
  width: 2.25rem !important;
}

.svg-icon.svg-icon-2hx svg {
  height: 2.5rem !important;
  width: 2.5rem !important;
}

.svg-icon.svg-icon-2tx svg {
  height: 2.75rem !important;
  width: 2.75rem !important;
}

.svg-icon.svg-icon-3x svg {
  height: 3rem !important;
  width: 3rem !important;
}

.svg-icon.svg-icon-3qx svg {
  height: 3.25rem !important;
  width: 3.25rem !important;
}

.svg-icon.svg-icon-3hx svg {
  height: 3.5rem !important;
  width: 3.5rem !important;
}

.svg-icon.svg-icon-3tx svg {
  height: 3.75rem !important;
  width: 3.75rem !important;
}

.svg-icon.svg-icon-4x svg {
  height: 4rem !important;
  width: 4rem !important;
}

.svg-icon.svg-icon-4qx svg {
  height: 4.25rem !important;
  width: 4.25rem !important;
}

.svg-icon.svg-icon-4hx svg {
  height: 4.5rem !important;
  width: 4.5rem !important;
}

.svg-icon.svg-icon-4tx svg {
  height: 4.75rem !important;
  width: 4.75rem !important;
}

.svg-icon.svg-icon-5x svg {
  height: 5rem !important;
  width: 5rem !important;
}

.svg-icon.svg-icon-5qx svg {
  height: 5.25rem !important;
  width: 5.25rem !important;
}

.svg-icon.svg-icon-5hx svg {
  height: 5.5rem !important;
  width: 5.5rem !important;
}

.svg-icon.svg-icon-5tx svg {
  height: 5.75rem !important;
  width: 5.75rem !important;
}

.svg-icon.svg-icon-6x svg {
  height: 6rem !important;
  width: 6rem !important;
}

.svg-icon.svg-icon-6qx svg {
  height: 6.25rem !important;
  width: 6.25rem !important;
}

.svg-icon.svg-icon-6hx svg {
  height: 6.5rem !important;
  width: 6.5rem !important;
}

.svg-icon.svg-icon-6tx svg {
  height: 6.75rem !important;
  width: 6.75rem !important;
}

.svg-icon.svg-icon-7x svg {
  height: 7rem !important;
  width: 7rem !important;
}

.svg-icon.svg-icon-7qx svg {
  height: 7.25rem !important;
  width: 7.25rem !important;
}

.svg-icon.svg-icon-7hx svg {
  height: 7.5rem !important;
  width: 7.5rem !important;
}

.svg-icon.svg-icon-7tx svg {
  height: 7.75rem !important;
  width: 7.75rem !important;
}

@media (min-width: 576px) {
  .svg-icon.svg-icon-sm-1 svg {
    height: 1.75rem !important;
    width: 1.75rem !important;
  }
  .svg-icon.svg-icon-sm-2 svg {
    height: 1.5rem !important;
    width: 1.5rem !important;
  }
  .svg-icon.svg-icon-sm-3 svg {
    height: 1.35rem !important;
    width: 1.35rem !important;
  }
  .svg-icon.svg-icon-sm-4 svg {
    height: 1.25rem !important;
    width: 1.25rem !important;
  }
  .svg-icon.svg-icon-sm-5 svg {
    height: 1.15rem !important;
    width: 1.15rem !important;
  }
  .svg-icon.svg-icon-sm-6 svg {
    height: 1.075rem !important;
    width: 1.075rem !important;
  }
  .svg-icon.svg-icon-sm-7 svg {
    height: 0.95rem !important;
    width: 0.95rem !important;
  }
  .svg-icon.svg-icon-sm-8 svg {
    height: 0.85rem !important;
    width: 0.85rem !important;
  }
  .svg-icon.svg-icon-sm-9 svg {
    height: 0.75rem !important;
    width: 0.75rem !important;
  }
  .svg-icon.svg-icon-sm-10 svg {
    height: 0.5rem !important;
    width: 0.5rem !important;
  }
  .svg-icon.svg-icon-sm-base svg {
    height: 1rem !important;
    width: 1rem !important;
  }
  .svg-icon.svg-icon-sm-fluid svg {
    height: 100% !important;
    width: 100% !important;
  }
  .svg-icon.svg-icon-sm-2x svg {
    height: 2rem !important;
    width: 2rem !important;
  }
  .svg-icon.svg-icon-sm-2qx svg {
    height: 2.25rem !important;
    width: 2.25rem !important;
  }
  .svg-icon.svg-icon-sm-2hx svg {
    height: 2.5rem !important;
    width: 2.5rem !important;
  }
  .svg-icon.svg-icon-sm-2tx svg {
    height: 2.75rem !important;
    width: 2.75rem !important;
  }
  .svg-icon.svg-icon-sm-3x svg {
    height: 3rem !important;
    width: 3rem !important;
  }
  .svg-icon.svg-icon-sm-3qx svg {
    height: 3.25rem !important;
    width: 3.25rem !important;
  }
  .svg-icon.svg-icon-sm-3hx svg {
    height: 3.5rem !important;
    width: 3.5rem !important;
  }
  .svg-icon.svg-icon-sm-3tx svg {
    height: 3.75rem !important;
    width: 3.75rem !important;
  }
  .svg-icon.svg-icon-sm-4x svg {
    height: 4rem !important;
    width: 4rem !important;
  }
  .svg-icon.svg-icon-sm-4qx svg {
    height: 4.25rem !important;
    width: 4.25rem !important;
  }
  .svg-icon.svg-icon-sm-4hx svg {
    height: 4.5rem !important;
    width: 4.5rem !important;
  }
  .svg-icon.svg-icon-sm-4tx svg {
    height: 4.75rem !important;
    width: 4.75rem !important;
  }
  .svg-icon.svg-icon-sm-5x svg {
    height: 5rem !important;
    width: 5rem !important;
  }
  .svg-icon.svg-icon-sm-5qx svg {
    height: 5.25rem !important;
    width: 5.25rem !important;
  }
  .svg-icon.svg-icon-sm-5hx svg {
    height: 5.5rem !important;
    width: 5.5rem !important;
  }
  .svg-icon.svg-icon-sm-5tx svg {
    height: 5.75rem !important;
    width: 5.75rem !important;
  }
  .svg-icon.svg-icon-sm-6x svg {
    height: 6rem !important;
    width: 6rem !important;
  }
  .svg-icon.svg-icon-sm-6qx svg {
    height: 6.25rem !important;
    width: 6.25rem !important;
  }
  .svg-icon.svg-icon-sm-6hx svg {
    height: 6.5rem !important;
    width: 6.5rem !important;
  }
  .svg-icon.svg-icon-sm-6tx svg {
    height: 6.75rem !important;
    width: 6.75rem !important;
  }
  .svg-icon.svg-icon-sm-7x svg {
    height: 7rem !important;
    width: 7rem !important;
  }
  .svg-icon.svg-icon-sm-7qx svg {
    height: 7.25rem !important;
    width: 7.25rem !important;
  }
  .svg-icon.svg-icon-sm-7hx svg {
    height: 7.5rem !important;
    width: 7.5rem !important;
  }
  .svg-icon.svg-icon-sm-7tx svg {
    height: 7.75rem !important;
    width: 7.75rem !important;
  }
}
@media (min-width: 768px) {
  .svg-icon.svg-icon-md-1 svg {
    height: 1.75rem !important;
    width: 1.75rem !important;
  }
  .svg-icon.svg-icon-md-2 svg {
    height: 1.5rem !important;
    width: 1.5rem !important;
  }
  .svg-icon.svg-icon-md-3 svg {
    height: 1.35rem !important;
    width: 1.35rem !important;
  }
  .svg-icon.svg-icon-md-4 svg {
    height: 1.25rem !important;
    width: 1.25rem !important;
  }
  .svg-icon.svg-icon-md-5 svg {
    height: 1.15rem !important;
    width: 1.15rem !important;
  }
  .svg-icon.svg-icon-md-6 svg {
    height: 1.075rem !important;
    width: 1.075rem !important;
  }
  .svg-icon.svg-icon-md-7 svg {
    height: 0.95rem !important;
    width: 0.95rem !important;
  }
  .svg-icon.svg-icon-md-8 svg {
    height: 0.85rem !important;
    width: 0.85rem !important;
  }
  .svg-icon.svg-icon-md-9 svg {
    height: 0.75rem !important;
    width: 0.75rem !important;
  }
  .svg-icon.svg-icon-md-10 svg {
    height: 0.5rem !important;
    width: 0.5rem !important;
  }
  .svg-icon.svg-icon-md-base svg {
    height: 1rem !important;
    width: 1rem !important;
  }
  .svg-icon.svg-icon-md-fluid svg {
    height: 100% !important;
    width: 100% !important;
  }
  .svg-icon.svg-icon-md-2x svg {
    height: 2rem !important;
    width: 2rem !important;
  }
  .svg-icon.svg-icon-md-2qx svg {
    height: 2.25rem !important;
    width: 2.25rem !important;
  }
  .svg-icon.svg-icon-md-2hx svg {
    height: 2.5rem !important;
    width: 2.5rem !important;
  }
  .svg-icon.svg-icon-md-2tx svg {
    height: 2.75rem !important;
    width: 2.75rem !important;
  }
  .svg-icon.svg-icon-md-3x svg {
    height: 3rem !important;
    width: 3rem !important;
  }
  .svg-icon.svg-icon-md-3qx svg {
    height: 3.25rem !important;
    width: 3.25rem !important;
  }
  .svg-icon.svg-icon-md-3hx svg {
    height: 3.5rem !important;
    width: 3.5rem !important;
  }
  .svg-icon.svg-icon-md-3tx svg {
    height: 3.75rem !important;
    width: 3.75rem !important;
  }
  .svg-icon.svg-icon-md-4x svg {
    height: 4rem !important;
    width: 4rem !important;
  }
  .svg-icon.svg-icon-md-4qx svg {
    height: 4.25rem !important;
    width: 4.25rem !important;
  }
  .svg-icon.svg-icon-md-4hx svg {
    height: 4.5rem !important;
    width: 4.5rem !important;
  }
  .svg-icon.svg-icon-md-4tx svg {
    height: 4.75rem !important;
    width: 4.75rem !important;
  }
  .svg-icon.svg-icon-md-5x svg {
    height: 5rem !important;
    width: 5rem !important;
  }
  .svg-icon.svg-icon-md-5qx svg {
    height: 5.25rem !important;
    width: 5.25rem !important;
  }
  .svg-icon.svg-icon-md-5hx svg {
    height: 5.5rem !important;
    width: 5.5rem !important;
  }
  .svg-icon.svg-icon-md-5tx svg {
    height: 5.75rem !important;
    width: 5.75rem !important;
  }
  .svg-icon.svg-icon-md-6x svg {
    height: 6rem !important;
    width: 6rem !important;
  }
  .svg-icon.svg-icon-md-6qx svg {
    height: 6.25rem !important;
    width: 6.25rem !important;
  }
  .svg-icon.svg-icon-md-6hx svg {
    height: 6.5rem !important;
    width: 6.5rem !important;
  }
  .svg-icon.svg-icon-md-6tx svg {
    height: 6.75rem !important;
    width: 6.75rem !important;
  }
  .svg-icon.svg-icon-md-7x svg {
    height: 7rem !important;
    width: 7rem !important;
  }
  .svg-icon.svg-icon-md-7qx svg {
    height: 7.25rem !important;
    width: 7.25rem !important;
  }
  .svg-icon.svg-icon-md-7hx svg {
    height: 7.5rem !important;
    width: 7.5rem !important;
  }
  .svg-icon.svg-icon-md-7tx svg {
    height: 7.75rem !important;
    width: 7.75rem !important;
  }
}
@media (min-width: 992px) {
  .svg-icon.svg-icon-lg-1 svg {
    height: 1.75rem !important;
    width: 1.75rem !important;
  }
  .svg-icon.svg-icon-lg-2 svg {
    height: 1.5rem !important;
    width: 1.5rem !important;
  }
  .svg-icon.svg-icon-lg-3 svg {
    height: 1.35rem !important;
    width: 1.35rem !important;
  }
  .svg-icon.svg-icon-lg-4 svg {
    height: 1.25rem !important;
    width: 1.25rem !important;
  }
  .svg-icon.svg-icon-lg-5 svg {
    height: 1.15rem !important;
    width: 1.15rem !important;
  }
  .svg-icon.svg-icon-lg-6 svg {
    height: 1.075rem !important;
    width: 1.075rem !important;
  }
  .svg-icon.svg-icon-lg-7 svg {
    height: 0.95rem !important;
    width: 0.95rem !important;
  }
  .svg-icon.svg-icon-lg-8 svg {
    height: 0.85rem !important;
    width: 0.85rem !important;
  }
  .svg-icon.svg-icon-lg-9 svg {
    height: 0.75rem !important;
    width: 0.75rem !important;
  }
  .svg-icon.svg-icon-lg-10 svg {
    height: 0.5rem !important;
    width: 0.5rem !important;
  }
  .svg-icon.svg-icon-lg-base svg {
    height: 1rem !important;
    width: 1rem !important;
  }
  .svg-icon.svg-icon-lg-fluid svg {
    height: 100% !important;
    width: 100% !important;
  }
  .svg-icon.svg-icon-lg-2x svg {
    height: 2rem !important;
    width: 2rem !important;
  }
  .svg-icon.svg-icon-lg-2qx svg {
    height: 2.25rem !important;
    width: 2.25rem !important;
  }
  .svg-icon.svg-icon-lg-2hx svg {
    height: 2.5rem !important;
    width: 2.5rem !important;
  }
  .svg-icon.svg-icon-lg-2tx svg {
    height: 2.75rem !important;
    width: 2.75rem !important;
  }
  .svg-icon.svg-icon-lg-3x svg {
    height: 3rem !important;
    width: 3rem !important;
  }
  .svg-icon.svg-icon-lg-3qx svg {
    height: 3.25rem !important;
    width: 3.25rem !important;
  }
  .svg-icon.svg-icon-lg-3hx svg {
    height: 3.5rem !important;
    width: 3.5rem !important;
  }
  .svg-icon.svg-icon-lg-3tx svg {
    height: 3.75rem !important;
    width: 3.75rem !important;
  }
  .svg-icon.svg-icon-lg-4x svg {
    height: 4rem !important;
    width: 4rem !important;
  }
  .svg-icon.svg-icon-lg-4qx svg {
    height: 4.25rem !important;
    width: 4.25rem !important;
  }
  .svg-icon.svg-icon-lg-4hx svg {
    height: 4.5rem !important;
    width: 4.5rem !important;
  }
  .svg-icon.svg-icon-lg-4tx svg {
    height: 4.75rem !important;
    width: 4.75rem !important;
  }
  .svg-icon.svg-icon-lg-5x svg {
    height: 5rem !important;
    width: 5rem !important;
  }
  .svg-icon.svg-icon-lg-5qx svg {
    height: 5.25rem !important;
    width: 5.25rem !important;
  }
  .svg-icon.svg-icon-lg-5hx svg {
    height: 5.5rem !important;
    width: 5.5rem !important;
  }
  .svg-icon.svg-icon-lg-5tx svg {
    height: 5.75rem !important;
    width: 5.75rem !important;
  }
  .svg-icon.svg-icon-lg-6x svg {
    height: 6rem !important;
    width: 6rem !important;
  }
  .svg-icon.svg-icon-lg-6qx svg {
    height: 6.25rem !important;
    width: 6.25rem !important;
  }
  .svg-icon.svg-icon-lg-6hx svg {
    height: 6.5rem !important;
    width: 6.5rem !important;
  }
  .svg-icon.svg-icon-lg-6tx svg {
    height: 6.75rem !important;
    width: 6.75rem !important;
  }
  .svg-icon.svg-icon-lg-7x svg {
    height: 7rem !important;
    width: 7rem !important;
  }
  .svg-icon.svg-icon-lg-7qx svg {
    height: 7.25rem !important;
    width: 7.25rem !important;
  }
  .svg-icon.svg-icon-lg-7hx svg {
    height: 7.5rem !important;
    width: 7.5rem !important;
  }
  .svg-icon.svg-icon-lg-7tx svg {
    height: 7.75rem !important;
    width: 7.75rem !important;
  }
}
@media (min-width: 1200px) {
  .svg-icon.svg-icon-xl-1 svg {
    height: 1.75rem !important;
    width: 1.75rem !important;
  }
  .svg-icon.svg-icon-xl-2 svg {
    height: 1.5rem !important;
    width: 1.5rem !important;
  }
  .svg-icon.svg-icon-xl-3 svg {
    height: 1.35rem !important;
    width: 1.35rem !important;
  }
  .svg-icon.svg-icon-xl-4 svg {
    height: 1.25rem !important;
    width: 1.25rem !important;
  }
  .svg-icon.svg-icon-xl-5 svg {
    height: 1.15rem !important;
    width: 1.15rem !important;
  }
  .svg-icon.svg-icon-xl-6 svg {
    height: 1.075rem !important;
    width: 1.075rem !important;
  }
  .svg-icon.svg-icon-xl-7 svg {
    height: 0.95rem !important;
    width: 0.95rem !important;
  }
  .svg-icon.svg-icon-xl-8 svg {
    height: 0.85rem !important;
    width: 0.85rem !important;
  }
  .svg-icon.svg-icon-xl-9 svg {
    height: 0.75rem !important;
    width: 0.75rem !important;
  }
  .svg-icon.svg-icon-xl-10 svg {
    height: 0.5rem !important;
    width: 0.5rem !important;
  }
  .svg-icon.svg-icon-xl-base svg {
    height: 1rem !important;
    width: 1rem !important;
  }
  .svg-icon.svg-icon-xl-fluid svg {
    height: 100% !important;
    width: 100% !important;
  }
  .svg-icon.svg-icon-xl-2x svg {
    height: 2rem !important;
    width: 2rem !important;
  }
  .svg-icon.svg-icon-xl-2qx svg {
    height: 2.25rem !important;
    width: 2.25rem !important;
  }
  .svg-icon.svg-icon-xl-2hx svg {
    height: 2.5rem !important;
    width: 2.5rem !important;
  }
  .svg-icon.svg-icon-xl-2tx svg {
    height: 2.75rem !important;
    width: 2.75rem !important;
  }
  .svg-icon.svg-icon-xl-3x svg {
    height: 3rem !important;
    width: 3rem !important;
  }
  .svg-icon.svg-icon-xl-3qx svg {
    height: 3.25rem !important;
    width: 3.25rem !important;
  }
  .svg-icon.svg-icon-xl-3hx svg {
    height: 3.5rem !important;
    width: 3.5rem !important;
  }
  .svg-icon.svg-icon-xl-3tx svg {
    height: 3.75rem !important;
    width: 3.75rem !important;
  }
  .svg-icon.svg-icon-xl-4x svg {
    height: 4rem !important;
    width: 4rem !important;
  }
  .svg-icon.svg-icon-xl-4qx svg {
    height: 4.25rem !important;
    width: 4.25rem !important;
  }
  .svg-icon.svg-icon-xl-4hx svg {
    height: 4.5rem !important;
    width: 4.5rem !important;
  }
  .svg-icon.svg-icon-xl-4tx svg {
    height: 4.75rem !important;
    width: 4.75rem !important;
  }
  .svg-icon.svg-icon-xl-5x svg {
    height: 5rem !important;
    width: 5rem !important;
  }
  .svg-icon.svg-icon-xl-5qx svg {
    height: 5.25rem !important;
    width: 5.25rem !important;
  }
  .svg-icon.svg-icon-xl-5hx svg {
    height: 5.5rem !important;
    width: 5.5rem !important;
  }
  .svg-icon.svg-icon-xl-5tx svg {
    height: 5.75rem !important;
    width: 5.75rem !important;
  }
  .svg-icon.svg-icon-xl-6x svg {
    height: 6rem !important;
    width: 6rem !important;
  }
  .svg-icon.svg-icon-xl-6qx svg {
    height: 6.25rem !important;
    width: 6.25rem !important;
  }
  .svg-icon.svg-icon-xl-6hx svg {
    height: 6.5rem !important;
    width: 6.5rem !important;
  }
  .svg-icon.svg-icon-xl-6tx svg {
    height: 6.75rem !important;
    width: 6.75rem !important;
  }
  .svg-icon.svg-icon-xl-7x svg {
    height: 7rem !important;
    width: 7rem !important;
  }
  .svg-icon.svg-icon-xl-7qx svg {
    height: 7.25rem !important;
    width: 7.25rem !important;
  }
  .svg-icon.svg-icon-xl-7hx svg {
    height: 7.5rem !important;
    width: 7.5rem !important;
  }
  .svg-icon.svg-icon-xl-7tx svg {
    height: 7.75rem !important;
    width: 7.75rem !important;
  }
}
@media (min-width: 1400px) {
  .svg-icon.svg-icon-xxl-1 svg {
    height: 1.75rem !important;
    width: 1.75rem !important;
  }
  .svg-icon.svg-icon-xxl-2 svg {
    height: 1.5rem !important;
    width: 1.5rem !important;
  }
  .svg-icon.svg-icon-xxl-3 svg {
    height: 1.35rem !important;
    width: 1.35rem !important;
  }
  .svg-icon.svg-icon-xxl-4 svg {
    height: 1.25rem !important;
    width: 1.25rem !important;
  }
  .svg-icon.svg-icon-xxl-5 svg {
    height: 1.15rem !important;
    width: 1.15rem !important;
  }
  .svg-icon.svg-icon-xxl-6 svg {
    height: 1.075rem !important;
    width: 1.075rem !important;
  }
  .svg-icon.svg-icon-xxl-7 svg {
    height: 0.95rem !important;
    width: 0.95rem !important;
  }
  .svg-icon.svg-icon-xxl-8 svg {
    height: 0.85rem !important;
    width: 0.85rem !important;
  }
  .svg-icon.svg-icon-xxl-9 svg {
    height: 0.75rem !important;
    width: 0.75rem !important;
  }
  .svg-icon.svg-icon-xxl-10 svg {
    height: 0.5rem !important;
    width: 0.5rem !important;
  }
  .svg-icon.svg-icon-xxl-base svg {
    height: 1rem !important;
    width: 1rem !important;
  }
  .svg-icon.svg-icon-xxl-fluid svg {
    height: 100% !important;
    width: 100% !important;
  }
  .svg-icon.svg-icon-xxl-2x svg {
    height: 2rem !important;
    width: 2rem !important;
  }
  .svg-icon.svg-icon-xxl-2qx svg {
    height: 2.25rem !important;
    width: 2.25rem !important;
  }
  .svg-icon.svg-icon-xxl-2hx svg {
    height: 2.5rem !important;
    width: 2.5rem !important;
  }
  .svg-icon.svg-icon-xxl-2tx svg {
    height: 2.75rem !important;
    width: 2.75rem !important;
  }
  .svg-icon.svg-icon-xxl-3x svg {
    height: 3rem !important;
    width: 3rem !important;
  }
  .svg-icon.svg-icon-xxl-3qx svg {
    height: 3.25rem !important;
    width: 3.25rem !important;
  }
  .svg-icon.svg-icon-xxl-3hx svg {
    height: 3.5rem !important;
    width: 3.5rem !important;
  }
  .svg-icon.svg-icon-xxl-3tx svg {
    height: 3.75rem !important;
    width: 3.75rem !important;
  }
  .svg-icon.svg-icon-xxl-4x svg {
    height: 4rem !important;
    width: 4rem !important;
  }
  .svg-icon.svg-icon-xxl-4qx svg {
    height: 4.25rem !important;
    width: 4.25rem !important;
  }
  .svg-icon.svg-icon-xxl-4hx svg {
    height: 4.5rem !important;
    width: 4.5rem !important;
  }
  .svg-icon.svg-icon-xxl-4tx svg {
    height: 4.75rem !important;
    width: 4.75rem !important;
  }
  .svg-icon.svg-icon-xxl-5x svg {
    height: 5rem !important;
    width: 5rem !important;
  }
  .svg-icon.svg-icon-xxl-5qx svg {
    height: 5.25rem !important;
    width: 5.25rem !important;
  }
  .svg-icon.svg-icon-xxl-5hx svg {
    height: 5.5rem !important;
    width: 5.5rem !important;
  }
  .svg-icon.svg-icon-xxl-5tx svg {
    height: 5.75rem !important;
    width: 5.75rem !important;
  }
  .svg-icon.svg-icon-xxl-6x svg {
    height: 6rem !important;
    width: 6rem !important;
  }
  .svg-icon.svg-icon-xxl-6qx svg {
    height: 6.25rem !important;
    width: 6.25rem !important;
  }
  .svg-icon.svg-icon-xxl-6hx svg {
    height: 6.5rem !important;
    width: 6.5rem !important;
  }
  .svg-icon.svg-icon-xxl-6tx svg {
    height: 6.75rem !important;
    width: 6.75rem !important;
  }
  .svg-icon.svg-icon-xxl-7x svg {
    height: 7rem !important;
    width: 7rem !important;
  }
  .svg-icon.svg-icon-xxl-7qx svg {
    height: 7.25rem !important;
    width: 7.25rem !important;
  }
  .svg-icon.svg-icon-xxl-7hx svg {
    height: 7.5rem !important;
    width: 7.5rem !important;
  }
  .svg-icon.svg-icon-xxl-7tx svg {
    height: 7.75rem !important;
    width: 7.75rem !important;
  }
}
.fixed-top {
  position: fixed;
  z-index: 101;
  top: 0;
  left: 0;
  right: 0;
}

@media (min-width: 576px) {
  .fixed-top-sm {
    position: fixed;
    z-index: 101;
    top: 0;
    left: 0;
    right: 0;
  }
}
@media (min-width: 768px) {
  .fixed-top-md {
    position: fixed;
    z-index: 101;
    top: 0;
    left: 0;
    right: 0;
  }
}
@media (min-width: 992px) {
  .fixed-top-lg {
    position: fixed;
    z-index: 101;
    top: 0;
    left: 0;
    right: 0;
  }
}
@media (min-width: 1200px) {
  .fixed-top-xl {
    position: fixed;
    z-index: 101;
    top: 0;
    left: 0;
    right: 0;
  }
}
@media (min-width: 1400px) {
  .fixed-top-xxl {
    position: fixed;
    z-index: 101;
    top: 0;
    left: 0;
    right: 0;
  }
}
.timeline .timeline-item {
  position: relative;
  padding: 0;
  margin: 0;
  display: flex;
  align-items: flex-start;
}

.timeline .timeline-item:last-child .timeline-line {
  bottom: 100%;
}

.timeline .timeline-line {
  display: block;
  content: " ";
  justify-content: center;
  position: absolute;
  z-index: 0;
  left: 0;
  top: 0;
  bottom: 0;
  transform: translate(50%);
  border-left-width: 1px;
  border-left-style: dashed;
  border-left-color: var(--bs-gray-300);
}

.timeline .timeline-icon {
  z-index: 1;
  flex-shrink: 0;
  margin-right: 1rem;
}

.timeline .timeline-content {
  width: 100%;
  overflow: auto;
  margin-bottom: 1.5rem;
}

.timeline.timeline-center .timeline-item {
  align-items: center;
}

.timeline.timeline-center .timeline-item:first-child .timeline-line {
  top: 50%;
}

.timeline.timeline-center .timeline-item:last-child .timeline-line {
  bottom: 50%;
}

.timeline-label {
  position: relative;
}

.timeline-label:before {
  content: "";
  position: absolute;
  left: 51px;
  width: 3px;
  top: 0;
  bottom: 0;
  background-color: var(--bs-gray-200);
}

.timeline-label .timeline-item {
  display: flex;
  align-items: flex-start;
  position: relative;
  margin-bottom: 1.7rem;
}

.timeline-label .timeline-item:last-child {
  margin-bottom: 0;
}

.timeline-label .timeline-label {
  width: 50px;
  flex-shrink: 0;
  position: relative;
  color: var(--bs-gray-800);
}

.timeline-label .timeline-badge {
  flex-shrink: 0;
  background-color: var(--bs-body-bg);
  width: 1rem;
  height: 1rem;
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 1;
  position: relative;
  margin-top: 1px;
  margin-left: -0.5rem;
  padding: 3px !important;
  border: 6px solid var(--bs-body-bg) !important;
}

.timeline-label .timeline-content {
  flex-grow: 1;
}

.overlay {
  position: relative;
}

.overlay .overlay-layer {
  position: absolute;
  top: 0;
  bottom: 0;
  left: 0;
  right: 0;
  display: flex;
  justify-content: center;
  align-items: center;
  background-color: var(--bs-overlay-bg);
  transition: all 0.3s ease;
  opacity: 0;
}

.overlay.overlay-show .overlay-layer, .overlay.overlay-block .overlay-layer, .overlay:hover .overlay-layer {
  transition: all 0.3s ease;
  opacity: 1;
}

.overlay.overlay-block {
  cursor: wait;
}

.bullet {
  display: inline-block;
  background-color: var(--bs-bullet-bg-color);
  border-radius: 6px;
  width: 8px;
  height: 4px;
  flex-shrink: 0;
}

.bullet-dot {
  width: 4px;
  height: 4px;
  border-radius: 100% !important;
}

.bullet-vertical {
  width: 4px;
  height: 8px;
}

.bullet-line {
  width: 5px;
  height: 1px;
  border-radius: 0;
}

.drawer {
  display: flex !important;
  overflow: auto;
  z-index: 110;
  position: fixed;
  top: 0;
  bottom: 0;
  background-color: var(--bs-drawer-bg-color);
  transition: transform 0.3s ease-in-out !important;
}

.drawer.drawer-start {
  left: 0;
  transform: translateX(-100%);
}

.drawer.drawer-end {
  right: 0;
  transform: translateX(100%);
}

.drawer.drawer-on {
  transform: none;
  box-shadow: var(--bs-drawer-box-shadow);
  transition: transform 0.3s ease-in-out !important;
}

.drawer-overlay {
  position: fixed;
  top: 0;
  left: 0;
  bottom: 0;
  right: 0;
  overflow: hidden;
  z-index: 109;
  background-color: var(--bs-drawer-overlay-bg-color);
  animation: animation-drawer-fade-in 0.3s ease-in-out 1;
}

[data-kt-drawer=true] {
  display: none;
}

@keyframes animation-drawer-fade-in {
  from {
    opacity: 0;
  }
  to {
    opacity: 1;
  }
}
@media (max-width: 991.98px) {
  body[data-kt-drawer=on] {
    overflow: hidden;
  }
}
.badge {
  display: inline-flex;
  align-items: center;
}

.badge.badge-circle, .badge.badge-square {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  height: 1.75rem;
  min-width: 1.75rem;
  padding: 0 0.1rem;
  line-height: 0;
}

.badge.badge-circle {
  border-radius: 50%;
  padding: 0;
  min-width: unset;
  width: 1.75rem;
}

.badge.badge-sm {
  min-width: 1.5rem;
  font-size: 0.8rem;
}

.badge.badge-sm.badge-square {
  height: 1.5rem;
}

.badge.badge-sm.badge-circle {
  width: 1.5rem;
  height: 1.5rem;
}

.badge.badge-lg {
  min-width: 2rem;
  font-size: 1rem;
}

.badge.badge-lg.badge-square {
  height: 2rem;
}

.badge.badge-lg.badge-circle {
  width: 2rem;
  height: 2rem;
}

.badge-light {
  color: var(--bs-light-inverse);
  background-color: var(--bs-light);
}

.badge-light.badge-outline {
  border: 1px solid var(--bs-light);
  color: var(--bs-light);
  background-color: transparent;
}

.badge-light-light {
  color: var(--bs-light);
  background-color: var(--bs-light-light);
}

.badge-primary {
  color: var(--bs-primary-inverse);
  background-color: var(--bs-primary);
}

.badge-primary.badge-outline {
  border: 1px solid var(--bs-primary);
  color: var(--bs-primary);
  background-color: transparent;
}

.badge-light-primary {
  color: var(--bs-primary);
  background-color: var(--bs-primary-light);
}

.badge-secondary {
  color: var(--bs-secondary-inverse);
  background-color: var(--bs-secondary);
}

.badge-secondary.badge-outline {
  border: 1px solid var(--bs-secondary);
  color: var(--bs-secondary);
  background-color: transparent;
}

.badge-light-secondary {
  color: var(--bs-secondary);
  background-color: var(--bs-secondary-light);
}

.badge-success {
  color: var(--bs-success-inverse);
  background-color: var(--bs-success);
}

.badge-success.badge-outline {
  border: 1px solid var(--bs-success);
  color: var(--bs-success);
  background-color: transparent;
}

.badge-light-success {
  color: var(--bs-success);
  background-color: var(--bs-success-light);
}

.badge-info {
  color: var(--bs-info-inverse);
  background-color: var(--bs-info);
}

.badge-info.badge-outline {
  border: 1px solid var(--bs-info);
  color: var(--bs-info);
  background-color: transparent;
}

.badge-light-info {
  color: var(--bs-info);
  background-color: var(--bs-info-light);
}

.badge-warning {
  color: var(--bs-warning-inverse);
  background-color: var(--bs-warning);
}

.badge-warning.badge-outline {
  border: 1px solid var(--bs-warning);
  color: var(--bs-warning);
  background-color: transparent;
}

.badge-light-warning {
  color: var(--bs-warning);
  background-color: var(--bs-warning-light);
}

.badge-danger {
  color: var(--bs-danger-inverse);
  background-color: var(--bs-danger);
}

.badge-danger.badge-outline {
  border: 1px solid var(--bs-danger);
  color: var(--bs-danger);
  background-color: transparent;
}

.badge-light-danger {
  color: var(--bs-danger);
  background-color: var(--bs-danger-light);
}

.badge-dark {
  color: var(--bs-dark-inverse);
  background-color: var(--bs-dark);
}

.badge-dark.badge-outline {
  border: 1px solid var(--bs-dark);
  color: var(--bs-dark);
  background-color: transparent;
}

.badge-light-dark {
  color: var(--bs-dark);
  background-color: var(--bs-dark-light);
}

.indicator-progress {
  display: none;
}

[data-kt-indicator=on] > .indicator-progress {
  display: inline-block;
}

[data-kt-indicator=on] > .indicator-label {
  display: none;
}

.hover-elevate-up {
  transition: transform 0.3s ease;
}

.hover-elevate-up:hover {
  transform: translateY(-2.5%);
  transition: transform 0.3s ease;
  will-change: transform;
}

.hover-elevate-down {
  transition: transform 0.3s ease;
}

.hover-elevate-down:hover {
  transform: translateY(2.5%);
  transition: transform 0.3s ease;
  will-change: transform;
}

.hover-scale {
  transition: transform 0.3s ease;
}

.hover-scale:hover {
  transform: scale(1.1);
  transition: transform 0.3s ease;
  will-change: transform;
}

.hover-rotate-end {
  transition: transform 0.3s ease;
}

.hover-rotate-end:hover {
  transform: rotate(4deg);
  transition: transform 0.3s ease;
  will-change: transform;
}

.hover-rotate-start {
  transition: transform 0.3s ease;
}

.hover-rotate-start:hover {
  transform: rotate(-4deg);
  transition: transform 0.3s ease;
  will-change: transform;
}

.rotate {
  display: inline-flex;
  align-items: center;
}

.rotate-90 {
  transition: transform 0.3s ease;
  backface-visibility: hidden;
  will-change: transform;
}

.collapsible:not(.collapsed) > .rotate-90, .show > .rotate-90, .active > .rotate-90 {
  transform: rotateZ(90deg);
  transition: transform 0.3s ease;
}

[direction=rtl] .collapsible:not(.collapsed) > .rotate-90, [direction=rtl] .show > .rotate-90, [direction=rtl] .active > .rotate-90 {
  transform: rotateZ(-90deg);
}

.rotate-n90 {
  transition: transform 0.3s ease;
  backface-visibility: hidden;
  will-change: transform;
}

.collapsible:not(.collapsed) > .rotate-n90, .show > .rotate-n90, .active > .rotate-n90 {
  transform: rotateZ(-90deg);
  transition: transform 0.3s ease;
}

[direction=rtl] .collapsible:not(.collapsed) > .rotate-n90, [direction=rtl] .show > .rotate-n90, [direction=rtl] .active > .rotate-n90 {
  transform: rotateZ(90deg);
}

.rotate-180 {
  transition: transform 0.3s ease;
  backface-visibility: hidden;
  will-change: transform;
}

.collapsible:not(.collapsed) > .rotate-180, .show > .rotate-180, .active > .rotate-180 {
  transform: rotateZ(180deg);
  transition: transform 0.3s ease;
}

[direction=rtl] .collapsible:not(.collapsed) > .rotate-180, [direction=rtl] .show > .rotate-180, [direction=rtl] .active > .rotate-180 {
  transform: rotateZ(-180deg);
}

.rotate-n180 {
  transition: transform 0.3s ease;
  backface-visibility: hidden;
  will-change: transform;
}

.collapsible:not(.collapsed) > .rotate-n180, .show > .rotate-n180, .active > .rotate-n180 {
  transform: rotateZ(-180deg);
  transition: transform 0.3s ease;
}

[direction=rtl] .collapsible:not(.collapsed) > .rotate-n180, [direction=rtl] .show > .rotate-n180, [direction=rtl] .active > .rotate-n180 {
  transform: rotateZ(180deg);
}

.rotate-270 {
  transition: transform 0.3s ease;
  backface-visibility: hidden;
  will-change: transform;
}

.collapsible:not(.collapsed) > .rotate-270, .show > .rotate-270, .active > .rotate-270 {
  transform: rotateZ(270deg);
  transition: transform 0.3s ease;
}

[direction=rtl] .collapsible:not(.collapsed) > .rotate-270, [direction=rtl] .show > .rotate-270, [direction=rtl] .active > .rotate-270 {
  transform: rotateZ(-270deg);
}

.rotate-n270 {
  transition: transform 0.3s ease;
  backface-visibility: hidden;
  will-change: transform;
}

.collapsible:not(.collapsed) > .rotate-n270, .show > .rotate-n270, .active > .rotate-n270 {
  transform: rotateZ(-270deg);
  transition: transform 0.3s ease;
}

[direction=rtl] .collapsible:not(.collapsed) > .rotate-n270, [direction=rtl] .show > .rotate-n270, [direction=rtl] .active > .rotate-n270 {
  transform: rotateZ(270deg);
}

@media (min-width: 992px) {
  main,
  span,
  ol,
  ul,
  pre,
  div {
    scrollbar-width: thin;
    scrollbar-color: var(--bs-scrollbar-color) transparent;
  }
  main::-webkit-scrollbar,
  span::-webkit-scrollbar,
  ol::-webkit-scrollbar,
  ul::-webkit-scrollbar,
  pre::-webkit-scrollbar,
  div::-webkit-scrollbar {
    width: var(--bs-scrollbar-size);
    height: var(--bs-scrollbar-size);
  }
  main ::-webkit-scrollbar-track,
  span ::-webkit-scrollbar-track,
  ol ::-webkit-scrollbar-track,
  ul ::-webkit-scrollbar-track,
  pre ::-webkit-scrollbar-track,
  div ::-webkit-scrollbar-track {
    background-color: transparent;
  }
  main ::-webkit-scrollbar-thumb,
  span ::-webkit-scrollbar-thumb,
  ol ::-webkit-scrollbar-thumb,
  ul ::-webkit-scrollbar-thumb,
  pre ::-webkit-scrollbar-thumb,
  div ::-webkit-scrollbar-thumb {
    border-radius: var(--bs-scrollbar-size);
  }
  main::-webkit-scrollbar-thumb,
  span::-webkit-scrollbar-thumb,
  ol::-webkit-scrollbar-thumb,
  ul::-webkit-scrollbar-thumb,
  pre::-webkit-scrollbar-thumb,
  div::-webkit-scrollbar-thumb {
    background-color: var(--bs-scrollbar-color);
  }
  main::-webkit-scrollbar-corner,
  span::-webkit-scrollbar-corner,
  ol::-webkit-scrollbar-corner,
  ul::-webkit-scrollbar-corner,
  pre::-webkit-scrollbar-corner,
  div::-webkit-scrollbar-corner {
    background-color: transparent;
  }
  main:hover,
  span:hover,
  ol:hover,
  ul:hover,
  pre:hover,
  div:hover {
    scrollbar-color: var(--bs-scrollbar-hover-color) transparent;
  }
  main:hover::-webkit-scrollbar-thumb,
  span:hover::-webkit-scrollbar-thumb,
  ol:hover::-webkit-scrollbar-thumb,
  ul:hover::-webkit-scrollbar-thumb,
  pre:hover::-webkit-scrollbar-thumb,
  div:hover::-webkit-scrollbar-thumb {
    background-color: var(--bs-scrollbar-hover-color);
  }
  main:hover::-webkit-scrollbar-corner,
  span:hover::-webkit-scrollbar-corner,
  ol:hover::-webkit-scrollbar-corner,
  ul:hover::-webkit-scrollbar-corner,
  pre:hover::-webkit-scrollbar-corner,
  div:hover::-webkit-scrollbar-corner {
    background-color: transparent;
  }
}
.scroll {
  overflow: scroll;
  position: relative;
}

@media (max-width: 991.98px) {
  .scroll {
    overflow: auto;
  }
}
.scroll-x {
  overflow-x: scroll;
  position: relative;
}

@media (max-width: 991.98px) {
  .scroll-x {
    overflow-x: auto;
  }
}
.scroll-y {
  overflow-y: scroll;
  position: relative;
}

@media (max-width: 991.98px) {
  .scroll-y {
    overflow-y: auto;
  }
}
.hover-scroll,
.hover-scroll-overlay {
  position: relative;
}

@media (min-width: 992px) {
  .hover-scroll,
  .hover-scroll-overlay {
    overflow: hidden;
  }
  @-moz-document url-prefix() {
    .hover-scroll,
    .hover-scroll-overlay {
      overflow: scroll;
    }
  }
  .safari-mode .hover-scroll,
  .safari-mode .hover-scroll-overlay {
    overflow: scroll;
  }
  .hover-scroll::-webkit-scrollbar,
  .hover-scroll-overlay::-webkit-scrollbar {
    width: var(--bs-scrollbar-overlay-size);
    height: var(--bs-scrollbar-overlay-size);
  }
  .hover-scroll::-webkit-scrollbar-thumb,
  .hover-scroll-overlay::-webkit-scrollbar-thumb {
    background-clip: content-box;
    border: var(--bs-scrollbar-overlay-space) solid transparent;
    border-radius: var(--bs-scrollbar-overlay-size);
  }
  .hover-scroll:hover,
  .hover-scroll-overlay:hover {
    overflow: overlay;
  }
}
@media (max-width: 991.98px) {
  .hover-scroll,
  .hover-scroll-overlay {
    overflow: auto;
  }
}
.hover-scroll-y,
.hover-scroll-overlay-y {
  position: relative;
}

@media (min-width: 992px) {
  .hover-scroll-y,
  .hover-scroll-overlay-y {
    overflow-y: hidden;
  }
  @-moz-document url-prefix() {
    .hover-scroll-y,
    .hover-scroll-overlay-y {
      overflow-y: scroll;
    }
  }
  .safari-mode .hover-scroll-y,
  .safari-mode .hover-scroll-overlay-y {
    overflow-y: scroll;
  }
  .hover-scroll-y::-webkit-scrollbar,
  .hover-scroll-overlay-y::-webkit-scrollbar {
    width: var(--bs-scrollbar-overlay-size);
  }
  .hover-scroll-y::-webkit-scrollbar-thumb,
  .hover-scroll-overlay-y::-webkit-scrollbar-thumb {
    background-clip: content-box;
    border: var(--bs-scrollbar-overlay-space) solid transparent;
    border-radius: var(--bs-scrollbar-overlay-size);
  }
  .hover-scroll-y:hover,
  .hover-scroll-overlay-y:hover {
    overflow-y: overlay;
  }
}
@media (max-width: 991.98px) {
  .hover-scroll-y,
  .hover-scroll-overlay-y {
    overflow-y: auto;
  }
}
.hover-scroll-x,
.hover-scroll-overlay-x {
  position: relative;
}

@media (min-width: 992px) {
  .hover-scroll-x,
  .hover-scroll-overlay-x {
    overflow-x: hidden;
  }
  @-moz-document url-prefix() {
    .hover-scroll-x,
    .hover-scroll-overlay-x {
      overflow-x: scroll;
    }
  }
  .safari-mode .hover-scroll-x,
  .safari-mode .hover-scroll-overlay-x {
    overflow-x: scroll;
  }
  .hover-scroll-x::-webkit-scrollbar,
  .hover-scroll-overlay-x::-webkit-scrollbar {
    height: var(--bs-scrollbar-overlay-size);
  }
  .hover-scroll-x::-webkit-scrollbar-thumb,
  .hover-scroll-overlay-x::-webkit-scrollbar-thumb {
    background-clip: content-box;
    border: var(--bs-scrollbar-overlay-space) solid transparent;
    border-radius: var(--bs-scrollbar-overlay-size);
  }
  .hover-scroll-x:hover,
  .hover-scroll-overlay-x:hover {
    overflow-x: overlay;
  }
}
@media (max-width: 991.98px) {
  .hover-scroll-x,
  .hover-scroll-overlay-x {
    overflow-x: auto;
  }
}
.scroll-ps {
  padding-left: var(--bs-scrollbar-size) !important;
}

.scroll-ms {
  margin-left: var(--bs-scrollbar-size) !important;
}

.scroll-mb {
  margin-bottom: var(--bs-scrollbar-size) !important;
}

.scroll-pe {
  padding-right: var(--bs-scrollbar-size) !important;
}

.scroll-me {
  margin-right: var(--bs-scrollbar-size) !important;
}

.scroll-px {
  padding-left: var(--bs-scrollbar-size) !important;
  padding-right: var(--bs-scrollbar-size) !important;
}

.scroll-mx {
  margin-left: var(--bs-scrollbar-size) !important;
  margin-right: var(--bs-scrollbar-size) !important;
}

.rating {
  display: flex;
  align-items: center;
}

.rating-input {
  position: absolute !important;
  left: -9999px !important;
}

.rating-input[disabled] {
  display: none;
}

.rating-label {
  padding: 0;
  margin: 0;
}

.rating-label > i, .rating-label > .svg-icon {
  line-height: 1;
  color: var(--bs-rating-color-default);
}

label.rating-label {
  cursor: pointer;
}

div.rating-label.checked > i, div.rating-label.checked > .svg-icon,
label.rating-label > i,
label.rating-label > .svg-icon {
  color: var(--bs-rating-color-active);
}

.rating-input:checked ~ .rating-label > i, .rating-input:checked ~ .rating-label > .svg-icon {
  color: var(--bs-rating-color-default);
}

.rating:hover label.rating-label > i, .rating:hover label.rating-label > .svg-icon {
  color: var(--bs-rating-color-active);
}

label.rating-label:hover ~ .rating-label {
  color: var(--bs-rating-color-default);
}

label.rating-label:hover ~ .rating-label > i, label.rating-label:hover ~ .rating-label > .svg-icon {
  color: var(--bs-rating-color-default);
}

.stepper [data-kt-stepper-element=info],
.stepper [data-kt-stepper-element=content] {
  display: none;
}

.stepper [data-kt-stepper-element=info].current,
.stepper [data-kt-stepper-element=content].current {
  display: flex;
}

.stepper .stepper-item[data-kt-stepper-action=step] {
  cursor: pointer;
}

.stepper [data-kt-stepper-action=final] {
  display: none;
}

.stepper [data-kt-stepper-action=previous] {
  display: none;
}

.stepper [data-kt-stepper-action=next] {
  display: inline-block;
}

.stepper [data-kt-stepper-action=submit] {
  display: none;
}

.stepper.first [data-kt-stepper-action=previous] {
  display: none;
}

.stepper.first [data-kt-stepper-action=next] {
  display: inline-block;
}

.stepper.first [data-kt-stepper-action=submit] {
  display: none;
}

.stepper.between [data-kt-stepper-action=previous] {
  display: inline-block;
}

.stepper.between [data-kt-stepper-action=next] {
  display: inline-block;
}

.stepper.between [data-kt-stepper-action=submit] {
  display: none;
}

.stepper.last [data-kt-stepper-action=final] {
  display: inline-block;
}

.stepper.last [data-kt-stepper-action=final].btn-flex {
  display: flex;
}

.stepper.last [data-kt-stepper-action=previous] {
  display: inline-block;
}

.stepper.last [data-kt-stepper-action=previous].btn-flex {
  display: flex;
}

.stepper.last [data-kt-stepper-action=next] {
  display: none;
}

.stepper.last [data-kt-stepper-action=next].btn-flex {
  display: flex;
}

.stepper.last [data-kt-stepper-action=submit] {
  display: inline-block;
}

.stepper.last [data-kt-stepper-action=submit].btn-flex {
  display: flex;
}

.stepper.stepper-pills {
  --bs-stepper-pills-size: 40px;
  --bs-stepper-icon-border-radius: 9px;
  --bs-stepper-icon-check-size: 1rem;
  --bs-stepper-icon-bg-color: var(--bs-primary-light);
  --bs-stepper-icon-bg-color-current: var(--bs-primary);
  --bs-stepper-icon-bg-color-completed: var(--bs-primary-light);
  --bs-stepper-icon-border: 0;
  --bs-stepper-icon-border-current: 0;
  --bs-stepper-icon-border-completed: 0;
  --bs-stepper-icon-number-color: var(--bs-primary);
  --bs-stepper-icon-number-color-current: var(--bs-white);
  --bs-stepper-icon-check-color-completed: var(--bs-primary);
  --bs-stepper-label-title-opacity: 1;
  --bs-stepper-label-title-opacity-current: 1;
  --bs-stepper-label-title-opacity-completed: 1;
  --bs-stepper-label-title-color: var(--bs-gray-800);
  --bs-stepper-label-title-color-current: var(--bs-gray-600);
  --bs-stepper-label-title-color-completed: var(--bs-text-muted);
  --bs-stepper-label-desc-opacity: 1;
  --bs-stepper-label-desc-opacity-current: 1;
  --bs-stepper-label-desc-opacity-completed: 1;
  --bs-stepper-label-desc-color: var(--bs-text-muted);
  --bs-stepper-label-desc-color-current: var(--bs-gray-400);
  --bs-stepper-label-desc-color-completed: var(--bs-gray-400);
  --bs-stepper-line-border: 1px dashed var(--bs-gray-300);
}

.stepper.stepper-pills .stepper-nav {
  display: flex;
}

.stepper.stepper-pills .stepper-item {
  display: flex;
  align-items: center;
  transition: color 0.2s ease;
}

.stepper.stepper-pills .stepper-item .stepper-icon {
  display: flex;
  align-items: center;
  justify-content: center;
  flex-shrink: 0;
  transition: color 0.2s ease;
  width: var(--bs-stepper-pills-size);
  height: var(--bs-stepper-pills-size);
  border-radius: var(--bs-stepper-icon-border-radius);
  background-color: var(--bs-stepper-icon-bg-color);
  border: var(--bs-stepper-icon-border);
  margin-right: 1.5rem;
}

.stepper.stepper-pills .stepper-item .stepper-icon .stepper-check {
  display: none;
  font-size: var(--bs-stepper-icon-check-size);
}

.stepper.stepper-pills .stepper-item .stepper-icon .stepper-number {
  font-weight: 600;
  color: var(--bs-stepper-icon-number-color);
  font-size: 1.25rem;
}

.stepper.stepper-pills .stepper-item .stepper-label {
  display: flex;
  flex-direction: column;
  justify-content: center;
}

.stepper.stepper-pills .stepper-item .stepper-label .stepper-title {
  color: var(--bs-stepper-label-title-color);
  opacity: var(--bs-stepper-label-title-opacity);
  font-weight: 600;
  font-size: 1.25rem;
  margin-bottom: 0.3rem;
}

.stepper.stepper-pills .stepper-item .stepper-label .stepper-desc {
  opacity: var(--bs-stepper-label-desc-opacity);
  color: var(--bs-stepper-label-desc-color);
}

.stepper.stepper-pills .stepper-item.current {
  transition: color 0.2s ease;
}

.stepper.stepper-pills .stepper-item.current .stepper-icon {
  transition: color 0.2s ease;
  background-color: var(--bs-stepper-icon-bg-color-current);
  border: var(--bs-stepper-icon-border-current);
}

.stepper.stepper-pills .stepper-item.current .stepper-icon .stepper-check {
  display: none;
}

.stepper.stepper-pills .stepper-item.current .stepper-icon .stepper-number {
  color: var(--bs-stepper-icon-number-color-current);
  font-size: 1.35rem;
}

.stepper.stepper-pills .stepper-item.current .stepper-label .stepper-title {
  opacity: var(--bs-stepper-label-title-opacity-current);
  color: var(--bs-stepper-label-title-color-current);
}

.stepper.stepper-pills .stepper-item.current .stepper-label .stepper-desc {
  opacity: var(--bs-stepper-label-desc-opacity-current);
  color: var(--bs-stepper-label-desc-color-current);
}

.stepper.stepper-pills .stepper-item.current.mark-completed:last-child .stepper-icon, .stepper.stepper-pills .stepper-item.completed .stepper-icon {
  transition: color 0.2s ease;
  background-color: var(--bs-stepper-icon-bg-color-completed);
  border: var(--bs-stepper-icon-border-completed);
}

.stepper.stepper-pills .stepper-item.current.mark-completed:last-child .stepper-icon .stepper-check, .stepper.stepper-pills .stepper-item.completed .stepper-icon .stepper-check {
  color: var(--bs-stepper-icon-check-color-completed);
  display: inline-block;
}

.stepper.stepper-pills .stepper-item.current.mark-completed:last-child .stepper-icon .stepper-number, .stepper.stepper-pills .stepper-item.completed .stepper-icon .stepper-number {
  display: none;
}

.stepper.stepper-pills .stepper-item.current.mark-completed:last-child .stepper-label .stepper-title, .stepper.stepper-pills .stepper-item.completed .stepper-label .stepper-title {
  opacity: var(--bs-stepper-label-title-opacity-completed);
  color: var(--bs-stepper-label-title-color-completed);
}

.stepper.stepper-pills .stepper-item.current.mark-completed:last-child .stepper-label .stepper-desc, .stepper.stepper-pills .stepper-item.completed .stepper-label .stepper-desc {
  opacity: var(--bs-stepper-label-desc-opacity-completed);
  color: var(--bs-stepper-label-desc-color-completed);
}

.stepper.stepper-pills.stepper-column .stepper-nav {
  flex-direction: column;
  align-items: start;
}

.stepper.stepper-pills.stepper-column .stepper-item {
  flex-direction: column;
  justify-content: start;
  align-items: stretch;
  padding: 0;
  margin: 0;
}

.stepper.stepper-pills.stepper-column .stepper-wrapper {
  display: flex;
  align-items: center;
}

.stepper.stepper-pills.stepper-column .stepper-icon {
  z-index: 1;
}

.stepper.stepper-pills.stepper-column .stepper-line {
  display: block;
  flex-grow: 1;
  margin-left: calc(var(--bs-stepper-pills-size) / 2);
  border-left: var(--bs-stepper-line-border);
  margin-top: 2px;
  margin-bottom: 2px;
}

.stepper.stepper-links .stepper-nav {
  display: flex;
  margin: 0 auto;
  justify-content: center;
  align-items: center;
  flex-wrap: wrap;
}

.stepper.stepper-links .stepper-nav .stepper-item {
  position: relative;
  flex-shrink: 0;
  margin: 1rem 1.5rem;
}

.stepper.stepper-links .stepper-nav .stepper-item:after {
  content: " ";
  position: absolute;
  top: 2.3rem;
  left: 0;
  height: 2px;
  width: 100%;
  background-color: transparent;
  transition: color 0.2s ease;
}

.stepper.stepper-links .stepper-nav .stepper-item .stepper-title {
  color: var(--bs-dark);
  font-weight: 600;
  font-size: 1.25rem;
}

.stepper.stepper-links .stepper-nav .stepper-item.current {
  transition: color 0.2s ease;
}

.stepper.stepper-links .stepper-nav .stepper-item.current .stepper-title {
  color: var(--bs-primary);
}

.stepper.stepper-links .stepper-nav .stepper-item.current:after {
  background-color: var(--bs-primary);
}

.stepper.stepper-links .stepper-nav .stepper-item.current.mark-completed:last-child .stepper-title, .stepper.stepper-links .stepper-nav .stepper-item.completed .stepper-title {
  color: var(--bs-gray-400);
}

.toggle.collapsible:not(.collapsed) .toggle-off, .toggle.active .toggle-off {
  display: none;
}

.toggle.collapsible.collapsed .toggle-on, .toggle:not(.collapsible):not(.active) .toggle-on {
  display: none;
}

.xehagon {
  clip-path: polygon(45% 1.3397459622%, 46.5797985667% 0.6030737921%, 48.2635182233% 0.1519224699%, 50% 0%, 51.7364817767% 0.1519224699%, 53.4202014333% 0.6030737921%, 55% 1.3397459622%, 89.6410161514% 21.3397459622%, 91.0688922482% 22.3395555688%, 92.3014605826% 23.5721239031%, 93.3012701892% 25%, 94.0379423592% 26.5797985667%, 94.4890936815% 28.2635182233%, 94.6410161514% 30%, 94.6410161514% 70%, 94.4890936815% 71.7364817767%, 94.0379423592% 73.4202014333%, 93.3012701892% 75%, 92.3014605826% 76.4278760969%, 91.0688922482% 77.6604444312%, 89.6410161514% 78.6602540378%, 55% 98.6602540378%, 53.4202014333% 99.3969262079%, 51.7364817767% 99.8480775301%, 50% 100%, 48.2635182233% 99.8480775301%, 46.5797985667% 99.3969262079%, 45% 98.6602540378%, 10.3589838486% 78.6602540378%, 8.9311077518% 77.6604444312%, 7.6985394174% 76.4278760969%, 6.6987298108% 75%, 5.9620576408% 73.4202014333%, 5.5109063185% 71.7364817767%, 5.3589838486% 70%, 5.3589838486% 30%, 5.5109063185% 28.2635182233%, 5.9620576408% 26.5797985667%, 6.6987298108% 25%, 7.6985394174% 23.5721239031%, 8.9311077518% 22.3395555688%, 10.3589838486% 21.3397459622%);
}

.octagon {
  clip-path: polygon(46.1731656763% 0.7612046749%, 47.411809549% 0.3407417371%, 48.6947380778% 0.0855513863%, 50% 0%, 51.3052619222% 0.0855513863%, 52.588190451% 0.3407417371%, 53.8268343237% 0.7612046749%, 82.1111055711% 12.4769334274%, 83.2842712475% 13.0554747147%, 84.3718855375% 13.7821953496%, 85.3553390593% 14.6446609407%, 86.2178046504% 15.6281144625%, 86.9445252853% 16.7157287525%, 87.5230665726% 17.8888944289%, 99.2387953251% 46.1731656763%, 99.6592582629% 47.411809549%, 99.9144486137% 48.6947380778%, 100% 50%, 99.9144486137% 51.3052619222%, 99.6592582629% 52.588190451%, 99.2387953251% 53.8268343237%, 87.5230665726% 82.1111055711%, 86.9445252853% 83.2842712475%, 86.2178046504% 84.3718855375%, 85.3553390593% 85.3553390593%, 84.3718855375% 86.2178046504%, 83.2842712475% 86.9445252853%, 82.1111055711% 87.5230665726%, 53.8268343237% 99.2387953251%, 52.588190451% 99.6592582629%, 51.3052619222% 99.9144486137%, 50% 100%, 48.6947380778% 99.9144486137%, 47.411809549% 99.6592582629%, 46.1731656763% 99.2387953251%, 17.8888944289% 87.5230665726%, 16.7157287525% 86.9445252853%, 15.6281144625% 86.2178046504%, 14.6446609407% 85.3553390593%, 13.7821953496% 84.3718855375%, 13.0554747147% 83.2842712475%, 12.4769334274% 82.1111055711%, 0.7612046749% 53.8268343237%, 0.3407417371% 52.588190451%, 0.0855513863% 51.3052619222%, 0% 50%, 0.0855513863% 48.6947380778%, 0.3407417371% 47.411809549%, 0.7612046749% 46.1731656763%, 12.4769334274% 17.8888944289%, 13.0554747147% 16.7157287525%, 13.7821953496% 15.6281144625%, 14.6446609407% 14.6446609407%, 15.6281144625% 13.7821953496%, 16.7157287525% 13.0554747147%, 17.8888944289% 12.4769334274%);
}

.ribbon {
  position: relative;
}

.ribbon .ribbon-label {
  display: flex;
  justify-content: center;
  align-items: center;
  padding: 5px 10px;
  position: absolute;
  z-index: 1;
  background-color: var(--bs-ribbon-label-bg);
  box-shadow: var(--bs-ribbon-label-box-shadow);
  color: var(--bs-primary-inverse);
  top: 50%;
  right: 0;
  transform: translateX(5px) translateY(-50%);
}

.ribbon .ribbon-label > .ribbon-inner {
  z-index: -1;
  position: absolute;
  padding: 0;
  width: 100%;
  height: 100%;
  top: 0;
  left: 0;
}

.ribbon .ribbon-label:after {
  border-color: var(--bs-ribbon-label-border-color);
}

.ribbon-vertical .ribbon-label {
  padding: 5px 10px;
  min-width: 36px;
  min-height: 46px;
  text-align: center;
}

.ribbon.ribbon-top .ribbon-label {
  top: 0;
  transform: translateX(-15px) translateY(-4px);
  border-bottom-right-radius: 0.475rem;
  border-bottom-left-radius: 0.475rem;
}

.ribbon.ribbon-bottom .ribbon-label {
  border-top-right-radius: 0.475rem;
  border-top-left-radius: 0.475rem;
}

.ribbon.ribbon-start .ribbon-label {
  top: 50%;
  left: 0;
  right: auto;
  transform: translateX(-5px) translateY(-50%);
  border-top-right-radius: 0.475rem;
  border-bottom-right-radius: 0.475rem;
}

.ribbon.ribbon-end .ribbon-label {
  border-top-left-radius: 0.475rem;
  border-bottom-left-radius: 0.475rem;
}

.ribbon.ribbon-clip.ribbon-start .ribbon-label {
  left: -5px;
}

.ribbon.ribbon-clip.ribbon-start .ribbon-label .ribbon-inner {
  border-top-right-radius: 0.475rem;
  border-bottom-right-radius: 0.475rem;
}

.ribbon.ribbon-clip.ribbon-start .ribbon-label .ribbon-inner:before, .ribbon.ribbon-clip.ribbon-start .ribbon-label .ribbon-inner:after {
  content: "";
  position: absolute;
  border-style: solid;
  border-color: transparent !important;
  bottom: -10px;
}

.ribbon.ribbon-clip.ribbon-start .ribbon-label .ribbon-inner:before {
  border-width: 0 10px 10px 0;
  border-right-color: var(--bs-ribbon-clip-bg) !important;
  left: 0;
}

.ribbon.ribbon-clip.ribbon-end .ribbon-label {
  right: -5px;
}

.ribbon.ribbon-clip.ribbon-end .ribbon-label .ribbon-inner {
  border-top-left-radius: 0.475rem;
  border-bottom-left-radius: 0.475rem;
}

.ribbon.ribbon-clip.ribbon-end .ribbon-label .ribbon-inner:before, .ribbon.ribbon-clip.ribbon-end .ribbon-label .ribbon-inner:after {
  content: "";
  position: absolute;
  border-style: solid;
  border-color: transparent !important;
  bottom: -10px;
}

.ribbon.ribbon-clip.ribbon-end .ribbon-label .ribbon-inner:before {
  border-width: 0 0 10px 10px;
  border-left-color: var(--bs-ribbon-clip-bg) !important;
  right: 0;
}

.ribbon.ribbon-triangle {
  position: absolute;
  z-index: 1;
  display: flex;
  align-items: flex-start;
  justify-content: flex-start;
}

.ribbon.ribbon-triangle.ribbon-top-start {
  top: 0;
  left: 0;
  width: 4rem;
  height: 4rem;
  border-bottom: solid 2rem transparent !important;
  border-left: solid 2rem transparent;
  border-right: solid 2rem transparent !important;
  border-top: solid 2rem transparent;
}

.ribbon.ribbon-triangle.ribbon-top-end {
  top: 0;
  right: 0;
  width: 4rem;
  height: 4rem;
  border-bottom: solid 2rem transparent !important;
  border-left: solid 2rem transparent !important;
  border-right: solid 2rem transparent;
  border-top: solid 2rem transparent;
}

.ribbon.ribbon-triangle.ribbon-bottom-start {
  bottom: 0;
  left: 0;
  width: 4rem;
  height: 4rem;
  border-bottom: solid 2rem transparent;
  border-left: solid 2rem transparent;
  border-right: solid 2rem transparent !important;
  border-top: solid 2rem transparent !important;
}

.ribbon.ribbon-triangle.ribbon-bottom-end {
  bottom: 0;
  right: 0;
  width: 4rem;
  height: 4rem;
  border-bottom: solid 2rem transparent;
  border-right: solid 2rem transparent;
  border-left: solid 2rem transparent !important;
  border-top: solid 2rem transparent !important;
}

.blockui {
  position: relative;
}

.blockui .blockui-overlay {
  transition: all 0.3s ease;
  position: absolute;
  top: 0;
  bottom: 0;
  left: 0;
  right: 0;
  display: flex;
  justify-content: center;
  align-items: center;
  background-color: var(--bs-blockui-overlay-bg);
}

.blockui .blockui-overlay .spinner-border {
  height: 1.35rem;
  width: 1.35rem;
}

.blockui .blockui-message {
  display: flex;
  align-items: center;
  border-radius: 0.475rem;
  box-shadow: var(--bs-blockui-message-box-shadow);
  background-color: var(--bs-blockui-message-bg);
  color: var(--bs-gray-700);
  font-weight: 600;
  margin: 0 !important;
  width: auto;
  padding: 0.85rem 1.75rem !important;
}

.blockui .blockui-message .spinner-border {
  margin-right: 0.65rem;
}

[data-bs-theme=dark] .blockui {
  --bs-blockui-overlay-bg: rgba(255, 255, 255, 0.05);
  --bs-blockui-message-bg: #2B2B40;
  --bs-blockui-message-box-shadow: 0px 0px 30px rgba(0, 0, 0, 0.15);
}

.explore-btn-toggle {
  color: var(--bs-gray-600);
  background-color: #ffffff;
}

.explore-btn-toggle:hover, .explore-btn-toggle:focus, .explore-btn-toggle:active {
  color: #ffffff;
  background-color: #00B2FF;
}

.explore-btn-dismiss {
  border: 0;
}

.explore-btn-dismiss:hover i,
.explore-btn-dismiss:hover .svg-icon {
  color: #00B2FF;
}

.explore-btn-primary {
  border: 0;
  color: #ffffff;
  background-color: #00B2FF;
}

.explore-btn-primary:hover {
  color: #ffffff;
  background-color: #0098DA;
}

.explore-btn-secondary {
  border: 0;
  color: var(--bs-gray-600);
  background-color: var(--bs-gray-100);
}

.explore-btn-secondary:hover {
  color: var(--bs-gray-800);
  background-color: var(--bs-gray-200);
}

.explore-btn-outline {
  border: 1px dashed var(--bs-gray-300) !important;
}

.explore-btn-outline:hover, .explore-btn-outline.active {
  border: 1px dashed #50CD89 !important;
  background-color: #E8FFF3;
}

.explore-link {
  color: #00B2FF;
}

.explore-link:hover {
  color: #0098DA;
}

.explore-link-hover:hover {
  color: #00B2FF !important;
}

.explore-icon-success {
  color: #50CD89;
}

.explore-icon-danger {
  color: #F1416C;
}

.explore-label-free {
  color: #ffffff;
  background-color: #FFC700;
}

.explore-label-pro {
  color: #ffffff;
  background-color: #50CD89;
}

.app-engage {
  position: fixed;
  right: 0;
  top: 50%;
  transform: translateY(-50%);
  display: flex;
  flex-direction: column;
  align-items: flex-end;
  z-index: 5;
  padding-right: 12px;
}

.app-engage .app-engage-btn {
  display: flex;
  align-items: center;
  justify-content: center;
  flex-direction: column;
  box-shadow: var(--bs-engage-btn-box-shadow);
  border-width: 1px;
  border-style: solid;
  font-size: 12px;
  font-weight: 600;
  margin-bottom: 8px;
  border-radius: 6px;
  width: 66px;
  height: 70px;
  color: var(--bs-engage-btn-color);
  border-color: var(--bs-engage-btn-border-color);
  background-color: var(--bs-engage-btn-bg);
}

.app-engage .app-engage-btn i,
.app-engage .app-engage-btn .svg-icon {
  color: var(--bs-engage-btn-icon-color);
}

.app-engage .app-engage-btn.dropdown-toggle:after {
  color: var(--bs-engage-btn-icon-color);
}

.app-engage .app-engage-btn.hover-dark:hover {
  color: var(--bs-dark-inverse);
  border-color: var(--bs-dark);
  background-color: var(--bs-dark);
}

.app-engage .app-engage-btn.hover-dark:hover i,
.app-engage .app-engage-btn.hover-dark:hover .svg-icon {
  color: var(--bs-dark-inverse);
}

.app-engage .app-engage-btn.hover-primary:hover {
  color: var(--bs-primary-inverse);
  border-color: var(--bs-primary);
  background-color: var(--bs-primary);
}

.app-engage .app-engage-btn.hover-primary:hover i,
.app-engage .app-engage-btn.hover-primary:hover .svg-icon {
  color: var(--bs-primary-inverse);
}

.app-engage .app-engage-btn.hover-success:hover {
  color: var(--bs-success-inverse);
  border-color: var(--bs-success);
  background-color: var(--bs-success);
}

.app-engage .app-engage-btn.hover-success:hover i,
.app-engage .app-engage-btn.hover-success:hover .svg-icon {
  color: var(--bs-success-inverse);
}

.app-engage .app-engage-btn.app-engage-btn-toggle-off {
  width: 35px;
  height: 35px;
}

.app-engage .app-engage-btn.app-engage-btn-toggle-on {
  width: 35px;
  height: 35px;
  display: none;
}

.app-engage.app-engage-hide .app-engage-btn {
  visibility: hidden;
}

.app-engage.app-engage-hide .app-engage-btn.app-engage-btn-toggle-off {
  display: none;
}

.app-engage.app-engage-hide .app-engage-btn.app-engage-btn-toggle-on {
  visibility: visible;
  display: flex;
}

.engage-btn {
  display: flex;
  align-items: center;
  height: 35px !important;
  color: var(--bs-engage-btn-color);
  border-color: var(--bs-engage-btn-bg);
  background-color: var(--bs-engage-btn-bg);
}

.engage-btn i,
.engage-btn .svg-icon {
  color: var(--bs-engage-btn-color);
}

.engage-btn.dropdown-toggle:after {
  color: var(--bs-engage-btn-color);
}

.btn-check:checked + .engage-btn, .btn-check:active + .engage-btn, .engage-btn:focus:not(.btn-active), .engage-btn:hover:not(.btn-active), .engage-btn:active:not(.btn-active), .engage-btn.active, .engage-btn.show, .show > .engage-btn {
  color: var(--bs-engage-btn-color-active);
  border-color: var(--bs-engage-btn-bg);
  background-color: var(--bs-engage-btn-bg) !important;
}

.btn-check:checked + .engage-btn i,
.btn-check:checked + .engage-btn .svg-icon, .btn-check:active + .engage-btn i,
.btn-check:active + .engage-btn .svg-icon, .engage-btn:focus:not(.btn-active) i,
.engage-btn:focus:not(.btn-active) .svg-icon, .engage-btn:hover:not(.btn-active) i,
.engage-btn:hover:not(.btn-active) .svg-icon, .engage-btn:active:not(.btn-active) i,
.engage-btn:active:not(.btn-active) .svg-icon, .engage-btn.active i,
.engage-btn.active .svg-icon, .engage-btn.show i,
.engage-btn.show .svg-icon, .show > .engage-btn i,
.show > .engage-btn .svg-icon {
  color: var(--bs-engage-btn-color-active);
}

.btn-check:checked + .engage-btn.dropdown-toggle:after, .btn-check:active + .engage-btn.dropdown-toggle:after, .engage-btn:focus:not(.btn-active).dropdown-toggle:after, .engage-btn:hover:not(.btn-active).dropdown-toggle:after, .engage-btn:active:not(.btn-active).dropdown-toggle:after, .engage-btn.active.dropdown-toggle:after, .engage-btn.show.dropdown-toggle:after, .show > .engage-btn.dropdown-toggle:after {
  color: var(--bs-engage-btn-color-active);
}

.cookiealert {
  background: inherit;
  color: inherit;
}

@media print {
  .print-content-only {
    padding: 0 !important;
    background: none !important;
  }
  .print-content-only .wrapper,
  .print-content-only .page,
  .print-content-only .page-title .content,
  .print-content-only .container,
  .print-content-only .container-xxl,
  .print-content-only .container-fluid,
  .print-content-only .container-sm,
  .print-content-only .container-md,
  .print-content-only .container-lg,
  .print-content-only .container-xl {
    background: none !important;
    padding: 0 !important;
    margin: 0 !important;
  }
  .print-content-only .aside,
  .print-content-only .sidebar,
  .print-content-only .scrolltop,
  .print-content-only .header,
  .print-content-only .footer,
  .print-content-only .toolbar,
  .print-content-only .drawer,
  .print-content-only .btn {
    display: none !important;
  }
}
.bg-white {
  --bs-bg-rgb-color: var(--bs-white-bg-rgb);
  background-color: #ffffff !important;
}

.bg-black {
  --bs-bg-rgb-color: var(--bs-black-bg-rgb);
  background-color: #000000 !important;
}

.bg-body {
  --bs-bg-rgb-color: var(--bs-body-bg-rgb);
  background-color: var(--bs-body-bg) !important;
}

.bg-hover-body {
  cursor: pointer;
}

.bg-hover-body:hover {
  background-color: var(--bs-body-bg) !important;
}

.bg-active-body.active {
  background-color: var(--bs-body-bg) !important;
}

.bg-state-body {
  cursor: pointer;
}

.bg-state-body.active, .bg-state-body:hover {
  background-color: var(--bs-body-bg) !important;
}

.bg-hover-white {
  cursor: pointer;
}

.bg-hover-white:hover {
  --bs-bg-rgb-color: var(--bs-white-bg-rgb);
  background-color: #ffffff !important;
}

.bg-active-white.active {
  --bs-bg-rgb-color: var(--bs-white-bg-rgb);
  background-color: #ffffff !important;
}

.bg-state-white {
  cursor: pointer;
}

.bg-state-white.active, .bg-state-white:hover {
  --bs-bg-rgb-color: var(--bs-white-bg-rgb);
  background-color: #ffffff !important;
}

.bg-light {
  --bs-bg-rgb-color: var(--bs-light-rgb);
  background-color: var(--bs-light) !important;
}

.bg-light-active {
  --bs-bg-rgb-color: var(--bs-light-active-rgb);
  background-color: var(--bs-light-active) !important;
}

.bg-hover-light {
  cursor: pointer;
}

.bg-hover-light:hover {
  background-color: var(--bs-light) !important;
}

.bg-active-light.active {
  background-color: var(--bs-light) !important;
}

.bg-state-light {
  cursor: pointer;
}

.bg-state-light.active, .bg-state-light:hover {
  background-color: var(--bs-light) !important;
}

.bg-light-primary {
  background-color: var(--bs-primary-light) !important;
}

.bg-primary {
  --bs-bg-rgb-color: var(--bs-primary-rgb);
  background-color: var(--bs-primary) !important;
}

.bg-primary-active {
  --bs-bg-rgb-color: var(--bs-primary-active-rgb);
  background-color: var(--bs-primary-active) !important;
}

.bg-hover-light-primary {
  cursor: pointer;
}

.bg-hover-light-primary:hover {
  background-color: var(--bs-primary-light) !important;
}

.bg-state-light-primary {
  cursor: pointer;
}

.bg-state-light-primary.active, .bg-state-light-primary:hover {
  background-color: var(--bs-primary-light) !important;
}

.bg-hover-primary {
  cursor: pointer;
}

.bg-hover-primary:hover {
  background-color: var(--bs-primary) !important;
}

.bg-active-primary.active {
  background-color: var(--bs-primary) !important;
}

.bg-state-primary {
  cursor: pointer;
}

.bg-state-primary.active, .bg-state-primary:hover {
  background-color: var(--bs-primary) !important;
}

.bg-light-secondary {
  background-color: var(--bs-secondary-light) !important;
}

.bg-secondary {
  --bs-bg-rgb-color: var(--bs-secondary-rgb);
  background-color: var(--bs-secondary) !important;
}

.bg-secondary-active {
  --bs-bg-rgb-color: var(--bs-secondary-active-rgb);
  background-color: var(--bs-secondary-active) !important;
}

.bg-hover-light-secondary {
  cursor: pointer;
}

.bg-hover-light-secondary:hover {
  background-color: var(--bs-secondary-light) !important;
}

.bg-state-light-secondary {
  cursor: pointer;
}

.bg-state-light-secondary.active, .bg-state-light-secondary:hover {
  background-color: var(--bs-secondary-light) !important;
}

.bg-hover-secondary {
  cursor: pointer;
}

.bg-hover-secondary:hover {
  background-color: var(--bs-secondary) !important;
}

.bg-active-secondary.active {
  background-color: var(--bs-secondary) !important;
}

.bg-state-secondary {
  cursor: pointer;
}

.bg-state-secondary.active, .bg-state-secondary:hover {
  background-color: var(--bs-secondary) !important;
}

.bg-light-success {
  background-color: var(--bs-success-light) !important;
}

.bg-success {
  --bs-bg-rgb-color: var(--bs-success-rgb);
  background-color: var(--bs-success) !important;
}

.bg-success-active {
  --bs-bg-rgb-color: var(--bs-success-active-rgb);
  background-color: var(--bs-success-active) !important;
}

.bg-hover-light-success {
  cursor: pointer;
}

.bg-hover-light-success:hover {
  background-color: var(--bs-success-light) !important;
}

.bg-state-light-success {
  cursor: pointer;
}

.bg-state-light-success.active, .bg-state-light-success:hover {
  background-color: var(--bs-success-light) !important;
}

.bg-hover-success {
  cursor: pointer;
}

.bg-hover-success:hover {
  background-color: var(--bs-success) !important;
}

.bg-active-success.active {
  background-color: var(--bs-success) !important;
}

.bg-state-success {
  cursor: pointer;
}

.bg-state-success.active, .bg-state-success:hover {
  background-color: var(--bs-success) !important;
}

.bg-light-info {
  background-color: var(--bs-info-light) !important;
}

.bg-info {
  --bs-bg-rgb-color: var(--bs-info-rgb);
  background-color: var(--bs-info) !important;
}

.bg-info-active {
  --bs-bg-rgb-color: var(--bs-info-active-rgb);
  background-color: var(--bs-info-active) !important;
}

.bg-hover-light-info {
  cursor: pointer;
}

.bg-hover-light-info:hover {
  background-color: var(--bs-info-light) !important;
}

.bg-state-light-info {
  cursor: pointer;
}

.bg-state-light-info.active, .bg-state-light-info:hover {
  background-color: var(--bs-info-light) !important;
}

.bg-hover-info {
  cursor: pointer;
}

.bg-hover-info:hover {
  background-color: var(--bs-info) !important;
}

.bg-active-info.active {
  background-color: var(--bs-info) !important;
}

.bg-state-info {
  cursor: pointer;
}

.bg-state-info.active, .bg-state-info:hover {
  background-color: var(--bs-info) !important;
}

.bg-light-warning {
  background-color: var(--bs-warning-light) !important;
}

.bg-warning {
  --bs-bg-rgb-color: var(--bs-warning-rgb);
  background-color: var(--bs-warning) !important;
}

.bg-warning-active {
  --bs-bg-rgb-color: var(--bs-warning-active-rgb);
  background-color: var(--bs-warning-active) !important;
}

.bg-hover-light-warning {
  cursor: pointer;
}

.bg-hover-light-warning:hover {
  background-color: var(--bs-warning-light) !important;
}

.bg-state-light-warning {
  cursor: pointer;
}

.bg-state-light-warning.active, .bg-state-light-warning:hover {
  background-color: var(--bs-warning-light) !important;
}

.bg-hover-warning {
  cursor: pointer;
}

.bg-hover-warning:hover {
  background-color: var(--bs-warning) !important;
}

.bg-active-warning.active {
  background-color: var(--bs-warning) !important;
}

.bg-state-warning {
  cursor: pointer;
}

.bg-state-warning.active, .bg-state-warning:hover {
  background-color: var(--bs-warning) !important;
}

.bg-light-danger {
  background-color: var(--bs-danger-light) !important;
}

.bg-danger {
  --bs-bg-rgb-color: var(--bs-danger-rgb);
  background-color: var(--bs-danger) !important;
}

.bg-danger-active {
  --bs-bg-rgb-color: var(--bs-danger-active-rgb);
  background-color: var(--bs-danger-active) !important;
}

.bg-hover-light-danger {
  cursor: pointer;
}

.bg-hover-light-danger:hover {
  background-color: var(--bs-danger-light) !important;
}

.bg-state-light-danger {
  cursor: pointer;
}

.bg-state-light-danger.active, .bg-state-light-danger:hover {
  background-color: var(--bs-danger-light) !important;
}

.bg-hover-danger {
  cursor: pointer;
}

.bg-hover-danger:hover {
  background-color: var(--bs-danger) !important;
}

.bg-active-danger.active {
  background-color: var(--bs-danger) !important;
}

.bg-state-danger {
  cursor: pointer;
}

.bg-state-danger.active, .bg-state-danger:hover {
  background-color: var(--bs-danger) !important;
}

.bg-light-dark {
  background-color: var(--bs-dark-light) !important;
}

.bg-dark {
  --bs-bg-rgb-color: var(--bs-dark-rgb);
  background-color: var(--bs-dark) !important;
}

.bg-dark-active {
  --bs-bg-rgb-color: var(--bs-dark-active-rgb);
  background-color: var(--bs-dark-active) !important;
}

.bg-hover-light-dark {
  cursor: pointer;
}

.bg-hover-light-dark:hover {
  background-color: var(--bs-dark-light) !important;
}

.bg-state-light-dark {
  cursor: pointer;
}

.bg-state-light-dark.active, .bg-state-light-dark:hover {
  background-color: var(--bs-dark-light) !important;
}

.bg-hover-dark {
  cursor: pointer;
}

.bg-hover-dark:hover {
  background-color: var(--bs-dark) !important;
}

.bg-active-dark.active {
  background-color: var(--bs-dark) !important;
}

.bg-state-dark {
  cursor: pointer;
}

.bg-state-dark.active, .bg-state-dark:hover {
  background-color: var(--bs-dark) !important;
}

.bg-gray-100 {
  --bs-bg-rgb-color: var(--bs-gray-100-rgb);
  background-color: var(--bs-gray-100);
}

.bg-gray-100i {
  --bs-bg-rgb-color: var(--bs-gray-100-rgb);
  background-color: var(--bs-gray-100) !important;
}

.bg-gray-200 {
  --bs-bg-rgb-color: var(--bs-gray-200-rgb);
  background-color: var(--bs-gray-200);
}

.bg-gray-200i {
  --bs-bg-rgb-color: var(--bs-gray-200-rgb);
  background-color: var(--bs-gray-200) !important;
}

.bg-gray-300 {
  --bs-bg-rgb-color: var(--bs-gray-300-rgb);
  background-color: var(--bs-gray-300);
}

.bg-gray-300i {
  --bs-bg-rgb-color: var(--bs-gray-300-rgb);
  background-color: var(--bs-gray-300) !important;
}

.bg-gray-400 {
  --bs-bg-rgb-color: var(--bs-gray-400-rgb);
  background-color: var(--bs-gray-400);
}

.bg-gray-400i {
  --bs-bg-rgb-color: var(--bs-gray-400-rgb);
  background-color: var(--bs-gray-400) !important;
}

.bg-gray-500 {
  --bs-bg-rgb-color: var(--bs-gray-500-rgb);
  background-color: var(--bs-gray-500);
}

.bg-gray-500i {
  --bs-bg-rgb-color: var(--bs-gray-500-rgb);
  background-color: var(--bs-gray-500) !important;
}

.bg-gray-600 {
  --bs-bg-rgb-color: var(--bs-gray-600-rgb);
  background-color: var(--bs-gray-600);
}

.bg-gray-600i {
  --bs-bg-rgb-color: var(--bs-gray-600-rgb);
  background-color: var(--bs-gray-600) !important;
}

.bg-gray-700 {
  --bs-bg-rgb-color: var(--bs-gray-700-rgb);
  background-color: var(--bs-gray-700);
}

.bg-gray-700i {
  --bs-bg-rgb-color: var(--bs-gray-700-rgb);
  background-color: var(--bs-gray-700) !important;
}

.bg-gray-800 {
  --bs-bg-rgb-color: var(--bs-gray-800-rgb);
  background-color: var(--bs-gray-800);
}

.bg-gray-800i {
  --bs-bg-rgb-color: var(--bs-gray-800-rgb);
  background-color: var(--bs-gray-800) !important;
}

.bg-gray-900 {
  --bs-bg-rgb-color: var(--bs-gray-900-rgb);
  background-color: var(--bs-gray-900);
}

.bg-gray-900i {
  --bs-bg-rgb-color: var(--bs-gray-900-rgb);
  background-color: var(--bs-gray-900) !important;
}

.bg-opacity-0 {
  background-color: rgba(var(--bs-bg-rgb-color), 0) !important;
}

.bg-hover-opacity-0:hover {
  background-color: rgba(var(--bs-bg-rgb-color), 0) !important;
}

.bg-active-opacity-0.active {
  background-color: rgba(var(--bs-bg-rgb-color), 0) !important;
}

.bg-state-opacity-0 .active, .bg-state-opacity-0:hover {
  background-color: rgba(var(--bs-bg-rgb-color), 0) !important;
}

.bg-opacity-5 {
  background-color: rgba(var(--bs-bg-rgb-color), 0.05) !important;
}

.bg-hover-opacity-5:hover {
  background-color: rgba(var(--bs-bg-rgb-color), 0.05) !important;
}

.bg-active-opacity-5.active {
  background-color: rgba(var(--bs-bg-rgb-color), 0.05) !important;
}

.bg-state-opacity-5 .active, .bg-state-opacity-5:hover {
  background-color: rgba(var(--bs-bg-rgb-color), 0.05) !important;
}

.bg-opacity-10 {
  background-color: rgba(var(--bs-bg-rgb-color), 0.1) !important;
}

.bg-hover-opacity-10:hover {
  background-color: rgba(var(--bs-bg-rgb-color), 0.1) !important;
}

.bg-active-opacity-10.active {
  background-color: rgba(var(--bs-bg-rgb-color), 0.1) !important;
}

.bg-state-opacity-10 .active, .bg-state-opacity-10:hover {
  background-color: rgba(var(--bs-bg-rgb-color), 0.1) !important;
}

.bg-opacity-15 {
  background-color: rgba(var(--bs-bg-rgb-color), 0.15) !important;
}

.bg-hover-opacity-15:hover {
  background-color: rgba(var(--bs-bg-rgb-color), 0.15) !important;
}

.bg-active-opacity-15.active {
  background-color: rgba(var(--bs-bg-rgb-color), 0.15) !important;
}

.bg-state-opacity-15 .active, .bg-state-opacity-15:hover {
  background-color: rgba(var(--bs-bg-rgb-color), 0.15) !important;
}

.bg-opacity-20 {
  background-color: rgba(var(--bs-bg-rgb-color), 0.2) !important;
}

.bg-hover-opacity-20:hover {
  background-color: rgba(var(--bs-bg-rgb-color), 0.2) !important;
}

.bg-active-opacity-20.active {
  background-color: rgba(var(--bs-bg-rgb-color), 0.2) !important;
}

.bg-state-opacity-20 .active, .bg-state-opacity-20:hover {
  background-color: rgba(var(--bs-bg-rgb-color), 0.2) !important;
}

.bg-opacity-25 {
  background-color: rgba(var(--bs-bg-rgb-color), 0.25) !important;
}

.bg-hover-opacity-25:hover {
  background-color: rgba(var(--bs-bg-rgb-color), 0.25) !important;
}

.bg-active-opacity-25.active {
  background-color: rgba(var(--bs-bg-rgb-color), 0.25) !important;
}

.bg-state-opacity-25 .active, .bg-state-opacity-25:hover {
  background-color: rgba(var(--bs-bg-rgb-color), 0.25) !important;
}

.bg-opacity-50 {
  background-color: rgba(var(--bs-bg-rgb-color), 0.5) !important;
}

.bg-hover-opacity-50:hover {
  background-color: rgba(var(--bs-bg-rgb-color), 0.5) !important;
}

.bg-active-opacity-50.active {
  background-color: rgba(var(--bs-bg-rgb-color), 0.5) !important;
}

.bg-state-opacity-50 .active, .bg-state-opacity-50:hover {
  background-color: rgba(var(--bs-bg-rgb-color), 0.5) !important;
}

.bg-opacity-75 {
  background-color: rgba(var(--bs-bg-rgb-color), 0.75) !important;
}

.bg-hover-opacity-75:hover {
  background-color: rgba(var(--bs-bg-rgb-color), 0.75) !important;
}

.bg-active-opacity-75.active {
  background-color: rgba(var(--bs-bg-rgb-color), 0.75) !important;
}

.bg-state-opacity-75 .active, .bg-state-opacity-75:hover {
  background-color: rgba(var(--bs-bg-rgb-color), 0.75) !important;
}

.bg-opacity-100 {
  background-color: rgba(var(--bs-bg-rgb-color), 1) !important;
}

.bg-hover-opacity-100:hover {
  background-color: rgba(var(--bs-bg-rgb-color), 1) !important;
}

.bg-active-opacity-100.active {
  background-color: rgba(var(--bs-bg-rgb-color), 1) !important;
}

.bg-state-opacity-100 .active, .bg-state-opacity-100:hover {
  background-color: rgba(var(--bs-bg-rgb-color), 1) !important;
}

.bgi-no-repeat {
  background-repeat: no-repeat;
}

.bgi-position-y-top {
  background-position-y: top;
}

.bgi-position-y-bottom {
  background-position-y: bottom;
}

.bgi-position-y-center {
  background-position-y: center;
}

.bgi-position-x-start {
  background-position-x: left;
}

.bgi-position-x-end {
  background-position-x: right;
}

.bgi-position-x-center {
  background-position-x: center;
}

.bgi-position-top {
  background-position: 0 top;
}

.bgi-position-bottom {
  background-position: 0 bottom;
}

.bgi-position-center {
  background-position: center;
}

.bgi-size-auto {
  background-size: auto;
}

.bgi-size-cover {
  background-size: cover;
}

.bgi-size-contain {
  background-size: contain;
}

.bgi-attachment-fixed {
  background-attachment: fixed;
}

.bgi-attachment-scroll {
  background-attachment: scroll;
}

@media (min-width: 576px) {
  .bgi-size-sm-auto {
    background-size: auto;
  }
  .bgi-size-sm-cover {
    background-size: cover;
  }
  .bgi-size-sm-contain {
    background-size: contain;
  }
  .bgi-attachment-sm-fixed {
    background-attachment: fixed;
  }
  .bgi-attachment-sm-scroll {
    background-attachment: scroll;
  }
}
@media (min-width: 768px) {
  .bgi-size-md-auto {
    background-size: auto;
  }
  .bgi-size-md-cover {
    background-size: cover;
  }
  .bgi-size-md-contain {
    background-size: contain;
  }
  .bgi-attachment-md-fixed {
    background-attachment: fixed;
  }
  .bgi-attachment-md-scroll {
    background-attachment: scroll;
  }
}
@media (min-width: 992px) {
  .bgi-size-lg-auto {
    background-size: auto;
  }
  .bgi-size-lg-cover {
    background-size: cover;
  }
  .bgi-size-lg-contain {
    background-size: contain;
  }
  .bgi-attachment-lg-fixed {
    background-attachment: fixed;
  }
  .bgi-attachment-lg-scroll {
    background-attachment: scroll;
  }
}
@media (min-width: 1200px) {
  .bgi-size-xl-auto {
    background-size: auto;
  }
  .bgi-size-xl-cover {
    background-size: cover;
  }
  .bgi-size-xl-contain {
    background-size: contain;
  }
  .bgi-attachment-xl-fixed {
    background-attachment: fixed;
  }
  .bgi-attachment-xl-scroll {
    background-attachment: scroll;
  }
}
@media (min-width: 1400px) {
  .bgi-size-xxl-auto {
    background-size: auto;
  }
  .bgi-size-xxl-cover {
    background-size: cover;
  }
  .bgi-size-xxl-contain {
    background-size: contain;
  }
  .bgi-attachment-xxl-fixed {
    background-attachment: fixed;
  }
  .bgi-attachment-xxl-scroll {
    background-attachment: scroll;
  }
}
.border-active:not(.active):not(:active):not(:hover):not(:focus) {
  border-color: transparent !important;
}

.border-hover:not(:hover):not(:focus):not(.active):not(:active) {
  cursor: pointer;
  border-color: transparent !important;
}

.border-gray-100 {
  border-color: var(--bs-gray-100) !important;
}

.border-gray-200 {
  border-color: var(--bs-gray-200) !important;
}

.border-gray-300 {
  border-color: var(--bs-gray-300) !important;
}

.border-gray-400 {
  border-color: var(--bs-gray-400) !important;
}

.border-gray-500 {
  border-color: var(--bs-gray-500) !important;
}

.border-gray-600 {
  border-color: var(--bs-gray-600) !important;
}

.border-gray-700 {
  border-color: var(--bs-gray-700) !important;
}

.border-gray-800 {
  border-color: var(--bs-gray-800) !important;
}

.border-gray-900 {
  border-color: var(--bs-gray-900) !important;
}

.border-hover-light:hover {
  border-color: var(--bs-light) !important;
}

.border-active-light.active {
  border-color: var(--bs-light) !important;
}

.border-hover-primary:hover {
  border-color: var(--bs-primary) !important;
}

.border-active-primary.active {
  border-color: var(--bs-primary) !important;
}

.border-hover-secondary:hover {
  border-color: var(--bs-secondary) !important;
}

.border-active-secondary.active {
  border-color: var(--bs-secondary) !important;
}

.border-hover-success:hover {
  border-color: var(--bs-success) !important;
}

.border-active-success.active {
  border-color: var(--bs-success) !important;
}

.border-hover-info:hover {
  border-color: var(--bs-info) !important;
}

.border-active-info.active {
  border-color: var(--bs-info) !important;
}

.border-hover-warning:hover {
  border-color: var(--bs-warning) !important;
}

.border-active-warning.active {
  border-color: var(--bs-warning) !important;
}

.border-hover-danger:hover {
  border-color: var(--bs-danger) !important;
}

.border-active-danger.active {
  border-color: var(--bs-danger) !important;
}

.border-hover-dark:hover {
  border-color: var(--bs-dark) !important;
}

.border-active-dark.active {
  border-color: var(--bs-dark) !important;
}

.border-hover-transparent:hover {
  border-color: transparent !important;
}

.border-dashed {
  border-style: dashed !important;
  border-color: var(--bs-border-dashed-color);
}

.border-top-dashed {
  border-top-style: dashed !important;
}

.border-bottom-dashed {
  border-bottom-style: dashed !important;
}

.border-start-dashed {
  border-left-style: dashed !important;
}

.border-end-dashed {
  border-right-style: dashed !important;
}

.border-dotted {
  border-style: dotted !important;
}

.border-top-dotted {
  border-top-style: dotted !important;
}

.border-bottom-dotted {
  border-bottom-style: dotted !important;
}

.border-start-dotted {
  border-left-style: dotted !important;
}

.border-end-dotted {
  border-right-style: dotted !important;
}

.border-transparent {
  border-color: transparent !important;
}

.border-body {
  border-color: var(--bs-body-bg) !important;
}

.rounded-top-0 {
  border-top-left-radius: 0 !important;
  border-top-right-radius: 0 !important;
}

.rounded-bottom-0 {
  border-bottom-left-radius: 0 !important;
  border-bottom-right-radius: 0 !important;
}

.rounded-start-0 {
  border-top-left-radius: 0 !important;
  border-bottom-left-radius: 0 !important;
}

.rounded-end-0 {
  border-top-right-radius: 0 !important;
  border-bottom-right-radius: 0 !important;
}

.rounded-circle {
  border-radius: 50% !important;
}

.flex-root {
  flex: 1 1;
}

.flex-column-auto {
  flex: none;
}

.flex-column-fluid {
  flex: 1 0 auto;
}

.flex-row-auto {
  flex: 0 0 auto;
}

.flex-row-fluid {
  flex: 1 1 auto;
  min-width: 0;
}

.flex-center {
  justify-content: center;
  align-items: center;
}

.flex-start {
  justify-content: start;
  align-items: start;
}

.flex-end {
  justify-content: flex-end;
  align-items: flex-end;
}

.flex-stack {
  justify-content: space-between;
  align-items: center;
}

@media (min-width: 576px) {
  .flex-sm-root {
    flex: 1 1;
  }
  .flex-sm-column-auto {
    flex: none;
  }
  .flex-sm-column-fluid {
    flex: 1 0 auto;
  }
  .flex-sm-row-auto {
    flex: 0 0 auto;
  }
  .flex-sm-row-fluid {
    flex: 1 1 auto;
    min-width: 0;
  }
  .flex-sm-center {
    justify-content: center;
    align-items: center;
  }
  .flex-sm-start {
    justify-content: start;
    align-items: start;
  }
  .flex-sm-end {
    justify-content: flex-end;
    align-items: flex-end;
  }
  .flex-sm-stack {
    justify-content: space-between;
    align-items: center;
  }
}
@media (min-width: 768px) {
  .flex-md-root {
    flex: 1 1;
  }
  .flex-md-column-auto {
    flex: none;
  }
  .flex-md-column-fluid {
    flex: 1 0 auto;
  }
  .flex-md-row-auto {
    flex: 0 0 auto;
  }
  .flex-md-row-fluid {
    flex: 1 1 auto;
    min-width: 0;
  }
  .flex-md-center {
    justify-content: center;
    align-items: center;
  }
  .flex-md-start {
    justify-content: start;
    align-items: start;
  }
  .flex-md-end {
    justify-content: flex-end;
    align-items: flex-end;
  }
  .flex-md-stack {
    justify-content: space-between;
    align-items: center;
  }
}
@media (min-width: 992px) {
  .flex-lg-root {
    flex: 1 1;
  }
  .flex-lg-column-auto {
    flex: none;
  }
  .flex-lg-column-fluid {
    flex: 1 0 auto;
  }
  .flex-lg-row-auto {
    flex: 0 0 auto;
  }
  .flex-lg-row-fluid {
    flex: 1 1 auto;
    min-width: 0;
  }
  .flex-lg-center {
    justify-content: center;
    align-items: center;
  }
  .flex-lg-start {
    justify-content: start;
    align-items: start;
  }
  .flex-lg-end {
    justify-content: flex-end;
    align-items: flex-end;
  }
  .flex-lg-stack {
    justify-content: space-between;
    align-items: center;
  }
}
@media (min-width: 1200px) {
  .flex-xl-root {
    flex: 1 1;
  }
  .flex-xl-column-auto {
    flex: none;
  }
  .flex-xl-column-fluid {
    flex: 1 0 auto;
  }
  .flex-xl-row-auto {
    flex: 0 0 auto;
  }
  .flex-xl-row-fluid {
    flex: 1 1 auto;
    min-width: 0;
  }
  .flex-xl-center {
    justify-content: center;
    align-items: center;
  }
  .flex-xl-start {
    justify-content: start;
    align-items: start;
  }
  .flex-xl-end {
    justify-content: flex-end;
    align-items: flex-end;
  }
  .flex-xl-stack {
    justify-content: space-between;
    align-items: center;
  }
}
@media (min-width: 1400px) {
  .flex-xxl-root {
    flex: 1 1;
  }
  .flex-xxl-column-auto {
    flex: none;
  }
  .flex-xxl-column-fluid {
    flex: 1 0 auto;
  }
  .flex-xxl-row-auto {
    flex: 0 0 auto;
  }
  .flex-xxl-row-fluid {
    flex: 1 1 auto;
    min-width: 0;
  }
  .flex-xxl-center {
    justify-content: center;
    align-items: center;
  }
  .flex-xxl-start {
    justify-content: start;
    align-items: start;
  }
  .flex-xxl-end {
    justify-content: flex-end;
    align-items: flex-end;
  }
  .flex-xxl-stack {
    justify-content: space-between;
    align-items: center;
  }
}
.flex-equal {
  flex-grow: 1;
  flex-basis: 0;
  flex-shrink: 0;
}

.shadow-xs {
  box-shadow: var(--bs-box-shadow-xs);
}

.shadow-sm {
  box-shadow: var(--bs-box-shadow-sm);
}

.shadow {
  box-shadow: var(--bs-box-shadow);
}

.shadow-lg {
  box-shadow: var(--bs-box-shadow-lg);
}

.text-white {
  color: var(--bs-text-white) !important;
}

.text-hover-white {
  transition: color 0.2s ease;
}

.text-hover-white i {
  transition: color 0.2s ease;
}

.text-hover-white:hover {
  transition: color 0.2s ease;
  color: var(--bs-text-white) !important;
}

.text-hover-white:hover i {
  transition: color 0.2s ease;
  color: var(--bs-text-white) !important;
}

.text-hover-white:hover .svg-icon {
  color: var(--bs-text-white) !important;
}

.text-active-white {
  transition: color 0.2s ease;
}

.text-active-white i {
  transition: color 0.2s ease;
}

.text-active-white.active {
  transition: color 0.2s ease;
  color: var(--bs-text-white) !important;
}

.text-active-white.active i {
  transition: color 0.2s ease;
  color: var(--bs-text-white) !important;
}

.text-active-white.active .svg-icon {
  color: var(--bs-text-white) !important;
}

.text-primary {
  color: var(--bs-text-primary) !important;
}

.text-inverse-primary {
  color: var(--bs-primary-inverse) !important;
}

.text-light-primary {
  color: var(--bs-primary-light) !important;
}

.text-hover-primary {
  transition: color 0.2s ease;
}

.text-hover-primary i {
  transition: color 0.2s ease;
}

.text-hover-primary:hover {
  transition: color 0.2s ease;
  color: var(--bs-text-primary) !important;
}

.text-hover-primary:hover i {
  transition: color 0.2s ease;
  color: var(--bs-text-primary) !important;
}

.text-hover-primary:hover .svg-icon {
  color: var(--bs-text-primary) !important;
}

.text-active-primary {
  transition: color 0.2s ease;
}

.text-active-primary i {
  transition: color 0.2s ease;
}

.text-active-primary.active {
  transition: color 0.2s ease;
  color: var(--bs-text-primary) !important;
}

.text-active-primary.active i {
  transition: color 0.2s ease;
  color: var(--bs-text-primary) !important;
}

.text-active-primary.active .svg-icon {
  color: var(--bs-text-primary) !important;
}

.text-secondary {
  color: var(--bs-text-secondary) !important;
}

.text-inverse-secondary {
  color: var(--bs-secondary-inverse) !important;
}

.text-light-secondary {
  color: var(--bs-secondary-light) !important;
}

.text-hover-secondary {
  transition: color 0.2s ease;
}

.text-hover-secondary i {
  transition: color 0.2s ease;
}

.text-hover-secondary:hover {
  transition: color 0.2s ease;
  color: var(--bs-text-secondary) !important;
}

.text-hover-secondary:hover i {
  transition: color 0.2s ease;
  color: var(--bs-text-secondary) !important;
}

.text-hover-secondary:hover .svg-icon {
  color: var(--bs-text-secondary) !important;
}

.text-active-secondary {
  transition: color 0.2s ease;
}

.text-active-secondary i {
  transition: color 0.2s ease;
}

.text-active-secondary.active {
  transition: color 0.2s ease;
  color: var(--bs-text-secondary) !important;
}

.text-active-secondary.active i {
  transition: color 0.2s ease;
  color: var(--bs-text-secondary) !important;
}

.text-active-secondary.active .svg-icon {
  color: var(--bs-text-secondary) !important;
}

.text-light {
  color: var(--bs-text-light) !important;
}

.text-inverse-light {
  color: var(--bs-light-inverse) !important;
}

.text-hover-light {
  transition: color 0.2s ease;
}

.text-hover-light i {
  transition: color 0.2s ease;
}

.text-hover-light:hover {
  transition: color 0.2s ease;
  color: var(--bs-text-light) !important;
}

.text-hover-light:hover i {
  transition: color 0.2s ease;
  color: var(--bs-text-light) !important;
}

.text-hover-light:hover .svg-icon {
  color: var(--bs-text-light) !important;
}

.text-active-light {
  transition: color 0.2s ease;
}

.text-active-light i {
  transition: color 0.2s ease;
}

.text-active-light.active {
  transition: color 0.2s ease;
  color: var(--bs-text-light) !important;
}

.text-active-light.active i {
  transition: color 0.2s ease;
  color: var(--bs-text-light) !important;
}

.text-active-light.active .svg-icon {
  color: var(--bs-text-light) !important;
}

.text-success {
  color: var(--bs-text-success) !important;
}

.text-inverse-success {
  color: var(--bs-success-inverse) !important;
}

.text-light-success {
  color: var(--bs-success-light) !important;
}

.text-hover-success {
  transition: color 0.2s ease;
}

.text-hover-success i {
  transition: color 0.2s ease;
}

.text-hover-success:hover {
  transition: color 0.2s ease;
  color: var(--bs-text-success) !important;
}

.text-hover-success:hover i {
  transition: color 0.2s ease;
  color: var(--bs-text-success) !important;
}

.text-hover-success:hover .svg-icon {
  color: var(--bs-text-success) !important;
}

.text-active-success {
  transition: color 0.2s ease;
}

.text-active-success i {
  transition: color 0.2s ease;
}

.text-active-success.active {
  transition: color 0.2s ease;
  color: var(--bs-text-success) !important;
}

.text-active-success.active i {
  transition: color 0.2s ease;
  color: var(--bs-text-success) !important;
}

.text-active-success.active .svg-icon {
  color: var(--bs-text-success) !important;
}

.text-info {
  color: var(--bs-text-info) !important;
}

.text-inverse-info {
  color: var(--bs-info-inverse) !important;
}

.text-light-info {
  color: var(--bs-info-light) !important;
}

.text-hover-info {
  transition: color 0.2s ease;
}

.text-hover-info i {
  transition: color 0.2s ease;
}

.text-hover-info:hover {
  transition: color 0.2s ease;
  color: var(--bs-text-info) !important;
}

.text-hover-info:hover i {
  transition: color 0.2s ease;
  color: var(--bs-text-info) !important;
}

.text-hover-info:hover .svg-icon {
  color: var(--bs-text-info) !important;
}

.text-active-info {
  transition: color 0.2s ease;
}

.text-active-info i {
  transition: color 0.2s ease;
}

.text-active-info.active {
  transition: color 0.2s ease;
  color: var(--bs-text-info) !important;
}

.text-active-info.active i {
  transition: color 0.2s ease;
  color: var(--bs-text-info) !important;
}

.text-active-info.active .svg-icon {
  color: var(--bs-text-info) !important;
}

.text-warning {
  color: var(--bs-text-warning) !important;
}

.text-inverse-warning {
  color: var(--bs-warning-inverse) !important;
}

.text-light-warning {
  color: var(--bs-warning-light) !important;
}

.text-hover-warning {
  transition: color 0.2s ease;
}

.text-hover-warning i {
  transition: color 0.2s ease;
}

.text-hover-warning:hover {
  transition: color 0.2s ease;
  color: var(--bs-text-warning) !important;
}

.text-hover-warning:hover i {
  transition: color 0.2s ease;
  color: var(--bs-text-warning) !important;
}

.text-hover-warning:hover .svg-icon {
  color: var(--bs-text-warning) !important;
}

.text-active-warning {
  transition: color 0.2s ease;
}

.text-active-warning i {
  transition: color 0.2s ease;
}

.text-active-warning.active {
  transition: color 0.2s ease;
  color: var(--bs-text-warning) !important;
}

.text-active-warning.active i {
  transition: color 0.2s ease;
  color: var(--bs-text-warning) !important;
}

.text-active-warning.active .svg-icon {
  color: var(--bs-text-warning) !important;
}

.text-danger {
  color: var(--bs-text-danger) !important;
}

.text-inverse-danger {
  color: var(--bs-danger-inverse) !important;
}

.text-light-danger {
  color: var(--bs-danger-light) !important;
}

.text-hover-danger {
  transition: color 0.2s ease;
}

.text-hover-danger i {
  transition: color 0.2s ease;
}

.text-hover-danger:hover {
  transition: color 0.2s ease;
  color: var(--bs-text-danger) !important;
}

.text-hover-danger:hover i {
  transition: color 0.2s ease;
  color: var(--bs-text-danger) !important;
}

.text-hover-danger:hover .svg-icon {
  color: var(--bs-text-danger) !important;
}

.text-active-danger {
  transition: color 0.2s ease;
}

.text-active-danger i {
  transition: color 0.2s ease;
}

.text-active-danger.active {
  transition: color 0.2s ease;
  color: var(--bs-text-danger) !important;
}

.text-active-danger.active i {
  transition: color 0.2s ease;
  color: var(--bs-text-danger) !important;
}

.text-active-danger.active .svg-icon {
  color: var(--bs-text-danger) !important;
}

.text-dark {
  color: var(--bs-text-dark) !important;
}

.text-inverse-dark {
  color: var(--bs-dark-inverse) !important;
}

.text-light-dark {
  color: var(--bs-dark-light) !important;
}

.text-hover-dark {
  transition: color 0.2s ease;
}

.text-hover-dark i {
  transition: color 0.2s ease;
}

.text-hover-dark:hover {
  transition: color 0.2s ease;
  color: var(--bs-text-dark) !important;
}

.text-hover-dark:hover i {
  transition: color 0.2s ease;
  color: var(--bs-text-dark) !important;
}

.text-hover-dark:hover .svg-icon {
  color: var(--bs-text-dark) !important;
}

.text-active-dark {
  transition: color 0.2s ease;
}

.text-active-dark i {
  transition: color 0.2s ease;
}

.text-active-dark.active {
  transition: color 0.2s ease;
  color: var(--bs-text-dark) !important;
}

.text-active-dark.active i {
  transition: color 0.2s ease;
  color: var(--bs-text-dark) !important;
}

.text-active-dark.active .svg-icon {
  color: var(--bs-text-dark) !important;
}

.text-muted {
  /* color: var(--bs-text-muted) !important; */
}

.text-hover-muted {
  transition: color 0.2s ease;
}

.text-hover-muted i {
  transition: color 0.2s ease;
}

.text-hover-muted:hover {
  transition: color 0.2s ease;
  color: var(--bs-text-muted) !important;
}

.text-hover-muted:hover i {
  transition: color 0.2s ease;
  color: var(--bs-text-muted) !important;
}

.text-hover-muted:hover .svg-icon {
  color: var(--bs-text-muted) !important;
}

.text-active-muted {
  transition: color 0.2s ease;
}

.text-active-muted i {
  transition: color 0.2s ease;
}

.text-active-muted.active {
  transition: color 0.2s ease;
  color: var(--bs-text-muted) !important;
}

.text-active-muted.active i {
  transition: color 0.2s ease;
  color: var(--bs-text-muted) !important;
}

.text-active-muted.active .svg-icon {
  color: var(--bs-text-muted) !important;
}

.text-gray-100 {
  color: var(--bs-text-gray-100) !important;
}

.text-hover-gray-100 {
  transition: color 0.2s ease;
}

.text-hover-gray-100 i {
  transition: color 0.2s ease;
}

.text-hover-gray-100:hover {
  transition: color 0.2s ease;
  color: var(--bs-text-gray-100) !important;
}

.text-hover-gray-100:hover i {
  transition: color 0.2s ease;
  color: var(--bs-text-gray-100) !important;
}

.text-hover-gray-100:hover .svg-icon {
  color: var(--bs-text-gray-100) !important;
}

.text-active-gray-100 {
  transition: color 0.2s ease;
}

.text-active-gray-100 i {
  transition: color 0.2s ease;
}

.text-active-gray-100.active {
  transition: color 0.2s ease;
  color: var(--bs-text-gray-100) !important;
}

.text-active-gray-100.active i {
  transition: color 0.2s ease;
  color: var(--bs-text-gray-100) !important;
}

.text-active-gray-100.active .svg-icon {
  color: var(--bs-text-gray-100) !important;
}

.text-gray-200 {
  color: var(--bs-text-gray-200) !important;
}

.text-hover-gray-200 {
  transition: color 0.2s ease;
}

.text-hover-gray-200 i {
  transition: color 0.2s ease;
}

.text-hover-gray-200:hover {
  transition: color 0.2s ease;
  color: var(--bs-text-gray-200) !important;
}

.text-hover-gray-200:hover i {
  transition: color 0.2s ease;
  color: var(--bs-text-gray-200) !important;
}

.text-hover-gray-200:hover .svg-icon {
  color: var(--bs-text-gray-200) !important;
}

.text-active-gray-200 {
  transition: color 0.2s ease;
}

.text-active-gray-200 i {
  transition: color 0.2s ease;
}

.text-active-gray-200.active {
  transition: color 0.2s ease;
  color: var(--bs-text-gray-200) !important;
}

.text-active-gray-200.active i {
  transition: color 0.2s ease;
  color: var(--bs-text-gray-200) !important;
}

.text-active-gray-200.active .svg-icon {
  color: var(--bs-text-gray-200) !important;
}

.text-gray-300 {
  color: var(--bs-text-gray-300) !important;
}

.text-hover-gray-300 {
  transition: color 0.2s ease;
}

.text-hover-gray-300 i {
  transition: color 0.2s ease;
}

.text-hover-gray-300:hover {
  transition: color 0.2s ease;
  color: var(--bs-text-gray-300) !important;
}

.text-hover-gray-300:hover i {
  transition: color 0.2s ease;
  color: var(--bs-text-gray-300) !important;
}

.text-hover-gray-300:hover .svg-icon {
  color: var(--bs-text-gray-300) !important;
}

.text-active-gray-300 {
  transition: color 0.2s ease;
}

.text-active-gray-300 i {
  transition: color 0.2s ease;
}

.text-active-gray-300.active {
  transition: color 0.2s ease;
  color: var(--bs-text-gray-300) !important;
}

.text-active-gray-300.active i {
  transition: color 0.2s ease;
  color: var(--bs-text-gray-300) !important;
}

.text-active-gray-300.active .svg-icon {
  color: var(--bs-text-gray-300) !important;
}

.text-gray-400 {
  color: var(--bs-text-gray-400) !important;
}

.text-hover-gray-400 {
  transition: color 0.2s ease;
}

.text-hover-gray-400 i {
  transition: color 0.2s ease;
}

.text-hover-gray-400:hover {
  transition: color 0.2s ease;
  color: var(--bs-text-gray-400) !important;
}

.text-hover-gray-400:hover i {
  transition: color 0.2s ease;
  color: var(--bs-text-gray-400) !important;
}

.text-hover-gray-400:hover .svg-icon {
  color: var(--bs-text-gray-400) !important;
}

.text-active-gray-400 {
  transition: color 0.2s ease;
}

.text-active-gray-400 i {
  transition: color 0.2s ease;
}

.text-active-gray-400.active {
  transition: color 0.2s ease;
  color: var(--bs-text-gray-400) !important;
}

.text-active-gray-400.active i {
  transition: color 0.2s ease;
  color: var(--bs-text-gray-400) !important;
}

.text-active-gray-400.active .svg-icon {
  color: var(--bs-text-gray-400) !important;
}

.text-gray-500 {
  color: var(--bs-text-gray-500) !important;
}

.text-hover-gray-500 {
  transition: color 0.2s ease;
}

.text-hover-gray-500 i {
  transition: color 0.2s ease;
}

.text-hover-gray-500:hover {
  transition: color 0.2s ease;
  color: var(--bs-text-gray-500) !important;
}

.text-hover-gray-500:hover i {
  transition: color 0.2s ease;
  color: var(--bs-text-gray-500) !important;
}

.text-hover-gray-500:hover .svg-icon {
  color: var(--bs-text-gray-500) !important;
}

.text-active-gray-500 {
  transition: color 0.2s ease;
}

.text-active-gray-500 i {
  transition: color 0.2s ease;
}

.text-active-gray-500.active {
  transition: color 0.2s ease;
  color: var(--bs-text-gray-500) !important;
}

.text-active-gray-500.active i {
  transition: color 0.2s ease;
  color: var(--bs-text-gray-500) !important;
}

.text-active-gray-500.active .svg-icon {
  color: var(--bs-text-gray-500) !important;
}

.text-gray-600 {
  color: var(--bs-text-gray-600) !important;
}

.text-hover-gray-600 {
  transition: color 0.2s ease;
}

.text-hover-gray-600 i {
  transition: color 0.2s ease;
}

.text-hover-gray-600:hover {
  transition: color 0.2s ease;
  color: var(--bs-text-gray-600) !important;
}

.text-hover-gray-600:hover i {
  transition: color 0.2s ease;
  color: var(--bs-text-gray-600) !important;
}

.text-hover-gray-600:hover .svg-icon {
  color: var(--bs-text-gray-600) !important;
}

.text-active-gray-600 {
  transition: color 0.2s ease;
}

.text-active-gray-600 i {
  transition: color 0.2s ease;
}

.text-active-gray-600.active {
  transition: color 0.2s ease;
  color: var(--bs-text-gray-600) !important;
}

.text-active-gray-600.active i {
  transition: color 0.2s ease;
  color: var(--bs-text-gray-600) !important;
}

.text-active-gray-600.active .svg-icon {
  color: var(--bs-text-gray-600) !important;
}

.text-gray-700 {
  color: var(--bs-text-gray-700) !important;
}

.text-hover-gray-700 {
  transition: color 0.2s ease;
}

.text-hover-gray-700 i {
  transition: color 0.2s ease;
}

.text-hover-gray-700:hover {
  transition: color 0.2s ease;
  color: var(--bs-text-gray-700) !important;
}

.text-hover-gray-700:hover i {
  transition: color 0.2s ease;
  color: var(--bs-text-gray-700) !important;
}

.text-hover-gray-700:hover .svg-icon {
  color: var(--bs-text-gray-700) !important;
}

.text-active-gray-700 {
  transition: color 0.2s ease;
}

.text-active-gray-700 i {
  transition: color 0.2s ease;
}

.text-active-gray-700.active {
  transition: color 0.2s ease;
  color: var(--bs-text-gray-700) !important;
}

.text-active-gray-700.active i {
  transition: color 0.2s ease;
  color: var(--bs-text-gray-700) !important;
}

.text-active-gray-700.active .svg-icon {
  color: var(--bs-text-gray-700) !important;
}

.text-gray-800 {
  color: var(--bs-text-gray-800) !important;
}

.text-hover-gray-800 {
  transition: color 0.2s ease;
}

.text-hover-gray-800 i {
  transition: color 0.2s ease;
}

.text-hover-gray-800:hover {
  transition: color 0.2s ease;
  color: var(--bs-text-gray-800) !important;
}

.text-hover-gray-800:hover i {
  transition: color 0.2s ease;
  color: var(--bs-text-gray-800) !important;
}

.text-hover-gray-800:hover .svg-icon {
  color: var(--bs-text-gray-800) !important;
}

.text-active-gray-800 {
  transition: color 0.2s ease;
}

.text-active-gray-800 i {
  transition: color 0.2s ease;
}

.text-active-gray-800.active {
  transition: color 0.2s ease;
  color: var(--bs-text-gray-800) !important;
}

.text-active-gray-800.active i {
  transition: color 0.2s ease;
  color: var(--bs-text-gray-800) !important;
}

.text-active-gray-800.active .svg-icon {
  color: var(--bs-text-gray-800) !important;
}

.text-gray-900 {
  color: var(--bs-text-gray-900) !important;
}

.text-hover-gray-900 {
  transition: color 0.2s ease;
}

.text-hover-gray-900 i {
  transition: color 0.2s ease;
}

.text-hover-gray-900:hover {
  transition: color 0.2s ease;
  color: var(--bs-text-gray-900) !important;
}

.text-hover-gray-900:hover i {
  transition: color 0.2s ease;
  color: var(--bs-text-gray-900) !important;
}

.text-hover-gray-900:hover .svg-icon {
  color: var(--bs-text-gray-900) !important;
}

.text-active-gray-900 {
  transition: color 0.2s ease;
}

.text-active-gray-900 i {
  transition: color 0.2s ease;
}

.text-active-gray-900.active {
  transition: color 0.2s ease;
  color: var(--bs-text-gray-900) !important;
}

.text-active-gray-900.active i {
  transition: color 0.2s ease;
  color: var(--bs-text-gray-900) !important;
}

.text-active-gray-900.active .svg-icon {
  color: var(--bs-text-gray-900) !important;
}

.parent-hover .parent-hover-white {
  transition: color 0.2s ease;
}

.parent-hover:hover .parent-hover-white {
  transition: color 0.2s ease;
  color: var(--bs-text-white) !important;
}

.parent-hover .parent-hover-primary {
  transition: color 0.2s ease;
}

.parent-hover:hover .parent-hover-primary {
  transition: color 0.2s ease;
  color: var(--bs-text-primary) !important;
}

.parent-hover .parent-hover-secondary {
  transition: color 0.2s ease;
}

.parent-hover:hover .parent-hover-secondary {
  transition: color 0.2s ease;
  color: var(--bs-text-secondary) !important;
}

.parent-hover .parent-hover-light {
  transition: color 0.2s ease;
}

.parent-hover:hover .parent-hover-light {
  transition: color 0.2s ease;
  color: var(--bs-text-light) !important;
}

.parent-hover .parent-hover-success {
  transition: color 0.2s ease;
}

.parent-hover:hover .parent-hover-success {
  transition: color 0.2s ease;
  color: var(--bs-text-success) !important;
}

.parent-hover .parent-hover-info {
  transition: color 0.2s ease;
}

.parent-hover:hover .parent-hover-info {
  transition: color 0.2s ease;
  color: var(--bs-text-info) !important;
}

.parent-hover .parent-hover-warning {
  transition: color 0.2s ease;
}

.parent-hover:hover .parent-hover-warning {
  transition: color 0.2s ease;
  color: var(--bs-text-warning) !important;
}

.parent-hover .parent-hover-danger {
  transition: color 0.2s ease;
}

.parent-hover:hover .parent-hover-danger {
  transition: color 0.2s ease;
  color: var(--bs-text-danger) !important;
}

.parent-hover .parent-hover-dark {
  transition: color 0.2s ease;
}

.parent-hover:hover .parent-hover-dark {
  transition: color 0.2s ease;
  color: var(--bs-text-dark) !important;
}

.parent-hover .parent-hover-muted {
  transition: color 0.2s ease;
}

.parent-hover:hover .parent-hover-muted {
  transition: color 0.2s ease;
  color: var(--bs-text-muted) !important;
}

.parent-hover .parent-hover-gray-100 {
  transition: color 0.2s ease;
}

.parent-hover:hover .parent-hover-gray-100 {
  transition: color 0.2s ease;
  color: var(--bs-text-gray-100) !important;
}

.parent-hover .parent-hover-gray-200 {
  transition: color 0.2s ease;
}

.parent-hover:hover .parent-hover-gray-200 {
  transition: color 0.2s ease;
  color: var(--bs-text-gray-200) !important;
}

.parent-hover .parent-hover-gray-300 {
  transition: color 0.2s ease;
}

.parent-hover:hover .parent-hover-gray-300 {
  transition: color 0.2s ease;
  color: var(--bs-text-gray-300) !important;
}

.parent-hover .parent-hover-gray-400 {
  transition: color 0.2s ease;
}

.parent-hover:hover .parent-hover-gray-400 {
  transition: color 0.2s ease;
  color: var(--bs-text-gray-400) !important;
}

.parent-hover .parent-hover-gray-500 {
  transition: color 0.2s ease;
}

.parent-hover:hover .parent-hover-gray-500 {
  transition: color 0.2s ease;
  color: var(--bs-text-gray-500) !important;
}

.parent-hover .parent-hover-gray-600 {
  transition: color 0.2s ease;
}

.parent-hover:hover .parent-hover-gray-600 {
  transition: color 0.2s ease;
  color: var(--bs-text-gray-600) !important;
}

.parent-hover .parent-hover-gray-700 {
  transition: color 0.2s ease;
}

.parent-hover:hover .parent-hover-gray-700 {
  transition: color 0.2s ease;
  color: var(--bs-text-gray-700) !important;
}

.parent-hover .parent-hover-gray-800 {
  transition: color 0.2s ease;
}

.parent-hover:hover .parent-hover-gray-800 {
  transition: color 0.2s ease;
  color: var(--bs-text-gray-800) !important;
}

.parent-hover .parent-hover-gray-900 {
  transition: color 0.2s ease;
}

.parent-hover:hover .parent-hover-gray-900 {
  transition: color 0.2s ease;
  color: var(--bs-text-gray-900) !important;
}

.parent-active .parent-active-white {
  transition: color 0.2s ease;
}

.parent-active.active .parent-active-white {
  transition: color 0.2s ease;
  color: var(--bs-text-white) !important;
}

.parent-active .parent-active-primary {
  transition: color 0.2s ease;
}

.parent-active.active .parent-active-primary {
  transition: color 0.2s ease;
  color: var(--bs-text-primary) !important;
}

.parent-active .parent-active-secondary {
  transition: color 0.2s ease;
}

.parent-active.active .parent-active-secondary {
  transition: color 0.2s ease;
  color: var(--bs-text-secondary) !important;
}

.parent-active .parent-active-light {
  transition: color 0.2s ease;
}

.parent-active.active .parent-active-light {
  transition: color 0.2s ease;
  color: var(--bs-text-light) !important;
}

.parent-active .parent-active-success {
  transition: color 0.2s ease;
}

.parent-active.active .parent-active-success {
  transition: color 0.2s ease;
  color: var(--bs-text-success) !important;
}

.parent-active .parent-active-info {
  transition: color 0.2s ease;
}

.parent-active.active .parent-active-info {
  transition: color 0.2s ease;
  color: var(--bs-text-info) !important;
}

.parent-active .parent-active-warning {
  transition: color 0.2s ease;
}

.parent-active.active .parent-active-warning {
  transition: color 0.2s ease;
  color: var(--bs-text-warning) !important;
}

.parent-active .parent-active-danger {
  transition: color 0.2s ease;
}

.parent-active.active .parent-active-danger {
  transition: color 0.2s ease;
  color: var(--bs-text-danger) !important;
}

.parent-active .parent-active-dark {
  transition: color 0.2s ease;
}

.parent-active.active .parent-active-dark {
  transition: color 0.2s ease;
  color: var(--bs-text-dark) !important;
}

.parent-active .parent-active-muted {
  transition: color 0.2s ease;
}

.parent-active.active .parent-active-muted {
  transition: color 0.2s ease;
  color: var(--bs-text-muted) !important;
}

.parent-active .parent-active-gray-100 {
  transition: color 0.2s ease;
}

.parent-active.active .parent-active-gray-100 {
  transition: color 0.2s ease;
  color: var(--bs-text-gray-100) !important;
}

.parent-active .parent-active-gray-200 {
  transition: color 0.2s ease;
}

.parent-active.active .parent-active-gray-200 {
  transition: color 0.2s ease;
  color: var(--bs-text-gray-200) !important;
}

.parent-active .parent-active-gray-300 {
  transition: color 0.2s ease;
}

.parent-active.active .parent-active-gray-300 {
  transition: color 0.2s ease;
  color: var(--bs-text-gray-300) !important;
}

.parent-active .parent-active-gray-400 {
  transition: color 0.2s ease;
}

.parent-active.active .parent-active-gray-400 {
  transition: color 0.2s ease;
  color: var(--bs-text-gray-400) !important;
}

.parent-active .parent-active-gray-500 {
  transition: color 0.2s ease;
}

.parent-active.active .parent-active-gray-500 {
  transition: color 0.2s ease;
  color: var(--bs-text-gray-500) !important;
}

.parent-active .parent-active-gray-600 {
  transition: color 0.2s ease;
}

.parent-active.active .parent-active-gray-600 {
  transition: color 0.2s ease;
  color: var(--bs-text-gray-600) !important;
}

.parent-active .parent-active-gray-700 {
  transition: color 0.2s ease;
}

.parent-active.active .parent-active-gray-700 {
  transition: color 0.2s ease;
  color: var(--bs-text-gray-700) !important;
}

.parent-active .parent-active-gray-800 {
  transition: color 0.2s ease;
}

.parent-active.active .parent-active-gray-800 {
  transition: color 0.2s ease;
  color: var(--bs-text-gray-800) !important;
}

.parent-active .parent-active-gray-900 {
  transition: color 0.2s ease;
}

.parent-active.active .parent-active-gray-900 {
  transition: color 0.2s ease;
  color: var(--bs-text-gray-900) !important;
}

.text-transparent {
  color: transparent;
}

.cursor-pointer {
  cursor: pointer;
}

.cursor-default {
  cursor: default;
}

.cursor-move {
  cursor: move;
}

i.bi, i[class^=fonticon-], i[class*=" fonticon-"], i[class^=fa-], i[class*=" fa-"], i[class^=la-], i[class*=" la-"] {
  line-height: 1;
  font-size: 1rem;
  color: var(--bs-text-muted);
}

a {
  transition: color 0.2s ease;
}

a:hover {
  transition: color 0.2s ease;
}

.opacity-active-0.active {
  opacity: 0 !important;
}

.opacity-state-0:hover, .opacity-state-0.active {
  opacity: 0 !important;
}

.opacity-active-5.active {
  opacity: 0.05 !important;
}

.opacity-state-5:hover, .opacity-state-5.active {
  opacity: 0.05 !important;
}

.opacity-active-10.active {
  opacity: 0.1 !important;
}

.opacity-state-10:hover, .opacity-state-10.active {
  opacity: 0.1 !important;
}

.opacity-active-15.active {
  opacity: 0.15 !important;
}

.opacity-state-15:hover, .opacity-state-15.active {
  opacity: 0.15 !important;
}

.opacity-active-20.active {
  opacity: 0.2 !important;
}

.opacity-state-20:hover, .opacity-state-20.active {
  opacity: 0.2 !important;
}

.opacity-active-25.active {
  opacity: 0.25 !important;
}

.opacity-state-25:hover, .opacity-state-25.active {
  opacity: 0.25 !important;
}

.opacity-active-50.active {
  opacity: 0.5 !important;
}

.opacity-state-50:hover, .opacity-state-50.active {
  opacity: 0.5 !important;
}

.opacity-active-75.active {
  opacity: 0.75 !important;
}

.opacity-state-75:hover, .opacity-state-75.active {
  opacity: 0.75 !important;
}

.opacity-active-100.active {
  opacity: 1 !important;
}

.opacity-state-100:hover, .opacity-state-100.active {
  opacity: 1 !important;
}

.transform-90 {
  transform: rotate(90deg);
  transform-origin: right top;
}

.stepper.stepper-pills.stepper-multistep {
  --bs-stepper-pills-size: 46px;
  --bs-stepper-icon-border-radius: 9px;
  --bs-stepper-icon-check-size: 1.25rem;
  --bs-stepper-icon-bg-color: rgba(255, 255, 255, 0.03);
  --bs-stepper-icon-bg-color-current: var(--bs-success);
  --bs-stepper-icon-bg-color-completed: rgba(255, 255, 255, 0.03);
  --bs-stepper-icon-border: 1px dashed rgba(255, 255, 255, 0.3);
  --bs-stepper-icon-border-current: 0;
  --bs-stepper-icon-border-completed: 1px dashed rgba(255, 255, 255, 0.3);
  --bs-stepper-icon-number-color: var(--bs-white);
  --bs-stepper-icon-number-color-current: var(--bs-white);
  --bs-stepper-icon-number-color-completed: var(--bs-white);
  --bs-stepper-icon-check-color-completed: var(--bs-success);
  --bs-stepper-label-title-opacity: 0.7;
  --bs-stepper-label-title-opacity-current: 1;
  --bs-stepper-label-title-opacity-completed: 1;
  --bs-stepper-label-title-color: var(--bs-white);
  --bs-stepper-label-title-color-current: var(--bs-white);
  --bs-stepper-label-title-color-completed: var(--bs-white);
  --bs-stepper-label-desc-opacity: 0.7;
  --bs-stepper-label-desc-opacity-current: 0.7;
  --bs-stepper-label-desc-opacity-completed: 0.7;
  --bs-stepper-label-desc-color: var(--bs-white);
  --bs-stepper-label-desc-color-current: var(--bs-white);
  --bs-stepper-label-desc-color-completed: var(--bs-white);
  --bs-stepper-line-border: 1px dashed rgba(255, 255, 255, 0.3);
}

.landing-dark-bg {
  background-color: #13263C;
}

.landing-dark-color {
  color: #13263C;
}

.landing-dark-border {
  border: 1px dashed #2C3F5B;
}

.landing-dark-separator {
  border-top: 1px dashed #2C3F5B;
}

.landing-curve {
  position: relative;
}

.landing-curve svg {
  position: relative;
  top: 0;
  display: block;
}

.landing-header {
  display: flex;
  align-items: center;
  height: 100px;
}

.landing-header .logo-default {
  display: block;
}

.landing-header .logo-sticky {
  display: none;
}

.landing-header .menu .menu-link.active {
  color: #ffffff;
}

[data-kt-sticky-landing-header=on] .landing-header .menu .menu-link.active {
  color: #009ef7;
  background-color: rgba(239, 242, 245, 0.4);
}

[data-kt-sticky-landing-header=on] .landing-header {
  padding: 0;
  position: fixed;
  top: 0;
  right: 0;
  left: 0;
  z-index: 100;
  background-color: #ffffff;
  box-shadow: 0px 10px 30px 0px rgba(82, 63, 105, 0.05);
  height: 70px;
}

[data-kt-sticky-landing-header=on] .landing-header .logo-sticky {
  display: block;
}

[data-kt-sticky-landing-header=on] .landing-header .logo-default {
  display: none;
}

body[data-kt-sticky-landing-header=on] {
  padding-top: 100px;
}

@media (max-width: 991.98px) {
  .landing-header {
    height: 70px;
  }
  .landing-header .landing-menu-wrapper {
    position: relative;
    overflow: auto;
  }
  [data-kt-sticky-landing-header=on] .landing-header {
    height: 70px;
  }
  .landing-header .menu .menu-link.active {
    color: #009ef7;
    background-color: rgba(239, 242, 245, 0.4);
  }
  body[data-kt-sticky-landing-header=on] {
    padding-top: 70px;
  }
}
[data-bs-theme=light] {
  --bs-app-bg-color: #f5f8fa;
  --bs-app-blank-bg-color: #ffffff;
  --bs-app-header-base-bg-color: #ffffff;
  --bs-app-header-base-box-shadow: 0px 10px 30px 0px rgba(82, 63, 105, 0.05);
  --bs-app-toolbar-base-bg-color: #ffffff;
  --bs-app-toolbar-base-box-shadow: 0px 10px 30px 0px rgba(82, 63, 105, 0.05);
  --bs-app-toolbar-base-border-top: 1px solid #F4F4F4;
  --bs-app-footer-bg-color: #ffffff;
  --bs-app-footer-box-shadow: 0px 10px 30px 0px rgba(82, 63, 105, 0.05);
}

[data-bs-theme=dark] {
  --bs-app-bg-color: #151521;
  --bs-app-blank-bg-color: #151521;
  --bs-app-header-base-bg-color: #1e1e2d;
  --bs-app-header-base-box-shadow: none;
  --bs-app-toolbar-base-bg-color: #1a1a27;
  --bs-app-toolbar-base-box-shadow: none;
  --bs-app-toolbar-base-border-top: 0;
  --bs-app-footer-bg-color: #1e1e2d;
  --bs-app-footer-box-shadow: none;
}

html {
  font-family: sans-serif;
  text-size-adjust: 100%;
}

html,
body {
  height: 100%;
  margin: 0px;
  padding: 0px;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  font-size: 13px !important;
  font-weight: 400;
  font-family: Inter, Helvetica, "sans-serif";
}

@media (max-width: 991.98px) {
  html,
  body {
    font-size: 12px !important;
  }
}
@media (max-width: 767.98px) {
  html,
  body {
    font-size: 12px !important;
  }
}
body {
  display: flex;
  flex-direction: column;
}

body a:hover,
body a:active,
body a:focus {
  text-decoration: none !important;
}

canvas {
  -webkit-user-select: none;
          user-select: none;
}

router-outlet {
  display: none;
}

body,
.app-default {
  background-color: var(--bs-app-bg-color);
}

.app-blank {
  background-color: var(--bs-app-blank-bg-color);
}

[data-kt-app-reset-transition=true] * {
  transition: none !important;
}

.app-page {
  display: flex;
}

[data-kt-app-page-loading=on] {
  overflow: hidden;
}

[data-kt-app-page-loading=on] * {
  transition: none !important;
}

.app-page-loader {
  background: var(--bs-body-bg);
  color: var(--bs-body-color);
  position: fixed;
  top: 0;
  bottom: 0;
  left: 0;
  right: 0;
  z-index: 10000;
  display: none;
}

[data-kt-app-page-loading=on] .app-page-loader {
  display: flex;
  justify-content: center;
  align-items: center;
}

@media (min-width: 992px) {
  .app-container {
    padding-left: 30px !important;
    padding-right: 30px !important;
  }
  .app-container-fit-desktop {
    padding-left: 0 !important;
    padding-right: 0 !important;
  }
}
@media (max-width: 991.98px) {
  .app-container {
    max-width: none;
    padding-left: 20px !important;
    padding-right: 20px !important;
  }
  .app-container-fit-mobile {
    padding-left: 0 !important;
    padding-right: 0 !important;
  }
}
@media print {
  .app-print-content-only {
    padding: 0 !important;
    background: none !important;
  }
  .app-print-content-only .app-wrapper,
  .app-print-content-only .app-page,
  .app-print-content-only .app-page-title,
  .app-print-content-only .app-content,
  .app-print-content-only .app-container {
    background: none !important;
    padding: 0 !important;
    margin: 0 !important;
  }
  .app-print-content-only .app-aside,
  .app-print-content-only .app-aside-panel,
  .app-print-content-only .app-sidebar,
  .app-print-content-only .app-sidebar-panel,
  .app-print-content-only .app-header,
  .app-print-content-only .app-footer,
  .app-print-content-only .app-toolbar,
  .app-print-content-only .drawer,
  .app-print-content-only .scrolltop,
  .app-print-content-only .btn {
    display: none !important;
  }
}
.app-navbar {
  display: flex;
  align-items: stretch;
}

.app-navbar .app-navbar-item {
  display: flex;
  align-items: center;
}

.app-navbar.app-navbar-stretch .app-navbar-item {
  align-items: stretch;
}

.app-header {
  transition: none;
  display: flex;
  align-items: stretch;
  background-color: var(--bs-app-header-base-bg-color);
  box-shadow: var(--bs-app-header-base-box-shadow);
  border-bottom: var(--bs-app-header-base-border-bottom);
}

@media (min-width: 992px) {
  :root {
    --bs-app-header-height: 70px;
    --bs-app-header-height-actual: 70px;
  }
  [data-kt-app-header-sticky=on] {
    --bs-app-header-height: 70px;
    --bs-app-header-height-actual: 70px;
  }
  [data-kt-app-header-sticky=on][data-kt-app-header-stacked=true] {
    --bs-app-header-height: calc(var(--bs-app-header-primary-height, 0px) + var(--bs-app-header-secondary-height, 0px) + var(--bs-app-header-tertiary-height, 0px));
    --bs-app-header-height-actual: calc(70px + 70px + 70px);
  }
  [data-kt-app-header-minimize=on] {
    --bs-app-header-height: 70px;
  }
  .app-header {
    height: var(--bs-app-header-height);
  }
  [data-kt-app-header-fixed=true] .app-header {
    z-index: 100;
    position: fixed;
    left: 0;
    right: 0;
    top: 0;
  }
  [data-kt-app-header-static=true] .app-header {
    position: relative;
  }
  [data-kt-app-header-stacked=true] .app-header {
    flex-direction: column;
    height: calc(var(--bs-app-header-primary-height) + var(--bs-app-header-secondary-height, 0px) + var(--bs-app-header-tertiary-height, 0px));
  }
  [data-kt-app-header-sticky=on] .app-header {
    position: fixed;
    left: 0;
    right: 0;
    top: 0;
    z-index: 100;
    background-color: var(--bs-app-header-sticky-bg-color);
    box-shadow: var(--bs-app-header-sticky-box-shadow);
    border-bottom: var(--bs-app-header-sticky-border-bottom);
  }
  [data-kt-app-header-minimize=on] .app-header {
    transition: none;
    z-index: 100;
    background-color: var(--bs-app-header-minimize-bg-color);
    box-shadow: var(--bs-app-header-minimize-box-shadow);
    border-bottom: var(--bs-app-header-minimize-border-bottom);
  }
  .app-header .app-header-mobile-drawer {
    display: flex;
  }
  [data-kt-app-header-fixed=true][data-kt-app-sidebar-fixed=true][data-kt-app-sidebar-push-header=true] .app-header, [data-kt-app-header-fixed=true][data-kt-app-sidebar-sticky=on][data-kt-app-sidebar-push-header=true] .app-header {
    left: calc(var(--bs-app-sidebar-width) + var(--bs-app-sidebar-gap-start, 0px) + var(--bs-app-sidebar-gap-end, 0px));
  }
  body:not([data-kt-app-header-fixed=true])[data-kt-app-sidebar-fixed=true][data-kt-app-sidebar-push-header=true] .app-header, body:not([data-kt-app-header-fixed=true])[data-kt-app-sidebar-sticky=on][data-kt-app-sidebar-push-header=true] .app-header {
    margin-left: calc(var(--bs-app-sidebar-width) + var(--bs-app-sidebar-gap-start, 0px) + var(--bs-app-sidebar-gap-end, 0px));
  }
  [data-kt-app-header-fixed=true][data-kt-app-sidebar-panel-fixed=true][data-kt-app-sidebar-panel-push-header=true] .app-header, [data-kt-app-header-fixed=true][data-kt-app-sidebar-panel-sticky=on][data-kt-app-sidebar-panel-push-header=true] .app-header {
    left: calc(var(--bs-app-sidebar-width) + var(--bs-app-sidebar-gap-start, 0px) + var(--bs-app-sidebar-gap-end, 0px) + var(--bs-app-sidebar-panel-width) + var(--bs-app-sidebar-panel-gap-start, 0px) + var(--bs-app-sidebar-panel-gap-end, 0px));
  }
  body:not([data-kt-app-header-fixed=true])[data-kt-app-sidebar-panel-fixed=true][data-kt-app-sidebar-panel-push-header=true] .app-header, body:not([data-kt-app-header-fixed=true])[data-kt-app-sidebar-panel-sticky=on][data-kt-app-sidebar-panel-push-header=true] .app-header {
    margin-left: calc(var(--bs-app-sidebar-width) + var(--bs-app-sidebar-gap-start, 0px) + var(--bs-app-sidebar-gap-end, 0px) + var(--bs-app-sidebar-panel-width) + var(--bs-app-sidebar-panel-gap-start, 0px) + var(--bs-app-sidebar-panel-gap-end, 0px));
  }
  [data-kt-app-header-fixed=true][data-kt-app-toolbar-fixed=true] .app-header {
    box-shadow: none;
  }
}
@media (max-width: 991.98px) {
  :root {
    --bs-app-header-height: 60px;
  }
  [data-kt-app-header-sticky=on] {
    --bs-app-header-height: 70px;
    --bs-app-header-height-actual: 70px;
  }
  [data-kt-app-header-minimize=on] {
    --bs-app-header-height: 70px;
    --bs-app-header-height-actual: 70px;
  }
  .app-header {
    height: var(--bs-app-header-height);
    align-items: stretch;
  }
  .app-header .app-header-mobile-drawer {
    display: none;
  }
  [data-kt-app-header-stacked=true] .app-header {
    flex-direction: column;
    height: calc(var(--bs-app-header-primary-height) + var(--bs-app-header-secondary-height, 0px) + var(--bs-app-header-tertiary-height, 0px));
  }
  [data-kt-app-header-fixed-mobile=true] .app-header {
    z-index: 100;
    transition: none;
    position: fixed;
    left: 0;
    right: 0;
    top: 0;
  }
  [data-kt-app-header-sticky=on] .app-header {
    position: fixed;
    left: 0;
    right: 0;
    top: 0;
    z-index: 100;
    background-color: var(--bs-app-header-sticky-bg-color);
    box-shadow: var(--bs-app-header-sticky-box-shadow);
    border-bottom: var(--bs-app-header-sticky-border-bottom);
  }
  [data-kt-app-header-minimize=on] .app-header {
    z-index: 100;
    transition: none;
    background-color: var(--bs-app-header-minimize-bg-color);
    box-shadow: var(--bs-app-header-minimize-box-shadow);
    border-bottom: var(--bs-app-header-minimize-border-bottom);
  }
  [data-kt-app-header-fixed-mobile=true][data-kt-app-toolbar-fixed-mobile=true] .app-header {
    box-shadow: none;
  }
  [data-kt-app-header-fixed-mobile=true][data-kt-app-toolbar-sticky=on] .app-header {
    box-shadow: none;
  }
}
.app-header-primary {
  transition: none;
  display: flex;
  align-items: stretch;
}

@media (min-width: 992px) {
  .app-header-primary {
    background-color: var(--bs-app-header-primary-base-bg-color);
    box-shadow: var(--bs-app-header-primary-base-box-shadow);
    border-bottom: var(--bs-app-header-primary-base-border-bottom);
  }
  [data-kt-app-header-primary-enabled=true] {
    --bs-app-header-primary-height: 70px;
  }
  [data-kt-app-header-primary-enabled=true][data-kt-app-header-sticky=on] {
    --bs-app-header-primary-height: 70px;
  }
  [data-kt-app-header-primary-enabled=true][data-kt-app-header-minimize=on] {
    --bs-app-header-primary-height: 70px;
  }
  [data-kt-app-header-primary-enabled=true][data-kt-app-header-sticky=on][data-kt-app-header-primary-sticky-hide=true] {
    --bs-app-header-primary-height: 0;
  }
  .app-header-primary {
    height: var(--bs-app-header-primary-height);
  }
  [data-kt-app-header-primary-fixed=true] .app-header-primary {
    z-index: 100;
    position: fixed;
    left: 0;
    right: 0;
    top: 0;
  }
  [data-kt-app-header-primary-static=true] .app-header-primary {
    position: relative;
  }
  [data-kt-app-header-primary-sticky=on] .app-header-primary {
    position: fixed;
    left: 0;
    right: 0;
    top: 0;
    height: 70px;
    z-index: 100;
    background-color: var(--bs-app-header-primary-sticky-bg-color);
    box-shadow: var(--bs-app-header-primary-sticky-box-shadow);
    border-bottom: var(--bs-app-header-primary-sticky-border-bottom);
  }
  [data-kt-app-header-primary-minimize=on] .app-header-primary {
    transition: none;
    height: 70px;
    z-index: 100;
    background-color: var(--bs-app-header-primary-minimize-bg-color);
    box-shadow: var(--bs-app-header-primary-minimize-box-shadow);
    border-bottom: var(--bs-app-header-primary-minimize-border-bottom);
  }
  [data-kt-app-header-sticky=on][data-kt-app-header-primary-sticky-hide=true] .app-header-primary {
    display: none !important;
  }
  [data-kt-app-header-primary-enabled=true][data-kt-app-sidebar-fixed=true][data-kt-app-sidebar-push-header=true] .app-header-primary {
    left: calc(var(--bs-app-sidebar-width) + var(--bs-app-sidebar-gap-start, 0px) + var(--bs-app-sidebar-gap-end, 0px));
  }
  [data-kt-app-header-primary-enabled=true][data-kt-app-sidebar-panel-fixed=true][data-kt-app-sidebar-panel-push-header=true] .app-header-primary {
    left: calc(var(--bs-app-sidebar-width) + var(--bs-app-sidebar-gap-start, 0px) + var(--bs-app-sidebar-gap-end, 0px) + var(--bs-app-sidebar-panel-width) + var(--bs-app-sidebar-panel-gap-start, 0px) + var(--bs-app-sidebar-panel-gap-end, 0px));
  }
}
@media (max-width: 991.98px) {
  .app-header .app-header-primary {
    flex-grow: 1;
    height: var(--bs-app-header-primary-height);
    border-bottom: var(--bs-app-header-primary-base-border-bottom);
    box-shadow: var(--bs-app-header-primary-base-box-shadow);
  }
  .app-header-primary {
    background-color: var(--bs-app-header-primary-base-bg-color);
  }
  [data-kt-app-header-primary-enabled=true] {
    --bs-app-header-primary-height: 60px;
  }
  [data-kt-app-header-primary-enabled=true][data-kt-app-header-sticky=on] {
    --bs-app-header-primary-height: 60px;
  }
  [data-kt-app-header-primary-enabled=true][data-kt-app-header-minimize=on] {
    --bs-app-header-primary-height: 60px;
  }
}
.app-header-secondary {
  transition: none;
  display: flex;
  align-items: stretch;
}

@media (min-width: 992px) {
  .app-header-secondary {
    background-color: var(--bs-app-header-secondary-base-bg-color);
    box-shadow: var(--bs-app-header-secondary-base-box-shadow);
    border-top: var(--bs-app-header-secondary-base-border-top);
    border-bottom: var(--bs-app-header-secondary-base-border-bottom);
  }
  [data-kt-app-header-secondary-enabled=true] {
    --bs-app-header-secondary-height: 70px;
  }
  [data-kt-app-header-secondary-enabled=true][data-kt-app-header-sticky=on] {
    --bs-app-header-secondary-height: 70px;
  }
  [data-kt-app-header-secondary-enabled=true][data-kt-app-header-minimize=on] {
    --bs-app-header-secondary-height: 70px;
  }
  [data-kt-app-header-secondary-enabled=true][data-kt-app-header-sticky=on][data-kt-app-header-secondary-sticky-hide=true] {
    --bs-app-header-secondary-height: 0;
  }
  .app-header-secondary {
    height: var(--bs-app-header-secondary-height);
  }
  [data-kt-app-header-secondary-fixed=true] .app-header-secondary {
    z-index: 100;
    position: fixed;
    left: 0;
    right: 0;
    top: 0;
  }
  [data-kt-app-header-secondary-static=true] .app-header-secondary {
    position: static;
  }
  [data-kt-app-header-secondary-sticky=on] .app-header-secondary {
    transition: none;
    position: fixed;
    left: 0;
    right: 0;
    top: 0;
    height: 70px;
    z-index: 100;
    background-color: var(--bs-app-header-secondary-sticky-bg-color);
    box-shadow: var(--bs-app-header-secondary-sticky-box-shadow);
    border-bottom: var(--bs-app-header-secondary-sticky-border-bottom);
  }
  [data-kt-app-header-secondary-minimize=on] .app-header-secondary {
    transition: none;
    height: 70px;
    z-index: 100;
    background-color: var(--bs-app-header-secondary-minimize-bg-color);
    box-shadow: var(--bs-app-header-secondary-minimize-box-shadow);
    border-bottom: var(--bs-app-header-secondary-minimize-border-bottom);
  }
  [data-kt-app-header-sticky=on][data-kt-app-header-secondary-sticky-hide=true] .app-header-secondary {
    display: none !important;
  }
  [data-kt-app-header-secondary-enabled=true][data-kt-app-sidebar-fixed=true][data-kt-app-sidebar-push-header=true] .app-header-secondary {
    left: calc(var(--bs-app-sidebar-width) + var(--bs-app-sidebar-gap-start, 0px) + var(--bs-app-sidebar-gap-end, 0px));
  }
  [data-kt-app-header-secondary-enabled=true][data-kt-app-sidebar-panel-fixed=true][data-kt-app-sidebar-panel-push-header=true] .app-header-secondary {
    left: calc(var(--bs-app-sidebar-width) + var(--bs-app-sidebar-gap-start, 0px) + var(--bs-app-sidebar-gap-end, 0px) + var(--bs-app-sidebar-panel-width) + var(--bs-app-sidebar-panel-gap-start, 0px) + var(--bs-app-sidebar-panel-gap-end, 0px));
  }
}
@media (max-width: 991.98px) {
  .app-header .app-header-secondary {
    flex-grow: 1;
    height: var(--bs-app-header-secondary-height);
    box-shadow: var(--bs-app-header-secondary-base-box-shadow);
    border-top: var(--bs-app-header-secondary-base-border-top);
    border-bottom: var(--bs-app-header-secondary-base-border-bottom);
  }
  .app-header-secondary {
    background-color: var(--bs-app-header-secondary-base-bg-color);
  }
  [data-kt-app-header-secondary-enabled=true] {
    --bs-app-header-secondary-height: 60px;
  }
  [data-kt-app-header-secondary-enabled=true][data-kt-app-header-sticky=on] {
    --bs-app-header-secondary-height: 60px;
  }
  [data-kt-app-header-secondary-enabled=true][data-kt-app-header-minimize=on] {
    --bs-app-header-secondary-height: 60px;
  }
}
.app-header-tertiary {
  transition: none;
  display: flex;
  align-items: stretch;
}

@media (min-width: 992px) {
  .app-header-tertiary {
    background-color: var(--bs-app-header-tertiary-base-bg-color);
    box-shadow: var(--bs-app-header-tertiary-base-box-shadow);
    border-top: var(--bs-app-header-tertiary-base-border-top);
    border-bottom: var(--bs-app-header-tertiary-base-border-bottom);
  }
  [data-kt-app-header-tertiary-enabled=true] {
    --bs-app-header-tertiary-height: 70px;
  }
  [data-kt-app-header-tertiary-enabled=true][data-kt-app-header-sticky=on] {
    --bs-app-header-tertiary-height: 70px;
  }
  [data-kt-app-header-tertiary-enabled=true][data-kt-app-header-minimize=on] {
    --bs-app-header-tertiary-height: 70px;
  }
  [data-kt-app-header-tertiary-enabled=true][data-kt-app-header-sticky=on][data-kt-app-header-tertiary-sticky-hide=true] {
    --bs-app-header-tertiary-height: 0;
  }
  .app-header-tertiary {
    height: var(--bs-app-header-tertiary-height);
  }
  [data-kt-app-header-tertiary-fixed=true] .app-header-tertiary {
    z-index: 100;
    position: fixed;
    left: 0;
    right: 0;
    top: 0;
  }
  [data-kt-app-header-tertiary-static=true] .app-header-tertiary {
    position: static;
  }
  [data-kt-app-header-tertiary-sticky=on] .app-header-tertiary {
    transition: none;
    position: fixed;
    left: 0;
    right: 0;
    top: 0;
    height: 70px;
    z-index: 100;
    background-color: var(--bs-app-header-tertiary-sticky-bg-color);
    box-shadow: var(--bs-app-header-tertiary-sticky-box-shadow);
    border-bottom: var(--bs-app-header-tertiary-sticky-border-bottom);
  }
  [data-kt-app-header-tertiary-minimize=on] .app-header-tertiary {
    transition: none;
    height: 70px;
    z-index: 100;
    background-color: var(--bs-app-header-tertiary-minimize-bg-color);
    box-shadow: var(--bs-app-header-tertiary-minimize-box-shadow);
    border-bottom: var(--bs-app-header-tertiary-minimize-border-bottom);
  }
  [data-kt-app-header-sticky=on][data-kt-app-header-tertiary-sticky-hide=true] .app-header-tertiary {
    display: none !important;
  }
  [data-kt-app-header-tertiary-enabled=true][data-kt-app-sidebar-fixed=true][data-kt-app-sidebar-push-header=true] .app-header-tertiary {
    left: calc(var(--bs-app-sidebar-width) + var(--bs-app-sidebar-gap-start, 0px) + var(--bs-app-sidebar-gap-end, 0px));
  }
  [data-kt-app-header-tertiary-enabled=true][data-kt-app-sidebar-panel-fixed=true][data-kt-app-sidebar-panel-push-header=true] .app-header-tertiary {
    left: calc(var(--bs-app-sidebar-width) + var(--bs-app-sidebar-gap-start, 0px) + var(--bs-app-sidebar-gap-end, 0px) + var(--bs-app-sidebar-panel-width) + var(--bs-app-sidebar-panel-gap-start, 0px) + var(--bs-app-sidebar-panel-gap-end, 0px));
  }
}
@media (max-width: 991.98px) {
  .app-header .app-header-tertiary {
    flex-grow: 1;
    height: var(--bs-app-header-tertiary-height);
    border-top: var(--bs-app-header-tertiary-base-border-top);
    box-shadow: var(--bs-app-header-tertiary-base-box-shadow);
  }
  .app-header-tertiary {
    background-color: var(--bs-app-header-tertiary-base-bg-color);
  }
  [data-kt-app-header-tertiary-enabled=true] {
    --bs-app-header-tertiary-height: 70px;
  }
  [data-kt-app-header-tertiary-enabled=true][data-kt-app-header-sticky=on] {
    --bs-app-header-tertiary-height: 60px;
  }
  [data-kt-app-header-secondary-enabled=true][data-kt-app-header-minimize=on] {
    --bs-app-header-tertiary-height: 60px;
  }
}
.app-toolbar {
  display: flex;
  align-items: stretch;
  background-color: var(--bs-app-toolbar-base-bg-color);
  box-shadow: var(--bs-app-toolbar-base-box-shadow);
  border-top: var(--bs-app-toolbar-base-border-top);
  border-bottom: var(--bs-app-toolbar-base-border-bottom);
}

.app-toolbar.app-toolbar-minimize {
  transition: none;
}

@media (min-width: 992px) {
  :root {
    --bs-app-toolbar-height: 55px;
    --bs-app-toolbar-height-actual: 55px;
  }
  [data-kt-app-toolbar-sticky=on] {
    --bs-app-toolbar-height: 70px;
  }
  [data-kt-app-toolbar-minimize=on] {
    --bs-app-toolbar-height: 70px;
  }
  .app-toolbar {
    height: var(--bs-app-toolbar-height);
  }
  [data-kt-app-header-fixed=true][data-kt-app-toolbar-fixed=true] .app-toolbar {
    z-index: 99;
    position: fixed;
    left: 0;
    right: 0;
    top: 0;
  }
  [data-kt-app-toolbar-sticky=on] .app-toolbar {
    position: fixed;
    left: 0;
    right: 0;
    top: 0;
    box-shadow: var(--bs-app-toolbar-sticky-box-shadow);
    background-color: var(--bs-app-toolbar-sticky-bg-color);
    border-top: var(--bs-app-toolbar-sticky-border-top);
    border-bottom: var(--bs-app-toolbar-sticky-border-bottom);
    z-index: 99;
  }
  [data-kt-app-toolbar-minimize=on] .app-toolbar {
    transition: none;
    box-shadow: var(--bs-app-toolbar-minimize-box-shadow);
    background-color: var(--bs-app-toolbar-minimize-bg-color);
    border-top: var(--bs-app-toolbar-minimize-border-top);
    border-bottom: var(--bs-app-toolbar-minimize-border-bottom);
    z-index: 99;
  }
  [data-kt-app-toolbar-fixed=true][data-kt-app-header-fixed=true] .app-toolbar {
    top: var(--bs-app-header-height);
  }
  [data-kt-app-toolbar-sticky=on][data-kt-app-sidebar-fixed=true][data-kt-app-sidebar-push-toolbar=true] .app-toolbar, [data-kt-app-toolbar-fixed=true][data-kt-app-sidebar-fixed=true][data-kt-app-sidebar-push-toolbar=true] .app-toolbar {
    left: calc(var(--bs-app-sidebar-width) + var(--bs-app-sidebar-gap-start, 0px) + var(--bs-app-sidebar-gap-end, 0px));
  }
  [data-kt-app-toolbar-sticky=on][data-kt-app-sidebar-panel-fixed=true][data-kt-app-sidebar-panel-push-toolbar=true] .app-toolbar, [data-kt-app-toolbar-fixed=true][data-kt-app-sidebar-panel-fixed=true][data-kt-app-sidebar-panel-push-toolbar=true] .app-toolbar {
    left: calc(var(--bs-app-sidebar-width) + var(--bs-app-sidebar-gap-start, 0px) + var(--bs-app-sidebar-gap-end, 0px) + var(--bs-app-sidebar-panel-width) + var(--bs-app-sidebar-panel-gap-start, 0px) + var(--bs-app-sidebar-panel-gap-end, 0px));
  }
  [data-kt-app-toolbar-sticky=on][data-kt-app-aside-fixed=true][data-kt-app-aside-push-toolbar=true] .app-toolbar, [data-kt-app-toolbar-fixed=true][data-kt-app-aside-fixed=true][data-kt-app-aside-push-toolbar=true] .app-toolbar {
    right: calc(var(--bs-app-aside-width) + var(--bs-app-aside-gap-start, 0px) + var(--bs-app-aside-gap-end, 0px));
  }
}
@media (max-width: 991.98px) {
  :root {
    --bs-app-toolbar-height: ;
  }
  [data-kt-app-toolbar-sticky=on] {
    --bs-app-toolbar-height: 70px;
  }
  [data-kt-app-toolbar-minimize=on] {
    --bs-app-toolbar-height: 70px;
  }
  .app-toolbar {
    height: var(--bs-app-toolbar-height);
  }
  [data-kt-app-header-fixed-mobile=true][data-kt-app-toolbar-fixed-mobile=true] .app-toolbar {
    z-index: 99;
    position: fixed;
    top: calc(var(--bs-app-header-height, 0px) + var(--bs-app-header-mobile-height, 0px));
    left: 0;
    right: 0;
  }
  [data-kt-app-toolbar-sticky=on] .app-toolbar {
    position: fixed;
    left: 0;
    right: 0;
    top: var(--bs-app-header-height, 0px);
    box-shadow: var(--bs-app-toolbar-sticky-box-shadow);
    background-color: var(--bs-app-toolbar-sticky-bg-color);
    border-top: var(--bs-app-toolbar-sticky-border-top);
    border-bottom: var(--bs-app-toolbar-sticky-border-bottom);
    z-index: 99;
  }
  [data-kt-app-toolbar-minimize=on] .app-toolbar {
    transition: none;
    box-shadow: var(--bs-app-toolbar-minimize-box-shadow);
    background-color: var(--bs-app-toolbar-minimize-bg-color);
    border-top: var(--bs-app-toolbar-minimize-border-top);
    border-bottom: var(--bs-app-toolbar-minimize-border-bottom);
    z-index: 99;
  }
}
.app-hero {
  display: flex;
  align-items: stretch;
  background-color: var(--bs-app-hero-bg-color);
  box-shadow: var(--bs-app-hero-box-shadow);
  border-top: var(--bs-app-hero-border-top);
  border-bottom: var(--bs-app-hero-border-bottom);
}

.app-sidebar {
  transition: width 0.3s ease;
  background-color: var(--bs-app-sidebar-base-bg-color);
  box-shadow: var(--bs-app-sidebar-base-box-shadow);
  border-left: var(--bs-app-sidebar-base-border-start);
  border-right: var(--bs-app-sidebar-base-border-end);
}

.app-sidebar-minimize-d-flex,
.app-sidebar-sticky-d-flex,
.app-sidebar-collapse-d-flex,
.app-sidebar-minimize-mobile-d-flex,
.app-sidebar-collapse-mobile-d-flex {
  display: none;
}

@media (min-width: 992px) {
  .app-sidebar {
    display: flex;
    flex-shrink: 0;
    width: var(--bs-app-sidebar-width);
    margin-left: 0px;
    margin-right: 0px;
    margin-top: 0px;
    margin-bottom: 0px;
  }
  :root {
    --bs-app-sidebar-width: 265px;
    --bs-app-sidebar-width-actual: 265px;
    --bs-app-sidebar-gap-start: 0px;
    --bs-app-sidebar-gap-end: 0px;
    --bs-app-sidebar-gap-top: 0px;
    --bs-app-sidebar-gap-bottom: 0px;
  }
  [data-kt-app-sidebar-stacked=true] {
    --bs-app-sidebar-width: calc(var(--bs-app-sidebar-primary-width) + var(--bs-app-sidebar-secondary-width, 0px));
  }
  [data-kt-app-sidebar-minimize=on] {
    --bs-app-sidebar-width: 75px;
    --bs-app-sidebar-gap-start: 0px;
    --bs-app-sidebar-gap-end: 0px;
    --bs-app-sidebar-gap-top: 0px;
    --bs-app-sidebar-gap-bottom: 0px;
  }
  [data-kt-app-sidebar-sticky=on] {
    --bs-app-sidebar-width: 300px;
    --bs-app-sidebar-gap-start: 0px;
    --bs-app-sidebar-gap-end: 0px;
    --bs-app-sidebar-gap-top: 0px;
    --bs-app-sidebar-gap-bottom: 0px;
  }
  [data-kt-app-sidebar-collapse=on] {
    --bs-app-sidebar-width: 0px;
  }
  [data-kt-app-sidebar-static=true] .app-sidebar {
    position: relative;
  }
  [data-kt-app-sidebar-offcanvas=true] .app-sidebar {
    display: none;
  }
  [data-kt-app-sidebar-fixed=true] .app-sidebar {
    position: fixed;
    z-index: 105;
    top: 0;
    bottom: 0;
    left: 0;
  }
  [data-kt-app-sidebar-stacked=true] .app-sidebar {
    align-items: stretch;
  }
  [data-kt-app-sidebar-sticky=on] .app-sidebar {
    position: fixed;
    transition: width 0.3s ease;
    top: auto;
    bottom: auto;
    left: auto;
    z-index: 105;
    box-shadow: var(--bs-app-sidebar-sticky-box-shadow);
    border-left: var(--bs-app-sidebar-sticky-border-start);
    border-right: var(--bs-app-sidebar-sticky-border-end);
    margin-left: 0px;
    margin-right: 0px;
    margin-top: 0px;
    margin-bottom: 0px;
  }
  [data-kt-app-sidebar-minimize=on] .app-sidebar {
    transition: width 0.3s ease;
    margin-left: 0px;
    margin-right: 0px;
    margin-top: 0px;
    margin-bottom: 0px;
  }
  [data-kt-app-sidebar-hoverable=true] .app-sidebar .app-sidebar-wrapper {
    width: var(--bs-app-sidebar-width-actual);
  }
  [data-kt-app-sidebar-hoverable=true][data-kt-app-sidebar-minimize=on] .app-sidebar:hover:not(.animating) {
    transition: width 0.3s ease;
    width: var(--bs-app-sidebar-width-actual);
  }
  [data-kt-app-sidebar-collapse=on] .app-sidebar {
    transition: width 0.3s ease;
    width: var(--bs-app-sidebar-width-actual);
    margin-left: calc(-1 * var(--bs-app-sidebar-width-actual));
  }
  [data-kt-app-sidebar-minimize=on] .app-sidebar-minimize-d-none {
    display: none !important;
  }
  [data-kt-app-sidebar-minimize=on] .app-sidebar-minimize-d-flex {
    display: flex !important;
  }
  [data-kt-app-sidebar-sticky=on] .app-sidebar-sticky-d-none {
    display: none !important;
  }
  [data-kt-app-sidebar-sticky=on] .app-sidebar-sticky-d-flex {
    display: flex !important;
  }
  [data-kt-app-sidebar-collapse=on] .app-sidebar-collapse-d-none {
    display: none !important;
  }
  [data-kt-app-sidebar-collapse=on] .app-sidebar-collapse-d-flex {
    display: flex !important;
  }
  [data-kt-app-sidebar-fixed=true][data-kt-app-header-fixed=true]:not([data-kt-app-sidebar-push-header=true]) .app-sidebar {
    top: var(--bs-app-header-height);
  }
  [data-kt-app-sidebar-fixed=true][data-kt-app-header-fixed=true][data-kt-app-toolbar-fixed=true]:not([data-kt-app-sidebar-push-toolbar=true]) .app-sidebar {
    top: calc(var(--bs-app-header-height) + var(--bs-app-toolbar-height, 0px));
  }
}
@media (max-width: 991.98px) {
  .app-sidebar {
    display: none;
    width: var(--bs-app-sidebar-width);
    z-index: 106;
    margin-left: 0px;
    margin-right: 0px;
    margin-top: 0px;
    margin-bottom: 0px;
  }
  :root {
    --bs-app-sidebar-width: 250px;
    --bs-app-sidebar-width-actual: 250px;
    --bs-app-sidebar-gap-start: 0px;
    --bs-app-sidebar-gap-end: 0px;
    --bs-app-sidebar-gap-top: 0px;
    --bs-app-sidebar-gap-bottom: 0px;
  }
  [data-kt-app-sidebar-stacked=true] {
    --bs-app-sidebar-width: calc(var(--bs-app-sidebar-primary-width) + var(--bs-app-sidebar-secondary-width, 0));
  }
  [data-kt-app-sidebar-minimize-mobile=on] {
    --bs-app-sidebar-width: 75px;
    --bs-app-sidebar-gap-start: 0px;
    --bs-app-sidebar-gap-end: 0px;
    --bs-app-sidebar-gap-top: 0px;
    --bs-app-sidebar-gap-bottom: 0px;
  }
  [data-kt-app-sidebar-collapse-mobile=on] {
    --bs-app-sidebar-width: 0px;
  }
  [data-kt-app-sidebar-stacked=true] .app-sidebar {
    align-items: stretch;
  }
  [data-kt-app-sidebar-minimize-mobile=on] .app-sidebar {
    transition: width 0.3s ease;
    margin-left: 0px;
    margin-right: 0px;
    margin-top: 0px;
    margin-bottom: 0px;
  }
  [data-kt-app-sidebar-hoverable-mobile=true] .app-sidebar .app-sidebar-wrapper {
    width: var(--bs-app-sidebar-width-actual);
  }
  [data-kt-app-sidebar-hoverable-mobile=true][data-kt-app-sidebar-minimize-mobile=on] .app-sidebar:hover:not(.animating) {
    transition: width 0.3s ease;
    width: var(--bs-app-sidebar-width-actual);
    box-shadow: var(--bs-app-sidebar-minimize-hover-box-shadow-mobile);
  }
  [data-kt-app-sidebar-collapse-mobile=on] .app-sidebar {
    transition: width 0.3s ease;
    width: var(--bs-app-sidebar-width-actual);
    margin-left: calc(-1 * var(--bs-app-sidebar-width-actual));
  }
  [data-kt-app-sidebar-minimize-mobile=on] .app-sidebar-minimize-mobile-d-none {
    display: none !important;
  }
  [data-kt-app-sidebar-minimize-mobile=on] .app-sidebar-minimize-mobile-d-flex {
    display: flex !important;
  }
  [data-kt-app-sidebar-collapse-mobile=on] .app-sidebar-collapse-mobile-d-none {
    display: none !important;
  }
  [data-kt-app-sidebar-collapse-mobile=on] .app-sidebar-collapse-mobile-d-flex {
    display: flex !important;
  }
}
.app-sidebar-primary {
  transition: none;
  position: relative;
  flex-shrink: 0;
  background-color: var(--bs-app-sidebar-primary-base-bg-color);
  box-shadow: var(--bs-app-sidebar-primary-base-box-shadow);
  border-left: var(--bs-app-sidebar-primary-base-border-start);
  border-right: var(--bs-app-sidebar-primary-base-border-end);
}

.app-sidebar-primary-collapse-d-flex,
.app-sidebar-primary-minimize-d-flex,
.app-sidebar-primary-collapse-mobile-d-flex,
.app-sidebar-primary-minimize-mobile-d-flex {
  display: none;
}

@media (min-width: 992px) {
  .app-sidebar-primary {
    z-index: 1;
    margin-left: 0px;
    margin-right: 0px;
    margin-top: 0px;
    margin-bottom: 0px;
  }
  :root {
    --bs-app-sidebar-primary-width-actual: 100px;
  }
  [data-kt-app-sidebar-stacked=true] {
    --bs-app-sidebar-primary-width: 100px;
    --bs-app-sidebar-primary-gap-start: 0px;
    --bs-app-sidebar-primary-gap-end: 0px;
    --bs-app-sidebar-primary-gap-top: 0px;
    --bs-app-sidebar-primary-gap-bottom: 0px;
  }
  [data-kt-app-sidebar-primary-minimize=on] {
    --bs-app-sidebar-primary-width: 75px;
    --bs-app-sidebar-primary-gap-start: 0px;
    --bs-app-sidebar-primary-gap-end: 0px;
    --bs-app-sidebar-primary-gap-top: 0px;
    --bs-app-sidebar-primary-gap-bottom: 0px;
  }
  [data-kt-app-sidebar-primary-collapse=on] {
    --bs-app-sidebar-primary-width: 0px;
  }
  .app-sidebar-primary {
    width: var(--bs-app-sidebar-primary-width);
  }
  [data-kt-app-sidebar-primary-collapse=on] .app-sidebar-primary {
    transition: none;
    width: var(--bs-app-sidebar-primary-width-actual);
    margin-left: calc(-1 * var(--bs-app-sidebar-primary-width-actual));
  }
  [data-kt-app-sidebar-primary-minimize=on] .app-sidebar-primary {
    transition: none;
    margin-left: 0px;
    margin-right: 0px;
    margin-top: 0px;
    margin-bottom: 0px;
  }
  [data-kt-app-sidebar-primary-hoverable=true] .app-sidebar-primary .app-sidebar-primary-hoverable {
    width: var(--bs-app-sidebar-primary-width-actual);
  }
  [data-kt-app-sidebar-primary-hoverable=true][data-kt-app-sidebar-primary-minimize=on] .app-sidebar-primary:hover:not(.animating) {
    transition: none;
    width: var(--bs-app-sidebar-primary-width-actual);
    box-shadow: var(--bs-app-sidebar-primary-minimize-hover-box-shadow);
  }
  [data-kt-app-sidebar-fixed=true][data-kt-app-header-fixed=true][data-kt-app-sidebar-primary-below-header=true] .app-sidebar-primary {
    top: var(--bs-app-header-height);
  }
  [data-kt-app-sidebar-fixed=true][data-kt-app-header-fixed=true][data-kt-app-toolbar-fixed=true][data-kt-app-sidebar-primary-below-toolbar=true] .app-sidebar-primary {
    top: calc(var(--bs-app-header-height) + var(--bs-app-toolbar-height, 0));
  }
  [data-kt-app-sidebar-primary-minimize=on] .app-sidebar-primary-minimize-d-none {
    display: none !important;
  }
  [data-kt-app-sidebar-primary-minimize=on] .app-sidebar-primary-minimize-d-flex {
    display: flex !important;
  }
  [data-kt-app-sidebar-primary-collapse=on] .app-sidebar-primary-collapse-d-none {
    display: none !important;
  }
  [data-kt-app-sidebar-primary-collapse=on] .app-sidebar-primary-collapse-d-flex {
    display: flex !important;
  }
}
@media (max-width: 991.98px) {
  .app-sidebar-primary {
    z-index: 1;
    margin-left: 0px;
    margin-right: 0px;
    margin-top: 0px;
    margin-bottom: 0px;
  }
  :root {
    --bs-app-sidebar-primary-width-actual: 100px;
  }
  [data-kt-app-sidebar-stacked=true] {
    --bs-app-sidebar-primary-width: 100px;
    --bs-app-sidebar-primary-gap-start: 0px;
    --bs-app-sidebar-primary-gap-end: 0px;
    --bs-app-sidebar-primary-gap-top: 0px;
    --bs-app-sidebar-primary-gap-bottom: 0px;
  }
  [data-kt-app-sidebar-primary-minimize-mobile=on] {
    --bs-app-sidebar-primary-width: 75px;
    --bs-app-sidebar-primary-gap-start: 0px;
    --bs-app-sidebar-primary-gap-end: 0px;
    --bs-app-sidebar-primary-gap-top: 0px;
    --bs-app-sidebar-primary-gap-bottom: 0px;
  }
  [data-kt-app-sidebar-primary-collapse-mobile=on] {
    --bs-app-sidebar-primary-width: 0px;
  }
  .app-sidebar-primary {
    width: var(--bs-app-sidebar-primary-width);
  }
  [data-kt-app-sidebar-primary-collapse-mobile=on] .app-sidebar-primary {
    transition: none;
    width: var(--bs-app-sidebar-primary-width-actual);
    margin-left: calc(-1 * var(--bs-app-sidebar-primary-width-actual));
  }
  [data-kt-app-sidebar-primary-minimize-mobile=on] .app-sidebar-primary {
    transition: none;
    margin-left: 0px;
    margin-right: 0px;
    margin-top: 0px;
    margin-bottom: 0px;
  }
  [data-kt-app-sidebar-primary-hoverable-mobile=true] .app-sidebar-primary .app-sidebar-primary-hoverable {
    width: var(--bs-app-sidebar-primary-width-actual);
  }
  [data-kt-app-sidebar-primary-hoverable-mobile=true][data-kt-app-sidebar-primary-minimize-mobile=on] .app-sidebar-primary:hover:not(.animating) {
    transition: none;
    width: var(--bs-app-sidebar-primary-width-actual);
    box-shadow: var(--bs-app-sidebar-primary-minimize-hover-box-shadow-mobile);
  }
  [data-kt-app-sidebar-primary-minimize-mobile=on] .app-sidebar-primary-minimize-mobile-d-none {
    display: none !important;
  }
  [data-kt-app-sidebar-primary-minimize-mobile=on] .app-sidebar-primary-minimize-mobile-d-flex {
    display: flex !important;
  }
  [data-kt-app-sidebar-primary-collapse-mobile=on] .app-sidebar-primary-collapse-mobile-d-none {
    display: none !important;
  }
  [data-kt-app-sidebar-primary-collapse-mobile=on] .app-sidebar-primary-collapse-mobile-d-flex {
    display: flex !important;
  }
}
.app-sidebar-secondary {
  transition: width 0.3s ease, margin 0.3s ease;
  position: relative;
  flex-shrink: 0;
  background-color: var(--bs-app-sidebar-secondary-base-bg-color);
  box-shadow: var(--bs-app-sidebar-secondary-base-box-shadow);
  border-left: var(--bs-app-sidebar-secondary-base-border-start);
  border-right: var(--bs-app-sidebar-secondary-base-border-end);
}

.app-sidebar-secondary-collapse-d-flex,
.app-sidebar-secondary-minimize-d-flex,
.app-sidebar-secondary-collapse-mobile-d-flex,
.app-sidebar-secondary-minimize-mobile-d-flex {
  display: none;
}

@media (min-width: 992px) {
  .app-sidebar-secondary {
    margin-left: 0px;
    margin-right: 0px;
    margin-top: 0px;
    margin-bottom: 0px;
  }
  [data-kt-app-sidebar-secondary-enabled=true] {
    --bs-app-sidebar-secondary-width-actual: calc(
        265px -
        100px -
        0px -
        0px -
        0px -
        0px
    );
  }
  [data-kt-app-sidebar-secondary-enabled=true][data-kt-app-sidebar-stacked=true] {
    --bs-app-sidebar-secondary-width: calc(
        265px -
        100px -
        0px -
        0px -
        0px -
        0px
    );
    --bs-app-sidebar-secondary-gap-start: 0px;
    --bs-app-sidebar-secondary-gap-end: 0px;
    --bs-app-sidebar-secondary-gap-top: 0px;
    --bs-app-sidebar-secondary-gap-bottom: 0px;
  }
  [data-kt-app-sidebar-secondary-enabled=true][data-kt-app-sidebar-secondary-minimize=on] {
    --bs-app-sidebar-secondary-width: 75px;
    --bs-app-sidebar-secondary-gap-start: 0px;
    --bs-app-sidebar-secondary-gap-end: 0px;
    --bs-app-sidebar-secondary-gap-top: 0px;
    --bs-app-sidebar-secondary-gap-bottom: 0px;
  }
  [data-kt-app-sidebar-secondary-enabled=true][data-kt-app-sidebar-secondary-collapse=on] {
    --bs-app-sidebar-secondary-width-actual: calc(
        265px -
        100px -
        0px -
        0px -
        0px -
        0px
    );
    --bs-app-sidebar-secondary-width: 0px;
  }
  .app-sidebar-secondary {
    width: var(--bs-app-sidebar-secondary-width);
  }
  [data-kt-app-sidebar-secondary-collapse=on] .app-sidebar-secondary {
    transition: width 0.3s ease, margin 0.3s ease;
    width: var(--bs-app-sidebar-secondary-width-actual);
    margin-left: calc(-1 * var(--bs-app-sidebar-secondary-width-actual));
  }
  [data-kt-app-sidebar-secondary-minimize=on] .app-sidebar-secondary {
    transition: width 0.3s ease, margin 0.3s ease;
    margin-left: 0px;
    margin-right: 0px;
    margin-top: 0px;
    margin-bottom: 0px;
  }
  [data-kt-app-sidebar-secondary-hoverable=true] .app-sidebar-secondary .app-sidebar-secondary-hoverable {
    width: var(--bs-app-sidebar-secondary-width-actual);
  }
  [data-kt-app-sidebar-secondary-hoverable=true][data-kt-app-sidebar-secondary-minimize=on] .app-sidebar-secondary:hover:not(.animating) {
    transition: width 0.3s ease, margin 0.3s ease;
    width: var(--bs-app-sidebar-secondary-width-actual);
    box-shadow: var(--bs-app-sidebar-secondary-minimize-hover-box-shadow);
  }
  [data-kt-app-sidebar-fixed=true][data-kt-app-header-fixed=true][data-kt-app-sidebar-secondary-below-header=true] .app-sidebar-secondary {
    top: var(--bs-app-header-height);
  }
  [data-kt-app-sidebar-fixed=true][data-kt-app-header-fixed=true][data-kt-app-toolbar-fixed=true][data-kt-app-sidebar-secondary-below-toolbar=true] .app-sidebar-secondary {
    top: calc(var(--bs-app-header-height) + var(--bs-app-toolbar-height, 0));
  }
  [data-kt-app-sidebar-secondary-enabled=true][data-kt-app-sidebar-secondary-minimize=on] .app-sidebar-secondary-minimize-d-none {
    display: none !important;
  }
  [data-kt-app-sidebar-secondary-enabled=true][data-kt-app-sidebar-secondary-minimize=on] .app-sidebar-secondary-minimize-d-flex {
    display: flex !important;
  }
  [data-kt-app-sidebar-secondary-enabled=true][data-kt-app-sidebar-secondary-collapse=on] .app-sidebar-secondary-collapse-d-none {
    display: none !important;
  }
  [data-kt-app-sidebar-secondary-enabled=true][data-kt-app-sidebar-secondary-collapse=on] .app-sidebar-secondary-collapse-d-flex {
    display: flex !important;
  }
}
@media (max-width: 991.98px) {
  .app-sidebar-secondary {
    margin-left: 0px;
    margin-right: 0px;
    margin-top: 0px;
    margin-bottom: 0px;
  }
  [data-kt-app-sidebar-secondary-enabled=true] {
    --bs-app-sidebar-secondary-width-actual: calc(
        250px -
        100px -
        0px -
        0px -
        0px -
        0px
    );
  }
  [data-kt-app-sidebar-secondary-enabled=true][data-kt-app-sidebar-stacked=true] {
    --bs-app-sidebar-secondary-width: calc(
        250px -
        100px -
        0px -
        0px -
        0px -
        0px
    );
    --bs-app-sidebar-secondary-gap-start: 0px;
    --bs-app-sidebar-secondary-gap-end: 0px;
    --bs-app-sidebar-secondary-gap-top: 0px;
    --bs-app-sidebar-secondary-gap-bottom: 0px;
  }
  [data-kt-app-sidebar-secondary-enabled=true][data-kt-app-sidebar-secondary-minimize-mobile=on] {
    --bs-app-sidebar-secondary-width: 75px;
    --bs-app-sidebar-secondary-gap-start: 0px;
    --bs-app-sidebar-secondary-gap-end: 0px;
    --bs-app-sidebar-secondary-gap-top: 0px;
    --bs-app-sidebar-secondary-gap-bottom: 0px;
  }
  [data-kt-app-sidebar-secondary-enabled=true][data-kt-app-sidebar-secondary-collapse-mobile=on] {
    --bs-app-sidebar-secondary-width-actual: calc(
        250px -
        100px -
        0px -
        0px -
        0px -
        0px
    );
    --bs-app-sidebar-secondary-width: 0px;
  }
  .app-sidebar-secondary {
    width: var(--bs-app-sidebar-secondary-width);
  }
  [data-kt-app-sidebar-secondary-collapse-mobile=on] .app-sidebar-secondary {
    transition: width 0.3s ease, margin 0.3s ease;
    width: var(--bs-app-sidebar-secondary-width-actual);
    margin-left: calc(-1 * var(--bs-app-sidebar-secondary-width-actual));
  }
  [data-kt-app-sidebar-secondary-minimize-mobile=on] .app-sidebar-secondary {
    transition: width 0.3s ease, margin 0.3s ease;
    background-color: var(--bs-app-sidebar-secondary-minimize-bg-color-mobile);
    box-shadow: var(--bs-app-sidebar-secondary-minimize-box-shadow-mobile);
    border-left: var(--bs-app-sidebar-secondary-minimize-border-start-mobile);
    border-right: var(--bs-app-sidebar-secondary-minimize-border-end-mobile);
  }
  [data-kt-app-sidebar-secondary-hoverable-mobile=true] .app-sidebar-secondary .app-sidebar-secondary-hoverable {
    width: var(--bs-app-sidebar-secondary-width-actual);
  }
  [data-kt-app-sidebar-secondary-hoverable-mobile=true][data-kt-app-sidebar-secondary-minimize-mobile=on] .app-sidebar-secondary:hover:not(.animating) {
    transition: width 0.3s ease, margin 0.3s ease;
    width: var(--bs-app-sidebar-secondary-width-actual);
    box-shadow: var(--bs-app-sidebar-secondary-minimize-hover-box-shadow-mobile);
  }
  [data-kt-app-sidebar-secondary-enabled=true][data-kt-app-sidebar-secondary-minimize-mobile=on] .app-sidebar-secondary-minimize-mobile-d-none {
    display: none !important;
  }
  [data-kt-app-sidebar-secondary-enabled=true][data-kt-app-sidebar-secondary-minimize-mobile=on] .app-sidebar-secondary-minimize-mobile-d-flex {
    display: flex !important;
  }
  [data-kt-app-sidebar-secondary-enabled=true][data-kt-app-sidebar-secondary-collapse=on] .app-sidebar-secondary-collapse-mobile-d-none {
    display: none !important;
  }
  [data-kt-app-sidebar-secondary-enabled=true][data-kt-app-sidebar-secondary-collapse=on] .app-sidebar-secondary-collapse-mobile-d-flex {
    display: flex !important;
  }
}
.app-sidebar-panel {
  transition: none;
  background-color: var(--bs-app-sidebar-panel-base-bg-color);
  box-shadow: var(--bs-app-sidebar-panel-base-box-shadow);
  border-left: var(--bs-app-sidebar-panel-base-border-start);
  border-right: var(--bs-app-sidebar-panel-base-border-end);
}

.app-sidebar-panel-minimize-d-flex,
.app-sidebar-panel-sticky-d-flex,
.app-sidebar-panel-collapse-d-flex,
.app-sidebar-panel-minimize-mobile-d-flex,
.app-sidebar-panel-collapse-mobile-d-flex {
  display: none;
}

@media (min-width: 992px) {
  .app-sidebar-panel {
    display: flex;
    flex-shrink: 0;
    width: var(--bs-app-sidebar-panel-width);
    margin-left: 0px;
    margin-right: 0px;
    margin-top: 0px;
    margin-bottom: 0px;
  }
  :root {
    --bs-app-sidebar-panel-width: 300px;
    --bs-app-sidebar-panel-width-actual: 300px;
    --bs-app-sidebar-panel-gap-start: 0px;
    --bs-app-sidebar-panel-gap-end: 0px;
    --bs-app-sidebar-panel-gap-top: 0px;
    --bs-app-sidebar-panel-gap-bottom: 0px;
  }
  [data-kt-app-sidebar-panel-minimize=on] {
    --bs-app-sidebar-panel-width: 75px;
    --bs-app-sidebar-panel-gap-start: 0px;
    --bs-app-sidebar-panel-gap-end: 0px;
    --bs-app-sidebar-panel-gap-top: 0px;
    --bs-app-sidebar-panel-gap-bottom: 0px;
  }
  [data-kt-app-sidebar-panel-sticky=on] {
    --bs-app-sidebar-panel-width: 300px;
    --bs-app-sidebar-panel-gap-start: 0px;
    --bs-app-sidebar-panel-gap-end: 0px;
    --bs-app-sidebar-panel-gap-top: 0px;
    --bs-app-sidebar-panel-gap-bottom: 0px;
  }
  [data-kt-app-sidebar-panel-collapse=on] {
    --bs-app-sidebar-panel-width-actual: 300px;
    --bs-app-sidebar-panel-width: 0px;
  }
  [data-kt-app-sidebar-panel-static=true] .app-sidebar-panel {
    position: relative;
  }
  [data-kt-app-sidebar-panel-offcanvas=true] .app-sidebar-panel {
    display: none;
  }
  [data-kt-app-sidebar-panel-fixed=true] .app-sidebar-panel {
    z-index: 104;
    position: fixed;
    left: calc(var(--bs-app-sidebar-width) + var(--bs-app-sidebar-gap-start, 0px) + var(--bs-app-sidebar-gap-end, 0px));
    top: 0;
    bottom: 0;
  }
  [data-kt-app-sidebar-panel-sticky=on] .app-sidebar-panel {
    position: fixed;
    left: calc(var(--bs-app-sidebar-width) + var(--bs-app-sidebar-gap-start, 0px) + var(--bs-app-sidebar-gap-end, 0px));
    top: 0;
    bottom: 0;
    transition: none;
    z-index: 104;
    margin-left: 0px;
    margin-right: 0px;
    margin-top: 0px;
    margin-bottom: 0px;
  }
  [data-kt-app-sidebar-panel-minimize=on] .app-sidebar-panel {
    transition: none;
    margin-left: 0px;
    margin-right: 0px;
    margin-top: 0px;
    margin-bottom: 0px;
  }
  [data-kt-app-sidebar-panel-hoverable=true] .app-sidebar-panel .app-sidebar-panel-hoverable {
    width: var(--bs-app-sidebar-panel-width-actual);
  }
  [data-kt-app-sidebar-panel-hoverable=true][data-kt-app-sidebar-panel-minimize=on] .app-sidebar-panel:hover:not(.animating) {
    transition: none;
    width: var(--bs-app-sidebar-panel-width-actual);
    box-shadow: var(--bs-app-sidebar-panel-minimize-hover-box-shadow);
  }
  [data-kt-app-sidebar-panel-collapse=on] .app-sidebar-panel {
    transition: none;
    width: var(--bs-app-sidebar-panel-width-actual);
    margin-left: calc(-1 * (var(--bs-app-sidebar-panel-width-actual) + var(--bs-app-sidebar-gap-start, 0px) + var(--bs-app-sidebar-gap-end, 0px)));
  }
  [data-kt-app-sidebar-panel-fixed=true][data-kt-app-header-fixed=true]:not([data-kt-app-sidebar-panel-push-header=true]) .app-sidebar-panel {
    top: var(--bs-app-header-height);
  }
  [data-kt-app-sidebar-panel-fixed=true][data-kt-app-header-fixed=true][data-kt-app-toolbar-fixed=true]:not([data-kt-app-sidebar-panel-push-toolbar=true]) .app-sidebar-panel {
    top: calc(var(--bs-app-header-height) + var(--bs-app-toolbar-height, 0));
  }
  [data-kt-app-sidebar-panel-minimize=on] .app-sidebar-panel-minimize-d-none {
    display: none !important;
  }
  [data-kt-app-sidebar-panel-minimize=on] .app-sidebar-panel-minimize-d-flex {
    display: flex !important;
  }
  [data-kt-app-sidebar-panel-sticky=on] .app-sidebar-panel-sticky-d-none {
    display: none !important;
  }
  [data-kt-app-sidebar-panel-sticky=on] .app-sidebar-panel-sticky-d-flex {
    display: flex !important;
  }
  [data-kt-app-sidebar-panel-collapse=on] .app-sidebar-panel-collapse-d-none {
    display: none !important;
  }
  [data-kt-app-sidebar-panel-collapse=on] .app-sidebar-panel-collapse-d-flex {
    display: flex !important;
  }
}
@media (max-width: 991.98px) {
  .app-sidebar-panel {
    display: none;
    width: var(--bs-app-sidebar-panel-width);
    margin-left: 0px;
    margin-right: 0px;
    margin-top: 0px;
    margin-bottom: 0px;
  }
  :root {
    --bs-app-sidebar-panel-gap-start: 0px;
    --bs-app-sidebar-panel-gap-end: 0px;
    --bs-app-sidebar-panel-gap-top: 0px;
    --bs-app-sidebar-panel-gap-bottom: 0px;
  }
  [data-kt-app-sidebar-panel-minimize-mobile=on] {
    --bs-app-sidebar-panel-width: 75px;
    --bs-app-sidebar-panel-gap-start: 0px;
    --bs-app-sidebar-panel-gap-end: 0px;
    --bs-app-sidebar-panel-gap-top: 0px;
    --bs-app-sidebar-panel-gap-bottom: 0px;
  }
  [data-kt-app-sidebar-panel-collapse-mobile=on] {
    --bs-app-sidebar-panel-width-actual: 300px;
    --bs-app-sidebar-panel-width: 0px;
  }
  [data-kt-app-sidebar-panel-minimize-mobile=on] .app-sidebar-panel {
    transition: none;
    background-color: var(--bs-app-sidebar-panel-minimize-bg-color-mobile);
    box-shadow: var(--bs-app-sidebar-panel-minimize-box-shadow-mobile);
    border-left: var(--bs-app-sidebar-panel-minimize-border-start-mobile);
    border-right: var(--bs-app-sidebar-panel-minimize-border-end-mobile);
    margin-left: 0px;
    margin-right: 0px;
    margin-top: 0px;
    margin-bottom: 0px;
  }
  [data-kt-app-sidebar-panel-hoverable-mobile=true] .app-sidebar-panel .app-sidebar-panel-hoverable {
    width: var(--bs-app-sidebar-panel-width-actual);
  }
  [data-kt-app-sidebar-panel-hoverable-mobile=true][data-kt-app-sidebar-panel-minimize-mobile=on] .app-sidebar-panel:hover:not(.animating) {
    transition: none;
    width: var(--bs-app-sidebar-panel-width-actual);
    box-shadow: var(--bs-app-sidebar-panel-minimize-hover-box-shadow-mobile);
  }
  [data-kt-app-sidebar-panel-collapse-mobile=on] .app-sidebar-panel {
    transition: none;
    width: var(--bs-app-sidebar-panel-width-actual);
    margin-left: calc(-1 * var(--bs-app-sidebar-panel-width-actual));
  }
  [data-kt-app-sidebar-panel-minimize-mobile=on] .app-sidebar-panel-minimize-mobile-d-none {
    display: none !important;
  }
  [data-kt-app-sidebar-panel-minimize-mobile=on] .app-sidebar-panel-minimize-mobile-d-flex {
    display: flex !important;
  }
  [data-kt-app-sidebar-panel-collapse-mobile=on] .app-sidebar-panel-collapse-mobile-d-none {
    display: none !important;
  }
  [data-kt-app-sidebar-panel-collapse-mobile=on] .app-sidebar-panel-collapse-mobile-d-flex {
    display: flex !important;
  }
}
.app-aside {
  transition: none;
  background-color: var(--bs-app-aside-base-bg-color);
  box-shadow: var(--bs-app-aside-base-box-shadow);
  border-left: var(--bs-app-aside-base-border-left);
  border-right: var(--bs-app-aside-base-border-right);
}

.app-aside-minimize-d-flex,
.app-aside-sticky-d-flex,
.app-aside-collapse-d-flex,
.app-aside-minimize-mobile-d-flex,
.app-aside-collapse-mobile-d-flex {
  display: none;
}

@media (min-width: 992px) {
  .app-aside {
    display: flex;
    flex-shrink: 0;
    width: var(--bs-app-aside-width);
    margin-left: 0px;
    margin-right: 0px;
    margin-top: 0px;
    margin-bottom: 0px;
  }
  :root {
    --bs-app-aside-width: 300px;
    --bs-app-aside-width-actual: 300px;
    --bs-app-aside-gap-start: 0px;
    --bs-app-aside-gap-end: 0px;
    --bs-app-aside-gap-top: 0px;
    --bs-app-aside-gap-bottom: 0px;
  }
  [data-kt-app-aside-stacked=true] {
    --bs-app-aside-width: calc(var(--bs-app-aside-primary-width) + var(--bs-app-aside-secondary-width));
  }
  [data-kt-app-aside-minimize=on] {
    --bs-app-aside-width: 75px;
    --bs-app-aside-gap-start: 0px;
    --bs-app-aside-gap-end: 0px;
    --bs-app-aside-gap-top: 0px;
    --bs-app-aside-gap-bottom: 0px;
  }
  [data-kt-app-aside-sticky=on] {
    --bs-app-aside-width: 300px;
    --bs-app-aside-gap-start: 0px;
    --bs-app-aside-gap-end: 0px;
    --bs-app-aside-gap-top: 0px;
    --bs-app-aside-gap-bottom: 0px;
  }
  [data-kt-app-aside-collapse=on] {
    --bs-app-aside-width: 0px;
  }
  [data-kt-app-aside-static=true] .app-aside {
    position: relative;
  }
  [data-kt-app-aside-offcanvas=true] .app-aside {
    display: none;
  }
  [data-kt-app-aside-fixed=true] .app-aside {
    position: fixed;
    z-index: 105;
    top: 0;
    bottom: 0;
    right: 0;
  }
  [data-kt-app-aside-stacked=true] .app-aside {
    align-items: stretch;
  }
  [data-kt-app-aside-sticky=on] .app-aside {
    position: fixed;
    transition: none;
    box-shadow: var(--bs-app-aside-sticky-box-shadow);
    border-left: var(--bs-aside-sticky-border-start);
    border-right: var(--bs-app-aside-sticky-border-end);
    top: auto;
    bottom: auto;
    left: auto;
    z-index: 105;
    margin-left: 0px;
    margin-right: 0px;
    margin-top: 0px;
    margin-bottom: 0px;
  }
  [data-kt-app-aside-minimize=on] .app-aside {
    transition: none;
    margin-left: 0px;
    margin-right: 0px;
    margin-top: 0px;
    margin-bottom: 0px;
  }
  [data-kt-app-aside-hoverable=true] .app-aside .app-aside-wrapper {
    width: var(--bs-app-aside-width-actual);
  }
  [data-kt-app-aside-hoverable=true][data-kt-app-aside-minimize=on] .app-aside:hover:not(.animating) {
    transition: none;
    width: var(--bs-app-aside-width-actual);
    box-shadow: var(--bs-app-aside-minimize-hover-box-shadow);
  }
  [data-kt-app-aside-collapse=on] .app-aside {
    transition: none;
    width: var(--bs-app-aside-width-actual);
    margin-right: calc(-1 * var(--bs-app-aside-width-actual));
  }
  [data-kt-app-aside-minimize=on] .app-aside-minimize-d-none {
    display: none !important;
  }
  [data-kt-app-aside-minimize=on] .app-aside-minimize-d-flex {
    display: flex !important;
  }
  [data-kt-app-aside-sticky=on] .app-aside-sticky-d-none {
    display: none !important;
  }
  [data-kt-app-aside-sticky=on] .app-aside-sticky-d-flex {
    display: flex !important;
  }
  [data-kt-app-aside-collapse=on] .app-aside-collapse-d-none {
    display: none !important;
  }
  [data-kt-app-aside-collapse=on] .app-aside-collapse-d-flex {
    display: flex !important;
  }
  [data-kt-app-aside-fixed=true][data-kt-app-header-fixed=true]:not([data-kt-app-aside-push-header=true]) .app-aside {
    top: var(--bs-app-header-height);
  }
  [data-kt-app-aside-fixed=true][data-kt-app-header-fixed=true][data-kt-app-toolbar-fixed=true]:not([data-kt-app-aside-push-toolbar=true]) .app-aside {
    top: calc(var(--bs-app-header-height) + var(--bs-app-toolbar-height, 0px));
  }
}
@media (max-width: 991.98px) {
  .app-aside {
    display: none;
    width: var(--bs-app-aside-width);
    z-index: 106;
    margin-left: 0px;
    margin-right: 0px;
    margin-top: 0px;
    margin-bottom: 0px;
  }
  :root {
    --bs-app-aside-width: 275px;
    --bs-app-aside-width-actual: 275px;
    --bs-app-aside-gap-start: 0px;
    --bs-app-aside-gap-end: 0px;
    --bs-app-aside-gap-top: 0px;
    --bs-app-aside-gap-bottom: 0px;
  }
  [data-kt-app-aside-minimize-mobile=on] {
    --bs-app-aside-width: 75px;
    --bs-app-aside-gap-start: 0px;
    --bs-app-aside-gap-end: 0px;
    --bs-app-aside-gap-top: 0px;
    --bs-app-aside-gap-bottom: 0px;
  }
  [data-kt-app-aside-collapse-mobile=on] {
    --bs-app-aside-width: 0px;
  }
  [data-kt-app-aside-stacked=true] .app-aside {
    align-items: stretch;
  }
  [data-kt-app-aside-minimize-mobile=on] .app-aside {
    transition: none;
    margin-left: 0px;
    margin-right: 0px;
    margin-top: 0px;
    margin-bottom: 0px;
  }
  [data-kt-app-aside-hoverable-mobile=true] .app-aside .app-aside-wrapper {
    width: var(--bs-app-aside-width-actual);
  }
  [data-kt-app-aside-hoverable-mobile=true][data-kt-app-aside-minimize-mobile=on] .app-aside:hover:not(.animating) {
    transition: none;
    width: var(--bs-app-aside-width-actual);
    box-shadow: var(--bs-app-aside-minimize-hover-box-shadow-mobile);
  }
  [data-kt-app-aside-collapse-mobile=on] .app-aside {
    transition: none;
    width: var(--bs-app-aside-width-actual);
    margin-right: calc(-1 * var(--bs-app-aside-width-actual));
  }
  [data-kt-app-aside-minimize-mobile=on] .app-aside-minimize-mobile-d-none {
    display: none !important;
  }
  [data-kt-app-aside-minimize-mobile=on] .app-aside-minimize-mobile-d-flex {
    display: flex !important;
  }
  [data-kt-app-aside-collapse-mobile=on] .app-aside-collapse-mobile-d-none {
    display: none !important;
  }
  [data-kt-app-aside-collapse-mobile=on] .app-aside-collapse-mobile-d-flex {
    display: flex !important;
  }
}
.app-wrapper {
  display: flex;
}

@media (min-width: 992px) {
  .app-wrapper {
    transition: margin-left 0.3s ease, margin-right 0.3s ease;
  }
  [data-kt-app-header-sticky=on] .app-wrapper {
    margin-top: var(--bs-app-header-height-actual);
  }
  [data-kt-app-header-fixed=true] .app-wrapper {
    margin-top: var(--bs-app-header-height);
  }
  [data-kt-app-toolbar-sticky=on] .app-wrapper {
    margin-top: var(--bs-app-toolbar-height);
  }
  [data-kt-app-header-fixed=true][data-kt-app-toolbar-sticky=on] .app-wrapper {
    margin-top: calc(var(--bs-app-header-height-actual) + var(--bs-app-toolbar-height-actual));
  }
  [data-kt-app-header-fixed=true][data-kt-app-toolbar-fixed=true] .app-wrapper {
    margin-top: calc(var(--bs-app-header-height) + var(--bs-app-toolbar-height));
  }
  [data-kt-app-sidebar-fixed=true] .app-wrapper {
    margin-left: calc(var(--bs-app-sidebar-width) + var(--bs-app-sidebar-gap-start, 0px) + var(--bs-app-sidebar-gap-end, 0px));
  }
  [data-kt-app-sidebar-panel-fixed=true] .app-wrapper {
    margin-left: calc(var(--bs-app-sidebar-width) + var(--bs-app-sidebar-gap-start, 0px) + var(--bs-app-sidebar-gap-end, 0px) + var(--bs-app-sidebar-panel-width) + var(--bs-app-sidebar-panel-gap-start, 0px) + var(--bs-app-sidebar-panel-gap-end, 0px));
  }
  [data-kt-app-aside-fixed=true] .app-wrapper {
    margin-right: calc(var(--bs-app-aside-width) + var(--bs-app-aside-gap-start, 0px) + var(--bs-app-aside-gap-end, 0px));
  }
  [data-kt-app-footer-fixed=true] .app-wrapper {
    margin-bottom: var(--bs-app-footer-height);
  }
}
@media (max-width: 991.98px) {
  .app-wrapper {
    transition: margin-left 0.3s ease, margin-right 0.3s ease;
  }
  [data-kt-app-header-sticky=on] .app-wrapper {
    margin-top: var(--bs-app-header-height-actual);
  }
  [data-kt-app-header-fixed-mobile=true] .app-wrapper {
    margin-top: var(--bs-app-header-height);
  }
  [data-kt-app-header-fixed-mobile=true][data-kt-app-toolbar-sticky=on] .app-wrapper {
    margin-top: calc(var(--bs-app-header-height-actual) + var(--bs-app-toolbar-height-actual));
  }
  [data-kt-app-footer-fixed-mobile=true] .app-wrapper {
    margin-bottom: var(--bs-app-footer-height);
  }
}
.app-main {
  display: flex;
}

@media (min-width: 992px) {
  .app-main {
    transition: margin 0.3s ease;
  }
  [data-kt-app-sidebar-sticky=true] .app-main {
    margin-left: calc(var(--bs-app-sidebar-width) + var(--bs-app-sidebar-gap-start, 0px) + var(--bs-app-sidebar-gap-end, 0px));
  }
  [data-kt-app-sidebar-panel-sticky=true] .app-main {
    margin-left: calc(var(--bs-app-sidebar-width) + var(--bs-app-sidebar-gap-start, 0px) + var(--bs-app-sidebar-gap-end, 0px) + var(--bs-app-sidebar-panel-width) + var(--bs-app-sidebar-panel-gap-start, 0px) + var(--bs-app-sidebar-panel-gap-end, 0px));
  }
  [data-kt-app-aside-sticky=true] .app-main {
    margin-right: calc(var(--bs-app-aside-width) + var(--bs-app-aside-gap-start, 0px) + var(--bs-app-aside-gap-end, 0px));
  }
}
@media (max-width: 991.98px) {
  .app-main {
    padding-left: 0;
    padding-right: 0;
  }
}
@media (min-width: 992px) {
  .app-content {
    padding-top: 30px;
    padding-bottom: 30px;
    padding-left: 0;
    padding-right: 0;
  }
}
@media (max-width: 991.98px) {
  .app-content {
    max-width: none;
    padding-top: 20px;
    padding-bottom: 20px;
    padding-left: 0;
    padding-right: 0;
  }
}
.app-footer {
  transition: left 0.3s ease, right 0.3s ease;
  display: flex;
  align-items: center;
  background-color: var(--bs-app-footer-bg-color);
  border-top: var(--bs-app-footer-border-top);
}

@media (min-width: 992px) {
  :root {
    --bs-app-footer-height: 60px;
  }
  .app-footer {
    height: var(--bs-app-footer-height);
  }
  [data-kt-app-footer-fixed=true] .app-footer {
    z-index: 100;
    box-shadow: var(--bs-app-footer-box-shadow);
    position: fixed;
    left: 0;
    right: 0;
    bottom: 0;
  }
  [data-kt-app-sidebar-fixed=true][data-kt-app-sidebar-push-footer=true] .app-footer {
    left: calc(var(--bs-app-sidebar-width) + var(--bs-app-sidebar-gap-start, 0px) + var(--bs-app-sidebar-gap-end, 0px));
  }
  [data-kt-app-sidebar-panel-fixed=true][data-kt-app-sidebar-panel-push-footer=true] .app-footer {
    left: calc(var(--bs-app-sidebar-width) + var(--bs-app-sidebar-gap-start, 0px) + var(--bs-app-sidebar-gap-end, 0px) + var(--bs-app-sidebar-panel-width) + var(--bs-app-sidebar-panel-gap-start, 0px) + var(--bs-app-sidebar-panel-gap-end, 0px));
  }
  [data-kt-app-aside-fixed=true][data-kt-app-aside-push-footer=true] .app-footer {
    right: calc(var(--bs-app-aside-width) + var(--bs-app-aside-gap-start, 0px) + var(--bs-app-aside-gap-end, 0px));
  }
}
@media (max-width: 991.98px) {
  body {
    --bs-app-footer-height: auto;
  }
  .app-footer {
    height: var(--bs-app-footer-height);
  }
  [data-kt-app-footer-fixed-mobile=true] .app-footer {
    z-index: 100;
    box-shadow: var(--bs-app-footer-box-shadow);
    position: fixed;
    left: 0;
    right: 0;
    bottom: 0;
  }
}
.app-layout-builder-toggle {
  position: fixed;
  z-index: 105;
  bottom: 40px;
  right: 50px;
}

@media (max-width: 991.98px) {
  .app-layout-builder-toggle {
    bottom: 20px;
    right: 40px;
  }
}
[data-bs-theme=light] {
  --bs-app-header-base-menu-link-bg-color-active: #F9F9F9;
  --bs-app-header-light-separator-color: #E4E6EF;
  --bs-app-sidebar-base-toggle-btn-box-shadow: 0px 0px 10px rgba(113, 121, 136, 0.1);
  --bs-app-sidebar-base-toggle-btn-bg-color: #ffffff;
  --bs-app-sidebar-light-bg-color: #ffffff;
  --bs-app-sidebar-light-box-shadow: 0 0 28px 0 rgba(82, 63, 105, 0.05);
  --bs-app-sidebar-light-separator-color: #E4E6EF;
  --bs-app-sidebar-light-scrollbar-color: #F4F4F4;
  --bs-app-sidebar-light-scrollbar-color-hover: #F4F4F4;
  --bs-app-sidebar-light-menu-heading-color: #B5B5C3;
  --bs-app-sidebar-light-menu-link-bg-color-active: #F4F6FA;
  --bs-app-sidebar-light-header-menu-link-bg-color-active: #EAEEF2;
}

[data-bs-theme=dark] {
  --bs-app-header-base-menu-link-bg-color-active: #2A2A3C;
  --bs-app-header-light-separator-color: #2B2B40;
  --bs-app-sidebar-base-toggle-btn-box-shadow: none;
  --bs-app-sidebar-base-toggle-btn-bg-color: #2A2A3C;
  --bs-app-sidebar-light-bg-color: #1e1e2d;
  --bs-app-sidebar-light-box-shadow: none;
  --bs-app-sidebar-light-separator-color: #2B2B40;
  --bs-app-sidebar-light-scrollbar-color: #2B2B40;
  --bs-app-sidebar-light-scrollbar-color-hover: #2B2B40;
  --bs-app-sidebar-light-menu-heading-color: #565674;
  --bs-app-sidebar-light-menu-link-bg-color-active: #2A2A3C;
  --bs-app-sidebar-light-header-menu-link-bg-color-active: #1b1b29;
}

@media (min-width: 992px) {
  .app-sidebar-toggle {
    box-shadow: var(--bs-app-sidebar-base-toggle-btn-box-shadow) !important;
    background-color: var(--bs-app-sidebar-base-toggle-btn-bg-color) !important;
  }
  .app-sidebar-toggle .active .svg-icon {
    transform: rotateZ(0deg) !important;
  }
  [dir=rtl] .app-sidebar-toggle .svg-icon {
    transform: rotateZ(180deg);
  }
  [dir=rtl] .app-sidebar-toggle.active .svg-icon {
    transform: rotateZ(0deg) !important;
  }
  .app-sidebar-logo {
    height: var(--bs-app-header-height);
    display: flex;
    align-items: center;
    justify-content: space-between;
    position: relative;
    flex-shrink: 0;
  }
  .app-sidebar-menu .menu > .menu-item {
    margin-left: 0.115rem;
  }
}
@media (max-width: 991.98px) {
  .app-sidebar-logo {
    display: none;
  }
}
.app-sidebar-logo-minimize {
  display: none;
}

.app-sidebar-footer .btn-custom .btn-icon {
  display: none;
}

@media (min-width: 992px) {
  [data-kt-app-sidebar-minimize=on]:not([data-kt-app-sidebar-hoverable=true]) .app-sidebar .app-sidebar-logo .app-sidebar-logo-default {
    display: none;
  }
  [data-kt-app-sidebar-minimize=on]:not([data-kt-app-sidebar-hoverable=true]) .app-sidebar .app-sidebar-logo .app-sidebar-logo-minimize {
    display: inline-block;
  }
  [data-kt-app-sidebar-minimize=on]:not([data-kt-app-sidebar-hoverable=true]) .app-sidebar .app-sidebar-wrapper {
    width: var(--bs-app-sidebar-width-actual);
  }
  [data-kt-app-sidebar-minimize=on]:not([data-kt-app-sidebar-hoverable=true]) .app-sidebar .app-sidebar-menu .menu-content,
  [data-kt-app-sidebar-minimize=on]:not([data-kt-app-sidebar-hoverable=true]) .app-sidebar .app-sidebar-menu .menu-title {
    opacity: 0;
    transition: opacity 0.3s ease !important;
  }
  [data-kt-app-sidebar-minimize=on]:not([data-kt-app-sidebar-hoverable=true]) .app-sidebar .app-sidebar-menu .menu-item.show > .menu-sub {
    height: 0;
    overflow: hidden;
    transition: height 0.3s ease !important;
  }
  [data-kt-app-sidebar-minimize=on]:not([data-kt-app-sidebar-hoverable=true]) .app-sidebar .app-sidebar-footer .btn-custom {
    padding-left: 0 !important;
    padding-right: 0 !important;
  }
  [data-kt-app-sidebar-minimize=on]:not([data-kt-app-sidebar-hoverable=true]) .app-sidebar .app-sidebar-footer .btn-custom .btn-label {
    width: 0;
    display: none;
  }
  [data-kt-app-sidebar-minimize=on]:not([data-kt-app-sidebar-hoverable=true]) .app-sidebar .app-sidebar-footer .btn-custom .btn-icon {
    width: auto;
    display: block;
  }
  [data-kt-app-sidebar-minimize=on][data-kt-app-sidebar-hoverable=true] .app-sidebar:not(:hover) .app-sidebar-logo .app-sidebar-logo-default {
    display: none;
  }
  [data-kt-app-sidebar-minimize=on][data-kt-app-sidebar-hoverable=true] .app-sidebar:not(:hover) .app-sidebar-logo .app-sidebar-logo-minimize {
    display: inline-block;
  }
  [data-kt-app-sidebar-minimize=on][data-kt-app-sidebar-hoverable=true] .app-sidebar:not(:hover) .app-sidebar-wrapper {
    width: var(--bs-app-sidebar-width-actual);
  }
  [data-kt-app-sidebar-minimize=on][data-kt-app-sidebar-hoverable=true] .app-sidebar:not(:hover) .app-sidebar-menu .menu-content,
  [data-kt-app-sidebar-minimize=on][data-kt-app-sidebar-hoverable=true] .app-sidebar:not(:hover) .app-sidebar-menu .menu-title {
    opacity: 0;
    transition: opacity 0.3s ease !important;
  }
  [data-kt-app-sidebar-minimize=on][data-kt-app-sidebar-hoverable=true] .app-sidebar:not(:hover) .app-sidebar-menu .menu-item.show > .menu-sub {
    height: 0;
    overflow: hidden;
    transition: height 0.3s ease !important;
  }
  [data-kt-app-sidebar-minimize=on][data-kt-app-sidebar-hoverable=true] .app-sidebar:not(:hover) .app-sidebar-footer .btn-custom {
    padding-left: 0 !important;
    padding-right: 0 !important;
  }
  [data-kt-app-sidebar-minimize=on][data-kt-app-sidebar-hoverable=true] .app-sidebar:not(:hover) .app-sidebar-footer .btn-custom .btn-label {
    width: 0;
    display: none;
  }
  [data-kt-app-sidebar-minimize=on][data-kt-app-sidebar-hoverable=true] .app-sidebar:not(:hover) .app-sidebar-footer .btn-custom .btn-icon {
    width: auto;
    display: block;
  }
}
[data-kt-app-layout=dark-sidebar] .app-sidebar {
  background-color: #1e1e2d;
  border-right: 0 !important;
}

[data-kt-app-layout=dark-sidebar] .app-sidebar .hover-scroll-overlay-y {
  scrollbar-color: #323248 transparent;
}

[data-kt-app-layout=dark-sidebar] .app-sidebar .hover-scroll-overlay-y::-webkit-scrollbar-thumb {
  background-color: #323248;
}

[data-kt-app-layout=dark-sidebar] .app-sidebar .hover-scroll-overlay-y::-webkit-scrollbar-corner {
  background-color: transparent;
}

[data-kt-app-layout=dark-sidebar] .app-sidebar .hover-scroll-overlay-y:hover {
  scrollbar-color: #323248 transparent;
}

[data-kt-app-layout=dark-sidebar] .app-sidebar .hover-scroll-overlay-y:hover::-webkit-scrollbar-thumb {
  background-color: #323248;
}

[data-kt-app-layout=dark-sidebar] .app-sidebar .hover-scroll-overlay-y:hover::-webkit-scrollbar-corner {
  background-color: transparent;
}

[data-kt-app-layout=dark-sidebar] .app-sidebar .app-sidebar-logo {
  border-bottom: 1px dashed #393945;
}

[data-kt-app-layout=dark-sidebar] .app-sidebar .btn-custom {
  color: #B5B5C3;
  background-color: rgba(63, 66, 84, 0.35);
}

[data-kt-app-layout=dark-sidebar] .app-sidebar .btn-custom i,
[data-kt-app-layout=dark-sidebar] .app-sidebar .btn-custom .svg-icon {
  color: #B5B5C3;
}

[data-kt-app-layout=dark-sidebar] .app-sidebar .btn-custom.dropdown-toggle:after {
  color: #B5B5C3;
}

.btn-check:checked + [data-kt-app-layout=dark-sidebar] .app-sidebar .btn-custom, .btn-check:active + [data-kt-app-layout=dark-sidebar] .app-sidebar .btn-custom, [data-kt-app-layout=dark-sidebar] .app-sidebar .btn-custom:focus:not(.btn-active), [data-kt-app-layout=dark-sidebar] .app-sidebar .btn-custom:hover:not(.btn-active), [data-kt-app-layout=dark-sidebar] .app-sidebar .btn-custom:active:not(.btn-active), [data-kt-app-layout=dark-sidebar] .app-sidebar .btn-custom.active, [data-kt-app-layout=dark-sidebar] .app-sidebar .btn-custom.show, .show > [data-kt-app-layout=dark-sidebar] .app-sidebar .btn-custom {
  color: #B5B5C3;
  background-color: rgba(63, 66, 84, 0.35) !important;
}

[data-kt-app-layout=dark-sidebar] .app-sidebar .menu .menu-item .menu-heading {
  color: #646477 !important;
}

[data-kt-app-layout=dark-sidebar] .app-sidebar .menu .menu-item .menu-link {
  color: #9D9DA6;
}

[data-kt-app-layout=dark-sidebar] .app-sidebar .menu .menu-item .menu-link .menu-title {
  color: #9D9DA6;
}

[data-kt-app-layout=dark-sidebar] .app-sidebar .menu .menu-item .menu-link .menu-icon,
[data-kt-app-layout=dark-sidebar] .app-sidebar .menu .menu-item .menu-link .menu-icon .svg-icon,
[data-kt-app-layout=dark-sidebar] .app-sidebar .menu .menu-item .menu-link .menu-icon i {
  color: #C5C5D8;
}

[data-kt-app-layout=dark-sidebar] .app-sidebar .menu .menu-item .menu-link .menu-bullet .bullet {
  background-color: #787887;
}

[data-kt-app-layout=dark-sidebar] .app-sidebar .menu .menu-item .menu-link .menu-arrow:after {
  mask-image: url(${___CSS_LOADER_URL_REPLACEMENT_115___});
  /*rtl:begin:remove*/
  mask-repeat: no-repeat;
  mask-position: center;
  -webkit-mask-repeat: no-repeat;
  -webkit-mask-position: center;
  background-color: #787887;
  mask-image: url(${___CSS_LOADER_URL_REPLACEMENT_116___});
  /*rtl:end:remove*/
}

[data-kt-app-layout=dark-sidebar] .app-sidebar .menu .menu-item.hover:not(.here) > .menu-link:not(.disabled):not(.active):not(.here), [data-kt-app-layout=dark-sidebar] .app-sidebar .menu .menu-item:not(.here) .menu-link:hover:not(.disabled):not(.active):not(.here) {
  transition: color 0.2s ease;
  color: var(--bs-primary-inverse);
}

[data-kt-app-layout=dark-sidebar] .app-sidebar .menu .menu-item.hover:not(.here) > .menu-link:not(.disabled):not(.active):not(.here) .menu-title, [data-kt-app-layout=dark-sidebar] .app-sidebar .menu .menu-item:not(.here) .menu-link:hover:not(.disabled):not(.active):not(.here) .menu-title {
  color: var(--bs-primary-inverse);
}

[data-kt-app-layout=dark-sidebar] .app-sidebar .menu .menu-item.hover:not(.here) > .menu-link:not(.disabled):not(.active):not(.here) .menu-icon,
[data-kt-app-layout=dark-sidebar] .app-sidebar .menu .menu-item.hover:not(.here) > .menu-link:not(.disabled):not(.active):not(.here) .menu-icon .svg-icon,
[data-kt-app-layout=dark-sidebar] .app-sidebar .menu .menu-item.hover:not(.here) > .menu-link:not(.disabled):not(.active):not(.here) .menu-icon i, [data-kt-app-layout=dark-sidebar] .app-sidebar .menu .menu-item:not(.here) .menu-link:hover:not(.disabled):not(.active):not(.here) .menu-icon,
[data-kt-app-layout=dark-sidebar] .app-sidebar .menu .menu-item:not(.here) .menu-link:hover:not(.disabled):not(.active):not(.here) .menu-icon .svg-icon,
[data-kt-app-layout=dark-sidebar] .app-sidebar .menu .menu-item:not(.here) .menu-link:hover:not(.disabled):not(.active):not(.here) .menu-icon i {
  color: var(--bs-primary-inverse);
}

[data-kt-app-layout=dark-sidebar] .app-sidebar .menu .menu-item.hover:not(.here) > .menu-link:not(.disabled):not(.active):not(.here) .menu-bullet .bullet, [data-kt-app-layout=dark-sidebar] .app-sidebar .menu .menu-item:not(.here) .menu-link:hover:not(.disabled):not(.active):not(.here) .menu-bullet .bullet {
  background-color: var(--bs-primary-inverse);
}

[data-kt-app-layout=dark-sidebar] .app-sidebar .menu .menu-item.hover:not(.here) > .menu-link:not(.disabled):not(.active):not(.here) .menu-arrow:after, [data-kt-app-layout=dark-sidebar] .app-sidebar .menu .menu-item:not(.here) .menu-link:hover:not(.disabled):not(.active):not(.here) .menu-arrow:after {
  mask-image: url(${___CSS_LOADER_URL_REPLACEMENT_110___});
  /*rtl:begin:remove*/
  mask-repeat: no-repeat;
  mask-position: center;
  -webkit-mask-repeat: no-repeat;
  -webkit-mask-position: center;
  background-color: var(--bs-primary-inverse);
  mask-image: url(${___CSS_LOADER_URL_REPLACEMENT_111___});
  /*rtl:end:remove*/
}

[data-kt-app-layout=dark-sidebar] .app-sidebar .menu .menu-item.here > .menu-link {
  transition: color 0.2s ease;
  color: var(--bs-primary-inverse);
}

[data-kt-app-layout=dark-sidebar] .app-sidebar .menu .menu-item.here > .menu-link .menu-title {
  color: var(--bs-primary-inverse);
}

[data-kt-app-layout=dark-sidebar] .app-sidebar .menu .menu-item.here > .menu-link .menu-icon,
[data-kt-app-layout=dark-sidebar] .app-sidebar .menu .menu-item.here > .menu-link .menu-icon .svg-icon,
[data-kt-app-layout=dark-sidebar] .app-sidebar .menu .menu-item.here > .menu-link .menu-icon i {
  color: var(--bs-primary-inverse);
}

[data-kt-app-layout=dark-sidebar] .app-sidebar .menu .menu-item.here > .menu-link .menu-bullet .bullet {
  background-color: var(--bs-primary-inverse);
}

[data-kt-app-layout=dark-sidebar] .app-sidebar .menu .menu-item.here > .menu-link .menu-arrow:after {
  mask-image: url(${___CSS_LOADER_URL_REPLACEMENT_110___});
  /*rtl:begin:remove*/
  mask-repeat: no-repeat;
  mask-position: center;
  -webkit-mask-repeat: no-repeat;
  -webkit-mask-position: center;
  background-color: var(--bs-primary-inverse);
  mask-image: url(${___CSS_LOADER_URL_REPLACEMENT_111___});
  /*rtl:end:remove*/
}

[data-kt-app-layout=dark-sidebar] .app-sidebar .menu .menu-item.show > .menu-link {
  transition: color 0.2s ease;
  color: var(--bs-primary-inverse);
}

[data-kt-app-layout=dark-sidebar] .app-sidebar .menu .menu-item.show > .menu-link .menu-title {
  color: var(--bs-primary-inverse);
}

[data-kt-app-layout=dark-sidebar] .app-sidebar .menu .menu-item.show > .menu-link .menu-icon,
[data-kt-app-layout=dark-sidebar] .app-sidebar .menu .menu-item.show > .menu-link .menu-icon .svg-icon,
[data-kt-app-layout=dark-sidebar] .app-sidebar .menu .menu-item.show > .menu-link .menu-icon i {
  color: var(--bs-primary-inverse);
}

[data-kt-app-layout=dark-sidebar] .app-sidebar .menu .menu-item.show > .menu-link .menu-bullet .bullet {
  background-color: var(--bs-primary-inverse);
}

[data-kt-app-layout=dark-sidebar] .app-sidebar .menu .menu-item.show > .menu-link .menu-arrow:after {
  mask-image: url(${___CSS_LOADER_URL_REPLACEMENT_110___});
  /*rtl:begin:remove*/
  mask-repeat: no-repeat;
  mask-position: center;
  -webkit-mask-repeat: no-repeat;
  -webkit-mask-position: center;
  background-color: var(--bs-primary-inverse);
  mask-image: url(${___CSS_LOADER_URL_REPLACEMENT_111___});
  /*rtl:end:remove*/
}

[data-kt-app-layout=dark-sidebar] .app-sidebar .menu .menu-item .menu-link.active {
  transition: color 0.2s ease;
  background-color: #2A2A3C;
  color: var(--bs-primary-inverse);
}

[data-kt-app-layout=dark-sidebar] .app-sidebar .menu .menu-item .menu-link.active .menu-title {
  color: var(--bs-primary-inverse);
}

[data-kt-app-layout=dark-sidebar] .app-sidebar .menu .menu-item .menu-link.active .menu-icon,
[data-kt-app-layout=dark-sidebar] .app-sidebar .menu .menu-item .menu-link.active .menu-icon .svg-icon,
[data-kt-app-layout=dark-sidebar] .app-sidebar .menu .menu-item .menu-link.active .menu-icon i {
  color: var(--bs-primary-inverse);
}

[data-kt-app-layout=dark-sidebar] .app-sidebar .menu .menu-item .menu-link.active .menu-bullet .bullet {
  background-color: var(--bs-primary-inverse);
}

[data-kt-app-layout=dark-sidebar] .app-sidebar .menu .menu-item .menu-link.active .menu-arrow:after {
  mask-image: url(${___CSS_LOADER_URL_REPLACEMENT_110___});
  /*rtl:begin:remove*/
  mask-repeat: no-repeat;
  mask-position: center;
  -webkit-mask-repeat: no-repeat;
  -webkit-mask-position: center;
  background-color: var(--bs-primary-inverse);
  mask-image: url(${___CSS_LOADER_URL_REPLACEMENT_111___});
  /*rtl:end:remove*/
}

@media (min-width: 992px) {
  [data-kt-app-layout=dark-sidebar] .app-sidebar .menu-sub-lg-dropdown {
    background-color: #1e1e2d;
  }
}
[data-kt-app-layout=light-sidebar] .app-sidebar {
  background-color: var(--bs-app-sidebar-light-bg-color);
  border-right: 0 !important;
}

[data-kt-app-layout=light-sidebar] .app-sidebar .hover-scroll-overlay-y {
  scrollbar-color: var(--bs-app-sidebar-light-scrollbar-color) transparent;
}

[data-kt-app-layout=light-sidebar] .app-sidebar .hover-scroll-overlay-y::-webkit-scrollbar-thumb {
  background-color: var(--bs-app-sidebar-light-scrollbar-color);
}

[data-kt-app-layout=light-sidebar] .app-sidebar .hover-scroll-overlay-y::-webkit-scrollbar-corner {
  background-color: transparent;
}

[data-kt-app-layout=light-sidebar] .app-sidebar .hover-scroll-overlay-y:hover {
  scrollbar-color: var(--bs-app-sidebar-light-scrollbar-color-hover) transparent;
}

[data-kt-app-layout=light-sidebar] .app-sidebar .hover-scroll-overlay-y:hover::-webkit-scrollbar-thumb {
  background-color: var(--bs-app-sidebar-light-scrollbar-color-hover);
}

[data-kt-app-layout=light-sidebar] .app-sidebar .hover-scroll-overlay-y:hover::-webkit-scrollbar-corner {
  background-color: transparent;
}

[data-kt-app-layout=light-sidebar] .app-sidebar .app-sidebar-logo {
  border-bottom: 1px solid var(--bs-app-sidebar-light-separator-color);
}

[data-kt-app-layout=light-sidebar] .app-sidebar .menu {
  font-weight: 500;
}

[data-kt-app-layout=light-sidebar] .app-sidebar .menu .menu-item .menu-heading {
  color: var(--bs-app-sidebar-light-menu-heading-color) !important;
}

[data-kt-app-layout=light-sidebar] .app-sidebar .menu .menu-item .menu-link {
  color: var(--bs-gray-700);
}

[data-kt-app-layout=light-sidebar] .app-sidebar .menu .menu-item .menu-link .menu-title {
  color: var(--bs-gray-700);
}

[data-kt-app-layout=light-sidebar] .app-sidebar .menu .menu-item .menu-link .menu-icon,
[data-kt-app-layout=light-sidebar] .app-sidebar .menu .menu-item .menu-link .menu-icon .svg-icon,
[data-kt-app-layout=light-sidebar] .app-sidebar .menu .menu-item .menu-link .menu-icon i {
  color: var(--bs-gray-500);
}

[data-kt-app-layout=light-sidebar] .app-sidebar .menu .menu-item .menu-link .menu-bullet .bullet {
  background-color: var(--bs-gray-500);
}

[data-kt-app-layout=light-sidebar] .app-sidebar .menu .menu-item .menu-link .menu-arrow:after {
  mask-image: url(${___CSS_LOADER_URL_REPLACEMENT_84___});
  /*rtl:begin:remove*/
  mask-repeat: no-repeat;
  mask-position: center;
  -webkit-mask-repeat: no-repeat;
  -webkit-mask-position: center;
  background-color: var(--bs-gray-500);
  mask-image: url(${___CSS_LOADER_URL_REPLACEMENT_85___});
  /*rtl:end:remove*/
}

[data-kt-app-layout=light-sidebar] .app-sidebar .menu .menu-item.hover:not(.here) > .menu-link:not(.disabled):not(.active):not(.here), [data-kt-app-layout=light-sidebar] .app-sidebar .menu .menu-item:not(.here) .menu-link:hover:not(.disabled):not(.active):not(.here) {
  transition: color 0.2s ease;
  color: var(--bs-gray-900);
}

[data-kt-app-layout=light-sidebar] .app-sidebar .menu .menu-item.hover:not(.here) > .menu-link:not(.disabled):not(.active):not(.here) .menu-title, [data-kt-app-layout=light-sidebar] .app-sidebar .menu .menu-item:not(.here) .menu-link:hover:not(.disabled):not(.active):not(.here) .menu-title {
  color: var(--bs-gray-900);
}

[data-kt-app-layout=light-sidebar] .app-sidebar .menu .menu-item.hover:not(.here) > .menu-link:not(.disabled):not(.active):not(.here) .menu-icon,
[data-kt-app-layout=light-sidebar] .app-sidebar .menu .menu-item.hover:not(.here) > .menu-link:not(.disabled):not(.active):not(.here) .menu-icon .svg-icon,
[data-kt-app-layout=light-sidebar] .app-sidebar .menu .menu-item.hover:not(.here) > .menu-link:not(.disabled):not(.active):not(.here) .menu-icon i, [data-kt-app-layout=light-sidebar] .app-sidebar .menu .menu-item:not(.here) .menu-link:hover:not(.disabled):not(.active):not(.here) .menu-icon,
[data-kt-app-layout=light-sidebar] .app-sidebar .menu .menu-item:not(.here) .menu-link:hover:not(.disabled):not(.active):not(.here) .menu-icon .svg-icon,
[data-kt-app-layout=light-sidebar] .app-sidebar .menu .menu-item:not(.here) .menu-link:hover:not(.disabled):not(.active):not(.here) .menu-icon i {
  color: var(--bs-gray-700);
}

[data-kt-app-layout=light-sidebar] .app-sidebar .menu .menu-item.hover:not(.here) > .menu-link:not(.disabled):not(.active):not(.here) .menu-bullet .bullet, [data-kt-app-layout=light-sidebar] .app-sidebar .menu .menu-item:not(.here) .menu-link:hover:not(.disabled):not(.active):not(.here) .menu-bullet .bullet {
  background-color: var(--bs-gray-700);
}

[data-kt-app-layout=light-sidebar] .app-sidebar .menu .menu-item.hover:not(.here) > .menu-link:not(.disabled):not(.active):not(.here) .menu-arrow:after, [data-kt-app-layout=light-sidebar] .app-sidebar .menu .menu-item:not(.here) .menu-link:hover:not(.disabled):not(.active):not(.here) .menu-arrow:after {
  mask-image: url(${___CSS_LOADER_URL_REPLACEMENT_18___});
  /*rtl:begin:remove*/
  mask-repeat: no-repeat;
  mask-position: center;
  -webkit-mask-repeat: no-repeat;
  -webkit-mask-position: center;
  background-color: var(--bs-gray-700);
  mask-image: url(${___CSS_LOADER_URL_REPLACEMENT_19___});
  /*rtl:end:remove*/
}

[data-kt-app-layout=light-sidebar] .app-sidebar .menu .menu-item.show > .menu-link {
  transition: color 0.2s ease;
  color: var(--bs-gray-900);
}

[data-kt-app-layout=light-sidebar] .app-sidebar .menu .menu-item.show > .menu-link .menu-title {
  color: var(--bs-gray-900);
}

[data-kt-app-layout=light-sidebar] .app-sidebar .menu .menu-item.show > .menu-link .menu-icon,
[data-kt-app-layout=light-sidebar] .app-sidebar .menu .menu-item.show > .menu-link .menu-icon .svg-icon,
[data-kt-app-layout=light-sidebar] .app-sidebar .menu .menu-item.show > .menu-link .menu-icon i {
  color: var(--bs-gray-700);
}

[data-kt-app-layout=light-sidebar] .app-sidebar .menu .menu-item.show > .menu-link .menu-bullet .bullet {
  background-color: var(--bs-gray-700);
}

[data-kt-app-layout=light-sidebar] .app-sidebar .menu .menu-item.show > .menu-link .menu-arrow:after {
  mask-image: url(${___CSS_LOADER_URL_REPLACEMENT_18___});
  /*rtl:begin:remove*/
  mask-repeat: no-repeat;
  mask-position: center;
  -webkit-mask-repeat: no-repeat;
  -webkit-mask-position: center;
  background-color: var(--bs-gray-700);
  mask-image: url(${___CSS_LOADER_URL_REPLACEMENT_19___});
  /*rtl:end:remove*/
}

[data-kt-app-layout=light-sidebar] .app-sidebar .menu .menu-item.here > .menu-link {
  transition: color 0.2s ease;
  color: var(--bs-gray-900);
}

[data-kt-app-layout=light-sidebar] .app-sidebar .menu .menu-item.here > .menu-link .menu-title {
  color: var(--bs-gray-900);
}

[data-kt-app-layout=light-sidebar] .app-sidebar .menu .menu-item.here > .menu-link .menu-icon,
[data-kt-app-layout=light-sidebar] .app-sidebar .menu .menu-item.here > .menu-link .menu-icon .svg-icon,
[data-kt-app-layout=light-sidebar] .app-sidebar .menu .menu-item.here > .menu-link .menu-icon i {
  color: var(--bs-gray-700);
}

[data-kt-app-layout=light-sidebar] .app-sidebar .menu .menu-item.here > .menu-link .menu-bullet .bullet {
  background-color: var(--bs-gray-700);
}

[data-kt-app-layout=light-sidebar] .app-sidebar .menu .menu-item.here > .menu-link .menu-arrow:after {
  mask-image: url(${___CSS_LOADER_URL_REPLACEMENT_18___});
  /*rtl:begin:remove*/
  mask-repeat: no-repeat;
  mask-position: center;
  -webkit-mask-repeat: no-repeat;
  -webkit-mask-position: center;
  background-color: var(--bs-gray-700);
  mask-image: url(${___CSS_LOADER_URL_REPLACEMENT_19___});
  /*rtl:end:remove*/
}

[data-kt-app-layout=light-sidebar] .app-sidebar .menu .menu-item .menu-link.active {
  transition: color 0.2s ease;
  background-color: var(--bs-app-sidebar-light-menu-link-bg-color-active);
  color: var(--bs-primary);
}

[data-kt-app-layout=light-sidebar] .app-sidebar .menu .menu-item .menu-link.active .menu-title {
  color: var(--bs-primary);
}

[data-kt-app-layout=light-sidebar] .app-sidebar .menu .menu-item .menu-link.active .menu-icon,
[data-kt-app-layout=light-sidebar] .app-sidebar .menu .menu-item .menu-link.active .menu-icon .svg-icon,
[data-kt-app-layout=light-sidebar] .app-sidebar .menu .menu-item .menu-link.active .menu-icon i {
  color: var(--bs-primary);
}

[data-kt-app-layout=light-sidebar] .app-sidebar .menu .menu-item .menu-link.active .menu-bullet .bullet {
  background-color: var(--bs-primary);
}

[data-kt-app-layout=light-sidebar] .app-sidebar .menu .menu-item .menu-link.active .menu-arrow:after {
  mask-image: url(${___CSS_LOADER_URL_REPLACEMENT_34___});
  /*rtl:begin:remove*/
  mask-repeat: no-repeat;
  mask-position: center;
  -webkit-mask-repeat: no-repeat;
  -webkit-mask-position: center;
  background-color: var(--bs-primary);
  mask-image: url(${___CSS_LOADER_URL_REPLACEMENT_35___});
  /*rtl:end:remove*/
}

[data-kt-app-layout=light-sidebar][data-kt-app-header-fixed=true] .app-header {
  background-color: var(--bs-app-bg-color);
  box-shadow: none;
  border-bottom: 1px dashed var(--bs-app-sidebar-light-separator-color);
}

[data-kt-app-layout=light-sidebar][data-kt-app-header-fixed=true] .app-sidebar .app-sidebar-logo {
  border-bottom: 1px dashed var(--bs-app-sidebar-light-separator-color);
}

.app-header-menu .menu .menu-item .menu-link {
  color: var(--bs-gray-700);
}

.app-header-menu .menu .menu-item .menu-link .menu-title {
  color: var(--bs-gray-700);
}

.app-header-menu .menu .menu-item .menu-link .menu-icon,
.app-header-menu .menu .menu-item .menu-link .menu-icon .svg-icon,
.app-header-menu .menu .menu-item .menu-link .menu-icon i {
  color: var(--bs-gray-500);
}

.app-header-menu .menu .menu-item .menu-link .menu-bullet .bullet {
  background-color: var(--bs-gray-500);
}

.app-header-menu .menu .menu-item .menu-link .menu-arrow:after {
  mask-image: url(${___CSS_LOADER_URL_REPLACEMENT_84___});
  /*rtl:begin:remove*/
  mask-repeat: no-repeat;
  mask-position: center;
  -webkit-mask-repeat: no-repeat;
  -webkit-mask-position: center;
  background-color: var(--bs-gray-500);
  mask-image: url(${___CSS_LOADER_URL_REPLACEMENT_85___});
  /*rtl:end:remove*/
}

.app-header-menu .menu .menu-item.hover:not(.here) > .menu-link:not(.disabled):not(.active):not(.here), .app-header-menu .menu .menu-item:not(.here) .menu-link:hover:not(.disabled):not(.active):not(.here) {
  transition: color 0.2s ease;
  background-color: var(--bs-menu-link-bg-color-active);
  color: var(--bs-primary);
}

.app-header-menu .menu .menu-item.hover:not(.here) > .menu-link:not(.disabled):not(.active):not(.here) .menu-title, .app-header-menu .menu .menu-item:not(.here) .menu-link:hover:not(.disabled):not(.active):not(.here) .menu-title {
  color: var(--bs-primary);
}

.app-header-menu .menu .menu-item.hover:not(.here) > .menu-link:not(.disabled):not(.active):not(.here) .menu-icon,
.app-header-menu .menu .menu-item.hover:not(.here) > .menu-link:not(.disabled):not(.active):not(.here) .menu-icon .svg-icon,
.app-header-menu .menu .menu-item.hover:not(.here) > .menu-link:not(.disabled):not(.active):not(.here) .menu-icon i, .app-header-menu .menu .menu-item:not(.here) .menu-link:hover:not(.disabled):not(.active):not(.here) .menu-icon,
.app-header-menu .menu .menu-item:not(.here) .menu-link:hover:not(.disabled):not(.active):not(.here) .menu-icon .svg-icon,
.app-header-menu .menu .menu-item:not(.here) .menu-link:hover:not(.disabled):not(.active):not(.here) .menu-icon i {
  color: var(--bs-primary);
}

.app-header-menu .menu .menu-item.hover:not(.here) > .menu-link:not(.disabled):not(.active):not(.here) .menu-bullet .bullet, .app-header-menu .menu .menu-item:not(.here) .menu-link:hover:not(.disabled):not(.active):not(.here) .menu-bullet .bullet {
  background-color: var(--bs-primary);
}

.app-header-menu .menu .menu-item.hover:not(.here) > .menu-link:not(.disabled):not(.active):not(.here) .menu-arrow:after, .app-header-menu .menu .menu-item:not(.here) .menu-link:hover:not(.disabled):not(.active):not(.here) .menu-arrow:after {
  mask-image: url(${___CSS_LOADER_URL_REPLACEMENT_34___});
  /*rtl:begin:remove*/
  mask-repeat: no-repeat;
  mask-position: center;
  -webkit-mask-repeat: no-repeat;
  -webkit-mask-position: center;
  background-color: var(--bs-primary);
  mask-image: url(${___CSS_LOADER_URL_REPLACEMENT_35___});
  /*rtl:end:remove*/
}

.app-header-menu .menu .menu-item.show > .menu-link {
  transition: color 0.2s ease;
  color: var(--bs-primary);
}

.app-header-menu .menu .menu-item.show > .menu-link .menu-title {
  color: var(--bs-primary);
}

.app-header-menu .menu .menu-item.show > .menu-link .menu-icon,
.app-header-menu .menu .menu-item.show > .menu-link .menu-icon .svg-icon,
.app-header-menu .menu .menu-item.show > .menu-link .menu-icon i {
  color: var(--bs-primary);
}

.app-header-menu .menu .menu-item.show > .menu-link .menu-bullet .bullet {
  background-color: var(--bs-primary);
}

.app-header-menu .menu .menu-item.show > .menu-link .menu-arrow:after {
  mask-image: url(${___CSS_LOADER_URL_REPLACEMENT_34___});
  /*rtl:begin:remove*/
  mask-repeat: no-repeat;
  mask-position: center;
  -webkit-mask-repeat: no-repeat;
  -webkit-mask-position: center;
  background-color: var(--bs-primary);
  mask-image: url(${___CSS_LOADER_URL_REPLACEMENT_35___});
  /*rtl:end:remove*/
}

.app-header-menu .menu .menu-item.here > .menu-link {
  transition: color 0.2s ease;
  background-color: var(--bs-menu-link-bg-color-active);
  color: var(--bs-primary);
}

.app-header-menu .menu .menu-item.here > .menu-link .menu-title {
  color: var(--bs-primary);
}

.app-header-menu .menu .menu-item.here > .menu-link .menu-icon,
.app-header-menu .menu .menu-item.here > .menu-link .menu-icon .svg-icon,
.app-header-menu .menu .menu-item.here > .menu-link .menu-icon i {
  color: var(--bs-primary);
}

.app-header-menu .menu .menu-item.here > .menu-link .menu-bullet .bullet {
  background-color: var(--bs-primary);
}

.app-header-menu .menu .menu-item.here > .menu-link .menu-arrow:after {
  mask-image: url(${___CSS_LOADER_URL_REPLACEMENT_34___});
  /*rtl:begin:remove*/
  mask-repeat: no-repeat;
  mask-position: center;
  -webkit-mask-repeat: no-repeat;
  -webkit-mask-position: center;
  background-color: var(--bs-primary);
  mask-image: url(${___CSS_LOADER_URL_REPLACEMENT_35___});
  /*rtl:end:remove*/
}

.app-header-menu .menu .menu-item .menu-link.active {
  transition: color 0.2s ease;
  background-color: var(--bs-menu-link-bg-color-active);
  color: var(--bs-primary);
}

.app-header-menu .menu .menu-item .menu-link.active .menu-title {
  color: var(--bs-primary);
}

.app-header-menu .menu .menu-item .menu-link.active .menu-icon,
.app-header-menu .menu .menu-item .menu-link.active .menu-icon .svg-icon,
.app-header-menu .menu .menu-item .menu-link.active .menu-icon i {
  color: var(--bs-primary);
}

.app-header-menu .menu .menu-item .menu-link.active .menu-bullet .bullet {
  background-color: var(--bs-primary);
}

.app-header-menu .menu .menu-item .menu-link.active .menu-arrow:after {
  mask-image: url(${___CSS_LOADER_URL_REPLACEMENT_34___});
  /*rtl:begin:remove*/
  mask-repeat: no-repeat;
  mask-position: center;
  -webkit-mask-repeat: no-repeat;
  -webkit-mask-position: center;
  background-color: var(--bs-primary);
  mask-image: url(${___CSS_LOADER_URL_REPLACEMENT_35___});
  /*rtl:end:remove*/
}

.app-header-menu .menu-extended {
  --bs-menu-link-bg-color-active: rgba(var(--bs-gray-100-rgb), 0.7);
  --bs-menu-link-bg-color-hover: rgba(var(--bs-gray-100-rgb), 0.7);
}

.app-header-menu .menu-extended .menu-custom-icon {
  background-color: var(--bs-gray-100);
}

.app-header-menu .menu-extended .menu-link.active .menu-custom-icon, .app-header-menu .menu-extended .menu-link:hover .menu-custom-icon {
  background-color: var(--bs-gray-200);
}

@media (min-width: 992px) {
  .app-header-menu .menu > .menu-item {
    margin-right: 0.5rem;
  }
  .app-header-menu .menu > .menu-item > .menu-link {
    padding-top: 0.775rem;
    padding-bottom: 0.775rem;
    font-weight: 500;
  }
  .app-header-menu .menu > .menu-item.here > .menu-link {
    transition: color 0.2s ease;
    background-color: var(--bs-app-header-base-menu-link-bg-color-active);
    color: var(--bs-primary);
  }
  .app-header-menu .menu > .menu-item.here > .menu-link .menu-title {
    color: var(--bs-primary);
  }
  .app-header-menu .menu > .menu-item.here > .menu-link .menu-icon,
  .app-header-menu .menu > .menu-item.here > .menu-link .menu-icon .svg-icon,
  .app-header-menu .menu > .menu-item.here > .menu-link .menu-icon i {
    color: var(--bs-primary);
  }
  .app-header-menu .menu > .menu-item.here > .menu-link .menu-bullet .bullet {
    background-color: var(--bs-primary);
  }
  .app-header-menu .menu > .menu-item.here > .menu-link .menu-arrow:after {
    mask-image: url(${___CSS_LOADER_URL_REPLACEMENT_34___});
    /*rtl:begin:remove*/
    mask-repeat: no-repeat;
    mask-position: center;
    -webkit-mask-repeat: no-repeat;
    -webkit-mask-position: center;
    background-color: var(--bs-primary);
    mask-image: url(${___CSS_LOADER_URL_REPLACEMENT_35___});
    /*rtl:end:remove*/
  }
}
@media (max-width: 991.98px) {
  .app-header .page-title {
    display: none !important;
  }
}
[data-kt-app-layout=dark-header] .app-header {
  background-color: #1e1e2d;
  border-bottom: 0 !important;
}

[data-kt-app-layout=dark-header] .app-header .btn-custom {
  color: #B5B5C3;
}

[data-kt-app-layout=dark-header] .app-header .btn-custom i,
[data-kt-app-layout=dark-header] .app-header .btn-custom .svg-icon {
  color: #B5B5C3;
}

[data-kt-app-layout=dark-header] .app-header .btn-custom.dropdown-toggle:after {
  color: #B5B5C3;
}

.btn-check:checked + [data-kt-app-layout=dark-header] .app-header .btn-custom, .btn-check:active + [data-kt-app-layout=dark-header] .app-header .btn-custom, [data-kt-app-layout=dark-header] .app-header .btn-custom:focus:not(.btn-active), [data-kt-app-layout=dark-header] .app-header .btn-custom:hover:not(.btn-active), [data-kt-app-layout=dark-header] .app-header .btn-custom:active:not(.btn-active), [data-kt-app-layout=dark-header] .app-header .btn-custom.active, [data-kt-app-layout=dark-header] .app-header .btn-custom.show, .show > [data-kt-app-layout=dark-header] .app-header .btn-custom {
  color: #B5B5C3;
  background-color: rgba(63, 66, 84, 0.35) !important;
}

.btn-check:checked + [data-kt-app-layout=dark-header] .app-header .btn-custom i,
.btn-check:checked + [data-kt-app-layout=dark-header] .app-header .btn-custom .svg-icon, .btn-check:active + [data-kt-app-layout=dark-header] .app-header .btn-custom i,
.btn-check:active + [data-kt-app-layout=dark-header] .app-header .btn-custom .svg-icon, [data-kt-app-layout=dark-header] .app-header .btn-custom:focus:not(.btn-active) i,
[data-kt-app-layout=dark-header] .app-header .btn-custom:focus:not(.btn-active) .svg-icon, [data-kt-app-layout=dark-header] .app-header .btn-custom:hover:not(.btn-active) i,
[data-kt-app-layout=dark-header] .app-header .btn-custom:hover:not(.btn-active) .svg-icon, [data-kt-app-layout=dark-header] .app-header .btn-custom:active:not(.btn-active) i,
[data-kt-app-layout=dark-header] .app-header .btn-custom:active:not(.btn-active) .svg-icon, [data-kt-app-layout=dark-header] .app-header .btn-custom.active i,
[data-kt-app-layout=dark-header] .app-header .btn-custom.active .svg-icon, [data-kt-app-layout=dark-header] .app-header .btn-custom.show i,
[data-kt-app-layout=dark-header] .app-header .btn-custom.show .svg-icon, .show > [data-kt-app-layout=dark-header] .app-header .btn-custom i,
.show > [data-kt-app-layout=dark-header] .app-header .btn-custom .svg-icon {
  color: var(--bs-primary);
}

.btn-check:checked + [data-kt-app-layout=dark-header] .app-header .btn-custom.dropdown-toggle:after, .btn-check:active + [data-kt-app-layout=dark-header] .app-header .btn-custom.dropdown-toggle:after, [data-kt-app-layout=dark-header] .app-header .btn-custom:focus:not(.btn-active).dropdown-toggle:after, [data-kt-app-layout=dark-header] .app-header .btn-custom:hover:not(.btn-active).dropdown-toggle:after, [data-kt-app-layout=dark-header] .app-header .btn-custom:active:not(.btn-active).dropdown-toggle:after, [data-kt-app-layout=dark-header] .app-header .btn-custom.active.dropdown-toggle:after, [data-kt-app-layout=dark-header] .app-header .btn-custom.show.dropdown-toggle:after, .show > [data-kt-app-layout=dark-header] .app-header .btn-custom.dropdown-toggle:after {
  color: var(--bs-primary);
}

@media (min-width: 992px) {
  [data-kt-app-layout=dark-header] .app-header-menu .menu > .menu-item > .menu-link {
    color: #9D9DA6;
  }
  [data-kt-app-layout=dark-header] .app-header-menu .menu > .menu-item > .menu-link .menu-title {
    color: #9D9DA6;
  }
  [data-kt-app-layout=dark-header] .app-header-menu .menu > .menu-item > .menu-link .menu-icon,
  [data-kt-app-layout=dark-header] .app-header-menu .menu > .menu-item > .menu-link .menu-icon .svg-icon,
  [data-kt-app-layout=dark-header] .app-header-menu .menu > .menu-item > .menu-link .menu-icon i {
    color: #C5C5D8;
  }
  [data-kt-app-layout=dark-header] .app-header-menu .menu > .menu-item > .menu-link .menu-bullet .bullet {
    background-color: #787887;
  }
  [data-kt-app-layout=dark-header] .app-header-menu .menu > .menu-item > .menu-link .menu-arrow:after {
    mask-image: url(${___CSS_LOADER_URL_REPLACEMENT_115___});
    /*rtl:begin:remove*/
    mask-repeat: no-repeat;
    mask-position: center;
    -webkit-mask-repeat: no-repeat;
    -webkit-mask-position: center;
    background-color: #787887;
    mask-image: url(${___CSS_LOADER_URL_REPLACEMENT_116___});
    /*rtl:end:remove*/
  }
  [data-kt-app-layout=dark-header] .app-header-menu .menu > .menu-item.hover:not(.here) > .menu-link:not(.disabled):not(.active):not(.here), [data-kt-app-layout=dark-header] .app-header-menu .menu > .menu-item:not(.here) > .menu-link:hover:not(.disabled):not(.active):not(.here) {
    transition: color 0.2s ease;
    background-color: #2A2A3C;
    color: var(--bs-primary-inverse);
  }
  [data-kt-app-layout=dark-header] .app-header-menu .menu > .menu-item.hover:not(.here) > .menu-link:not(.disabled):not(.active):not(.here) .menu-title, [data-kt-app-layout=dark-header] .app-header-menu .menu > .menu-item:not(.here) > .menu-link:hover:not(.disabled):not(.active):not(.here) .menu-title {
    color: var(--bs-primary-inverse);
  }
  [data-kt-app-layout=dark-header] .app-header-menu .menu > .menu-item.hover:not(.here) > .menu-link:not(.disabled):not(.active):not(.here) .menu-icon,
  [data-kt-app-layout=dark-header] .app-header-menu .menu > .menu-item.hover:not(.here) > .menu-link:not(.disabled):not(.active):not(.here) .menu-icon .svg-icon,
  [data-kt-app-layout=dark-header] .app-header-menu .menu > .menu-item.hover:not(.here) > .menu-link:not(.disabled):not(.active):not(.here) .menu-icon i, [data-kt-app-layout=dark-header] .app-header-menu .menu > .menu-item:not(.here) > .menu-link:hover:not(.disabled):not(.active):not(.here) .menu-icon,
  [data-kt-app-layout=dark-header] .app-header-menu .menu > .menu-item:not(.here) > .menu-link:hover:not(.disabled):not(.active):not(.here) .menu-icon .svg-icon,
  [data-kt-app-layout=dark-header] .app-header-menu .menu > .menu-item:not(.here) > .menu-link:hover:not(.disabled):not(.active):not(.here) .menu-icon i {
    color: var(--bs-primary-inverse);
  }
  [data-kt-app-layout=dark-header] .app-header-menu .menu > .menu-item.hover:not(.here) > .menu-link:not(.disabled):not(.active):not(.here) .menu-bullet .bullet, [data-kt-app-layout=dark-header] .app-header-menu .menu > .menu-item:not(.here) > .menu-link:hover:not(.disabled):not(.active):not(.here) .menu-bullet .bullet {
    background-color: var(--bs-primary-inverse);
  }
  [data-kt-app-layout=dark-header] .app-header-menu .menu > .menu-item.hover:not(.here) > .menu-link:not(.disabled):not(.active):not(.here) .menu-arrow:after, [data-kt-app-layout=dark-header] .app-header-menu .menu > .menu-item:not(.here) > .menu-link:hover:not(.disabled):not(.active):not(.here) .menu-arrow:after {
    mask-image: url(${___CSS_LOADER_URL_REPLACEMENT_110___});
    /*rtl:begin:remove*/
    mask-repeat: no-repeat;
    mask-position: center;
    -webkit-mask-repeat: no-repeat;
    -webkit-mask-position: center;
    background-color: var(--bs-primary-inverse);
    mask-image: url(${___CSS_LOADER_URL_REPLACEMENT_111___});
    /*rtl:end:remove*/
  }
  [data-kt-app-layout=dark-header] .app-header-menu .menu > .menu-item.show > .menu-link {
    transition: color 0.2s ease;
    color: var(--bs-primary-inverse);
  }
  [data-kt-app-layout=dark-header] .app-header-menu .menu > .menu-item.show > .menu-link .menu-title {
    color: var(--bs-primary-inverse);
  }
  [data-kt-app-layout=dark-header] .app-header-menu .menu > .menu-item.show > .menu-link .menu-icon,
  [data-kt-app-layout=dark-header] .app-header-menu .menu > .menu-item.show > .menu-link .menu-icon .svg-icon,
  [data-kt-app-layout=dark-header] .app-header-menu .menu > .menu-item.show > .menu-link .menu-icon i {
    color: var(--bs-primary-inverse);
  }
  [data-kt-app-layout=dark-header] .app-header-menu .menu > .menu-item.show > .menu-link .menu-bullet .bullet {
    background-color: var(--bs-primary-inverse);
  }
  [data-kt-app-layout=dark-header] .app-header-menu .menu > .menu-item.show > .menu-link .menu-arrow:after {
    mask-image: url(${___CSS_LOADER_URL_REPLACEMENT_110___});
    /*rtl:begin:remove*/
    mask-repeat: no-repeat;
    mask-position: center;
    -webkit-mask-repeat: no-repeat;
    -webkit-mask-position: center;
    background-color: var(--bs-primary-inverse);
    mask-image: url(${___CSS_LOADER_URL_REPLACEMENT_111___});
    /*rtl:end:remove*/
  }
  [data-kt-app-layout=dark-header] .app-header-menu .menu > .menu-item.here > .menu-link {
    transition: color 0.2s ease;
    background-color: #2A2A3C;
    color: var(--bs-primary-inverse);
  }
  [data-kt-app-layout=dark-header] .app-header-menu .menu > .menu-item.here > .menu-link .menu-title {
    color: var(--bs-primary-inverse);
  }
  [data-kt-app-layout=dark-header] .app-header-menu .menu > .menu-item.here > .menu-link .menu-icon,
  [data-kt-app-layout=dark-header] .app-header-menu .menu > .menu-item.here > .menu-link .menu-icon .svg-icon,
  [data-kt-app-layout=dark-header] .app-header-menu .menu > .menu-item.here > .menu-link .menu-icon i {
    color: var(--bs-primary-inverse);
  }
  [data-kt-app-layout=dark-header] .app-header-menu .menu > .menu-item.here > .menu-link .menu-bullet .bullet {
    background-color: var(--bs-primary-inverse);
  }
  [data-kt-app-layout=dark-header] .app-header-menu .menu > .menu-item.here > .menu-link .menu-arrow:after {
    mask-image: url(${___CSS_LOADER_URL_REPLACEMENT_110___});
    /*rtl:begin:remove*/
    mask-repeat: no-repeat;
    mask-position: center;
    -webkit-mask-repeat: no-repeat;
    -webkit-mask-position: center;
    background-color: var(--bs-primary-inverse);
    mask-image: url(${___CSS_LOADER_URL_REPLACEMENT_111___});
    /*rtl:end:remove*/
  }
  [data-kt-app-layout=dark-header] .app-header-menu .menu > .menu-item > .menu-link.active {
    transition: color 0.2s ease;
    background-color: #2A2A3C;
    color: var(--bs-primary-inverse);
  }
  [data-kt-app-layout=dark-header] .app-header-menu .menu > .menu-item > .menu-link.active .menu-title {
    color: var(--bs-primary-inverse);
  }
  [data-kt-app-layout=dark-header] .app-header-menu .menu > .menu-item > .menu-link.active .menu-icon,
  [data-kt-app-layout=dark-header] .app-header-menu .menu > .menu-item > .menu-link.active .menu-icon .svg-icon,
  [data-kt-app-layout=dark-header] .app-header-menu .menu > .menu-item > .menu-link.active .menu-icon i {
    color: var(--bs-primary-inverse);
  }
  [data-kt-app-layout=dark-header] .app-header-menu .menu > .menu-item > .menu-link.active .menu-bullet .bullet {
    background-color: var(--bs-primary-inverse);
  }
  [data-kt-app-layout=dark-header] .app-header-menu .menu > .menu-item > .menu-link.active .menu-arrow:after {
    mask-image: url(${___CSS_LOADER_URL_REPLACEMENT_110___});
    /*rtl:begin:remove*/
    mask-repeat: no-repeat;
    mask-position: center;
    -webkit-mask-repeat: no-repeat;
    -webkit-mask-position: center;
    background-color: var(--bs-primary-inverse);
    mask-image: url(${___CSS_LOADER_URL_REPLACEMENT_111___});
    /*rtl:end:remove*/
  }
  [data-kt-app-layout=light-sidebar] .app-header-menu .menu > .menu-item.here > .menu-link {
    transition: color 0.2s ease;
    background-color: var(--bs-app-sidebar-light-header-menu-link-bg-color-active);
    color: var(--bs-primary);
  }
  [data-kt-app-layout=light-sidebar] .app-header-menu .menu > .menu-item.here > .menu-link .menu-title {
    color: var(--bs-primary);
  }
  [data-kt-app-layout=light-sidebar] .app-header-menu .menu > .menu-item.here > .menu-link .menu-icon,
  [data-kt-app-layout=light-sidebar] .app-header-menu .menu > .menu-item.here > .menu-link .menu-icon .svg-icon,
  [data-kt-app-layout=light-sidebar] .app-header-menu .menu > .menu-item.here > .menu-link .menu-icon i {
    color: var(--bs-primary);
  }
  [data-kt-app-layout=light-sidebar] .app-header-menu .menu > .menu-item.here > .menu-link .menu-bullet .bullet {
    background-color: var(--bs-primary);
  }
  [data-kt-app-layout=light-sidebar] .app-header-menu .menu > .menu-item.here > .menu-link .menu-arrow:after {
    mask-image: url(${___CSS_LOADER_URL_REPLACEMENT_34___});
    /*rtl:begin:remove*/
    mask-repeat: no-repeat;
    mask-position: center;
    -webkit-mask-repeat: no-repeat;
    -webkit-mask-position: center;
    background-color: var(--bs-primary);
    mask-image: url(${___CSS_LOADER_URL_REPLACEMENT_35___});
    /*rtl:end:remove*/
  }
  [data-kt-app-layout=light-sidebar] .app-header-menu .menu > .menu-item > .menu-link.active {
    transition: color 0.2s ease;
    background-color: var(--bs-app-sidebar-light-header-menu-link-bg-color-active);
    color: var(--bs-primary);
  }
  [data-kt-app-layout=light-sidebar] .app-header-menu .menu > .menu-item > .menu-link.active .menu-title {
    color: var(--bs-primary);
  }
  [data-kt-app-layout=light-sidebar] .app-header-menu .menu > .menu-item > .menu-link.active .menu-icon,
  [data-kt-app-layout=light-sidebar] .app-header-menu .menu > .menu-item > .menu-link.active .menu-icon .svg-icon,
  [data-kt-app-layout=light-sidebar] .app-header-menu .menu > .menu-item > .menu-link.active .menu-icon i {
    color: var(--bs-primary);
  }
  [data-kt-app-layout=light-sidebar] .app-header-menu .menu > .menu-item > .menu-link.active .menu-bullet .bullet {
    background-color: var(--bs-primary);
  }
  [data-kt-app-layout=light-sidebar] .app-header-menu .menu > .menu-item > .menu-link.active .menu-arrow:after {
    mask-image: url(${___CSS_LOADER_URL_REPLACEMENT_34___});
    /*rtl:begin:remove*/
    mask-repeat: no-repeat;
    mask-position: center;
    -webkit-mask-repeat: no-repeat;
    -webkit-mask-position: center;
    background-color: var(--bs-primary);
    mask-image: url(${___CSS_LOADER_URL_REPLACEMENT_35___});
    /*rtl:end:remove*/
  }
  [data-kt-app-layout=light-sidebar]:not([data-kt-app-header-fixed=true]) .app-header {
    background-color: transparent;
    box-shadow: none;
    border-bottom: 1px solid var(--bs-app-sidebar-light-separator-color);
  }
}
@media (max-width: 991.98px) {
  [data-kt-app-layout=light-sidebar]:not([data-kt-app-header-fixed-mobile=true]) .app-header {
    background-color: transparent;
    box-shadow: none;
    border-bottom: 1px solid var(--bs-app-sidebar-light-separator-color);
  }
}
@media (min-width: 992px) {
  [data-kt-app-toolbar-enabled=true]:not([data-kt-app-toolbar-fixed=true]) .app-content {
    padding-top: 0;
  }
}
@media (max-width: 991.98px) {
  [data-kt-app-toolbar-enabled=true]:not([data-kt-app-toolbar-fixed-mobile=true]) .app-content {
    padding-top: 0;
  }
}
:is([data-kt-app-layout=light-sidebar], [data-kt-app-layout=light-header], [data-kt-app-layout=dark-header]) .app-toolbar .form-select.form-select {
  background-color: var(--bs-body-bg) !important;
}

@media (min-width: 992px) {
  body:not([data-kt-app-toolbar-fixed=true]) .app-toolbar {
    height: auto;
    background-color: transparent;
    border-top: 0;
    border-bottom: 0;
    box-shadow: none;
  }
}
@media (max-width: 991.98px) {
  body:not([data-kt-app-toolbar-fixed-mobile=true]) .app-toolbar {
    height: auto;
    background-color: transparent;
    border-top: 0;
    border-bottom: 0;
    box-shadow: none;
  }
}
@media (min-width: 992px) {
  [data-kt-app-layout=dark-header] .app-header .page-heading {
    color: #ffffff !important;
  }
}`, "",{"version":3,"sources":["webpack://./src/assets/scss/style.bundle.scss","webpack://./src/assets/scss/color-base.scss"],"names":[],"mappings":"AAAA,gBAAgB;AAGhB;;;;EAAA;AAKA;EAEE,kBAAA;EACA,oBAAA;EACA,oBAAA;EACA,kBAAA;EACA,iBAAA;EACA,oBAAA;EACA,oBAAA;EACA,mBAAA;EACA,kBAAA;EACA,kBAAA;EACA,mBAAA;EAEA,kBAAA;EACA,uBAAA;EACA,sBAAA;EACA,sBAAA;EACA,sBAAA;EACA,sBAAA;EACA,sBAAA;EACA,sBAAA;EACA,sBAAA;EACA,sBAAA;EACA,sBAAA;EACA,mBAAA;EAEA,uBAAA;EAKA,kBAAA;EACA,6BAAA;EAEA,iCAAA;EAKA,yBAAA;EACA,0BAAA;EACA,4BAAA;EACA,0BAAA;EACA,uBAAA;EACA,0BAAA;EACA,yBAAA;EACA,wBAAA;EACA,uBAAA;EACA,+BAAA;EACA,iCAAA;EACA,+BAAA;EACA,4BAAA;EACA,+BAAA;EACA,8BAAA;EACA,6BAAA;EACA,4BAAA;EACA,mCAAA;EACA,qCAAA;EACA,mCAAA;EACA,gCAAA;EACA,mCAAA;EACA,kCAAA;EACA,iCAAA;EACA,gCAAA;EAEA,uBAAA;EACA,+BAAA;EAEA,oDAAA;EACA,yGAAA;EACA,yFAAA;EACA,gDAAA;EACA,yBAAA;EACA,0BAAA;EACA,0BAAA;EACA,wBAAA;EAEA,gCAAA;EACA,4CAAA;EACA,oCAAA;EACA,0BAAA;EACA,oCAAA;EACA,0CAAA;EACA,mCAAA;EACA,yBAAA;EACA,mCAAA;EACA,qBAAA;EACA,+BAAA;EACA,2BAAA;EAGA,0BAAA;EACA,8BAAA;EACA,sCAAA;EACA,gCAAA;EAGA,sBAAA;EACA,wBAAA;EACA,0BAAA;EACA,mDAAA;EACA,4BAAA;EACA,+BAAA;EACA,+BAAA;EACA,2BAAA;EACA,4BAAA;EACA,8BAAA;EAIA,2DAAA;EACA,4BAAA;EACA,uCAAA;EACA,qDAAA;EACA,0BAAA;EACA,qBAAA;EACA,yBAAA;EACA,yBAAA;EACA,yBAAA;EACA,0BAAA;EACA,2BAAA;EACA,wBAAA;EACA,kCAAA;EACA,qBAAA;EACA,4BAAA;EACA,4BAAA;EACA,sCAAA;EACA,+CAAA;EACA,uCAAA;EACA,0BAAA;EACA,iCAAA;EACA,6CAAA;EACA,sCAAA;EACA,yBAAA;EACA,gCAAA;EACA,4BAAA;EACA,0BAAA;EACA,4BAAA;EACA,0BAAA;EACA,uBAAA;EACA,0BAAA;EACA,yBAAA;EACA,wBAAA;EACA,uBAAA;EACA,+BAAA;EACA,iCAAA;EACA,+BAAA;EACA,4BAAA;EACA,+BAAA;EACA,8BAAA;EACA,6BAAA;EACA,4BAAA;EACA,mCAAA;EACA,qCAAA;EACA,mCAAA;EACA,gCAAA;EACA,mCAAA;EACA,kCAAA;EACA,iCAAA;EACA,gCAAA;EACA,2BAAA;EACA,wBAAA;EACA,8BAAA;EACA,gCAAA;EACA,wCAAA;EAGA,wDAAA;EAEA,SAAA;EACA,aAAA;EACA,aAAA;EACA,aAAA;EACA,cAAA;EACA,eAAA;EACA,wBAAA;EACA,iCAAA;EACA,iCAAA;EACA,gCAAA;EACA,0BAAA;EAGA,sBAAA;EACA,6BAAA;EACA,sBAAA;EACA,6BAAA;EACA,sBAAA;EACA,6BAAA;EACA,sBAAA;EACA,6BAAA;EACA,sBAAA;EACA,8BAAA;EACA,sBAAA;EACA,gCAAA;EACA,sBAAA;EACA,gCAAA;EACA,sBAAA;EACA,gCAAA;EACA,sBAAA;EACA,gCAAA;EACA,mBAAA;EACA,mBAAA;EACA,qBAAA;EACA,qBAAA;EACA,kBAAA;EACA,qBAAA;EACA,oBAAA;EACA,kBAAA;EACA,uBAAA;EACA,4BAAA;EACA,8BAAA;EACA,0BAAA;EACA,4BAAA;EACA,yBAAA;EACA,4BAAA;EACA,2BAAA;EACA,uBAAA;EACA,2BAAA;EACA,2BAAA;EACA,wBAAA;EACA,2BAAA;EACA,0BAAA;EACA,wBAAA;EACA,6BAAA;EACA,6BAAA;EACA,+BAAA;EACA,2BAAA;EACA,6BAAA;EACA,0BAAA;EACA,6BAAA;EACA,4BAAA;EACA,0BAAA;EACA,6BAAA;EACA,0BAAA;EACA,6BAAA;EACA,8BAAA;EACA,2BAAA;EACA,6BAAA;EACA,6BAAA;EACA,4BAAA;EACA,8BAAA;EACA,wBAAA;EACA,0BAAA;EACA,4BAAA;EACA,wBAAA;EACA,0BAAA;EACA,uBAAA;EACA,0BAAA;EACA,yBAAA;EACA,uBAAA;EACA,wBAAA;EACA,2BAAA;EACA,2BAAA;EACA,2BAAA;EACA,2BAAA;EACA,2BAAA;EACA,2BAAA;EACA,2BAAA;EACA,2BAAA;EACA,2BAAA;EACA,0BAAA;EACA,iCAAA;EACA,oCAAA;EACA,iCAAA;EACA,mCAAA;EACA,gCAAA;EACA,qCAAA;EACA,kCAAA;EACA,gEAAA;EACA,6DAAA;EACA,4DAAA;EACA,uDAAA;EACA,oCAAA;EACA,gCAAA;EACA,0CAAA;EACA,uCAAA;EACA,6CAAA;EACA,sDAAA;EACA,yDAAA;EACA,sBAAA;EACA,6CAAA;EACA,sEAAA;EACA,yBAAA;EACA,yDAAA;EACA,qBAAA;EACA,qDAAA;EACA,wBAAA;EACA,gCAAA;EACA,6BAAA;EACA,kDAAA;EACA,6BAAA;EACA,yBAAA;EACA,8BAAA;EACA,+BAAA;EACA,sEAAA;EACA,gCAAA;EACA,sCAAA;EACA,kCAAA;EACA,wCAAA;EACA,uDAAA;EACA,6BAAA;EACA,gDAAA;EACA,8DAAA;EACA,oCAAA;EACA,gCAAA;EACA,mCAAA;EACA,kCAAA;EACA,kCAAA;EACA,oCAAA;EACA,sCAAA;EACA,qCAAA;EACA,qCAAA;EACA,uCAAA;EACA,6BAAA;EACA,mCAAA;EACA,0CAAA;EACA,kDAAA;EACA,kCAAA;EACA,iCAAA;EACA,uEAAA;EACA,6BAAA;EACA,uCAAA;EACA,4BAAA;EACA,2BAAA;EACA,2DAAA;EACA,qCAAA;EACA,8BAAA;EACA,mCAAA;EACA,qCAAA;AAJF;;AAOA;;;EAGE,sBAAA;AAJF;;AAOA;EACE,SAAA;EACA,uCAAA;EACA,mCAAA;EACA,uCAAA;EACA,uCAAA;EACA,2BAAA;EACA,qCAAA;EACA,mCAAA;EACA,8BAAA;EACA,6CAAA;AAJF;;AAOA;EACE,cAAA;EACA,cAAA;EACA,SAAA;EACA,wCAAA;EACA,aAAA;AAJF;;AAOA;EACE,aAAA;EACA,qBAAA;EACA,gBAAA;EACA,gBAAA;EACA,uCAAA;AAJF;;AAOA;EACE,+BAAA;AAJF;;AAMA;EACE;IACE,kBAAA;EAHF;AACF;AAMA;EACE,iCAAA;AAJF;;AAMA;EACE;IACE,iBAAA;EAHF;AACF;AAMA;EACE,iCAAA;AAJF;;AAMA;EACE;IACE,kBAAA;EAHF;AACF;AAMA;EACE,kBAAA;AAJF;;AAOA;EACE,kBAAA;AAJF;;AAOA;EACE,mBAAA;AAJF;;AAOA;EACE,aAAA;EACA,mBAAA;AAJF;;AAOA;EACE,yCAAA;UAAA,iCAAA;EACA,YAAA;EACA,8BAAA;AAJF;;AAOA;EACE,mBAAA;EACA,kBAAA;EACA,oBAAA;AAJF;;AAOA;;EAEE,kBAAA;AAJF;;AAOA;;;EAGE,aAAA;EACA,mBAAA;AAJF;;AAOA;;;;EAIE,gBAAA;AAJF;;AAOA;EACE,gBAAA;AAJF;;AAOA;EACE,qBAAA;EACA,cAAA;AAJF;;AAOA;EACE,gBAAA;AAJF;;AAOA;;EAEE,gBAAA;AAJF;;AAOA;EACE,kBAAA;AAJF;;AAOA;EACE,iBAAA;EACA,wCAAA;AAJF;;AAOA;;EAEE,kBAAA;EACA,iBAAA;EACA,cAAA;EACA,wBAAA;AAJF;;AAOA;EACE,eAAA;AAJF;;AAOA;EACE,WAAA;AAJF;;AAOA;EACE,gEAAA;EACA,qBAAA;AAJF;;AAMA;EACE,mDAAA;EACA,qBAAA;AAHF;;AAMA;EACE,cAAA;EACA,qBAAA;AAHF;;AAMA;;;;EAIE,qCAAA;EACA,cAAA;AAHF;;AAMA;EACE,cAAA;EACA,aAAA;EACA,mBAAA;EACA,cAAA;EACA,kBAAA;AAHF;;AAKA;EACE,kBAAA;EACA,cAAA;EACA,kBAAA;AAFF;;AAKA;EACE,kBAAA;EACA,2BAAA;EACA,qBAAA;AAFF;;AAIA;EACE,cAAA;AADF;;AAIA;EACE,2BAAA;EACA,kBAAA;EACA,wBAAA;EACA,sCAAA;EACA,uBAAA;AADF;;AAGA;EACE,UAAA;EACA,cAAA;AAAF;;AAGA;EACE,gBAAA;AAAF;;AAGA;;EAEE,sBAAA;AAAF;;AAGA;EACE,oBAAA;EACA,yBAAA;AAAF;;AAGA;EACE,oBAAA;EACA,uBAAA;EACA,cAAA;EACA,gBAAA;AAAF;;AAGA;EACE,mBAAA;EACA,gCAAA;AAAF;;AAGA;;;;;;EAME,qBAAA;EACA,mBAAA;EACA,eAAA;AAAF;;AAGA;EACE,qBAAA;AAAF;;AAGA;EACE,gBAAA;AAAF;;AAGA;EACE,UAAA;AAAF;;AAGA;;;;;EAKE,SAAA;EACA,oBAAA;EACA,kBAAA;EACA,oBAAA;AAAF;;AAGA;;EAEE,oBAAA;AAAF;;AAGA;EACE,eAAA;AAAF;;AAGA;EACE,iBAAA;AAAF;;AAEA;EACE,UAAA;AACF;;AAEA;EACE,wBAAA;AACF;;AAEA;;;;EAIE,0BAAA;AACF;;AACA;;;;EAIE,eAAA;AAEF;;AACA;EACE,UAAA;EACA,kBAAA;AAEF;;AACA;EACE,gBAAA;AAEF;;AACA;EACE,YAAA;EACA,UAAA;EACA,SAAA;EACA,SAAA;AAEF;;AACA;EACE,WAAA;EACA,WAAA;EACA,UAAA;EACA,qBAAA;EACA,iCAAA;EACA,oBAAA;AAEF;;AAAA;EACE;IACE,iBAAA;EAGF;AACF;AADA;EACE,WAAA;AAGF;;AAAA;;;;;;;EAOE,UAAA;AAGF;;AAAA;EACE,YAAA;AAGF;;AAAA;EACE,oBAAA;EACA,6BAAA;AAGF;;AAAA;;;;;;;CAAA;AAQA;EACE,wBAAA;AAGF;;AAAA;EACE,UAAA;AAGF;;AAAA;EACE,aAAA;EACA,0BAAA;AAGF;;AAAA;EACE,qBAAA;AAGF;;AAAA;EACE,SAAA;AAGF;;AAAA;EACE,kBAAA;EACA,eAAA;AAGF;;AAAA;EACE,wBAAA;AAGF;;AAAA;EACE,wBAAA;AAGF;;AAAA;EACE,kBAAA;EACA,gBAAA;AAGF;;AAAA;EACE,iCAAA;EACA,gBAAA;EACA,gBAAA;AAGF;;AADA;EACE;IACE,eAAA;EAIF;AACF;AADA;EACE,iCAAA;EACA,gBAAA;EACA,gBAAA;AAGF;;AADA;EACE;IACE,iBAAA;EAIF;AACF;AADA;EACE,iCAAA;EACA,gBAAA;EACA,gBAAA;AAGF;;AADA;EACE;IACE,eAAA;EAIF;AACF;AADA;EACE,iCAAA;EACA,gBAAA;EACA,gBAAA;AAGF;;AADA;EACE;IACE,iBAAA;EAIF;AACF;AADA;EACE,iCAAA;EACA,gBAAA;EACA,gBAAA;AAGF;;AADA;EACE;IACE,eAAA;EAIF;AACF;AADA;EACE,iCAAA;EACA,gBAAA;EACA,gBAAA;AAGF;;AADA;EACE;IACE,iBAAA;EAIF;AACF;AADA;EACE,eAAA;EACA,gBAAA;AAGF;;AAAA;EACE,eAAA;EACA,gBAAA;AAGF;;AAAA;EACE,qBAAA;AAGF;;AADA;EACE,oBAAA;AAIF;;AADA;EACE,kBAAA;EACA,yBAAA;AAIF;;AADA;EACE,mBAAA;EACA,kBAAA;AAIF;;AAFA;EACE,gBAAA;AAKF;;AAFA;EACE,iBAAA;EACA,mBAAA;EACA,kBAAA;EACA,cAAA;AAKF;;AAHA;EACE,aAAA;AAMF;;AAHA;EACE,eAAA;EACA,YAAA;AAMF;;AAHA;EACE,gBAAA;EACA,mCAAA;EACA,2DAAA;EACA,sCAAA;EACA,mCAAA;EACA,eAAA;EACA,YAAA;AAMF;;AAHA;EACE,qBAAA;AAMF;;AAHA;EACE,qBAAA;EACA,cAAA;AAMF;;AAHA;EACE,kBAAA;EACA,yBAAA;AAMF;;AAHA;;;;;;;EAOE,qBAAA;EACA,gBAAA;EACA,WAAA;EACA,6CAAA;EACA,4CAAA;EACA,kBAAA;EACA,iBAAA;AAMF;;AAHA;EACE;IACE,gBAAA;EAMF;AACF;AAJA;EACE;IACE,gBAAA;EAMF;AACF;AAJA;EACE;IACE,gBAAA;EAMF;AACF;AAJA;EACE;IACE,iBAAA;EAMF;AACF;AAJA;EACE;IACE,iBAAA;EAMF;AACF;AAJA;EACE,qBAAA;EACA,gBAAA;EACA,aAAA;EACA,eAAA;EACA,yCAAA;EACA,6CAAA;EACA,4CAAA;AAMF;;AAJA;EACE,cAAA;EACA,WAAA;EACA,eAAA;EACA,6CAAA;EACA,4CAAA;EACA,8BAAA;AAOF;;AAJA;EACE,SAAA;AAOF;;AAJA;EACE,cAAA;EACA,WAAA;AAOF;;AAJA;EACE,cAAA;EACA,WAAA;AAOF;;AAJA;EACE,cAAA;EACA,UAAA;AAOF;;AAJA;EACE,cAAA;EACA,qBAAA;AAOF;;AAJA;EACE,cAAA;EACA,UAAA;AAOF;;AAJA;EACE,cAAA;EACA,UAAA;AAOF;;AAJA;EACE,cAAA;EACA,qBAAA;AAOF;;AAJA;EACE,cAAA;EACA,WAAA;AAOF;;AAJA;EACE,cAAA;EACA,kBAAA;AAOF;;AAJA;EACE,cAAA;EACA,mBAAA;AAOF;;AAJA;EACE,cAAA;EACA,UAAA;AAOF;;AAJA;EACE,cAAA;EACA,mBAAA;AAOF;;AAJA;EACE,cAAA;EACA,mBAAA;AAOF;;AAJA;EACE,cAAA;EACA,UAAA;AAOF;;AAJA;EACE,cAAA;EACA,mBAAA;AAOF;;AAJA;EACE,cAAA;EACA,mBAAA;AAOF;;AAJA;EACE,cAAA;EACA,UAAA;AAOF;;AAJA;EACE,cAAA;EACA,mBAAA;AAOF;;AAJA;EACE,cAAA;EACA,mBAAA;AAOF;;AAJA;EACE,cAAA;EACA,WAAA;AAOF;;AAJA;EACE,wBAAA;AAOF;;AAJA;EACE,yBAAA;AAOF;;AAJA;EACE,gBAAA;AAOF;;AAJA;EACE,yBAAA;AAOF;;AAJA;EACE,yBAAA;AAOF;;AAJA;EACE,gBAAA;AAOF;;AAJA;EACE,yBAAA;AAOF;;AAJA;EACE,yBAAA;AAOF;;AAJA;EACE,gBAAA;AAOF;;AAJA;EACE,yBAAA;AAOF;;AAJA;EACE,yBAAA;AAOF;;AAJA;;EAEE,mBAAA;AAOF;;AAJA;;EAEE,mBAAA;AAOF;;AAJA;;EAEE,sBAAA;AAOF;;AAJA;;EAEE,sBAAA;AAOF;;AAJA;;EAEE,qBAAA;AAOF;;AAJA;;EAEE,qBAAA;AAOF;;AAJA;;EAEE,sBAAA;AAOF;;AAJA;;EAEE,sBAAA;AAOF;;AAJA;;EAEE,mBAAA;AAOF;;AAJA;;EAEE,mBAAA;AAOF;;AAJA;;EAEE,sBAAA;AAOF;;AAJA;;EAEE,sBAAA;AAOF;;AAJA;;EAEE,qBAAA;AAOF;;AAJA;;EAEE,qBAAA;AAOF;;AAJA;;EAEE,sBAAA;AAOF;;AAJA;;EAEE,sBAAA;AAOF;;AAJA;;EAEE,mBAAA;AAOF;;AAJA;;EAEE,mBAAA;AAOF;;AAJA;;EAEE,sBAAA;AAOF;;AAJA;;EAEE,sBAAA;AAOF;;AAJA;;EAEE,qBAAA;AAOF;;AAJA;;EAEE,qBAAA;AAOF;;AAJA;EACE;IACE,SAAA;EAOF;EALA;IACE,cAAA;IACA,WAAA;EAOF;EALA;IACE,cAAA;IACA,WAAA;EAOF;EALA;IACE,cAAA;IACA,UAAA;EAOF;EALA;IACE,cAAA;IACA,qBAAA;EAOF;EALA;IACE,cAAA;IACA,UAAA;EAOF;EALA;IACE,cAAA;IACA,UAAA;EAOF;EALA;IACE,cAAA;IACA,qBAAA;EAOF;EALA;IACE,cAAA;IACA,WAAA;EAOF;EALA;IACE,cAAA;IACA,kBAAA;EAOF;EALA;IACE,cAAA;IACA,mBAAA;EAOF;EALA;IACE,cAAA;IACA,UAAA;EAOF;EALA;IACE,cAAA;IACA,mBAAA;EAOF;EALA;IACE,cAAA;IACA,mBAAA;EAOF;EALA;IACE,cAAA;IACA,UAAA;EAOF;EALA;IACE,cAAA;IACA,mBAAA;EAOF;EALA;IACE,cAAA;IACA,mBAAA;EAOF;EALA;IACE,cAAA;IACA,UAAA;EAOF;EALA;IACE,cAAA;IACA,mBAAA;EAOF;EALA;IACE,cAAA;IACA,mBAAA;EAOF;EALA;IACE,cAAA;IACA,WAAA;EAOF;EALA;IACE,cAAA;EAOF;EALA;IACE,wBAAA;EAOF;EALA;IACE,yBAAA;EAOF;EALA;IACE,gBAAA;EAOF;EALA;IACE,yBAAA;EAOF;EALA;IACE,yBAAA;EAOF;EALA;IACE,gBAAA;EAOF;EALA;IACE,yBAAA;EAOF;EALA;IACE,yBAAA;EAOF;EALA;IACE,gBAAA;EAOF;EALA;IACE,yBAAA;EAOF;EALA;IACE,yBAAA;EAOF;EALA;;IAEE,mBAAA;EAOF;EALA;;IAEE,mBAAA;EAOF;EALA;;IAEE,sBAAA;EAOF;EALA;;IAEE,sBAAA;EAOF;EALA;;IAEE,qBAAA;EAOF;EALA;;IAEE,qBAAA;EAOF;EALA;;IAEE,sBAAA;EAOF;EALA;;IAEE,sBAAA;EAOF;EALA;;IAEE,mBAAA;EAOF;EALA;;IAEE,mBAAA;EAOF;EALA;;IAEE,sBAAA;EAOF;EALA;;IAEE,sBAAA;EAOF;EALA;;IAEE,qBAAA;EAOF;EALA;;IAEE,qBAAA;EAOF;EALA;;IAEE,sBAAA;EAOF;EALA;;IAEE,sBAAA;EAOF;EALA;;IAEE,mBAAA;EAOF;EALA;;IAEE,mBAAA;EAOF;EALA;;IAEE,sBAAA;EAOF;EALA;;IAEE,sBAAA;EAOF;EALA;;IAEE,qBAAA;EAOF;EALA;;IAEE,qBAAA;EAOF;AACF;AALA;EACE;IACE,SAAA;EAOF;EALA;IACE,cAAA;IACA,WAAA;EAOF;EALA;IACE,cAAA;IACA,WAAA;EAOF;EALA;IACE,cAAA;IACA,UAAA;EAOF;EALA;IACE,cAAA;IACA,qBAAA;EAOF;EALA;IACE,cAAA;IACA,UAAA;EAOF;EALA;IACE,cAAA;IACA,UAAA;EAOF;EALA;IACE,cAAA;IACA,qBAAA;EAOF;EALA;IACE,cAAA;IACA,WAAA;EAOF;EALA;IACE,cAAA;IACA,kBAAA;EAOF;EALA;IACE,cAAA;IACA,mBAAA;EAOF;EALA;IACE,cAAA;IACA,UAAA;EAOF;EALA;IACE,cAAA;IACA,mBAAA;EAOF;EALA;IACE,cAAA;IACA,mBAAA;EAOF;EALA;IACE,cAAA;IACA,UAAA;EAOF;EALA;IACE,cAAA;IACA,mBAAA;EAOF;EALA;IACE,cAAA;IACA,mBAAA;EAOF;EALA;IACE,cAAA;IACA,UAAA;EAOF;EALA;IACE,cAAA;IACA,mBAAA;EAOF;EALA;IACE,cAAA;IACA,mBAAA;EAOF;EALA;IACE,cAAA;IACA,WAAA;EAOF;EALA;IACE,cAAA;EAOF;EALA;IACE,wBAAA;EAOF;EALA;IACE,yBAAA;EAOF;EALA;IACE,gBAAA;EAOF;EALA;IACE,yBAAA;EAOF;EALA;IACE,yBAAA;EAOF;EALA;IACE,gBAAA;EAOF;EALA;IACE,yBAAA;EAOF;EALA;IACE,yBAAA;EAOF;EALA;IACE,gBAAA;EAOF;EALA;IACE,yBAAA;EAOF;EALA;IACE,yBAAA;EAOF;EALA;;IAEE,mBAAA;EAOF;EALA;;IAEE,mBAAA;EAOF;EALA;;IAEE,sBAAA;EAOF;EALA;;IAEE,sBAAA;EAOF;EALA;;IAEE,qBAAA;EAOF;EALA;;IAEE,qBAAA;EAOF;EALA;;IAEE,sBAAA;EAOF;EALA;;IAEE,sBAAA;EAOF;EALA;;IAEE,mBAAA;EAOF;EALA;;IAEE,mBAAA;EAOF;EALA;;IAEE,sBAAA;EAOF;EALA;;IAEE,sBAAA;EAOF;EALA;;IAEE,qBAAA;EAOF;EALA;;IAEE,qBAAA;EAOF;EALA;;IAEE,sBAAA;EAOF;EALA;;IAEE,sBAAA;EAOF;EALA;;IAEE,mBAAA;EAOF;EALA;;IAEE,mBAAA;EAOF;EALA;;IAEE,sBAAA;EAOF;EALA;;IAEE,sBAAA;EAOF;EALA;;IAEE,qBAAA;EAOF;EALA;;IAEE,qBAAA;EAOF;AACF;AALA;EACE;IACE,SAAA;EAOF;EALA;IACE,cAAA;IACA,WAAA;EAOF;EALA;IACE,cAAA;IACA,WAAA;EAOF;EALA;IACE,cAAA;IACA,UAAA;EAOF;EALA;IACE,cAAA;IACA,qBAAA;EAOF;EALA;IACE,cAAA;IACA,UAAA;EAOF;EALA;IACE,cAAA;IACA,UAAA;EAOF;EALA;IACE,cAAA;IACA,qBAAA;EAOF;EALA;IACE,cAAA;IACA,WAAA;EAOF;EALA;IACE,cAAA;IACA,kBAAA;EAOF;EALA;IACE,cAAA;IACA,mBAAA;EAOF;EALA;IACE,cAAA;IACA,UAAA;EAOF;EALA;IACE,cAAA;IACA,mBAAA;EAOF;EALA;IACE,cAAA;IACA,mBAAA;EAOF;EALA;IACE,cAAA;IACA,UAAA;EAOF;EALA;IACE,cAAA;IACA,mBAAA;EAOF;EALA;IACE,cAAA;IACA,mBAAA;EAOF;EALA;IACE,cAAA;IACA,UAAA;EAOF;EALA;IACE,cAAA;IACA,mBAAA;EAOF;EALA;IACE,cAAA;IACA,mBAAA;EAOF;EALA;IACE,cAAA;IACA,WAAA;EAOF;EALA;IACE,cAAA;EAOF;EALA;IACE,wBAAA;EAOF;EALA;IACE,yBAAA;EAOF;EALA;IACE,gBAAA;EAOF;EALA;IACE,yBAAA;EAOF;EALA;IACE,yBAAA;EAOF;EALA;IACE,gBAAA;EAOF;EALA;IACE,yBAAA;EAOF;EALA;IACE,yBAAA;EAOF;EALA;IACE,gBAAA;EAOF;EALA;IACE,yBAAA;EAOF;EALA;IACE,yBAAA;EAOF;EALA;;IAEE,mBAAA;EAOF;EALA;;IAEE,mBAAA;EAOF;EALA;;IAEE,sBAAA;EAOF;EALA;;IAEE,sBAAA;EAOF;EALA;;IAEE,qBAAA;EAOF;EALA;;IAEE,qBAAA;EAOF;EALA;;IAEE,sBAAA;EAOF;EALA;;IAEE,sBAAA;EAOF;EALA;;IAEE,mBAAA;EAOF;EALA;;IAEE,mBAAA;EAOF;EALA;;IAEE,sBAAA;EAOF;EALA;;IAEE,sBAAA;EAOF;EALA;;IAEE,qBAAA;EAOF;EALA;;IAEE,qBAAA;EAOF;EALA;;IAEE,sBAAA;EAOF;EALA;;IAEE,sBAAA;EAOF;EALA;;IAEE,mBAAA;EAOF;EALA;;IAEE,mBAAA;EAOF;EALA;;IAEE,sBAAA;EAOF;EALA;;IAEE,sBAAA;EAOF;EALA;;IAEE,qBAAA;EAOF;EALA;;IAEE,qBAAA;EAOF;AACF;AALA;EACE;IACE,SAAA;EAOF;EALA;IACE,cAAA;IACA,WAAA;EAOF;EALA;IACE,cAAA;IACA,WAAA;EAOF;EALA;IACE,cAAA;IACA,UAAA;EAOF;EALA;IACE,cAAA;IACA,qBAAA;EAOF;EALA;IACE,cAAA;IACA,UAAA;EAOF;EALA;IACE,cAAA;IACA,UAAA;EAOF;EALA;IACE,cAAA;IACA,qBAAA;EAOF;EALA;IACE,cAAA;IACA,WAAA;EAOF;EALA;IACE,cAAA;IACA,kBAAA;EAOF;EALA;IACE,cAAA;IACA,mBAAA;EAOF;EALA;IACE,cAAA;IACA,UAAA;EAOF;EALA;IACE,cAAA;IACA,mBAAA;EAOF;EALA;IACE,cAAA;IACA,mBAAA;EAOF;EALA;IACE,cAAA;IACA,UAAA;EAOF;EALA;IACE,cAAA;IACA,mBAAA;EAOF;EALA;IACE,cAAA;IACA,mBAAA;EAOF;EALA;IACE,cAAA;IACA,UAAA;EAOF;EALA;IACE,cAAA;IACA,mBAAA;EAOF;EALA;IACE,cAAA;IACA,mBAAA;EAOF;EALA;IACE,cAAA;IACA,WAAA;EAOF;EALA;IACE,cAAA;EAOF;EALA;IACE,wBAAA;EAOF;EALA;IACE,yBAAA;EAOF;EALA;IACE,gBAAA;EAOF;EALA;IACE,yBAAA;EAOF;EALA;IACE,yBAAA;EAOF;EALA;IACE,gBAAA;EAOF;EALA;IACE,yBAAA;EAOF;EALA;IACE,yBAAA;EAOF;EALA;IACE,gBAAA;EAOF;EALA;IACE,yBAAA;EAOF;EALA;IACE,yBAAA;EAOF;EALA;;IAEE,mBAAA;EAOF;EALA;;IAEE,mBAAA;EAOF;EALA;;IAEE,sBAAA;EAOF;EALA;;IAEE,sBAAA;EAOF;EALA;;IAEE,qBAAA;EAOF;EALA;;IAEE,qBAAA;EAOF;EALA;;IAEE,sBAAA;EAOF;EALA;;IAEE,sBAAA;EAOF;EALA;;IAEE,mBAAA;EAOF;EALA;;IAEE,mBAAA;EAOF;EALA;;IAEE,sBAAA;EAOF;EALA;;IAEE,sBAAA;EAOF;EALA;;IAEE,qBAAA;EAOF;EALA;;IAEE,qBAAA;EAOF;EALA;;IAEE,sBAAA;EAOF;EALA;;IAEE,sBAAA;EAOF;EALA;;IAEE,mBAAA;EAOF;EALA;;IAEE,mBAAA;EAOF;EALA;;IAEE,sBAAA;EAOF;EALA;;IAEE,sBAAA;EAOF;EALA;;IAEE,qBAAA;EAOF;EALA;;IAEE,qBAAA;EAOF;AACF;AALA;EACE;IACE,SAAA;EAOF;EALA;IACE,cAAA;IACA,WAAA;EAOF;EALA;IACE,cAAA;IACA,WAAA;EAOF;EALA;IACE,cAAA;IACA,UAAA;EAOF;EALA;IACE,cAAA;IACA,qBAAA;EAOF;EALA;IACE,cAAA;IACA,UAAA;EAOF;EALA;IACE,cAAA;IACA,UAAA;EAOF;EALA;IACE,cAAA;IACA,qBAAA;EAOF;EALA;IACE,cAAA;IACA,WAAA;EAOF;EALA;IACE,cAAA;IACA,kBAAA;EAOF;EALA;IACE,cAAA;IACA,mBAAA;EAOF;EALA;IACE,cAAA;IACA,UAAA;EAOF;EALA;IACE,cAAA;IACA,mBAAA;EAOF;EALA;IACE,cAAA;IACA,mBAAA;EAOF;EALA;IACE,cAAA;IACA,UAAA;EAOF;EALA;IACE,cAAA;IACA,mBAAA;EAOF;EALA;IACE,cAAA;IACA,mBAAA;EAOF;EALA;IACE,cAAA;IACA,UAAA;EAOF;EALA;IACE,cAAA;IACA,mBAAA;EAOF;EALA;IACE,cAAA;IACA,mBAAA;EAOF;EALA;IACE,cAAA;IACA,WAAA;EAOF;EALA;IACE,cAAA;EAOF;EALA;IACE,wBAAA;EAOF;EALA;IACE,yBAAA;EAOF;EALA;IACE,gBAAA;EAOF;EALA;IACE,yBAAA;EAOF;EALA;IACE,yBAAA;EAOF;EALA;IACE,gBAAA;EAOF;EALA;IACE,yBAAA;EAOF;EALA;IACE,yBAAA;EAOF;EALA;IACE,gBAAA;EAOF;EALA;IACE,yBAAA;EAOF;EALA;IACE,yBAAA;EAOF;EALA;;IAEE,mBAAA;EAOF;EALA;;IAEE,mBAAA;EAOF;EALA;;IAEE,sBAAA;EAOF;EALA;;IAEE,sBAAA;EAOF;EALA;;IAEE,qBAAA;EAOF;EALA;;IAEE,qBAAA;EAOF;EALA;;IAEE,sBAAA;EAOF;EALA;;IAEE,sBAAA;EAOF;EALA;;IAEE,mBAAA;EAOF;EALA;;IAEE,mBAAA;EAOF;EALA;;IAEE,sBAAA;EAOF;EALA;;IAEE,sBAAA;EAOF;EALA;;IAEE,qBAAA;EAOF;EALA;;IAEE,qBAAA;EAOF;EALA;;IAEE,sBAAA;EAOF;EALA;;IAEE,sBAAA;EAOF;EALA;;IAEE,mBAAA;EAOF;EALA;;IAEE,mBAAA;EAOF;EALA;;IAEE,sBAAA;EAOF;EALA;;IAEE,sBAAA;EAOF;EALA;;IAEE,qBAAA;EAOF;EALA;;IAEE,qBAAA;EAOF;AACF;AALA;EACE,sCAAA;EACA,0BAAA;EACA,+CAAA;EACA,iCAAA;EACA,8CAAA;EACA,yDAAA;EACA,6CAAA;EACA,wCAAA;EACA,4CAAA;EACA,uCAAA;EACA,WAAA;EACA,mBAAA;EACA,4BAAA;EACA,mBAAA;EACA,0CAAA;AAOF;;AALA;EACE,wBAAA;EACA,oCAAA;EACA,wBAAA;EACA,wDAAA;AAQF;;AANA;EACE,uBAAA;AASF;;AAPA;EACE,sBAAA;AAUF;;AAPA;EACE,kCAAA;AAUF;;AAPA;EACE,iBAAA;AAUF;;AAPA;EACE,sBAAA;AAUF;;AAPA;EACE,mBAAA;AAUF;;AARA;EACE,mBAAA;AAWF;;AARA;EACE,sBAAA;AAWF;;AATA;EACE,mBAAA;AAYF;;AATA;EACE,gDAAA;EACA,oCAAA;AAYF;;AATA;EACE,gDAAA;EACA,oCAAA;AAYF;;AATA;EACE,+CAAA;EACA,mCAAA;AAYF;;AATA;EACE,8CAAA;EACA,kCAAA;AAYF;;AATA;EACE,yBAAA;EACA,sBAAA;EACA,gCAAA;EACA,8BAAA;EACA,iCAAA;EACA,6BAAA;EACA,gCAAA;EACA,4BAAA;EACA,+BAAA;EACA,4BAAA;EACA,0CAAA;AAYF;;AATA;EACE,yBAAA;EACA,sBAAA;EACA,gCAAA;EACA,8BAAA;EACA,iCAAA;EACA,6BAAA;EACA,gCAAA;EACA,4BAAA;EACA,+BAAA;EACA,4BAAA;EACA,0CAAA;AAYF;;AATA;EACE,yBAAA;EACA,sBAAA;EACA,gCAAA;EACA,8BAAA;EACA,iCAAA;EACA,6BAAA;EACA,gCAAA;EACA,4BAAA;EACA,+BAAA;EACA,4BAAA;EACA,0CAAA;AAYF;;AATA;EACE,yBAAA;EACA,sBAAA;EACA,gCAAA;EACA,8BAAA;EACA,iCAAA;EACA,6BAAA;EACA,gCAAA;EACA,4BAAA;EACA,+BAAA;EACA,4BAAA;EACA,0CAAA;AAYF;;AATA;EACE,yBAAA;EACA,sBAAA;EACA,gCAAA;EACA,8BAAA;EACA,iCAAA;EACA,6BAAA;EACA,gCAAA;EACA,4BAAA;EACA,+BAAA;EACA,4BAAA;EACA,0CAAA;AAYF;;AATA;EACE,yBAAA;EACA,sBAAA;EACA,gCAAA;EACA,8BAAA;EACA,iCAAA;EACA,6BAAA;EACA,gCAAA;EACA,4BAAA;EACA,+BAAA;EACA,4BAAA;EACA,0CAAA;AAYF;;AATA;EACE,yBAAA;EACA,sBAAA;EACA,gCAAA;EACA,8BAAA;EACA,iCAAA;EACA,6BAAA;EACA,gCAAA;EACA,4BAAA;EACA,+BAAA;EACA,4BAAA;EACA,0CAAA;AAYF;;AATA;EACE,yBAAA;EACA,sBAAA;EACA,gCAAA;EACA,8BAAA;EACA,iCAAA;EACA,6BAAA;EACA,gCAAA;EACA,4BAAA;EACA,+BAAA;EACA,4BAAA;EACA,0CAAA;AAYF;;AATA;EACE,gBAAA;EACA,iCAAA;AAYF;;AATA;EACE;IACE,gBAAA;IACA,iCAAA;EAYF;AACF;AAVA;EACE;IACE,gBAAA;IACA,iCAAA;EAYF;AACF;AAVA;EACE;IACE,gBAAA;IACA,iCAAA;EAYF;AACF;AAVA;EACE;IACE,gBAAA;IACA,iCAAA;EAYF;AACF;AAVA;EACE;IACE,gBAAA;IACA,iCAAA;EAYF;AACF;AAVA;EACE,qBAAA;EACA,kBAAA;EACA,gBAAA;EACA,yBAAA;AAYF;;AATA;EACE,iCAAA;EACA,oCAAA;EACA,gBAAA;EACA,kBAAA;EACA,gBAAA;EACA,gBAAA;EACA,yBAAA;AAYF;;AATA;EACE,iCAAA;EACA,oCAAA;EACA,kBAAA;AAYF;;AATA;EACE,gCAAA;EACA,mCAAA;EACA,kBAAA;AAYF;;AATA;EACE,kBAAA;EACA,kBAAA;EACA,2BAAA;AAYF;;AATA;EACE,cAAA;EACA,WAAA;EACA,sBAAA;EACA,iBAAA;EACA,gBAAA;EACA,gBAAA;EACA,yBAAA;EACA,mCAAA;EACA,4BAAA;EACA,oCAAA;EACA,gBAAA;EACA,uBAAA;EACA,iBAAA;EACA,wEAAA;AAYF;;AAVA;EACE;IACE,gBAAA;EAaF;AACF;AAXA;EACE,gBAAA;AAaF;;AAXA;EACE,eAAA;AAcF;;AAZA;EACE,yBAAA;EACA,mCAAA;EACA,gCAAA;EACA,UAAA;EACA,0EAAA;AAeF;;AAbA;EACE,aAAA;AAgBF;;AAdA;EACE,cAAA;EACA,UAAA;AAiBF;;AAfA;EACE,yBAAA;EACA,UAAA;AAkBF;;AAhBA;EACE,yBAAA;EACA,oCAAA;EACA,gCAAA;EACA,UAAA;AAmBF;;AAjBA;EACE,sBAAA;EACA,uBAAA;EACA,uBAAA;EACA,yBAAA;EACA,oCAAA;EACA,oBAAA;EACA,qBAAA;EACA,mBAAA;EACA,eAAA;EACA,4BAAA;EACA,gBAAA;EACA,qIAAA;AAoBF;;AAlBA;EACE;IACE,gBAAA;EAqBF;AACF;AAnBA;EACE,qDAAA;AAqBF;;AAlBA;EACE,cAAA;EACA,WAAA;EACA,mBAAA;EACA,gBAAA;EACA,gBAAA;EACA,yBAAA;EACA,6BAAA;EACA,yBAAA;EACA,mBAAA;AAqBF;;AAnBA;EACE,UAAA;AAsBF;;AApBA;EACE,gBAAA;EACA,eAAA;AAuBF;;AApBA;EACE,sCAAA;EACA,wBAAA;EACA,kBAAA;EACA,uBAAA;AAuBF;;AArBA;EACE,wBAAA;EACA,yBAAA;EACA,0BAAA;AAwBF;;AArBA;EACE,uCAAA;EACA,wBAAA;EACA,kBAAA;EACA,uBAAA;AAwBF;;AAtBA;EACE,wBAAA;EACA,yBAAA;EACA,yBAAA;AAyBF;;AAtBA;EACE,uCAAA;AAyBF;;AAvBA;EACE,sCAAA;AA0BF;;AAxBA;EACE,uCAAA;AA2BF;;AAxBA;EACE,WAAA;EACA,mCAAA;EACA,iBAAA;AA2BF;;AAzBA;EACE,eAAA;AA4BF;;AA1BA;EACE,oBAAA;EACA,uBAAA;AA6BF;;AA3BA;EACE,uBAAA;AA8BF;;AA5BA;EACE,kCAAA;AA+BF;;AA7BA;EACE,mCAAA;AAgCF;;AA7BA;EACE,gEAAA;EACA,cAAA;EACA,WAAA;EACA,oCAAA;EACA,oCAAA;EACA,iBAAA;EACA,gBAAA;EACA,gBAAA;EACA,yBAAA;EACA,mCAAA;EACA,mFAAA;EACA,4BAAA;EACA,sCAAA;EACA,0BAAA;EACA,oCAAA;EACA,uBAAA;EACA,iBAAA;EACA,wEAAA;EACA,gBAAA;AAgCF;;AA9BA;EACE;IACE,gBAAA;EAiCF;AACF;AA/BA;EACE,gCAAA;EACA,UAAA;EACA,0EAAA;AAiCF;;AA/BA;EACE,mBAAA;EACA,sBAAA;AAkCF;;AAhCA;EACE,yBAAA;EACA,oCAAA;EACA,gCAAA;AAmCF;;AAjCA;EACE,kBAAA;EACA,qCAAA;AAoCF;;AAjCA;EACE,oBAAA;EACA,uBAAA;EACA,qBAAA;EACA,kBAAA;EACA,uBAAA;AAoCF;;AAjCA;EACE,qBAAA;EACA,wBAAA;EACA,oBAAA;EACA,kBAAA;EACA,uBAAA;AAoCF;;AAjCA;EACE,gEAAA;AAoCF;;AAjCA;EACE,cAAA;EACA,kBAAA;EACA,qBAAA;EACA,uBAAA;AAoCF;;AAlCA;EACE,WAAA;EACA,qBAAA;AAqCF;;AAlCA;EACE,sBAAA;EACA,eAAA;EACA,iBAAA;AAqCF;;AAnCA;EACE,YAAA;EACA,sBAAA;EACA,cAAA;AAsCF;;AAnCA;EACE,+BAAA;EACA,cAAA;EACA,eAAA;EACA,qBAAA;EACA,mBAAA;EACA,yCAAA;EACA,+CAAA;EACA,4BAAA;EACA,2BAAA;EACA,wBAAA;EACA,oCAAA;EACA,gBAAA;EACA,iCAAA;UAAA,yBAAA;AAsCF;;AApCA;EACE,qBAAA;AAuCF;;AArCA;EACE,kBAAA;AAwCF;;AAtCA;EACE,uBAAA;AAyCF;;AAvCA;EACE,gCAAA;EACA,UAAA;EACA,gBAAA;AA0CF;;AAxCA;EACE,yBAAA;EACA,qBAAA;AA2CF;;AAzCA;EACE,iEAAA;AA4CF;;AA1CA;EACE,iEAAA;AA6CF;;AA3CA;EACE,yBAAA;EACA,qBAAA;EACA,iEAAA;AA8CF;;AA5CA;EACE,oBAAA;EACA,YAAA;EACA,YAAA;AA+CF;;AA7CA;EACE,eAAA;EACA,YAAA;AAgDF;;AA7CA;EACE,yBAAA;AAgDF;;AA7CA;EACE,qBAAA;AAgDF;;AA9CA;EACE,4DAAA;EACA,cAAA;EACA,qBAAA;EACA,0CAAA;EACA,gCAAA;EACA,sBAAA;EACA,iDAAA;AAiDF;;AA/CA;EACE;IACE,gBAAA;EAkDF;AACF;AAhDA;EACE,4DAAA;AAkDF;;AAhDA;EACE,iCAAA;EACA,4DAAA;AAmDF;;AAjDA;EACE,sBAAA;EACA,eAAA;AAoDF;;AAlDA;EACE,sBAAA;EACA,cAAA;AAqDF;;AAlDA;EACE,qBAAA;EACA,kBAAA;AAqDF;;AAlDA;EACE,kBAAA;EACA,sBAAA;EACA,oBAAA;AAqDF;;AAnDA;EACE,oBAAA;EACA,YAAA;EACA,aAAA;AAsDF;;AAnDA;EACE,4DAAA;AAsDF;;AAnDA;EACE,WAAA;EACA,cAAA;EACA,UAAA;EACA,6BAAA;EACA,gBAAA;AAsDF;;AApDA;EACE,UAAA;AAuDF;;AArDA;EACE,sFAAA;AAwDF;;AAtDA;EACE,sFAAA;AAyDF;;AAvDA;EACE,SAAA;AA0DF;;AAxDA;EACE,WAAA;EACA,YAAA;EACA,oBAAA;EACA,yBAAA;EACA,SAAA;EACA,mBAAA;EACA,+CAAA;EACA,oHAAA;EAAA,4GAAA;EACA,gBAAA;AA2DF;;AAzDA;EACE;IACE,wBAAA;IAAA,gBAAA;EA4DF;AACF;AA1DA;EACE,yBAAA;AA4DF;;AA1DA;EACE,WAAA;EACA,cAAA;EACA,kBAAA;EACA,eAAA;EACA,oCAAA;EACA,yBAAA;EACA,uBAAA;EACA,gDAAA;AA6DF;;AA3DA;EACE,WAAA;EACA,YAAA;EACA,yBAAA;EACA,SAAA;EACA,mBAAA;EACA,+CAAA;EACA,iHAAA;EAAA,4GAAA;EACA,gBAAA;AA8DF;;AA5DA;EACE;IACE,qBAAA;IAAA,gBAAA;EA+DF;AACF;AA7DA;EACE,yBAAA;AA+DF;;AA7DA;EACE,WAAA;EACA,cAAA;EACA,kBAAA;EACA,eAAA;EACA,oCAAA;EACA,yBAAA;EACA,uBAAA;EACA,gDAAA;AAgEF;;AA9DA;EACE,oBAAA;AAiEF;;AA/DA;EACE,oCAAA;AAkEF;;AAhEA;EACE,oCAAA;AAmEF;;AAhEA;EACE,kBAAA;AAmEF;;AAjEA;EACE,kBAAA;EACA,QAAA;EACA,SAAA;EACA,6DAAA;EACA,eAAA;EACA,WAAA;EACA,mCAAA;EACA,uBAAA;AAoEF;;AAlEA;;;EAGE,2BAAA;EACA,iBAAA;AAqEF;;AAnEA;EACE,kBAAA;EACA,MAAA;EACA,OAAA;EACA,WAAA;EACA,YAAA;EACA,kBAAA;EACA,gBAAA;EACA,iBAAA;EACA,uBAAA;EACA,mBAAA;EACA,oBAAA;EACA,6BAAA;EACA,qBAAA;EACA,gEAAA;AAsEF;;AApEA;EACE;IACE,gBAAA;EAuEF;AACF;AArEA;;EAEE,kBAAA;AAuEF;;AArEA;;EAEE,kBAAA;AAwEF;;AAtEA;;;EAGE,oBAAA;EACA,wBAAA;AAyEF;;AAvEA;;EAEE,oBAAA;EACA,wBAAA;AA0EF;;AAxEA;EACE,oBAAA;EACA,wBAAA;AA2EF;;AAzEA;;;;EAIE,aAAA;EACA,8DAAA;AA4EF;;AA1EA;EACE,aAAA;EACA,8DAAA;AA6EF;;AA3EA;EACE,mBAAA;AA8EF;;AA5EA;EACE,cAAA;AA+EF;;AA5EA;EACE,kBAAA;EACA,aAAA;EACA,eAAA;EACA,oBAAA;EACA,WAAA;AA+EF;;AA7EA;;;EAGE,kBAAA;EACA,cAAA;EACA,SAAA;EACA,YAAA;AAgFF;;AA9EA;;;EAGE,UAAA;AAiFF;;AA/EA;EACE,kBAAA;EACA,UAAA;AAkFF;;AAhFA;EACE,UAAA;AAmFF;;AAhFA;EACE,aAAA;EACA,mBAAA;EACA,sBAAA;EACA,iBAAA;EACA,gBAAA;EACA,gBAAA;EACA,yBAAA;EACA,kBAAA;EACA,mBAAA;EACA,oCAAA;EACA,oCAAA;EACA,uBAAA;AAmFF;;AAhFA;;;;EAIE,wBAAA;EACA,kBAAA;EACA,uBAAA;AAmFF;;AAhFA;;;;EAIE,wBAAA;EACA,kBAAA;EACA,uBAAA;AAmFF;;AAhFA;;EAEE,mBAAA;AAmFF;;AAhFA;;;;EAIE,0BAAA;EACA,6BAAA;AAmFF;;AAjFA;;;;EAIE,0BAAA;EACA,6BAAA;AAoFF;;AAlFA;EACE,iBAAA;EACA,yBAAA;EACA,4BAAA;AAqFF;;AAnFA;;EAEE,yBAAA;EACA,4BAAA;AAsFF;;AAnFA;EACE,aAAA;EACA,WAAA;EACA,kBAAA;EACA,kBAAA;EACA,6BAAA;AAsFF;;AAnFA;EACE,kBAAA;EACA,SAAA;EACA,UAAA;EACA,aAAA;EACA,eAAA;EACA,qBAAA;EACA,kBAAA;EACA,eAAA;EACA,WAAA;EACA,mCAAA;EACA,uBAAA;AAsFF;;AAnFA;;;;EAIE,cAAA;AAsFF;;AAnFA;EACE,+BAAA;EACA,oCAAA;EACA,yDAAA;EACA,4BAAA;EACA,2DAAA;EACA,gEAAA;AAsFF;;AApFA;EACE,+BAAA;EACA,2DAAA;AAuFF;;AApFA;EACE,oCAAA;EACA,kFAAA;AAuFF;;AApFA;EACE,+BAAA;AAuFF;;AArFA;EACE,iEAAA;EACA,qBAAA;EACA,yDAAA;EACA,2EAAA;AAwFF;;AAtFA;EACE,+BAAA;EACA,2DAAA;AAyFF;;AAtFA;EACE,mCAAA;AAyFF;;AAtFA;EACE,+BAAA;AAyFF;;AAvFA;EACE,wCAAA;AA0FF;;AAxFA;EACE,2DAAA;AA2FF;;AAzFA;EACE,6BAAA;AA4FF;;AAzFA;EACE,kBAAA;AA4FF;;AAzFA;;;;;EAKE,UAAA;AA4FF;;AAzFA;EACE,aAAA;EACA,WAAA;EACA,kBAAA;EACA,kBAAA;EACA,4BAAA;AA4FF;;AAzFA;EACE,kBAAA;EACA,SAAA;EACA,UAAA;EACA,aAAA;EACA,eAAA;EACA,qBAAA;EACA,kBAAA;EACA,eAAA;EACA,WAAA;EACA,kCAAA;EACA,uBAAA;AA4FF;;AAzFA;;;;EAIE,cAAA;AA4FF;;AAzFA;EACE,8BAAA;EACA,oCAAA;EACA,yDAAA;EACA,4BAAA;EACA,2DAAA;EACA,gEAAA;AA4FF;;AA1FA;EACE,8BAAA;EACA,0DAAA;AA6FF;;AA1FA;EACE,oCAAA;EACA,kFAAA;AA6FF;;AA1FA;EACE,8BAAA;AA6FF;;AA3FA;EACE,iEAAA;EACA,qBAAA;EACA,yDAAA;EACA,2EAAA;AA8FF;;AA5FA;EACE,8BAAA;EACA,0DAAA;AA+FF;;AA5FA;EACE,mCAAA;AA+FF;;AA5FA;EACE,8BAAA;AA+FF;;AA7FA;EACE,uCAAA;AAgGF;;AA9FA;EACE,0DAAA;AAiGF;;AA/FA;EACE,4BAAA;AAkGF;;AA/FA;EACE,kBAAA;AAkGF;;AA/FA;;;;;EAKE,UAAA;AAkGF;;AA/FA;EACE,0BAAA;EACA,4BAAA;EACA,sBAAA;EACA,0BAAA;EACA,yBAAA;EACA,yBAAA;EACA,uBAAA;EACA,wBAAA;EACA,0BAAA;EACA,kCAAA;EACA,gCAAA;EACA,wCAAA;EACA,4FAAA;EACA,+BAAA;EACA,iFAAA;EACA,qBAAA;EACA,wDAAA;EACA,sCAAA;EACA,kCAAA;EACA,sCAAA;EACA,sCAAA;EACA,0BAAA;EACA,kBAAA;EACA,sBAAA;EACA,eAAA;EACA,yBAAA;UAAA,iBAAA;EACA,mEAAA;EACA,0CAAA;EACA,kCAAA;EACA,oCAAA;EACA,qIAAA;AAkGF;;AAhGA;EACE;IACE,gBAAA;EAmGF;AACF;AAjGA;EACE,gCAAA;EACA,wCAAA;EACA,8CAAA;AAmGF;;AAjGA;EACE,0BAAA;EACA,kCAAA;EACA,wCAAA;AAoGF;;AAlGA;EACE,gCAAA;EACA,wCAAA;EACA,8CAAA;EACA,UAAA;EACA,oEAAA;AAqGF;;AAnGA;EACE,8CAAA;EACA,UAAA;EACA,oEAAA;AAsGF;;AApGA;EACE,iCAAA;EACA,yCAAA;EACA,+CAAA;EACA,uCAAA;AAuGF;;AArGA;EACE,uEAAA;AAwGF;;AAtGA;EACE,mCAAA;EACA,oBAAA;EACA,2CAAA;EACA,iDAAA;EACA,uCAAA;EACA,gBAAA;AAyGF;;AAtGA;EACE,uBAAA;EACA,oBAAA;EACA,8BAAA;EACA,6BAAA;EACA,0BAAA;EACA,oCAAA;EACA,wCAAA;EACA,8BAAA;EACA,2BAAA;EACA,qCAAA;EACA,4DAAA;EACA,gCAAA;EACA,6BAAA;EACA,uCAAA;AAyGF;;AAtGA;EACE,uBAAA;EACA,oBAAA;EACA,8BAAA;EACA,6BAAA;EACA,0BAAA;EACA,oCAAA;EACA,sCAAA;EACA,8BAAA;EACA,2BAAA;EACA,qCAAA;EACA,4DAAA;EACA,gCAAA;EACA,6BAAA;EACA,uCAAA;AAyGF;;AAtGA;EACE,uBAAA;EACA,oBAAA;EACA,8BAAA;EACA,6BAAA;EACA,0BAAA;EACA,oCAAA;EACA,wCAAA;EACA,8BAAA;EACA,2BAAA;EACA,qCAAA;EACA,4DAAA;EACA,gCAAA;EACA,6BAAA;EACA,uCAAA;AAyGF;;AAtGA;EACE,uBAAA;EACA,oBAAA;EACA,8BAAA;EACA,6BAAA;EACA,0BAAA;EACA,oCAAA;EACA,uCAAA;EACA,8BAAA;EACA,2BAAA;EACA,qCAAA;EACA,4DAAA;EACA,gCAAA;EACA,6BAAA;EACA,uCAAA;AAyGF;;AAtGA;EACE,uBAAA;EACA,oBAAA;EACA,8BAAA;EACA,6BAAA;EACA,0BAAA;EACA,oCAAA;EACA,uCAAA;EACA,8BAAA;EACA,2BAAA;EACA,qCAAA;EACA,4DAAA;EACA,gCAAA;EACA,6BAAA;EACA,uCAAA;AAyGF;;AAtGA;EACE,uBAAA;EACA,oBAAA;EACA,8BAAA;EACA,6BAAA;EACA,0BAAA;EACA,oCAAA;EACA,sCAAA;EACA,8BAAA;EACA,2BAAA;EACA,qCAAA;EACA,4DAAA;EACA,gCAAA;EACA,6BAAA;EACA,uCAAA;AAyGF;;AAtGA;EACE,uBAAA;EACA,oBAAA;EACA,8BAAA;EACA,6BAAA;EACA,0BAAA;EACA,oCAAA;EACA,sCAAA;EACA,8BAAA;EACA,2BAAA;EACA,qCAAA;EACA,4DAAA;EACA,gCAAA;EACA,6BAAA;EACA,uCAAA;AAyGF;;AAtGA;EACE,uBAAA;EACA,oBAAA;EACA,8BAAA;EACA,6BAAA;EACA,0BAAA;EACA,oCAAA;EACA,qCAAA;EACA,8BAAA;EACA,2BAAA;EACA,qCAAA;EACA,4DAAA;EACA,gCAAA;EACA,6BAAA;EACA,uCAAA;AAyGF;;AAtGA;EACE,uBAAA;EACA,8BAAA;EACA,6BAAA;EACA,0BAAA;EACA,oCAAA;EACA,wCAAA;EACA,8BAAA;EACA,2BAAA;EACA,qCAAA;EACA,4DAAA;EACA,gCAAA;EACA,iCAAA;EACA,uCAAA;EACA,mBAAA;AAyGF;;AAtGA;EACE,uBAAA;EACA,8BAAA;EACA,6BAAA;EACA,0BAAA;EACA,oCAAA;EACA,sCAAA;EACA,8BAAA;EACA,2BAAA;EACA,qCAAA;EACA,4DAAA;EACA,gCAAA;EACA,iCAAA;EACA,uCAAA;EACA,mBAAA;AAyGF;;AAtGA;EACE,uBAAA;EACA,8BAAA;EACA,6BAAA;EACA,0BAAA;EACA,oCAAA;EACA,wCAAA;EACA,8BAAA;EACA,2BAAA;EACA,qCAAA;EACA,4DAAA;EACA,gCAAA;EACA,iCAAA;EACA,uCAAA;EACA,mBAAA;AAyGF;;AAtGA;EACE,uBAAA;EACA,8BAAA;EACA,6BAAA;EACA,0BAAA;EACA,oCAAA;EACA,uCAAA;EACA,8BAAA;EACA,2BAAA;EACA,qCAAA;EACA,4DAAA;EACA,gCAAA;EACA,iCAAA;EACA,uCAAA;EACA,mBAAA;AAyGF;;AAtGA;EACE,uBAAA;EACA,8BAAA;EACA,6BAAA;EACA,0BAAA;EACA,oCAAA;EACA,uCAAA;EACA,8BAAA;EACA,2BAAA;EACA,qCAAA;EACA,4DAAA;EACA,gCAAA;EACA,iCAAA;EACA,uCAAA;EACA,mBAAA;AAyGF;;AAtGA;EACE,uBAAA;EACA,8BAAA;EACA,6BAAA;EACA,0BAAA;EACA,oCAAA;EACA,sCAAA;EACA,8BAAA;EACA,2BAAA;EACA,qCAAA;EACA,4DAAA;EACA,gCAAA;EACA,iCAAA;EACA,uCAAA;EACA,mBAAA;AAyGF;;AAtGA;EACE,uBAAA;EACA,8BAAA;EACA,6BAAA;EACA,0BAAA;EACA,oCAAA;EACA,uCAAA;EACA,8BAAA;EACA,2BAAA;EACA,qCAAA;EACA,4DAAA;EACA,gCAAA;EACA,iCAAA;EACA,uCAAA;EACA,mBAAA;AAyGF;;AAtGA;EACE,uBAAA;EACA,8BAAA;EACA,6BAAA;EACA,0BAAA;EACA,oCAAA;EACA,qCAAA;EACA,8BAAA;EACA,2BAAA;EACA,qCAAA;EACA,4DAAA;EACA,gCAAA;EACA,iCAAA;EACA,uCAAA;EACA,mBAAA;AAyGF;;AAtGA;EACE,yBAAA;EACA,oCAAA;EACA,wBAAA;EACA,kCAAA;EACA,gDAAA;EACA,wCAAA;EACA,iDAAA;EACA,yCAAA;EACA,2CAAA;EACA,2CAAA;EACA,yBAAA;EACA,sCAAA;EACA,qBAAA;AAyGF;;AAvGA;EACE,qBAAA;AA0GF;;AAxGA;EACE,0BAAA;AA2GF;;AAzGA;EACE,gCAAA;AA4GF;;AAzGA;EACE,4BAAA;EACA,2BAAA;EACA,2BAAA;EACA,gCAAA;AA4GF;;AAzGA;EACE,2BAAA;EACA,2BAAA;EACA,2BAAA;EACA,gCAAA;AA4GF;;AAzGA;EACE,gCAAA;AA4GF;;AA1GA;EACE;IACE,gBAAA;EA6GF;AACF;AA3GA;EACE,UAAA;AA6GF;;AA1GA;EACE,aAAA;AA6GF;;AA1GA;EACE,SAAA;EACA,gBAAA;EACA,6BAAA;AA6GF;;AA3GA;EACE;IACE,gBAAA;EA8GF;AACF;AA5GA;EACE,QAAA;EACA,YAAA;EACA,4BAAA;AA8GF;;AA5GA;EACE;IACE,gBAAA;EA+GF;AACF;AA5GA;;;;;;EAME,kBAAA;AA8GF;;AA3GA;EACE,mBAAA;AA8GF;;AA5GA;EACE,qBAAA;EACA,oBAAA;EACA,uBAAA;EACA,WAAA;EACA,uBAAA;EACA,qCAAA;EACA,gBAAA;EACA,oCAAA;AA+GF;;AA7GA;EACE,cAAA;AAgHF;;AA7GA;EACE,0BAAA;EACA,8BAAA;EACA,0BAAA;EACA,+BAAA;EACA,8BAAA;EACA,6BAAA;EACA,yCAAA;EACA,mCAAA;EACA,8DAAA;EACA,qCAAA;EACA,gCAAA;EACA,2CAAA;EACA,4CAAA;EACA,sCAAA;EACA,kEAAA;EACA,4CAAA;EACA,kDAAA;EACA,kDAAA;EACA,gEAAA;EACA,0DAAA;EACA,qDAAA;EACA,qCAAA;EACA,qCAAA;EACA,8CAAA;EACA,uCAAA;EACA,sCAAA;EACA,kBAAA;EACA,kCAAA;EACA,aAAA;EACA,uCAAA;EACA,kEAAA;EACA,SAAA;EACA,uCAAA;EACA,+BAAA;EACA,gBAAA;EACA,gBAAA;EACA,uCAAA;EACA,4BAAA;EACA,6EAAA;EACA,+CAAA;EACA,yCAAA;AAgHF;;AA9GA;EACE,SAAA;EACA,OAAA;EACA,qCAAA;AAiHF;;AA9GA;EACE,oBAAA;AAiHF;;AA/GA;EACE,WAAA;EACA,OAAA;AAkHF;;AA/GA;EACE,kBAAA;AAkHF;;AAhHA;EACE,QAAA;EACA,UAAA;AAmHF;;AAhHA;EACE;IACE,oBAAA;EAmHF;EAjHA;IACE,WAAA;IACA,OAAA;EAmHF;EAjHA;IACE,kBAAA;EAmHF;EAjHA;IACE,QAAA;IACA,UAAA;EAmHF;AACF;AAjHA;EACE;IACE,oBAAA;EAmHF;EAjHA;IACE,WAAA;IACA,OAAA;EAmHF;EAjHA;IACE,kBAAA;EAmHF;EAjHA;IACE,QAAA;IACA,UAAA;EAmHF;AACF;AAjHA;EACE;IACE,oBAAA;EAmHF;EAjHA;IACE,WAAA;IACA,OAAA;EAmHF;EAjHA;IACE,kBAAA;EAmHF;EAjHA;IACE,QAAA;IACA,UAAA;EAmHF;AACF;AAjHA;EACE;IACE,oBAAA;EAmHF;EAjHA;IACE,WAAA;IACA,OAAA;EAmHF;EAjHA;IACE,kBAAA;EAmHF;EAjHA;IACE,QAAA;IACA,UAAA;EAmHF;AACF;AAjHA;EACE;IACE,oBAAA;EAmHF;EAjHA;IACE,WAAA;IACA,OAAA;EAmHF;EAjHA;IACE,kBAAA;EAmHF;EAjHA;IACE,QAAA;IACA,UAAA;EAmHF;AACF;AAjHA;EACE,SAAA;EACA,YAAA;EACA,aAAA;EACA,wCAAA;AAmHF;;AAjHA;EACE,qBAAA;EACA,oBAAA;EACA,uBAAA;EACA,WAAA;EACA,aAAA;EACA,qCAAA;EACA,0BAAA;EACA,oCAAA;AAoHF;;AAlHA;EACE,cAAA;AAqHF;;AAlHA;EACE,MAAA;EACA,WAAA;EACA,UAAA;EACA,aAAA;EACA,sCAAA;AAqHF;;AAnHA;EACE,qBAAA;EACA,oBAAA;EACA,uBAAA;EACA,WAAA;EACA,mCAAA;EACA,eAAA;EACA,sCAAA;EACA,wBAAA;AAsHF;;AApHA;EACE,cAAA;AAuHF;;AArHA;EACE,iBAAA;AAwHF;;AArHA;EACE,MAAA;EACA,WAAA;EACA,UAAA;EACA,aAAA;EACA,uCAAA;AAwHF;;AAtHA;EACE,qBAAA;EACA,oBAAA;EACA,uBAAA;EACA,WAAA;EAGA,aAAA;AAsHF;;AApHA;EACE,qBAAA;EACA,qBAAA;EACA,uBAAA;EACA,WAAA;EACA,mCAAA;EACA,yBAAA;EACA,sCAAA;AA2HF;;AAzHA;EACE,cAAA;AA4HF;;AA1HA;EACE,iBAAA;AA6HF;;AA1HA;EACE,SAAA;EACA,6CAAA;EACA,gBAAA;EACA,mDAAA;EACA,UAAA;AA6HF;;AA1HA;EACE,cAAA;EACA,WAAA;EACA,4EAAA;EACA,WAAA;EACA,gBAAA;EACA,oCAAA;EACA,mBAAA;EACA,mBAAA;EACA,6BAAA;EACA,SAAA;EACA,uDAAA;AA6HF;;AA3HA;EACE,0CAAA;EACA,kDAAA;AA8HF;;AA5HA;EACE,2CAAA;EACA,qBAAA;EACA,mDAAA;AA+HF;;AA7HA;EACE,6CAAA;EACA,oBAAA;EACA,6BAAA;AAgIF;;AA7HA;EACE,cAAA;AAgIF;;AA7HA;EACE,cAAA;EACA,gFAAA;EACA,gBAAA;EACA,kBAAA;EACA,sCAAA;EACA,mBAAA;AAgIF;;AA7HA;EACE,cAAA;EACA,4EAAA;EACA,oCAAA;AAgIF;;AA7HA;EACE,4BAAA;EACA,yBAAA;EACA,8DAAA;EACA,0BAAA;EACA,iCAAA;EACA,uCAAA;EACA,4CAAA;EACA,sDAAA;EACA,gEAAA;EACA,0DAAA;EACA,0CAAA;EACA,mCAAA;AAgIF;;AA7HA;;EAEE,kBAAA;EACA,oBAAA;EACA,sBAAA;AAgIF;;AA9HA;;EAEE,kBAAA;EACA,cAAA;AAiIF;;AA/HA;;;;;;;;;;;;EAYE,UAAA;AAkIF;;AA/HA;EACE,aAAA;EACA,eAAA;EACA,2BAAA;AAkIF;;AAhIA;EACE,WAAA;AAmIF;;AAhIA;EACE,uBAAA;AAmIF;;AAjIA;;EAEE,iBAAA;AAoIF;;AAlIA;;;EAGE,0BAAA;EACA,6BAAA;AAqIF;;AAnIA;;;EAGE,yBAAA;EACA,4BAAA;AAsIF;;AAnIA;EACE,uBAAA;EACA,sBAAA;AAsIF;;AApIA;EACE,cAAA;AAuIF;;AArIA;EACE,eAAA;AAwIF;;AArIA;EACE,wBAAA;EACA,uBAAA;AAwIF;;AArIA;EACE,wBAAA;EACA,uBAAA;AAwIF;;AArIA;EACE,gDAAA;AAwIF;;AAtIA;EACE,gBAAA;AAyIF;;AAtIA;EACE,sBAAA;EACA,uBAAA;EACA,uBAAA;AAyIF;;AAvIA;;EAEE,WAAA;AA0IF;;AAxIA;;EAEE,gBAAA;AA2IF;;AAzIA;;EAEE,6BAAA;EACA,4BAAA;AA4IF;;AA1IA;;EAEE,yBAAA;EACA,0BAAA;AA6IF;;AA1IA;EACE,6BAAA;EACA,+BAAA;EACA,2BAAA;EACA,yCAAA;EACA,qDAAA;EACA,uDAAA;EACA,aAAA;EACA,eAAA;EACA,eAAA;EACA,gBAAA;EACA,gBAAA;AA6IF;;AA1IA;EACE,cAAA;EACA,kEAAA;EACA,uCAAA;EACA,2CAAA;EACA,+BAAA;EACA,mCAAA;AA6IF;;AA3IA;EACE;IACE,gBAAA;EA8IF;AACF;AA5IA;EACE,qCAAA;AA8IF;;AA5IA;EACE,wCAAA;EACA,oBAAA;EACA,eAAA;AA+IF;;AA5IA;EACE,kDAAA;EACA,kDAAA;EACA,oDAAA;EACA,2GAAA;EACA,yDAAA;EACA,+CAAA;EACA,uGAAA;EACA,oFAAA;AA+IF;;AA7IA;EACE,yDAAA;EACA,gBAAA;EACA,yDAAA;EACA,wDAAA;EACA,yDAAA;AAgJF;;AA9IA;EACE,kBAAA;EACA,wDAAA;AAiJF;;AA/IA;EACE,wCAAA;EACA,6BAAA;EACA,yBAAA;AAkJF;;AAhJA;;EAEE,2CAAA;EACA,mDAAA;EACA,yDAAA;AAmJF;;AAjJA;EACE,sDAAA;EACA,yBAAA;EACA,0BAAA;AAoJF;;AAjJA;EACE,sCAAA;EACA,yCAAA;EACA,sCAAA;AAoJF;;AAlJA;EACE,gBAAA;EACA,SAAA;EACA,gDAAA;AAqJF;;AAnJA;EACE,wCAAA;EACA,6BAAA;EACA,yBAAA;AAsJF;;AApJA;;EAEE,4CAAA;EACA,oDAAA;AAuJF;;AApJA;;EAEE,cAAA;EACA,kBAAA;AAuJF;;AApJA;;EAEE,aAAA;EACA,YAAA;EACA,kBAAA;AAuJF;;AApJA;;EAEE,WAAA;AAuJF;;AApJA;EACE,aAAA;AAuJF;;AArJA;EACE,cAAA;AAwJF;;AArJA;EACE,wBAAA;EACA,6BAAA;EACA,2DAAA;EACA,gEAAA;EACA,mEAAA;EACA,+DAAA;EACA,uCAAA;EACA,kCAAA;EACA,qCAAA;EACA,8DAAA;EACA,oEAAA;EACA,sCAAA;EACA,sCAAA;EACA,sCAAA;EACA,uCAAA;EACA,qEAAA;EACA,0EAAA;EACA,2CAAA;EACA,wCAAA;EACA,4DAAA;EACA,kBAAA;EACA,aAAA;EACA,eAAA;EACA,mBAAA;EACA,8BAAA;EACA,8DAAA;AAwJF;;AAtJA;;;;;;;EAOE,aAAA;EACA,kBAAA;EACA,mBAAA;EACA,8BAAA;AAyJF;;AAvJA;EACE,6CAAA;EACA,gDAAA;EACA,+CAAA;EACA,2CAAA;EACA,mCAAA;EACA,mBAAA;AA0JF;;AAxJA;EACE,yCAAA;AA2JF;;AAxJA;EACE,0BAAA;EACA,+BAAA;EACA,2BAAA;EACA,2CAAA;EACA,uDAAA;EACA,6DAAA;EACA,aAAA;EACA,sBAAA;EACA,eAAA;EACA,gBAAA;EACA,gBAAA;AA2JF;;AAzJA;;EAEE,oCAAA;AA4JF;;AA1JA;EACE,gBAAA;AA6JF;;AA1JA;EACE,mBAAA;EACA,sBAAA;EACA,6BAAA;AA6JF;;AA3JA;;;EAGE,oCAAA;AA8JF;;AA3JA;EACE,gBAAA;EACA,YAAA;EACA,mBAAA;AA8JF;;AA3JA;EACE,8EAAA;EACA,6CAAA;EACA,cAAA;EACA,6BAAA;EACA,6BAAA;EACA,0EAAA;EACA,qDAAA;EACA,+CAAA;AA8JF;;AA5JA;EACE;IACE,gBAAA;EA+JF;AACF;AA7JA;EACE,qBAAA;AA+JF;;AA7JA;EACE,qBAAA;EACA,UAAA;EACA,sDAAA;AAgKF;;AA7JA;EACE,qBAAA;EACA,YAAA;EACA,aAAA;EACA,sBAAA;EACA,kDAAA;EACA,4BAAA;EACA,2BAAA;EACA,qBAAA;AAgKF;;AA7JA;EACE,yCAAA;EACA,gBAAA;AAgKF;;AA7JA;EACE;IACE,iBAAA;IACA,2BAAA;EAgKF;EA9JA;IACE,mBAAA;EAgKF;EA9JA;IACE,kBAAA;EAgKF;EA9JA;IACE,kDAAA;IACA,iDAAA;EAgKF;EA9JA;IACE,iBAAA;EAgKF;EA9JA;IACE,wBAAA;IACA,gBAAA;EAgKF;EA9JA;IACE,aAAA;EAgKF;EA9JA;IACE,gBAAA;IACA,aAAA;IACA,YAAA;IACA,sBAAA;IACA,uBAAA;IACA,8BAAA;IACA,wCAAA;IACA,oBAAA;IACA,0BAAA;IACA,gBAAA;IACA,gBAAA;EAgKF;EA9JA;IACE,aAAA;EAgKF;EA9JA;IACE,aAAA;IACA,YAAA;IACA,UAAA;IACA,mBAAA;EAgKF;AACF;AA9JA;EACE;IACE,iBAAA;IACA,2BAAA;EAgKF;EA9JA;IACE,mBAAA;EAgKF;EA9JA;IACE,kBAAA;EAgKF;EA9JA;IACE,kDAAA;IACA,iDAAA;EAgKF;EA9JA;IACE,iBAAA;EAgKF;EA9JA;IACE,wBAAA;IACA,gBAAA;EAgKF;EA9JA;IACE,aAAA;EAgKF;EA9JA;IACE,gBAAA;IACA,aAAA;IACA,YAAA;IACA,sBAAA;IACA,uBAAA;IACA,8BAAA;IACA,wCAAA;IACA,oBAAA;IACA,0BAAA;IACA,gBAAA;IACA,gBAAA;EAgKF;EA9JA;IACE,aAAA;EAgKF;EA9JA;IACE,aAAA;IACA,YAAA;IACA,UAAA;IACA,mBAAA;EAgKF;AACF;AA9JA;EACE;IACE,iBAAA;IACA,2BAAA;EAgKF;EA9JA;IACE,mBAAA;EAgKF;EA9JA;IACE,kBAAA;EAgKF;EA9JA;IACE,kDAAA;IACA,iDAAA;EAgKF;EA9JA;IACE,iBAAA;EAgKF;EA9JA;IACE,wBAAA;IACA,gBAAA;EAgKF;EA9JA;IACE,aAAA;EAgKF;EA9JA;IACE,gBAAA;IACA,aAAA;IACA,YAAA;IACA,sBAAA;IACA,uBAAA;IACA,8BAAA;IACA,wCAAA;IACA,oBAAA;IACA,0BAAA;IACA,gBAAA;IACA,gBAAA;EAgKF;EA9JA;IACE,aAAA;EAgKF;EA9JA;IACE,aAAA;IACA,YAAA;IACA,UAAA;IACA,mBAAA;EAgKF;AACF;AA9JA;EACE;IACE,iBAAA;IACA,2BAAA;EAgKF;EA9JA;IACE,mBAAA;EAgKF;EA9JA;IACE,kBAAA;EAgKF;EA9JA;IACE,kDAAA;IACA,iDAAA;EAgKF;EA9JA;IACE,iBAAA;EAgKF;EA9JA;IACE,wBAAA;IACA,gBAAA;EAgKF;EA9JA;IACE,aAAA;EAgKF;EA9JA;IACE,gBAAA;IACA,aAAA;IACA,YAAA;IACA,sBAAA;IACA,uBAAA;IACA,8BAAA;IACA,wCAAA;IACA,oBAAA;IACA,0BAAA;IACA,gBAAA;IACA,gBAAA;EAgKF;EA9JA;IACE,aAAA;EAgKF;EA9JA;IACE,aAAA;IACA,YAAA;IACA,UAAA;IACA,mBAAA;EAgKF;AACF;AA9JA;EACE;IACE,iBAAA;IACA,2BAAA;EAgKF;EA9JA;IACE,mBAAA;EAgKF;EA9JA;IACE,kBAAA;EAgKF;EA9JA;IACE,kDAAA;IACA,iDAAA;EAgKF;EA9JA;IACE,iBAAA;EAgKF;EA9JA;IACE,wBAAA;IACA,gBAAA;EAgKF;EA9JA;IACE,aAAA;EAgKF;EA9JA;IACE,gBAAA;IACA,aAAA;IACA,YAAA;IACA,sBAAA;IACA,uBAAA;IACA,8BAAA;IACA,wCAAA;IACA,oBAAA;IACA,0BAAA;IACA,gBAAA;IACA,gBAAA;EAgKF;EA9JA;IACE,aAAA;EAgKF;EA9JA;IACE,aAAA;IACA,YAAA;IACA,UAAA;IACA,mBAAA;EAgKF;AACF;AA9JA;EACE,iBAAA;EACA,2BAAA;AAgKF;;AA9JA;EACE,mBAAA;AAiKF;;AA/JA;EACE,kBAAA;AAkKF;;AAhKA;EACE,kDAAA;EACA,iDAAA;AAmKF;;AAjKA;EACE,iBAAA;AAoKF;;AAlKA;EACE,wBAAA;EACA,gBAAA;AAqKF;;AAnKA;EACE,aAAA;AAsKF;;AApKA;EACE,gBAAA;EACA,aAAA;EACA,YAAA;EACA,sBAAA;EACA,uBAAA;EACA,8BAAA;EACA,wCAAA;EACA,oBAAA;EACA,0BAAA;EACA,gBAAA;EACA,gBAAA;AAuKF;;AArKA;EACE,aAAA;AAwKF;;AAtKA;EACE,aAAA;EACA,YAAA;EACA,UAAA;EACA,mBAAA;AAyKF;;AAtKA;EACE,4CAAA;EACA,kDAAA;EACA,qDAAA;EACA,iCAAA;EACA,gCAAA;EACA,sCAAA;EACA,0DAAA;EACA,qEAAA;AAyKF;;AAtKA;EACE,qEAAA;AAyKF;;AAtKA;EACE,wBAAA;EACA,wBAAA;EACA,gCAAA;EACA,uBAAA;EACA,0BAAA;EACA,2BAAA;EACA,8CAAA;EACA,iCAAA;EACA,8DAAA;EACA,mDAAA;EACA,+BAAA;EACA,6BAAA;EACA,6BAAA;EACA,qBAAA;EACA,kBAAA;EACA,iBAAA;EACA,+BAAA;EACA,mCAAA;EACA,+BAAA;EACA,kBAAA;EACA,aAAA;EACA,sBAAA;EACA,YAAA;EACA,6BAAA;EACA,qBAAA;EACA,mCAAA;EACA,2BAAA;EACA,qEAAA;EACA,2CAAA;EACA,qCAAA;AAyKF;;AAvKA;EACE,eAAA;EACA,cAAA;AA0KF;;AAxKA;EACE,mBAAA;EACA,sBAAA;AA2KF;;AAzKA;EACE,mBAAA;EACA,0DAAA;EACA,2DAAA;AA4KF;;AA1KA;EACE,sBAAA;EACA,8DAAA;EACA,6DAAA;AA6KF;;AA3KA;;EAEE,aAAA;AA8KF;;AA3KA;EACE,cAAA;EACA,wDAAA;EACA,2BAAA;AA8KF;;AA3KA;EACE,4CAAA;EACA,iCAAA;AA8KF;;AA3KA;EACE,sDAAA;EACA,gBAAA;EACA,oCAAA;AA8KF;;AA3KA;EACE,gBAAA;AA8KF;;AA3KA;EACE,oCAAA;AA8KF;;AA3KA;EACE,kEAAA;EACA,gBAAA;EACA,+BAAA;EACA,uCAAA;EACA,4EAAA;AA8KF;;AA5KA;EACE,wFAAA;AA+KF;;AA5KA;EACE,kEAAA;EACA,+BAAA;EACA,uCAAA;EACA,yEAAA;AA+KF;;AA7KA;EACE,wFAAA;AAgLF;;AA7KA;EACE,uDAAA;EACA,sDAAA;EACA,sDAAA;EACA,gBAAA;AAgLF;;AA9KA;EACE,mCAAA;EACA,sCAAA;AAiLF;;AA9KA;EACE,uDAAA;EACA,sDAAA;AAiLF;;AA9KA;EACE,kBAAA;EACA,MAAA;EACA,QAAA;EACA,SAAA;EACA,OAAA;EACA,2CAAA;EACA,iDAAA;AAiLF;;AA9KA;;;EAGE,WAAA;AAiLF;;AA9KA;;EAEE,0DAAA;EACA,2DAAA;AAiLF;;AA9KA;;EAEE,8DAAA;EACA,6DAAA;AAiLF;;AA9KA;EACE,0CAAA;AAiLF;;AA/KA;EACE;IACE,aAAA;IACA,mBAAA;EAkLF;EAhLA;IACE,SAAA;IACA,gBAAA;EAkLF;EAhLA;IACE,cAAA;IACA,cAAA;EAkLF;EAhLA;IACE,0BAAA;IACA,6BAAA;EAkLF;EAhLA;;IAEE,0BAAA;EAkLF;EAhLA;;IAEE,6BAAA;EAkLF;EAhLA;IACE,yBAAA;IACA,4BAAA;EAkLF;EAhLA;;IAEE,yBAAA;EAkLF;EAhLA;;IAEE,4BAAA;EAkLF;AACF;AA/KA;EACE,0CAAA;EACA,oCAAA;EACA,8KAAA;EACA,mDAAA;EACA,mDAAA;EACA,sCAAA;EACA,6EAAA;EACA,oCAAA;EACA,oCAAA;EACA,8CAAA;EACA,wCAAA;EACA,iEAAA;EACA,sCAAA;EACA,kDAAA;EACA,8DAAA;EACA,wEAAA;EACA,6DAAA;EACA,yCAAA;EACA,qCAAA;EACA,qCAAA;EACA,8CAAA;EACA,4CAAA;AAiLF;;AA9KA;EACE,kBAAA;EACA,aAAA;EACA,mBAAA;EACA,WAAA;EACA,4EAAA;EACA,eAAA;EACA,oCAAA;EACA,gBAAA;EACA,4CAAA;EACA,SAAA;EACA,gBAAA;EACA,qBAAA;EACA,0CAAA;AAiLF;;AA/KA;EACE;IACE,gBAAA;EAkLF;AACF;AAhLA;EACE,uCAAA;EACA,+CAAA;EACA,kGAAA;AAkLF;;AAhLA;EACE,qDAAA;EACA,iDAAA;AAmLF;;AAjLA;EACE,cAAA;EACA,yCAAA;EACA,0CAAA;EACA,iBAAA;EACA,WAAA;EACA,8CAAA;EACA,4BAAA;EACA,mDAAA;EACA,mDAAA;AAoLF;;AAlLA;EACE;IACE,gBAAA;EAqLF;AACF;AAnLA;EACE,UAAA;AAqLF;;AAnLA;EACE,UAAA;EACA,wDAAA;EACA,UAAA;EACA,oDAAA;AAsLF;;AAnLA;EACE,gBAAA;AAsLF;;AAnLA;EACE,gCAAA;EACA,wCAAA;EACA,+EAAA;AAsLF;;AApLA;EACE,yDAAA;EACA,0DAAA;AAuLF;;AArLA;EACE,+DAAA;EACA,gEAAA;AAwLF;;AAtLA;EACE,aAAA;AAyLF;;AAvLA;EACE,6DAAA;EACA,4DAAA;AA0LF;;AAxLA;EACE,mEAAA;EACA,kEAAA;AA2LF;;AAzLA;EACE,6DAAA;EACA,4DAAA;AA4LF;;AAzLA;EACE,8EAAA;AA4LF;;AAzLA;EACE,eAAA;AA4LF;;AA1LA;EACE,eAAA;EACA,cAAA;EACA,gBAAA;AA6LF;;AA3LA;EACE,aAAA;AA8LF;;AA5LA;EACE,gBAAA;AA+LF;;AA7LA;EACE,gBAAA;AAgMF;;AA7LA;EACE,iEAAA;EACA,wEAAA;AAgMF;;AA7LA;EACE,4BAAA;EACA,4BAAA;EACA,mCAAA;EACA,oBAAA;EACA,+BAAA;EACA,iDAAA;EACA,sCAAA;EACA,oDAAA;EACA,aAAA;EACA,eAAA;EACA,sEAAA;EACA,iDAAA;EACA,yCAAA;EACA,gBAAA;EACA,yCAAA;EACA,iDAAA;AAgMF;;AA7LA;EACE,iDAAA;AAgMF;;AA9LA;EACE,WAAA;EACA,kDAAA;EACA,yCAAA;EACA,0CAAA;AAiMF;;AA/LA;EACE,6CAAA;AAkMF;;AA/LA;EACE,kCAAA;EACA,mCAAA;EACA,mCAAA;EACA,yCAAA;EACA,+BAAA;EACA,+BAAA;EACA,yCAAA;EACA,uCAAA;EACA,4DAAA;EACA,sDAAA;EACA,+CAAA;EACA,4DAAA;EACA,sDAAA;EACA,sCAAA;EACA,8DAAA;EACA,wDAAA;EACA,gDAAA;EACA,kDAAA;EACA,wCAAA;EACA,kDAAA;EACA,aAAA;EACA,eAAA;EACA,gBAAA;AAkMF;;AA/LA;EACE,kBAAA;EACA,cAAA;EACA,sEAAA;EACA,yCAAA;EACA,iCAAA;EACA,yCAAA;EACA,iFAAA;EACA,qIAAA;AAkMF;;AAhMA;EACE;IACE,gBAAA;EAmMF;AACF;AAjMA;EACE,UAAA;EACA,uCAAA;EACA,+CAAA;EACA,qDAAA;AAmMF;;AAjMA;EACE,UAAA;EACA,uCAAA;EACA,+CAAA;EACA,UAAA;EACA,iDAAA;AAoMF;;AAlMA;EACE,UAAA;EACA,wCAAA;EACA,gDAAA;EACA,sDAAA;AAqMF;;AAnMA;EACE,0CAAA;EACA,oBAAA;EACA,kDAAA;EACA,wDAAA;AAsMF;;AAnMA;EACE,cAAA;AAsMF;;AApMA;EACE,0DAAA;EACA,6DAAA;AAuMF;;AArMA;EACE,2DAAA;EACA,8DAAA;AAwMF;;AArMA;EACE,iCAAA;EACA,kCAAA;EACA,mCAAA;EACA,uCAAA;AAwMF;;AArMA;EACE,iCAAA;EACA,kCAAA;EACA,kCAAA;EACA,uCAAA;AAwMF;;AArMA;EACE,4BAAA;EACA,8BAAA;EACA,6BAAA;EACA,2BAAA;EACA,sCAAA;EACA,kCAAA;EACA,qBAAA;EACA,4DAAA;EACA,oCAAA;EACA,wCAAA;EACA,cAAA;EACA,4BAAA;EACA,kBAAA;EACA,mBAAA;EACA,wBAAA;EACA,4CAAA;AAwMF;;AAtMA;EACE,aAAA;AAyMF;;AAtMA;EACE,kBAAA;EACA,SAAA;AAyMF;;AAtMA;EACE,0BAAA;EACA,0BAAA;EACA,0BAAA;EACA,8BAAA;EACA,yBAAA;EACA,oCAAA;EACA,4EAAA;EACA,kCAAA;EACA,8BAAA;EACA,kBAAA;EACA,4DAAA;EACA,4CAAA;EACA,4BAAA;EACA,oCAAA;EACA,8BAAA;EACA,4CAAA;AAyMF;;AAtMA;EACE,cAAA;AAyMF;;AAtMA;EACE,gBAAA;EACA,iCAAA;AAyMF;;AAtMA;EACE,mBAAA;AAyMF;;AAvMA;EACE,kBAAA;EACA,MAAA;EACA,QAAA;EACA,UAAA;EACA,qBAAA;AA0MF;;AAvMA;EACE,sCAAA;EACA,wCAAA;EACA,sDAAA;EACA,2CAAA;AA0MF;;AAvMA;EACE,wCAAA;EACA,0CAAA;EACA,wDAAA;EACA,6CAAA;AA0MF;;AAvMA;EACE,0CAAA;EACA,4CAAA;EACA,0DAAA;EACA,+CAAA;AA0MF;;AAvMA;EACE,wCAAA;EACA,0CAAA;EACA,wDAAA;EACA,6CAAA;AA0MF;;AAvMA;EACE,qCAAA;EACA,uCAAA;EACA,qDAAA;EACA,0CAAA;AA0MF;;AAvMA;EACE,wCAAA;EACA,0CAAA;EACA,wDAAA;EACA,6CAAA;AA0MF;;AAvMA;EACE,uCAAA;EACA,yCAAA;EACA,uDAAA;EACA,4CAAA;AA0MF;;AAvMA;EACE,qCAAA;EACA,uCAAA;EACA,qDAAA;EACA,0CAAA;AA0MF;;AAvMA;EACE;IACE,2BAAA;EA0MF;AACF;AAxMA;;EAEE,0BAAA;EACA,gCAAA;EACA,oCAAA;EACA,gCAAA;EACA,8BAAA;EACA,gCAAA;EACA,6BAAA;EACA,6CAAA;EACA,aAAA;EACA,iCAAA;EACA,gBAAA;EACA,uCAAA;EACA,uCAAA;EACA,+CAAA;EACA,yCAAA;AA0MF;;AAvMA;EACE,aAAA;EACA,sBAAA;EACA,uBAAA;EACA,gBAAA;EACA,mCAAA;EACA,kBAAA;EACA,mBAAA;EACA,2CAAA;EACA,6CAAA;AA0MF;;AAxMA;EACE;IACE,gBAAA;EA2MF;AACF;AAxMA;EACE,qMAAA;EACA,oEAAA;AA0MF;;AAvMA;EACE,iBAAA;AA0MF;;AAvMA;EACE,WAAA;AA0MF;;AAvMA;EACE,kDAAA;AA0MF;;AAxMA;EACE;IACE,eAAA;EA2MF;AACF;AAxMA;EACE,yCAAA;EACA,2BAAA;EACA,kDAAA;EACA,oDAAA;EACA,sDAAA;EACA,oCAAA;EACA,sCAAA;EACA,gDAAA;EACA,sDAAA;EACA,mDAAA;EACA,yDAAA;EACA,oDAAA;EACA,kDAAA;EACA,oCAAA;EACA,8DAAA;EACA,wDAAA;EACA,kEAAA;EACA,aAAA;EACA,sBAAA;EACA,eAAA;EACA,gBAAA;EACA,iDAAA;AA0MF;;AAvMA;EACE,qBAAA;EACA,sBAAA;AA0MF;;AAxMA;EACE,oCAAA;EACA,0BAAA;AA2MF;;AAxMA;EACE,WAAA;EACA,wCAAA;EACA,mBAAA;AA2MF;;AAzMA;EACE,UAAA;EACA,8CAAA;EACA,qBAAA;EACA,sDAAA;AA4MF;;AA1MA;EACE,+CAAA;EACA,uDAAA;AA6MF;;AA1MA;EACE,kBAAA;EACA,cAAA;EACA,gFAAA;EACA,iCAAA;EACA,yCAAA;EACA,iFAAA;AA6MF;;AA3MA;EACE,+BAAA;EACA,gCAAA;AA8MF;;AA5MA;EACE,mCAAA;EACA,kCAAA;AA+MF;;AA7MA;EACE,0CAAA;EACA,oBAAA;EACA,kDAAA;AAgNF;;AA9MA;EACE,UAAA;EACA,wCAAA;EACA,gDAAA;EACA,sDAAA;AAiNF;;AA/MA;EACE,mBAAA;AAkNF;;AAhNA;EACE,wDAAA;EACA,mDAAA;AAmNF;;AAhNA;EACE,mBAAA;AAmNF;;AAjNA;EACE,6DAAA;EACA,0BAAA;AAoNF;;AAlNA;EACE,2DAAA;EACA,4BAAA;AAqNF;;AAnNA;EACE,aAAA;AAsNF;;AApNA;EACE,mDAAA;EACA,oBAAA;AAuNF;;AArNA;EACE,yDAAA;EACA,oDAAA;AAwNF;;AArNA;EACE;IACE,mBAAA;EAwNF;EAtNA;IACE,6DAAA;IACA,0BAAA;EAwNF;EAtNA;IACE,2DAAA;IACA,4BAAA;EAwNF;EAtNA;IACE,aAAA;EAwNF;EAtNA;IACE,mDAAA;IACA,oBAAA;EAwNF;EAtNA;IACE,yDAAA;IACA,oDAAA;EAwNF;AACF;AAtNA;EACE;IACE,mBAAA;EAwNF;EAtNA;IACE,6DAAA;IACA,0BAAA;EAwNF;EAtNA;IACE,2DAAA;IACA,4BAAA;EAwNF;EAtNA;IACE,aAAA;EAwNF;EAtNA;IACE,mDAAA;IACA,oBAAA;EAwNF;EAtNA;IACE,yDAAA;IACA,oDAAA;EAwNF;AACF;AAtNA;EACE;IACE,mBAAA;EAwNF;EAtNA;IACE,6DAAA;IACA,0BAAA;EAwNF;EAtNA;IACE,2DAAA;IACA,4BAAA;EAwNF;EAtNA;IACE,aAAA;EAwNF;EAtNA;IACE,mDAAA;IACA,oBAAA;EAwNF;EAtNA;IACE,yDAAA;IACA,oDAAA;EAwNF;AACF;AAtNA;EACE;IACE,mBAAA;EAwNF;EAtNA;IACE,6DAAA;IACA,0BAAA;EAwNF;EAtNA;IACE,2DAAA;IACA,4BAAA;EAwNF;EAtNA;IACE,aAAA;EAwNF;EAtNA;IACE,mDAAA;IACA,oBAAA;EAwNF;EAtNA;IACE,yDAAA;IACA,oDAAA;EAwNF;AACF;AAtNA;EACE;IACE,mBAAA;EAwNF;EAtNA;IACE,6DAAA;IACA,0BAAA;EAwNF;EAtNA;IACE,2DAAA;IACA,4BAAA;EAwNF;EAtNA;IACE,aAAA;EAwNF;EAtNA;IACE,mDAAA;IACA,oBAAA;EAwNF;EAtNA;IACE,yDAAA;IACA,oDAAA;EAwNF;AACF;AAtNA;EACE,gBAAA;AAwNF;;AAtNA;EACE,mDAAA;AAyNF;;AAvNA;EACE,sBAAA;AA0NF;;AAvNA;EACE,2CAAA;EACA,6CAAA;EACA,2DAAA;AA0NF;;AAxNA;EACE,4DAAA;EACA,8DAAA;AA2NF;;AAzNA;EACE,sDAAA;EACA,+CAAA;EACA,yDAAA;AA4NF;;AAzNA;EACE,6CAAA;EACA,+CAAA;EACA,6DAAA;AA4NF;;AA1NA;EACE,4DAAA;EACA,gEAAA;AA6NF;;AA3NA;EACE,sDAAA;EACA,iDAAA;EACA,2DAAA;AA8NF;;AA3NA;EACE,+CAAA;EACA,iDAAA;EACA,+DAAA;AA8NF;;AA5NA;EACE,4DAAA;EACA,kEAAA;AA+NF;;AA7NA;EACE,sDAAA;EACA,mDAAA;EACA,6DAAA;AAgOF;;AA7NA;EACE,6CAAA;EACA,+CAAA;EACA,6DAAA;AAgOF;;AA9NA;EACE,4DAAA;EACA,gEAAA;AAiOF;;AA/NA;EACE,sDAAA;EACA,iDAAA;EACA,2DAAA;AAkOF;;AA/NA;EACE,0CAAA;EACA,4CAAA;EACA,0DAAA;AAkOF;;AAhOA;EACE,4DAAA;EACA,6DAAA;AAmOF;;AAjOA;EACE,sDAAA;EACA,8CAAA;EACA,wDAAA;AAoOF;;AAjOA;EACE,6CAAA;EACA,+CAAA;EACA,6DAAA;AAoOF;;AAlOA;EACE,4DAAA;EACA,gEAAA;AAqOF;;AAnOA;EACE,sDAAA;EACA,iDAAA;EACA,2DAAA;AAsOF;;AAnOA;EACE,4CAAA;EACA,8CAAA;EACA,4DAAA;AAsOF;;AApOA;EACE,4DAAA;EACA,+DAAA;AAuOF;;AArOA;EACE,sDAAA;EACA,gDAAA;EACA,0DAAA;AAwOF;;AArOA;EACE,0CAAA;EACA,4CAAA;EACA,0DAAA;AAwOF;;AAtOA;EACE,4DAAA;EACA,6DAAA;AAyOF;;AAvOA;EACE,sDAAA;EACA,8CAAA;EACA,wDAAA;AA0OF;;AAvOA;EACE,6BAAA;EACA,2DAAA;EACA,2BAAA;EACA,kCAAA;EACA,iCAAA;EACA,+BAAA;EACA,qCAAA;EACA,uEAAA;EACA,uBAAA;EACA,cAAA;EACA,eAAA;EACA,sBAAA;EACA,gCAAA;EACA,4EAAA;EACA,SAAA;EACA,uBAAA;EACA,oCAAA;AA0OF;;AAxOA;EACE,gCAAA;EACA,qBAAA;EACA,0CAAA;AA2OF;;AAzOA;EACE,UAAA;EACA,4CAAA;EACA,0CAAA;AA4OF;;AA1OA;EACE,oBAAA;EACA,yBAAA;UAAA,iBAAA;EACA,6CAAA;AA6OF;;AA1OA;EACE,wCAAA;AA6OF;;AA1OA;EACE,wCAAA;AA6OF;;AA1OA;EACE,uBAAA;EACA,6BAAA;EACA,4BAAA;EACA,0BAAA;EACA,2BAAA;EACA,8BAAA;EACA,oCAAA;EACA,gCAAA;EACA,+CAAA;EACA,oCAAA;EACA,iDAAA;EACA,2CAAA;EACA,2CAAA;EACA,uCAAA;EACA,sDAAA;EACA,gCAAA;EACA,eAAA;EACA,oCAAA;EACA,4BAAA;EACA,oBAAA;EACA,oCAAA;EACA,4BAAA;EACA,uEAAA;EACA,sCAAA;EACA,4CAAA;AA6OF;;AA3OA;EACE,UAAA;AA8OF;;AA5OA;EACE,aAAA;AA+OF;;AA5OA;EACE,uBAAA;EACA,kBAAA;EACA,+BAAA;EACA,kBAAA;EACA,eAAA;EACA,oBAAA;AA+OF;;AA7OA;EACE,sCAAA;AAgPF;;AA7OA;EACE,aAAA;EACA,mBAAA;EACA,4DAAA;EACA,mCAAA;EACA,2CAAA;EACA,4BAAA;EACA,qFAAA;EACA,0FAAA;EACA,2FAAA;AAgPF;;AA9OA;EACE,oDAAA;EACA,sCAAA;AAiPF;;AA9OA;EACE,kCAAA;EACA,qBAAA;AAiPF;;AA9OA;EACE,uBAAA;EACA,uBAAA;EACA,2BAAA;EACA,yBAAA;EACA,kBAAA;EACA,gCAAA;EACA,2DAAA;EACA,0BAAA;EACA,kCAAA;EACA,0DAAA;EACA,wCAAA;EACA,oCAAA;EACA,oCAAA;EACA,0CAAA;EACA,sDAAA;EACA,mCAAA;EACA,iCAAA;EACA,6BAAA;EACA,sBAAA;EACA,sDAAA;EACA,mCAAA;EACA,eAAA;EACA,MAAA;EACA,OAAA;EACA,+BAAA;EACA,aAAA;EACA,WAAA;EACA,YAAA;EACA,kBAAA;EACA,gBAAA;EACA,UAAA;AAiPF;;AA9OA;EACE,kBAAA;EACA,WAAA;EACA,8BAAA;EACA,oBAAA;AAiPF;;AA/OA;EACE,mCAAA;EACA,8BAAA;AAkPF;;AAhPA;EACE;IACE,gBAAA;EAmPF;AACF;AAjPA;EACE,eAAA;AAmPF;;AAjPA;EACE,sBAAA;AAoPF;;AAjPA;EACE,+CAAA;AAoPF;;AAlPA;EACE,gBAAA;EACA,gBAAA;AAqPF;;AAnPA;EACE,gBAAA;AAsPF;;AAnPA;EACE,aAAA;EACA,mBAAA;EACA,mDAAA;AAsPF;;AAnPA;EACE,kBAAA;EACA,aAAA;EACA,sBAAA;EACA,WAAA;EACA,4BAAA;EACA,oBAAA;EACA,oCAAA;EACA,4BAAA;EACA,uEAAA;EACA,4CAAA;EACA,sCAAA;EACA,UAAA;AAsPF;;AAnPA;EACE,0BAAA;EACA,yBAAA;EACA,0BAAA;EACA,eAAA;EACA,MAAA;EACA,OAAA;EACA,kCAAA;EACA,YAAA;EACA,aAAA;EACA,uCAAA;AAsPF;;AApPA;EACE,UAAA;AAuPF;;AArPA;EACE,mCAAA;AAwPF;;AArPA;EACE,aAAA;EACA,cAAA;EACA,mBAAA;EACA,8BAAA;EACA,uCAAA;EACA,4FAAA;EACA,2DAAA;EACA,4DAAA;AAwPF;;AAtPA;EACE,kGAAA;EACA,sJAAA;AAyPF;;AAtPA;EACE,gBAAA;EACA,8CAAA;AAyPF;;AAtPA;EACE,kBAAA;EACA,cAAA;EACA,gCAAA;AAyPF;;AAtPA;EACE,aAAA;EACA,cAAA;EACA,eAAA;EACA,mBAAA;EACA,yBAAA;EACA,yEAAA;EACA,2CAAA;EACA,yFAAA;EACA,+DAAA;EACA,8DAAA;AAyPF;;AAvPA;EACE,8CAAA;AA0PF;;AAvPA;EACE;IACE,0BAAA;IACA,uDAAA;EA0PF;EAxPA;IACE,gCAAA;IACA,kBAAA;IACA,iBAAA;EA0PF;EAxPA;IACE,uBAAA;EA0PF;AACF;AAxPA;EACE;;IAEE,uBAAA;EA0PF;AACF;AAxPA;EACE;IACE,wBAAA;EA0PF;AACF;AAxPA;EACE,YAAA;EACA,eAAA;EACA,YAAA;EACA,SAAA;AA0PF;;AAxPA;EACE,YAAA;EACA,SAAA;EACA,gBAAA;AA2PF;;AAzPA;;EAEE,gBAAA;AA4PF;;AA1PA;EACE,gBAAA;AA6PF;;AA1PA;EACE;IACE,YAAA;IACA,eAAA;IACA,YAAA;IACA,SAAA;EA6PF;EA3PA;IACE,YAAA;IACA,SAAA;IACA,gBAAA;EA6PF;EA3PA;;IAEE,gBAAA;EA6PF;EA3PA;IACE,gBAAA;EA6PF;AACF;AA3PA;EACE;IACE,YAAA;IACA,eAAA;IACA,YAAA;IACA,SAAA;EA6PF;EA3PA;IACE,YAAA;IACA,SAAA;IACA,gBAAA;EA6PF;EA3PA;;IAEE,gBAAA;EA6PF;EA3PA;IACE,gBAAA;EA6PF;AACF;AA3PA;EACE;IACE,YAAA;IACA,eAAA;IACA,YAAA;IACA,SAAA;EA6PF;EA3PA;IACE,YAAA;IACA,SAAA;IACA,gBAAA;EA6PF;EA3PA;;IAEE,gBAAA;EA6PF;EA3PA;IACE,gBAAA;EA6PF;AACF;AA3PA;EACE;IACE,YAAA;IACA,eAAA;IACA,YAAA;IACA,SAAA;EA6PF;EA3PA;IACE,YAAA;IACA,SAAA;IACA,gBAAA;EA6PF;EA3PA;;IAEE,gBAAA;EA6PF;EA3PA;IACE,gBAAA;EA6PF;AACF;AA3PA;EACE;IACE,YAAA;IACA,eAAA;IACA,YAAA;IACA,SAAA;EA6PF;EA3PA;IACE,YAAA;IACA,SAAA;IACA,gBAAA;EA6PF;EA3PA;;IAEE,gBAAA;EA6PF;EA3PA;IACE,gBAAA;EA6PF;AACF;AA3PA;EACE,yBAAA;EACA,6BAAA;EACA,4BAAA;EACA,+BAAA;EACA,sBAAA;EACA,4BAAA;EACA,sCAAA;EACA,kCAAA;EACA,oCAAA;EACA,uBAAA;EACA,gCAAA;EACA,iCAAA;EACA,iCAAA;EACA,cAAA;EACA,uCAAA;EACA,gCAAA;EACA,sCAAA;EACA,kBAAA;EACA,gBAAA;EACA,gBAAA;EACA,gBAAA;EACA,iBAAA;EACA,qBAAA;EACA,iBAAA;EACA,oBAAA;EACA,sBAAA;EACA,kBAAA;EACA,mBAAA;EACA,oBAAA;EACA,gBAAA;EACA,sCAAA;EACA,qBAAA;EACA,UAAA;AA6PF;;AA3PA;EACE,kCAAA;AA8PF;;AA5PA;EACE,cAAA;EACA,oCAAA;EACA,sCAAA;AA+PF;;AA7PA;EACE,kBAAA;EACA,WAAA;EACA,yBAAA;EACA,mBAAA;AAgQF;;AA7PA;EACE,SAAA;AAgQF;;AA9PA;EACE,SAAA;EACA,wFAAA;EACA,sCAAA;AAiQF;;AA9PA,qBAAA;AACA;EACE,OAAA;EACA,qCAAA;EACA,qCAAA;AAiQF;;AA/PA;EACE,WAAA;EACA,kIAAA;EACA,wCAAA;AAkQF;;AA/PA,mBAAA;AACA;EACE,MAAA;AAkQF;;AAhQA;EACE,YAAA;EACA,wFAAA;EACA,yCAAA;AAmQF;;AAhQA,qBAAA;AACA;EACE,QAAA;EACA,qCAAA;EACA,qCAAA;AAmQF;;AAjQA;EACE,UAAA;EACA,kIAAA;EACA,uCAAA;AAoQF;;AAjQA,mBAAA;AACA;EACE,sCAAA;EACA,gEAAA;EACA,8BAAA;EACA,kBAAA;EACA,sCAAA;EACA,8CAAA;AAoQF;;AAjQA;EACE,yBAAA;EACA,6BAAA;EACA,4BAAA;EACA,wBAAA;EACA,iDAAA;EACA,kCAAA;EACA,oCAAA;EACA,0CAAA;EACA,iEAAA;EACA,sCAAA;EACA,mCAAA;EACA,mCAAA;EACA,6CAAA;EACA,+BAAA;EACA,oCAAA;EACA,oCAAA;EACA,2CAAA;EACA,8BAAA;EACA,iCAAA;EACA,yDAAA;EACA,iCAAA;EACA,cAAA;EACA,sCAAA;EACA,sCAAA;EACA,kBAAA;EACA,gBAAA;EACA,gBAAA;EACA,gBAAA;EACA,iBAAA;EACA,qBAAA;EACA,iBAAA;EACA,oBAAA;EACA,sBAAA;EACA,kBAAA;EACA,mBAAA;EACA,oBAAA;EACA,gBAAA;EACA,sCAAA;EACA,qBAAA;EACA,sCAAA;EACA,4BAAA;EACA,2EAAA;EACA,8CAAA;EACA,wCAAA;AAoQF;;AAlQA;EACE,cAAA;EACA,oCAAA;EACA,sCAAA;AAqQF;;AAnQA;EACE,kBAAA;EACA,cAAA;EACA,WAAA;EACA,yBAAA;EACA,mBAAA;EACA,eAAA;AAsQF;;AAnQA;EACE,oFAAA;AAsQF;;AApQA;EACE,wFAAA;AAuQF;;AArQA;EACE,SAAA;EACA,gDAAA;AAwQF;;AAtQA;EACE,sCAAA;EACA,sCAAA;AAyQF;;AAtQA,qBAAA;AACA;EACE,kFAAA;EACA,qCAAA;EACA,qCAAA;AAyQF;;AAvQA;EACE,kIAAA;AA0QF;;AAxQA;EACE,OAAA;EACA,kDAAA;AA2QF;;AAzQA;EACE,oCAAA;EACA,wCAAA;AA4QF;;AAzQA,mBAAA;AACA;EACE,iFAAA;AA4QF;;AA1QA;EACE,wFAAA;AA6QF;;AA3QA;EACE,MAAA;EACA,mDAAA;AA8QF;;AA5QA;EACE,mCAAA;EACA,yCAAA;AA+QF;;AA7QA;EACE,kBAAA;EACA,MAAA;EACA,SAAA;EACA,cAAA;EACA,oCAAA;EACA,uDAAA;EACA,WAAA;EACA,+EAAA;AAgRF;;AA7QA,qBAAA;AACA;EACE,mFAAA;EACA,qCAAA;EACA,qCAAA;AAgRF;;AA9QA;EACE,kIAAA;AAiRF;;AA/QA;EACE,QAAA;EACA,iDAAA;AAkRF;;AAhRA;EACE,qCAAA;EACA,uCAAA;AAmRF;;AAhRA,mBAAA;AACA;EACE,8EAAA;EACA,gBAAA;EACA,6CAAA;EACA,qCAAA;EACA,6CAAA;EACA,kFAAA;EACA,6DAAA;EACA,8DAAA;AAmRF;;AAjRA;EACE,aAAA;AAoRF;;AAjRA;EACE,0EAAA;EACA,mCAAA;AAoRF;;AAjRA;EACE,kBAAA;AAoRF;;AAjRA;EACE,mBAAA;AAoRF;;AAjRA;EACE,kBAAA;EACA,WAAA;EACA,gBAAA;AAoRF;;AAlRA;EACE,cAAA;EACA,WAAA;EACA,WAAA;AAqRF;;AAlRA;EACE,kBAAA;EACA,aAAA;EACA,WAAA;EACA,WAAA;EACA,mBAAA;EACA,2BAAA;EACA,sCAAA;AAqRF;;AAnRA;EACE;IACE,gBAAA;EAsRF;AACF;AAnRA;;;EAGE,cAAA;AAqRF;;AAlRA;;EAEE,2BAAA;AAqRF;;AAlRA;;EAEE,4BAAA;AAqRF;;AAlRA;EACE,UAAA;EACA,4BAAA;EACA,eAAA;AAqRF;;AAnRA;;;EAGE,UAAA;EACA,UAAA;AAsRF;;AApRA;;EAEE,UAAA;EACA,UAAA;EACA,2BAAA;AAuRF;;AArRA;EACE;;IAEE,gBAAA;EAwRF;AACF;AArRA;;EAEE,kBAAA;EACA,MAAA;EACA,SAAA;EACA,UAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,UAAA;EACA,UAAA;EACA,cAAA;EACA,kBAAA;EACA,gBAAA;EACA,SAAA;EACA,YAAA;EACA,8BAAA;AAuRF;;AArRA;EACE;;IAEE,gBAAA;EAwRF;AACF;AAtRA;;;EAGE,cAAA;EACA,qBAAA;EACA,UAAA;EACA,YAAA;AAwRF;;AArRA;EACE,OAAA;AAwRF;;AArRA;EACE,QAAA;AAwRF;;AArRA;;EAEE,qBAAA;EACA,WAAA;EACA,YAAA;EACA,4BAAA;EACA,wBAAA;EACA,0BAAA;AAwRF;;AArRA;;;;;;;GAAA;AAQA;EACE,0DAAA;AAwRF;;AArRA;EACE,0DAAA;AAwRF;;AArRA;EACE,kBAAA;EACA,QAAA;EACA,SAAA;EACA,OAAA;EACA,UAAA;EACA,aAAA;EACA,uBAAA;EACA,UAAA;EACA,iBAAA;EACA,mBAAA;EACA,gBAAA;EACA,gBAAA;AAwRF;;AAtRA;EACE,uBAAA;EACA,cAAA;EACA,WAAA;EACA,WAAA;EACA,UAAA;EACA,iBAAA;EACA,gBAAA;EACA,mBAAA;EACA,eAAA;EACA,yBAAA;EACA,4BAAA;EACA,SAAA;EACA,kCAAA;EACA,qCAAA;EACA,YAAA;EACA,6BAAA;AAyRF;;AAvRA;EACE;IACE,gBAAA;EA0RF;AACF;AAxRA;EACE,UAAA;AA0RF;;AAvRA;EACE,kBAAA;EACA,UAAA;EACA,eAAA;EACA,SAAA;EACA,oBAAA;EACA,uBAAA;EACA,cAAA;EACA,kBAAA;AA0RF;;AAvRA;;EAEE,gCAAA;AA0RF;;AAxRA;EACE,yBAAA;AA2RF;;AAzRA;EACE,cAAA;AA4RF;;AAzRA;;EAEE,gCAAA;AA4RF;;AA1RA;EACE,yBAAA;AA6RF;;AA3RA;EACE,cAAA;AA8RF;;AA3RA;;EAEE,qBAAA;EACA,8BAAA;EACA,gCAAA;EACA,gDAAA;EACA,kBAAA;EACA,6FAAA;AA8RF;;AA3RA;EACE;IACE,yBAAA;EA8RF;AACF;AA5RA;EACE,wBAAA;EACA,yBAAA;EACA,qCAAA;EACA,mCAAA;EACA,mCAAA;EACA,2CAAA;EACA,yDAAA;EACA,+BAAA;AA8RF;;AA3RA;EACE,wBAAA;EACA,yBAAA;EACA,kCAAA;AA8RF;;AA3RA;EACE;IACE,mBAAA;EA8RF;EA5RA;IACE,UAAA;IACA,eAAA;EA8RF;AACF;AA5RA;EACE,wBAAA;EACA,yBAAA;EACA,qCAAA;EACA,mCAAA;EACA,yCAAA;EACA,8BAAA;EACA,UAAA;AA8RF;;AA3RA;EACE,wBAAA;EACA,yBAAA;AA8RF;;AA3RA;EACE;;IAEE,kCAAA;EA8RF;AACF;AA5RA;EACE,2BAAA;EACA,2BAAA;EACA,2BAAA;EACA,iCAAA;EACA,iCAAA;EACA,0CAAA;EACA,oCAAA;EACA,8BAAA;EACA,+DAAA;EACA,8DAAA;EACA,qDAAA;EACA,qCAAA;AA8RF;;AA3RA;EACE;IACE,eAAA;IACA,SAAA;IACA,mCAAA;IACA,aAAA;IACA,sBAAA;IACA,eAAA;IACA,gCAAA;IACA,kBAAA;IACA,wCAAA;IACA,4BAAA;IACA,UAAA;IACA,0CAAA;IACA,0CAAA;EA8RF;AACF;AA5RA;EACE;IACE,gBAAA;EA8RF;AACF;AA5RA;EACE;IACE,MAAA;IACA,OAAA;IACA,gCAAA;IACA,qFAAA;IACA,4BAAA;EA8RF;EA1RA;IACE,MAAA;IACA,QAAA;IACA,gCAAA;IACA,oFAAA;IACA,2BAAA;EA8RF;EA1RA;IACE,MAAA;IACA,QAAA;IACA,OAAA;IACA,kCAAA;IACA,gBAAA;IACA,sFAAA;IACA,4BAAA;EA8RF;EA1RA;IACE,QAAA;IACA,OAAA;IACA,kCAAA;IACA,gBAAA;IACA,mFAAA;IACA,2BAAA;EA8RF;EA1RA;IACE,eAAA;EA8RF;EA1RA;IACE,mBAAA;EA8RF;AAvCF;AApPA;EACE;IACE,2BAAA;IACA,8BAAA;IACA,wCAAA;EA8RF;EA5RA;IACE,aAAA;EA8RF;EA5RA;IACE,aAAA;IACA,YAAA;IACA,UAAA;IACA,mBAAA;IACA,wCAAA;EA8RF;AACF;AA3RA;EACE;IACE,eAAA;IACA,SAAA;IACA,mCAAA;IACA,aAAA;IACA,sBAAA;IACA,eAAA;IACA,gCAAA;IACA,kBAAA;IACA,wCAAA;IACA,4BAAA;IACA,UAAA;IACA,0CAAA;IACA,0CAAA;EA6RF;AACF;AA3RA;EACE;IACE,gBAAA;EA6RF;AACF;AA3RA;EACE;IACE,MAAA;IACA,OAAA;IACA,gCAAA;IACA,qFAAA;IACA,4BAAA;EA6RF;EAzRA;IACE,MAAA;IACA,QAAA;IACA,gCAAA;IACA,oFAAA;IACA,2BAAA;EA6RF;EAzRA;IACE,MAAA;IACA,QAAA;IACA,OAAA;IACA,kCAAA;IACA,gBAAA;IACA,sFAAA;IACA,4BAAA;EA6RF;EAzRA;IACE,QAAA;IACA,OAAA;IACA,kCAAA;IACA,gBAAA;IACA,mFAAA;IACA,2BAAA;EA6RF;EAzRA;IACE,eAAA;EA6RF;EAzRA;IACE,mBAAA;EA6RF;AAvCF;AAnPA;EACE;IACE,2BAAA;IACA,8BAAA;IACA,wCAAA;EA6RF;EA3RA;IACE,aAAA;EA6RF;EA3RA;IACE,aAAA;IACA,YAAA;IACA,UAAA;IACA,mBAAA;IACA,wCAAA;EA6RF;AACF;AA1RA;EACE;IACE,eAAA;IACA,SAAA;IACA,mCAAA;IACA,aAAA;IACA,sBAAA;IACA,eAAA;IACA,gCAAA;IACA,kBAAA;IACA,wCAAA;IACA,4BAAA;IACA,UAAA;IACA,0CAAA;IACA,0CAAA;EA4RF;AACF;AA1RA;EACE;IACE,gBAAA;EA4RF;AACF;AA1RA;EACE;IACE,MAAA;IACA,OAAA;IACA,gCAAA;IACA,qFAAA;IACA,4BAAA;EA4RF;EAxRA;IACE,MAAA;IACA,QAAA;IACA,gCAAA;IACA,oFAAA;IACA,2BAAA;EA4RF;EAxRA;IACE,MAAA;IACA,QAAA;IACA,OAAA;IACA,kCAAA;IACA,gBAAA;IACA,sFAAA;IACA,4BAAA;EA4RF;EAxRA;IACE,QAAA;IACA,OAAA;IACA,kCAAA;IACA,gBAAA;IACA,mFAAA;IACA,2BAAA;EA4RF;EAxRA;IACE,eAAA;EA4RF;EAxRA;IACE,mBAAA;EA4RF;AAvCF;AAlPA;EACE;IACE,2BAAA;IACA,8BAAA;IACA,wCAAA;EA4RF;EA1RA;IACE,aAAA;EA4RF;EA1RA;IACE,aAAA;IACA,YAAA;IACA,UAAA;IACA,mBAAA;IACA,wCAAA;EA4RF;AACF;AAzRA;EACE;IACE,eAAA;IACA,SAAA;IACA,mCAAA;IACA,aAAA;IACA,sBAAA;IACA,eAAA;IACA,gCAAA;IACA,kBAAA;IACA,wCAAA;IACA,4BAAA;IACA,UAAA;IACA,0CAAA;IACA,0CAAA;EA2RF;AACF;AAzRA;EACE;IACE,gBAAA;EA2RF;AACF;AAzRA;EACE;IACE,MAAA;IACA,OAAA;IACA,gCAAA;IACA,qFAAA;IACA,4BAAA;EA2RF;EAvRA;IACE,MAAA;IACA,QAAA;IACA,gCAAA;IACA,oFAAA;IACA,2BAAA;EA2RF;EAvRA;IACE,MAAA;IACA,QAAA;IACA,OAAA;IACA,kCAAA;IACA,gBAAA;IACA,sFAAA;IACA,4BAAA;EA2RF;EAvRA;IACE,QAAA;IACA,OAAA;IACA,kCAAA;IACA,gBAAA;IACA,mFAAA;IACA,2BAAA;EA2RF;EAvRA;IACE,eAAA;EA2RF;EAvRA;IACE,mBAAA;EA2RF;AAvCF;AAjPA;EACE;IACE,2BAAA;IACA,8BAAA;IACA,wCAAA;EA2RF;EAzRA;IACE,aAAA;EA2RF;EAzRA;IACE,aAAA;IACA,YAAA;IACA,UAAA;IACA,mBAAA;IACA,wCAAA;EA2RF;AACF;AAxRA;EACE;IACE,eAAA;IACA,SAAA;IACA,mCAAA;IACA,aAAA;IACA,sBAAA;IACA,eAAA;IACA,gCAAA;IACA,kBAAA;IACA,wCAAA;IACA,4BAAA;IACA,UAAA;IACA,0CAAA;IACA,0CAAA;EA0RF;AACF;AAxRA;EACE;IACE,gBAAA;EA0RF;AACF;AAxRA;EACE;IACE,MAAA;IACA,OAAA;IACA,gCAAA;IACA,qFAAA;IACA,4BAAA;EA0RF;EAtRA;IACE,MAAA;IACA,QAAA;IACA,gCAAA;IACA,oFAAA;IACA,2BAAA;EA0RF;EAtRA;IACE,MAAA;IACA,QAAA;IACA,OAAA;IACA,kCAAA;IACA,gBAAA;IACA,sFAAA;IACA,4BAAA;EA0RF;EAtRA;IACE,QAAA;IACA,OAAA;IACA,kCAAA;IACA,gBAAA;IACA,mFAAA;IACA,2BAAA;EA0RF;EAtRA;IACE,eAAA;EA0RF;EAtRA;IACE,mBAAA;EA0RF;AAvCF;AAhPA;EACE;IACE,2BAAA;IACA,8BAAA;IACA,wCAAA;EA0RF;EAxRA;IACE,aAAA;EA0RF;EAxRA;IACE,aAAA;IACA,YAAA;IACA,UAAA;IACA,mBAAA;IACA,wCAAA;EA0RF;AACF;AAvRA;EACE,eAAA;EACA,SAAA;EACA,mCAAA;EACA,aAAA;EACA,sBAAA;EACA,eAAA;EACA,gCAAA;EACA,kBAAA;EACA,wCAAA;EACA,4BAAA;EACA,UAAA;EACA,0CAAA;EACA,0CAAA;AAyRF;;AAvRA;EACE;IACE,gBAAA;EA0RF;AACF;AAxRA;EACE,MAAA;EACA,OAAA;EACA,gCAAA;EACA,qFAAA;EACA,4BAAA;AA0RF;;AAxRA;EACE,MAAA;EACA,QAAA;EACA,gCAAA;EACA,oFAAA;EACA,2BAAA;AA2RF;;AAzRA;EACE,MAAA;EACA,QAAA;EACA,OAAA;EACA,kCAAA;EACA,gBAAA;EACA,sFAAA;EACA,4BAAA;AA4RF;;AA1RA;EACE,QAAA;EACA,OAAA;EACA,kCAAA;EACA,gBAAA;EACA,mFAAA;EACA,2BAAA;AA6RF;;AA3RA;EACE,eAAA;AA8RF;;AA5RA;EACE,mBAAA;AA+RF;;AA5RA;EACE,eAAA;EACA,MAAA;EACA,OAAA;EACA,aAAA;EACA,YAAA;EACA,aAAA;EACA,yBAAA;AA+RF;;AA7RA;EACE,UAAA;AAgSF;;AA9RA;EACE,YAAA;AAiSF;;AA9RA;EACE,aAAA;EACA,mBAAA;EACA,8BAAA;EACA,oEAAA;AAiSF;;AA/RA;EACE,4FAAA;EACA,sDAAA;EACA,wDAAA;EACA,yDAAA;AAkSF;;AA/RA;EACE,gBAAA;EACA,kDAAA;AAkSF;;AA/RA;EACE,YAAA;EACA,oEAAA;EACA,gBAAA;AAkSF;;AA/RA;EACE,qBAAA;EACA,eAAA;EACA,sBAAA;EACA,YAAA;EACA,8BAAA;EACA,YAAA;AAkSF;;AAhSA;EACE,qBAAA;EACA,WAAA;AAmSF;;AAhSA;EACE,iBAAA;AAmSF;;AAhSA;EACE,iBAAA;AAmSF;;AAhSA;EACE,iBAAA;AAmSF;;AAhSA;EACE,mDAAA;AAmSF;;AAhSA;EACE;IACE,YAAA;EAmSF;AACF;AAjSA;EACE,qFAAA;EACA,oBAAA;EACA,8CAAA;AAmSF;;AAhSA;EACE;IACE,uBAAA;EAmSF;AACF;AAjSA;EACE,cAAA;EACA,WAAA;EACA,WAAA;AAmSF;;AAhSA;EACE,yBAAA;EACA,yEAAA;AAmSF;;AAhSA;EACE,yBAAA;EACA,uEAAA;AAmSF;;AAhSA;EACE,yBAAA;EACA,yEAAA;AAmSF;;AAhSA;EACE,yBAAA;EACA,wEAAA;AAmSF;;AAhSA;EACE,yBAAA;EACA,wEAAA;AAmSF;;AAhSA;EACE,yBAAA;EACA,uEAAA;AAmSF;;AAhSA;EACE,yBAAA;EACA,wEAAA;AAmSF;;AAhSA;EACE,yBAAA;EACA,sEAAA;AAmSF;;AAhSA;EACE,yBAAA;AAmSF;;AAjSA;EACE,yBAAA;AAoSF;;AAjSA;EACE,yBAAA;AAoSF;;AAlSA;EACE,yBAAA;AAqSF;;AAlSA;EACE,yBAAA;AAqSF;;AAnSA;EACE,yBAAA;AAsSF;;AAnSA;EACE,yBAAA;AAsSF;;AApSA;EACE,yBAAA;AAuSF;;AApSA;EACE,yBAAA;AAuSF;;AArSA;EACE,yBAAA;AAwSF;;AArSA;EACE,yBAAA;AAwSF;;AAtSA;EACE,yBAAA;AAySF;;AAtSA;EACE,yBAAA;AAySF;;AAvSA;EACE,yBAAA;AA0SF;;AAvSA;EACE,yBAAA;AA0SF;;AAxSA;EACE,yBAAA;AA2SF;;AAxSA;EACE,kBAAA;EACA,WAAA;AA2SF;;AAzSA;EACE,cAAA;EACA,mCAAA;EACA,WAAA;AA4SF;;AA1SA;EACE,kBAAA;EACA,MAAA;EACA,OAAA;EACA,WAAA;EACA,YAAA;AA6SF;;AA1SA;EACE,uBAAA;AA6SF;;AA1SA;EACE,sBAAA;AA6SF;;AA1SA;EACE,yBAAA;AA6SF;;AA1SA;EACE,iCAAA;AA6SF;;AA1SA;EACE,eAAA;EACA,MAAA;EACA,QAAA;EACA,OAAA;EACA,aAAA;AA6SF;;AA1SA;EACE,eAAA;EACA,QAAA;EACA,SAAA;EACA,OAAA;EACA,aAAA;AA6SF;;AA1SA;EACE,gBAAA;EACA,MAAA;EACA,aAAA;AA6SF;;AA1SA;EACE,gBAAA;EACA,SAAA;EACA,aAAA;AA6SF;;AA1SA;EACE;IACE,gBAAA;IACA,MAAA;IACA,aAAA;EA6SF;EA3SA;IACE,gBAAA;IACA,SAAA;IACA,aAAA;EA6SF;AACF;AA3SA;EACE;IACE,gBAAA;IACA,MAAA;IACA,aAAA;EA6SF;EA3SA;IACE,gBAAA;IACA,SAAA;IACA,aAAA;EA6SF;AACF;AA3SA;EACE;IACE,gBAAA;IACA,MAAA;IACA,aAAA;EA6SF;EA3SA;IACE,gBAAA;IACA,SAAA;IACA,aAAA;EA6SF;AACF;AA3SA;EACE;IACE,gBAAA;IACA,MAAA;IACA,aAAA;EA6SF;EA3SA;IACE,gBAAA;IACA,SAAA;IACA,aAAA;EA6SF;AACF;AA3SA;EACE;IACE,gBAAA;IACA,MAAA;IACA,aAAA;EA6SF;EA3SA;IACE,gBAAA;IACA,SAAA;IACA,aAAA;EA6SF;AACF;AA3SA;EACE,aAAA;EACA,mBAAA;EACA,mBAAA;EACA,mBAAA;AA6SF;;AA1SA;EACE,aAAA;EACA,cAAA;EACA,sBAAA;EACA,mBAAA;AA6SF;;AA1SA;;EAEE,6BAAA;EACA,qBAAA;EACA,sBAAA;EACA,qBAAA;EACA,uBAAA;EACA,2BAAA;EACA,iCAAA;EACA,8BAAA;EACA,oBAAA;AA6SF;;AA1SA;EACE,kBAAA;EACA,MAAA;EACA,QAAA;EACA,SAAA;EACA,OAAA;EACA,UAAA;EACA,WAAA;AA6SF;;AA1SA;EACE,gBAAA;EACA,uBAAA;EACA,mBAAA;AA6SF;;AA1SA;EACE,qBAAA;EACA,mBAAA;EACA,UAAA;EACA,eAAA;EACA,8BAAA;EACA,aAAA;AA6SF;;AA1SA;EACE,mCAAA;AA6SF;;AA1SA;EACE,8BAAA;AA6SF;;AA1SA;EACE,iCAAA;AA6SF;;AA1SA;EACE,iCAAA;AA6SF;;AA1SA;EACE,sCAAA;AA6SF;;AA1SA;EACE,mCAAA;AA6SF;;AA1SA;EACE,sBAAA;AA6SF;;AA1SA;EACE,uBAAA;AA6SF;;AA1SA;EACE,sBAAA;AA6SF;;AA1SA;EACE,8BAAA;AA6SF;;AA1SA;EACE,4BAAA;AA6SF;;AA1SA;EACE,2BAAA;AA6SF;;AA1SA;EACE,iCAAA;AA6SF;;AA1SA;EACE,2BAAA;AA6SF;;AA1SA;EACE,qBAAA;AA6SF;;AA1SA;EACE,wBAAA;AA6SF;;AA1SA;EACE,uBAAA;AA6SF;;AA1SA;EACE,wBAAA;AA6SF;;AA1SA;EACE,uBAAA;AA6SF;;AA1SA;EACE,wBAAA;AA6SF;;AA1SA;EACE,uBAAA;AA6SF;;AA1SA;EACE,wBAAA;AA6SF;;AA1SA;EACE,qBAAA;AA6SF;;AA1SA;EACE,yBAAA;AA6SF;;AA1SA;EACE,2BAAA;AA6SF;;AA1SA;EACE,4BAAA;AA6SF;;AA1SA;EACE,2BAAA;AA6SF;;AA1SA;EACE,2BAAA;AA6SF;;AA1SA;EACE,6BAAA;AA6SF;;AA1SA;EACE,8BAAA;AA6SF;;AA1SA;EACE,6BAAA;AA6SF;;AA1SA;EACE,2BAAA;AA6SF;;AA1SA;EACE,6BAAA;AA6SF;;AA1SA;EACE,8BAAA;AA6SF;;AA1SA;EACE,6BAAA;AA6SF;;AA1SA;EACE,0BAAA;AA6SF;;AA1SA;EACE,gCAAA;AA6SF;;AA1SA;EACE,yBAAA;AA6SF;;AA1SA;EACE,wBAAA;AA6SF;;AA1SA;EACE,yBAAA;AA6SF;;AA1SA;EACE,6BAAA;AA6SF;;AA1SA;EACE,8BAAA;AA6SF;;AA1SA;EACE,wBAAA;AA6SF;;AA1SA;EACE,+BAAA;AA6SF;;AA1SA;EACE,wBAAA;AA6SF;;AA1SA;EACE,kEAAA;AA6SF;;AA1SA;EACE,gEAAA;AA6SF;;AA1SA;EACE,0DAAA;AA6SF;;AA1SA;EACE,2BAAA;AA6SF;;AA1SA;EACE,2BAAA;AA6SF;;AA1SA;EACE,6BAAA;AA6SF;;AA1SA;EACE,6BAAA;AA6SF;;AA1SA;EACE,0BAAA;AA6SF;;AA1SA;EACE,2BAAA;AA6SF;;AA1SA;EACE,iBAAA;AA6SF;;AA1SA;EACE,mBAAA;AA6SF;;AA1SA;EACE,mBAAA;AA6SF;;AA1SA;EACE,mBAAA;AA6SF;;AA1SA;EACE,oBAAA;AA6SF;;AA1SA;EACE,oBAAA;AA6SF;;AA1SA;EACE,sBAAA;AA6SF;;AA1SA;EACE,sBAAA;AA6SF;;AA1SA;EACE,sBAAA;AA6SF;;AA1SA;EACE,uBAAA;AA6SF;;AA1SA;EACE,kBAAA;AA6SF;;AA1SA;EACE,oBAAA;AA6SF;;AA1SA;EACE,oBAAA;AA6SF;;AA1SA;EACE,oBAAA;AA6SF;;AA1SA;EACE,qBAAA;AA6SF;;AA1SA;EACE,mBAAA;AA6SF;;AA1SA;EACE,qBAAA;AA6SF;;AA1SA;EACE,qBAAA;AA6SF;;AA1SA;EACE,qBAAA;AA6SF;;AA1SA;EACE,sBAAA;AA6SF;;AA1SA;EACE,2CAAA;AA6SF;;AA1SA;EACE,sCAAA;AA6SF;;AA1SA;EACE,sCAAA;AA6SF;;AA1SA;EACE,uFAAA;AA6SF;;AA1SA;EACE,oBAAA;AA6SF;;AA1SA;EACE,2FAAA;AA6SF;;AA1SA;EACE,wBAAA;AA6SF;;AA1SA;EACE,6FAAA;AA6SF;;AA1SA;EACE,0BAAA;AA6SF;;AA1SA;EACE,8FAAA;AA6SF;;AA1SA;EACE,2BAAA;AA6SF;;AA1SA;EACE,4FAAA;AA6SF;;AA1SA;EACE,yBAAA;AA6SF;;AA1SA;EACE,sBAAA;EACA,4EAAA;AA6SF;;AA1SA;EACE,sBAAA;EACA,8EAAA;AA6SF;;AA1SA;EACE,sBAAA;EACA,gFAAA;AA6SF;;AA1SA;EACE,sBAAA;EACA,8EAAA;AA6SF;;AA1SA;EACE,sBAAA;EACA,2EAAA;AA6SF;;AA1SA;EACE,sBAAA;EACA,8EAAA;AA6SF;;AA1SA;EACE,sBAAA;EACA,6EAAA;AA6SF;;AA1SA;EACE,sBAAA;EACA,2EAAA;AA6SF;;AA1SA;EACE,sBAAA;EACA,4EAAA;AA6SF;;AA1SA;EACE,wDAAA;AA6SF;;AA1SA;EACE,0DAAA;AA6SF;;AA1SA;EACE,wDAAA;AA6SF;;AA1SA;EACE,qDAAA;AA6SF;;AA1SA;EACE,wDAAA;AA6SF;;AA1SA;EACE,uDAAA;AA6SF;;AA1SA;EACE,sDAAA;AA6SF;;AA1SA;EACE,qDAAA;AA6SF;;AA1SA;EACE,oBAAA;AA6SF;;AA1SA;EACE,sBAAA;AA6SF;;AA1SA;EACE,sBAAA;AA6SF;;AA1SA;EACE,sBAAA;AA6SF;;AA1SA;EACE,sBAAA;AA6SF;;AA1SA;EACE,sBAAA;AA6SF;;AA1SA;EACE,wBAAA;AA6SF;;AA1SA;EACE,yBAAA;AA6SF;;AA1SA;EACE,wBAAA;AA6SF;;AA1SA;EACE,yBAAA;AA6SF;;AA1SA;EACE,sBAAA;AA6SF;;AA1SA;EACE,uBAAA;AA6SF;;AA1SA;EACE,qBAAA;AA6SF;;AA1SA;EACE,qBAAA;AA6SF;;AA1SA;EACE,qBAAA;AA6SF;;AA1SA;EACE,sBAAA;AA6SF;;AA1SA;EACE,sBAAA;AA6SF;;AA1SA;EACE,qBAAA;AA6SF;;AA1SA;EACE,qBAAA;AA6SF;;AA1SA;EACE,qBAAA;AA6SF;;AA1SA;EACE,qBAAA;AA6SF;;AA1SA;EACE,qBAAA;AA6SF;;AA1SA;EACE,qBAAA;AA6SF;;AA1SA;EACE,qBAAA;AA6SF;;AA1SA;EACE,qBAAA;AA6SF;;AA1SA;EACE,qBAAA;AA6SF;;AA1SA;EACE,sBAAA;AA6SF;;AA1SA;EACE,sBAAA;AA6SF;;AA1SA;EACE,sBAAA;AA6SF;;AA1SA;EACE,sBAAA;AA6SF;;AA1SA;EACE,sBAAA;AA6SF;;AA1SA;EACE,sBAAA;AA6SF;;AA1SA;EACE,sBAAA;AA6SF;;AA1SA;EACE,sBAAA;AA6SF;;AA1SA;EACE,sBAAA;AA6SF;;AA1SA;EACE,sBAAA;AA6SF;;AA1SA;EACE,sBAAA;AA6SF;;AA1SA;EACE,sBAAA;AA6SF;;AA1SA;EACE,sBAAA;AA6SF;;AA1SA;EACE,sBAAA;AA6SF;;AA1SA;EACE,sBAAA;AA6SF;;AA1SA;EACE,sBAAA;AA6SF;;AA1SA;EACE,sBAAA;AA6SF;;AA1SA;EACE,sBAAA;AA6SF;;AA1SA;EACE,uBAAA;AA6SF;;AA1SA;EACE,uBAAA;AA6SF;;AA1SA;EACE,uBAAA;AA6SF;;AA1SA;EACE,uBAAA;AA6SF;;AA1SA;EACE,uBAAA;AA6SF;;AA1SA;EACE,uBAAA;AA6SF;;AA1SA;EACE,uBAAA;AA6SF;;AA1SA;EACE,uBAAA;AA6SF;;AA1SA;EACE,uBAAA;AA6SF;;AA1SA;EACE,uBAAA;AA6SF;;AA1SA;EACE,uBAAA;AA6SF;;AA1SA;EACE,uBAAA;AA6SF;;AA1SA;EACE,uBAAA;AA6SF;;AA1SA;EACE,uBAAA;AA6SF;;AA1SA;EACE,uBAAA;AA6SF;;AA1SA;EACE,uBAAA;AA6SF;;AA1SA;EACE,uBAAA;AA6SF;;AA1SA;EACE,uBAAA;AA6SF;;AA1SA;EACE,uBAAA;AA6SF;;AA1SA;EACE,uBAAA;AA6SF;;AA1SA;EACE,uBAAA;AA6SF;;AA1SA;EACE,uBAAA;AA6SF;;AA1SA;EACE,uBAAA;AA6SF;;AA1SA;EACE,uBAAA;AA6SF;;AA1SA;EACE,uBAAA;AA6SF;;AA1SA;EACE,uBAAA;AA6SF;;AA1SA;EACE,wBAAA;AA6SF;;AA1SA;EACE,2BAAA;AA6SF;;AA1SA;EACE,yBAAA;AA6SF;;AA1SA;EACE,yBAAA;AA6SF;;AA1SA;EACE,yBAAA;AA6SF;;AA1SA;EACE,0BAAA;AA6SF;;AA1SA;EACE,0BAAA;AA6SF;;AA1SA;EACE,yBAAA;AA6SF;;AA1SA;EACE,yBAAA;AA6SF;;AA1SA;EACE,yBAAA;AA6SF;;AA1SA;EACE,yBAAA;AA6SF;;AA1SA;EACE,yBAAA;AA6SF;;AA1SA;EACE,yBAAA;AA6SF;;AA1SA;EACE,yBAAA;AA6SF;;AA1SA;EACE,yBAAA;AA6SF;;AA1SA;EACE,yBAAA;AA6SF;;AA1SA;EACE,0BAAA;AA6SF;;AA1SA;EACE,0BAAA;AA6SF;;AA1SA;EACE,0BAAA;AA6SF;;AA1SA;EACE,0BAAA;AA6SF;;AA1SA;EACE,0BAAA;AA6SF;;AA1SA;EACE,0BAAA;AA6SF;;AA1SA;EACE,0BAAA;AA6SF;;AA1SA;EACE,0BAAA;AA6SF;;AA1SA;EACE,0BAAA;AA6SF;;AA1SA;EACE,0BAAA;AA6SF;;AA1SA;EACE,0BAAA;AA6SF;;AA1SA;EACE,0BAAA;AA6SF;;AA1SA;EACE,0BAAA;AA6SF;;AA1SA;EACE,0BAAA;AA6SF;;AA1SA;EACE,0BAAA;AA6SF;;AA1SA;EACE,0BAAA;AA6SF;;AA1SA;EACE,0BAAA;AA6SF;;AA1SA;EACE,0BAAA;AA6SF;;AA1SA;EACE,2BAAA;AA6SF;;AA1SA;EACE,2BAAA;AA6SF;;AA1SA;EACE,2BAAA;AA6SF;;AA1SA;EACE,2BAAA;AA6SF;;AA1SA;EACE,2BAAA;AA6SF;;AA1SA;EACE,2BAAA;AA6SF;;AA1SA;EACE,2BAAA;AA6SF;;AA1SA;EACE,2BAAA;AA6SF;;AA1SA;EACE,2BAAA;AA6SF;;AA1SA;EACE,2BAAA;AA6SF;;AA1SA;EACE,2BAAA;AA6SF;;AA1SA;EACE,2BAAA;AA6SF;;AA1SA;EACE,2BAAA;AA6SF;;AA1SA;EACE,2BAAA;AA6SF;;AA1SA;EACE,2BAAA;AA6SF;;AA1SA;EACE,2BAAA;AA6SF;;AA1SA;EACE,2BAAA;AA6SF;;AA1SA;EACE,2BAAA;AA6SF;;AA1SA;EACE,2BAAA;AA6SF;;AA1SA;EACE,2BAAA;AA6SF;;AA1SA;EACE,2BAAA;AA6SF;;AA1SA;EACE,2BAAA;AA6SF;;AA1SA;EACE,2BAAA;AA6SF;;AA1SA;EACE,2BAAA;AA6SF;;AA1SA;EACE,2BAAA;AA6SF;;AA1SA;EACE,2BAAA;AA6SF;;AA1SA;EACE,4BAAA;AA6SF;;AA1SA;EACE,uBAAA;AA6SF;;AA1SA;EACE,2BAAA;AA6SF;;AA1SA;EACE,wBAAA;AA6SF;;AA1SA;EACE,sBAAA;AA6SF;;AA1SA;EACE,sBAAA;AA6SF;;AA1SA;EACE,sBAAA;AA6SF;;AA1SA;EACE,uBAAA;AA6SF;;AA1SA;EACE,uBAAA;AA6SF;;AA1SA;EACE,sBAAA;AA6SF;;AA1SA;EACE,sBAAA;AA6SF;;AA1SA;EACE,sBAAA;AA6SF;;AA1SA;EACE,sBAAA;AA6SF;;AA1SA;EACE,sBAAA;AA6SF;;AA1SA;EACE,sBAAA;AA6SF;;AA1SA;EACE,sBAAA;AA6SF;;AA1SA;EACE,sBAAA;AA6SF;;AA1SA;EACE,sBAAA;AA6SF;;AA1SA;EACE,uBAAA;AA6SF;;AA1SA;EACE,uBAAA;AA6SF;;AA1SA;EACE,uBAAA;AA6SF;;AA1SA;EACE,uBAAA;AA6SF;;AA1SA;EACE,uBAAA;AA6SF;;AA1SA;EACE,uBAAA;AA6SF;;AA1SA;EACE,uBAAA;AA6SF;;AA1SA;EACE,uBAAA;AA6SF;;AA1SA;EACE,uBAAA;AA6SF;;AA1SA;EACE,uBAAA;AA6SF;;AA1SA;EACE,uBAAA;AA6SF;;AA1SA;EACE,uBAAA;AA6SF;;AA1SA;EACE,uBAAA;AA6SF;;AA1SA;EACE,uBAAA;AA6SF;;AA1SA;EACE,uBAAA;AA6SF;;AA1SA;EACE,uBAAA;AA6SF;;AA1SA;EACE,uBAAA;AA6SF;;AA1SA;EACE,uBAAA;AA6SF;;AA1SA;EACE,wBAAA;AA6SF;;AA1SA;EACE,wBAAA;AA6SF;;AA1SA;EACE,wBAAA;AA6SF;;AA1SA;EACE,wBAAA;AA6SF;;AA1SA;EACE,wBAAA;AA6SF;;AA1SA;EACE,wBAAA;AA6SF;;AA1SA;EACE,wBAAA;AA6SF;;AA1SA;EACE,wBAAA;AA6SF;;AA1SA;EACE,wBAAA;AA6SF;;AA1SA;EACE,wBAAA;AA6SF;;AA1SA;EACE,wBAAA;AA6SF;;AA1SA;EACE,wBAAA;AA6SF;;AA1SA;EACE,wBAAA;AA6SF;;AA1SA;EACE,wBAAA;AA6SF;;AA1SA;EACE,wBAAA;AA6SF;;AA1SA;EACE,wBAAA;AA6SF;;AA1SA;EACE,wBAAA;AA6SF;;AA1SA;EACE,wBAAA;AA6SF;;AA1SA;EACE,wBAAA;AA6SF;;AA1SA;EACE,wBAAA;AA6SF;;AA1SA;EACE,wBAAA;AA6SF;;AA1SA;EACE,wBAAA;AA6SF;;AA1SA;EACE,wBAAA;AA6SF;;AA1SA;EACE,wBAAA;AA6SF;;AA1SA;EACE,wBAAA;AA6SF;;AA1SA;EACE,wBAAA;AA6SF;;AA1SA;EACE,yBAAA;AA6SF;;AA1SA;EACE,4BAAA;AA6SF;;AA1SA;EACE,0BAAA;AA6SF;;AA1SA;EACE,0BAAA;AA6SF;;AA1SA;EACE,0BAAA;AA6SF;;AA1SA;EACE,2BAAA;AA6SF;;AA1SA;EACE,2BAAA;AA6SF;;AA1SA;EACE,0BAAA;AA6SF;;AA1SA;EACE,0BAAA;AA6SF;;AA1SA;EACE,0BAAA;AA6SF;;AA1SA;EACE,0BAAA;AA6SF;;AA1SA;EACE,0BAAA;AA6SF;;AA1SA;EACE,0BAAA;AA6SF;;AA1SA;EACE,0BAAA;AA6SF;;AA1SA;EACE,0BAAA;AA6SF;;AA1SA;EACE,0BAAA;AA6SF;;AA1SA;EACE,2BAAA;AA6SF;;AA1SA;EACE,2BAAA;AA6SF;;AA1SA;EACE,2BAAA;AA6SF;;AA1SA;EACE,2BAAA;AA6SF;;AA1SA;EACE,2BAAA;AA6SF;;AA1SA;EACE,2BAAA;AA6SF;;AA1SA;EACE,2BAAA;AA6SF;;AA1SA;EACE,2BAAA;AA6SF;;AA1SA;EACE,2BAAA;AA6SF;;AA1SA;EACE,2BAAA;AA6SF;;AA1SA;EACE,2BAAA;AA6SF;;AA1SA;EACE,2BAAA;AA6SF;;AA1SA;EACE,2BAAA;AA6SF;;AA1SA;EACE,2BAAA;AA6SF;;AA1SA;EACE,2BAAA;AA6SF;;AA1SA;EACE,2BAAA;AA6SF;;AA1SA;EACE,2BAAA;AA6SF;;AA1SA;EACE,2BAAA;AA6SF;;AA1SA;EACE,4BAAA;AA6SF;;AA1SA;EACE,4BAAA;AA6SF;;AA1SA;EACE,4BAAA;AA6SF;;AA1SA;EACE,4BAAA;AA6SF;;AA1SA;EACE,4BAAA;AA6SF;;AA1SA;EACE,4BAAA;AA6SF;;AA1SA;EACE,4BAAA;AA6SF;;AA1SA;EACE,4BAAA;AA6SF;;AA1SA;EACE,4BAAA;AA6SF;;AA1SA;EACE,4BAAA;AA6SF;;AA1SA;EACE,4BAAA;AA6SF;;AA1SA;EACE,4BAAA;AA6SF;;AA1SA;EACE,4BAAA;AA6SF;;AA1SA;EACE,4BAAA;AA6SF;;AA1SA;EACE,4BAAA;AA6SF;;AA1SA;EACE,4BAAA;AA6SF;;AA1SA;EACE,4BAAA;AA6SF;;AA1SA;EACE,4BAAA;AA6SF;;AA1SA;EACE,4BAAA;AA6SF;;AA1SA;EACE,4BAAA;AA6SF;;AA1SA;EACE,4BAAA;AA6SF;;AA1SA;EACE,4BAAA;AA6SF;;AA1SA;EACE,4BAAA;AA6SF;;AA1SA;EACE,4BAAA;AA6SF;;AA1SA;EACE,4BAAA;AA6SF;;AA1SA;EACE,4BAAA;AA6SF;;AA1SA;EACE,6BAAA;AA6SF;;AA1SA;EACE,wBAAA;AA6SF;;AA1SA;EACE,4BAAA;AA6SF;;AA1SA;EACE,yBAAA;AA6SF;;AA1SA;EACE,8BAAA;AA6SF;;AA1SA;EACE,iCAAA;AA6SF;;AA1SA;EACE,sCAAA;AA6SF;;AA1SA;EACE,yCAAA;AA6SF;;AA1SA;EACE,uBAAA;AA6SF;;AA1SA;EACE,uBAAA;AA6SF;;AA1SA;EACE,yBAAA;AA6SF;;AA1SA;EACE,yBAAA;AA6SF;;AA1SA;EACE,0BAAA;AA6SF;;AA1SA;EACE,4BAAA;AA6SF;;AA1SA;EACE,kCAAA;AA6SF;;AA1SA;EACE,sCAAA;AA6SF;;AA1SA;EACE,oCAAA;AA6SF;;AA1SA;EACE,kCAAA;AA6SF;;AA1SA;EACE,yCAAA;AA6SF;;AA1SA;EACE,wCAAA;AA6SF;;AA1SA;EACE,wCAAA;AA6SF;;AA1SA;EACE,kCAAA;AA6SF;;AA1SA;EACE,gCAAA;AA6SF;;AA1SA;EACE,8BAAA;AA6SF;;AA1SA;EACE,gCAAA;AA6SF;;AA1SA;EACE,+BAAA;AA6SF;;AA1SA;EACE,oCAAA;AA6SF;;AA1SA;EACE,kCAAA;AA6SF;;AA1SA;EACE,gCAAA;AA6SF;;AA1SA;EACE,uCAAA;AA6SF;;AA1SA;EACE,sCAAA;AA6SF;;AA1SA;EACE,iCAAA;AA6SF;;AA1SA;EACE,2BAAA;AA6SF;;AA1SA;EACE,iCAAA;AA6SF;;AA1SA;EACE,+BAAA;AA6SF;;AA1SA;EACE,6BAAA;AA6SF;;AA1SA;EACE,+BAAA;AA6SF;;AA1SA;EACE,8BAAA;AA6SF;;AA1SA;EACE,oBAAA;AA6SF;;AA1SA;EACE,mBAAA;AA6SF;;AA1SA;EACE,mBAAA;AA6SF;;AA1SA;EACE,mBAAA;AA6SF;;AA1SA;EACE,mBAAA;AA6SF;;AA1SA;EACE,mBAAA;AA6SF;;AA1SA;EACE,mBAAA;AA6SF;;AA1SA;EACE,mBAAA;AA6SF;;AA1SA;EACE,oBAAA;AA6SF;;AA1SA;EACE,0BAAA;AA6SF;;AA1SA;EACE,yBAAA;AA6SF;;AA1SA;EACE,0BAAA;AA6SF;;AA1SA;EACE,uBAAA;AA6SF;;AA1SA;EACE,0BAAA;AA6SF;;AA1SA;EACE,yBAAA;AA6SF;;AA1SA;EACE,0BAAA;AA6SF;;AA1SA;EACE,uBAAA;AA6SF;;AA1SA;EACE,0BAAA;AA6SF;;AA1SA;EACE,yBAAA;AA6SF;;AA1SA;EACE,0BAAA;AA6SF;;AA1SA;EACE,uBAAA;AA6SF;;AA1SA;EACE,0BAAA;AA6SF;;AA1SA;EACE,yBAAA;AA6SF;;AA1SA;EACE,0BAAA;AA6SF;;AA1SA;EACE,uBAAA;AA6SF;;AA1SA;EACE,0BAAA;AA6SF;;AA1SA;EACE,yBAAA;AA6SF;;AA1SA;EACE,0BAAA;AA6SF;;AA1SA;EACE,uBAAA;AA6SF;;AA1SA;EACE,uBAAA;AA6SF;;AA1SA;EACE,0BAAA;EACA,yBAAA;AA6SF;;AA1SA;EACE,gCAAA;EACA,+BAAA;AA6SF;;AA1SA;EACE,+BAAA;EACA,8BAAA;AA6SF;;AA1SA;EACE,gCAAA;EACA,+BAAA;AA6SF;;AA1SA;EACE,6BAAA;EACA,4BAAA;AA6SF;;AA1SA;EACE,gCAAA;EACA,+BAAA;AA6SF;;AA1SA;EACE,+BAAA;EACA,8BAAA;AA6SF;;AA1SA;EACE,gCAAA;EACA,+BAAA;AA6SF;;AA1SA;EACE,6BAAA;EACA,4BAAA;AA6SF;;AA1SA;EACE,gCAAA;EACA,+BAAA;AA6SF;;AA1SA;EACE,+BAAA;EACA,8BAAA;AA6SF;;AA1SA;EACE,gCAAA;EACA,+BAAA;AA6SF;;AA1SA;EACE,6BAAA;EACA,4BAAA;AA6SF;;AA1SA;EACE,gCAAA;EACA,+BAAA;AA6SF;;AA1SA;EACE,+BAAA;EACA,8BAAA;AA6SF;;AA1SA;EACE,gCAAA;EACA,+BAAA;AA6SF;;AA1SA;EACE,6BAAA;EACA,4BAAA;AA6SF;;AA1SA;EACE,gCAAA;EACA,+BAAA;AA6SF;;AA1SA;EACE,+BAAA;EACA,8BAAA;AA6SF;;AA1SA;EACE,gCAAA;EACA,+BAAA;AA6SF;;AA1SA;EACE,6BAAA;EACA,4BAAA;AA6SF;;AA1SA;EACE,6BAAA;EACA,4BAAA;AA6SF;;AA1SA;EACE,wBAAA;EACA,2BAAA;AA6SF;;AA1SA;EACE,8BAAA;EACA,iCAAA;AA6SF;;AA1SA;EACE,6BAAA;EACA,gCAAA;AA6SF;;AA1SA;EACE,8BAAA;EACA,iCAAA;AA6SF;;AA1SA;EACE,2BAAA;EACA,8BAAA;AA6SF;;AA1SA;EACE,8BAAA;EACA,iCAAA;AA6SF;;AA1SA;EACE,6BAAA;EACA,gCAAA;AA6SF;;AA1SA;EACE,8BAAA;EACA,iCAAA;AA6SF;;AA1SA;EACE,2BAAA;EACA,8BAAA;AA6SF;;AA1SA;EACE,8BAAA;EACA,iCAAA;AA6SF;;AA1SA;EACE,6BAAA;EACA,gCAAA;AA6SF;;AA1SA;EACE,8BAAA;EACA,iCAAA;AA6SF;;AA1SA;EACE,2BAAA;EACA,8BAAA;AA6SF;;AA1SA;EACE,8BAAA;EACA,iCAAA;AA6SF;;AA1SA;EACE,6BAAA;EACA,gCAAA;AA6SF;;AA1SA;EACE,8BAAA;EACA,iCAAA;AA6SF;;AA1SA;EACE,2BAAA;EACA,8BAAA;AA6SF;;AA1SA;EACE,8BAAA;EACA,iCAAA;AA6SF;;AA1SA;EACE,6BAAA;EACA,gCAAA;AA6SF;;AA1SA;EACE,8BAAA;EACA,iCAAA;AA6SF;;AA1SA;EACE,2BAAA;EACA,8BAAA;AA6SF;;AA1SA;EACE,2BAAA;EACA,8BAAA;AA6SF;;AA1SA;EACE,wBAAA;AA6SF;;AA1SA;EACE,8BAAA;AA6SF;;AA1SA;EACE,6BAAA;AA6SF;;AA1SA;EACE,8BAAA;AA6SF;;AA1SA;EACE,2BAAA;AA6SF;;AA1SA;EACE,8BAAA;AA6SF;;AA1SA;EACE,6BAAA;AA6SF;;AA1SA;EACE,8BAAA;AA6SF;;AA1SA;EACE,2BAAA;AA6SF;;AA1SA;EACE,8BAAA;AA6SF;;AA1SA;EACE,6BAAA;AA6SF;;AA1SA;EACE,8BAAA;AA6SF;;AA1SA;EACE,2BAAA;AA6SF;;AA1SA;EACE,8BAAA;AA6SF;;AA1SA;EACE,6BAAA;AA6SF;;AA1SA;EACE,8BAAA;AA6SF;;AA1SA;EACE,2BAAA;AA6SF;;AA1SA;EACE,8BAAA;AA6SF;;AA1SA;EACE,6BAAA;AA6SF;;AA1SA;EACE,8BAAA;AA6SF;;AA1SA;EACE,2BAAA;AA6SF;;AA1SA;EACE,2BAAA;AA6SF;;AA1SA;EACE,0BAAA;AA6SF;;AA1SA;EACE,gCAAA;AA6SF;;AA1SA;EACE,+BAAA;AA6SF;;AA1SA;EACE,gCAAA;AA6SF;;AA1SA;EACE,6BAAA;AA6SF;;AA1SA;EACE,gCAAA;AA6SF;;AA1SA;EACE,+BAAA;AA6SF;;AA1SA;EACE,gCAAA;AA6SF;;AA1SA;EACE,6BAAA;AA6SF;;AA1SA;EACE,gCAAA;AA6SF;;AA1SA;EACE,+BAAA;AA6SF;;AA1SA;EACE,gCAAA;AA6SF;;AA1SA;EACE,6BAAA;AA6SF;;AA1SA;EACE,gCAAA;AA6SF;;AA1SA;EACE,+BAAA;AA6SF;;AA1SA;EACE,gCAAA;AA6SF;;AA1SA;EACE,6BAAA;AA6SF;;AA1SA;EACE,gCAAA;AA6SF;;AA1SA;EACE,+BAAA;AA6SF;;AA1SA;EACE,gCAAA;AA6SF;;AA1SA;EACE,6BAAA;AA6SF;;AA1SA;EACE,6BAAA;AA6SF;;AA1SA;EACE,2BAAA;AA6SF;;AA1SA;EACE,iCAAA;AA6SF;;AA1SA;EACE,gCAAA;AA6SF;;AA1SA;EACE,iCAAA;AA6SF;;AA1SA;EACE,8BAAA;AA6SF;;AA1SA;EACE,iCAAA;AA6SF;;AA1SA;EACE,gCAAA;AA6SF;;AA1SA;EACE,iCAAA;AA6SF;;AA1SA;EACE,8BAAA;AA6SF;;AA1SA;EACE,iCAAA;AA6SF;;AA1SA;EACE,gCAAA;AA6SF;;AA1SA;EACE,iCAAA;AA6SF;;AA1SA;EACE,8BAAA;AA6SF;;AA1SA;EACE,iCAAA;AA6SF;;AA1SA;EACE,gCAAA;AA6SF;;AA1SA;EACE,iCAAA;AA6SF;;AA1SA;EACE,8BAAA;AA6SF;;AA1SA;EACE,iCAAA;AA6SF;;AA1SA;EACE,gCAAA;AA6SF;;AA1SA;EACE,iCAAA;AA6SF;;AA1SA;EACE,8BAAA;AA6SF;;AA1SA;EACE,8BAAA;AA6SF;;AA1SA;EACE,yBAAA;AA6SF;;AA1SA;EACE,+BAAA;AA6SF;;AA1SA;EACE,8BAAA;AA6SF;;AA1SA;EACE,+BAAA;AA6SF;;AA1SA;EACE,4BAAA;AA6SF;;AA1SA;EACE,+BAAA;AA6SF;;AA1SA;EACE,8BAAA;AA6SF;;AA1SA;EACE,+BAAA;AA6SF;;AA1SA;EACE,4BAAA;AA6SF;;AA1SA;EACE,+BAAA;AA6SF;;AA1SA;EACE,8BAAA;AA6SF;;AA1SA;EACE,+BAAA;AA6SF;;AA1SA;EACE,4BAAA;AA6SF;;AA1SA;EACE,+BAAA;AA6SF;;AA1SA;EACE,8BAAA;AA6SF;;AA1SA;EACE,+BAAA;AA6SF;;AA1SA;EACE,4BAAA;AA6SF;;AA1SA;EACE,+BAAA;AA6SF;;AA1SA;EACE,8BAAA;AA6SF;;AA1SA;EACE,+BAAA;AA6SF;;AA1SA;EACE,4BAAA;AA6SF;;AA1SA;EACE,4BAAA;AA6SF;;AA1SA;EACE,2BAAA;AA6SF;;AA1SA;EACE,0BAAA;AA6SF;;AA1SA;EACE,2BAAA;AA6SF;;AA1SA;EACE,wBAAA;AA6SF;;AA1SA;EACE,2BAAA;AA6SF;;AA1SA;EACE,0BAAA;AA6SF;;AA1SA;EACE,2BAAA;AA6SF;;AA1SA;EACE,wBAAA;AA6SF;;AA1SA;EACE,2BAAA;AA6SF;;AA1SA;EACE,0BAAA;AA6SF;;AA1SA;EACE,2BAAA;AA6SF;;AA1SA;EACE,wBAAA;AA6SF;;AA1SA;EACE,2BAAA;AA6SF;;AA1SA;EACE,0BAAA;AA6SF;;AA1SA;EACE,2BAAA;AA6SF;;AA1SA;EACE,wBAAA;AA6SF;;AA1SA;EACE,2BAAA;AA6SF;;AA1SA;EACE,0BAAA;AA6SF;;AA1SA;EACE,2BAAA;AA6SF;;AA1SA;EACE,wBAAA;AA6SF;;AA1SA;EACE,iCAAA;EACA,gCAAA;AA6SF;;AA1SA;EACE,gCAAA;EACA,+BAAA;AA6SF;;AA1SA;EACE,iCAAA;EACA,gCAAA;AA6SF;;AA1SA;EACE,8BAAA;EACA,6BAAA;AA6SF;;AA1SA;EACE,iCAAA;EACA,gCAAA;AA6SF;;AA1SA;EACE,gCAAA;EACA,+BAAA;AA6SF;;AA1SA;EACE,iCAAA;EACA,gCAAA;AA6SF;;AA1SA;EACE,8BAAA;EACA,6BAAA;AA6SF;;AA1SA;EACE,iCAAA;EACA,gCAAA;AA6SF;;AA1SA;EACE,gCAAA;EACA,+BAAA;AA6SF;;AA1SA;EACE,iCAAA;EACA,gCAAA;AA6SF;;AA1SA;EACE,8BAAA;EACA,6BAAA;AA6SF;;AA1SA;EACE,iCAAA;EACA,gCAAA;AA6SF;;AA1SA;EACE,gCAAA;EACA,+BAAA;AA6SF;;AA1SA;EACE,iCAAA;EACA,gCAAA;AA6SF;;AA1SA;EACE,8BAAA;EACA,6BAAA;AA6SF;;AA1SA;EACE,iCAAA;EACA,gCAAA;AA6SF;;AA1SA;EACE,gCAAA;EACA,+BAAA;AA6SF;;AA1SA;EACE,iCAAA;EACA,gCAAA;AA6SF;;AA1SA;EACE,8BAAA;EACA,6BAAA;AA6SF;;AA1SA;EACE,+BAAA;EACA,kCAAA;AA6SF;;AA1SA;EACE,8BAAA;EACA,iCAAA;AA6SF;;AA1SA;EACE,+BAAA;EACA,kCAAA;AA6SF;;AA1SA;EACE,4BAAA;EACA,+BAAA;AA6SF;;AA1SA;EACE,+BAAA;EACA,kCAAA;AA6SF;;AA1SA;EACE,8BAAA;EACA,iCAAA;AA6SF;;AA1SA;EACE,+BAAA;EACA,kCAAA;AA6SF;;AA1SA;EACE,4BAAA;EACA,+BAAA;AA6SF;;AA1SA;EACE,+BAAA;EACA,kCAAA;AA6SF;;AA1SA;EACE,8BAAA;EACA,iCAAA;AA6SF;;AA1SA;EACE,+BAAA;EACA,kCAAA;AA6SF;;AA1SA;EACE,4BAAA;EACA,+BAAA;AA6SF;;AA1SA;EACE,+BAAA;EACA,kCAAA;AA6SF;;AA1SA;EACE,8BAAA;EACA,iCAAA;AA6SF;;AA1SA;EACE,+BAAA;EACA,kCAAA;AA6SF;;AA1SA;EACE,4BAAA;EACA,+BAAA;AA6SF;;AA1SA;EACE,+BAAA;EACA,kCAAA;AA6SF;;AA1SA;EACE,8BAAA;EACA,iCAAA;AA6SF;;AA1SA;EACE,+BAAA;EACA,kCAAA;AA6SF;;AA1SA;EACE,4BAAA;EACA,+BAAA;AA6SF;;AA1SA;EACE,+BAAA;AA6SF;;AA1SA;EACE,8BAAA;AA6SF;;AA1SA;EACE,+BAAA;AA6SF;;AA1SA;EACE,4BAAA;AA6SF;;AA1SA;EACE,+BAAA;AA6SF;;AA1SA;EACE,8BAAA;AA6SF;;AA1SA;EACE,+BAAA;AA6SF;;AA1SA;EACE,4BAAA;AA6SF;;AA1SA;EACE,+BAAA;AA6SF;;AA1SA;EACE,8BAAA;AA6SF;;AA1SA;EACE,+BAAA;AA6SF;;AA1SA;EACE,4BAAA;AA6SF;;AA1SA;EACE,+BAAA;AA6SF;;AA1SA;EACE,8BAAA;AA6SF;;AA1SA;EACE,+BAAA;AA6SF;;AA1SA;EACE,4BAAA;AA6SF;;AA1SA;EACE,+BAAA;AA6SF;;AA1SA;EACE,8BAAA;AA6SF;;AA1SA;EACE,+BAAA;AA6SF;;AA1SA;EACE,4BAAA;AA6SF;;AA1SA;EACE,iCAAA;AA6SF;;AA1SA;EACE,gCAAA;AA6SF;;AA1SA;EACE,iCAAA;AA6SF;;AA1SA;EACE,8BAAA;AA6SF;;AA1SA;EACE,iCAAA;AA6SF;;AA1SA;EACE,gCAAA;AA6SF;;AA1SA;EACE,iCAAA;AA6SF;;AA1SA;EACE,8BAAA;AA6SF;;AA1SA;EACE,iCAAA;AA6SF;;AA1SA;EACE,gCAAA;AA6SF;;AA1SA;EACE,iCAAA;AA6SF;;AA1SA;EACE,8BAAA;AA6SF;;AA1SA;EACE,iCAAA;AA6SF;;AA1SA;EACE,gCAAA;AA6SF;;AA1SA;EACE,iCAAA;AA6SF;;AA1SA;EACE,8BAAA;AA6SF;;AA1SA;EACE,iCAAA;AA6SF;;AA1SA;EACE,gCAAA;AA6SF;;AA1SA;EACE,iCAAA;AA6SF;;AA1SA;EACE,8BAAA;AA6SF;;AA1SA;EACE,kCAAA;AA6SF;;AA1SA;EACE,iCAAA;AA6SF;;AA1SA;EACE,kCAAA;AA6SF;;AA1SA;EACE,+BAAA;AA6SF;;AA1SA;EACE,kCAAA;AA6SF;;AA1SA;EACE,iCAAA;AA6SF;;AA1SA;EACE,kCAAA;AA6SF;;AA1SA;EACE,+BAAA;AA6SF;;AA1SA;EACE,kCAAA;AA6SF;;AA1SA;EACE,iCAAA;AA6SF;;AA1SA;EACE,kCAAA;AA6SF;;AA1SA;EACE,+BAAA;AA6SF;;AA1SA;EACE,kCAAA;AA6SF;;AA1SA;EACE,iCAAA;AA6SF;;AA1SA;EACE,kCAAA;AA6SF;;AA1SA;EACE,+BAAA;AA6SF;;AA1SA;EACE,kCAAA;AA6SF;;AA1SA;EACE,iCAAA;AA6SF;;AA1SA;EACE,kCAAA;AA6SF;;AA1SA;EACE,+BAAA;AA6SF;;AA1SA;EACE,gCAAA;AA6SF;;AA1SA;EACE,+BAAA;AA6SF;;AA1SA;EACE,gCAAA;AA6SF;;AA1SA;EACE,6BAAA;AA6SF;;AA1SA;EACE,gCAAA;AA6SF;;AA1SA;EACE,+BAAA;AA6SF;;AA1SA;EACE,gCAAA;AA6SF;;AA1SA;EACE,6BAAA;AA6SF;;AA1SA;EACE,gCAAA;AA6SF;;AA1SA;EACE,+BAAA;AA6SF;;AA1SA;EACE,gCAAA;AA6SF;;AA1SA;EACE,6BAAA;AA6SF;;AA1SA;EACE,gCAAA;AA6SF;;AA1SA;EACE,+BAAA;AA6SF;;AA1SA;EACE,gCAAA;AA6SF;;AA1SA;EACE,6BAAA;AA6SF;;AA1SA;EACE,gCAAA;AA6SF;;AA1SA;EACE,+BAAA;AA6SF;;AA1SA;EACE,gCAAA;AA6SF;;AA1SA;EACE,6BAAA;AA6SF;;AA1SA;EACE,qBAAA;AA6SF;;AA1SA;EACE,2BAAA;AA6SF;;AA1SA;EACE,0BAAA;AA6SF;;AA1SA;EACE,2BAAA;AA6SF;;AA1SA;EACE,wBAAA;AA6SF;;AA1SA;EACE,2BAAA;AA6SF;;AA1SA;EACE,0BAAA;AA6SF;;AA1SA;EACE,2BAAA;AA6SF;;AA1SA;EACE,wBAAA;AA6SF;;AA1SA;EACE,2BAAA;AA6SF;;AA1SA;EACE,0BAAA;AA6SF;;AA1SA;EACE,2BAAA;AA6SF;;AA1SA;EACE,wBAAA;AA6SF;;AA1SA;EACE,2BAAA;AA6SF;;AA1SA;EACE,0BAAA;AA6SF;;AA1SA;EACE,2BAAA;AA6SF;;AA1SA;EACE,wBAAA;AA6SF;;AA1SA;EACE,2BAAA;AA6SF;;AA1SA;EACE,0BAAA;AA6SF;;AA1SA;EACE,2BAAA;AA6SF;;AA1SA;EACE,wBAAA;AA6SF;;AA1SA;EACE,2BAAA;EACA,0BAAA;AA6SF;;AA1SA;EACE,iCAAA;EACA,gCAAA;AA6SF;;AA1SA;EACE,gCAAA;EACA,+BAAA;AA6SF;;AA1SA;EACE,iCAAA;EACA,gCAAA;AA6SF;;AA1SA;EACE,8BAAA;EACA,6BAAA;AA6SF;;AA1SA;EACE,iCAAA;EACA,gCAAA;AA6SF;;AA1SA;EACE,gCAAA;EACA,+BAAA;AA6SF;;AA1SA;EACE,iCAAA;EACA,gCAAA;AA6SF;;AA1SA;EACE,8BAAA;EACA,6BAAA;AA6SF;;AA1SA;EACE,iCAAA;EACA,gCAAA;AA6SF;;AA1SA;EACE,gCAAA;EACA,+BAAA;AA6SF;;AA1SA;EACE,iCAAA;EACA,gCAAA;AA6SF;;AA1SA;EACE,8BAAA;EACA,6BAAA;AA6SF;;AA1SA;EACE,iCAAA;EACA,gCAAA;AA6SF;;AA1SA;EACE,gCAAA;EACA,+BAAA;AA6SF;;AA1SA;EACE,iCAAA;EACA,gCAAA;AA6SF;;AA1SA;EACE,8BAAA;EACA,6BAAA;AA6SF;;AA1SA;EACE,iCAAA;EACA,gCAAA;AA6SF;;AA1SA;EACE,gCAAA;EACA,+BAAA;AA6SF;;AA1SA;EACE,iCAAA;EACA,gCAAA;AA6SF;;AA1SA;EACE,8BAAA;EACA,6BAAA;AA6SF;;AA1SA;EACE,yBAAA;EACA,4BAAA;AA6SF;;AA1SA;EACE,+BAAA;EACA,kCAAA;AA6SF;;AA1SA;EACE,8BAAA;EACA,iCAAA;AA6SF;;AA1SA;EACE,+BAAA;EACA,kCAAA;AA6SF;;AA1SA;EACE,4BAAA;EACA,+BAAA;AA6SF;;AA1SA;EACE,+BAAA;EACA,kCAAA;AA6SF;;AA1SA;EACE,8BAAA;EACA,iCAAA;AA6SF;;AA1SA;EACE,+BAAA;EACA,kCAAA;AA6SF;;AA1SA;EACE,4BAAA;EACA,+BAAA;AA6SF;;AA1SA;EACE,+BAAA;EACA,kCAAA;AA6SF;;AA1SA;EACE,8BAAA;EACA,iCAAA;AA6SF;;AA1SA;EACE,+BAAA;EACA,kCAAA;AA6SF;;AA1SA;EACE,4BAAA;EACA,+BAAA;AA6SF;;AA1SA;EACE,+BAAA;EACA,kCAAA;AA6SF;;AA1SA;EACE,8BAAA;EACA,iCAAA;AA6SF;;AA1SA;EACE,+BAAA;EACA,kCAAA;AA6SF;;AA1SA;EACE,4BAAA;EACA,+BAAA;AA6SF;;AA1SA;EACE,+BAAA;EACA,kCAAA;AA6SF;;AA1SA;EACE,8BAAA;EACA,iCAAA;AA6SF;;AA1SA;EACE,+BAAA;EACA,kCAAA;AA6SF;;AA1SA;EACE,4BAAA;EACA,+BAAA;AA6SF;;AA1SA;EACE,yBAAA;AA6SF;;AA1SA;EACE,+BAAA;AA6SF;;AA1SA;EACE,8BAAA;AA6SF;;AA1SA;EACE,+BAAA;AA6SF;;AA1SA;EACE,4BAAA;AA6SF;;AA1SA;EACE,+BAAA;AA6SF;;AA1SA;EACE,8BAAA;AA6SF;;AA1SA;EACE,+BAAA;AA6SF;;AA1SA;EACE,4BAAA;AA6SF;;AA1SA;EACE,+BAAA;AA6SF;;AA1SA;EACE,8BAAA;AA6SF;;AA1SA;EACE,+BAAA;AA6SF;;AA1SA;EACE,4BAAA;AA6SF;;AA1SA;EACE,+BAAA;AA6SF;;AA1SA;EACE,8BAAA;AA6SF;;AA1SA;EACE,+BAAA;AA6SF;;AA1SA;EACE,4BAAA;AA6SF;;AA1SA;EACE,+BAAA;AA6SF;;AA1SA;EACE,8BAAA;AA6SF;;AA1SA;EACE,+BAAA;AA6SF;;AA1SA;EACE,4BAAA;AA6SF;;AA1SA;EACE,2BAAA;AA6SF;;AA1SA;EACE,iCAAA;AA6SF;;AA1SA;EACE,gCAAA;AA6SF;;AA1SA;EACE,iCAAA;AA6SF;;AA1SA;EACE,8BAAA;AA6SF;;AA1SA;EACE,iCAAA;AA6SF;;AA1SA;EACE,gCAAA;AA6SF;;AA1SA;EACE,iCAAA;AA6SF;;AA1SA;EACE,8BAAA;AA6SF;;AA1SA;EACE,iCAAA;AA6SF;;AA1SA;EACE,gCAAA;AA6SF;;AA1SA;EACE,iCAAA;AA6SF;;AA1SA;EACE,8BAAA;AA6SF;;AA1SA;EACE,iCAAA;AA6SF;;AA1SA;EACE,gCAAA;AA6SF;;AA1SA;EACE,iCAAA;AA6SF;;AA1SA;EACE,8BAAA;AA6SF;;AA1SA;EACE,iCAAA;AA6SF;;AA1SA;EACE,gCAAA;AA6SF;;AA1SA;EACE,iCAAA;AA6SF;;AA1SA;EACE,8BAAA;AA6SF;;AA1SA;EACE,4BAAA;AA6SF;;AA1SA;EACE,kCAAA;AA6SF;;AA1SA;EACE,iCAAA;AA6SF;;AA1SA;EACE,kCAAA;AA6SF;;AA1SA;EACE,+BAAA;AA6SF;;AA1SA;EACE,kCAAA;AA6SF;;AA1SA;EACE,iCAAA;AA6SF;;AA1SA;EACE,kCAAA;AA6SF;;AA1SA;EACE,+BAAA;AA6SF;;AA1SA;EACE,kCAAA;AA6SF;;AA1SA;EACE,iCAAA;AA6SF;;AA1SA;EACE,kCAAA;AA6SF;;AA1SA;EACE,+BAAA;AA6SF;;AA1SA;EACE,kCAAA;AA6SF;;AA1SA;EACE,iCAAA;AA6SF;;AA1SA;EACE,kCAAA;AA6SF;;AA1SA;EACE,+BAAA;AA6SF;;AA1SA;EACE,kCAAA;AA6SF;;AA1SA;EACE,iCAAA;AA6SF;;AA1SA;EACE,kCAAA;AA6SF;;AA1SA;EACE,+BAAA;AA6SF;;AA1SA;EACE,0BAAA;AA6SF;;AA1SA;EACE,gCAAA;AA6SF;;AA1SA;EACE,+BAAA;AA6SF;;AA1SA;EACE,gCAAA;AA6SF;;AA1SA;EACE,6BAAA;AA6SF;;AA1SA;EACE,gCAAA;AA6SF;;AA1SA;EACE,+BAAA;AA6SF;;AA1SA;EACE,gCAAA;AA6SF;;AA1SA;EACE,6BAAA;AA6SF;;AA1SA;EACE,gCAAA;AA6SF;;AA1SA;EACE,+BAAA;AA6SF;;AA1SA;EACE,gCAAA;AA6SF;;AA1SA;EACE,6BAAA;AA6SF;;AA1SA;EACE,gCAAA;AA6SF;;AA1SA;EACE,+BAAA;AA6SF;;AA1SA;EACE,gCAAA;AA6SF;;AA1SA;EACE,6BAAA;AA6SF;;AA1SA;EACE,gCAAA;AA6SF;;AA1SA;EACE,+BAAA;AA6SF;;AA1SA;EACE,gCAAA;AA6SF;;AA1SA;EACE,6BAAA;AA6SF;;AA1SA;EACE,iBAAA;AA6SF;;AA1SA;EACE,uBAAA;AA6SF;;AA1SA;EACE,sBAAA;AA6SF;;AA1SA;EACE,uBAAA;AA6SF;;AA1SA;EACE,oBAAA;AA6SF;;AA1SA;EACE,uBAAA;AA6SF;;AA1SA;EACE,sBAAA;AA6SF;;AA1SA;EACE,uBAAA;AA6SF;;AA1SA;EACE,oBAAA;AA6SF;;AA1SA;EACE,uBAAA;AA6SF;;AA1SA;EACE,sBAAA;AA6SF;;AA1SA;EACE,uBAAA;AA6SF;;AA1SA;EACE,oBAAA;AA6SF;;AA1SA;EACE,uBAAA;AA6SF;;AA1SA;EACE,sBAAA;AA6SF;;AA1SA;EACE,uBAAA;AA6SF;;AA1SA;EACE,oBAAA;AA6SF;;AA1SA;EACE,uBAAA;AA6SF;;AA1SA;EACE,sBAAA;AA6SF;;AA1SA;EACE,uBAAA;AA6SF;;AA1SA;EACE,oBAAA;AA6SF;;AA1SA;EACE,qBAAA;AA6SF;;AA1SA;EACE,2BAAA;AA6SF;;AA1SA;EACE,0BAAA;AA6SF;;AA1SA;EACE,2BAAA;AA6SF;;AA1SA;EACE,wBAAA;AA6SF;;AA1SA;EACE,2BAAA;AA6SF;;AA1SA;EACE,0BAAA;AA6SF;;AA1SA;EACE,2BAAA;AA6SF;;AA1SA;EACE,wBAAA;AA6SF;;AA1SA;EACE,2BAAA;AA6SF;;AA1SA;EACE,0BAAA;AA6SF;;AA1SA;EACE,2BAAA;AA6SF;;AA1SA;EACE,wBAAA;AA6SF;;AA1SA;EACE,2BAAA;AA6SF;;AA1SA;EACE,0BAAA;AA6SF;;AA1SA;EACE,2BAAA;AA6SF;;AA1SA;EACE,wBAAA;AA6SF;;AA1SA;EACE,2BAAA;AA6SF;;AA1SA;EACE,0BAAA;AA6SF;;AA1SA;EACE,2BAAA;AA6SF;;AA1SA;EACE,wBAAA;AA6SF;;AA1SA;EACE,wBAAA;AA6SF;;AA1SA;EACE,8BAAA;AA6SF;;AA1SA;EACE,6BAAA;AA6SF;;AA1SA;EACE,8BAAA;AA6SF;;AA1SA;EACE,2BAAA;AA6SF;;AA1SA;EACE,8BAAA;AA6SF;;AA1SA;EACE,6BAAA;AA6SF;;AA1SA;EACE,8BAAA;AA6SF;;AA1SA;EACE,2BAAA;AA6SF;;AA1SA;EACE,8BAAA;AA6SF;;AA1SA;EACE,6BAAA;AA6SF;;AA1SA;EACE,8BAAA;AA6SF;;AA1SA;EACE,2BAAA;AA6SF;;AA1SA;EACE,8BAAA;AA6SF;;AA1SA;EACE,6BAAA;AA6SF;;AA1SA;EACE,8BAAA;AA6SF;;AA1SA;EACE,2BAAA;AA6SF;;AA1SA;EACE,8BAAA;AA6SF;;AA1SA;EACE,6BAAA;AA6SF;;AA1SA;EACE,8BAAA;AA6SF;;AA1SA;EACE,2BAAA;AA6SF;;AA1SA;EACE,gDAAA;AA6SF;;AA1SA;EACE,0CAAA;AA6SF;;AA1SA;EACE,4CAAA;AA6SF;;AA1SA;EACE,4CAAA;AA6SF;;AA1SA;EACE,6BAAA;AA6SF;;AA1SA;EACE,6BAAA;AA6SF;;AA1SA;EACE,8BAAA;AA6SF;;AA1SA;EACE,6BAAA;AA6SF;;AA1SA;EACE,6BAAA;AA6SF;;AA1SA;EACE,6BAAA;AA6SF;;AA1SA;EACE,4BAAA;AA6SF;;AA1SA;EACE,0BAAA;AA6SF;;AA1SA;EACE,0BAAA;AA6SF;;AA1SA;EACE,4CAAA;AA6SF;;AA1SA;EACE,2CAAA;AA6SF;;AA1SA;EACE,4CAAA;AA6SF;;AA1SA;EACE,0CAAA;AA6SF;;AA1SA;EACE,4CAAA;AA6SF;;AA1SA;EACE,2CAAA;AA6SF;;AA1SA;EACE,4CAAA;AA6SF;;AA1SA;EACE,wCAAA;AA6SF;;AA1SA;EACE,4CAAA;AA6SF;;AA1SA;EACE,2CAAA;AA6SF;;AA1SA;EACE,4CAAA;AA6SF;;AA1SA;EACE,0CAAA;AA6SF;;AA1SA;EACE,4CAAA;AA6SF;;AA1SA;EACE,2CAAA;AA6SF;;AA1SA;EACE,4CAAA;AA6SF;;AA1SA;EACE,0CAAA;AA6SF;;AA1SA;EACE,4CAAA;AA6SF;;AA1SA;EACE,yCAAA;AA6SF;;AA1SA;EACE,4CAAA;AA6SF;;AA1SA;EACE,0CAAA;AA6SF;;AA1SA;EACE,4CAAA;AA6SF;;AA1SA;EACE,2CAAA;AA6SF;;AA1SA;EACE,4CAAA;AA6SF;;AA1SA;EACE,0CAAA;AA6SF;;AA1SA;EACE,6BAAA;AA6SF;;AA1SA;EACE,6BAAA;AA6SF;;AA1SA;EACE,+BAAA;AA6SF;;AA1SA;EACE,2BAAA;AA6SF;;AA1SA;EACE,2BAAA;AA6SF;;AA1SA;EACE,2BAAA;AA6SF;;AA1SA;EACE,2BAAA;AA6SF;;AA1SA;EACE,2BAAA;AA6SF;;AA1SA;EACE,2BAAA;AA6SF;;AA1SA;EACE,yBAAA;AA6SF;;AA1SA;EACE,yBAAA;AA6SF;;AA1SA;EACE,4BAAA;AA6SF;;AA1SA;EACE,2BAAA;AA6SF;;AA1SA;EACE,4BAAA;AA6SF;;AA1SA;EACE,yBAAA;AA6SF;;AA1SA;EACE,4BAAA;AA6SF;;AA1SA;EACE,2BAAA;AA6SF;;AA1SA;EACE,4BAAA;AA6SF;;AA1SA;EACE,6BAAA;AA6SF;;AA1SA;EACE,gCAAA;AA6SF;;AA1SA;EACE,qCAAA;AA6SF;;AA1SA;EACE,wCAAA;AA6SF;;AA1SA;EACE,oCAAA;AA6SF;;AA1SA;EACE,oCAAA;AA6SF;;AA1SA;EACE,qCAAA;AA6SF;;AA1SA;EACE,8BAAA;AA6SF;;AA1SA;EACE,8BAAA;AA6SF;;AA1SA,qBAAA;AACA;EACE,gCAAA;EACA,iCAAA;AA6SF;;AA1SA,mBAAA;AACA;EACE,oBAAA;EACA,mEAAA;AA6SF;;AA1SA;EACE,oBAAA;EACA,qEAAA;AA6SF;;AA1SA;EACE,oBAAA;EACA,uEAAA;AA6SF;;AA1SA;EACE,oBAAA;EACA,qEAAA;AA6SF;;AA1SA;EACE,oBAAA;EACA,kEAAA;AA6SF;;AA1SA;EACE,oBAAA;EACA,qEAAA;AA6SF;;AA1SA;EACE,oBAAA;EACA,oEAAA;AA6SF;;AA1SA;EACE,oBAAA;EACA,kEAAA;AA6SF;;AA1SA;EACE,oBAAA;EACA,mEAAA;AA6SF;;AA1SA;EACE,oBAAA;EACA,mEAAA;AA6SF;;AA1SA;EACE,oBAAA;EACA,wEAAA;AA6SF;;AA1SA;EACE,oBAAA;EACA,yBAAA;AA6SF;;AA1SA;EACE,oBAAA;EACA,oCAAA;AA6SF;;AA1SA;EACE,oBAAA;EACA,0CAAA;AA6SF;;AA1SA;EACE,oBAAA;EACA,2CAAA;AA6SF;;AA1SA;EACE,oBAAA;EACA,0CAAA;AA6SF;;AA1SA;EACE,oBAAA;EACA,0CAAA;AA6SF;;AA1SA;EACE,oBAAA;EACA,yBAAA;AA6SF;;AA1SA;EACE,uBAAA;AA6SF;;AA1SA;EACE,sBAAA;AA6SF;;AA1SA;EACE,uBAAA;AA6SF;;AA1SA;EACE,oBAAA;AA6SF;;AA1SA;EACE,wCAAA;AA6SF;;AA1SA;EACE,0CAAA;AA6SF;;AA1SA;EACE,wCAAA;AA6SF;;AA1SA;EACE,qCAAA;AA6SF;;AA1SA;EACE,wCAAA;AA6SF;;AA1SA;EACE,uCAAA;AA6SF;;AA1SA;EACE,sCAAA;AA6SF;;AA1SA;EACE,qCAAA;AA6SF;;AA1SA;EACE,kBAAA;EACA,4EAAA;AA6SF;;AA1SA;EACE,kBAAA;EACA,8EAAA;AA6SF;;AA1SA;EACE,kBAAA;EACA,gFAAA;AA6SF;;AA1SA;EACE,kBAAA;EACA,8EAAA;AA6SF;;AA1SA;EACE,kBAAA;EACA,2EAAA;AA6SF;;AA1SA;EACE,kBAAA;EACA,8EAAA;AA6SF;;AA1SA;EACE,kBAAA;EACA,6EAAA;AA6SF;;AA1SA;EACE,kBAAA;EACA,2EAAA;AA6SF;;AA1SA;EACE,kBAAA;EACA,4EAAA;AA6SF;;AA1SA;EACE,kBAAA;EACA,4EAAA;AA6SF;;AA1SA;EACE,kBAAA;EACA,8EAAA;AA6SF;;AA1SA;EACE,kBAAA;EACA,wCAAA;AA6SF;;AA1SA;EACE,kBAAA;EACA,mFAAA;AA6SF;;AA1SA;EACE,kBAAA;EACA,kFAAA;AA6SF;;AA1SA;EACE,kBAAA;EACA,kFAAA;AA6SF;;AA1SA;EACE,oBAAA;AA6SF;;AA1SA;EACE,qBAAA;AA6SF;;AA1SA;EACE,oBAAA;AA6SF;;AA1SA;EACE,qBAAA;AA6SF;;AA1SA;EACE,kBAAA;AA6SF;;AA1SA;EACE,wDAAA;AA6SF;;AA1SA;EACE,0DAAA;AA6SF;;AA1SA;EACE,wDAAA;AA6SF;;AA1SA;EACE,qDAAA;AA6SF;;AA1SA;EACE,wDAAA;AA6SF;;AA1SA;EACE,uDAAA;AA6SF;;AA1SA;EACE,sDAAA;AA6SF;;AA1SA;EACE,qDAAA;AA6SF;;AA1SA;EACE,+CAAA;AA6SF;;AA1SA;EACE,mCAAA;UAAA,2BAAA;AA6SF;;AA1SA;EACE,oCAAA;UAAA,4BAAA;AA6SF;;AA1SA;EACE,oCAAA;UAAA,4BAAA;AA6SF;;AA1SA;EACE,+BAAA;AA6SF;;AA1SA;EACE,+BAAA;AA6SF;;AA1SA;EACE,kCAAA;AA6SF;;AA1SA;EACE,2BAAA;AA6SF;;AA1SA;EACE,kCAAA;AA6SF;;AA1SA;EACE,kCAAA;AA6SF;;AA1SA;EACE,kCAAA;AA6SF;;AA1SA;EACE,8BAAA;AA6SF;;AA1SA;EACE,6BAAA;AA6SF;;AA1SA;EACE,+BAAA;AA6SF;;AA1SA;EACE,0DAAA;EACA,2DAAA;AA6SF;;AA1SA;EACE,oCAAA;EACA,qCAAA;AA6SF;;AA1SA;EACE,6DAAA;EACA,8DAAA;AA6SF;;AA1SA;EACE,0DAAA;EACA,2DAAA;AA6SF;;AA1SA;EACE,6DAAA;EACA,8DAAA;AA6SF;;AA1SA;EACE,6DAAA;EACA,8DAAA;AA6SF;;AA1SA;EACE,8DAAA;EACA,+DAAA;AA6SF;;AA1SA;EACE,sCAAA;EACA,uCAAA;AA6SF;;AA1SA;EACE,+DAAA;EACA,gEAAA;AA6SF;;AA1SA;EACE,2DAAA;EACA,8DAAA;AA6SF;;AA1SA;EACE,qCAAA;EACA,wCAAA;AA6SF;;AA1SA;EACE,8DAAA;EACA,iEAAA;AA6SF;;AA1SA;EACE,2DAAA;EACA,8DAAA;AA6SF;;AA1SA;EACE,8DAAA;EACA,iEAAA;AA6SF;;AA1SA;EACE,8DAAA;EACA,iEAAA;AA6SF;;AA1SA;EACE,+DAAA;EACA,kEAAA;AA6SF;;AA1SA;EACE,uCAAA;EACA,0CAAA;AA6SF;;AA1SA;EACE,gEAAA;EACA,mEAAA;AA6SF;;AA1SA;EACE,8DAAA;EACA,6DAAA;AA6SF;;AA1SA;EACE,wCAAA;EACA,uCAAA;AA6SF;;AA1SA;EACE,iEAAA;EACA,gEAAA;AA6SF;;AA1SA;EACE,8DAAA;EACA,6DAAA;AA6SF;;AA1SA;EACE,iEAAA;EACA,gEAAA;AA6SF;;AA1SA;EACE,iEAAA;EACA,gEAAA;AA6SF;;AA1SA;EACE,kEAAA;EACA,iEAAA;AA6SF;;AA1SA;EACE,0CAAA;EACA,yCAAA;AA6SF;;AA1SA;EACE,mEAAA;EACA,kEAAA;AA6SF;;AA1SA;EACE,6DAAA;EACA,0DAAA;AA6SF;;AA1SA;EACE,uCAAA;EACA,oCAAA;AA6SF;;AA1SA;EACE,gEAAA;EACA,6DAAA;AA6SF;;AA1SA;EACE,6DAAA;EACA,0DAAA;AA6SF;;AA1SA;EACE,gEAAA;EACA,6DAAA;AA6SF;;AA1SA;EACE,gEAAA;EACA,6DAAA;AA6SF;;AA1SA;EACE,iEAAA;EACA,8DAAA;AA6SF;;AA1SA;EACE,yCAAA;EACA,sCAAA;AA6SF;;AA1SA;EACE,kEAAA;EACA,+DAAA;AA6SF;;AA1SA;EACE,8BAAA;AA6SF;;AA1SA;EACE,6BAAA;AA6SF;;AA1SA;EACE,sBAAA;AA6SF;;AA1SA;EACE,sBAAA;AA6SF;;AA1SA;EACE,qBAAA;AA6SF;;AA1SA;EACE,qBAAA;AA6SF;;AA1SA;EACE,qBAAA;AA6SF;;AA1SA;EACE,qBAAA;AA6SF;;AA1SA;EACE,qBAAA;AA6SF;;AA1SA;EACE,qBAAA;AA6SF;;AA1SA;EACE,wBAAA;AA6SF;;AA1SA;EACE,wBAAA;AA6SF;;AA1SA;EACE,uBAAA;AA6SF;;AA1SA;EACE,uBAAA;AA6SF;;AA1SA;EACE,wBAAA;AA6SF;;AA1SA;EACE,wBAAA;AA6SF;;AA1SA;EACE,uBAAA;AA6SF;;AA1SA;EACE,uBAAA;AA6SF;;AA1SA;EACE,wBAAA;AA6SF;;AA1SA;EACE,wBAAA;AA6SF;;AA1SA;EACE,uBAAA;AA6SF;;AA1SA;EACE,uBAAA;AA6SF;;AA1SA;EACE,wBAAA;AA6SF;;AA1SA;EACE,wBAAA;AA6SF;;AA1SA;EACE,qBAAA;AA6SF;;AA1SA;EACE,qBAAA;AA6SF;;AA1SA;EACE,2BAAA;AA6SF;;AA1SA;EACE,yBAAA;AA6SF;;AA1SA;EACE,yBAAA;AA6SF;;AA1SA;EACE,yBAAA;AA6SF;;AA1SA;EACE,0BAAA;AA6SF;;AA1SA;EACE,0BAAA;AA6SF;;AA1SA;EACE,yBAAA;AA6SF;;AA1SA;EACE,yBAAA;AA6SF;;AA1SA;EACE,yBAAA;AA6SF;;AA1SA;EACE,yBAAA;AA6SF;;AA1SA;EACE,yBAAA;AA6SF;;AA1SA;EACE,yBAAA;AA6SF;;AA1SA;EACE,yBAAA;AA6SF;;AA1SA;EACE,yBAAA;AA6SF;;AA1SA;EACE,yBAAA;AA6SF;;AA1SA;EACE,0BAAA;AA6SF;;AA1SA;EACE,0BAAA;AA6SF;;AA1SA;EACE,0BAAA;AA6SF;;AA1SA;EACE,0BAAA;AA6SF;;AA1SA;EACE,0BAAA;AA6SF;;AA1SA;EACE,0BAAA;AA6SF;;AA1SA;EACE,0BAAA;AA6SF;;AA1SA;EACE,0BAAA;AA6SF;;AA1SA;EACE,0BAAA;AA6SF;;AA1SA;EACE,0BAAA;AA6SF;;AA1SA;EACE,0BAAA;AA6SF;;AA1SA;EACE,0BAAA;AA6SF;;AA1SA;EACE,0BAAA;AA6SF;;AA1SA;EACE,0BAAA;AA6SF;;AA1SA;EACE,0BAAA;AA6SF;;AA1SA;EACE,0BAAA;AA6SF;;AA1SA;EACE,0BAAA;AA6SF;;AA1SA;EACE,0BAAA;AA6SF;;AA1SA;EACE,2BAAA;AA6SF;;AA1SA;EACE,2BAAA;AA6SF;;AA1SA;EACE,2BAAA;AA6SF;;AA1SA;EACE,2BAAA;AA6SF;;AA1SA;EACE,2BAAA;AA6SF;;AA1SA;EACE,2BAAA;AA6SF;;AA1SA;EACE,2BAAA;AA6SF;;AA1SA;EACE,2BAAA;AA6SF;;AA1SA;EACE,2BAAA;AA6SF;;AA1SA;EACE,2BAAA;AA6SF;;AA1SA;EACE,2BAAA;AA6SF;;AA1SA;EACE,2BAAA;AA6SF;;AA1SA;EACE,2BAAA;AA6SF;;AA1SA;EACE,2BAAA;AA6SF;;AA1SA;EACE,2BAAA;AA6SF;;AA1SA;EACE,2BAAA;AA6SF;;AA1SA;EACE,2BAAA;AA6SF;;AA1SA;EACE,2BAAA;AA6SF;;AA1SA;EACE,2BAAA;AA6SF;;AA1SA;EACE,2BAAA;AA6SF;;AA1SA;EACE,2BAAA;AA6SF;;AA1SA;EACE,2BAAA;AA6SF;;AA1SA;EACE,2BAAA;AA6SF;;AA1SA;EACE,2BAAA;AA6SF;;AA1SA;EACE,2BAAA;AA6SF;;AA1SA;EACE,2BAAA;AA6SF;;AA1SA;EACE,4BAAA;AA6SF;;AA1SA;EACE,4BAAA;AA6SF;;AA1SA;EACE,0BAAA;AA6SF;;AA1SA;EACE,0BAAA;AA6SF;;AA1SA;EACE,0BAAA;AA6SF;;AA1SA;EACE,2BAAA;AA6SF;;AA1SA;EACE,2BAAA;AA6SF;;AA1SA;EACE,0BAAA;AA6SF;;AA1SA;EACE,0BAAA;AA6SF;;AA1SA;EACE,0BAAA;AA6SF;;AA1SA;EACE,0BAAA;AA6SF;;AA1SA;EACE,0BAAA;AA6SF;;AA1SA;EACE,0BAAA;AA6SF;;AA1SA;EACE,0BAAA;AA6SF;;AA1SA;EACE,0BAAA;AA6SF;;AA1SA;EACE,0BAAA;AA6SF;;AA1SA;EACE,2BAAA;AA6SF;;AA1SA;EACE,2BAAA;AA6SF;;AA1SA;EACE,2BAAA;AA6SF;;AA1SA;EACE,2BAAA;AA6SF;;AA1SA;EACE,2BAAA;AA6SF;;AA1SA;EACE,2BAAA;AA6SF;;AA1SA;EACE,2BAAA;AA6SF;;AA1SA;EACE,2BAAA;AA6SF;;AA1SA;EACE,2BAAA;AA6SF;;AA1SA;EACE,2BAAA;AA6SF;;AA1SA;EACE,2BAAA;AA6SF;;AA1SA;EACE,2BAAA;AA6SF;;AA1SA;EACE,2BAAA;AA6SF;;AA1SA;EACE,2BAAA;AA6SF;;AA1SA;EACE,2BAAA;AA6SF;;AA1SA;EACE,2BAAA;AA6SF;;AA1SA;EACE,2BAAA;AA6SF;;AA1SA;EACE,2BAAA;AA6SF;;AA1SA;EACE,4BAAA;AA6SF;;AA1SA;EACE,4BAAA;AA6SF;;AA1SA;EACE,4BAAA;AA6SF;;AA1SA;EACE,4BAAA;AA6SF;;AA1SA;EACE,4BAAA;AA6SF;;AA1SA;EACE,4BAAA;AA6SF;;AA1SA;EACE,4BAAA;AA6SF;;AA1SA;EACE,4BAAA;AA6SF;;AA1SA;EACE,4BAAA;AA6SF;;AA1SA;EACE,4BAAA;AA6SF;;AA1SA;EACE,4BAAA;AA6SF;;AA1SA;EACE,4BAAA;AA6SF;;AA1SA;EACE,4BAAA;AA6SF;;AA1SA;EACE,4BAAA;AA6SF;;AA1SA;EACE,4BAAA;AA6SF;;AA1SA;EACE,4BAAA;AA6SF;;AA1SA;EACE,4BAAA;AA6SF;;AA1SA;EACE,4BAAA;AA6SF;;AA1SA;EACE,4BAAA;AA6SF;;AA1SA;EACE,4BAAA;AA6SF;;AA1SA;EACE,4BAAA;AA6SF;;AA1SA;EACE,4BAAA;AA6SF;;AA1SA;EACE,4BAAA;AA6SF;;AA1SA;EACE,4BAAA;AA6SF;;AA1SA;EACE,4BAAA;AA6SF;;AA1SA;EACE,4BAAA;AA6SF;;AA1SA;EACE,6BAAA;AA6SF;;AA1SA;EACE,8BAAA;AA6SF;;AA1SA;EACE,gCAAA;AA6SF;;AA1SA;EACE,gCAAA;AA6SF;;AA1SA;EACE,gCAAA;AA6SF;;AA1SA;EACE,gCAAA;AA6SF;;AA1SA;EACE,gCAAA;AA6SF;;AA1SA;EACE,iCAAA;AA6SF;;AA1SA;EACE,mCAAA;AA6SF;;AA1SA;EACE,mCAAA;AA6SF;;AA1SA;EACE,mCAAA;AA6SF;;AA1SA;EACE,mCAAA;AA6SF;;AA1SA;EACE,mCAAA;AA6SF;;AA1SA;EACE,gCAAA;AA6SF;;AA1SA;EACE,kCAAA;AA6SF;;AA1SA;EACE,kCAAA;AA6SF;;AA1SA;EACE,kCAAA;AA6SF;;AA1SA;EACE,kCAAA;AA6SF;;AA1SA;EACE,kCAAA;AA6SF;;AA1SA;EACE,+BAAA;AA6SF;;AA1SA;EACE,iCAAA;AA6SF;;AA1SA;EACE,iCAAA;AA6SF;;AA1SA;EACE,iCAAA;AA6SF;;AA1SA;EACE,iCAAA;AA6SF;;AA1SA;EACE,iCAAA;AA6SF;;AA1SA;EACE,iCAAA;AA6SF;;AA1SA;EACE,mCAAA;AA6SF;;AA1SA;EACE,mCAAA;AA6SF;;AA1SA;EACE,kCAAA;AA6SF;;AA1SA;EACE,iCAAA;AA6SF;;AA1SA;EACE,kCAAA;AA6SF;;AA1SA;EACE,oCAAA;AA6SF;;AA1SA;EACE,oCAAA;AA6SF;;AA1SA;EACE,mCAAA;AA6SF;;AA1SA;EACE,kCAAA;AA6SF;;AA1SA;EACE;IACE,sBAAA;EA6SF;EA3SA;IACE,uBAAA;EA6SF;EA3SA;IACE,sBAAA;EA6SF;EA3SA;IACE,8BAAA;EA6SF;EA3SA;IACE,4BAAA;EA6SF;EA3SA;IACE,2BAAA;EA6SF;EA3SA;IACE,iCAAA;EA6SF;EA3SA;IACE,2BAAA;EA6SF;EA3SA;IACE,yBAAA;EA6SF;EA3SA;IACE,2BAAA;EA6SF;EA3SA;IACE,4BAAA;EA6SF;EA3SA;IACE,2BAAA;EA6SF;EA3SA;IACE,0BAAA;EA6SF;EA3SA;IACE,gCAAA;EA6SF;EA3SA;IACE,yBAAA;EA6SF;EA3SA;IACE,wBAAA;EA6SF;EA3SA;IACE,yBAAA;EA6SF;EA3SA;IACE,6BAAA;EA6SF;EA3SA;IACE,8BAAA;EA6SF;EA3SA;IACE,wBAAA;EA6SF;EA3SA;IACE,+BAAA;EA6SF;EA3SA;IACE,wBAAA;EA6SF;EA3SA;IACE,2BAAA;EA6SF;EA3SA;IACE,6BAAA;EA6SF;EA3SA;IACE,6BAAA;EA6SF;EA3SA;IACE,0BAAA;EA6SF;EA3SA;IACE,2BAAA;EA6SF;EA3SA;IACE,uBAAA;EA6SF;EA3SA;IACE,qBAAA;EA6SF;EA3SA;IACE,qBAAA;EA6SF;EA3SA;IACE,qBAAA;EA6SF;EA3SA;IACE,sBAAA;EA6SF;EA3SA;IACE,sBAAA;EA6SF;EA3SA;IACE,qBAAA;EA6SF;EA3SA;IACE,qBAAA;EA6SF;EA3SA;IACE,qBAAA;EA6SF;EA3SA;IACE,qBAAA;EA6SF;EA3SA;IACE,qBAAA;EA6SF;EA3SA;IACE,qBAAA;EA6SF;EA3SA;IACE,qBAAA;EA6SF;EA3SA;IACE,qBAAA;EA6SF;EA3SA;IACE,qBAAA;EA6SF;EA3SA;IACE,sBAAA;EA6SF;EA3SA;IACE,sBAAA;EA6SF;EA3SA;IACE,sBAAA;EA6SF;EA3SA;IACE,sBAAA;EA6SF;EA3SA;IACE,sBAAA;EA6SF;EA3SA;IACE,sBAAA;EA6SF;EA3SA;IACE,sBAAA;EA6SF;EA3SA;IACE,sBAAA;EA6SF;EA3SA;IACE,sBAAA;EA6SF;EA3SA;IACE,sBAAA;EA6SF;EA3SA;IACE,sBAAA;EA6SF;EA3SA;IACE,sBAAA;EA6SF;EA3SA;IACE,sBAAA;EA6SF;EA3SA;IACE,sBAAA;EA6SF;EA3SA;IACE,sBAAA;EA6SF;EA3SA;IACE,sBAAA;EA6SF;EA3SA;IACE,sBAAA;EA6SF;EA3SA;IACE,sBAAA;EA6SF;EA3SA;IACE,uBAAA;EA6SF;EA3SA;IACE,uBAAA;EA6SF;EA3SA;IACE,uBAAA;EA6SF;EA3SA;IACE,uBAAA;EA6SF;EA3SA;IACE,uBAAA;EA6SF;EA3SA;IACE,uBAAA;EA6SF;EA3SA;IACE,uBAAA;EA6SF;EA3SA;IACE,uBAAA;EA6SF;EA3SA;IACE,uBAAA;EA6SF;EA3SA;IACE,uBAAA;EA6SF;EA3SA;IACE,uBAAA;EA6SF;EA3SA;IACE,uBAAA;EA6SF;EA3SA;IACE,uBAAA;EA6SF;EA3SA;IACE,uBAAA;EA6SF;EA3SA;IACE,uBAAA;EA6SF;EA3SA;IACE,uBAAA;EA6SF;EA3SA;IACE,uBAAA;EA6SF;EA3SA;IACE,uBAAA;EA6SF;EA3SA;IACE,uBAAA;EA6SF;EA3SA;IACE,uBAAA;EA6SF;EA3SA;IACE,uBAAA;EA6SF;EA3SA;IACE,uBAAA;EA6SF;EA3SA;IACE,uBAAA;EA6SF;EA3SA;IACE,uBAAA;EA6SF;EA3SA;IACE,uBAAA;EA6SF;EA3SA;IACE,uBAAA;EA6SF;EA3SA;IACE,wBAAA;EA6SF;EA3SA;IACE,2BAAA;EA6SF;EA3SA;IACE,yBAAA;EA6SF;EA3SA;IACE,yBAAA;EA6SF;EA3SA;IACE,yBAAA;EA6SF;EA3SA;IACE,0BAAA;EA6SF;EA3SA;IACE,0BAAA;EA6SF;EA3SA;IACE,yBAAA;EA6SF;EA3SA;IACE,yBAAA;EA6SF;EA3SA;IACE,yBAAA;EA6SF;EA3SA;IACE,yBAAA;EA6SF;EA3SA;IACE,yBAAA;EA6SF;EA3SA;IACE,yBAAA;EA6SF;EA3SA;IACE,yBAAA;EA6SF;EA3SA;IACE,yBAAA;EA6SF;EA3SA;IACE,yBAAA;EA6SF;EA3SA;IACE,0BAAA;EA6SF;EA3SA;IACE,0BAAA;EA6SF;EA3SA;IACE,0BAAA;EA6SF;EA3SA;IACE,0BAAA;EA6SF;EA3SA;IACE,0BAAA;EA6SF;EA3SA;IACE,0BAAA;EA6SF;EA3SA;IACE,0BAAA;EA6SF;EA3SA;IACE,0BAAA;EA6SF;EA3SA;IACE,0BAAA;EA6SF;EA3SA;IACE,0BAAA;EA6SF;EA3SA;IACE,0BAAA;EA6SF;EA3SA;IACE,0BAAA;EA6SF;EA3SA;IACE,0BAAA;EA6SF;EA3SA;IACE,0BAAA;EA6SF;EA3SA;IACE,0BAAA;EA6SF;EA3SA;IACE,0BAAA;EA6SF;EA3SA;IACE,0BAAA;EA6SF;EA3SA;IACE,0BAAA;EA6SF;EA3SA;IACE,2BAAA;EA6SF;EA3SA;IACE,2BAAA;EA6SF;EA3SA;IACE,2BAAA;EA6SF;EA3SA;IACE,2BAAA;EA6SF;EA3SA;IACE,2BAAA;EA6SF;EA3SA;IACE,2BAAA;EA6SF;EA3SA;IACE,2BAAA;EA6SF;EA3SA;IACE,2BAAA;EA6SF;EA3SA;IACE,2BAAA;EA6SF;EA3SA;IACE,2BAAA;EA6SF;EA3SA;IACE,2BAAA;EA6SF;EA3SA;IACE,2BAAA;EA6SF;EA3SA;IACE,2BAAA;EA6SF;EA3SA;IACE,2BAAA;EA6SF;EA3SA;IACE,2BAAA;EA6SF;EA3SA;IACE,2BAAA;EA6SF;EA3SA;IACE,2BAAA;EA6SF;EA3SA;IACE,2BAAA;EA6SF;EA3SA;IACE,2BAAA;EA6SF;EA3SA;IACE,2BAAA;EA6SF;EA3SA;IACE,2BAAA;EA6SF;EA3SA;IACE,2BAAA;EA6SF;EA3SA;IACE,2BAAA;EA6SF;EA3SA;IACE,2BAAA;EA6SF;EA3SA;IACE,2BAAA;EA6SF;EA3SA;IACE,2BAAA;EA6SF;EA3SA;IACE,4BAAA;EA6SF;EA3SA;IACE,wBAAA;EA6SF;EA3SA;IACE,sBAAA;EA6SF;EA3SA;IACE,sBAAA;EA6SF;EA3SA;IACE,sBAAA;EA6SF;EA3SA;IACE,uBAAA;EA6SF;EA3SA;IACE,uBAAA;EA6SF;EA3SA;IACE,sBAAA;EA6SF;EA3SA;IACE,sBAAA;EA6SF;EA3SA;IACE,sBAAA;EA6SF;EA3SA;IACE,sBAAA;EA6SF;EA3SA;IACE,sBAAA;EA6SF;EA3SA;IACE,sBAAA;EA6SF;EA3SA;IACE,sBAAA;EA6SF;EA3SA;IACE,sBAAA;EA6SF;EA3SA;IACE,sBAAA;EA6SF;EA3SA;IACE,uBAAA;EA6SF;EA3SA;IACE,uBAAA;EA6SF;EA3SA;IACE,uBAAA;EA6SF;EA3SA;IACE,uBAAA;EA6SF;EA3SA;IACE,uBAAA;EA6SF;EA3SA;IACE,uBAAA;EA6SF;EA3SA;IACE,uBAAA;EA6SF;EA3SA;IACE,uBAAA;EA6SF;EA3SA;IACE,uBAAA;EA6SF;EA3SA;IACE,uBAAA;EA6SF;EA3SA;IACE,uBAAA;EA6SF;EA3SA;IACE,uBAAA;EA6SF;EA3SA;IACE,uBAAA;EA6SF;EA3SA;IACE,uBAAA;EA6SF;EA3SA;IACE,uBAAA;EA6SF;EA3SA;IACE,uBAAA;EA6SF;EA3SA;IACE,uBAAA;EA6SF;EA3SA;IACE,uBAAA;EA6SF;EA3SA;IACE,wBAAA;EA6SF;EA3SA;IACE,wBAAA;EA6SF;EA3SA;IACE,wBAAA;EA6SF;EA3SA;IACE,wBAAA;EA6SF;EA3SA;IACE,wBAAA;EA6SF;EA3SA;IACE,wBAAA;EA6SF;EA3SA;IACE,wBAAA;EA6SF;EA3SA;IACE,wBAAA;EA6SF;EA3SA;IACE,wBAAA;EA6SF;EA3SA;IACE,wBAAA;EA6SF;EA3SA;IACE,wBAAA;EA6SF;EA3SA;IACE,wBAAA;EA6SF;EA3SA;IACE,wBAAA;EA6SF;EA3SA;IACE,wBAAA;EA6SF;EA3SA;IACE,wBAAA;EA6SF;EA3SA;IACE,wBAAA;EA6SF;EA3SA;IACE,wBAAA;EA6SF;EA3SA;IACE,wBAAA;EA6SF;EA3SA;IACE,wBAAA;EA6SF;EA3SA;IACE,wBAAA;EA6SF;EA3SA;IACE,wBAAA;EA6SF;EA3SA;IACE,wBAAA;EA6SF;EA3SA;IACE,wBAAA;EA6SF;EA3SA;IACE,wBAAA;EA6SF;EA3SA;IACE,wBAAA;EA6SF;EA3SA;IACE,wBAAA;EA6SF;EA3SA;IACE,yBAAA;EA6SF;EA3SA;IACE,4BAAA;EA6SF;EA3SA;IACE,0BAAA;EA6SF;EA3SA;IACE,0BAAA;EA6SF;EA3SA;IACE,0BAAA;EA6SF;EA3SA;IACE,2BAAA;EA6SF;EA3SA;IACE,2BAAA;EA6SF;EA3SA;IACE,0BAAA;EA6SF;EA3SA;IACE,0BAAA;EA6SF;EA3SA;IACE,0BAAA;EA6SF;EA3SA;IACE,0BAAA;EA6SF;EA3SA;IACE,0BAAA;EA6SF;EA3SA;IACE,0BAAA;EA6SF;EA3SA;IACE,0BAAA;EA6SF;EA3SA;IACE,0BAAA;EA6SF;EA3SA;IACE,0BAAA;EA6SF;EA3SA;IACE,2BAAA;EA6SF;EA3SA;IACE,2BAAA;EA6SF;EA3SA;IACE,2BAAA;EA6SF;EA3SA;IACE,2BAAA;EA6SF;EA3SA;IACE,2BAAA;EA6SF;EA3SA;IACE,2BAAA;EA6SF;EA3SA;IACE,2BAAA;EA6SF;EA3SA;IACE,2BAAA;EA6SF;EA3SA;IACE,2BAAA;EA6SF;EA3SA;IACE,2BAAA;EA6SF;EA3SA;IACE,2BAAA;EA6SF;EA3SA;IACE,2BAAA;EA6SF;EA3SA;IACE,2BAAA;EA6SF;EA3SA;IACE,2BAAA;EA6SF;EA3SA;IACE,2BAAA;EA6SF;EA3SA;IACE,2BAAA;EA6SF;EA3SA;IACE,2BAAA;EA6SF;EA3SA;IACE,2BAAA;EA6SF;EA3SA;IACE,4BAAA;EA6SF;EA3SA;IACE,4BAAA;EA6SF;EA3SA;IACE,4BAAA;EA6SF;EA3SA;IACE,4BAAA;EA6SF;EA3SA;IACE,4BAAA;EA6SF;EA3SA;IACE,4BAAA;EA6SF;EA3SA;IACE,4BAAA;EA6SF;EA3SA;IACE,4BAAA;EA6SF;EA3SA;IACE,4BAAA;EA6SF;EA3SA;IACE,4BAAA;EA6SF;EA3SA;IACE,4BAAA;EA6SF;EA3SA;IACE,4BAAA;EA6SF;EA3SA;IACE,4BAAA;EA6SF;EA3SA;IACE,4BAAA;EA6SF;EA3SA;IACE,4BAAA;EA6SF;EA3SA;IACE,4BAAA;EA6SF;EA3SA;IACE,4BAAA;EA6SF;EA3SA;IACE,4BAAA;EA6SF;EA3SA;IACE,4BAAA;EA6SF;EA3SA;IACE,4BAAA;EA6SF;EA3SA;IACE,4BAAA;EA6SF;EA3SA;IACE,4BAAA;EA6SF;EA3SA;IACE,4BAAA;EA6SF;EA3SA;IACE,4BAAA;EA6SF;EA3SA;IACE,4BAAA;EA6SF;EA3SA;IACE,4BAAA;EA6SF;EA3SA;IACE,6BAAA;EA6SF;EA3SA;IACE,yBAAA;EA6SF;EA3SA;IACE,8BAAA;EA6SF;EA3SA;IACE,iCAAA;EA6SF;EA3SA;IACE,sCAAA;EA6SF;EA3SA;IACE,yCAAA;EA6SF;EA3SA;IACE,uBAAA;EA6SF;EA3SA;IACE,uBAAA;EA6SF;EA3SA;IACE,yBAAA;EA6SF;EA3SA;IACE,yBAAA;EA6SF;EA3SA;IACE,0BAAA;EA6SF;EA3SA;IACE,4BAAA;EA6SF;EA3SA;IACE,kCAAA;EA6SF;EA3SA;IACE,sCAAA;EA6SF;EA3SA;IACE,oCAAA;EA6SF;EA3SA;IACE,kCAAA;EA6SF;EA3SA;IACE,yCAAA;EA6SF;EA3SA;IACE,wCAAA;EA6SF;EA3SA;IACE,wCAAA;EA6SF;EA3SA;IACE,kCAAA;EA6SF;EA3SA;IACE,gCAAA;EA6SF;EA3SA;IACE,8BAAA;EA6SF;EA3SA;IACE,gCAAA;EA6SF;EA3SA;IACE,+BAAA;EA6SF;EA3SA;IACE,oCAAA;EA6SF;EA3SA;IACE,kCAAA;EA6SF;EA3SA;IACE,gCAAA;EA6SF;EA3SA;IACE,uCAAA;EA6SF;EA3SA;IACE,sCAAA;EA6SF;EA3SA;IACE,iCAAA;EA6SF;EA3SA;IACE,2BAAA;EA6SF;EA3SA;IACE,iCAAA;EA6SF;EA3SA;IACE,+BAAA;EA6SF;EA3SA;IACE,6BAAA;EA6SF;EA3SA;IACE,+BAAA;EA6SF;EA3SA;IACE,8BAAA;EA6SF;EA3SA;IACE,oBAAA;EA6SF;EA3SA;IACE,mBAAA;EA6SF;EA3SA;IACE,mBAAA;EA6SF;EA3SA;IACE,mBAAA;EA6SF;EA3SA;IACE,mBAAA;EA6SF;EA3SA;IACE,mBAAA;EA6SF;EA3SA;IACE,mBAAA;EA6SF;EA3SA;IACE,mBAAA;EA6SF;EA3SA;IACE,oBAAA;EA6SF;EA3SA;IACE,0BAAA;EA6SF;EA3SA;IACE,yBAAA;EA6SF;EA3SA;IACE,0BAAA;EA6SF;EA3SA;IACE,uBAAA;EA6SF;EA3SA;IACE,0BAAA;EA6SF;EA3SA;IACE,yBAAA;EA6SF;EA3SA;IACE,0BAAA;EA6SF;EA3SA;IACE,uBAAA;EA6SF;EA3SA;IACE,0BAAA;EA6SF;EA3SA;IACE,yBAAA;EA6SF;EA3SA;IACE,0BAAA;EA6SF;EA3SA;IACE,uBAAA;EA6SF;EA3SA;IACE,0BAAA;EA6SF;EA3SA;IACE,yBAAA;EA6SF;EA3SA;IACE,0BAAA;EA6SF;EA3SA;IACE,uBAAA;EA6SF;EA3SA;IACE,0BAAA;EA6SF;EA3SA;IACE,yBAAA;EA6SF;EA3SA;IACE,0BAAA;EA6SF;EA3SA;IACE,uBAAA;EA6SF;EA3SA;IACE,uBAAA;EA6SF;EA3SA;IACE,0BAAA;IACA,yBAAA;EA6SF;EA3SA;IACE,gCAAA;IACA,+BAAA;EA6SF;EA3SA;IACE,+BAAA;IACA,8BAAA;EA6SF;EA3SA;IACE,gCAAA;IACA,+BAAA;EA6SF;EA3SA;IACE,6BAAA;IACA,4BAAA;EA6SF;EA3SA;IACE,gCAAA;IACA,+BAAA;EA6SF;EA3SA;IACE,+BAAA;IACA,8BAAA;EA6SF;EA3SA;IACE,gCAAA;IACA,+BAAA;EA6SF;EA3SA;IACE,6BAAA;IACA,4BAAA;EA6SF;EA3SA;IACE,gCAAA;IACA,+BAAA;EA6SF;EA3SA;IACE,+BAAA;IACA,8BAAA;EA6SF;EA3SA;IACE,gCAAA;IACA,+BAAA;EA6SF;EA3SA;IACE,6BAAA;IACA,4BAAA;EA6SF;EA3SA;IACE,gCAAA;IACA,+BAAA;EA6SF;EA3SA;IACE,+BAAA;IACA,8BAAA;EA6SF;EA3SA;IACE,gCAAA;IACA,+BAAA;EA6SF;EA3SA;IACE,6BAAA;IACA,4BAAA;EA6SF;EA3SA;IACE,gCAAA;IACA,+BAAA;EA6SF;EA3SA;IACE,+BAAA;IACA,8BAAA;EA6SF;EA3SA;IACE,gCAAA;IACA,+BAAA;EA6SF;EA3SA;IACE,6BAAA;IACA,4BAAA;EA6SF;EA3SA;IACE,6BAAA;IACA,4BAAA;EA6SF;EA3SA;IACE,wBAAA;IACA,2BAAA;EA6SF;EA3SA;IACE,8BAAA;IACA,iCAAA;EA6SF;EA3SA;IACE,6BAAA;IACA,gCAAA;EA6SF;EA3SA;IACE,8BAAA;IACA,iCAAA;EA6SF;EA3SA;IACE,2BAAA;IACA,8BAAA;EA6SF;EA3SA;IACE,8BAAA;IACA,iCAAA;EA6SF;EA3SA;IACE,6BAAA;IACA,gCAAA;EA6SF;EA3SA;IACE,8BAAA;IACA,iCAAA;EA6SF;EA3SA;IACE,2BAAA;IACA,8BAAA;EA6SF;EA3SA;IACE,8BAAA;IACA,iCAAA;EA6SF;EA3SA;IACE,6BAAA;IACA,gCAAA;EA6SF;EA3SA;IACE,8BAAA;IACA,iCAAA;EA6SF;EA3SA;IACE,2BAAA;IACA,8BAAA;EA6SF;EA3SA;IACE,8BAAA;IACA,iCAAA;EA6SF;EA3SA;IACE,6BAAA;IACA,gCAAA;EA6SF;EA3SA;IACE,8BAAA;IACA,iCAAA;EA6SF;EA3SA;IACE,2BAAA;IACA,8BAAA;EA6SF;EA3SA;IACE,8BAAA;IACA,iCAAA;EA6SF;EA3SA;IACE,6BAAA;IACA,gCAAA;EA6SF;EA3SA;IACE,8BAAA;IACA,iCAAA;EA6SF;EA3SA;IACE,2BAAA;IACA,8BAAA;EA6SF;EA3SA;IACE,2BAAA;IACA,8BAAA;EA6SF;EA3SA;IACE,wBAAA;EA6SF;EA3SA;IACE,8BAAA;EA6SF;EA3SA;IACE,6BAAA;EA6SF;EA3SA;IACE,8BAAA;EA6SF;EA3SA;IACE,2BAAA;EA6SF;EA3SA;IACE,8BAAA;EA6SF;EA3SA;IACE,6BAAA;EA6SF;EA3SA;IACE,8BAAA;EA6SF;EA3SA;IACE,2BAAA;EA6SF;EA3SA;IACE,8BAAA;EA6SF;EA3SA;IACE,6BAAA;EA6SF;EA3SA;IACE,8BAAA;EA6SF;EA3SA;IACE,2BAAA;EA6SF;EA3SA;IACE,8BAAA;EA6SF;EA3SA;IACE,6BAAA;EA6SF;EA3SA;IACE,8BAAA;EA6SF;EA3SA;IACE,2BAAA;EA6SF;EA3SA;IACE,8BAAA;EA6SF;EA3SA;IACE,6BAAA;EA6SF;EA3SA;IACE,8BAAA;EA6SF;EA3SA;IACE,2BAAA;EA6SF;EA3SA;IACE,2BAAA;EA6SF;EA3SA;IACE,0BAAA;EA6SF;EA3SA;IACE,gCAAA;EA6SF;EA3SA;IACE,+BAAA;EA6SF;EA3SA;IACE,gCAAA;EA6SF;EA3SA;IACE,6BAAA;EA6SF;EA3SA;IACE,gCAAA;EA6SF;EA3SA;IACE,+BAAA;EA6SF;EA3SA;IACE,gCAAA;EA6SF;EA3SA;IACE,6BAAA;EA6SF;EA3SA;IACE,gCAAA;EA6SF;EA3SA;IACE,+BAAA;EA6SF;EA3SA;IACE,gCAAA;EA6SF;EA3SA;IACE,6BAAA;EA6SF;EA3SA;IACE,gCAAA;EA6SF;EA3SA;IACE,+BAAA;EA6SF;EA3SA;IACE,gCAAA;EA6SF;EA3SA;IACE,6BAAA;EA6SF;EA3SA;IACE,gCAAA;EA6SF;EA3SA;IACE,+BAAA;EA6SF;EA3SA;IACE,gCAAA;EA6SF;EA3SA;IACE,6BAAA;EA6SF;EA3SA;IACE,6BAAA;EA6SF;EA3SA;IACE,2BAAA;EA6SF;EA3SA;IACE,iCAAA;EA6SF;EA3SA;IACE,gCAAA;EA6SF;EA3SA;IACE,iCAAA;EA6SF;EA3SA;IACE,8BAAA;EA6SF;EA3SA;IACE,iCAAA;EA6SF;EA3SA;IACE,gCAAA;EA6SF;EA3SA;IACE,iCAAA;EA6SF;EA3SA;IACE,8BAAA;EA6SF;EA3SA;IACE,iCAAA;EA6SF;EA3SA;IACE,gCAAA;EA6SF;EA3SA;IACE,iCAAA;EA6SF;EA3SA;IACE,8BAAA;EA6SF;EA3SA;IACE,iCAAA;EA6SF;EA3SA;IACE,gCAAA;EA6SF;EA3SA;IACE,iCAAA;EA6SF;EA3SA;IACE,8BAAA;EA6SF;EA3SA;IACE,iCAAA;EA6SF;EA3SA;IACE,gCAAA;EA6SF;EA3SA;IACE,iCAAA;EA6SF;EA3SA;IACE,8BAAA;EA6SF;EA3SA;IACE,8BAAA;EA6SF;EA3SA;IACE,yBAAA;EA6SF;EA3SA;IACE,+BAAA;EA6SF;EA3SA;IACE,8BAAA;EA6SF;EA3SA;IACE,+BAAA;EA6SF;EA3SA;IACE,4BAAA;EA6SF;EA3SA;IACE,+BAAA;EA6SF;EA3SA;IACE,8BAAA;EA6SF;EA3SA;IACE,+BAAA;EA6SF;EA3SA;IACE,4BAAA;EA6SF;EA3SA;IACE,+BAAA;EA6SF;EA3SA;IACE,8BAAA;EA6SF;EA3SA;IACE,+BAAA;EA6SF;EA3SA;IACE,4BAAA;EA6SF;EA3SA;IACE,+BAAA;EA6SF;EA3SA;IACE,8BAAA;EA6SF;EA3SA;IACE,+BAAA;EA6SF;EA3SA;IACE,4BAAA;EA6SF;EA3SA;IACE,+BAAA;EA6SF;EA3SA;IACE,8BAAA;EA6SF;EA3SA;IACE,+BAAA;EA6SF;EA3SA;IACE,4BAAA;EA6SF;EA3SA;IACE,4BAAA;EA6SF;EA3SA;IACE,2BAAA;EA6SF;EA3SA;IACE,0BAAA;EA6SF;EA3SA;IACE,2BAAA;EA6SF;EA3SA;IACE,wBAAA;EA6SF;EA3SA;IACE,2BAAA;EA6SF;EA3SA;IACE,0BAAA;EA6SF;EA3SA;IACE,2BAAA;EA6SF;EA3SA;IACE,wBAAA;EA6SF;EA3SA;IACE,2BAAA;EA6SF;EA3SA;IACE,0BAAA;EA6SF;EA3SA;IACE,2BAAA;EA6SF;EA3SA;IACE,wBAAA;EA6SF;EA3SA;IACE,2BAAA;EA6SF;EA3SA;IACE,0BAAA;EA6SF;EA3SA;IACE,2BAAA;EA6SF;EA3SA;IACE,wBAAA;EA6SF;EA3SA;IACE,2BAAA;EA6SF;EA3SA;IACE,0BAAA;EA6SF;EA3SA;IACE,2BAAA;EA6SF;EA3SA;IACE,wBAAA;EA6SF;EA3SA;IACE,iCAAA;IACA,gCAAA;EA6SF;EA3SA;IACE,gCAAA;IACA,+BAAA;EA6SF;EA3SA;IACE,iCAAA;IACA,gCAAA;EA6SF;EA3SA;IACE,8BAAA;IACA,6BAAA;EA6SF;EA3SA;IACE,iCAAA;IACA,gCAAA;EA6SF;EA3SA;IACE,gCAAA;IACA,+BAAA;EA6SF;EA3SA;IACE,iCAAA;IACA,gCAAA;EA6SF;EA3SA;IACE,8BAAA;IACA,6BAAA;EA6SF;EA3SA;IACE,iCAAA;IACA,gCAAA;EA6SF;EA3SA;IACE,gCAAA;IACA,+BAAA;EA6SF;EA3SA;IACE,iCAAA;IACA,gCAAA;EA6SF;EA3SA;IACE,8BAAA;IACA,6BAAA;EA6SF;EA3SA;IACE,iCAAA;IACA,gCAAA;EA6SF;EA3SA;IACE,gCAAA;IACA,+BAAA;EA6SF;EA3SA;IACE,iCAAA;IACA,gCAAA;EA6SF;EA3SA;IACE,8BAAA;IACA,6BAAA;EA6SF;EA3SA;IACE,iCAAA;IACA,gCAAA;EA6SF;EA3SA;IACE,gCAAA;IACA,+BAAA;EA6SF;EA3SA;IACE,iCAAA;IACA,gCAAA;EA6SF;EA3SA;IACE,8BAAA;IACA,6BAAA;EA6SF;EA3SA;IACE,+BAAA;IACA,kCAAA;EA6SF;EA3SA;IACE,8BAAA;IACA,iCAAA;EA6SF;EA3SA;IACE,+BAAA;IACA,kCAAA;EA6SF;EA3SA;IACE,4BAAA;IACA,+BAAA;EA6SF;EA3SA;IACE,+BAAA;IACA,kCAAA;EA6SF;EA3SA;IACE,8BAAA;IACA,iCAAA;EA6SF;EA3SA;IACE,+BAAA;IACA,kCAAA;EA6SF;EA3SA;IACE,4BAAA;IACA,+BAAA;EA6SF;EA3SA;IACE,+BAAA;IACA,kCAAA;EA6SF;EA3SA;IACE,8BAAA;IACA,iCAAA;EA6SF;EA3SA;IACE,+BAAA;IACA,kCAAA;EA6SF;EA3SA;IACE,4BAAA;IACA,+BAAA;EA6SF;EA3SA;IACE,+BAAA;IACA,kCAAA;EA6SF;EA3SA;IACE,8BAAA;IACA,iCAAA;EA6SF;EA3SA;IACE,+BAAA;IACA,kCAAA;EA6SF;EA3SA;IACE,4BAAA;IACA,+BAAA;EA6SF;EA3SA;IACE,+BAAA;IACA,kCAAA;EA6SF;EA3SA;IACE,8BAAA;IACA,iCAAA;EA6SF;EA3SA;IACE,+BAAA;IACA,kCAAA;EA6SF;EA3SA;IACE,4BAAA;IACA,+BAAA;EA6SF;EA3SA;IACE,+BAAA;EA6SF;EA3SA;IACE,8BAAA;EA6SF;EA3SA;IACE,+BAAA;EA6SF;EA3SA;IACE,4BAAA;EA6SF;EA3SA;IACE,+BAAA;EA6SF;EA3SA;IACE,8BAAA;EA6SF;EA3SA;IACE,+BAAA;EA6SF;EA3SA;IACE,4BAAA;EA6SF;EA3SA;IACE,+BAAA;EA6SF;EA3SA;IACE,8BAAA;EA6SF;EA3SA;IACE,+BAAA;EA6SF;EA3SA;IACE,4BAAA;EA6SF;EA3SA;IACE,+BAAA;EA6SF;EA3SA;IACE,8BAAA;EA6SF;EA3SA;IACE,+BAAA;EA6SF;EA3SA;IACE,4BAAA;EA6SF;EA3SA;IACE,+BAAA;EA6SF;EA3SA;IACE,8BAAA;EA6SF;EA3SA;IACE,+BAAA;EA6SF;EA3SA;IACE,4BAAA;EA6SF;EA3SA;IACE,iCAAA;EA6SF;EA3SA;IACE,gCAAA;EA6SF;EA3SA;IACE,iCAAA;EA6SF;EA3SA;IACE,8BAAA;EA6SF;EA3SA;IACE,iCAAA;EA6SF;EA3SA;IACE,gCAAA;EA6SF;EA3SA;IACE,iCAAA;EA6SF;EA3SA;IACE,8BAAA;EA6SF;EA3SA;IACE,iCAAA;EA6SF;EA3SA;IACE,gCAAA;EA6SF;EA3SA;IACE,iCAAA;EA6SF;EA3SA;IACE,8BAAA;EA6SF;EA3SA;IACE,iCAAA;EA6SF;EA3SA;IACE,gCAAA;EA6SF;EA3SA;IACE,iCAAA;EA6SF;EA3SA;IACE,8BAAA;EA6SF;EA3SA;IACE,iCAAA;EA6SF;EA3SA;IACE,gCAAA;EA6SF;EA3SA;IACE,iCAAA;EA6SF;EA3SA;IACE,8BAAA;EA6SF;EA3SA;IACE,kCAAA;EA6SF;EA3SA;IACE,iCAAA;EA6SF;EA3SA;IACE,kCAAA;EA6SF;EA3SA;IACE,+BAAA;EA6SF;EA3SA;IACE,kCAAA;EA6SF;EA3SA;IACE,iCAAA;EA6SF;EA3SA;IACE,kCAAA;EA6SF;EA3SA;IACE,+BAAA;EA6SF;EA3SA;IACE,kCAAA;EA6SF;EA3SA;IACE,iCAAA;EA6SF;EA3SA;IACE,kCAAA;EA6SF;EA3SA;IACE,+BAAA;EA6SF;EA3SA;IACE,kCAAA;EA6SF;EA3SA;IACE,iCAAA;EA6SF;EA3SA;IACE,kCAAA;EA6SF;EA3SA;IACE,+BAAA;EA6SF;EA3SA;IACE,kCAAA;EA6SF;EA3SA;IACE,iCAAA;EA6SF;EA3SA;IACE,kCAAA;EA6SF;EA3SA;IACE,+BAAA;EA6SF;EA3SA;IACE,gCAAA;EA6SF;EA3SA;IACE,+BAAA;EA6SF;EA3SA;IACE,gCAAA;EA6SF;EA3SA;IACE,6BAAA;EA6SF;EA3SA;IACE,gCAAA;EA6SF;EA3SA;IACE,+BAAA;EA6SF;EA3SA;IACE,gCAAA;EA6SF;EA3SA;IACE,6BAAA;EA6SF;EA3SA;IACE,gCAAA;EA6SF;EA3SA;IACE,+BAAA;EA6SF;EA3SA;IACE,gCAAA;EA6SF;EA3SA;IACE,6BAAA;EA6SF;EA3SA;IACE,gCAAA;EA6SF;EA3SA;IACE,+BAAA;EA6SF;EA3SA;IACE,gCAAA;EA6SF;EA3SA;IACE,6BAAA;EA6SF;EA3SA;IACE,gCAAA;EA6SF;EA3SA;IACE,+BAAA;EA6SF;EA3SA;IACE,gCAAA;EA6SF;EA3SA;IACE,6BAAA;EA6SF;EA3SA;IACE,qBAAA;EA6SF;EA3SA;IACE,2BAAA;EA6SF;EA3SA;IACE,0BAAA;EA6SF;EA3SA;IACE,2BAAA;EA6SF;EA3SA;IACE,wBAAA;EA6SF;EA3SA;IACE,2BAAA;EA6SF;EA3SA;IACE,0BAAA;EA6SF;EA3SA;IACE,2BAAA;EA6SF;EA3SA;IACE,wBAAA;EA6SF;EA3SA;IACE,2BAAA;EA6SF;EA3SA;IACE,0BAAA;EA6SF;EA3SA;IACE,2BAAA;EA6SF;EA3SA;IACE,wBAAA;EA6SF;EA3SA;IACE,2BAAA;EA6SF;EA3SA;IACE,0BAAA;EA6SF;EA3SA;IACE,2BAAA;EA6SF;EA3SA;IACE,wBAAA;EA6SF;EA3SA;IACE,2BAAA;EA6SF;EA3SA;IACE,0BAAA;EA6SF;EA3SA;IACE,2BAAA;EA6SF;EA3SA;IACE,wBAAA;EA6SF;EA3SA;IACE,2BAAA;IACA,0BAAA;EA6SF;EA3SA;IACE,iCAAA;IACA,gCAAA;EA6SF;EA3SA;IACE,gCAAA;IACA,+BAAA;EA6SF;EA3SA;IACE,iCAAA;IACA,gCAAA;EA6SF;EA3SA;IACE,8BAAA;IACA,6BAAA;EA6SF;EA3SA;IACE,iCAAA;IACA,gCAAA;EA6SF;EA3SA;IACE,gCAAA;IACA,+BAAA;EA6SF;EA3SA;IACE,iCAAA;IACA,gCAAA;EA6SF;EA3SA;IACE,8BAAA;IACA,6BAAA;EA6SF;EA3SA;IACE,iCAAA;IACA,gCAAA;EA6SF;EA3SA;IACE,gCAAA;IACA,+BAAA;EA6SF;EA3SA;IACE,iCAAA;IACA,gCAAA;EA6SF;EA3SA;IACE,8BAAA;IACA,6BAAA;EA6SF;EA3SA;IACE,iCAAA;IACA,gCAAA;EA6SF;EA3SA;IACE,gCAAA;IACA,+BAAA;EA6SF;EA3SA;IACE,iCAAA;IACA,gCAAA;EA6SF;EA3SA;IACE,8BAAA;IACA,6BAAA;EA6SF;EA3SA;IACE,iCAAA;IACA,gCAAA;EA6SF;EA3SA;IACE,gCAAA;IACA,+BAAA;EA6SF;EA3SA;IACE,iCAAA;IACA,gCAAA;EA6SF;EA3SA;IACE,8BAAA;IACA,6BAAA;EA6SF;EA3SA;IACE,yBAAA;IACA,4BAAA;EA6SF;EA3SA;IACE,+BAAA;IACA,kCAAA;EA6SF;EA3SA;IACE,8BAAA;IACA,iCAAA;EA6SF;EA3SA;IACE,+BAAA;IACA,kCAAA;EA6SF;EA3SA;IACE,4BAAA;IACA,+BAAA;EA6SF;EA3SA;IACE,+BAAA;IACA,kCAAA;EA6SF;EA3SA;IACE,8BAAA;IACA,iCAAA;EA6SF;EA3SA;IACE,+BAAA;IACA,kCAAA;EA6SF;EA3SA;IACE,4BAAA;IACA,+BAAA;EA6SF;EA3SA;IACE,+BAAA;IACA,kCAAA;EA6SF;EA3SA;IACE,8BAAA;IACA,iCAAA;EA6SF;EA3SA;IACE,+BAAA;IACA,kCAAA;EA6SF;EA3SA;IACE,4BAAA;IACA,+BAAA;EA6SF;EA3SA;IACE,+BAAA;IACA,kCAAA;EA6SF;EA3SA;IACE,8BAAA;IACA,iCAAA;EA6SF;EA3SA;IACE,+BAAA;IACA,kCAAA;EA6SF;EA3SA;IACE,4BAAA;IACA,+BAAA;EA6SF;EA3SA;IACE,+BAAA;IACA,kCAAA;EA6SF;EA3SA;IACE,8BAAA;IACA,iCAAA;EA6SF;EA3SA;IACE,+BAAA;IACA,kCAAA;EA6SF;EA3SA;IACE,4BAAA;IACA,+BAAA;EA6SF;EA3SA;IACE,yBAAA;EA6SF;EA3SA;IACE,+BAAA;EA6SF;EA3SA;IACE,8BAAA;EA6SF;EA3SA;IACE,+BAAA;EA6SF;EA3SA;IACE,4BAAA;EA6SF;EA3SA;IACE,+BAAA;EA6SF;EA3SA;IACE,8BAAA;EA6SF;EA3SA;IACE,+BAAA;EA6SF;EA3SA;IACE,4BAAA;EA6SF;EA3SA;IACE,+BAAA;EA6SF;EA3SA;IACE,8BAAA;EA6SF;EA3SA;IACE,+BAAA;EA6SF;EA3SA;IACE,4BAAA;EA6SF;EA3SA;IACE,+BAAA;EA6SF;EA3SA;IACE,8BAAA;EA6SF;EA3SA;IACE,+BAAA;EA6SF;EA3SA;IACE,4BAAA;EA6SF;EA3SA;IACE,+BAAA;EA6SF;EA3SA;IACE,8BAAA;EA6SF;EA3SA;IACE,+BAAA;EA6SF;EA3SA;IACE,4BAAA;EA6SF;EA3SA;IACE,2BAAA;EA6SF;EA3SA;IACE,iCAAA;EA6SF;EA3SA;IACE,gCAAA;EA6SF;EA3SA;IACE,iCAAA;EA6SF;EA3SA;IACE,8BAAA;EA6SF;EA3SA;IACE,iCAAA;EA6SF;EA3SA;IACE,gCAAA;EA6SF;EA3SA;IACE,iCAAA;EA6SF;EA3SA;IACE,8BAAA;EA6SF;EA3SA;IACE,iCAAA;EA6SF;EA3SA;IACE,gCAAA;EA6SF;EA3SA;IACE,iCAAA;EA6SF;EA3SA;IACE,8BAAA;EA6SF;EA3SA;IACE,iCAAA;EA6SF;EA3SA;IACE,gCAAA;EA6SF;EA3SA;IACE,iCAAA;EA6SF;EA3SA;IACE,8BAAA;EA6SF;EA3SA;IACE,iCAAA;EA6SF;EA3SA;IACE,gCAAA;EA6SF;EA3SA;IACE,iCAAA;EA6SF;EA3SA;IACE,8BAAA;EA6SF;EA3SA;IACE,4BAAA;EA6SF;EA3SA;IACE,kCAAA;EA6SF;EA3SA;IACE,iCAAA;EA6SF;EA3SA;IACE,kCAAA;EA6SF;EA3SA;IACE,+BAAA;EA6SF;EA3SA;IACE,kCAAA;EA6SF;EA3SA;IACE,iCAAA;EA6SF;EA3SA;IACE,kCAAA;EA6SF;EA3SA;IACE,+BAAA;EA6SF;EA3SA;IACE,kCAAA;EA6SF;EA3SA;IACE,iCAAA;EA6SF;EA3SA;IACE,kCAAA;EA6SF;EA3SA;IACE,+BAAA;EA6SF;EA3SA;IACE,kCAAA;EA6SF;EA3SA;IACE,iCAAA;EA6SF;EA3SA;IACE,kCAAA;EA6SF;EA3SA;IACE,+BAAA;EA6SF;EA3SA;IACE,kCAAA;EA6SF;EA3SA;IACE,iCAAA;EA6SF;EA3SA;IACE,kCAAA;EA6SF;EA3SA;IACE,+BAAA;EA6SF;EA3SA;IACE,0BAAA;EA6SF;EA3SA;IACE,gCAAA;EA6SF;EA3SA;IACE,+BAAA;EA6SF;EA3SA;IACE,gCAAA;EA6SF;EA3SA;IACE,6BAAA;EA6SF;EA3SA;IACE,gCAAA;EA6SF;EA3SA;IACE,+BAAA;EA6SF;EA3SA;IACE,gCAAA;EA6SF;EA3SA;IACE,6BAAA;EA6SF;EA3SA;IACE,gCAAA;EA6SF;EA3SA;IACE,+BAAA;EA6SF;EA3SA;IACE,gCAAA;EA6SF;EA3SA;IACE,6BAAA;EA6SF;EA3SA;IACE,gCAAA;EA6SF;EA3SA;IACE,+BAAA;EA6SF;EA3SA;IACE,gCAAA;EA6SF;EA3SA;IACE,6BAAA;EA6SF;EA3SA;IACE,gCAAA;EA6SF;EA3SA;IACE,+BAAA;EA6SF;EA3SA;IACE,gCAAA;EA6SF;EA3SA;IACE,6BAAA;EA6SF;EA3SA;IACE,iBAAA;EA6SF;EA3SA;IACE,uBAAA;EA6SF;EA3SA;IACE,sBAAA;EA6SF;EA3SA;IACE,uBAAA;EA6SF;EA3SA;IACE,oBAAA;EA6SF;EA3SA;IACE,uBAAA;EA6SF;EA3SA;IACE,sBAAA;EA6SF;EA3SA;IACE,uBAAA;EA6SF;EA3SA;IACE,oBAAA;EA6SF;EA3SA;IACE,uBAAA;EA6SF;EA3SA;IACE,sBAAA;EA6SF;EA3SA;IACE,uBAAA;EA6SF;EA3SA;IACE,oBAAA;EA6SF;EA3SA;IACE,uBAAA;EA6SF;EA3SA;IACE,sBAAA;EA6SF;EA3SA;IACE,uBAAA;EA6SF;EA3SA;IACE,oBAAA;EA6SF;EA3SA;IACE,uBAAA;EA6SF;EA3SA;IACE,sBAAA;EA6SF;EA3SA;IACE,uBAAA;EA6SF;EA3SA;IACE,oBAAA;EA6SF;EA3SA;IACE,qBAAA;EA6SF;EA3SA;IACE,2BAAA;EA6SF;EA3SA;IACE,0BAAA;EA6SF;EA3SA;IACE,2BAAA;EA6SF;EA3SA;IACE,wBAAA;EA6SF;EA3SA;IACE,2BAAA;EA6SF;EA3SA;IACE,0BAAA;EA6SF;EA3SA;IACE,2BAAA;EA6SF;EA3SA;IACE,wBAAA;EA6SF;EA3SA;IACE,2BAAA;EA6SF;EA3SA;IACE,0BAAA;EA6SF;EA3SA;IACE,2BAAA;EA6SF;EA3SA;IACE,wBAAA;EA6SF;EA3SA;IACE,2BAAA;EA6SF;EA3SA;IACE,0BAAA;EA6SF;EA3SA;IACE,2BAAA;EA6SF;EA3SA;IACE,wBAAA;EA6SF;EA3SA;IACE,2BAAA;EA6SF;EA3SA;IACE,0BAAA;EA6SF;EA3SA;IACE,2BAAA;EA6SF;EA3SA;IACE,wBAAA;EA6SF;EA3SA;IACE,wBAAA;EA6SF;EA3SA;IACE,8BAAA;EA6SF;EA3SA;IACE,6BAAA;EA6SF;EA3SA;IACE,8BAAA;EA6SF;EA3SA;IACE,2BAAA;EA6SF;EA3SA;IACE,8BAAA;EA6SF;EA3SA;IACE,6BAAA;EA6SF;EA3SA;IACE,8BAAA;EA6SF;EA3SA;IACE,2BAAA;EA6SF;EA3SA;IACE,8BAAA;EA6SF;EA3SA;IACE,6BAAA;EA6SF;EA3SA;IACE,8BAAA;EA6SF;EA3SA;IACE,2BAAA;EA6SF;EA3SA;IACE,8BAAA;EA6SF;EA3SA;IACE,6BAAA;EA6SF;EA3SA;IACE,8BAAA;EA6SF;EA3SA;IACE,2BAAA;EA6SF;EA3SA;IACE,8BAAA;EA6SF;EA3SA;IACE,6BAAA;EA6SF;EA3SA;IACE,8BAAA;EA6SF;EA3SA;IACE,2BAAA;EA6SF;EA3SA;IACE,0CAAA;EA6SF;EA3SA;IACE,4CAAA;EA6SF;EA3SA;IACE,4CAAA;EA6SF;EA3SA;IACE,6BAAA;EA6SF;EA3SA;IACE,6BAAA;EA6SF;EA3SA;IACE,8BAAA;EA6SF;EA3SA;IACE,6BAAA;EA6SF;EA3SA;IACE,6BAAA;EA6SF;EA3SA;IACE,6BAAA;EA6SF;EA3SA;IACE,4BAAA;EA6SF;EA3SA;IACE,0BAAA;EA6SF;EA3SA;IACE,0BAAA;EA6SF;EA3SA;IACE,4CAAA;EA6SF;EA3SA;IACE,2CAAA;EA6SF;EA3SA;IACE,4CAAA;EA6SF;EA3SA;IACE,0CAAA;EA6SF;EA3SA;IACE,4CAAA;EA6SF;EA3SA;IACE,2CAAA;EA6SF;EA3SA;IACE,4CAAA;EA6SF;EA3SA;IACE,wCAAA;EA6SF;EA3SA;IACE,4CAAA;EA6SF;EA3SA;IACE,2CAAA;EA6SF;EA3SA;IACE,4CAAA;EA6SF;EA3SA;IACE,0CAAA;EA6SF;EA3SA;IACE,4CAAA;EA6SF;EA3SA;IACE,2CAAA;EA6SF;EA3SA;IACE,4CAAA;EA6SF;EA3SA;IACE,0CAAA;EA6SF;EA3SA;IACE,4CAAA;EA6SF;EA3SA;IACE,yCAAA;EA6SF;EA3SA;IACE,4CAAA;EA6SF;EA3SA;IACE,0CAAA;EA6SF;EA3SA;IACE,4CAAA;EA6SF;EA3SA;IACE,2CAAA;EA6SF;EA3SA;IACE,4CAAA;EA6SF;EA3SA;IACE,0CAAA;EA6SF;EA3SA;IACE,2BAAA;EA6SF;EA3SA;IACE,4BAAA;EA6SF;EA3SA;IACE,6BAAA;EA6SF;EA3SA;IACE,2BAAA;EA6SF;EA3SA;IACE,yBAAA;EA6SF;EA3SA;IACE,yBAAA;EA6SF;EA3SA;IACE,yBAAA;EA6SF;EA3SA;IACE,0BAAA;EA6SF;EA3SA;IACE,0BAAA;EA6SF;EA3SA;IACE,yBAAA;EA6SF;EA3SA;IACE,yBAAA;EA6SF;EA3SA;IACE,yBAAA;EA6SF;EA3SA;IACE,yBAAA;EA6SF;EA3SA;IACE,yBAAA;EA6SF;EA3SA;IACE,yBAAA;EA6SF;EA3SA;IACE,yBAAA;EA6SF;EA3SA;IACE,yBAAA;EA6SF;EA3SA;IACE,yBAAA;EA6SF;EA3SA;IACE,0BAAA;EA6SF;EA3SA;IACE,0BAAA;EA6SF;EA3SA;IACE,0BAAA;EA6SF;EA3SA;IACE,0BAAA;EA6SF;EA3SA;IACE,0BAAA;EA6SF;EA3SA;IACE,0BAAA;EA6SF;EA3SA;IACE,0BAAA;EA6SF;EA3SA;IACE,0BAAA;EA6SF;EA3SA;IACE,0BAAA;EA6SF;EA3SA;IACE,0BAAA;EA6SF;EA3SA;IACE,0BAAA;EA6SF;EA3SA;IACE,0BAAA;EA6SF;EA3SA;IACE,0BAAA;EA6SF;EA3SA;IACE,0BAAA;EA6SF;EA3SA;IACE,0BAAA;EA6SF;EA3SA;IACE,0BAAA;EA6SF;EA3SA;IACE,0BAAA;EA6SF;EA3SA;IACE,0BAAA;EA6SF;EA3SA;IACE,2BAAA;EA6SF;EA3SA;IACE,2BAAA;EA6SF;EA3SA;IACE,2BAAA;EA6SF;EA3SA;IACE,2BAAA;EA6SF;EA3SA;IACE,2BAAA;EA6SF;EA3SA;IACE,2BAAA;EA6SF;EA3SA;IACE,2BAAA;EA6SF;EA3SA;IACE,2BAAA;EA6SF;EA3SA;IACE,2BAAA;EA6SF;EA3SA;IACE,2BAAA;EA6SF;EA3SA;IACE,2BAAA;EA6SF;EA3SA;IACE,2BAAA;EA6SF;EA3SA;IACE,2BAAA;EA6SF;EA3SA;IACE,2BAAA;EA6SF;EA3SA;IACE,2BAAA;EA6SF;EA3SA;IACE,2BAAA;EA6SF;EA3SA;IACE,2BAAA;EA6SF;EA3SA;IACE,2BAAA;EA6SF;EA3SA;IACE,2BAAA;EA6SF;EA3SA;IACE,2BAAA;EA6SF;EA3SA;IACE,2BAAA;EA6SF;EA3SA;IACE,2BAAA;EA6SF;EA3SA;IACE,2BAAA;EA6SF;EA3SA;IACE,2BAAA;EA6SF;EA3SA;IACE,2BAAA;EA6SF;EA3SA;IACE,2BAAA;EA6SF;EA3SA;IACE,4BAAA;EA6SF;EA3SA;IACE,4BAAA;EA6SF;EA3SA;IACE,0BAAA;EA6SF;EA3SA;IACE,0BAAA;EA6SF;EA3SA;IACE,0BAAA;EA6SF;EA3SA;IACE,2BAAA;EA6SF;EA3SA;IACE,2BAAA;EA6SF;EA3SA;IACE,0BAAA;EA6SF;EA3SA;IACE,0BAAA;EA6SF;EA3SA;IACE,0BAAA;EA6SF;EA3SA;IACE,0BAAA;EA6SF;EA3SA;IACE,0BAAA;EA6SF;EA3SA;IACE,0BAAA;EA6SF;EA3SA;IACE,0BAAA;EA6SF;EA3SA;IACE,0BAAA;EA6SF;EA3SA;IACE,0BAAA;EA6SF;EA3SA;IACE,2BAAA;EA6SF;EA3SA;IACE,2BAAA;EA6SF;EA3SA;IACE,2BAAA;EA6SF;EA3SA;IACE,2BAAA;EA6SF;EA3SA;IACE,2BAAA;EA6SF;EA3SA;IACE,2BAAA;EA6SF;EA3SA;IACE,2BAAA;EA6SF;EA3SA;IACE,2BAAA;EA6SF;EA3SA;IACE,2BAAA;EA6SF;EA3SA;IACE,2BAAA;EA6SF;EA3SA;IACE,2BAAA;EA6SF;EA3SA;IACE,2BAAA;EA6SF;EA3SA;IACE,2BAAA;EA6SF;EA3SA;IACE,2BAAA;EA6SF;EA3SA;IACE,2BAAA;EA6SF;EA3SA;IACE,2BAAA;EA6SF;EA3SA;IACE,2BAAA;EA6SF;EA3SA;IACE,2BAAA;EA6SF;EA3SA;IACE,4BAAA;EA6SF;EA3SA;IACE,4BAAA;EA6SF;EA3SA;IACE,4BAAA;EA6SF;EA3SA;IACE,4BAAA;EA6SF;EA3SA;IACE,4BAAA;EA6SF;EA3SA;IACE,4BAAA;EA6SF;EA3SA;IACE,4BAAA;EA6SF;EA3SA;IACE,4BAAA;EA6SF;EA3SA;IACE,4BAAA;EA6SF;EA3SA;IACE,4BAAA;EA6SF;EA3SA;IACE,4BAAA;EA6SF;EA3SA;IACE,4BAAA;EA6SF;EA3SA;IACE,4BAAA;EA6SF;EA3SA;IACE,4BAAA;EA6SF;EA3SA;IACE,4BAAA;EA6SF;EA3SA;IACE,4BAAA;EA6SF;EA3SA;IACE,4BAAA;EA6SF;EA3SA;IACE,4BAAA;EA6SF;EA3SA;IACE,4BAAA;EA6SF;EA3SA;IACE,4BAAA;EA6SF;EA3SA;IACE,4BAAA;EA6SF;EA3SA;IACE,4BAAA;EA6SF;EA3SA;IACE,4BAAA;EA6SF;EA3SA;IACE,4BAAA;EA6SF;EA3SA;IACE,4BAAA;EA6SF;EA3SA;IACE,4BAAA;EA6SF;EA3SA;IACE,6BAAA;EA6SF;AACF;AA3SA;EACE;IACE,sBAAA;EA6SF;EA3SA;IACE,uBAAA;EA6SF;EA3SA;IACE,sBAAA;EA6SF;EA3SA;IACE,8BAAA;EA6SF;EA3SA;IACE,4BAAA;EA6SF;EA3SA;IACE,2BAAA;EA6SF;EA3SA;IACE,iCAAA;EA6SF;EA3SA;IACE,2BAAA;EA6SF;EA3SA;IACE,yBAAA;EA6SF;EA3SA;IACE,2BAAA;EA6SF;EA3SA;IACE,4BAAA;EA6SF;EA3SA;IACE,2BAAA;EA6SF;EA3SA;IACE,0BAAA;EA6SF;EA3SA;IACE,gCAAA;EA6SF;EA3SA;IACE,yBAAA;EA6SF;EA3SA;IACE,wBAAA;EA6SF;EA3SA;IACE,yBAAA;EA6SF;EA3SA;IACE,6BAAA;EA6SF;EA3SA;IACE,8BAAA;EA6SF;EA3SA;IACE,wBAAA;EA6SF;EA3SA;IACE,+BAAA;EA6SF;EA3SA;IACE,wBAAA;EA6SF;EA3SA;IACE,2BAAA;EA6SF;EA3SA;IACE,6BAAA;EA6SF;EA3SA;IACE,6BAAA;EA6SF;EA3SA;IACE,0BAAA;EA6SF;EA3SA;IACE,2BAAA;EA6SF;EA3SA;IACE,uBAAA;EA6SF;EA3SA;IACE,qBAAA;EA6SF;EA3SA;IACE,qBAAA;EA6SF;EA3SA;IACE,qBAAA;EA6SF;EA3SA;IACE,sBAAA;EA6SF;EA3SA;IACE,sBAAA;EA6SF;EA3SA;IACE,qBAAA;EA6SF;EA3SA;IACE,qBAAA;EA6SF;EA3SA;IACE,qBAAA;EA6SF;EA3SA;IACE,qBAAA;EA6SF;EA3SA;IACE,qBAAA;EA6SF;EA3SA;IACE,qBAAA;EA6SF;EA3SA;IACE,qBAAA;EA6SF;EA3SA;IACE,qBAAA;EA6SF;EA3SA;IACE,qBAAA;EA6SF;EA3SA;IACE,sBAAA;EA6SF;EA3SA;IACE,sBAAA;EA6SF;EA3SA;IACE,sBAAA;EA6SF;EA3SA;IACE,sBAAA;EA6SF;EA3SA;IACE,sBAAA;EA6SF;EA3SA;IACE,sBAAA;EA6SF;EA3SA;IACE,sBAAA;EA6SF;EA3SA;IACE,sBAAA;EA6SF;EA3SA;IACE,sBAAA;EA6SF;EA3SA;IACE,sBAAA;EA6SF;EA3SA;IACE,sBAAA;EA6SF;EA3SA;IACE,sBAAA;EA6SF;EA3SA;IACE,sBAAA;EA6SF;EA3SA;IACE,sBAAA;EA6SF;EA3SA;IACE,sBAAA;EA6SF;EA3SA;IACE,sBAAA;EA6SF;EA3SA;IACE,sBAAA;EA6SF;EA3SA;IACE,sBAAA;EA6SF;EA3SA;IACE,uBAAA;EA6SF;EA3SA;IACE,uBAAA;EA6SF;EA3SA;IACE,uBAAA;EA6SF;EA3SA;IACE,uBAAA;EA6SF;EA3SA;IACE,uBAAA;EA6SF;EA3SA;IACE,uBAAA;EA6SF;EA3SA;IACE,uBAAA;EA6SF;EA3SA;IACE,uBAAA;EA6SF;EA3SA;IACE,uBAAA;EA6SF;EA3SA;IACE,uBAAA;EA6SF;EA3SA;IACE,uBAAA;EA6SF;EA3SA;IACE,uBAAA;EA6SF;EA3SA;IACE,uBAAA;EA6SF;EA3SA;IACE,uBAAA;EA6SF;EA3SA;IACE,uBAAA;EA6SF;EA3SA;IACE,uBAAA;EA6SF;EA3SA;IACE,uBAAA;EA6SF;EA3SA;IACE,uBAAA;EA6SF;EA3SA;IACE,uBAAA;EA6SF;EA3SA;IACE,uBAAA;EA6SF;EA3SA;IACE,uBAAA;EA6SF;EA3SA;IACE,uBAAA;EA6SF;EA3SA;IACE,uBAAA;EA6SF;EA3SA;IACE,uBAAA;EA6SF;EA3SA;IACE,uBAAA;EA6SF;EA3SA;IACE,uBAAA;EA6SF;EA3SA;IACE,wBAAA;EA6SF;EA3SA;IACE,2BAAA;EA6SF;EA3SA;IACE,yBAAA;EA6SF;EA3SA;IACE,yBAAA;EA6SF;EA3SA;IACE,yBAAA;EA6SF;EA3SA;IACE,0BAAA;EA6SF;EA3SA;IACE,0BAAA;EA6SF;EA3SA;IACE,yBAAA;EA6SF;EA3SA;IACE,yBAAA;EA6SF;EA3SA;IACE,yBAAA;EA6SF;EA3SA;IACE,yBAAA;EA6SF;EA3SA;IACE,yBAAA;EA6SF;EA3SA;IACE,yBAAA;EA6SF;EA3SA;IACE,yBAAA;EA6SF;EA3SA;IACE,yBAAA;EA6SF;EA3SA;IACE,yBAAA;EA6SF;EA3SA;IACE,0BAAA;EA6SF;EA3SA;IACE,0BAAA;EA6SF;EA3SA;IACE,0BAAA;EA6SF;EA3SA;IACE,0BAAA;EA6SF;EA3SA;IACE,0BAAA;EA6SF;EA3SA;IACE,0BAAA;EA6SF;EA3SA;IACE,0BAAA;EA6SF;EA3SA;IACE,0BAAA;EA6SF;EA3SA;IACE,0BAAA;EA6SF;EA3SA;IACE,0BAAA;EA6SF;EA3SA;IACE,0BAAA;EA6SF;EA3SA;IACE,0BAAA;EA6SF;EA3SA;IACE,0BAAA;EA6SF;EA3SA;IACE,0BAAA;EA6SF;EA3SA;IACE,0BAAA;EA6SF;EA3SA;IACE,0BAAA;EA6SF;EA3SA;IACE,0BAAA;EA6SF;EA3SA;IACE,0BAAA;EA6SF;EA3SA;IACE,2BAAA;EA6SF;EA3SA;IACE,2BAAA;EA6SF;EA3SA;IACE,2BAAA;EA6SF;EA3SA;IACE,2BAAA;EA6SF;EA3SA;IACE,2BAAA;EA6SF;EA3SA;IACE,2BAAA;EA6SF;EA3SA;IACE,2BAAA;EA6SF;EA3SA;IACE,2BAAA;EA6SF;EA3SA;IACE,2BAAA;EA6SF;EA3SA;IACE,2BAAA;EA6SF;EA3SA;IACE,2BAAA;EA6SF;EA3SA;IACE,2BAAA;EA6SF;EA3SA;IACE,2BAAA;EA6SF;EA3SA;IACE,2BAAA;EA6SF;EA3SA;IACE,2BAAA;EA6SF;EA3SA;IACE,2BAAA;EA6SF;EA3SA;IACE,2BAAA;EA6SF;EA3SA;IACE,2BAAA;EA6SF;EA3SA;IACE,2BAAA;EA6SF;EA3SA;IACE,2BAAA;EA6SF;EA3SA;IACE,2BAAA;EA6SF;EA3SA;IACE,2BAAA;EA6SF;EA3SA;IACE,2BAAA;EA6SF;EA3SA;IACE,2BAAA;EA6SF;EA3SA;IACE,2BAAA;EA6SF;EA3SA;IACE,2BAAA;EA6SF;EA3SA;IACE,4BAAA;EA6SF;EA3SA;IACE,wBAAA;EA6SF;EA3SA;IACE,sBAAA;EA6SF;EA3SA;IACE,sBAAA;EA6SF;EA3SA;IACE,sBAAA;EA6SF;EA3SA;IACE,uBAAA;EA6SF;EA3SA;IACE,uBAAA;EA6SF;EA3SA;IACE,sBAAA;EA6SF;EA3SA;IACE,sBAAA;EA6SF;EA3SA;IACE,sBAAA;EA6SF;EA3SA;IACE,sBAAA;EA6SF;EA3SA;IACE,sBAAA;EA6SF;EA3SA;IACE,sBAAA;EA6SF;EA3SA;IACE,sBAAA;EA6SF;EA3SA;IACE,sBAAA;EA6SF;EA3SA;IACE,sBAAA;EA6SF;EA3SA;IACE,uBAAA;EA6SF;EA3SA;IACE,uBAAA;EA6SF;EA3SA;IACE,uBAAA;EA6SF;EA3SA;IACE,uBAAA;EA6SF;EA3SA;IACE,uBAAA;EA6SF;EA3SA;IACE,uBAAA;EA6SF;EA3SA;IACE,uBAAA;EA6SF;EA3SA;IACE,uBAAA;EA6SF;EA3SA;IACE,uBAAA;EA6SF;EA3SA;IACE,uBAAA;EA6SF;EA3SA;IACE,uBAAA;EA6SF;EA3SA;IACE,uBAAA;EA6SF;EA3SA;IACE,uBAAA;EA6SF;EA3SA;IACE,uBAAA;EA6SF;EA3SA;IACE,uBAAA;EA6SF;EA3SA;IACE,uBAAA;EA6SF;EA3SA;IACE,uBAAA;EA6SF;EA3SA;IACE,uBAAA;EA6SF;EA3SA;IACE,wBAAA;EA6SF;EA3SA;IACE,wBAAA;EA6SF;EA3SA;IACE,wBAAA;EA6SF;EA3SA;IACE,wBAAA;EA6SF;EA3SA;IACE,wBAAA;EA6SF;EA3SA;IACE,wBAAA;EA6SF;EA3SA;IACE,wBAAA;EA6SF;EA3SA;IACE,wBAAA;EA6SF;EA3SA;IACE,wBAAA;EA6SF;EA3SA;IACE,wBAAA;EA6SF;EA3SA;IACE,wBAAA;EA6SF;EA3SA;IACE,wBAAA;EA6SF;EA3SA;IACE,wBAAA;EA6SF;EA3SA;IACE,wBAAA;EA6SF;EA3SA;IACE,wBAAA;EA6SF;EA3SA;IACE,wBAAA;EA6SF;EA3SA;IACE,wBAAA;EA6SF;EA3SA;IACE,wBAAA;EA6SF;EA3SA;IACE,wBAAA;EA6SF;EA3SA;IACE,wBAAA;EA6SF;EA3SA;IACE,wBAAA;EA6SF;EA3SA;IACE,wBAAA;EA6SF;EA3SA;IACE,wBAAA;EA6SF;EA3SA;IACE,wBAAA;EA6SF;EA3SA;IACE,wBAAA;EA6SF;EA3SA;IACE,wBAAA;EA6SF;EA3SA;IACE,yBAAA;EA6SF;EA3SA;IACE,4BAAA;EA6SF;EA3SA;IACE,0BAAA;EA6SF;EA3SA;IACE,0BAAA;EA6SF;EA3SA;IACE,0BAAA;EA6SF;EA3SA;IACE,2BAAA;EA6SF;EA3SA;IACE,2BAAA;EA6SF;EA3SA;IACE,0BAAA;EA6SF;EA3SA;IACE,0BAAA;EA6SF;EA3SA;IACE,0BAAA;EA6SF;EA3SA;IACE,0BAAA;EA6SF;EA3SA;IACE,0BAAA;EA6SF;EA3SA;IACE,0BAAA;EA6SF;EA3SA;IACE,0BAAA;EA6SF;EA3SA;IACE,0BAAA;EA6SF;EA3SA;IACE,0BAAA;EA6SF;EA3SA;IACE,2BAAA;EA6SF;EA3SA;IACE,2BAAA;EA6SF;EA3SA;IACE,2BAAA;EA6SF;EA3SA;IACE,2BAAA;EA6SF;EA3SA;IACE,2BAAA;EA6SF;EA3SA;IACE,2BAAA;EA6SF;EA3SA;IACE,2BAAA;EA6SF;EA3SA;IACE,2BAAA;EA6SF;EA3SA;IACE,2BAAA;EA6SF;EA3SA;IACE,2BAAA;EA6SF;EA3SA;IACE,2BAAA;EA6SF;EA3SA;IACE,2BAAA;EA6SF;EA3SA;IACE,2BAAA;EA6SF;EA3SA;IACE,2BAAA;EA6SF;EA3SA;IACE,2BAAA;EA6SF;EA3SA;IACE,2BAAA;EA6SF;EA3SA;IACE,2BAAA;EA6SF;EA3SA;IACE,2BAAA;EA6SF;EA3SA;IACE,4BAAA;EA6SF;EA3SA;IACE,4BAAA;EA6SF;EA3SA;IACE,4BAAA;EA6SF;EA3SA;IACE,4BAAA;EA6SF;EA3SA;IACE,4BAAA;EA6SF;EA3SA;IACE,4BAAA;EA6SF;EA3SA;IACE,4BAAA;EA6SF;EA3SA;IACE,4BAAA;EA6SF;EA3SA;IACE,4BAAA;EA6SF;EA3SA;IACE,4BAAA;EA6SF;EA3SA;IACE,4BAAA;EA6SF;EA3SA;IACE,4BAAA;EA6SF;EA3SA;IACE,4BAAA;EA6SF;EA3SA;IACE,4BAAA;EA6SF;EA3SA;IACE,4BAAA;EA6SF;EA3SA;IACE,4BAAA;EA6SF;EA3SA;IACE,4BAAA;EA6SF;EA3SA;IACE,4BAAA;EA6SF;EA3SA;IACE,4BAAA;EA6SF;EA3SA;IACE,4BAAA;EA6SF;EA3SA;IACE,4BAAA;EA6SF;EA3SA;IACE,4BAAA;EA6SF;EA3SA;IACE,4BAAA;EA6SF;EA3SA;IACE,4BAAA;EA6SF;EA3SA;IACE,4BAAA;EA6SF;EA3SA;IACE,4BAAA;EA6SF;EA3SA;IACE,6BAAA;EA6SF;EA3SA;IACE,yBAAA;EA6SF;EA3SA;IACE,8BAAA;EA6SF;EA3SA;IACE,iCAAA;EA6SF;EA3SA;IACE,sCAAA;EA6SF;EA3SA;IACE,yCAAA;EA6SF;EA3SA;IACE,uBAAA;EA6SF;EA3SA;IACE,uBAAA;EA6SF;EA3SA;IACE,yBAAA;EA6SF;EA3SA;IACE,yBAAA;EA6SF;EA3SA;IACE,0BAAA;EA6SF;EA3SA;IACE,4BAAA;EA6SF;EA3SA;IACE,kCAAA;EA6SF;EA3SA;IACE,sCAAA;EA6SF;EA3SA;IACE,oCAAA;EA6SF;EA3SA;IACE,kCAAA;EA6SF;EA3SA;IACE,yCAAA;EA6SF;EA3SA;IACE,wCAAA;EA6SF;EA3SA;IACE,wCAAA;EA6SF;EA3SA;IACE,kCAAA;EA6SF;EA3SA;IACE,gCAAA;EA6SF;EA3SA;IACE,8BAAA;EA6SF;EA3SA;IACE,gCAAA;EA6SF;EA3SA;IACE,+BAAA;EA6SF;EA3SA;IACE,oCAAA;EA6SF;EA3SA;IACE,kCAAA;EA6SF;EA3SA;IACE,gCAAA;EA6SF;EA3SA;IACE,uCAAA;EA6SF;EA3SA;IACE,sCAAA;EA6SF;EA3SA;IACE,iCAAA;EA6SF;EA3SA;IACE,2BAAA;EA6SF;EA3SA;IACE,iCAAA;EA6SF;EA3SA;IACE,+BAAA;EA6SF;EA3SA;IACE,6BAAA;EA6SF;EA3SA;IACE,+BAAA;EA6SF;EA3SA;IACE,8BAAA;EA6SF;EA3SA;IACE,oBAAA;EA6SF;EA3SA;IACE,mBAAA;EA6SF;EA3SA;IACE,mBAAA;EA6SF;EA3SA;IACE,mBAAA;EA6SF;EA3SA;IACE,mBAAA;EA6SF;EA3SA;IACE,mBAAA;EA6SF;EA3SA;IACE,mBAAA;EA6SF;EA3SA;IACE,mBAAA;EA6SF;EA3SA;IACE,oBAAA;EA6SF;EA3SA;IACE,0BAAA;EA6SF;EA3SA;IACE,yBAAA;EA6SF;EA3SA;IACE,0BAAA;EA6SF;EA3SA;IACE,uBAAA;EA6SF;EA3SA;IACE,0BAAA;EA6SF;EA3SA;IACE,yBAAA;EA6SF;EA3SA;IACE,0BAAA;EA6SF;EA3SA;IACE,uBAAA;EA6SF;EA3SA;IACE,0BAAA;EA6SF;EA3SA;IACE,yBAAA;EA6SF;EA3SA;IACE,0BAAA;EA6SF;EA3SA;IACE,uBAAA;EA6SF;EA3SA;IACE,0BAAA;EA6SF;EA3SA;IACE,yBAAA;EA6SF;EA3SA;IACE,0BAAA;EA6SF;EA3SA;IACE,uBAAA;EA6SF;EA3SA;IACE,0BAAA;EA6SF;EA3SA;IACE,yBAAA;EA6SF;EA3SA;IACE,0BAAA;EA6SF;EA3SA;IACE,uBAAA;EA6SF;EA3SA;IACE,uBAAA;EA6SF;EA3SA;IACE,0BAAA;IACA,yBAAA;EA6SF;EA3SA;IACE,gCAAA;IACA,+BAAA;EA6SF;EA3SA;IACE,+BAAA;IACA,8BAAA;EA6SF;EA3SA;IACE,gCAAA;IACA,+BAAA;EA6SF;EA3SA;IACE,6BAAA;IACA,4BAAA;EA6SF;EA3SA;IACE,gCAAA;IACA,+BAAA;EA6SF;EA3SA;IACE,+BAAA;IACA,8BAAA;EA6SF;EA3SA;IACE,gCAAA;IACA,+BAAA;EA6SF;EA3SA;IACE,6BAAA;IACA,4BAAA;EA6SF;EA3SA;IACE,gCAAA;IACA,+BAAA;EA6SF;EA3SA;IACE,+BAAA;IACA,8BAAA;EA6SF;EA3SA;IACE,gCAAA;IACA,+BAAA;EA6SF;EA3SA;IACE,6BAAA;IACA,4BAAA;EA6SF;EA3SA;IACE,gCAAA;IACA,+BAAA;EA6SF;EA3SA;IACE,+BAAA;IACA,8BAAA;EA6SF;EA3SA;IACE,gCAAA;IACA,+BAAA;EA6SF;EA3SA;IACE,6BAAA;IACA,4BAAA;EA6SF;EA3SA;IACE,gCAAA;IACA,+BAAA;EA6SF;EA3SA;IACE,+BAAA;IACA,8BAAA;EA6SF;EA3SA;IACE,gCAAA;IACA,+BAAA;EA6SF;EA3SA;IACE,6BAAA;IACA,4BAAA;EA6SF;EA3SA;IACE,6BAAA;IACA,4BAAA;EA6SF;EA3SA;IACE,wBAAA;IACA,2BAAA;EA6SF;EA3SA;IACE,8BAAA;IACA,iCAAA;EA6SF;EA3SA;IACE,6BAAA;IACA,gCAAA;EA6SF;EA3SA;IACE,8BAAA;IACA,iCAAA;EA6SF;EA3SA;IACE,2BAAA;IACA,8BAAA;EA6SF;EA3SA;IACE,8BAAA;IACA,iCAAA;EA6SF;EA3SA;IACE,6BAAA;IACA,gCAAA;EA6SF;EA3SA;IACE,8BAAA;IACA,iCAAA;EA6SF;EA3SA;IACE,2BAAA;IACA,8BAAA;EA6SF;EA3SA;IACE,8BAAA;IACA,iCAAA;EA6SF;EA3SA;IACE,6BAAA;IACA,gCAAA;EA6SF;EA3SA;IACE,8BAAA;IACA,iCAAA;EA6SF;EA3SA;IACE,2BAAA;IACA,8BAAA;EA6SF;EA3SA;IACE,8BAAA;IACA,iCAAA;EA6SF;EA3SA;IACE,6BAAA;IACA,gCAAA;EA6SF;EA3SA;IACE,8BAAA;IACA,iCAAA;EA6SF;EA3SA;IACE,2BAAA;IACA,8BAAA;EA6SF;EA3SA;IACE,8BAAA;IACA,iCAAA;EA6SF;EA3SA;IACE,6BAAA;IACA,gCAAA;EA6SF;EA3SA;IACE,8BAAA;IACA,iCAAA;EA6SF;EA3SA;IACE,2BAAA;IACA,8BAAA;EA6SF;EA3SA;IACE,2BAAA;IACA,8BAAA;EA6SF;EA3SA;IACE,wBAAA;EA6SF;EA3SA;IACE,8BAAA;EA6SF;EA3SA;IACE,6BAAA;EA6SF;EA3SA;IACE,8BAAA;EA6SF;EA3SA;IACE,2BAAA;EA6SF;EA3SA;IACE,8BAAA;EA6SF;EA3SA;IACE,6BAAA;EA6SF;EA3SA;IACE,8BAAA;EA6SF;EA3SA;IACE,2BAAA;EA6SF;EA3SA;IACE,8BAAA;EA6SF;EA3SA;IACE,6BAAA;EA6SF;EA3SA;IACE,8BAAA;EA6SF;EA3SA;IACE,2BAAA;EA6SF;EA3SA;IACE,8BAAA;EA6SF;EA3SA;IACE,6BAAA;EA6SF;EA3SA;IACE,8BAAA;EA6SF;EA3SA;IACE,2BAAA;EA6SF;EA3SA;IACE,8BAAA;EA6SF;EA3SA;IACE,6BAAA;EA6SF;EA3SA;IACE,8BAAA;EA6SF;EA3SA;IACE,2BAAA;EA6SF;EA3SA;IACE,2BAAA;EA6SF;EA3SA;IACE,0BAAA;EA6SF;EA3SA;IACE,gCAAA;EA6SF;EA3SA;IACE,+BAAA;EA6SF;EA3SA;IACE,gCAAA;EA6SF;EA3SA;IACE,6BAAA;EA6SF;EA3SA;IACE,gCAAA;EA6SF;EA3SA;IACE,+BAAA;EA6SF;EA3SA;IACE,gCAAA;EA6SF;EA3SA;IACE,6BAAA;EA6SF;EA3SA;IACE,gCAAA;EA6SF;EA3SA;IACE,+BAAA;EA6SF;EA3SA;IACE,gCAAA;EA6SF;EA3SA;IACE,6BAAA;EA6SF;EA3SA;IACE,gCAAA;EA6SF;EA3SA;IACE,+BAAA;EA6SF;EA3SA;IACE,gCAAA;EA6SF;EA3SA;IACE,6BAAA;EA6SF;EA3SA;IACE,gCAAA;EA6SF;EA3SA;IACE,+BAAA;EA6SF;EA3SA;IACE,gCAAA;EA6SF;EA3SA;IACE,6BAAA;EA6SF;EA3SA;IACE,6BAAA;EA6SF;EA3SA;IACE,2BAAA;EA6SF;EA3SA;IACE,iCAAA;EA6SF;EA3SA;IACE,gCAAA;EA6SF;EA3SA;IACE,iCAAA;EA6SF;EA3SA;IACE,8BAAA;EA6SF;EA3SA;IACE,iCAAA;EA6SF;EA3SA;IACE,gCAAA;EA6SF;EA3SA;IACE,iCAAA;EA6SF;EA3SA;IACE,8BAAA;EA6SF;EA3SA;IACE,iCAAA;EA6SF;EA3SA;IACE,gCAAA;EA6SF;EA3SA;IACE,iCAAA;EA6SF;EA3SA;IACE,8BAAA;EA6SF;EA3SA;IACE,iCAAA;EA6SF;EA3SA;IACE,gCAAA;EA6SF;EA3SA;IACE,iCAAA;EA6SF;EA3SA;IACE,8BAAA;EA6SF;EA3SA;IACE,iCAAA;EA6SF;EA3SA;IACE,gCAAA;EA6SF;EA3SA;IACE,iCAAA;EA6SF;EA3SA;IACE,8BAAA;EA6SF;EA3SA;IACE,8BAAA;EA6SF;EA3SA;IACE,yBAAA;EA6SF;EA3SA;IACE,+BAAA;EA6SF;EA3SA;IACE,8BAAA;EA6SF;EA3SA;IACE,+BAAA;EA6SF;EA3SA;IACE,4BAAA;EA6SF;EA3SA;IACE,+BAAA;EA6SF;EA3SA;IACE,8BAAA;EA6SF;EA3SA;IACE,+BAAA;EA6SF;EA3SA;IACE,4BAAA;EA6SF;EA3SA;IACE,+BAAA;EA6SF;EA3SA;IACE,8BAAA;EA6SF;EA3SA;IACE,+BAAA;EA6SF;EA3SA;IACE,4BAAA;EA6SF;EA3SA;IACE,+BAAA;EA6SF;EA3SA;IACE,8BAAA;EA6SF;EA3SA;IACE,+BAAA;EA6SF;EA3SA;IACE,4BAAA;EA6SF;EA3SA;IACE,+BAAA;EA6SF;EA3SA;IACE,8BAAA;EA6SF;EA3SA;IACE,+BAAA;EA6SF;EA3SA;IACE,4BAAA;EA6SF;EA3SA;IACE,4BAAA;EA6SF;EA3SA;IACE,2BAAA;EA6SF;EA3SA;IACE,0BAAA;EA6SF;EA3SA;IACE,2BAAA;EA6SF;EA3SA;IACE,wBAAA;EA6SF;EA3SA;IACE,2BAAA;EA6SF;EA3SA;IACE,0BAAA;EA6SF;EA3SA;IACE,2BAAA;EA6SF;EA3SA;IACE,wBAAA;EA6SF;EA3SA;IACE,2BAAA;EA6SF;EA3SA;IACE,0BAAA;EA6SF;EA3SA;IACE,2BAAA;EA6SF;EA3SA;IACE,wBAAA;EA6SF;EA3SA;IACE,2BAAA;EA6SF;EA3SA;IACE,0BAAA;EA6SF;EA3SA;IACE,2BAAA;EA6SF;EA3SA;IACE,wBAAA;EA6SF;EA3SA;IACE,2BAAA;EA6SF;EA3SA;IACE,0BAAA;EA6SF;EA3SA;IACE,2BAAA;EA6SF;EA3SA;IACE,wBAAA;EA6SF;EA3SA;IACE,iCAAA;IACA,gCAAA;EA6SF;EA3SA;IACE,gCAAA;IACA,+BAAA;EA6SF;EA3SA;IACE,iCAAA;IACA,gCAAA;EA6SF;EA3SA;IACE,8BAAA;IACA,6BAAA;EA6SF;EA3SA;IACE,iCAAA;IACA,gCAAA;EA6SF;EA3SA;IACE,gCAAA;IACA,+BAAA;EA6SF;EA3SA;IACE,iCAAA;IACA,gCAAA;EA6SF;EA3SA;IACE,8BAAA;IACA,6BAAA;EA6SF;EA3SA;IACE,iCAAA;IACA,gCAAA;EA6SF;EA3SA;IACE,gCAAA;IACA,+BAAA;EA6SF;EA3SA;IACE,iCAAA;IACA,gCAAA;EA6SF;EA3SA;IACE,8BAAA;IACA,6BAAA;EA6SF;EA3SA;IACE,iCAAA;IACA,gCAAA;EA6SF;EA3SA;IACE,gCAAA;IACA,+BAAA;EA6SF;EA3SA;IACE,iCAAA;IACA,gCAAA;EA6SF;EA3SA;IACE,8BAAA;IACA,6BAAA;EA6SF;EA3SA;IACE,iCAAA;IACA,gCAAA;EA6SF;EA3SA;IACE,gCAAA;IACA,+BAAA;EA6SF;EA3SA;IACE,iCAAA;IACA,gCAAA;EA6SF;EA3SA;IACE,8BAAA;IACA,6BAAA;EA6SF;EA3SA;IACE,+BAAA;IACA,kCAAA;EA6SF;EA3SA;IACE,8BAAA;IACA,iCAAA;EA6SF;EA3SA;IACE,+BAAA;IACA,kCAAA;EA6SF;EA3SA;IACE,4BAAA;IACA,+BAAA;EA6SF;EA3SA;IACE,+BAAA;IACA,kCAAA;EA6SF;EA3SA;IACE,8BAAA;IACA,iCAAA;EA6SF;EA3SA;IACE,+BAAA;IACA,kCAAA;EA6SF;EA3SA;IACE,4BAAA;IACA,+BAAA;EA6SF;EA3SA;IACE,+BAAA;IACA,kCAAA;EA6SF;EA3SA;IACE,8BAAA;IACA,iCAAA;EA6SF;EA3SA;IACE,+BAAA;IACA,kCAAA;EA6SF;EA3SA;IACE,4BAAA;IACA,+BAAA;EA6SF;EA3SA;IACE,+BAAA;IACA,kCAAA;EA6SF;EA3SA;IACE,8BAAA;IACA,iCAAA;EA6SF;EA3SA;IACE,+BAAA;IACA,kCAAA;EA6SF;EA3SA;IACE,4BAAA;IACA,+BAAA;EA6SF;EA3SA;IACE,+BAAA;IACA,kCAAA;EA6SF;EA3SA;IACE,8BAAA;IACA,iCAAA;EA6SF;EA3SA;IACE,+BAAA;IACA,kCAAA;EA6SF;EA3SA;IACE,4BAAA;IACA,+BAAA;EA6SF;EA3SA;IACE,+BAAA;EA6SF;EA3SA;IACE,8BAAA;EA6SF;EA3SA;IACE,+BAAA;EA6SF;EA3SA;IACE,4BAAA;EA6SF;EA3SA;IACE,+BAAA;EA6SF;EA3SA;IACE,8BAAA;EA6SF;EA3SA;IACE,+BAAA;EA6SF;EA3SA;IACE,4BAAA;EA6SF;EA3SA;IACE,+BAAA;EA6SF;EA3SA;IACE,8BAAA;EA6SF;EA3SA;IACE,+BAAA;EA6SF;EA3SA;IACE,4BAAA;EA6SF;EA3SA;IACE,+BAAA;EA6SF;EA3SA;IACE,8BAAA;EA6SF;EA3SA;IACE,+BAAA;EA6SF;EA3SA;IACE,4BAAA;EA6SF;EA3SA;IACE,+BAAA;EA6SF;EA3SA;IACE,8BAAA;EA6SF;EA3SA;IACE,+BAAA;EA6SF;EA3SA;IACE,4BAAA;EA6SF;EA3SA;IACE,iCAAA;EA6SF;EA3SA;IACE,gCAAA;EA6SF;EA3SA;IACE,iCAAA;EA6SF;EA3SA;IACE,8BAAA;EA6SF;EA3SA;IACE,iCAAA;EA6SF;EA3SA;IACE,gCAAA;EA6SF;EA3SA;IACE,iCAAA;EA6SF;EA3SA;IACE,8BAAA;EA6SF;EA3SA;IACE,iCAAA;EA6SF;EA3SA;IACE,gCAAA;EA6SF;EA3SA;IACE,iCAAA;EA6SF;EA3SA;IACE,8BAAA;EA6SF;EA3SA;IACE,iCAAA;EA6SF;EA3SA;IACE,gCAAA;EA6SF;EA3SA;IACE,iCAAA;EA6SF;EA3SA;IACE,8BAAA;EA6SF;EA3SA;IACE,iCAAA;EA6SF;EA3SA;IACE,gCAAA;EA6SF;EA3SA;IACE,iCAAA;EA6SF;EA3SA;IACE,8BAAA;EA6SF;EA3SA;IACE,kCAAA;EA6SF;EA3SA;IACE,iCAAA;EA6SF;EA3SA;IACE,kCAAA;EA6SF;EA3SA;IACE,+BAAA;EA6SF;EA3SA;IACE,kCAAA;EA6SF;EA3SA;IACE,iCAAA;EA6SF;EA3SA;IACE,kCAAA;EA6SF;EA3SA;IACE,+BAAA;EA6SF;EA3SA;IACE,kCAAA;EA6SF;EA3SA;IACE,iCAAA;EA6SF;EA3SA;IACE,kCAAA;EA6SF;EA3SA;IACE,+BAAA;EA6SF;EA3SA;IACE,kCAAA;EA6SF;EA3SA;IACE,iCAAA;EA6SF;EA3SA;IACE,kCAAA;EA6SF;EA3SA;IACE,+BAAA;EA6SF;EA3SA;IACE,kCAAA;EA6SF;EA3SA;IACE,iCAAA;EA6SF;EA3SA;IACE,kCAAA;EA6SF;EA3SA;IACE,+BAAA;EA6SF;EA3SA;IACE,gCAAA;EA6SF;EA3SA;IACE,+BAAA;EA6SF;EA3SA;IACE,gCAAA;EA6SF;EA3SA;IACE,6BAAA;EA6SF;EA3SA;IACE,gCAAA;EA6SF;EA3SA;IACE,+BAAA;EA6SF;EA3SA;IACE,gCAAA;EA6SF;EA3SA;IACE,6BAAA;EA6SF;EA3SA;IACE,gCAAA;EA6SF;EA3SA;IACE,+BAAA;EA6SF;EA3SA;IACE,gCAAA;EA6SF;EA3SA;IACE,6BAAA;EA6SF;EA3SA;IACE,gCAAA;EA6SF;EA3SA;IACE,+BAAA;EA6SF;EA3SA;IACE,gCAAA;EA6SF;EA3SA;IACE,6BAAA;EA6SF;EA3SA;IACE,gCAAA;EA6SF;EA3SA;IACE,+BAAA;EA6SF;EA3SA;IACE,gCAAA;EA6SF;EA3SA;IACE,6BAAA;EA6SF;EA3SA;IACE,qBAAA;EA6SF;EA3SA;IACE,2BAAA;EA6SF;EA3SA;IACE,0BAAA;EA6SF;EA3SA;IACE,2BAAA;EA6SF;EA3SA;IACE,wBAAA;EA6SF;EA3SA;IACE,2BAAA;EA6SF;EA3SA;IACE,0BAAA;EA6SF;EA3SA;IACE,2BAAA;EA6SF;EA3SA;IACE,wBAAA;EA6SF;EA3SA;IACE,2BAAA;EA6SF;EA3SA;IACE,0BAAA;EA6SF;EA3SA;IACE,2BAAA;EA6SF;EA3SA;IACE,wBAAA;EA6SF;EA3SA;IACE,2BAAA;EA6SF;EA3SA;IACE,0BAAA;EA6SF;EA3SA;IACE,2BAAA;EA6SF;EA3SA;IACE,wBAAA;EA6SF;EA3SA;IACE,2BAAA;EA6SF;EA3SA;IACE,0BAAA;EA6SF;EA3SA;IACE,2BAAA;EA6SF;EA3SA;IACE,wBAAA;EA6SF;EA3SA;IACE,2BAAA;IACA,0BAAA;EA6SF;EA3SA;IACE,iCAAA;IACA,gCAAA;EA6SF;EA3SA;IACE,gCAAA;IACA,+BAAA;EA6SF;EA3SA;IACE,iCAAA;IACA,gCAAA;EA6SF;EA3SA;IACE,8BAAA;IACA,6BAAA;EA6SF;EA3SA;IACE,iCAAA;IACA,gCAAA;EA6SF;EA3SA;IACE,gCAAA;IACA,+BAAA;EA6SF;EA3SA;IACE,iCAAA;IACA,gCAAA;EA6SF;EA3SA;IACE,8BAAA;IACA,6BAAA;EA6SF;EA3SA;IACE,iCAAA;IACA,gCAAA;EA6SF;EA3SA;IACE,gCAAA;IACA,+BAAA;EA6SF;EA3SA;IACE,iCAAA;IACA,gCAAA;EA6SF;EA3SA;IACE,8BAAA;IACA,6BAAA;EA6SF;EA3SA;IACE,iCAAA;IACA,gCAAA;EA6SF;EA3SA;IACE,gCAAA;IACA,+BAAA;EA6SF;EA3SA;IACE,iCAAA;IACA,gCAAA;EA6SF;EA3SA;IACE,8BAAA;IACA,6BAAA;EA6SF;EA3SA;IACE,iCAAA;IACA,gCAAA;EA6SF;EA3SA;IACE,gCAAA;IACA,+BAAA;EA6SF;EA3SA;IACE,iCAAA;IACA,gCAAA;EA6SF;EA3SA;IACE,8BAAA;IACA,6BAAA;EA6SF;EA3SA;IACE,yBAAA;IACA,4BAAA;EA6SF;EA3SA;IACE,+BAAA;IACA,kCAAA;EA6SF;EA3SA;IACE,8BAAA;IACA,iCAAA;EA6SF;EA3SA;IACE,+BAAA;IACA,kCAAA;EA6SF;EA3SA;IACE,4BAAA;IACA,+BAAA;EA6SF;EA3SA;IACE,+BAAA;IACA,kCAAA;EA6SF;EA3SA;IACE,8BAAA;IACA,iCAAA;EA6SF;EA3SA;IACE,+BAAA;IACA,kCAAA;EA6SF;EA3SA;IACE,4BAAA;IACA,+BAAA;EA6SF;EA3SA;IACE,+BAAA;IACA,kCAAA;EA6SF;EA3SA;IACE,8BAAA;IACA,iCAAA;EA6SF;EA3SA;IACE,+BAAA;IACA,kCAAA;EA6SF;EA3SA;IACE,4BAAA;IACA,+BAAA;EA6SF;EA3SA;IACE,+BAAA;IACA,kCAAA;EA6SF;EA3SA;IACE,8BAAA;IACA,iCAAA;EA6SF;EA3SA;IACE,+BAAA;IACA,kCAAA;EA6SF;EA3SA;IACE,4BAAA;IACA,+BAAA;EA6SF;EA3SA;IACE,+BAAA;IACA,kCAAA;EA6SF;EA3SA;IACE,8BAAA;IACA,iCAAA;EA6SF;EA3SA;IACE,+BAAA;IACA,kCAAA;EA6SF;EA3SA;IACE,4BAAA;IACA,+BAAA;EA6SF;EA3SA;IACE,yBAAA;EA6SF;EA3SA;IACE,+BAAA;EA6SF;EA3SA;IACE,8BAAA;EA6SF;EA3SA;IACE,+BAAA;EA6SF;EA3SA;IACE,4BAAA;EA6SF;EA3SA;IACE,+BAAA;EA6SF;EA3SA;IACE,8BAAA;EA6SF;EA3SA;IACE,+BAAA;EA6SF;EA3SA;IACE,4BAAA;EA6SF;EA3SA;IACE,+BAAA;EA6SF;EA3SA;IACE,8BAAA;EA6SF;EA3SA;IACE,+BAAA;EA6SF;EA3SA;IACE,4BAAA;EA6SF;EA3SA;IACE,+BAAA;EA6SF;EA3SA;IACE,8BAAA;EA6SF;EA3SA;IACE,+BAAA;EA6SF;EA3SA;IACE,4BAAA;EA6SF;EA3SA;IACE,+BAAA;EA6SF;EA3SA;IACE,8BAAA;EA6SF;EA3SA;IACE,+BAAA;EA6SF;EA3SA;IACE,4BAAA;EA6SF;EA3SA;IACE,2BAAA;EA6SF;EA3SA;IACE,iCAAA;EA6SF;EA3SA;IACE,gCAAA;EA6SF;EA3SA;IACE,iCAAA;EA6SF;EA3SA;IACE,8BAAA;EA6SF;EA3SA;IACE,iCAAA;EA6SF;EA3SA;IACE,gCAAA;EA6SF;EA3SA;IACE,iCAAA;EA6SF;EA3SA;IACE,8BAAA;EA6SF;EA3SA;IACE,iCAAA;EA6SF;EA3SA;IACE,gCAAA;EA6SF;EA3SA;IACE,iCAAA;EA6SF;EA3SA;IACE,8BAAA;EA6SF;EA3SA;IACE,iCAAA;EA6SF;EA3SA;IACE,gCAAA;EA6SF;EA3SA;IACE,iCAAA;EA6SF;EA3SA;IACE,8BAAA;EA6SF;EA3SA;IACE,iCAAA;EA6SF;EA3SA;IACE,gCAAA;EA6SF;EA3SA;IACE,iCAAA;EA6SF;EA3SA;IACE,8BAAA;EA6SF;EA3SA;IACE,4BAAA;EA6SF;EA3SA;IACE,kCAAA;EA6SF;EA3SA;IACE,iCAAA;EA6SF;EA3SA;IACE,kCAAA;EA6SF;EA3SA;IACE,+BAAA;EA6SF;EA3SA;IACE,kCAAA;EA6SF;EA3SA;IACE,iCAAA;EA6SF;EA3SA;IACE,kCAAA;EA6SF;EA3SA;IACE,+BAAA;EA6SF;EA3SA;IACE,kCAAA;EA6SF;EA3SA;IACE,iCAAA;EA6SF;EA3SA;IACE,kCAAA;EA6SF;EA3SA;IACE,+BAAA;EA6SF;EA3SA;IACE,kCAAA;EA6SF;EA3SA;IACE,iCAAA;EA6SF;EA3SA;IACE,kCAAA;EA6SF;EA3SA;IACE,+BAAA;EA6SF;EA3SA;IACE,kCAAA;EA6SF;EA3SA;IACE,iCAAA;EA6SF;EA3SA;IACE,kCAAA;EA6SF;EA3SA;IACE,+BAAA;EA6SF;EA3SA;IACE,0BAAA;EA6SF;EA3SA;IACE,gCAAA;EA6SF;EA3SA;IACE,+BAAA;EA6SF;EA3SA;IACE,gCAAA;EA6SF;EA3SA;IACE,6BAAA;EA6SF;EA3SA;IACE,gCAAA;EA6SF;EA3SA;IACE,+BAAA;EA6SF;EA3SA;IACE,gCAAA;EA6SF;EA3SA;IACE,6BAAA;EA6SF;EA3SA;IACE,gCAAA;EA6SF;EA3SA;IACE,+BAAA;EA6SF;EA3SA;IACE,gCAAA;EA6SF;EA3SA;IACE,6BAAA;EA6SF;EA3SA;IACE,gCAAA;EA6SF;EA3SA;IACE,+BAAA;EA6SF;EA3SA;IACE,gCAAA;EA6SF;EA3SA;IACE,6BAAA;EA6SF;EA3SA;IACE,gCAAA;EA6SF;EA3SA;IACE,+BAAA;EA6SF;EA3SA;IACE,gCAAA;EA6SF;EA3SA;IACE,6BAAA;EA6SF;EA3SA;IACE,iBAAA;EA6SF;EA3SA;IACE,uBAAA;EA6SF;EA3SA;IACE,sBAAA;EA6SF;EA3SA;IACE,uBAAA;EA6SF;EA3SA;IACE,oBAAA;EA6SF;EA3SA;IACE,uBAAA;EA6SF;EA3SA;IACE,sBAAA;EA6SF;EA3SA;IACE,uBAAA;EA6SF;EA3SA;IACE,oBAAA;EA6SF;EA3SA;IACE,uBAAA;EA6SF;EA3SA;IACE,sBAAA;EA6SF;EA3SA;IACE,uBAAA;EA6SF;EA3SA;IACE,oBAAA;EA6SF;EA3SA;IACE,uBAAA;EA6SF;EA3SA;IACE,sBAAA;EA6SF;EA3SA;IACE,uBAAA;EA6SF;EA3SA;IACE,oBAAA;EA6SF;EA3SA;IACE,uBAAA;EA6SF;EA3SA;IACE,sBAAA;EA6SF;EA3SA;IACE,uBAAA;EA6SF;EA3SA;IACE,oBAAA;EA6SF;EA3SA;IACE,qBAAA;EA6SF;EA3SA;IACE,2BAAA;EA6SF;EA3SA;IACE,0BAAA;EA6SF;EA3SA;IACE,2BAAA;EA6SF;EA3SA;IACE,wBAAA;EA6SF;EA3SA;IACE,2BAAA;EA6SF;EA3SA;IACE,0BAAA;EA6SF;EA3SA;IACE,2BAAA;EA6SF;EA3SA;IACE,wBAAA;EA6SF;EA3SA;IACE,2BAAA;EA6SF;EA3SA;IACE,0BAAA;EA6SF;EA3SA;IACE,2BAAA;EA6SF;EA3SA;IACE,wBAAA;EA6SF;EA3SA;IACE,2BAAA;EA6SF;EA3SA;IACE,0BAAA;EA6SF;EA3SA;IACE,2BAAA;EA6SF;EA3SA;IACE,wBAAA;EA6SF;EA3SA;IACE,2BAAA;EA6SF;EA3SA;IACE,0BAAA;EA6SF;EA3SA;IACE,2BAAA;EA6SF;EA3SA;IACE,wBAAA;EA6SF;EA3SA;IACE,wBAAA;EA6SF;EA3SA;IACE,8BAAA;EA6SF;EA3SA;IACE,6BAAA;EA6SF;EA3SA;IACE,8BAAA;EA6SF;EA3SA;IACE,2BAAA;EA6SF;EA3SA;IACE,8BAAA;EA6SF;EA3SA;IACE,6BAAA;EA6SF;EA3SA;IACE,8BAAA;EA6SF;EA3SA;IACE,2BAAA;EA6SF;EA3SA;IACE,8BAAA;EA6SF;EA3SA;IACE,6BAAA;EA6SF;EA3SA;IACE,8BAAA;EA6SF;EA3SA;IACE,2BAAA;EA6SF;EA3SA;IACE,8BAAA;EA6SF;EA3SA;IACE,6BAAA;EA6SF;EA3SA;IACE,8BAAA;EA6SF;EA3SA;IACE,2BAAA;EA6SF;EA3SA;IACE,8BAAA;EA6SF;EA3SA;IACE,6BAAA;EA6SF;EA3SA;IACE,8BAAA;EA6SF;EA3SA;IACE,2BAAA;EA6SF;EA3SA;IACE,0CAAA;EA6SF;EA3SA;IACE,4CAAA;EA6SF;EA3SA;IACE,4CAAA;EA6SF;EA3SA;IACE,6BAAA;EA6SF;EA3SA;IACE,6BAAA;EA6SF;EA3SA;IACE,8BAAA;EA6SF;EA3SA;IACE,6BAAA;EA6SF;EA3SA;IACE,6BAAA;EA6SF;EA3SA;IACE,6BAAA;EA6SF;EA3SA;IACE,4BAAA;EA6SF;EA3SA;IACE,0BAAA;EA6SF;EA3SA;IACE,0BAAA;EA6SF;EA3SA;IACE,4CAAA;EA6SF;EA3SA;IACE,2CAAA;EA6SF;EA3SA;IACE,4CAAA;EA6SF;EA3SA;IACE,0CAAA;EA6SF;EA3SA;IACE,4CAAA;EA6SF;EA3SA;IACE,2CAAA;EA6SF;EA3SA;IACE,4CAAA;EA6SF;EA3SA;IACE,wCAAA;EA6SF;EA3SA;IACE,4CAAA;EA6SF;EA3SA;IACE,2CAAA;EA6SF;EA3SA;IACE,4CAAA;EA6SF;EA3SA;IACE,0CAAA;EA6SF;EA3SA;IACE,4CAAA;EA6SF;EA3SA;IACE,2CAAA;EA6SF;EA3SA;IACE,4CAAA;EA6SF;EA3SA;IACE,0CAAA;EA6SF;EA3SA;IACE,4CAAA;EA6SF;EA3SA;IACE,yCAAA;EA6SF;EA3SA;IACE,4CAAA;EA6SF;EA3SA;IACE,0CAAA;EA6SF;EA3SA;IACE,4CAAA;EA6SF;EA3SA;IACE,2CAAA;EA6SF;EA3SA;IACE,4CAAA;EA6SF;EA3SA;IACE,0CAAA;EA6SF;EA3SA;IACE,2BAAA;EA6SF;EA3SA;IACE,4BAAA;EA6SF;EA3SA;IACE,6BAAA;EA6SF;EA3SA;IACE,2BAAA;EA6SF;EA3SA;IACE,yBAAA;EA6SF;EA3SA;IACE,yBAAA;EA6SF;EA3SA;IACE,yBAAA;EA6SF;EA3SA;IACE,0BAAA;EA6SF;EA3SA;IACE,0BAAA;EA6SF;EA3SA;IACE,yBAAA;EA6SF;EA3SA;IACE,yBAAA;EA6SF;EA3SA;IACE,yBAAA;EA6SF;EA3SA;IACE,yBAAA;EA6SF;EA3SA;IACE,yBAAA;EA6SF;EA3SA;IACE,yBAAA;EA6SF;EA3SA;IACE,yBAAA;EA6SF;EA3SA;IACE,yBAAA;EA6SF;EA3SA;IACE,yBAAA;EA6SF;EA3SA;IACE,0BAAA;EA6SF;EA3SA;IACE,0BAAA;EA6SF;EA3SA;IACE,0BAAA;EA6SF;EA3SA;IACE,0BAAA;EA6SF;EA3SA;IACE,0BAAA;EA6SF;EA3SA;IACE,0BAAA;EA6SF;EA3SA;IACE,0BAAA;EA6SF;EA3SA;IACE,0BAAA;EA6SF;EA3SA;IACE,0BAAA;EA6SF;EA3SA;IACE,0BAAA;EA6SF;EA3SA;IACE,0BAAA;EA6SF;EA3SA;IACE,0BAAA;EA6SF;EA3SA;IACE,0BAAA;EA6SF;EA3SA;IACE,0BAAA;EA6SF;EA3SA;IACE,0BAAA;EA6SF;EA3SA;IACE,0BAAA;EA6SF;EA3SA;IACE,0BAAA;EA6SF;EA3SA;IACE,0BAAA;EA6SF;EA3SA;IACE,2BAAA;EA6SF;EA3SA;IACE,2BAAA;EA6SF;EA3SA;IACE,2BAAA;EA6SF;EA3SA;IACE,2BAAA;EA6SF;EA3SA;IACE,2BAAA;EA6SF;EA3SA;IACE,2BAAA;EA6SF;EA3SA;IACE,2BAAA;EA6SF;EA3SA;IACE,2BAAA;EA6SF;EA3SA;IACE,2BAAA;EA6SF;EA3SA;IACE,2BAAA;EA6SF;EA3SA;IACE,2BAAA;EA6SF;EA3SA;IACE,2BAAA;EA6SF;EA3SA;IACE,2BAAA;EA6SF;EA3SA;IACE,2BAAA;EA6SF;EA3SA;IACE,2BAAA;EA6SF;EA3SA;IACE,2BAAA;EA6SF;EA3SA;IACE,2BAAA;EA6SF;EA3SA;IACE,2BAAA;EA6SF;EA3SA;IACE,2BAAA;EA6SF;EA3SA;IACE,2BAAA;EA6SF;EA3SA;IACE,2BAAA;EA6SF;EA3SA;IACE,2BAAA;EA6SF;EA3SA;IACE,2BAAA;EA6SF;EA3SA;IACE,2BAAA;EA6SF;EA3SA;IACE,2BAAA;EA6SF;EA3SA;IACE,2BAAA;EA6SF;EA3SA;IACE,4BAAA;EA6SF;EA3SA;IACE,4BAAA;EA6SF;EA3SA;IACE,0BAAA;EA6SF;EA3SA;IACE,0BAAA;EA6SF;EA3SA;IACE,0BAAA;EA6SF;EA3SA;IACE,2BAAA;EA6SF;EA3SA;IACE,2BAAA;EA6SF;EA3SA;IACE,0BAAA;EA6SF;EA3SA;IACE,0BAAA;EA6SF;EA3SA;IACE,0BAAA;EA6SF;EA3SA;IACE,0BAAA;EA6SF;EA3SA;IACE,0BAAA;EA6SF;EA3SA;IACE,0BAAA;EA6SF;EA3SA;IACE,0BAAA;EA6SF;EA3SA;IACE,0BAAA;EA6SF;EA3SA;IACE,0BAAA;EA6SF;EA3SA;IACE,2BAAA;EA6SF;EA3SA;IACE,2BAAA;EA6SF;EA3SA;IACE,2BAAA;EA6SF;EA3SA;IACE,2BAAA;EA6SF;EA3SA;IACE,2BAAA;EA6SF;EA3SA;IACE,2BAAA;EA6SF;EA3SA;IACE,2BAAA;EA6SF;EA3SA;IACE,2BAAA;EA6SF;EA3SA;IACE,2BAAA;EA6SF;EA3SA;IACE,2BAAA;EA6SF;EA3SA;IACE,2BAAA;EA6SF;EA3SA;IACE,2BAAA;EA6SF;EA3SA;IACE,2BAAA;EA6SF;EA3SA;IACE,2BAAA;EA6SF;EA3SA;IACE,2BAAA;EA6SF;EA3SA;IACE,2BAAA;EA6SF;EA3SA;IACE,2BAAA;EA6SF;EA3SA;IACE,2BAAA;EA6SF;EA3SA;IACE,4BAAA;EA6SF;EA3SA;IACE,4BAAA;EA6SF;EA3SA;IACE,4BAAA;EA6SF;EA3SA;IACE,4BAAA;EA6SF;EA3SA;IACE,4BAAA;EA6SF;EA3SA;IACE,4BAAA;EA6SF;EA3SA;IACE,4BAAA;EA6SF;EA3SA;IACE,4BAAA;EA6SF;EA3SA;IACE,4BAAA;EA6SF;EA3SA;IACE,4BAAA;EA6SF;EA3SA;IACE,4BAAA;EA6SF;EA3SA;IACE,4BAAA;EA6SF;EA3SA;IACE,4BAAA;EA6SF;EA3SA;IACE,4BAAA;EA6SF;EA3SA;IACE,4BAAA;EA6SF;EA3SA;IACE,4BAAA;EA6SF;EA3SA;IACE,4BAAA;EA6SF;EA3SA;IACE,4BAAA;EA6SF;EA3SA;IACE,4BAAA;EA6SF;EA3SA;IACE,4BAAA;EA6SF;EA3SA;IACE,4BAAA;EA6SF;EA3SA;IACE,4BAAA;EA6SF;EA3SA;IACE,4BAAA;EA6SF;EA3SA;IACE,4BAAA;EA6SF;EA3SA;IACE,4BAAA;EA6SF;EA3SA;IACE,4BAAA;EA6SF;EA3SA;IACE,6BAAA;EA6SF;AACF;AA3SA;EACE;IACE,sBAAA;EA6SF;EA3SA;IACE,uBAAA;EA6SF;EA3SA;IACE,sBAAA;EA6SF;EA3SA;IACE,8BAAA;EA6SF;EA3SA;IACE,4BAAA;EA6SF;EA3SA;IACE,2BAAA;EA6SF;EA3SA;IACE,iCAAA;EA6SF;EA3SA;IACE,2BAAA;EA6SF;EA3SA;IACE,yBAAA;EA6SF;EA3SA;IACE,2BAAA;EA6SF;EA3SA;IACE,4BAAA;EA6SF;EA3SA;IACE,2BAAA;EA6SF;EA3SA;IACE,0BAAA;EA6SF;EA3SA;IACE,gCAAA;EA6SF;EA3SA;IACE,yBAAA;EA6SF;EA3SA;IACE,wBAAA;EA6SF;EA3SA;IACE,yBAAA;EA6SF;EA3SA;IACE,6BAAA;EA6SF;EA3SA;IACE,8BAAA;EA6SF;EA3SA;IACE,wBAAA;EA6SF;EA3SA;IACE,+BAAA;EA6SF;EA3SA;IACE,wBAAA;EA6SF;EA3SA;IACE,2BAAA;EA6SF;EA3SA;IACE,6BAAA;EA6SF;EA3SA;IACE,6BAAA;EA6SF;EA3SA;IACE,0BAAA;EA6SF;EA3SA;IACE,2BAAA;EA6SF;EA3SA;IACE,uBAAA;EA6SF;EA3SA;IACE,qBAAA;EA6SF;EA3SA;IACE,qBAAA;EA6SF;EA3SA;IACE,qBAAA;EA6SF;EA3SA;IACE,sBAAA;EA6SF;EA3SA;IACE,sBAAA;EA6SF;EA3SA;IACE,qBAAA;EA6SF;EA3SA;IACE,qBAAA;EA6SF;EA3SA;IACE,qBAAA;EA6SF;EA3SA;IACE,qBAAA;EA6SF;EA3SA;IACE,qBAAA;EA6SF;EA3SA;IACE,qBAAA;EA6SF;EA3SA;IACE,qBAAA;EA6SF;EA3SA;IACE,qBAAA;EA6SF;EA3SA;IACE,qBAAA;EA6SF;EA3SA;IACE,sBAAA;EA6SF;EA3SA;IACE,sBAAA;EA6SF;EA3SA;IACE,sBAAA;EA6SF;EA3SA;IACE,sBAAA;EA6SF;EA3SA;IACE,sBAAA;EA6SF;EA3SA;IACE,sBAAA;EA6SF;EA3SA;IACE,sBAAA;EA6SF;EA3SA;IACE,sBAAA;EA6SF;EA3SA;IACE,sBAAA;EA6SF;EA3SA;IACE,sBAAA;EA6SF;EA3SA;IACE,sBAAA;EA6SF;EA3SA;IACE,sBAAA;EA6SF;EA3SA;IACE,sBAAA;EA6SF;EA3SA;IACE,sBAAA;EA6SF;EA3SA;IACE,sBAAA;EA6SF;EA3SA;IACE,sBAAA;EA6SF;EA3SA;IACE,sBAAA;EA6SF;EA3SA;IACE,sBAAA;EA6SF;EA3SA;IACE,uBAAA;EA6SF;EA3SA;IACE,uBAAA;EA6SF;EA3SA;IACE,uBAAA;EA6SF;EA3SA;IACE,uBAAA;EA6SF;EA3SA;IACE,uBAAA;EA6SF;EA3SA;IACE,uBAAA;EA6SF;EA3SA;IACE,uBAAA;EA6SF;EA3SA;IACE,uBAAA;EA6SF;EA3SA;IACE,uBAAA;EA6SF;EA3SA;IACE,uBAAA;EA6SF;EA3SA;IACE,uBAAA;EA6SF;EA3SA;IACE,uBAAA;EA6SF;EA3SA;IACE,uBAAA;EA6SF;EA3SA;IACE,uBAAA;EA6SF;EA3SA;IACE,uBAAA;EA6SF;EA3SA;IACE,uBAAA;EA6SF;EA3SA;IACE,uBAAA;EA6SF;EA3SA;IACE,uBAAA;EA6SF;EA3SA;IACE,uBAAA;EA6SF;EA3SA;IACE,uBAAA;EA6SF;EA3SA;IACE,uBAAA;EA6SF;EA3SA;IACE,uBAAA;EA6SF;EA3SA;IACE,uBAAA;EA6SF;EA3SA;IACE,uBAAA;EA6SF;EA3SA;IACE,uBAAA;EA6SF;EA3SA;IACE,uBAAA;EA6SF;EA3SA;IACE,wBAAA;EA6SF;EA3SA;IACE,2BAAA;EA6SF;EA3SA;IACE,yBAAA;EA6SF;EA3SA;IACE,yBAAA;EA6SF;EA3SA;IACE,yBAAA;EA6SF;EA3SA;IACE,0BAAA;EA6SF;EA3SA;IACE,0BAAA;EA6SF;EA3SA;IACE,yBAAA;EA6SF;EA3SA;IACE,yBAAA;EA6SF;EA3SA;IACE,yBAAA;EA6SF;EA3SA;IACE,yBAAA;EA6SF;EA3SA;IACE,yBAAA;EA6SF;EA3SA;IACE,yBAAA;EA6SF;EA3SA;IACE,yBAAA;EA6SF;EA3SA;IACE,yBAAA;EA6SF;EA3SA;IACE,yBAAA;EA6SF;EA3SA;IACE,0BAAA;EA6SF;EA3SA;IACE,0BAAA;EA6SF;EA3SA;IACE,0BAAA;EA6SF;EA3SA;IACE,0BAAA;EA6SF;EA3SA;IACE,0BAAA;EA6SF;EA3SA;IACE,0BAAA;EA6SF;EA3SA;IACE,0BAAA;EA6SF;EA3SA;IACE,0BAAA;EA6SF;EA3SA;IACE,0BAAA;EA6SF;EA3SA;IACE,0BAAA;EA6SF;EA3SA;IACE,0BAAA;EA6SF;EA3SA;IACE,0BAAA;EA6SF;EA3SA;IACE,0BAAA;EA6SF;EA3SA;IACE,0BAAA;EA6SF;EA3SA;IACE,0BAAA;EA6SF;EA3SA;IACE,0BAAA;EA6SF;EA3SA;IACE,0BAAA;EA6SF;EA3SA;IACE,0BAAA;EA6SF;EA3SA;IACE,2BAAA;EA6SF;EA3SA;IACE,2BAAA;EA6SF;EA3SA;IACE,2BAAA;EA6SF;EA3SA;IACE,2BAAA;EA6SF;EA3SA;IACE,2BAAA;EA6SF;EA3SA;IACE,2BAAA;EA6SF;EA3SA;IACE,2BAAA;EA6SF;EA3SA;IACE,2BAAA;EA6SF;EA3SA;IACE,2BAAA;EA6SF;EA3SA;IACE,2BAAA;EA6SF;EA3SA;IACE,2BAAA;EA6SF;EA3SA;IACE,2BAAA;EA6SF;EA3SA;IACE,2BAAA;EA6SF;EA3SA;IACE,2BAAA;EA6SF;EA3SA;IACE,2BAAA;EA6SF;EA3SA;IACE,2BAAA;EA6SF;EA3SA;IACE,2BAAA;EA6SF;EA3SA;IACE,2BAAA;EA6SF;EA3SA;IACE,2BAAA;EA6SF;EA3SA;IACE,2BAAA;EA6SF;EA3SA;IACE,2BAAA;EA6SF;EA3SA;IACE,2BAAA;EA6SF;EA3SA;IACE,2BAAA;EA6SF;EA3SA;IACE,2BAAA;EA6SF;EA3SA;IACE,2BAAA;EA6SF;EA3SA;IACE,2BAAA;EA6SF;EA3SA;IACE,4BAAA;EA6SF;EA3SA;IACE,wBAAA;EA6SF;EA3SA;IACE,sBAAA;EA6SF;EA3SA;IACE,sBAAA;EA6SF;EA3SA;IACE,sBAAA;EA6SF;EA3SA;IACE,uBAAA;EA6SF;EA3SA;IACE,uBAAA;EA6SF;EA3SA;IACE,sBAAA;EA6SF;EA3SA;IACE,sBAAA;EA6SF;EA3SA;IACE,sBAAA;EA6SF;EA3SA;IACE,sBAAA;EA6SF;EA3SA;IACE,sBAAA;EA6SF;EA3SA;IACE,sBAAA;EA6SF;EA3SA;IACE,sBAAA;EA6SF;EA3SA;IACE,sBAAA;EA6SF;EA3SA;IACE,sBAAA;EA6SF;EA3SA;IACE,uBAAA;EA6SF;EA3SA;IACE,uBAAA;EA6SF;EA3SA;IACE,uBAAA;EA6SF;EA3SA;IACE,uBAAA;EA6SF;EA3SA;IACE,uBAAA;EA6SF;EA3SA;IACE,uBAAA;EA6SF;EA3SA;IACE,uBAAA;EA6SF;EA3SA;IACE,uBAAA;EA6SF;EA3SA;IACE,uBAAA;EA6SF;EA3SA;IACE,uBAAA;EA6SF;EA3SA;IACE,uBAAA;EA6SF;EA3SA;IACE,uBAAA;EA6SF;EA3SA;IACE,uBAAA;EA6SF;EA3SA;IACE,uBAAA;EA6SF;EA3SA;IACE,uBAAA;EA6SF;EA3SA;IACE,uBAAA;EA6SF;EA3SA;IACE,uBAAA;EA6SF;EA3SA;IACE,uBAAA;EA6SF;EA3SA;IACE,wBAAA;EA6SF;EA3SA;IACE,wBAAA;EA6SF;EA3SA;IACE,wBAAA;EA6SF;EA3SA;IACE,wBAAA;EA6SF;EA3SA;IACE,wBAAA;EA6SF;EA3SA;IACE,wBAAA;EA6SF;EA3SA;IACE,wBAAA;EA6SF;EA3SA;IACE,wBAAA;EA6SF;EA3SA;IACE,wBAAA;EA6SF;EA3SA;IACE,wBAAA;EA6SF;EA3SA;IACE,wBAAA;EA6SF;EA3SA;IACE,wBAAA;EA6SF;EA3SA;IACE,wBAAA;EA6SF;EA3SA;IACE,wBAAA;EA6SF;EA3SA;IACE,wBAAA;EA6SF;EA3SA;IACE,wBAAA;EA6SF;EA3SA;IACE,wBAAA;EA6SF;EA3SA;IACE,wBAAA;EA6SF;EA3SA;IACE,wBAAA;EA6SF;EA3SA;IACE,wBAAA;EA6SF;EA3SA;IACE,wBAAA;EA6SF;EA3SA;IACE,wBAAA;EA6SF;EA3SA;IACE,wBAAA;EA6SF;EA3SA;IACE,wBAAA;EA6SF;EA3SA;IACE,wBAAA;EA6SF;EA3SA;IACE,wBAAA;EA6SF;EA3SA;IACE,yBAAA;EA6SF;EA3SA;IACE,4BAAA;EA6SF;EA3SA;IACE,0BAAA;EA6SF;EA3SA;IACE,0BAAA;EA6SF;EA3SA;IACE,0BAAA;EA6SF;EA3SA;IACE,2BAAA;EA6SF;EA3SA;IACE,2BAAA;EA6SF;EA3SA;IACE,0BAAA;EA6SF;EA3SA;IACE,0BAAA;EA6SF;EA3SA;IACE,0BAAA;EA6SF;EA3SA;IACE,0BAAA;EA6SF;EA3SA;IACE,0BAAA;EA6SF;EA3SA;IACE,0BAAA;EA6SF;EA3SA;IACE,0BAAA;EA6SF;EA3SA;IACE,0BAAA;EA6SF;EA3SA;IACE,0BAAA;EA6SF;EA3SA;IACE,2BAAA;EA6SF;EA3SA;IACE,2BAAA;EA6SF;EA3SA;IACE,2BAAA;EA6SF;EA3SA;IACE,2BAAA;EA6SF;EA3SA;IACE,2BAAA;EA6SF;EA3SA;IACE,2BAAA;EA6SF;EA3SA;IACE,2BAAA;EA6SF;EA3SA;IACE,2BAAA;EA6SF;EA3SA;IACE,2BAAA;EA6SF;EA3SA;IACE,2BAAA;EA6SF;EA3SA;IACE,2BAAA;EA6SF;EA3SA;IACE,2BAAA;EA6SF;EA3SA;IACE,2BAAA;EA6SF;EA3SA;IACE,2BAAA;EA6SF;EA3SA;IACE,2BAAA;EA6SF;EA3SA;IACE,2BAAA;EA6SF;EA3SA;IACE,2BAAA;EA6SF;EA3SA;IACE,2BAAA;EA6SF;EA3SA;IACE,4BAAA;EA6SF;EA3SA;IACE,4BAAA;EA6SF;EA3SA;IACE,4BAAA;EA6SF;EA3SA;IACE,4BAAA;EA6SF;EA3SA;IACE,4BAAA;EA6SF;EA3SA;IACE,4BAAA;EA6SF;EA3SA;IACE,4BAAA;EA6SF;EA3SA;IACE,4BAAA;EA6SF;EA3SA;IACE,4BAAA;EA6SF;EA3SA;IACE,4BAAA;EA6SF;EA3SA;IACE,4BAAA;EA6SF;EA3SA;IACE,4BAAA;EA6SF;EA3SA;IACE,4BAAA;EA6SF;EA3SA;IACE,4BAAA;EA6SF;EA3SA;IACE,4BAAA;EA6SF;EA3SA;IACE,4BAAA;EA6SF;EA3SA;IACE,4BAAA;EA6SF;EA3SA;IACE,4BAAA;EA6SF;EA3SA;IACE,4BAAA;EA6SF;EA3SA;IACE,4BAAA;EA6SF;EA3SA;IACE,4BAAA;EA6SF;EA3SA;IACE,4BAAA;EA6SF;EA3SA;IACE,4BAAA;EA6SF;EA3SA;IACE,4BAAA;EA6SF;EA3SA;IACE,4BAAA;EA6SF;EA3SA;IACE,4BAAA;EA6SF;EA3SA;IACE,6BAAA;EA6SF;EA3SA;IACE,yBAAA;EA6SF;EA3SA;IACE,8BAAA;EA6SF;EA3SA;IACE,iCAAA;EA6SF;EA3SA;IACE,sCAAA;EA6SF;EA3SA;IACE,yCAAA;EA6SF;EA3SA;IACE,uBAAA;EA6SF;EA3SA;IACE,uBAAA;EA6SF;EA3SA;IACE,yBAAA;EA6SF;EA3SA;IACE,yBAAA;EA6SF;EA3SA;IACE,0BAAA;EA6SF;EA3SA;IACE,4BAAA;EA6SF;EA3SA;IACE,kCAAA;EA6SF;EA3SA;IACE,sCAAA;EA6SF;EA3SA;IACE,oCAAA;EA6SF;EA3SA;IACE,kCAAA;EA6SF;EA3SA;IACE,yCAAA;EA6SF;EA3SA;IACE,wCAAA;EA6SF;EA3SA;IACE,wCAAA;EA6SF;EA3SA;IACE,kCAAA;EA6SF;EA3SA;IACE,gCAAA;EA6SF;EA3SA;IACE,8BAAA;EA6SF;EA3SA;IACE,gCAAA;EA6SF;EA3SA;IACE,+BAAA;EA6SF;EA3SA;IACE,oCAAA;EA6SF;EA3SA;IACE,kCAAA;EA6SF;EA3SA;IACE,gCAAA;EA6SF;EA3SA;IACE,uCAAA;EA6SF;EA3SA;IACE,sCAAA;EA6SF;EA3SA;IACE,iCAAA;EA6SF;EA3SA;IACE,2BAAA;EA6SF;EA3SA;IACE,iCAAA;EA6SF;EA3SA;IACE,+BAAA;EA6SF;EA3SA;IACE,6BAAA;EA6SF;EA3SA;IACE,+BAAA;EA6SF;EA3SA;IACE,8BAAA;EA6SF;EA3SA;IACE,oBAAA;EA6SF;EA3SA;IACE,mBAAA;EA6SF;EA3SA;IACE,mBAAA;EA6SF;EA3SA;IACE,mBAAA;EA6SF;EA3SA;IACE,mBAAA;EA6SF;EA3SA;IACE,mBAAA;EA6SF;EA3SA;IACE,mBAAA;EA6SF;EA3SA;IACE,mBAAA;EA6SF;EA3SA;IACE,oBAAA;EA6SF;EA3SA;IACE,0BAAA;EA6SF;EA3SA;IACE,yBAAA;EA6SF;EA3SA;IACE,0BAAA;EA6SF;EA3SA;IACE,uBAAA;EA6SF;EA3SA;IACE,0BAAA;EA6SF;EA3SA;IACE,yBAAA;EA6SF;EA3SA;IACE,0BAAA;EA6SF;EA3SA;IACE,uBAAA;EA6SF;EA3SA;IACE,0BAAA;EA6SF;EA3SA;IACE,yBAAA;EA6SF;EA3SA;IACE,0BAAA;EA6SF;EA3SA;IACE,uBAAA;EA6SF;EA3SA;IACE,0BAAA;EA6SF;EA3SA;IACE,yBAAA;EA6SF;EA3SA;IACE,0BAAA;EA6SF;EA3SA;IACE,uBAAA;EA6SF;EA3SA;IACE,0BAAA;EA6SF;EA3SA;IACE,yBAAA;EA6SF;EA3SA;IACE,0BAAA;EA6SF;EA3SA;IACE,uBAAA;EA6SF;EA3SA;IACE,uBAAA;EA6SF;EA3SA;IACE,0BAAA;IACA,yBAAA;EA6SF;EA3SA;IACE,gCAAA;IACA,+BAAA;EA6SF;EA3SA;IACE,+BAAA;IACA,8BAAA;EA6SF;EA3SA;IACE,gCAAA;IACA,+BAAA;EA6SF;EA3SA;IACE,6BAAA;IACA,4BAAA;EA6SF;EA3SA;IACE,gCAAA;IACA,+BAAA;EA6SF;EA3SA;IACE,+BAAA;IACA,8BAAA;EA6SF;EA3SA;IACE,gCAAA;IACA,+BAAA;EA6SF;EA3SA;IACE,6BAAA;IACA,4BAAA;EA6SF;EA3SA;IACE,gCAAA;IACA,+BAAA;EA6SF;EA3SA;IACE,+BAAA;IACA,8BAAA;EA6SF;EA3SA;IACE,gCAAA;IACA,+BAAA;EA6SF;EA3SA;IACE,6BAAA;IACA,4BAAA;EA6SF;EA3SA;IACE,gCAAA;IACA,+BAAA;EA6SF;EA3SA;IACE,+BAAA;IACA,8BAAA;EA6SF;EA3SA;IACE,gCAAA;IACA,+BAAA;EA6SF;EA3SA;IACE,6BAAA;IACA,4BAAA;EA6SF;EA3SA;IACE,gCAAA;IACA,+BAAA;EA6SF;EA3SA;IACE,+BAAA;IACA,8BAAA;EA6SF;EA3SA;IACE,gCAAA;IACA,+BAAA;EA6SF;EA3SA;IACE,6BAAA;IACA,4BAAA;EA6SF;EA3SA;IACE,6BAAA;IACA,4BAAA;EA6SF;EA3SA;IACE,wBAAA;IACA,2BAAA;EA6SF;EA3SA;IACE,8BAAA;IACA,iCAAA;EA6SF;EA3SA;IACE,6BAAA;IACA,gCAAA;EA6SF;EA3SA;IACE,8BAAA;IACA,iCAAA;EA6SF;EA3SA;IACE,2BAAA;IACA,8BAAA;EA6SF;EA3SA;IACE,8BAAA;IACA,iCAAA;EA6SF;EA3SA;IACE,6BAAA;IACA,gCAAA;EA6SF;EA3SA;IACE,8BAAA;IACA,iCAAA;EA6SF;EA3SA;IACE,2BAAA;IACA,8BAAA;EA6SF;EA3SA;IACE,8BAAA;IACA,iCAAA;EA6SF;EA3SA;IACE,6BAAA;IACA,gCAAA;EA6SF;EA3SA;IACE,8BAAA;IACA,iCAAA;EA6SF;EA3SA;IACE,2BAAA;IACA,8BAAA;EA6SF;EA3SA;IACE,8BAAA;IACA,iCAAA;EA6SF;EA3SA;IACE,6BAAA;IACA,gCAAA;EA6SF;EA3SA;IACE,8BAAA;IACA,iCAAA;EA6SF;EA3SA;IACE,2BAAA;IACA,8BAAA;EA6SF;EA3SA;IACE,8BAAA;IACA,iCAAA;EA6SF;EA3SA;IACE,6BAAA;IACA,gCAAA;EA6SF;EA3SA;IACE,8BAAA;IACA,iCAAA;EA6SF;EA3SA;IACE,2BAAA;IACA,8BAAA;EA6SF;EA3SA;IACE,2BAAA;IACA,8BAAA;EA6SF;EA3SA;IACE,wBAAA;EA6SF;EA3SA;IACE,8BAAA;EA6SF;EA3SA;IACE,6BAAA;EA6SF;EA3SA;IACE,8BAAA;EA6SF;EA3SA;IACE,2BAAA;EA6SF;EA3SA;IACE,8BAAA;EA6SF;EA3SA;IACE,6BAAA;EA6SF;EA3SA;IACE,8BAAA;EA6SF;EA3SA;IACE,2BAAA;EA6SF;EA3SA;IACE,8BAAA;EA6SF;EA3SA;IACE,6BAAA;EA6SF;EA3SA;IACE,8BAAA;EA6SF;EA3SA;IACE,2BAAA;EA6SF;EA3SA;IACE,8BAAA;EA6SF;EA3SA;IACE,6BAAA;EA6SF;EA3SA;IACE,8BAAA;EA6SF;EA3SA;IACE,2BAAA;EA6SF;EA3SA;IACE,8BAAA;EA6SF;EA3SA;IACE,6BAAA;EA6SF;EA3SA;IACE,8BAAA;EA6SF;EA3SA;IACE,2BAAA;EA6SF;EA3SA;IACE,2BAAA;EA6SF;EA3SA;IACE,0BAAA;EA6SF;EA3SA;IACE,gCAAA;EA6SF;EA3SA;IACE,+BAAA;EA6SF;EA3SA;IACE,gCAAA;EA6SF;EA3SA;IACE,6BAAA;EA6SF;EA3SA;IACE,gCAAA;EA6SF;EA3SA;IACE,+BAAA;EA6SF;EA3SA;IACE,gCAAA;EA6SF;EA3SA;IACE,6BAAA;EA6SF;EA3SA;IACE,gCAAA;EA6SF;EA3SA;IACE,+BAAA;EA6SF;EA3SA;IACE,gCAAA;EA6SF;EA3SA;IACE,6BAAA;EA6SF;EA3SA;IACE,gCAAA;EA6SF;EA3SA;IACE,+BAAA;EA6SF;EA3SA;IACE,gCAAA;EA6SF;EA3SA;IACE,6BAAA;EA6SF;EA3SA;IACE,gCAAA;EA6SF;EA3SA;IACE,+BAAA;EA6SF;EA3SA;IACE,gCAAA;EA6SF;EA3SA;IACE,6BAAA;EA6SF;EA3SA;IACE,6BAAA;EA6SF;EA3SA;IACE,2BAAA;EA6SF;EA3SA;IACE,iCAAA;EA6SF;EA3SA;IACE,gCAAA;EA6SF;EA3SA;IACE,iCAAA;EA6SF;EA3SA;IACE,8BAAA;EA6SF;EA3SA;IACE,iCAAA;EA6SF;EA3SA;IACE,gCAAA;EA6SF;EA3SA;IACE,iCAAA;EA6SF;EA3SA;IACE,8BAAA;EA6SF;EA3SA;IACE,iCAAA;EA6SF;EA3SA;IACE,gCAAA;EA6SF;EA3SA;IACE,iCAAA;EA6SF;EA3SA;IACE,8BAAA;EA6SF;EA3SA;IACE,iCAAA;EA6SF;EA3SA;IACE,gCAAA;EA6SF;EA3SA;IACE,iCAAA;EA6SF;EA3SA;IACE,8BAAA;EA6SF;EA3SA;IACE,iCAAA;EA6SF;EA3SA;IACE,gCAAA;EA6SF;EA3SA;IACE,iCAAA;EA6SF;EA3SA;IACE,8BAAA;EA6SF;EA3SA;IACE,8BAAA;EA6SF;EA3SA;IACE,yBAAA;EA6SF;EA3SA;IACE,+BAAA;EA6SF;EA3SA;IACE,8BAAA;EA6SF;EA3SA;IACE,+BAAA;EA6SF;EA3SA;IACE,4BAAA;EA6SF;EA3SA;IACE,+BAAA;EA6SF;EA3SA;IACE,8BAAA;EA6SF;EA3SA;IACE,+BAAA;EA6SF;EA3SA;IACE,4BAAA;EA6SF;EA3SA;IACE,+BAAA;EA6SF;EA3SA;IACE,8BAAA;EA6SF;EA3SA;IACE,+BAAA;EA6SF;EA3SA;IACE,4BAAA;EA6SF;EA3SA;IACE,+BAAA;EA6SF;EA3SA;IACE,8BAAA;EA6SF;EA3SA;IACE,+BAAA;EA6SF;EA3SA;IACE,4BAAA;EA6SF;EA3SA;IACE,+BAAA;EA6SF;EA3SA;IACE,8BAAA;EA6SF;EA3SA;IACE,+BAAA;EA6SF;EA3SA;IACE,4BAAA;EA6SF;EA3SA;IACE,4BAAA;EA6SF;EA3SA;IACE,2BAAA;EA6SF;EA3SA;IACE,0BAAA;EA6SF;EA3SA;IACE,2BAAA;EA6SF;EA3SA;IACE,wBAAA;EA6SF;EA3SA;IACE,2BAAA;EA6SF;EA3SA;IACE,0BAAA;EA6SF;EA3SA;IACE,2BAAA;EA6SF;EA3SA;IACE,wBAAA;EA6SF;EA3SA;IACE,2BAAA;EA6SF;EA3SA;IACE,0BAAA;EA6SF;EA3SA;IACE,2BAAA;EA6SF;EA3SA;IACE,wBAAA;EA6SF;EA3SA;IACE,2BAAA;EA6SF;EA3SA;IACE,0BAAA;EA6SF;EA3SA;IACE,2BAAA;EA6SF;EA3SA;IACE,wBAAA;EA6SF;EA3SA;IACE,2BAAA;EA6SF;EA3SA;IACE,0BAAA;EA6SF;EA3SA;IACE,2BAAA;EA6SF;EA3SA;IACE,wBAAA;EA6SF;EA3SA;IACE,iCAAA;IACA,gCAAA;EA6SF;EA3SA;IACE,gCAAA;IACA,+BAAA;EA6SF;EA3SA;IACE,iCAAA;IACA,gCAAA;EA6SF;EA3SA;IACE,8BAAA;IACA,6BAAA;EA6SF;EA3SA;IACE,iCAAA;IACA,gCAAA;EA6SF;EA3SA;IACE,gCAAA;IACA,+BAAA;EA6SF;EA3SA;IACE,iCAAA;IACA,gCAAA;EA6SF;EA3SA;IACE,8BAAA;IACA,6BAAA;EA6SF;EA3SA;IACE,iCAAA;IACA,gCAAA;EA6SF;EA3SA;IACE,gCAAA;IACA,+BAAA;EA6SF;EA3SA;IACE,iCAAA;IACA,gCAAA;EA6SF;EA3SA;IACE,8BAAA;IACA,6BAAA;EA6SF;EA3SA;IACE,iCAAA;IACA,gCAAA;EA6SF;EA3SA;IACE,gCAAA;IACA,+BAAA;EA6SF;EA3SA;IACE,iCAAA;IACA,gCAAA;EA6SF;EA3SA;IACE,8BAAA;IACA,6BAAA;EA6SF;EA3SA;IACE,iCAAA;IACA,gCAAA;EA6SF;EA3SA;IACE,gCAAA;IACA,+BAAA;EA6SF;EA3SA;IACE,iCAAA;IACA,gCAAA;EA6SF;EA3SA;IACE,8BAAA;IACA,6BAAA;EA6SF;EA3SA;IACE,+BAAA;IACA,kCAAA;EA6SF;EA3SA;IACE,8BAAA;IACA,iCAAA;EA6SF;EA3SA;IACE,+BAAA;IACA,kCAAA;EA6SF;EA3SA;IACE,4BAAA;IACA,+BAAA;EA6SF;EA3SA;IACE,+BAAA;IACA,kCAAA;EA6SF;EA3SA;IACE,8BAAA;IACA,iCAAA;EA6SF;EA3SA;IACE,+BAAA;IACA,kCAAA;EA6SF;EA3SA;IACE,4BAAA;IACA,+BAAA;EA6SF;EA3SA;IACE,+BAAA;IACA,kCAAA;EA6SF;EA3SA;IACE,8BAAA;IACA,iCAAA;EA6SF;EA3SA;IACE,+BAAA;IACA,kCAAA;EA6SF;EA3SA;IACE,4BAAA;IACA,+BAAA;EA6SF;EA3SA;IACE,+BAAA;IACA,kCAAA;EA6SF;EA3SA;IACE,8BAAA;IACA,iCAAA;EA6SF;EA3SA;IACE,+BAAA;IACA,kCAAA;EA6SF;EA3SA;IACE,4BAAA;IACA,+BAAA;EA6SF;EA3SA;IACE,+BAAA;IACA,kCAAA;EA6SF;EA3SA;IACE,8BAAA;IACA,iCAAA;EA6SF;EA3SA;IACE,+BAAA;IACA,kCAAA;EA6SF;EA3SA;IACE,4BAAA;IACA,+BAAA;EA6SF;EA3SA;IACE,+BAAA;EA6SF;EA3SA;IACE,8BAAA;EA6SF;EA3SA;IACE,+BAAA;EA6SF;EA3SA;IACE,4BAAA;EA6SF;EA3SA;IACE,+BAAA;EA6SF;EA3SA;IACE,8BAAA;EA6SF;EA3SA;IACE,+BAAA;EA6SF;EA3SA;IACE,4BAAA;EA6SF;EA3SA;IACE,+BAAA;EA6SF;EA3SA;IACE,8BAAA;EA6SF;EA3SA;IACE,+BAAA;EA6SF;EA3SA;IACE,4BAAA;EA6SF;EA3SA;IACE,+BAAA;EA6SF;EA3SA;IACE,8BAAA;EA6SF;EA3SA;IACE,+BAAA;EA6SF;EA3SA;IACE,4BAAA;EA6SF;EA3SA;IACE,+BAAA;EA6SF;EA3SA;IACE,8BAAA;EA6SF;EA3SA;IACE,+BAAA;EA6SF;EA3SA;IACE,4BAAA;EA6SF;EA3SA;IACE,iCAAA;EA6SF;EA3SA;IACE,gCAAA;EA6SF;EA3SA;IACE,iCAAA;EA6SF;EA3SA;IACE,8BAAA;EA6SF;EA3SA;IACE,iCAAA;EA6SF;EA3SA;IACE,gCAAA;EA6SF;EA3SA;IACE,iCAAA;EA6SF;EA3SA;IACE,8BAAA;EA6SF;EA3SA;IACE,iCAAA;EA6SF;EA3SA;IACE,gCAAA;EA6SF;EA3SA;IACE,iCAAA;EA6SF;EA3SA;IACE,8BAAA;EA6SF;EA3SA;IACE,iCAAA;EA6SF;EA3SA;IACE,gCAAA;EA6SF;EA3SA;IACE,iCAAA;EA6SF;EA3SA;IACE,8BAAA;EA6SF;EA3SA;IACE,iCAAA;EA6SF;EA3SA;IACE,gCAAA;EA6SF;EA3SA;IACE,iCAAA;EA6SF;EA3SA;IACE,8BAAA;EA6SF;EA3SA;IACE,kCAAA;EA6SF;EA3SA;IACE,iCAAA;EA6SF;EA3SA;IACE,kCAAA;EA6SF;EA3SA;IACE,+BAAA;EA6SF;EA3SA;IACE,kCAAA;EA6SF;EA3SA;IACE,iCAAA;EA6SF;EA3SA;IACE,kCAAA;EA6SF;EA3SA;IACE,+BAAA;EA6SF;EA3SA;IACE,kCAAA;EA6SF;EA3SA;IACE,iCAAA;EA6SF;EA3SA;IACE,kCAAA;EA6SF;EA3SA;IACE,+BAAA;EA6SF;EA3SA;IACE,kCAAA;EA6SF;EA3SA;IACE,iCAAA;EA6SF;EA3SA;IACE,kCAAA;EA6SF;EA3SA;IACE,+BAAA;EA6SF;EA3SA;IACE,kCAAA;EA6SF;EA3SA;IACE,iCAAA;EA6SF;EA3SA;IACE,kCAAA;EA6SF;EA3SA;IACE,+BAAA;EA6SF;EA3SA;IACE,gCAAA;EA6SF;EA3SA;IACE,+BAAA;EA6SF;EA3SA;IACE,gCAAA;EA6SF;EA3SA;IACE,6BAAA;EA6SF;EA3SA;IACE,gCAAA;EA6SF;EA3SA;IACE,+BAAA;EA6SF;EA3SA;IACE,gCAAA;EA6SF;EA3SA;IACE,6BAAA;EA6SF;EA3SA;IACE,gCAAA;EA6SF;EA3SA;IACE,+BAAA;EA6SF;EA3SA;IACE,gCAAA;EA6SF;EA3SA;IACE,6BAAA;EA6SF;EA3SA;IACE,gCAAA;EA6SF;EA3SA;IACE,+BAAA;EA6SF;EA3SA;IACE,gCAAA;EA6SF;EA3SA;IACE,6BAAA;EA6SF;EA3SA;IACE,gCAAA;EA6SF;EA3SA;IACE,+BAAA;EA6SF;EA3SA;IACE,gCAAA;EA6SF;EA3SA;IACE,6BAAA;EA6SF;EA3SA;IACE,qBAAA;EA6SF;EA3SA;IACE,2BAAA;EA6SF;EA3SA;IACE,0BAAA;EA6SF;EA3SA;IACE,2BAAA;EA6SF;EA3SA;IACE,wBAAA;EA6SF;EA3SA;IACE,2BAAA;EA6SF;EA3SA;IACE,0BAAA;EA6SF;EA3SA;IACE,2BAAA;EA6SF;EA3SA;IACE,wBAAA;EA6SF;EA3SA;IACE,2BAAA;EA6SF;EA3SA;IACE,0BAAA;EA6SF;EA3SA;IACE,2BAAA;EA6SF;EA3SA;IACE,wBAAA;EA6SF;EA3SA;IACE,2BAAA;EA6SF;EA3SA;IACE,0BAAA;EA6SF;EA3SA;IACE,2BAAA;EA6SF;EA3SA;IACE,wBAAA;EA6SF;EA3SA;IACE,2BAAA;EA6SF;EA3SA;IACE,0BAAA;EA6SF;EA3SA;IACE,2BAAA;EA6SF;EA3SA;IACE,wBAAA;EA6SF;EA3SA;IACE,2BAAA;IACA,0BAAA;EA6SF;EA3SA;IACE,iCAAA;IACA,gCAAA;EA6SF;EA3SA;IACE,gCAAA;IACA,+BAAA;EA6SF;EA3SA;IACE,iCAAA;IACA,gCAAA;EA6SF;EA3SA;IACE,8BAAA;IACA,6BAAA;EA6SF;EA3SA;IACE,iCAAA;IACA,gCAAA;EA6SF;EA3SA;IACE,gCAAA;IACA,+BAAA;EA6SF;EA3SA;IACE,iCAAA;IACA,gCAAA;EA6SF;EA3SA;IACE,8BAAA;IACA,6BAAA;EA6SF;EA3SA;IACE,iCAAA;IACA,gCAAA;EA6SF;EA3SA;IACE,gCAAA;IACA,+BAAA;EA6SF;EA3SA;IACE,iCAAA;IACA,gCAAA;EA6SF;EA3SA;IACE,8BAAA;IACA,6BAAA;EA6SF;EA3SA;IACE,iCAAA;IACA,gCAAA;EA6SF;EA3SA;IACE,gCAAA;IACA,+BAAA;EA6SF;EA3SA;IACE,iCAAA;IACA,gCAAA;EA6SF;EA3SA;IACE,8BAAA;IACA,6BAAA;EA6SF;EA3SA;IACE,iCAAA;IACA,gCAAA;EA6SF;EA3SA;IACE,gCAAA;IACA,+BAAA;EA6SF;EA3SA;IACE,iCAAA;IACA,gCAAA;EA6SF;EA3SA;IACE,8BAAA;IACA,6BAAA;EA6SF;EA3SA;IACE,yBAAA;IACA,4BAAA;EA6SF;EA3SA;IACE,+BAAA;IACA,kCAAA;EA6SF;EA3SA;IACE,8BAAA;IACA,iCAAA;EA6SF;EA3SA;IACE,+BAAA;IACA,kCAAA;EA6SF;EA3SA;IACE,4BAAA;IACA,+BAAA;EA6SF;EA3SA;IACE,+BAAA;IACA,kCAAA;EA6SF;EA3SA;IACE,8BAAA;IACA,iCAAA;EA6SF;EA3SA;IACE,+BAAA;IACA,kCAAA;EA6SF;EA3SA;IACE,4BAAA;IACA,+BAAA;EA6SF;EA3SA;IACE,+BAAA;IACA,kCAAA;EA6SF;EA3SA;IACE,8BAAA;IACA,iCAAA;EA6SF;EA3SA;IACE,+BAAA;IACA,kCAAA;EA6SF;EA3SA;IACE,4BAAA;IACA,+BAAA;EA6SF;EA3SA;IACE,+BAAA;IACA,kCAAA;EA6SF;EA3SA;IACE,8BAAA;IACA,iCAAA;EA6SF;EA3SA;IACE,+BAAA;IACA,kCAAA;EA6SF;EA3SA;IACE,4BAAA;IACA,+BAAA;EA6SF;EA3SA;IACE,+BAAA;IACA,kCAAA;EA6SF;EA3SA;IACE,8BAAA;IACA,iCAAA;EA6SF;EA3SA;IACE,+BAAA;IACA,kCAAA;EA6SF;EA3SA;IACE,4BAAA;IACA,+BAAA;EA6SF;EA3SA;IACE,yBAAA;EA6SF;EA3SA;IACE,+BAAA;EA6SF;EA3SA;IACE,8BAAA;EA6SF;EA3SA;IACE,+BAAA;EA6SF;EA3SA;IACE,4BAAA;EA6SF;EA3SA;IACE,+BAAA;EA6SF;EA3SA;IACE,8BAAA;EA6SF;EA3SA;IACE,+BAAA;EA6SF;EA3SA;IACE,4BAAA;EA6SF;EA3SA;IACE,+BAAA;EA6SF;EA3SA;IACE,8BAAA;EA6SF;EA3SA;IACE,+BAAA;EA6SF;EA3SA;IACE,4BAAA;EA6SF;EA3SA;IACE,+BAAA;EA6SF;EA3SA;IACE,8BAAA;EA6SF;EA3SA;IACE,+BAAA;EA6SF;EA3SA;IACE,4BAAA;EA6SF;EA3SA;IACE,+BAAA;EA6SF;EA3SA;IACE,8BAAA;EA6SF;EA3SA;IACE,+BAAA;EA6SF;EA3SA;IACE,4BAAA;EA6SF;EA3SA;IACE,2BAAA;EA6SF;EA3SA;IACE,iCAAA;EA6SF;EA3SA;IACE,gCAAA;EA6SF;EA3SA;IACE,iCAAA;EA6SF;EA3SA;IACE,8BAAA;EA6SF;EA3SA;IACE,iCAAA;EA6SF;EA3SA;IACE,gCAAA;EA6SF;EA3SA;IACE,iCAAA;EA6SF;EA3SA;IACE,8BAAA;EA6SF;EA3SA;IACE,iCAAA;EA6SF;EA3SA;IACE,gCAAA;EA6SF;EA3SA;IACE,iCAAA;EA6SF;EA3SA;IACE,8BAAA;EA6SF;EA3SA;IACE,iCAAA;EA6SF;EA3SA;IACE,gCAAA;EA6SF;EA3SA;IACE,iCAAA;EA6SF;EA3SA;IACE,8BAAA;EA6SF;EA3SA;IACE,iCAAA;EA6SF;EA3SA;IACE,gCAAA;EA6SF;EA3SA;IACE,iCAAA;EA6SF;EA3SA;IACE,8BAAA;EA6SF;EA3SA;IACE,4BAAA;EA6SF;EA3SA;IACE,kCAAA;EA6SF;EA3SA;IACE,iCAAA;EA6SF;EA3SA;IACE,kCAAA;EA6SF;EA3SA;IACE,+BAAA;EA6SF;EA3SA;IACE,kCAAA;EA6SF;EA3SA;IACE,iCAAA;EA6SF;EA3SA;IACE,kCAAA;EA6SF;EA3SA;IACE,+BAAA;EA6SF;EA3SA;IACE,kCAAA;EA6SF;EA3SA;IACE,iCAAA;EA6SF;EA3SA;IACE,kCAAA;EA6SF;EA3SA;IACE,+BAAA;EA6SF;EA3SA;IACE,kCAAA;EA6SF;EA3SA;IACE,iCAAA;EA6SF;EA3SA;IACE,kCAAA;EA6SF;EA3SA;IACE,+BAAA;EA6SF;EA3SA;IACE,kCAAA;EA6SF;EA3SA;IACE,iCAAA;EA6SF;EA3SA;IACE,kCAAA;EA6SF;EA3SA;IACE,+BAAA;EA6SF;EA3SA;IACE,0BAAA;EA6SF;EA3SA;IACE,gCAAA;EA6SF;EA3SA;IACE,+BAAA;EA6SF;EA3SA;IACE,gCAAA;EA6SF;EA3SA;IACE,6BAAA;EA6SF;EA3SA;IACE,gCAAA;EA6SF;EA3SA;IACE,+BAAA;EA6SF;EA3SA;IACE,gCAAA;EA6SF;EA3SA;IACE,6BAAA;EA6SF;EA3SA;IACE,gCAAA;EA6SF;EA3SA;IACE,+BAAA;EA6SF;EA3SA;IACE,gCAAA;EA6SF;EA3SA;IACE,6BAAA;EA6SF;EA3SA;IACE,gCAAA;EA6SF;EA3SA;IACE,+BAAA;EA6SF;EA3SA;IACE,gCAAA;EA6SF;EA3SA;IACE,6BAAA;EA6SF;EA3SA;IACE,gCAAA;EA6SF;EA3SA;IACE,+BAAA;EA6SF;EA3SA;IACE,gCAAA;EA6SF;EA3SA;IACE,6BAAA;EA6SF;EA3SA;IACE,iBAAA;EA6SF;EA3SA;IACE,uBAAA;EA6SF;EA3SA;IACE,sBAAA;EA6SF;EA3SA;IACE,uBAAA;EA6SF;EA3SA;IACE,oBAAA;EA6SF;EA3SA;IACE,uBAAA;EA6SF;EA3SA;IACE,sBAAA;EA6SF;EA3SA;IACE,uBAAA;EA6SF;EA3SA;IACE,oBAAA;EA6SF;EA3SA;IACE,uBAAA;EA6SF;EA3SA;IACE,sBAAA;EA6SF;EA3SA;IACE,uBAAA;EA6SF;EA3SA;IACE,oBAAA;EA6SF;EA3SA;IACE,uBAAA;EA6SF;EA3SA;IACE,sBAAA;EA6SF;EA3SA;IACE,uBAAA;EA6SF;EA3SA;IACE,oBAAA;EA6SF;EA3SA;IACE,uBAAA;EA6SF;EA3SA;IACE,sBAAA;EA6SF;EA3SA;IACE,uBAAA;EA6SF;EA3SA;IACE,oBAAA;EA6SF;EA3SA;IACE,qBAAA;EA6SF;EA3SA;IACE,2BAAA;EA6SF;EA3SA;IACE,0BAAA;EA6SF;EA3SA;IACE,2BAAA;EA6SF;EA3SA;IACE,wBAAA;EA6SF;EA3SA;IACE,2BAAA;EA6SF;EA3SA;IACE,0BAAA;EA6SF;EA3SA;IACE,2BAAA;EA6SF;EA3SA;IACE,wBAAA;EA6SF;EA3SA;IACE,2BAAA;EA6SF;EA3SA;IACE,0BAAA;EA6SF;EA3SA;IACE,2BAAA;EA6SF;EA3SA;IACE,wBAAA;EA6SF;EA3SA;IACE,2BAAA;EA6SF;EA3SA;IACE,0BAAA;EA6SF;EA3SA;IACE,2BAAA;EA6SF;EA3SA;IACE,wBAAA;EA6SF;EA3SA;IACE,2BAAA;EA6SF;EA3SA;IACE,0BAAA;EA6SF;EA3SA;IACE,2BAAA;EA6SF;EA3SA;IACE,wBAAA;EA6SF;EA3SA;IACE,wBAAA;EA6SF;EA3SA;IACE,8BAAA;EA6SF;EA3SA;IACE,6BAAA;EA6SF;EA3SA;IACE,8BAAA;EA6SF;EA3SA;IACE,2BAAA;EA6SF;EA3SA;IACE,8BAAA;EA6SF;EA3SA;IACE,6BAAA;EA6SF;EA3SA;IACE,8BAAA;EA6SF;EA3SA;IACE,2BAAA;EA6SF;EA3SA;IACE,8BAAA;EA6SF;EA3SA;IACE,6BAAA;EA6SF;EA3SA;IACE,8BAAA;EA6SF;EA3SA;IACE,2BAAA;EA6SF;EA3SA;IACE,8BAAA;EA6SF;EA3SA;IACE,6BAAA;EA6SF;EA3SA;IACE,8BAAA;EA6SF;EA3SA;IACE,2BAAA;EA6SF;EA3SA;IACE,8BAAA;EA6SF;EA3SA;IACE,6BAAA;EA6SF;EA3SA;IACE,8BAAA;EA6SF;EA3SA;IACE,2BAAA;EA6SF;EA3SA;IACE,0CAAA;EA6SF;EA3SA;IACE,4CAAA;EA6SF;EA3SA;IACE,4CAAA;EA6SF;EA3SA;IACE,6BAAA;EA6SF;EA3SA;IACE,6BAAA;EA6SF;EA3SA;IACE,8BAAA;EA6SF;EA3SA;IACE,6BAAA;EA6SF;EA3SA;IACE,6BAAA;EA6SF;EA3SA;IACE,6BAAA;EA6SF;EA3SA;IACE,4BAAA;EA6SF;EA3SA;IACE,0BAAA;EA6SF;EA3SA;IACE,0BAAA;EA6SF;EA3SA;IACE,4CAAA;EA6SF;EA3SA;IACE,2CAAA;EA6SF;EA3SA;IACE,4CAAA;EA6SF;EA3SA;IACE,0CAAA;EA6SF;EA3SA;IACE,4CAAA;EA6SF;EA3SA;IACE,2CAAA;EA6SF;EA3SA;IACE,4CAAA;EA6SF;EA3SA;IACE,wCAAA;EA6SF;EA3SA;IACE,4CAAA;EA6SF;EA3SA;IACE,2CAAA;EA6SF;EA3SA;IACE,4CAAA;EA6SF;EA3SA;IACE,0CAAA;EA6SF;EA3SA;IACE,4CAAA;EA6SF;EA3SA;IACE,2CAAA;EA6SF;EA3SA;IACE,4CAAA;EA6SF;EA3SA;IACE,0CAAA;EA6SF;EA3SA;IACE,4CAAA;EA6SF;EA3SA;IACE,yCAAA;EA6SF;EA3SA;IACE,4CAAA;EA6SF;EA3SA;IACE,0CAAA;EA6SF;EA3SA;IACE,4CAAA;EA6SF;EA3SA;IACE,2CAAA;EA6SF;EA3SA;IACE,4CAAA;EA6SF;EA3SA;IACE,0CAAA;EA6SF;EA3SA;IACE,2BAAA;EA6SF;EA3SA;IACE,4BAAA;EA6SF;EA3SA;IACE,6BAAA;EA6SF;EA3SA;IACE,2BAAA;EA6SF;EA3SA;IACE,yBAAA;EA6SF;EA3SA;IACE,yBAAA;EA6SF;EA3SA;IACE,yBAAA;EA6SF;EA3SA;IACE,0BAAA;EA6SF;EA3SA;IACE,0BAAA;EA6SF;EA3SA;IACE,yBAAA;EA6SF;EA3SA;IACE,yBAAA;EA6SF;EA3SA;IACE,yBAAA;EA6SF;EA3SA;IACE,yBAAA;EA6SF;EA3SA;IACE,yBAAA;EA6SF;EA3SA;IACE,yBAAA;EA6SF;EA3SA;IACE,yBAAA;EA6SF;EA3SA;IACE,yBAAA;EA6SF;EA3SA;IACE,yBAAA;EA6SF;EA3SA;IACE,0BAAA;EA6SF;EA3SA;IACE,0BAAA;EA6SF;EA3SA;IACE,0BAAA;EA6SF;EA3SA;IACE,0BAAA;EA6SF;EA3SA;IACE,0BAAA;EA6SF;EA3SA;IACE,0BAAA;EA6SF;EA3SA;IACE,0BAAA;EA6SF;EA3SA;IACE,0BAAA;EA6SF;EA3SA;IACE,0BAAA;EA6SF;EA3SA;IACE,0BAAA;EA6SF;EA3SA;IACE,0BAAA;EA6SF;EA3SA;IACE,0BAAA;EA6SF;EA3SA;IACE,0BAAA;EA6SF;EA3SA;IACE,0BAAA;EA6SF;EA3SA;IACE,0BAAA;EA6SF;EA3SA;IACE,0BAAA;EA6SF;EA3SA;IACE,0BAAA;EA6SF;EA3SA;IACE,0BAAA;EA6SF;EA3SA;IACE,2BAAA;EA6SF;EA3SA;IACE,2BAAA;EA6SF;EA3SA;IACE,2BAAA;EA6SF;EA3SA;IACE,2BAAA;EA6SF;EA3SA;IACE,2BAAA;EA6SF;EA3SA;IACE,2BAAA;EA6SF;EA3SA;IACE,2BAAA;EA6SF;EA3SA;IACE,2BAAA;EA6SF;EA3SA;IACE,2BAAA;EA6SF;EA3SA;IACE,2BAAA;EA6SF;EA3SA;IACE,2BAAA;EA6SF;EA3SA;IACE,2BAAA;EA6SF;EA3SA;IACE,2BAAA;EA6SF;EA3SA;IACE,2BAAA;EA6SF;EA3SA;IACE,2BAAA;EA6SF;EA3SA;IACE,2BAAA;EA6SF;EA3SA;IACE,2BAAA;EA6SF;EA3SA;IACE,2BAAA;EA6SF;EA3SA;IACE,2BAAA;EA6SF;EA3SA;IACE,2BAAA;EA6SF;EA3SA;IACE,2BAAA;EA6SF;EA3SA;IACE,2BAAA;EA6SF;EA3SA;IACE,2BAAA;EA6SF;EA3SA;IACE,2BAAA;EA6SF;EA3SA;IACE,2BAAA;EA6SF;EA3SA;IACE,2BAAA;EA6SF;EA3SA;IACE,4BAAA;EA6SF;EA3SA;IACE,4BAAA;EA6SF;EA3SA;IACE,0BAAA;EA6SF;EA3SA;IACE,0BAAA;EA6SF;EA3SA;IACE,0BAAA;EA6SF;EA3SA;IACE,2BAAA;EA6SF;EA3SA;IACE,2BAAA;EA6SF;EA3SA;IACE,0BAAA;EA6SF;EA3SA;IACE,0BAAA;EA6SF;EA3SA;IACE,0BAAA;EA6SF;EA3SA;IACE,0BAAA;EA6SF;EA3SA;IACE,0BAAA;EA6SF;EA3SA;IACE,0BAAA;EA6SF;EA3SA;IACE,0BAAA;EA6SF;EA3SA;IACE,0BAAA;EA6SF;EA3SA;IACE,0BAAA;EA6SF;EA3SA;IACE,2BAAA;EA6SF;EA3SA;IACE,2BAAA;EA6SF;EA3SA;IACE,2BAAA;EA6SF;EA3SA;IACE,2BAAA;EA6SF;EA3SA;IACE,2BAAA;EA6SF;EA3SA;IACE,2BAAA;EA6SF;EA3SA;IACE,2BAAA;EA6SF;EA3SA;IACE,2BAAA;EA6SF;EA3SA;IACE,2BAAA;EA6SF;EA3SA;IACE,2BAAA;EA6SF;EA3SA;IACE,2BAAA;EA6SF;EA3SA;IACE,2BAAA;EA6SF;EA3SA;IACE,2BAAA;EA6SF;EA3SA;IACE,2BAAA;EA6SF;EA3SA;IACE,2BAAA;EA6SF;EA3SA;IACE,2BAAA;EA6SF;EA3SA;IACE,2BAAA;EA6SF;EA3SA;IACE,2BAAA;EA6SF;EA3SA;IACE,4BAAA;EA6SF;EA3SA;IACE,4BAAA;EA6SF;EA3SA;IACE,4BAAA;EA6SF;EA3SA;IACE,4BAAA;EA6SF;EA3SA;IACE,4BAAA;EA6SF;EA3SA;IACE,4BAAA;EA6SF;EA3SA;IACE,4BAAA;EA6SF;EA3SA;IACE,4BAAA;EA6SF;EA3SA;IACE,4BAAA;EA6SF;EA3SA;IACE,4BAAA;EA6SF;EA3SA;IACE,4BAAA;EA6SF;EA3SA;IACE,4BAAA;EA6SF;EA3SA;IACE,4BAAA;EA6SF;EA3SA;IACE,4BAAA;EA6SF;EA3SA;IACE,4BAAA;EA6SF;EA3SA;IACE,4BAAA;EA6SF;EA3SA;IACE,4BAAA;EA6SF;EA3SA;IACE,4BAAA;EA6SF;EA3SA;IACE,4BAAA;EA6SF;EA3SA;IACE,4BAAA;EA6SF;EA3SA;IACE,4BAAA;EA6SF;EA3SA;IACE,4BAAA;EA6SF;EA3SA;IACE,4BAAA;EA6SF;EA3SA;IACE,4BAAA;EA6SF;EA3SA;IACE,4BAAA;EA6SF;EA3SA;IACE,4BAAA;EA6SF;EA3SA;IACE,6BAAA;EA6SF;AACF;AA3SA;EACE;IACE,sBAAA;EA6SF;EA3SA;IACE,uBAAA;EA6SF;EA3SA;IACE,sBAAA;EA6SF;EA3SA;IACE,8BAAA;EA6SF;EA3SA;IACE,4BAAA;EA6SF;EA3SA;IACE,2BAAA;EA6SF;EA3SA;IACE,iCAAA;EA6SF;EA3SA;IACE,2BAAA;EA6SF;EA3SA;IACE,yBAAA;EA6SF;EA3SA;IACE,2BAAA;EA6SF;EA3SA;IACE,4BAAA;EA6SF;EA3SA;IACE,2BAAA;EA6SF;EA3SA;IACE,0BAAA;EA6SF;EA3SA;IACE,gCAAA;EA6SF;EA3SA;IACE,yBAAA;EA6SF;EA3SA;IACE,wBAAA;EA6SF;EA3SA;IACE,yBAAA;EA6SF;EA3SA;IACE,6BAAA;EA6SF;EA3SA;IACE,8BAAA;EA6SF;EA3SA;IACE,wBAAA;EA6SF;EA3SA;IACE,+BAAA;EA6SF;EA3SA;IACE,wBAAA;EA6SF;EA3SA;IACE,2BAAA;EA6SF;EA3SA;IACE,6BAAA;EA6SF;EA3SA;IACE,6BAAA;EA6SF;EA3SA;IACE,0BAAA;EA6SF;EA3SA;IACE,2BAAA;EA6SF;EA3SA;IACE,uBAAA;EA6SF;EA3SA;IACE,qBAAA;EA6SF;EA3SA;IACE,qBAAA;EA6SF;EA3SA;IACE,qBAAA;EA6SF;EA3SA;IACE,sBAAA;EA6SF;EA3SA;IACE,sBAAA;EA6SF;EA3SA;IACE,qBAAA;EA6SF;EA3SA;IACE,qBAAA;EA6SF;EA3SA;IACE,qBAAA;EA6SF;EA3SA;IACE,qBAAA;EA6SF;EA3SA;IACE,qBAAA;EA6SF;EA3SA;IACE,qBAAA;EA6SF;EA3SA;IACE,qBAAA;EA6SF;EA3SA;IACE,qBAAA;EA6SF;EA3SA;IACE,qBAAA;EA6SF;EA3SA;IACE,sBAAA;EA6SF;EA3SA;IACE,sBAAA;EA6SF;EA3SA;IACE,sBAAA;EA6SF;EA3SA;IACE,sBAAA;EA6SF;EA3SA;IACE,sBAAA;EA6SF;EA3SA;IACE,sBAAA;EA6SF;EA3SA;IACE,sBAAA;EA6SF;EA3SA;IACE,sBAAA;EA6SF;EA3SA;IACE,sBAAA;EA6SF;EA3SA;IACE,sBAAA;EA6SF;EA3SA;IACE,sBAAA;EA6SF;EA3SA;IACE,sBAAA;EA6SF;EA3SA;IACE,sBAAA;EA6SF;EA3SA;IACE,sBAAA;EA6SF;EA3SA;IACE,sBAAA;EA6SF;EA3SA;IACE,sBAAA;EA6SF;EA3SA;IACE,sBAAA;EA6SF;EA3SA;IACE,sBAAA;EA6SF;EA3SA;IACE,uBAAA;EA6SF;EA3SA;IACE,uBAAA;EA6SF;EA3SA;IACE,uBAAA;EA6SF;EA3SA;IACE,uBAAA;EA6SF;EA3SA;IACE,uBAAA;EA6SF;EA3SA;IACE,uBAAA;EA6SF;EA3SA;IACE,uBAAA;EA6SF;EA3SA;IACE,uBAAA;EA6SF;EA3SA;IACE,uBAAA;EA6SF;EA3SA;IACE,uBAAA;EA6SF;EA3SA;IACE,uBAAA;EA6SF;EA3SA;IACE,uBAAA;EA6SF;EA3SA;IACE,uBAAA;EA6SF;EA3SA;IACE,uBAAA;EA6SF;EA3SA;IACE,uBAAA;EA6SF;EA3SA;IACE,uBAAA;EA6SF;EA3SA;IACE,uBAAA;EA6SF;EA3SA;IACE,uBAAA;EA6SF;EA3SA;IACE,uBAAA;EA6SF;EA3SA;IACE,uBAAA;EA6SF;EA3SA;IACE,uBAAA;EA6SF;EA3SA;IACE,uBAAA;EA6SF;EA3SA;IACE,uBAAA;EA6SF;EA3SA;IACE,uBAAA;EA6SF;EA3SA;IACE,uBAAA;EA6SF;EA3SA;IACE,uBAAA;EA6SF;EA3SA;IACE,wBAAA;EA6SF;EA3SA;IACE,2BAAA;EA6SF;EA3SA;IACE,yBAAA;EA6SF;EA3SA;IACE,yBAAA;EA6SF;EA3SA;IACE,yBAAA;EA6SF;EA3SA;IACE,0BAAA;EA6SF;EA3SA;IACE,0BAAA;EA6SF;EA3SA;IACE,yBAAA;EA6SF;EA3SA;IACE,yBAAA;EA6SF;EA3SA;IACE,yBAAA;EA6SF;EA3SA;IACE,yBAAA;EA6SF;EA3SA;IACE,yBAAA;EA6SF;EA3SA;IACE,yBAAA;EA6SF;EA3SA;IACE,yBAAA;EA6SF;EA3SA;IACE,yBAAA;EA6SF;EA3SA;IACE,yBAAA;EA6SF;EA3SA;IACE,0BAAA;EA6SF;EA3SA;IACE,0BAAA;EA6SF;EA3SA;IACE,0BAAA;EA6SF;EA3SA;IACE,0BAAA;EA6SF;EA3SA;IACE,0BAAA;EA6SF;EA3SA;IACE,0BAAA;EA6SF;EA3SA;IACE,0BAAA;EA6SF;EA3SA;IACE,0BAAA;EA6SF;EA3SA;IACE,0BAAA;EA6SF;EA3SA;IACE,0BAAA;EA6SF;EA3SA;IACE,0BAAA;EA6SF;EA3SA;IACE,0BAAA;EA6SF;EA3SA;IACE,0BAAA;EA6SF;EA3SA;IACE,0BAAA;EA6SF;EA3SA;IACE,0BAAA;EA6SF;EA3SA;IACE,0BAAA;EA6SF;EA3SA;IACE,0BAAA;EA6SF;EA3SA;IACE,0BAAA;EA6SF;EA3SA;IACE,2BAAA;EA6SF;EA3SA;IACE,2BAAA;EA6SF;EA3SA;IACE,2BAAA;EA6SF;EA3SA;IACE,2BAAA;EA6SF;EA3SA;IACE,2BAAA;EA6SF;EA3SA;IACE,2BAAA;EA6SF;EA3SA;IACE,2BAAA;EA6SF;EA3SA;IACE,2BAAA;EA6SF;EA3SA;IACE,2BAAA;EA6SF;EA3SA;IACE,2BAAA;EA6SF;EA3SA;IACE,2BAAA;EA6SF;EA3SA;IACE,2BAAA;EA6SF;EA3SA;IACE,2BAAA;EA6SF;EA3SA;IACE,2BAAA;EA6SF;EA3SA;IACE,2BAAA;EA6SF;EA3SA;IACE,2BAAA;EA6SF;EA3SA;IACE,2BAAA;EA6SF;EA3SA;IACE,2BAAA;EA6SF;EA3SA;IACE,2BAAA;EA6SF;EA3SA;IACE,2BAAA;EA6SF;EA3SA;IACE,2BAAA;EA6SF;EA3SA;IACE,2BAAA;EA6SF;EA3SA;IACE,2BAAA;EA6SF;EA3SA;IACE,2BAAA;EA6SF;EA3SA;IACE,2BAAA;EA6SF;EA3SA;IACE,2BAAA;EA6SF;EA3SA;IACE,4BAAA;EA6SF;EA3SA;IACE,wBAAA;EA6SF;EA3SA;IACE,sBAAA;EA6SF;EA3SA;IACE,sBAAA;EA6SF;EA3SA;IACE,sBAAA;EA6SF;EA3SA;IACE,uBAAA;EA6SF;EA3SA;IACE,uBAAA;EA6SF;EA3SA;IACE,sBAAA;EA6SF;EA3SA;IACE,sBAAA;EA6SF;EA3SA;IACE,sBAAA;EA6SF;EA3SA;IACE,sBAAA;EA6SF;EA3SA;IACE,sBAAA;EA6SF;EA3SA;IACE,sBAAA;EA6SF;EA3SA;IACE,sBAAA;EA6SF;EA3SA;IACE,sBAAA;EA6SF;EA3SA;IACE,sBAAA;EA6SF;EA3SA;IACE,uBAAA;EA6SF;EA3SA;IACE,uBAAA;EA6SF;EA3SA;IACE,uBAAA;EA6SF;EA3SA;IACE,uBAAA;EA6SF;EA3SA;IACE,uBAAA;EA6SF;EA3SA;IACE,uBAAA;EA6SF;EA3SA;IACE,uBAAA;EA6SF;EA3SA;IACE,uBAAA;EA6SF;EA3SA;IACE,uBAAA;EA6SF;EA3SA;IACE,uBAAA;EA6SF;EA3SA;IACE,uBAAA;EA6SF;EA3SA;IACE,uBAAA;EA6SF;EA3SA;IACE,uBAAA;EA6SF;EA3SA;IACE,uBAAA;EA6SF;EA3SA;IACE,uBAAA;EA6SF;EA3SA;IACE,uBAAA;EA6SF;EA3SA;IACE,uBAAA;EA6SF;EA3SA;IACE,uBAAA;EA6SF;EA3SA;IACE,wBAAA;EA6SF;EA3SA;IACE,wBAAA;EA6SF;EA3SA;IACE,wBAAA;EA6SF;EA3SA;IACE,wBAAA;EA6SF;EA3SA;IACE,wBAAA;EA6SF;EA3SA;IACE,wBAAA;EA6SF;EA3SA;IACE,wBAAA;EA6SF;EA3SA;IACE,wBAAA;EA6SF;EA3SA;IACE,wBAAA;EA6SF;EA3SA;IACE,wBAAA;EA6SF;EA3SA;IACE,wBAAA;EA6SF;EA3SA;IACE,wBAAA;EA6SF;EA3SA;IACE,wBAAA;EA6SF;EA3SA;IACE,wBAAA;EA6SF;EA3SA;IACE,wBAAA;EA6SF;EA3SA;IACE,wBAAA;EA6SF;EA3SA;IACE,wBAAA;EA6SF;EA3SA;IACE,wBAAA;EA6SF;EA3SA;IACE,wBAAA;EA6SF;EA3SA;IACE,wBAAA;EA6SF;EA3SA;IACE,wBAAA;EA6SF;EA3SA;IACE,wBAAA;EA6SF;EA3SA;IACE,wBAAA;EA6SF;EA3SA;IACE,wBAAA;EA6SF;EA3SA;IACE,wBAAA;EA6SF;EA3SA;IACE,wBAAA;EA6SF;EA3SA;IACE,yBAAA;EA6SF;EA3SA;IACE,4BAAA;EA6SF;EA3SA;IACE,0BAAA;EA6SF;EA3SA;IACE,0BAAA;EA6SF;EA3SA;IACE,0BAAA;EA6SF;EA3SA;IACE,2BAAA;EA6SF;EA3SA;IACE,2BAAA;EA6SF;EA3SA;IACE,0BAAA;EA6SF;EA3SA;IACE,0BAAA;EA6SF;EA3SA;IACE,0BAAA;EA6SF;EA3SA;IACE,0BAAA;EA6SF;EA3SA;IACE,0BAAA;EA6SF;EA3SA;IACE,0BAAA;EA6SF;EA3SA;IACE,0BAAA;EA6SF;EA3SA;IACE,0BAAA;EA6SF;EA3SA;IACE,0BAAA;EA6SF;EA3SA;IACE,2BAAA;EA6SF;EA3SA;IACE,2BAAA;EA6SF;EA3SA;IACE,2BAAA;EA6SF;EA3SA;IACE,2BAAA;EA6SF;EA3SA;IACE,2BAAA;EA6SF;EA3SA;IACE,2BAAA;EA6SF;EA3SA;IACE,2BAAA;EA6SF;EA3SA;IACE,2BAAA;EA6SF;EA3SA;IACE,2BAAA;EA6SF;EA3SA;IACE,2BAAA;EA6SF;EA3SA;IACE,2BAAA;EA6SF;EA3SA;IACE,2BAAA;EA6SF;EA3SA;IACE,2BAAA;EA6SF;EA3SA;IACE,2BAAA;EA6SF;EA3SA;IACE,2BAAA;EA6SF;EA3SA;IACE,2BAAA;EA6SF;EA3SA;IACE,2BAAA;EA6SF;EA3SA;IACE,2BAAA;EA6SF;EA3SA;IACE,4BAAA;EA6SF;EA3SA;IACE,4BAAA;EA6SF;EA3SA;IACE,4BAAA;EA6SF;EA3SA;IACE,4BAAA;EA6SF;EA3SA;IACE,4BAAA;EA6SF;EA3SA;IACE,4BAAA;EA6SF;EA3SA;IACE,4BAAA;EA6SF;EA3SA;IACE,4BAAA;EA6SF;EA3SA;IACE,4BAAA;EA6SF;EA3SA;IACE,4BAAA;EA6SF;EA3SA;IACE,4BAAA;EA6SF;EA3SA;IACE,4BAAA;EA6SF;EA3SA;IACE,4BAAA;EA6SF;EA3SA;IACE,4BAAA;EA6SF;EA3SA;IACE,4BAAA;EA6SF;EA3SA;IACE,4BAAA;EA6SF;EA3SA;IACE,4BAAA;EA6SF;EA3SA;IACE,4BAAA;EA6SF;EA3SA;IACE,4BAAA;EA6SF;EA3SA;IACE,4BAAA;EA6SF;EA3SA;IACE,4BAAA;EA6SF;EA3SA;IACE,4BAAA;EA6SF;EA3SA;IACE,4BAAA;EA6SF;EA3SA;IACE,4BAAA;EA6SF;EA3SA;IACE,4BAAA;EA6SF;EA3SA;IACE,4BAAA;EA6SF;EA3SA;IACE,6BAAA;EA6SF;EA3SA;IACE,yBAAA;EA6SF;EA3SA;IACE,8BAAA;EA6SF;EA3SA;IACE,iCAAA;EA6SF;EA3SA;IACE,sCAAA;EA6SF;EA3SA;IACE,yCAAA;EA6SF;EA3SA;IACE,uBAAA;EA6SF;EA3SA;IACE,uBAAA;EA6SF;EA3SA;IACE,yBAAA;EA6SF;EA3SA;IACE,yBAAA;EA6SF;EA3SA;IACE,0BAAA;EA6SF;EA3SA;IACE,4BAAA;EA6SF;EA3SA;IACE,kCAAA;EA6SF;EA3SA;IACE,sCAAA;EA6SF;EA3SA;IACE,oCAAA;EA6SF;EA3SA;IACE,kCAAA;EA6SF;EA3SA;IACE,yCAAA;EA6SF;EA3SA;IACE,wCAAA;EA6SF;EA3SA;IACE,wCAAA;EA6SF;EA3SA;IACE,kCAAA;EA6SF;EA3SA;IACE,gCAAA;EA6SF;EA3SA;IACE,8BAAA;EA6SF;EA3SA;IACE,gCAAA;EA6SF;EA3SA;IACE,+BAAA;EA6SF;EA3SA;IACE,oCAAA;EA6SF;EA3SA;IACE,kCAAA;EA6SF;EA3SA;IACE,gCAAA;EA6SF;EA3SA;IACE,uCAAA;EA6SF;EA3SA;IACE,sCAAA;EA6SF;EA3SA;IACE,iCAAA;EA6SF;EA3SA;IACE,2BAAA;EA6SF;EA3SA;IACE,iCAAA;EA6SF;EA3SA;IACE,+BAAA;EA6SF;EA3SA;IACE,6BAAA;EA6SF;EA3SA;IACE,+BAAA;EA6SF;EA3SA;IACE,8BAAA;EA6SF;EA3SA;IACE,oBAAA;EA6SF;EA3SA;IACE,mBAAA;EA6SF;EA3SA;IACE,mBAAA;EA6SF;EA3SA;IACE,mBAAA;EA6SF;EA3SA;IACE,mBAAA;EA6SF;EA3SA;IACE,mBAAA;EA6SF;EA3SA;IACE,mBAAA;EA6SF;EA3SA;IACE,mBAAA;EA6SF;EA3SA;IACE,oBAAA;EA6SF;EA3SA;IACE,0BAAA;EA6SF;EA3SA;IACE,yBAAA;EA6SF;EA3SA;IACE,0BAAA;EA6SF;EA3SA;IACE,uBAAA;EA6SF;EA3SA;IACE,0BAAA;EA6SF;EA3SA;IACE,yBAAA;EA6SF;EA3SA;IACE,0BAAA;EA6SF;EA3SA;IACE,uBAAA;EA6SF;EA3SA;IACE,0BAAA;EA6SF;EA3SA;IACE,yBAAA;EA6SF;EA3SA;IACE,0BAAA;EA6SF;EA3SA;IACE,uBAAA;EA6SF;EA3SA;IACE,0BAAA;EA6SF;EA3SA;IACE,yBAAA;EA6SF;EA3SA;IACE,0BAAA;EA6SF;EA3SA;IACE,uBAAA;EA6SF;EA3SA;IACE,0BAAA;EA6SF;EA3SA;IACE,yBAAA;EA6SF;EA3SA;IACE,0BAAA;EA6SF;EA3SA;IACE,uBAAA;EA6SF;EA3SA;IACE,uBAAA;EA6SF;EA3SA;IACE,0BAAA;IACA,yBAAA;EA6SF;EA3SA;IACE,gCAAA;IACA,+BAAA;EA6SF;EA3SA;IACE,+BAAA;IACA,8BAAA;EA6SF;EA3SA;IACE,gCAAA;IACA,+BAAA;EA6SF;EA3SA;IACE,6BAAA;IACA,4BAAA;EA6SF;EA3SA;IACE,gCAAA;IACA,+BAAA;EA6SF;EA3SA;IACE,+BAAA;IACA,8BAAA;EA6SF;EA3SA;IACE,gCAAA;IACA,+BAAA;EA6SF;EA3SA;IACE,6BAAA;IACA,4BAAA;EA6SF;EA3SA;IACE,gCAAA;IACA,+BAAA;EA6SF;EA3SA;IACE,+BAAA;IACA,8BAAA;EA6SF;EA3SA;IACE,gCAAA;IACA,+BAAA;EA6SF;EA3SA;IACE,6BAAA;IACA,4BAAA;EA6SF;EA3SA;IACE,gCAAA;IACA,+BAAA;EA6SF;EA3SA;IACE,+BAAA;IACA,8BAAA;EA6SF;EA3SA;IACE,gCAAA;IACA,+BAAA;EA6SF;EA3SA;IACE,6BAAA;IACA,4BAAA;EA6SF;EA3SA;IACE,gCAAA;IACA,+BAAA;EA6SF;EA3SA;IACE,+BAAA;IACA,8BAAA;EA6SF;EA3SA;IACE,gCAAA;IACA,+BAAA;EA6SF;EA3SA;IACE,6BAAA;IACA,4BAAA;EA6SF;EA3SA;IACE,6BAAA;IACA,4BAAA;EA6SF;EA3SA;IACE,wBAAA;IACA,2BAAA;EA6SF;EA3SA;IACE,8BAAA;IACA,iCAAA;EA6SF;EA3SA;IACE,6BAAA;IACA,gCAAA;EA6SF;EA3SA;IACE,8BAAA;IACA,iCAAA;EA6SF;EA3SA;IACE,2BAAA;IACA,8BAAA;EA6SF;EA3SA;IACE,8BAAA;IACA,iCAAA;EA6SF;EA3SA;IACE,6BAAA;IACA,gCAAA;EA6SF;EA3SA;IACE,8BAAA;IACA,iCAAA;EA6SF;EA3SA;IACE,2BAAA;IACA,8BAAA;EA6SF;EA3SA;IACE,8BAAA;IACA,iCAAA;EA6SF;EA3SA;IACE,6BAAA;IACA,gCAAA;EA6SF;EA3SA;IACE,8BAAA;IACA,iCAAA;EA6SF;EA3SA;IACE,2BAAA;IACA,8BAAA;EA6SF;EA3SA;IACE,8BAAA;IACA,iCAAA;EA6SF;EA3SA;IACE,6BAAA;IACA,gCAAA;EA6SF;EA3SA;IACE,8BAAA;IACA,iCAAA;EA6SF;EA3SA;IACE,2BAAA;IACA,8BAAA;EA6SF;EA3SA;IACE,8BAAA;IACA,iCAAA;EA6SF;EA3SA;IACE,6BAAA;IACA,gCAAA;EA6SF;EA3SA;IACE,8BAAA;IACA,iCAAA;EA6SF;EA3SA;IACE,2BAAA;IACA,8BAAA;EA6SF;EA3SA;IACE,2BAAA;IACA,8BAAA;EA6SF;EA3SA;IACE,wBAAA;EA6SF;EA3SA;IACE,8BAAA;EA6SF;EA3SA;IACE,6BAAA;EA6SF;EA3SA;IACE,8BAAA;EA6SF;EA3SA;IACE,2BAAA;EA6SF;EA3SA;IACE,8BAAA;EA6SF;EA3SA;IACE,6BAAA;EA6SF;EA3SA;IACE,8BAAA;EA6SF;EA3SA;IACE,2BAAA;EA6SF;EA3SA;IACE,8BAAA;EA6SF;EA3SA;IACE,6BAAA;EA6SF;EA3SA;IACE,8BAAA;EA6SF;EA3SA;IACE,2BAAA;EA6SF;EA3SA;IACE,8BAAA;EA6SF;EA3SA;IACE,6BAAA;EA6SF;EA3SA;IACE,8BAAA;EA6SF;EA3SA;IACE,2BAAA;EA6SF;EA3SA;IACE,8BAAA;EA6SF;EA3SA;IACE,6BAAA;EA6SF;EA3SA;IACE,8BAAA;EA6SF;EA3SA;IACE,2BAAA;EA6SF;EA3SA;IACE,2BAAA;EA6SF;EA3SA;IACE,0BAAA;EA6SF;EA3SA;IACE,gCAAA;EA6SF;EA3SA;IACE,+BAAA;EA6SF;EA3SA;IACE,gCAAA;EA6SF;EA3SA;IACE,6BAAA;EA6SF;EA3SA;IACE,gCAAA;EA6SF;EA3SA;IACE,+BAAA;EA6SF;EA3SA;IACE,gCAAA;EA6SF;EA3SA;IACE,6BAAA;EA6SF;EA3SA;IACE,gCAAA;EA6SF;EA3SA;IACE,+BAAA;EA6SF;EA3SA;IACE,gCAAA;EA6SF;EA3SA;IACE,6BAAA;EA6SF;EA3SA;IACE,gCAAA;EA6SF;EA3SA;IACE,+BAAA;EA6SF;EA3SA;IACE,gCAAA;EA6SF;EA3SA;IACE,6BAAA;EA6SF;EA3SA;IACE,gCAAA;EA6SF;EA3SA;IACE,+BAAA;EA6SF;EA3SA;IACE,gCAAA;EA6SF;EA3SA;IACE,6BAAA;EA6SF;EA3SA;IACE,6BAAA;EA6SF;EA3SA;IACE,2BAAA;EA6SF;EA3SA;IACE,iCAAA;EA6SF;EA3SA;IACE,gCAAA;EA6SF;EA3SA;IACE,iCAAA;EA6SF;EA3SA;IACE,8BAAA;EA6SF;EA3SA;IACE,iCAAA;EA6SF;EA3SA;IACE,gCAAA;EA6SF;EA3SA;IACE,iCAAA;EA6SF;EA3SA;IACE,8BAAA;EA6SF;EA3SA;IACE,iCAAA;EA6SF;EA3SA;IACE,gCAAA;EA6SF;EA3SA;IACE,iCAAA;EA6SF;EA3SA;IACE,8BAAA;EA6SF;EA3SA;IACE,iCAAA;EA6SF;EA3SA;IACE,gCAAA;EA6SF;EA3SA;IACE,iCAAA;EA6SF;EA3SA;IACE,8BAAA;EA6SF;EA3SA;IACE,iCAAA;EA6SF;EA3SA;IACE,gCAAA;EA6SF;EA3SA;IACE,iCAAA;EA6SF;EA3SA;IACE,8BAAA;EA6SF;EA3SA;IACE,8BAAA;EA6SF;EA3SA;IACE,yBAAA;EA6SF;EA3SA;IACE,+BAAA;EA6SF;EA3SA;IACE,8BAAA;EA6SF;EA3SA;IACE,+BAAA;EA6SF;EA3SA;IACE,4BAAA;EA6SF;EA3SA;IACE,+BAAA;EA6SF;EA3SA;IACE,8BAAA;EA6SF;EA3SA;IACE,+BAAA;EA6SF;EA3SA;IACE,4BAAA;EA6SF;EA3SA;IACE,+BAAA;EA6SF;EA3SA;IACE,8BAAA;EA6SF;EA3SA;IACE,+BAAA;EA6SF;EA3SA;IACE,4BAAA;EA6SF;EA3SA;IACE,+BAAA;EA6SF;EA3SA;IACE,8BAAA;EA6SF;EA3SA;IACE,+BAAA;EA6SF;EA3SA;IACE,4BAAA;EA6SF;EA3SA;IACE,+BAAA;EA6SF;EA3SA;IACE,8BAAA;EA6SF;EA3SA;IACE,+BAAA;EA6SF;EA3SA;IACE,4BAAA;EA6SF;EA3SA;IACE,4BAAA;EA6SF;EA3SA;IACE,2BAAA;EA6SF;EA3SA;IACE,0BAAA;EA6SF;EA3SA;IACE,2BAAA;EA6SF;EA3SA;IACE,wBAAA;EA6SF;EA3SA;IACE,2BAAA;EA6SF;EA3SA;IACE,0BAAA;EA6SF;EA3SA;IACE,2BAAA;EA6SF;EA3SA;IACE,wBAAA;EA6SF;EA3SA;IACE,2BAAA;EA6SF;EA3SA;IACE,0BAAA;EA6SF;EA3SA;IACE,2BAAA;EA6SF;EA3SA;IACE,wBAAA;EA6SF;EA3SA;IACE,2BAAA;EA6SF;EA3SA;IACE,0BAAA;EA6SF;EA3SA;IACE,2BAAA;EA6SF;EA3SA;IACE,wBAAA;EA6SF;EA3SA;IACE,2BAAA;EA6SF;EA3SA;IACE,0BAAA;EA6SF;EA3SA;IACE,2BAAA;EA6SF;EA3SA;IACE,wBAAA;EA6SF;EA3SA;IACE,iCAAA;IACA,gCAAA;EA6SF;EA3SA;IACE,gCAAA;IACA,+BAAA;EA6SF;EA3SA;IACE,iCAAA;IACA,gCAAA;EA6SF;EA3SA;IACE,8BAAA;IACA,6BAAA;EA6SF;EA3SA;IACE,iCAAA;IACA,gCAAA;EA6SF;EA3SA;IACE,gCAAA;IACA,+BAAA;EA6SF;EA3SA;IACE,iCAAA;IACA,gCAAA;EA6SF;EA3SA;IACE,8BAAA;IACA,6BAAA;EA6SF;EA3SA;IACE,iCAAA;IACA,gCAAA;EA6SF;EA3SA;IACE,gCAAA;IACA,+BAAA;EA6SF;EA3SA;IACE,iCAAA;IACA,gCAAA;EA6SF;EA3SA;IACE,8BAAA;IACA,6BAAA;EA6SF;EA3SA;IACE,iCAAA;IACA,gCAAA;EA6SF;EA3SA;IACE,gCAAA;IACA,+BAAA;EA6SF;EA3SA;IACE,iCAAA;IACA,gCAAA;EA6SF;EA3SA;IACE,8BAAA;IACA,6BAAA;EA6SF;EA3SA;IACE,iCAAA;IACA,gCAAA;EA6SF;EA3SA;IACE,gCAAA;IACA,+BAAA;EA6SF;EA3SA;IACE,iCAAA;IACA,gCAAA;EA6SF;EA3SA;IACE,8BAAA;IACA,6BAAA;EA6SF;EA3SA;IACE,+BAAA;IACA,kCAAA;EA6SF;EA3SA;IACE,8BAAA;IACA,iCAAA;EA6SF;EA3SA;IACE,+BAAA;IACA,kCAAA;EA6SF;EA3SA;IACE,4BAAA;IACA,+BAAA;EA6SF;EA3SA;IACE,+BAAA;IACA,kCAAA;EA6SF;EA3SA;IACE,8BAAA;IACA,iCAAA;EA6SF;EA3SA;IACE,+BAAA;IACA,kCAAA;EA6SF;EA3SA;IACE,4BAAA;IACA,+BAAA;EA6SF;EA3SA;IACE,+BAAA;IACA,kCAAA;EA6SF;EA3SA;IACE,8BAAA;IACA,iCAAA;EA6SF;EA3SA;IACE,+BAAA;IACA,kCAAA;EA6SF;EA3SA;IACE,4BAAA;IACA,+BAAA;EA6SF;EA3SA;IACE,+BAAA;IACA,kCAAA;EA6SF;EA3SA;IACE,8BAAA;IACA,iCAAA;EA6SF;EA3SA;IACE,+BAAA;IACA,kCAAA;EA6SF;EA3SA;IACE,4BAAA;IACA,+BAAA;EA6SF;EA3SA;IACE,+BAAA;IACA,kCAAA;EA6SF;EA3SA;IACE,8BAAA;IACA,iCAAA;EA6SF;EA3SA;IACE,+BAAA;IACA,kCAAA;EA6SF;EA3SA;IACE,4BAAA;IACA,+BAAA;EA6SF;EA3SA;IACE,+BAAA;EA6SF;EA3SA;IACE,8BAAA;EA6SF;EA3SA;IACE,+BAAA;EA6SF;EA3SA;IACE,4BAAA;EA6SF;EA3SA;IACE,+BAAA;EA6SF;EA3SA;IACE,8BAAA;EA6SF;EA3SA;IACE,+BAAA;EA6SF;EA3SA;IACE,4BAAA;EA6SF;EA3SA;IACE,+BAAA;EA6SF;EA3SA;IACE,8BAAA;EA6SF;EA3SA;IACE,+BAAA;EA6SF;EA3SA;IACE,4BAAA;EA6SF;EA3SA;IACE,+BAAA;EA6SF;EA3SA;IACE,8BAAA;EA6SF;EA3SA;IACE,+BAAA;EA6SF;EA3SA;IACE,4BAAA;EA6SF;EA3SA;IACE,+BAAA;EA6SF;EA3SA;IACE,8BAAA;EA6SF;EA3SA;IACE,+BAAA;EA6SF;EA3SA;IACE,4BAAA;EA6SF;EA3SA;IACE,iCAAA;EA6SF;EA3SA;IACE,gCAAA;EA6SF;EA3SA;IACE,iCAAA;EA6SF;EA3SA;IACE,8BAAA;EA6SF;EA3SA;IACE,iCAAA;EA6SF;EA3SA;IACE,gCAAA;EA6SF;EA3SA;IACE,iCAAA;EA6SF;EA3SA;IACE,8BAAA;EA6SF;EA3SA;IACE,iCAAA;EA6SF;EA3SA;IACE,gCAAA;EA6SF;EA3SA;IACE,iCAAA;EA6SF;EA3SA;IACE,8BAAA;EA6SF;EA3SA;IACE,iCAAA;EA6SF;EA3SA;IACE,gCAAA;EA6SF;EA3SA;IACE,iCAAA;EA6SF;EA3SA;IACE,8BAAA;EA6SF;EA3SA;IACE,iCAAA;EA6SF;EA3SA;IACE,gCAAA;EA6SF;EA3SA;IACE,iCAAA;EA6SF;EA3SA;IACE,8BAAA;EA6SF;EA3SA;IACE,kCAAA;EA6SF;EA3SA;IACE,iCAAA;EA6SF;EA3SA;IACE,kCAAA;EA6SF;EA3SA;IACE,+BAAA;EA6SF;EA3SA;IACE,kCAAA;EA6SF;EA3SA;IACE,iCAAA;EA6SF;EA3SA;IACE,kCAAA;EA6SF;EA3SA;IACE,+BAAA;EA6SF;EA3SA;IACE,kCAAA;EA6SF;EA3SA;IACE,iCAAA;EA6SF;EA3SA;IACE,kCAAA;EA6SF;EA3SA;IACE,+BAAA;EA6SF;EA3SA;IACE,kCAAA;EA6SF;EA3SA;IACE,iCAAA;EA6SF;EA3SA;IACE,kCAAA;EA6SF;EA3SA;IACE,+BAAA;EA6SF;EA3SA;IACE,kCAAA;EA6SF;EA3SA;IACE,iCAAA;EA6SF;EA3SA;IACE,kCAAA;EA6SF;EA3SA;IACE,+BAAA;EA6SF;EA3SA;IACE,gCAAA;EA6SF;EA3SA;IACE,+BAAA;EA6SF;EA3SA;IACE,gCAAA;EA6SF;EA3SA;IACE,6BAAA;EA6SF;EA3SA;IACE,gCAAA;EA6SF;EA3SA;IACE,+BAAA;EA6SF;EA3SA;IACE,gCAAA;EA6SF;EA3SA;IACE,6BAAA;EA6SF;EA3SA;IACE,gCAAA;EA6SF;EA3SA;IACE,+BAAA;EA6SF;EA3SA;IACE,gCAAA;EA6SF;EA3SA;IACE,6BAAA;EA6SF;EA3SA;IACE,gCAAA;EA6SF;EA3SA;IACE,+BAAA;EA6SF;EA3SA;IACE,gCAAA;EA6SF;EA3SA;IACE,6BAAA;EA6SF;EA3SA;IACE,gCAAA;EA6SF;EA3SA;IACE,+BAAA;EA6SF;EA3SA;IACE,gCAAA;EA6SF;EA3SA;IACE,6BAAA;EA6SF;EA3SA;IACE,qBAAA;EA6SF;EA3SA;IACE,2BAAA;EA6SF;EA3SA;IACE,0BAAA;EA6SF;EA3SA;IACE,2BAAA;EA6SF;EA3SA;IACE,wBAAA;EA6SF;EA3SA;IACE,2BAAA;EA6SF;EA3SA;IACE,0BAAA;EA6SF;EA3SA;IACE,2BAAA;EA6SF;EA3SA;IACE,wBAAA;EA6SF;EA3SA;IACE,2BAAA;EA6SF;EA3SA;IACE,0BAAA;EA6SF;EA3SA;IACE,2BAAA;EA6SF;EA3SA;IACE,wBAAA;EA6SF;EA3SA;IACE,2BAAA;EA6SF;EA3SA;IACE,0BAAA;EA6SF;EA3SA;IACE,2BAAA;EA6SF;EA3SA;IACE,wBAAA;EA6SF;EA3SA;IACE,2BAAA;EA6SF;EA3SA;IACE,0BAAA;EA6SF;EA3SA;IACE,2BAAA;EA6SF;EA3SA;IACE,wBAAA;EA6SF;EA3SA;IACE,2BAAA;IACA,0BAAA;EA6SF;EA3SA;IACE,iCAAA;IACA,gCAAA;EA6SF;EA3SA;IACE,gCAAA;IACA,+BAAA;EA6SF;EA3SA;IACE,iCAAA;IACA,gCAAA;EA6SF;EA3SA;IACE,8BAAA;IACA,6BAAA;EA6SF;EA3SA;IACE,iCAAA;IACA,gCAAA;EA6SF;EA3SA;IACE,gCAAA;IACA,+BAAA;EA6SF;EA3SA;IACE,iCAAA;IACA,gCAAA;EA6SF;EA3SA;IACE,8BAAA;IACA,6BAAA;EA6SF;EA3SA;IACE,iCAAA;IACA,gCAAA;EA6SF;EA3SA;IACE,gCAAA;IACA,+BAAA;EA6SF;EA3SA;IACE,iCAAA;IACA,gCAAA;EA6SF;EA3SA;IACE,8BAAA;IACA,6BAAA;EA6SF;EA3SA;IACE,iCAAA;IACA,gCAAA;EA6SF;EA3SA;IACE,gCAAA;IACA,+BAAA;EA6SF;EA3SA;IACE,iCAAA;IACA,gCAAA;EA6SF;EA3SA;IACE,8BAAA;IACA,6BAAA;EA6SF;EA3SA;IACE,iCAAA;IACA,gCAAA;EA6SF;EA3SA;IACE,gCAAA;IACA,+BAAA;EA6SF;EA3SA;IACE,iCAAA;IACA,gCAAA;EA6SF;EA3SA;IACE,8BAAA;IACA,6BAAA;EA6SF;EA3SA;IACE,yBAAA;IACA,4BAAA;EA6SF;EA3SA;IACE,+BAAA;IACA,kCAAA;EA6SF;EA3SA;IACE,8BAAA;IACA,iCAAA;EA6SF;EA3SA;IACE,+BAAA;IACA,kCAAA;EA6SF;EA3SA;IACE,4BAAA;IACA,+BAAA;EA6SF;EA3SA;IACE,+BAAA;IACA,kCAAA;EA6SF;EA3SA;IACE,8BAAA;IACA,iCAAA;EA6SF;EA3SA;IACE,+BAAA;IACA,kCAAA;EA6SF;EA3SA;IACE,4BAAA;IACA,+BAAA;EA6SF;EA3SA;IACE,+BAAA;IACA,kCAAA;EA6SF;EA3SA;IACE,8BAAA;IACA,iCAAA;EA6SF;EA3SA;IACE,+BAAA;IACA,kCAAA;EA6SF;EA3SA;IACE,4BAAA;IACA,+BAAA;EA6SF;EA3SA;IACE,+BAAA;IACA,kCAAA;EA6SF;EA3SA;IACE,8BAAA;IACA,iCAAA;EA6SF;EA3SA;IACE,+BAAA;IACA,kCAAA;EA6SF;EA3SA;IACE,4BAAA;IACA,+BAAA;EA6SF;EA3SA;IACE,+BAAA;IACA,kCAAA;EA6SF;EA3SA;IACE,8BAAA;IACA,iCAAA;EA6SF;EA3SA;IACE,+BAAA;IACA,kCAAA;EA6SF;EA3SA;IACE,4BAAA;IACA,+BAAA;EA6SF;EA3SA;IACE,yBAAA;EA6SF;EA3SA;IACE,+BAAA;EA6SF;EA3SA;IACE,8BAAA;EA6SF;EA3SA;IACE,+BAAA;EA6SF;EA3SA;IACE,4BAAA;EA6SF;EA3SA;IACE,+BAAA;EA6SF;EA3SA;IACE,8BAAA;EA6SF;EA3SA;IACE,+BAAA;EA6SF;EA3SA;IACE,4BAAA;EA6SF;EA3SA;IACE,+BAAA;EA6SF;EA3SA;IACE,8BAAA;EA6SF;EA3SA;IACE,+BAAA;EA6SF;EA3SA;IACE,4BAAA;EA6SF;EA3SA;IACE,+BAAA;EA6SF;EA3SA;IACE,8BAAA;EA6SF;EA3SA;IACE,+BAAA;EA6SF;EA3SA;IACE,4BAAA;EA6SF;EA3SA;IACE,+BAAA;EA6SF;EA3SA;IACE,8BAAA;EA6SF;EA3SA;IACE,+BAAA;EA6SF;EA3SA;IACE,4BAAA;EA6SF;EA3SA;IACE,2BAAA;EA6SF;EA3SA;IACE,iCAAA;EA6SF;EA3SA;IACE,gCAAA;EA6SF;EA3SA;IACE,iCAAA;EA6SF;EA3SA;IACE,8BAAA;EA6SF;EA3SA;IACE,iCAAA;EA6SF;EA3SA;IACE,gCAAA;EA6SF;EA3SA;IACE,iCAAA;EA6SF;EA3SA;IACE,8BAAA;EA6SF;EA3SA;IACE,iCAAA;EA6SF;EA3SA;IACE,gCAAA;EA6SF;EA3SA;IACE,iCAAA;EA6SF;EA3SA;IACE,8BAAA;EA6SF;EA3SA;IACE,iCAAA;EA6SF;EA3SA;IACE,gCAAA;EA6SF;EA3SA;IACE,iCAAA;EA6SF;EA3SA;IACE,8BAAA;EA6SF;EA3SA;IACE,iCAAA;EA6SF;EA3SA;IACE,gCAAA;EA6SF;EA3SA;IACE,iCAAA;EA6SF;EA3SA;IACE,8BAAA;EA6SF;EA3SA;IACE,4BAAA;EA6SF;EA3SA;IACE,kCAAA;EA6SF;EA3SA;IACE,iCAAA;EA6SF;EA3SA;IACE,kCAAA;EA6SF;EA3SA;IACE,+BAAA;EA6SF;EA3SA;IACE,kCAAA;EA6SF;EA3SA;IACE,iCAAA;EA6SF;EA3SA;IACE,kCAAA;EA6SF;EA3SA;IACE,+BAAA;EA6SF;EA3SA;IACE,kCAAA;EA6SF;EA3SA;IACE,iCAAA;EA6SF;EA3SA;IACE,kCAAA;EA6SF;EA3SA;IACE,+BAAA;EA6SF;EA3SA;IACE,kCAAA;EA6SF;EA3SA;IACE,iCAAA;EA6SF;EA3SA;IACE,kCAAA;EA6SF;EA3SA;IACE,+BAAA;EA6SF;EA3SA;IACE,kCAAA;EA6SF;EA3SA;IACE,iCAAA;EA6SF;EA3SA;IACE,kCAAA;EA6SF;EA3SA;IACE,+BAAA;EA6SF;EA3SA;IACE,0BAAA;EA6SF;EA3SA;IACE,gCAAA;EA6SF;EA3SA;IACE,+BAAA;EA6SF;EA3SA;IACE,gCAAA;EA6SF;EA3SA;IACE,6BAAA;EA6SF;EA3SA;IACE,gCAAA;EA6SF;EA3SA;IACE,+BAAA;EA6SF;EA3SA;IACE,gCAAA;EA6SF;EA3SA;IACE,6BAAA;EA6SF;EA3SA;IACE,gCAAA;EA6SF;EA3SA;IACE,+BAAA;EA6SF;EA3SA;IACE,gCAAA;EA6SF;EA3SA;IACE,6BAAA;EA6SF;EA3SA;IACE,gCAAA;EA6SF;EA3SA;IACE,+BAAA;EA6SF;EA3SA;IACE,gCAAA;EA6SF;EA3SA;IACE,6BAAA;EA6SF;EA3SA;IACE,gCAAA;EA6SF;EA3SA;IACE,+BAAA;EA6SF;EA3SA;IACE,gCAAA;EA6SF;EA3SA;IACE,6BAAA;EA6SF;EA3SA;IACE,iBAAA;EA6SF;EA3SA;IACE,uBAAA;EA6SF;EA3SA;IACE,sBAAA;EA6SF;EA3SA;IACE,uBAAA;EA6SF;EA3SA;IACE,oBAAA;EA6SF;EA3SA;IACE,uBAAA;EA6SF;EA3SA;IACE,sBAAA;EA6SF;EA3SA;IACE,uBAAA;EA6SF;EA3SA;IACE,oBAAA;EA6SF;EA3SA;IACE,uBAAA;EA6SF;EA3SA;IACE,sBAAA;EA6SF;EA3SA;IACE,uBAAA;EA6SF;EA3SA;IACE,oBAAA;EA6SF;EA3SA;IACE,uBAAA;EA6SF;EA3SA;IACE,sBAAA;EA6SF;EA3SA;IACE,uBAAA;EA6SF;EA3SA;IACE,oBAAA;EA6SF;EA3SA;IACE,uBAAA;EA6SF;EA3SA;IACE,sBAAA;EA6SF;EA3SA;IACE,uBAAA;EA6SF;EA3SA;IACE,oBAAA;EA6SF;EA3SA;IACE,qBAAA;EA6SF;EA3SA;IACE,2BAAA;EA6SF;EA3SA;IACE,0BAAA;EA6SF;EA3SA;IACE,2BAAA;EA6SF;EA3SA;IACE,wBAAA;EA6SF;EA3SA;IACE,2BAAA;EA6SF;EA3SA;IACE,0BAAA;EA6SF;EA3SA;IACE,2BAAA;EA6SF;EA3SA;IACE,wBAAA;EA6SF;EA3SA;IACE,2BAAA;EA6SF;EA3SA;IACE,0BAAA;EA6SF;EA3SA;IACE,2BAAA;EA6SF;EA3SA;IACE,wBAAA;EA6SF;EA3SA;IACE,2BAAA;EA6SF;EA3SA;IACE,0BAAA;EA6SF;EA3SA;IACE,2BAAA;EA6SF;EA3SA;IACE,wBAAA;EA6SF;EA3SA;IACE,2BAAA;EA6SF;EA3SA;IACE,0BAAA;EA6SF;EA3SA;IACE,2BAAA;EA6SF;EA3SA;IACE,wBAAA;EA6SF;EA3SA;IACE,wBAAA;EA6SF;EA3SA;IACE,8BAAA;EA6SF;EA3SA;IACE,6BAAA;EA6SF;EA3SA;IACE,8BAAA;EA6SF;EA3SA;IACE,2BAAA;EA6SF;EA3SA;IACE,8BAAA;EA6SF;EA3SA;IACE,6BAAA;EA6SF;EA3SA;IACE,8BAAA;EA6SF;EA3SA;IACE,2BAAA;EA6SF;EA3SA;IACE,8BAAA;EA6SF;EA3SA;IACE,6BAAA;EA6SF;EA3SA;IACE,8BAAA;EA6SF;EA3SA;IACE,2BAAA;EA6SF;EA3SA;IACE,8BAAA;EA6SF;EA3SA;IACE,6BAAA;EA6SF;EA3SA;IACE,8BAAA;EA6SF;EA3SA;IACE,2BAAA;EA6SF;EA3SA;IACE,8BAAA;EA6SF;EA3SA;IACE,6BAAA;EA6SF;EA3SA;IACE,8BAAA;EA6SF;EA3SA;IACE,2BAAA;EA6SF;EA3SA;IACE,0CAAA;EA6SF;EA3SA;IACE,4CAAA;EA6SF;EA3SA;IACE,4CAAA;EA6SF;EA3SA;IACE,6BAAA;EA6SF;EA3SA;IACE,6BAAA;EA6SF;EA3SA;IACE,8BAAA;EA6SF;EA3SA;IACE,6BAAA;EA6SF;EA3SA;IACE,6BAAA;EA6SF;EA3SA;IACE,6BAAA;EA6SF;EA3SA;IACE,4BAAA;EA6SF;EA3SA;IACE,0BAAA;EA6SF;EA3SA;IACE,0BAAA;EA6SF;EA3SA;IACE,4CAAA;EA6SF;EA3SA;IACE,2CAAA;EA6SF;EA3SA;IACE,4CAAA;EA6SF;EA3SA;IACE,0CAAA;EA6SF;EA3SA;IACE,4CAAA;EA6SF;EA3SA;IACE,2CAAA;EA6SF;EA3SA;IACE,4CAAA;EA6SF;EA3SA;IACE,wCAAA;EA6SF;EA3SA;IACE,4CAAA;EA6SF;EA3SA;IACE,2CAAA;EA6SF;EA3SA;IACE,4CAAA;EA6SF;EA3SA;IACE,0CAAA;EA6SF;EA3SA;IACE,4CAAA;EA6SF;EA3SA;IACE,2CAAA;EA6SF;EA3SA;IACE,4CAAA;EA6SF;EA3SA;IACE,0CAAA;EA6SF;EA3SA;IACE,4CAAA;EA6SF;EA3SA;IACE,yCAAA;EA6SF;EA3SA;IACE,4CAAA;EA6SF;EA3SA;IACE,0CAAA;EA6SF;EA3SA;IACE,4CAAA;EA6SF;EA3SA;IACE,2CAAA;EA6SF;EA3SA;IACE,4CAAA;EA6SF;EA3SA;IACE,0CAAA;EA6SF;EA3SA;IACE,2BAAA;EA6SF;EA3SA;IACE,4BAAA;EA6SF;EA3SA;IACE,6BAAA;EA6SF;EA3SA;IACE,2BAAA;EA6SF;EA3SA;IACE,yBAAA;EA6SF;EA3SA;IACE,yBAAA;EA6SF;EA3SA;IACE,yBAAA;EA6SF;EA3SA;IACE,0BAAA;EA6SF;EA3SA;IACE,0BAAA;EA6SF;EA3SA;IACE,yBAAA;EA6SF;EA3SA;IACE,yBAAA;EA6SF;EA3SA;IACE,yBAAA;EA6SF;EA3SA;IACE,yBAAA;EA6SF;EA3SA;IACE,yBAAA;EA6SF;EA3SA;IACE,yBAAA;EA6SF;EA3SA;IACE,yBAAA;EA6SF;EA3SA;IACE,yBAAA;EA6SF;EA3SA;IACE,yBAAA;EA6SF;EA3SA;IACE,0BAAA;EA6SF;EA3SA;IACE,0BAAA;EA6SF;EA3SA;IACE,0BAAA;EA6SF;EA3SA;IACE,0BAAA;EA6SF;EA3SA;IACE,0BAAA;EA6SF;EA3SA;IACE,0BAAA;EA6SF;EA3SA;IACE,0BAAA;EA6SF;EA3SA;IACE,0BAAA;EA6SF;EA3SA;IACE,0BAAA;EA6SF;EA3SA;IACE,0BAAA;EA6SF;EA3SA;IACE,0BAAA;EA6SF;EA3SA;IACE,0BAAA;EA6SF;EA3SA;IACE,0BAAA;EA6SF;EA3SA;IACE,0BAAA;EA6SF;EA3SA;IACE,0BAAA;EA6SF;EA3SA;IACE,0BAAA;EA6SF;EA3SA;IACE,0BAAA;EA6SF;EA3SA;IACE,0BAAA;EA6SF;EA3SA;IACE,2BAAA;EA6SF;EA3SA;IACE,2BAAA;EA6SF;EA3SA;IACE,2BAAA;EA6SF;EA3SA;IACE,2BAAA;EA6SF;EA3SA;IACE,2BAAA;EA6SF;EA3SA;IACE,2BAAA;EA6SF;EA3SA;IACE,2BAAA;EA6SF;EA3SA;IACE,2BAAA;EA6SF;EA3SA;IACE,2BAAA;EA6SF;EA3SA;IACE,2BAAA;EA6SF;EA3SA;IACE,2BAAA;EA6SF;EA3SA;IACE,2BAAA;EA6SF;EA3SA;IACE,2BAAA;EA6SF;EA3SA;IACE,2BAAA;EA6SF;EA3SA;IACE,2BAAA;EA6SF;EA3SA;IACE,2BAAA;EA6SF;EA3SA;IACE,2BAAA;EA6SF;EA3SA;IACE,2BAAA;EA6SF;EA3SA;IACE,2BAAA;EA6SF;EA3SA;IACE,2BAAA;EA6SF;EA3SA;IACE,2BAAA;EA6SF;EA3SA;IACE,2BAAA;EA6SF;EA3SA;IACE,2BAAA;EA6SF;EA3SA;IACE,2BAAA;EA6SF;EA3SA;IACE,2BAAA;EA6SF;EA3SA;IACE,2BAAA;EA6SF;EA3SA;IACE,4BAAA;EA6SF;EA3SA;IACE,4BAAA;EA6SF;EA3SA;IACE,0BAAA;EA6SF;EA3SA;IACE,0BAAA;EA6SF;EA3SA;IACE,0BAAA;EA6SF;EA3SA;IACE,2BAAA;EA6SF;EA3SA;IACE,2BAAA;EA6SF;EA3SA;IACE,0BAAA;EA6SF;EA3SA;IACE,0BAAA;EA6SF;EA3SA;IACE,0BAAA;EA6SF;EA3SA;IACE,0BAAA;EA6SF;EA3SA;IACE,0BAAA;EA6SF;EA3SA;IACE,0BAAA;EA6SF;EA3SA;IACE,0BAAA;EA6SF;EA3SA;IACE,0BAAA;EA6SF;EA3SA;IACE,0BAAA;EA6SF;EA3SA;IACE,2BAAA;EA6SF;EA3SA;IACE,2BAAA;EA6SF;EA3SA;IACE,2BAAA;EA6SF;EA3SA;IACE,2BAAA;EA6SF;EA3SA;IACE,2BAAA;EA6SF;EA3SA;IACE,2BAAA;EA6SF;EA3SA;IACE,2BAAA;EA6SF;EA3SA;IACE,2BAAA;EA6SF;EA3SA;IACE,2BAAA;EA6SF;EA3SA;IACE,2BAAA;EA6SF;EA3SA;IACE,2BAAA;EA6SF;EA3SA;IACE,2BAAA;EA6SF;EA3SA;IACE,2BAAA;EA6SF;EA3SA;IACE,2BAAA;EA6SF;EA3SA;IACE,2BAAA;EA6SF;EA3SA;IACE,2BAAA;EA6SF;EA3SA;IACE,2BAAA;EA6SF;EA3SA;IACE,2BAAA;EA6SF;EA3SA;IACE,4BAAA;EA6SF;EA3SA;IACE,4BAAA;EA6SF;EA3SA;IACE,4BAAA;EA6SF;EA3SA;IACE,4BAAA;EA6SF;EA3SA;IACE,4BAAA;EA6SF;EA3SA;IACE,4BAAA;EA6SF;EA3SA;IACE,4BAAA;EA6SF;EA3SA;IACE,4BAAA;EA6SF;EA3SA;IACE,4BAAA;EA6SF;EA3SA;IACE,4BAAA;EA6SF;EA3SA;IACE,4BAAA;EA6SF;EA3SA;IACE,4BAAA;EA6SF;EA3SA;IACE,4BAAA;EA6SF;EA3SA;IACE,4BAAA;EA6SF;EA3SA;IACE,4BAAA;EA6SF;EA3SA;IACE,4BAAA;EA6SF;EA3SA;IACE,4BAAA;EA6SF;EA3SA;IACE,4BAAA;EA6SF;EA3SA;IACE,4BAAA;EA6SF;EA3SA;IACE,4BAAA;EA6SF;EA3SA;IACE,4BAAA;EA6SF;EA3SA;IACE,4BAAA;EA6SF;EA3SA;IACE,4BAAA;EA6SF;EA3SA;IACE,4BAAA;EA6SF;EA3SA;IACE,4BAAA;EA6SF;EA3SA;IACE,4BAAA;EA6SF;EA3SA;IACE,6BAAA;EA6SF;AACF;AA3SA;EACE;IACE,sBAAA;EA6SF;EA3SA;IACE,uBAAA;EA6SF;EA3SA;IACE,sBAAA;EA6SF;EA3SA;IACE,8BAAA;EA6SF;EA3SA;IACE,4BAAA;EA6SF;EA3SA;IACE,2BAAA;EA6SF;EA3SA;IACE,iCAAA;EA6SF;EA3SA;IACE,2BAAA;EA6SF;EA3SA;IACE,yBAAA;EA6SF;EA3SA;IACE,2BAAA;EA6SF;EA3SA;IACE,4BAAA;EA6SF;EA3SA;IACE,2BAAA;EA6SF;EA3SA;IACE,0BAAA;EA6SF;EA3SA;IACE,gCAAA;EA6SF;EA3SA;IACE,yBAAA;EA6SF;EA3SA;IACE,wBAAA;EA6SF;EA3SA;IACE,yBAAA;EA6SF;EA3SA;IACE,6BAAA;EA6SF;EA3SA;IACE,8BAAA;EA6SF;EA3SA;IACE,wBAAA;EA6SF;EA3SA;IACE,+BAAA;EA6SF;EA3SA;IACE,wBAAA;EA6SF;EA3SA;IACE,2BAAA;EA6SF;EA3SA;IACE,6BAAA;EA6SF;EA3SA;IACE,6BAAA;EA6SF;EA3SA;IACE,0BAAA;EA6SF;EA3SA;IACE,2BAAA;EA6SF;EA3SA;IACE,uBAAA;EA6SF;EA3SA;IACE,qBAAA;EA6SF;EA3SA;IACE,qBAAA;EA6SF;EA3SA;IACE,qBAAA;EA6SF;EA3SA;IACE,sBAAA;EA6SF;EA3SA;IACE,sBAAA;EA6SF;EA3SA;IACE,qBAAA;EA6SF;EA3SA;IACE,qBAAA;EA6SF;EA3SA;IACE,qBAAA;EA6SF;EA3SA;IACE,qBAAA;EA6SF;EA3SA;IACE,qBAAA;EA6SF;EA3SA;IACE,qBAAA;EA6SF;EA3SA;IACE,qBAAA;EA6SF;EA3SA;IACE,qBAAA;EA6SF;EA3SA;IACE,qBAAA;EA6SF;EA3SA;IACE,sBAAA;EA6SF;EA3SA;IACE,sBAAA;EA6SF;EA3SA;IACE,sBAAA;EA6SF;EA3SA;IACE,sBAAA;EA6SF;EA3SA;IACE,sBAAA;EA6SF;EA3SA;IACE,sBAAA;EA6SF;EA3SA;IACE,sBAAA;EA6SF;EA3SA;IACE,sBAAA;EA6SF;EA3SA;IACE,sBAAA;EA6SF;EA3SA;IACE,sBAAA;EA6SF;EA3SA;IACE,sBAAA;EA6SF;EA3SA;IACE,sBAAA;EA6SF;EA3SA;IACE,sBAAA;EA6SF;EA3SA;IACE,sBAAA;EA6SF;EA3SA;IACE,sBAAA;EA6SF;EA3SA;IACE,sBAAA;EA6SF;EA3SA;IACE,sBAAA;EA6SF;EA3SA;IACE,sBAAA;EA6SF;EA3SA;IACE,uBAAA;EA6SF;EA3SA;IACE,uBAAA;EA6SF;EA3SA;IACE,uBAAA;EA6SF;EA3SA;IACE,uBAAA;EA6SF;EA3SA;IACE,uBAAA;EA6SF;EA3SA;IACE,uBAAA;EA6SF;EA3SA;IACE,uBAAA;EA6SF;EA3SA;IACE,uBAAA;EA6SF;EA3SA;IACE,uBAAA;EA6SF;EA3SA;IACE,uBAAA;EA6SF;EA3SA;IACE,uBAAA;EA6SF;EA3SA;IACE,uBAAA;EA6SF;EA3SA;IACE,uBAAA;EA6SF;EA3SA;IACE,uBAAA;EA6SF;EA3SA;IACE,uBAAA;EA6SF;EA3SA;IACE,uBAAA;EA6SF;EA3SA;IACE,uBAAA;EA6SF;EA3SA;IACE,uBAAA;EA6SF;EA3SA;IACE,uBAAA;EA6SF;EA3SA;IACE,uBAAA;EA6SF;EA3SA;IACE,uBAAA;EA6SF;EA3SA;IACE,uBAAA;EA6SF;EA3SA;IACE,uBAAA;EA6SF;EA3SA;IACE,uBAAA;EA6SF;EA3SA;IACE,uBAAA;EA6SF;EA3SA;IACE,uBAAA;EA6SF;EA3SA;IACE,wBAAA;EA6SF;EA3SA;IACE,2BAAA;EA6SF;EA3SA;IACE,yBAAA;EA6SF;EA3SA;IACE,yBAAA;EA6SF;EA3SA;IACE,yBAAA;EA6SF;EA3SA;IACE,0BAAA;EA6SF;EA3SA;IACE,0BAAA;EA6SF;EA3SA;IACE,yBAAA;EA6SF;EA3SA;IACE,yBAAA;EA6SF;EA3SA;IACE,yBAAA;EA6SF;EA3SA;IACE,yBAAA;EA6SF;EA3SA;IACE,yBAAA;EA6SF;EA3SA;IACE,yBAAA;EA6SF;EA3SA;IACE,yBAAA;EA6SF;EA3SA;IACE,yBAAA;EA6SF;EA3SA;IACE,yBAAA;EA6SF;EA3SA;IACE,0BAAA;EA6SF;EA3SA;IACE,0BAAA;EA6SF;EA3SA;IACE,0BAAA;EA6SF;EA3SA;IACE,0BAAA;EA6SF;EA3SA;IACE,0BAAA;EA6SF;EA3SA;IACE,0BAAA;EA6SF;EA3SA;IACE,0BAAA;EA6SF;EA3SA;IACE,0BAAA;EA6SF;EA3SA;IACE,0BAAA;EA6SF;EA3SA;IACE,0BAAA;EA6SF;EA3SA;IACE,0BAAA;EA6SF;EA3SA;IACE,0BAAA;EA6SF;EA3SA;IACE,0BAAA;EA6SF;EA3SA;IACE,0BAAA;EA6SF;EA3SA;IACE,0BAAA;EA6SF;EA3SA;IACE,0BAAA;EA6SF;EA3SA;IACE,0BAAA;EA6SF;EA3SA;IACE,0BAAA;EA6SF;EA3SA;IACE,2BAAA;EA6SF;EA3SA;IACE,2BAAA;EA6SF;EA3SA;IACE,2BAAA;EA6SF;EA3SA;IACE,2BAAA;EA6SF;EA3SA;IACE,2BAAA;EA6SF;EA3SA;IACE,2BAAA;EA6SF;EA3SA;IACE,2BAAA;EA6SF;EA3SA;IACE,2BAAA;EA6SF;EA3SA;IACE,2BAAA;EA6SF;EA3SA;IACE,2BAAA;EA6SF;EA3SA;IACE,2BAAA;EA6SF;EA3SA;IACE,2BAAA;EA6SF;EA3SA;IACE,2BAAA;EA6SF;EA3SA;IACE,2BAAA;EA6SF;EA3SA;IACE,2BAAA;EA6SF;EA3SA;IACE,2BAAA;EA6SF;EA3SA;IACE,2BAAA;EA6SF;EA3SA;IACE,2BAAA;EA6SF;EA3SA;IACE,2BAAA;EA6SF;EA3SA;IACE,2BAAA;EA6SF;EA3SA;IACE,2BAAA;EA6SF;EA3SA;IACE,2BAAA;EA6SF;EA3SA;IACE,2BAAA;EA6SF;EA3SA;IACE,2BAAA;EA6SF;EA3SA;IACE,2BAAA;EA6SF;EA3SA;IACE,2BAAA;EA6SF;EA3SA;IACE,4BAAA;EA6SF;EA3SA;IACE,wBAAA;EA6SF;EA3SA;IACE,sBAAA;EA6SF;EA3SA;IACE,sBAAA;EA6SF;EA3SA;IACE,sBAAA;EA6SF;EA3SA;IACE,uBAAA;EA6SF;EA3SA;IACE,uBAAA;EA6SF;EA3SA;IACE,sBAAA;EA6SF;EA3SA;IACE,sBAAA;EA6SF;EA3SA;IACE,sBAAA;EA6SF;EA3SA;IACE,sBAAA;EA6SF;EA3SA;IACE,sBAAA;EA6SF;EA3SA;IACE,sBAAA;EA6SF;EA3SA;IACE,sBAAA;EA6SF;EA3SA;IACE,sBAAA;EA6SF;EA3SA;IACE,sBAAA;EA6SF;EA3SA;IACE,uBAAA;EA6SF;EA3SA;IACE,uBAAA;EA6SF;EA3SA;IACE,uBAAA;EA6SF;EA3SA;IACE,uBAAA;EA6SF;EA3SA;IACE,uBAAA;EA6SF;EA3SA;IACE,uBAAA;EA6SF;EA3SA;IACE,uBAAA;EA6SF;EA3SA;IACE,uBAAA;EA6SF;EA3SA;IACE,uBAAA;EA6SF;EA3SA;IACE,uBAAA;EA6SF;EA3SA;IACE,uBAAA;EA6SF;EA3SA;IACE,uBAAA;EA6SF;EA3SA;IACE,uBAAA;EA6SF;EA3SA;IACE,uBAAA;EA6SF;EA3SA;IACE,uBAAA;EA6SF;EA3SA;IACE,uBAAA;EA6SF;EA3SA;IACE,uBAAA;EA6SF;EA3SA;IACE,uBAAA;EA6SF;EA3SA;IACE,wBAAA;EA6SF;EA3SA;IACE,wBAAA;EA6SF;EA3SA;IACE,wBAAA;EA6SF;EA3SA;IACE,wBAAA;EA6SF;EA3SA;IACE,wBAAA;EA6SF;EA3SA;IACE,wBAAA;EA6SF;EA3SA;IACE,wBAAA;EA6SF;EA3SA;IACE,wBAAA;EA6SF;EA3SA;IACE,wBAAA;EA6SF;EA3SA;IACE,wBAAA;EA6SF;EA3SA;IACE,wBAAA;EA6SF;EA3SA;IACE,wBAAA;EA6SF;EA3SA;IACE,wBAAA;EA6SF;EA3SA;IACE,wBAAA;EA6SF;EA3SA;IACE,wBAAA;EA6SF;EA3SA;IACE,wBAAA;EA6SF;EA3SA;IACE,wBAAA;EA6SF;EA3SA;IACE,wBAAA;EA6SF;EA3SA;IACE,wBAAA;EA6SF;EA3SA;IACE,wBAAA;EA6SF;EA3SA;IACE,wBAAA;EA6SF;EA3SA;IACE,wBAAA;EA6SF;EA3SA;IACE,wBAAA;EA6SF;EA3SA;IACE,wBAAA;EA6SF;EA3SA;IACE,wBAAA;EA6SF;EA3SA;IACE,wBAAA;EA6SF;EA3SA;IACE,yBAAA;EA6SF;EA3SA;IACE,4BAAA;EA6SF;EA3SA;IACE,0BAAA;EA6SF;EA3SA;IACE,0BAAA;EA6SF;EA3SA;IACE,0BAAA;EA6SF;EA3SA;IACE,2BAAA;EA6SF;EA3SA;IACE,2BAAA;EA6SF;EA3SA;IACE,0BAAA;EA6SF;EA3SA;IACE,0BAAA;EA6SF;EA3SA;IACE,0BAAA;EA6SF;EA3SA;IACE,0BAAA;EA6SF;EA3SA;IACE,0BAAA;EA6SF;EA3SA;IACE,0BAAA;EA6SF;EA3SA;IACE,0BAAA;EA6SF;EA3SA;IACE,0BAAA;EA6SF;EA3SA;IACE,0BAAA;EA6SF;EA3SA;IACE,2BAAA;EA6SF;EA3SA;IACE,2BAAA;EA6SF;EA3SA;IACE,2BAAA;EA6SF;EA3SA;IACE,2BAAA;EA6SF;EA3SA;IACE,2BAAA;EA6SF;EA3SA;IACE,2BAAA;EA6SF;EA3SA;IACE,2BAAA;EA6SF;EA3SA;IACE,2BAAA;EA6SF;EA3SA;IACE,2BAAA;EA6SF;EA3SA;IACE,2BAAA;EA6SF;EA3SA;IACE,2BAAA;EA6SF;EA3SA;IACE,2BAAA;EA6SF;EA3SA;IACE,2BAAA;EA6SF;EA3SA;IACE,2BAAA;EA6SF;EA3SA;IACE,2BAAA;EA6SF;EA3SA;IACE,2BAAA;EA6SF;EA3SA;IACE,2BAAA;EA6SF;EA3SA;IACE,2BAAA;EA6SF;EA3SA;IACE,4BAAA;EA6SF;EA3SA;IACE,4BAAA;EA6SF;EA3SA;IACE,4BAAA;EA6SF;EA3SA;IACE,4BAAA;EA6SF;EA3SA;IACE,4BAAA;EA6SF;EA3SA;IACE,4BAAA;EA6SF;EA3SA;IACE,4BAAA;EA6SF;EA3SA;IACE,4BAAA;EA6SF;EA3SA;IACE,4BAAA;EA6SF;EA3SA;IACE,4BAAA;EA6SF;EA3SA;IACE,4BAAA;EA6SF;EA3SA;IACE,4BAAA;EA6SF;EA3SA;IACE,4BAAA;EA6SF;EA3SA;IACE,4BAAA;EA6SF;EA3SA;IACE,4BAAA;EA6SF;EA3SA;IACE,4BAAA;EA6SF;EA3SA;IACE,4BAAA;EA6SF;EA3SA;IACE,4BAAA;EA6SF;EA3SA;IACE,4BAAA;EA6SF;EA3SA;IACE,4BAAA;EA6SF;EA3SA;IACE,4BAAA;EA6SF;EA3SA;IACE,4BAAA;EA6SF;EA3SA;IACE,4BAAA;EA6SF;EA3SA;IACE,4BAAA;EA6SF;EA3SA;IACE,4BAAA;EA6SF;EA3SA;IACE,4BAAA;EA6SF;EA3SA;IACE,6BAAA;EA6SF;EA3SA;IACE,yBAAA;EA6SF;EA3SA;IACE,8BAAA;EA6SF;EA3SA;IACE,iCAAA;EA6SF;EA3SA;IACE,sCAAA;EA6SF;EA3SA;IACE,yCAAA;EA6SF;EA3SA;IACE,uBAAA;EA6SF;EA3SA;IACE,uBAAA;EA6SF;EA3SA;IACE,yBAAA;EA6SF;EA3SA;IACE,yBAAA;EA6SF;EA3SA;IACE,0BAAA;EA6SF;EA3SA;IACE,4BAAA;EA6SF;EA3SA;IACE,kCAAA;EA6SF;EA3SA;IACE,sCAAA;EA6SF;EA3SA;IACE,oCAAA;EA6SF;EA3SA;IACE,kCAAA;EA6SF;EA3SA;IACE,yCAAA;EA6SF;EA3SA;IACE,wCAAA;EA6SF;EA3SA;IACE,wCAAA;EA6SF;EA3SA;IACE,kCAAA;EA6SF;EA3SA;IACE,gCAAA;EA6SF;EA3SA;IACE,8BAAA;EA6SF;EA3SA;IACE,gCAAA;EA6SF;EA3SA;IACE,+BAAA;EA6SF;EA3SA;IACE,oCAAA;EA6SF;EA3SA;IACE,kCAAA;EA6SF;EA3SA;IACE,gCAAA;EA6SF;EA3SA;IACE,uCAAA;EA6SF;EA3SA;IACE,sCAAA;EA6SF;EA3SA;IACE,iCAAA;EA6SF;EA3SA;IACE,2BAAA;EA6SF;EA3SA;IACE,iCAAA;EA6SF;EA3SA;IACE,+BAAA;EA6SF;EA3SA;IACE,6BAAA;EA6SF;EA3SA;IACE,+BAAA;EA6SF;EA3SA;IACE,8BAAA;EA6SF;EA3SA;IACE,oBAAA;EA6SF;EA3SA;IACE,mBAAA;EA6SF;EA3SA;IACE,mBAAA;EA6SF;EA3SA;IACE,mBAAA;EA6SF;EA3SA;IACE,mBAAA;EA6SF;EA3SA;IACE,mBAAA;EA6SF;EA3SA;IACE,mBAAA;EA6SF;EA3SA;IACE,mBAAA;EA6SF;EA3SA;IACE,oBAAA;EA6SF;EA3SA;IACE,0BAAA;EA6SF;EA3SA;IACE,yBAAA;EA6SF;EA3SA;IACE,0BAAA;EA6SF;EA3SA;IACE,uBAAA;EA6SF;EA3SA;IACE,0BAAA;EA6SF;EA3SA;IACE,yBAAA;EA6SF;EA3SA;IACE,0BAAA;EA6SF;EA3SA;IACE,uBAAA;EA6SF;EA3SA;IACE,0BAAA;EA6SF;EA3SA;IACE,yBAAA;EA6SF;EA3SA;IACE,0BAAA;EA6SF;EA3SA;IACE,uBAAA;EA6SF;EA3SA;IACE,0BAAA;EA6SF;EA3SA;IACE,yBAAA;EA6SF;EA3SA;IACE,0BAAA;EA6SF;EA3SA;IACE,uBAAA;EA6SF;EA3SA;IACE,0BAAA;EA6SF;EA3SA;IACE,yBAAA;EA6SF;EA3SA;IACE,0BAAA;EA6SF;EA3SA;IACE,uBAAA;EA6SF;EA3SA;IACE,uBAAA;EA6SF;EA3SA;IACE,0BAAA;IACA,yBAAA;EA6SF;EA3SA;IACE,gCAAA;IACA,+BAAA;EA6SF;EA3SA;IACE,+BAAA;IACA,8BAAA;EA6SF;EA3SA;IACE,gCAAA;IACA,+BAAA;EA6SF;EA3SA;IACE,6BAAA;IACA,4BAAA;EA6SF;EA3SA;IACE,gCAAA;IACA,+BAAA;EA6SF;EA3SA;IACE,+BAAA;IACA,8BAAA;EA6SF;EA3SA;IACE,gCAAA;IACA,+BAAA;EA6SF;EA3SA;IACE,6BAAA;IACA,4BAAA;EA6SF;EA3SA;IACE,gCAAA;IACA,+BAAA;EA6SF;EA3SA;IACE,+BAAA;IACA,8BAAA;EA6SF;EA3SA;IACE,gCAAA;IACA,+BAAA;EA6SF;EA3SA;IACE,6BAAA;IACA,4BAAA;EA6SF;EA3SA;IACE,gCAAA;IACA,+BAAA;EA6SF;EA3SA;IACE,+BAAA;IACA,8BAAA;EA6SF;EA3SA;IACE,gCAAA;IACA,+BAAA;EA6SF;EA3SA;IACE,6BAAA;IACA,4BAAA;EA6SF;EA3SA;IACE,gCAAA;IACA,+BAAA;EA6SF;EA3SA;IACE,+BAAA;IACA,8BAAA;EA6SF;EA3SA;IACE,gCAAA;IACA,+BAAA;EA6SF;EA3SA;IACE,6BAAA;IACA,4BAAA;EA6SF;EA3SA;IACE,6BAAA;IACA,4BAAA;EA6SF;EA3SA;IACE,wBAAA;IACA,2BAAA;EA6SF;EA3SA;IACE,8BAAA;IACA,iCAAA;EA6SF;EA3SA;IACE,6BAAA;IACA,gCAAA;EA6SF;EA3SA;IACE,8BAAA;IACA,iCAAA;EA6SF;EA3SA;IACE,2BAAA;IACA,8BAAA;EA6SF;EA3SA;IACE,8BAAA;IACA,iCAAA;EA6SF;EA3SA;IACE,6BAAA;IACA,gCAAA;EA6SF;EA3SA;IACE,8BAAA;IACA,iCAAA;EA6SF;EA3SA;IACE,2BAAA;IACA,8BAAA;EA6SF;EA3SA;IACE,8BAAA;IACA,iCAAA;EA6SF;EA3SA;IACE,6BAAA;IACA,gCAAA;EA6SF;EA3SA;IACE,8BAAA;IACA,iCAAA;EA6SF;EA3SA;IACE,2BAAA;IACA,8BAAA;EA6SF;EA3SA;IACE,8BAAA;IACA,iCAAA;EA6SF;EA3SA;IACE,6BAAA;IACA,gCAAA;EA6SF;EA3SA;IACE,8BAAA;IACA,iCAAA;EA6SF;EA3SA;IACE,2BAAA;IACA,8BAAA;EA6SF;EA3SA;IACE,8BAAA;IACA,iCAAA;EA6SF;EA3SA;IACE,6BAAA;IACA,gCAAA;EA6SF;EA3SA;IACE,8BAAA;IACA,iCAAA;EA6SF;EA3SA;IACE,2BAAA;IACA,8BAAA;EA6SF;EA3SA;IACE,2BAAA;IACA,8BAAA;EA6SF;EA3SA;IACE,wBAAA;EA6SF;EA3SA;IACE,8BAAA;EA6SF;EA3SA;IACE,6BAAA;EA6SF;EA3SA;IACE,8BAAA;EA6SF;EA3SA;IACE,2BAAA;EA6SF;EA3SA;IACE,8BAAA;EA6SF;EA3SA;IACE,6BAAA;EA6SF;EA3SA;IACE,8BAAA;EA6SF;EA3SA;IACE,2BAAA;EA6SF;EA3SA;IACE,8BAAA;EA6SF;EA3SA;IACE,6BAAA;EA6SF;EA3SA;IACE,8BAAA;EA6SF;EA3SA;IACE,2BAAA;EA6SF;EA3SA;IACE,8BAAA;EA6SF;EA3SA;IACE,6BAAA;EA6SF;EA3SA;IACE,8BAAA;EA6SF;EA3SA;IACE,2BAAA;EA6SF;EA3SA;IACE,8BAAA;EA6SF;EA3SA;IACE,6BAAA;EA6SF;EA3SA;IACE,8BAAA;EA6SF;EA3SA;IACE,2BAAA;EA6SF;EA3SA;IACE,2BAAA;EA6SF;EA3SA;IACE,0BAAA;EA6SF;EA3SA;IACE,gCAAA;EA6SF;EA3SA;IACE,+BAAA;EA6SF;EA3SA;IACE,gCAAA;EA6SF;EA3SA;IACE,6BAAA;EA6SF;EA3SA;IACE,gCAAA;EA6SF;EA3SA;IACE,+BAAA;EA6SF;EA3SA;IACE,gCAAA;EA6SF;EA3SA;IACE,6BAAA;EA6SF;EA3SA;IACE,gCAAA;EA6SF;EA3SA;IACE,+BAAA;EA6SF;EA3SA;IACE,gCAAA;EA6SF;EA3SA;IACE,6BAAA;EA6SF;EA3SA;IACE,gCAAA;EA6SF;EA3SA;IACE,+BAAA;EA6SF;EA3SA;IACE,gCAAA;EA6SF;EA3SA;IACE,6BAAA;EA6SF;EA3SA;IACE,gCAAA;EA6SF;EA3SA;IACE,+BAAA;EA6SF;EA3SA;IACE,gCAAA;EA6SF;EA3SA;IACE,6BAAA;EA6SF;EA3SA;IACE,6BAAA;EA6SF;EA3SA;IACE,2BAAA;EA6SF;EA3SA;IACE,iCAAA;EA6SF;EA3SA;IACE,gCAAA;EA6SF;EA3SA;IACE,iCAAA;EA6SF;EA3SA;IACE,8BAAA;EA6SF;EA3SA;IACE,iCAAA;EA6SF;EA3SA;IACE,gCAAA;EA6SF;EA3SA;IACE,iCAAA;EA6SF;EA3SA;IACE,8BAAA;EA6SF;EA3SA;IACE,iCAAA;EA6SF;EA3SA;IACE,gCAAA;EA6SF;EA3SA;IACE,iCAAA;EA6SF;EA3SA;IACE,8BAAA;EA6SF;EA3SA;IACE,iCAAA;EA6SF;EA3SA;IACE,gCAAA;EA6SF;EA3SA;IACE,iCAAA;EA6SF;EA3SA;IACE,8BAAA;EA6SF;EA3SA;IACE,iCAAA;EA6SF;EA3SA;IACE,gCAAA;EA6SF;EA3SA;IACE,iCAAA;EA6SF;EA3SA;IACE,8BAAA;EA6SF;EA3SA;IACE,8BAAA;EA6SF;EA3SA;IACE,yBAAA;EA6SF;EA3SA;IACE,+BAAA;EA6SF;EA3SA;IACE,8BAAA;EA6SF;EA3SA;IACE,+BAAA;EA6SF;EA3SA;IACE,4BAAA;EA6SF;EA3SA;IACE,+BAAA;EA6SF;EA3SA;IACE,8BAAA;EA6SF;EA3SA;IACE,+BAAA;EA6SF;EA3SA;IACE,4BAAA;EA6SF;EA3SA;IACE,+BAAA;EA6SF;EA3SA;IACE,8BAAA;EA6SF;EA3SA;IACE,+BAAA;EA6SF;EA3SA;IACE,4BAAA;EA6SF;EA3SA;IACE,+BAAA;EA6SF;EA3SA;IACE,8BAAA;EA6SF;EA3SA;IACE,+BAAA;EA6SF;EA3SA;IACE,4BAAA;EA6SF;EA3SA;IACE,+BAAA;EA6SF;EA3SA;IACE,8BAAA;EA6SF;EA3SA;IACE,+BAAA;EA6SF;EA3SA;IACE,4BAAA;EA6SF;EA3SA;IACE,4BAAA;EA6SF;EA3SA;IACE,2BAAA;EA6SF;EA3SA;IACE,0BAAA;EA6SF;EA3SA;IACE,2BAAA;EA6SF;EA3SA;IACE,wBAAA;EA6SF;EA3SA;IACE,2BAAA;EA6SF;EA3SA;IACE,0BAAA;EA6SF;EA3SA;IACE,2BAAA;EA6SF;EA3SA;IACE,wBAAA;EA6SF;EA3SA;IACE,2BAAA;EA6SF;EA3SA;IACE,0BAAA;EA6SF;EA3SA;IACE,2BAAA;EA6SF;EA3SA;IACE,wBAAA;EA6SF;EA3SA;IACE,2BAAA;EA6SF;EA3SA;IACE,0BAAA;EA6SF;EA3SA;IACE,2BAAA;EA6SF;EA3SA;IACE,wBAAA;EA6SF;EA3SA;IACE,2BAAA;EA6SF;EA3SA;IACE,0BAAA;EA6SF;EA3SA;IACE,2BAAA;EA6SF;EA3SA;IACE,wBAAA;EA6SF;EA3SA;IACE,iCAAA;IACA,gCAAA;EA6SF;EA3SA;IACE,gCAAA;IACA,+BAAA;EA6SF;EA3SA;IACE,iCAAA;IACA,gCAAA;EA6SF;EA3SA;IACE,8BAAA;IACA,6BAAA;EA6SF;EA3SA;IACE,iCAAA;IACA,gCAAA;EA6SF;EA3SA;IACE,gCAAA;IACA,+BAAA;EA6SF;EA3SA;IACE,iCAAA;IACA,gCAAA;EA6SF;EA3SA;IACE,8BAAA;IACA,6BAAA;EA6SF;EA3SA;IACE,iCAAA;IACA,gCAAA;EA6SF;EA3SA;IACE,gCAAA;IACA,+BAAA;EA6SF;EA3SA;IACE,iCAAA;IACA,gCAAA;EA6SF;EA3SA;IACE,8BAAA;IACA,6BAAA;EA6SF;EA3SA;IACE,iCAAA;IACA,gCAAA;EA6SF;EA3SA;IACE,gCAAA;IACA,+BAAA;EA6SF;EA3SA;IACE,iCAAA;IACA,gCAAA;EA6SF;EA3SA;IACE,8BAAA;IACA,6BAAA;EA6SF;EA3SA;IACE,iCAAA;IACA,gCAAA;EA6SF;EA3SA;IACE,gCAAA;IACA,+BAAA;EA6SF;EA3SA;IACE,iCAAA;IACA,gCAAA;EA6SF;EA3SA;IACE,8BAAA;IACA,6BAAA;EA6SF;EA3SA;IACE,+BAAA;IACA,kCAAA;EA6SF;EA3SA;IACE,8BAAA;IACA,iCAAA;EA6SF;EA3SA;IACE,+BAAA;IACA,kCAAA;EA6SF;EA3SA;IACE,4BAAA;IACA,+BAAA;EA6SF;EA3SA;IACE,+BAAA;IACA,kCAAA;EA6SF;EA3SA;IACE,8BAAA;IACA,iCAAA;EA6SF;EA3SA;IACE,+BAAA;IACA,kCAAA;EA6SF;EA3SA;IACE,4BAAA;IACA,+BAAA;EA6SF;EA3SA;IACE,+BAAA;IACA,kCAAA;EA6SF;EA3SA;IACE,8BAAA;IACA,iCAAA;EA6SF;EA3SA;IACE,+BAAA;IACA,kCAAA;EA6SF;EA3SA;IACE,4BAAA;IACA,+BAAA;EA6SF;EA3SA;IACE,+BAAA;IACA,kCAAA;EA6SF;EA3SA;IACE,8BAAA;IACA,iCAAA;EA6SF;EA3SA;IACE,+BAAA;IACA,kCAAA;EA6SF;EA3SA;IACE,4BAAA;IACA,+BAAA;EA6SF;EA3SA;IACE,+BAAA;IACA,kCAAA;EA6SF;EA3SA;IACE,8BAAA;IACA,iCAAA;EA6SF;EA3SA;IACE,+BAAA;IACA,kCAAA;EA6SF;EA3SA;IACE,4BAAA;IACA,+BAAA;EA6SF;EA3SA;IACE,+BAAA;EA6SF;EA3SA;IACE,8BAAA;EA6SF;EA3SA;IACE,+BAAA;EA6SF;EA3SA;IACE,4BAAA;EA6SF;EA3SA;IACE,+BAAA;EA6SF;EA3SA;IACE,8BAAA;EA6SF;EA3SA;IACE,+BAAA;EA6SF;EA3SA;IACE,4BAAA;EA6SF;EA3SA;IACE,+BAAA;EA6SF;EA3SA;IACE,8BAAA;EA6SF;EA3SA;IACE,+BAAA;EA6SF;EA3SA;IACE,4BAAA;EA6SF;EA3SA;IACE,+BAAA;EA6SF;EA3SA;IACE,8BAAA;EA6SF;EA3SA;IACE,+BAAA;EA6SF;EA3SA;IACE,4BAAA;EA6SF;EA3SA;IACE,+BAAA;EA6SF;EA3SA;IACE,8BAAA;EA6SF;EA3SA;IACE,+BAAA;EA6SF;EA3SA;IACE,4BAAA;EA6SF;EA3SA;IACE,iCAAA;EA6SF;EA3SA;IACE,gCAAA;EA6SF;EA3SA;IACE,iCAAA;EA6SF;EA3SA;IACE,8BAAA;EA6SF;EA3SA;IACE,iCAAA;EA6SF;EA3SA;IACE,gCAAA;EA6SF;EA3SA;IACE,iCAAA;EA6SF;EA3SA;IACE,8BAAA;EA6SF;EA3SA;IACE,iCAAA;EA6SF;EA3SA;IACE,gCAAA;EA6SF;EA3SA;IACE,iCAAA;EA6SF;EA3SA;IACE,8BAAA;EA6SF;EA3SA;IACE,iCAAA;EA6SF;EA3SA;IACE,gCAAA;EA6SF;EA3SA;IACE,iCAAA;EA6SF;EA3SA;IACE,8BAAA;EA6SF;EA3SA;IACE,iCAAA;EA6SF;EA3SA;IACE,gCAAA;EA6SF;EA3SA;IACE,iCAAA;EA6SF;EA3SA;IACE,8BAAA;EA6SF;EA3SA;IACE,kCAAA;EA6SF;EA3SA;IACE,iCAAA;EA6SF;EA3SA;IACE,kCAAA;EA6SF;EA3SA;IACE,+BAAA;EA6SF;EA3SA;IACE,kCAAA;EA6SF;EA3SA;IACE,iCAAA;EA6SF;EA3SA;IACE,kCAAA;EA6SF;EA3SA;IACE,+BAAA;EA6SF;EA3SA;IACE,kCAAA;EA6SF;EA3SA;IACE,iCAAA;EA6SF;EA3SA;IACE,kCAAA;EA6SF;EA3SA;IACE,+BAAA;EA6SF;EA3SA;IACE,kCAAA;EA6SF;EA3SA;IACE,iCAAA;EA6SF;EA3SA;IACE,kCAAA;EA6SF;EA3SA;IACE,+BAAA;EA6SF;EA3SA;IACE,kCAAA;EA6SF;EA3SA;IACE,iCAAA;EA6SF;EA3SA;IACE,kCAAA;EA6SF;EA3SA;IACE,+BAAA;EA6SF;EA3SA;IACE,gCAAA;EA6SF;EA3SA;IACE,+BAAA;EA6SF;EA3SA;IACE,gCAAA;EA6SF;EA3SA;IACE,6BAAA;EA6SF;EA3SA;IACE,gCAAA;EA6SF;EA3SA;IACE,+BAAA;EA6SF;EA3SA;IACE,gCAAA;EA6SF;EA3SA;IACE,6BAAA;EA6SF;EA3SA;IACE,gCAAA;EA6SF;EA3SA;IACE,+BAAA;EA6SF;EA3SA;IACE,gCAAA;EA6SF;EA3SA;IACE,6BAAA;EA6SF;EA3SA;IACE,gCAAA;EA6SF;EA3SA;IACE,+BAAA;EA6SF;EA3SA;IACE,gCAAA;EA6SF;EA3SA;IACE,6BAAA;EA6SF;EA3SA;IACE,gCAAA;EA6SF;EA3SA;IACE,+BAAA;EA6SF;EA3SA;IACE,gCAAA;EA6SF;EA3SA;IACE,6BAAA;EA6SF;EA3SA;IACE,qBAAA;EA6SF;EA3SA;IACE,2BAAA;EA6SF;EA3SA;IACE,0BAAA;EA6SF;EA3SA;IACE,2BAAA;EA6SF;EA3SA;IACE,wBAAA;EA6SF;EA3SA;IACE,2BAAA;EA6SF;EA3SA;IACE,0BAAA;EA6SF;EA3SA;IACE,2BAAA;EA6SF;EA3SA;IACE,wBAAA;EA6SF;EA3SA;IACE,2BAAA;EA6SF;EA3SA;IACE,0BAAA;EA6SF;EA3SA;IACE,2BAAA;EA6SF;EA3SA;IACE,wBAAA;EA6SF;EA3SA;IACE,2BAAA;EA6SF;EA3SA;IACE,0BAAA;EA6SF;EA3SA;IACE,2BAAA;EA6SF;EA3SA;IACE,wBAAA;EA6SF;EA3SA;IACE,2BAAA;EA6SF;EA3SA;IACE,0BAAA;EA6SF;EA3SA;IACE,2BAAA;EA6SF;EA3SA;IACE,wBAAA;EA6SF;EA3SA;IACE,2BAAA;IACA,0BAAA;EA6SF;EA3SA;IACE,iCAAA;IACA,gCAAA;EA6SF;EA3SA;IACE,gCAAA;IACA,+BAAA;EA6SF;EA3SA;IACE,iCAAA;IACA,gCAAA;EA6SF;EA3SA;IACE,8BAAA;IACA,6BAAA;EA6SF;EA3SA;IACE,iCAAA;IACA,gCAAA;EA6SF;EA3SA;IACE,gCAAA;IACA,+BAAA;EA6SF;EA3SA;IACE,iCAAA;IACA,gCAAA;EA6SF;EA3SA;IACE,8BAAA;IACA,6BAAA;EA6SF;EA3SA;IACE,iCAAA;IACA,gCAAA;EA6SF;EA3SA;IACE,gCAAA;IACA,+BAAA;EA6SF;EA3SA;IACE,iCAAA;IACA,gCAAA;EA6SF;EA3SA;IACE,8BAAA;IACA,6BAAA;EA6SF;EA3SA;IACE,iCAAA;IACA,gCAAA;EA6SF;EA3SA;IACE,gCAAA;IACA,+BAAA;EA6SF;EA3SA;IACE,iCAAA;IACA,gCAAA;EA6SF;EA3SA;IACE,8BAAA;IACA,6BAAA;EA6SF;EA3SA;IACE,iCAAA;IACA,gCAAA;EA6SF;EA3SA;IACE,gCAAA;IACA,+BAAA;EA6SF;EA3SA;IACE,iCAAA;IACA,gCAAA;EA6SF;EA3SA;IACE,8BAAA;IACA,6BAAA;EA6SF;EA3SA;IACE,yBAAA;IACA,4BAAA;EA6SF;EA3SA;IACE,+BAAA;IACA,kCAAA;EA6SF;EA3SA;IACE,8BAAA;IACA,iCAAA;EA6SF;EA3SA;IACE,+BAAA;IACA,kCAAA;EA6SF;EA3SA;IACE,4BAAA;IACA,+BAAA;EA6SF;EA3SA;IACE,+BAAA;IACA,kCAAA;EA6SF;EA3SA;IACE,8BAAA;IACA,iCAAA;EA6SF;EA3SA;IACE,+BAAA;IACA,kCAAA;EA6SF;EA3SA;IACE,4BAAA;IACA,+BAAA;EA6SF;EA3SA;IACE,+BAAA;IACA,kCAAA;EA6SF;EA3SA;IACE,8BAAA;IACA,iCAAA;EA6SF;EA3SA;IACE,+BAAA;IACA,kCAAA;EA6SF;EA3SA;IACE,4BAAA;IACA,+BAAA;EA6SF;EA3SA;IACE,+BAAA;IACA,kCAAA;EA6SF;EA3SA;IACE,8BAAA;IACA,iCAAA;EA6SF;EA3SA;IACE,+BAAA;IACA,kCAAA;EA6SF;EA3SA;IACE,4BAAA;IACA,+BAAA;EA6SF;EA3SA;IACE,+BAAA;IACA,kCAAA;EA6SF;EA3SA;IACE,8BAAA;IACA,iCAAA;EA6SF;EA3SA;IACE,+BAAA;IACA,kCAAA;EA6SF;EA3SA;IACE,4BAAA;IACA,+BAAA;EA6SF;EA3SA;IACE,yBAAA;EA6SF;EA3SA;IACE,+BAAA;EA6SF;EA3SA;IACE,8BAAA;EA6SF;EA3SA;IACE,+BAAA;EA6SF;EA3SA;IACE,4BAAA;EA6SF;EA3SA;IACE,+BAAA;EA6SF;EA3SA;IACE,8BAAA;EA6SF;EA3SA;IACE,+BAAA;EA6SF;EA3SA;IACE,4BAAA;EA6SF;EA3SA;IACE,+BAAA;EA6SF;EA3SA;IACE,8BAAA;EA6SF;EA3SA;IACE,+BAAA;EA6SF;EA3SA;IACE,4BAAA;EA6SF;EA3SA;IACE,+BAAA;EA6SF;EA3SA;IACE,8BAAA;EA6SF;EA3SA;IACE,+BAAA;EA6SF;EA3SA;IACE,4BAAA;EA6SF;EA3SA;IACE,+BAAA;EA6SF;EA3SA;IACE,8BAAA;EA6SF;EA3SA;IACE,+BAAA;EA6SF;EA3SA;IACE,4BAAA;EA6SF;EA3SA;IACE,2BAAA;EA6SF;EA3SA;IACE,iCAAA;EA6SF;EA3SA;IACE,gCAAA;EA6SF;EA3SA;IACE,iCAAA;EA6SF;EA3SA;IACE,8BAAA;EA6SF;EA3SA;IACE,iCAAA;EA6SF;EA3SA;IACE,gCAAA;EA6SF;EA3SA;IACE,iCAAA;EA6SF;EA3SA;IACE,8BAAA;EA6SF;EA3SA;IACE,iCAAA;EA6SF;EA3SA;IACE,gCAAA;EA6SF;EA3SA;IACE,iCAAA;EA6SF;EA3SA;IACE,8BAAA;EA6SF;EA3SA;IACE,iCAAA;EA6SF;EA3SA;IACE,gCAAA;EA6SF;EA3SA;IACE,iCAAA;EA6SF;EA3SA;IACE,8BAAA;EA6SF;EA3SA;IACE,iCAAA;EA6SF;EA3SA;IACE,gCAAA;EA6SF;EA3SA;IACE,iCAAA;EA6SF;EA3SA;IACE,8BAAA;EA6SF;EA3SA;IACE,4BAAA;EA6SF;EA3SA;IACE,kCAAA;EA6SF;EA3SA;IACE,iCAAA;EA6SF;EA3SA;IACE,kCAAA;EA6SF;EA3SA;IACE,+BAAA;EA6SF;EA3SA;IACE,kCAAA;EA6SF;EA3SA;IACE,iCAAA;EA6SF;EA3SA;IACE,kCAAA;EA6SF;EA3SA;IACE,+BAAA;EA6SF;EA3SA;IACE,kCAAA;EA6SF;EA3SA;IACE,iCAAA;EA6SF;EA3SA;IACE,kCAAA;EA6SF;EA3SA;IACE,+BAAA;EA6SF;EA3SA;IACE,kCAAA;EA6SF;EA3SA;IACE,iCAAA;EA6SF;EA3SA;IACE,kCAAA;EA6SF;EA3SA;IACE,+BAAA;EA6SF;EA3SA;IACE,kCAAA;EA6SF;EA3SA;IACE,iCAAA;EA6SF;EA3SA;IACE,kCAAA;EA6SF;EA3SA;IACE,+BAAA;EA6SF;EA3SA;IACE,0BAAA;EA6SF;EA3SA;IACE,gCAAA;EA6SF;EA3SA;IACE,+BAAA;EA6SF;EA3SA;IACE,gCAAA;EA6SF;EA3SA;IACE,6BAAA;EA6SF;EA3SA;IACE,gCAAA;EA6SF;EA3SA;IACE,+BAAA;EA6SF;EA3SA;IACE,gCAAA;EA6SF;EA3SA;IACE,6BAAA;EA6SF;EA3SA;IACE,gCAAA;EA6SF;EA3SA;IACE,+BAAA;EA6SF;EA3SA;IACE,gCAAA;EA6SF;EA3SA;IACE,6BAAA;EA6SF;EA3SA;IACE,gCAAA;EA6SF;EA3SA;IACE,+BAAA;EA6SF;EA3SA;IACE,gCAAA;EA6SF;EA3SA;IACE,6BAAA;EA6SF;EA3SA;IACE,gCAAA;EA6SF;EA3SA;IACE,+BAAA;EA6SF;EA3SA;IACE,gCAAA;EA6SF;EA3SA;IACE,6BAAA;EA6SF;EA3SA;IACE,iBAAA;EA6SF;EA3SA;IACE,uBAAA;EA6SF;EA3SA;IACE,sBAAA;EA6SF;EA3SA;IACE,uBAAA;EA6SF;EA3SA;IACE,oBAAA;EA6SF;EA3SA;IACE,uBAAA;EA6SF;EA3SA;IACE,sBAAA;EA6SF;EA3SA;IACE,uBAAA;EA6SF;EA3SA;IACE,oBAAA;EA6SF;EA3SA;IACE,uBAAA;EA6SF;EA3SA;IACE,sBAAA;EA6SF;EA3SA;IACE,uBAAA;EA6SF;EA3SA;IACE,oBAAA;EA6SF;EA3SA;IACE,uBAAA;EA6SF;EA3SA;IACE,sBAAA;EA6SF;EA3SA;IACE,uBAAA;EA6SF;EA3SA;IACE,oBAAA;EA6SF;EA3SA;IACE,uBAAA;EA6SF;EA3SA;IACE,sBAAA;EA6SF;EA3SA;IACE,uBAAA;EA6SF;EA3SA;IACE,oBAAA;EA6SF;EA3SA;IACE,qBAAA;EA6SF;EA3SA;IACE,2BAAA;EA6SF;EA3SA;IACE,0BAAA;EA6SF;EA3SA;IACE,2BAAA;EA6SF;EA3SA;IACE,wBAAA;EA6SF;EA3SA;IACE,2BAAA;EA6SF;EA3SA;IACE,0BAAA;EA6SF;EA3SA;IACE,2BAAA;EA6SF;EA3SA;IACE,wBAAA;EA6SF;EA3SA;IACE,2BAAA;EA6SF;EA3SA;IACE,0BAAA;EA6SF;EA3SA;IACE,2BAAA;EA6SF;EA3SA;IACE,wBAAA;EA6SF;EA3SA;IACE,2BAAA;EA6SF;EA3SA;IACE,0BAAA;EA6SF;EA3SA;IACE,2BAAA;EA6SF;EA3SA;IACE,wBAAA;EA6SF;EA3SA;IACE,2BAAA;EA6SF;EA3SA;IACE,0BAAA;EA6SF;EA3SA;IACE,2BAAA;EA6SF;EA3SA;IACE,wBAAA;EA6SF;EA3SA;IACE,wBAAA;EA6SF;EA3SA;IACE,8BAAA;EA6SF;EA3SA;IACE,6BAAA;EA6SF;EA3SA;IACE,8BAAA;EA6SF;EA3SA;IACE,2BAAA;EA6SF;EA3SA;IACE,8BAAA;EA6SF;EA3SA;IACE,6BAAA;EA6SF;EA3SA;IACE,8BAAA;EA6SF;EA3SA;IACE,2BAAA;EA6SF;EA3SA;IACE,8BAAA;EA6SF;EA3SA;IACE,6BAAA;EA6SF;EA3SA;IACE,8BAAA;EA6SF;EA3SA;IACE,2BAAA;EA6SF;EA3SA;IACE,8BAAA;EA6SF;EA3SA;IACE,6BAAA;EA6SF;EA3SA;IACE,8BAAA;EA6SF;EA3SA;IACE,2BAAA;EA6SF;EA3SA;IACE,8BAAA;EA6SF;EA3SA;IACE,6BAAA;EA6SF;EA3SA;IACE,8BAAA;EA6SF;EA3SA;IACE,2BAAA;EA6SF;EA3SA;IACE,0CAAA;EA6SF;EA3SA;IACE,4CAAA;EA6SF;EA3SA;IACE,4CAAA;EA6SF;EA3SA;IACE,6BAAA;EA6SF;EA3SA;IACE,6BAAA;EA6SF;EA3SA;IACE,8BAAA;EA6SF;EA3SA;IACE,6BAAA;EA6SF;EA3SA;IACE,6BAAA;EA6SF;EA3SA;IACE,6BAAA;EA6SF;EA3SA;IACE,4BAAA;EA6SF;EA3SA;IACE,0BAAA;EA6SF;EA3SA;IACE,0BAAA;EA6SF;EA3SA;IACE,4CAAA;EA6SF;EA3SA;IACE,2CAAA;EA6SF;EA3SA;IACE,4CAAA;EA6SF;EA3SA;IACE,0CAAA;EA6SF;EA3SA;IACE,4CAAA;EA6SF;EA3SA;IACE,2CAAA;EA6SF;EA3SA;IACE,4CAAA;EA6SF;EA3SA;IACE,wCAAA;EA6SF;EA3SA;IACE,4CAAA;EA6SF;EA3SA;IACE,2CAAA;EA6SF;EA3SA;IACE,4CAAA;EA6SF;EA3SA;IACE,0CAAA;EA6SF;EA3SA;IACE,4CAAA;EA6SF;EA3SA;IACE,2CAAA;EA6SF;EA3SA;IACE,4CAAA;EA6SF;EA3SA;IACE,0CAAA;EA6SF;EA3SA;IACE,4CAAA;EA6SF;EA3SA;IACE,yCAAA;EA6SF;EA3SA;IACE,4CAAA;EA6SF;EA3SA;IACE,0CAAA;EA6SF;EA3SA;IACE,4CAAA;EA6SF;EA3SA;IACE,2CAAA;EA6SF;EA3SA;IACE,4CAAA;EA6SF;EA3SA;IACE,0CAAA;EA6SF;EA3SA;IACE,2BAAA;EA6SF;EA3SA;IACE,4BAAA;EA6SF;EA3SA;IACE,6BAAA;EA6SF;EA3SA;IACE,2BAAA;EA6SF;EA3SA;IACE,yBAAA;EA6SF;EA3SA;IACE,yBAAA;EA6SF;EA3SA;IACE,yBAAA;EA6SF;EA3SA;IACE,0BAAA;EA6SF;EA3SA;IACE,0BAAA;EA6SF;EA3SA;IACE,yBAAA;EA6SF;EA3SA;IACE,yBAAA;EA6SF;EA3SA;IACE,yBAAA;EA6SF;EA3SA;IACE,yBAAA;EA6SF;EA3SA;IACE,yBAAA;EA6SF;EA3SA;IACE,yBAAA;EA6SF;EA3SA;IACE,yBAAA;EA6SF;EA3SA;IACE,yBAAA;EA6SF;EA3SA;IACE,yBAAA;EA6SF;EA3SA;IACE,0BAAA;EA6SF;EA3SA;IACE,0BAAA;EA6SF;EA3SA;IACE,0BAAA;EA6SF;EA3SA;IACE,0BAAA;EA6SF;EA3SA;IACE,0BAAA;EA6SF;EA3SA;IACE,0BAAA;EA6SF;EA3SA;IACE,0BAAA;EA6SF;EA3SA;IACE,0BAAA;EA6SF;EA3SA;IACE,0BAAA;EA6SF;EA3SA;IACE,0BAAA;EA6SF;EA3SA;IACE,0BAAA;EA6SF;EA3SA;IACE,0BAAA;EA6SF;EA3SA;IACE,0BAAA;EA6SF;EA3SA;IACE,0BAAA;EA6SF;EA3SA;IACE,0BAAA;EA6SF;EA3SA;IACE,0BAAA;EA6SF;EA3SA;IACE,0BAAA;EA6SF;EA3SA;IACE,0BAAA;EA6SF;EA3SA;IACE,2BAAA;EA6SF;EA3SA;IACE,2BAAA;EA6SF;EA3SA;IACE,2BAAA;EA6SF;EA3SA;IACE,2BAAA;EA6SF;EA3SA;IACE,2BAAA;EA6SF;EA3SA;IACE,2BAAA;EA6SF;EA3SA;IACE,2BAAA;EA6SF;EA3SA;IACE,2BAAA;EA6SF;EA3SA;IACE,2BAAA;EA6SF;EA3SA;IACE,2BAAA;EA6SF;EA3SA;IACE,2BAAA;EA6SF;EA3SA;IACE,2BAAA;EA6SF;EA3SA;IACE,2BAAA;EA6SF;EA3SA;IACE,2BAAA;EA6SF;EA3SA;IACE,2BAAA;EA6SF;EA3SA;IACE,2BAAA;EA6SF;EA3SA;IACE,2BAAA;EA6SF;EA3SA;IACE,2BAAA;EA6SF;EA3SA;IACE,2BAAA;EA6SF;EA3SA;IACE,2BAAA;EA6SF;EA3SA;IACE,2BAAA;EA6SF;EA3SA;IACE,2BAAA;EA6SF;EA3SA;IACE,2BAAA;EA6SF;EA3SA;IACE,2BAAA;EA6SF;EA3SA;IACE,2BAAA;EA6SF;EA3SA;IACE,2BAAA;EA6SF;EA3SA;IACE,4BAAA;EA6SF;EA3SA;IACE,4BAAA;EA6SF;EA3SA;IACE,0BAAA;EA6SF;EA3SA;IACE,0BAAA;EA6SF;EA3SA;IACE,0BAAA;EA6SF;EA3SA;IACE,2BAAA;EA6SF;EA3SA;IACE,2BAAA;EA6SF;EA3SA;IACE,0BAAA;EA6SF;EA3SA;IACE,0BAAA;EA6SF;EA3SA;IACE,0BAAA;EA6SF;EA3SA;IACE,0BAAA;EA6SF;EA3SA;IACE,0BAAA;EA6SF;EA3SA;IACE,0BAAA;EA6SF;EA3SA;IACE,0BAAA;EA6SF;EA3SA;IACE,0BAAA;EA6SF;EA3SA;IACE,0BAAA;EA6SF;EA3SA;IACE,2BAAA;EA6SF;EA3SA;IACE,2BAAA;EA6SF;EA3SA;IACE,2BAAA;EA6SF;EA3SA;IACE,2BAAA;EA6SF;EA3SA;IACE,2BAAA;EA6SF;EA3SA;IACE,2BAAA;EA6SF;EA3SA;IACE,2BAAA;EA6SF;EA3SA;IACE,2BAAA;EA6SF;EA3SA;IACE,2BAAA;EA6SF;EA3SA;IACE,2BAAA;EA6SF;EA3SA;IACE,2BAAA;EA6SF;EA3SA;IACE,2BAAA;EA6SF;EA3SA;IACE,2BAAA;EA6SF;EA3SA;IACE,2BAAA;EA6SF;EA3SA;IACE,2BAAA;EA6SF;EA3SA;IACE,2BAAA;EA6SF;EA3SA;IACE,2BAAA;EA6SF;EA3SA;IACE,2BAAA;EA6SF;EA3SA;IACE,4BAAA;EA6SF;EA3SA;IACE,4BAAA;EA6SF;EA3SA;IACE,4BAAA;EA6SF;EA3SA;IACE,4BAAA;EA6SF;EA3SA;IACE,4BAAA;EA6SF;EA3SA;IACE,4BAAA;EA6SF;EA3SA;IACE,4BAAA;EA6SF;EA3SA;IACE,4BAAA;EA6SF;EA3SA;IACE,4BAAA;EA6SF;EA3SA;IACE,4BAAA;EA6SF;EA3SA;IACE,4BAAA;EA6SF;EA3SA;IACE,4BAAA;EA6SF;EA3SA;IACE,4BAAA;EA6SF;EA3SA;IACE,4BAAA;EA6SF;EA3SA;IACE,4BAAA;EA6SF;EA3SA;IACE,4BAAA;EA6SF;EA3SA;IACE,4BAAA;EA6SF;EA3SA;IACE,4BAAA;EA6SF;EA3SA;IACE,4BAAA;EA6SF;EA3SA;IACE,4BAAA;EA6SF;EA3SA;IACE,4BAAA;EA6SF;EA3SA;IACE,4BAAA;EA6SF;EA3SA;IACE,4BAAA;EA6SF;EA3SA;IACE,4BAAA;EA6SF;EA3SA;IACE,4BAAA;EA6SF;EA3SA;IACE,4BAAA;EA6SF;EA3SA;IACE,6BAAA;EA6SF;AACF;AA3SA;EACE;IACE,6BAAA;EA6SF;EA3SA;IACE,4BAAA;EA6SF;EA3SA;IACE,6BAAA;EA6SF;EA3SA;IACE,0BAAA;EA6SF;EA3SA;IACE,6BAAA;EA6SF;EA3SA;IACE,4BAAA;EA6SF;EA3SA;IACE,6BAAA;EA6SF;EA3SA;IACE,0BAAA;EA6SF;EA3SA;IACE,6BAAA;EA6SF;EA3SA;IACE,4BAAA;EA6SF;EA3SA;IACE,6BAAA;EA6SF;EA3SA;IACE,0BAAA;EA6SF;EA3SA;IACE,6BAAA;EA6SF;EA3SA;IACE,4BAAA;EA6SF;EA3SA;IACE,6BAAA;EA6SF;EA3SA;IACE,0BAAA;EA6SF;EA3SA;IACE,6BAAA;EA6SF;EA3SA;IACE,4BAAA;EA6SF;EA3SA;IACE,6BAAA;EA6SF;EA3SA;IACE,0BAAA;EA6SF;EA3SA;IACE,6BAAA;EA6SF;EA3SA;IACE,4BAAA;EA6SF;EA3SA;IACE,6BAAA;EA6SF;EA3SA;IACE,0BAAA;EA6SF;EA3SA;IACE,6BAAA;EA6SF;EA3SA;IACE,4BAAA;EA6SF;EA3SA;IACE,6BAAA;EA6SF;EA3SA;IACE,6BAAA;EA6SF;EA3SA;IACE,4BAAA;EA6SF;EA3SA;IACE,6BAAA;EA6SF;EA3SA;IACE,0BAAA;EA6SF;EA3SA;IACE,6BAAA;EA6SF;EA3SA;IACE,4BAAA;EA6SF;EA3SA;IACE,6BAAA;EA6SF;EA3SA;IACE,0BAAA;EA6SF;EA3SA;IACE,6BAAA;EA6SF;EA3SA;IACE,4BAAA;EA6SF;EA3SA;IACE,6BAAA;EA6SF;EA3SA;IACE,0BAAA;EA6SF;EA3SA;IACE,6BAAA;EA6SF;EA3SA;IACE,4BAAA;EA6SF;EA3SA;IACE,6BAAA;EA6SF;EA3SA;IACE,0BAAA;EA6SF;EA3SA;IACE,6BAAA;EA6SF;EA3SA;IACE,4BAAA;EA6SF;EA3SA;IACE,6BAAA;EA6SF;EA3SA;IACE,0BAAA;EA6SF;EA3SA;IACE,6BAAA;EA6SF;EA3SA;IACE,4BAAA;EA6SF;EA3SA;IACE,6BAAA;EA6SF;EA3SA;IACE,0BAAA;EA6SF;EA3SA;IACE,6BAAA;EA6SF;EA3SA;IACE,4BAAA;EA6SF;EA3SA;IACE,6BAAA;EA6SF;EA3SA;IACE,6BAAA;EA6SF;EA3SA;IACE,4BAAA;EA6SF;EA3SA;IACE,6BAAA;EA6SF;EA3SA;IACE,0BAAA;EA6SF;EA3SA;IACE,6BAAA;EA6SF;EA3SA;IACE,4BAAA;EA6SF;EA3SA;IACE,6BAAA;EA6SF;EA3SA;IACE,0BAAA;EA6SF;EA3SA;IACE,6BAAA;EA6SF;EA3SA;IACE,4BAAA;EA6SF;EA3SA;IACE,6BAAA;EA6SF;EA3SA;IACE,0BAAA;EA6SF;EA3SA;IACE,6BAAA;EA6SF;EA3SA;IACE,4BAAA;EA6SF;EA3SA;IACE,6BAAA;EA6SF;EA3SA;IACE,0BAAA;EA6SF;EA3SA;IACE,6BAAA;EA6SF;EA3SA;IACE,4BAAA;EA6SF;EA3SA;IACE,6BAAA;EA6SF;EA3SA;IACE,0BAAA;EA6SF;EA3SA;IACE,6BAAA;EA6SF;EA3SA;IACE,4BAAA;EA6SF;EA3SA;IACE,6BAAA;EA6SF;EA3SA;IACE,0BAAA;EA6SF;EA3SA;IACE,6BAAA;EA6SF;EA3SA;IACE,4BAAA;EA6SF;EA3SA;IACE,6BAAA;EA6SF;EA3SA;IACE,6BAAA;EA6SF;EA3SA;IACE,4BAAA;EA6SF;EA3SA;IACE,6BAAA;EA6SF;EA3SA;IACE,0BAAA;EA6SF;EA3SA;IACE,6BAAA;EA6SF;EA3SA;IACE,4BAAA;EA6SF;EA3SA;IACE,6BAAA;EA6SF;EA3SA;IACE,0BAAA;EA6SF;EA3SA;IACE,6BAAA;EA6SF;EA3SA;IACE,4BAAA;EA6SF;EA3SA;IACE,6BAAA;EA6SF;EA3SA;IACE,0BAAA;EA6SF;EA3SA;IACE,6BAAA;EA6SF;EA3SA;IACE,4BAAA;EA6SF;EA3SA;IACE,6BAAA;EA6SF;EA3SA;IACE,0BAAA;EA6SF;EA3SA;IACE,6BAAA;EA6SF;EA3SA;IACE,4BAAA;EA6SF;EA3SA;IACE,6BAAA;EA6SF;EA3SA;IACE,0BAAA;EA6SF;EA3SA;IACE,6BAAA;EA6SF;EA3SA;IACE,4BAAA;EA6SF;EA3SA;IACE,6BAAA;EA6SF;EA3SA;IACE,0BAAA;EA6SF;EA3SA;IACE,6BAAA;EA6SF;EA3SA;IACE,4BAAA;EA6SF;EA3SA;IACE,6BAAA;EA6SF;AACF;AA3SA;EACE;IACE,0BAAA;EA6SF;EA3SA;IACE,gCAAA;EA6SF;EA3SA;IACE,yBAAA;EA6SF;EA3SA;IACE,wBAAA;EA6SF;EA3SA;IACE,yBAAA;EA6SF;EA3SA;IACE,6BAAA;EA6SF;EA3SA;IACE,8BAAA;EA6SF;EA3SA;IACE,wBAAA;EA6SF;EA3SA;IACE,+BAAA;EA6SF;EA3SA;IACE,wBAAA;EA6SF;AACF;AA1SA;EACE,UAAA;AA4SF;;AAzSA;EACE,wCAAA;AA4SF;;AAzSA;EACE,gBAAA;AA4SF;;AAzSA;EACE,2BAAA;AA4SF;;AAzSA;EACE,wBAAA;AA4SF;;AA1SA;EACE,wCAAA;AA6SF;;AA3SA;EACE,8CAAA;AA8SF;;AA3SA;EACE,wBAAA;AA8SF;;AA5SA;EACE,wCAAA;AA+SF;;AA7SA;EACE,8CAAA;AAgTF;;AA7SA;EACE,sBAAA;EACA,yBAAA;AAgTF;;AA7SA;EACE;IACE,mCAAA;IACA,mBAAA;EAgTF;EA9SA;IACE,+BAAA;EAgTF;AACF;AA9SA;EACE,oCAAA;AAgTF;;AA7SA;EACE;IACE,kCAAA;IACA,mBAAA;EAgTF;EA9SA;IACE,+BAAA;EAgTF;AACF;AA9SA;EACE,kCAAA;AAgTF;;AA7SA;EACE;IACE,UAAA;EAgTF;EA9SA;IACE,UAAA;EAgTF;AACF;AA9SA;EACE,+BAAA;AAgTF;;AA7SA;EACE;IACE,UAAA;EAgTF;EA9SA;IACE,UAAA;EAgTF;AACF;AA9SA;EACE,gCAAA;AAgTF;;AA7SA;EACE,qDAAA;AAgTF;;AA7SA;EACE;IACE,kBAAA;EAgTF;AACF;AA9SA;EACE,sBAAA;EACA,6BAAA;EACA,uCAAA;AAgTF;;AA9SA;EACE,sBAAA;AAiTF;;AA9SA;EACE,wBAAA;EACA,+BAAA;EACA,yCAAA;AAiTF;;AA/SA;EACE,wBAAA;AAkTF;;AA/SA;EACE,0BAAA;EACA,iCAAA;EACA,2CAAA;AAkTF;;AAhTA;EACE,0BAAA;AAmTF;;AAhTA;EACE,wBAAA;EACA,+BAAA;EACA,yCAAA;AAmTF;;AAjTA;EACE,wBAAA;AAoTF;;AAjTA;EACE,qBAAA;EACA,4BAAA;EACA,sCAAA;AAoTF;;AAlTA;EACE,qBAAA;AAqTF;;AAlTA;EACE,wBAAA;EACA,+BAAA;EACA,yCAAA;AAqTF;;AAnTA;EACE,wBAAA;AAsTF;;AAnTA;EACE,uBAAA;EACA,8BAAA;EACA,wCAAA;AAsTF;;AApTA;EACE,uBAAA;AAuTF;;AApTA;EACE,qBAAA;EACA,4BAAA;EACA,sCAAA;AAuTF;;AArTA;EACE,qBAAA;AAwTF;;AArTA;EACE,2CAAA;AAwTF;;AArTA;EACE,eAAA;AAwTF;;AArTA;EACE,sBAAA;EACA,6BAAA;EACA,uCAAA;AAwTF;;AArTA;EACE,oBAAA;AAwTF;;AAtTA;EACE,eAAA;AAyTF;;AAtTA;EACE,oBAAA;EACA,yBAAA;EACA,4BAAA;AAyTF;;AAvTA;EACE,aAAA;EACA,oBAAA;EACA,yBAAA;EACA,4BAAA;AA0TF;;AAxTA;EACE,aAAA;EACA,mBAAA;AA2TF;;AAxTA;EACE,gBAAA;EACA,uBAAA;EACA,oCAAA;AA2TF;;AAzTA;EACE,6BAAA;EACA,wCAAA;AA4TF;;AA1TA;EACE,aAAA;AA6TF;;AA3TA;;EAEE,kBAAA;EACA,cAAA;EACA,YAAA;EACA,aAAA;AA8TF;;AA5TA;EACE,oBAAA;AA+TF;;AA7TA;EACE,WAAA;AAgUF;;AA9TA;EACE,eAAA;AAiUF;;AA9TA;EACE,wBAAA;EACA,0BAAA;EACA,2CAAA;AAiUF;;AA/TA;EACE,mBAAA;AAkUF;;AAhUA;EACE,yBAAA;EACA,SAAA;EACA,oCAAA;EACA,2BAAA;EACA,iBAAA;EACA,cAAA;AAmUF;;AAjUA;EACE,cAAA;AAoUF;;AAlUA;EACE,eAAA;AAqUF;;AAnUA;;;EAGE,6BAAA;EACA,SAAA;EACA,0CAAA;EACA,2BAAA;AAsUF;;AApUA;EACE,wBAAA;AAuUF;;AArUA;EACE,mBAAA;AAwUF;;AAtUA;EACE,wBAAA;AAyUF;;AAvUA;;;EAGE,wBAAA;AA0UF;;AAvUA;;EAEE,gDAAA;EACA,uBAAA;AA0UF;;AAxUA;;EAEE,+CAAA;AA2UF;;AAzUA;;EAEE,mCAAA;AA4UF;;AA1UA;;EAEE,WAAA;EACA,2BAAA;AA6UF;;AA3UA;;EAEE,qBAAA;AA8UF;;AA5UA;;EAEE,aAAA;AA+UF;;AA7UA;;EAEE,6BAAA;EACA,+CAAA;EACA,wBAAA;EACA,kBAAA;AAgVF;;AA9UA;;EAEE,oCAAA;EACA,2BAAA;AAiVF;;AA/UA;;EAEE,cAAA;AAkVF;;AAhVA;;EAEE,aAAA;AAmVF;;AAjVA;EACE,cAAA;AAoVF;;AAlVA;EACE,cAAA;AAqVF;;AAnVA;EACE,yBAAA;AAsVF;;AApVA;EACE,yBAAA;AAuVF;;AArVA;EACE,yBAAA;AAwVF;;AAtVA;EACE,yBAAA;AAyVF;;AAtVA;EACE,aAAA;EACA,eAAA;EACA,uBAAA;EACA,SAAA;AAyVF;;AAvVA;EACE,kBAAA;AA0VF;;AAxVA;EACE,wCAAA;AA2VF;;AAzVA;EACE,qCAAA;AA4VF;;AAzVA;EACE,oBAAA;EACA,iBAAA;AA4VF;;AA1VA;EACE,eAAA;AA6VF;;AA3VA;EACE,aAAA;EACA,uBAAA;EACA,mBAAA;EACA,uBAAA;EACA,cAAA;EACA,iBAAA;EACA,gBAAA;EACA,mBAAA;EACA,mCAAA;EACA,iBAAA;EACA,mCAAA;AA8VF;;AA5VA;EACE,kBAAA;AA+VF;;AA7VA;;EAEE,cAAA;EACA,gBAAA;EACA,eAAA;EACA,uCAAA;AAgWF;;AA9VA;EACE,sBAAA;EACA,qBAAA;EACA,8BAAA;EACA,6BAAA;EACA,oCAAA;EAEA,oDAAA;AAiWF;;AA/VA;EACE,sBAAA;EACA,qBAAA;EACA,8BAAA;EACA,6BAAA;EACA,oCAAA;EAEA,oDAAA;AAkWF;;AAhWA;EACE,uCAAA;EACA,mCAAA;AAmWF;;AAjWA;;EAEE,uCAAA;AAoWF;;AAlWA;EACE,sBAAA;EACA,qBAAA;EACA,8BAAA;EACA,6BAAA;EACA,kDAAA;EAEA,oDAAA;AAqWF;;AAnWA;EACE,sBAAA;EACA,qBAAA;EACA,8BAAA;EACA,6BAAA;EACA,kDAAA;EAEA,oDAAA;AAsWF;;AApWA;EACE,uCAAA;EACA,mCAAA;AAuWF;;AArWA;EACE,6BAAA;AAwWF;;AAtWA;;EAEE,uCAAA;AAyWF;;AAvWA;EACE,sBAAA;EACA,qBAAA;EACA,8BAAA;EACA,6BAAA;EACA,kDAAA;EAEA,oDAAA;AA0WF;;AAxWA;EACE,sBAAA;EACA,qBAAA;EACA,8BAAA;EACA,6BAAA;EACA,kDAAA;EAEA,oDAAA;AA2WF;;AAzWA;EACE,wCAAA;EACA,mCAAA;AA4WF;;AA1WA;EACE,6BAAA;AA6WF;;AA3WA;;EAEE,wCAAA;AA8WF;;AA5WA;EACE,sBAAA;EACA,qBAAA;EACA,8BAAA;EACA,6BAAA;EACA,mDAAA;EAEA,oDAAA;AA+WF;;AA7WA;EACE,sBAAA;EACA,qBAAA;EACA,8BAAA;EACA,6BAAA;EACA,mDAAA;EAEA,oDAAA;AAgXF;;AA9WA;EACE,0CAAA;EACA,mCAAA;AAiXF;;AA/WA;;EAEE,0CAAA;AAkXF;;AAhXA;EACE,sBAAA;EACA,qBAAA;EACA,8BAAA;EACA,6BAAA;EACA,qDAAA;EAEA,oDAAA;AAmXF;;AAjXA;EACE,sBAAA;EACA,qBAAA;EACA,8BAAA;EACA,6BAAA;EACA,qDAAA;EAEA,oDAAA;AAoXF;;AAjXA;EACE;IACE,qBAAA;EAoXF;EAlXA;IACE,eAAA;EAoXF;AACF;AAlXA;EACE,cAAA;EACA,SAAA;EACA,+CAAA;AAoXF;;AAlXA;EACE,2BAAA;EACA,kDAAA;AAqXF;;AAnXA;EACE,2BAAA;EACA,kDAAA;AAsXF;;AApXA;EACE,aAAA;EACA,mBAAA;EACA,gBAAA;EACA,kBAAA;AAuXF;;AArXA;EACE,YAAA;EACA,UAAA;EACA,+CAAA;AAwXF;;AAtXA;EACE,qBAAA;AAyXF;;AAvXA;EACE,oBAAA;AA0XF;;AAxXA;EACE,2BAAA;EACA,kDAAA;AA2XF;;AAzXA;EACE,2BAAA;EACA,kDAAA;AA4XF;;AA1XA;EACE,gCAAA;AA6XF;;AA3XA;EACE,gCAAA;AA8XF;;AA5XA;EACE,gCAAA;AA+XF;;AA7XA;EACE,gCAAA;AAgYF;;AA9XA;EACE,gCAAA;AAiYF;;AA/XA;EACE,gCAAA;AAkYF;;AAhYA;EACE,gCAAA;AAmYF;;AAjYA;EACE,gCAAA;AAoYF;;AAjYA;EACE,mBAAA;EACA,gBAAA;EACA,aAAA;EACA,SAAA;EACA,UAAA;EACA,gBAAA;AAoYF;;AAlYA;EACE,eAAA;EACA,UAAA;AAqYF;;AAnYA;EACE,eAAA;EACA,UAAA;AAsYF;;AApYA;EACE,gBAAA;EACA,wCAAA;EACA,YAAA;EACA,WAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,kBAAA;AAuYF;;AArYA;EACE,qBAAA;EACA,YAAA;EACA,kBAAA;EACA,yBAAA;EACA,oCAAA;EACA,WAAA;EACA,UAAA;AAwYF;;AAtYA;EACE,6BAAA;AAyYF;;AAvYA;EACE,yBAAA;EACA,YAAA;EACA,WAAA;EACA,oCAAA;AA0YF;;AAxYA;EACE,yBAAA;EACA,wCAAA;EACA,kBAAA;EACA,WAAA;EACA,UAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,kBAAA;AA2YF;;AAzYA;EACE,qBAAA;EACA,YAAA;EACA,yBAAA;EACA,oCAAA;EACA,kBAAA;EACA,WAAA;EACA,UAAA;AA4YF;;AA1YA;EACE,yBAAA;EACA,6BAAA;EACA,WAAA;EACA,WAAA;AA6YF;;AA3YA;EACE,yBAAA;EACA,WAAA;EACA,WAAA;EACA,oCAAA;AA8YF;;AA5YA;EACE,4CAAA;AA+YF;;AA7YA;EACE,8CAAA;AAgZF;;AA9YA;EACE,gDAAA;AAiZF;;AA/YA;EACE,8CAAA;AAkZF;;AAhZA;EACE,2CAAA;AAmZF;;AAjZA;EACE,8CAAA;AAoZF;;AAlZA;EACE,6CAAA;AAqZF;;AAnZA;EACE,2CAAA;AAsZF;;AApZA;EACE,YAAA;EACA,aAAA;EACA,sBAAA;AAuZF;;AArZA;EACE,YAAA;AAwZF;;AAtZA;EACE,YAAA;AAyZF;;AAvZA;EACE,aAAA;EACA,sBAAA;EACA,YAAA;AA0ZF;;AAvZA;EACE,aAAA;AA0ZF;;AAvZA;;EAEE,aAAA;EACA,UAAA;EACA,SAAA;EACA,gBAAA;AA0ZF;;AAvZA;EACE,UAAA;EACA,SAAA;EACA,gBAAA;AA0ZF;;AAvZA;EACE,aAAA;EACA,UAAA;EACA,SAAA;EACA,gBAAA;EACA,sBAAA;AA0ZF;;AAvZA;EACE,cAAA;EACA,kBAAA;AA0ZF;;AAxZA;EACE,eAAA;EACA,aAAA;EACA,mBAAA;EACA,UAAA;EACA,cAAA;EACA,qBAAA;EACA,gBAAA;EACA,wBAAA;AA2ZF;;AAzZA;EACE,cAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,WAAA;EACA,oBAAA;AA4ZF;;AA1ZA;;EAEE,cAAA;AA6ZF;;AA3ZA;EACE,cAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,cAAA;EACA,oBAAA;AA8ZF;;AA5ZA;EACE,aAAA;EACA,mBAAA;EACA,YAAA;AA+ZF;;AA7ZA;EACE,aAAA;EACA,mBAAA;EACA,cAAA;EACA,mBAAA;AAgaF;;AA9ZA;EACE,aAAA;EACA,oBAAA;EACA,kBAAA;EACA,gBAAA;EACA,cAAA;EACA,gBAAA;EACA,UAAA;EACA,WAAA;AAiaF;;AA/ZA;EACE,cAAA;EACA,WAAA;EACA,YAAA;EACA,sBAAA;EACA,0BAAA;EAOA,oDAAA;EACA,mBAAA;EACA,sBAAA;EACA,qBAAA;EACA,8BAAA;EACA,6BAAA;EACA,sCAAA;EAEA,oDAAA;EACA,iBAAA;AAkaF;;AAhaA;EACE,qBAAA;AAmaF;;AAhaA;EACE,2BAAA;EACA,+BAAA;AAmaF;;AAhaA;EACE,uBAAA;AAmaF;;AAhaA;EACE,mCAAA;AAmaF;;AAhaA;EACE,aAAA;EACA,0BAAA;EACA,aAAA;EACA,yBAAA;EACA,+BAAA;AAmaF;;AAjaA;EACE,aAAA;EACA,yBAAA;EACA,aAAA;EACA,0BAAA;EACA,+BAAA;AAoaF;;AAjaA;EACE,aAAA;EACA,uBAAA;EACA,kDAAA;EACA,8CAAA;EACA,YAAA;AAoaF;;AAlaA;EACE,aAAA;EACA,sBAAA;EACA,2GAAA;AAqaF;;AAlaA;EACE,aAAA;AAqaF;;AAnaA;EACE,aAAA;AAsaF;;AAnaA;EACE,iBAAA;AAsaF;;AApaA;EACE,kBAAA;AAuaF;;AApaA;EACE,aAAA;AAuaF;;AApaA;;EAEE,0BAAA;EACA,2BAAA;AAuaF;;AApaA;EACE,sBAAA;EACA,WAAA;AAuaF;;AApaA;EACE,mBAAA;AAuaF;;AAraA;EACE,aAAA;EACA,mBAAA;AAwaF;;AAtaA;EACE,aAAA;EACA,0BAAA;EACA,aAAA;EACA,yBAAA;EACA,+BAAA;AAyaF;;AAtaA;EACE,uBAAA;AAyaF;;AAtaA;EACE,mBAAA;AAyaF;;AAtaA;EACE,2BAAA;AAyaF;;AAtaA;EACE;IACE,aAAA;IACA,0BAAA;IACA,aAAA;IACA,yBAAA;IACA,+BAAA;EAyaF;EAvaA;IACE,aAAA;IACA,yBAAA;IACA,aAAA;IACA,0BAAA;IACA,+BAAA;EAyaF;EAvaA;IACE,aAAA;IACA,uBAAA;IACA,kDAAA;IACA,8CAAA;IACA,YAAA;EAyaF;EAvaA;IACE,aAAA;IACA,sBAAA;IACA,2GAAA;EAyaF;EAvaA;IACE,aAAA;EAyaF;EAvaA;IACE,aAAA;EAyaF;EAvaA;IACE,iBAAA;EAyaF;EAvaA;IACE,kBAAA;EAyaF;EAvaA;IACE,aAAA;EAyaF;EAvaA;;IAEE,0BAAA;IACA,2BAAA;EAyaF;EAvaA;IACE,sBAAA;IACA,WAAA;EAyaF;EAvaA;IACE,mBAAA;EAyaF;EAvaA;IACE,aAAA;IACA,mBAAA;EAyaF;EAvaA;IACE,aAAA;IACA,0BAAA;IACA,aAAA;IACA,yBAAA;IACA,+BAAA;EAyaF;EAvaA;IACE,uBAAA;EAyaF;EAvaA;IACE,mBAAA;EAyaF;EAvaA;IACE,2BAAA;EAyaF;AACF;AAvaA;EACE;IACE,aAAA;IACA,0BAAA;IACA,aAAA;IACA,yBAAA;IACA,+BAAA;EAyaF;EAvaA;IACE,aAAA;IACA,yBAAA;IACA,aAAA;IACA,0BAAA;IACA,+BAAA;EAyaF;EAvaA;IACE,aAAA;IACA,uBAAA;IACA,kDAAA;IACA,8CAAA;IACA,YAAA;EAyaF;EAvaA;IACE,aAAA;IACA,sBAAA;IACA,2GAAA;EAyaF;EAvaA;IACE,aAAA;EAyaF;EAvaA;IACE,aAAA;EAyaF;EAvaA;IACE,iBAAA;EAyaF;EAvaA;IACE,kBAAA;EAyaF;EAvaA;IACE,aAAA;EAyaF;EAvaA;;IAEE,0BAAA;IACA,2BAAA;EAyaF;EAvaA;IACE,sBAAA;IACA,WAAA;EAyaF;EAvaA;IACE,mBAAA;EAyaF;EAvaA;IACE,aAAA;IACA,mBAAA;EAyaF;EAvaA;IACE,aAAA;IACA,0BAAA;IACA,aAAA;IACA,yBAAA;IACA,+BAAA;EAyaF;EAvaA;IACE,uBAAA;EAyaF;EAvaA;IACE,mBAAA;EAyaF;EAvaA;IACE,2BAAA;EAyaF;AACF;AAvaA;EACE;IACE,aAAA;IACA,0BAAA;IACA,aAAA;IACA,yBAAA;IACA,+BAAA;EAyaF;EAvaA;IACE,aAAA;IACA,yBAAA;IACA,aAAA;IACA,0BAAA;IACA,+BAAA;EAyaF;EAvaA;IACE,aAAA;IACA,uBAAA;IACA,kDAAA;IACA,8CAAA;IACA,YAAA;EAyaF;EAvaA;IACE,aAAA;IACA,sBAAA;IACA,2GAAA;EAyaF;EAvaA;IACE,aAAA;EAyaF;EAvaA;IACE,aAAA;EAyaF;EAvaA;IACE,iBAAA;EAyaF;EAvaA;IACE,kBAAA;EAyaF;EAvaA;IACE,aAAA;EAyaF;EAvaA;;IAEE,0BAAA;IACA,2BAAA;EAyaF;EAvaA;IACE,sBAAA;IACA,WAAA;EAyaF;EAvaA;IACE,mBAAA;EAyaF;EAvaA;IACE,aAAA;IACA,mBAAA;EAyaF;EAvaA;IACE,aAAA;IACA,0BAAA;IACA,aAAA;IACA,yBAAA;IACA,+BAAA;EAyaF;EAvaA;IACE,uBAAA;EAyaF;EAvaA;IACE,mBAAA;EAyaF;EAvaA;IACE,2BAAA;EAyaF;AACF;AAvaA;EACE;IACE,aAAA;IACA,0BAAA;IACA,aAAA;IACA,yBAAA;IACA,+BAAA;EAyaF;EAvaA;IACE,aAAA;IACA,yBAAA;IACA,aAAA;IACA,0BAAA;IACA,+BAAA;EAyaF;EAvaA;IACE,aAAA;IACA,uBAAA;IACA,kDAAA;IACA,8CAAA;IACA,YAAA;EAyaF;EAvaA;IACE,aAAA;IACA,sBAAA;IACA,2GAAA;EAyaF;EAvaA;IACE,aAAA;EAyaF;EAvaA;IACE,aAAA;EAyaF;EAvaA;IACE,iBAAA;EAyaF;EAvaA;IACE,kBAAA;EAyaF;EAvaA;IACE,aAAA;EAyaF;EAvaA;;IAEE,0BAAA;IACA,2BAAA;EAyaF;EAvaA;IACE,sBAAA;IACA,WAAA;EAyaF;EAvaA;IACE,mBAAA;EAyaF;EAvaA;IACE,aAAA;IACA,mBAAA;EAyaF;EAvaA;IACE,aAAA;IACA,0BAAA;IACA,aAAA;IACA,yBAAA;IACA,+BAAA;EAyaF;EAvaA;IACE,uBAAA;EAyaF;EAvaA;IACE,mBAAA;EAyaF;EAvaA;IACE,2BAAA;EAyaF;AACF;AAvaA;EACE;IACE,aAAA;IACA,0BAAA;IACA,aAAA;IACA,yBAAA;IACA,+BAAA;EAyaF;EAvaA;IACE,aAAA;IACA,yBAAA;IACA,aAAA;IACA,0BAAA;IACA,+BAAA;EAyaF;EAvaA;IACE,aAAA;IACA,uBAAA;IACA,kDAAA;IACA,8CAAA;IACA,YAAA;EAyaF;EAvaA;IACE,aAAA;IACA,sBAAA;IACA,2GAAA;EAyaF;EAvaA;IACE,aAAA;EAyaF;EAvaA;IACE,aAAA;EAyaF;EAvaA;IACE,iBAAA;EAyaF;EAvaA;IACE,kBAAA;EAyaF;EAvaA;IACE,aAAA;EAyaF;EAvaA;;IAEE,0BAAA;IACA,2BAAA;EAyaF;EAvaA;IACE,sBAAA;IACA,WAAA;EAyaF;EAvaA;IACE,mBAAA;EAyaF;EAvaA;IACE,aAAA;IACA,mBAAA;EAyaF;EAvaA;IACE,aAAA;IACA,0BAAA;IACA,aAAA;IACA,yBAAA;IACA,+BAAA;EAyaF;EAvaA;IACE,uBAAA;EAyaF;EAvaA;IACE,mBAAA;EAyaF;EAvaA;IACE,2BAAA;EAyaF;AACF;AAvaA;EACE;IACE,aAAA;IACA,0BAAA;IACA,aAAA;IACA,yBAAA;IACA,+BAAA;EAyaF;EAvaA;IACE,aAAA;IACA,yBAAA;IACA,aAAA;IACA,0BAAA;IACA,+BAAA;EAyaF;EAvaA;IACE,aAAA;IACA,uBAAA;IACA,kDAAA;IACA,8CAAA;IACA,YAAA;EAyaF;EAvaA;IACE,aAAA;IACA,sBAAA;IACA,2GAAA;EAyaF;EAvaA;IACE,aAAA;EAyaF;EAvaA;IACE,aAAA;EAyaF;EAvaA;IACE,iBAAA;EAyaF;EAvaA;IACE,kBAAA;EAyaF;EAvaA;IACE,aAAA;EAyaF;EAvaA;;IAEE,0BAAA;IACA,2BAAA;EAyaF;EAvaA;IACE,sBAAA;IACA,WAAA;EAyaF;EAvaA;IACE,mBAAA;EAyaF;EAvaA;IACE,aAAA;IACA,mBAAA;EAyaF;EAvaA;IACE,aAAA;IACA,0BAAA;IACA,aAAA;IACA,yBAAA;IACA,+BAAA;EAyaF;EAvaA;IACE,uBAAA;EAyaF;EAvaA;IACE,mBAAA;EAyaF;EAvaA;IACE,2BAAA;EAyaF;AACF;AAvaA;EACE;IACE,aAAA;IACA,0BAAA;IACA,aAAA;IACA,yBAAA;IACA,+BAAA;EAyaF;EAvaA;IACE,aAAA;IACA,yBAAA;IACA,aAAA;IACA,0BAAA;IACA,+BAAA;EAyaF;EAvaA;IACE,aAAA;IACA,uBAAA;IACA,kDAAA;IACA,8CAAA;IACA,YAAA;EAyaF;EAvaA;IACE,aAAA;IACA,sBAAA;IACA,2GAAA;EAyaF;EAvaA;IACE,aAAA;EAyaF;EAvaA;IACE,aAAA;EAyaF;EAvaA;IACE,iBAAA;EAyaF;EAvaA;IACE,kBAAA;EAyaF;EAvaA;IACE,aAAA;EAyaF;EAvaA;;IAEE,0BAAA;IACA,2BAAA;EAyaF;EAvaA;IACE,sBAAA;IACA,WAAA;EAyaF;EAvaA;IACE,mBAAA;EAyaF;EAvaA;IACE,aAAA;IACA,mBAAA;EAyaF;EAvaA;IACE,aAAA;IACA,0BAAA;IACA,aAAA;IACA,yBAAA;IACA,+BAAA;EAyaF;EAvaA;IACE,uBAAA;EAyaF;EAvaA;IACE,mBAAA;EAyaF;EAvaA;IACE,2BAAA;EAyaF;AACF;AAvaA;EACE;IACE,aAAA;IACA,0BAAA;IACA,aAAA;IACA,yBAAA;IACA,+BAAA;EAyaF;EAvaA;IACE,aAAA;IACA,yBAAA;IACA,aAAA;IACA,0BAAA;IACA,+BAAA;EAyaF;EAvaA;IACE,aAAA;IACA,uBAAA;IACA,kDAAA;IACA,8CAAA;IACA,YAAA;EAyaF;EAvaA;IACE,aAAA;IACA,sBAAA;IACA,2GAAA;EAyaF;EAvaA;IACE,aAAA;EAyaF;EAvaA;IACE,aAAA;EAyaF;EAvaA;IACE,iBAAA;EAyaF;EAvaA;IACE,kBAAA;EAyaF;EAvaA;IACE,aAAA;EAyaF;EAvaA;;IAEE,0BAAA;IACA,2BAAA;EAyaF;EAvaA;IACE,sBAAA;IACA,WAAA;EAyaF;EAvaA;IACE,mBAAA;EAyaF;EAvaA;IACE,aAAA;IACA,mBAAA;EAyaF;EAvaA;IACE,aAAA;IACA,0BAAA;IACA,aAAA;IACA,yBAAA;IACA,+BAAA;EAyaF;EAvaA;IACE,uBAAA;EAyaF;EAvaA;IACE,mBAAA;EAyaF;EAvaA;IACE,2BAAA;EAyaF;AACF;AAvaA;EACE;IACE,aAAA;IACA,0BAAA;IACA,aAAA;IACA,yBAAA;IACA,+BAAA;EAyaF;EAvaA;IACE,aAAA;IACA,yBAAA;IACA,aAAA;IACA,0BAAA;IACA,+BAAA;EAyaF;EAvaA;IACE,aAAA;IACA,uBAAA;IACA,kDAAA;IACA,8CAAA;IACA,YAAA;EAyaF;EAvaA;IACE,aAAA;IACA,sBAAA;IACA,2GAAA;EAyaF;EAvaA;IACE,aAAA;EAyaF;EAvaA;IACE,aAAA;EAyaF;EAvaA;IACE,iBAAA;EAyaF;EAvaA;IACE,kBAAA;EAyaF;EAvaA;IACE,aAAA;EAyaF;EAvaA;;IAEE,0BAAA;IACA,2BAAA;EAyaF;EAvaA;IACE,sBAAA;IACA,WAAA;EAyaF;EAvaA;IACE,mBAAA;EAyaF;EAvaA;IACE,aAAA;IACA,mBAAA;EAyaF;EAvaA;IACE,aAAA;IACA,0BAAA;IACA,aAAA;IACA,yBAAA;IACA,+BAAA;EAyaF;EAvaA;IACE,uBAAA;EAyaF;EAvaA;IACE,mBAAA;EAyaF;EAvaA;IACE,2BAAA;EAyaF;AACF;AAvaA;EACE;IACE,aAAA;IACA,0BAAA;IACA,aAAA;IACA,yBAAA;IACA,+BAAA;EAyaF;EAvaA;IACE,aAAA;IACA,yBAAA;IACA,aAAA;IACA,0BAAA;IACA,+BAAA;EAyaF;EAvaA;IACE,aAAA;IACA,uBAAA;IACA,kDAAA;IACA,8CAAA;IACA,YAAA;EAyaF;EAvaA;IACE,aAAA;IACA,sBAAA;IACA,2GAAA;EAyaF;EAvaA;IACE,aAAA;EAyaF;EAvaA;IACE,aAAA;EAyaF;EAvaA;IACE,iBAAA;EAyaF;EAvaA;IACE,kBAAA;EAyaF;EAvaA;IACE,aAAA;EAyaF;EAvaA;;IAEE,0BAAA;IACA,2BAAA;EAyaF;EAvaA;IACE,sBAAA;IACA,WAAA;EAyaF;EAvaA;IACE,mBAAA;EAyaF;EAvaA;IACE,aAAA;IACA,mBAAA;EAyaF;EAvaA;IACE,aAAA;IACA,0BAAA;IACA,aAAA;IACA,yBAAA;IACA,+BAAA;EAyaF;EAvaA;IACE,uBAAA;EAyaF;EAvaA;IACE,mBAAA;EAyaF;EAvaA;IACE,2BAAA;EAyaF;AACF;AAvaA;EACE,cAAA;EACA,iBAAA;AAyaF;;AAvaA;;;;EAIE,kBAAA;AA0aF;;AAxaA;;;;;;;;EAQE,kBAAA;AA2aF;;AAzaA;;;;;;;;;;;;;;;;EAgBE,kBAAA;AA4aF;;AA1aA;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;EAgCE,kBAAA;AA6aF;;AA3aA;;;;EAIE,kBAAA;EACA,gBAAA;AA8aF;;AA5aA;;;;;;;;EAQE,kBAAA;EACA,gBAAA;AA+aF;;AA7aA;;;;;;;;;;;;;;;;EAgBE,kBAAA;EACA,gBAAA;AAgbF;;AA9aA;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;EAgCE,kBAAA;EACA,gBAAA;AAibF;;AA9aA;EACE;IACE,UAAA;EAibF;EA/aA;IACE,UAAA;EAibF;AACF;AA/aA;EACE;IACE,mBAAA;EAibF;EA/aA;IACE,aAAA;EAibF;AACF;AA/aA;EACE;IACE,sBAAA;EAibF;EA/aA;IACE,gBAAA;EAibF;AACF;AA/aA;EACE,sBAAA;AAibF;;AA/aA;EACE,sBAAA;AAkbF;;AAhbA;;;EAGE,sBAAA;AAmbF;;AAjbA;EACE,iCAAA;AAobF;;AAlbA;EAOE,oDAAA;EACA,mBAAA;EACA,sBAAA;EACA,qBAAA;EACA,8BAAA;EACA,6BAAA;EACA,iCAAA;EAEA,oDAAA;EACA,iBAAA;AAqbF;;AAlbA;EACE,2BAAA;AAqbF;;AAnbA;EACE,2BAAA;AAsbF;;AAnbA;;;EAGE,2BAAA;AAsbF;;AAnbA;EACE,sCAAA;AAsbF;;AAnbA;EAOE,oDAAA;EACA,mBAAA;EACA,sBAAA;EACA,qBAAA;EACA,8BAAA;EACA,6BAAA;EACA,sCAAA;EAEA,oDAAA;EACA,iBAAA;AAsbF;;AAnbA;EACE,wBAAA;AAsbF;;AApbA;EACE,wBAAA;AAubF;;AArbA;;;EAGE,wBAAA;AAwbF;;AAtbA;EACE,mCAAA;AAybF;;AAvbA;EAOE,oDAAA;EACA,mBAAA;EACA,sBAAA;EACA,qBAAA;EACA,8BAAA;EACA,6BAAA;EACA,mCAAA;EAEA,oDAAA;EACA,iBAAA;AA0bF;;AAvbA;EACE,6BAAA;AA0bF;;AAxbA;EACE,6BAAA;AA2bF;;AAxbA;;;EAGE,6BAAA;AA2bF;;AAxbA;EACE,wCAAA;AA2bF;;AAxbA;EAOE,oDAAA;EACA,mBAAA;EACA,sBAAA;EACA,qBAAA;EACA,8BAAA;EACA,6BAAA;EACA,wCAAA;EAEA,oDAAA;EACA,iBAAA;AA2bF;;AAxbA;EACE,0BAAA;AA2bF;;AAzbA;EACE,0BAAA;AA4bF;;AA1bA;;;EAGE,0BAAA;AA6bF;;AA3bA;EACE,qCAAA;AA8bF;;AA5bA;EAOE,oDAAA;EACA,mBAAA;EACA,sBAAA;EACA,qBAAA;EACA,8BAAA;EACA,6BAAA;EACA,qCAAA;EAEA,oDAAA;EACA,iBAAA;AA+bF;;AA5bA;EACE,+BAAA;AA+bF;;AA7bA;EACE,+BAAA;AAgcF;;AA7bA;;;EAGE,+BAAA;AAgcF;;AA7bA;EACE,0CAAA;AAgcF;;AA7bA;EAOE,oDAAA;EACA,mBAAA;EACA,sBAAA;EACA,qBAAA;EACA,8BAAA;EACA,6BAAA;EACA,0CAAA;EAEA,oDAAA;EACA,iBAAA;AAgcF;;AA7bA;EACE,sBAAA;AAgcF;;AA9bA;EACE,sBAAA;AAicF;;AA/bA;;;EAGE,sBAAA;AAkcF;;AAhcA;EACE,iCAAA;AAmcF;;AAjcA;EAOE,oDAAA;EACA,mBAAA;EACA,sBAAA;EACA,qBAAA;EACA,8BAAA;EACA,6BAAA;EACA,iCAAA;EAEA,oDAAA;EACA,iBAAA;AAocF;;AAjcA;EACE,2BAAA;AAocF;;AAlcA;EACE,2BAAA;AAqcF;;AAlcA;;;EAGE,2BAAA;AAqcF;;AAlcA;EACE,sCAAA;AAqcF;;AAlcA;EAOE,oDAAA;EACA,mBAAA;EACA,sBAAA;EACA,qBAAA;EACA,8BAAA;EACA,6BAAA;EACA,sCAAA;EAEA,oDAAA;EACA,iBAAA;AAqcF;;AAlcA;EACE,wBAAA;AAqcF;;AAncA;EACE,wBAAA;AAscF;;AApcA;;;EAGE,wBAAA;AAucF;;AArcA;EACE,mCAAA;AAwcF;;AAtcA;EAOE,oDAAA;EACA,mBAAA;EACA,sBAAA;EACA,qBAAA;EACA,8BAAA;EACA,6BAAA;EACA,mCAAA;EAEA,oDAAA;EACA,iBAAA;AAycF;;AAtcA;EACE,6BAAA;AAycF;;AAvcA;EACE,6BAAA;AA0cF;;AAvcA;;;EAGE,6BAAA;AA0cF;;AAvcA;EACE,wCAAA;AA0cF;;AAvcA;EAOE,oDAAA;EACA,mBAAA;EACA,sBAAA;EACA,qBAAA;EACA,8BAAA;EACA,6BAAA;EACA,wCAAA;EAEA,oDAAA;EACA,iBAAA;AA0cF;;AAvcA;EACE,qBAAA;AA0cF;;AAxcA;EACE,qBAAA;AA2cF;;AAzcA;;;EAGE,qBAAA;AA4cF;;AA1cA;EACE,gCAAA;AA6cF;;AA3cA;EAOE,oDAAA;EACA,mBAAA;EACA,sBAAA;EACA,qBAAA;EACA,8BAAA;EACA,6BAAA;EACA,gCAAA;EAEA,oDAAA;EACA,iBAAA;AA8cF;;AA3cA;EACE,0BAAA;AA8cF;;AA5cA;EACE,0BAAA;AA+cF;;AA5cA;;;EAGE,0BAAA;AA+cF;;AA5cA;EACE,qCAAA;AA+cF;;AA5cA;EAOE,oDAAA;EACA,mBAAA;EACA,sBAAA;EACA,qBAAA;EACA,8BAAA;EACA,6BAAA;EACA,qCAAA;EAEA,oDAAA;EACA,iBAAA;AA+cF;;AA5cA;EACE,wBAAA;AA+cF;;AA7cA;EACE,wBAAA;AAgdF;;AA9cA;;;EAGE,wBAAA;AAidF;;AA/cA;EACE,mCAAA;AAkdF;;AAhdA;EAOE,oDAAA;EACA,mBAAA;EACA,sBAAA;EACA,qBAAA;EACA,8BAAA;EACA,6BAAA;EACA,mCAAA;EAEA,oDAAA;EACA,iBAAA;AAmdF;;AAhdA;EACE,6BAAA;AAmdF;;AAjdA;EACE,6BAAA;AAodF;;AAjdA;;;EAGE,6BAAA;AAodF;;AAjdA;EACE,wCAAA;AAodF;;AAjdA;EAOE,oDAAA;EACA,mBAAA;EACA,sBAAA;EACA,qBAAA;EACA,8BAAA;EACA,6BAAA;EACA,wCAAA;EAEA,oDAAA;EACA,iBAAA;AAodF;;AAjdA;EACE,uBAAA;AAodF;;AAldA;EACE,uBAAA;AAqdF;;AAndA;;;EAGE,uBAAA;AAsdF;;AApdA;EACE,kCAAA;AAudF;;AArdA;EAOE,oDAAA;EACA,mBAAA;EACA,sBAAA;EACA,qBAAA;EACA,8BAAA;EACA,6BAAA;EACA,kCAAA;EAEA,oDAAA;EACA,iBAAA;AAwdF;;AArdA;EACE,4BAAA;AAwdF;;AAtdA;EACE,4BAAA;AAydF;;AAtdA;;;EAGE,4BAAA;AAydF;;AAtdA;EACE,uCAAA;AAydF;;AAtdA;EAOE,oDAAA;EACA,mBAAA;EACA,sBAAA;EACA,qBAAA;EACA,8BAAA;EACA,6BAAA;EACA,uCAAA;EAEA,oDAAA;EACA,iBAAA;AAydF;;AAtdA;EACE,qBAAA;AAydF;;AAvdA;EACE,qBAAA;AA0dF;;AAxdA;;;EAGE,qBAAA;AA2dF;;AAzdA;EACE,gCAAA;AA4dF;;AA1dA;EAOE,oDAAA;EACA,mBAAA;EACA,sBAAA;EACA,qBAAA;EACA,8BAAA;EACA,6BAAA;EACA,gCAAA;EAEA,oDAAA;EACA,iBAAA;AA6dF;;AA1dA;EACE,0BAAA;AA6dF;;AA3dA;EACE,0BAAA;AA8dF;;AA3dA;;;EAGE,0BAAA;AA8dF;;AA3dA;EACE,qCAAA;AA8dF;;AA3dA;EAOE,oDAAA;EACA,mBAAA;EACA,sBAAA;EACA,qBAAA;EACA,8BAAA;EACA,6BAAA;EACA,qCAAA;EAEA,oDAAA;EACA,iBAAA;AA8dF;;AA3dA;EACE,sBAAA;AA8dF;;AA5dA;EACE,sBAAA;AA+dF;;AA7dA;;;EAGE,sBAAA;AAgeF;;AA9dA;EACE,iCAAA;AAieF;;AA/dA;EAOE,oDAAA;EACA,mBAAA;EACA,sBAAA;EACA,qBAAA;EACA,8BAAA;EACA,6BAAA;EACA,iCAAA;EAEA,oDAAA;EACA,iBAAA;AAkeF;;AA/dA;EACE,2BAAA;AAkeF;;AAheA;EACE,2BAAA;AAmeF;;AAheA;;;EAGE,2BAAA;AAmeF;;AAheA;EACE,sCAAA;AAmeF;;AAheA;EAOE,oDAAA;EACA,mBAAA;EACA,sBAAA;EACA,qBAAA;EACA,8BAAA;EACA,6BAAA;EACA,sCAAA;EAEA,oDAAA;EACA,iBAAA;AAmeF;;AAheA;EACE,yBAAA;AAmeF;;AAjeA;EACE,yBAAA;AAoeF;;AAleA;;;EAGE,yBAAA;AAqeF;;AAneA;EACE,oCAAA;AAseF;;AApeA;EAOE,oDAAA;EACA,mBAAA;EACA,sBAAA;EACA,qBAAA;EACA,8BAAA;EACA,6BAAA;EACA,oCAAA;EAEA,oDAAA;EACA,iBAAA;AAueF;;AApeA;EACE,8BAAA;AAueF;;AAreA;EACE,8BAAA;AAweF;;AAreA;;;EAGE,8BAAA;AAweF;;AAreA;EACE,yCAAA;AAweF;;AAreA;EAOE,oDAAA;EACA,mBAAA;EACA,sBAAA;EACA,qBAAA;EACA,8BAAA;EACA,6BAAA;EACA,yCAAA;EAEA,oDAAA;EACA,iBAAA;AAweF;;AAreA;EACE,yBAAA;AAweF;;AAteA;EACE,yBAAA;AAyeF;;AAveA;;;EAGE,yBAAA;AA0eF;;AAxeA;EACE,oCAAA;AA2eF;;AAzeA;EAOE,oDAAA;EACA,mBAAA;EACA,sBAAA;EACA,qBAAA;EACA,8BAAA;EACA,6BAAA;EACA,oCAAA;EAEA,oDAAA;EACA,iBAAA;AA4eF;;AAzeA;EACE,8BAAA;AA4eF;;AA1eA;EACE,8BAAA;AA6eF;;AA1eA;;;EAGE,8BAAA;AA6eF;;AA1eA;EACE,yCAAA;AA6eF;;AA1eA;EAOE,oDAAA;EACA,mBAAA;EACA,sBAAA;EACA,qBAAA;EACA,8BAAA;EACA,6BAAA;EACA,yCAAA;EAEA,oDAAA;EACA,iBAAA;AA6eF;;AA1eA;EACE,yBAAA;AA6eF;;AA3eA;EACE,yBAAA;AA8eF;;AA5eA;;;EAGE,yBAAA;AA+eF;;AA7eA;EACE,oCAAA;AAgfF;;AA9eA;EAOE,oDAAA;EACA,mBAAA;EACA,sBAAA;EACA,qBAAA;EACA,8BAAA;EACA,6BAAA;EACA,oCAAA;EAEA,oDAAA;EACA,iBAAA;AAifF;;AA9eA;EACE,8BAAA;AAifF;;AA/eA;EACE,8BAAA;AAkfF;;AA/eA;;;EAGE,8BAAA;AAkfF;;AA/eA;EACE,yCAAA;AAkfF;;AA/eA;EAOE,oDAAA;EACA,mBAAA;EACA,sBAAA;EACA,qBAAA;EACA,8BAAA;EACA,6BAAA;EACA,yCAAA;EAEA,oDAAA;EACA,iBAAA;AAkfF;;AA/eA;EACE,yBAAA;AAkfF;;AAhfA;EACE,yBAAA;AAmfF;;AAjfA;;;EAGE,yBAAA;AAofF;;AAlfA;EACE,oCAAA;AAqfF;;AAnfA;EAOE,oDAAA;EACA,mBAAA;EACA,sBAAA;EACA,qBAAA;EACA,8BAAA;EACA,6BAAA;EACA,oCAAA;EAEA,oDAAA;EACA,iBAAA;AAsfF;;AAnfA;EACE,8BAAA;AAsfF;;AApfA;EACE,8BAAA;AAufF;;AApfA;;;EAGE,8BAAA;AAufF;;AApfA;EACE,yCAAA;AAufF;;AApfA;EAOE,oDAAA;EACA,mBAAA;EACA,sBAAA;EACA,qBAAA;EACA,8BAAA;EACA,6BAAA;EACA,yCAAA;EAEA,oDAAA;EACA,iBAAA;AAufF;;AApfA;EACE,yBAAA;AAufF;;AArfA;EACE,yBAAA;AAwfF;;AAtfA;;;EAGE,yBAAA;AAyfF;;AAvfA;EACE,oCAAA;AA0fF;;AAxfA;EAOE,oDAAA;EACA,mBAAA;EACA,sBAAA;EACA,qBAAA;EACA,8BAAA;EACA,6BAAA;EACA,oCAAA;EAEA,oDAAA;EACA,iBAAA;AA2fF;;AAxfA;EACE,8BAAA;AA2fF;;AAzfA;EACE,8BAAA;AA4fF;;AAzfA;;;EAGE,8BAAA;AA4fF;;AAzfA;EACE,yCAAA;AA4fF;;AAzfA;EAOE,oDAAA;EACA,mBAAA;EACA,sBAAA;EACA,qBAAA;EACA,8BAAA;EACA,6BAAA;EACA,yCAAA;EAEA,oDAAA;EACA,iBAAA;AA4fF;;AAzfA;EACE,yBAAA;AA4fF;;AA1fA;EACE,yBAAA;AA6fF;;AA3fA;;;EAGE,yBAAA;AA8fF;;AA5fA;EACE,oCAAA;AA+fF;;AA7fA;EAOE,oDAAA;EACA,mBAAA;EACA,sBAAA;EACA,qBAAA;EACA,8BAAA;EACA,6BAAA;EACA,oCAAA;EAEA,oDAAA;EACA,iBAAA;AAggBF;;AA7fA;EACE,8BAAA;AAggBF;;AA9fA;EACE,8BAAA;AAigBF;;AA9fA;;;EAGE,8BAAA;AAigBF;;AA9fA;EACE,yCAAA;AAigBF;;AA9fA;EAOE,oDAAA;EACA,mBAAA;EACA,sBAAA;EACA,qBAAA;EACA,8BAAA;EACA,6BAAA;EACA,yCAAA;EAEA,oDAAA;EACA,iBAAA;AAigBF;;AA9fA;EACE,yBAAA;AAigBF;;AA/fA;EACE,yBAAA;AAkgBF;;AAhgBA;;;EAGE,yBAAA;AAmgBF;;AAjgBA;EACE,oCAAA;AAogBF;;AAlgBA;EAOE,oDAAA;EACA,mBAAA;EACA,sBAAA;EACA,qBAAA;EACA,8BAAA;EACA,6BAAA;EACA,oCAAA;EAEA,oDAAA;EACA,iBAAA;AAqgBF;;AAlgBA;EACE,8BAAA;AAqgBF;;AAngBA;EACE,8BAAA;AAsgBF;;AAngBA;;;EAGE,8BAAA;AAsgBF;;AAngBA;EACE,yCAAA;AAsgBF;;AAngBA;EAOE,oDAAA;EACA,mBAAA;EACA,sBAAA;EACA,qBAAA;EACA,8BAAA;EACA,6BAAA;EACA,yCAAA;EAEA,oDAAA;EACA,iBAAA;AAsgBF;;AAngBA;EACE,yBAAA;AAsgBF;;AApgBA;EACE,yBAAA;AAugBF;;AArgBA;;;EAGE,yBAAA;AAwgBF;;AAtgBA;EACE,oCAAA;AAygBF;;AAvgBA;EAOE,oDAAA;EACA,mBAAA;EACA,sBAAA;EACA,qBAAA;EACA,8BAAA;EACA,6BAAA;EACA,oCAAA;EAEA,oDAAA;EACA,iBAAA;AA0gBF;;AAvgBA;EACE,8BAAA;AA0gBF;;AAxgBA;EACE,8BAAA;AA2gBF;;AAxgBA;;;EAGE,8BAAA;AA2gBF;;AAxgBA;EACE,yCAAA;AA2gBF;;AAxgBA;EAOE,oDAAA;EACA,mBAAA;EACA,sBAAA;EACA,qBAAA;EACA,8BAAA;EACA,6BAAA;EACA,yCAAA;EAEA,oDAAA;EACA,iBAAA;AA2gBF;;AAxgBA;EACE,yBAAA;AA2gBF;;AAzgBA;EACE,yBAAA;AA4gBF;;AA1gBA;;;EAGE,yBAAA;AA6gBF;;AA3gBA;EACE,oCAAA;AA8gBF;;AA5gBA;EAOE,oDAAA;EACA,mBAAA;EACA,sBAAA;EACA,qBAAA;EACA,8BAAA;EACA,6BAAA;EACA,oCAAA;EAEA,oDAAA;EACA,iBAAA;AA+gBF;;AA5gBA;EACE,8BAAA;AA+gBF;;AA7gBA;EACE,8BAAA;AAghBF;;AA7gBA;;;EAGE,8BAAA;AAghBF;;AA7gBA;EACE,yCAAA;AAghBF;;AA7gBA;EAOE,qDAAA;EACA,mBAAA;EACA,sBAAA;EACA,qBAAA;EACA,8BAAA;EACA,6BAAA;EACA,yCAAA;EAEA,qDAAA;EACA,iBAAA;AAghBF;;AA7gBA;EACE,2BAAA;EACA,oDAAA;EACA,sCAAA;AAghBF;;AA9gBA;EACE,sCAAA;AAihBF;;AA/gBA;;;;;EAKE,sCAAA;AAkhBF;;AAhhBA;EACE,iDAAA;AAmhBF;;AAjhBA;EAOE,qDAAA;EACA,mBAAA;EACA,sBAAA;EACA,qBAAA;EACA,8BAAA;EACA,6BAAA;EACA,iDAAA;EAEA,qDAAA;EACA,iBAAA;AAohBF;;AAjhBA;EACE,2BAAA;EACA,mDAAA;EACA,qCAAA;AAohBF;;AAlhBA;EACE,qCAAA;AAqhBF;;AAnhBA;;;EAGE,qCAAA;AAshBF;;AAphBA;EACE,gDAAA;AAuhBF;;AArhBA;EAOE,qDAAA;EACA,mBAAA;EACA,sBAAA;EACA,qBAAA;EACA,8BAAA;EACA,6BAAA;EACA,gDAAA;EAEA,qDAAA;EACA,iBAAA;AAwhBF;;AArhBA;EACE,2BAAA;EACA,mDAAA;EACA,qCAAA;AAwhBF;;AAthBA;EACE,qCAAA;AAyhBF;;AAvhBA;;;EAGE,qCAAA;AA0hBF;;AAxhBA;EACE,gDAAA;AA2hBF;;AAzhBA;EAOE,qDAAA;EACA,mBAAA;EACA,sBAAA;EACA,qBAAA;EACA,8BAAA;EACA,6BAAA;EACA,gDAAA;EAEA,qDAAA;EACA,iBAAA;AA4hBF;;AAzhBA;EACE;IACE,2BAAA;IACA,mDAAA;IACA,qCAAA;EA4hBF;EA1hBA;IACE,qCAAA;EA4hBF;EA1hBA;;;IAGE,qCAAA;EA4hBF;EA1hBA;IACE,gDAAA;EA4hBF;EA1hBA;IAOE,qDAAA;IACA,mBAAA;IACA,sBAAA;IACA,qBAAA;IACA,8BAAA;IACA,6BAAA;IACA,gDAAA;IAEA,qDAAA;IACA,iBAAA;EA4hBF;AACF;AA1hBA;EACE,2BAAA;EACA,mDAAA;EACA,qCAAA;AA4hBF;;AA1hBA;EACE,qCAAA;AA6hBF;;AA3hBA;;;EAGE,qCAAA;AA8hBF;;AA5hBA;EACE,gDAAA;AA+hBF;;AA7hBA;EAOE,qDAAA;EACA,mBAAA;EACA,sBAAA;EACA,qBAAA;EACA,8BAAA;EACA,6BAAA;EACA,gDAAA;EAEA,qDAAA;EACA,iBAAA;AAgiBF;;AA7hBA;EACE,2BAAA;EACA,qDAAA;EACA,uCAAA;AAgiBF;;AA9hBA;EACE,uCAAA;AAiiBF;;AA/hBA;;;EAGE,uCAAA;AAkiBF;;AAhiBA;EACE,kDAAA;AAmiBF;;AAjiBA;EAOE,qDAAA;EACA,mBAAA;EACA,sBAAA;EACA,qBAAA;EACA,8BAAA;EACA,6BAAA;EACA,kDAAA;EAEA,qDAAA;EACA,iBAAA;AAoiBF;;AAjiBA;EACE,2BAAA;EACA,oDAAA;EACA,sCAAA;AAoiBF;;AAliBA;EACE,sCAAA;AAqiBF;;AAniBA;;;;;EAKE,sCAAA;AAsiBF;;AApiBA;EACE,iDAAA;AAuiBF;;AAriBA;EAOE,qDAAA;EACA,mBAAA;EACA,sBAAA;EACA,qBAAA;EACA,8BAAA;EACA,6BAAA;EACA,iDAAA;EAEA,qDAAA;EACA,iBAAA;AAwiBF;;AAtiBA;EACE,2BAAA;EACA,mDAAA;EACA,qCAAA;AAyiBF;;AAviBA;EACE,qCAAA;AA0iBF;;AAxiBA;;;EAGE,qCAAA;AA2iBF;;AAziBA;EACE,gDAAA;AA4iBF;;AA1iBA;EAOE,qDAAA;EACA,mBAAA;EACA,sBAAA;EACA,qBAAA;EACA,8BAAA;EACA,6BAAA;EACA,gDAAA;EAEA,qDAAA;EACA,iBAAA;AA6iBF;;AA3iBA;EACE,2BAAA;EACA,mDAAA;EACA,qCAAA;AA8iBF;;AA5iBA;EACE,qCAAA;AA+iBF;;AA7iBA;;;EAGE,qCAAA;AAgjBF;;AA9iBA;EACE,gDAAA;AAijBF;;AA/iBA;EAOE,qDAAA;EACA,mBAAA;EACA,sBAAA;EACA,qBAAA;EACA,8BAAA;EACA,6BAAA;EACA,gDAAA;EAEA,qDAAA;EACA,iBAAA;AAkjBF;;AAhjBA;EACE,2BAAA;EACA,qDAAA;EACA,uCAAA;AAmjBF;;AAjjBA;EACE,uCAAA;AAojBF;;AAljBA;;;EAGE,uCAAA;AAqjBF;;AAnjBA;EACE,kDAAA;AAsjBF;;AApjBA;EAOE,qDAAA;EACA,mBAAA;EACA,sBAAA;EACA,qBAAA;EACA,8BAAA;EACA,6BAAA;EACA,kDAAA;EAEA,qDAAA;EACA,iBAAA;AAujBF;;AApjBA;EACE,2BAAA;EACA,sCAAA;AAujBF;;AArjBA;EACE,sCAAA;AAwjBF;;AAtjBA;;;;;EAKE,sCAAA;AAyjBF;;AAvjBA;EACE,iDAAA;AA0jBF;;AAxjBA;EAOE,qDAAA;EACA,mBAAA;EACA,sBAAA;EACA,qBAAA;EACA,8BAAA;EACA,6BAAA;EACA,iDAAA;EAEA,qDAAA;EACA,iBAAA;AA2jBF;;AAzjBA;EACE,2BAAA;EACA,qCAAA;AA4jBF;;AA1jBA;EACE,qCAAA;AA6jBF;;AA3jBA;;;EAGE,qCAAA;AA8jBF;;AA5jBA;EACE,gDAAA;AA+jBF;;AA7jBA;EAOE,qDAAA;EACA,mBAAA;EACA,sBAAA;EACA,qBAAA;EACA,8BAAA;EACA,6BAAA;EACA,gDAAA;EAEA,qDAAA;EACA,iBAAA;AAgkBF;;AA9jBA;EACE,2BAAA;EACA,qCAAA;AAikBF;;AA/jBA;EACE,qCAAA;AAkkBF;;AAhkBA;;;EAGE,qCAAA;AAmkBF;;AAjkBA;EACE,gDAAA;AAokBF;;AAlkBA;EAOE,qDAAA;EACA,mBAAA;EACA,sBAAA;EACA,qBAAA;EACA,8BAAA;EACA,6BAAA;EACA,gDAAA;EAEA,qDAAA;EACA,iBAAA;AAqkBF;;AAnkBA;EACE,2BAAA;EACA,uCAAA;AAskBF;;AApkBA;EACE,uCAAA;AAukBF;;AArkBA;;;EAGE,uCAAA;AAwkBF;;AAtkBA;EACE,kDAAA;AAykBF;;AAvkBA;EAOE,qDAAA;EACA,mBAAA;EACA,sBAAA;EACA,qBAAA;EACA,8BAAA;EACA,6BAAA;EACA,kDAAA;EAEA,qDAAA;EACA,iBAAA;AA0kBF;;AAvkBA;EACE,2BAAA;EACA,mCAAA;EACA,gCAAA;AA0kBF;;AAxkBA;EACE,gCAAA;AA2kBF;;AAzkBA;;;;;EAKE,gCAAA;AA4kBF;;AA1kBA;EACE,2CAAA;AA6kBF;;AA3kBA;EAOE,qDAAA;EACA,mBAAA;EACA,sBAAA;EACA,qBAAA;EACA,8BAAA;EACA,6BAAA;EACA,2CAAA;EAEA,qDAAA;EACA,iBAAA;AA8kBF;;AA3kBA;EACE,2BAAA;EACA,mCAAA;EACA,gCAAA;AA8kBF;;AA5kBA;EACE,gCAAA;AA+kBF;;AA7kBA;;;EAGE,gCAAA;AAglBF;;AA9kBA;EACE,2CAAA;AAilBF;;AA/kBA;EAOE,qDAAA;EACA,mBAAA;EACA,sBAAA;EACA,qBAAA;EACA,8BAAA;EACA,6BAAA;EACA,2CAAA;EAEA,qDAAA;EACA,iBAAA;AAklBF;;AA/kBA;EACE,2BAAA;EACA,mCAAA;EACA,gCAAA;AAklBF;;AAhlBA;EACE,gCAAA;AAmlBF;;AAjlBA;;;EAGE,gCAAA;AAolBF;;AAllBA;EACE,2CAAA;AAqlBF;;AAnlBA;EAOE,qDAAA;EACA,mBAAA;EACA,sBAAA;EACA,qBAAA;EACA,8BAAA;EACA,6BAAA;EACA,2CAAA;EAEA,qDAAA;EACA,iBAAA;AAslBF;;AAnlBA;EACE,2BAAA;EACA,mCAAA;EACA,gCAAA;AAslBF;;AAplBA;EACE,gCAAA;AAulBF;;AArlBA;;;EAGE,gCAAA;AAwlBF;;AAtlBA;EACE,2CAAA;AAylBF;;AAvlBA;EAOE,qDAAA;EACA,mBAAA;EACA,sBAAA;EACA,qBAAA;EACA,8BAAA;EACA,6BAAA;EACA,2CAAA;EAEA,qDAAA;EACA,iBAAA;AA0lBF;;AAvlBA;EACE,2BAAA;EACA,mCAAA;EACA,gCAAA;AA0lBF;;AAxlBA;EACE,gCAAA;AA2lBF;;AAzlBA;;;;;EAKE,gCAAA;AA4lBF;;AA1lBA;EACE,2CAAA;AA6lBF;;AA3lBA;EAOE,qDAAA;EACA,mBAAA;EACA,sBAAA;EACA,qBAAA;EACA,8BAAA;EACA,6BAAA;EACA,2CAAA;EAEA,qDAAA;EACA,iBAAA;AA8lBF;;AA5lBA;EACE,2BAAA;EACA,mCAAA;EACA,gCAAA;AA+lBF;;AA7lBA;EACE,gCAAA;AAgmBF;;AA9lBA;;;EAGE,gCAAA;AAimBF;;AA/lBA;EACE,2CAAA;AAkmBF;;AAhmBA;EAOE,qDAAA;EACA,mBAAA;EACA,sBAAA;EACA,qBAAA;EACA,8BAAA;EACA,6BAAA;EACA,2CAAA;EAEA,qDAAA;EACA,iBAAA;AAmmBF;;AAjmBA;EACE,2BAAA;EACA,mCAAA;EACA,gCAAA;AAomBF;;AAlmBA;EACE,gCAAA;AAqmBF;;AAnmBA;;;EAGE,gCAAA;AAsmBF;;AApmBA;EACE,2CAAA;AAumBF;;AArmBA;EAOE,qDAAA;EACA,mBAAA;EACA,sBAAA;EACA,qBAAA;EACA,8BAAA;EACA,6BAAA;EACA,2CAAA;EAEA,qDAAA;EACA,iBAAA;AAwmBF;;AAtmBA;EACE,2BAAA;EACA,mCAAA;EACA,gCAAA;AAymBF;;AAvmBA;EACE,gCAAA;AA0mBF;;AAxmBA;;;EAGE,gCAAA;AA2mBF;;AAzmBA;EACE,2CAAA;AA4mBF;;AA1mBA;EAOE,qDAAA;EACA,mBAAA;EACA,sBAAA;EACA,qBAAA;EACA,8BAAA;EACA,6BAAA;EACA,2CAAA;EAEA,qDAAA;EACA,iBAAA;AA6mBF;;AA3mBA;EACE,2BAAA;EACA,mCAAA;EACA,gCAAA;AA8mBF;;AA5mBA;EACE,gCAAA;AA+mBF;;AA7mBA;;;EAGE,gCAAA;AAgnBF;;AA9mBA;EACE,2CAAA;AAinBF;;AA/mBA;EAOE,qDAAA;EACA,mBAAA;EACA,sBAAA;EACA,qBAAA;EACA,8BAAA;EACA,6BAAA;EACA,2CAAA;EAEA,qDAAA;EACA,iBAAA;AAknBF;;AA/mBA;EACE,2BAAA;EACA,yCAAA;EACA,wBAAA;AAknBF;;AAhnBA;EACE,wBAAA;AAmnBF;;AAjnBA;;;EAGE,wBAAA;AAonBF;;AAlnBA;EACE,mCAAA;AAqnBF;;AAnnBA;EAOE,oDAAA;EACA,mBAAA;EACA,sBAAA;EACA,qBAAA;EACA,8BAAA;EACA,6BAAA;EACA,mCAAA;EAEA,oDAAA;EACA,iBAAA;AAsnBF;;AAnnBA;EACE,2BAAA;EACA,yCAAA;EACA,wBAAA;AAsnBF;;AApnBA;EACE,wBAAA;AAunBF;;AArnBA;;;EAGE,wBAAA;AAwnBF;;AAtnBA;EACE,mCAAA;AAynBF;;AAvnBA;EAOE,oDAAA;EACA,mBAAA;EACA,sBAAA;EACA,qBAAA;EACA,8BAAA;EACA,6BAAA;EACA,mCAAA;EAEA,oDAAA;EACA,iBAAA;AA0nBF;;AAvnBA;EACE,2BAAA;EACA,yCAAA;EACA,wBAAA;AA0nBF;;AAxnBA;EACE,wBAAA;AA2nBF;;AAznBA;;;;;EAKE,wBAAA;AA4nBF;;AA1nBA;EACE,mCAAA;AA6nBF;;AA3nBA;EAOE,oDAAA;EACA,mBAAA;EACA,sBAAA;EACA,qBAAA;EACA,8BAAA;EACA,6BAAA;EACA,mCAAA;EAEA,oDAAA;EACA,iBAAA;AA8nBF;;AA3nBA;EACE,2BAAA;EACA,yCAAA;EACA,wBAAA;AA8nBF;;AA5nBA;EACE,wBAAA;AA+nBF;;AA7nBA;;;EAGE,wBAAA;AAgoBF;;AA9nBA;EACE,mCAAA;AAioBF;;AA/nBA;EAOE,oDAAA;EACA,mBAAA;EACA,sBAAA;EACA,qBAAA;EACA,8BAAA;EACA,6BAAA;EACA,mCAAA;EAEA,oDAAA;EACA,iBAAA;AAkoBF;;AA/nBA;EACE,2BAAA;EACA,yCAAA;EACA,wBAAA;AAkoBF;;AAhoBA;EACE,wBAAA;AAmoBF;;AAjoBA;;;EAGE,wBAAA;AAooBF;;AAloBA;EACE,mCAAA;AAqoBF;;AAnoBA;EAOE,oDAAA;EACA,mBAAA;EACA,sBAAA;EACA,qBAAA;EACA,8BAAA;EACA,6BAAA;EACA,mCAAA;EAEA,oDAAA;EACA,iBAAA;AAsoBF;;AApoBA;EACE,2BAAA;EACA,yCAAA;EACA,wBAAA;AAuoBF;;AAroBA;EACE,wBAAA;AAwoBF;;AAtoBA;;;EAGE,wBAAA;AAyoBF;;AAvoBA;EACE,mCAAA;AA0oBF;;AAxoBA;EAOE,oDAAA;EACA,mBAAA;EACA,sBAAA;EACA,qBAAA;EACA,8BAAA;EACA,6BAAA;EACA,mCAAA;EAEA,oDAAA;EACA,iBAAA;AA2oBF;;AAzoBA;EACE,2BAAA;EACA,yCAAA;EACA,wBAAA;AA4oBF;;AA1oBA;EACE,wBAAA;AA6oBF;;AA3oBA;;;;;EAKE,wBAAA;AA8oBF;;AA5oBA;EACE,mCAAA;AA+oBF;;AA7oBA;EAOE,oDAAA;EACA,mBAAA;EACA,sBAAA;EACA,qBAAA;EACA,8BAAA;EACA,6BAAA;EACA,mCAAA;EAEA,oDAAA;EACA,iBAAA;AAgpBF;;AA9oBA;EACE,2BAAA;EACA,yCAAA;EACA,wBAAA;AAipBF;;AA/oBA;EACE,wBAAA;AAkpBF;;AAhpBA;;;EAGE,wBAAA;AAmpBF;;AAjpBA;EACE,mCAAA;AAopBF;;AAlpBA;EAOE,oDAAA;EACA,mBAAA;EACA,sBAAA;EACA,qBAAA;EACA,8BAAA;EACA,6BAAA;EACA,mCAAA;EAEA,oDAAA;EACA,iBAAA;AAqpBF;;AAlpBA;EACE,2BAAA;EACA,wBAAA;AAqpBF;;AAnpBA;EACE,wBAAA;AAspBF;;AAppBA;;;;;EAKE,wBAAA;AAupBF;;AArpBA;EACE,mCAAA;AAwpBF;;AAtpBA;EAOE,oDAAA;EACA,mBAAA;EACA,sBAAA;EACA,qBAAA;EACA,8BAAA;EACA,6BAAA;EACA,mCAAA;EAEA,oDAAA;EACA,iBAAA;AAypBF;;AAtpBA;EACE,2BAAA;EACA,wBAAA;AAypBF;;AAvpBA;EACE,wBAAA;AA0pBF;;AAxpBA;;;EAGE,wBAAA;AA2pBF;;AAzpBA;EACE,mCAAA;AA4pBF;;AA1pBA;EAOE,oDAAA;EACA,mBAAA;EACA,sBAAA;EACA,qBAAA;EACA,8BAAA;EACA,6BAAA;EACA,mCAAA;EAEA,oDAAA;EACA,iBAAA;AA6pBF;;AA1pBA;EACE,2BAAA;EACA,wBAAA;AA6pBF;;AA3pBA;EACE,wBAAA;AA8pBF;;AA5pBA;;;EAGE,wBAAA;AA+pBF;;AA7pBA;EACE,mCAAA;AAgqBF;;AA9pBA;EAOE,oDAAA;EACA,mBAAA;EACA,sBAAA;EACA,qBAAA;EACA,8BAAA;EACA,6BAAA;EACA,mCAAA;EAEA,oDAAA;EACA,iBAAA;AAiqBF;;AA9pBA;EACE,2BAAA;EACA,wBAAA;AAiqBF;;AA/pBA;EACE,wBAAA;AAkqBF;;AAhqBA;;;EAGE,wBAAA;AAmqBF;;AAjqBA;EACE,mCAAA;AAoqBF;;AAlqBA;EAOE,oDAAA;EACA,mBAAA;EACA,sBAAA;EACA,qBAAA;EACA,8BAAA;EACA,6BAAA;EACA,mCAAA;EAEA,oDAAA;EACA,iBAAA;AAqqBF;;AAlqBA;EACE,2BAAA;EACA,wBAAA;AAqqBF;;AAnqBA;EACE,wBAAA;AAsqBF;;AApqBA;;;;;EAKE,wBAAA;AAuqBF;;AArqBA;EACE,mCAAA;AAwqBF;;AAtqBA;EAOE,oDAAA;EACA,mBAAA;EACA,sBAAA;EACA,qBAAA;EACA,8BAAA;EACA,6BAAA;EACA,mCAAA;EAEA,oDAAA;EACA,iBAAA;AAyqBF;;AAvqBA;EACE,2BAAA;EACA,wBAAA;AA0qBF;;AAxqBA;EACE,wBAAA;AA2qBF;;AAzqBA;;;EAGE,wBAAA;AA4qBF;;AA1qBA;EACE,mCAAA;AA6qBF;;AA3qBA;EAOE,oDAAA;EACA,mBAAA;EACA,sBAAA;EACA,qBAAA;EACA,8BAAA;EACA,6BAAA;EACA,mCAAA;EAEA,oDAAA;EACA,iBAAA;AA8qBF;;AA5qBA;EACE,2BAAA;EACA,wBAAA;AA+qBF;;AA7qBA;EACE,wBAAA;AAgrBF;;AA9qBA;;;EAGE,wBAAA;AAirBF;;AA/qBA;EACE,mCAAA;AAkrBF;;AAhrBA;EAOE,oDAAA;EACA,mBAAA;EACA,sBAAA;EACA,qBAAA;EACA,8BAAA;EACA,6BAAA;EACA,mCAAA;EAEA,oDAAA;EACA,iBAAA;AAmrBF;;AAjrBA;EACE,2BAAA;EACA,wBAAA;AAorBF;;AAlrBA;EACE,wBAAA;AAqrBF;;AAnrBA;;;EAGE,wBAAA;AAsrBF;;AAprBA;EACE,mCAAA;AAurBF;;AArrBA;EAOE,oDAAA;EACA,mBAAA;EACA,sBAAA;EACA,qBAAA;EACA,8BAAA;EACA,6BAAA;EACA,mCAAA;EAEA,oDAAA;EACA,iBAAA;AAwrBF;;AArrBA;EACE,2BAAA;EACA,qBAAA;AAwrBF;;AAtrBA;EACE,qBAAA;AAyrBF;;AAvrBA;;;;;EAKE,qBAAA;AA0rBF;;AAxrBA;EACE,gCAAA;AA2rBF;;AAzrBA;EAOE,oDAAA;EACA,mBAAA;EACA,sBAAA;EACA,qBAAA;EACA,8BAAA;EACA,6BAAA;EACA,gCAAA;EAEA,oDAAA;EACA,iBAAA;AA4rBF;;AA1rBA;EACE,2BAAA;EACA,qBAAA;AA6rBF;;AA3rBA;EACE,qBAAA;AA8rBF;;AA5rBA;;;EAGE,qBAAA;AA+rBF;;AA7rBA;EACE,gCAAA;AAgsBF;;AA9rBA;EAOE,oDAAA;EACA,mBAAA;EACA,sBAAA;EACA,qBAAA;EACA,8BAAA;EACA,6BAAA;EACA,gCAAA;EAEA,oDAAA;EACA,iBAAA;AAisBF;;AA/rBA;EACE,2BAAA;EACA,qBAAA;AAksBF;;AAhsBA;EACE,qBAAA;AAmsBF;;AAjsBA;;;EAGE,qBAAA;AAosBF;;AAlsBA;EACE,gCAAA;AAqsBF;;AAnsBA;EAOE,oDAAA;EACA,mBAAA;EACA,sBAAA;EACA,qBAAA;EACA,8BAAA;EACA,6BAAA;EACA,gCAAA;EAEA,oDAAA;EACA,iBAAA;AAssBF;;AApsBA;EACE,2BAAA;EACA,qBAAA;AAusBF;;AArsBA;EACE,qBAAA;AAwsBF;;AAtsBA;;;EAGE,qBAAA;AAysBF;;AAvsBA;EACE,gCAAA;AA0sBF;;AAxsBA;EAOE,oDAAA;EACA,mBAAA;EACA,sBAAA;EACA,qBAAA;EACA,8BAAA;EACA,6BAAA;EACA,gCAAA;EAEA,oDAAA;EACA,iBAAA;AA2sBF;;AAxsBA;EACE,2BAAA;EACA,wBAAA;AA2sBF;;AAzsBA;EACE,wBAAA;AA4sBF;;AAzsBA;EACE,2BAAA;EACA,wBAAA;AA4sBF;;AA1sBA;EACE,wBAAA;AA6sBF;;AA1sBA;EACE,2BAAA;EACA,wBAAA;AA6sBF;;AA3sBA;EACE,wBAAA;AA8sBF;;AA3sBA;EACE,2BAAA;EACA,wBAAA;AA8sBF;;AA5sBA;EACE,wBAAA;AA+sBF;;AA5sBA;EACE,2BAAA;EACA,wBAAA;AA+sBF;;AA7sBA;EACE,wBAAA;AAgtBF;;AA9sBA;EACE,2BAAA;EACA,wBAAA;AAitBF;;AA/sBA;EACE,wBAAA;AAktBF;;AAhtBA;EACE,2BAAA;EACA,wBAAA;AAmtBF;;AAjtBA;EACE,wBAAA;AAotBF;;AAltBA;EACE,2BAAA;EACA,wBAAA;AAqtBF;;AAntBA;EACE,wBAAA;AAstBF;;AAntBA;EACE,2BAAA;AAstBF;;AAptBA;;;;;EAKE,wBAAA;AAutBF;;AAptBA;EACE,2BAAA;AAutBF;;AArtBA;;;EAGE,wBAAA;AAwtBF;;AArtBA;EACE,2BAAA;AAwtBF;;AAttBA;;;EAGE,wBAAA;AAytBF;;AAttBA;EACE,2BAAA;AAytBF;;AAvtBA;;;EAGE,wBAAA;AA0tBF;;AAvtBA;EACE,2BAAA;AA0tBF;;AAxtBA;;;;;EAKE,wBAAA;AA2tBF;;AAztBA;EACE,2BAAA;AA4tBF;;AA1tBA;;;EAGE,wBAAA;AA6tBF;;AA3tBA;EACE,2BAAA;AA8tBF;;AA5tBA;;;EAGE,wBAAA;AA+tBF;;AA7tBA;EACE,2BAAA;AAguBF;;AA9tBA;;;EAGE,wBAAA;AAiuBF;;AA9tBA;EACE,2BAAA;AAiuBF;;AA/tBA;EACE,mCAAA;AAkuBF;;AA/tBA;EACE,2BAAA;AAkuBF;;AAhuBA;EACE,mCAAA;AAmuBF;;AAhuBA;EACE,2BAAA;AAmuBF;;AAjuBA;EACE,mCAAA;AAouBF;;AAjuBA;EACE,2BAAA;AAouBF;;AAluBA;EACE,mCAAA;AAquBF;;AAluBA;EACE,2BAAA;AAquBF;;AAnuBA;EACE,mCAAA;AAsuBF;;AApuBA;EACE,2BAAA;AAuuBF;;AAruBA;EACE,mCAAA;AAwuBF;;AAtuBA;EACE,2BAAA;AAyuBF;;AAvuBA;EACE,mCAAA;AA0uBF;;AAxuBA;EACE,2BAAA;AA2uBF;;AAzuBA;EACE,mCAAA;AA4uBF;;AAzuBA;EACE,2BAAA;AA4uBF;;AA1uBA;EAOE,oDAAA;EACA,mBAAA;EACA,sBAAA;EACA,qBAAA;EACA,8BAAA;EACA,6BAAA;EACA,mCAAA;EAEA,oDAAA;EACA,iBAAA;AA6uBF;;AA1uBA;EACE,2BAAA;AA6uBF;;AA3uBA;EAOE,oDAAA;EACA,mBAAA;EACA,sBAAA;EACA,qBAAA;EACA,8BAAA;EACA,6BAAA;EACA,mCAAA;EAEA,oDAAA;EACA,iBAAA;AA8uBF;;AA3uBA;EACE,2BAAA;AA8uBF;;AA5uBA;EAOE,oDAAA;EACA,mBAAA;EACA,sBAAA;EACA,qBAAA;EACA,8BAAA;EACA,6BAAA;EACA,mCAAA;EAEA,oDAAA;EACA,iBAAA;AA+uBF;;AA5uBA;EACE,2BAAA;AA+uBF;;AA7uBA;EAOE,oDAAA;EACA,mBAAA;EACA,sBAAA;EACA,qBAAA;EACA,8BAAA;EACA,6BAAA;EACA,mCAAA;EAEA,oDAAA;EACA,iBAAA;AAgvBF;;AA7uBA;EACE,2BAAA;AAgvBF;;AA9uBA;EAOE,oDAAA;EACA,mBAAA;EACA,sBAAA;EACA,qBAAA;EACA,8BAAA;EACA,6BAAA;EACA,mCAAA;EAEA,oDAAA;EACA,iBAAA;AAivBF;;AA/uBA;EACE,2BAAA;AAkvBF;;AAhvBA;EAOE,oDAAA;EACA,mBAAA;EACA,sBAAA;EACA,qBAAA;EACA,8BAAA;EACA,6BAAA;EACA,mCAAA;EAEA,oDAAA;EACA,iBAAA;AAmvBF;;AAjvBA;EACE,2BAAA;AAovBF;;AAlvBA;EAOE,oDAAA;EACA,mBAAA;EACA,sBAAA;EACA,qBAAA;EACA,8BAAA;EACA,6BAAA;EACA,mCAAA;EAEA,oDAAA;EACA,iBAAA;AAqvBF;;AAnvBA;EACE,2BAAA;AAsvBF;;AApvBA;EAOE,oDAAA;EACA,mBAAA;EACA,sBAAA;EACA,qBAAA;EACA,8BAAA;EACA,6BAAA;EACA,mCAAA;EAEA,oDAAA;EACA,iBAAA;AAuvBF;;AApvBA;EACE,aAAA;EACA,mBAAA;AAuvBF;;AArvBA;EACE,kBAAA;EACA,aAAA;EACA,mBAAA;EACA,2BAAA;EACA,WAAA;EACA,aAAA;EACA,oBAAA;EACA,gBAAA;EACA,gBAAA;EACA,2BAAA;EACA,gCAAA;AAwvBF;;AAtvBA;EACE,YAAA;AAyvBF;;AAvvBA;EACE,aAAA;AA0vBF;;AAxvBA;EACE,wBAAA;EACA,gCAAA;AA2vBF;;AAxvBA;EACE,eAAA;AA2vBF;;AAzvBA;EACE,aAAA;EACA,8BAAA;EACA,oBAAA;EACA,eAAA;EACA,gBAAA;EACA,kBAAA;EACA,+BAAA;EACA,oCCpkhCQ;EDqkhCR,oDAAA;AA4vBF;;AA1vBA;EACE,aAAA;EACA,mBAAA;EACA,cAAA;EACA,cAAA;AA6vBF;;AA3vBA;EACE,uBAAA;EACA,uBAAA;AA8vBF;;AA5vBA;EACE,qBAAA;EACA,cAAA;AA+vBF;;AA7vBA;EACE,kBAAA;EACA,yBAAA;EACA,cAAA;AAgwBF;;AA9vBA;EACE,cAAA;AAiwBF;;AA/vBA;EACE,yBAAA;AAkwBF;;AAhwBA;EACE,YAAA;EACA,WAAA;AAmwBF;;AAjwBA;;EAEE,gBAAA;EACA,mBAAA;EACA,0BAAA;AAowBF;;AAlwBA;EACE,qBAAA;EACA,eAAA;AAqwBF;;AAnwBA;EACE,2BAAA;EACA,eAAA;AAswBF;;AApwBA;EACE,gBAAA;AAuwBF;;AArwBA;EACE,aAAA;EACA,mBAAA;EACA,gBAAA;EACA,eAAA;AAwwBF;;AAtwBA;EACE,qBAAA;EACA,2BAAA;EACA,yBC3nhCU;ADo4iCZ;;AAvwBA;EACE,qBAAA;EACA,+BAAA;EACA,uCAAA;EACA,iDAAA;AA0wBF;;AAxwBA;EACE,kBAAA;EACA,cAAA;AA2wBF;;AAzwBA;;;EAGE,eAAA;EACA,gBAAA;AA4wBF;;AA1wBA;;;EAGE,cAAA;EACA,iBAAA;AA6wBF;;AA3wBA;;;EAGE,UAAA;AA8wBF;;AA5wBA;EACE,gBAAA;EACA,gDAAA;AA+wBF;;AA7wBA;EACE,uDAAA;AAgxBF;;AA9wBA;EACE,oDAAA;AAixBF;;AA/wBA;EACE,gBAAA;EACA,wCAAA;AAkxBF;;AAhxBA;EACE,2BAAA;AAmxBF;;AAjxBA;EACE,wBAAA;AAoxBF;;AAlxBA;EACE,qCAAA;EACA,SAAA;AAqxBF;;AAnxBA;EACE,oBAAA;EACA,2BAAA;EACA,wCAAA;AAsxBF;;AApxBA;EACE,2BAAA;AAuxBF;;AArxBA;EACE,wBAAA;AAwxBF;;AAtxBA;EACE,oBAAA;AAyxBF;;AAvxBA;EACE,2BAAA;AA0xBF;;AAxxBA;EACE,wBAAA;AA2xBF;;AAzxBA;EACE,oBAAA;AA4xBF;;AAzxBA;EACE,uCAAA;AA4xBF;;AA1xBA;EACE,sCAAA;AA6xBF;;AA3xBA;EACE,sCAAA;AA8xBF;;AA5xBA;EACE,0CAAA;AA+xBF;;AA7xBA;EACE,sCAAA;AAgyBF;;AA9xBA;EACE,yBAAA;EACA,4BAAA;EACA,oBAAA;AAiyBF;;AA/xBA;EACE,SAAA;EACA,oBAAA;AAkyBF;;AAhyBA;EACE;IACE,uCAAA;EAmyBF;EAjyBA;IACE,sCAAA;EAmyBF;EAjyBA;IACE,sCAAA;EAmyBF;EAjyBA;IACE,0CAAA;EAmyBF;EAjyBA;IACE,sCAAA;EAmyBF;EAjyBA;IACE,yBAAA;IACA,4BAAA;IACA,oBAAA;EAmyBF;EAjyBA;IACE,SAAA;IACA,oBAAA;EAmyBF;AACF;AAjyBA;EACE;IACE,uCAAA;EAmyBF;EAjyBA;IACE,sCAAA;EAmyBF;EAjyBA;IACE,sCAAA;EAmyBF;EAjyBA;IACE,0CAAA;EAmyBF;EAjyBA;IACE,sCAAA;EAmyBF;EAjyBA;IACE,yBAAA;IACA,4BAAA;IACA,oBAAA;EAmyBF;EAjyBA;IACE,SAAA;IACA,oBAAA;EAmyBF;AACF;AAjyBA;EACE;IACE,uCAAA;EAmyBF;EAjyBA;IACE,sCAAA;EAmyBF;EAjyBA;IACE,sCAAA;EAmyBF;EAjyBA;IACE,0CAAA;EAmyBF;EAjyBA;IACE,sCAAA;EAmyBF;EAjyBA;IACE,yBAAA;IACA,4BAAA;IACA,oBAAA;EAmyBF;EAjyBA;IACE,SAAA;IACA,oBAAA;EAmyBF;AACF;AAjyBA;EACE;IACE,uCAAA;EAmyBF;EAjyBA;IACE,sCAAA;EAmyBF;EAjyBA;IACE,sCAAA;EAmyBF;EAjyBA;IACE,0CAAA;EAmyBF;EAjyBA;IACE,sCAAA;EAmyBF;EAjyBA;IACE,yBAAA;IACA,4BAAA;IACA,oBAAA;EAmyBF;EAjyBA;IACE,SAAA;IACA,oBAAA;EAmyBF;AACF;AAjyBA;EACE;IACE,uCAAA;EAmyBF;EAjyBA;IACE,sCAAA;EAmyBF;EAjyBA;IACE,sCAAA;EAmyBF;EAjyBA;IACE,0CAAA;EAmyBF;EAjyBA;IACE,sCAAA;EAmyBF;EAjyBA;IACE,yBAAA;IACA,4BAAA;IACA,oBAAA;EAmyBF;EAjyBA;IACE,SAAA;IACA,oBAAA;EAmyBF;AACF;AAhyBA;EACE,gCAAA;AAkyBF;;AA/xBA;EACE,gCAAA;EACA,iCAAA;AAkyBF;;AA/xBA;EACE,qCAAA;AAkyBF;;AA/xBA;EACE,4BAAA;EACA,+BAAA;AAkyBF;;AA/xBA;EACE,uBAAA;AAkyBF;;AA/xBA;EACE,gCAAA;EACA,mCAAA;AAkyBF;;AA/xBA;EACE,iCAAA;EACA,oCAAA;AAkyBF;;AA/xBA;EACE,gCAAA;EACA,iCAAA;AAkyBF;;AA/xBA;EACE,mCAAA;EACA,oCAAA;AAkyBF;;AA/xBA;EACE;IACE,mBAAA;IACA,sBAAA;EAkyBF;AACF;AAhyBA;EACE,sBAAA;AAkyBF;;AA/xBA;EACE,aAAA;EACA,mBAAA;EACA,6BAAA;EACA,UAAA;EACA,SAAA;AAkyBF;;AAhyBA;EACE,aAAA;EACA,mBAAA;EACA,oBAAA;AAmyBF;;AAjyBA;EACE,gBAAA;AAoyBF;;AAlyBA;EACE,oBAAA;EACA,YAAA;AAqyBF;;AAnyBA;EACE,aAAA;AAsyBF;;AApyBA;EACE,eAAA;AAuyBF;;AAryBA;EACE,aAAA;AAwyBF;;AAryBA;EACE,YAAA;AAwyBF;;AAryBA;EACE,YAAA;AAwyBF;;AAryBA;EACE,aAAA;AAwyBF;;AAryBA;EACE,oCAAA;EACA,wBAAA;AAwyBF;;AAtyBA;EACE,gBAAA;AAyyBF;;AAvyBA;EACE,SAAA;EACA,gDAAA;AA0yBF;;AAxyBA;EACE,iDAAA;AA2yBF;;AAzyBA;EACE,gDAAA;AA4yBF;;AA1yBA;EACE,SAAA;EACA,gBAAA;EACA,0BAAA;EACA,2BAAA;EACA,qBAAA;EACA,gBAAA;AA6yBF;;AA3yBA;EACE,oCAAA;AA8yBF;;AA5yBA;EACE,qCAAA;AA+yBF;;AA7yBA;EACE,gBAAA;EACA,gBAAA;EACA,gBAAA;EACA,YAAA;EACA,eAAA;EACA,6BAAA;EACA,wBAAA;EACA,SAAA;EACA,UAAA;AAgzBF;;AA9yBA;EACE,oBAAA;EACA,mBAAA;AAizBF;;AA/yBA;EACE,sCAAA;EACA,0BAAA;AAkzBF;;AAhzBA;EACE,oCAAA;EACA,2BAAA;AAmzBF;;AAhzBA;EACE,6BAAA;EACA,SAAA;EACA,gBAAA;EACA,yBAAA;UAAA,iBAAA;EACA,aAAA;AAmzBF;;AAhzBA;EACE,oBAAA;EACA,eAAA;EACA,sBAAA;EACA,sBAAA;AAmzBF;;AAjzBA;EACE,cAAA;EACA,cAAA;EACA,oBAAA;AAozBF;;AAlzBA;EACE,oBAAA;EACA,mBAAA;EACA,uBAAA;EACA,UAAA;EACA,mCAAA;EACA,kCAAA;AAqzBF;;AAnzBA;EACE,SAAA;AAszBF;;AApzBA;EACE,kCAAA;EACA,iCAAA;AAuzBF;;AArzBA;EACE,mCAAA;EACA,kCAAA;AAwzBF;;AAtzBA;EACE,kBAAA;AAyzBF;;AAvzBA;;EAEE,UAAA;EACA,SAAA;EACA,cAAA;AA0zBF;;AAvzBA;EACE,iBAAA;EACA,oBAAA;AA0zBF;;AAxzBA;EACE,+BAAA;AA2zBF;;AAxzBA;EACE,8BAAA;EACA,6BAAA;EACA,iCAAA;AA2zBF;;AAzzBA;;EAEE,8BAAA;AA4zBF;;AA1zBA;EACE,8BAAA;AA6zBF;;AA3zBA;EACE,8BAAA;EACA,oCAAA;EACA,mDAAA;AA8zBF;;AA5zBA;;;;;;;;;EASE,8BAAA;AA+zBF;;AA7zBA;EACE,8BAAA;AAg0BF;;AA7zBA;EACE,6BAAA;EACA,iCAAA;AAg0BF;;AA9zBA;EACE,8BAAA;EACA,6BAAA;EACA,4CAAA;AAi0BF;;AA/zBA;;;;;;;;;EASE,8BAAA;AAk0BF;;AAh0BA;EACE,8BAAA;AAm0BF;;AAh0BA;EACE,sBAAA;EACA,6BAAA;EACA,6BAAA;AAm0BF;;AAj0BA;;EAEE,sBAAA;AAo0BF;;AAl0BA;EACE,sBAAA;AAq0BF;;AAn0BA;EACE,6BAAA;EACA,6BAAA;EACA,kDAAA;AAs0BF;;AAp0BA;;;;;;;;;EASE,6BAAA;AAu0BF;;AAr0BA;EACE,6BAAA;AAw0BF;;AAr0BA;EACE,gCAAA;EACA,+BAAA;EACA,mCAAA;AAw0BF;;AAt0BA;;EAEE,gCAAA;AAy0BF;;AAv0BA;EACE,gCAAA;AA00BF;;AAx0BA;EACE,gCAAA;EACA,sCAAA;EACA,qDAAA;AA20BF;;AAz0BA;;;;;;;;;EASE,gCAAA;AA40BF;;AA10BA;EACE,gCAAA;AA60BF;;AA10BA;EACE,wBAAA;EACA,qCAAA;EACA,yCAAA;AA60BF;;AA30BA;;EAEE,wBAAA;AA80BF;;AA50BA;EACE,wBAAA;AA+0BF;;AA70BA;EACE,gCAAA;EACA,+BAAA;EACA,8CAAA;AAg1BF;;AA90BA;;;;;;;;;EASE,gCAAA;AAi1BF;;AA/0BA;EACE,gCAAA;AAk1BF;;AA/0BA;EACE,+BAAA;EACA,mCAAA;AAk1BF;;AAh1BA;EACE,gCAAA;EACA,+BAAA;EACA,8CAAA;AAm1BF;;AAj1BA;;;;;;;;;EASE,gCAAA;AAo1BF;;AAl1BA;EACE,gCAAA;AAq1BF;;AAl1BA;EACE,wBAAA;EACA,qCAAA;EACA,oDAAA;AAq1BF;;AAn1BA;;;;;;;;;EASE,wBAAA;AAs1BF;;AAp1BA;EACE,wBAAA;AAu1BF;;AAp1BA;EACE,wBAAA;EACA,+BAAA;EACA,6BAAA;AAu1BF;;AAr1BA;;EAEE,wBAAA;AAw1BF;;AAt1BA;EACE,wBAAA;AAy1BF;;AAv1BA;EACE,+BAAA;EACA,+BAAA;EACA,oDAAA;AA01BF;;AAx1BA;;;;;;;;;EASE,+BAAA;AA21BF;;AAz1BA;EACE,+BAAA;AA41BF;;AAz1BA;EACE,kCAAA;EACA,iCAAA;EACA,qCAAA;AA41BF;;AA11BA;;EAEE,kCAAA;AA61BF;;AA31BA;EACE,kCAAA;AA81BF;;AA51BA;EACE,kCAAA;EACA,wCAAA;EACA,uDAAA;AA+1BF;;AA71BA;;;;;;;;;EASE,kCAAA;AAg2BF;;AA91BA;EACE,kCAAA;AAi2BF;;AA91BA;EACE,0BAAA;EACA,uCAAA;EACA,2CAAA;AAi2BF;;AA/1BA;;EAEE,0BAAA;AAk2BF;;AAh2BA;EACE,0BAAA;AAm2BF;;AAj2BA;EACE,kCAAA;EACA,iCAAA;EACA,gDAAA;AAo2BF;;AAl2BA;;;;;;;;;EASE,kCAAA;AAq2BF;;AAn2BA;EACE,kCAAA;AAs2BF;;AAn2BA;EACE,iCAAA;EACA,qCAAA;AAs2BF;;AAp2BA;EACE,kCAAA;EACA,iCAAA;EACA,gDAAA;AAu2BF;;AAr2BA;;;;;;;;;EASE,kCAAA;AAw2BF;;AAt2BA;EACE,kCAAA;AAy2BF;;AAt2BA;EACE,0BAAA;EACA,uCAAA;EACA,sDAAA;AAy2BF;;AAv2BA;;;;;;;;;EASE,0BAAA;AA02BF;;AAx2BA;EACE,0BAAA;AA22BF;;AAx2BA;EACE,0BAAA;EACA,iCAAA;EACA,6BAAA;AA22BF;;AAz2BA;;EAEE,0BAAA;AA42BF;;AA12BA;EACE,0BAAA;AA62BF;;AA32BA;EACE,iCAAA;EACA,iCAAA;EACA,sDAAA;AA82BF;;AA52BA;;;;;;;;;EASE,iCAAA;AA+2BF;;AA72BA;EACE,iCAAA;AAg3BF;;AA72BA;EACE,gCAAA;EACA,+BAAA;EACA,mCAAA;AAg3BF;;AA92BA;;EAEE,gCAAA;AAi3BF;;AA/2BA;EACE,gCAAA;AAk3BF;;AAh3BA;EACE,gCAAA;EACA,sCAAA;EACA,qDAAA;AAm3BF;;AAj3BA;;;;;;;;;EASE,gCAAA;AAo3BF;;AAl3BA;EACE,gCAAA;AAq3BF;;AAl3BA;EACE,wBAAA;EACA,qCAAA;EACA,yCAAA;AAq3BF;;AAn3BA;;EAEE,wBAAA;AAs3BF;;AAp3BA;EACE,wBAAA;AAu3BF;;AAr3BA;EACE,gCAAA;EACA,+BAAA;EACA,8CAAA;AAw3BF;;AAt3BA;;;;;;;;;EASE,gCAAA;AAy3BF;;AAv3BA;EACE,gCAAA;AA03BF;;AAv3BA;EACE,+BAAA;EACA,mCAAA;AA03BF;;AAx3BA;EACE,gCAAA;EACA,+BAAA;EACA,8CAAA;AA23BF;;AAz3BA;;;;;;;;;EASE,gCAAA;AA43BF;;AA13BA;EACE,gCAAA;AA63BF;;AA13BA;EACE,wBAAA;EACA,qCAAA;EACA,oDAAA;AA63BF;;AA33BA;;;;;;;;;EASE,wBAAA;AA83BF;;AA53BA;EACE,wBAAA;AA+3BF;;AA53BA;EACE,wBAAA;EACA,+BAAA;EACA,6BAAA;AA+3BF;;AA73BA;;EAEE,wBAAA;AAg4BF;;AA93BA;EACE,wBAAA;AAi4BF;;AA/3BA;EACE,+BAAA;EACA,+BAAA;EACA,oDAAA;AAk4BF;;AAh4BA;;;;;;;;;EASE,+BAAA;AAm4BF;;AAj4BA;EACE,+BAAA;AAo4BF;;AAj4BA;EACE,6BAAA;EACA,4BAAA;EACA,gCAAA;AAo4BF;;AAl4BA;;EAEE,6BAAA;AAq4BF;;AAn4BA;EACE,6BAAA;AAs4BF;;AAp4BA;EACE,6BAAA;EACA,mCAAA;EACA,kDAAA;AAu4BF;;AAr4BA;;;;;;;;;EASE,6BAAA;AAw4BF;;AAt4BA;EACE,6BAAA;AAy4BF;;AAt4BA;EACE,qBAAA;EACA,kCAAA;EACA,sCAAA;AAy4BF;;AAv4BA;;EAEE,qBAAA;AA04BF;;AAx4BA;EACE,qBAAA;AA24BF;;AAz4BA;EACE,6BAAA;EACA,4BAAA;EACA,2CAAA;AA44BF;;AA14BA;;;;;;;;;EASE,6BAAA;AA64BF;;AA34BA;EACE,6BAAA;AA84BF;;AA34BA;EACE,4BAAA;EACA,gCAAA;AA84BF;;AA54BA;EACE,6BAAA;EACA,4BAAA;EACA,2CAAA;AA+4BF;;AA74BA;;;;;;;;;EASE,6BAAA;AAg5BF;;AA94BA;EACE,6BAAA;AAi5BF;;AA94BA;EACE,qBAAA;EACA,kCAAA;EACA,iDAAA;AAi5BF;;AA/4BA;;;;;;;;;EASE,qBAAA;AAk5BF;;AAh5BA;EACE,qBAAA;AAm5BF;;AAh5BA;EACE,qBAAA;EACA,4BAAA;EACA,6BAAA;AAm5BF;;AAj5BA;;EAEE,qBAAA;AAo5BF;;AAl5BA;EACE,qBAAA;AAq5BF;;AAn5BA;EACE,4BAAA;EACA,4BAAA;EACA,iDAAA;AAs5BF;;AAp5BA;;;;;;;;;EASE,4BAAA;AAu5BF;;AAr5BA;EACE,4BAAA;AAw5BF;;AAr5BA;EACE,gCAAA;EACA,+BAAA;EACA,mCAAA;AAw5BF;;AAt5BA;;EAEE,gCAAA;AAy5BF;;AAv5BA;EACE,gCAAA;AA05BF;;AAx5BA;EACE,gCAAA;EACA,sCAAA;EACA,qDAAA;AA25BF;;AAz5BA;;;;;;;;;EASE,gCAAA;AA45BF;;AA15BA;EACE,gCAAA;AA65BF;;AA15BA;EACE,wBAAA;EACA,qCAAA;EACA,yCAAA;AA65BF;;AA35BA;;EAEE,wBAAA;AA85BF;;AA55BA;EACE,wBAAA;AA+5BF;;AA75BA;EACE,gCAAA;EACA,+BAAA;EACA,8CAAA;AAg6BF;;AA95BA;;;;;;;;;EASE,gCAAA;AAi6BF;;AA/5BA;EACE,gCAAA;AAk6BF;;AA/5BA;EACE,+BAAA;EACA,mCAAA;AAk6BF;;AAh6BA;EACE,gCAAA;EACA,+BAAA;EACA,8CAAA;AAm6BF;;AAj6BA;;;;;;;;;EASE,gCAAA;AAo6BF;;AAl6BA;EACE,gCAAA;AAq6BF;;AAl6BA;EACE,wBAAA;EACA,qCAAA;EACA,oDAAA;AAq6BF;;AAn6BA;;;;;;;;;EASE,wBAAA;AAs6BF;;AAp6BA;EACE,wBAAA;AAu6BF;;AAp6BA;EACE,wBAAA;EACA,+BAAA;EACA,6BAAA;AAu6BF;;AAr6BA;;EAEE,wBAAA;AAw6BF;;AAt6BA;EACE,wBAAA;AAy6BF;;AAv6BA;EACE,+BAAA;EACA,+BAAA;EACA,oDAAA;AA06BF;;AAx6BA;;;;;;;;;EASE,+BAAA;AA26BF;;AAz6BA;EACE,+BAAA;AA46BF;;AAz6BA;EACE,+BAAA;EACA,8BAAA;EACA,kCAAA;AA46BF;;AA16BA;;EAEE,+BAAA;AA66BF;;AA36BA;EACE,+BAAA;AA86BF;;AA56BA;EACE,+BAAA;EACA,qCAAA;EACA,oDAAA;AA+6BF;;AA76BA;;;;;;;;;EASE,+BAAA;AAg7BF;;AA96BA;EACE,+BAAA;AAi7BF;;AA96BA;EACE,uBAAA;EACA,oCAAA;EACA,wCAAA;AAi7BF;;AA/6BA;;EAEE,uBAAA;AAk7BF;;AAh7BA;EACE,uBAAA;AAm7BF;;AAj7BA;EACE,+BAAA;EACA,8BAAA;EACA,6CAAA;AAo7BF;;AAl7BA;;;;;;;;;EASE,+BAAA;AAq7BF;;AAn7BA;EACE,+BAAA;AAs7BF;;AAn7BA;EACE,8BAAA;EACA,kCAAA;AAs7BF;;AAp7BA;EACE,+BAAA;EACA,8BAAA;EACA,6CAAA;AAu7BF;;AAr7BA;;;;;;;;;EASE,+BAAA;AAw7BF;;AAt7BA;EACE,+BAAA;AAy7BF;;AAt7BA;EACE,uBAAA;EACA,oCAAA;EACA,mDAAA;AAy7BF;;AAv7BA;;;;;;;;;EASE,uBAAA;AA07BF;;AAx7BA;EACE,uBAAA;AA27BF;;AAx7BA;EACE,uBAAA;EACA,8BAAA;EACA,6BAAA;AA27BF;;AAz7BA;;EAEE,uBAAA;AA47BF;;AA17BA;EACE,uBAAA;AA67BF;;AA37BA;EACE,8BAAA;EACA,8BAAA;EACA,mDAAA;AA87BF;;AA57BA;;;;;;;;;EASE,8BAAA;AA+7BF;;AA77BA;EACE,8BAAA;AAg8BF;;AA77BA;EACE,6BAAA;EACA,4BAAA;EACA,gCAAA;AAg8BF;;AA97BA;;EAEE,6BAAA;AAi8BF;;AA/7BA;EACE,6BAAA;AAk8BF;;AAh8BA;EACE,6BAAA;EACA,mCAAA;EACA,kDAAA;AAm8BF;;AAj8BA;;;;;;;;;EASE,6BAAA;AAo8BF;;AAl8BA;EACE,6BAAA;AAq8BF;;AAl8BA;EACE,qBAAA;EACA,kCAAA;EACA,sCAAA;AAq8BF;;AAn8BA;;EAEE,qBAAA;AAs8BF;;AAp8BA;EACE,qBAAA;AAu8BF;;AAr8BA;EACE,6BAAA;EACA,4BAAA;EACA,2CAAA;AAw8BF;;AAt8BA;;;;;;;;;EASE,6BAAA;AAy8BF;;AAv8BA;EACE,6BAAA;AA08BF;;AAv8BA;EACE,4BAAA;EACA,gCAAA;AA08BF;;AAx8BA;EACE,6BAAA;EACA,4BAAA;EACA,2CAAA;AA28BF;;AAz8BA;;;;;;;;;EASE,6BAAA;AA48BF;;AA18BA;EACE,6BAAA;AA68BF;;AA18BA;EACE,qBAAA;EACA,kCAAA;EACA,iDAAA;AA68BF;;AA38BA;;;;;;;;;EASE,qBAAA;AA88BF;;AA58BA;EACE,qBAAA;AA+8BF;;AA58BA;EACE,qBAAA;EACA,4BAAA;EACA,6BAAA;AA+8BF;;AA78BA;;EAEE,qBAAA;AAg9BF;;AA98BA;EACE,qBAAA;AAi9BF;;AA/8BA;EACE,4BAAA;EACA,4BAAA;EACA,iDAAA;AAk9BF;;AAh9BA;;;;;;;;;EASE,4BAAA;AAm9BF;;AAj9BA;EACE,4BAAA;AAo9BF;;AAj9BA;EACE,2BAAA;AAo9BF;;AAl9BA;;EAEE,2BAAA;AAq9BF;;AAn9BA;EACE,2BAAA;AAs9BF;;AAp9BA;EACE,2BAAA;AAu9BF;;AAr9BA;;;;;;;;;EASE,2BAAA;AAw9BF;;AAt9BA;EACE,2BAAA;AAy9BF;;AAt9BA;;EAEE,2BAAA;AAy9BF;;AAv9BA;EACE,2BAAA;AA09BF;;AAx9BA;;;;;;;;;EASE,2BAAA;AA29BF;;AAz9BA;EACE,2BAAA;AA49BF;;AAz9BA;EACE,2BAAA;AA49BF;;AA19BA;EACE,2BAAA;AA69BF;;AA19BA;EACE,6BAAA;AA69BF;;AA39BA;;EAEE,6BAAA;AA89BF;;AA59BA;EACE,6BAAA;AA+9BF;;AA79BA;EACE,6BAAA;AAg+BF;;AA99BA;;;;;;;;;EASE,6BAAA;AAi+BF;;AA/9BA;EACE,6BAAA;AAk+BF;;AA/9BA;;EAEE,6BAAA;AAk+BF;;AAh+BA;EACE,6BAAA;AAm+BF;;AAj+BA;;;;;;;;;EASE,6BAAA;AAo+BF;;AAl+BA;EACE,6BAAA;AAq+BF;;AAl+BA;EACE,6BAAA;AAq+BF;;AAn+BA;EACE,6BAAA;AAs+BF;;AAn+BA;EACE,+BAAA;AAs+BF;;AAp+BA;;EAEE,+BAAA;AAu+BF;;AAr+BA;EACE,+BAAA;AAw+BF;;AAt+BA;EACE,+BAAA;AAy+BF;;AAv+BA;;;;;;;;;EASE,+BAAA;AA0+BF;;AAx+BA;EACE,+BAAA;AA2+BF;;AAx+BA;;EAEE,+BAAA;AA2+BF;;AAz+BA;EACE,+BAAA;AA4+BF;;AA1+BA;;;;;;;;;EASE,+BAAA;AA6+BF;;AA3+BA;EACE,+BAAA;AA8+BF;;AA3+BA;EACE,+BAAA;AA8+BF;;AA5+BA;EACE,+BAAA;AA++BF;;AA5+BA;EACE,2BAAA;AA++BF;;AA7+BA;;EAEE,2BAAA;AAg/BF;;AA9+BA;EACE,2BAAA;AAi/BF;;AA/+BA;EACE,2BAAA;AAk/BF;;AAh/BA;;;;;;;;;EASE,2BAAA;AAm/BF;;AAj/BA;EACE,2BAAA;AAo/BF;;AAj/BA;;EAEE,2BAAA;AAo/BF;;AAl/BA;EACE,2BAAA;AAq/BF;;AAn/BA;;;;;;;;;EASE,2BAAA;AAs/BF;;AAp/BA;EACE,2BAAA;AAu/BF;;AAp/BA;EACE,2BAAA;AAu/BF;;AAr/BA;EACE,2BAAA;AAw/BF;;AAr/BA;EACE,6BAAA;AAw/BF;;AAt/BA;;EAEE,6BAAA;AAy/BF;;AAv/BA;EACE,6BAAA;AA0/BF;;AAx/BA;EACE,6BAAA;AA2/BF;;AAz/BA;;;;;;;;;EASE,6BAAA;AA4/BF;;AA1/BA;EACE,6BAAA;AA6/BF;;AA1/BA;;EAEE,6BAAA;AA6/BF;;AA3/BA;EACE,6BAAA;AA8/BF;;AA5/BA;;;;;;;;;EASE,6BAAA;AA+/BF;;AA7/BA;EACE,6BAAA;AAggCF;;AA7/BA;EACE,6BAAA;AAggCF;;AA9/BA;EACE,6BAAA;AAigCF;;AA9/BA;EACE,0BAAA;AAigCF;;AA//BA;;EAEE,0BAAA;AAkgCF;;AAhgCA;EACE,0BAAA;AAmgCF;;AAjgCA;EACE,0BAAA;AAogCF;;AAlgCA;;;;;;;;;EASE,0BAAA;AAqgCF;;AAngCA;EACE,0BAAA;AAsgCF;;AAngCA;;EAEE,0BAAA;AAsgCF;;AApgCA;EACE,0BAAA;AAugCF;;AArgCA;;;;;;;;;EASE,0BAAA;AAwgCF;;AAtgCA;EACE,0BAAA;AAygCF;;AAtgCA;EACE,0BAAA;AAygCF;;AAvgCA;EACE,0BAAA;AA0gCF;;AAvgCA;EACE,6BAAA;AA0gCF;;AAxgCA;;EAEE,6BAAA;AA2gCF;;AAzgCA;EACE,6BAAA;AA4gCF;;AA1gCA;EACE,6BAAA;AA6gCF;;AA3gCA;;;;;;;;;EASE,6BAAA;AA8gCF;;AA5gCA;EACE,6BAAA;AA+gCF;;AA5gCA;;EAEE,6BAAA;AA+gCF;;AA7gCA;EACE,6BAAA;AAghCF;;AA9gCA;;;;;;;;;EASE,6BAAA;AAihCF;;AA/gCA;EACE,6BAAA;AAkhCF;;AA/gCA;EACE,6BAAA;AAkhCF;;AAhhCA;EACE,6BAAA;AAmhCF;;AAhhCA;EACE,4BAAA;AAmhCF;;AAjhCA;;EAEE,4BAAA;AAohCF;;AAlhCA;EACE,4BAAA;AAqhCF;;AAnhCA;EACE,4BAAA;AAshCF;;AAphCA;;;;;;;;;EASE,4BAAA;AAuhCF;;AArhCA;EACE,4BAAA;AAwhCF;;AArhCA;;EAEE,4BAAA;AAwhCF;;AAthCA;EACE,4BAAA;AAyhCF;;AAvhCA;;;;;;;;;EASE,4BAAA;AA0hCF;;AAxhCA;EACE,4BAAA;AA2hCF;;AAxhCA;EACE,4BAAA;AA2hCF;;AAzhCA;EACE,4BAAA;AA4hCF;;AAzhCA;EACE,0BAAA;AA4hCF;;AA1hCA;;EAEE,0BAAA;AA6hCF;;AA3hCA;EACE,0BAAA;AA8hCF;;AA5hCA;EACE,0BAAA;AA+hCF;;AA7hCA;;;;;;;;;EASE,0BAAA;AAgiCF;;AA9hCA;EACE,0BAAA;AAiiCF;;AA9hCA;;EAEE,0BAAA;AAiiCF;;AA/hCA;EACE,0BAAA;AAkiCF;;AAhiCA;;;;;;;;;EASE,0BAAA;AAmiCF;;AAjiCA;EACE,0BAAA;AAoiCF;;AAjiCA;EACE,0BAAA;AAoiCF;;AAliCA;EACE,0BAAA;AAqiCF;;AAliCA;EACE,2BAAA;AAqiCF;;AAniCA;;EAEE,2BAAA;AAsiCF;;AApiCA;EACE,2BAAA;AAuiCF;;AAriCA;EACE,2BAAA;AAwiCF;;AAtiCA;;;;;;;;;EASE,2BAAA;AAyiCF;;AAviCA;EACE,2BAAA;AA0iCF;;AAviCA;;EAEE,2BAAA;AA0iCF;;AAxiCA;EACE,2BAAA;AA2iCF;;AAziCA;;;;;;;;;EASE,2BAAA;AA4iCF;;AA1iCA;EACE,2BAAA;AA6iCF;;AA1iCA;EACE,2BAAA;AA6iCF;;AA3iCA;EACE,2BAAA;AA8iCF;;AA3iCA;EACE,8BAAA;AA8iCF;;AA5iCA;;EAEE,8BAAA;AA+iCF;;AA7iCA;EACE,8BAAA;AAgjCF;;AA9iCA;EACE,8BAAA;AAijCF;;AA/iCA;;;;;;;;;EASE,8BAAA;AAkjCF;;AAhjCA;EACE,8BAAA;AAmjCF;;AAhjCA;;EAEE,8BAAA;AAmjCF;;AAjjCA;EACE,8BAAA;AAojCF;;AAljCA;;;;;;;;;EASE,8BAAA;AAqjCF;;AAnjCA;EACE,8BAAA;AAsjCF;;AAnjCA;EACE,8BAAA;AAsjCF;;AApjCA;EACE,8BAAA;AAujCF;;AApjCA;EACE,8BAAA;AAujCF;;AArjCA;;EAEE,8BAAA;AAwjCF;;AAtjCA;EACE,8BAAA;AAyjCF;;AAvjCA;EACE,8BAAA;AA0jCF;;AAxjCA;;;;;;;;;EASE,8BAAA;AA2jCF;;AAzjCA;EACE,8BAAA;AA4jCF;;AAzjCA;;EAEE,8BAAA;AA4jCF;;AA1jCA;EACE,8BAAA;AA6jCF;;AA3jCA;;;;;;;;;EASE,8BAAA;AA8jCF;;AA5jCA;EACE,8BAAA;AA+jCF;;AA5jCA;EACE,8BAAA;AA+jCF;;AA7jCA;EACE,8BAAA;AAgkCF;;AA7jCA;EACE,8BAAA;AAgkCF;;AA9jCA;;EAEE,8BAAA;AAikCF;;AA/jCA;EACE,8BAAA;AAkkCF;;AAhkCA;EACE,8BAAA;AAmkCF;;AAjkCA;;;;;;;;;EASE,8BAAA;AAokCF;;AAlkCA;EACE,8BAAA;AAqkCF;;AAlkCA;;EAEE,8BAAA;AAqkCF;;AAnkCA;EACE,8BAAA;AAskCF;;AApkCA;;;;;;;;;EASE,8BAAA;AAukCF;;AArkCA;EACE,8BAAA;AAwkCF;;AArkCA;EACE,8BAAA;AAwkCF;;AAtkCA;EACE,8BAAA;AAykCF;;AAtkCA;EACE,8BAAA;AAykCF;;AAvkCA;;EAEE,8BAAA;AA0kCF;;AAxkCA;EACE,8BAAA;AA2kCF;;AAzkCA;EACE,8BAAA;AA4kCF;;AA1kCA;;;;;;;;;EASE,8BAAA;AA6kCF;;AA3kCA;EACE,8BAAA;AA8kCF;;AA3kCA;;EAEE,8BAAA;AA8kCF;;AA5kCA;EACE,8BAAA;AA+kCF;;AA7kCA;;;;;;;;;EASE,8BAAA;AAglCF;;AA9kCA;EACE,8BAAA;AAilCF;;AA9kCA;EACE,8BAAA;AAilCF;;AA/kCA;EACE,8BAAA;AAklCF;;AA/kCA;EACE,8BAAA;AAklCF;;AAhlCA;;EAEE,8BAAA;AAmlCF;;AAjlCA;EACE,8BAAA;AAolCF;;AAllCA;EACE,8BAAA;AAqlCF;;AAnlCA;;;;;;;;;EASE,8BAAA;AAslCF;;AAplCA;EACE,8BAAA;AAulCF;;AAplCA;;EAEE,8BAAA;AAulCF;;AArlCA;EACE,8BAAA;AAwlCF;;AAtlCA;;;;;;;;;EASE,8BAAA;AAylCF;;AAvlCA;EACE,8BAAA;AA0lCF;;AAvlCA;EACE,8BAAA;AA0lCF;;AAxlCA;EACE,8BAAA;AA2lCF;;AAxlCA;EACE,8BAAA;AA2lCF;;AAzlCA;;EAEE,8BAAA;AA4lCF;;AA1lCA;EACE,8BAAA;AA6lCF;;AA3lCA;EACE,8BAAA;AA8lCF;;AA5lCA;;;;;;;;;EASE,8BAAA;AA+lCF;;AA7lCA;EACE,8BAAA;AAgmCF;;AA7lCA;;EAEE,8BAAA;AAgmCF;;AA9lCA;EACE,8BAAA;AAimCF;;AA/lCA;;;;;;;;;EASE,8BAAA;AAkmCF;;AAhmCA;EACE,8BAAA;AAmmCF;;AAhmCA;EACE,8BAAA;AAmmCF;;AAjmCA;EACE,8BAAA;AAomCF;;AAjmCA;EACE,8BAAA;AAomCF;;AAlmCA;;EAEE,8BAAA;AAqmCF;;AAnmCA;EACE,8BAAA;AAsmCF;;AApmCA;EACE,8BAAA;AAumCF;;AArmCA;;;;;;;;;EASE,8BAAA;AAwmCF;;AAtmCA;EACE,8BAAA;AAymCF;;AAtmCA;;EAEE,8BAAA;AAymCF;;AAvmCA;EACE,8BAAA;AA0mCF;;AAxmCA;;;;;;;;;EASE,8BAAA;AA2mCF;;AAzmCA;EACE,8BAAA;AA4mCF;;AAzmCA;EACE,8BAAA;AA4mCF;;AA1mCA;EACE,8BAAA;AA6mCF;;AA1mCA;EACE,8BAAA;AA6mCF;;AA3mCA;;EAEE,8BAAA;AA8mCF;;AA5mCA;EACE,8BAAA;AA+mCF;;AA7mCA;EACE,8BAAA;AAgnCF;;AA9mCA;;;;;;;;;EASE,8BAAA;AAinCF;;AA/mCA;EACE,8BAAA;AAknCF;;AA/mCA;;EAEE,8BAAA;AAknCF;;AAhnCA;EACE,8BAAA;AAmnCF;;AAjnCA;;;;;;;;;EASE,8BAAA;AAonCF;;AAlnCA;EACE,8BAAA;AAqnCF;;AAlnCA;EACE,8BAAA;AAqnCF;;AAnnCA;EACE,8BAAA;AAsnCF;;AAnnCA;EACE,8BAAA;AAsnCF;;AApnCA;;EAEE,8BAAA;AAunCF;;AArnCA;EACE,8BAAA;AAwnCF;;AAtnCA;EACE,8BAAA;AAynCF;;AAvnCA;;;;;;;;;EASE,8BAAA;AA0nCF;;AAxnCA;EACE,8BAAA;AA2nCF;;AAxnCA;;EAEE,8BAAA;AA2nCF;;AAznCA;EACE,8BAAA;AA4nCF;;AA1nCA;;;;;;;;;EASE,8BAAA;AA6nCF;;AA3nCA;EACE,8BAAA;AA8nCF;;AA3nCA;EACE,8BAAA;AA8nCF;;AA5nCA;EACE,8BAAA;AA+nCF;;AA5nCA;EACE,cAAA;EACA,qBAAA;EACA,yBAAA;AA+nCF;;AA7nCA;;EAEE,cAAA;AAgoCF;;AA9nCA;EACE,cAAA;AAioCF;;AA/nCA;EACE,qBAAA;EACA,oCAAA;AAkoCF;;AA/nCA;EACE,cAAA;EACA,oCAAA;EACA,wCAAA;AAkoCF;;AAhoCA;;EAEE,cAAA;AAmoCF;;AAjoCA;EACE,cAAA;AAooCF;;AAloCA;EACE,cAAA;EACA,qBAAA;EACA,oCAAA;AAqoCF;;AAnoCA;;;;;;;;;EASE,cAAA;AAsoCF;;AApoCA;EACE,cAAA;AAuoCF;;AApoCA;EACE,cAAA;EACA,qBAAA;EACA,yBAAA;AAuoCF;;AAroCA;;EAEE,cAAA;AAwoCF;;AAtoCA;EACE,cAAA;AAyoCF;;AAvoCA;EACE,qBAAA;EACA,oCAAA;AA0oCF;;AAvoCA;EACE,cAAA;EACA,oCAAA;EACA,wCAAA;AA0oCF;;AAxoCA;;EAEE,cAAA;AA2oCF;;AAzoCA;EACE,cAAA;AA4oCF;;AA1oCA;EACE,cAAA;EACA,qBAAA;EACA,oCAAA;AA6oCF;;AA3oCA;;;;;;;;;EASE,cAAA;AA8oCF;;AA5oCA;EACE,cAAA;AA+oCF;;AA5oCA;EACE,cAAA;EACA,qBAAA;EACA,yBAAA;AA+oCF;;AA7oCA;;EAEE,cAAA;AAgpCF;;AA9oCA;EACE,cAAA;AAipCF;;AA/oCA;EACE,qBAAA;EACA,oCAAA;AAkpCF;;AA/oCA;EACE,cAAA;EACA,qCAAA;EACA,yCAAA;AAkpCF;;AAhpCA;;EAEE,cAAA;AAmpCF;;AAjpCA;EACE,cAAA;AAopCF;;AAlpCA;EACE,cAAA;EACA,qBAAA;EACA,oCAAA;AAqpCF;;AAnpCA;;;;;;;;;EASE,cAAA;AAspCF;;AAppCA;EACE,cAAA;AAupCF;;AAppCA;EACE,cAAA;EACA,qBAAA;EACA,yBAAA;AAupCF;;AArpCA;;EAEE,cAAA;AAwpCF;;AAtpCA;EACE,cAAA;AAypCF;;AAvpCA;EACE,qBAAA;EACA,oCAAA;AA0pCF;;AAvpCA;EACE,cAAA;EACA,qCAAA;EACA,yCAAA;AA0pCF;;AAxpCA;;EAEE,cAAA;AA2pCF;;AAzpCA;EACE,cAAA;AA4pCF;;AA1pCA;EACE,cAAA;EACA,qBAAA;EACA,oCAAA;AA6pCF;;AA3pCA;;;;;;;;;EASE,cAAA;AA8pCF;;AA5pCA;EACE,cAAA;AA+pCF;;AA5pCA;EACE,cAAA;EACA,qBAAA;EACA,yBAAA;AA+pCF;;AA7pCA;;EAEE,cAAA;AAgqCF;;AA9pCA;EACE,cAAA;AAiqCF;;AA/pCA;EACE,qBAAA;EACA,oCAAA;AAkqCF;;AA/pCA;EACE,cAAA;EACA,kCAAA;EACA,sCAAA;AAkqCF;;AAhqCA;;EAEE,cAAA;AAmqCF;;AAjqCA;EACE,cAAA;AAoqCF;;AAlqCA;EACE,cAAA;EACA,qBAAA;EACA,oCAAA;AAqqCF;;AAnqCA;;;;;;;;;EASE,cAAA;AAsqCF;;AApqCA;EACE,cAAA;AAuqCF;;AApqCA;EACE,cAAA;EACA,qBAAA;EACA,yBAAA;AAuqCF;;AArqCA;;EAEE,cAAA;AAwqCF;;AAtqCA;EACE,cAAA;AAyqCF;;AAvqCA;EACE,qBAAA;EACA,oCAAA;AA0qCF;;AAvqCA;EACE,cAAA;EACA,oCAAA;EACA,wCAAA;AA0qCF;;AAxqCA;;EAEE,cAAA;AA2qCF;;AAzqCA;EACE,cAAA;AA4qCF;;AA1qCA;EACE,cAAA;EACA,qBAAA;EACA,oCAAA;AA6qCF;;AA3qCA;;;;;;;;;EASE,cAAA;AA8qCF;;AA5qCA;EACE,cAAA;AA+qCF;;AA5qCA;EACE,kCAAA;AA+qCF;;AA5qCA;EACE,gBAAA;EACA,2BAAA;EACA,oBAAA;EACA,kBAAA;EACA,mCAAA;EACA,sBAAA;EACA,gBAAA;EACA,qCAAA;EACA,qBAAA;AA+qCF;;AA5qCA;EACE,kBAAA;AA+qCF;;AA5qCA;EACE,6BAAA;EACA,yBAAA;AA+qCF;;AA7qCA;EACE,6BAAA;EACA,yBAAA;AAgrCF;;AA9qCA;EACE,SAAA;EACA,6BAAA;EACA,wBAAA;EACA,gBAAA;EACA,gBAAA;AAirCF;;AA9qCA;EACE,oCAAA;EACA,gCAAA;EACA,yBAAA;EACA,2BAAA;AAirCF;;AA/qCA;EACE,yBAAA;AAkrCF;;AAhrCA;EACE,yBAAA;EACA,UAAA;AAmrCF;;AAjrCA;EACE,oCAAA;EACA,gCAAA;EACA,yBAAA;EACA,2BAAA;AAorCF;;AAjrCA;EACE,oCAAA;AAorCF;;AAjrCA;EACE,yBAAA;AAorCF;;AAjrCA;EACE,yBAAA;AAorCF;;AA7qCA;EACE,cAAA;AAqrCF;;AAnrCA;EACE,cAAA;EACA,UAAA;AAsrCF;;AAnrCA;EACE,YAAA;AAsrCF;;AAnrCA;EACE,kBAAA;AAsrCF;;AAnrCA;EACE,gBAAA;AAsrCF;;AAprCA;EACE,gCAAA;EACA,0EAAA;AAurCF;;AArrCA;EACE,yBAAA;EACA,oCAAA;EACA,gCAAA;AAwrCF;;AAtrCA;EACE,qCAAA;AAyrCF;;AAvrCA;EACE,oCAAA;EACA,gCAAA;EACA,yBAAA;EACA,2BAAA;AA0rCF;;AAxrCA;EACE,yBAAA;AA2rCF;;AAzrCA;EACE,yBAAA;EACA,UAAA;AA4rCF;;AA1rCA;EACE,oCAAA;EACA,2CAAA;EACA,yBAAA;EACA,2BAAA;AA6rCF;;AA3rCA;EACE,6BAAA;EACA,yBAAA;EACA,yBAAA;AA8rCF;;AA5rCA;EACE,yBAAA;AA+rCF;;AA7rCA;EACE,yBAAA;EACA,UAAA;AAgsCF;;AA9rCA;EACE,6BAAA;EACA,oCAAA;EACA,yBAAA;AAisCF;;AA9rCA;EACE,wBAAA;AAisCF;;AA/rCA;EACE,eAAA;EACA,cAAA;AAksCF;;AAhsCA;EACE,eAAA;EACA,cAAA;AAmsCF;;AAjsCA;EACE,qBAAA;EACA,kBAAA;AAosCF;;AAlsCA;EACE,SAAA;AAqsCF;;AAnsCA;EACE,oCAAA;AAssCF;;AApsCA;EACE,yBAAA;AAusCF;;AArsCA;EACE,mCAAA;AAwsCF;;AAtsCA;EACE,kCAAA;AAysCF;;AAvsCA;EACE,mCAAA;AA0sCF;;AAvsCA;EACE,aAAA;EACA,mBAAA;EACA,eAAA;EACA,SAAA;AA0sCF;;AAxsCA;EACE,SAAA;EACA,WAAA;EACA,cAAA;AA2sCF;;AAzsCA;EACE,oBAAA;AA4sCF;;AAzsCA;EACE,eAAA;AA4sCF;;AA1sCA;EACE,cAAA;EACA,aAAA;AA6sCF;;AA3sCA;EACE,eAAA;EACA,cAAA;AA8sCF;;AA5sCA;EACE,4DAAA;AA+sCF;;AA7sCA;EACE,oCAAA;AAgtCF;;AA7sCA;EACE,4DAAA;AAgtCF;;AA7sCA;EACE,kBAAA;EACA,gBAAA;AAgtCF;;AA9sCA;EACE,eAAA;AAitCF;;AA/sCA;EACE,uBAAA;EACA,6BAAA;EACA,gCAAA;EACA,eAAA;EACA,gBAAA;EACA,sBAAA;AAktCF;;AAhtCA;EACE,uBAAA;AAmtCF;;AAjtCA;EACE,gBAAA;EACA,mBAAA;AAotCF;;AAltCA;EACE,0CAAA;AAqtCF;;AAntCA;EACE,0CAAA;AAstCF;;AAptCA;EACE,yCAAA;AAutCF;;AArtCA;EACE,aAAA;AAwtCF;;AArtCA;EACE,uBAAA;AAwtCF;;AAttCA;EACE,uBAAA;AAytCF;;AAvtCA;EACE,uBAAA;AA0tCF;;AAxtCA;EACE,oCAAA;EACA,gCAAA;AA2tCF;;AAztCA;EACE,qCAAA;AA4tCF;;AA1tCA;EACE,oCAAA;EACA,gCAAA;AA6tCF;;AA3tCA;EACE,qCAAA;AA8tCF;;AA3tCA;EACE,kBAAA;AA8tCF;;AA3tCA;EACE,YAAA;EACA,kBAAA;EACA,kBAAA;EACA,uBAAA;EACA,qBAAA;EACA,gBAAA;AA8tCF;;AA3tCA;EACE,aAAA;EACA,oBAAA;EACA,8BAAA;AA8tCF;;AA5tCA;EACE,YAAA;EACA,uBAAA;EACA,aAAA;EACA,qBAAA;EACA,kBAAA;AA+tCF;;AA7tCA;EACE,eAAA;AAguCF;;AA9tCA;EACE,UAAA;EACA,uBAAA;AAiuCF;;AA9tCA;EACE,yBAAA;EACA,eAAA;EACA,kBAAA;AAiuCF;;AA/tCA;EACE,4BAAA;AAkuCF;;AAhuCA;EACE,qBAAA;EACA,qBAAA;EACA,qBAAA;EACA,uBAAA;EACA,oBAAA;EACA,kBAAA;EACA,cAAA;EACA,eAAA;EACA,mBAAA;AAmuCF;;AAjuCA;EACE,eAAA;AAouCF;;AAluCA;EACE,gBAAA;AAquCF;;AAnuCA;;EAEE,2BAAA;AAsuCF;;AApuCA;;;EAGE,2BAAA;AAuuCF;;AAruCA;EACE,mBAAA;AAwuCF;;AAtuCA;EACE,uBAAA;EACA,iBAAA;EACA,yBAAA;AAyuCF;;AAvuCA;EACE,gBAAA;AA0uCF;;AAxuCA;EACE,wBAAA;EACA,0BAAA;EACA,2CAAA;AA2uCF;;AAzuCA;EACE,gCAAA;AA4uCF;;AA1uCA;EACE,wBAAA;EACA,2BAAA;EACA,2CAAA;AA6uCF;;AA3uCA;EACE,gCAAA;AA8uCF;;AA5uCA;EACE,uCAAA;AA+uCF;;AA7uCA;EACE,uCAAA;AAgvCF;;AA9uCA;EACE,uCAAA;AAivCF;;AA/uCA;EACE,uCAAA;AAkvCF;;AAhvCA;EACE,uCAAA;AAmvCF;;AAjvCA;EACE,uCAAA;AAovCF;;AAlvCA;EACE,uCAAA;AAqvCF;;AAnvCA;EACE,uCAAA;AAsvCF;;AApvCA;EACE,uCAAA;AAuvCF;;AApvCA;EACE,mBAAA;AAuvCF;;AApvCA;EACE,UAAA;AAuvCF;;AApvCA;;;EAGE,sBAAA;AAuvCF;;AArvCA;;;EAGE,kBAAA;EACA,qBAAA;EACA,cAAA;EACA,eAAA;EACA,YAAA;EACA,YAAA;EACA,WAAA;EACA,UAAA;EACA,mBAAA;AAwvCF;;AArvCA;EACE,UAAA;EACA,sBAAA;EACA,qBAAA;EACA,8BAAA;EACA,6BAAA;EACA,sCAAA;EAEA,qDAAA;AAwvCF;;AArvCA;EACE,UAAA;EACA,sBAAA;EACA,qBAAA;EACA,8BAAA;EACA,6BAAA;EACA,sCAAA;EAEA,qDAAA;AAwvCF;;AArvCA;EACE,aAAA;EACA,kBAAA;EACA,QAAA;EACA,SAAA;EACA,uBAAA;EACA,sDAAA;EACA,mCAAA;EACA,yBAAA;EACA,gBAAA;EACA,oBAAA;EACA,WAAA;EACA,gCAAA;EACA,4CAAA;AAwvCF;;AArvCA;EACE,kBAAA;AAwvCF;;AAtvCA;EACE,cAAA;AAyvCF;;AAtvCA;EACE,aAAA;AAyvCF;;AAvvCA;EACE,6BAAA;AA0vCF;;AAvvCA;EACE,iBAAA;EACA,oBAAA;AA0vCF;;AAvvCA;EACE,kBAAA;EACA,mBAAA;AA0vCF;;AAxvCA;EACE,6BAAA;AA2vCF;;AAxvCA;EACE,kBAAA;AA2vCF;;AAzvCA;EACE,mBAAA;AA4vCF;;AA1vCA;EACE,6BAAA;AA6vCF;;AA1vCA;EACE,gBAAA;AA6vCF;;AA3vCA;EACE,gCAAA;AA8vCF;;AA3vCA;EACE,oBAAA;EACA,uBAAA;AA8vCF;;AA3vCA;EACE,qBAAA;EACA,sBAAA;AA8vCF;;AA5vCA;EACE,gCAAA;AA+vCF;;AA5vCA;EACE,qBAAA;AA+vCF;;AA7vCA;EACE,sBAAA;AAgwCF;;AA9vCA;EACE,gCAAA;AAiwCF;;AA9vCA;EACE,eAAA;AAiwCF;;AA/vCA;EACE,+BAAA;AAkwCF;;AA/vCA;EACE,mBAAA;EACA,sBAAA;AAkwCF;;AA/vCA;EACE,oBAAA;EACA,qBAAA;AAkwCF;;AAhwCA;EACE,+BAAA;AAmwCF;;AAhwCA;EACE,oBAAA;AAmwCF;;AAjwCA;EACE,qBAAA;AAowCF;;AAlwCA;EACE,+BAAA;AAqwCF;;AAlwCA;EACE,gBAAA;AAqwCF;;AAnwCA;EACE,gCAAA;AAswCF;;AAnwCA;EACE,oBAAA;EACA,uBAAA;AAswCF;;AAnwCA;EACE,qBAAA;EACA,sBAAA;AAswCF;;AApwCA;EACE,gCAAA;AAuwCF;;AApwCA;EACE,qBAAA;AAuwCF;;AArwCA;EACE,sBAAA;AAwwCF;;AAtwCA;EACE,gCAAA;AAywCF;;AAtwCA;EACE,aAAA;AAywCF;;AAvwCA;EACE,6BAAA;AA0wCF;;AAvwCA;EACE,iBAAA;EACA,oBAAA;AA0wCF;;AAvwCA;EACE,kBAAA;EACA,mBAAA;AA0wCF;;AAxwCA;EACE,6BAAA;AA2wCF;;AAxwCA;EACE,kBAAA;AA2wCF;;AAzwCA;EACE,mBAAA;AA4wCF;;AA1wCA;EACE,6BAAA;AA6wCF;;AA1wCA;EACE,gBAAA;AA6wCF;;AA3wCA;EACE,gCAAA;AA8wCF;;AA3wCA;EACE,oBAAA;EACA,uBAAA;AA8wCF;;AA3wCA;EACE,qBAAA;EACA,sBAAA;AA8wCF;;AA5wCA;EACE,gCAAA;AA+wCF;;AA5wCA;EACE,qBAAA;AA+wCF;;AA7wCA;EACE,sBAAA;AAgxCF;;AA9wCA;EACE,gCAAA;AAixCF;;AA9wCA;EACE,eAAA;AAixCF;;AA/wCA;EACE,+BAAA;AAkxCF;;AA/wCA;EACE,mBAAA;EACA,sBAAA;AAkxCF;;AA/wCA;EACE,oBAAA;EACA,qBAAA;AAkxCF;;AAhxCA;EACE,+BAAA;AAmxCF;;AAhxCA;EACE,oBAAA;AAmxCF;;AAjxCA;EACE,qBAAA;AAoxCF;;AAlxCA;EACE,+BAAA;AAqxCF;;AAlxCA;EACE,gBAAA;AAqxCF;;AAnxCA;EACE,gCAAA;AAsxCF;;AAnxCA;EACE,oBAAA;EACA,uBAAA;AAsxCF;;AAnxCA;EACE,qBAAA;EACA,sBAAA;AAsxCF;;AApxCA;EACE,gCAAA;AAuxCF;;AApxCA;EACE,qBAAA;AAuxCF;;AArxCA;EACE,sBAAA;AAwxCF;;AAtxCA;EACE,gCAAA;AAyxCF;;AAtxCA;EACE,aAAA;AAyxCF;;AAvxCA;EACE,6BAAA;AA0xCF;;AAvxCA;EACE,iBAAA;EACA,oBAAA;AA0xCF;;AAvxCA;EACE,kBAAA;EACA,mBAAA;AA0xCF;;AAxxCA;EACE,6BAAA;AA2xCF;;AAxxCA;EACE,kBAAA;AA2xCF;;AAzxCA;EACE,mBAAA;AA4xCF;;AA1xCA;EACE,6BAAA;AA6xCF;;AA1xCA;EACE,gBAAA;AA6xCF;;AA3xCA;EACE,gCAAA;AA8xCF;;AA3xCA;EACE,oBAAA;EACA,uBAAA;AA8xCF;;AA3xCA;EACE,qBAAA;EACA,sBAAA;AA8xCF;;AA5xCA;EACE,gCAAA;AA+xCF;;AA5xCA;EACE,qBAAA;AA+xCF;;AA7xCA;EACE,sBAAA;AAgyCF;;AA9xCA;EACE,gCAAA;AAiyCF;;AA9xCA;EACE,eAAA;AAiyCF;;AA/xCA;EACE,+BAAA;AAkyCF;;AA/xCA;EACE,mBAAA;EACA,sBAAA;AAkyCF;;AA/xCA;EACE,oBAAA;EACA,qBAAA;AAkyCF;;AAhyCA;EACE,+BAAA;AAmyCF;;AAhyCA;EACE,oBAAA;AAmyCF;;AAjyCA;EACE,qBAAA;AAoyCF;;AAlyCA;EACE,+BAAA;AAqyCF;;AAlyCA;EACE;IACE,aAAA;EAqyCF;EAnyCA;IACE,6BAAA;EAqyCF;EAnyCA;IACE,iBAAA;IACA,oBAAA;EAqyCF;EAnyCA;IACE,kBAAA;IACA,mBAAA;EAqyCF;EAnyCA;IACE,6BAAA;EAqyCF;EAnyCA;IACE,kBAAA;EAqyCF;EAnyCA;IACE,mBAAA;EAqyCF;EAnyCA;IACE,6BAAA;EAqyCF;EAnyCA;IACE,gBAAA;EAqyCF;EAnyCA;IACE,gCAAA;EAqyCF;EAnyCA;IACE,oBAAA;IACA,uBAAA;EAqyCF;EAnyCA;IACE,qBAAA;IACA,sBAAA;EAqyCF;EAnyCA;IACE,gCAAA;EAqyCF;EAnyCA;IACE,qBAAA;EAqyCF;EAnyCA;IACE,sBAAA;EAqyCF;EAnyCA;IACE,gCAAA;EAqyCF;EAnyCA;IACE,eAAA;EAqyCF;EAnyCA;IACE,+BAAA;EAqyCF;EAnyCA;IACE,mBAAA;IACA,sBAAA;EAqyCF;EAnyCA;IACE,oBAAA;IACA,qBAAA;EAqyCF;EAnyCA;IACE,+BAAA;EAqyCF;EAnyCA;IACE,oBAAA;EAqyCF;EAnyCA;IACE,qBAAA;EAqyCF;EAnyCA;IACE,+BAAA;EAqyCF;EAnyCA;IACE,gBAAA;EAqyCF;EAnyCA;IACE,gCAAA;EAqyCF;EAnyCA;IACE,oBAAA;IACA,uBAAA;EAqyCF;EAnyCA;IACE,qBAAA;IACA,sBAAA;EAqyCF;EAnyCA;IACE,gCAAA;EAqyCF;EAnyCA;IACE,qBAAA;EAqyCF;EAnyCA;IACE,sBAAA;EAqyCF;EAnyCA;IACE,gCAAA;EAqyCF;EAnyCA;IACE,aAAA;EAqyCF;EAnyCA;IACE,6BAAA;EAqyCF;EAnyCA;IACE,iBAAA;IACA,oBAAA;EAqyCF;EAnyCA;IACE,kBAAA;IACA,mBAAA;EAqyCF;EAnyCA;IACE,6BAAA;EAqyCF;EAnyCA;IACE,kBAAA;EAqyCF;EAnyCA;IACE,mBAAA;EAqyCF;EAnyCA;IACE,6BAAA;EAqyCF;EAnyCA;IACE,gBAAA;EAqyCF;EAnyCA;IACE,gCAAA;EAqyCF;EAnyCA;IACE,oBAAA;IACA,uBAAA;EAqyCF;EAnyCA;IACE,qBAAA;IACA,sBAAA;EAqyCF;EAnyCA;IACE,gCAAA;EAqyCF;EAnyCA;IACE,qBAAA;EAqyCF;EAnyCA;IACE,sBAAA;EAqyCF;EAnyCA;IACE,gCAAA;EAqyCF;EAnyCA;IACE,eAAA;EAqyCF;EAnyCA;IACE,+BAAA;EAqyCF;EAnyCA;IACE,mBAAA;IACA,sBAAA;EAqyCF;EAnyCA;IACE,oBAAA;IACA,qBAAA;EAqyCF;EAnyCA;IACE,+BAAA;EAqyCF;EAnyCA;IACE,oBAAA;EAqyCF;EAnyCA;IACE,qBAAA;EAqyCF;EAnyCA;IACE,+BAAA;EAqyCF;EAnyCA;IACE,gBAAA;EAqyCF;EAnyCA;IACE,gCAAA;EAqyCF;EAnyCA;IACE,oBAAA;IACA,uBAAA;EAqyCF;EAnyCA;IACE,qBAAA;IACA,sBAAA;EAqyCF;EAnyCA;IACE,gCAAA;EAqyCF;EAnyCA;IACE,qBAAA;EAqyCF;EAnyCA;IACE,sBAAA;EAqyCF;EAnyCA;IACE,gCAAA;EAqyCF;EAnyCA;IACE,aAAA;EAqyCF;EAnyCA;IACE,6BAAA;EAqyCF;EAnyCA;IACE,iBAAA;IACA,oBAAA;EAqyCF;EAnyCA;IACE,kBAAA;IACA,mBAAA;EAqyCF;EAnyCA;IACE,6BAAA;EAqyCF;EAnyCA;IACE,kBAAA;EAqyCF;EAnyCA;IACE,mBAAA;EAqyCF;EAnyCA;IACE,6BAAA;EAqyCF;EAnyCA;IACE,gBAAA;EAqyCF;EAnyCA;IACE,gCAAA;EAqyCF;EAnyCA;IACE,oBAAA;IACA,uBAAA;EAqyCF;EAnyCA;IACE,qBAAA;IACA,sBAAA;EAqyCF;EAnyCA;IACE,gCAAA;EAqyCF;EAnyCA;IACE,qBAAA;EAqyCF;EAnyCA;IACE,sBAAA;EAqyCF;EAnyCA;IACE,gCAAA;EAqyCF;EAnyCA;IACE,eAAA;EAqyCF;EAnyCA;IACE,+BAAA;EAqyCF;EAnyCA;IACE,mBAAA;IACA,sBAAA;EAqyCF;EAnyCA;IACE,oBAAA;IACA,qBAAA;EAqyCF;EAnyCA;IACE,+BAAA;EAqyCF;EAnyCA;IACE,oBAAA;EAqyCF;EAnyCA;IACE,qBAAA;EAqyCF;EAnyCA;IACE,+BAAA;EAqyCF;AACF;AAnyCA;EACE;IACE,aAAA;EAqyCF;EAnyCA;IACE,6BAAA;EAqyCF;EAnyCA;IACE,iBAAA;IACA,oBAAA;EAqyCF;EAnyCA;IACE,kBAAA;IACA,mBAAA;EAqyCF;EAnyCA;IACE,6BAAA;EAqyCF;EAnyCA;IACE,kBAAA;EAqyCF;EAnyCA;IACE,mBAAA;EAqyCF;EAnyCA;IACE,6BAAA;EAqyCF;EAnyCA;IACE,gBAAA;EAqyCF;EAnyCA;IACE,gCAAA;EAqyCF;EAnyCA;IACE,oBAAA;IACA,uBAAA;EAqyCF;EAnyCA;IACE,qBAAA;IACA,sBAAA;EAqyCF;EAnyCA;IACE,gCAAA;EAqyCF;EAnyCA;IACE,qBAAA;EAqyCF;EAnyCA;IACE,sBAAA;EAqyCF;EAnyCA;IACE,gCAAA;EAqyCF;EAnyCA;IACE,eAAA;EAqyCF;EAnyCA;IACE,+BAAA;EAqyCF;EAnyCA;IACE,mBAAA;IACA,sBAAA;EAqyCF;EAnyCA;IACE,oBAAA;IACA,qBAAA;EAqyCF;EAnyCA;IACE,+BAAA;EAqyCF;EAnyCA;IACE,oBAAA;EAqyCF;EAnyCA;IACE,qBAAA;EAqyCF;EAnyCA;IACE,+BAAA;EAqyCF;EAnyCA;IACE,gBAAA;EAqyCF;EAnyCA;IACE,gCAAA;EAqyCF;EAnyCA;IACE,oBAAA;IACA,uBAAA;EAqyCF;EAnyCA;IACE,qBAAA;IACA,sBAAA;EAqyCF;EAnyCA;IACE,gCAAA;EAqyCF;EAnyCA;IACE,qBAAA;EAqyCF;EAnyCA;IACE,sBAAA;EAqyCF;EAnyCA;IACE,gCAAA;EAqyCF;EAnyCA;IACE,aAAA;EAqyCF;EAnyCA;IACE,6BAAA;EAqyCF;EAnyCA;IACE,iBAAA;IACA,oBAAA;EAqyCF;EAnyCA;IACE,kBAAA;IACA,mBAAA;EAqyCF;EAnyCA;IACE,6BAAA;EAqyCF;EAnyCA;IACE,kBAAA;EAqyCF;EAnyCA;IACE,mBAAA;EAqyCF;EAnyCA;IACE,6BAAA;EAqyCF;EAnyCA;IACE,gBAAA;EAqyCF;EAnyCA;IACE,gCAAA;EAqyCF;EAnyCA;IACE,oBAAA;IACA,uBAAA;EAqyCF;EAnyCA;IACE,qBAAA;IACA,sBAAA;EAqyCF;EAnyCA;IACE,gCAAA;EAqyCF;EAnyCA;IACE,qBAAA;EAqyCF;EAnyCA;IACE,sBAAA;EAqyCF;EAnyCA;IACE,gCAAA;EAqyCF;EAnyCA;IACE,eAAA;EAqyCF;EAnyCA;IACE,+BAAA;EAqyCF;EAnyCA;IACE,mBAAA;IACA,sBAAA;EAqyCF;EAnyCA;IACE,oBAAA;IACA,qBAAA;EAqyCF;EAnyCA;IACE,+BAAA;EAqyCF;EAnyCA;IACE,oBAAA;EAqyCF;EAnyCA;IACE,qBAAA;EAqyCF;EAnyCA;IACE,+BAAA;EAqyCF;EAnyCA;IACE,gBAAA;EAqyCF;EAnyCA;IACE,gCAAA;EAqyCF;EAnyCA;IACE,oBAAA;IACA,uBAAA;EAqyCF;EAnyCA;IACE,qBAAA;IACA,sBAAA;EAqyCF;EAnyCA;IACE,gCAAA;EAqyCF;EAnyCA;IACE,qBAAA;EAqyCF;EAnyCA;IACE,sBAAA;EAqyCF;EAnyCA;IACE,gCAAA;EAqyCF;EAnyCA;IACE,aAAA;EAqyCF;EAnyCA;IACE,6BAAA;EAqyCF;EAnyCA;IACE,iBAAA;IACA,oBAAA;EAqyCF;EAnyCA;IACE,kBAAA;IACA,mBAAA;EAqyCF;EAnyCA;IACE,6BAAA;EAqyCF;EAnyCA;IACE,kBAAA;EAqyCF;EAnyCA;IACE,mBAAA;EAqyCF;EAnyCA;IACE,6BAAA;EAqyCF;EAnyCA;IACE,gBAAA;EAqyCF;EAnyCA;IACE,gCAAA;EAqyCF;EAnyCA;IACE,oBAAA;IACA,uBAAA;EAqyCF;EAnyCA;IACE,qBAAA;IACA,sBAAA;EAqyCF;EAnyCA;IACE,gCAAA;EAqyCF;EAnyCA;IACE,qBAAA;EAqyCF;EAnyCA;IACE,sBAAA;EAqyCF;EAnyCA;IACE,gCAAA;EAqyCF;EAnyCA;IACE,eAAA;EAqyCF;EAnyCA;IACE,+BAAA;EAqyCF;EAnyCA;IACE,mBAAA;IACA,sBAAA;EAqyCF;EAnyCA;IACE,oBAAA;IACA,qBAAA;EAqyCF;EAnyCA;IACE,+BAAA;EAqyCF;EAnyCA;IACE,oBAAA;EAqyCF;EAnyCA;IACE,qBAAA;EAqyCF;EAnyCA;IACE,+BAAA;EAqyCF;AACF;AAnyCA;EACE;IACE,aAAA;EAqyCF;EAnyCA;IACE,6BAAA;EAqyCF;EAnyCA;IACE,iBAAA;IACA,oBAAA;EAqyCF;EAnyCA;IACE,kBAAA;IACA,mBAAA;EAqyCF;EAnyCA;IACE,6BAAA;EAqyCF;EAnyCA;IACE,kBAAA;EAqyCF;EAnyCA;IACE,mBAAA;EAqyCF;EAnyCA;IACE,6BAAA;EAqyCF;EAnyCA;IACE,gBAAA;EAqyCF;EAnyCA;IACE,gCAAA;EAqyCF;EAnyCA;IACE,oBAAA;IACA,uBAAA;EAqyCF;EAnyCA;IACE,qBAAA;IACA,sBAAA;EAqyCF;EAnyCA;IACE,gCAAA;EAqyCF;EAnyCA;IACE,qBAAA;EAqyCF;EAnyCA;IACE,sBAAA;EAqyCF;EAnyCA;IACE,gCAAA;EAqyCF;EAnyCA;IACE,eAAA;EAqyCF;EAnyCA;IACE,+BAAA;EAqyCF;EAnyCA;IACE,mBAAA;IACA,sBAAA;EAqyCF;EAnyCA;IACE,oBAAA;IACA,qBAAA;EAqyCF;EAnyCA;IACE,+BAAA;EAqyCF;EAnyCA;IACE,oBAAA;EAqyCF;EAnyCA;IACE,qBAAA;EAqyCF;EAnyCA;IACE,+BAAA;EAqyCF;EAnyCA;IACE,gBAAA;EAqyCF;EAnyCA;IACE,gCAAA;EAqyCF;EAnyCA;IACE,oBAAA;IACA,uBAAA;EAqyCF;EAnyCA;IACE,qBAAA;IACA,sBAAA;EAqyCF;EAnyCA;IACE,gCAAA;EAqyCF;EAnyCA;IACE,qBAAA;EAqyCF;EAnyCA;IACE,sBAAA;EAqyCF;EAnyCA;IACE,gCAAA;EAqyCF;EAnyCA;IACE,aAAA;EAqyCF;EAnyCA;IACE,6BAAA;EAqyCF;EAnyCA;IACE,iBAAA;IACA,oBAAA;EAqyCF;EAnyCA;IACE,kBAAA;IACA,mBAAA;EAqyCF;EAnyCA;IACE,6BAAA;EAqyCF;EAnyCA;IACE,kBAAA;EAqyCF;EAnyCA;IACE,mBAAA;EAqyCF;EAnyCA;IACE,6BAAA;EAqyCF;EAnyCA;IACE,gBAAA;EAqyCF;EAnyCA;IACE,gCAAA;EAqyCF;EAnyCA;IACE,oBAAA;IACA,uBAAA;EAqyCF;EAnyCA;IACE,qBAAA;IACA,sBAAA;EAqyCF;EAnyCA;IACE,gCAAA;EAqyCF;EAnyCA;IACE,qBAAA;EAqyCF;EAnyCA;IACE,sBAAA;EAqyCF;EAnyCA;IACE,gCAAA;EAqyCF;EAnyCA;IACE,eAAA;EAqyCF;EAnyCA;IACE,+BAAA;EAqyCF;EAnyCA;IACE,mBAAA;IACA,sBAAA;EAqyCF;EAnyCA;IACE,oBAAA;IACA,qBAAA;EAqyCF;EAnyCA;IACE,+BAAA;EAqyCF;EAnyCA;IACE,oBAAA;EAqyCF;EAnyCA;IACE,qBAAA;EAqyCF;EAnyCA;IACE,+BAAA;EAqyCF;EAnyCA;IACE,gBAAA;EAqyCF;EAnyCA;IACE,gCAAA;EAqyCF;EAnyCA;IACE,oBAAA;IACA,uBAAA;EAqyCF;EAnyCA;IACE,qBAAA;IACA,sBAAA;EAqyCF;EAnyCA;IACE,gCAAA;EAqyCF;EAnyCA;IACE,qBAAA;EAqyCF;EAnyCA;IACE,sBAAA;EAqyCF;EAnyCA;IACE,gCAAA;EAqyCF;EAnyCA;IACE,aAAA;EAqyCF;EAnyCA;IACE,6BAAA;EAqyCF;EAnyCA;IACE,iBAAA;IACA,oBAAA;EAqyCF;EAnyCA;IACE,kBAAA;IACA,mBAAA;EAqyCF;EAnyCA;IACE,6BAAA;EAqyCF;EAnyCA;IACE,kBAAA;EAqyCF;EAnyCA;IACE,mBAAA;EAqyCF;EAnyCA;IACE,6BAAA;EAqyCF;EAnyCA;IACE,gBAAA;EAqyCF;EAnyCA;IACE,gCAAA;EAqyCF;EAnyCA;IACE,oBAAA;IACA,uBAAA;EAqyCF;EAnyCA;IACE,qBAAA;IACA,sBAAA;EAqyCF;EAnyCA;IACE,gCAAA;EAqyCF;EAnyCA;IACE,qBAAA;EAqyCF;EAnyCA;IACE,sBAAA;EAqyCF;EAnyCA;IACE,gCAAA;EAqyCF;EAnyCA;IACE,eAAA;EAqyCF;EAnyCA;IACE,+BAAA;EAqyCF;EAnyCA;IACE,mBAAA;IACA,sBAAA;EAqyCF;EAnyCA;IACE,oBAAA;IACA,qBAAA;EAqyCF;EAnyCA;IACE,+BAAA;EAqyCF;EAnyCA;IACE,oBAAA;EAqyCF;EAnyCA;IACE,qBAAA;EAqyCF;EAnyCA;IACE,+BAAA;EAqyCF;AACF;AAnyCA;EACE;IACE,aAAA;EAqyCF;EAnyCA;IACE,6BAAA;EAqyCF;EAnyCA;IACE,iBAAA;IACA,oBAAA;EAqyCF;EAnyCA;IACE,kBAAA;IACA,mBAAA;EAqyCF;EAnyCA;IACE,6BAAA;EAqyCF;EAnyCA;IACE,kBAAA;EAqyCF;EAnyCA;IACE,mBAAA;EAqyCF;EAnyCA;IACE,6BAAA;EAqyCF;EAnyCA;IACE,gBAAA;EAqyCF;EAnyCA;IACE,gCAAA;EAqyCF;EAnyCA;IACE,oBAAA;IACA,uBAAA;EAqyCF;EAnyCA;IACE,qBAAA;IACA,sBAAA;EAqyCF;EAnyCA;IACE,gCAAA;EAqyCF;EAnyCA;IACE,qBAAA;EAqyCF;EAnyCA;IACE,sBAAA;EAqyCF;EAnyCA;IACE,gCAAA;EAqyCF;EAnyCA;IACE,eAAA;EAqyCF;EAnyCA;IACE,+BAAA;EAqyCF;EAnyCA;IACE,mBAAA;IACA,sBAAA;EAqyCF;EAnyCA;IACE,oBAAA;IACA,qBAAA;EAqyCF;EAnyCA;IACE,+BAAA;EAqyCF;EAnyCA;IACE,oBAAA;EAqyCF;EAnyCA;IACE,qBAAA;EAqyCF;EAnyCA;IACE,+BAAA;EAqyCF;EAnyCA;IACE,gBAAA;EAqyCF;EAnyCA;IACE,gCAAA;EAqyCF;EAnyCA;IACE,oBAAA;IACA,uBAAA;EAqyCF;EAnyCA;IACE,qBAAA;IACA,sBAAA;EAqyCF;EAnyCA;IACE,gCAAA;EAqyCF;EAnyCA;IACE,qBAAA;EAqyCF;EAnyCA;IACE,sBAAA;EAqyCF;EAnyCA;IACE,gCAAA;EAqyCF;EAnyCA;IACE,aAAA;EAqyCF;EAnyCA;IACE,6BAAA;EAqyCF;EAnyCA;IACE,iBAAA;IACA,oBAAA;EAqyCF;EAnyCA;IACE,kBAAA;IACA,mBAAA;EAqyCF;EAnyCA;IACE,6BAAA;EAqyCF;EAnyCA;IACE,kBAAA;EAqyCF;EAnyCA;IACE,mBAAA;EAqyCF;EAnyCA;IACE,6BAAA;EAqyCF;EAnyCA;IACE,gBAAA;EAqyCF;EAnyCA;IACE,gCAAA;EAqyCF;EAnyCA;IACE,oBAAA;IACA,uBAAA;EAqyCF;EAnyCA;IACE,qBAAA;IACA,sBAAA;EAqyCF;EAnyCA;IACE,gCAAA;EAqyCF;EAnyCA;IACE,qBAAA;EAqyCF;EAnyCA;IACE,sBAAA;EAqyCF;EAnyCA;IACE,gCAAA;EAqyCF;EAnyCA;IACE,eAAA;EAqyCF;EAnyCA;IACE,+BAAA;EAqyCF;EAnyCA;IACE,mBAAA;IACA,sBAAA;EAqyCF;EAnyCA;IACE,oBAAA;IACA,qBAAA;EAqyCF;EAnyCA;IACE,+BAAA;EAqyCF;EAnyCA;IACE,oBAAA;EAqyCF;EAnyCA;IACE,qBAAA;EAqyCF;EAnyCA;IACE,+BAAA;EAqyCF;EAnyCA;IACE,gBAAA;EAqyCF;EAnyCA;IACE,gCAAA;EAqyCF;EAnyCA;IACE,oBAAA;IACA,uBAAA;EAqyCF;EAnyCA;IACE,qBAAA;IACA,sBAAA;EAqyCF;EAnyCA;IACE,gCAAA;EAqyCF;EAnyCA;IACE,qBAAA;EAqyCF;EAnyCA;IACE,sBAAA;EAqyCF;EAnyCA;IACE,gCAAA;EAqyCF;EAnyCA;IACE,aAAA;EAqyCF;EAnyCA;IACE,6BAAA;EAqyCF;EAnyCA;IACE,iBAAA;IACA,oBAAA;EAqyCF;EAnyCA;IACE,kBAAA;IACA,mBAAA;EAqyCF;EAnyCA;IACE,6BAAA;EAqyCF;EAnyCA;IACE,kBAAA;EAqyCF;EAnyCA;IACE,mBAAA;EAqyCF;EAnyCA;IACE,6BAAA;EAqyCF;EAnyCA;IACE,gBAAA;EAqyCF;EAnyCA;IACE,gCAAA;EAqyCF;EAnyCA;IACE,oBAAA;IACA,uBAAA;EAqyCF;EAnyCA;IACE,qBAAA;IACA,sBAAA;EAqyCF;EAnyCA;IACE,gCAAA;EAqyCF;EAnyCA;IACE,qBAAA;EAqyCF;EAnyCA;IACE,sBAAA;EAqyCF;EAnyCA;IACE,gCAAA;EAqyCF;EAnyCA;IACE,eAAA;EAqyCF;EAnyCA;IACE,+BAAA;EAqyCF;EAnyCA;IACE,mBAAA;IACA,sBAAA;EAqyCF;EAnyCA;IACE,oBAAA;IACA,qBAAA;EAqyCF;EAnyCA;IACE,+BAAA;EAqyCF;EAnyCA;IACE,oBAAA;EAqyCF;EAnyCA;IACE,qBAAA;EAqyCF;EAnyCA;IACE,+BAAA;EAqyCF;AACF;AAnyCA;EACE;IACE,aAAA;EAqyCF;EAnyCA;IACE,6BAAA;EAqyCF;EAnyCA;IACE,iBAAA;IACA,oBAAA;EAqyCF;EAnyCA;IACE,kBAAA;IACA,mBAAA;EAqyCF;EAnyCA;IACE,6BAAA;EAqyCF;EAnyCA;IACE,kBAAA;EAqyCF;EAnyCA;IACE,mBAAA;EAqyCF;EAnyCA;IACE,6BAAA;EAqyCF;EAnyCA;IACE,gBAAA;EAqyCF;EAnyCA;IACE,gCAAA;EAqyCF;EAnyCA;IACE,oBAAA;IACA,uBAAA;EAqyCF;EAnyCA;IACE,qBAAA;IACA,sBAAA;EAqyCF;EAnyCA;IACE,gCAAA;EAqyCF;EAnyCA;IACE,qBAAA;EAqyCF;EAnyCA;IACE,sBAAA;EAqyCF;EAnyCA;IACE,gCAAA;EAqyCF;EAnyCA;IACE,eAAA;EAqyCF;EAnyCA;IACE,+BAAA;EAqyCF;EAnyCA;IACE,mBAAA;IACA,sBAAA;EAqyCF;EAnyCA;IACE,oBAAA;IACA,qBAAA;EAqyCF;EAnyCA;IACE,+BAAA;EAqyCF;EAnyCA;IACE,oBAAA;EAqyCF;EAnyCA;IACE,qBAAA;EAqyCF;EAnyCA;IACE,+BAAA;EAqyCF;EAnyCA;IACE,gBAAA;EAqyCF;EAnyCA;IACE,gCAAA;EAqyCF;EAnyCA;IACE,oBAAA;IACA,uBAAA;EAqyCF;EAnyCA;IACE,qBAAA;IACA,sBAAA;EAqyCF;EAnyCA;IACE,gCAAA;EAqyCF;EAnyCA;IACE,qBAAA;EAqyCF;EAnyCA;IACE,sBAAA;EAqyCF;EAnyCA;IACE,gCAAA;EAqyCF;EAnyCA;IACE,aAAA;EAqyCF;EAnyCA;IACE,6BAAA;EAqyCF;EAnyCA;IACE,iBAAA;IACA,oBAAA;EAqyCF;EAnyCA;IACE,kBAAA;IACA,mBAAA;EAqyCF;EAnyCA;IACE,6BAAA;EAqyCF;EAnyCA;IACE,kBAAA;EAqyCF;EAnyCA;IACE,mBAAA;EAqyCF;EAnyCA;IACE,6BAAA;EAqyCF;EAnyCA;IACE,gBAAA;EAqyCF;EAnyCA;IACE,gCAAA;EAqyCF;EAnyCA;IACE,oBAAA;IACA,uBAAA;EAqyCF;EAnyCA;IACE,qBAAA;IACA,sBAAA;EAqyCF;EAnyCA;IACE,gCAAA;EAqyCF;EAnyCA;IACE,qBAAA;EAqyCF;EAnyCA;IACE,sBAAA;EAqyCF;EAnyCA;IACE,gCAAA;EAqyCF;EAnyCA;IACE,eAAA;EAqyCF;EAnyCA;IACE,+BAAA;EAqyCF;EAnyCA;IACE,mBAAA;IACA,sBAAA;EAqyCF;EAnyCA;IACE,oBAAA;IACA,qBAAA;EAqyCF;EAnyCA;IACE,+BAAA;EAqyCF;EAnyCA;IACE,oBAAA;EAqyCF;EAnyCA;IACE,qBAAA;EAqyCF;EAnyCA;IACE,+BAAA;EAqyCF;EAnyCA;IACE,gBAAA;EAqyCF;EAnyCA;IACE,gCAAA;EAqyCF;EAnyCA;IACE,oBAAA;IACA,uBAAA;EAqyCF;EAnyCA;IACE,qBAAA;IACA,sBAAA;EAqyCF;EAnyCA;IACE,gCAAA;EAqyCF;EAnyCA;IACE,qBAAA;EAqyCF;EAnyCA;IACE,sBAAA;EAqyCF;EAnyCA;IACE,gCAAA;EAqyCF;EAnyCA;IACE,aAAA;EAqyCF;EAnyCA;IACE,6BAAA;EAqyCF;EAnyCA;IACE,iBAAA;IACA,oBAAA;EAqyCF;EAnyCA;IACE,kBAAA;IACA,mBAAA;EAqyCF;EAnyCA;IACE,6BAAA;EAqyCF;EAnyCA;IACE,kBAAA;EAqyCF;EAnyCA;IACE,mBAAA;EAqyCF;EAnyCA;IACE,6BAAA;EAqyCF;EAnyCA;IACE,gBAAA;EAqyCF;EAnyCA;IACE,gCAAA;EAqyCF;EAnyCA;IACE,oBAAA;IACA,uBAAA;EAqyCF;EAnyCA;IACE,qBAAA;IACA,sBAAA;EAqyCF;EAnyCA;IACE,gCAAA;EAqyCF;EAnyCA;IACE,qBAAA;EAqyCF;EAnyCA;IACE,sBAAA;EAqyCF;EAnyCA;IACE,gCAAA;EAqyCF;EAnyCA;IACE,eAAA;EAqyCF;EAnyCA;IACE,+BAAA;EAqyCF;EAnyCA;IACE,mBAAA;IACA,sBAAA;EAqyCF;EAnyCA;IACE,oBAAA;IACA,qBAAA;EAqyCF;EAnyCA;IACE,+BAAA;EAqyCF;EAnyCA;IACE,oBAAA;EAqyCF;EAnyCA;IACE,qBAAA;EAqyCF;EAnyCA;IACE,+BAAA;EAqyCF;AACF;AAnyCA;EACE,yCAAA;AAqyCF;;AAnyCA;EACE,eAAA;EACA,gBAAA;EACA,8DAAA;AAsyCF;;AApyCA;EACE,kBAAA;EACA,YAAA;EACA,cAAA;EACA,eAAA;EACA,cAAA;EACA,sBAAA;EACA,qBAAA;EACA,8BAAA;EACA,6BAAA;EACA,oCAAA;EAEA,qDAAA;EACA,cAAA;EACA,sBAAA;AAuyCF;;AAryCA;EACE,mCAAA;AAwyCF;;AAtyCA;EACE,qBAAA;AAyyCF;;AAtyCA;EACE,mCAAA;EACA,6CAAA;EACA,wDAAA;EACA,6CAAA;EACA,0CAAA;EACA,2CAAA;EACA,sCAAA;EACA,oDAAA;AAyyCF;;AAtyCA;EACE,wBAAA;EACA,kCAAA;EACA,+BAAA;EACA,wDAAA;EACA,yCAAA;AAyyCF;;AAtyCA;EACE,wCAAA;AAyyCF;;AAvyCA;EACE,mBAAA;EACA,eAAA;AA0yCF;;AAxyCA;EACE,0CAAA;EACA,+BAAA;AA2yCF;;AAxyCA;EACE,wBAAA;EACA,yDAAA;AA2yCF;;AAxyCA;EACE,eAAA;AA2yCF;;AAzyCA;EACE,aAAA;EACA,cAAA;EACA,gCAAA;EACA,wBAAA;EACA,mBAAA;EACA,uBAAA;AA4yCF;;AA1yCA;;EAEE,wBAAA;AA6yCF;;AA3yCA;EACE,gCAAA;EACA,oBAAA;AA8yCF;;AA5yCA;;EAEE,2BAAA;AA+yCF;;AA7yCA;EACE,aAAA;EACA,cAAA;EACA,mBAAA;EACA,uBAAA;EACA,gCAAA;AAgzCF;;AA9yCA;EACE,oBAAA;AAizCF;;AA/yCA;EACE,aAAA;AAkzCF;;AAhzCA;;EAEE,wBAAA;AAmzCF;;AAjzCA;EACE,gCAAA;AAozCF;;AAlzCA;EACE,aAAA;AAqzCF;;AAnzCA;EACE,oBAAA;AAszCF;;AApzCA;;EAEE,2BAAA;AAuzCF;;AArzCA;EACE,SAAA;AAwzCF;;AAtzCA;EACE,6BAAA;EACA,SAAA;EACA,gBAAA;EACA,eAAA;EACA,gBAAA;AAyzCF;;AAtzCA;EACE,kBAAA;EACA,qBAAA;EACA,uBAAA;EACA,4BAAA;EACA,sBAAA;AAyzCF;;AAvzCA;EACE,iCAAA;AA0zCF;;AAxzCA;EACE,YAAA;EACA,aAAA;EACA,uBAAA;EACA,4BAAA;EACA,sBAAA;AA2zCF;;AAzzCA;EACE,eAAA;EACA,kBAAA;EACA,gCAAA;AA4zCF;;AA1zCA;EACE,UAAA;EACA,MAAA;AA6zCF;;AA3zCA;EACE,mBAAA;EACA,oBAAA;EACA,gBAAA;EACA,UAAA;AA8zCF;;AA5zCA;;EAEE,kBAAA;EACA,UAAA;EACA,SAAA;AA+zCF;;AA7zCA;EACE,aAAA;AAg0CF;;AA9zCA;EACE,aAAA;AAi0CF;;AA/zCA;EACE,aAAA;AAk0CF;;AAh0CA;;EAEE,aAAA;AAm0CF;;AAj0CA;EACE,kBAAA;AAo0CF;;AAl0CA;EACE,kBAAA;AAq0CF;;AAn0CA;EACE,UAAA;EACA,MAAA;EACA,+BAAA;AAs0CF;;AAp0CA;;EAEE,UAAA;EACA,SAAA;EACA,kCAAA;AAu0CF;;AAr0CA;EACE,mCAAA;EACA,gCAAA;AAw0CF;;AAr0CA;EACE,qBAAA;EACA,cAAA;EACA,kBAAA;EACA,uBAAA;AAw0CF;;AAt0CA;EACE,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,gBAAA;EACA,mCAAA;EACA,2CAAA;EACA,4BAAA;EACA,kCAAA;EACA,sBAAA;EACA,uBAAA;AAy0CF;;AAv0CA;EACE,uBAAA;AA00CF;;AAx0CA;EACE,kBAAA;EACA,mBAAA;EACA,MAAA;EACA,SAAA;EACA,uDAAA;AA20CF;;AAz0CA;EACE,WAAA;EACA,cAAA;EACA,qBAAA;EACA,uBAAA;AA40CF;;AA10CA;;;EAGE,2BAAA;AA60CF;;AA30CA;;;EAGE,kBAAA;AA80CF;;AA50CA;;;EAGE,kBAAA;AA+0CF;;AA70CA;EACE,WAAA;EACA,YAAA;AAg1CF;;AA90CA;EACE,WAAA;EACA,YAAA;AAi1CF;;AA/0CA;EACE,WAAA;EACA,YAAA;AAk1CF;;AAh1CA;EACE,WAAA;EACA,YAAA;EACA,eAAA;AAm1CF;;AAj1CA;EACE,YAAA;EACA,WAAA;AAo1CF;;AAl1CA;EACE,YAAA;EACA,WAAA;EACA,eAAA;AAq1CF;;AAn1CA;EACE,WAAA;EACA,YAAA;AAs1CF;;AAp1CA;EACE,WAAA;EACA,YAAA;AAu1CF;;AAr1CA;EACE,WAAA;EACA,YAAA;AAw1CF;;AAt1CA;EACE,WAAA;EACA,YAAA;EACA,eAAA;AAy1CF;;AAv1CA;EACE,YAAA;EACA,WAAA;AA01CF;;AAx1CA;EACE,YAAA;EACA,WAAA;EACA,eAAA;AA21CF;;AAz1CA;EACE,WAAA;EACA,YAAA;AA41CF;;AA11CA;EACE,WAAA;EACA,YAAA;AA61CF;;AA31CA;EACE,WAAA;EACA,YAAA;AA81CF;;AA51CA;EACE,WAAA;EACA,YAAA;EACA,eAAA;AA+1CF;;AA71CA;EACE,YAAA;EACA,aAAA;AAg2CF;;AA91CA;EACE,YAAA;EACA,aAAA;EACA,eAAA;AAi2CF;;AA/1CA;EACE,WAAA;EACA,YAAA;AAk2CF;;AAh2CA;EACE,WAAA;EACA,YAAA;AAm2CF;;AAj2CA;EACE,WAAA;EACA,YAAA;AAo2CF;;AAl2CA;EACE,WAAA;EACA,YAAA;EACA,eAAA;AAq2CF;;AAn2CA;EACE,YAAA;EACA,WAAA;AAs2CF;;AAp2CA;EACE,YAAA;EACA,WAAA;EACA,eAAA;AAu2CF;;AAr2CA;EACE,WAAA;EACA,YAAA;AAw2CF;;AAt2CA;EACE,WAAA;EACA,YAAA;AAy2CF;;AAv2CA;EACE,WAAA;EACA,YAAA;AA02CF;;AAx2CA;EACE,WAAA;EACA,YAAA;EACA,eAAA;AA22CF;;AAz2CA;EACE,YAAA;EACA,aAAA;AA42CF;;AA12CA;EACE,YAAA;EACA,aAAA;EACA,eAAA;AA62CF;;AA32CA;EACE,WAAA;EACA,YAAA;AA82CF;;AA52CA;EACE,WAAA;EACA,YAAA;AA+2CF;;AA72CA;EACE,WAAA;EACA,YAAA;AAg3CF;;AA92CA;EACE,WAAA;EACA,YAAA;EACA,eAAA;AAi3CF;;AA/2CA;EACE,YAAA;EACA,WAAA;AAk3CF;;AAh3CA;EACE,YAAA;EACA,WAAA;EACA,eAAA;AAm3CF;;AAj3CA;EACE,WAAA;EACA,YAAA;AAo3CF;;AAl3CA;EACE,WAAA;EACA,YAAA;AAq3CF;;AAn3CA;EACE,WAAA;EACA,YAAA;AAs3CF;;AAp3CA;EACE,WAAA;EACA,YAAA;EACA,eAAA;AAu3CF;;AAr3CA;EACE,YAAA;EACA,aAAA;AAw3CF;;AAt3CA;EACE,YAAA;EACA,aAAA;EACA,eAAA;AAy3CF;;AAv3CA;EACE,WAAA;EACA,YAAA;AA03CF;;AAx3CA;EACE,WAAA;EACA,YAAA;AA23CF;;AAz3CA;EACE,WAAA;EACA,YAAA;AA43CF;;AA13CA;EACE,WAAA;EACA,YAAA;EACA,eAAA;AA63CF;;AA33CA;EACE,YAAA;EACA,WAAA;AA83CF;;AA53CA;EACE,YAAA;EACA,WAAA;EACA,eAAA;AA+3CF;;AA73CA;EACE,WAAA;EACA,YAAA;AAg4CF;;AA93CA;EACE,WAAA;EACA,YAAA;AAi4CF;;AA/3CA;EACE,WAAA;EACA,YAAA;AAk4CF;;AAh4CA;EACE,WAAA;EACA,YAAA;EACA,eAAA;AAm4CF;;AAj4CA;EACE,YAAA;EACA,aAAA;AAo4CF;;AAl4CA;EACE,YAAA;EACA,aAAA;EACA,eAAA;AAq4CF;;AAn4CA;EACE,WAAA;EACA,YAAA;AAs4CF;;AAp4CA;EACE,WAAA;EACA,YAAA;AAu4CF;;AAr4CA;EACE,WAAA;EACA,YAAA;AAw4CF;;AAt4CA;EACE,WAAA;EACA,YAAA;EACA,eAAA;AAy4CF;;AAv4CA;EACE,YAAA;EACA,WAAA;AA04CF;;AAx4CA;EACE,YAAA;EACA,WAAA;EACA,eAAA;AA24CF;;AAz4CA;EACE,WAAA;EACA,YAAA;AA44CF;;AA14CA;EACE,WAAA;EACA,YAAA;AA64CF;;AA34CA;EACE,WAAA;EACA,YAAA;AA84CF;;AA54CA;EACE,WAAA;EACA,YAAA;EACA,eAAA;AA+4CF;;AA74CA;EACE,YAAA;EACA,aAAA;AAg5CF;;AA94CA;EACE,YAAA;EACA,aAAA;EACA,eAAA;AAi5CF;;AA/4CA;EACE,WAAA;EACA,YAAA;AAk5CF;;AAh5CA;EACE,WAAA;EACA,YAAA;AAm5CF;;AAj5CA;EACE,WAAA;EACA,YAAA;AAo5CF;;AAl5CA;EACE,WAAA;EACA,YAAA;EACA,eAAA;AAq5CF;;AAn5CA;EACE,YAAA;EACA,YAAA;AAs5CF;;AAp5CA;EACE,YAAA;EACA,YAAA;EACA,eAAA;AAu5CF;;AAr5CA;EACE,WAAA;EACA,YAAA;AAw5CF;;AAt5CA;EACE,WAAA;EACA,YAAA;AAy5CF;;AAv5CA;EACE,WAAA;EACA,YAAA;AA05CF;;AAx5CA;EACE,WAAA;EACA,YAAA;EACA,eAAA;AA25CF;;AAz5CA;EACE,YAAA;EACA,cAAA;AA45CF;;AA15CA;EACE,YAAA;EACA,cAAA;EACA,eAAA;AA65CF;;AA35CA;EACE,WAAA;EACA,YAAA;AA85CF;;AA55CA;EACE,WAAA;EACA,YAAA;AA+5CF;;AA75CA;EACE,WAAA;EACA,YAAA;AAg6CF;;AA95CA;EACE,WAAA;EACA,YAAA;EACA,eAAA;AAi6CF;;AA/5CA;EACE,YAAA;EACA,YAAA;AAk6CF;;AAh6CA;EACE,YAAA;EACA,YAAA;EACA,eAAA;AAm6CF;;AAj6CA;EACE,YAAA;EACA,aAAA;AAo6CF;;AAl6CA;EACE,YAAA;EACA,aAAA;AAq6CF;;AAn6CA;EACE,YAAA;EACA,aAAA;AAs6CF;;AAp6CA;EACE,YAAA;EACA,aAAA;EACA,eAAA;AAu6CF;;AAr6CA;EACE,aAAA;EACA,YAAA;AAw6CF;;AAt6CA;EACE,aAAA;EACA,YAAA;EACA,eAAA;AAy6CF;;AAv6CA;EACE,YAAA;EACA,aAAA;AA06CF;;AAx6CA;EACE,YAAA;EACA,aAAA;AA26CF;;AAz6CA;EACE,YAAA;EACA,aAAA;AA46CF;;AA16CA;EACE,YAAA;EACA,aAAA;EACA,eAAA;AA66CF;;AA36CA;EACE,aAAA;EACA,cAAA;AA86CF;;AA56CA;EACE,aAAA;EACA,cAAA;EACA,eAAA;AA+6CF;;AA76CA;EACE,YAAA;EACA,aAAA;AAg7CF;;AA96CA;EACE,YAAA;EACA,aAAA;AAi7CF;;AA/6CA;EACE,YAAA;EACA,aAAA;AAk7CF;;AAh7CA;EACE,YAAA;EACA,aAAA;EACA,eAAA;AAm7CF;;AAj7CA;EACE,aAAA;EACA,YAAA;AAo7CF;;AAl7CA;EACE,aAAA;EACA,YAAA;EACA,eAAA;AAq7CF;;AAn7CA;EACE,YAAA;EACA,aAAA;AAs7CF;;AAp7CA;EACE,YAAA;EACA,aAAA;AAu7CF;;AAr7CA;EACE,YAAA;EACA,aAAA;AAw7CF;;AAt7CA;EACE,YAAA;EACA,aAAA;EACA,eAAA;AAy7CF;;AAv7CA;EACE,aAAA;EACA,YAAA;AA07CF;;AAx7CA;EACE,aAAA;EACA,YAAA;EACA,eAAA;AA27CF;;AAz7CA;EACE,YAAA;EACA,aAAA;AA47CF;;AA17CA;EACE,YAAA;EACA,aAAA;AA67CF;;AA37CA;EACE,YAAA;EACA,aAAA;AA87CF;;AA57CA;EACE,YAAA;EACA,aAAA;EACA,eAAA;AA+7CF;;AA77CA;EACE,aAAA;EACA,cAAA;AAg8CF;;AA97CA;EACE,aAAA;EACA,cAAA;EACA,eAAA;AAi8CF;;AA/7CA;EACE,YAAA;EACA,aAAA;AAk8CF;;AAh8CA;EACE,YAAA;EACA,aAAA;AAm8CF;;AAj8CA;EACE,YAAA;EACA,aAAA;AAo8CF;;AAl8CA;EACE,YAAA;EACA,aAAA;EACA,eAAA;AAq8CF;;AAn8CA;EACE,aAAA;EACA,YAAA;AAs8CF;;AAp8CA;EACE,aAAA;EACA,YAAA;EACA,eAAA;AAu8CF;;AAr8CA;EACE;IACE,WAAA;IACA,YAAA;EAw8CF;EAt8CA;IACE,WAAA;IACA,YAAA;EAw8CF;EAt8CA;IACE,WAAA;IACA,YAAA;EAw8CF;EAt8CA;IACE,WAAA;IACA,YAAA;IACA,eAAA;EAw8CF;EAt8CA;IACE,YAAA;IACA,WAAA;EAw8CF;EAt8CA;IACE,YAAA;IACA,WAAA;IACA,eAAA;EAw8CF;EAt8CA;IACE,WAAA;IACA,YAAA;EAw8CF;EAt8CA;IACE,WAAA;IACA,YAAA;EAw8CF;EAt8CA;IACE,WAAA;IACA,YAAA;EAw8CF;EAt8CA;IACE,WAAA;IACA,YAAA;IACA,eAAA;EAw8CF;EAt8CA;IACE,YAAA;IACA,aAAA;EAw8CF;EAt8CA;IACE,YAAA;IACA,aAAA;IACA,eAAA;EAw8CF;EAt8CA;IACE,WAAA;IACA,YAAA;EAw8CF;EAt8CA;IACE,WAAA;IACA,YAAA;EAw8CF;EAt8CA;IACE,WAAA;IACA,YAAA;EAw8CF;EAt8CA;IACE,WAAA;IACA,YAAA;IACA,eAAA;EAw8CF;EAt8CA;IACE,YAAA;IACA,WAAA;EAw8CF;EAt8CA;IACE,YAAA;IACA,WAAA;IACA,eAAA;EAw8CF;EAt8CA;IACE,WAAA;IACA,YAAA;EAw8CF;EAt8CA;IACE,WAAA;IACA,YAAA;EAw8CF;EAt8CA;IACE,WAAA;IACA,YAAA;EAw8CF;EAt8CA;IACE,WAAA;IACA,YAAA;IACA,eAAA;EAw8CF;EAt8CA;IACE,YAAA;IACA,aAAA;EAw8CF;EAt8CA;IACE,YAAA;IACA,aAAA;IACA,eAAA;EAw8CF;EAt8CA;IACE,WAAA;IACA,YAAA;EAw8CF;EAt8CA;IACE,WAAA;IACA,YAAA;EAw8CF;EAt8CA;IACE,WAAA;IACA,YAAA;EAw8CF;EAt8CA;IACE,WAAA;IACA,YAAA;IACA,eAAA;EAw8CF;EAt8CA;IACE,YAAA;IACA,WAAA;EAw8CF;EAt8CA;IACE,YAAA;IACA,WAAA;IACA,eAAA;EAw8CF;EAt8CA;IACE,WAAA;IACA,YAAA;EAw8CF;EAt8CA;IACE,WAAA;IACA,YAAA;EAw8CF;EAt8CA;IACE,WAAA;IACA,YAAA;EAw8CF;EAt8CA;IACE,WAAA;IACA,YAAA;IACA,eAAA;EAw8CF;EAt8CA;IACE,YAAA;IACA,aAAA;EAw8CF;EAt8CA;IACE,YAAA;IACA,aAAA;IACA,eAAA;EAw8CF;EAt8CA;IACE,WAAA;IACA,YAAA;EAw8CF;EAt8CA;IACE,WAAA;IACA,YAAA;EAw8CF;EAt8CA;IACE,WAAA;IACA,YAAA;EAw8CF;EAt8CA;IACE,WAAA;IACA,YAAA;IACA,eAAA;EAw8CF;EAt8CA;IACE,YAAA;IACA,WAAA;EAw8CF;EAt8CA;IACE,YAAA;IACA,WAAA;IACA,eAAA;EAw8CF;EAt8CA;IACE,WAAA;IACA,YAAA;EAw8CF;EAt8CA;IACE,WAAA;IACA,YAAA;EAw8CF;EAt8CA;IACE,WAAA;IACA,YAAA;EAw8CF;EAt8CA;IACE,WAAA;IACA,YAAA;IACA,eAAA;EAw8CF;EAt8CA;IACE,YAAA;IACA,aAAA;EAw8CF;EAt8CA;IACE,YAAA;IACA,aAAA;IACA,eAAA;EAw8CF;EAt8CA;IACE,WAAA;IACA,YAAA;EAw8CF;EAt8CA;IACE,WAAA;IACA,YAAA;EAw8CF;EAt8CA;IACE,WAAA;IACA,YAAA;EAw8CF;EAt8CA;IACE,WAAA;IACA,YAAA;IACA,eAAA;EAw8CF;EAt8CA;IACE,YAAA;IACA,WAAA;EAw8CF;EAt8CA;IACE,YAAA;IACA,WAAA;IACA,eAAA;EAw8CF;EAt8CA;IACE,WAAA;IACA,YAAA;EAw8CF;EAt8CA;IACE,WAAA;IACA,YAAA;EAw8CF;EAt8CA;IACE,WAAA;IACA,YAAA;EAw8CF;EAt8CA;IACE,WAAA;IACA,YAAA;IACA,eAAA;EAw8CF;EAt8CA;IACE,YAAA;IACA,aAAA;EAw8CF;EAt8CA;IACE,YAAA;IACA,aAAA;IACA,eAAA;EAw8CF;EAt8CA;IACE,WAAA;IACA,YAAA;EAw8CF;EAt8CA;IACE,WAAA;IACA,YAAA;EAw8CF;EAt8CA;IACE,WAAA;IACA,YAAA;EAw8CF;EAt8CA;IACE,WAAA;IACA,YAAA;IACA,eAAA;EAw8CF;EAt8CA;IACE,YAAA;IACA,YAAA;EAw8CF;EAt8CA;IACE,YAAA;IACA,YAAA;IACA,eAAA;EAw8CF;EAt8CA;IACE,WAAA;IACA,YAAA;EAw8CF;EAt8CA;IACE,WAAA;IACA,YAAA;EAw8CF;EAt8CA;IACE,WAAA;IACA,YAAA;EAw8CF;EAt8CA;IACE,WAAA;IACA,YAAA;IACA,eAAA;EAw8CF;EAt8CA;IACE,YAAA;IACA,cAAA;EAw8CF;EAt8CA;IACE,YAAA;IACA,cAAA;IACA,eAAA;EAw8CF;EAt8CA;IACE,WAAA;IACA,YAAA;EAw8CF;EAt8CA;IACE,WAAA;IACA,YAAA;EAw8CF;EAt8CA;IACE,WAAA;IACA,YAAA;EAw8CF;EAt8CA;IACE,WAAA;IACA,YAAA;IACA,eAAA;EAw8CF;EAt8CA;IACE,YAAA;IACA,YAAA;EAw8CF;EAt8CA;IACE,YAAA;IACA,YAAA;IACA,eAAA;EAw8CF;EAt8CA;IACE,YAAA;IACA,aAAA;EAw8CF;EAt8CA;IACE,YAAA;IACA,aAAA;EAw8CF;EAt8CA;IACE,YAAA;IACA,aAAA;EAw8CF;EAt8CA;IACE,YAAA;IACA,aAAA;IACA,eAAA;EAw8CF;EAt8CA;IACE,aAAA;IACA,YAAA;EAw8CF;EAt8CA;IACE,aAAA;IACA,YAAA;IACA,eAAA;EAw8CF;EAt8CA;IACE,YAAA;IACA,aAAA;EAw8CF;EAt8CA;IACE,YAAA;IACA,aAAA;EAw8CF;EAt8CA;IACE,YAAA;IACA,aAAA;EAw8CF;EAt8CA;IACE,YAAA;IACA,aAAA;IACA,eAAA;EAw8CF;EAt8CA;IACE,aAAA;IACA,cAAA;EAw8CF;EAt8CA;IACE,aAAA;IACA,cAAA;IACA,eAAA;EAw8CF;EAt8CA;IACE,YAAA;IACA,aAAA;EAw8CF;EAt8CA;IACE,YAAA;IACA,aAAA;EAw8CF;EAt8CA;IACE,YAAA;IACA,aAAA;EAw8CF;EAt8CA;IACE,YAAA;IACA,aAAA;IACA,eAAA;EAw8CF;EAt8CA;IACE,aAAA;IACA,YAAA;EAw8CF;EAt8CA;IACE,aAAA;IACA,YAAA;IACA,eAAA;EAw8CF;EAt8CA;IACE,YAAA;IACA,aAAA;EAw8CF;EAt8CA;IACE,YAAA;IACA,aAAA;EAw8CF;EAt8CA;IACE,YAAA;IACA,aAAA;EAw8CF;EAt8CA;IACE,YAAA;IACA,aAAA;IACA,eAAA;EAw8CF;EAt8CA;IACE,aAAA;IACA,YAAA;EAw8CF;EAt8CA;IACE,aAAA;IACA,YAAA;IACA,eAAA;EAw8CF;EAt8CA;IACE,YAAA;IACA,aAAA;EAw8CF;EAt8CA;IACE,YAAA;IACA,aAAA;EAw8CF;EAt8CA;IACE,YAAA;IACA,aAAA;EAw8CF;EAt8CA;IACE,YAAA;IACA,aAAA;IACA,eAAA;EAw8CF;EAt8CA;IACE,aAAA;IACA,cAAA;EAw8CF;EAt8CA;IACE,aAAA;IACA,cAAA;IACA,eAAA;EAw8CF;EAt8CA;IACE,YAAA;IACA,aAAA;EAw8CF;EAt8CA;IACE,YAAA;IACA,aAAA;EAw8CF;EAt8CA;IACE,YAAA;IACA,aAAA;EAw8CF;EAt8CA;IACE,YAAA;IACA,aAAA;IACA,eAAA;EAw8CF;EAt8CA;IACE,aAAA;IACA,YAAA;EAw8CF;EAt8CA;IACE,aAAA;IACA,YAAA;IACA,eAAA;EAw8CF;AACF;AAt8CA;EACE;IACE,WAAA;IACA,YAAA;EAw8CF;EAt8CA;IACE,WAAA;IACA,YAAA;EAw8CF;EAt8CA;IACE,WAAA;IACA,YAAA;EAw8CF;EAt8CA;IACE,WAAA;IACA,YAAA;IACA,eAAA;EAw8CF;EAt8CA;IACE,YAAA;IACA,WAAA;EAw8CF;EAt8CA;IACE,YAAA;IACA,WAAA;IACA,eAAA;EAw8CF;EAt8CA;IACE,WAAA;IACA,YAAA;EAw8CF;EAt8CA;IACE,WAAA;IACA,YAAA;EAw8CF;EAt8CA;IACE,WAAA;IACA,YAAA;EAw8CF;EAt8CA;IACE,WAAA;IACA,YAAA;IACA,eAAA;EAw8CF;EAt8CA;IACE,YAAA;IACA,aAAA;EAw8CF;EAt8CA;IACE,YAAA;IACA,aAAA;IACA,eAAA;EAw8CF;EAt8CA;IACE,WAAA;IACA,YAAA;EAw8CF;EAt8CA;IACE,WAAA;IACA,YAAA;EAw8CF;EAt8CA;IACE,WAAA;IACA,YAAA;EAw8CF;EAt8CA;IACE,WAAA;IACA,YAAA;IACA,eAAA;EAw8CF;EAt8CA;IACE,YAAA;IACA,WAAA;EAw8CF;EAt8CA;IACE,YAAA;IACA,WAAA;IACA,eAAA;EAw8CF;EAt8CA;IACE,WAAA;IACA,YAAA;EAw8CF;EAt8CA;IACE,WAAA;IACA,YAAA;EAw8CF;EAt8CA;IACE,WAAA;IACA,YAAA;EAw8CF;EAt8CA;IACE,WAAA;IACA,YAAA;IACA,eAAA;EAw8CF;EAt8CA;IACE,YAAA;IACA,aAAA;EAw8CF;EAt8CA;IACE,YAAA;IACA,aAAA;IACA,eAAA;EAw8CF;EAt8CA;IACE,WAAA;IACA,YAAA;EAw8CF;EAt8CA;IACE,WAAA;IACA,YAAA;EAw8CF;EAt8CA;IACE,WAAA;IACA,YAAA;EAw8CF;EAt8CA;IACE,WAAA;IACA,YAAA;IACA,eAAA;EAw8CF;EAt8CA;IACE,YAAA;IACA,WAAA;EAw8CF;EAt8CA;IACE,YAAA;IACA,WAAA;IACA,eAAA;EAw8CF;EAt8CA;IACE,WAAA;IACA,YAAA;EAw8CF;EAt8CA;IACE,WAAA;IACA,YAAA;EAw8CF;EAt8CA;IACE,WAAA;IACA,YAAA;EAw8CF;EAt8CA;IACE,WAAA;IACA,YAAA;IACA,eAAA;EAw8CF;EAt8CA;IACE,YAAA;IACA,aAAA;EAw8CF;EAt8CA;IACE,YAAA;IACA,aAAA;IACA,eAAA;EAw8CF;EAt8CA;IACE,WAAA;IACA,YAAA;EAw8CF;EAt8CA;IACE,WAAA;IACA,YAAA;EAw8CF;EAt8CA;IACE,WAAA;IACA,YAAA;EAw8CF;EAt8CA;IACE,WAAA;IACA,YAAA;IACA,eAAA;EAw8CF;EAt8CA;IACE,YAAA;IACA,WAAA;EAw8CF;EAt8CA;IACE,YAAA;IACA,WAAA;IACA,eAAA;EAw8CF;EAt8CA;IACE,WAAA;IACA,YAAA;EAw8CF;EAt8CA;IACE,WAAA;IACA,YAAA;EAw8CF;EAt8CA;IACE,WAAA;IACA,YAAA;EAw8CF;EAt8CA;IACE,WAAA;IACA,YAAA;IACA,eAAA;EAw8CF;EAt8CA;IACE,YAAA;IACA,aAAA;EAw8CF;EAt8CA;IACE,YAAA;IACA,aAAA;IACA,eAAA;EAw8CF;EAt8CA;IACE,WAAA;IACA,YAAA;EAw8CF;EAt8CA;IACE,WAAA;IACA,YAAA;EAw8CF;EAt8CA;IACE,WAAA;IACA,YAAA;EAw8CF;EAt8CA;IACE,WAAA;IACA,YAAA;IACA,eAAA;EAw8CF;EAt8CA;IACE,YAAA;IACA,WAAA;EAw8CF;EAt8CA;IACE,YAAA;IACA,WAAA;IACA,eAAA;EAw8CF;EAt8CA;IACE,WAAA;IACA,YAAA;EAw8CF;EAt8CA;IACE,WAAA;IACA,YAAA;EAw8CF;EAt8CA;IACE,WAAA;IACA,YAAA;EAw8CF;EAt8CA;IACE,WAAA;IACA,YAAA;IACA,eAAA;EAw8CF;EAt8CA;IACE,YAAA;IACA,aAAA;EAw8CF;EAt8CA;IACE,YAAA;IACA,aAAA;IACA,eAAA;EAw8CF;EAt8CA;IACE,WAAA;IACA,YAAA;EAw8CF;EAt8CA;IACE,WAAA;IACA,YAAA;EAw8CF;EAt8CA;IACE,WAAA;IACA,YAAA;EAw8CF;EAt8CA;IACE,WAAA;IACA,YAAA;IACA,eAAA;EAw8CF;EAt8CA;IACE,YAAA;IACA,YAAA;EAw8CF;EAt8CA;IACE,YAAA;IACA,YAAA;IACA,eAAA;EAw8CF;EAt8CA;IACE,WAAA;IACA,YAAA;EAw8CF;EAt8CA;IACE,WAAA;IACA,YAAA;EAw8CF;EAt8CA;IACE,WAAA;IACA,YAAA;EAw8CF;EAt8CA;IACE,WAAA;IACA,YAAA;IACA,eAAA;EAw8CF;EAt8CA;IACE,YAAA;IACA,cAAA;EAw8CF;EAt8CA;IACE,YAAA;IACA,cAAA;IACA,eAAA;EAw8CF;EAt8CA;IACE,WAAA;IACA,YAAA;EAw8CF;EAt8CA;IACE,WAAA;IACA,YAAA;EAw8CF;EAt8CA;IACE,WAAA;IACA,YAAA;EAw8CF;EAt8CA;IACE,WAAA;IACA,YAAA;IACA,eAAA;EAw8CF;EAt8CA;IACE,YAAA;IACA,YAAA;EAw8CF;EAt8CA;IACE,YAAA;IACA,YAAA;IACA,eAAA;EAw8CF;EAt8CA;IACE,YAAA;IACA,aAAA;EAw8CF;EAt8CA;IACE,YAAA;IACA,aAAA;EAw8CF;EAt8CA;IACE,YAAA;IACA,aAAA;EAw8CF;EAt8CA;IACE,YAAA;IACA,aAAA;IACA,eAAA;EAw8CF;EAt8CA;IACE,aAAA;IACA,YAAA;EAw8CF;EAt8CA;IACE,aAAA;IACA,YAAA;IACA,eAAA;EAw8CF;EAt8CA;IACE,YAAA;IACA,aAAA;EAw8CF;EAt8CA;IACE,YAAA;IACA,aAAA;EAw8CF;EAt8CA;IACE,YAAA;IACA,aAAA;EAw8CF;EAt8CA;IACE,YAAA;IACA,aAAA;IACA,eAAA;EAw8CF;EAt8CA;IACE,aAAA;IACA,cAAA;EAw8CF;EAt8CA;IACE,aAAA;IACA,cAAA;IACA,eAAA;EAw8CF;EAt8CA;IACE,YAAA;IACA,aAAA;EAw8CF;EAt8CA;IACE,YAAA;IACA,aAAA;EAw8CF;EAt8CA;IACE,YAAA;IACA,aAAA;EAw8CF;EAt8CA;IACE,YAAA;IACA,aAAA;IACA,eAAA;EAw8CF;EAt8CA;IACE,aAAA;IACA,YAAA;EAw8CF;EAt8CA;IACE,aAAA;IACA,YAAA;IACA,eAAA;EAw8CF;EAt8CA;IACE,YAAA;IACA,aAAA;EAw8CF;EAt8CA;IACE,YAAA;IACA,aAAA;EAw8CF;EAt8CA;IACE,YAAA;IACA,aAAA;EAw8CF;EAt8CA;IACE,YAAA;IACA,aAAA;IACA,eAAA;EAw8CF;EAt8CA;IACE,aAAA;IACA,YAAA;EAw8CF;EAt8CA;IACE,aAAA;IACA,YAAA;IACA,eAAA;EAw8CF;EAt8CA;IACE,YAAA;IACA,aAAA;EAw8CF;EAt8CA;IACE,YAAA;IACA,aAAA;EAw8CF;EAt8CA;IACE,YAAA;IACA,aAAA;EAw8CF;EAt8CA;IACE,YAAA;IACA,aAAA;IACA,eAAA;EAw8CF;EAt8CA;IACE,aAAA;IACA,cAAA;EAw8CF;EAt8CA;IACE,aAAA;IACA,cAAA;IACA,eAAA;EAw8CF;EAt8CA;IACE,YAAA;IACA,aAAA;EAw8CF;EAt8CA;IACE,YAAA;IACA,aAAA;EAw8CF;EAt8CA;IACE,YAAA;IACA,aAAA;EAw8CF;EAt8CA;IACE,YAAA;IACA,aAAA;IACA,eAAA;EAw8CF;EAt8CA;IACE,aAAA;IACA,YAAA;EAw8CF;EAt8CA;IACE,aAAA;IACA,YAAA;IACA,eAAA;EAw8CF;AACF;AAt8CA;EACE;IACE,WAAA;IACA,YAAA;EAw8CF;EAt8CA;IACE,WAAA;IACA,YAAA;EAw8CF;EAt8CA;IACE,WAAA;IACA,YAAA;EAw8CF;EAt8CA;IACE,WAAA;IACA,YAAA;IACA,eAAA;EAw8CF;EAt8CA;IACE,YAAA;IACA,WAAA;EAw8CF;EAt8CA;IACE,YAAA;IACA,WAAA;IACA,eAAA;EAw8CF;EAt8CA;IACE,WAAA;IACA,YAAA;EAw8CF;EAt8CA;IACE,WAAA;IACA,YAAA;EAw8CF;EAt8CA;IACE,WAAA;IACA,YAAA;EAw8CF;EAt8CA;IACE,WAAA;IACA,YAAA;IACA,eAAA;EAw8CF;EAt8CA;IACE,YAAA;IACA,aAAA;EAw8CF;EAt8CA;IACE,YAAA;IACA,aAAA;IACA,eAAA;EAw8CF;EAt8CA;IACE,WAAA;IACA,YAAA;EAw8CF;EAt8CA;IACE,WAAA;IACA,YAAA;EAw8CF;EAt8CA;IACE,WAAA;IACA,YAAA;EAw8CF;EAt8CA;IACE,WAAA;IACA,YAAA;IACA,eAAA;EAw8CF;EAt8CA;IACE,YAAA;IACA,WAAA;EAw8CF;EAt8CA;IACE,YAAA;IACA,WAAA;IACA,eAAA;EAw8CF;EAt8CA;IACE,WAAA;IACA,YAAA;EAw8CF;EAt8CA;IACE,WAAA;IACA,YAAA;EAw8CF;EAt8CA;IACE,WAAA;IACA,YAAA;EAw8CF;EAt8CA;IACE,WAAA;IACA,YAAA;IACA,eAAA;EAw8CF;EAt8CA;IACE,YAAA;IACA,aAAA;EAw8CF;EAt8CA;IACE,YAAA;IACA,aAAA;IACA,eAAA;EAw8CF;EAt8CA;IACE,WAAA;IACA,YAAA;EAw8CF;EAt8CA;IACE,WAAA;IACA,YAAA;EAw8CF;EAt8CA;IACE,WAAA;IACA,YAAA;EAw8CF;EAt8CA;IACE,WAAA;IACA,YAAA;IACA,eAAA;EAw8CF;EAt8CA;IACE,YAAA;IACA,WAAA;EAw8CF;EAt8CA;IACE,YAAA;IACA,WAAA;IACA,eAAA;EAw8CF;EAt8CA;IACE,WAAA;IACA,YAAA;EAw8CF;EAt8CA;IACE,WAAA;IACA,YAAA;EAw8CF;EAt8CA;IACE,WAAA;IACA,YAAA;EAw8CF;EAt8CA;IACE,WAAA;IACA,YAAA;IACA,eAAA;EAw8CF;EAt8CA;IACE,YAAA;IACA,aAAA;EAw8CF;EAt8CA;IACE,YAAA;IACA,aAAA;IACA,eAAA;EAw8CF;EAt8CA;IACE,WAAA;IACA,YAAA;EAw8CF;EAt8CA;IACE,WAAA;IACA,YAAA;EAw8CF;EAt8CA;IACE,WAAA;IACA,YAAA;EAw8CF;EAt8CA;IACE,WAAA;IACA,YAAA;IACA,eAAA;EAw8CF;EAt8CA;IACE,YAAA;IACA,WAAA;EAw8CF;EAt8CA;IACE,YAAA;IACA,WAAA;IACA,eAAA;EAw8CF;EAt8CA;IACE,WAAA;IACA,YAAA;EAw8CF;EAt8CA;IACE,WAAA;IACA,YAAA;EAw8CF;EAt8CA;IACE,WAAA;IACA,YAAA;EAw8CF;EAt8CA;IACE,WAAA;IACA,YAAA;IACA,eAAA;EAw8CF;EAt8CA;IACE,YAAA;IACA,aAAA;EAw8CF;EAt8CA;IACE,YAAA;IACA,aAAA;IACA,eAAA;EAw8CF;EAt8CA;IACE,WAAA;IACA,YAAA;EAw8CF;EAt8CA;IACE,WAAA;IACA,YAAA;EAw8CF;EAt8CA;IACE,WAAA;IACA,YAAA;EAw8CF;EAt8CA;IACE,WAAA;IACA,YAAA;IACA,eAAA;EAw8CF;EAt8CA;IACE,YAAA;IACA,WAAA;EAw8CF;EAt8CA;IACE,YAAA;IACA,WAAA;IACA,eAAA;EAw8CF;EAt8CA;IACE,WAAA;IACA,YAAA;EAw8CF;EAt8CA;IACE,WAAA;IACA,YAAA;EAw8CF;EAt8CA;IACE,WAAA;IACA,YAAA;EAw8CF;EAt8CA;IACE,WAAA;IACA,YAAA;IACA,eAAA;EAw8CF;EAt8CA;IACE,YAAA;IACA,aAAA;EAw8CF;EAt8CA;IACE,YAAA;IACA,aAAA;IACA,eAAA;EAw8CF;EAt8CA;IACE,WAAA;IACA,YAAA;EAw8CF;EAt8CA;IACE,WAAA;IACA,YAAA;EAw8CF;EAt8CA;IACE,WAAA;IACA,YAAA;EAw8CF;EAt8CA;IACE,WAAA;IACA,YAAA;IACA,eAAA;EAw8CF;EAt8CA;IACE,YAAA;IACA,YAAA;EAw8CF;EAt8CA;IACE,YAAA;IACA,YAAA;IACA,eAAA;EAw8CF;EAt8CA;IACE,WAAA;IACA,YAAA;EAw8CF;EAt8CA;IACE,WAAA;IACA,YAAA;EAw8CF;EAt8CA;IACE,WAAA;IACA,YAAA;EAw8CF;EAt8CA;IACE,WAAA;IACA,YAAA;IACA,eAAA;EAw8CF;EAt8CA;IACE,YAAA;IACA,cAAA;EAw8CF;EAt8CA;IACE,YAAA;IACA,cAAA;IACA,eAAA;EAw8CF;EAt8CA;IACE,WAAA;IACA,YAAA;EAw8CF;EAt8CA;IACE,WAAA;IACA,YAAA;EAw8CF;EAt8CA;IACE,WAAA;IACA,YAAA;EAw8CF;EAt8CA;IACE,WAAA;IACA,YAAA;IACA,eAAA;EAw8CF;EAt8CA;IACE,YAAA;IACA,YAAA;EAw8CF;EAt8CA;IACE,YAAA;IACA,YAAA;IACA,eAAA;EAw8CF;EAt8CA;IACE,YAAA;IACA,aAAA;EAw8CF;EAt8CA;IACE,YAAA;IACA,aAAA;EAw8CF;EAt8CA;IACE,YAAA;IACA,aAAA;EAw8CF;EAt8CA;IACE,YAAA;IACA,aAAA;IACA,eAAA;EAw8CF;EAt8CA;IACE,aAAA;IACA,YAAA;EAw8CF;EAt8CA;IACE,aAAA;IACA,YAAA;IACA,eAAA;EAw8CF;EAt8CA;IACE,YAAA;IACA,aAAA;EAw8CF;EAt8CA;IACE,YAAA;IACA,aAAA;EAw8CF;EAt8CA;IACE,YAAA;IACA,aAAA;EAw8CF;EAt8CA;IACE,YAAA;IACA,aAAA;IACA,eAAA;EAw8CF;EAt8CA;IACE,aAAA;IACA,cAAA;EAw8CF;EAt8CA;IACE,aAAA;IACA,cAAA;IACA,eAAA;EAw8CF;EAt8CA;IACE,YAAA;IACA,aAAA;EAw8CF;EAt8CA;IACE,YAAA;IACA,aAAA;EAw8CF;EAt8CA;IACE,YAAA;IACA,aAAA;EAw8CF;EAt8CA;IACE,YAAA;IACA,aAAA;IACA,eAAA;EAw8CF;EAt8CA;IACE,aAAA;IACA,YAAA;EAw8CF;EAt8CA;IACE,aAAA;IACA,YAAA;IACA,eAAA;EAw8CF;EAt8CA;IACE,YAAA;IACA,aAAA;EAw8CF;EAt8CA;IACE,YAAA;IACA,aAAA;EAw8CF;EAt8CA;IACE,YAAA;IACA,aAAA;EAw8CF;EAt8CA;IACE,YAAA;IACA,aAAA;IACA,eAAA;EAw8CF;EAt8CA;IACE,aAAA;IACA,YAAA;EAw8CF;EAt8CA;IACE,aAAA;IACA,YAAA;IACA,eAAA;EAw8CF;EAt8CA;IACE,YAAA;IACA,aAAA;EAw8CF;EAt8CA;IACE,YAAA;IACA,aAAA;EAw8CF;EAt8CA;IACE,YAAA;IACA,aAAA;EAw8CF;EAt8CA;IACE,YAAA;IACA,aAAA;IACA,eAAA;EAw8CF;EAt8CA;IACE,aAAA;IACA,cAAA;EAw8CF;EAt8CA;IACE,aAAA;IACA,cAAA;IACA,eAAA;EAw8CF;EAt8CA;IACE,YAAA;IACA,aAAA;EAw8CF;EAt8CA;IACE,YAAA;IACA,aAAA;EAw8CF;EAt8CA;IACE,YAAA;IACA,aAAA;EAw8CF;EAt8CA;IACE,YAAA;IACA,aAAA;IACA,eAAA;EAw8CF;EAt8CA;IACE,aAAA;IACA,YAAA;EAw8CF;EAt8CA;IACE,aAAA;IACA,YAAA;IACA,eAAA;EAw8CF;AACF;AAt8CA;EACE;IACE,WAAA;IACA,YAAA;EAw8CF;EAt8CA;IACE,WAAA;IACA,YAAA;EAw8CF;EAt8CA;IACE,WAAA;IACA,YAAA;EAw8CF;EAt8CA;IACE,WAAA;IACA,YAAA;IACA,eAAA;EAw8CF;EAt8CA;IACE,YAAA;IACA,WAAA;EAw8CF;EAt8CA;IACE,YAAA;IACA,WAAA;IACA,eAAA;EAw8CF;EAt8CA;IACE,WAAA;IACA,YAAA;EAw8CF;EAt8CA;IACE,WAAA;IACA,YAAA;EAw8CF;EAt8CA;IACE,WAAA;IACA,YAAA;EAw8CF;EAt8CA;IACE,WAAA;IACA,YAAA;IACA,eAAA;EAw8CF;EAt8CA;IACE,YAAA;IACA,aAAA;EAw8CF;EAt8CA;IACE,YAAA;IACA,aAAA;IACA,eAAA;EAw8CF;EAt8CA;IACE,WAAA;IACA,YAAA;EAw8CF;EAt8CA;IACE,WAAA;IACA,YAAA;EAw8CF;EAt8CA;IACE,WAAA;IACA,YAAA;EAw8CF;EAt8CA;IACE,WAAA;IACA,YAAA;IACA,eAAA;EAw8CF;EAt8CA;IACE,YAAA;IACA,WAAA;EAw8CF;EAt8CA;IACE,YAAA;IACA,WAAA;IACA,eAAA;EAw8CF;EAt8CA;IACE,WAAA;IACA,YAAA;EAw8CF;EAt8CA;IACE,WAAA;IACA,YAAA;EAw8CF;EAt8CA;IACE,WAAA;IACA,YAAA;EAw8CF;EAt8CA;IACE,WAAA;IACA,YAAA;IACA,eAAA;EAw8CF;EAt8CA;IACE,YAAA;IACA,aAAA;EAw8CF;EAt8CA;IACE,YAAA;IACA,aAAA;IACA,eAAA;EAw8CF;EAt8CA;IACE,WAAA;IACA,YAAA;EAw8CF;EAt8CA;IACE,WAAA;IACA,YAAA;EAw8CF;EAt8CA;IACE,WAAA;IACA,YAAA;EAw8CF;EAt8CA;IACE,WAAA;IACA,YAAA;IACA,eAAA;EAw8CF;EAt8CA;IACE,YAAA;IACA,WAAA;EAw8CF;EAt8CA;IACE,YAAA;IACA,WAAA;IACA,eAAA;EAw8CF;EAt8CA;IACE,WAAA;IACA,YAAA;EAw8CF;EAt8CA;IACE,WAAA;IACA,YAAA;EAw8CF;EAt8CA;IACE,WAAA;IACA,YAAA;EAw8CF;EAt8CA;IACE,WAAA;IACA,YAAA;IACA,eAAA;EAw8CF;EAt8CA;IACE,YAAA;IACA,aAAA;EAw8CF;EAt8CA;IACE,YAAA;IACA,aAAA;IACA,eAAA;EAw8CF;EAt8CA;IACE,WAAA;IACA,YAAA;EAw8CF;EAt8CA;IACE,WAAA;IACA,YAAA;EAw8CF;EAt8CA;IACE,WAAA;IACA,YAAA;EAw8CF;EAt8CA;IACE,WAAA;IACA,YAAA;IACA,eAAA;EAw8CF;EAt8CA;IACE,YAAA;IACA,WAAA;EAw8CF;EAt8CA;IACE,YAAA;IACA,WAAA;IACA,eAAA;EAw8CF;EAt8CA;IACE,WAAA;IACA,YAAA;EAw8CF;EAt8CA;IACE,WAAA;IACA,YAAA;EAw8CF;EAt8CA;IACE,WAAA;IACA,YAAA;EAw8CF;EAt8CA;IACE,WAAA;IACA,YAAA;IACA,eAAA;EAw8CF;EAt8CA;IACE,YAAA;IACA,aAAA;EAw8CF;EAt8CA;IACE,YAAA;IACA,aAAA;IACA,eAAA;EAw8CF;EAt8CA;IACE,WAAA;IACA,YAAA;EAw8CF;EAt8CA;IACE,WAAA;IACA,YAAA;EAw8CF;EAt8CA;IACE,WAAA;IACA,YAAA;EAw8CF;EAt8CA;IACE,WAAA;IACA,YAAA;IACA,eAAA;EAw8CF;EAt8CA;IACE,YAAA;IACA,WAAA;EAw8CF;EAt8CA;IACE,YAAA;IACA,WAAA;IACA,eAAA;EAw8CF;EAt8CA;IACE,WAAA;IACA,YAAA;EAw8CF;EAt8CA;IACE,WAAA;IACA,YAAA;EAw8CF;EAt8CA;IACE,WAAA;IACA,YAAA;EAw8CF;EAt8CA;IACE,WAAA;IACA,YAAA;IACA,eAAA;EAw8CF;EAt8CA;IACE,YAAA;IACA,aAAA;EAw8CF;EAt8CA;IACE,YAAA;IACA,aAAA;IACA,eAAA;EAw8CF;EAt8CA;IACE,WAAA;IACA,YAAA;EAw8CF;EAt8CA;IACE,WAAA;IACA,YAAA;EAw8CF;EAt8CA;IACE,WAAA;IACA,YAAA;EAw8CF;EAt8CA;IACE,WAAA;IACA,YAAA;IACA,eAAA;EAw8CF;EAt8CA;IACE,YAAA;IACA,YAAA;EAw8CF;EAt8CA;IACE,YAAA;IACA,YAAA;IACA,eAAA;EAw8CF;EAt8CA;IACE,WAAA;IACA,YAAA;EAw8CF;EAt8CA;IACE,WAAA;IACA,YAAA;EAw8CF;EAt8CA;IACE,WAAA;IACA,YAAA;EAw8CF;EAt8CA;IACE,WAAA;IACA,YAAA;IACA,eAAA;EAw8CF;EAt8CA;IACE,YAAA;IACA,cAAA;EAw8CF;EAt8CA;IACE,YAAA;IACA,cAAA;IACA,eAAA;EAw8CF;EAt8CA;IACE,WAAA;IACA,YAAA;EAw8CF;EAt8CA;IACE,WAAA;IACA,YAAA;EAw8CF;EAt8CA;IACE,WAAA;IACA,YAAA;EAw8CF;EAt8CA;IACE,WAAA;IACA,YAAA;IACA,eAAA;EAw8CF;EAt8CA;IACE,YAAA;IACA,YAAA;EAw8CF;EAt8CA;IACE,YAAA;IACA,YAAA;IACA,eAAA;EAw8CF;EAt8CA;IACE,YAAA;IACA,aAAA;EAw8CF;EAt8CA;IACE,YAAA;IACA,aAAA;EAw8CF;EAt8CA;IACE,YAAA;IACA,aAAA;EAw8CF;EAt8CA;IACE,YAAA;IACA,aAAA;IACA,eAAA;EAw8CF;EAt8CA;IACE,aAAA;IACA,YAAA;EAw8CF;EAt8CA;IACE,aAAA;IACA,YAAA;IACA,eAAA;EAw8CF;EAt8CA;IACE,YAAA;IACA,aAAA;EAw8CF;EAt8CA;IACE,YAAA;IACA,aAAA;EAw8CF;EAt8CA;IACE,YAAA;IACA,aAAA;EAw8CF;EAt8CA;IACE,YAAA;IACA,aAAA;IACA,eAAA;EAw8CF;EAt8CA;IACE,aAAA;IACA,cAAA;EAw8CF;EAt8CA;IACE,aAAA;IACA,cAAA;IACA,eAAA;EAw8CF;EAt8CA;IACE,YAAA;IACA,aAAA;EAw8CF;EAt8CA;IACE,YAAA;IACA,aAAA;EAw8CF;EAt8CA;IACE,YAAA;IACA,aAAA;EAw8CF;EAt8CA;IACE,YAAA;IACA,aAAA;IACA,eAAA;EAw8CF;EAt8CA;IACE,aAAA;IACA,YAAA;EAw8CF;EAt8CA;IACE,aAAA;IACA,YAAA;IACA,eAAA;EAw8CF;EAt8CA;IACE,YAAA;IACA,aAAA;EAw8CF;EAt8CA;IACE,YAAA;IACA,aAAA;EAw8CF;EAt8CA;IACE,YAAA;IACA,aAAA;EAw8CF;EAt8CA;IACE,YAAA;IACA,aAAA;IACA,eAAA;EAw8CF;EAt8CA;IACE,aAAA;IACA,YAAA;EAw8CF;EAt8CA;IACE,aAAA;IACA,YAAA;IACA,eAAA;EAw8CF;EAt8CA;IACE,YAAA;IACA,aAAA;EAw8CF;EAt8CA;IACE,YAAA;IACA,aAAA;EAw8CF;EAt8CA;IACE,YAAA;IACA,aAAA;EAw8CF;EAt8CA;IACE,YAAA;IACA,aAAA;IACA,eAAA;EAw8CF;EAt8CA;IACE,aAAA;IACA,cAAA;EAw8CF;EAt8CA;IACE,aAAA;IACA,cAAA;IACA,eAAA;EAw8CF;EAt8CA;IACE,YAAA;IACA,aAAA;EAw8CF;EAt8CA;IACE,YAAA;IACA,aAAA;EAw8CF;EAt8CA;IACE,YAAA;IACA,aAAA;EAw8CF;EAt8CA;IACE,YAAA;IACA,aAAA;IACA,eAAA;EAw8CF;EAt8CA;IACE,aAAA;IACA,YAAA;EAw8CF;EAt8CA;IACE,aAAA;IACA,YAAA;IACA,eAAA;EAw8CF;AACF;AAt8CA;EACE;IACE,WAAA;IACA,YAAA;EAw8CF;EAt8CA;IACE,WAAA;IACA,YAAA;EAw8CF;EAt8CA;IACE,WAAA;IACA,YAAA;EAw8CF;EAt8CA;IACE,WAAA;IACA,YAAA;IACA,eAAA;EAw8CF;EAt8CA;IACE,YAAA;IACA,WAAA;EAw8CF;EAt8CA;IACE,YAAA;IACA,WAAA;IACA,eAAA;EAw8CF;EAt8CA;IACE,WAAA;IACA,YAAA;EAw8CF;EAt8CA;IACE,WAAA;IACA,YAAA;EAw8CF;EAt8CA;IACE,WAAA;IACA,YAAA;EAw8CF;EAt8CA;IACE,WAAA;IACA,YAAA;IACA,eAAA;EAw8CF;EAt8CA;IACE,YAAA;IACA,aAAA;EAw8CF;EAt8CA;IACE,YAAA;IACA,aAAA;IACA,eAAA;EAw8CF;EAt8CA;IACE,WAAA;IACA,YAAA;EAw8CF;EAt8CA;IACE,WAAA;IACA,YAAA;EAw8CF;EAt8CA;IACE,WAAA;IACA,YAAA;EAw8CF;EAt8CA;IACE,WAAA;IACA,YAAA;IACA,eAAA;EAw8CF;EAt8CA;IACE,YAAA;IACA,WAAA;EAw8CF;EAt8CA;IACE,YAAA;IACA,WAAA;IACA,eAAA;EAw8CF;EAt8CA;IACE,WAAA;IACA,YAAA;EAw8CF;EAt8CA;IACE,WAAA;IACA,YAAA;EAw8CF;EAt8CA;IACE,WAAA;IACA,YAAA;EAw8CF;EAt8CA;IACE,WAAA;IACA,YAAA;IACA,eAAA;EAw8CF;EAt8CA;IACE,YAAA;IACA,aAAA;EAw8CF;EAt8CA;IACE,YAAA;IACA,aAAA;IACA,eAAA;EAw8CF;EAt8CA;IACE,WAAA;IACA,YAAA;EAw8CF;EAt8CA;IACE,WAAA;IACA,YAAA;EAw8CF;EAt8CA;IACE,WAAA;IACA,YAAA;EAw8CF;EAt8CA;IACE,WAAA;IACA,YAAA;IACA,eAAA;EAw8CF;EAt8CA;IACE,YAAA;IACA,WAAA;EAw8CF;EAt8CA;IACE,YAAA;IACA,WAAA;IACA,eAAA;EAw8CF;EAt8CA;IACE,WAAA;IACA,YAAA;EAw8CF;EAt8CA;IACE,WAAA;IACA,YAAA;EAw8CF;EAt8CA;IACE,WAAA;IACA,YAAA;EAw8CF;EAt8CA;IACE,WAAA;IACA,YAAA;IACA,eAAA;EAw8CF;EAt8CA;IACE,YAAA;IACA,aAAA;EAw8CF;EAt8CA;IACE,YAAA;IACA,aAAA;IACA,eAAA;EAw8CF;EAt8CA;IACE,WAAA;IACA,YAAA;EAw8CF;EAt8CA;IACE,WAAA;IACA,YAAA;EAw8CF;EAt8CA;IACE,WAAA;IACA,YAAA;EAw8CF;EAt8CA;IACE,WAAA;IACA,YAAA;IACA,eAAA;EAw8CF;EAt8CA;IACE,YAAA;IACA,WAAA;EAw8CF;EAt8CA;IACE,YAAA;IACA,WAAA;IACA,eAAA;EAw8CF;EAt8CA;IACE,WAAA;IACA,YAAA;EAw8CF;EAt8CA;IACE,WAAA;IACA,YAAA;EAw8CF;EAt8CA;IACE,WAAA;IACA,YAAA;EAw8CF;EAt8CA;IACE,WAAA;IACA,YAAA;IACA,eAAA;EAw8CF;EAt8CA;IACE,YAAA;IACA,aAAA;EAw8CF;EAt8CA;IACE,YAAA;IACA,aAAA;IACA,eAAA;EAw8CF;EAt8CA;IACE,WAAA;IACA,YAAA;EAw8CF;EAt8CA;IACE,WAAA;IACA,YAAA;EAw8CF;EAt8CA;IACE,WAAA;IACA,YAAA;EAw8CF;EAt8CA;IACE,WAAA;IACA,YAAA;IACA,eAAA;EAw8CF;EAt8CA;IACE,YAAA;IACA,WAAA;EAw8CF;EAt8CA;IACE,YAAA;IACA,WAAA;IACA,eAAA;EAw8CF;EAt8CA;IACE,WAAA;IACA,YAAA;EAw8CF;EAt8CA;IACE,WAAA;IACA,YAAA;EAw8CF;EAt8CA;IACE,WAAA;IACA,YAAA;EAw8CF;EAt8CA;IACE,WAAA;IACA,YAAA;IACA,eAAA;EAw8CF;EAt8CA;IACE,YAAA;IACA,aAAA;EAw8CF;EAt8CA;IACE,YAAA;IACA,aAAA;IACA,eAAA;EAw8CF;EAt8CA;IACE,WAAA;IACA,YAAA;EAw8CF;EAt8CA;IACE,WAAA;IACA,YAAA;EAw8CF;EAt8CA;IACE,WAAA;IACA,YAAA;EAw8CF;EAt8CA;IACE,WAAA;IACA,YAAA;IACA,eAAA;EAw8CF;EAt8CA;IACE,YAAA;IACA,YAAA;EAw8CF;EAt8CA;IACE,YAAA;IACA,YAAA;IACA,eAAA;EAw8CF;EAt8CA;IACE,WAAA;IACA,YAAA;EAw8CF;EAt8CA;IACE,WAAA;IACA,YAAA;EAw8CF;EAt8CA;IACE,WAAA;IACA,YAAA;EAw8CF;EAt8CA;IACE,WAAA;IACA,YAAA;IACA,eAAA;EAw8CF;EAt8CA;IACE,YAAA;IACA,cAAA;EAw8CF;EAt8CA;IACE,YAAA;IACA,cAAA;IACA,eAAA;EAw8CF;EAt8CA;IACE,WAAA;IACA,YAAA;EAw8CF;EAt8CA;IACE,WAAA;IACA,YAAA;EAw8CF;EAt8CA;IACE,WAAA;IACA,YAAA;EAw8CF;EAt8CA;IACE,WAAA;IACA,YAAA;IACA,eAAA;EAw8CF;EAt8CA;IACE,YAAA;IACA,YAAA;EAw8CF;EAt8CA;IACE,YAAA;IACA,YAAA;IACA,eAAA;EAw8CF;EAt8CA;IACE,YAAA;IACA,aAAA;EAw8CF;EAt8CA;IACE,YAAA;IACA,aAAA;EAw8CF;EAt8CA;IACE,YAAA;IACA,aAAA;EAw8CF;EAt8CA;IACE,YAAA;IACA,aAAA;IACA,eAAA;EAw8CF;EAt8CA;IACE,aAAA;IACA,YAAA;EAw8CF;EAt8CA;IACE,aAAA;IACA,YAAA;IACA,eAAA;EAw8CF;EAt8CA;IACE,YAAA;IACA,aAAA;EAw8CF;EAt8CA;IACE,YAAA;IACA,aAAA;EAw8CF;EAt8CA;IACE,YAAA;IACA,aAAA;EAw8CF;EAt8CA;IACE,YAAA;IACA,aAAA;IACA,eAAA;EAw8CF;EAt8CA;IACE,aAAA;IACA,cAAA;EAw8CF;EAt8CA;IACE,aAAA;IACA,cAAA;IACA,eAAA;EAw8CF;EAt8CA;IACE,YAAA;IACA,aAAA;EAw8CF;EAt8CA;IACE,YAAA;IACA,aAAA;EAw8CF;EAt8CA;IACE,YAAA;IACA,aAAA;EAw8CF;EAt8CA;IACE,YAAA;IACA,aAAA;IACA,eAAA;EAw8CF;EAt8CA;IACE,aAAA;IACA,YAAA;EAw8CF;EAt8CA;IACE,aAAA;IACA,YAAA;IACA,eAAA;EAw8CF;EAt8CA;IACE,YAAA;IACA,aAAA;EAw8CF;EAt8CA;IACE,YAAA;IACA,aAAA;EAw8CF;EAt8CA;IACE,YAAA;IACA,aAAA;EAw8CF;EAt8CA;IACE,YAAA;IACA,aAAA;IACA,eAAA;EAw8CF;EAt8CA;IACE,aAAA;IACA,YAAA;EAw8CF;EAt8CA;IACE,aAAA;IACA,YAAA;IACA,eAAA;EAw8CF;EAt8CA;IACE,YAAA;IACA,aAAA;EAw8CF;EAt8CA;IACE,YAAA;IACA,aAAA;EAw8CF;EAt8CA;IACE,YAAA;IACA,aAAA;EAw8CF;EAt8CA;IACE,YAAA;IACA,aAAA;IACA,eAAA;EAw8CF;EAt8CA;IACE,aAAA;IACA,cAAA;EAw8CF;EAt8CA;IACE,aAAA;IACA,cAAA;IACA,eAAA;EAw8CF;EAt8CA;IACE,YAAA;IACA,aAAA;EAw8CF;EAt8CA;IACE,YAAA;IACA,aAAA;EAw8CF;EAt8CA;IACE,YAAA;IACA,aAAA;EAw8CF;EAt8CA;IACE,YAAA;IACA,aAAA;IACA,eAAA;EAw8CF;EAt8CA;IACE,aAAA;IACA,YAAA;EAw8CF;EAt8CA;IACE,aAAA;IACA,YAAA;IACA,eAAA;EAw8CF;AACF;AAr8CA;EACE,aAAA;EACA,eAAA;EACA,mBAAA;EACA,iBAAA;AAu8CF;;AAr8CA;EACE,kBAAA;EACA,UAAA;EACA,kBAAA;EACA,yBAAA;AAw8CF;;AAt8CA;EACE,yBAAA;EACA,UAAA;AAy8CF;;AAv8CA;EACE,mCAAA;AA08CF;;AAx8CA;EACE,kBAAA;AA28CF;;AAz8CA;EACE,cAAA;EACA,YAAA;EACA,sBAAA;EACA,kBAAA;EACA,MAAA;EACA,QAAA;EACA,OAAA;EACA,SAAA;EACA,+CAAA,EACA,eAAA;EACA,4BAAA,EAAA,wCAAA;AA48CF;;AA18CA;EACE,eAAA;AA68CF;;AA18CA;EACE,kBAAA;AA68CF;;AA38CA;EACE,6BAAA;AA88CF;;AA58CA;EACE,+BAAA;AA+8CF;;AA78CA;EACE,iCAAA;AAg9CF;;AA98CA;EACE,+BAAA;AAi9CF;;AA/8CA;EACE,4BAAA;AAk9CF;;AAh9CA;EACE,+BAAA;AAm9CF;;AAj9CA;EACE,8BAAA;AAo9CF;;AAl9CA;EACE,4BAAA;AAq9CF;;AAl9CA;EACE,cAAA;EACA,mBAAA;EACA,YAAA;EACA,WAAA;EACA,kBAAA;EACA,wCAAA;EACA,mCAAA;EACA,UAAA;EACA,iBAAA;EACA,mBAAA;EACA,gCAAA;AAq9CF;;AAl9CA;EACE;IACE,kCAAA;IACA,UAAA;EAq9CF;EAn9CA;IACE,kCAAA;IACA,UAAA;EAq9CF;EAn9CA;IACE,UAAA;EAq9CF;EAn9CA;IACE,kCAAA;IACA,UAAA;EAq9CF;AACF;AAn9CA;;EAEE,2BAAA;AAq9CF;;AAl9CA;EACE,mCAAA;EACA,eAAA;EACA,MAAA;EACA,SAAA;EACA,OAAA;EACA,QAAA;EACA,cAAA;EACA,aAAA;AAq9CF;;AAn9CA;EACE,aAAA;EACA,uBAAA;EACA,mBAAA;AAs9CF;;AAn9CA;EACE,eAAA;EACA,aAAA;EACA,eAAA;EACA,YAAA;EACA,uBAAA;EACA,mBAAA;EACA,WAAA;EACA,YAAA;EACA,YAAA;EACA,UAAA;EACA,8CAAA;EACA,0CAAA;EACA,UAAA;EACA,2BAAA;EACA,uBAAA;AAs9CF;;AAp9CA;EACE,qCAAA;AAu9CF;;AAr9CA;EACE,YAAA;EACA,WAAA;AAw9CF;;AAt9CA;EACE,iBAAA;EACA,qCAAA;AAy9CF;;AAv9CA;EACE,oDAAA;AA09CF;;AAx9CA;;EAEE,2CAAA;AA29CF;;AAz9CA;EACE,uCAAA;EACA,8CAAA;EACA,aAAA;AA49CF;;AA19CA;EACE,2BAAA;EACA,0CAAA;AA69CF;;AA19CA;EACE;IACE,YAAA;IACA,UAAA;IACA,WAAA;IACA,YAAA;EA69CF;AACF;AA39CA;EACE;IACE,oBAAA;EA69CF;EA39CA;IACE,gBAAA;EA69CF;AACF;AA39CA;EACE,cAAA;EACA,2BAAA;AA69CF;;AA39CA;EACE,eAAA;EACA,cAAA;AA89CF;;AA59CA;EACE,2BAAA;AA+9CF;;AA79CA;EACE,6BAAA;AAg+CF;;AA99CA;EACE,+BAAA;AAi+CF;;AA/9CA;EACE,2BAAA;AAk+CF;;AAh+CA;EACE,6BAAA;AAm+CF;;AAj+CA;EACE,0BAAA;AAo+CF;;AAl+CA;EACE,6BAAA;AAq+CF;;AAn+CA;EACE,4BAAA;AAs+CF;;AAp+CA;EACE,0BAAA;AAu+CF;;AAr+CA;EACE,2BAAA;AAw+CF;;AAt+CA;EACE,8BAAA;AAy+CF;;AAv+CA;EACE,8BAAA;AA0+CF;;AAx+CA;EACE,8BAAA;AA2+CF;;AAz+CA;EACE,8BAAA;AA4+CF;;AA1+CA;EACE,8BAAA;AA6+CF;;AA3+CA;EACE,8BAAA;AA8+CF;;AA5+CA;EACE,8BAAA;AA++CF;;AA7+CA;EACE,8BAAA;AAg/CF;;AA9+CA;EACE,8BAAA;AAi/CF;;AA/+CA;EACE,0BAAA;EACA,yBAAA;AAk/CF;;AAh/CA;EACE,yBAAA;EACA,wBAAA;AAm/CF;;AAj/CA;EACE,0BAAA;EACA,yBAAA;AAo/CF;;AAl/CA;EACE,0BAAA;EACA,yBAAA;AAq/CF;;AAn/CA;EACE,0BAAA;EACA,yBAAA;AAs/CF;;AAp/CA;EACE,2BAAA;EACA,0BAAA;AAu/CF;;AAr/CA;EACE,0BAAA;EACA,yBAAA;AAw/CF;;AAt/CA;EACE,0BAAA;EACA,yBAAA;AAy/CF;;AAv/CA;EACE,0BAAA;EACA,yBAAA;AA0/CF;;AAx/CA;EACE,yBAAA;EACA,wBAAA;AA2/CF;;AAz/CA;EACE,uBAAA;EACA,sBAAA;AA4/CF;;AA1/CA;EACE,uBAAA;EACA,sBAAA;AA6/CF;;AA3/CA;EACE,uBAAA;EACA,sBAAA;AA8/CF;;AA5/CA;EACE,0BAAA;EACA,yBAAA;AA+/CF;;AA7/CA;EACE,yBAAA;EACA,wBAAA;AAggDF;;AA9/CA;EACE,0BAAA;EACA,yBAAA;AAigDF;;AA//CA;EACE,uBAAA;EACA,sBAAA;AAkgDF;;AAhgDA;EACE,0BAAA;EACA,yBAAA;AAmgDF;;AAjgDA;EACE,yBAAA;EACA,wBAAA;AAogDF;;AAlgDA;EACE,0BAAA;EACA,yBAAA;AAqgDF;;AAngDA;EACE,uBAAA;EACA,sBAAA;AAsgDF;;AApgDA;EACE,0BAAA;EACA,yBAAA;AAugDF;;AArgDA;EACE,yBAAA;EACA,wBAAA;AAwgDF;;AAtgDA;EACE,0BAAA;EACA,yBAAA;AAygDF;;AAvgDA;EACE,uBAAA;EACA,sBAAA;AA0gDF;;AAxgDA;EACE,0BAAA;EACA,yBAAA;AA2gDF;;AAzgDA;EACE,yBAAA;EACA,wBAAA;AA4gDF;;AA1gDA;EACE,0BAAA;EACA,yBAAA;AA6gDF;;AA3gDA;EACE,uBAAA;EACA,sBAAA;AA8gDF;;AA5gDA;EACE,0BAAA;EACA,yBAAA;AA+gDF;;AA7gDA;EACE,yBAAA;EACA,wBAAA;AAghDF;;AA9gDA;EACE,0BAAA;EACA,yBAAA;AAihDF;;AA/gDA;EACE,uBAAA;EACA,sBAAA;AAkhDF;;AAhhDA;EACE,0BAAA;EACA,yBAAA;AAmhDF;;AAjhDA;EACE,yBAAA;EACA,wBAAA;AAohDF;;AAlhDA;EACE,0BAAA;EACA,yBAAA;AAqhDF;;AAnhDA;EACE;IACE,0BAAA;IACA,yBAAA;EAshDF;EAphDA;IACE,yBAAA;IACA,wBAAA;EAshDF;EAphDA;IACE,0BAAA;IACA,yBAAA;EAshDF;EAphDA;IACE,0BAAA;IACA,yBAAA;EAshDF;EAphDA;IACE,0BAAA;IACA,yBAAA;EAshDF;EAphDA;IACE,2BAAA;IACA,0BAAA;EAshDF;EAphDA;IACE,0BAAA;IACA,yBAAA;EAshDF;EAphDA;IACE,0BAAA;IACA,yBAAA;EAshDF;EAphDA;IACE,0BAAA;IACA,yBAAA;EAshDF;EAphDA;IACE,yBAAA;IACA,wBAAA;EAshDF;EAphDA;IACE,uBAAA;IACA,sBAAA;EAshDF;EAphDA;IACE,uBAAA;IACA,sBAAA;EAshDF;EAphDA;IACE,uBAAA;IACA,sBAAA;EAshDF;EAphDA;IACE,0BAAA;IACA,yBAAA;EAshDF;EAphDA;IACE,yBAAA;IACA,wBAAA;EAshDF;EAphDA;IACE,0BAAA;IACA,yBAAA;EAshDF;EAphDA;IACE,uBAAA;IACA,sBAAA;EAshDF;EAphDA;IACE,0BAAA;IACA,yBAAA;EAshDF;EAphDA;IACE,yBAAA;IACA,wBAAA;EAshDF;EAphDA;IACE,0BAAA;IACA,yBAAA;EAshDF;EAphDA;IACE,uBAAA;IACA,sBAAA;EAshDF;EAphDA;IACE,0BAAA;IACA,yBAAA;EAshDF;EAphDA;IACE,yBAAA;IACA,wBAAA;EAshDF;EAphDA;IACE,0BAAA;IACA,yBAAA;EAshDF;EAphDA;IACE,uBAAA;IACA,sBAAA;EAshDF;EAphDA;IACE,0BAAA;IACA,yBAAA;EAshDF;EAphDA;IACE,yBAAA;IACA,wBAAA;EAshDF;EAphDA;IACE,0BAAA;IACA,yBAAA;EAshDF;EAphDA;IACE,uBAAA;IACA,sBAAA;EAshDF;EAphDA;IACE,0BAAA;IACA,yBAAA;EAshDF;EAphDA;IACE,yBAAA;IACA,wBAAA;EAshDF;EAphDA;IACE,0BAAA;IACA,yBAAA;EAshDF;EAphDA;IACE,uBAAA;IACA,sBAAA;EAshDF;EAphDA;IACE,0BAAA;IACA,yBAAA;EAshDF;EAphDA;IACE,yBAAA;IACA,wBAAA;EAshDF;EAphDA;IACE,0BAAA;IACA,yBAAA;EAshDF;AACF;AAphDA;EACE;IACE,0BAAA;IACA,yBAAA;EAshDF;EAphDA;IACE,yBAAA;IACA,wBAAA;EAshDF;EAphDA;IACE,0BAAA;IACA,yBAAA;EAshDF;EAphDA;IACE,0BAAA;IACA,yBAAA;EAshDF;EAphDA;IACE,0BAAA;IACA,yBAAA;EAshDF;EAphDA;IACE,2BAAA;IACA,0BAAA;EAshDF;EAphDA;IACE,0BAAA;IACA,yBAAA;EAshDF;EAphDA;IACE,0BAAA;IACA,yBAAA;EAshDF;EAphDA;IACE,0BAAA;IACA,yBAAA;EAshDF;EAphDA;IACE,yBAAA;IACA,wBAAA;EAshDF;EAphDA;IACE,uBAAA;IACA,sBAAA;EAshDF;EAphDA;IACE,uBAAA;IACA,sBAAA;EAshDF;EAphDA;IACE,uBAAA;IACA,sBAAA;EAshDF;EAphDA;IACE,0BAAA;IACA,yBAAA;EAshDF;EAphDA;IACE,yBAAA;IACA,wBAAA;EAshDF;EAphDA;IACE,0BAAA;IACA,yBAAA;EAshDF;EAphDA;IACE,uBAAA;IACA,sBAAA;EAshDF;EAphDA;IACE,0BAAA;IACA,yBAAA;EAshDF;EAphDA;IACE,yBAAA;IACA,wBAAA;EAshDF;EAphDA;IACE,0BAAA;IACA,yBAAA;EAshDF;EAphDA;IACE,uBAAA;IACA,sBAAA;EAshDF;EAphDA;IACE,0BAAA;IACA,yBAAA;EAshDF;EAphDA;IACE,yBAAA;IACA,wBAAA;EAshDF;EAphDA;IACE,0BAAA;IACA,yBAAA;EAshDF;EAphDA;IACE,uBAAA;IACA,sBAAA;EAshDF;EAphDA;IACE,0BAAA;IACA,yBAAA;EAshDF;EAphDA;IACE,yBAAA;IACA,wBAAA;EAshDF;EAphDA;IACE,0BAAA;IACA,yBAAA;EAshDF;EAphDA;IACE,uBAAA;IACA,sBAAA;EAshDF;EAphDA;IACE,0BAAA;IACA,yBAAA;EAshDF;EAphDA;IACE,yBAAA;IACA,wBAAA;EAshDF;EAphDA;IACE,0BAAA;IACA,yBAAA;EAshDF;EAphDA;IACE,uBAAA;IACA,sBAAA;EAshDF;EAphDA;IACE,0BAAA;IACA,yBAAA;EAshDF;EAphDA;IACE,yBAAA;IACA,wBAAA;EAshDF;EAphDA;IACE,0BAAA;IACA,yBAAA;EAshDF;AACF;AAphDA;EACE;IACE,0BAAA;IACA,yBAAA;EAshDF;EAphDA;IACE,yBAAA;IACA,wBAAA;EAshDF;EAphDA;IACE,0BAAA;IACA,yBAAA;EAshDF;EAphDA;IACE,0BAAA;IACA,yBAAA;EAshDF;EAphDA;IACE,0BAAA;IACA,yBAAA;EAshDF;EAphDA;IACE,2BAAA;IACA,0BAAA;EAshDF;EAphDA;IACE,0BAAA;IACA,yBAAA;EAshDF;EAphDA;IACE,0BAAA;IACA,yBAAA;EAshDF;EAphDA;IACE,0BAAA;IACA,yBAAA;EAshDF;EAphDA;IACE,yBAAA;IACA,wBAAA;EAshDF;EAphDA;IACE,uBAAA;IACA,sBAAA;EAshDF;EAphDA;IACE,uBAAA;IACA,sBAAA;EAshDF;EAphDA;IACE,uBAAA;IACA,sBAAA;EAshDF;EAphDA;IACE,0BAAA;IACA,yBAAA;EAshDF;EAphDA;IACE,yBAAA;IACA,wBAAA;EAshDF;EAphDA;IACE,0BAAA;IACA,yBAAA;EAshDF;EAphDA;IACE,uBAAA;IACA,sBAAA;EAshDF;EAphDA;IACE,0BAAA;IACA,yBAAA;EAshDF;EAphDA;IACE,yBAAA;IACA,wBAAA;EAshDF;EAphDA;IACE,0BAAA;IACA,yBAAA;EAshDF;EAphDA;IACE,uBAAA;IACA,sBAAA;EAshDF;EAphDA;IACE,0BAAA;IACA,yBAAA;EAshDF;EAphDA;IACE,yBAAA;IACA,wBAAA;EAshDF;EAphDA;IACE,0BAAA;IACA,yBAAA;EAshDF;EAphDA;IACE,uBAAA;IACA,sBAAA;EAshDF;EAphDA;IACE,0BAAA;IACA,yBAAA;EAshDF;EAphDA;IACE,yBAAA;IACA,wBAAA;EAshDF;EAphDA;IACE,0BAAA;IACA,yBAAA;EAshDF;EAphDA;IACE,uBAAA;IACA,sBAAA;EAshDF;EAphDA;IACE,0BAAA;IACA,yBAAA;EAshDF;EAphDA;IACE,yBAAA;IACA,wBAAA;EAshDF;EAphDA;IACE,0BAAA;IACA,yBAAA;EAshDF;EAphDA;IACE,uBAAA;IACA,sBAAA;EAshDF;EAphDA;IACE,0BAAA;IACA,yBAAA;EAshDF;EAphDA;IACE,yBAAA;IACA,wBAAA;EAshDF;EAphDA;IACE,0BAAA;IACA,yBAAA;EAshDF;AACF;AAphDA;EACE;IACE,0BAAA;IACA,yBAAA;EAshDF;EAphDA;IACE,yBAAA;IACA,wBAAA;EAshDF;EAphDA;IACE,0BAAA;IACA,yBAAA;EAshDF;EAphDA;IACE,0BAAA;IACA,yBAAA;EAshDF;EAphDA;IACE,0BAAA;IACA,yBAAA;EAshDF;EAphDA;IACE,2BAAA;IACA,0BAAA;EAshDF;EAphDA;IACE,0BAAA;IACA,yBAAA;EAshDF;EAphDA;IACE,0BAAA;IACA,yBAAA;EAshDF;EAphDA;IACE,0BAAA;IACA,yBAAA;EAshDF;EAphDA;IACE,yBAAA;IACA,wBAAA;EAshDF;EAphDA;IACE,uBAAA;IACA,sBAAA;EAshDF;EAphDA;IACE,uBAAA;IACA,sBAAA;EAshDF;EAphDA;IACE,uBAAA;IACA,sBAAA;EAshDF;EAphDA;IACE,0BAAA;IACA,yBAAA;EAshDF;EAphDA;IACE,yBAAA;IACA,wBAAA;EAshDF;EAphDA;IACE,0BAAA;IACA,yBAAA;EAshDF;EAphDA;IACE,uBAAA;IACA,sBAAA;EAshDF;EAphDA;IACE,0BAAA;IACA,yBAAA;EAshDF;EAphDA;IACE,yBAAA;IACA,wBAAA;EAshDF;EAphDA;IACE,0BAAA;IACA,yBAAA;EAshDF;EAphDA;IACE,uBAAA;IACA,sBAAA;EAshDF;EAphDA;IACE,0BAAA;IACA,yBAAA;EAshDF;EAphDA;IACE,yBAAA;IACA,wBAAA;EAshDF;EAphDA;IACE,0BAAA;IACA,yBAAA;EAshDF;EAphDA;IACE,uBAAA;IACA,sBAAA;EAshDF;EAphDA;IACE,0BAAA;IACA,yBAAA;EAshDF;EAphDA;IACE,yBAAA;IACA,wBAAA;EAshDF;EAphDA;IACE,0BAAA;IACA,yBAAA;EAshDF;EAphDA;IACE,uBAAA;IACA,sBAAA;EAshDF;EAphDA;IACE,0BAAA;IACA,yBAAA;EAshDF;EAphDA;IACE,yBAAA;IACA,wBAAA;EAshDF;EAphDA;IACE,0BAAA;IACA,yBAAA;EAshDF;EAphDA;IACE,uBAAA;IACA,sBAAA;EAshDF;EAphDA;IACE,0BAAA;IACA,yBAAA;EAshDF;EAphDA;IACE,yBAAA;IACA,wBAAA;EAshDF;EAphDA;IACE,0BAAA;IACA,yBAAA;EAshDF;AACF;AAphDA;EACE;IACE,0BAAA;IACA,yBAAA;EAshDF;EAphDA;IACE,yBAAA;IACA,wBAAA;EAshDF;EAphDA;IACE,0BAAA;IACA,yBAAA;EAshDF;EAphDA;IACE,0BAAA;IACA,yBAAA;EAshDF;EAphDA;IACE,0BAAA;IACA,yBAAA;EAshDF;EAphDA;IACE,2BAAA;IACA,0BAAA;EAshDF;EAphDA;IACE,0BAAA;IACA,yBAAA;EAshDF;EAphDA;IACE,0BAAA;IACA,yBAAA;EAshDF;EAphDA;IACE,0BAAA;IACA,yBAAA;EAshDF;EAphDA;IACE,yBAAA;IACA,wBAAA;EAshDF;EAphDA;IACE,uBAAA;IACA,sBAAA;EAshDF;EAphDA;IACE,uBAAA;IACA,sBAAA;EAshDF;EAphDA;IACE,uBAAA;IACA,sBAAA;EAshDF;EAphDA;IACE,0BAAA;IACA,yBAAA;EAshDF;EAphDA;IACE,yBAAA;IACA,wBAAA;EAshDF;EAphDA;IACE,0BAAA;IACA,yBAAA;EAshDF;EAphDA;IACE,uBAAA;IACA,sBAAA;EAshDF;EAphDA;IACE,0BAAA;IACA,yBAAA;EAshDF;EAphDA;IACE,yBAAA;IACA,wBAAA;EAshDF;EAphDA;IACE,0BAAA;IACA,yBAAA;EAshDF;EAphDA;IACE,uBAAA;IACA,sBAAA;EAshDF;EAphDA;IACE,0BAAA;IACA,yBAAA;EAshDF;EAphDA;IACE,yBAAA;IACA,wBAAA;EAshDF;EAphDA;IACE,0BAAA;IACA,yBAAA;EAshDF;EAphDA;IACE,uBAAA;IACA,sBAAA;EAshDF;EAphDA;IACE,0BAAA;IACA,yBAAA;EAshDF;EAphDA;IACE,yBAAA;IACA,wBAAA;EAshDF;EAphDA;IACE,0BAAA;IACA,yBAAA;EAshDF;EAphDA;IACE,uBAAA;IACA,sBAAA;EAshDF;EAphDA;IACE,0BAAA;IACA,yBAAA;EAshDF;EAphDA;IACE,yBAAA;IACA,wBAAA;EAshDF;EAphDA;IACE,0BAAA;IACA,yBAAA;EAshDF;EAphDA;IACE,uBAAA;IACA,sBAAA;EAshDF;EAphDA;IACE,0BAAA;IACA,yBAAA;EAshDF;EAphDA;IACE,yBAAA;IACA,wBAAA;EAshDF;EAphDA;IACE,0BAAA;IACA,yBAAA;EAshDF;AACF;AAnhDA;EACE,eAAA;EACA,YAAA;EACA,MAAA;EACA,OAAA;EACA,QAAA;AAqhDF;;AAlhDA;EACE;IACE,eAAA;IACA,YAAA;IACA,MAAA;IACA,OAAA;IACA,QAAA;EAqhDF;AACF;AAnhDA;EACE;IACE,eAAA;IACA,YAAA;IACA,MAAA;IACA,OAAA;IACA,QAAA;EAqhDF;AACF;AAnhDA;EACE;IACE,eAAA;IACA,YAAA;IACA,MAAA;IACA,OAAA;IACA,QAAA;EAqhDF;AACF;AAnhDA;EACE;IACE,eAAA;IACA,YAAA;IACA,MAAA;IACA,OAAA;IACA,QAAA;EAqhDF;AACF;AAnhDA;EACE;IACE,eAAA;IACA,YAAA;IACA,MAAA;IACA,OAAA;IACA,QAAA;EAqhDF;AACF;AAnhDA;EACE,kBAAA;EACA,UAAA;EACA,SAAA;EACA,aAAA;EACA,uBAAA;AAqhDF;;AAnhDA;EACE,YAAA;AAshDF;;AAphDA;EACE,cAAA;EACA,YAAA;EACA,uBAAA;EACA,kBAAA;EACA,UAAA;EACA,OAAA;EACA,MAAA;EACA,SAAA;EACA,yBAAA;EACA,sBAAA;EACA,yBAAA;EACA,qCAAA;AAuhDF;;AArhDA;EACE,UAAA;EACA,cAAA;EACA,kBAAA;AAwhDF;;AAthDA;EACE,WAAA;EACA,cAAA;EACA,qBAAA;AAyhDF;;AAvhDA;EACE,mBAAA;AA0hDF;;AAxhDA;EACE,QAAA;AA2hDF;;AAzhDA;EACE,WAAA;AA4hDF;;AAzhDA;EACE,kBAAA;AA4hDF;;AA1hDA;EACE,WAAA;EACA,kBAAA;EACA,UAAA;EACA,UAAA;EACA,MAAA;EACA,SAAA;EACA,oCAAA;AA6hDF;;AA3hDA;EACE,aAAA;EACA,uBAAA;EACA,kBAAA;EACA,qBAAA;AA8hDF;;AA5hDA;EACE,gBAAA;AA+hDF;;AA7hDA;EACE,WAAA;EACA,cAAA;EACA,kBAAA;EACA,yBAAA;AAgiDF;;AA9hDA;EACE,cAAA;EACA,mCAAA;EACA,WAAA;EACA,YAAA;EACA,aAAA;EACA,uBAAA;EACA,mBAAA;EACA,UAAA;EACA,kBAAA;EACA,eAAA;EACA,oBAAA;EACA,uBAAA;EACA,8CAAA;AAiiDF;;AA/hDA;EACE,YAAA;AAkiDF;;AA/hDA;EACE,kBAAA;AAkiDF;;AAhiDA;EACE,kBAAA;EACA,MAAA;EACA,SAAA;EACA,OAAA;EACA,QAAA;EACA,aAAA;EACA,uBAAA;EACA,mBAAA;EACA,sCAAA;EACA,yBAAA;EACA,UAAA;AAmiDF;;AAjiDA;EACE,yBAAA;EACA,UAAA;AAoiDF;;AAliDA;EACE,YAAA;AAqiDF;;AAliDA;EACE,qBAAA;EACA,2CAAA;EACA,kBAAA;EACA,UAAA;EACA,WAAA;EACA,cAAA;AAqiDF;;AAliDA;EACE,UAAA;EACA,WAAA;EACA,8BAAA;AAqiDF;;AAliDA;EACE,UAAA;EACA,WAAA;AAqiDF;;AAliDA;EACE,UAAA;EACA,WAAA;EACA,gBAAA;AAqiDF;;AAliDA;EACE,wBAAA;EACA,cAAA;EACA,YAAA;EACA,eAAA;EACA,MAAA;EACA,SAAA;EACA,2CAAA;EACA,iDAAA;AAqiDF;;AAniDA;EACE,OAAA;EACA,4BAAA;AAsiDF;;AApiDA;EACE,QAAA;EACA,2BAAA;AAuiDF;;AAriDA;EACE,eAAA;EACA,uCAAA;EACA,iDAAA;AAwiDF;;AAriDA;EACE,eAAA;EACA,MAAA;EACA,OAAA;EACA,SAAA;EACA,QAAA;EACA,gBAAA;EACA,YAAA;EACA,mDAAA;EACA,sDAAA;AAwiDF;;AAriDA;EACE,aAAA;AAwiDF;;AAriDA;EACE;IACE,UAAA;EAwiDF;EAtiDA;IACE,UAAA;EAwiDF;AACF;AAtiDA;EACE;IACE,gBAAA;EAwiDF;AACF;AAtiDA;EACE,oBAAA;EACA,mBAAA;AAwiDF;;AAtiDA;EACE,oBAAA;EACA,mBAAA;EACA,uBAAA;EACA,eAAA;EACA,kBAAA;EACA,iBAAA;EACA,cAAA;AAyiDF;;AAviDA;EACE,kBAAA;EACA,UAAA;EACA,gBAAA;EACA,cAAA;AA0iDF;;AAxiDA;EACE,iBAAA;EACA,iBAAA;AA2iDF;;AAziDA;EACE,cAAA;AA4iDF;;AA1iDA;EACE,aAAA;EACA,cAAA;AA6iDF;;AA3iDA;EACE,eAAA;EACA,eAAA;AA8iDF;;AA5iDA;EACE,YAAA;AA+iDF;;AA7iDA;EACE,WAAA;EACA,YAAA;AAgjDF;;AA7iDA;EACE,8BAAA;EACA,iCAAA;AAgjDF;;AA9iDA;EACE,iCAAA;EACA,sBAAA;EACA,6BAAA;AAijDF;;AA9iDA;EACE,sBAAA;EACA,uCAAA;AAijDF;;AA9iDA;EACE,gCAAA;EACA,mCAAA;AAijDF;;AA/iDA;EACE,mCAAA;EACA,wBAAA;EACA,6BAAA;AAkjDF;;AA/iDA;EACE,wBAAA;EACA,yCAAA;AAkjDF;;AA/iDA;EACE,kCAAA;EACA,qCAAA;AAkjDF;;AAhjDA;EACE,qCAAA;EACA,0BAAA;EACA,6BAAA;AAmjDF;;AAhjDA;EACE,0BAAA;EACA,2CAAA;AAmjDF;;AAhjDA;EACE,gCAAA;EACA,mCAAA;AAmjDF;;AAjjDA;EACE,mCAAA;EACA,wBAAA;EACA,6BAAA;AAojDF;;AAjjDA;EACE,wBAAA;EACA,yCAAA;AAojDF;;AAjjDA;EACE,6BAAA;EACA,gCAAA;AAojDF;;AAljDA;EACE,gCAAA;EACA,qBAAA;EACA,6BAAA;AAqjDF;;AAljDA;EACE,qBAAA;EACA,sCAAA;AAqjDF;;AAljDA;EACE,gCAAA;EACA,mCAAA;AAqjDF;;AAnjDA;EACE,mCAAA;EACA,wBAAA;EACA,6BAAA;AAsjDF;;AAnjDA;EACE,wBAAA;EACA,yCAAA;AAsjDF;;AAnjDA;EACE,+BAAA;EACA,kCAAA;AAsjDF;;AApjDA;EACE,kCAAA;EACA,uBAAA;EACA,6BAAA;AAujDF;;AApjDA;EACE,uBAAA;EACA,wCAAA;AAujDF;;AApjDA;EACE,6BAAA;EACA,gCAAA;AAujDF;;AArjDA;EACE,gCAAA;EACA,qBAAA;EACA,6BAAA;AAwjDF;;AArjDA;EACE,qBAAA;EACA,sCAAA;AAwjDF;;AArjDA;EACE,aAAA;AAwjDF;;AAtjDA;EACE,qBAAA;AAyjDF;;AAtjDA;EACE,aAAA;AAyjDF;;AAtjDA;EACE,+BAAA;AAyjDF;;AAvjDA;EACE,4BAAA;EACA,+BAAA;EACA,sBAAA;AA0jDF;;AAvjDA;EACE,+BAAA;AA0jDF;;AAxjDA;EACE,2BAAA;EACA,+BAAA;EACA,sBAAA;AA2jDF;;AAxjDA;EACE,+BAAA;AA2jDF;;AAzjDA;EACE,qBAAA;EACA,+BAAA;EACA,sBAAA;AA4jDF;;AAzjDA;EACE,+BAAA;AA4jDF;;AA1jDA;EACE,uBAAA;EACA,+BAAA;EACA,sBAAA;AA6jDF;;AA1jDA;EACE,+BAAA;AA6jDF;;AA3jDA;EACE,wBAAA;EACA,+BAAA;EACA,sBAAA;AA8jDF;;AA3jDA;EACE,oBAAA;EACA,mBAAA;AA8jDF;;AA3jDA;EACE,+BAAA;EACA,2BAAA;EACA,sBAAA;AA8jDF;;AA5jDA;EACE,yBAAA;EACA,+BAAA;AA+jDF;;AA7jDA;EACE,0BAAA;AAgkDF;;AA7jDA;EACE,+BAAA;EACA,2BAAA;EACA,sBAAA;AAgkDF;;AA9jDA;EACE,0BAAA;EACA,+BAAA;AAikDF;;AA/jDA;EACE,yBAAA;AAkkDF;;AA/jDA;EACE,+BAAA;EACA,2BAAA;EACA,sBAAA;AAkkDF;;AAhkDA;EACE,0BAAA;EACA,+BAAA;AAmkDF;;AAjkDA;EACE,2BAAA;AAokDF;;AAjkDA;EACE,+BAAA;EACA,2BAAA;EACA,sBAAA;AAokDF;;AAlkDA;EACE,2BAAA;EACA,+BAAA;AAqkDF;;AAnkDA;EACE,0BAAA;AAskDF;;AAnkDA;EACE,+BAAA;EACA,2BAAA;EACA,sBAAA;AAskDF;;AApkDA;EACE,0BAAA;EACA,+BAAA;AAukDF;;AArkDA;EACE,2BAAA;AAwkDF;;AArkDA;EACE,+BAAA;EACA,2BAAA;EACA,sBAAA;AAwkDF;;AAtkDA;EACE,2BAAA;EACA,+BAAA;AAykDF;;AAvkDA;EACE,0BAAA;AA0kDF;;AAvkDA;EACE;;;;;;IAME,qBAAA;IACA,sDAAA;EA0kDF;EAxkDA;;;;;;IAME,+BAAA;IACA,gCAAA;EA0kDF;EAxkDA;;;;;;IAME,6BAAA;EA0kDF;EAxkDA;;;;;;IAME,uCAAA;EA0kDF;EAxkDA;;;;;;IAME,2CAAA;EA0kDF;EAxkDA;;;;;;IAME,6BAAA;EA0kDF;EAxkDA;;;;;;IAME,4DAAA;EA0kDF;EAxkDA;;;;;;IAME,iDAAA;EA0kDF;EAxkDA;;;;;;IAME,6BAAA;EA0kDF;AACF;AAxkDA;EACE,gBAAA;EACA,kBAAA;AA0kDF;;AAxkDA;EACE;IACE,cAAA;EA2kDF;AACF;AAxkDA;EACE,kBAAA;EACA,kBAAA;AA0kDF;;AAxkDA;EACE;IACE,gBAAA;EA2kDF;AACF;AAxkDA;EACE,kBAAA;EACA,kBAAA;AA0kDF;;AAxkDA;EACE;IACE,gBAAA;EA2kDF;AACF;AAxkDA;;EAEE,kBAAA;AA0kDF;;AAxkDA;EACE;;IAEE,gBAAA;EA2kDF;EAzkDA;IACE;;MAEE,gBAAA;IA2kDF;EACF;EAzkDA;;IAEE,gBAAA;EA2kDF;EAzkDA;;IAEE,uCAAA;IACA,wCAAA;EA2kDF;EAzkDA;;IAEE,4BAAA;IACA,2DAAA;IACA,+CAAA;EA2kDF;EAzkDA;;IAEE,iBAAA;EA2kDF;AACF;AAzkDA;EACE;;IAEE,cAAA;EA2kDF;AACF;AAxkDA;;EAEE,kBAAA;AA0kDF;;AAxkDA;EACE;;IAEE,kBAAA;EA2kDF;EAzkDA;IACE;;MAEE,kBAAA;IA2kDF;EACF;EAzkDA;;IAEE,kBAAA;EA2kDF;EAzkDA;;IAEE,uCAAA;EA2kDF;EAzkDA;;IAEE,4BAAA;IACA,2DAAA;IACA,+CAAA;EA2kDF;EAzkDA;;IAEE,mBAAA;EA2kDF;AACF;AAzkDA;EACE;;IAEE,gBAAA;EA2kDF;AACF;AAxkDA;;EAEE,kBAAA;AA0kDF;;AAxkDA;EACE;;IAEE,kBAAA;EA2kDF;EAzkDA;IACE;;MAEE,kBAAA;IA2kDF;EACF;EAzkDA;;IAEE,kBAAA;EA2kDF;EAzkDA;;IAEE,wCAAA;EA2kDF;EAzkDA;;IAEE,4BAAA;IACA,2DAAA;IACA,+CAAA;EA2kDF;EAzkDA;;IAEE,mBAAA;EA2kDF;AACF;AAzkDA;EACE;;IAEE,gBAAA;EA2kDF;AACF;AAxkDA;EACE,iDAAA;AA0kDF;;AAvkDA;EACE,gDAAA;AA0kDF;;AAvkDA;EACE,kDAAA;AA0kDF;;AAvkDA;EACE,kDAAA;AA0kDF;;AAvkDA;EACE,iDAAA;AA0kDF;;AAvkDA;EACE,iDAAA;EACA,kDAAA;AA0kDF;;AAvkDA;EACE,gDAAA;EACA,iDAAA;AA0kDF;;AAvkDA;EACE,aAAA;EACA,mBAAA;AA0kDF;;AAvkDA;EACE,6BAAA;EACA,wBAAA;AA0kDF;;AAxkDA;EACE,aAAA;AA2kDF;;AAxkDA;EACE,UAAA;EACA,SAAA;AA2kDF;;AAzkDA;EACE,cAAA;EACA,qCAAA;AA4kDF;;AAzkDA;EACE,eAAA;AA4kDF;;AAzkDA;;;EAGE,oCAAA;AA4kDF;;AAzkDA;EACE,qCAAA;AA4kDF;;AAzkDA;EACE,oCAAA;AA4kDF;;AAzkDA;EACE,qCAAA;AA4kDF;;AA1kDA;EACE,qCAAA;AA6kDF;;AA1kDA;;EAEE,aAAA;AA6kDF;;AA3kDA;;EAEE,aAAA;AA8kDF;;AA5kDA;EACE,eAAA;AA+kDF;;AA7kDA;EACE,aAAA;AAglDF;;AA9kDA;EACE,aAAA;AAilDF;;AA/kDA;EACE,qBAAA;AAklDF;;AAhlDA;EACE,aAAA;AAmlDF;;AAjlDA;EACE,aAAA;AAolDF;;AAllDA;EACE,qBAAA;AAqlDF;;AAnlDA;EACE,aAAA;AAslDF;;AAplDA;EACE,qBAAA;AAulDF;;AArlDA;EACE,qBAAA;AAwlDF;;AAtlDA;EACE,aAAA;AAylDF;;AAvlDA;EACE,qBAAA;AA0lDF;;AAxlDA;EACE,aAAA;AA2lDF;;AAzlDA;EACE,qBAAA;AA4lDF;;AA1lDA;EACE,aAAA;AA6lDF;;AA3lDA;EACE,aAAA;AA8lDF;;AA5lDA;EACE,aAAA;AA+lDF;;AA7lDA;EACE,qBAAA;AAgmDF;;AA9lDA;EACE,aAAA;AAimDF;;AA9lDA;EACE,6BAAA;EACA,oCAAA;EACA,kCAAA;EACA,mDAAA;EACA,qDAAA;EACA,6DAAA;EACA,2BAAA;EACA,mCAAA;EACA,qCAAA;EACA,iDAAA;EACA,uDAAA;EACA,0DAAA;EACA,mCAAA;EACA,2CAAA;EACA,6CAAA;EACA,kDAAA;EACA,0DAAA;EACA,8DAAA;EACA,kCAAA;EACA,0CAAA;EACA,4CAAA;EACA,mDAAA;EACA,yDAAA;EACA,2DAAA;EACA,uDAAA;AAimDF;;AA/lDA;EACE,aAAA;AAkmDF;;AAhmDA;EACE,aAAA;EACA,mBAAA;EACA,2BAAA;AAmmDF;;AAjmDA;EACE,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,cAAA;EACA,2BAAA;EACA,mCAAA;EACA,oCAAA;EACA,mDAAA;EACA,iDAAA;EACA,qCAAA;EACA,oBAAA;AAomDF;;AAlmDA;EACE,aAAA;EACA,4CAAA;AAqmDF;;AAnmDA;EACE,gBAAA;EACA,0CAAA;EACA,kBAAA;AAsmDF;;AApmDA;EACE,aAAA;EACA,sBAAA;EACA,uBAAA;AAumDF;;AArmDA;EACE,0CAAA;EACA,8CAAA;EACA,gBAAA;EACA,kBAAA;EACA,qBAAA;AAwmDF;;AAtmDA;EACE,6CAAA;EACA,yCAAA;AAymDF;;AAvmDA;EACE,2BAAA;AA0mDF;;AAxmDA;EACE,2BAAA;EACA,yDAAA;EACA,6CAAA;AA2mDF;;AAzmDA;EACE,aAAA;AA4mDF;;AA1mDA;EACE,kDAAA;EACA,kBAAA;AA6mDF;;AA3mDA;EACE,sDAAA;EACA,kDAAA;AA8mDF;;AA5mDA;EACE,qDAAA;EACA,iDAAA;AA+mDF;;AA7mDA;EACE,2BAAA;EACA,2DAAA;EACA,+CAAA;AAgnDF;;AA9mDA;EACE,mDAAA;EACA,qBAAA;AAinDF;;AA/mDA;EACE,aAAA;AAknDF;;AAhnDA;EACE,wDAAA;EACA,oDAAA;AAmnDF;;AAjnDA;EACE,uDAAA;EACA,mDAAA;AAonDF;;AAlnDA;EACE,sBAAA;EACA,kBAAA;AAqnDF;;AAnnDA;EACE,sBAAA;EACA,sBAAA;EACA,oBAAA;EACA,UAAA;EACA,SAAA;AAsnDF;;AApnDA;EACE,aAAA;EACA,mBAAA;AAunDF;;AArnDA;EACE,UAAA;AAwnDF;;AAtnDA;EACE,cAAA;EACA,YAAA;EACA,mDAAA;EACA,0CAAA;EACA,eAAA;EACA,kBAAA;AAynDF;;AAtnDA;EACE,aAAA;EACA,cAAA;EACA,uBAAA;EACA,mBAAA;EACA,eAAA;AAynDF;;AAvnDA;EACE,kBAAA;EACA,cAAA;EACA,mBAAA;AA0nDF;;AAxnDA;EACE,YAAA;EACA,kBAAA;EACA,WAAA;EACA,OAAA;EACA,WAAA;EACA,WAAA;EACA,6BAAA;EACA,2BAAA;AA2nDF;;AAznDA;EACE,qBAAA;EACA,gBAAA;EACA,kBAAA;AA4nDF;;AA1nDA;EACE,2BAAA;AA6nDF;;AA3nDA;EACE,wBAAA;AA8nDF;;AA5nDA;EACE,mCAAA;AA+nDF;;AA7nDA;EACE,yBAAA;AAgoDF;;AA7nDA;EACE,aAAA;AAgoDF;;AA9nDA;EACE,aAAA;AAioDF;;AA9nDA;EACE,smCAAA;AAioDF;;AA9nDA;EACE,8mDAAA;AAioDF;;AA9nDA;EACE,kBAAA;AAioDF;;AA/nDA;EACE,aAAA;EACA,uBAAA;EACA,mBAAA;EACA,iBAAA;EACA,kBAAA;EACA,UAAA;EACA,2CAAA;EACA,6CAAA;EACA,gCAAA;EACA,QAAA;EACA,QAAA;EACA,2CAAA;AAkoDF;;AAhoDA;EACE,WAAA;EACA,kBAAA;EACA,UAAA;EACA,WAAA;EACA,YAAA;EACA,MAAA;EACA,OAAA;AAmoDF;;AAjoDA;EACE,iDAAA;AAooDF;;AAloDA;EACE,iBAAA;EACA,eAAA;EACA,gBAAA;EACA,kBAAA;AAqoDF;;AAnoDA;EACE,MAAA;EACA,6CAAA;EACA,oCAAA;EACA,mCAAA;AAsoDF;;AApoDA;EACE,iCAAA;EACA,gCAAA;AAuoDF;;AAroDA;EACE,QAAA;EACA,OAAA;EACA,WAAA;EACA,4CAAA;EACA,iCAAA;EACA,oCAAA;AAwoDF;;AAtoDA;EACE,gCAAA;EACA,mCAAA;AAyoDF;;AAtoDA;EACE,UAAA;AAyoDF;;AAvoDA;EACE,iCAAA;EACA,oCAAA;AA0oDF;;AAxoDA;EACE,WAAA;EACA,kBAAA;EACA,mBAAA;EACA,oCAAA;EACA,aAAA;AA2oDF;;AAzoDA;EACE,2BAAA;EACA,uDAAA;EACA,OAAA;AA4oDF;;AA1oDA;EACE,WAAA;AA6oDF;;AA3oDA;EACE,gCAAA;EACA,mCAAA;AA8oDF;;AA5oDA;EACE,WAAA;EACA,kBAAA;EACA,mBAAA;EACA,oCAAA;EACA,aAAA;AA+oDF;;AA7oDA;EACE,2BAAA;EACA,sDAAA;EACA,QAAA;AAgpDF;;AA7oDA;EACE,kBAAA;EACA,UAAA;EACA,aAAA;EACA,uBAAA;EACA,2BAAA;AAgpDF;;AA9oDA;EACE,MAAA;EACA,OAAA;EACA,WAAA;EACA,YAAA;EACA,gDAAA;EACA,mCAAA;EACA,+CAAA;EACA,kCAAA;AAipDF;;AA/oDA;EACE,MAAA;EACA,QAAA;EACA,WAAA;EACA,YAAA;EACA,gDAAA;EACA,8CAAA;EACA,oCAAA;EACA,kCAAA;AAkpDF;;AAhpDA;EACE,SAAA;EACA,OAAA;EACA,WAAA;EACA,YAAA;EACA,qCAAA;EACA,mCAAA;EACA,+CAAA;EACA,6CAAA;AAmpDF;;AAjpDA;EACE,SAAA;EACA,QAAA;EACA,WAAA;EACA,YAAA;EACA,qCAAA;EACA,oCAAA;EACA,8CAAA;EACA,6CAAA;AAopDF;;AAjpDA;EACE,kBAAA;AAopDF;;AAlpDA;EACE,yBAAA;EACA,kBAAA;EACA,MAAA;EACA,SAAA;EACA,OAAA;EACA,QAAA;EACA,aAAA;EACA,uBAAA;EACA,mBAAA;EACA,8CAAA;AAqpDF;;AAnpDA;EACE,eAAA;EACA,cAAA;AAspDF;;AAppDA;EACE,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,gDAAA;EACA,8CAAA;EACA,yBAAA;EACA,gBAAA;EACA,oBAAA;EACA,WAAA;EACA,mCAAA;AAupDF;;AArpDA;EACE,qBAAA;AAwpDF;;AArpDA;EACE,kDAAA;EACA,gCAAA;EACA,iEAAA;AAwpDF;;AArpDA;EACE,yBAAA;EACA,yBAAA;AAwpDF;;AAtpDA;EACE,cAAA;EACA,yBAAA;AAypDF;;AAtpDA;EACE,SAAA;AAypDF;;AAvpDA;;EAEE,cAAA;AA0pDF;;AAvpDA;EACE,SAAA;EACA,cAAA;EACA,yBAAA;AA0pDF;;AAxpDA;EACE,cAAA;EACA,yBAAA;AA2pDF;;AAxpDA;EACE,SAAA;EACA,yBAAA;EACA,oCAAA;AA2pDF;;AAzpDA;EACE,yBAAA;EACA,oCAAA;AA4pDF;;AAzpDA;EACE,gDAAA;AA4pDF;;AA1pDA;EACE,qCAAA;EACA,yBAAA;AA6pDF;;AA1pDA;EACE,cAAA;AA6pDF;;AA3pDA;EACE,cAAA;AA8pDF;;AA3pDA;EACE,yBAAA;AA8pDF;;AA3pDA;EACE,cAAA;AA8pDF;;AA3pDA;EACE,cAAA;AA8pDF;;AA3pDA;EACE,cAAA;EACA,yBAAA;AA8pDF;;AA3pDA;EACE,cAAA;EACA,yBAAA;AA8pDF;;AA3pDA;EACE,eAAA;EACA,QAAA;EACA,QAAA;EACA,2BAAA;EACA,aAAA;EACA,sBAAA;EACA,qBAAA;EACA,UAAA;EACA,mBAAA;AA8pDF;;AA5pDA;EACE,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,sBAAA;EACA,2CAAA;EACA,iBAAA;EACA,mBAAA;EACA,eAAA;EACA,gBAAA;EACA,kBAAA;EACA,kBAAA;EACA,WAAA;EACA,YAAA;EACA,iCAAA;EACA,+CAAA;EACA,yCAAA;AA+pDF;;AA7pDA;;EAEE,sCAAA;AAgqDF;;AA9pDA;EACE,sCAAA;AAiqDF;;AA/pDA;EACE,6BAAA;EACA,4BAAA;EACA,gCAAA;AAkqDF;;AAhqDA;;EAEE,6BAAA;AAmqDF;;AAjqDA;EACE,gCAAA;EACA,+BAAA;EACA,mCAAA;AAoqDF;;AAlqDA;;EAEE,gCAAA;AAqqDF;;AAnqDA;EACE,gCAAA;EACA,+BAAA;EACA,mCAAA;AAsqDF;;AApqDA;;EAEE,gCAAA;AAuqDF;;AArqDA;EACE,WAAA;EACA,YAAA;AAwqDF;;AAtqDA;EACE,WAAA;EACA,YAAA;EACA,aAAA;AAyqDF;;AAvqDA;EACE,kBAAA;AA0qDF;;AAxqDA;EACE,aAAA;AA2qDF;;AAzqDA;EACE,mBAAA;EACA,aAAA;AA4qDF;;AAzqDA;EACE,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,iCAAA;EACA,qCAAA;EACA,yCAAA;AA4qDF;;AA1qDA;;EAEE,iCAAA;AA6qDF;;AA3qDA;EACE,iCAAA;AA8qDF;;AA5qDA;EACE,wCAAA;EACA,qCAAA;EACA,oDAAA;AA+qDF;;AA7qDA;;;;;;;;;EASE,wCAAA;AAgrDF;;AA9qDA;EACE,wCAAA;AAirDF;;AA9qDA;EACE,mBAAA;EACA,cAAA;AAirDF;;AA9qDA;EACE;IACE,qBAAA;IACA,2BAAA;EAirDF;EA/qDA;;;;;;;;;;IAUE,2BAAA;IACA,qBAAA;IACA,oBAAA;EAirDF;EA/qDA;;;;;;;;IAQE,wBAAA;EAirDF;AACF;AA/qDA;EACE,yCAAA;EACA,oCAAA;AAirDF;;AA9qDA;EACE,yCAAA;EACA,oCAAA;AAirDF;;AA9qDA;EACE,wCAAA;EACA,8CAAA;AAirDF;;AA9qDA;EACE,eAAA;AAirDF;;AA/qDA;EACE,8CAAA;AAkrDF;;AA/qDA;EACE,8CAAA;AAkrDF;;AA/qDA;EACE,eAAA;AAkrDF;;AAhrDA;EACE,8CAAA;AAmrDF;;AAhrDA;EACE,eAAA;AAmrDF;;AAjrDA;EACE,yCAAA;EACA,oCAAA;AAorDF;;AAjrDA;EACE,yCAAA;EACA,oCAAA;AAorDF;;AAjrDA;EACE,eAAA;AAorDF;;AAlrDA;EACE,yCAAA;EACA,oCAAA;AAqrDF;;AAlrDA;EACE,sCAAA;EACA,4CAAA;AAqrDF;;AAlrDA;EACE,6CAAA;EACA,mDAAA;AAqrDF;;AAlrDA;EACE,eAAA;AAqrDF;;AAnrDA;EACE,4CAAA;AAsrDF;;AAnrDA;EACE,4CAAA;AAsrDF;;AAnrDA;EACE,eAAA;AAsrDF;;AAprDA;EACE,4CAAA;AAurDF;;AAprDA;EACE,oDAAA;AAurDF;;AAprDA;EACE,wCAAA;EACA,8CAAA;AAurDF;;AAprDA;EACE,+CAAA;EACA,qDAAA;AAurDF;;AAprDA;EACE,eAAA;AAurDF;;AArrDA;EACE,oDAAA;AAwrDF;;AArrDA;EACE,eAAA;AAwrDF;;AAtrDA;EACE,oDAAA;AAyrDF;;AAtrDA;EACE,eAAA;AAyrDF;;AAvrDA;EACE,8CAAA;AA0rDF;;AAvrDA;EACE,8CAAA;AA0rDF;;AAvrDA;EACE,eAAA;AA0rDF;;AAxrDA;EACE,8CAAA;AA2rDF;;AAxrDA;EACE,sDAAA;AA2rDF;;AAxrDA;EACE,0CAAA;EACA,gDAAA;AA2rDF;;AAxrDA;EACE,iDAAA;EACA,uDAAA;AA2rDF;;AAxrDA;EACE,eAAA;AA2rDF;;AAzrDA;EACE,sDAAA;AA4rDF;;AAzrDA;EACE,eAAA;AA4rDF;;AA1rDA;EACE,sDAAA;AA6rDF;;AA1rDA;EACE,eAAA;AA6rDF;;AA3rDA;EACE,gDAAA;AA8rDF;;AA3rDA;EACE,gDAAA;AA8rDF;;AA3rDA;EACE,eAAA;AA8rDF;;AA5rDA;EACE,gDAAA;AA+rDF;;AA5rDA;EACE,oDAAA;AA+rDF;;AA5rDA;EACE,wCAAA;EACA,8CAAA;AA+rDF;;AA5rDA;EACE,+CAAA;EACA,qDAAA;AA+rDF;;AA5rDA;EACE,eAAA;AA+rDF;;AA7rDA;EACE,oDAAA;AAgsDF;;AA7rDA;EACE,eAAA;AAgsDF;;AA9rDA;EACE,oDAAA;AAisDF;;AA9rDA;EACE,eAAA;AAisDF;;AA/rDA;EACE,8CAAA;AAksDF;;AA/rDA;EACE,8CAAA;AAksDF;;AA/rDA;EACE,eAAA;AAksDF;;AAhsDA;EACE,8CAAA;AAmsDF;;AAhsDA;EACE,iDAAA;AAmsDF;;AAhsDA;EACE,qCAAA;EACA,2CAAA;AAmsDF;;AAhsDA;EACE,4CAAA;EACA,kDAAA;AAmsDF;;AAhsDA;EACE,eAAA;AAmsDF;;AAjsDA;EACE,iDAAA;AAosDF;;AAjsDA;EACE,eAAA;AAosDF;;AAlsDA;EACE,iDAAA;AAqsDF;;AAlsDA;EACE,eAAA;AAqsDF;;AAnsDA;EACE,2CAAA;AAssDF;;AAnsDA;EACE,2CAAA;AAssDF;;AAnsDA;EACE,eAAA;AAssDF;;AApsDA;EACE,2CAAA;AAusDF;;AApsDA;EACE,oDAAA;AAusDF;;AApsDA;EACE,wCAAA;EACA,8CAAA;AAusDF;;AApsDA;EACE,+CAAA;EACA,qDAAA;AAusDF;;AApsDA;EACE,eAAA;AAusDF;;AArsDA;EACE,oDAAA;AAwsDF;;AArsDA;EACE,eAAA;AAwsDF;;AAtsDA;EACE,oDAAA;AAysDF;;AAtsDA;EACE,eAAA;AAysDF;;AAvsDA;EACE,8CAAA;AA0sDF;;AAvsDA;EACE,8CAAA;AA0sDF;;AAvsDA;EACE,eAAA;AA0sDF;;AAxsDA;EACE,8CAAA;AA2sDF;;AAxsDA;EACE,mDAAA;AA2sDF;;AAxsDA;EACE,uCAAA;EACA,6CAAA;AA2sDF;;AAxsDA;EACE,8CAAA;EACA,oDAAA;AA2sDF;;AAxsDA;EACE,eAAA;AA2sDF;;AAzsDA;EACE,mDAAA;AA4sDF;;AAzsDA;EACE,eAAA;AA4sDF;;AA1sDA;EACE,mDAAA;AA6sDF;;AA1sDA;EACE,eAAA;AA6sDF;;AA3sDA;EACE,6CAAA;AA8sDF;;AA3sDA;EACE,6CAAA;AA8sDF;;AA3sDA;EACE,eAAA;AA8sDF;;AA5sDA;EACE,6CAAA;AA+sDF;;AA5sDA;EACE,iDAAA;AA+sDF;;AA5sDA;EACE,qCAAA;EACA,2CAAA;AA+sDF;;AA5sDA;EACE,4CAAA;EACA,kDAAA;AA+sDF;;AA5sDA;EACE,eAAA;AA+sDF;;AA7sDA;EACE,iDAAA;AAgtDF;;AA7sDA;EACE,eAAA;AAgtDF;;AA9sDA;EACE,iDAAA;AAitDF;;AA9sDA;EACE,eAAA;AAitDF;;AA/sDA;EACE,2CAAA;AAktDF;;AA/sDA;EACE,2CAAA;AAktDF;;AA/sDA;EACE,eAAA;AAktDF;;AAhtDA;EACE,2CAAA;AAmtDF;;AAhtDA;EACE,yCAAA;EACA,oCAAA;AAmtDF;;AAhtDA;EACE,yCAAA;EACA,+CAAA;AAmtDF;;AAhtDA;EACE,yCAAA;EACA,oCAAA;AAmtDF;;AAhtDA;EACE,yCAAA;EACA,+CAAA;AAmtDF;;AAhtDA;EACE,yCAAA;EACA,oCAAA;AAmtDF;;AAhtDA;EACE,yCAAA;EACA,+CAAA;AAmtDF;;AAhtDA;EACE,yCAAA;EACA,oCAAA;AAmtDF;;AAhtDA;EACE,yCAAA;EACA,+CAAA;AAmtDF;;AAhtDA;EACE,yCAAA;EACA,oCAAA;AAmtDF;;AAhtDA;EACE,yCAAA;EACA,+CAAA;AAmtDF;;AAhtDA;EACE,yCAAA;EACA,oCAAA;AAmtDF;;AAhtDA;EACE,yCAAA;EACA,+CAAA;AAmtDF;;AAhtDA;EACE,yCAAA;EACA,oCAAA;AAmtDF;;AAhtDA;EACE,yCAAA;EACA,+CAAA;AAmtDF;;AAhtDA;EACE,yCAAA;EACA,oCAAA;AAmtDF;;AAhtDA;EACE,yCAAA;EACA,+CAAA;AAmtDF;;AAhtDA;EACE,yCAAA;EACA,oCAAA;AAmtDF;;AAhtDA;EACE,yCAAA;EACA,+CAAA;AAmtDF;;AAhtDA;EACE,4DAAA;AAmtDF;;AAhtDA;EACE,4DAAA;AAmtDF;;AAhtDA;EACE,4DAAA;AAmtDF;;AAhtDA;EACE,4DAAA;AAmtDF;;AAhtDA;EACE,+DAAA;AAmtDF;;AAhtDA;EACE,+DAAA;AAmtDF;;AAhtDA;EACE,+DAAA;AAmtDF;;AAhtDA;EACE,+DAAA;AAmtDF;;AAhtDA;EACE,8DAAA;AAmtDF;;AAhtDA;EACE,8DAAA;AAmtDF;;AAhtDA;EACE,8DAAA;AAmtDF;;AAhtDA;EACE,8DAAA;AAmtDF;;AAhtDA;EACE,+DAAA;AAmtDF;;AAhtDA;EACE,+DAAA;AAmtDF;;AAhtDA;EACE,+DAAA;AAmtDF;;AAhtDA;EACE,+DAAA;AAmtDF;;AAhtDA;EACE,8DAAA;AAmtDF;;AAhtDA;EACE,8DAAA;AAmtDF;;AAhtDA;EACE,8DAAA;AAmtDF;;AAhtDA;EACE,8DAAA;AAmtDF;;AAhtDA;EACE,+DAAA;AAmtDF;;AAhtDA;EACE,+DAAA;AAmtDF;;AAhtDA;EACE,+DAAA;AAmtDF;;AAhtDA;EACE,+DAAA;AAmtDF;;AAhtDA;EACE,8DAAA;AAmtDF;;AAhtDA;EACE,8DAAA;AAmtDF;;AAhtDA;EACE,8DAAA;AAmtDF;;AAhtDA;EACE,8DAAA;AAmtDF;;AAhtDA;EACE,+DAAA;AAmtDF;;AAhtDA;EACE,+DAAA;AAmtDF;;AAhtDA;EACE,+DAAA;AAmtDF;;AAhtDA;EACE,+DAAA;AAmtDF;;AAhtDA;EACE,4DAAA;AAmtDF;;AAhtDA;EACE,4DAAA;AAmtDF;;AAhtDA;EACE,4DAAA;AAmtDF;;AAhtDA;EACE,4DAAA;AAmtDF;;AAhtDA;EACE,4BAAA;AAmtDF;;AAhtDA;EACE,0BAAA;AAmtDF;;AAhtDA;EACE,6BAAA;AAmtDF;;AAhtDA;EACE,6BAAA;AAmtDF;;AAhtDA;EACE,2BAAA;AAmtDF;;AAhtDA;EACE,4BAAA;AAmtDF;;AAhtDA;EACE,6BAAA;AAmtDF;;AAhtDA;EACE,0BAAA;AAmtDF;;AAhtDA;EACE,6BAAA;AAmtDF;;AAhtDA;EACE,2BAAA;AAmtDF;;AAhtDA;EACE,qBAAA;AAmtDF;;AAhtDA;EACE,sBAAA;AAmtDF;;AAhtDA;EACE,wBAAA;AAmtDF;;AAhtDA;EACE,4BAAA;AAmtDF;;AAhtDA;EACE,6BAAA;AAmtDF;;AAhtDA;EACE;IACE,qBAAA;EAmtDF;EAjtDA;IACE,sBAAA;EAmtDF;EAjtDA;IACE,wBAAA;EAmtDF;EAjtDA;IACE,4BAAA;EAmtDF;EAjtDA;IACE,6BAAA;EAmtDF;AACF;AAjtDA;EACE;IACE,qBAAA;EAmtDF;EAjtDA;IACE,sBAAA;EAmtDF;EAjtDA;IACE,wBAAA;EAmtDF;EAjtDA;IACE,4BAAA;EAmtDF;EAjtDA;IACE,6BAAA;EAmtDF;AACF;AAjtDA;EACE;IACE,qBAAA;EAmtDF;EAjtDA;IACE,sBAAA;EAmtDF;EAjtDA;IACE,wBAAA;EAmtDF;EAjtDA;IACE,4BAAA;EAmtDF;EAjtDA;IACE,6BAAA;EAmtDF;AACF;AAjtDA;EACE;IACE,qBAAA;EAmtDF;EAjtDA;IACE,sBAAA;EAmtDF;EAjtDA;IACE,wBAAA;EAmtDF;EAjtDA;IACE,4BAAA;EAmtDF;EAjtDA;IACE,6BAAA;EAmtDF;AACF;AAjtDA;EACE;IACE,qBAAA;EAmtDF;EAjtDA;IACE,sBAAA;EAmtDF;EAjtDA;IACE,wBAAA;EAmtDF;EAjtDA;IACE,4BAAA;EAmtDF;EAjtDA;IACE,6BAAA;EAmtDF;AACF;AAjtDA;EACE,oCAAA;AAmtDF;;AAhtDA;EACE,eAAA;EACA,oCAAA;AAmtDF;;AAhtDA;EACE,2CAAA;AAmtDF;;AAhtDA;EACE,2CAAA;AAmtDF;;AAhtDA;EACE,2CAAA;AAmtDF;;AAhtDA;EACE,2CAAA;AAmtDF;;AAhtDA;EACE,2CAAA;AAmtDF;;AAhtDA;EACE,2CAAA;AAmtDF;;AAhtDA;EACE,2CAAA;AAmtDF;;AAhtDA;EACE,2CAAA;AAmtDF;;AAhtDA;EACE,2CAAA;AAmtDF;;AAhtDA;EACE,wCAAA;AAmtDF;;AAhtDA;EACE,wCAAA;AAmtDF;;AAhtDA;EACE,0CAAA;AAmtDF;;AAhtDA;EACE,0CAAA;AAmtDF;;AAhtDA;EACE,4CAAA;AAmtDF;;AAhtDA;EACE,4CAAA;AAmtDF;;AAhtDA;EACE,0CAAA;AAmtDF;;AAhtDA;EACE,0CAAA;AAmtDF;;AAhtDA;EACE,uCAAA;AAmtDF;;AAhtDA;EACE,uCAAA;AAmtDF;;AAhtDA;EACE,0CAAA;AAmtDF;;AAhtDA;EACE,0CAAA;AAmtDF;;AAhtDA;EACE,yCAAA;AAmtDF;;AAhtDA;EACE,yCAAA;AAmtDF;;AAhtDA;EACE,uCAAA;AAmtDF;;AAhtDA;EACE,uCAAA;AAmtDF;;AAhtDA;EACE,oCAAA;AAmtDF;;AAhtDA;EACE,+BAAA;EACA,2CAAA;AAmtDF;;AAhtDA;EACE,mCAAA;AAmtDF;;AAhtDA;EACE,sCAAA;AAmtDF;;AAhtDA;EACE,oCAAA;AAmtDF;;AAhtDA;EACE,qCAAA;AAmtDF;;AAhtDA;EACE,+BAAA;AAmtDF;;AAhtDA;EACE,mCAAA;AAmtDF;;AAhtDA;EACE,sCAAA;AAmtDF;;AAhtDA;EACE,oCAAA;AAmtDF;;AAhtDA;EACE,qCAAA;AAmtDF;;AAhtDA;EACE,oCAAA;AAmtDF;;AAhtDA;EACE,0CAAA;AAmtDF;;AAhtDA;EACE,oCAAA;EACA,qCAAA;AAmtDF;;AAhtDA;EACE,uCAAA;EACA,wCAAA;AAmtDF;;AAhtDA;EACE,oCAAA;EACA,uCAAA;AAmtDF;;AAhtDA;EACE,qCAAA;EACA,wCAAA;AAmtDF;;AAhtDA;EACE,6BAAA;AAmtDF;;AAhtDA;EACE,SAAA;AAmtDF;;AAhtDA;EACE,UAAA;AAmtDF;;AAhtDA;EACE,cAAA;AAmtDF;;AAhtDA;EACE,cAAA;AAmtDF;;AAhtDA;EACE,cAAA;EACA,YAAA;AAmtDF;;AAhtDA;EACE,uBAAA;EACA,mBAAA;AAmtDF;;AAhtDA;EACE,sBAAA;EACA,kBAAA;AAmtDF;;AAhtDA;EACE,yBAAA;EACA,qBAAA;AAmtDF;;AAhtDA;EACE,8BAAA;EACA,mBAAA;AAmtDF;;AAhtDA;EACE;IACE,SAAA;EAmtDF;EAjtDA;IACE,UAAA;EAmtDF;EAjtDA;IACE,cAAA;EAmtDF;EAjtDA;IACE,cAAA;EAmtDF;EAjtDA;IACE,cAAA;IACA,YAAA;EAmtDF;EAjtDA;IACE,uBAAA;IACA,mBAAA;EAmtDF;EAjtDA;IACE,sBAAA;IACA,kBAAA;EAmtDF;EAjtDA;IACE,yBAAA;IACA,qBAAA;EAmtDF;EAjtDA;IACE,8BAAA;IACA,mBAAA;EAmtDF;AACF;AAjtDA;EACE;IACE,SAAA;EAmtDF;EAjtDA;IACE,UAAA;EAmtDF;EAjtDA;IACE,cAAA;EAmtDF;EAjtDA;IACE,cAAA;EAmtDF;EAjtDA;IACE,cAAA;IACA,YAAA;EAmtDF;EAjtDA;IACE,uBAAA;IACA,mBAAA;EAmtDF;EAjtDA;IACE,sBAAA;IACA,kBAAA;EAmtDF;EAjtDA;IACE,yBAAA;IACA,qBAAA;EAmtDF;EAjtDA;IACE,8BAAA;IACA,mBAAA;EAmtDF;AACF;AAjtDA;EACE;IACE,SAAA;EAmtDF;EAjtDA;IACE,UAAA;EAmtDF;EAjtDA;IACE,cAAA;EAmtDF;EAjtDA;IACE,cAAA;EAmtDF;EAjtDA;IACE,cAAA;IACA,YAAA;EAmtDF;EAjtDA;IACE,uBAAA;IACA,mBAAA;EAmtDF;EAjtDA;IACE,sBAAA;IACA,kBAAA;EAmtDF;EAjtDA;IACE,yBAAA;IACA,qBAAA;EAmtDF;EAjtDA;IACE,8BAAA;IACA,mBAAA;EAmtDF;AACF;AAjtDA;EACE;IACE,SAAA;EAmtDF;EAjtDA;IACE,UAAA;EAmtDF;EAjtDA;IACE,cAAA;EAmtDF;EAjtDA;IACE,cAAA;EAmtDF;EAjtDA;IACE,cAAA;IACA,YAAA;EAmtDF;EAjtDA;IACE,uBAAA;IACA,mBAAA;EAmtDF;EAjtDA;IACE,sBAAA;IACA,kBAAA;EAmtDF;EAjtDA;IACE,yBAAA;IACA,qBAAA;EAmtDF;EAjtDA;IACE,8BAAA;IACA,mBAAA;EAmtDF;AACF;AAjtDA;EACE;IACE,SAAA;EAmtDF;EAjtDA;IACE,UAAA;EAmtDF;EAjtDA;IACE,cAAA;EAmtDF;EAjtDA;IACE,cAAA;EAmtDF;EAjtDA;IACE,cAAA;IACA,YAAA;EAmtDF;EAjtDA;IACE,uBAAA;IACA,mBAAA;EAmtDF;EAjtDA;IACE,sBAAA;IACA,kBAAA;EAmtDF;EAjtDA;IACE,yBAAA;IACA,qBAAA;EAmtDF;EAjtDA;IACE,8BAAA;IACA,mBAAA;EAmtDF;AACF;AAjtDA;EACE,YAAA;EACA,aAAA;EACA,cAAA;AAmtDF;;AAhtDA;EACE,mCAAA;AAmtDF;;AAhtDA;EACE,mCAAA;AAmtDF;;AAhtDA;EACE,gCAAA;AAmtDF;;AAhtDA;EACE,mCAAA;AAmtDF;;AAhtDA;EACE,sCAAA;AAmtDF;;AAhtDA;EACE,2BAAA;AAmtDF;;AAjtDA;EACE,2BAAA;AAotDF;;AAltDA;EACE,2BAAA;EACA,sCAAA;AAqtDF;;AAntDA;EACE,2BAAA;EACA,sCAAA;AAstDF;;AAptDA;EACE,sCAAA;AAutDF;;AAptDA;EACE,2BAAA;AAutDF;;AArtDA;EACE,2BAAA;AAwtDF;;AAttDA;EACE,2BAAA;EACA,sCAAA;AAytDF;;AAvtDA;EACE,2BAAA;EACA,sCAAA;AA0tDF;;AAxtDA;EACE,sCAAA;AA2tDF;;AAxtDA;EACE,wCAAA;AA2tDF;;AAxtDA;EACE,2CAAA;AA2tDF;;AAxtDA;EACE,yCAAA;AA2tDF;;AAxtDA;EACE,2BAAA;AA2tDF;;AAztDA;EACE,2BAAA;AA4tDF;;AA1tDA;EACE,2BAAA;EACA,wCAAA;AA6tDF;;AA3tDA;EACE,2BAAA;EACA,wCAAA;AA8tDF;;AA5tDA;EACE,wCAAA;AA+tDF;;AA5tDA;EACE,2BAAA;AA+tDF;;AA7tDA;EACE,2BAAA;AAguDF;;AA9tDA;EACE,2BAAA;EACA,wCAAA;AAiuDF;;AA/tDA;EACE,2BAAA;EACA,wCAAA;AAkuDF;;AAhuDA;EACE,wCAAA;AAmuDF;;AAhuDA;EACE,0CAAA;AAmuDF;;AAhuDA;EACE,6CAAA;AAmuDF;;AAhuDA;EACE,2CAAA;AAmuDF;;AAhuDA;EACE,2BAAA;AAmuDF;;AAjuDA;EACE,2BAAA;AAouDF;;AAluDA;EACE,2BAAA;EACA,0CAAA;AAquDF;;AAnuDA;EACE,2BAAA;EACA,0CAAA;AAsuDF;;AApuDA;EACE,0CAAA;AAuuDF;;AApuDA;EACE,2BAAA;AAuuDF;;AAruDA;EACE,2BAAA;AAwuDF;;AAtuDA;EACE,2BAAA;EACA,0CAAA;AAyuDF;;AAvuDA;EACE,2BAAA;EACA,0CAAA;AA0uDF;;AAxuDA;EACE,0CAAA;AA2uDF;;AAxuDA;EACE,sCAAA;AA2uDF;;AAxuDA;EACE,yCAAA;AA2uDF;;AAxuDA;EACE,2BAAA;AA2uDF;;AAzuDA;EACE,2BAAA;AA4uDF;;AA1uDA;EACE,2BAAA;EACA,sCAAA;AA6uDF;;AA3uDA;EACE,2BAAA;EACA,sCAAA;AA8uDF;;AA5uDA;EACE,sCAAA;AA+uDF;;AA5uDA;EACE,2BAAA;AA+uDF;;AA7uDA;EACE,2BAAA;AAgvDF;;AA9uDA;EACE,2BAAA;EACA,sCAAA;AAivDF;;AA/uDA;EACE,2BAAA;EACA,sCAAA;AAkvDF;;AAhvDA;EACE,sCAAA;AAmvDF;;AAhvDA;EACE,wCAAA;AAmvDF;;AAhvDA;EACE,2CAAA;AAmvDF;;AAhvDA;EACE,yCAAA;AAmvDF;;AAhvDA;EACE,2BAAA;AAmvDF;;AAjvDA;EACE,2BAAA;AAovDF;;AAlvDA;EACE,2BAAA;EACA,wCAAA;AAqvDF;;AAnvDA;EACE,2BAAA;EACA,wCAAA;AAsvDF;;AApvDA;EACE,wCAAA;AAuvDF;;AApvDA;EACE,2BAAA;AAuvDF;;AArvDA;EACE,2BAAA;AAwvDF;;AAtvDA;EACE,2BAAA;EACA,wCAAA;AAyvDF;;AAvvDA;EACE,2BAAA;EACA,wCAAA;AA0vDF;;AAxvDA;EACE,wCAAA;AA2vDF;;AAxvDA;EACE,qCAAA;AA2vDF;;AAxvDA;EACE,wCAAA;AA2vDF;;AAxvDA;EACE,sCAAA;AA2vDF;;AAxvDA;EACE,2BAAA;AA2vDF;;AAzvDA;EACE,2BAAA;AA4vDF;;AA1vDA;EACE,2BAAA;EACA,qCAAA;AA6vDF;;AA3vDA;EACE,2BAAA;EACA,qCAAA;AA8vDF;;AA5vDA;EACE,qCAAA;AA+vDF;;AA5vDA;EACE,2BAAA;AA+vDF;;AA7vDA;EACE,2BAAA;AAgwDF;;AA9vDA;EACE,2BAAA;EACA,qCAAA;AAiwDF;;AA/vDA;EACE,2BAAA;EACA,qCAAA;AAkwDF;;AAhwDA;EACE,qCAAA;AAmwDF;;AAhwDA;EACE,wCAAA;AAmwDF;;AAhwDA;EACE,2CAAA;AAmwDF;;AAhwDA;EACE,yCAAA;AAmwDF;;AAhwDA;EACE,2BAAA;AAmwDF;;AAjwDA;EACE,2BAAA;AAowDF;;AAlwDA;EACE,2BAAA;EACA,wCAAA;AAqwDF;;AAnwDA;EACE,2BAAA;EACA,wCAAA;AAswDF;;AApwDA;EACE,wCAAA;AAuwDF;;AApwDA;EACE,2BAAA;AAuwDF;;AArwDA;EACE,2BAAA;AAwwDF;;AAtwDA;EACE,2BAAA;EACA,wCAAA;AAywDF;;AAvwDA;EACE,2BAAA;EACA,wCAAA;AA0wDF;;AAxwDA;EACE,wCAAA;AA2wDF;;AAxwDA;EACE,uCAAA;AA2wDF;;AAxwDA;EACE,0CAAA;AA2wDF;;AAxwDA;EACE,wCAAA;AA2wDF;;AAxwDA;EACE,2BAAA;AA2wDF;;AAzwDA;EACE,2BAAA;AA4wDF;;AA1wDA;EACE,2BAAA;EACA,uCAAA;AA6wDF;;AA3wDA;EACE,2BAAA;EACA,uCAAA;AA8wDF;;AA5wDA;EACE,uCAAA;AA+wDF;;AA5wDA;EACE,2BAAA;AA+wDF;;AA7wDA;EACE,2BAAA;AAgxDF;;AA9wDA;EACE,2BAAA;EACA,uCAAA;AAixDF;;AA/wDA;EACE,2BAAA;EACA,uCAAA;AAkxDF;;AAhxDA;EACE,uCAAA;AAmxDF;;AAhxDA;EACE,qCAAA;AAmxDF;;AAhxDA;EACE,wCAAA;AAmxDF;;AAhxDA;EACE,sCAAA;AAmxDF;;AAhxDA;EACE,2BAAA;AAmxDF;;AAjxDA;EACE,2BAAA;AAoxDF;;AAlxDA;EACE,2BAAA;EACA,qCAAA;AAqxDF;;AAnxDA;EACE,2BAAA;EACA,qCAAA;AAsxDF;;AApxDA;EACE,qCAAA;AAuxDF;;AApxDA;EACE,2BAAA;AAuxDF;;AArxDA;EACE,2BAAA;AAwxDF;;AAtxDA;EACE,2BAAA;EACA,qCAAA;AAyxDF;;AAvxDA;EACE,2BAAA;EACA,qCAAA;AA0xDF;;AAxxDA;EACE,qCAAA;AA2xDF;;AAxxDA;EACE,4CAAA;AA2xDF;;AAxxDA;EACE,2BAAA;AA2xDF;;AAzxDA;EACE,2BAAA;AA4xDF;;AA1xDA;EACE,2BAAA;EACA,sCAAA;AA6xDF;;AA3xDA;EACE,2BAAA;EACA,sCAAA;AA8xDF;;AA5xDA;EACE,sCAAA;AA+xDF;;AA5xDA;EACE,2BAAA;AA+xDF;;AA7xDA;EACE,2BAAA;AAgyDF;;AA9xDA;EACE,2BAAA;EACA,sCAAA;AAiyDF;;AA/xDA;EACE,2BAAA;EACA,sCAAA;AAkyDF;;AAhyDA;EACE,sCAAA;AAmyDF;;AAhyDA;EACE,yCAAA;AAmyDF;;AAhyDA;EACE,2BAAA;AAmyDF;;AAjyDA;EACE,2BAAA;AAoyDF;;AAlyDA;EACE,2BAAA;EACA,yCAAA;AAqyDF;;AAnyDA;EACE,2BAAA;EACA,yCAAA;AAsyDF;;AApyDA;EACE,yCAAA;AAuyDF;;AApyDA;EACE,2BAAA;AAuyDF;;AAryDA;EACE,2BAAA;AAwyDF;;AAtyDA;EACE,2BAAA;EACA,yCAAA;AAyyDF;;AAvyDA;EACE,2BAAA;EACA,yCAAA;AA0yDF;;AAxyDA;EACE,yCAAA;AA2yDF;;AAxyDA;EACE,yCAAA;AA2yDF;;AAxyDA;EACE,2BAAA;AA2yDF;;AAzyDA;EACE,2BAAA;AA4yDF;;AA1yDA;EACE,2BAAA;EACA,yCAAA;AA6yDF;;AA3yDA;EACE,2BAAA;EACA,yCAAA;AA8yDF;;AA5yDA;EACE,yCAAA;AA+yDF;;AA5yDA;EACE,2BAAA;AA+yDF;;AA7yDA;EACE,2BAAA;AAgzDF;;AA9yDA;EACE,2BAAA;EACA,yCAAA;AAizDF;;AA/yDA;EACE,2BAAA;EACA,yCAAA;AAkzDF;;AAhzDA;EACE,yCAAA;AAmzDF;;AAhzDA;EACE,yCAAA;AAmzDF;;AAhzDA;EACE,2BAAA;AAmzDF;;AAjzDA;EACE,2BAAA;AAozDF;;AAlzDA;EACE,2BAAA;EACA,yCAAA;AAqzDF;;AAnzDA;EACE,2BAAA;EACA,yCAAA;AAszDF;;AApzDA;EACE,yCAAA;AAuzDF;;AApzDA;EACE,2BAAA;AAuzDF;;AArzDA;EACE,2BAAA;AAwzDF;;AAtzDA;EACE,2BAAA;EACA,yCAAA;AAyzDF;;AAvzDA;EACE,2BAAA;EACA,yCAAA;AA0zDF;;AAxzDA;EACE,yCAAA;AA2zDF;;AAxzDA;EACE,yCAAA;AA2zDF;;AAxzDA;EACE,2BAAA;AA2zDF;;AAzzDA;EACE,2BAAA;AA4zDF;;AA1zDA;EACE,2BAAA;EACA,yCAAA;AA6zDF;;AA3zDA;EACE,2BAAA;EACA,yCAAA;AA8zDF;;AA5zDA;EACE,yCAAA;AA+zDF;;AA5zDA;EACE,2BAAA;AA+zDF;;AA7zDA;EACE,2BAAA;AAg0DF;;AA9zDA;EACE,2BAAA;EACA,yCAAA;AAi0DF;;AA/zDA;EACE,2BAAA;EACA,yCAAA;AAk0DF;;AAh0DA;EACE,yCAAA;AAm0DF;;AAh0DA;EACE,yCAAA;AAm0DF;;AAh0DA;EACE,2BAAA;AAm0DF;;AAj0DA;EACE,2BAAA;AAo0DF;;AAl0DA;EACE,2BAAA;EACA,yCAAA;AAq0DF;;AAn0DA;EACE,2BAAA;EACA,yCAAA;AAs0DF;;AAp0DA;EACE,yCAAA;AAu0DF;;AAp0DA;EACE,2BAAA;AAu0DF;;AAr0DA;EACE,2BAAA;AAw0DF;;AAt0DA;EACE,2BAAA;EACA,yCAAA;AAy0DF;;AAv0DA;EACE,2BAAA;EACA,yCAAA;AA00DF;;AAx0DA;EACE,yCAAA;AA20DF;;AAx0DA;EACE,yCAAA;AA20DF;;AAx0DA;EACE,2BAAA;AA20DF;;AAz0DA;EACE,2BAAA;AA40DF;;AA10DA;EACE,2BAAA;EACA,yCAAA;AA60DF;;AA30DA;EACE,2BAAA;EACA,yCAAA;AA80DF;;AA50DA;EACE,yCAAA;AA+0DF;;AA50DA;EACE,2BAAA;AA+0DF;;AA70DA;EACE,2BAAA;AAg1DF;;AA90DA;EACE,2BAAA;EACA,yCAAA;AAi1DF;;AA/0DA;EACE,2BAAA;EACA,yCAAA;AAk1DF;;AAh1DA;EACE,yCAAA;AAm1DF;;AAh1DA;EACE,yCAAA;AAm1DF;;AAh1DA;EACE,2BAAA;AAm1DF;;AAj1DA;EACE,2BAAA;AAo1DF;;AAl1DA;EACE,2BAAA;EACA,yCAAA;AAq1DF;;AAn1DA;EACE,2BAAA;EACA,yCAAA;AAs1DF;;AAp1DA;EACE,yCAAA;AAu1DF;;AAp1DA;EACE,2BAAA;AAu1DF;;AAr1DA;EACE,2BAAA;AAw1DF;;AAt1DA;EACE,2BAAA;EACA,yCAAA;AAy1DF;;AAv1DA;EACE,2BAAA;EACA,yCAAA;AA01DF;;AAx1DA;EACE,yCAAA;AA21DF;;AAx1DA;EACE,yCAAA;AA21DF;;AAx1DA;EACE,2BAAA;AA21DF;;AAz1DA;EACE,2BAAA;AA41DF;;AA11DA;EACE,2BAAA;EACA,yCAAA;AA61DF;;AA31DA;EACE,2BAAA;EACA,yCAAA;AA81DF;;AA51DA;EACE,yCAAA;AA+1DF;;AA51DA;EACE,2BAAA;AA+1DF;;AA71DA;EACE,2BAAA;AAg2DF;;AA91DA;EACE,2BAAA;EACA,yCAAA;AAi2DF;;AA/1DA;EACE,2BAAA;EACA,yCAAA;AAk2DF;;AAh2DA;EACE,yCAAA;AAm2DF;;AAh2DA;EACE,yCAAA;AAm2DF;;AAh2DA;EACE,2BAAA;AAm2DF;;AAj2DA;EACE,2BAAA;AAo2DF;;AAl2DA;EACE,2BAAA;EACA,yCAAA;AAq2DF;;AAn2DA;EACE,2BAAA;EACA,yCAAA;AAs2DF;;AAp2DA;EACE,yCAAA;AAu2DF;;AAp2DA;EACE,2BAAA;AAu2DF;;AAr2DA;EACE,2BAAA;AAw2DF;;AAt2DA;EACE,2BAAA;EACA,yCAAA;AAy2DF;;AAv2DA;EACE,2BAAA;EACA,yCAAA;AA02DF;;AAx2DA;EACE,yCAAA;AA22DF;;AAx2DA;EACE,2BAAA;AA22DF;;AAz2DA;EACE,2BAAA;EACA,sCAAA;AA42DF;;AA12DA;EACE,2BAAA;AA62DF;;AA32DA;EACE,2BAAA;EACA,wCAAA;AA82DF;;AA52DA;EACE,2BAAA;AA+2DF;;AA72DA;EACE,2BAAA;EACA,0CAAA;AAg3DF;;AA92DA;EACE,2BAAA;AAi3DF;;AA/2DA;EACE,2BAAA;EACA,sCAAA;AAk3DF;;AAh3DA;EACE,2BAAA;AAm3DF;;AAj3DA;EACE,2BAAA;EACA,wCAAA;AAo3DF;;AAl3DA;EACE,2BAAA;AAq3DF;;AAn3DA;EACE,2BAAA;EACA,qCAAA;AAs3DF;;AAp3DA;EACE,2BAAA;AAu3DF;;AAr3DA;EACE,2BAAA;EACA,wCAAA;AAw3DF;;AAt3DA;EACE,2BAAA;AAy3DF;;AAv3DA;EACE,2BAAA;EACA,uCAAA;AA03DF;;AAx3DA;EACE,2BAAA;AA23DF;;AAz3DA;EACE,2BAAA;EACA,qCAAA;AA43DF;;AA13DA;EACE,2BAAA;AA63DF;;AA33DA;EACE,2BAAA;EACA,sCAAA;AA83DF;;AA53DA;EACE,2BAAA;AA+3DF;;AA73DA;EACE,2BAAA;EACA,yCAAA;AAg4DF;;AA93DA;EACE,2BAAA;AAi4DF;;AA/3DA;EACE,2BAAA;EACA,yCAAA;AAk4DF;;AAh4DA;EACE,2BAAA;AAm4DF;;AAj4DA;EACE,2BAAA;EACA,yCAAA;AAo4DF;;AAl4DA;EACE,2BAAA;AAq4DF;;AAn4DA;EACE,2BAAA;EACA,yCAAA;AAs4DF;;AAp4DA;EACE,2BAAA;AAu4DF;;AAr4DA;EACE,2BAAA;EACA,yCAAA;AAw4DF;;AAt4DA;EACE,2BAAA;AAy4DF;;AAv4DA;EACE,2BAAA;EACA,yCAAA;AA04DF;;AAx4DA;EACE,2BAAA;AA24DF;;AAz4DA;EACE,2BAAA;EACA,yCAAA;AA44DF;;AA14DA;EACE,2BAAA;AA64DF;;AA34DA;EACE,2BAAA;EACA,yCAAA;AA84DF;;AA54DA;EACE,2BAAA;AA+4DF;;AA74DA;EACE,2BAAA;EACA,yCAAA;AAg5DF;;AA74DA;EACE,2BAAA;AAg5DF;;AA94DA;EACE,2BAAA;EACA,sCAAA;AAi5DF;;AA/4DA;EACE,2BAAA;AAk5DF;;AAh5DA;EACE,2BAAA;EACA,wCAAA;AAm5DF;;AAj5DA;EACE,2BAAA;AAo5DF;;AAl5DA;EACE,2BAAA;EACA,0CAAA;AAq5DF;;AAn5DA;EACE,2BAAA;AAs5DF;;AAp5DA;EACE,2BAAA;EACA,sCAAA;AAu5DF;;AAr5DA;EACE,2BAAA;AAw5DF;;AAt5DA;EACE,2BAAA;EACA,wCAAA;AAy5DF;;AAv5DA;EACE,2BAAA;AA05DF;;AAx5DA;EACE,2BAAA;EACA,qCAAA;AA25DF;;AAz5DA;EACE,2BAAA;AA45DF;;AA15DA;EACE,2BAAA;EACA,wCAAA;AA65DF;;AA35DA;EACE,2BAAA;AA85DF;;AA55DA;EACE,2BAAA;EACA,uCAAA;AA+5DF;;AA75DA;EACE,2BAAA;AAg6DF;;AA95DA;EACE,2BAAA;EACA,qCAAA;AAi6DF;;AA/5DA;EACE,2BAAA;AAk6DF;;AAh6DA;EACE,2BAAA;EACA,sCAAA;AAm6DF;;AAj6DA;EACE,2BAAA;AAo6DF;;AAl6DA;EACE,2BAAA;EACA,yCAAA;AAq6DF;;AAn6DA;EACE,2BAAA;AAs6DF;;AAp6DA;EACE,2BAAA;EACA,yCAAA;AAu6DF;;AAr6DA;EACE,2BAAA;AAw6DF;;AAt6DA;EACE,2BAAA;EACA,yCAAA;AAy6DF;;AAv6DA;EACE,2BAAA;AA06DF;;AAx6DA;EACE,2BAAA;EACA,yCAAA;AA26DF;;AAz6DA;EACE,2BAAA;AA46DF;;AA16DA;EACE,2BAAA;EACA,yCAAA;AA66DF;;AA36DA;EACE,2BAAA;AA86DF;;AA56DA;EACE,2BAAA;EACA,yCAAA;AA+6DF;;AA76DA;EACE,2BAAA;AAg7DF;;AA96DA;EACE,2BAAA;EACA,yCAAA;AAi7DF;;AA/6DA;EACE,2BAAA;AAk7DF;;AAh7DA;EACE,2BAAA;EACA,yCAAA;AAm7DF;;AAj7DA;EACE,2BAAA;AAo7DF;;AAl7DA;EACE,2BAAA;EACA,yCAAA;AAq7DF;;AAl7DA;EACE,kBAAA;AAq7DF;;AAl7DA;EACE,eAAA;AAq7DF;;AAl7DA;EACE,eAAA;AAq7DF;;AAl7DA;EACE,YAAA;AAq7DF;;AAl7DA;EACE,cAAA;EACA,eAAA;EACA,2BAAA;AAq7DF;;AAl7DA;EACE,2BAAA;AAq7DF;;AAn7DA;EACE,2BAAA;AAs7DF;;AAn7DA;EACE,qBAAA;AAs7DF;;AAn7DA;EACE,qBAAA;AAs7DF;;AAn7DA;EACE,wBAAA;AAs7DF;;AAn7DA;EACE,wBAAA;AAs7DF;;AAn7DA;EACE,uBAAA;AAs7DF;;AAn7DA;EACE,uBAAA;AAs7DF;;AAn7DA;EACE,wBAAA;AAs7DF;;AAn7DA;EACE,wBAAA;AAs7DF;;AAn7DA;EACE,uBAAA;AAs7DF;;AAn7DA;EACE,uBAAA;AAs7DF;;AAn7DA;EACE,wBAAA;AAs7DF;;AAn7DA;EACE,wBAAA;AAs7DF;;AAn7DA;EACE,uBAAA;AAs7DF;;AAn7DA;EACE,uBAAA;AAs7DF;;AAn7DA;EACE,wBAAA;AAs7DF;;AAn7DA;EACE,wBAAA;AAs7DF;;AAn7DA;EACE,qBAAA;AAs7DF;;AAn7DA;EACE,qBAAA;AAs7DF;;AAn7DA;EACE,wBAAA;EACA,2BAAA;AAs7DF;;AAn7DA;EACE,6BAAA;EACA,oCAAA;EACA,qCAAA;EACA,qDAAA;EACA,qDAAA;EACA,+DAAA;EACA,6DAAA;EACA,mCAAA;EACA,uEAAA;EACA,+CAAA;EACA,uDAAA;EACA,yDAAA;EACA,0DAAA;EACA,qCAAA;EACA,2CAAA;EACA,6CAAA;EACA,+CAAA;EACA,uDAAA;EACA,yDAAA;EACA,oCAAA;EACA,4CAAA;EACA,8CAAA;EACA,8CAAA;EACA,sDAAA;EACA,wDAAA;EACA,6DAAA;AAs7DF;;AAn7DA;EACE,yBAAA;AAs7DF;;AAn7DA;EACE,cAAA;AAs7DF;;AAn7DA;EACE,0BAAA;AAs7DF;;AAn7DA;EACE,8BAAA;AAs7DF;;AAn7DA;EACE,kBAAA;AAs7DF;;AAp7DA;EACE,kBAAA;EACA,MAAA;EACA,cAAA;AAu7DF;;AAp7DA;EACE,aAAA;EACA,mBAAA;EACA,aAAA;AAu7DF;;AAr7DA;EACE,cAAA;AAw7DF;;AAt7DA;EACE,aAAA;AAy7DF;;AAv7DA;EACE,cAAA;AA07DF;;AAx7DA;EACE,cAAA;EACA,0CAAA;AA27DF;;AAz7DA;EACE,UAAA;EACA,eAAA;EACA,MAAA;EACA,QAAA;EACA,OAAA;EACA,YAAA;EACA,yBAAA;EACA,qDAAA;EACA,YAAA;AA47DF;;AA17DA;EACE,cAAA;AA67DF;;AA37DA;EACE,aAAA;AA87DF;;AA37DA;EACE,kBAAA;AA87DF;;AA37DA;EACE;IACE,YAAA;EA87DF;EA57DA;IACE,kBAAA;IACA,cAAA;EA87DF;EA57DA;IACE,YAAA;EA87DF;EA57DA;IACE,cAAA;IACA,0CAAA;EA87DF;EA57DA;IACE,iBAAA;EA87DF;AACF;AA57DA;EACE,0BAAA;EACA,gCAAA;EACA,sCAAA;EACA,0EAAA;EACA,uCAAA;EACA,2EAAA;EACA,mDAAA;EACA,iCAAA;EACA,qEAAA;AA87DF;;AA37DA;EACE,0BAAA;EACA,gCAAA;EACA,sCAAA;EACA,qCAAA;EACA,uCAAA;EACA,sCAAA;EACA,mCAAA;EACA,iCAAA;EACA,gCAAA;AA87DF;;AA37DA;EACE,uBAAA;EACA,sBAAA;AA87DF;;AA37DA;;EAEE,YAAA;EACA,WAAA;EACA,YAAA;EACA,mCAAA;EACA,kCAAA;EACA,0BAAA;EACA,gBAAA;EACA,2CAAA;AA87DF;;AA57DA;EACE;;IAEE,0BAAA;EA+7DF;AACF;AA77DA;EACE;;IAEE,0BAAA;EA+7DF;AACF;AA57DA;EACE,aAAA;EACA,sBAAA;AA87DF;;AA57DA;;;EAGE,gCAAA;AA+7DF;;AA57DA;EACE,yBAAA;UAAA,iBAAA;AA+7DF;;AA57DA;EACE,aAAA;AA+7DF;;AA57DA;;EAEE,wCAAA;AA+7DF;;AA57DA;EACE,8CAAA;AA+7DF;;AA57DA;EACE,2BAAA;AA+7DF;;AA57DA;EACE,aAAA;AA+7DF;;AA57DA;EACE,gBAAA;AA+7DF;;AA57DA;EACE,2BAAA;AA+7DF;;AA57DA;EACE,6BAAA;EACA,2BAAA;EACA,eAAA;EACA,MAAA;EACA,SAAA;EACA,OAAA;EACA,QAAA;EACA,cAAA;EACA,aAAA;AA+7DF;;AA77DA;EACE,aAAA;EACA,uBAAA;EACA,mBAAA;AAg8DF;;AA77DA;EACE;IACE,6BAAA;IACA,8BAAA;EAg8DF;EA97DA;IACE,0BAAA;IACA,2BAAA;EAg8DF;AACF;AA97DA;EACE;IACE,eAAA;IACA,6BAAA;IACA,8BAAA;EAg8DF;EA97DA;IACE,0BAAA;IACA,2BAAA;EAg8DF;AACF;AA97DA;EACE;IACE,qBAAA;IACA,2BAAA;EAg8DF;EA97DA;;;;;IAKE,2BAAA;IACA,qBAAA;IACA,oBAAA;EAg8DF;EA97DA;;;;;;;;;;IAUE,wBAAA;EAg8DF;AACF;AA97DA;EACE,aAAA;EACA,oBAAA;AAg8DF;;AA97DA;EACE,aAAA;EACA,mBAAA;AAi8DF;;AA/7DA;EACE,oBAAA;AAk8DF;;AA/7DA;EACE,gBAAA;EACA,aAAA;EACA,oBAAA;EACA,oDAAA;EACA,gDAAA;EACA,sDAAA;AAk8DF;;AA/7DA;EACE;IACE,4BAAA;IACA,mCAAA;EAk8DF;EAh8DA;IACE,4BAAA;IACA,mCAAA;EAk8DF;EAh8DA;IACE,+JAAA;IACA,uDAAA;EAk8DF;EAh8DA;IACE,4BAAA;EAk8DF;EAh8DA;IACE,mCAAA;EAk8DF;EAh8DA;IACE,YAAA;IACA,eAAA;IACA,OAAA;IACA,QAAA;IACA,MAAA;EAk8DF;EAh8DA;IACE,kBAAA;EAk8DF;EAh8DA;IACE,sBAAA;IACA,0IAAA;EAk8DF;EAh8DA;IACE,eAAA;IACA,OAAA;IACA,QAAA;IACA,MAAA;IACA,YAAA;IACA,sDAAA;IACA,kDAAA;IACA,wDAAA;EAk8DF;EAh8DA;IACE,gBAAA;IACA,YAAA;IACA,wDAAA;IACA,oDAAA;IACA,0DAAA;EAk8DF;EAh8DA;IACE,aAAA;EAk8DF;EAh8DA;IACE,mHAAA;EAk8DF;EAh8DA;IACE,0HAAA;EAk8DF;EAh8DA;IACE,+OAAA;EAk8DF;EAh8DA;IACE,sPAAA;EAk8DF;EAh8DA;IACE,gBAAA;EAk8DF;AACF;AAh8DA;EACE;IACE,4BAAA;EAk8DF;EAh8DA;IACE,4BAAA;IACA,mCAAA;EAk8DF;EAh8DA;IACE,4BAAA;IACA,mCAAA;EAk8DF;EAh8DA;IACE,mCAAA;IACA,oBAAA;EAk8DF;EAh8DA;IACE,aAAA;EAk8DF;EAh8DA;IACE,sBAAA;IACA,0IAAA;EAk8DF;EAh8DA;IACE,YAAA;IACA,gBAAA;IACA,eAAA;IACA,OAAA;IACA,QAAA;IACA,MAAA;EAk8DF;EAh8DA;IACE,eAAA;IACA,OAAA;IACA,QAAA;IACA,MAAA;IACA,YAAA;IACA,sDAAA;IACA,kDAAA;IACA,wDAAA;EAk8DF;EAh8DA;IACE,YAAA;IACA,gBAAA;IACA,wDAAA;IACA,oDAAA;IACA,0DAAA;EAk8DF;EAh8DA;IACE,gBAAA;EAk8DF;EAh8DA;IACE,gBAAA;EAk8DF;AACF;AAh8DA;EACE,gBAAA;EACA,aAAA;EACA,oBAAA;AAk8DF;;AA/7DA;EACE;IACE,4DAAA;IACA,wDAAA;IACA,8DAAA;EAk8DF;EAh8DA;IACE,oCAAA;EAk8DF;EAh8DA;IACE,oCAAA;EAk8DF;EAh8DA;IACE,oCAAA;EAk8DF;EAh8DA;IACE,iCAAA;EAk8DF;EAh8DA;IACE,2CAAA;EAk8DF;EAh8DA;IACE,YAAA;IACA,eAAA;IACA,OAAA;IACA,QAAA;IACA,MAAA;EAk8DF;EAh8DA;IACE,kBAAA;EAk8DF;EAh8DA;IACE,eAAA;IACA,OAAA;IACA,QAAA;IACA,MAAA;IACA,YAAA;IACA,YAAA;IACA,8DAAA;IACA,0DAAA;IACA,gEAAA;EAk8DF;EAh8DA;IACE,gBAAA;IACA,YAAA;IACA,YAAA;IACA,gEAAA;IACA,4DAAA;IACA,kEAAA;EAk8DF;EAh8DA;IACE,wBAAA;EAk8DF;EAh8DA;IACE,mHAAA;EAk8DF;EAh8DA;IACE,+OAAA;EAk8DF;AACF;AAh8DA;EACE;IACE,YAAA;IACA,2CAAA;IACA,8DAAA;IACA,wDAAA;EAk8DF;EAh8DA;IACE,4DAAA;EAk8DF;EAh8DA;IACE,oCAAA;EAk8DF;EAh8DA;IACE,oCAAA;EAk8DF;EAh8DA;IACE,oCAAA;EAk8DF;AACF;AAh8DA;EACE,gBAAA;EACA,aAAA;EACA,oBAAA;AAk8DF;;AA/7DA;EACE;IACE,8DAAA;IACA,0DAAA;IACA,0DAAA;IACA,gEAAA;EAk8DF;EAh8DA;IACE,sCAAA;EAk8DF;EAh8DA;IACE,sCAAA;EAk8DF;EAh8DA;IACE,sCAAA;EAk8DF;EAh8DA;IACE,mCAAA;EAk8DF;EAh8DA;IACE,6CAAA;EAk8DF;EAh8DA;IACE,YAAA;IACA,eAAA;IACA,OAAA;IACA,QAAA;IACA,MAAA;EAk8DF;EAh8DA;IACE,gBAAA;EAk8DF;EAh8DA;IACE,gBAAA;IACA,eAAA;IACA,OAAA;IACA,QAAA;IACA,MAAA;IACA,YAAA;IACA,YAAA;IACA,gEAAA;IACA,4DAAA;IACA,kEAAA;EAk8DF;EAh8DA;IACE,gBAAA;IACA,YAAA;IACA,YAAA;IACA,kEAAA;IACA,8DAAA;IACA,oEAAA;EAk8DF;EAh8DA;IACE,wBAAA;EAk8DF;EAh8DA;IACE,mHAAA;EAk8DF;EAh8DA;IACE,+OAAA;EAk8DF;AACF;AAh8DA;EACE;IACE,YAAA;IACA,6CAAA;IACA,0DAAA;IACA,0DAAA;IACA,gEAAA;EAk8DF;EAh8DA;IACE,8DAAA;EAk8DF;EAh8DA;IACE,sCAAA;EAk8DF;EAh8DA;IACE,sCAAA;EAk8DF;EAh8DA;IACE,sCAAA;EAk8DF;AACF;AAh8DA;EACE,gBAAA;EACA,aAAA;EACA,oBAAA;AAk8DF;;AA/7DA;EACE;IACE,6DAAA;IACA,yDAAA;IACA,yDAAA;IACA,+DAAA;EAk8DF;EAh8DA;IACE,qCAAA;EAk8DF;EAh8DA;IACE,qCAAA;EAk8DF;EAh8DA;IACE,qCAAA;EAk8DF;EAh8DA;IACE,kCAAA;EAk8DF;EAh8DA;IACE,4CAAA;EAk8DF;EAh8DA;IACE,YAAA;IACA,eAAA;IACA,OAAA;IACA,QAAA;IACA,MAAA;EAk8DF;EAh8DA;IACE,gBAAA;EAk8DF;EAh8DA;IACE,gBAAA;IACA,eAAA;IACA,OAAA;IACA,QAAA;IACA,MAAA;IACA,YAAA;IACA,YAAA;IACA,+DAAA;IACA,2DAAA;IACA,iEAAA;EAk8DF;EAh8DA;IACE,gBAAA;IACA,YAAA;IACA,YAAA;IACA,iEAAA;IACA,6DAAA;IACA,mEAAA;EAk8DF;EAh8DA;IACE,wBAAA;EAk8DF;EAh8DA;IACE,mHAAA;EAk8DF;EAh8DA;IACE,+OAAA;EAk8DF;AACF;AAh8DA;EACE;IACE,YAAA;IACA,4CAAA;IACA,yDAAA;IACA,yDAAA;EAk8DF;EAh8DA;IACE,6DAAA;EAk8DF;EAh8DA;IACE,qCAAA;EAk8DF;EAh8DA;IACE,qCAAA;EAk8DF;EAh8DA;IACE,qCAAA;EAk8DF;AACF;AAh8DA;EACE,aAAA;EACA,oBAAA;EACA,qDAAA;EACA,iDAAA;EACA,iDAAA;EACA,uDAAA;AAk8DF;;AAh8DA;EACE,gBAAA;AAm8DF;;AAh8DA;EACE;IACE,6BAAA;IACA,oCAAA;EAm8DF;EAj8DA;IACE,6BAAA;EAm8DF;EAj8DA;IACE,6BAAA;EAm8DF;EAj8DA;IACE,oCAAA;EAm8DF;EAj8DA;IACE,WAAA;IACA,eAAA;IACA,OAAA;IACA,QAAA;IACA,MAAA;EAm8DF;EAj8DA;IACE,eAAA;IACA,OAAA;IACA,QAAA;IACA,MAAA;IACA,mDAAA;IACA,uDAAA;IACA,mDAAA;IACA,yDAAA;IACA,WAAA;EAm8DF;EAj8DA;IACE,gBAAA;IACA,qDAAA;IACA,yDAAA;IACA,qDAAA;IACA,2DAAA;IACA,WAAA;EAm8DF;EAj8DA;IACE,gCAAA;EAm8DF;EAj8DA;IACE,mHAAA;EAm8DF;EAj8DA;IACE,+OAAA;EAm8DF;EAj8DA;IACE,8GAAA;EAm8DF;AACF;AAj8DA;EACE;IACE,yBAAA;EAm8DF;EAj8DA;IACE,6BAAA;EAm8DF;EAj8DA;IACE,6BAAA;EAm8DF;EAj8DA;IACE,oCAAA;EAm8DF;EAj8DA;IACE,WAAA;IACA,eAAA;IACA,qFAAA;IACA,OAAA;IACA,QAAA;EAm8DF;EAj8DA;IACE,eAAA;IACA,OAAA;IACA,QAAA;IACA,qCAAA;IACA,mDAAA;IACA,uDAAA;IACA,mDAAA;IACA,yDAAA;IACA,WAAA;EAm8DF;EAj8DA;IACE,gBAAA;IACA,qDAAA;IACA,yDAAA;IACA,qDAAA;IACA,2DAAA;IACA,WAAA;EAm8DF;AACF;AAj8DA;EACE,aAAA;EACA,oBAAA;EACA,6CAAA;EACA,yCAAA;EACA,yCAAA;EACA,+CAAA;AAm8DF;;AAh8DA;EACE,2BAAA;EACA,qDAAA;EACA,iDAAA;EACA,oDAAA;EACA,mDAAA;AAm8DF;;AAh8DA;;;;;EAKE,aAAA;AAm8DF;;AAh8DA;EACE;IACE,aAAA;IACA,cAAA;IACA,kCAAA;IACA,gBAAA;IACA,iBAAA;IACA,eAAA;IACA,kBAAA;EAm8DF;EAj8DA;IACE,6BAAA;IACA,oCAAA;IACA,+BAAA;IACA,6BAAA;IACA,6BAAA;IACA,gCAAA;EAm8DF;EAj8DA;IACE,8GAAA;EAm8DF;EAj8DA;IACE,4BAAA;IACA,+BAAA;IACA,6BAAA;IACA,6BAAA;IACA,gCAAA;EAm8DF;EAj8DA;IACE,6BAAA;IACA,+BAAA;IACA,6BAAA;IACA,6BAAA;IACA,gCAAA;EAm8DF;EAj8DA;IACE,2BAAA;EAm8DF;EAj8DA;IACE,kBAAA;EAm8DF;EAj8DA;IACE,aAAA;EAm8DF;EAj8DA;IACE,eAAA;IACA,YAAA;IACA,MAAA;IACA,SAAA;IACA,OAAA;EAm8DF;EAj8DA;IACE,oBAAA;EAm8DF;EAj8DA;IACE,eAAA;IACA,2BAAA;IACA,SAAA;IACA,YAAA;IACA,UAAA;IACA,YAAA;IACA,mDAAA;IACA,sDAAA;IACA,qDAAA;IACA,gBAAA;IACA,iBAAA;IACA,eAAA;IACA,kBAAA;EAm8DF;EAj8DA;IACE,2BAAA;IACA,gBAAA;IACA,iBAAA;IACA,eAAA;IACA,kBAAA;EAm8DF;EAj8DA;IACE,yCAAA;EAm8DF;EAj8DA;IACE,2BAAA;IACA,yCAAA;EAm8DF;EAj8DA;IACE,2BAAA;IACA,yCAAA;IACA,0DAAA;EAm8DF;EAj8DA;IACE,wBAAA;EAm8DF;EAj8DA;IACE,wBAAA;EAm8DF;EAj8DA;IACE,wBAAA;EAm8DF;EAj8DA;IACE,wBAAA;EAm8DF;EAj8DA;IACE,wBAAA;EAm8DF;EAj8DA;IACE,wBAAA;EAm8DF;EAj8DA;IACE,gCAAA;EAm8DF;EAj8DA;IACE,0EAAA;EAm8DF;AACF;AAj8DA;EACE;IACE,aAAA;IACA,kCAAA;IACA,YAAA;IACA,gBAAA;IACA,iBAAA;IACA,eAAA;IACA,kBAAA;EAm8DF;EAj8DA;IACE,6BAAA;IACA,oCAAA;IACA,+BAAA;IACA,6BAAA;IACA,6BAAA;IACA,gCAAA;EAm8DF;EAj8DA;IACE,4GAAA;EAm8DF;EAj8DA;IACE,4BAAA;IACA,+BAAA;IACA,6BAAA;IACA,6BAAA;IACA,gCAAA;EAm8DF;EAj8DA;IACE,2BAAA;EAm8DF;EAj8DA;IACE,oBAAA;EAm8DF;EAj8DA;IACE,2BAAA;IACA,gBAAA;IACA,iBAAA;IACA,eAAA;IACA,kBAAA;EAm8DF;EAj8DA;IACE,yCAAA;EAm8DF;EAj8DA;IACE,2BAAA;IACA,yCAAA;IACA,kEAAA;EAm8DF;EAj8DA;IACE,2BAAA;IACA,yCAAA;IACA,0DAAA;EAm8DF;EAj8DA;IACE,wBAAA;EAm8DF;EAj8DA;IACE,wBAAA;EAm8DF;EAj8DA;IACE,wBAAA;EAm8DF;EAj8DA;IACE,wBAAA;EAm8DF;AACF;AAj8DA;EACE,gBAAA;EACA,kBAAA;EACA,cAAA;EACA,6DAAA;EACA,yDAAA;EACA,4DAAA;EACA,2DAAA;AAm8DF;;AAh8DA;;;;EAIE,aAAA;AAm8DF;;AAh8DA;EACE;IACE,UAAA;IACA,gBAAA;IACA,iBAAA;IACA,eAAA;IACA,kBAAA;EAm8DF;EAj8DA;IACE,4CAAA;EAm8DF;EAj8DA;IACE,qCAAA;IACA,uCAAA;IACA,qCAAA;IACA,qCAAA;IACA,wCAAA;EAm8DF;EAj8DA;IACE,oCAAA;IACA,uCAAA;IACA,qCAAA;IACA,qCAAA;IACA,wCAAA;EAm8DF;EAj8DA;IACE,mCAAA;EAm8DF;EAj8DA;IACE,0CAAA;EAm8DF;EAj8DA;IACE,gBAAA;IACA,iDAAA;IACA,kEAAA;EAm8DF;EAj8DA;IACE,gBAAA;IACA,gBAAA;IACA,iBAAA;IACA,eAAA;IACA,kBAAA;EAm8DF;EAj8DA;IACE,iDAAA;EAm8DF;EAj8DA;IACE,gBAAA;IACA,iDAAA;IACA,mEAAA;EAm8DF;EAj8DA;IACE,gCAAA;EAm8DF;EAj8DA;IACE,wEAAA;EAm8DF;EAj8DA;IACE,wBAAA;EAm8DF;EAj8DA;IACE,wBAAA;EAm8DF;EAj8DA;IACE,wBAAA;EAm8DF;EAj8DA;IACE,wBAAA;EAm8DF;AACF;AAj8DA;EACE;IACE,UAAA;IACA,gBAAA;IACA,iBAAA;IACA,eAAA;IACA,kBAAA;EAm8DF;EAj8DA;IACE,4CAAA;EAm8DF;EAj8DA;IACE,qCAAA;IACA,uCAAA;IACA,qCAAA;IACA,qCAAA;IACA,wCAAA;EAm8DF;EAj8DA;IACE,oCAAA;IACA,uCAAA;IACA,qCAAA;IACA,qCAAA;IACA,wCAAA;EAm8DF;EAj8DA;IACE,mCAAA;EAm8DF;EAj8DA;IACE,0CAAA;EAm8DF;EAj8DA;IACE,gBAAA;IACA,iDAAA;IACA,kEAAA;EAm8DF;EAj8DA;IACE,gBAAA;IACA,gBAAA;IACA,iBAAA;IACA,eAAA;IACA,kBAAA;EAm8DF;EAj8DA;IACE,iDAAA;EAm8DF;EAj8DA;IACE,gBAAA;IACA,iDAAA;IACA,0EAAA;EAm8DF;EAj8DA;IACE,wBAAA;EAm8DF;EAj8DA;IACE,wBAAA;EAm8DF;EAj8DA;IACE,wBAAA;EAm8DF;EAj8DA;IACE,wBAAA;EAm8DF;AACF;AAj8DA;EACE,6CAAA;EACA,kBAAA;EACA,cAAA;EACA,+DAAA;EACA,2DAAA;EACA,8DAAA;EACA,6DAAA;AAm8DF;;AAh8DA;;;;EAIE,aAAA;AAm8DF;;AAh8DA;EACE;IACE,gBAAA;IACA,iBAAA;IACA,eAAA;IACA,kBAAA;EAm8DF;EAj8DA;IACE;;;;;;;KAAA;EA08DF;EAj8DA;IACE;;;;;;;KAAA;IAQA,yCAAA;IACA,uCAAA;IACA,uCAAA;IACA,0CAAA;EAm8DF;EAj8DA;IACE,sCAAA;IACA,yCAAA;IACA,uCAAA;IACA,uCAAA;IACA,0CAAA;EAm8DF;EAj8DA;IACE;;;;;;;KAAA;IAQA,qCAAA;EAm8DF;EAj8DA;IACE,4CAAA;EAm8DF;EAj8DA;IACE,6CAAA;IACA,mDAAA;IACA,oEAAA;EAm8DF;EAj8DA;IACE,6CAAA;IACA,gBAAA;IACA,iBAAA;IACA,eAAA;IACA,kBAAA;EAm8DF;EAj8DA;IACE,mDAAA;EAm8DF;EAj8DA;IACE,6CAAA;IACA,mDAAA;IACA,qEAAA;EAm8DF;EAj8DA;IACE,gCAAA;EAm8DF;EAj8DA;IACE,wEAAA;EAm8DF;EAj8DA;IACE,wBAAA;EAm8DF;EAj8DA;IACE,wBAAA;EAm8DF;EAj8DA;IACE,wBAAA;EAm8DF;EAj8DA;IACE,wBAAA;EAm8DF;AACF;AAj8DA;EACE;IACE,gBAAA;IACA,iBAAA;IACA,eAAA;IACA,kBAAA;EAm8DF;EAj8DA;IACE;;;;;;;KAAA;EA08DF;EAj8DA;IACE;;;;;;;KAAA;IAQA,yCAAA;IACA,uCAAA;IACA,uCAAA;IACA,0CAAA;EAm8DF;EAj8DA;IACE,sCAAA;IACA,yCAAA;IACA,uCAAA;IACA,uCAAA;IACA,0CAAA;EAm8DF;EAj8DA;IACE;;;;;;;KAAA;IAQA,qCAAA;EAm8DF;EAj8DA;IACE,4CAAA;EAm8DF;EAj8DA;IACE,6CAAA;IACA,mDAAA;IACA,oEAAA;EAm8DF;EAj8DA;IACE,6CAAA;IACA,0EAAA;IACA,sEAAA;IACA,yEAAA;IACA,wEAAA;EAm8DF;EAj8DA;IACE,mDAAA;EAm8DF;EAj8DA;IACE,6CAAA;IACA,mDAAA;IACA,4EAAA;EAm8DF;EAj8DA;IACE,wBAAA;EAm8DF;EAj8DA;IACE,wBAAA;EAm8DF;EAj8DA;IACE,wBAAA;EAm8DF;EAj8DA;IACE,wBAAA;EAm8DF;AACF;AAj8DA;EACE,gBAAA;EACA,2DAAA;EACA,uDAAA;EACA,0DAAA;EACA,yDAAA;AAm8DF;;AAh8DA;;;;;EAKE,aAAA;AAm8DF;;AAh8DA;EACE;IACE,aAAA;IACA,cAAA;IACA,wCAAA;IACA,gBAAA;IACA,iBAAA;IACA,eAAA;IACA,kBAAA;EAm8DF;EAj8DA;IACE,mCAAA;IACA,0CAAA;IACA,qCAAA;IACA,mCAAA;IACA,mCAAA;IACA,sCAAA;EAm8DF;EAj8DA;IACE,kCAAA;IACA,qCAAA;IACA,mCAAA;IACA,mCAAA;IACA,sCAAA;EAm8DF;EAj8DA;IACE,mCAAA;IACA,qCAAA;IACA,mCAAA;IACA,mCAAA;IACA,sCAAA;EAm8DF;EAj8DA;IACE,0CAAA;IACA,iCAAA;EAm8DF;EAj8DA;IACE,kBAAA;EAm8DF;EAj8DA;IACE,aAAA;EAm8DF;EAj8DA;IACE,YAAA;IACA,eAAA;IACA,mHAAA;IACA,MAAA;IACA,SAAA;EAm8DF;EAj8DA;IACE,eAAA;IACA,mHAAA;IACA,MAAA;IACA,SAAA;IACA,gBAAA;IACA,YAAA;IACA,gBAAA;IACA,iBAAA;IACA,eAAA;IACA,kBAAA;EAm8DF;EAj8DA;IACE,gBAAA;IACA,gBAAA;IACA,iBAAA;IACA,eAAA;IACA,kBAAA;EAm8DF;EAj8DA;IACE,+CAAA;EAm8DF;EAj8DA;IACE,gBAAA;IACA,+CAAA;IACA,iEAAA;EAm8DF;EAj8DA;IACE,gBAAA;IACA,+CAAA;IACA,8IAAA;EAm8DF;EAj8DA;IACE,gCAAA;EAm8DF;EAj8DA;IACE,wEAAA;EAm8DF;EAj8DA;IACE,wBAAA;EAm8DF;EAj8DA;IACE,wBAAA;EAm8DF;EAj8DA;IACE,wBAAA;EAm8DF;EAj8DA;IACE,wBAAA;EAm8DF;EAj8DA;IACE,wBAAA;EAm8DF;EAj8DA;IACE,wBAAA;EAm8DF;AACF;AAj8DA;EACE;IACE,aAAA;IACA,wCAAA;IACA,gBAAA;IACA,iBAAA;IACA,eAAA;IACA,kBAAA;EAm8DF;EAj8DA;IACE,qCAAA;IACA,mCAAA;IACA,mCAAA;IACA,sCAAA;EAm8DF;EAj8DA;IACE,kCAAA;IACA,qCAAA;IACA,mCAAA;IACA,mCAAA;IACA,sCAAA;EAm8DF;EAj8DA;IACE,0CAAA;IACA,iCAAA;EAm8DF;EAj8DA;IACE,gBAAA;IACA,sEAAA;IACA,kEAAA;IACA,qEAAA;IACA,oEAAA;IACA,gBAAA;IACA,iBAAA;IACA,eAAA;IACA,kBAAA;EAm8DF;EAj8DA;IACE,+CAAA;EAm8DF;EAj8DA;IACE,gBAAA;IACA,+CAAA;IACA,wEAAA;EAm8DF;EAj8DA;IACE,gBAAA;IACA,+CAAA;IACA,gEAAA;EAm8DF;EAj8DA;IACE,wBAAA;EAm8DF;EAj8DA;IACE,wBAAA;EAm8DF;EAj8DA;IACE,wBAAA;EAm8DF;EAj8DA;IACE,wBAAA;EAm8DF;AACF;AAj8DA;EACE,gBAAA;EACA,mDAAA;EACA,+CAAA;EACA,iDAAA;EACA,mDAAA;AAm8DF;;AAh8DA;;;;;EAKE,aAAA;AAm8DF;;AAh8DA;EACE;IACE,aAAA;IACA,cAAA;IACA,gCAAA;IACA,gBAAA;IACA,iBAAA;IACA,eAAA;IACA,kBAAA;EAm8DF;EAj8DA;IACE,2BAAA;IACA,kCAAA;IACA,6BAAA;IACA,2BAAA;IACA,2BAAA;IACA,8BAAA;EAm8DF;EAj8DA;IACE,mGAAA;EAm8DF;EAj8DA;IACE,0BAAA;IACA,6BAAA;IACA,2BAAA;IACA,2BAAA;IACA,8BAAA;EAm8DF;EAj8DA;IACE,2BAAA;IACA,6BAAA;IACA,2BAAA;IACA,2BAAA;IACA,8BAAA;EAm8DF;EAj8DA;IACE,yBAAA;EAm8DF;EAj8DA;IACE,kBAAA;EAm8DF;EAj8DA;IACE,aAAA;EAm8DF;EAj8DA;IACE,eAAA;IACA,YAAA;IACA,MAAA;IACA,SAAA;IACA,QAAA;EAm8DF;EAj8DA;IACE,oBAAA;EAm8DF;EAj8DA;IACE,eAAA;IACA,gBAAA;IACA,iDAAA;IACA,gDAAA;IACA,mDAAA;IACA,SAAA;IACA,YAAA;IACA,UAAA;IACA,YAAA;IACA,gBAAA;IACA,iBAAA;IACA,eAAA;IACA,kBAAA;EAm8DF;EAj8DA;IACE,gBAAA;IACA,gBAAA;IACA,iBAAA;IACA,eAAA;IACA,kBAAA;EAm8DF;EAj8DA;IACE,uCAAA;EAm8DF;EAj8DA;IACE,gBAAA;IACA,uCAAA;IACA,yDAAA;EAm8DF;EAj8DA;IACE,gBAAA;IACA,uCAAA;IACA,yDAAA;EAm8DF;EAj8DA;IACE,wBAAA;EAm8DF;EAj8DA;IACE,wBAAA;EAm8DF;EAj8DA;IACE,wBAAA;EAm8DF;EAj8DA;IACE,wBAAA;EAm8DF;EAj8DA;IACE,wBAAA;EAm8DF;EAj8DA;IACE,wBAAA;EAm8DF;EAj8DA;IACE,gCAAA;EAm8DF;EAj8DA;IACE,0EAAA;EAm8DF;AACF;AAj8DA;EACE;IACE,aAAA;IACA,gCAAA;IACA,YAAA;IACA,gBAAA;IACA,iBAAA;IACA,eAAA;IACA,kBAAA;EAm8DF;EAj8DA;IACE,2BAAA;IACA,kCAAA;IACA,6BAAA;IACA,2BAAA;IACA,2BAAA;IACA,8BAAA;EAm8DF;EAj8DA;IACE,0BAAA;IACA,6BAAA;IACA,2BAAA;IACA,2BAAA;IACA,8BAAA;EAm8DF;EAj8DA;IACE,yBAAA;EAm8DF;EAj8DA;IACE,oBAAA;EAm8DF;EAj8DA;IACE,gBAAA;IACA,gBAAA;IACA,iBAAA;IACA,eAAA;IACA,kBAAA;EAm8DF;EAj8DA;IACE,uCAAA;EAm8DF;EAj8DA;IACE,gBAAA;IACA,uCAAA;IACA,gEAAA;EAm8DF;EAj8DA;IACE,gBAAA;IACA,uCAAA;IACA,yDAAA;EAm8DF;EAj8DA;IACE,wBAAA;EAm8DF;EAj8DA;IACE,wBAAA;EAm8DF;EAj8DA;IACE,wBAAA;EAm8DF;EAj8DA;IACE,wBAAA;EAm8DF;AACF;AAj8DA;EACE,aAAA;AAm8DF;;AAh8DA;EACE;IACE,yDAAA;EAm8DF;EAj8DA;IACE,8CAAA;EAm8DF;EAj8DA;IACE,uCAAA;EAm8DF;EAj8DA;IACE,wCAAA;EAm8DF;EAj8DA;IACE,0FAAA;EAm8DF;EAj8DA;IACE,4EAAA;EAm8DF;EAj8DA;IACE,0HAAA;EAm8DF;EAj8DA;IACE,sPAAA;EAm8DF;EAj8DA;IACE,qHAAA;EAm8DF;EAj8DA;IACE,0CAAA;EAm8DF;AACF;AAj8DA;EACE;IACE,yDAAA;EAm8DF;EAj8DA;IACE,8CAAA;EAm8DF;EAj8DA;IACE,uCAAA;EAm8DF;EAj8DA;IACE,0FAAA;EAm8DF;EAj8DA;IACE,0CAAA;EAm8DF;AACF;AAj8DA;EACE,aAAA;AAm8DF;;AAh8DA;EACE;IACE,4BAAA;EAm8DF;EAj8DA;IACE,0HAAA;EAm8DF;EAj8DA;IACE,sPAAA;EAm8DF;EAj8DA;IACE,qHAAA;EAm8DF;AACF;AAj8DA;EACE;IACE,eAAA;IACA,gBAAA;EAm8DF;AACF;AAj8DA;EACE;IACE,iBAAA;IACA,oBAAA;IACA,eAAA;IACA,gBAAA;EAm8DF;AACF;AAj8DA;EACE;IACE,eAAA;IACA,iBAAA;IACA,oBAAA;IACA,eAAA;IACA,gBAAA;EAm8DF;AACF;AAj8DA;EACE,2CAAA;EACA,aAAA;EACA,mBAAA;EACA,+CAAA;EACA,2CAAA;AAm8DF;;AAh8DA;EACE;IACE,4BAAA;EAm8DF;EAj8DA;IACE,mCAAA;EAm8DF;EAj8DA;IACE,YAAA;IACA,2CAAA;IACA,eAAA;IACA,OAAA;IACA,QAAA;IACA,SAAA;EAm8DF;EAj8DA;IACE,mHAAA;EAm8DF;EAj8DA;IACE,+OAAA;EAm8DF;EAj8DA;IACE,8GAAA;EAm8DF;AACF;AAj8DA;EACE;IACE,4BAAA;EAm8DF;EAj8DA;IACE,mCAAA;EAm8DF;EAj8DA;IACE,YAAA;IACA,2CAAA;IACA,eAAA;IACA,OAAA;IACA,QAAA;IACA,SAAA;EAm8DF;AACF;AAj8DA;EACE,eAAA;EACA,YAAA;EACA,YAAA;EACA,WAAA;AAm8DF;;AAh8DA;EACE;IACE,YAAA;IACA,WAAA;EAm8DF;AACF;AAj8DA;EACE,uDAAA;EACA,8CAAA;EACA,kFAAA;EACA,kDAAA;EACA,wCAAA;EACA,qEAAA;EACA,+CAAA;EACA,+CAAA;EACA,qDAAA;EACA,kDAAA;EACA,yDAAA;EACA,gEAAA;AAm8DF;;AAh8DA;EACE,uDAAA;EACA,8CAAA;EACA,iDAAA;EACA,kDAAA;EACA,wCAAA;EACA,uCAAA;EACA,+CAAA;EACA,+CAAA;EACA,qDAAA;EACA,kDAAA;EACA,yDAAA;EACA,gEAAA;AAm8DF;;AAh8DA;EACE;IACE,uEAAA;IACA,2EAAA;EAm8DF;EAj8DA;IACE,mCAAA;EAm8DF;EAj8DA;IACE,0BAAA;EAm8DF;EAj8DA;IACE,mCAAA;EAm8DF;EAj8DA;IACE,mCAAA;IACA,aAAA;IACA,mBAAA;IACA,8BAAA;IACA,kBAAA;IACA,cAAA;EAm8DF;EAj8DA;IACE,qBAAA;EAm8DF;AACF;AAj8DA;EACE;IACE,aAAA;EAm8DF;AACF;AAj8DA;EACE,aAAA;AAm8DF;;AAh8DA;EACE,aAAA;AAm8DF;;AAh8DA;EACE;IACE,aAAA;EAm8DF;EAj8DA;IACE,qBAAA;EAm8DF;EAj8DA;IACE,yCAAA;EAm8DF;EAj8DA;;IAEE,UAAA;IACA,wCAAA;EAm8DF;EAj8DA;IACE,SAAA;IACA,gBAAA;IACA,uCAAA;EAm8DF;EAj8DA;IACE,0BAAA;IACA,2BAAA;EAm8DF;EAj8DA;IACE,QAAA;IACA,aAAA;EAm8DF;EAj8DA;IACE,WAAA;IACA,cAAA;EAm8DF;EAj8DA;IACE,aAAA;EAm8DF;EAj8DA;IACE,qBAAA;EAm8DF;EAj8DA;IACE,yCAAA;EAm8DF;EAj8DA;;IAEE,UAAA;IACA,wCAAA;EAm8DF;EAj8DA;IACE,SAAA;IACA,gBAAA;IACA,uCAAA;EAm8DF;EAj8DA;IACE,0BAAA;IACA,2BAAA;EAm8DF;EAj8DA;IACE,QAAA;IACA,aAAA;EAm8DF;EAj8DA;IACE,WAAA;IACA,cAAA;EAm8DF;AACF;AAj8DA;EACE,yBAAA;EACA,0BAAA;AAm8DF;;AAj8DA;EACE,oCAAA;AAo8DF;;AAl8DA;EACE,yBAAA;AAq8DF;;AAn8DA;EACE,6BAAA;AAs8DF;;AAp8DA;EACE,oCAAA;AAu8DF;;AAr8DA;EACE,yBAAA;AAw8DF;;AAt8DA;EACE,6BAAA;AAy8DF;;AAv8DA;EACE,iCAAA;AA08DF;;AAx8DA;EACE,cAAA;EACA,wCAAA;AA28DF;;AAz8DA;;EAEE,cAAA;AA48DF;;AA18DA;EACE,cAAA;AA68DF;;AA38DA;EACE,cAAA;EACA,mDAAA;AA88DF;;AA58DA;EACE,yBAAA;AA+8DF;;AA78DA;EACE,cAAA;AAg9DF;;AA98DA;EACE,cAAA;AAi9DF;;AA/8DA;;;EAGE,cAAA;AAk9DF;;AAh9DA;EACE,yBAAA;AAm9DF;;AAj9DA;EAOE,qDAAA;EACA,mBAAA;EACA,sBAAA;EACA,qBAAA;EACA,8BAAA;EACA,6BAAA;EACA,yBAAA;EAEA,qDAAA;EACA,iBAAA;AAo9DF;;AAl9DA;EACE,2BAAA;EACA,gCAAA;AAq9DF;;AAn9DA;EACE,gCAAA;AAs9DF;;AAp9DA;;;;;EAKE,gCAAA;AAu9DF;;AAr9DA;EACE,2CAAA;AAw9DF;;AAt9DA;EAOE,qDAAA;EACA,mBAAA;EACA,sBAAA;EACA,qBAAA;EACA,8BAAA;EACA,6BAAA;EACA,2CAAA;EAEA,qDAAA;EACA,iBAAA;AAy9DF;;AAv9DA;EACE,2BAAA;EACA,gCAAA;AA09DF;;AAx9DA;EACE,gCAAA;AA29DF;;AAz9DA;;;EAGE,gCAAA;AA49DF;;AA19DA;EACE,2CAAA;AA69DF;;AA39DA;EAOE,qDAAA;EACA,mBAAA;EACA,sBAAA;EACA,qBAAA;EACA,8BAAA;EACA,6BAAA;EACA,2CAAA;EAEA,qDAAA;EACA,iBAAA;AA89DF;;AA59DA;EACE,2BAAA;EACA,gCAAA;AA+9DF;;AA79DA;EACE,gCAAA;AAg+DF;;AA99DA;;;EAGE,gCAAA;AAi+DF;;AA/9DA;EACE,2CAAA;AAk+DF;;AAh+DA;EAOE,qDAAA;EACA,mBAAA;EACA,sBAAA;EACA,qBAAA;EACA,8BAAA;EACA,6BAAA;EACA,2CAAA;EAEA,qDAAA;EACA,iBAAA;AAm+DF;;AAj+DA;EACE,2BAAA;EACA,yBAAA;EACA,gCAAA;AAo+DF;;AAl+DA;EACE,gCAAA;AAq+DF;;AAn+DA;;;EAGE,gCAAA;AAs+DF;;AAp+DA;EACE,2CAAA;AAu+DF;;AAr+DA;EAOE,qDAAA;EACA,mBAAA;EACA,sBAAA;EACA,qBAAA;EACA,8BAAA;EACA,6BAAA;EACA,2CAAA;EAEA,qDAAA;EACA,iBAAA;AAw+DF;;AAr+DA;EACE;IACE,yBAAA;EAw+DF;AACF;AAt+DA;EACE,sDAAA;EACA,0BAAA;AAw+DF;;AAt+DA;EACE,wEAAA;AAy+DF;;AAv+DA;EACE,6DAAA;AA0+DF;;AAx+DA;EACE,6BAAA;AA2+DF;;AAz+DA;EACE,8EAAA;AA4+DF;;AA1+DA;EACE,mEAAA;AA6+DF;;AA3+DA;EACE,6BAAA;AA8+DF;;AA5+DA;EACE,oEAAA;AA++DF;;AA7+DA;EACE,gBAAA;AAg/DF;;AA9+DA;EACE,gEAAA;AAi/DF;;AA/+DA;EACE,yBAAA;AAk/DF;;AAh/DA;EACE,yBAAA;AAm/DF;;AAj/DA;;;EAGE,yBAAA;AAo/DF;;AAl/DA;EACE,oCAAA;AAq/DF;;AAn/DA;EAOE,oDAAA;EACA,mBAAA;EACA,sBAAA;EACA,qBAAA;EACA,8BAAA;EACA,6BAAA;EACA,oCAAA;EAEA,oDAAA;EACA,iBAAA;AAs/DF;;AAp/DA;EACE,2BAAA;EACA,yBAAA;AAu/DF;;AAr/DA;EACE,yBAAA;AAw/DF;;AAt/DA;;;;;EAKE,yBAAA;AAy/DF;;AAv/DA;EACE,oCAAA;AA0/DF;;AAx/DA;EAOE,oDAAA;EACA,mBAAA;EACA,sBAAA;EACA,qBAAA;EACA,8BAAA;EACA,6BAAA;EACA,oCAAA;EAEA,oDAAA;EACA,iBAAA;AA2/DF;;AAz/DA;EACE,2BAAA;EACA,yBAAA;AA4/DF;;AA1/DA;EACE,yBAAA;AA6/DF;;AA3/DA;;;EAGE,yBAAA;AA8/DF;;AA5/DA;EACE,oCAAA;AA+/DF;;AA7/DA;EAOE,oDAAA;EACA,mBAAA;EACA,sBAAA;EACA,qBAAA;EACA,8BAAA;EACA,6BAAA;EACA,oCAAA;EAEA,oDAAA;EACA,iBAAA;AAggEF;;AA9/DA;EACE,2BAAA;EACA,yBAAA;AAigEF;;AA//DA;EACE,yBAAA;AAkgEF;;AAhgEA;;;EAGE,yBAAA;AAmgEF;;AAjgEA;EACE,oCAAA;AAogEF;;AAlgEA;EAOE,oDAAA;EACA,mBAAA;EACA,sBAAA;EACA,qBAAA;EACA,8BAAA;EACA,6BAAA;EACA,oCAAA;EAEA,oDAAA;EACA,iBAAA;AAqgEF;;AAngEA;EACE,2BAAA;EACA,uEAAA;EACA,wBAAA;AAsgEF;;AApgEA;EACE,wBAAA;AAugEF;;AArgEA;;;EAGE,wBAAA;AAwgEF;;AAtgEA;EACE,mCAAA;AAygEF;;AAvgEA;EAOE,oDAAA;EACA,mBAAA;EACA,sBAAA;EACA,qBAAA;EACA,8BAAA;EACA,6BAAA;EACA,mCAAA;EAEA,oDAAA;EACA,iBAAA;AA0gEF;;AAvgEA;EACE,wCAAA;EACA,gBAAA;EACA,qEAAA;AA0gEF;;AAxgEA;EACE,qEAAA;AA2gEF;;AAxgEA;EACE,yBAAA;AA2gEF;;AAzgEA;EACE,yBAAA;AA4gEF;;AA1gEA;;;EAGE,yBAAA;AA6gEF;;AA3gEA;EACE,oCAAA;AA8gEF;;AA5gEA;EAOE,oDAAA;EACA,mBAAA;EACA,sBAAA;EACA,qBAAA;EACA,8BAAA;EACA,6BAAA;EACA,oCAAA;EAEA,oDAAA;EACA,iBAAA;AA+gEF;;AA7gEA;EACE,2BAAA;EACA,qDAAA;EACA,wBAAA;AAghEF;;AA9gEA;EACE,wBAAA;AAihEF;;AA/gEA;;;;;EAKE,wBAAA;AAkhEF;;AAhhEA;EACE,mCAAA;AAmhEF;;AAjhEA;EAOE,oDAAA;EACA,mBAAA;EACA,sBAAA;EACA,qBAAA;EACA,8BAAA;EACA,6BAAA;EACA,mCAAA;EAEA,oDAAA;EACA,iBAAA;AAohEF;;AAlhEA;EACE,2BAAA;EACA,wBAAA;AAqhEF;;AAnhEA;EACE,wBAAA;AAshEF;;AAphEA;;;EAGE,wBAAA;AAuhEF;;AArhEA;EACE,mCAAA;AAwhEF;;AAthEA;EAOE,oDAAA;EACA,mBAAA;EACA,sBAAA;EACA,qBAAA;EACA,8BAAA;EACA,6BAAA;EACA,mCAAA;EAEA,oDAAA;EACA,iBAAA;AAyhEF;;AAvhEA;EACE,2BAAA;EACA,qDAAA;EACA,wBAAA;AA0hEF;;AAxhEA;EACE,wBAAA;AA2hEF;;AAzhEA;;;EAGE,wBAAA;AA4hEF;;AA1hEA;EACE,mCAAA;AA6hEF;;AA3hEA;EAOE,oDAAA;EACA,mBAAA;EACA,sBAAA;EACA,qBAAA;EACA,8BAAA;EACA,6BAAA;EACA,mCAAA;EAEA,oDAAA;EACA,iBAAA;AA8hEF;;AA5hEA;EACE,2BAAA;EACA,qDAAA;EACA,wBAAA;AA+hEF;;AA7hEA;EACE,wBAAA;AAgiEF;;AA9hEA;;;EAGE,wBAAA;AAiiEF;;AA/hEA;EACE,mCAAA;AAkiEF;;AAhiEA;EAOE,oDAAA;EACA,mBAAA;EACA,sBAAA;EACA,qBAAA;EACA,8BAAA;EACA,6BAAA;EACA,mCAAA;EAEA,oDAAA;EACA,iBAAA;AAmiEF;;AAjiEA;EACE,iEAAA;EACA,gEAAA;AAoiEF;;AAliEA;EACE,oCAAA;AAqiEF;;AAniEA;EACE,oCAAA;AAsiEF;;AAniEA;EACE;IACE,oBAAA;EAsiEF;EApiEA;IACE,qBAAA;IACA,wBAAA;IACA,gBAAA;EAsiEF;EApiEA;IACE,2BAAA;IACA,qEAAA;IACA,wBAAA;EAsiEF;EApiEA;IACE,wBAAA;EAsiEF;EApiEA;;;IAGE,wBAAA;EAsiEF;EApiEA;IACE,mCAAA;EAsiEF;EApiEA;IAOE,oDAAA;IACA,mBAAA;IACA,sBAAA;IACA,qBAAA;IACA,8BAAA;IACA,6BAAA;IACA,mCAAA;IAEA,oDAAA;IACA,iBAAA;EAsiEF;AACF;AApiEA;EACE;IACE,wBAAA;EAsiEF;AACF;AApiEA;EACE,yBAAA;EACA,2BAAA;AAsiEF;;AApiEA;EACE,cAAA;AAuiEF;;AAriEA;;EAEE,cAAA;AAwiEF;;AAtiEA;EACE,cAAA;AAyiEF;;AAviEA;EACE,cAAA;EACA,mDAAA;AA0iEF;;AAxiEA;;;;;;;;;EASE,wBAAA;AA2iEF;;AAziEA;EACE,wBAAA;AA4iEF;;AA1iEA;EACE;IACE,cAAA;EA6iEF;EA3iEA;IACE,cAAA;EA6iEF;EA3iEA;;;IAGE,cAAA;EA6iEF;EA3iEA;IACE,yBAAA;EA6iEF;EA3iEA;IAOE,qDAAA;IACA,mBAAA;IACA,sBAAA;IACA,qBAAA;IACA,8BAAA;IACA,6BAAA;IACA,yBAAA;IAEA,qDAAA;IACA,iBAAA;EA6iEF;EA3iEA;IACE,2BAAA;IACA,yBAAA;IACA,gCAAA;EA6iEF;EA3iEA;IACE,gCAAA;EA6iEF;EA3iEA;;;;;IAKE,gCAAA;EA6iEF;EA3iEA;IACE,2CAAA;EA6iEF;EA3iEA;IAOE,qDAAA;IACA,mBAAA;IACA,sBAAA;IACA,qBAAA;IACA,8BAAA;IACA,6BAAA;IACA,2CAAA;IAEA,qDAAA;IACA,iBAAA;EA6iEF;EA3iEA;IACE,2BAAA;IACA,gCAAA;EA6iEF;EA3iEA;IACE,gCAAA;EA6iEF;EA3iEA;;;IAGE,gCAAA;EA6iEF;EA3iEA;IACE,2CAAA;EA6iEF;EA3iEA;IAOE,qDAAA;IACA,mBAAA;IACA,sBAAA;IACA,qBAAA;IACA,8BAAA;IACA,6BAAA;IACA,2CAAA;IAEA,qDAAA;IACA,iBAAA;EA6iEF;EA3iEA;IACE,2BAAA;IACA,yBAAA;IACA,gCAAA;EA6iEF;EA3iEA;IACE,gCAAA;EA6iEF;EA3iEA;;;IAGE,gCAAA;EA6iEF;EA3iEA;IACE,2CAAA;EA6iEF;EA3iEA;IAOE,qDAAA;IACA,mBAAA;IACA,sBAAA;IACA,qBAAA;IACA,8BAAA;IACA,6BAAA;IACA,2CAAA;IAEA,qDAAA;IACA,iBAAA;EA6iEF;EA3iEA;IACE,2BAAA;IACA,yBAAA;IACA,gCAAA;EA6iEF;EA3iEA;IACE,gCAAA;EA6iEF;EA3iEA;;;IAGE,gCAAA;EA6iEF;EA3iEA;IACE,2CAAA;EA6iEF;EA3iEA;IAOE,qDAAA;IACA,mBAAA;IACA,sBAAA;IACA,qBAAA;IACA,8BAAA;IACA,6BAAA;IACA,2CAAA;IAEA,qDAAA;IACA,iBAAA;EA6iEF;EAxiEA;IACE,2BAAA;IACA,8EAAA;IACA,wBAAA;EA4iEF;EA1iEA;IACE,wBAAA;EA4iEF;EA1iEA;;;IAGE,wBAAA;EA4iEF;EA1iEA;IACE,mCAAA;EA4iEF;EA1iEA;IAOE,oDAAA;IACA,mBAAA;IACA,sBAAA;IACA,qBAAA;IACA,8BAAA;IACA,6BAAA;IACA,mCAAA;IAEA,oDAAA;IACA,iBAAA;EA4iEF;EA1iEA;IACE,2BAAA;IACA,8EAAA;IACA,wBAAA;EA4iEF;EA1iEA;IACE,wBAAA;EA4iEF;EA1iEA;;;IAGE,wBAAA;EA4iEF;EA1iEA;IACE,mCAAA;EA4iEF;EA1iEA;IAOE,oDAAA;IACA,mBAAA;IACA,sBAAA;IACA,qBAAA;IACA,8BAAA;IACA,6BAAA;IACA,mCAAA;IAEA,oDAAA;IACA,iBAAA;EA4iEF;EAviEA;IACE,6BAAA;IACA,gBAAA;IACA,oEAAA;EA2iEF;AA5EF;AA59DA;EACE;IACE,6BAAA;IACA,gBAAA;IACA,oEAAA;EA2iEF;AACF;AAziEA;EACE;IACE,cAAA;EA2iEF;AACF;AAziEA;EACE;IACE,cAAA;EA2iEF;AACF;AAziEA;EACE,8CAAA;AA2iEF;;AAxiEA;EACE;IACE,YAAA;IACA,6BAAA;IACA,aAAA;IACA,gBAAA;IACA,gBAAA;EA2iEF;AACF;AAziEA;EACE;IACE,YAAA;IACA,6BAAA;IACA,aAAA;IACA,gBAAA;IACA,gBAAA;EA2iEF;AACF;AAziEA;EACE;IACE,yBAAA;EA2iEF;AACF","sourcesContent":["@charset \"UTF-8\";\n\n@import './color-base.scss';\n/*!\n * Bootstrap  v5.3.0-alpha1 (https://getbootstrap.com/)\n * Copyright 2011-2022 The Bootstrap Authors\n * Licensed under MIT (https://github.com/twbs/bootstrap/blob/main/LICENSE)\n */\n:root\n {\n  --bs-blue: #0d6efd;\n  --bs-indigo: #6610f2;\n  --bs-purple: #6f42c1;\n  --bs-pink: #d63384;\n  --bs-red: #dc3545;\n  --bs-orange: #fd7e14;\n  --bs-yellow: #ffc107;\n  --bs-green: #198754;\n  --bs-teal: #20c997;\n  --bs-cyan: #0dcaf0;\n  --bs-black: #000000;\n  --bs-white: #ffffff;\n  --bs-gray: #7E8299;\n  --bs-gray-dark: #3F4254;\n  --bs-gray-100: #F9F9F9;\n  --bs-gray-200: #F4F4F4;\n  --bs-gray-300: #E1E3EA;\n  --bs-gray-400: #B5B5C3;\n  --bs-gray-500: #A1A5B7;\n  --bs-gray-600: #7E8299;\n  --bs-gray-700: #5E6278;\n  --bs-gray-800: #3F4254;\n  --bs-gray-900: #181C32;\n  --bs-light: #F9F9F9;\n  --bs-primary: #009ef7;\n  --bs-secondary: #E1E3EA;\n  --bs-success: #50cd89;\n  --bs-info: #7239ea;\n  --bs-warning: #ffc700;\n  --bs-danger: #f1416c;\n  --bs-dark: #181C32;\n  --bs-light-rgb: 249, 249, 249;\n  --bs-primary-rgb: 0, 158, 247;\n  --bs-secondary-rgb: 225, 227, 234;\n  --bs-success-rgb: 80, 205, 137;\n  --bs-info-rgb: 114, 57, 234;\n  --bs-warning-rgb: 255, 199, 0;\n  --bs-danger-rgb: 241, 65, 108;\n  --bs-dark-rgb: 24, 28, 50;\n  --bs-primary-text: #0a58ca;\n  --bs-secondary-text: #7E8299;\n  --bs-success-text: #146c43;\n  --bs-info-text: #087990;\n  --bs-warning-text: #997404;\n  --bs-danger-text: #b02a37;\n  --bs-light-text: #7E8299;\n  --bs-dark-text: #5E6278;\n  --bs-primary-bg-subtle: #cfe2ff;\n  --bs-secondary-bg-subtle: #F9F9F9;\n  --bs-success-bg-subtle: #d1e7dd;\n  --bs-info-bg-subtle: #cff4fc;\n  --bs-warning-bg-subtle: #fff3cd;\n  --bs-danger-bg-subtle: #f8d7da;\n  --bs-light-bg-subtle: #fcfcfc;\n  --bs-dark-bg-subtle: #B5B5C3;\n  --bs-primary-border-subtle: #9ec5fe;\n  --bs-secondary-border-subtle: #F4F4F4;\n  --bs-success-border-subtle: #a3cfbb;\n  --bs-info-border-subtle: #9eeaf9;\n  --bs-warning-border-subtle: #ffe69c;\n  --bs-danger-border-subtle: #f1aeb5;\n  --bs-light-border-subtle: #F4F4F4;\n  --bs-dark-border-subtle: #A1A5B7;\n  --bs-white-rgb: 255, 255, 255;\n  --bs-black-rgb: 0, 0, 0;\n  --bs-body-color-rgb: 24, 28, 50;\n  --bs-body-bg-rgb: 255, 255, 255;\n  --bs-font-sans-serif: Inter, Helvetica, \"sans-serif\";\n  --bs-font-monospace: SFMono-Regular, Menlo, Monaco, Consolas, \"Liberation Mono\", \"Courier New\", monospace;\n  --bs-gradient: linear-gradient(180deg, rgba(255, 255, 255, 0.15), rgba(255, 255, 255, 0));\n  --bs-body-font-family: var(--bs-font-sans-serif);\n  --bs-body-font-size: 1rem;\n  --bs-body-font-weight: 400;\n  --bs-body-line-height: 1.5;\n  --bs-body-color: #181C32;\n  --bs-emphasis-color: #000000;\n  --bs-emphasis-color-rgb: 0, 0, 0;\n  --bs-secondary-color: rgba(24, 28, 50, 0.75);\n  --bs-secondary-color-rgb: 24, 28, 50;\n  --bs-secondary-bg: #F4F4F4;\n  --bs-secondary-bg-rgb: 244, 244, 244;\n  --bs-tertiary-color: rgba(24, 28, 50, 0.5);\n  --bs-tertiary-color-rgb: 24, 28, 50;\n  --bs-tertiary-bg: #F9F9F9;\n  --bs-tertiary-bg-rgb: 249, 249, 249;\n  --bs-body-bg: #ffffff;\n  --bs-body-bg-rgb: 255, 255, 255;\n  --bs-heading-color: #181C32;\n  --bs-link-color: #009ef7;\n  --bs-link-color-rgb: 0, 158, 247;\n  --bs-link-decoration: none;\n  --bs-link-hover-color: #0095e8;\n  --bs-link-hover-color-rgb: 0, 149, 232;\n  --bs-link-hover-decoration: none;\n  --bs-code-color: #b93993;\n  --bs-highlight-bg: #fff3cd;\n  --bs-border-width: 1px;\n  --bs-border-style: solid;\n  --bs-border-color: #F4F4F4;\n  --bs-border-color-translucent: rgba(0, 0, 0, 0.175);\n  --bs-border-radius: 0.475rem;\n  --bs-border-radius-sm: 0.425rem;\n  --bs-border-radius-lg: 0.625rem;\n  --bs-border-radius-xl: 1rem;\n  --bs-border-radius-2xl: 2rem;\n  --bs-border-radius-pill: 50rem;\n  --bs-box-shadow: 0 0.5rem 1.5rem 0.5rem rgba(0, 0, 0, 0.075);\n  --bs-box-shadow-sm: 0 0.1rem 1rem 0.25rem rgba(0, 0, 0, 0.05);\n  --bs-box-shadow-lg: 0 1rem 2rem 1rem rgba(0, 0, 0, 0.1);\n  --bs-box-shadow-inset: inset 0 1px 2px rgba(0, 0, 0, 0.075);\n  --bs-emphasis-color: #000000;\n  --bs-form-control-bg: var(--bs-body-bg);\n  --bs-form-control-disabled-bg: var(--bs-secondary-bg);\n  --bs-highlight-bg: #fff3cd;\n  --bs-breakpoint-xs: 0;\n  --bs-breakpoint-sm: 576px;\n  --bs-breakpoint-md: 768px;\n  --bs-breakpoint-lg: 992px;\n  --bs-breakpoint-xl: 1200px;\n  --bs-breakpoint-xxl: 1400px;\n  --bs-body-color: #FFFFFF;\n  --bs-body-color-rgb: 255, 255, 255;\n  --bs-body-bg: #1e1e2d;\n  --bs-body-bg-rgb: 30, 30, 45;\n  --bs-emphasis-color: #F9F9F9;\n  --bs-emphasis-color-rgb: 249, 249, 249;\n  --bs-secondary-color: rgba(255, 255, 255, 0.75);\n  --bs-secondary-color-rgb: 255, 255, 255;\n  --bs-secondary-bg: #3F4254;\n  --bs-secondary-bg-rgb: 63, 66, 84;\n  --bs-tertiary-color: rgba(255, 255, 255, 0.5);\n  --bs-tertiary-color-rgb: 255, 255, 255;\n  --bs-tertiary-bg: #2c2f43;\n  --bs-tertiary-bg-rgb: 44, 47, 67;\n  --bs-emphasis-color: #ffffff;\n  --bs-primary-text: #6ea8fe;\n  --bs-secondary-text: #E1E3EA;\n  --bs-success-text: #75b798;\n  --bs-info-text: #6edff6;\n  --bs-warning-text: #ffda6a;\n  --bs-danger-text: #ea868f;\n  --bs-light-text: #F9F9F9;\n  --bs-dark-text: #E1E3EA;\n  --bs-primary-bg-subtle: #031633;\n  --bs-secondary-bg-subtle: #181C32;\n  --bs-success-bg-subtle: #051b11;\n  --bs-info-bg-subtle: #032830;\n  --bs-warning-bg-subtle: #332701;\n  --bs-danger-bg-subtle: #2c0b0e;\n  --bs-light-bg-subtle: #3F4254;\n  --bs-dark-bg-subtle: #20212a;\n  --bs-primary-border-subtle: #084298;\n  --bs-secondary-border-subtle: #5E6278;\n  --bs-success-border-subtle: #0f5132;\n  --bs-info-border-subtle: #055160;\n  --bs-warning-border-subtle: #664d03;\n  --bs-danger-border-subtle: #842029;\n  --bs-light-border-subtle: #5E6278;\n  --bs-dark-border-subtle: #3F4254;\n  --bs-heading-color: #FFFFFF;\n  --bs-link-color: #009ef7;\n  --bs-link-hover-color: #9ec5fe;\n  --bs-link-color-rgb: 0, 158, 247;\n  --bs-link-hover-color-rgb: 158, 197, 254;\n  --bs-code-color: #b93993;\n  --bs-border-color: #2B2B40;\n  --bs-border-color-translucent: rgba(255, 255, 255, 0.15);\n\n  --bs-xs:0;\n  --bs-sm:576px;\n  --bs-md:768px;\n  --bs-lg:992px;\n  --bs-xl:1200px;\n  --bs-xxl:1400px;\n  --bs-scrollbar-size: 5px;\n  --bs-scrollbar-overlay-size: 19px;\n  --bs-scrollbar-overlay-space: 7px;\n  --bs-white-bg-rgb: 255, 255, 255;\n  --bs-black-bg-rgb: 0, 0, 0;\n\n  --bs-text-muted: #565674;\n  --bs-gray-100: #1b1b29;\n  --bs-gray-100-rgb: 27, 27, 41;\n  --bs-gray-200: #2B2B40;\n  --bs-gray-200-rgb: 43, 43, 64;\n  --bs-gray-300: #323248;\n  --bs-gray-300-rgb: 50, 50, 72;\n  --bs-gray-400: #474761;\n  --bs-gray-400-rgb: 71, 71, 97;\n  --bs-gray-500: #565674;\n  --bs-gray-500-rgb: 86, 86, 116;\n  --bs-gray-600: #6D6D80;\n  --bs-gray-600-rgb: 109, 109, 128;\n  --bs-gray-700: #92929F;\n  --bs-gray-700-rgb: 146, 146, 159;\n  --bs-gray-800: #CDCDDE;\n  --bs-gray-800-rgb: 205, 205, 222;\n  --bs-gray-900: #FFFFFF;\n  --bs-gray-900-rgb: 255, 255, 255;\n  --bs-white: #ffffff;\n  --bs-light: #2B2B40;\n  --bs-primary: #009ef7;\n  --bs-success: #50cd89;\n  --bs-info: #7239ea;\n  --bs-warning: #ffc700;\n  --bs-danger: #f1416c;\n  --bs-dark: #FFFFFF;\n  --bs-secondary: #323248;\n  --bs-primary-active: #0095e8;\n  --bs-secondary-active: #474761;\n  --bs-light-active: #323248;\n  --bs-success-active: #47be7d;\n  --bs-info-active: #5014d0;\n  --bs-warning-active: #f1bc00;\n  --bs-danger-active: #d9214e;\n  --bs-dark-active: white;\n  --bs-primary-light: #82a6c9; //YOU BUBBLE\n  --bs-success-light: #1c3238;\n  --bs-info-light: #4870a0; //BOT BUBBLE\n  --bs-warning-light: #392f28;\n  --bs-danger-light: #3a2434;\n  --bs-dark-light: #2B2B40;\n  --bs-secondary-light: #1b1b29;\n  --bs-primary-inverse: #ffffff;\n  --bs-secondary-inverse: #92929F;\n  --bs-light-inverse: #7E8299;\n  --bs-success-inverse: #ffffff;\n  --bs-info-inverse: #ffffff;\n  --bs-warning-inverse: #ffffff;\n  --bs-danger-inverse: #ffffff;\n  --bs-dark-inverse: #1b1b29;\n  --bs-white-rgb: 255, 255, 255;\n  --bs-light-rgb: 43, 43, 64;\n  --bs-primary-rgb: 0, 158, 247;\n  --bs-success-rgb: 80, 205, 137;\n  --bs-info-rgb: 114, 57, 234;\n  --bs-warning-rgb: 255, 199, 0;\n  --bs-danger-rgb: 241, 65, 108;\n  --bs-dark-rgb: 255, 255, 255;\n  --bs-secondary-rgb: 50, 50, 72;\n  --bs-text-white: #ffffff;\n  --bs-text-primary: #009ef7;\n  --bs-text-secondary: #323248;\n  --bs-text-light: #2B2B40;\n  --bs-text-success: #50cd89;\n  --bs-text-info: #7239ea;\n  --bs-text-warning: #ffc700;\n  --bs-text-danger: #f1416c;\n  --bs-text-dark: #FFFFFF;\n  --bs-text-muted: #565674;\n  --bs-text-gray-100: #1b1b29;\n  --bs-text-gray-200: #2B2B40;\n  --bs-text-gray-300: #323248;\n  --bs-text-gray-400: #474761;\n  --bs-text-gray-500: #565674;\n  --bs-text-gray-600: #6D6D80;\n  --bs-text-gray-700: #92929F;\n  --bs-text-gray-800: #CDCDDE;\n  --bs-text-gray-900: #FFFFFF;\n  --bs-border-color: #2B2B40;\n  --bs-border-dashed-color: #323248;\n  --bs-component-active-color: #ffffff;\n  --bs-component-active-bg: #009ef7;\n  --bs-component-hover-color: #009ef7;\n  --bs-component-hover-bg: #1b1b29;\n  --bs-component-checked-color: #ffffff;\n  --bs-component-checked-bg: #009ef7;\n  --bs-box-shadow-xs: 0 0.1rem 0.75rem 0.25rem rgba(0, 0, 0, 0.05);\n  --bs-box-shadow-sm: 0 0.1rem 1rem 0.25rem rgba(0, 0, 0, 0.05);\n  --bs-box-shadow: 0 0.5rem 1.5rem 0.5rem rgba(0, 0, 0, 0.075);\n  --bs-box-shadow-lg: 0 1rem 2rem 1rem rgba(0, 0, 0, 0.1);\n  --bs-input-color: var(--bs-gray-700);\n  --bs-input-bg: var(--bs-body-bg);\n  --bs-input-solid-color: var(--bs-gray-700);\n  --bs-input-solid-bg: var(--bs-gray-100);\n  --bs-input-solid-bg-focus: var(--bs-gray-200);\n  --bs-input-solid-placeholder-color: var(--bs-gray-500);\n  --bs-tooltip-box-shadow: 0px 0px 30px rgba(0, 0, 0, 0.15);\n  --bs-card-box-shadow: ;\n  --bs-table-striped-bg: rgba(27, 27, 41, 0.75);\n  --bs-table-loading-message-box-shadow: 0px 0px 30px rgba(0, 0, 0, 0.3);\n  --bs-dropdown-bg: #1e1e2d;\n  --bs-dropdown-box-shadow: 0px 0px 30px rgba(0, 0, 0, 0.3);\n  --bs-code-bg: #2B2B40;\n  --bs-code-box-shadow: 0px 3px 9px rgba(0, 0, 0, 0.08);\n  --bs-code-color: #b93993;\n  --bs-symbol-label-color: #CDCDDE;\n  --bs-symbol-label-bg: #1b1b29;\n  --bs-symbol-border-color: rgba(255, 255, 255, 0.5);\n  --bs-bullet-bg-color: #474761;\n  --bs-scrolltop-opacity: 0;\n  --bs-scrolltop-opacity-on: 0.3;\n  --bs-scrolltop-opacity-hover: 1;\n  --bs-scrolltop-box-shadow: 0 0.5rem 1.5rem 0.5rem rgba(0, 0, 0, 0.075);\n  --bs-scrolltop-bg-color: #009ef7;\n  --bs-scrolltop-bg-color-hover: #009ef7;\n  --bs-scrolltop-icon-color: #ffffff;\n  --bs-scrolltop-icon-color-hover: #ffffff;\n  --bs-drawer-box-shadow: 0px 0px 30px rgba(0, 0, 0, 0.1);\n  --bs-drawer-bg-color: #1e1e2d;\n  --bs-drawer-overlay-bg-color: rgba(0, 0, 0, 0.4);\n  --bs-menu-dropdown-box-shadow: 0px 0px 30px rgba(0, 0, 0, 0.3);\n  --bs-menu-dropdown-bg-color: #1e1e2d;\n  --bs-menu-heading-color: #565674;\n  --bs-menu-link-color-hover: #009ef7;\n  --bs-menu-link-color-show: #009ef7;\n  --bs-menu-link-color-here: #009ef7;\n  --bs-menu-link-color-active: #009ef7;\n  --bs-menu-link-bg-color-hover: #1b1b29;\n  --bs-menu-link-bg-color-show: #1b1b29;\n  --bs-menu-link-bg-color-here: #1b1b29;\n  --bs-menu-link-bg-color-active: #1b1b29;\n  --bs-scrollbar-color: #2B2B40;\n  --bs-scrollbar-hover-color: #27273a;\n  --bs-overlay-bg: rgba(255, 255, 255, 0.05);\n  --bs-blockui-overlay-bg: rgba(255, 255, 255, 0.05);\n  --bs-rating-color-default: #474761;\n  --bs-rating-color-active: #FFAD0F;\n  --bs-ribbon-label-box-shadow: 0px -1px 5px 0px rgba(255, 255, 255, 0.1);\n  --bs-ribbon-label-bg: #009ef7;\n  --bs-ribbon-label-border-color: #005d91;\n  --bs-ribbon-clip-bg: #F9F9F9;\n  --bs-engage-btn-bg: #2B2B40;\n  --bs-engage-btn-box-shadow: 0px 0px 30px rgba(0, 0, 0, 0.3);\n  --bs-engage-btn-border-color: #2B2B40;\n  --bs-engage-btn-color: #CDCDDE;\n  --bs-engage-btn-icon-color: #6D6D80;\n  --bs-engage-btn-color-active: #CDCDDE;\n}\n\n*,\n*::before,\n*::after {\n  box-sizing: border-box;\n}\n\nbody {\n  margin: 0;\n  font-family: var(--bs-body-font-family);\n  font-size: var(--bs-body-font-size);\n  font-weight: var(--bs-body-font-weight);\n  line-height: var(--bs-body-line-height);\n  color: var(--bs-body-color);\n  text-align: var(--bs-body-text-align);\n  background-color: var(--bs-body-bg);\n  -webkit-text-size-adjust: 100%;\n  -webkit-tap-highlight-color: rgba(0, 0, 0, 0);\n}\n\nhr {\n  margin: 1rem 0;\n  color: inherit;\n  border: 0;\n  border-top: var(--bs-border-width) solid;\n  opacity: 0.25;\n}\n\nh6, .h6, h5, .h5, h4, .h4, h3, .h3, h2, .h2, h1, .h1 {\n  margin-top: 0;\n  margin-bottom: 0.5rem;\n  font-weight: 600;\n  line-height: 1.2;\n  color: var(--bs-heading-color, inherit);\n}\n\nh1, .h1 {\n  font-size: calc(1.3rem + 0.6vw);\n}\n@media (min-width: 1200px) {\n  h1, .h1 {\n    font-size: 1.75rem;\n  }\n}\n\nh2, .h2 {\n  font-size: calc(1.275rem + 0.3vw);\n}\n@media (min-width: 1200px) {\n  h2, .h2 {\n    font-size: 1.5rem;\n  }\n}\n\nh3, .h3 {\n  font-size: calc(1.26rem + 0.12vw);\n}\n@media (min-width: 1200px) {\n  h3, .h3 {\n    font-size: 1.35rem;\n  }\n}\n\nh4, .h4 {\n  font-size: 1.25rem;\n}\n\nh5, .h5 {\n  font-size: 1.15rem;\n}\n\nh6, .h6 {\n  font-size: 1.075rem;\n}\n\np {\n  margin-top: 0;\n  margin-bottom: 1rem;\n}\n\nabbr[title] {\n  text-decoration: underline dotted;\n  cursor: help;\n  text-decoration-skip-ink: none;\n}\n\naddress {\n  margin-bottom: 1rem;\n  font-style: normal;\n  line-height: inherit;\n}\n\nol,\nul {\n  padding-left: 2rem;\n}\n\nol,\nul,\ndl {\n  margin-top: 0;\n  margin-bottom: 1rem;\n}\n\nol ol,\nul ul,\nol ul,\nul ol {\n  margin-bottom: 0;\n}\n\ndt {\n  font-weight: 600;\n}\n\ndd {\n  margin-bottom: 0.5rem;\n  margin-left: 0;\n}\n\nblockquote {\n  margin: 0 0 1rem;\n}\n\nb,\nstrong {\n  font-weight: 700;\n}\n\nsmall, .small {\n  font-size: 0.875em;\n}\n\nmark, .mark {\n  padding: 0.1875em;\n  background-color: var(--bs-highlight-bg);\n}\n\nsub,\nsup {\n  position: relative;\n  font-size: 0.75em;\n  line-height: 0;\n  vertical-align: baseline;\n}\n\nsub {\n  bottom: -0.25em;\n}\n\nsup {\n  top: -0.5em;\n}\n\na {\n  color: rgba(var(--bs-link-color-rgb), var(--bs-link-opacity, 1));\n  text-decoration: none;\n}\na:hover {\n  --bs-link-color-rgb: var(--bs-link-hover-color-rgb);\n  text-decoration: none;\n}\n\na:not([href]):not([class]), a:not([href]):not([class]):hover {\n  color: inherit;\n  text-decoration: none;\n}\n\npre,\ncode,\nkbd,\nsamp {\n  font-family: var(--bs-font-monospace);\n  font-size: 1em;\n}\n\npre {\n  display: block;\n  margin-top: 0;\n  margin-bottom: 1rem;\n  overflow: auto;\n  font-size: 0.875em;\n}\npre code {\n  font-size: inherit;\n  color: inherit;\n  word-break: normal;\n}\n\ncode {\n  font-size: 0.875em;\n  color: var(--bs-code-color);\n  word-wrap: break-word;\n}\na > code {\n  color: inherit;\n}\n\nkbd {\n  padding: 0.1875rem 0.375rem;\n  font-size: 0.875em;\n  color: var(--bs-body-bg);\n  background-color: var(--bs-body-color);\n  border-radius: 0.425rem;\n}\nkbd kbd {\n  padding: 0;\n  font-size: 1em;\n}\n\nfigure {\n  margin: 0 0 1rem;\n}\n\nimg,\nsvg {\n  vertical-align: middle;\n}\n\ntable {\n  caption-side: bottom;\n  border-collapse: collapse;\n}\n\ncaption {\n  padding-top: 0.75rem;\n  padding-bottom: 0.75rem;\n  color: #A1A5B7;\n  text-align: left;\n}\n\nth {\n  text-align: inherit;\n  text-align: -webkit-match-parent;\n}\n\nthead,\ntbody,\ntfoot,\ntr,\ntd,\nth {\n  border-color: inherit;\n  border-style: solid;\n  border-width: 0;\n}\n\nlabel {\n  display: inline-block;\n}\n\nbutton {\n  border-radius: 0;\n}\n\nbutton:focus:not(:focus-visible) {\n  outline: 0;\n}\n\ninput,\nbutton,\nselect,\noptgroup,\ntextarea {\n  margin: 0;\n  font-family: inherit;\n  font-size: inherit;\n  line-height: inherit;\n}\n\nbutton,\nselect {\n  text-transform: none;\n}\n\n[role=button] {\n  cursor: pointer;\n}\n\nselect {\n  word-wrap: normal;\n}\nselect:disabled {\n  opacity: 1;\n}\n\n[list]:not([type=date]):not([type=datetime-local]):not([type=month]):not([type=week]):not([type=time])::-webkit-calendar-picker-indicator {\n  display: none !important;\n}\n\nbutton,\n[type=button],\n[type=reset],\n[type=submit] {\n  -webkit-appearance: button;\n}\nbutton:not(:disabled),\n[type=button]:not(:disabled),\n[type=reset]:not(:disabled),\n[type=submit]:not(:disabled) {\n  cursor: pointer;\n}\n\n::-moz-focus-inner {\n  padding: 0;\n  border-style: none;\n}\n\ntextarea {\n  resize: vertical;\n}\n\nfieldset {\n  min-width: 0;\n  padding: 0;\n  margin: 0;\n  border: 0;\n}\n\nlegend {\n  float: left;\n  width: 100%;\n  padding: 0;\n  margin-bottom: 0.5rem;\n  font-size: calc(1.275rem + 0.3vw);\n  line-height: inherit;\n}\n@media (min-width: 1200px) {\n  legend {\n    font-size: 1.5rem;\n  }\n}\nlegend + * {\n  clear: left;\n}\n\n::-webkit-datetime-edit-fields-wrapper,\n::-webkit-datetime-edit-text,\n::-webkit-datetime-edit-minute,\n::-webkit-datetime-edit-hour-field,\n::-webkit-datetime-edit-day-field,\n::-webkit-datetime-edit-month-field,\n::-webkit-datetime-edit-year-field {\n  padding: 0;\n}\n\n::-webkit-inner-spin-button {\n  height: auto;\n}\n\n[type=search] {\n  outline-offset: -2px;\n  -webkit-appearance: textfield;\n}\n\n/* rtl:raw:\n[type=\"tel\"],\n[type=\"url\"],\n[type=\"email\"],\n[type=\"number\"] {\n  direction: ltr;\n}\n*/\n::-webkit-search-decoration {\n  -webkit-appearance: none;\n}\n\n::-webkit-color-swatch-wrapper {\n  padding: 0;\n}\n\n::file-selector-button {\n  font: inherit;\n  -webkit-appearance: button;\n}\n\noutput {\n  display: inline-block;\n}\n\niframe {\n  border: 0;\n}\n\nsummary {\n  display: list-item;\n  cursor: pointer;\n}\n\nprogress {\n  vertical-align: baseline;\n}\n\n[hidden] {\n  display: none !important;\n}\n\n.lead {\n  font-size: 1.25rem;\n  font-weight: 300;\n}\n\n.display-1 {\n  font-size: calc(1.625rem + 4.5vw);\n  font-weight: 700;\n  line-height: 1.2;\n}\n@media (min-width: 1200px) {\n  .display-1 {\n    font-size: 5rem;\n  }\n}\n\n.display-2 {\n  font-size: calc(1.575rem + 3.9vw);\n  font-weight: 700;\n  line-height: 1.2;\n}\n@media (min-width: 1200px) {\n  .display-2 {\n    font-size: 4.5rem;\n  }\n}\n\n.display-3 {\n  font-size: calc(1.525rem + 3.3vw);\n  font-weight: 700;\n  line-height: 1.2;\n}\n@media (min-width: 1200px) {\n  .display-3 {\n    font-size: 4rem;\n  }\n}\n\n.display-4 {\n  font-size: calc(1.475rem + 2.7vw);\n  font-weight: 700;\n  line-height: 1.2;\n}\n@media (min-width: 1200px) {\n  .display-4 {\n    font-size: 3.5rem;\n  }\n}\n\n.display-5 {\n  font-size: calc(1.425rem + 2.1vw);\n  font-weight: 700;\n  line-height: 1.2;\n}\n@media (min-width: 1200px) {\n  .display-5 {\n    font-size: 3rem;\n  }\n}\n\n.display-6 {\n  font-size: calc(1.375rem + 1.5vw);\n  font-weight: 700;\n  line-height: 1.2;\n}\n@media (min-width: 1200px) {\n  .display-6 {\n    font-size: 2.5rem;\n  }\n}\n\n.list-unstyled {\n  padding-left: 0;\n  list-style: none;\n}\n\n.list-inline {\n  padding-left: 0;\n  list-style: none;\n}\n\n.list-inline-item {\n  display: inline-block;\n}\n.list-inline-item:not(:last-child) {\n  margin-right: 0.5rem;\n}\n\n.initialism {\n  font-size: 0.875em;\n  text-transform: uppercase;\n}\n\n.blockquote {\n  margin-bottom: 1rem;\n  font-size: 1.25rem;\n}\n.blockquote > :last-child {\n  margin-bottom: 0;\n}\n\n.blockquote-footer {\n  margin-top: -1rem;\n  margin-bottom: 1rem;\n  font-size: 0.875em;\n  color: #7E8299;\n}\n.blockquote-footer::before {\n  content: \"— \";\n}\n\n.img-fluid {\n  max-width: 100%;\n  height: auto;\n}\n\n.img-thumbnail {\n  padding: 0.25rem;\n  background-color: var(--bs-body-bg);\n  border: var(--bs-border-width) solid var(--bs-border-color);\n  border-radius: var(--bs-border-radius);\n  box-shadow: var(--bs-box-shadow-sm);\n  max-width: 100%;\n  height: auto;\n}\n\n.figure {\n  display: inline-block;\n}\n\n.figure-img {\n  margin-bottom: 0.5rem;\n  line-height: 1;\n}\n\n.figure-caption {\n  font-size: 0.875em;\n  color: var(--bs-gray-600);\n}\n\n.container,\n.container-fluid,\n.container-xxl,\n.container-xl,\n.container-lg,\n.container-md,\n.container-sm {\n  --bs-gutter-x: 1.5rem;\n  --bs-gutter-y: 0;\n  width: 100%;\n  padding-right: calc(var(--bs-gutter-x) * 0.5);\n  padding-left: calc(var(--bs-gutter-x) * 0.5);\n  margin-right: auto;\n  margin-left: auto;\n}\n\n@media (min-width: 576px) {\n  .container-sm, .container {\n    max-width: 540px;\n  }\n}\n@media (min-width: 768px) {\n  .container-md, .container-sm, .container {\n    max-width: 720px;\n  }\n}\n@media (min-width: 992px) {\n  .container-lg, .container-md, .container-sm, .container {\n    max-width: 960px;\n  }\n}\n@media (min-width: 1200px) {\n  .container-xl, .container-lg, .container-md, .container-sm, .container {\n    max-width: 1140px;\n  }\n}\n@media (min-width: 1400px) {\n  .container-xxl, .container-xl, .container-lg, .container-md, .container-sm, .container {\n    max-width: 1320px;\n  }\n}\n.row {\n  --bs-gutter-x: 1.5rem;\n  --bs-gutter-y: 0;\n  display: flex;\n  flex-wrap: wrap;\n  margin-top: calc(-1 * var(--bs-gutter-y));\n  margin-right: calc(-0.5 * var(--bs-gutter-x));\n  margin-left: calc(-0.5 * var(--bs-gutter-x));\n}\n.row > * {\n  flex-shrink: 0;\n  width: 100%;\n  max-width: 100%;\n  padding-right: calc(var(--bs-gutter-x) * 0.5);\n  padding-left: calc(var(--bs-gutter-x) * 0.5);\n  margin-top: var(--bs-gutter-y);\n}\n\n.col {\n  flex: 1 0 0%;\n}\n\n.row-cols-auto > * {\n  flex: 0 0 auto;\n  width: auto;\n}\n\n.row-cols-1 > * {\n  flex: 0 0 auto;\n  width: 100%;\n}\n\n.row-cols-2 > * {\n  flex: 0 0 auto;\n  width: 50%;\n}\n\n.row-cols-3 > * {\n  flex: 0 0 auto;\n  width: 33.3333333333%;\n}\n\n.row-cols-4 > * {\n  flex: 0 0 auto;\n  width: 25%;\n}\n\n.row-cols-5 > * {\n  flex: 0 0 auto;\n  width: 20%;\n}\n\n.row-cols-6 > * {\n  flex: 0 0 auto;\n  width: 16.6666666667%;\n}\n\n.col-auto {\n  flex: 0 0 auto;\n  width: auto;\n}\n\n.col-1 {\n  flex: 0 0 auto;\n  width: 8.33333333%;\n}\n\n.col-2 {\n  flex: 0 0 auto;\n  width: 16.66666667%;\n}\n\n.col-3 {\n  flex: 0 0 auto;\n  width: 25%;\n}\n\n.col-4 {\n  flex: 0 0 auto;\n  width: 33.33333333%;\n}\n\n.col-5 {\n  flex: 0 0 auto;\n  width: 41.66666667%;\n}\n\n.col-6 {\n  flex: 0 0 auto;\n  width: 50%;\n}\n\n.col-7 {\n  flex: 0 0 auto;\n  width: 58.33333333%;\n}\n\n.col-8 {\n  flex: 0 0 auto;\n  width: 66.66666667%;\n}\n\n.col-9 {\n  flex: 0 0 auto;\n  width: 75%;\n}\n\n.col-10 {\n  flex: 0 0 auto;\n  width: 83.33333333%;\n}\n\n.col-11 {\n  flex: 0 0 auto;\n  width: 91.66666667%;\n}\n\n.col-12 {\n  flex: 0 0 auto;\n  width: 100%;\n}\n\n.offset-1 {\n  margin-left: 8.33333333%;\n}\n\n.offset-2 {\n  margin-left: 16.66666667%;\n}\n\n.offset-3 {\n  margin-left: 25%;\n}\n\n.offset-4 {\n  margin-left: 33.33333333%;\n}\n\n.offset-5 {\n  margin-left: 41.66666667%;\n}\n\n.offset-6 {\n  margin-left: 50%;\n}\n\n.offset-7 {\n  margin-left: 58.33333333%;\n}\n\n.offset-8 {\n  margin-left: 66.66666667%;\n}\n\n.offset-9 {\n  margin-left: 75%;\n}\n\n.offset-10 {\n  margin-left: 83.33333333%;\n}\n\n.offset-11 {\n  margin-left: 91.66666667%;\n}\n\n.g-0,\n.gx-0 {\n  --bs-gutter-x: 0rem;\n}\n\n.g-0,\n.gy-0 {\n  --bs-gutter-y: 0rem;\n}\n\n.g-1,\n.gx-1 {\n  --bs-gutter-x: 0.25rem;\n}\n\n.g-1,\n.gy-1 {\n  --bs-gutter-y: 0.25rem;\n}\n\n.g-2,\n.gx-2 {\n  --bs-gutter-x: 0.5rem;\n}\n\n.g-2,\n.gy-2 {\n  --bs-gutter-y: 0.5rem;\n}\n\n.g-3,\n.gx-3 {\n  --bs-gutter-x: 0.75rem;\n}\n\n.g-3,\n.gy-3 {\n  --bs-gutter-y: 0.75rem;\n}\n\n.g-4,\n.gx-4 {\n  --bs-gutter-x: 1rem;\n}\n\n.g-4,\n.gy-4 {\n  --bs-gutter-y: 1rem;\n}\n\n.g-5,\n.gx-5 {\n  --bs-gutter-x: 1.25rem;\n}\n\n.g-5,\n.gy-5 {\n  --bs-gutter-y: 1.25rem;\n}\n\n.g-6,\n.gx-6 {\n  --bs-gutter-x: 1.5rem;\n}\n\n.g-6,\n.gy-6 {\n  --bs-gutter-y: 1.5rem;\n}\n\n.g-7,\n.gx-7 {\n  --bs-gutter-x: 1.75rem;\n}\n\n.g-7,\n.gy-7 {\n  --bs-gutter-y: 1.75rem;\n}\n\n.g-8,\n.gx-8 {\n  --bs-gutter-x: 2rem;\n}\n\n.g-8,\n.gy-8 {\n  --bs-gutter-y: 2rem;\n}\n\n.g-9,\n.gx-9 {\n  --bs-gutter-x: 2.25rem;\n}\n\n.g-9,\n.gy-9 {\n  --bs-gutter-y: 2.25rem;\n}\n\n.g-10,\n.gx-10 {\n  --bs-gutter-x: 2.5rem;\n}\n\n.g-10,\n.gy-10 {\n  --bs-gutter-y: 2.5rem;\n}\n\n@media (min-width: 576px) {\n  .col-sm {\n    flex: 1 0 0%;\n  }\n  .row-cols-sm-auto > * {\n    flex: 0 0 auto;\n    width: auto;\n  }\n  .row-cols-sm-1 > * {\n    flex: 0 0 auto;\n    width: 100%;\n  }\n  .row-cols-sm-2 > * {\n    flex: 0 0 auto;\n    width: 50%;\n  }\n  .row-cols-sm-3 > * {\n    flex: 0 0 auto;\n    width: 33.3333333333%;\n  }\n  .row-cols-sm-4 > * {\n    flex: 0 0 auto;\n    width: 25%;\n  }\n  .row-cols-sm-5 > * {\n    flex: 0 0 auto;\n    width: 20%;\n  }\n  .row-cols-sm-6 > * {\n    flex: 0 0 auto;\n    width: 16.6666666667%;\n  }\n  .col-sm-auto {\n    flex: 0 0 auto;\n    width: auto;\n  }\n  .col-sm-1 {\n    flex: 0 0 auto;\n    width: 8.33333333%;\n  }\n  .col-sm-2 {\n    flex: 0 0 auto;\n    width: 16.66666667%;\n  }\n  .col-sm-3 {\n    flex: 0 0 auto;\n    width: 25%;\n  }\n  .col-sm-4 {\n    flex: 0 0 auto;\n    width: 33.33333333%;\n  }\n  .col-sm-5 {\n    flex: 0 0 auto;\n    width: 41.66666667%;\n  }\n  .col-sm-6 {\n    flex: 0 0 auto;\n    width: 50%;\n  }\n  .col-sm-7 {\n    flex: 0 0 auto;\n    width: 58.33333333%;\n  }\n  .col-sm-8 {\n    flex: 0 0 auto;\n    width: 66.66666667%;\n  }\n  .col-sm-9 {\n    flex: 0 0 auto;\n    width: 75%;\n  }\n  .col-sm-10 {\n    flex: 0 0 auto;\n    width: 83.33333333%;\n  }\n  .col-sm-11 {\n    flex: 0 0 auto;\n    width: 91.66666667%;\n  }\n  .col-sm-12 {\n    flex: 0 0 auto;\n    width: 100%;\n  }\n  .offset-sm-0 {\n    margin-left: 0;\n  }\n  .offset-sm-1 {\n    margin-left: 8.33333333%;\n  }\n  .offset-sm-2 {\n    margin-left: 16.66666667%;\n  }\n  .offset-sm-3 {\n    margin-left: 25%;\n  }\n  .offset-sm-4 {\n    margin-left: 33.33333333%;\n  }\n  .offset-sm-5 {\n    margin-left: 41.66666667%;\n  }\n  .offset-sm-6 {\n    margin-left: 50%;\n  }\n  .offset-sm-7 {\n    margin-left: 58.33333333%;\n  }\n  .offset-sm-8 {\n    margin-left: 66.66666667%;\n  }\n  .offset-sm-9 {\n    margin-left: 75%;\n  }\n  .offset-sm-10 {\n    margin-left: 83.33333333%;\n  }\n  .offset-sm-11 {\n    margin-left: 91.66666667%;\n  }\n  .g-sm-0,\n.gx-sm-0 {\n    --bs-gutter-x: 0rem;\n  }\n  .g-sm-0,\n.gy-sm-0 {\n    --bs-gutter-y: 0rem;\n  }\n  .g-sm-1,\n.gx-sm-1 {\n    --bs-gutter-x: 0.25rem;\n  }\n  .g-sm-1,\n.gy-sm-1 {\n    --bs-gutter-y: 0.25rem;\n  }\n  .g-sm-2,\n.gx-sm-2 {\n    --bs-gutter-x: 0.5rem;\n  }\n  .g-sm-2,\n.gy-sm-2 {\n    --bs-gutter-y: 0.5rem;\n  }\n  .g-sm-3,\n.gx-sm-3 {\n    --bs-gutter-x: 0.75rem;\n  }\n  .g-sm-3,\n.gy-sm-3 {\n    --bs-gutter-y: 0.75rem;\n  }\n  .g-sm-4,\n.gx-sm-4 {\n    --bs-gutter-x: 1rem;\n  }\n  .g-sm-4,\n.gy-sm-4 {\n    --bs-gutter-y: 1rem;\n  }\n  .g-sm-5,\n.gx-sm-5 {\n    --bs-gutter-x: 1.25rem;\n  }\n  .g-sm-5,\n.gy-sm-5 {\n    --bs-gutter-y: 1.25rem;\n  }\n  .g-sm-6,\n.gx-sm-6 {\n    --bs-gutter-x: 1.5rem;\n  }\n  .g-sm-6,\n.gy-sm-6 {\n    --bs-gutter-y: 1.5rem;\n  }\n  .g-sm-7,\n.gx-sm-7 {\n    --bs-gutter-x: 1.75rem;\n  }\n  .g-sm-7,\n.gy-sm-7 {\n    --bs-gutter-y: 1.75rem;\n  }\n  .g-sm-8,\n.gx-sm-8 {\n    --bs-gutter-x: 2rem;\n  }\n  .g-sm-8,\n.gy-sm-8 {\n    --bs-gutter-y: 2rem;\n  }\n  .g-sm-9,\n.gx-sm-9 {\n    --bs-gutter-x: 2.25rem;\n  }\n  .g-sm-9,\n.gy-sm-9 {\n    --bs-gutter-y: 2.25rem;\n  }\n  .g-sm-10,\n.gx-sm-10 {\n    --bs-gutter-x: 2.5rem;\n  }\n  .g-sm-10,\n.gy-sm-10 {\n    --bs-gutter-y: 2.5rem;\n  }\n}\n@media (min-width: 768px) {\n  .col-md {\n    flex: 1 0 0%;\n  }\n  .row-cols-md-auto > * {\n    flex: 0 0 auto;\n    width: auto;\n  }\n  .row-cols-md-1 > * {\n    flex: 0 0 auto;\n    width: 100%;\n  }\n  .row-cols-md-2 > * {\n    flex: 0 0 auto;\n    width: 50%;\n  }\n  .row-cols-md-3 > * {\n    flex: 0 0 auto;\n    width: 33.3333333333%;\n  }\n  .row-cols-md-4 > * {\n    flex: 0 0 auto;\n    width: 25%;\n  }\n  .row-cols-md-5 > * {\n    flex: 0 0 auto;\n    width: 20%;\n  }\n  .row-cols-md-6 > * {\n    flex: 0 0 auto;\n    width: 16.6666666667%;\n  }\n  .col-md-auto {\n    flex: 0 0 auto;\n    width: auto;\n  }\n  .col-md-1 {\n    flex: 0 0 auto;\n    width: 8.33333333%;\n  }\n  .col-md-2 {\n    flex: 0 0 auto;\n    width: 16.66666667%;\n  }\n  .col-md-3 {\n    flex: 0 0 auto;\n    width: 25%;\n  }\n  .col-md-4 {\n    flex: 0 0 auto;\n    width: 33.33333333%;\n  }\n  .col-md-5 {\n    flex: 0 0 auto;\n    width: 41.66666667%;\n  }\n  .col-md-6 {\n    flex: 0 0 auto;\n    width: 50%;\n  }\n  .col-md-7 {\n    flex: 0 0 auto;\n    width: 58.33333333%;\n  }\n  .col-md-8 {\n    flex: 0 0 auto;\n    width: 66.66666667%;\n  }\n  .col-md-9 {\n    flex: 0 0 auto;\n    width: 75%;\n  }\n  .col-md-10 {\n    flex: 0 0 auto;\n    width: 83.33333333%;\n  }\n  .col-md-11 {\n    flex: 0 0 auto;\n    width: 91.66666667%;\n  }\n  .col-md-12 {\n    flex: 0 0 auto;\n    width: 100%;\n  }\n  .offset-md-0 {\n    margin-left: 0;\n  }\n  .offset-md-1 {\n    margin-left: 8.33333333%;\n  }\n  .offset-md-2 {\n    margin-left: 16.66666667%;\n  }\n  .offset-md-3 {\n    margin-left: 25%;\n  }\n  .offset-md-4 {\n    margin-left: 33.33333333%;\n  }\n  .offset-md-5 {\n    margin-left: 41.66666667%;\n  }\n  .offset-md-6 {\n    margin-left: 50%;\n  }\n  .offset-md-7 {\n    margin-left: 58.33333333%;\n  }\n  .offset-md-8 {\n    margin-left: 66.66666667%;\n  }\n  .offset-md-9 {\n    margin-left: 75%;\n  }\n  .offset-md-10 {\n    margin-left: 83.33333333%;\n  }\n  .offset-md-11 {\n    margin-left: 91.66666667%;\n  }\n  .g-md-0,\n.gx-md-0 {\n    --bs-gutter-x: 0rem;\n  }\n  .g-md-0,\n.gy-md-0 {\n    --bs-gutter-y: 0rem;\n  }\n  .g-md-1,\n.gx-md-1 {\n    --bs-gutter-x: 0.25rem;\n  }\n  .g-md-1,\n.gy-md-1 {\n    --bs-gutter-y: 0.25rem;\n  }\n  .g-md-2,\n.gx-md-2 {\n    --bs-gutter-x: 0.5rem;\n  }\n  .g-md-2,\n.gy-md-2 {\n    --bs-gutter-y: 0.5rem;\n  }\n  .g-md-3,\n.gx-md-3 {\n    --bs-gutter-x: 0.75rem;\n  }\n  .g-md-3,\n.gy-md-3 {\n    --bs-gutter-y: 0.75rem;\n  }\n  .g-md-4,\n.gx-md-4 {\n    --bs-gutter-x: 1rem;\n  }\n  .g-md-4,\n.gy-md-4 {\n    --bs-gutter-y: 1rem;\n  }\n  .g-md-5,\n.gx-md-5 {\n    --bs-gutter-x: 1.25rem;\n  }\n  .g-md-5,\n.gy-md-5 {\n    --bs-gutter-y: 1.25rem;\n  }\n  .g-md-6,\n.gx-md-6 {\n    --bs-gutter-x: 1.5rem;\n  }\n  .g-md-6,\n.gy-md-6 {\n    --bs-gutter-y: 1.5rem;\n  }\n  .g-md-7,\n.gx-md-7 {\n    --bs-gutter-x: 1.75rem;\n  }\n  .g-md-7,\n.gy-md-7 {\n    --bs-gutter-y: 1.75rem;\n  }\n  .g-md-8,\n.gx-md-8 {\n    --bs-gutter-x: 2rem;\n  }\n  .g-md-8,\n.gy-md-8 {\n    --bs-gutter-y: 2rem;\n  }\n  .g-md-9,\n.gx-md-9 {\n    --bs-gutter-x: 2.25rem;\n  }\n  .g-md-9,\n.gy-md-9 {\n    --bs-gutter-y: 2.25rem;\n  }\n  .g-md-10,\n.gx-md-10 {\n    --bs-gutter-x: 2.5rem;\n  }\n  .g-md-10,\n.gy-md-10 {\n    --bs-gutter-y: 2.5rem;\n  }\n}\n@media (min-width: 992px) {\n  .col-lg {\n    flex: 1 0 0%;\n  }\n  .row-cols-lg-auto > * {\n    flex: 0 0 auto;\n    width: auto;\n  }\n  .row-cols-lg-1 > * {\n    flex: 0 0 auto;\n    width: 100%;\n  }\n  .row-cols-lg-2 > * {\n    flex: 0 0 auto;\n    width: 50%;\n  }\n  .row-cols-lg-3 > * {\n    flex: 0 0 auto;\n    width: 33.3333333333%;\n  }\n  .row-cols-lg-4 > * {\n    flex: 0 0 auto;\n    width: 25%;\n  }\n  .row-cols-lg-5 > * {\n    flex: 0 0 auto;\n    width: 20%;\n  }\n  .row-cols-lg-6 > * {\n    flex: 0 0 auto;\n    width: 16.6666666667%;\n  }\n  .col-lg-auto {\n    flex: 0 0 auto;\n    width: auto;\n  }\n  .col-lg-1 {\n    flex: 0 0 auto;\n    width: 8.33333333%;\n  }\n  .col-lg-2 {\n    flex: 0 0 auto;\n    width: 16.66666667%;\n  }\n  .col-lg-3 {\n    flex: 0 0 auto;\n    width: 25%;\n  }\n  .col-lg-4 {\n    flex: 0 0 auto;\n    width: 33.33333333%;\n  }\n  .col-lg-5 {\n    flex: 0 0 auto;\n    width: 41.66666667%;\n  }\n  .col-lg-6 {\n    flex: 0 0 auto;\n    width: 50%;\n  }\n  .col-lg-7 {\n    flex: 0 0 auto;\n    width: 58.33333333%;\n  }\n  .col-lg-8 {\n    flex: 0 0 auto;\n    width: 66.66666667%;\n  }\n  .col-lg-9 {\n    flex: 0 0 auto;\n    width: 75%;\n  }\n  .col-lg-10 {\n    flex: 0 0 auto;\n    width: 83.33333333%;\n  }\n  .col-lg-11 {\n    flex: 0 0 auto;\n    width: 91.66666667%;\n  }\n  .col-lg-12 {\n    flex: 0 0 auto;\n    width: 100%;\n  }\n  .offset-lg-0 {\n    margin-left: 0;\n  }\n  .offset-lg-1 {\n    margin-left: 8.33333333%;\n  }\n  .offset-lg-2 {\n    margin-left: 16.66666667%;\n  }\n  .offset-lg-3 {\n    margin-left: 25%;\n  }\n  .offset-lg-4 {\n    margin-left: 33.33333333%;\n  }\n  .offset-lg-5 {\n    margin-left: 41.66666667%;\n  }\n  .offset-lg-6 {\n    margin-left: 50%;\n  }\n  .offset-lg-7 {\n    margin-left: 58.33333333%;\n  }\n  .offset-lg-8 {\n    margin-left: 66.66666667%;\n  }\n  .offset-lg-9 {\n    margin-left: 75%;\n  }\n  .offset-lg-10 {\n    margin-left: 83.33333333%;\n  }\n  .offset-lg-11 {\n    margin-left: 91.66666667%;\n  }\n  .g-lg-0,\n.gx-lg-0 {\n    --bs-gutter-x: 0rem;\n  }\n  .g-lg-0,\n.gy-lg-0 {\n    --bs-gutter-y: 0rem;\n  }\n  .g-lg-1,\n.gx-lg-1 {\n    --bs-gutter-x: 0.25rem;\n  }\n  .g-lg-1,\n.gy-lg-1 {\n    --bs-gutter-y: 0.25rem;\n  }\n  .g-lg-2,\n.gx-lg-2 {\n    --bs-gutter-x: 0.5rem;\n  }\n  .g-lg-2,\n.gy-lg-2 {\n    --bs-gutter-y: 0.5rem;\n  }\n  .g-lg-3,\n.gx-lg-3 {\n    --bs-gutter-x: 0.75rem;\n  }\n  .g-lg-3,\n.gy-lg-3 {\n    --bs-gutter-y: 0.75rem;\n  }\n  .g-lg-4,\n.gx-lg-4 {\n    --bs-gutter-x: 1rem;\n  }\n  .g-lg-4,\n.gy-lg-4 {\n    --bs-gutter-y: 1rem;\n  }\n  .g-lg-5,\n.gx-lg-5 {\n    --bs-gutter-x: 1.25rem;\n  }\n  .g-lg-5,\n.gy-lg-5 {\n    --bs-gutter-y: 1.25rem;\n  }\n  .g-lg-6,\n.gx-lg-6 {\n    --bs-gutter-x: 1.5rem;\n  }\n  .g-lg-6,\n.gy-lg-6 {\n    --bs-gutter-y: 1.5rem;\n  }\n  .g-lg-7,\n.gx-lg-7 {\n    --bs-gutter-x: 1.75rem;\n  }\n  .g-lg-7,\n.gy-lg-7 {\n    --bs-gutter-y: 1.75rem;\n  }\n  .g-lg-8,\n.gx-lg-8 {\n    --bs-gutter-x: 2rem;\n  }\n  .g-lg-8,\n.gy-lg-8 {\n    --bs-gutter-y: 2rem;\n  }\n  .g-lg-9,\n.gx-lg-9 {\n    --bs-gutter-x: 2.25rem;\n  }\n  .g-lg-9,\n.gy-lg-9 {\n    --bs-gutter-y: 2.25rem;\n  }\n  .g-lg-10,\n.gx-lg-10 {\n    --bs-gutter-x: 2.5rem;\n  }\n  .g-lg-10,\n.gy-lg-10 {\n    --bs-gutter-y: 2.5rem;\n  }\n}\n@media (min-width: 1200px) {\n  .col-xl {\n    flex: 1 0 0%;\n  }\n  .row-cols-xl-auto > * {\n    flex: 0 0 auto;\n    width: auto;\n  }\n  .row-cols-xl-1 > * {\n    flex: 0 0 auto;\n    width: 100%;\n  }\n  .row-cols-xl-2 > * {\n    flex: 0 0 auto;\n    width: 50%;\n  }\n  .row-cols-xl-3 > * {\n    flex: 0 0 auto;\n    width: 33.3333333333%;\n  }\n  .row-cols-xl-4 > * {\n    flex: 0 0 auto;\n    width: 25%;\n  }\n  .row-cols-xl-5 > * {\n    flex: 0 0 auto;\n    width: 20%;\n  }\n  .row-cols-xl-6 > * {\n    flex: 0 0 auto;\n    width: 16.6666666667%;\n  }\n  .col-xl-auto {\n    flex: 0 0 auto;\n    width: auto;\n  }\n  .col-xl-1 {\n    flex: 0 0 auto;\n    width: 8.33333333%;\n  }\n  .col-xl-2 {\n    flex: 0 0 auto;\n    width: 16.66666667%;\n  }\n  .col-xl-3 {\n    flex: 0 0 auto;\n    width: 25%;\n  }\n  .col-xl-4 {\n    flex: 0 0 auto;\n    width: 33.33333333%;\n  }\n  .col-xl-5 {\n    flex: 0 0 auto;\n    width: 41.66666667%;\n  }\n  .col-xl-6 {\n    flex: 0 0 auto;\n    width: 50%;\n  }\n  .col-xl-7 {\n    flex: 0 0 auto;\n    width: 58.33333333%;\n  }\n  .col-xl-8 {\n    flex: 0 0 auto;\n    width: 66.66666667%;\n  }\n  .col-xl-9 {\n    flex: 0 0 auto;\n    width: 75%;\n  }\n  .col-xl-10 {\n    flex: 0 0 auto;\n    width: 83.33333333%;\n  }\n  .col-xl-11 {\n    flex: 0 0 auto;\n    width: 91.66666667%;\n  }\n  .col-xl-12 {\n    flex: 0 0 auto;\n    width: 100%;\n  }\n  .offset-xl-0 {\n    margin-left: 0;\n  }\n  .offset-xl-1 {\n    margin-left: 8.33333333%;\n  }\n  .offset-xl-2 {\n    margin-left: 16.66666667%;\n  }\n  .offset-xl-3 {\n    margin-left: 25%;\n  }\n  .offset-xl-4 {\n    margin-left: 33.33333333%;\n  }\n  .offset-xl-5 {\n    margin-left: 41.66666667%;\n  }\n  .offset-xl-6 {\n    margin-left: 50%;\n  }\n  .offset-xl-7 {\n    margin-left: 58.33333333%;\n  }\n  .offset-xl-8 {\n    margin-left: 66.66666667%;\n  }\n  .offset-xl-9 {\n    margin-left: 75%;\n  }\n  .offset-xl-10 {\n    margin-left: 83.33333333%;\n  }\n  .offset-xl-11 {\n    margin-left: 91.66666667%;\n  }\n  .g-xl-0,\n.gx-xl-0 {\n    --bs-gutter-x: 0rem;\n  }\n  .g-xl-0,\n.gy-xl-0 {\n    --bs-gutter-y: 0rem;\n  }\n  .g-xl-1,\n.gx-xl-1 {\n    --bs-gutter-x: 0.25rem;\n  }\n  .g-xl-1,\n.gy-xl-1 {\n    --bs-gutter-y: 0.25rem;\n  }\n  .g-xl-2,\n.gx-xl-2 {\n    --bs-gutter-x: 0.5rem;\n  }\n  .g-xl-2,\n.gy-xl-2 {\n    --bs-gutter-y: 0.5rem;\n  }\n  .g-xl-3,\n.gx-xl-3 {\n    --bs-gutter-x: 0.75rem;\n  }\n  .g-xl-3,\n.gy-xl-3 {\n    --bs-gutter-y: 0.75rem;\n  }\n  .g-xl-4,\n.gx-xl-4 {\n    --bs-gutter-x: 1rem;\n  }\n  .g-xl-4,\n.gy-xl-4 {\n    --bs-gutter-y: 1rem;\n  }\n  .g-xl-5,\n.gx-xl-5 {\n    --bs-gutter-x: 1.25rem;\n  }\n  .g-xl-5,\n.gy-xl-5 {\n    --bs-gutter-y: 1.25rem;\n  }\n  .g-xl-6,\n.gx-xl-6 {\n    --bs-gutter-x: 1.5rem;\n  }\n  .g-xl-6,\n.gy-xl-6 {\n    --bs-gutter-y: 1.5rem;\n  }\n  .g-xl-7,\n.gx-xl-7 {\n    --bs-gutter-x: 1.75rem;\n  }\n  .g-xl-7,\n.gy-xl-7 {\n    --bs-gutter-y: 1.75rem;\n  }\n  .g-xl-8,\n.gx-xl-8 {\n    --bs-gutter-x: 2rem;\n  }\n  .g-xl-8,\n.gy-xl-8 {\n    --bs-gutter-y: 2rem;\n  }\n  .g-xl-9,\n.gx-xl-9 {\n    --bs-gutter-x: 2.25rem;\n  }\n  .g-xl-9,\n.gy-xl-9 {\n    --bs-gutter-y: 2.25rem;\n  }\n  .g-xl-10,\n.gx-xl-10 {\n    --bs-gutter-x: 2.5rem;\n  }\n  .g-xl-10,\n.gy-xl-10 {\n    --bs-gutter-y: 2.5rem;\n  }\n}\n@media (min-width: 1400px) {\n  .col-xxl {\n    flex: 1 0 0%;\n  }\n  .row-cols-xxl-auto > * {\n    flex: 0 0 auto;\n    width: auto;\n  }\n  .row-cols-xxl-1 > * {\n    flex: 0 0 auto;\n    width: 100%;\n  }\n  .row-cols-xxl-2 > * {\n    flex: 0 0 auto;\n    width: 50%;\n  }\n  .row-cols-xxl-3 > * {\n    flex: 0 0 auto;\n    width: 33.3333333333%;\n  }\n  .row-cols-xxl-4 > * {\n    flex: 0 0 auto;\n    width: 25%;\n  }\n  .row-cols-xxl-5 > * {\n    flex: 0 0 auto;\n    width: 20%;\n  }\n  .row-cols-xxl-6 > * {\n    flex: 0 0 auto;\n    width: 16.6666666667%;\n  }\n  .col-xxl-auto {\n    flex: 0 0 auto;\n    width: auto;\n  }\n  .col-xxl-1 {\n    flex: 0 0 auto;\n    width: 8.33333333%;\n  }\n  .col-xxl-2 {\n    flex: 0 0 auto;\n    width: 16.66666667%;\n  }\n  .col-xxl-3 {\n    flex: 0 0 auto;\n    width: 25%;\n  }\n  .col-xxl-4 {\n    flex: 0 0 auto;\n    width: 33.33333333%;\n  }\n  .col-xxl-5 {\n    flex: 0 0 auto;\n    width: 41.66666667%;\n  }\n  .col-xxl-6 {\n    flex: 0 0 auto;\n    width: 50%;\n  }\n  .col-xxl-7 {\n    flex: 0 0 auto;\n    width: 58.33333333%;\n  }\n  .col-xxl-8 {\n    flex: 0 0 auto;\n    width: 66.66666667%;\n  }\n  .col-xxl-9 {\n    flex: 0 0 auto;\n    width: 75%;\n  }\n  .col-xxl-10 {\n    flex: 0 0 auto;\n    width: 83.33333333%;\n  }\n  .col-xxl-11 {\n    flex: 0 0 auto;\n    width: 91.66666667%;\n  }\n  .col-xxl-12 {\n    flex: 0 0 auto;\n    width: 100%;\n  }\n  .offset-xxl-0 {\n    margin-left: 0;\n  }\n  .offset-xxl-1 {\n    margin-left: 8.33333333%;\n  }\n  .offset-xxl-2 {\n    margin-left: 16.66666667%;\n  }\n  .offset-xxl-3 {\n    margin-left: 25%;\n  }\n  .offset-xxl-4 {\n    margin-left: 33.33333333%;\n  }\n  .offset-xxl-5 {\n    margin-left: 41.66666667%;\n  }\n  .offset-xxl-6 {\n    margin-left: 50%;\n  }\n  .offset-xxl-7 {\n    margin-left: 58.33333333%;\n  }\n  .offset-xxl-8 {\n    margin-left: 66.66666667%;\n  }\n  .offset-xxl-9 {\n    margin-left: 75%;\n  }\n  .offset-xxl-10 {\n    margin-left: 83.33333333%;\n  }\n  .offset-xxl-11 {\n    margin-left: 91.66666667%;\n  }\n  .g-xxl-0,\n.gx-xxl-0 {\n    --bs-gutter-x: 0rem;\n  }\n  .g-xxl-0,\n.gy-xxl-0 {\n    --bs-gutter-y: 0rem;\n  }\n  .g-xxl-1,\n.gx-xxl-1 {\n    --bs-gutter-x: 0.25rem;\n  }\n  .g-xxl-1,\n.gy-xxl-1 {\n    --bs-gutter-y: 0.25rem;\n  }\n  .g-xxl-2,\n.gx-xxl-2 {\n    --bs-gutter-x: 0.5rem;\n  }\n  .g-xxl-2,\n.gy-xxl-2 {\n    --bs-gutter-y: 0.5rem;\n  }\n  .g-xxl-3,\n.gx-xxl-3 {\n    --bs-gutter-x: 0.75rem;\n  }\n  .g-xxl-3,\n.gy-xxl-3 {\n    --bs-gutter-y: 0.75rem;\n  }\n  .g-xxl-4,\n.gx-xxl-4 {\n    --bs-gutter-x: 1rem;\n  }\n  .g-xxl-4,\n.gy-xxl-4 {\n    --bs-gutter-y: 1rem;\n  }\n  .g-xxl-5,\n.gx-xxl-5 {\n    --bs-gutter-x: 1.25rem;\n  }\n  .g-xxl-5,\n.gy-xxl-5 {\n    --bs-gutter-y: 1.25rem;\n  }\n  .g-xxl-6,\n.gx-xxl-6 {\n    --bs-gutter-x: 1.5rem;\n  }\n  .g-xxl-6,\n.gy-xxl-6 {\n    --bs-gutter-y: 1.5rem;\n  }\n  .g-xxl-7,\n.gx-xxl-7 {\n    --bs-gutter-x: 1.75rem;\n  }\n  .g-xxl-7,\n.gy-xxl-7 {\n    --bs-gutter-y: 1.75rem;\n  }\n  .g-xxl-8,\n.gx-xxl-8 {\n    --bs-gutter-x: 2rem;\n  }\n  .g-xxl-8,\n.gy-xxl-8 {\n    --bs-gutter-y: 2rem;\n  }\n  .g-xxl-9,\n.gx-xxl-9 {\n    --bs-gutter-x: 2.25rem;\n  }\n  .g-xxl-9,\n.gy-xxl-9 {\n    --bs-gutter-y: 2.25rem;\n  }\n  .g-xxl-10,\n.gx-xxl-10 {\n    --bs-gutter-x: 2.5rem;\n  }\n  .g-xxl-10,\n.gy-xxl-10 {\n    --bs-gutter-y: 2.5rem;\n  }\n}\n.table {\n  --bs-table-color: var(--bs-body-color);\n  --bs-table-bg: transparent;\n  --bs-table-border-color: var(--bs-border-color);\n  --bs-table-accent-bg: transparent;\n  --bs-table-striped-color: var(--bs-body-color);\n  --bs-table-striped-bg: rgba(var(--bs-gray-100-rgb), 0.75);\n  --bs-table-active-color: var(--bs-body-color);\n  --bs-table-active-bg: var(--bs-gray-100);\n  --bs-table-hover-color: var(--bs-body-color);\n  --bs-table-hover-bg: var(--bs-gray-100);\n  width: 100%;\n  margin-bottom: 1rem;\n  color: var(--bs-table-color);\n  vertical-align: top;\n  border-color: var(--bs-table-border-color);\n}\n.table > :not(caption) > * > * {\n  padding: 0.75rem 0.75rem;\n  background-color: var(--bs-table-bg);\n  border-bottom-width: 1px;\n  box-shadow: inset 0 0 0 9999px var(--bs-table-accent-bg);\n}\n.table > tbody {\n  vertical-align: inherit;\n}\n.table > thead {\n  vertical-align: bottom;\n}\n\n.table-group-divider {\n  border-top: 2px solid currentcolor;\n}\n\n.caption-top {\n  caption-side: top;\n}\n\n.table-sm > :not(caption) > * > * {\n  padding: 0.5rem 0.5rem;\n}\n\n.table-bordered > :not(caption) > * {\n  border-width: 1px 0;\n}\n.table-bordered > :not(caption) > * > * {\n  border-width: 0 1px;\n}\n\n.table-borderless > :not(caption) > * > * {\n  border-bottom-width: 0;\n}\n.table-borderless > :not(:first-child) {\n  border-top-width: 0;\n}\n\n.table-striped > tbody > tr:nth-of-type(odd) > * {\n  --bs-table-accent-bg: var(--bs-table-striped-bg);\n  color: var(--bs-table-striped-color);\n}\n\n.table-striped-columns > :not(caption) > tr > :nth-child(even) {\n  --bs-table-accent-bg: var(--bs-table-striped-bg);\n  color: var(--bs-table-striped-color);\n}\n\n.table-active {\n  --bs-table-accent-bg: var(--bs-table-active-bg);\n  color: var(--bs-table-active-color);\n}\n\n.table-hover > tbody > tr:hover > * {\n  --bs-table-accent-bg: var(--bs-table-hover-bg);\n  color: var(--bs-table-hover-color);\n}\n\n.table-primary {\n  --bs-table-color: #000000;\n  --bs-table-bg: #ccecfd;\n  --bs-table-border-color: #b8d4e4;\n  --bs-table-striped-bg: #c2e0f0;\n  --bs-table-striped-color: #000000;\n  --bs-table-active-bg: #b8d4e4;\n  --bs-table-active-color: #000000;\n  --bs-table-hover-bg: #bddaea;\n  --bs-table-hover-color: #000000;\n  color: var(--bs-table-color);\n  border-color: var(--bs-table-border-color);\n}\n\n.table-secondary {\n  --bs-table-color: #000000;\n  --bs-table-bg: #f9f9fb;\n  --bs-table-border-color: #e0e0e2;\n  --bs-table-striped-bg: #ededee;\n  --bs-table-striped-color: #000000;\n  --bs-table-active-bg: #e0e0e2;\n  --bs-table-active-color: #000000;\n  --bs-table-hover-bg: #e6e6e8;\n  --bs-table-hover-color: #000000;\n  color: var(--bs-table-color);\n  border-color: var(--bs-table-border-color);\n}\n\n.table-success {\n  --bs-table-color: #000000;\n  --bs-table-bg: #dcf5e7;\n  --bs-table-border-color: #c6ddd0;\n  --bs-table-striped-bg: #d1e9db;\n  --bs-table-striped-color: #000000;\n  --bs-table-active-bg: #c6ddd0;\n  --bs-table-active-color: #000000;\n  --bs-table-hover-bg: #cce3d6;\n  --bs-table-hover-color: #000000;\n  color: var(--bs-table-color);\n  border-color: var(--bs-table-border-color);\n}\n\n.table-info {\n  --bs-table-color: #000000;\n  --bs-table-bg: #e3d7fb;\n  --bs-table-border-color: #ccc2e2;\n  --bs-table-striped-bg: #d8ccee;\n  --bs-table-striped-color: #000000;\n  --bs-table-active-bg: #ccc2e2;\n  --bs-table-active-color: #000000;\n  --bs-table-hover-bg: #d2c7e8;\n  --bs-table-hover-color: #000000;\n  color: var(--bs-table-color);\n  border-color: var(--bs-table-border-color);\n}\n\n.table-warning {\n  --bs-table-color: #000000;\n  --bs-table-bg: #fff4cc;\n  --bs-table-border-color: #e6dcb8;\n  --bs-table-striped-bg: #f2e8c2;\n  --bs-table-striped-color: #000000;\n  --bs-table-active-bg: #e6dcb8;\n  --bs-table-active-color: #000000;\n  --bs-table-hover-bg: #ece2bd;\n  --bs-table-hover-color: #000000;\n  color: var(--bs-table-color);\n  border-color: var(--bs-table-border-color);\n}\n\n.table-danger {\n  --bs-table-color: #000000;\n  --bs-table-bg: #fcd9e2;\n  --bs-table-border-color: #e3c3cb;\n  --bs-table-striped-bg: #efced7;\n  --bs-table-striped-color: #000000;\n  --bs-table-active-bg: #e3c3cb;\n  --bs-table-active-color: #000000;\n  --bs-table-hover-bg: #e9c9d1;\n  --bs-table-hover-color: #000000;\n  color: var(--bs-table-color);\n  border-color: var(--bs-table-border-color);\n}\n\n.table-light {\n  --bs-table-color: #000000;\n  --bs-table-bg: #F9F9F9;\n  --bs-table-border-color: #e0e0e0;\n  --bs-table-striped-bg: #ededed;\n  --bs-table-striped-color: #000000;\n  --bs-table-active-bg: #e0e0e0;\n  --bs-table-active-color: #000000;\n  --bs-table-hover-bg: #e6e6e6;\n  --bs-table-hover-color: #000000;\n  color: var(--bs-table-color);\n  border-color: var(--bs-table-border-color);\n}\n\n.table-dark {\n  --bs-table-color: #ffffff;\n  --bs-table-bg: #181C32;\n  --bs-table-border-color: #2f3347;\n  --bs-table-striped-bg: #24273c;\n  --bs-table-striped-color: #ffffff;\n  --bs-table-active-bg: #2f3347;\n  --bs-table-active-color: #ffffff;\n  --bs-table-hover-bg: #292d41;\n  --bs-table-hover-color: #ffffff;\n  color: var(--bs-table-color);\n  border-color: var(--bs-table-border-color);\n}\n\n.table-responsive {\n  overflow-x: auto;\n  -webkit-overflow-scrolling: touch;\n}\n\n@media (max-width: 575.98px) {\n  .table-responsive-sm {\n    overflow-x: auto;\n    -webkit-overflow-scrolling: touch;\n  }\n}\n@media (max-width: 767.98px) {\n  .table-responsive-md {\n    overflow-x: auto;\n    -webkit-overflow-scrolling: touch;\n  }\n}\n@media (max-width: 991.98px) {\n  .table-responsive-lg {\n    overflow-x: auto;\n    -webkit-overflow-scrolling: touch;\n  }\n}\n@media (max-width: 1199.98px) {\n  .table-responsive-xl {\n    overflow-x: auto;\n    -webkit-overflow-scrolling: touch;\n  }\n}\n@media (max-width: 1399.98px) {\n  .table-responsive-xxl {\n    overflow-x: auto;\n    -webkit-overflow-scrolling: touch;\n  }\n}\n.form-label {\n  margin-bottom: 0.5rem;\n  font-size: 1.05rem;\n  font-weight: 500;\n  color: var(--bs-gray-800);\n}\n\n.col-form-label {\n  padding-top: calc(0.775rem + 1px);\n  padding-bottom: calc(0.775rem + 1px);\n  margin-bottom: 0;\n  font-size: inherit;\n  font-weight: 500;\n  line-height: 1.5;\n  color: var(--bs-gray-800);\n}\n\n.col-form-label-lg {\n  padding-top: calc(0.825rem + 1px);\n  padding-bottom: calc(0.825rem + 1px);\n  font-size: 1.15rem;\n}\n\n.col-form-label-sm {\n  padding-top: calc(0.55rem + 1px);\n  padding-bottom: calc(0.55rem + 1px);\n  font-size: 0.95rem;\n}\n\n.form-text {\n  margin-top: 0.5rem;\n  font-size: 0.95rem;\n  color: var(--bs-text-muted);\n}\n\n.form-control {\n  display: block;\n  width: 100%;\n  padding: 0.775rem 1rem;\n  font-size: 1.1rem;\n  font-weight: 500;\n  line-height: 1.5;\n  color: var(--bs-gray-700);\n  background-color: var(--bs-body-bg);\n  background-clip: padding-box;\n  border: 1px solid var(--bs-gray-300);\n  appearance: none;\n  border-radius: 0.475rem;\n  box-shadow: false;\n  transition: border-color 0.15s ease-in-out, box-shadow 0.15s ease-in-out;\n}\n@media (prefers-reduced-motion: reduce) {\n  .form-control {\n    transition: none;\n  }\n}\n.form-control[type=file] {\n  overflow: hidden;\n}\n.form-control[type=file]:not(:disabled):not([readonly]) {\n  cursor: pointer;\n}\n.form-control:focus {\n  color: var(--bs-gray-700);\n  background-color: var(--bs-body-bg);\n  border-color: var(--bs-gray-400);\n  outline: 0;\n  box-shadow: false, 0 0 0 0.25rem rgba(var(--bs-component-active-bg), 0.25);\n}\n.form-control::-webkit-date-and-time-value {\n  height: 1.5em;\n}\n.form-control::-webkit-datetime-edit {\n  display: block;\n  padding: 0;\n}\n.form-control::placeholder {\n  color: var(--bs-gray-500);\n  opacity: 1;\n}\n.form-control:disabled {\n  color: var(--bs-gray-500);\n  background-color: var(--bs-gray-200);\n  border-color: var(--bs-gray-300);\n  opacity: 1;\n}\n.form-control::file-selector-button {\n  padding: 0.775rem 1rem;\n  margin: -0.775rem -1rem;\n  margin-inline-end: 1rem;\n  color: var(--bs-gray-700);\n  background-color: var(--bs-gray-100);\n  pointer-events: none;\n  border-color: inherit;\n  border-style: solid;\n  border-width: 0;\n  border-inline-end-width: 1px;\n  border-radius: 0;\n  transition: color 0.15s ease-in-out, background-color 0.15s ease-in-out, border-color 0.15s ease-in-out, box-shadow 0.15s ease-in-out;\n}\n@media (prefers-reduced-motion: reduce) {\n  .form-control::file-selector-button {\n    transition: none;\n  }\n}\n.form-control:hover:not(:disabled):not([readonly])::file-selector-button {\n  background-color: shade-color(var(--bs-gray-100), 5%);\n}\n\n.form-control-plaintext {\n  display: block;\n  width: 100%;\n  padding: 0.775rem 0;\n  margin-bottom: 0;\n  line-height: 1.5;\n  color: var(--bs-gray-700);\n  background-color: transparent;\n  border: solid transparent;\n  border-width: 1px 0;\n}\n.form-control-plaintext:focus {\n  outline: 0;\n}\n.form-control-plaintext.form-control-sm, .form-control-plaintext.form-control-lg {\n  padding-right: 0;\n  padding-left: 0;\n}\n\n.form-control-sm {\n  min-height: calc(1.5em + 1.1rem + 2px);\n  padding: 0.55rem 0.75rem;\n  font-size: 0.95rem;\n  border-radius: 0.425rem;\n}\n.form-control-sm::file-selector-button {\n  padding: 0.55rem 0.75rem;\n  margin: -0.55rem -0.75rem;\n  margin-inline-end: 0.75rem;\n}\n\n.form-control-lg {\n  min-height: calc(1.5em + 1.65rem + 2px);\n  padding: 0.825rem 1.5rem;\n  font-size: 1.15rem;\n  border-radius: 0.625rem;\n}\n.form-control-lg::file-selector-button {\n  padding: 0.825rem 1.5rem;\n  margin: -0.825rem -1.5rem;\n  margin-inline-end: 1.5rem;\n}\n\ntextarea.form-control {\n  min-height: calc(1.5em + 1.55rem + 2px);\n}\ntextarea.form-control-sm {\n  min-height: calc(1.5em + 1.1rem + 2px);\n}\ntextarea.form-control-lg {\n  min-height: calc(1.5em + 1.65rem + 2px);\n}\n\n.form-control-color {\n  width: 3rem;\n  height: calc(1.5em + 1.55rem + 2px);\n  padding: 0.775rem;\n}\n.form-control-color:not(:disabled):not([readonly]) {\n  cursor: pointer;\n}\n.form-control-color::-moz-color-swatch {\n  border: 0 !important;\n  border-radius: 0.475rem;\n}\n.form-control-color::-webkit-color-swatch {\n  border-radius: 0.475rem;\n}\n.form-control-color.form-control-sm {\n  height: calc(1.5em + 1.1rem + 2px);\n}\n.form-control-color.form-control-lg {\n  height: calc(1.5em + 1.65rem + 2px);\n}\n\n.form-select {\n  --bs-form-select-bg-img: url(\"data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 16 16'%3e%3cpath fill='none' stroke='%237E8299' stroke-linecap='round' stroke-linejoin='round' stroke-width='2' d='m2 5 6 6 6-6'/%3e%3c/svg%3e\");\n  display: block;\n  width: 100%;\n  padding: 0.775rem 3rem 0.775rem 1rem;\n  -moz-padding-start: calc(1rem - 3px);\n  font-size: 1.1rem;\n  font-weight: 500;\n  line-height: 1.5;\n  color: var(--bs-gray-700);\n  background-color: var(--bs-body-bg);\n  background-image: var(--bs-form-select-bg-img), var(--bs-form-select-bg-icon, none);\n  background-repeat: no-repeat;\n  background-position: right 1rem center;\n  background-size: 16px 12px;\n  border: 1px solid var(--bs-gray-300);\n  border-radius: 0.475rem;\n  box-shadow: false;\n  transition: border-color 0.15s ease-in-out, box-shadow 0.15s ease-in-out;\n  appearance: none;\n}\n@media (prefers-reduced-motion: reduce) {\n  .form-select {\n    transition: none;\n  }\n}\n.form-select:focus {\n  border-color: var(--bs-gray-400);\n  outline: 0;\n  box-shadow: false, 0 0 0 0.25rem rgba(var(--bs-component-active-bg), 0.25);\n}\n.form-select[multiple], .form-select[size]:not([size=\"1\"]) {\n  padding-right: 1rem;\n  background-image: none;\n}\n.form-select:disabled {\n  color: var(--bs-gray-500);\n  background-color: var(--bs-gray-200);\n  border-color: var(--bs-gray-300);\n}\n.form-select:-moz-focusring {\n  color: transparent;\n  text-shadow: 0 0 0 var(--bs-gray-700);\n}\n\n.form-select-sm {\n  padding-top: 0.55rem;\n  padding-bottom: 0.55rem;\n  padding-left: 0.75rem;\n  font-size: 0.95rem;\n  border-radius: 0.425rem;\n}\n\n.form-select-lg {\n  padding-top: 0.825rem;\n  padding-bottom: 0.825rem;\n  padding-left: 1.5rem;\n  font-size: 1.15rem;\n  border-radius: 0.625rem;\n}\n\n[data-bs-theme=dark] .form-select {\n  --bs-form-select-bg-img: url(\"data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 16 16'%3e%3cpath fill='none' stroke='%236D6D80' stroke-linecap='round' stroke-linejoin='round' stroke-width='2' d='m2 5 6 6 6-6'/%3e%3c/svg%3e\");\n}\n\n.form-check {\n  display: block;\n  min-height: 1.5rem;\n  padding-left: 2.25rem;\n  margin-bottom: 0.125rem;\n}\n.form-check .form-check-input {\n  float: left;\n  margin-left: -2.25rem;\n}\n\n.form-check-reverse {\n  padding-right: 2.25rem;\n  padding-left: 0;\n  text-align: right;\n}\n.form-check-reverse .form-check-input {\n  float: right;\n  margin-right: -2.25rem;\n  margin-left: 0;\n}\n\n.form-check-input {\n  --bs-form-check-bg: transparent;\n  width: 1.75rem;\n  height: 1.75rem;\n  margin-top: -0.125rem;\n  vertical-align: top;\n  background-color: var(--bs-form-check-bg);\n  background-image: var(--bs-form-check-bg-image);\n  background-repeat: no-repeat;\n  background-position: center;\n  background-size: contain;\n  border: 1px solid var(--bs-gray-300);\n  appearance: none;\n  print-color-adjust: exact;\n}\n.form-check-input[type=checkbox] {\n  border-radius: 0.45em;\n}\n.form-check-input[type=radio] {\n  border-radius: 50%;\n}\n.form-check-input:active {\n  filter: brightness(90%);\n}\n.form-check-input:focus {\n  border-color: var(--bs-gray-400);\n  outline: 0;\n  box-shadow: none;\n}\n.form-check-input:checked {\n  background-color: #009ef7;\n  border-color: #009ef7;\n}\n.form-check-input:checked[type=checkbox] {\n  --bs-form-check-bg-image: url(\"data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 13 11' width='13' height='11' fill='none'%3e%3cpath d='M11.0426 1.02893C11.3258 0.695792 11.8254 0.655283 12.1585 0.938451C12.4917 1.22162 12.5322 1.72124 12.249 2.05437L5.51985 9.97104C5.23224 10.3094 4.72261 10.3451 4.3907 10.05L0.828197 6.88335C0.50141 6.59288 0.471975 6.09249 0.762452 5.7657C1.05293 5.43891 1.55332 5.40948 1.88011 5.69995L4.83765 8.32889L11.0426 1.02893Z' fill='%23ffffff'/%3e%3c/svg%3e\");\n}\n.form-check-input:checked[type=radio] {\n  --bs-form-check-bg-image: url(\"data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' viewBox='-4 -4 8 8'%3e%3ccircle r='2' fill='%23ffffff'/%3e%3c/svg%3e\");\n}\n.form-check-input[type=checkbox]:indeterminate {\n  background-color: #009ef7;\n  border-color: #009ef7;\n  --bs-form-check-bg-image: url(\"data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 20 20'%3e%3cpath fill='none' stroke='%23ffffff' stroke-linecap='round' stroke-linejoin='round' stroke-width='3' d='M6 10h8'/%3e%3c/svg%3e\");\n}\n.form-check-input:disabled {\n  pointer-events: none;\n  filter: none;\n  opacity: 0.5;\n}\n.form-check-input[disabled] ~ .form-check-label, .form-check-input:disabled ~ .form-check-label {\n  cursor: default;\n  opacity: 0.5;\n}\n\n.form-check-label {\n  color: var(--bs-gray-500);\n}\n\n.form-switch {\n  padding-left: 3.75rem;\n}\n.form-switch .form-check-input {\n  --bs-form-switch-bg: url(\"data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' viewBox='-4 -4 8 8'%3e%3ccircle r='3' fill='rgba%280, 0, 0, 0.25%29'/%3e%3c/svg%3e\");\n  width: 3.25rem;\n  margin-left: -3.75rem;\n  background-image: var(--bs-form-switch-bg);\n  background-position: left center;\n  border-radius: 3.25rem;\n  transition: background-position 0.15s ease-in-out;\n}\n@media (prefers-reduced-motion: reduce) {\n  .form-switch .form-check-input {\n    transition: none;\n  }\n}\n.form-switch .form-check-input:focus {\n  --bs-form-switch-bg: url(\"data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' viewBox='-4 -4 8 8'%3e%3ccircle r='3' fill='rgba%280, 0, 0, 0.25%29'/%3e%3c/svg%3e\");\n}\n.form-switch .form-check-input:checked {\n  background-position: right center;\n  --bs-form-switch-bg: url(\"data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' viewBox='-4 -4 8 8'%3e%3ccircle r='3' fill='%23ffffff'/%3e%3c/svg%3e\");\n}\n.form-switch.form-check-reverse {\n  padding-right: 3.75rem;\n  padding-left: 0;\n}\n.form-switch.form-check-reverse .form-check-input {\n  margin-right: -3.75rem;\n  margin-left: 0;\n}\n\n.form-check-inline {\n  display: inline-block;\n  margin-right: 1rem;\n}\n\n.btn-check {\n  position: absolute;\n  clip: rect(0, 0, 0, 0);\n  pointer-events: none;\n}\n.btn-check[disabled] + .btn, .btn-check:disabled + .btn {\n  pointer-events: none;\n  filter: none;\n  opacity: 0.65;\n}\n\n[data-bs-theme=dark] .form-switch .form-check-input:not(:checked):not(:focus) {\n  --bs-form-switch-bg: url(\"data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' viewBox='-4 -4 8 8'%3e%3ccircle r='3' fill='rgba%28255, 255, 255, 0.25%29'/%3e%3c/svg%3e\");\n}\n\n.form-range {\n  width: 100%;\n  height: 1.5rem;\n  padding: 0;\n  background-color: transparent;\n  appearance: none;\n}\n.form-range:focus {\n  outline: 0;\n}\n.form-range:focus::-webkit-slider-thumb {\n  box-shadow: 0 0 0 1px #ffffff, 0 0 0 0.25rem rgba(var(--bs-component-active-bg), 0.25);\n}\n.form-range:focus::-moz-range-thumb {\n  box-shadow: 0 0 0 1px #ffffff, 0 0 0 0.25rem rgba(var(--bs-component-active-bg), 0.25);\n}\n.form-range::-moz-focus-outer {\n  border: 0;\n}\n.form-range::-webkit-slider-thumb {\n  width: 1rem;\n  height: 1rem;\n  margin-top: -0.25rem;\n  background-color: #009ef7;\n  border: 0;\n  border-radius: 1rem;\n  box-shadow: 0 0.1rem 0.25rem rgba(0, 0, 0, 0.1);\n  transition: background-color 0.15s ease-in-out, border-color 0.15s ease-in-out, box-shadow 0.15s ease-in-out;\n  appearance: none;\n}\n@media (prefers-reduced-motion: reduce) {\n  .form-range::-webkit-slider-thumb {\n    transition: none;\n  }\n}\n.form-range::-webkit-slider-thumb:active {\n  background-color: #b3e2fd;\n}\n.form-range::-webkit-slider-runnable-track {\n  width: 100%;\n  height: 0.5rem;\n  color: transparent;\n  cursor: pointer;\n  background-color: var(--bs-gray-300);\n  border-color: transparent;\n  border-radius: 0.475rem;\n  box-shadow: inset 0 1px 2px rgba(0, 0, 0, 0.075);\n}\n.form-range::-moz-range-thumb {\n  width: 1rem;\n  height: 1rem;\n  background-color: #009ef7;\n  border: 0;\n  border-radius: 1rem;\n  box-shadow: 0 0.1rem 0.25rem rgba(0, 0, 0, 0.1);\n  transition: background-color 0.15s ease-in-out, border-color 0.15s ease-in-out, box-shadow 0.15s ease-in-out;\n  appearance: none;\n}\n@media (prefers-reduced-motion: reduce) {\n  .form-range::-moz-range-thumb {\n    transition: none;\n  }\n}\n.form-range::-moz-range-thumb:active {\n  background-color: #b3e2fd;\n}\n.form-range::-moz-range-track {\n  width: 100%;\n  height: 0.5rem;\n  color: transparent;\n  cursor: pointer;\n  background-color: var(--bs-gray-300);\n  border-color: transparent;\n  border-radius: 0.475rem;\n  box-shadow: inset 0 1px 2px rgba(0, 0, 0, 0.075);\n}\n.form-range:disabled {\n  pointer-events: none;\n}\n.form-range:disabled::-webkit-slider-thumb {\n  background-color: var(--bs-gray-500);\n}\n.form-range:disabled::-moz-range-thumb {\n  background-color: var(--bs-gray-500);\n}\n\n.form-floating {\n  position: relative;\n}\n.form-floating::before:not(.form-control:disabled) {\n  position: absolute;\n  top: 1px;\n  left: 1px;\n  width: calc(100% - (calc(calc(0.375em + 0.3875rem) + calc(0.75em + 0.775rem))));\n  height: 1.875em;\n  content: \"\";\n  background-color: var(--bs-body-bg);\n  border-radius: 0.475rem;\n}\n.form-floating > .form-control,\n.form-floating > .form-control-plaintext,\n.form-floating > .form-select {\n  height: calc(3.75rem + 2px);\n  line-height: 1.25;\n}\n.form-floating > label {\n  position: absolute;\n  top: 0;\n  left: 0;\n  width: 100%;\n  height: 100%;\n  padding: 1rem 1rem;\n  overflow: hidden;\n  text-align: start;\n  text-overflow: ellipsis;\n  white-space: nowrap;\n  pointer-events: none;\n  border: 1px solid transparent;\n  transform-origin: 0 0;\n  transition: opacity 0.1s ease-in-out, transform 0.1s ease-in-out;\n}\n@media (prefers-reduced-motion: reduce) {\n  .form-floating > label {\n    transition: none;\n  }\n}\n.form-floating > .form-control,\n.form-floating > .form-control-plaintext {\n  padding: 1rem 1rem;\n}\n.form-floating > .form-control::placeholder,\n.form-floating > .form-control-plaintext::placeholder {\n  color: transparent;\n}\n.form-floating > .form-control:focus, .form-floating > .form-control:not(:placeholder-shown),\n.form-floating > .form-control-plaintext:focus,\n.form-floating > .form-control-plaintext:not(:placeholder-shown) {\n  padding-top: 1.85rem;\n  padding-bottom: 0.625rem;\n}\n.form-floating > .form-control:-webkit-autofill,\n.form-floating > .form-control-plaintext:-webkit-autofill {\n  padding-top: 1.85rem;\n  padding-bottom: 0.625rem;\n}\n.form-floating > .form-select {\n  padding-top: 1.85rem;\n  padding-bottom: 0.625rem;\n}\n.form-floating > .form-control:focus ~ label,\n.form-floating > .form-control:not(:placeholder-shown) ~ label,\n.form-floating > .form-control-plaintext ~ label,\n.form-floating > .form-select ~ label {\n  opacity: 0.65;\n  transform: scale(0.85) translateY(-0.5rem) translateX(0.15rem);\n}\n.form-floating > .form-control:-webkit-autofill ~ label {\n  opacity: 0.65;\n  transform: scale(0.85) translateY(-0.5rem) translateX(0.15rem);\n}\n.form-floating > .form-control-plaintext ~ label {\n  border-width: 1px 0;\n}\n.form-floating > .form-control:disabled ~ label {\n  color: #7E8299;\n}\n\n.input-group {\n  position: relative;\n  display: flex;\n  flex-wrap: wrap;\n  align-items: stretch;\n  width: 100%;\n}\n.input-group > .form-control,\n.input-group > .form-select,\n.input-group > .form-floating {\n  position: relative;\n  flex: 1 1 auto;\n  width: 1%;\n  min-width: 0;\n}\n.input-group > .form-control:focus,\n.input-group > .form-select:focus,\n.input-group > .form-floating:focus-within {\n  z-index: 5;\n}\n.input-group .btn {\n  position: relative;\n  z-index: 2;\n}\n.input-group .btn:focus {\n  z-index: 5;\n}\n\n.input-group-text {\n  display: flex;\n  align-items: center;\n  padding: 0.775rem 1rem;\n  font-size: 1.1rem;\n  font-weight: 500;\n  line-height: 1.5;\n  color: var(--bs-gray-700);\n  text-align: center;\n  white-space: nowrap;\n  background-color: var(--bs-gray-100);\n  border: 1px solid var(--bs-gray-300);\n  border-radius: 0.475rem;\n}\n\n.input-group-lg > .form-control,\n.input-group-lg > .form-select,\n.input-group-lg > .input-group-text,\n.input-group-lg > .btn {\n  padding: 0.825rem 1.5rem;\n  font-size: 1.15rem;\n  border-radius: 0.625rem;\n}\n\n.input-group-sm > .form-control,\n.input-group-sm > .form-select,\n.input-group-sm > .input-group-text,\n.input-group-sm > .btn {\n  padding: 0.55rem 0.75rem;\n  font-size: 0.95rem;\n  border-radius: 0.425rem;\n}\n\n.input-group-lg > .form-select,\n.input-group-sm > .form-select {\n  padding-right: 4rem;\n}\n\n.input-group:not(.has-validation) > :not(:last-child):not(.dropdown-toggle):not(.dropdown-menu):not(.form-floating),\n.input-group:not(.has-validation) > .dropdown-toggle:nth-last-child(n+3),\n.input-group:not(.has-validation) > .form-floating:not(:last-child) > .form-control,\n.input-group:not(.has-validation) > .form-floating:not(:last-child) > .form-select {\n  border-top-right-radius: 0;\n  border-bottom-right-radius: 0;\n}\n.input-group.has-validation > :nth-last-child(n+3):not(.dropdown-toggle):not(.dropdown-menu):not(.form-floating),\n.input-group.has-validation > .dropdown-toggle:nth-last-child(n+4),\n.input-group.has-validation > .form-floating:nth-last-child(n+3) > .form-control,\n.input-group.has-validation > .form-floating:nth-last-child(n+3) > .form-select {\n  border-top-right-radius: 0;\n  border-bottom-right-radius: 0;\n}\n.input-group > :not(:first-child):not(.dropdown-menu):not(.valid-tooltip):not(.valid-feedback):not(.invalid-tooltip):not(.invalid-feedback) {\n  margin-left: -1px;\n  border-top-left-radius: 0;\n  border-bottom-left-radius: 0;\n}\n.input-group > .form-floating:not(:first-child) > .form-control,\n.input-group > .form-floating:not(:first-child) > .form-select {\n  border-top-left-radius: 0;\n  border-bottom-left-radius: 0;\n}\n\n.valid-feedback {\n  display: none;\n  width: 100%;\n  margin-top: 0.5rem;\n  font-size: 0.95rem;\n  color: var(--bs-success-text);\n}\n\n.valid-tooltip {\n  position: absolute;\n  top: 100%;\n  z-index: 5;\n  display: none;\n  max-width: 100%;\n  padding: 0.75rem 1rem;\n  margin-top: 0.1rem;\n  font-size: 1rem;\n  color: #fff;\n  background-color: var(--bs-success);\n  border-radius: 0.475rem;\n}\n\n.was-validated :valid ~ .valid-feedback,\n.was-validated :valid ~ .valid-tooltip,\n.is-valid ~ .valid-feedback,\n.is-valid ~ .valid-tooltip {\n  display: block;\n}\n\n.was-validated .form-control:valid, .form-control.is-valid {\n  border-color: var(--bs-success);\n  padding-right: calc(1.5em + 1.55rem);\n  background-image: url(\"data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 8 8'%3e%3cpath fill='%2350cd89' d='M2.3 6.73.6 4.53c-.4-1.04.46-1.4 1.1-.8l1.1 1.4 3.4-3.8c.6-.63 1.6-.27 1.2.7l-4 4.6c-.43.5-.8.4-1.1.1z'/%3e%3c/svg%3e\");\n  background-repeat: no-repeat;\n  background-position: right calc(0.375em + 0.3875rem) center;\n  background-size: calc(0.75em + 0.775rem) calc(0.75em + 0.775rem);\n}\n.was-validated .form-control:valid:focus, .form-control.is-valid:focus {\n  border-color: var(--bs-success);\n  box-shadow: 0 0 0 0.25rem rgba(var(--bs-success-rgb), 0.25);\n}\n\n.was-validated textarea.form-control:valid, textarea.form-control.is-valid {\n  padding-right: calc(1.5em + 1.55rem);\n  background-position: top calc(0.375em + 0.3875rem) right calc(0.375em + 0.3875rem);\n}\n\n.was-validated .form-select:valid, .form-select.is-valid {\n  border-color: var(--bs-success);\n}\n.was-validated .form-select:valid:not([multiple]):not([size]), .was-validated .form-select:valid:not([multiple])[size=\"1\"], .form-select.is-valid:not([multiple]):not([size]), .form-select.is-valid:not([multiple])[size=\"1\"] {\n  --bs-form-select-bg-icon: url(\"data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 8 8'%3e%3cpath fill='%2350cd89' d='M2.3 6.73.6 4.53c-.4-1.04.46-1.4 1.1-.8l1.1 1.4 3.4-3.8c.6-.63 1.6-.27 1.2.7l-4 4.6c-.43.5-.8.4-1.1.1z'/%3e%3c/svg%3e\");\n  padding-right: 5.5rem;\n  background-position: right 1rem center, center right 3rem;\n  background-size: 16px 12px, calc(0.75em + 0.775rem) calc(0.75em + 0.775rem);\n}\n.was-validated .form-select:valid:focus, .form-select.is-valid:focus {\n  border-color: var(--bs-success);\n  box-shadow: 0 0 0 0.25rem rgba(var(--bs-success-rgb), 0.25);\n}\n\n.was-validated .form-control-color:valid, .form-control-color.is-valid {\n  width: calc(3rem + calc(1.5em + 1.55rem));\n}\n\n.was-validated .form-check-input:valid, .form-check-input.is-valid {\n  border-color: var(--bs-success);\n}\n.was-validated .form-check-input:valid:checked, .form-check-input.is-valid:checked {\n  background-color: var(--bs-success-text);\n}\n.was-validated .form-check-input:valid:focus, .form-check-input.is-valid:focus {\n  box-shadow: 0 0 0 0.25rem rgba(var(--bs-success-rgb), 0.25);\n}\n.was-validated .form-check-input:valid ~ .form-check-label, .form-check-input.is-valid ~ .form-check-label {\n  color: var(--bs-success-text);\n}\n\n.form-check-inline .form-check-input ~ .valid-feedback {\n  margin-left: 0.5em;\n}\n\n.was-validated .input-group > .form-control:not(:focus):valid, .input-group > .form-control:not(:focus).is-valid,\n.was-validated .input-group > .form-select:not(:focus):valid,\n.input-group > .form-select:not(:focus).is-valid,\n.was-validated .input-group > .form-floating:not(:focus-within):valid,\n.input-group > .form-floating:not(:focus-within).is-valid {\n  z-index: 3;\n}\n\n.invalid-feedback {\n  display: none;\n  width: 100%;\n  margin-top: 0.5rem;\n  font-size: 0.95rem;\n  color: var(--bs-danger-text);\n}\n\n.invalid-tooltip {\n  position: absolute;\n  top: 100%;\n  z-index: 5;\n  display: none;\n  max-width: 100%;\n  padding: 0.75rem 1rem;\n  margin-top: 0.1rem;\n  font-size: 1rem;\n  color: #fff;\n  background-color: var(--bs-danger);\n  border-radius: 0.475rem;\n}\n\n.was-validated :invalid ~ .invalid-feedback,\n.was-validated :invalid ~ .invalid-tooltip,\n.is-invalid ~ .invalid-feedback,\n.is-invalid ~ .invalid-tooltip {\n  display: block;\n}\n\n.was-validated .form-control:invalid, .form-control.is-invalid {\n  border-color: var(--bs-danger);\n  padding-right: calc(1.5em + 1.55rem);\n  background-image: url(\"data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 12 12' width='12' height='12' fill='none' stroke='%23f1416c'%3e%3ccircle cx='6' cy='6' r='4.5'/%3e%3cpath stroke-linejoin='round' d='M5.8 3.6h.4L6 6.5z'/%3e%3ccircle cx='6' cy='8.2' r='.6' fill='%23f1416c' stroke='none'/%3e%3c/svg%3e\");\n  background-repeat: no-repeat;\n  background-position: right calc(0.375em + 0.3875rem) center;\n  background-size: calc(0.75em + 0.775rem) calc(0.75em + 0.775rem);\n}\n.was-validated .form-control:invalid:focus, .form-control.is-invalid:focus {\n  border-color: var(--bs-danger);\n  box-shadow: 0 0 0 0.25rem rgba(var(--bs-danger-rgb), 0.25);\n}\n\n.was-validated textarea.form-control:invalid, textarea.form-control.is-invalid {\n  padding-right: calc(1.5em + 1.55rem);\n  background-position: top calc(0.375em + 0.3875rem) right calc(0.375em + 0.3875rem);\n}\n\n.was-validated .form-select:invalid, .form-select.is-invalid {\n  border-color: var(--bs-danger);\n}\n.was-validated .form-select:invalid:not([multiple]):not([size]), .was-validated .form-select:invalid:not([multiple])[size=\"1\"], .form-select.is-invalid:not([multiple]):not([size]), .form-select.is-invalid:not([multiple])[size=\"1\"] {\n  --bs-form-select-bg-icon: url(\"data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 12 12' width='12' height='12' fill='none' stroke='%23f1416c'%3e%3ccircle cx='6' cy='6' r='4.5'/%3e%3cpath stroke-linejoin='round' d='M5.8 3.6h.4L6 6.5z'/%3e%3ccircle cx='6' cy='8.2' r='.6' fill='%23f1416c' stroke='none'/%3e%3c/svg%3e\");\n  padding-right: 5.5rem;\n  background-position: right 1rem center, center right 3rem;\n  background-size: 16px 12px, calc(0.75em + 0.775rem) calc(0.75em + 0.775rem);\n}\n.was-validated .form-select:invalid:focus, .form-select.is-invalid:focus {\n  border-color: var(--bs-danger);\n  box-shadow: 0 0 0 0.25rem rgba(var(--bs-danger-rgb), 0.25);\n}\n\n.was-validated .form-control-color:invalid, .form-control-color.is-invalid {\n  width: calc(3rem + calc(1.5em + 1.55rem));\n}\n\n.was-validated .form-check-input:invalid, .form-check-input.is-invalid {\n  border-color: var(--bs-danger);\n}\n.was-validated .form-check-input:invalid:checked, .form-check-input.is-invalid:checked {\n  background-color: var(--bs-danger-text);\n}\n.was-validated .form-check-input:invalid:focus, .form-check-input.is-invalid:focus {\n  box-shadow: 0 0 0 0.25rem rgba(var(--bs-danger-rgb), 0.25);\n}\n.was-validated .form-check-input:invalid ~ .form-check-label, .form-check-input.is-invalid ~ .form-check-label {\n  color: var(--bs-danger-text);\n}\n\n.form-check-inline .form-check-input ~ .invalid-feedback {\n  margin-left: 0.5em;\n}\n\n.was-validated .input-group > .form-control:not(:focus):invalid, .input-group > .form-control:not(:focus).is-invalid,\n.was-validated .input-group > .form-select:not(:focus):invalid,\n.input-group > .form-select:not(:focus).is-invalid,\n.was-validated .input-group > .form-floating:not(:focus-within):invalid,\n.input-group > .form-floating:not(:focus-within).is-invalid {\n  z-index: 4;\n}\n\n.btn {\n  --bs-btn-padding-x: 1.5rem;\n  --bs-btn-padding-y: 0.775rem;\n  --bs-btn-font-family: ;\n  --bs-btn-font-size: 1.1rem;\n  --bs-btn-font-weight: 500;\n  --bs-btn-line-height: 1.5;\n  --bs-btn-color: #181C32;\n  --bs-btn-bg: transparent;\n  --bs-btn-border-width: 1px;\n  --bs-btn-border-color: transparent;\n  --bs-btn-border-radius: 0.475rem;\n  --bs-btn-hover-border-color: transparent;\n  --bs-btn-box-shadow: inset 0 1px 0 rgba(255, 255, 255, 0.15), 0 1px 1px rgba(0, 0, 0, 0.075);\n  --bs-btn-disabled-opacity: 0.65;\n  --bs-btn-focus-box-shadow: 0 0 0 0.25rem rgba(var(--bs-btn-focus-shadow-rgb), .5);\n  display: inline-block;\n  padding: var(--bs-btn-padding-y) var(--bs-btn-padding-x);\n  font-family: var(--bs-btn-font-family);\n  font-size: var(--bs-btn-font-size);\n  font-weight: var(--bs-btn-font-weight);\n  line-height: var(--bs-btn-line-height);\n  color: var(--bs-btn-color);\n  text-align: center;\n  vertical-align: middle;\n  cursor: pointer;\n  user-select: none;\n  border: var(--bs-btn-border-width) solid var(--bs-btn-border-color);\n  border-radius: var(--bs-btn-border-radius);\n  background-color: var(--bs-btn-bg);\n  box-shadow: var(--bs-btn-box-shadow);\n  transition: color 0.15s ease-in-out, background-color 0.15s ease-in-out, border-color 0.15s ease-in-out, box-shadow 0.15s ease-in-out;\n}\n@media (prefers-reduced-motion: reduce) {\n  .btn {\n    transition: none;\n  }\n}\n.btn:hover {\n  color: var(--bs-btn-hover-color);\n  background-color: var(--bs-btn-hover-bg);\n  border-color: var(--bs-btn-hover-border-color);\n}\n.btn-check + .btn:hover {\n  color: var(--bs-btn-color);\n  background-color: var(--bs-btn-bg);\n  border-color: var(--bs-btn-border-color);\n}\n.btn:focus-visible {\n  color: var(--bs-btn-hover-color);\n  background-color: var(--bs-btn-hover-bg);\n  border-color: var(--bs-btn-hover-border-color);\n  outline: 0;\n  box-shadow: var(--bs-btn-box-shadow), var(--bs-btn-focus-box-shadow);\n}\n.btn-check:focus-visible + .btn {\n  border-color: var(--bs-btn-hover-border-color);\n  outline: 0;\n  box-shadow: var(--bs-btn-box-shadow), var(--bs-btn-focus-box-shadow);\n}\n.btn-check:checked + .btn, :not(.btn-check) + .btn:active, .btn:first-child:active, .btn.active, .btn.show {\n  color: var(--bs-btn-active-color);\n  background-color: var(--bs-btn-active-bg);\n  border-color: var(--bs-btn-active-border-color);\n  box-shadow: var(--bs-btn-active-shadow);\n}\n.btn-check:checked + .btn:focus-visible, :not(.btn-check) + .btn:active:focus-visible, .btn:first-child:active:focus-visible, .btn.active:focus-visible, .btn.show:focus-visible {\n  box-shadow: var(--bs-btn-active-shadow), var(--bs-btn-focus-box-shadow);\n}\n.btn:disabled, .btn.disabled, fieldset:disabled .btn {\n  color: var(--bs-btn-disabled-color);\n  pointer-events: none;\n  background-color: var(--bs-btn-disabled-bg);\n  border-color: var(--bs-btn-disabled-border-color);\n  opacity: var(--bs-btn-disabled-opacity);\n  box-shadow: none;\n}\n\n.btn-light {\n  --bs-btn-color: #000000;\n  --bs-btn-bg: #F9F9F9;\n  --bs-btn-border-color: #F9F9F9;\n  --bs-btn-hover-color: #000000;\n  --bs-btn-hover-bg: #d4d4d4;\n  --bs-btn-hover-border-color: #c7c7c7;\n  --bs-btn-focus-shadow-rgb: 212, 212, 212;\n  --bs-btn-active-color: #000000;\n  --bs-btn-active-bg: #c7c7c7;\n  --bs-btn-active-border-color: #bbbbbb;\n  --bs-btn-active-shadow: inset 0 3px 5px rgba(0, 0, 0, 0.125);\n  --bs-btn-disabled-color: #000000;\n  --bs-btn-disabled-bg: #F9F9F9;\n  --bs-btn-disabled-border-color: #F9F9F9;\n}\n\n.btn-primary {\n  --bs-btn-color: #000000;\n  --bs-btn-bg: #009ef7;\n  --bs-btn-border-color: #009ef7;\n  --bs-btn-hover-color: #000000;\n  --bs-btn-hover-bg: #26adf8;\n  --bs-btn-hover-border-color: #1aa8f8;\n  --bs-btn-focus-shadow-rgb: 0, 134, 210;\n  --bs-btn-active-color: #000000;\n  --bs-btn-active-bg: #33b1f9;\n  --bs-btn-active-border-color: #1aa8f8;\n  --bs-btn-active-shadow: inset 0 3px 5px rgba(0, 0, 0, 0.125);\n  --bs-btn-disabled-color: #000000;\n  --bs-btn-disabled-bg: #009ef7;\n  --bs-btn-disabled-border-color: #009ef7;\n}\n\n.btn-secondary {\n  --bs-btn-color: #000000;\n  --bs-btn-bg: #E1E3EA;\n  --bs-btn-border-color: #E1E3EA;\n  --bs-btn-hover-color: #000000;\n  --bs-btn-hover-bg: #e6e7ed;\n  --bs-btn-hover-border-color: #e4e6ec;\n  --bs-btn-focus-shadow-rgb: 191, 193, 199;\n  --bs-btn-active-color: #000000;\n  --bs-btn-active-bg: #e7e9ee;\n  --bs-btn-active-border-color: #e4e6ec;\n  --bs-btn-active-shadow: inset 0 3px 5px rgba(0, 0, 0, 0.125);\n  --bs-btn-disabled-color: #000000;\n  --bs-btn-disabled-bg: #E1E3EA;\n  --bs-btn-disabled-border-color: #E1E3EA;\n}\n\n.btn-success {\n  --bs-btn-color: #000000;\n  --bs-btn-bg: #50cd89;\n  --bs-btn-border-color: #50cd89;\n  --bs-btn-hover-color: #000000;\n  --bs-btn-hover-bg: #6ad59b;\n  --bs-btn-hover-border-color: #62d295;\n  --bs-btn-focus-shadow-rgb: 68, 174, 116;\n  --bs-btn-active-color: #000000;\n  --bs-btn-active-bg: #73d7a1;\n  --bs-btn-active-border-color: #62d295;\n  --bs-btn-active-shadow: inset 0 3px 5px rgba(0, 0, 0, 0.125);\n  --bs-btn-disabled-color: #000000;\n  --bs-btn-disabled-bg: #50cd89;\n  --bs-btn-disabled-border-color: #50cd89;\n}\n\n.btn-info {\n  --bs-btn-color: #ffffff;\n  --bs-btn-bg: #7239ea;\n  --bs-btn-border-color: #7239ea;\n  --bs-btn-hover-color: #ffffff;\n  --bs-btn-hover-bg: #6130c7;\n  --bs-btn-hover-border-color: #5b2ebb;\n  --bs-btn-focus-shadow-rgb: 135, 87, 237;\n  --bs-btn-active-color: #ffffff;\n  --bs-btn-active-bg: #5b2ebb;\n  --bs-btn-active-border-color: #562bb0;\n  --bs-btn-active-shadow: inset 0 3px 5px rgba(0, 0, 0, 0.125);\n  --bs-btn-disabled-color: #ffffff;\n  --bs-btn-disabled-bg: #7239ea;\n  --bs-btn-disabled-border-color: #7239ea;\n}\n\n.btn-warning {\n  --bs-btn-color: #000000;\n  --bs-btn-bg: #ffc700;\n  --bs-btn-border-color: #ffc700;\n  --bs-btn-hover-color: #000000;\n  --bs-btn-hover-bg: #ffcf26;\n  --bs-btn-hover-border-color: #ffcd1a;\n  --bs-btn-focus-shadow-rgb: 217, 169, 0;\n  --bs-btn-active-color: #000000;\n  --bs-btn-active-bg: #ffd233;\n  --bs-btn-active-border-color: #ffcd1a;\n  --bs-btn-active-shadow: inset 0 3px 5px rgba(0, 0, 0, 0.125);\n  --bs-btn-disabled-color: #000000;\n  --bs-btn-disabled-bg: #ffc700;\n  --bs-btn-disabled-border-color: #ffc700;\n}\n\n.btn-danger {\n  --bs-btn-color: #000000;\n  --bs-btn-bg: #f1416c;\n  --bs-btn-border-color: #f1416c;\n  --bs-btn-hover-color: #000000;\n  --bs-btn-hover-bg: #f35e82;\n  --bs-btn-hover-border-color: #f2547b;\n  --bs-btn-focus-shadow-rgb: 205, 55, 92;\n  --bs-btn-active-color: #000000;\n  --bs-btn-active-bg: #f46789;\n  --bs-btn-active-border-color: #f2547b;\n  --bs-btn-active-shadow: inset 0 3px 5px rgba(0, 0, 0, 0.125);\n  --bs-btn-disabled-color: #000000;\n  --bs-btn-disabled-bg: #f1416c;\n  --bs-btn-disabled-border-color: #f1416c;\n}\n\n.btn-dark {\n  --bs-btn-color: #ffffff;\n  --bs-btn-bg: #181C32;\n  --bs-btn-border-color: #181C32;\n  --bs-btn-hover-color: #ffffff;\n  --bs-btn-hover-bg: #3b3e51;\n  --bs-btn-hover-border-color: #2f3347;\n  --bs-btn-focus-shadow-rgb: 59, 62, 81;\n  --bs-btn-active-color: #ffffff;\n  --bs-btn-active-bg: #46495b;\n  --bs-btn-active-border-color: #2f3347;\n  --bs-btn-active-shadow: inset 0 3px 5px rgba(0, 0, 0, 0.125);\n  --bs-btn-disabled-color: #ffffff;\n  --bs-btn-disabled-bg: #181C32;\n  --bs-btn-disabled-border-color: #181C32;\n}\n\n.btn-outline-light {\n  --bs-btn-color: #F9F9F9;\n  --bs-btn-border-color: #F9F9F9;\n  --bs-btn-hover-color: #000000;\n  --bs-btn-hover-bg: #F9F9F9;\n  --bs-btn-hover-border-color: #F9F9F9;\n  --bs-btn-focus-shadow-rgb: 249, 249, 249;\n  --bs-btn-active-color: #000000;\n  --bs-btn-active-bg: #F9F9F9;\n  --bs-btn-active-border-color: #F9F9F9;\n  --bs-btn-active-shadow: inset 0 3px 5px rgba(0, 0, 0, 0.125);\n  --bs-btn-disabled-color: #F9F9F9;\n  --bs-btn-disabled-bg: transparent;\n  --bs-btn-disabled-border-color: #F9F9F9;\n  --bs-gradient: none;\n}\n\n.btn-outline-primary {\n  --bs-btn-color: #009ef7;\n  --bs-btn-border-color: #009ef7;\n  --bs-btn-hover-color: #000000;\n  --bs-btn-hover-bg: #009ef7;\n  --bs-btn-hover-border-color: #009ef7;\n  --bs-btn-focus-shadow-rgb: 0, 158, 247;\n  --bs-btn-active-color: #000000;\n  --bs-btn-active-bg: #009ef7;\n  --bs-btn-active-border-color: #009ef7;\n  --bs-btn-active-shadow: inset 0 3px 5px rgba(0, 0, 0, 0.125);\n  --bs-btn-disabled-color: #009ef7;\n  --bs-btn-disabled-bg: transparent;\n  --bs-btn-disabled-border-color: #009ef7;\n  --bs-gradient: none;\n}\n\n.btn-outline-secondary {\n  --bs-btn-color: #E1E3EA;\n  --bs-btn-border-color: #E1E3EA;\n  --bs-btn-hover-color: #000000;\n  --bs-btn-hover-bg: #E1E3EA;\n  --bs-btn-hover-border-color: #E1E3EA;\n  --bs-btn-focus-shadow-rgb: 225, 227, 234;\n  --bs-btn-active-color: #000000;\n  --bs-btn-active-bg: #E1E3EA;\n  --bs-btn-active-border-color: #E1E3EA;\n  --bs-btn-active-shadow: inset 0 3px 5px rgba(0, 0, 0, 0.125);\n  --bs-btn-disabled-color: #E1E3EA;\n  --bs-btn-disabled-bg: transparent;\n  --bs-btn-disabled-border-color: #E1E3EA;\n  --bs-gradient: none;\n}\n\n.btn-outline-success {\n  --bs-btn-color: #50cd89;\n  --bs-btn-border-color: #50cd89;\n  --bs-btn-hover-color: #000000;\n  --bs-btn-hover-bg: #50cd89;\n  --bs-btn-hover-border-color: #50cd89;\n  --bs-btn-focus-shadow-rgb: 80, 205, 137;\n  --bs-btn-active-color: #000000;\n  --bs-btn-active-bg: #50cd89;\n  --bs-btn-active-border-color: #50cd89;\n  --bs-btn-active-shadow: inset 0 3px 5px rgba(0, 0, 0, 0.125);\n  --bs-btn-disabled-color: #50cd89;\n  --bs-btn-disabled-bg: transparent;\n  --bs-btn-disabled-border-color: #50cd89;\n  --bs-gradient: none;\n}\n\n.btn-outline-info {\n  --bs-btn-color: #7239ea;\n  --bs-btn-border-color: #7239ea;\n  --bs-btn-hover-color: #ffffff;\n  --bs-btn-hover-bg: #7239ea;\n  --bs-btn-hover-border-color: #7239ea;\n  --bs-btn-focus-shadow-rgb: 114, 57, 234;\n  --bs-btn-active-color: #ffffff;\n  --bs-btn-active-bg: #7239ea;\n  --bs-btn-active-border-color: #7239ea;\n  --bs-btn-active-shadow: inset 0 3px 5px rgba(0, 0, 0, 0.125);\n  --bs-btn-disabled-color: #7239ea;\n  --bs-btn-disabled-bg: transparent;\n  --bs-btn-disabled-border-color: #7239ea;\n  --bs-gradient: none;\n}\n\n.btn-outline-warning {\n  --bs-btn-color: #ffc700;\n  --bs-btn-border-color: #ffc700;\n  --bs-btn-hover-color: #000000;\n  --bs-btn-hover-bg: #ffc700;\n  --bs-btn-hover-border-color: #ffc700;\n  --bs-btn-focus-shadow-rgb: 255, 199, 0;\n  --bs-btn-active-color: #000000;\n  --bs-btn-active-bg: #ffc700;\n  --bs-btn-active-border-color: #ffc700;\n  --bs-btn-active-shadow: inset 0 3px 5px rgba(0, 0, 0, 0.125);\n  --bs-btn-disabled-color: #ffc700;\n  --bs-btn-disabled-bg: transparent;\n  --bs-btn-disabled-border-color: #ffc700;\n  --bs-gradient: none;\n}\n\n.btn-outline-danger {\n  --bs-btn-color: #f1416c;\n  --bs-btn-border-color: #f1416c;\n  --bs-btn-hover-color: #000000;\n  --bs-btn-hover-bg: #f1416c;\n  --bs-btn-hover-border-color: #f1416c;\n  --bs-btn-focus-shadow-rgb: 241, 65, 108;\n  --bs-btn-active-color: #000000;\n  --bs-btn-active-bg: #f1416c;\n  --bs-btn-active-border-color: #f1416c;\n  --bs-btn-active-shadow: inset 0 3px 5px rgba(0, 0, 0, 0.125);\n  --bs-btn-disabled-color: #f1416c;\n  --bs-btn-disabled-bg: transparent;\n  --bs-btn-disabled-border-color: #f1416c;\n  --bs-gradient: none;\n}\n\n.btn-outline-dark {\n  --bs-btn-color: #181C32;\n  --bs-btn-border-color: #181C32;\n  --bs-btn-hover-color: #ffffff;\n  --bs-btn-hover-bg: #181C32;\n  --bs-btn-hover-border-color: #181C32;\n  --bs-btn-focus-shadow-rgb: 24, 28, 50;\n  --bs-btn-active-color: #ffffff;\n  --bs-btn-active-bg: #181C32;\n  --bs-btn-active-border-color: #181C32;\n  --bs-btn-active-shadow: inset 0 3px 5px rgba(0, 0, 0, 0.125);\n  --bs-btn-disabled-color: #181C32;\n  --bs-btn-disabled-bg: transparent;\n  --bs-btn-disabled-border-color: #181C32;\n  --bs-gradient: none;\n}\n\n.btn-link {\n  --bs-btn-font-weight: 400;\n  --bs-btn-color: var(--bs-link-color);\n  --bs-btn-bg: transparent;\n  --bs-btn-border-color: transparent;\n  --bs-btn-hover-color: var(--bs-link-hover-color);\n  --bs-btn-hover-border-color: transparent;\n  --bs-btn-active-color: var(--bs-link-hover-color);\n  --bs-btn-active-border-color: transparent;\n  --bs-btn-disabled-color: var(--bs-gray-600);\n  --bs-btn-disabled-border-color: transparent;\n  --bs-btn-box-shadow: none;\n  --bs-btn-focus-shadow-rgb: 0, 134, 210;\n  text-decoration: none;\n}\n.btn-link:hover, .btn-link:focus-visible {\n  text-decoration: none;\n}\n.btn-link:focus-visible {\n  color: var(--bs-btn-color);\n}\n.btn-link:hover {\n  color: var(--bs-btn-hover-color);\n}\n\n.btn-lg, .btn-group-lg > .btn {\n  --bs-btn-padding-y: 0.825rem;\n  --bs-btn-padding-x: 1.75rem;\n  --bs-btn-font-size: 1.15rem;\n  --bs-btn-border-radius: 0.625rem;\n}\n\n.btn-sm, .btn-group-sm > .btn {\n  --bs-btn-padding-y: 0.55rem;\n  --bs-btn-padding-x: 1.25rem;\n  --bs-btn-font-size: 0.95rem;\n  --bs-btn-border-radius: 0.425rem;\n}\n\n.fade {\n  transition: opacity 0.15s linear;\n}\n@media (prefers-reduced-motion: reduce) {\n  .fade {\n    transition: none;\n  }\n}\n.fade:not(.show) {\n  opacity: 0;\n}\n\n.collapse:not(.show) {\n  display: none;\n}\n\n.collapsing {\n  height: 0;\n  overflow: hidden;\n  transition: height 0.35s ease;\n}\n@media (prefers-reduced-motion: reduce) {\n  .collapsing {\n    transition: none;\n  }\n}\n.collapsing.collapse-horizontal {\n  width: 0;\n  height: auto;\n  transition: width 0.35s ease;\n}\n@media (prefers-reduced-motion: reduce) {\n  .collapsing.collapse-horizontal {\n    transition: none;\n  }\n}\n\n.dropup,\n.dropend,\n.dropdown,\n.dropstart,\n.dropup-center,\n.dropdown-center {\n  position: relative;\n}\n\n.dropdown-toggle {\n  white-space: nowrap;\n}\n.dropdown-toggle::after {\n  display: inline-block;\n  margin-left: 0.255em;\n  vertical-align: 0.255em;\n  content: \"\";\n  border-top: 0.3em solid;\n  border-right: 0.3em solid transparent;\n  border-bottom: 0;\n  border-left: 0.3em solid transparent;\n}\n.dropdown-toggle:empty::after {\n  margin-left: 0;\n}\n\n.dropdown-menu {\n  --bs-dropdown-zindex: 1000;\n  --bs-dropdown-min-width: 10rem;\n  --bs-dropdown-padding-x: 0;\n  --bs-dropdown-padding-y: 0.5rem;\n  --bs-dropdown-spacer: 0.125rem;\n  --bs-dropdown-font-size: 1rem;\n  --bs-dropdown-color: var(--bs-body-color);\n  --bs-dropdown-bg: var(--bs-body-bg);\n  --bs-dropdown-border-color: var(--bs-border-color-translucent);\n  --bs-dropdown-border-radius: 0.475rem;\n  --bs-dropdown-border-width: 0rem;\n  --bs-dropdown-inner-border-radius: 0.475rem;\n  --bs-dropdown-divider-bg: var(--bs-gray-100);\n  --bs-dropdown-divider-margin-y: 0.5rem;\n  --bs-dropdown-box-shadow: 0px 0px 50px 0px rgba(82, 63, 105, 0.15);\n  --bs-dropdown-link-color: var(--bs-gray-900);\n  --bs-dropdown-link-hover-color: var(--bs-gray-900);\n  --bs-dropdown-link-hover-bg: var(--bs-tertiary-bg);\n  --bs-dropdown-link-active-color: var(--bs-component-hover-color);\n  --bs-dropdown-link-active-bg: var(--bs-component-hover-bg);\n  --bs-dropdown-link-disabled-color: var(--bs-gray-500);\n  --bs-dropdown-item-padding-x: 0.85rem;\n  --bs-dropdown-item-padding-y: 0.65rem;\n  --bs-dropdown-header-color: var(--bs-gray-600);\n  --bs-dropdown-header-padding-x: 0.85rem;\n  --bs-dropdown-header-padding-y: 0.5rem;\n  position: absolute;\n  z-index: var(--bs-dropdown-zindex);\n  display: none;\n  min-width: var(--bs-dropdown-min-width);\n  padding: var(--bs-dropdown-padding-y) var(--bs-dropdown-padding-x);\n  margin: 0;\n  font-size: var(--bs-dropdown-font-size);\n  color: var(--bs-dropdown-color);\n  text-align: left;\n  list-style: none;\n  background-color: var(--bs-dropdown-bg);\n  background-clip: padding-box;\n  border: var(--bs-dropdown-border-width) solid var(--bs-dropdown-border-color);\n  border-radius: var(--bs-dropdown-border-radius);\n  box-shadow: var(--bs-dropdown-box-shadow);\n}\n.dropdown-menu[data-bs-popper] {\n  top: 100%;\n  left: 0;\n  margin-top: var(--bs-dropdown-spacer);\n}\n\n.dropdown-menu-start {\n  --bs-position: start;\n}\n.dropdown-menu-start[data-bs-popper] {\n  right: auto;\n  left: 0;\n}\n\n.dropdown-menu-end {\n  --bs-position: end;\n}\n.dropdown-menu-end[data-bs-popper] {\n  right: 0;\n  left: auto;\n}\n\n@media (min-width: 576px) {\n  .dropdown-menu-sm-start {\n    --bs-position: start;\n  }\n  .dropdown-menu-sm-start[data-bs-popper] {\n    right: auto;\n    left: 0;\n  }\n  .dropdown-menu-sm-end {\n    --bs-position: end;\n  }\n  .dropdown-menu-sm-end[data-bs-popper] {\n    right: 0;\n    left: auto;\n  }\n}\n@media (min-width: 768px) {\n  .dropdown-menu-md-start {\n    --bs-position: start;\n  }\n  .dropdown-menu-md-start[data-bs-popper] {\n    right: auto;\n    left: 0;\n  }\n  .dropdown-menu-md-end {\n    --bs-position: end;\n  }\n  .dropdown-menu-md-end[data-bs-popper] {\n    right: 0;\n    left: auto;\n  }\n}\n@media (min-width: 992px) {\n  .dropdown-menu-lg-start {\n    --bs-position: start;\n  }\n  .dropdown-menu-lg-start[data-bs-popper] {\n    right: auto;\n    left: 0;\n  }\n  .dropdown-menu-lg-end {\n    --bs-position: end;\n  }\n  .dropdown-menu-lg-end[data-bs-popper] {\n    right: 0;\n    left: auto;\n  }\n}\n@media (min-width: 1200px) {\n  .dropdown-menu-xl-start {\n    --bs-position: start;\n  }\n  .dropdown-menu-xl-start[data-bs-popper] {\n    right: auto;\n    left: 0;\n  }\n  .dropdown-menu-xl-end {\n    --bs-position: end;\n  }\n  .dropdown-menu-xl-end[data-bs-popper] {\n    right: 0;\n    left: auto;\n  }\n}\n@media (min-width: 1400px) {\n  .dropdown-menu-xxl-start {\n    --bs-position: start;\n  }\n  .dropdown-menu-xxl-start[data-bs-popper] {\n    right: auto;\n    left: 0;\n  }\n  .dropdown-menu-xxl-end {\n    --bs-position: end;\n  }\n  .dropdown-menu-xxl-end[data-bs-popper] {\n    right: 0;\n    left: auto;\n  }\n}\n.dropup .dropdown-menu[data-bs-popper] {\n  top: auto;\n  bottom: 100%;\n  margin-top: 0;\n  margin-bottom: var(--bs-dropdown-spacer);\n}\n.dropup .dropdown-toggle::after {\n  display: inline-block;\n  margin-left: 0.255em;\n  vertical-align: 0.255em;\n  content: \"\";\n  border-top: 0;\n  border-right: 0.3em solid transparent;\n  border-bottom: 0.3em solid;\n  border-left: 0.3em solid transparent;\n}\n.dropup .dropdown-toggle:empty::after {\n  margin-left: 0;\n}\n\n.dropend .dropdown-menu[data-bs-popper] {\n  top: 0;\n  right: auto;\n  left: 100%;\n  margin-top: 0;\n  margin-left: var(--bs-dropdown-spacer);\n}\n.dropend .dropdown-toggle::after {\n  display: inline-block;\n  margin-left: 0.255em;\n  vertical-align: 0.255em;\n  content: \"\";\n  border-top: 0.3em solid transparent;\n  border-right: 0;\n  border-bottom: 0.3em solid transparent;\n  border-left: 0.3em solid;\n}\n.dropend .dropdown-toggle:empty::after {\n  margin-left: 0;\n}\n.dropend .dropdown-toggle::after {\n  vertical-align: 0;\n}\n\n.dropstart .dropdown-menu[data-bs-popper] {\n  top: 0;\n  right: 100%;\n  left: auto;\n  margin-top: 0;\n  margin-right: var(--bs-dropdown-spacer);\n}\n.dropstart .dropdown-toggle::after {\n  display: inline-block;\n  margin-left: 0.255em;\n  vertical-align: 0.255em;\n  content: \"\";\n}\n.dropstart .dropdown-toggle::after {\n  display: none;\n}\n.dropstart .dropdown-toggle::before {\n  display: inline-block;\n  margin-right: 0.255em;\n  vertical-align: 0.255em;\n  content: \"\";\n  border-top: 0.3em solid transparent;\n  border-right: 0.3em solid;\n  border-bottom: 0.3em solid transparent;\n}\n.dropstart .dropdown-toggle:empty::after {\n  margin-left: 0;\n}\n.dropstart .dropdown-toggle::before {\n  vertical-align: 0;\n}\n\n.dropdown-divider {\n  height: 0;\n  margin: var(--bs-dropdown-divider-margin-y) 0;\n  overflow: hidden;\n  border-top: 1px solid var(--bs-dropdown-divider-bg);\n  opacity: 1;\n}\n\n.dropdown-item {\n  display: block;\n  width: 100%;\n  padding: var(--bs-dropdown-item-padding-y) var(--bs-dropdown-item-padding-x);\n  clear: both;\n  font-weight: 400;\n  color: var(--bs-dropdown-link-color);\n  text-align: inherit;\n  white-space: nowrap;\n  background-color: transparent;\n  border: 0;\n  border-radius: var(--bs-dropdown-item-border-radius, 0);\n}\n.dropdown-item:hover, .dropdown-item:focus {\n  color: var(--bs-dropdown-link-hover-color);\n  background-color: var(--bs-dropdown-link-hover-bg);\n}\n.dropdown-item.active, .dropdown-item:active {\n  color: var(--bs-dropdown-link-active-color);\n  text-decoration: none;\n  background-color: var(--bs-dropdown-link-active-bg);\n}\n.dropdown-item.disabled, .dropdown-item:disabled {\n  color: var(--bs-dropdown-link-disabled-color);\n  pointer-events: none;\n  background-color: transparent;\n}\n\n.dropdown-menu.show {\n  display: block;\n}\n\n.dropdown-header {\n  display: block;\n  padding: var(--bs-dropdown-header-padding-y) var(--bs-dropdown-header-padding-x);\n  margin-bottom: 0;\n  font-size: 0.95rem;\n  color: var(--bs-dropdown-header-color);\n  white-space: nowrap;\n}\n\n.dropdown-item-text {\n  display: block;\n  padding: var(--bs-dropdown-item-padding-y) var(--bs-dropdown-item-padding-x);\n  color: var(--bs-dropdown-link-color);\n}\n\n.dropdown-menu-dark {\n  --bs-dropdown-color: #E1E3EA;\n  --bs-dropdown-bg: #3F4254;\n  --bs-dropdown-border-color: var(--bs-border-color-translucent);\n  --bs-dropdown-box-shadow: ;\n  --bs-dropdown-link-color: #E1E3EA;\n  --bs-dropdown-link-hover-color: #ffffff;\n  --bs-dropdown-divider-bg: var(--bs-gray-100);\n  --bs-dropdown-link-hover-bg: rgba(255, 255, 255, 0.15);\n  --bs-dropdown-link-active-color: var(--bs-component-hover-color);\n  --bs-dropdown-link-active-bg: var(--bs-component-hover-bg);\n  --bs-dropdown-link-disabled-color: #A1A5B7;\n  --bs-dropdown-header-color: #A1A5B7;\n}\n\n.btn-group,\n.btn-group-vertical {\n  position: relative;\n  display: inline-flex;\n  vertical-align: middle;\n}\n.btn-group > .btn,\n.btn-group-vertical > .btn {\n  position: relative;\n  flex: 1 1 auto;\n}\n.btn-group > .btn-check:checked + .btn,\n.btn-group > .btn-check:focus + .btn,\n.btn-group > .btn:hover,\n.btn-group > .btn:focus,\n.btn-group > .btn:active,\n.btn-group > .btn.active,\n.btn-group-vertical > .btn-check:checked + .btn,\n.btn-group-vertical > .btn-check:focus + .btn,\n.btn-group-vertical > .btn:hover,\n.btn-group-vertical > .btn:focus,\n.btn-group-vertical > .btn:active,\n.btn-group-vertical > .btn.active {\n  z-index: 1;\n}\n\n.btn-toolbar {\n  display: flex;\n  flex-wrap: wrap;\n  justify-content: flex-start;\n}\n.btn-toolbar .input-group {\n  width: auto;\n}\n\n.btn-group {\n  border-radius: 0.475rem;\n}\n.btn-group > :not(.btn-check:first-child) + .btn,\n.btn-group > .btn-group:not(:first-child) {\n  margin-left: -1px;\n}\n.btn-group > .btn:not(:last-child):not(.dropdown-toggle),\n.btn-group > .btn.dropdown-toggle-split:first-child,\n.btn-group > .btn-group:not(:last-child) > .btn {\n  border-top-right-radius: 0;\n  border-bottom-right-radius: 0;\n}\n.btn-group > .btn:nth-child(n+3),\n.btn-group > :not(.btn-check) + .btn,\n.btn-group > .btn-group:not(:first-child) > .btn {\n  border-top-left-radius: 0;\n  border-bottom-left-radius: 0;\n}\n\n.dropdown-toggle-split {\n  padding-right: 1.125rem;\n  padding-left: 1.125rem;\n}\n.dropdown-toggle-split::after, .dropup .dropdown-toggle-split::after, .dropend .dropdown-toggle-split::after {\n  margin-left: 0;\n}\n.dropstart .dropdown-toggle-split::before {\n  margin-right: 0;\n}\n\n.btn-sm + .dropdown-toggle-split, .btn-group-sm > .btn + .dropdown-toggle-split {\n  padding-right: 0.9375rem;\n  padding-left: 0.9375rem;\n}\n\n.btn-lg + .dropdown-toggle-split, .btn-group-lg > .btn + .dropdown-toggle-split {\n  padding-right: 1.3125rem;\n  padding-left: 1.3125rem;\n}\n\n.btn-group.show .dropdown-toggle {\n  box-shadow: inset 0 3px 5px rgba(0, 0, 0, 0.125);\n}\n.btn-group.show .dropdown-toggle.btn-link {\n  box-shadow: none;\n}\n\n.btn-group-vertical {\n  flex-direction: column;\n  align-items: flex-start;\n  justify-content: center;\n}\n.btn-group-vertical > .btn,\n.btn-group-vertical > .btn-group {\n  width: 100%;\n}\n.btn-group-vertical > .btn:not(:first-child),\n.btn-group-vertical > .btn-group:not(:first-child) {\n  margin-top: -1px;\n}\n.btn-group-vertical > .btn:not(:last-child):not(.dropdown-toggle),\n.btn-group-vertical > .btn-group:not(:last-child) > .btn {\n  border-bottom-right-radius: 0;\n  border-bottom-left-radius: 0;\n}\n.btn-group-vertical > .btn ~ .btn,\n.btn-group-vertical > .btn-group:not(:first-child) > .btn {\n  border-top-left-radius: 0;\n  border-top-right-radius: 0;\n}\n\n.nav {\n  --bs-nav-link-padding-x: 1rem;\n  --bs-nav-link-padding-y: 0.5rem;\n  --bs-nav-link-font-weight: ;\n  --bs-nav-link-color: var(--bs-link-color);\n  --bs-nav-link-hover-color: var(--bs-link-hover-color);\n  --bs-nav-link-disabled-color: var(--bs-secondary-color);\n  display: flex;\n  flex-wrap: wrap;\n  padding-left: 0;\n  margin-bottom: 0;\n  list-style: none;\n}\n\n.nav-link {\n  display: block;\n  padding: var(--bs-nav-link-padding-y) var(--bs-nav-link-padding-x);\n  font-size: var(--bs-nav-link-font-size);\n  font-weight: var(--bs-nav-link-font-weight);\n  color: var(--bs-nav-link-color);\n  transition: color 0.15s ease-in-out;\n}\n@media (prefers-reduced-motion: reduce) {\n  .nav-link {\n    transition: none;\n  }\n}\n.nav-link:hover, .nav-link:focus {\n  color: var(--bs-nav-link-hover-color);\n}\n.nav-link.disabled {\n  color: var(--bs-nav-link-disabled-color);\n  pointer-events: none;\n  cursor: default;\n}\n\n.nav-tabs {\n  --bs-nav-tabs-border-width: var(--bs-border-width);\n  --bs-nav-tabs-border-color: var(--bs-border-color);\n  --bs-nav-tabs-border-radius: var(--bs-border-radius);\n  --bs-nav-tabs-link-hover-border-color: var(--bs-secondary-bg) var(--bs-secondary-bg) var(--bs-border-color);\n  --bs-nav-tabs-link-active-color: var(--bs-emphasis-color);\n  --bs-nav-tabs-link-active-bg: var(--bs-body-bg);\n  --bs-nav-tabs-link-active-border-color: var(--bs-border-color) var(--bs-border-color) var(--bs-body-bg);\n  border-bottom: var(--bs-nav-tabs-border-width) solid var(--bs-nav-tabs-border-color);\n}\n.nav-tabs .nav-link {\n  margin-bottom: calc(-1 * var(--bs-nav-tabs-border-width));\n  background: none;\n  border: var(--bs-nav-tabs-border-width) solid transparent;\n  border-top-left-radius: var(--bs-nav-tabs-border-radius);\n  border-top-right-radius: var(--bs-nav-tabs-border-radius);\n}\n.nav-tabs .nav-link:hover, .nav-tabs .nav-link:focus {\n  isolation: isolate;\n  border-color: var(--bs-nav-tabs-link-hover-border-color);\n}\n.nav-tabs .nav-link.disabled, .nav-tabs .nav-link:disabled {\n  color: var(--bs-nav-link-disabled-color);\n  background-color: transparent;\n  border-color: transparent;\n}\n.nav-tabs .nav-link.active,\n.nav-tabs .nav-item.show .nav-link {\n  color: var(--bs-nav-tabs-link-active-color);\n  background-color: var(--bs-nav-tabs-link-active-bg);\n  border-color: var(--bs-nav-tabs-link-active-border-color);\n}\n.nav-tabs .dropdown-menu {\n  margin-top: calc(-1 * var(--bs-nav-tabs-border-width));\n  border-top-left-radius: 0;\n  border-top-right-radius: 0;\n}\n\n.nav-pills {\n  --bs-nav-pills-border-radius: 0.475rem;\n  --bs-nav-pills-link-active-color: #ffffff;\n  --bs-nav-pills-link-active-bg: #009ef7;\n}\n.nav-pills .nav-link {\n  background: none;\n  border: 0;\n  border-radius: var(--bs-nav-pills-border-radius);\n}\n.nav-pills .nav-link:disabled {\n  color: var(--bs-nav-link-disabled-color);\n  background-color: transparent;\n  border-color: transparent;\n}\n.nav-pills .nav-link.active,\n.nav-pills .show > .nav-link {\n  color: var(--bs-nav-pills-link-active-color);\n  background-color: var(--bs-nav-pills-link-active-bg);\n}\n\n.nav-fill > .nav-link,\n.nav-fill .nav-item {\n  flex: 1 1 auto;\n  text-align: center;\n}\n\n.nav-justified > .nav-link,\n.nav-justified .nav-item {\n  flex-basis: 0;\n  flex-grow: 1;\n  text-align: center;\n}\n\n.nav-fill .nav-item .nav-link,\n.nav-justified .nav-item .nav-link {\n  width: 100%;\n}\n\n.tab-content > .tab-pane {\n  display: none;\n}\n.tab-content > .active {\n  display: block;\n}\n\n.navbar {\n  --bs-navbar-padding-x: 0;\n  --bs-navbar-padding-y: 0.5rem;\n  --bs-navbar-color: rgba(var(--bs-emphasis-color-rgb), 0.65);\n  --bs-navbar-hover-color: rgba(var(--bs-emphasis-color-rgb), 0.8);\n  --bs-navbar-disabled-color: rgba(var(--bs-emphasis-color-rgb), 0.3);\n  --bs-navbar-active-color: rgba(var(--bs-emphasis-color-rgb), 1);\n  --bs-navbar-brand-padding-y: 0.44375rem;\n  --bs-navbar-brand-margin-end: 1rem;\n  --bs-navbar-brand-font-size: 1.075rem;\n  --bs-navbar-brand-color: rgba(var(--bs-emphasis-color-rgb), 1);\n  --bs-navbar-brand-hover-color: rgba(var(--bs-emphasis-color-rgb), 1);\n  --bs-navbar-nav-link-padding-x: 0.5rem;\n  --bs-navbar-toggler-padding-y: 0.25rem;\n  --bs-navbar-toggler-padding-x: 0.75rem;\n  --bs-navbar-toggler-font-size: 1.075rem;\n  --bs-navbar-toggler-icon-bg: url(\"data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 30 30'%3e%3cpath stroke='rgba%2824, 28, 50, 0.75%29' stroke-linecap='round' stroke-miterlimit='10' stroke-width='2' d='M4 7h22M4 15h22M4 23h22'/%3e%3c/svg%3e\");\n  --bs-navbar-toggler-border-color: rgba(var(--bs-emphasis-color-rgb), 0.15);\n  --bs-navbar-toggler-border-radius: 0.475rem;\n  --bs-navbar-toggler-focus-width: 0.25rem;\n  --bs-navbar-toggler-transition: box-shadow 0.15s ease-in-out;\n  position: relative;\n  display: flex;\n  flex-wrap: wrap;\n  align-items: center;\n  justify-content: space-between;\n  padding: var(--bs-navbar-padding-y) var(--bs-navbar-padding-x);\n}\n.navbar > .container,\n.navbar > .container-fluid,\n.navbar > .container-sm,\n.navbar > .container-md,\n.navbar > .container-lg,\n.navbar > .container-xl,\n.navbar > .container-xxl {\n  display: flex;\n  flex-wrap: inherit;\n  align-items: center;\n  justify-content: space-between;\n}\n.navbar-brand {\n  padding-top: var(--bs-navbar-brand-padding-y);\n  padding-bottom: var(--bs-navbar-brand-padding-y);\n  margin-right: var(--bs-navbar-brand-margin-end);\n  font-size: var(--bs-navbar-brand-font-size);\n  color: var(--bs-navbar-brand-color);\n  white-space: nowrap;\n}\n.navbar-brand:hover, .navbar-brand:focus {\n  color: var(--bs-navbar-brand-hover-color);\n}\n\n.navbar-nav {\n  --bs-nav-link-padding-x: 0;\n  --bs-nav-link-padding-y: 0.5rem;\n  --bs-nav-link-font-weight: ;\n  --bs-nav-link-color: var(--bs-navbar-color);\n  --bs-nav-link-hover-color: var(--bs-navbar-hover-color);\n  --bs-nav-link-disabled-color: var(--bs-navbar-disabled-color);\n  display: flex;\n  flex-direction: column;\n  padding-left: 0;\n  margin-bottom: 0;\n  list-style: none;\n}\n.navbar-nav .show > .nav-link,\n.navbar-nav .nav-link.active {\n  color: var(--bs-navbar-active-color);\n}\n.navbar-nav .dropdown-menu {\n  position: static;\n}\n\n.navbar-text {\n  padding-top: 0.5rem;\n  padding-bottom: 0.5rem;\n  color: var(--bs-navbar-color);\n}\n.navbar-text a,\n.navbar-text a:hover,\n.navbar-text a:focus {\n  color: var(--bs-navbar-active-color);\n}\n\n.navbar-collapse {\n  flex-basis: 100%;\n  flex-grow: 1;\n  align-items: center;\n}\n\n.navbar-toggler {\n  padding: var(--bs-navbar-toggler-padding-y) var(--bs-navbar-toggler-padding-x);\n  font-size: var(--bs-navbar-toggler-font-size);\n  line-height: 1;\n  color: var(--bs-navbar-color);\n  background-color: transparent;\n  border: var(--bs-border-width) solid var(--bs-navbar-toggler-border-color);\n  border-radius: var(--bs-navbar-toggler-border-radius);\n  transition: var(--bs-navbar-toggler-transition);\n}\n@media (prefers-reduced-motion: reduce) {\n  .navbar-toggler {\n    transition: none;\n  }\n}\n.navbar-toggler:hover {\n  text-decoration: none;\n}\n.navbar-toggler:focus {\n  text-decoration: none;\n  outline: 0;\n  box-shadow: 0 0 0 var(--bs-navbar-toggler-focus-width);\n}\n\n.navbar-toggler-icon {\n  display: inline-block;\n  width: 1.5em;\n  height: 1.5em;\n  vertical-align: middle;\n  background-image: var(--bs-navbar-toggler-icon-bg);\n  background-repeat: no-repeat;\n  background-position: center;\n  background-size: 100%;\n}\n\n.navbar-nav-scroll {\n  max-height: var(--bs-scroll-height, 75vh);\n  overflow-y: auto;\n}\n\n@media (min-width: 576px) {\n  .navbar-expand-sm {\n    flex-wrap: nowrap;\n    justify-content: flex-start;\n  }\n  .navbar-expand-sm .navbar-nav {\n    flex-direction: row;\n  }\n  .navbar-expand-sm .navbar-nav .dropdown-menu {\n    position: absolute;\n  }\n  .navbar-expand-sm .navbar-nav .nav-link {\n    padding-right: var(--bs-navbar-nav-link-padding-x);\n    padding-left: var(--bs-navbar-nav-link-padding-x);\n  }\n  .navbar-expand-sm .navbar-nav-scroll {\n    overflow: visible;\n  }\n  .navbar-expand-sm .navbar-collapse {\n    display: flex !important;\n    flex-basis: auto;\n  }\n  .navbar-expand-sm .navbar-toggler {\n    display: none;\n  }\n  .navbar-expand-sm .offcanvas {\n    position: static;\n    z-index: auto;\n    flex-grow: 1;\n    width: auto !important;\n    height: auto !important;\n    visibility: visible !important;\n    background-color: transparent !important;\n    border: 0 !important;\n    transform: none !important;\n    box-shadow: none;\n    transition: none;\n  }\n  .navbar-expand-sm .offcanvas .offcanvas-header {\n    display: none;\n  }\n  .navbar-expand-sm .offcanvas .offcanvas-body {\n    display: flex;\n    flex-grow: 0;\n    padding: 0;\n    overflow-y: visible;\n  }\n}\n@media (min-width: 768px) {\n  .navbar-expand-md {\n    flex-wrap: nowrap;\n    justify-content: flex-start;\n  }\n  .navbar-expand-md .navbar-nav {\n    flex-direction: row;\n  }\n  .navbar-expand-md .navbar-nav .dropdown-menu {\n    position: absolute;\n  }\n  .navbar-expand-md .navbar-nav .nav-link {\n    padding-right: var(--bs-navbar-nav-link-padding-x);\n    padding-left: var(--bs-navbar-nav-link-padding-x);\n  }\n  .navbar-expand-md .navbar-nav-scroll {\n    overflow: visible;\n  }\n  .navbar-expand-md .navbar-collapse {\n    display: flex !important;\n    flex-basis: auto;\n  }\n  .navbar-expand-md .navbar-toggler {\n    display: none;\n  }\n  .navbar-expand-md .offcanvas {\n    position: static;\n    z-index: auto;\n    flex-grow: 1;\n    width: auto !important;\n    height: auto !important;\n    visibility: visible !important;\n    background-color: transparent !important;\n    border: 0 !important;\n    transform: none !important;\n    box-shadow: none;\n    transition: none;\n  }\n  .navbar-expand-md .offcanvas .offcanvas-header {\n    display: none;\n  }\n  .navbar-expand-md .offcanvas .offcanvas-body {\n    display: flex;\n    flex-grow: 0;\n    padding: 0;\n    overflow-y: visible;\n  }\n}\n@media (min-width: 992px) {\n  .navbar-expand-lg {\n    flex-wrap: nowrap;\n    justify-content: flex-start;\n  }\n  .navbar-expand-lg .navbar-nav {\n    flex-direction: row;\n  }\n  .navbar-expand-lg .navbar-nav .dropdown-menu {\n    position: absolute;\n  }\n  .navbar-expand-lg .navbar-nav .nav-link {\n    padding-right: var(--bs-navbar-nav-link-padding-x);\n    padding-left: var(--bs-navbar-nav-link-padding-x);\n  }\n  .navbar-expand-lg .navbar-nav-scroll {\n    overflow: visible;\n  }\n  .navbar-expand-lg .navbar-collapse {\n    display: flex !important;\n    flex-basis: auto;\n  }\n  .navbar-expand-lg .navbar-toggler {\n    display: none;\n  }\n  .navbar-expand-lg .offcanvas {\n    position: static;\n    z-index: auto;\n    flex-grow: 1;\n    width: auto !important;\n    height: auto !important;\n    visibility: visible !important;\n    background-color: transparent !important;\n    border: 0 !important;\n    transform: none !important;\n    box-shadow: none;\n    transition: none;\n  }\n  .navbar-expand-lg .offcanvas .offcanvas-header {\n    display: none;\n  }\n  .navbar-expand-lg .offcanvas .offcanvas-body {\n    display: flex;\n    flex-grow: 0;\n    padding: 0;\n    overflow-y: visible;\n  }\n}\n@media (min-width: 1200px) {\n  .navbar-expand-xl {\n    flex-wrap: nowrap;\n    justify-content: flex-start;\n  }\n  .navbar-expand-xl .navbar-nav {\n    flex-direction: row;\n  }\n  .navbar-expand-xl .navbar-nav .dropdown-menu {\n    position: absolute;\n  }\n  .navbar-expand-xl .navbar-nav .nav-link {\n    padding-right: var(--bs-navbar-nav-link-padding-x);\n    padding-left: var(--bs-navbar-nav-link-padding-x);\n  }\n  .navbar-expand-xl .navbar-nav-scroll {\n    overflow: visible;\n  }\n  .navbar-expand-xl .navbar-collapse {\n    display: flex !important;\n    flex-basis: auto;\n  }\n  .navbar-expand-xl .navbar-toggler {\n    display: none;\n  }\n  .navbar-expand-xl .offcanvas {\n    position: static;\n    z-index: auto;\n    flex-grow: 1;\n    width: auto !important;\n    height: auto !important;\n    visibility: visible !important;\n    background-color: transparent !important;\n    border: 0 !important;\n    transform: none !important;\n    box-shadow: none;\n    transition: none;\n  }\n  .navbar-expand-xl .offcanvas .offcanvas-header {\n    display: none;\n  }\n  .navbar-expand-xl .offcanvas .offcanvas-body {\n    display: flex;\n    flex-grow: 0;\n    padding: 0;\n    overflow-y: visible;\n  }\n}\n@media (min-width: 1400px) {\n  .navbar-expand-xxl {\n    flex-wrap: nowrap;\n    justify-content: flex-start;\n  }\n  .navbar-expand-xxl .navbar-nav {\n    flex-direction: row;\n  }\n  .navbar-expand-xxl .navbar-nav .dropdown-menu {\n    position: absolute;\n  }\n  .navbar-expand-xxl .navbar-nav .nav-link {\n    padding-right: var(--bs-navbar-nav-link-padding-x);\n    padding-left: var(--bs-navbar-nav-link-padding-x);\n  }\n  .navbar-expand-xxl .navbar-nav-scroll {\n    overflow: visible;\n  }\n  .navbar-expand-xxl .navbar-collapse {\n    display: flex !important;\n    flex-basis: auto;\n  }\n  .navbar-expand-xxl .navbar-toggler {\n    display: none;\n  }\n  .navbar-expand-xxl .offcanvas {\n    position: static;\n    z-index: auto;\n    flex-grow: 1;\n    width: auto !important;\n    height: auto !important;\n    visibility: visible !important;\n    background-color: transparent !important;\n    border: 0 !important;\n    transform: none !important;\n    box-shadow: none;\n    transition: none;\n  }\n  .navbar-expand-xxl .offcanvas .offcanvas-header {\n    display: none;\n  }\n  .navbar-expand-xxl .offcanvas .offcanvas-body {\n    display: flex;\n    flex-grow: 0;\n    padding: 0;\n    overflow-y: visible;\n  }\n}\n.navbar-expand {\n  flex-wrap: nowrap;\n  justify-content: flex-start;\n}\n.navbar-expand .navbar-nav {\n  flex-direction: row;\n}\n.navbar-expand .navbar-nav .dropdown-menu {\n  position: absolute;\n}\n.navbar-expand .navbar-nav .nav-link {\n  padding-right: var(--bs-navbar-nav-link-padding-x);\n  padding-left: var(--bs-navbar-nav-link-padding-x);\n}\n.navbar-expand .navbar-nav-scroll {\n  overflow: visible;\n}\n.navbar-expand .navbar-collapse {\n  display: flex !important;\n  flex-basis: auto;\n}\n.navbar-expand .navbar-toggler {\n  display: none;\n}\n.navbar-expand .offcanvas {\n  position: static;\n  z-index: auto;\n  flex-grow: 1;\n  width: auto !important;\n  height: auto !important;\n  visibility: visible !important;\n  background-color: transparent !important;\n  border: 0 !important;\n  transform: none !important;\n  box-shadow: none;\n  transition: none;\n}\n.navbar-expand .offcanvas .offcanvas-header {\n  display: none;\n}\n.navbar-expand .offcanvas .offcanvas-body {\n  display: flex;\n  flex-grow: 0;\n  padding: 0;\n  overflow-y: visible;\n}\n\n.navbar-dark {\n  --bs-navbar-color: rgba(255, 255, 255, 0.55);\n  --bs-navbar-hover-color: rgba(255, 255, 255, 0.75);\n  --bs-navbar-disabled-color: rgba(255, 255, 255, 0.25);\n  --bs-navbar-active-color: #ffffff;\n  --bs-navbar-brand-color: #ffffff;\n  --bs-navbar-brand-hover-color: #ffffff;\n  --bs-navbar-toggler-border-color: rgba(255, 255, 255, 0.1);\n  --bs-navbar-toggler-icon-bg: url(\"data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 30 30'%3e%3cpath stroke='rgba%28255, 255, 255, 0.55%29' stroke-linecap='round' stroke-miterlimit='10' stroke-width='2' d='M4 7h22M4 15h22M4 23h22'/%3e%3c/svg%3e\");\n}\n\n[data-bs-theme=dark] .navbar {\n  --bs-navbar-toggler-icon-bg: url(\"data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 30 30'%3e%3cpath stroke='rgba%28255, 255, 255, 0.55%29' stroke-linecap='round' stroke-miterlimit='10' stroke-width='2' d='M4 7h22M4 15h22M4 23h22'/%3e%3c/svg%3e\");\n}\n\n.card {\n  --bs-card-spacer-y: 1rem;\n  --bs-card-spacer-x: 1rem;\n  --bs-card-title-spacer-y: 0.5rem;\n  --bs-card-title-color: ;\n  --bs-card-subtitle-color: ;\n  --bs-card-border-width: 1px;\n  --bs-card-border-color: var(--bs-border-color);\n  --bs-card-border-radius: 0.625rem;\n  --bs-card-box-shadow: 0px 0px 20px 0px rgba(76, 87, 125, 0.02);\n  --bs-card-inner-border-radius: calc(0.625rem - 1px);\n  --bs-card-cap-padding-y: 0.5rem;\n  --bs-card-cap-padding-x: 1rem;\n  --bs-card-cap-bg: transparent;\n  --bs-card-cap-color: ;\n  --bs-card-height: ;\n  --bs-card-color: ;\n  --bs-card-bg: var(--bs-body-bg);\n  --bs-card-img-overlay-padding: 1rem;\n  --bs-card-group-margin: 0.75rem;\n  position: relative;\n  display: flex;\n  flex-direction: column;\n  min-width: 0;\n  height: var(--bs-card-height);\n  word-wrap: break-word;\n  background-color: var(--bs-card-bg);\n  background-clip: border-box;\n  border: var(--bs-card-border-width) solid var(--bs-card-border-color);\n  border-radius: var(--bs-card-border-radius);\n  box-shadow: var(--bs-card-box-shadow);\n}\n.card > hr {\n  margin-right: 0;\n  margin-left: 0;\n}\n.card > .list-group {\n  border-top: inherit;\n  border-bottom: inherit;\n}\n.card > .list-group:first-child {\n  border-top-width: 0;\n  border-top-left-radius: var(--bs-card-inner-border-radius);\n  border-top-right-radius: var(--bs-card-inner-border-radius);\n}\n.card > .list-group:last-child {\n  border-bottom-width: 0;\n  border-bottom-right-radius: var(--bs-card-inner-border-radius);\n  border-bottom-left-radius: var(--bs-card-inner-border-radius);\n}\n.card > .card-header + .list-group,\n.card > .list-group + .card-footer {\n  border-top: 0;\n}\n\n.card-body {\n  flex: 1 1 auto;\n  padding: var(--bs-card-spacer-y) var(--bs-card-spacer-x);\n  color: var(--bs-card-color);\n}\n\n.card-title {\n  margin-bottom: var(--bs-card-title-spacer-y);\n  color: var(--bs-card-title-color);\n}\n\n.card-subtitle {\n  margin-top: calc(-0.5 * var(--bs-card-title-spacer-y));\n  margin-bottom: 0;\n  color: var(--bs-card-subtitle-color);\n}\n\n.card-text:last-child {\n  margin-bottom: 0;\n}\n\n.card-link + .card-link {\n  margin-left: var(--bs-card-spacer-x);\n}\n\n.card-header {\n  padding: var(--bs-card-cap-padding-y) var(--bs-card-cap-padding-x);\n  margin-bottom: 0;\n  color: var(--bs-card-cap-color);\n  background-color: var(--bs-card-cap-bg);\n  border-bottom: var(--bs-card-border-width) solid var(--bs-card-border-color);\n}\n.card-header:first-child {\n  border-radius: var(--bs-card-inner-border-radius) var(--bs-card-inner-border-radius) 0 0;\n}\n\n.card-footer {\n  padding: var(--bs-card-cap-padding-y) var(--bs-card-cap-padding-x);\n  color: var(--bs-card-cap-color);\n  background-color: var(--bs-card-cap-bg);\n  border-top: var(--bs-card-border-width) solid var(--bs-card-border-color);\n}\n.card-footer:last-child {\n  border-radius: 0 0 var(--bs-card-inner-border-radius) var(--bs-card-inner-border-radius);\n}\n\n.card-header-tabs {\n  margin-right: calc(-0.5 * var(--bs-card-cap-padding-x));\n  margin-bottom: calc(-1 * var(--bs-card-cap-padding-y));\n  margin-left: calc(-0.5 * var(--bs-card-cap-padding-x));\n  border-bottom: 0;\n}\n.card-header-tabs .nav-link.active {\n  background-color: var(--bs-card-bg);\n  border-bottom-color: var(--bs-card-bg);\n}\n\n.card-header-pills {\n  margin-right: calc(-0.5 * var(--bs-card-cap-padding-x));\n  margin-left: calc(-0.5 * var(--bs-card-cap-padding-x));\n}\n\n.card-img-overlay {\n  position: absolute;\n  top: 0;\n  right: 0;\n  bottom: 0;\n  left: 0;\n  padding: var(--bs-card-img-overlay-padding);\n  border-radius: var(--bs-card-inner-border-radius);\n}\n\n.card-img,\n.card-img-top,\n.card-img-bottom {\n  width: 100%;\n}\n\n.card-img,\n.card-img-top {\n  border-top-left-radius: var(--bs-card-inner-border-radius);\n  border-top-right-radius: var(--bs-card-inner-border-radius);\n}\n\n.card-img,\n.card-img-bottom {\n  border-bottom-right-radius: var(--bs-card-inner-border-radius);\n  border-bottom-left-radius: var(--bs-card-inner-border-radius);\n}\n\n.card-group > .card {\n  margin-bottom: var(--bs-card-group-margin);\n}\n@media (min-width: 576px) {\n  .card-group {\n    display: flex;\n    flex-flow: row wrap;\n  }\n  .card-group > .card {\n    flex: 1 0 0%;\n    margin-bottom: 0;\n  }\n  .card-group > .card + .card {\n    margin-left: 0;\n    border-left: 0;\n  }\n  .card-group > .card:not(:last-child) {\n    border-top-right-radius: 0;\n    border-bottom-right-radius: 0;\n  }\n  .card-group > .card:not(:last-child) .card-img-top,\n.card-group > .card:not(:last-child) .card-header {\n    border-top-right-radius: 0;\n  }\n  .card-group > .card:not(:last-child) .card-img-bottom,\n.card-group > .card:not(:last-child) .card-footer {\n    border-bottom-right-radius: 0;\n  }\n  .card-group > .card:not(:first-child) {\n    border-top-left-radius: 0;\n    border-bottom-left-radius: 0;\n  }\n  .card-group > .card:not(:first-child) .card-img-top,\n.card-group > .card:not(:first-child) .card-header {\n    border-top-left-radius: 0;\n  }\n  .card-group > .card:not(:first-child) .card-img-bottom,\n.card-group > .card:not(:first-child) .card-footer {\n    border-bottom-left-radius: 0;\n  }\n}\n\n.accordion {\n  --bs-accordion-color: var(--bs-body-color);\n  --bs-accordion-bg: var(--bs-body-bg);\n  --bs-accordion-transition: color 0.15s ease-in-out, background-color 0.15s ease-in-out, border-color 0.15s ease-in-out, box-shadow 0.15s ease-in-out, border-radius 0.15s ease;\n  --bs-accordion-border-color: var(--bs-border-color);\n  --bs-accordion-border-width: var(--bs-border-width);\n  --bs-accordion-border-radius: 0.475rem;\n  --bs-accordion-inner-border-radius: calc(0.475rem - (var(--bs-border-width)));\n  --bs-accordion-btn-padding-x: 1.5rem;\n  --bs-accordion-btn-padding-y: 1.5rem;\n  --bs-accordion-btn-color: var(--bs-body-color);\n  --bs-accordion-btn-bg: var(--bs-body-bg);\n  --bs-accordion-btn-icon: url(\"data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 16 16' fill='%23181C32'%3e%3cpath fill-rule='evenodd' d='M1.646 4.646a.5.5 0 0 1 .708 0L8 10.293l5.646-5.647a.5.5 0 0 1 .708.708l-6 6a.5.5 0 0 1-.708 0l-6-6a.5.5 0 0 1 0-.708z'/%3e%3c/svg%3e\");\n  --bs-accordion-btn-icon-width: 1.15rem;\n  --bs-accordion-btn-icon-transform: rotate(-180deg);\n  --bs-accordion-btn-icon-transition: transform 0.2s ease-in-out;\n  --bs-accordion-btn-active-icon: url(\"data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 16 16' fill='%23009ef7'%3e%3cpath fill-rule='evenodd' d='M1.646 4.646a.5.5 0 0 1 .708 0L8 10.293l5.646-5.647a.5.5 0 0 1 .708.708l-6 6a.5.5 0 0 1-.708 0l-6-6a.5.5 0 0 1 0-.708z'/%3e%3c/svg%3e\");\n  --bs-accordion-btn-focus-border-color: var(--bs-border-color);\n  --bs-accordion-btn-focus-box-shadow: none;\n  --bs-accordion-body-padding-x: 1.5rem;\n  --bs-accordion-body-padding-y: 1.5rem;\n  --bs-accordion-active-color: var(--bs-primary);\n  --bs-accordion-active-bg: var(--bs-gray-100);\n}\n\n.accordion-button {\n  position: relative;\n  display: flex;\n  align-items: center;\n  width: 100%;\n  padding: var(--bs-accordion-btn-padding-y) var(--bs-accordion-btn-padding-x);\n  font-size: 1rem;\n  color: var(--bs-accordion-btn-color);\n  text-align: left;\n  background-color: var(--bs-accordion-btn-bg);\n  border: 0;\n  border-radius: 0;\n  overflow-anchor: none;\n  transition: var(--bs-accordion-transition);\n}\n@media (prefers-reduced-motion: reduce) {\n  .accordion-button {\n    transition: none;\n  }\n}\n.accordion-button:not(.collapsed) {\n  color: var(--bs-accordion-active-color);\n  background-color: var(--bs-accordion-active-bg);\n  box-shadow: inset 0 calc(-1 * var(--bs-accordion-border-width)) 0 var(--bs-accordion-border-color);\n}\n.accordion-button:not(.collapsed)::after {\n  background-image: var(--bs-accordion-btn-active-icon);\n  transform: var(--bs-accordion-btn-icon-transform);\n}\n.accordion-button::after {\n  flex-shrink: 0;\n  width: var(--bs-accordion-btn-icon-width);\n  height: var(--bs-accordion-btn-icon-width);\n  margin-left: auto;\n  content: \"\";\n  background-image: var(--bs-accordion-btn-icon);\n  background-repeat: no-repeat;\n  background-size: var(--bs-accordion-btn-icon-width);\n  transition: var(--bs-accordion-btn-icon-transition);\n}\n@media (prefers-reduced-motion: reduce) {\n  .accordion-button::after {\n    transition: none;\n  }\n}\n.accordion-button:hover {\n  z-index: 2;\n}\n.accordion-button:focus {\n  z-index: 3;\n  border-color: var(--bs-accordion-btn-focus-border-color);\n  outline: 0;\n  box-shadow: var(--bs-accordion-btn-focus-box-shadow);\n}\n\n.accordion-header {\n  margin-bottom: 0;\n}\n\n.accordion-item {\n  color: var(--bs-accordion-color);\n  background-color: var(--bs-accordion-bg);\n  border: var(--bs-accordion-border-width) solid var(--bs-accordion-border-color);\n}\n.accordion-item:first-of-type {\n  border-top-left-radius: var(--bs-accordion-border-radius);\n  border-top-right-radius: var(--bs-accordion-border-radius);\n}\n.accordion-item:first-of-type .accordion-button {\n  border-top-left-radius: var(--bs-accordion-inner-border-radius);\n  border-top-right-radius: var(--bs-accordion-inner-border-radius);\n}\n.accordion-item:not(:first-of-type) {\n  border-top: 0;\n}\n.accordion-item:last-of-type {\n  border-bottom-right-radius: var(--bs-accordion-border-radius);\n  border-bottom-left-radius: var(--bs-accordion-border-radius);\n}\n.accordion-item:last-of-type .accordion-button.collapsed {\n  border-bottom-right-radius: var(--bs-accordion-inner-border-radius);\n  border-bottom-left-radius: var(--bs-accordion-inner-border-radius);\n}\n.accordion-item:last-of-type .accordion-collapse {\n  border-bottom-right-radius: var(--bs-accordion-border-radius);\n  border-bottom-left-radius: var(--bs-accordion-border-radius);\n}\n\n.accordion-body {\n  padding: var(--bs-accordion-body-padding-y) var(--bs-accordion-body-padding-x);\n}\n\n.accordion-flush .accordion-collapse {\n  border-width: 0;\n}\n.accordion-flush .accordion-item {\n  border-right: 0;\n  border-left: 0;\n  border-radius: 0;\n}\n.accordion-flush .accordion-item:first-child {\n  border-top: 0;\n}\n.accordion-flush .accordion-item:last-child {\n  border-bottom: 0;\n}\n.accordion-flush .accordion-item .accordion-button, .accordion-flush .accordion-item .accordion-button.collapsed {\n  border-radius: 0;\n}\n\n[data-bs-theme=dark] .accordion-button::after {\n  --bs-accordion-btn-icon: url(\"data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 16 16' fill='%23FFFFFF'%3e%3cpath fill-rule='evenodd' d='M1.646 4.646a.5.5 0 0 1 .708 0L8 10.293l5.646-5.647a.5.5 0 0 1 .708.708l-6 6a.5.5 0 0 1-.708 0l-6-6a.5.5 0 0 1 0-.708z'/%3e%3c/svg%3e\");\n  --bs-accordion-btn-active-icon: url(\"data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 16 16' fill='%23009ef7'%3e%3cpath fill-rule='evenodd' d='M1.646 4.646a.5.5 0 0 1 .708 0L8 10.293l5.646-5.647a.5.5 0 0 1 .708.708l-6 6a.5.5 0 0 1-.708 0l-6-6a.5.5 0 0 1 0-.708z'/%3e%3c/svg%3e\");\n}\n\n.breadcrumb {\n  --bs-breadcrumb-padding-x: 0;\n  --bs-breadcrumb-padding-y: 0;\n  --bs-breadcrumb-margin-bottom: 1rem;\n  --bs-breadcrumb-bg: ;\n  --bs-breadcrumb-border-radius: ;\n  --bs-breadcrumb-divider-color: var(--bs-gray-600);\n  --bs-breadcrumb-item-padding-x: 0.5rem;\n  --bs-breadcrumb-item-active-color: var(--bs-primary);\n  display: flex;\n  flex-wrap: wrap;\n  padding: var(--bs-breadcrumb-padding-y) var(--bs-breadcrumb-padding-x);\n  margin-bottom: var(--bs-breadcrumb-margin-bottom);\n  font-size: var(--bs-breadcrumb-font-size);\n  list-style: none;\n  background-color: var(--bs-breadcrumb-bg);\n  border-radius: var(--bs-breadcrumb-border-radius);\n}\n\n.breadcrumb-item + .breadcrumb-item {\n  padding-left: var(--bs-breadcrumb-item-padding-x);\n}\n.breadcrumb-item + .breadcrumb-item::before {\n  float: left;\n  padding-right: var(--bs-breadcrumb-item-padding-x);\n  color: var(--bs-breadcrumb-divider-color);\n  content: var(--bs-breadcrumb-divider, \"/\") /* rtl: var(--bs-breadcrumb-divider, \"/\") */;\n}\n.breadcrumb-item.active {\n  color: var(--bs-breadcrumb-item-active-color);\n}\n\n.pagination {\n  --bs-pagination-padding-x: 0.75rem;\n  --bs-pagination-padding-y: 0.375rem;\n  --bs-pagination-font-size: 1.075rem;\n  --bs-pagination-color: var(--bs-gray-700);\n  --bs-pagination-bg: transparent;\n  --bs-pagination-border-width: 0;\n  --bs-pagination-border-color: transparent;\n  --bs-pagination-border-radius: 0.475rem;\n  --bs-pagination-hover-color: var(--bs-component-hover-color);\n  --bs-pagination-hover-bg: var(--bs-component-hover-bg);\n  --bs-pagination-hover-border-color: transparent;\n  --bs-pagination-focus-color: var(--bs-component-hover-color);\n  --bs-pagination-focus-bg: var(--bs-component-hover-bg);\n  --bs-pagination-focus-box-shadow: none;\n  --bs-pagination-active-color: var(--bs-component-active-color);\n  --bs-pagination-active-bg: var(--bs-component-active-bg);\n  --bs-pagination-active-border-color: transparent;\n  --bs-pagination-disabled-color: var(--bs-gray-400);\n  --bs-pagination-disabled-bg: transparent;\n  --bs-pagination-disabled-border-color: transparent;\n  display: flex;\n  padding-left: 0;\n  list-style: none;\n}\n\n.page-link {\n  position: relative;\n  display: block;\n  padding: var(--bs-pagination-padding-y) var(--bs-pagination-padding-x);\n  font-size: var(--bs-pagination-font-size);\n  color: var(--bs-pagination-color);\n  background-color: var(--bs-pagination-bg);\n  border: var(--bs-pagination-border-width) solid var(--bs-pagination-border-color);\n  transition: color 0.15s ease-in-out, background-color 0.15s ease-in-out, border-color 0.15s ease-in-out, box-shadow 0.15s ease-in-out;\n}\n@media (prefers-reduced-motion: reduce) {\n  .page-link {\n    transition: none;\n  }\n}\n.page-link:hover {\n  z-index: 2;\n  color: var(--bs-pagination-hover-color);\n  background-color: var(--bs-pagination-hover-bg);\n  border-color: var(--bs-pagination-hover-border-color);\n}\n.page-link:focus {\n  z-index: 3;\n  color: var(--bs-pagination-focus-color);\n  background-color: var(--bs-pagination-focus-bg);\n  outline: 0;\n  box-shadow: var(--bs-pagination-focus-box-shadow);\n}\n.page-link.active, .active > .page-link {\n  z-index: 3;\n  color: var(--bs-pagination-active-color);\n  background-color: var(--bs-pagination-active-bg);\n  border-color: var(--bs-pagination-active-border-color);\n}\n.page-link.disabled, .disabled > .page-link {\n  color: var(--bs-pagination-disabled-color);\n  pointer-events: none;\n  background-color: var(--bs-pagination-disabled-bg);\n  border-color: var(--bs-pagination-disabled-border-color);\n}\n\n.page-item:not(:first-child) .page-link {\n  margin-left: 0;\n}\n.page-item:first-child .page-link {\n  border-top-left-radius: var(--bs-pagination-border-radius);\n  border-bottom-left-radius: var(--bs-pagination-border-radius);\n}\n.page-item:last-child .page-link {\n  border-top-right-radius: var(--bs-pagination-border-radius);\n  border-bottom-right-radius: var(--bs-pagination-border-radius);\n}\n\n.pagination-lg {\n  --bs-pagination-padding-x: 1.5rem;\n  --bs-pagination-padding-y: 0.75rem;\n  --bs-pagination-font-size: 1.075rem;\n  --bs-pagination-border-radius: 0.625rem;\n}\n\n.pagination-sm {\n  --bs-pagination-padding-x: 0.5rem;\n  --bs-pagination-padding-y: 0.25rem;\n  --bs-pagination-font-size: 0.95rem;\n  --bs-pagination-border-radius: 0.425rem;\n}\n\n.badge {\n  --bs-badge-padding-x: 0.5rem;\n  --bs-badge-padding-y: 0.325rem;\n  --bs-badge-font-size: 0.85rem;\n  --bs-badge-font-weight: 600;\n  --bs-badge-color: var(--bs-body-color);\n  --bs-badge-border-radius: 0.425rem;\n  display: inline-block;\n  padding: var(--bs-badge-padding-y) var(--bs-badge-padding-x);\n  font-size: var(--bs-badge-font-size);\n  font-weight: var(--bs-badge-font-weight);\n  line-height: 1;\n  color: var(--bs-badge-color);\n  text-align: center;\n  white-space: nowrap;\n  vertical-align: baseline;\n  border-radius: var(--bs-badge-border-radius);\n}\n.badge:empty {\n  display: none;\n}\n\n.btn .badge {\n  position: relative;\n  top: -1px;\n}\n\n.alert {\n  --bs-alert-bg: transparent;\n  --bs-alert-padding-x: 1rem;\n  --bs-alert-padding-y: 1rem;\n  --bs-alert-margin-bottom: 1rem;\n  --bs-alert-color: inherit;\n  --bs-alert-border-color: transparent;\n  --bs-alert-border: var(--bs-border-width) solid var(--bs-alert-border-color);\n  --bs-alert-border-radius: 0.475rem;\n  --bs-alert-link-color: inherit;\n  position: relative;\n  padding: var(--bs-alert-padding-y) var(--bs-alert-padding-x);\n  margin-bottom: var(--bs-alert-margin-bottom);\n  color: var(--bs-alert-color);\n  background-color: var(--bs-alert-bg);\n  border: var(--bs-alert-border);\n  border-radius: var(--bs-alert-border-radius);\n}\n\n.alert-heading {\n  color: inherit;\n}\n\n.alert-link {\n  font-weight: 600;\n  color: var(--bs-alert-link-color);\n}\n\n.alert-dismissible {\n  padding-right: 3rem;\n}\n.alert-dismissible .btn-close {\n  position: absolute;\n  top: 0;\n  right: 0;\n  z-index: 2;\n  padding: 1.25rem 1rem;\n}\n\n.alert-light {\n  --bs-alert-color: var(--bs-light-text);\n  --bs-alert-bg: var(--bs-light-bg-subtle);\n  --bs-alert-border-color: var(--bs-light-border-subtle);\n  --bs-alert-link-color: var(--bs-light-text);\n}\n\n.alert-primary {\n  --bs-alert-color: var(--bs-primary-text);\n  --bs-alert-bg: var(--bs-primary-bg-subtle);\n  --bs-alert-border-color: var(--bs-primary-border-subtle);\n  --bs-alert-link-color: var(--bs-primary-text);\n}\n\n.alert-secondary {\n  --bs-alert-color: var(--bs-secondary-text);\n  --bs-alert-bg: var(--bs-secondary-bg-subtle);\n  --bs-alert-border-color: var(--bs-secondary-border-subtle);\n  --bs-alert-link-color: var(--bs-secondary-text);\n}\n\n.alert-success {\n  --bs-alert-color: var(--bs-success-text);\n  --bs-alert-bg: var(--bs-success-bg-subtle);\n  --bs-alert-border-color: var(--bs-success-border-subtle);\n  --bs-alert-link-color: var(--bs-success-text);\n}\n\n.alert-info {\n  --bs-alert-color: var(--bs-info-text);\n  --bs-alert-bg: var(--bs-info-bg-subtle);\n  --bs-alert-border-color: var(--bs-info-border-subtle);\n  --bs-alert-link-color: var(--bs-info-text);\n}\n\n.alert-warning {\n  --bs-alert-color: var(--bs-warning-text);\n  --bs-alert-bg: var(--bs-warning-bg-subtle);\n  --bs-alert-border-color: var(--bs-warning-border-subtle);\n  --bs-alert-link-color: var(--bs-warning-text);\n}\n\n.alert-danger {\n  --bs-alert-color: var(--bs-danger-text);\n  --bs-alert-bg: var(--bs-danger-bg-subtle);\n  --bs-alert-border-color: var(--bs-danger-border-subtle);\n  --bs-alert-link-color: var(--bs-danger-text);\n}\n\n.alert-dark {\n  --bs-alert-color: var(--bs-dark-text);\n  --bs-alert-bg: var(--bs-dark-bg-subtle);\n  --bs-alert-border-color: var(--bs-dark-border-subtle);\n  --bs-alert-link-color: var(--bs-dark-text);\n}\n\n@keyframes progress-bar-stripes {\n  0% {\n    background-position-x: 1rem;\n  }\n}\n.progress,\n.progress-stacked {\n  --bs-progress-height: 1rem;\n  --bs-progress-font-size: 0.75rem;\n  --bs-progress-bg: var(--bs-gray-100);\n  --bs-progress-border-radius: 6px;\n  --bs-progress-box-shadow: none;\n  --bs-progress-bar-color: #ffffff;\n  --bs-progress-bar-bg: #009ef7;\n  --bs-progress-bar-transition: width 0.6s ease;\n  display: flex;\n  height: var(--bs-progress-height);\n  overflow: hidden;\n  font-size: var(--bs-progress-font-size);\n  background-color: var(--bs-progress-bg);\n  border-radius: var(--bs-progress-border-radius);\n  box-shadow: var(--bs-progress-box-shadow);\n}\n\n.progress-bar {\n  display: flex;\n  flex-direction: column;\n  justify-content: center;\n  overflow: hidden;\n  color: var(--bs-progress-bar-color);\n  text-align: center;\n  white-space: nowrap;\n  background-color: var(--bs-progress-bar-bg);\n  transition: var(--bs-progress-bar-transition);\n}\n@media (prefers-reduced-motion: reduce) {\n  .progress-bar {\n    transition: none;\n  }\n}\n\n.progress-bar-striped {\n  background-image: linear-gradient(45deg, rgba(255, 255, 255, 0.15) 25%, transparent 25%, transparent 50%, rgba(255, 255, 255, 0.15) 50%, rgba(255, 255, 255, 0.15) 75%, transparent 75%, transparent);\n  background-size: var(--bs-progress-height) var(--bs-progress-height);\n}\n\n.progress-stacked > .progress {\n  overflow: visible;\n}\n\n.progress-stacked > .progress > .progress-bar {\n  width: 100%;\n}\n\n.progress-bar-animated {\n  animation: 1s linear infinite progress-bar-stripes;\n}\n@media (prefers-reduced-motion: reduce) {\n  .progress-bar-animated {\n    animation: none;\n  }\n}\n\n.list-group {\n  --bs-list-group-color: var(--bs-gray-900);\n  --bs-list-group-bg: #ffffff;\n  --bs-list-group-border-color: rgba(0, 0, 0, 0.125);\n  --bs-list-group-border-width: var(--bs-border-width);\n  --bs-list-group-border-radius: var(--bs-border-radius);\n  --bs-list-group-item-padding-x: 1rem;\n  --bs-list-group-item-padding-y: 0.5rem;\n  --bs-list-group-action-color: var(--bs-gray-700);\n  --bs-list-group-action-hover-color: var(--bs-gray-700);\n  --bs-list-group-action-hover-bg: var(--bs-gray-100);\n  --bs-list-group-action-active-color: var(--bs-body-color);\n  --bs-list-group-action-active-bg: var(--bs-gray-200);\n  --bs-list-group-disabled-color: var(--bs-gray-600);\n  --bs-list-group-disabled-bg: #ffffff;\n  --bs-list-group-active-color: var(--bs-component-active-color);\n  --bs-list-group-active-bg: var(--bs-component-active-bg);\n  --bs-list-group-active-border-color: var(--bs-component-active-bg);\n  display: flex;\n  flex-direction: column;\n  padding-left: 0;\n  margin-bottom: 0;\n  border-radius: var(--bs-list-group-border-radius);\n}\n\n.list-group-numbered {\n  list-style-type: none;\n  counter-reset: section;\n}\n.list-group-numbered > .list-group-item::before {\n  content: counters(section, \".\") \". \";\n  counter-increment: section;\n}\n\n.list-group-item-action {\n  width: 100%;\n  color: var(--bs-list-group-action-color);\n  text-align: inherit;\n}\n.list-group-item-action:hover, .list-group-item-action:focus {\n  z-index: 1;\n  color: var(--bs-list-group-action-hover-color);\n  text-decoration: none;\n  background-color: var(--bs-list-group-action-hover-bg);\n}\n.list-group-item-action:active {\n  color: var(--bs-list-group-action-active-color);\n  background-color: var(--bs-list-group-action-active-bg);\n}\n\n.list-group-item {\n  position: relative;\n  display: block;\n  padding: var(--bs-list-group-item-padding-y) var(--bs-list-group-item-padding-x);\n  color: var(--bs-list-group-color);\n  background-color: var(--bs-list-group-bg);\n  border: var(--bs-list-group-border-width) solid var(--bs-list-group-border-color);\n}\n.list-group-item:first-child {\n  border-top-left-radius: inherit;\n  border-top-right-radius: inherit;\n}\n.list-group-item:last-child {\n  border-bottom-right-radius: inherit;\n  border-bottom-left-radius: inherit;\n}\n.list-group-item.disabled, .list-group-item:disabled {\n  color: var(--bs-list-group-disabled-color);\n  pointer-events: none;\n  background-color: var(--bs-list-group-disabled-bg);\n}\n.list-group-item.active {\n  z-index: 2;\n  color: var(--bs-list-group-active-color);\n  background-color: var(--bs-list-group-active-bg);\n  border-color: var(--bs-list-group-active-border-color);\n}\n.list-group-item + .list-group-item {\n  border-top-width: 0;\n}\n.list-group-item + .list-group-item.active {\n  margin-top: calc(-1 * var(--bs-list-group-border-width));\n  border-top-width: var(--bs-list-group-border-width);\n}\n\n.list-group-horizontal {\n  flex-direction: row;\n}\n.list-group-horizontal > .list-group-item:first-child:not(:last-child) {\n  border-bottom-left-radius: var(--bs-list-group-border-radius);\n  border-top-right-radius: 0;\n}\n.list-group-horizontal > .list-group-item:last-child:not(:first-child) {\n  border-top-right-radius: var(--bs-list-group-border-radius);\n  border-bottom-left-radius: 0;\n}\n.list-group-horizontal > .list-group-item.active {\n  margin-top: 0;\n}\n.list-group-horizontal > .list-group-item + .list-group-item {\n  border-top-width: var(--bs-list-group-border-width);\n  border-left-width: 0;\n}\n.list-group-horizontal > .list-group-item + .list-group-item.active {\n  margin-left: calc(-1 * var(--bs-list-group-border-width));\n  border-left-width: var(--bs-list-group-border-width);\n}\n\n@media (min-width: 576px) {\n  .list-group-horizontal-sm {\n    flex-direction: row;\n  }\n  .list-group-horizontal-sm > .list-group-item:first-child:not(:last-child) {\n    border-bottom-left-radius: var(--bs-list-group-border-radius);\n    border-top-right-radius: 0;\n  }\n  .list-group-horizontal-sm > .list-group-item:last-child:not(:first-child) {\n    border-top-right-radius: var(--bs-list-group-border-radius);\n    border-bottom-left-radius: 0;\n  }\n  .list-group-horizontal-sm > .list-group-item.active {\n    margin-top: 0;\n  }\n  .list-group-horizontal-sm > .list-group-item + .list-group-item {\n    border-top-width: var(--bs-list-group-border-width);\n    border-left-width: 0;\n  }\n  .list-group-horizontal-sm > .list-group-item + .list-group-item.active {\n    margin-left: calc(-1 * var(--bs-list-group-border-width));\n    border-left-width: var(--bs-list-group-border-width);\n  }\n}\n@media (min-width: 768px) {\n  .list-group-horizontal-md {\n    flex-direction: row;\n  }\n  .list-group-horizontal-md > .list-group-item:first-child:not(:last-child) {\n    border-bottom-left-radius: var(--bs-list-group-border-radius);\n    border-top-right-radius: 0;\n  }\n  .list-group-horizontal-md > .list-group-item:last-child:not(:first-child) {\n    border-top-right-radius: var(--bs-list-group-border-radius);\n    border-bottom-left-radius: 0;\n  }\n  .list-group-horizontal-md > .list-group-item.active {\n    margin-top: 0;\n  }\n  .list-group-horizontal-md > .list-group-item + .list-group-item {\n    border-top-width: var(--bs-list-group-border-width);\n    border-left-width: 0;\n  }\n  .list-group-horizontal-md > .list-group-item + .list-group-item.active {\n    margin-left: calc(-1 * var(--bs-list-group-border-width));\n    border-left-width: var(--bs-list-group-border-width);\n  }\n}\n@media (min-width: 992px) {\n  .list-group-horizontal-lg {\n    flex-direction: row;\n  }\n  .list-group-horizontal-lg > .list-group-item:first-child:not(:last-child) {\n    border-bottom-left-radius: var(--bs-list-group-border-radius);\n    border-top-right-radius: 0;\n  }\n  .list-group-horizontal-lg > .list-group-item:last-child:not(:first-child) {\n    border-top-right-radius: var(--bs-list-group-border-radius);\n    border-bottom-left-radius: 0;\n  }\n  .list-group-horizontal-lg > .list-group-item.active {\n    margin-top: 0;\n  }\n  .list-group-horizontal-lg > .list-group-item + .list-group-item {\n    border-top-width: var(--bs-list-group-border-width);\n    border-left-width: 0;\n  }\n  .list-group-horizontal-lg > .list-group-item + .list-group-item.active {\n    margin-left: calc(-1 * var(--bs-list-group-border-width));\n    border-left-width: var(--bs-list-group-border-width);\n  }\n}\n@media (min-width: 1200px) {\n  .list-group-horizontal-xl {\n    flex-direction: row;\n  }\n  .list-group-horizontal-xl > .list-group-item:first-child:not(:last-child) {\n    border-bottom-left-radius: var(--bs-list-group-border-radius);\n    border-top-right-radius: 0;\n  }\n  .list-group-horizontal-xl > .list-group-item:last-child:not(:first-child) {\n    border-top-right-radius: var(--bs-list-group-border-radius);\n    border-bottom-left-radius: 0;\n  }\n  .list-group-horizontal-xl > .list-group-item.active {\n    margin-top: 0;\n  }\n  .list-group-horizontal-xl > .list-group-item + .list-group-item {\n    border-top-width: var(--bs-list-group-border-width);\n    border-left-width: 0;\n  }\n  .list-group-horizontal-xl > .list-group-item + .list-group-item.active {\n    margin-left: calc(-1 * var(--bs-list-group-border-width));\n    border-left-width: var(--bs-list-group-border-width);\n  }\n}\n@media (min-width: 1400px) {\n  .list-group-horizontal-xxl {\n    flex-direction: row;\n  }\n  .list-group-horizontal-xxl > .list-group-item:first-child:not(:last-child) {\n    border-bottom-left-radius: var(--bs-list-group-border-radius);\n    border-top-right-radius: 0;\n  }\n  .list-group-horizontal-xxl > .list-group-item:last-child:not(:first-child) {\n    border-top-right-radius: var(--bs-list-group-border-radius);\n    border-bottom-left-radius: 0;\n  }\n  .list-group-horizontal-xxl > .list-group-item.active {\n    margin-top: 0;\n  }\n  .list-group-horizontal-xxl > .list-group-item + .list-group-item {\n    border-top-width: var(--bs-list-group-border-width);\n    border-left-width: 0;\n  }\n  .list-group-horizontal-xxl > .list-group-item + .list-group-item.active {\n    margin-left: calc(-1 * var(--bs-list-group-border-width));\n    border-left-width: var(--bs-list-group-border-width);\n  }\n}\n.list-group-flush {\n  border-radius: 0;\n}\n.list-group-flush > .list-group-item {\n  border-width: 0 0 var(--bs-list-group-border-width);\n}\n.list-group-flush > .list-group-item:last-child {\n  border-bottom-width: 0;\n}\n\n.list-group-item-light {\n  --bs-list-group-color: var(--bs-light-text);\n  --bs-list-group-bg: var(--bs-light-bg-subtle);\n  --bs-list-group-border-color: var(--bs-light-border-subtle);\n}\n.list-group-item-light.list-group-item-action:hover, .list-group-item-light.list-group-item-action:focus {\n  --bs-list-group-action-hover-color: var(--bs-emphasis-color);\n  --bs-list-group-action-hover-bg: var(--bs-light-border-subtle);\n}\n.list-group-item-light.list-group-item-action:active {\n  --bs-list-group-active-color: var(--bs-emphasis-color);\n  --bs-list-group-active-bg: var(--bs-light-text);\n  --bs-list-group-active-border-color: var(--bs-light-text);\n}\n\n.list-group-item-primary {\n  --bs-list-group-color: var(--bs-primary-text);\n  --bs-list-group-bg: var(--bs-primary-bg-subtle);\n  --bs-list-group-border-color: var(--bs-primary-border-subtle);\n}\n.list-group-item-primary.list-group-item-action:hover, .list-group-item-primary.list-group-item-action:focus {\n  --bs-list-group-action-hover-color: var(--bs-emphasis-color);\n  --bs-list-group-action-hover-bg: var(--bs-primary-border-subtle);\n}\n.list-group-item-primary.list-group-item-action:active {\n  --bs-list-group-active-color: var(--bs-emphasis-color);\n  --bs-list-group-active-bg: var(--bs-primary-text);\n  --bs-list-group-active-border-color: var(--bs-primary-text);\n}\n\n.list-group-item-secondary {\n  --bs-list-group-color: var(--bs-secondary-text);\n  --bs-list-group-bg: var(--bs-secondary-bg-subtle);\n  --bs-list-group-border-color: var(--bs-secondary-border-subtle);\n}\n.list-group-item-secondary.list-group-item-action:hover, .list-group-item-secondary.list-group-item-action:focus {\n  --bs-list-group-action-hover-color: var(--bs-emphasis-color);\n  --bs-list-group-action-hover-bg: var(--bs-secondary-border-subtle);\n}\n.list-group-item-secondary.list-group-item-action:active {\n  --bs-list-group-active-color: var(--bs-emphasis-color);\n  --bs-list-group-active-bg: var(--bs-secondary-text);\n  --bs-list-group-active-border-color: var(--bs-secondary-text);\n}\n\n.list-group-item-success {\n  --bs-list-group-color: var(--bs-success-text);\n  --bs-list-group-bg: var(--bs-success-bg-subtle);\n  --bs-list-group-border-color: var(--bs-success-border-subtle);\n}\n.list-group-item-success.list-group-item-action:hover, .list-group-item-success.list-group-item-action:focus {\n  --bs-list-group-action-hover-color: var(--bs-emphasis-color);\n  --bs-list-group-action-hover-bg: var(--bs-success-border-subtle);\n}\n.list-group-item-success.list-group-item-action:active {\n  --bs-list-group-active-color: var(--bs-emphasis-color);\n  --bs-list-group-active-bg: var(--bs-success-text);\n  --bs-list-group-active-border-color: var(--bs-success-text);\n}\n\n.list-group-item-info {\n  --bs-list-group-color: var(--bs-info-text);\n  --bs-list-group-bg: var(--bs-info-bg-subtle);\n  --bs-list-group-border-color: var(--bs-info-border-subtle);\n}\n.list-group-item-info.list-group-item-action:hover, .list-group-item-info.list-group-item-action:focus {\n  --bs-list-group-action-hover-color: var(--bs-emphasis-color);\n  --bs-list-group-action-hover-bg: var(--bs-info-border-subtle);\n}\n.list-group-item-info.list-group-item-action:active {\n  --bs-list-group-active-color: var(--bs-emphasis-color);\n  --bs-list-group-active-bg: var(--bs-info-text);\n  --bs-list-group-active-border-color: var(--bs-info-text);\n}\n\n.list-group-item-warning {\n  --bs-list-group-color: var(--bs-warning-text);\n  --bs-list-group-bg: var(--bs-warning-bg-subtle);\n  --bs-list-group-border-color: var(--bs-warning-border-subtle);\n}\n.list-group-item-warning.list-group-item-action:hover, .list-group-item-warning.list-group-item-action:focus {\n  --bs-list-group-action-hover-color: var(--bs-emphasis-color);\n  --bs-list-group-action-hover-bg: var(--bs-warning-border-subtle);\n}\n.list-group-item-warning.list-group-item-action:active {\n  --bs-list-group-active-color: var(--bs-emphasis-color);\n  --bs-list-group-active-bg: var(--bs-warning-text);\n  --bs-list-group-active-border-color: var(--bs-warning-text);\n}\n\n.list-group-item-danger {\n  --bs-list-group-color: var(--bs-danger-text);\n  --bs-list-group-bg: var(--bs-danger-bg-subtle);\n  --bs-list-group-border-color: var(--bs-danger-border-subtle);\n}\n.list-group-item-danger.list-group-item-action:hover, .list-group-item-danger.list-group-item-action:focus {\n  --bs-list-group-action-hover-color: var(--bs-emphasis-color);\n  --bs-list-group-action-hover-bg: var(--bs-danger-border-subtle);\n}\n.list-group-item-danger.list-group-item-action:active {\n  --bs-list-group-active-color: var(--bs-emphasis-color);\n  --bs-list-group-active-bg: var(--bs-danger-text);\n  --bs-list-group-active-border-color: var(--bs-danger-text);\n}\n\n.list-group-item-dark {\n  --bs-list-group-color: var(--bs-dark-text);\n  --bs-list-group-bg: var(--bs-dark-bg-subtle);\n  --bs-list-group-border-color: var(--bs-dark-border-subtle);\n}\n.list-group-item-dark.list-group-item-action:hover, .list-group-item-dark.list-group-item-action:focus {\n  --bs-list-group-action-hover-color: var(--bs-emphasis-color);\n  --bs-list-group-action-hover-bg: var(--bs-dark-border-subtle);\n}\n.list-group-item-dark.list-group-item-action:active {\n  --bs-list-group-active-color: var(--bs-emphasis-color);\n  --bs-list-group-active-bg: var(--bs-dark-text);\n  --bs-list-group-active-border-color: var(--bs-dark-text);\n}\n\n.btn-close {\n  --bs-btn-close-color: #000000;\n  --bs-btn-close-bg: url(\"data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 16 16' fill='%23000000'%3e%3cpath d='M.293.293a1 1 0 0 1 1.414 0L8 6.586 14.293.293a1 1 0 1 1 1.414 1.414L9.414 8l6.293 6.293a1 1 0 0 1-1.414 1.414L8 9.414l-6.293 6.293a1 1 0 0 1-1.414-1.414L6.586 8 .293 1.707a1 1 0 0 1 0-1.414z'/%3e%3c/svg%3e\");\n  --bs-btn-close-opacity: 0.5;\n  --bs-btn-close-hover-opacity: 0.75;\n  --bs-btn-close-focus-shadow: none;\n  --bs-btn-close-focus-opacity: 1;\n  --bs-btn-close-disabled-opacity: 0.25;\n  --bs-btn-close-white-filter: invert(1) grayscale(100%) brightness(200%);\n  box-sizing: content-box;\n  width: 0.75rem;\n  height: 0.75rem;\n  padding: 0.25em 0.25em;\n  color: var(--bs-btn-close-color);\n  background: transparent var(--bs-btn-close-bg) center/0.75rem auto no-repeat;\n  border: 0;\n  border-radius: 0.475rem;\n  opacity: var(--bs-btn-close-opacity);\n}\n.btn-close:hover {\n  color: var(--bs-btn-close-color);\n  text-decoration: none;\n  opacity: var(--bs-btn-close-hover-opacity);\n}\n.btn-close:focus {\n  outline: 0;\n  box-shadow: var(--bs-btn-close-focus-shadow);\n  opacity: var(--bs-btn-close-focus-opacity);\n}\n.btn-close:disabled, .btn-close.disabled {\n  pointer-events: none;\n  user-select: none;\n  opacity: var(--bs-btn-close-disabled-opacity);\n}\n\n.btn-close-white {\n  filter: var(--bs-btn-close-white-filter);\n}\n\n[data-bs-theme=dark] .btn-close {\n  filter: var(--bs-btn-close-white-filter);\n}\n\n.toast {\n  --bs-toast-zindex: 1090;\n  --bs-toast-padding-x: 0.75rem;\n  --bs-toast-padding-y: 0.5rem;\n  --bs-toast-spacing: 1.5rem;\n  --bs-toast-max-width: 350px;\n  --bs-toast-font-size: 0.875rem;\n  --bs-toast-color: var(--bs-gray-700);\n  --bs-toast-bg: var(--bs-body-bg);\n  --bs-toast-border-width: var(--bs-border-width);\n  --bs-toast-border-color: transparent;\n  --bs-toast-border-radius: var(--bs-border-radius);\n  --bs-toast-box-shadow: var(--bs-box-shadow);\n  --bs-toast-header-color: var(--bs-gray-700);\n  --bs-toast-header-bg: var(--bs-body-bg);\n  --bs-toast-header-border-color: var(--bs-border-color);\n  width: var(--bs-toast-max-width);\n  max-width: 100%;\n  font-size: var(--bs-toast-font-size);\n  color: var(--bs-toast-color);\n  pointer-events: auto;\n  background-color: var(--bs-toast-bg);\n  background-clip: padding-box;\n  border: var(--bs-toast-border-width) solid var(--bs-toast-border-color);\n  box-shadow: var(--bs-toast-box-shadow);\n  border-radius: var(--bs-toast-border-radius);\n}\n.toast.showing {\n  opacity: 0;\n}\n.toast:not(.show) {\n  display: none;\n}\n\n.toast-container {\n  --bs-toast-zindex: 1090;\n  position: absolute;\n  z-index: var(--bs-toast-zindex);\n  width: max-content;\n  max-width: 100%;\n  pointer-events: none;\n}\n.toast-container > :not(:last-child) {\n  margin-bottom: var(--bs-toast-spacing);\n}\n\n.toast-header {\n  display: flex;\n  align-items: center;\n  padding: var(--bs-toast-padding-y) var(--bs-toast-padding-x);\n  color: var(--bs-toast-header-color);\n  background-color: var(--bs-toast-header-bg);\n  background-clip: padding-box;\n  border-bottom: var(--bs-toast-border-width) solid var(--bs-toast-header-border-color);\n  border-top-left-radius: calc(var(--bs-toast-border-radius) - var(--bs-toast-border-width));\n  border-top-right-radius: calc(var(--bs-toast-border-radius) - var(--bs-toast-border-width));\n}\n.toast-header .btn-close {\n  margin-right: calc(-0.5 * var(--bs-toast-padding-x));\n  margin-left: var(--bs-toast-padding-x);\n}\n\n.toast-body {\n  padding: var(--bs-toast-padding-x);\n  word-wrap: break-word;\n}\n\n.modal {\n  --bs-modal-zindex: 1055;\n  --bs-modal-width: 500px;\n  --bs-modal-padding: 1.75rem;\n  --bs-modal-margin: 0.5rem;\n  --bs-modal-color: ;\n  --bs-modal-bg: var(--bs-body-bg);\n  --bs-modal-border-color: var(--bs-border-color-translucent);\n  --bs-modal-border-width: 0;\n  --bs-modal-border-radius: 0.475rem;\n  --bs-modal-box-shadow: 0 0.25rem 0.5rem rgba(0, 0, 0, 0.1);\n  --bs-modal-inner-border-radius: 0.475rem;\n  --bs-modal-header-padding-x: 1.75rem;\n  --bs-modal-header-padding-y: 1.75rem;\n  --bs-modal-header-padding: 1.75rem 1.75rem;\n  --bs-modal-header-border-color: var(--bs-border-color);\n  --bs-modal-header-border-width: 1px;\n  --bs-modal-title-line-height: 1.5;\n  --bs-modal-footer-gap: 0.5rem;\n  --bs-modal-footer-bg: ;\n  --bs-modal-footer-border-color: var(--bs-border-color);\n  --bs-modal-footer-border-width: 1px;\n  position: fixed;\n  top: 0;\n  left: 0;\n  z-index: var(--bs-modal-zindex);\n  display: none;\n  width: 100%;\n  height: 100%;\n  overflow-x: hidden;\n  overflow-y: auto;\n  outline: 0;\n}\n\n.modal-dialog {\n  position: relative;\n  width: auto;\n  margin: var(--bs-modal-margin);\n  pointer-events: none;\n}\n.modal.fade .modal-dialog {\n  transition: transform 0.3s ease-out;\n  transform: translate(0, -50px);\n}\n@media (prefers-reduced-motion: reduce) {\n  .modal.fade .modal-dialog {\n    transition: none;\n  }\n}\n.modal.show .modal-dialog {\n  transform: none;\n}\n.modal.modal-static .modal-dialog {\n  transform: scale(1.02);\n}\n\n.modal-dialog-scrollable {\n  height: calc(100% - var(--bs-modal-margin) * 2);\n}\n.modal-dialog-scrollable .modal-content {\n  max-height: 100%;\n  overflow: hidden;\n}\n.modal-dialog-scrollable .modal-body {\n  overflow-y: auto;\n}\n\n.modal-dialog-centered {\n  display: flex;\n  align-items: center;\n  min-height: calc(100% - var(--bs-modal-margin) * 2);\n}\n\n.modal-content {\n  position: relative;\n  display: flex;\n  flex-direction: column;\n  width: 100%;\n  color: var(--bs-modal-color);\n  pointer-events: auto;\n  background-color: var(--bs-modal-bg);\n  background-clip: padding-box;\n  border: var(--bs-modal-border-width) solid var(--bs-modal-border-color);\n  border-radius: var(--bs-modal-border-radius);\n  box-shadow: var(--bs-modal-box-shadow);\n  outline: 0;\n}\n\n.modal-backdrop {\n  --bs-backdrop-zindex: 1050;\n  --bs-backdrop-bg: #000000;\n  --bs-backdrop-opacity: 0.4;\n  position: fixed;\n  top: 0;\n  left: 0;\n  z-index: var(--bs-backdrop-zindex);\n  width: 100vw;\n  height: 100vh;\n  background-color: var(--bs-backdrop-bg);\n}\n.modal-backdrop.fade {\n  opacity: 0;\n}\n.modal-backdrop.show {\n  opacity: var(--bs-backdrop-opacity);\n}\n\n.modal-header {\n  display: flex;\n  flex-shrink: 0;\n  align-items: center;\n  justify-content: space-between;\n  padding: var(--bs-modal-header-padding);\n  border-bottom: var(--bs-modal-header-border-width) solid var(--bs-modal-header-border-color);\n  border-top-left-radius: var(--bs-modal-inner-border-radius);\n  border-top-right-radius: var(--bs-modal-inner-border-radius);\n}\n.modal-header .btn-close {\n  padding: calc(var(--bs-modal-header-padding-y) * 0.5) calc(var(--bs-modal-header-padding-x) * 0.5);\n  margin: calc(-0.5 * var(--bs-modal-header-padding-y)) calc(-0.5 * var(--bs-modal-header-padding-x)) calc(-0.5 * var(--bs-modal-header-padding-y)) auto;\n}\n\n.modal-title {\n  margin-bottom: 0;\n  line-height: var(--bs-modal-title-line-height);\n}\n\n.modal-body {\n  position: relative;\n  flex: 1 1 auto;\n  padding: var(--bs-modal-padding);\n}\n\n.modal-footer {\n  display: flex;\n  flex-shrink: 0;\n  flex-wrap: wrap;\n  align-items: center;\n  justify-content: flex-end;\n  padding: calc(var(--bs-modal-padding) - var(--bs-modal-footer-gap) * 0.5);\n  background-color: var(--bs-modal-footer-bg);\n  border-top: var(--bs-modal-footer-border-width) solid var(--bs-modal-footer-border-color);\n  border-bottom-right-radius: var(--bs-modal-inner-border-radius);\n  border-bottom-left-radius: var(--bs-modal-inner-border-radius);\n}\n.modal-footer > * {\n  margin: calc(var(--bs-modal-footer-gap) * 0.5);\n}\n\n@media (min-width: 576px) {\n  .modal {\n    --bs-modal-margin: 1.75rem;\n    --bs-modal-box-shadow: 0 0.5rem 1rem rgba(0, 0, 0, 0.1);\n  }\n  .modal-dialog {\n    max-width: var(--bs-modal-width);\n    margin-right: auto;\n    margin-left: auto;\n  }\n  .modal-sm {\n    --bs-modal-width: 300px;\n  }\n}\n@media (min-width: 992px) {\n  .modal-lg,\n.modal-xl {\n    --bs-modal-width: 800px;\n  }\n}\n@media (min-width: 1200px) {\n  .modal-xl {\n    --bs-modal-width: 1140px;\n  }\n}\n.modal-fullscreen {\n  width: 100vw;\n  max-width: none;\n  height: 100%;\n  margin: 0;\n}\n.modal-fullscreen .modal-content {\n  height: 100%;\n  border: 0;\n  border-radius: 0;\n}\n.modal-fullscreen .modal-header,\n.modal-fullscreen .modal-footer {\n  border-radius: 0;\n}\n.modal-fullscreen .modal-body {\n  overflow-y: auto;\n}\n\n@media (max-width: 575.98px) {\n  .modal-fullscreen-sm-down {\n    width: 100vw;\n    max-width: none;\n    height: 100%;\n    margin: 0;\n  }\n  .modal-fullscreen-sm-down .modal-content {\n    height: 100%;\n    border: 0;\n    border-radius: 0;\n  }\n  .modal-fullscreen-sm-down .modal-header,\n.modal-fullscreen-sm-down .modal-footer {\n    border-radius: 0;\n  }\n  .modal-fullscreen-sm-down .modal-body {\n    overflow-y: auto;\n  }\n}\n@media (max-width: 767.98px) {\n  .modal-fullscreen-md-down {\n    width: 100vw;\n    max-width: none;\n    height: 100%;\n    margin: 0;\n  }\n  .modal-fullscreen-md-down .modal-content {\n    height: 100%;\n    border: 0;\n    border-radius: 0;\n  }\n  .modal-fullscreen-md-down .modal-header,\n.modal-fullscreen-md-down .modal-footer {\n    border-radius: 0;\n  }\n  .modal-fullscreen-md-down .modal-body {\n    overflow-y: auto;\n  }\n}\n@media (max-width: 991.98px) {\n  .modal-fullscreen-lg-down {\n    width: 100vw;\n    max-width: none;\n    height: 100%;\n    margin: 0;\n  }\n  .modal-fullscreen-lg-down .modal-content {\n    height: 100%;\n    border: 0;\n    border-radius: 0;\n  }\n  .modal-fullscreen-lg-down .modal-header,\n.modal-fullscreen-lg-down .modal-footer {\n    border-radius: 0;\n  }\n  .modal-fullscreen-lg-down .modal-body {\n    overflow-y: auto;\n  }\n}\n@media (max-width: 1199.98px) {\n  .modal-fullscreen-xl-down {\n    width: 100vw;\n    max-width: none;\n    height: 100%;\n    margin: 0;\n  }\n  .modal-fullscreen-xl-down .modal-content {\n    height: 100%;\n    border: 0;\n    border-radius: 0;\n  }\n  .modal-fullscreen-xl-down .modal-header,\n.modal-fullscreen-xl-down .modal-footer {\n    border-radius: 0;\n  }\n  .modal-fullscreen-xl-down .modal-body {\n    overflow-y: auto;\n  }\n}\n@media (max-width: 1399.98px) {\n  .modal-fullscreen-xxl-down {\n    width: 100vw;\n    max-width: none;\n    height: 100%;\n    margin: 0;\n  }\n  .modal-fullscreen-xxl-down .modal-content {\n    height: 100%;\n    border: 0;\n    border-radius: 0;\n  }\n  .modal-fullscreen-xxl-down .modal-header,\n.modal-fullscreen-xxl-down .modal-footer {\n    border-radius: 0;\n  }\n  .modal-fullscreen-xxl-down .modal-body {\n    overflow-y: auto;\n  }\n}\n.tooltip {\n  --bs-tooltip-zindex: 1080;\n  --bs-tooltip-max-width: 200px;\n  --bs-tooltip-padding-x: 1rem;\n  --bs-tooltip-padding-y: 0.75rem;\n  --bs-tooltip-margin: 0;\n  --bs-tooltip-font-size: 1rem;\n  --bs-tooltip-color: var(--bs-gray-800);\n  --bs-tooltip-bg: var(--bs-body-bg);\n  --bs-tooltip-border-radius: 0.475rem;\n  --bs-tooltip-opacity: 1;\n  --bs-tooltip-arrow-width: 0.8rem;\n  --bs-tooltip-arrow-height: 0.4rem;\n  z-index: var(--bs-tooltip-zindex);\n  display: block;\n  padding: var(--bs-tooltip-arrow-height);\n  margin: var(--bs-tooltip-margin);\n  font-family: var(--bs-font-sans-serif);\n  font-style: normal;\n  font-weight: 400;\n  line-height: 1.5;\n  text-align: left;\n  text-align: start;\n  text-decoration: none;\n  text-shadow: none;\n  text-transform: none;\n  letter-spacing: normal;\n  word-break: normal;\n  white-space: normal;\n  word-spacing: normal;\n  line-break: auto;\n  font-size: var(--bs-tooltip-font-size);\n  word-wrap: break-word;\n  opacity: 0;\n}\n.tooltip.show {\n  opacity: var(--bs-tooltip-opacity);\n}\n.tooltip .tooltip-arrow {\n  display: block;\n  width: var(--bs-tooltip-arrow-width);\n  height: var(--bs-tooltip-arrow-height);\n}\n.tooltip .tooltip-arrow::before {\n  position: absolute;\n  content: \"\";\n  border-color: transparent;\n  border-style: solid;\n}\n\n.bs-tooltip-top .tooltip-arrow, .bs-tooltip-auto[data-popper-placement^=top] .tooltip-arrow {\n  bottom: 0;\n}\n.bs-tooltip-top .tooltip-arrow::before, .bs-tooltip-auto[data-popper-placement^=top] .tooltip-arrow::before {\n  top: -1px;\n  border-width: var(--bs-tooltip-arrow-height) calc(var(--bs-tooltip-arrow-width) * 0.5) 0;\n  border-top-color: var(--bs-tooltip-bg);\n}\n\n/* rtl:begin:ignore */\n.bs-tooltip-end .tooltip-arrow, .bs-tooltip-auto[data-popper-placement^=right] .tooltip-arrow {\n  left: 0;\n  width: var(--bs-tooltip-arrow-height);\n  height: var(--bs-tooltip-arrow-width);\n}\n.bs-tooltip-end .tooltip-arrow::before, .bs-tooltip-auto[data-popper-placement^=right] .tooltip-arrow::before {\n  right: -1px;\n  border-width: calc(var(--bs-tooltip-arrow-width) * 0.5) var(--bs-tooltip-arrow-height) calc(var(--bs-tooltip-arrow-width) * 0.5) 0;\n  border-right-color: var(--bs-tooltip-bg);\n}\n\n/* rtl:end:ignore */\n.bs-tooltip-bottom .tooltip-arrow, .bs-tooltip-auto[data-popper-placement^=bottom] .tooltip-arrow {\n  top: 0;\n}\n.bs-tooltip-bottom .tooltip-arrow::before, .bs-tooltip-auto[data-popper-placement^=bottom] .tooltip-arrow::before {\n  bottom: -1px;\n  border-width: 0 calc(var(--bs-tooltip-arrow-width) * 0.5) var(--bs-tooltip-arrow-height);\n  border-bottom-color: var(--bs-tooltip-bg);\n}\n\n/* rtl:begin:ignore */\n.bs-tooltip-start .tooltip-arrow, .bs-tooltip-auto[data-popper-placement^=left] .tooltip-arrow {\n  right: 0;\n  width: var(--bs-tooltip-arrow-height);\n  height: var(--bs-tooltip-arrow-width);\n}\n.bs-tooltip-start .tooltip-arrow::before, .bs-tooltip-auto[data-popper-placement^=left] .tooltip-arrow::before {\n  left: -1px;\n  border-width: calc(var(--bs-tooltip-arrow-width) * 0.5) 0 calc(var(--bs-tooltip-arrow-width) * 0.5) var(--bs-tooltip-arrow-height);\n  border-left-color: var(--bs-tooltip-bg);\n}\n\n/* rtl:end:ignore */\n.tooltip-inner {\n  max-width: var(--bs-tooltip-max-width);\n  padding: var(--bs-tooltip-padding-y) var(--bs-tooltip-padding-x);\n  color: var(--bs-tooltip-color);\n  text-align: center;\n  background-color: var(--bs-tooltip-bg);\n  border-radius: var(--bs-tooltip-border-radius);\n}\n\n.popover {\n  --bs-popover-zindex: 1070;\n  --bs-popover-max-width: 276px;\n  --bs-popover-font-size: 1rem;\n  --bs-popover-bg: #ffffff;\n  --bs-popover-border-width: var(--bs-border-width);\n  --bs-popover-border-color: #ffffff;\n  --bs-popover-border-radius: 0.475rem;\n  --bs-popover-inner-border-radius: 0.475rem;\n  --bs-popover-box-shadow: 0px 0px 50px 0px rgba(82, 63, 105, 0.15);\n  --bs-popover-header-padding-x: 1.25rem;\n  --bs-popover-header-padding-y: 1rem;\n  --bs-popover-header-font-size: 1rem;\n  --bs-popover-header-color: var(--bs-gray-800);\n  --bs-popover-header-bg: #ffffff;\n  --bs-popover-body-padding-x: 1.25rem;\n  --bs-popover-body-padding-y: 1.25rem;\n  --bs-popover-body-color: var(--bs-gray-800);\n  --bs-popover-arrow-width: 1rem;\n  --bs-popover-arrow-height: 0.5rem;\n  --bs-popover-arrow-border: var(--bs-popover-border-color);\n  z-index: var(--bs-popover-zindex);\n  display: block;\n  max-width: var(--bs-popover-max-width);\n  font-family: var(--bs-font-sans-serif);\n  font-style: normal;\n  font-weight: 400;\n  line-height: 1.5;\n  text-align: left;\n  text-align: start;\n  text-decoration: none;\n  text-shadow: none;\n  text-transform: none;\n  letter-spacing: normal;\n  word-break: normal;\n  white-space: normal;\n  word-spacing: normal;\n  line-break: auto;\n  font-size: var(--bs-popover-font-size);\n  word-wrap: break-word;\n  background-color: var(--bs-popover-bg);\n  background-clip: padding-box;\n  border: var(--bs-popover-border-width) solid var(--bs-popover-border-color);\n  border-radius: var(--bs-popover-border-radius);\n  box-shadow: var(--bs-popover-box-shadow);\n}\n.popover .popover-arrow {\n  display: block;\n  width: var(--bs-popover-arrow-width);\n  height: var(--bs-popover-arrow-height);\n}\n.popover .popover-arrow::before, .popover .popover-arrow::after {\n  position: absolute;\n  display: block;\n  content: \"\";\n  border-color: transparent;\n  border-style: solid;\n  border-width: 0;\n}\n\n.bs-popover-top > .popover-arrow, .bs-popover-auto[data-popper-placement^=top] > .popover-arrow {\n  bottom: calc(-1 * (var(--bs-popover-arrow-height)) - var(--bs-popover-border-width));\n}\n.bs-popover-top > .popover-arrow::before, .bs-popover-auto[data-popper-placement^=top] > .popover-arrow::before, .bs-popover-top > .popover-arrow::after, .bs-popover-auto[data-popper-placement^=top] > .popover-arrow::after {\n  border-width: var(--bs-popover-arrow-height) calc(var(--bs-popover-arrow-width) * 0.5) 0;\n}\n.bs-popover-top > .popover-arrow::before, .bs-popover-auto[data-popper-placement^=top] > .popover-arrow::before {\n  bottom: 0;\n  border-top-color: var(--bs-popover-arrow-border);\n}\n.bs-popover-top > .popover-arrow::after, .bs-popover-auto[data-popper-placement^=top] > .popover-arrow::after {\n  bottom: var(--bs-popover-border-width);\n  border-top-color: var(--bs-popover-bg);\n}\n\n/* rtl:begin:ignore */\n.bs-popover-end > .popover-arrow, .bs-popover-auto[data-popper-placement^=right] > .popover-arrow {\n  left: calc(-1 * (var(--bs-popover-arrow-height)) - var(--bs-popover-border-width));\n  width: var(--bs-popover-arrow-height);\n  height: var(--bs-popover-arrow-width);\n}\n.bs-popover-end > .popover-arrow::before, .bs-popover-auto[data-popper-placement^=right] > .popover-arrow::before, .bs-popover-end > .popover-arrow::after, .bs-popover-auto[data-popper-placement^=right] > .popover-arrow::after {\n  border-width: calc(var(--bs-popover-arrow-width) * 0.5) var(--bs-popover-arrow-height) calc(var(--bs-popover-arrow-width) * 0.5) 0;\n}\n.bs-popover-end > .popover-arrow::before, .bs-popover-auto[data-popper-placement^=right] > .popover-arrow::before {\n  left: 0;\n  border-right-color: var(--bs-popover-arrow-border);\n}\n.bs-popover-end > .popover-arrow::after, .bs-popover-auto[data-popper-placement^=right] > .popover-arrow::after {\n  left: var(--bs-popover-border-width);\n  border-right-color: var(--bs-popover-bg);\n}\n\n/* rtl:end:ignore */\n.bs-popover-bottom > .popover-arrow, .bs-popover-auto[data-popper-placement^=bottom] > .popover-arrow {\n  top: calc(-1 * (var(--bs-popover-arrow-height)) - var(--bs-popover-border-width));\n}\n.bs-popover-bottom > .popover-arrow::before, .bs-popover-auto[data-popper-placement^=bottom] > .popover-arrow::before, .bs-popover-bottom > .popover-arrow::after, .bs-popover-auto[data-popper-placement^=bottom] > .popover-arrow::after {\n  border-width: 0 calc(var(--bs-popover-arrow-width) * 0.5) var(--bs-popover-arrow-height);\n}\n.bs-popover-bottom > .popover-arrow::before, .bs-popover-auto[data-popper-placement^=bottom] > .popover-arrow::before {\n  top: 0;\n  border-bottom-color: var(--bs-popover-arrow-border);\n}\n.bs-popover-bottom > .popover-arrow::after, .bs-popover-auto[data-popper-placement^=bottom] > .popover-arrow::after {\n  top: var(--bs-popover-border-width);\n  border-bottom-color: var(--bs-popover-bg);\n}\n.bs-popover-bottom .popover-header::before, .bs-popover-auto[data-popper-placement^=bottom] .popover-header::before {\n  position: absolute;\n  top: 0;\n  left: 50%;\n  display: block;\n  width: var(--bs-popover-arrow-width);\n  margin-left: calc(-0.5 * var(--bs-popover-arrow-width));\n  content: \"\";\n  border-bottom: var(--bs-popover-border-width) solid var(--bs-popover-header-bg);\n}\n\n/* rtl:begin:ignore */\n.bs-popover-start > .popover-arrow, .bs-popover-auto[data-popper-placement^=left] > .popover-arrow {\n  right: calc(-1 * (var(--bs-popover-arrow-height)) - var(--bs-popover-border-width));\n  width: var(--bs-popover-arrow-height);\n  height: var(--bs-popover-arrow-width);\n}\n.bs-popover-start > .popover-arrow::before, .bs-popover-auto[data-popper-placement^=left] > .popover-arrow::before, .bs-popover-start > .popover-arrow::after, .bs-popover-auto[data-popper-placement^=left] > .popover-arrow::after {\n  border-width: calc(var(--bs-popover-arrow-width) * 0.5) 0 calc(var(--bs-popover-arrow-width) * 0.5) var(--bs-popover-arrow-height);\n}\n.bs-popover-start > .popover-arrow::before, .bs-popover-auto[data-popper-placement^=left] > .popover-arrow::before {\n  right: 0;\n  border-left-color: var(--bs-popover-arrow-border);\n}\n.bs-popover-start > .popover-arrow::after, .bs-popover-auto[data-popper-placement^=left] > .popover-arrow::after {\n  right: var(--bs-popover-border-width);\n  border-left-color: var(--bs-popover-bg);\n}\n\n/* rtl:end:ignore */\n.popover-header {\n  padding: var(--bs-popover-header-padding-y) var(--bs-popover-header-padding-x);\n  margin-bottom: 0;\n  font-size: var(--bs-popover-header-font-size);\n  color: var(--bs-popover-header-color);\n  background-color: var(--bs-popover-header-bg);\n  border-bottom: var(--bs-popover-border-width) solid var(--bs-popover-border-color);\n  border-top-left-radius: var(--bs-popover-inner-border-radius);\n  border-top-right-radius: var(--bs-popover-inner-border-radius);\n}\n.popover-header:empty {\n  display: none;\n}\n\n.popover-body {\n  padding: var(--bs-popover-body-padding-y) var(--bs-popover-body-padding-x);\n  color: var(--bs-popover-body-color);\n}\n\n.carousel {\n  position: relative;\n}\n\n.carousel.pointer-event {\n  touch-action: pan-y;\n}\n\n.carousel-inner {\n  position: relative;\n  width: 100%;\n  overflow: hidden;\n}\n.carousel-inner::after {\n  display: block;\n  clear: both;\n  content: \"\";\n}\n\n.carousel-item {\n  position: relative;\n  display: none;\n  float: left;\n  width: 100%;\n  margin-right: -100%;\n  backface-visibility: hidden;\n  transition: transform 0.6s ease-in-out;\n}\n@media (prefers-reduced-motion: reduce) {\n  .carousel-item {\n    transition: none;\n  }\n}\n\n.carousel-item.active,\n.carousel-item-next,\n.carousel-item-prev {\n  display: block;\n}\n\n.carousel-item-next:not(.carousel-item-start),\n.active.carousel-item-end {\n  transform: translateX(100%);\n}\n\n.carousel-item-prev:not(.carousel-item-end),\n.active.carousel-item-start {\n  transform: translateX(-100%);\n}\n\n.carousel-fade .carousel-item {\n  opacity: 0;\n  transition-property: opacity;\n  transform: none;\n}\n.carousel-fade .carousel-item.active,\n.carousel-fade .carousel-item-next.carousel-item-start,\n.carousel-fade .carousel-item-prev.carousel-item-end {\n  z-index: 1;\n  opacity: 1;\n}\n.carousel-fade .active.carousel-item-start,\n.carousel-fade .active.carousel-item-end {\n  z-index: 0;\n  opacity: 0;\n  transition: opacity 0s 0.6s;\n}\n@media (prefers-reduced-motion: reduce) {\n  .carousel-fade .active.carousel-item-start,\n.carousel-fade .active.carousel-item-end {\n    transition: none;\n  }\n}\n\n.carousel-control-prev,\n.carousel-control-next {\n  position: absolute;\n  top: 0;\n  bottom: 0;\n  z-index: 1;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  width: 15%;\n  padding: 0;\n  color: #ffffff;\n  text-align: center;\n  background: none;\n  border: 0;\n  opacity: 0.5;\n  transition: opacity 0.15s ease;\n}\n@media (prefers-reduced-motion: reduce) {\n  .carousel-control-prev,\n.carousel-control-next {\n    transition: none;\n  }\n}\n.carousel-control-prev:hover, .carousel-control-prev:focus,\n.carousel-control-next:hover,\n.carousel-control-next:focus {\n  color: #ffffff;\n  text-decoration: none;\n  outline: 0;\n  opacity: 0.9;\n}\n\n.carousel-control-prev {\n  left: 0;\n}\n\n.carousel-control-next {\n  right: 0;\n}\n\n.carousel-control-prev-icon,\n.carousel-control-next-icon {\n  display: inline-block;\n  width: 2rem;\n  height: 2rem;\n  background-repeat: no-repeat;\n  background-position: 50%;\n  background-size: 100% 100%;\n}\n\n/* rtl:options: {\n  \"autoRename\": true,\n  \"stringMap\":[ {\n    \"name\"    : \"prev-next\",\n    \"search\"  : \"prev\",\n    \"replace\" : \"next\"\n  } ]\n} */\n.carousel-control-prev-icon {\n  background-image: url(\"data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 16 16' fill='%23ffffff'%3e%3cpath d='M11.354 1.646a.5.5 0 0 1 0 .708L5.707 8l5.647 5.646a.5.5 0 0 1-.708.708l-6-6a.5.5 0 0 1 0-.708l6-6a.5.5 0 0 1 .708 0z'/%3e%3c/svg%3e\");\n}\n\n.carousel-control-next-icon {\n  background-image: url(\"data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 16 16' fill='%23ffffff'%3e%3cpath d='M4.646 1.646a.5.5 0 0 1 .708 0l6 6a.5.5 0 0 1 0 .708l-6 6a.5.5 0 0 1-.708-.708L10.293 8 4.646 2.354a.5.5 0 0 1 0-.708z'/%3e%3c/svg%3e\");\n}\n\n.carousel-indicators {\n  position: absolute;\n  right: 0;\n  bottom: 0;\n  left: 0;\n  z-index: 2;\n  display: flex;\n  justify-content: center;\n  padding: 0;\n  margin-right: 15%;\n  margin-bottom: 1rem;\n  margin-left: 15%;\n  list-style: none;\n}\n.carousel-indicators [data-bs-target] {\n  box-sizing: content-box;\n  flex: 0 1 auto;\n  width: 30px;\n  height: 3px;\n  padding: 0;\n  margin-right: 3px;\n  margin-left: 3px;\n  text-indent: -999px;\n  cursor: pointer;\n  background-color: #ffffff;\n  background-clip: padding-box;\n  border: 0;\n  border-top: 10px solid transparent;\n  border-bottom: 10px solid transparent;\n  opacity: 0.5;\n  transition: opacity 0.6s ease;\n}\n@media (prefers-reduced-motion: reduce) {\n  .carousel-indicators [data-bs-target] {\n    transition: none;\n  }\n}\n.carousel-indicators .active {\n  opacity: 1;\n}\n\n.carousel-caption {\n  position: absolute;\n  right: 15%;\n  bottom: 1.25rem;\n  left: 15%;\n  padding-top: 1.25rem;\n  padding-bottom: 1.25rem;\n  color: #ffffff;\n  text-align: center;\n}\n\n.carousel-dark .carousel-control-prev-icon,\n.carousel-dark .carousel-control-next-icon {\n  filter: invert(1) grayscale(100);\n}\n.carousel-dark .carousel-indicators [data-bs-target] {\n  background-color: #000000;\n}\n.carousel-dark .carousel-caption {\n  color: #000000;\n}\n\n[data-bs-theme=dark] .carousel .carousel-control-prev-icon,\n[data-bs-theme=dark] .carousel .carousel-control-next-icon {\n  filter: invert(1) grayscale(100);\n}\n[data-bs-theme=dark] .carousel .carousel-indicators [data-bs-target] {\n  background-color: #000000;\n}\n[data-bs-theme=dark] .carousel .carousel-caption {\n  color: #000000;\n}\n\n.spinner-grow,\n.spinner-border {\n  display: inline-block;\n  width: var(--bs-spinner-width);\n  height: var(--bs-spinner-height);\n  vertical-align: var(--bs-spinner-vertical-align);\n  border-radius: 50%;\n  animation: var(--bs-spinner-animation-speed) linear infinite var(--bs-spinner-animation-name);\n}\n\n@keyframes spinner-border {\n  to {\n    transform: rotate(360deg) /* rtl:ignore */;\n  }\n}\n.spinner-border {\n  --bs-spinner-width: 2rem;\n  --bs-spinner-height: 2rem;\n  --bs-spinner-vertical-align: -0.125em;\n  --bs-spinner-border-width: 0.185rem;\n  --bs-spinner-animation-speed: 0.65s;\n  --bs-spinner-animation-name: spinner-border;\n  border: var(--bs-spinner-border-width) solid currentcolor;\n  border-right-color: transparent;\n}\n\n.spinner-border-sm {\n  --bs-spinner-width: 1rem;\n  --bs-spinner-height: 1rem;\n  --bs-spinner-border-width: 0.145em;\n}\n\n@keyframes spinner-grow {\n  0% {\n    transform: scale(0);\n  }\n  50% {\n    opacity: 1;\n    transform: none;\n  }\n}\n.spinner-grow {\n  --bs-spinner-width: 2rem;\n  --bs-spinner-height: 2rem;\n  --bs-spinner-vertical-align: -0.125em;\n  --bs-spinner-animation-speed: 0.65s;\n  --bs-spinner-animation-name: spinner-grow;\n  background-color: currentcolor;\n  opacity: 0;\n}\n\n.spinner-grow-sm {\n  --bs-spinner-width: 1rem;\n  --bs-spinner-height: 1rem;\n}\n\n@media (prefers-reduced-motion: reduce) {\n  .spinner-border,\n.spinner-grow {\n    --bs-spinner-animation-speed: 1.3s;\n  }\n}\n.offcanvas, .offcanvas-xxl, .offcanvas-xl, .offcanvas-lg, .offcanvas-md, .offcanvas-sm {\n  --bs-offcanvas-zindex: 1045;\n  --bs-offcanvas-width: 400px;\n  --bs-offcanvas-height: 30vh;\n  --bs-offcanvas-padding-x: 1.75rem;\n  --bs-offcanvas-padding-y: 1.75rem;\n  --bs-offcanvas-color: var(--bs-body-color);\n  --bs-offcanvas-bg: var(--bs-body-bg);\n  --bs-offcanvas-border-width: 0;\n  --bs-offcanvas-border-color: var(--bs-border-color-translucent);\n  --bs-offcanvas-box-shadow: 0 0.25rem 0.5rem rgba(0, 0, 0, 0.1);\n  --bs-offcanvas-transition: transform 0.3s ease-in-out;\n  --bs-offcanvas-title-line-height: 1.5;\n}\n\n@media (max-width: 575.98px) {\n  .offcanvas-sm {\n    position: fixed;\n    bottom: 0;\n    z-index: var(--bs-offcanvas-zindex);\n    display: flex;\n    flex-direction: column;\n    max-width: 100%;\n    color: var(--bs-offcanvas-color);\n    visibility: hidden;\n    background-color: var(--bs-offcanvas-bg);\n    background-clip: padding-box;\n    outline: 0;\n    box-shadow: var(--bs-offcanvas-box-shadow);\n    transition: var(--bs-offcanvas-transition);\n  }\n}\n@media (max-width: 575.98px) and (prefers-reduced-motion: reduce) {\n  .offcanvas-sm {\n    transition: none;\n  }\n}\n@media (max-width: 575.98px) {\n  .offcanvas-sm.offcanvas-start {\n    top: 0;\n    left: 0;\n    width: var(--bs-offcanvas-width);\n    border-right: var(--bs-offcanvas-border-width) solid var(--bs-offcanvas-border-color);\n    transform: translateX(-100%);\n  }\n}\n@media (max-width: 575.98px) {\n  .offcanvas-sm.offcanvas-end {\n    top: 0;\n    right: 0;\n    width: var(--bs-offcanvas-width);\n    border-left: var(--bs-offcanvas-border-width) solid var(--bs-offcanvas-border-color);\n    transform: translateX(100%);\n  }\n}\n@media (max-width: 575.98px) {\n  .offcanvas-sm.offcanvas-top {\n    top: 0;\n    right: 0;\n    left: 0;\n    height: var(--bs-offcanvas-height);\n    max-height: 100%;\n    border-bottom: var(--bs-offcanvas-border-width) solid var(--bs-offcanvas-border-color);\n    transform: translateY(-100%);\n  }\n}\n@media (max-width: 575.98px) {\n  .offcanvas-sm.offcanvas-bottom {\n    right: 0;\n    left: 0;\n    height: var(--bs-offcanvas-height);\n    max-height: 100%;\n    border-top: var(--bs-offcanvas-border-width) solid var(--bs-offcanvas-border-color);\n    transform: translateY(100%);\n  }\n}\n@media (max-width: 575.98px) {\n  .offcanvas-sm.showing, .offcanvas-sm.show:not(.hiding) {\n    transform: none;\n  }\n}\n@media (max-width: 575.98px) {\n  .offcanvas-sm.showing, .offcanvas-sm.hiding, .offcanvas-sm.show {\n    visibility: visible;\n  }\n}\n@media (min-width: 576px) {\n  .offcanvas-sm {\n    --bs-offcanvas-height: auto;\n    --bs-offcanvas-border-width: 0;\n    background-color: transparent !important;\n  }\n  .offcanvas-sm .offcanvas-header {\n    display: none;\n  }\n  .offcanvas-sm .offcanvas-body {\n    display: flex;\n    flex-grow: 0;\n    padding: 0;\n    overflow-y: visible;\n    background-color: transparent !important;\n  }\n}\n\n@media (max-width: 767.98px) {\n  .offcanvas-md {\n    position: fixed;\n    bottom: 0;\n    z-index: var(--bs-offcanvas-zindex);\n    display: flex;\n    flex-direction: column;\n    max-width: 100%;\n    color: var(--bs-offcanvas-color);\n    visibility: hidden;\n    background-color: var(--bs-offcanvas-bg);\n    background-clip: padding-box;\n    outline: 0;\n    box-shadow: var(--bs-offcanvas-box-shadow);\n    transition: var(--bs-offcanvas-transition);\n  }\n}\n@media (max-width: 767.98px) and (prefers-reduced-motion: reduce) {\n  .offcanvas-md {\n    transition: none;\n  }\n}\n@media (max-width: 767.98px) {\n  .offcanvas-md.offcanvas-start {\n    top: 0;\n    left: 0;\n    width: var(--bs-offcanvas-width);\n    border-right: var(--bs-offcanvas-border-width) solid var(--bs-offcanvas-border-color);\n    transform: translateX(-100%);\n  }\n}\n@media (max-width: 767.98px) {\n  .offcanvas-md.offcanvas-end {\n    top: 0;\n    right: 0;\n    width: var(--bs-offcanvas-width);\n    border-left: var(--bs-offcanvas-border-width) solid var(--bs-offcanvas-border-color);\n    transform: translateX(100%);\n  }\n}\n@media (max-width: 767.98px) {\n  .offcanvas-md.offcanvas-top {\n    top: 0;\n    right: 0;\n    left: 0;\n    height: var(--bs-offcanvas-height);\n    max-height: 100%;\n    border-bottom: var(--bs-offcanvas-border-width) solid var(--bs-offcanvas-border-color);\n    transform: translateY(-100%);\n  }\n}\n@media (max-width: 767.98px) {\n  .offcanvas-md.offcanvas-bottom {\n    right: 0;\n    left: 0;\n    height: var(--bs-offcanvas-height);\n    max-height: 100%;\n    border-top: var(--bs-offcanvas-border-width) solid var(--bs-offcanvas-border-color);\n    transform: translateY(100%);\n  }\n}\n@media (max-width: 767.98px) {\n  .offcanvas-md.showing, .offcanvas-md.show:not(.hiding) {\n    transform: none;\n  }\n}\n@media (max-width: 767.98px) {\n  .offcanvas-md.showing, .offcanvas-md.hiding, .offcanvas-md.show {\n    visibility: visible;\n  }\n}\n@media (min-width: 768px) {\n  .offcanvas-md {\n    --bs-offcanvas-height: auto;\n    --bs-offcanvas-border-width: 0;\n    background-color: transparent !important;\n  }\n  .offcanvas-md .offcanvas-header {\n    display: none;\n  }\n  .offcanvas-md .offcanvas-body {\n    display: flex;\n    flex-grow: 0;\n    padding: 0;\n    overflow-y: visible;\n    background-color: transparent !important;\n  }\n}\n\n@media (max-width: 991.98px) {\n  .offcanvas-lg {\n    position: fixed;\n    bottom: 0;\n    z-index: var(--bs-offcanvas-zindex);\n    display: flex;\n    flex-direction: column;\n    max-width: 100%;\n    color: var(--bs-offcanvas-color);\n    visibility: hidden;\n    background-color: var(--bs-offcanvas-bg);\n    background-clip: padding-box;\n    outline: 0;\n    box-shadow: var(--bs-offcanvas-box-shadow);\n    transition: var(--bs-offcanvas-transition);\n  }\n}\n@media (max-width: 991.98px) and (prefers-reduced-motion: reduce) {\n  .offcanvas-lg {\n    transition: none;\n  }\n}\n@media (max-width: 991.98px) {\n  .offcanvas-lg.offcanvas-start {\n    top: 0;\n    left: 0;\n    width: var(--bs-offcanvas-width);\n    border-right: var(--bs-offcanvas-border-width) solid var(--bs-offcanvas-border-color);\n    transform: translateX(-100%);\n  }\n}\n@media (max-width: 991.98px) {\n  .offcanvas-lg.offcanvas-end {\n    top: 0;\n    right: 0;\n    width: var(--bs-offcanvas-width);\n    border-left: var(--bs-offcanvas-border-width) solid var(--bs-offcanvas-border-color);\n    transform: translateX(100%);\n  }\n}\n@media (max-width: 991.98px) {\n  .offcanvas-lg.offcanvas-top {\n    top: 0;\n    right: 0;\n    left: 0;\n    height: var(--bs-offcanvas-height);\n    max-height: 100%;\n    border-bottom: var(--bs-offcanvas-border-width) solid var(--bs-offcanvas-border-color);\n    transform: translateY(-100%);\n  }\n}\n@media (max-width: 991.98px) {\n  .offcanvas-lg.offcanvas-bottom {\n    right: 0;\n    left: 0;\n    height: var(--bs-offcanvas-height);\n    max-height: 100%;\n    border-top: var(--bs-offcanvas-border-width) solid var(--bs-offcanvas-border-color);\n    transform: translateY(100%);\n  }\n}\n@media (max-width: 991.98px) {\n  .offcanvas-lg.showing, .offcanvas-lg.show:not(.hiding) {\n    transform: none;\n  }\n}\n@media (max-width: 991.98px) {\n  .offcanvas-lg.showing, .offcanvas-lg.hiding, .offcanvas-lg.show {\n    visibility: visible;\n  }\n}\n@media (min-width: 992px) {\n  .offcanvas-lg {\n    --bs-offcanvas-height: auto;\n    --bs-offcanvas-border-width: 0;\n    background-color: transparent !important;\n  }\n  .offcanvas-lg .offcanvas-header {\n    display: none;\n  }\n  .offcanvas-lg .offcanvas-body {\n    display: flex;\n    flex-grow: 0;\n    padding: 0;\n    overflow-y: visible;\n    background-color: transparent !important;\n  }\n}\n\n@media (max-width: 1199.98px) {\n  .offcanvas-xl {\n    position: fixed;\n    bottom: 0;\n    z-index: var(--bs-offcanvas-zindex);\n    display: flex;\n    flex-direction: column;\n    max-width: 100%;\n    color: var(--bs-offcanvas-color);\n    visibility: hidden;\n    background-color: var(--bs-offcanvas-bg);\n    background-clip: padding-box;\n    outline: 0;\n    box-shadow: var(--bs-offcanvas-box-shadow);\n    transition: var(--bs-offcanvas-transition);\n  }\n}\n@media (max-width: 1199.98px) and (prefers-reduced-motion: reduce) {\n  .offcanvas-xl {\n    transition: none;\n  }\n}\n@media (max-width: 1199.98px) {\n  .offcanvas-xl.offcanvas-start {\n    top: 0;\n    left: 0;\n    width: var(--bs-offcanvas-width);\n    border-right: var(--bs-offcanvas-border-width) solid var(--bs-offcanvas-border-color);\n    transform: translateX(-100%);\n  }\n}\n@media (max-width: 1199.98px) {\n  .offcanvas-xl.offcanvas-end {\n    top: 0;\n    right: 0;\n    width: var(--bs-offcanvas-width);\n    border-left: var(--bs-offcanvas-border-width) solid var(--bs-offcanvas-border-color);\n    transform: translateX(100%);\n  }\n}\n@media (max-width: 1199.98px) {\n  .offcanvas-xl.offcanvas-top {\n    top: 0;\n    right: 0;\n    left: 0;\n    height: var(--bs-offcanvas-height);\n    max-height: 100%;\n    border-bottom: var(--bs-offcanvas-border-width) solid var(--bs-offcanvas-border-color);\n    transform: translateY(-100%);\n  }\n}\n@media (max-width: 1199.98px) {\n  .offcanvas-xl.offcanvas-bottom {\n    right: 0;\n    left: 0;\n    height: var(--bs-offcanvas-height);\n    max-height: 100%;\n    border-top: var(--bs-offcanvas-border-width) solid var(--bs-offcanvas-border-color);\n    transform: translateY(100%);\n  }\n}\n@media (max-width: 1199.98px) {\n  .offcanvas-xl.showing, .offcanvas-xl.show:not(.hiding) {\n    transform: none;\n  }\n}\n@media (max-width: 1199.98px) {\n  .offcanvas-xl.showing, .offcanvas-xl.hiding, .offcanvas-xl.show {\n    visibility: visible;\n  }\n}\n@media (min-width: 1200px) {\n  .offcanvas-xl {\n    --bs-offcanvas-height: auto;\n    --bs-offcanvas-border-width: 0;\n    background-color: transparent !important;\n  }\n  .offcanvas-xl .offcanvas-header {\n    display: none;\n  }\n  .offcanvas-xl .offcanvas-body {\n    display: flex;\n    flex-grow: 0;\n    padding: 0;\n    overflow-y: visible;\n    background-color: transparent !important;\n  }\n}\n\n@media (max-width: 1399.98px) {\n  .offcanvas-xxl {\n    position: fixed;\n    bottom: 0;\n    z-index: var(--bs-offcanvas-zindex);\n    display: flex;\n    flex-direction: column;\n    max-width: 100%;\n    color: var(--bs-offcanvas-color);\n    visibility: hidden;\n    background-color: var(--bs-offcanvas-bg);\n    background-clip: padding-box;\n    outline: 0;\n    box-shadow: var(--bs-offcanvas-box-shadow);\n    transition: var(--bs-offcanvas-transition);\n  }\n}\n@media (max-width: 1399.98px) and (prefers-reduced-motion: reduce) {\n  .offcanvas-xxl {\n    transition: none;\n  }\n}\n@media (max-width: 1399.98px) {\n  .offcanvas-xxl.offcanvas-start {\n    top: 0;\n    left: 0;\n    width: var(--bs-offcanvas-width);\n    border-right: var(--bs-offcanvas-border-width) solid var(--bs-offcanvas-border-color);\n    transform: translateX(-100%);\n  }\n}\n@media (max-width: 1399.98px) {\n  .offcanvas-xxl.offcanvas-end {\n    top: 0;\n    right: 0;\n    width: var(--bs-offcanvas-width);\n    border-left: var(--bs-offcanvas-border-width) solid var(--bs-offcanvas-border-color);\n    transform: translateX(100%);\n  }\n}\n@media (max-width: 1399.98px) {\n  .offcanvas-xxl.offcanvas-top {\n    top: 0;\n    right: 0;\n    left: 0;\n    height: var(--bs-offcanvas-height);\n    max-height: 100%;\n    border-bottom: var(--bs-offcanvas-border-width) solid var(--bs-offcanvas-border-color);\n    transform: translateY(-100%);\n  }\n}\n@media (max-width: 1399.98px) {\n  .offcanvas-xxl.offcanvas-bottom {\n    right: 0;\n    left: 0;\n    height: var(--bs-offcanvas-height);\n    max-height: 100%;\n    border-top: var(--bs-offcanvas-border-width) solid var(--bs-offcanvas-border-color);\n    transform: translateY(100%);\n  }\n}\n@media (max-width: 1399.98px) {\n  .offcanvas-xxl.showing, .offcanvas-xxl.show:not(.hiding) {\n    transform: none;\n  }\n}\n@media (max-width: 1399.98px) {\n  .offcanvas-xxl.showing, .offcanvas-xxl.hiding, .offcanvas-xxl.show {\n    visibility: visible;\n  }\n}\n@media (min-width: 1400px) {\n  .offcanvas-xxl {\n    --bs-offcanvas-height: auto;\n    --bs-offcanvas-border-width: 0;\n    background-color: transparent !important;\n  }\n  .offcanvas-xxl .offcanvas-header {\n    display: none;\n  }\n  .offcanvas-xxl .offcanvas-body {\n    display: flex;\n    flex-grow: 0;\n    padding: 0;\n    overflow-y: visible;\n    background-color: transparent !important;\n  }\n}\n\n.offcanvas {\n  position: fixed;\n  bottom: 0;\n  z-index: var(--bs-offcanvas-zindex);\n  display: flex;\n  flex-direction: column;\n  max-width: 100%;\n  color: var(--bs-offcanvas-color);\n  visibility: hidden;\n  background-color: var(--bs-offcanvas-bg);\n  background-clip: padding-box;\n  outline: 0;\n  box-shadow: var(--bs-offcanvas-box-shadow);\n  transition: var(--bs-offcanvas-transition);\n}\n@media (prefers-reduced-motion: reduce) {\n  .offcanvas {\n    transition: none;\n  }\n}\n.offcanvas.offcanvas-start {\n  top: 0;\n  left: 0;\n  width: var(--bs-offcanvas-width);\n  border-right: var(--bs-offcanvas-border-width) solid var(--bs-offcanvas-border-color);\n  transform: translateX(-100%);\n}\n.offcanvas.offcanvas-end {\n  top: 0;\n  right: 0;\n  width: var(--bs-offcanvas-width);\n  border-left: var(--bs-offcanvas-border-width) solid var(--bs-offcanvas-border-color);\n  transform: translateX(100%);\n}\n.offcanvas.offcanvas-top {\n  top: 0;\n  right: 0;\n  left: 0;\n  height: var(--bs-offcanvas-height);\n  max-height: 100%;\n  border-bottom: var(--bs-offcanvas-border-width) solid var(--bs-offcanvas-border-color);\n  transform: translateY(-100%);\n}\n.offcanvas.offcanvas-bottom {\n  right: 0;\n  left: 0;\n  height: var(--bs-offcanvas-height);\n  max-height: 100%;\n  border-top: var(--bs-offcanvas-border-width) solid var(--bs-offcanvas-border-color);\n  transform: translateY(100%);\n}\n.offcanvas.showing, .offcanvas.show:not(.hiding) {\n  transform: none;\n}\n.offcanvas.showing, .offcanvas.hiding, .offcanvas.show {\n  visibility: visible;\n}\n\n.offcanvas-backdrop {\n  position: fixed;\n  top: 0;\n  left: 0;\n  z-index: 1040;\n  width: 100vw;\n  height: 100vh;\n  background-color: #000000;\n}\n.offcanvas-backdrop.fade {\n  opacity: 0;\n}\n.offcanvas-backdrop.show {\n  opacity: 0.4;\n}\n\n.offcanvas-header {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  padding: var(--bs-offcanvas-padding-y) var(--bs-offcanvas-padding-x);\n}\n.offcanvas-header .btn-close {\n  padding: calc(var(--bs-offcanvas-padding-y) * 0.5) calc(var(--bs-offcanvas-padding-x) * 0.5);\n  margin-top: calc(-0.5 * var(--bs-offcanvas-padding-y));\n  margin-right: calc(-0.5 * var(--bs-offcanvas-padding-x));\n  margin-bottom: calc(-0.5 * var(--bs-offcanvas-padding-y));\n}\n\n.offcanvas-title {\n  margin-bottom: 0;\n  line-height: var(--bs-offcanvas-title-line-height);\n}\n\n.offcanvas-body {\n  flex-grow: 1;\n  padding: var(--bs-offcanvas-padding-y) var(--bs-offcanvas-padding-x);\n  overflow-y: auto;\n}\n\n.placeholder {\n  display: inline-block;\n  min-height: 1em;\n  vertical-align: middle;\n  cursor: wait;\n  background-color: currentcolor;\n  opacity: 0.5;\n}\n.placeholder.btn::before {\n  display: inline-block;\n  content: \"\";\n}\n\n.placeholder-xs {\n  min-height: 0.6em;\n}\n\n.placeholder-sm {\n  min-height: 0.8em;\n}\n\n.placeholder-lg {\n  min-height: 1.2em;\n}\n\n.placeholder-glow .placeholder {\n  animation: placeholder-glow 2s ease-in-out infinite;\n}\n\n@keyframes placeholder-glow {\n  50% {\n    opacity: 0.2;\n  }\n}\n.placeholder-wave {\n  mask-image: linear-gradient(130deg, #000000 55%, rgba(0, 0, 0, 0.8) 75%, #000000 95%);\n  mask-size: 200% 100%;\n  animation: placeholder-wave 2s linear infinite;\n}\n\n@keyframes placeholder-wave {\n  100% {\n    mask-position: -200% 0%;\n  }\n}\n.clearfix::after {\n  display: block;\n  clear: both;\n  content: \"\";\n}\n\n.text-bg-light {\n  color: #000000 !important;\n  background-color: RGBA(249, 249, 249, var(--bs-bg-opacity, 1)) !important;\n}\n\n.text-bg-primary {\n  color: #000000 !important;\n  background-color: RGBA(0, 158, 247, var(--bs-bg-opacity, 1)) !important;\n}\n\n.text-bg-secondary {\n  color: #000000 !important;\n  background-color: RGBA(225, 227, 234, var(--bs-bg-opacity, 1)) !important;\n}\n\n.text-bg-success {\n  color: #000000 !important;\n  background-color: RGBA(80, 205, 137, var(--bs-bg-opacity, 1)) !important;\n}\n\n.text-bg-info {\n  color: #ffffff !important;\n  background-color: RGBA(114, 57, 234, var(--bs-bg-opacity, 1)) !important;\n}\n\n.text-bg-warning {\n  color: #000000 !important;\n  background-color: RGBA(255, 199, 0, var(--bs-bg-opacity, 1)) !important;\n}\n\n.text-bg-danger {\n  color: #000000 !important;\n  background-color: RGBA(241, 65, 108, var(--bs-bg-opacity, 1)) !important;\n}\n\n.text-bg-dark {\n  color: #ffffff !important;\n  background-color: RGBA(24, 28, 50, var(--bs-bg-opacity, 1)) !important;\n}\n\n.link-light {\n  color: #F9F9F9 !important;\n}\n.link-light:hover, .link-light:focus {\n  color: #fafafa !important;\n}\n\n.link-primary {\n  color: #009ef7 !important;\n}\n.link-primary:hover, .link-primary:focus {\n  color: #33b1f9 !important;\n}\n\n.link-secondary {\n  color: #E1E3EA !important;\n}\n.link-secondary:hover, .link-secondary:focus {\n  color: #e7e9ee !important;\n}\n\n.link-success {\n  color: #50cd89 !important;\n}\n.link-success:hover, .link-success:focus {\n  color: #73d7a1 !important;\n}\n\n.link-info {\n  color: #7239ea !important;\n}\n.link-info:hover, .link-info:focus {\n  color: #5b2ebb !important;\n}\n\n.link-warning {\n  color: #ffc700 !important;\n}\n.link-warning:hover, .link-warning:focus {\n  color: #ffd233 !important;\n}\n\n.link-danger {\n  color: #f1416c !important;\n}\n.link-danger:hover, .link-danger:focus {\n  color: #f46789 !important;\n}\n\n.link-dark {\n  color: #181C32 !important;\n}\n.link-dark:hover, .link-dark:focus {\n  color: #131628 !important;\n}\n\n.ratio {\n  position: relative;\n  width: 100%;\n}\n.ratio::before {\n  display: block;\n  padding-top: var(--bs-aspect-ratio);\n  content: \"\";\n}\n.ratio > * {\n  position: absolute;\n  top: 0;\n  left: 0;\n  width: 100%;\n  height: 100%;\n}\n\n.ratio-1x1 {\n  --bs-aspect-ratio: 100%;\n}\n\n.ratio-4x3 {\n  --bs-aspect-ratio: 75%;\n}\n\n.ratio-16x9 {\n  --bs-aspect-ratio: 56.25%;\n}\n\n.ratio-21x9 {\n  --bs-aspect-ratio: 42.8571428571%;\n}\n\n.fixed-top {\n  position: fixed;\n  top: 0;\n  right: 0;\n  left: 0;\n  z-index: 1030;\n}\n\n.fixed-bottom {\n  position: fixed;\n  right: 0;\n  bottom: 0;\n  left: 0;\n  z-index: 1030;\n}\n\n.sticky-top {\n  position: sticky;\n  top: 0;\n  z-index: 1020;\n}\n\n.sticky-bottom {\n  position: sticky;\n  bottom: 0;\n  z-index: 1020;\n}\n\n@media (min-width: 576px) {\n  .sticky-sm-top {\n    position: sticky;\n    top: 0;\n    z-index: 1020;\n  }\n  .sticky-sm-bottom {\n    position: sticky;\n    bottom: 0;\n    z-index: 1020;\n  }\n}\n@media (min-width: 768px) {\n  .sticky-md-top {\n    position: sticky;\n    top: 0;\n    z-index: 1020;\n  }\n  .sticky-md-bottom {\n    position: sticky;\n    bottom: 0;\n    z-index: 1020;\n  }\n}\n@media (min-width: 992px) {\n  .sticky-lg-top {\n    position: sticky;\n    top: 0;\n    z-index: 1020;\n  }\n  .sticky-lg-bottom {\n    position: sticky;\n    bottom: 0;\n    z-index: 1020;\n  }\n}\n@media (min-width: 1200px) {\n  .sticky-xl-top {\n    position: sticky;\n    top: 0;\n    z-index: 1020;\n  }\n  .sticky-xl-bottom {\n    position: sticky;\n    bottom: 0;\n    z-index: 1020;\n  }\n}\n@media (min-width: 1400px) {\n  .sticky-xxl-top {\n    position: sticky;\n    top: 0;\n    z-index: 1020;\n  }\n  .sticky-xxl-bottom {\n    position: sticky;\n    bottom: 0;\n    z-index: 1020;\n  }\n}\n.hstack {\n  display: flex;\n  flex-direction: row;\n  align-items: center;\n  align-self: stretch;\n}\n\n.vstack {\n  display: flex;\n  flex: 1 1 auto;\n  flex-direction: column;\n  align-self: stretch;\n}\n\n.visually-hidden,\n.visually-hidden-focusable:not(:focus):not(:focus-within) {\n  position: absolute !important;\n  width: 1px !important;\n  height: 1px !important;\n  padding: 0 !important;\n  margin: -1px !important;\n  overflow: hidden !important;\n  clip: rect(0, 0, 0, 0) !important;\n  white-space: nowrap !important;\n  border: 0 !important;\n}\n\n.stretched-link::after {\n  position: absolute;\n  top: 0;\n  right: 0;\n  bottom: 0;\n  left: 0;\n  z-index: 1;\n  content: \"\";\n}\n\n.text-truncate {\n  overflow: hidden;\n  text-overflow: ellipsis;\n  white-space: nowrap;\n}\n\n.vr {\n  display: inline-block;\n  align-self: stretch;\n  width: 1px;\n  min-height: 1em;\n  background-color: currentcolor;\n  opacity: 0.25;\n}\n\n.align-baseline {\n  vertical-align: baseline !important;\n}\n\n.align-top {\n  vertical-align: top !important;\n}\n\n.align-middle {\n  vertical-align: middle !important;\n}\n\n.align-bottom {\n  vertical-align: bottom !important;\n}\n\n.align-text-bottom {\n  vertical-align: text-bottom !important;\n}\n\n.align-text-top {\n  vertical-align: text-top !important;\n}\n\n.float-start {\n  float: left !important;\n}\n\n.float-end {\n  float: right !important;\n}\n\n.float-none {\n  float: none !important;\n}\n\n.object-fit-contain {\n  object-fit: contain !important;\n}\n\n.object-fit-cover {\n  object-fit: cover !important;\n}\n\n.object-fit-fill {\n  object-fit: fill !important;\n}\n\n.object-fit-scale {\n  object-fit: scale-down !important;\n}\n\n.object-fit-none {\n  object-fit: none !important;\n}\n\n.opacity-0 {\n  opacity: 0 !important;\n}\n\n.opacity-5 {\n  opacity: 0.05 !important;\n}\n\n.opacity-10 {\n  opacity: 0.1 !important;\n}\n\n.opacity-15 {\n  opacity: 0.15 !important;\n}\n\n.opacity-20 {\n  opacity: 0.2 !important;\n}\n\n.opacity-25 {\n  opacity: 0.25 !important;\n}\n\n.opacity-50 {\n  opacity: 0.5 !important;\n}\n\n.opacity-75 {\n  opacity: 0.75 !important;\n}\n\n.opacity-100 {\n  opacity: 1 !important;\n}\n\n.overflow-auto {\n  overflow: auto !important;\n}\n\n.overflow-hidden {\n  overflow: hidden !important;\n}\n\n.overflow-visible {\n  overflow: visible !important;\n}\n\n.overflow-scroll {\n  overflow: scroll !important;\n}\n\n.overflow-x-auto {\n  overflow-x: auto !important;\n}\n\n.overflow-x-hidden {\n  overflow-x: hidden !important;\n}\n\n.overflow-x-visible {\n  overflow-x: visible !important;\n}\n\n.overflow-x-scroll {\n  overflow-x: scroll !important;\n}\n\n.overflow-y-auto {\n  overflow-y: auto !important;\n}\n\n.overflow-y-hidden {\n  overflow-y: hidden !important;\n}\n\n.overflow-y-visible {\n  overflow-y: visible !important;\n}\n\n.overflow-y-scroll {\n  overflow-y: scroll !important;\n}\n\n.d-inline {\n  display: inline !important;\n}\n\n.d-inline-block {\n  display: inline-block !important;\n}\n\n.d-block {\n  display: block !important;\n}\n\n.d-grid {\n  display: grid !important;\n}\n\n.d-table {\n  display: table !important;\n}\n\n.d-table-row {\n  display: table-row !important;\n}\n\n.d-table-cell {\n  display: table-cell !important;\n}\n\n.d-flex {\n  display: flex !important;\n}\n\n.d-inline-flex {\n  display: inline-flex !important;\n}\n\n.d-none {\n  display: none !important;\n}\n\n.shadow {\n  box-shadow: 0 0.5rem 1.5rem 0.5rem rgba(0, 0, 0, 0.075) !important;\n}\n\n.shadow-sm {\n  box-shadow: 0 0.1rem 1rem 0.25rem rgba(0, 0, 0, 0.05) !important;\n}\n\n.shadow-lg {\n  box-shadow: 0 1rem 2rem 1rem rgba(0, 0, 0, 0.1) !important;\n}\n\n.shadow-none {\n  box-shadow: none !important;\n}\n\n.position-static {\n  position: static !important;\n}\n\n.position-relative {\n  position: relative !important;\n}\n\n.position-absolute {\n  position: absolute !important;\n}\n\n.position-fixed {\n  position: fixed !important;\n}\n\n.position-sticky {\n  position: sticky !important;\n}\n\n.top-0 {\n  top: 0 !important;\n}\n\n.top-25 {\n  top: 25% !important;\n}\n\n.top-50 {\n  top: 50% !important;\n}\n\n.top-75 {\n  top: 75% !important;\n}\n\n.top-100 {\n  top: 100% !important;\n}\n\n.bottom-0 {\n  bottom: 0 !important;\n}\n\n.bottom-25 {\n  bottom: 25% !important;\n}\n\n.bottom-50 {\n  bottom: 50% !important;\n}\n\n.bottom-75 {\n  bottom: 75% !important;\n}\n\n.bottom-100 {\n  bottom: 100% !important;\n}\n\n.start-0 {\n  left: 0 !important;\n}\n\n.start-25 {\n  left: 25% !important;\n}\n\n.start-50 {\n  left: 50% !important;\n}\n\n.start-75 {\n  left: 75% !important;\n}\n\n.start-100 {\n  left: 100% !important;\n}\n\n.end-0 {\n  right: 0 !important;\n}\n\n.end-25 {\n  right: 25% !important;\n}\n\n.end-50 {\n  right: 50% !important;\n}\n\n.end-75 {\n  right: 75% !important;\n}\n\n.end-100 {\n  right: 100% !important;\n}\n\n.translate-middle {\n  transform: translate(-50%, -50%) !important;\n}\n\n.translate-middle-x {\n  transform: translateX(-50%) !important;\n}\n\n.translate-middle-y {\n  transform: translateY(-50%) !important;\n}\n\n.border {\n  border: var(--bs-border-width) var(--bs-border-style) var(--bs-border-color) !important;\n}\n\n.border-0 {\n  border: 0 !important;\n}\n\n.border-top {\n  border-top: var(--bs-border-width) var(--bs-border-style) var(--bs-border-color) !important;\n}\n\n.border-top-0 {\n  border-top: 0 !important;\n}\n\n.border-end {\n  border-right: var(--bs-border-width) var(--bs-border-style) var(--bs-border-color) !important;\n}\n\n.border-end-0 {\n  border-right: 0 !important;\n}\n\n.border-bottom {\n  border-bottom: var(--bs-border-width) var(--bs-border-style) var(--bs-border-color) !important;\n}\n\n.border-bottom-0 {\n  border-bottom: 0 !important;\n}\n\n.border-start {\n  border-left: var(--bs-border-width) var(--bs-border-style) var(--bs-border-color) !important;\n}\n\n.border-start-0 {\n  border-left: 0 !important;\n}\n\n.border-light {\n  --bs-border-opacity: 1;\n  border-color: rgba(var(--bs-light-rgb), var(--bs-border-opacity)) !important;\n}\n\n.border-primary {\n  --bs-border-opacity: 1;\n  border-color: rgba(var(--bs-primary-rgb), var(--bs-border-opacity)) !important;\n}\n\n.border-secondary {\n  --bs-border-opacity: 1;\n  border-color: rgba(var(--bs-secondary-rgb), var(--bs-border-opacity)) !important;\n}\n\n.border-success {\n  --bs-border-opacity: 1;\n  border-color: rgba(var(--bs-success-rgb), var(--bs-border-opacity)) !important;\n}\n\n.border-info {\n  --bs-border-opacity: 1;\n  border-color: rgba(var(--bs-info-rgb), var(--bs-border-opacity)) !important;\n}\n\n.border-warning {\n  --bs-border-opacity: 1;\n  border-color: rgba(var(--bs-warning-rgb), var(--bs-border-opacity)) !important;\n}\n\n.border-danger {\n  --bs-border-opacity: 1;\n  border-color: rgba(var(--bs-danger-rgb), var(--bs-border-opacity)) !important;\n}\n\n.border-dark {\n  --bs-border-opacity: 1;\n  border-color: rgba(var(--bs-dark-rgb), var(--bs-border-opacity)) !important;\n}\n\n.border-white {\n  --bs-border-opacity: 1;\n  border-color: rgba(var(--bs-white-rgb), var(--bs-border-opacity)) !important;\n}\n\n.border-primary-subtle {\n  border-color: var(--bs-primary-border-subtle) !important;\n}\n\n.border-secondary-subtle {\n  border-color: var(--bs-secondary-border-subtle) !important;\n}\n\n.border-success-subtle {\n  border-color: var(--bs-success-border-subtle) !important;\n}\n\n.border-info-subtle {\n  border-color: var(--bs-info-border-subtle) !important;\n}\n\n.border-warning-subtle {\n  border-color: var(--bs-warning-border-subtle) !important;\n}\n\n.border-danger-subtle {\n  border-color: var(--bs-danger-border-subtle) !important;\n}\n\n.border-light-subtle {\n  border-color: var(--bs-light-border-subtle) !important;\n}\n\n.border-dark-subtle {\n  border-color: var(--bs-dark-border-subtle) !important;\n}\n\n.border-0 {\n  --bs-border-width: 0;\n}\n\n.border-1 {\n  --bs-border-width: 1px;\n}\n\n.border-2 {\n  --bs-border-width: 2px;\n}\n\n.border-3 {\n  --bs-border-width: 3px;\n}\n\n.border-4 {\n  --bs-border-width: 4px;\n}\n\n.border-5 {\n  --bs-border-width: 5px;\n}\n\n.border-opacity-10 {\n  --bs-border-opacity: 0.1;\n}\n\n.border-opacity-25 {\n  --bs-border-opacity: 0.25;\n}\n\n.border-opacity-50 {\n  --bs-border-opacity: 0.5;\n}\n\n.border-opacity-75 {\n  --bs-border-opacity: 0.75;\n}\n\n.border-opacity-100 {\n  --bs-border-opacity: 1;\n}\n\n.w-unset {\n  width: unset !important;\n}\n\n.w-25 {\n  width: 25% !important;\n}\n\n.w-50 {\n  width: 50% !important;\n}\n\n.w-75 {\n  width: 75% !important;\n}\n\n.w-100 {\n  width: 100% !important;\n}\n\n.w-auto {\n  width: auto !important;\n}\n\n.w-1px {\n  width: 1px !important;\n}\n\n.w-2px {\n  width: 2px !important;\n}\n\n.w-3px {\n  width: 3px !important;\n}\n\n.w-4px {\n  width: 4px !important;\n}\n\n.w-5px {\n  width: 5px !important;\n}\n\n.w-6px {\n  width: 6px !important;\n}\n\n.w-7px {\n  width: 7px !important;\n}\n\n.w-8px {\n  width: 8px !important;\n}\n\n.w-9px {\n  width: 9px !important;\n}\n\n.w-10px {\n  width: 10px !important;\n}\n\n.w-15px {\n  width: 15px !important;\n}\n\n.w-20px {\n  width: 20px !important;\n}\n\n.w-25px {\n  width: 25px !important;\n}\n\n.w-30px {\n  width: 30px !important;\n}\n\n.w-35px {\n  width: 35px !important;\n}\n\n.w-40px {\n  width: 40px !important;\n}\n\n.w-45px {\n  width: 45px !important;\n}\n\n.w-50px {\n  width: 50px !important;\n}\n\n.w-55px {\n  width: 55px !important;\n}\n\n.w-60px {\n  width: 60px !important;\n}\n\n.w-65px {\n  width: 65px !important;\n}\n\n.w-70px {\n  width: 70px !important;\n}\n\n.w-75px {\n  width: 75px !important;\n}\n\n.w-80px {\n  width: 80px !important;\n}\n\n.w-85px {\n  width: 85px !important;\n}\n\n.w-90px {\n  width: 90px !important;\n}\n\n.w-95px {\n  width: 95px !important;\n}\n\n.w-100px {\n  width: 100px !important;\n}\n\n.w-125px {\n  width: 125px !important;\n}\n\n.w-150px {\n  width: 150px !important;\n}\n\n.w-175px {\n  width: 175px !important;\n}\n\n.w-200px {\n  width: 200px !important;\n}\n\n.w-225px {\n  width: 225px !important;\n}\n\n.w-250px {\n  width: 250px !important;\n}\n\n.w-275px {\n  width: 275px !important;\n}\n\n.w-300px {\n  width: 300px !important;\n}\n\n.w-325px {\n  width: 325px !important;\n}\n\n.w-350px {\n  width: 350px !important;\n}\n\n.w-375px {\n  width: 375px !important;\n}\n\n.w-400px {\n  width: 400px !important;\n}\n\n.w-425px {\n  width: 425px !important;\n}\n\n.w-450px {\n  width: 450px !important;\n}\n\n.w-475px {\n  width: 475px !important;\n}\n\n.w-500px {\n  width: 500px !important;\n}\n\n.w-550px {\n  width: 550px !important;\n}\n\n.w-600px {\n  width: 600px !important;\n}\n\n.w-650px {\n  width: 650px !important;\n}\n\n.w-700px {\n  width: 700px !important;\n}\n\n.w-750px {\n  width: 750px !important;\n}\n\n.w-800px {\n  width: 800px !important;\n}\n\n.w-850px {\n  width: 850px !important;\n}\n\n.w-900px {\n  width: 900px !important;\n}\n\n.w-950px {\n  width: 950px !important;\n}\n\n.w-1000px {\n  width: 1000px !important;\n}\n\n.mw-unset {\n  max-width: unset !important;\n}\n\n.mw-25 {\n  max-width: 25% !important;\n}\n\n.mw-50 {\n  max-width: 50% !important;\n}\n\n.mw-75 {\n  max-width: 75% !important;\n}\n\n.mw-100 {\n  max-width: 100% !important;\n}\n\n.mw-auto {\n  max-width: auto !important;\n}\n\n.mw-1px {\n  max-width: 1px !important;\n}\n\n.mw-2px {\n  max-width: 2px !important;\n}\n\n.mw-3px {\n  max-width: 3px !important;\n}\n\n.mw-4px {\n  max-width: 4px !important;\n}\n\n.mw-5px {\n  max-width: 5px !important;\n}\n\n.mw-6px {\n  max-width: 6px !important;\n}\n\n.mw-7px {\n  max-width: 7px !important;\n}\n\n.mw-8px {\n  max-width: 8px !important;\n}\n\n.mw-9px {\n  max-width: 9px !important;\n}\n\n.mw-10px {\n  max-width: 10px !important;\n}\n\n.mw-15px {\n  max-width: 15px !important;\n}\n\n.mw-20px {\n  max-width: 20px !important;\n}\n\n.mw-25px {\n  max-width: 25px !important;\n}\n\n.mw-30px {\n  max-width: 30px !important;\n}\n\n.mw-35px {\n  max-width: 35px !important;\n}\n\n.mw-40px {\n  max-width: 40px !important;\n}\n\n.mw-45px {\n  max-width: 45px !important;\n}\n\n.mw-50px {\n  max-width: 50px !important;\n}\n\n.mw-55px {\n  max-width: 55px !important;\n}\n\n.mw-60px {\n  max-width: 60px !important;\n}\n\n.mw-65px {\n  max-width: 65px !important;\n}\n\n.mw-70px {\n  max-width: 70px !important;\n}\n\n.mw-75px {\n  max-width: 75px !important;\n}\n\n.mw-80px {\n  max-width: 80px !important;\n}\n\n.mw-85px {\n  max-width: 85px !important;\n}\n\n.mw-90px {\n  max-width: 90px !important;\n}\n\n.mw-95px {\n  max-width: 95px !important;\n}\n\n.mw-100px {\n  max-width: 100px !important;\n}\n\n.mw-125px {\n  max-width: 125px !important;\n}\n\n.mw-150px {\n  max-width: 150px !important;\n}\n\n.mw-175px {\n  max-width: 175px !important;\n}\n\n.mw-200px {\n  max-width: 200px !important;\n}\n\n.mw-225px {\n  max-width: 225px !important;\n}\n\n.mw-250px {\n  max-width: 250px !important;\n}\n\n.mw-275px {\n  max-width: 275px !important;\n}\n\n.mw-300px {\n  max-width: 300px !important;\n}\n\n.mw-325px {\n  max-width: 325px !important;\n}\n\n.mw-350px {\n  max-width: 350px !important;\n}\n\n.mw-375px {\n  max-width: 375px !important;\n}\n\n.mw-400px {\n  max-width: 400px !important;\n}\n\n.mw-425px {\n  max-width: 425px !important;\n}\n\n.mw-450px {\n  max-width: 450px !important;\n}\n\n.mw-475px {\n  max-width: 475px !important;\n}\n\n.mw-500px {\n  max-width: 500px !important;\n}\n\n.mw-550px {\n  max-width: 550px !important;\n}\n\n.mw-600px {\n  max-width: 600px !important;\n}\n\n.mw-650px {\n  max-width: 650px !important;\n}\n\n.mw-700px {\n  max-width: 700px !important;\n}\n\n.mw-750px {\n  max-width: 750px !important;\n}\n\n.mw-800px {\n  max-width: 800px !important;\n}\n\n.mw-850px {\n  max-width: 850px !important;\n}\n\n.mw-900px {\n  max-width: 900px !important;\n}\n\n.mw-950px {\n  max-width: 950px !important;\n}\n\n.mw-1000px {\n  max-width: 1000px !important;\n}\n\n.vw-100 {\n  width: 100vw !important;\n}\n\n.min-vw-100 {\n  min-width: 100vw !important;\n}\n\n.h-unset {\n  height: unset !important;\n}\n\n.h-25 {\n  height: 25% !important;\n}\n\n.h-50 {\n  height: 50% !important;\n}\n\n.h-75 {\n  height: 75% !important;\n}\n\n.h-100 {\n  height: 100% !important;\n}\n\n.h-auto {\n  height: auto !important;\n}\n\n.h-1px {\n  height: 1px !important;\n}\n\n.h-2px {\n  height: 2px !important;\n}\n\n.h-3px {\n  height: 3px !important;\n}\n\n.h-4px {\n  height: 4px !important;\n}\n\n.h-5px {\n  height: 5px !important;\n}\n\n.h-6px {\n  height: 6px !important;\n}\n\n.h-7px {\n  height: 7px !important;\n}\n\n.h-8px {\n  height: 8px !important;\n}\n\n.h-9px {\n  height: 9px !important;\n}\n\n.h-10px {\n  height: 10px !important;\n}\n\n.h-15px {\n  height: 15px !important;\n}\n\n.h-20px {\n  height: 20px !important;\n}\n\n.h-25px {\n  height: 25px !important;\n}\n\n.h-30px {\n  height: 30px !important;\n}\n\n.h-35px {\n  height: 35px !important;\n}\n\n.h-40px {\n  height: 40px !important;\n}\n\n.h-45px {\n  height: 45px !important;\n}\n\n.h-50px {\n  height: 50px !important;\n}\n\n.h-55px {\n  height: 55px !important;\n}\n\n.h-60px {\n  height: 60px !important;\n}\n\n.h-65px {\n  height: 65px !important;\n}\n\n.h-70px {\n  height: 70px !important;\n}\n\n.h-75px {\n  height: 75px !important;\n}\n\n.h-80px {\n  height: 80px !important;\n}\n\n.h-85px {\n  height: 85px !important;\n}\n\n.h-90px {\n  height: 90px !important;\n}\n\n.h-95px {\n  height: 95px !important;\n}\n\n.h-100px {\n  height: 100px !important;\n}\n\n.h-125px {\n  height: 125px !important;\n}\n\n.h-150px {\n  height: 150px !important;\n}\n\n.h-175px {\n  height: 175px !important;\n}\n\n.h-200px {\n  height: 200px !important;\n}\n\n.h-225px {\n  height: 225px !important;\n}\n\n.h-250px {\n  height: 250px !important;\n}\n\n.h-275px {\n  height: 275px !important;\n}\n\n.h-300px {\n  height: 300px !important;\n}\n\n.h-325px {\n  height: 325px !important;\n}\n\n.h-350px {\n  height: 350px !important;\n}\n\n.h-375px {\n  height: 375px !important;\n}\n\n.h-400px {\n  height: 400px !important;\n}\n\n.h-425px {\n  height: 425px !important;\n}\n\n.h-450px {\n  height: 450px !important;\n}\n\n.h-475px {\n  height: 475px !important;\n}\n\n.h-500px {\n  height: 500px !important;\n}\n\n.h-550px {\n  height: 550px !important;\n}\n\n.h-600px {\n  height: 600px !important;\n}\n\n.h-650px {\n  height: 650px !important;\n}\n\n.h-700px {\n  height: 700px !important;\n}\n\n.h-750px {\n  height: 750px !important;\n}\n\n.h-800px {\n  height: 800px !important;\n}\n\n.h-850px {\n  height: 850px !important;\n}\n\n.h-900px {\n  height: 900px !important;\n}\n\n.h-950px {\n  height: 950px !important;\n}\n\n.h-1000px {\n  height: 1000px !important;\n}\n\n.mh-unset {\n  max-height: unset !important;\n}\n\n.mh-25 {\n  max-height: 25% !important;\n}\n\n.mh-50 {\n  max-height: 50% !important;\n}\n\n.mh-75 {\n  max-height: 75% !important;\n}\n\n.mh-100 {\n  max-height: 100% !important;\n}\n\n.mh-auto {\n  max-height: auto !important;\n}\n\n.mh-1px {\n  max-height: 1px !important;\n}\n\n.mh-2px {\n  max-height: 2px !important;\n}\n\n.mh-3px {\n  max-height: 3px !important;\n}\n\n.mh-4px {\n  max-height: 4px !important;\n}\n\n.mh-5px {\n  max-height: 5px !important;\n}\n\n.mh-6px {\n  max-height: 6px !important;\n}\n\n.mh-7px {\n  max-height: 7px !important;\n}\n\n.mh-8px {\n  max-height: 8px !important;\n}\n\n.mh-9px {\n  max-height: 9px !important;\n}\n\n.mh-10px {\n  max-height: 10px !important;\n}\n\n.mh-15px {\n  max-height: 15px !important;\n}\n\n.mh-20px {\n  max-height: 20px !important;\n}\n\n.mh-25px {\n  max-height: 25px !important;\n}\n\n.mh-30px {\n  max-height: 30px !important;\n}\n\n.mh-35px {\n  max-height: 35px !important;\n}\n\n.mh-40px {\n  max-height: 40px !important;\n}\n\n.mh-45px {\n  max-height: 45px !important;\n}\n\n.mh-50px {\n  max-height: 50px !important;\n}\n\n.mh-55px {\n  max-height: 55px !important;\n}\n\n.mh-60px {\n  max-height: 60px !important;\n}\n\n.mh-65px {\n  max-height: 65px !important;\n}\n\n.mh-70px {\n  max-height: 70px !important;\n}\n\n.mh-75px {\n  max-height: 75px !important;\n}\n\n.mh-80px {\n  max-height: 80px !important;\n}\n\n.mh-85px {\n  max-height: 85px !important;\n}\n\n.mh-90px {\n  max-height: 90px !important;\n}\n\n.mh-95px {\n  max-height: 95px !important;\n}\n\n.mh-100px {\n  max-height: 100px !important;\n}\n\n.mh-125px {\n  max-height: 125px !important;\n}\n\n.mh-150px {\n  max-height: 150px !important;\n}\n\n.mh-175px {\n  max-height: 175px !important;\n}\n\n.mh-200px {\n  max-height: 200px !important;\n}\n\n.mh-225px {\n  max-height: 225px !important;\n}\n\n.mh-250px {\n  max-height: 250px !important;\n}\n\n.mh-275px {\n  max-height: 275px !important;\n}\n\n.mh-300px {\n  max-height: 300px !important;\n}\n\n.mh-325px {\n  max-height: 325px !important;\n}\n\n.mh-350px {\n  max-height: 350px !important;\n}\n\n.mh-375px {\n  max-height: 375px !important;\n}\n\n.mh-400px {\n  max-height: 400px !important;\n}\n\n.mh-425px {\n  max-height: 425px !important;\n}\n\n.mh-450px {\n  max-height: 450px !important;\n}\n\n.mh-475px {\n  max-height: 475px !important;\n}\n\n.mh-500px {\n  max-height: 500px !important;\n}\n\n.mh-550px {\n  max-height: 550px !important;\n}\n\n.mh-600px {\n  max-height: 600px !important;\n}\n\n.mh-650px {\n  max-height: 650px !important;\n}\n\n.mh-700px {\n  max-height: 700px !important;\n}\n\n.mh-750px {\n  max-height: 750px !important;\n}\n\n.mh-800px {\n  max-height: 800px !important;\n}\n\n.mh-850px {\n  max-height: 850px !important;\n}\n\n.mh-900px {\n  max-height: 900px !important;\n}\n\n.mh-950px {\n  max-height: 950px !important;\n}\n\n.mh-1000px {\n  max-height: 1000px !important;\n}\n\n.vh-100 {\n  height: 100vh !important;\n}\n\n.min-vh-100 {\n  min-height: 100vh !important;\n}\n\n.flex-fill {\n  flex: 1 1 auto !important;\n}\n\n.flex-row {\n  flex-direction: row !important;\n}\n\n.flex-column {\n  flex-direction: column !important;\n}\n\n.flex-row-reverse {\n  flex-direction: row-reverse !important;\n}\n\n.flex-column-reverse {\n  flex-direction: column-reverse !important;\n}\n\n.flex-grow-0 {\n  flex-grow: 0 !important;\n}\n\n.flex-grow-1 {\n  flex-grow: 1 !important;\n}\n\n.flex-shrink-0 {\n  flex-shrink: 0 !important;\n}\n\n.flex-shrink-1 {\n  flex-shrink: 1 !important;\n}\n\n.flex-wrap {\n  flex-wrap: wrap !important;\n}\n\n.flex-nowrap {\n  flex-wrap: nowrap !important;\n}\n\n.flex-wrap-reverse {\n  flex-wrap: wrap-reverse !important;\n}\n\n.justify-content-start {\n  justify-content: flex-start !important;\n}\n\n.justify-content-end {\n  justify-content: flex-end !important;\n}\n\n.justify-content-center {\n  justify-content: center !important;\n}\n\n.justify-content-between {\n  justify-content: space-between !important;\n}\n\n.justify-content-around {\n  justify-content: space-around !important;\n}\n\n.justify-content-evenly {\n  justify-content: space-evenly !important;\n}\n\n.align-items-start {\n  align-items: flex-start !important;\n}\n\n.align-items-end {\n  align-items: flex-end !important;\n}\n\n.align-items-center {\n  align-items: center !important;\n}\n\n.align-items-baseline {\n  align-items: baseline !important;\n}\n\n.align-items-stretch {\n  align-items: stretch !important;\n}\n\n.align-content-start {\n  align-content: flex-start !important;\n}\n\n.align-content-end {\n  align-content: flex-end !important;\n}\n\n.align-content-center {\n  align-content: center !important;\n}\n\n.align-content-between {\n  align-content: space-between !important;\n}\n\n.align-content-around {\n  align-content: space-around !important;\n}\n\n.align-content-stretch {\n  align-content: stretch !important;\n}\n\n.align-self-auto {\n  align-self: auto !important;\n}\n\n.align-self-start {\n  align-self: flex-start !important;\n}\n\n.align-self-end {\n  align-self: flex-end !important;\n}\n\n.align-self-center {\n  align-self: center !important;\n}\n\n.align-self-baseline {\n  align-self: baseline !important;\n}\n\n.align-self-stretch {\n  align-self: stretch !important;\n}\n\n.order-first {\n  order: -1 !important;\n}\n\n.order-0 {\n  order: 0 !important;\n}\n\n.order-1 {\n  order: 1 !important;\n}\n\n.order-2 {\n  order: 2 !important;\n}\n\n.order-3 {\n  order: 3 !important;\n}\n\n.order-4 {\n  order: 4 !important;\n}\n\n.order-5 {\n  order: 5 !important;\n}\n\n.order-last {\n  order: 6 !important;\n}\n\n.m-0 {\n  margin: 0 !important;\n}\n\n.m-1 {\n  margin: 0.25rem !important;\n}\n\n.m-2 {\n  margin: 0.5rem !important;\n}\n\n.m-3 {\n  margin: 0.75rem !important;\n}\n\n.m-4 {\n  margin: 1rem !important;\n}\n\n.m-5 {\n  margin: 1.25rem !important;\n}\n\n.m-6 {\n  margin: 1.5rem !important;\n}\n\n.m-7 {\n  margin: 1.75rem !important;\n}\n\n.m-8 {\n  margin: 2rem !important;\n}\n\n.m-9 {\n  margin: 2.25rem !important;\n}\n\n.m-10 {\n  margin: 2.5rem !important;\n}\n\n.m-11 {\n  margin: 2.75rem !important;\n}\n\n.m-12 {\n  margin: 3rem !important;\n}\n\n.m-13 {\n  margin: 3.25rem !important;\n}\n\n.m-14 {\n  margin: 3.5rem !important;\n}\n\n.m-15 {\n  margin: 3.75rem !important;\n}\n\n.m-16 {\n  margin: 4rem !important;\n}\n\n.m-17 {\n  margin: 4.25rem !important;\n}\n\n.m-18 {\n  margin: 4.5rem !important;\n}\n\n.m-19 {\n  margin: 4.75rem !important;\n}\n\n.m-20 {\n  margin: 5rem !important;\n}\n\n.m-auto {\n  margin: auto !important;\n}\n\n.mx-0 {\n  margin-right: 0 !important;\n  margin-left: 0 !important;\n}\n\n.mx-1 {\n  margin-right: 0.25rem !important;\n  margin-left: 0.25rem !important;\n}\n\n.mx-2 {\n  margin-right: 0.5rem !important;\n  margin-left: 0.5rem !important;\n}\n\n.mx-3 {\n  margin-right: 0.75rem !important;\n  margin-left: 0.75rem !important;\n}\n\n.mx-4 {\n  margin-right: 1rem !important;\n  margin-left: 1rem !important;\n}\n\n.mx-5 {\n  margin-right: 1.25rem !important;\n  margin-left: 1.25rem !important;\n}\n\n.mx-6 {\n  margin-right: 1.5rem !important;\n  margin-left: 1.5rem !important;\n}\n\n.mx-7 {\n  margin-right: 1.75rem !important;\n  margin-left: 1.75rem !important;\n}\n\n.mx-8 {\n  margin-right: 2rem !important;\n  margin-left: 2rem !important;\n}\n\n.mx-9 {\n  margin-right: 2.25rem !important;\n  margin-left: 2.25rem !important;\n}\n\n.mx-10 {\n  margin-right: 2.5rem !important;\n  margin-left: 2.5rem !important;\n}\n\n.mx-11 {\n  margin-right: 2.75rem !important;\n  margin-left: 2.75rem !important;\n}\n\n.mx-12 {\n  margin-right: 3rem !important;\n  margin-left: 3rem !important;\n}\n\n.mx-13 {\n  margin-right: 3.25rem !important;\n  margin-left: 3.25rem !important;\n}\n\n.mx-14 {\n  margin-right: 3.5rem !important;\n  margin-left: 3.5rem !important;\n}\n\n.mx-15 {\n  margin-right: 3.75rem !important;\n  margin-left: 3.75rem !important;\n}\n\n.mx-16 {\n  margin-right: 4rem !important;\n  margin-left: 4rem !important;\n}\n\n.mx-17 {\n  margin-right: 4.25rem !important;\n  margin-left: 4.25rem !important;\n}\n\n.mx-18 {\n  margin-right: 4.5rem !important;\n  margin-left: 4.5rem !important;\n}\n\n.mx-19 {\n  margin-right: 4.75rem !important;\n  margin-left: 4.75rem !important;\n}\n\n.mx-20 {\n  margin-right: 5rem !important;\n  margin-left: 5rem !important;\n}\n\n.mx-auto {\n  margin-right: auto !important;\n  margin-left: auto !important;\n}\n\n.my-0 {\n  margin-top: 0 !important;\n  margin-bottom: 0 !important;\n}\n\n.my-1 {\n  margin-top: 0.25rem !important;\n  margin-bottom: 0.25rem !important;\n}\n\n.my-2 {\n  margin-top: 0.5rem !important;\n  margin-bottom: 0.5rem !important;\n}\n\n.my-3 {\n  margin-top: 0.75rem !important;\n  margin-bottom: 0.75rem !important;\n}\n\n.my-4 {\n  margin-top: 1rem !important;\n  margin-bottom: 1rem !important;\n}\n\n.my-5 {\n  margin-top: 1.25rem !important;\n  margin-bottom: 1.25rem !important;\n}\n\n.my-6 {\n  margin-top: 1.5rem !important;\n  margin-bottom: 1.5rem !important;\n}\n\n.my-7 {\n  margin-top: 1.75rem !important;\n  margin-bottom: 1.75rem !important;\n}\n\n.my-8 {\n  margin-top: 2rem !important;\n  margin-bottom: 2rem !important;\n}\n\n.my-9 {\n  margin-top: 2.25rem !important;\n  margin-bottom: 2.25rem !important;\n}\n\n.my-10 {\n  margin-top: 2.5rem !important;\n  margin-bottom: 2.5rem !important;\n}\n\n.my-11 {\n  margin-top: 2.75rem !important;\n  margin-bottom: 2.75rem !important;\n}\n\n.my-12 {\n  margin-top: 3rem !important;\n  margin-bottom: 3rem !important;\n}\n\n.my-13 {\n  margin-top: 3.25rem !important;\n  margin-bottom: 3.25rem !important;\n}\n\n.my-14 {\n  margin-top: 3.5rem !important;\n  margin-bottom: 3.5rem !important;\n}\n\n.my-15 {\n  margin-top: 3.75rem !important;\n  margin-bottom: 3.75rem !important;\n}\n\n.my-16 {\n  margin-top: 4rem !important;\n  margin-bottom: 4rem !important;\n}\n\n.my-17 {\n  margin-top: 4.25rem !important;\n  margin-bottom: 4.25rem !important;\n}\n\n.my-18 {\n  margin-top: 4.5rem !important;\n  margin-bottom: 4.5rem !important;\n}\n\n.my-19 {\n  margin-top: 4.75rem !important;\n  margin-bottom: 4.75rem !important;\n}\n\n.my-20 {\n  margin-top: 5rem !important;\n  margin-bottom: 5rem !important;\n}\n\n.my-auto {\n  margin-top: auto !important;\n  margin-bottom: auto !important;\n}\n\n.mt-0 {\n  margin-top: 0 !important;\n}\n\n.mt-1 {\n  margin-top: 0.25rem !important;\n}\n\n.mt-2 {\n  margin-top: 0.5rem !important;\n}\n\n.mt-3 {\n  margin-top: 0.75rem !important;\n}\n\n.mt-4 {\n  margin-top: 1rem !important;\n}\n\n.mt-5 {\n  margin-top: 1.25rem !important;\n}\n\n.mt-6 {\n  margin-top: 1.5rem !important;\n}\n\n.mt-7 {\n  margin-top: 1.75rem !important;\n}\n\n.mt-8 {\n  margin-top: 2rem !important;\n}\n\n.mt-9 {\n  margin-top: 2.25rem !important;\n}\n\n.mt-10 {\n  margin-top: 2.5rem !important;\n}\n\n.mt-11 {\n  margin-top: 2.75rem !important;\n}\n\n.mt-12 {\n  margin-top: 3rem !important;\n}\n\n.mt-13 {\n  margin-top: 3.25rem !important;\n}\n\n.mt-14 {\n  margin-top: 3.5rem !important;\n}\n\n.mt-15 {\n  margin-top: 3.75rem !important;\n}\n\n.mt-16 {\n  margin-top: 4rem !important;\n}\n\n.mt-17 {\n  margin-top: 4.25rem !important;\n}\n\n.mt-18 {\n  margin-top: 4.5rem !important;\n}\n\n.mt-19 {\n  margin-top: 4.75rem !important;\n}\n\n.mt-20 {\n  margin-top: 5rem !important;\n}\n\n.mt-auto {\n  margin-top: auto !important;\n}\n\n.me-0 {\n  margin-right: 0 !important;\n}\n\n.me-1 {\n  margin-right: 0.25rem !important;\n}\n\n.me-2 {\n  margin-right: 0.5rem !important;\n}\n\n.me-3 {\n  margin-right: 0.75rem !important;\n}\n\n.me-4 {\n  margin-right: 1rem !important;\n}\n\n.me-5 {\n  margin-right: 1.25rem !important;\n}\n\n.me-6 {\n  margin-right: 1.5rem !important;\n}\n\n.me-7 {\n  margin-right: 1.75rem !important;\n}\n\n.me-8 {\n  margin-right: 2rem !important;\n}\n\n.me-9 {\n  margin-right: 2.25rem !important;\n}\n\n.me-10 {\n  margin-right: 2.5rem !important;\n}\n\n.me-11 {\n  margin-right: 2.75rem !important;\n}\n\n.me-12 {\n  margin-right: 3rem !important;\n}\n\n.me-13 {\n  margin-right: 3.25rem !important;\n}\n\n.me-14 {\n  margin-right: 3.5rem !important;\n}\n\n.me-15 {\n  margin-right: 3.75rem !important;\n}\n\n.me-16 {\n  margin-right: 4rem !important;\n}\n\n.me-17 {\n  margin-right: 4.25rem !important;\n}\n\n.me-18 {\n  margin-right: 4.5rem !important;\n}\n\n.me-19 {\n  margin-right: 4.75rem !important;\n}\n\n.me-20 {\n  margin-right: 5rem !important;\n}\n\n.me-auto {\n  margin-right: auto !important;\n}\n\n.mb-0 {\n  margin-bottom: 0 !important;\n}\n\n.mb-1 {\n  margin-bottom: 0.25rem !important;\n}\n\n.mb-2 {\n  margin-bottom: 0.5rem !important;\n}\n\n.mb-3 {\n  margin-bottom: 0.75rem !important;\n}\n\n.mb-4 {\n  margin-bottom: 1rem !important;\n}\n\n.mb-5 {\n  margin-bottom: 1.25rem !important;\n}\n\n.mb-6 {\n  margin-bottom: 1.5rem !important;\n}\n\n.mb-7 {\n  margin-bottom: 1.75rem !important;\n}\n\n.mb-8 {\n  margin-bottom: 2rem !important;\n}\n\n.mb-9 {\n  margin-bottom: 2.25rem !important;\n}\n\n.mb-10 {\n  margin-bottom: 2.5rem !important;\n}\n\n.mb-11 {\n  margin-bottom: 2.75rem !important;\n}\n\n.mb-12 {\n  margin-bottom: 3rem !important;\n}\n\n.mb-13 {\n  margin-bottom: 3.25rem !important;\n}\n\n.mb-14 {\n  margin-bottom: 3.5rem !important;\n}\n\n.mb-15 {\n  margin-bottom: 3.75rem !important;\n}\n\n.mb-16 {\n  margin-bottom: 4rem !important;\n}\n\n.mb-17 {\n  margin-bottom: 4.25rem !important;\n}\n\n.mb-18 {\n  margin-bottom: 4.5rem !important;\n}\n\n.mb-19 {\n  margin-bottom: 4.75rem !important;\n}\n\n.mb-20 {\n  margin-bottom: 5rem !important;\n}\n\n.mb-auto {\n  margin-bottom: auto !important;\n}\n\n.ms-0 {\n  margin-left: 0 !important;\n}\n\n.ms-1 {\n  margin-left: 0.25rem !important;\n}\n\n.ms-2 {\n  margin-left: 0.5rem !important;\n}\n\n.ms-3 {\n  margin-left: 0.75rem !important;\n}\n\n.ms-4 {\n  margin-left: 1rem !important;\n}\n\n.ms-5 {\n  margin-left: 1.25rem !important;\n}\n\n.ms-6 {\n  margin-left: 1.5rem !important;\n}\n\n.ms-7 {\n  margin-left: 1.75rem !important;\n}\n\n.ms-8 {\n  margin-left: 2rem !important;\n}\n\n.ms-9 {\n  margin-left: 2.25rem !important;\n}\n\n.ms-10 {\n  margin-left: 2.5rem !important;\n}\n\n.ms-11 {\n  margin-left: 2.75rem !important;\n}\n\n.ms-12 {\n  margin-left: 3rem !important;\n}\n\n.ms-13 {\n  margin-left: 3.25rem !important;\n}\n\n.ms-14 {\n  margin-left: 3.5rem !important;\n}\n\n.ms-15 {\n  margin-left: 3.75rem !important;\n}\n\n.ms-16 {\n  margin-left: 4rem !important;\n}\n\n.ms-17 {\n  margin-left: 4.25rem !important;\n}\n\n.ms-18 {\n  margin-left: 4.5rem !important;\n}\n\n.ms-19 {\n  margin-left: 4.75rem !important;\n}\n\n.ms-20 {\n  margin-left: 5rem !important;\n}\n\n.ms-auto {\n  margin-left: auto !important;\n}\n\n.m-n1 {\n  margin: -0.25rem !important;\n}\n\n.m-n2 {\n  margin: -0.5rem !important;\n}\n\n.m-n3 {\n  margin: -0.75rem !important;\n}\n\n.m-n4 {\n  margin: -1rem !important;\n}\n\n.m-n5 {\n  margin: -1.25rem !important;\n}\n\n.m-n6 {\n  margin: -1.5rem !important;\n}\n\n.m-n7 {\n  margin: -1.75rem !important;\n}\n\n.m-n8 {\n  margin: -2rem !important;\n}\n\n.m-n9 {\n  margin: -2.25rem !important;\n}\n\n.m-n10 {\n  margin: -2.5rem !important;\n}\n\n.m-n11 {\n  margin: -2.75rem !important;\n}\n\n.m-n12 {\n  margin: -3rem !important;\n}\n\n.m-n13 {\n  margin: -3.25rem !important;\n}\n\n.m-n14 {\n  margin: -3.5rem !important;\n}\n\n.m-n15 {\n  margin: -3.75rem !important;\n}\n\n.m-n16 {\n  margin: -4rem !important;\n}\n\n.m-n17 {\n  margin: -4.25rem !important;\n}\n\n.m-n18 {\n  margin: -4.5rem !important;\n}\n\n.m-n19 {\n  margin: -4.75rem !important;\n}\n\n.m-n20 {\n  margin: -5rem !important;\n}\n\n.mx-n1 {\n  margin-right: -0.25rem !important;\n  margin-left: -0.25rem !important;\n}\n\n.mx-n2 {\n  margin-right: -0.5rem !important;\n  margin-left: -0.5rem !important;\n}\n\n.mx-n3 {\n  margin-right: -0.75rem !important;\n  margin-left: -0.75rem !important;\n}\n\n.mx-n4 {\n  margin-right: -1rem !important;\n  margin-left: -1rem !important;\n}\n\n.mx-n5 {\n  margin-right: -1.25rem !important;\n  margin-left: -1.25rem !important;\n}\n\n.mx-n6 {\n  margin-right: -1.5rem !important;\n  margin-left: -1.5rem !important;\n}\n\n.mx-n7 {\n  margin-right: -1.75rem !important;\n  margin-left: -1.75rem !important;\n}\n\n.mx-n8 {\n  margin-right: -2rem !important;\n  margin-left: -2rem !important;\n}\n\n.mx-n9 {\n  margin-right: -2.25rem !important;\n  margin-left: -2.25rem !important;\n}\n\n.mx-n10 {\n  margin-right: -2.5rem !important;\n  margin-left: -2.5rem !important;\n}\n\n.mx-n11 {\n  margin-right: -2.75rem !important;\n  margin-left: -2.75rem !important;\n}\n\n.mx-n12 {\n  margin-right: -3rem !important;\n  margin-left: -3rem !important;\n}\n\n.mx-n13 {\n  margin-right: -3.25rem !important;\n  margin-left: -3.25rem !important;\n}\n\n.mx-n14 {\n  margin-right: -3.5rem !important;\n  margin-left: -3.5rem !important;\n}\n\n.mx-n15 {\n  margin-right: -3.75rem !important;\n  margin-left: -3.75rem !important;\n}\n\n.mx-n16 {\n  margin-right: -4rem !important;\n  margin-left: -4rem !important;\n}\n\n.mx-n17 {\n  margin-right: -4.25rem !important;\n  margin-left: -4.25rem !important;\n}\n\n.mx-n18 {\n  margin-right: -4.5rem !important;\n  margin-left: -4.5rem !important;\n}\n\n.mx-n19 {\n  margin-right: -4.75rem !important;\n  margin-left: -4.75rem !important;\n}\n\n.mx-n20 {\n  margin-right: -5rem !important;\n  margin-left: -5rem !important;\n}\n\n.my-n1 {\n  margin-top: -0.25rem !important;\n  margin-bottom: -0.25rem !important;\n}\n\n.my-n2 {\n  margin-top: -0.5rem !important;\n  margin-bottom: -0.5rem !important;\n}\n\n.my-n3 {\n  margin-top: -0.75rem !important;\n  margin-bottom: -0.75rem !important;\n}\n\n.my-n4 {\n  margin-top: -1rem !important;\n  margin-bottom: -1rem !important;\n}\n\n.my-n5 {\n  margin-top: -1.25rem !important;\n  margin-bottom: -1.25rem !important;\n}\n\n.my-n6 {\n  margin-top: -1.5rem !important;\n  margin-bottom: -1.5rem !important;\n}\n\n.my-n7 {\n  margin-top: -1.75rem !important;\n  margin-bottom: -1.75rem !important;\n}\n\n.my-n8 {\n  margin-top: -2rem !important;\n  margin-bottom: -2rem !important;\n}\n\n.my-n9 {\n  margin-top: -2.25rem !important;\n  margin-bottom: -2.25rem !important;\n}\n\n.my-n10 {\n  margin-top: -2.5rem !important;\n  margin-bottom: -2.5rem !important;\n}\n\n.my-n11 {\n  margin-top: -2.75rem !important;\n  margin-bottom: -2.75rem !important;\n}\n\n.my-n12 {\n  margin-top: -3rem !important;\n  margin-bottom: -3rem !important;\n}\n\n.my-n13 {\n  margin-top: -3.25rem !important;\n  margin-bottom: -3.25rem !important;\n}\n\n.my-n14 {\n  margin-top: -3.5rem !important;\n  margin-bottom: -3.5rem !important;\n}\n\n.my-n15 {\n  margin-top: -3.75rem !important;\n  margin-bottom: -3.75rem !important;\n}\n\n.my-n16 {\n  margin-top: -4rem !important;\n  margin-bottom: -4rem !important;\n}\n\n.my-n17 {\n  margin-top: -4.25rem !important;\n  margin-bottom: -4.25rem !important;\n}\n\n.my-n18 {\n  margin-top: -4.5rem !important;\n  margin-bottom: -4.5rem !important;\n}\n\n.my-n19 {\n  margin-top: -4.75rem !important;\n  margin-bottom: -4.75rem !important;\n}\n\n.my-n20 {\n  margin-top: -5rem !important;\n  margin-bottom: -5rem !important;\n}\n\n.mt-n1 {\n  margin-top: -0.25rem !important;\n}\n\n.mt-n2 {\n  margin-top: -0.5rem !important;\n}\n\n.mt-n3 {\n  margin-top: -0.75rem !important;\n}\n\n.mt-n4 {\n  margin-top: -1rem !important;\n}\n\n.mt-n5 {\n  margin-top: -1.25rem !important;\n}\n\n.mt-n6 {\n  margin-top: -1.5rem !important;\n}\n\n.mt-n7 {\n  margin-top: -1.75rem !important;\n}\n\n.mt-n8 {\n  margin-top: -2rem !important;\n}\n\n.mt-n9 {\n  margin-top: -2.25rem !important;\n}\n\n.mt-n10 {\n  margin-top: -2.5rem !important;\n}\n\n.mt-n11 {\n  margin-top: -2.75rem !important;\n}\n\n.mt-n12 {\n  margin-top: -3rem !important;\n}\n\n.mt-n13 {\n  margin-top: -3.25rem !important;\n}\n\n.mt-n14 {\n  margin-top: -3.5rem !important;\n}\n\n.mt-n15 {\n  margin-top: -3.75rem !important;\n}\n\n.mt-n16 {\n  margin-top: -4rem !important;\n}\n\n.mt-n17 {\n  margin-top: -4.25rem !important;\n}\n\n.mt-n18 {\n  margin-top: -4.5rem !important;\n}\n\n.mt-n19 {\n  margin-top: -4.75rem !important;\n}\n\n.mt-n20 {\n  margin-top: -5rem !important;\n}\n\n.me-n1 {\n  margin-right: -0.25rem !important;\n}\n\n.me-n2 {\n  margin-right: -0.5rem !important;\n}\n\n.me-n3 {\n  margin-right: -0.75rem !important;\n}\n\n.me-n4 {\n  margin-right: -1rem !important;\n}\n\n.me-n5 {\n  margin-right: -1.25rem !important;\n}\n\n.me-n6 {\n  margin-right: -1.5rem !important;\n}\n\n.me-n7 {\n  margin-right: -1.75rem !important;\n}\n\n.me-n8 {\n  margin-right: -2rem !important;\n}\n\n.me-n9 {\n  margin-right: -2.25rem !important;\n}\n\n.me-n10 {\n  margin-right: -2.5rem !important;\n}\n\n.me-n11 {\n  margin-right: -2.75rem !important;\n}\n\n.me-n12 {\n  margin-right: -3rem !important;\n}\n\n.me-n13 {\n  margin-right: -3.25rem !important;\n}\n\n.me-n14 {\n  margin-right: -3.5rem !important;\n}\n\n.me-n15 {\n  margin-right: -3.75rem !important;\n}\n\n.me-n16 {\n  margin-right: -4rem !important;\n}\n\n.me-n17 {\n  margin-right: -4.25rem !important;\n}\n\n.me-n18 {\n  margin-right: -4.5rem !important;\n}\n\n.me-n19 {\n  margin-right: -4.75rem !important;\n}\n\n.me-n20 {\n  margin-right: -5rem !important;\n}\n\n.mb-n1 {\n  margin-bottom: -0.25rem !important;\n}\n\n.mb-n2 {\n  margin-bottom: -0.5rem !important;\n}\n\n.mb-n3 {\n  margin-bottom: -0.75rem !important;\n}\n\n.mb-n4 {\n  margin-bottom: -1rem !important;\n}\n\n.mb-n5 {\n  margin-bottom: -1.25rem !important;\n}\n\n.mb-n6 {\n  margin-bottom: -1.5rem !important;\n}\n\n.mb-n7 {\n  margin-bottom: -1.75rem !important;\n}\n\n.mb-n8 {\n  margin-bottom: -2rem !important;\n}\n\n.mb-n9 {\n  margin-bottom: -2.25rem !important;\n}\n\n.mb-n10 {\n  margin-bottom: -2.5rem !important;\n}\n\n.mb-n11 {\n  margin-bottom: -2.75rem !important;\n}\n\n.mb-n12 {\n  margin-bottom: -3rem !important;\n}\n\n.mb-n13 {\n  margin-bottom: -3.25rem !important;\n}\n\n.mb-n14 {\n  margin-bottom: -3.5rem !important;\n}\n\n.mb-n15 {\n  margin-bottom: -3.75rem !important;\n}\n\n.mb-n16 {\n  margin-bottom: -4rem !important;\n}\n\n.mb-n17 {\n  margin-bottom: -4.25rem !important;\n}\n\n.mb-n18 {\n  margin-bottom: -4.5rem !important;\n}\n\n.mb-n19 {\n  margin-bottom: -4.75rem !important;\n}\n\n.mb-n20 {\n  margin-bottom: -5rem !important;\n}\n\n.ms-n1 {\n  margin-left: -0.25rem !important;\n}\n\n.ms-n2 {\n  margin-left: -0.5rem !important;\n}\n\n.ms-n3 {\n  margin-left: -0.75rem !important;\n}\n\n.ms-n4 {\n  margin-left: -1rem !important;\n}\n\n.ms-n5 {\n  margin-left: -1.25rem !important;\n}\n\n.ms-n6 {\n  margin-left: -1.5rem !important;\n}\n\n.ms-n7 {\n  margin-left: -1.75rem !important;\n}\n\n.ms-n8 {\n  margin-left: -2rem !important;\n}\n\n.ms-n9 {\n  margin-left: -2.25rem !important;\n}\n\n.ms-n10 {\n  margin-left: -2.5rem !important;\n}\n\n.ms-n11 {\n  margin-left: -2.75rem !important;\n}\n\n.ms-n12 {\n  margin-left: -3rem !important;\n}\n\n.ms-n13 {\n  margin-left: -3.25rem !important;\n}\n\n.ms-n14 {\n  margin-left: -3.5rem !important;\n}\n\n.ms-n15 {\n  margin-left: -3.75rem !important;\n}\n\n.ms-n16 {\n  margin-left: -4rem !important;\n}\n\n.ms-n17 {\n  margin-left: -4.25rem !important;\n}\n\n.ms-n18 {\n  margin-left: -4.5rem !important;\n}\n\n.ms-n19 {\n  margin-left: -4.75rem !important;\n}\n\n.ms-n20 {\n  margin-left: -5rem !important;\n}\n\n.p-0 {\n  padding: 0 !important;\n}\n\n.p-1 {\n  padding: 0.25rem !important;\n}\n\n.p-2 {\n  padding: 0.5rem !important;\n}\n\n.p-3 {\n  padding: 0.75rem !important;\n}\n\n.p-4 {\n  padding: 1rem !important;\n}\n\n.p-5 {\n  padding: 1.25rem !important;\n}\n\n.p-6 {\n  padding: 1.5rem !important;\n}\n\n.p-7 {\n  padding: 1.75rem !important;\n}\n\n.p-8 {\n  padding: 2rem !important;\n}\n\n.p-9 {\n  padding: 2.25rem !important;\n}\n\n.p-10 {\n  padding: 2.5rem !important;\n}\n\n.p-11 {\n  padding: 2.75rem !important;\n}\n\n.p-12 {\n  padding: 3rem !important;\n}\n\n.p-13 {\n  padding: 3.25rem !important;\n}\n\n.p-14 {\n  padding: 3.5rem !important;\n}\n\n.p-15 {\n  padding: 3.75rem !important;\n}\n\n.p-16 {\n  padding: 4rem !important;\n}\n\n.p-17 {\n  padding: 4.25rem !important;\n}\n\n.p-18 {\n  padding: 4.5rem !important;\n}\n\n.p-19 {\n  padding: 4.75rem !important;\n}\n\n.p-20 {\n  padding: 5rem !important;\n}\n\n.px-0 {\n  padding-right: 0 !important;\n  padding-left: 0 !important;\n}\n\n.px-1 {\n  padding-right: 0.25rem !important;\n  padding-left: 0.25rem !important;\n}\n\n.px-2 {\n  padding-right: 0.5rem !important;\n  padding-left: 0.5rem !important;\n}\n\n.px-3 {\n  padding-right: 0.75rem !important;\n  padding-left: 0.75rem !important;\n}\n\n.px-4 {\n  padding-right: 1rem !important;\n  padding-left: 1rem !important;\n}\n\n.px-5 {\n  padding-right: 1.25rem !important;\n  padding-left: 1.25rem !important;\n}\n\n.px-6 {\n  padding-right: 1.5rem !important;\n  padding-left: 1.5rem !important;\n}\n\n.px-7 {\n  padding-right: 1.75rem !important;\n  padding-left: 1.75rem !important;\n}\n\n.px-8 {\n  padding-right: 2rem !important;\n  padding-left: 2rem !important;\n}\n\n.px-9 {\n  padding-right: 2.25rem !important;\n  padding-left: 2.25rem !important;\n}\n\n.px-10 {\n  padding-right: 2.5rem !important;\n  padding-left: 2.5rem !important;\n}\n\n.px-11 {\n  padding-right: 2.75rem !important;\n  padding-left: 2.75rem !important;\n}\n\n.px-12 {\n  padding-right: 3rem !important;\n  padding-left: 3rem !important;\n}\n\n.px-13 {\n  padding-right: 3.25rem !important;\n  padding-left: 3.25rem !important;\n}\n\n.px-14 {\n  padding-right: 3.5rem !important;\n  padding-left: 3.5rem !important;\n}\n\n.px-15 {\n  padding-right: 3.75rem !important;\n  padding-left: 3.75rem !important;\n}\n\n.px-16 {\n  padding-right: 4rem !important;\n  padding-left: 4rem !important;\n}\n\n.px-17 {\n  padding-right: 4.25rem !important;\n  padding-left: 4.25rem !important;\n}\n\n.px-18 {\n  padding-right: 4.5rem !important;\n  padding-left: 4.5rem !important;\n}\n\n.px-19 {\n  padding-right: 4.75rem !important;\n  padding-left: 4.75rem !important;\n}\n\n.px-20 {\n  padding-right: 5rem !important;\n  padding-left: 5rem !important;\n}\n\n.py-0 {\n  padding-top: 0 !important;\n  padding-bottom: 0 !important;\n}\n\n.py-1 {\n  padding-top: 0.25rem !important;\n  padding-bottom: 0.25rem !important;\n}\n\n.py-2 {\n  padding-top: 0.5rem !important;\n  padding-bottom: 0.5rem !important;\n}\n\n.py-3 {\n  padding-top: 0.75rem !important;\n  padding-bottom: 0.75rem !important;\n}\n\n.py-4 {\n  padding-top: 1rem !important;\n  padding-bottom: 1rem !important;\n}\n\n.py-5 {\n  padding-top: 1.25rem !important;\n  padding-bottom: 1.25rem !important;\n}\n\n.py-6 {\n  padding-top: 1.5rem !important;\n  padding-bottom: 1.5rem !important;\n}\n\n.py-7 {\n  padding-top: 1.75rem !important;\n  padding-bottom: 1.75rem !important;\n}\n\n.py-8 {\n  padding-top: 2rem !important;\n  padding-bottom: 2rem !important;\n}\n\n.py-9 {\n  padding-top: 2.25rem !important;\n  padding-bottom: 2.25rem !important;\n}\n\n.py-10 {\n  padding-top: 2.5rem !important;\n  padding-bottom: 2.5rem !important;\n}\n\n.py-11 {\n  padding-top: 2.75rem !important;\n  padding-bottom: 2.75rem !important;\n}\n\n.py-12 {\n  padding-top: 3rem !important;\n  padding-bottom: 3rem !important;\n}\n\n.py-13 {\n  padding-top: 3.25rem !important;\n  padding-bottom: 3.25rem !important;\n}\n\n.py-14 {\n  padding-top: 3.5rem !important;\n  padding-bottom: 3.5rem !important;\n}\n\n.py-15 {\n  padding-top: 3.75rem !important;\n  padding-bottom: 3.75rem !important;\n}\n\n.py-16 {\n  padding-top: 4rem !important;\n  padding-bottom: 4rem !important;\n}\n\n.py-17 {\n  padding-top: 4.25rem !important;\n  padding-bottom: 4.25rem !important;\n}\n\n.py-18 {\n  padding-top: 4.5rem !important;\n  padding-bottom: 4.5rem !important;\n}\n\n.py-19 {\n  padding-top: 4.75rem !important;\n  padding-bottom: 4.75rem !important;\n}\n\n.py-20 {\n  padding-top: 5rem !important;\n  padding-bottom: 5rem !important;\n}\n\n.pt-0 {\n  padding-top: 0 !important;\n}\n\n.pt-1 {\n  padding-top: 0.25rem !important;\n}\n\n.pt-2 {\n  padding-top: 0.5rem !important;\n}\n\n.pt-3 {\n  padding-top: 0.75rem !important;\n}\n\n.pt-4 {\n  padding-top: 1rem !important;\n}\n\n.pt-5 {\n  padding-top: 1.25rem !important;\n}\n\n.pt-6 {\n  padding-top: 1.5rem !important;\n}\n\n.pt-7 {\n  padding-top: 1.75rem !important;\n}\n\n.pt-8 {\n  padding-top: 2rem !important;\n}\n\n.pt-9 {\n  padding-top: 2.25rem !important;\n}\n\n.pt-10 {\n  padding-top: 2.5rem !important;\n}\n\n.pt-11 {\n  padding-top: 2.75rem !important;\n}\n\n.pt-12 {\n  padding-top: 3rem !important;\n}\n\n.pt-13 {\n  padding-top: 3.25rem !important;\n}\n\n.pt-14 {\n  padding-top: 3.5rem !important;\n}\n\n.pt-15 {\n  padding-top: 3.75rem !important;\n}\n\n.pt-16 {\n  padding-top: 4rem !important;\n}\n\n.pt-17 {\n  padding-top: 4.25rem !important;\n}\n\n.pt-18 {\n  padding-top: 4.5rem !important;\n}\n\n.pt-19 {\n  padding-top: 4.75rem !important;\n}\n\n.pt-20 {\n  padding-top: 5rem !important;\n}\n\n.pe-0 {\n  padding-right: 0 !important;\n}\n\n.pe-1 {\n  padding-right: 0.25rem !important;\n}\n\n.pe-2 {\n  padding-right: 0.5rem !important;\n}\n\n.pe-3 {\n  padding-right: 0.75rem !important;\n}\n\n.pe-4 {\n  padding-right: 1rem !important;\n}\n\n.pe-5 {\n  padding-right: 1.25rem !important;\n}\n\n.pe-6 {\n  padding-right: 1.5rem !important;\n}\n\n.pe-7 {\n  padding-right: 1.75rem !important;\n}\n\n.pe-8 {\n  padding-right: 2rem !important;\n}\n\n.pe-9 {\n  padding-right: 2.25rem !important;\n}\n\n.pe-10 {\n  padding-right: 2.5rem !important;\n}\n\n.pe-11 {\n  padding-right: 2.75rem !important;\n}\n\n.pe-12 {\n  padding-right: 3rem !important;\n}\n\n.pe-13 {\n  padding-right: 3.25rem !important;\n}\n\n.pe-14 {\n  padding-right: 3.5rem !important;\n}\n\n.pe-15 {\n  padding-right: 3.75rem !important;\n}\n\n.pe-16 {\n  padding-right: 4rem !important;\n}\n\n.pe-17 {\n  padding-right: 4.25rem !important;\n}\n\n.pe-18 {\n  padding-right: 4.5rem !important;\n}\n\n.pe-19 {\n  padding-right: 4.75rem !important;\n}\n\n.pe-20 {\n  padding-right: 5rem !important;\n}\n\n.pb-0 {\n  padding-bottom: 0 !important;\n}\n\n.pb-1 {\n  padding-bottom: 0.25rem !important;\n}\n\n.pb-2 {\n  padding-bottom: 0.5rem !important;\n}\n\n.pb-3 {\n  padding-bottom: 0.75rem !important;\n}\n\n.pb-4 {\n  padding-bottom: 1rem !important;\n}\n\n.pb-5 {\n  padding-bottom: 1.25rem !important;\n}\n\n.pb-6 {\n  padding-bottom: 1.5rem !important;\n}\n\n.pb-7 {\n  padding-bottom: 1.75rem !important;\n}\n\n.pb-8 {\n  padding-bottom: 2rem !important;\n}\n\n.pb-9 {\n  padding-bottom: 2.25rem !important;\n}\n\n.pb-10 {\n  padding-bottom: 2.5rem !important;\n}\n\n.pb-11 {\n  padding-bottom: 2.75rem !important;\n}\n\n.pb-12 {\n  padding-bottom: 3rem !important;\n}\n\n.pb-13 {\n  padding-bottom: 3.25rem !important;\n}\n\n.pb-14 {\n  padding-bottom: 3.5rem !important;\n}\n\n.pb-15 {\n  padding-bottom: 3.75rem !important;\n}\n\n.pb-16 {\n  padding-bottom: 4rem !important;\n}\n\n.pb-17 {\n  padding-bottom: 4.25rem !important;\n}\n\n.pb-18 {\n  padding-bottom: 4.5rem !important;\n}\n\n.pb-19 {\n  padding-bottom: 4.75rem !important;\n}\n\n.pb-20 {\n  padding-bottom: 5rem !important;\n}\n\n.ps-0 {\n  padding-left: 0 !important;\n}\n\n.ps-1 {\n  padding-left: 0.25rem !important;\n}\n\n.ps-2 {\n  padding-left: 0.5rem !important;\n}\n\n.ps-3 {\n  padding-left: 0.75rem !important;\n}\n\n.ps-4 {\n  padding-left: 1rem !important;\n}\n\n.ps-5 {\n  padding-left: 1.25rem !important;\n}\n\n.ps-6 {\n  padding-left: 1.5rem !important;\n}\n\n.ps-7 {\n  padding-left: 1.75rem !important;\n}\n\n.ps-8 {\n  padding-left: 2rem !important;\n}\n\n.ps-9 {\n  padding-left: 2.25rem !important;\n}\n\n.ps-10 {\n  padding-left: 2.5rem !important;\n}\n\n.ps-11 {\n  padding-left: 2.75rem !important;\n}\n\n.ps-12 {\n  padding-left: 3rem !important;\n}\n\n.ps-13 {\n  padding-left: 3.25rem !important;\n}\n\n.ps-14 {\n  padding-left: 3.5rem !important;\n}\n\n.ps-15 {\n  padding-left: 3.75rem !important;\n}\n\n.ps-16 {\n  padding-left: 4rem !important;\n}\n\n.ps-17 {\n  padding-left: 4.25rem !important;\n}\n\n.ps-18 {\n  padding-left: 4.5rem !important;\n}\n\n.ps-19 {\n  padding-left: 4.75rem !important;\n}\n\n.ps-20 {\n  padding-left: 5rem !important;\n}\n\n.gap-0 {\n  gap: 0 !important;\n}\n\n.gap-1 {\n  gap: 0.25rem !important;\n}\n\n.gap-2 {\n  gap: 0.5rem !important;\n}\n\n.gap-3 {\n  gap: 0.75rem !important;\n}\n\n.gap-4 {\n  gap: 1rem !important;\n}\n\n.gap-5 {\n  gap: 1.25rem !important;\n}\n\n.gap-6 {\n  gap: 1.5rem !important;\n}\n\n.gap-7 {\n  gap: 1.75rem !important;\n}\n\n.gap-8 {\n  gap: 2rem !important;\n}\n\n.gap-9 {\n  gap: 2.25rem !important;\n}\n\n.gap-10 {\n  gap: 2.5rem !important;\n}\n\n.gap-11 {\n  gap: 2.75rem !important;\n}\n\n.gap-12 {\n  gap: 3rem !important;\n}\n\n.gap-13 {\n  gap: 3.25rem !important;\n}\n\n.gap-14 {\n  gap: 3.5rem !important;\n}\n\n.gap-15 {\n  gap: 3.75rem !important;\n}\n\n.gap-16 {\n  gap: 4rem !important;\n}\n\n.gap-17 {\n  gap: 4.25rem !important;\n}\n\n.gap-18 {\n  gap: 4.5rem !important;\n}\n\n.gap-19 {\n  gap: 4.75rem !important;\n}\n\n.gap-20 {\n  gap: 5rem !important;\n}\n\n.row-gap-0 {\n  row-gap: 0 !important;\n}\n\n.row-gap-1 {\n  row-gap: 0.25rem !important;\n}\n\n.row-gap-2 {\n  row-gap: 0.5rem !important;\n}\n\n.row-gap-3 {\n  row-gap: 0.75rem !important;\n}\n\n.row-gap-4 {\n  row-gap: 1rem !important;\n}\n\n.row-gap-5 {\n  row-gap: 1.25rem !important;\n}\n\n.row-gap-6 {\n  row-gap: 1.5rem !important;\n}\n\n.row-gap-7 {\n  row-gap: 1.75rem !important;\n}\n\n.row-gap-8 {\n  row-gap: 2rem !important;\n}\n\n.row-gap-9 {\n  row-gap: 2.25rem !important;\n}\n\n.row-gap-10 {\n  row-gap: 2.5rem !important;\n}\n\n.row-gap-11 {\n  row-gap: 2.75rem !important;\n}\n\n.row-gap-12 {\n  row-gap: 3rem !important;\n}\n\n.row-gap-13 {\n  row-gap: 3.25rem !important;\n}\n\n.row-gap-14 {\n  row-gap: 3.5rem !important;\n}\n\n.row-gap-15 {\n  row-gap: 3.75rem !important;\n}\n\n.row-gap-16 {\n  row-gap: 4rem !important;\n}\n\n.row-gap-17 {\n  row-gap: 4.25rem !important;\n}\n\n.row-gap-18 {\n  row-gap: 4.5rem !important;\n}\n\n.row-gap-19 {\n  row-gap: 4.75rem !important;\n}\n\n.row-gap-20 {\n  row-gap: 5rem !important;\n}\n\n.column-gap-0 {\n  column-gap: 0 !important;\n}\n\n.column-gap-1 {\n  column-gap: 0.25rem !important;\n}\n\n.column-gap-2 {\n  column-gap: 0.5rem !important;\n}\n\n.column-gap-3 {\n  column-gap: 0.75rem !important;\n}\n\n.column-gap-4 {\n  column-gap: 1rem !important;\n}\n\n.column-gap-5 {\n  column-gap: 1.25rem !important;\n}\n\n.column-gap-6 {\n  column-gap: 1.5rem !important;\n}\n\n.column-gap-7 {\n  column-gap: 1.75rem !important;\n}\n\n.column-gap-8 {\n  column-gap: 2rem !important;\n}\n\n.column-gap-9 {\n  column-gap: 2.25rem !important;\n}\n\n.column-gap-10 {\n  column-gap: 2.5rem !important;\n}\n\n.column-gap-11 {\n  column-gap: 2.75rem !important;\n}\n\n.column-gap-12 {\n  column-gap: 3rem !important;\n}\n\n.column-gap-13 {\n  column-gap: 3.25rem !important;\n}\n\n.column-gap-14 {\n  column-gap: 3.5rem !important;\n}\n\n.column-gap-15 {\n  column-gap: 3.75rem !important;\n}\n\n.column-gap-16 {\n  column-gap: 4rem !important;\n}\n\n.column-gap-17 {\n  column-gap: 4.25rem !important;\n}\n\n.column-gap-18 {\n  column-gap: 4.5rem !important;\n}\n\n.column-gap-19 {\n  column-gap: 4.75rem !important;\n}\n\n.column-gap-20 {\n  column-gap: 5rem !important;\n}\n\n.font-monospace {\n  font-family: var(--bs-font-monospace) !important;\n}\n\n.fs-1 {\n  font-size: calc(1.3rem + 0.6vw) !important;\n}\n\n.fs-2 {\n  font-size: calc(1.275rem + 0.3vw) !important;\n}\n\n.fs-3 {\n  font-size: calc(1.26rem + 0.12vw) !important;\n}\n\n.fs-4 {\n  font-size: 1.25rem !important;\n}\n\n.fs-5 {\n  font-size: 1.15rem !important;\n}\n\n.fs-6 {\n  font-size: 1.075rem !important;\n}\n\n.fs-7 {\n  font-size: 0.95rem !important;\n}\n\n.fs-8 {\n  font-size: 0.85rem !important;\n}\n\n.fs-9 {\n  font-size: 0.75rem !important;\n}\n\n.fs-10 {\n  font-size: 0.5rem !important;\n}\n\n.fs-base {\n  font-size: 1rem !important;\n}\n\n.fs-fluid {\n  font-size: 100% !important;\n}\n\n.fs-2x {\n  font-size: calc(1.325rem + 0.9vw) !important;\n}\n\n.fs-2qx {\n  font-size: calc(1.35rem + 1.2vw) !important;\n}\n\n.fs-2hx {\n  font-size: calc(1.375rem + 1.5vw) !important;\n}\n\n.fs-2tx {\n  font-size: calc(1.4rem + 1.8vw) !important;\n}\n\n.fs-3x {\n  font-size: calc(1.425rem + 2.1vw) !important;\n}\n\n.fs-3qx {\n  font-size: calc(1.45rem + 2.4vw) !important;\n}\n\n.fs-3hx {\n  font-size: calc(1.475rem + 2.7vw) !important;\n}\n\n.fs-3tx {\n  font-size: calc(1.5rem + 3vw) !important;\n}\n\n.fs-4x {\n  font-size: calc(1.525rem + 3.3vw) !important;\n}\n\n.fs-4qx {\n  font-size: calc(1.55rem + 3.6vw) !important;\n}\n\n.fs-4hx {\n  font-size: calc(1.575rem + 3.9vw) !important;\n}\n\n.fs-4tx {\n  font-size: calc(1.6rem + 4.2vw) !important;\n}\n\n.fs-5x {\n  font-size: calc(1.625rem + 4.5vw) !important;\n}\n\n.fs-5qx {\n  font-size: calc(1.65rem + 4.8vw) !important;\n}\n\n.fs-5hx {\n  font-size: calc(1.675rem + 5.1vw) !important;\n}\n\n.fs-5tx {\n  font-size: calc(1.7rem + 5.4vw) !important;\n}\n\n.fs-6x {\n  font-size: calc(1.725rem + 5.7vw) !important;\n}\n\n.fs-6qx {\n  font-size: calc(1.75rem + 6vw) !important;\n}\n\n.fs-6hx {\n  font-size: calc(1.775rem + 6.3vw) !important;\n}\n\n.fs-6tx {\n  font-size: calc(1.8rem + 6.6vw) !important;\n}\n\n.fs-7x {\n  font-size: calc(1.825rem + 6.9vw) !important;\n}\n\n.fs-7qx {\n  font-size: calc(1.85rem + 7.2vw) !important;\n}\n\n.fs-7hx {\n  font-size: calc(1.875rem + 7.5vw) !important;\n}\n\n.fs-7tx {\n  font-size: calc(1.9rem + 7.8vw) !important;\n}\n\n.fst-italic {\n  font-style: italic !important;\n}\n\n.fst-normal {\n  font-style: normal !important;\n}\n\n.fw-lighter {\n  font-weight: lighter !important;\n}\n\n.fw-light {\n  font-weight: 300 !important;\n}\n\n.fw-normal {\n  font-weight: 400 !important;\n}\n\n.fw-medium {\n  font-weight: 500 !important;\n}\n\n.fw-semibold {\n  font-weight: 500 !important;\n}\n\n.fw-bold {\n  font-weight: 600 !important;\n}\n\n.fw-bolder {\n  font-weight: 700 !important;\n}\n\n.lh-0 {\n  line-height: 0 !important;\n}\n\n.lh-1 {\n  line-height: 1 !important;\n}\n\n.lh-sm {\n  line-height: 1.25 !important;\n}\n\n.lh-base {\n  line-height: 1.5 !important;\n}\n\n.lh-lg {\n  line-height: 1.75 !important;\n}\n\n.lh-xl {\n  line-height: 2 !important;\n}\n\n.lh-xxl {\n  line-height: 2.25 !important;\n}\n\n.text-start {\n  text-align: left !important;\n}\n\n.text-end {\n  text-align: right !important;\n}\n\n.text-center {\n  text-align: center !important;\n}\n\n.text-decoration-none {\n  text-decoration: none !important;\n}\n\n.text-decoration-underline {\n  text-decoration: underline !important;\n}\n\n.text-decoration-line-through {\n  text-decoration: line-through !important;\n}\n\n.text-lowercase {\n  text-transform: lowercase !important;\n}\n\n.text-uppercase {\n  text-transform: uppercase !important;\n}\n\n.text-capitalize {\n  text-transform: capitalize !important;\n}\n\n.text-wrap {\n  white-space: normal !important;\n}\n\n.text-nowrap {\n  white-space: nowrap !important;\n}\n\n/* rtl:begin:remove */\n.text-break {\n  word-wrap: break-word !important;\n  word-break: break-word !important;\n}\n\n/* rtl:end:remove */\n.text-light {\n  --bs-text-opacity: 1;\n  color: rgba(var(--bs-light-rgb), var(--bs-text-opacity)) !important;\n}\n\n.text-primary {\n  --bs-text-opacity: 1;\n  color: rgba(var(--bs-primary-rgb), var(--bs-text-opacity)) !important;\n}\n\n.text-secondary {\n  --bs-text-opacity: 1;\n  color: rgba(var(--bs-secondary-rgb), var(--bs-text-opacity)) !important;\n}\n\n.text-success {\n  --bs-text-opacity: 1;\n  color: rgba(var(--bs-success-rgb), var(--bs-text-opacity)) !important;\n}\n\n.text-info {\n  --bs-text-opacity: 1;\n  color: rgba(var(--bs-info-rgb), var(--bs-text-opacity)) !important;\n}\n\n.text-warning {\n  --bs-text-opacity: 1;\n  color: rgba(var(--bs-warning-rgb), var(--bs-text-opacity)) !important;\n}\n\n.text-danger {\n  --bs-text-opacity: 1;\n  color: rgba(var(--bs-danger-rgb), var(--bs-text-opacity)) !important;\n}\n\n.text-dark {\n  --bs-text-opacity: 1;\n  color: rgba(var(--bs-dark-rgb), var(--bs-text-opacity)) !important;\n}\n\n.text-black {\n  --bs-text-opacity: 1;\n  color: rgba(var(--bs-black-rgb), var(--bs-text-opacity)) !important;\n}\n\n.text-white {\n  --bs-text-opacity: 1;\n  color: rgba(var(--bs-white-rgb), var(--bs-text-opacity)) !important;\n}\n\n.text-body {\n  --bs-text-opacity: 1;\n  color: rgba(var(--bs-body-color-rgb), var(--bs-text-opacity)) !important;\n}\n\n.text-muted {\n  --bs-text-opacity: 1;\n  color: #A1A5B7 !important;\n}\n\n.text-black-50 {\n  --bs-text-opacity: 1;\n  color: rgba(0, 0, 0, 0.5) !important;\n}\n\n.text-white-50 {\n  --bs-text-opacity: 1;\n  color: rgba(255, 255, 255, 0.5) !important;\n}\n\n.text-body-secondary {\n  --bs-text-opacity: 1;\n  color: var(--bs-secondary-color) !important;\n}\n\n.text-body-tertiary {\n  --bs-text-opacity: 1;\n  color: var(--bs-tertiary-color) !important;\n}\n\n.text-body-emphasis {\n  --bs-text-opacity: 1;\n  color: var(--bs-emphasis-color) !important;\n}\n\n.text-reset {\n  --bs-text-opacity: 1;\n  color: inherit !important;\n}\n\n.text-opacity-25 {\n  --bs-text-opacity: 0.25;\n}\n\n.text-opacity-50 {\n  --bs-text-opacity: 0.5;\n}\n\n.text-opacity-75 {\n  --bs-text-opacity: 0.75;\n}\n\n.text-opacity-100 {\n  --bs-text-opacity: 1;\n}\n\n.text-primary-emphasis {\n  color: var(--bs-primary-text) !important;\n}\n\n.text-secondary-emphasis {\n  color: var(--bs-secondary-text) !important;\n}\n\n.text-success-emphasis {\n  color: var(--bs-success-text) !important;\n}\n\n.text-info-emphasis {\n  color: var(--bs-info-text) !important;\n}\n\n.text-warning-emphasis {\n  color: var(--bs-warning-text) !important;\n}\n\n.text-danger-emphasis {\n  color: var(--bs-danger-text) !important;\n}\n\n.text-light-emphasis {\n  color: var(--bs-light-text) !important;\n}\n\n.text-dark-emphasis {\n  color: var(--bs-dark-text) !important;\n}\n\n.bg-light {\n  --bs-bg-opacity: 1;\n  background-color: rgba(var(--bs-light-rgb), var(--bs-bg-opacity)) !important;\n}\n\n.bg-primary {\n  --bs-bg-opacity: 1;\n  background-color: rgba(var(--bs-primary-rgb), var(--bs-bg-opacity)) !important;\n}\n\n.bg-secondary {\n  --bs-bg-opacity: 1;\n  background-color: rgba(var(--bs-secondary-rgb), var(--bs-bg-opacity)) !important;\n}\n\n.bg-success {\n  --bs-bg-opacity: 1;\n  background-color: rgba(var(--bs-success-rgb), var(--bs-bg-opacity)) !important;\n}\n\n.bg-info {\n  --bs-bg-opacity: 1;\n  background-color: rgba(var(--bs-info-rgb), var(--bs-bg-opacity)) !important;\n}\n\n.bg-warning {\n  --bs-bg-opacity: 1;\n  background-color: rgba(var(--bs-warning-rgb), var(--bs-bg-opacity)) !important;\n}\n\n.bg-danger {\n  --bs-bg-opacity: 1;\n  background-color: rgba(var(--bs-danger-rgb), var(--bs-bg-opacity)) !important;\n}\n\n.bg-dark {\n  --bs-bg-opacity: 1;\n  background-color: rgba(var(--bs-dark-rgb), var(--bs-bg-opacity)) !important;\n}\n\n.bg-black {\n  --bs-bg-opacity: 1;\n  background-color: rgba(var(--bs-black-rgb), var(--bs-bg-opacity)) !important;\n}\n\n.bg-white {\n  --bs-bg-opacity: 1;\n  background-color: rgba(var(--bs-white-rgb), var(--bs-bg-opacity)) !important;\n}\n\n.bg-body {\n  --bs-bg-opacity: 1;\n  background-color: rgba(var(--bs-body-bg-rgb), var(--bs-bg-opacity)) !important;\n}\n\n.bg-transparent {\n  --bs-bg-opacity: 1;\n  background-color: transparent !important;\n}\n\n.bg-body-secondary {\n  --bs-bg-opacity: 1;\n  background-color: rgba(var(--bs-secondary-bg-rgb), var(--bs-bg-opacity)) !important;\n}\n\n.bg-body-tertiary {\n  --bs-bg-opacity: 1;\n  background-color: rgba(var(--bs-tertiary-bg-rgb), var(--bs-bg-opacity)) !important;\n}\n\n.bg-body-emphasis {\n  --bs-bg-opacity: 1;\n  background-color: rgba(var(--bs-emphasis-bg-rgb), var(--bs-bg-opacity)) !important;\n}\n\n.bg-opacity-10 {\n  --bs-bg-opacity: 0.1;\n}\n\n.bg-opacity-25 {\n  --bs-bg-opacity: 0.25;\n}\n\n.bg-opacity-50 {\n  --bs-bg-opacity: 0.5;\n}\n\n.bg-opacity-75 {\n  --bs-bg-opacity: 0.75;\n}\n\n.bg-opacity-100 {\n  --bs-bg-opacity: 1;\n}\n\n.bg-primary-subtle {\n  background-color: var(--bs-primary-bg-subtle) !important;\n}\n\n.bg-secondary-subtle {\n  background-color: var(--bs-secondary-bg-subtle) !important;\n}\n\n.bg-success-subtle {\n  background-color: var(--bs-success-bg-subtle) !important;\n}\n\n.bg-info-subtle {\n  background-color: var(--bs-info-bg-subtle) !important;\n}\n\n.bg-warning-subtle {\n  background-color: var(--bs-warning-bg-subtle) !important;\n}\n\n.bg-danger-subtle {\n  background-color: var(--bs-danger-bg-subtle) !important;\n}\n\n.bg-light-subtle {\n  background-color: var(--bs-light-bg-subtle) !important;\n}\n\n.bg-dark-subtle {\n  background-color: var(--bs-dark-bg-subtle) !important;\n}\n\n.bg-gradient {\n  background-image: var(--bs-gradient) !important;\n}\n\n.user-select-all {\n  user-select: all !important;\n}\n\n.user-select-auto {\n  user-select: auto !important;\n}\n\n.user-select-none {\n  user-select: none !important;\n}\n\n.pe-none {\n  pointer-events: none !important;\n}\n\n.pe-auto {\n  pointer-events: auto !important;\n}\n\n.rounded {\n  border-radius: 0.475rem !important;\n}\n\n.rounded-0 {\n  border-radius: 0 !important;\n}\n\n.rounded-1 {\n  border-radius: 0.425rem !important;\n}\n\n.rounded-2 {\n  border-radius: 0.475rem !important;\n}\n\n.rounded-3 {\n  border-radius: 0.625rem !important;\n}\n\n.rounded-4 {\n  border-radius: 1rem !important;\n}\n\n.rounded-circle {\n  border-radius: 50% !important;\n}\n\n.rounded-pill {\n  border-radius: 50rem !important;\n}\n\n.rounded-top {\n  border-top-left-radius: var(--bs-border-radius) !important;\n  border-top-right-radius: var(--bs-border-radius) !important;\n}\n\n.rounded-top-0 {\n  border-top-left-radius: 0 !important;\n  border-top-right-radius: 0 !important;\n}\n\n.rounded-top-1 {\n  border-top-left-radius: var(--bs-border-radius-sm) !important;\n  border-top-right-radius: var(--bs-border-radius-sm) !important;\n}\n\n.rounded-top-2 {\n  border-top-left-radius: var(--bs-border-radius) !important;\n  border-top-right-radius: var(--bs-border-radius) !important;\n}\n\n.rounded-top-3 {\n  border-top-left-radius: var(--bs-border-radius-lg) !important;\n  border-top-right-radius: var(--bs-border-radius-lg) !important;\n}\n\n.rounded-top-4 {\n  border-top-left-radius: var(--bs-border-radius-xl) !important;\n  border-top-right-radius: var(--bs-border-radius-xl) !important;\n}\n\n.rounded-top-5 {\n  border-top-left-radius: var(--bs-border-radius-2xl) !important;\n  border-top-right-radius: var(--bs-border-radius-2xl) !important;\n}\n\n.rounded-top-circle {\n  border-top-left-radius: 50% !important;\n  border-top-right-radius: 50% !important;\n}\n\n.rounded-top-pill {\n  border-top-left-radius: var(--bs-border-radius-pill) !important;\n  border-top-right-radius: var(--bs-border-radius-pill) !important;\n}\n\n.rounded-end {\n  border-top-right-radius: var(--bs-border-radius) !important;\n  border-bottom-right-radius: var(--bs-border-radius) !important;\n}\n\n.rounded-end-0 {\n  border-top-right-radius: 0 !important;\n  border-bottom-right-radius: 0 !important;\n}\n\n.rounded-end-1 {\n  border-top-right-radius: var(--bs-border-radius-sm) !important;\n  border-bottom-right-radius: var(--bs-border-radius-sm) !important;\n}\n\n.rounded-end-2 {\n  border-top-right-radius: var(--bs-border-radius) !important;\n  border-bottom-right-radius: var(--bs-border-radius) !important;\n}\n\n.rounded-end-3 {\n  border-top-right-radius: var(--bs-border-radius-lg) !important;\n  border-bottom-right-radius: var(--bs-border-radius-lg) !important;\n}\n\n.rounded-end-4 {\n  border-top-right-radius: var(--bs-border-radius-xl) !important;\n  border-bottom-right-radius: var(--bs-border-radius-xl) !important;\n}\n\n.rounded-end-5 {\n  border-top-right-radius: var(--bs-border-radius-2xl) !important;\n  border-bottom-right-radius: var(--bs-border-radius-2xl) !important;\n}\n\n.rounded-end-circle {\n  border-top-right-radius: 50% !important;\n  border-bottom-right-radius: 50% !important;\n}\n\n.rounded-end-pill {\n  border-top-right-radius: var(--bs-border-radius-pill) !important;\n  border-bottom-right-radius: var(--bs-border-radius-pill) !important;\n}\n\n.rounded-bottom {\n  border-bottom-right-radius: var(--bs-border-radius) !important;\n  border-bottom-left-radius: var(--bs-border-radius) !important;\n}\n\n.rounded-bottom-0 {\n  border-bottom-right-radius: 0 !important;\n  border-bottom-left-radius: 0 !important;\n}\n\n.rounded-bottom-1 {\n  border-bottom-right-radius: var(--bs-border-radius-sm) !important;\n  border-bottom-left-radius: var(--bs-border-radius-sm) !important;\n}\n\n.rounded-bottom-2 {\n  border-bottom-right-radius: var(--bs-border-radius) !important;\n  border-bottom-left-radius: var(--bs-border-radius) !important;\n}\n\n.rounded-bottom-3 {\n  border-bottom-right-radius: var(--bs-border-radius-lg) !important;\n  border-bottom-left-radius: var(--bs-border-radius-lg) !important;\n}\n\n.rounded-bottom-4 {\n  border-bottom-right-radius: var(--bs-border-radius-xl) !important;\n  border-bottom-left-radius: var(--bs-border-radius-xl) !important;\n}\n\n.rounded-bottom-5 {\n  border-bottom-right-radius: var(--bs-border-radius-2xl) !important;\n  border-bottom-left-radius: var(--bs-border-radius-2xl) !important;\n}\n\n.rounded-bottom-circle {\n  border-bottom-right-radius: 50% !important;\n  border-bottom-left-radius: 50% !important;\n}\n\n.rounded-bottom-pill {\n  border-bottom-right-radius: var(--bs-border-radius-pill) !important;\n  border-bottom-left-radius: var(--bs-border-radius-pill) !important;\n}\n\n.rounded-start {\n  border-bottom-left-radius: var(--bs-border-radius) !important;\n  border-top-left-radius: var(--bs-border-radius) !important;\n}\n\n.rounded-start-0 {\n  border-bottom-left-radius: 0 !important;\n  border-top-left-radius: 0 !important;\n}\n\n.rounded-start-1 {\n  border-bottom-left-radius: var(--bs-border-radius-sm) !important;\n  border-top-left-radius: var(--bs-border-radius-sm) !important;\n}\n\n.rounded-start-2 {\n  border-bottom-left-radius: var(--bs-border-radius) !important;\n  border-top-left-radius: var(--bs-border-radius) !important;\n}\n\n.rounded-start-3 {\n  border-bottom-left-radius: var(--bs-border-radius-lg) !important;\n  border-top-left-radius: var(--bs-border-radius-lg) !important;\n}\n\n.rounded-start-4 {\n  border-bottom-left-radius: var(--bs-border-radius-xl) !important;\n  border-top-left-radius: var(--bs-border-radius-xl) !important;\n}\n\n.rounded-start-5 {\n  border-bottom-left-radius: var(--bs-border-radius-2xl) !important;\n  border-top-left-radius: var(--bs-border-radius-2xl) !important;\n}\n\n.rounded-start-circle {\n  border-bottom-left-radius: 50% !important;\n  border-top-left-radius: 50% !important;\n}\n\n.rounded-start-pill {\n  border-bottom-left-radius: var(--bs-border-radius-pill) !important;\n  border-top-left-radius: var(--bs-border-radius-pill) !important;\n}\n\n.visible {\n  visibility: visible !important;\n}\n\n.invisible {\n  visibility: hidden !important;\n}\n\n.z-index-n1 {\n  z-index: -1 !important;\n}\n\n.z-index-n2 {\n  z-index: -2 !important;\n}\n\n.z-index-0 {\n  z-index: 0 !important;\n}\n\n.z-index-1 {\n  z-index: 1 !important;\n}\n\n.z-index-2 {\n  z-index: 2 !important;\n}\n\n.z-index-3 {\n  z-index: 3 !important;\n}\n\n.opacity-0 {\n  opacity: 0 !important;\n}\n\n.opacity-0-hover:hover {\n  opacity: 0 !important;\n}\n\n.opacity-5 {\n  opacity: 0.05 !important;\n}\n\n.opacity-5-hover:hover {\n  opacity: 0.05 !important;\n}\n\n.opacity-10 {\n  opacity: 0.1 !important;\n}\n\n.opacity-10-hover:hover {\n  opacity: 0.1 !important;\n}\n\n.opacity-15 {\n  opacity: 0.15 !important;\n}\n\n.opacity-15-hover:hover {\n  opacity: 0.15 !important;\n}\n\n.opacity-20 {\n  opacity: 0.2 !important;\n}\n\n.opacity-20-hover:hover {\n  opacity: 0.2 !important;\n}\n\n.opacity-25 {\n  opacity: 0.25 !important;\n}\n\n.opacity-25-hover:hover {\n  opacity: 0.25 !important;\n}\n\n.opacity-50 {\n  opacity: 0.5 !important;\n}\n\n.opacity-50-hover:hover {\n  opacity: 0.5 !important;\n}\n\n.opacity-75 {\n  opacity: 0.75 !important;\n}\n\n.opacity-75-hover:hover {\n  opacity: 0.75 !important;\n}\n\n.opacity-100 {\n  opacity: 1 !important;\n}\n\n.opacity-100-hover:hover {\n  opacity: 1 !important;\n}\n\n.min-w-unset {\n  min-width: unset !important;\n}\n\n.min-w-25 {\n  min-width: 25% !important;\n}\n\n.min-w-50 {\n  min-width: 50% !important;\n}\n\n.min-w-75 {\n  min-width: 75% !important;\n}\n\n.min-w-100 {\n  min-width: 100% !important;\n}\n\n.min-w-auto {\n  min-width: auto !important;\n}\n\n.min-w-1px {\n  min-width: 1px !important;\n}\n\n.min-w-2px {\n  min-width: 2px !important;\n}\n\n.min-w-3px {\n  min-width: 3px !important;\n}\n\n.min-w-4px {\n  min-width: 4px !important;\n}\n\n.min-w-5px {\n  min-width: 5px !important;\n}\n\n.min-w-6px {\n  min-width: 6px !important;\n}\n\n.min-w-7px {\n  min-width: 7px !important;\n}\n\n.min-w-8px {\n  min-width: 8px !important;\n}\n\n.min-w-9px {\n  min-width: 9px !important;\n}\n\n.min-w-10px {\n  min-width: 10px !important;\n}\n\n.min-w-15px {\n  min-width: 15px !important;\n}\n\n.min-w-20px {\n  min-width: 20px !important;\n}\n\n.min-w-25px {\n  min-width: 25px !important;\n}\n\n.min-w-30px {\n  min-width: 30px !important;\n}\n\n.min-w-35px {\n  min-width: 35px !important;\n}\n\n.min-w-40px {\n  min-width: 40px !important;\n}\n\n.min-w-45px {\n  min-width: 45px !important;\n}\n\n.min-w-50px {\n  min-width: 50px !important;\n}\n\n.min-w-55px {\n  min-width: 55px !important;\n}\n\n.min-w-60px {\n  min-width: 60px !important;\n}\n\n.min-w-65px {\n  min-width: 65px !important;\n}\n\n.min-w-70px {\n  min-width: 70px !important;\n}\n\n.min-w-75px {\n  min-width: 75px !important;\n}\n\n.min-w-80px {\n  min-width: 80px !important;\n}\n\n.min-w-85px {\n  min-width: 85px !important;\n}\n\n.min-w-90px {\n  min-width: 90px !important;\n}\n\n.min-w-95px {\n  min-width: 95px !important;\n}\n\n.min-w-100px {\n  min-width: 100px !important;\n}\n\n.min-w-125px {\n  min-width: 125px !important;\n}\n\n.min-w-150px {\n  min-width: 150px !important;\n}\n\n.min-w-175px {\n  min-width: 175px !important;\n}\n\n.min-w-200px {\n  min-width: 200px !important;\n}\n\n.min-w-225px {\n  min-width: 225px !important;\n}\n\n.min-w-250px {\n  min-width: 250px !important;\n}\n\n.min-w-275px {\n  min-width: 275px !important;\n}\n\n.min-w-300px {\n  min-width: 300px !important;\n}\n\n.min-w-325px {\n  min-width: 325px !important;\n}\n\n.min-w-350px {\n  min-width: 350px !important;\n}\n\n.min-w-375px {\n  min-width: 375px !important;\n}\n\n.min-w-400px {\n  min-width: 400px !important;\n}\n\n.min-w-425px {\n  min-width: 425px !important;\n}\n\n.min-w-450px {\n  min-width: 450px !important;\n}\n\n.min-w-475px {\n  min-width: 475px !important;\n}\n\n.min-w-500px {\n  min-width: 500px !important;\n}\n\n.min-w-550px {\n  min-width: 550px !important;\n}\n\n.min-w-600px {\n  min-width: 600px !important;\n}\n\n.min-w-650px {\n  min-width: 650px !important;\n}\n\n.min-w-700px {\n  min-width: 700px !important;\n}\n\n.min-w-750px {\n  min-width: 750px !important;\n}\n\n.min-w-800px {\n  min-width: 800px !important;\n}\n\n.min-w-850px {\n  min-width: 850px !important;\n}\n\n.min-w-900px {\n  min-width: 900px !important;\n}\n\n.min-w-950px {\n  min-width: 950px !important;\n}\n\n.min-w-1000px {\n  min-width: 1000px !important;\n}\n\n.min-h-unset {\n  min-height: unset !important;\n}\n\n.min-h-25 {\n  min-height: 25% !important;\n}\n\n.min-h-50 {\n  min-height: 50% !important;\n}\n\n.min-h-75 {\n  min-height: 75% !important;\n}\n\n.min-h-100 {\n  min-height: 100% !important;\n}\n\n.min-h-auto {\n  min-height: auto !important;\n}\n\n.min-h-1px {\n  min-height: 1px !important;\n}\n\n.min-h-2px {\n  min-height: 2px !important;\n}\n\n.min-h-3px {\n  min-height: 3px !important;\n}\n\n.min-h-4px {\n  min-height: 4px !important;\n}\n\n.min-h-5px {\n  min-height: 5px !important;\n}\n\n.min-h-6px {\n  min-height: 6px !important;\n}\n\n.min-h-7px {\n  min-height: 7px !important;\n}\n\n.min-h-8px {\n  min-height: 8px !important;\n}\n\n.min-h-9px {\n  min-height: 9px !important;\n}\n\n.min-h-10px {\n  min-height: 10px !important;\n}\n\n.min-h-15px {\n  min-height: 15px !important;\n}\n\n.min-h-20px {\n  min-height: 20px !important;\n}\n\n.min-h-25px {\n  min-height: 25px !important;\n}\n\n.min-h-30px {\n  min-height: 30px !important;\n}\n\n.min-h-35px {\n  min-height: 35px !important;\n}\n\n.min-h-40px {\n  min-height: 40px !important;\n}\n\n.min-h-45px {\n  min-height: 45px !important;\n}\n\n.min-h-50px {\n  min-height: 50px !important;\n}\n\n.min-h-55px {\n  min-height: 55px !important;\n}\n\n.min-h-60px {\n  min-height: 60px !important;\n}\n\n.min-h-65px {\n  min-height: 65px !important;\n}\n\n.min-h-70px {\n  min-height: 70px !important;\n}\n\n.min-h-75px {\n  min-height: 75px !important;\n}\n\n.min-h-80px {\n  min-height: 80px !important;\n}\n\n.min-h-85px {\n  min-height: 85px !important;\n}\n\n.min-h-90px {\n  min-height: 90px !important;\n}\n\n.min-h-95px {\n  min-height: 95px !important;\n}\n\n.min-h-100px {\n  min-height: 100px !important;\n}\n\n.min-h-125px {\n  min-height: 125px !important;\n}\n\n.min-h-150px {\n  min-height: 150px !important;\n}\n\n.min-h-175px {\n  min-height: 175px !important;\n}\n\n.min-h-200px {\n  min-height: 200px !important;\n}\n\n.min-h-225px {\n  min-height: 225px !important;\n}\n\n.min-h-250px {\n  min-height: 250px !important;\n}\n\n.min-h-275px {\n  min-height: 275px !important;\n}\n\n.min-h-300px {\n  min-height: 300px !important;\n}\n\n.min-h-325px {\n  min-height: 325px !important;\n}\n\n.min-h-350px {\n  min-height: 350px !important;\n}\n\n.min-h-375px {\n  min-height: 375px !important;\n}\n\n.min-h-400px {\n  min-height: 400px !important;\n}\n\n.min-h-425px {\n  min-height: 425px !important;\n}\n\n.min-h-450px {\n  min-height: 450px !important;\n}\n\n.min-h-475px {\n  min-height: 475px !important;\n}\n\n.min-h-500px {\n  min-height: 500px !important;\n}\n\n.min-h-550px {\n  min-height: 550px !important;\n}\n\n.min-h-600px {\n  min-height: 600px !important;\n}\n\n.min-h-650px {\n  min-height: 650px !important;\n}\n\n.min-h-700px {\n  min-height: 700px !important;\n}\n\n.min-h-750px {\n  min-height: 750px !important;\n}\n\n.min-h-800px {\n  min-height: 800px !important;\n}\n\n.min-h-850px {\n  min-height: 850px !important;\n}\n\n.min-h-900px {\n  min-height: 900px !important;\n}\n\n.min-h-950px {\n  min-height: 950px !important;\n}\n\n.min-h-1000px {\n  min-height: 1000px !important;\n}\n\n.border-top-0 {\n  border-top-width: 0 !important;\n}\n\n.border-top-1 {\n  border-top-width: 1px !important;\n}\n\n.border-top-2 {\n  border-top-width: 2px !important;\n}\n\n.border-top-3 {\n  border-top-width: 3px !important;\n}\n\n.border-top-4 {\n  border-top-width: 4px !important;\n}\n\n.border-top-5 {\n  border-top-width: 5px !important;\n}\n\n.border-bottom-0 {\n  border-bottom-width: 0 !important;\n}\n\n.border-bottom-1 {\n  border-bottom-width: 1px !important;\n}\n\n.border-bottom-2 {\n  border-bottom-width: 2px !important;\n}\n\n.border-bottom-3 {\n  border-bottom-width: 3px !important;\n}\n\n.border-bottom-4 {\n  border-bottom-width: 4px !important;\n}\n\n.border-bottom-5 {\n  border-bottom-width: 5px !important;\n}\n\n.border-right-0 {\n  border-right-width: 0 !important;\n}\n\n.border-right-1 {\n  border-right-width: 1px !important;\n}\n\n.border-right-2 {\n  border-right-width: 2px !important;\n}\n\n.border-right-3 {\n  border-right-width: 3px !important;\n}\n\n.border-right-4 {\n  border-right-width: 4px !important;\n}\n\n.border-right-5 {\n  border-right-width: 5px !important;\n}\n\n.border-left-0 {\n  border-left-width: 0 !important;\n}\n\n.border-left-1 {\n  border-left-width: 1px !important;\n}\n\n.border-left-2 {\n  border-left-width: 2px !important;\n}\n\n.border-left-3 {\n  border-left-width: 3px !important;\n}\n\n.border-left-4 {\n  border-left-width: 4px !important;\n}\n\n.border-left-5 {\n  border-left-width: 5px !important;\n}\n\n.ls-1 {\n  letter-spacing: 0.1rem !important;\n}\n\n.ls-2 {\n  letter-spacing: 0.115rem !important;\n}\n\n.ls-3 {\n  letter-spacing: 0.125rem !important;\n}\n\n.ls-4 {\n  letter-spacing: 0.25rem !important;\n}\n\n.ls-5 {\n  letter-spacing: 0.5rem !important;\n}\n\n.ls-n1 {\n  letter-spacing: -0.1rem !important;\n}\n\n.ls-n2 {\n  letter-spacing: -0.115rem !important;\n}\n\n.ls-n3 {\n  letter-spacing: -0.125rem !important;\n}\n\n.ls-n4 {\n  letter-spacing: -0.25rem !important;\n}\n\n.ls-n5 {\n  letter-spacing: -0.5rem !important;\n}\n\n@media (min-width: 576px) {\n  .float-sm-start {\n    float: left !important;\n  }\n  .float-sm-end {\n    float: right !important;\n  }\n  .float-sm-none {\n    float: none !important;\n  }\n  .object-fit-sm-contain {\n    object-fit: contain !important;\n  }\n  .object-fit-sm-cover {\n    object-fit: cover !important;\n  }\n  .object-fit-sm-fill {\n    object-fit: fill !important;\n  }\n  .object-fit-sm-scale {\n    object-fit: scale-down !important;\n  }\n  .object-fit-sm-none {\n    object-fit: none !important;\n  }\n  .overflow-sm-auto {\n    overflow: auto !important;\n  }\n  .overflow-sm-hidden {\n    overflow: hidden !important;\n  }\n  .overflow-sm-visible {\n    overflow: visible !important;\n  }\n  .overflow-sm-scroll {\n    overflow: scroll !important;\n  }\n  .d-sm-inline {\n    display: inline !important;\n  }\n  .d-sm-inline-block {\n    display: inline-block !important;\n  }\n  .d-sm-block {\n    display: block !important;\n  }\n  .d-sm-grid {\n    display: grid !important;\n  }\n  .d-sm-table {\n    display: table !important;\n  }\n  .d-sm-table-row {\n    display: table-row !important;\n  }\n  .d-sm-table-cell {\n    display: table-cell !important;\n  }\n  .d-sm-flex {\n    display: flex !important;\n  }\n  .d-sm-inline-flex {\n    display: inline-flex !important;\n  }\n  .d-sm-none {\n    display: none !important;\n  }\n  .position-sm-static {\n    position: static !important;\n  }\n  .position-sm-relative {\n    position: relative !important;\n  }\n  .position-sm-absolute {\n    position: absolute !important;\n  }\n  .position-sm-fixed {\n    position: fixed !important;\n  }\n  .position-sm-sticky {\n    position: sticky !important;\n  }\n  .w-sm-unset {\n    width: unset !important;\n  }\n  .w-sm-25 {\n    width: 25% !important;\n  }\n  .w-sm-50 {\n    width: 50% !important;\n  }\n  .w-sm-75 {\n    width: 75% !important;\n  }\n  .w-sm-100 {\n    width: 100% !important;\n  }\n  .w-sm-auto {\n    width: auto !important;\n  }\n  .w-sm-1px {\n    width: 1px !important;\n  }\n  .w-sm-2px {\n    width: 2px !important;\n  }\n  .w-sm-3px {\n    width: 3px !important;\n  }\n  .w-sm-4px {\n    width: 4px !important;\n  }\n  .w-sm-5px {\n    width: 5px !important;\n  }\n  .w-sm-6px {\n    width: 6px !important;\n  }\n  .w-sm-7px {\n    width: 7px !important;\n  }\n  .w-sm-8px {\n    width: 8px !important;\n  }\n  .w-sm-9px {\n    width: 9px !important;\n  }\n  .w-sm-10px {\n    width: 10px !important;\n  }\n  .w-sm-15px {\n    width: 15px !important;\n  }\n  .w-sm-20px {\n    width: 20px !important;\n  }\n  .w-sm-25px {\n    width: 25px !important;\n  }\n  .w-sm-30px {\n    width: 30px !important;\n  }\n  .w-sm-35px {\n    width: 35px !important;\n  }\n  .w-sm-40px {\n    width: 40px !important;\n  }\n  .w-sm-45px {\n    width: 45px !important;\n  }\n  .w-sm-50px {\n    width: 50px !important;\n  }\n  .w-sm-55px {\n    width: 55px !important;\n  }\n  .w-sm-60px {\n    width: 60px !important;\n  }\n  .w-sm-65px {\n    width: 65px !important;\n  }\n  .w-sm-70px {\n    width: 70px !important;\n  }\n  .w-sm-75px {\n    width: 75px !important;\n  }\n  .w-sm-80px {\n    width: 80px !important;\n  }\n  .w-sm-85px {\n    width: 85px !important;\n  }\n  .w-sm-90px {\n    width: 90px !important;\n  }\n  .w-sm-95px {\n    width: 95px !important;\n  }\n  .w-sm-100px {\n    width: 100px !important;\n  }\n  .w-sm-125px {\n    width: 125px !important;\n  }\n  .w-sm-150px {\n    width: 150px !important;\n  }\n  .w-sm-175px {\n    width: 175px !important;\n  }\n  .w-sm-200px {\n    width: 200px !important;\n  }\n  .w-sm-225px {\n    width: 225px !important;\n  }\n  .w-sm-250px {\n    width: 250px !important;\n  }\n  .w-sm-275px {\n    width: 275px !important;\n  }\n  .w-sm-300px {\n    width: 300px !important;\n  }\n  .w-sm-325px {\n    width: 325px !important;\n  }\n  .w-sm-350px {\n    width: 350px !important;\n  }\n  .w-sm-375px {\n    width: 375px !important;\n  }\n  .w-sm-400px {\n    width: 400px !important;\n  }\n  .w-sm-425px {\n    width: 425px !important;\n  }\n  .w-sm-450px {\n    width: 450px !important;\n  }\n  .w-sm-475px {\n    width: 475px !important;\n  }\n  .w-sm-500px {\n    width: 500px !important;\n  }\n  .w-sm-550px {\n    width: 550px !important;\n  }\n  .w-sm-600px {\n    width: 600px !important;\n  }\n  .w-sm-650px {\n    width: 650px !important;\n  }\n  .w-sm-700px {\n    width: 700px !important;\n  }\n  .w-sm-750px {\n    width: 750px !important;\n  }\n  .w-sm-800px {\n    width: 800px !important;\n  }\n  .w-sm-850px {\n    width: 850px !important;\n  }\n  .w-sm-900px {\n    width: 900px !important;\n  }\n  .w-sm-950px {\n    width: 950px !important;\n  }\n  .w-sm-1000px {\n    width: 1000px !important;\n  }\n  .mw-sm-unset {\n    max-width: unset !important;\n  }\n  .mw-sm-25 {\n    max-width: 25% !important;\n  }\n  .mw-sm-50 {\n    max-width: 50% !important;\n  }\n  .mw-sm-75 {\n    max-width: 75% !important;\n  }\n  .mw-sm-100 {\n    max-width: 100% !important;\n  }\n  .mw-sm-auto {\n    max-width: auto !important;\n  }\n  .mw-sm-1px {\n    max-width: 1px !important;\n  }\n  .mw-sm-2px {\n    max-width: 2px !important;\n  }\n  .mw-sm-3px {\n    max-width: 3px !important;\n  }\n  .mw-sm-4px {\n    max-width: 4px !important;\n  }\n  .mw-sm-5px {\n    max-width: 5px !important;\n  }\n  .mw-sm-6px {\n    max-width: 6px !important;\n  }\n  .mw-sm-7px {\n    max-width: 7px !important;\n  }\n  .mw-sm-8px {\n    max-width: 8px !important;\n  }\n  .mw-sm-9px {\n    max-width: 9px !important;\n  }\n  .mw-sm-10px {\n    max-width: 10px !important;\n  }\n  .mw-sm-15px {\n    max-width: 15px !important;\n  }\n  .mw-sm-20px {\n    max-width: 20px !important;\n  }\n  .mw-sm-25px {\n    max-width: 25px !important;\n  }\n  .mw-sm-30px {\n    max-width: 30px !important;\n  }\n  .mw-sm-35px {\n    max-width: 35px !important;\n  }\n  .mw-sm-40px {\n    max-width: 40px !important;\n  }\n  .mw-sm-45px {\n    max-width: 45px !important;\n  }\n  .mw-sm-50px {\n    max-width: 50px !important;\n  }\n  .mw-sm-55px {\n    max-width: 55px !important;\n  }\n  .mw-sm-60px {\n    max-width: 60px !important;\n  }\n  .mw-sm-65px {\n    max-width: 65px !important;\n  }\n  .mw-sm-70px {\n    max-width: 70px !important;\n  }\n  .mw-sm-75px {\n    max-width: 75px !important;\n  }\n  .mw-sm-80px {\n    max-width: 80px !important;\n  }\n  .mw-sm-85px {\n    max-width: 85px !important;\n  }\n  .mw-sm-90px {\n    max-width: 90px !important;\n  }\n  .mw-sm-95px {\n    max-width: 95px !important;\n  }\n  .mw-sm-100px {\n    max-width: 100px !important;\n  }\n  .mw-sm-125px {\n    max-width: 125px !important;\n  }\n  .mw-sm-150px {\n    max-width: 150px !important;\n  }\n  .mw-sm-175px {\n    max-width: 175px !important;\n  }\n  .mw-sm-200px {\n    max-width: 200px !important;\n  }\n  .mw-sm-225px {\n    max-width: 225px !important;\n  }\n  .mw-sm-250px {\n    max-width: 250px !important;\n  }\n  .mw-sm-275px {\n    max-width: 275px !important;\n  }\n  .mw-sm-300px {\n    max-width: 300px !important;\n  }\n  .mw-sm-325px {\n    max-width: 325px !important;\n  }\n  .mw-sm-350px {\n    max-width: 350px !important;\n  }\n  .mw-sm-375px {\n    max-width: 375px !important;\n  }\n  .mw-sm-400px {\n    max-width: 400px !important;\n  }\n  .mw-sm-425px {\n    max-width: 425px !important;\n  }\n  .mw-sm-450px {\n    max-width: 450px !important;\n  }\n  .mw-sm-475px {\n    max-width: 475px !important;\n  }\n  .mw-sm-500px {\n    max-width: 500px !important;\n  }\n  .mw-sm-550px {\n    max-width: 550px !important;\n  }\n  .mw-sm-600px {\n    max-width: 600px !important;\n  }\n  .mw-sm-650px {\n    max-width: 650px !important;\n  }\n  .mw-sm-700px {\n    max-width: 700px !important;\n  }\n  .mw-sm-750px {\n    max-width: 750px !important;\n  }\n  .mw-sm-800px {\n    max-width: 800px !important;\n  }\n  .mw-sm-850px {\n    max-width: 850px !important;\n  }\n  .mw-sm-900px {\n    max-width: 900px !important;\n  }\n  .mw-sm-950px {\n    max-width: 950px !important;\n  }\n  .mw-sm-1000px {\n    max-width: 1000px !important;\n  }\n  .h-sm-unset {\n    height: unset !important;\n  }\n  .h-sm-25 {\n    height: 25% !important;\n  }\n  .h-sm-50 {\n    height: 50% !important;\n  }\n  .h-sm-75 {\n    height: 75% !important;\n  }\n  .h-sm-100 {\n    height: 100% !important;\n  }\n  .h-sm-auto {\n    height: auto !important;\n  }\n  .h-sm-1px {\n    height: 1px !important;\n  }\n  .h-sm-2px {\n    height: 2px !important;\n  }\n  .h-sm-3px {\n    height: 3px !important;\n  }\n  .h-sm-4px {\n    height: 4px !important;\n  }\n  .h-sm-5px {\n    height: 5px !important;\n  }\n  .h-sm-6px {\n    height: 6px !important;\n  }\n  .h-sm-7px {\n    height: 7px !important;\n  }\n  .h-sm-8px {\n    height: 8px !important;\n  }\n  .h-sm-9px {\n    height: 9px !important;\n  }\n  .h-sm-10px {\n    height: 10px !important;\n  }\n  .h-sm-15px {\n    height: 15px !important;\n  }\n  .h-sm-20px {\n    height: 20px !important;\n  }\n  .h-sm-25px {\n    height: 25px !important;\n  }\n  .h-sm-30px {\n    height: 30px !important;\n  }\n  .h-sm-35px {\n    height: 35px !important;\n  }\n  .h-sm-40px {\n    height: 40px !important;\n  }\n  .h-sm-45px {\n    height: 45px !important;\n  }\n  .h-sm-50px {\n    height: 50px !important;\n  }\n  .h-sm-55px {\n    height: 55px !important;\n  }\n  .h-sm-60px {\n    height: 60px !important;\n  }\n  .h-sm-65px {\n    height: 65px !important;\n  }\n  .h-sm-70px {\n    height: 70px !important;\n  }\n  .h-sm-75px {\n    height: 75px !important;\n  }\n  .h-sm-80px {\n    height: 80px !important;\n  }\n  .h-sm-85px {\n    height: 85px !important;\n  }\n  .h-sm-90px {\n    height: 90px !important;\n  }\n  .h-sm-95px {\n    height: 95px !important;\n  }\n  .h-sm-100px {\n    height: 100px !important;\n  }\n  .h-sm-125px {\n    height: 125px !important;\n  }\n  .h-sm-150px {\n    height: 150px !important;\n  }\n  .h-sm-175px {\n    height: 175px !important;\n  }\n  .h-sm-200px {\n    height: 200px !important;\n  }\n  .h-sm-225px {\n    height: 225px !important;\n  }\n  .h-sm-250px {\n    height: 250px !important;\n  }\n  .h-sm-275px {\n    height: 275px !important;\n  }\n  .h-sm-300px {\n    height: 300px !important;\n  }\n  .h-sm-325px {\n    height: 325px !important;\n  }\n  .h-sm-350px {\n    height: 350px !important;\n  }\n  .h-sm-375px {\n    height: 375px !important;\n  }\n  .h-sm-400px {\n    height: 400px !important;\n  }\n  .h-sm-425px {\n    height: 425px !important;\n  }\n  .h-sm-450px {\n    height: 450px !important;\n  }\n  .h-sm-475px {\n    height: 475px !important;\n  }\n  .h-sm-500px {\n    height: 500px !important;\n  }\n  .h-sm-550px {\n    height: 550px !important;\n  }\n  .h-sm-600px {\n    height: 600px !important;\n  }\n  .h-sm-650px {\n    height: 650px !important;\n  }\n  .h-sm-700px {\n    height: 700px !important;\n  }\n  .h-sm-750px {\n    height: 750px !important;\n  }\n  .h-sm-800px {\n    height: 800px !important;\n  }\n  .h-sm-850px {\n    height: 850px !important;\n  }\n  .h-sm-900px {\n    height: 900px !important;\n  }\n  .h-sm-950px {\n    height: 950px !important;\n  }\n  .h-sm-1000px {\n    height: 1000px !important;\n  }\n  .mh-sm-unset {\n    max-height: unset !important;\n  }\n  .mh-sm-25 {\n    max-height: 25% !important;\n  }\n  .mh-sm-50 {\n    max-height: 50% !important;\n  }\n  .mh-sm-75 {\n    max-height: 75% !important;\n  }\n  .mh-sm-100 {\n    max-height: 100% !important;\n  }\n  .mh-sm-auto {\n    max-height: auto !important;\n  }\n  .mh-sm-1px {\n    max-height: 1px !important;\n  }\n  .mh-sm-2px {\n    max-height: 2px !important;\n  }\n  .mh-sm-3px {\n    max-height: 3px !important;\n  }\n  .mh-sm-4px {\n    max-height: 4px !important;\n  }\n  .mh-sm-5px {\n    max-height: 5px !important;\n  }\n  .mh-sm-6px {\n    max-height: 6px !important;\n  }\n  .mh-sm-7px {\n    max-height: 7px !important;\n  }\n  .mh-sm-8px {\n    max-height: 8px !important;\n  }\n  .mh-sm-9px {\n    max-height: 9px !important;\n  }\n  .mh-sm-10px {\n    max-height: 10px !important;\n  }\n  .mh-sm-15px {\n    max-height: 15px !important;\n  }\n  .mh-sm-20px {\n    max-height: 20px !important;\n  }\n  .mh-sm-25px {\n    max-height: 25px !important;\n  }\n  .mh-sm-30px {\n    max-height: 30px !important;\n  }\n  .mh-sm-35px {\n    max-height: 35px !important;\n  }\n  .mh-sm-40px {\n    max-height: 40px !important;\n  }\n  .mh-sm-45px {\n    max-height: 45px !important;\n  }\n  .mh-sm-50px {\n    max-height: 50px !important;\n  }\n  .mh-sm-55px {\n    max-height: 55px !important;\n  }\n  .mh-sm-60px {\n    max-height: 60px !important;\n  }\n  .mh-sm-65px {\n    max-height: 65px !important;\n  }\n  .mh-sm-70px {\n    max-height: 70px !important;\n  }\n  .mh-sm-75px {\n    max-height: 75px !important;\n  }\n  .mh-sm-80px {\n    max-height: 80px !important;\n  }\n  .mh-sm-85px {\n    max-height: 85px !important;\n  }\n  .mh-sm-90px {\n    max-height: 90px !important;\n  }\n  .mh-sm-95px {\n    max-height: 95px !important;\n  }\n  .mh-sm-100px {\n    max-height: 100px !important;\n  }\n  .mh-sm-125px {\n    max-height: 125px !important;\n  }\n  .mh-sm-150px {\n    max-height: 150px !important;\n  }\n  .mh-sm-175px {\n    max-height: 175px !important;\n  }\n  .mh-sm-200px {\n    max-height: 200px !important;\n  }\n  .mh-sm-225px {\n    max-height: 225px !important;\n  }\n  .mh-sm-250px {\n    max-height: 250px !important;\n  }\n  .mh-sm-275px {\n    max-height: 275px !important;\n  }\n  .mh-sm-300px {\n    max-height: 300px !important;\n  }\n  .mh-sm-325px {\n    max-height: 325px !important;\n  }\n  .mh-sm-350px {\n    max-height: 350px !important;\n  }\n  .mh-sm-375px {\n    max-height: 375px !important;\n  }\n  .mh-sm-400px {\n    max-height: 400px !important;\n  }\n  .mh-sm-425px {\n    max-height: 425px !important;\n  }\n  .mh-sm-450px {\n    max-height: 450px !important;\n  }\n  .mh-sm-475px {\n    max-height: 475px !important;\n  }\n  .mh-sm-500px {\n    max-height: 500px !important;\n  }\n  .mh-sm-550px {\n    max-height: 550px !important;\n  }\n  .mh-sm-600px {\n    max-height: 600px !important;\n  }\n  .mh-sm-650px {\n    max-height: 650px !important;\n  }\n  .mh-sm-700px {\n    max-height: 700px !important;\n  }\n  .mh-sm-750px {\n    max-height: 750px !important;\n  }\n  .mh-sm-800px {\n    max-height: 800px !important;\n  }\n  .mh-sm-850px {\n    max-height: 850px !important;\n  }\n  .mh-sm-900px {\n    max-height: 900px !important;\n  }\n  .mh-sm-950px {\n    max-height: 950px !important;\n  }\n  .mh-sm-1000px {\n    max-height: 1000px !important;\n  }\n  .flex-sm-fill {\n    flex: 1 1 auto !important;\n  }\n  .flex-sm-row {\n    flex-direction: row !important;\n  }\n  .flex-sm-column {\n    flex-direction: column !important;\n  }\n  .flex-sm-row-reverse {\n    flex-direction: row-reverse !important;\n  }\n  .flex-sm-column-reverse {\n    flex-direction: column-reverse !important;\n  }\n  .flex-sm-grow-0 {\n    flex-grow: 0 !important;\n  }\n  .flex-sm-grow-1 {\n    flex-grow: 1 !important;\n  }\n  .flex-sm-shrink-0 {\n    flex-shrink: 0 !important;\n  }\n  .flex-sm-shrink-1 {\n    flex-shrink: 1 !important;\n  }\n  .flex-sm-wrap {\n    flex-wrap: wrap !important;\n  }\n  .flex-sm-nowrap {\n    flex-wrap: nowrap !important;\n  }\n  .flex-sm-wrap-reverse {\n    flex-wrap: wrap-reverse !important;\n  }\n  .justify-content-sm-start {\n    justify-content: flex-start !important;\n  }\n  .justify-content-sm-end {\n    justify-content: flex-end !important;\n  }\n  .justify-content-sm-center {\n    justify-content: center !important;\n  }\n  .justify-content-sm-between {\n    justify-content: space-between !important;\n  }\n  .justify-content-sm-around {\n    justify-content: space-around !important;\n  }\n  .justify-content-sm-evenly {\n    justify-content: space-evenly !important;\n  }\n  .align-items-sm-start {\n    align-items: flex-start !important;\n  }\n  .align-items-sm-end {\n    align-items: flex-end !important;\n  }\n  .align-items-sm-center {\n    align-items: center !important;\n  }\n  .align-items-sm-baseline {\n    align-items: baseline !important;\n  }\n  .align-items-sm-stretch {\n    align-items: stretch !important;\n  }\n  .align-content-sm-start {\n    align-content: flex-start !important;\n  }\n  .align-content-sm-end {\n    align-content: flex-end !important;\n  }\n  .align-content-sm-center {\n    align-content: center !important;\n  }\n  .align-content-sm-between {\n    align-content: space-between !important;\n  }\n  .align-content-sm-around {\n    align-content: space-around !important;\n  }\n  .align-content-sm-stretch {\n    align-content: stretch !important;\n  }\n  .align-self-sm-auto {\n    align-self: auto !important;\n  }\n  .align-self-sm-start {\n    align-self: flex-start !important;\n  }\n  .align-self-sm-end {\n    align-self: flex-end !important;\n  }\n  .align-self-sm-center {\n    align-self: center !important;\n  }\n  .align-self-sm-baseline {\n    align-self: baseline !important;\n  }\n  .align-self-sm-stretch {\n    align-self: stretch !important;\n  }\n  .order-sm-first {\n    order: -1 !important;\n  }\n  .order-sm-0 {\n    order: 0 !important;\n  }\n  .order-sm-1 {\n    order: 1 !important;\n  }\n  .order-sm-2 {\n    order: 2 !important;\n  }\n  .order-sm-3 {\n    order: 3 !important;\n  }\n  .order-sm-4 {\n    order: 4 !important;\n  }\n  .order-sm-5 {\n    order: 5 !important;\n  }\n  .order-sm-last {\n    order: 6 !important;\n  }\n  .m-sm-0 {\n    margin: 0 !important;\n  }\n  .m-sm-1 {\n    margin: 0.25rem !important;\n  }\n  .m-sm-2 {\n    margin: 0.5rem !important;\n  }\n  .m-sm-3 {\n    margin: 0.75rem !important;\n  }\n  .m-sm-4 {\n    margin: 1rem !important;\n  }\n  .m-sm-5 {\n    margin: 1.25rem !important;\n  }\n  .m-sm-6 {\n    margin: 1.5rem !important;\n  }\n  .m-sm-7 {\n    margin: 1.75rem !important;\n  }\n  .m-sm-8 {\n    margin: 2rem !important;\n  }\n  .m-sm-9 {\n    margin: 2.25rem !important;\n  }\n  .m-sm-10 {\n    margin: 2.5rem !important;\n  }\n  .m-sm-11 {\n    margin: 2.75rem !important;\n  }\n  .m-sm-12 {\n    margin: 3rem !important;\n  }\n  .m-sm-13 {\n    margin: 3.25rem !important;\n  }\n  .m-sm-14 {\n    margin: 3.5rem !important;\n  }\n  .m-sm-15 {\n    margin: 3.75rem !important;\n  }\n  .m-sm-16 {\n    margin: 4rem !important;\n  }\n  .m-sm-17 {\n    margin: 4.25rem !important;\n  }\n  .m-sm-18 {\n    margin: 4.5rem !important;\n  }\n  .m-sm-19 {\n    margin: 4.75rem !important;\n  }\n  .m-sm-20 {\n    margin: 5rem !important;\n  }\n  .m-sm-auto {\n    margin: auto !important;\n  }\n  .mx-sm-0 {\n    margin-right: 0 !important;\n    margin-left: 0 !important;\n  }\n  .mx-sm-1 {\n    margin-right: 0.25rem !important;\n    margin-left: 0.25rem !important;\n  }\n  .mx-sm-2 {\n    margin-right: 0.5rem !important;\n    margin-left: 0.5rem !important;\n  }\n  .mx-sm-3 {\n    margin-right: 0.75rem !important;\n    margin-left: 0.75rem !important;\n  }\n  .mx-sm-4 {\n    margin-right: 1rem !important;\n    margin-left: 1rem !important;\n  }\n  .mx-sm-5 {\n    margin-right: 1.25rem !important;\n    margin-left: 1.25rem !important;\n  }\n  .mx-sm-6 {\n    margin-right: 1.5rem !important;\n    margin-left: 1.5rem !important;\n  }\n  .mx-sm-7 {\n    margin-right: 1.75rem !important;\n    margin-left: 1.75rem !important;\n  }\n  .mx-sm-8 {\n    margin-right: 2rem !important;\n    margin-left: 2rem !important;\n  }\n  .mx-sm-9 {\n    margin-right: 2.25rem !important;\n    margin-left: 2.25rem !important;\n  }\n  .mx-sm-10 {\n    margin-right: 2.5rem !important;\n    margin-left: 2.5rem !important;\n  }\n  .mx-sm-11 {\n    margin-right: 2.75rem !important;\n    margin-left: 2.75rem !important;\n  }\n  .mx-sm-12 {\n    margin-right: 3rem !important;\n    margin-left: 3rem !important;\n  }\n  .mx-sm-13 {\n    margin-right: 3.25rem !important;\n    margin-left: 3.25rem !important;\n  }\n  .mx-sm-14 {\n    margin-right: 3.5rem !important;\n    margin-left: 3.5rem !important;\n  }\n  .mx-sm-15 {\n    margin-right: 3.75rem !important;\n    margin-left: 3.75rem !important;\n  }\n  .mx-sm-16 {\n    margin-right: 4rem !important;\n    margin-left: 4rem !important;\n  }\n  .mx-sm-17 {\n    margin-right: 4.25rem !important;\n    margin-left: 4.25rem !important;\n  }\n  .mx-sm-18 {\n    margin-right: 4.5rem !important;\n    margin-left: 4.5rem !important;\n  }\n  .mx-sm-19 {\n    margin-right: 4.75rem !important;\n    margin-left: 4.75rem !important;\n  }\n  .mx-sm-20 {\n    margin-right: 5rem !important;\n    margin-left: 5rem !important;\n  }\n  .mx-sm-auto {\n    margin-right: auto !important;\n    margin-left: auto !important;\n  }\n  .my-sm-0 {\n    margin-top: 0 !important;\n    margin-bottom: 0 !important;\n  }\n  .my-sm-1 {\n    margin-top: 0.25rem !important;\n    margin-bottom: 0.25rem !important;\n  }\n  .my-sm-2 {\n    margin-top: 0.5rem !important;\n    margin-bottom: 0.5rem !important;\n  }\n  .my-sm-3 {\n    margin-top: 0.75rem !important;\n    margin-bottom: 0.75rem !important;\n  }\n  .my-sm-4 {\n    margin-top: 1rem !important;\n    margin-bottom: 1rem !important;\n  }\n  .my-sm-5 {\n    margin-top: 1.25rem !important;\n    margin-bottom: 1.25rem !important;\n  }\n  .my-sm-6 {\n    margin-top: 1.5rem !important;\n    margin-bottom: 1.5rem !important;\n  }\n  .my-sm-7 {\n    margin-top: 1.75rem !important;\n    margin-bottom: 1.75rem !important;\n  }\n  .my-sm-8 {\n    margin-top: 2rem !important;\n    margin-bottom: 2rem !important;\n  }\n  .my-sm-9 {\n    margin-top: 2.25rem !important;\n    margin-bottom: 2.25rem !important;\n  }\n  .my-sm-10 {\n    margin-top: 2.5rem !important;\n    margin-bottom: 2.5rem !important;\n  }\n  .my-sm-11 {\n    margin-top: 2.75rem !important;\n    margin-bottom: 2.75rem !important;\n  }\n  .my-sm-12 {\n    margin-top: 3rem !important;\n    margin-bottom: 3rem !important;\n  }\n  .my-sm-13 {\n    margin-top: 3.25rem !important;\n    margin-bottom: 3.25rem !important;\n  }\n  .my-sm-14 {\n    margin-top: 3.5rem !important;\n    margin-bottom: 3.5rem !important;\n  }\n  .my-sm-15 {\n    margin-top: 3.75rem !important;\n    margin-bottom: 3.75rem !important;\n  }\n  .my-sm-16 {\n    margin-top: 4rem !important;\n    margin-bottom: 4rem !important;\n  }\n  .my-sm-17 {\n    margin-top: 4.25rem !important;\n    margin-bottom: 4.25rem !important;\n  }\n  .my-sm-18 {\n    margin-top: 4.5rem !important;\n    margin-bottom: 4.5rem !important;\n  }\n  .my-sm-19 {\n    margin-top: 4.75rem !important;\n    margin-bottom: 4.75rem !important;\n  }\n  .my-sm-20 {\n    margin-top: 5rem !important;\n    margin-bottom: 5rem !important;\n  }\n  .my-sm-auto {\n    margin-top: auto !important;\n    margin-bottom: auto !important;\n  }\n  .mt-sm-0 {\n    margin-top: 0 !important;\n  }\n  .mt-sm-1 {\n    margin-top: 0.25rem !important;\n  }\n  .mt-sm-2 {\n    margin-top: 0.5rem !important;\n  }\n  .mt-sm-3 {\n    margin-top: 0.75rem !important;\n  }\n  .mt-sm-4 {\n    margin-top: 1rem !important;\n  }\n  .mt-sm-5 {\n    margin-top: 1.25rem !important;\n  }\n  .mt-sm-6 {\n    margin-top: 1.5rem !important;\n  }\n  .mt-sm-7 {\n    margin-top: 1.75rem !important;\n  }\n  .mt-sm-8 {\n    margin-top: 2rem !important;\n  }\n  .mt-sm-9 {\n    margin-top: 2.25rem !important;\n  }\n  .mt-sm-10 {\n    margin-top: 2.5rem !important;\n  }\n  .mt-sm-11 {\n    margin-top: 2.75rem !important;\n  }\n  .mt-sm-12 {\n    margin-top: 3rem !important;\n  }\n  .mt-sm-13 {\n    margin-top: 3.25rem !important;\n  }\n  .mt-sm-14 {\n    margin-top: 3.5rem !important;\n  }\n  .mt-sm-15 {\n    margin-top: 3.75rem !important;\n  }\n  .mt-sm-16 {\n    margin-top: 4rem !important;\n  }\n  .mt-sm-17 {\n    margin-top: 4.25rem !important;\n  }\n  .mt-sm-18 {\n    margin-top: 4.5rem !important;\n  }\n  .mt-sm-19 {\n    margin-top: 4.75rem !important;\n  }\n  .mt-sm-20 {\n    margin-top: 5rem !important;\n  }\n  .mt-sm-auto {\n    margin-top: auto !important;\n  }\n  .me-sm-0 {\n    margin-right: 0 !important;\n  }\n  .me-sm-1 {\n    margin-right: 0.25rem !important;\n  }\n  .me-sm-2 {\n    margin-right: 0.5rem !important;\n  }\n  .me-sm-3 {\n    margin-right: 0.75rem !important;\n  }\n  .me-sm-4 {\n    margin-right: 1rem !important;\n  }\n  .me-sm-5 {\n    margin-right: 1.25rem !important;\n  }\n  .me-sm-6 {\n    margin-right: 1.5rem !important;\n  }\n  .me-sm-7 {\n    margin-right: 1.75rem !important;\n  }\n  .me-sm-8 {\n    margin-right: 2rem !important;\n  }\n  .me-sm-9 {\n    margin-right: 2.25rem !important;\n  }\n  .me-sm-10 {\n    margin-right: 2.5rem !important;\n  }\n  .me-sm-11 {\n    margin-right: 2.75rem !important;\n  }\n  .me-sm-12 {\n    margin-right: 3rem !important;\n  }\n  .me-sm-13 {\n    margin-right: 3.25rem !important;\n  }\n  .me-sm-14 {\n    margin-right: 3.5rem !important;\n  }\n  .me-sm-15 {\n    margin-right: 3.75rem !important;\n  }\n  .me-sm-16 {\n    margin-right: 4rem !important;\n  }\n  .me-sm-17 {\n    margin-right: 4.25rem !important;\n  }\n  .me-sm-18 {\n    margin-right: 4.5rem !important;\n  }\n  .me-sm-19 {\n    margin-right: 4.75rem !important;\n  }\n  .me-sm-20 {\n    margin-right: 5rem !important;\n  }\n  .me-sm-auto {\n    margin-right: auto !important;\n  }\n  .mb-sm-0 {\n    margin-bottom: 0 !important;\n  }\n  .mb-sm-1 {\n    margin-bottom: 0.25rem !important;\n  }\n  .mb-sm-2 {\n    margin-bottom: 0.5rem !important;\n  }\n  .mb-sm-3 {\n    margin-bottom: 0.75rem !important;\n  }\n  .mb-sm-4 {\n    margin-bottom: 1rem !important;\n  }\n  .mb-sm-5 {\n    margin-bottom: 1.25rem !important;\n  }\n  .mb-sm-6 {\n    margin-bottom: 1.5rem !important;\n  }\n  .mb-sm-7 {\n    margin-bottom: 1.75rem !important;\n  }\n  .mb-sm-8 {\n    margin-bottom: 2rem !important;\n  }\n  .mb-sm-9 {\n    margin-bottom: 2.25rem !important;\n  }\n  .mb-sm-10 {\n    margin-bottom: 2.5rem !important;\n  }\n  .mb-sm-11 {\n    margin-bottom: 2.75rem !important;\n  }\n  .mb-sm-12 {\n    margin-bottom: 3rem !important;\n  }\n  .mb-sm-13 {\n    margin-bottom: 3.25rem !important;\n  }\n  .mb-sm-14 {\n    margin-bottom: 3.5rem !important;\n  }\n  .mb-sm-15 {\n    margin-bottom: 3.75rem !important;\n  }\n  .mb-sm-16 {\n    margin-bottom: 4rem !important;\n  }\n  .mb-sm-17 {\n    margin-bottom: 4.25rem !important;\n  }\n  .mb-sm-18 {\n    margin-bottom: 4.5rem !important;\n  }\n  .mb-sm-19 {\n    margin-bottom: 4.75rem !important;\n  }\n  .mb-sm-20 {\n    margin-bottom: 5rem !important;\n  }\n  .mb-sm-auto {\n    margin-bottom: auto !important;\n  }\n  .ms-sm-0 {\n    margin-left: 0 !important;\n  }\n  .ms-sm-1 {\n    margin-left: 0.25rem !important;\n  }\n  .ms-sm-2 {\n    margin-left: 0.5rem !important;\n  }\n  .ms-sm-3 {\n    margin-left: 0.75rem !important;\n  }\n  .ms-sm-4 {\n    margin-left: 1rem !important;\n  }\n  .ms-sm-5 {\n    margin-left: 1.25rem !important;\n  }\n  .ms-sm-6 {\n    margin-left: 1.5rem !important;\n  }\n  .ms-sm-7 {\n    margin-left: 1.75rem !important;\n  }\n  .ms-sm-8 {\n    margin-left: 2rem !important;\n  }\n  .ms-sm-9 {\n    margin-left: 2.25rem !important;\n  }\n  .ms-sm-10 {\n    margin-left: 2.5rem !important;\n  }\n  .ms-sm-11 {\n    margin-left: 2.75rem !important;\n  }\n  .ms-sm-12 {\n    margin-left: 3rem !important;\n  }\n  .ms-sm-13 {\n    margin-left: 3.25rem !important;\n  }\n  .ms-sm-14 {\n    margin-left: 3.5rem !important;\n  }\n  .ms-sm-15 {\n    margin-left: 3.75rem !important;\n  }\n  .ms-sm-16 {\n    margin-left: 4rem !important;\n  }\n  .ms-sm-17 {\n    margin-left: 4.25rem !important;\n  }\n  .ms-sm-18 {\n    margin-left: 4.5rem !important;\n  }\n  .ms-sm-19 {\n    margin-left: 4.75rem !important;\n  }\n  .ms-sm-20 {\n    margin-left: 5rem !important;\n  }\n  .ms-sm-auto {\n    margin-left: auto !important;\n  }\n  .m-sm-n1 {\n    margin: -0.25rem !important;\n  }\n  .m-sm-n2 {\n    margin: -0.5rem !important;\n  }\n  .m-sm-n3 {\n    margin: -0.75rem !important;\n  }\n  .m-sm-n4 {\n    margin: -1rem !important;\n  }\n  .m-sm-n5 {\n    margin: -1.25rem !important;\n  }\n  .m-sm-n6 {\n    margin: -1.5rem !important;\n  }\n  .m-sm-n7 {\n    margin: -1.75rem !important;\n  }\n  .m-sm-n8 {\n    margin: -2rem !important;\n  }\n  .m-sm-n9 {\n    margin: -2.25rem !important;\n  }\n  .m-sm-n10 {\n    margin: -2.5rem !important;\n  }\n  .m-sm-n11 {\n    margin: -2.75rem !important;\n  }\n  .m-sm-n12 {\n    margin: -3rem !important;\n  }\n  .m-sm-n13 {\n    margin: -3.25rem !important;\n  }\n  .m-sm-n14 {\n    margin: -3.5rem !important;\n  }\n  .m-sm-n15 {\n    margin: -3.75rem !important;\n  }\n  .m-sm-n16 {\n    margin: -4rem !important;\n  }\n  .m-sm-n17 {\n    margin: -4.25rem !important;\n  }\n  .m-sm-n18 {\n    margin: -4.5rem !important;\n  }\n  .m-sm-n19 {\n    margin: -4.75rem !important;\n  }\n  .m-sm-n20 {\n    margin: -5rem !important;\n  }\n  .mx-sm-n1 {\n    margin-right: -0.25rem !important;\n    margin-left: -0.25rem !important;\n  }\n  .mx-sm-n2 {\n    margin-right: -0.5rem !important;\n    margin-left: -0.5rem !important;\n  }\n  .mx-sm-n3 {\n    margin-right: -0.75rem !important;\n    margin-left: -0.75rem !important;\n  }\n  .mx-sm-n4 {\n    margin-right: -1rem !important;\n    margin-left: -1rem !important;\n  }\n  .mx-sm-n5 {\n    margin-right: -1.25rem !important;\n    margin-left: -1.25rem !important;\n  }\n  .mx-sm-n6 {\n    margin-right: -1.5rem !important;\n    margin-left: -1.5rem !important;\n  }\n  .mx-sm-n7 {\n    margin-right: -1.75rem !important;\n    margin-left: -1.75rem !important;\n  }\n  .mx-sm-n8 {\n    margin-right: -2rem !important;\n    margin-left: -2rem !important;\n  }\n  .mx-sm-n9 {\n    margin-right: -2.25rem !important;\n    margin-left: -2.25rem !important;\n  }\n  .mx-sm-n10 {\n    margin-right: -2.5rem !important;\n    margin-left: -2.5rem !important;\n  }\n  .mx-sm-n11 {\n    margin-right: -2.75rem !important;\n    margin-left: -2.75rem !important;\n  }\n  .mx-sm-n12 {\n    margin-right: -3rem !important;\n    margin-left: -3rem !important;\n  }\n  .mx-sm-n13 {\n    margin-right: -3.25rem !important;\n    margin-left: -3.25rem !important;\n  }\n  .mx-sm-n14 {\n    margin-right: -3.5rem !important;\n    margin-left: -3.5rem !important;\n  }\n  .mx-sm-n15 {\n    margin-right: -3.75rem !important;\n    margin-left: -3.75rem !important;\n  }\n  .mx-sm-n16 {\n    margin-right: -4rem !important;\n    margin-left: -4rem !important;\n  }\n  .mx-sm-n17 {\n    margin-right: -4.25rem !important;\n    margin-left: -4.25rem !important;\n  }\n  .mx-sm-n18 {\n    margin-right: -4.5rem !important;\n    margin-left: -4.5rem !important;\n  }\n  .mx-sm-n19 {\n    margin-right: -4.75rem !important;\n    margin-left: -4.75rem !important;\n  }\n  .mx-sm-n20 {\n    margin-right: -5rem !important;\n    margin-left: -5rem !important;\n  }\n  .my-sm-n1 {\n    margin-top: -0.25rem !important;\n    margin-bottom: -0.25rem !important;\n  }\n  .my-sm-n2 {\n    margin-top: -0.5rem !important;\n    margin-bottom: -0.5rem !important;\n  }\n  .my-sm-n3 {\n    margin-top: -0.75rem !important;\n    margin-bottom: -0.75rem !important;\n  }\n  .my-sm-n4 {\n    margin-top: -1rem !important;\n    margin-bottom: -1rem !important;\n  }\n  .my-sm-n5 {\n    margin-top: -1.25rem !important;\n    margin-bottom: -1.25rem !important;\n  }\n  .my-sm-n6 {\n    margin-top: -1.5rem !important;\n    margin-bottom: -1.5rem !important;\n  }\n  .my-sm-n7 {\n    margin-top: -1.75rem !important;\n    margin-bottom: -1.75rem !important;\n  }\n  .my-sm-n8 {\n    margin-top: -2rem !important;\n    margin-bottom: -2rem !important;\n  }\n  .my-sm-n9 {\n    margin-top: -2.25rem !important;\n    margin-bottom: -2.25rem !important;\n  }\n  .my-sm-n10 {\n    margin-top: -2.5rem !important;\n    margin-bottom: -2.5rem !important;\n  }\n  .my-sm-n11 {\n    margin-top: -2.75rem !important;\n    margin-bottom: -2.75rem !important;\n  }\n  .my-sm-n12 {\n    margin-top: -3rem !important;\n    margin-bottom: -3rem !important;\n  }\n  .my-sm-n13 {\n    margin-top: -3.25rem !important;\n    margin-bottom: -3.25rem !important;\n  }\n  .my-sm-n14 {\n    margin-top: -3.5rem !important;\n    margin-bottom: -3.5rem !important;\n  }\n  .my-sm-n15 {\n    margin-top: -3.75rem !important;\n    margin-bottom: -3.75rem !important;\n  }\n  .my-sm-n16 {\n    margin-top: -4rem !important;\n    margin-bottom: -4rem !important;\n  }\n  .my-sm-n17 {\n    margin-top: -4.25rem !important;\n    margin-bottom: -4.25rem !important;\n  }\n  .my-sm-n18 {\n    margin-top: -4.5rem !important;\n    margin-bottom: -4.5rem !important;\n  }\n  .my-sm-n19 {\n    margin-top: -4.75rem !important;\n    margin-bottom: -4.75rem !important;\n  }\n  .my-sm-n20 {\n    margin-top: -5rem !important;\n    margin-bottom: -5rem !important;\n  }\n  .mt-sm-n1 {\n    margin-top: -0.25rem !important;\n  }\n  .mt-sm-n2 {\n    margin-top: -0.5rem !important;\n  }\n  .mt-sm-n3 {\n    margin-top: -0.75rem !important;\n  }\n  .mt-sm-n4 {\n    margin-top: -1rem !important;\n  }\n  .mt-sm-n5 {\n    margin-top: -1.25rem !important;\n  }\n  .mt-sm-n6 {\n    margin-top: -1.5rem !important;\n  }\n  .mt-sm-n7 {\n    margin-top: -1.75rem !important;\n  }\n  .mt-sm-n8 {\n    margin-top: -2rem !important;\n  }\n  .mt-sm-n9 {\n    margin-top: -2.25rem !important;\n  }\n  .mt-sm-n10 {\n    margin-top: -2.5rem !important;\n  }\n  .mt-sm-n11 {\n    margin-top: -2.75rem !important;\n  }\n  .mt-sm-n12 {\n    margin-top: -3rem !important;\n  }\n  .mt-sm-n13 {\n    margin-top: -3.25rem !important;\n  }\n  .mt-sm-n14 {\n    margin-top: -3.5rem !important;\n  }\n  .mt-sm-n15 {\n    margin-top: -3.75rem !important;\n  }\n  .mt-sm-n16 {\n    margin-top: -4rem !important;\n  }\n  .mt-sm-n17 {\n    margin-top: -4.25rem !important;\n  }\n  .mt-sm-n18 {\n    margin-top: -4.5rem !important;\n  }\n  .mt-sm-n19 {\n    margin-top: -4.75rem !important;\n  }\n  .mt-sm-n20 {\n    margin-top: -5rem !important;\n  }\n  .me-sm-n1 {\n    margin-right: -0.25rem !important;\n  }\n  .me-sm-n2 {\n    margin-right: -0.5rem !important;\n  }\n  .me-sm-n3 {\n    margin-right: -0.75rem !important;\n  }\n  .me-sm-n4 {\n    margin-right: -1rem !important;\n  }\n  .me-sm-n5 {\n    margin-right: -1.25rem !important;\n  }\n  .me-sm-n6 {\n    margin-right: -1.5rem !important;\n  }\n  .me-sm-n7 {\n    margin-right: -1.75rem !important;\n  }\n  .me-sm-n8 {\n    margin-right: -2rem !important;\n  }\n  .me-sm-n9 {\n    margin-right: -2.25rem !important;\n  }\n  .me-sm-n10 {\n    margin-right: -2.5rem !important;\n  }\n  .me-sm-n11 {\n    margin-right: -2.75rem !important;\n  }\n  .me-sm-n12 {\n    margin-right: -3rem !important;\n  }\n  .me-sm-n13 {\n    margin-right: -3.25rem !important;\n  }\n  .me-sm-n14 {\n    margin-right: -3.5rem !important;\n  }\n  .me-sm-n15 {\n    margin-right: -3.75rem !important;\n  }\n  .me-sm-n16 {\n    margin-right: -4rem !important;\n  }\n  .me-sm-n17 {\n    margin-right: -4.25rem !important;\n  }\n  .me-sm-n18 {\n    margin-right: -4.5rem !important;\n  }\n  .me-sm-n19 {\n    margin-right: -4.75rem !important;\n  }\n  .me-sm-n20 {\n    margin-right: -5rem !important;\n  }\n  .mb-sm-n1 {\n    margin-bottom: -0.25rem !important;\n  }\n  .mb-sm-n2 {\n    margin-bottom: -0.5rem !important;\n  }\n  .mb-sm-n3 {\n    margin-bottom: -0.75rem !important;\n  }\n  .mb-sm-n4 {\n    margin-bottom: -1rem !important;\n  }\n  .mb-sm-n5 {\n    margin-bottom: -1.25rem !important;\n  }\n  .mb-sm-n6 {\n    margin-bottom: -1.5rem !important;\n  }\n  .mb-sm-n7 {\n    margin-bottom: -1.75rem !important;\n  }\n  .mb-sm-n8 {\n    margin-bottom: -2rem !important;\n  }\n  .mb-sm-n9 {\n    margin-bottom: -2.25rem !important;\n  }\n  .mb-sm-n10 {\n    margin-bottom: -2.5rem !important;\n  }\n  .mb-sm-n11 {\n    margin-bottom: -2.75rem !important;\n  }\n  .mb-sm-n12 {\n    margin-bottom: -3rem !important;\n  }\n  .mb-sm-n13 {\n    margin-bottom: -3.25rem !important;\n  }\n  .mb-sm-n14 {\n    margin-bottom: -3.5rem !important;\n  }\n  .mb-sm-n15 {\n    margin-bottom: -3.75rem !important;\n  }\n  .mb-sm-n16 {\n    margin-bottom: -4rem !important;\n  }\n  .mb-sm-n17 {\n    margin-bottom: -4.25rem !important;\n  }\n  .mb-sm-n18 {\n    margin-bottom: -4.5rem !important;\n  }\n  .mb-sm-n19 {\n    margin-bottom: -4.75rem !important;\n  }\n  .mb-sm-n20 {\n    margin-bottom: -5rem !important;\n  }\n  .ms-sm-n1 {\n    margin-left: -0.25rem !important;\n  }\n  .ms-sm-n2 {\n    margin-left: -0.5rem !important;\n  }\n  .ms-sm-n3 {\n    margin-left: -0.75rem !important;\n  }\n  .ms-sm-n4 {\n    margin-left: -1rem !important;\n  }\n  .ms-sm-n5 {\n    margin-left: -1.25rem !important;\n  }\n  .ms-sm-n6 {\n    margin-left: -1.5rem !important;\n  }\n  .ms-sm-n7 {\n    margin-left: -1.75rem !important;\n  }\n  .ms-sm-n8 {\n    margin-left: -2rem !important;\n  }\n  .ms-sm-n9 {\n    margin-left: -2.25rem !important;\n  }\n  .ms-sm-n10 {\n    margin-left: -2.5rem !important;\n  }\n  .ms-sm-n11 {\n    margin-left: -2.75rem !important;\n  }\n  .ms-sm-n12 {\n    margin-left: -3rem !important;\n  }\n  .ms-sm-n13 {\n    margin-left: -3.25rem !important;\n  }\n  .ms-sm-n14 {\n    margin-left: -3.5rem !important;\n  }\n  .ms-sm-n15 {\n    margin-left: -3.75rem !important;\n  }\n  .ms-sm-n16 {\n    margin-left: -4rem !important;\n  }\n  .ms-sm-n17 {\n    margin-left: -4.25rem !important;\n  }\n  .ms-sm-n18 {\n    margin-left: -4.5rem !important;\n  }\n  .ms-sm-n19 {\n    margin-left: -4.75rem !important;\n  }\n  .ms-sm-n20 {\n    margin-left: -5rem !important;\n  }\n  .p-sm-0 {\n    padding: 0 !important;\n  }\n  .p-sm-1 {\n    padding: 0.25rem !important;\n  }\n  .p-sm-2 {\n    padding: 0.5rem !important;\n  }\n  .p-sm-3 {\n    padding: 0.75rem !important;\n  }\n  .p-sm-4 {\n    padding: 1rem !important;\n  }\n  .p-sm-5 {\n    padding: 1.25rem !important;\n  }\n  .p-sm-6 {\n    padding: 1.5rem !important;\n  }\n  .p-sm-7 {\n    padding: 1.75rem !important;\n  }\n  .p-sm-8 {\n    padding: 2rem !important;\n  }\n  .p-sm-9 {\n    padding: 2.25rem !important;\n  }\n  .p-sm-10 {\n    padding: 2.5rem !important;\n  }\n  .p-sm-11 {\n    padding: 2.75rem !important;\n  }\n  .p-sm-12 {\n    padding: 3rem !important;\n  }\n  .p-sm-13 {\n    padding: 3.25rem !important;\n  }\n  .p-sm-14 {\n    padding: 3.5rem !important;\n  }\n  .p-sm-15 {\n    padding: 3.75rem !important;\n  }\n  .p-sm-16 {\n    padding: 4rem !important;\n  }\n  .p-sm-17 {\n    padding: 4.25rem !important;\n  }\n  .p-sm-18 {\n    padding: 4.5rem !important;\n  }\n  .p-sm-19 {\n    padding: 4.75rem !important;\n  }\n  .p-sm-20 {\n    padding: 5rem !important;\n  }\n  .px-sm-0 {\n    padding-right: 0 !important;\n    padding-left: 0 !important;\n  }\n  .px-sm-1 {\n    padding-right: 0.25rem !important;\n    padding-left: 0.25rem !important;\n  }\n  .px-sm-2 {\n    padding-right: 0.5rem !important;\n    padding-left: 0.5rem !important;\n  }\n  .px-sm-3 {\n    padding-right: 0.75rem !important;\n    padding-left: 0.75rem !important;\n  }\n  .px-sm-4 {\n    padding-right: 1rem !important;\n    padding-left: 1rem !important;\n  }\n  .px-sm-5 {\n    padding-right: 1.25rem !important;\n    padding-left: 1.25rem !important;\n  }\n  .px-sm-6 {\n    padding-right: 1.5rem !important;\n    padding-left: 1.5rem !important;\n  }\n  .px-sm-7 {\n    padding-right: 1.75rem !important;\n    padding-left: 1.75rem !important;\n  }\n  .px-sm-8 {\n    padding-right: 2rem !important;\n    padding-left: 2rem !important;\n  }\n  .px-sm-9 {\n    padding-right: 2.25rem !important;\n    padding-left: 2.25rem !important;\n  }\n  .px-sm-10 {\n    padding-right: 2.5rem !important;\n    padding-left: 2.5rem !important;\n  }\n  .px-sm-11 {\n    padding-right: 2.75rem !important;\n    padding-left: 2.75rem !important;\n  }\n  .px-sm-12 {\n    padding-right: 3rem !important;\n    padding-left: 3rem !important;\n  }\n  .px-sm-13 {\n    padding-right: 3.25rem !important;\n    padding-left: 3.25rem !important;\n  }\n  .px-sm-14 {\n    padding-right: 3.5rem !important;\n    padding-left: 3.5rem !important;\n  }\n  .px-sm-15 {\n    padding-right: 3.75rem !important;\n    padding-left: 3.75rem !important;\n  }\n  .px-sm-16 {\n    padding-right: 4rem !important;\n    padding-left: 4rem !important;\n  }\n  .px-sm-17 {\n    padding-right: 4.25rem !important;\n    padding-left: 4.25rem !important;\n  }\n  .px-sm-18 {\n    padding-right: 4.5rem !important;\n    padding-left: 4.5rem !important;\n  }\n  .px-sm-19 {\n    padding-right: 4.75rem !important;\n    padding-left: 4.75rem !important;\n  }\n  .px-sm-20 {\n    padding-right: 5rem !important;\n    padding-left: 5rem !important;\n  }\n  .py-sm-0 {\n    padding-top: 0 !important;\n    padding-bottom: 0 !important;\n  }\n  .py-sm-1 {\n    padding-top: 0.25rem !important;\n    padding-bottom: 0.25rem !important;\n  }\n  .py-sm-2 {\n    padding-top: 0.5rem !important;\n    padding-bottom: 0.5rem !important;\n  }\n  .py-sm-3 {\n    padding-top: 0.75rem !important;\n    padding-bottom: 0.75rem !important;\n  }\n  .py-sm-4 {\n    padding-top: 1rem !important;\n    padding-bottom: 1rem !important;\n  }\n  .py-sm-5 {\n    padding-top: 1.25rem !important;\n    padding-bottom: 1.25rem !important;\n  }\n  .py-sm-6 {\n    padding-top: 1.5rem !important;\n    padding-bottom: 1.5rem !important;\n  }\n  .py-sm-7 {\n    padding-top: 1.75rem !important;\n    padding-bottom: 1.75rem !important;\n  }\n  .py-sm-8 {\n    padding-top: 2rem !important;\n    padding-bottom: 2rem !important;\n  }\n  .py-sm-9 {\n    padding-top: 2.25rem !important;\n    padding-bottom: 2.25rem !important;\n  }\n  .py-sm-10 {\n    padding-top: 2.5rem !important;\n    padding-bottom: 2.5rem !important;\n  }\n  .py-sm-11 {\n    padding-top: 2.75rem !important;\n    padding-bottom: 2.75rem !important;\n  }\n  .py-sm-12 {\n    padding-top: 3rem !important;\n    padding-bottom: 3rem !important;\n  }\n  .py-sm-13 {\n    padding-top: 3.25rem !important;\n    padding-bottom: 3.25rem !important;\n  }\n  .py-sm-14 {\n    padding-top: 3.5rem !important;\n    padding-bottom: 3.5rem !important;\n  }\n  .py-sm-15 {\n    padding-top: 3.75rem !important;\n    padding-bottom: 3.75rem !important;\n  }\n  .py-sm-16 {\n    padding-top: 4rem !important;\n    padding-bottom: 4rem !important;\n  }\n  .py-sm-17 {\n    padding-top: 4.25rem !important;\n    padding-bottom: 4.25rem !important;\n  }\n  .py-sm-18 {\n    padding-top: 4.5rem !important;\n    padding-bottom: 4.5rem !important;\n  }\n  .py-sm-19 {\n    padding-top: 4.75rem !important;\n    padding-bottom: 4.75rem !important;\n  }\n  .py-sm-20 {\n    padding-top: 5rem !important;\n    padding-bottom: 5rem !important;\n  }\n  .pt-sm-0 {\n    padding-top: 0 !important;\n  }\n  .pt-sm-1 {\n    padding-top: 0.25rem !important;\n  }\n  .pt-sm-2 {\n    padding-top: 0.5rem !important;\n  }\n  .pt-sm-3 {\n    padding-top: 0.75rem !important;\n  }\n  .pt-sm-4 {\n    padding-top: 1rem !important;\n  }\n  .pt-sm-5 {\n    padding-top: 1.25rem !important;\n  }\n  .pt-sm-6 {\n    padding-top: 1.5rem !important;\n  }\n  .pt-sm-7 {\n    padding-top: 1.75rem !important;\n  }\n  .pt-sm-8 {\n    padding-top: 2rem !important;\n  }\n  .pt-sm-9 {\n    padding-top: 2.25rem !important;\n  }\n  .pt-sm-10 {\n    padding-top: 2.5rem !important;\n  }\n  .pt-sm-11 {\n    padding-top: 2.75rem !important;\n  }\n  .pt-sm-12 {\n    padding-top: 3rem !important;\n  }\n  .pt-sm-13 {\n    padding-top: 3.25rem !important;\n  }\n  .pt-sm-14 {\n    padding-top: 3.5rem !important;\n  }\n  .pt-sm-15 {\n    padding-top: 3.75rem !important;\n  }\n  .pt-sm-16 {\n    padding-top: 4rem !important;\n  }\n  .pt-sm-17 {\n    padding-top: 4.25rem !important;\n  }\n  .pt-sm-18 {\n    padding-top: 4.5rem !important;\n  }\n  .pt-sm-19 {\n    padding-top: 4.75rem !important;\n  }\n  .pt-sm-20 {\n    padding-top: 5rem !important;\n  }\n  .pe-sm-0 {\n    padding-right: 0 !important;\n  }\n  .pe-sm-1 {\n    padding-right: 0.25rem !important;\n  }\n  .pe-sm-2 {\n    padding-right: 0.5rem !important;\n  }\n  .pe-sm-3 {\n    padding-right: 0.75rem !important;\n  }\n  .pe-sm-4 {\n    padding-right: 1rem !important;\n  }\n  .pe-sm-5 {\n    padding-right: 1.25rem !important;\n  }\n  .pe-sm-6 {\n    padding-right: 1.5rem !important;\n  }\n  .pe-sm-7 {\n    padding-right: 1.75rem !important;\n  }\n  .pe-sm-8 {\n    padding-right: 2rem !important;\n  }\n  .pe-sm-9 {\n    padding-right: 2.25rem !important;\n  }\n  .pe-sm-10 {\n    padding-right: 2.5rem !important;\n  }\n  .pe-sm-11 {\n    padding-right: 2.75rem !important;\n  }\n  .pe-sm-12 {\n    padding-right: 3rem !important;\n  }\n  .pe-sm-13 {\n    padding-right: 3.25rem !important;\n  }\n  .pe-sm-14 {\n    padding-right: 3.5rem !important;\n  }\n  .pe-sm-15 {\n    padding-right: 3.75rem !important;\n  }\n  .pe-sm-16 {\n    padding-right: 4rem !important;\n  }\n  .pe-sm-17 {\n    padding-right: 4.25rem !important;\n  }\n  .pe-sm-18 {\n    padding-right: 4.5rem !important;\n  }\n  .pe-sm-19 {\n    padding-right: 4.75rem !important;\n  }\n  .pe-sm-20 {\n    padding-right: 5rem !important;\n  }\n  .pb-sm-0 {\n    padding-bottom: 0 !important;\n  }\n  .pb-sm-1 {\n    padding-bottom: 0.25rem !important;\n  }\n  .pb-sm-2 {\n    padding-bottom: 0.5rem !important;\n  }\n  .pb-sm-3 {\n    padding-bottom: 0.75rem !important;\n  }\n  .pb-sm-4 {\n    padding-bottom: 1rem !important;\n  }\n  .pb-sm-5 {\n    padding-bottom: 1.25rem !important;\n  }\n  .pb-sm-6 {\n    padding-bottom: 1.5rem !important;\n  }\n  .pb-sm-7 {\n    padding-bottom: 1.75rem !important;\n  }\n  .pb-sm-8 {\n    padding-bottom: 2rem !important;\n  }\n  .pb-sm-9 {\n    padding-bottom: 2.25rem !important;\n  }\n  .pb-sm-10 {\n    padding-bottom: 2.5rem !important;\n  }\n  .pb-sm-11 {\n    padding-bottom: 2.75rem !important;\n  }\n  .pb-sm-12 {\n    padding-bottom: 3rem !important;\n  }\n  .pb-sm-13 {\n    padding-bottom: 3.25rem !important;\n  }\n  .pb-sm-14 {\n    padding-bottom: 3.5rem !important;\n  }\n  .pb-sm-15 {\n    padding-bottom: 3.75rem !important;\n  }\n  .pb-sm-16 {\n    padding-bottom: 4rem !important;\n  }\n  .pb-sm-17 {\n    padding-bottom: 4.25rem !important;\n  }\n  .pb-sm-18 {\n    padding-bottom: 4.5rem !important;\n  }\n  .pb-sm-19 {\n    padding-bottom: 4.75rem !important;\n  }\n  .pb-sm-20 {\n    padding-bottom: 5rem !important;\n  }\n  .ps-sm-0 {\n    padding-left: 0 !important;\n  }\n  .ps-sm-1 {\n    padding-left: 0.25rem !important;\n  }\n  .ps-sm-2 {\n    padding-left: 0.5rem !important;\n  }\n  .ps-sm-3 {\n    padding-left: 0.75rem !important;\n  }\n  .ps-sm-4 {\n    padding-left: 1rem !important;\n  }\n  .ps-sm-5 {\n    padding-left: 1.25rem !important;\n  }\n  .ps-sm-6 {\n    padding-left: 1.5rem !important;\n  }\n  .ps-sm-7 {\n    padding-left: 1.75rem !important;\n  }\n  .ps-sm-8 {\n    padding-left: 2rem !important;\n  }\n  .ps-sm-9 {\n    padding-left: 2.25rem !important;\n  }\n  .ps-sm-10 {\n    padding-left: 2.5rem !important;\n  }\n  .ps-sm-11 {\n    padding-left: 2.75rem !important;\n  }\n  .ps-sm-12 {\n    padding-left: 3rem !important;\n  }\n  .ps-sm-13 {\n    padding-left: 3.25rem !important;\n  }\n  .ps-sm-14 {\n    padding-left: 3.5rem !important;\n  }\n  .ps-sm-15 {\n    padding-left: 3.75rem !important;\n  }\n  .ps-sm-16 {\n    padding-left: 4rem !important;\n  }\n  .ps-sm-17 {\n    padding-left: 4.25rem !important;\n  }\n  .ps-sm-18 {\n    padding-left: 4.5rem !important;\n  }\n  .ps-sm-19 {\n    padding-left: 4.75rem !important;\n  }\n  .ps-sm-20 {\n    padding-left: 5rem !important;\n  }\n  .gap-sm-0 {\n    gap: 0 !important;\n  }\n  .gap-sm-1 {\n    gap: 0.25rem !important;\n  }\n  .gap-sm-2 {\n    gap: 0.5rem !important;\n  }\n  .gap-sm-3 {\n    gap: 0.75rem !important;\n  }\n  .gap-sm-4 {\n    gap: 1rem !important;\n  }\n  .gap-sm-5 {\n    gap: 1.25rem !important;\n  }\n  .gap-sm-6 {\n    gap: 1.5rem !important;\n  }\n  .gap-sm-7 {\n    gap: 1.75rem !important;\n  }\n  .gap-sm-8 {\n    gap: 2rem !important;\n  }\n  .gap-sm-9 {\n    gap: 2.25rem !important;\n  }\n  .gap-sm-10 {\n    gap: 2.5rem !important;\n  }\n  .gap-sm-11 {\n    gap: 2.75rem !important;\n  }\n  .gap-sm-12 {\n    gap: 3rem !important;\n  }\n  .gap-sm-13 {\n    gap: 3.25rem !important;\n  }\n  .gap-sm-14 {\n    gap: 3.5rem !important;\n  }\n  .gap-sm-15 {\n    gap: 3.75rem !important;\n  }\n  .gap-sm-16 {\n    gap: 4rem !important;\n  }\n  .gap-sm-17 {\n    gap: 4.25rem !important;\n  }\n  .gap-sm-18 {\n    gap: 4.5rem !important;\n  }\n  .gap-sm-19 {\n    gap: 4.75rem !important;\n  }\n  .gap-sm-20 {\n    gap: 5rem !important;\n  }\n  .row-gap-sm-0 {\n    row-gap: 0 !important;\n  }\n  .row-gap-sm-1 {\n    row-gap: 0.25rem !important;\n  }\n  .row-gap-sm-2 {\n    row-gap: 0.5rem !important;\n  }\n  .row-gap-sm-3 {\n    row-gap: 0.75rem !important;\n  }\n  .row-gap-sm-4 {\n    row-gap: 1rem !important;\n  }\n  .row-gap-sm-5 {\n    row-gap: 1.25rem !important;\n  }\n  .row-gap-sm-6 {\n    row-gap: 1.5rem !important;\n  }\n  .row-gap-sm-7 {\n    row-gap: 1.75rem !important;\n  }\n  .row-gap-sm-8 {\n    row-gap: 2rem !important;\n  }\n  .row-gap-sm-9 {\n    row-gap: 2.25rem !important;\n  }\n  .row-gap-sm-10 {\n    row-gap: 2.5rem !important;\n  }\n  .row-gap-sm-11 {\n    row-gap: 2.75rem !important;\n  }\n  .row-gap-sm-12 {\n    row-gap: 3rem !important;\n  }\n  .row-gap-sm-13 {\n    row-gap: 3.25rem !important;\n  }\n  .row-gap-sm-14 {\n    row-gap: 3.5rem !important;\n  }\n  .row-gap-sm-15 {\n    row-gap: 3.75rem !important;\n  }\n  .row-gap-sm-16 {\n    row-gap: 4rem !important;\n  }\n  .row-gap-sm-17 {\n    row-gap: 4.25rem !important;\n  }\n  .row-gap-sm-18 {\n    row-gap: 4.5rem !important;\n  }\n  .row-gap-sm-19 {\n    row-gap: 4.75rem !important;\n  }\n  .row-gap-sm-20 {\n    row-gap: 5rem !important;\n  }\n  .column-gap-sm-0 {\n    column-gap: 0 !important;\n  }\n  .column-gap-sm-1 {\n    column-gap: 0.25rem !important;\n  }\n  .column-gap-sm-2 {\n    column-gap: 0.5rem !important;\n  }\n  .column-gap-sm-3 {\n    column-gap: 0.75rem !important;\n  }\n  .column-gap-sm-4 {\n    column-gap: 1rem !important;\n  }\n  .column-gap-sm-5 {\n    column-gap: 1.25rem !important;\n  }\n  .column-gap-sm-6 {\n    column-gap: 1.5rem !important;\n  }\n  .column-gap-sm-7 {\n    column-gap: 1.75rem !important;\n  }\n  .column-gap-sm-8 {\n    column-gap: 2rem !important;\n  }\n  .column-gap-sm-9 {\n    column-gap: 2.25rem !important;\n  }\n  .column-gap-sm-10 {\n    column-gap: 2.5rem !important;\n  }\n  .column-gap-sm-11 {\n    column-gap: 2.75rem !important;\n  }\n  .column-gap-sm-12 {\n    column-gap: 3rem !important;\n  }\n  .column-gap-sm-13 {\n    column-gap: 3.25rem !important;\n  }\n  .column-gap-sm-14 {\n    column-gap: 3.5rem !important;\n  }\n  .column-gap-sm-15 {\n    column-gap: 3.75rem !important;\n  }\n  .column-gap-sm-16 {\n    column-gap: 4rem !important;\n  }\n  .column-gap-sm-17 {\n    column-gap: 4.25rem !important;\n  }\n  .column-gap-sm-18 {\n    column-gap: 4.5rem !important;\n  }\n  .column-gap-sm-19 {\n    column-gap: 4.75rem !important;\n  }\n  .column-gap-sm-20 {\n    column-gap: 5rem !important;\n  }\n  .fs-sm-1 {\n    font-size: calc(1.3rem + 0.6vw) !important;\n  }\n  .fs-sm-2 {\n    font-size: calc(1.275rem + 0.3vw) !important;\n  }\n  .fs-sm-3 {\n    font-size: calc(1.26rem + 0.12vw) !important;\n  }\n  .fs-sm-4 {\n    font-size: 1.25rem !important;\n  }\n  .fs-sm-5 {\n    font-size: 1.15rem !important;\n  }\n  .fs-sm-6 {\n    font-size: 1.075rem !important;\n  }\n  .fs-sm-7 {\n    font-size: 0.95rem !important;\n  }\n  .fs-sm-8 {\n    font-size: 0.85rem !important;\n  }\n  .fs-sm-9 {\n    font-size: 0.75rem !important;\n  }\n  .fs-sm-10 {\n    font-size: 0.5rem !important;\n  }\n  .fs-sm-base {\n    font-size: 1rem !important;\n  }\n  .fs-sm-fluid {\n    font-size: 100% !important;\n  }\n  .fs-sm-2x {\n    font-size: calc(1.325rem + 0.9vw) !important;\n  }\n  .fs-sm-2qx {\n    font-size: calc(1.35rem + 1.2vw) !important;\n  }\n  .fs-sm-2hx {\n    font-size: calc(1.375rem + 1.5vw) !important;\n  }\n  .fs-sm-2tx {\n    font-size: calc(1.4rem + 1.8vw) !important;\n  }\n  .fs-sm-3x {\n    font-size: calc(1.425rem + 2.1vw) !important;\n  }\n  .fs-sm-3qx {\n    font-size: calc(1.45rem + 2.4vw) !important;\n  }\n  .fs-sm-3hx {\n    font-size: calc(1.475rem + 2.7vw) !important;\n  }\n  .fs-sm-3tx {\n    font-size: calc(1.5rem + 3vw) !important;\n  }\n  .fs-sm-4x {\n    font-size: calc(1.525rem + 3.3vw) !important;\n  }\n  .fs-sm-4qx {\n    font-size: calc(1.55rem + 3.6vw) !important;\n  }\n  .fs-sm-4hx {\n    font-size: calc(1.575rem + 3.9vw) !important;\n  }\n  .fs-sm-4tx {\n    font-size: calc(1.6rem + 4.2vw) !important;\n  }\n  .fs-sm-5x {\n    font-size: calc(1.625rem + 4.5vw) !important;\n  }\n  .fs-sm-5qx {\n    font-size: calc(1.65rem + 4.8vw) !important;\n  }\n  .fs-sm-5hx {\n    font-size: calc(1.675rem + 5.1vw) !important;\n  }\n  .fs-sm-5tx {\n    font-size: calc(1.7rem + 5.4vw) !important;\n  }\n  .fs-sm-6x {\n    font-size: calc(1.725rem + 5.7vw) !important;\n  }\n  .fs-sm-6qx {\n    font-size: calc(1.75rem + 6vw) !important;\n  }\n  .fs-sm-6hx {\n    font-size: calc(1.775rem + 6.3vw) !important;\n  }\n  .fs-sm-6tx {\n    font-size: calc(1.8rem + 6.6vw) !important;\n  }\n  .fs-sm-7x {\n    font-size: calc(1.825rem + 6.9vw) !important;\n  }\n  .fs-sm-7qx {\n    font-size: calc(1.85rem + 7.2vw) !important;\n  }\n  .fs-sm-7hx {\n    font-size: calc(1.875rem + 7.5vw) !important;\n  }\n  .fs-sm-7tx {\n    font-size: calc(1.9rem + 7.8vw) !important;\n  }\n  .text-sm-start {\n    text-align: left !important;\n  }\n  .text-sm-end {\n    text-align: right !important;\n  }\n  .text-sm-center {\n    text-align: center !important;\n  }\n  .min-w-sm-unset {\n    min-width: unset !important;\n  }\n  .min-w-sm-25 {\n    min-width: 25% !important;\n  }\n  .min-w-sm-50 {\n    min-width: 50% !important;\n  }\n  .min-w-sm-75 {\n    min-width: 75% !important;\n  }\n  .min-w-sm-100 {\n    min-width: 100% !important;\n  }\n  .min-w-sm-auto {\n    min-width: auto !important;\n  }\n  .min-w-sm-1px {\n    min-width: 1px !important;\n  }\n  .min-w-sm-2px {\n    min-width: 2px !important;\n  }\n  .min-w-sm-3px {\n    min-width: 3px !important;\n  }\n  .min-w-sm-4px {\n    min-width: 4px !important;\n  }\n  .min-w-sm-5px {\n    min-width: 5px !important;\n  }\n  .min-w-sm-6px {\n    min-width: 6px !important;\n  }\n  .min-w-sm-7px {\n    min-width: 7px !important;\n  }\n  .min-w-sm-8px {\n    min-width: 8px !important;\n  }\n  .min-w-sm-9px {\n    min-width: 9px !important;\n  }\n  .min-w-sm-10px {\n    min-width: 10px !important;\n  }\n  .min-w-sm-15px {\n    min-width: 15px !important;\n  }\n  .min-w-sm-20px {\n    min-width: 20px !important;\n  }\n  .min-w-sm-25px {\n    min-width: 25px !important;\n  }\n  .min-w-sm-30px {\n    min-width: 30px !important;\n  }\n  .min-w-sm-35px {\n    min-width: 35px !important;\n  }\n  .min-w-sm-40px {\n    min-width: 40px !important;\n  }\n  .min-w-sm-45px {\n    min-width: 45px !important;\n  }\n  .min-w-sm-50px {\n    min-width: 50px !important;\n  }\n  .min-w-sm-55px {\n    min-width: 55px !important;\n  }\n  .min-w-sm-60px {\n    min-width: 60px !important;\n  }\n  .min-w-sm-65px {\n    min-width: 65px !important;\n  }\n  .min-w-sm-70px {\n    min-width: 70px !important;\n  }\n  .min-w-sm-75px {\n    min-width: 75px !important;\n  }\n  .min-w-sm-80px {\n    min-width: 80px !important;\n  }\n  .min-w-sm-85px {\n    min-width: 85px !important;\n  }\n  .min-w-sm-90px {\n    min-width: 90px !important;\n  }\n  .min-w-sm-95px {\n    min-width: 95px !important;\n  }\n  .min-w-sm-100px {\n    min-width: 100px !important;\n  }\n  .min-w-sm-125px {\n    min-width: 125px !important;\n  }\n  .min-w-sm-150px {\n    min-width: 150px !important;\n  }\n  .min-w-sm-175px {\n    min-width: 175px !important;\n  }\n  .min-w-sm-200px {\n    min-width: 200px !important;\n  }\n  .min-w-sm-225px {\n    min-width: 225px !important;\n  }\n  .min-w-sm-250px {\n    min-width: 250px !important;\n  }\n  .min-w-sm-275px {\n    min-width: 275px !important;\n  }\n  .min-w-sm-300px {\n    min-width: 300px !important;\n  }\n  .min-w-sm-325px {\n    min-width: 325px !important;\n  }\n  .min-w-sm-350px {\n    min-width: 350px !important;\n  }\n  .min-w-sm-375px {\n    min-width: 375px !important;\n  }\n  .min-w-sm-400px {\n    min-width: 400px !important;\n  }\n  .min-w-sm-425px {\n    min-width: 425px !important;\n  }\n  .min-w-sm-450px {\n    min-width: 450px !important;\n  }\n  .min-w-sm-475px {\n    min-width: 475px !important;\n  }\n  .min-w-sm-500px {\n    min-width: 500px !important;\n  }\n  .min-w-sm-550px {\n    min-width: 550px !important;\n  }\n  .min-w-sm-600px {\n    min-width: 600px !important;\n  }\n  .min-w-sm-650px {\n    min-width: 650px !important;\n  }\n  .min-w-sm-700px {\n    min-width: 700px !important;\n  }\n  .min-w-sm-750px {\n    min-width: 750px !important;\n  }\n  .min-w-sm-800px {\n    min-width: 800px !important;\n  }\n  .min-w-sm-850px {\n    min-width: 850px !important;\n  }\n  .min-w-sm-900px {\n    min-width: 900px !important;\n  }\n  .min-w-sm-950px {\n    min-width: 950px !important;\n  }\n  .min-w-sm-1000px {\n    min-width: 1000px !important;\n  }\n  .min-h-sm-unset {\n    min-height: unset !important;\n  }\n  .min-h-sm-25 {\n    min-height: 25% !important;\n  }\n  .min-h-sm-50 {\n    min-height: 50% !important;\n  }\n  .min-h-sm-75 {\n    min-height: 75% !important;\n  }\n  .min-h-sm-100 {\n    min-height: 100% !important;\n  }\n  .min-h-sm-auto {\n    min-height: auto !important;\n  }\n  .min-h-sm-1px {\n    min-height: 1px !important;\n  }\n  .min-h-sm-2px {\n    min-height: 2px !important;\n  }\n  .min-h-sm-3px {\n    min-height: 3px !important;\n  }\n  .min-h-sm-4px {\n    min-height: 4px !important;\n  }\n  .min-h-sm-5px {\n    min-height: 5px !important;\n  }\n  .min-h-sm-6px {\n    min-height: 6px !important;\n  }\n  .min-h-sm-7px {\n    min-height: 7px !important;\n  }\n  .min-h-sm-8px {\n    min-height: 8px !important;\n  }\n  .min-h-sm-9px {\n    min-height: 9px !important;\n  }\n  .min-h-sm-10px {\n    min-height: 10px !important;\n  }\n  .min-h-sm-15px {\n    min-height: 15px !important;\n  }\n  .min-h-sm-20px {\n    min-height: 20px !important;\n  }\n  .min-h-sm-25px {\n    min-height: 25px !important;\n  }\n  .min-h-sm-30px {\n    min-height: 30px !important;\n  }\n  .min-h-sm-35px {\n    min-height: 35px !important;\n  }\n  .min-h-sm-40px {\n    min-height: 40px !important;\n  }\n  .min-h-sm-45px {\n    min-height: 45px !important;\n  }\n  .min-h-sm-50px {\n    min-height: 50px !important;\n  }\n  .min-h-sm-55px {\n    min-height: 55px !important;\n  }\n  .min-h-sm-60px {\n    min-height: 60px !important;\n  }\n  .min-h-sm-65px {\n    min-height: 65px !important;\n  }\n  .min-h-sm-70px {\n    min-height: 70px !important;\n  }\n  .min-h-sm-75px {\n    min-height: 75px !important;\n  }\n  .min-h-sm-80px {\n    min-height: 80px !important;\n  }\n  .min-h-sm-85px {\n    min-height: 85px !important;\n  }\n  .min-h-sm-90px {\n    min-height: 90px !important;\n  }\n  .min-h-sm-95px {\n    min-height: 95px !important;\n  }\n  .min-h-sm-100px {\n    min-height: 100px !important;\n  }\n  .min-h-sm-125px {\n    min-height: 125px !important;\n  }\n  .min-h-sm-150px {\n    min-height: 150px !important;\n  }\n  .min-h-sm-175px {\n    min-height: 175px !important;\n  }\n  .min-h-sm-200px {\n    min-height: 200px !important;\n  }\n  .min-h-sm-225px {\n    min-height: 225px !important;\n  }\n  .min-h-sm-250px {\n    min-height: 250px !important;\n  }\n  .min-h-sm-275px {\n    min-height: 275px !important;\n  }\n  .min-h-sm-300px {\n    min-height: 300px !important;\n  }\n  .min-h-sm-325px {\n    min-height: 325px !important;\n  }\n  .min-h-sm-350px {\n    min-height: 350px !important;\n  }\n  .min-h-sm-375px {\n    min-height: 375px !important;\n  }\n  .min-h-sm-400px {\n    min-height: 400px !important;\n  }\n  .min-h-sm-425px {\n    min-height: 425px !important;\n  }\n  .min-h-sm-450px {\n    min-height: 450px !important;\n  }\n  .min-h-sm-475px {\n    min-height: 475px !important;\n  }\n  .min-h-sm-500px {\n    min-height: 500px !important;\n  }\n  .min-h-sm-550px {\n    min-height: 550px !important;\n  }\n  .min-h-sm-600px {\n    min-height: 600px !important;\n  }\n  .min-h-sm-650px {\n    min-height: 650px !important;\n  }\n  .min-h-sm-700px {\n    min-height: 700px !important;\n  }\n  .min-h-sm-750px {\n    min-height: 750px !important;\n  }\n  .min-h-sm-800px {\n    min-height: 800px !important;\n  }\n  .min-h-sm-850px {\n    min-height: 850px !important;\n  }\n  .min-h-sm-900px {\n    min-height: 900px !important;\n  }\n  .min-h-sm-950px {\n    min-height: 950px !important;\n  }\n  .min-h-sm-1000px {\n    min-height: 1000px !important;\n  }\n}\n@media (min-width: 768px) {\n  .float-md-start {\n    float: left !important;\n  }\n  .float-md-end {\n    float: right !important;\n  }\n  .float-md-none {\n    float: none !important;\n  }\n  .object-fit-md-contain {\n    object-fit: contain !important;\n  }\n  .object-fit-md-cover {\n    object-fit: cover !important;\n  }\n  .object-fit-md-fill {\n    object-fit: fill !important;\n  }\n  .object-fit-md-scale {\n    object-fit: scale-down !important;\n  }\n  .object-fit-md-none {\n    object-fit: none !important;\n  }\n  .overflow-md-auto {\n    overflow: auto !important;\n  }\n  .overflow-md-hidden {\n    overflow: hidden !important;\n  }\n  .overflow-md-visible {\n    overflow: visible !important;\n  }\n  .overflow-md-scroll {\n    overflow: scroll !important;\n  }\n  .d-md-inline {\n    display: inline !important;\n  }\n  .d-md-inline-block {\n    display: inline-block !important;\n  }\n  .d-md-block {\n    display: block !important;\n  }\n  .d-md-grid {\n    display: grid !important;\n  }\n  .d-md-table {\n    display: table !important;\n  }\n  .d-md-table-row {\n    display: table-row !important;\n  }\n  .d-md-table-cell {\n    display: table-cell !important;\n  }\n  .d-md-flex {\n    display: flex !important;\n  }\n  .d-md-inline-flex {\n    display: inline-flex !important;\n  }\n  .d-md-none {\n    display: none !important;\n  }\n  .position-md-static {\n    position: static !important;\n  }\n  .position-md-relative {\n    position: relative !important;\n  }\n  .position-md-absolute {\n    position: absolute !important;\n  }\n  .position-md-fixed {\n    position: fixed !important;\n  }\n  .position-md-sticky {\n    position: sticky !important;\n  }\n  .w-md-unset {\n    width: unset !important;\n  }\n  .w-md-25 {\n    width: 25% !important;\n  }\n  .w-md-50 {\n    width: 50% !important;\n  }\n  .w-md-75 {\n    width: 75% !important;\n  }\n  .w-md-100 {\n    width: 100% !important;\n  }\n  .w-md-auto {\n    width: auto !important;\n  }\n  .w-md-1px {\n    width: 1px !important;\n  }\n  .w-md-2px {\n    width: 2px !important;\n  }\n  .w-md-3px {\n    width: 3px !important;\n  }\n  .w-md-4px {\n    width: 4px !important;\n  }\n  .w-md-5px {\n    width: 5px !important;\n  }\n  .w-md-6px {\n    width: 6px !important;\n  }\n  .w-md-7px {\n    width: 7px !important;\n  }\n  .w-md-8px {\n    width: 8px !important;\n  }\n  .w-md-9px {\n    width: 9px !important;\n  }\n  .w-md-10px {\n    width: 10px !important;\n  }\n  .w-md-15px {\n    width: 15px !important;\n  }\n  .w-md-20px {\n    width: 20px !important;\n  }\n  .w-md-25px {\n    width: 25px !important;\n  }\n  .w-md-30px {\n    width: 30px !important;\n  }\n  .w-md-35px {\n    width: 35px !important;\n  }\n  .w-md-40px {\n    width: 40px !important;\n  }\n  .w-md-45px {\n    width: 45px !important;\n  }\n  .w-md-50px {\n    width: 50px !important;\n  }\n  .w-md-55px {\n    width: 55px !important;\n  }\n  .w-md-60px {\n    width: 60px !important;\n  }\n  .w-md-65px {\n    width: 65px !important;\n  }\n  .w-md-70px {\n    width: 70px !important;\n  }\n  .w-md-75px {\n    width: 75px !important;\n  }\n  .w-md-80px {\n    width: 80px !important;\n  }\n  .w-md-85px {\n    width: 85px !important;\n  }\n  .w-md-90px {\n    width: 90px !important;\n  }\n  .w-md-95px {\n    width: 95px !important;\n  }\n  .w-md-100px {\n    width: 100px !important;\n  }\n  .w-md-125px {\n    width: 125px !important;\n  }\n  .w-md-150px {\n    width: 150px !important;\n  }\n  .w-md-175px {\n    width: 175px !important;\n  }\n  .w-md-200px {\n    width: 200px !important;\n  }\n  .w-md-225px {\n    width: 225px !important;\n  }\n  .w-md-250px {\n    width: 250px !important;\n  }\n  .w-md-275px {\n    width: 275px !important;\n  }\n  .w-md-300px {\n    width: 300px !important;\n  }\n  .w-md-325px {\n    width: 325px !important;\n  }\n  .w-md-350px {\n    width: 350px !important;\n  }\n  .w-md-375px {\n    width: 375px !important;\n  }\n  .w-md-400px {\n    width: 400px !important;\n  }\n  .w-md-425px {\n    width: 425px !important;\n  }\n  .w-md-450px {\n    width: 450px !important;\n  }\n  .w-md-475px {\n    width: 475px !important;\n  }\n  .w-md-500px {\n    width: 500px !important;\n  }\n  .w-md-550px {\n    width: 550px !important;\n  }\n  .w-md-600px {\n    width: 600px !important;\n  }\n  .w-md-650px {\n    width: 650px !important;\n  }\n  .w-md-700px {\n    width: 700px !important;\n  }\n  .w-md-750px {\n    width: 750px !important;\n  }\n  .w-md-800px {\n    width: 800px !important;\n  }\n  .w-md-850px {\n    width: 850px !important;\n  }\n  .w-md-900px {\n    width: 900px !important;\n  }\n  .w-md-950px {\n    width: 950px !important;\n  }\n  .w-md-1000px {\n    width: 1000px !important;\n  }\n  .mw-md-unset {\n    max-width: unset !important;\n  }\n  .mw-md-25 {\n    max-width: 25% !important;\n  }\n  .mw-md-50 {\n    max-width: 50% !important;\n  }\n  .mw-md-75 {\n    max-width: 75% !important;\n  }\n  .mw-md-100 {\n    max-width: 100% !important;\n  }\n  .mw-md-auto {\n    max-width: auto !important;\n  }\n  .mw-md-1px {\n    max-width: 1px !important;\n  }\n  .mw-md-2px {\n    max-width: 2px !important;\n  }\n  .mw-md-3px {\n    max-width: 3px !important;\n  }\n  .mw-md-4px {\n    max-width: 4px !important;\n  }\n  .mw-md-5px {\n    max-width: 5px !important;\n  }\n  .mw-md-6px {\n    max-width: 6px !important;\n  }\n  .mw-md-7px {\n    max-width: 7px !important;\n  }\n  .mw-md-8px {\n    max-width: 8px !important;\n  }\n  .mw-md-9px {\n    max-width: 9px !important;\n  }\n  .mw-md-10px {\n    max-width: 10px !important;\n  }\n  .mw-md-15px {\n    max-width: 15px !important;\n  }\n  .mw-md-20px {\n    max-width: 20px !important;\n  }\n  .mw-md-25px {\n    max-width: 25px !important;\n  }\n  .mw-md-30px {\n    max-width: 30px !important;\n  }\n  .mw-md-35px {\n    max-width: 35px !important;\n  }\n  .mw-md-40px {\n    max-width: 40px !important;\n  }\n  .mw-md-45px {\n    max-width: 45px !important;\n  }\n  .mw-md-50px {\n    max-width: 50px !important;\n  }\n  .mw-md-55px {\n    max-width: 55px !important;\n  }\n  .mw-md-60px {\n    max-width: 60px !important;\n  }\n  .mw-md-65px {\n    max-width: 65px !important;\n  }\n  .mw-md-70px {\n    max-width: 70px !important;\n  }\n  .mw-md-75px {\n    max-width: 75px !important;\n  }\n  .mw-md-80px {\n    max-width: 80px !important;\n  }\n  .mw-md-85px {\n    max-width: 85px !important;\n  }\n  .mw-md-90px {\n    max-width: 90px !important;\n  }\n  .mw-md-95px {\n    max-width: 95px !important;\n  }\n  .mw-md-100px {\n    max-width: 100px !important;\n  }\n  .mw-md-125px {\n    max-width: 125px !important;\n  }\n  .mw-md-150px {\n    max-width: 150px !important;\n  }\n  .mw-md-175px {\n    max-width: 175px !important;\n  }\n  .mw-md-200px {\n    max-width: 200px !important;\n  }\n  .mw-md-225px {\n    max-width: 225px !important;\n  }\n  .mw-md-250px {\n    max-width: 250px !important;\n  }\n  .mw-md-275px {\n    max-width: 275px !important;\n  }\n  .mw-md-300px {\n    max-width: 300px !important;\n  }\n  .mw-md-325px {\n    max-width: 325px !important;\n  }\n  .mw-md-350px {\n    max-width: 350px !important;\n  }\n  .mw-md-375px {\n    max-width: 375px !important;\n  }\n  .mw-md-400px {\n    max-width: 400px !important;\n  }\n  .mw-md-425px {\n    max-width: 425px !important;\n  }\n  .mw-md-450px {\n    max-width: 450px !important;\n  }\n  .mw-md-475px {\n    max-width: 475px !important;\n  }\n  .mw-md-500px {\n    max-width: 500px !important;\n  }\n  .mw-md-550px {\n    max-width: 550px !important;\n  }\n  .mw-md-600px {\n    max-width: 600px !important;\n  }\n  .mw-md-650px {\n    max-width: 650px !important;\n  }\n  .mw-md-700px {\n    max-width: 700px !important;\n  }\n  .mw-md-750px {\n    max-width: 750px !important;\n  }\n  .mw-md-800px {\n    max-width: 800px !important;\n  }\n  .mw-md-850px {\n    max-width: 850px !important;\n  }\n  .mw-md-900px {\n    max-width: 900px !important;\n  }\n  .mw-md-950px {\n    max-width: 950px !important;\n  }\n  .mw-md-1000px {\n    max-width: 1000px !important;\n  }\n  .h-md-unset {\n    height: unset !important;\n  }\n  .h-md-25 {\n    height: 25% !important;\n  }\n  .h-md-50 {\n    height: 50% !important;\n  }\n  .h-md-75 {\n    height: 75% !important;\n  }\n  .h-md-100 {\n    height: 100% !important;\n  }\n  .h-md-auto {\n    height: auto !important;\n  }\n  .h-md-1px {\n    height: 1px !important;\n  }\n  .h-md-2px {\n    height: 2px !important;\n  }\n  .h-md-3px {\n    height: 3px !important;\n  }\n  .h-md-4px {\n    height: 4px !important;\n  }\n  .h-md-5px {\n    height: 5px !important;\n  }\n  .h-md-6px {\n    height: 6px !important;\n  }\n  .h-md-7px {\n    height: 7px !important;\n  }\n  .h-md-8px {\n    height: 8px !important;\n  }\n  .h-md-9px {\n    height: 9px !important;\n  }\n  .h-md-10px {\n    height: 10px !important;\n  }\n  .h-md-15px {\n    height: 15px !important;\n  }\n  .h-md-20px {\n    height: 20px !important;\n  }\n  .h-md-25px {\n    height: 25px !important;\n  }\n  .h-md-30px {\n    height: 30px !important;\n  }\n  .h-md-35px {\n    height: 35px !important;\n  }\n  .h-md-40px {\n    height: 40px !important;\n  }\n  .h-md-45px {\n    height: 45px !important;\n  }\n  .h-md-50px {\n    height: 50px !important;\n  }\n  .h-md-55px {\n    height: 55px !important;\n  }\n  .h-md-60px {\n    height: 60px !important;\n  }\n  .h-md-65px {\n    height: 65px !important;\n  }\n  .h-md-70px {\n    height: 70px !important;\n  }\n  .h-md-75px {\n    height: 75px !important;\n  }\n  .h-md-80px {\n    height: 80px !important;\n  }\n  .h-md-85px {\n    height: 85px !important;\n  }\n  .h-md-90px {\n    height: 90px !important;\n  }\n  .h-md-95px {\n    height: 95px !important;\n  }\n  .h-md-100px {\n    height: 100px !important;\n  }\n  .h-md-125px {\n    height: 125px !important;\n  }\n  .h-md-150px {\n    height: 150px !important;\n  }\n  .h-md-175px {\n    height: 175px !important;\n  }\n  .h-md-200px {\n    height: 200px !important;\n  }\n  .h-md-225px {\n    height: 225px !important;\n  }\n  .h-md-250px {\n    height: 250px !important;\n  }\n  .h-md-275px {\n    height: 275px !important;\n  }\n  .h-md-300px {\n    height: 300px !important;\n  }\n  .h-md-325px {\n    height: 325px !important;\n  }\n  .h-md-350px {\n    height: 350px !important;\n  }\n  .h-md-375px {\n    height: 375px !important;\n  }\n  .h-md-400px {\n    height: 400px !important;\n  }\n  .h-md-425px {\n    height: 425px !important;\n  }\n  .h-md-450px {\n    height: 450px !important;\n  }\n  .h-md-475px {\n    height: 475px !important;\n  }\n  .h-md-500px {\n    height: 500px !important;\n  }\n  .h-md-550px {\n    height: 550px !important;\n  }\n  .h-md-600px {\n    height: 600px !important;\n  }\n  .h-md-650px {\n    height: 650px !important;\n  }\n  .h-md-700px {\n    height: 700px !important;\n  }\n  .h-md-750px {\n    height: 750px !important;\n  }\n  .h-md-800px {\n    height: 800px !important;\n  }\n  .h-md-850px {\n    height: 850px !important;\n  }\n  .h-md-900px {\n    height: 900px !important;\n  }\n  .h-md-950px {\n    height: 950px !important;\n  }\n  .h-md-1000px {\n    height: 1000px !important;\n  }\n  .mh-md-unset {\n    max-height: unset !important;\n  }\n  .mh-md-25 {\n    max-height: 25% !important;\n  }\n  .mh-md-50 {\n    max-height: 50% !important;\n  }\n  .mh-md-75 {\n    max-height: 75% !important;\n  }\n  .mh-md-100 {\n    max-height: 100% !important;\n  }\n  .mh-md-auto {\n    max-height: auto !important;\n  }\n  .mh-md-1px {\n    max-height: 1px !important;\n  }\n  .mh-md-2px {\n    max-height: 2px !important;\n  }\n  .mh-md-3px {\n    max-height: 3px !important;\n  }\n  .mh-md-4px {\n    max-height: 4px !important;\n  }\n  .mh-md-5px {\n    max-height: 5px !important;\n  }\n  .mh-md-6px {\n    max-height: 6px !important;\n  }\n  .mh-md-7px {\n    max-height: 7px !important;\n  }\n  .mh-md-8px {\n    max-height: 8px !important;\n  }\n  .mh-md-9px {\n    max-height: 9px !important;\n  }\n  .mh-md-10px {\n    max-height: 10px !important;\n  }\n  .mh-md-15px {\n    max-height: 15px !important;\n  }\n  .mh-md-20px {\n    max-height: 20px !important;\n  }\n  .mh-md-25px {\n    max-height: 25px !important;\n  }\n  .mh-md-30px {\n    max-height: 30px !important;\n  }\n  .mh-md-35px {\n    max-height: 35px !important;\n  }\n  .mh-md-40px {\n    max-height: 40px !important;\n  }\n  .mh-md-45px {\n    max-height: 45px !important;\n  }\n  .mh-md-50px {\n    max-height: 50px !important;\n  }\n  .mh-md-55px {\n    max-height: 55px !important;\n  }\n  .mh-md-60px {\n    max-height: 60px !important;\n  }\n  .mh-md-65px {\n    max-height: 65px !important;\n  }\n  .mh-md-70px {\n    max-height: 70px !important;\n  }\n  .mh-md-75px {\n    max-height: 75px !important;\n  }\n  .mh-md-80px {\n    max-height: 80px !important;\n  }\n  .mh-md-85px {\n    max-height: 85px !important;\n  }\n  .mh-md-90px {\n    max-height: 90px !important;\n  }\n  .mh-md-95px {\n    max-height: 95px !important;\n  }\n  .mh-md-100px {\n    max-height: 100px !important;\n  }\n  .mh-md-125px {\n    max-height: 125px !important;\n  }\n  .mh-md-150px {\n    max-height: 150px !important;\n  }\n  .mh-md-175px {\n    max-height: 175px !important;\n  }\n  .mh-md-200px {\n    max-height: 200px !important;\n  }\n  .mh-md-225px {\n    max-height: 225px !important;\n  }\n  .mh-md-250px {\n    max-height: 250px !important;\n  }\n  .mh-md-275px {\n    max-height: 275px !important;\n  }\n  .mh-md-300px {\n    max-height: 300px !important;\n  }\n  .mh-md-325px {\n    max-height: 325px !important;\n  }\n  .mh-md-350px {\n    max-height: 350px !important;\n  }\n  .mh-md-375px {\n    max-height: 375px !important;\n  }\n  .mh-md-400px {\n    max-height: 400px !important;\n  }\n  .mh-md-425px {\n    max-height: 425px !important;\n  }\n  .mh-md-450px {\n    max-height: 450px !important;\n  }\n  .mh-md-475px {\n    max-height: 475px !important;\n  }\n  .mh-md-500px {\n    max-height: 500px !important;\n  }\n  .mh-md-550px {\n    max-height: 550px !important;\n  }\n  .mh-md-600px {\n    max-height: 600px !important;\n  }\n  .mh-md-650px {\n    max-height: 650px !important;\n  }\n  .mh-md-700px {\n    max-height: 700px !important;\n  }\n  .mh-md-750px {\n    max-height: 750px !important;\n  }\n  .mh-md-800px {\n    max-height: 800px !important;\n  }\n  .mh-md-850px {\n    max-height: 850px !important;\n  }\n  .mh-md-900px {\n    max-height: 900px !important;\n  }\n  .mh-md-950px {\n    max-height: 950px !important;\n  }\n  .mh-md-1000px {\n    max-height: 1000px !important;\n  }\n  .flex-md-fill {\n    flex: 1 1 auto !important;\n  }\n  .flex-md-row {\n    flex-direction: row !important;\n  }\n  .flex-md-column {\n    flex-direction: column !important;\n  }\n  .flex-md-row-reverse {\n    flex-direction: row-reverse !important;\n  }\n  .flex-md-column-reverse {\n    flex-direction: column-reverse !important;\n  }\n  .flex-md-grow-0 {\n    flex-grow: 0 !important;\n  }\n  .flex-md-grow-1 {\n    flex-grow: 1 !important;\n  }\n  .flex-md-shrink-0 {\n    flex-shrink: 0 !important;\n  }\n  .flex-md-shrink-1 {\n    flex-shrink: 1 !important;\n  }\n  .flex-md-wrap {\n    flex-wrap: wrap !important;\n  }\n  .flex-md-nowrap {\n    flex-wrap: nowrap !important;\n  }\n  .flex-md-wrap-reverse {\n    flex-wrap: wrap-reverse !important;\n  }\n  .justify-content-md-start {\n    justify-content: flex-start !important;\n  }\n  .justify-content-md-end {\n    justify-content: flex-end !important;\n  }\n  .justify-content-md-center {\n    justify-content: center !important;\n  }\n  .justify-content-md-between {\n    justify-content: space-between !important;\n  }\n  .justify-content-md-around {\n    justify-content: space-around !important;\n  }\n  .justify-content-md-evenly {\n    justify-content: space-evenly !important;\n  }\n  .align-items-md-start {\n    align-items: flex-start !important;\n  }\n  .align-items-md-end {\n    align-items: flex-end !important;\n  }\n  .align-items-md-center {\n    align-items: center !important;\n  }\n  .align-items-md-baseline {\n    align-items: baseline !important;\n  }\n  .align-items-md-stretch {\n    align-items: stretch !important;\n  }\n  .align-content-md-start {\n    align-content: flex-start !important;\n  }\n  .align-content-md-end {\n    align-content: flex-end !important;\n  }\n  .align-content-md-center {\n    align-content: center !important;\n  }\n  .align-content-md-between {\n    align-content: space-between !important;\n  }\n  .align-content-md-around {\n    align-content: space-around !important;\n  }\n  .align-content-md-stretch {\n    align-content: stretch !important;\n  }\n  .align-self-md-auto {\n    align-self: auto !important;\n  }\n  .align-self-md-start {\n    align-self: flex-start !important;\n  }\n  .align-self-md-end {\n    align-self: flex-end !important;\n  }\n  .align-self-md-center {\n    align-self: center !important;\n  }\n  .align-self-md-baseline {\n    align-self: baseline !important;\n  }\n  .align-self-md-stretch {\n    align-self: stretch !important;\n  }\n  .order-md-first {\n    order: -1 !important;\n  }\n  .order-md-0 {\n    order: 0 !important;\n  }\n  .order-md-1 {\n    order: 1 !important;\n  }\n  .order-md-2 {\n    order: 2 !important;\n  }\n  .order-md-3 {\n    order: 3 !important;\n  }\n  .order-md-4 {\n    order: 4 !important;\n  }\n  .order-md-5 {\n    order: 5 !important;\n  }\n  .order-md-last {\n    order: 6 !important;\n  }\n  .m-md-0 {\n    margin: 0 !important;\n  }\n  .m-md-1 {\n    margin: 0.25rem !important;\n  }\n  .m-md-2 {\n    margin: 0.5rem !important;\n  }\n  .m-md-3 {\n    margin: 0.75rem !important;\n  }\n  .m-md-4 {\n    margin: 1rem !important;\n  }\n  .m-md-5 {\n    margin: 1.25rem !important;\n  }\n  .m-md-6 {\n    margin: 1.5rem !important;\n  }\n  .m-md-7 {\n    margin: 1.75rem !important;\n  }\n  .m-md-8 {\n    margin: 2rem !important;\n  }\n  .m-md-9 {\n    margin: 2.25rem !important;\n  }\n  .m-md-10 {\n    margin: 2.5rem !important;\n  }\n  .m-md-11 {\n    margin: 2.75rem !important;\n  }\n  .m-md-12 {\n    margin: 3rem !important;\n  }\n  .m-md-13 {\n    margin: 3.25rem !important;\n  }\n  .m-md-14 {\n    margin: 3.5rem !important;\n  }\n  .m-md-15 {\n    margin: 3.75rem !important;\n  }\n  .m-md-16 {\n    margin: 4rem !important;\n  }\n  .m-md-17 {\n    margin: 4.25rem !important;\n  }\n  .m-md-18 {\n    margin: 4.5rem !important;\n  }\n  .m-md-19 {\n    margin: 4.75rem !important;\n  }\n  .m-md-20 {\n    margin: 5rem !important;\n  }\n  .m-md-auto {\n    margin: auto !important;\n  }\n  .mx-md-0 {\n    margin-right: 0 !important;\n    margin-left: 0 !important;\n  }\n  .mx-md-1 {\n    margin-right: 0.25rem !important;\n    margin-left: 0.25rem !important;\n  }\n  .mx-md-2 {\n    margin-right: 0.5rem !important;\n    margin-left: 0.5rem !important;\n  }\n  .mx-md-3 {\n    margin-right: 0.75rem !important;\n    margin-left: 0.75rem !important;\n  }\n  .mx-md-4 {\n    margin-right: 1rem !important;\n    margin-left: 1rem !important;\n  }\n  .mx-md-5 {\n    margin-right: 1.25rem !important;\n    margin-left: 1.25rem !important;\n  }\n  .mx-md-6 {\n    margin-right: 1.5rem !important;\n    margin-left: 1.5rem !important;\n  }\n  .mx-md-7 {\n    margin-right: 1.75rem !important;\n    margin-left: 1.75rem !important;\n  }\n  .mx-md-8 {\n    margin-right: 2rem !important;\n    margin-left: 2rem !important;\n  }\n  .mx-md-9 {\n    margin-right: 2.25rem !important;\n    margin-left: 2.25rem !important;\n  }\n  .mx-md-10 {\n    margin-right: 2.5rem !important;\n    margin-left: 2.5rem !important;\n  }\n  .mx-md-11 {\n    margin-right: 2.75rem !important;\n    margin-left: 2.75rem !important;\n  }\n  .mx-md-12 {\n    margin-right: 3rem !important;\n    margin-left: 3rem !important;\n  }\n  .mx-md-13 {\n    margin-right: 3.25rem !important;\n    margin-left: 3.25rem !important;\n  }\n  .mx-md-14 {\n    margin-right: 3.5rem !important;\n    margin-left: 3.5rem !important;\n  }\n  .mx-md-15 {\n    margin-right: 3.75rem !important;\n    margin-left: 3.75rem !important;\n  }\n  .mx-md-16 {\n    margin-right: 4rem !important;\n    margin-left: 4rem !important;\n  }\n  .mx-md-17 {\n    margin-right: 4.25rem !important;\n    margin-left: 4.25rem !important;\n  }\n  .mx-md-18 {\n    margin-right: 4.5rem !important;\n    margin-left: 4.5rem !important;\n  }\n  .mx-md-19 {\n    margin-right: 4.75rem !important;\n    margin-left: 4.75rem !important;\n  }\n  .mx-md-20 {\n    margin-right: 5rem !important;\n    margin-left: 5rem !important;\n  }\n  .mx-md-auto {\n    margin-right: auto !important;\n    margin-left: auto !important;\n  }\n  .my-md-0 {\n    margin-top: 0 !important;\n    margin-bottom: 0 !important;\n  }\n  .my-md-1 {\n    margin-top: 0.25rem !important;\n    margin-bottom: 0.25rem !important;\n  }\n  .my-md-2 {\n    margin-top: 0.5rem !important;\n    margin-bottom: 0.5rem !important;\n  }\n  .my-md-3 {\n    margin-top: 0.75rem !important;\n    margin-bottom: 0.75rem !important;\n  }\n  .my-md-4 {\n    margin-top: 1rem !important;\n    margin-bottom: 1rem !important;\n  }\n  .my-md-5 {\n    margin-top: 1.25rem !important;\n    margin-bottom: 1.25rem !important;\n  }\n  .my-md-6 {\n    margin-top: 1.5rem !important;\n    margin-bottom: 1.5rem !important;\n  }\n  .my-md-7 {\n    margin-top: 1.75rem !important;\n    margin-bottom: 1.75rem !important;\n  }\n  .my-md-8 {\n    margin-top: 2rem !important;\n    margin-bottom: 2rem !important;\n  }\n  .my-md-9 {\n    margin-top: 2.25rem !important;\n    margin-bottom: 2.25rem !important;\n  }\n  .my-md-10 {\n    margin-top: 2.5rem !important;\n    margin-bottom: 2.5rem !important;\n  }\n  .my-md-11 {\n    margin-top: 2.75rem !important;\n    margin-bottom: 2.75rem !important;\n  }\n  .my-md-12 {\n    margin-top: 3rem !important;\n    margin-bottom: 3rem !important;\n  }\n  .my-md-13 {\n    margin-top: 3.25rem !important;\n    margin-bottom: 3.25rem !important;\n  }\n  .my-md-14 {\n    margin-top: 3.5rem !important;\n    margin-bottom: 3.5rem !important;\n  }\n  .my-md-15 {\n    margin-top: 3.75rem !important;\n    margin-bottom: 3.75rem !important;\n  }\n  .my-md-16 {\n    margin-top: 4rem !important;\n    margin-bottom: 4rem !important;\n  }\n  .my-md-17 {\n    margin-top: 4.25rem !important;\n    margin-bottom: 4.25rem !important;\n  }\n  .my-md-18 {\n    margin-top: 4.5rem !important;\n    margin-bottom: 4.5rem !important;\n  }\n  .my-md-19 {\n    margin-top: 4.75rem !important;\n    margin-bottom: 4.75rem !important;\n  }\n  .my-md-20 {\n    margin-top: 5rem !important;\n    margin-bottom: 5rem !important;\n  }\n  .my-md-auto {\n    margin-top: auto !important;\n    margin-bottom: auto !important;\n  }\n  .mt-md-0 {\n    margin-top: 0 !important;\n  }\n  .mt-md-1 {\n    margin-top: 0.25rem !important;\n  }\n  .mt-md-2 {\n    margin-top: 0.5rem !important;\n  }\n  .mt-md-3 {\n    margin-top: 0.75rem !important;\n  }\n  .mt-md-4 {\n    margin-top: 1rem !important;\n  }\n  .mt-md-5 {\n    margin-top: 1.25rem !important;\n  }\n  .mt-md-6 {\n    margin-top: 1.5rem !important;\n  }\n  .mt-md-7 {\n    margin-top: 1.75rem !important;\n  }\n  .mt-md-8 {\n    margin-top: 2rem !important;\n  }\n  .mt-md-9 {\n    margin-top: 2.25rem !important;\n  }\n  .mt-md-10 {\n    margin-top: 2.5rem !important;\n  }\n  .mt-md-11 {\n    margin-top: 2.75rem !important;\n  }\n  .mt-md-12 {\n    margin-top: 3rem !important;\n  }\n  .mt-md-13 {\n    margin-top: 3.25rem !important;\n  }\n  .mt-md-14 {\n    margin-top: 3.5rem !important;\n  }\n  .mt-md-15 {\n    margin-top: 3.75rem !important;\n  }\n  .mt-md-16 {\n    margin-top: 4rem !important;\n  }\n  .mt-md-17 {\n    margin-top: 4.25rem !important;\n  }\n  .mt-md-18 {\n    margin-top: 4.5rem !important;\n  }\n  .mt-md-19 {\n    margin-top: 4.75rem !important;\n  }\n  .mt-md-20 {\n    margin-top: 5rem !important;\n  }\n  .mt-md-auto {\n    margin-top: auto !important;\n  }\n  .me-md-0 {\n    margin-right: 0 !important;\n  }\n  .me-md-1 {\n    margin-right: 0.25rem !important;\n  }\n  .me-md-2 {\n    margin-right: 0.5rem !important;\n  }\n  .me-md-3 {\n    margin-right: 0.75rem !important;\n  }\n  .me-md-4 {\n    margin-right: 1rem !important;\n  }\n  .me-md-5 {\n    margin-right: 1.25rem !important;\n  }\n  .me-md-6 {\n    margin-right: 1.5rem !important;\n  }\n  .me-md-7 {\n    margin-right: 1.75rem !important;\n  }\n  .me-md-8 {\n    margin-right: 2rem !important;\n  }\n  .me-md-9 {\n    margin-right: 2.25rem !important;\n  }\n  .me-md-10 {\n    margin-right: 2.5rem !important;\n  }\n  .me-md-11 {\n    margin-right: 2.75rem !important;\n  }\n  .me-md-12 {\n    margin-right: 3rem !important;\n  }\n  .me-md-13 {\n    margin-right: 3.25rem !important;\n  }\n  .me-md-14 {\n    margin-right: 3.5rem !important;\n  }\n  .me-md-15 {\n    margin-right: 3.75rem !important;\n  }\n  .me-md-16 {\n    margin-right: 4rem !important;\n  }\n  .me-md-17 {\n    margin-right: 4.25rem !important;\n  }\n  .me-md-18 {\n    margin-right: 4.5rem !important;\n  }\n  .me-md-19 {\n    margin-right: 4.75rem !important;\n  }\n  .me-md-20 {\n    margin-right: 5rem !important;\n  }\n  .me-md-auto {\n    margin-right: auto !important;\n  }\n  .mb-md-0 {\n    margin-bottom: 0 !important;\n  }\n  .mb-md-1 {\n    margin-bottom: 0.25rem !important;\n  }\n  .mb-md-2 {\n    margin-bottom: 0.5rem !important;\n  }\n  .mb-md-3 {\n    margin-bottom: 0.75rem !important;\n  }\n  .mb-md-4 {\n    margin-bottom: 1rem !important;\n  }\n  .mb-md-5 {\n    margin-bottom: 1.25rem !important;\n  }\n  .mb-md-6 {\n    margin-bottom: 1.5rem !important;\n  }\n  .mb-md-7 {\n    margin-bottom: 1.75rem !important;\n  }\n  .mb-md-8 {\n    margin-bottom: 2rem !important;\n  }\n  .mb-md-9 {\n    margin-bottom: 2.25rem !important;\n  }\n  .mb-md-10 {\n    margin-bottom: 2.5rem !important;\n  }\n  .mb-md-11 {\n    margin-bottom: 2.75rem !important;\n  }\n  .mb-md-12 {\n    margin-bottom: 3rem !important;\n  }\n  .mb-md-13 {\n    margin-bottom: 3.25rem !important;\n  }\n  .mb-md-14 {\n    margin-bottom: 3.5rem !important;\n  }\n  .mb-md-15 {\n    margin-bottom: 3.75rem !important;\n  }\n  .mb-md-16 {\n    margin-bottom: 4rem !important;\n  }\n  .mb-md-17 {\n    margin-bottom: 4.25rem !important;\n  }\n  .mb-md-18 {\n    margin-bottom: 4.5rem !important;\n  }\n  .mb-md-19 {\n    margin-bottom: 4.75rem !important;\n  }\n  .mb-md-20 {\n    margin-bottom: 5rem !important;\n  }\n  .mb-md-auto {\n    margin-bottom: auto !important;\n  }\n  .ms-md-0 {\n    margin-left: 0 !important;\n  }\n  .ms-md-1 {\n    margin-left: 0.25rem !important;\n  }\n  .ms-md-2 {\n    margin-left: 0.5rem !important;\n  }\n  .ms-md-3 {\n    margin-left: 0.75rem !important;\n  }\n  .ms-md-4 {\n    margin-left: 1rem !important;\n  }\n  .ms-md-5 {\n    margin-left: 1.25rem !important;\n  }\n  .ms-md-6 {\n    margin-left: 1.5rem !important;\n  }\n  .ms-md-7 {\n    margin-left: 1.75rem !important;\n  }\n  .ms-md-8 {\n    margin-left: 2rem !important;\n  }\n  .ms-md-9 {\n    margin-left: 2.25rem !important;\n  }\n  .ms-md-10 {\n    margin-left: 2.5rem !important;\n  }\n  .ms-md-11 {\n    margin-left: 2.75rem !important;\n  }\n  .ms-md-12 {\n    margin-left: 3rem !important;\n  }\n  .ms-md-13 {\n    margin-left: 3.25rem !important;\n  }\n  .ms-md-14 {\n    margin-left: 3.5rem !important;\n  }\n  .ms-md-15 {\n    margin-left: 3.75rem !important;\n  }\n  .ms-md-16 {\n    margin-left: 4rem !important;\n  }\n  .ms-md-17 {\n    margin-left: 4.25rem !important;\n  }\n  .ms-md-18 {\n    margin-left: 4.5rem !important;\n  }\n  .ms-md-19 {\n    margin-left: 4.75rem !important;\n  }\n  .ms-md-20 {\n    margin-left: 5rem !important;\n  }\n  .ms-md-auto {\n    margin-left: auto !important;\n  }\n  .m-md-n1 {\n    margin: -0.25rem !important;\n  }\n  .m-md-n2 {\n    margin: -0.5rem !important;\n  }\n  .m-md-n3 {\n    margin: -0.75rem !important;\n  }\n  .m-md-n4 {\n    margin: -1rem !important;\n  }\n  .m-md-n5 {\n    margin: -1.25rem !important;\n  }\n  .m-md-n6 {\n    margin: -1.5rem !important;\n  }\n  .m-md-n7 {\n    margin: -1.75rem !important;\n  }\n  .m-md-n8 {\n    margin: -2rem !important;\n  }\n  .m-md-n9 {\n    margin: -2.25rem !important;\n  }\n  .m-md-n10 {\n    margin: -2.5rem !important;\n  }\n  .m-md-n11 {\n    margin: -2.75rem !important;\n  }\n  .m-md-n12 {\n    margin: -3rem !important;\n  }\n  .m-md-n13 {\n    margin: -3.25rem !important;\n  }\n  .m-md-n14 {\n    margin: -3.5rem !important;\n  }\n  .m-md-n15 {\n    margin: -3.75rem !important;\n  }\n  .m-md-n16 {\n    margin: -4rem !important;\n  }\n  .m-md-n17 {\n    margin: -4.25rem !important;\n  }\n  .m-md-n18 {\n    margin: -4.5rem !important;\n  }\n  .m-md-n19 {\n    margin: -4.75rem !important;\n  }\n  .m-md-n20 {\n    margin: -5rem !important;\n  }\n  .mx-md-n1 {\n    margin-right: -0.25rem !important;\n    margin-left: -0.25rem !important;\n  }\n  .mx-md-n2 {\n    margin-right: -0.5rem !important;\n    margin-left: -0.5rem !important;\n  }\n  .mx-md-n3 {\n    margin-right: -0.75rem !important;\n    margin-left: -0.75rem !important;\n  }\n  .mx-md-n4 {\n    margin-right: -1rem !important;\n    margin-left: -1rem !important;\n  }\n  .mx-md-n5 {\n    margin-right: -1.25rem !important;\n    margin-left: -1.25rem !important;\n  }\n  .mx-md-n6 {\n    margin-right: -1.5rem !important;\n    margin-left: -1.5rem !important;\n  }\n  .mx-md-n7 {\n    margin-right: -1.75rem !important;\n    margin-left: -1.75rem !important;\n  }\n  .mx-md-n8 {\n    margin-right: -2rem !important;\n    margin-left: -2rem !important;\n  }\n  .mx-md-n9 {\n    margin-right: -2.25rem !important;\n    margin-left: -2.25rem !important;\n  }\n  .mx-md-n10 {\n    margin-right: -2.5rem !important;\n    margin-left: -2.5rem !important;\n  }\n  .mx-md-n11 {\n    margin-right: -2.75rem !important;\n    margin-left: -2.75rem !important;\n  }\n  .mx-md-n12 {\n    margin-right: -3rem !important;\n    margin-left: -3rem !important;\n  }\n  .mx-md-n13 {\n    margin-right: -3.25rem !important;\n    margin-left: -3.25rem !important;\n  }\n  .mx-md-n14 {\n    margin-right: -3.5rem !important;\n    margin-left: -3.5rem !important;\n  }\n  .mx-md-n15 {\n    margin-right: -3.75rem !important;\n    margin-left: -3.75rem !important;\n  }\n  .mx-md-n16 {\n    margin-right: -4rem !important;\n    margin-left: -4rem !important;\n  }\n  .mx-md-n17 {\n    margin-right: -4.25rem !important;\n    margin-left: -4.25rem !important;\n  }\n  .mx-md-n18 {\n    margin-right: -4.5rem !important;\n    margin-left: -4.5rem !important;\n  }\n  .mx-md-n19 {\n    margin-right: -4.75rem !important;\n    margin-left: -4.75rem !important;\n  }\n  .mx-md-n20 {\n    margin-right: -5rem !important;\n    margin-left: -5rem !important;\n  }\n  .my-md-n1 {\n    margin-top: -0.25rem !important;\n    margin-bottom: -0.25rem !important;\n  }\n  .my-md-n2 {\n    margin-top: -0.5rem !important;\n    margin-bottom: -0.5rem !important;\n  }\n  .my-md-n3 {\n    margin-top: -0.75rem !important;\n    margin-bottom: -0.75rem !important;\n  }\n  .my-md-n4 {\n    margin-top: -1rem !important;\n    margin-bottom: -1rem !important;\n  }\n  .my-md-n5 {\n    margin-top: -1.25rem !important;\n    margin-bottom: -1.25rem !important;\n  }\n  .my-md-n6 {\n    margin-top: -1.5rem !important;\n    margin-bottom: -1.5rem !important;\n  }\n  .my-md-n7 {\n    margin-top: -1.75rem !important;\n    margin-bottom: -1.75rem !important;\n  }\n  .my-md-n8 {\n    margin-top: -2rem !important;\n    margin-bottom: -2rem !important;\n  }\n  .my-md-n9 {\n    margin-top: -2.25rem !important;\n    margin-bottom: -2.25rem !important;\n  }\n  .my-md-n10 {\n    margin-top: -2.5rem !important;\n    margin-bottom: -2.5rem !important;\n  }\n  .my-md-n11 {\n    margin-top: -2.75rem !important;\n    margin-bottom: -2.75rem !important;\n  }\n  .my-md-n12 {\n    margin-top: -3rem !important;\n    margin-bottom: -3rem !important;\n  }\n  .my-md-n13 {\n    margin-top: -3.25rem !important;\n    margin-bottom: -3.25rem !important;\n  }\n  .my-md-n14 {\n    margin-top: -3.5rem !important;\n    margin-bottom: -3.5rem !important;\n  }\n  .my-md-n15 {\n    margin-top: -3.75rem !important;\n    margin-bottom: -3.75rem !important;\n  }\n  .my-md-n16 {\n    margin-top: -4rem !important;\n    margin-bottom: -4rem !important;\n  }\n  .my-md-n17 {\n    margin-top: -4.25rem !important;\n    margin-bottom: -4.25rem !important;\n  }\n  .my-md-n18 {\n    margin-top: -4.5rem !important;\n    margin-bottom: -4.5rem !important;\n  }\n  .my-md-n19 {\n    margin-top: -4.75rem !important;\n    margin-bottom: -4.75rem !important;\n  }\n  .my-md-n20 {\n    margin-top: -5rem !important;\n    margin-bottom: -5rem !important;\n  }\n  .mt-md-n1 {\n    margin-top: -0.25rem !important;\n  }\n  .mt-md-n2 {\n    margin-top: -0.5rem !important;\n  }\n  .mt-md-n3 {\n    margin-top: -0.75rem !important;\n  }\n  .mt-md-n4 {\n    margin-top: -1rem !important;\n  }\n  .mt-md-n5 {\n    margin-top: -1.25rem !important;\n  }\n  .mt-md-n6 {\n    margin-top: -1.5rem !important;\n  }\n  .mt-md-n7 {\n    margin-top: -1.75rem !important;\n  }\n  .mt-md-n8 {\n    margin-top: -2rem !important;\n  }\n  .mt-md-n9 {\n    margin-top: -2.25rem !important;\n  }\n  .mt-md-n10 {\n    margin-top: -2.5rem !important;\n  }\n  .mt-md-n11 {\n    margin-top: -2.75rem !important;\n  }\n  .mt-md-n12 {\n    margin-top: -3rem !important;\n  }\n  .mt-md-n13 {\n    margin-top: -3.25rem !important;\n  }\n  .mt-md-n14 {\n    margin-top: -3.5rem !important;\n  }\n  .mt-md-n15 {\n    margin-top: -3.75rem !important;\n  }\n  .mt-md-n16 {\n    margin-top: -4rem !important;\n  }\n  .mt-md-n17 {\n    margin-top: -4.25rem !important;\n  }\n  .mt-md-n18 {\n    margin-top: -4.5rem !important;\n  }\n  .mt-md-n19 {\n    margin-top: -4.75rem !important;\n  }\n  .mt-md-n20 {\n    margin-top: -5rem !important;\n  }\n  .me-md-n1 {\n    margin-right: -0.25rem !important;\n  }\n  .me-md-n2 {\n    margin-right: -0.5rem !important;\n  }\n  .me-md-n3 {\n    margin-right: -0.75rem !important;\n  }\n  .me-md-n4 {\n    margin-right: -1rem !important;\n  }\n  .me-md-n5 {\n    margin-right: -1.25rem !important;\n  }\n  .me-md-n6 {\n    margin-right: -1.5rem !important;\n  }\n  .me-md-n7 {\n    margin-right: -1.75rem !important;\n  }\n  .me-md-n8 {\n    margin-right: -2rem !important;\n  }\n  .me-md-n9 {\n    margin-right: -2.25rem !important;\n  }\n  .me-md-n10 {\n    margin-right: -2.5rem !important;\n  }\n  .me-md-n11 {\n    margin-right: -2.75rem !important;\n  }\n  .me-md-n12 {\n    margin-right: -3rem !important;\n  }\n  .me-md-n13 {\n    margin-right: -3.25rem !important;\n  }\n  .me-md-n14 {\n    margin-right: -3.5rem !important;\n  }\n  .me-md-n15 {\n    margin-right: -3.75rem !important;\n  }\n  .me-md-n16 {\n    margin-right: -4rem !important;\n  }\n  .me-md-n17 {\n    margin-right: -4.25rem !important;\n  }\n  .me-md-n18 {\n    margin-right: -4.5rem !important;\n  }\n  .me-md-n19 {\n    margin-right: -4.75rem !important;\n  }\n  .me-md-n20 {\n    margin-right: -5rem !important;\n  }\n  .mb-md-n1 {\n    margin-bottom: -0.25rem !important;\n  }\n  .mb-md-n2 {\n    margin-bottom: -0.5rem !important;\n  }\n  .mb-md-n3 {\n    margin-bottom: -0.75rem !important;\n  }\n  .mb-md-n4 {\n    margin-bottom: -1rem !important;\n  }\n  .mb-md-n5 {\n    margin-bottom: -1.25rem !important;\n  }\n  .mb-md-n6 {\n    margin-bottom: -1.5rem !important;\n  }\n  .mb-md-n7 {\n    margin-bottom: -1.75rem !important;\n  }\n  .mb-md-n8 {\n    margin-bottom: -2rem !important;\n  }\n  .mb-md-n9 {\n    margin-bottom: -2.25rem !important;\n  }\n  .mb-md-n10 {\n    margin-bottom: -2.5rem !important;\n  }\n  .mb-md-n11 {\n    margin-bottom: -2.75rem !important;\n  }\n  .mb-md-n12 {\n    margin-bottom: -3rem !important;\n  }\n  .mb-md-n13 {\n    margin-bottom: -3.25rem !important;\n  }\n  .mb-md-n14 {\n    margin-bottom: -3.5rem !important;\n  }\n  .mb-md-n15 {\n    margin-bottom: -3.75rem !important;\n  }\n  .mb-md-n16 {\n    margin-bottom: -4rem !important;\n  }\n  .mb-md-n17 {\n    margin-bottom: -4.25rem !important;\n  }\n  .mb-md-n18 {\n    margin-bottom: -4.5rem !important;\n  }\n  .mb-md-n19 {\n    margin-bottom: -4.75rem !important;\n  }\n  .mb-md-n20 {\n    margin-bottom: -5rem !important;\n  }\n  .ms-md-n1 {\n    margin-left: -0.25rem !important;\n  }\n  .ms-md-n2 {\n    margin-left: -0.5rem !important;\n  }\n  .ms-md-n3 {\n    margin-left: -0.75rem !important;\n  }\n  .ms-md-n4 {\n    margin-left: -1rem !important;\n  }\n  .ms-md-n5 {\n    margin-left: -1.25rem !important;\n  }\n  .ms-md-n6 {\n    margin-left: -1.5rem !important;\n  }\n  .ms-md-n7 {\n    margin-left: -1.75rem !important;\n  }\n  .ms-md-n8 {\n    margin-left: -2rem !important;\n  }\n  .ms-md-n9 {\n    margin-left: -2.25rem !important;\n  }\n  .ms-md-n10 {\n    margin-left: -2.5rem !important;\n  }\n  .ms-md-n11 {\n    margin-left: -2.75rem !important;\n  }\n  .ms-md-n12 {\n    margin-left: -3rem !important;\n  }\n  .ms-md-n13 {\n    margin-left: -3.25rem !important;\n  }\n  .ms-md-n14 {\n    margin-left: -3.5rem !important;\n  }\n  .ms-md-n15 {\n    margin-left: -3.75rem !important;\n  }\n  .ms-md-n16 {\n    margin-left: -4rem !important;\n  }\n  .ms-md-n17 {\n    margin-left: -4.25rem !important;\n  }\n  .ms-md-n18 {\n    margin-left: -4.5rem !important;\n  }\n  .ms-md-n19 {\n    margin-left: -4.75rem !important;\n  }\n  .ms-md-n20 {\n    margin-left: -5rem !important;\n  }\n  .p-md-0 {\n    padding: 0 !important;\n  }\n  .p-md-1 {\n    padding: 0.25rem !important;\n  }\n  .p-md-2 {\n    padding: 0.5rem !important;\n  }\n  .p-md-3 {\n    padding: 0.75rem !important;\n  }\n  .p-md-4 {\n    padding: 1rem !important;\n  }\n  .p-md-5 {\n    padding: 1.25rem !important;\n  }\n  .p-md-6 {\n    padding: 1.5rem !important;\n  }\n  .p-md-7 {\n    padding: 1.75rem !important;\n  }\n  .p-md-8 {\n    padding: 2rem !important;\n  }\n  .p-md-9 {\n    padding: 2.25rem !important;\n  }\n  .p-md-10 {\n    padding: 2.5rem !important;\n  }\n  .p-md-11 {\n    padding: 2.75rem !important;\n  }\n  .p-md-12 {\n    padding: 3rem !important;\n  }\n  .p-md-13 {\n    padding: 3.25rem !important;\n  }\n  .p-md-14 {\n    padding: 3.5rem !important;\n  }\n  .p-md-15 {\n    padding: 3.75rem !important;\n  }\n  .p-md-16 {\n    padding: 4rem !important;\n  }\n  .p-md-17 {\n    padding: 4.25rem !important;\n  }\n  .p-md-18 {\n    padding: 4.5rem !important;\n  }\n  .p-md-19 {\n    padding: 4.75rem !important;\n  }\n  .p-md-20 {\n    padding: 5rem !important;\n  }\n  .px-md-0 {\n    padding-right: 0 !important;\n    padding-left: 0 !important;\n  }\n  .px-md-1 {\n    padding-right: 0.25rem !important;\n    padding-left: 0.25rem !important;\n  }\n  .px-md-2 {\n    padding-right: 0.5rem !important;\n    padding-left: 0.5rem !important;\n  }\n  .px-md-3 {\n    padding-right: 0.75rem !important;\n    padding-left: 0.75rem !important;\n  }\n  .px-md-4 {\n    padding-right: 1rem !important;\n    padding-left: 1rem !important;\n  }\n  .px-md-5 {\n    padding-right: 1.25rem !important;\n    padding-left: 1.25rem !important;\n  }\n  .px-md-6 {\n    padding-right: 1.5rem !important;\n    padding-left: 1.5rem !important;\n  }\n  .px-md-7 {\n    padding-right: 1.75rem !important;\n    padding-left: 1.75rem !important;\n  }\n  .px-md-8 {\n    padding-right: 2rem !important;\n    padding-left: 2rem !important;\n  }\n  .px-md-9 {\n    padding-right: 2.25rem !important;\n    padding-left: 2.25rem !important;\n  }\n  .px-md-10 {\n    padding-right: 2.5rem !important;\n    padding-left: 2.5rem !important;\n  }\n  .px-md-11 {\n    padding-right: 2.75rem !important;\n    padding-left: 2.75rem !important;\n  }\n  .px-md-12 {\n    padding-right: 3rem !important;\n    padding-left: 3rem !important;\n  }\n  .px-md-13 {\n    padding-right: 3.25rem !important;\n    padding-left: 3.25rem !important;\n  }\n  .px-md-14 {\n    padding-right: 3.5rem !important;\n    padding-left: 3.5rem !important;\n  }\n  .px-md-15 {\n    padding-right: 3.75rem !important;\n    padding-left: 3.75rem !important;\n  }\n  .px-md-16 {\n    padding-right: 4rem !important;\n    padding-left: 4rem !important;\n  }\n  .px-md-17 {\n    padding-right: 4.25rem !important;\n    padding-left: 4.25rem !important;\n  }\n  .px-md-18 {\n    padding-right: 4.5rem !important;\n    padding-left: 4.5rem !important;\n  }\n  .px-md-19 {\n    padding-right: 4.75rem !important;\n    padding-left: 4.75rem !important;\n  }\n  .px-md-20 {\n    padding-right: 5rem !important;\n    padding-left: 5rem !important;\n  }\n  .py-md-0 {\n    padding-top: 0 !important;\n    padding-bottom: 0 !important;\n  }\n  .py-md-1 {\n    padding-top: 0.25rem !important;\n    padding-bottom: 0.25rem !important;\n  }\n  .py-md-2 {\n    padding-top: 0.5rem !important;\n    padding-bottom: 0.5rem !important;\n  }\n  .py-md-3 {\n    padding-top: 0.75rem !important;\n    padding-bottom: 0.75rem !important;\n  }\n  .py-md-4 {\n    padding-top: 1rem !important;\n    padding-bottom: 1rem !important;\n  }\n  .py-md-5 {\n    padding-top: 1.25rem !important;\n    padding-bottom: 1.25rem !important;\n  }\n  .py-md-6 {\n    padding-top: 1.5rem !important;\n    padding-bottom: 1.5rem !important;\n  }\n  .py-md-7 {\n    padding-top: 1.75rem !important;\n    padding-bottom: 1.75rem !important;\n  }\n  .py-md-8 {\n    padding-top: 2rem !important;\n    padding-bottom: 2rem !important;\n  }\n  .py-md-9 {\n    padding-top: 2.25rem !important;\n    padding-bottom: 2.25rem !important;\n  }\n  .py-md-10 {\n    padding-top: 2.5rem !important;\n    padding-bottom: 2.5rem !important;\n  }\n  .py-md-11 {\n    padding-top: 2.75rem !important;\n    padding-bottom: 2.75rem !important;\n  }\n  .py-md-12 {\n    padding-top: 3rem !important;\n    padding-bottom: 3rem !important;\n  }\n  .py-md-13 {\n    padding-top: 3.25rem !important;\n    padding-bottom: 3.25rem !important;\n  }\n  .py-md-14 {\n    padding-top: 3.5rem !important;\n    padding-bottom: 3.5rem !important;\n  }\n  .py-md-15 {\n    padding-top: 3.75rem !important;\n    padding-bottom: 3.75rem !important;\n  }\n  .py-md-16 {\n    padding-top: 4rem !important;\n    padding-bottom: 4rem !important;\n  }\n  .py-md-17 {\n    padding-top: 4.25rem !important;\n    padding-bottom: 4.25rem !important;\n  }\n  .py-md-18 {\n    padding-top: 4.5rem !important;\n    padding-bottom: 4.5rem !important;\n  }\n  .py-md-19 {\n    padding-top: 4.75rem !important;\n    padding-bottom: 4.75rem !important;\n  }\n  .py-md-20 {\n    padding-top: 5rem !important;\n    padding-bottom: 5rem !important;\n  }\n  .pt-md-0 {\n    padding-top: 0 !important;\n  }\n  .pt-md-1 {\n    padding-top: 0.25rem !important;\n  }\n  .pt-md-2 {\n    padding-top: 0.5rem !important;\n  }\n  .pt-md-3 {\n    padding-top: 0.75rem !important;\n  }\n  .pt-md-4 {\n    padding-top: 1rem !important;\n  }\n  .pt-md-5 {\n    padding-top: 1.25rem !important;\n  }\n  .pt-md-6 {\n    padding-top: 1.5rem !important;\n  }\n  .pt-md-7 {\n    padding-top: 1.75rem !important;\n  }\n  .pt-md-8 {\n    padding-top: 2rem !important;\n  }\n  .pt-md-9 {\n    padding-top: 2.25rem !important;\n  }\n  .pt-md-10 {\n    padding-top: 2.5rem !important;\n  }\n  .pt-md-11 {\n    padding-top: 2.75rem !important;\n  }\n  .pt-md-12 {\n    padding-top: 3rem !important;\n  }\n  .pt-md-13 {\n    padding-top: 3.25rem !important;\n  }\n  .pt-md-14 {\n    padding-top: 3.5rem !important;\n  }\n  .pt-md-15 {\n    padding-top: 3.75rem !important;\n  }\n  .pt-md-16 {\n    padding-top: 4rem !important;\n  }\n  .pt-md-17 {\n    padding-top: 4.25rem !important;\n  }\n  .pt-md-18 {\n    padding-top: 4.5rem !important;\n  }\n  .pt-md-19 {\n    padding-top: 4.75rem !important;\n  }\n  .pt-md-20 {\n    padding-top: 5rem !important;\n  }\n  .pe-md-0 {\n    padding-right: 0 !important;\n  }\n  .pe-md-1 {\n    padding-right: 0.25rem !important;\n  }\n  .pe-md-2 {\n    padding-right: 0.5rem !important;\n  }\n  .pe-md-3 {\n    padding-right: 0.75rem !important;\n  }\n  .pe-md-4 {\n    padding-right: 1rem !important;\n  }\n  .pe-md-5 {\n    padding-right: 1.25rem !important;\n  }\n  .pe-md-6 {\n    padding-right: 1.5rem !important;\n  }\n  .pe-md-7 {\n    padding-right: 1.75rem !important;\n  }\n  .pe-md-8 {\n    padding-right: 2rem !important;\n  }\n  .pe-md-9 {\n    padding-right: 2.25rem !important;\n  }\n  .pe-md-10 {\n    padding-right: 2.5rem !important;\n  }\n  .pe-md-11 {\n    padding-right: 2.75rem !important;\n  }\n  .pe-md-12 {\n    padding-right: 3rem !important;\n  }\n  .pe-md-13 {\n    padding-right: 3.25rem !important;\n  }\n  .pe-md-14 {\n    padding-right: 3.5rem !important;\n  }\n  .pe-md-15 {\n    padding-right: 3.75rem !important;\n  }\n  .pe-md-16 {\n    padding-right: 4rem !important;\n  }\n  .pe-md-17 {\n    padding-right: 4.25rem !important;\n  }\n  .pe-md-18 {\n    padding-right: 4.5rem !important;\n  }\n  .pe-md-19 {\n    padding-right: 4.75rem !important;\n  }\n  .pe-md-20 {\n    padding-right: 5rem !important;\n  }\n  .pb-md-0 {\n    padding-bottom: 0 !important;\n  }\n  .pb-md-1 {\n    padding-bottom: 0.25rem !important;\n  }\n  .pb-md-2 {\n    padding-bottom: 0.5rem !important;\n  }\n  .pb-md-3 {\n    padding-bottom: 0.75rem !important;\n  }\n  .pb-md-4 {\n    padding-bottom: 1rem !important;\n  }\n  .pb-md-5 {\n    padding-bottom: 1.25rem !important;\n  }\n  .pb-md-6 {\n    padding-bottom: 1.5rem !important;\n  }\n  .pb-md-7 {\n    padding-bottom: 1.75rem !important;\n  }\n  .pb-md-8 {\n    padding-bottom: 2rem !important;\n  }\n  .pb-md-9 {\n    padding-bottom: 2.25rem !important;\n  }\n  .pb-md-10 {\n    padding-bottom: 2.5rem !important;\n  }\n  .pb-md-11 {\n    padding-bottom: 2.75rem !important;\n  }\n  .pb-md-12 {\n    padding-bottom: 3rem !important;\n  }\n  .pb-md-13 {\n    padding-bottom: 3.25rem !important;\n  }\n  .pb-md-14 {\n    padding-bottom: 3.5rem !important;\n  }\n  .pb-md-15 {\n    padding-bottom: 3.75rem !important;\n  }\n  .pb-md-16 {\n    padding-bottom: 4rem !important;\n  }\n  .pb-md-17 {\n    padding-bottom: 4.25rem !important;\n  }\n  .pb-md-18 {\n    padding-bottom: 4.5rem !important;\n  }\n  .pb-md-19 {\n    padding-bottom: 4.75rem !important;\n  }\n  .pb-md-20 {\n    padding-bottom: 5rem !important;\n  }\n  .ps-md-0 {\n    padding-left: 0 !important;\n  }\n  .ps-md-1 {\n    padding-left: 0.25rem !important;\n  }\n  .ps-md-2 {\n    padding-left: 0.5rem !important;\n  }\n  .ps-md-3 {\n    padding-left: 0.75rem !important;\n  }\n  .ps-md-4 {\n    padding-left: 1rem !important;\n  }\n  .ps-md-5 {\n    padding-left: 1.25rem !important;\n  }\n  .ps-md-6 {\n    padding-left: 1.5rem !important;\n  }\n  .ps-md-7 {\n    padding-left: 1.75rem !important;\n  }\n  .ps-md-8 {\n    padding-left: 2rem !important;\n  }\n  .ps-md-9 {\n    padding-left: 2.25rem !important;\n  }\n  .ps-md-10 {\n    padding-left: 2.5rem !important;\n  }\n  .ps-md-11 {\n    padding-left: 2.75rem !important;\n  }\n  .ps-md-12 {\n    padding-left: 3rem !important;\n  }\n  .ps-md-13 {\n    padding-left: 3.25rem !important;\n  }\n  .ps-md-14 {\n    padding-left: 3.5rem !important;\n  }\n  .ps-md-15 {\n    padding-left: 3.75rem !important;\n  }\n  .ps-md-16 {\n    padding-left: 4rem !important;\n  }\n  .ps-md-17 {\n    padding-left: 4.25rem !important;\n  }\n  .ps-md-18 {\n    padding-left: 4.5rem !important;\n  }\n  .ps-md-19 {\n    padding-left: 4.75rem !important;\n  }\n  .ps-md-20 {\n    padding-left: 5rem !important;\n  }\n  .gap-md-0 {\n    gap: 0 !important;\n  }\n  .gap-md-1 {\n    gap: 0.25rem !important;\n  }\n  .gap-md-2 {\n    gap: 0.5rem !important;\n  }\n  .gap-md-3 {\n    gap: 0.75rem !important;\n  }\n  .gap-md-4 {\n    gap: 1rem !important;\n  }\n  .gap-md-5 {\n    gap: 1.25rem !important;\n  }\n  .gap-md-6 {\n    gap: 1.5rem !important;\n  }\n  .gap-md-7 {\n    gap: 1.75rem !important;\n  }\n  .gap-md-8 {\n    gap: 2rem !important;\n  }\n  .gap-md-9 {\n    gap: 2.25rem !important;\n  }\n  .gap-md-10 {\n    gap: 2.5rem !important;\n  }\n  .gap-md-11 {\n    gap: 2.75rem !important;\n  }\n  .gap-md-12 {\n    gap: 3rem !important;\n  }\n  .gap-md-13 {\n    gap: 3.25rem !important;\n  }\n  .gap-md-14 {\n    gap: 3.5rem !important;\n  }\n  .gap-md-15 {\n    gap: 3.75rem !important;\n  }\n  .gap-md-16 {\n    gap: 4rem !important;\n  }\n  .gap-md-17 {\n    gap: 4.25rem !important;\n  }\n  .gap-md-18 {\n    gap: 4.5rem !important;\n  }\n  .gap-md-19 {\n    gap: 4.75rem !important;\n  }\n  .gap-md-20 {\n    gap: 5rem !important;\n  }\n  .row-gap-md-0 {\n    row-gap: 0 !important;\n  }\n  .row-gap-md-1 {\n    row-gap: 0.25rem !important;\n  }\n  .row-gap-md-2 {\n    row-gap: 0.5rem !important;\n  }\n  .row-gap-md-3 {\n    row-gap: 0.75rem !important;\n  }\n  .row-gap-md-4 {\n    row-gap: 1rem !important;\n  }\n  .row-gap-md-5 {\n    row-gap: 1.25rem !important;\n  }\n  .row-gap-md-6 {\n    row-gap: 1.5rem !important;\n  }\n  .row-gap-md-7 {\n    row-gap: 1.75rem !important;\n  }\n  .row-gap-md-8 {\n    row-gap: 2rem !important;\n  }\n  .row-gap-md-9 {\n    row-gap: 2.25rem !important;\n  }\n  .row-gap-md-10 {\n    row-gap: 2.5rem !important;\n  }\n  .row-gap-md-11 {\n    row-gap: 2.75rem !important;\n  }\n  .row-gap-md-12 {\n    row-gap: 3rem !important;\n  }\n  .row-gap-md-13 {\n    row-gap: 3.25rem !important;\n  }\n  .row-gap-md-14 {\n    row-gap: 3.5rem !important;\n  }\n  .row-gap-md-15 {\n    row-gap: 3.75rem !important;\n  }\n  .row-gap-md-16 {\n    row-gap: 4rem !important;\n  }\n  .row-gap-md-17 {\n    row-gap: 4.25rem !important;\n  }\n  .row-gap-md-18 {\n    row-gap: 4.5rem !important;\n  }\n  .row-gap-md-19 {\n    row-gap: 4.75rem !important;\n  }\n  .row-gap-md-20 {\n    row-gap: 5rem !important;\n  }\n  .column-gap-md-0 {\n    column-gap: 0 !important;\n  }\n  .column-gap-md-1 {\n    column-gap: 0.25rem !important;\n  }\n  .column-gap-md-2 {\n    column-gap: 0.5rem !important;\n  }\n  .column-gap-md-3 {\n    column-gap: 0.75rem !important;\n  }\n  .column-gap-md-4 {\n    column-gap: 1rem !important;\n  }\n  .column-gap-md-5 {\n    column-gap: 1.25rem !important;\n  }\n  .column-gap-md-6 {\n    column-gap: 1.5rem !important;\n  }\n  .column-gap-md-7 {\n    column-gap: 1.75rem !important;\n  }\n  .column-gap-md-8 {\n    column-gap: 2rem !important;\n  }\n  .column-gap-md-9 {\n    column-gap: 2.25rem !important;\n  }\n  .column-gap-md-10 {\n    column-gap: 2.5rem !important;\n  }\n  .column-gap-md-11 {\n    column-gap: 2.75rem !important;\n  }\n  .column-gap-md-12 {\n    column-gap: 3rem !important;\n  }\n  .column-gap-md-13 {\n    column-gap: 3.25rem !important;\n  }\n  .column-gap-md-14 {\n    column-gap: 3.5rem !important;\n  }\n  .column-gap-md-15 {\n    column-gap: 3.75rem !important;\n  }\n  .column-gap-md-16 {\n    column-gap: 4rem !important;\n  }\n  .column-gap-md-17 {\n    column-gap: 4.25rem !important;\n  }\n  .column-gap-md-18 {\n    column-gap: 4.5rem !important;\n  }\n  .column-gap-md-19 {\n    column-gap: 4.75rem !important;\n  }\n  .column-gap-md-20 {\n    column-gap: 5rem !important;\n  }\n  .fs-md-1 {\n    font-size: calc(1.3rem + 0.6vw) !important;\n  }\n  .fs-md-2 {\n    font-size: calc(1.275rem + 0.3vw) !important;\n  }\n  .fs-md-3 {\n    font-size: calc(1.26rem + 0.12vw) !important;\n  }\n  .fs-md-4 {\n    font-size: 1.25rem !important;\n  }\n  .fs-md-5 {\n    font-size: 1.15rem !important;\n  }\n  .fs-md-6 {\n    font-size: 1.075rem !important;\n  }\n  .fs-md-7 {\n    font-size: 0.95rem !important;\n  }\n  .fs-md-8 {\n    font-size: 0.85rem !important;\n  }\n  .fs-md-9 {\n    font-size: 0.75rem !important;\n  }\n  .fs-md-10 {\n    font-size: 0.5rem !important;\n  }\n  .fs-md-base {\n    font-size: 1rem !important;\n  }\n  .fs-md-fluid {\n    font-size: 100% !important;\n  }\n  .fs-md-2x {\n    font-size: calc(1.325rem + 0.9vw) !important;\n  }\n  .fs-md-2qx {\n    font-size: calc(1.35rem + 1.2vw) !important;\n  }\n  .fs-md-2hx {\n    font-size: calc(1.375rem + 1.5vw) !important;\n  }\n  .fs-md-2tx {\n    font-size: calc(1.4rem + 1.8vw) !important;\n  }\n  .fs-md-3x {\n    font-size: calc(1.425rem + 2.1vw) !important;\n  }\n  .fs-md-3qx {\n    font-size: calc(1.45rem + 2.4vw) !important;\n  }\n  .fs-md-3hx {\n    font-size: calc(1.475rem + 2.7vw) !important;\n  }\n  .fs-md-3tx {\n    font-size: calc(1.5rem + 3vw) !important;\n  }\n  .fs-md-4x {\n    font-size: calc(1.525rem + 3.3vw) !important;\n  }\n  .fs-md-4qx {\n    font-size: calc(1.55rem + 3.6vw) !important;\n  }\n  .fs-md-4hx {\n    font-size: calc(1.575rem + 3.9vw) !important;\n  }\n  .fs-md-4tx {\n    font-size: calc(1.6rem + 4.2vw) !important;\n  }\n  .fs-md-5x {\n    font-size: calc(1.625rem + 4.5vw) !important;\n  }\n  .fs-md-5qx {\n    font-size: calc(1.65rem + 4.8vw) !important;\n  }\n  .fs-md-5hx {\n    font-size: calc(1.675rem + 5.1vw) !important;\n  }\n  .fs-md-5tx {\n    font-size: calc(1.7rem + 5.4vw) !important;\n  }\n  .fs-md-6x {\n    font-size: calc(1.725rem + 5.7vw) !important;\n  }\n  .fs-md-6qx {\n    font-size: calc(1.75rem + 6vw) !important;\n  }\n  .fs-md-6hx {\n    font-size: calc(1.775rem + 6.3vw) !important;\n  }\n  .fs-md-6tx {\n    font-size: calc(1.8rem + 6.6vw) !important;\n  }\n  .fs-md-7x {\n    font-size: calc(1.825rem + 6.9vw) !important;\n  }\n  .fs-md-7qx {\n    font-size: calc(1.85rem + 7.2vw) !important;\n  }\n  .fs-md-7hx {\n    font-size: calc(1.875rem + 7.5vw) !important;\n  }\n  .fs-md-7tx {\n    font-size: calc(1.9rem + 7.8vw) !important;\n  }\n  .text-md-start {\n    text-align: left !important;\n  }\n  .text-md-end {\n    text-align: right !important;\n  }\n  .text-md-center {\n    text-align: center !important;\n  }\n  .min-w-md-unset {\n    min-width: unset !important;\n  }\n  .min-w-md-25 {\n    min-width: 25% !important;\n  }\n  .min-w-md-50 {\n    min-width: 50% !important;\n  }\n  .min-w-md-75 {\n    min-width: 75% !important;\n  }\n  .min-w-md-100 {\n    min-width: 100% !important;\n  }\n  .min-w-md-auto {\n    min-width: auto !important;\n  }\n  .min-w-md-1px {\n    min-width: 1px !important;\n  }\n  .min-w-md-2px {\n    min-width: 2px !important;\n  }\n  .min-w-md-3px {\n    min-width: 3px !important;\n  }\n  .min-w-md-4px {\n    min-width: 4px !important;\n  }\n  .min-w-md-5px {\n    min-width: 5px !important;\n  }\n  .min-w-md-6px {\n    min-width: 6px !important;\n  }\n  .min-w-md-7px {\n    min-width: 7px !important;\n  }\n  .min-w-md-8px {\n    min-width: 8px !important;\n  }\n  .min-w-md-9px {\n    min-width: 9px !important;\n  }\n  .min-w-md-10px {\n    min-width: 10px !important;\n  }\n  .min-w-md-15px {\n    min-width: 15px !important;\n  }\n  .min-w-md-20px {\n    min-width: 20px !important;\n  }\n  .min-w-md-25px {\n    min-width: 25px !important;\n  }\n  .min-w-md-30px {\n    min-width: 30px !important;\n  }\n  .min-w-md-35px {\n    min-width: 35px !important;\n  }\n  .min-w-md-40px {\n    min-width: 40px !important;\n  }\n  .min-w-md-45px {\n    min-width: 45px !important;\n  }\n  .min-w-md-50px {\n    min-width: 50px !important;\n  }\n  .min-w-md-55px {\n    min-width: 55px !important;\n  }\n  .min-w-md-60px {\n    min-width: 60px !important;\n  }\n  .min-w-md-65px {\n    min-width: 65px !important;\n  }\n  .min-w-md-70px {\n    min-width: 70px !important;\n  }\n  .min-w-md-75px {\n    min-width: 75px !important;\n  }\n  .min-w-md-80px {\n    min-width: 80px !important;\n  }\n  .min-w-md-85px {\n    min-width: 85px !important;\n  }\n  .min-w-md-90px {\n    min-width: 90px !important;\n  }\n  .min-w-md-95px {\n    min-width: 95px !important;\n  }\n  .min-w-md-100px {\n    min-width: 100px !important;\n  }\n  .min-w-md-125px {\n    min-width: 125px !important;\n  }\n  .min-w-md-150px {\n    min-width: 150px !important;\n  }\n  .min-w-md-175px {\n    min-width: 175px !important;\n  }\n  .min-w-md-200px {\n    min-width: 200px !important;\n  }\n  .min-w-md-225px {\n    min-width: 225px !important;\n  }\n  .min-w-md-250px {\n    min-width: 250px !important;\n  }\n  .min-w-md-275px {\n    min-width: 275px !important;\n  }\n  .min-w-md-300px {\n    min-width: 300px !important;\n  }\n  .min-w-md-325px {\n    min-width: 325px !important;\n  }\n  .min-w-md-350px {\n    min-width: 350px !important;\n  }\n  .min-w-md-375px {\n    min-width: 375px !important;\n  }\n  .min-w-md-400px {\n    min-width: 400px !important;\n  }\n  .min-w-md-425px {\n    min-width: 425px !important;\n  }\n  .min-w-md-450px {\n    min-width: 450px !important;\n  }\n  .min-w-md-475px {\n    min-width: 475px !important;\n  }\n  .min-w-md-500px {\n    min-width: 500px !important;\n  }\n  .min-w-md-550px {\n    min-width: 550px !important;\n  }\n  .min-w-md-600px {\n    min-width: 600px !important;\n  }\n  .min-w-md-650px {\n    min-width: 650px !important;\n  }\n  .min-w-md-700px {\n    min-width: 700px !important;\n  }\n  .min-w-md-750px {\n    min-width: 750px !important;\n  }\n  .min-w-md-800px {\n    min-width: 800px !important;\n  }\n  .min-w-md-850px {\n    min-width: 850px !important;\n  }\n  .min-w-md-900px {\n    min-width: 900px !important;\n  }\n  .min-w-md-950px {\n    min-width: 950px !important;\n  }\n  .min-w-md-1000px {\n    min-width: 1000px !important;\n  }\n  .min-h-md-unset {\n    min-height: unset !important;\n  }\n  .min-h-md-25 {\n    min-height: 25% !important;\n  }\n  .min-h-md-50 {\n    min-height: 50% !important;\n  }\n  .min-h-md-75 {\n    min-height: 75% !important;\n  }\n  .min-h-md-100 {\n    min-height: 100% !important;\n  }\n  .min-h-md-auto {\n    min-height: auto !important;\n  }\n  .min-h-md-1px {\n    min-height: 1px !important;\n  }\n  .min-h-md-2px {\n    min-height: 2px !important;\n  }\n  .min-h-md-3px {\n    min-height: 3px !important;\n  }\n  .min-h-md-4px {\n    min-height: 4px !important;\n  }\n  .min-h-md-5px {\n    min-height: 5px !important;\n  }\n  .min-h-md-6px {\n    min-height: 6px !important;\n  }\n  .min-h-md-7px {\n    min-height: 7px !important;\n  }\n  .min-h-md-8px {\n    min-height: 8px !important;\n  }\n  .min-h-md-9px {\n    min-height: 9px !important;\n  }\n  .min-h-md-10px {\n    min-height: 10px !important;\n  }\n  .min-h-md-15px {\n    min-height: 15px !important;\n  }\n  .min-h-md-20px {\n    min-height: 20px !important;\n  }\n  .min-h-md-25px {\n    min-height: 25px !important;\n  }\n  .min-h-md-30px {\n    min-height: 30px !important;\n  }\n  .min-h-md-35px {\n    min-height: 35px !important;\n  }\n  .min-h-md-40px {\n    min-height: 40px !important;\n  }\n  .min-h-md-45px {\n    min-height: 45px !important;\n  }\n  .min-h-md-50px {\n    min-height: 50px !important;\n  }\n  .min-h-md-55px {\n    min-height: 55px !important;\n  }\n  .min-h-md-60px {\n    min-height: 60px !important;\n  }\n  .min-h-md-65px {\n    min-height: 65px !important;\n  }\n  .min-h-md-70px {\n    min-height: 70px !important;\n  }\n  .min-h-md-75px {\n    min-height: 75px !important;\n  }\n  .min-h-md-80px {\n    min-height: 80px !important;\n  }\n  .min-h-md-85px {\n    min-height: 85px !important;\n  }\n  .min-h-md-90px {\n    min-height: 90px !important;\n  }\n  .min-h-md-95px {\n    min-height: 95px !important;\n  }\n  .min-h-md-100px {\n    min-height: 100px !important;\n  }\n  .min-h-md-125px {\n    min-height: 125px !important;\n  }\n  .min-h-md-150px {\n    min-height: 150px !important;\n  }\n  .min-h-md-175px {\n    min-height: 175px !important;\n  }\n  .min-h-md-200px {\n    min-height: 200px !important;\n  }\n  .min-h-md-225px {\n    min-height: 225px !important;\n  }\n  .min-h-md-250px {\n    min-height: 250px !important;\n  }\n  .min-h-md-275px {\n    min-height: 275px !important;\n  }\n  .min-h-md-300px {\n    min-height: 300px !important;\n  }\n  .min-h-md-325px {\n    min-height: 325px !important;\n  }\n  .min-h-md-350px {\n    min-height: 350px !important;\n  }\n  .min-h-md-375px {\n    min-height: 375px !important;\n  }\n  .min-h-md-400px {\n    min-height: 400px !important;\n  }\n  .min-h-md-425px {\n    min-height: 425px !important;\n  }\n  .min-h-md-450px {\n    min-height: 450px !important;\n  }\n  .min-h-md-475px {\n    min-height: 475px !important;\n  }\n  .min-h-md-500px {\n    min-height: 500px !important;\n  }\n  .min-h-md-550px {\n    min-height: 550px !important;\n  }\n  .min-h-md-600px {\n    min-height: 600px !important;\n  }\n  .min-h-md-650px {\n    min-height: 650px !important;\n  }\n  .min-h-md-700px {\n    min-height: 700px !important;\n  }\n  .min-h-md-750px {\n    min-height: 750px !important;\n  }\n  .min-h-md-800px {\n    min-height: 800px !important;\n  }\n  .min-h-md-850px {\n    min-height: 850px !important;\n  }\n  .min-h-md-900px {\n    min-height: 900px !important;\n  }\n  .min-h-md-950px {\n    min-height: 950px !important;\n  }\n  .min-h-md-1000px {\n    min-height: 1000px !important;\n  }\n}\n@media (min-width: 992px) {\n  .float-lg-start {\n    float: left !important;\n  }\n  .float-lg-end {\n    float: right !important;\n  }\n  .float-lg-none {\n    float: none !important;\n  }\n  .object-fit-lg-contain {\n    object-fit: contain !important;\n  }\n  .object-fit-lg-cover {\n    object-fit: cover !important;\n  }\n  .object-fit-lg-fill {\n    object-fit: fill !important;\n  }\n  .object-fit-lg-scale {\n    object-fit: scale-down !important;\n  }\n  .object-fit-lg-none {\n    object-fit: none !important;\n  }\n  .overflow-lg-auto {\n    overflow: auto !important;\n  }\n  .overflow-lg-hidden {\n    overflow: hidden !important;\n  }\n  .overflow-lg-visible {\n    overflow: visible !important;\n  }\n  .overflow-lg-scroll {\n    overflow: scroll !important;\n  }\n  .d-lg-inline {\n    display: inline !important;\n  }\n  .d-lg-inline-block {\n    display: inline-block !important;\n  }\n  .d-lg-block {\n    display: block !important;\n  }\n  .d-lg-grid {\n    display: grid !important;\n  }\n  .d-lg-table {\n    display: table !important;\n  }\n  .d-lg-table-row {\n    display: table-row !important;\n  }\n  .d-lg-table-cell {\n    display: table-cell !important;\n  }\n  .d-lg-flex {\n    display: flex !important;\n  }\n  .d-lg-inline-flex {\n    display: inline-flex !important;\n  }\n  .d-lg-none {\n    display: none !important;\n  }\n  .position-lg-static {\n    position: static !important;\n  }\n  .position-lg-relative {\n    position: relative !important;\n  }\n  .position-lg-absolute {\n    position: absolute !important;\n  }\n  .position-lg-fixed {\n    position: fixed !important;\n  }\n  .position-lg-sticky {\n    position: sticky !important;\n  }\n  .w-lg-unset {\n    width: unset !important;\n  }\n  .w-lg-25 {\n    width: 25% !important;\n  }\n  .w-lg-50 {\n    width: 50% !important;\n  }\n  .w-lg-75 {\n    width: 75% !important;\n  }\n  .w-lg-100 {\n    width: 100% !important;\n  }\n  .w-lg-auto {\n    width: auto !important;\n  }\n  .w-lg-1px {\n    width: 1px !important;\n  }\n  .w-lg-2px {\n    width: 2px !important;\n  }\n  .w-lg-3px {\n    width: 3px !important;\n  }\n  .w-lg-4px {\n    width: 4px !important;\n  }\n  .w-lg-5px {\n    width: 5px !important;\n  }\n  .w-lg-6px {\n    width: 6px !important;\n  }\n  .w-lg-7px {\n    width: 7px !important;\n  }\n  .w-lg-8px {\n    width: 8px !important;\n  }\n  .w-lg-9px {\n    width: 9px !important;\n  }\n  .w-lg-10px {\n    width: 10px !important;\n  }\n  .w-lg-15px {\n    width: 15px !important;\n  }\n  .w-lg-20px {\n    width: 20px !important;\n  }\n  .w-lg-25px {\n    width: 25px !important;\n  }\n  .w-lg-30px {\n    width: 30px !important;\n  }\n  .w-lg-35px {\n    width: 35px !important;\n  }\n  .w-lg-40px {\n    width: 40px !important;\n  }\n  .w-lg-45px {\n    width: 45px !important;\n  }\n  .w-lg-50px {\n    width: 50px !important;\n  }\n  .w-lg-55px {\n    width: 55px !important;\n  }\n  .w-lg-60px {\n    width: 60px !important;\n  }\n  .w-lg-65px {\n    width: 65px !important;\n  }\n  .w-lg-70px {\n    width: 70px !important;\n  }\n  .w-lg-75px {\n    width: 75px !important;\n  }\n  .w-lg-80px {\n    width: 80px !important;\n  }\n  .w-lg-85px {\n    width: 85px !important;\n  }\n  .w-lg-90px {\n    width: 90px !important;\n  }\n  .w-lg-95px {\n    width: 95px !important;\n  }\n  .w-lg-100px {\n    width: 100px !important;\n  }\n  .w-lg-125px {\n    width: 125px !important;\n  }\n  .w-lg-150px {\n    width: 150px !important;\n  }\n  .w-lg-175px {\n    width: 175px !important;\n  }\n  .w-lg-200px {\n    width: 200px !important;\n  }\n  .w-lg-225px {\n    width: 225px !important;\n  }\n  .w-lg-250px {\n    width: 250px !important;\n  }\n  .w-lg-275px {\n    width: 275px !important;\n  }\n  .w-lg-300px {\n    width: 300px !important;\n  }\n  .w-lg-325px {\n    width: 325px !important;\n  }\n  .w-lg-350px {\n    width: 350px !important;\n  }\n  .w-lg-375px {\n    width: 375px !important;\n  }\n  .w-lg-400px {\n    width: 400px !important;\n  }\n  .w-lg-425px {\n    width: 425px !important;\n  }\n  .w-lg-450px {\n    width: 450px !important;\n  }\n  .w-lg-475px {\n    width: 475px !important;\n  }\n  .w-lg-500px {\n    width: 500px !important;\n  }\n  .w-lg-550px {\n    width: 550px !important;\n  }\n  .w-lg-600px {\n    width: 600px !important;\n  }\n  .w-lg-650px {\n    width: 650px !important;\n  }\n  .w-lg-700px {\n    width: 700px !important;\n  }\n  .w-lg-750px {\n    width: 750px !important;\n  }\n  .w-lg-800px {\n    width: 800px !important;\n  }\n  .w-lg-850px {\n    width: 850px !important;\n  }\n  .w-lg-900px {\n    width: 900px !important;\n  }\n  .w-lg-950px {\n    width: 950px !important;\n  }\n  .w-lg-1000px {\n    width: 1000px !important;\n  }\n  .mw-lg-unset {\n    max-width: unset !important;\n  }\n  .mw-lg-25 {\n    max-width: 25% !important;\n  }\n  .mw-lg-50 {\n    max-width: 50% !important;\n  }\n  .mw-lg-75 {\n    max-width: 75% !important;\n  }\n  .mw-lg-100 {\n    max-width: 100% !important;\n  }\n  .mw-lg-auto {\n    max-width: auto !important;\n  }\n  .mw-lg-1px {\n    max-width: 1px !important;\n  }\n  .mw-lg-2px {\n    max-width: 2px !important;\n  }\n  .mw-lg-3px {\n    max-width: 3px !important;\n  }\n  .mw-lg-4px {\n    max-width: 4px !important;\n  }\n  .mw-lg-5px {\n    max-width: 5px !important;\n  }\n  .mw-lg-6px {\n    max-width: 6px !important;\n  }\n  .mw-lg-7px {\n    max-width: 7px !important;\n  }\n  .mw-lg-8px {\n    max-width: 8px !important;\n  }\n  .mw-lg-9px {\n    max-width: 9px !important;\n  }\n  .mw-lg-10px {\n    max-width: 10px !important;\n  }\n  .mw-lg-15px {\n    max-width: 15px !important;\n  }\n  .mw-lg-20px {\n    max-width: 20px !important;\n  }\n  .mw-lg-25px {\n    max-width: 25px !important;\n  }\n  .mw-lg-30px {\n    max-width: 30px !important;\n  }\n  .mw-lg-35px {\n    max-width: 35px !important;\n  }\n  .mw-lg-40px {\n    max-width: 40px !important;\n  }\n  .mw-lg-45px {\n    max-width: 45px !important;\n  }\n  .mw-lg-50px {\n    max-width: 50px !important;\n  }\n  .mw-lg-55px {\n    max-width: 55px !important;\n  }\n  .mw-lg-60px {\n    max-width: 60px !important;\n  }\n  .mw-lg-65px {\n    max-width: 65px !important;\n  }\n  .mw-lg-70px {\n    max-width: 70px !important;\n  }\n  .mw-lg-75px {\n    max-width: 75px !important;\n  }\n  .mw-lg-80px {\n    max-width: 80px !important;\n  }\n  .mw-lg-85px {\n    max-width: 85px !important;\n  }\n  .mw-lg-90px {\n    max-width: 90px !important;\n  }\n  .mw-lg-95px {\n    max-width: 95px !important;\n  }\n  .mw-lg-100px {\n    max-width: 100px !important;\n  }\n  .mw-lg-125px {\n    max-width: 125px !important;\n  }\n  .mw-lg-150px {\n    max-width: 150px !important;\n  }\n  .mw-lg-175px {\n    max-width: 175px !important;\n  }\n  .mw-lg-200px {\n    max-width: 200px !important;\n  }\n  .mw-lg-225px {\n    max-width: 225px !important;\n  }\n  .mw-lg-250px {\n    max-width: 250px !important;\n  }\n  .mw-lg-275px {\n    max-width: 275px !important;\n  }\n  .mw-lg-300px {\n    max-width: 300px !important;\n  }\n  .mw-lg-325px {\n    max-width: 325px !important;\n  }\n  .mw-lg-350px {\n    max-width: 350px !important;\n  }\n  .mw-lg-375px {\n    max-width: 375px !important;\n  }\n  .mw-lg-400px {\n    max-width: 400px !important;\n  }\n  .mw-lg-425px {\n    max-width: 425px !important;\n  }\n  .mw-lg-450px {\n    max-width: 450px !important;\n  }\n  .mw-lg-475px {\n    max-width: 475px !important;\n  }\n  .mw-lg-500px {\n    max-width: 500px !important;\n  }\n  .mw-lg-550px {\n    max-width: 550px !important;\n  }\n  .mw-lg-600px {\n    max-width: 600px !important;\n  }\n  .mw-lg-650px {\n    max-width: 650px !important;\n  }\n  .mw-lg-700px {\n    max-width: 700px !important;\n  }\n  .mw-lg-750px {\n    max-width: 750px !important;\n  }\n  .mw-lg-800px {\n    max-width: 800px !important;\n  }\n  .mw-lg-850px {\n    max-width: 850px !important;\n  }\n  .mw-lg-900px {\n    max-width: 900px !important;\n  }\n  .mw-lg-950px {\n    max-width: 950px !important;\n  }\n  .mw-lg-1000px {\n    max-width: 1000px !important;\n  }\n  .h-lg-unset {\n    height: unset !important;\n  }\n  .h-lg-25 {\n    height: 25% !important;\n  }\n  .h-lg-50 {\n    height: 50% !important;\n  }\n  .h-lg-75 {\n    height: 75% !important;\n  }\n  .h-lg-100 {\n    height: 100% !important;\n  }\n  .h-lg-auto {\n    height: auto !important;\n  }\n  .h-lg-1px {\n    height: 1px !important;\n  }\n  .h-lg-2px {\n    height: 2px !important;\n  }\n  .h-lg-3px {\n    height: 3px !important;\n  }\n  .h-lg-4px {\n    height: 4px !important;\n  }\n  .h-lg-5px {\n    height: 5px !important;\n  }\n  .h-lg-6px {\n    height: 6px !important;\n  }\n  .h-lg-7px {\n    height: 7px !important;\n  }\n  .h-lg-8px {\n    height: 8px !important;\n  }\n  .h-lg-9px {\n    height: 9px !important;\n  }\n  .h-lg-10px {\n    height: 10px !important;\n  }\n  .h-lg-15px {\n    height: 15px !important;\n  }\n  .h-lg-20px {\n    height: 20px !important;\n  }\n  .h-lg-25px {\n    height: 25px !important;\n  }\n  .h-lg-30px {\n    height: 30px !important;\n  }\n  .h-lg-35px {\n    height: 35px !important;\n  }\n  .h-lg-40px {\n    height: 40px !important;\n  }\n  .h-lg-45px {\n    height: 45px !important;\n  }\n  .h-lg-50px {\n    height: 50px !important;\n  }\n  .h-lg-55px {\n    height: 55px !important;\n  }\n  .h-lg-60px {\n    height: 60px !important;\n  }\n  .h-lg-65px {\n    height: 65px !important;\n  }\n  .h-lg-70px {\n    height: 70px !important;\n  }\n  .h-lg-75px {\n    height: 75px !important;\n  }\n  .h-lg-80px {\n    height: 80px !important;\n  }\n  .h-lg-85px {\n    height: 85px !important;\n  }\n  .h-lg-90px {\n    height: 90px !important;\n  }\n  .h-lg-95px {\n    height: 95px !important;\n  }\n  .h-lg-100px {\n    height: 100px !important;\n  }\n  .h-lg-125px {\n    height: 125px !important;\n  }\n  .h-lg-150px {\n    height: 150px !important;\n  }\n  .h-lg-175px {\n    height: 175px !important;\n  }\n  .h-lg-200px {\n    height: 200px !important;\n  }\n  .h-lg-225px {\n    height: 225px !important;\n  }\n  .h-lg-250px {\n    height: 250px !important;\n  }\n  .h-lg-275px {\n    height: 275px !important;\n  }\n  .h-lg-300px {\n    height: 300px !important;\n  }\n  .h-lg-325px {\n    height: 325px !important;\n  }\n  .h-lg-350px {\n    height: 350px !important;\n  }\n  .h-lg-375px {\n    height: 375px !important;\n  }\n  .h-lg-400px {\n    height: 400px !important;\n  }\n  .h-lg-425px {\n    height: 425px !important;\n  }\n  .h-lg-450px {\n    height: 450px !important;\n  }\n  .h-lg-475px {\n    height: 475px !important;\n  }\n  .h-lg-500px {\n    height: 500px !important;\n  }\n  .h-lg-550px {\n    height: 550px !important;\n  }\n  .h-lg-600px {\n    height: 600px !important;\n  }\n  .h-lg-650px {\n    height: 650px !important;\n  }\n  .h-lg-700px {\n    height: 700px !important;\n  }\n  .h-lg-750px {\n    height: 750px !important;\n  }\n  .h-lg-800px {\n    height: 800px !important;\n  }\n  .h-lg-850px {\n    height: 850px !important;\n  }\n  .h-lg-900px {\n    height: 900px !important;\n  }\n  .h-lg-950px {\n    height: 950px !important;\n  }\n  .h-lg-1000px {\n    height: 1000px !important;\n  }\n  .mh-lg-unset {\n    max-height: unset !important;\n  }\n  .mh-lg-25 {\n    max-height: 25% !important;\n  }\n  .mh-lg-50 {\n    max-height: 50% !important;\n  }\n  .mh-lg-75 {\n    max-height: 75% !important;\n  }\n  .mh-lg-100 {\n    max-height: 100% !important;\n  }\n  .mh-lg-auto {\n    max-height: auto !important;\n  }\n  .mh-lg-1px {\n    max-height: 1px !important;\n  }\n  .mh-lg-2px {\n    max-height: 2px !important;\n  }\n  .mh-lg-3px {\n    max-height: 3px !important;\n  }\n  .mh-lg-4px {\n    max-height: 4px !important;\n  }\n  .mh-lg-5px {\n    max-height: 5px !important;\n  }\n  .mh-lg-6px {\n    max-height: 6px !important;\n  }\n  .mh-lg-7px {\n    max-height: 7px !important;\n  }\n  .mh-lg-8px {\n    max-height: 8px !important;\n  }\n  .mh-lg-9px {\n    max-height: 9px !important;\n  }\n  .mh-lg-10px {\n    max-height: 10px !important;\n  }\n  .mh-lg-15px {\n    max-height: 15px !important;\n  }\n  .mh-lg-20px {\n    max-height: 20px !important;\n  }\n  .mh-lg-25px {\n    max-height: 25px !important;\n  }\n  .mh-lg-30px {\n    max-height: 30px !important;\n  }\n  .mh-lg-35px {\n    max-height: 35px !important;\n  }\n  .mh-lg-40px {\n    max-height: 40px !important;\n  }\n  .mh-lg-45px {\n    max-height: 45px !important;\n  }\n  .mh-lg-50px {\n    max-height: 50px !important;\n  }\n  .mh-lg-55px {\n    max-height: 55px !important;\n  }\n  .mh-lg-60px {\n    max-height: 60px !important;\n  }\n  .mh-lg-65px {\n    max-height: 65px !important;\n  }\n  .mh-lg-70px {\n    max-height: 70px !important;\n  }\n  .mh-lg-75px {\n    max-height: 75px !important;\n  }\n  .mh-lg-80px {\n    max-height: 80px !important;\n  }\n  .mh-lg-85px {\n    max-height: 85px !important;\n  }\n  .mh-lg-90px {\n    max-height: 90px !important;\n  }\n  .mh-lg-95px {\n    max-height: 95px !important;\n  }\n  .mh-lg-100px {\n    max-height: 100px !important;\n  }\n  .mh-lg-125px {\n    max-height: 125px !important;\n  }\n  .mh-lg-150px {\n    max-height: 150px !important;\n  }\n  .mh-lg-175px {\n    max-height: 175px !important;\n  }\n  .mh-lg-200px {\n    max-height: 200px !important;\n  }\n  .mh-lg-225px {\n    max-height: 225px !important;\n  }\n  .mh-lg-250px {\n    max-height: 250px !important;\n  }\n  .mh-lg-275px {\n    max-height: 275px !important;\n  }\n  .mh-lg-300px {\n    max-height: 300px !important;\n  }\n  .mh-lg-325px {\n    max-height: 325px !important;\n  }\n  .mh-lg-350px {\n    max-height: 350px !important;\n  }\n  .mh-lg-375px {\n    max-height: 375px !important;\n  }\n  .mh-lg-400px {\n    max-height: 400px !important;\n  }\n  .mh-lg-425px {\n    max-height: 425px !important;\n  }\n  .mh-lg-450px {\n    max-height: 450px !important;\n  }\n  .mh-lg-475px {\n    max-height: 475px !important;\n  }\n  .mh-lg-500px {\n    max-height: 500px !important;\n  }\n  .mh-lg-550px {\n    max-height: 550px !important;\n  }\n  .mh-lg-600px {\n    max-height: 600px !important;\n  }\n  .mh-lg-650px {\n    max-height: 650px !important;\n  }\n  .mh-lg-700px {\n    max-height: 700px !important;\n  }\n  .mh-lg-750px {\n    max-height: 750px !important;\n  }\n  .mh-lg-800px {\n    max-height: 800px !important;\n  }\n  .mh-lg-850px {\n    max-height: 850px !important;\n  }\n  .mh-lg-900px {\n    max-height: 900px !important;\n  }\n  .mh-lg-950px {\n    max-height: 950px !important;\n  }\n  .mh-lg-1000px {\n    max-height: 1000px !important;\n  }\n  .flex-lg-fill {\n    flex: 1 1 auto !important;\n  }\n  .flex-lg-row {\n    flex-direction: row !important;\n  }\n  .flex-lg-column {\n    flex-direction: column !important;\n  }\n  .flex-lg-row-reverse {\n    flex-direction: row-reverse !important;\n  }\n  .flex-lg-column-reverse {\n    flex-direction: column-reverse !important;\n  }\n  .flex-lg-grow-0 {\n    flex-grow: 0 !important;\n  }\n  .flex-lg-grow-1 {\n    flex-grow: 1 !important;\n  }\n  .flex-lg-shrink-0 {\n    flex-shrink: 0 !important;\n  }\n  .flex-lg-shrink-1 {\n    flex-shrink: 1 !important;\n  }\n  .flex-lg-wrap {\n    flex-wrap: wrap !important;\n  }\n  .flex-lg-nowrap {\n    flex-wrap: nowrap !important;\n  }\n  .flex-lg-wrap-reverse {\n    flex-wrap: wrap-reverse !important;\n  }\n  .justify-content-lg-start {\n    justify-content: flex-start !important;\n  }\n  .justify-content-lg-end {\n    justify-content: flex-end !important;\n  }\n  .justify-content-lg-center {\n    justify-content: center !important;\n  }\n  .justify-content-lg-between {\n    justify-content: space-between !important;\n  }\n  .justify-content-lg-around {\n    justify-content: space-around !important;\n  }\n  .justify-content-lg-evenly {\n    justify-content: space-evenly !important;\n  }\n  .align-items-lg-start {\n    align-items: flex-start !important;\n  }\n  .align-items-lg-end {\n    align-items: flex-end !important;\n  }\n  .align-items-lg-center {\n    align-items: center !important;\n  }\n  .align-items-lg-baseline {\n    align-items: baseline !important;\n  }\n  .align-items-lg-stretch {\n    align-items: stretch !important;\n  }\n  .align-content-lg-start {\n    align-content: flex-start !important;\n  }\n  .align-content-lg-end {\n    align-content: flex-end !important;\n  }\n  .align-content-lg-center {\n    align-content: center !important;\n  }\n  .align-content-lg-between {\n    align-content: space-between !important;\n  }\n  .align-content-lg-around {\n    align-content: space-around !important;\n  }\n  .align-content-lg-stretch {\n    align-content: stretch !important;\n  }\n  .align-self-lg-auto {\n    align-self: auto !important;\n  }\n  .align-self-lg-start {\n    align-self: flex-start !important;\n  }\n  .align-self-lg-end {\n    align-self: flex-end !important;\n  }\n  .align-self-lg-center {\n    align-self: center !important;\n  }\n  .align-self-lg-baseline {\n    align-self: baseline !important;\n  }\n  .align-self-lg-stretch {\n    align-self: stretch !important;\n  }\n  .order-lg-first {\n    order: -1 !important;\n  }\n  .order-lg-0 {\n    order: 0 !important;\n  }\n  .order-lg-1 {\n    order: 1 !important;\n  }\n  .order-lg-2 {\n    order: 2 !important;\n  }\n  .order-lg-3 {\n    order: 3 !important;\n  }\n  .order-lg-4 {\n    order: 4 !important;\n  }\n  .order-lg-5 {\n    order: 5 !important;\n  }\n  .order-lg-last {\n    order: 6 !important;\n  }\n  .m-lg-0 {\n    margin: 0 !important;\n  }\n  .m-lg-1 {\n    margin: 0.25rem !important;\n  }\n  .m-lg-2 {\n    margin: 0.5rem !important;\n  }\n  .m-lg-3 {\n    margin: 0.75rem !important;\n  }\n  .m-lg-4 {\n    margin: 1rem !important;\n  }\n  .m-lg-5 {\n    margin: 1.25rem !important;\n  }\n  .m-lg-6 {\n    margin: 1.5rem !important;\n  }\n  .m-lg-7 {\n    margin: 1.75rem !important;\n  }\n  .m-lg-8 {\n    margin: 2rem !important;\n  }\n  .m-lg-9 {\n    margin: 2.25rem !important;\n  }\n  .m-lg-10 {\n    margin: 2.5rem !important;\n  }\n  .m-lg-11 {\n    margin: 2.75rem !important;\n  }\n  .m-lg-12 {\n    margin: 3rem !important;\n  }\n  .m-lg-13 {\n    margin: 3.25rem !important;\n  }\n  .m-lg-14 {\n    margin: 3.5rem !important;\n  }\n  .m-lg-15 {\n    margin: 3.75rem !important;\n  }\n  .m-lg-16 {\n    margin: 4rem !important;\n  }\n  .m-lg-17 {\n    margin: 4.25rem !important;\n  }\n  .m-lg-18 {\n    margin: 4.5rem !important;\n  }\n  .m-lg-19 {\n    margin: 4.75rem !important;\n  }\n  .m-lg-20 {\n    margin: 5rem !important;\n  }\n  .m-lg-auto {\n    margin: auto !important;\n  }\n  .mx-lg-0 {\n    margin-right: 0 !important;\n    margin-left: 0 !important;\n  }\n  .mx-lg-1 {\n    margin-right: 0.25rem !important;\n    margin-left: 0.25rem !important;\n  }\n  .mx-lg-2 {\n    margin-right: 0.5rem !important;\n    margin-left: 0.5rem !important;\n  }\n  .mx-lg-3 {\n    margin-right: 0.75rem !important;\n    margin-left: 0.75rem !important;\n  }\n  .mx-lg-4 {\n    margin-right: 1rem !important;\n    margin-left: 1rem !important;\n  }\n  .mx-lg-5 {\n    margin-right: 1.25rem !important;\n    margin-left: 1.25rem !important;\n  }\n  .mx-lg-6 {\n    margin-right: 1.5rem !important;\n    margin-left: 1.5rem !important;\n  }\n  .mx-lg-7 {\n    margin-right: 1.75rem !important;\n    margin-left: 1.75rem !important;\n  }\n  .mx-lg-8 {\n    margin-right: 2rem !important;\n    margin-left: 2rem !important;\n  }\n  .mx-lg-9 {\n    margin-right: 2.25rem !important;\n    margin-left: 2.25rem !important;\n  }\n  .mx-lg-10 {\n    margin-right: 2.5rem !important;\n    margin-left: 2.5rem !important;\n  }\n  .mx-lg-11 {\n    margin-right: 2.75rem !important;\n    margin-left: 2.75rem !important;\n  }\n  .mx-lg-12 {\n    margin-right: 3rem !important;\n    margin-left: 3rem !important;\n  }\n  .mx-lg-13 {\n    margin-right: 3.25rem !important;\n    margin-left: 3.25rem !important;\n  }\n  .mx-lg-14 {\n    margin-right: 3.5rem !important;\n    margin-left: 3.5rem !important;\n  }\n  .mx-lg-15 {\n    margin-right: 3.75rem !important;\n    margin-left: 3.75rem !important;\n  }\n  .mx-lg-16 {\n    margin-right: 4rem !important;\n    margin-left: 4rem !important;\n  }\n  .mx-lg-17 {\n    margin-right: 4.25rem !important;\n    margin-left: 4.25rem !important;\n  }\n  .mx-lg-18 {\n    margin-right: 4.5rem !important;\n    margin-left: 4.5rem !important;\n  }\n  .mx-lg-19 {\n    margin-right: 4.75rem !important;\n    margin-left: 4.75rem !important;\n  }\n  .mx-lg-20 {\n    margin-right: 5rem !important;\n    margin-left: 5rem !important;\n  }\n  .mx-lg-auto {\n    margin-right: auto !important;\n    margin-left: auto !important;\n  }\n  .my-lg-0 {\n    margin-top: 0 !important;\n    margin-bottom: 0 !important;\n  }\n  .my-lg-1 {\n    margin-top: 0.25rem !important;\n    margin-bottom: 0.25rem !important;\n  }\n  .my-lg-2 {\n    margin-top: 0.5rem !important;\n    margin-bottom: 0.5rem !important;\n  }\n  .my-lg-3 {\n    margin-top: 0.75rem !important;\n    margin-bottom: 0.75rem !important;\n  }\n  .my-lg-4 {\n    margin-top: 1rem !important;\n    margin-bottom: 1rem !important;\n  }\n  .my-lg-5 {\n    margin-top: 1.25rem !important;\n    margin-bottom: 1.25rem !important;\n  }\n  .my-lg-6 {\n    margin-top: 1.5rem !important;\n    margin-bottom: 1.5rem !important;\n  }\n  .my-lg-7 {\n    margin-top: 1.75rem !important;\n    margin-bottom: 1.75rem !important;\n  }\n  .my-lg-8 {\n    margin-top: 2rem !important;\n    margin-bottom: 2rem !important;\n  }\n  .my-lg-9 {\n    margin-top: 2.25rem !important;\n    margin-bottom: 2.25rem !important;\n  }\n  .my-lg-10 {\n    margin-top: 2.5rem !important;\n    margin-bottom: 2.5rem !important;\n  }\n  .my-lg-11 {\n    margin-top: 2.75rem !important;\n    margin-bottom: 2.75rem !important;\n  }\n  .my-lg-12 {\n    margin-top: 3rem !important;\n    margin-bottom: 3rem !important;\n  }\n  .my-lg-13 {\n    margin-top: 3.25rem !important;\n    margin-bottom: 3.25rem !important;\n  }\n  .my-lg-14 {\n    margin-top: 3.5rem !important;\n    margin-bottom: 3.5rem !important;\n  }\n  .my-lg-15 {\n    margin-top: 3.75rem !important;\n    margin-bottom: 3.75rem !important;\n  }\n  .my-lg-16 {\n    margin-top: 4rem !important;\n    margin-bottom: 4rem !important;\n  }\n  .my-lg-17 {\n    margin-top: 4.25rem !important;\n    margin-bottom: 4.25rem !important;\n  }\n  .my-lg-18 {\n    margin-top: 4.5rem !important;\n    margin-bottom: 4.5rem !important;\n  }\n  .my-lg-19 {\n    margin-top: 4.75rem !important;\n    margin-bottom: 4.75rem !important;\n  }\n  .my-lg-20 {\n    margin-top: 5rem !important;\n    margin-bottom: 5rem !important;\n  }\n  .my-lg-auto {\n    margin-top: auto !important;\n    margin-bottom: auto !important;\n  }\n  .mt-lg-0 {\n    margin-top: 0 !important;\n  }\n  .mt-lg-1 {\n    margin-top: 0.25rem !important;\n  }\n  .mt-lg-2 {\n    margin-top: 0.5rem !important;\n  }\n  .mt-lg-3 {\n    margin-top: 0.75rem !important;\n  }\n  .mt-lg-4 {\n    margin-top: 1rem !important;\n  }\n  .mt-lg-5 {\n    margin-top: 1.25rem !important;\n  }\n  .mt-lg-6 {\n    margin-top: 1.5rem !important;\n  }\n  .mt-lg-7 {\n    margin-top: 1.75rem !important;\n  }\n  .mt-lg-8 {\n    margin-top: 2rem !important;\n  }\n  .mt-lg-9 {\n    margin-top: 2.25rem !important;\n  }\n  .mt-lg-10 {\n    margin-top: 2.5rem !important;\n  }\n  .mt-lg-11 {\n    margin-top: 2.75rem !important;\n  }\n  .mt-lg-12 {\n    margin-top: 3rem !important;\n  }\n  .mt-lg-13 {\n    margin-top: 3.25rem !important;\n  }\n  .mt-lg-14 {\n    margin-top: 3.5rem !important;\n  }\n  .mt-lg-15 {\n    margin-top: 3.75rem !important;\n  }\n  .mt-lg-16 {\n    margin-top: 4rem !important;\n  }\n  .mt-lg-17 {\n    margin-top: 4.25rem !important;\n  }\n  .mt-lg-18 {\n    margin-top: 4.5rem !important;\n  }\n  .mt-lg-19 {\n    margin-top: 4.75rem !important;\n  }\n  .mt-lg-20 {\n    margin-top: 5rem !important;\n  }\n  .mt-lg-auto {\n    margin-top: auto !important;\n  }\n  .me-lg-0 {\n    margin-right: 0 !important;\n  }\n  .me-lg-1 {\n    margin-right: 0.25rem !important;\n  }\n  .me-lg-2 {\n    margin-right: 0.5rem !important;\n  }\n  .me-lg-3 {\n    margin-right: 0.75rem !important;\n  }\n  .me-lg-4 {\n    margin-right: 1rem !important;\n  }\n  .me-lg-5 {\n    margin-right: 1.25rem !important;\n  }\n  .me-lg-6 {\n    margin-right: 1.5rem !important;\n  }\n  .me-lg-7 {\n    margin-right: 1.75rem !important;\n  }\n  .me-lg-8 {\n    margin-right: 2rem !important;\n  }\n  .me-lg-9 {\n    margin-right: 2.25rem !important;\n  }\n  .me-lg-10 {\n    margin-right: 2.5rem !important;\n  }\n  .me-lg-11 {\n    margin-right: 2.75rem !important;\n  }\n  .me-lg-12 {\n    margin-right: 3rem !important;\n  }\n  .me-lg-13 {\n    margin-right: 3.25rem !important;\n  }\n  .me-lg-14 {\n    margin-right: 3.5rem !important;\n  }\n  .me-lg-15 {\n    margin-right: 3.75rem !important;\n  }\n  .me-lg-16 {\n    margin-right: 4rem !important;\n  }\n  .me-lg-17 {\n    margin-right: 4.25rem !important;\n  }\n  .me-lg-18 {\n    margin-right: 4.5rem !important;\n  }\n  .me-lg-19 {\n    margin-right: 4.75rem !important;\n  }\n  .me-lg-20 {\n    margin-right: 5rem !important;\n  }\n  .me-lg-auto {\n    margin-right: auto !important;\n  }\n  .mb-lg-0 {\n    margin-bottom: 0 !important;\n  }\n  .mb-lg-1 {\n    margin-bottom: 0.25rem !important;\n  }\n  .mb-lg-2 {\n    margin-bottom: 0.5rem !important;\n  }\n  .mb-lg-3 {\n    margin-bottom: 0.75rem !important;\n  }\n  .mb-lg-4 {\n    margin-bottom: 1rem !important;\n  }\n  .mb-lg-5 {\n    margin-bottom: 1.25rem !important;\n  }\n  .mb-lg-6 {\n    margin-bottom: 1.5rem !important;\n  }\n  .mb-lg-7 {\n    margin-bottom: 1.75rem !important;\n  }\n  .mb-lg-8 {\n    margin-bottom: 2rem !important;\n  }\n  .mb-lg-9 {\n    margin-bottom: 2.25rem !important;\n  }\n  .mb-lg-10 {\n    margin-bottom: 2.5rem !important;\n  }\n  .mb-lg-11 {\n    margin-bottom: 2.75rem !important;\n  }\n  .mb-lg-12 {\n    margin-bottom: 3rem !important;\n  }\n  .mb-lg-13 {\n    margin-bottom: 3.25rem !important;\n  }\n  .mb-lg-14 {\n    margin-bottom: 3.5rem !important;\n  }\n  .mb-lg-15 {\n    margin-bottom: 3.75rem !important;\n  }\n  .mb-lg-16 {\n    margin-bottom: 4rem !important;\n  }\n  .mb-lg-17 {\n    margin-bottom: 4.25rem !important;\n  }\n  .mb-lg-18 {\n    margin-bottom: 4.5rem !important;\n  }\n  .mb-lg-19 {\n    margin-bottom: 4.75rem !important;\n  }\n  .mb-lg-20 {\n    margin-bottom: 5rem !important;\n  }\n  .mb-lg-auto {\n    margin-bottom: auto !important;\n  }\n  .ms-lg-0 {\n    margin-left: 0 !important;\n  }\n  .ms-lg-1 {\n    margin-left: 0.25rem !important;\n  }\n  .ms-lg-2 {\n    margin-left: 0.5rem !important;\n  }\n  .ms-lg-3 {\n    margin-left: 0.75rem !important;\n  }\n  .ms-lg-4 {\n    margin-left: 1rem !important;\n  }\n  .ms-lg-5 {\n    margin-left: 1.25rem !important;\n  }\n  .ms-lg-6 {\n    margin-left: 1.5rem !important;\n  }\n  .ms-lg-7 {\n    margin-left: 1.75rem !important;\n  }\n  .ms-lg-8 {\n    margin-left: 2rem !important;\n  }\n  .ms-lg-9 {\n    margin-left: 2.25rem !important;\n  }\n  .ms-lg-10 {\n    margin-left: 2.5rem !important;\n  }\n  .ms-lg-11 {\n    margin-left: 2.75rem !important;\n  }\n  .ms-lg-12 {\n    margin-left: 3rem !important;\n  }\n  .ms-lg-13 {\n    margin-left: 3.25rem !important;\n  }\n  .ms-lg-14 {\n    margin-left: 3.5rem !important;\n  }\n  .ms-lg-15 {\n    margin-left: 3.75rem !important;\n  }\n  .ms-lg-16 {\n    margin-left: 4rem !important;\n  }\n  .ms-lg-17 {\n    margin-left: 4.25rem !important;\n  }\n  .ms-lg-18 {\n    margin-left: 4.5rem !important;\n  }\n  .ms-lg-19 {\n    margin-left: 4.75rem !important;\n  }\n  .ms-lg-20 {\n    margin-left: 5rem !important;\n  }\n  .ms-lg-auto {\n    margin-left: auto !important;\n  }\n  .m-lg-n1 {\n    margin: -0.25rem !important;\n  }\n  .m-lg-n2 {\n    margin: -0.5rem !important;\n  }\n  .m-lg-n3 {\n    margin: -0.75rem !important;\n  }\n  .m-lg-n4 {\n    margin: -1rem !important;\n  }\n  .m-lg-n5 {\n    margin: -1.25rem !important;\n  }\n  .m-lg-n6 {\n    margin: -1.5rem !important;\n  }\n  .m-lg-n7 {\n    margin: -1.75rem !important;\n  }\n  .m-lg-n8 {\n    margin: -2rem !important;\n  }\n  .m-lg-n9 {\n    margin: -2.25rem !important;\n  }\n  .m-lg-n10 {\n    margin: -2.5rem !important;\n  }\n  .m-lg-n11 {\n    margin: -2.75rem !important;\n  }\n  .m-lg-n12 {\n    margin: -3rem !important;\n  }\n  .m-lg-n13 {\n    margin: -3.25rem !important;\n  }\n  .m-lg-n14 {\n    margin: -3.5rem !important;\n  }\n  .m-lg-n15 {\n    margin: -3.75rem !important;\n  }\n  .m-lg-n16 {\n    margin: -4rem !important;\n  }\n  .m-lg-n17 {\n    margin: -4.25rem !important;\n  }\n  .m-lg-n18 {\n    margin: -4.5rem !important;\n  }\n  .m-lg-n19 {\n    margin: -4.75rem !important;\n  }\n  .m-lg-n20 {\n    margin: -5rem !important;\n  }\n  .mx-lg-n1 {\n    margin-right: -0.25rem !important;\n    margin-left: -0.25rem !important;\n  }\n  .mx-lg-n2 {\n    margin-right: -0.5rem !important;\n    margin-left: -0.5rem !important;\n  }\n  .mx-lg-n3 {\n    margin-right: -0.75rem !important;\n    margin-left: -0.75rem !important;\n  }\n  .mx-lg-n4 {\n    margin-right: -1rem !important;\n    margin-left: -1rem !important;\n  }\n  .mx-lg-n5 {\n    margin-right: -1.25rem !important;\n    margin-left: -1.25rem !important;\n  }\n  .mx-lg-n6 {\n    margin-right: -1.5rem !important;\n    margin-left: -1.5rem !important;\n  }\n  .mx-lg-n7 {\n    margin-right: -1.75rem !important;\n    margin-left: -1.75rem !important;\n  }\n  .mx-lg-n8 {\n    margin-right: -2rem !important;\n    margin-left: -2rem !important;\n  }\n  .mx-lg-n9 {\n    margin-right: -2.25rem !important;\n    margin-left: -2.25rem !important;\n  }\n  .mx-lg-n10 {\n    margin-right: -2.5rem !important;\n    margin-left: -2.5rem !important;\n  }\n  .mx-lg-n11 {\n    margin-right: -2.75rem !important;\n    margin-left: -2.75rem !important;\n  }\n  .mx-lg-n12 {\n    margin-right: -3rem !important;\n    margin-left: -3rem !important;\n  }\n  .mx-lg-n13 {\n    margin-right: -3.25rem !important;\n    margin-left: -3.25rem !important;\n  }\n  .mx-lg-n14 {\n    margin-right: -3.5rem !important;\n    margin-left: -3.5rem !important;\n  }\n  .mx-lg-n15 {\n    margin-right: -3.75rem !important;\n    margin-left: -3.75rem !important;\n  }\n  .mx-lg-n16 {\n    margin-right: -4rem !important;\n    margin-left: -4rem !important;\n  }\n  .mx-lg-n17 {\n    margin-right: -4.25rem !important;\n    margin-left: -4.25rem !important;\n  }\n  .mx-lg-n18 {\n    margin-right: -4.5rem !important;\n    margin-left: -4.5rem !important;\n  }\n  .mx-lg-n19 {\n    margin-right: -4.75rem !important;\n    margin-left: -4.75rem !important;\n  }\n  .mx-lg-n20 {\n    margin-right: -5rem !important;\n    margin-left: -5rem !important;\n  }\n  .my-lg-n1 {\n    margin-top: -0.25rem !important;\n    margin-bottom: -0.25rem !important;\n  }\n  .my-lg-n2 {\n    margin-top: -0.5rem !important;\n    margin-bottom: -0.5rem !important;\n  }\n  .my-lg-n3 {\n    margin-top: -0.75rem !important;\n    margin-bottom: -0.75rem !important;\n  }\n  .my-lg-n4 {\n    margin-top: -1rem !important;\n    margin-bottom: -1rem !important;\n  }\n  .my-lg-n5 {\n    margin-top: -1.25rem !important;\n    margin-bottom: -1.25rem !important;\n  }\n  .my-lg-n6 {\n    margin-top: -1.5rem !important;\n    margin-bottom: -1.5rem !important;\n  }\n  .my-lg-n7 {\n    margin-top: -1.75rem !important;\n    margin-bottom: -1.75rem !important;\n  }\n  .my-lg-n8 {\n    margin-top: -2rem !important;\n    margin-bottom: -2rem !important;\n  }\n  .my-lg-n9 {\n    margin-top: -2.25rem !important;\n    margin-bottom: -2.25rem !important;\n  }\n  .my-lg-n10 {\n    margin-top: -2.5rem !important;\n    margin-bottom: -2.5rem !important;\n  }\n  .my-lg-n11 {\n    margin-top: -2.75rem !important;\n    margin-bottom: -2.75rem !important;\n  }\n  .my-lg-n12 {\n    margin-top: -3rem !important;\n    margin-bottom: -3rem !important;\n  }\n  .my-lg-n13 {\n    margin-top: -3.25rem !important;\n    margin-bottom: -3.25rem !important;\n  }\n  .my-lg-n14 {\n    margin-top: -3.5rem !important;\n    margin-bottom: -3.5rem !important;\n  }\n  .my-lg-n15 {\n    margin-top: -3.75rem !important;\n    margin-bottom: -3.75rem !important;\n  }\n  .my-lg-n16 {\n    margin-top: -4rem !important;\n    margin-bottom: -4rem !important;\n  }\n  .my-lg-n17 {\n    margin-top: -4.25rem !important;\n    margin-bottom: -4.25rem !important;\n  }\n  .my-lg-n18 {\n    margin-top: -4.5rem !important;\n    margin-bottom: -4.5rem !important;\n  }\n  .my-lg-n19 {\n    margin-top: -4.75rem !important;\n    margin-bottom: -4.75rem !important;\n  }\n  .my-lg-n20 {\n    margin-top: -5rem !important;\n    margin-bottom: -5rem !important;\n  }\n  .mt-lg-n1 {\n    margin-top: -0.25rem !important;\n  }\n  .mt-lg-n2 {\n    margin-top: -0.5rem !important;\n  }\n  .mt-lg-n3 {\n    margin-top: -0.75rem !important;\n  }\n  .mt-lg-n4 {\n    margin-top: -1rem !important;\n  }\n  .mt-lg-n5 {\n    margin-top: -1.25rem !important;\n  }\n  .mt-lg-n6 {\n    margin-top: -1.5rem !important;\n  }\n  .mt-lg-n7 {\n    margin-top: -1.75rem !important;\n  }\n  .mt-lg-n8 {\n    margin-top: -2rem !important;\n  }\n  .mt-lg-n9 {\n    margin-top: -2.25rem !important;\n  }\n  .mt-lg-n10 {\n    margin-top: -2.5rem !important;\n  }\n  .mt-lg-n11 {\n    margin-top: -2.75rem !important;\n  }\n  .mt-lg-n12 {\n    margin-top: -3rem !important;\n  }\n  .mt-lg-n13 {\n    margin-top: -3.25rem !important;\n  }\n  .mt-lg-n14 {\n    margin-top: -3.5rem !important;\n  }\n  .mt-lg-n15 {\n    margin-top: -3.75rem !important;\n  }\n  .mt-lg-n16 {\n    margin-top: -4rem !important;\n  }\n  .mt-lg-n17 {\n    margin-top: -4.25rem !important;\n  }\n  .mt-lg-n18 {\n    margin-top: -4.5rem !important;\n  }\n  .mt-lg-n19 {\n    margin-top: -4.75rem !important;\n  }\n  .mt-lg-n20 {\n    margin-top: -5rem !important;\n  }\n  .me-lg-n1 {\n    margin-right: -0.25rem !important;\n  }\n  .me-lg-n2 {\n    margin-right: -0.5rem !important;\n  }\n  .me-lg-n3 {\n    margin-right: -0.75rem !important;\n  }\n  .me-lg-n4 {\n    margin-right: -1rem !important;\n  }\n  .me-lg-n5 {\n    margin-right: -1.25rem !important;\n  }\n  .me-lg-n6 {\n    margin-right: -1.5rem !important;\n  }\n  .me-lg-n7 {\n    margin-right: -1.75rem !important;\n  }\n  .me-lg-n8 {\n    margin-right: -2rem !important;\n  }\n  .me-lg-n9 {\n    margin-right: -2.25rem !important;\n  }\n  .me-lg-n10 {\n    margin-right: -2.5rem !important;\n  }\n  .me-lg-n11 {\n    margin-right: -2.75rem !important;\n  }\n  .me-lg-n12 {\n    margin-right: -3rem !important;\n  }\n  .me-lg-n13 {\n    margin-right: -3.25rem !important;\n  }\n  .me-lg-n14 {\n    margin-right: -3.5rem !important;\n  }\n  .me-lg-n15 {\n    margin-right: -3.75rem !important;\n  }\n  .me-lg-n16 {\n    margin-right: -4rem !important;\n  }\n  .me-lg-n17 {\n    margin-right: -4.25rem !important;\n  }\n  .me-lg-n18 {\n    margin-right: -4.5rem !important;\n  }\n  .me-lg-n19 {\n    margin-right: -4.75rem !important;\n  }\n  .me-lg-n20 {\n    margin-right: -5rem !important;\n  }\n  .mb-lg-n1 {\n    margin-bottom: -0.25rem !important;\n  }\n  .mb-lg-n2 {\n    margin-bottom: -0.5rem !important;\n  }\n  .mb-lg-n3 {\n    margin-bottom: -0.75rem !important;\n  }\n  .mb-lg-n4 {\n    margin-bottom: -1rem !important;\n  }\n  .mb-lg-n5 {\n    margin-bottom: -1.25rem !important;\n  }\n  .mb-lg-n6 {\n    margin-bottom: -1.5rem !important;\n  }\n  .mb-lg-n7 {\n    margin-bottom: -1.75rem !important;\n  }\n  .mb-lg-n8 {\n    margin-bottom: -2rem !important;\n  }\n  .mb-lg-n9 {\n    margin-bottom: -2.25rem !important;\n  }\n  .mb-lg-n10 {\n    margin-bottom: -2.5rem !important;\n  }\n  .mb-lg-n11 {\n    margin-bottom: -2.75rem !important;\n  }\n  .mb-lg-n12 {\n    margin-bottom: -3rem !important;\n  }\n  .mb-lg-n13 {\n    margin-bottom: -3.25rem !important;\n  }\n  .mb-lg-n14 {\n    margin-bottom: -3.5rem !important;\n  }\n  .mb-lg-n15 {\n    margin-bottom: -3.75rem !important;\n  }\n  .mb-lg-n16 {\n    margin-bottom: -4rem !important;\n  }\n  .mb-lg-n17 {\n    margin-bottom: -4.25rem !important;\n  }\n  .mb-lg-n18 {\n    margin-bottom: -4.5rem !important;\n  }\n  .mb-lg-n19 {\n    margin-bottom: -4.75rem !important;\n  }\n  .mb-lg-n20 {\n    margin-bottom: -5rem !important;\n  }\n  .ms-lg-n1 {\n    margin-left: -0.25rem !important;\n  }\n  .ms-lg-n2 {\n    margin-left: -0.5rem !important;\n  }\n  .ms-lg-n3 {\n    margin-left: -0.75rem !important;\n  }\n  .ms-lg-n4 {\n    margin-left: -1rem !important;\n  }\n  .ms-lg-n5 {\n    margin-left: -1.25rem !important;\n  }\n  .ms-lg-n6 {\n    margin-left: -1.5rem !important;\n  }\n  .ms-lg-n7 {\n    margin-left: -1.75rem !important;\n  }\n  .ms-lg-n8 {\n    margin-left: -2rem !important;\n  }\n  .ms-lg-n9 {\n    margin-left: -2.25rem !important;\n  }\n  .ms-lg-n10 {\n    margin-left: -2.5rem !important;\n  }\n  .ms-lg-n11 {\n    margin-left: -2.75rem !important;\n  }\n  .ms-lg-n12 {\n    margin-left: -3rem !important;\n  }\n  .ms-lg-n13 {\n    margin-left: -3.25rem !important;\n  }\n  .ms-lg-n14 {\n    margin-left: -3.5rem !important;\n  }\n  .ms-lg-n15 {\n    margin-left: -3.75rem !important;\n  }\n  .ms-lg-n16 {\n    margin-left: -4rem !important;\n  }\n  .ms-lg-n17 {\n    margin-left: -4.25rem !important;\n  }\n  .ms-lg-n18 {\n    margin-left: -4.5rem !important;\n  }\n  .ms-lg-n19 {\n    margin-left: -4.75rem !important;\n  }\n  .ms-lg-n20 {\n    margin-left: -5rem !important;\n  }\n  .p-lg-0 {\n    padding: 0 !important;\n  }\n  .p-lg-1 {\n    padding: 0.25rem !important;\n  }\n  .p-lg-2 {\n    padding: 0.5rem !important;\n  }\n  .p-lg-3 {\n    padding: 0.75rem !important;\n  }\n  .p-lg-4 {\n    padding: 1rem !important;\n  }\n  .p-lg-5 {\n    padding: 1.25rem !important;\n  }\n  .p-lg-6 {\n    padding: 1.5rem !important;\n  }\n  .p-lg-7 {\n    padding: 1.75rem !important;\n  }\n  .p-lg-8 {\n    padding: 2rem !important;\n  }\n  .p-lg-9 {\n    padding: 2.25rem !important;\n  }\n  .p-lg-10 {\n    padding: 2.5rem !important;\n  }\n  .p-lg-11 {\n    padding: 2.75rem !important;\n  }\n  .p-lg-12 {\n    padding: 3rem !important;\n  }\n  .p-lg-13 {\n    padding: 3.25rem !important;\n  }\n  .p-lg-14 {\n    padding: 3.5rem !important;\n  }\n  .p-lg-15 {\n    padding: 3.75rem !important;\n  }\n  .p-lg-16 {\n    padding: 4rem !important;\n  }\n  .p-lg-17 {\n    padding: 4.25rem !important;\n  }\n  .p-lg-18 {\n    padding: 4.5rem !important;\n  }\n  .p-lg-19 {\n    padding: 4.75rem !important;\n  }\n  .p-lg-20 {\n    padding: 5rem !important;\n  }\n  .px-lg-0 {\n    padding-right: 0 !important;\n    padding-left: 0 !important;\n  }\n  .px-lg-1 {\n    padding-right: 0.25rem !important;\n    padding-left: 0.25rem !important;\n  }\n  .px-lg-2 {\n    padding-right: 0.5rem !important;\n    padding-left: 0.5rem !important;\n  }\n  .px-lg-3 {\n    padding-right: 0.75rem !important;\n    padding-left: 0.75rem !important;\n  }\n  .px-lg-4 {\n    padding-right: 1rem !important;\n    padding-left: 1rem !important;\n  }\n  .px-lg-5 {\n    padding-right: 1.25rem !important;\n    padding-left: 1.25rem !important;\n  }\n  .px-lg-6 {\n    padding-right: 1.5rem !important;\n    padding-left: 1.5rem !important;\n  }\n  .px-lg-7 {\n    padding-right: 1.75rem !important;\n    padding-left: 1.75rem !important;\n  }\n  .px-lg-8 {\n    padding-right: 2rem !important;\n    padding-left: 2rem !important;\n  }\n  .px-lg-9 {\n    padding-right: 2.25rem !important;\n    padding-left: 2.25rem !important;\n  }\n  .px-lg-10 {\n    padding-right: 2.5rem !important;\n    padding-left: 2.5rem !important;\n  }\n  .px-lg-11 {\n    padding-right: 2.75rem !important;\n    padding-left: 2.75rem !important;\n  }\n  .px-lg-12 {\n    padding-right: 3rem !important;\n    padding-left: 3rem !important;\n  }\n  .px-lg-13 {\n    padding-right: 3.25rem !important;\n    padding-left: 3.25rem !important;\n  }\n  .px-lg-14 {\n    padding-right: 3.5rem !important;\n    padding-left: 3.5rem !important;\n  }\n  .px-lg-15 {\n    padding-right: 3.75rem !important;\n    padding-left: 3.75rem !important;\n  }\n  .px-lg-16 {\n    padding-right: 4rem !important;\n    padding-left: 4rem !important;\n  }\n  .px-lg-17 {\n    padding-right: 4.25rem !important;\n    padding-left: 4.25rem !important;\n  }\n  .px-lg-18 {\n    padding-right: 4.5rem !important;\n    padding-left: 4.5rem !important;\n  }\n  .px-lg-19 {\n    padding-right: 4.75rem !important;\n    padding-left: 4.75rem !important;\n  }\n  .px-lg-20 {\n    padding-right: 5rem !important;\n    padding-left: 5rem !important;\n  }\n  .py-lg-0 {\n    padding-top: 0 !important;\n    padding-bottom: 0 !important;\n  }\n  .py-lg-1 {\n    padding-top: 0.25rem !important;\n    padding-bottom: 0.25rem !important;\n  }\n  .py-lg-2 {\n    padding-top: 0.5rem !important;\n    padding-bottom: 0.5rem !important;\n  }\n  .py-lg-3 {\n    padding-top: 0.75rem !important;\n    padding-bottom: 0.75rem !important;\n  }\n  .py-lg-4 {\n    padding-top: 1rem !important;\n    padding-bottom: 1rem !important;\n  }\n  .py-lg-5 {\n    padding-top: 1.25rem !important;\n    padding-bottom: 1.25rem !important;\n  }\n  .py-lg-6 {\n    padding-top: 1.5rem !important;\n    padding-bottom: 1.5rem !important;\n  }\n  .py-lg-7 {\n    padding-top: 1.75rem !important;\n    padding-bottom: 1.75rem !important;\n  }\n  .py-lg-8 {\n    padding-top: 2rem !important;\n    padding-bottom: 2rem !important;\n  }\n  .py-lg-9 {\n    padding-top: 2.25rem !important;\n    padding-bottom: 2.25rem !important;\n  }\n  .py-lg-10 {\n    padding-top: 2.5rem !important;\n    padding-bottom: 2.5rem !important;\n  }\n  .py-lg-11 {\n    padding-top: 2.75rem !important;\n    padding-bottom: 2.75rem !important;\n  }\n  .py-lg-12 {\n    padding-top: 3rem !important;\n    padding-bottom: 3rem !important;\n  }\n  .py-lg-13 {\n    padding-top: 3.25rem !important;\n    padding-bottom: 3.25rem !important;\n  }\n  .py-lg-14 {\n    padding-top: 3.5rem !important;\n    padding-bottom: 3.5rem !important;\n  }\n  .py-lg-15 {\n    padding-top: 3.75rem !important;\n    padding-bottom: 3.75rem !important;\n  }\n  .py-lg-16 {\n    padding-top: 4rem !important;\n    padding-bottom: 4rem !important;\n  }\n  .py-lg-17 {\n    padding-top: 4.25rem !important;\n    padding-bottom: 4.25rem !important;\n  }\n  .py-lg-18 {\n    padding-top: 4.5rem !important;\n    padding-bottom: 4.5rem !important;\n  }\n  .py-lg-19 {\n    padding-top: 4.75rem !important;\n    padding-bottom: 4.75rem !important;\n  }\n  .py-lg-20 {\n    padding-top: 5rem !important;\n    padding-bottom: 5rem !important;\n  }\n  .pt-lg-0 {\n    padding-top: 0 !important;\n  }\n  .pt-lg-1 {\n    padding-top: 0.25rem !important;\n  }\n  .pt-lg-2 {\n    padding-top: 0.5rem !important;\n  }\n  .pt-lg-3 {\n    padding-top: 0.75rem !important;\n  }\n  .pt-lg-4 {\n    padding-top: 1rem !important;\n  }\n  .pt-lg-5 {\n    padding-top: 1.25rem !important;\n  }\n  .pt-lg-6 {\n    padding-top: 1.5rem !important;\n  }\n  .pt-lg-7 {\n    padding-top: 1.75rem !important;\n  }\n  .pt-lg-8 {\n    padding-top: 2rem !important;\n  }\n  .pt-lg-9 {\n    padding-top: 2.25rem !important;\n  }\n  .pt-lg-10 {\n    padding-top: 2.5rem !important;\n  }\n  .pt-lg-11 {\n    padding-top: 2.75rem !important;\n  }\n  .pt-lg-12 {\n    padding-top: 3rem !important;\n  }\n  .pt-lg-13 {\n    padding-top: 3.25rem !important;\n  }\n  .pt-lg-14 {\n    padding-top: 3.5rem !important;\n  }\n  .pt-lg-15 {\n    padding-top: 3.75rem !important;\n  }\n  .pt-lg-16 {\n    padding-top: 4rem !important;\n  }\n  .pt-lg-17 {\n    padding-top: 4.25rem !important;\n  }\n  .pt-lg-18 {\n    padding-top: 4.5rem !important;\n  }\n  .pt-lg-19 {\n    padding-top: 4.75rem !important;\n  }\n  .pt-lg-20 {\n    padding-top: 5rem !important;\n  }\n  .pe-lg-0 {\n    padding-right: 0 !important;\n  }\n  .pe-lg-1 {\n    padding-right: 0.25rem !important;\n  }\n  .pe-lg-2 {\n    padding-right: 0.5rem !important;\n  }\n  .pe-lg-3 {\n    padding-right: 0.75rem !important;\n  }\n  .pe-lg-4 {\n    padding-right: 1rem !important;\n  }\n  .pe-lg-5 {\n    padding-right: 1.25rem !important;\n  }\n  .pe-lg-6 {\n    padding-right: 1.5rem !important;\n  }\n  .pe-lg-7 {\n    padding-right: 1.75rem !important;\n  }\n  .pe-lg-8 {\n    padding-right: 2rem !important;\n  }\n  .pe-lg-9 {\n    padding-right: 2.25rem !important;\n  }\n  .pe-lg-10 {\n    padding-right: 2.5rem !important;\n  }\n  .pe-lg-11 {\n    padding-right: 2.75rem !important;\n  }\n  .pe-lg-12 {\n    padding-right: 3rem !important;\n  }\n  .pe-lg-13 {\n    padding-right: 3.25rem !important;\n  }\n  .pe-lg-14 {\n    padding-right: 3.5rem !important;\n  }\n  .pe-lg-15 {\n    padding-right: 3.75rem !important;\n  }\n  .pe-lg-16 {\n    padding-right: 4rem !important;\n  }\n  .pe-lg-17 {\n    padding-right: 4.25rem !important;\n  }\n  .pe-lg-18 {\n    padding-right: 4.5rem !important;\n  }\n  .pe-lg-19 {\n    padding-right: 4.75rem !important;\n  }\n  .pe-lg-20 {\n    padding-right: 5rem !important;\n  }\n  .pb-lg-0 {\n    padding-bottom: 0 !important;\n  }\n  .pb-lg-1 {\n    padding-bottom: 0.25rem !important;\n  }\n  .pb-lg-2 {\n    padding-bottom: 0.5rem !important;\n  }\n  .pb-lg-3 {\n    padding-bottom: 0.75rem !important;\n  }\n  .pb-lg-4 {\n    padding-bottom: 1rem !important;\n  }\n  .pb-lg-5 {\n    padding-bottom: 1.25rem !important;\n  }\n  .pb-lg-6 {\n    padding-bottom: 1.5rem !important;\n  }\n  .pb-lg-7 {\n    padding-bottom: 1.75rem !important;\n  }\n  .pb-lg-8 {\n    padding-bottom: 2rem !important;\n  }\n  .pb-lg-9 {\n    padding-bottom: 2.25rem !important;\n  }\n  .pb-lg-10 {\n    padding-bottom: 2.5rem !important;\n  }\n  .pb-lg-11 {\n    padding-bottom: 2.75rem !important;\n  }\n  .pb-lg-12 {\n    padding-bottom: 3rem !important;\n  }\n  .pb-lg-13 {\n    padding-bottom: 3.25rem !important;\n  }\n  .pb-lg-14 {\n    padding-bottom: 3.5rem !important;\n  }\n  .pb-lg-15 {\n    padding-bottom: 3.75rem !important;\n  }\n  .pb-lg-16 {\n    padding-bottom: 4rem !important;\n  }\n  .pb-lg-17 {\n    padding-bottom: 4.25rem !important;\n  }\n  .pb-lg-18 {\n    padding-bottom: 4.5rem !important;\n  }\n  .pb-lg-19 {\n    padding-bottom: 4.75rem !important;\n  }\n  .pb-lg-20 {\n    padding-bottom: 5rem !important;\n  }\n  .ps-lg-0 {\n    padding-left: 0 !important;\n  }\n  .ps-lg-1 {\n    padding-left: 0.25rem !important;\n  }\n  .ps-lg-2 {\n    padding-left: 0.5rem !important;\n  }\n  .ps-lg-3 {\n    padding-left: 0.75rem !important;\n  }\n  .ps-lg-4 {\n    padding-left: 1rem !important;\n  }\n  .ps-lg-5 {\n    padding-left: 1.25rem !important;\n  }\n  .ps-lg-6 {\n    padding-left: 1.5rem !important;\n  }\n  .ps-lg-7 {\n    padding-left: 1.75rem !important;\n  }\n  .ps-lg-8 {\n    padding-left: 2rem !important;\n  }\n  .ps-lg-9 {\n    padding-left: 2.25rem !important;\n  }\n  .ps-lg-10 {\n    padding-left: 2.5rem !important;\n  }\n  .ps-lg-11 {\n    padding-left: 2.75rem !important;\n  }\n  .ps-lg-12 {\n    padding-left: 3rem !important;\n  }\n  .ps-lg-13 {\n    padding-left: 3.25rem !important;\n  }\n  .ps-lg-14 {\n    padding-left: 3.5rem !important;\n  }\n  .ps-lg-15 {\n    padding-left: 3.75rem !important;\n  }\n  .ps-lg-16 {\n    padding-left: 4rem !important;\n  }\n  .ps-lg-17 {\n    padding-left: 4.25rem !important;\n  }\n  .ps-lg-18 {\n    padding-left: 4.5rem !important;\n  }\n  .ps-lg-19 {\n    padding-left: 4.75rem !important;\n  }\n  .ps-lg-20 {\n    padding-left: 5rem !important;\n  }\n  .gap-lg-0 {\n    gap: 0 !important;\n  }\n  .gap-lg-1 {\n    gap: 0.25rem !important;\n  }\n  .gap-lg-2 {\n    gap: 0.5rem !important;\n  }\n  .gap-lg-3 {\n    gap: 0.75rem !important;\n  }\n  .gap-lg-4 {\n    gap: 1rem !important;\n  }\n  .gap-lg-5 {\n    gap: 1.25rem !important;\n  }\n  .gap-lg-6 {\n    gap: 1.5rem !important;\n  }\n  .gap-lg-7 {\n    gap: 1.75rem !important;\n  }\n  .gap-lg-8 {\n    gap: 2rem !important;\n  }\n  .gap-lg-9 {\n    gap: 2.25rem !important;\n  }\n  .gap-lg-10 {\n    gap: 2.5rem !important;\n  }\n  .gap-lg-11 {\n    gap: 2.75rem !important;\n  }\n  .gap-lg-12 {\n    gap: 3rem !important;\n  }\n  .gap-lg-13 {\n    gap: 3.25rem !important;\n  }\n  .gap-lg-14 {\n    gap: 3.5rem !important;\n  }\n  .gap-lg-15 {\n    gap: 3.75rem !important;\n  }\n  .gap-lg-16 {\n    gap: 4rem !important;\n  }\n  .gap-lg-17 {\n    gap: 4.25rem !important;\n  }\n  .gap-lg-18 {\n    gap: 4.5rem !important;\n  }\n  .gap-lg-19 {\n    gap: 4.75rem !important;\n  }\n  .gap-lg-20 {\n    gap: 5rem !important;\n  }\n  .row-gap-lg-0 {\n    row-gap: 0 !important;\n  }\n  .row-gap-lg-1 {\n    row-gap: 0.25rem !important;\n  }\n  .row-gap-lg-2 {\n    row-gap: 0.5rem !important;\n  }\n  .row-gap-lg-3 {\n    row-gap: 0.75rem !important;\n  }\n  .row-gap-lg-4 {\n    row-gap: 1rem !important;\n  }\n  .row-gap-lg-5 {\n    row-gap: 1.25rem !important;\n  }\n  .row-gap-lg-6 {\n    row-gap: 1.5rem !important;\n  }\n  .row-gap-lg-7 {\n    row-gap: 1.75rem !important;\n  }\n  .row-gap-lg-8 {\n    row-gap: 2rem !important;\n  }\n  .row-gap-lg-9 {\n    row-gap: 2.25rem !important;\n  }\n  .row-gap-lg-10 {\n    row-gap: 2.5rem !important;\n  }\n  .row-gap-lg-11 {\n    row-gap: 2.75rem !important;\n  }\n  .row-gap-lg-12 {\n    row-gap: 3rem !important;\n  }\n  .row-gap-lg-13 {\n    row-gap: 3.25rem !important;\n  }\n  .row-gap-lg-14 {\n    row-gap: 3.5rem !important;\n  }\n  .row-gap-lg-15 {\n    row-gap: 3.75rem !important;\n  }\n  .row-gap-lg-16 {\n    row-gap: 4rem !important;\n  }\n  .row-gap-lg-17 {\n    row-gap: 4.25rem !important;\n  }\n  .row-gap-lg-18 {\n    row-gap: 4.5rem !important;\n  }\n  .row-gap-lg-19 {\n    row-gap: 4.75rem !important;\n  }\n  .row-gap-lg-20 {\n    row-gap: 5rem !important;\n  }\n  .column-gap-lg-0 {\n    column-gap: 0 !important;\n  }\n  .column-gap-lg-1 {\n    column-gap: 0.25rem !important;\n  }\n  .column-gap-lg-2 {\n    column-gap: 0.5rem !important;\n  }\n  .column-gap-lg-3 {\n    column-gap: 0.75rem !important;\n  }\n  .column-gap-lg-4 {\n    column-gap: 1rem !important;\n  }\n  .column-gap-lg-5 {\n    column-gap: 1.25rem !important;\n  }\n  .column-gap-lg-6 {\n    column-gap: 1.5rem !important;\n  }\n  .column-gap-lg-7 {\n    column-gap: 1.75rem !important;\n  }\n  .column-gap-lg-8 {\n    column-gap: 2rem !important;\n  }\n  .column-gap-lg-9 {\n    column-gap: 2.25rem !important;\n  }\n  .column-gap-lg-10 {\n    column-gap: 2.5rem !important;\n  }\n  .column-gap-lg-11 {\n    column-gap: 2.75rem !important;\n  }\n  .column-gap-lg-12 {\n    column-gap: 3rem !important;\n  }\n  .column-gap-lg-13 {\n    column-gap: 3.25rem !important;\n  }\n  .column-gap-lg-14 {\n    column-gap: 3.5rem !important;\n  }\n  .column-gap-lg-15 {\n    column-gap: 3.75rem !important;\n  }\n  .column-gap-lg-16 {\n    column-gap: 4rem !important;\n  }\n  .column-gap-lg-17 {\n    column-gap: 4.25rem !important;\n  }\n  .column-gap-lg-18 {\n    column-gap: 4.5rem !important;\n  }\n  .column-gap-lg-19 {\n    column-gap: 4.75rem !important;\n  }\n  .column-gap-lg-20 {\n    column-gap: 5rem !important;\n  }\n  .fs-lg-1 {\n    font-size: calc(1.3rem + 0.6vw) !important;\n  }\n  .fs-lg-2 {\n    font-size: calc(1.275rem + 0.3vw) !important;\n  }\n  .fs-lg-3 {\n    font-size: calc(1.26rem + 0.12vw) !important;\n  }\n  .fs-lg-4 {\n    font-size: 1.25rem !important;\n  }\n  .fs-lg-5 {\n    font-size: 1.15rem !important;\n  }\n  .fs-lg-6 {\n    font-size: 1.075rem !important;\n  }\n  .fs-lg-7 {\n    font-size: 0.95rem !important;\n  }\n  .fs-lg-8 {\n    font-size: 0.85rem !important;\n  }\n  .fs-lg-9 {\n    font-size: 0.75rem !important;\n  }\n  .fs-lg-10 {\n    font-size: 0.5rem !important;\n  }\n  .fs-lg-base {\n    font-size: 1rem !important;\n  }\n  .fs-lg-fluid {\n    font-size: 100% !important;\n  }\n  .fs-lg-2x {\n    font-size: calc(1.325rem + 0.9vw) !important;\n  }\n  .fs-lg-2qx {\n    font-size: calc(1.35rem + 1.2vw) !important;\n  }\n  .fs-lg-2hx {\n    font-size: calc(1.375rem + 1.5vw) !important;\n  }\n  .fs-lg-2tx {\n    font-size: calc(1.4rem + 1.8vw) !important;\n  }\n  .fs-lg-3x {\n    font-size: calc(1.425rem + 2.1vw) !important;\n  }\n  .fs-lg-3qx {\n    font-size: calc(1.45rem + 2.4vw) !important;\n  }\n  .fs-lg-3hx {\n    font-size: calc(1.475rem + 2.7vw) !important;\n  }\n  .fs-lg-3tx {\n    font-size: calc(1.5rem + 3vw) !important;\n  }\n  .fs-lg-4x {\n    font-size: calc(1.525rem + 3.3vw) !important;\n  }\n  .fs-lg-4qx {\n    font-size: calc(1.55rem + 3.6vw) !important;\n  }\n  .fs-lg-4hx {\n    font-size: calc(1.575rem + 3.9vw) !important;\n  }\n  .fs-lg-4tx {\n    font-size: calc(1.6rem + 4.2vw) !important;\n  }\n  .fs-lg-5x {\n    font-size: calc(1.625rem + 4.5vw) !important;\n  }\n  .fs-lg-5qx {\n    font-size: calc(1.65rem + 4.8vw) !important;\n  }\n  .fs-lg-5hx {\n    font-size: calc(1.675rem + 5.1vw) !important;\n  }\n  .fs-lg-5tx {\n    font-size: calc(1.7rem + 5.4vw) !important;\n  }\n  .fs-lg-6x {\n    font-size: calc(1.725rem + 5.7vw) !important;\n  }\n  .fs-lg-6qx {\n    font-size: calc(1.75rem + 6vw) !important;\n  }\n  .fs-lg-6hx {\n    font-size: calc(1.775rem + 6.3vw) !important;\n  }\n  .fs-lg-6tx {\n    font-size: calc(1.8rem + 6.6vw) !important;\n  }\n  .fs-lg-7x {\n    font-size: calc(1.825rem + 6.9vw) !important;\n  }\n  .fs-lg-7qx {\n    font-size: calc(1.85rem + 7.2vw) !important;\n  }\n  .fs-lg-7hx {\n    font-size: calc(1.875rem + 7.5vw) !important;\n  }\n  .fs-lg-7tx {\n    font-size: calc(1.9rem + 7.8vw) !important;\n  }\n  .text-lg-start {\n    text-align: left !important;\n  }\n  .text-lg-end {\n    text-align: right !important;\n  }\n  .text-lg-center {\n    text-align: center !important;\n  }\n  .min-w-lg-unset {\n    min-width: unset !important;\n  }\n  .min-w-lg-25 {\n    min-width: 25% !important;\n  }\n  .min-w-lg-50 {\n    min-width: 50% !important;\n  }\n  .min-w-lg-75 {\n    min-width: 75% !important;\n  }\n  .min-w-lg-100 {\n    min-width: 100% !important;\n  }\n  .min-w-lg-auto {\n    min-width: auto !important;\n  }\n  .min-w-lg-1px {\n    min-width: 1px !important;\n  }\n  .min-w-lg-2px {\n    min-width: 2px !important;\n  }\n  .min-w-lg-3px {\n    min-width: 3px !important;\n  }\n  .min-w-lg-4px {\n    min-width: 4px !important;\n  }\n  .min-w-lg-5px {\n    min-width: 5px !important;\n  }\n  .min-w-lg-6px {\n    min-width: 6px !important;\n  }\n  .min-w-lg-7px {\n    min-width: 7px !important;\n  }\n  .min-w-lg-8px {\n    min-width: 8px !important;\n  }\n  .min-w-lg-9px {\n    min-width: 9px !important;\n  }\n  .min-w-lg-10px {\n    min-width: 10px !important;\n  }\n  .min-w-lg-15px {\n    min-width: 15px !important;\n  }\n  .min-w-lg-20px {\n    min-width: 20px !important;\n  }\n  .min-w-lg-25px {\n    min-width: 25px !important;\n  }\n  .min-w-lg-30px {\n    min-width: 30px !important;\n  }\n  .min-w-lg-35px {\n    min-width: 35px !important;\n  }\n  .min-w-lg-40px {\n    min-width: 40px !important;\n  }\n  .min-w-lg-45px {\n    min-width: 45px !important;\n  }\n  .min-w-lg-50px {\n    min-width: 50px !important;\n  }\n  .min-w-lg-55px {\n    min-width: 55px !important;\n  }\n  .min-w-lg-60px {\n    min-width: 60px !important;\n  }\n  .min-w-lg-65px {\n    min-width: 65px !important;\n  }\n  .min-w-lg-70px {\n    min-width: 70px !important;\n  }\n  .min-w-lg-75px {\n    min-width: 75px !important;\n  }\n  .min-w-lg-80px {\n    min-width: 80px !important;\n  }\n  .min-w-lg-85px {\n    min-width: 85px !important;\n  }\n  .min-w-lg-90px {\n    min-width: 90px !important;\n  }\n  .min-w-lg-95px {\n    min-width: 95px !important;\n  }\n  .min-w-lg-100px {\n    min-width: 100px !important;\n  }\n  .min-w-lg-125px {\n    min-width: 125px !important;\n  }\n  .min-w-lg-150px {\n    min-width: 150px !important;\n  }\n  .min-w-lg-175px {\n    min-width: 175px !important;\n  }\n  .min-w-lg-200px {\n    min-width: 200px !important;\n  }\n  .min-w-lg-225px {\n    min-width: 225px !important;\n  }\n  .min-w-lg-250px {\n    min-width: 250px !important;\n  }\n  .min-w-lg-275px {\n    min-width: 275px !important;\n  }\n  .min-w-lg-300px {\n    min-width: 300px !important;\n  }\n  .min-w-lg-325px {\n    min-width: 325px !important;\n  }\n  .min-w-lg-350px {\n    min-width: 350px !important;\n  }\n  .min-w-lg-375px {\n    min-width: 375px !important;\n  }\n  .min-w-lg-400px {\n    min-width: 400px !important;\n  }\n  .min-w-lg-425px {\n    min-width: 425px !important;\n  }\n  .min-w-lg-450px {\n    min-width: 450px !important;\n  }\n  .min-w-lg-475px {\n    min-width: 475px !important;\n  }\n  .min-w-lg-500px {\n    min-width: 500px !important;\n  }\n  .min-w-lg-550px {\n    min-width: 550px !important;\n  }\n  .min-w-lg-600px {\n    min-width: 600px !important;\n  }\n  .min-w-lg-650px {\n    min-width: 650px !important;\n  }\n  .min-w-lg-700px {\n    min-width: 700px !important;\n  }\n  .min-w-lg-750px {\n    min-width: 750px !important;\n  }\n  .min-w-lg-800px {\n    min-width: 800px !important;\n  }\n  .min-w-lg-850px {\n    min-width: 850px !important;\n  }\n  .min-w-lg-900px {\n    min-width: 900px !important;\n  }\n  .min-w-lg-950px {\n    min-width: 950px !important;\n  }\n  .min-w-lg-1000px {\n    min-width: 1000px !important;\n  }\n  .min-h-lg-unset {\n    min-height: unset !important;\n  }\n  .min-h-lg-25 {\n    min-height: 25% !important;\n  }\n  .min-h-lg-50 {\n    min-height: 50% !important;\n  }\n  .min-h-lg-75 {\n    min-height: 75% !important;\n  }\n  .min-h-lg-100 {\n    min-height: 100% !important;\n  }\n  .min-h-lg-auto {\n    min-height: auto !important;\n  }\n  .min-h-lg-1px {\n    min-height: 1px !important;\n  }\n  .min-h-lg-2px {\n    min-height: 2px !important;\n  }\n  .min-h-lg-3px {\n    min-height: 3px !important;\n  }\n  .min-h-lg-4px {\n    min-height: 4px !important;\n  }\n  .min-h-lg-5px {\n    min-height: 5px !important;\n  }\n  .min-h-lg-6px {\n    min-height: 6px !important;\n  }\n  .min-h-lg-7px {\n    min-height: 7px !important;\n  }\n  .min-h-lg-8px {\n    min-height: 8px !important;\n  }\n  .min-h-lg-9px {\n    min-height: 9px !important;\n  }\n  .min-h-lg-10px {\n    min-height: 10px !important;\n  }\n  .min-h-lg-15px {\n    min-height: 15px !important;\n  }\n  .min-h-lg-20px {\n    min-height: 20px !important;\n  }\n  .min-h-lg-25px {\n    min-height: 25px !important;\n  }\n  .min-h-lg-30px {\n    min-height: 30px !important;\n  }\n  .min-h-lg-35px {\n    min-height: 35px !important;\n  }\n  .min-h-lg-40px {\n    min-height: 40px !important;\n  }\n  .min-h-lg-45px {\n    min-height: 45px !important;\n  }\n  .min-h-lg-50px {\n    min-height: 50px !important;\n  }\n  .min-h-lg-55px {\n    min-height: 55px !important;\n  }\n  .min-h-lg-60px {\n    min-height: 60px !important;\n  }\n  .min-h-lg-65px {\n    min-height: 65px !important;\n  }\n  .min-h-lg-70px {\n    min-height: 70px !important;\n  }\n  .min-h-lg-75px {\n    min-height: 75px !important;\n  }\n  .min-h-lg-80px {\n    min-height: 80px !important;\n  }\n  .min-h-lg-85px {\n    min-height: 85px !important;\n  }\n  .min-h-lg-90px {\n    min-height: 90px !important;\n  }\n  .min-h-lg-95px {\n    min-height: 95px !important;\n  }\n  .min-h-lg-100px {\n    min-height: 100px !important;\n  }\n  .min-h-lg-125px {\n    min-height: 125px !important;\n  }\n  .min-h-lg-150px {\n    min-height: 150px !important;\n  }\n  .min-h-lg-175px {\n    min-height: 175px !important;\n  }\n  .min-h-lg-200px {\n    min-height: 200px !important;\n  }\n  .min-h-lg-225px {\n    min-height: 225px !important;\n  }\n  .min-h-lg-250px {\n    min-height: 250px !important;\n  }\n  .min-h-lg-275px {\n    min-height: 275px !important;\n  }\n  .min-h-lg-300px {\n    min-height: 300px !important;\n  }\n  .min-h-lg-325px {\n    min-height: 325px !important;\n  }\n  .min-h-lg-350px {\n    min-height: 350px !important;\n  }\n  .min-h-lg-375px {\n    min-height: 375px !important;\n  }\n  .min-h-lg-400px {\n    min-height: 400px !important;\n  }\n  .min-h-lg-425px {\n    min-height: 425px !important;\n  }\n  .min-h-lg-450px {\n    min-height: 450px !important;\n  }\n  .min-h-lg-475px {\n    min-height: 475px !important;\n  }\n  .min-h-lg-500px {\n    min-height: 500px !important;\n  }\n  .min-h-lg-550px {\n    min-height: 550px !important;\n  }\n  .min-h-lg-600px {\n    min-height: 600px !important;\n  }\n  .min-h-lg-650px {\n    min-height: 650px !important;\n  }\n  .min-h-lg-700px {\n    min-height: 700px !important;\n  }\n  .min-h-lg-750px {\n    min-height: 750px !important;\n  }\n  .min-h-lg-800px {\n    min-height: 800px !important;\n  }\n  .min-h-lg-850px {\n    min-height: 850px !important;\n  }\n  .min-h-lg-900px {\n    min-height: 900px !important;\n  }\n  .min-h-lg-950px {\n    min-height: 950px !important;\n  }\n  .min-h-lg-1000px {\n    min-height: 1000px !important;\n  }\n}\n@media (min-width: 1200px) {\n  .float-xl-start {\n    float: left !important;\n  }\n  .float-xl-end {\n    float: right !important;\n  }\n  .float-xl-none {\n    float: none !important;\n  }\n  .object-fit-xl-contain {\n    object-fit: contain !important;\n  }\n  .object-fit-xl-cover {\n    object-fit: cover !important;\n  }\n  .object-fit-xl-fill {\n    object-fit: fill !important;\n  }\n  .object-fit-xl-scale {\n    object-fit: scale-down !important;\n  }\n  .object-fit-xl-none {\n    object-fit: none !important;\n  }\n  .overflow-xl-auto {\n    overflow: auto !important;\n  }\n  .overflow-xl-hidden {\n    overflow: hidden !important;\n  }\n  .overflow-xl-visible {\n    overflow: visible !important;\n  }\n  .overflow-xl-scroll {\n    overflow: scroll !important;\n  }\n  .d-xl-inline {\n    display: inline !important;\n  }\n  .d-xl-inline-block {\n    display: inline-block !important;\n  }\n  .d-xl-block {\n    display: block !important;\n  }\n  .d-xl-grid {\n    display: grid !important;\n  }\n  .d-xl-table {\n    display: table !important;\n  }\n  .d-xl-table-row {\n    display: table-row !important;\n  }\n  .d-xl-table-cell {\n    display: table-cell !important;\n  }\n  .d-xl-flex {\n    display: flex !important;\n  }\n  .d-xl-inline-flex {\n    display: inline-flex !important;\n  }\n  .d-xl-none {\n    display: none !important;\n  }\n  .position-xl-static {\n    position: static !important;\n  }\n  .position-xl-relative {\n    position: relative !important;\n  }\n  .position-xl-absolute {\n    position: absolute !important;\n  }\n  .position-xl-fixed {\n    position: fixed !important;\n  }\n  .position-xl-sticky {\n    position: sticky !important;\n  }\n  .w-xl-unset {\n    width: unset !important;\n  }\n  .w-xl-25 {\n    width: 25% !important;\n  }\n  .w-xl-50 {\n    width: 50% !important;\n  }\n  .w-xl-75 {\n    width: 75% !important;\n  }\n  .w-xl-100 {\n    width: 100% !important;\n  }\n  .w-xl-auto {\n    width: auto !important;\n  }\n  .w-xl-1px {\n    width: 1px !important;\n  }\n  .w-xl-2px {\n    width: 2px !important;\n  }\n  .w-xl-3px {\n    width: 3px !important;\n  }\n  .w-xl-4px {\n    width: 4px !important;\n  }\n  .w-xl-5px {\n    width: 5px !important;\n  }\n  .w-xl-6px {\n    width: 6px !important;\n  }\n  .w-xl-7px {\n    width: 7px !important;\n  }\n  .w-xl-8px {\n    width: 8px !important;\n  }\n  .w-xl-9px {\n    width: 9px !important;\n  }\n  .w-xl-10px {\n    width: 10px !important;\n  }\n  .w-xl-15px {\n    width: 15px !important;\n  }\n  .w-xl-20px {\n    width: 20px !important;\n  }\n  .w-xl-25px {\n    width: 25px !important;\n  }\n  .w-xl-30px {\n    width: 30px !important;\n  }\n  .w-xl-35px {\n    width: 35px !important;\n  }\n  .w-xl-40px {\n    width: 40px !important;\n  }\n  .w-xl-45px {\n    width: 45px !important;\n  }\n  .w-xl-50px {\n    width: 50px !important;\n  }\n  .w-xl-55px {\n    width: 55px !important;\n  }\n  .w-xl-60px {\n    width: 60px !important;\n  }\n  .w-xl-65px {\n    width: 65px !important;\n  }\n  .w-xl-70px {\n    width: 70px !important;\n  }\n  .w-xl-75px {\n    width: 75px !important;\n  }\n  .w-xl-80px {\n    width: 80px !important;\n  }\n  .w-xl-85px {\n    width: 85px !important;\n  }\n  .w-xl-90px {\n    width: 90px !important;\n  }\n  .w-xl-95px {\n    width: 95px !important;\n  }\n  .w-xl-100px {\n    width: 100px !important;\n  }\n  .w-xl-125px {\n    width: 125px !important;\n  }\n  .w-xl-150px {\n    width: 150px !important;\n  }\n  .w-xl-175px {\n    width: 175px !important;\n  }\n  .w-xl-200px {\n    width: 200px !important;\n  }\n  .w-xl-225px {\n    width: 225px !important;\n  }\n  .w-xl-250px {\n    width: 250px !important;\n  }\n  .w-xl-275px {\n    width: 275px !important;\n  }\n  .w-xl-300px {\n    width: 300px !important;\n  }\n  .w-xl-325px {\n    width: 325px !important;\n  }\n  .w-xl-350px {\n    width: 350px !important;\n  }\n  .w-xl-375px {\n    width: 375px !important;\n  }\n  .w-xl-400px {\n    width: 400px !important;\n  }\n  .w-xl-425px {\n    width: 425px !important;\n  }\n  .w-xl-450px {\n    width: 450px !important;\n  }\n  .w-xl-475px {\n    width: 475px !important;\n  }\n  .w-xl-500px {\n    width: 500px !important;\n  }\n  .w-xl-550px {\n    width: 550px !important;\n  }\n  .w-xl-600px {\n    width: 600px !important;\n  }\n  .w-xl-650px {\n    width: 650px !important;\n  }\n  .w-xl-700px {\n    width: 700px !important;\n  }\n  .w-xl-750px {\n    width: 750px !important;\n  }\n  .w-xl-800px {\n    width: 800px !important;\n  }\n  .w-xl-850px {\n    width: 850px !important;\n  }\n  .w-xl-900px {\n    width: 900px !important;\n  }\n  .w-xl-950px {\n    width: 950px !important;\n  }\n  .w-xl-1000px {\n    width: 1000px !important;\n  }\n  .mw-xl-unset {\n    max-width: unset !important;\n  }\n  .mw-xl-25 {\n    max-width: 25% !important;\n  }\n  .mw-xl-50 {\n    max-width: 50% !important;\n  }\n  .mw-xl-75 {\n    max-width: 75% !important;\n  }\n  .mw-xl-100 {\n    max-width: 100% !important;\n  }\n  .mw-xl-auto {\n    max-width: auto !important;\n  }\n  .mw-xl-1px {\n    max-width: 1px !important;\n  }\n  .mw-xl-2px {\n    max-width: 2px !important;\n  }\n  .mw-xl-3px {\n    max-width: 3px !important;\n  }\n  .mw-xl-4px {\n    max-width: 4px !important;\n  }\n  .mw-xl-5px {\n    max-width: 5px !important;\n  }\n  .mw-xl-6px {\n    max-width: 6px !important;\n  }\n  .mw-xl-7px {\n    max-width: 7px !important;\n  }\n  .mw-xl-8px {\n    max-width: 8px !important;\n  }\n  .mw-xl-9px {\n    max-width: 9px !important;\n  }\n  .mw-xl-10px {\n    max-width: 10px !important;\n  }\n  .mw-xl-15px {\n    max-width: 15px !important;\n  }\n  .mw-xl-20px {\n    max-width: 20px !important;\n  }\n  .mw-xl-25px {\n    max-width: 25px !important;\n  }\n  .mw-xl-30px {\n    max-width: 30px !important;\n  }\n  .mw-xl-35px {\n    max-width: 35px !important;\n  }\n  .mw-xl-40px {\n    max-width: 40px !important;\n  }\n  .mw-xl-45px {\n    max-width: 45px !important;\n  }\n  .mw-xl-50px {\n    max-width: 50px !important;\n  }\n  .mw-xl-55px {\n    max-width: 55px !important;\n  }\n  .mw-xl-60px {\n    max-width: 60px !important;\n  }\n  .mw-xl-65px {\n    max-width: 65px !important;\n  }\n  .mw-xl-70px {\n    max-width: 70px !important;\n  }\n  .mw-xl-75px {\n    max-width: 75px !important;\n  }\n  .mw-xl-80px {\n    max-width: 80px !important;\n  }\n  .mw-xl-85px {\n    max-width: 85px !important;\n  }\n  .mw-xl-90px {\n    max-width: 90px !important;\n  }\n  .mw-xl-95px {\n    max-width: 95px !important;\n  }\n  .mw-xl-100px {\n    max-width: 100px !important;\n  }\n  .mw-xl-125px {\n    max-width: 125px !important;\n  }\n  .mw-xl-150px {\n    max-width: 150px !important;\n  }\n  .mw-xl-175px {\n    max-width: 175px !important;\n  }\n  .mw-xl-200px {\n    max-width: 200px !important;\n  }\n  .mw-xl-225px {\n    max-width: 225px !important;\n  }\n  .mw-xl-250px {\n    max-width: 250px !important;\n  }\n  .mw-xl-275px {\n    max-width: 275px !important;\n  }\n  .mw-xl-300px {\n    max-width: 300px !important;\n  }\n  .mw-xl-325px {\n    max-width: 325px !important;\n  }\n  .mw-xl-350px {\n    max-width: 350px !important;\n  }\n  .mw-xl-375px {\n    max-width: 375px !important;\n  }\n  .mw-xl-400px {\n    max-width: 400px !important;\n  }\n  .mw-xl-425px {\n    max-width: 425px !important;\n  }\n  .mw-xl-450px {\n    max-width: 450px !important;\n  }\n  .mw-xl-475px {\n    max-width: 475px !important;\n  }\n  .mw-xl-500px {\n    max-width: 500px !important;\n  }\n  .mw-xl-550px {\n    max-width: 550px !important;\n  }\n  .mw-xl-600px {\n    max-width: 600px !important;\n  }\n  .mw-xl-650px {\n    max-width: 650px !important;\n  }\n  .mw-xl-700px {\n    max-width: 700px !important;\n  }\n  .mw-xl-750px {\n    max-width: 750px !important;\n  }\n  .mw-xl-800px {\n    max-width: 800px !important;\n  }\n  .mw-xl-850px {\n    max-width: 850px !important;\n  }\n  .mw-xl-900px {\n    max-width: 900px !important;\n  }\n  .mw-xl-950px {\n    max-width: 950px !important;\n  }\n  .mw-xl-1000px {\n    max-width: 1000px !important;\n  }\n  .h-xl-unset {\n    height: unset !important;\n  }\n  .h-xl-25 {\n    height: 25% !important;\n  }\n  .h-xl-50 {\n    height: 50% !important;\n  }\n  .h-xl-75 {\n    height: 75% !important;\n  }\n  .h-xl-100 {\n    height: 100% !important;\n  }\n  .h-xl-auto {\n    height: auto !important;\n  }\n  .h-xl-1px {\n    height: 1px !important;\n  }\n  .h-xl-2px {\n    height: 2px !important;\n  }\n  .h-xl-3px {\n    height: 3px !important;\n  }\n  .h-xl-4px {\n    height: 4px !important;\n  }\n  .h-xl-5px {\n    height: 5px !important;\n  }\n  .h-xl-6px {\n    height: 6px !important;\n  }\n  .h-xl-7px {\n    height: 7px !important;\n  }\n  .h-xl-8px {\n    height: 8px !important;\n  }\n  .h-xl-9px {\n    height: 9px !important;\n  }\n  .h-xl-10px {\n    height: 10px !important;\n  }\n  .h-xl-15px {\n    height: 15px !important;\n  }\n  .h-xl-20px {\n    height: 20px !important;\n  }\n  .h-xl-25px {\n    height: 25px !important;\n  }\n  .h-xl-30px {\n    height: 30px !important;\n  }\n  .h-xl-35px {\n    height: 35px !important;\n  }\n  .h-xl-40px {\n    height: 40px !important;\n  }\n  .h-xl-45px {\n    height: 45px !important;\n  }\n  .h-xl-50px {\n    height: 50px !important;\n  }\n  .h-xl-55px {\n    height: 55px !important;\n  }\n  .h-xl-60px {\n    height: 60px !important;\n  }\n  .h-xl-65px {\n    height: 65px !important;\n  }\n  .h-xl-70px {\n    height: 70px !important;\n  }\n  .h-xl-75px {\n    height: 75px !important;\n  }\n  .h-xl-80px {\n    height: 80px !important;\n  }\n  .h-xl-85px {\n    height: 85px !important;\n  }\n  .h-xl-90px {\n    height: 90px !important;\n  }\n  .h-xl-95px {\n    height: 95px !important;\n  }\n  .h-xl-100px {\n    height: 100px !important;\n  }\n  .h-xl-125px {\n    height: 125px !important;\n  }\n  .h-xl-150px {\n    height: 150px !important;\n  }\n  .h-xl-175px {\n    height: 175px !important;\n  }\n  .h-xl-200px {\n    height: 200px !important;\n  }\n  .h-xl-225px {\n    height: 225px !important;\n  }\n  .h-xl-250px {\n    height: 250px !important;\n  }\n  .h-xl-275px {\n    height: 275px !important;\n  }\n  .h-xl-300px {\n    height: 300px !important;\n  }\n  .h-xl-325px {\n    height: 325px !important;\n  }\n  .h-xl-350px {\n    height: 350px !important;\n  }\n  .h-xl-375px {\n    height: 375px !important;\n  }\n  .h-xl-400px {\n    height: 400px !important;\n  }\n  .h-xl-425px {\n    height: 425px !important;\n  }\n  .h-xl-450px {\n    height: 450px !important;\n  }\n  .h-xl-475px {\n    height: 475px !important;\n  }\n  .h-xl-500px {\n    height: 500px !important;\n  }\n  .h-xl-550px {\n    height: 550px !important;\n  }\n  .h-xl-600px {\n    height: 600px !important;\n  }\n  .h-xl-650px {\n    height: 650px !important;\n  }\n  .h-xl-700px {\n    height: 700px !important;\n  }\n  .h-xl-750px {\n    height: 750px !important;\n  }\n  .h-xl-800px {\n    height: 800px !important;\n  }\n  .h-xl-850px {\n    height: 850px !important;\n  }\n  .h-xl-900px {\n    height: 900px !important;\n  }\n  .h-xl-950px {\n    height: 950px !important;\n  }\n  .h-xl-1000px {\n    height: 1000px !important;\n  }\n  .mh-xl-unset {\n    max-height: unset !important;\n  }\n  .mh-xl-25 {\n    max-height: 25% !important;\n  }\n  .mh-xl-50 {\n    max-height: 50% !important;\n  }\n  .mh-xl-75 {\n    max-height: 75% !important;\n  }\n  .mh-xl-100 {\n    max-height: 100% !important;\n  }\n  .mh-xl-auto {\n    max-height: auto !important;\n  }\n  .mh-xl-1px {\n    max-height: 1px !important;\n  }\n  .mh-xl-2px {\n    max-height: 2px !important;\n  }\n  .mh-xl-3px {\n    max-height: 3px !important;\n  }\n  .mh-xl-4px {\n    max-height: 4px !important;\n  }\n  .mh-xl-5px {\n    max-height: 5px !important;\n  }\n  .mh-xl-6px {\n    max-height: 6px !important;\n  }\n  .mh-xl-7px {\n    max-height: 7px !important;\n  }\n  .mh-xl-8px {\n    max-height: 8px !important;\n  }\n  .mh-xl-9px {\n    max-height: 9px !important;\n  }\n  .mh-xl-10px {\n    max-height: 10px !important;\n  }\n  .mh-xl-15px {\n    max-height: 15px !important;\n  }\n  .mh-xl-20px {\n    max-height: 20px !important;\n  }\n  .mh-xl-25px {\n    max-height: 25px !important;\n  }\n  .mh-xl-30px {\n    max-height: 30px !important;\n  }\n  .mh-xl-35px {\n    max-height: 35px !important;\n  }\n  .mh-xl-40px {\n    max-height: 40px !important;\n  }\n  .mh-xl-45px {\n    max-height: 45px !important;\n  }\n  .mh-xl-50px {\n    max-height: 50px !important;\n  }\n  .mh-xl-55px {\n    max-height: 55px !important;\n  }\n  .mh-xl-60px {\n    max-height: 60px !important;\n  }\n  .mh-xl-65px {\n    max-height: 65px !important;\n  }\n  .mh-xl-70px {\n    max-height: 70px !important;\n  }\n  .mh-xl-75px {\n    max-height: 75px !important;\n  }\n  .mh-xl-80px {\n    max-height: 80px !important;\n  }\n  .mh-xl-85px {\n    max-height: 85px !important;\n  }\n  .mh-xl-90px {\n    max-height: 90px !important;\n  }\n  .mh-xl-95px {\n    max-height: 95px !important;\n  }\n  .mh-xl-100px {\n    max-height: 100px !important;\n  }\n  .mh-xl-125px {\n    max-height: 125px !important;\n  }\n  .mh-xl-150px {\n    max-height: 150px !important;\n  }\n  .mh-xl-175px {\n    max-height: 175px !important;\n  }\n  .mh-xl-200px {\n    max-height: 200px !important;\n  }\n  .mh-xl-225px {\n    max-height: 225px !important;\n  }\n  .mh-xl-250px {\n    max-height: 250px !important;\n  }\n  .mh-xl-275px {\n    max-height: 275px !important;\n  }\n  .mh-xl-300px {\n    max-height: 300px !important;\n  }\n  .mh-xl-325px {\n    max-height: 325px !important;\n  }\n  .mh-xl-350px {\n    max-height: 350px !important;\n  }\n  .mh-xl-375px {\n    max-height: 375px !important;\n  }\n  .mh-xl-400px {\n    max-height: 400px !important;\n  }\n  .mh-xl-425px {\n    max-height: 425px !important;\n  }\n  .mh-xl-450px {\n    max-height: 450px !important;\n  }\n  .mh-xl-475px {\n    max-height: 475px !important;\n  }\n  .mh-xl-500px {\n    max-height: 500px !important;\n  }\n  .mh-xl-550px {\n    max-height: 550px !important;\n  }\n  .mh-xl-600px {\n    max-height: 600px !important;\n  }\n  .mh-xl-650px {\n    max-height: 650px !important;\n  }\n  .mh-xl-700px {\n    max-height: 700px !important;\n  }\n  .mh-xl-750px {\n    max-height: 750px !important;\n  }\n  .mh-xl-800px {\n    max-height: 800px !important;\n  }\n  .mh-xl-850px {\n    max-height: 850px !important;\n  }\n  .mh-xl-900px {\n    max-height: 900px !important;\n  }\n  .mh-xl-950px {\n    max-height: 950px !important;\n  }\n  .mh-xl-1000px {\n    max-height: 1000px !important;\n  }\n  .flex-xl-fill {\n    flex: 1 1 auto !important;\n  }\n  .flex-xl-row {\n    flex-direction: row !important;\n  }\n  .flex-xl-column {\n    flex-direction: column !important;\n  }\n  .flex-xl-row-reverse {\n    flex-direction: row-reverse !important;\n  }\n  .flex-xl-column-reverse {\n    flex-direction: column-reverse !important;\n  }\n  .flex-xl-grow-0 {\n    flex-grow: 0 !important;\n  }\n  .flex-xl-grow-1 {\n    flex-grow: 1 !important;\n  }\n  .flex-xl-shrink-0 {\n    flex-shrink: 0 !important;\n  }\n  .flex-xl-shrink-1 {\n    flex-shrink: 1 !important;\n  }\n  .flex-xl-wrap {\n    flex-wrap: wrap !important;\n  }\n  .flex-xl-nowrap {\n    flex-wrap: nowrap !important;\n  }\n  .flex-xl-wrap-reverse {\n    flex-wrap: wrap-reverse !important;\n  }\n  .justify-content-xl-start {\n    justify-content: flex-start !important;\n  }\n  .justify-content-xl-end {\n    justify-content: flex-end !important;\n  }\n  .justify-content-xl-center {\n    justify-content: center !important;\n  }\n  .justify-content-xl-between {\n    justify-content: space-between !important;\n  }\n  .justify-content-xl-around {\n    justify-content: space-around !important;\n  }\n  .justify-content-xl-evenly {\n    justify-content: space-evenly !important;\n  }\n  .align-items-xl-start {\n    align-items: flex-start !important;\n  }\n  .align-items-xl-end {\n    align-items: flex-end !important;\n  }\n  .align-items-xl-center {\n    align-items: center !important;\n  }\n  .align-items-xl-baseline {\n    align-items: baseline !important;\n  }\n  .align-items-xl-stretch {\n    align-items: stretch !important;\n  }\n  .align-content-xl-start {\n    align-content: flex-start !important;\n  }\n  .align-content-xl-end {\n    align-content: flex-end !important;\n  }\n  .align-content-xl-center {\n    align-content: center !important;\n  }\n  .align-content-xl-between {\n    align-content: space-between !important;\n  }\n  .align-content-xl-around {\n    align-content: space-around !important;\n  }\n  .align-content-xl-stretch {\n    align-content: stretch !important;\n  }\n  .align-self-xl-auto {\n    align-self: auto !important;\n  }\n  .align-self-xl-start {\n    align-self: flex-start !important;\n  }\n  .align-self-xl-end {\n    align-self: flex-end !important;\n  }\n  .align-self-xl-center {\n    align-self: center !important;\n  }\n  .align-self-xl-baseline {\n    align-self: baseline !important;\n  }\n  .align-self-xl-stretch {\n    align-self: stretch !important;\n  }\n  .order-xl-first {\n    order: -1 !important;\n  }\n  .order-xl-0 {\n    order: 0 !important;\n  }\n  .order-xl-1 {\n    order: 1 !important;\n  }\n  .order-xl-2 {\n    order: 2 !important;\n  }\n  .order-xl-3 {\n    order: 3 !important;\n  }\n  .order-xl-4 {\n    order: 4 !important;\n  }\n  .order-xl-5 {\n    order: 5 !important;\n  }\n  .order-xl-last {\n    order: 6 !important;\n  }\n  .m-xl-0 {\n    margin: 0 !important;\n  }\n  .m-xl-1 {\n    margin: 0.25rem !important;\n  }\n  .m-xl-2 {\n    margin: 0.5rem !important;\n  }\n  .m-xl-3 {\n    margin: 0.75rem !important;\n  }\n  .m-xl-4 {\n    margin: 1rem !important;\n  }\n  .m-xl-5 {\n    margin: 1.25rem !important;\n  }\n  .m-xl-6 {\n    margin: 1.5rem !important;\n  }\n  .m-xl-7 {\n    margin: 1.75rem !important;\n  }\n  .m-xl-8 {\n    margin: 2rem !important;\n  }\n  .m-xl-9 {\n    margin: 2.25rem !important;\n  }\n  .m-xl-10 {\n    margin: 2.5rem !important;\n  }\n  .m-xl-11 {\n    margin: 2.75rem !important;\n  }\n  .m-xl-12 {\n    margin: 3rem !important;\n  }\n  .m-xl-13 {\n    margin: 3.25rem !important;\n  }\n  .m-xl-14 {\n    margin: 3.5rem !important;\n  }\n  .m-xl-15 {\n    margin: 3.75rem !important;\n  }\n  .m-xl-16 {\n    margin: 4rem !important;\n  }\n  .m-xl-17 {\n    margin: 4.25rem !important;\n  }\n  .m-xl-18 {\n    margin: 4.5rem !important;\n  }\n  .m-xl-19 {\n    margin: 4.75rem !important;\n  }\n  .m-xl-20 {\n    margin: 5rem !important;\n  }\n  .m-xl-auto {\n    margin: auto !important;\n  }\n  .mx-xl-0 {\n    margin-right: 0 !important;\n    margin-left: 0 !important;\n  }\n  .mx-xl-1 {\n    margin-right: 0.25rem !important;\n    margin-left: 0.25rem !important;\n  }\n  .mx-xl-2 {\n    margin-right: 0.5rem !important;\n    margin-left: 0.5rem !important;\n  }\n  .mx-xl-3 {\n    margin-right: 0.75rem !important;\n    margin-left: 0.75rem !important;\n  }\n  .mx-xl-4 {\n    margin-right: 1rem !important;\n    margin-left: 1rem !important;\n  }\n  .mx-xl-5 {\n    margin-right: 1.25rem !important;\n    margin-left: 1.25rem !important;\n  }\n  .mx-xl-6 {\n    margin-right: 1.5rem !important;\n    margin-left: 1.5rem !important;\n  }\n  .mx-xl-7 {\n    margin-right: 1.75rem !important;\n    margin-left: 1.75rem !important;\n  }\n  .mx-xl-8 {\n    margin-right: 2rem !important;\n    margin-left: 2rem !important;\n  }\n  .mx-xl-9 {\n    margin-right: 2.25rem !important;\n    margin-left: 2.25rem !important;\n  }\n  .mx-xl-10 {\n    margin-right: 2.5rem !important;\n    margin-left: 2.5rem !important;\n  }\n  .mx-xl-11 {\n    margin-right: 2.75rem !important;\n    margin-left: 2.75rem !important;\n  }\n  .mx-xl-12 {\n    margin-right: 3rem !important;\n    margin-left: 3rem !important;\n  }\n  .mx-xl-13 {\n    margin-right: 3.25rem !important;\n    margin-left: 3.25rem !important;\n  }\n  .mx-xl-14 {\n    margin-right: 3.5rem !important;\n    margin-left: 3.5rem !important;\n  }\n  .mx-xl-15 {\n    margin-right: 3.75rem !important;\n    margin-left: 3.75rem !important;\n  }\n  .mx-xl-16 {\n    margin-right: 4rem !important;\n    margin-left: 4rem !important;\n  }\n  .mx-xl-17 {\n    margin-right: 4.25rem !important;\n    margin-left: 4.25rem !important;\n  }\n  .mx-xl-18 {\n    margin-right: 4.5rem !important;\n    margin-left: 4.5rem !important;\n  }\n  .mx-xl-19 {\n    margin-right: 4.75rem !important;\n    margin-left: 4.75rem !important;\n  }\n  .mx-xl-20 {\n    margin-right: 5rem !important;\n    margin-left: 5rem !important;\n  }\n  .mx-xl-auto {\n    margin-right: auto !important;\n    margin-left: auto !important;\n  }\n  .my-xl-0 {\n    margin-top: 0 !important;\n    margin-bottom: 0 !important;\n  }\n  .my-xl-1 {\n    margin-top: 0.25rem !important;\n    margin-bottom: 0.25rem !important;\n  }\n  .my-xl-2 {\n    margin-top: 0.5rem !important;\n    margin-bottom: 0.5rem !important;\n  }\n  .my-xl-3 {\n    margin-top: 0.75rem !important;\n    margin-bottom: 0.75rem !important;\n  }\n  .my-xl-4 {\n    margin-top: 1rem !important;\n    margin-bottom: 1rem !important;\n  }\n  .my-xl-5 {\n    margin-top: 1.25rem !important;\n    margin-bottom: 1.25rem !important;\n  }\n  .my-xl-6 {\n    margin-top: 1.5rem !important;\n    margin-bottom: 1.5rem !important;\n  }\n  .my-xl-7 {\n    margin-top: 1.75rem !important;\n    margin-bottom: 1.75rem !important;\n  }\n  .my-xl-8 {\n    margin-top: 2rem !important;\n    margin-bottom: 2rem !important;\n  }\n  .my-xl-9 {\n    margin-top: 2.25rem !important;\n    margin-bottom: 2.25rem !important;\n  }\n  .my-xl-10 {\n    margin-top: 2.5rem !important;\n    margin-bottom: 2.5rem !important;\n  }\n  .my-xl-11 {\n    margin-top: 2.75rem !important;\n    margin-bottom: 2.75rem !important;\n  }\n  .my-xl-12 {\n    margin-top: 3rem !important;\n    margin-bottom: 3rem !important;\n  }\n  .my-xl-13 {\n    margin-top: 3.25rem !important;\n    margin-bottom: 3.25rem !important;\n  }\n  .my-xl-14 {\n    margin-top: 3.5rem !important;\n    margin-bottom: 3.5rem !important;\n  }\n  .my-xl-15 {\n    margin-top: 3.75rem !important;\n    margin-bottom: 3.75rem !important;\n  }\n  .my-xl-16 {\n    margin-top: 4rem !important;\n    margin-bottom: 4rem !important;\n  }\n  .my-xl-17 {\n    margin-top: 4.25rem !important;\n    margin-bottom: 4.25rem !important;\n  }\n  .my-xl-18 {\n    margin-top: 4.5rem !important;\n    margin-bottom: 4.5rem !important;\n  }\n  .my-xl-19 {\n    margin-top: 4.75rem !important;\n    margin-bottom: 4.75rem !important;\n  }\n  .my-xl-20 {\n    margin-top: 5rem !important;\n    margin-bottom: 5rem !important;\n  }\n  .my-xl-auto {\n    margin-top: auto !important;\n    margin-bottom: auto !important;\n  }\n  .mt-xl-0 {\n    margin-top: 0 !important;\n  }\n  .mt-xl-1 {\n    margin-top: 0.25rem !important;\n  }\n  .mt-xl-2 {\n    margin-top: 0.5rem !important;\n  }\n  .mt-xl-3 {\n    margin-top: 0.75rem !important;\n  }\n  .mt-xl-4 {\n    margin-top: 1rem !important;\n  }\n  .mt-xl-5 {\n    margin-top: 1.25rem !important;\n  }\n  .mt-xl-6 {\n    margin-top: 1.5rem !important;\n  }\n  .mt-xl-7 {\n    margin-top: 1.75rem !important;\n  }\n  .mt-xl-8 {\n    margin-top: 2rem !important;\n  }\n  .mt-xl-9 {\n    margin-top: 2.25rem !important;\n  }\n  .mt-xl-10 {\n    margin-top: 2.5rem !important;\n  }\n  .mt-xl-11 {\n    margin-top: 2.75rem !important;\n  }\n  .mt-xl-12 {\n    margin-top: 3rem !important;\n  }\n  .mt-xl-13 {\n    margin-top: 3.25rem !important;\n  }\n  .mt-xl-14 {\n    margin-top: 3.5rem !important;\n  }\n  .mt-xl-15 {\n    margin-top: 3.75rem !important;\n  }\n  .mt-xl-16 {\n    margin-top: 4rem !important;\n  }\n  .mt-xl-17 {\n    margin-top: 4.25rem !important;\n  }\n  .mt-xl-18 {\n    margin-top: 4.5rem !important;\n  }\n  .mt-xl-19 {\n    margin-top: 4.75rem !important;\n  }\n  .mt-xl-20 {\n    margin-top: 5rem !important;\n  }\n  .mt-xl-auto {\n    margin-top: auto !important;\n  }\n  .me-xl-0 {\n    margin-right: 0 !important;\n  }\n  .me-xl-1 {\n    margin-right: 0.25rem !important;\n  }\n  .me-xl-2 {\n    margin-right: 0.5rem !important;\n  }\n  .me-xl-3 {\n    margin-right: 0.75rem !important;\n  }\n  .me-xl-4 {\n    margin-right: 1rem !important;\n  }\n  .me-xl-5 {\n    margin-right: 1.25rem !important;\n  }\n  .me-xl-6 {\n    margin-right: 1.5rem !important;\n  }\n  .me-xl-7 {\n    margin-right: 1.75rem !important;\n  }\n  .me-xl-8 {\n    margin-right: 2rem !important;\n  }\n  .me-xl-9 {\n    margin-right: 2.25rem !important;\n  }\n  .me-xl-10 {\n    margin-right: 2.5rem !important;\n  }\n  .me-xl-11 {\n    margin-right: 2.75rem !important;\n  }\n  .me-xl-12 {\n    margin-right: 3rem !important;\n  }\n  .me-xl-13 {\n    margin-right: 3.25rem !important;\n  }\n  .me-xl-14 {\n    margin-right: 3.5rem !important;\n  }\n  .me-xl-15 {\n    margin-right: 3.75rem !important;\n  }\n  .me-xl-16 {\n    margin-right: 4rem !important;\n  }\n  .me-xl-17 {\n    margin-right: 4.25rem !important;\n  }\n  .me-xl-18 {\n    margin-right: 4.5rem !important;\n  }\n  .me-xl-19 {\n    margin-right: 4.75rem !important;\n  }\n  .me-xl-20 {\n    margin-right: 5rem !important;\n  }\n  .me-xl-auto {\n    margin-right: auto !important;\n  }\n  .mb-xl-0 {\n    margin-bottom: 0 !important;\n  }\n  .mb-xl-1 {\n    margin-bottom: 0.25rem !important;\n  }\n  .mb-xl-2 {\n    margin-bottom: 0.5rem !important;\n  }\n  .mb-xl-3 {\n    margin-bottom: 0.75rem !important;\n  }\n  .mb-xl-4 {\n    margin-bottom: 1rem !important;\n  }\n  .mb-xl-5 {\n    margin-bottom: 1.25rem !important;\n  }\n  .mb-xl-6 {\n    margin-bottom: 1.5rem !important;\n  }\n  .mb-xl-7 {\n    margin-bottom: 1.75rem !important;\n  }\n  .mb-xl-8 {\n    margin-bottom: 2rem !important;\n  }\n  .mb-xl-9 {\n    margin-bottom: 2.25rem !important;\n  }\n  .mb-xl-10 {\n    margin-bottom: 2.5rem !important;\n  }\n  .mb-xl-11 {\n    margin-bottom: 2.75rem !important;\n  }\n  .mb-xl-12 {\n    margin-bottom: 3rem !important;\n  }\n  .mb-xl-13 {\n    margin-bottom: 3.25rem !important;\n  }\n  .mb-xl-14 {\n    margin-bottom: 3.5rem !important;\n  }\n  .mb-xl-15 {\n    margin-bottom: 3.75rem !important;\n  }\n  .mb-xl-16 {\n    margin-bottom: 4rem !important;\n  }\n  .mb-xl-17 {\n    margin-bottom: 4.25rem !important;\n  }\n  .mb-xl-18 {\n    margin-bottom: 4.5rem !important;\n  }\n  .mb-xl-19 {\n    margin-bottom: 4.75rem !important;\n  }\n  .mb-xl-20 {\n    margin-bottom: 5rem !important;\n  }\n  .mb-xl-auto {\n    margin-bottom: auto !important;\n  }\n  .ms-xl-0 {\n    margin-left: 0 !important;\n  }\n  .ms-xl-1 {\n    margin-left: 0.25rem !important;\n  }\n  .ms-xl-2 {\n    margin-left: 0.5rem !important;\n  }\n  .ms-xl-3 {\n    margin-left: 0.75rem !important;\n  }\n  .ms-xl-4 {\n    margin-left: 1rem !important;\n  }\n  .ms-xl-5 {\n    margin-left: 1.25rem !important;\n  }\n  .ms-xl-6 {\n    margin-left: 1.5rem !important;\n  }\n  .ms-xl-7 {\n    margin-left: 1.75rem !important;\n  }\n  .ms-xl-8 {\n    margin-left: 2rem !important;\n  }\n  .ms-xl-9 {\n    margin-left: 2.25rem !important;\n  }\n  .ms-xl-10 {\n    margin-left: 2.5rem !important;\n  }\n  .ms-xl-11 {\n    margin-left: 2.75rem !important;\n  }\n  .ms-xl-12 {\n    margin-left: 3rem !important;\n  }\n  .ms-xl-13 {\n    margin-left: 3.25rem !important;\n  }\n  .ms-xl-14 {\n    margin-left: 3.5rem !important;\n  }\n  .ms-xl-15 {\n    margin-left: 3.75rem !important;\n  }\n  .ms-xl-16 {\n    margin-left: 4rem !important;\n  }\n  .ms-xl-17 {\n    margin-left: 4.25rem !important;\n  }\n  .ms-xl-18 {\n    margin-left: 4.5rem !important;\n  }\n  .ms-xl-19 {\n    margin-left: 4.75rem !important;\n  }\n  .ms-xl-20 {\n    margin-left: 5rem !important;\n  }\n  .ms-xl-auto {\n    margin-left: auto !important;\n  }\n  .m-xl-n1 {\n    margin: -0.25rem !important;\n  }\n  .m-xl-n2 {\n    margin: -0.5rem !important;\n  }\n  .m-xl-n3 {\n    margin: -0.75rem !important;\n  }\n  .m-xl-n4 {\n    margin: -1rem !important;\n  }\n  .m-xl-n5 {\n    margin: -1.25rem !important;\n  }\n  .m-xl-n6 {\n    margin: -1.5rem !important;\n  }\n  .m-xl-n7 {\n    margin: -1.75rem !important;\n  }\n  .m-xl-n8 {\n    margin: -2rem !important;\n  }\n  .m-xl-n9 {\n    margin: -2.25rem !important;\n  }\n  .m-xl-n10 {\n    margin: -2.5rem !important;\n  }\n  .m-xl-n11 {\n    margin: -2.75rem !important;\n  }\n  .m-xl-n12 {\n    margin: -3rem !important;\n  }\n  .m-xl-n13 {\n    margin: -3.25rem !important;\n  }\n  .m-xl-n14 {\n    margin: -3.5rem !important;\n  }\n  .m-xl-n15 {\n    margin: -3.75rem !important;\n  }\n  .m-xl-n16 {\n    margin: -4rem !important;\n  }\n  .m-xl-n17 {\n    margin: -4.25rem !important;\n  }\n  .m-xl-n18 {\n    margin: -4.5rem !important;\n  }\n  .m-xl-n19 {\n    margin: -4.75rem !important;\n  }\n  .m-xl-n20 {\n    margin: -5rem !important;\n  }\n  .mx-xl-n1 {\n    margin-right: -0.25rem !important;\n    margin-left: -0.25rem !important;\n  }\n  .mx-xl-n2 {\n    margin-right: -0.5rem !important;\n    margin-left: -0.5rem !important;\n  }\n  .mx-xl-n3 {\n    margin-right: -0.75rem !important;\n    margin-left: -0.75rem !important;\n  }\n  .mx-xl-n4 {\n    margin-right: -1rem !important;\n    margin-left: -1rem !important;\n  }\n  .mx-xl-n5 {\n    margin-right: -1.25rem !important;\n    margin-left: -1.25rem !important;\n  }\n  .mx-xl-n6 {\n    margin-right: -1.5rem !important;\n    margin-left: -1.5rem !important;\n  }\n  .mx-xl-n7 {\n    margin-right: -1.75rem !important;\n    margin-left: -1.75rem !important;\n  }\n  .mx-xl-n8 {\n    margin-right: -2rem !important;\n    margin-left: -2rem !important;\n  }\n  .mx-xl-n9 {\n    margin-right: -2.25rem !important;\n    margin-left: -2.25rem !important;\n  }\n  .mx-xl-n10 {\n    margin-right: -2.5rem !important;\n    margin-left: -2.5rem !important;\n  }\n  .mx-xl-n11 {\n    margin-right: -2.75rem !important;\n    margin-left: -2.75rem !important;\n  }\n  .mx-xl-n12 {\n    margin-right: -3rem !important;\n    margin-left: -3rem !important;\n  }\n  .mx-xl-n13 {\n    margin-right: -3.25rem !important;\n    margin-left: -3.25rem !important;\n  }\n  .mx-xl-n14 {\n    margin-right: -3.5rem !important;\n    margin-left: -3.5rem !important;\n  }\n  .mx-xl-n15 {\n    margin-right: -3.75rem !important;\n    margin-left: -3.75rem !important;\n  }\n  .mx-xl-n16 {\n    margin-right: -4rem !important;\n    margin-left: -4rem !important;\n  }\n  .mx-xl-n17 {\n    margin-right: -4.25rem !important;\n    margin-left: -4.25rem !important;\n  }\n  .mx-xl-n18 {\n    margin-right: -4.5rem !important;\n    margin-left: -4.5rem !important;\n  }\n  .mx-xl-n19 {\n    margin-right: -4.75rem !important;\n    margin-left: -4.75rem !important;\n  }\n  .mx-xl-n20 {\n    margin-right: -5rem !important;\n    margin-left: -5rem !important;\n  }\n  .my-xl-n1 {\n    margin-top: -0.25rem !important;\n    margin-bottom: -0.25rem !important;\n  }\n  .my-xl-n2 {\n    margin-top: -0.5rem !important;\n    margin-bottom: -0.5rem !important;\n  }\n  .my-xl-n3 {\n    margin-top: -0.75rem !important;\n    margin-bottom: -0.75rem !important;\n  }\n  .my-xl-n4 {\n    margin-top: -1rem !important;\n    margin-bottom: -1rem !important;\n  }\n  .my-xl-n5 {\n    margin-top: -1.25rem !important;\n    margin-bottom: -1.25rem !important;\n  }\n  .my-xl-n6 {\n    margin-top: -1.5rem !important;\n    margin-bottom: -1.5rem !important;\n  }\n  .my-xl-n7 {\n    margin-top: -1.75rem !important;\n    margin-bottom: -1.75rem !important;\n  }\n  .my-xl-n8 {\n    margin-top: -2rem !important;\n    margin-bottom: -2rem !important;\n  }\n  .my-xl-n9 {\n    margin-top: -2.25rem !important;\n    margin-bottom: -2.25rem !important;\n  }\n  .my-xl-n10 {\n    margin-top: -2.5rem !important;\n    margin-bottom: -2.5rem !important;\n  }\n  .my-xl-n11 {\n    margin-top: -2.75rem !important;\n    margin-bottom: -2.75rem !important;\n  }\n  .my-xl-n12 {\n    margin-top: -3rem !important;\n    margin-bottom: -3rem !important;\n  }\n  .my-xl-n13 {\n    margin-top: -3.25rem !important;\n    margin-bottom: -3.25rem !important;\n  }\n  .my-xl-n14 {\n    margin-top: -3.5rem !important;\n    margin-bottom: -3.5rem !important;\n  }\n  .my-xl-n15 {\n    margin-top: -3.75rem !important;\n    margin-bottom: -3.75rem !important;\n  }\n  .my-xl-n16 {\n    margin-top: -4rem !important;\n    margin-bottom: -4rem !important;\n  }\n  .my-xl-n17 {\n    margin-top: -4.25rem !important;\n    margin-bottom: -4.25rem !important;\n  }\n  .my-xl-n18 {\n    margin-top: -4.5rem !important;\n    margin-bottom: -4.5rem !important;\n  }\n  .my-xl-n19 {\n    margin-top: -4.75rem !important;\n    margin-bottom: -4.75rem !important;\n  }\n  .my-xl-n20 {\n    margin-top: -5rem !important;\n    margin-bottom: -5rem !important;\n  }\n  .mt-xl-n1 {\n    margin-top: -0.25rem !important;\n  }\n  .mt-xl-n2 {\n    margin-top: -0.5rem !important;\n  }\n  .mt-xl-n3 {\n    margin-top: -0.75rem !important;\n  }\n  .mt-xl-n4 {\n    margin-top: -1rem !important;\n  }\n  .mt-xl-n5 {\n    margin-top: -1.25rem !important;\n  }\n  .mt-xl-n6 {\n    margin-top: -1.5rem !important;\n  }\n  .mt-xl-n7 {\n    margin-top: -1.75rem !important;\n  }\n  .mt-xl-n8 {\n    margin-top: -2rem !important;\n  }\n  .mt-xl-n9 {\n    margin-top: -2.25rem !important;\n  }\n  .mt-xl-n10 {\n    margin-top: -2.5rem !important;\n  }\n  .mt-xl-n11 {\n    margin-top: -2.75rem !important;\n  }\n  .mt-xl-n12 {\n    margin-top: -3rem !important;\n  }\n  .mt-xl-n13 {\n    margin-top: -3.25rem !important;\n  }\n  .mt-xl-n14 {\n    margin-top: -3.5rem !important;\n  }\n  .mt-xl-n15 {\n    margin-top: -3.75rem !important;\n  }\n  .mt-xl-n16 {\n    margin-top: -4rem !important;\n  }\n  .mt-xl-n17 {\n    margin-top: -4.25rem !important;\n  }\n  .mt-xl-n18 {\n    margin-top: -4.5rem !important;\n  }\n  .mt-xl-n19 {\n    margin-top: -4.75rem !important;\n  }\n  .mt-xl-n20 {\n    margin-top: -5rem !important;\n  }\n  .me-xl-n1 {\n    margin-right: -0.25rem !important;\n  }\n  .me-xl-n2 {\n    margin-right: -0.5rem !important;\n  }\n  .me-xl-n3 {\n    margin-right: -0.75rem !important;\n  }\n  .me-xl-n4 {\n    margin-right: -1rem !important;\n  }\n  .me-xl-n5 {\n    margin-right: -1.25rem !important;\n  }\n  .me-xl-n6 {\n    margin-right: -1.5rem !important;\n  }\n  .me-xl-n7 {\n    margin-right: -1.75rem !important;\n  }\n  .me-xl-n8 {\n    margin-right: -2rem !important;\n  }\n  .me-xl-n9 {\n    margin-right: -2.25rem !important;\n  }\n  .me-xl-n10 {\n    margin-right: -2.5rem !important;\n  }\n  .me-xl-n11 {\n    margin-right: -2.75rem !important;\n  }\n  .me-xl-n12 {\n    margin-right: -3rem !important;\n  }\n  .me-xl-n13 {\n    margin-right: -3.25rem !important;\n  }\n  .me-xl-n14 {\n    margin-right: -3.5rem !important;\n  }\n  .me-xl-n15 {\n    margin-right: -3.75rem !important;\n  }\n  .me-xl-n16 {\n    margin-right: -4rem !important;\n  }\n  .me-xl-n17 {\n    margin-right: -4.25rem !important;\n  }\n  .me-xl-n18 {\n    margin-right: -4.5rem !important;\n  }\n  .me-xl-n19 {\n    margin-right: -4.75rem !important;\n  }\n  .me-xl-n20 {\n    margin-right: -5rem !important;\n  }\n  .mb-xl-n1 {\n    margin-bottom: -0.25rem !important;\n  }\n  .mb-xl-n2 {\n    margin-bottom: -0.5rem !important;\n  }\n  .mb-xl-n3 {\n    margin-bottom: -0.75rem !important;\n  }\n  .mb-xl-n4 {\n    margin-bottom: -1rem !important;\n  }\n  .mb-xl-n5 {\n    margin-bottom: -1.25rem !important;\n  }\n  .mb-xl-n6 {\n    margin-bottom: -1.5rem !important;\n  }\n  .mb-xl-n7 {\n    margin-bottom: -1.75rem !important;\n  }\n  .mb-xl-n8 {\n    margin-bottom: -2rem !important;\n  }\n  .mb-xl-n9 {\n    margin-bottom: -2.25rem !important;\n  }\n  .mb-xl-n10 {\n    margin-bottom: -2.5rem !important;\n  }\n  .mb-xl-n11 {\n    margin-bottom: -2.75rem !important;\n  }\n  .mb-xl-n12 {\n    margin-bottom: -3rem !important;\n  }\n  .mb-xl-n13 {\n    margin-bottom: -3.25rem !important;\n  }\n  .mb-xl-n14 {\n    margin-bottom: -3.5rem !important;\n  }\n  .mb-xl-n15 {\n    margin-bottom: -3.75rem !important;\n  }\n  .mb-xl-n16 {\n    margin-bottom: -4rem !important;\n  }\n  .mb-xl-n17 {\n    margin-bottom: -4.25rem !important;\n  }\n  .mb-xl-n18 {\n    margin-bottom: -4.5rem !important;\n  }\n  .mb-xl-n19 {\n    margin-bottom: -4.75rem !important;\n  }\n  .mb-xl-n20 {\n    margin-bottom: -5rem !important;\n  }\n  .ms-xl-n1 {\n    margin-left: -0.25rem !important;\n  }\n  .ms-xl-n2 {\n    margin-left: -0.5rem !important;\n  }\n  .ms-xl-n3 {\n    margin-left: -0.75rem !important;\n  }\n  .ms-xl-n4 {\n    margin-left: -1rem !important;\n  }\n  .ms-xl-n5 {\n    margin-left: -1.25rem !important;\n  }\n  .ms-xl-n6 {\n    margin-left: -1.5rem !important;\n  }\n  .ms-xl-n7 {\n    margin-left: -1.75rem !important;\n  }\n  .ms-xl-n8 {\n    margin-left: -2rem !important;\n  }\n  .ms-xl-n9 {\n    margin-left: -2.25rem !important;\n  }\n  .ms-xl-n10 {\n    margin-left: -2.5rem !important;\n  }\n  .ms-xl-n11 {\n    margin-left: -2.75rem !important;\n  }\n  .ms-xl-n12 {\n    margin-left: -3rem !important;\n  }\n  .ms-xl-n13 {\n    margin-left: -3.25rem !important;\n  }\n  .ms-xl-n14 {\n    margin-left: -3.5rem !important;\n  }\n  .ms-xl-n15 {\n    margin-left: -3.75rem !important;\n  }\n  .ms-xl-n16 {\n    margin-left: -4rem !important;\n  }\n  .ms-xl-n17 {\n    margin-left: -4.25rem !important;\n  }\n  .ms-xl-n18 {\n    margin-left: -4.5rem !important;\n  }\n  .ms-xl-n19 {\n    margin-left: -4.75rem !important;\n  }\n  .ms-xl-n20 {\n    margin-left: -5rem !important;\n  }\n  .p-xl-0 {\n    padding: 0 !important;\n  }\n  .p-xl-1 {\n    padding: 0.25rem !important;\n  }\n  .p-xl-2 {\n    padding: 0.5rem !important;\n  }\n  .p-xl-3 {\n    padding: 0.75rem !important;\n  }\n  .p-xl-4 {\n    padding: 1rem !important;\n  }\n  .p-xl-5 {\n    padding: 1.25rem !important;\n  }\n  .p-xl-6 {\n    padding: 1.5rem !important;\n  }\n  .p-xl-7 {\n    padding: 1.75rem !important;\n  }\n  .p-xl-8 {\n    padding: 2rem !important;\n  }\n  .p-xl-9 {\n    padding: 2.25rem !important;\n  }\n  .p-xl-10 {\n    padding: 2.5rem !important;\n  }\n  .p-xl-11 {\n    padding: 2.75rem !important;\n  }\n  .p-xl-12 {\n    padding: 3rem !important;\n  }\n  .p-xl-13 {\n    padding: 3.25rem !important;\n  }\n  .p-xl-14 {\n    padding: 3.5rem !important;\n  }\n  .p-xl-15 {\n    padding: 3.75rem !important;\n  }\n  .p-xl-16 {\n    padding: 4rem !important;\n  }\n  .p-xl-17 {\n    padding: 4.25rem !important;\n  }\n  .p-xl-18 {\n    padding: 4.5rem !important;\n  }\n  .p-xl-19 {\n    padding: 4.75rem !important;\n  }\n  .p-xl-20 {\n    padding: 5rem !important;\n  }\n  .px-xl-0 {\n    padding-right: 0 !important;\n    padding-left: 0 !important;\n  }\n  .px-xl-1 {\n    padding-right: 0.25rem !important;\n    padding-left: 0.25rem !important;\n  }\n  .px-xl-2 {\n    padding-right: 0.5rem !important;\n    padding-left: 0.5rem !important;\n  }\n  .px-xl-3 {\n    padding-right: 0.75rem !important;\n    padding-left: 0.75rem !important;\n  }\n  .px-xl-4 {\n    padding-right: 1rem !important;\n    padding-left: 1rem !important;\n  }\n  .px-xl-5 {\n    padding-right: 1.25rem !important;\n    padding-left: 1.25rem !important;\n  }\n  .px-xl-6 {\n    padding-right: 1.5rem !important;\n    padding-left: 1.5rem !important;\n  }\n  .px-xl-7 {\n    padding-right: 1.75rem !important;\n    padding-left: 1.75rem !important;\n  }\n  .px-xl-8 {\n    padding-right: 2rem !important;\n    padding-left: 2rem !important;\n  }\n  .px-xl-9 {\n    padding-right: 2.25rem !important;\n    padding-left: 2.25rem !important;\n  }\n  .px-xl-10 {\n    padding-right: 2.5rem !important;\n    padding-left: 2.5rem !important;\n  }\n  .px-xl-11 {\n    padding-right: 2.75rem !important;\n    padding-left: 2.75rem !important;\n  }\n  .px-xl-12 {\n    padding-right: 3rem !important;\n    padding-left: 3rem !important;\n  }\n  .px-xl-13 {\n    padding-right: 3.25rem !important;\n    padding-left: 3.25rem !important;\n  }\n  .px-xl-14 {\n    padding-right: 3.5rem !important;\n    padding-left: 3.5rem !important;\n  }\n  .px-xl-15 {\n    padding-right: 3.75rem !important;\n    padding-left: 3.75rem !important;\n  }\n  .px-xl-16 {\n    padding-right: 4rem !important;\n    padding-left: 4rem !important;\n  }\n  .px-xl-17 {\n    padding-right: 4.25rem !important;\n    padding-left: 4.25rem !important;\n  }\n  .px-xl-18 {\n    padding-right: 4.5rem !important;\n    padding-left: 4.5rem !important;\n  }\n  .px-xl-19 {\n    padding-right: 4.75rem !important;\n    padding-left: 4.75rem !important;\n  }\n  .px-xl-20 {\n    padding-right: 5rem !important;\n    padding-left: 5rem !important;\n  }\n  .py-xl-0 {\n    padding-top: 0 !important;\n    padding-bottom: 0 !important;\n  }\n  .py-xl-1 {\n    padding-top: 0.25rem !important;\n    padding-bottom: 0.25rem !important;\n  }\n  .py-xl-2 {\n    padding-top: 0.5rem !important;\n    padding-bottom: 0.5rem !important;\n  }\n  .py-xl-3 {\n    padding-top: 0.75rem !important;\n    padding-bottom: 0.75rem !important;\n  }\n  .py-xl-4 {\n    padding-top: 1rem !important;\n    padding-bottom: 1rem !important;\n  }\n  .py-xl-5 {\n    padding-top: 1.25rem !important;\n    padding-bottom: 1.25rem !important;\n  }\n  .py-xl-6 {\n    padding-top: 1.5rem !important;\n    padding-bottom: 1.5rem !important;\n  }\n  .py-xl-7 {\n    padding-top: 1.75rem !important;\n    padding-bottom: 1.75rem !important;\n  }\n  .py-xl-8 {\n    padding-top: 2rem !important;\n    padding-bottom: 2rem !important;\n  }\n  .py-xl-9 {\n    padding-top: 2.25rem !important;\n    padding-bottom: 2.25rem !important;\n  }\n  .py-xl-10 {\n    padding-top: 2.5rem !important;\n    padding-bottom: 2.5rem !important;\n  }\n  .py-xl-11 {\n    padding-top: 2.75rem !important;\n    padding-bottom: 2.75rem !important;\n  }\n  .py-xl-12 {\n    padding-top: 3rem !important;\n    padding-bottom: 3rem !important;\n  }\n  .py-xl-13 {\n    padding-top: 3.25rem !important;\n    padding-bottom: 3.25rem !important;\n  }\n  .py-xl-14 {\n    padding-top: 3.5rem !important;\n    padding-bottom: 3.5rem !important;\n  }\n  .py-xl-15 {\n    padding-top: 3.75rem !important;\n    padding-bottom: 3.75rem !important;\n  }\n  .py-xl-16 {\n    padding-top: 4rem !important;\n    padding-bottom: 4rem !important;\n  }\n  .py-xl-17 {\n    padding-top: 4.25rem !important;\n    padding-bottom: 4.25rem !important;\n  }\n  .py-xl-18 {\n    padding-top: 4.5rem !important;\n    padding-bottom: 4.5rem !important;\n  }\n  .py-xl-19 {\n    padding-top: 4.75rem !important;\n    padding-bottom: 4.75rem !important;\n  }\n  .py-xl-20 {\n    padding-top: 5rem !important;\n    padding-bottom: 5rem !important;\n  }\n  .pt-xl-0 {\n    padding-top: 0 !important;\n  }\n  .pt-xl-1 {\n    padding-top: 0.25rem !important;\n  }\n  .pt-xl-2 {\n    padding-top: 0.5rem !important;\n  }\n  .pt-xl-3 {\n    padding-top: 0.75rem !important;\n  }\n  .pt-xl-4 {\n    padding-top: 1rem !important;\n  }\n  .pt-xl-5 {\n    padding-top: 1.25rem !important;\n  }\n  .pt-xl-6 {\n    padding-top: 1.5rem !important;\n  }\n  .pt-xl-7 {\n    padding-top: 1.75rem !important;\n  }\n  .pt-xl-8 {\n    padding-top: 2rem !important;\n  }\n  .pt-xl-9 {\n    padding-top: 2.25rem !important;\n  }\n  .pt-xl-10 {\n    padding-top: 2.5rem !important;\n  }\n  .pt-xl-11 {\n    padding-top: 2.75rem !important;\n  }\n  .pt-xl-12 {\n    padding-top: 3rem !important;\n  }\n  .pt-xl-13 {\n    padding-top: 3.25rem !important;\n  }\n  .pt-xl-14 {\n    padding-top: 3.5rem !important;\n  }\n  .pt-xl-15 {\n    padding-top: 3.75rem !important;\n  }\n  .pt-xl-16 {\n    padding-top: 4rem !important;\n  }\n  .pt-xl-17 {\n    padding-top: 4.25rem !important;\n  }\n  .pt-xl-18 {\n    padding-top: 4.5rem !important;\n  }\n  .pt-xl-19 {\n    padding-top: 4.75rem !important;\n  }\n  .pt-xl-20 {\n    padding-top: 5rem !important;\n  }\n  .pe-xl-0 {\n    padding-right: 0 !important;\n  }\n  .pe-xl-1 {\n    padding-right: 0.25rem !important;\n  }\n  .pe-xl-2 {\n    padding-right: 0.5rem !important;\n  }\n  .pe-xl-3 {\n    padding-right: 0.75rem !important;\n  }\n  .pe-xl-4 {\n    padding-right: 1rem !important;\n  }\n  .pe-xl-5 {\n    padding-right: 1.25rem !important;\n  }\n  .pe-xl-6 {\n    padding-right: 1.5rem !important;\n  }\n  .pe-xl-7 {\n    padding-right: 1.75rem !important;\n  }\n  .pe-xl-8 {\n    padding-right: 2rem !important;\n  }\n  .pe-xl-9 {\n    padding-right: 2.25rem !important;\n  }\n  .pe-xl-10 {\n    padding-right: 2.5rem !important;\n  }\n  .pe-xl-11 {\n    padding-right: 2.75rem !important;\n  }\n  .pe-xl-12 {\n    padding-right: 3rem !important;\n  }\n  .pe-xl-13 {\n    padding-right: 3.25rem !important;\n  }\n  .pe-xl-14 {\n    padding-right: 3.5rem !important;\n  }\n  .pe-xl-15 {\n    padding-right: 3.75rem !important;\n  }\n  .pe-xl-16 {\n    padding-right: 4rem !important;\n  }\n  .pe-xl-17 {\n    padding-right: 4.25rem !important;\n  }\n  .pe-xl-18 {\n    padding-right: 4.5rem !important;\n  }\n  .pe-xl-19 {\n    padding-right: 4.75rem !important;\n  }\n  .pe-xl-20 {\n    padding-right: 5rem !important;\n  }\n  .pb-xl-0 {\n    padding-bottom: 0 !important;\n  }\n  .pb-xl-1 {\n    padding-bottom: 0.25rem !important;\n  }\n  .pb-xl-2 {\n    padding-bottom: 0.5rem !important;\n  }\n  .pb-xl-3 {\n    padding-bottom: 0.75rem !important;\n  }\n  .pb-xl-4 {\n    padding-bottom: 1rem !important;\n  }\n  .pb-xl-5 {\n    padding-bottom: 1.25rem !important;\n  }\n  .pb-xl-6 {\n    padding-bottom: 1.5rem !important;\n  }\n  .pb-xl-7 {\n    padding-bottom: 1.75rem !important;\n  }\n  .pb-xl-8 {\n    padding-bottom: 2rem !important;\n  }\n  .pb-xl-9 {\n    padding-bottom: 2.25rem !important;\n  }\n  .pb-xl-10 {\n    padding-bottom: 2.5rem !important;\n  }\n  .pb-xl-11 {\n    padding-bottom: 2.75rem !important;\n  }\n  .pb-xl-12 {\n    padding-bottom: 3rem !important;\n  }\n  .pb-xl-13 {\n    padding-bottom: 3.25rem !important;\n  }\n  .pb-xl-14 {\n    padding-bottom: 3.5rem !important;\n  }\n  .pb-xl-15 {\n    padding-bottom: 3.75rem !important;\n  }\n  .pb-xl-16 {\n    padding-bottom: 4rem !important;\n  }\n  .pb-xl-17 {\n    padding-bottom: 4.25rem !important;\n  }\n  .pb-xl-18 {\n    padding-bottom: 4.5rem !important;\n  }\n  .pb-xl-19 {\n    padding-bottom: 4.75rem !important;\n  }\n  .pb-xl-20 {\n    padding-bottom: 5rem !important;\n  }\n  .ps-xl-0 {\n    padding-left: 0 !important;\n  }\n  .ps-xl-1 {\n    padding-left: 0.25rem !important;\n  }\n  .ps-xl-2 {\n    padding-left: 0.5rem !important;\n  }\n  .ps-xl-3 {\n    padding-left: 0.75rem !important;\n  }\n  .ps-xl-4 {\n    padding-left: 1rem !important;\n  }\n  .ps-xl-5 {\n    padding-left: 1.25rem !important;\n  }\n  .ps-xl-6 {\n    padding-left: 1.5rem !important;\n  }\n  .ps-xl-7 {\n    padding-left: 1.75rem !important;\n  }\n  .ps-xl-8 {\n    padding-left: 2rem !important;\n  }\n  .ps-xl-9 {\n    padding-left: 2.25rem !important;\n  }\n  .ps-xl-10 {\n    padding-left: 2.5rem !important;\n  }\n  .ps-xl-11 {\n    padding-left: 2.75rem !important;\n  }\n  .ps-xl-12 {\n    padding-left: 3rem !important;\n  }\n  .ps-xl-13 {\n    padding-left: 3.25rem !important;\n  }\n  .ps-xl-14 {\n    padding-left: 3.5rem !important;\n  }\n  .ps-xl-15 {\n    padding-left: 3.75rem !important;\n  }\n  .ps-xl-16 {\n    padding-left: 4rem !important;\n  }\n  .ps-xl-17 {\n    padding-left: 4.25rem !important;\n  }\n  .ps-xl-18 {\n    padding-left: 4.5rem !important;\n  }\n  .ps-xl-19 {\n    padding-left: 4.75rem !important;\n  }\n  .ps-xl-20 {\n    padding-left: 5rem !important;\n  }\n  .gap-xl-0 {\n    gap: 0 !important;\n  }\n  .gap-xl-1 {\n    gap: 0.25rem !important;\n  }\n  .gap-xl-2 {\n    gap: 0.5rem !important;\n  }\n  .gap-xl-3 {\n    gap: 0.75rem !important;\n  }\n  .gap-xl-4 {\n    gap: 1rem !important;\n  }\n  .gap-xl-5 {\n    gap: 1.25rem !important;\n  }\n  .gap-xl-6 {\n    gap: 1.5rem !important;\n  }\n  .gap-xl-7 {\n    gap: 1.75rem !important;\n  }\n  .gap-xl-8 {\n    gap: 2rem !important;\n  }\n  .gap-xl-9 {\n    gap: 2.25rem !important;\n  }\n  .gap-xl-10 {\n    gap: 2.5rem !important;\n  }\n  .gap-xl-11 {\n    gap: 2.75rem !important;\n  }\n  .gap-xl-12 {\n    gap: 3rem !important;\n  }\n  .gap-xl-13 {\n    gap: 3.25rem !important;\n  }\n  .gap-xl-14 {\n    gap: 3.5rem !important;\n  }\n  .gap-xl-15 {\n    gap: 3.75rem !important;\n  }\n  .gap-xl-16 {\n    gap: 4rem !important;\n  }\n  .gap-xl-17 {\n    gap: 4.25rem !important;\n  }\n  .gap-xl-18 {\n    gap: 4.5rem !important;\n  }\n  .gap-xl-19 {\n    gap: 4.75rem !important;\n  }\n  .gap-xl-20 {\n    gap: 5rem !important;\n  }\n  .row-gap-xl-0 {\n    row-gap: 0 !important;\n  }\n  .row-gap-xl-1 {\n    row-gap: 0.25rem !important;\n  }\n  .row-gap-xl-2 {\n    row-gap: 0.5rem !important;\n  }\n  .row-gap-xl-3 {\n    row-gap: 0.75rem !important;\n  }\n  .row-gap-xl-4 {\n    row-gap: 1rem !important;\n  }\n  .row-gap-xl-5 {\n    row-gap: 1.25rem !important;\n  }\n  .row-gap-xl-6 {\n    row-gap: 1.5rem !important;\n  }\n  .row-gap-xl-7 {\n    row-gap: 1.75rem !important;\n  }\n  .row-gap-xl-8 {\n    row-gap: 2rem !important;\n  }\n  .row-gap-xl-9 {\n    row-gap: 2.25rem !important;\n  }\n  .row-gap-xl-10 {\n    row-gap: 2.5rem !important;\n  }\n  .row-gap-xl-11 {\n    row-gap: 2.75rem !important;\n  }\n  .row-gap-xl-12 {\n    row-gap: 3rem !important;\n  }\n  .row-gap-xl-13 {\n    row-gap: 3.25rem !important;\n  }\n  .row-gap-xl-14 {\n    row-gap: 3.5rem !important;\n  }\n  .row-gap-xl-15 {\n    row-gap: 3.75rem !important;\n  }\n  .row-gap-xl-16 {\n    row-gap: 4rem !important;\n  }\n  .row-gap-xl-17 {\n    row-gap: 4.25rem !important;\n  }\n  .row-gap-xl-18 {\n    row-gap: 4.5rem !important;\n  }\n  .row-gap-xl-19 {\n    row-gap: 4.75rem !important;\n  }\n  .row-gap-xl-20 {\n    row-gap: 5rem !important;\n  }\n  .column-gap-xl-0 {\n    column-gap: 0 !important;\n  }\n  .column-gap-xl-1 {\n    column-gap: 0.25rem !important;\n  }\n  .column-gap-xl-2 {\n    column-gap: 0.5rem !important;\n  }\n  .column-gap-xl-3 {\n    column-gap: 0.75rem !important;\n  }\n  .column-gap-xl-4 {\n    column-gap: 1rem !important;\n  }\n  .column-gap-xl-5 {\n    column-gap: 1.25rem !important;\n  }\n  .column-gap-xl-6 {\n    column-gap: 1.5rem !important;\n  }\n  .column-gap-xl-7 {\n    column-gap: 1.75rem !important;\n  }\n  .column-gap-xl-8 {\n    column-gap: 2rem !important;\n  }\n  .column-gap-xl-9 {\n    column-gap: 2.25rem !important;\n  }\n  .column-gap-xl-10 {\n    column-gap: 2.5rem !important;\n  }\n  .column-gap-xl-11 {\n    column-gap: 2.75rem !important;\n  }\n  .column-gap-xl-12 {\n    column-gap: 3rem !important;\n  }\n  .column-gap-xl-13 {\n    column-gap: 3.25rem !important;\n  }\n  .column-gap-xl-14 {\n    column-gap: 3.5rem !important;\n  }\n  .column-gap-xl-15 {\n    column-gap: 3.75rem !important;\n  }\n  .column-gap-xl-16 {\n    column-gap: 4rem !important;\n  }\n  .column-gap-xl-17 {\n    column-gap: 4.25rem !important;\n  }\n  .column-gap-xl-18 {\n    column-gap: 4.5rem !important;\n  }\n  .column-gap-xl-19 {\n    column-gap: 4.75rem !important;\n  }\n  .column-gap-xl-20 {\n    column-gap: 5rem !important;\n  }\n  .fs-xl-1 {\n    font-size: calc(1.3rem + 0.6vw) !important;\n  }\n  .fs-xl-2 {\n    font-size: calc(1.275rem + 0.3vw) !important;\n  }\n  .fs-xl-3 {\n    font-size: calc(1.26rem + 0.12vw) !important;\n  }\n  .fs-xl-4 {\n    font-size: 1.25rem !important;\n  }\n  .fs-xl-5 {\n    font-size: 1.15rem !important;\n  }\n  .fs-xl-6 {\n    font-size: 1.075rem !important;\n  }\n  .fs-xl-7 {\n    font-size: 0.95rem !important;\n  }\n  .fs-xl-8 {\n    font-size: 0.85rem !important;\n  }\n  .fs-xl-9 {\n    font-size: 0.75rem !important;\n  }\n  .fs-xl-10 {\n    font-size: 0.5rem !important;\n  }\n  .fs-xl-base {\n    font-size: 1rem !important;\n  }\n  .fs-xl-fluid {\n    font-size: 100% !important;\n  }\n  .fs-xl-2x {\n    font-size: calc(1.325rem + 0.9vw) !important;\n  }\n  .fs-xl-2qx {\n    font-size: calc(1.35rem + 1.2vw) !important;\n  }\n  .fs-xl-2hx {\n    font-size: calc(1.375rem + 1.5vw) !important;\n  }\n  .fs-xl-2tx {\n    font-size: calc(1.4rem + 1.8vw) !important;\n  }\n  .fs-xl-3x {\n    font-size: calc(1.425rem + 2.1vw) !important;\n  }\n  .fs-xl-3qx {\n    font-size: calc(1.45rem + 2.4vw) !important;\n  }\n  .fs-xl-3hx {\n    font-size: calc(1.475rem + 2.7vw) !important;\n  }\n  .fs-xl-3tx {\n    font-size: calc(1.5rem + 3vw) !important;\n  }\n  .fs-xl-4x {\n    font-size: calc(1.525rem + 3.3vw) !important;\n  }\n  .fs-xl-4qx {\n    font-size: calc(1.55rem + 3.6vw) !important;\n  }\n  .fs-xl-4hx {\n    font-size: calc(1.575rem + 3.9vw) !important;\n  }\n  .fs-xl-4tx {\n    font-size: calc(1.6rem + 4.2vw) !important;\n  }\n  .fs-xl-5x {\n    font-size: calc(1.625rem + 4.5vw) !important;\n  }\n  .fs-xl-5qx {\n    font-size: calc(1.65rem + 4.8vw) !important;\n  }\n  .fs-xl-5hx {\n    font-size: calc(1.675rem + 5.1vw) !important;\n  }\n  .fs-xl-5tx {\n    font-size: calc(1.7rem + 5.4vw) !important;\n  }\n  .fs-xl-6x {\n    font-size: calc(1.725rem + 5.7vw) !important;\n  }\n  .fs-xl-6qx {\n    font-size: calc(1.75rem + 6vw) !important;\n  }\n  .fs-xl-6hx {\n    font-size: calc(1.775rem + 6.3vw) !important;\n  }\n  .fs-xl-6tx {\n    font-size: calc(1.8rem + 6.6vw) !important;\n  }\n  .fs-xl-7x {\n    font-size: calc(1.825rem + 6.9vw) !important;\n  }\n  .fs-xl-7qx {\n    font-size: calc(1.85rem + 7.2vw) !important;\n  }\n  .fs-xl-7hx {\n    font-size: calc(1.875rem + 7.5vw) !important;\n  }\n  .fs-xl-7tx {\n    font-size: calc(1.9rem + 7.8vw) !important;\n  }\n  .text-xl-start {\n    text-align: left !important;\n  }\n  .text-xl-end {\n    text-align: right !important;\n  }\n  .text-xl-center {\n    text-align: center !important;\n  }\n  .min-w-xl-unset {\n    min-width: unset !important;\n  }\n  .min-w-xl-25 {\n    min-width: 25% !important;\n  }\n  .min-w-xl-50 {\n    min-width: 50% !important;\n  }\n  .min-w-xl-75 {\n    min-width: 75% !important;\n  }\n  .min-w-xl-100 {\n    min-width: 100% !important;\n  }\n  .min-w-xl-auto {\n    min-width: auto !important;\n  }\n  .min-w-xl-1px {\n    min-width: 1px !important;\n  }\n  .min-w-xl-2px {\n    min-width: 2px !important;\n  }\n  .min-w-xl-3px {\n    min-width: 3px !important;\n  }\n  .min-w-xl-4px {\n    min-width: 4px !important;\n  }\n  .min-w-xl-5px {\n    min-width: 5px !important;\n  }\n  .min-w-xl-6px {\n    min-width: 6px !important;\n  }\n  .min-w-xl-7px {\n    min-width: 7px !important;\n  }\n  .min-w-xl-8px {\n    min-width: 8px !important;\n  }\n  .min-w-xl-9px {\n    min-width: 9px !important;\n  }\n  .min-w-xl-10px {\n    min-width: 10px !important;\n  }\n  .min-w-xl-15px {\n    min-width: 15px !important;\n  }\n  .min-w-xl-20px {\n    min-width: 20px !important;\n  }\n  .min-w-xl-25px {\n    min-width: 25px !important;\n  }\n  .min-w-xl-30px {\n    min-width: 30px !important;\n  }\n  .min-w-xl-35px {\n    min-width: 35px !important;\n  }\n  .min-w-xl-40px {\n    min-width: 40px !important;\n  }\n  .min-w-xl-45px {\n    min-width: 45px !important;\n  }\n  .min-w-xl-50px {\n    min-width: 50px !important;\n  }\n  .min-w-xl-55px {\n    min-width: 55px !important;\n  }\n  .min-w-xl-60px {\n    min-width: 60px !important;\n  }\n  .min-w-xl-65px {\n    min-width: 65px !important;\n  }\n  .min-w-xl-70px {\n    min-width: 70px !important;\n  }\n  .min-w-xl-75px {\n    min-width: 75px !important;\n  }\n  .min-w-xl-80px {\n    min-width: 80px !important;\n  }\n  .min-w-xl-85px {\n    min-width: 85px !important;\n  }\n  .min-w-xl-90px {\n    min-width: 90px !important;\n  }\n  .min-w-xl-95px {\n    min-width: 95px !important;\n  }\n  .min-w-xl-100px {\n    min-width: 100px !important;\n  }\n  .min-w-xl-125px {\n    min-width: 125px !important;\n  }\n  .min-w-xl-150px {\n    min-width: 150px !important;\n  }\n  .min-w-xl-175px {\n    min-width: 175px !important;\n  }\n  .min-w-xl-200px {\n    min-width: 200px !important;\n  }\n  .min-w-xl-225px {\n    min-width: 225px !important;\n  }\n  .min-w-xl-250px {\n    min-width: 250px !important;\n  }\n  .min-w-xl-275px {\n    min-width: 275px !important;\n  }\n  .min-w-xl-300px {\n    min-width: 300px !important;\n  }\n  .min-w-xl-325px {\n    min-width: 325px !important;\n  }\n  .min-w-xl-350px {\n    min-width: 350px !important;\n  }\n  .min-w-xl-375px {\n    min-width: 375px !important;\n  }\n  .min-w-xl-400px {\n    min-width: 400px !important;\n  }\n  .min-w-xl-425px {\n    min-width: 425px !important;\n  }\n  .min-w-xl-450px {\n    min-width: 450px !important;\n  }\n  .min-w-xl-475px {\n    min-width: 475px !important;\n  }\n  .min-w-xl-500px {\n    min-width: 500px !important;\n  }\n  .min-w-xl-550px {\n    min-width: 550px !important;\n  }\n  .min-w-xl-600px {\n    min-width: 600px !important;\n  }\n  .min-w-xl-650px {\n    min-width: 650px !important;\n  }\n  .min-w-xl-700px {\n    min-width: 700px !important;\n  }\n  .min-w-xl-750px {\n    min-width: 750px !important;\n  }\n  .min-w-xl-800px {\n    min-width: 800px !important;\n  }\n  .min-w-xl-850px {\n    min-width: 850px !important;\n  }\n  .min-w-xl-900px {\n    min-width: 900px !important;\n  }\n  .min-w-xl-950px {\n    min-width: 950px !important;\n  }\n  .min-w-xl-1000px {\n    min-width: 1000px !important;\n  }\n  .min-h-xl-unset {\n    min-height: unset !important;\n  }\n  .min-h-xl-25 {\n    min-height: 25% !important;\n  }\n  .min-h-xl-50 {\n    min-height: 50% !important;\n  }\n  .min-h-xl-75 {\n    min-height: 75% !important;\n  }\n  .min-h-xl-100 {\n    min-height: 100% !important;\n  }\n  .min-h-xl-auto {\n    min-height: auto !important;\n  }\n  .min-h-xl-1px {\n    min-height: 1px !important;\n  }\n  .min-h-xl-2px {\n    min-height: 2px !important;\n  }\n  .min-h-xl-3px {\n    min-height: 3px !important;\n  }\n  .min-h-xl-4px {\n    min-height: 4px !important;\n  }\n  .min-h-xl-5px {\n    min-height: 5px !important;\n  }\n  .min-h-xl-6px {\n    min-height: 6px !important;\n  }\n  .min-h-xl-7px {\n    min-height: 7px !important;\n  }\n  .min-h-xl-8px {\n    min-height: 8px !important;\n  }\n  .min-h-xl-9px {\n    min-height: 9px !important;\n  }\n  .min-h-xl-10px {\n    min-height: 10px !important;\n  }\n  .min-h-xl-15px {\n    min-height: 15px !important;\n  }\n  .min-h-xl-20px {\n    min-height: 20px !important;\n  }\n  .min-h-xl-25px {\n    min-height: 25px !important;\n  }\n  .min-h-xl-30px {\n    min-height: 30px !important;\n  }\n  .min-h-xl-35px {\n    min-height: 35px !important;\n  }\n  .min-h-xl-40px {\n    min-height: 40px !important;\n  }\n  .min-h-xl-45px {\n    min-height: 45px !important;\n  }\n  .min-h-xl-50px {\n    min-height: 50px !important;\n  }\n  .min-h-xl-55px {\n    min-height: 55px !important;\n  }\n  .min-h-xl-60px {\n    min-height: 60px !important;\n  }\n  .min-h-xl-65px {\n    min-height: 65px !important;\n  }\n  .min-h-xl-70px {\n    min-height: 70px !important;\n  }\n  .min-h-xl-75px {\n    min-height: 75px !important;\n  }\n  .min-h-xl-80px {\n    min-height: 80px !important;\n  }\n  .min-h-xl-85px {\n    min-height: 85px !important;\n  }\n  .min-h-xl-90px {\n    min-height: 90px !important;\n  }\n  .min-h-xl-95px {\n    min-height: 95px !important;\n  }\n  .min-h-xl-100px {\n    min-height: 100px !important;\n  }\n  .min-h-xl-125px {\n    min-height: 125px !important;\n  }\n  .min-h-xl-150px {\n    min-height: 150px !important;\n  }\n  .min-h-xl-175px {\n    min-height: 175px !important;\n  }\n  .min-h-xl-200px {\n    min-height: 200px !important;\n  }\n  .min-h-xl-225px {\n    min-height: 225px !important;\n  }\n  .min-h-xl-250px {\n    min-height: 250px !important;\n  }\n  .min-h-xl-275px {\n    min-height: 275px !important;\n  }\n  .min-h-xl-300px {\n    min-height: 300px !important;\n  }\n  .min-h-xl-325px {\n    min-height: 325px !important;\n  }\n  .min-h-xl-350px {\n    min-height: 350px !important;\n  }\n  .min-h-xl-375px {\n    min-height: 375px !important;\n  }\n  .min-h-xl-400px {\n    min-height: 400px !important;\n  }\n  .min-h-xl-425px {\n    min-height: 425px !important;\n  }\n  .min-h-xl-450px {\n    min-height: 450px !important;\n  }\n  .min-h-xl-475px {\n    min-height: 475px !important;\n  }\n  .min-h-xl-500px {\n    min-height: 500px !important;\n  }\n  .min-h-xl-550px {\n    min-height: 550px !important;\n  }\n  .min-h-xl-600px {\n    min-height: 600px !important;\n  }\n  .min-h-xl-650px {\n    min-height: 650px !important;\n  }\n  .min-h-xl-700px {\n    min-height: 700px !important;\n  }\n  .min-h-xl-750px {\n    min-height: 750px !important;\n  }\n  .min-h-xl-800px {\n    min-height: 800px !important;\n  }\n  .min-h-xl-850px {\n    min-height: 850px !important;\n  }\n  .min-h-xl-900px {\n    min-height: 900px !important;\n  }\n  .min-h-xl-950px {\n    min-height: 950px !important;\n  }\n  .min-h-xl-1000px {\n    min-height: 1000px !important;\n  }\n}\n@media (min-width: 1400px) {\n  .float-xxl-start {\n    float: left !important;\n  }\n  .float-xxl-end {\n    float: right !important;\n  }\n  .float-xxl-none {\n    float: none !important;\n  }\n  .object-fit-xxl-contain {\n    object-fit: contain !important;\n  }\n  .object-fit-xxl-cover {\n    object-fit: cover !important;\n  }\n  .object-fit-xxl-fill {\n    object-fit: fill !important;\n  }\n  .object-fit-xxl-scale {\n    object-fit: scale-down !important;\n  }\n  .object-fit-xxl-none {\n    object-fit: none !important;\n  }\n  .overflow-xxl-auto {\n    overflow: auto !important;\n  }\n  .overflow-xxl-hidden {\n    overflow: hidden !important;\n  }\n  .overflow-xxl-visible {\n    overflow: visible !important;\n  }\n  .overflow-xxl-scroll {\n    overflow: scroll !important;\n  }\n  .d-xxl-inline {\n    display: inline !important;\n  }\n  .d-xxl-inline-block {\n    display: inline-block !important;\n  }\n  .d-xxl-block {\n    display: block !important;\n  }\n  .d-xxl-grid {\n    display: grid !important;\n  }\n  .d-xxl-table {\n    display: table !important;\n  }\n  .d-xxl-table-row {\n    display: table-row !important;\n  }\n  .d-xxl-table-cell {\n    display: table-cell !important;\n  }\n  .d-xxl-flex {\n    display: flex !important;\n  }\n  .d-xxl-inline-flex {\n    display: inline-flex !important;\n  }\n  .d-xxl-none {\n    display: none !important;\n  }\n  .position-xxl-static {\n    position: static !important;\n  }\n  .position-xxl-relative {\n    position: relative !important;\n  }\n  .position-xxl-absolute {\n    position: absolute !important;\n  }\n  .position-xxl-fixed {\n    position: fixed !important;\n  }\n  .position-xxl-sticky {\n    position: sticky !important;\n  }\n  .w-xxl-unset {\n    width: unset !important;\n  }\n  .w-xxl-25 {\n    width: 25% !important;\n  }\n  .w-xxl-50 {\n    width: 50% !important;\n  }\n  .w-xxl-75 {\n    width: 75% !important;\n  }\n  .w-xxl-100 {\n    width: 100% !important;\n  }\n  .w-xxl-auto {\n    width: auto !important;\n  }\n  .w-xxl-1px {\n    width: 1px !important;\n  }\n  .w-xxl-2px {\n    width: 2px !important;\n  }\n  .w-xxl-3px {\n    width: 3px !important;\n  }\n  .w-xxl-4px {\n    width: 4px !important;\n  }\n  .w-xxl-5px {\n    width: 5px !important;\n  }\n  .w-xxl-6px {\n    width: 6px !important;\n  }\n  .w-xxl-7px {\n    width: 7px !important;\n  }\n  .w-xxl-8px {\n    width: 8px !important;\n  }\n  .w-xxl-9px {\n    width: 9px !important;\n  }\n  .w-xxl-10px {\n    width: 10px !important;\n  }\n  .w-xxl-15px {\n    width: 15px !important;\n  }\n  .w-xxl-20px {\n    width: 20px !important;\n  }\n  .w-xxl-25px {\n    width: 25px !important;\n  }\n  .w-xxl-30px {\n    width: 30px !important;\n  }\n  .w-xxl-35px {\n    width: 35px !important;\n  }\n  .w-xxl-40px {\n    width: 40px !important;\n  }\n  .w-xxl-45px {\n    width: 45px !important;\n  }\n  .w-xxl-50px {\n    width: 50px !important;\n  }\n  .w-xxl-55px {\n    width: 55px !important;\n  }\n  .w-xxl-60px {\n    width: 60px !important;\n  }\n  .w-xxl-65px {\n    width: 65px !important;\n  }\n  .w-xxl-70px {\n    width: 70px !important;\n  }\n  .w-xxl-75px {\n    width: 75px !important;\n  }\n  .w-xxl-80px {\n    width: 80px !important;\n  }\n  .w-xxl-85px {\n    width: 85px !important;\n  }\n  .w-xxl-90px {\n    width: 90px !important;\n  }\n  .w-xxl-95px {\n    width: 95px !important;\n  }\n  .w-xxl-100px {\n    width: 100px !important;\n  }\n  .w-xxl-125px {\n    width: 125px !important;\n  }\n  .w-xxl-150px {\n    width: 150px !important;\n  }\n  .w-xxl-175px {\n    width: 175px !important;\n  }\n  .w-xxl-200px {\n    width: 200px !important;\n  }\n  .w-xxl-225px {\n    width: 225px !important;\n  }\n  .w-xxl-250px {\n    width: 250px !important;\n  }\n  .w-xxl-275px {\n    width: 275px !important;\n  }\n  .w-xxl-300px {\n    width: 300px !important;\n  }\n  .w-xxl-325px {\n    width: 325px !important;\n  }\n  .w-xxl-350px {\n    width: 350px !important;\n  }\n  .w-xxl-375px {\n    width: 375px !important;\n  }\n  .w-xxl-400px {\n    width: 400px !important;\n  }\n  .w-xxl-425px {\n    width: 425px !important;\n  }\n  .w-xxl-450px {\n    width: 450px !important;\n  }\n  .w-xxl-475px {\n    width: 475px !important;\n  }\n  .w-xxl-500px {\n    width: 500px !important;\n  }\n  .w-xxl-550px {\n    width: 550px !important;\n  }\n  .w-xxl-600px {\n    width: 600px !important;\n  }\n  .w-xxl-650px {\n    width: 650px !important;\n  }\n  .w-xxl-700px {\n    width: 700px !important;\n  }\n  .w-xxl-750px {\n    width: 750px !important;\n  }\n  .w-xxl-800px {\n    width: 800px !important;\n  }\n  .w-xxl-850px {\n    width: 850px !important;\n  }\n  .w-xxl-900px {\n    width: 900px !important;\n  }\n  .w-xxl-950px {\n    width: 950px !important;\n  }\n  .w-xxl-1000px {\n    width: 1000px !important;\n  }\n  .mw-xxl-unset {\n    max-width: unset !important;\n  }\n  .mw-xxl-25 {\n    max-width: 25% !important;\n  }\n  .mw-xxl-50 {\n    max-width: 50% !important;\n  }\n  .mw-xxl-75 {\n    max-width: 75% !important;\n  }\n  .mw-xxl-100 {\n    max-width: 100% !important;\n  }\n  .mw-xxl-auto {\n    max-width: auto !important;\n  }\n  .mw-xxl-1px {\n    max-width: 1px !important;\n  }\n  .mw-xxl-2px {\n    max-width: 2px !important;\n  }\n  .mw-xxl-3px {\n    max-width: 3px !important;\n  }\n  .mw-xxl-4px {\n    max-width: 4px !important;\n  }\n  .mw-xxl-5px {\n    max-width: 5px !important;\n  }\n  .mw-xxl-6px {\n    max-width: 6px !important;\n  }\n  .mw-xxl-7px {\n    max-width: 7px !important;\n  }\n  .mw-xxl-8px {\n    max-width: 8px !important;\n  }\n  .mw-xxl-9px {\n    max-width: 9px !important;\n  }\n  .mw-xxl-10px {\n    max-width: 10px !important;\n  }\n  .mw-xxl-15px {\n    max-width: 15px !important;\n  }\n  .mw-xxl-20px {\n    max-width: 20px !important;\n  }\n  .mw-xxl-25px {\n    max-width: 25px !important;\n  }\n  .mw-xxl-30px {\n    max-width: 30px !important;\n  }\n  .mw-xxl-35px {\n    max-width: 35px !important;\n  }\n  .mw-xxl-40px {\n    max-width: 40px !important;\n  }\n  .mw-xxl-45px {\n    max-width: 45px !important;\n  }\n  .mw-xxl-50px {\n    max-width: 50px !important;\n  }\n  .mw-xxl-55px {\n    max-width: 55px !important;\n  }\n  .mw-xxl-60px {\n    max-width: 60px !important;\n  }\n  .mw-xxl-65px {\n    max-width: 65px !important;\n  }\n  .mw-xxl-70px {\n    max-width: 70px !important;\n  }\n  .mw-xxl-75px {\n    max-width: 75px !important;\n  }\n  .mw-xxl-80px {\n    max-width: 80px !important;\n  }\n  .mw-xxl-85px {\n    max-width: 85px !important;\n  }\n  .mw-xxl-90px {\n    max-width: 90px !important;\n  }\n  .mw-xxl-95px {\n    max-width: 95px !important;\n  }\n  .mw-xxl-100px {\n    max-width: 100px !important;\n  }\n  .mw-xxl-125px {\n    max-width: 125px !important;\n  }\n  .mw-xxl-150px {\n    max-width: 150px !important;\n  }\n  .mw-xxl-175px {\n    max-width: 175px !important;\n  }\n  .mw-xxl-200px {\n    max-width: 200px !important;\n  }\n  .mw-xxl-225px {\n    max-width: 225px !important;\n  }\n  .mw-xxl-250px {\n    max-width: 250px !important;\n  }\n  .mw-xxl-275px {\n    max-width: 275px !important;\n  }\n  .mw-xxl-300px {\n    max-width: 300px !important;\n  }\n  .mw-xxl-325px {\n    max-width: 325px !important;\n  }\n  .mw-xxl-350px {\n    max-width: 350px !important;\n  }\n  .mw-xxl-375px {\n    max-width: 375px !important;\n  }\n  .mw-xxl-400px {\n    max-width: 400px !important;\n  }\n  .mw-xxl-425px {\n    max-width: 425px !important;\n  }\n  .mw-xxl-450px {\n    max-width: 450px !important;\n  }\n  .mw-xxl-475px {\n    max-width: 475px !important;\n  }\n  .mw-xxl-500px {\n    max-width: 500px !important;\n  }\n  .mw-xxl-550px {\n    max-width: 550px !important;\n  }\n  .mw-xxl-600px {\n    max-width: 600px !important;\n  }\n  .mw-xxl-650px {\n    max-width: 650px !important;\n  }\n  .mw-xxl-700px {\n    max-width: 700px !important;\n  }\n  .mw-xxl-750px {\n    max-width: 750px !important;\n  }\n  .mw-xxl-800px {\n    max-width: 800px !important;\n  }\n  .mw-xxl-850px {\n    max-width: 850px !important;\n  }\n  .mw-xxl-900px {\n    max-width: 900px !important;\n  }\n  .mw-xxl-950px {\n    max-width: 950px !important;\n  }\n  .mw-xxl-1000px {\n    max-width: 1000px !important;\n  }\n  .h-xxl-unset {\n    height: unset !important;\n  }\n  .h-xxl-25 {\n    height: 25% !important;\n  }\n  .h-xxl-50 {\n    height: 50% !important;\n  }\n  .h-xxl-75 {\n    height: 75% !important;\n  }\n  .h-xxl-100 {\n    height: 100% !important;\n  }\n  .h-xxl-auto {\n    height: auto !important;\n  }\n  .h-xxl-1px {\n    height: 1px !important;\n  }\n  .h-xxl-2px {\n    height: 2px !important;\n  }\n  .h-xxl-3px {\n    height: 3px !important;\n  }\n  .h-xxl-4px {\n    height: 4px !important;\n  }\n  .h-xxl-5px {\n    height: 5px !important;\n  }\n  .h-xxl-6px {\n    height: 6px !important;\n  }\n  .h-xxl-7px {\n    height: 7px !important;\n  }\n  .h-xxl-8px {\n    height: 8px !important;\n  }\n  .h-xxl-9px {\n    height: 9px !important;\n  }\n  .h-xxl-10px {\n    height: 10px !important;\n  }\n  .h-xxl-15px {\n    height: 15px !important;\n  }\n  .h-xxl-20px {\n    height: 20px !important;\n  }\n  .h-xxl-25px {\n    height: 25px !important;\n  }\n  .h-xxl-30px {\n    height: 30px !important;\n  }\n  .h-xxl-35px {\n    height: 35px !important;\n  }\n  .h-xxl-40px {\n    height: 40px !important;\n  }\n  .h-xxl-45px {\n    height: 45px !important;\n  }\n  .h-xxl-50px {\n    height: 50px !important;\n  }\n  .h-xxl-55px {\n    height: 55px !important;\n  }\n  .h-xxl-60px {\n    height: 60px !important;\n  }\n  .h-xxl-65px {\n    height: 65px !important;\n  }\n  .h-xxl-70px {\n    height: 70px !important;\n  }\n  .h-xxl-75px {\n    height: 75px !important;\n  }\n  .h-xxl-80px {\n    height: 80px !important;\n  }\n  .h-xxl-85px {\n    height: 85px !important;\n  }\n  .h-xxl-90px {\n    height: 90px !important;\n  }\n  .h-xxl-95px {\n    height: 95px !important;\n  }\n  .h-xxl-100px {\n    height: 100px !important;\n  }\n  .h-xxl-125px {\n    height: 125px !important;\n  }\n  .h-xxl-150px {\n    height: 150px !important;\n  }\n  .h-xxl-175px {\n    height: 175px !important;\n  }\n  .h-xxl-200px {\n    height: 200px !important;\n  }\n  .h-xxl-225px {\n    height: 225px !important;\n  }\n  .h-xxl-250px {\n    height: 250px !important;\n  }\n  .h-xxl-275px {\n    height: 275px !important;\n  }\n  .h-xxl-300px {\n    height: 300px !important;\n  }\n  .h-xxl-325px {\n    height: 325px !important;\n  }\n  .h-xxl-350px {\n    height: 350px !important;\n  }\n  .h-xxl-375px {\n    height: 375px !important;\n  }\n  .h-xxl-400px {\n    height: 400px !important;\n  }\n  .h-xxl-425px {\n    height: 425px !important;\n  }\n  .h-xxl-450px {\n    height: 450px !important;\n  }\n  .h-xxl-475px {\n    height: 475px !important;\n  }\n  .h-xxl-500px {\n    height: 500px !important;\n  }\n  .h-xxl-550px {\n    height: 550px !important;\n  }\n  .h-xxl-600px {\n    height: 600px !important;\n  }\n  .h-xxl-650px {\n    height: 650px !important;\n  }\n  .h-xxl-700px {\n    height: 700px !important;\n  }\n  .h-xxl-750px {\n    height: 750px !important;\n  }\n  .h-xxl-800px {\n    height: 800px !important;\n  }\n  .h-xxl-850px {\n    height: 850px !important;\n  }\n  .h-xxl-900px {\n    height: 900px !important;\n  }\n  .h-xxl-950px {\n    height: 950px !important;\n  }\n  .h-xxl-1000px {\n    height: 1000px !important;\n  }\n  .mh-xxl-unset {\n    max-height: unset !important;\n  }\n  .mh-xxl-25 {\n    max-height: 25% !important;\n  }\n  .mh-xxl-50 {\n    max-height: 50% !important;\n  }\n  .mh-xxl-75 {\n    max-height: 75% !important;\n  }\n  .mh-xxl-100 {\n    max-height: 100% !important;\n  }\n  .mh-xxl-auto {\n    max-height: auto !important;\n  }\n  .mh-xxl-1px {\n    max-height: 1px !important;\n  }\n  .mh-xxl-2px {\n    max-height: 2px !important;\n  }\n  .mh-xxl-3px {\n    max-height: 3px !important;\n  }\n  .mh-xxl-4px {\n    max-height: 4px !important;\n  }\n  .mh-xxl-5px {\n    max-height: 5px !important;\n  }\n  .mh-xxl-6px {\n    max-height: 6px !important;\n  }\n  .mh-xxl-7px {\n    max-height: 7px !important;\n  }\n  .mh-xxl-8px {\n    max-height: 8px !important;\n  }\n  .mh-xxl-9px {\n    max-height: 9px !important;\n  }\n  .mh-xxl-10px {\n    max-height: 10px !important;\n  }\n  .mh-xxl-15px {\n    max-height: 15px !important;\n  }\n  .mh-xxl-20px {\n    max-height: 20px !important;\n  }\n  .mh-xxl-25px {\n    max-height: 25px !important;\n  }\n  .mh-xxl-30px {\n    max-height: 30px !important;\n  }\n  .mh-xxl-35px {\n    max-height: 35px !important;\n  }\n  .mh-xxl-40px {\n    max-height: 40px !important;\n  }\n  .mh-xxl-45px {\n    max-height: 45px !important;\n  }\n  .mh-xxl-50px {\n    max-height: 50px !important;\n  }\n  .mh-xxl-55px {\n    max-height: 55px !important;\n  }\n  .mh-xxl-60px {\n    max-height: 60px !important;\n  }\n  .mh-xxl-65px {\n    max-height: 65px !important;\n  }\n  .mh-xxl-70px {\n    max-height: 70px !important;\n  }\n  .mh-xxl-75px {\n    max-height: 75px !important;\n  }\n  .mh-xxl-80px {\n    max-height: 80px !important;\n  }\n  .mh-xxl-85px {\n    max-height: 85px !important;\n  }\n  .mh-xxl-90px {\n    max-height: 90px !important;\n  }\n  .mh-xxl-95px {\n    max-height: 95px !important;\n  }\n  .mh-xxl-100px {\n    max-height: 100px !important;\n  }\n  .mh-xxl-125px {\n    max-height: 125px !important;\n  }\n  .mh-xxl-150px {\n    max-height: 150px !important;\n  }\n  .mh-xxl-175px {\n    max-height: 175px !important;\n  }\n  .mh-xxl-200px {\n    max-height: 200px !important;\n  }\n  .mh-xxl-225px {\n    max-height: 225px !important;\n  }\n  .mh-xxl-250px {\n    max-height: 250px !important;\n  }\n  .mh-xxl-275px {\n    max-height: 275px !important;\n  }\n  .mh-xxl-300px {\n    max-height: 300px !important;\n  }\n  .mh-xxl-325px {\n    max-height: 325px !important;\n  }\n  .mh-xxl-350px {\n    max-height: 350px !important;\n  }\n  .mh-xxl-375px {\n    max-height: 375px !important;\n  }\n  .mh-xxl-400px {\n    max-height: 400px !important;\n  }\n  .mh-xxl-425px {\n    max-height: 425px !important;\n  }\n  .mh-xxl-450px {\n    max-height: 450px !important;\n  }\n  .mh-xxl-475px {\n    max-height: 475px !important;\n  }\n  .mh-xxl-500px {\n    max-height: 500px !important;\n  }\n  .mh-xxl-550px {\n    max-height: 550px !important;\n  }\n  .mh-xxl-600px {\n    max-height: 600px !important;\n  }\n  .mh-xxl-650px {\n    max-height: 650px !important;\n  }\n  .mh-xxl-700px {\n    max-height: 700px !important;\n  }\n  .mh-xxl-750px {\n    max-height: 750px !important;\n  }\n  .mh-xxl-800px {\n    max-height: 800px !important;\n  }\n  .mh-xxl-850px {\n    max-height: 850px !important;\n  }\n  .mh-xxl-900px {\n    max-height: 900px !important;\n  }\n  .mh-xxl-950px {\n    max-height: 950px !important;\n  }\n  .mh-xxl-1000px {\n    max-height: 1000px !important;\n  }\n  .flex-xxl-fill {\n    flex: 1 1 auto !important;\n  }\n  .flex-xxl-row {\n    flex-direction: row !important;\n  }\n  .flex-xxl-column {\n    flex-direction: column !important;\n  }\n  .flex-xxl-row-reverse {\n    flex-direction: row-reverse !important;\n  }\n  .flex-xxl-column-reverse {\n    flex-direction: column-reverse !important;\n  }\n  .flex-xxl-grow-0 {\n    flex-grow: 0 !important;\n  }\n  .flex-xxl-grow-1 {\n    flex-grow: 1 !important;\n  }\n  .flex-xxl-shrink-0 {\n    flex-shrink: 0 !important;\n  }\n  .flex-xxl-shrink-1 {\n    flex-shrink: 1 !important;\n  }\n  .flex-xxl-wrap {\n    flex-wrap: wrap !important;\n  }\n  .flex-xxl-nowrap {\n    flex-wrap: nowrap !important;\n  }\n  .flex-xxl-wrap-reverse {\n    flex-wrap: wrap-reverse !important;\n  }\n  .justify-content-xxl-start {\n    justify-content: flex-start !important;\n  }\n  .justify-content-xxl-end {\n    justify-content: flex-end !important;\n  }\n  .justify-content-xxl-center {\n    justify-content: center !important;\n  }\n  .justify-content-xxl-between {\n    justify-content: space-between !important;\n  }\n  .justify-content-xxl-around {\n    justify-content: space-around !important;\n  }\n  .justify-content-xxl-evenly {\n    justify-content: space-evenly !important;\n  }\n  .align-items-xxl-start {\n    align-items: flex-start !important;\n  }\n  .align-items-xxl-end {\n    align-items: flex-end !important;\n  }\n  .align-items-xxl-center {\n    align-items: center !important;\n  }\n  .align-items-xxl-baseline {\n    align-items: baseline !important;\n  }\n  .align-items-xxl-stretch {\n    align-items: stretch !important;\n  }\n  .align-content-xxl-start {\n    align-content: flex-start !important;\n  }\n  .align-content-xxl-end {\n    align-content: flex-end !important;\n  }\n  .align-content-xxl-center {\n    align-content: center !important;\n  }\n  .align-content-xxl-between {\n    align-content: space-between !important;\n  }\n  .align-content-xxl-around {\n    align-content: space-around !important;\n  }\n  .align-content-xxl-stretch {\n    align-content: stretch !important;\n  }\n  .align-self-xxl-auto {\n    align-self: auto !important;\n  }\n  .align-self-xxl-start {\n    align-self: flex-start !important;\n  }\n  .align-self-xxl-end {\n    align-self: flex-end !important;\n  }\n  .align-self-xxl-center {\n    align-self: center !important;\n  }\n  .align-self-xxl-baseline {\n    align-self: baseline !important;\n  }\n  .align-self-xxl-stretch {\n    align-self: stretch !important;\n  }\n  .order-xxl-first {\n    order: -1 !important;\n  }\n  .order-xxl-0 {\n    order: 0 !important;\n  }\n  .order-xxl-1 {\n    order: 1 !important;\n  }\n  .order-xxl-2 {\n    order: 2 !important;\n  }\n  .order-xxl-3 {\n    order: 3 !important;\n  }\n  .order-xxl-4 {\n    order: 4 !important;\n  }\n  .order-xxl-5 {\n    order: 5 !important;\n  }\n  .order-xxl-last {\n    order: 6 !important;\n  }\n  .m-xxl-0 {\n    margin: 0 !important;\n  }\n  .m-xxl-1 {\n    margin: 0.25rem !important;\n  }\n  .m-xxl-2 {\n    margin: 0.5rem !important;\n  }\n  .m-xxl-3 {\n    margin: 0.75rem !important;\n  }\n  .m-xxl-4 {\n    margin: 1rem !important;\n  }\n  .m-xxl-5 {\n    margin: 1.25rem !important;\n  }\n  .m-xxl-6 {\n    margin: 1.5rem !important;\n  }\n  .m-xxl-7 {\n    margin: 1.75rem !important;\n  }\n  .m-xxl-8 {\n    margin: 2rem !important;\n  }\n  .m-xxl-9 {\n    margin: 2.25rem !important;\n  }\n  .m-xxl-10 {\n    margin: 2.5rem !important;\n  }\n  .m-xxl-11 {\n    margin: 2.75rem !important;\n  }\n  .m-xxl-12 {\n    margin: 3rem !important;\n  }\n  .m-xxl-13 {\n    margin: 3.25rem !important;\n  }\n  .m-xxl-14 {\n    margin: 3.5rem !important;\n  }\n  .m-xxl-15 {\n    margin: 3.75rem !important;\n  }\n  .m-xxl-16 {\n    margin: 4rem !important;\n  }\n  .m-xxl-17 {\n    margin: 4.25rem !important;\n  }\n  .m-xxl-18 {\n    margin: 4.5rem !important;\n  }\n  .m-xxl-19 {\n    margin: 4.75rem !important;\n  }\n  .m-xxl-20 {\n    margin: 5rem !important;\n  }\n  .m-xxl-auto {\n    margin: auto !important;\n  }\n  .mx-xxl-0 {\n    margin-right: 0 !important;\n    margin-left: 0 !important;\n  }\n  .mx-xxl-1 {\n    margin-right: 0.25rem !important;\n    margin-left: 0.25rem !important;\n  }\n  .mx-xxl-2 {\n    margin-right: 0.5rem !important;\n    margin-left: 0.5rem !important;\n  }\n  .mx-xxl-3 {\n    margin-right: 0.75rem !important;\n    margin-left: 0.75rem !important;\n  }\n  .mx-xxl-4 {\n    margin-right: 1rem !important;\n    margin-left: 1rem !important;\n  }\n  .mx-xxl-5 {\n    margin-right: 1.25rem !important;\n    margin-left: 1.25rem !important;\n  }\n  .mx-xxl-6 {\n    margin-right: 1.5rem !important;\n    margin-left: 1.5rem !important;\n  }\n  .mx-xxl-7 {\n    margin-right: 1.75rem !important;\n    margin-left: 1.75rem !important;\n  }\n  .mx-xxl-8 {\n    margin-right: 2rem !important;\n    margin-left: 2rem !important;\n  }\n  .mx-xxl-9 {\n    margin-right: 2.25rem !important;\n    margin-left: 2.25rem !important;\n  }\n  .mx-xxl-10 {\n    margin-right: 2.5rem !important;\n    margin-left: 2.5rem !important;\n  }\n  .mx-xxl-11 {\n    margin-right: 2.75rem !important;\n    margin-left: 2.75rem !important;\n  }\n  .mx-xxl-12 {\n    margin-right: 3rem !important;\n    margin-left: 3rem !important;\n  }\n  .mx-xxl-13 {\n    margin-right: 3.25rem !important;\n    margin-left: 3.25rem !important;\n  }\n  .mx-xxl-14 {\n    margin-right: 3.5rem !important;\n    margin-left: 3.5rem !important;\n  }\n  .mx-xxl-15 {\n    margin-right: 3.75rem !important;\n    margin-left: 3.75rem !important;\n  }\n  .mx-xxl-16 {\n    margin-right: 4rem !important;\n    margin-left: 4rem !important;\n  }\n  .mx-xxl-17 {\n    margin-right: 4.25rem !important;\n    margin-left: 4.25rem !important;\n  }\n  .mx-xxl-18 {\n    margin-right: 4.5rem !important;\n    margin-left: 4.5rem !important;\n  }\n  .mx-xxl-19 {\n    margin-right: 4.75rem !important;\n    margin-left: 4.75rem !important;\n  }\n  .mx-xxl-20 {\n    margin-right: 5rem !important;\n    margin-left: 5rem !important;\n  }\n  .mx-xxl-auto {\n    margin-right: auto !important;\n    margin-left: auto !important;\n  }\n  .my-xxl-0 {\n    margin-top: 0 !important;\n    margin-bottom: 0 !important;\n  }\n  .my-xxl-1 {\n    margin-top: 0.25rem !important;\n    margin-bottom: 0.25rem !important;\n  }\n  .my-xxl-2 {\n    margin-top: 0.5rem !important;\n    margin-bottom: 0.5rem !important;\n  }\n  .my-xxl-3 {\n    margin-top: 0.75rem !important;\n    margin-bottom: 0.75rem !important;\n  }\n  .my-xxl-4 {\n    margin-top: 1rem !important;\n    margin-bottom: 1rem !important;\n  }\n  .my-xxl-5 {\n    margin-top: 1.25rem !important;\n    margin-bottom: 1.25rem !important;\n  }\n  .my-xxl-6 {\n    margin-top: 1.5rem !important;\n    margin-bottom: 1.5rem !important;\n  }\n  .my-xxl-7 {\n    margin-top: 1.75rem !important;\n    margin-bottom: 1.75rem !important;\n  }\n  .my-xxl-8 {\n    margin-top: 2rem !important;\n    margin-bottom: 2rem !important;\n  }\n  .my-xxl-9 {\n    margin-top: 2.25rem !important;\n    margin-bottom: 2.25rem !important;\n  }\n  .my-xxl-10 {\n    margin-top: 2.5rem !important;\n    margin-bottom: 2.5rem !important;\n  }\n  .my-xxl-11 {\n    margin-top: 2.75rem !important;\n    margin-bottom: 2.75rem !important;\n  }\n  .my-xxl-12 {\n    margin-top: 3rem !important;\n    margin-bottom: 3rem !important;\n  }\n  .my-xxl-13 {\n    margin-top: 3.25rem !important;\n    margin-bottom: 3.25rem !important;\n  }\n  .my-xxl-14 {\n    margin-top: 3.5rem !important;\n    margin-bottom: 3.5rem !important;\n  }\n  .my-xxl-15 {\n    margin-top: 3.75rem !important;\n    margin-bottom: 3.75rem !important;\n  }\n  .my-xxl-16 {\n    margin-top: 4rem !important;\n    margin-bottom: 4rem !important;\n  }\n  .my-xxl-17 {\n    margin-top: 4.25rem !important;\n    margin-bottom: 4.25rem !important;\n  }\n  .my-xxl-18 {\n    margin-top: 4.5rem !important;\n    margin-bottom: 4.5rem !important;\n  }\n  .my-xxl-19 {\n    margin-top: 4.75rem !important;\n    margin-bottom: 4.75rem !important;\n  }\n  .my-xxl-20 {\n    margin-top: 5rem !important;\n    margin-bottom: 5rem !important;\n  }\n  .my-xxl-auto {\n    margin-top: auto !important;\n    margin-bottom: auto !important;\n  }\n  .mt-xxl-0 {\n    margin-top: 0 !important;\n  }\n  .mt-xxl-1 {\n    margin-top: 0.25rem !important;\n  }\n  .mt-xxl-2 {\n    margin-top: 0.5rem !important;\n  }\n  .mt-xxl-3 {\n    margin-top: 0.75rem !important;\n  }\n  .mt-xxl-4 {\n    margin-top: 1rem !important;\n  }\n  .mt-xxl-5 {\n    margin-top: 1.25rem !important;\n  }\n  .mt-xxl-6 {\n    margin-top: 1.5rem !important;\n  }\n  .mt-xxl-7 {\n    margin-top: 1.75rem !important;\n  }\n  .mt-xxl-8 {\n    margin-top: 2rem !important;\n  }\n  .mt-xxl-9 {\n    margin-top: 2.25rem !important;\n  }\n  .mt-xxl-10 {\n    margin-top: 2.5rem !important;\n  }\n  .mt-xxl-11 {\n    margin-top: 2.75rem !important;\n  }\n  .mt-xxl-12 {\n    margin-top: 3rem !important;\n  }\n  .mt-xxl-13 {\n    margin-top: 3.25rem !important;\n  }\n  .mt-xxl-14 {\n    margin-top: 3.5rem !important;\n  }\n  .mt-xxl-15 {\n    margin-top: 3.75rem !important;\n  }\n  .mt-xxl-16 {\n    margin-top: 4rem !important;\n  }\n  .mt-xxl-17 {\n    margin-top: 4.25rem !important;\n  }\n  .mt-xxl-18 {\n    margin-top: 4.5rem !important;\n  }\n  .mt-xxl-19 {\n    margin-top: 4.75rem !important;\n  }\n  .mt-xxl-20 {\n    margin-top: 5rem !important;\n  }\n  .mt-xxl-auto {\n    margin-top: auto !important;\n  }\n  .me-xxl-0 {\n    margin-right: 0 !important;\n  }\n  .me-xxl-1 {\n    margin-right: 0.25rem !important;\n  }\n  .me-xxl-2 {\n    margin-right: 0.5rem !important;\n  }\n  .me-xxl-3 {\n    margin-right: 0.75rem !important;\n  }\n  .me-xxl-4 {\n    margin-right: 1rem !important;\n  }\n  .me-xxl-5 {\n    margin-right: 1.25rem !important;\n  }\n  .me-xxl-6 {\n    margin-right: 1.5rem !important;\n  }\n  .me-xxl-7 {\n    margin-right: 1.75rem !important;\n  }\n  .me-xxl-8 {\n    margin-right: 2rem !important;\n  }\n  .me-xxl-9 {\n    margin-right: 2.25rem !important;\n  }\n  .me-xxl-10 {\n    margin-right: 2.5rem !important;\n  }\n  .me-xxl-11 {\n    margin-right: 2.75rem !important;\n  }\n  .me-xxl-12 {\n    margin-right: 3rem !important;\n  }\n  .me-xxl-13 {\n    margin-right: 3.25rem !important;\n  }\n  .me-xxl-14 {\n    margin-right: 3.5rem !important;\n  }\n  .me-xxl-15 {\n    margin-right: 3.75rem !important;\n  }\n  .me-xxl-16 {\n    margin-right: 4rem !important;\n  }\n  .me-xxl-17 {\n    margin-right: 4.25rem !important;\n  }\n  .me-xxl-18 {\n    margin-right: 4.5rem !important;\n  }\n  .me-xxl-19 {\n    margin-right: 4.75rem !important;\n  }\n  .me-xxl-20 {\n    margin-right: 5rem !important;\n  }\n  .me-xxl-auto {\n    margin-right: auto !important;\n  }\n  .mb-xxl-0 {\n    margin-bottom: 0 !important;\n  }\n  .mb-xxl-1 {\n    margin-bottom: 0.25rem !important;\n  }\n  .mb-xxl-2 {\n    margin-bottom: 0.5rem !important;\n  }\n  .mb-xxl-3 {\n    margin-bottom: 0.75rem !important;\n  }\n  .mb-xxl-4 {\n    margin-bottom: 1rem !important;\n  }\n  .mb-xxl-5 {\n    margin-bottom: 1.25rem !important;\n  }\n  .mb-xxl-6 {\n    margin-bottom: 1.5rem !important;\n  }\n  .mb-xxl-7 {\n    margin-bottom: 1.75rem !important;\n  }\n  .mb-xxl-8 {\n    margin-bottom: 2rem !important;\n  }\n  .mb-xxl-9 {\n    margin-bottom: 2.25rem !important;\n  }\n  .mb-xxl-10 {\n    margin-bottom: 2.5rem !important;\n  }\n  .mb-xxl-11 {\n    margin-bottom: 2.75rem !important;\n  }\n  .mb-xxl-12 {\n    margin-bottom: 3rem !important;\n  }\n  .mb-xxl-13 {\n    margin-bottom: 3.25rem !important;\n  }\n  .mb-xxl-14 {\n    margin-bottom: 3.5rem !important;\n  }\n  .mb-xxl-15 {\n    margin-bottom: 3.75rem !important;\n  }\n  .mb-xxl-16 {\n    margin-bottom: 4rem !important;\n  }\n  .mb-xxl-17 {\n    margin-bottom: 4.25rem !important;\n  }\n  .mb-xxl-18 {\n    margin-bottom: 4.5rem !important;\n  }\n  .mb-xxl-19 {\n    margin-bottom: 4.75rem !important;\n  }\n  .mb-xxl-20 {\n    margin-bottom: 5rem !important;\n  }\n  .mb-xxl-auto {\n    margin-bottom: auto !important;\n  }\n  .ms-xxl-0 {\n    margin-left: 0 !important;\n  }\n  .ms-xxl-1 {\n    margin-left: 0.25rem !important;\n  }\n  .ms-xxl-2 {\n    margin-left: 0.5rem !important;\n  }\n  .ms-xxl-3 {\n    margin-left: 0.75rem !important;\n  }\n  .ms-xxl-4 {\n    margin-left: 1rem !important;\n  }\n  .ms-xxl-5 {\n    margin-left: 1.25rem !important;\n  }\n  .ms-xxl-6 {\n    margin-left: 1.5rem !important;\n  }\n  .ms-xxl-7 {\n    margin-left: 1.75rem !important;\n  }\n  .ms-xxl-8 {\n    margin-left: 2rem !important;\n  }\n  .ms-xxl-9 {\n    margin-left: 2.25rem !important;\n  }\n  .ms-xxl-10 {\n    margin-left: 2.5rem !important;\n  }\n  .ms-xxl-11 {\n    margin-left: 2.75rem !important;\n  }\n  .ms-xxl-12 {\n    margin-left: 3rem !important;\n  }\n  .ms-xxl-13 {\n    margin-left: 3.25rem !important;\n  }\n  .ms-xxl-14 {\n    margin-left: 3.5rem !important;\n  }\n  .ms-xxl-15 {\n    margin-left: 3.75rem !important;\n  }\n  .ms-xxl-16 {\n    margin-left: 4rem !important;\n  }\n  .ms-xxl-17 {\n    margin-left: 4.25rem !important;\n  }\n  .ms-xxl-18 {\n    margin-left: 4.5rem !important;\n  }\n  .ms-xxl-19 {\n    margin-left: 4.75rem !important;\n  }\n  .ms-xxl-20 {\n    margin-left: 5rem !important;\n  }\n  .ms-xxl-auto {\n    margin-left: auto !important;\n  }\n  .m-xxl-n1 {\n    margin: -0.25rem !important;\n  }\n  .m-xxl-n2 {\n    margin: -0.5rem !important;\n  }\n  .m-xxl-n3 {\n    margin: -0.75rem !important;\n  }\n  .m-xxl-n4 {\n    margin: -1rem !important;\n  }\n  .m-xxl-n5 {\n    margin: -1.25rem !important;\n  }\n  .m-xxl-n6 {\n    margin: -1.5rem !important;\n  }\n  .m-xxl-n7 {\n    margin: -1.75rem !important;\n  }\n  .m-xxl-n8 {\n    margin: -2rem !important;\n  }\n  .m-xxl-n9 {\n    margin: -2.25rem !important;\n  }\n  .m-xxl-n10 {\n    margin: -2.5rem !important;\n  }\n  .m-xxl-n11 {\n    margin: -2.75rem !important;\n  }\n  .m-xxl-n12 {\n    margin: -3rem !important;\n  }\n  .m-xxl-n13 {\n    margin: -3.25rem !important;\n  }\n  .m-xxl-n14 {\n    margin: -3.5rem !important;\n  }\n  .m-xxl-n15 {\n    margin: -3.75rem !important;\n  }\n  .m-xxl-n16 {\n    margin: -4rem !important;\n  }\n  .m-xxl-n17 {\n    margin: -4.25rem !important;\n  }\n  .m-xxl-n18 {\n    margin: -4.5rem !important;\n  }\n  .m-xxl-n19 {\n    margin: -4.75rem !important;\n  }\n  .m-xxl-n20 {\n    margin: -5rem !important;\n  }\n  .mx-xxl-n1 {\n    margin-right: -0.25rem !important;\n    margin-left: -0.25rem !important;\n  }\n  .mx-xxl-n2 {\n    margin-right: -0.5rem !important;\n    margin-left: -0.5rem !important;\n  }\n  .mx-xxl-n3 {\n    margin-right: -0.75rem !important;\n    margin-left: -0.75rem !important;\n  }\n  .mx-xxl-n4 {\n    margin-right: -1rem !important;\n    margin-left: -1rem !important;\n  }\n  .mx-xxl-n5 {\n    margin-right: -1.25rem !important;\n    margin-left: -1.25rem !important;\n  }\n  .mx-xxl-n6 {\n    margin-right: -1.5rem !important;\n    margin-left: -1.5rem !important;\n  }\n  .mx-xxl-n7 {\n    margin-right: -1.75rem !important;\n    margin-left: -1.75rem !important;\n  }\n  .mx-xxl-n8 {\n    margin-right: -2rem !important;\n    margin-left: -2rem !important;\n  }\n  .mx-xxl-n9 {\n    margin-right: -2.25rem !important;\n    margin-left: -2.25rem !important;\n  }\n  .mx-xxl-n10 {\n    margin-right: -2.5rem !important;\n    margin-left: -2.5rem !important;\n  }\n  .mx-xxl-n11 {\n    margin-right: -2.75rem !important;\n    margin-left: -2.75rem !important;\n  }\n  .mx-xxl-n12 {\n    margin-right: -3rem !important;\n    margin-left: -3rem !important;\n  }\n  .mx-xxl-n13 {\n    margin-right: -3.25rem !important;\n    margin-left: -3.25rem !important;\n  }\n  .mx-xxl-n14 {\n    margin-right: -3.5rem !important;\n    margin-left: -3.5rem !important;\n  }\n  .mx-xxl-n15 {\n    margin-right: -3.75rem !important;\n    margin-left: -3.75rem !important;\n  }\n  .mx-xxl-n16 {\n    margin-right: -4rem !important;\n    margin-left: -4rem !important;\n  }\n  .mx-xxl-n17 {\n    margin-right: -4.25rem !important;\n    margin-left: -4.25rem !important;\n  }\n  .mx-xxl-n18 {\n    margin-right: -4.5rem !important;\n    margin-left: -4.5rem !important;\n  }\n  .mx-xxl-n19 {\n    margin-right: -4.75rem !important;\n    margin-left: -4.75rem !important;\n  }\n  .mx-xxl-n20 {\n    margin-right: -5rem !important;\n    margin-left: -5rem !important;\n  }\n  .my-xxl-n1 {\n    margin-top: -0.25rem !important;\n    margin-bottom: -0.25rem !important;\n  }\n  .my-xxl-n2 {\n    margin-top: -0.5rem !important;\n    margin-bottom: -0.5rem !important;\n  }\n  .my-xxl-n3 {\n    margin-top: -0.75rem !important;\n    margin-bottom: -0.75rem !important;\n  }\n  .my-xxl-n4 {\n    margin-top: -1rem !important;\n    margin-bottom: -1rem !important;\n  }\n  .my-xxl-n5 {\n    margin-top: -1.25rem !important;\n    margin-bottom: -1.25rem !important;\n  }\n  .my-xxl-n6 {\n    margin-top: -1.5rem !important;\n    margin-bottom: -1.5rem !important;\n  }\n  .my-xxl-n7 {\n    margin-top: -1.75rem !important;\n    margin-bottom: -1.75rem !important;\n  }\n  .my-xxl-n8 {\n    margin-top: -2rem !important;\n    margin-bottom: -2rem !important;\n  }\n  .my-xxl-n9 {\n    margin-top: -2.25rem !important;\n    margin-bottom: -2.25rem !important;\n  }\n  .my-xxl-n10 {\n    margin-top: -2.5rem !important;\n    margin-bottom: -2.5rem !important;\n  }\n  .my-xxl-n11 {\n    margin-top: -2.75rem !important;\n    margin-bottom: -2.75rem !important;\n  }\n  .my-xxl-n12 {\n    margin-top: -3rem !important;\n    margin-bottom: -3rem !important;\n  }\n  .my-xxl-n13 {\n    margin-top: -3.25rem !important;\n    margin-bottom: -3.25rem !important;\n  }\n  .my-xxl-n14 {\n    margin-top: -3.5rem !important;\n    margin-bottom: -3.5rem !important;\n  }\n  .my-xxl-n15 {\n    margin-top: -3.75rem !important;\n    margin-bottom: -3.75rem !important;\n  }\n  .my-xxl-n16 {\n    margin-top: -4rem !important;\n    margin-bottom: -4rem !important;\n  }\n  .my-xxl-n17 {\n    margin-top: -4.25rem !important;\n    margin-bottom: -4.25rem !important;\n  }\n  .my-xxl-n18 {\n    margin-top: -4.5rem !important;\n    margin-bottom: -4.5rem !important;\n  }\n  .my-xxl-n19 {\n    margin-top: -4.75rem !important;\n    margin-bottom: -4.75rem !important;\n  }\n  .my-xxl-n20 {\n    margin-top: -5rem !important;\n    margin-bottom: -5rem !important;\n  }\n  .mt-xxl-n1 {\n    margin-top: -0.25rem !important;\n  }\n  .mt-xxl-n2 {\n    margin-top: -0.5rem !important;\n  }\n  .mt-xxl-n3 {\n    margin-top: -0.75rem !important;\n  }\n  .mt-xxl-n4 {\n    margin-top: -1rem !important;\n  }\n  .mt-xxl-n5 {\n    margin-top: -1.25rem !important;\n  }\n  .mt-xxl-n6 {\n    margin-top: -1.5rem !important;\n  }\n  .mt-xxl-n7 {\n    margin-top: -1.75rem !important;\n  }\n  .mt-xxl-n8 {\n    margin-top: -2rem !important;\n  }\n  .mt-xxl-n9 {\n    margin-top: -2.25rem !important;\n  }\n  .mt-xxl-n10 {\n    margin-top: -2.5rem !important;\n  }\n  .mt-xxl-n11 {\n    margin-top: -2.75rem !important;\n  }\n  .mt-xxl-n12 {\n    margin-top: -3rem !important;\n  }\n  .mt-xxl-n13 {\n    margin-top: -3.25rem !important;\n  }\n  .mt-xxl-n14 {\n    margin-top: -3.5rem !important;\n  }\n  .mt-xxl-n15 {\n    margin-top: -3.75rem !important;\n  }\n  .mt-xxl-n16 {\n    margin-top: -4rem !important;\n  }\n  .mt-xxl-n17 {\n    margin-top: -4.25rem !important;\n  }\n  .mt-xxl-n18 {\n    margin-top: -4.5rem !important;\n  }\n  .mt-xxl-n19 {\n    margin-top: -4.75rem !important;\n  }\n  .mt-xxl-n20 {\n    margin-top: -5rem !important;\n  }\n  .me-xxl-n1 {\n    margin-right: -0.25rem !important;\n  }\n  .me-xxl-n2 {\n    margin-right: -0.5rem !important;\n  }\n  .me-xxl-n3 {\n    margin-right: -0.75rem !important;\n  }\n  .me-xxl-n4 {\n    margin-right: -1rem !important;\n  }\n  .me-xxl-n5 {\n    margin-right: -1.25rem !important;\n  }\n  .me-xxl-n6 {\n    margin-right: -1.5rem !important;\n  }\n  .me-xxl-n7 {\n    margin-right: -1.75rem !important;\n  }\n  .me-xxl-n8 {\n    margin-right: -2rem !important;\n  }\n  .me-xxl-n9 {\n    margin-right: -2.25rem !important;\n  }\n  .me-xxl-n10 {\n    margin-right: -2.5rem !important;\n  }\n  .me-xxl-n11 {\n    margin-right: -2.75rem !important;\n  }\n  .me-xxl-n12 {\n    margin-right: -3rem !important;\n  }\n  .me-xxl-n13 {\n    margin-right: -3.25rem !important;\n  }\n  .me-xxl-n14 {\n    margin-right: -3.5rem !important;\n  }\n  .me-xxl-n15 {\n    margin-right: -3.75rem !important;\n  }\n  .me-xxl-n16 {\n    margin-right: -4rem !important;\n  }\n  .me-xxl-n17 {\n    margin-right: -4.25rem !important;\n  }\n  .me-xxl-n18 {\n    margin-right: -4.5rem !important;\n  }\n  .me-xxl-n19 {\n    margin-right: -4.75rem !important;\n  }\n  .me-xxl-n20 {\n    margin-right: -5rem !important;\n  }\n  .mb-xxl-n1 {\n    margin-bottom: -0.25rem !important;\n  }\n  .mb-xxl-n2 {\n    margin-bottom: -0.5rem !important;\n  }\n  .mb-xxl-n3 {\n    margin-bottom: -0.75rem !important;\n  }\n  .mb-xxl-n4 {\n    margin-bottom: -1rem !important;\n  }\n  .mb-xxl-n5 {\n    margin-bottom: -1.25rem !important;\n  }\n  .mb-xxl-n6 {\n    margin-bottom: -1.5rem !important;\n  }\n  .mb-xxl-n7 {\n    margin-bottom: -1.75rem !important;\n  }\n  .mb-xxl-n8 {\n    margin-bottom: -2rem !important;\n  }\n  .mb-xxl-n9 {\n    margin-bottom: -2.25rem !important;\n  }\n  .mb-xxl-n10 {\n    margin-bottom: -2.5rem !important;\n  }\n  .mb-xxl-n11 {\n    margin-bottom: -2.75rem !important;\n  }\n  .mb-xxl-n12 {\n    margin-bottom: -3rem !important;\n  }\n  .mb-xxl-n13 {\n    margin-bottom: -3.25rem !important;\n  }\n  .mb-xxl-n14 {\n    margin-bottom: -3.5rem !important;\n  }\n  .mb-xxl-n15 {\n    margin-bottom: -3.75rem !important;\n  }\n  .mb-xxl-n16 {\n    margin-bottom: -4rem !important;\n  }\n  .mb-xxl-n17 {\n    margin-bottom: -4.25rem !important;\n  }\n  .mb-xxl-n18 {\n    margin-bottom: -4.5rem !important;\n  }\n  .mb-xxl-n19 {\n    margin-bottom: -4.75rem !important;\n  }\n  .mb-xxl-n20 {\n    margin-bottom: -5rem !important;\n  }\n  .ms-xxl-n1 {\n    margin-left: -0.25rem !important;\n  }\n  .ms-xxl-n2 {\n    margin-left: -0.5rem !important;\n  }\n  .ms-xxl-n3 {\n    margin-left: -0.75rem !important;\n  }\n  .ms-xxl-n4 {\n    margin-left: -1rem !important;\n  }\n  .ms-xxl-n5 {\n    margin-left: -1.25rem !important;\n  }\n  .ms-xxl-n6 {\n    margin-left: -1.5rem !important;\n  }\n  .ms-xxl-n7 {\n    margin-left: -1.75rem !important;\n  }\n  .ms-xxl-n8 {\n    margin-left: -2rem !important;\n  }\n  .ms-xxl-n9 {\n    margin-left: -2.25rem !important;\n  }\n  .ms-xxl-n10 {\n    margin-left: -2.5rem !important;\n  }\n  .ms-xxl-n11 {\n    margin-left: -2.75rem !important;\n  }\n  .ms-xxl-n12 {\n    margin-left: -3rem !important;\n  }\n  .ms-xxl-n13 {\n    margin-left: -3.25rem !important;\n  }\n  .ms-xxl-n14 {\n    margin-left: -3.5rem !important;\n  }\n  .ms-xxl-n15 {\n    margin-left: -3.75rem !important;\n  }\n  .ms-xxl-n16 {\n    margin-left: -4rem !important;\n  }\n  .ms-xxl-n17 {\n    margin-left: -4.25rem !important;\n  }\n  .ms-xxl-n18 {\n    margin-left: -4.5rem !important;\n  }\n  .ms-xxl-n19 {\n    margin-left: -4.75rem !important;\n  }\n  .ms-xxl-n20 {\n    margin-left: -5rem !important;\n  }\n  .p-xxl-0 {\n    padding: 0 !important;\n  }\n  .p-xxl-1 {\n    padding: 0.25rem !important;\n  }\n  .p-xxl-2 {\n    padding: 0.5rem !important;\n  }\n  .p-xxl-3 {\n    padding: 0.75rem !important;\n  }\n  .p-xxl-4 {\n    padding: 1rem !important;\n  }\n  .p-xxl-5 {\n    padding: 1.25rem !important;\n  }\n  .p-xxl-6 {\n    padding: 1.5rem !important;\n  }\n  .p-xxl-7 {\n    padding: 1.75rem !important;\n  }\n  .p-xxl-8 {\n    padding: 2rem !important;\n  }\n  .p-xxl-9 {\n    padding: 2.25rem !important;\n  }\n  .p-xxl-10 {\n    padding: 2.5rem !important;\n  }\n  .p-xxl-11 {\n    padding: 2.75rem !important;\n  }\n  .p-xxl-12 {\n    padding: 3rem !important;\n  }\n  .p-xxl-13 {\n    padding: 3.25rem !important;\n  }\n  .p-xxl-14 {\n    padding: 3.5rem !important;\n  }\n  .p-xxl-15 {\n    padding: 3.75rem !important;\n  }\n  .p-xxl-16 {\n    padding: 4rem !important;\n  }\n  .p-xxl-17 {\n    padding: 4.25rem !important;\n  }\n  .p-xxl-18 {\n    padding: 4.5rem !important;\n  }\n  .p-xxl-19 {\n    padding: 4.75rem !important;\n  }\n  .p-xxl-20 {\n    padding: 5rem !important;\n  }\n  .px-xxl-0 {\n    padding-right: 0 !important;\n    padding-left: 0 !important;\n  }\n  .px-xxl-1 {\n    padding-right: 0.25rem !important;\n    padding-left: 0.25rem !important;\n  }\n  .px-xxl-2 {\n    padding-right: 0.5rem !important;\n    padding-left: 0.5rem !important;\n  }\n  .px-xxl-3 {\n    padding-right: 0.75rem !important;\n    padding-left: 0.75rem !important;\n  }\n  .px-xxl-4 {\n    padding-right: 1rem !important;\n    padding-left: 1rem !important;\n  }\n  .px-xxl-5 {\n    padding-right: 1.25rem !important;\n    padding-left: 1.25rem !important;\n  }\n  .px-xxl-6 {\n    padding-right: 1.5rem !important;\n    padding-left: 1.5rem !important;\n  }\n  .px-xxl-7 {\n    padding-right: 1.75rem !important;\n    padding-left: 1.75rem !important;\n  }\n  .px-xxl-8 {\n    padding-right: 2rem !important;\n    padding-left: 2rem !important;\n  }\n  .px-xxl-9 {\n    padding-right: 2.25rem !important;\n    padding-left: 2.25rem !important;\n  }\n  .px-xxl-10 {\n    padding-right: 2.5rem !important;\n    padding-left: 2.5rem !important;\n  }\n  .px-xxl-11 {\n    padding-right: 2.75rem !important;\n    padding-left: 2.75rem !important;\n  }\n  .px-xxl-12 {\n    padding-right: 3rem !important;\n    padding-left: 3rem !important;\n  }\n  .px-xxl-13 {\n    padding-right: 3.25rem !important;\n    padding-left: 3.25rem !important;\n  }\n  .px-xxl-14 {\n    padding-right: 3.5rem !important;\n    padding-left: 3.5rem !important;\n  }\n  .px-xxl-15 {\n    padding-right: 3.75rem !important;\n    padding-left: 3.75rem !important;\n  }\n  .px-xxl-16 {\n    padding-right: 4rem !important;\n    padding-left: 4rem !important;\n  }\n  .px-xxl-17 {\n    padding-right: 4.25rem !important;\n    padding-left: 4.25rem !important;\n  }\n  .px-xxl-18 {\n    padding-right: 4.5rem !important;\n    padding-left: 4.5rem !important;\n  }\n  .px-xxl-19 {\n    padding-right: 4.75rem !important;\n    padding-left: 4.75rem !important;\n  }\n  .px-xxl-20 {\n    padding-right: 5rem !important;\n    padding-left: 5rem !important;\n  }\n  .py-xxl-0 {\n    padding-top: 0 !important;\n    padding-bottom: 0 !important;\n  }\n  .py-xxl-1 {\n    padding-top: 0.25rem !important;\n    padding-bottom: 0.25rem !important;\n  }\n  .py-xxl-2 {\n    padding-top: 0.5rem !important;\n    padding-bottom: 0.5rem !important;\n  }\n  .py-xxl-3 {\n    padding-top: 0.75rem !important;\n    padding-bottom: 0.75rem !important;\n  }\n  .py-xxl-4 {\n    padding-top: 1rem !important;\n    padding-bottom: 1rem !important;\n  }\n  .py-xxl-5 {\n    padding-top: 1.25rem !important;\n    padding-bottom: 1.25rem !important;\n  }\n  .py-xxl-6 {\n    padding-top: 1.5rem !important;\n    padding-bottom: 1.5rem !important;\n  }\n  .py-xxl-7 {\n    padding-top: 1.75rem !important;\n    padding-bottom: 1.75rem !important;\n  }\n  .py-xxl-8 {\n    padding-top: 2rem !important;\n    padding-bottom: 2rem !important;\n  }\n  .py-xxl-9 {\n    padding-top: 2.25rem !important;\n    padding-bottom: 2.25rem !important;\n  }\n  .py-xxl-10 {\n    padding-top: 2.5rem !important;\n    padding-bottom: 2.5rem !important;\n  }\n  .py-xxl-11 {\n    padding-top: 2.75rem !important;\n    padding-bottom: 2.75rem !important;\n  }\n  .py-xxl-12 {\n    padding-top: 3rem !important;\n    padding-bottom: 3rem !important;\n  }\n  .py-xxl-13 {\n    padding-top: 3.25rem !important;\n    padding-bottom: 3.25rem !important;\n  }\n  .py-xxl-14 {\n    padding-top: 3.5rem !important;\n    padding-bottom: 3.5rem !important;\n  }\n  .py-xxl-15 {\n    padding-top: 3.75rem !important;\n    padding-bottom: 3.75rem !important;\n  }\n  .py-xxl-16 {\n    padding-top: 4rem !important;\n    padding-bottom: 4rem !important;\n  }\n  .py-xxl-17 {\n    padding-top: 4.25rem !important;\n    padding-bottom: 4.25rem !important;\n  }\n  .py-xxl-18 {\n    padding-top: 4.5rem !important;\n    padding-bottom: 4.5rem !important;\n  }\n  .py-xxl-19 {\n    padding-top: 4.75rem !important;\n    padding-bottom: 4.75rem !important;\n  }\n  .py-xxl-20 {\n    padding-top: 5rem !important;\n    padding-bottom: 5rem !important;\n  }\n  .pt-xxl-0 {\n    padding-top: 0 !important;\n  }\n  .pt-xxl-1 {\n    padding-top: 0.25rem !important;\n  }\n  .pt-xxl-2 {\n    padding-top: 0.5rem !important;\n  }\n  .pt-xxl-3 {\n    padding-top: 0.75rem !important;\n  }\n  .pt-xxl-4 {\n    padding-top: 1rem !important;\n  }\n  .pt-xxl-5 {\n    padding-top: 1.25rem !important;\n  }\n  .pt-xxl-6 {\n    padding-top: 1.5rem !important;\n  }\n  .pt-xxl-7 {\n    padding-top: 1.75rem !important;\n  }\n  .pt-xxl-8 {\n    padding-top: 2rem !important;\n  }\n  .pt-xxl-9 {\n    padding-top: 2.25rem !important;\n  }\n  .pt-xxl-10 {\n    padding-top: 2.5rem !important;\n  }\n  .pt-xxl-11 {\n    padding-top: 2.75rem !important;\n  }\n  .pt-xxl-12 {\n    padding-top: 3rem !important;\n  }\n  .pt-xxl-13 {\n    padding-top: 3.25rem !important;\n  }\n  .pt-xxl-14 {\n    padding-top: 3.5rem !important;\n  }\n  .pt-xxl-15 {\n    padding-top: 3.75rem !important;\n  }\n  .pt-xxl-16 {\n    padding-top: 4rem !important;\n  }\n  .pt-xxl-17 {\n    padding-top: 4.25rem !important;\n  }\n  .pt-xxl-18 {\n    padding-top: 4.5rem !important;\n  }\n  .pt-xxl-19 {\n    padding-top: 4.75rem !important;\n  }\n  .pt-xxl-20 {\n    padding-top: 5rem !important;\n  }\n  .pe-xxl-0 {\n    padding-right: 0 !important;\n  }\n  .pe-xxl-1 {\n    padding-right: 0.25rem !important;\n  }\n  .pe-xxl-2 {\n    padding-right: 0.5rem !important;\n  }\n  .pe-xxl-3 {\n    padding-right: 0.75rem !important;\n  }\n  .pe-xxl-4 {\n    padding-right: 1rem !important;\n  }\n  .pe-xxl-5 {\n    padding-right: 1.25rem !important;\n  }\n  .pe-xxl-6 {\n    padding-right: 1.5rem !important;\n  }\n  .pe-xxl-7 {\n    padding-right: 1.75rem !important;\n  }\n  .pe-xxl-8 {\n    padding-right: 2rem !important;\n  }\n  .pe-xxl-9 {\n    padding-right: 2.25rem !important;\n  }\n  .pe-xxl-10 {\n    padding-right: 2.5rem !important;\n  }\n  .pe-xxl-11 {\n    padding-right: 2.75rem !important;\n  }\n  .pe-xxl-12 {\n    padding-right: 3rem !important;\n  }\n  .pe-xxl-13 {\n    padding-right: 3.25rem !important;\n  }\n  .pe-xxl-14 {\n    padding-right: 3.5rem !important;\n  }\n  .pe-xxl-15 {\n    padding-right: 3.75rem !important;\n  }\n  .pe-xxl-16 {\n    padding-right: 4rem !important;\n  }\n  .pe-xxl-17 {\n    padding-right: 4.25rem !important;\n  }\n  .pe-xxl-18 {\n    padding-right: 4.5rem !important;\n  }\n  .pe-xxl-19 {\n    padding-right: 4.75rem !important;\n  }\n  .pe-xxl-20 {\n    padding-right: 5rem !important;\n  }\n  .pb-xxl-0 {\n    padding-bottom: 0 !important;\n  }\n  .pb-xxl-1 {\n    padding-bottom: 0.25rem !important;\n  }\n  .pb-xxl-2 {\n    padding-bottom: 0.5rem !important;\n  }\n  .pb-xxl-3 {\n    padding-bottom: 0.75rem !important;\n  }\n  .pb-xxl-4 {\n    padding-bottom: 1rem !important;\n  }\n  .pb-xxl-5 {\n    padding-bottom: 1.25rem !important;\n  }\n  .pb-xxl-6 {\n    padding-bottom: 1.5rem !important;\n  }\n  .pb-xxl-7 {\n    padding-bottom: 1.75rem !important;\n  }\n  .pb-xxl-8 {\n    padding-bottom: 2rem !important;\n  }\n  .pb-xxl-9 {\n    padding-bottom: 2.25rem !important;\n  }\n  .pb-xxl-10 {\n    padding-bottom: 2.5rem !important;\n  }\n  .pb-xxl-11 {\n    padding-bottom: 2.75rem !important;\n  }\n  .pb-xxl-12 {\n    padding-bottom: 3rem !important;\n  }\n  .pb-xxl-13 {\n    padding-bottom: 3.25rem !important;\n  }\n  .pb-xxl-14 {\n    padding-bottom: 3.5rem !important;\n  }\n  .pb-xxl-15 {\n    padding-bottom: 3.75rem !important;\n  }\n  .pb-xxl-16 {\n    padding-bottom: 4rem !important;\n  }\n  .pb-xxl-17 {\n    padding-bottom: 4.25rem !important;\n  }\n  .pb-xxl-18 {\n    padding-bottom: 4.5rem !important;\n  }\n  .pb-xxl-19 {\n    padding-bottom: 4.75rem !important;\n  }\n  .pb-xxl-20 {\n    padding-bottom: 5rem !important;\n  }\n  .ps-xxl-0 {\n    padding-left: 0 !important;\n  }\n  .ps-xxl-1 {\n    padding-left: 0.25rem !important;\n  }\n  .ps-xxl-2 {\n    padding-left: 0.5rem !important;\n  }\n  .ps-xxl-3 {\n    padding-left: 0.75rem !important;\n  }\n  .ps-xxl-4 {\n    padding-left: 1rem !important;\n  }\n  .ps-xxl-5 {\n    padding-left: 1.25rem !important;\n  }\n  .ps-xxl-6 {\n    padding-left: 1.5rem !important;\n  }\n  .ps-xxl-7 {\n    padding-left: 1.75rem !important;\n  }\n  .ps-xxl-8 {\n    padding-left: 2rem !important;\n  }\n  .ps-xxl-9 {\n    padding-left: 2.25rem !important;\n  }\n  .ps-xxl-10 {\n    padding-left: 2.5rem !important;\n  }\n  .ps-xxl-11 {\n    padding-left: 2.75rem !important;\n  }\n  .ps-xxl-12 {\n    padding-left: 3rem !important;\n  }\n  .ps-xxl-13 {\n    padding-left: 3.25rem !important;\n  }\n  .ps-xxl-14 {\n    padding-left: 3.5rem !important;\n  }\n  .ps-xxl-15 {\n    padding-left: 3.75rem !important;\n  }\n  .ps-xxl-16 {\n    padding-left: 4rem !important;\n  }\n  .ps-xxl-17 {\n    padding-left: 4.25rem !important;\n  }\n  .ps-xxl-18 {\n    padding-left: 4.5rem !important;\n  }\n  .ps-xxl-19 {\n    padding-left: 4.75rem !important;\n  }\n  .ps-xxl-20 {\n    padding-left: 5rem !important;\n  }\n  .gap-xxl-0 {\n    gap: 0 !important;\n  }\n  .gap-xxl-1 {\n    gap: 0.25rem !important;\n  }\n  .gap-xxl-2 {\n    gap: 0.5rem !important;\n  }\n  .gap-xxl-3 {\n    gap: 0.75rem !important;\n  }\n  .gap-xxl-4 {\n    gap: 1rem !important;\n  }\n  .gap-xxl-5 {\n    gap: 1.25rem !important;\n  }\n  .gap-xxl-6 {\n    gap: 1.5rem !important;\n  }\n  .gap-xxl-7 {\n    gap: 1.75rem !important;\n  }\n  .gap-xxl-8 {\n    gap: 2rem !important;\n  }\n  .gap-xxl-9 {\n    gap: 2.25rem !important;\n  }\n  .gap-xxl-10 {\n    gap: 2.5rem !important;\n  }\n  .gap-xxl-11 {\n    gap: 2.75rem !important;\n  }\n  .gap-xxl-12 {\n    gap: 3rem !important;\n  }\n  .gap-xxl-13 {\n    gap: 3.25rem !important;\n  }\n  .gap-xxl-14 {\n    gap: 3.5rem !important;\n  }\n  .gap-xxl-15 {\n    gap: 3.75rem !important;\n  }\n  .gap-xxl-16 {\n    gap: 4rem !important;\n  }\n  .gap-xxl-17 {\n    gap: 4.25rem !important;\n  }\n  .gap-xxl-18 {\n    gap: 4.5rem !important;\n  }\n  .gap-xxl-19 {\n    gap: 4.75rem !important;\n  }\n  .gap-xxl-20 {\n    gap: 5rem !important;\n  }\n  .row-gap-xxl-0 {\n    row-gap: 0 !important;\n  }\n  .row-gap-xxl-1 {\n    row-gap: 0.25rem !important;\n  }\n  .row-gap-xxl-2 {\n    row-gap: 0.5rem !important;\n  }\n  .row-gap-xxl-3 {\n    row-gap: 0.75rem !important;\n  }\n  .row-gap-xxl-4 {\n    row-gap: 1rem !important;\n  }\n  .row-gap-xxl-5 {\n    row-gap: 1.25rem !important;\n  }\n  .row-gap-xxl-6 {\n    row-gap: 1.5rem !important;\n  }\n  .row-gap-xxl-7 {\n    row-gap: 1.75rem !important;\n  }\n  .row-gap-xxl-8 {\n    row-gap: 2rem !important;\n  }\n  .row-gap-xxl-9 {\n    row-gap: 2.25rem !important;\n  }\n  .row-gap-xxl-10 {\n    row-gap: 2.5rem !important;\n  }\n  .row-gap-xxl-11 {\n    row-gap: 2.75rem !important;\n  }\n  .row-gap-xxl-12 {\n    row-gap: 3rem !important;\n  }\n  .row-gap-xxl-13 {\n    row-gap: 3.25rem !important;\n  }\n  .row-gap-xxl-14 {\n    row-gap: 3.5rem !important;\n  }\n  .row-gap-xxl-15 {\n    row-gap: 3.75rem !important;\n  }\n  .row-gap-xxl-16 {\n    row-gap: 4rem !important;\n  }\n  .row-gap-xxl-17 {\n    row-gap: 4.25rem !important;\n  }\n  .row-gap-xxl-18 {\n    row-gap: 4.5rem !important;\n  }\n  .row-gap-xxl-19 {\n    row-gap: 4.75rem !important;\n  }\n  .row-gap-xxl-20 {\n    row-gap: 5rem !important;\n  }\n  .column-gap-xxl-0 {\n    column-gap: 0 !important;\n  }\n  .column-gap-xxl-1 {\n    column-gap: 0.25rem !important;\n  }\n  .column-gap-xxl-2 {\n    column-gap: 0.5rem !important;\n  }\n  .column-gap-xxl-3 {\n    column-gap: 0.75rem !important;\n  }\n  .column-gap-xxl-4 {\n    column-gap: 1rem !important;\n  }\n  .column-gap-xxl-5 {\n    column-gap: 1.25rem !important;\n  }\n  .column-gap-xxl-6 {\n    column-gap: 1.5rem !important;\n  }\n  .column-gap-xxl-7 {\n    column-gap: 1.75rem !important;\n  }\n  .column-gap-xxl-8 {\n    column-gap: 2rem !important;\n  }\n  .column-gap-xxl-9 {\n    column-gap: 2.25rem !important;\n  }\n  .column-gap-xxl-10 {\n    column-gap: 2.5rem !important;\n  }\n  .column-gap-xxl-11 {\n    column-gap: 2.75rem !important;\n  }\n  .column-gap-xxl-12 {\n    column-gap: 3rem !important;\n  }\n  .column-gap-xxl-13 {\n    column-gap: 3.25rem !important;\n  }\n  .column-gap-xxl-14 {\n    column-gap: 3.5rem !important;\n  }\n  .column-gap-xxl-15 {\n    column-gap: 3.75rem !important;\n  }\n  .column-gap-xxl-16 {\n    column-gap: 4rem !important;\n  }\n  .column-gap-xxl-17 {\n    column-gap: 4.25rem !important;\n  }\n  .column-gap-xxl-18 {\n    column-gap: 4.5rem !important;\n  }\n  .column-gap-xxl-19 {\n    column-gap: 4.75rem !important;\n  }\n  .column-gap-xxl-20 {\n    column-gap: 5rem !important;\n  }\n  .fs-xxl-1 {\n    font-size: calc(1.3rem + 0.6vw) !important;\n  }\n  .fs-xxl-2 {\n    font-size: calc(1.275rem + 0.3vw) !important;\n  }\n  .fs-xxl-3 {\n    font-size: calc(1.26rem + 0.12vw) !important;\n  }\n  .fs-xxl-4 {\n    font-size: 1.25rem !important;\n  }\n  .fs-xxl-5 {\n    font-size: 1.15rem !important;\n  }\n  .fs-xxl-6 {\n    font-size: 1.075rem !important;\n  }\n  .fs-xxl-7 {\n    font-size: 0.95rem !important;\n  }\n  .fs-xxl-8 {\n    font-size: 0.85rem !important;\n  }\n  .fs-xxl-9 {\n    font-size: 0.75rem !important;\n  }\n  .fs-xxl-10 {\n    font-size: 0.5rem !important;\n  }\n  .fs-xxl-base {\n    font-size: 1rem !important;\n  }\n  .fs-xxl-fluid {\n    font-size: 100% !important;\n  }\n  .fs-xxl-2x {\n    font-size: calc(1.325rem + 0.9vw) !important;\n  }\n  .fs-xxl-2qx {\n    font-size: calc(1.35rem + 1.2vw) !important;\n  }\n  .fs-xxl-2hx {\n    font-size: calc(1.375rem + 1.5vw) !important;\n  }\n  .fs-xxl-2tx {\n    font-size: calc(1.4rem + 1.8vw) !important;\n  }\n  .fs-xxl-3x {\n    font-size: calc(1.425rem + 2.1vw) !important;\n  }\n  .fs-xxl-3qx {\n    font-size: calc(1.45rem + 2.4vw) !important;\n  }\n  .fs-xxl-3hx {\n    font-size: calc(1.475rem + 2.7vw) !important;\n  }\n  .fs-xxl-3tx {\n    font-size: calc(1.5rem + 3vw) !important;\n  }\n  .fs-xxl-4x {\n    font-size: calc(1.525rem + 3.3vw) !important;\n  }\n  .fs-xxl-4qx {\n    font-size: calc(1.55rem + 3.6vw) !important;\n  }\n  .fs-xxl-4hx {\n    font-size: calc(1.575rem + 3.9vw) !important;\n  }\n  .fs-xxl-4tx {\n    font-size: calc(1.6rem + 4.2vw) !important;\n  }\n  .fs-xxl-5x {\n    font-size: calc(1.625rem + 4.5vw) !important;\n  }\n  .fs-xxl-5qx {\n    font-size: calc(1.65rem + 4.8vw) !important;\n  }\n  .fs-xxl-5hx {\n    font-size: calc(1.675rem + 5.1vw) !important;\n  }\n  .fs-xxl-5tx {\n    font-size: calc(1.7rem + 5.4vw) !important;\n  }\n  .fs-xxl-6x {\n    font-size: calc(1.725rem + 5.7vw) !important;\n  }\n  .fs-xxl-6qx {\n    font-size: calc(1.75rem + 6vw) !important;\n  }\n  .fs-xxl-6hx {\n    font-size: calc(1.775rem + 6.3vw) !important;\n  }\n  .fs-xxl-6tx {\n    font-size: calc(1.8rem + 6.6vw) !important;\n  }\n  .fs-xxl-7x {\n    font-size: calc(1.825rem + 6.9vw) !important;\n  }\n  .fs-xxl-7qx {\n    font-size: calc(1.85rem + 7.2vw) !important;\n  }\n  .fs-xxl-7hx {\n    font-size: calc(1.875rem + 7.5vw) !important;\n  }\n  .fs-xxl-7tx {\n    font-size: calc(1.9rem + 7.8vw) !important;\n  }\n  .text-xxl-start {\n    text-align: left !important;\n  }\n  .text-xxl-end {\n    text-align: right !important;\n  }\n  .text-xxl-center {\n    text-align: center !important;\n  }\n  .min-w-xxl-unset {\n    min-width: unset !important;\n  }\n  .min-w-xxl-25 {\n    min-width: 25% !important;\n  }\n  .min-w-xxl-50 {\n    min-width: 50% !important;\n  }\n  .min-w-xxl-75 {\n    min-width: 75% !important;\n  }\n  .min-w-xxl-100 {\n    min-width: 100% !important;\n  }\n  .min-w-xxl-auto {\n    min-width: auto !important;\n  }\n  .min-w-xxl-1px {\n    min-width: 1px !important;\n  }\n  .min-w-xxl-2px {\n    min-width: 2px !important;\n  }\n  .min-w-xxl-3px {\n    min-width: 3px !important;\n  }\n  .min-w-xxl-4px {\n    min-width: 4px !important;\n  }\n  .min-w-xxl-5px {\n    min-width: 5px !important;\n  }\n  .min-w-xxl-6px {\n    min-width: 6px !important;\n  }\n  .min-w-xxl-7px {\n    min-width: 7px !important;\n  }\n  .min-w-xxl-8px {\n    min-width: 8px !important;\n  }\n  .min-w-xxl-9px {\n    min-width: 9px !important;\n  }\n  .min-w-xxl-10px {\n    min-width: 10px !important;\n  }\n  .min-w-xxl-15px {\n    min-width: 15px !important;\n  }\n  .min-w-xxl-20px {\n    min-width: 20px !important;\n  }\n  .min-w-xxl-25px {\n    min-width: 25px !important;\n  }\n  .min-w-xxl-30px {\n    min-width: 30px !important;\n  }\n  .min-w-xxl-35px {\n    min-width: 35px !important;\n  }\n  .min-w-xxl-40px {\n    min-width: 40px !important;\n  }\n  .min-w-xxl-45px {\n    min-width: 45px !important;\n  }\n  .min-w-xxl-50px {\n    min-width: 50px !important;\n  }\n  .min-w-xxl-55px {\n    min-width: 55px !important;\n  }\n  .min-w-xxl-60px {\n    min-width: 60px !important;\n  }\n  .min-w-xxl-65px {\n    min-width: 65px !important;\n  }\n  .min-w-xxl-70px {\n    min-width: 70px !important;\n  }\n  .min-w-xxl-75px {\n    min-width: 75px !important;\n  }\n  .min-w-xxl-80px {\n    min-width: 80px !important;\n  }\n  .min-w-xxl-85px {\n    min-width: 85px !important;\n  }\n  .min-w-xxl-90px {\n    min-width: 90px !important;\n  }\n  .min-w-xxl-95px {\n    min-width: 95px !important;\n  }\n  .min-w-xxl-100px {\n    min-width: 100px !important;\n  }\n  .min-w-xxl-125px {\n    min-width: 125px !important;\n  }\n  .min-w-xxl-150px {\n    min-width: 150px !important;\n  }\n  .min-w-xxl-175px {\n    min-width: 175px !important;\n  }\n  .min-w-xxl-200px {\n    min-width: 200px !important;\n  }\n  .min-w-xxl-225px {\n    min-width: 225px !important;\n  }\n  .min-w-xxl-250px {\n    min-width: 250px !important;\n  }\n  .min-w-xxl-275px {\n    min-width: 275px !important;\n  }\n  .min-w-xxl-300px {\n    min-width: 300px !important;\n  }\n  .min-w-xxl-325px {\n    min-width: 325px !important;\n  }\n  .min-w-xxl-350px {\n    min-width: 350px !important;\n  }\n  .min-w-xxl-375px {\n    min-width: 375px !important;\n  }\n  .min-w-xxl-400px {\n    min-width: 400px !important;\n  }\n  .min-w-xxl-425px {\n    min-width: 425px !important;\n  }\n  .min-w-xxl-450px {\n    min-width: 450px !important;\n  }\n  .min-w-xxl-475px {\n    min-width: 475px !important;\n  }\n  .min-w-xxl-500px {\n    min-width: 500px !important;\n  }\n  .min-w-xxl-550px {\n    min-width: 550px !important;\n  }\n  .min-w-xxl-600px {\n    min-width: 600px !important;\n  }\n  .min-w-xxl-650px {\n    min-width: 650px !important;\n  }\n  .min-w-xxl-700px {\n    min-width: 700px !important;\n  }\n  .min-w-xxl-750px {\n    min-width: 750px !important;\n  }\n  .min-w-xxl-800px {\n    min-width: 800px !important;\n  }\n  .min-w-xxl-850px {\n    min-width: 850px !important;\n  }\n  .min-w-xxl-900px {\n    min-width: 900px !important;\n  }\n  .min-w-xxl-950px {\n    min-width: 950px !important;\n  }\n  .min-w-xxl-1000px {\n    min-width: 1000px !important;\n  }\n  .min-h-xxl-unset {\n    min-height: unset !important;\n  }\n  .min-h-xxl-25 {\n    min-height: 25% !important;\n  }\n  .min-h-xxl-50 {\n    min-height: 50% !important;\n  }\n  .min-h-xxl-75 {\n    min-height: 75% !important;\n  }\n  .min-h-xxl-100 {\n    min-height: 100% !important;\n  }\n  .min-h-xxl-auto {\n    min-height: auto !important;\n  }\n  .min-h-xxl-1px {\n    min-height: 1px !important;\n  }\n  .min-h-xxl-2px {\n    min-height: 2px !important;\n  }\n  .min-h-xxl-3px {\n    min-height: 3px !important;\n  }\n  .min-h-xxl-4px {\n    min-height: 4px !important;\n  }\n  .min-h-xxl-5px {\n    min-height: 5px !important;\n  }\n  .min-h-xxl-6px {\n    min-height: 6px !important;\n  }\n  .min-h-xxl-7px {\n    min-height: 7px !important;\n  }\n  .min-h-xxl-8px {\n    min-height: 8px !important;\n  }\n  .min-h-xxl-9px {\n    min-height: 9px !important;\n  }\n  .min-h-xxl-10px {\n    min-height: 10px !important;\n  }\n  .min-h-xxl-15px {\n    min-height: 15px !important;\n  }\n  .min-h-xxl-20px {\n    min-height: 20px !important;\n  }\n  .min-h-xxl-25px {\n    min-height: 25px !important;\n  }\n  .min-h-xxl-30px {\n    min-height: 30px !important;\n  }\n  .min-h-xxl-35px {\n    min-height: 35px !important;\n  }\n  .min-h-xxl-40px {\n    min-height: 40px !important;\n  }\n  .min-h-xxl-45px {\n    min-height: 45px !important;\n  }\n  .min-h-xxl-50px {\n    min-height: 50px !important;\n  }\n  .min-h-xxl-55px {\n    min-height: 55px !important;\n  }\n  .min-h-xxl-60px {\n    min-height: 60px !important;\n  }\n  .min-h-xxl-65px {\n    min-height: 65px !important;\n  }\n  .min-h-xxl-70px {\n    min-height: 70px !important;\n  }\n  .min-h-xxl-75px {\n    min-height: 75px !important;\n  }\n  .min-h-xxl-80px {\n    min-height: 80px !important;\n  }\n  .min-h-xxl-85px {\n    min-height: 85px !important;\n  }\n  .min-h-xxl-90px {\n    min-height: 90px !important;\n  }\n  .min-h-xxl-95px {\n    min-height: 95px !important;\n  }\n  .min-h-xxl-100px {\n    min-height: 100px !important;\n  }\n  .min-h-xxl-125px {\n    min-height: 125px !important;\n  }\n  .min-h-xxl-150px {\n    min-height: 150px !important;\n  }\n  .min-h-xxl-175px {\n    min-height: 175px !important;\n  }\n  .min-h-xxl-200px {\n    min-height: 200px !important;\n  }\n  .min-h-xxl-225px {\n    min-height: 225px !important;\n  }\n  .min-h-xxl-250px {\n    min-height: 250px !important;\n  }\n  .min-h-xxl-275px {\n    min-height: 275px !important;\n  }\n  .min-h-xxl-300px {\n    min-height: 300px !important;\n  }\n  .min-h-xxl-325px {\n    min-height: 325px !important;\n  }\n  .min-h-xxl-350px {\n    min-height: 350px !important;\n  }\n  .min-h-xxl-375px {\n    min-height: 375px !important;\n  }\n  .min-h-xxl-400px {\n    min-height: 400px !important;\n  }\n  .min-h-xxl-425px {\n    min-height: 425px !important;\n  }\n  .min-h-xxl-450px {\n    min-height: 450px !important;\n  }\n  .min-h-xxl-475px {\n    min-height: 475px !important;\n  }\n  .min-h-xxl-500px {\n    min-height: 500px !important;\n  }\n  .min-h-xxl-550px {\n    min-height: 550px !important;\n  }\n  .min-h-xxl-600px {\n    min-height: 600px !important;\n  }\n  .min-h-xxl-650px {\n    min-height: 650px !important;\n  }\n  .min-h-xxl-700px {\n    min-height: 700px !important;\n  }\n  .min-h-xxl-750px {\n    min-height: 750px !important;\n  }\n  .min-h-xxl-800px {\n    min-height: 800px !important;\n  }\n  .min-h-xxl-850px {\n    min-height: 850px !important;\n  }\n  .min-h-xxl-900px {\n    min-height: 900px !important;\n  }\n  .min-h-xxl-950px {\n    min-height: 950px !important;\n  }\n  .min-h-xxl-1000px {\n    min-height: 1000px !important;\n  }\n}\n@media (min-width: 1200px) {\n  .fs-1 {\n    font-size: 1.75rem !important;\n  }\n  .fs-2 {\n    font-size: 1.5rem !important;\n  }\n  .fs-3 {\n    font-size: 1.35rem !important;\n  }\n  .fs-2x {\n    font-size: 2rem !important;\n  }\n  .fs-2qx {\n    font-size: 2.25rem !important;\n  }\n  .fs-2hx {\n    font-size: 2.5rem !important;\n  }\n  .fs-2tx {\n    font-size: 2.75rem !important;\n  }\n  .fs-3x {\n    font-size: 3rem !important;\n  }\n  .fs-3qx {\n    font-size: 3.25rem !important;\n  }\n  .fs-3hx {\n    font-size: 3.5rem !important;\n  }\n  .fs-3tx {\n    font-size: 3.75rem !important;\n  }\n  .fs-4x {\n    font-size: 4rem !important;\n  }\n  .fs-4qx {\n    font-size: 4.25rem !important;\n  }\n  .fs-4hx {\n    font-size: 4.5rem !important;\n  }\n  .fs-4tx {\n    font-size: 4.75rem !important;\n  }\n  .fs-5x {\n    font-size: 5rem !important;\n  }\n  .fs-5qx {\n    font-size: 5.25rem !important;\n  }\n  .fs-5hx {\n    font-size: 5.5rem !important;\n  }\n  .fs-5tx {\n    font-size: 5.75rem !important;\n  }\n  .fs-6x {\n    font-size: 6rem !important;\n  }\n  .fs-6qx {\n    font-size: 6.25rem !important;\n  }\n  .fs-6hx {\n    font-size: 6.5rem !important;\n  }\n  .fs-6tx {\n    font-size: 6.75rem !important;\n  }\n  .fs-7x {\n    font-size: 7rem !important;\n  }\n  .fs-7qx {\n    font-size: 7.25rem !important;\n  }\n  .fs-7hx {\n    font-size: 7.5rem !important;\n  }\n  .fs-7tx {\n    font-size: 7.75rem !important;\n  }\n  .fs-sm-1 {\n    font-size: 1.75rem !important;\n  }\n  .fs-sm-2 {\n    font-size: 1.5rem !important;\n  }\n  .fs-sm-3 {\n    font-size: 1.35rem !important;\n  }\n  .fs-sm-2x {\n    font-size: 2rem !important;\n  }\n  .fs-sm-2qx {\n    font-size: 2.25rem !important;\n  }\n  .fs-sm-2hx {\n    font-size: 2.5rem !important;\n  }\n  .fs-sm-2tx {\n    font-size: 2.75rem !important;\n  }\n  .fs-sm-3x {\n    font-size: 3rem !important;\n  }\n  .fs-sm-3qx {\n    font-size: 3.25rem !important;\n  }\n  .fs-sm-3hx {\n    font-size: 3.5rem !important;\n  }\n  .fs-sm-3tx {\n    font-size: 3.75rem !important;\n  }\n  .fs-sm-4x {\n    font-size: 4rem !important;\n  }\n  .fs-sm-4qx {\n    font-size: 4.25rem !important;\n  }\n  .fs-sm-4hx {\n    font-size: 4.5rem !important;\n  }\n  .fs-sm-4tx {\n    font-size: 4.75rem !important;\n  }\n  .fs-sm-5x {\n    font-size: 5rem !important;\n  }\n  .fs-sm-5qx {\n    font-size: 5.25rem !important;\n  }\n  .fs-sm-5hx {\n    font-size: 5.5rem !important;\n  }\n  .fs-sm-5tx {\n    font-size: 5.75rem !important;\n  }\n  .fs-sm-6x {\n    font-size: 6rem !important;\n  }\n  .fs-sm-6qx {\n    font-size: 6.25rem !important;\n  }\n  .fs-sm-6hx {\n    font-size: 6.5rem !important;\n  }\n  .fs-sm-6tx {\n    font-size: 6.75rem !important;\n  }\n  .fs-sm-7x {\n    font-size: 7rem !important;\n  }\n  .fs-sm-7qx {\n    font-size: 7.25rem !important;\n  }\n  .fs-sm-7hx {\n    font-size: 7.5rem !important;\n  }\n  .fs-sm-7tx {\n    font-size: 7.75rem !important;\n  }\n  .fs-md-1 {\n    font-size: 1.75rem !important;\n  }\n  .fs-md-2 {\n    font-size: 1.5rem !important;\n  }\n  .fs-md-3 {\n    font-size: 1.35rem !important;\n  }\n  .fs-md-2x {\n    font-size: 2rem !important;\n  }\n  .fs-md-2qx {\n    font-size: 2.25rem !important;\n  }\n  .fs-md-2hx {\n    font-size: 2.5rem !important;\n  }\n  .fs-md-2tx {\n    font-size: 2.75rem !important;\n  }\n  .fs-md-3x {\n    font-size: 3rem !important;\n  }\n  .fs-md-3qx {\n    font-size: 3.25rem !important;\n  }\n  .fs-md-3hx {\n    font-size: 3.5rem !important;\n  }\n  .fs-md-3tx {\n    font-size: 3.75rem !important;\n  }\n  .fs-md-4x {\n    font-size: 4rem !important;\n  }\n  .fs-md-4qx {\n    font-size: 4.25rem !important;\n  }\n  .fs-md-4hx {\n    font-size: 4.5rem !important;\n  }\n  .fs-md-4tx {\n    font-size: 4.75rem !important;\n  }\n  .fs-md-5x {\n    font-size: 5rem !important;\n  }\n  .fs-md-5qx {\n    font-size: 5.25rem !important;\n  }\n  .fs-md-5hx {\n    font-size: 5.5rem !important;\n  }\n  .fs-md-5tx {\n    font-size: 5.75rem !important;\n  }\n  .fs-md-6x {\n    font-size: 6rem !important;\n  }\n  .fs-md-6qx {\n    font-size: 6.25rem !important;\n  }\n  .fs-md-6hx {\n    font-size: 6.5rem !important;\n  }\n  .fs-md-6tx {\n    font-size: 6.75rem !important;\n  }\n  .fs-md-7x {\n    font-size: 7rem !important;\n  }\n  .fs-md-7qx {\n    font-size: 7.25rem !important;\n  }\n  .fs-md-7hx {\n    font-size: 7.5rem !important;\n  }\n  .fs-md-7tx {\n    font-size: 7.75rem !important;\n  }\n  .fs-lg-1 {\n    font-size: 1.75rem !important;\n  }\n  .fs-lg-2 {\n    font-size: 1.5rem !important;\n  }\n  .fs-lg-3 {\n    font-size: 1.35rem !important;\n  }\n  .fs-lg-2x {\n    font-size: 2rem !important;\n  }\n  .fs-lg-2qx {\n    font-size: 2.25rem !important;\n  }\n  .fs-lg-2hx {\n    font-size: 2.5rem !important;\n  }\n  .fs-lg-2tx {\n    font-size: 2.75rem !important;\n  }\n  .fs-lg-3x {\n    font-size: 3rem !important;\n  }\n  .fs-lg-3qx {\n    font-size: 3.25rem !important;\n  }\n  .fs-lg-3hx {\n    font-size: 3.5rem !important;\n  }\n  .fs-lg-3tx {\n    font-size: 3.75rem !important;\n  }\n  .fs-lg-4x {\n    font-size: 4rem !important;\n  }\n  .fs-lg-4qx {\n    font-size: 4.25rem !important;\n  }\n  .fs-lg-4hx {\n    font-size: 4.5rem !important;\n  }\n  .fs-lg-4tx {\n    font-size: 4.75rem !important;\n  }\n  .fs-lg-5x {\n    font-size: 5rem !important;\n  }\n  .fs-lg-5qx {\n    font-size: 5.25rem !important;\n  }\n  .fs-lg-5hx {\n    font-size: 5.5rem !important;\n  }\n  .fs-lg-5tx {\n    font-size: 5.75rem !important;\n  }\n  .fs-lg-6x {\n    font-size: 6rem !important;\n  }\n  .fs-lg-6qx {\n    font-size: 6.25rem !important;\n  }\n  .fs-lg-6hx {\n    font-size: 6.5rem !important;\n  }\n  .fs-lg-6tx {\n    font-size: 6.75rem !important;\n  }\n  .fs-lg-7x {\n    font-size: 7rem !important;\n  }\n  .fs-lg-7qx {\n    font-size: 7.25rem !important;\n  }\n  .fs-lg-7hx {\n    font-size: 7.5rem !important;\n  }\n  .fs-lg-7tx {\n    font-size: 7.75rem !important;\n  }\n}\n@media print {\n  .d-print-inline {\n    display: inline !important;\n  }\n  .d-print-inline-block {\n    display: inline-block !important;\n  }\n  .d-print-block {\n    display: block !important;\n  }\n  .d-print-grid {\n    display: grid !important;\n  }\n  .d-print-table {\n    display: table !important;\n  }\n  .d-print-table-row {\n    display: table-row !important;\n  }\n  .d-print-table-cell {\n    display: table-cell !important;\n  }\n  .d-print-flex {\n    display: flex !important;\n  }\n  .d-print-inline-flex {\n    display: inline-flex !important;\n  }\n  .d-print-none {\n    display: none !important;\n  }\n}\n\nh1, .h1, h2, .h2, h3, .h3, h4, .h4, h5, .h5, h6, .h6 {\n  outline: 0;\n}\n\n.blockquote-footer {\n  color: var(--bs-blockquote-footer-color);\n}\n\n.list-style-none {\n  list-style: none;\n}\n\n[data-kt-theme-mode-switching=true] * {\n  transition: none !important;\n}\n\n[data-bs-theme=light] .theme-dark-show {\n  display: none !important;\n}\n[data-bs-theme=light] .theme-light-bg-transparent {\n  background-color: transparent !important;\n}\n[data-bs-theme=light] .theme-light-bg-body {\n  background-color: var(--bs-body-bg) !important;\n}\n\n[data-bs-theme=dark] .theme-light-show {\n  display: none !important;\n}\n[data-bs-theme=dark] .theme-dark-bg-transparent {\n  background-color: transparent !important;\n}\n[data-bs-theme=dark] .theme-dark-bg-body {\n  background-color: var(--bs-body-bg) !important;\n}\n\n.animation {\n  animation-duration: 1s;\n  animation-fill-mode: both;\n}\n\n@keyframes animationSlideInDown {\n  from {\n    transform: translate3d(0, -100%, 0);\n    visibility: visible;\n  }\n  to {\n    transform: translate3d(0, 0, 0);\n  }\n}\n.animation-slide-in-down {\n  animation-name: animationSlideInDown;\n}\n\n@keyframes animationSlideInUp {\n  from {\n    transform: translate3d(0, 100%, 0);\n    visibility: visible;\n  }\n  to {\n    transform: translate3d(0, 0, 0);\n  }\n}\n.animation-slide-in-up {\n  animation-name: animationSlideInUp;\n}\n\n@keyframes animationFadeIn {\n  from {\n    opacity: 0;\n  }\n  to {\n    opacity: 1;\n  }\n}\n.animation-fade-in {\n  animation-name: animationFadeIn;\n}\n\n@keyframes animationFadeOut {\n  from {\n    opacity: 1;\n  }\n  to {\n    opacity: 0;\n  }\n}\n.animation-fade-out {\n  animation-name: animationFadeOut;\n}\n\n.animation-blink {\n  animation: animationBlink 1s steps(5, start) infinite;\n}\n\n@keyframes animationBlink {\n  to {\n    visibility: hidden;\n  }\n}\n.alert-light {\n  color: var(--bs-light);\n  border-color: var(--bs-light);\n  background-color: var(--bs-light-light);\n}\n.alert-light .alert-link {\n  color: var(--bs-light);\n}\n\n.alert-primary {\n  color: var(--bs-primary);\n  border-color: var(--bs-primary);\n  background-color: var(--bs-primary-light);\n}\n.alert-primary .alert-link {\n  color: var(--bs-primary);\n}\n\n.alert-secondary {\n  color: var(--bs-secondary);\n  border-color: var(--bs-secondary);\n  background-color: var(--bs-secondary-light);\n}\n.alert-secondary .alert-link {\n  color: var(--bs-secondary);\n}\n\n.alert-success {\n  color: var(--bs-success);\n  border-color: var(--bs-success);\n  background-color: var(--bs-success-light);\n}\n.alert-success .alert-link {\n  color: var(--bs-success);\n}\n\n.alert-info {\n  color: var(--bs-info);\n  border-color: var(--bs-info);\n  background-color: var(--bs-info-light);\n}\n.alert-info .alert-link {\n  color: var(--bs-info);\n}\n\n.alert-warning {\n  color: var(--bs-warning);\n  border-color: var(--bs-warning);\n  background-color: var(--bs-warning-light);\n}\n.alert-warning .alert-link {\n  color: var(--bs-warning);\n}\n\n.alert-danger {\n  color: var(--bs-danger);\n  border-color: var(--bs-danger);\n  background-color: var(--bs-danger-light);\n}\n.alert-danger .alert-link {\n  color: var(--bs-danger);\n}\n\n.alert-dark {\n  color: var(--bs-dark);\n  border-color: var(--bs-dark);\n  background-color: var(--bs-dark-light);\n}\n.alert-dark .alert-link {\n  color: var(--bs-dark);\n}\n\n[data-bs-theme=dark] .dropdown-menu {\n  box-shadow: 0px 0px 30px rgba(0, 0, 0, 0.3);\n}\n\n.toast .toast-header .btn-close {\n  margin-right: 0;\n}\n\n[data-bs-theme=dark] .toast {\n  --bs-toast-bg: #2B2B40;\n  --bs-toast-header-bg: #2B2B40;\n  --bs-toast-header-border-color: #323248;\n}\n\n.nav-pills .nav-item {\n  margin-right: 0.5rem;\n}\n.nav-pills .nav-item:last-child {\n  margin-right: 0;\n}\n\n.nav-stretch {\n  align-items: stretch;\n  padding-top: 0 !important;\n  padding-bottom: 0 !important;\n}\n.nav-stretch .nav-item {\n  display: flex;\n  align-items: stretch;\n  padding-top: 0 !important;\n  padding-bottom: 0 !important;\n}\n.nav-stretch .nav-link {\n  display: flex;\n  align-items: center;\n}\n\n.nav-group {\n  padding: 0.35rem;\n  border-radius: 0.475rem;\n  background-color: var(--bs-gray-100);\n}\n.nav-group.nav-group-outline {\n  background-color: transparent;\n  border: 1px solid var(--bs-border-color);\n}\n.nav-group.nav-group-fluid {\n  display: flex;\n}\n.nav-group.nav-group-fluid > label,\n.nav-group.nav-group-fluid > .btn {\n  position: relative;\n  flex-shrink: 0;\n  flex-grow: 1;\n  flex-basis: 0;\n}\n.nav-group.nav-group-fluid > label {\n  margin-right: 0.1rem;\n}\n.nav-group.nav-group-fluid > label > .btn {\n  width: 100%;\n}\n.nav-group.nav-group-fluid > label:last-child {\n  margin-right: 0;\n}\n\n.nav-line-tabs {\n  border-bottom-width: 1px;\n  border-bottom-style: solid;\n  border-bottom-color: var(--bs-border-color);\n}\n.nav-line-tabs .nav-item {\n  margin-bottom: -1px;\n}\n.nav-line-tabs .nav-item .nav-link {\n  color: var(--bs-gray-500);\n  border: 0;\n  border-bottom: 1px solid transparent;\n  transition: color 0.2s ease;\n  padding: 0.5rem 0;\n  margin: 0 1rem;\n}\n.nav-line-tabs .nav-item:first-child .nav-link {\n  margin-left: 0;\n}\n.nav-line-tabs .nav-item:last-child .nav-link {\n  margin-right: 0;\n}\n.nav-line-tabs .nav-item .nav-link.active,\n.nav-line-tabs .nav-item.show .nav-link,\n.nav-line-tabs .nav-item .nav-link:hover:not(.disabled) {\n  background-color: transparent;\n  border: 0;\n  border-bottom: 1px solid var(--bs-primary);\n  transition: color 0.2s ease;\n}\n.nav-line-tabs.nav-line-tabs-2x {\n  border-bottom-width: 2px;\n}\n.nav-line-tabs.nav-line-tabs-2x .nav-item {\n  margin-bottom: -2px;\n}\n.nav-line-tabs.nav-line-tabs-2x .nav-item .nav-link {\n  border-bottom-width: 2px;\n}\n.nav-line-tabs.nav-line-tabs-2x .nav-item .nav-link.active,\n.nav-line-tabs.nav-line-tabs-2x .nav-item.show .nav-link,\n.nav-line-tabs.nav-line-tabs-2x .nav-item .nav-link:hover:not(.disabled) {\n  border-bottom-width: 2px;\n}\n\n.nav.nav-pills.nav-pills-custom .show > .nav-link,\n.nav.nav-pills.nav-pills-custom .nav-link {\n  border: 1px dashed var(--bs-border-dashed-color);\n  border-radius: 0.625rem;\n}\n.nav.nav-pills.nav-pills-custom .show > .nav-link.nav-link-border-solid,\n.nav.nav-pills.nav-pills-custom .nav-link.nav-link-border-solid {\n  border: 3px solid var(--bs-border-dashed-color);\n}\n.nav.nav-pills.nav-pills-custom .show > .nav-link.nav-link-border-solid.active,\n.nav.nav-pills.nav-pills-custom .nav-link.nav-link-border-solid.active {\n  border: 3px solid var(--bs-primary);\n}\n.nav.nav-pills.nav-pills-custom .show > .nav-link .nav-icon img,\n.nav.nav-pills.nav-pills-custom .nav-link .nav-icon img {\n  width: 30px;\n  transition: color 0.2s ease;\n}\n.nav.nav-pills.nav-pills-custom .show > .nav-link .nav-icon img.default,\n.nav.nav-pills.nav-pills-custom .nav-link .nav-icon img.default {\n  display: inline-block;\n}\n.nav.nav-pills.nav-pills-custom .show > .nav-link .nav-icon img.active,\n.nav.nav-pills.nav-pills-custom .nav-link .nav-icon img.active {\n  display: none;\n}\n.nav.nav-pills.nav-pills-custom .show > .nav-link.active,\n.nav.nav-pills.nav-pills-custom .nav-link.active {\n  background-color: transparent;\n  border: 1px solid var(--bs-border-dashed-color);\n  transition-duration: 1ms;\n  position: relative;\n}\n.nav.nav-pills.nav-pills-custom .show > .nav-link.active .nav-text,\n.nav.nav-pills.nav-pills-custom .nav-link.active .nav-text {\n  color: var(--bs-gray-800) !important;\n  transition: color 0.2s ease;\n}\n.nav.nav-pills.nav-pills-custom .show > .nav-link.active .bullet-custom,\n.nav.nav-pills.nav-pills-custom .nav-link.active .bullet-custom {\n  display: block;\n}\n.nav.nav-pills.nav-pills-custom .show > .nav-link .bullet-custom,\n.nav.nav-pills.nav-pills-custom .nav-link .bullet-custom {\n  display: none;\n}\n.nav.nav-pills.nav-pills-custom.nav-pills-active-custom .nav-item .nav-link:not(:active) span:nth-child(1) {\n  color: #B5B5C3;\n}\n.nav.nav-pills.nav-pills-custom.nav-pills-active-custom .nav-item .nav-link:not(:active) span:nth-child(2) {\n  color: #3F4254;\n}\n.nav.nav-pills.nav-pills-custom.nav-pills-active-custom .nav-item .nav-link:hover span:nth-child(1) {\n  color: #ffffff !important;\n}\n.nav.nav-pills.nav-pills-custom.nav-pills-active-custom .nav-item .nav-link:hover span:nth-child(2) {\n  color: #ffffff !important;\n}\n.nav.nav-pills.nav-pills-custom.nav-pills-active-custom .nav-item .nav-link.active span:nth-child(1) {\n  color: #ffffff !important;\n}\n.nav.nav-pills.nav-pills-custom.nav-pills-active-custom .nav-item .nav-link.active span:nth-child(2) {\n  color: #ffffff !important;\n}\n\n.pagination {\n  display: flex;\n  flex-wrap: wrap;\n  justify-content: center;\n  margin: 0;\n}\n.pagination.pagination-circle .page-link {\n  border-radius: 50%;\n}\n.pagination.pagination-outline .page-link {\n  border: 1px solid var(--bs-border-color);\n}\n.pagination.pagination-outline .page-item:hover:not(.disabled) .page-link, .pagination.pagination-outline .page-item.active .page-link {\n  border-color: var(--bs-primary-light);\n}\n\n.page-item {\n  margin-right: 0.5rem;\n  /*rtl:end:ignore*/\n}\n.page-item:last-child {\n  margin-right: 0;\n}\n.page-item .page-link {\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  border-radius: 0.475rem;\n  height: 2.5rem;\n  min-width: 2.5rem;\n  font-weight: 500;\n  font-size: 1.075rem;\n  /*rtl:options:{\"autoRename\":false}*/\n  /*rtl:end:ignore*/\n  /*rtl:options:{\"autoRename\":false}*/\n}\n.page-item .page-link i {\n  font-size: 0.85rem;\n}\n.page-item .page-link .previous,\n.page-item .page-link .next {\n  display: block;\n  height: 0.875rem;\n  width: 0.875rem;\n  /*rtl:raw:transform: rotateZ(-180deg);*/\n}\n.page-item .page-link .previous {\n  mask-repeat: no-repeat;\n  mask-position: center;\n  -webkit-mask-repeat: no-repeat;\n  -webkit-mask-position: center;\n  background-color: var(--bs-gray-700);\n  -webkit-mask-image: url(\"data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 6 6' fill='var%28--bs-gray-700%29'%3e%3cpath d='M2.72011 2.76429L4.46358 1.02083C4.63618 0.848244 4.63617 0.568419 4.46358 0.395831C4.29099 0.223244 4.01118 0.223244 3.83861 0.395831L1.52904 2.70537C1.36629 2.86808 1.36629 3.13191 1.52904 3.29462L3.83861 5.60419C4.01117 5.77675 4.29099 5.77675 4.46358 5.60419C4.63617 5.43156 4.63617 5.15175 4.46358 4.97919L2.72011 3.23571C2.58994 3.10554 2.58994 2.89446 2.72011 2.76429Z'/%3e%3c/svg%3e\");\n  mask-image: url(\"data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 6 6' fill='var%28--bs-gray-700%29'%3e%3cpath d='M2.72011 2.76429L4.46358 1.02083C4.63618 0.848244 4.63617 0.568419 4.46358 0.395831C4.29099 0.223244 4.01118 0.223244 3.83861 0.395831L1.52904 2.70537C1.36629 2.86808 1.36629 3.13191 1.52904 3.29462L3.83861 5.60419C4.01117 5.77675 4.29099 5.77675 4.46358 5.60419C4.63617 5.43156 4.63617 5.15175 4.46358 4.97919L2.72011 3.23571C2.58994 3.10554 2.58994 2.89446 2.72011 2.76429Z'/%3e%3c/svg%3e\");\n}\n.page-item .page-link .next {\n  mask-repeat: no-repeat;\n  mask-position: center;\n  -webkit-mask-repeat: no-repeat;\n  -webkit-mask-position: center;\n  background-color: var(--bs-gray-700);\n  -webkit-mask-image: url(\"data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 6 6' fill='var%28--bs-gray-700%29'%3e%3cpath d='M3.27989 3.23571L1.53642 4.97917C1.36382 5.15176 1.36383 5.43158 1.53642 5.60417C1.70901 5.77676 1.98882 5.77676 2.16139 5.60417L4.47096 3.29463C4.63371 3.13192 4.63371 2.86809 4.47096 2.70538L2.16139 0.395812C1.98883 0.22325 1.70901 0.22325 1.53642 0.395812C1.36383 0.568437 1.36383 0.84825 1.53642 1.02081L3.27989 2.76429C3.41006 2.89446 3.41006 3.10554 3.27989 3.23571Z'/%3e%3c/svg%3e\");\n  mask-image: url(\"data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 6 6' fill='var%28--bs-gray-700%29'%3e%3cpath d='M3.27989 3.23571L1.53642 4.97917C1.36382 5.15176 1.36383 5.43158 1.53642 5.60417C1.70901 5.77676 1.98882 5.77676 2.16139 5.60417L4.47096 3.29463C4.63371 3.13192 4.63371 2.86809 4.47096 2.70538L2.16139 0.395812C1.98883 0.22325 1.70901 0.22325 1.53642 0.395812C1.36383 0.568437 1.36383 0.84825 1.53642 1.02081L3.27989 2.76429C3.41006 2.89446 3.41006 3.10554 3.27989 3.23571Z'/%3e%3c/svg%3e\");\n}\n.page-item:focus .page-link {\n  color: var(--bs-pagination-focus-color);\n  /*rtl:options:{\"autoRename\":false}*/\n}\n.page-item:focus .page-link .svg-icon,\n.page-item:focus .page-link i {\n  color: var(--bs-pagination-focus-color);\n}\n.page-item:focus .page-link .previous {\n  mask-repeat: no-repeat;\n  mask-position: center;\n  -webkit-mask-repeat: no-repeat;\n  -webkit-mask-position: center;\n  background-color: var(--bs-pagination-focus-color);\n  -webkit-mask-image: url(\"data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 6 6' fill='var%28--bs-pagination-focus-color%29'%3e%3cpath d='M2.72011 2.76429L4.46358 1.02083C4.63618 0.848244 4.63617 0.568419 4.46358 0.395831C4.29099 0.223244 4.01118 0.223244 3.83861 0.395831L1.52904 2.70537C1.36629 2.86808 1.36629 3.13191 1.52904 3.29462L3.83861 5.60419C4.01117 5.77675 4.29099 5.77675 4.46358 5.60419C4.63617 5.43156 4.63617 5.15175 4.46358 4.97919L2.72011 3.23571C2.58994 3.10554 2.58994 2.89446 2.72011 2.76429Z'/%3e%3c/svg%3e\");\n  mask-image: url(\"data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 6 6' fill='var%28--bs-pagination-focus-color%29'%3e%3cpath d='M2.72011 2.76429L4.46358 1.02083C4.63618 0.848244 4.63617 0.568419 4.46358 0.395831C4.29099 0.223244 4.01118 0.223244 3.83861 0.395831L1.52904 2.70537C1.36629 2.86808 1.36629 3.13191 1.52904 3.29462L3.83861 5.60419C4.01117 5.77675 4.29099 5.77675 4.46358 5.60419C4.63617 5.43156 4.63617 5.15175 4.46358 4.97919L2.72011 3.23571C2.58994 3.10554 2.58994 2.89446 2.72011 2.76429Z'/%3e%3c/svg%3e\");\n}\n.page-item:focus .page-link .next {\n  mask-repeat: no-repeat;\n  mask-position: center;\n  -webkit-mask-repeat: no-repeat;\n  -webkit-mask-position: center;\n  background-color: var(--bs-pagination-focus-color);\n  -webkit-mask-image: url(\"data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 6 6' fill='var%28--bs-pagination-focus-color%29'%3e%3cpath d='M3.27989 3.23571L1.53642 4.97917C1.36382 5.15176 1.36383 5.43158 1.53642 5.60417C1.70901 5.77676 1.98882 5.77676 2.16139 5.60417L4.47096 3.29463C4.63371 3.13192 4.63371 2.86809 4.47096 2.70538L2.16139 0.395812C1.98883 0.22325 1.70901 0.22325 1.53642 0.395812C1.36383 0.568437 1.36383 0.84825 1.53642 1.02081L3.27989 2.76429C3.41006 2.89446 3.41006 3.10554 3.27989 3.23571Z'/%3e%3c/svg%3e\");\n  mask-image: url(\"data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 6 6' fill='var%28--bs-pagination-focus-color%29'%3e%3cpath d='M3.27989 3.23571L1.53642 4.97917C1.36382 5.15176 1.36383 5.43158 1.53642 5.60417C1.70901 5.77676 1.98882 5.77676 2.16139 5.60417L4.47096 3.29463C4.63371 3.13192 4.63371 2.86809 4.47096 2.70538L2.16139 0.395812C1.98883 0.22325 1.70901 0.22325 1.53642 0.395812C1.36383 0.568437 1.36383 0.84825 1.53642 1.02081L3.27989 2.76429C3.41006 2.89446 3.41006 3.10554 3.27989 3.23571Z'/%3e%3c/svg%3e\");\n}\n.page-item:hover:not(.active):not(.offset):not(.disabled) .page-link {\n  color: var(--bs-pagination-hover-color);\n  /*rtl:options:{\"autoRename\":false}*/\n}\n.page-item:hover:not(.active):not(.offset):not(.disabled) .page-link.page-text {\n  background-color: transparent;\n}\n.page-item:hover:not(.active):not(.offset):not(.disabled) .page-link .svg-icon,\n.page-item:hover:not(.active):not(.offset):not(.disabled) .page-link i {\n  color: var(--bs-pagination-hover-color);\n}\n.page-item:hover:not(.active):not(.offset):not(.disabled) .page-link .previous {\n  mask-repeat: no-repeat;\n  mask-position: center;\n  -webkit-mask-repeat: no-repeat;\n  -webkit-mask-position: center;\n  background-color: var(--bs-pagination-hover-color);\n  -webkit-mask-image: url(\"data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 6 6' fill='var%28--bs-pagination-hover-color%29'%3e%3cpath d='M2.72011 2.76429L4.46358 1.02083C4.63618 0.848244 4.63617 0.568419 4.46358 0.395831C4.29099 0.223244 4.01118 0.223244 3.83861 0.395831L1.52904 2.70537C1.36629 2.86808 1.36629 3.13191 1.52904 3.29462L3.83861 5.60419C4.01117 5.77675 4.29099 5.77675 4.46358 5.60419C4.63617 5.43156 4.63617 5.15175 4.46358 4.97919L2.72011 3.23571C2.58994 3.10554 2.58994 2.89446 2.72011 2.76429Z'/%3e%3c/svg%3e\");\n  mask-image: url(\"data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 6 6' fill='var%28--bs-pagination-hover-color%29'%3e%3cpath d='M2.72011 2.76429L4.46358 1.02083C4.63618 0.848244 4.63617 0.568419 4.46358 0.395831C4.29099 0.223244 4.01118 0.223244 3.83861 0.395831L1.52904 2.70537C1.36629 2.86808 1.36629 3.13191 1.52904 3.29462L3.83861 5.60419C4.01117 5.77675 4.29099 5.77675 4.46358 5.60419C4.63617 5.43156 4.63617 5.15175 4.46358 4.97919L2.72011 3.23571C2.58994 3.10554 2.58994 2.89446 2.72011 2.76429Z'/%3e%3c/svg%3e\");\n}\n.page-item:hover:not(.active):not(.offset):not(.disabled) .page-link .next {\n  mask-repeat: no-repeat;\n  mask-position: center;\n  -webkit-mask-repeat: no-repeat;\n  -webkit-mask-position: center;\n  background-color: var(--bs-pagination-hover-color);\n  -webkit-mask-image: url(\"data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 6 6' fill='var%28--bs-pagination-hover-color%29'%3e%3cpath d='M3.27989 3.23571L1.53642 4.97917C1.36382 5.15176 1.36383 5.43158 1.53642 5.60417C1.70901 5.77676 1.98882 5.77676 2.16139 5.60417L4.47096 3.29463C4.63371 3.13192 4.63371 2.86809 4.47096 2.70538L2.16139 0.395812C1.98883 0.22325 1.70901 0.22325 1.53642 0.395812C1.36383 0.568437 1.36383 0.84825 1.53642 1.02081L3.27989 2.76429C3.41006 2.89446 3.41006 3.10554 3.27989 3.23571Z'/%3e%3c/svg%3e\");\n  mask-image: url(\"data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 6 6' fill='var%28--bs-pagination-hover-color%29'%3e%3cpath d='M3.27989 3.23571L1.53642 4.97917C1.36382 5.15176 1.36383 5.43158 1.53642 5.60417C1.70901 5.77676 1.98882 5.77676 2.16139 5.60417L4.47096 3.29463C4.63371 3.13192 4.63371 2.86809 4.47096 2.70538L2.16139 0.395812C1.98883 0.22325 1.70901 0.22325 1.53642 0.395812C1.36383 0.568437 1.36383 0.84825 1.53642 1.02081L3.27989 2.76429C3.41006 2.89446 3.41006 3.10554 3.27989 3.23571Z'/%3e%3c/svg%3e\");\n}\n.page-item.active .page-link {\n  color: var(--bs-pagination-active-color);\n  /*rtl:options:{\"autoRename\":false}*/\n}\n.page-item.active .page-link.page-text {\n  background-color: transparent;\n}\n.page-item.active .page-link .svg-icon,\n.page-item.active .page-link i {\n  color: var(--bs-pagination-active-color);\n}\n.page-item.active .page-link .previous {\n  mask-repeat: no-repeat;\n  mask-position: center;\n  -webkit-mask-repeat: no-repeat;\n  -webkit-mask-position: center;\n  background-color: var(--bs-pagination-active-color);\n  -webkit-mask-image: url(\"data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 6 6' fill='var%28--bs-pagination-active-color%29'%3e%3cpath d='M2.72011 2.76429L4.46358 1.02083C4.63618 0.848244 4.63617 0.568419 4.46358 0.395831C4.29099 0.223244 4.01118 0.223244 3.83861 0.395831L1.52904 2.70537C1.36629 2.86808 1.36629 3.13191 1.52904 3.29462L3.83861 5.60419C4.01117 5.77675 4.29099 5.77675 4.46358 5.60419C4.63617 5.43156 4.63617 5.15175 4.46358 4.97919L2.72011 3.23571C2.58994 3.10554 2.58994 2.89446 2.72011 2.76429Z'/%3e%3c/svg%3e\");\n  mask-image: url(\"data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 6 6' fill='var%28--bs-pagination-active-color%29'%3e%3cpath d='M2.72011 2.76429L4.46358 1.02083C4.63618 0.848244 4.63617 0.568419 4.46358 0.395831C4.29099 0.223244 4.01118 0.223244 3.83861 0.395831L1.52904 2.70537C1.36629 2.86808 1.36629 3.13191 1.52904 3.29462L3.83861 5.60419C4.01117 5.77675 4.29099 5.77675 4.46358 5.60419C4.63617 5.43156 4.63617 5.15175 4.46358 4.97919L2.72011 3.23571C2.58994 3.10554 2.58994 2.89446 2.72011 2.76429Z'/%3e%3c/svg%3e\");\n}\n.page-item.active .page-link .next {\n  mask-repeat: no-repeat;\n  mask-position: center;\n  -webkit-mask-repeat: no-repeat;\n  -webkit-mask-position: center;\n  background-color: var(--bs-pagination-active-color);\n  -webkit-mask-image: url(\"data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 6 6' fill='var%28--bs-pagination-active-color%29'%3e%3cpath d='M3.27989 3.23571L1.53642 4.97917C1.36382 5.15176 1.36383 5.43158 1.53642 5.60417C1.70901 5.77676 1.98882 5.77676 2.16139 5.60417L4.47096 3.29463C4.63371 3.13192 4.63371 2.86809 4.47096 2.70538L2.16139 0.395812C1.98883 0.22325 1.70901 0.22325 1.53642 0.395812C1.36383 0.568437 1.36383 0.84825 1.53642 1.02081L3.27989 2.76429C3.41006 2.89446 3.41006 3.10554 3.27989 3.23571Z'/%3e%3c/svg%3e\");\n  mask-image: url(\"data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 6 6' fill='var%28--bs-pagination-active-color%29'%3e%3cpath d='M3.27989 3.23571L1.53642 4.97917C1.36382 5.15176 1.36383 5.43158 1.53642 5.60417C1.70901 5.77676 1.98882 5.77676 2.16139 5.60417L4.47096 3.29463C4.63371 3.13192 4.63371 2.86809 4.47096 2.70538L2.16139 0.395812C1.98883 0.22325 1.70901 0.22325 1.53642 0.395812C1.36383 0.568437 1.36383 0.84825 1.53642 1.02081L3.27989 2.76429C3.41006 2.89446 3.41006 3.10554 3.27989 3.23571Z'/%3e%3c/svg%3e\");\n}\n.page-item.disabled .page-link {\n  color: var(--bs-pagination-disabled-color);\n  /*rtl:options:{\"autoRename\":false}*/\n}\n.page-item.disabled .page-link .svg-icon,\n.page-item.disabled .page-link i {\n  color: var(--bs-pagination-disabled-color);\n}\n.page-item.disabled .page-link .previous {\n  mask-repeat: no-repeat;\n  mask-position: center;\n  -webkit-mask-repeat: no-repeat;\n  -webkit-mask-position: center;\n  background-color: var(--bs-pagination-disabled-color);\n  -webkit-mask-image: url(\"data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 6 6' fill='var%28--bs-pagination-disabled-color%29'%3e%3cpath d='M2.72011 2.76429L4.46358 1.02083C4.63618 0.848244 4.63617 0.568419 4.46358 0.395831C4.29099 0.223244 4.01118 0.223244 3.83861 0.395831L1.52904 2.70537C1.36629 2.86808 1.36629 3.13191 1.52904 3.29462L3.83861 5.60419C4.01117 5.77675 4.29099 5.77675 4.46358 5.60419C4.63617 5.43156 4.63617 5.15175 4.46358 4.97919L2.72011 3.23571C2.58994 3.10554 2.58994 2.89446 2.72011 2.76429Z'/%3e%3c/svg%3e\");\n  mask-image: url(\"data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 6 6' fill='var%28--bs-pagination-disabled-color%29'%3e%3cpath d='M2.72011 2.76429L4.46358 1.02083C4.63618 0.848244 4.63617 0.568419 4.46358 0.395831C4.29099 0.223244 4.01118 0.223244 3.83861 0.395831L1.52904 2.70537C1.36629 2.86808 1.36629 3.13191 1.52904 3.29462L3.83861 5.60419C4.01117 5.77675 4.29099 5.77675 4.46358 5.60419C4.63617 5.43156 4.63617 5.15175 4.46358 4.97919L2.72011 3.23571C2.58994 3.10554 2.58994 2.89446 2.72011 2.76429Z'/%3e%3c/svg%3e\");\n}\n.page-item.disabled .page-link .next {\n  mask-repeat: no-repeat;\n  mask-position: center;\n  -webkit-mask-repeat: no-repeat;\n  -webkit-mask-position: center;\n  background-color: var(--bs-pagination-disabled-color);\n  -webkit-mask-image: url(\"data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 6 6' fill='var%28--bs-pagination-disabled-color%29'%3e%3cpath d='M3.27989 3.23571L1.53642 4.97917C1.36382 5.15176 1.36383 5.43158 1.53642 5.60417C1.70901 5.77676 1.98882 5.77676 2.16139 5.60417L4.47096 3.29463C4.63371 3.13192 4.63371 2.86809 4.47096 2.70538L2.16139 0.395812C1.98883 0.22325 1.70901 0.22325 1.53642 0.395812C1.36383 0.568437 1.36383 0.84825 1.53642 1.02081L3.27989 2.76429C3.41006 2.89446 3.41006 3.10554 3.27989 3.23571Z'/%3e%3c/svg%3e\");\n  mask-image: url(\"data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 6 6' fill='var%28--bs-pagination-disabled-color%29'%3e%3cpath d='M3.27989 3.23571L1.53642 4.97917C1.36382 5.15176 1.36383 5.43158 1.53642 5.60417C1.70901 5.77676 1.98882 5.77676 2.16139 5.60417L4.47096 3.29463C4.63371 3.13192 4.63371 2.86809 4.47096 2.70538L2.16139 0.395812C1.98883 0.22325 1.70901 0.22325 1.53642 0.395812C1.36383 0.568437 1.36383 0.84825 1.53642 1.02081L3.27989 2.76429C3.41006 2.89446 3.41006 3.10554 3.27989 3.23571Z'/%3e%3c/svg%3e\");\n}\n\n@media (max-width: 991.98px) {\n  .page-item {\n    margin-right: 0.25rem;\n  }\n  .page-item:last-child {\n    margin-right: 0;\n  }\n}\n.separator {\n  display: block;\n  height: 0;\n  border-bottom: 1px solid var(--bs-border-color);\n}\n.separator.separator-dotted {\n  border-bottom-style: dotted;\n  border-bottom-color: var(--bs-border-dashed-color);\n}\n.separator.separator-dashed {\n  border-bottom-style: dashed;\n  border-bottom-color: var(--bs-border-dashed-color);\n}\n.separator.separator-content {\n  display: flex;\n  align-items: center;\n  border-bottom: 0;\n  text-align: center;\n}\n.separator.separator-content::before, .separator.separator-content::after {\n  content: \" \";\n  width: 50%;\n  border-bottom: 1px solid var(--bs-border-color);\n}\n.separator.separator-content::before {\n  margin-right: 1.25rem;\n}\n.separator.separator-content::after {\n  margin-left: 1.25rem;\n}\n.separator.separator-content.separator-dotted::before, .separator.separator-content.separator-dotted::after {\n  border-bottom-style: dotted;\n  border-bottom-color: var(--bs-border-dashed-color);\n}\n.separator.separator-content.separator-dashed::before, .separator.separator-content.separator-dashed::after {\n  border-bottom-style: dashed;\n  border-bottom-color: var(--bs-border-dashed-color);\n}\n.separator.separator-content.border-light::before, .separator.separator-content.border-light::after {\n  border-color: #F9F9F9 !important;\n}\n.separator.separator-content.border-primary::before, .separator.separator-content.border-primary::after {\n  border-color: #009ef7 !important;\n}\n.separator.separator-content.border-secondary::before, .separator.separator-content.border-secondary::after {\n  border-color: #E1E3EA !important;\n}\n.separator.separator-content.border-success::before, .separator.separator-content.border-success::after {\n  border-color: #50cd89 !important;\n}\n.separator.separator-content.border-info::before, .separator.separator-content.border-info::after {\n  border-color: #7239ea !important;\n}\n.separator.separator-content.border-warning::before, .separator.separator-content.border-warning::after {\n  border-color: #ffc700 !important;\n}\n.separator.separator-content.border-danger::before, .separator.separator-content.border-danger::after {\n  border-color: #f1416c !important;\n}\n.separator.separator-content.border-dark::before, .separator.separator-content.border-dark::after {\n  border-color: #181C32 !important;\n}\n\n.carousel-custom .carousel-indicators {\n  align-items: center;\n  position: static;\n  z-index: auto;\n  margin: 0;\n  padding: 0;\n  list-style: none;\n}\n.carousel-custom .carousel-indicators li {\n  transform: none;\n  opacity: 1;\n}\n.carousel-custom .carousel-indicators li.active {\n  transform: none;\n  opacity: 1;\n}\n.carousel-custom .carousel-indicators.carousel-indicators-dots li {\n  border-radius: 0;\n  background-color: transparent !important;\n  height: 13px;\n  width: 13px;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  text-align: center;\n}\n.carousel-custom .carousel-indicators.carousel-indicators-dots li:after {\n  display: inline-block;\n  content: \" \";\n  border-radius: 50%;\n  transition: all 0.3s ease;\n  background-color: var(--bs-gray-200);\n  height: 9px;\n  width: 9px;\n}\n.carousel-custom .carousel-indicators.carousel-indicators-dots li.active {\n  background-color: transparent;\n}\n.carousel-custom .carousel-indicators.carousel-indicators-dots li.active:after {\n  transition: all 0.3s ease;\n  height: 13px;\n  width: 13px;\n  background-color: var(--bs-gray-400);\n}\n.carousel-custom .carousel-indicators.carousel-indicators-bullet li {\n  transition: all 0.3s ease;\n  background-color: transparent !important;\n  border-radius: 6px;\n  height: 6px;\n  width: 6px;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  text-align: center;\n}\n.carousel-custom .carousel-indicators.carousel-indicators-bullet li:after {\n  display: inline-block;\n  content: \" \";\n  transition: all 0.3s ease;\n  background-color: var(--bs-gray-400);\n  border-radius: 6px;\n  height: 6px;\n  width: 6px;\n}\n.carousel-custom .carousel-indicators.carousel-indicators-bullet li.active {\n  transition: all 0.3s ease;\n  background-color: transparent;\n  height: 6px;\n  width: 16px;\n}\n.carousel-custom .carousel-indicators.carousel-indicators-bullet li.active:after {\n  transition: all 0.3s ease;\n  height: 6px;\n  width: 16px;\n  background-color: var(--bs-gray-600);\n}\n.carousel-custom .carousel-indicators-active-light li.active:after {\n  background-color: var(--bs-light) !important;\n}\n.carousel-custom .carousel-indicators-active-primary li.active:after {\n  background-color: var(--bs-primary) !important;\n}\n.carousel-custom .carousel-indicators-active-secondary li.active:after {\n  background-color: var(--bs-secondary) !important;\n}\n.carousel-custom .carousel-indicators-active-success li.active:after {\n  background-color: var(--bs-success) !important;\n}\n.carousel-custom .carousel-indicators-active-info li.active:after {\n  background-color: var(--bs-info) !important;\n}\n.carousel-custom .carousel-indicators-active-warning li.active:after {\n  background-color: var(--bs-warning) !important;\n}\n.carousel-custom .carousel-indicators-active-danger li.active:after {\n  background-color: var(--bs-danger) !important;\n}\n.carousel-custom .carousel-indicators-active-dark li.active:after {\n  background-color: var(--bs-dark) !important;\n}\n.carousel-custom.carousel-stretch {\n  height: 100%;\n  display: flex;\n  flex-direction: column;\n}\n.carousel-custom.carousel-stretch .carousel-inner {\n  flex-grow: 1;\n}\n.carousel-custom.carousel-stretch .carousel-item {\n  height: 100%;\n}\n.carousel-custom.carousel-stretch .carousel-wrapper {\n  display: flex;\n  flex-direction: column;\n  height: 100%;\n}\n\n.menu-group {\n  display: flex;\n}\n\n.menu,\n.menu-wrapper {\n  display: flex;\n  padding: 0;\n  margin: 0;\n  list-style: none;\n}\n\n.menu-inner {\n  padding: 0;\n  margin: 0;\n  list-style: none;\n}\n\n.menu-sub {\n  display: none;\n  padding: 0;\n  margin: 0;\n  list-style: none;\n  flex-direction: column;\n}\n\n.menu-item {\n  display: block;\n  padding: 0.15rem 0;\n}\n.menu-item .menu-link {\n  cursor: pointer;\n  display: flex;\n  align-items: center;\n  padding: 0;\n  flex: 0 0 100%;\n  padding: 0.65rem 1rem;\n  transition: none;\n  outline: none !important;\n}\n.menu-item .menu-link .menu-icon {\n  flex-shrink: 0;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  width: 2rem;\n  margin-right: 0.5rem;\n}\n.menu-item .menu-link .menu-icon i,\n.menu-item .menu-link .menu-icon .svg-icon {\n  line-height: 1;\n}\n.menu-item .menu-link .menu-bullet {\n  flex-shrink: 0;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  width: 1.25rem;\n  margin-right: 0.5rem;\n}\n.menu-item .menu-link .menu-title {\n  display: flex;\n  align-items: center;\n  flex-grow: 1;\n}\n.menu-item .menu-link .menu-badge {\n  display: flex;\n  align-items: center;\n  flex-shrink: 0;\n  margin-left: 0.5rem;\n}\n.menu-item .menu-link .menu-arrow {\n  display: flex;\n  align-items: stretch;\n  position: relative;\n  overflow: hidden;\n  flex-shrink: 0;\n  margin-left: 5px;\n  width: 9px;\n  height: 9px;\n}\n.menu-item .menu-link .menu-arrow:after {\n  display: block;\n  width: 100%;\n  content: \" \";\n  will-change: transform;\n  background-size: 100% 100%;\n  mask-repeat: no-repeat;\n  mask-position: center;\n  -webkit-mask-repeat: no-repeat;\n  -webkit-mask-position: center;\n  background-color: var(--bs-text-muted);\n  -webkit-mask-image: url(\"data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 6 6' fill='var%28--bs-text-muted%29'%3e%3cpath d='M2.72011 2.76429L4.46358 1.02083C4.63618 0.848244 4.63617 0.568419 4.46358 0.395831C4.29099 0.223244 4.01118 0.223244 3.83861 0.395831L1.52904 2.70537C1.36629 2.86808 1.36629 3.13191 1.52904 3.29462L3.83861 5.60419C4.01117 5.77675 4.29099 5.77675 4.46358 5.60419C4.63617 5.43156 4.63617 5.15175 4.46358 4.97919L2.72011 3.23571C2.58994 3.10554 2.58994 2.89446 2.72011 2.76429Z'/%3e%3c/svg%3e\");\n  mask-image: url(\"data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 6 6' fill='var%28--bs-text-muted%29'%3e%3cpath d='M2.72011 2.76429L4.46358 1.02083C4.63618 0.848244 4.63617 0.568419 4.46358 0.395831C4.29099 0.223244 4.01118 0.223244 3.83861 0.395831L1.52904 2.70537C1.36629 2.86808 1.36629 3.13191 1.52904 3.29462L3.83861 5.60419C4.01117 5.77675 4.29099 5.77675 4.46358 5.60419C4.63617 5.43156 4.63617 5.15175 4.46358 4.97919L2.72011 3.23571C2.58994 3.10554 2.58994 2.89446 2.72011 2.76429Z'/%3e%3c/svg%3e\");\n  /*rtl:begin:remove*/\n  mask-repeat: no-repeat;\n  mask-position: center;\n  -webkit-mask-repeat: no-repeat;\n  -webkit-mask-position: center;\n  background-color: var(--bs-text-muted);\n  -webkit-mask-image: url(\"data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 6 6' fill='var%28--bs-text-muted%29'%3e%3cpath d='M3.27989 3.23571L1.53642 4.97917C1.36382 5.15176 1.36383 5.43158 1.53642 5.60417C1.70901 5.77676 1.98882 5.77676 2.16139 5.60417L4.47096 3.29463C4.63371 3.13192 4.63371 2.86809 4.47096 2.70538L2.16139 0.395812C1.98883 0.22325 1.70901 0.22325 1.53642 0.395812C1.36383 0.568437 1.36383 0.84825 1.53642 1.02081L3.27989 2.76429C3.41006 2.89446 3.41006 3.10554 3.27989 3.23571Z'/%3e%3c/svg%3e\");\n  mask-image: url(\"data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 6 6' fill='var%28--bs-text-muted%29'%3e%3cpath d='M3.27989 3.23571L1.53642 4.97917C1.36382 5.15176 1.36383 5.43158 1.53642 5.60417C1.70901 5.77676 1.98882 5.77676 2.16139 5.60417L4.47096 3.29463C4.63371 3.13192 4.63371 2.86809 4.47096 2.70538L2.16139 0.395812C1.98883 0.22325 1.70901 0.22325 1.53642 0.395812C1.36383 0.568437 1.36383 0.84825 1.53642 1.02081L3.27989 2.76429C3.41006 2.89446 3.41006 3.10554 3.27989 3.23571Z'/%3e%3c/svg%3e\");\n  /*rtl:end:remove*/\n}\n.menu-item .menu-content {\n  padding: 0.65rem 1rem;\n}\n\n.menu-item.show .menu-link .menu-arrow:after {\n  backface-visibility: hidden;\n  transition: transform 0.3s ease;\n}\n\n.menu-center {\n  justify-content: center;\n}\n\n.menu-heading {\n  color: var(--bs-menu-heading-color);\n}\n\n.menu-item.menu-accordion .menu-arrow:after {\n  /*rtl:ignore*/\n  transform: rotateZ(-90deg);\n  /*rtl:remove*/\n  transform: rotateZ(90deg);\n  transition: transform 0.3s ease;\n}\n.menu-item.menu-accordion.showing:not(.menu-dropdown) > .menu-link .menu-arrow:after, .menu-item.menu-accordion.show:not(.hiding):not(.menu-dropdown) > .menu-link .menu-arrow:after {\n  /*rtl:ignore*/\n  transform: rotateZ(90deg);\n  /*rtl:remove*/\n  transform: rotateZ(-90deg);\n  transition: transform 0.3s ease;\n}\n\n.menu-sub-dropdown {\n  display: none;\n  border-radius: 0.475rem;\n  background-color: var(--bs-menu-dropdown-bg-color);\n  box-shadow: var(--bs-menu-dropdown-box-shadow);\n  z-index: 107;\n}\n.show.menu-dropdown > .menu-sub-dropdown, .menu-sub-dropdown.menu.show, .menu-sub-dropdown.show[data-popper-placement] {\n  display: flex;\n  will-change: transform;\n  animation: menu-sub-dropdown-animation-fade-in 0.3s ease 1, menu-sub-dropdown-animation-move-up 0.3s ease 1;\n}\n\n.menu-sub-accordion {\n  display: none;\n}\n.show:not(.menu-dropdown) > .menu-sub-accordion, .menu-sub-accordion.show {\n  display: flex;\n}\n\n.menu-sub-indention .menu-sub:not([data-popper-placement]) {\n  margin-left: 1rem;\n}\n.menu-sub-indention .menu-item .menu-item .menu-link.active {\n  margin-right: 1rem;\n}\n\n.menu-inline {\n  display: flex;\n}\n\n.menu-fit > .menu-item > .menu-content,\n.menu-fit > .menu-item > .menu-link {\n  padding-left: 0 !important;\n  padding-right: 0 !important;\n}\n\n.menu-column {\n  flex-direction: column;\n  width: 100%;\n}\n\n.menu-row {\n  flex-direction: row;\n}\n.menu-row > .menu-item {\n  display: flex;\n  align-items: center;\n}\n.menu-row > .menu-item > .menu-link .menu-arrow:after {\n  /*rtl:ignore*/\n  transform: rotateZ(-90deg);\n  /*rtl:remove*/\n  transform: rotateZ(90deg);\n  transition: transform 0.3s ease;\n}\n\n.menu-rounded .menu-link {\n  border-radius: 0.475rem;\n}\n\n.menu-pill .menu-link {\n  border-radius: 50px;\n}\n\n.menu-rounded-0 .menu-link {\n  border-radius: 0 !important;\n}\n\n@media (min-width: 576px) {\n  .menu-item.menu-sm-accordion .menu-arrow:after {\n    /*rtl:ignore*/\n    transform: rotateZ(-90deg);\n    /*rtl:remove*/\n    transform: rotateZ(90deg);\n    transition: transform 0.3s ease;\n  }\n  .menu-item.menu-sm-accordion.showing:not(.menu-dropdown) > .menu-link .menu-arrow:after, .menu-item.menu-sm-accordion.show:not(.hiding):not(.menu-dropdown) > .menu-link .menu-arrow:after {\n    /*rtl:ignore*/\n    transform: rotateZ(90deg);\n    /*rtl:remove*/\n    transform: rotateZ(-90deg);\n    transition: transform 0.3s ease;\n  }\n  .menu-sub-sm-dropdown {\n    display: none;\n    border-radius: 0.475rem;\n    background-color: var(--bs-menu-dropdown-bg-color);\n    box-shadow: var(--bs-menu-dropdown-box-shadow);\n    z-index: 107;\n  }\n  .show.menu-dropdown > .menu-sub-sm-dropdown, .menu-sub-sm-dropdown.menu.show, .menu-sub-sm-dropdown.show[data-popper-placement] {\n    display: flex;\n    will-change: transform;\n    animation: menu-sub-dropdown-animation-fade-in 0.3s ease 1, menu-sub-dropdown-animation-move-up 0.3s ease 1;\n  }\n  .menu-sub-sm-accordion {\n    display: none;\n  }\n  .show:not(.menu-dropdown) > .menu-sub-sm-accordion, .menu-sub-sm-accordion.show {\n    display: flex;\n  }\n  .menu-sub-sm-indention .menu-sub:not([data-popper-placement]) {\n    margin-left: 1rem;\n  }\n  .menu-sub-sm-indention .menu-item .menu-item .menu-link.active {\n    margin-right: 1rem;\n  }\n  .menu-sm-inline {\n    display: flex;\n  }\n  .menu-sm-fit > .menu-item > .menu-content,\n.menu-sm-fit > .menu-item > .menu-link {\n    padding-left: 0 !important;\n    padding-right: 0 !important;\n  }\n  .menu-sm-column {\n    flex-direction: column;\n    width: 100%;\n  }\n  .menu-sm-row {\n    flex-direction: row;\n  }\n  .menu-sm-row > .menu-item {\n    display: flex;\n    align-items: center;\n  }\n  .menu-sm-row > .menu-item > .menu-link .menu-arrow:after {\n    /*rtl:ignore*/\n    transform: rotateZ(-90deg);\n    /*rtl:remove*/\n    transform: rotateZ(90deg);\n    transition: transform 0.3s ease;\n  }\n  .menu-sm-rounded .menu-link {\n    border-radius: 0.475rem;\n  }\n  .menu-sm-pill .menu-link {\n    border-radius: 50px;\n  }\n  .menu-sm-rounded-0 .menu-link {\n    border-radius: 0 !important;\n  }\n}\n@media (min-width: 768px) {\n  .menu-item.menu-md-accordion .menu-arrow:after {\n    /*rtl:ignore*/\n    transform: rotateZ(-90deg);\n    /*rtl:remove*/\n    transform: rotateZ(90deg);\n    transition: transform 0.3s ease;\n  }\n  .menu-item.menu-md-accordion.showing:not(.menu-dropdown) > .menu-link .menu-arrow:after, .menu-item.menu-md-accordion.show:not(.hiding):not(.menu-dropdown) > .menu-link .menu-arrow:after {\n    /*rtl:ignore*/\n    transform: rotateZ(90deg);\n    /*rtl:remove*/\n    transform: rotateZ(-90deg);\n    transition: transform 0.3s ease;\n  }\n  .menu-sub-md-dropdown {\n    display: none;\n    border-radius: 0.475rem;\n    background-color: var(--bs-menu-dropdown-bg-color);\n    box-shadow: var(--bs-menu-dropdown-box-shadow);\n    z-index: 107;\n  }\n  .show.menu-dropdown > .menu-sub-md-dropdown, .menu-sub-md-dropdown.menu.show, .menu-sub-md-dropdown.show[data-popper-placement] {\n    display: flex;\n    will-change: transform;\n    animation: menu-sub-dropdown-animation-fade-in 0.3s ease 1, menu-sub-dropdown-animation-move-up 0.3s ease 1;\n  }\n  .menu-sub-md-accordion {\n    display: none;\n  }\n  .show:not(.menu-dropdown) > .menu-sub-md-accordion, .menu-sub-md-accordion.show {\n    display: flex;\n  }\n  .menu-sub-md-indention .menu-sub:not([data-popper-placement]) {\n    margin-left: 1rem;\n  }\n  .menu-sub-md-indention .menu-item .menu-item .menu-link.active {\n    margin-right: 1rem;\n  }\n  .menu-md-inline {\n    display: flex;\n  }\n  .menu-md-fit > .menu-item > .menu-content,\n.menu-md-fit > .menu-item > .menu-link {\n    padding-left: 0 !important;\n    padding-right: 0 !important;\n  }\n  .menu-md-column {\n    flex-direction: column;\n    width: 100%;\n  }\n  .menu-md-row {\n    flex-direction: row;\n  }\n  .menu-md-row > .menu-item {\n    display: flex;\n    align-items: center;\n  }\n  .menu-md-row > .menu-item > .menu-link .menu-arrow:after {\n    /*rtl:ignore*/\n    transform: rotateZ(-90deg);\n    /*rtl:remove*/\n    transform: rotateZ(90deg);\n    transition: transform 0.3s ease;\n  }\n  .menu-md-rounded .menu-link {\n    border-radius: 0.475rem;\n  }\n  .menu-md-pill .menu-link {\n    border-radius: 50px;\n  }\n  .menu-md-rounded-0 .menu-link {\n    border-radius: 0 !important;\n  }\n}\n@media (min-width: 992px) {\n  .menu-item.menu-lg-accordion .menu-arrow:after {\n    /*rtl:ignore*/\n    transform: rotateZ(-90deg);\n    /*rtl:remove*/\n    transform: rotateZ(90deg);\n    transition: transform 0.3s ease;\n  }\n  .menu-item.menu-lg-accordion.showing:not(.menu-dropdown) > .menu-link .menu-arrow:after, .menu-item.menu-lg-accordion.show:not(.hiding):not(.menu-dropdown) > .menu-link .menu-arrow:after {\n    /*rtl:ignore*/\n    transform: rotateZ(90deg);\n    /*rtl:remove*/\n    transform: rotateZ(-90deg);\n    transition: transform 0.3s ease;\n  }\n  .menu-sub-lg-dropdown {\n    display: none;\n    border-radius: 0.475rem;\n    background-color: var(--bs-menu-dropdown-bg-color);\n    box-shadow: var(--bs-menu-dropdown-box-shadow);\n    z-index: 107;\n  }\n  .show.menu-dropdown > .menu-sub-lg-dropdown, .menu-sub-lg-dropdown.menu.show, .menu-sub-lg-dropdown.show[data-popper-placement] {\n    display: flex;\n    will-change: transform;\n    animation: menu-sub-dropdown-animation-fade-in 0.3s ease 1, menu-sub-dropdown-animation-move-up 0.3s ease 1;\n  }\n  .menu-sub-lg-accordion {\n    display: none;\n  }\n  .show:not(.menu-dropdown) > .menu-sub-lg-accordion, .menu-sub-lg-accordion.show {\n    display: flex;\n  }\n  .menu-sub-lg-indention .menu-sub:not([data-popper-placement]) {\n    margin-left: 1rem;\n  }\n  .menu-sub-lg-indention .menu-item .menu-item .menu-link.active {\n    margin-right: 1rem;\n  }\n  .menu-lg-inline {\n    display: flex;\n  }\n  .menu-lg-fit > .menu-item > .menu-content,\n.menu-lg-fit > .menu-item > .menu-link {\n    padding-left: 0 !important;\n    padding-right: 0 !important;\n  }\n  .menu-lg-column {\n    flex-direction: column;\n    width: 100%;\n  }\n  .menu-lg-row {\n    flex-direction: row;\n  }\n  .menu-lg-row > .menu-item {\n    display: flex;\n    align-items: center;\n  }\n  .menu-lg-row > .menu-item > .menu-link .menu-arrow:after {\n    /*rtl:ignore*/\n    transform: rotateZ(-90deg);\n    /*rtl:remove*/\n    transform: rotateZ(90deg);\n    transition: transform 0.3s ease;\n  }\n  .menu-lg-rounded .menu-link {\n    border-radius: 0.475rem;\n  }\n  .menu-lg-pill .menu-link {\n    border-radius: 50px;\n  }\n  .menu-lg-rounded-0 .menu-link {\n    border-radius: 0 !important;\n  }\n}\n@media (min-width: 1200px) {\n  .menu-item.menu-xl-accordion .menu-arrow:after {\n    /*rtl:ignore*/\n    transform: rotateZ(-90deg);\n    /*rtl:remove*/\n    transform: rotateZ(90deg);\n    transition: transform 0.3s ease;\n  }\n  .menu-item.menu-xl-accordion.showing:not(.menu-dropdown) > .menu-link .menu-arrow:after, .menu-item.menu-xl-accordion.show:not(.hiding):not(.menu-dropdown) > .menu-link .menu-arrow:after {\n    /*rtl:ignore*/\n    transform: rotateZ(90deg);\n    /*rtl:remove*/\n    transform: rotateZ(-90deg);\n    transition: transform 0.3s ease;\n  }\n  .menu-sub-xl-dropdown {\n    display: none;\n    border-radius: 0.475rem;\n    background-color: var(--bs-menu-dropdown-bg-color);\n    box-shadow: var(--bs-menu-dropdown-box-shadow);\n    z-index: 107;\n  }\n  .show.menu-dropdown > .menu-sub-xl-dropdown, .menu-sub-xl-dropdown.menu.show, .menu-sub-xl-dropdown.show[data-popper-placement] {\n    display: flex;\n    will-change: transform;\n    animation: menu-sub-dropdown-animation-fade-in 0.3s ease 1, menu-sub-dropdown-animation-move-up 0.3s ease 1;\n  }\n  .menu-sub-xl-accordion {\n    display: none;\n  }\n  .show:not(.menu-dropdown) > .menu-sub-xl-accordion, .menu-sub-xl-accordion.show {\n    display: flex;\n  }\n  .menu-sub-xl-indention .menu-sub:not([data-popper-placement]) {\n    margin-left: 1rem;\n  }\n  .menu-sub-xl-indention .menu-item .menu-item .menu-link.active {\n    margin-right: 1rem;\n  }\n  .menu-xl-inline {\n    display: flex;\n  }\n  .menu-xl-fit > .menu-item > .menu-content,\n.menu-xl-fit > .menu-item > .menu-link {\n    padding-left: 0 !important;\n    padding-right: 0 !important;\n  }\n  .menu-xl-column {\n    flex-direction: column;\n    width: 100%;\n  }\n  .menu-xl-row {\n    flex-direction: row;\n  }\n  .menu-xl-row > .menu-item {\n    display: flex;\n    align-items: center;\n  }\n  .menu-xl-row > .menu-item > .menu-link .menu-arrow:after {\n    /*rtl:ignore*/\n    transform: rotateZ(-90deg);\n    /*rtl:remove*/\n    transform: rotateZ(90deg);\n    transition: transform 0.3s ease;\n  }\n  .menu-xl-rounded .menu-link {\n    border-radius: 0.475rem;\n  }\n  .menu-xl-pill .menu-link {\n    border-radius: 50px;\n  }\n  .menu-xl-rounded-0 .menu-link {\n    border-radius: 0 !important;\n  }\n}\n@media (min-width: 1400px) {\n  .menu-item.menu-xxl-accordion .menu-arrow:after {\n    /*rtl:ignore*/\n    transform: rotateZ(-90deg);\n    /*rtl:remove*/\n    transform: rotateZ(90deg);\n    transition: transform 0.3s ease;\n  }\n  .menu-item.menu-xxl-accordion.showing:not(.menu-dropdown) > .menu-link .menu-arrow:after, .menu-item.menu-xxl-accordion.show:not(.hiding):not(.menu-dropdown) > .menu-link .menu-arrow:after {\n    /*rtl:ignore*/\n    transform: rotateZ(90deg);\n    /*rtl:remove*/\n    transform: rotateZ(-90deg);\n    transition: transform 0.3s ease;\n  }\n  .menu-sub-xxl-dropdown {\n    display: none;\n    border-radius: 0.475rem;\n    background-color: var(--bs-menu-dropdown-bg-color);\n    box-shadow: var(--bs-menu-dropdown-box-shadow);\n    z-index: 107;\n  }\n  .show.menu-dropdown > .menu-sub-xxl-dropdown, .menu-sub-xxl-dropdown.menu.show, .menu-sub-xxl-dropdown.show[data-popper-placement] {\n    display: flex;\n    will-change: transform;\n    animation: menu-sub-dropdown-animation-fade-in 0.3s ease 1, menu-sub-dropdown-animation-move-up 0.3s ease 1;\n  }\n  .menu-sub-xxl-accordion {\n    display: none;\n  }\n  .show:not(.menu-dropdown) > .menu-sub-xxl-accordion, .menu-sub-xxl-accordion.show {\n    display: flex;\n  }\n  .menu-sub-xxl-indention .menu-sub:not([data-popper-placement]) {\n    margin-left: 1rem;\n  }\n  .menu-sub-xxl-indention .menu-item .menu-item .menu-link.active {\n    margin-right: 1rem;\n  }\n  .menu-xxl-inline {\n    display: flex;\n  }\n  .menu-xxl-fit > .menu-item > .menu-content,\n.menu-xxl-fit > .menu-item > .menu-link {\n    padding-left: 0 !important;\n    padding-right: 0 !important;\n  }\n  .menu-xxl-column {\n    flex-direction: column;\n    width: 100%;\n  }\n  .menu-xxl-row {\n    flex-direction: row;\n  }\n  .menu-xxl-row > .menu-item {\n    display: flex;\n    align-items: center;\n  }\n  .menu-xxl-row > .menu-item > .menu-link .menu-arrow:after {\n    /*rtl:ignore*/\n    transform: rotateZ(-90deg);\n    /*rtl:remove*/\n    transform: rotateZ(90deg);\n    transition: transform 0.3s ease;\n  }\n  .menu-xxl-rounded .menu-link {\n    border-radius: 0.475rem;\n  }\n  .menu-xxl-pill .menu-link {\n    border-radius: 50px;\n  }\n  .menu-xxl-rounded-0 .menu-link {\n    border-radius: 0 !important;\n  }\n}\n@media (max-width: 575.98px) {\n  .menu-item.menu-sm-down-accordion .menu-arrow:after {\n    /*rtl:ignore*/\n    transform: rotateZ(-90deg);\n    /*rtl:remove*/\n    transform: rotateZ(90deg);\n    transition: transform 0.3s ease;\n  }\n  .menu-item.menu-sm-down-accordion.showing:not(.menu-dropdown) > .menu-link .menu-arrow:after, .menu-item.menu-sm-down-accordion.show:not(.hiding):not(.menu-dropdown) > .menu-link .menu-arrow:after {\n    /*rtl:ignore*/\n    transform: rotateZ(90deg);\n    /*rtl:remove*/\n    transform: rotateZ(-90deg);\n    transition: transform 0.3s ease;\n  }\n  .menu-sub-sm-down-dropdown {\n    display: none;\n    border-radius: 0.475rem;\n    background-color: var(--bs-menu-dropdown-bg-color);\n    box-shadow: var(--bs-menu-dropdown-box-shadow);\n    z-index: 107;\n  }\n  .show.menu-dropdown > .menu-sub-sm-down-dropdown, .menu-sub-sm-down-dropdown.menu.show, .menu-sub-sm-down-dropdown.show[data-popper-placement] {\n    display: flex;\n    will-change: transform;\n    animation: menu-sub-dropdown-animation-fade-in 0.3s ease 1, menu-sub-dropdown-animation-move-up 0.3s ease 1;\n  }\n  .menu-sub-sm-down-accordion {\n    display: none;\n  }\n  .show:not(.menu-dropdown) > .menu-sub-sm-down-accordion, .menu-sub-sm-down-accordion.show {\n    display: flex;\n  }\n  .menu-sub-sm-down-indention .menu-sub:not([data-popper-placement]) {\n    margin-left: 1rem;\n  }\n  .menu-sub-sm-down-indention .menu-item .menu-item .menu-link.active {\n    margin-right: 1rem;\n  }\n  .menu-sm-down-inline {\n    display: flex;\n  }\n  .menu-sm-down-fit > .menu-item > .menu-content,\n.menu-sm-down-fit > .menu-item > .menu-link {\n    padding-left: 0 !important;\n    padding-right: 0 !important;\n  }\n  .menu-sm-down-column {\n    flex-direction: column;\n    width: 100%;\n  }\n  .menu-sm-down-row {\n    flex-direction: row;\n  }\n  .menu-sm-down-row > .menu-item {\n    display: flex;\n    align-items: center;\n  }\n  .menu-sm-down-row > .menu-item > .menu-link .menu-arrow:after {\n    /*rtl:ignore*/\n    transform: rotateZ(-90deg);\n    /*rtl:remove*/\n    transform: rotateZ(90deg);\n    transition: transform 0.3s ease;\n  }\n  .menu-sm-down-rounded .menu-link {\n    border-radius: 0.475rem;\n  }\n  .menu-sm-down-pill .menu-link {\n    border-radius: 50px;\n  }\n  .menu-sm-down-rounded-0 .menu-link {\n    border-radius: 0 !important;\n  }\n}\n@media (max-width: 767.98px) {\n  .menu-item.menu-md-down-accordion .menu-arrow:after {\n    /*rtl:ignore*/\n    transform: rotateZ(-90deg);\n    /*rtl:remove*/\n    transform: rotateZ(90deg);\n    transition: transform 0.3s ease;\n  }\n  .menu-item.menu-md-down-accordion.showing:not(.menu-dropdown) > .menu-link .menu-arrow:after, .menu-item.menu-md-down-accordion.show:not(.hiding):not(.menu-dropdown) > .menu-link .menu-arrow:after {\n    /*rtl:ignore*/\n    transform: rotateZ(90deg);\n    /*rtl:remove*/\n    transform: rotateZ(-90deg);\n    transition: transform 0.3s ease;\n  }\n  .menu-sub-md-down-dropdown {\n    display: none;\n    border-radius: 0.475rem;\n    background-color: var(--bs-menu-dropdown-bg-color);\n    box-shadow: var(--bs-menu-dropdown-box-shadow);\n    z-index: 107;\n  }\n  .show.menu-dropdown > .menu-sub-md-down-dropdown, .menu-sub-md-down-dropdown.menu.show, .menu-sub-md-down-dropdown.show[data-popper-placement] {\n    display: flex;\n    will-change: transform;\n    animation: menu-sub-dropdown-animation-fade-in 0.3s ease 1, menu-sub-dropdown-animation-move-up 0.3s ease 1;\n  }\n  .menu-sub-md-down-accordion {\n    display: none;\n  }\n  .show:not(.menu-dropdown) > .menu-sub-md-down-accordion, .menu-sub-md-down-accordion.show {\n    display: flex;\n  }\n  .menu-sub-md-down-indention .menu-sub:not([data-popper-placement]) {\n    margin-left: 1rem;\n  }\n  .menu-sub-md-down-indention .menu-item .menu-item .menu-link.active {\n    margin-right: 1rem;\n  }\n  .menu-md-down-inline {\n    display: flex;\n  }\n  .menu-md-down-fit > .menu-item > .menu-content,\n.menu-md-down-fit > .menu-item > .menu-link {\n    padding-left: 0 !important;\n    padding-right: 0 !important;\n  }\n  .menu-md-down-column {\n    flex-direction: column;\n    width: 100%;\n  }\n  .menu-md-down-row {\n    flex-direction: row;\n  }\n  .menu-md-down-row > .menu-item {\n    display: flex;\n    align-items: center;\n  }\n  .menu-md-down-row > .menu-item > .menu-link .menu-arrow:after {\n    /*rtl:ignore*/\n    transform: rotateZ(-90deg);\n    /*rtl:remove*/\n    transform: rotateZ(90deg);\n    transition: transform 0.3s ease;\n  }\n  .menu-md-down-rounded .menu-link {\n    border-radius: 0.475rem;\n  }\n  .menu-md-down-pill .menu-link {\n    border-radius: 50px;\n  }\n  .menu-md-down-rounded-0 .menu-link {\n    border-radius: 0 !important;\n  }\n}\n@media (max-width: 991.98px) {\n  .menu-item.menu-lg-down-accordion .menu-arrow:after {\n    /*rtl:ignore*/\n    transform: rotateZ(-90deg);\n    /*rtl:remove*/\n    transform: rotateZ(90deg);\n    transition: transform 0.3s ease;\n  }\n  .menu-item.menu-lg-down-accordion.showing:not(.menu-dropdown) > .menu-link .menu-arrow:after, .menu-item.menu-lg-down-accordion.show:not(.hiding):not(.menu-dropdown) > .menu-link .menu-arrow:after {\n    /*rtl:ignore*/\n    transform: rotateZ(90deg);\n    /*rtl:remove*/\n    transform: rotateZ(-90deg);\n    transition: transform 0.3s ease;\n  }\n  .menu-sub-lg-down-dropdown {\n    display: none;\n    border-radius: 0.475rem;\n    background-color: var(--bs-menu-dropdown-bg-color);\n    box-shadow: var(--bs-menu-dropdown-box-shadow);\n    z-index: 107;\n  }\n  .show.menu-dropdown > .menu-sub-lg-down-dropdown, .menu-sub-lg-down-dropdown.menu.show, .menu-sub-lg-down-dropdown.show[data-popper-placement] {\n    display: flex;\n    will-change: transform;\n    animation: menu-sub-dropdown-animation-fade-in 0.3s ease 1, menu-sub-dropdown-animation-move-up 0.3s ease 1;\n  }\n  .menu-sub-lg-down-accordion {\n    display: none;\n  }\n  .show:not(.menu-dropdown) > .menu-sub-lg-down-accordion, .menu-sub-lg-down-accordion.show {\n    display: flex;\n  }\n  .menu-sub-lg-down-indention .menu-sub:not([data-popper-placement]) {\n    margin-left: 1rem;\n  }\n  .menu-sub-lg-down-indention .menu-item .menu-item .menu-link.active {\n    margin-right: 1rem;\n  }\n  .menu-lg-down-inline {\n    display: flex;\n  }\n  .menu-lg-down-fit > .menu-item > .menu-content,\n.menu-lg-down-fit > .menu-item > .menu-link {\n    padding-left: 0 !important;\n    padding-right: 0 !important;\n  }\n  .menu-lg-down-column {\n    flex-direction: column;\n    width: 100%;\n  }\n  .menu-lg-down-row {\n    flex-direction: row;\n  }\n  .menu-lg-down-row > .menu-item {\n    display: flex;\n    align-items: center;\n  }\n  .menu-lg-down-row > .menu-item > .menu-link .menu-arrow:after {\n    /*rtl:ignore*/\n    transform: rotateZ(-90deg);\n    /*rtl:remove*/\n    transform: rotateZ(90deg);\n    transition: transform 0.3s ease;\n  }\n  .menu-lg-down-rounded .menu-link {\n    border-radius: 0.475rem;\n  }\n  .menu-lg-down-pill .menu-link {\n    border-radius: 50px;\n  }\n  .menu-lg-down-rounded-0 .menu-link {\n    border-radius: 0 !important;\n  }\n}\n@media (max-width: 1199.98px) {\n  .menu-item.menu-xl-down-accordion .menu-arrow:after {\n    /*rtl:ignore*/\n    transform: rotateZ(-90deg);\n    /*rtl:remove*/\n    transform: rotateZ(90deg);\n    transition: transform 0.3s ease;\n  }\n  .menu-item.menu-xl-down-accordion.showing:not(.menu-dropdown) > .menu-link .menu-arrow:after, .menu-item.menu-xl-down-accordion.show:not(.hiding):not(.menu-dropdown) > .menu-link .menu-arrow:after {\n    /*rtl:ignore*/\n    transform: rotateZ(90deg);\n    /*rtl:remove*/\n    transform: rotateZ(-90deg);\n    transition: transform 0.3s ease;\n  }\n  .menu-sub-xl-down-dropdown {\n    display: none;\n    border-radius: 0.475rem;\n    background-color: var(--bs-menu-dropdown-bg-color);\n    box-shadow: var(--bs-menu-dropdown-box-shadow);\n    z-index: 107;\n  }\n  .show.menu-dropdown > .menu-sub-xl-down-dropdown, .menu-sub-xl-down-dropdown.menu.show, .menu-sub-xl-down-dropdown.show[data-popper-placement] {\n    display: flex;\n    will-change: transform;\n    animation: menu-sub-dropdown-animation-fade-in 0.3s ease 1, menu-sub-dropdown-animation-move-up 0.3s ease 1;\n  }\n  .menu-sub-xl-down-accordion {\n    display: none;\n  }\n  .show:not(.menu-dropdown) > .menu-sub-xl-down-accordion, .menu-sub-xl-down-accordion.show {\n    display: flex;\n  }\n  .menu-sub-xl-down-indention .menu-sub:not([data-popper-placement]) {\n    margin-left: 1rem;\n  }\n  .menu-sub-xl-down-indention .menu-item .menu-item .menu-link.active {\n    margin-right: 1rem;\n  }\n  .menu-xl-down-inline {\n    display: flex;\n  }\n  .menu-xl-down-fit > .menu-item > .menu-content,\n.menu-xl-down-fit > .menu-item > .menu-link {\n    padding-left: 0 !important;\n    padding-right: 0 !important;\n  }\n  .menu-xl-down-column {\n    flex-direction: column;\n    width: 100%;\n  }\n  .menu-xl-down-row {\n    flex-direction: row;\n  }\n  .menu-xl-down-row > .menu-item {\n    display: flex;\n    align-items: center;\n  }\n  .menu-xl-down-row > .menu-item > .menu-link .menu-arrow:after {\n    /*rtl:ignore*/\n    transform: rotateZ(-90deg);\n    /*rtl:remove*/\n    transform: rotateZ(90deg);\n    transition: transform 0.3s ease;\n  }\n  .menu-xl-down-rounded .menu-link {\n    border-radius: 0.475rem;\n  }\n  .menu-xl-down-pill .menu-link {\n    border-radius: 50px;\n  }\n  .menu-xl-down-rounded-0 .menu-link {\n    border-radius: 0 !important;\n  }\n}\n@media (max-width: 1399.98px) {\n  .menu-item.menu-xxl-down-accordion .menu-arrow:after {\n    /*rtl:ignore*/\n    transform: rotateZ(-90deg);\n    /*rtl:remove*/\n    transform: rotateZ(90deg);\n    transition: transform 0.3s ease;\n  }\n  .menu-item.menu-xxl-down-accordion.showing:not(.menu-dropdown) > .menu-link .menu-arrow:after, .menu-item.menu-xxl-down-accordion.show:not(.hiding):not(.menu-dropdown) > .menu-link .menu-arrow:after {\n    /*rtl:ignore*/\n    transform: rotateZ(90deg);\n    /*rtl:remove*/\n    transform: rotateZ(-90deg);\n    transition: transform 0.3s ease;\n  }\n  .menu-sub-xxl-down-dropdown {\n    display: none;\n    border-radius: 0.475rem;\n    background-color: var(--bs-menu-dropdown-bg-color);\n    box-shadow: var(--bs-menu-dropdown-box-shadow);\n    z-index: 107;\n  }\n  .show.menu-dropdown > .menu-sub-xxl-down-dropdown, .menu-sub-xxl-down-dropdown.menu.show, .menu-sub-xxl-down-dropdown.show[data-popper-placement] {\n    display: flex;\n    will-change: transform;\n    animation: menu-sub-dropdown-animation-fade-in 0.3s ease 1, menu-sub-dropdown-animation-move-up 0.3s ease 1;\n  }\n  .menu-sub-xxl-down-accordion {\n    display: none;\n  }\n  .show:not(.menu-dropdown) > .menu-sub-xxl-down-accordion, .menu-sub-xxl-down-accordion.show {\n    display: flex;\n  }\n  .menu-sub-xxl-down-indention .menu-sub:not([data-popper-placement]) {\n    margin-left: 1rem;\n  }\n  .menu-sub-xxl-down-indention .menu-item .menu-item .menu-link.active {\n    margin-right: 1rem;\n  }\n  .menu-xxl-down-inline {\n    display: flex;\n  }\n  .menu-xxl-down-fit > .menu-item > .menu-content,\n.menu-xxl-down-fit > .menu-item > .menu-link {\n    padding-left: 0 !important;\n    padding-right: 0 !important;\n  }\n  .menu-xxl-down-column {\n    flex-direction: column;\n    width: 100%;\n  }\n  .menu-xxl-down-row {\n    flex-direction: row;\n  }\n  .menu-xxl-down-row > .menu-item {\n    display: flex;\n    align-items: center;\n  }\n  .menu-xxl-down-row > .menu-item > .menu-link .menu-arrow:after {\n    /*rtl:ignore*/\n    transform: rotateZ(-90deg);\n    /*rtl:remove*/\n    transform: rotateZ(90deg);\n    transition: transform 0.3s ease;\n  }\n  .menu-xxl-down-rounded .menu-link {\n    border-radius: 0.475rem;\n  }\n  .menu-xxl-down-pill .menu-link {\n    border-radius: 50px;\n  }\n  .menu-xxl-down-rounded-0 .menu-link {\n    border-radius: 0 !important;\n  }\n}\n.menu-link-indention .menu-item {\n  padding-top: 0;\n  padding-bottom: 0;\n}\n.menu-link-indention .menu-sub:not([data-popper-placement]) > .menu-item > .menu-content,\n.menu-link-indention .menu-sub:not([data-popper-placement]) > .menu-item > .menu-link,\n.menu-link-indention .menu-sub:not([data-popper-placement]) > .menu-inner > .menu-item > .menu-content,\n.menu-link-indention .menu-sub:not([data-popper-placement]) > .menu-inner > .menu-item > .menu-link {\n  padding-left: calc(1rem + 1rem);\n}\n.menu-link-indention .menu-sub:not([data-popper-placement]) > .menu-item > .menu-sub:not([data-popper-placement]) > .menu-item > .menu-content,\n.menu-link-indention .menu-sub:not([data-popper-placement]) > .menu-item > .menu-sub:not([data-popper-placement]) > .menu-item > .menu-link,\n.menu-link-indention .menu-sub:not([data-popper-placement]) > .menu-item > .menu-sub:not([data-popper-placement]) > .menu-inner > .menu-item > .menu-content,\n.menu-link-indention .menu-sub:not([data-popper-placement]) > .menu-item > .menu-sub:not([data-popper-placement]) > .menu-inner > .menu-item > .menu-link,\n.menu-link-indention .menu-sub:not([data-popper-placement]) > .menu-inner > .menu-item > .menu-sub:not([data-popper-placement]) > .menu-item > .menu-content,\n.menu-link-indention .menu-sub:not([data-popper-placement]) > .menu-inner > .menu-item > .menu-sub:not([data-popper-placement]) > .menu-item > .menu-link,\n.menu-link-indention .menu-sub:not([data-popper-placement]) > .menu-inner > .menu-item > .menu-sub:not([data-popper-placement]) > .menu-inner > .menu-item > .menu-content,\n.menu-link-indention .menu-sub:not([data-popper-placement]) > .menu-inner > .menu-item > .menu-sub:not([data-popper-placement]) > .menu-inner > .menu-item > .menu-link {\n  padding-left: calc(2rem + 1rem);\n}\n.menu-link-indention .menu-sub:not([data-popper-placement]) > .menu-item > .menu-sub:not([data-popper-placement]) > .menu-item > .menu-sub:not([data-popper-placement]) > .menu-item > .menu-content,\n.menu-link-indention .menu-sub:not([data-popper-placement]) > .menu-item > .menu-sub:not([data-popper-placement]) > .menu-item > .menu-sub:not([data-popper-placement]) > .menu-item > .menu-link,\n.menu-link-indention .menu-sub:not([data-popper-placement]) > .menu-item > .menu-sub:not([data-popper-placement]) > .menu-item > .menu-sub:not([data-popper-placement]) > .menu-inner > .menu-item > .menu-content,\n.menu-link-indention .menu-sub:not([data-popper-placement]) > .menu-item > .menu-sub:not([data-popper-placement]) > .menu-item > .menu-sub:not([data-popper-placement]) > .menu-inner > .menu-item > .menu-link,\n.menu-link-indention .menu-sub:not([data-popper-placement]) > .menu-item > .menu-sub:not([data-popper-placement]) > .menu-inner > .menu-item > .menu-sub:not([data-popper-placement]) > .menu-item > .menu-content,\n.menu-link-indention .menu-sub:not([data-popper-placement]) > .menu-item > .menu-sub:not([data-popper-placement]) > .menu-inner > .menu-item > .menu-sub:not([data-popper-placement]) > .menu-item > .menu-link,\n.menu-link-indention .menu-sub:not([data-popper-placement]) > .menu-item > .menu-sub:not([data-popper-placement]) > .menu-inner > .menu-item > .menu-sub:not([data-popper-placement]) > .menu-inner > .menu-item > .menu-content,\n.menu-link-indention .menu-sub:not([data-popper-placement]) > .menu-item > .menu-sub:not([data-popper-placement]) > .menu-inner > .menu-item > .menu-sub:not([data-popper-placement]) > .menu-inner > .menu-item > .menu-link,\n.menu-link-indention .menu-sub:not([data-popper-placement]) > .menu-inner > .menu-item > .menu-sub:not([data-popper-placement]) > .menu-item > .menu-sub:not([data-popper-placement]) > .menu-item > .menu-content,\n.menu-link-indention .menu-sub:not([data-popper-placement]) > .menu-inner > .menu-item > .menu-sub:not([data-popper-placement]) > .menu-item > .menu-sub:not([data-popper-placement]) > .menu-item > .menu-link,\n.menu-link-indention .menu-sub:not([data-popper-placement]) > .menu-inner > .menu-item > .menu-sub:not([data-popper-placement]) > .menu-item > .menu-sub:not([data-popper-placement]) > .menu-inner > .menu-item > .menu-content,\n.menu-link-indention .menu-sub:not([data-popper-placement]) > .menu-inner > .menu-item > .menu-sub:not([data-popper-placement]) > .menu-item > .menu-sub:not([data-popper-placement]) > .menu-inner > .menu-item > .menu-link,\n.menu-link-indention .menu-sub:not([data-popper-placement]) > .menu-inner > .menu-item > .menu-sub:not([data-popper-placement]) > .menu-inner > .menu-item > .menu-sub:not([data-popper-placement]) > .menu-item > .menu-content,\n.menu-link-indention .menu-sub:not([data-popper-placement]) > .menu-inner > .menu-item > .menu-sub:not([data-popper-placement]) > .menu-inner > .menu-item > .menu-sub:not([data-popper-placement]) > .menu-item > .menu-link,\n.menu-link-indention .menu-sub:not([data-popper-placement]) > .menu-inner > .menu-item > .menu-sub:not([data-popper-placement]) > .menu-inner > .menu-item > .menu-sub:not([data-popper-placement]) > .menu-inner > .menu-item > .menu-content,\n.menu-link-indention .menu-sub:not([data-popper-placement]) > .menu-inner > .menu-item > .menu-sub:not([data-popper-placement]) > .menu-inner > .menu-item > .menu-sub:not([data-popper-placement]) > .menu-inner > .menu-item > .menu-link {\n  padding-left: calc(3rem + 1rem);\n}\n.menu-link-indention .menu-sub:not([data-popper-placement]) > .menu-item > .menu-sub:not([data-popper-placement]) > .menu-item > .menu-sub:not([data-popper-placement]) > .menu-item > .menu-sub:not([data-popper-placement]) > .menu-item > .menu-content,\n.menu-link-indention .menu-sub:not([data-popper-placement]) > .menu-item > .menu-sub:not([data-popper-placement]) > .menu-item > .menu-sub:not([data-popper-placement]) > .menu-item > .menu-sub:not([data-popper-placement]) > .menu-item > .menu-link,\n.menu-link-indention .menu-sub:not([data-popper-placement]) > .menu-item > .menu-sub:not([data-popper-placement]) > .menu-item > .menu-sub:not([data-popper-placement]) > .menu-item > .menu-sub:not([data-popper-placement]) > .menu-inner > .menu-item > .menu-content,\n.menu-link-indention .menu-sub:not([data-popper-placement]) > .menu-item > .menu-sub:not([data-popper-placement]) > .menu-item > .menu-sub:not([data-popper-placement]) > .menu-item > .menu-sub:not([data-popper-placement]) > .menu-inner > .menu-item > .menu-link,\n.menu-link-indention .menu-sub:not([data-popper-placement]) > .menu-item > .menu-sub:not([data-popper-placement]) > .menu-item > .menu-sub:not([data-popper-placement]) > .menu-inner > .menu-item > .menu-sub:not([data-popper-placement]) > .menu-item > .menu-content,\n.menu-link-indention .menu-sub:not([data-popper-placement]) > .menu-item > .menu-sub:not([data-popper-placement]) > .menu-item > .menu-sub:not([data-popper-placement]) > .menu-inner > .menu-item > .menu-sub:not([data-popper-placement]) > .menu-item > .menu-link,\n.menu-link-indention .menu-sub:not([data-popper-placement]) > .menu-item > .menu-sub:not([data-popper-placement]) > .menu-item > .menu-sub:not([data-popper-placement]) > .menu-inner > .menu-item > .menu-sub:not([data-popper-placement]) > .menu-inner > .menu-item > .menu-content,\n.menu-link-indention .menu-sub:not([data-popper-placement]) > .menu-item > .menu-sub:not([data-popper-placement]) > .menu-item > .menu-sub:not([data-popper-placement]) > .menu-inner > .menu-item > .menu-sub:not([data-popper-placement]) > .menu-inner > .menu-item > .menu-link,\n.menu-link-indention .menu-sub:not([data-popper-placement]) > .menu-item > .menu-sub:not([data-popper-placement]) > .menu-inner > .menu-item > .menu-sub:not([data-popper-placement]) > .menu-item > .menu-sub:not([data-popper-placement]) > .menu-item > .menu-content,\n.menu-link-indention .menu-sub:not([data-popper-placement]) > .menu-item > .menu-sub:not([data-popper-placement]) > .menu-inner > .menu-item > .menu-sub:not([data-popper-placement]) > .menu-item > .menu-sub:not([data-popper-placement]) > .menu-item > .menu-link,\n.menu-link-indention .menu-sub:not([data-popper-placement]) > .menu-item > .menu-sub:not([data-popper-placement]) > .menu-inner > .menu-item > .menu-sub:not([data-popper-placement]) > .menu-item > .menu-sub:not([data-popper-placement]) > .menu-inner > .menu-item > .menu-content,\n.menu-link-indention .menu-sub:not([data-popper-placement]) > .menu-item > .menu-sub:not([data-popper-placement]) > .menu-inner > .menu-item > .menu-sub:not([data-popper-placement]) > .menu-item > .menu-sub:not([data-popper-placement]) > .menu-inner > .menu-item > .menu-link,\n.menu-link-indention .menu-sub:not([data-popper-placement]) > .menu-item > .menu-sub:not([data-popper-placement]) > .menu-inner > .menu-item > .menu-sub:not([data-popper-placement]) > .menu-inner > .menu-item > .menu-sub:not([data-popper-placement]) > .menu-item > .menu-content,\n.menu-link-indention .menu-sub:not([data-popper-placement]) > .menu-item > .menu-sub:not([data-popper-placement]) > .menu-inner > .menu-item > .menu-sub:not([data-popper-placement]) > .menu-inner > .menu-item > .menu-sub:not([data-popper-placement]) > .menu-item > .menu-link,\n.menu-link-indention .menu-sub:not([data-popper-placement]) > .menu-item > .menu-sub:not([data-popper-placement]) > .menu-inner > .menu-item > .menu-sub:not([data-popper-placement]) > .menu-inner > .menu-item > .menu-sub:not([data-popper-placement]) > .menu-inner > .menu-item > .menu-content,\n.menu-link-indention .menu-sub:not([data-popper-placement]) > .menu-item > .menu-sub:not([data-popper-placement]) > .menu-inner > .menu-item > .menu-sub:not([data-popper-placement]) > .menu-inner > .menu-item > .menu-sub:not([data-popper-placement]) > .menu-inner > .menu-item > .menu-link,\n.menu-link-indention .menu-sub:not([data-popper-placement]) > .menu-inner > .menu-item > .menu-sub:not([data-popper-placement]) > .menu-item > .menu-sub:not([data-popper-placement]) > .menu-item > .menu-sub:not([data-popper-placement]) > .menu-item > .menu-content,\n.menu-link-indention .menu-sub:not([data-popper-placement]) > .menu-inner > .menu-item > .menu-sub:not([data-popper-placement]) > .menu-item > .menu-sub:not([data-popper-placement]) > .menu-item > .menu-sub:not([data-popper-placement]) > .menu-item > .menu-link,\n.menu-link-indention .menu-sub:not([data-popper-placement]) > .menu-inner > .menu-item > .menu-sub:not([data-popper-placement]) > .menu-item > .menu-sub:not([data-popper-placement]) > .menu-item > .menu-sub:not([data-popper-placement]) > .menu-inner > .menu-item > .menu-content,\n.menu-link-indention .menu-sub:not([data-popper-placement]) > .menu-inner > .menu-item > .menu-sub:not([data-popper-placement]) > .menu-item > .menu-sub:not([data-popper-placement]) > .menu-item > .menu-sub:not([data-popper-placement]) > .menu-inner > .menu-item > .menu-link,\n.menu-link-indention .menu-sub:not([data-popper-placement]) > .menu-inner > .menu-item > .menu-sub:not([data-popper-placement]) > .menu-item > .menu-sub:not([data-popper-placement]) > .menu-inner > .menu-item > .menu-sub:not([data-popper-placement]) > .menu-item > .menu-content,\n.menu-link-indention .menu-sub:not([data-popper-placement]) > .menu-inner > .menu-item > .menu-sub:not([data-popper-placement]) > .menu-item > .menu-sub:not([data-popper-placement]) > .menu-inner > .menu-item > .menu-sub:not([data-popper-placement]) > .menu-item > .menu-link,\n.menu-link-indention .menu-sub:not([data-popper-placement]) > .menu-inner > .menu-item > .menu-sub:not([data-popper-placement]) > .menu-item > .menu-sub:not([data-popper-placement]) > .menu-inner > .menu-item > .menu-sub:not([data-popper-placement]) > .menu-inner > .menu-item > .menu-content,\n.menu-link-indention .menu-sub:not([data-popper-placement]) > .menu-inner > .menu-item > .menu-sub:not([data-popper-placement]) > .menu-item > .menu-sub:not([data-popper-placement]) > .menu-inner > .menu-item > .menu-sub:not([data-popper-placement]) > .menu-inner > .menu-item > .menu-link,\n.menu-link-indention .menu-sub:not([data-popper-placement]) > .menu-inner > .menu-item > .menu-sub:not([data-popper-placement]) > .menu-inner > .menu-item > .menu-sub:not([data-popper-placement]) > .menu-item > .menu-sub:not([data-popper-placement]) > .menu-item > .menu-content,\n.menu-link-indention .menu-sub:not([data-popper-placement]) > .menu-inner > .menu-item > .menu-sub:not([data-popper-placement]) > .menu-inner > .menu-item > .menu-sub:not([data-popper-placement]) > .menu-item > .menu-sub:not([data-popper-placement]) > .menu-item > .menu-link,\n.menu-link-indention .menu-sub:not([data-popper-placement]) > .menu-inner > .menu-item > .menu-sub:not([data-popper-placement]) > .menu-inner > .menu-item > .menu-sub:not([data-popper-placement]) > .menu-item > .menu-sub:not([data-popper-placement]) > .menu-inner > .menu-item > .menu-content,\n.menu-link-indention .menu-sub:not([data-popper-placement]) > .menu-inner > .menu-item > .menu-sub:not([data-popper-placement]) > .menu-inner > .menu-item > .menu-sub:not([data-popper-placement]) > .menu-item > .menu-sub:not([data-popper-placement]) > .menu-inner > .menu-item > .menu-link,\n.menu-link-indention .menu-sub:not([data-popper-placement]) > .menu-inner > .menu-item > .menu-sub:not([data-popper-placement]) > .menu-inner > .menu-item > .menu-sub:not([data-popper-placement]) > .menu-inner > .menu-item > .menu-sub:not([data-popper-placement]) > .menu-item > .menu-content,\n.menu-link-indention .menu-sub:not([data-popper-placement]) > .menu-inner > .menu-item > .menu-sub:not([data-popper-placement]) > .menu-inner > .menu-item > .menu-sub:not([data-popper-placement]) > .menu-inner > .menu-item > .menu-sub:not([data-popper-placement]) > .menu-item > .menu-link,\n.menu-link-indention .menu-sub:not([data-popper-placement]) > .menu-inner > .menu-item > .menu-sub:not([data-popper-placement]) > .menu-inner > .menu-item > .menu-sub:not([data-popper-placement]) > .menu-inner > .menu-item > .menu-sub:not([data-popper-placement]) > .menu-inner > .menu-item > .menu-content,\n.menu-link-indention .menu-sub:not([data-popper-placement]) > .menu-inner > .menu-item > .menu-sub:not([data-popper-placement]) > .menu-inner > .menu-item > .menu-sub:not([data-popper-placement]) > .menu-inner > .menu-item > .menu-sub:not([data-popper-placement]) > .menu-inner > .menu-item > .menu-link {\n  padding-left: calc(4rem + 1rem);\n}\n.menu-link-indention.menu-fit .menu-sub:not([data-popper-placement]) > .menu-item > .menu-content,\n.menu-link-indention.menu-fit .menu-sub:not([data-popper-placement]) > .menu-item > .menu-link,\n.menu-link-indention.menu-fit .menu-sub:not([data-popper-placement]) > .menu-inner > .menu-item > .menu-content,\n.menu-link-indention.menu-fit .menu-sub:not([data-popper-placement]) > .menu-inner > .menu-item > .menu-link {\n  padding-left: 1rem;\n  padding-right: 0;\n}\n.menu-link-indention.menu-fit .menu-sub:not([data-popper-placement]) > .menu-item > .menu-sub:not([data-popper-placement]) > .menu-item > .menu-content,\n.menu-link-indention.menu-fit .menu-sub:not([data-popper-placement]) > .menu-item > .menu-sub:not([data-popper-placement]) > .menu-item > .menu-link,\n.menu-link-indention.menu-fit .menu-sub:not([data-popper-placement]) > .menu-item > .menu-sub:not([data-popper-placement]) > .menu-inner > .menu-item > .menu-content,\n.menu-link-indention.menu-fit .menu-sub:not([data-popper-placement]) > .menu-item > .menu-sub:not([data-popper-placement]) > .menu-inner > .menu-item > .menu-link,\n.menu-link-indention.menu-fit .menu-sub:not([data-popper-placement]) > .menu-inner > .menu-item > .menu-sub:not([data-popper-placement]) > .menu-item > .menu-content,\n.menu-link-indention.menu-fit .menu-sub:not([data-popper-placement]) > .menu-inner > .menu-item > .menu-sub:not([data-popper-placement]) > .menu-item > .menu-link,\n.menu-link-indention.menu-fit .menu-sub:not([data-popper-placement]) > .menu-inner > .menu-item > .menu-sub:not([data-popper-placement]) > .menu-inner > .menu-item > .menu-content,\n.menu-link-indention.menu-fit .menu-sub:not([data-popper-placement]) > .menu-inner > .menu-item > .menu-sub:not([data-popper-placement]) > .menu-inner > .menu-item > .menu-link {\n  padding-left: calc(2rem);\n  padding-right: 0;\n}\n.menu-link-indention.menu-fit .menu-sub:not([data-popper-placement]) > .menu-item > .menu-sub:not([data-popper-placement]) > .menu-item > .menu-sub:not([data-popper-placement]) > .menu-item > .menu-content,\n.menu-link-indention.menu-fit .menu-sub:not([data-popper-placement]) > .menu-item > .menu-sub:not([data-popper-placement]) > .menu-item > .menu-sub:not([data-popper-placement]) > .menu-item > .menu-link,\n.menu-link-indention.menu-fit .menu-sub:not([data-popper-placement]) > .menu-item > .menu-sub:not([data-popper-placement]) > .menu-item > .menu-sub:not([data-popper-placement]) > .menu-inner > .menu-item > .menu-content,\n.menu-link-indention.menu-fit .menu-sub:not([data-popper-placement]) > .menu-item > .menu-sub:not([data-popper-placement]) > .menu-item > .menu-sub:not([data-popper-placement]) > .menu-inner > .menu-item > .menu-link,\n.menu-link-indention.menu-fit .menu-sub:not([data-popper-placement]) > .menu-item > .menu-sub:not([data-popper-placement]) > .menu-inner > .menu-item > .menu-sub:not([data-popper-placement]) > .menu-item > .menu-content,\n.menu-link-indention.menu-fit .menu-sub:not([data-popper-placement]) > .menu-item > .menu-sub:not([data-popper-placement]) > .menu-inner > .menu-item > .menu-sub:not([data-popper-placement]) > .menu-item > .menu-link,\n.menu-link-indention.menu-fit .menu-sub:not([data-popper-placement]) > .menu-item > .menu-sub:not([data-popper-placement]) > .menu-inner > .menu-item > .menu-sub:not([data-popper-placement]) > .menu-inner > .menu-item > .menu-content,\n.menu-link-indention.menu-fit .menu-sub:not([data-popper-placement]) > .menu-item > .menu-sub:not([data-popper-placement]) > .menu-inner > .menu-item > .menu-sub:not([data-popper-placement]) > .menu-inner > .menu-item > .menu-link,\n.menu-link-indention.menu-fit .menu-sub:not([data-popper-placement]) > .menu-inner > .menu-item > .menu-sub:not([data-popper-placement]) > .menu-item > .menu-sub:not([data-popper-placement]) > .menu-item > .menu-content,\n.menu-link-indention.menu-fit .menu-sub:not([data-popper-placement]) > .menu-inner > .menu-item > .menu-sub:not([data-popper-placement]) > .menu-item > .menu-sub:not([data-popper-placement]) > .menu-item > .menu-link,\n.menu-link-indention.menu-fit .menu-sub:not([data-popper-placement]) > .menu-inner > .menu-item > .menu-sub:not([data-popper-placement]) > .menu-item > .menu-sub:not([data-popper-placement]) > .menu-inner > .menu-item > .menu-content,\n.menu-link-indention.menu-fit .menu-sub:not([data-popper-placement]) > .menu-inner > .menu-item > .menu-sub:not([data-popper-placement]) > .menu-item > .menu-sub:not([data-popper-placement]) > .menu-inner > .menu-item > .menu-link,\n.menu-link-indention.menu-fit .menu-sub:not([data-popper-placement]) > .menu-inner > .menu-item > .menu-sub:not([data-popper-placement]) > .menu-inner > .menu-item > .menu-sub:not([data-popper-placement]) > .menu-item > .menu-content,\n.menu-link-indention.menu-fit .menu-sub:not([data-popper-placement]) > .menu-inner > .menu-item > .menu-sub:not([data-popper-placement]) > .menu-inner > .menu-item > .menu-sub:not([data-popper-placement]) > .menu-item > .menu-link,\n.menu-link-indention.menu-fit .menu-sub:not([data-popper-placement]) > .menu-inner > .menu-item > .menu-sub:not([data-popper-placement]) > .menu-inner > .menu-item > .menu-sub:not([data-popper-placement]) > .menu-inner > .menu-item > .menu-content,\n.menu-link-indention.menu-fit .menu-sub:not([data-popper-placement]) > .menu-inner > .menu-item > .menu-sub:not([data-popper-placement]) > .menu-inner > .menu-item > .menu-sub:not([data-popper-placement]) > .menu-inner > .menu-item > .menu-link {\n  padding-left: calc(3rem);\n  padding-right: 0;\n}\n.menu-link-indention.menu-fit .menu-sub:not([data-popper-placement]) > .menu-item > .menu-sub:not([data-popper-placement]) > .menu-item > .menu-sub:not([data-popper-placement]) > .menu-item > .menu-sub:not([data-popper-placement]) > .menu-item > .menu-content,\n.menu-link-indention.menu-fit .menu-sub:not([data-popper-placement]) > .menu-item > .menu-sub:not([data-popper-placement]) > .menu-item > .menu-sub:not([data-popper-placement]) > .menu-item > .menu-sub:not([data-popper-placement]) > .menu-item > .menu-link,\n.menu-link-indention.menu-fit .menu-sub:not([data-popper-placement]) > .menu-item > .menu-sub:not([data-popper-placement]) > .menu-item > .menu-sub:not([data-popper-placement]) > .menu-item > .menu-sub:not([data-popper-placement]) > .menu-inner > .menu-item > .menu-content,\n.menu-link-indention.menu-fit .menu-sub:not([data-popper-placement]) > .menu-item > .menu-sub:not([data-popper-placement]) > .menu-item > .menu-sub:not([data-popper-placement]) > .menu-item > .menu-sub:not([data-popper-placement]) > .menu-inner > .menu-item > .menu-link,\n.menu-link-indention.menu-fit .menu-sub:not([data-popper-placement]) > .menu-item > .menu-sub:not([data-popper-placement]) > .menu-item > .menu-sub:not([data-popper-placement]) > .menu-inner > .menu-item > .menu-sub:not([data-popper-placement]) > .menu-item > .menu-content,\n.menu-link-indention.menu-fit .menu-sub:not([data-popper-placement]) > .menu-item > .menu-sub:not([data-popper-placement]) > .menu-item > .menu-sub:not([data-popper-placement]) > .menu-inner > .menu-item > .menu-sub:not([data-popper-placement]) > .menu-item > .menu-link,\n.menu-link-indention.menu-fit .menu-sub:not([data-popper-placement]) > .menu-item > .menu-sub:not([data-popper-placement]) > .menu-item > .menu-sub:not([data-popper-placement]) > .menu-inner > .menu-item > .menu-sub:not([data-popper-placement]) > .menu-inner > .menu-item > .menu-content,\n.menu-link-indention.menu-fit .menu-sub:not([data-popper-placement]) > .menu-item > .menu-sub:not([data-popper-placement]) > .menu-item > .menu-sub:not([data-popper-placement]) > .menu-inner > .menu-item > .menu-sub:not([data-popper-placement]) > .menu-inner > .menu-item > .menu-link,\n.menu-link-indention.menu-fit .menu-sub:not([data-popper-placement]) > .menu-item > .menu-sub:not([data-popper-placement]) > .menu-inner > .menu-item > .menu-sub:not([data-popper-placement]) > .menu-item > .menu-sub:not([data-popper-placement]) > .menu-item > .menu-content,\n.menu-link-indention.menu-fit .menu-sub:not([data-popper-placement]) > .menu-item > .menu-sub:not([data-popper-placement]) > .menu-inner > .menu-item > .menu-sub:not([data-popper-placement]) > .menu-item > .menu-sub:not([data-popper-placement]) > .menu-item > .menu-link,\n.menu-link-indention.menu-fit .menu-sub:not([data-popper-placement]) > .menu-item > .menu-sub:not([data-popper-placement]) > .menu-inner > .menu-item > .menu-sub:not([data-popper-placement]) > .menu-item > .menu-sub:not([data-popper-placement]) > .menu-inner > .menu-item > .menu-content,\n.menu-link-indention.menu-fit .menu-sub:not([data-popper-placement]) > .menu-item > .menu-sub:not([data-popper-placement]) > .menu-inner > .menu-item > .menu-sub:not([data-popper-placement]) > .menu-item > .menu-sub:not([data-popper-placement]) > .menu-inner > .menu-item > .menu-link,\n.menu-link-indention.menu-fit .menu-sub:not([data-popper-placement]) > .menu-item > .menu-sub:not([data-popper-placement]) > .menu-inner > .menu-item > .menu-sub:not([data-popper-placement]) > .menu-inner > .menu-item > .menu-sub:not([data-popper-placement]) > .menu-item > .menu-content,\n.menu-link-indention.menu-fit .menu-sub:not([data-popper-placement]) > .menu-item > .menu-sub:not([data-popper-placement]) > .menu-inner > .menu-item > .menu-sub:not([data-popper-placement]) > .menu-inner > .menu-item > .menu-sub:not([data-popper-placement]) > .menu-item > .menu-link,\n.menu-link-indention.menu-fit .menu-sub:not([data-popper-placement]) > .menu-item > .menu-sub:not([data-popper-placement]) > .menu-inner > .menu-item > .menu-sub:not([data-popper-placement]) > .menu-inner > .menu-item > .menu-sub:not([data-popper-placement]) > .menu-inner > .menu-item > .menu-content,\n.menu-link-indention.menu-fit .menu-sub:not([data-popper-placement]) > .menu-item > .menu-sub:not([data-popper-placement]) > .menu-inner > .menu-item > .menu-sub:not([data-popper-placement]) > .menu-inner > .menu-item > .menu-sub:not([data-popper-placement]) > .menu-inner > .menu-item > .menu-link,\n.menu-link-indention.menu-fit .menu-sub:not([data-popper-placement]) > .menu-inner > .menu-item > .menu-sub:not([data-popper-placement]) > .menu-item > .menu-sub:not([data-popper-placement]) > .menu-item > .menu-sub:not([data-popper-placement]) > .menu-item > .menu-content,\n.menu-link-indention.menu-fit .menu-sub:not([data-popper-placement]) > .menu-inner > .menu-item > .menu-sub:not([data-popper-placement]) > .menu-item > .menu-sub:not([data-popper-placement]) > .menu-item > .menu-sub:not([data-popper-placement]) > .menu-item > .menu-link,\n.menu-link-indention.menu-fit .menu-sub:not([data-popper-placement]) > .menu-inner > .menu-item > .menu-sub:not([data-popper-placement]) > .menu-item > .menu-sub:not([data-popper-placement]) > .menu-item > .menu-sub:not([data-popper-placement]) > .menu-inner > .menu-item > .menu-content,\n.menu-link-indention.menu-fit .menu-sub:not([data-popper-placement]) > .menu-inner > .menu-item > .menu-sub:not([data-popper-placement]) > .menu-item > .menu-sub:not([data-popper-placement]) > .menu-item > .menu-sub:not([data-popper-placement]) > .menu-inner > .menu-item > .menu-link,\n.menu-link-indention.menu-fit .menu-sub:not([data-popper-placement]) > .menu-inner > .menu-item > .menu-sub:not([data-popper-placement]) > .menu-item > .menu-sub:not([data-popper-placement]) > .menu-inner > .menu-item > .menu-sub:not([data-popper-placement]) > .menu-item > .menu-content,\n.menu-link-indention.menu-fit .menu-sub:not([data-popper-placement]) > .menu-inner > .menu-item > .menu-sub:not([data-popper-placement]) > .menu-item > .menu-sub:not([data-popper-placement]) > .menu-inner > .menu-item > .menu-sub:not([data-popper-placement]) > .menu-item > .menu-link,\n.menu-link-indention.menu-fit .menu-sub:not([data-popper-placement]) > .menu-inner > .menu-item > .menu-sub:not([data-popper-placement]) > .menu-item > .menu-sub:not([data-popper-placement]) > .menu-inner > .menu-item > .menu-sub:not([data-popper-placement]) > .menu-inner > .menu-item > .menu-content,\n.menu-link-indention.menu-fit .menu-sub:not([data-popper-placement]) > .menu-inner > .menu-item > .menu-sub:not([data-popper-placement]) > .menu-item > .menu-sub:not([data-popper-placement]) > .menu-inner > .menu-item > .menu-sub:not([data-popper-placement]) > .menu-inner > .menu-item > .menu-link,\n.menu-link-indention.menu-fit .menu-sub:not([data-popper-placement]) > .menu-inner > .menu-item > .menu-sub:not([data-popper-placement]) > .menu-inner > .menu-item > .menu-sub:not([data-popper-placement]) > .menu-item > .menu-sub:not([data-popper-placement]) > .menu-item > .menu-content,\n.menu-link-indention.menu-fit .menu-sub:not([data-popper-placement]) > .menu-inner > .menu-item > .menu-sub:not([data-popper-placement]) > .menu-inner > .menu-item > .menu-sub:not([data-popper-placement]) > .menu-item > .menu-sub:not([data-popper-placement]) > .menu-item > .menu-link,\n.menu-link-indention.menu-fit .menu-sub:not([data-popper-placement]) > .menu-inner > .menu-item > .menu-sub:not([data-popper-placement]) > .menu-inner > .menu-item > .menu-sub:not([data-popper-placement]) > .menu-item > .menu-sub:not([data-popper-placement]) > .menu-inner > .menu-item > .menu-content,\n.menu-link-indention.menu-fit .menu-sub:not([data-popper-placement]) > .menu-inner > .menu-item > .menu-sub:not([data-popper-placement]) > .menu-inner > .menu-item > .menu-sub:not([data-popper-placement]) > .menu-item > .menu-sub:not([data-popper-placement]) > .menu-inner > .menu-item > .menu-link,\n.menu-link-indention.menu-fit .menu-sub:not([data-popper-placement]) > .menu-inner > .menu-item > .menu-sub:not([data-popper-placement]) > .menu-inner > .menu-item > .menu-sub:not([data-popper-placement]) > .menu-inner > .menu-item > .menu-sub:not([data-popper-placement]) > .menu-item > .menu-content,\n.menu-link-indention.menu-fit .menu-sub:not([data-popper-placement]) > .menu-inner > .menu-item > .menu-sub:not([data-popper-placement]) > .menu-inner > .menu-item > .menu-sub:not([data-popper-placement]) > .menu-inner > .menu-item > .menu-sub:not([data-popper-placement]) > .menu-item > .menu-link,\n.menu-link-indention.menu-fit .menu-sub:not([data-popper-placement]) > .menu-inner > .menu-item > .menu-sub:not([data-popper-placement]) > .menu-inner > .menu-item > .menu-sub:not([data-popper-placement]) > .menu-inner > .menu-item > .menu-sub:not([data-popper-placement]) > .menu-inner > .menu-item > .menu-content,\n.menu-link-indention.menu-fit .menu-sub:not([data-popper-placement]) > .menu-inner > .menu-item > .menu-sub:not([data-popper-placement]) > .menu-inner > .menu-item > .menu-sub:not([data-popper-placement]) > .menu-inner > .menu-item > .menu-sub:not([data-popper-placement]) > .menu-inner > .menu-item > .menu-link {\n  padding-left: calc(4rem);\n  padding-right: 0;\n}\n\n@keyframes menu-sub-dropdown-animation-fade-in {\n  from {\n    opacity: 0;\n  }\n  to {\n    opacity: 1;\n  }\n}\n@keyframes menu-sub-dropdown-animation-move-up {\n  from {\n    margin-top: 0.75rem;\n  }\n  to {\n    margin-top: 0;\n  }\n}\n@keyframes menu-sub-dropdown-animation-move-down {\n  from {\n    margin-bottom: 0.75rem;\n  }\n  to {\n    margin-bottom: 0;\n  }\n}\n.menu-white .menu-item .menu-link {\n  color: var(--bs-white);\n}\n.menu-white .menu-item .menu-link .menu-title {\n  color: var(--bs-white);\n}\n.menu-white .menu-item .menu-link .menu-icon,\n.menu-white .menu-item .menu-link .menu-icon .svg-icon,\n.menu-white .menu-item .menu-link .menu-icon i {\n  color: var(--bs-white);\n}\n.menu-white .menu-item .menu-link .menu-bullet .bullet {\n  background-color: var(--bs-white);\n}\n.menu-white .menu-item .menu-link .menu-arrow:after {\n  mask-repeat: no-repeat;\n  mask-position: center;\n  -webkit-mask-repeat: no-repeat;\n  -webkit-mask-position: center;\n  background-color: var(--bs-white);\n  -webkit-mask-image: url(\"data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 6 6' fill='var%28--bs-white%29'%3e%3cpath d='M2.72011 2.76429L4.46358 1.02083C4.63618 0.848244 4.63617 0.568419 4.46358 0.395831C4.29099 0.223244 4.01118 0.223244 3.83861 0.395831L1.52904 2.70537C1.36629 2.86808 1.36629 3.13191 1.52904 3.29462L3.83861 5.60419C4.01117 5.77675 4.29099 5.77675 4.46358 5.60419C4.63617 5.43156 4.63617 5.15175 4.46358 4.97919L2.72011 3.23571C2.58994 3.10554 2.58994 2.89446 2.72011 2.76429Z'/%3e%3c/svg%3e\");\n  mask-image: url(\"data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 6 6' fill='var%28--bs-white%29'%3e%3cpath d='M2.72011 2.76429L4.46358 1.02083C4.63618 0.848244 4.63617 0.568419 4.46358 0.395831C4.29099 0.223244 4.01118 0.223244 3.83861 0.395831L1.52904 2.70537C1.36629 2.86808 1.36629 3.13191 1.52904 3.29462L3.83861 5.60419C4.01117 5.77675 4.29099 5.77675 4.46358 5.60419C4.63617 5.43156 4.63617 5.15175 4.46358 4.97919L2.72011 3.23571C2.58994 3.10554 2.58994 2.89446 2.72011 2.76429Z'/%3e%3c/svg%3e\");\n  /*rtl:begin:remove*/\n  mask-repeat: no-repeat;\n  mask-position: center;\n  -webkit-mask-repeat: no-repeat;\n  -webkit-mask-position: center;\n  background-color: var(--bs-white);\n  -webkit-mask-image: url(\"data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 6 6' fill='var%28--bs-white%29'%3e%3cpath d='M3.27989 3.23571L1.53642 4.97917C1.36382 5.15176 1.36383 5.43158 1.53642 5.60417C1.70901 5.77676 1.98882 5.77676 2.16139 5.60417L4.47096 3.29463C4.63371 3.13192 4.63371 2.86809 4.47096 2.70538L2.16139 0.395812C1.98883 0.22325 1.70901 0.22325 1.53642 0.395812C1.36383 0.568437 1.36383 0.84825 1.53642 1.02081L3.27989 2.76429C3.41006 2.89446 3.41006 3.10554 3.27989 3.23571Z'/%3e%3c/svg%3e\");\n  mask-image: url(\"data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 6 6' fill='var%28--bs-white%29'%3e%3cpath d='M3.27989 3.23571L1.53642 4.97917C1.36382 5.15176 1.36383 5.43158 1.53642 5.60417C1.70901 5.77676 1.98882 5.77676 2.16139 5.60417L4.47096 3.29463C4.63371 3.13192 4.63371 2.86809 4.47096 2.70538L2.16139 0.395812C1.98883 0.22325 1.70901 0.22325 1.53642 0.395812C1.36383 0.568437 1.36383 0.84825 1.53642 1.02081L3.27989 2.76429C3.41006 2.89446 3.41006 3.10554 3.27989 3.23571Z'/%3e%3c/svg%3e\");\n  /*rtl:end:remove*/\n}\n\n.menu-title-white .menu-item .menu-link {\n  color: var(--bs-text-white);\n}\n.menu-title-white .menu-item .menu-link .menu-title {\n  color: var(--bs-text-white);\n}\n\n.menu-icon-white .menu-item .menu-link .menu-icon,\n.menu-icon-white .menu-item .menu-link .menu-icon .svg-icon,\n.menu-icon-white .menu-item .menu-link .menu-icon i {\n  color: var(--bs-text-white);\n}\n\n.menu-bullet-white .menu-item .menu-link .menu-bullet .bullet {\n  background-color: var(--bs-text-white);\n}\n\n.menu-arrow-white .menu-item .menu-link .menu-arrow:after {\n  mask-repeat: no-repeat;\n  mask-position: center;\n  -webkit-mask-repeat: no-repeat;\n  -webkit-mask-position: center;\n  background-color: var(--bs-text-white);\n  -webkit-mask-image: url(\"data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 6 6' fill='var%28--bs-text-white%29'%3e%3cpath d='M2.72011 2.76429L4.46358 1.02083C4.63618 0.848244 4.63617 0.568419 4.46358 0.395831C4.29099 0.223244 4.01118 0.223244 3.83861 0.395831L1.52904 2.70537C1.36629 2.86808 1.36629 3.13191 1.52904 3.29462L3.83861 5.60419C4.01117 5.77675 4.29099 5.77675 4.46358 5.60419C4.63617 5.43156 4.63617 5.15175 4.46358 4.97919L2.72011 3.23571C2.58994 3.10554 2.58994 2.89446 2.72011 2.76429Z'/%3e%3c/svg%3e\");\n  mask-image: url(\"data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 6 6' fill='var%28--bs-text-white%29'%3e%3cpath d='M2.72011 2.76429L4.46358 1.02083C4.63618 0.848244 4.63617 0.568419 4.46358 0.395831C4.29099 0.223244 4.01118 0.223244 3.83861 0.395831L1.52904 2.70537C1.36629 2.86808 1.36629 3.13191 1.52904 3.29462L3.83861 5.60419C4.01117 5.77675 4.29099 5.77675 4.46358 5.60419C4.63617 5.43156 4.63617 5.15175 4.46358 4.97919L2.72011 3.23571C2.58994 3.10554 2.58994 2.89446 2.72011 2.76429Z'/%3e%3c/svg%3e\");\n  /*rtl:begin:remove*/\n  mask-repeat: no-repeat;\n  mask-position: center;\n  -webkit-mask-repeat: no-repeat;\n  -webkit-mask-position: center;\n  background-color: var(--bs-text-white);\n  -webkit-mask-image: url(\"data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 6 6' fill='var%28--bs-text-white%29'%3e%3cpath d='M3.27989 3.23571L1.53642 4.97917C1.36382 5.15176 1.36383 5.43158 1.53642 5.60417C1.70901 5.77676 1.98882 5.77676 2.16139 5.60417L4.47096 3.29463C4.63371 3.13192 4.63371 2.86809 4.47096 2.70538L2.16139 0.395812C1.98883 0.22325 1.70901 0.22325 1.53642 0.395812C1.36383 0.568437 1.36383 0.84825 1.53642 1.02081L3.27989 2.76429C3.41006 2.89446 3.41006 3.10554 3.27989 3.23571Z'/%3e%3c/svg%3e\");\n  mask-image: url(\"data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 6 6' fill='var%28--bs-text-white%29'%3e%3cpath d='M3.27989 3.23571L1.53642 4.97917C1.36382 5.15176 1.36383 5.43158 1.53642 5.60417C1.70901 5.77676 1.98882 5.77676 2.16139 5.60417L4.47096 3.29463C4.63371 3.13192 4.63371 2.86809 4.47096 2.70538L2.16139 0.395812C1.98883 0.22325 1.70901 0.22325 1.53642 0.395812C1.36383 0.568437 1.36383 0.84825 1.53642 1.02081L3.27989 2.76429C3.41006 2.89446 3.41006 3.10554 3.27989 3.23571Z'/%3e%3c/svg%3e\");\n  /*rtl:end:remove*/\n}\n\n.menu-primary .menu-item .menu-link {\n  color: var(--bs-primary);\n}\n.menu-primary .menu-item .menu-link .menu-title {\n  color: var(--bs-primary);\n}\n.menu-primary .menu-item .menu-link .menu-icon,\n.menu-primary .menu-item .menu-link .menu-icon .svg-icon,\n.menu-primary .menu-item .menu-link .menu-icon i {\n  color: var(--bs-primary);\n}\n.menu-primary .menu-item .menu-link .menu-bullet .bullet {\n  background-color: var(--bs-primary);\n}\n.menu-primary .menu-item .menu-link .menu-arrow:after {\n  mask-repeat: no-repeat;\n  mask-position: center;\n  -webkit-mask-repeat: no-repeat;\n  -webkit-mask-position: center;\n  background-color: var(--bs-primary);\n  -webkit-mask-image: url(\"data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 6 6' fill='var%28--bs-primary%29'%3e%3cpath d='M2.72011 2.76429L4.46358 1.02083C4.63618 0.848244 4.63617 0.568419 4.46358 0.395831C4.29099 0.223244 4.01118 0.223244 3.83861 0.395831L1.52904 2.70537C1.36629 2.86808 1.36629 3.13191 1.52904 3.29462L3.83861 5.60419C4.01117 5.77675 4.29099 5.77675 4.46358 5.60419C4.63617 5.43156 4.63617 5.15175 4.46358 4.97919L2.72011 3.23571C2.58994 3.10554 2.58994 2.89446 2.72011 2.76429Z'/%3e%3c/svg%3e\");\n  mask-image: url(\"data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 6 6' fill='var%28--bs-primary%29'%3e%3cpath d='M2.72011 2.76429L4.46358 1.02083C4.63618 0.848244 4.63617 0.568419 4.46358 0.395831C4.29099 0.223244 4.01118 0.223244 3.83861 0.395831L1.52904 2.70537C1.36629 2.86808 1.36629 3.13191 1.52904 3.29462L3.83861 5.60419C4.01117 5.77675 4.29099 5.77675 4.46358 5.60419C4.63617 5.43156 4.63617 5.15175 4.46358 4.97919L2.72011 3.23571C2.58994 3.10554 2.58994 2.89446 2.72011 2.76429Z'/%3e%3c/svg%3e\");\n  /*rtl:begin:remove*/\n  mask-repeat: no-repeat;\n  mask-position: center;\n  -webkit-mask-repeat: no-repeat;\n  -webkit-mask-position: center;\n  background-color: var(--bs-primary);\n  -webkit-mask-image: url(\"data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 6 6' fill='var%28--bs-primary%29'%3e%3cpath d='M3.27989 3.23571L1.53642 4.97917C1.36382 5.15176 1.36383 5.43158 1.53642 5.60417C1.70901 5.77676 1.98882 5.77676 2.16139 5.60417L4.47096 3.29463C4.63371 3.13192 4.63371 2.86809 4.47096 2.70538L2.16139 0.395812C1.98883 0.22325 1.70901 0.22325 1.53642 0.395812C1.36383 0.568437 1.36383 0.84825 1.53642 1.02081L3.27989 2.76429C3.41006 2.89446 3.41006 3.10554 3.27989 3.23571Z'/%3e%3c/svg%3e\");\n  mask-image: url(\"data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 6 6' fill='var%28--bs-primary%29'%3e%3cpath d='M3.27989 3.23571L1.53642 4.97917C1.36382 5.15176 1.36383 5.43158 1.53642 5.60417C1.70901 5.77676 1.98882 5.77676 2.16139 5.60417L4.47096 3.29463C4.63371 3.13192 4.63371 2.86809 4.47096 2.70538L2.16139 0.395812C1.98883 0.22325 1.70901 0.22325 1.53642 0.395812C1.36383 0.568437 1.36383 0.84825 1.53642 1.02081L3.27989 2.76429C3.41006 2.89446 3.41006 3.10554 3.27989 3.23571Z'/%3e%3c/svg%3e\");\n  /*rtl:end:remove*/\n}\n\n.menu-title-primary .menu-item .menu-link {\n  color: var(--bs-text-primary);\n}\n.menu-title-primary .menu-item .menu-link .menu-title {\n  color: var(--bs-text-primary);\n}\n\n.menu-icon-primary .menu-item .menu-link .menu-icon,\n.menu-icon-primary .menu-item .menu-link .menu-icon .svg-icon,\n.menu-icon-primary .menu-item .menu-link .menu-icon i {\n  color: var(--bs-text-primary);\n}\n\n.menu-bullet-primary .menu-item .menu-link .menu-bullet .bullet {\n  background-color: var(--bs-text-primary);\n}\n\n.menu-arrow-primary .menu-item .menu-link .menu-arrow:after {\n  mask-repeat: no-repeat;\n  mask-position: center;\n  -webkit-mask-repeat: no-repeat;\n  -webkit-mask-position: center;\n  background-color: var(--bs-text-primary);\n  -webkit-mask-image: url(\"data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 6 6' fill='var%28--bs-text-primary%29'%3e%3cpath d='M2.72011 2.76429L4.46358 1.02083C4.63618 0.848244 4.63617 0.568419 4.46358 0.395831C4.29099 0.223244 4.01118 0.223244 3.83861 0.395831L1.52904 2.70537C1.36629 2.86808 1.36629 3.13191 1.52904 3.29462L3.83861 5.60419C4.01117 5.77675 4.29099 5.77675 4.46358 5.60419C4.63617 5.43156 4.63617 5.15175 4.46358 4.97919L2.72011 3.23571C2.58994 3.10554 2.58994 2.89446 2.72011 2.76429Z'/%3e%3c/svg%3e\");\n  mask-image: url(\"data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 6 6' fill='var%28--bs-text-primary%29'%3e%3cpath d='M2.72011 2.76429L4.46358 1.02083C4.63618 0.848244 4.63617 0.568419 4.46358 0.395831C4.29099 0.223244 4.01118 0.223244 3.83861 0.395831L1.52904 2.70537C1.36629 2.86808 1.36629 3.13191 1.52904 3.29462L3.83861 5.60419C4.01117 5.77675 4.29099 5.77675 4.46358 5.60419C4.63617 5.43156 4.63617 5.15175 4.46358 4.97919L2.72011 3.23571C2.58994 3.10554 2.58994 2.89446 2.72011 2.76429Z'/%3e%3c/svg%3e\");\n  /*rtl:begin:remove*/\n  mask-repeat: no-repeat;\n  mask-position: center;\n  -webkit-mask-repeat: no-repeat;\n  -webkit-mask-position: center;\n  background-color: var(--bs-text-primary);\n  -webkit-mask-image: url(\"data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 6 6' fill='var%28--bs-text-primary%29'%3e%3cpath d='M3.27989 3.23571L1.53642 4.97917C1.36382 5.15176 1.36383 5.43158 1.53642 5.60417C1.70901 5.77676 1.98882 5.77676 2.16139 5.60417L4.47096 3.29463C4.63371 3.13192 4.63371 2.86809 4.47096 2.70538L2.16139 0.395812C1.98883 0.22325 1.70901 0.22325 1.53642 0.395812C1.36383 0.568437 1.36383 0.84825 1.53642 1.02081L3.27989 2.76429C3.41006 2.89446 3.41006 3.10554 3.27989 3.23571Z'/%3e%3c/svg%3e\");\n  mask-image: url(\"data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 6 6' fill='var%28--bs-text-primary%29'%3e%3cpath d='M3.27989 3.23571L1.53642 4.97917C1.36382 5.15176 1.36383 5.43158 1.53642 5.60417C1.70901 5.77676 1.98882 5.77676 2.16139 5.60417L4.47096 3.29463C4.63371 3.13192 4.63371 2.86809 4.47096 2.70538L2.16139 0.395812C1.98883 0.22325 1.70901 0.22325 1.53642 0.395812C1.36383 0.568437 1.36383 0.84825 1.53642 1.02081L3.27989 2.76429C3.41006 2.89446 3.41006 3.10554 3.27989 3.23571Z'/%3e%3c/svg%3e\");\n  /*rtl:end:remove*/\n}\n\n.menu-secondary .menu-item .menu-link {\n  color: var(--bs-secondary);\n}\n.menu-secondary .menu-item .menu-link .menu-title {\n  color: var(--bs-secondary);\n}\n.menu-secondary .menu-item .menu-link .menu-icon,\n.menu-secondary .menu-item .menu-link .menu-icon .svg-icon,\n.menu-secondary .menu-item .menu-link .menu-icon i {\n  color: var(--bs-secondary);\n}\n.menu-secondary .menu-item .menu-link .menu-bullet .bullet {\n  background-color: var(--bs-secondary);\n}\n.menu-secondary .menu-item .menu-link .menu-arrow:after {\n  mask-repeat: no-repeat;\n  mask-position: center;\n  -webkit-mask-repeat: no-repeat;\n  -webkit-mask-position: center;\n  background-color: var(--bs-secondary);\n  -webkit-mask-image: url(\"data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 6 6' fill='var%28--bs-secondary%29'%3e%3cpath d='M2.72011 2.76429L4.46358 1.02083C4.63618 0.848244 4.63617 0.568419 4.46358 0.395831C4.29099 0.223244 4.01118 0.223244 3.83861 0.395831L1.52904 2.70537C1.36629 2.86808 1.36629 3.13191 1.52904 3.29462L3.83861 5.60419C4.01117 5.77675 4.29099 5.77675 4.46358 5.60419C4.63617 5.43156 4.63617 5.15175 4.46358 4.97919L2.72011 3.23571C2.58994 3.10554 2.58994 2.89446 2.72011 2.76429Z'/%3e%3c/svg%3e\");\n  mask-image: url(\"data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 6 6' fill='var%28--bs-secondary%29'%3e%3cpath d='M2.72011 2.76429L4.46358 1.02083C4.63618 0.848244 4.63617 0.568419 4.46358 0.395831C4.29099 0.223244 4.01118 0.223244 3.83861 0.395831L1.52904 2.70537C1.36629 2.86808 1.36629 3.13191 1.52904 3.29462L3.83861 5.60419C4.01117 5.77675 4.29099 5.77675 4.46358 5.60419C4.63617 5.43156 4.63617 5.15175 4.46358 4.97919L2.72011 3.23571C2.58994 3.10554 2.58994 2.89446 2.72011 2.76429Z'/%3e%3c/svg%3e\");\n  /*rtl:begin:remove*/\n  mask-repeat: no-repeat;\n  mask-position: center;\n  -webkit-mask-repeat: no-repeat;\n  -webkit-mask-position: center;\n  background-color: var(--bs-secondary);\n  -webkit-mask-image: url(\"data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 6 6' fill='var%28--bs-secondary%29'%3e%3cpath d='M3.27989 3.23571L1.53642 4.97917C1.36382 5.15176 1.36383 5.43158 1.53642 5.60417C1.70901 5.77676 1.98882 5.77676 2.16139 5.60417L4.47096 3.29463C4.63371 3.13192 4.63371 2.86809 4.47096 2.70538L2.16139 0.395812C1.98883 0.22325 1.70901 0.22325 1.53642 0.395812C1.36383 0.568437 1.36383 0.84825 1.53642 1.02081L3.27989 2.76429C3.41006 2.89446 3.41006 3.10554 3.27989 3.23571Z'/%3e%3c/svg%3e\");\n  mask-image: url(\"data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 6 6' fill='var%28--bs-secondary%29'%3e%3cpath d='M3.27989 3.23571L1.53642 4.97917C1.36382 5.15176 1.36383 5.43158 1.53642 5.60417C1.70901 5.77676 1.98882 5.77676 2.16139 5.60417L4.47096 3.29463C4.63371 3.13192 4.63371 2.86809 4.47096 2.70538L2.16139 0.395812C1.98883 0.22325 1.70901 0.22325 1.53642 0.395812C1.36383 0.568437 1.36383 0.84825 1.53642 1.02081L3.27989 2.76429C3.41006 2.89446 3.41006 3.10554 3.27989 3.23571Z'/%3e%3c/svg%3e\");\n  /*rtl:end:remove*/\n}\n\n.menu-title-secondary .menu-item .menu-link {\n  color: var(--bs-text-secondary);\n}\n.menu-title-secondary .menu-item .menu-link .menu-title {\n  color: var(--bs-text-secondary);\n}\n\n.menu-icon-secondary .menu-item .menu-link .menu-icon,\n.menu-icon-secondary .menu-item .menu-link .menu-icon .svg-icon,\n.menu-icon-secondary .menu-item .menu-link .menu-icon i {\n  color: var(--bs-text-secondary);\n}\n\n.menu-bullet-secondary .menu-item .menu-link .menu-bullet .bullet {\n  background-color: var(--bs-text-secondary);\n}\n\n.menu-arrow-secondary .menu-item .menu-link .menu-arrow:after {\n  mask-repeat: no-repeat;\n  mask-position: center;\n  -webkit-mask-repeat: no-repeat;\n  -webkit-mask-position: center;\n  background-color: var(--bs-text-secondary);\n  -webkit-mask-image: url(\"data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 6 6' fill='var%28--bs-text-secondary%29'%3e%3cpath d='M2.72011 2.76429L4.46358 1.02083C4.63618 0.848244 4.63617 0.568419 4.46358 0.395831C4.29099 0.223244 4.01118 0.223244 3.83861 0.395831L1.52904 2.70537C1.36629 2.86808 1.36629 3.13191 1.52904 3.29462L3.83861 5.60419C4.01117 5.77675 4.29099 5.77675 4.46358 5.60419C4.63617 5.43156 4.63617 5.15175 4.46358 4.97919L2.72011 3.23571C2.58994 3.10554 2.58994 2.89446 2.72011 2.76429Z'/%3e%3c/svg%3e\");\n  mask-image: url(\"data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 6 6' fill='var%28--bs-text-secondary%29'%3e%3cpath d='M2.72011 2.76429L4.46358 1.02083C4.63618 0.848244 4.63617 0.568419 4.46358 0.395831C4.29099 0.223244 4.01118 0.223244 3.83861 0.395831L1.52904 2.70537C1.36629 2.86808 1.36629 3.13191 1.52904 3.29462L3.83861 5.60419C4.01117 5.77675 4.29099 5.77675 4.46358 5.60419C4.63617 5.43156 4.63617 5.15175 4.46358 4.97919L2.72011 3.23571C2.58994 3.10554 2.58994 2.89446 2.72011 2.76429Z'/%3e%3c/svg%3e\");\n  /*rtl:begin:remove*/\n  mask-repeat: no-repeat;\n  mask-position: center;\n  -webkit-mask-repeat: no-repeat;\n  -webkit-mask-position: center;\n  background-color: var(--bs-text-secondary);\n  -webkit-mask-image: url(\"data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 6 6' fill='var%28--bs-text-secondary%29'%3e%3cpath d='M3.27989 3.23571L1.53642 4.97917C1.36382 5.15176 1.36383 5.43158 1.53642 5.60417C1.70901 5.77676 1.98882 5.77676 2.16139 5.60417L4.47096 3.29463C4.63371 3.13192 4.63371 2.86809 4.47096 2.70538L2.16139 0.395812C1.98883 0.22325 1.70901 0.22325 1.53642 0.395812C1.36383 0.568437 1.36383 0.84825 1.53642 1.02081L3.27989 2.76429C3.41006 2.89446 3.41006 3.10554 3.27989 3.23571Z'/%3e%3c/svg%3e\");\n  mask-image: url(\"data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 6 6' fill='var%28--bs-text-secondary%29'%3e%3cpath d='M3.27989 3.23571L1.53642 4.97917C1.36382 5.15176 1.36383 5.43158 1.53642 5.60417C1.70901 5.77676 1.98882 5.77676 2.16139 5.60417L4.47096 3.29463C4.63371 3.13192 4.63371 2.86809 4.47096 2.70538L2.16139 0.395812C1.98883 0.22325 1.70901 0.22325 1.53642 0.395812C1.36383 0.568437 1.36383 0.84825 1.53642 1.02081L3.27989 2.76429C3.41006 2.89446 3.41006 3.10554 3.27989 3.23571Z'/%3e%3c/svg%3e\");\n  /*rtl:end:remove*/\n}\n\n.menu-light .menu-item .menu-link {\n  color: var(--bs-light);\n}\n.menu-light .menu-item .menu-link .menu-title {\n  color: var(--bs-light);\n}\n.menu-light .menu-item .menu-link .menu-icon,\n.menu-light .menu-item .menu-link .menu-icon .svg-icon,\n.menu-light .menu-item .menu-link .menu-icon i {\n  color: var(--bs-light);\n}\n.menu-light .menu-item .menu-link .menu-bullet .bullet {\n  background-color: var(--bs-light);\n}\n.menu-light .menu-item .menu-link .menu-arrow:after {\n  mask-repeat: no-repeat;\n  mask-position: center;\n  -webkit-mask-repeat: no-repeat;\n  -webkit-mask-position: center;\n  background-color: var(--bs-light);\n  -webkit-mask-image: url(\"data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 6 6' fill='var%28--bs-light%29'%3e%3cpath d='M2.72011 2.76429L4.46358 1.02083C4.63618 0.848244 4.63617 0.568419 4.46358 0.395831C4.29099 0.223244 4.01118 0.223244 3.83861 0.395831L1.52904 2.70537C1.36629 2.86808 1.36629 3.13191 1.52904 3.29462L3.83861 5.60419C4.01117 5.77675 4.29099 5.77675 4.46358 5.60419C4.63617 5.43156 4.63617 5.15175 4.46358 4.97919L2.72011 3.23571C2.58994 3.10554 2.58994 2.89446 2.72011 2.76429Z'/%3e%3c/svg%3e\");\n  mask-image: url(\"data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 6 6' fill='var%28--bs-light%29'%3e%3cpath d='M2.72011 2.76429L4.46358 1.02083C4.63618 0.848244 4.63617 0.568419 4.46358 0.395831C4.29099 0.223244 4.01118 0.223244 3.83861 0.395831L1.52904 2.70537C1.36629 2.86808 1.36629 3.13191 1.52904 3.29462L3.83861 5.60419C4.01117 5.77675 4.29099 5.77675 4.46358 5.60419C4.63617 5.43156 4.63617 5.15175 4.46358 4.97919L2.72011 3.23571C2.58994 3.10554 2.58994 2.89446 2.72011 2.76429Z'/%3e%3c/svg%3e\");\n  /*rtl:begin:remove*/\n  mask-repeat: no-repeat;\n  mask-position: center;\n  -webkit-mask-repeat: no-repeat;\n  -webkit-mask-position: center;\n  background-color: var(--bs-light);\n  -webkit-mask-image: url(\"data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 6 6' fill='var%28--bs-light%29'%3e%3cpath d='M3.27989 3.23571L1.53642 4.97917C1.36382 5.15176 1.36383 5.43158 1.53642 5.60417C1.70901 5.77676 1.98882 5.77676 2.16139 5.60417L4.47096 3.29463C4.63371 3.13192 4.63371 2.86809 4.47096 2.70538L2.16139 0.395812C1.98883 0.22325 1.70901 0.22325 1.53642 0.395812C1.36383 0.568437 1.36383 0.84825 1.53642 1.02081L3.27989 2.76429C3.41006 2.89446 3.41006 3.10554 3.27989 3.23571Z'/%3e%3c/svg%3e\");\n  mask-image: url(\"data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 6 6' fill='var%28--bs-light%29'%3e%3cpath d='M3.27989 3.23571L1.53642 4.97917C1.36382 5.15176 1.36383 5.43158 1.53642 5.60417C1.70901 5.77676 1.98882 5.77676 2.16139 5.60417L4.47096 3.29463C4.63371 3.13192 4.63371 2.86809 4.47096 2.70538L2.16139 0.395812C1.98883 0.22325 1.70901 0.22325 1.53642 0.395812C1.36383 0.568437 1.36383 0.84825 1.53642 1.02081L3.27989 2.76429C3.41006 2.89446 3.41006 3.10554 3.27989 3.23571Z'/%3e%3c/svg%3e\");\n  /*rtl:end:remove*/\n}\n\n.menu-title-light .menu-item .menu-link {\n  color: var(--bs-text-light);\n}\n.menu-title-light .menu-item .menu-link .menu-title {\n  color: var(--bs-text-light);\n}\n\n.menu-icon-light .menu-item .menu-link .menu-icon,\n.menu-icon-light .menu-item .menu-link .menu-icon .svg-icon,\n.menu-icon-light .menu-item .menu-link .menu-icon i {\n  color: var(--bs-text-light);\n}\n\n.menu-bullet-light .menu-item .menu-link .menu-bullet .bullet {\n  background-color: var(--bs-text-light);\n}\n\n.menu-arrow-light .menu-item .menu-link .menu-arrow:after {\n  mask-repeat: no-repeat;\n  mask-position: center;\n  -webkit-mask-repeat: no-repeat;\n  -webkit-mask-position: center;\n  background-color: var(--bs-text-light);\n  -webkit-mask-image: url(\"data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 6 6' fill='var%28--bs-text-light%29'%3e%3cpath d='M2.72011 2.76429L4.46358 1.02083C4.63618 0.848244 4.63617 0.568419 4.46358 0.395831C4.29099 0.223244 4.01118 0.223244 3.83861 0.395831L1.52904 2.70537C1.36629 2.86808 1.36629 3.13191 1.52904 3.29462L3.83861 5.60419C4.01117 5.77675 4.29099 5.77675 4.46358 5.60419C4.63617 5.43156 4.63617 5.15175 4.46358 4.97919L2.72011 3.23571C2.58994 3.10554 2.58994 2.89446 2.72011 2.76429Z'/%3e%3c/svg%3e\");\n  mask-image: url(\"data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 6 6' fill='var%28--bs-text-light%29'%3e%3cpath d='M2.72011 2.76429L4.46358 1.02083C4.63618 0.848244 4.63617 0.568419 4.46358 0.395831C4.29099 0.223244 4.01118 0.223244 3.83861 0.395831L1.52904 2.70537C1.36629 2.86808 1.36629 3.13191 1.52904 3.29462L3.83861 5.60419C4.01117 5.77675 4.29099 5.77675 4.46358 5.60419C4.63617 5.43156 4.63617 5.15175 4.46358 4.97919L2.72011 3.23571C2.58994 3.10554 2.58994 2.89446 2.72011 2.76429Z'/%3e%3c/svg%3e\");\n  /*rtl:begin:remove*/\n  mask-repeat: no-repeat;\n  mask-position: center;\n  -webkit-mask-repeat: no-repeat;\n  -webkit-mask-position: center;\n  background-color: var(--bs-text-light);\n  -webkit-mask-image: url(\"data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 6 6' fill='var%28--bs-text-light%29'%3e%3cpath d='M3.27989 3.23571L1.53642 4.97917C1.36382 5.15176 1.36383 5.43158 1.53642 5.60417C1.70901 5.77676 1.98882 5.77676 2.16139 5.60417L4.47096 3.29463C4.63371 3.13192 4.63371 2.86809 4.47096 2.70538L2.16139 0.395812C1.98883 0.22325 1.70901 0.22325 1.53642 0.395812C1.36383 0.568437 1.36383 0.84825 1.53642 1.02081L3.27989 2.76429C3.41006 2.89446 3.41006 3.10554 3.27989 3.23571Z'/%3e%3c/svg%3e\");\n  mask-image: url(\"data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 6 6' fill='var%28--bs-text-light%29'%3e%3cpath d='M3.27989 3.23571L1.53642 4.97917C1.36382 5.15176 1.36383 5.43158 1.53642 5.60417C1.70901 5.77676 1.98882 5.77676 2.16139 5.60417L4.47096 3.29463C4.63371 3.13192 4.63371 2.86809 4.47096 2.70538L2.16139 0.395812C1.98883 0.22325 1.70901 0.22325 1.53642 0.395812C1.36383 0.568437 1.36383 0.84825 1.53642 1.02081L3.27989 2.76429C3.41006 2.89446 3.41006 3.10554 3.27989 3.23571Z'/%3e%3c/svg%3e\");\n  /*rtl:end:remove*/\n}\n\n.menu-success .menu-item .menu-link {\n  color: var(--bs-success);\n}\n.menu-success .menu-item .menu-link .menu-title {\n  color: var(--bs-success);\n}\n.menu-success .menu-item .menu-link .menu-icon,\n.menu-success .menu-item .menu-link .menu-icon .svg-icon,\n.menu-success .menu-item .menu-link .menu-icon i {\n  color: var(--bs-success);\n}\n.menu-success .menu-item .menu-link .menu-bullet .bullet {\n  background-color: var(--bs-success);\n}\n.menu-success .menu-item .menu-link .menu-arrow:after {\n  mask-repeat: no-repeat;\n  mask-position: center;\n  -webkit-mask-repeat: no-repeat;\n  -webkit-mask-position: center;\n  background-color: var(--bs-success);\n  -webkit-mask-image: url(\"data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 6 6' fill='var%28--bs-success%29'%3e%3cpath d='M2.72011 2.76429L4.46358 1.02083C4.63618 0.848244 4.63617 0.568419 4.46358 0.395831C4.29099 0.223244 4.01118 0.223244 3.83861 0.395831L1.52904 2.70537C1.36629 2.86808 1.36629 3.13191 1.52904 3.29462L3.83861 5.60419C4.01117 5.77675 4.29099 5.77675 4.46358 5.60419C4.63617 5.43156 4.63617 5.15175 4.46358 4.97919L2.72011 3.23571C2.58994 3.10554 2.58994 2.89446 2.72011 2.76429Z'/%3e%3c/svg%3e\");\n  mask-image: url(\"data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 6 6' fill='var%28--bs-success%29'%3e%3cpath d='M2.72011 2.76429L4.46358 1.02083C4.63618 0.848244 4.63617 0.568419 4.46358 0.395831C4.29099 0.223244 4.01118 0.223244 3.83861 0.395831L1.52904 2.70537C1.36629 2.86808 1.36629 3.13191 1.52904 3.29462L3.83861 5.60419C4.01117 5.77675 4.29099 5.77675 4.46358 5.60419C4.63617 5.43156 4.63617 5.15175 4.46358 4.97919L2.72011 3.23571C2.58994 3.10554 2.58994 2.89446 2.72011 2.76429Z'/%3e%3c/svg%3e\");\n  /*rtl:begin:remove*/\n  mask-repeat: no-repeat;\n  mask-position: center;\n  -webkit-mask-repeat: no-repeat;\n  -webkit-mask-position: center;\n  background-color: var(--bs-success);\n  -webkit-mask-image: url(\"data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 6 6' fill='var%28--bs-success%29'%3e%3cpath d='M3.27989 3.23571L1.53642 4.97917C1.36382 5.15176 1.36383 5.43158 1.53642 5.60417C1.70901 5.77676 1.98882 5.77676 2.16139 5.60417L4.47096 3.29463C4.63371 3.13192 4.63371 2.86809 4.47096 2.70538L2.16139 0.395812C1.98883 0.22325 1.70901 0.22325 1.53642 0.395812C1.36383 0.568437 1.36383 0.84825 1.53642 1.02081L3.27989 2.76429C3.41006 2.89446 3.41006 3.10554 3.27989 3.23571Z'/%3e%3c/svg%3e\");\n  mask-image: url(\"data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 6 6' fill='var%28--bs-success%29'%3e%3cpath d='M3.27989 3.23571L1.53642 4.97917C1.36382 5.15176 1.36383 5.43158 1.53642 5.60417C1.70901 5.77676 1.98882 5.77676 2.16139 5.60417L4.47096 3.29463C4.63371 3.13192 4.63371 2.86809 4.47096 2.70538L2.16139 0.395812C1.98883 0.22325 1.70901 0.22325 1.53642 0.395812C1.36383 0.568437 1.36383 0.84825 1.53642 1.02081L3.27989 2.76429C3.41006 2.89446 3.41006 3.10554 3.27989 3.23571Z'/%3e%3c/svg%3e\");\n  /*rtl:end:remove*/\n}\n\n.menu-title-success .menu-item .menu-link {\n  color: var(--bs-text-success);\n}\n.menu-title-success .menu-item .menu-link .menu-title {\n  color: var(--bs-text-success);\n}\n\n.menu-icon-success .menu-item .menu-link .menu-icon,\n.menu-icon-success .menu-item .menu-link .menu-icon .svg-icon,\n.menu-icon-success .menu-item .menu-link .menu-icon i {\n  color: var(--bs-text-success);\n}\n\n.menu-bullet-success .menu-item .menu-link .menu-bullet .bullet {\n  background-color: var(--bs-text-success);\n}\n\n.menu-arrow-success .menu-item .menu-link .menu-arrow:after {\n  mask-repeat: no-repeat;\n  mask-position: center;\n  -webkit-mask-repeat: no-repeat;\n  -webkit-mask-position: center;\n  background-color: var(--bs-text-success);\n  -webkit-mask-image: url(\"data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 6 6' fill='var%28--bs-text-success%29'%3e%3cpath d='M2.72011 2.76429L4.46358 1.02083C4.63618 0.848244 4.63617 0.568419 4.46358 0.395831C4.29099 0.223244 4.01118 0.223244 3.83861 0.395831L1.52904 2.70537C1.36629 2.86808 1.36629 3.13191 1.52904 3.29462L3.83861 5.60419C4.01117 5.77675 4.29099 5.77675 4.46358 5.60419C4.63617 5.43156 4.63617 5.15175 4.46358 4.97919L2.72011 3.23571C2.58994 3.10554 2.58994 2.89446 2.72011 2.76429Z'/%3e%3c/svg%3e\");\n  mask-image: url(\"data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 6 6' fill='var%28--bs-text-success%29'%3e%3cpath d='M2.72011 2.76429L4.46358 1.02083C4.63618 0.848244 4.63617 0.568419 4.46358 0.395831C4.29099 0.223244 4.01118 0.223244 3.83861 0.395831L1.52904 2.70537C1.36629 2.86808 1.36629 3.13191 1.52904 3.29462L3.83861 5.60419C4.01117 5.77675 4.29099 5.77675 4.46358 5.60419C4.63617 5.43156 4.63617 5.15175 4.46358 4.97919L2.72011 3.23571C2.58994 3.10554 2.58994 2.89446 2.72011 2.76429Z'/%3e%3c/svg%3e\");\n  /*rtl:begin:remove*/\n  mask-repeat: no-repeat;\n  mask-position: center;\n  -webkit-mask-repeat: no-repeat;\n  -webkit-mask-position: center;\n  background-color: var(--bs-text-success);\n  -webkit-mask-image: url(\"data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 6 6' fill='var%28--bs-text-success%29'%3e%3cpath d='M3.27989 3.23571L1.53642 4.97917C1.36382 5.15176 1.36383 5.43158 1.53642 5.60417C1.70901 5.77676 1.98882 5.77676 2.16139 5.60417L4.47096 3.29463C4.63371 3.13192 4.63371 2.86809 4.47096 2.70538L2.16139 0.395812C1.98883 0.22325 1.70901 0.22325 1.53642 0.395812C1.36383 0.568437 1.36383 0.84825 1.53642 1.02081L3.27989 2.76429C3.41006 2.89446 3.41006 3.10554 3.27989 3.23571Z'/%3e%3c/svg%3e\");\n  mask-image: url(\"data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 6 6' fill='var%28--bs-text-success%29'%3e%3cpath d='M3.27989 3.23571L1.53642 4.97917C1.36382 5.15176 1.36383 5.43158 1.53642 5.60417C1.70901 5.77676 1.98882 5.77676 2.16139 5.60417L4.47096 3.29463C4.63371 3.13192 4.63371 2.86809 4.47096 2.70538L2.16139 0.395812C1.98883 0.22325 1.70901 0.22325 1.53642 0.395812C1.36383 0.568437 1.36383 0.84825 1.53642 1.02081L3.27989 2.76429C3.41006 2.89446 3.41006 3.10554 3.27989 3.23571Z'/%3e%3c/svg%3e\");\n  /*rtl:end:remove*/\n}\n\n.menu-info .menu-item .menu-link {\n  color: var(--bs-info);\n}\n.menu-info .menu-item .menu-link .menu-title {\n  color: var(--bs-info);\n}\n.menu-info .menu-item .menu-link .menu-icon,\n.menu-info .menu-item .menu-link .menu-icon .svg-icon,\n.menu-info .menu-item .menu-link .menu-icon i {\n  color: var(--bs-info);\n}\n.menu-info .menu-item .menu-link .menu-bullet .bullet {\n  background-color: var(--bs-info);\n}\n.menu-info .menu-item .menu-link .menu-arrow:after {\n  mask-repeat: no-repeat;\n  mask-position: center;\n  -webkit-mask-repeat: no-repeat;\n  -webkit-mask-position: center;\n  background-color: var(--bs-info);\n  -webkit-mask-image: url(\"data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 6 6' fill='var%28--bs-info%29'%3e%3cpath d='M2.72011 2.76429L4.46358 1.02083C4.63618 0.848244 4.63617 0.568419 4.46358 0.395831C4.29099 0.223244 4.01118 0.223244 3.83861 0.395831L1.52904 2.70537C1.36629 2.86808 1.36629 3.13191 1.52904 3.29462L3.83861 5.60419C4.01117 5.77675 4.29099 5.77675 4.46358 5.60419C4.63617 5.43156 4.63617 5.15175 4.46358 4.97919L2.72011 3.23571C2.58994 3.10554 2.58994 2.89446 2.72011 2.76429Z'/%3e%3c/svg%3e\");\n  mask-image: url(\"data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 6 6' fill='var%28--bs-info%29'%3e%3cpath d='M2.72011 2.76429L4.46358 1.02083C4.63618 0.848244 4.63617 0.568419 4.46358 0.395831C4.29099 0.223244 4.01118 0.223244 3.83861 0.395831L1.52904 2.70537C1.36629 2.86808 1.36629 3.13191 1.52904 3.29462L3.83861 5.60419C4.01117 5.77675 4.29099 5.77675 4.46358 5.60419C4.63617 5.43156 4.63617 5.15175 4.46358 4.97919L2.72011 3.23571C2.58994 3.10554 2.58994 2.89446 2.72011 2.76429Z'/%3e%3c/svg%3e\");\n  /*rtl:begin:remove*/\n  mask-repeat: no-repeat;\n  mask-position: center;\n  -webkit-mask-repeat: no-repeat;\n  -webkit-mask-position: center;\n  background-color: var(--bs-info);\n  -webkit-mask-image: url(\"data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 6 6' fill='var%28--bs-info%29'%3e%3cpath d='M3.27989 3.23571L1.53642 4.97917C1.36382 5.15176 1.36383 5.43158 1.53642 5.60417C1.70901 5.77676 1.98882 5.77676 2.16139 5.60417L4.47096 3.29463C4.63371 3.13192 4.63371 2.86809 4.47096 2.70538L2.16139 0.395812C1.98883 0.22325 1.70901 0.22325 1.53642 0.395812C1.36383 0.568437 1.36383 0.84825 1.53642 1.02081L3.27989 2.76429C3.41006 2.89446 3.41006 3.10554 3.27989 3.23571Z'/%3e%3c/svg%3e\");\n  mask-image: url(\"data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 6 6' fill='var%28--bs-info%29'%3e%3cpath d='M3.27989 3.23571L1.53642 4.97917C1.36382 5.15176 1.36383 5.43158 1.53642 5.60417C1.70901 5.77676 1.98882 5.77676 2.16139 5.60417L4.47096 3.29463C4.63371 3.13192 4.63371 2.86809 4.47096 2.70538L2.16139 0.395812C1.98883 0.22325 1.70901 0.22325 1.53642 0.395812C1.36383 0.568437 1.36383 0.84825 1.53642 1.02081L3.27989 2.76429C3.41006 2.89446 3.41006 3.10554 3.27989 3.23571Z'/%3e%3c/svg%3e\");\n  /*rtl:end:remove*/\n}\n\n.menu-title-info .menu-item .menu-link {\n  color: var(--bs-text-info);\n}\n.menu-title-info .menu-item .menu-link .menu-title {\n  color: var(--bs-text-info);\n}\n\n.menu-icon-info .menu-item .menu-link .menu-icon,\n.menu-icon-info .menu-item .menu-link .menu-icon .svg-icon,\n.menu-icon-info .menu-item .menu-link .menu-icon i {\n  color: var(--bs-text-info);\n}\n\n.menu-bullet-info .menu-item .menu-link .menu-bullet .bullet {\n  background-color: var(--bs-text-info);\n}\n\n.menu-arrow-info .menu-item .menu-link .menu-arrow:after {\n  mask-repeat: no-repeat;\n  mask-position: center;\n  -webkit-mask-repeat: no-repeat;\n  -webkit-mask-position: center;\n  background-color: var(--bs-text-info);\n  -webkit-mask-image: url(\"data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 6 6' fill='var%28--bs-text-info%29'%3e%3cpath d='M2.72011 2.76429L4.46358 1.02083C4.63618 0.848244 4.63617 0.568419 4.46358 0.395831C4.29099 0.223244 4.01118 0.223244 3.83861 0.395831L1.52904 2.70537C1.36629 2.86808 1.36629 3.13191 1.52904 3.29462L3.83861 5.60419C4.01117 5.77675 4.29099 5.77675 4.46358 5.60419C4.63617 5.43156 4.63617 5.15175 4.46358 4.97919L2.72011 3.23571C2.58994 3.10554 2.58994 2.89446 2.72011 2.76429Z'/%3e%3c/svg%3e\");\n  mask-image: url(\"data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 6 6' fill='var%28--bs-text-info%29'%3e%3cpath d='M2.72011 2.76429L4.46358 1.02083C4.63618 0.848244 4.63617 0.568419 4.46358 0.395831C4.29099 0.223244 4.01118 0.223244 3.83861 0.395831L1.52904 2.70537C1.36629 2.86808 1.36629 3.13191 1.52904 3.29462L3.83861 5.60419C4.01117 5.77675 4.29099 5.77675 4.46358 5.60419C4.63617 5.43156 4.63617 5.15175 4.46358 4.97919L2.72011 3.23571C2.58994 3.10554 2.58994 2.89446 2.72011 2.76429Z'/%3e%3c/svg%3e\");\n  /*rtl:begin:remove*/\n  mask-repeat: no-repeat;\n  mask-position: center;\n  -webkit-mask-repeat: no-repeat;\n  -webkit-mask-position: center;\n  background-color: var(--bs-text-info);\n  -webkit-mask-image: url(\"data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 6 6' fill='var%28--bs-text-info%29'%3e%3cpath d='M3.27989 3.23571L1.53642 4.97917C1.36382 5.15176 1.36383 5.43158 1.53642 5.60417C1.70901 5.77676 1.98882 5.77676 2.16139 5.60417L4.47096 3.29463C4.63371 3.13192 4.63371 2.86809 4.47096 2.70538L2.16139 0.395812C1.98883 0.22325 1.70901 0.22325 1.53642 0.395812C1.36383 0.568437 1.36383 0.84825 1.53642 1.02081L3.27989 2.76429C3.41006 2.89446 3.41006 3.10554 3.27989 3.23571Z'/%3e%3c/svg%3e\");\n  mask-image: url(\"data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 6 6' fill='var%28--bs-text-info%29'%3e%3cpath d='M3.27989 3.23571L1.53642 4.97917C1.36382 5.15176 1.36383 5.43158 1.53642 5.60417C1.70901 5.77676 1.98882 5.77676 2.16139 5.60417L4.47096 3.29463C4.63371 3.13192 4.63371 2.86809 4.47096 2.70538L2.16139 0.395812C1.98883 0.22325 1.70901 0.22325 1.53642 0.395812C1.36383 0.568437 1.36383 0.84825 1.53642 1.02081L3.27989 2.76429C3.41006 2.89446 3.41006 3.10554 3.27989 3.23571Z'/%3e%3c/svg%3e\");\n  /*rtl:end:remove*/\n}\n\n.menu-warning .menu-item .menu-link {\n  color: var(--bs-warning);\n}\n.menu-warning .menu-item .menu-link .menu-title {\n  color: var(--bs-warning);\n}\n.menu-warning .menu-item .menu-link .menu-icon,\n.menu-warning .menu-item .menu-link .menu-icon .svg-icon,\n.menu-warning .menu-item .menu-link .menu-icon i {\n  color: var(--bs-warning);\n}\n.menu-warning .menu-item .menu-link .menu-bullet .bullet {\n  background-color: var(--bs-warning);\n}\n.menu-warning .menu-item .menu-link .menu-arrow:after {\n  mask-repeat: no-repeat;\n  mask-position: center;\n  -webkit-mask-repeat: no-repeat;\n  -webkit-mask-position: center;\n  background-color: var(--bs-warning);\n  -webkit-mask-image: url(\"data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 6 6' fill='var%28--bs-warning%29'%3e%3cpath d='M2.72011 2.76429L4.46358 1.02083C4.63618 0.848244 4.63617 0.568419 4.46358 0.395831C4.29099 0.223244 4.01118 0.223244 3.83861 0.395831L1.52904 2.70537C1.36629 2.86808 1.36629 3.13191 1.52904 3.29462L3.83861 5.60419C4.01117 5.77675 4.29099 5.77675 4.46358 5.60419C4.63617 5.43156 4.63617 5.15175 4.46358 4.97919L2.72011 3.23571C2.58994 3.10554 2.58994 2.89446 2.72011 2.76429Z'/%3e%3c/svg%3e\");\n  mask-image: url(\"data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 6 6' fill='var%28--bs-warning%29'%3e%3cpath d='M2.72011 2.76429L4.46358 1.02083C4.63618 0.848244 4.63617 0.568419 4.46358 0.395831C4.29099 0.223244 4.01118 0.223244 3.83861 0.395831L1.52904 2.70537C1.36629 2.86808 1.36629 3.13191 1.52904 3.29462L3.83861 5.60419C4.01117 5.77675 4.29099 5.77675 4.46358 5.60419C4.63617 5.43156 4.63617 5.15175 4.46358 4.97919L2.72011 3.23571C2.58994 3.10554 2.58994 2.89446 2.72011 2.76429Z'/%3e%3c/svg%3e\");\n  /*rtl:begin:remove*/\n  mask-repeat: no-repeat;\n  mask-position: center;\n  -webkit-mask-repeat: no-repeat;\n  -webkit-mask-position: center;\n  background-color: var(--bs-warning);\n  -webkit-mask-image: url(\"data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 6 6' fill='var%28--bs-warning%29'%3e%3cpath d='M3.27989 3.23571L1.53642 4.97917C1.36382 5.15176 1.36383 5.43158 1.53642 5.60417C1.70901 5.77676 1.98882 5.77676 2.16139 5.60417L4.47096 3.29463C4.63371 3.13192 4.63371 2.86809 4.47096 2.70538L2.16139 0.395812C1.98883 0.22325 1.70901 0.22325 1.53642 0.395812C1.36383 0.568437 1.36383 0.84825 1.53642 1.02081L3.27989 2.76429C3.41006 2.89446 3.41006 3.10554 3.27989 3.23571Z'/%3e%3c/svg%3e\");\n  mask-image: url(\"data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 6 6' fill='var%28--bs-warning%29'%3e%3cpath d='M3.27989 3.23571L1.53642 4.97917C1.36382 5.15176 1.36383 5.43158 1.53642 5.60417C1.70901 5.77676 1.98882 5.77676 2.16139 5.60417L4.47096 3.29463C4.63371 3.13192 4.63371 2.86809 4.47096 2.70538L2.16139 0.395812C1.98883 0.22325 1.70901 0.22325 1.53642 0.395812C1.36383 0.568437 1.36383 0.84825 1.53642 1.02081L3.27989 2.76429C3.41006 2.89446 3.41006 3.10554 3.27989 3.23571Z'/%3e%3c/svg%3e\");\n  /*rtl:end:remove*/\n}\n\n.menu-title-warning .menu-item .menu-link {\n  color: var(--bs-text-warning);\n}\n.menu-title-warning .menu-item .menu-link .menu-title {\n  color: var(--bs-text-warning);\n}\n\n.menu-icon-warning .menu-item .menu-link .menu-icon,\n.menu-icon-warning .menu-item .menu-link .menu-icon .svg-icon,\n.menu-icon-warning .menu-item .menu-link .menu-icon i {\n  color: var(--bs-text-warning);\n}\n\n.menu-bullet-warning .menu-item .menu-link .menu-bullet .bullet {\n  background-color: var(--bs-text-warning);\n}\n\n.menu-arrow-warning .menu-item .menu-link .menu-arrow:after {\n  mask-repeat: no-repeat;\n  mask-position: center;\n  -webkit-mask-repeat: no-repeat;\n  -webkit-mask-position: center;\n  background-color: var(--bs-text-warning);\n  -webkit-mask-image: url(\"data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 6 6' fill='var%28--bs-text-warning%29'%3e%3cpath d='M2.72011 2.76429L4.46358 1.02083C4.63618 0.848244 4.63617 0.568419 4.46358 0.395831C4.29099 0.223244 4.01118 0.223244 3.83861 0.395831L1.52904 2.70537C1.36629 2.86808 1.36629 3.13191 1.52904 3.29462L3.83861 5.60419C4.01117 5.77675 4.29099 5.77675 4.46358 5.60419C4.63617 5.43156 4.63617 5.15175 4.46358 4.97919L2.72011 3.23571C2.58994 3.10554 2.58994 2.89446 2.72011 2.76429Z'/%3e%3c/svg%3e\");\n  mask-image: url(\"data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 6 6' fill='var%28--bs-text-warning%29'%3e%3cpath d='M2.72011 2.76429L4.46358 1.02083C4.63618 0.848244 4.63617 0.568419 4.46358 0.395831C4.29099 0.223244 4.01118 0.223244 3.83861 0.395831L1.52904 2.70537C1.36629 2.86808 1.36629 3.13191 1.52904 3.29462L3.83861 5.60419C4.01117 5.77675 4.29099 5.77675 4.46358 5.60419C4.63617 5.43156 4.63617 5.15175 4.46358 4.97919L2.72011 3.23571C2.58994 3.10554 2.58994 2.89446 2.72011 2.76429Z'/%3e%3c/svg%3e\");\n  /*rtl:begin:remove*/\n  mask-repeat: no-repeat;\n  mask-position: center;\n  -webkit-mask-repeat: no-repeat;\n  -webkit-mask-position: center;\n  background-color: var(--bs-text-warning);\n  -webkit-mask-image: url(\"data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 6 6' fill='var%28--bs-text-warning%29'%3e%3cpath d='M3.27989 3.23571L1.53642 4.97917C1.36382 5.15176 1.36383 5.43158 1.53642 5.60417C1.70901 5.77676 1.98882 5.77676 2.16139 5.60417L4.47096 3.29463C4.63371 3.13192 4.63371 2.86809 4.47096 2.70538L2.16139 0.395812C1.98883 0.22325 1.70901 0.22325 1.53642 0.395812C1.36383 0.568437 1.36383 0.84825 1.53642 1.02081L3.27989 2.76429C3.41006 2.89446 3.41006 3.10554 3.27989 3.23571Z'/%3e%3c/svg%3e\");\n  mask-image: url(\"data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 6 6' fill='var%28--bs-text-warning%29'%3e%3cpath d='M3.27989 3.23571L1.53642 4.97917C1.36382 5.15176 1.36383 5.43158 1.53642 5.60417C1.70901 5.77676 1.98882 5.77676 2.16139 5.60417L4.47096 3.29463C4.63371 3.13192 4.63371 2.86809 4.47096 2.70538L2.16139 0.395812C1.98883 0.22325 1.70901 0.22325 1.53642 0.395812C1.36383 0.568437 1.36383 0.84825 1.53642 1.02081L3.27989 2.76429C3.41006 2.89446 3.41006 3.10554 3.27989 3.23571Z'/%3e%3c/svg%3e\");\n  /*rtl:end:remove*/\n}\n\n.menu-danger .menu-item .menu-link {\n  color: var(--bs-danger);\n}\n.menu-danger .menu-item .menu-link .menu-title {\n  color: var(--bs-danger);\n}\n.menu-danger .menu-item .menu-link .menu-icon,\n.menu-danger .menu-item .menu-link .menu-icon .svg-icon,\n.menu-danger .menu-item .menu-link .menu-icon i {\n  color: var(--bs-danger);\n}\n.menu-danger .menu-item .menu-link .menu-bullet .bullet {\n  background-color: var(--bs-danger);\n}\n.menu-danger .menu-item .menu-link .menu-arrow:after {\n  mask-repeat: no-repeat;\n  mask-position: center;\n  -webkit-mask-repeat: no-repeat;\n  -webkit-mask-position: center;\n  background-color: var(--bs-danger);\n  -webkit-mask-image: url(\"data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 6 6' fill='var%28--bs-danger%29'%3e%3cpath d='M2.72011 2.76429L4.46358 1.02083C4.63618 0.848244 4.63617 0.568419 4.46358 0.395831C4.29099 0.223244 4.01118 0.223244 3.83861 0.395831L1.52904 2.70537C1.36629 2.86808 1.36629 3.13191 1.52904 3.29462L3.83861 5.60419C4.01117 5.77675 4.29099 5.77675 4.46358 5.60419C4.63617 5.43156 4.63617 5.15175 4.46358 4.97919L2.72011 3.23571C2.58994 3.10554 2.58994 2.89446 2.72011 2.76429Z'/%3e%3c/svg%3e\");\n  mask-image: url(\"data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 6 6' fill='var%28--bs-danger%29'%3e%3cpath d='M2.72011 2.76429L4.46358 1.02083C4.63618 0.848244 4.63617 0.568419 4.46358 0.395831C4.29099 0.223244 4.01118 0.223244 3.83861 0.395831L1.52904 2.70537C1.36629 2.86808 1.36629 3.13191 1.52904 3.29462L3.83861 5.60419C4.01117 5.77675 4.29099 5.77675 4.46358 5.60419C4.63617 5.43156 4.63617 5.15175 4.46358 4.97919L2.72011 3.23571C2.58994 3.10554 2.58994 2.89446 2.72011 2.76429Z'/%3e%3c/svg%3e\");\n  /*rtl:begin:remove*/\n  mask-repeat: no-repeat;\n  mask-position: center;\n  -webkit-mask-repeat: no-repeat;\n  -webkit-mask-position: center;\n  background-color: var(--bs-danger);\n  -webkit-mask-image: url(\"data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 6 6' fill='var%28--bs-danger%29'%3e%3cpath d='M3.27989 3.23571L1.53642 4.97917C1.36382 5.15176 1.36383 5.43158 1.53642 5.60417C1.70901 5.77676 1.98882 5.77676 2.16139 5.60417L4.47096 3.29463C4.63371 3.13192 4.63371 2.86809 4.47096 2.70538L2.16139 0.395812C1.98883 0.22325 1.70901 0.22325 1.53642 0.395812C1.36383 0.568437 1.36383 0.84825 1.53642 1.02081L3.27989 2.76429C3.41006 2.89446 3.41006 3.10554 3.27989 3.23571Z'/%3e%3c/svg%3e\");\n  mask-image: url(\"data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 6 6' fill='var%28--bs-danger%29'%3e%3cpath d='M3.27989 3.23571L1.53642 4.97917C1.36382 5.15176 1.36383 5.43158 1.53642 5.60417C1.70901 5.77676 1.98882 5.77676 2.16139 5.60417L4.47096 3.29463C4.63371 3.13192 4.63371 2.86809 4.47096 2.70538L2.16139 0.395812C1.98883 0.22325 1.70901 0.22325 1.53642 0.395812C1.36383 0.568437 1.36383 0.84825 1.53642 1.02081L3.27989 2.76429C3.41006 2.89446 3.41006 3.10554 3.27989 3.23571Z'/%3e%3c/svg%3e\");\n  /*rtl:end:remove*/\n}\n\n.menu-title-danger .menu-item .menu-link {\n  color: var(--bs-text-danger);\n}\n.menu-title-danger .menu-item .menu-link .menu-title {\n  color: var(--bs-text-danger);\n}\n\n.menu-icon-danger .menu-item .menu-link .menu-icon,\n.menu-icon-danger .menu-item .menu-link .menu-icon .svg-icon,\n.menu-icon-danger .menu-item .menu-link .menu-icon i {\n  color: var(--bs-text-danger);\n}\n\n.menu-bullet-danger .menu-item .menu-link .menu-bullet .bullet {\n  background-color: var(--bs-text-danger);\n}\n\n.menu-arrow-danger .menu-item .menu-link .menu-arrow:after {\n  mask-repeat: no-repeat;\n  mask-position: center;\n  -webkit-mask-repeat: no-repeat;\n  -webkit-mask-position: center;\n  background-color: var(--bs-text-danger);\n  -webkit-mask-image: url(\"data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 6 6' fill='var%28--bs-text-danger%29'%3e%3cpath d='M2.72011 2.76429L4.46358 1.02083C4.63618 0.848244 4.63617 0.568419 4.46358 0.395831C4.29099 0.223244 4.01118 0.223244 3.83861 0.395831L1.52904 2.70537C1.36629 2.86808 1.36629 3.13191 1.52904 3.29462L3.83861 5.60419C4.01117 5.77675 4.29099 5.77675 4.46358 5.60419C4.63617 5.43156 4.63617 5.15175 4.46358 4.97919L2.72011 3.23571C2.58994 3.10554 2.58994 2.89446 2.72011 2.76429Z'/%3e%3c/svg%3e\");\n  mask-image: url(\"data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 6 6' fill='var%28--bs-text-danger%29'%3e%3cpath d='M2.72011 2.76429L4.46358 1.02083C4.63618 0.848244 4.63617 0.568419 4.46358 0.395831C4.29099 0.223244 4.01118 0.223244 3.83861 0.395831L1.52904 2.70537C1.36629 2.86808 1.36629 3.13191 1.52904 3.29462L3.83861 5.60419C4.01117 5.77675 4.29099 5.77675 4.46358 5.60419C4.63617 5.43156 4.63617 5.15175 4.46358 4.97919L2.72011 3.23571C2.58994 3.10554 2.58994 2.89446 2.72011 2.76429Z'/%3e%3c/svg%3e\");\n  /*rtl:begin:remove*/\n  mask-repeat: no-repeat;\n  mask-position: center;\n  -webkit-mask-repeat: no-repeat;\n  -webkit-mask-position: center;\n  background-color: var(--bs-text-danger);\n  -webkit-mask-image: url(\"data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 6 6' fill='var%28--bs-text-danger%29'%3e%3cpath d='M3.27989 3.23571L1.53642 4.97917C1.36382 5.15176 1.36383 5.43158 1.53642 5.60417C1.70901 5.77676 1.98882 5.77676 2.16139 5.60417L4.47096 3.29463C4.63371 3.13192 4.63371 2.86809 4.47096 2.70538L2.16139 0.395812C1.98883 0.22325 1.70901 0.22325 1.53642 0.395812C1.36383 0.568437 1.36383 0.84825 1.53642 1.02081L3.27989 2.76429C3.41006 2.89446 3.41006 3.10554 3.27989 3.23571Z'/%3e%3c/svg%3e\");\n  mask-image: url(\"data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 6 6' fill='var%28--bs-text-danger%29'%3e%3cpath d='M3.27989 3.23571L1.53642 4.97917C1.36382 5.15176 1.36383 5.43158 1.53642 5.60417C1.70901 5.77676 1.98882 5.77676 2.16139 5.60417L4.47096 3.29463C4.63371 3.13192 4.63371 2.86809 4.47096 2.70538L2.16139 0.395812C1.98883 0.22325 1.70901 0.22325 1.53642 0.395812C1.36383 0.568437 1.36383 0.84825 1.53642 1.02081L3.27989 2.76429C3.41006 2.89446 3.41006 3.10554 3.27989 3.23571Z'/%3e%3c/svg%3e\");\n  /*rtl:end:remove*/\n}\n\n.menu-dark .menu-item .menu-link {\n  color: var(--bs-dark);\n}\n.menu-dark .menu-item .menu-link .menu-title {\n  color: var(--bs-dark);\n}\n.menu-dark .menu-item .menu-link .menu-icon,\n.menu-dark .menu-item .menu-link .menu-icon .svg-icon,\n.menu-dark .menu-item .menu-link .menu-icon i {\n  color: var(--bs-dark);\n}\n.menu-dark .menu-item .menu-link .menu-bullet .bullet {\n  background-color: var(--bs-dark);\n}\n.menu-dark .menu-item .menu-link .menu-arrow:after {\n  mask-repeat: no-repeat;\n  mask-position: center;\n  -webkit-mask-repeat: no-repeat;\n  -webkit-mask-position: center;\n  background-color: var(--bs-dark);\n  -webkit-mask-image: url(\"data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 6 6' fill='var%28--bs-dark%29'%3e%3cpath d='M2.72011 2.76429L4.46358 1.02083C4.63618 0.848244 4.63617 0.568419 4.46358 0.395831C4.29099 0.223244 4.01118 0.223244 3.83861 0.395831L1.52904 2.70537C1.36629 2.86808 1.36629 3.13191 1.52904 3.29462L3.83861 5.60419C4.01117 5.77675 4.29099 5.77675 4.46358 5.60419C4.63617 5.43156 4.63617 5.15175 4.46358 4.97919L2.72011 3.23571C2.58994 3.10554 2.58994 2.89446 2.72011 2.76429Z'/%3e%3c/svg%3e\");\n  mask-image: url(\"data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 6 6' fill='var%28--bs-dark%29'%3e%3cpath d='M2.72011 2.76429L4.46358 1.02083C4.63618 0.848244 4.63617 0.568419 4.46358 0.395831C4.29099 0.223244 4.01118 0.223244 3.83861 0.395831L1.52904 2.70537C1.36629 2.86808 1.36629 3.13191 1.52904 3.29462L3.83861 5.60419C4.01117 5.77675 4.29099 5.77675 4.46358 5.60419C4.63617 5.43156 4.63617 5.15175 4.46358 4.97919L2.72011 3.23571C2.58994 3.10554 2.58994 2.89446 2.72011 2.76429Z'/%3e%3c/svg%3e\");\n  /*rtl:begin:remove*/\n  mask-repeat: no-repeat;\n  mask-position: center;\n  -webkit-mask-repeat: no-repeat;\n  -webkit-mask-position: center;\n  background-color: var(--bs-dark);\n  -webkit-mask-image: url(\"data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 6 6' fill='var%28--bs-dark%29'%3e%3cpath d='M3.27989 3.23571L1.53642 4.97917C1.36382 5.15176 1.36383 5.43158 1.53642 5.60417C1.70901 5.77676 1.98882 5.77676 2.16139 5.60417L4.47096 3.29463C4.63371 3.13192 4.63371 2.86809 4.47096 2.70538L2.16139 0.395812C1.98883 0.22325 1.70901 0.22325 1.53642 0.395812C1.36383 0.568437 1.36383 0.84825 1.53642 1.02081L3.27989 2.76429C3.41006 2.89446 3.41006 3.10554 3.27989 3.23571Z'/%3e%3c/svg%3e\");\n  mask-image: url(\"data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 6 6' fill='var%28--bs-dark%29'%3e%3cpath d='M3.27989 3.23571L1.53642 4.97917C1.36382 5.15176 1.36383 5.43158 1.53642 5.60417C1.70901 5.77676 1.98882 5.77676 2.16139 5.60417L4.47096 3.29463C4.63371 3.13192 4.63371 2.86809 4.47096 2.70538L2.16139 0.395812C1.98883 0.22325 1.70901 0.22325 1.53642 0.395812C1.36383 0.568437 1.36383 0.84825 1.53642 1.02081L3.27989 2.76429C3.41006 2.89446 3.41006 3.10554 3.27989 3.23571Z'/%3e%3c/svg%3e\");\n  /*rtl:end:remove*/\n}\n\n.menu-title-dark .menu-item .menu-link {\n  color: var(--bs-text-dark);\n}\n.menu-title-dark .menu-item .menu-link .menu-title {\n  color: var(--bs-text-dark);\n}\n\n.menu-icon-dark .menu-item .menu-link .menu-icon,\n.menu-icon-dark .menu-item .menu-link .menu-icon .svg-icon,\n.menu-icon-dark .menu-item .menu-link .menu-icon i {\n  color: var(--bs-text-dark);\n}\n\n.menu-bullet-dark .menu-item .menu-link .menu-bullet .bullet {\n  background-color: var(--bs-text-dark);\n}\n\n.menu-arrow-dark .menu-item .menu-link .menu-arrow:after {\n  mask-repeat: no-repeat;\n  mask-position: center;\n  -webkit-mask-repeat: no-repeat;\n  -webkit-mask-position: center;\n  background-color: var(--bs-text-dark);\n  -webkit-mask-image: url(\"data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 6 6' fill='var%28--bs-text-dark%29'%3e%3cpath d='M2.72011 2.76429L4.46358 1.02083C4.63618 0.848244 4.63617 0.568419 4.46358 0.395831C4.29099 0.223244 4.01118 0.223244 3.83861 0.395831L1.52904 2.70537C1.36629 2.86808 1.36629 3.13191 1.52904 3.29462L3.83861 5.60419C4.01117 5.77675 4.29099 5.77675 4.46358 5.60419C4.63617 5.43156 4.63617 5.15175 4.46358 4.97919L2.72011 3.23571C2.58994 3.10554 2.58994 2.89446 2.72011 2.76429Z'/%3e%3c/svg%3e\");\n  mask-image: url(\"data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 6 6' fill='var%28--bs-text-dark%29'%3e%3cpath d='M2.72011 2.76429L4.46358 1.02083C4.63618 0.848244 4.63617 0.568419 4.46358 0.395831C4.29099 0.223244 4.01118 0.223244 3.83861 0.395831L1.52904 2.70537C1.36629 2.86808 1.36629 3.13191 1.52904 3.29462L3.83861 5.60419C4.01117 5.77675 4.29099 5.77675 4.46358 5.60419C4.63617 5.43156 4.63617 5.15175 4.46358 4.97919L2.72011 3.23571C2.58994 3.10554 2.58994 2.89446 2.72011 2.76429Z'/%3e%3c/svg%3e\");\n  /*rtl:begin:remove*/\n  mask-repeat: no-repeat;\n  mask-position: center;\n  -webkit-mask-repeat: no-repeat;\n  -webkit-mask-position: center;\n  background-color: var(--bs-text-dark);\n  -webkit-mask-image: url(\"data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 6 6' fill='var%28--bs-text-dark%29'%3e%3cpath d='M3.27989 3.23571L1.53642 4.97917C1.36382 5.15176 1.36383 5.43158 1.53642 5.60417C1.70901 5.77676 1.98882 5.77676 2.16139 5.60417L4.47096 3.29463C4.63371 3.13192 4.63371 2.86809 4.47096 2.70538L2.16139 0.395812C1.98883 0.22325 1.70901 0.22325 1.53642 0.395812C1.36383 0.568437 1.36383 0.84825 1.53642 1.02081L3.27989 2.76429C3.41006 2.89446 3.41006 3.10554 3.27989 3.23571Z'/%3e%3c/svg%3e\");\n  mask-image: url(\"data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 6 6' fill='var%28--bs-text-dark%29'%3e%3cpath d='M3.27989 3.23571L1.53642 4.97917C1.36382 5.15176 1.36383 5.43158 1.53642 5.60417C1.70901 5.77676 1.98882 5.77676 2.16139 5.60417L4.47096 3.29463C4.63371 3.13192 4.63371 2.86809 4.47096 2.70538L2.16139 0.395812C1.98883 0.22325 1.70901 0.22325 1.53642 0.395812C1.36383 0.568437 1.36383 0.84825 1.53642 1.02081L3.27989 2.76429C3.41006 2.89446 3.41006 3.10554 3.27989 3.23571Z'/%3e%3c/svg%3e\");\n  /*rtl:end:remove*/\n}\n\n.menu-muted .menu-item .menu-link {\n  color: var(--bs-muted);\n}\n.menu-muted .menu-item .menu-link .menu-title {\n  color: var(--bs-muted);\n}\n.menu-muted .menu-item .menu-link .menu-icon,\n.menu-muted .menu-item .menu-link .menu-icon .svg-icon,\n.menu-muted .menu-item .menu-link .menu-icon i {\n  color: var(--bs-muted);\n}\n.menu-muted .menu-item .menu-link .menu-bullet .bullet {\n  background-color: var(--bs-muted);\n}\n.menu-muted .menu-item .menu-link .menu-arrow:after {\n  mask-repeat: no-repeat;\n  mask-position: center;\n  -webkit-mask-repeat: no-repeat;\n  -webkit-mask-position: center;\n  background-color: var(--bs-muted);\n  -webkit-mask-image: url(\"data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 6 6' fill='var%28--bs-muted%29'%3e%3cpath d='M2.72011 2.76429L4.46358 1.02083C4.63618 0.848244 4.63617 0.568419 4.46358 0.395831C4.29099 0.223244 4.01118 0.223244 3.83861 0.395831L1.52904 2.70537C1.36629 2.86808 1.36629 3.13191 1.52904 3.29462L3.83861 5.60419C4.01117 5.77675 4.29099 5.77675 4.46358 5.60419C4.63617 5.43156 4.63617 5.15175 4.46358 4.97919L2.72011 3.23571C2.58994 3.10554 2.58994 2.89446 2.72011 2.76429Z'/%3e%3c/svg%3e\");\n  mask-image: url(\"data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 6 6' fill='var%28--bs-muted%29'%3e%3cpath d='M2.72011 2.76429L4.46358 1.02083C4.63618 0.848244 4.63617 0.568419 4.46358 0.395831C4.29099 0.223244 4.01118 0.223244 3.83861 0.395831L1.52904 2.70537C1.36629 2.86808 1.36629 3.13191 1.52904 3.29462L3.83861 5.60419C4.01117 5.77675 4.29099 5.77675 4.46358 5.60419C4.63617 5.43156 4.63617 5.15175 4.46358 4.97919L2.72011 3.23571C2.58994 3.10554 2.58994 2.89446 2.72011 2.76429Z'/%3e%3c/svg%3e\");\n  /*rtl:begin:remove*/\n  mask-repeat: no-repeat;\n  mask-position: center;\n  -webkit-mask-repeat: no-repeat;\n  -webkit-mask-position: center;\n  background-color: var(--bs-muted);\n  -webkit-mask-image: url(\"data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 6 6' fill='var%28--bs-muted%29'%3e%3cpath d='M3.27989 3.23571L1.53642 4.97917C1.36382 5.15176 1.36383 5.43158 1.53642 5.60417C1.70901 5.77676 1.98882 5.77676 2.16139 5.60417L4.47096 3.29463C4.63371 3.13192 4.63371 2.86809 4.47096 2.70538L2.16139 0.395812C1.98883 0.22325 1.70901 0.22325 1.53642 0.395812C1.36383 0.568437 1.36383 0.84825 1.53642 1.02081L3.27989 2.76429C3.41006 2.89446 3.41006 3.10554 3.27989 3.23571Z'/%3e%3c/svg%3e\");\n  mask-image: url(\"data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 6 6' fill='var%28--bs-muted%29'%3e%3cpath d='M3.27989 3.23571L1.53642 4.97917C1.36382 5.15176 1.36383 5.43158 1.53642 5.60417C1.70901 5.77676 1.98882 5.77676 2.16139 5.60417L4.47096 3.29463C4.63371 3.13192 4.63371 2.86809 4.47096 2.70538L2.16139 0.395812C1.98883 0.22325 1.70901 0.22325 1.53642 0.395812C1.36383 0.568437 1.36383 0.84825 1.53642 1.02081L3.27989 2.76429C3.41006 2.89446 3.41006 3.10554 3.27989 3.23571Z'/%3e%3c/svg%3e\");\n  /*rtl:end:remove*/\n}\n\n.menu-title-muted .menu-item .menu-link {\n  color: var(--bs-text-muted);\n}\n.menu-title-muted .menu-item .menu-link .menu-title {\n  color: var(--bs-text-muted);\n}\n\n.menu-icon-muted .menu-item .menu-link .menu-icon,\n.menu-icon-muted .menu-item .menu-link .menu-icon .svg-icon,\n.menu-icon-muted .menu-item .menu-link .menu-icon i {\n  color: var(--bs-text-muted);\n}\n\n.menu-bullet-muted .menu-item .menu-link .menu-bullet .bullet {\n  background-color: var(--bs-text-muted);\n}\n\n.menu-arrow-muted .menu-item .menu-link .menu-arrow:after {\n  mask-repeat: no-repeat;\n  mask-position: center;\n  -webkit-mask-repeat: no-repeat;\n  -webkit-mask-position: center;\n  background-color: var(--bs-text-muted);\n  -webkit-mask-image: url(\"data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 6 6' fill='var%28--bs-text-muted%29'%3e%3cpath d='M2.72011 2.76429L4.46358 1.02083C4.63618 0.848244 4.63617 0.568419 4.46358 0.395831C4.29099 0.223244 4.01118 0.223244 3.83861 0.395831L1.52904 2.70537C1.36629 2.86808 1.36629 3.13191 1.52904 3.29462L3.83861 5.60419C4.01117 5.77675 4.29099 5.77675 4.46358 5.60419C4.63617 5.43156 4.63617 5.15175 4.46358 4.97919L2.72011 3.23571C2.58994 3.10554 2.58994 2.89446 2.72011 2.76429Z'/%3e%3c/svg%3e\");\n  mask-image: url(\"data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 6 6' fill='var%28--bs-text-muted%29'%3e%3cpath d='M2.72011 2.76429L4.46358 1.02083C4.63618 0.848244 4.63617 0.568419 4.46358 0.395831C4.29099 0.223244 4.01118 0.223244 3.83861 0.395831L1.52904 2.70537C1.36629 2.86808 1.36629 3.13191 1.52904 3.29462L3.83861 5.60419C4.01117 5.77675 4.29099 5.77675 4.46358 5.60419C4.63617 5.43156 4.63617 5.15175 4.46358 4.97919L2.72011 3.23571C2.58994 3.10554 2.58994 2.89446 2.72011 2.76429Z'/%3e%3c/svg%3e\");\n  /*rtl:begin:remove*/\n  mask-repeat: no-repeat;\n  mask-position: center;\n  -webkit-mask-repeat: no-repeat;\n  -webkit-mask-position: center;\n  background-color: var(--bs-text-muted);\n  -webkit-mask-image: url(\"data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 6 6' fill='var%28--bs-text-muted%29'%3e%3cpath d='M3.27989 3.23571L1.53642 4.97917C1.36382 5.15176 1.36383 5.43158 1.53642 5.60417C1.70901 5.77676 1.98882 5.77676 2.16139 5.60417L4.47096 3.29463C4.63371 3.13192 4.63371 2.86809 4.47096 2.70538L2.16139 0.395812C1.98883 0.22325 1.70901 0.22325 1.53642 0.395812C1.36383 0.568437 1.36383 0.84825 1.53642 1.02081L3.27989 2.76429C3.41006 2.89446 3.41006 3.10554 3.27989 3.23571Z'/%3e%3c/svg%3e\");\n  mask-image: url(\"data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 6 6' fill='var%28--bs-text-muted%29'%3e%3cpath d='M3.27989 3.23571L1.53642 4.97917C1.36382 5.15176 1.36383 5.43158 1.53642 5.60417C1.70901 5.77676 1.98882 5.77676 2.16139 5.60417L4.47096 3.29463C4.63371 3.13192 4.63371 2.86809 4.47096 2.70538L2.16139 0.395812C1.98883 0.22325 1.70901 0.22325 1.53642 0.395812C1.36383 0.568437 1.36383 0.84825 1.53642 1.02081L3.27989 2.76429C3.41006 2.89446 3.41006 3.10554 3.27989 3.23571Z'/%3e%3c/svg%3e\");\n  /*rtl:end:remove*/\n}\n\n.menu-gray-100 .menu-item .menu-link {\n  color: var(--bs-gray-100);\n}\n.menu-gray-100 .menu-item .menu-link .menu-title {\n  color: var(--bs-gray-100);\n}\n.menu-gray-100 .menu-item .menu-link .menu-icon,\n.menu-gray-100 .menu-item .menu-link .menu-icon .svg-icon,\n.menu-gray-100 .menu-item .menu-link .menu-icon i {\n  color: var(--bs-gray-100);\n}\n.menu-gray-100 .menu-item .menu-link .menu-bullet .bullet {\n  background-color: var(--bs-gray-100);\n}\n.menu-gray-100 .menu-item .menu-link .menu-arrow:after {\n  mask-repeat: no-repeat;\n  mask-position: center;\n  -webkit-mask-repeat: no-repeat;\n  -webkit-mask-position: center;\n  background-color: var(--bs-gray-100);\n  -webkit-mask-image: url(\"data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 6 6' fill='var%28--bs-gray-100%29'%3e%3cpath d='M2.72011 2.76429L4.46358 1.02083C4.63618 0.848244 4.63617 0.568419 4.46358 0.395831C4.29099 0.223244 4.01118 0.223244 3.83861 0.395831L1.52904 2.70537C1.36629 2.86808 1.36629 3.13191 1.52904 3.29462L3.83861 5.60419C4.01117 5.77675 4.29099 5.77675 4.46358 5.60419C4.63617 5.43156 4.63617 5.15175 4.46358 4.97919L2.72011 3.23571C2.58994 3.10554 2.58994 2.89446 2.72011 2.76429Z'/%3e%3c/svg%3e\");\n  mask-image: url(\"data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 6 6' fill='var%28--bs-gray-100%29'%3e%3cpath d='M2.72011 2.76429L4.46358 1.02083C4.63618 0.848244 4.63617 0.568419 4.46358 0.395831C4.29099 0.223244 4.01118 0.223244 3.83861 0.395831L1.52904 2.70537C1.36629 2.86808 1.36629 3.13191 1.52904 3.29462L3.83861 5.60419C4.01117 5.77675 4.29099 5.77675 4.46358 5.60419C4.63617 5.43156 4.63617 5.15175 4.46358 4.97919L2.72011 3.23571C2.58994 3.10554 2.58994 2.89446 2.72011 2.76429Z'/%3e%3c/svg%3e\");\n  /*rtl:begin:remove*/\n  mask-repeat: no-repeat;\n  mask-position: center;\n  -webkit-mask-repeat: no-repeat;\n  -webkit-mask-position: center;\n  background-color: var(--bs-gray-100);\n  -webkit-mask-image: url(\"data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 6 6' fill='var%28--bs-gray-100%29'%3e%3cpath d='M3.27989 3.23571L1.53642 4.97917C1.36382 5.15176 1.36383 5.43158 1.53642 5.60417C1.70901 5.77676 1.98882 5.77676 2.16139 5.60417L4.47096 3.29463C4.63371 3.13192 4.63371 2.86809 4.47096 2.70538L2.16139 0.395812C1.98883 0.22325 1.70901 0.22325 1.53642 0.395812C1.36383 0.568437 1.36383 0.84825 1.53642 1.02081L3.27989 2.76429C3.41006 2.89446 3.41006 3.10554 3.27989 3.23571Z'/%3e%3c/svg%3e\");\n  mask-image: url(\"data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 6 6' fill='var%28--bs-gray-100%29'%3e%3cpath d='M3.27989 3.23571L1.53642 4.97917C1.36382 5.15176 1.36383 5.43158 1.53642 5.60417C1.70901 5.77676 1.98882 5.77676 2.16139 5.60417L4.47096 3.29463C4.63371 3.13192 4.63371 2.86809 4.47096 2.70538L2.16139 0.395812C1.98883 0.22325 1.70901 0.22325 1.53642 0.395812C1.36383 0.568437 1.36383 0.84825 1.53642 1.02081L3.27989 2.76429C3.41006 2.89446 3.41006 3.10554 3.27989 3.23571Z'/%3e%3c/svg%3e\");\n  /*rtl:end:remove*/\n}\n\n.menu-title-gray-100 .menu-item .menu-link {\n  color: var(--bs-text-gray-100);\n}\n.menu-title-gray-100 .menu-item .menu-link .menu-title {\n  color: var(--bs-text-gray-100);\n}\n\n.menu-icon-gray-100 .menu-item .menu-link .menu-icon,\n.menu-icon-gray-100 .menu-item .menu-link .menu-icon .svg-icon,\n.menu-icon-gray-100 .menu-item .menu-link .menu-icon i {\n  color: var(--bs-text-gray-100);\n}\n\n.menu-bullet-gray-100 .menu-item .menu-link .menu-bullet .bullet {\n  background-color: var(--bs-text-gray-100);\n}\n\n.menu-arrow-gray-100 .menu-item .menu-link .menu-arrow:after {\n  mask-repeat: no-repeat;\n  mask-position: center;\n  -webkit-mask-repeat: no-repeat;\n  -webkit-mask-position: center;\n  background-color: var(--bs-text-gray-100);\n  -webkit-mask-image: url(\"data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 6 6' fill='var%28--bs-text-gray-100%29'%3e%3cpath d='M2.72011 2.76429L4.46358 1.02083C4.63618 0.848244 4.63617 0.568419 4.46358 0.395831C4.29099 0.223244 4.01118 0.223244 3.83861 0.395831L1.52904 2.70537C1.36629 2.86808 1.36629 3.13191 1.52904 3.29462L3.83861 5.60419C4.01117 5.77675 4.29099 5.77675 4.46358 5.60419C4.63617 5.43156 4.63617 5.15175 4.46358 4.97919L2.72011 3.23571C2.58994 3.10554 2.58994 2.89446 2.72011 2.76429Z'/%3e%3c/svg%3e\");\n  mask-image: url(\"data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 6 6' fill='var%28--bs-text-gray-100%29'%3e%3cpath d='M2.72011 2.76429L4.46358 1.02083C4.63618 0.848244 4.63617 0.568419 4.46358 0.395831C4.29099 0.223244 4.01118 0.223244 3.83861 0.395831L1.52904 2.70537C1.36629 2.86808 1.36629 3.13191 1.52904 3.29462L3.83861 5.60419C4.01117 5.77675 4.29099 5.77675 4.46358 5.60419C4.63617 5.43156 4.63617 5.15175 4.46358 4.97919L2.72011 3.23571C2.58994 3.10554 2.58994 2.89446 2.72011 2.76429Z'/%3e%3c/svg%3e\");\n  /*rtl:begin:remove*/\n  mask-repeat: no-repeat;\n  mask-position: center;\n  -webkit-mask-repeat: no-repeat;\n  -webkit-mask-position: center;\n  background-color: var(--bs-text-gray-100);\n  -webkit-mask-image: url(\"data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 6 6' fill='var%28--bs-text-gray-100%29'%3e%3cpath d='M3.27989 3.23571L1.53642 4.97917C1.36382 5.15176 1.36383 5.43158 1.53642 5.60417C1.70901 5.77676 1.98882 5.77676 2.16139 5.60417L4.47096 3.29463C4.63371 3.13192 4.63371 2.86809 4.47096 2.70538L2.16139 0.395812C1.98883 0.22325 1.70901 0.22325 1.53642 0.395812C1.36383 0.568437 1.36383 0.84825 1.53642 1.02081L3.27989 2.76429C3.41006 2.89446 3.41006 3.10554 3.27989 3.23571Z'/%3e%3c/svg%3e\");\n  mask-image: url(\"data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 6 6' fill='var%28--bs-text-gray-100%29'%3e%3cpath d='M3.27989 3.23571L1.53642 4.97917C1.36382 5.15176 1.36383 5.43158 1.53642 5.60417C1.70901 5.77676 1.98882 5.77676 2.16139 5.60417L4.47096 3.29463C4.63371 3.13192 4.63371 2.86809 4.47096 2.70538L2.16139 0.395812C1.98883 0.22325 1.70901 0.22325 1.53642 0.395812C1.36383 0.568437 1.36383 0.84825 1.53642 1.02081L3.27989 2.76429C3.41006 2.89446 3.41006 3.10554 3.27989 3.23571Z'/%3e%3c/svg%3e\");\n  /*rtl:end:remove*/\n}\n\n.menu-gray-200 .menu-item .menu-link {\n  color: var(--bs-gray-200);\n}\n.menu-gray-200 .menu-item .menu-link .menu-title {\n  color: var(--bs-gray-200);\n}\n.menu-gray-200 .menu-item .menu-link .menu-icon,\n.menu-gray-200 .menu-item .menu-link .menu-icon .svg-icon,\n.menu-gray-200 .menu-item .menu-link .menu-icon i {\n  color: var(--bs-gray-200);\n}\n.menu-gray-200 .menu-item .menu-link .menu-bullet .bullet {\n  background-color: var(--bs-gray-200);\n}\n.menu-gray-200 .menu-item .menu-link .menu-arrow:after {\n  mask-repeat: no-repeat;\n  mask-position: center;\n  -webkit-mask-repeat: no-repeat;\n  -webkit-mask-position: center;\n  background-color: var(--bs-gray-200);\n  -webkit-mask-image: url(\"data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 6 6' fill='var%28--bs-gray-200%29'%3e%3cpath d='M2.72011 2.76429L4.46358 1.02083C4.63618 0.848244 4.63617 0.568419 4.46358 0.395831C4.29099 0.223244 4.01118 0.223244 3.83861 0.395831L1.52904 2.70537C1.36629 2.86808 1.36629 3.13191 1.52904 3.29462L3.83861 5.60419C4.01117 5.77675 4.29099 5.77675 4.46358 5.60419C4.63617 5.43156 4.63617 5.15175 4.46358 4.97919L2.72011 3.23571C2.58994 3.10554 2.58994 2.89446 2.72011 2.76429Z'/%3e%3c/svg%3e\");\n  mask-image: url(\"data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 6 6' fill='var%28--bs-gray-200%29'%3e%3cpath d='M2.72011 2.76429L4.46358 1.02083C4.63618 0.848244 4.63617 0.568419 4.46358 0.395831C4.29099 0.223244 4.01118 0.223244 3.83861 0.395831L1.52904 2.70537C1.36629 2.86808 1.36629 3.13191 1.52904 3.29462L3.83861 5.60419C4.01117 5.77675 4.29099 5.77675 4.46358 5.60419C4.63617 5.43156 4.63617 5.15175 4.46358 4.97919L2.72011 3.23571C2.58994 3.10554 2.58994 2.89446 2.72011 2.76429Z'/%3e%3c/svg%3e\");\n  /*rtl:begin:remove*/\n  mask-repeat: no-repeat;\n  mask-position: center;\n  -webkit-mask-repeat: no-repeat;\n  -webkit-mask-position: center;\n  background-color: var(--bs-gray-200);\n  -webkit-mask-image: url(\"data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 6 6' fill='var%28--bs-gray-200%29'%3e%3cpath d='M3.27989 3.23571L1.53642 4.97917C1.36382 5.15176 1.36383 5.43158 1.53642 5.60417C1.70901 5.77676 1.98882 5.77676 2.16139 5.60417L4.47096 3.29463C4.63371 3.13192 4.63371 2.86809 4.47096 2.70538L2.16139 0.395812C1.98883 0.22325 1.70901 0.22325 1.53642 0.395812C1.36383 0.568437 1.36383 0.84825 1.53642 1.02081L3.27989 2.76429C3.41006 2.89446 3.41006 3.10554 3.27989 3.23571Z'/%3e%3c/svg%3e\");\n  mask-image: url(\"data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 6 6' fill='var%28--bs-gray-200%29'%3e%3cpath d='M3.27989 3.23571L1.53642 4.97917C1.36382 5.15176 1.36383 5.43158 1.53642 5.60417C1.70901 5.77676 1.98882 5.77676 2.16139 5.60417L4.47096 3.29463C4.63371 3.13192 4.63371 2.86809 4.47096 2.70538L2.16139 0.395812C1.98883 0.22325 1.70901 0.22325 1.53642 0.395812C1.36383 0.568437 1.36383 0.84825 1.53642 1.02081L3.27989 2.76429C3.41006 2.89446 3.41006 3.10554 3.27989 3.23571Z'/%3e%3c/svg%3e\");\n  /*rtl:end:remove*/\n}\n\n.menu-title-gray-200 .menu-item .menu-link {\n  color: var(--bs-text-gray-200);\n}\n.menu-title-gray-200 .menu-item .menu-link .menu-title {\n  color: var(--bs-text-gray-200);\n}\n\n.menu-icon-gray-200 .menu-item .menu-link .menu-icon,\n.menu-icon-gray-200 .menu-item .menu-link .menu-icon .svg-icon,\n.menu-icon-gray-200 .menu-item .menu-link .menu-icon i {\n  color: var(--bs-text-gray-200);\n}\n\n.menu-bullet-gray-200 .menu-item .menu-link .menu-bullet .bullet {\n  background-color: var(--bs-text-gray-200);\n}\n\n.menu-arrow-gray-200 .menu-item .menu-link .menu-arrow:after {\n  mask-repeat: no-repeat;\n  mask-position: center;\n  -webkit-mask-repeat: no-repeat;\n  -webkit-mask-position: center;\n  background-color: var(--bs-text-gray-200);\n  -webkit-mask-image: url(\"data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 6 6' fill='var%28--bs-text-gray-200%29'%3e%3cpath d='M2.72011 2.76429L4.46358 1.02083C4.63618 0.848244 4.63617 0.568419 4.46358 0.395831C4.29099 0.223244 4.01118 0.223244 3.83861 0.395831L1.52904 2.70537C1.36629 2.86808 1.36629 3.13191 1.52904 3.29462L3.83861 5.60419C4.01117 5.77675 4.29099 5.77675 4.46358 5.60419C4.63617 5.43156 4.63617 5.15175 4.46358 4.97919L2.72011 3.23571C2.58994 3.10554 2.58994 2.89446 2.72011 2.76429Z'/%3e%3c/svg%3e\");\n  mask-image: url(\"data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 6 6' fill='var%28--bs-text-gray-200%29'%3e%3cpath d='M2.72011 2.76429L4.46358 1.02083C4.63618 0.848244 4.63617 0.568419 4.46358 0.395831C4.29099 0.223244 4.01118 0.223244 3.83861 0.395831L1.52904 2.70537C1.36629 2.86808 1.36629 3.13191 1.52904 3.29462L3.83861 5.60419C4.01117 5.77675 4.29099 5.77675 4.46358 5.60419C4.63617 5.43156 4.63617 5.15175 4.46358 4.97919L2.72011 3.23571C2.58994 3.10554 2.58994 2.89446 2.72011 2.76429Z'/%3e%3c/svg%3e\");\n  /*rtl:begin:remove*/\n  mask-repeat: no-repeat;\n  mask-position: center;\n  -webkit-mask-repeat: no-repeat;\n  -webkit-mask-position: center;\n  background-color: var(--bs-text-gray-200);\n  -webkit-mask-image: url(\"data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 6 6' fill='var%28--bs-text-gray-200%29'%3e%3cpath d='M3.27989 3.23571L1.53642 4.97917C1.36382 5.15176 1.36383 5.43158 1.53642 5.60417C1.70901 5.77676 1.98882 5.77676 2.16139 5.60417L4.47096 3.29463C4.63371 3.13192 4.63371 2.86809 4.47096 2.70538L2.16139 0.395812C1.98883 0.22325 1.70901 0.22325 1.53642 0.395812C1.36383 0.568437 1.36383 0.84825 1.53642 1.02081L3.27989 2.76429C3.41006 2.89446 3.41006 3.10554 3.27989 3.23571Z'/%3e%3c/svg%3e\");\n  mask-image: url(\"data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 6 6' fill='var%28--bs-text-gray-200%29'%3e%3cpath d='M3.27989 3.23571L1.53642 4.97917C1.36382 5.15176 1.36383 5.43158 1.53642 5.60417C1.70901 5.77676 1.98882 5.77676 2.16139 5.60417L4.47096 3.29463C4.63371 3.13192 4.63371 2.86809 4.47096 2.70538L2.16139 0.395812C1.98883 0.22325 1.70901 0.22325 1.53642 0.395812C1.36383 0.568437 1.36383 0.84825 1.53642 1.02081L3.27989 2.76429C3.41006 2.89446 3.41006 3.10554 3.27989 3.23571Z'/%3e%3c/svg%3e\");\n  /*rtl:end:remove*/\n}\n\n.menu-gray-300 .menu-item .menu-link {\n  color: var(--bs-gray-300);\n}\n.menu-gray-300 .menu-item .menu-link .menu-title {\n  color: var(--bs-gray-300);\n}\n.menu-gray-300 .menu-item .menu-link .menu-icon,\n.menu-gray-300 .menu-item .menu-link .menu-icon .svg-icon,\n.menu-gray-300 .menu-item .menu-link .menu-icon i {\n  color: var(--bs-gray-300);\n}\n.menu-gray-300 .menu-item .menu-link .menu-bullet .bullet {\n  background-color: var(--bs-gray-300);\n}\n.menu-gray-300 .menu-item .menu-link .menu-arrow:after {\n  mask-repeat: no-repeat;\n  mask-position: center;\n  -webkit-mask-repeat: no-repeat;\n  -webkit-mask-position: center;\n  background-color: var(--bs-gray-300);\n  -webkit-mask-image: url(\"data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 6 6' fill='var%28--bs-gray-300%29'%3e%3cpath d='M2.72011 2.76429L4.46358 1.02083C4.63618 0.848244 4.63617 0.568419 4.46358 0.395831C4.29099 0.223244 4.01118 0.223244 3.83861 0.395831L1.52904 2.70537C1.36629 2.86808 1.36629 3.13191 1.52904 3.29462L3.83861 5.60419C4.01117 5.77675 4.29099 5.77675 4.46358 5.60419C4.63617 5.43156 4.63617 5.15175 4.46358 4.97919L2.72011 3.23571C2.58994 3.10554 2.58994 2.89446 2.72011 2.76429Z'/%3e%3c/svg%3e\");\n  mask-image: url(\"data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 6 6' fill='var%28--bs-gray-300%29'%3e%3cpath d='M2.72011 2.76429L4.46358 1.02083C4.63618 0.848244 4.63617 0.568419 4.46358 0.395831C4.29099 0.223244 4.01118 0.223244 3.83861 0.395831L1.52904 2.70537C1.36629 2.86808 1.36629 3.13191 1.52904 3.29462L3.83861 5.60419C4.01117 5.77675 4.29099 5.77675 4.46358 5.60419C4.63617 5.43156 4.63617 5.15175 4.46358 4.97919L2.72011 3.23571C2.58994 3.10554 2.58994 2.89446 2.72011 2.76429Z'/%3e%3c/svg%3e\");\n  /*rtl:begin:remove*/\n  mask-repeat: no-repeat;\n  mask-position: center;\n  -webkit-mask-repeat: no-repeat;\n  -webkit-mask-position: center;\n  background-color: var(--bs-gray-300);\n  -webkit-mask-image: url(\"data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 6 6' fill='var%28--bs-gray-300%29'%3e%3cpath d='M3.27989 3.23571L1.53642 4.97917C1.36382 5.15176 1.36383 5.43158 1.53642 5.60417C1.70901 5.77676 1.98882 5.77676 2.16139 5.60417L4.47096 3.29463C4.63371 3.13192 4.63371 2.86809 4.47096 2.70538L2.16139 0.395812C1.98883 0.22325 1.70901 0.22325 1.53642 0.395812C1.36383 0.568437 1.36383 0.84825 1.53642 1.02081L3.27989 2.76429C3.41006 2.89446 3.41006 3.10554 3.27989 3.23571Z'/%3e%3c/svg%3e\");\n  mask-image: url(\"data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 6 6' fill='var%28--bs-gray-300%29'%3e%3cpath d='M3.27989 3.23571L1.53642 4.97917C1.36382 5.15176 1.36383 5.43158 1.53642 5.60417C1.70901 5.77676 1.98882 5.77676 2.16139 5.60417L4.47096 3.29463C4.63371 3.13192 4.63371 2.86809 4.47096 2.70538L2.16139 0.395812C1.98883 0.22325 1.70901 0.22325 1.53642 0.395812C1.36383 0.568437 1.36383 0.84825 1.53642 1.02081L3.27989 2.76429C3.41006 2.89446 3.41006 3.10554 3.27989 3.23571Z'/%3e%3c/svg%3e\");\n  /*rtl:end:remove*/\n}\n\n.menu-title-gray-300 .menu-item .menu-link {\n  color: var(--bs-text-gray-300);\n}\n.menu-title-gray-300 .menu-item .menu-link .menu-title {\n  color: var(--bs-text-gray-300);\n}\n\n.menu-icon-gray-300 .menu-item .menu-link .menu-icon,\n.menu-icon-gray-300 .menu-item .menu-link .menu-icon .svg-icon,\n.menu-icon-gray-300 .menu-item .menu-link .menu-icon i {\n  color: var(--bs-text-gray-300);\n}\n\n.menu-bullet-gray-300 .menu-item .menu-link .menu-bullet .bullet {\n  background-color: var(--bs-text-gray-300);\n}\n\n.menu-arrow-gray-300 .menu-item .menu-link .menu-arrow:after {\n  mask-repeat: no-repeat;\n  mask-position: center;\n  -webkit-mask-repeat: no-repeat;\n  -webkit-mask-position: center;\n  background-color: var(--bs-text-gray-300);\n  -webkit-mask-image: url(\"data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 6 6' fill='var%28--bs-text-gray-300%29'%3e%3cpath d='M2.72011 2.76429L4.46358 1.02083C4.63618 0.848244 4.63617 0.568419 4.46358 0.395831C4.29099 0.223244 4.01118 0.223244 3.83861 0.395831L1.52904 2.70537C1.36629 2.86808 1.36629 3.13191 1.52904 3.29462L3.83861 5.60419C4.01117 5.77675 4.29099 5.77675 4.46358 5.60419C4.63617 5.43156 4.63617 5.15175 4.46358 4.97919L2.72011 3.23571C2.58994 3.10554 2.58994 2.89446 2.72011 2.76429Z'/%3e%3c/svg%3e\");\n  mask-image: url(\"data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 6 6' fill='var%28--bs-text-gray-300%29'%3e%3cpath d='M2.72011 2.76429L4.46358 1.02083C4.63618 0.848244 4.63617 0.568419 4.46358 0.395831C4.29099 0.223244 4.01118 0.223244 3.83861 0.395831L1.52904 2.70537C1.36629 2.86808 1.36629 3.13191 1.52904 3.29462L3.83861 5.60419C4.01117 5.77675 4.29099 5.77675 4.46358 5.60419C4.63617 5.43156 4.63617 5.15175 4.46358 4.97919L2.72011 3.23571C2.58994 3.10554 2.58994 2.89446 2.72011 2.76429Z'/%3e%3c/svg%3e\");\n  /*rtl:begin:remove*/\n  mask-repeat: no-repeat;\n  mask-position: center;\n  -webkit-mask-repeat: no-repeat;\n  -webkit-mask-position: center;\n  background-color: var(--bs-text-gray-300);\n  -webkit-mask-image: url(\"data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 6 6' fill='var%28--bs-text-gray-300%29'%3e%3cpath d='M3.27989 3.23571L1.53642 4.97917C1.36382 5.15176 1.36383 5.43158 1.53642 5.60417C1.70901 5.77676 1.98882 5.77676 2.16139 5.60417L4.47096 3.29463C4.63371 3.13192 4.63371 2.86809 4.47096 2.70538L2.16139 0.395812C1.98883 0.22325 1.70901 0.22325 1.53642 0.395812C1.36383 0.568437 1.36383 0.84825 1.53642 1.02081L3.27989 2.76429C3.41006 2.89446 3.41006 3.10554 3.27989 3.23571Z'/%3e%3c/svg%3e\");\n  mask-image: url(\"data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 6 6' fill='var%28--bs-text-gray-300%29'%3e%3cpath d='M3.27989 3.23571L1.53642 4.97917C1.36382 5.15176 1.36383 5.43158 1.53642 5.60417C1.70901 5.77676 1.98882 5.77676 2.16139 5.60417L4.47096 3.29463C4.63371 3.13192 4.63371 2.86809 4.47096 2.70538L2.16139 0.395812C1.98883 0.22325 1.70901 0.22325 1.53642 0.395812C1.36383 0.568437 1.36383 0.84825 1.53642 1.02081L3.27989 2.76429C3.41006 2.89446 3.41006 3.10554 3.27989 3.23571Z'/%3e%3c/svg%3e\");\n  /*rtl:end:remove*/\n}\n\n.menu-gray-400 .menu-item .menu-link {\n  color: var(--bs-gray-400);\n}\n.menu-gray-400 .menu-item .menu-link .menu-title {\n  color: var(--bs-gray-400);\n}\n.menu-gray-400 .menu-item .menu-link .menu-icon,\n.menu-gray-400 .menu-item .menu-link .menu-icon .svg-icon,\n.menu-gray-400 .menu-item .menu-link .menu-icon i {\n  color: var(--bs-gray-400);\n}\n.menu-gray-400 .menu-item .menu-link .menu-bullet .bullet {\n  background-color: var(--bs-gray-400);\n}\n.menu-gray-400 .menu-item .menu-link .menu-arrow:after {\n  mask-repeat: no-repeat;\n  mask-position: center;\n  -webkit-mask-repeat: no-repeat;\n  -webkit-mask-position: center;\n  background-color: var(--bs-gray-400);\n  -webkit-mask-image: url(\"data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 6 6' fill='var%28--bs-gray-400%29'%3e%3cpath d='M2.72011 2.76429L4.46358 1.02083C4.63618 0.848244 4.63617 0.568419 4.46358 0.395831C4.29099 0.223244 4.01118 0.223244 3.83861 0.395831L1.52904 2.70537C1.36629 2.86808 1.36629 3.13191 1.52904 3.29462L3.83861 5.60419C4.01117 5.77675 4.29099 5.77675 4.46358 5.60419C4.63617 5.43156 4.63617 5.15175 4.46358 4.97919L2.72011 3.23571C2.58994 3.10554 2.58994 2.89446 2.72011 2.76429Z'/%3e%3c/svg%3e\");\n  mask-image: url(\"data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 6 6' fill='var%28--bs-gray-400%29'%3e%3cpath d='M2.72011 2.76429L4.46358 1.02083C4.63618 0.848244 4.63617 0.568419 4.46358 0.395831C4.29099 0.223244 4.01118 0.223244 3.83861 0.395831L1.52904 2.70537C1.36629 2.86808 1.36629 3.13191 1.52904 3.29462L3.83861 5.60419C4.01117 5.77675 4.29099 5.77675 4.46358 5.60419C4.63617 5.43156 4.63617 5.15175 4.46358 4.97919L2.72011 3.23571C2.58994 3.10554 2.58994 2.89446 2.72011 2.76429Z'/%3e%3c/svg%3e\");\n  /*rtl:begin:remove*/\n  mask-repeat: no-repeat;\n  mask-position: center;\n  -webkit-mask-repeat: no-repeat;\n  -webkit-mask-position: center;\n  background-color: var(--bs-gray-400);\n  -webkit-mask-image: url(\"data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 6 6' fill='var%28--bs-gray-400%29'%3e%3cpath d='M3.27989 3.23571L1.53642 4.97917C1.36382 5.15176 1.36383 5.43158 1.53642 5.60417C1.70901 5.77676 1.98882 5.77676 2.16139 5.60417L4.47096 3.29463C4.63371 3.13192 4.63371 2.86809 4.47096 2.70538L2.16139 0.395812C1.98883 0.22325 1.70901 0.22325 1.53642 0.395812C1.36383 0.568437 1.36383 0.84825 1.53642 1.02081L3.27989 2.76429C3.41006 2.89446 3.41006 3.10554 3.27989 3.23571Z'/%3e%3c/svg%3e\");\n  mask-image: url(\"data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 6 6' fill='var%28--bs-gray-400%29'%3e%3cpath d='M3.27989 3.23571L1.53642 4.97917C1.36382 5.15176 1.36383 5.43158 1.53642 5.60417C1.70901 5.77676 1.98882 5.77676 2.16139 5.60417L4.47096 3.29463C4.63371 3.13192 4.63371 2.86809 4.47096 2.70538L2.16139 0.395812C1.98883 0.22325 1.70901 0.22325 1.53642 0.395812C1.36383 0.568437 1.36383 0.84825 1.53642 1.02081L3.27989 2.76429C3.41006 2.89446 3.41006 3.10554 3.27989 3.23571Z'/%3e%3c/svg%3e\");\n  /*rtl:end:remove*/\n}\n\n.menu-title-gray-400 .menu-item .menu-link {\n  color: var(--bs-text-gray-400);\n}\n.menu-title-gray-400 .menu-item .menu-link .menu-title {\n  color: var(--bs-text-gray-400);\n}\n\n.menu-icon-gray-400 .menu-item .menu-link .menu-icon,\n.menu-icon-gray-400 .menu-item .menu-link .menu-icon .svg-icon,\n.menu-icon-gray-400 .menu-item .menu-link .menu-icon i {\n  color: var(--bs-text-gray-400);\n}\n\n.menu-bullet-gray-400 .menu-item .menu-link .menu-bullet .bullet {\n  background-color: var(--bs-text-gray-400);\n}\n\n.menu-arrow-gray-400 .menu-item .menu-link .menu-arrow:after {\n  mask-repeat: no-repeat;\n  mask-position: center;\n  -webkit-mask-repeat: no-repeat;\n  -webkit-mask-position: center;\n  background-color: var(--bs-text-gray-400);\n  -webkit-mask-image: url(\"data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 6 6' fill='var%28--bs-text-gray-400%29'%3e%3cpath d='M2.72011 2.76429L4.46358 1.02083C4.63618 0.848244 4.63617 0.568419 4.46358 0.395831C4.29099 0.223244 4.01118 0.223244 3.83861 0.395831L1.52904 2.70537C1.36629 2.86808 1.36629 3.13191 1.52904 3.29462L3.83861 5.60419C4.01117 5.77675 4.29099 5.77675 4.46358 5.60419C4.63617 5.43156 4.63617 5.15175 4.46358 4.97919L2.72011 3.23571C2.58994 3.10554 2.58994 2.89446 2.72011 2.76429Z'/%3e%3c/svg%3e\");\n  mask-image: url(\"data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 6 6' fill='var%28--bs-text-gray-400%29'%3e%3cpath d='M2.72011 2.76429L4.46358 1.02083C4.63618 0.848244 4.63617 0.568419 4.46358 0.395831C4.29099 0.223244 4.01118 0.223244 3.83861 0.395831L1.52904 2.70537C1.36629 2.86808 1.36629 3.13191 1.52904 3.29462L3.83861 5.60419C4.01117 5.77675 4.29099 5.77675 4.46358 5.60419C4.63617 5.43156 4.63617 5.15175 4.46358 4.97919L2.72011 3.23571C2.58994 3.10554 2.58994 2.89446 2.72011 2.76429Z'/%3e%3c/svg%3e\");\n  /*rtl:begin:remove*/\n  mask-repeat: no-repeat;\n  mask-position: center;\n  -webkit-mask-repeat: no-repeat;\n  -webkit-mask-position: center;\n  background-color: var(--bs-text-gray-400);\n  -webkit-mask-image: url(\"data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 6 6' fill='var%28--bs-text-gray-400%29'%3e%3cpath d='M3.27989 3.23571L1.53642 4.97917C1.36382 5.15176 1.36383 5.43158 1.53642 5.60417C1.70901 5.77676 1.98882 5.77676 2.16139 5.60417L4.47096 3.29463C4.63371 3.13192 4.63371 2.86809 4.47096 2.70538L2.16139 0.395812C1.98883 0.22325 1.70901 0.22325 1.53642 0.395812C1.36383 0.568437 1.36383 0.84825 1.53642 1.02081L3.27989 2.76429C3.41006 2.89446 3.41006 3.10554 3.27989 3.23571Z'/%3e%3c/svg%3e\");\n  mask-image: url(\"data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 6 6' fill='var%28--bs-text-gray-400%29'%3e%3cpath d='M3.27989 3.23571L1.53642 4.97917C1.36382 5.15176 1.36383 5.43158 1.53642 5.60417C1.70901 5.77676 1.98882 5.77676 2.16139 5.60417L4.47096 3.29463C4.63371 3.13192 4.63371 2.86809 4.47096 2.70538L2.16139 0.395812C1.98883 0.22325 1.70901 0.22325 1.53642 0.395812C1.36383 0.568437 1.36383 0.84825 1.53642 1.02081L3.27989 2.76429C3.41006 2.89446 3.41006 3.10554 3.27989 3.23571Z'/%3e%3c/svg%3e\");\n  /*rtl:end:remove*/\n}\n\n.menu-gray-500 .menu-item .menu-link {\n  color: var(--bs-gray-500);\n}\n.menu-gray-500 .menu-item .menu-link .menu-title {\n  color: var(--bs-gray-500);\n}\n.menu-gray-500 .menu-item .menu-link .menu-icon,\n.menu-gray-500 .menu-item .menu-link .menu-icon .svg-icon,\n.menu-gray-500 .menu-item .menu-link .menu-icon i {\n  color: var(--bs-gray-500);\n}\n.menu-gray-500 .menu-item .menu-link .menu-bullet .bullet {\n  background-color: var(--bs-gray-500);\n}\n.menu-gray-500 .menu-item .menu-link .menu-arrow:after {\n  mask-repeat: no-repeat;\n  mask-position: center;\n  -webkit-mask-repeat: no-repeat;\n  -webkit-mask-position: center;\n  background-color: var(--bs-gray-500);\n  -webkit-mask-image: url(\"data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 6 6' fill='var%28--bs-gray-500%29'%3e%3cpath d='M2.72011 2.76429L4.46358 1.02083C4.63618 0.848244 4.63617 0.568419 4.46358 0.395831C4.29099 0.223244 4.01118 0.223244 3.83861 0.395831L1.52904 2.70537C1.36629 2.86808 1.36629 3.13191 1.52904 3.29462L3.83861 5.60419C4.01117 5.77675 4.29099 5.77675 4.46358 5.60419C4.63617 5.43156 4.63617 5.15175 4.46358 4.97919L2.72011 3.23571C2.58994 3.10554 2.58994 2.89446 2.72011 2.76429Z'/%3e%3c/svg%3e\");\n  mask-image: url(\"data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 6 6' fill='var%28--bs-gray-500%29'%3e%3cpath d='M2.72011 2.76429L4.46358 1.02083C4.63618 0.848244 4.63617 0.568419 4.46358 0.395831C4.29099 0.223244 4.01118 0.223244 3.83861 0.395831L1.52904 2.70537C1.36629 2.86808 1.36629 3.13191 1.52904 3.29462L3.83861 5.60419C4.01117 5.77675 4.29099 5.77675 4.46358 5.60419C4.63617 5.43156 4.63617 5.15175 4.46358 4.97919L2.72011 3.23571C2.58994 3.10554 2.58994 2.89446 2.72011 2.76429Z'/%3e%3c/svg%3e\");\n  /*rtl:begin:remove*/\n  mask-repeat: no-repeat;\n  mask-position: center;\n  -webkit-mask-repeat: no-repeat;\n  -webkit-mask-position: center;\n  background-color: var(--bs-gray-500);\n  -webkit-mask-image: url(\"data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 6 6' fill='var%28--bs-gray-500%29'%3e%3cpath d='M3.27989 3.23571L1.53642 4.97917C1.36382 5.15176 1.36383 5.43158 1.53642 5.60417C1.70901 5.77676 1.98882 5.77676 2.16139 5.60417L4.47096 3.29463C4.63371 3.13192 4.63371 2.86809 4.47096 2.70538L2.16139 0.395812C1.98883 0.22325 1.70901 0.22325 1.53642 0.395812C1.36383 0.568437 1.36383 0.84825 1.53642 1.02081L3.27989 2.76429C3.41006 2.89446 3.41006 3.10554 3.27989 3.23571Z'/%3e%3c/svg%3e\");\n  mask-image: url(\"data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 6 6' fill='var%28--bs-gray-500%29'%3e%3cpath d='M3.27989 3.23571L1.53642 4.97917C1.36382 5.15176 1.36383 5.43158 1.53642 5.60417C1.70901 5.77676 1.98882 5.77676 2.16139 5.60417L4.47096 3.29463C4.63371 3.13192 4.63371 2.86809 4.47096 2.70538L2.16139 0.395812C1.98883 0.22325 1.70901 0.22325 1.53642 0.395812C1.36383 0.568437 1.36383 0.84825 1.53642 1.02081L3.27989 2.76429C3.41006 2.89446 3.41006 3.10554 3.27989 3.23571Z'/%3e%3c/svg%3e\");\n  /*rtl:end:remove*/\n}\n\n.menu-title-gray-500 .menu-item .menu-link {\n  color: var(--bs-text-gray-500);\n}\n.menu-title-gray-500 .menu-item .menu-link .menu-title {\n  color: var(--bs-text-gray-500);\n}\n\n.menu-icon-gray-500 .menu-item .menu-link .menu-icon,\n.menu-icon-gray-500 .menu-item .menu-link .menu-icon .svg-icon,\n.menu-icon-gray-500 .menu-item .menu-link .menu-icon i {\n  color: var(--bs-text-gray-500);\n}\n\n.menu-bullet-gray-500 .menu-item .menu-link .menu-bullet .bullet {\n  background-color: var(--bs-text-gray-500);\n}\n\n.menu-arrow-gray-500 .menu-item .menu-link .menu-arrow:after {\n  mask-repeat: no-repeat;\n  mask-position: center;\n  -webkit-mask-repeat: no-repeat;\n  -webkit-mask-position: center;\n  background-color: var(--bs-text-gray-500);\n  -webkit-mask-image: url(\"data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 6 6' fill='var%28--bs-text-gray-500%29'%3e%3cpath d='M2.72011 2.76429L4.46358 1.02083C4.63618 0.848244 4.63617 0.568419 4.46358 0.395831C4.29099 0.223244 4.01118 0.223244 3.83861 0.395831L1.52904 2.70537C1.36629 2.86808 1.36629 3.13191 1.52904 3.29462L3.83861 5.60419C4.01117 5.77675 4.29099 5.77675 4.46358 5.60419C4.63617 5.43156 4.63617 5.15175 4.46358 4.97919L2.72011 3.23571C2.58994 3.10554 2.58994 2.89446 2.72011 2.76429Z'/%3e%3c/svg%3e\");\n  mask-image: url(\"data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 6 6' fill='var%28--bs-text-gray-500%29'%3e%3cpath d='M2.72011 2.76429L4.46358 1.02083C4.63618 0.848244 4.63617 0.568419 4.46358 0.395831C4.29099 0.223244 4.01118 0.223244 3.83861 0.395831L1.52904 2.70537C1.36629 2.86808 1.36629 3.13191 1.52904 3.29462L3.83861 5.60419C4.01117 5.77675 4.29099 5.77675 4.46358 5.60419C4.63617 5.43156 4.63617 5.15175 4.46358 4.97919L2.72011 3.23571C2.58994 3.10554 2.58994 2.89446 2.72011 2.76429Z'/%3e%3c/svg%3e\");\n  /*rtl:begin:remove*/\n  mask-repeat: no-repeat;\n  mask-position: center;\n  -webkit-mask-repeat: no-repeat;\n  -webkit-mask-position: center;\n  background-color: var(--bs-text-gray-500);\n  -webkit-mask-image: url(\"data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 6 6' fill='var%28--bs-text-gray-500%29'%3e%3cpath d='M3.27989 3.23571L1.53642 4.97917C1.36382 5.15176 1.36383 5.43158 1.53642 5.60417C1.70901 5.77676 1.98882 5.77676 2.16139 5.60417L4.47096 3.29463C4.63371 3.13192 4.63371 2.86809 4.47096 2.70538L2.16139 0.395812C1.98883 0.22325 1.70901 0.22325 1.53642 0.395812C1.36383 0.568437 1.36383 0.84825 1.53642 1.02081L3.27989 2.76429C3.41006 2.89446 3.41006 3.10554 3.27989 3.23571Z'/%3e%3c/svg%3e\");\n  mask-image: url(\"data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 6 6' fill='var%28--bs-text-gray-500%29'%3e%3cpath d='M3.27989 3.23571L1.53642 4.97917C1.36382 5.15176 1.36383 5.43158 1.53642 5.60417C1.70901 5.77676 1.98882 5.77676 2.16139 5.60417L4.47096 3.29463C4.63371 3.13192 4.63371 2.86809 4.47096 2.70538L2.16139 0.395812C1.98883 0.22325 1.70901 0.22325 1.53642 0.395812C1.36383 0.568437 1.36383 0.84825 1.53642 1.02081L3.27989 2.76429C3.41006 2.89446 3.41006 3.10554 3.27989 3.23571Z'/%3e%3c/svg%3e\");\n  /*rtl:end:remove*/\n}\n\n.menu-gray-600 .menu-item .menu-link {\n  color: var(--bs-gray-600);\n}\n.menu-gray-600 .menu-item .menu-link .menu-title {\n  color: var(--bs-gray-600);\n}\n.menu-gray-600 .menu-item .menu-link .menu-icon,\n.menu-gray-600 .menu-item .menu-link .menu-icon .svg-icon,\n.menu-gray-600 .menu-item .menu-link .menu-icon i {\n  color: var(--bs-gray-600);\n}\n.menu-gray-600 .menu-item .menu-link .menu-bullet .bullet {\n  background-color: var(--bs-gray-600);\n}\n.menu-gray-600 .menu-item .menu-link .menu-arrow:after {\n  mask-repeat: no-repeat;\n  mask-position: center;\n  -webkit-mask-repeat: no-repeat;\n  -webkit-mask-position: center;\n  background-color: var(--bs-gray-600);\n  -webkit-mask-image: url(\"data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 6 6' fill='var%28--bs-gray-600%29'%3e%3cpath d='M2.72011 2.76429L4.46358 1.02083C4.63618 0.848244 4.63617 0.568419 4.46358 0.395831C4.29099 0.223244 4.01118 0.223244 3.83861 0.395831L1.52904 2.70537C1.36629 2.86808 1.36629 3.13191 1.52904 3.29462L3.83861 5.60419C4.01117 5.77675 4.29099 5.77675 4.46358 5.60419C4.63617 5.43156 4.63617 5.15175 4.46358 4.97919L2.72011 3.23571C2.58994 3.10554 2.58994 2.89446 2.72011 2.76429Z'/%3e%3c/svg%3e\");\n  mask-image: url(\"data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 6 6' fill='var%28--bs-gray-600%29'%3e%3cpath d='M2.72011 2.76429L4.46358 1.02083C4.63618 0.848244 4.63617 0.568419 4.46358 0.395831C4.29099 0.223244 4.01118 0.223244 3.83861 0.395831L1.52904 2.70537C1.36629 2.86808 1.36629 3.13191 1.52904 3.29462L3.83861 5.60419C4.01117 5.77675 4.29099 5.77675 4.46358 5.60419C4.63617 5.43156 4.63617 5.15175 4.46358 4.97919L2.72011 3.23571C2.58994 3.10554 2.58994 2.89446 2.72011 2.76429Z'/%3e%3c/svg%3e\");\n  /*rtl:begin:remove*/\n  mask-repeat: no-repeat;\n  mask-position: center;\n  -webkit-mask-repeat: no-repeat;\n  -webkit-mask-position: center;\n  background-color: var(--bs-gray-600);\n  -webkit-mask-image: url(\"data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 6 6' fill='var%28--bs-gray-600%29'%3e%3cpath d='M3.27989 3.23571L1.53642 4.97917C1.36382 5.15176 1.36383 5.43158 1.53642 5.60417C1.70901 5.77676 1.98882 5.77676 2.16139 5.60417L4.47096 3.29463C4.63371 3.13192 4.63371 2.86809 4.47096 2.70538L2.16139 0.395812C1.98883 0.22325 1.70901 0.22325 1.53642 0.395812C1.36383 0.568437 1.36383 0.84825 1.53642 1.02081L3.27989 2.76429C3.41006 2.89446 3.41006 3.10554 3.27989 3.23571Z'/%3e%3c/svg%3e\");\n  mask-image: url(\"data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 6 6' fill='var%28--bs-gray-600%29'%3e%3cpath d='M3.27989 3.23571L1.53642 4.97917C1.36382 5.15176 1.36383 5.43158 1.53642 5.60417C1.70901 5.77676 1.98882 5.77676 2.16139 5.60417L4.47096 3.29463C4.63371 3.13192 4.63371 2.86809 4.47096 2.70538L2.16139 0.395812C1.98883 0.22325 1.70901 0.22325 1.53642 0.395812C1.36383 0.568437 1.36383 0.84825 1.53642 1.02081L3.27989 2.76429C3.41006 2.89446 3.41006 3.10554 3.27989 3.23571Z'/%3e%3c/svg%3e\");\n  /*rtl:end:remove*/\n}\n\n.menu-title-gray-600 .menu-item .menu-link {\n  color: var(--bs-text-gray-600);\n}\n.menu-title-gray-600 .menu-item .menu-link .menu-title {\n  color: var(--bs-text-gray-600);\n}\n\n.menu-icon-gray-600 .menu-item .menu-link .menu-icon,\n.menu-icon-gray-600 .menu-item .menu-link .menu-icon .svg-icon,\n.menu-icon-gray-600 .menu-item .menu-link .menu-icon i {\n  color: var(--bs-text-gray-600);\n}\n\n.menu-bullet-gray-600 .menu-item .menu-link .menu-bullet .bullet {\n  background-color: var(--bs-text-gray-600);\n}\n\n.menu-arrow-gray-600 .menu-item .menu-link .menu-arrow:after {\n  mask-repeat: no-repeat;\n  mask-position: center;\n  -webkit-mask-repeat: no-repeat;\n  -webkit-mask-position: center;\n  background-color: var(--bs-text-gray-600);\n  -webkit-mask-image: url(\"data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 6 6' fill='var%28--bs-text-gray-600%29'%3e%3cpath d='M2.72011 2.76429L4.46358 1.02083C4.63618 0.848244 4.63617 0.568419 4.46358 0.395831C4.29099 0.223244 4.01118 0.223244 3.83861 0.395831L1.52904 2.70537C1.36629 2.86808 1.36629 3.13191 1.52904 3.29462L3.83861 5.60419C4.01117 5.77675 4.29099 5.77675 4.46358 5.60419C4.63617 5.43156 4.63617 5.15175 4.46358 4.97919L2.72011 3.23571C2.58994 3.10554 2.58994 2.89446 2.72011 2.76429Z'/%3e%3c/svg%3e\");\n  mask-image: url(\"data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 6 6' fill='var%28--bs-text-gray-600%29'%3e%3cpath d='M2.72011 2.76429L4.46358 1.02083C4.63618 0.848244 4.63617 0.568419 4.46358 0.395831C4.29099 0.223244 4.01118 0.223244 3.83861 0.395831L1.52904 2.70537C1.36629 2.86808 1.36629 3.13191 1.52904 3.29462L3.83861 5.60419C4.01117 5.77675 4.29099 5.77675 4.46358 5.60419C4.63617 5.43156 4.63617 5.15175 4.46358 4.97919L2.72011 3.23571C2.58994 3.10554 2.58994 2.89446 2.72011 2.76429Z'/%3e%3c/svg%3e\");\n  /*rtl:begin:remove*/\n  mask-repeat: no-repeat;\n  mask-position: center;\n  -webkit-mask-repeat: no-repeat;\n  -webkit-mask-position: center;\n  background-color: var(--bs-text-gray-600);\n  -webkit-mask-image: url(\"data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 6 6' fill='var%28--bs-text-gray-600%29'%3e%3cpath d='M3.27989 3.23571L1.53642 4.97917C1.36382 5.15176 1.36383 5.43158 1.53642 5.60417C1.70901 5.77676 1.98882 5.77676 2.16139 5.60417L4.47096 3.29463C4.63371 3.13192 4.63371 2.86809 4.47096 2.70538L2.16139 0.395812C1.98883 0.22325 1.70901 0.22325 1.53642 0.395812C1.36383 0.568437 1.36383 0.84825 1.53642 1.02081L3.27989 2.76429C3.41006 2.89446 3.41006 3.10554 3.27989 3.23571Z'/%3e%3c/svg%3e\");\n  mask-image: url(\"data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 6 6' fill='var%28--bs-text-gray-600%29'%3e%3cpath d='M3.27989 3.23571L1.53642 4.97917C1.36382 5.15176 1.36383 5.43158 1.53642 5.60417C1.70901 5.77676 1.98882 5.77676 2.16139 5.60417L4.47096 3.29463C4.63371 3.13192 4.63371 2.86809 4.47096 2.70538L2.16139 0.395812C1.98883 0.22325 1.70901 0.22325 1.53642 0.395812C1.36383 0.568437 1.36383 0.84825 1.53642 1.02081L3.27989 2.76429C3.41006 2.89446 3.41006 3.10554 3.27989 3.23571Z'/%3e%3c/svg%3e\");\n  /*rtl:end:remove*/\n}\n\n.menu-gray-700 .menu-item .menu-link {\n  color: var(--bs-gray-700);\n}\n.menu-gray-700 .menu-item .menu-link .menu-title {\n  color: var(--bs-gray-700);\n}\n.menu-gray-700 .menu-item .menu-link .menu-icon,\n.menu-gray-700 .menu-item .menu-link .menu-icon .svg-icon,\n.menu-gray-700 .menu-item .menu-link .menu-icon i {\n  color: var(--bs-gray-700);\n}\n.menu-gray-700 .menu-item .menu-link .menu-bullet .bullet {\n  background-color: var(--bs-gray-700);\n}\n.menu-gray-700 .menu-item .menu-link .menu-arrow:after {\n  mask-repeat: no-repeat;\n  mask-position: center;\n  -webkit-mask-repeat: no-repeat;\n  -webkit-mask-position: center;\n  background-color: var(--bs-gray-700);\n  -webkit-mask-image: url(\"data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 6 6' fill='var%28--bs-gray-700%29'%3e%3cpath d='M2.72011 2.76429L4.46358 1.02083C4.63618 0.848244 4.63617 0.568419 4.46358 0.395831C4.29099 0.223244 4.01118 0.223244 3.83861 0.395831L1.52904 2.70537C1.36629 2.86808 1.36629 3.13191 1.52904 3.29462L3.83861 5.60419C4.01117 5.77675 4.29099 5.77675 4.46358 5.60419C4.63617 5.43156 4.63617 5.15175 4.46358 4.97919L2.72011 3.23571C2.58994 3.10554 2.58994 2.89446 2.72011 2.76429Z'/%3e%3c/svg%3e\");\n  mask-image: url(\"data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 6 6' fill='var%28--bs-gray-700%29'%3e%3cpath d='M2.72011 2.76429L4.46358 1.02083C4.63618 0.848244 4.63617 0.568419 4.46358 0.395831C4.29099 0.223244 4.01118 0.223244 3.83861 0.395831L1.52904 2.70537C1.36629 2.86808 1.36629 3.13191 1.52904 3.29462L3.83861 5.60419C4.01117 5.77675 4.29099 5.77675 4.46358 5.60419C4.63617 5.43156 4.63617 5.15175 4.46358 4.97919L2.72011 3.23571C2.58994 3.10554 2.58994 2.89446 2.72011 2.76429Z'/%3e%3c/svg%3e\");\n  /*rtl:begin:remove*/\n  mask-repeat: no-repeat;\n  mask-position: center;\n  -webkit-mask-repeat: no-repeat;\n  -webkit-mask-position: center;\n  background-color: var(--bs-gray-700);\n  -webkit-mask-image: url(\"data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 6 6' fill='var%28--bs-gray-700%29'%3e%3cpath d='M3.27989 3.23571L1.53642 4.97917C1.36382 5.15176 1.36383 5.43158 1.53642 5.60417C1.70901 5.77676 1.98882 5.77676 2.16139 5.60417L4.47096 3.29463C4.63371 3.13192 4.63371 2.86809 4.47096 2.70538L2.16139 0.395812C1.98883 0.22325 1.70901 0.22325 1.53642 0.395812C1.36383 0.568437 1.36383 0.84825 1.53642 1.02081L3.27989 2.76429C3.41006 2.89446 3.41006 3.10554 3.27989 3.23571Z'/%3e%3c/svg%3e\");\n  mask-image: url(\"data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 6 6' fill='var%28--bs-gray-700%29'%3e%3cpath d='M3.27989 3.23571L1.53642 4.97917C1.36382 5.15176 1.36383 5.43158 1.53642 5.60417C1.70901 5.77676 1.98882 5.77676 2.16139 5.60417L4.47096 3.29463C4.63371 3.13192 4.63371 2.86809 4.47096 2.70538L2.16139 0.395812C1.98883 0.22325 1.70901 0.22325 1.53642 0.395812C1.36383 0.568437 1.36383 0.84825 1.53642 1.02081L3.27989 2.76429C3.41006 2.89446 3.41006 3.10554 3.27989 3.23571Z'/%3e%3c/svg%3e\");\n  /*rtl:end:remove*/\n}\n\n.menu-title-gray-700 .menu-item .menu-link {\n  color: var(--bs-text-gray-700);\n}\n.menu-title-gray-700 .menu-item .menu-link .menu-title {\n  color: var(--bs-text-gray-700);\n}\n\n.menu-icon-gray-700 .menu-item .menu-link .menu-icon,\n.menu-icon-gray-700 .menu-item .menu-link .menu-icon .svg-icon,\n.menu-icon-gray-700 .menu-item .menu-link .menu-icon i {\n  color: var(--bs-text-gray-700);\n}\n\n.menu-bullet-gray-700 .menu-item .menu-link .menu-bullet .bullet {\n  background-color: var(--bs-text-gray-700);\n}\n\n.menu-arrow-gray-700 .menu-item .menu-link .menu-arrow:after {\n  mask-repeat: no-repeat;\n  mask-position: center;\n  -webkit-mask-repeat: no-repeat;\n  -webkit-mask-position: center;\n  background-color: var(--bs-text-gray-700);\n  -webkit-mask-image: url(\"data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 6 6' fill='var%28--bs-text-gray-700%29'%3e%3cpath d='M2.72011 2.76429L4.46358 1.02083C4.63618 0.848244 4.63617 0.568419 4.46358 0.395831C4.29099 0.223244 4.01118 0.223244 3.83861 0.395831L1.52904 2.70537C1.36629 2.86808 1.36629 3.13191 1.52904 3.29462L3.83861 5.60419C4.01117 5.77675 4.29099 5.77675 4.46358 5.60419C4.63617 5.43156 4.63617 5.15175 4.46358 4.97919L2.72011 3.23571C2.58994 3.10554 2.58994 2.89446 2.72011 2.76429Z'/%3e%3c/svg%3e\");\n  mask-image: url(\"data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 6 6' fill='var%28--bs-text-gray-700%29'%3e%3cpath d='M2.72011 2.76429L4.46358 1.02083C4.63618 0.848244 4.63617 0.568419 4.46358 0.395831C4.29099 0.223244 4.01118 0.223244 3.83861 0.395831L1.52904 2.70537C1.36629 2.86808 1.36629 3.13191 1.52904 3.29462L3.83861 5.60419C4.01117 5.77675 4.29099 5.77675 4.46358 5.60419C4.63617 5.43156 4.63617 5.15175 4.46358 4.97919L2.72011 3.23571C2.58994 3.10554 2.58994 2.89446 2.72011 2.76429Z'/%3e%3c/svg%3e\");\n  /*rtl:begin:remove*/\n  mask-repeat: no-repeat;\n  mask-position: center;\n  -webkit-mask-repeat: no-repeat;\n  -webkit-mask-position: center;\n  background-color: var(--bs-text-gray-700);\n  -webkit-mask-image: url(\"data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 6 6' fill='var%28--bs-text-gray-700%29'%3e%3cpath d='M3.27989 3.23571L1.53642 4.97917C1.36382 5.15176 1.36383 5.43158 1.53642 5.60417C1.70901 5.77676 1.98882 5.77676 2.16139 5.60417L4.47096 3.29463C4.63371 3.13192 4.63371 2.86809 4.47096 2.70538L2.16139 0.395812C1.98883 0.22325 1.70901 0.22325 1.53642 0.395812C1.36383 0.568437 1.36383 0.84825 1.53642 1.02081L3.27989 2.76429C3.41006 2.89446 3.41006 3.10554 3.27989 3.23571Z'/%3e%3c/svg%3e\");\n  mask-image: url(\"data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 6 6' fill='var%28--bs-text-gray-700%29'%3e%3cpath d='M3.27989 3.23571L1.53642 4.97917C1.36382 5.15176 1.36383 5.43158 1.53642 5.60417C1.70901 5.77676 1.98882 5.77676 2.16139 5.60417L4.47096 3.29463C4.63371 3.13192 4.63371 2.86809 4.47096 2.70538L2.16139 0.395812C1.98883 0.22325 1.70901 0.22325 1.53642 0.395812C1.36383 0.568437 1.36383 0.84825 1.53642 1.02081L3.27989 2.76429C3.41006 2.89446 3.41006 3.10554 3.27989 3.23571Z'/%3e%3c/svg%3e\");\n  /*rtl:end:remove*/\n}\n\n.menu-gray-800 .menu-item .menu-link {\n  color: var(--bs-gray-800);\n}\n.menu-gray-800 .menu-item .menu-link .menu-title {\n  color: var(--bs-gray-800);\n}\n.menu-gray-800 .menu-item .menu-link .menu-icon,\n.menu-gray-800 .menu-item .menu-link .menu-icon .svg-icon,\n.menu-gray-800 .menu-item .menu-link .menu-icon i {\n  color: var(--bs-gray-800);\n}\n.menu-gray-800 .menu-item .menu-link .menu-bullet .bullet {\n  background-color: var(--bs-gray-800);\n}\n.menu-gray-800 .menu-item .menu-link .menu-arrow:after {\n  mask-repeat: no-repeat;\n  mask-position: center;\n  -webkit-mask-repeat: no-repeat;\n  -webkit-mask-position: center;\n  background-color: var(--bs-gray-800);\n  -webkit-mask-image: url(\"data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 6 6' fill='var%28--bs-gray-800%29'%3e%3cpath d='M2.72011 2.76429L4.46358 1.02083C4.63618 0.848244 4.63617 0.568419 4.46358 0.395831C4.29099 0.223244 4.01118 0.223244 3.83861 0.395831L1.52904 2.70537C1.36629 2.86808 1.36629 3.13191 1.52904 3.29462L3.83861 5.60419C4.01117 5.77675 4.29099 5.77675 4.46358 5.60419C4.63617 5.43156 4.63617 5.15175 4.46358 4.97919L2.72011 3.23571C2.58994 3.10554 2.58994 2.89446 2.72011 2.76429Z'/%3e%3c/svg%3e\");\n  mask-image: url(\"data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 6 6' fill='var%28--bs-gray-800%29'%3e%3cpath d='M2.72011 2.76429L4.46358 1.02083C4.63618 0.848244 4.63617 0.568419 4.46358 0.395831C4.29099 0.223244 4.01118 0.223244 3.83861 0.395831L1.52904 2.70537C1.36629 2.86808 1.36629 3.13191 1.52904 3.29462L3.83861 5.60419C4.01117 5.77675 4.29099 5.77675 4.46358 5.60419C4.63617 5.43156 4.63617 5.15175 4.46358 4.97919L2.72011 3.23571C2.58994 3.10554 2.58994 2.89446 2.72011 2.76429Z'/%3e%3c/svg%3e\");\n  /*rtl:begin:remove*/\n  mask-repeat: no-repeat;\n  mask-position: center;\n  -webkit-mask-repeat: no-repeat;\n  -webkit-mask-position: center;\n  background-color: var(--bs-gray-800);\n  -webkit-mask-image: url(\"data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 6 6' fill='var%28--bs-gray-800%29'%3e%3cpath d='M3.27989 3.23571L1.53642 4.97917C1.36382 5.15176 1.36383 5.43158 1.53642 5.60417C1.70901 5.77676 1.98882 5.77676 2.16139 5.60417L4.47096 3.29463C4.63371 3.13192 4.63371 2.86809 4.47096 2.70538L2.16139 0.395812C1.98883 0.22325 1.70901 0.22325 1.53642 0.395812C1.36383 0.568437 1.36383 0.84825 1.53642 1.02081L3.27989 2.76429C3.41006 2.89446 3.41006 3.10554 3.27989 3.23571Z'/%3e%3c/svg%3e\");\n  mask-image: url(\"data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 6 6' fill='var%28--bs-gray-800%29'%3e%3cpath d='M3.27989 3.23571L1.53642 4.97917C1.36382 5.15176 1.36383 5.43158 1.53642 5.60417C1.70901 5.77676 1.98882 5.77676 2.16139 5.60417L4.47096 3.29463C4.63371 3.13192 4.63371 2.86809 4.47096 2.70538L2.16139 0.395812C1.98883 0.22325 1.70901 0.22325 1.53642 0.395812C1.36383 0.568437 1.36383 0.84825 1.53642 1.02081L3.27989 2.76429C3.41006 2.89446 3.41006 3.10554 3.27989 3.23571Z'/%3e%3c/svg%3e\");\n  /*rtl:end:remove*/\n}\n\n.menu-title-gray-800 .menu-item .menu-link {\n  color: var(--bs-text-gray-800);\n}\n.menu-title-gray-800 .menu-item .menu-link .menu-title {\n  color: var(--bs-text-gray-800);\n}\n\n.menu-icon-gray-800 .menu-item .menu-link .menu-icon,\n.menu-icon-gray-800 .menu-item .menu-link .menu-icon .svg-icon,\n.menu-icon-gray-800 .menu-item .menu-link .menu-icon i {\n  color: var(--bs-text-gray-800);\n}\n\n.menu-bullet-gray-800 .menu-item .menu-link .menu-bullet .bullet {\n  background-color: var(--bs-text-gray-800);\n}\n\n.menu-arrow-gray-800 .menu-item .menu-link .menu-arrow:after {\n  mask-repeat: no-repeat;\n  mask-position: center;\n  -webkit-mask-repeat: no-repeat;\n  -webkit-mask-position: center;\n  background-color: var(--bs-text-gray-800);\n  -webkit-mask-image: url(\"data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 6 6' fill='var%28--bs-text-gray-800%29'%3e%3cpath d='M2.72011 2.76429L4.46358 1.02083C4.63618 0.848244 4.63617 0.568419 4.46358 0.395831C4.29099 0.223244 4.01118 0.223244 3.83861 0.395831L1.52904 2.70537C1.36629 2.86808 1.36629 3.13191 1.52904 3.29462L3.83861 5.60419C4.01117 5.77675 4.29099 5.77675 4.46358 5.60419C4.63617 5.43156 4.63617 5.15175 4.46358 4.97919L2.72011 3.23571C2.58994 3.10554 2.58994 2.89446 2.72011 2.76429Z'/%3e%3c/svg%3e\");\n  mask-image: url(\"data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 6 6' fill='var%28--bs-text-gray-800%29'%3e%3cpath d='M2.72011 2.76429L4.46358 1.02083C4.63618 0.848244 4.63617 0.568419 4.46358 0.395831C4.29099 0.223244 4.01118 0.223244 3.83861 0.395831L1.52904 2.70537C1.36629 2.86808 1.36629 3.13191 1.52904 3.29462L3.83861 5.60419C4.01117 5.77675 4.29099 5.77675 4.46358 5.60419C4.63617 5.43156 4.63617 5.15175 4.46358 4.97919L2.72011 3.23571C2.58994 3.10554 2.58994 2.89446 2.72011 2.76429Z'/%3e%3c/svg%3e\");\n  /*rtl:begin:remove*/\n  mask-repeat: no-repeat;\n  mask-position: center;\n  -webkit-mask-repeat: no-repeat;\n  -webkit-mask-position: center;\n  background-color: var(--bs-text-gray-800);\n  -webkit-mask-image: url(\"data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 6 6' fill='var%28--bs-text-gray-800%29'%3e%3cpath d='M3.27989 3.23571L1.53642 4.97917C1.36382 5.15176 1.36383 5.43158 1.53642 5.60417C1.70901 5.77676 1.98882 5.77676 2.16139 5.60417L4.47096 3.29463C4.63371 3.13192 4.63371 2.86809 4.47096 2.70538L2.16139 0.395812C1.98883 0.22325 1.70901 0.22325 1.53642 0.395812C1.36383 0.568437 1.36383 0.84825 1.53642 1.02081L3.27989 2.76429C3.41006 2.89446 3.41006 3.10554 3.27989 3.23571Z'/%3e%3c/svg%3e\");\n  mask-image: url(\"data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 6 6' fill='var%28--bs-text-gray-800%29'%3e%3cpath d='M3.27989 3.23571L1.53642 4.97917C1.36382 5.15176 1.36383 5.43158 1.53642 5.60417C1.70901 5.77676 1.98882 5.77676 2.16139 5.60417L4.47096 3.29463C4.63371 3.13192 4.63371 2.86809 4.47096 2.70538L2.16139 0.395812C1.98883 0.22325 1.70901 0.22325 1.53642 0.395812C1.36383 0.568437 1.36383 0.84825 1.53642 1.02081L3.27989 2.76429C3.41006 2.89446 3.41006 3.10554 3.27989 3.23571Z'/%3e%3c/svg%3e\");\n  /*rtl:end:remove*/\n}\n\n.menu-gray-900 .menu-item .menu-link {\n  color: var(--bs-gray-900);\n}\n.menu-gray-900 .menu-item .menu-link .menu-title {\n  color: var(--bs-gray-900);\n}\n.menu-gray-900 .menu-item .menu-link .menu-icon,\n.menu-gray-900 .menu-item .menu-link .menu-icon .svg-icon,\n.menu-gray-900 .menu-item .menu-link .menu-icon i {\n  color: var(--bs-gray-900);\n}\n.menu-gray-900 .menu-item .menu-link .menu-bullet .bullet {\n  background-color: var(--bs-gray-900);\n}\n.menu-gray-900 .menu-item .menu-link .menu-arrow:after {\n  mask-repeat: no-repeat;\n  mask-position: center;\n  -webkit-mask-repeat: no-repeat;\n  -webkit-mask-position: center;\n  background-color: var(--bs-gray-900);\n  -webkit-mask-image: url(\"data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 6 6' fill='var%28--bs-gray-900%29'%3e%3cpath d='M2.72011 2.76429L4.46358 1.02083C4.63618 0.848244 4.63617 0.568419 4.46358 0.395831C4.29099 0.223244 4.01118 0.223244 3.83861 0.395831L1.52904 2.70537C1.36629 2.86808 1.36629 3.13191 1.52904 3.29462L3.83861 5.60419C4.01117 5.77675 4.29099 5.77675 4.46358 5.60419C4.63617 5.43156 4.63617 5.15175 4.46358 4.97919L2.72011 3.23571C2.58994 3.10554 2.58994 2.89446 2.72011 2.76429Z'/%3e%3c/svg%3e\");\n  mask-image: url(\"data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 6 6' fill='var%28--bs-gray-900%29'%3e%3cpath d='M2.72011 2.76429L4.46358 1.02083C4.63618 0.848244 4.63617 0.568419 4.46358 0.395831C4.29099 0.223244 4.01118 0.223244 3.83861 0.395831L1.52904 2.70537C1.36629 2.86808 1.36629 3.13191 1.52904 3.29462L3.83861 5.60419C4.01117 5.77675 4.29099 5.77675 4.46358 5.60419C4.63617 5.43156 4.63617 5.15175 4.46358 4.97919L2.72011 3.23571C2.58994 3.10554 2.58994 2.89446 2.72011 2.76429Z'/%3e%3c/svg%3e\");\n  /*rtl:begin:remove*/\n  mask-repeat: no-repeat;\n  mask-position: center;\n  -webkit-mask-repeat: no-repeat;\n  -webkit-mask-position: center;\n  background-color: var(--bs-gray-900);\n  -webkit-mask-image: url(\"data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 6 6' fill='var%28--bs-gray-900%29'%3e%3cpath d='M3.27989 3.23571L1.53642 4.97917C1.36382 5.15176 1.36383 5.43158 1.53642 5.60417C1.70901 5.77676 1.98882 5.77676 2.16139 5.60417L4.47096 3.29463C4.63371 3.13192 4.63371 2.86809 4.47096 2.70538L2.16139 0.395812C1.98883 0.22325 1.70901 0.22325 1.53642 0.395812C1.36383 0.568437 1.36383 0.84825 1.53642 1.02081L3.27989 2.76429C3.41006 2.89446 3.41006 3.10554 3.27989 3.23571Z'/%3e%3c/svg%3e\");\n  mask-image: url(\"data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 6 6' fill='var%28--bs-gray-900%29'%3e%3cpath d='M3.27989 3.23571L1.53642 4.97917C1.36382 5.15176 1.36383 5.43158 1.53642 5.60417C1.70901 5.77676 1.98882 5.77676 2.16139 5.60417L4.47096 3.29463C4.63371 3.13192 4.63371 2.86809 4.47096 2.70538L2.16139 0.395812C1.98883 0.22325 1.70901 0.22325 1.53642 0.395812C1.36383 0.568437 1.36383 0.84825 1.53642 1.02081L3.27989 2.76429C3.41006 2.89446 3.41006 3.10554 3.27989 3.23571Z'/%3e%3c/svg%3e\");\n  /*rtl:end:remove*/\n}\n\n.menu-title-gray-900 .menu-item .menu-link {\n  color: var(--bs-text-gray-900);\n}\n.menu-title-gray-900 .menu-item .menu-link .menu-title {\n  color: var(--bs-text-gray-900);\n}\n\n.menu-icon-gray-900 .menu-item .menu-link .menu-icon,\n.menu-icon-gray-900 .menu-item .menu-link .menu-icon .svg-icon,\n.menu-icon-gray-900 .menu-item .menu-link .menu-icon i {\n  color: var(--bs-text-gray-900);\n}\n\n.menu-bullet-gray-900 .menu-item .menu-link .menu-bullet .bullet {\n  background-color: var(--bs-text-gray-900);\n}\n\n.menu-arrow-gray-900 .menu-item .menu-link .menu-arrow:after {\n  mask-repeat: no-repeat;\n  mask-position: center;\n  -webkit-mask-repeat: no-repeat;\n  -webkit-mask-position: center;\n  background-color: var(--bs-text-gray-900);\n  -webkit-mask-image: url(\"data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 6 6' fill='var%28--bs-text-gray-900%29'%3e%3cpath d='M2.72011 2.76429L4.46358 1.02083C4.63618 0.848244 4.63617 0.568419 4.46358 0.395831C4.29099 0.223244 4.01118 0.223244 3.83861 0.395831L1.52904 2.70537C1.36629 2.86808 1.36629 3.13191 1.52904 3.29462L3.83861 5.60419C4.01117 5.77675 4.29099 5.77675 4.46358 5.60419C4.63617 5.43156 4.63617 5.15175 4.46358 4.97919L2.72011 3.23571C2.58994 3.10554 2.58994 2.89446 2.72011 2.76429Z'/%3e%3c/svg%3e\");\n  mask-image: url(\"data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 6 6' fill='var%28--bs-text-gray-900%29'%3e%3cpath d='M2.72011 2.76429L4.46358 1.02083C4.63618 0.848244 4.63617 0.568419 4.46358 0.395831C4.29099 0.223244 4.01118 0.223244 3.83861 0.395831L1.52904 2.70537C1.36629 2.86808 1.36629 3.13191 1.52904 3.29462L3.83861 5.60419C4.01117 5.77675 4.29099 5.77675 4.46358 5.60419C4.63617 5.43156 4.63617 5.15175 4.46358 4.97919L2.72011 3.23571C2.58994 3.10554 2.58994 2.89446 2.72011 2.76429Z'/%3e%3c/svg%3e\");\n  /*rtl:begin:remove*/\n  mask-repeat: no-repeat;\n  mask-position: center;\n  -webkit-mask-repeat: no-repeat;\n  -webkit-mask-position: center;\n  background-color: var(--bs-text-gray-900);\n  -webkit-mask-image: url(\"data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 6 6' fill='var%28--bs-text-gray-900%29'%3e%3cpath d='M3.27989 3.23571L1.53642 4.97917C1.36382 5.15176 1.36383 5.43158 1.53642 5.60417C1.70901 5.77676 1.98882 5.77676 2.16139 5.60417L4.47096 3.29463C4.63371 3.13192 4.63371 2.86809 4.47096 2.70538L2.16139 0.395812C1.98883 0.22325 1.70901 0.22325 1.53642 0.395812C1.36383 0.568437 1.36383 0.84825 1.53642 1.02081L3.27989 2.76429C3.41006 2.89446 3.41006 3.10554 3.27989 3.23571Z'/%3e%3c/svg%3e\");\n  mask-image: url(\"data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 6 6' fill='var%28--bs-text-gray-900%29'%3e%3cpath d='M3.27989 3.23571L1.53642 4.97917C1.36382 5.15176 1.36383 5.43158 1.53642 5.60417C1.70901 5.77676 1.98882 5.77676 2.16139 5.60417L4.47096 3.29463C4.63371 3.13192 4.63371 2.86809 4.47096 2.70538L2.16139 0.395812C1.98883 0.22325 1.70901 0.22325 1.53642 0.395812C1.36383 0.568437 1.36383 0.84825 1.53642 1.02081L3.27989 2.76429C3.41006 2.89446 3.41006 3.10554 3.27989 3.23571Z'/%3e%3c/svg%3e\");\n  /*rtl:end:remove*/\n}\n\n.menu-hover-bg .menu-item.hover:not(.here) > .menu-link:not(.disabled):not(.active):not(.here), .menu-hover-bg .menu-item:not(.here) .menu-link:hover:not(.disabled):not(.active):not(.here) {\n  transition: color 0.2s ease;\n  background-color: var(--bs-menu-link-bg-color-hover);\n  color: var(--bs-menu-link-color-hover);\n}\n.menu-hover-bg .menu-item.hover:not(.here) > .menu-link:not(.disabled):not(.active):not(.here) .menu-title, .menu-hover-bg .menu-item:not(.here) .menu-link:hover:not(.disabled):not(.active):not(.here) .menu-title {\n  color: var(--bs-menu-link-color-hover);\n}\n.menu-hover-bg .menu-item.hover:not(.here) > .menu-link:not(.disabled):not(.active):not(.here) .menu-icon,\n.menu-hover-bg .menu-item.hover:not(.here) > .menu-link:not(.disabled):not(.active):not(.here) .menu-icon .svg-icon,\n.menu-hover-bg .menu-item.hover:not(.here) > .menu-link:not(.disabled):not(.active):not(.here) .menu-icon i, .menu-hover-bg .menu-item:not(.here) .menu-link:hover:not(.disabled):not(.active):not(.here) .menu-icon,\n.menu-hover-bg .menu-item:not(.here) .menu-link:hover:not(.disabled):not(.active):not(.here) .menu-icon .svg-icon,\n.menu-hover-bg .menu-item:not(.here) .menu-link:hover:not(.disabled):not(.active):not(.here) .menu-icon i {\n  color: var(--bs-menu-link-color-hover);\n}\n.menu-hover-bg .menu-item.hover:not(.here) > .menu-link:not(.disabled):not(.active):not(.here) .menu-bullet .bullet, .menu-hover-bg .menu-item:not(.here) .menu-link:hover:not(.disabled):not(.active):not(.here) .menu-bullet .bullet {\n  background-color: var(--bs-menu-link-color-hover);\n}\n.menu-hover-bg .menu-item.hover:not(.here) > .menu-link:not(.disabled):not(.active):not(.here) .menu-arrow:after, .menu-hover-bg .menu-item:not(.here) .menu-link:hover:not(.disabled):not(.active):not(.here) .menu-arrow:after {\n  mask-repeat: no-repeat;\n  mask-position: center;\n  -webkit-mask-repeat: no-repeat;\n  -webkit-mask-position: center;\n  background-color: var(--bs-menu-link-color-hover);\n  -webkit-mask-image: url(\"data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 6 6' fill='var%28--bs-menu-link-color-hover%29'%3e%3cpath d='M2.72011 2.76429L4.46358 1.02083C4.63618 0.848244 4.63617 0.568419 4.46358 0.395831C4.29099 0.223244 4.01118 0.223244 3.83861 0.395831L1.52904 2.70537C1.36629 2.86808 1.36629 3.13191 1.52904 3.29462L3.83861 5.60419C4.01117 5.77675 4.29099 5.77675 4.46358 5.60419C4.63617 5.43156 4.63617 5.15175 4.46358 4.97919L2.72011 3.23571C2.58994 3.10554 2.58994 2.89446 2.72011 2.76429Z'/%3e%3c/svg%3e\");\n  mask-image: url(\"data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 6 6' fill='var%28--bs-menu-link-color-hover%29'%3e%3cpath d='M2.72011 2.76429L4.46358 1.02083C4.63618 0.848244 4.63617 0.568419 4.46358 0.395831C4.29099 0.223244 4.01118 0.223244 3.83861 0.395831L1.52904 2.70537C1.36629 2.86808 1.36629 3.13191 1.52904 3.29462L3.83861 5.60419C4.01117 5.77675 4.29099 5.77675 4.46358 5.60419C4.63617 5.43156 4.63617 5.15175 4.46358 4.97919L2.72011 3.23571C2.58994 3.10554 2.58994 2.89446 2.72011 2.76429Z'/%3e%3c/svg%3e\");\n  /*rtl:begin:remove*/\n  mask-repeat: no-repeat;\n  mask-position: center;\n  -webkit-mask-repeat: no-repeat;\n  -webkit-mask-position: center;\n  background-color: var(--bs-menu-link-color-hover);\n  -webkit-mask-image: url(\"data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 6 6' fill='var%28--bs-menu-link-color-hover%29'%3e%3cpath d='M3.27989 3.23571L1.53642 4.97917C1.36382 5.15176 1.36383 5.43158 1.53642 5.60417C1.70901 5.77676 1.98882 5.77676 2.16139 5.60417L4.47096 3.29463C4.63371 3.13192 4.63371 2.86809 4.47096 2.70538L2.16139 0.395812C1.98883 0.22325 1.70901 0.22325 1.53642 0.395812C1.36383 0.568437 1.36383 0.84825 1.53642 1.02081L3.27989 2.76429C3.41006 2.89446 3.41006 3.10554 3.27989 3.23571Z'/%3e%3c/svg%3e\");\n  mask-image: url(\"data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 6 6' fill='var%28--bs-menu-link-color-hover%29'%3e%3cpath d='M3.27989 3.23571L1.53642 4.97917C1.36382 5.15176 1.36383 5.43158 1.53642 5.60417C1.70901 5.77676 1.98882 5.77676 2.16139 5.60417L4.47096 3.29463C4.63371 3.13192 4.63371 2.86809 4.47096 2.70538L2.16139 0.395812C1.98883 0.22325 1.70901 0.22325 1.53642 0.395812C1.36383 0.568437 1.36383 0.84825 1.53642 1.02081L3.27989 2.76429C3.41006 2.89446 3.41006 3.10554 3.27989 3.23571Z'/%3e%3c/svg%3e\");\n  /*rtl:end:remove*/\n}\n\n.menu-here-bg .menu-item.here > .menu-link {\n  transition: color 0.2s ease;\n  background-color: var(--bs-menu-link-bg-color-here);\n  color: var(--bs-menu-link-color-here);\n}\n.menu-here-bg .menu-item.here > .menu-link .menu-title {\n  color: var(--bs-menu-link-color-here);\n}\n.menu-here-bg .menu-item.here > .menu-link .menu-icon,\n.menu-here-bg .menu-item.here > .menu-link .menu-icon .svg-icon,\n.menu-here-bg .menu-item.here > .menu-link .menu-icon i {\n  color: var(--bs-menu-link-color-here);\n}\n.menu-here-bg .menu-item.here > .menu-link .menu-bullet .bullet {\n  background-color: var(--bs-menu-link-color-here);\n}\n.menu-here-bg .menu-item.here > .menu-link .menu-arrow:after {\n  mask-repeat: no-repeat;\n  mask-position: center;\n  -webkit-mask-repeat: no-repeat;\n  -webkit-mask-position: center;\n  background-color: var(--bs-menu-link-color-here);\n  -webkit-mask-image: url(\"data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 6 6' fill='var%28--bs-menu-link-color-here%29'%3e%3cpath d='M2.72011 2.76429L4.46358 1.02083C4.63618 0.848244 4.63617 0.568419 4.46358 0.395831C4.29099 0.223244 4.01118 0.223244 3.83861 0.395831L1.52904 2.70537C1.36629 2.86808 1.36629 3.13191 1.52904 3.29462L3.83861 5.60419C4.01117 5.77675 4.29099 5.77675 4.46358 5.60419C4.63617 5.43156 4.63617 5.15175 4.46358 4.97919L2.72011 3.23571C2.58994 3.10554 2.58994 2.89446 2.72011 2.76429Z'/%3e%3c/svg%3e\");\n  mask-image: url(\"data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 6 6' fill='var%28--bs-menu-link-color-here%29'%3e%3cpath d='M2.72011 2.76429L4.46358 1.02083C4.63618 0.848244 4.63617 0.568419 4.46358 0.395831C4.29099 0.223244 4.01118 0.223244 3.83861 0.395831L1.52904 2.70537C1.36629 2.86808 1.36629 3.13191 1.52904 3.29462L3.83861 5.60419C4.01117 5.77675 4.29099 5.77675 4.46358 5.60419C4.63617 5.43156 4.63617 5.15175 4.46358 4.97919L2.72011 3.23571C2.58994 3.10554 2.58994 2.89446 2.72011 2.76429Z'/%3e%3c/svg%3e\");\n  /*rtl:begin:remove*/\n  mask-repeat: no-repeat;\n  mask-position: center;\n  -webkit-mask-repeat: no-repeat;\n  -webkit-mask-position: center;\n  background-color: var(--bs-menu-link-color-here);\n  -webkit-mask-image: url(\"data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 6 6' fill='var%28--bs-menu-link-color-here%29'%3e%3cpath d='M3.27989 3.23571L1.53642 4.97917C1.36382 5.15176 1.36383 5.43158 1.53642 5.60417C1.70901 5.77676 1.98882 5.77676 2.16139 5.60417L4.47096 3.29463C4.63371 3.13192 4.63371 2.86809 4.47096 2.70538L2.16139 0.395812C1.98883 0.22325 1.70901 0.22325 1.53642 0.395812C1.36383 0.568437 1.36383 0.84825 1.53642 1.02081L3.27989 2.76429C3.41006 2.89446 3.41006 3.10554 3.27989 3.23571Z'/%3e%3c/svg%3e\");\n  mask-image: url(\"data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 6 6' fill='var%28--bs-menu-link-color-here%29'%3e%3cpath d='M3.27989 3.23571L1.53642 4.97917C1.36382 5.15176 1.36383 5.43158 1.53642 5.60417C1.70901 5.77676 1.98882 5.77676 2.16139 5.60417L4.47096 3.29463C4.63371 3.13192 4.63371 2.86809 4.47096 2.70538L2.16139 0.395812C1.98883 0.22325 1.70901 0.22325 1.53642 0.395812C1.36383 0.568437 1.36383 0.84825 1.53642 1.02081L3.27989 2.76429C3.41006 2.89446 3.41006 3.10554 3.27989 3.23571Z'/%3e%3c/svg%3e\");\n  /*rtl:end:remove*/\n}\n\n.menu-root-here-bg > .menu-item.here > .menu-link {\n  transition: color 0.2s ease;\n  background-color: var(--bs-menu-link-bg-color-here);\n  color: var(--bs-menu-link-color-here);\n}\n.menu-root-here-bg > .menu-item.here > .menu-link .menu-title {\n  color: var(--bs-menu-link-color-here);\n}\n.menu-root-here-bg > .menu-item.here > .menu-link .menu-icon,\n.menu-root-here-bg > .menu-item.here > .menu-link .menu-icon .svg-icon,\n.menu-root-here-bg > .menu-item.here > .menu-link .menu-icon i {\n  color: var(--bs-menu-link-color-here);\n}\n.menu-root-here-bg > .menu-item.here > .menu-link .menu-bullet .bullet {\n  background-color: var(--bs-menu-link-color-here);\n}\n.menu-root-here-bg > .menu-item.here > .menu-link .menu-arrow:after {\n  mask-repeat: no-repeat;\n  mask-position: center;\n  -webkit-mask-repeat: no-repeat;\n  -webkit-mask-position: center;\n  background-color: var(--bs-menu-link-color-here);\n  -webkit-mask-image: url(\"data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 6 6' fill='var%28--bs-menu-link-color-here%29'%3e%3cpath d='M2.72011 2.76429L4.46358 1.02083C4.63618 0.848244 4.63617 0.568419 4.46358 0.395831C4.29099 0.223244 4.01118 0.223244 3.83861 0.395831L1.52904 2.70537C1.36629 2.86808 1.36629 3.13191 1.52904 3.29462L3.83861 5.60419C4.01117 5.77675 4.29099 5.77675 4.46358 5.60419C4.63617 5.43156 4.63617 5.15175 4.46358 4.97919L2.72011 3.23571C2.58994 3.10554 2.58994 2.89446 2.72011 2.76429Z'/%3e%3c/svg%3e\");\n  mask-image: url(\"data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 6 6' fill='var%28--bs-menu-link-color-here%29'%3e%3cpath d='M2.72011 2.76429L4.46358 1.02083C4.63618 0.848244 4.63617 0.568419 4.46358 0.395831C4.29099 0.223244 4.01118 0.223244 3.83861 0.395831L1.52904 2.70537C1.36629 2.86808 1.36629 3.13191 1.52904 3.29462L3.83861 5.60419C4.01117 5.77675 4.29099 5.77675 4.46358 5.60419C4.63617 5.43156 4.63617 5.15175 4.46358 4.97919L2.72011 3.23571C2.58994 3.10554 2.58994 2.89446 2.72011 2.76429Z'/%3e%3c/svg%3e\");\n  /*rtl:begin:remove*/\n  mask-repeat: no-repeat;\n  mask-position: center;\n  -webkit-mask-repeat: no-repeat;\n  -webkit-mask-position: center;\n  background-color: var(--bs-menu-link-color-here);\n  -webkit-mask-image: url(\"data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 6 6' fill='var%28--bs-menu-link-color-here%29'%3e%3cpath d='M3.27989 3.23571L1.53642 4.97917C1.36382 5.15176 1.36383 5.43158 1.53642 5.60417C1.70901 5.77676 1.98882 5.77676 2.16139 5.60417L4.47096 3.29463C4.63371 3.13192 4.63371 2.86809 4.47096 2.70538L2.16139 0.395812C1.98883 0.22325 1.70901 0.22325 1.53642 0.395812C1.36383 0.568437 1.36383 0.84825 1.53642 1.02081L3.27989 2.76429C3.41006 2.89446 3.41006 3.10554 3.27989 3.23571Z'/%3e%3c/svg%3e\");\n  mask-image: url(\"data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 6 6' fill='var%28--bs-menu-link-color-here%29'%3e%3cpath d='M3.27989 3.23571L1.53642 4.97917C1.36382 5.15176 1.36383 5.43158 1.53642 5.60417C1.70901 5.77676 1.98882 5.77676 2.16139 5.60417L4.47096 3.29463C4.63371 3.13192 4.63371 2.86809 4.47096 2.70538L2.16139 0.395812C1.98883 0.22325 1.70901 0.22325 1.53642 0.395812C1.36383 0.568437 1.36383 0.84825 1.53642 1.02081L3.27989 2.76429C3.41006 2.89446 3.41006 3.10554 3.27989 3.23571Z'/%3e%3c/svg%3e\");\n  /*rtl:end:remove*/\n}\n\n@media (min-width: 992px) {\n  .menu-root-here-bg-desktop > .menu-item.here > .menu-link {\n    transition: color 0.2s ease;\n    background-color: var(--bs-menu-link-bg-color-here);\n    color: var(--bs-menu-link-color-here);\n  }\n  .menu-root-here-bg-desktop > .menu-item.here > .menu-link .menu-title {\n    color: var(--bs-menu-link-color-here);\n  }\n  .menu-root-here-bg-desktop > .menu-item.here > .menu-link .menu-icon,\n.menu-root-here-bg-desktop > .menu-item.here > .menu-link .menu-icon .svg-icon,\n.menu-root-here-bg-desktop > .menu-item.here > .menu-link .menu-icon i {\n    color: var(--bs-menu-link-color-here);\n  }\n  .menu-root-here-bg-desktop > .menu-item.here > .menu-link .menu-bullet .bullet {\n    background-color: var(--bs-menu-link-color-here);\n  }\n  .menu-root-here-bg-desktop > .menu-item.here > .menu-link .menu-arrow:after {\n    mask-repeat: no-repeat;\n    mask-position: center;\n    -webkit-mask-repeat: no-repeat;\n    -webkit-mask-position: center;\n    background-color: var(--bs-menu-link-color-here);\n    -webkit-mask-image: url(\"data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 6 6' fill='var%28--bs-menu-link-color-here%29'%3e%3cpath d='M2.72011 2.76429L4.46358 1.02083C4.63618 0.848244 4.63617 0.568419 4.46358 0.395831C4.29099 0.223244 4.01118 0.223244 3.83861 0.395831L1.52904 2.70537C1.36629 2.86808 1.36629 3.13191 1.52904 3.29462L3.83861 5.60419C4.01117 5.77675 4.29099 5.77675 4.46358 5.60419C4.63617 5.43156 4.63617 5.15175 4.46358 4.97919L2.72011 3.23571C2.58994 3.10554 2.58994 2.89446 2.72011 2.76429Z'/%3e%3c/svg%3e\");\n    mask-image: url(\"data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 6 6' fill='var%28--bs-menu-link-color-here%29'%3e%3cpath d='M2.72011 2.76429L4.46358 1.02083C4.63618 0.848244 4.63617 0.568419 4.46358 0.395831C4.29099 0.223244 4.01118 0.223244 3.83861 0.395831L1.52904 2.70537C1.36629 2.86808 1.36629 3.13191 1.52904 3.29462L3.83861 5.60419C4.01117 5.77675 4.29099 5.77675 4.46358 5.60419C4.63617 5.43156 4.63617 5.15175 4.46358 4.97919L2.72011 3.23571C2.58994 3.10554 2.58994 2.89446 2.72011 2.76429Z'/%3e%3c/svg%3e\");\n    /*rtl:begin:remove*/\n    mask-repeat: no-repeat;\n    mask-position: center;\n    -webkit-mask-repeat: no-repeat;\n    -webkit-mask-position: center;\n    background-color: var(--bs-menu-link-color-here);\n    -webkit-mask-image: url(\"data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 6 6' fill='var%28--bs-menu-link-color-here%29'%3e%3cpath d='M3.27989 3.23571L1.53642 4.97917C1.36382 5.15176 1.36383 5.43158 1.53642 5.60417C1.70901 5.77676 1.98882 5.77676 2.16139 5.60417L4.47096 3.29463C4.63371 3.13192 4.63371 2.86809 4.47096 2.70538L2.16139 0.395812C1.98883 0.22325 1.70901 0.22325 1.53642 0.395812C1.36383 0.568437 1.36383 0.84825 1.53642 1.02081L3.27989 2.76429C3.41006 2.89446 3.41006 3.10554 3.27989 3.23571Z'/%3e%3c/svg%3e\");\n    mask-image: url(\"data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 6 6' fill='var%28--bs-menu-link-color-here%29'%3e%3cpath d='M3.27989 3.23571L1.53642 4.97917C1.36382 5.15176 1.36383 5.43158 1.53642 5.60417C1.70901 5.77676 1.98882 5.77676 2.16139 5.60417L4.47096 3.29463C4.63371 3.13192 4.63371 2.86809 4.47096 2.70538L2.16139 0.395812C1.98883 0.22325 1.70901 0.22325 1.53642 0.395812C1.36383 0.568437 1.36383 0.84825 1.53642 1.02081L3.27989 2.76429C3.41006 2.89446 3.41006 3.10554 3.27989 3.23571Z'/%3e%3c/svg%3e\");\n    /*rtl:end:remove*/\n  }\n}\n.menu-show-bg .menu-item.show > .menu-link {\n  transition: color 0.2s ease;\n  background-color: var(--bs-menu-link-bg-color-show);\n  color: var(--bs-menu-link-color-show);\n}\n.menu-show-bg .menu-item.show > .menu-link .menu-title {\n  color: var(--bs-menu-link-color-show);\n}\n.menu-show-bg .menu-item.show > .menu-link .menu-icon,\n.menu-show-bg .menu-item.show > .menu-link .menu-icon .svg-icon,\n.menu-show-bg .menu-item.show > .menu-link .menu-icon i {\n  color: var(--bs-menu-link-color-show);\n}\n.menu-show-bg .menu-item.show > .menu-link .menu-bullet .bullet {\n  background-color: var(--bs-menu-link-color-show);\n}\n.menu-show-bg .menu-item.show > .menu-link .menu-arrow:after {\n  mask-repeat: no-repeat;\n  mask-position: center;\n  -webkit-mask-repeat: no-repeat;\n  -webkit-mask-position: center;\n  background-color: var(--bs-menu-link-color-show);\n  -webkit-mask-image: url(\"data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 6 6' fill='var%28--bs-menu-link-color-show%29'%3e%3cpath d='M2.72011 2.76429L4.46358 1.02083C4.63618 0.848244 4.63617 0.568419 4.46358 0.395831C4.29099 0.223244 4.01118 0.223244 3.83861 0.395831L1.52904 2.70537C1.36629 2.86808 1.36629 3.13191 1.52904 3.29462L3.83861 5.60419C4.01117 5.77675 4.29099 5.77675 4.46358 5.60419C4.63617 5.43156 4.63617 5.15175 4.46358 4.97919L2.72011 3.23571C2.58994 3.10554 2.58994 2.89446 2.72011 2.76429Z'/%3e%3c/svg%3e\");\n  mask-image: url(\"data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 6 6' fill='var%28--bs-menu-link-color-show%29'%3e%3cpath d='M2.72011 2.76429L4.46358 1.02083C4.63618 0.848244 4.63617 0.568419 4.46358 0.395831C4.29099 0.223244 4.01118 0.223244 3.83861 0.395831L1.52904 2.70537C1.36629 2.86808 1.36629 3.13191 1.52904 3.29462L3.83861 5.60419C4.01117 5.77675 4.29099 5.77675 4.46358 5.60419C4.63617 5.43156 4.63617 5.15175 4.46358 4.97919L2.72011 3.23571C2.58994 3.10554 2.58994 2.89446 2.72011 2.76429Z'/%3e%3c/svg%3e\");\n  /*rtl:begin:remove*/\n  mask-repeat: no-repeat;\n  mask-position: center;\n  -webkit-mask-repeat: no-repeat;\n  -webkit-mask-position: center;\n  background-color: var(--bs-menu-link-color-show);\n  -webkit-mask-image: url(\"data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 6 6' fill='var%28--bs-menu-link-color-show%29'%3e%3cpath d='M3.27989 3.23571L1.53642 4.97917C1.36382 5.15176 1.36383 5.43158 1.53642 5.60417C1.70901 5.77676 1.98882 5.77676 2.16139 5.60417L4.47096 3.29463C4.63371 3.13192 4.63371 2.86809 4.47096 2.70538L2.16139 0.395812C1.98883 0.22325 1.70901 0.22325 1.53642 0.395812C1.36383 0.568437 1.36383 0.84825 1.53642 1.02081L3.27989 2.76429C3.41006 2.89446 3.41006 3.10554 3.27989 3.23571Z'/%3e%3c/svg%3e\");\n  mask-image: url(\"data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 6 6' fill='var%28--bs-menu-link-color-show%29'%3e%3cpath d='M3.27989 3.23571L1.53642 4.97917C1.36382 5.15176 1.36383 5.43158 1.53642 5.60417C1.70901 5.77676 1.98882 5.77676 2.16139 5.60417L4.47096 3.29463C4.63371 3.13192 4.63371 2.86809 4.47096 2.70538L2.16139 0.395812C1.98883 0.22325 1.70901 0.22325 1.53642 0.395812C1.36383 0.568437 1.36383 0.84825 1.53642 1.02081L3.27989 2.76429C3.41006 2.89446 3.41006 3.10554 3.27989 3.23571Z'/%3e%3c/svg%3e\");\n  /*rtl:end:remove*/\n}\n\n.menu-active-bg .menu-item .menu-link.active {\n  transition: color 0.2s ease;\n  background-color: var(--bs-menu-link-bg-color-active);\n  color: var(--bs-menu-link-color-active);\n}\n.menu-active-bg .menu-item .menu-link.active .menu-title {\n  color: var(--bs-menu-link-color-active);\n}\n.menu-active-bg .menu-item .menu-link.active .menu-icon,\n.menu-active-bg .menu-item .menu-link.active .menu-icon .svg-icon,\n.menu-active-bg .menu-item .menu-link.active .menu-icon i {\n  color: var(--bs-menu-link-color-active);\n}\n.menu-active-bg .menu-item .menu-link.active .menu-bullet .bullet {\n  background-color: var(--bs-menu-link-color-active);\n}\n.menu-active-bg .menu-item .menu-link.active .menu-arrow:after {\n  mask-repeat: no-repeat;\n  mask-position: center;\n  -webkit-mask-repeat: no-repeat;\n  -webkit-mask-position: center;\n  background-color: var(--bs-menu-link-color-active);\n  -webkit-mask-image: url(\"data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 6 6' fill='var%28--bs-menu-link-color-active%29'%3e%3cpath d='M2.72011 2.76429L4.46358 1.02083C4.63618 0.848244 4.63617 0.568419 4.46358 0.395831C4.29099 0.223244 4.01118 0.223244 3.83861 0.395831L1.52904 2.70537C1.36629 2.86808 1.36629 3.13191 1.52904 3.29462L3.83861 5.60419C4.01117 5.77675 4.29099 5.77675 4.46358 5.60419C4.63617 5.43156 4.63617 5.15175 4.46358 4.97919L2.72011 3.23571C2.58994 3.10554 2.58994 2.89446 2.72011 2.76429Z'/%3e%3c/svg%3e\");\n  mask-image: url(\"data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 6 6' fill='var%28--bs-menu-link-color-active%29'%3e%3cpath d='M2.72011 2.76429L4.46358 1.02083C4.63618 0.848244 4.63617 0.568419 4.46358 0.395831C4.29099 0.223244 4.01118 0.223244 3.83861 0.395831L1.52904 2.70537C1.36629 2.86808 1.36629 3.13191 1.52904 3.29462L3.83861 5.60419C4.01117 5.77675 4.29099 5.77675 4.46358 5.60419C4.63617 5.43156 4.63617 5.15175 4.46358 4.97919L2.72011 3.23571C2.58994 3.10554 2.58994 2.89446 2.72011 2.76429Z'/%3e%3c/svg%3e\");\n  /*rtl:begin:remove*/\n  mask-repeat: no-repeat;\n  mask-position: center;\n  -webkit-mask-repeat: no-repeat;\n  -webkit-mask-position: center;\n  background-color: var(--bs-menu-link-color-active);\n  -webkit-mask-image: url(\"data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 6 6' fill='var%28--bs-menu-link-color-active%29'%3e%3cpath d='M3.27989 3.23571L1.53642 4.97917C1.36382 5.15176 1.36383 5.43158 1.53642 5.60417C1.70901 5.77676 1.98882 5.77676 2.16139 5.60417L4.47096 3.29463C4.63371 3.13192 4.63371 2.86809 4.47096 2.70538L2.16139 0.395812C1.98883 0.22325 1.70901 0.22325 1.53642 0.395812C1.36383 0.568437 1.36383 0.84825 1.53642 1.02081L3.27989 2.76429C3.41006 2.89446 3.41006 3.10554 3.27989 3.23571Z'/%3e%3c/svg%3e\");\n  mask-image: url(\"data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 6 6' fill='var%28--bs-menu-link-color-active%29'%3e%3cpath d='M3.27989 3.23571L1.53642 4.97917C1.36382 5.15176 1.36383 5.43158 1.53642 5.60417C1.70901 5.77676 1.98882 5.77676 2.16139 5.60417L4.47096 3.29463C4.63371 3.13192 4.63371 2.86809 4.47096 2.70538L2.16139 0.395812C1.98883 0.22325 1.70901 0.22325 1.53642 0.395812C1.36383 0.568437 1.36383 0.84825 1.53642 1.02081L3.27989 2.76429C3.41006 2.89446 3.41006 3.10554 3.27989 3.23571Z'/%3e%3c/svg%3e\");\n  /*rtl:end:remove*/\n}\n\n.menu-state-bg .menu-item.hover:not(.here) > .menu-link:not(.disabled):not(.active):not(.here), .menu-state-bg .menu-item:not(.here) .menu-link:hover:not(.disabled):not(.active):not(.here) {\n  transition: color 0.2s ease;\n  background-color: var(--bs-menu-link-bg-color-hover);\n  color: var(--bs-menu-link-color-hover);\n}\n.menu-state-bg .menu-item.hover:not(.here) > .menu-link:not(.disabled):not(.active):not(.here) .menu-title, .menu-state-bg .menu-item:not(.here) .menu-link:hover:not(.disabled):not(.active):not(.here) .menu-title {\n  color: var(--bs-menu-link-color-hover);\n}\n.menu-state-bg .menu-item.hover:not(.here) > .menu-link:not(.disabled):not(.active):not(.here) .menu-icon,\n.menu-state-bg .menu-item.hover:not(.here) > .menu-link:not(.disabled):not(.active):not(.here) .menu-icon .svg-icon,\n.menu-state-bg .menu-item.hover:not(.here) > .menu-link:not(.disabled):not(.active):not(.here) .menu-icon i, .menu-state-bg .menu-item:not(.here) .menu-link:hover:not(.disabled):not(.active):not(.here) .menu-icon,\n.menu-state-bg .menu-item:not(.here) .menu-link:hover:not(.disabled):not(.active):not(.here) .menu-icon .svg-icon,\n.menu-state-bg .menu-item:not(.here) .menu-link:hover:not(.disabled):not(.active):not(.here) .menu-icon i {\n  color: var(--bs-menu-link-color-hover);\n}\n.menu-state-bg .menu-item.hover:not(.here) > .menu-link:not(.disabled):not(.active):not(.here) .menu-bullet .bullet, .menu-state-bg .menu-item:not(.here) .menu-link:hover:not(.disabled):not(.active):not(.here) .menu-bullet .bullet {\n  background-color: var(--bs-menu-link-color-hover);\n}\n.menu-state-bg .menu-item.hover:not(.here) > .menu-link:not(.disabled):not(.active):not(.here) .menu-arrow:after, .menu-state-bg .menu-item:not(.here) .menu-link:hover:not(.disabled):not(.active):not(.here) .menu-arrow:after {\n  mask-repeat: no-repeat;\n  mask-position: center;\n  -webkit-mask-repeat: no-repeat;\n  -webkit-mask-position: center;\n  background-color: var(--bs-menu-link-color-hover);\n  -webkit-mask-image: url(\"data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 6 6' fill='var%28--bs-menu-link-color-hover%29'%3e%3cpath d='M2.72011 2.76429L4.46358 1.02083C4.63618 0.848244 4.63617 0.568419 4.46358 0.395831C4.29099 0.223244 4.01118 0.223244 3.83861 0.395831L1.52904 2.70537C1.36629 2.86808 1.36629 3.13191 1.52904 3.29462L3.83861 5.60419C4.01117 5.77675 4.29099 5.77675 4.46358 5.60419C4.63617 5.43156 4.63617 5.15175 4.46358 4.97919L2.72011 3.23571C2.58994 3.10554 2.58994 2.89446 2.72011 2.76429Z'/%3e%3c/svg%3e\");\n  mask-image: url(\"data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 6 6' fill='var%28--bs-menu-link-color-hover%29'%3e%3cpath d='M2.72011 2.76429L4.46358 1.02083C4.63618 0.848244 4.63617 0.568419 4.46358 0.395831C4.29099 0.223244 4.01118 0.223244 3.83861 0.395831L1.52904 2.70537C1.36629 2.86808 1.36629 3.13191 1.52904 3.29462L3.83861 5.60419C4.01117 5.77675 4.29099 5.77675 4.46358 5.60419C4.63617 5.43156 4.63617 5.15175 4.46358 4.97919L2.72011 3.23571C2.58994 3.10554 2.58994 2.89446 2.72011 2.76429Z'/%3e%3c/svg%3e\");\n  /*rtl:begin:remove*/\n  mask-repeat: no-repeat;\n  mask-position: center;\n  -webkit-mask-repeat: no-repeat;\n  -webkit-mask-position: center;\n  background-color: var(--bs-menu-link-color-hover);\n  -webkit-mask-image: url(\"data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 6 6' fill='var%28--bs-menu-link-color-hover%29'%3e%3cpath d='M3.27989 3.23571L1.53642 4.97917C1.36382 5.15176 1.36383 5.43158 1.53642 5.60417C1.70901 5.77676 1.98882 5.77676 2.16139 5.60417L4.47096 3.29463C4.63371 3.13192 4.63371 2.86809 4.47096 2.70538L2.16139 0.395812C1.98883 0.22325 1.70901 0.22325 1.53642 0.395812C1.36383 0.568437 1.36383 0.84825 1.53642 1.02081L3.27989 2.76429C3.41006 2.89446 3.41006 3.10554 3.27989 3.23571Z'/%3e%3c/svg%3e\");\n  mask-image: url(\"data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 6 6' fill='var%28--bs-menu-link-color-hover%29'%3e%3cpath d='M3.27989 3.23571L1.53642 4.97917C1.36382 5.15176 1.36383 5.43158 1.53642 5.60417C1.70901 5.77676 1.98882 5.77676 2.16139 5.60417L4.47096 3.29463C4.63371 3.13192 4.63371 2.86809 4.47096 2.70538L2.16139 0.395812C1.98883 0.22325 1.70901 0.22325 1.53642 0.395812C1.36383 0.568437 1.36383 0.84825 1.53642 1.02081L3.27989 2.76429C3.41006 2.89446 3.41006 3.10554 3.27989 3.23571Z'/%3e%3c/svg%3e\");\n  /*rtl:end:remove*/\n}\n.menu-state-bg .menu-item.here > .menu-link {\n  transition: color 0.2s ease;\n  background-color: var(--bs-menu-link-bg-color-here);\n  color: var(--bs-menu-link-color-here);\n}\n.menu-state-bg .menu-item.here > .menu-link .menu-title {\n  color: var(--bs-menu-link-color-here);\n}\n.menu-state-bg .menu-item.here > .menu-link .menu-icon,\n.menu-state-bg .menu-item.here > .menu-link .menu-icon .svg-icon,\n.menu-state-bg .menu-item.here > .menu-link .menu-icon i {\n  color: var(--bs-menu-link-color-here);\n}\n.menu-state-bg .menu-item.here > .menu-link .menu-bullet .bullet {\n  background-color: var(--bs-menu-link-color-here);\n}\n.menu-state-bg .menu-item.here > .menu-link .menu-arrow:after {\n  mask-repeat: no-repeat;\n  mask-position: center;\n  -webkit-mask-repeat: no-repeat;\n  -webkit-mask-position: center;\n  background-color: var(--bs-menu-link-color-here);\n  -webkit-mask-image: url(\"data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 6 6' fill='var%28--bs-menu-link-color-here%29'%3e%3cpath d='M2.72011 2.76429L4.46358 1.02083C4.63618 0.848244 4.63617 0.568419 4.46358 0.395831C4.29099 0.223244 4.01118 0.223244 3.83861 0.395831L1.52904 2.70537C1.36629 2.86808 1.36629 3.13191 1.52904 3.29462L3.83861 5.60419C4.01117 5.77675 4.29099 5.77675 4.46358 5.60419C4.63617 5.43156 4.63617 5.15175 4.46358 4.97919L2.72011 3.23571C2.58994 3.10554 2.58994 2.89446 2.72011 2.76429Z'/%3e%3c/svg%3e\");\n  mask-image: url(\"data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 6 6' fill='var%28--bs-menu-link-color-here%29'%3e%3cpath d='M2.72011 2.76429L4.46358 1.02083C4.63618 0.848244 4.63617 0.568419 4.46358 0.395831C4.29099 0.223244 4.01118 0.223244 3.83861 0.395831L1.52904 2.70537C1.36629 2.86808 1.36629 3.13191 1.52904 3.29462L3.83861 5.60419C4.01117 5.77675 4.29099 5.77675 4.46358 5.60419C4.63617 5.43156 4.63617 5.15175 4.46358 4.97919L2.72011 3.23571C2.58994 3.10554 2.58994 2.89446 2.72011 2.76429Z'/%3e%3c/svg%3e\");\n  /*rtl:begin:remove*/\n  mask-repeat: no-repeat;\n  mask-position: center;\n  -webkit-mask-repeat: no-repeat;\n  -webkit-mask-position: center;\n  background-color: var(--bs-menu-link-color-here);\n  -webkit-mask-image: url(\"data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 6 6' fill='var%28--bs-menu-link-color-here%29'%3e%3cpath d='M3.27989 3.23571L1.53642 4.97917C1.36382 5.15176 1.36383 5.43158 1.53642 5.60417C1.70901 5.77676 1.98882 5.77676 2.16139 5.60417L4.47096 3.29463C4.63371 3.13192 4.63371 2.86809 4.47096 2.70538L2.16139 0.395812C1.98883 0.22325 1.70901 0.22325 1.53642 0.395812C1.36383 0.568437 1.36383 0.84825 1.53642 1.02081L3.27989 2.76429C3.41006 2.89446 3.41006 3.10554 3.27989 3.23571Z'/%3e%3c/svg%3e\");\n  mask-image: url(\"data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 6 6' fill='var%28--bs-menu-link-color-here%29'%3e%3cpath d='M3.27989 3.23571L1.53642 4.97917C1.36382 5.15176 1.36383 5.43158 1.53642 5.60417C1.70901 5.77676 1.98882 5.77676 2.16139 5.60417L4.47096 3.29463C4.63371 3.13192 4.63371 2.86809 4.47096 2.70538L2.16139 0.395812C1.98883 0.22325 1.70901 0.22325 1.53642 0.395812C1.36383 0.568437 1.36383 0.84825 1.53642 1.02081L3.27989 2.76429C3.41006 2.89446 3.41006 3.10554 3.27989 3.23571Z'/%3e%3c/svg%3e\");\n  /*rtl:end:remove*/\n}\n.menu-state-bg .menu-item.show > .menu-link {\n  transition: color 0.2s ease;\n  background-color: var(--bs-menu-link-bg-color-show);\n  color: var(--bs-menu-link-color-show);\n}\n.menu-state-bg .menu-item.show > .menu-link .menu-title {\n  color: var(--bs-menu-link-color-show);\n}\n.menu-state-bg .menu-item.show > .menu-link .menu-icon,\n.menu-state-bg .menu-item.show > .menu-link .menu-icon .svg-icon,\n.menu-state-bg .menu-item.show > .menu-link .menu-icon i {\n  color: var(--bs-menu-link-color-show);\n}\n.menu-state-bg .menu-item.show > .menu-link .menu-bullet .bullet {\n  background-color: var(--bs-menu-link-color-show);\n}\n.menu-state-bg .menu-item.show > .menu-link .menu-arrow:after {\n  mask-repeat: no-repeat;\n  mask-position: center;\n  -webkit-mask-repeat: no-repeat;\n  -webkit-mask-position: center;\n  background-color: var(--bs-menu-link-color-show);\n  -webkit-mask-image: url(\"data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 6 6' fill='var%28--bs-menu-link-color-show%29'%3e%3cpath d='M2.72011 2.76429L4.46358 1.02083C4.63618 0.848244 4.63617 0.568419 4.46358 0.395831C4.29099 0.223244 4.01118 0.223244 3.83861 0.395831L1.52904 2.70537C1.36629 2.86808 1.36629 3.13191 1.52904 3.29462L3.83861 5.60419C4.01117 5.77675 4.29099 5.77675 4.46358 5.60419C4.63617 5.43156 4.63617 5.15175 4.46358 4.97919L2.72011 3.23571C2.58994 3.10554 2.58994 2.89446 2.72011 2.76429Z'/%3e%3c/svg%3e\");\n  mask-image: url(\"data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 6 6' fill='var%28--bs-menu-link-color-show%29'%3e%3cpath d='M2.72011 2.76429L4.46358 1.02083C4.63618 0.848244 4.63617 0.568419 4.46358 0.395831C4.29099 0.223244 4.01118 0.223244 3.83861 0.395831L1.52904 2.70537C1.36629 2.86808 1.36629 3.13191 1.52904 3.29462L3.83861 5.60419C4.01117 5.77675 4.29099 5.77675 4.46358 5.60419C4.63617 5.43156 4.63617 5.15175 4.46358 4.97919L2.72011 3.23571C2.58994 3.10554 2.58994 2.89446 2.72011 2.76429Z'/%3e%3c/svg%3e\");\n  /*rtl:begin:remove*/\n  mask-repeat: no-repeat;\n  mask-position: center;\n  -webkit-mask-repeat: no-repeat;\n  -webkit-mask-position: center;\n  background-color: var(--bs-menu-link-color-show);\n  -webkit-mask-image: url(\"data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 6 6' fill='var%28--bs-menu-link-color-show%29'%3e%3cpath d='M3.27989 3.23571L1.53642 4.97917C1.36382 5.15176 1.36383 5.43158 1.53642 5.60417C1.70901 5.77676 1.98882 5.77676 2.16139 5.60417L4.47096 3.29463C4.63371 3.13192 4.63371 2.86809 4.47096 2.70538L2.16139 0.395812C1.98883 0.22325 1.70901 0.22325 1.53642 0.395812C1.36383 0.568437 1.36383 0.84825 1.53642 1.02081L3.27989 2.76429C3.41006 2.89446 3.41006 3.10554 3.27989 3.23571Z'/%3e%3c/svg%3e\");\n  mask-image: url(\"data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 6 6' fill='var%28--bs-menu-link-color-show%29'%3e%3cpath d='M3.27989 3.23571L1.53642 4.97917C1.36382 5.15176 1.36383 5.43158 1.53642 5.60417C1.70901 5.77676 1.98882 5.77676 2.16139 5.60417L4.47096 3.29463C4.63371 3.13192 4.63371 2.86809 4.47096 2.70538L2.16139 0.395812C1.98883 0.22325 1.70901 0.22325 1.53642 0.395812C1.36383 0.568437 1.36383 0.84825 1.53642 1.02081L3.27989 2.76429C3.41006 2.89446 3.41006 3.10554 3.27989 3.23571Z'/%3e%3c/svg%3e\");\n  /*rtl:end:remove*/\n}\n.menu-state-bg .menu-item .menu-link.active {\n  transition: color 0.2s ease;\n  background-color: var(--bs-menu-link-bg-color-active);\n  color: var(--bs-menu-link-color-active);\n}\n.menu-state-bg .menu-item .menu-link.active .menu-title {\n  color: var(--bs-menu-link-color-active);\n}\n.menu-state-bg .menu-item .menu-link.active .menu-icon,\n.menu-state-bg .menu-item .menu-link.active .menu-icon .svg-icon,\n.menu-state-bg .menu-item .menu-link.active .menu-icon i {\n  color: var(--bs-menu-link-color-active);\n}\n.menu-state-bg .menu-item .menu-link.active .menu-bullet .bullet {\n  background-color: var(--bs-menu-link-color-active);\n}\n.menu-state-bg .menu-item .menu-link.active .menu-arrow:after {\n  mask-repeat: no-repeat;\n  mask-position: center;\n  -webkit-mask-repeat: no-repeat;\n  -webkit-mask-position: center;\n  background-color: var(--bs-menu-link-color-active);\n  -webkit-mask-image: url(\"data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 6 6' fill='var%28--bs-menu-link-color-active%29'%3e%3cpath d='M2.72011 2.76429L4.46358 1.02083C4.63618 0.848244 4.63617 0.568419 4.46358 0.395831C4.29099 0.223244 4.01118 0.223244 3.83861 0.395831L1.52904 2.70537C1.36629 2.86808 1.36629 3.13191 1.52904 3.29462L3.83861 5.60419C4.01117 5.77675 4.29099 5.77675 4.46358 5.60419C4.63617 5.43156 4.63617 5.15175 4.46358 4.97919L2.72011 3.23571C2.58994 3.10554 2.58994 2.89446 2.72011 2.76429Z'/%3e%3c/svg%3e\");\n  mask-image: url(\"data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 6 6' fill='var%28--bs-menu-link-color-active%29'%3e%3cpath d='M2.72011 2.76429L4.46358 1.02083C4.63618 0.848244 4.63617 0.568419 4.46358 0.395831C4.29099 0.223244 4.01118 0.223244 3.83861 0.395831L1.52904 2.70537C1.36629 2.86808 1.36629 3.13191 1.52904 3.29462L3.83861 5.60419C4.01117 5.77675 4.29099 5.77675 4.46358 5.60419C4.63617 5.43156 4.63617 5.15175 4.46358 4.97919L2.72011 3.23571C2.58994 3.10554 2.58994 2.89446 2.72011 2.76429Z'/%3e%3c/svg%3e\");\n  /*rtl:begin:remove*/\n  mask-repeat: no-repeat;\n  mask-position: center;\n  -webkit-mask-repeat: no-repeat;\n  -webkit-mask-position: center;\n  background-color: var(--bs-menu-link-color-active);\n  -webkit-mask-image: url(\"data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 6 6' fill='var%28--bs-menu-link-color-active%29'%3e%3cpath d='M3.27989 3.23571L1.53642 4.97917C1.36382 5.15176 1.36383 5.43158 1.53642 5.60417C1.70901 5.77676 1.98882 5.77676 2.16139 5.60417L4.47096 3.29463C4.63371 3.13192 4.63371 2.86809 4.47096 2.70538L2.16139 0.395812C1.98883 0.22325 1.70901 0.22325 1.53642 0.395812C1.36383 0.568437 1.36383 0.84825 1.53642 1.02081L3.27989 2.76429C3.41006 2.89446 3.41006 3.10554 3.27989 3.23571Z'/%3e%3c/svg%3e\");\n  mask-image: url(\"data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 6 6' fill='var%28--bs-menu-link-color-active%29'%3e%3cpath d='M3.27989 3.23571L1.53642 4.97917C1.36382 5.15176 1.36383 5.43158 1.53642 5.60417C1.70901 5.77676 1.98882 5.77676 2.16139 5.60417L4.47096 3.29463C4.63371 3.13192 4.63371 2.86809 4.47096 2.70538L2.16139 0.395812C1.98883 0.22325 1.70901 0.22325 1.53642 0.395812C1.36383 0.568437 1.36383 0.84825 1.53642 1.02081L3.27989 2.76429C3.41006 2.89446 3.41006 3.10554 3.27989 3.23571Z'/%3e%3c/svg%3e\");\n  /*rtl:end:remove*/\n}\n\n.menu-state-color .menu-item.hover:not(.here) > .menu-link:not(.disabled):not(.active):not(.here), .menu-state-color .menu-item:not(.here) .menu-link:hover:not(.disabled):not(.active):not(.here) {\n  transition: color 0.2s ease;\n  color: var(--bs-menu-link-color-hover);\n}\n.menu-state-color .menu-item.hover:not(.here) > .menu-link:not(.disabled):not(.active):not(.here) .menu-title, .menu-state-color .menu-item:not(.here) .menu-link:hover:not(.disabled):not(.active):not(.here) .menu-title {\n  color: var(--bs-menu-link-color-hover);\n}\n.menu-state-color .menu-item.hover:not(.here) > .menu-link:not(.disabled):not(.active):not(.here) .menu-icon,\n.menu-state-color .menu-item.hover:not(.here) > .menu-link:not(.disabled):not(.active):not(.here) .menu-icon .svg-icon,\n.menu-state-color .menu-item.hover:not(.here) > .menu-link:not(.disabled):not(.active):not(.here) .menu-icon i, .menu-state-color .menu-item:not(.here) .menu-link:hover:not(.disabled):not(.active):not(.here) .menu-icon,\n.menu-state-color .menu-item:not(.here) .menu-link:hover:not(.disabled):not(.active):not(.here) .menu-icon .svg-icon,\n.menu-state-color .menu-item:not(.here) .menu-link:hover:not(.disabled):not(.active):not(.here) .menu-icon i {\n  color: var(--bs-menu-link-color-hover);\n}\n.menu-state-color .menu-item.hover:not(.here) > .menu-link:not(.disabled):not(.active):not(.here) .menu-bullet .bullet, .menu-state-color .menu-item:not(.here) .menu-link:hover:not(.disabled):not(.active):not(.here) .menu-bullet .bullet {\n  background-color: var(--bs-menu-link-color-hover);\n}\n.menu-state-color .menu-item.hover:not(.here) > .menu-link:not(.disabled):not(.active):not(.here) .menu-arrow:after, .menu-state-color .menu-item:not(.here) .menu-link:hover:not(.disabled):not(.active):not(.here) .menu-arrow:after {\n  mask-repeat: no-repeat;\n  mask-position: center;\n  -webkit-mask-repeat: no-repeat;\n  -webkit-mask-position: center;\n  background-color: var(--bs-menu-link-color-hover);\n  -webkit-mask-image: url(\"data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 6 6' fill='var%28--bs-menu-link-color-hover%29'%3e%3cpath d='M2.72011 2.76429L4.46358 1.02083C4.63618 0.848244 4.63617 0.568419 4.46358 0.395831C4.29099 0.223244 4.01118 0.223244 3.83861 0.395831L1.52904 2.70537C1.36629 2.86808 1.36629 3.13191 1.52904 3.29462L3.83861 5.60419C4.01117 5.77675 4.29099 5.77675 4.46358 5.60419C4.63617 5.43156 4.63617 5.15175 4.46358 4.97919L2.72011 3.23571C2.58994 3.10554 2.58994 2.89446 2.72011 2.76429Z'/%3e%3c/svg%3e\");\n  mask-image: url(\"data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 6 6' fill='var%28--bs-menu-link-color-hover%29'%3e%3cpath d='M2.72011 2.76429L4.46358 1.02083C4.63618 0.848244 4.63617 0.568419 4.46358 0.395831C4.29099 0.223244 4.01118 0.223244 3.83861 0.395831L1.52904 2.70537C1.36629 2.86808 1.36629 3.13191 1.52904 3.29462L3.83861 5.60419C4.01117 5.77675 4.29099 5.77675 4.46358 5.60419C4.63617 5.43156 4.63617 5.15175 4.46358 4.97919L2.72011 3.23571C2.58994 3.10554 2.58994 2.89446 2.72011 2.76429Z'/%3e%3c/svg%3e\");\n  /*rtl:begin:remove*/\n  mask-repeat: no-repeat;\n  mask-position: center;\n  -webkit-mask-repeat: no-repeat;\n  -webkit-mask-position: center;\n  background-color: var(--bs-menu-link-color-hover);\n  -webkit-mask-image: url(\"data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 6 6' fill='var%28--bs-menu-link-color-hover%29'%3e%3cpath d='M3.27989 3.23571L1.53642 4.97917C1.36382 5.15176 1.36383 5.43158 1.53642 5.60417C1.70901 5.77676 1.98882 5.77676 2.16139 5.60417L4.47096 3.29463C4.63371 3.13192 4.63371 2.86809 4.47096 2.70538L2.16139 0.395812C1.98883 0.22325 1.70901 0.22325 1.53642 0.395812C1.36383 0.568437 1.36383 0.84825 1.53642 1.02081L3.27989 2.76429C3.41006 2.89446 3.41006 3.10554 3.27989 3.23571Z'/%3e%3c/svg%3e\");\n  mask-image: url(\"data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 6 6' fill='var%28--bs-menu-link-color-hover%29'%3e%3cpath d='M3.27989 3.23571L1.53642 4.97917C1.36382 5.15176 1.36383 5.43158 1.53642 5.60417C1.70901 5.77676 1.98882 5.77676 2.16139 5.60417L4.47096 3.29463C4.63371 3.13192 4.63371 2.86809 4.47096 2.70538L2.16139 0.395812C1.98883 0.22325 1.70901 0.22325 1.53642 0.395812C1.36383 0.568437 1.36383 0.84825 1.53642 1.02081L3.27989 2.76429C3.41006 2.89446 3.41006 3.10554 3.27989 3.23571Z'/%3e%3c/svg%3e\");\n  /*rtl:end:remove*/\n}\n.menu-state-color .menu-item.here > .menu-link {\n  transition: color 0.2s ease;\n  color: var(--bs-menu-link-color-here);\n}\n.menu-state-color .menu-item.here > .menu-link .menu-title {\n  color: var(--bs-menu-link-color-here);\n}\n.menu-state-color .menu-item.here > .menu-link .menu-icon,\n.menu-state-color .menu-item.here > .menu-link .menu-icon .svg-icon,\n.menu-state-color .menu-item.here > .menu-link .menu-icon i {\n  color: var(--bs-menu-link-color-here);\n}\n.menu-state-color .menu-item.here > .menu-link .menu-bullet .bullet {\n  background-color: var(--bs-menu-link-color-here);\n}\n.menu-state-color .menu-item.here > .menu-link .menu-arrow:after {\n  mask-repeat: no-repeat;\n  mask-position: center;\n  -webkit-mask-repeat: no-repeat;\n  -webkit-mask-position: center;\n  background-color: var(--bs-menu-link-color-here);\n  -webkit-mask-image: url(\"data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 6 6' fill='var%28--bs-menu-link-color-here%29'%3e%3cpath d='M2.72011 2.76429L4.46358 1.02083C4.63618 0.848244 4.63617 0.568419 4.46358 0.395831C4.29099 0.223244 4.01118 0.223244 3.83861 0.395831L1.52904 2.70537C1.36629 2.86808 1.36629 3.13191 1.52904 3.29462L3.83861 5.60419C4.01117 5.77675 4.29099 5.77675 4.46358 5.60419C4.63617 5.43156 4.63617 5.15175 4.46358 4.97919L2.72011 3.23571C2.58994 3.10554 2.58994 2.89446 2.72011 2.76429Z'/%3e%3c/svg%3e\");\n  mask-image: url(\"data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 6 6' fill='var%28--bs-menu-link-color-here%29'%3e%3cpath d='M2.72011 2.76429L4.46358 1.02083C4.63618 0.848244 4.63617 0.568419 4.46358 0.395831C4.29099 0.223244 4.01118 0.223244 3.83861 0.395831L1.52904 2.70537C1.36629 2.86808 1.36629 3.13191 1.52904 3.29462L3.83861 5.60419C4.01117 5.77675 4.29099 5.77675 4.46358 5.60419C4.63617 5.43156 4.63617 5.15175 4.46358 4.97919L2.72011 3.23571C2.58994 3.10554 2.58994 2.89446 2.72011 2.76429Z'/%3e%3c/svg%3e\");\n  /*rtl:begin:remove*/\n  mask-repeat: no-repeat;\n  mask-position: center;\n  -webkit-mask-repeat: no-repeat;\n  -webkit-mask-position: center;\n  background-color: var(--bs-menu-link-color-here);\n  -webkit-mask-image: url(\"data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 6 6' fill='var%28--bs-menu-link-color-here%29'%3e%3cpath d='M3.27989 3.23571L1.53642 4.97917C1.36382 5.15176 1.36383 5.43158 1.53642 5.60417C1.70901 5.77676 1.98882 5.77676 2.16139 5.60417L4.47096 3.29463C4.63371 3.13192 4.63371 2.86809 4.47096 2.70538L2.16139 0.395812C1.98883 0.22325 1.70901 0.22325 1.53642 0.395812C1.36383 0.568437 1.36383 0.84825 1.53642 1.02081L3.27989 2.76429C3.41006 2.89446 3.41006 3.10554 3.27989 3.23571Z'/%3e%3c/svg%3e\");\n  mask-image: url(\"data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 6 6' fill='var%28--bs-menu-link-color-here%29'%3e%3cpath d='M3.27989 3.23571L1.53642 4.97917C1.36382 5.15176 1.36383 5.43158 1.53642 5.60417C1.70901 5.77676 1.98882 5.77676 2.16139 5.60417L4.47096 3.29463C4.63371 3.13192 4.63371 2.86809 4.47096 2.70538L2.16139 0.395812C1.98883 0.22325 1.70901 0.22325 1.53642 0.395812C1.36383 0.568437 1.36383 0.84825 1.53642 1.02081L3.27989 2.76429C3.41006 2.89446 3.41006 3.10554 3.27989 3.23571Z'/%3e%3c/svg%3e\");\n  /*rtl:end:remove*/\n}\n.menu-state-color .menu-item.show > .menu-link {\n  transition: color 0.2s ease;\n  color: var(--bs-menu-link-color-show);\n}\n.menu-state-color .menu-item.show > .menu-link .menu-title {\n  color: var(--bs-menu-link-color-show);\n}\n.menu-state-color .menu-item.show > .menu-link .menu-icon,\n.menu-state-color .menu-item.show > .menu-link .menu-icon .svg-icon,\n.menu-state-color .menu-item.show > .menu-link .menu-icon i {\n  color: var(--bs-menu-link-color-show);\n}\n.menu-state-color .menu-item.show > .menu-link .menu-bullet .bullet {\n  background-color: var(--bs-menu-link-color-show);\n}\n.menu-state-color .menu-item.show > .menu-link .menu-arrow:after {\n  mask-repeat: no-repeat;\n  mask-position: center;\n  -webkit-mask-repeat: no-repeat;\n  -webkit-mask-position: center;\n  background-color: var(--bs-menu-link-color-show);\n  -webkit-mask-image: url(\"data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 6 6' fill='var%28--bs-menu-link-color-show%29'%3e%3cpath d='M2.72011 2.76429L4.46358 1.02083C4.63618 0.848244 4.63617 0.568419 4.46358 0.395831C4.29099 0.223244 4.01118 0.223244 3.83861 0.395831L1.52904 2.70537C1.36629 2.86808 1.36629 3.13191 1.52904 3.29462L3.83861 5.60419C4.01117 5.77675 4.29099 5.77675 4.46358 5.60419C4.63617 5.43156 4.63617 5.15175 4.46358 4.97919L2.72011 3.23571C2.58994 3.10554 2.58994 2.89446 2.72011 2.76429Z'/%3e%3c/svg%3e\");\n  mask-image: url(\"data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 6 6' fill='var%28--bs-menu-link-color-show%29'%3e%3cpath d='M2.72011 2.76429L4.46358 1.02083C4.63618 0.848244 4.63617 0.568419 4.46358 0.395831C4.29099 0.223244 4.01118 0.223244 3.83861 0.395831L1.52904 2.70537C1.36629 2.86808 1.36629 3.13191 1.52904 3.29462L3.83861 5.60419C4.01117 5.77675 4.29099 5.77675 4.46358 5.60419C4.63617 5.43156 4.63617 5.15175 4.46358 4.97919L2.72011 3.23571C2.58994 3.10554 2.58994 2.89446 2.72011 2.76429Z'/%3e%3c/svg%3e\");\n  /*rtl:begin:remove*/\n  mask-repeat: no-repeat;\n  mask-position: center;\n  -webkit-mask-repeat: no-repeat;\n  -webkit-mask-position: center;\n  background-color: var(--bs-menu-link-color-show);\n  -webkit-mask-image: url(\"data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 6 6' fill='var%28--bs-menu-link-color-show%29'%3e%3cpath d='M3.27989 3.23571L1.53642 4.97917C1.36382 5.15176 1.36383 5.43158 1.53642 5.60417C1.70901 5.77676 1.98882 5.77676 2.16139 5.60417L4.47096 3.29463C4.63371 3.13192 4.63371 2.86809 4.47096 2.70538L2.16139 0.395812C1.98883 0.22325 1.70901 0.22325 1.53642 0.395812C1.36383 0.568437 1.36383 0.84825 1.53642 1.02081L3.27989 2.76429C3.41006 2.89446 3.41006 3.10554 3.27989 3.23571Z'/%3e%3c/svg%3e\");\n  mask-image: url(\"data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 6 6' fill='var%28--bs-menu-link-color-show%29'%3e%3cpath d='M3.27989 3.23571L1.53642 4.97917C1.36382 5.15176 1.36383 5.43158 1.53642 5.60417C1.70901 5.77676 1.98882 5.77676 2.16139 5.60417L4.47096 3.29463C4.63371 3.13192 4.63371 2.86809 4.47096 2.70538L2.16139 0.395812C1.98883 0.22325 1.70901 0.22325 1.53642 0.395812C1.36383 0.568437 1.36383 0.84825 1.53642 1.02081L3.27989 2.76429C3.41006 2.89446 3.41006 3.10554 3.27989 3.23571Z'/%3e%3c/svg%3e\");\n  /*rtl:end:remove*/\n}\n.menu-state-color .menu-item .menu-link.active {\n  transition: color 0.2s ease;\n  color: var(--bs-menu-link-color-active);\n}\n.menu-state-color .menu-item .menu-link.active .menu-title {\n  color: var(--bs-menu-link-color-active);\n}\n.menu-state-color .menu-item .menu-link.active .menu-icon,\n.menu-state-color .menu-item .menu-link.active .menu-icon .svg-icon,\n.menu-state-color .menu-item .menu-link.active .menu-icon i {\n  color: var(--bs-menu-link-color-active);\n}\n.menu-state-color .menu-item .menu-link.active .menu-bullet .bullet {\n  background-color: var(--bs-menu-link-color-active);\n}\n.menu-state-color .menu-item .menu-link.active .menu-arrow:after {\n  mask-repeat: no-repeat;\n  mask-position: center;\n  -webkit-mask-repeat: no-repeat;\n  -webkit-mask-position: center;\n  background-color: var(--bs-menu-link-color-active);\n  -webkit-mask-image: url(\"data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 6 6' fill='var%28--bs-menu-link-color-active%29'%3e%3cpath d='M2.72011 2.76429L4.46358 1.02083C4.63618 0.848244 4.63617 0.568419 4.46358 0.395831C4.29099 0.223244 4.01118 0.223244 3.83861 0.395831L1.52904 2.70537C1.36629 2.86808 1.36629 3.13191 1.52904 3.29462L3.83861 5.60419C4.01117 5.77675 4.29099 5.77675 4.46358 5.60419C4.63617 5.43156 4.63617 5.15175 4.46358 4.97919L2.72011 3.23571C2.58994 3.10554 2.58994 2.89446 2.72011 2.76429Z'/%3e%3c/svg%3e\");\n  mask-image: url(\"data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 6 6' fill='var%28--bs-menu-link-color-active%29'%3e%3cpath d='M2.72011 2.76429L4.46358 1.02083C4.63618 0.848244 4.63617 0.568419 4.46358 0.395831C4.29099 0.223244 4.01118 0.223244 3.83861 0.395831L1.52904 2.70537C1.36629 2.86808 1.36629 3.13191 1.52904 3.29462L3.83861 5.60419C4.01117 5.77675 4.29099 5.77675 4.46358 5.60419C4.63617 5.43156 4.63617 5.15175 4.46358 4.97919L2.72011 3.23571C2.58994 3.10554 2.58994 2.89446 2.72011 2.76429Z'/%3e%3c/svg%3e\");\n  /*rtl:begin:remove*/\n  mask-repeat: no-repeat;\n  mask-position: center;\n  -webkit-mask-repeat: no-repeat;\n  -webkit-mask-position: center;\n  background-color: var(--bs-menu-link-color-active);\n  -webkit-mask-image: url(\"data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 6 6' fill='var%28--bs-menu-link-color-active%29'%3e%3cpath d='M3.27989 3.23571L1.53642 4.97917C1.36382 5.15176 1.36383 5.43158 1.53642 5.60417C1.70901 5.77676 1.98882 5.77676 2.16139 5.60417L4.47096 3.29463C4.63371 3.13192 4.63371 2.86809 4.47096 2.70538L2.16139 0.395812C1.98883 0.22325 1.70901 0.22325 1.53642 0.395812C1.36383 0.568437 1.36383 0.84825 1.53642 1.02081L3.27989 2.76429C3.41006 2.89446 3.41006 3.10554 3.27989 3.23571Z'/%3e%3c/svg%3e\");\n  mask-image: url(\"data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 6 6' fill='var%28--bs-menu-link-color-active%29'%3e%3cpath d='M3.27989 3.23571L1.53642 4.97917C1.36382 5.15176 1.36383 5.43158 1.53642 5.60417C1.70901 5.77676 1.98882 5.77676 2.16139 5.60417L4.47096 3.29463C4.63371 3.13192 4.63371 2.86809 4.47096 2.70538L2.16139 0.395812C1.98883 0.22325 1.70901 0.22325 1.53642 0.395812C1.36383 0.568437 1.36383 0.84825 1.53642 1.02081L3.27989 2.76429C3.41006 2.89446 3.41006 3.10554 3.27989 3.23571Z'/%3e%3c/svg%3e\");\n  /*rtl:end:remove*/\n}\n\n.menu-hover-bg-primary .menu-item.hover:not(.here) > .menu-link:not(.disabled):not(.active):not(.here), .menu-hover-bg-primary .menu-item:not(.here) .menu-link:hover:not(.disabled):not(.active):not(.here) {\n  transition: color 0.2s ease;\n  background-color: var(--bs-primary);\n  color: var(--bs-primary-inverse);\n}\n.menu-hover-bg-primary .menu-item.hover:not(.here) > .menu-link:not(.disabled):not(.active):not(.here) .menu-title, .menu-hover-bg-primary .menu-item:not(.here) .menu-link:hover:not(.disabled):not(.active):not(.here) .menu-title {\n  color: var(--bs-primary-inverse);\n}\n.menu-hover-bg-primary .menu-item.hover:not(.here) > .menu-link:not(.disabled):not(.active):not(.here) .menu-icon,\n.menu-hover-bg-primary .menu-item.hover:not(.here) > .menu-link:not(.disabled):not(.active):not(.here) .menu-icon .svg-icon,\n.menu-hover-bg-primary .menu-item.hover:not(.here) > .menu-link:not(.disabled):not(.active):not(.here) .menu-icon i, .menu-hover-bg-primary .menu-item:not(.here) .menu-link:hover:not(.disabled):not(.active):not(.here) .menu-icon,\n.menu-hover-bg-primary .menu-item:not(.here) .menu-link:hover:not(.disabled):not(.active):not(.here) .menu-icon .svg-icon,\n.menu-hover-bg-primary .menu-item:not(.here) .menu-link:hover:not(.disabled):not(.active):not(.here) .menu-icon i {\n  color: var(--bs-primary-inverse);\n}\n.menu-hover-bg-primary .menu-item.hover:not(.here) > .menu-link:not(.disabled):not(.active):not(.here) .menu-bullet .bullet, .menu-hover-bg-primary .menu-item:not(.here) .menu-link:hover:not(.disabled):not(.active):not(.here) .menu-bullet .bullet {\n  background-color: var(--bs-primary-inverse);\n}\n.menu-hover-bg-primary .menu-item.hover:not(.here) > .menu-link:not(.disabled):not(.active):not(.here) .menu-arrow:after, .menu-hover-bg-primary .menu-item:not(.here) .menu-link:hover:not(.disabled):not(.active):not(.here) .menu-arrow:after {\n  mask-repeat: no-repeat;\n  mask-position: center;\n  -webkit-mask-repeat: no-repeat;\n  -webkit-mask-position: center;\n  background-color: var(--bs-primary-inverse);\n  -webkit-mask-image: url(\"data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 6 6' fill='var%28--bs-primary-inverse%29'%3e%3cpath d='M2.72011 2.76429L4.46358 1.02083C4.63618 0.848244 4.63617 0.568419 4.46358 0.395831C4.29099 0.223244 4.01118 0.223244 3.83861 0.395831L1.52904 2.70537C1.36629 2.86808 1.36629 3.13191 1.52904 3.29462L3.83861 5.60419C4.01117 5.77675 4.29099 5.77675 4.46358 5.60419C4.63617 5.43156 4.63617 5.15175 4.46358 4.97919L2.72011 3.23571C2.58994 3.10554 2.58994 2.89446 2.72011 2.76429Z'/%3e%3c/svg%3e\");\n  mask-image: url(\"data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 6 6' fill='var%28--bs-primary-inverse%29'%3e%3cpath d='M2.72011 2.76429L4.46358 1.02083C4.63618 0.848244 4.63617 0.568419 4.46358 0.395831C4.29099 0.223244 4.01118 0.223244 3.83861 0.395831L1.52904 2.70537C1.36629 2.86808 1.36629 3.13191 1.52904 3.29462L3.83861 5.60419C4.01117 5.77675 4.29099 5.77675 4.46358 5.60419C4.63617 5.43156 4.63617 5.15175 4.46358 4.97919L2.72011 3.23571C2.58994 3.10554 2.58994 2.89446 2.72011 2.76429Z'/%3e%3c/svg%3e\");\n  /*rtl:begin:remove*/\n  mask-repeat: no-repeat;\n  mask-position: center;\n  -webkit-mask-repeat: no-repeat;\n  -webkit-mask-position: center;\n  background-color: var(--bs-primary-inverse);\n  -webkit-mask-image: url(\"data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 6 6' fill='var%28--bs-primary-inverse%29'%3e%3cpath d='M3.27989 3.23571L1.53642 4.97917C1.36382 5.15176 1.36383 5.43158 1.53642 5.60417C1.70901 5.77676 1.98882 5.77676 2.16139 5.60417L4.47096 3.29463C4.63371 3.13192 4.63371 2.86809 4.47096 2.70538L2.16139 0.395812C1.98883 0.22325 1.70901 0.22325 1.53642 0.395812C1.36383 0.568437 1.36383 0.84825 1.53642 1.02081L3.27989 2.76429C3.41006 2.89446 3.41006 3.10554 3.27989 3.23571Z'/%3e%3c/svg%3e\");\n  mask-image: url(\"data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 6 6' fill='var%28--bs-primary-inverse%29'%3e%3cpath d='M3.27989 3.23571L1.53642 4.97917C1.36382 5.15176 1.36383 5.43158 1.53642 5.60417C1.70901 5.77676 1.98882 5.77676 2.16139 5.60417L4.47096 3.29463C4.63371 3.13192 4.63371 2.86809 4.47096 2.70538L2.16139 0.395812C1.98883 0.22325 1.70901 0.22325 1.53642 0.395812C1.36383 0.568437 1.36383 0.84825 1.53642 1.02081L3.27989 2.76429C3.41006 2.89446 3.41006 3.10554 3.27989 3.23571Z'/%3e%3c/svg%3e\");\n  /*rtl:end:remove*/\n}\n\n.menu-show-bg-primary .menu-item.show > .menu-link {\n  transition: color 0.2s ease;\n  background-color: var(--bs-primary);\n  color: var(--bs-primary-inverse);\n}\n.menu-show-bg-primary .menu-item.show > .menu-link .menu-title {\n  color: var(--bs-primary-inverse);\n}\n.menu-show-bg-primary .menu-item.show > .menu-link .menu-icon,\n.menu-show-bg-primary .menu-item.show > .menu-link .menu-icon .svg-icon,\n.menu-show-bg-primary .menu-item.show > .menu-link .menu-icon i {\n  color: var(--bs-primary-inverse);\n}\n.menu-show-bg-primary .menu-item.show > .menu-link .menu-bullet .bullet {\n  background-color: var(--bs-primary-inverse);\n}\n.menu-show-bg-primary .menu-item.show > .menu-link .menu-arrow:after {\n  mask-repeat: no-repeat;\n  mask-position: center;\n  -webkit-mask-repeat: no-repeat;\n  -webkit-mask-position: center;\n  background-color: var(--bs-primary-inverse);\n  -webkit-mask-image: url(\"data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 6 6' fill='var%28--bs-primary-inverse%29'%3e%3cpath d='M2.72011 2.76429L4.46358 1.02083C4.63618 0.848244 4.63617 0.568419 4.46358 0.395831C4.29099 0.223244 4.01118 0.223244 3.83861 0.395831L1.52904 2.70537C1.36629 2.86808 1.36629 3.13191 1.52904 3.29462L3.83861 5.60419C4.01117 5.77675 4.29099 5.77675 4.46358 5.60419C4.63617 5.43156 4.63617 5.15175 4.46358 4.97919L2.72011 3.23571C2.58994 3.10554 2.58994 2.89446 2.72011 2.76429Z'/%3e%3c/svg%3e\");\n  mask-image: url(\"data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 6 6' fill='var%28--bs-primary-inverse%29'%3e%3cpath d='M2.72011 2.76429L4.46358 1.02083C4.63618 0.848244 4.63617 0.568419 4.46358 0.395831C4.29099 0.223244 4.01118 0.223244 3.83861 0.395831L1.52904 2.70537C1.36629 2.86808 1.36629 3.13191 1.52904 3.29462L3.83861 5.60419C4.01117 5.77675 4.29099 5.77675 4.46358 5.60419C4.63617 5.43156 4.63617 5.15175 4.46358 4.97919L2.72011 3.23571C2.58994 3.10554 2.58994 2.89446 2.72011 2.76429Z'/%3e%3c/svg%3e\");\n  /*rtl:begin:remove*/\n  mask-repeat: no-repeat;\n  mask-position: center;\n  -webkit-mask-repeat: no-repeat;\n  -webkit-mask-position: center;\n  background-color: var(--bs-primary-inverse);\n  -webkit-mask-image: url(\"data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 6 6' fill='var%28--bs-primary-inverse%29'%3e%3cpath d='M3.27989 3.23571L1.53642 4.97917C1.36382 5.15176 1.36383 5.43158 1.53642 5.60417C1.70901 5.77676 1.98882 5.77676 2.16139 5.60417L4.47096 3.29463C4.63371 3.13192 4.63371 2.86809 4.47096 2.70538L2.16139 0.395812C1.98883 0.22325 1.70901 0.22325 1.53642 0.395812C1.36383 0.568437 1.36383 0.84825 1.53642 1.02081L3.27989 2.76429C3.41006 2.89446 3.41006 3.10554 3.27989 3.23571Z'/%3e%3c/svg%3e\");\n  mask-image: url(\"data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 6 6' fill='var%28--bs-primary-inverse%29'%3e%3cpath d='M3.27989 3.23571L1.53642 4.97917C1.36382 5.15176 1.36383 5.43158 1.53642 5.60417C1.70901 5.77676 1.98882 5.77676 2.16139 5.60417L4.47096 3.29463C4.63371 3.13192 4.63371 2.86809 4.47096 2.70538L2.16139 0.395812C1.98883 0.22325 1.70901 0.22325 1.53642 0.395812C1.36383 0.568437 1.36383 0.84825 1.53642 1.02081L3.27989 2.76429C3.41006 2.89446 3.41006 3.10554 3.27989 3.23571Z'/%3e%3c/svg%3e\");\n  /*rtl:end:remove*/\n}\n\n.menu-here-bg-primary .menu-item.here > .menu-link {\n  transition: color 0.2s ease;\n  background-color: var(--bs-primary);\n  color: var(--bs-primary-inverse);\n}\n.menu-here-bg-primary .menu-item.here > .menu-link .menu-title {\n  color: var(--bs-primary-inverse);\n}\n.menu-here-bg-primary .menu-item.here > .menu-link .menu-icon,\n.menu-here-bg-primary .menu-item.here > .menu-link .menu-icon .svg-icon,\n.menu-here-bg-primary .menu-item.here > .menu-link .menu-icon i {\n  color: var(--bs-primary-inverse);\n}\n.menu-here-bg-primary .menu-item.here > .menu-link .menu-bullet .bullet {\n  background-color: var(--bs-primary-inverse);\n}\n.menu-here-bg-primary .menu-item.here > .menu-link .menu-arrow:after {\n  mask-repeat: no-repeat;\n  mask-position: center;\n  -webkit-mask-repeat: no-repeat;\n  -webkit-mask-position: center;\n  background-color: var(--bs-primary-inverse);\n  -webkit-mask-image: url(\"data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 6 6' fill='var%28--bs-primary-inverse%29'%3e%3cpath d='M2.72011 2.76429L4.46358 1.02083C4.63618 0.848244 4.63617 0.568419 4.46358 0.395831C4.29099 0.223244 4.01118 0.223244 3.83861 0.395831L1.52904 2.70537C1.36629 2.86808 1.36629 3.13191 1.52904 3.29462L3.83861 5.60419C4.01117 5.77675 4.29099 5.77675 4.46358 5.60419C4.63617 5.43156 4.63617 5.15175 4.46358 4.97919L2.72011 3.23571C2.58994 3.10554 2.58994 2.89446 2.72011 2.76429Z'/%3e%3c/svg%3e\");\n  mask-image: url(\"data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 6 6' fill='var%28--bs-primary-inverse%29'%3e%3cpath d='M2.72011 2.76429L4.46358 1.02083C4.63618 0.848244 4.63617 0.568419 4.46358 0.395831C4.29099 0.223244 4.01118 0.223244 3.83861 0.395831L1.52904 2.70537C1.36629 2.86808 1.36629 3.13191 1.52904 3.29462L3.83861 5.60419C4.01117 5.77675 4.29099 5.77675 4.46358 5.60419C4.63617 5.43156 4.63617 5.15175 4.46358 4.97919L2.72011 3.23571C2.58994 3.10554 2.58994 2.89446 2.72011 2.76429Z'/%3e%3c/svg%3e\");\n  /*rtl:begin:remove*/\n  mask-repeat: no-repeat;\n  mask-position: center;\n  -webkit-mask-repeat: no-repeat;\n  -webkit-mask-position: center;\n  background-color: var(--bs-primary-inverse);\n  -webkit-mask-image: url(\"data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 6 6' fill='var%28--bs-primary-inverse%29'%3e%3cpath d='M3.27989 3.23571L1.53642 4.97917C1.36382 5.15176 1.36383 5.43158 1.53642 5.60417C1.70901 5.77676 1.98882 5.77676 2.16139 5.60417L4.47096 3.29463C4.63371 3.13192 4.63371 2.86809 4.47096 2.70538L2.16139 0.395812C1.98883 0.22325 1.70901 0.22325 1.53642 0.395812C1.36383 0.568437 1.36383 0.84825 1.53642 1.02081L3.27989 2.76429C3.41006 2.89446 3.41006 3.10554 3.27989 3.23571Z'/%3e%3c/svg%3e\");\n  mask-image: url(\"data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 6 6' fill='var%28--bs-primary-inverse%29'%3e%3cpath d='M3.27989 3.23571L1.53642 4.97917C1.36382 5.15176 1.36383 5.43158 1.53642 5.60417C1.70901 5.77676 1.98882 5.77676 2.16139 5.60417L4.47096 3.29463C4.63371 3.13192 4.63371 2.86809 4.47096 2.70538L2.16139 0.395812C1.98883 0.22325 1.70901 0.22325 1.53642 0.395812C1.36383 0.568437 1.36383 0.84825 1.53642 1.02081L3.27989 2.76429C3.41006 2.89446 3.41006 3.10554 3.27989 3.23571Z'/%3e%3c/svg%3e\");\n  /*rtl:end:remove*/\n}\n\n.menu-active-bg-primary .menu-item .menu-link.active {\n  transition: color 0.2s ease;\n  background-color: var(--bs-primary);\n  color: var(--bs-primary-inverse);\n}\n.menu-active-bg-primary .menu-item .menu-link.active .menu-title {\n  color: var(--bs-primary-inverse);\n}\n.menu-active-bg-primary .menu-item .menu-link.active .menu-icon,\n.menu-active-bg-primary .menu-item .menu-link.active .menu-icon .svg-icon,\n.menu-active-bg-primary .menu-item .menu-link.active .menu-icon i {\n  color: var(--bs-primary-inverse);\n}\n.menu-active-bg-primary .menu-item .menu-link.active .menu-bullet .bullet {\n  background-color: var(--bs-primary-inverse);\n}\n.menu-active-bg-primary .menu-item .menu-link.active .menu-arrow:after {\n  mask-repeat: no-repeat;\n  mask-position: center;\n  -webkit-mask-repeat: no-repeat;\n  -webkit-mask-position: center;\n  background-color: var(--bs-primary-inverse);\n  -webkit-mask-image: url(\"data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 6 6' fill='var%28--bs-primary-inverse%29'%3e%3cpath d='M2.72011 2.76429L4.46358 1.02083C4.63618 0.848244 4.63617 0.568419 4.46358 0.395831C4.29099 0.223244 4.01118 0.223244 3.83861 0.395831L1.52904 2.70537C1.36629 2.86808 1.36629 3.13191 1.52904 3.29462L3.83861 5.60419C4.01117 5.77675 4.29099 5.77675 4.46358 5.60419C4.63617 5.43156 4.63617 5.15175 4.46358 4.97919L2.72011 3.23571C2.58994 3.10554 2.58994 2.89446 2.72011 2.76429Z'/%3e%3c/svg%3e\");\n  mask-image: url(\"data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 6 6' fill='var%28--bs-primary-inverse%29'%3e%3cpath d='M2.72011 2.76429L4.46358 1.02083C4.63618 0.848244 4.63617 0.568419 4.46358 0.395831C4.29099 0.223244 4.01118 0.223244 3.83861 0.395831L1.52904 2.70537C1.36629 2.86808 1.36629 3.13191 1.52904 3.29462L3.83861 5.60419C4.01117 5.77675 4.29099 5.77675 4.46358 5.60419C4.63617 5.43156 4.63617 5.15175 4.46358 4.97919L2.72011 3.23571C2.58994 3.10554 2.58994 2.89446 2.72011 2.76429Z'/%3e%3c/svg%3e\");\n  /*rtl:begin:remove*/\n  mask-repeat: no-repeat;\n  mask-position: center;\n  -webkit-mask-repeat: no-repeat;\n  -webkit-mask-position: center;\n  background-color: var(--bs-primary-inverse);\n  -webkit-mask-image: url(\"data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 6 6' fill='var%28--bs-primary-inverse%29'%3e%3cpath d='M3.27989 3.23571L1.53642 4.97917C1.36382 5.15176 1.36383 5.43158 1.53642 5.60417C1.70901 5.77676 1.98882 5.77676 2.16139 5.60417L4.47096 3.29463C4.63371 3.13192 4.63371 2.86809 4.47096 2.70538L2.16139 0.395812C1.98883 0.22325 1.70901 0.22325 1.53642 0.395812C1.36383 0.568437 1.36383 0.84825 1.53642 1.02081L3.27989 2.76429C3.41006 2.89446 3.41006 3.10554 3.27989 3.23571Z'/%3e%3c/svg%3e\");\n  mask-image: url(\"data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 6 6' fill='var%28--bs-primary-inverse%29'%3e%3cpath d='M3.27989 3.23571L1.53642 4.97917C1.36382 5.15176 1.36383 5.43158 1.53642 5.60417C1.70901 5.77676 1.98882 5.77676 2.16139 5.60417L4.47096 3.29463C4.63371 3.13192 4.63371 2.86809 4.47096 2.70538L2.16139 0.395812C1.98883 0.22325 1.70901 0.22325 1.53642 0.395812C1.36383 0.568437 1.36383 0.84825 1.53642 1.02081L3.27989 2.76429C3.41006 2.89446 3.41006 3.10554 3.27989 3.23571Z'/%3e%3c/svg%3e\");\n  /*rtl:end:remove*/\n}\n\n.menu-state-bg-primary .menu-item.hover:not(.here) > .menu-link:not(.disabled):not(.active):not(.here), .menu-state-bg-primary .menu-item:not(.here) .menu-link:hover:not(.disabled):not(.active):not(.here) {\n  transition: color 0.2s ease;\n  background-color: var(--bs-primary);\n  color: var(--bs-primary-inverse);\n}\n.menu-state-bg-primary .menu-item.hover:not(.here) > .menu-link:not(.disabled):not(.active):not(.here) .menu-title, .menu-state-bg-primary .menu-item:not(.here) .menu-link:hover:not(.disabled):not(.active):not(.here) .menu-title {\n  color: var(--bs-primary-inverse);\n}\n.menu-state-bg-primary .menu-item.hover:not(.here) > .menu-link:not(.disabled):not(.active):not(.here) .menu-icon,\n.menu-state-bg-primary .menu-item.hover:not(.here) > .menu-link:not(.disabled):not(.active):not(.here) .menu-icon .svg-icon,\n.menu-state-bg-primary .menu-item.hover:not(.here) > .menu-link:not(.disabled):not(.active):not(.here) .menu-icon i, .menu-state-bg-primary .menu-item:not(.here) .menu-link:hover:not(.disabled):not(.active):not(.here) .menu-icon,\n.menu-state-bg-primary .menu-item:not(.here) .menu-link:hover:not(.disabled):not(.active):not(.here) .menu-icon .svg-icon,\n.menu-state-bg-primary .menu-item:not(.here) .menu-link:hover:not(.disabled):not(.active):not(.here) .menu-icon i {\n  color: var(--bs-primary-inverse);\n}\n.menu-state-bg-primary .menu-item.hover:not(.here) > .menu-link:not(.disabled):not(.active):not(.here) .menu-bullet .bullet, .menu-state-bg-primary .menu-item:not(.here) .menu-link:hover:not(.disabled):not(.active):not(.here) .menu-bullet .bullet {\n  background-color: var(--bs-primary-inverse);\n}\n.menu-state-bg-primary .menu-item.hover:not(.here) > .menu-link:not(.disabled):not(.active):not(.here) .menu-arrow:after, .menu-state-bg-primary .menu-item:not(.here) .menu-link:hover:not(.disabled):not(.active):not(.here) .menu-arrow:after {\n  mask-repeat: no-repeat;\n  mask-position: center;\n  -webkit-mask-repeat: no-repeat;\n  -webkit-mask-position: center;\n  background-color: var(--bs-primary-inverse);\n  -webkit-mask-image: url(\"data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 6 6' fill='var%28--bs-primary-inverse%29'%3e%3cpath d='M2.72011 2.76429L4.46358 1.02083C4.63618 0.848244 4.63617 0.568419 4.46358 0.395831C4.29099 0.223244 4.01118 0.223244 3.83861 0.395831L1.52904 2.70537C1.36629 2.86808 1.36629 3.13191 1.52904 3.29462L3.83861 5.60419C4.01117 5.77675 4.29099 5.77675 4.46358 5.60419C4.63617 5.43156 4.63617 5.15175 4.46358 4.97919L2.72011 3.23571C2.58994 3.10554 2.58994 2.89446 2.72011 2.76429Z'/%3e%3c/svg%3e\");\n  mask-image: url(\"data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 6 6' fill='var%28--bs-primary-inverse%29'%3e%3cpath d='M2.72011 2.76429L4.46358 1.02083C4.63618 0.848244 4.63617 0.568419 4.46358 0.395831C4.29099 0.223244 4.01118 0.223244 3.83861 0.395831L1.52904 2.70537C1.36629 2.86808 1.36629 3.13191 1.52904 3.29462L3.83861 5.60419C4.01117 5.77675 4.29099 5.77675 4.46358 5.60419C4.63617 5.43156 4.63617 5.15175 4.46358 4.97919L2.72011 3.23571C2.58994 3.10554 2.58994 2.89446 2.72011 2.76429Z'/%3e%3c/svg%3e\");\n  /*rtl:begin:remove*/\n  mask-repeat: no-repeat;\n  mask-position: center;\n  -webkit-mask-repeat: no-repeat;\n  -webkit-mask-position: center;\n  background-color: var(--bs-primary-inverse);\n  -webkit-mask-image: url(\"data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 6 6' fill='var%28--bs-primary-inverse%29'%3e%3cpath d='M3.27989 3.23571L1.53642 4.97917C1.36382 5.15176 1.36383 5.43158 1.53642 5.60417C1.70901 5.77676 1.98882 5.77676 2.16139 5.60417L4.47096 3.29463C4.63371 3.13192 4.63371 2.86809 4.47096 2.70538L2.16139 0.395812C1.98883 0.22325 1.70901 0.22325 1.53642 0.395812C1.36383 0.568437 1.36383 0.84825 1.53642 1.02081L3.27989 2.76429C3.41006 2.89446 3.41006 3.10554 3.27989 3.23571Z'/%3e%3c/svg%3e\");\n  mask-image: url(\"data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 6 6' fill='var%28--bs-primary-inverse%29'%3e%3cpath d='M3.27989 3.23571L1.53642 4.97917C1.36382 5.15176 1.36383 5.43158 1.53642 5.60417C1.70901 5.77676 1.98882 5.77676 2.16139 5.60417L4.47096 3.29463C4.63371 3.13192 4.63371 2.86809 4.47096 2.70538L2.16139 0.395812C1.98883 0.22325 1.70901 0.22325 1.53642 0.395812C1.36383 0.568437 1.36383 0.84825 1.53642 1.02081L3.27989 2.76429C3.41006 2.89446 3.41006 3.10554 3.27989 3.23571Z'/%3e%3c/svg%3e\");\n  /*rtl:end:remove*/\n}\n.menu-state-bg-primary .menu-item.show > .menu-link {\n  transition: color 0.2s ease;\n  background-color: var(--bs-primary);\n  color: var(--bs-primary-inverse);\n}\n.menu-state-bg-primary .menu-item.show > .menu-link .menu-title {\n  color: var(--bs-primary-inverse);\n}\n.menu-state-bg-primary .menu-item.show > .menu-link .menu-icon,\n.menu-state-bg-primary .menu-item.show > .menu-link .menu-icon .svg-icon,\n.menu-state-bg-primary .menu-item.show > .menu-link .menu-icon i {\n  color: var(--bs-primary-inverse);\n}\n.menu-state-bg-primary .menu-item.show > .menu-link .menu-bullet .bullet {\n  background-color: var(--bs-primary-inverse);\n}\n.menu-state-bg-primary .menu-item.show > .menu-link .menu-arrow:after {\n  mask-repeat: no-repeat;\n  mask-position: center;\n  -webkit-mask-repeat: no-repeat;\n  -webkit-mask-position: center;\n  background-color: var(--bs-primary-inverse);\n  -webkit-mask-image: url(\"data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 6 6' fill='var%28--bs-primary-inverse%29'%3e%3cpath d='M2.72011 2.76429L4.46358 1.02083C4.63618 0.848244 4.63617 0.568419 4.46358 0.395831C4.29099 0.223244 4.01118 0.223244 3.83861 0.395831L1.52904 2.70537C1.36629 2.86808 1.36629 3.13191 1.52904 3.29462L3.83861 5.60419C4.01117 5.77675 4.29099 5.77675 4.46358 5.60419C4.63617 5.43156 4.63617 5.15175 4.46358 4.97919L2.72011 3.23571C2.58994 3.10554 2.58994 2.89446 2.72011 2.76429Z'/%3e%3c/svg%3e\");\n  mask-image: url(\"data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 6 6' fill='var%28--bs-primary-inverse%29'%3e%3cpath d='M2.72011 2.76429L4.46358 1.02083C4.63618 0.848244 4.63617 0.568419 4.46358 0.395831C4.29099 0.223244 4.01118 0.223244 3.83861 0.395831L1.52904 2.70537C1.36629 2.86808 1.36629 3.13191 1.52904 3.29462L3.83861 5.60419C4.01117 5.77675 4.29099 5.77675 4.46358 5.60419C4.63617 5.43156 4.63617 5.15175 4.46358 4.97919L2.72011 3.23571C2.58994 3.10554 2.58994 2.89446 2.72011 2.76429Z'/%3e%3c/svg%3e\");\n  /*rtl:begin:remove*/\n  mask-repeat: no-repeat;\n  mask-position: center;\n  -webkit-mask-repeat: no-repeat;\n  -webkit-mask-position: center;\n  background-color: var(--bs-primary-inverse);\n  -webkit-mask-image: url(\"data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 6 6' fill='var%28--bs-primary-inverse%29'%3e%3cpath d='M3.27989 3.23571L1.53642 4.97917C1.36382 5.15176 1.36383 5.43158 1.53642 5.60417C1.70901 5.77676 1.98882 5.77676 2.16139 5.60417L4.47096 3.29463C4.63371 3.13192 4.63371 2.86809 4.47096 2.70538L2.16139 0.395812C1.98883 0.22325 1.70901 0.22325 1.53642 0.395812C1.36383 0.568437 1.36383 0.84825 1.53642 1.02081L3.27989 2.76429C3.41006 2.89446 3.41006 3.10554 3.27989 3.23571Z'/%3e%3c/svg%3e\");\n  mask-image: url(\"data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 6 6' fill='var%28--bs-primary-inverse%29'%3e%3cpath d='M3.27989 3.23571L1.53642 4.97917C1.36382 5.15176 1.36383 5.43158 1.53642 5.60417C1.70901 5.77676 1.98882 5.77676 2.16139 5.60417L4.47096 3.29463C4.63371 3.13192 4.63371 2.86809 4.47096 2.70538L2.16139 0.395812C1.98883 0.22325 1.70901 0.22325 1.53642 0.395812C1.36383 0.568437 1.36383 0.84825 1.53642 1.02081L3.27989 2.76429C3.41006 2.89446 3.41006 3.10554 3.27989 3.23571Z'/%3e%3c/svg%3e\");\n  /*rtl:end:remove*/\n}\n.menu-state-bg-primary .menu-item.here > .menu-link {\n  transition: color 0.2s ease;\n  background-color: var(--bs-primary);\n  color: var(--bs-primary-inverse);\n}\n.menu-state-bg-primary .menu-item.here > .menu-link .menu-title {\n  color: var(--bs-primary-inverse);\n}\n.menu-state-bg-primary .menu-item.here > .menu-link .menu-icon,\n.menu-state-bg-primary .menu-item.here > .menu-link .menu-icon .svg-icon,\n.menu-state-bg-primary .menu-item.here > .menu-link .menu-icon i {\n  color: var(--bs-primary-inverse);\n}\n.menu-state-bg-primary .menu-item.here > .menu-link .menu-bullet .bullet {\n  background-color: var(--bs-primary-inverse);\n}\n.menu-state-bg-primary .menu-item.here > .menu-link .menu-arrow:after {\n  mask-repeat: no-repeat;\n  mask-position: center;\n  -webkit-mask-repeat: no-repeat;\n  -webkit-mask-position: center;\n  background-color: var(--bs-primary-inverse);\n  -webkit-mask-image: url(\"data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 6 6' fill='var%28--bs-primary-inverse%29'%3e%3cpath d='M2.72011 2.76429L4.46358 1.02083C4.63618 0.848244 4.63617 0.568419 4.46358 0.395831C4.29099 0.223244 4.01118 0.223244 3.83861 0.395831L1.52904 2.70537C1.36629 2.86808 1.36629 3.13191 1.52904 3.29462L3.83861 5.60419C4.01117 5.77675 4.29099 5.77675 4.46358 5.60419C4.63617 5.43156 4.63617 5.15175 4.46358 4.97919L2.72011 3.23571C2.58994 3.10554 2.58994 2.89446 2.72011 2.76429Z'/%3e%3c/svg%3e\");\n  mask-image: url(\"data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 6 6' fill='var%28--bs-primary-inverse%29'%3e%3cpath d='M2.72011 2.76429L4.46358 1.02083C4.63618 0.848244 4.63617 0.568419 4.46358 0.395831C4.29099 0.223244 4.01118 0.223244 3.83861 0.395831L1.52904 2.70537C1.36629 2.86808 1.36629 3.13191 1.52904 3.29462L3.83861 5.60419C4.01117 5.77675 4.29099 5.77675 4.46358 5.60419C4.63617 5.43156 4.63617 5.15175 4.46358 4.97919L2.72011 3.23571C2.58994 3.10554 2.58994 2.89446 2.72011 2.76429Z'/%3e%3c/svg%3e\");\n  /*rtl:begin:remove*/\n  mask-repeat: no-repeat;\n  mask-position: center;\n  -webkit-mask-repeat: no-repeat;\n  -webkit-mask-position: center;\n  background-color: var(--bs-primary-inverse);\n  -webkit-mask-image: url(\"data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 6 6' fill='var%28--bs-primary-inverse%29'%3e%3cpath d='M3.27989 3.23571L1.53642 4.97917C1.36382 5.15176 1.36383 5.43158 1.53642 5.60417C1.70901 5.77676 1.98882 5.77676 2.16139 5.60417L4.47096 3.29463C4.63371 3.13192 4.63371 2.86809 4.47096 2.70538L2.16139 0.395812C1.98883 0.22325 1.70901 0.22325 1.53642 0.395812C1.36383 0.568437 1.36383 0.84825 1.53642 1.02081L3.27989 2.76429C3.41006 2.89446 3.41006 3.10554 3.27989 3.23571Z'/%3e%3c/svg%3e\");\n  mask-image: url(\"data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 6 6' fill='var%28--bs-primary-inverse%29'%3e%3cpath d='M3.27989 3.23571L1.53642 4.97917C1.36382 5.15176 1.36383 5.43158 1.53642 5.60417C1.70901 5.77676 1.98882 5.77676 2.16139 5.60417L4.47096 3.29463C4.63371 3.13192 4.63371 2.86809 4.47096 2.70538L2.16139 0.395812C1.98883 0.22325 1.70901 0.22325 1.53642 0.395812C1.36383 0.568437 1.36383 0.84825 1.53642 1.02081L3.27989 2.76429C3.41006 2.89446 3.41006 3.10554 3.27989 3.23571Z'/%3e%3c/svg%3e\");\n  /*rtl:end:remove*/\n}\n.menu-state-bg-primary .menu-item .menu-link.active {\n  transition: color 0.2s ease;\n  background-color: var(--bs-primary);\n  color: var(--bs-primary-inverse);\n}\n.menu-state-bg-primary .menu-item .menu-link.active .menu-title {\n  color: var(--bs-primary-inverse);\n}\n.menu-state-bg-primary .menu-item .menu-link.active .menu-icon,\n.menu-state-bg-primary .menu-item .menu-link.active .menu-icon .svg-icon,\n.menu-state-bg-primary .menu-item .menu-link.active .menu-icon i {\n  color: var(--bs-primary-inverse);\n}\n.menu-state-bg-primary .menu-item .menu-link.active .menu-bullet .bullet {\n  background-color: var(--bs-primary-inverse);\n}\n.menu-state-bg-primary .menu-item .menu-link.active .menu-arrow:after {\n  mask-repeat: no-repeat;\n  mask-position: center;\n  -webkit-mask-repeat: no-repeat;\n  -webkit-mask-position: center;\n  background-color: var(--bs-primary-inverse);\n  -webkit-mask-image: url(\"data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 6 6' fill='var%28--bs-primary-inverse%29'%3e%3cpath d='M2.72011 2.76429L4.46358 1.02083C4.63618 0.848244 4.63617 0.568419 4.46358 0.395831C4.29099 0.223244 4.01118 0.223244 3.83861 0.395831L1.52904 2.70537C1.36629 2.86808 1.36629 3.13191 1.52904 3.29462L3.83861 5.60419C4.01117 5.77675 4.29099 5.77675 4.46358 5.60419C4.63617 5.43156 4.63617 5.15175 4.46358 4.97919L2.72011 3.23571C2.58994 3.10554 2.58994 2.89446 2.72011 2.76429Z'/%3e%3c/svg%3e\");\n  mask-image: url(\"data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 6 6' fill='var%28--bs-primary-inverse%29'%3e%3cpath d='M2.72011 2.76429L4.46358 1.02083C4.63618 0.848244 4.63617 0.568419 4.46358 0.395831C4.29099 0.223244 4.01118 0.223244 3.83861 0.395831L1.52904 2.70537C1.36629 2.86808 1.36629 3.13191 1.52904 3.29462L3.83861 5.60419C4.01117 5.77675 4.29099 5.77675 4.46358 5.60419C4.63617 5.43156 4.63617 5.15175 4.46358 4.97919L2.72011 3.23571C2.58994 3.10554 2.58994 2.89446 2.72011 2.76429Z'/%3e%3c/svg%3e\");\n  /*rtl:begin:remove*/\n  mask-repeat: no-repeat;\n  mask-position: center;\n  -webkit-mask-repeat: no-repeat;\n  -webkit-mask-position: center;\n  background-color: var(--bs-primary-inverse);\n  -webkit-mask-image: url(\"data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 6 6' fill='var%28--bs-primary-inverse%29'%3e%3cpath d='M3.27989 3.23571L1.53642 4.97917C1.36382 5.15176 1.36383 5.43158 1.53642 5.60417C1.70901 5.77676 1.98882 5.77676 2.16139 5.60417L4.47096 3.29463C4.63371 3.13192 4.63371 2.86809 4.47096 2.70538L2.16139 0.395812C1.98883 0.22325 1.70901 0.22325 1.53642 0.395812C1.36383 0.568437 1.36383 0.84825 1.53642 1.02081L3.27989 2.76429C3.41006 2.89446 3.41006 3.10554 3.27989 3.23571Z'/%3e%3c/svg%3e\");\n  mask-image: url(\"data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 6 6' fill='var%28--bs-primary-inverse%29'%3e%3cpath d='M3.27989 3.23571L1.53642 4.97917C1.36382 5.15176 1.36383 5.43158 1.53642 5.60417C1.70901 5.77676 1.98882 5.77676 2.16139 5.60417L4.47096 3.29463C4.63371 3.13192 4.63371 2.86809 4.47096 2.70538L2.16139 0.395812C1.98883 0.22325 1.70901 0.22325 1.53642 0.395812C1.36383 0.568437 1.36383 0.84825 1.53642 1.02081L3.27989 2.76429C3.41006 2.89446 3.41006 3.10554 3.27989 3.23571Z'/%3e%3c/svg%3e\");\n  /*rtl:end:remove*/\n}\n.menu-state-bg-primary .menu-item.show > .menu-link {\n  transition: color 0.2s ease;\n  background-color: var(--bs-primary);\n  color: var(--bs-primary-inverse);\n}\n.menu-state-bg-primary .menu-item.show > .menu-link .menu-title {\n  color: var(--bs-primary-inverse);\n}\n.menu-state-bg-primary .menu-item.show > .menu-link .menu-icon,\n.menu-state-bg-primary .menu-item.show > .menu-link .menu-icon .svg-icon,\n.menu-state-bg-primary .menu-item.show > .menu-link .menu-icon i {\n  color: var(--bs-primary-inverse);\n}\n.menu-state-bg-primary .menu-item.show > .menu-link .menu-bullet .bullet {\n  background-color: var(--bs-primary-inverse);\n}\n.menu-state-bg-primary .menu-item.show > .menu-link .menu-arrow:after {\n  mask-repeat: no-repeat;\n  mask-position: center;\n  -webkit-mask-repeat: no-repeat;\n  -webkit-mask-position: center;\n  background-color: var(--bs-primary-inverse);\n  -webkit-mask-image: url(\"data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 6 6' fill='var%28--bs-primary-inverse%29'%3e%3cpath d='M2.72011 2.76429L4.46358 1.02083C4.63618 0.848244 4.63617 0.568419 4.46358 0.395831C4.29099 0.223244 4.01118 0.223244 3.83861 0.395831L1.52904 2.70537C1.36629 2.86808 1.36629 3.13191 1.52904 3.29462L3.83861 5.60419C4.01117 5.77675 4.29099 5.77675 4.46358 5.60419C4.63617 5.43156 4.63617 5.15175 4.46358 4.97919L2.72011 3.23571C2.58994 3.10554 2.58994 2.89446 2.72011 2.76429Z'/%3e%3c/svg%3e\");\n  mask-image: url(\"data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 6 6' fill='var%28--bs-primary-inverse%29'%3e%3cpath d='M2.72011 2.76429L4.46358 1.02083C4.63618 0.848244 4.63617 0.568419 4.46358 0.395831C4.29099 0.223244 4.01118 0.223244 3.83861 0.395831L1.52904 2.70537C1.36629 2.86808 1.36629 3.13191 1.52904 3.29462L3.83861 5.60419C4.01117 5.77675 4.29099 5.77675 4.46358 5.60419C4.63617 5.43156 4.63617 5.15175 4.46358 4.97919L2.72011 3.23571C2.58994 3.10554 2.58994 2.89446 2.72011 2.76429Z'/%3e%3c/svg%3e\");\n  /*rtl:begin:remove*/\n  mask-repeat: no-repeat;\n  mask-position: center;\n  -webkit-mask-repeat: no-repeat;\n  -webkit-mask-position: center;\n  background-color: var(--bs-primary-inverse);\n  -webkit-mask-image: url(\"data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 6 6' fill='var%28--bs-primary-inverse%29'%3e%3cpath d='M3.27989 3.23571L1.53642 4.97917C1.36382 5.15176 1.36383 5.43158 1.53642 5.60417C1.70901 5.77676 1.98882 5.77676 2.16139 5.60417L4.47096 3.29463C4.63371 3.13192 4.63371 2.86809 4.47096 2.70538L2.16139 0.395812C1.98883 0.22325 1.70901 0.22325 1.53642 0.395812C1.36383 0.568437 1.36383 0.84825 1.53642 1.02081L3.27989 2.76429C3.41006 2.89446 3.41006 3.10554 3.27989 3.23571Z'/%3e%3c/svg%3e\");\n  mask-image: url(\"data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 6 6' fill='var%28--bs-primary-inverse%29'%3e%3cpath d='M3.27989 3.23571L1.53642 4.97917C1.36382 5.15176 1.36383 5.43158 1.53642 5.60417C1.70901 5.77676 1.98882 5.77676 2.16139 5.60417L4.47096 3.29463C4.63371 3.13192 4.63371 2.86809 4.47096 2.70538L2.16139 0.395812C1.98883 0.22325 1.70901 0.22325 1.53642 0.395812C1.36383 0.568437 1.36383 0.84825 1.53642 1.02081L3.27989 2.76429C3.41006 2.89446 3.41006 3.10554 3.27989 3.23571Z'/%3e%3c/svg%3e\");\n  /*rtl:end:remove*/\n}\n\n.menu-show-bg-light-primary .menu-item.show > .menu-link {\n  transition: color 0.2s ease;\n  background-color: var(--bs-primary-light);\n  color: var(--bs-primary);\n}\n.menu-show-bg-light-primary .menu-item.show > .menu-link .menu-title {\n  color: var(--bs-primary);\n}\n.menu-show-bg-light-primary .menu-item.show > .menu-link .menu-icon,\n.menu-show-bg-light-primary .menu-item.show > .menu-link .menu-icon .svg-icon,\n.menu-show-bg-light-primary .menu-item.show > .menu-link .menu-icon i {\n  color: var(--bs-primary);\n}\n.menu-show-bg-light-primary .menu-item.show > .menu-link .menu-bullet .bullet {\n  background-color: var(--bs-primary);\n}\n.menu-show-bg-light-primary .menu-item.show > .menu-link .menu-arrow:after {\n  mask-repeat: no-repeat;\n  mask-position: center;\n  -webkit-mask-repeat: no-repeat;\n  -webkit-mask-position: center;\n  background-color: var(--bs-primary);\n  -webkit-mask-image: url(\"data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 6 6' fill='var%28--bs-primary%29'%3e%3cpath d='M2.72011 2.76429L4.46358 1.02083C4.63618 0.848244 4.63617 0.568419 4.46358 0.395831C4.29099 0.223244 4.01118 0.223244 3.83861 0.395831L1.52904 2.70537C1.36629 2.86808 1.36629 3.13191 1.52904 3.29462L3.83861 5.60419C4.01117 5.77675 4.29099 5.77675 4.46358 5.60419C4.63617 5.43156 4.63617 5.15175 4.46358 4.97919L2.72011 3.23571C2.58994 3.10554 2.58994 2.89446 2.72011 2.76429Z'/%3e%3c/svg%3e\");\n  mask-image: url(\"data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 6 6' fill='var%28--bs-primary%29'%3e%3cpath d='M2.72011 2.76429L4.46358 1.02083C4.63618 0.848244 4.63617 0.568419 4.46358 0.395831C4.29099 0.223244 4.01118 0.223244 3.83861 0.395831L1.52904 2.70537C1.36629 2.86808 1.36629 3.13191 1.52904 3.29462L3.83861 5.60419C4.01117 5.77675 4.29099 5.77675 4.46358 5.60419C4.63617 5.43156 4.63617 5.15175 4.46358 4.97919L2.72011 3.23571C2.58994 3.10554 2.58994 2.89446 2.72011 2.76429Z'/%3e%3c/svg%3e\");\n  /*rtl:begin:remove*/\n  mask-repeat: no-repeat;\n  mask-position: center;\n  -webkit-mask-repeat: no-repeat;\n  -webkit-mask-position: center;\n  background-color: var(--bs-primary);\n  -webkit-mask-image: url(\"data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 6 6' fill='var%28--bs-primary%29'%3e%3cpath d='M3.27989 3.23571L1.53642 4.97917C1.36382 5.15176 1.36383 5.43158 1.53642 5.60417C1.70901 5.77676 1.98882 5.77676 2.16139 5.60417L4.47096 3.29463C4.63371 3.13192 4.63371 2.86809 4.47096 2.70538L2.16139 0.395812C1.98883 0.22325 1.70901 0.22325 1.53642 0.395812C1.36383 0.568437 1.36383 0.84825 1.53642 1.02081L3.27989 2.76429C3.41006 2.89446 3.41006 3.10554 3.27989 3.23571Z'/%3e%3c/svg%3e\");\n  mask-image: url(\"data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 6 6' fill='var%28--bs-primary%29'%3e%3cpath d='M3.27989 3.23571L1.53642 4.97917C1.36382 5.15176 1.36383 5.43158 1.53642 5.60417C1.70901 5.77676 1.98882 5.77676 2.16139 5.60417L4.47096 3.29463C4.63371 3.13192 4.63371 2.86809 4.47096 2.70538L2.16139 0.395812C1.98883 0.22325 1.70901 0.22325 1.53642 0.395812C1.36383 0.568437 1.36383 0.84825 1.53642 1.02081L3.27989 2.76429C3.41006 2.89446 3.41006 3.10554 3.27989 3.23571Z'/%3e%3c/svg%3e\");\n  /*rtl:end:remove*/\n}\n\n.menu-here-bg-light-primary .menu-item.here > .menu-link {\n  transition: color 0.2s ease;\n  background-color: var(--bs-primary-light);\n  color: var(--bs-primary);\n}\n.menu-here-bg-light-primary .menu-item.here > .menu-link .menu-title {\n  color: var(--bs-primary);\n}\n.menu-here-bg-light-primary .menu-item.here > .menu-link .menu-icon,\n.menu-here-bg-light-primary .menu-item.here > .menu-link .menu-icon .svg-icon,\n.menu-here-bg-light-primary .menu-item.here > .menu-link .menu-icon i {\n  color: var(--bs-primary);\n}\n.menu-here-bg-light-primary .menu-item.here > .menu-link .menu-bullet .bullet {\n  background-color: var(--bs-primary);\n}\n.menu-here-bg-light-primary .menu-item.here > .menu-link .menu-arrow:after {\n  mask-repeat: no-repeat;\n  mask-position: center;\n  -webkit-mask-repeat: no-repeat;\n  -webkit-mask-position: center;\n  background-color: var(--bs-primary);\n  -webkit-mask-image: url(\"data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 6 6' fill='var%28--bs-primary%29'%3e%3cpath d='M2.72011 2.76429L4.46358 1.02083C4.63618 0.848244 4.63617 0.568419 4.46358 0.395831C4.29099 0.223244 4.01118 0.223244 3.83861 0.395831L1.52904 2.70537C1.36629 2.86808 1.36629 3.13191 1.52904 3.29462L3.83861 5.60419C4.01117 5.77675 4.29099 5.77675 4.46358 5.60419C4.63617 5.43156 4.63617 5.15175 4.46358 4.97919L2.72011 3.23571C2.58994 3.10554 2.58994 2.89446 2.72011 2.76429Z'/%3e%3c/svg%3e\");\n  mask-image: url(\"data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 6 6' fill='var%28--bs-primary%29'%3e%3cpath d='M2.72011 2.76429L4.46358 1.02083C4.63618 0.848244 4.63617 0.568419 4.46358 0.395831C4.29099 0.223244 4.01118 0.223244 3.83861 0.395831L1.52904 2.70537C1.36629 2.86808 1.36629 3.13191 1.52904 3.29462L3.83861 5.60419C4.01117 5.77675 4.29099 5.77675 4.46358 5.60419C4.63617 5.43156 4.63617 5.15175 4.46358 4.97919L2.72011 3.23571C2.58994 3.10554 2.58994 2.89446 2.72011 2.76429Z'/%3e%3c/svg%3e\");\n  /*rtl:begin:remove*/\n  mask-repeat: no-repeat;\n  mask-position: center;\n  -webkit-mask-repeat: no-repeat;\n  -webkit-mask-position: center;\n  background-color: var(--bs-primary);\n  -webkit-mask-image: url(\"data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 6 6' fill='var%28--bs-primary%29'%3e%3cpath d='M3.27989 3.23571L1.53642 4.97917C1.36382 5.15176 1.36383 5.43158 1.53642 5.60417C1.70901 5.77676 1.98882 5.77676 2.16139 5.60417L4.47096 3.29463C4.63371 3.13192 4.63371 2.86809 4.47096 2.70538L2.16139 0.395812C1.98883 0.22325 1.70901 0.22325 1.53642 0.395812C1.36383 0.568437 1.36383 0.84825 1.53642 1.02081L3.27989 2.76429C3.41006 2.89446 3.41006 3.10554 3.27989 3.23571Z'/%3e%3c/svg%3e\");\n  mask-image: url(\"data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 6 6' fill='var%28--bs-primary%29'%3e%3cpath d='M3.27989 3.23571L1.53642 4.97917C1.36382 5.15176 1.36383 5.43158 1.53642 5.60417C1.70901 5.77676 1.98882 5.77676 2.16139 5.60417L4.47096 3.29463C4.63371 3.13192 4.63371 2.86809 4.47096 2.70538L2.16139 0.395812C1.98883 0.22325 1.70901 0.22325 1.53642 0.395812C1.36383 0.568437 1.36383 0.84825 1.53642 1.02081L3.27989 2.76429C3.41006 2.89446 3.41006 3.10554 3.27989 3.23571Z'/%3e%3c/svg%3e\");\n  /*rtl:end:remove*/\n}\n\n.menu-hover-bg-light-primary .menu-item.hover:not(.here) > .menu-link:not(.disabled):not(.active):not(.here), .menu-hover-bg-light-primary .menu-item:not(.here) .menu-link:hover:not(.disabled):not(.active):not(.here) {\n  transition: color 0.2s ease;\n  background-color: var(--bs-primary-light);\n  color: var(--bs-primary);\n}\n.menu-hover-bg-light-primary .menu-item.hover:not(.here) > .menu-link:not(.disabled):not(.active):not(.here) .menu-title, .menu-hover-bg-light-primary .menu-item:not(.here) .menu-link:hover:not(.disabled):not(.active):not(.here) .menu-title {\n  color: var(--bs-primary);\n}\n.menu-hover-bg-light-primary .menu-item.hover:not(.here) > .menu-link:not(.disabled):not(.active):not(.here) .menu-icon,\n.menu-hover-bg-light-primary .menu-item.hover:not(.here) > .menu-link:not(.disabled):not(.active):not(.here) .menu-icon .svg-icon,\n.menu-hover-bg-light-primary .menu-item.hover:not(.here) > .menu-link:not(.disabled):not(.active):not(.here) .menu-icon i, .menu-hover-bg-light-primary .menu-item:not(.here) .menu-link:hover:not(.disabled):not(.active):not(.here) .menu-icon,\n.menu-hover-bg-light-primary .menu-item:not(.here) .menu-link:hover:not(.disabled):not(.active):not(.here) .menu-icon .svg-icon,\n.menu-hover-bg-light-primary .menu-item:not(.here) .menu-link:hover:not(.disabled):not(.active):not(.here) .menu-icon i {\n  color: var(--bs-primary);\n}\n.menu-hover-bg-light-primary .menu-item.hover:not(.here) > .menu-link:not(.disabled):not(.active):not(.here) .menu-bullet .bullet, .menu-hover-bg-light-primary .menu-item:not(.here) .menu-link:hover:not(.disabled):not(.active):not(.here) .menu-bullet .bullet {\n  background-color: var(--bs-primary);\n}\n.menu-hover-bg-light-primary .menu-item.hover:not(.here) > .menu-link:not(.disabled):not(.active):not(.here) .menu-arrow:after, .menu-hover-bg-light-primary .menu-item:not(.here) .menu-link:hover:not(.disabled):not(.active):not(.here) .menu-arrow:after {\n  mask-repeat: no-repeat;\n  mask-position: center;\n  -webkit-mask-repeat: no-repeat;\n  -webkit-mask-position: center;\n  background-color: var(--bs-primary);\n  -webkit-mask-image: url(\"data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 6 6' fill='var%28--bs-primary%29'%3e%3cpath d='M2.72011 2.76429L4.46358 1.02083C4.63618 0.848244 4.63617 0.568419 4.46358 0.395831C4.29099 0.223244 4.01118 0.223244 3.83861 0.395831L1.52904 2.70537C1.36629 2.86808 1.36629 3.13191 1.52904 3.29462L3.83861 5.60419C4.01117 5.77675 4.29099 5.77675 4.46358 5.60419C4.63617 5.43156 4.63617 5.15175 4.46358 4.97919L2.72011 3.23571C2.58994 3.10554 2.58994 2.89446 2.72011 2.76429Z'/%3e%3c/svg%3e\");\n  mask-image: url(\"data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 6 6' fill='var%28--bs-primary%29'%3e%3cpath d='M2.72011 2.76429L4.46358 1.02083C4.63618 0.848244 4.63617 0.568419 4.46358 0.395831C4.29099 0.223244 4.01118 0.223244 3.83861 0.395831L1.52904 2.70537C1.36629 2.86808 1.36629 3.13191 1.52904 3.29462L3.83861 5.60419C4.01117 5.77675 4.29099 5.77675 4.46358 5.60419C4.63617 5.43156 4.63617 5.15175 4.46358 4.97919L2.72011 3.23571C2.58994 3.10554 2.58994 2.89446 2.72011 2.76429Z'/%3e%3c/svg%3e\");\n  /*rtl:begin:remove*/\n  mask-repeat: no-repeat;\n  mask-position: center;\n  -webkit-mask-repeat: no-repeat;\n  -webkit-mask-position: center;\n  background-color: var(--bs-primary);\n  -webkit-mask-image: url(\"data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 6 6' fill='var%28--bs-primary%29'%3e%3cpath d='M3.27989 3.23571L1.53642 4.97917C1.36382 5.15176 1.36383 5.43158 1.53642 5.60417C1.70901 5.77676 1.98882 5.77676 2.16139 5.60417L4.47096 3.29463C4.63371 3.13192 4.63371 2.86809 4.47096 2.70538L2.16139 0.395812C1.98883 0.22325 1.70901 0.22325 1.53642 0.395812C1.36383 0.568437 1.36383 0.84825 1.53642 1.02081L3.27989 2.76429C3.41006 2.89446 3.41006 3.10554 3.27989 3.23571Z'/%3e%3c/svg%3e\");\n  mask-image: url(\"data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 6 6' fill='var%28--bs-primary%29'%3e%3cpath d='M3.27989 3.23571L1.53642 4.97917C1.36382 5.15176 1.36383 5.43158 1.53642 5.60417C1.70901 5.77676 1.98882 5.77676 2.16139 5.60417L4.47096 3.29463C4.63371 3.13192 4.63371 2.86809 4.47096 2.70538L2.16139 0.395812C1.98883 0.22325 1.70901 0.22325 1.53642 0.395812C1.36383 0.568437 1.36383 0.84825 1.53642 1.02081L3.27989 2.76429C3.41006 2.89446 3.41006 3.10554 3.27989 3.23571Z'/%3e%3c/svg%3e\");\n  /*rtl:end:remove*/\n}\n\n.menu-active-bg-light-primary .menu-item .menu-link.active {\n  transition: color 0.2s ease;\n  background-color: var(--bs-primary-light);\n  color: var(--bs-primary);\n}\n.menu-active-bg-light-primary .menu-item .menu-link.active .menu-title {\n  color: var(--bs-primary);\n}\n.menu-active-bg-light-primary .menu-item .menu-link.active .menu-icon,\n.menu-active-bg-light-primary .menu-item .menu-link.active .menu-icon .svg-icon,\n.menu-active-bg-light-primary .menu-item .menu-link.active .menu-icon i {\n  color: var(--bs-primary);\n}\n.menu-active-bg-light-primary .menu-item .menu-link.active .menu-bullet .bullet {\n  background-color: var(--bs-primary);\n}\n.menu-active-bg-light-primary .menu-item .menu-link.active .menu-arrow:after {\n  mask-repeat: no-repeat;\n  mask-position: center;\n  -webkit-mask-repeat: no-repeat;\n  -webkit-mask-position: center;\n  background-color: var(--bs-primary);\n  -webkit-mask-image: url(\"data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 6 6' fill='var%28--bs-primary%29'%3e%3cpath d='M2.72011 2.76429L4.46358 1.02083C4.63618 0.848244 4.63617 0.568419 4.46358 0.395831C4.29099 0.223244 4.01118 0.223244 3.83861 0.395831L1.52904 2.70537C1.36629 2.86808 1.36629 3.13191 1.52904 3.29462L3.83861 5.60419C4.01117 5.77675 4.29099 5.77675 4.46358 5.60419C4.63617 5.43156 4.63617 5.15175 4.46358 4.97919L2.72011 3.23571C2.58994 3.10554 2.58994 2.89446 2.72011 2.76429Z'/%3e%3c/svg%3e\");\n  mask-image: url(\"data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 6 6' fill='var%28--bs-primary%29'%3e%3cpath d='M2.72011 2.76429L4.46358 1.02083C4.63618 0.848244 4.63617 0.568419 4.46358 0.395831C4.29099 0.223244 4.01118 0.223244 3.83861 0.395831L1.52904 2.70537C1.36629 2.86808 1.36629 3.13191 1.52904 3.29462L3.83861 5.60419C4.01117 5.77675 4.29099 5.77675 4.46358 5.60419C4.63617 5.43156 4.63617 5.15175 4.46358 4.97919L2.72011 3.23571C2.58994 3.10554 2.58994 2.89446 2.72011 2.76429Z'/%3e%3c/svg%3e\");\n  /*rtl:begin:remove*/\n  mask-repeat: no-repeat;\n  mask-position: center;\n  -webkit-mask-repeat: no-repeat;\n  -webkit-mask-position: center;\n  background-color: var(--bs-primary);\n  -webkit-mask-image: url(\"data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 6 6' fill='var%28--bs-primary%29'%3e%3cpath d='M3.27989 3.23571L1.53642 4.97917C1.36382 5.15176 1.36383 5.43158 1.53642 5.60417C1.70901 5.77676 1.98882 5.77676 2.16139 5.60417L4.47096 3.29463C4.63371 3.13192 4.63371 2.86809 4.47096 2.70538L2.16139 0.395812C1.98883 0.22325 1.70901 0.22325 1.53642 0.395812C1.36383 0.568437 1.36383 0.84825 1.53642 1.02081L3.27989 2.76429C3.41006 2.89446 3.41006 3.10554 3.27989 3.23571Z'/%3e%3c/svg%3e\");\n  mask-image: url(\"data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 6 6' fill='var%28--bs-primary%29'%3e%3cpath d='M3.27989 3.23571L1.53642 4.97917C1.36382 5.15176 1.36383 5.43158 1.53642 5.60417C1.70901 5.77676 1.98882 5.77676 2.16139 5.60417L4.47096 3.29463C4.63371 3.13192 4.63371 2.86809 4.47096 2.70538L2.16139 0.395812C1.98883 0.22325 1.70901 0.22325 1.53642 0.395812C1.36383 0.568437 1.36383 0.84825 1.53642 1.02081L3.27989 2.76429C3.41006 2.89446 3.41006 3.10554 3.27989 3.23571Z'/%3e%3c/svg%3e\");\n  /*rtl:end:remove*/\n}\n\n.menu-state-bg-light-primary .menu-item.show > .menu-link {\n  transition: color 0.2s ease;\n  background-color: var(--bs-primary-light);\n  color: var(--bs-primary);\n}\n.menu-state-bg-light-primary .menu-item.show > .menu-link .menu-title {\n  color: var(--bs-primary);\n}\n.menu-state-bg-light-primary .menu-item.show > .menu-link .menu-icon,\n.menu-state-bg-light-primary .menu-item.show > .menu-link .menu-icon .svg-icon,\n.menu-state-bg-light-primary .menu-item.show > .menu-link .menu-icon i {\n  color: var(--bs-primary);\n}\n.menu-state-bg-light-primary .menu-item.show > .menu-link .menu-bullet .bullet {\n  background-color: var(--bs-primary);\n}\n.menu-state-bg-light-primary .menu-item.show > .menu-link .menu-arrow:after {\n  mask-repeat: no-repeat;\n  mask-position: center;\n  -webkit-mask-repeat: no-repeat;\n  -webkit-mask-position: center;\n  background-color: var(--bs-primary);\n  -webkit-mask-image: url(\"data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 6 6' fill='var%28--bs-primary%29'%3e%3cpath d='M2.72011 2.76429L4.46358 1.02083C4.63618 0.848244 4.63617 0.568419 4.46358 0.395831C4.29099 0.223244 4.01118 0.223244 3.83861 0.395831L1.52904 2.70537C1.36629 2.86808 1.36629 3.13191 1.52904 3.29462L3.83861 5.60419C4.01117 5.77675 4.29099 5.77675 4.46358 5.60419C4.63617 5.43156 4.63617 5.15175 4.46358 4.97919L2.72011 3.23571C2.58994 3.10554 2.58994 2.89446 2.72011 2.76429Z'/%3e%3c/svg%3e\");\n  mask-image: url(\"data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 6 6' fill='var%28--bs-primary%29'%3e%3cpath d='M2.72011 2.76429L4.46358 1.02083C4.63618 0.848244 4.63617 0.568419 4.46358 0.395831C4.29099 0.223244 4.01118 0.223244 3.83861 0.395831L1.52904 2.70537C1.36629 2.86808 1.36629 3.13191 1.52904 3.29462L3.83861 5.60419C4.01117 5.77675 4.29099 5.77675 4.46358 5.60419C4.63617 5.43156 4.63617 5.15175 4.46358 4.97919L2.72011 3.23571C2.58994 3.10554 2.58994 2.89446 2.72011 2.76429Z'/%3e%3c/svg%3e\");\n  /*rtl:begin:remove*/\n  mask-repeat: no-repeat;\n  mask-position: center;\n  -webkit-mask-repeat: no-repeat;\n  -webkit-mask-position: center;\n  background-color: var(--bs-primary);\n  -webkit-mask-image: url(\"data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 6 6' fill='var%28--bs-primary%29'%3e%3cpath d='M3.27989 3.23571L1.53642 4.97917C1.36382 5.15176 1.36383 5.43158 1.53642 5.60417C1.70901 5.77676 1.98882 5.77676 2.16139 5.60417L4.47096 3.29463C4.63371 3.13192 4.63371 2.86809 4.47096 2.70538L2.16139 0.395812C1.98883 0.22325 1.70901 0.22325 1.53642 0.395812C1.36383 0.568437 1.36383 0.84825 1.53642 1.02081L3.27989 2.76429C3.41006 2.89446 3.41006 3.10554 3.27989 3.23571Z'/%3e%3c/svg%3e\");\n  mask-image: url(\"data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 6 6' fill='var%28--bs-primary%29'%3e%3cpath d='M3.27989 3.23571L1.53642 4.97917C1.36382 5.15176 1.36383 5.43158 1.53642 5.60417C1.70901 5.77676 1.98882 5.77676 2.16139 5.60417L4.47096 3.29463C4.63371 3.13192 4.63371 2.86809 4.47096 2.70538L2.16139 0.395812C1.98883 0.22325 1.70901 0.22325 1.53642 0.395812C1.36383 0.568437 1.36383 0.84825 1.53642 1.02081L3.27989 2.76429C3.41006 2.89446 3.41006 3.10554 3.27989 3.23571Z'/%3e%3c/svg%3e\");\n  /*rtl:end:remove*/\n}\n.menu-state-bg-light-primary .menu-item.here > .menu-link {\n  transition: color 0.2s ease;\n  background-color: var(--bs-primary-light);\n  color: var(--bs-primary);\n}\n.menu-state-bg-light-primary .menu-item.here > .menu-link .menu-title {\n  color: var(--bs-primary);\n}\n.menu-state-bg-light-primary .menu-item.here > .menu-link .menu-icon,\n.menu-state-bg-light-primary .menu-item.here > .menu-link .menu-icon .svg-icon,\n.menu-state-bg-light-primary .menu-item.here > .menu-link .menu-icon i {\n  color: var(--bs-primary);\n}\n.menu-state-bg-light-primary .menu-item.here > .menu-link .menu-bullet .bullet {\n  background-color: var(--bs-primary);\n}\n.menu-state-bg-light-primary .menu-item.here > .menu-link .menu-arrow:after {\n  mask-repeat: no-repeat;\n  mask-position: center;\n  -webkit-mask-repeat: no-repeat;\n  -webkit-mask-position: center;\n  background-color: var(--bs-primary);\n  -webkit-mask-image: url(\"data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 6 6' fill='var%28--bs-primary%29'%3e%3cpath d='M2.72011 2.76429L4.46358 1.02083C4.63618 0.848244 4.63617 0.568419 4.46358 0.395831C4.29099 0.223244 4.01118 0.223244 3.83861 0.395831L1.52904 2.70537C1.36629 2.86808 1.36629 3.13191 1.52904 3.29462L3.83861 5.60419C4.01117 5.77675 4.29099 5.77675 4.46358 5.60419C4.63617 5.43156 4.63617 5.15175 4.46358 4.97919L2.72011 3.23571C2.58994 3.10554 2.58994 2.89446 2.72011 2.76429Z'/%3e%3c/svg%3e\");\n  mask-image: url(\"data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 6 6' fill='var%28--bs-primary%29'%3e%3cpath d='M2.72011 2.76429L4.46358 1.02083C4.63618 0.848244 4.63617 0.568419 4.46358 0.395831C4.29099 0.223244 4.01118 0.223244 3.83861 0.395831L1.52904 2.70537C1.36629 2.86808 1.36629 3.13191 1.52904 3.29462L3.83861 5.60419C4.01117 5.77675 4.29099 5.77675 4.46358 5.60419C4.63617 5.43156 4.63617 5.15175 4.46358 4.97919L2.72011 3.23571C2.58994 3.10554 2.58994 2.89446 2.72011 2.76429Z'/%3e%3c/svg%3e\");\n  /*rtl:begin:remove*/\n  mask-repeat: no-repeat;\n  mask-position: center;\n  -webkit-mask-repeat: no-repeat;\n  -webkit-mask-position: center;\n  background-color: var(--bs-primary);\n  -webkit-mask-image: url(\"data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 6 6' fill='var%28--bs-primary%29'%3e%3cpath d='M3.27989 3.23571L1.53642 4.97917C1.36382 5.15176 1.36383 5.43158 1.53642 5.60417C1.70901 5.77676 1.98882 5.77676 2.16139 5.60417L4.47096 3.29463C4.63371 3.13192 4.63371 2.86809 4.47096 2.70538L2.16139 0.395812C1.98883 0.22325 1.70901 0.22325 1.53642 0.395812C1.36383 0.568437 1.36383 0.84825 1.53642 1.02081L3.27989 2.76429C3.41006 2.89446 3.41006 3.10554 3.27989 3.23571Z'/%3e%3c/svg%3e\");\n  mask-image: url(\"data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 6 6' fill='var%28--bs-primary%29'%3e%3cpath d='M3.27989 3.23571L1.53642 4.97917C1.36382 5.15176 1.36383 5.43158 1.53642 5.60417C1.70901 5.77676 1.98882 5.77676 2.16139 5.60417L4.47096 3.29463C4.63371 3.13192 4.63371 2.86809 4.47096 2.70538L2.16139 0.395812C1.98883 0.22325 1.70901 0.22325 1.53642 0.395812C1.36383 0.568437 1.36383 0.84825 1.53642 1.02081L3.27989 2.76429C3.41006 2.89446 3.41006 3.10554 3.27989 3.23571Z'/%3e%3c/svg%3e\");\n  /*rtl:end:remove*/\n}\n.menu-state-bg-light-primary .menu-item.hover:not(.here) > .menu-link:not(.disabled):not(.active):not(.here), .menu-state-bg-light-primary .menu-item:not(.here) .menu-link:hover:not(.disabled):not(.active):not(.here) {\n  transition: color 0.2s ease;\n  background-color: var(--bs-primary-light);\n  color: var(--bs-primary);\n}\n.menu-state-bg-light-primary .menu-item.hover:not(.here) > .menu-link:not(.disabled):not(.active):not(.here) .menu-title, .menu-state-bg-light-primary .menu-item:not(.here) .menu-link:hover:not(.disabled):not(.active):not(.here) .menu-title {\n  color: var(--bs-primary);\n}\n.menu-state-bg-light-primary .menu-item.hover:not(.here) > .menu-link:not(.disabled):not(.active):not(.here) .menu-icon,\n.menu-state-bg-light-primary .menu-item.hover:not(.here) > .menu-link:not(.disabled):not(.active):not(.here) .menu-icon .svg-icon,\n.menu-state-bg-light-primary .menu-item.hover:not(.here) > .menu-link:not(.disabled):not(.active):not(.here) .menu-icon i, .menu-state-bg-light-primary .menu-item:not(.here) .menu-link:hover:not(.disabled):not(.active):not(.here) .menu-icon,\n.menu-state-bg-light-primary .menu-item:not(.here) .menu-link:hover:not(.disabled):not(.active):not(.here) .menu-icon .svg-icon,\n.menu-state-bg-light-primary .menu-item:not(.here) .menu-link:hover:not(.disabled):not(.active):not(.here) .menu-icon i {\n  color: var(--bs-primary);\n}\n.menu-state-bg-light-primary .menu-item.hover:not(.here) > .menu-link:not(.disabled):not(.active):not(.here) .menu-bullet .bullet, .menu-state-bg-light-primary .menu-item:not(.here) .menu-link:hover:not(.disabled):not(.active):not(.here) .menu-bullet .bullet {\n  background-color: var(--bs-primary);\n}\n.menu-state-bg-light-primary .menu-item.hover:not(.here) > .menu-link:not(.disabled):not(.active):not(.here) .menu-arrow:after, .menu-state-bg-light-primary .menu-item:not(.here) .menu-link:hover:not(.disabled):not(.active):not(.here) .menu-arrow:after {\n  mask-repeat: no-repeat;\n  mask-position: center;\n  -webkit-mask-repeat: no-repeat;\n  -webkit-mask-position: center;\n  background-color: var(--bs-primary);\n  -webkit-mask-image: url(\"data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 6 6' fill='var%28--bs-primary%29'%3e%3cpath d='M2.72011 2.76429L4.46358 1.02083C4.63618 0.848244 4.63617 0.568419 4.46358 0.395831C4.29099 0.223244 4.01118 0.223244 3.83861 0.395831L1.52904 2.70537C1.36629 2.86808 1.36629 3.13191 1.52904 3.29462L3.83861 5.60419C4.01117 5.77675 4.29099 5.77675 4.46358 5.60419C4.63617 5.43156 4.63617 5.15175 4.46358 4.97919L2.72011 3.23571C2.58994 3.10554 2.58994 2.89446 2.72011 2.76429Z'/%3e%3c/svg%3e\");\n  mask-image: url(\"data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 6 6' fill='var%28--bs-primary%29'%3e%3cpath d='M2.72011 2.76429L4.46358 1.02083C4.63618 0.848244 4.63617 0.568419 4.46358 0.395831C4.29099 0.223244 4.01118 0.223244 3.83861 0.395831L1.52904 2.70537C1.36629 2.86808 1.36629 3.13191 1.52904 3.29462L3.83861 5.60419C4.01117 5.77675 4.29099 5.77675 4.46358 5.60419C4.63617 5.43156 4.63617 5.15175 4.46358 4.97919L2.72011 3.23571C2.58994 3.10554 2.58994 2.89446 2.72011 2.76429Z'/%3e%3c/svg%3e\");\n  /*rtl:begin:remove*/\n  mask-repeat: no-repeat;\n  mask-position: center;\n  -webkit-mask-repeat: no-repeat;\n  -webkit-mask-position: center;\n  background-color: var(--bs-primary);\n  -webkit-mask-image: url(\"data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 6 6' fill='var%28--bs-primary%29'%3e%3cpath d='M3.27989 3.23571L1.53642 4.97917C1.36382 5.15176 1.36383 5.43158 1.53642 5.60417C1.70901 5.77676 1.98882 5.77676 2.16139 5.60417L4.47096 3.29463C4.63371 3.13192 4.63371 2.86809 4.47096 2.70538L2.16139 0.395812C1.98883 0.22325 1.70901 0.22325 1.53642 0.395812C1.36383 0.568437 1.36383 0.84825 1.53642 1.02081L3.27989 2.76429C3.41006 2.89446 3.41006 3.10554 3.27989 3.23571Z'/%3e%3c/svg%3e\");\n  mask-image: url(\"data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 6 6' fill='var%28--bs-primary%29'%3e%3cpath d='M3.27989 3.23571L1.53642 4.97917C1.36382 5.15176 1.36383 5.43158 1.53642 5.60417C1.70901 5.77676 1.98882 5.77676 2.16139 5.60417L4.47096 3.29463C4.63371 3.13192 4.63371 2.86809 4.47096 2.70538L2.16139 0.395812C1.98883 0.22325 1.70901 0.22325 1.53642 0.395812C1.36383 0.568437 1.36383 0.84825 1.53642 1.02081L3.27989 2.76429C3.41006 2.89446 3.41006 3.10554 3.27989 3.23571Z'/%3e%3c/svg%3e\");\n  /*rtl:end:remove*/\n}\n.menu-state-bg-light-primary .menu-item .menu-link.active {\n  transition: color 0.2s ease;\n  background-color: var(--bs-primary-light);\n  color: var(--bs-primary);\n}\n.menu-state-bg-light-primary .menu-item .menu-link.active .menu-title {\n  color: var(--bs-primary);\n}\n.menu-state-bg-light-primary .menu-item .menu-link.active .menu-icon,\n.menu-state-bg-light-primary .menu-item .menu-link.active .menu-icon .svg-icon,\n.menu-state-bg-light-primary .menu-item .menu-link.active .menu-icon i {\n  color: var(--bs-primary);\n}\n.menu-state-bg-light-primary .menu-item .menu-link.active .menu-bullet .bullet {\n  background-color: var(--bs-primary);\n}\n.menu-state-bg-light-primary .menu-item .menu-link.active .menu-arrow:after {\n  mask-repeat: no-repeat;\n  mask-position: center;\n  -webkit-mask-repeat: no-repeat;\n  -webkit-mask-position: center;\n  background-color: var(--bs-primary);\n  -webkit-mask-image: url(\"data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 6 6' fill='var%28--bs-primary%29'%3e%3cpath d='M2.72011 2.76429L4.46358 1.02083C4.63618 0.848244 4.63617 0.568419 4.46358 0.395831C4.29099 0.223244 4.01118 0.223244 3.83861 0.395831L1.52904 2.70537C1.36629 2.86808 1.36629 3.13191 1.52904 3.29462L3.83861 5.60419C4.01117 5.77675 4.29099 5.77675 4.46358 5.60419C4.63617 5.43156 4.63617 5.15175 4.46358 4.97919L2.72011 3.23571C2.58994 3.10554 2.58994 2.89446 2.72011 2.76429Z'/%3e%3c/svg%3e\");\n  mask-image: url(\"data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 6 6' fill='var%28--bs-primary%29'%3e%3cpath d='M2.72011 2.76429L4.46358 1.02083C4.63618 0.848244 4.63617 0.568419 4.46358 0.395831C4.29099 0.223244 4.01118 0.223244 3.83861 0.395831L1.52904 2.70537C1.36629 2.86808 1.36629 3.13191 1.52904 3.29462L3.83861 5.60419C4.01117 5.77675 4.29099 5.77675 4.46358 5.60419C4.63617 5.43156 4.63617 5.15175 4.46358 4.97919L2.72011 3.23571C2.58994 3.10554 2.58994 2.89446 2.72011 2.76429Z'/%3e%3c/svg%3e\");\n  /*rtl:begin:remove*/\n  mask-repeat: no-repeat;\n  mask-position: center;\n  -webkit-mask-repeat: no-repeat;\n  -webkit-mask-position: center;\n  background-color: var(--bs-primary);\n  -webkit-mask-image: url(\"data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 6 6' fill='var%28--bs-primary%29'%3e%3cpath d='M3.27989 3.23571L1.53642 4.97917C1.36382 5.15176 1.36383 5.43158 1.53642 5.60417C1.70901 5.77676 1.98882 5.77676 2.16139 5.60417L4.47096 3.29463C4.63371 3.13192 4.63371 2.86809 4.47096 2.70538L2.16139 0.395812C1.98883 0.22325 1.70901 0.22325 1.53642 0.395812C1.36383 0.568437 1.36383 0.84825 1.53642 1.02081L3.27989 2.76429C3.41006 2.89446 3.41006 3.10554 3.27989 3.23571Z'/%3e%3c/svg%3e\");\n  mask-image: url(\"data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 6 6' fill='var%28--bs-primary%29'%3e%3cpath d='M3.27989 3.23571L1.53642 4.97917C1.36382 5.15176 1.36383 5.43158 1.53642 5.60417C1.70901 5.77676 1.98882 5.77676 2.16139 5.60417L4.47096 3.29463C4.63371 3.13192 4.63371 2.86809 4.47096 2.70538L2.16139 0.395812C1.98883 0.22325 1.70901 0.22325 1.53642 0.395812C1.36383 0.568437 1.36383 0.84825 1.53642 1.02081L3.27989 2.76429C3.41006 2.89446 3.41006 3.10554 3.27989 3.23571Z'/%3e%3c/svg%3e\");\n  /*rtl:end:remove*/\n}\n\n.menu-hover-primary .menu-item.hover:not(.here) > .menu-link:not(.disabled):not(.active):not(.here), .menu-hover-primary .menu-item:not(.here) .menu-link:hover:not(.disabled):not(.active):not(.here) {\n  transition: color 0.2s ease;\n  color: var(--bs-primary);\n}\n.menu-hover-primary .menu-item.hover:not(.here) > .menu-link:not(.disabled):not(.active):not(.here) .menu-title, .menu-hover-primary .menu-item:not(.here) .menu-link:hover:not(.disabled):not(.active):not(.here) .menu-title {\n  color: var(--bs-primary);\n}\n.menu-hover-primary .menu-item.hover:not(.here) > .menu-link:not(.disabled):not(.active):not(.here) .menu-icon,\n.menu-hover-primary .menu-item.hover:not(.here) > .menu-link:not(.disabled):not(.active):not(.here) .menu-icon .svg-icon,\n.menu-hover-primary .menu-item.hover:not(.here) > .menu-link:not(.disabled):not(.active):not(.here) .menu-icon i, .menu-hover-primary .menu-item:not(.here) .menu-link:hover:not(.disabled):not(.active):not(.here) .menu-icon,\n.menu-hover-primary .menu-item:not(.here) .menu-link:hover:not(.disabled):not(.active):not(.here) .menu-icon .svg-icon,\n.menu-hover-primary .menu-item:not(.here) .menu-link:hover:not(.disabled):not(.active):not(.here) .menu-icon i {\n  color: var(--bs-primary);\n}\n.menu-hover-primary .menu-item.hover:not(.here) > .menu-link:not(.disabled):not(.active):not(.here) .menu-bullet .bullet, .menu-hover-primary .menu-item:not(.here) .menu-link:hover:not(.disabled):not(.active):not(.here) .menu-bullet .bullet {\n  background-color: var(--bs-primary);\n}\n.menu-hover-primary .menu-item.hover:not(.here) > .menu-link:not(.disabled):not(.active):not(.here) .menu-arrow:after, .menu-hover-primary .menu-item:not(.here) .menu-link:hover:not(.disabled):not(.active):not(.here) .menu-arrow:after {\n  mask-repeat: no-repeat;\n  mask-position: center;\n  -webkit-mask-repeat: no-repeat;\n  -webkit-mask-position: center;\n  background-color: var(--bs-primary);\n  -webkit-mask-image: url(\"data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 6 6' fill='var%28--bs-primary%29'%3e%3cpath d='M2.72011 2.76429L4.46358 1.02083C4.63618 0.848244 4.63617 0.568419 4.46358 0.395831C4.29099 0.223244 4.01118 0.223244 3.83861 0.395831L1.52904 2.70537C1.36629 2.86808 1.36629 3.13191 1.52904 3.29462L3.83861 5.60419C4.01117 5.77675 4.29099 5.77675 4.46358 5.60419C4.63617 5.43156 4.63617 5.15175 4.46358 4.97919L2.72011 3.23571C2.58994 3.10554 2.58994 2.89446 2.72011 2.76429Z'/%3e%3c/svg%3e\");\n  mask-image: url(\"data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 6 6' fill='var%28--bs-primary%29'%3e%3cpath d='M2.72011 2.76429L4.46358 1.02083C4.63618 0.848244 4.63617 0.568419 4.46358 0.395831C4.29099 0.223244 4.01118 0.223244 3.83861 0.395831L1.52904 2.70537C1.36629 2.86808 1.36629 3.13191 1.52904 3.29462L3.83861 5.60419C4.01117 5.77675 4.29099 5.77675 4.46358 5.60419C4.63617 5.43156 4.63617 5.15175 4.46358 4.97919L2.72011 3.23571C2.58994 3.10554 2.58994 2.89446 2.72011 2.76429Z'/%3e%3c/svg%3e\");\n  /*rtl:begin:remove*/\n  mask-repeat: no-repeat;\n  mask-position: center;\n  -webkit-mask-repeat: no-repeat;\n  -webkit-mask-position: center;\n  background-color: var(--bs-primary);\n  -webkit-mask-image: url(\"data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 6 6' fill='var%28--bs-primary%29'%3e%3cpath d='M3.27989 3.23571L1.53642 4.97917C1.36382 5.15176 1.36383 5.43158 1.53642 5.60417C1.70901 5.77676 1.98882 5.77676 2.16139 5.60417L4.47096 3.29463C4.63371 3.13192 4.63371 2.86809 4.47096 2.70538L2.16139 0.395812C1.98883 0.22325 1.70901 0.22325 1.53642 0.395812C1.36383 0.568437 1.36383 0.84825 1.53642 1.02081L3.27989 2.76429C3.41006 2.89446 3.41006 3.10554 3.27989 3.23571Z'/%3e%3c/svg%3e\");\n  mask-image: url(\"data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 6 6' fill='var%28--bs-primary%29'%3e%3cpath d='M3.27989 3.23571L1.53642 4.97917C1.36382 5.15176 1.36383 5.43158 1.53642 5.60417C1.70901 5.77676 1.98882 5.77676 2.16139 5.60417L4.47096 3.29463C4.63371 3.13192 4.63371 2.86809 4.47096 2.70538L2.16139 0.395812C1.98883 0.22325 1.70901 0.22325 1.53642 0.395812C1.36383 0.568437 1.36383 0.84825 1.53642 1.02081L3.27989 2.76429C3.41006 2.89446 3.41006 3.10554 3.27989 3.23571Z'/%3e%3c/svg%3e\");\n  /*rtl:end:remove*/\n}\n\n.menu-show-primary .menu-item.show > .menu-link {\n  transition: color 0.2s ease;\n  color: var(--bs-primary);\n}\n.menu-show-primary .menu-item.show > .menu-link .menu-title {\n  color: var(--bs-primary);\n}\n.menu-show-primary .menu-item.show > .menu-link .menu-icon,\n.menu-show-primary .menu-item.show > .menu-link .menu-icon .svg-icon,\n.menu-show-primary .menu-item.show > .menu-link .menu-icon i {\n  color: var(--bs-primary);\n}\n.menu-show-primary .menu-item.show > .menu-link .menu-bullet .bullet {\n  background-color: var(--bs-primary);\n}\n.menu-show-primary .menu-item.show > .menu-link .menu-arrow:after {\n  mask-repeat: no-repeat;\n  mask-position: center;\n  -webkit-mask-repeat: no-repeat;\n  -webkit-mask-position: center;\n  background-color: var(--bs-primary);\n  -webkit-mask-image: url(\"data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 6 6' fill='var%28--bs-primary%29'%3e%3cpath d='M2.72011 2.76429L4.46358 1.02083C4.63618 0.848244 4.63617 0.568419 4.46358 0.395831C4.29099 0.223244 4.01118 0.223244 3.83861 0.395831L1.52904 2.70537C1.36629 2.86808 1.36629 3.13191 1.52904 3.29462L3.83861 5.60419C4.01117 5.77675 4.29099 5.77675 4.46358 5.60419C4.63617 5.43156 4.63617 5.15175 4.46358 4.97919L2.72011 3.23571C2.58994 3.10554 2.58994 2.89446 2.72011 2.76429Z'/%3e%3c/svg%3e\");\n  mask-image: url(\"data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 6 6' fill='var%28--bs-primary%29'%3e%3cpath d='M2.72011 2.76429L4.46358 1.02083C4.63618 0.848244 4.63617 0.568419 4.46358 0.395831C4.29099 0.223244 4.01118 0.223244 3.83861 0.395831L1.52904 2.70537C1.36629 2.86808 1.36629 3.13191 1.52904 3.29462L3.83861 5.60419C4.01117 5.77675 4.29099 5.77675 4.46358 5.60419C4.63617 5.43156 4.63617 5.15175 4.46358 4.97919L2.72011 3.23571C2.58994 3.10554 2.58994 2.89446 2.72011 2.76429Z'/%3e%3c/svg%3e\");\n  /*rtl:begin:remove*/\n  mask-repeat: no-repeat;\n  mask-position: center;\n  -webkit-mask-repeat: no-repeat;\n  -webkit-mask-position: center;\n  background-color: var(--bs-primary);\n  -webkit-mask-image: url(\"data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 6 6' fill='var%28--bs-primary%29'%3e%3cpath d='M3.27989 3.23571L1.53642 4.97917C1.36382 5.15176 1.36383 5.43158 1.53642 5.60417C1.70901 5.77676 1.98882 5.77676 2.16139 5.60417L4.47096 3.29463C4.63371 3.13192 4.63371 2.86809 4.47096 2.70538L2.16139 0.395812C1.98883 0.22325 1.70901 0.22325 1.53642 0.395812C1.36383 0.568437 1.36383 0.84825 1.53642 1.02081L3.27989 2.76429C3.41006 2.89446 3.41006 3.10554 3.27989 3.23571Z'/%3e%3c/svg%3e\");\n  mask-image: url(\"data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 6 6' fill='var%28--bs-primary%29'%3e%3cpath d='M3.27989 3.23571L1.53642 4.97917C1.36382 5.15176 1.36383 5.43158 1.53642 5.60417C1.70901 5.77676 1.98882 5.77676 2.16139 5.60417L4.47096 3.29463C4.63371 3.13192 4.63371 2.86809 4.47096 2.70538L2.16139 0.395812C1.98883 0.22325 1.70901 0.22325 1.53642 0.395812C1.36383 0.568437 1.36383 0.84825 1.53642 1.02081L3.27989 2.76429C3.41006 2.89446 3.41006 3.10554 3.27989 3.23571Z'/%3e%3c/svg%3e\");\n  /*rtl:end:remove*/\n}\n\n.menu-here-primary .menu-item.here > .menu-link {\n  transition: color 0.2s ease;\n  color: var(--bs-primary);\n}\n.menu-here-primary .menu-item.here > .menu-link .menu-title {\n  color: var(--bs-primary);\n}\n.menu-here-primary .menu-item.here > .menu-link .menu-icon,\n.menu-here-primary .menu-item.here > .menu-link .menu-icon .svg-icon,\n.menu-here-primary .menu-item.here > .menu-link .menu-icon i {\n  color: var(--bs-primary);\n}\n.menu-here-primary .menu-item.here > .menu-link .menu-bullet .bullet {\n  background-color: var(--bs-primary);\n}\n.menu-here-primary .menu-item.here > .menu-link .menu-arrow:after {\n  mask-repeat: no-repeat;\n  mask-position: center;\n  -webkit-mask-repeat: no-repeat;\n  -webkit-mask-position: center;\n  background-color: var(--bs-primary);\n  -webkit-mask-image: url(\"data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 6 6' fill='var%28--bs-primary%29'%3e%3cpath d='M2.72011 2.76429L4.46358 1.02083C4.63618 0.848244 4.63617 0.568419 4.46358 0.395831C4.29099 0.223244 4.01118 0.223244 3.83861 0.395831L1.52904 2.70537C1.36629 2.86808 1.36629 3.13191 1.52904 3.29462L3.83861 5.60419C4.01117 5.77675 4.29099 5.77675 4.46358 5.60419C4.63617 5.43156 4.63617 5.15175 4.46358 4.97919L2.72011 3.23571C2.58994 3.10554 2.58994 2.89446 2.72011 2.76429Z'/%3e%3c/svg%3e\");\n  mask-image: url(\"data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 6 6' fill='var%28--bs-primary%29'%3e%3cpath d='M2.72011 2.76429L4.46358 1.02083C4.63618 0.848244 4.63617 0.568419 4.46358 0.395831C4.29099 0.223244 4.01118 0.223244 3.83861 0.395831L1.52904 2.70537C1.36629 2.86808 1.36629 3.13191 1.52904 3.29462L3.83861 5.60419C4.01117 5.77675 4.29099 5.77675 4.46358 5.60419C4.63617 5.43156 4.63617 5.15175 4.46358 4.97919L2.72011 3.23571C2.58994 3.10554 2.58994 2.89446 2.72011 2.76429Z'/%3e%3c/svg%3e\");\n  /*rtl:begin:remove*/\n  mask-repeat: no-repeat;\n  mask-position: center;\n  -webkit-mask-repeat: no-repeat;\n  -webkit-mask-position: center;\n  background-color: var(--bs-primary);\n  -webkit-mask-image: url(\"data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 6 6' fill='var%28--bs-primary%29'%3e%3cpath d='M3.27989 3.23571L1.53642 4.97917C1.36382 5.15176 1.36383 5.43158 1.53642 5.60417C1.70901 5.77676 1.98882 5.77676 2.16139 5.60417L4.47096 3.29463C4.63371 3.13192 4.63371 2.86809 4.47096 2.70538L2.16139 0.395812C1.98883 0.22325 1.70901 0.22325 1.53642 0.395812C1.36383 0.568437 1.36383 0.84825 1.53642 1.02081L3.27989 2.76429C3.41006 2.89446 3.41006 3.10554 3.27989 3.23571Z'/%3e%3c/svg%3e\");\n  mask-image: url(\"data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 6 6' fill='var%28--bs-primary%29'%3e%3cpath d='M3.27989 3.23571L1.53642 4.97917C1.36382 5.15176 1.36383 5.43158 1.53642 5.60417C1.70901 5.77676 1.98882 5.77676 2.16139 5.60417L4.47096 3.29463C4.63371 3.13192 4.63371 2.86809 4.47096 2.70538L2.16139 0.395812C1.98883 0.22325 1.70901 0.22325 1.53642 0.395812C1.36383 0.568437 1.36383 0.84825 1.53642 1.02081L3.27989 2.76429C3.41006 2.89446 3.41006 3.10554 3.27989 3.23571Z'/%3e%3c/svg%3e\");\n  /*rtl:end:remove*/\n}\n\n.menu-active-primary .menu-item .menu-link.active {\n  transition: color 0.2s ease;\n  color: var(--bs-primary);\n}\n.menu-active-primary .menu-item .menu-link.active .menu-title {\n  color: var(--bs-primary);\n}\n.menu-active-primary .menu-item .menu-link.active .menu-icon,\n.menu-active-primary .menu-item .menu-link.active .menu-icon .svg-icon,\n.menu-active-primary .menu-item .menu-link.active .menu-icon i {\n  color: var(--bs-primary);\n}\n.menu-active-primary .menu-item .menu-link.active .menu-bullet .bullet {\n  background-color: var(--bs-primary);\n}\n.menu-active-primary .menu-item .menu-link.active .menu-arrow:after {\n  mask-repeat: no-repeat;\n  mask-position: center;\n  -webkit-mask-repeat: no-repeat;\n  -webkit-mask-position: center;\n  background-color: var(--bs-primary);\n  -webkit-mask-image: url(\"data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 6 6' fill='var%28--bs-primary%29'%3e%3cpath d='M2.72011 2.76429L4.46358 1.02083C4.63618 0.848244 4.63617 0.568419 4.46358 0.395831C4.29099 0.223244 4.01118 0.223244 3.83861 0.395831L1.52904 2.70537C1.36629 2.86808 1.36629 3.13191 1.52904 3.29462L3.83861 5.60419C4.01117 5.77675 4.29099 5.77675 4.46358 5.60419C4.63617 5.43156 4.63617 5.15175 4.46358 4.97919L2.72011 3.23571C2.58994 3.10554 2.58994 2.89446 2.72011 2.76429Z'/%3e%3c/svg%3e\");\n  mask-image: url(\"data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 6 6' fill='var%28--bs-primary%29'%3e%3cpath d='M2.72011 2.76429L4.46358 1.02083C4.63618 0.848244 4.63617 0.568419 4.46358 0.395831C4.29099 0.223244 4.01118 0.223244 3.83861 0.395831L1.52904 2.70537C1.36629 2.86808 1.36629 3.13191 1.52904 3.29462L3.83861 5.60419C4.01117 5.77675 4.29099 5.77675 4.46358 5.60419C4.63617 5.43156 4.63617 5.15175 4.46358 4.97919L2.72011 3.23571C2.58994 3.10554 2.58994 2.89446 2.72011 2.76429Z'/%3e%3c/svg%3e\");\n  /*rtl:begin:remove*/\n  mask-repeat: no-repeat;\n  mask-position: center;\n  -webkit-mask-repeat: no-repeat;\n  -webkit-mask-position: center;\n  background-color: var(--bs-primary);\n  -webkit-mask-image: url(\"data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 6 6' fill='var%28--bs-primary%29'%3e%3cpath d='M3.27989 3.23571L1.53642 4.97917C1.36382 5.15176 1.36383 5.43158 1.53642 5.60417C1.70901 5.77676 1.98882 5.77676 2.16139 5.60417L4.47096 3.29463C4.63371 3.13192 4.63371 2.86809 4.47096 2.70538L2.16139 0.395812C1.98883 0.22325 1.70901 0.22325 1.53642 0.395812C1.36383 0.568437 1.36383 0.84825 1.53642 1.02081L3.27989 2.76429C3.41006 2.89446 3.41006 3.10554 3.27989 3.23571Z'/%3e%3c/svg%3e\");\n  mask-image: url(\"data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 6 6' fill='var%28--bs-primary%29'%3e%3cpath d='M3.27989 3.23571L1.53642 4.97917C1.36382 5.15176 1.36383 5.43158 1.53642 5.60417C1.70901 5.77676 1.98882 5.77676 2.16139 5.60417L4.47096 3.29463C4.63371 3.13192 4.63371 2.86809 4.47096 2.70538L2.16139 0.395812C1.98883 0.22325 1.70901 0.22325 1.53642 0.395812C1.36383 0.568437 1.36383 0.84825 1.53642 1.02081L3.27989 2.76429C3.41006 2.89446 3.41006 3.10554 3.27989 3.23571Z'/%3e%3c/svg%3e\");\n  /*rtl:end:remove*/\n}\n\n.menu-state-primary .menu-item.hover:not(.here) > .menu-link:not(.disabled):not(.active):not(.here), .menu-state-primary .menu-item:not(.here) .menu-link:hover:not(.disabled):not(.active):not(.here) {\n  transition: color 0.2s ease;\n  color: var(--bs-primary);\n}\n.menu-state-primary .menu-item.hover:not(.here) > .menu-link:not(.disabled):not(.active):not(.here) .menu-title, .menu-state-primary .menu-item:not(.here) .menu-link:hover:not(.disabled):not(.active):not(.here) .menu-title {\n  color: var(--bs-primary);\n}\n.menu-state-primary .menu-item.hover:not(.here) > .menu-link:not(.disabled):not(.active):not(.here) .menu-icon,\n.menu-state-primary .menu-item.hover:not(.here) > .menu-link:not(.disabled):not(.active):not(.here) .menu-icon .svg-icon,\n.menu-state-primary .menu-item.hover:not(.here) > .menu-link:not(.disabled):not(.active):not(.here) .menu-icon i, .menu-state-primary .menu-item:not(.here) .menu-link:hover:not(.disabled):not(.active):not(.here) .menu-icon,\n.menu-state-primary .menu-item:not(.here) .menu-link:hover:not(.disabled):not(.active):not(.here) .menu-icon .svg-icon,\n.menu-state-primary .menu-item:not(.here) .menu-link:hover:not(.disabled):not(.active):not(.here) .menu-icon i {\n  color: var(--bs-primary);\n}\n.menu-state-primary .menu-item.hover:not(.here) > .menu-link:not(.disabled):not(.active):not(.here) .menu-bullet .bullet, .menu-state-primary .menu-item:not(.here) .menu-link:hover:not(.disabled):not(.active):not(.here) .menu-bullet .bullet {\n  background-color: var(--bs-primary);\n}\n.menu-state-primary .menu-item.hover:not(.here) > .menu-link:not(.disabled):not(.active):not(.here) .menu-arrow:after, .menu-state-primary .menu-item:not(.here) .menu-link:hover:not(.disabled):not(.active):not(.here) .menu-arrow:after {\n  mask-repeat: no-repeat;\n  mask-position: center;\n  -webkit-mask-repeat: no-repeat;\n  -webkit-mask-position: center;\n  background-color: var(--bs-primary);\n  -webkit-mask-image: url(\"data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 6 6' fill='var%28--bs-primary%29'%3e%3cpath d='M2.72011 2.76429L4.46358 1.02083C4.63618 0.848244 4.63617 0.568419 4.46358 0.395831C4.29099 0.223244 4.01118 0.223244 3.83861 0.395831L1.52904 2.70537C1.36629 2.86808 1.36629 3.13191 1.52904 3.29462L3.83861 5.60419C4.01117 5.77675 4.29099 5.77675 4.46358 5.60419C4.63617 5.43156 4.63617 5.15175 4.46358 4.97919L2.72011 3.23571C2.58994 3.10554 2.58994 2.89446 2.72011 2.76429Z'/%3e%3c/svg%3e\");\n  mask-image: url(\"data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 6 6' fill='var%28--bs-primary%29'%3e%3cpath d='M2.72011 2.76429L4.46358 1.02083C4.63618 0.848244 4.63617 0.568419 4.46358 0.395831C4.29099 0.223244 4.01118 0.223244 3.83861 0.395831L1.52904 2.70537C1.36629 2.86808 1.36629 3.13191 1.52904 3.29462L3.83861 5.60419C4.01117 5.77675 4.29099 5.77675 4.46358 5.60419C4.63617 5.43156 4.63617 5.15175 4.46358 4.97919L2.72011 3.23571C2.58994 3.10554 2.58994 2.89446 2.72011 2.76429Z'/%3e%3c/svg%3e\");\n  /*rtl:begin:remove*/\n  mask-repeat: no-repeat;\n  mask-position: center;\n  -webkit-mask-repeat: no-repeat;\n  -webkit-mask-position: center;\n  background-color: var(--bs-primary);\n  -webkit-mask-image: url(\"data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 6 6' fill='var%28--bs-primary%29'%3e%3cpath d='M3.27989 3.23571L1.53642 4.97917C1.36382 5.15176 1.36383 5.43158 1.53642 5.60417C1.70901 5.77676 1.98882 5.77676 2.16139 5.60417L4.47096 3.29463C4.63371 3.13192 4.63371 2.86809 4.47096 2.70538L2.16139 0.395812C1.98883 0.22325 1.70901 0.22325 1.53642 0.395812C1.36383 0.568437 1.36383 0.84825 1.53642 1.02081L3.27989 2.76429C3.41006 2.89446 3.41006 3.10554 3.27989 3.23571Z'/%3e%3c/svg%3e\");\n  mask-image: url(\"data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 6 6' fill='var%28--bs-primary%29'%3e%3cpath d='M3.27989 3.23571L1.53642 4.97917C1.36382 5.15176 1.36383 5.43158 1.53642 5.60417C1.70901 5.77676 1.98882 5.77676 2.16139 5.60417L4.47096 3.29463C4.63371 3.13192 4.63371 2.86809 4.47096 2.70538L2.16139 0.395812C1.98883 0.22325 1.70901 0.22325 1.53642 0.395812C1.36383 0.568437 1.36383 0.84825 1.53642 1.02081L3.27989 2.76429C3.41006 2.89446 3.41006 3.10554 3.27989 3.23571Z'/%3e%3c/svg%3e\");\n  /*rtl:end:remove*/\n}\n.menu-state-primary .menu-item.show > .menu-link {\n  transition: color 0.2s ease;\n  color: var(--bs-primary);\n}\n.menu-state-primary .menu-item.show > .menu-link .menu-title {\n  color: var(--bs-primary);\n}\n.menu-state-primary .menu-item.show > .menu-link .menu-icon,\n.menu-state-primary .menu-item.show > .menu-link .menu-icon .svg-icon,\n.menu-state-primary .menu-item.show > .menu-link .menu-icon i {\n  color: var(--bs-primary);\n}\n.menu-state-primary .menu-item.show > .menu-link .menu-bullet .bullet {\n  background-color: var(--bs-primary);\n}\n.menu-state-primary .menu-item.show > .menu-link .menu-arrow:after {\n  mask-repeat: no-repeat;\n  mask-position: center;\n  -webkit-mask-repeat: no-repeat;\n  -webkit-mask-position: center;\n  background-color: var(--bs-primary);\n  -webkit-mask-image: url(\"data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 6 6' fill='var%28--bs-primary%29'%3e%3cpath d='M2.72011 2.76429L4.46358 1.02083C4.63618 0.848244 4.63617 0.568419 4.46358 0.395831C4.29099 0.223244 4.01118 0.223244 3.83861 0.395831L1.52904 2.70537C1.36629 2.86808 1.36629 3.13191 1.52904 3.29462L3.83861 5.60419C4.01117 5.77675 4.29099 5.77675 4.46358 5.60419C4.63617 5.43156 4.63617 5.15175 4.46358 4.97919L2.72011 3.23571C2.58994 3.10554 2.58994 2.89446 2.72011 2.76429Z'/%3e%3c/svg%3e\");\n  mask-image: url(\"data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 6 6' fill='var%28--bs-primary%29'%3e%3cpath d='M2.72011 2.76429L4.46358 1.02083C4.63618 0.848244 4.63617 0.568419 4.46358 0.395831C4.29099 0.223244 4.01118 0.223244 3.83861 0.395831L1.52904 2.70537C1.36629 2.86808 1.36629 3.13191 1.52904 3.29462L3.83861 5.60419C4.01117 5.77675 4.29099 5.77675 4.46358 5.60419C4.63617 5.43156 4.63617 5.15175 4.46358 4.97919L2.72011 3.23571C2.58994 3.10554 2.58994 2.89446 2.72011 2.76429Z'/%3e%3c/svg%3e\");\n  /*rtl:begin:remove*/\n  mask-repeat: no-repeat;\n  mask-position: center;\n  -webkit-mask-repeat: no-repeat;\n  -webkit-mask-position: center;\n  background-color: var(--bs-primary);\n  -webkit-mask-image: url(\"data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 6 6' fill='var%28--bs-primary%29'%3e%3cpath d='M3.27989 3.23571L1.53642 4.97917C1.36382 5.15176 1.36383 5.43158 1.53642 5.60417C1.70901 5.77676 1.98882 5.77676 2.16139 5.60417L4.47096 3.29463C4.63371 3.13192 4.63371 2.86809 4.47096 2.70538L2.16139 0.395812C1.98883 0.22325 1.70901 0.22325 1.53642 0.395812C1.36383 0.568437 1.36383 0.84825 1.53642 1.02081L3.27989 2.76429C3.41006 2.89446 3.41006 3.10554 3.27989 3.23571Z'/%3e%3c/svg%3e\");\n  mask-image: url(\"data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 6 6' fill='var%28--bs-primary%29'%3e%3cpath d='M3.27989 3.23571L1.53642 4.97917C1.36382 5.15176 1.36383 5.43158 1.53642 5.60417C1.70901 5.77676 1.98882 5.77676 2.16139 5.60417L4.47096 3.29463C4.63371 3.13192 4.63371 2.86809 4.47096 2.70538L2.16139 0.395812C1.98883 0.22325 1.70901 0.22325 1.53642 0.395812C1.36383 0.568437 1.36383 0.84825 1.53642 1.02081L3.27989 2.76429C3.41006 2.89446 3.41006 3.10554 3.27989 3.23571Z'/%3e%3c/svg%3e\");\n  /*rtl:end:remove*/\n}\n.menu-state-primary .menu-item.here > .menu-link {\n  transition: color 0.2s ease;\n  color: var(--bs-primary);\n}\n.menu-state-primary .menu-item.here > .menu-link .menu-title {\n  color: var(--bs-primary);\n}\n.menu-state-primary .menu-item.here > .menu-link .menu-icon,\n.menu-state-primary .menu-item.here > .menu-link .menu-icon .svg-icon,\n.menu-state-primary .menu-item.here > .menu-link .menu-icon i {\n  color: var(--bs-primary);\n}\n.menu-state-primary .menu-item.here > .menu-link .menu-bullet .bullet {\n  background-color: var(--bs-primary);\n}\n.menu-state-primary .menu-item.here > .menu-link .menu-arrow:after {\n  mask-repeat: no-repeat;\n  mask-position: center;\n  -webkit-mask-repeat: no-repeat;\n  -webkit-mask-position: center;\n  background-color: var(--bs-primary);\n  -webkit-mask-image: url(\"data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 6 6' fill='var%28--bs-primary%29'%3e%3cpath d='M2.72011 2.76429L4.46358 1.02083C4.63618 0.848244 4.63617 0.568419 4.46358 0.395831C4.29099 0.223244 4.01118 0.223244 3.83861 0.395831L1.52904 2.70537C1.36629 2.86808 1.36629 3.13191 1.52904 3.29462L3.83861 5.60419C4.01117 5.77675 4.29099 5.77675 4.46358 5.60419C4.63617 5.43156 4.63617 5.15175 4.46358 4.97919L2.72011 3.23571C2.58994 3.10554 2.58994 2.89446 2.72011 2.76429Z'/%3e%3c/svg%3e\");\n  mask-image: url(\"data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 6 6' fill='var%28--bs-primary%29'%3e%3cpath d='M2.72011 2.76429L4.46358 1.02083C4.63618 0.848244 4.63617 0.568419 4.46358 0.395831C4.29099 0.223244 4.01118 0.223244 3.83861 0.395831L1.52904 2.70537C1.36629 2.86808 1.36629 3.13191 1.52904 3.29462L3.83861 5.60419C4.01117 5.77675 4.29099 5.77675 4.46358 5.60419C4.63617 5.43156 4.63617 5.15175 4.46358 4.97919L2.72011 3.23571C2.58994 3.10554 2.58994 2.89446 2.72011 2.76429Z'/%3e%3c/svg%3e\");\n  /*rtl:begin:remove*/\n  mask-repeat: no-repeat;\n  mask-position: center;\n  -webkit-mask-repeat: no-repeat;\n  -webkit-mask-position: center;\n  background-color: var(--bs-primary);\n  -webkit-mask-image: url(\"data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 6 6' fill='var%28--bs-primary%29'%3e%3cpath d='M3.27989 3.23571L1.53642 4.97917C1.36382 5.15176 1.36383 5.43158 1.53642 5.60417C1.70901 5.77676 1.98882 5.77676 2.16139 5.60417L4.47096 3.29463C4.63371 3.13192 4.63371 2.86809 4.47096 2.70538L2.16139 0.395812C1.98883 0.22325 1.70901 0.22325 1.53642 0.395812C1.36383 0.568437 1.36383 0.84825 1.53642 1.02081L3.27989 2.76429C3.41006 2.89446 3.41006 3.10554 3.27989 3.23571Z'/%3e%3c/svg%3e\");\n  mask-image: url(\"data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 6 6' fill='var%28--bs-primary%29'%3e%3cpath d='M3.27989 3.23571L1.53642 4.97917C1.36382 5.15176 1.36383 5.43158 1.53642 5.60417C1.70901 5.77676 1.98882 5.77676 2.16139 5.60417L4.47096 3.29463C4.63371 3.13192 4.63371 2.86809 4.47096 2.70538L2.16139 0.395812C1.98883 0.22325 1.70901 0.22325 1.53642 0.395812C1.36383 0.568437 1.36383 0.84825 1.53642 1.02081L3.27989 2.76429C3.41006 2.89446 3.41006 3.10554 3.27989 3.23571Z'/%3e%3c/svg%3e\");\n  /*rtl:end:remove*/\n}\n.menu-state-primary .menu-item .menu-link.active {\n  transition: color 0.2s ease;\n  color: var(--bs-primary);\n}\n.menu-state-primary .menu-item .menu-link.active .menu-title {\n  color: var(--bs-primary);\n}\n.menu-state-primary .menu-item .menu-link.active .menu-icon,\n.menu-state-primary .menu-item .menu-link.active .menu-icon .svg-icon,\n.menu-state-primary .menu-item .menu-link.active .menu-icon i {\n  color: var(--bs-primary);\n}\n.menu-state-primary .menu-item .menu-link.active .menu-bullet .bullet {\n  background-color: var(--bs-primary);\n}\n.menu-state-primary .menu-item .menu-link.active .menu-arrow:after {\n  mask-repeat: no-repeat;\n  mask-position: center;\n  -webkit-mask-repeat: no-repeat;\n  -webkit-mask-position: center;\n  background-color: var(--bs-primary);\n  -webkit-mask-image: url(\"data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 6 6' fill='var%28--bs-primary%29'%3e%3cpath d='M2.72011 2.76429L4.46358 1.02083C4.63618 0.848244 4.63617 0.568419 4.46358 0.395831C4.29099 0.223244 4.01118 0.223244 3.83861 0.395831L1.52904 2.70537C1.36629 2.86808 1.36629 3.13191 1.52904 3.29462L3.83861 5.60419C4.01117 5.77675 4.29099 5.77675 4.46358 5.60419C4.63617 5.43156 4.63617 5.15175 4.46358 4.97919L2.72011 3.23571C2.58994 3.10554 2.58994 2.89446 2.72011 2.76429Z'/%3e%3c/svg%3e\");\n  mask-image: url(\"data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 6 6' fill='var%28--bs-primary%29'%3e%3cpath d='M2.72011 2.76429L4.46358 1.02083C4.63618 0.848244 4.63617 0.568419 4.46358 0.395831C4.29099 0.223244 4.01118 0.223244 3.83861 0.395831L1.52904 2.70537C1.36629 2.86808 1.36629 3.13191 1.52904 3.29462L3.83861 5.60419C4.01117 5.77675 4.29099 5.77675 4.46358 5.60419C4.63617 5.43156 4.63617 5.15175 4.46358 4.97919L2.72011 3.23571C2.58994 3.10554 2.58994 2.89446 2.72011 2.76429Z'/%3e%3c/svg%3e\");\n  /*rtl:begin:remove*/\n  mask-repeat: no-repeat;\n  mask-position: center;\n  -webkit-mask-repeat: no-repeat;\n  -webkit-mask-position: center;\n  background-color: var(--bs-primary);\n  -webkit-mask-image: url(\"data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 6 6' fill='var%28--bs-primary%29'%3e%3cpath d='M3.27989 3.23571L1.53642 4.97917C1.36382 5.15176 1.36383 5.43158 1.53642 5.60417C1.70901 5.77676 1.98882 5.77676 2.16139 5.60417L4.47096 3.29463C4.63371 3.13192 4.63371 2.86809 4.47096 2.70538L2.16139 0.395812C1.98883 0.22325 1.70901 0.22325 1.53642 0.395812C1.36383 0.568437 1.36383 0.84825 1.53642 1.02081L3.27989 2.76429C3.41006 2.89446 3.41006 3.10554 3.27989 3.23571Z'/%3e%3c/svg%3e\");\n  mask-image: url(\"data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 6 6' fill='var%28--bs-primary%29'%3e%3cpath d='M3.27989 3.23571L1.53642 4.97917C1.36382 5.15176 1.36383 5.43158 1.53642 5.60417C1.70901 5.77676 1.98882 5.77676 2.16139 5.60417L4.47096 3.29463C4.63371 3.13192 4.63371 2.86809 4.47096 2.70538L2.16139 0.395812C1.98883 0.22325 1.70901 0.22325 1.53642 0.395812C1.36383 0.568437 1.36383 0.84825 1.53642 1.02081L3.27989 2.76429C3.41006 2.89446 3.41006 3.10554 3.27989 3.23571Z'/%3e%3c/svg%3e\");\n  /*rtl:end:remove*/\n}\n\n.menu-state-dark .menu-item.hover:not(.here) > .menu-link:not(.disabled):not(.active):not(.here), .menu-state-dark .menu-item:not(.here) .menu-link:hover:not(.disabled):not(.active):not(.here) {\n  transition: color 0.2s ease;\n  color: var(--bs-dark);\n}\n.menu-state-dark .menu-item.hover:not(.here) > .menu-link:not(.disabled):not(.active):not(.here) .menu-title, .menu-state-dark .menu-item:not(.here) .menu-link:hover:not(.disabled):not(.active):not(.here) .menu-title {\n  color: var(--bs-dark);\n}\n.menu-state-dark .menu-item.hover:not(.here) > .menu-link:not(.disabled):not(.active):not(.here) .menu-icon,\n.menu-state-dark .menu-item.hover:not(.here) > .menu-link:not(.disabled):not(.active):not(.here) .menu-icon .svg-icon,\n.menu-state-dark .menu-item.hover:not(.here) > .menu-link:not(.disabled):not(.active):not(.here) .menu-icon i, .menu-state-dark .menu-item:not(.here) .menu-link:hover:not(.disabled):not(.active):not(.here) .menu-icon,\n.menu-state-dark .menu-item:not(.here) .menu-link:hover:not(.disabled):not(.active):not(.here) .menu-icon .svg-icon,\n.menu-state-dark .menu-item:not(.here) .menu-link:hover:not(.disabled):not(.active):not(.here) .menu-icon i {\n  color: var(--bs-dark);\n}\n.menu-state-dark .menu-item.hover:not(.here) > .menu-link:not(.disabled):not(.active):not(.here) .menu-bullet .bullet, .menu-state-dark .menu-item:not(.here) .menu-link:hover:not(.disabled):not(.active):not(.here) .menu-bullet .bullet {\n  background-color: var(--bs-dark);\n}\n.menu-state-dark .menu-item.hover:not(.here) > .menu-link:not(.disabled):not(.active):not(.here) .menu-arrow:after, .menu-state-dark .menu-item:not(.here) .menu-link:hover:not(.disabled):not(.active):not(.here) .menu-arrow:after {\n  mask-repeat: no-repeat;\n  mask-position: center;\n  -webkit-mask-repeat: no-repeat;\n  -webkit-mask-position: center;\n  background-color: var(--bs-dark);\n  -webkit-mask-image: url(\"data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 6 6' fill='var%28--bs-dark%29'%3e%3cpath d='M2.72011 2.76429L4.46358 1.02083C4.63618 0.848244 4.63617 0.568419 4.46358 0.395831C4.29099 0.223244 4.01118 0.223244 3.83861 0.395831L1.52904 2.70537C1.36629 2.86808 1.36629 3.13191 1.52904 3.29462L3.83861 5.60419C4.01117 5.77675 4.29099 5.77675 4.46358 5.60419C4.63617 5.43156 4.63617 5.15175 4.46358 4.97919L2.72011 3.23571C2.58994 3.10554 2.58994 2.89446 2.72011 2.76429Z'/%3e%3c/svg%3e\");\n  mask-image: url(\"data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 6 6' fill='var%28--bs-dark%29'%3e%3cpath d='M2.72011 2.76429L4.46358 1.02083C4.63618 0.848244 4.63617 0.568419 4.46358 0.395831C4.29099 0.223244 4.01118 0.223244 3.83861 0.395831L1.52904 2.70537C1.36629 2.86808 1.36629 3.13191 1.52904 3.29462L3.83861 5.60419C4.01117 5.77675 4.29099 5.77675 4.46358 5.60419C4.63617 5.43156 4.63617 5.15175 4.46358 4.97919L2.72011 3.23571C2.58994 3.10554 2.58994 2.89446 2.72011 2.76429Z'/%3e%3c/svg%3e\");\n  /*rtl:begin:remove*/\n  mask-repeat: no-repeat;\n  mask-position: center;\n  -webkit-mask-repeat: no-repeat;\n  -webkit-mask-position: center;\n  background-color: var(--bs-dark);\n  -webkit-mask-image: url(\"data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 6 6' fill='var%28--bs-dark%29'%3e%3cpath d='M3.27989 3.23571L1.53642 4.97917C1.36382 5.15176 1.36383 5.43158 1.53642 5.60417C1.70901 5.77676 1.98882 5.77676 2.16139 5.60417L4.47096 3.29463C4.63371 3.13192 4.63371 2.86809 4.47096 2.70538L2.16139 0.395812C1.98883 0.22325 1.70901 0.22325 1.53642 0.395812C1.36383 0.568437 1.36383 0.84825 1.53642 1.02081L3.27989 2.76429C3.41006 2.89446 3.41006 3.10554 3.27989 3.23571Z'/%3e%3c/svg%3e\");\n  mask-image: url(\"data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 6 6' fill='var%28--bs-dark%29'%3e%3cpath d='M3.27989 3.23571L1.53642 4.97917C1.36382 5.15176 1.36383 5.43158 1.53642 5.60417C1.70901 5.77676 1.98882 5.77676 2.16139 5.60417L4.47096 3.29463C4.63371 3.13192 4.63371 2.86809 4.47096 2.70538L2.16139 0.395812C1.98883 0.22325 1.70901 0.22325 1.53642 0.395812C1.36383 0.568437 1.36383 0.84825 1.53642 1.02081L3.27989 2.76429C3.41006 2.89446 3.41006 3.10554 3.27989 3.23571Z'/%3e%3c/svg%3e\");\n  /*rtl:end:remove*/\n}\n.menu-state-dark .menu-item.show > .menu-link {\n  transition: color 0.2s ease;\n  color: var(--bs-dark);\n}\n.menu-state-dark .menu-item.show > .menu-link .menu-title {\n  color: var(--bs-dark);\n}\n.menu-state-dark .menu-item.show > .menu-link .menu-icon,\n.menu-state-dark .menu-item.show > .menu-link .menu-icon .svg-icon,\n.menu-state-dark .menu-item.show > .menu-link .menu-icon i {\n  color: var(--bs-dark);\n}\n.menu-state-dark .menu-item.show > .menu-link .menu-bullet .bullet {\n  background-color: var(--bs-dark);\n}\n.menu-state-dark .menu-item.show > .menu-link .menu-arrow:after {\n  mask-repeat: no-repeat;\n  mask-position: center;\n  -webkit-mask-repeat: no-repeat;\n  -webkit-mask-position: center;\n  background-color: var(--bs-dark);\n  -webkit-mask-image: url(\"data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 6 6' fill='var%28--bs-dark%29'%3e%3cpath d='M2.72011 2.76429L4.46358 1.02083C4.63618 0.848244 4.63617 0.568419 4.46358 0.395831C4.29099 0.223244 4.01118 0.223244 3.83861 0.395831L1.52904 2.70537C1.36629 2.86808 1.36629 3.13191 1.52904 3.29462L3.83861 5.60419C4.01117 5.77675 4.29099 5.77675 4.46358 5.60419C4.63617 5.43156 4.63617 5.15175 4.46358 4.97919L2.72011 3.23571C2.58994 3.10554 2.58994 2.89446 2.72011 2.76429Z'/%3e%3c/svg%3e\");\n  mask-image: url(\"data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 6 6' fill='var%28--bs-dark%29'%3e%3cpath d='M2.72011 2.76429L4.46358 1.02083C4.63618 0.848244 4.63617 0.568419 4.46358 0.395831C4.29099 0.223244 4.01118 0.223244 3.83861 0.395831L1.52904 2.70537C1.36629 2.86808 1.36629 3.13191 1.52904 3.29462L3.83861 5.60419C4.01117 5.77675 4.29099 5.77675 4.46358 5.60419C4.63617 5.43156 4.63617 5.15175 4.46358 4.97919L2.72011 3.23571C2.58994 3.10554 2.58994 2.89446 2.72011 2.76429Z'/%3e%3c/svg%3e\");\n  /*rtl:begin:remove*/\n  mask-repeat: no-repeat;\n  mask-position: center;\n  -webkit-mask-repeat: no-repeat;\n  -webkit-mask-position: center;\n  background-color: var(--bs-dark);\n  -webkit-mask-image: url(\"data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 6 6' fill='var%28--bs-dark%29'%3e%3cpath d='M3.27989 3.23571L1.53642 4.97917C1.36382 5.15176 1.36383 5.43158 1.53642 5.60417C1.70901 5.77676 1.98882 5.77676 2.16139 5.60417L4.47096 3.29463C4.63371 3.13192 4.63371 2.86809 4.47096 2.70538L2.16139 0.395812C1.98883 0.22325 1.70901 0.22325 1.53642 0.395812C1.36383 0.568437 1.36383 0.84825 1.53642 1.02081L3.27989 2.76429C3.41006 2.89446 3.41006 3.10554 3.27989 3.23571Z'/%3e%3c/svg%3e\");\n  mask-image: url(\"data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 6 6' fill='var%28--bs-dark%29'%3e%3cpath d='M3.27989 3.23571L1.53642 4.97917C1.36382 5.15176 1.36383 5.43158 1.53642 5.60417C1.70901 5.77676 1.98882 5.77676 2.16139 5.60417L4.47096 3.29463C4.63371 3.13192 4.63371 2.86809 4.47096 2.70538L2.16139 0.395812C1.98883 0.22325 1.70901 0.22325 1.53642 0.395812C1.36383 0.568437 1.36383 0.84825 1.53642 1.02081L3.27989 2.76429C3.41006 2.89446 3.41006 3.10554 3.27989 3.23571Z'/%3e%3c/svg%3e\");\n  /*rtl:end:remove*/\n}\n.menu-state-dark .menu-item.here > .menu-link {\n  transition: color 0.2s ease;\n  color: var(--bs-dark);\n}\n.menu-state-dark .menu-item.here > .menu-link .menu-title {\n  color: var(--bs-dark);\n}\n.menu-state-dark .menu-item.here > .menu-link .menu-icon,\n.menu-state-dark .menu-item.here > .menu-link .menu-icon .svg-icon,\n.menu-state-dark .menu-item.here > .menu-link .menu-icon i {\n  color: var(--bs-dark);\n}\n.menu-state-dark .menu-item.here > .menu-link .menu-bullet .bullet {\n  background-color: var(--bs-dark);\n}\n.menu-state-dark .menu-item.here > .menu-link .menu-arrow:after {\n  mask-repeat: no-repeat;\n  mask-position: center;\n  -webkit-mask-repeat: no-repeat;\n  -webkit-mask-position: center;\n  background-color: var(--bs-dark);\n  -webkit-mask-image: url(\"data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 6 6' fill='var%28--bs-dark%29'%3e%3cpath d='M2.72011 2.76429L4.46358 1.02083C4.63618 0.848244 4.63617 0.568419 4.46358 0.395831C4.29099 0.223244 4.01118 0.223244 3.83861 0.395831L1.52904 2.70537C1.36629 2.86808 1.36629 3.13191 1.52904 3.29462L3.83861 5.60419C4.01117 5.77675 4.29099 5.77675 4.46358 5.60419C4.63617 5.43156 4.63617 5.15175 4.46358 4.97919L2.72011 3.23571C2.58994 3.10554 2.58994 2.89446 2.72011 2.76429Z'/%3e%3c/svg%3e\");\n  mask-image: url(\"data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 6 6' fill='var%28--bs-dark%29'%3e%3cpath d='M2.72011 2.76429L4.46358 1.02083C4.63618 0.848244 4.63617 0.568419 4.46358 0.395831C4.29099 0.223244 4.01118 0.223244 3.83861 0.395831L1.52904 2.70537C1.36629 2.86808 1.36629 3.13191 1.52904 3.29462L3.83861 5.60419C4.01117 5.77675 4.29099 5.77675 4.46358 5.60419C4.63617 5.43156 4.63617 5.15175 4.46358 4.97919L2.72011 3.23571C2.58994 3.10554 2.58994 2.89446 2.72011 2.76429Z'/%3e%3c/svg%3e\");\n  /*rtl:begin:remove*/\n  mask-repeat: no-repeat;\n  mask-position: center;\n  -webkit-mask-repeat: no-repeat;\n  -webkit-mask-position: center;\n  background-color: var(--bs-dark);\n  -webkit-mask-image: url(\"data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 6 6' fill='var%28--bs-dark%29'%3e%3cpath d='M3.27989 3.23571L1.53642 4.97917C1.36382 5.15176 1.36383 5.43158 1.53642 5.60417C1.70901 5.77676 1.98882 5.77676 2.16139 5.60417L4.47096 3.29463C4.63371 3.13192 4.63371 2.86809 4.47096 2.70538L2.16139 0.395812C1.98883 0.22325 1.70901 0.22325 1.53642 0.395812C1.36383 0.568437 1.36383 0.84825 1.53642 1.02081L3.27989 2.76429C3.41006 2.89446 3.41006 3.10554 3.27989 3.23571Z'/%3e%3c/svg%3e\");\n  mask-image: url(\"data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 6 6' fill='var%28--bs-dark%29'%3e%3cpath d='M3.27989 3.23571L1.53642 4.97917C1.36382 5.15176 1.36383 5.43158 1.53642 5.60417C1.70901 5.77676 1.98882 5.77676 2.16139 5.60417L4.47096 3.29463C4.63371 3.13192 4.63371 2.86809 4.47096 2.70538L2.16139 0.395812C1.98883 0.22325 1.70901 0.22325 1.53642 0.395812C1.36383 0.568437 1.36383 0.84825 1.53642 1.02081L3.27989 2.76429C3.41006 2.89446 3.41006 3.10554 3.27989 3.23571Z'/%3e%3c/svg%3e\");\n  /*rtl:end:remove*/\n}\n.menu-state-dark .menu-item .menu-link.active {\n  transition: color 0.2s ease;\n  color: var(--bs-dark);\n}\n.menu-state-dark .menu-item .menu-link.active .menu-title {\n  color: var(--bs-dark);\n}\n.menu-state-dark .menu-item .menu-link.active .menu-icon,\n.menu-state-dark .menu-item .menu-link.active .menu-icon .svg-icon,\n.menu-state-dark .menu-item .menu-link.active .menu-icon i {\n  color: var(--bs-dark);\n}\n.menu-state-dark .menu-item .menu-link.active .menu-bullet .bullet {\n  background-color: var(--bs-dark);\n}\n.menu-state-dark .menu-item .menu-link.active .menu-arrow:after {\n  mask-repeat: no-repeat;\n  mask-position: center;\n  -webkit-mask-repeat: no-repeat;\n  -webkit-mask-position: center;\n  background-color: var(--bs-dark);\n  -webkit-mask-image: url(\"data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 6 6' fill='var%28--bs-dark%29'%3e%3cpath d='M2.72011 2.76429L4.46358 1.02083C4.63618 0.848244 4.63617 0.568419 4.46358 0.395831C4.29099 0.223244 4.01118 0.223244 3.83861 0.395831L1.52904 2.70537C1.36629 2.86808 1.36629 3.13191 1.52904 3.29462L3.83861 5.60419C4.01117 5.77675 4.29099 5.77675 4.46358 5.60419C4.63617 5.43156 4.63617 5.15175 4.46358 4.97919L2.72011 3.23571C2.58994 3.10554 2.58994 2.89446 2.72011 2.76429Z'/%3e%3c/svg%3e\");\n  mask-image: url(\"data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 6 6' fill='var%28--bs-dark%29'%3e%3cpath d='M2.72011 2.76429L4.46358 1.02083C4.63618 0.848244 4.63617 0.568419 4.46358 0.395831C4.29099 0.223244 4.01118 0.223244 3.83861 0.395831L1.52904 2.70537C1.36629 2.86808 1.36629 3.13191 1.52904 3.29462L3.83861 5.60419C4.01117 5.77675 4.29099 5.77675 4.46358 5.60419C4.63617 5.43156 4.63617 5.15175 4.46358 4.97919L2.72011 3.23571C2.58994 3.10554 2.58994 2.89446 2.72011 2.76429Z'/%3e%3c/svg%3e\");\n  /*rtl:begin:remove*/\n  mask-repeat: no-repeat;\n  mask-position: center;\n  -webkit-mask-repeat: no-repeat;\n  -webkit-mask-position: center;\n  background-color: var(--bs-dark);\n  -webkit-mask-image: url(\"data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 6 6' fill='var%28--bs-dark%29'%3e%3cpath d='M3.27989 3.23571L1.53642 4.97917C1.36382 5.15176 1.36383 5.43158 1.53642 5.60417C1.70901 5.77676 1.98882 5.77676 2.16139 5.60417L4.47096 3.29463C4.63371 3.13192 4.63371 2.86809 4.47096 2.70538L2.16139 0.395812C1.98883 0.22325 1.70901 0.22325 1.53642 0.395812C1.36383 0.568437 1.36383 0.84825 1.53642 1.02081L3.27989 2.76429C3.41006 2.89446 3.41006 3.10554 3.27989 3.23571Z'/%3e%3c/svg%3e\");\n  mask-image: url(\"data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 6 6' fill='var%28--bs-dark%29'%3e%3cpath d='M3.27989 3.23571L1.53642 4.97917C1.36382 5.15176 1.36383 5.43158 1.53642 5.60417C1.70901 5.77676 1.98882 5.77676 2.16139 5.60417L4.47096 3.29463C4.63371 3.13192 4.63371 2.86809 4.47096 2.70538L2.16139 0.395812C1.98883 0.22325 1.70901 0.22325 1.53642 0.395812C1.36383 0.568437 1.36383 0.84825 1.53642 1.02081L3.27989 2.76429C3.41006 2.89446 3.41006 3.10554 3.27989 3.23571Z'/%3e%3c/svg%3e\");\n  /*rtl:end:remove*/\n}\n\n.menu-hover-title-primary .menu-item.hover:not(.here) > .menu-link:not(.disabled):not(.active):not(.here), .menu-hover-title-primary .menu-item:not(.here) .menu-link:hover:not(.disabled):not(.active):not(.here) {\n  transition: color 0.2s ease;\n  color: var(--bs-primary);\n}\n.menu-hover-title-primary .menu-item.hover:not(.here) > .menu-link:not(.disabled):not(.active):not(.here) .menu-title, .menu-hover-title-primary .menu-item:not(.here) .menu-link:hover:not(.disabled):not(.active):not(.here) .menu-title {\n  color: var(--bs-primary);\n}\n\n.menu-here-title-primary .menu-item.here > .menu-link {\n  transition: color 0.2s ease;\n  color: var(--bs-primary);\n}\n.menu-here-title-primary .menu-item.here > .menu-link .menu-title {\n  color: var(--bs-primary);\n}\n\n.menu-show-title-primary .menu-item.show > .menu-link {\n  transition: color 0.2s ease;\n  color: var(--bs-primary);\n}\n.menu-show-title-primary .menu-item.show > .menu-link .menu-title {\n  color: var(--bs-primary);\n}\n\n.menu-active-title-primary .menu-item .menu-link.active {\n  transition: color 0.2s ease;\n  color: var(--bs-primary);\n}\n.menu-active-title-primary .menu-item .menu-link.active .menu-title {\n  color: var(--bs-primary);\n}\n\n.menu-state-title-primary .menu-item.hover:not(.here) > .menu-link:not(.disabled):not(.active):not(.here), .menu-state-title-primary .menu-item:not(.here) .menu-link:hover:not(.disabled):not(.active):not(.here) {\n  transition: color 0.2s ease;\n  color: var(--bs-primary);\n}\n.menu-state-title-primary .menu-item.hover:not(.here) > .menu-link:not(.disabled):not(.active):not(.here) .menu-title, .menu-state-title-primary .menu-item:not(.here) .menu-link:hover:not(.disabled):not(.active):not(.here) .menu-title {\n  color: var(--bs-primary);\n}\n.menu-state-title-primary .menu-item.here > .menu-link {\n  transition: color 0.2s ease;\n  color: var(--bs-primary);\n}\n.menu-state-title-primary .menu-item.here > .menu-link .menu-title {\n  color: var(--bs-primary);\n}\n.menu-state-title-primary .menu-item.show > .menu-link {\n  transition: color 0.2s ease;\n  color: var(--bs-primary);\n}\n.menu-state-title-primary .menu-item.show > .menu-link .menu-title {\n  color: var(--bs-primary);\n}\n.menu-state-title-primary .menu-item .menu-link.active {\n  transition: color 0.2s ease;\n  color: var(--bs-primary);\n}\n.menu-state-title-primary .menu-item .menu-link.active .menu-title {\n  color: var(--bs-primary);\n}\n\n.menu-hover-icon-primary .menu-item.hover:not(.here) > .menu-link:not(.disabled):not(.active):not(.here), .menu-hover-icon-primary .menu-item:not(.here) .menu-link:hover:not(.disabled):not(.active):not(.here) {\n  transition: color 0.2s ease;\n}\n.menu-hover-icon-primary .menu-item.hover:not(.here) > .menu-link:not(.disabled):not(.active):not(.here) .menu-icon,\n.menu-hover-icon-primary .menu-item.hover:not(.here) > .menu-link:not(.disabled):not(.active):not(.here) .menu-icon .svg-icon,\n.menu-hover-icon-primary .menu-item.hover:not(.here) > .menu-link:not(.disabled):not(.active):not(.here) .menu-icon i, .menu-hover-icon-primary .menu-item:not(.here) .menu-link:hover:not(.disabled):not(.active):not(.here) .menu-icon,\n.menu-hover-icon-primary .menu-item:not(.here) .menu-link:hover:not(.disabled):not(.active):not(.here) .menu-icon .svg-icon,\n.menu-hover-icon-primary .menu-item:not(.here) .menu-link:hover:not(.disabled):not(.active):not(.here) .menu-icon i {\n  color: var(--bs-primary);\n}\n\n.menu-here-icon-primary .menu-item.here > .menu-link {\n  transition: color 0.2s ease;\n}\n.menu-here-icon-primary .menu-item.here > .menu-link .menu-icon,\n.menu-here-icon-primary .menu-item.here > .menu-link .menu-icon .svg-icon,\n.menu-here-icon-primary .menu-item.here > .menu-link .menu-icon i {\n  color: var(--bs-primary);\n}\n\n.menu-show-icon-primary .menu-item.show > .menu-link {\n  transition: color 0.2s ease;\n}\n.menu-show-icon-primary .menu-item.show > .menu-link .menu-icon,\n.menu-show-icon-primary .menu-item.show > .menu-link .menu-icon .svg-icon,\n.menu-show-icon-primary .menu-item.show > .menu-link .menu-icon i {\n  color: var(--bs-primary);\n}\n\n.menu-active-icon-primary .menu-item .menu-link.active {\n  transition: color 0.2s ease;\n}\n.menu-active-icon-primary .menu-item .menu-link.active .menu-icon,\n.menu-active-icon-primary .menu-item .menu-link.active .menu-icon .svg-icon,\n.menu-active-icon-primary .menu-item .menu-link.active .menu-icon i {\n  color: var(--bs-primary);\n}\n\n.menu-state-icon-primary .menu-item.hover:not(.here) > .menu-link:not(.disabled):not(.active):not(.here), .menu-state-icon-primary .menu-item:not(.here) .menu-link:hover:not(.disabled):not(.active):not(.here) {\n  transition: color 0.2s ease;\n}\n.menu-state-icon-primary .menu-item.hover:not(.here) > .menu-link:not(.disabled):not(.active):not(.here) .menu-icon,\n.menu-state-icon-primary .menu-item.hover:not(.here) > .menu-link:not(.disabled):not(.active):not(.here) .menu-icon .svg-icon,\n.menu-state-icon-primary .menu-item.hover:not(.here) > .menu-link:not(.disabled):not(.active):not(.here) .menu-icon i, .menu-state-icon-primary .menu-item:not(.here) .menu-link:hover:not(.disabled):not(.active):not(.here) .menu-icon,\n.menu-state-icon-primary .menu-item:not(.here) .menu-link:hover:not(.disabled):not(.active):not(.here) .menu-icon .svg-icon,\n.menu-state-icon-primary .menu-item:not(.here) .menu-link:hover:not(.disabled):not(.active):not(.here) .menu-icon i {\n  color: var(--bs-primary);\n}\n.menu-state-icon-primary .menu-item.here > .menu-link {\n  transition: color 0.2s ease;\n}\n.menu-state-icon-primary .menu-item.here > .menu-link .menu-icon,\n.menu-state-icon-primary .menu-item.here > .menu-link .menu-icon .svg-icon,\n.menu-state-icon-primary .menu-item.here > .menu-link .menu-icon i {\n  color: var(--bs-primary);\n}\n.menu-state-icon-primary .menu-item.show > .menu-link {\n  transition: color 0.2s ease;\n}\n.menu-state-icon-primary .menu-item.show > .menu-link .menu-icon,\n.menu-state-icon-primary .menu-item.show > .menu-link .menu-icon .svg-icon,\n.menu-state-icon-primary .menu-item.show > .menu-link .menu-icon i {\n  color: var(--bs-primary);\n}\n.menu-state-icon-primary .menu-item .menu-link.active {\n  transition: color 0.2s ease;\n}\n.menu-state-icon-primary .menu-item .menu-link.active .menu-icon,\n.menu-state-icon-primary .menu-item .menu-link.active .menu-icon .svg-icon,\n.menu-state-icon-primary .menu-item .menu-link.active .menu-icon i {\n  color: var(--bs-primary);\n}\n\n.menu-hover-bullet-primary .menu-item.hover:not(.here) > .menu-link:not(.disabled):not(.active):not(.here), .menu-hover-bullet-primary .menu-item:not(.here) .menu-link:hover:not(.disabled):not(.active):not(.here) {\n  transition: color 0.2s ease;\n}\n.menu-hover-bullet-primary .menu-item.hover:not(.here) > .menu-link:not(.disabled):not(.active):not(.here) .menu-bullet .bullet, .menu-hover-bullet-primary .menu-item:not(.here) .menu-link:hover:not(.disabled):not(.active):not(.here) .menu-bullet .bullet {\n  background-color: var(--bs-primary);\n}\n\n.menu-show-bullet-primary .menu-item.show > .menu-link {\n  transition: color 0.2s ease;\n}\n.menu-show-bullet-primary .menu-item.show > .menu-link .menu-bullet .bullet {\n  background-color: var(--bs-primary);\n}\n\n.menu-here-bullet-primary .menu-item.here > .menu-link {\n  transition: color 0.2s ease;\n}\n.menu-here-bullet-primary .menu-item.here > .menu-link .menu-bullet .bullet {\n  background-color: var(--bs-primary);\n}\n\n.menu-active-bullet-primary .menu-item .menu-link.active {\n  transition: color 0.2s ease;\n}\n.menu-active-bullet-primary .menu-item .menu-link.active .menu-bullet .bullet {\n  background-color: var(--bs-primary);\n}\n\n.menu-state-bullet-primary .menu-item.hover:not(.here) > .menu-link:not(.disabled):not(.active):not(.here), .menu-state-bullet-primary .menu-item:not(.here) .menu-link:hover:not(.disabled):not(.active):not(.here) {\n  transition: color 0.2s ease;\n}\n.menu-state-bullet-primary .menu-item.hover:not(.here) > .menu-link:not(.disabled):not(.active):not(.here) .menu-bullet .bullet, .menu-state-bullet-primary .menu-item:not(.here) .menu-link:hover:not(.disabled):not(.active):not(.here) .menu-bullet .bullet {\n  background-color: var(--bs-primary);\n}\n.menu-state-bullet-primary .menu-item.here > .menu-link {\n  transition: color 0.2s ease;\n}\n.menu-state-bullet-primary .menu-item.here > .menu-link .menu-bullet .bullet {\n  background-color: var(--bs-primary);\n}\n.menu-state-bullet-primary .menu-item.show > .menu-link {\n  transition: color 0.2s ease;\n}\n.menu-state-bullet-primary .menu-item.show > .menu-link .menu-bullet .bullet {\n  background-color: var(--bs-primary);\n}\n.menu-state-bullet-primary .menu-item .menu-link.active {\n  transition: color 0.2s ease;\n}\n.menu-state-bullet-primary .menu-item .menu-link.active .menu-bullet .bullet {\n  background-color: var(--bs-primary);\n}\n\n.menu-hover-arrow-primary .menu-item.hover:not(.here) > .menu-link:not(.disabled):not(.active):not(.here), .menu-hover-arrow-primary .menu-item:not(.here) .menu-link:hover:not(.disabled):not(.active):not(.here) {\n  transition: color 0.2s ease;\n}\n.menu-hover-arrow-primary .menu-item.hover:not(.here) > .menu-link:not(.disabled):not(.active):not(.here) .menu-arrow:after, .menu-hover-arrow-primary .menu-item:not(.here) .menu-link:hover:not(.disabled):not(.active):not(.here) .menu-arrow:after {\n  mask-repeat: no-repeat;\n  mask-position: center;\n  -webkit-mask-repeat: no-repeat;\n  -webkit-mask-position: center;\n  background-color: var(--bs-primary);\n  -webkit-mask-image: url(\"data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 6 6' fill='var%28--bs-primary%29'%3e%3cpath d='M2.72011 2.76429L4.46358 1.02083C4.63618 0.848244 4.63617 0.568419 4.46358 0.395831C4.29099 0.223244 4.01118 0.223244 3.83861 0.395831L1.52904 2.70537C1.36629 2.86808 1.36629 3.13191 1.52904 3.29462L3.83861 5.60419C4.01117 5.77675 4.29099 5.77675 4.46358 5.60419C4.63617 5.43156 4.63617 5.15175 4.46358 4.97919L2.72011 3.23571C2.58994 3.10554 2.58994 2.89446 2.72011 2.76429Z'/%3e%3c/svg%3e\");\n  mask-image: url(\"data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 6 6' fill='var%28--bs-primary%29'%3e%3cpath d='M2.72011 2.76429L4.46358 1.02083C4.63618 0.848244 4.63617 0.568419 4.46358 0.395831C4.29099 0.223244 4.01118 0.223244 3.83861 0.395831L1.52904 2.70537C1.36629 2.86808 1.36629 3.13191 1.52904 3.29462L3.83861 5.60419C4.01117 5.77675 4.29099 5.77675 4.46358 5.60419C4.63617 5.43156 4.63617 5.15175 4.46358 4.97919L2.72011 3.23571C2.58994 3.10554 2.58994 2.89446 2.72011 2.76429Z'/%3e%3c/svg%3e\");\n  /*rtl:begin:remove*/\n  mask-repeat: no-repeat;\n  mask-position: center;\n  -webkit-mask-repeat: no-repeat;\n  -webkit-mask-position: center;\n  background-color: var(--bs-primary);\n  -webkit-mask-image: url(\"data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 6 6' fill='var%28--bs-primary%29'%3e%3cpath d='M3.27989 3.23571L1.53642 4.97917C1.36382 5.15176 1.36383 5.43158 1.53642 5.60417C1.70901 5.77676 1.98882 5.77676 2.16139 5.60417L4.47096 3.29463C4.63371 3.13192 4.63371 2.86809 4.47096 2.70538L2.16139 0.395812C1.98883 0.22325 1.70901 0.22325 1.53642 0.395812C1.36383 0.568437 1.36383 0.84825 1.53642 1.02081L3.27989 2.76429C3.41006 2.89446 3.41006 3.10554 3.27989 3.23571Z'/%3e%3c/svg%3e\");\n  mask-image: url(\"data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 6 6' fill='var%28--bs-primary%29'%3e%3cpath d='M3.27989 3.23571L1.53642 4.97917C1.36382 5.15176 1.36383 5.43158 1.53642 5.60417C1.70901 5.77676 1.98882 5.77676 2.16139 5.60417L4.47096 3.29463C4.63371 3.13192 4.63371 2.86809 4.47096 2.70538L2.16139 0.395812C1.98883 0.22325 1.70901 0.22325 1.53642 0.395812C1.36383 0.568437 1.36383 0.84825 1.53642 1.02081L3.27989 2.76429C3.41006 2.89446 3.41006 3.10554 3.27989 3.23571Z'/%3e%3c/svg%3e\");\n  /*rtl:end:remove*/\n}\n\n.menu-here-arrow-primary .menu-item.here > .menu-link {\n  transition: color 0.2s ease;\n}\n.menu-here-arrow-primary .menu-item.here > .menu-link .menu-arrow:after {\n  mask-repeat: no-repeat;\n  mask-position: center;\n  -webkit-mask-repeat: no-repeat;\n  -webkit-mask-position: center;\n  background-color: var(--bs-primary);\n  -webkit-mask-image: url(\"data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 6 6' fill='var%28--bs-primary%29'%3e%3cpath d='M2.72011 2.76429L4.46358 1.02083C4.63618 0.848244 4.63617 0.568419 4.46358 0.395831C4.29099 0.223244 4.01118 0.223244 3.83861 0.395831L1.52904 2.70537C1.36629 2.86808 1.36629 3.13191 1.52904 3.29462L3.83861 5.60419C4.01117 5.77675 4.29099 5.77675 4.46358 5.60419C4.63617 5.43156 4.63617 5.15175 4.46358 4.97919L2.72011 3.23571C2.58994 3.10554 2.58994 2.89446 2.72011 2.76429Z'/%3e%3c/svg%3e\");\n  mask-image: url(\"data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 6 6' fill='var%28--bs-primary%29'%3e%3cpath d='M2.72011 2.76429L4.46358 1.02083C4.63618 0.848244 4.63617 0.568419 4.46358 0.395831C4.29099 0.223244 4.01118 0.223244 3.83861 0.395831L1.52904 2.70537C1.36629 2.86808 1.36629 3.13191 1.52904 3.29462L3.83861 5.60419C4.01117 5.77675 4.29099 5.77675 4.46358 5.60419C4.63617 5.43156 4.63617 5.15175 4.46358 4.97919L2.72011 3.23571C2.58994 3.10554 2.58994 2.89446 2.72011 2.76429Z'/%3e%3c/svg%3e\");\n  /*rtl:begin:remove*/\n  mask-repeat: no-repeat;\n  mask-position: center;\n  -webkit-mask-repeat: no-repeat;\n  -webkit-mask-position: center;\n  background-color: var(--bs-primary);\n  -webkit-mask-image: url(\"data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 6 6' fill='var%28--bs-primary%29'%3e%3cpath d='M3.27989 3.23571L1.53642 4.97917C1.36382 5.15176 1.36383 5.43158 1.53642 5.60417C1.70901 5.77676 1.98882 5.77676 2.16139 5.60417L4.47096 3.29463C4.63371 3.13192 4.63371 2.86809 4.47096 2.70538L2.16139 0.395812C1.98883 0.22325 1.70901 0.22325 1.53642 0.395812C1.36383 0.568437 1.36383 0.84825 1.53642 1.02081L3.27989 2.76429C3.41006 2.89446 3.41006 3.10554 3.27989 3.23571Z'/%3e%3c/svg%3e\");\n  mask-image: url(\"data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 6 6' fill='var%28--bs-primary%29'%3e%3cpath d='M3.27989 3.23571L1.53642 4.97917C1.36382 5.15176 1.36383 5.43158 1.53642 5.60417C1.70901 5.77676 1.98882 5.77676 2.16139 5.60417L4.47096 3.29463C4.63371 3.13192 4.63371 2.86809 4.47096 2.70538L2.16139 0.395812C1.98883 0.22325 1.70901 0.22325 1.53642 0.395812C1.36383 0.568437 1.36383 0.84825 1.53642 1.02081L3.27989 2.76429C3.41006 2.89446 3.41006 3.10554 3.27989 3.23571Z'/%3e%3c/svg%3e\");\n  /*rtl:end:remove*/\n}\n\n.menu-show-arrow-primary .menu-item.show > .menu-link {\n  transition: color 0.2s ease;\n}\n.menu-show-arrow-primary .menu-item.show > .menu-link .menu-arrow:after {\n  mask-repeat: no-repeat;\n  mask-position: center;\n  -webkit-mask-repeat: no-repeat;\n  -webkit-mask-position: center;\n  background-color: var(--bs-primary);\n  -webkit-mask-image: url(\"data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 6 6' fill='var%28--bs-primary%29'%3e%3cpath d='M2.72011 2.76429L4.46358 1.02083C4.63618 0.848244 4.63617 0.568419 4.46358 0.395831C4.29099 0.223244 4.01118 0.223244 3.83861 0.395831L1.52904 2.70537C1.36629 2.86808 1.36629 3.13191 1.52904 3.29462L3.83861 5.60419C4.01117 5.77675 4.29099 5.77675 4.46358 5.60419C4.63617 5.43156 4.63617 5.15175 4.46358 4.97919L2.72011 3.23571C2.58994 3.10554 2.58994 2.89446 2.72011 2.76429Z'/%3e%3c/svg%3e\");\n  mask-image: url(\"data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 6 6' fill='var%28--bs-primary%29'%3e%3cpath d='M2.72011 2.76429L4.46358 1.02083C4.63618 0.848244 4.63617 0.568419 4.46358 0.395831C4.29099 0.223244 4.01118 0.223244 3.83861 0.395831L1.52904 2.70537C1.36629 2.86808 1.36629 3.13191 1.52904 3.29462L3.83861 5.60419C4.01117 5.77675 4.29099 5.77675 4.46358 5.60419C4.63617 5.43156 4.63617 5.15175 4.46358 4.97919L2.72011 3.23571C2.58994 3.10554 2.58994 2.89446 2.72011 2.76429Z'/%3e%3c/svg%3e\");\n  /*rtl:begin:remove*/\n  mask-repeat: no-repeat;\n  mask-position: center;\n  -webkit-mask-repeat: no-repeat;\n  -webkit-mask-position: center;\n  background-color: var(--bs-primary);\n  -webkit-mask-image: url(\"data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 6 6' fill='var%28--bs-primary%29'%3e%3cpath d='M3.27989 3.23571L1.53642 4.97917C1.36382 5.15176 1.36383 5.43158 1.53642 5.60417C1.70901 5.77676 1.98882 5.77676 2.16139 5.60417L4.47096 3.29463C4.63371 3.13192 4.63371 2.86809 4.47096 2.70538L2.16139 0.395812C1.98883 0.22325 1.70901 0.22325 1.53642 0.395812C1.36383 0.568437 1.36383 0.84825 1.53642 1.02081L3.27989 2.76429C3.41006 2.89446 3.41006 3.10554 3.27989 3.23571Z'/%3e%3c/svg%3e\");\n  mask-image: url(\"data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 6 6' fill='var%28--bs-primary%29'%3e%3cpath d='M3.27989 3.23571L1.53642 4.97917C1.36382 5.15176 1.36383 5.43158 1.53642 5.60417C1.70901 5.77676 1.98882 5.77676 2.16139 5.60417L4.47096 3.29463C4.63371 3.13192 4.63371 2.86809 4.47096 2.70538L2.16139 0.395812C1.98883 0.22325 1.70901 0.22325 1.53642 0.395812C1.36383 0.568437 1.36383 0.84825 1.53642 1.02081L3.27989 2.76429C3.41006 2.89446 3.41006 3.10554 3.27989 3.23571Z'/%3e%3c/svg%3e\");\n  /*rtl:end:remove*/\n}\n\n.menu-active-arrow-primary .menu-item .menu-link.active {\n  transition: color 0.2s ease;\n}\n.menu-active-arrow-primary .menu-item .menu-link.active .menu-arrow:after {\n  mask-repeat: no-repeat;\n  mask-position: center;\n  -webkit-mask-repeat: no-repeat;\n  -webkit-mask-position: center;\n  background-color: var(--bs-primary);\n  -webkit-mask-image: url(\"data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 6 6' fill='var%28--bs-primary%29'%3e%3cpath d='M2.72011 2.76429L4.46358 1.02083C4.63618 0.848244 4.63617 0.568419 4.46358 0.395831C4.29099 0.223244 4.01118 0.223244 3.83861 0.395831L1.52904 2.70537C1.36629 2.86808 1.36629 3.13191 1.52904 3.29462L3.83861 5.60419C4.01117 5.77675 4.29099 5.77675 4.46358 5.60419C4.63617 5.43156 4.63617 5.15175 4.46358 4.97919L2.72011 3.23571C2.58994 3.10554 2.58994 2.89446 2.72011 2.76429Z'/%3e%3c/svg%3e\");\n  mask-image: url(\"data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 6 6' fill='var%28--bs-primary%29'%3e%3cpath d='M2.72011 2.76429L4.46358 1.02083C4.63618 0.848244 4.63617 0.568419 4.46358 0.395831C4.29099 0.223244 4.01118 0.223244 3.83861 0.395831L1.52904 2.70537C1.36629 2.86808 1.36629 3.13191 1.52904 3.29462L3.83861 5.60419C4.01117 5.77675 4.29099 5.77675 4.46358 5.60419C4.63617 5.43156 4.63617 5.15175 4.46358 4.97919L2.72011 3.23571C2.58994 3.10554 2.58994 2.89446 2.72011 2.76429Z'/%3e%3c/svg%3e\");\n  /*rtl:begin:remove*/\n  mask-repeat: no-repeat;\n  mask-position: center;\n  -webkit-mask-repeat: no-repeat;\n  -webkit-mask-position: center;\n  background-color: var(--bs-primary);\n  -webkit-mask-image: url(\"data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 6 6' fill='var%28--bs-primary%29'%3e%3cpath d='M3.27989 3.23571L1.53642 4.97917C1.36382 5.15176 1.36383 5.43158 1.53642 5.60417C1.70901 5.77676 1.98882 5.77676 2.16139 5.60417L4.47096 3.29463C4.63371 3.13192 4.63371 2.86809 4.47096 2.70538L2.16139 0.395812C1.98883 0.22325 1.70901 0.22325 1.53642 0.395812C1.36383 0.568437 1.36383 0.84825 1.53642 1.02081L3.27989 2.76429C3.41006 2.89446 3.41006 3.10554 3.27989 3.23571Z'/%3e%3c/svg%3e\");\n  mask-image: url(\"data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 6 6' fill='var%28--bs-primary%29'%3e%3cpath d='M3.27989 3.23571L1.53642 4.97917C1.36382 5.15176 1.36383 5.43158 1.53642 5.60417C1.70901 5.77676 1.98882 5.77676 2.16139 5.60417L4.47096 3.29463C4.63371 3.13192 4.63371 2.86809 4.47096 2.70538L2.16139 0.395812C1.98883 0.22325 1.70901 0.22325 1.53642 0.395812C1.36383 0.568437 1.36383 0.84825 1.53642 1.02081L3.27989 2.76429C3.41006 2.89446 3.41006 3.10554 3.27989 3.23571Z'/%3e%3c/svg%3e\");\n  /*rtl:end:remove*/\n}\n\n.menu-state-arrow-primary .menu-item.hover:not(.here) > .menu-link:not(.disabled):not(.active):not(.here), .menu-state-arrow-primary .menu-item:not(.here) .menu-link:hover:not(.disabled):not(.active):not(.here) {\n  transition: color 0.2s ease;\n}\n.menu-state-arrow-primary .menu-item.hover:not(.here) > .menu-link:not(.disabled):not(.active):not(.here) .menu-arrow:after, .menu-state-arrow-primary .menu-item:not(.here) .menu-link:hover:not(.disabled):not(.active):not(.here) .menu-arrow:after {\n  mask-repeat: no-repeat;\n  mask-position: center;\n  -webkit-mask-repeat: no-repeat;\n  -webkit-mask-position: center;\n  background-color: var(--bs-primary);\n  -webkit-mask-image: url(\"data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 6 6' fill='var%28--bs-primary%29'%3e%3cpath d='M2.72011 2.76429L4.46358 1.02083C4.63618 0.848244 4.63617 0.568419 4.46358 0.395831C4.29099 0.223244 4.01118 0.223244 3.83861 0.395831L1.52904 2.70537C1.36629 2.86808 1.36629 3.13191 1.52904 3.29462L3.83861 5.60419C4.01117 5.77675 4.29099 5.77675 4.46358 5.60419C4.63617 5.43156 4.63617 5.15175 4.46358 4.97919L2.72011 3.23571C2.58994 3.10554 2.58994 2.89446 2.72011 2.76429Z'/%3e%3c/svg%3e\");\n  mask-image: url(\"data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 6 6' fill='var%28--bs-primary%29'%3e%3cpath d='M2.72011 2.76429L4.46358 1.02083C4.63618 0.848244 4.63617 0.568419 4.46358 0.395831C4.29099 0.223244 4.01118 0.223244 3.83861 0.395831L1.52904 2.70537C1.36629 2.86808 1.36629 3.13191 1.52904 3.29462L3.83861 5.60419C4.01117 5.77675 4.29099 5.77675 4.46358 5.60419C4.63617 5.43156 4.63617 5.15175 4.46358 4.97919L2.72011 3.23571C2.58994 3.10554 2.58994 2.89446 2.72011 2.76429Z'/%3e%3c/svg%3e\");\n  /*rtl:begin:remove*/\n  mask-repeat: no-repeat;\n  mask-position: center;\n  -webkit-mask-repeat: no-repeat;\n  -webkit-mask-position: center;\n  background-color: var(--bs-primary);\n  -webkit-mask-image: url(\"data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 6 6' fill='var%28--bs-primary%29'%3e%3cpath d='M3.27989 3.23571L1.53642 4.97917C1.36382 5.15176 1.36383 5.43158 1.53642 5.60417C1.70901 5.77676 1.98882 5.77676 2.16139 5.60417L4.47096 3.29463C4.63371 3.13192 4.63371 2.86809 4.47096 2.70538L2.16139 0.395812C1.98883 0.22325 1.70901 0.22325 1.53642 0.395812C1.36383 0.568437 1.36383 0.84825 1.53642 1.02081L3.27989 2.76429C3.41006 2.89446 3.41006 3.10554 3.27989 3.23571Z'/%3e%3c/svg%3e\");\n  mask-image: url(\"data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 6 6' fill='var%28--bs-primary%29'%3e%3cpath d='M3.27989 3.23571L1.53642 4.97917C1.36382 5.15176 1.36383 5.43158 1.53642 5.60417C1.70901 5.77676 1.98882 5.77676 2.16139 5.60417L4.47096 3.29463C4.63371 3.13192 4.63371 2.86809 4.47096 2.70538L2.16139 0.395812C1.98883 0.22325 1.70901 0.22325 1.53642 0.395812C1.36383 0.568437 1.36383 0.84825 1.53642 1.02081L3.27989 2.76429C3.41006 2.89446 3.41006 3.10554 3.27989 3.23571Z'/%3e%3c/svg%3e\");\n  /*rtl:end:remove*/\n}\n.menu-state-arrow-primary .menu-item.here > .menu-link {\n  transition: color 0.2s ease;\n}\n.menu-state-arrow-primary .menu-item.here > .menu-link .menu-arrow:after {\n  mask-repeat: no-repeat;\n  mask-position: center;\n  -webkit-mask-repeat: no-repeat;\n  -webkit-mask-position: center;\n  background-color: var(--bs-primary);\n  -webkit-mask-image: url(\"data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 6 6' fill='var%28--bs-primary%29'%3e%3cpath d='M2.72011 2.76429L4.46358 1.02083C4.63618 0.848244 4.63617 0.568419 4.46358 0.395831C4.29099 0.223244 4.01118 0.223244 3.83861 0.395831L1.52904 2.70537C1.36629 2.86808 1.36629 3.13191 1.52904 3.29462L3.83861 5.60419C4.01117 5.77675 4.29099 5.77675 4.46358 5.60419C4.63617 5.43156 4.63617 5.15175 4.46358 4.97919L2.72011 3.23571C2.58994 3.10554 2.58994 2.89446 2.72011 2.76429Z'/%3e%3c/svg%3e\");\n  mask-image: url(\"data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 6 6' fill='var%28--bs-primary%29'%3e%3cpath d='M2.72011 2.76429L4.46358 1.02083C4.63618 0.848244 4.63617 0.568419 4.46358 0.395831C4.29099 0.223244 4.01118 0.223244 3.83861 0.395831L1.52904 2.70537C1.36629 2.86808 1.36629 3.13191 1.52904 3.29462L3.83861 5.60419C4.01117 5.77675 4.29099 5.77675 4.46358 5.60419C4.63617 5.43156 4.63617 5.15175 4.46358 4.97919L2.72011 3.23571C2.58994 3.10554 2.58994 2.89446 2.72011 2.76429Z'/%3e%3c/svg%3e\");\n  /*rtl:begin:remove*/\n  mask-repeat: no-repeat;\n  mask-position: center;\n  -webkit-mask-repeat: no-repeat;\n  -webkit-mask-position: center;\n  background-color: var(--bs-primary);\n  -webkit-mask-image: url(\"data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 6 6' fill='var%28--bs-primary%29'%3e%3cpath d='M3.27989 3.23571L1.53642 4.97917C1.36382 5.15176 1.36383 5.43158 1.53642 5.60417C1.70901 5.77676 1.98882 5.77676 2.16139 5.60417L4.47096 3.29463C4.63371 3.13192 4.63371 2.86809 4.47096 2.70538L2.16139 0.395812C1.98883 0.22325 1.70901 0.22325 1.53642 0.395812C1.36383 0.568437 1.36383 0.84825 1.53642 1.02081L3.27989 2.76429C3.41006 2.89446 3.41006 3.10554 3.27989 3.23571Z'/%3e%3c/svg%3e\");\n  mask-image: url(\"data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 6 6' fill='var%28--bs-primary%29'%3e%3cpath d='M3.27989 3.23571L1.53642 4.97917C1.36382 5.15176 1.36383 5.43158 1.53642 5.60417C1.70901 5.77676 1.98882 5.77676 2.16139 5.60417L4.47096 3.29463C4.63371 3.13192 4.63371 2.86809 4.47096 2.70538L2.16139 0.395812C1.98883 0.22325 1.70901 0.22325 1.53642 0.395812C1.36383 0.568437 1.36383 0.84825 1.53642 1.02081L3.27989 2.76429C3.41006 2.89446 3.41006 3.10554 3.27989 3.23571Z'/%3e%3c/svg%3e\");\n  /*rtl:end:remove*/\n}\n.menu-state-arrow-primary .menu-item.show > .menu-link {\n  transition: color 0.2s ease;\n}\n.menu-state-arrow-primary .menu-item.show > .menu-link .menu-arrow:after {\n  mask-repeat: no-repeat;\n  mask-position: center;\n  -webkit-mask-repeat: no-repeat;\n  -webkit-mask-position: center;\n  background-color: var(--bs-primary);\n  -webkit-mask-image: url(\"data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 6 6' fill='var%28--bs-primary%29'%3e%3cpath d='M2.72011 2.76429L4.46358 1.02083C4.63618 0.848244 4.63617 0.568419 4.46358 0.395831C4.29099 0.223244 4.01118 0.223244 3.83861 0.395831L1.52904 2.70537C1.36629 2.86808 1.36629 3.13191 1.52904 3.29462L3.83861 5.60419C4.01117 5.77675 4.29099 5.77675 4.46358 5.60419C4.63617 5.43156 4.63617 5.15175 4.46358 4.97919L2.72011 3.23571C2.58994 3.10554 2.58994 2.89446 2.72011 2.76429Z'/%3e%3c/svg%3e\");\n  mask-image: url(\"data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 6 6' fill='var%28--bs-primary%29'%3e%3cpath d='M2.72011 2.76429L4.46358 1.02083C4.63618 0.848244 4.63617 0.568419 4.46358 0.395831C4.29099 0.223244 4.01118 0.223244 3.83861 0.395831L1.52904 2.70537C1.36629 2.86808 1.36629 3.13191 1.52904 3.29462L3.83861 5.60419C4.01117 5.77675 4.29099 5.77675 4.46358 5.60419C4.63617 5.43156 4.63617 5.15175 4.46358 4.97919L2.72011 3.23571C2.58994 3.10554 2.58994 2.89446 2.72011 2.76429Z'/%3e%3c/svg%3e\");\n  /*rtl:begin:remove*/\n  mask-repeat: no-repeat;\n  mask-position: center;\n  -webkit-mask-repeat: no-repeat;\n  -webkit-mask-position: center;\n  background-color: var(--bs-primary);\n  -webkit-mask-image: url(\"data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 6 6' fill='var%28--bs-primary%29'%3e%3cpath d='M3.27989 3.23571L1.53642 4.97917C1.36382 5.15176 1.36383 5.43158 1.53642 5.60417C1.70901 5.77676 1.98882 5.77676 2.16139 5.60417L4.47096 3.29463C4.63371 3.13192 4.63371 2.86809 4.47096 2.70538L2.16139 0.395812C1.98883 0.22325 1.70901 0.22325 1.53642 0.395812C1.36383 0.568437 1.36383 0.84825 1.53642 1.02081L3.27989 2.76429C3.41006 2.89446 3.41006 3.10554 3.27989 3.23571Z'/%3e%3c/svg%3e\");\n  mask-image: url(\"data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 6 6' fill='var%28--bs-primary%29'%3e%3cpath d='M3.27989 3.23571L1.53642 4.97917C1.36382 5.15176 1.36383 5.43158 1.53642 5.60417C1.70901 5.77676 1.98882 5.77676 2.16139 5.60417L4.47096 3.29463C4.63371 3.13192 4.63371 2.86809 4.47096 2.70538L2.16139 0.395812C1.98883 0.22325 1.70901 0.22325 1.53642 0.395812C1.36383 0.568437 1.36383 0.84825 1.53642 1.02081L3.27989 2.76429C3.41006 2.89446 3.41006 3.10554 3.27989 3.23571Z'/%3e%3c/svg%3e\");\n  /*rtl:end:remove*/\n}\n.menu-state-arrow-primary .menu-item .menu-link.active {\n  transition: color 0.2s ease;\n}\n.menu-state-arrow-primary .menu-item .menu-link.active .menu-arrow:after {\n  mask-repeat: no-repeat;\n  mask-position: center;\n  -webkit-mask-repeat: no-repeat;\n  -webkit-mask-position: center;\n  background-color: var(--bs-primary);\n  -webkit-mask-image: url(\"data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 6 6' fill='var%28--bs-primary%29'%3e%3cpath d='M2.72011 2.76429L4.46358 1.02083C4.63618 0.848244 4.63617 0.568419 4.46358 0.395831C4.29099 0.223244 4.01118 0.223244 3.83861 0.395831L1.52904 2.70537C1.36629 2.86808 1.36629 3.13191 1.52904 3.29462L3.83861 5.60419C4.01117 5.77675 4.29099 5.77675 4.46358 5.60419C4.63617 5.43156 4.63617 5.15175 4.46358 4.97919L2.72011 3.23571C2.58994 3.10554 2.58994 2.89446 2.72011 2.76429Z'/%3e%3c/svg%3e\");\n  mask-image: url(\"data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 6 6' fill='var%28--bs-primary%29'%3e%3cpath d='M2.72011 2.76429L4.46358 1.02083C4.63618 0.848244 4.63617 0.568419 4.46358 0.395831C4.29099 0.223244 4.01118 0.223244 3.83861 0.395831L1.52904 2.70537C1.36629 2.86808 1.36629 3.13191 1.52904 3.29462L3.83861 5.60419C4.01117 5.77675 4.29099 5.77675 4.46358 5.60419C4.63617 5.43156 4.63617 5.15175 4.46358 4.97919L2.72011 3.23571C2.58994 3.10554 2.58994 2.89446 2.72011 2.76429Z'/%3e%3c/svg%3e\");\n  /*rtl:begin:remove*/\n  mask-repeat: no-repeat;\n  mask-position: center;\n  -webkit-mask-repeat: no-repeat;\n  -webkit-mask-position: center;\n  background-color: var(--bs-primary);\n  -webkit-mask-image: url(\"data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 6 6' fill='var%28--bs-primary%29'%3e%3cpath d='M3.27989 3.23571L1.53642 4.97917C1.36382 5.15176 1.36383 5.43158 1.53642 5.60417C1.70901 5.77676 1.98882 5.77676 2.16139 5.60417L4.47096 3.29463C4.63371 3.13192 4.63371 2.86809 4.47096 2.70538L2.16139 0.395812C1.98883 0.22325 1.70901 0.22325 1.53642 0.395812C1.36383 0.568437 1.36383 0.84825 1.53642 1.02081L3.27989 2.76429C3.41006 2.89446 3.41006 3.10554 3.27989 3.23571Z'/%3e%3c/svg%3e\");\n  mask-image: url(\"data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 6 6' fill='var%28--bs-primary%29'%3e%3cpath d='M3.27989 3.23571L1.53642 4.97917C1.36382 5.15176 1.36383 5.43158 1.53642 5.60417C1.70901 5.77676 1.98882 5.77676 2.16139 5.60417L4.47096 3.29463C4.63371 3.13192 4.63371 2.86809 4.47096 2.70538L2.16139 0.395812C1.98883 0.22325 1.70901 0.22325 1.53642 0.395812C1.36383 0.568437 1.36383 0.84825 1.53642 1.02081L3.27989 2.76429C3.41006 2.89446 3.41006 3.10554 3.27989 3.23571Z'/%3e%3c/svg%3e\");\n  /*rtl:end:remove*/\n}\n\n.anchor {\n  display: flex;\n  align-items: center;\n}\n.anchor a {\n  position: relative;\n  display: none;\n  align-items: center;\n  justify-content: flex-start;\n  height: 1em;\n  width: 1.25em;\n  margin-left: -1.25em;\n  font-weight: 500;\n  font-size: 0.8em;\n  color: var(--bs-text-muted);\n  transition: all 0.2s ease-in-out;\n}\n.anchor a:before {\n  content: \"#\";\n}\n.anchor:hover a {\n  display: flex;\n}\n.anchor:hover a:hover {\n  color: var(--bs-primary);\n  transition: all 0.2s ease-in-out;\n}\n\n.card {\n  /* border: 0; */\n}\n.card .card-header {\n  display: flex;\n  justify-content: space-between;\n  align-items: stretch;\n  flex-wrap: wrap;\n  min-height: 70px;\n  padding: 0 2.25rem;\n  color: var(--bs-card-cap-color);\n  background-color: $body-bg;\n  border-bottom: 1px solid var(--bs-card-border-color);\n}\n.card .card-header .card-title {\n  display: flex;\n  align-items: center;\n  margin: 0.5rem;\n  margin-left: 0;\n}\n.card .card-header .card-title.flex-column {\n  align-items: flex-start;\n  justify-content: center;\n}\n.card .card-header .card-title .card-icon {\n  margin-right: 0.75rem;\n  line-height: 0;\n}\n.card .card-header .card-title .card-icon i {\n  font-size: 1.25rem;\n  color: var(--bs-gray-600);\n  line-height: 0;\n}\n.card .card-header .card-title .card-icon i:after, .card .card-header .card-title .card-icon i:before {\n  line-height: 0;\n}\n.card .card-header .card-title .card-icon .svg-icon {\n  color: var(--bs-gray-600);\n}\n.card .card-header .card-title .card-icon .svg-icon svg {\n  height: 24px;\n  width: 24px;\n}\n.card .card-header .card-title,\n.card .card-header .card-title .card-label {\n  font-weight: 500;\n  font-size: 1.275rem;\n  color: var(--bs-text-dark);\n}\n.card .card-header .card-title .card-label {\n  margin: 0 0.75rem 0 0;\n  flex-wrap: wrap;\n}\n.card .card-header .card-title small, .card .card-header .card-title .small {\n  color: var(--bs-text-muted);\n  font-size: 1rem;\n}\n.card .card-header .card-title h1, .card .card-header .card-title .h1, .card .card-header .card-title h2, .card .card-header .card-title .h2, .card .card-header .card-title h3, .card .card-header .card-title .h3, .card .card-header .card-title h4, .card .card-header .card-title .h4, .card .card-header .card-title h5, .card .card-header .card-title .h5, .card .card-header .card-title h6, .card .card-header .card-title .h6 {\n  margin-bottom: 0;\n}\n.card .card-header .card-toolbar {\n  display: flex;\n  align-items: center;\n  margin: 0.5rem 0;\n  flex-wrap: wrap;\n}\n.card .card-body {\n  padding: 2rem 2.25rem;\n  color: var(--bs-card-color);\n  background-color: $card-body;\n}\n.card .card-footer {\n  padding: 2rem 2.25rem;\n  color: var(--bs-card-cap-color);\n  background-color: var(--bs-card-cap-bg);\n  border-top: 1px solid var(--bs-card-border-color);\n}\n.card .card-scroll {\n  position: relative;\n  overflow: auto;\n}\n.card.card-px-0 .card-header,\n.card.card-px-0 .card-body,\n.card.card-px-0 .card-footer {\n  padding-left: 0;\n  padding-right: 0;\n}\n.card.card-py-0 .card-header,\n.card.card-py-0 .card-body,\n.card.card-py-0 .card-footer {\n  padding-top: 0;\n  padding-bottom: 0;\n}\n.card.card-p-0 .card-header,\n.card.card-p-0 .card-body,\n.card.card-p-0 .card-footer {\n  padding: 0;\n}\n.card.card-dashed {\n  box-shadow: none;\n  border: 1px dashed var(--bs-border-dashed-color);\n}\n.card.card-dashed > .card-header {\n  border-bottom: 1px dashed var(--bs-border-dashed-color);\n}\n.card.card-dashed > .card-footer {\n  border-top: 1px dashed var(--bs-border-dashed-color);\n}\n.card.card-bordered {\n  box-shadow: none;\n  border: 1px solid var(--bs-border-color);\n}\n.card.card-flush > .card-header {\n  border-bottom: 0 !important;\n}\n.card.card-flush > .card-footer {\n  border-top: 0 !important;\n}\n.card.card-shadow {\n  box-shadow: var(--bs-card-box-shadow);\n  border: 0;\n}\n.card.card-reset {\n  border: 0 !important;\n  box-shadow: none !important;\n  background-color: transparent !important;\n}\n.card.card-reset > .card-header {\n  border-bottom: 0 !important;\n}\n.card.card-reset > .card-footer {\n  border-top: 0 !important;\n}\n.card.card-borderless {\n  border: 0 !important;\n}\n.card.card-borderless > .card-header {\n  border-bottom: 0 !important;\n}\n.card.card-borderless > .card-footer {\n  border-top: 0 !important;\n}\n.card.card-border-0 {\n  border: 0 !important;\n}\n\n.card.card-stretch {\n  height: calc(100% - var(--bs-gutter-y));\n}\n.card.card-stretch-75 {\n  height: calc(75% - var(--bs-gutter-y));\n}\n.card.card-stretch-50 {\n  height: calc(50% - var(--bs-gutter-y));\n}\n.card.card-stretch-33 {\n  height: calc(33.333% - var(--bs-gutter-y));\n}\n.card.card-stretch-25 {\n  height: calc(25% - var(--bs-gutter-y));\n}\n.card .card-header-stretch {\n  padding-top: 0 !important;\n  padding-bottom: 0 !important;\n  align-items: stretch;\n}\n.card .card-header-stretch .card-toolbar {\n  margin: 0;\n  align-items: stretch;\n}\n@media (min-width: 576px) {\n  .card.card-sm-stretch {\n    height: calc(100% - var(--bs-gutter-y));\n  }\n  .card.card-sm-stretch-75 {\n    height: calc(75% - var(--bs-gutter-y));\n  }\n  .card.card-sm-stretch-50 {\n    height: calc(50% - var(--bs-gutter-y));\n  }\n  .card.card-sm-stretch-33 {\n    height: calc(33.333% - var(--bs-gutter-y));\n  }\n  .card.card-sm-stretch-25 {\n    height: calc(25% - var(--bs-gutter-y));\n  }\n  .card .card-header-sm-stretch {\n    padding-top: 0 !important;\n    padding-bottom: 0 !important;\n    align-items: stretch;\n  }\n  .card .card-header-sm-stretch .card-toolbar {\n    margin: 0;\n    align-items: stretch;\n  }\n}\n@media (min-width: 768px) {\n  .card.card-md-stretch {\n    height: calc(100% - var(--bs-gutter-y));\n  }\n  .card.card-md-stretch-75 {\n    height: calc(75% - var(--bs-gutter-y));\n  }\n  .card.card-md-stretch-50 {\n    height: calc(50% - var(--bs-gutter-y));\n  }\n  .card.card-md-stretch-33 {\n    height: calc(33.333% - var(--bs-gutter-y));\n  }\n  .card.card-md-stretch-25 {\n    height: calc(25% - var(--bs-gutter-y));\n  }\n  .card .card-header-md-stretch {\n    padding-top: 0 !important;\n    padding-bottom: 0 !important;\n    align-items: stretch;\n  }\n  .card .card-header-md-stretch .card-toolbar {\n    margin: 0;\n    align-items: stretch;\n  }\n}\n@media (min-width: 992px) {\n  .card.card-lg-stretch {\n    height: calc(100% - var(--bs-gutter-y));\n  }\n  .card.card-lg-stretch-75 {\n    height: calc(75% - var(--bs-gutter-y));\n  }\n  .card.card-lg-stretch-50 {\n    height: calc(50% - var(--bs-gutter-y));\n  }\n  .card.card-lg-stretch-33 {\n    height: calc(33.333% - var(--bs-gutter-y));\n  }\n  .card.card-lg-stretch-25 {\n    height: calc(25% - var(--bs-gutter-y));\n  }\n  .card .card-header-lg-stretch {\n    padding-top: 0 !important;\n    padding-bottom: 0 !important;\n    align-items: stretch;\n  }\n  .card .card-header-lg-stretch .card-toolbar {\n    margin: 0;\n    align-items: stretch;\n  }\n}\n@media (min-width: 1200px) {\n  .card.card-xl-stretch {\n    height: calc(100% - var(--bs-gutter-y));\n  }\n  .card.card-xl-stretch-75 {\n    height: calc(75% - var(--bs-gutter-y));\n  }\n  .card.card-xl-stretch-50 {\n    height: calc(50% - var(--bs-gutter-y));\n  }\n  .card.card-xl-stretch-33 {\n    height: calc(33.333% - var(--bs-gutter-y));\n  }\n  .card.card-xl-stretch-25 {\n    height: calc(25% - var(--bs-gutter-y));\n  }\n  .card .card-header-xl-stretch {\n    padding-top: 0 !important;\n    padding-bottom: 0 !important;\n    align-items: stretch;\n  }\n  .card .card-header-xl-stretch .card-toolbar {\n    margin: 0;\n    align-items: stretch;\n  }\n}\n@media (min-width: 1400px) {\n  .card.card-xxl-stretch {\n    height: calc(100% - var(--bs-gutter-y));\n  }\n  .card.card-xxl-stretch-75 {\n    height: calc(75% - var(--bs-gutter-y));\n  }\n  .card.card-xxl-stretch-50 {\n    height: calc(50% - var(--bs-gutter-y));\n  }\n  .card.card-xxl-stretch-33 {\n    height: calc(33.333% - var(--bs-gutter-y));\n  }\n  .card.card-xxl-stretch-25 {\n    height: calc(25% - var(--bs-gutter-y));\n  }\n  .card .card-header-xxl-stretch {\n    padding-top: 0 !important;\n    padding-bottom: 0 !important;\n    align-items: stretch;\n  }\n  .card .card-header-xxl-stretch .card-toolbar {\n    margin: 0;\n    align-items: stretch;\n  }\n}\n\n.card-p {\n  padding: 2rem 2.25rem !important;\n}\n\n.card-px {\n  padding-left: 2.25rem !important;\n  padding-right: 2.25rem !important;\n}\n\n.card-shadow {\n  box-shadow: var(--bs-card-box-shadow);\n}\n\n.card-py {\n  padding-top: 2rem !important;\n  padding-bottom: 2rem !important;\n}\n\n.card-rounded {\n  border-radius: 0.625rem;\n}\n\n.card-rounded-start {\n  border-top-left-radius: 0.625rem;\n  border-bottom-left-radius: 0.625rem;\n}\n\n.card-rounded-end {\n  border-top-right-radius: 0.625rem;\n  border-bottom-right-radius: 0.625rem;\n}\n\n.card-rounded-top {\n  border-top-left-radius: 0.625rem;\n  border-top-right-radius: 0.625rem;\n}\n\n.card-rounded-bottom {\n  border-bottom-left-radius: 0.625rem;\n  border-bottom-right-radius: 0.625rem;\n}\n\n@media (max-width: 767.98px) {\n  .card > .card-header:not(.flex-nowrap) {\n    padding-top: 0.5rem;\n    padding-bottom: 0.5rem;\n  }\n}\n[data-bs-theme=dark] .card {\n  --bs-card-box-shadow: ;\n}\n\n.breadcrumb {\n  display: flex;\n  align-items: center;\n  background-color: transparent;\n  padding: 0;\n  margin: 0;\n}\n.breadcrumb .breadcrumb-item {\n  display: flex;\n  align-items: center;\n  padding-left: 0.5rem;\n}\n.breadcrumb .breadcrumb-item:last-child {\n  padding-right: 0;\n}\n.breadcrumb .breadcrumb-item:after {\n  padding-left: 0.5rem;\n  content: \"/\";\n}\n.breadcrumb .breadcrumb-item:before {\n  display: none;\n}\n.breadcrumb .breadcrumb-item:first-child {\n  padding-left: 0;\n}\n.breadcrumb .breadcrumb-item:last-child:after {\n  display: none;\n}\n\n.breadcrumb-line .breadcrumb-item:after {\n  content: \"-\";\n}\n\n.breadcrumb-dot .breadcrumb-item:after {\n  content: \"•\";\n}\n\n.breadcrumb-separatorless .breadcrumb-item:after {\n  display: none;\n}\n\n.btn {\n  --bs-btn-color: var(--bs-body-color);\n  outline: none !important;\n}\n.btn:not(.btn-shadow):not(.shadow):not(.shadow-sm):not(.shadow-lg):not(.shadow-xs) {\n  box-shadow: none;\n}\n.btn:not(.btn-outline):not(.btn-dashed):not(.border-hover):not(.border-active):not(.btn-flush):not(.btn-icon) {\n  border: 0;\n  padding: calc(0.775rem + 1px) calc(1.5rem + 1px);\n}\n.btn:not(.btn-outline):not(.btn-dashed):not(.border-hover):not(.border-active):not(.btn-flush):not(.btn-icon).btn-lg, .btn-group-lg > .btn:not(.btn-outline):not(.btn-dashed):not(.border-hover):not(.border-active):not(.btn-flush):not(.btn-icon) {\n  padding: calc(0.825rem + 1px) calc(1.75rem + 1px);\n}\n.btn:not(.btn-outline):not(.btn-dashed):not(.border-hover):not(.border-active):not(.btn-flush):not(.btn-icon).btn-sm, .btn-group-sm > .btn:not(.btn-outline):not(.btn-dashed):not(.border-hover):not(.border-active):not(.btn-flush):not(.btn-icon) {\n  padding: calc(0.55rem + 1px) calc(1.25rem + 1px);\n}\n.btn.btn-link {\n  border: 0;\n  border-radius: 0;\n  padding-left: 0 !important;\n  padding-right: 0 !important;\n  text-decoration: none;\n  font-weight: 500;\n}\n.btn.btn-outline:not(.btn-outline-dashed) {\n  border: 1px solid var(--bs-gray-300);\n}\n.btn.btn-outline-dashed {\n  border: 1px dashed var(--bs-gray-300);\n}\n.btn.btn-flush {\n  appearance: none;\n  box-shadow: none;\n  border-radius: 0;\n  border: none;\n  cursor: pointer;\n  background-color: transparent;\n  outline: none !important;\n  margin: 0;\n  padding: 0;\n}\n.btn.btn-flex {\n  display: inline-flex;\n  align-items: center;\n}\n.btn.btn-trim-start {\n  justify-content: flex-start !important;\n  padding-left: 0 !important;\n}\n.btn.btn-trim-end {\n  justify-content: flex-end !important;\n  padding-right: 0 !important;\n}\n\n.btn-reset {\n  background-color: transparent;\n  border: 0;\n  box-shadow: none;\n  user-select: none;\n  outline: none;\n}\n\n.btn > i {\n  display: inline-flex;\n  font-size: 1rem;\n  padding-right: 0.35rem;\n  vertical-align: middle;\n}\n.btn .svg-icon {\n  flex-shrink: 0;\n  line-height: 0;\n  margin-right: 0.5rem;\n}\n.btn.btn-icon {\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  padding: 0;\n  height: calc(1.5em + 1.55rem + 2px);\n  width: calc(1.5em + 1.55rem + 2px);\n}\n.btn.btn-icon:not(.btn-outline):not(.btn-dashed):not(.border-hover):not(.border-active):not(.btn-flush) {\n  border: 0;\n}\n.btn.btn-icon.btn-sm, .btn-group-sm > .btn.btn-icon {\n  height: calc(1.5em + 1.1rem + 2px);\n  width: calc(1.5em + 1.1rem + 2px);\n}\n.btn.btn-icon.btn-lg, .btn-group-lg > .btn.btn-icon {\n  height: calc(1.5em + 1.65rem + 2px);\n  width: calc(1.5em + 1.65rem + 2px);\n}\n.btn.btn-icon.btn-circle {\n  border-radius: 50%;\n}\n.btn.btn-icon i,\n.btn.btn-icon .svg-icon {\n  padding: 0;\n  margin: 0;\n  line-height: 1;\n}\n\n.btn.btn-outline.btn-outline-dashed {\n  border-width: 1px;\n  border-style: dashed;\n}\n.btn-check:checked + .btn.btn-outline.btn-outline-dashed, .btn-check:active + .btn.btn-outline.btn-outline-dashed, .btn.btn-outline.btn-outline-dashed:focus:not(.btn-active), .btn.btn-outline.btn-outline-dashed:hover:not(.btn-active), .btn.btn-outline.btn-outline-dashed:active:not(.btn-active), .btn.btn-outline.btn-outline-dashed.active, .btn.btn-outline.btn-outline-dashed.show, .show > .btn.btn-outline.btn-outline-dashed {\n  border-color: var(--bs-primary);\n}\n\n.btn.btn-light {\n  color: var(--bs-light-inverse);\n  border-color: var(--bs-light);\n  background-color: var(--bs-light);\n}\n.btn.btn-light i,\n.btn.btn-light .svg-icon {\n  color: var(--bs-light-inverse);\n}\n.btn.btn-light.dropdown-toggle:after {\n  color: var(--bs-light-inverse);\n}\n.btn-check:checked + .btn.btn-light, .btn-check:active + .btn.btn-light, .btn.btn-light:focus:not(.btn-active), .btn.btn-light:hover:not(.btn-active), .btn.btn-light:active:not(.btn-active), .btn.btn-light.active, .btn.btn-light.show, .show > .btn.btn-light {\n  color: var(--bs-light-inverse);\n  border-color: var(--bs-light-active);\n  background-color: var(--bs-light-active) !important;\n}\n.btn-check:checked + .btn.btn-light i,\n.btn-check:checked + .btn.btn-light .svg-icon, .btn-check:active + .btn.btn-light i,\n.btn-check:active + .btn.btn-light .svg-icon, .btn.btn-light:focus:not(.btn-active) i,\n.btn.btn-light:focus:not(.btn-active) .svg-icon, .btn.btn-light:hover:not(.btn-active) i,\n.btn.btn-light:hover:not(.btn-active) .svg-icon, .btn.btn-light:active:not(.btn-active) i,\n.btn.btn-light:active:not(.btn-active) .svg-icon, .btn.btn-light.active i,\n.btn.btn-light.active .svg-icon, .btn.btn-light.show i,\n.btn.btn-light.show .svg-icon, .show > .btn.btn-light i,\n.show > .btn.btn-light .svg-icon {\n  color: var(--bs-light-inverse);\n}\n.btn-check:checked + .btn.btn-light.dropdown-toggle:after, .btn-check:active + .btn.btn-light.dropdown-toggle:after, .btn.btn-light:focus:not(.btn-active).dropdown-toggle:after, .btn.btn-light:hover:not(.btn-active).dropdown-toggle:after, .btn.btn-light:active:not(.btn-active).dropdown-toggle:after, .btn.btn-light.active.dropdown-toggle:after, .btn.btn-light.show.dropdown-toggle:after, .show > .btn.btn-light.dropdown-toggle:after {\n  color: var(--bs-light-inverse);\n}\n\n.btn.btn-bg-light {\n  border-color: var(--bs-light);\n  background-color: var(--bs-light);\n}\n.btn-check:checked + .btn.btn-active-light, .btn-check:active + .btn.btn-active-light, .btn.btn-active-light:focus:not(.btn-active), .btn.btn-active-light:hover:not(.btn-active), .btn.btn-active-light:active:not(.btn-active), .btn.btn-active-light.active, .btn.btn-active-light.show, .show > .btn.btn-active-light {\n  color: var(--bs-light-inverse);\n  border-color: var(--bs-light);\n  background-color: var(--bs-light) !important;\n}\n.btn-check:checked + .btn.btn-active-light i,\n.btn-check:checked + .btn.btn-active-light .svg-icon, .btn-check:active + .btn.btn-active-light i,\n.btn-check:active + .btn.btn-active-light .svg-icon, .btn.btn-active-light:focus:not(.btn-active) i,\n.btn.btn-active-light:focus:not(.btn-active) .svg-icon, .btn.btn-active-light:hover:not(.btn-active) i,\n.btn.btn-active-light:hover:not(.btn-active) .svg-icon, .btn.btn-active-light:active:not(.btn-active) i,\n.btn.btn-active-light:active:not(.btn-active) .svg-icon, .btn.btn-active-light.active i,\n.btn.btn-active-light.active .svg-icon, .btn.btn-active-light.show i,\n.btn.btn-active-light.show .svg-icon, .show > .btn.btn-active-light i,\n.show > .btn.btn-active-light .svg-icon {\n  color: var(--bs-light-inverse);\n}\n.btn-check:checked + .btn.btn-active-light.dropdown-toggle:after, .btn-check:active + .btn.btn-active-light.dropdown-toggle:after, .btn.btn-active-light:focus:not(.btn-active).dropdown-toggle:after, .btn.btn-active-light:hover:not(.btn-active).dropdown-toggle:after, .btn.btn-active-light:active:not(.btn-active).dropdown-toggle:after, .btn.btn-active-light.active.dropdown-toggle:after, .btn.btn-active-light.show.dropdown-toggle:after, .show > .btn.btn-active-light.dropdown-toggle:after {\n  color: var(--bs-light-inverse);\n}\n\n.btn.btn-outline.btn-outline-light {\n  color: var(--bs-light);\n  border-color: var(--bs-light);\n  background-color: transparent;\n}\n.btn.btn-outline.btn-outline-light i,\n.btn.btn-outline.btn-outline-light .svg-icon {\n  color: var(--bs-light);\n}\n.btn.btn-outline.btn-outline-light.dropdown-toggle:after {\n  color: var(--bs-light);\n}\n.btn-check:checked + .btn.btn-outline.btn-outline-light, .btn-check:active + .btn.btn-outline.btn-outline-light, .btn.btn-outline.btn-outline-light:focus:not(.btn-active), .btn.btn-outline.btn-outline-light:hover:not(.btn-active), .btn.btn-outline.btn-outline-light:active:not(.btn-active), .btn.btn-outline.btn-outline-light.active, .btn.btn-outline.btn-outline-light.show, .show > .btn.btn-outline.btn-outline-light {\n  color: var(--bs-light-active);\n  border-color: var(--bs-light);\n  background-color: var(--bs-light-light) !important;\n}\n.btn-check:checked + .btn.btn-outline.btn-outline-light i,\n.btn-check:checked + .btn.btn-outline.btn-outline-light .svg-icon, .btn-check:active + .btn.btn-outline.btn-outline-light i,\n.btn-check:active + .btn.btn-outline.btn-outline-light .svg-icon, .btn.btn-outline.btn-outline-light:focus:not(.btn-active) i,\n.btn.btn-outline.btn-outline-light:focus:not(.btn-active) .svg-icon, .btn.btn-outline.btn-outline-light:hover:not(.btn-active) i,\n.btn.btn-outline.btn-outline-light:hover:not(.btn-active) .svg-icon, .btn.btn-outline.btn-outline-light:active:not(.btn-active) i,\n.btn.btn-outline.btn-outline-light:active:not(.btn-active) .svg-icon, .btn.btn-outline.btn-outline-light.active i,\n.btn.btn-outline.btn-outline-light.active .svg-icon, .btn.btn-outline.btn-outline-light.show i,\n.btn.btn-outline.btn-outline-light.show .svg-icon, .show > .btn.btn-outline.btn-outline-light i,\n.show > .btn.btn-outline.btn-outline-light .svg-icon {\n  color: var(--bs-light-active);\n}\n.btn-check:checked + .btn.btn-outline.btn-outline-light.dropdown-toggle:after, .btn-check:active + .btn.btn-outline.btn-outline-light.dropdown-toggle:after, .btn.btn-outline.btn-outline-light:focus:not(.btn-active).dropdown-toggle:after, .btn.btn-outline.btn-outline-light:hover:not(.btn-active).dropdown-toggle:after, .btn.btn-outline.btn-outline-light:active:not(.btn-active).dropdown-toggle:after, .btn.btn-outline.btn-outline-light.active.dropdown-toggle:after, .btn.btn-outline.btn-outline-light.show.dropdown-toggle:after, .show > .btn.btn-outline.btn-outline-light.dropdown-toggle:after {\n  color: var(--bs-light-active);\n}\n\n.btn.btn-primary {\n  color: var(--bs-primary-inverse);\n  border-color: var(--bs-primary);\n  background-color: var(--bs-primary);\n}\n.btn.btn-primary i,\n.btn.btn-primary .svg-icon {\n  color: var(--bs-primary-inverse);\n}\n.btn.btn-primary.dropdown-toggle:after {\n  color: var(--bs-primary-inverse);\n}\n.btn-check:checked + .btn.btn-primary, .btn-check:active + .btn.btn-primary, .btn.btn-primary:focus:not(.btn-active), .btn.btn-primary:hover:not(.btn-active), .btn.btn-primary:active:not(.btn-active), .btn.btn-primary.active, .btn.btn-primary.show, .show > .btn.btn-primary {\n  color: var(--bs-primary-inverse);\n  border-color: var(--bs-primary-active);\n  background-color: var(--bs-primary-active) !important;\n}\n.btn-check:checked + .btn.btn-primary i,\n.btn-check:checked + .btn.btn-primary .svg-icon, .btn-check:active + .btn.btn-primary i,\n.btn-check:active + .btn.btn-primary .svg-icon, .btn.btn-primary:focus:not(.btn-active) i,\n.btn.btn-primary:focus:not(.btn-active) .svg-icon, .btn.btn-primary:hover:not(.btn-active) i,\n.btn.btn-primary:hover:not(.btn-active) .svg-icon, .btn.btn-primary:active:not(.btn-active) i,\n.btn.btn-primary:active:not(.btn-active) .svg-icon, .btn.btn-primary.active i,\n.btn.btn-primary.active .svg-icon, .btn.btn-primary.show i,\n.btn.btn-primary.show .svg-icon, .show > .btn.btn-primary i,\n.show > .btn.btn-primary .svg-icon {\n  color: var(--bs-primary-inverse);\n}\n.btn-check:checked + .btn.btn-primary.dropdown-toggle:after, .btn-check:active + .btn.btn-primary.dropdown-toggle:after, .btn.btn-primary:focus:not(.btn-active).dropdown-toggle:after, .btn.btn-primary:hover:not(.btn-active).dropdown-toggle:after, .btn.btn-primary:active:not(.btn-active).dropdown-toggle:after, .btn.btn-primary.active.dropdown-toggle:after, .btn.btn-primary.show.dropdown-toggle:after, .show > .btn.btn-primary.dropdown-toggle:after {\n  color: var(--bs-primary-inverse);\n}\n\n.btn.btn-light-primary {\n  color: var(--bs-primary);\n  border-color: var(--bs-primary-light);\n  background-color: var(--bs-primary-light);\n}\n.btn.btn-light-primary i,\n.btn.btn-light-primary .svg-icon {\n  color: var(--bs-primary);\n}\n.btn.btn-light-primary.dropdown-toggle:after {\n  color: var(--bs-primary);\n}\n.btn-check:checked + .btn.btn-light-primary, .btn-check:active + .btn.btn-light-primary, .btn.btn-light-primary:focus:not(.btn-active), .btn.btn-light-primary:hover:not(.btn-active), .btn.btn-light-primary:active:not(.btn-active), .btn.btn-light-primary.active, .btn.btn-light-primary.show, .show > .btn.btn-light-primary {\n  color: var(--bs-primary-inverse);\n  border-color: var(--bs-primary);\n  background-color: var(--bs-primary) !important;\n}\n.btn-check:checked + .btn.btn-light-primary i,\n.btn-check:checked + .btn.btn-light-primary .svg-icon, .btn-check:active + .btn.btn-light-primary i,\n.btn-check:active + .btn.btn-light-primary .svg-icon, .btn.btn-light-primary:focus:not(.btn-active) i,\n.btn.btn-light-primary:focus:not(.btn-active) .svg-icon, .btn.btn-light-primary:hover:not(.btn-active) i,\n.btn.btn-light-primary:hover:not(.btn-active) .svg-icon, .btn.btn-light-primary:active:not(.btn-active) i,\n.btn.btn-light-primary:active:not(.btn-active) .svg-icon, .btn.btn-light-primary.active i,\n.btn.btn-light-primary.active .svg-icon, .btn.btn-light-primary.show i,\n.btn.btn-light-primary.show .svg-icon, .show > .btn.btn-light-primary i,\n.show > .btn.btn-light-primary .svg-icon {\n  color: var(--bs-primary-inverse);\n}\n.btn-check:checked + .btn.btn-light-primary.dropdown-toggle:after, .btn-check:active + .btn.btn-light-primary.dropdown-toggle:after, .btn.btn-light-primary:focus:not(.btn-active).dropdown-toggle:after, .btn.btn-light-primary:hover:not(.btn-active).dropdown-toggle:after, .btn.btn-light-primary:active:not(.btn-active).dropdown-toggle:after, .btn.btn-light-primary.active.dropdown-toggle:after, .btn.btn-light-primary.show.dropdown-toggle:after, .show > .btn.btn-light-primary.dropdown-toggle:after {\n  color: var(--bs-primary-inverse);\n}\n\n.btn.btn-bg-primary {\n  border-color: var(--bs-primary);\n  background-color: var(--bs-primary);\n}\n.btn-check:checked + .btn.btn-active-primary, .btn-check:active + .btn.btn-active-primary, .btn.btn-active-primary:focus:not(.btn-active), .btn.btn-active-primary:hover:not(.btn-active), .btn.btn-active-primary:active:not(.btn-active), .btn.btn-active-primary.active, .btn.btn-active-primary.show, .show > .btn.btn-active-primary {\n  color: var(--bs-primary-inverse);\n  border-color: var(--bs-primary);\n  background-color: var(--bs-primary) !important;\n}\n.btn-check:checked + .btn.btn-active-primary i,\n.btn-check:checked + .btn.btn-active-primary .svg-icon, .btn-check:active + .btn.btn-active-primary i,\n.btn-check:active + .btn.btn-active-primary .svg-icon, .btn.btn-active-primary:focus:not(.btn-active) i,\n.btn.btn-active-primary:focus:not(.btn-active) .svg-icon, .btn.btn-active-primary:hover:not(.btn-active) i,\n.btn.btn-active-primary:hover:not(.btn-active) .svg-icon, .btn.btn-active-primary:active:not(.btn-active) i,\n.btn.btn-active-primary:active:not(.btn-active) .svg-icon, .btn.btn-active-primary.active i,\n.btn.btn-active-primary.active .svg-icon, .btn.btn-active-primary.show i,\n.btn.btn-active-primary.show .svg-icon, .show > .btn.btn-active-primary i,\n.show > .btn.btn-active-primary .svg-icon {\n  color: var(--bs-primary-inverse);\n}\n.btn-check:checked + .btn.btn-active-primary.dropdown-toggle:after, .btn-check:active + .btn.btn-active-primary.dropdown-toggle:after, .btn.btn-active-primary:focus:not(.btn-active).dropdown-toggle:after, .btn.btn-active-primary:hover:not(.btn-active).dropdown-toggle:after, .btn.btn-active-primary:active:not(.btn-active).dropdown-toggle:after, .btn.btn-active-primary.active.dropdown-toggle:after, .btn.btn-active-primary.show.dropdown-toggle:after, .show > .btn.btn-active-primary.dropdown-toggle:after {\n  color: var(--bs-primary-inverse);\n}\n\n.btn-check:checked + .btn.btn-active-light-primary, .btn-check:active + .btn.btn-active-light-primary, .btn.btn-active-light-primary:focus:not(.btn-active), .btn.btn-active-light-primary:hover:not(.btn-active), .btn.btn-active-light-primary:active:not(.btn-active), .btn.btn-active-light-primary.active, .btn.btn-active-light-primary.show, .show > .btn.btn-active-light-primary {\n  color: var(--bs-primary);\n  border-color: var(--bs-primary-light);\n  background-color: var(--bs-primary-light) !important;\n}\n.btn-check:checked + .btn.btn-active-light-primary i,\n.btn-check:checked + .btn.btn-active-light-primary .svg-icon, .btn-check:active + .btn.btn-active-light-primary i,\n.btn-check:active + .btn.btn-active-light-primary .svg-icon, .btn.btn-active-light-primary:focus:not(.btn-active) i,\n.btn.btn-active-light-primary:focus:not(.btn-active) .svg-icon, .btn.btn-active-light-primary:hover:not(.btn-active) i,\n.btn.btn-active-light-primary:hover:not(.btn-active) .svg-icon, .btn.btn-active-light-primary:active:not(.btn-active) i,\n.btn.btn-active-light-primary:active:not(.btn-active) .svg-icon, .btn.btn-active-light-primary.active i,\n.btn.btn-active-light-primary.active .svg-icon, .btn.btn-active-light-primary.show i,\n.btn.btn-active-light-primary.show .svg-icon, .show > .btn.btn-active-light-primary i,\n.show > .btn.btn-active-light-primary .svg-icon {\n  color: var(--bs-primary);\n}\n.btn-check:checked + .btn.btn-active-light-primary.dropdown-toggle:after, .btn-check:active + .btn.btn-active-light-primary.dropdown-toggle:after, .btn.btn-active-light-primary:focus:not(.btn-active).dropdown-toggle:after, .btn.btn-active-light-primary:hover:not(.btn-active).dropdown-toggle:after, .btn.btn-active-light-primary:active:not(.btn-active).dropdown-toggle:after, .btn.btn-active-light-primary.active.dropdown-toggle:after, .btn.btn-active-light-primary.show.dropdown-toggle:after, .show > .btn.btn-active-light-primary.dropdown-toggle:after {\n  color: var(--bs-primary);\n}\n\n.btn.btn-outline.btn-outline-primary {\n  color: var(--bs-primary);\n  border-color: var(--bs-primary);\n  background-color: transparent;\n}\n.btn.btn-outline.btn-outline-primary i,\n.btn.btn-outline.btn-outline-primary .svg-icon {\n  color: var(--bs-primary);\n}\n.btn.btn-outline.btn-outline-primary.dropdown-toggle:after {\n  color: var(--bs-primary);\n}\n.btn-check:checked + .btn.btn-outline.btn-outline-primary, .btn-check:active + .btn.btn-outline.btn-outline-primary, .btn.btn-outline.btn-outline-primary:focus:not(.btn-active), .btn.btn-outline.btn-outline-primary:hover:not(.btn-active), .btn.btn-outline.btn-outline-primary:active:not(.btn-active), .btn.btn-outline.btn-outline-primary.active, .btn.btn-outline.btn-outline-primary.show, .show > .btn.btn-outline.btn-outline-primary {\n  color: var(--bs-primary-active);\n  border-color: var(--bs-primary);\n  background-color: var(--bs-primary-light) !important;\n}\n.btn-check:checked + .btn.btn-outline.btn-outline-primary i,\n.btn-check:checked + .btn.btn-outline.btn-outline-primary .svg-icon, .btn-check:active + .btn.btn-outline.btn-outline-primary i,\n.btn-check:active + .btn.btn-outline.btn-outline-primary .svg-icon, .btn.btn-outline.btn-outline-primary:focus:not(.btn-active) i,\n.btn.btn-outline.btn-outline-primary:focus:not(.btn-active) .svg-icon, .btn.btn-outline.btn-outline-primary:hover:not(.btn-active) i,\n.btn.btn-outline.btn-outline-primary:hover:not(.btn-active) .svg-icon, .btn.btn-outline.btn-outline-primary:active:not(.btn-active) i,\n.btn.btn-outline.btn-outline-primary:active:not(.btn-active) .svg-icon, .btn.btn-outline.btn-outline-primary.active i,\n.btn.btn-outline.btn-outline-primary.active .svg-icon, .btn.btn-outline.btn-outline-primary.show i,\n.btn.btn-outline.btn-outline-primary.show .svg-icon, .show > .btn.btn-outline.btn-outline-primary i,\n.show > .btn.btn-outline.btn-outline-primary .svg-icon {\n  color: var(--bs-primary-active);\n}\n.btn-check:checked + .btn.btn-outline.btn-outline-primary.dropdown-toggle:after, .btn-check:active + .btn.btn-outline.btn-outline-primary.dropdown-toggle:after, .btn.btn-outline.btn-outline-primary:focus:not(.btn-active).dropdown-toggle:after, .btn.btn-outline.btn-outline-primary:hover:not(.btn-active).dropdown-toggle:after, .btn.btn-outline.btn-outline-primary:active:not(.btn-active).dropdown-toggle:after, .btn.btn-outline.btn-outline-primary.active.dropdown-toggle:after, .btn.btn-outline.btn-outline-primary.show.dropdown-toggle:after, .show > .btn.btn-outline.btn-outline-primary.dropdown-toggle:after {\n  color: var(--bs-primary-active);\n}\n\n.btn.btn-secondary {\n  color: var(--bs-secondary-inverse);\n  border-color: var(--bs-secondary);\n  background-color: var(--bs-secondary);\n}\n.btn.btn-secondary i,\n.btn.btn-secondary .svg-icon {\n  color: var(--bs-secondary-inverse);\n}\n.btn.btn-secondary.dropdown-toggle:after {\n  color: var(--bs-secondary-inverse);\n}\n.btn-check:checked + .btn.btn-secondary, .btn-check:active + .btn.btn-secondary, .btn.btn-secondary:focus:not(.btn-active), .btn.btn-secondary:hover:not(.btn-active), .btn.btn-secondary:active:not(.btn-active), .btn.btn-secondary.active, .btn.btn-secondary.show, .show > .btn.btn-secondary {\n  color: var(--bs-secondary-inverse);\n  border-color: var(--bs-secondary-active);\n  background-color: var(--bs-secondary-active) !important;\n}\n.btn-check:checked + .btn.btn-secondary i,\n.btn-check:checked + .btn.btn-secondary .svg-icon, .btn-check:active + .btn.btn-secondary i,\n.btn-check:active + .btn.btn-secondary .svg-icon, .btn.btn-secondary:focus:not(.btn-active) i,\n.btn.btn-secondary:focus:not(.btn-active) .svg-icon, .btn.btn-secondary:hover:not(.btn-active) i,\n.btn.btn-secondary:hover:not(.btn-active) .svg-icon, .btn.btn-secondary:active:not(.btn-active) i,\n.btn.btn-secondary:active:not(.btn-active) .svg-icon, .btn.btn-secondary.active i,\n.btn.btn-secondary.active .svg-icon, .btn.btn-secondary.show i,\n.btn.btn-secondary.show .svg-icon, .show > .btn.btn-secondary i,\n.show > .btn.btn-secondary .svg-icon {\n  color: var(--bs-secondary-inverse);\n}\n.btn-check:checked + .btn.btn-secondary.dropdown-toggle:after, .btn-check:active + .btn.btn-secondary.dropdown-toggle:after, .btn.btn-secondary:focus:not(.btn-active).dropdown-toggle:after, .btn.btn-secondary:hover:not(.btn-active).dropdown-toggle:after, .btn.btn-secondary:active:not(.btn-active).dropdown-toggle:after, .btn.btn-secondary.active.dropdown-toggle:after, .btn.btn-secondary.show.dropdown-toggle:after, .show > .btn.btn-secondary.dropdown-toggle:after {\n  color: var(--bs-secondary-inverse);\n}\n\n.btn.btn-light-secondary {\n  color: var(--bs-secondary);\n  border-color: var(--bs-secondary-light);\n  background-color: var(--bs-secondary-light);\n}\n.btn.btn-light-secondary i,\n.btn.btn-light-secondary .svg-icon {\n  color: var(--bs-secondary);\n}\n.btn.btn-light-secondary.dropdown-toggle:after {\n  color: var(--bs-secondary);\n}\n.btn-check:checked + .btn.btn-light-secondary, .btn-check:active + .btn.btn-light-secondary, .btn.btn-light-secondary:focus:not(.btn-active), .btn.btn-light-secondary:hover:not(.btn-active), .btn.btn-light-secondary:active:not(.btn-active), .btn.btn-light-secondary.active, .btn.btn-light-secondary.show, .show > .btn.btn-light-secondary {\n  color: var(--bs-secondary-inverse);\n  border-color: var(--bs-secondary);\n  background-color: var(--bs-secondary) !important;\n}\n.btn-check:checked + .btn.btn-light-secondary i,\n.btn-check:checked + .btn.btn-light-secondary .svg-icon, .btn-check:active + .btn.btn-light-secondary i,\n.btn-check:active + .btn.btn-light-secondary .svg-icon, .btn.btn-light-secondary:focus:not(.btn-active) i,\n.btn.btn-light-secondary:focus:not(.btn-active) .svg-icon, .btn.btn-light-secondary:hover:not(.btn-active) i,\n.btn.btn-light-secondary:hover:not(.btn-active) .svg-icon, .btn.btn-light-secondary:active:not(.btn-active) i,\n.btn.btn-light-secondary:active:not(.btn-active) .svg-icon, .btn.btn-light-secondary.active i,\n.btn.btn-light-secondary.active .svg-icon, .btn.btn-light-secondary.show i,\n.btn.btn-light-secondary.show .svg-icon, .show > .btn.btn-light-secondary i,\n.show > .btn.btn-light-secondary .svg-icon {\n  color: var(--bs-secondary-inverse);\n}\n.btn-check:checked + .btn.btn-light-secondary.dropdown-toggle:after, .btn-check:active + .btn.btn-light-secondary.dropdown-toggle:after, .btn.btn-light-secondary:focus:not(.btn-active).dropdown-toggle:after, .btn.btn-light-secondary:hover:not(.btn-active).dropdown-toggle:after, .btn.btn-light-secondary:active:not(.btn-active).dropdown-toggle:after, .btn.btn-light-secondary.active.dropdown-toggle:after, .btn.btn-light-secondary.show.dropdown-toggle:after, .show > .btn.btn-light-secondary.dropdown-toggle:after {\n  color: var(--bs-secondary-inverse);\n}\n\n.btn.btn-bg-secondary {\n  border-color: var(--bs-secondary);\n  background-color: var(--bs-secondary);\n}\n.btn-check:checked + .btn.btn-active-secondary, .btn-check:active + .btn.btn-active-secondary, .btn.btn-active-secondary:focus:not(.btn-active), .btn.btn-active-secondary:hover:not(.btn-active), .btn.btn-active-secondary:active:not(.btn-active), .btn.btn-active-secondary.active, .btn.btn-active-secondary.show, .show > .btn.btn-active-secondary {\n  color: var(--bs-secondary-inverse);\n  border-color: var(--bs-secondary);\n  background-color: var(--bs-secondary) !important;\n}\n.btn-check:checked + .btn.btn-active-secondary i,\n.btn-check:checked + .btn.btn-active-secondary .svg-icon, .btn-check:active + .btn.btn-active-secondary i,\n.btn-check:active + .btn.btn-active-secondary .svg-icon, .btn.btn-active-secondary:focus:not(.btn-active) i,\n.btn.btn-active-secondary:focus:not(.btn-active) .svg-icon, .btn.btn-active-secondary:hover:not(.btn-active) i,\n.btn.btn-active-secondary:hover:not(.btn-active) .svg-icon, .btn.btn-active-secondary:active:not(.btn-active) i,\n.btn.btn-active-secondary:active:not(.btn-active) .svg-icon, .btn.btn-active-secondary.active i,\n.btn.btn-active-secondary.active .svg-icon, .btn.btn-active-secondary.show i,\n.btn.btn-active-secondary.show .svg-icon, .show > .btn.btn-active-secondary i,\n.show > .btn.btn-active-secondary .svg-icon {\n  color: var(--bs-secondary-inverse);\n}\n.btn-check:checked + .btn.btn-active-secondary.dropdown-toggle:after, .btn-check:active + .btn.btn-active-secondary.dropdown-toggle:after, .btn.btn-active-secondary:focus:not(.btn-active).dropdown-toggle:after, .btn.btn-active-secondary:hover:not(.btn-active).dropdown-toggle:after, .btn.btn-active-secondary:active:not(.btn-active).dropdown-toggle:after, .btn.btn-active-secondary.active.dropdown-toggle:after, .btn.btn-active-secondary.show.dropdown-toggle:after, .show > .btn.btn-active-secondary.dropdown-toggle:after {\n  color: var(--bs-secondary-inverse);\n}\n\n.btn-check:checked + .btn.btn-active-light-secondary, .btn-check:active + .btn.btn-active-light-secondary, .btn.btn-active-light-secondary:focus:not(.btn-active), .btn.btn-active-light-secondary:hover:not(.btn-active), .btn.btn-active-light-secondary:active:not(.btn-active), .btn.btn-active-light-secondary.active, .btn.btn-active-light-secondary.show, .show > .btn.btn-active-light-secondary {\n  color: var(--bs-secondary);\n  border-color: var(--bs-secondary-light);\n  background-color: var(--bs-secondary-light) !important;\n}\n.btn-check:checked + .btn.btn-active-light-secondary i,\n.btn-check:checked + .btn.btn-active-light-secondary .svg-icon, .btn-check:active + .btn.btn-active-light-secondary i,\n.btn-check:active + .btn.btn-active-light-secondary .svg-icon, .btn.btn-active-light-secondary:focus:not(.btn-active) i,\n.btn.btn-active-light-secondary:focus:not(.btn-active) .svg-icon, .btn.btn-active-light-secondary:hover:not(.btn-active) i,\n.btn.btn-active-light-secondary:hover:not(.btn-active) .svg-icon, .btn.btn-active-light-secondary:active:not(.btn-active) i,\n.btn.btn-active-light-secondary:active:not(.btn-active) .svg-icon, .btn.btn-active-light-secondary.active i,\n.btn.btn-active-light-secondary.active .svg-icon, .btn.btn-active-light-secondary.show i,\n.btn.btn-active-light-secondary.show .svg-icon, .show > .btn.btn-active-light-secondary i,\n.show > .btn.btn-active-light-secondary .svg-icon {\n  color: var(--bs-secondary);\n}\n.btn-check:checked + .btn.btn-active-light-secondary.dropdown-toggle:after, .btn-check:active + .btn.btn-active-light-secondary.dropdown-toggle:after, .btn.btn-active-light-secondary:focus:not(.btn-active).dropdown-toggle:after, .btn.btn-active-light-secondary:hover:not(.btn-active).dropdown-toggle:after, .btn.btn-active-light-secondary:active:not(.btn-active).dropdown-toggle:after, .btn.btn-active-light-secondary.active.dropdown-toggle:after, .btn.btn-active-light-secondary.show.dropdown-toggle:after, .show > .btn.btn-active-light-secondary.dropdown-toggle:after {\n  color: var(--bs-secondary);\n}\n\n.btn.btn-outline.btn-outline-secondary {\n  color: var(--bs-secondary);\n  border-color: var(--bs-secondary);\n  background-color: transparent;\n}\n.btn.btn-outline.btn-outline-secondary i,\n.btn.btn-outline.btn-outline-secondary .svg-icon {\n  color: var(--bs-secondary);\n}\n.btn.btn-outline.btn-outline-secondary.dropdown-toggle:after {\n  color: var(--bs-secondary);\n}\n.btn-check:checked + .btn.btn-outline.btn-outline-secondary, .btn-check:active + .btn.btn-outline.btn-outline-secondary, .btn.btn-outline.btn-outline-secondary:focus:not(.btn-active), .btn.btn-outline.btn-outline-secondary:hover:not(.btn-active), .btn.btn-outline.btn-outline-secondary:active:not(.btn-active), .btn.btn-outline.btn-outline-secondary.active, .btn.btn-outline.btn-outline-secondary.show, .show > .btn.btn-outline.btn-outline-secondary {\n  color: var(--bs-secondary-active);\n  border-color: var(--bs-secondary);\n  background-color: var(--bs-secondary-light) !important;\n}\n.btn-check:checked + .btn.btn-outline.btn-outline-secondary i,\n.btn-check:checked + .btn.btn-outline.btn-outline-secondary .svg-icon, .btn-check:active + .btn.btn-outline.btn-outline-secondary i,\n.btn-check:active + .btn.btn-outline.btn-outline-secondary .svg-icon, .btn.btn-outline.btn-outline-secondary:focus:not(.btn-active) i,\n.btn.btn-outline.btn-outline-secondary:focus:not(.btn-active) .svg-icon, .btn.btn-outline.btn-outline-secondary:hover:not(.btn-active) i,\n.btn.btn-outline.btn-outline-secondary:hover:not(.btn-active) .svg-icon, .btn.btn-outline.btn-outline-secondary:active:not(.btn-active) i,\n.btn.btn-outline.btn-outline-secondary:active:not(.btn-active) .svg-icon, .btn.btn-outline.btn-outline-secondary.active i,\n.btn.btn-outline.btn-outline-secondary.active .svg-icon, .btn.btn-outline.btn-outline-secondary.show i,\n.btn.btn-outline.btn-outline-secondary.show .svg-icon, .show > .btn.btn-outline.btn-outline-secondary i,\n.show > .btn.btn-outline.btn-outline-secondary .svg-icon {\n  color: var(--bs-secondary-active);\n}\n.btn-check:checked + .btn.btn-outline.btn-outline-secondary.dropdown-toggle:after, .btn-check:active + .btn.btn-outline.btn-outline-secondary.dropdown-toggle:after, .btn.btn-outline.btn-outline-secondary:focus:not(.btn-active).dropdown-toggle:after, .btn.btn-outline.btn-outline-secondary:hover:not(.btn-active).dropdown-toggle:after, .btn.btn-outline.btn-outline-secondary:active:not(.btn-active).dropdown-toggle:after, .btn.btn-outline.btn-outline-secondary.active.dropdown-toggle:after, .btn.btn-outline.btn-outline-secondary.show.dropdown-toggle:after, .show > .btn.btn-outline.btn-outline-secondary.dropdown-toggle:after {\n  color: var(--bs-secondary-active);\n}\n\n.btn.btn-success {\n  color: var(--bs-success-inverse);\n  border-color: var(--bs-success);\n  background-color: var(--bs-success);\n}\n.btn.btn-success i,\n.btn.btn-success .svg-icon {\n  color: var(--bs-success-inverse);\n}\n.btn.btn-success.dropdown-toggle:after {\n  color: var(--bs-success-inverse);\n}\n.btn-check:checked + .btn.btn-success, .btn-check:active + .btn.btn-success, .btn.btn-success:focus:not(.btn-active), .btn.btn-success:hover:not(.btn-active), .btn.btn-success:active:not(.btn-active), .btn.btn-success.active, .btn.btn-success.show, .show > .btn.btn-success {\n  color: var(--bs-success-inverse);\n  border-color: var(--bs-success-active);\n  background-color: var(--bs-success-active) !important;\n}\n.btn-check:checked + .btn.btn-success i,\n.btn-check:checked + .btn.btn-success .svg-icon, .btn-check:active + .btn.btn-success i,\n.btn-check:active + .btn.btn-success .svg-icon, .btn.btn-success:focus:not(.btn-active) i,\n.btn.btn-success:focus:not(.btn-active) .svg-icon, .btn.btn-success:hover:not(.btn-active) i,\n.btn.btn-success:hover:not(.btn-active) .svg-icon, .btn.btn-success:active:not(.btn-active) i,\n.btn.btn-success:active:not(.btn-active) .svg-icon, .btn.btn-success.active i,\n.btn.btn-success.active .svg-icon, .btn.btn-success.show i,\n.btn.btn-success.show .svg-icon, .show > .btn.btn-success i,\n.show > .btn.btn-success .svg-icon {\n  color: var(--bs-success-inverse);\n}\n.btn-check:checked + .btn.btn-success.dropdown-toggle:after, .btn-check:active + .btn.btn-success.dropdown-toggle:after, .btn.btn-success:focus:not(.btn-active).dropdown-toggle:after, .btn.btn-success:hover:not(.btn-active).dropdown-toggle:after, .btn.btn-success:active:not(.btn-active).dropdown-toggle:after, .btn.btn-success.active.dropdown-toggle:after, .btn.btn-success.show.dropdown-toggle:after, .show > .btn.btn-success.dropdown-toggle:after {\n  color: var(--bs-success-inverse);\n}\n\n.btn.btn-light-success {\n  color: var(--bs-success);\n  border-color: var(--bs-success-light);\n  background-color: var(--bs-success-light);\n}\n.btn.btn-light-success i,\n.btn.btn-light-success .svg-icon {\n  color: var(--bs-success);\n}\n.btn.btn-light-success.dropdown-toggle:after {\n  color: var(--bs-success);\n}\n.btn-check:checked + .btn.btn-light-success, .btn-check:active + .btn.btn-light-success, .btn.btn-light-success:focus:not(.btn-active), .btn.btn-light-success:hover:not(.btn-active), .btn.btn-light-success:active:not(.btn-active), .btn.btn-light-success.active, .btn.btn-light-success.show, .show > .btn.btn-light-success {\n  color: var(--bs-success-inverse);\n  border-color: var(--bs-success);\n  background-color: var(--bs-success) !important;\n}\n.btn-check:checked + .btn.btn-light-success i,\n.btn-check:checked + .btn.btn-light-success .svg-icon, .btn-check:active + .btn.btn-light-success i,\n.btn-check:active + .btn.btn-light-success .svg-icon, .btn.btn-light-success:focus:not(.btn-active) i,\n.btn.btn-light-success:focus:not(.btn-active) .svg-icon, .btn.btn-light-success:hover:not(.btn-active) i,\n.btn.btn-light-success:hover:not(.btn-active) .svg-icon, .btn.btn-light-success:active:not(.btn-active) i,\n.btn.btn-light-success:active:not(.btn-active) .svg-icon, .btn.btn-light-success.active i,\n.btn.btn-light-success.active .svg-icon, .btn.btn-light-success.show i,\n.btn.btn-light-success.show .svg-icon, .show > .btn.btn-light-success i,\n.show > .btn.btn-light-success .svg-icon {\n  color: var(--bs-success-inverse);\n}\n.btn-check:checked + .btn.btn-light-success.dropdown-toggle:after, .btn-check:active + .btn.btn-light-success.dropdown-toggle:after, .btn.btn-light-success:focus:not(.btn-active).dropdown-toggle:after, .btn.btn-light-success:hover:not(.btn-active).dropdown-toggle:after, .btn.btn-light-success:active:not(.btn-active).dropdown-toggle:after, .btn.btn-light-success.active.dropdown-toggle:after, .btn.btn-light-success.show.dropdown-toggle:after, .show > .btn.btn-light-success.dropdown-toggle:after {\n  color: var(--bs-success-inverse);\n}\n\n.btn.btn-bg-success {\n  border-color: var(--bs-success);\n  background-color: var(--bs-success);\n}\n.btn-check:checked + .btn.btn-active-success, .btn-check:active + .btn.btn-active-success, .btn.btn-active-success:focus:not(.btn-active), .btn.btn-active-success:hover:not(.btn-active), .btn.btn-active-success:active:not(.btn-active), .btn.btn-active-success.active, .btn.btn-active-success.show, .show > .btn.btn-active-success {\n  color: var(--bs-success-inverse);\n  border-color: var(--bs-success);\n  background-color: var(--bs-success) !important;\n}\n.btn-check:checked + .btn.btn-active-success i,\n.btn-check:checked + .btn.btn-active-success .svg-icon, .btn-check:active + .btn.btn-active-success i,\n.btn-check:active + .btn.btn-active-success .svg-icon, .btn.btn-active-success:focus:not(.btn-active) i,\n.btn.btn-active-success:focus:not(.btn-active) .svg-icon, .btn.btn-active-success:hover:not(.btn-active) i,\n.btn.btn-active-success:hover:not(.btn-active) .svg-icon, .btn.btn-active-success:active:not(.btn-active) i,\n.btn.btn-active-success:active:not(.btn-active) .svg-icon, .btn.btn-active-success.active i,\n.btn.btn-active-success.active .svg-icon, .btn.btn-active-success.show i,\n.btn.btn-active-success.show .svg-icon, .show > .btn.btn-active-success i,\n.show > .btn.btn-active-success .svg-icon {\n  color: var(--bs-success-inverse);\n}\n.btn-check:checked + .btn.btn-active-success.dropdown-toggle:after, .btn-check:active + .btn.btn-active-success.dropdown-toggle:after, .btn.btn-active-success:focus:not(.btn-active).dropdown-toggle:after, .btn.btn-active-success:hover:not(.btn-active).dropdown-toggle:after, .btn.btn-active-success:active:not(.btn-active).dropdown-toggle:after, .btn.btn-active-success.active.dropdown-toggle:after, .btn.btn-active-success.show.dropdown-toggle:after, .show > .btn.btn-active-success.dropdown-toggle:after {\n  color: var(--bs-success-inverse);\n}\n\n.btn-check:checked + .btn.btn-active-light-success, .btn-check:active + .btn.btn-active-light-success, .btn.btn-active-light-success:focus:not(.btn-active), .btn.btn-active-light-success:hover:not(.btn-active), .btn.btn-active-light-success:active:not(.btn-active), .btn.btn-active-light-success.active, .btn.btn-active-light-success.show, .show > .btn.btn-active-light-success {\n  color: var(--bs-success);\n  border-color: var(--bs-success-light);\n  background-color: var(--bs-success-light) !important;\n}\n.btn-check:checked + .btn.btn-active-light-success i,\n.btn-check:checked + .btn.btn-active-light-success .svg-icon, .btn-check:active + .btn.btn-active-light-success i,\n.btn-check:active + .btn.btn-active-light-success .svg-icon, .btn.btn-active-light-success:focus:not(.btn-active) i,\n.btn.btn-active-light-success:focus:not(.btn-active) .svg-icon, .btn.btn-active-light-success:hover:not(.btn-active) i,\n.btn.btn-active-light-success:hover:not(.btn-active) .svg-icon, .btn.btn-active-light-success:active:not(.btn-active) i,\n.btn.btn-active-light-success:active:not(.btn-active) .svg-icon, .btn.btn-active-light-success.active i,\n.btn.btn-active-light-success.active .svg-icon, .btn.btn-active-light-success.show i,\n.btn.btn-active-light-success.show .svg-icon, .show > .btn.btn-active-light-success i,\n.show > .btn.btn-active-light-success .svg-icon {\n  color: var(--bs-success);\n}\n.btn-check:checked + .btn.btn-active-light-success.dropdown-toggle:after, .btn-check:active + .btn.btn-active-light-success.dropdown-toggle:after, .btn.btn-active-light-success:focus:not(.btn-active).dropdown-toggle:after, .btn.btn-active-light-success:hover:not(.btn-active).dropdown-toggle:after, .btn.btn-active-light-success:active:not(.btn-active).dropdown-toggle:after, .btn.btn-active-light-success.active.dropdown-toggle:after, .btn.btn-active-light-success.show.dropdown-toggle:after, .show > .btn.btn-active-light-success.dropdown-toggle:after {\n  color: var(--bs-success);\n}\n\n.btn.btn-outline.btn-outline-success {\n  color: var(--bs-success);\n  border-color: var(--bs-success);\n  background-color: transparent;\n}\n.btn.btn-outline.btn-outline-success i,\n.btn.btn-outline.btn-outline-success .svg-icon {\n  color: var(--bs-success);\n}\n.btn.btn-outline.btn-outline-success.dropdown-toggle:after {\n  color: var(--bs-success);\n}\n.btn-check:checked + .btn.btn-outline.btn-outline-success, .btn-check:active + .btn.btn-outline.btn-outline-success, .btn.btn-outline.btn-outline-success:focus:not(.btn-active), .btn.btn-outline.btn-outline-success:hover:not(.btn-active), .btn.btn-outline.btn-outline-success:active:not(.btn-active), .btn.btn-outline.btn-outline-success.active, .btn.btn-outline.btn-outline-success.show, .show > .btn.btn-outline.btn-outline-success {\n  color: var(--bs-success-active);\n  border-color: var(--bs-success);\n  background-color: var(--bs-success-light) !important;\n}\n.btn-check:checked + .btn.btn-outline.btn-outline-success i,\n.btn-check:checked + .btn.btn-outline.btn-outline-success .svg-icon, .btn-check:active + .btn.btn-outline.btn-outline-success i,\n.btn-check:active + .btn.btn-outline.btn-outline-success .svg-icon, .btn.btn-outline.btn-outline-success:focus:not(.btn-active) i,\n.btn.btn-outline.btn-outline-success:focus:not(.btn-active) .svg-icon, .btn.btn-outline.btn-outline-success:hover:not(.btn-active) i,\n.btn.btn-outline.btn-outline-success:hover:not(.btn-active) .svg-icon, .btn.btn-outline.btn-outline-success:active:not(.btn-active) i,\n.btn.btn-outline.btn-outline-success:active:not(.btn-active) .svg-icon, .btn.btn-outline.btn-outline-success.active i,\n.btn.btn-outline.btn-outline-success.active .svg-icon, .btn.btn-outline.btn-outline-success.show i,\n.btn.btn-outline.btn-outline-success.show .svg-icon, .show > .btn.btn-outline.btn-outline-success i,\n.show > .btn.btn-outline.btn-outline-success .svg-icon {\n  color: var(--bs-success-active);\n}\n.btn-check:checked + .btn.btn-outline.btn-outline-success.dropdown-toggle:after, .btn-check:active + .btn.btn-outline.btn-outline-success.dropdown-toggle:after, .btn.btn-outline.btn-outline-success:focus:not(.btn-active).dropdown-toggle:after, .btn.btn-outline.btn-outline-success:hover:not(.btn-active).dropdown-toggle:after, .btn.btn-outline.btn-outline-success:active:not(.btn-active).dropdown-toggle:after, .btn.btn-outline.btn-outline-success.active.dropdown-toggle:after, .btn.btn-outline.btn-outline-success.show.dropdown-toggle:after, .show > .btn.btn-outline.btn-outline-success.dropdown-toggle:after {\n  color: var(--bs-success-active);\n}\n\n.btn.btn-info {\n  color: var(--bs-info-inverse);\n  border-color: var(--bs-info);\n  background-color: var(--bs-info);\n}\n.btn.btn-info i,\n.btn.btn-info .svg-icon {\n  color: var(--bs-info-inverse);\n}\n.btn.btn-info.dropdown-toggle:after {\n  color: var(--bs-info-inverse);\n}\n.btn-check:checked + .btn.btn-info, .btn-check:active + .btn.btn-info, .btn.btn-info:focus:not(.btn-active), .btn.btn-info:hover:not(.btn-active), .btn.btn-info:active:not(.btn-active), .btn.btn-info.active, .btn.btn-info.show, .show > .btn.btn-info {\n  color: var(--bs-info-inverse);\n  border-color: var(--bs-info-active);\n  background-color: var(--bs-info-active) !important;\n}\n.btn-check:checked + .btn.btn-info i,\n.btn-check:checked + .btn.btn-info .svg-icon, .btn-check:active + .btn.btn-info i,\n.btn-check:active + .btn.btn-info .svg-icon, .btn.btn-info:focus:not(.btn-active) i,\n.btn.btn-info:focus:not(.btn-active) .svg-icon, .btn.btn-info:hover:not(.btn-active) i,\n.btn.btn-info:hover:not(.btn-active) .svg-icon, .btn.btn-info:active:not(.btn-active) i,\n.btn.btn-info:active:not(.btn-active) .svg-icon, .btn.btn-info.active i,\n.btn.btn-info.active .svg-icon, .btn.btn-info.show i,\n.btn.btn-info.show .svg-icon, .show > .btn.btn-info i,\n.show > .btn.btn-info .svg-icon {\n  color: var(--bs-info-inverse);\n}\n.btn-check:checked + .btn.btn-info.dropdown-toggle:after, .btn-check:active + .btn.btn-info.dropdown-toggle:after, .btn.btn-info:focus:not(.btn-active).dropdown-toggle:after, .btn.btn-info:hover:not(.btn-active).dropdown-toggle:after, .btn.btn-info:active:not(.btn-active).dropdown-toggle:after, .btn.btn-info.active.dropdown-toggle:after, .btn.btn-info.show.dropdown-toggle:after, .show > .btn.btn-info.dropdown-toggle:after {\n  color: var(--bs-info-inverse);\n}\n\n.btn.btn-light-info {\n  color: var(--bs-info);\n  border-color: var(--bs-info-light);\n  background-color: var(--bs-info-light);\n}\n.btn.btn-light-info i,\n.btn.btn-light-info .svg-icon {\n  color: var(--bs-info);\n}\n.btn.btn-light-info.dropdown-toggle:after {\n  color: var(--bs-info);\n}\n.btn-check:checked + .btn.btn-light-info, .btn-check:active + .btn.btn-light-info, .btn.btn-light-info:focus:not(.btn-active), .btn.btn-light-info:hover:not(.btn-active), .btn.btn-light-info:active:not(.btn-active), .btn.btn-light-info.active, .btn.btn-light-info.show, .show > .btn.btn-light-info {\n  color: var(--bs-info-inverse);\n  border-color: var(--bs-info);\n  background-color: var(--bs-info) !important;\n}\n.btn-check:checked + .btn.btn-light-info i,\n.btn-check:checked + .btn.btn-light-info .svg-icon, .btn-check:active + .btn.btn-light-info i,\n.btn-check:active + .btn.btn-light-info .svg-icon, .btn.btn-light-info:focus:not(.btn-active) i,\n.btn.btn-light-info:focus:not(.btn-active) .svg-icon, .btn.btn-light-info:hover:not(.btn-active) i,\n.btn.btn-light-info:hover:not(.btn-active) .svg-icon, .btn.btn-light-info:active:not(.btn-active) i,\n.btn.btn-light-info:active:not(.btn-active) .svg-icon, .btn.btn-light-info.active i,\n.btn.btn-light-info.active .svg-icon, .btn.btn-light-info.show i,\n.btn.btn-light-info.show .svg-icon, .show > .btn.btn-light-info i,\n.show > .btn.btn-light-info .svg-icon {\n  color: var(--bs-info-inverse);\n}\n.btn-check:checked + .btn.btn-light-info.dropdown-toggle:after, .btn-check:active + .btn.btn-light-info.dropdown-toggle:after, .btn.btn-light-info:focus:not(.btn-active).dropdown-toggle:after, .btn.btn-light-info:hover:not(.btn-active).dropdown-toggle:after, .btn.btn-light-info:active:not(.btn-active).dropdown-toggle:after, .btn.btn-light-info.active.dropdown-toggle:after, .btn.btn-light-info.show.dropdown-toggle:after, .show > .btn.btn-light-info.dropdown-toggle:after {\n  color: var(--bs-info-inverse);\n}\n\n.btn.btn-bg-info {\n  border-color: var(--bs-info);\n  background-color: var(--bs-info);\n}\n.btn-check:checked + .btn.btn-active-info, .btn-check:active + .btn.btn-active-info, .btn.btn-active-info:focus:not(.btn-active), .btn.btn-active-info:hover:not(.btn-active), .btn.btn-active-info:active:not(.btn-active), .btn.btn-active-info.active, .btn.btn-active-info.show, .show > .btn.btn-active-info {\n  color: var(--bs-info-inverse);\n  border-color: var(--bs-info);\n  background-color: var(--bs-info) !important;\n}\n.btn-check:checked + .btn.btn-active-info i,\n.btn-check:checked + .btn.btn-active-info .svg-icon, .btn-check:active + .btn.btn-active-info i,\n.btn-check:active + .btn.btn-active-info .svg-icon, .btn.btn-active-info:focus:not(.btn-active) i,\n.btn.btn-active-info:focus:not(.btn-active) .svg-icon, .btn.btn-active-info:hover:not(.btn-active) i,\n.btn.btn-active-info:hover:not(.btn-active) .svg-icon, .btn.btn-active-info:active:not(.btn-active) i,\n.btn.btn-active-info:active:not(.btn-active) .svg-icon, .btn.btn-active-info.active i,\n.btn.btn-active-info.active .svg-icon, .btn.btn-active-info.show i,\n.btn.btn-active-info.show .svg-icon, .show > .btn.btn-active-info i,\n.show > .btn.btn-active-info .svg-icon {\n  color: var(--bs-info-inverse);\n}\n.btn-check:checked + .btn.btn-active-info.dropdown-toggle:after, .btn-check:active + .btn.btn-active-info.dropdown-toggle:after, .btn.btn-active-info:focus:not(.btn-active).dropdown-toggle:after, .btn.btn-active-info:hover:not(.btn-active).dropdown-toggle:after, .btn.btn-active-info:active:not(.btn-active).dropdown-toggle:after, .btn.btn-active-info.active.dropdown-toggle:after, .btn.btn-active-info.show.dropdown-toggle:after, .show > .btn.btn-active-info.dropdown-toggle:after {\n  color: var(--bs-info-inverse);\n}\n\n.btn-check:checked + .btn.btn-active-light-info, .btn-check:active + .btn.btn-active-light-info, .btn.btn-active-light-info:focus:not(.btn-active), .btn.btn-active-light-info:hover:not(.btn-active), .btn.btn-active-light-info:active:not(.btn-active), .btn.btn-active-light-info.active, .btn.btn-active-light-info.show, .show > .btn.btn-active-light-info {\n  color: var(--bs-info);\n  border-color: var(--bs-info-light);\n  background-color: var(--bs-info-light) !important;\n}\n.btn-check:checked + .btn.btn-active-light-info i,\n.btn-check:checked + .btn.btn-active-light-info .svg-icon, .btn-check:active + .btn.btn-active-light-info i,\n.btn-check:active + .btn.btn-active-light-info .svg-icon, .btn.btn-active-light-info:focus:not(.btn-active) i,\n.btn.btn-active-light-info:focus:not(.btn-active) .svg-icon, .btn.btn-active-light-info:hover:not(.btn-active) i,\n.btn.btn-active-light-info:hover:not(.btn-active) .svg-icon, .btn.btn-active-light-info:active:not(.btn-active) i,\n.btn.btn-active-light-info:active:not(.btn-active) .svg-icon, .btn.btn-active-light-info.active i,\n.btn.btn-active-light-info.active .svg-icon, .btn.btn-active-light-info.show i,\n.btn.btn-active-light-info.show .svg-icon, .show > .btn.btn-active-light-info i,\n.show > .btn.btn-active-light-info .svg-icon {\n  color: var(--bs-info);\n}\n.btn-check:checked + .btn.btn-active-light-info.dropdown-toggle:after, .btn-check:active + .btn.btn-active-light-info.dropdown-toggle:after, .btn.btn-active-light-info:focus:not(.btn-active).dropdown-toggle:after, .btn.btn-active-light-info:hover:not(.btn-active).dropdown-toggle:after, .btn.btn-active-light-info:active:not(.btn-active).dropdown-toggle:after, .btn.btn-active-light-info.active.dropdown-toggle:after, .btn.btn-active-light-info.show.dropdown-toggle:after, .show > .btn.btn-active-light-info.dropdown-toggle:after {\n  color: var(--bs-info);\n}\n\n.btn.btn-outline.btn-outline-info {\n  color: var(--bs-info);\n  border-color: var(--bs-info);\n  background-color: transparent;\n}\n.btn.btn-outline.btn-outline-info i,\n.btn.btn-outline.btn-outline-info .svg-icon {\n  color: var(--bs-info);\n}\n.btn.btn-outline.btn-outline-info.dropdown-toggle:after {\n  color: var(--bs-info);\n}\n.btn-check:checked + .btn.btn-outline.btn-outline-info, .btn-check:active + .btn.btn-outline.btn-outline-info, .btn.btn-outline.btn-outline-info:focus:not(.btn-active), .btn.btn-outline.btn-outline-info:hover:not(.btn-active), .btn.btn-outline.btn-outline-info:active:not(.btn-active), .btn.btn-outline.btn-outline-info.active, .btn.btn-outline.btn-outline-info.show, .show > .btn.btn-outline.btn-outline-info {\n  color: var(--bs-info-active);\n  border-color: var(--bs-info);\n  background-color: var(--bs-info-light) !important;\n}\n.btn-check:checked + .btn.btn-outline.btn-outline-info i,\n.btn-check:checked + .btn.btn-outline.btn-outline-info .svg-icon, .btn-check:active + .btn.btn-outline.btn-outline-info i,\n.btn-check:active + .btn.btn-outline.btn-outline-info .svg-icon, .btn.btn-outline.btn-outline-info:focus:not(.btn-active) i,\n.btn.btn-outline.btn-outline-info:focus:not(.btn-active) .svg-icon, .btn.btn-outline.btn-outline-info:hover:not(.btn-active) i,\n.btn.btn-outline.btn-outline-info:hover:not(.btn-active) .svg-icon, .btn.btn-outline.btn-outline-info:active:not(.btn-active) i,\n.btn.btn-outline.btn-outline-info:active:not(.btn-active) .svg-icon, .btn.btn-outline.btn-outline-info.active i,\n.btn.btn-outline.btn-outline-info.active .svg-icon, .btn.btn-outline.btn-outline-info.show i,\n.btn.btn-outline.btn-outline-info.show .svg-icon, .show > .btn.btn-outline.btn-outline-info i,\n.show > .btn.btn-outline.btn-outline-info .svg-icon {\n  color: var(--bs-info-active);\n}\n.btn-check:checked + .btn.btn-outline.btn-outline-info.dropdown-toggle:after, .btn-check:active + .btn.btn-outline.btn-outline-info.dropdown-toggle:after, .btn.btn-outline.btn-outline-info:focus:not(.btn-active).dropdown-toggle:after, .btn.btn-outline.btn-outline-info:hover:not(.btn-active).dropdown-toggle:after, .btn.btn-outline.btn-outline-info:active:not(.btn-active).dropdown-toggle:after, .btn.btn-outline.btn-outline-info.active.dropdown-toggle:after, .btn.btn-outline.btn-outline-info.show.dropdown-toggle:after, .show > .btn.btn-outline.btn-outline-info.dropdown-toggle:after {\n  color: var(--bs-info-active);\n}\n\n.btn.btn-warning {\n  color: var(--bs-warning-inverse);\n  border-color: var(--bs-warning);\n  background-color: var(--bs-warning);\n}\n.btn.btn-warning i,\n.btn.btn-warning .svg-icon {\n  color: var(--bs-warning-inverse);\n}\n.btn.btn-warning.dropdown-toggle:after {\n  color: var(--bs-warning-inverse);\n}\n.btn-check:checked + .btn.btn-warning, .btn-check:active + .btn.btn-warning, .btn.btn-warning:focus:not(.btn-active), .btn.btn-warning:hover:not(.btn-active), .btn.btn-warning:active:not(.btn-active), .btn.btn-warning.active, .btn.btn-warning.show, .show > .btn.btn-warning {\n  color: var(--bs-warning-inverse);\n  border-color: var(--bs-warning-active);\n  background-color: var(--bs-warning-active) !important;\n}\n.btn-check:checked + .btn.btn-warning i,\n.btn-check:checked + .btn.btn-warning .svg-icon, .btn-check:active + .btn.btn-warning i,\n.btn-check:active + .btn.btn-warning .svg-icon, .btn.btn-warning:focus:not(.btn-active) i,\n.btn.btn-warning:focus:not(.btn-active) .svg-icon, .btn.btn-warning:hover:not(.btn-active) i,\n.btn.btn-warning:hover:not(.btn-active) .svg-icon, .btn.btn-warning:active:not(.btn-active) i,\n.btn.btn-warning:active:not(.btn-active) .svg-icon, .btn.btn-warning.active i,\n.btn.btn-warning.active .svg-icon, .btn.btn-warning.show i,\n.btn.btn-warning.show .svg-icon, .show > .btn.btn-warning i,\n.show > .btn.btn-warning .svg-icon {\n  color: var(--bs-warning-inverse);\n}\n.btn-check:checked + .btn.btn-warning.dropdown-toggle:after, .btn-check:active + .btn.btn-warning.dropdown-toggle:after, .btn.btn-warning:focus:not(.btn-active).dropdown-toggle:after, .btn.btn-warning:hover:not(.btn-active).dropdown-toggle:after, .btn.btn-warning:active:not(.btn-active).dropdown-toggle:after, .btn.btn-warning.active.dropdown-toggle:after, .btn.btn-warning.show.dropdown-toggle:after, .show > .btn.btn-warning.dropdown-toggle:after {\n  color: var(--bs-warning-inverse);\n}\n\n.btn.btn-light-warning {\n  color: var(--bs-warning);\n  border-color: var(--bs-warning-light);\n  background-color: var(--bs-warning-light);\n}\n.btn.btn-light-warning i,\n.btn.btn-light-warning .svg-icon {\n  color: var(--bs-warning);\n}\n.btn.btn-light-warning.dropdown-toggle:after {\n  color: var(--bs-warning);\n}\n.btn-check:checked + .btn.btn-light-warning, .btn-check:active + .btn.btn-light-warning, .btn.btn-light-warning:focus:not(.btn-active), .btn.btn-light-warning:hover:not(.btn-active), .btn.btn-light-warning:active:not(.btn-active), .btn.btn-light-warning.active, .btn.btn-light-warning.show, .show > .btn.btn-light-warning {\n  color: var(--bs-warning-inverse);\n  border-color: var(--bs-warning);\n  background-color: var(--bs-warning) !important;\n}\n.btn-check:checked + .btn.btn-light-warning i,\n.btn-check:checked + .btn.btn-light-warning .svg-icon, .btn-check:active + .btn.btn-light-warning i,\n.btn-check:active + .btn.btn-light-warning .svg-icon, .btn.btn-light-warning:focus:not(.btn-active) i,\n.btn.btn-light-warning:focus:not(.btn-active) .svg-icon, .btn.btn-light-warning:hover:not(.btn-active) i,\n.btn.btn-light-warning:hover:not(.btn-active) .svg-icon, .btn.btn-light-warning:active:not(.btn-active) i,\n.btn.btn-light-warning:active:not(.btn-active) .svg-icon, .btn.btn-light-warning.active i,\n.btn.btn-light-warning.active .svg-icon, .btn.btn-light-warning.show i,\n.btn.btn-light-warning.show .svg-icon, .show > .btn.btn-light-warning i,\n.show > .btn.btn-light-warning .svg-icon {\n  color: var(--bs-warning-inverse);\n}\n.btn-check:checked + .btn.btn-light-warning.dropdown-toggle:after, .btn-check:active + .btn.btn-light-warning.dropdown-toggle:after, .btn.btn-light-warning:focus:not(.btn-active).dropdown-toggle:after, .btn.btn-light-warning:hover:not(.btn-active).dropdown-toggle:after, .btn.btn-light-warning:active:not(.btn-active).dropdown-toggle:after, .btn.btn-light-warning.active.dropdown-toggle:after, .btn.btn-light-warning.show.dropdown-toggle:after, .show > .btn.btn-light-warning.dropdown-toggle:after {\n  color: var(--bs-warning-inverse);\n}\n\n.btn.btn-bg-warning {\n  border-color: var(--bs-warning);\n  background-color: var(--bs-warning);\n}\n.btn-check:checked + .btn.btn-active-warning, .btn-check:active + .btn.btn-active-warning, .btn.btn-active-warning:focus:not(.btn-active), .btn.btn-active-warning:hover:not(.btn-active), .btn.btn-active-warning:active:not(.btn-active), .btn.btn-active-warning.active, .btn.btn-active-warning.show, .show > .btn.btn-active-warning {\n  color: var(--bs-warning-inverse);\n  border-color: var(--bs-warning);\n  background-color: var(--bs-warning) !important;\n}\n.btn-check:checked + .btn.btn-active-warning i,\n.btn-check:checked + .btn.btn-active-warning .svg-icon, .btn-check:active + .btn.btn-active-warning i,\n.btn-check:active + .btn.btn-active-warning .svg-icon, .btn.btn-active-warning:focus:not(.btn-active) i,\n.btn.btn-active-warning:focus:not(.btn-active) .svg-icon, .btn.btn-active-warning:hover:not(.btn-active) i,\n.btn.btn-active-warning:hover:not(.btn-active) .svg-icon, .btn.btn-active-warning:active:not(.btn-active) i,\n.btn.btn-active-warning:active:not(.btn-active) .svg-icon, .btn.btn-active-warning.active i,\n.btn.btn-active-warning.active .svg-icon, .btn.btn-active-warning.show i,\n.btn.btn-active-warning.show .svg-icon, .show > .btn.btn-active-warning i,\n.show > .btn.btn-active-warning .svg-icon {\n  color: var(--bs-warning-inverse);\n}\n.btn-check:checked + .btn.btn-active-warning.dropdown-toggle:after, .btn-check:active + .btn.btn-active-warning.dropdown-toggle:after, .btn.btn-active-warning:focus:not(.btn-active).dropdown-toggle:after, .btn.btn-active-warning:hover:not(.btn-active).dropdown-toggle:after, .btn.btn-active-warning:active:not(.btn-active).dropdown-toggle:after, .btn.btn-active-warning.active.dropdown-toggle:after, .btn.btn-active-warning.show.dropdown-toggle:after, .show > .btn.btn-active-warning.dropdown-toggle:after {\n  color: var(--bs-warning-inverse);\n}\n\n.btn-check:checked + .btn.btn-active-light-warning, .btn-check:active + .btn.btn-active-light-warning, .btn.btn-active-light-warning:focus:not(.btn-active), .btn.btn-active-light-warning:hover:not(.btn-active), .btn.btn-active-light-warning:active:not(.btn-active), .btn.btn-active-light-warning.active, .btn.btn-active-light-warning.show, .show > .btn.btn-active-light-warning {\n  color: var(--bs-warning);\n  border-color: var(--bs-warning-light);\n  background-color: var(--bs-warning-light) !important;\n}\n.btn-check:checked + .btn.btn-active-light-warning i,\n.btn-check:checked + .btn.btn-active-light-warning .svg-icon, .btn-check:active + .btn.btn-active-light-warning i,\n.btn-check:active + .btn.btn-active-light-warning .svg-icon, .btn.btn-active-light-warning:focus:not(.btn-active) i,\n.btn.btn-active-light-warning:focus:not(.btn-active) .svg-icon, .btn.btn-active-light-warning:hover:not(.btn-active) i,\n.btn.btn-active-light-warning:hover:not(.btn-active) .svg-icon, .btn.btn-active-light-warning:active:not(.btn-active) i,\n.btn.btn-active-light-warning:active:not(.btn-active) .svg-icon, .btn.btn-active-light-warning.active i,\n.btn.btn-active-light-warning.active .svg-icon, .btn.btn-active-light-warning.show i,\n.btn.btn-active-light-warning.show .svg-icon, .show > .btn.btn-active-light-warning i,\n.show > .btn.btn-active-light-warning .svg-icon {\n  color: var(--bs-warning);\n}\n.btn-check:checked + .btn.btn-active-light-warning.dropdown-toggle:after, .btn-check:active + .btn.btn-active-light-warning.dropdown-toggle:after, .btn.btn-active-light-warning:focus:not(.btn-active).dropdown-toggle:after, .btn.btn-active-light-warning:hover:not(.btn-active).dropdown-toggle:after, .btn.btn-active-light-warning:active:not(.btn-active).dropdown-toggle:after, .btn.btn-active-light-warning.active.dropdown-toggle:after, .btn.btn-active-light-warning.show.dropdown-toggle:after, .show > .btn.btn-active-light-warning.dropdown-toggle:after {\n  color: var(--bs-warning);\n}\n\n.btn.btn-outline.btn-outline-warning {\n  color: var(--bs-warning);\n  border-color: var(--bs-warning);\n  background-color: transparent;\n}\n.btn.btn-outline.btn-outline-warning i,\n.btn.btn-outline.btn-outline-warning .svg-icon {\n  color: var(--bs-warning);\n}\n.btn.btn-outline.btn-outline-warning.dropdown-toggle:after {\n  color: var(--bs-warning);\n}\n.btn-check:checked + .btn.btn-outline.btn-outline-warning, .btn-check:active + .btn.btn-outline.btn-outline-warning, .btn.btn-outline.btn-outline-warning:focus:not(.btn-active), .btn.btn-outline.btn-outline-warning:hover:not(.btn-active), .btn.btn-outline.btn-outline-warning:active:not(.btn-active), .btn.btn-outline.btn-outline-warning.active, .btn.btn-outline.btn-outline-warning.show, .show > .btn.btn-outline.btn-outline-warning {\n  color: var(--bs-warning-active);\n  border-color: var(--bs-warning);\n  background-color: var(--bs-warning-light) !important;\n}\n.btn-check:checked + .btn.btn-outline.btn-outline-warning i,\n.btn-check:checked + .btn.btn-outline.btn-outline-warning .svg-icon, .btn-check:active + .btn.btn-outline.btn-outline-warning i,\n.btn-check:active + .btn.btn-outline.btn-outline-warning .svg-icon, .btn.btn-outline.btn-outline-warning:focus:not(.btn-active) i,\n.btn.btn-outline.btn-outline-warning:focus:not(.btn-active) .svg-icon, .btn.btn-outline.btn-outline-warning:hover:not(.btn-active) i,\n.btn.btn-outline.btn-outline-warning:hover:not(.btn-active) .svg-icon, .btn.btn-outline.btn-outline-warning:active:not(.btn-active) i,\n.btn.btn-outline.btn-outline-warning:active:not(.btn-active) .svg-icon, .btn.btn-outline.btn-outline-warning.active i,\n.btn.btn-outline.btn-outline-warning.active .svg-icon, .btn.btn-outline.btn-outline-warning.show i,\n.btn.btn-outline.btn-outline-warning.show .svg-icon, .show > .btn.btn-outline.btn-outline-warning i,\n.show > .btn.btn-outline.btn-outline-warning .svg-icon {\n  color: var(--bs-warning-active);\n}\n.btn-check:checked + .btn.btn-outline.btn-outline-warning.dropdown-toggle:after, .btn-check:active + .btn.btn-outline.btn-outline-warning.dropdown-toggle:after, .btn.btn-outline.btn-outline-warning:focus:not(.btn-active).dropdown-toggle:after, .btn.btn-outline.btn-outline-warning:hover:not(.btn-active).dropdown-toggle:after, .btn.btn-outline.btn-outline-warning:active:not(.btn-active).dropdown-toggle:after, .btn.btn-outline.btn-outline-warning.active.dropdown-toggle:after, .btn.btn-outline.btn-outline-warning.show.dropdown-toggle:after, .show > .btn.btn-outline.btn-outline-warning.dropdown-toggle:after {\n  color: var(--bs-warning-active);\n}\n\n.btn.btn-danger {\n  color: var(--bs-danger-inverse);\n  border-color: var(--bs-danger);\n  background-color: var(--bs-danger);\n}\n.btn.btn-danger i,\n.btn.btn-danger .svg-icon {\n  color: var(--bs-danger-inverse);\n}\n.btn.btn-danger.dropdown-toggle:after {\n  color: var(--bs-danger-inverse);\n}\n.btn-check:checked + .btn.btn-danger, .btn-check:active + .btn.btn-danger, .btn.btn-danger:focus:not(.btn-active), .btn.btn-danger:hover:not(.btn-active), .btn.btn-danger:active:not(.btn-active), .btn.btn-danger.active, .btn.btn-danger.show, .show > .btn.btn-danger {\n  color: var(--bs-danger-inverse);\n  border-color: var(--bs-danger-active);\n  background-color: var(--bs-danger-active) !important;\n}\n.btn-check:checked + .btn.btn-danger i,\n.btn-check:checked + .btn.btn-danger .svg-icon, .btn-check:active + .btn.btn-danger i,\n.btn-check:active + .btn.btn-danger .svg-icon, .btn.btn-danger:focus:not(.btn-active) i,\n.btn.btn-danger:focus:not(.btn-active) .svg-icon, .btn.btn-danger:hover:not(.btn-active) i,\n.btn.btn-danger:hover:not(.btn-active) .svg-icon, .btn.btn-danger:active:not(.btn-active) i,\n.btn.btn-danger:active:not(.btn-active) .svg-icon, .btn.btn-danger.active i,\n.btn.btn-danger.active .svg-icon, .btn.btn-danger.show i,\n.btn.btn-danger.show .svg-icon, .show > .btn.btn-danger i,\n.show > .btn.btn-danger .svg-icon {\n  color: var(--bs-danger-inverse);\n}\n.btn-check:checked + .btn.btn-danger.dropdown-toggle:after, .btn-check:active + .btn.btn-danger.dropdown-toggle:after, .btn.btn-danger:focus:not(.btn-active).dropdown-toggle:after, .btn.btn-danger:hover:not(.btn-active).dropdown-toggle:after, .btn.btn-danger:active:not(.btn-active).dropdown-toggle:after, .btn.btn-danger.active.dropdown-toggle:after, .btn.btn-danger.show.dropdown-toggle:after, .show > .btn.btn-danger.dropdown-toggle:after {\n  color: var(--bs-danger-inverse);\n}\n\n.btn.btn-light-danger {\n  color: var(--bs-danger);\n  border-color: var(--bs-danger-light);\n  background-color: var(--bs-danger-light);\n}\n.btn.btn-light-danger i,\n.btn.btn-light-danger .svg-icon {\n  color: var(--bs-danger);\n}\n.btn.btn-light-danger.dropdown-toggle:after {\n  color: var(--bs-danger);\n}\n.btn-check:checked + .btn.btn-light-danger, .btn-check:active + .btn.btn-light-danger, .btn.btn-light-danger:focus:not(.btn-active), .btn.btn-light-danger:hover:not(.btn-active), .btn.btn-light-danger:active:not(.btn-active), .btn.btn-light-danger.active, .btn.btn-light-danger.show, .show > .btn.btn-light-danger {\n  color: var(--bs-danger-inverse);\n  border-color: var(--bs-danger);\n  background-color: var(--bs-danger) !important;\n}\n.btn-check:checked + .btn.btn-light-danger i,\n.btn-check:checked + .btn.btn-light-danger .svg-icon, .btn-check:active + .btn.btn-light-danger i,\n.btn-check:active + .btn.btn-light-danger .svg-icon, .btn.btn-light-danger:focus:not(.btn-active) i,\n.btn.btn-light-danger:focus:not(.btn-active) .svg-icon, .btn.btn-light-danger:hover:not(.btn-active) i,\n.btn.btn-light-danger:hover:not(.btn-active) .svg-icon, .btn.btn-light-danger:active:not(.btn-active) i,\n.btn.btn-light-danger:active:not(.btn-active) .svg-icon, .btn.btn-light-danger.active i,\n.btn.btn-light-danger.active .svg-icon, .btn.btn-light-danger.show i,\n.btn.btn-light-danger.show .svg-icon, .show > .btn.btn-light-danger i,\n.show > .btn.btn-light-danger .svg-icon {\n  color: var(--bs-danger-inverse);\n}\n.btn-check:checked + .btn.btn-light-danger.dropdown-toggle:after, .btn-check:active + .btn.btn-light-danger.dropdown-toggle:after, .btn.btn-light-danger:focus:not(.btn-active).dropdown-toggle:after, .btn.btn-light-danger:hover:not(.btn-active).dropdown-toggle:after, .btn.btn-light-danger:active:not(.btn-active).dropdown-toggle:after, .btn.btn-light-danger.active.dropdown-toggle:after, .btn.btn-light-danger.show.dropdown-toggle:after, .show > .btn.btn-light-danger.dropdown-toggle:after {\n  color: var(--bs-danger-inverse);\n}\n\n.btn.btn-bg-danger {\n  border-color: var(--bs-danger);\n  background-color: var(--bs-danger);\n}\n.btn-check:checked + .btn.btn-active-danger, .btn-check:active + .btn.btn-active-danger, .btn.btn-active-danger:focus:not(.btn-active), .btn.btn-active-danger:hover:not(.btn-active), .btn.btn-active-danger:active:not(.btn-active), .btn.btn-active-danger.active, .btn.btn-active-danger.show, .show > .btn.btn-active-danger {\n  color: var(--bs-danger-inverse);\n  border-color: var(--bs-danger);\n  background-color: var(--bs-danger) !important;\n}\n.btn-check:checked + .btn.btn-active-danger i,\n.btn-check:checked + .btn.btn-active-danger .svg-icon, .btn-check:active + .btn.btn-active-danger i,\n.btn-check:active + .btn.btn-active-danger .svg-icon, .btn.btn-active-danger:focus:not(.btn-active) i,\n.btn.btn-active-danger:focus:not(.btn-active) .svg-icon, .btn.btn-active-danger:hover:not(.btn-active) i,\n.btn.btn-active-danger:hover:not(.btn-active) .svg-icon, .btn.btn-active-danger:active:not(.btn-active) i,\n.btn.btn-active-danger:active:not(.btn-active) .svg-icon, .btn.btn-active-danger.active i,\n.btn.btn-active-danger.active .svg-icon, .btn.btn-active-danger.show i,\n.btn.btn-active-danger.show .svg-icon, .show > .btn.btn-active-danger i,\n.show > .btn.btn-active-danger .svg-icon {\n  color: var(--bs-danger-inverse);\n}\n.btn-check:checked + .btn.btn-active-danger.dropdown-toggle:after, .btn-check:active + .btn.btn-active-danger.dropdown-toggle:after, .btn.btn-active-danger:focus:not(.btn-active).dropdown-toggle:after, .btn.btn-active-danger:hover:not(.btn-active).dropdown-toggle:after, .btn.btn-active-danger:active:not(.btn-active).dropdown-toggle:after, .btn.btn-active-danger.active.dropdown-toggle:after, .btn.btn-active-danger.show.dropdown-toggle:after, .show > .btn.btn-active-danger.dropdown-toggle:after {\n  color: var(--bs-danger-inverse);\n}\n\n.btn-check:checked + .btn.btn-active-light-danger, .btn-check:active + .btn.btn-active-light-danger, .btn.btn-active-light-danger:focus:not(.btn-active), .btn.btn-active-light-danger:hover:not(.btn-active), .btn.btn-active-light-danger:active:not(.btn-active), .btn.btn-active-light-danger.active, .btn.btn-active-light-danger.show, .show > .btn.btn-active-light-danger {\n  color: var(--bs-danger);\n  border-color: var(--bs-danger-light);\n  background-color: var(--bs-danger-light) !important;\n}\n.btn-check:checked + .btn.btn-active-light-danger i,\n.btn-check:checked + .btn.btn-active-light-danger .svg-icon, .btn-check:active + .btn.btn-active-light-danger i,\n.btn-check:active + .btn.btn-active-light-danger .svg-icon, .btn.btn-active-light-danger:focus:not(.btn-active) i,\n.btn.btn-active-light-danger:focus:not(.btn-active) .svg-icon, .btn.btn-active-light-danger:hover:not(.btn-active) i,\n.btn.btn-active-light-danger:hover:not(.btn-active) .svg-icon, .btn.btn-active-light-danger:active:not(.btn-active) i,\n.btn.btn-active-light-danger:active:not(.btn-active) .svg-icon, .btn.btn-active-light-danger.active i,\n.btn.btn-active-light-danger.active .svg-icon, .btn.btn-active-light-danger.show i,\n.btn.btn-active-light-danger.show .svg-icon, .show > .btn.btn-active-light-danger i,\n.show > .btn.btn-active-light-danger .svg-icon {\n  color: var(--bs-danger);\n}\n.btn-check:checked + .btn.btn-active-light-danger.dropdown-toggle:after, .btn-check:active + .btn.btn-active-light-danger.dropdown-toggle:after, .btn.btn-active-light-danger:focus:not(.btn-active).dropdown-toggle:after, .btn.btn-active-light-danger:hover:not(.btn-active).dropdown-toggle:after, .btn.btn-active-light-danger:active:not(.btn-active).dropdown-toggle:after, .btn.btn-active-light-danger.active.dropdown-toggle:after, .btn.btn-active-light-danger.show.dropdown-toggle:after, .show > .btn.btn-active-light-danger.dropdown-toggle:after {\n  color: var(--bs-danger);\n}\n\n.btn.btn-outline.btn-outline-danger {\n  color: var(--bs-danger);\n  border-color: var(--bs-danger);\n  background-color: transparent;\n}\n.btn.btn-outline.btn-outline-danger i,\n.btn.btn-outline.btn-outline-danger .svg-icon {\n  color: var(--bs-danger);\n}\n.btn.btn-outline.btn-outline-danger.dropdown-toggle:after {\n  color: var(--bs-danger);\n}\n.btn-check:checked + .btn.btn-outline.btn-outline-danger, .btn-check:active + .btn.btn-outline.btn-outline-danger, .btn.btn-outline.btn-outline-danger:focus:not(.btn-active), .btn.btn-outline.btn-outline-danger:hover:not(.btn-active), .btn.btn-outline.btn-outline-danger:active:not(.btn-active), .btn.btn-outline.btn-outline-danger.active, .btn.btn-outline.btn-outline-danger.show, .show > .btn.btn-outline.btn-outline-danger {\n  color: var(--bs-danger-active);\n  border-color: var(--bs-danger);\n  background-color: var(--bs-danger-light) !important;\n}\n.btn-check:checked + .btn.btn-outline.btn-outline-danger i,\n.btn-check:checked + .btn.btn-outline.btn-outline-danger .svg-icon, .btn-check:active + .btn.btn-outline.btn-outline-danger i,\n.btn-check:active + .btn.btn-outline.btn-outline-danger .svg-icon, .btn.btn-outline.btn-outline-danger:focus:not(.btn-active) i,\n.btn.btn-outline.btn-outline-danger:focus:not(.btn-active) .svg-icon, .btn.btn-outline.btn-outline-danger:hover:not(.btn-active) i,\n.btn.btn-outline.btn-outline-danger:hover:not(.btn-active) .svg-icon, .btn.btn-outline.btn-outline-danger:active:not(.btn-active) i,\n.btn.btn-outline.btn-outline-danger:active:not(.btn-active) .svg-icon, .btn.btn-outline.btn-outline-danger.active i,\n.btn.btn-outline.btn-outline-danger.active .svg-icon, .btn.btn-outline.btn-outline-danger.show i,\n.btn.btn-outline.btn-outline-danger.show .svg-icon, .show > .btn.btn-outline.btn-outline-danger i,\n.show > .btn.btn-outline.btn-outline-danger .svg-icon {\n  color: var(--bs-danger-active);\n}\n.btn-check:checked + .btn.btn-outline.btn-outline-danger.dropdown-toggle:after, .btn-check:active + .btn.btn-outline.btn-outline-danger.dropdown-toggle:after, .btn.btn-outline.btn-outline-danger:focus:not(.btn-active).dropdown-toggle:after, .btn.btn-outline.btn-outline-danger:hover:not(.btn-active).dropdown-toggle:after, .btn.btn-outline.btn-outline-danger:active:not(.btn-active).dropdown-toggle:after, .btn.btn-outline.btn-outline-danger.active.dropdown-toggle:after, .btn.btn-outline.btn-outline-danger.show.dropdown-toggle:after, .show > .btn.btn-outline.btn-outline-danger.dropdown-toggle:after {\n  color: var(--bs-danger-active);\n}\n\n.btn.btn-dark {\n  color: var(--bs-dark-inverse);\n  border-color: var(--bs-dark);\n  background-color: var(--bs-dark);\n}\n.btn.btn-dark i,\n.btn.btn-dark .svg-icon {\n  color: var(--bs-dark-inverse);\n}\n.btn.btn-dark.dropdown-toggle:after {\n  color: var(--bs-dark-inverse);\n}\n.btn-check:checked + .btn.btn-dark, .btn-check:active + .btn.btn-dark, .btn.btn-dark:focus:not(.btn-active), .btn.btn-dark:hover:not(.btn-active), .btn.btn-dark:active:not(.btn-active), .btn.btn-dark.active, .btn.btn-dark.show, .show > .btn.btn-dark {\n  color: var(--bs-dark-inverse);\n  border-color: var(--bs-dark-active);\n  background-color: var(--bs-dark-active) !important;\n}\n.btn-check:checked + .btn.btn-dark i,\n.btn-check:checked + .btn.btn-dark .svg-icon, .btn-check:active + .btn.btn-dark i,\n.btn-check:active + .btn.btn-dark .svg-icon, .btn.btn-dark:focus:not(.btn-active) i,\n.btn.btn-dark:focus:not(.btn-active) .svg-icon, .btn.btn-dark:hover:not(.btn-active) i,\n.btn.btn-dark:hover:not(.btn-active) .svg-icon, .btn.btn-dark:active:not(.btn-active) i,\n.btn.btn-dark:active:not(.btn-active) .svg-icon, .btn.btn-dark.active i,\n.btn.btn-dark.active .svg-icon, .btn.btn-dark.show i,\n.btn.btn-dark.show .svg-icon, .show > .btn.btn-dark i,\n.show > .btn.btn-dark .svg-icon {\n  color: var(--bs-dark-inverse);\n}\n.btn-check:checked + .btn.btn-dark.dropdown-toggle:after, .btn-check:active + .btn.btn-dark.dropdown-toggle:after, .btn.btn-dark:focus:not(.btn-active).dropdown-toggle:after, .btn.btn-dark:hover:not(.btn-active).dropdown-toggle:after, .btn.btn-dark:active:not(.btn-active).dropdown-toggle:after, .btn.btn-dark.active.dropdown-toggle:after, .btn.btn-dark.show.dropdown-toggle:after, .show > .btn.btn-dark.dropdown-toggle:after {\n  color: var(--bs-dark-inverse);\n}\n\n.btn.btn-light-dark {\n  color: var(--bs-dark);\n  border-color: var(--bs-dark-light);\n  background-color: var(--bs-dark-light);\n}\n.btn.btn-light-dark i,\n.btn.btn-light-dark .svg-icon {\n  color: var(--bs-dark);\n}\n.btn.btn-light-dark.dropdown-toggle:after {\n  color: var(--bs-dark);\n}\n.btn-check:checked + .btn.btn-light-dark, .btn-check:active + .btn.btn-light-dark, .btn.btn-light-dark:focus:not(.btn-active), .btn.btn-light-dark:hover:not(.btn-active), .btn.btn-light-dark:active:not(.btn-active), .btn.btn-light-dark.active, .btn.btn-light-dark.show, .show > .btn.btn-light-dark {\n  color: var(--bs-dark-inverse);\n  border-color: var(--bs-dark);\n  background-color: var(--bs-dark) !important;\n}\n.btn-check:checked + .btn.btn-light-dark i,\n.btn-check:checked + .btn.btn-light-dark .svg-icon, .btn-check:active + .btn.btn-light-dark i,\n.btn-check:active + .btn.btn-light-dark .svg-icon, .btn.btn-light-dark:focus:not(.btn-active) i,\n.btn.btn-light-dark:focus:not(.btn-active) .svg-icon, .btn.btn-light-dark:hover:not(.btn-active) i,\n.btn.btn-light-dark:hover:not(.btn-active) .svg-icon, .btn.btn-light-dark:active:not(.btn-active) i,\n.btn.btn-light-dark:active:not(.btn-active) .svg-icon, .btn.btn-light-dark.active i,\n.btn.btn-light-dark.active .svg-icon, .btn.btn-light-dark.show i,\n.btn.btn-light-dark.show .svg-icon, .show > .btn.btn-light-dark i,\n.show > .btn.btn-light-dark .svg-icon {\n  color: var(--bs-dark-inverse);\n}\n.btn-check:checked + .btn.btn-light-dark.dropdown-toggle:after, .btn-check:active + .btn.btn-light-dark.dropdown-toggle:after, .btn.btn-light-dark:focus:not(.btn-active).dropdown-toggle:after, .btn.btn-light-dark:hover:not(.btn-active).dropdown-toggle:after, .btn.btn-light-dark:active:not(.btn-active).dropdown-toggle:after, .btn.btn-light-dark.active.dropdown-toggle:after, .btn.btn-light-dark.show.dropdown-toggle:after, .show > .btn.btn-light-dark.dropdown-toggle:after {\n  color: var(--bs-dark-inverse);\n}\n\n.btn.btn-bg-dark {\n  border-color: var(--bs-dark);\n  background-color: var(--bs-dark);\n}\n.btn-check:checked + .btn.btn-active-dark, .btn-check:active + .btn.btn-active-dark, .btn.btn-active-dark:focus:not(.btn-active), .btn.btn-active-dark:hover:not(.btn-active), .btn.btn-active-dark:active:not(.btn-active), .btn.btn-active-dark.active, .btn.btn-active-dark.show, .show > .btn.btn-active-dark {\n  color: var(--bs-dark-inverse);\n  border-color: var(--bs-dark);\n  background-color: var(--bs-dark) !important;\n}\n.btn-check:checked + .btn.btn-active-dark i,\n.btn-check:checked + .btn.btn-active-dark .svg-icon, .btn-check:active + .btn.btn-active-dark i,\n.btn-check:active + .btn.btn-active-dark .svg-icon, .btn.btn-active-dark:focus:not(.btn-active) i,\n.btn.btn-active-dark:focus:not(.btn-active) .svg-icon, .btn.btn-active-dark:hover:not(.btn-active) i,\n.btn.btn-active-dark:hover:not(.btn-active) .svg-icon, .btn.btn-active-dark:active:not(.btn-active) i,\n.btn.btn-active-dark:active:not(.btn-active) .svg-icon, .btn.btn-active-dark.active i,\n.btn.btn-active-dark.active .svg-icon, .btn.btn-active-dark.show i,\n.btn.btn-active-dark.show .svg-icon, .show > .btn.btn-active-dark i,\n.show > .btn.btn-active-dark .svg-icon {\n  color: var(--bs-dark-inverse);\n}\n.btn-check:checked + .btn.btn-active-dark.dropdown-toggle:after, .btn-check:active + .btn.btn-active-dark.dropdown-toggle:after, .btn.btn-active-dark:focus:not(.btn-active).dropdown-toggle:after, .btn.btn-active-dark:hover:not(.btn-active).dropdown-toggle:after, .btn.btn-active-dark:active:not(.btn-active).dropdown-toggle:after, .btn.btn-active-dark.active.dropdown-toggle:after, .btn.btn-active-dark.show.dropdown-toggle:after, .show > .btn.btn-active-dark.dropdown-toggle:after {\n  color: var(--bs-dark-inverse);\n}\n\n.btn-check:checked + .btn.btn-active-light-dark, .btn-check:active + .btn.btn-active-light-dark, .btn.btn-active-light-dark:focus:not(.btn-active), .btn.btn-active-light-dark:hover:not(.btn-active), .btn.btn-active-light-dark:active:not(.btn-active), .btn.btn-active-light-dark.active, .btn.btn-active-light-dark.show, .show > .btn.btn-active-light-dark {\n  color: var(--bs-dark);\n  border-color: var(--bs-dark-light);\n  background-color: var(--bs-dark-light) !important;\n}\n.btn-check:checked + .btn.btn-active-light-dark i,\n.btn-check:checked + .btn.btn-active-light-dark .svg-icon, .btn-check:active + .btn.btn-active-light-dark i,\n.btn-check:active + .btn.btn-active-light-dark .svg-icon, .btn.btn-active-light-dark:focus:not(.btn-active) i,\n.btn.btn-active-light-dark:focus:not(.btn-active) .svg-icon, .btn.btn-active-light-dark:hover:not(.btn-active) i,\n.btn.btn-active-light-dark:hover:not(.btn-active) .svg-icon, .btn.btn-active-light-dark:active:not(.btn-active) i,\n.btn.btn-active-light-dark:active:not(.btn-active) .svg-icon, .btn.btn-active-light-dark.active i,\n.btn.btn-active-light-dark.active .svg-icon, .btn.btn-active-light-dark.show i,\n.btn.btn-active-light-dark.show .svg-icon, .show > .btn.btn-active-light-dark i,\n.show > .btn.btn-active-light-dark .svg-icon {\n  color: var(--bs-dark);\n}\n.btn-check:checked + .btn.btn-active-light-dark.dropdown-toggle:after, .btn-check:active + .btn.btn-active-light-dark.dropdown-toggle:after, .btn.btn-active-light-dark:focus:not(.btn-active).dropdown-toggle:after, .btn.btn-active-light-dark:hover:not(.btn-active).dropdown-toggle:after, .btn.btn-active-light-dark:active:not(.btn-active).dropdown-toggle:after, .btn.btn-active-light-dark.active.dropdown-toggle:after, .btn.btn-active-light-dark.show.dropdown-toggle:after, .show > .btn.btn-active-light-dark.dropdown-toggle:after {\n  color: var(--bs-dark);\n}\n\n.btn.btn-outline.btn-outline-dark {\n  color: var(--bs-dark);\n  border-color: var(--bs-dark);\n  background-color: transparent;\n}\n.btn.btn-outline.btn-outline-dark i,\n.btn.btn-outline.btn-outline-dark .svg-icon {\n  color: var(--bs-dark);\n}\n.btn.btn-outline.btn-outline-dark.dropdown-toggle:after {\n  color: var(--bs-dark);\n}\n.btn-check:checked + .btn.btn-outline.btn-outline-dark, .btn-check:active + .btn.btn-outline.btn-outline-dark, .btn.btn-outline.btn-outline-dark:focus:not(.btn-active), .btn.btn-outline.btn-outline-dark:hover:not(.btn-active), .btn.btn-outline.btn-outline-dark:active:not(.btn-active), .btn.btn-outline.btn-outline-dark.active, .btn.btn-outline.btn-outline-dark.show, .show > .btn.btn-outline.btn-outline-dark {\n  color: var(--bs-dark-active);\n  border-color: var(--bs-dark);\n  background-color: var(--bs-dark-light) !important;\n}\n.btn-check:checked + .btn.btn-outline.btn-outline-dark i,\n.btn-check:checked + .btn.btn-outline.btn-outline-dark .svg-icon, .btn-check:active + .btn.btn-outline.btn-outline-dark i,\n.btn-check:active + .btn.btn-outline.btn-outline-dark .svg-icon, .btn.btn-outline.btn-outline-dark:focus:not(.btn-active) i,\n.btn.btn-outline.btn-outline-dark:focus:not(.btn-active) .svg-icon, .btn.btn-outline.btn-outline-dark:hover:not(.btn-active) i,\n.btn.btn-outline.btn-outline-dark:hover:not(.btn-active) .svg-icon, .btn.btn-outline.btn-outline-dark:active:not(.btn-active) i,\n.btn.btn-outline.btn-outline-dark:active:not(.btn-active) .svg-icon, .btn.btn-outline.btn-outline-dark.active i,\n.btn.btn-outline.btn-outline-dark.active .svg-icon, .btn.btn-outline.btn-outline-dark.show i,\n.btn.btn-outline.btn-outline-dark.show .svg-icon, .show > .btn.btn-outline.btn-outline-dark i,\n.show > .btn.btn-outline.btn-outline-dark .svg-icon {\n  color: var(--bs-dark-active);\n}\n.btn-check:checked + .btn.btn-outline.btn-outline-dark.dropdown-toggle:after, .btn-check:active + .btn.btn-outline.btn-outline-dark.dropdown-toggle:after, .btn.btn-outline.btn-outline-dark:focus:not(.btn-active).dropdown-toggle:after, .btn.btn-outline.btn-outline-dark:hover:not(.btn-active).dropdown-toggle:after, .btn.btn-outline.btn-outline-dark:active:not(.btn-active).dropdown-toggle:after, .btn.btn-outline.btn-outline-dark.active.dropdown-toggle:after, .btn.btn-outline.btn-outline-dark.show.dropdown-toggle:after, .show > .btn.btn-outline.btn-outline-dark.dropdown-toggle:after {\n  color: var(--bs-dark-active);\n}\n\n.btn.btn-color-white {\n  color: var(--bs-text-white);\n}\n.btn.btn-color-white i,\n.btn.btn-color-white .svg-icon {\n  color: var(--bs-text-white);\n}\n.btn.btn-color-white.dropdown-toggle:after {\n  color: var(--bs-text-white);\n}\n.btn-check:checked + .btn.btn-active-color-white, .btn-check:active + .btn.btn-active-color-white, .btn.btn-active-color-white:focus:not(.btn-active), .btn.btn-active-color-white:hover:not(.btn-active), .btn.btn-active-color-white:active:not(.btn-active), .btn.btn-active-color-white.active, .btn.btn-active-color-white.show, .show > .btn.btn-active-color-white {\n  color: var(--bs-text-white);\n}\n.btn-check:checked + .btn.btn-active-color-white i,\n.btn-check:checked + .btn.btn-active-color-white .svg-icon, .btn-check:active + .btn.btn-active-color-white i,\n.btn-check:active + .btn.btn-active-color-white .svg-icon, .btn.btn-active-color-white:focus:not(.btn-active) i,\n.btn.btn-active-color-white:focus:not(.btn-active) .svg-icon, .btn.btn-active-color-white:hover:not(.btn-active) i,\n.btn.btn-active-color-white:hover:not(.btn-active) .svg-icon, .btn.btn-active-color-white:active:not(.btn-active) i,\n.btn.btn-active-color-white:active:not(.btn-active) .svg-icon, .btn.btn-active-color-white.active i,\n.btn.btn-active-color-white.active .svg-icon, .btn.btn-active-color-white.show i,\n.btn.btn-active-color-white.show .svg-icon, .show > .btn.btn-active-color-white i,\n.show > .btn.btn-active-color-white .svg-icon {\n  color: var(--bs-text-white);\n}\n.btn-check:checked + .btn.btn-active-color-white.dropdown-toggle:after, .btn-check:active + .btn.btn-active-color-white.dropdown-toggle:after, .btn.btn-active-color-white:focus:not(.btn-active).dropdown-toggle:after, .btn.btn-active-color-white:hover:not(.btn-active).dropdown-toggle:after, .btn.btn-active-color-white:active:not(.btn-active).dropdown-toggle:after, .btn.btn-active-color-white.active.dropdown-toggle:after, .btn.btn-active-color-white.show.dropdown-toggle:after, .show > .btn.btn-active-color-white.dropdown-toggle:after {\n  color: var(--bs-text-white);\n}\n\n.btn.btn-icon-white i,\n.btn.btn-icon-white .svg-icon {\n  color: var(--bs-text-white);\n}\n.btn.btn-icon-white.dropdown-toggle:after {\n  color: var(--bs-text-white);\n}\n.btn-check:checked + .btn.btn-active-icon-white i,\n.btn-check:checked + .btn.btn-active-icon-white .svg-icon, .btn-check:active + .btn.btn-active-icon-white i,\n.btn-check:active + .btn.btn-active-icon-white .svg-icon, .btn.btn-active-icon-white:focus:not(.btn-active) i,\n.btn.btn-active-icon-white:focus:not(.btn-active) .svg-icon, .btn.btn-active-icon-white:hover:not(.btn-active) i,\n.btn.btn-active-icon-white:hover:not(.btn-active) .svg-icon, .btn.btn-active-icon-white:active:not(.btn-active) i,\n.btn.btn-active-icon-white:active:not(.btn-active) .svg-icon, .btn.btn-active-icon-white.active i,\n.btn.btn-active-icon-white.active .svg-icon, .btn.btn-active-icon-white.show i,\n.btn.btn-active-icon-white.show .svg-icon, .show > .btn.btn-active-icon-white i,\n.show > .btn.btn-active-icon-white .svg-icon {\n  color: var(--bs-text-white);\n}\n.btn-check:checked + .btn.btn-active-icon-white.dropdown-toggle:after, .btn-check:active + .btn.btn-active-icon-white.dropdown-toggle:after, .btn.btn-active-icon-white:focus:not(.btn-active).dropdown-toggle:after, .btn.btn-active-icon-white:hover:not(.btn-active).dropdown-toggle:after, .btn.btn-active-icon-white:active:not(.btn-active).dropdown-toggle:after, .btn.btn-active-icon-white.active.dropdown-toggle:after, .btn.btn-active-icon-white.show.dropdown-toggle:after, .show > .btn.btn-active-icon-white.dropdown-toggle:after {\n  color: var(--bs-text-white);\n}\n\n.btn.btn-text-white {\n  color: var(--bs-text-white);\n}\n.btn-check:checked + .btn.btn-active-text-white, .btn-check:active + .btn.btn-active-text-white, .btn.btn-active-text-white:focus:not(.btn-active), .btn.btn-active-text-white:hover:not(.btn-active), .btn.btn-active-text-white:active:not(.btn-active), .btn.btn-active-text-white.active, .btn.btn-active-text-white.show, .show > .btn.btn-active-text-white {\n  color: var(--bs-text-white);\n}\n\n.btn.btn-color-primary {\n  color: var(--bs-text-primary);\n}\n.btn.btn-color-primary i,\n.btn.btn-color-primary .svg-icon {\n  color: var(--bs-text-primary);\n}\n.btn.btn-color-primary.dropdown-toggle:after {\n  color: var(--bs-text-primary);\n}\n.btn-check:checked + .btn.btn-active-color-primary, .btn-check:active + .btn.btn-active-color-primary, .btn.btn-active-color-primary:focus:not(.btn-active), .btn.btn-active-color-primary:hover:not(.btn-active), .btn.btn-active-color-primary:active:not(.btn-active), .btn.btn-active-color-primary.active, .btn.btn-active-color-primary.show, .show > .btn.btn-active-color-primary {\n  color: var(--bs-text-primary);\n}\n.btn-check:checked + .btn.btn-active-color-primary i,\n.btn-check:checked + .btn.btn-active-color-primary .svg-icon, .btn-check:active + .btn.btn-active-color-primary i,\n.btn-check:active + .btn.btn-active-color-primary .svg-icon, .btn.btn-active-color-primary:focus:not(.btn-active) i,\n.btn.btn-active-color-primary:focus:not(.btn-active) .svg-icon, .btn.btn-active-color-primary:hover:not(.btn-active) i,\n.btn.btn-active-color-primary:hover:not(.btn-active) .svg-icon, .btn.btn-active-color-primary:active:not(.btn-active) i,\n.btn.btn-active-color-primary:active:not(.btn-active) .svg-icon, .btn.btn-active-color-primary.active i,\n.btn.btn-active-color-primary.active .svg-icon, .btn.btn-active-color-primary.show i,\n.btn.btn-active-color-primary.show .svg-icon, .show > .btn.btn-active-color-primary i,\n.show > .btn.btn-active-color-primary .svg-icon {\n  color: var(--bs-text-primary);\n}\n.btn-check:checked + .btn.btn-active-color-primary.dropdown-toggle:after, .btn-check:active + .btn.btn-active-color-primary.dropdown-toggle:after, .btn.btn-active-color-primary:focus:not(.btn-active).dropdown-toggle:after, .btn.btn-active-color-primary:hover:not(.btn-active).dropdown-toggle:after, .btn.btn-active-color-primary:active:not(.btn-active).dropdown-toggle:after, .btn.btn-active-color-primary.active.dropdown-toggle:after, .btn.btn-active-color-primary.show.dropdown-toggle:after, .show > .btn.btn-active-color-primary.dropdown-toggle:after {\n  color: var(--bs-text-primary);\n}\n\n.btn.btn-icon-primary i,\n.btn.btn-icon-primary .svg-icon {\n  color: var(--bs-text-primary);\n}\n.btn.btn-icon-primary.dropdown-toggle:after {\n  color: var(--bs-text-primary);\n}\n.btn-check:checked + .btn.btn-active-icon-primary i,\n.btn-check:checked + .btn.btn-active-icon-primary .svg-icon, .btn-check:active + .btn.btn-active-icon-primary i,\n.btn-check:active + .btn.btn-active-icon-primary .svg-icon, .btn.btn-active-icon-primary:focus:not(.btn-active) i,\n.btn.btn-active-icon-primary:focus:not(.btn-active) .svg-icon, .btn.btn-active-icon-primary:hover:not(.btn-active) i,\n.btn.btn-active-icon-primary:hover:not(.btn-active) .svg-icon, .btn.btn-active-icon-primary:active:not(.btn-active) i,\n.btn.btn-active-icon-primary:active:not(.btn-active) .svg-icon, .btn.btn-active-icon-primary.active i,\n.btn.btn-active-icon-primary.active .svg-icon, .btn.btn-active-icon-primary.show i,\n.btn.btn-active-icon-primary.show .svg-icon, .show > .btn.btn-active-icon-primary i,\n.show > .btn.btn-active-icon-primary .svg-icon {\n  color: var(--bs-text-primary);\n}\n.btn-check:checked + .btn.btn-active-icon-primary.dropdown-toggle:after, .btn-check:active + .btn.btn-active-icon-primary.dropdown-toggle:after, .btn.btn-active-icon-primary:focus:not(.btn-active).dropdown-toggle:after, .btn.btn-active-icon-primary:hover:not(.btn-active).dropdown-toggle:after, .btn.btn-active-icon-primary:active:not(.btn-active).dropdown-toggle:after, .btn.btn-active-icon-primary.active.dropdown-toggle:after, .btn.btn-active-icon-primary.show.dropdown-toggle:after, .show > .btn.btn-active-icon-primary.dropdown-toggle:after {\n  color: var(--bs-text-primary);\n}\n\n.btn.btn-text-primary {\n  color: var(--bs-text-primary);\n}\n.btn-check:checked + .btn.btn-active-text-primary, .btn-check:active + .btn.btn-active-text-primary, .btn.btn-active-text-primary:focus:not(.btn-active), .btn.btn-active-text-primary:hover:not(.btn-active), .btn.btn-active-text-primary:active:not(.btn-active), .btn.btn-active-text-primary.active, .btn.btn-active-text-primary.show, .show > .btn.btn-active-text-primary {\n  color: var(--bs-text-primary);\n}\n\n.btn.btn-color-secondary {\n  color: var(--bs-text-secondary);\n}\n.btn.btn-color-secondary i,\n.btn.btn-color-secondary .svg-icon {\n  color: var(--bs-text-secondary);\n}\n.btn.btn-color-secondary.dropdown-toggle:after {\n  color: var(--bs-text-secondary);\n}\n.btn-check:checked + .btn.btn-active-color-secondary, .btn-check:active + .btn.btn-active-color-secondary, .btn.btn-active-color-secondary:focus:not(.btn-active), .btn.btn-active-color-secondary:hover:not(.btn-active), .btn.btn-active-color-secondary:active:not(.btn-active), .btn.btn-active-color-secondary.active, .btn.btn-active-color-secondary.show, .show > .btn.btn-active-color-secondary {\n  color: var(--bs-text-secondary);\n}\n.btn-check:checked + .btn.btn-active-color-secondary i,\n.btn-check:checked + .btn.btn-active-color-secondary .svg-icon, .btn-check:active + .btn.btn-active-color-secondary i,\n.btn-check:active + .btn.btn-active-color-secondary .svg-icon, .btn.btn-active-color-secondary:focus:not(.btn-active) i,\n.btn.btn-active-color-secondary:focus:not(.btn-active) .svg-icon, .btn.btn-active-color-secondary:hover:not(.btn-active) i,\n.btn.btn-active-color-secondary:hover:not(.btn-active) .svg-icon, .btn.btn-active-color-secondary:active:not(.btn-active) i,\n.btn.btn-active-color-secondary:active:not(.btn-active) .svg-icon, .btn.btn-active-color-secondary.active i,\n.btn.btn-active-color-secondary.active .svg-icon, .btn.btn-active-color-secondary.show i,\n.btn.btn-active-color-secondary.show .svg-icon, .show > .btn.btn-active-color-secondary i,\n.show > .btn.btn-active-color-secondary .svg-icon {\n  color: var(--bs-text-secondary);\n}\n.btn-check:checked + .btn.btn-active-color-secondary.dropdown-toggle:after, .btn-check:active + .btn.btn-active-color-secondary.dropdown-toggle:after, .btn.btn-active-color-secondary:focus:not(.btn-active).dropdown-toggle:after, .btn.btn-active-color-secondary:hover:not(.btn-active).dropdown-toggle:after, .btn.btn-active-color-secondary:active:not(.btn-active).dropdown-toggle:after, .btn.btn-active-color-secondary.active.dropdown-toggle:after, .btn.btn-active-color-secondary.show.dropdown-toggle:after, .show > .btn.btn-active-color-secondary.dropdown-toggle:after {\n  color: var(--bs-text-secondary);\n}\n\n.btn.btn-icon-secondary i,\n.btn.btn-icon-secondary .svg-icon {\n  color: var(--bs-text-secondary);\n}\n.btn.btn-icon-secondary.dropdown-toggle:after {\n  color: var(--bs-text-secondary);\n}\n.btn-check:checked + .btn.btn-active-icon-secondary i,\n.btn-check:checked + .btn.btn-active-icon-secondary .svg-icon, .btn-check:active + .btn.btn-active-icon-secondary i,\n.btn-check:active + .btn.btn-active-icon-secondary .svg-icon, .btn.btn-active-icon-secondary:focus:not(.btn-active) i,\n.btn.btn-active-icon-secondary:focus:not(.btn-active) .svg-icon, .btn.btn-active-icon-secondary:hover:not(.btn-active) i,\n.btn.btn-active-icon-secondary:hover:not(.btn-active) .svg-icon, .btn.btn-active-icon-secondary:active:not(.btn-active) i,\n.btn.btn-active-icon-secondary:active:not(.btn-active) .svg-icon, .btn.btn-active-icon-secondary.active i,\n.btn.btn-active-icon-secondary.active .svg-icon, .btn.btn-active-icon-secondary.show i,\n.btn.btn-active-icon-secondary.show .svg-icon, .show > .btn.btn-active-icon-secondary i,\n.show > .btn.btn-active-icon-secondary .svg-icon {\n  color: var(--bs-text-secondary);\n}\n.btn-check:checked + .btn.btn-active-icon-secondary.dropdown-toggle:after, .btn-check:active + .btn.btn-active-icon-secondary.dropdown-toggle:after, .btn.btn-active-icon-secondary:focus:not(.btn-active).dropdown-toggle:after, .btn.btn-active-icon-secondary:hover:not(.btn-active).dropdown-toggle:after, .btn.btn-active-icon-secondary:active:not(.btn-active).dropdown-toggle:after, .btn.btn-active-icon-secondary.active.dropdown-toggle:after, .btn.btn-active-icon-secondary.show.dropdown-toggle:after, .show > .btn.btn-active-icon-secondary.dropdown-toggle:after {\n  color: var(--bs-text-secondary);\n}\n\n.btn.btn-text-secondary {\n  color: var(--bs-text-secondary);\n}\n.btn-check:checked + .btn.btn-active-text-secondary, .btn-check:active + .btn.btn-active-text-secondary, .btn.btn-active-text-secondary:focus:not(.btn-active), .btn.btn-active-text-secondary:hover:not(.btn-active), .btn.btn-active-text-secondary:active:not(.btn-active), .btn.btn-active-text-secondary.active, .btn.btn-active-text-secondary.show, .show > .btn.btn-active-text-secondary {\n  color: var(--bs-text-secondary);\n}\n\n.btn.btn-color-light {\n  color: var(--bs-text-light);\n}\n.btn.btn-color-light i,\n.btn.btn-color-light .svg-icon {\n  color: var(--bs-text-light);\n}\n.btn.btn-color-light.dropdown-toggle:after {\n  color: var(--bs-text-light);\n}\n.btn-check:checked + .btn.btn-active-color-light, .btn-check:active + .btn.btn-active-color-light, .btn.btn-active-color-light:focus:not(.btn-active), .btn.btn-active-color-light:hover:not(.btn-active), .btn.btn-active-color-light:active:not(.btn-active), .btn.btn-active-color-light.active, .btn.btn-active-color-light.show, .show > .btn.btn-active-color-light {\n  color: var(--bs-text-light);\n}\n.btn-check:checked + .btn.btn-active-color-light i,\n.btn-check:checked + .btn.btn-active-color-light .svg-icon, .btn-check:active + .btn.btn-active-color-light i,\n.btn-check:active + .btn.btn-active-color-light .svg-icon, .btn.btn-active-color-light:focus:not(.btn-active) i,\n.btn.btn-active-color-light:focus:not(.btn-active) .svg-icon, .btn.btn-active-color-light:hover:not(.btn-active) i,\n.btn.btn-active-color-light:hover:not(.btn-active) .svg-icon, .btn.btn-active-color-light:active:not(.btn-active) i,\n.btn.btn-active-color-light:active:not(.btn-active) .svg-icon, .btn.btn-active-color-light.active i,\n.btn.btn-active-color-light.active .svg-icon, .btn.btn-active-color-light.show i,\n.btn.btn-active-color-light.show .svg-icon, .show > .btn.btn-active-color-light i,\n.show > .btn.btn-active-color-light .svg-icon {\n  color: var(--bs-text-light);\n}\n.btn-check:checked + .btn.btn-active-color-light.dropdown-toggle:after, .btn-check:active + .btn.btn-active-color-light.dropdown-toggle:after, .btn.btn-active-color-light:focus:not(.btn-active).dropdown-toggle:after, .btn.btn-active-color-light:hover:not(.btn-active).dropdown-toggle:after, .btn.btn-active-color-light:active:not(.btn-active).dropdown-toggle:after, .btn.btn-active-color-light.active.dropdown-toggle:after, .btn.btn-active-color-light.show.dropdown-toggle:after, .show > .btn.btn-active-color-light.dropdown-toggle:after {\n  color: var(--bs-text-light);\n}\n\n.btn.btn-icon-light i,\n.btn.btn-icon-light .svg-icon {\n  color: var(--bs-text-light);\n}\n.btn.btn-icon-light.dropdown-toggle:after {\n  color: var(--bs-text-light);\n}\n.btn-check:checked + .btn.btn-active-icon-light i,\n.btn-check:checked + .btn.btn-active-icon-light .svg-icon, .btn-check:active + .btn.btn-active-icon-light i,\n.btn-check:active + .btn.btn-active-icon-light .svg-icon, .btn.btn-active-icon-light:focus:not(.btn-active) i,\n.btn.btn-active-icon-light:focus:not(.btn-active) .svg-icon, .btn.btn-active-icon-light:hover:not(.btn-active) i,\n.btn.btn-active-icon-light:hover:not(.btn-active) .svg-icon, .btn.btn-active-icon-light:active:not(.btn-active) i,\n.btn.btn-active-icon-light:active:not(.btn-active) .svg-icon, .btn.btn-active-icon-light.active i,\n.btn.btn-active-icon-light.active .svg-icon, .btn.btn-active-icon-light.show i,\n.btn.btn-active-icon-light.show .svg-icon, .show > .btn.btn-active-icon-light i,\n.show > .btn.btn-active-icon-light .svg-icon {\n  color: var(--bs-text-light);\n}\n.btn-check:checked + .btn.btn-active-icon-light.dropdown-toggle:after, .btn-check:active + .btn.btn-active-icon-light.dropdown-toggle:after, .btn.btn-active-icon-light:focus:not(.btn-active).dropdown-toggle:after, .btn.btn-active-icon-light:hover:not(.btn-active).dropdown-toggle:after, .btn.btn-active-icon-light:active:not(.btn-active).dropdown-toggle:after, .btn.btn-active-icon-light.active.dropdown-toggle:after, .btn.btn-active-icon-light.show.dropdown-toggle:after, .show > .btn.btn-active-icon-light.dropdown-toggle:after {\n  color: var(--bs-text-light);\n}\n\n.btn.btn-text-light {\n  color: var(--bs-text-light);\n}\n.btn-check:checked + .btn.btn-active-text-light, .btn-check:active + .btn.btn-active-text-light, .btn.btn-active-text-light:focus:not(.btn-active), .btn.btn-active-text-light:hover:not(.btn-active), .btn.btn-active-text-light:active:not(.btn-active), .btn.btn-active-text-light.active, .btn.btn-active-text-light.show, .show > .btn.btn-active-text-light {\n  color: var(--bs-text-light);\n}\n\n.btn.btn-color-success {\n  color: var(--bs-text-success);\n}\n.btn.btn-color-success i,\n.btn.btn-color-success .svg-icon {\n  color: var(--bs-text-success);\n}\n.btn.btn-color-success.dropdown-toggle:after {\n  color: var(--bs-text-success);\n}\n.btn-check:checked + .btn.btn-active-color-success, .btn-check:active + .btn.btn-active-color-success, .btn.btn-active-color-success:focus:not(.btn-active), .btn.btn-active-color-success:hover:not(.btn-active), .btn.btn-active-color-success:active:not(.btn-active), .btn.btn-active-color-success.active, .btn.btn-active-color-success.show, .show > .btn.btn-active-color-success {\n  color: var(--bs-text-success);\n}\n.btn-check:checked + .btn.btn-active-color-success i,\n.btn-check:checked + .btn.btn-active-color-success .svg-icon, .btn-check:active + .btn.btn-active-color-success i,\n.btn-check:active + .btn.btn-active-color-success .svg-icon, .btn.btn-active-color-success:focus:not(.btn-active) i,\n.btn.btn-active-color-success:focus:not(.btn-active) .svg-icon, .btn.btn-active-color-success:hover:not(.btn-active) i,\n.btn.btn-active-color-success:hover:not(.btn-active) .svg-icon, .btn.btn-active-color-success:active:not(.btn-active) i,\n.btn.btn-active-color-success:active:not(.btn-active) .svg-icon, .btn.btn-active-color-success.active i,\n.btn.btn-active-color-success.active .svg-icon, .btn.btn-active-color-success.show i,\n.btn.btn-active-color-success.show .svg-icon, .show > .btn.btn-active-color-success i,\n.show > .btn.btn-active-color-success .svg-icon {\n  color: var(--bs-text-success);\n}\n.btn-check:checked + .btn.btn-active-color-success.dropdown-toggle:after, .btn-check:active + .btn.btn-active-color-success.dropdown-toggle:after, .btn.btn-active-color-success:focus:not(.btn-active).dropdown-toggle:after, .btn.btn-active-color-success:hover:not(.btn-active).dropdown-toggle:after, .btn.btn-active-color-success:active:not(.btn-active).dropdown-toggle:after, .btn.btn-active-color-success.active.dropdown-toggle:after, .btn.btn-active-color-success.show.dropdown-toggle:after, .show > .btn.btn-active-color-success.dropdown-toggle:after {\n  color: var(--bs-text-success);\n}\n\n.btn.btn-icon-success i,\n.btn.btn-icon-success .svg-icon {\n  color: var(--bs-text-success);\n}\n.btn.btn-icon-success.dropdown-toggle:after {\n  color: var(--bs-text-success);\n}\n.btn-check:checked + .btn.btn-active-icon-success i,\n.btn-check:checked + .btn.btn-active-icon-success .svg-icon, .btn-check:active + .btn.btn-active-icon-success i,\n.btn-check:active + .btn.btn-active-icon-success .svg-icon, .btn.btn-active-icon-success:focus:not(.btn-active) i,\n.btn.btn-active-icon-success:focus:not(.btn-active) .svg-icon, .btn.btn-active-icon-success:hover:not(.btn-active) i,\n.btn.btn-active-icon-success:hover:not(.btn-active) .svg-icon, .btn.btn-active-icon-success:active:not(.btn-active) i,\n.btn.btn-active-icon-success:active:not(.btn-active) .svg-icon, .btn.btn-active-icon-success.active i,\n.btn.btn-active-icon-success.active .svg-icon, .btn.btn-active-icon-success.show i,\n.btn.btn-active-icon-success.show .svg-icon, .show > .btn.btn-active-icon-success i,\n.show > .btn.btn-active-icon-success .svg-icon {\n  color: var(--bs-text-success);\n}\n.btn-check:checked + .btn.btn-active-icon-success.dropdown-toggle:after, .btn-check:active + .btn.btn-active-icon-success.dropdown-toggle:after, .btn.btn-active-icon-success:focus:not(.btn-active).dropdown-toggle:after, .btn.btn-active-icon-success:hover:not(.btn-active).dropdown-toggle:after, .btn.btn-active-icon-success:active:not(.btn-active).dropdown-toggle:after, .btn.btn-active-icon-success.active.dropdown-toggle:after, .btn.btn-active-icon-success.show.dropdown-toggle:after, .show > .btn.btn-active-icon-success.dropdown-toggle:after {\n  color: var(--bs-text-success);\n}\n\n.btn.btn-text-success {\n  color: var(--bs-text-success);\n}\n.btn-check:checked + .btn.btn-active-text-success, .btn-check:active + .btn.btn-active-text-success, .btn.btn-active-text-success:focus:not(.btn-active), .btn.btn-active-text-success:hover:not(.btn-active), .btn.btn-active-text-success:active:not(.btn-active), .btn.btn-active-text-success.active, .btn.btn-active-text-success.show, .show > .btn.btn-active-text-success {\n  color: var(--bs-text-success);\n}\n\n.btn.btn-color-info {\n  color: var(--bs-text-info);\n}\n.btn.btn-color-info i,\n.btn.btn-color-info .svg-icon {\n  color: var(--bs-text-info);\n}\n.btn.btn-color-info.dropdown-toggle:after {\n  color: var(--bs-text-info);\n}\n.btn-check:checked + .btn.btn-active-color-info, .btn-check:active + .btn.btn-active-color-info, .btn.btn-active-color-info:focus:not(.btn-active), .btn.btn-active-color-info:hover:not(.btn-active), .btn.btn-active-color-info:active:not(.btn-active), .btn.btn-active-color-info.active, .btn.btn-active-color-info.show, .show > .btn.btn-active-color-info {\n  color: var(--bs-text-info);\n}\n.btn-check:checked + .btn.btn-active-color-info i,\n.btn-check:checked + .btn.btn-active-color-info .svg-icon, .btn-check:active + .btn.btn-active-color-info i,\n.btn-check:active + .btn.btn-active-color-info .svg-icon, .btn.btn-active-color-info:focus:not(.btn-active) i,\n.btn.btn-active-color-info:focus:not(.btn-active) .svg-icon, .btn.btn-active-color-info:hover:not(.btn-active) i,\n.btn.btn-active-color-info:hover:not(.btn-active) .svg-icon, .btn.btn-active-color-info:active:not(.btn-active) i,\n.btn.btn-active-color-info:active:not(.btn-active) .svg-icon, .btn.btn-active-color-info.active i,\n.btn.btn-active-color-info.active .svg-icon, .btn.btn-active-color-info.show i,\n.btn.btn-active-color-info.show .svg-icon, .show > .btn.btn-active-color-info i,\n.show > .btn.btn-active-color-info .svg-icon {\n  color: var(--bs-text-info);\n}\n.btn-check:checked + .btn.btn-active-color-info.dropdown-toggle:after, .btn-check:active + .btn.btn-active-color-info.dropdown-toggle:after, .btn.btn-active-color-info:focus:not(.btn-active).dropdown-toggle:after, .btn.btn-active-color-info:hover:not(.btn-active).dropdown-toggle:after, .btn.btn-active-color-info:active:not(.btn-active).dropdown-toggle:after, .btn.btn-active-color-info.active.dropdown-toggle:after, .btn.btn-active-color-info.show.dropdown-toggle:after, .show > .btn.btn-active-color-info.dropdown-toggle:after {\n  color: var(--bs-text-info);\n}\n\n.btn.btn-icon-info i,\n.btn.btn-icon-info .svg-icon {\n  color: var(--bs-text-info);\n}\n.btn.btn-icon-info.dropdown-toggle:after {\n  color: var(--bs-text-info);\n}\n.btn-check:checked + .btn.btn-active-icon-info i,\n.btn-check:checked + .btn.btn-active-icon-info .svg-icon, .btn-check:active + .btn.btn-active-icon-info i,\n.btn-check:active + .btn.btn-active-icon-info .svg-icon, .btn.btn-active-icon-info:focus:not(.btn-active) i,\n.btn.btn-active-icon-info:focus:not(.btn-active) .svg-icon, .btn.btn-active-icon-info:hover:not(.btn-active) i,\n.btn.btn-active-icon-info:hover:not(.btn-active) .svg-icon, .btn.btn-active-icon-info:active:not(.btn-active) i,\n.btn.btn-active-icon-info:active:not(.btn-active) .svg-icon, .btn.btn-active-icon-info.active i,\n.btn.btn-active-icon-info.active .svg-icon, .btn.btn-active-icon-info.show i,\n.btn.btn-active-icon-info.show .svg-icon, .show > .btn.btn-active-icon-info i,\n.show > .btn.btn-active-icon-info .svg-icon {\n  color: var(--bs-text-info);\n}\n.btn-check:checked + .btn.btn-active-icon-info.dropdown-toggle:after, .btn-check:active + .btn.btn-active-icon-info.dropdown-toggle:after, .btn.btn-active-icon-info:focus:not(.btn-active).dropdown-toggle:after, .btn.btn-active-icon-info:hover:not(.btn-active).dropdown-toggle:after, .btn.btn-active-icon-info:active:not(.btn-active).dropdown-toggle:after, .btn.btn-active-icon-info.active.dropdown-toggle:after, .btn.btn-active-icon-info.show.dropdown-toggle:after, .show > .btn.btn-active-icon-info.dropdown-toggle:after {\n  color: var(--bs-text-info);\n}\n\n.btn.btn-text-info {\n  color: var(--bs-text-info);\n}\n.btn-check:checked + .btn.btn-active-text-info, .btn-check:active + .btn.btn-active-text-info, .btn.btn-active-text-info:focus:not(.btn-active), .btn.btn-active-text-info:hover:not(.btn-active), .btn.btn-active-text-info:active:not(.btn-active), .btn.btn-active-text-info.active, .btn.btn-active-text-info.show, .show > .btn.btn-active-text-info {\n  color: var(--bs-text-info);\n}\n\n.btn.btn-color-warning {\n  color: var(--bs-text-warning);\n}\n.btn.btn-color-warning i,\n.btn.btn-color-warning .svg-icon {\n  color: var(--bs-text-warning);\n}\n.btn.btn-color-warning.dropdown-toggle:after {\n  color: var(--bs-text-warning);\n}\n.btn-check:checked + .btn.btn-active-color-warning, .btn-check:active + .btn.btn-active-color-warning, .btn.btn-active-color-warning:focus:not(.btn-active), .btn.btn-active-color-warning:hover:not(.btn-active), .btn.btn-active-color-warning:active:not(.btn-active), .btn.btn-active-color-warning.active, .btn.btn-active-color-warning.show, .show > .btn.btn-active-color-warning {\n  color: var(--bs-text-warning);\n}\n.btn-check:checked + .btn.btn-active-color-warning i,\n.btn-check:checked + .btn.btn-active-color-warning .svg-icon, .btn-check:active + .btn.btn-active-color-warning i,\n.btn-check:active + .btn.btn-active-color-warning .svg-icon, .btn.btn-active-color-warning:focus:not(.btn-active) i,\n.btn.btn-active-color-warning:focus:not(.btn-active) .svg-icon, .btn.btn-active-color-warning:hover:not(.btn-active) i,\n.btn.btn-active-color-warning:hover:not(.btn-active) .svg-icon, .btn.btn-active-color-warning:active:not(.btn-active) i,\n.btn.btn-active-color-warning:active:not(.btn-active) .svg-icon, .btn.btn-active-color-warning.active i,\n.btn.btn-active-color-warning.active .svg-icon, .btn.btn-active-color-warning.show i,\n.btn.btn-active-color-warning.show .svg-icon, .show > .btn.btn-active-color-warning i,\n.show > .btn.btn-active-color-warning .svg-icon {\n  color: var(--bs-text-warning);\n}\n.btn-check:checked + .btn.btn-active-color-warning.dropdown-toggle:after, .btn-check:active + .btn.btn-active-color-warning.dropdown-toggle:after, .btn.btn-active-color-warning:focus:not(.btn-active).dropdown-toggle:after, .btn.btn-active-color-warning:hover:not(.btn-active).dropdown-toggle:after, .btn.btn-active-color-warning:active:not(.btn-active).dropdown-toggle:after, .btn.btn-active-color-warning.active.dropdown-toggle:after, .btn.btn-active-color-warning.show.dropdown-toggle:after, .show > .btn.btn-active-color-warning.dropdown-toggle:after {\n  color: var(--bs-text-warning);\n}\n\n.btn.btn-icon-warning i,\n.btn.btn-icon-warning .svg-icon {\n  color: var(--bs-text-warning);\n}\n.btn.btn-icon-warning.dropdown-toggle:after {\n  color: var(--bs-text-warning);\n}\n.btn-check:checked + .btn.btn-active-icon-warning i,\n.btn-check:checked + .btn.btn-active-icon-warning .svg-icon, .btn-check:active + .btn.btn-active-icon-warning i,\n.btn-check:active + .btn.btn-active-icon-warning .svg-icon, .btn.btn-active-icon-warning:focus:not(.btn-active) i,\n.btn.btn-active-icon-warning:focus:not(.btn-active) .svg-icon, .btn.btn-active-icon-warning:hover:not(.btn-active) i,\n.btn.btn-active-icon-warning:hover:not(.btn-active) .svg-icon, .btn.btn-active-icon-warning:active:not(.btn-active) i,\n.btn.btn-active-icon-warning:active:not(.btn-active) .svg-icon, .btn.btn-active-icon-warning.active i,\n.btn.btn-active-icon-warning.active .svg-icon, .btn.btn-active-icon-warning.show i,\n.btn.btn-active-icon-warning.show .svg-icon, .show > .btn.btn-active-icon-warning i,\n.show > .btn.btn-active-icon-warning .svg-icon {\n  color: var(--bs-text-warning);\n}\n.btn-check:checked + .btn.btn-active-icon-warning.dropdown-toggle:after, .btn-check:active + .btn.btn-active-icon-warning.dropdown-toggle:after, .btn.btn-active-icon-warning:focus:not(.btn-active).dropdown-toggle:after, .btn.btn-active-icon-warning:hover:not(.btn-active).dropdown-toggle:after, .btn.btn-active-icon-warning:active:not(.btn-active).dropdown-toggle:after, .btn.btn-active-icon-warning.active.dropdown-toggle:after, .btn.btn-active-icon-warning.show.dropdown-toggle:after, .show > .btn.btn-active-icon-warning.dropdown-toggle:after {\n  color: var(--bs-text-warning);\n}\n\n.btn.btn-text-warning {\n  color: var(--bs-text-warning);\n}\n.btn-check:checked + .btn.btn-active-text-warning, .btn-check:active + .btn.btn-active-text-warning, .btn.btn-active-text-warning:focus:not(.btn-active), .btn.btn-active-text-warning:hover:not(.btn-active), .btn.btn-active-text-warning:active:not(.btn-active), .btn.btn-active-text-warning.active, .btn.btn-active-text-warning.show, .show > .btn.btn-active-text-warning {\n  color: var(--bs-text-warning);\n}\n\n.btn.btn-color-danger {\n  color: var(--bs-text-danger);\n}\n.btn.btn-color-danger i,\n.btn.btn-color-danger .svg-icon {\n  color: var(--bs-text-danger);\n}\n.btn.btn-color-danger.dropdown-toggle:after {\n  color: var(--bs-text-danger);\n}\n.btn-check:checked + .btn.btn-active-color-danger, .btn-check:active + .btn.btn-active-color-danger, .btn.btn-active-color-danger:focus:not(.btn-active), .btn.btn-active-color-danger:hover:not(.btn-active), .btn.btn-active-color-danger:active:not(.btn-active), .btn.btn-active-color-danger.active, .btn.btn-active-color-danger.show, .show > .btn.btn-active-color-danger {\n  color: var(--bs-text-danger);\n}\n.btn-check:checked + .btn.btn-active-color-danger i,\n.btn-check:checked + .btn.btn-active-color-danger .svg-icon, .btn-check:active + .btn.btn-active-color-danger i,\n.btn-check:active + .btn.btn-active-color-danger .svg-icon, .btn.btn-active-color-danger:focus:not(.btn-active) i,\n.btn.btn-active-color-danger:focus:not(.btn-active) .svg-icon, .btn.btn-active-color-danger:hover:not(.btn-active) i,\n.btn.btn-active-color-danger:hover:not(.btn-active) .svg-icon, .btn.btn-active-color-danger:active:not(.btn-active) i,\n.btn.btn-active-color-danger:active:not(.btn-active) .svg-icon, .btn.btn-active-color-danger.active i,\n.btn.btn-active-color-danger.active .svg-icon, .btn.btn-active-color-danger.show i,\n.btn.btn-active-color-danger.show .svg-icon, .show > .btn.btn-active-color-danger i,\n.show > .btn.btn-active-color-danger .svg-icon {\n  color: var(--bs-text-danger);\n}\n.btn-check:checked + .btn.btn-active-color-danger.dropdown-toggle:after, .btn-check:active + .btn.btn-active-color-danger.dropdown-toggle:after, .btn.btn-active-color-danger:focus:not(.btn-active).dropdown-toggle:after, .btn.btn-active-color-danger:hover:not(.btn-active).dropdown-toggle:after, .btn.btn-active-color-danger:active:not(.btn-active).dropdown-toggle:after, .btn.btn-active-color-danger.active.dropdown-toggle:after, .btn.btn-active-color-danger.show.dropdown-toggle:after, .show > .btn.btn-active-color-danger.dropdown-toggle:after {\n  color: var(--bs-text-danger);\n}\n\n.btn.btn-icon-danger i,\n.btn.btn-icon-danger .svg-icon {\n  color: var(--bs-text-danger);\n}\n.btn.btn-icon-danger.dropdown-toggle:after {\n  color: var(--bs-text-danger);\n}\n.btn-check:checked + .btn.btn-active-icon-danger i,\n.btn-check:checked + .btn.btn-active-icon-danger .svg-icon, .btn-check:active + .btn.btn-active-icon-danger i,\n.btn-check:active + .btn.btn-active-icon-danger .svg-icon, .btn.btn-active-icon-danger:focus:not(.btn-active) i,\n.btn.btn-active-icon-danger:focus:not(.btn-active) .svg-icon, .btn.btn-active-icon-danger:hover:not(.btn-active) i,\n.btn.btn-active-icon-danger:hover:not(.btn-active) .svg-icon, .btn.btn-active-icon-danger:active:not(.btn-active) i,\n.btn.btn-active-icon-danger:active:not(.btn-active) .svg-icon, .btn.btn-active-icon-danger.active i,\n.btn.btn-active-icon-danger.active .svg-icon, .btn.btn-active-icon-danger.show i,\n.btn.btn-active-icon-danger.show .svg-icon, .show > .btn.btn-active-icon-danger i,\n.show > .btn.btn-active-icon-danger .svg-icon {\n  color: var(--bs-text-danger);\n}\n.btn-check:checked + .btn.btn-active-icon-danger.dropdown-toggle:after, .btn-check:active + .btn.btn-active-icon-danger.dropdown-toggle:after, .btn.btn-active-icon-danger:focus:not(.btn-active).dropdown-toggle:after, .btn.btn-active-icon-danger:hover:not(.btn-active).dropdown-toggle:after, .btn.btn-active-icon-danger:active:not(.btn-active).dropdown-toggle:after, .btn.btn-active-icon-danger.active.dropdown-toggle:after, .btn.btn-active-icon-danger.show.dropdown-toggle:after, .show > .btn.btn-active-icon-danger.dropdown-toggle:after {\n  color: var(--bs-text-danger);\n}\n\n.btn.btn-text-danger {\n  color: var(--bs-text-danger);\n}\n.btn-check:checked + .btn.btn-active-text-danger, .btn-check:active + .btn.btn-active-text-danger, .btn.btn-active-text-danger:focus:not(.btn-active), .btn.btn-active-text-danger:hover:not(.btn-active), .btn.btn-active-text-danger:active:not(.btn-active), .btn.btn-active-text-danger.active, .btn.btn-active-text-danger.show, .show > .btn.btn-active-text-danger {\n  color: var(--bs-text-danger);\n}\n\n.btn.btn-color-dark {\n  color: var(--bs-text-dark);\n}\n.btn.btn-color-dark i,\n.btn.btn-color-dark .svg-icon {\n  color: var(--bs-text-dark);\n}\n.btn.btn-color-dark.dropdown-toggle:after {\n  color: var(--bs-text-dark);\n}\n.btn-check:checked + .btn.btn-active-color-dark, .btn-check:active + .btn.btn-active-color-dark, .btn.btn-active-color-dark:focus:not(.btn-active), .btn.btn-active-color-dark:hover:not(.btn-active), .btn.btn-active-color-dark:active:not(.btn-active), .btn.btn-active-color-dark.active, .btn.btn-active-color-dark.show, .show > .btn.btn-active-color-dark {\n  color: var(--bs-text-dark);\n}\n.btn-check:checked + .btn.btn-active-color-dark i,\n.btn-check:checked + .btn.btn-active-color-dark .svg-icon, .btn-check:active + .btn.btn-active-color-dark i,\n.btn-check:active + .btn.btn-active-color-dark .svg-icon, .btn.btn-active-color-dark:focus:not(.btn-active) i,\n.btn.btn-active-color-dark:focus:not(.btn-active) .svg-icon, .btn.btn-active-color-dark:hover:not(.btn-active) i,\n.btn.btn-active-color-dark:hover:not(.btn-active) .svg-icon, .btn.btn-active-color-dark:active:not(.btn-active) i,\n.btn.btn-active-color-dark:active:not(.btn-active) .svg-icon, .btn.btn-active-color-dark.active i,\n.btn.btn-active-color-dark.active .svg-icon, .btn.btn-active-color-dark.show i,\n.btn.btn-active-color-dark.show .svg-icon, .show > .btn.btn-active-color-dark i,\n.show > .btn.btn-active-color-dark .svg-icon {\n  color: var(--bs-text-dark);\n}\n.btn-check:checked + .btn.btn-active-color-dark.dropdown-toggle:after, .btn-check:active + .btn.btn-active-color-dark.dropdown-toggle:after, .btn.btn-active-color-dark:focus:not(.btn-active).dropdown-toggle:after, .btn.btn-active-color-dark:hover:not(.btn-active).dropdown-toggle:after, .btn.btn-active-color-dark:active:not(.btn-active).dropdown-toggle:after, .btn.btn-active-color-dark.active.dropdown-toggle:after, .btn.btn-active-color-dark.show.dropdown-toggle:after, .show > .btn.btn-active-color-dark.dropdown-toggle:after {\n  color: var(--bs-text-dark);\n}\n\n.btn.btn-icon-dark i,\n.btn.btn-icon-dark .svg-icon {\n  color: var(--bs-text-dark);\n}\n.btn.btn-icon-dark.dropdown-toggle:after {\n  color: var(--bs-text-dark);\n}\n.btn-check:checked + .btn.btn-active-icon-dark i,\n.btn-check:checked + .btn.btn-active-icon-dark .svg-icon, .btn-check:active + .btn.btn-active-icon-dark i,\n.btn-check:active + .btn.btn-active-icon-dark .svg-icon, .btn.btn-active-icon-dark:focus:not(.btn-active) i,\n.btn.btn-active-icon-dark:focus:not(.btn-active) .svg-icon, .btn.btn-active-icon-dark:hover:not(.btn-active) i,\n.btn.btn-active-icon-dark:hover:not(.btn-active) .svg-icon, .btn.btn-active-icon-dark:active:not(.btn-active) i,\n.btn.btn-active-icon-dark:active:not(.btn-active) .svg-icon, .btn.btn-active-icon-dark.active i,\n.btn.btn-active-icon-dark.active .svg-icon, .btn.btn-active-icon-dark.show i,\n.btn.btn-active-icon-dark.show .svg-icon, .show > .btn.btn-active-icon-dark i,\n.show > .btn.btn-active-icon-dark .svg-icon {\n  color: var(--bs-text-dark);\n}\n.btn-check:checked + .btn.btn-active-icon-dark.dropdown-toggle:after, .btn-check:active + .btn.btn-active-icon-dark.dropdown-toggle:after, .btn.btn-active-icon-dark:focus:not(.btn-active).dropdown-toggle:after, .btn.btn-active-icon-dark:hover:not(.btn-active).dropdown-toggle:after, .btn.btn-active-icon-dark:active:not(.btn-active).dropdown-toggle:after, .btn.btn-active-icon-dark.active.dropdown-toggle:after, .btn.btn-active-icon-dark.show.dropdown-toggle:after, .show > .btn.btn-active-icon-dark.dropdown-toggle:after {\n  color: var(--bs-text-dark);\n}\n\n.btn.btn-text-dark {\n  color: var(--bs-text-dark);\n}\n.btn-check:checked + .btn.btn-active-text-dark, .btn-check:active + .btn.btn-active-text-dark, .btn.btn-active-text-dark:focus:not(.btn-active), .btn.btn-active-text-dark:hover:not(.btn-active), .btn.btn-active-text-dark:active:not(.btn-active), .btn.btn-active-text-dark.active, .btn.btn-active-text-dark.show, .show > .btn.btn-active-text-dark {\n  color: var(--bs-text-dark);\n}\n\n.btn.btn-color-muted {\n  color: var(--bs-text-muted);\n}\n.btn.btn-color-muted i,\n.btn.btn-color-muted .svg-icon {\n  color: var(--bs-text-muted);\n}\n.btn.btn-color-muted.dropdown-toggle:after {\n  color: var(--bs-text-muted);\n}\n.btn-check:checked + .btn.btn-active-color-muted, .btn-check:active + .btn.btn-active-color-muted, .btn.btn-active-color-muted:focus:not(.btn-active), .btn.btn-active-color-muted:hover:not(.btn-active), .btn.btn-active-color-muted:active:not(.btn-active), .btn.btn-active-color-muted.active, .btn.btn-active-color-muted.show, .show > .btn.btn-active-color-muted {\n  color: var(--bs-text-muted);\n}\n.btn-check:checked + .btn.btn-active-color-muted i,\n.btn-check:checked + .btn.btn-active-color-muted .svg-icon, .btn-check:active + .btn.btn-active-color-muted i,\n.btn-check:active + .btn.btn-active-color-muted .svg-icon, .btn.btn-active-color-muted:focus:not(.btn-active) i,\n.btn.btn-active-color-muted:focus:not(.btn-active) .svg-icon, .btn.btn-active-color-muted:hover:not(.btn-active) i,\n.btn.btn-active-color-muted:hover:not(.btn-active) .svg-icon, .btn.btn-active-color-muted:active:not(.btn-active) i,\n.btn.btn-active-color-muted:active:not(.btn-active) .svg-icon, .btn.btn-active-color-muted.active i,\n.btn.btn-active-color-muted.active .svg-icon, .btn.btn-active-color-muted.show i,\n.btn.btn-active-color-muted.show .svg-icon, .show > .btn.btn-active-color-muted i,\n.show > .btn.btn-active-color-muted .svg-icon {\n  color: var(--bs-text-muted);\n}\n.btn-check:checked + .btn.btn-active-color-muted.dropdown-toggle:after, .btn-check:active + .btn.btn-active-color-muted.dropdown-toggle:after, .btn.btn-active-color-muted:focus:not(.btn-active).dropdown-toggle:after, .btn.btn-active-color-muted:hover:not(.btn-active).dropdown-toggle:after, .btn.btn-active-color-muted:active:not(.btn-active).dropdown-toggle:after, .btn.btn-active-color-muted.active.dropdown-toggle:after, .btn.btn-active-color-muted.show.dropdown-toggle:after, .show > .btn.btn-active-color-muted.dropdown-toggle:after {\n  color: var(--bs-text-muted);\n}\n\n.btn.btn-icon-muted i,\n.btn.btn-icon-muted .svg-icon {\n  color: var(--bs-text-muted);\n}\n.btn.btn-icon-muted.dropdown-toggle:after {\n  color: var(--bs-text-muted);\n}\n.btn-check:checked + .btn.btn-active-icon-muted i,\n.btn-check:checked + .btn.btn-active-icon-muted .svg-icon, .btn-check:active + .btn.btn-active-icon-muted i,\n.btn-check:active + .btn.btn-active-icon-muted .svg-icon, .btn.btn-active-icon-muted:focus:not(.btn-active) i,\n.btn.btn-active-icon-muted:focus:not(.btn-active) .svg-icon, .btn.btn-active-icon-muted:hover:not(.btn-active) i,\n.btn.btn-active-icon-muted:hover:not(.btn-active) .svg-icon, .btn.btn-active-icon-muted:active:not(.btn-active) i,\n.btn.btn-active-icon-muted:active:not(.btn-active) .svg-icon, .btn.btn-active-icon-muted.active i,\n.btn.btn-active-icon-muted.active .svg-icon, .btn.btn-active-icon-muted.show i,\n.btn.btn-active-icon-muted.show .svg-icon, .show > .btn.btn-active-icon-muted i,\n.show > .btn.btn-active-icon-muted .svg-icon {\n  color: var(--bs-text-muted);\n}\n.btn-check:checked + .btn.btn-active-icon-muted.dropdown-toggle:after, .btn-check:active + .btn.btn-active-icon-muted.dropdown-toggle:after, .btn.btn-active-icon-muted:focus:not(.btn-active).dropdown-toggle:after, .btn.btn-active-icon-muted:hover:not(.btn-active).dropdown-toggle:after, .btn.btn-active-icon-muted:active:not(.btn-active).dropdown-toggle:after, .btn.btn-active-icon-muted.active.dropdown-toggle:after, .btn.btn-active-icon-muted.show.dropdown-toggle:after, .show > .btn.btn-active-icon-muted.dropdown-toggle:after {\n  color: var(--bs-text-muted);\n}\n\n.btn.btn-text-muted {\n  color: var(--bs-text-muted);\n}\n.btn-check:checked + .btn.btn-active-text-muted, .btn-check:active + .btn.btn-active-text-muted, .btn.btn-active-text-muted:focus:not(.btn-active), .btn.btn-active-text-muted:hover:not(.btn-active), .btn.btn-active-text-muted:active:not(.btn-active), .btn.btn-active-text-muted.active, .btn.btn-active-text-muted.show, .show > .btn.btn-active-text-muted {\n  color: var(--bs-text-muted);\n}\n\n.btn.btn-color-gray-100 {\n  color: var(--bs-text-gray-100);\n}\n.btn.btn-color-gray-100 i,\n.btn.btn-color-gray-100 .svg-icon {\n  color: var(--bs-text-gray-100);\n}\n.btn.btn-color-gray-100.dropdown-toggle:after {\n  color: var(--bs-text-gray-100);\n}\n.btn-check:checked + .btn.btn-active-color-gray-100, .btn-check:active + .btn.btn-active-color-gray-100, .btn.btn-active-color-gray-100:focus:not(.btn-active), .btn.btn-active-color-gray-100:hover:not(.btn-active), .btn.btn-active-color-gray-100:active:not(.btn-active), .btn.btn-active-color-gray-100.active, .btn.btn-active-color-gray-100.show, .show > .btn.btn-active-color-gray-100 {\n  color: var(--bs-text-gray-100);\n}\n.btn-check:checked + .btn.btn-active-color-gray-100 i,\n.btn-check:checked + .btn.btn-active-color-gray-100 .svg-icon, .btn-check:active + .btn.btn-active-color-gray-100 i,\n.btn-check:active + .btn.btn-active-color-gray-100 .svg-icon, .btn.btn-active-color-gray-100:focus:not(.btn-active) i,\n.btn.btn-active-color-gray-100:focus:not(.btn-active) .svg-icon, .btn.btn-active-color-gray-100:hover:not(.btn-active) i,\n.btn.btn-active-color-gray-100:hover:not(.btn-active) .svg-icon, .btn.btn-active-color-gray-100:active:not(.btn-active) i,\n.btn.btn-active-color-gray-100:active:not(.btn-active) .svg-icon, .btn.btn-active-color-gray-100.active i,\n.btn.btn-active-color-gray-100.active .svg-icon, .btn.btn-active-color-gray-100.show i,\n.btn.btn-active-color-gray-100.show .svg-icon, .show > .btn.btn-active-color-gray-100 i,\n.show > .btn.btn-active-color-gray-100 .svg-icon {\n  color: var(--bs-text-gray-100);\n}\n.btn-check:checked + .btn.btn-active-color-gray-100.dropdown-toggle:after, .btn-check:active + .btn.btn-active-color-gray-100.dropdown-toggle:after, .btn.btn-active-color-gray-100:focus:not(.btn-active).dropdown-toggle:after, .btn.btn-active-color-gray-100:hover:not(.btn-active).dropdown-toggle:after, .btn.btn-active-color-gray-100:active:not(.btn-active).dropdown-toggle:after, .btn.btn-active-color-gray-100.active.dropdown-toggle:after, .btn.btn-active-color-gray-100.show.dropdown-toggle:after, .show > .btn.btn-active-color-gray-100.dropdown-toggle:after {\n  color: var(--bs-text-gray-100);\n}\n\n.btn.btn-icon-gray-100 i,\n.btn.btn-icon-gray-100 .svg-icon {\n  color: var(--bs-text-gray-100);\n}\n.btn.btn-icon-gray-100.dropdown-toggle:after {\n  color: var(--bs-text-gray-100);\n}\n.btn-check:checked + .btn.btn-active-icon-gray-100 i,\n.btn-check:checked + .btn.btn-active-icon-gray-100 .svg-icon, .btn-check:active + .btn.btn-active-icon-gray-100 i,\n.btn-check:active + .btn.btn-active-icon-gray-100 .svg-icon, .btn.btn-active-icon-gray-100:focus:not(.btn-active) i,\n.btn.btn-active-icon-gray-100:focus:not(.btn-active) .svg-icon, .btn.btn-active-icon-gray-100:hover:not(.btn-active) i,\n.btn.btn-active-icon-gray-100:hover:not(.btn-active) .svg-icon, .btn.btn-active-icon-gray-100:active:not(.btn-active) i,\n.btn.btn-active-icon-gray-100:active:not(.btn-active) .svg-icon, .btn.btn-active-icon-gray-100.active i,\n.btn.btn-active-icon-gray-100.active .svg-icon, .btn.btn-active-icon-gray-100.show i,\n.btn.btn-active-icon-gray-100.show .svg-icon, .show > .btn.btn-active-icon-gray-100 i,\n.show > .btn.btn-active-icon-gray-100 .svg-icon {\n  color: var(--bs-text-gray-100);\n}\n.btn-check:checked + .btn.btn-active-icon-gray-100.dropdown-toggle:after, .btn-check:active + .btn.btn-active-icon-gray-100.dropdown-toggle:after, .btn.btn-active-icon-gray-100:focus:not(.btn-active).dropdown-toggle:after, .btn.btn-active-icon-gray-100:hover:not(.btn-active).dropdown-toggle:after, .btn.btn-active-icon-gray-100:active:not(.btn-active).dropdown-toggle:after, .btn.btn-active-icon-gray-100.active.dropdown-toggle:after, .btn.btn-active-icon-gray-100.show.dropdown-toggle:after, .show > .btn.btn-active-icon-gray-100.dropdown-toggle:after {\n  color: var(--bs-text-gray-100);\n}\n\n.btn.btn-text-gray-100 {\n  color: var(--bs-text-gray-100);\n}\n.btn-check:checked + .btn.btn-active-text-gray-100, .btn-check:active + .btn.btn-active-text-gray-100, .btn.btn-active-text-gray-100:focus:not(.btn-active), .btn.btn-active-text-gray-100:hover:not(.btn-active), .btn.btn-active-text-gray-100:active:not(.btn-active), .btn.btn-active-text-gray-100.active, .btn.btn-active-text-gray-100.show, .show > .btn.btn-active-text-gray-100 {\n  color: var(--bs-text-gray-100);\n}\n\n.btn.btn-color-gray-200 {\n  color: var(--bs-text-gray-200);\n}\n.btn.btn-color-gray-200 i,\n.btn.btn-color-gray-200 .svg-icon {\n  color: var(--bs-text-gray-200);\n}\n.btn.btn-color-gray-200.dropdown-toggle:after {\n  color: var(--bs-text-gray-200);\n}\n.btn-check:checked + .btn.btn-active-color-gray-200, .btn-check:active + .btn.btn-active-color-gray-200, .btn.btn-active-color-gray-200:focus:not(.btn-active), .btn.btn-active-color-gray-200:hover:not(.btn-active), .btn.btn-active-color-gray-200:active:not(.btn-active), .btn.btn-active-color-gray-200.active, .btn.btn-active-color-gray-200.show, .show > .btn.btn-active-color-gray-200 {\n  color: var(--bs-text-gray-200);\n}\n.btn-check:checked + .btn.btn-active-color-gray-200 i,\n.btn-check:checked + .btn.btn-active-color-gray-200 .svg-icon, .btn-check:active + .btn.btn-active-color-gray-200 i,\n.btn-check:active + .btn.btn-active-color-gray-200 .svg-icon, .btn.btn-active-color-gray-200:focus:not(.btn-active) i,\n.btn.btn-active-color-gray-200:focus:not(.btn-active) .svg-icon, .btn.btn-active-color-gray-200:hover:not(.btn-active) i,\n.btn.btn-active-color-gray-200:hover:not(.btn-active) .svg-icon, .btn.btn-active-color-gray-200:active:not(.btn-active) i,\n.btn.btn-active-color-gray-200:active:not(.btn-active) .svg-icon, .btn.btn-active-color-gray-200.active i,\n.btn.btn-active-color-gray-200.active .svg-icon, .btn.btn-active-color-gray-200.show i,\n.btn.btn-active-color-gray-200.show .svg-icon, .show > .btn.btn-active-color-gray-200 i,\n.show > .btn.btn-active-color-gray-200 .svg-icon {\n  color: var(--bs-text-gray-200);\n}\n.btn-check:checked + .btn.btn-active-color-gray-200.dropdown-toggle:after, .btn-check:active + .btn.btn-active-color-gray-200.dropdown-toggle:after, .btn.btn-active-color-gray-200:focus:not(.btn-active).dropdown-toggle:after, .btn.btn-active-color-gray-200:hover:not(.btn-active).dropdown-toggle:after, .btn.btn-active-color-gray-200:active:not(.btn-active).dropdown-toggle:after, .btn.btn-active-color-gray-200.active.dropdown-toggle:after, .btn.btn-active-color-gray-200.show.dropdown-toggle:after, .show > .btn.btn-active-color-gray-200.dropdown-toggle:after {\n  color: var(--bs-text-gray-200);\n}\n\n.btn.btn-icon-gray-200 i,\n.btn.btn-icon-gray-200 .svg-icon {\n  color: var(--bs-text-gray-200);\n}\n.btn.btn-icon-gray-200.dropdown-toggle:after {\n  color: var(--bs-text-gray-200);\n}\n.btn-check:checked + .btn.btn-active-icon-gray-200 i,\n.btn-check:checked + .btn.btn-active-icon-gray-200 .svg-icon, .btn-check:active + .btn.btn-active-icon-gray-200 i,\n.btn-check:active + .btn.btn-active-icon-gray-200 .svg-icon, .btn.btn-active-icon-gray-200:focus:not(.btn-active) i,\n.btn.btn-active-icon-gray-200:focus:not(.btn-active) .svg-icon, .btn.btn-active-icon-gray-200:hover:not(.btn-active) i,\n.btn.btn-active-icon-gray-200:hover:not(.btn-active) .svg-icon, .btn.btn-active-icon-gray-200:active:not(.btn-active) i,\n.btn.btn-active-icon-gray-200:active:not(.btn-active) .svg-icon, .btn.btn-active-icon-gray-200.active i,\n.btn.btn-active-icon-gray-200.active .svg-icon, .btn.btn-active-icon-gray-200.show i,\n.btn.btn-active-icon-gray-200.show .svg-icon, .show > .btn.btn-active-icon-gray-200 i,\n.show > .btn.btn-active-icon-gray-200 .svg-icon {\n  color: var(--bs-text-gray-200);\n}\n.btn-check:checked + .btn.btn-active-icon-gray-200.dropdown-toggle:after, .btn-check:active + .btn.btn-active-icon-gray-200.dropdown-toggle:after, .btn.btn-active-icon-gray-200:focus:not(.btn-active).dropdown-toggle:after, .btn.btn-active-icon-gray-200:hover:not(.btn-active).dropdown-toggle:after, .btn.btn-active-icon-gray-200:active:not(.btn-active).dropdown-toggle:after, .btn.btn-active-icon-gray-200.active.dropdown-toggle:after, .btn.btn-active-icon-gray-200.show.dropdown-toggle:after, .show > .btn.btn-active-icon-gray-200.dropdown-toggle:after {\n  color: var(--bs-text-gray-200);\n}\n\n.btn.btn-text-gray-200 {\n  color: var(--bs-text-gray-200);\n}\n.btn-check:checked + .btn.btn-active-text-gray-200, .btn-check:active + .btn.btn-active-text-gray-200, .btn.btn-active-text-gray-200:focus:not(.btn-active), .btn.btn-active-text-gray-200:hover:not(.btn-active), .btn.btn-active-text-gray-200:active:not(.btn-active), .btn.btn-active-text-gray-200.active, .btn.btn-active-text-gray-200.show, .show > .btn.btn-active-text-gray-200 {\n  color: var(--bs-text-gray-200);\n}\n\n.btn.btn-color-gray-300 {\n  color: var(--bs-text-gray-300);\n}\n.btn.btn-color-gray-300 i,\n.btn.btn-color-gray-300 .svg-icon {\n  color: var(--bs-text-gray-300);\n}\n.btn.btn-color-gray-300.dropdown-toggle:after {\n  color: var(--bs-text-gray-300);\n}\n.btn-check:checked + .btn.btn-active-color-gray-300, .btn-check:active + .btn.btn-active-color-gray-300, .btn.btn-active-color-gray-300:focus:not(.btn-active), .btn.btn-active-color-gray-300:hover:not(.btn-active), .btn.btn-active-color-gray-300:active:not(.btn-active), .btn.btn-active-color-gray-300.active, .btn.btn-active-color-gray-300.show, .show > .btn.btn-active-color-gray-300 {\n  color: var(--bs-text-gray-300);\n}\n.btn-check:checked + .btn.btn-active-color-gray-300 i,\n.btn-check:checked + .btn.btn-active-color-gray-300 .svg-icon, .btn-check:active + .btn.btn-active-color-gray-300 i,\n.btn-check:active + .btn.btn-active-color-gray-300 .svg-icon, .btn.btn-active-color-gray-300:focus:not(.btn-active) i,\n.btn.btn-active-color-gray-300:focus:not(.btn-active) .svg-icon, .btn.btn-active-color-gray-300:hover:not(.btn-active) i,\n.btn.btn-active-color-gray-300:hover:not(.btn-active) .svg-icon, .btn.btn-active-color-gray-300:active:not(.btn-active) i,\n.btn.btn-active-color-gray-300:active:not(.btn-active) .svg-icon, .btn.btn-active-color-gray-300.active i,\n.btn.btn-active-color-gray-300.active .svg-icon, .btn.btn-active-color-gray-300.show i,\n.btn.btn-active-color-gray-300.show .svg-icon, .show > .btn.btn-active-color-gray-300 i,\n.show > .btn.btn-active-color-gray-300 .svg-icon {\n  color: var(--bs-text-gray-300);\n}\n.btn-check:checked + .btn.btn-active-color-gray-300.dropdown-toggle:after, .btn-check:active + .btn.btn-active-color-gray-300.dropdown-toggle:after, .btn.btn-active-color-gray-300:focus:not(.btn-active).dropdown-toggle:after, .btn.btn-active-color-gray-300:hover:not(.btn-active).dropdown-toggle:after, .btn.btn-active-color-gray-300:active:not(.btn-active).dropdown-toggle:after, .btn.btn-active-color-gray-300.active.dropdown-toggle:after, .btn.btn-active-color-gray-300.show.dropdown-toggle:after, .show > .btn.btn-active-color-gray-300.dropdown-toggle:after {\n  color: var(--bs-text-gray-300);\n}\n\n.btn.btn-icon-gray-300 i,\n.btn.btn-icon-gray-300 .svg-icon {\n  color: var(--bs-text-gray-300);\n}\n.btn.btn-icon-gray-300.dropdown-toggle:after {\n  color: var(--bs-text-gray-300);\n}\n.btn-check:checked + .btn.btn-active-icon-gray-300 i,\n.btn-check:checked + .btn.btn-active-icon-gray-300 .svg-icon, .btn-check:active + .btn.btn-active-icon-gray-300 i,\n.btn-check:active + .btn.btn-active-icon-gray-300 .svg-icon, .btn.btn-active-icon-gray-300:focus:not(.btn-active) i,\n.btn.btn-active-icon-gray-300:focus:not(.btn-active) .svg-icon, .btn.btn-active-icon-gray-300:hover:not(.btn-active) i,\n.btn.btn-active-icon-gray-300:hover:not(.btn-active) .svg-icon, .btn.btn-active-icon-gray-300:active:not(.btn-active) i,\n.btn.btn-active-icon-gray-300:active:not(.btn-active) .svg-icon, .btn.btn-active-icon-gray-300.active i,\n.btn.btn-active-icon-gray-300.active .svg-icon, .btn.btn-active-icon-gray-300.show i,\n.btn.btn-active-icon-gray-300.show .svg-icon, .show > .btn.btn-active-icon-gray-300 i,\n.show > .btn.btn-active-icon-gray-300 .svg-icon {\n  color: var(--bs-text-gray-300);\n}\n.btn-check:checked + .btn.btn-active-icon-gray-300.dropdown-toggle:after, .btn-check:active + .btn.btn-active-icon-gray-300.dropdown-toggle:after, .btn.btn-active-icon-gray-300:focus:not(.btn-active).dropdown-toggle:after, .btn.btn-active-icon-gray-300:hover:not(.btn-active).dropdown-toggle:after, .btn.btn-active-icon-gray-300:active:not(.btn-active).dropdown-toggle:after, .btn.btn-active-icon-gray-300.active.dropdown-toggle:after, .btn.btn-active-icon-gray-300.show.dropdown-toggle:after, .show > .btn.btn-active-icon-gray-300.dropdown-toggle:after {\n  color: var(--bs-text-gray-300);\n}\n\n.btn.btn-text-gray-300 {\n  color: var(--bs-text-gray-300);\n}\n.btn-check:checked + .btn.btn-active-text-gray-300, .btn-check:active + .btn.btn-active-text-gray-300, .btn.btn-active-text-gray-300:focus:not(.btn-active), .btn.btn-active-text-gray-300:hover:not(.btn-active), .btn.btn-active-text-gray-300:active:not(.btn-active), .btn.btn-active-text-gray-300.active, .btn.btn-active-text-gray-300.show, .show > .btn.btn-active-text-gray-300 {\n  color: var(--bs-text-gray-300);\n}\n\n.btn.btn-color-gray-400 {\n  color: var(--bs-text-gray-400);\n}\n.btn.btn-color-gray-400 i,\n.btn.btn-color-gray-400 .svg-icon {\n  color: var(--bs-text-gray-400);\n}\n.btn.btn-color-gray-400.dropdown-toggle:after {\n  color: var(--bs-text-gray-400);\n}\n.btn-check:checked + .btn.btn-active-color-gray-400, .btn-check:active + .btn.btn-active-color-gray-400, .btn.btn-active-color-gray-400:focus:not(.btn-active), .btn.btn-active-color-gray-400:hover:not(.btn-active), .btn.btn-active-color-gray-400:active:not(.btn-active), .btn.btn-active-color-gray-400.active, .btn.btn-active-color-gray-400.show, .show > .btn.btn-active-color-gray-400 {\n  color: var(--bs-text-gray-400);\n}\n.btn-check:checked + .btn.btn-active-color-gray-400 i,\n.btn-check:checked + .btn.btn-active-color-gray-400 .svg-icon, .btn-check:active + .btn.btn-active-color-gray-400 i,\n.btn-check:active + .btn.btn-active-color-gray-400 .svg-icon, .btn.btn-active-color-gray-400:focus:not(.btn-active) i,\n.btn.btn-active-color-gray-400:focus:not(.btn-active) .svg-icon, .btn.btn-active-color-gray-400:hover:not(.btn-active) i,\n.btn.btn-active-color-gray-400:hover:not(.btn-active) .svg-icon, .btn.btn-active-color-gray-400:active:not(.btn-active) i,\n.btn.btn-active-color-gray-400:active:not(.btn-active) .svg-icon, .btn.btn-active-color-gray-400.active i,\n.btn.btn-active-color-gray-400.active .svg-icon, .btn.btn-active-color-gray-400.show i,\n.btn.btn-active-color-gray-400.show .svg-icon, .show > .btn.btn-active-color-gray-400 i,\n.show > .btn.btn-active-color-gray-400 .svg-icon {\n  color: var(--bs-text-gray-400);\n}\n.btn-check:checked + .btn.btn-active-color-gray-400.dropdown-toggle:after, .btn-check:active + .btn.btn-active-color-gray-400.dropdown-toggle:after, .btn.btn-active-color-gray-400:focus:not(.btn-active).dropdown-toggle:after, .btn.btn-active-color-gray-400:hover:not(.btn-active).dropdown-toggle:after, .btn.btn-active-color-gray-400:active:not(.btn-active).dropdown-toggle:after, .btn.btn-active-color-gray-400.active.dropdown-toggle:after, .btn.btn-active-color-gray-400.show.dropdown-toggle:after, .show > .btn.btn-active-color-gray-400.dropdown-toggle:after {\n  color: var(--bs-text-gray-400);\n}\n\n.btn.btn-icon-gray-400 i,\n.btn.btn-icon-gray-400 .svg-icon {\n  color: var(--bs-text-gray-400);\n}\n.btn.btn-icon-gray-400.dropdown-toggle:after {\n  color: var(--bs-text-gray-400);\n}\n.btn-check:checked + .btn.btn-active-icon-gray-400 i,\n.btn-check:checked + .btn.btn-active-icon-gray-400 .svg-icon, .btn-check:active + .btn.btn-active-icon-gray-400 i,\n.btn-check:active + .btn.btn-active-icon-gray-400 .svg-icon, .btn.btn-active-icon-gray-400:focus:not(.btn-active) i,\n.btn.btn-active-icon-gray-400:focus:not(.btn-active) .svg-icon, .btn.btn-active-icon-gray-400:hover:not(.btn-active) i,\n.btn.btn-active-icon-gray-400:hover:not(.btn-active) .svg-icon, .btn.btn-active-icon-gray-400:active:not(.btn-active) i,\n.btn.btn-active-icon-gray-400:active:not(.btn-active) .svg-icon, .btn.btn-active-icon-gray-400.active i,\n.btn.btn-active-icon-gray-400.active .svg-icon, .btn.btn-active-icon-gray-400.show i,\n.btn.btn-active-icon-gray-400.show .svg-icon, .show > .btn.btn-active-icon-gray-400 i,\n.show > .btn.btn-active-icon-gray-400 .svg-icon {\n  color: var(--bs-text-gray-400);\n}\n.btn-check:checked + .btn.btn-active-icon-gray-400.dropdown-toggle:after, .btn-check:active + .btn.btn-active-icon-gray-400.dropdown-toggle:after, .btn.btn-active-icon-gray-400:focus:not(.btn-active).dropdown-toggle:after, .btn.btn-active-icon-gray-400:hover:not(.btn-active).dropdown-toggle:after, .btn.btn-active-icon-gray-400:active:not(.btn-active).dropdown-toggle:after, .btn.btn-active-icon-gray-400.active.dropdown-toggle:after, .btn.btn-active-icon-gray-400.show.dropdown-toggle:after, .show > .btn.btn-active-icon-gray-400.dropdown-toggle:after {\n  color: var(--bs-text-gray-400);\n}\n\n.btn.btn-text-gray-400 {\n  color: var(--bs-text-gray-400);\n}\n.btn-check:checked + .btn.btn-active-text-gray-400, .btn-check:active + .btn.btn-active-text-gray-400, .btn.btn-active-text-gray-400:focus:not(.btn-active), .btn.btn-active-text-gray-400:hover:not(.btn-active), .btn.btn-active-text-gray-400:active:not(.btn-active), .btn.btn-active-text-gray-400.active, .btn.btn-active-text-gray-400.show, .show > .btn.btn-active-text-gray-400 {\n  color: var(--bs-text-gray-400);\n}\n\n.btn.btn-color-gray-500 {\n  color: var(--bs-text-gray-500);\n}\n.btn.btn-color-gray-500 i,\n.btn.btn-color-gray-500 .svg-icon {\n  color: var(--bs-text-gray-500);\n}\n.btn.btn-color-gray-500.dropdown-toggle:after {\n  color: var(--bs-text-gray-500);\n}\n.btn-check:checked + .btn.btn-active-color-gray-500, .btn-check:active + .btn.btn-active-color-gray-500, .btn.btn-active-color-gray-500:focus:not(.btn-active), .btn.btn-active-color-gray-500:hover:not(.btn-active), .btn.btn-active-color-gray-500:active:not(.btn-active), .btn.btn-active-color-gray-500.active, .btn.btn-active-color-gray-500.show, .show > .btn.btn-active-color-gray-500 {\n  color: var(--bs-text-gray-500);\n}\n.btn-check:checked + .btn.btn-active-color-gray-500 i,\n.btn-check:checked + .btn.btn-active-color-gray-500 .svg-icon, .btn-check:active + .btn.btn-active-color-gray-500 i,\n.btn-check:active + .btn.btn-active-color-gray-500 .svg-icon, .btn.btn-active-color-gray-500:focus:not(.btn-active) i,\n.btn.btn-active-color-gray-500:focus:not(.btn-active) .svg-icon, .btn.btn-active-color-gray-500:hover:not(.btn-active) i,\n.btn.btn-active-color-gray-500:hover:not(.btn-active) .svg-icon, .btn.btn-active-color-gray-500:active:not(.btn-active) i,\n.btn.btn-active-color-gray-500:active:not(.btn-active) .svg-icon, .btn.btn-active-color-gray-500.active i,\n.btn.btn-active-color-gray-500.active .svg-icon, .btn.btn-active-color-gray-500.show i,\n.btn.btn-active-color-gray-500.show .svg-icon, .show > .btn.btn-active-color-gray-500 i,\n.show > .btn.btn-active-color-gray-500 .svg-icon {\n  color: var(--bs-text-gray-500);\n}\n.btn-check:checked + .btn.btn-active-color-gray-500.dropdown-toggle:after, .btn-check:active + .btn.btn-active-color-gray-500.dropdown-toggle:after, .btn.btn-active-color-gray-500:focus:not(.btn-active).dropdown-toggle:after, .btn.btn-active-color-gray-500:hover:not(.btn-active).dropdown-toggle:after, .btn.btn-active-color-gray-500:active:not(.btn-active).dropdown-toggle:after, .btn.btn-active-color-gray-500.active.dropdown-toggle:after, .btn.btn-active-color-gray-500.show.dropdown-toggle:after, .show > .btn.btn-active-color-gray-500.dropdown-toggle:after {\n  color: var(--bs-text-gray-500);\n}\n\n.btn.btn-icon-gray-500 i,\n.btn.btn-icon-gray-500 .svg-icon {\n  color: var(--bs-text-gray-500);\n}\n.btn.btn-icon-gray-500.dropdown-toggle:after {\n  color: var(--bs-text-gray-500);\n}\n.btn-check:checked + .btn.btn-active-icon-gray-500 i,\n.btn-check:checked + .btn.btn-active-icon-gray-500 .svg-icon, .btn-check:active + .btn.btn-active-icon-gray-500 i,\n.btn-check:active + .btn.btn-active-icon-gray-500 .svg-icon, .btn.btn-active-icon-gray-500:focus:not(.btn-active) i,\n.btn.btn-active-icon-gray-500:focus:not(.btn-active) .svg-icon, .btn.btn-active-icon-gray-500:hover:not(.btn-active) i,\n.btn.btn-active-icon-gray-500:hover:not(.btn-active) .svg-icon, .btn.btn-active-icon-gray-500:active:not(.btn-active) i,\n.btn.btn-active-icon-gray-500:active:not(.btn-active) .svg-icon, .btn.btn-active-icon-gray-500.active i,\n.btn.btn-active-icon-gray-500.active .svg-icon, .btn.btn-active-icon-gray-500.show i,\n.btn.btn-active-icon-gray-500.show .svg-icon, .show > .btn.btn-active-icon-gray-500 i,\n.show > .btn.btn-active-icon-gray-500 .svg-icon {\n  color: var(--bs-text-gray-500);\n}\n.btn-check:checked + .btn.btn-active-icon-gray-500.dropdown-toggle:after, .btn-check:active + .btn.btn-active-icon-gray-500.dropdown-toggle:after, .btn.btn-active-icon-gray-500:focus:not(.btn-active).dropdown-toggle:after, .btn.btn-active-icon-gray-500:hover:not(.btn-active).dropdown-toggle:after, .btn.btn-active-icon-gray-500:active:not(.btn-active).dropdown-toggle:after, .btn.btn-active-icon-gray-500.active.dropdown-toggle:after, .btn.btn-active-icon-gray-500.show.dropdown-toggle:after, .show > .btn.btn-active-icon-gray-500.dropdown-toggle:after {\n  color: var(--bs-text-gray-500);\n}\n\n.btn.btn-text-gray-500 {\n  color: var(--bs-text-gray-500);\n}\n.btn-check:checked + .btn.btn-active-text-gray-500, .btn-check:active + .btn.btn-active-text-gray-500, .btn.btn-active-text-gray-500:focus:not(.btn-active), .btn.btn-active-text-gray-500:hover:not(.btn-active), .btn.btn-active-text-gray-500:active:not(.btn-active), .btn.btn-active-text-gray-500.active, .btn.btn-active-text-gray-500.show, .show > .btn.btn-active-text-gray-500 {\n  color: var(--bs-text-gray-500);\n}\n\n.btn.btn-color-gray-600 {\n  color: var(--bs-text-gray-600);\n}\n.btn.btn-color-gray-600 i,\n.btn.btn-color-gray-600 .svg-icon {\n  color: var(--bs-text-gray-600);\n}\n.btn.btn-color-gray-600.dropdown-toggle:after {\n  color: var(--bs-text-gray-600);\n}\n.btn-check:checked + .btn.btn-active-color-gray-600, .btn-check:active + .btn.btn-active-color-gray-600, .btn.btn-active-color-gray-600:focus:not(.btn-active), .btn.btn-active-color-gray-600:hover:not(.btn-active), .btn.btn-active-color-gray-600:active:not(.btn-active), .btn.btn-active-color-gray-600.active, .btn.btn-active-color-gray-600.show, .show > .btn.btn-active-color-gray-600 {\n  color: var(--bs-text-gray-600);\n}\n.btn-check:checked + .btn.btn-active-color-gray-600 i,\n.btn-check:checked + .btn.btn-active-color-gray-600 .svg-icon, .btn-check:active + .btn.btn-active-color-gray-600 i,\n.btn-check:active + .btn.btn-active-color-gray-600 .svg-icon, .btn.btn-active-color-gray-600:focus:not(.btn-active) i,\n.btn.btn-active-color-gray-600:focus:not(.btn-active) .svg-icon, .btn.btn-active-color-gray-600:hover:not(.btn-active) i,\n.btn.btn-active-color-gray-600:hover:not(.btn-active) .svg-icon, .btn.btn-active-color-gray-600:active:not(.btn-active) i,\n.btn.btn-active-color-gray-600:active:not(.btn-active) .svg-icon, .btn.btn-active-color-gray-600.active i,\n.btn.btn-active-color-gray-600.active .svg-icon, .btn.btn-active-color-gray-600.show i,\n.btn.btn-active-color-gray-600.show .svg-icon, .show > .btn.btn-active-color-gray-600 i,\n.show > .btn.btn-active-color-gray-600 .svg-icon {\n  color: var(--bs-text-gray-600);\n}\n.btn-check:checked + .btn.btn-active-color-gray-600.dropdown-toggle:after, .btn-check:active + .btn.btn-active-color-gray-600.dropdown-toggle:after, .btn.btn-active-color-gray-600:focus:not(.btn-active).dropdown-toggle:after, .btn.btn-active-color-gray-600:hover:not(.btn-active).dropdown-toggle:after, .btn.btn-active-color-gray-600:active:not(.btn-active).dropdown-toggle:after, .btn.btn-active-color-gray-600.active.dropdown-toggle:after, .btn.btn-active-color-gray-600.show.dropdown-toggle:after, .show > .btn.btn-active-color-gray-600.dropdown-toggle:after {\n  color: var(--bs-text-gray-600);\n}\n\n.btn.btn-icon-gray-600 i,\n.btn.btn-icon-gray-600 .svg-icon {\n  color: var(--bs-text-gray-600);\n}\n.btn.btn-icon-gray-600.dropdown-toggle:after {\n  color: var(--bs-text-gray-600);\n}\n.btn-check:checked + .btn.btn-active-icon-gray-600 i,\n.btn-check:checked + .btn.btn-active-icon-gray-600 .svg-icon, .btn-check:active + .btn.btn-active-icon-gray-600 i,\n.btn-check:active + .btn.btn-active-icon-gray-600 .svg-icon, .btn.btn-active-icon-gray-600:focus:not(.btn-active) i,\n.btn.btn-active-icon-gray-600:focus:not(.btn-active) .svg-icon, .btn.btn-active-icon-gray-600:hover:not(.btn-active) i,\n.btn.btn-active-icon-gray-600:hover:not(.btn-active) .svg-icon, .btn.btn-active-icon-gray-600:active:not(.btn-active) i,\n.btn.btn-active-icon-gray-600:active:not(.btn-active) .svg-icon, .btn.btn-active-icon-gray-600.active i,\n.btn.btn-active-icon-gray-600.active .svg-icon, .btn.btn-active-icon-gray-600.show i,\n.btn.btn-active-icon-gray-600.show .svg-icon, .show > .btn.btn-active-icon-gray-600 i,\n.show > .btn.btn-active-icon-gray-600 .svg-icon {\n  color: var(--bs-text-gray-600);\n}\n.btn-check:checked + .btn.btn-active-icon-gray-600.dropdown-toggle:after, .btn-check:active + .btn.btn-active-icon-gray-600.dropdown-toggle:after, .btn.btn-active-icon-gray-600:focus:not(.btn-active).dropdown-toggle:after, .btn.btn-active-icon-gray-600:hover:not(.btn-active).dropdown-toggle:after, .btn.btn-active-icon-gray-600:active:not(.btn-active).dropdown-toggle:after, .btn.btn-active-icon-gray-600.active.dropdown-toggle:after, .btn.btn-active-icon-gray-600.show.dropdown-toggle:after, .show > .btn.btn-active-icon-gray-600.dropdown-toggle:after {\n  color: var(--bs-text-gray-600);\n}\n\n.btn.btn-text-gray-600 {\n  color: var(--bs-text-gray-600);\n}\n.btn-check:checked + .btn.btn-active-text-gray-600, .btn-check:active + .btn.btn-active-text-gray-600, .btn.btn-active-text-gray-600:focus:not(.btn-active), .btn.btn-active-text-gray-600:hover:not(.btn-active), .btn.btn-active-text-gray-600:active:not(.btn-active), .btn.btn-active-text-gray-600.active, .btn.btn-active-text-gray-600.show, .show > .btn.btn-active-text-gray-600 {\n  color: var(--bs-text-gray-600);\n}\n\n.btn.btn-color-gray-700 {\n  color: var(--bs-text-gray-700);\n}\n.btn.btn-color-gray-700 i,\n.btn.btn-color-gray-700 .svg-icon {\n  color: var(--bs-text-gray-700);\n}\n.btn.btn-color-gray-700.dropdown-toggle:after {\n  color: var(--bs-text-gray-700);\n}\n.btn-check:checked + .btn.btn-active-color-gray-700, .btn-check:active + .btn.btn-active-color-gray-700, .btn.btn-active-color-gray-700:focus:not(.btn-active), .btn.btn-active-color-gray-700:hover:not(.btn-active), .btn.btn-active-color-gray-700:active:not(.btn-active), .btn.btn-active-color-gray-700.active, .btn.btn-active-color-gray-700.show, .show > .btn.btn-active-color-gray-700 {\n  color: var(--bs-text-gray-700);\n}\n.btn-check:checked + .btn.btn-active-color-gray-700 i,\n.btn-check:checked + .btn.btn-active-color-gray-700 .svg-icon, .btn-check:active + .btn.btn-active-color-gray-700 i,\n.btn-check:active + .btn.btn-active-color-gray-700 .svg-icon, .btn.btn-active-color-gray-700:focus:not(.btn-active) i,\n.btn.btn-active-color-gray-700:focus:not(.btn-active) .svg-icon, .btn.btn-active-color-gray-700:hover:not(.btn-active) i,\n.btn.btn-active-color-gray-700:hover:not(.btn-active) .svg-icon, .btn.btn-active-color-gray-700:active:not(.btn-active) i,\n.btn.btn-active-color-gray-700:active:not(.btn-active) .svg-icon, .btn.btn-active-color-gray-700.active i,\n.btn.btn-active-color-gray-700.active .svg-icon, .btn.btn-active-color-gray-700.show i,\n.btn.btn-active-color-gray-700.show .svg-icon, .show > .btn.btn-active-color-gray-700 i,\n.show > .btn.btn-active-color-gray-700 .svg-icon {\n  color: var(--bs-text-gray-700);\n}\n.btn-check:checked + .btn.btn-active-color-gray-700.dropdown-toggle:after, .btn-check:active + .btn.btn-active-color-gray-700.dropdown-toggle:after, .btn.btn-active-color-gray-700:focus:not(.btn-active).dropdown-toggle:after, .btn.btn-active-color-gray-700:hover:not(.btn-active).dropdown-toggle:after, .btn.btn-active-color-gray-700:active:not(.btn-active).dropdown-toggle:after, .btn.btn-active-color-gray-700.active.dropdown-toggle:after, .btn.btn-active-color-gray-700.show.dropdown-toggle:after, .show > .btn.btn-active-color-gray-700.dropdown-toggle:after {\n  color: var(--bs-text-gray-700);\n}\n\n.btn.btn-icon-gray-700 i,\n.btn.btn-icon-gray-700 .svg-icon {\n  color: var(--bs-text-gray-700);\n}\n.btn.btn-icon-gray-700.dropdown-toggle:after {\n  color: var(--bs-text-gray-700);\n}\n.btn-check:checked + .btn.btn-active-icon-gray-700 i,\n.btn-check:checked + .btn.btn-active-icon-gray-700 .svg-icon, .btn-check:active + .btn.btn-active-icon-gray-700 i,\n.btn-check:active + .btn.btn-active-icon-gray-700 .svg-icon, .btn.btn-active-icon-gray-700:focus:not(.btn-active) i,\n.btn.btn-active-icon-gray-700:focus:not(.btn-active) .svg-icon, .btn.btn-active-icon-gray-700:hover:not(.btn-active) i,\n.btn.btn-active-icon-gray-700:hover:not(.btn-active) .svg-icon, .btn.btn-active-icon-gray-700:active:not(.btn-active) i,\n.btn.btn-active-icon-gray-700:active:not(.btn-active) .svg-icon, .btn.btn-active-icon-gray-700.active i,\n.btn.btn-active-icon-gray-700.active .svg-icon, .btn.btn-active-icon-gray-700.show i,\n.btn.btn-active-icon-gray-700.show .svg-icon, .show > .btn.btn-active-icon-gray-700 i,\n.show > .btn.btn-active-icon-gray-700 .svg-icon {\n  color: var(--bs-text-gray-700);\n}\n.btn-check:checked + .btn.btn-active-icon-gray-700.dropdown-toggle:after, .btn-check:active + .btn.btn-active-icon-gray-700.dropdown-toggle:after, .btn.btn-active-icon-gray-700:focus:not(.btn-active).dropdown-toggle:after, .btn.btn-active-icon-gray-700:hover:not(.btn-active).dropdown-toggle:after, .btn.btn-active-icon-gray-700:active:not(.btn-active).dropdown-toggle:after, .btn.btn-active-icon-gray-700.active.dropdown-toggle:after, .btn.btn-active-icon-gray-700.show.dropdown-toggle:after, .show > .btn.btn-active-icon-gray-700.dropdown-toggle:after {\n  color: var(--bs-text-gray-700);\n}\n\n.btn.btn-text-gray-700 {\n  color: var(--bs-text-gray-700);\n}\n.btn-check:checked + .btn.btn-active-text-gray-700, .btn-check:active + .btn.btn-active-text-gray-700, .btn.btn-active-text-gray-700:focus:not(.btn-active), .btn.btn-active-text-gray-700:hover:not(.btn-active), .btn.btn-active-text-gray-700:active:not(.btn-active), .btn.btn-active-text-gray-700.active, .btn.btn-active-text-gray-700.show, .show > .btn.btn-active-text-gray-700 {\n  color: var(--bs-text-gray-700);\n}\n\n.btn.btn-color-gray-800 {\n  color: var(--bs-text-gray-800);\n}\n.btn.btn-color-gray-800 i,\n.btn.btn-color-gray-800 .svg-icon {\n  color: var(--bs-text-gray-800);\n}\n.btn.btn-color-gray-800.dropdown-toggle:after {\n  color: var(--bs-text-gray-800);\n}\n.btn-check:checked + .btn.btn-active-color-gray-800, .btn-check:active + .btn.btn-active-color-gray-800, .btn.btn-active-color-gray-800:focus:not(.btn-active), .btn.btn-active-color-gray-800:hover:not(.btn-active), .btn.btn-active-color-gray-800:active:not(.btn-active), .btn.btn-active-color-gray-800.active, .btn.btn-active-color-gray-800.show, .show > .btn.btn-active-color-gray-800 {\n  color: var(--bs-text-gray-800);\n}\n.btn-check:checked + .btn.btn-active-color-gray-800 i,\n.btn-check:checked + .btn.btn-active-color-gray-800 .svg-icon, .btn-check:active + .btn.btn-active-color-gray-800 i,\n.btn-check:active + .btn.btn-active-color-gray-800 .svg-icon, .btn.btn-active-color-gray-800:focus:not(.btn-active) i,\n.btn.btn-active-color-gray-800:focus:not(.btn-active) .svg-icon, .btn.btn-active-color-gray-800:hover:not(.btn-active) i,\n.btn.btn-active-color-gray-800:hover:not(.btn-active) .svg-icon, .btn.btn-active-color-gray-800:active:not(.btn-active) i,\n.btn.btn-active-color-gray-800:active:not(.btn-active) .svg-icon, .btn.btn-active-color-gray-800.active i,\n.btn.btn-active-color-gray-800.active .svg-icon, .btn.btn-active-color-gray-800.show i,\n.btn.btn-active-color-gray-800.show .svg-icon, .show > .btn.btn-active-color-gray-800 i,\n.show > .btn.btn-active-color-gray-800 .svg-icon {\n  color: var(--bs-text-gray-800);\n}\n.btn-check:checked + .btn.btn-active-color-gray-800.dropdown-toggle:after, .btn-check:active + .btn.btn-active-color-gray-800.dropdown-toggle:after, .btn.btn-active-color-gray-800:focus:not(.btn-active).dropdown-toggle:after, .btn.btn-active-color-gray-800:hover:not(.btn-active).dropdown-toggle:after, .btn.btn-active-color-gray-800:active:not(.btn-active).dropdown-toggle:after, .btn.btn-active-color-gray-800.active.dropdown-toggle:after, .btn.btn-active-color-gray-800.show.dropdown-toggle:after, .show > .btn.btn-active-color-gray-800.dropdown-toggle:after {\n  color: var(--bs-text-gray-800);\n}\n\n.btn.btn-icon-gray-800 i,\n.btn.btn-icon-gray-800 .svg-icon {\n  color: var(--bs-text-gray-800);\n}\n.btn.btn-icon-gray-800.dropdown-toggle:after {\n  color: var(--bs-text-gray-800);\n}\n.btn-check:checked + .btn.btn-active-icon-gray-800 i,\n.btn-check:checked + .btn.btn-active-icon-gray-800 .svg-icon, .btn-check:active + .btn.btn-active-icon-gray-800 i,\n.btn-check:active + .btn.btn-active-icon-gray-800 .svg-icon, .btn.btn-active-icon-gray-800:focus:not(.btn-active) i,\n.btn.btn-active-icon-gray-800:focus:not(.btn-active) .svg-icon, .btn.btn-active-icon-gray-800:hover:not(.btn-active) i,\n.btn.btn-active-icon-gray-800:hover:not(.btn-active) .svg-icon, .btn.btn-active-icon-gray-800:active:not(.btn-active) i,\n.btn.btn-active-icon-gray-800:active:not(.btn-active) .svg-icon, .btn.btn-active-icon-gray-800.active i,\n.btn.btn-active-icon-gray-800.active .svg-icon, .btn.btn-active-icon-gray-800.show i,\n.btn.btn-active-icon-gray-800.show .svg-icon, .show > .btn.btn-active-icon-gray-800 i,\n.show > .btn.btn-active-icon-gray-800 .svg-icon {\n  color: var(--bs-text-gray-800);\n}\n.btn-check:checked + .btn.btn-active-icon-gray-800.dropdown-toggle:after, .btn-check:active + .btn.btn-active-icon-gray-800.dropdown-toggle:after, .btn.btn-active-icon-gray-800:focus:not(.btn-active).dropdown-toggle:after, .btn.btn-active-icon-gray-800:hover:not(.btn-active).dropdown-toggle:after, .btn.btn-active-icon-gray-800:active:not(.btn-active).dropdown-toggle:after, .btn.btn-active-icon-gray-800.active.dropdown-toggle:after, .btn.btn-active-icon-gray-800.show.dropdown-toggle:after, .show > .btn.btn-active-icon-gray-800.dropdown-toggle:after {\n  color: var(--bs-text-gray-800);\n}\n\n.btn.btn-text-gray-800 {\n  color: var(--bs-text-gray-800);\n}\n.btn-check:checked + .btn.btn-active-text-gray-800, .btn-check:active + .btn.btn-active-text-gray-800, .btn.btn-active-text-gray-800:focus:not(.btn-active), .btn.btn-active-text-gray-800:hover:not(.btn-active), .btn.btn-active-text-gray-800:active:not(.btn-active), .btn.btn-active-text-gray-800.active, .btn.btn-active-text-gray-800.show, .show > .btn.btn-active-text-gray-800 {\n  color: var(--bs-text-gray-800);\n}\n\n.btn.btn-color-gray-900 {\n  color: var(--bs-text-gray-900);\n}\n.btn.btn-color-gray-900 i,\n.btn.btn-color-gray-900 .svg-icon {\n  color: var(--bs-text-gray-900);\n}\n.btn.btn-color-gray-900.dropdown-toggle:after {\n  color: var(--bs-text-gray-900);\n}\n.btn-check:checked + .btn.btn-active-color-gray-900, .btn-check:active + .btn.btn-active-color-gray-900, .btn.btn-active-color-gray-900:focus:not(.btn-active), .btn.btn-active-color-gray-900:hover:not(.btn-active), .btn.btn-active-color-gray-900:active:not(.btn-active), .btn.btn-active-color-gray-900.active, .btn.btn-active-color-gray-900.show, .show > .btn.btn-active-color-gray-900 {\n  color: var(--bs-text-gray-900);\n}\n.btn-check:checked + .btn.btn-active-color-gray-900 i,\n.btn-check:checked + .btn.btn-active-color-gray-900 .svg-icon, .btn-check:active + .btn.btn-active-color-gray-900 i,\n.btn-check:active + .btn.btn-active-color-gray-900 .svg-icon, .btn.btn-active-color-gray-900:focus:not(.btn-active) i,\n.btn.btn-active-color-gray-900:focus:not(.btn-active) .svg-icon, .btn.btn-active-color-gray-900:hover:not(.btn-active) i,\n.btn.btn-active-color-gray-900:hover:not(.btn-active) .svg-icon, .btn.btn-active-color-gray-900:active:not(.btn-active) i,\n.btn.btn-active-color-gray-900:active:not(.btn-active) .svg-icon, .btn.btn-active-color-gray-900.active i,\n.btn.btn-active-color-gray-900.active .svg-icon, .btn.btn-active-color-gray-900.show i,\n.btn.btn-active-color-gray-900.show .svg-icon, .show > .btn.btn-active-color-gray-900 i,\n.show > .btn.btn-active-color-gray-900 .svg-icon {\n  color: var(--bs-text-gray-900);\n}\n.btn-check:checked + .btn.btn-active-color-gray-900.dropdown-toggle:after, .btn-check:active + .btn.btn-active-color-gray-900.dropdown-toggle:after, .btn.btn-active-color-gray-900:focus:not(.btn-active).dropdown-toggle:after, .btn.btn-active-color-gray-900:hover:not(.btn-active).dropdown-toggle:after, .btn.btn-active-color-gray-900:active:not(.btn-active).dropdown-toggle:after, .btn.btn-active-color-gray-900.active.dropdown-toggle:after, .btn.btn-active-color-gray-900.show.dropdown-toggle:after, .show > .btn.btn-active-color-gray-900.dropdown-toggle:after {\n  color: var(--bs-text-gray-900);\n}\n\n.btn.btn-icon-gray-900 i,\n.btn.btn-icon-gray-900 .svg-icon {\n  color: var(--bs-text-gray-900);\n}\n.btn.btn-icon-gray-900.dropdown-toggle:after {\n  color: var(--bs-text-gray-900);\n}\n.btn-check:checked + .btn.btn-active-icon-gray-900 i,\n.btn-check:checked + .btn.btn-active-icon-gray-900 .svg-icon, .btn-check:active + .btn.btn-active-icon-gray-900 i,\n.btn-check:active + .btn.btn-active-icon-gray-900 .svg-icon, .btn.btn-active-icon-gray-900:focus:not(.btn-active) i,\n.btn.btn-active-icon-gray-900:focus:not(.btn-active) .svg-icon, .btn.btn-active-icon-gray-900:hover:not(.btn-active) i,\n.btn.btn-active-icon-gray-900:hover:not(.btn-active) .svg-icon, .btn.btn-active-icon-gray-900:active:not(.btn-active) i,\n.btn.btn-active-icon-gray-900:active:not(.btn-active) .svg-icon, .btn.btn-active-icon-gray-900.active i,\n.btn.btn-active-icon-gray-900.active .svg-icon, .btn.btn-active-icon-gray-900.show i,\n.btn.btn-active-icon-gray-900.show .svg-icon, .show > .btn.btn-active-icon-gray-900 i,\n.show > .btn.btn-active-icon-gray-900 .svg-icon {\n  color: var(--bs-text-gray-900);\n}\n.btn-check:checked + .btn.btn-active-icon-gray-900.dropdown-toggle:after, .btn-check:active + .btn.btn-active-icon-gray-900.dropdown-toggle:after, .btn.btn-active-icon-gray-900:focus:not(.btn-active).dropdown-toggle:after, .btn.btn-active-icon-gray-900:hover:not(.btn-active).dropdown-toggle:after, .btn.btn-active-icon-gray-900:active:not(.btn-active).dropdown-toggle:after, .btn.btn-active-icon-gray-900.active.dropdown-toggle:after, .btn.btn-active-icon-gray-900.show.dropdown-toggle:after, .show > .btn.btn-active-icon-gray-900.dropdown-toggle:after {\n  color: var(--bs-text-gray-900);\n}\n\n.btn.btn-text-gray-900 {\n  color: var(--bs-text-gray-900);\n}\n.btn-check:checked + .btn.btn-active-text-gray-900, .btn-check:active + .btn.btn-active-text-gray-900, .btn.btn-active-text-gray-900:focus:not(.btn-active), .btn.btn-active-text-gray-900:hover:not(.btn-active), .btn.btn-active-text-gray-900:active:not(.btn-active), .btn.btn-active-text-gray-900.active, .btn.btn-active-text-gray-900.show, .show > .btn.btn-active-text-gray-900 {\n  color: var(--bs-text-gray-900);\n}\n\n.btn.btn-facebook {\n  color: #ffffff;\n  border-color: #3b5998;\n  background-color: #3b5998;\n}\n.btn.btn-facebook i,\n.btn.btn-facebook .svg-icon {\n  color: #ffffff;\n}\n.btn.btn-facebook.dropdown-toggle:after {\n  color: #ffffff;\n}\n.btn-check:checked + .btn.btn-facebook, .btn-check:active + .btn.btn-facebook, .btn.btn-facebook:focus:not(.btn-active), .btn.btn-facebook:hover:not(.btn-active), .btn.btn-facebook:active:not(.btn-active), .btn.btn-facebook.active, .btn.btn-facebook.show, .show > .btn.btn-facebook {\n  border-color: #30497c;\n  background-color: #30497c !important;\n}\n\n.btn.btn-light-facebook {\n  color: #3b5998;\n  border-color: rgba(59, 89, 152, 0.1);\n  background-color: rgba(59, 89, 152, 0.1);\n}\n.btn.btn-light-facebook i,\n.btn.btn-light-facebook .svg-icon {\n  color: #3b5998;\n}\n.btn.btn-light-facebook.dropdown-toggle:after {\n  color: #3b5998;\n}\n.btn-check:checked + .btn.btn-light-facebook, .btn-check:active + .btn.btn-light-facebook, .btn.btn-light-facebook:focus:not(.btn-active), .btn.btn-light-facebook:hover:not(.btn-active), .btn.btn-light-facebook:active:not(.btn-active), .btn.btn-light-facebook.active, .btn.btn-light-facebook.show, .show > .btn.btn-light-facebook {\n  color: #ffffff;\n  border-color: #3b5998;\n  background-color: #3b5998 !important;\n}\n.btn-check:checked + .btn.btn-light-facebook i,\n.btn-check:checked + .btn.btn-light-facebook .svg-icon, .btn-check:active + .btn.btn-light-facebook i,\n.btn-check:active + .btn.btn-light-facebook .svg-icon, .btn.btn-light-facebook:focus:not(.btn-active) i,\n.btn.btn-light-facebook:focus:not(.btn-active) .svg-icon, .btn.btn-light-facebook:hover:not(.btn-active) i,\n.btn.btn-light-facebook:hover:not(.btn-active) .svg-icon, .btn.btn-light-facebook:active:not(.btn-active) i,\n.btn.btn-light-facebook:active:not(.btn-active) .svg-icon, .btn.btn-light-facebook.active i,\n.btn.btn-light-facebook.active .svg-icon, .btn.btn-light-facebook.show i,\n.btn.btn-light-facebook.show .svg-icon, .show > .btn.btn-light-facebook i,\n.show > .btn.btn-light-facebook .svg-icon {\n  color: #ffffff;\n}\n.btn-check:checked + .btn.btn-light-facebook.dropdown-toggle:after, .btn-check:active + .btn.btn-light-facebook.dropdown-toggle:after, .btn.btn-light-facebook:focus:not(.btn-active).dropdown-toggle:after, .btn.btn-light-facebook:hover:not(.btn-active).dropdown-toggle:after, .btn.btn-light-facebook:active:not(.btn-active).dropdown-toggle:after, .btn.btn-light-facebook.active.dropdown-toggle:after, .btn.btn-light-facebook.show.dropdown-toggle:after, .show > .btn.btn-light-facebook.dropdown-toggle:after {\n  color: #ffffff;\n}\n\n.btn.btn-google {\n  color: #ffffff;\n  border-color: #dd4b39;\n  background-color: #dd4b39;\n}\n.btn.btn-google i,\n.btn.btn-google .svg-icon {\n  color: #ffffff;\n}\n.btn.btn-google.dropdown-toggle:after {\n  color: #ffffff;\n}\n.btn-check:checked + .btn.btn-google, .btn-check:active + .btn.btn-google, .btn.btn-google:focus:not(.btn-active), .btn.btn-google:hover:not(.btn-active), .btn.btn-google:active:not(.btn-active), .btn.btn-google.active, .btn.btn-google.show, .show > .btn.btn-google {\n  border-color: #cd3623;\n  background-color: #cd3623 !important;\n}\n\n.btn.btn-light-google {\n  color: #dd4b39;\n  border-color: rgba(221, 75, 57, 0.1);\n  background-color: rgba(221, 75, 57, 0.1);\n}\n.btn.btn-light-google i,\n.btn.btn-light-google .svg-icon {\n  color: #dd4b39;\n}\n.btn.btn-light-google.dropdown-toggle:after {\n  color: #dd4b39;\n}\n.btn-check:checked + .btn.btn-light-google, .btn-check:active + .btn.btn-light-google, .btn.btn-light-google:focus:not(.btn-active), .btn.btn-light-google:hover:not(.btn-active), .btn.btn-light-google:active:not(.btn-active), .btn.btn-light-google.active, .btn.btn-light-google.show, .show > .btn.btn-light-google {\n  color: #ffffff;\n  border-color: #dd4b39;\n  background-color: #dd4b39 !important;\n}\n.btn-check:checked + .btn.btn-light-google i,\n.btn-check:checked + .btn.btn-light-google .svg-icon, .btn-check:active + .btn.btn-light-google i,\n.btn-check:active + .btn.btn-light-google .svg-icon, .btn.btn-light-google:focus:not(.btn-active) i,\n.btn.btn-light-google:focus:not(.btn-active) .svg-icon, .btn.btn-light-google:hover:not(.btn-active) i,\n.btn.btn-light-google:hover:not(.btn-active) .svg-icon, .btn.btn-light-google:active:not(.btn-active) i,\n.btn.btn-light-google:active:not(.btn-active) .svg-icon, .btn.btn-light-google.active i,\n.btn.btn-light-google.active .svg-icon, .btn.btn-light-google.show i,\n.btn.btn-light-google.show .svg-icon, .show > .btn.btn-light-google i,\n.show > .btn.btn-light-google .svg-icon {\n  color: #ffffff;\n}\n.btn-check:checked + .btn.btn-light-google.dropdown-toggle:after, .btn-check:active + .btn.btn-light-google.dropdown-toggle:after, .btn.btn-light-google:focus:not(.btn-active).dropdown-toggle:after, .btn.btn-light-google:hover:not(.btn-active).dropdown-toggle:after, .btn.btn-light-google:active:not(.btn-active).dropdown-toggle:after, .btn.btn-light-google.active.dropdown-toggle:after, .btn.btn-light-google.show.dropdown-toggle:after, .show > .btn.btn-light-google.dropdown-toggle:after {\n  color: #ffffff;\n}\n\n.btn.btn-twitter {\n  color: #ffffff;\n  border-color: #1da1f2;\n  background-color: #1da1f2;\n}\n.btn.btn-twitter i,\n.btn.btn-twitter .svg-icon {\n  color: #ffffff;\n}\n.btn.btn-twitter.dropdown-toggle:after {\n  color: #ffffff;\n}\n.btn-check:checked + .btn.btn-twitter, .btn-check:active + .btn.btn-twitter, .btn.btn-twitter:focus:not(.btn-active), .btn.btn-twitter:hover:not(.btn-active), .btn.btn-twitter:active:not(.btn-active), .btn.btn-twitter.active, .btn.btn-twitter.show, .show > .btn.btn-twitter {\n  border-color: #0d8ddc;\n  background-color: #0d8ddc !important;\n}\n\n.btn.btn-light-twitter {\n  color: #1da1f2;\n  border-color: rgba(29, 161, 242, 0.1);\n  background-color: rgba(29, 161, 242, 0.1);\n}\n.btn.btn-light-twitter i,\n.btn.btn-light-twitter .svg-icon {\n  color: #1da1f2;\n}\n.btn.btn-light-twitter.dropdown-toggle:after {\n  color: #1da1f2;\n}\n.btn-check:checked + .btn.btn-light-twitter, .btn-check:active + .btn.btn-light-twitter, .btn.btn-light-twitter:focus:not(.btn-active), .btn.btn-light-twitter:hover:not(.btn-active), .btn.btn-light-twitter:active:not(.btn-active), .btn.btn-light-twitter.active, .btn.btn-light-twitter.show, .show > .btn.btn-light-twitter {\n  color: #ffffff;\n  border-color: #1da1f2;\n  background-color: #1da1f2 !important;\n}\n.btn-check:checked + .btn.btn-light-twitter i,\n.btn-check:checked + .btn.btn-light-twitter .svg-icon, .btn-check:active + .btn.btn-light-twitter i,\n.btn-check:active + .btn.btn-light-twitter .svg-icon, .btn.btn-light-twitter:focus:not(.btn-active) i,\n.btn.btn-light-twitter:focus:not(.btn-active) .svg-icon, .btn.btn-light-twitter:hover:not(.btn-active) i,\n.btn.btn-light-twitter:hover:not(.btn-active) .svg-icon, .btn.btn-light-twitter:active:not(.btn-active) i,\n.btn.btn-light-twitter:active:not(.btn-active) .svg-icon, .btn.btn-light-twitter.active i,\n.btn.btn-light-twitter.active .svg-icon, .btn.btn-light-twitter.show i,\n.btn.btn-light-twitter.show .svg-icon, .show > .btn.btn-light-twitter i,\n.show > .btn.btn-light-twitter .svg-icon {\n  color: #ffffff;\n}\n.btn-check:checked + .btn.btn-light-twitter.dropdown-toggle:after, .btn-check:active + .btn.btn-light-twitter.dropdown-toggle:after, .btn.btn-light-twitter:focus:not(.btn-active).dropdown-toggle:after, .btn.btn-light-twitter:hover:not(.btn-active).dropdown-toggle:after, .btn.btn-light-twitter:active:not(.btn-active).dropdown-toggle:after, .btn.btn-light-twitter.active.dropdown-toggle:after, .btn.btn-light-twitter.show.dropdown-toggle:after, .show > .btn.btn-light-twitter.dropdown-toggle:after {\n  color: #ffffff;\n}\n\n.btn.btn-instagram {\n  color: #ffffff;\n  border-color: #e1306c;\n  background-color: #e1306c;\n}\n.btn.btn-instagram i,\n.btn.btn-instagram .svg-icon {\n  color: #ffffff;\n}\n.btn.btn-instagram.dropdown-toggle:after {\n  color: #ffffff;\n}\n.btn-check:checked + .btn.btn-instagram, .btn-check:active + .btn.btn-instagram, .btn.btn-instagram:focus:not(.btn-active), .btn.btn-instagram:hover:not(.btn-active), .btn.btn-instagram:active:not(.btn-active), .btn.btn-instagram.active, .btn.btn-instagram.show, .show > .btn.btn-instagram {\n  border-color: #cd1e59;\n  background-color: #cd1e59 !important;\n}\n\n.btn.btn-light-instagram {\n  color: #e1306c;\n  border-color: rgba(225, 48, 108, 0.1);\n  background-color: rgba(225, 48, 108, 0.1);\n}\n.btn.btn-light-instagram i,\n.btn.btn-light-instagram .svg-icon {\n  color: #e1306c;\n}\n.btn.btn-light-instagram.dropdown-toggle:after {\n  color: #e1306c;\n}\n.btn-check:checked + .btn.btn-light-instagram, .btn-check:active + .btn.btn-light-instagram, .btn.btn-light-instagram:focus:not(.btn-active), .btn.btn-light-instagram:hover:not(.btn-active), .btn.btn-light-instagram:active:not(.btn-active), .btn.btn-light-instagram.active, .btn.btn-light-instagram.show, .show > .btn.btn-light-instagram {\n  color: #ffffff;\n  border-color: #e1306c;\n  background-color: #e1306c !important;\n}\n.btn-check:checked + .btn.btn-light-instagram i,\n.btn-check:checked + .btn.btn-light-instagram .svg-icon, .btn-check:active + .btn.btn-light-instagram i,\n.btn-check:active + .btn.btn-light-instagram .svg-icon, .btn.btn-light-instagram:focus:not(.btn-active) i,\n.btn.btn-light-instagram:focus:not(.btn-active) .svg-icon, .btn.btn-light-instagram:hover:not(.btn-active) i,\n.btn.btn-light-instagram:hover:not(.btn-active) .svg-icon, .btn.btn-light-instagram:active:not(.btn-active) i,\n.btn.btn-light-instagram:active:not(.btn-active) .svg-icon, .btn.btn-light-instagram.active i,\n.btn.btn-light-instagram.active .svg-icon, .btn.btn-light-instagram.show i,\n.btn.btn-light-instagram.show .svg-icon, .show > .btn.btn-light-instagram i,\n.show > .btn.btn-light-instagram .svg-icon {\n  color: #ffffff;\n}\n.btn-check:checked + .btn.btn-light-instagram.dropdown-toggle:after, .btn-check:active + .btn.btn-light-instagram.dropdown-toggle:after, .btn.btn-light-instagram:focus:not(.btn-active).dropdown-toggle:after, .btn.btn-light-instagram:hover:not(.btn-active).dropdown-toggle:after, .btn.btn-light-instagram:active:not(.btn-active).dropdown-toggle:after, .btn.btn-light-instagram.active.dropdown-toggle:after, .btn.btn-light-instagram.show.dropdown-toggle:after, .show > .btn.btn-light-instagram.dropdown-toggle:after {\n  color: #ffffff;\n}\n\n.btn.btn-youtube {\n  color: #ffffff;\n  border-color: #ff0000;\n  background-color: #ff0000;\n}\n.btn.btn-youtube i,\n.btn.btn-youtube .svg-icon {\n  color: #ffffff;\n}\n.btn.btn-youtube.dropdown-toggle:after {\n  color: #ffffff;\n}\n.btn-check:checked + .btn.btn-youtube, .btn-check:active + .btn.btn-youtube, .btn.btn-youtube:focus:not(.btn-active), .btn.btn-youtube:hover:not(.btn-active), .btn.btn-youtube:active:not(.btn-active), .btn.btn-youtube.active, .btn.btn-youtube.show, .show > .btn.btn-youtube {\n  border-color: #d90000;\n  background-color: #d90000 !important;\n}\n\n.btn.btn-light-youtube {\n  color: #ff0000;\n  border-color: rgba(255, 0, 0, 0.1);\n  background-color: rgba(255, 0, 0, 0.1);\n}\n.btn.btn-light-youtube i,\n.btn.btn-light-youtube .svg-icon {\n  color: #ff0000;\n}\n.btn.btn-light-youtube.dropdown-toggle:after {\n  color: #ff0000;\n}\n.btn-check:checked + .btn.btn-light-youtube, .btn-check:active + .btn.btn-light-youtube, .btn.btn-light-youtube:focus:not(.btn-active), .btn.btn-light-youtube:hover:not(.btn-active), .btn.btn-light-youtube:active:not(.btn-active), .btn.btn-light-youtube.active, .btn.btn-light-youtube.show, .show > .btn.btn-light-youtube {\n  color: #ffffff;\n  border-color: #ff0000;\n  background-color: #ff0000 !important;\n}\n.btn-check:checked + .btn.btn-light-youtube i,\n.btn-check:checked + .btn.btn-light-youtube .svg-icon, .btn-check:active + .btn.btn-light-youtube i,\n.btn-check:active + .btn.btn-light-youtube .svg-icon, .btn.btn-light-youtube:focus:not(.btn-active) i,\n.btn.btn-light-youtube:focus:not(.btn-active) .svg-icon, .btn.btn-light-youtube:hover:not(.btn-active) i,\n.btn.btn-light-youtube:hover:not(.btn-active) .svg-icon, .btn.btn-light-youtube:active:not(.btn-active) i,\n.btn.btn-light-youtube:active:not(.btn-active) .svg-icon, .btn.btn-light-youtube.active i,\n.btn.btn-light-youtube.active .svg-icon, .btn.btn-light-youtube.show i,\n.btn.btn-light-youtube.show .svg-icon, .show > .btn.btn-light-youtube i,\n.show > .btn.btn-light-youtube .svg-icon {\n  color: #ffffff;\n}\n.btn-check:checked + .btn.btn-light-youtube.dropdown-toggle:after, .btn-check:active + .btn.btn-light-youtube.dropdown-toggle:after, .btn.btn-light-youtube:focus:not(.btn-active).dropdown-toggle:after, .btn.btn-light-youtube:hover:not(.btn-active).dropdown-toggle:after, .btn.btn-light-youtube:active:not(.btn-active).dropdown-toggle:after, .btn.btn-light-youtube.active.dropdown-toggle:after, .btn.btn-light-youtube.show.dropdown-toggle:after, .show > .btn.btn-light-youtube.dropdown-toggle:after {\n  color: #ffffff;\n}\n\n.btn.btn-linkedin {\n  color: #ffffff;\n  border-color: #0077b5;\n  background-color: #0077b5;\n}\n.btn.btn-linkedin i,\n.btn.btn-linkedin .svg-icon {\n  color: #ffffff;\n}\n.btn.btn-linkedin.dropdown-toggle:after {\n  color: #ffffff;\n}\n.btn-check:checked + .btn.btn-linkedin, .btn-check:active + .btn.btn-linkedin, .btn.btn-linkedin:focus:not(.btn-active), .btn.btn-linkedin:hover:not(.btn-active), .btn.btn-linkedin:active:not(.btn-active), .btn.btn-linkedin.active, .btn.btn-linkedin.show, .show > .btn.btn-linkedin {\n  border-color: #005e8f;\n  background-color: #005e8f !important;\n}\n\n.btn.btn-light-linkedin {\n  color: #0077b5;\n  border-color: rgba(0, 119, 181, 0.1);\n  background-color: rgba(0, 119, 181, 0.1);\n}\n.btn.btn-light-linkedin i,\n.btn.btn-light-linkedin .svg-icon {\n  color: #0077b5;\n}\n.btn.btn-light-linkedin.dropdown-toggle:after {\n  color: #0077b5;\n}\n.btn-check:checked + .btn.btn-light-linkedin, .btn-check:active + .btn.btn-light-linkedin, .btn.btn-light-linkedin:focus:not(.btn-active), .btn.btn-light-linkedin:hover:not(.btn-active), .btn.btn-light-linkedin:active:not(.btn-active), .btn.btn-light-linkedin.active, .btn.btn-light-linkedin.show, .show > .btn.btn-light-linkedin {\n  color: #ffffff;\n  border-color: #0077b5;\n  background-color: #0077b5 !important;\n}\n.btn-check:checked + .btn.btn-light-linkedin i,\n.btn-check:checked + .btn.btn-light-linkedin .svg-icon, .btn-check:active + .btn.btn-light-linkedin i,\n.btn-check:active + .btn.btn-light-linkedin .svg-icon, .btn.btn-light-linkedin:focus:not(.btn-active) i,\n.btn.btn-light-linkedin:focus:not(.btn-active) .svg-icon, .btn.btn-light-linkedin:hover:not(.btn-active) i,\n.btn.btn-light-linkedin:hover:not(.btn-active) .svg-icon, .btn.btn-light-linkedin:active:not(.btn-active) i,\n.btn.btn-light-linkedin:active:not(.btn-active) .svg-icon, .btn.btn-light-linkedin.active i,\n.btn.btn-light-linkedin.active .svg-icon, .btn.btn-light-linkedin.show i,\n.btn.btn-light-linkedin.show .svg-icon, .show > .btn.btn-light-linkedin i,\n.show > .btn.btn-light-linkedin .svg-icon {\n  color: #ffffff;\n}\n.btn-check:checked + .btn.btn-light-linkedin.dropdown-toggle:after, .btn-check:active + .btn.btn-light-linkedin.dropdown-toggle:after, .btn.btn-light-linkedin:focus:not(.btn-active).dropdown-toggle:after, .btn.btn-light-linkedin:hover:not(.btn-active).dropdown-toggle:after, .btn.btn-light-linkedin:active:not(.btn-active).dropdown-toggle:after, .btn.btn-light-linkedin.active.dropdown-toggle:after, .btn.btn-light-linkedin.show.dropdown-toggle:after, .show > .btn.btn-light-linkedin.dropdown-toggle:after {\n  color: #ffffff;\n}\n\n.modal-rounded {\n  border-radius: 0.475rem !important;\n}\n\ncode:not([class*=language-]) {\n  font-weight: 400;\n  color: var(--bs-code-color);\n  line-height: inherit;\n  font-size: inherit;\n  background-color: var(--bs-code-bg);\n  padding: 0.1rem 0.4rem;\n  margin: 0 0.5rem;\n  box-shadow: var(--bs-code-box-shadow);\n  border-radius: 0.3rem;\n}\n\n.col-form-label {\n  font-size: 1.05rem;\n}\n\n.form-control.form-control-transparent {\n  background-color: transparent;\n  border-color: transparent;\n}\n.dropdown.show > .form-control.form-control-transparent, .form-control.form-control-transparent:active, .form-control.form-control-transparent.active, .form-control.form-control-transparent:focus, .form-control.form-control-transparent.focus {\n  background-color: transparent;\n  border-color: transparent;\n}\n.form-control.form-control-flush {\n  border: 0;\n  background-color: transparent;\n  outline: none !important;\n  box-shadow: none;\n  border-radius: 0;\n}\n\n.form-control.form-control-solid {\n  background-color: var(--bs-gray-100);\n  border-color: var(--bs-gray-100);\n  color: var(--bs-gray-700);\n  transition: color 0.2s ease;\n}\n.form-control.form-control-solid::placeholder {\n  color: var(--bs-gray-500);\n}\n.form-control.form-control-solid::-moz-placeholder {\n  color: var(--bs-gray-500);\n  opacity: 1;\n}\n.dropdown.show > .form-control.form-control-solid, .form-control.form-control-solid:active, .form-control.form-control-solid.active, .form-control.form-control-solid:focus, .form-control.form-control-solid.focus {\n  background-color: var(--bs-gray-200);\n  border-color: var(--bs-gray-200);\n  color: var(--bs-gray-700);\n  transition: color 0.2s ease;\n}\n\n.form-control-solid-bg {\n  background-color: var(--bs-gray-100);\n}\n\n.form-control-plaintext {\n  color: var(--bs-gray-700);\n}\n\n.placeholder-gray-500::placeholder {\n  color: var(--bs-gray-500);\n}\n.placeholder-gray-500::-moz-placeholder {\n  color: var(--bs-gray-500);\n  opacity: 1;\n}\n\n.placeholder-white::placeholder {\n  color: #ffffff;\n}\n.placeholder-white::-moz-placeholder {\n  color: #ffffff;\n  opacity: 1;\n}\n\n.resize-none {\n  resize: none;\n}\n\n.form-floating .form-control.form-control-solid::placeholder {\n  color: transparent;\n}\n\n.form-select {\n  appearance: none;\n}\n.form-select:focus {\n  border-color: var(--bs-gray-400);\n  box-shadow: false, 0 0 0 0.25rem rgba(var(--bs-component-active-bg), 0.25);\n}\n.form-select:disabled {\n  color: var(--bs-gray-500);\n  background-color: var(--bs-gray-200);\n  border-color: var(--bs-gray-300);\n}\n.form-select:-moz-focusring {\n  text-shadow: 0 0 0 var(--bs-gray-700);\n}\n.form-select.form-select-solid {\n  background-color: var(--bs-gray-100);\n  border-color: var(--bs-gray-100);\n  color: var(--bs-gray-700);\n  transition: color 0.2s ease;\n}\n.form-select.form-select-solid::placeholder {\n  color: var(--bs-gray-500);\n}\n.form-select.form-select-solid::-moz-placeholder {\n  color: var(--bs-gray-500);\n  opacity: 1;\n}\n.dropdown.show > .form-select.form-select-solid, .form-select.form-select-solid:active, .form-select.form-select-solid.active, .form-select.form-select-solid:focus, .form-select.form-select-solid.focus {\n  background-color: var(--bs-gray-200);\n  border-color: var(--bs-gray-200) !important;\n  color: var(--bs-gray-700);\n  transition: color 0.2s ease;\n}\n.form-select.form-select-transparent {\n  background-color: transparent;\n  border-color: transparent;\n  color: var(--bs-gray-700);\n}\n.form-select.form-select-transparent::placeholder {\n  color: var(--bs-gray-500);\n}\n.form-select.form-select-transparent::-moz-placeholder {\n  color: var(--bs-gray-500);\n  opacity: 1;\n}\n.dropdown.show > .form-select.form-select-transparent, .form-select.form-select-transparent:active, .form-select.form-select-transparent.active, .form-select.form-select-transparent:focus, .form-select.form-select-transparent.focus {\n  background-color: transparent;\n  border-color: transparent !important;\n  color: var(--bs-gray-700);\n}\n\n.form-check:not(.form-switch) .form-check-input[type=checkbox] {\n  background-size: 60% 60%;\n}\n.form-check.form-check-sm .form-check-input {\n  height: 1.55rem;\n  width: 1.55rem;\n}\n.form-check.form-check-lg .form-check-input {\n  height: 2.25rem;\n  width: 2.25rem;\n}\n.form-check.form-check-inline {\n  display: inline-block;\n  margin-right: 1rem;\n}\n.form-check.form-check-solid .form-check-input {\n  border: 0;\n}\n.form-check.form-check-solid .form-check-input:not(:checked) {\n  background-color: var(--bs-gray-200);\n}\n.form-check.form-check-solid .form-check-input[type=checkbox]:indeterminate {\n  background-color: #009ef7;\n}\n.form-check.form-check-success .form-check-input:checked {\n  background-color: var(--bs-success);\n}\n.form-check.form-check-danger .form-check-input:checked {\n  background-color: var(--bs-danger);\n}\n.form-check.form-check-warning .form-check-input:checked {\n  background-color: var(--bs-warning);\n}\n\n.form-check-custom {\n  display: flex;\n  align-items: center;\n  padding-left: 0;\n  margin: 0;\n}\n.form-check-custom .form-check-input {\n  margin: 0;\n  float: none;\n  flex-shrink: 0;\n}\n.form-check-custom .form-check-label {\n  margin-left: 0.55rem;\n}\n\n.form-switch.form-check-custom .form-check-input {\n  height: 2.25rem;\n}\n.form-switch.form-check-custom.form-switch-sm .form-check-input {\n  height: 1.5rem;\n  width: 2.5rem;\n}\n.form-switch.form-check-custom.form-switch-lg .form-check-input {\n  height: 2.75rem;\n  width: 3.75rem;\n}\n.form-switch.form-check-solid .form-check-input {\n  --bs-form-switch-bg: url(\"data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' viewBox='-4 -4 8 8'%3e%3ccircle r='3' fill='%23ffffff'/%3e%3c/svg%3e\");\n}\n.form-switch.form-check-solid .form-check-input:not(:checked) {\n  background-color: var(--bs-gray-200);\n}\n\n[data-bs-theme=dark] .form-switch .form-check-input:focus:not(:checked) {\n  --bs-form-switch-bg: url(\"data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' viewBox='-4 -4 8 8'%3e%3ccircle r='3' fill='rgba%28255, 255, 255, 0.25%29'/%3e%3c/svg%3e\");\n}\n\n.form-check-image {\n  position: relative;\n  overflow: hidden;\n}\n.form-check-image img {\n  max-width: 100%;\n}\n.form-check-image .form-check-wrapper {\n  border-radius: 0.625rem;\n  border: 2px solid transparent;\n  transition: all 0.2s ease-in-out;\n  cursor: pointer;\n  overflow: hidden;\n  margin-bottom: 0.75rem;\n}\n.form-check-image .form-check-rounded {\n  border-radius: 0.625rem;\n}\n.form-check-image .form-check-label {\n  font-weight: 600;\n  margin-left: 0.5rem;\n}\n.form-check-image.active:not(.form-check-success):not(.form-check-danger) .form-check-wrapper {\n  border-color: var(--bs-primary) !important;\n}\n.form-check-image.form-check-success.active .form-check-wrapper {\n  border-color: var(--bs-success) !important;\n}\n.form-check-image.form-check-danger.active .form-check-wrapper {\n  border-color: var(--bs-danger) !important;\n}\n.form-check-image.disabled {\n  opacity: 0.65;\n}\n\n.input-group.input-group-solid {\n  border-radius: 0.475rem;\n}\n.input-group.input-group-solid.input-group-sm {\n  border-radius: 0.425rem;\n}\n.input-group.input-group-solid.input-group-lg {\n  border-radius: 0.625rem;\n}\n.input-group.input-group-solid .input-group-text {\n  background-color: var(--bs-gray-100);\n  border-color: var(--bs-gray-100);\n}\n.input-group.input-group-solid .input-group-text + .form-control {\n  border-left-color: var(--bs-gray-300);\n}\n.input-group.input-group-solid .form-control {\n  background-color: var(--bs-gray-100);\n  border-color: var(--bs-gray-100);\n}\n.input-group.input-group-solid .form-control + .input-group-text {\n  border-left-color: var(--bs-gray-300);\n}\n\n.form-floating .form-control.form-control-solid::placeholder {\n  color: transparent;\n}\n\n.required:after {\n  content: \"*\";\n  position: relative;\n  font-size: inherit;\n  color: var(--bs-danger);\n  padding-left: 0.25rem;\n  font-weight: 600;\n}\n\n.progress-vertical {\n  display: flex;\n  align-items: stretch;\n  justify-content: space-between;\n}\n.progress-vertical .progress {\n  height: 100%;\n  border-radius: 0.475rem;\n  display: flex;\n  align-items: flex-end;\n  margin-right: 1rem;\n}\n.progress-vertical .progress:last-child {\n  margin-right: 0;\n}\n.progress-vertical .progress .progress-bar {\n  width: 8px;\n  border-radius: 0.475rem;\n}\n\n.table:not(.table-bordered) > :not(:first-child) {\n  border-color: transparent;\n  border-width: 0;\n  border-style: none;\n}\n.table:not(.table-bordered) > :not(:last-child) > :last-child > * {\n  border-bottom-color: inherit;\n}\n.table:not(.table-bordered) tr, .table:not(.table-bordered) th, .table:not(.table-bordered) td {\n  border-color: inherit;\n  border-width: inherit;\n  border-style: inherit;\n  text-transform: inherit;\n  font-weight: inherit;\n  font-size: inherit;\n  color: inherit;\n  height: inherit;\n  min-height: inherit;\n}\n.table:not(.table-bordered) tr:first-child, .table:not(.table-bordered) th:first-child, .table:not(.table-bordered) td:first-child {\n  padding-left: 0;\n}\n.table:not(.table-bordered) tr:last-child, .table:not(.table-bordered) th:last-child, .table:not(.table-bordered) td:last-child {\n  padding-right: 0;\n}\n.table:not(.table-bordered) tfoot tr:last-child,\n.table:not(.table-bordered) tbody tr:last-child {\n  border-bottom: 0 !important;\n}\n.table:not(.table-bordered) tfoot tr:last-child th, .table:not(.table-bordered) tfoot tr:last-child td,\n.table:not(.table-bordered) tbody tr:last-child th,\n.table:not(.table-bordered) tbody tr:last-child td {\n  border-bottom: 0 !important;\n}\n.table:not(.table-bordered) tfoot th, .table:not(.table-bordered) tfoot td {\n  border-top: inherit;\n}\n.table:not(.table-bordered).table-rounded {\n  border-radius: 0.475rem;\n  border-spacing: 0;\n  border-collapse: separate;\n}\n.table:not(.table-bordered).table-flush tr, .table:not(.table-bordered).table-flush th, .table:not(.table-bordered).table-flush td {\n  padding: inherit;\n}\n.table:not(.table-bordered).table-row-bordered tr {\n  border-bottom-width: 1px;\n  border-bottom-style: solid;\n  border-bottom-color: var(--bs-border-color);\n}\n.table:not(.table-bordered).table-row-bordered tfoot th, .table:not(.table-bordered).table-row-bordered tfoot td {\n  border-top-width: 1px !important;\n}\n.table:not(.table-bordered).table-row-dashed tr {\n  border-bottom-width: 1px;\n  border-bottom-style: dashed;\n  border-bottom-color: var(--bs-border-color);\n}\n.table:not(.table-bordered).table-row-dashed tfoot th, .table:not(.table-bordered).table-row-dashed tfoot td {\n  border-top-width: 1px !important;\n}\n.table:not(.table-bordered).table-row-gray-100 tr {\n  border-bottom-color: var(--bs-gray-100);\n}\n.table:not(.table-bordered).table-row-gray-200 tr {\n  border-bottom-color: var(--bs-gray-200);\n}\n.table:not(.table-bordered).table-row-gray-300 tr {\n  border-bottom-color: var(--bs-gray-300);\n}\n.table:not(.table-bordered).table-row-gray-400 tr {\n  border-bottom-color: var(--bs-gray-400);\n}\n.table:not(.table-bordered).table-row-gray-500 tr {\n  border-bottom-color: var(--bs-gray-500);\n}\n.table:not(.table-bordered).table-row-gray-600 tr {\n  border-bottom-color: var(--bs-gray-600);\n}\n.table:not(.table-bordered).table-row-gray-700 tr {\n  border-bottom-color: var(--bs-gray-700);\n}\n.table:not(.table-bordered).table-row-gray-800 tr {\n  border-bottom-color: var(--bs-gray-800);\n}\n.table:not(.table-bordered).table-row-gray-900 tr {\n  border-bottom-color: var(--bs-gray-900);\n}\n\n.table-layout-fixed {\n  table-layout: fixed;\n}\n\n.table-sort:after {\n  opacity: 0;\n}\n\n.table-sort,\n.table-sort-asc,\n.table-sort-desc {\n  vertical-align: middle;\n}\n.table-sort:after,\n.table-sort-asc:after,\n.table-sort-desc:after {\n  position: relative;\n  display: inline-block;\n  width: 0.75rem;\n  height: 0.75rem;\n  content: \" \";\n  bottom: auto;\n  right: auto;\n  left: auto;\n  margin-left: 0.5rem;\n}\n\n.table-sort-asc:after {\n  opacity: 1;\n  mask-repeat: no-repeat;\n  mask-position: center;\n  -webkit-mask-repeat: no-repeat;\n  -webkit-mask-position: center;\n  background-color: var(--bs-text-muted);\n  -webkit-mask-image: url(\"data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 6 6' fill='var%28--bs-text-muted%29'%3e%3cpath d='M3.23571 2.72011L4.97917 4.46358C5.15176 4.63618 5.43158 4.63617 5.60417 4.46358C5.77676 4.29099 5.77676 4.01118 5.60417 3.83861L3.29463 1.52904C3.13192 1.36629 2.86809 1.36629 2.70538 1.52904L0.395812 3.83861C0.22325 4.01117 0.22325 4.29099 0.395812 4.46358C0.568437 4.63617 0.84825 4.63617 1.02081 4.46358L2.76429 2.72011C2.89446 2.58994 3.10554 2.58994 3.23571 2.72011Z'/%3e%3c/svg%3e\");\n  mask-image: url(\"data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 6 6' fill='var%28--bs-text-muted%29'%3e%3cpath d='M3.23571 2.72011L4.97917 4.46358C5.15176 4.63618 5.43158 4.63617 5.60417 4.46358C5.77676 4.29099 5.77676 4.01118 5.60417 3.83861L3.29463 1.52904C3.13192 1.36629 2.86809 1.36629 2.70538 1.52904L0.395812 3.83861C0.22325 4.01117 0.22325 4.29099 0.395812 4.46358C0.568437 4.63617 0.84825 4.63617 1.02081 4.46358L2.76429 2.72011C2.89446 2.58994 3.10554 2.58994 3.23571 2.72011Z'/%3e%3c/svg%3e\");\n}\n\n.table-sort-desc:after {\n  opacity: 1;\n  mask-repeat: no-repeat;\n  mask-position: center;\n  -webkit-mask-repeat: no-repeat;\n  -webkit-mask-position: center;\n  background-color: var(--bs-text-muted);\n  -webkit-mask-image: url(\"data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 6 6' fill='var%28--bs-text-muted%29'%3e%3cpath d='M2.76429 3.27989L1.02083 1.53642C0.848244 1.36382 0.568419 1.36383 0.395831 1.53642C0.223244 1.70901 0.223244 1.98882 0.395831 2.16139L2.70537 4.47096C2.86808 4.63371 3.13191 4.63371 3.29462 4.47096L5.60419 2.16139C5.77675 1.98883 5.77675 1.70901 5.60419 1.53642C5.43156 1.36383 5.15175 1.36383 4.97919 1.53642L3.23571 3.27989C3.10554 3.41006 2.89446 3.41006 2.76429 3.27989Z'/%3e%3c/svg%3e\");\n  mask-image: url(\"data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 6 6' fill='var%28--bs-text-muted%29'%3e%3cpath d='M2.76429 3.27989L1.02083 1.53642C0.848244 1.36382 0.568419 1.36383 0.395831 1.53642C0.223244 1.70901 0.223244 1.98882 0.395831 2.16139L2.70537 4.47096C2.86808 4.63371 3.13191 4.63371 3.29462 4.47096L5.60419 2.16139C5.77675 1.98883 5.77675 1.70901 5.60419 1.53642C5.43156 1.36383 5.15175 1.36383 4.97919 1.53642L3.23571 3.27989C3.10554 3.41006 2.89446 3.41006 2.76429 3.27989Z'/%3e%3c/svg%3e\");\n}\n\n.table-loading-message {\n  display: none;\n  position: absolute;\n  top: 50%;\n  left: 50%;\n  border-radius: 0.475rem;\n  box-shadow: var(--bs-table-loading-message-box-shadow);\n  background-color: var(--bs-body-bg);\n  color: var(--bs-gray-700);\n  font-weight: 600;\n  margin: 0 !important;\n  width: auto;\n  padding: 0.85rem 2rem !important;\n  transform: translateX(-50%) translateY(-50%);\n}\n\n.table-loading {\n  position: relative;\n}\n.table-loading .table-loading-message {\n  display: block;\n}\n\n.table.g-0 th, .table.g-0 td {\n  padding: 0rem;\n}\n.table.g-0 th.dtr-control, .table.g-0 td.dtr-control {\n  padding-left: 0rem !important;\n}\n\n.table.gy-0 th, .table.gy-0 td {\n  padding-top: 0rem;\n  padding-bottom: 0rem;\n}\n\n.table.gx-0 th, .table.gx-0 td {\n  padding-left: 0rem;\n  padding-right: 0rem;\n}\n.table.gx-0 th.dtr-control, .table.gx-0 td.dtr-control {\n  padding-left: 0rem !important;\n}\n\n.table.gs-0 th:first-child, .table.gs-0 td:first-child {\n  padding-left: 0rem;\n}\n.table.gs-0 th:last-child, .table.gs-0 td:last-child {\n  padding-right: 0rem;\n}\n.table.gs-0 th.dtr-control:first-child, .table.gs-0 td.dtr-control:first-child {\n  padding-left: 0rem !important;\n}\n\n.table.g-1 th, .table.g-1 td {\n  padding: 0.25rem;\n}\n.table.g-1 th.dtr-control, .table.g-1 td.dtr-control {\n  padding-left: 0.25rem !important;\n}\n\n.table.gy-1 th, .table.gy-1 td {\n  padding-top: 0.25rem;\n  padding-bottom: 0.25rem;\n}\n\n.table.gx-1 th, .table.gx-1 td {\n  padding-left: 0.25rem;\n  padding-right: 0.25rem;\n}\n.table.gx-1 th.dtr-control, .table.gx-1 td.dtr-control {\n  padding-left: 0.25rem !important;\n}\n\n.table.gs-1 th:first-child, .table.gs-1 td:first-child {\n  padding-left: 0.25rem;\n}\n.table.gs-1 th:last-child, .table.gs-1 td:last-child {\n  padding-right: 0.25rem;\n}\n.table.gs-1 th.dtr-control:first-child, .table.gs-1 td.dtr-control:first-child {\n  padding-left: 0.25rem !important;\n}\n\n.table.g-2 th, .table.g-2 td {\n  padding: 0.5rem;\n}\n.table.g-2 th.dtr-control, .table.g-2 td.dtr-control {\n  padding-left: 0.5rem !important;\n}\n\n.table.gy-2 th, .table.gy-2 td {\n  padding-top: 0.5rem;\n  padding-bottom: 0.5rem;\n}\n\n.table.gx-2 th, .table.gx-2 td {\n  padding-left: 0.5rem;\n  padding-right: 0.5rem;\n}\n.table.gx-2 th.dtr-control, .table.gx-2 td.dtr-control {\n  padding-left: 0.5rem !important;\n}\n\n.table.gs-2 th:first-child, .table.gs-2 td:first-child {\n  padding-left: 0.5rem;\n}\n.table.gs-2 th:last-child, .table.gs-2 td:last-child {\n  padding-right: 0.5rem;\n}\n.table.gs-2 th.dtr-control:first-child, .table.gs-2 td.dtr-control:first-child {\n  padding-left: 0.5rem !important;\n}\n\n.table.g-3 th, .table.g-3 td {\n  padding: 0.75rem;\n}\n.table.g-3 th.dtr-control, .table.g-3 td.dtr-control {\n  padding-left: 0.75rem !important;\n}\n\n.table.gy-3 th, .table.gy-3 td {\n  padding-top: 0.75rem;\n  padding-bottom: 0.75rem;\n}\n\n.table.gx-3 th, .table.gx-3 td {\n  padding-left: 0.75rem;\n  padding-right: 0.75rem;\n}\n.table.gx-3 th.dtr-control, .table.gx-3 td.dtr-control {\n  padding-left: 0.75rem !important;\n}\n\n.table.gs-3 th:first-child, .table.gs-3 td:first-child {\n  padding-left: 0.75rem;\n}\n.table.gs-3 th:last-child, .table.gs-3 td:last-child {\n  padding-right: 0.75rem;\n}\n.table.gs-3 th.dtr-control:first-child, .table.gs-3 td.dtr-control:first-child {\n  padding-left: 0.75rem !important;\n}\n\n.table.g-4 th, .table.g-4 td {\n  padding: 1rem;\n}\n.table.g-4 th.dtr-control, .table.g-4 td.dtr-control {\n  padding-left: 1rem !important;\n}\n\n.table.gy-4 th, .table.gy-4 td {\n  padding-top: 1rem;\n  padding-bottom: 1rem;\n}\n\n.table.gx-4 th, .table.gx-4 td {\n  padding-left: 1rem;\n  padding-right: 1rem;\n}\n.table.gx-4 th.dtr-control, .table.gx-4 td.dtr-control {\n  padding-left: 1rem !important;\n}\n\n.table.gs-4 th:first-child, .table.gs-4 td:first-child {\n  padding-left: 1rem;\n}\n.table.gs-4 th:last-child, .table.gs-4 td:last-child {\n  padding-right: 1rem;\n}\n.table.gs-4 th.dtr-control:first-child, .table.gs-4 td.dtr-control:first-child {\n  padding-left: 1rem !important;\n}\n\n.table.g-5 th, .table.g-5 td {\n  padding: 1.25rem;\n}\n.table.g-5 th.dtr-control, .table.g-5 td.dtr-control {\n  padding-left: 1.25rem !important;\n}\n\n.table.gy-5 th, .table.gy-5 td {\n  padding-top: 1.25rem;\n  padding-bottom: 1.25rem;\n}\n\n.table.gx-5 th, .table.gx-5 td {\n  padding-left: 1.25rem;\n  padding-right: 1.25rem;\n}\n.table.gx-5 th.dtr-control, .table.gx-5 td.dtr-control {\n  padding-left: 1.25rem !important;\n}\n\n.table.gs-5 th:first-child, .table.gs-5 td:first-child {\n  padding-left: 1.25rem;\n}\n.table.gs-5 th:last-child, .table.gs-5 td:last-child {\n  padding-right: 1.25rem;\n}\n.table.gs-5 th.dtr-control:first-child, .table.gs-5 td.dtr-control:first-child {\n  padding-left: 1.25rem !important;\n}\n\n.table.g-6 th, .table.g-6 td {\n  padding: 1.5rem;\n}\n.table.g-6 th.dtr-control, .table.g-6 td.dtr-control {\n  padding-left: 1.5rem !important;\n}\n\n.table.gy-6 th, .table.gy-6 td {\n  padding-top: 1.5rem;\n  padding-bottom: 1.5rem;\n}\n\n.table.gx-6 th, .table.gx-6 td {\n  padding-left: 1.5rem;\n  padding-right: 1.5rem;\n}\n.table.gx-6 th.dtr-control, .table.gx-6 td.dtr-control {\n  padding-left: 1.5rem !important;\n}\n\n.table.gs-6 th:first-child, .table.gs-6 td:first-child {\n  padding-left: 1.5rem;\n}\n.table.gs-6 th:last-child, .table.gs-6 td:last-child {\n  padding-right: 1.5rem;\n}\n.table.gs-6 th.dtr-control:first-child, .table.gs-6 td.dtr-control:first-child {\n  padding-left: 1.5rem !important;\n}\n\n.table.g-7 th, .table.g-7 td {\n  padding: 1.75rem;\n}\n.table.g-7 th.dtr-control, .table.g-7 td.dtr-control {\n  padding-left: 1.75rem !important;\n}\n\n.table.gy-7 th, .table.gy-7 td {\n  padding-top: 1.75rem;\n  padding-bottom: 1.75rem;\n}\n\n.table.gx-7 th, .table.gx-7 td {\n  padding-left: 1.75rem;\n  padding-right: 1.75rem;\n}\n.table.gx-7 th.dtr-control, .table.gx-7 td.dtr-control {\n  padding-left: 1.75rem !important;\n}\n\n.table.gs-7 th:first-child, .table.gs-7 td:first-child {\n  padding-left: 1.75rem;\n}\n.table.gs-7 th:last-child, .table.gs-7 td:last-child {\n  padding-right: 1.75rem;\n}\n.table.gs-7 th.dtr-control:first-child, .table.gs-7 td.dtr-control:first-child {\n  padding-left: 1.75rem !important;\n}\n\n.table.g-8 th, .table.g-8 td {\n  padding: 2rem;\n}\n.table.g-8 th.dtr-control, .table.g-8 td.dtr-control {\n  padding-left: 2rem !important;\n}\n\n.table.gy-8 th, .table.gy-8 td {\n  padding-top: 2rem;\n  padding-bottom: 2rem;\n}\n\n.table.gx-8 th, .table.gx-8 td {\n  padding-left: 2rem;\n  padding-right: 2rem;\n}\n.table.gx-8 th.dtr-control, .table.gx-8 td.dtr-control {\n  padding-left: 2rem !important;\n}\n\n.table.gs-8 th:first-child, .table.gs-8 td:first-child {\n  padding-left: 2rem;\n}\n.table.gs-8 th:last-child, .table.gs-8 td:last-child {\n  padding-right: 2rem;\n}\n.table.gs-8 th.dtr-control:first-child, .table.gs-8 td.dtr-control:first-child {\n  padding-left: 2rem !important;\n}\n\n.table.g-9 th, .table.g-9 td {\n  padding: 2.25rem;\n}\n.table.g-9 th.dtr-control, .table.g-9 td.dtr-control {\n  padding-left: 2.25rem !important;\n}\n\n.table.gy-9 th, .table.gy-9 td {\n  padding-top: 2.25rem;\n  padding-bottom: 2.25rem;\n}\n\n.table.gx-9 th, .table.gx-9 td {\n  padding-left: 2.25rem;\n  padding-right: 2.25rem;\n}\n.table.gx-9 th.dtr-control, .table.gx-9 td.dtr-control {\n  padding-left: 2.25rem !important;\n}\n\n.table.gs-9 th:first-child, .table.gs-9 td:first-child {\n  padding-left: 2.25rem;\n}\n.table.gs-9 th:last-child, .table.gs-9 td:last-child {\n  padding-right: 2.25rem;\n}\n.table.gs-9 th.dtr-control:first-child, .table.gs-9 td.dtr-control:first-child {\n  padding-left: 2.25rem !important;\n}\n\n.table.g-10 th, .table.g-10 td {\n  padding: 2.5rem;\n}\n.table.g-10 th.dtr-control, .table.g-10 td.dtr-control {\n  padding-left: 2.5rem !important;\n}\n\n.table.gy-10 th, .table.gy-10 td {\n  padding-top: 2.5rem;\n  padding-bottom: 2.5rem;\n}\n\n.table.gx-10 th, .table.gx-10 td {\n  padding-left: 2.5rem;\n  padding-right: 2.5rem;\n}\n.table.gx-10 th.dtr-control, .table.gx-10 td.dtr-control {\n  padding-left: 2.5rem !important;\n}\n\n.table.gs-10 th:first-child, .table.gs-10 td:first-child {\n  padding-left: 2.5rem;\n}\n.table.gs-10 th:last-child, .table.gs-10 td:last-child {\n  padding-right: 2.5rem;\n}\n.table.gs-10 th.dtr-control:first-child, .table.gs-10 td.dtr-control:first-child {\n  padding-left: 2.5rem !important;\n}\n\n@media (min-width: 576px) {\n  .table.g-sm-0 th, .table.g-sm-0 td {\n    padding: 0rem;\n  }\n  .table.g-sm-0 th.dtr-control, .table.g-sm-0 td.dtr-control {\n    padding-left: 0rem !important;\n  }\n  .table.gy-sm-0 th, .table.gy-sm-0 td {\n    padding-top: 0rem;\n    padding-bottom: 0rem;\n  }\n  .table.gx-sm-0 th, .table.gx-sm-0 td {\n    padding-left: 0rem;\n    padding-right: 0rem;\n  }\n  .table.gx-sm-0 th.dtr-control, .table.gx-sm-0 td.dtr-control {\n    padding-left: 0rem !important;\n  }\n  .table.gs-sm-0 th:first-child, .table.gs-sm-0 td:first-child {\n    padding-left: 0rem;\n  }\n  .table.gs-sm-0 th:last-child, .table.gs-sm-0 td:last-child {\n    padding-right: 0rem;\n  }\n  .table.gs-sm-0 th.dtr-control:first-child, .table.gs-sm-0 td.dtr-control:first-child {\n    padding-left: 0rem !important;\n  }\n  .table.g-sm-1 th, .table.g-sm-1 td {\n    padding: 0.25rem;\n  }\n  .table.g-sm-1 th.dtr-control, .table.g-sm-1 td.dtr-control {\n    padding-left: 0.25rem !important;\n  }\n  .table.gy-sm-1 th, .table.gy-sm-1 td {\n    padding-top: 0.25rem;\n    padding-bottom: 0.25rem;\n  }\n  .table.gx-sm-1 th, .table.gx-sm-1 td {\n    padding-left: 0.25rem;\n    padding-right: 0.25rem;\n  }\n  .table.gx-sm-1 th.dtr-control, .table.gx-sm-1 td.dtr-control {\n    padding-left: 0.25rem !important;\n  }\n  .table.gs-sm-1 th:first-child, .table.gs-sm-1 td:first-child {\n    padding-left: 0.25rem;\n  }\n  .table.gs-sm-1 th:last-child, .table.gs-sm-1 td:last-child {\n    padding-right: 0.25rem;\n  }\n  .table.gs-sm-1 th.dtr-control:first-child, .table.gs-sm-1 td.dtr-control:first-child {\n    padding-left: 0.25rem !important;\n  }\n  .table.g-sm-2 th, .table.g-sm-2 td {\n    padding: 0.5rem;\n  }\n  .table.g-sm-2 th.dtr-control, .table.g-sm-2 td.dtr-control {\n    padding-left: 0.5rem !important;\n  }\n  .table.gy-sm-2 th, .table.gy-sm-2 td {\n    padding-top: 0.5rem;\n    padding-bottom: 0.5rem;\n  }\n  .table.gx-sm-2 th, .table.gx-sm-2 td {\n    padding-left: 0.5rem;\n    padding-right: 0.5rem;\n  }\n  .table.gx-sm-2 th.dtr-control, .table.gx-sm-2 td.dtr-control {\n    padding-left: 0.5rem !important;\n  }\n  .table.gs-sm-2 th:first-child, .table.gs-sm-2 td:first-child {\n    padding-left: 0.5rem;\n  }\n  .table.gs-sm-2 th:last-child, .table.gs-sm-2 td:last-child {\n    padding-right: 0.5rem;\n  }\n  .table.gs-sm-2 th.dtr-control:first-child, .table.gs-sm-2 td.dtr-control:first-child {\n    padding-left: 0.5rem !important;\n  }\n  .table.g-sm-3 th, .table.g-sm-3 td {\n    padding: 0.75rem;\n  }\n  .table.g-sm-3 th.dtr-control, .table.g-sm-3 td.dtr-control {\n    padding-left: 0.75rem !important;\n  }\n  .table.gy-sm-3 th, .table.gy-sm-3 td {\n    padding-top: 0.75rem;\n    padding-bottom: 0.75rem;\n  }\n  .table.gx-sm-3 th, .table.gx-sm-3 td {\n    padding-left: 0.75rem;\n    padding-right: 0.75rem;\n  }\n  .table.gx-sm-3 th.dtr-control, .table.gx-sm-3 td.dtr-control {\n    padding-left: 0.75rem !important;\n  }\n  .table.gs-sm-3 th:first-child, .table.gs-sm-3 td:first-child {\n    padding-left: 0.75rem;\n  }\n  .table.gs-sm-3 th:last-child, .table.gs-sm-3 td:last-child {\n    padding-right: 0.75rem;\n  }\n  .table.gs-sm-3 th.dtr-control:first-child, .table.gs-sm-3 td.dtr-control:first-child {\n    padding-left: 0.75rem !important;\n  }\n  .table.g-sm-4 th, .table.g-sm-4 td {\n    padding: 1rem;\n  }\n  .table.g-sm-4 th.dtr-control, .table.g-sm-4 td.dtr-control {\n    padding-left: 1rem !important;\n  }\n  .table.gy-sm-4 th, .table.gy-sm-4 td {\n    padding-top: 1rem;\n    padding-bottom: 1rem;\n  }\n  .table.gx-sm-4 th, .table.gx-sm-4 td {\n    padding-left: 1rem;\n    padding-right: 1rem;\n  }\n  .table.gx-sm-4 th.dtr-control, .table.gx-sm-4 td.dtr-control {\n    padding-left: 1rem !important;\n  }\n  .table.gs-sm-4 th:first-child, .table.gs-sm-4 td:first-child {\n    padding-left: 1rem;\n  }\n  .table.gs-sm-4 th:last-child, .table.gs-sm-4 td:last-child {\n    padding-right: 1rem;\n  }\n  .table.gs-sm-4 th.dtr-control:first-child, .table.gs-sm-4 td.dtr-control:first-child {\n    padding-left: 1rem !important;\n  }\n  .table.g-sm-5 th, .table.g-sm-5 td {\n    padding: 1.25rem;\n  }\n  .table.g-sm-5 th.dtr-control, .table.g-sm-5 td.dtr-control {\n    padding-left: 1.25rem !important;\n  }\n  .table.gy-sm-5 th, .table.gy-sm-5 td {\n    padding-top: 1.25rem;\n    padding-bottom: 1.25rem;\n  }\n  .table.gx-sm-5 th, .table.gx-sm-5 td {\n    padding-left: 1.25rem;\n    padding-right: 1.25rem;\n  }\n  .table.gx-sm-5 th.dtr-control, .table.gx-sm-5 td.dtr-control {\n    padding-left: 1.25rem !important;\n  }\n  .table.gs-sm-5 th:first-child, .table.gs-sm-5 td:first-child {\n    padding-left: 1.25rem;\n  }\n  .table.gs-sm-5 th:last-child, .table.gs-sm-5 td:last-child {\n    padding-right: 1.25rem;\n  }\n  .table.gs-sm-5 th.dtr-control:first-child, .table.gs-sm-5 td.dtr-control:first-child {\n    padding-left: 1.25rem !important;\n  }\n  .table.g-sm-6 th, .table.g-sm-6 td {\n    padding: 1.5rem;\n  }\n  .table.g-sm-6 th.dtr-control, .table.g-sm-6 td.dtr-control {\n    padding-left: 1.5rem !important;\n  }\n  .table.gy-sm-6 th, .table.gy-sm-6 td {\n    padding-top: 1.5rem;\n    padding-bottom: 1.5rem;\n  }\n  .table.gx-sm-6 th, .table.gx-sm-6 td {\n    padding-left: 1.5rem;\n    padding-right: 1.5rem;\n  }\n  .table.gx-sm-6 th.dtr-control, .table.gx-sm-6 td.dtr-control {\n    padding-left: 1.5rem !important;\n  }\n  .table.gs-sm-6 th:first-child, .table.gs-sm-6 td:first-child {\n    padding-left: 1.5rem;\n  }\n  .table.gs-sm-6 th:last-child, .table.gs-sm-6 td:last-child {\n    padding-right: 1.5rem;\n  }\n  .table.gs-sm-6 th.dtr-control:first-child, .table.gs-sm-6 td.dtr-control:first-child {\n    padding-left: 1.5rem !important;\n  }\n  .table.g-sm-7 th, .table.g-sm-7 td {\n    padding: 1.75rem;\n  }\n  .table.g-sm-7 th.dtr-control, .table.g-sm-7 td.dtr-control {\n    padding-left: 1.75rem !important;\n  }\n  .table.gy-sm-7 th, .table.gy-sm-7 td {\n    padding-top: 1.75rem;\n    padding-bottom: 1.75rem;\n  }\n  .table.gx-sm-7 th, .table.gx-sm-7 td {\n    padding-left: 1.75rem;\n    padding-right: 1.75rem;\n  }\n  .table.gx-sm-7 th.dtr-control, .table.gx-sm-7 td.dtr-control {\n    padding-left: 1.75rem !important;\n  }\n  .table.gs-sm-7 th:first-child, .table.gs-sm-7 td:first-child {\n    padding-left: 1.75rem;\n  }\n  .table.gs-sm-7 th:last-child, .table.gs-sm-7 td:last-child {\n    padding-right: 1.75rem;\n  }\n  .table.gs-sm-7 th.dtr-control:first-child, .table.gs-sm-7 td.dtr-control:first-child {\n    padding-left: 1.75rem !important;\n  }\n  .table.g-sm-8 th, .table.g-sm-8 td {\n    padding: 2rem;\n  }\n  .table.g-sm-8 th.dtr-control, .table.g-sm-8 td.dtr-control {\n    padding-left: 2rem !important;\n  }\n  .table.gy-sm-8 th, .table.gy-sm-8 td {\n    padding-top: 2rem;\n    padding-bottom: 2rem;\n  }\n  .table.gx-sm-8 th, .table.gx-sm-8 td {\n    padding-left: 2rem;\n    padding-right: 2rem;\n  }\n  .table.gx-sm-8 th.dtr-control, .table.gx-sm-8 td.dtr-control {\n    padding-left: 2rem !important;\n  }\n  .table.gs-sm-8 th:first-child, .table.gs-sm-8 td:first-child {\n    padding-left: 2rem;\n  }\n  .table.gs-sm-8 th:last-child, .table.gs-sm-8 td:last-child {\n    padding-right: 2rem;\n  }\n  .table.gs-sm-8 th.dtr-control:first-child, .table.gs-sm-8 td.dtr-control:first-child {\n    padding-left: 2rem !important;\n  }\n  .table.g-sm-9 th, .table.g-sm-9 td {\n    padding: 2.25rem;\n  }\n  .table.g-sm-9 th.dtr-control, .table.g-sm-9 td.dtr-control {\n    padding-left: 2.25rem !important;\n  }\n  .table.gy-sm-9 th, .table.gy-sm-9 td {\n    padding-top: 2.25rem;\n    padding-bottom: 2.25rem;\n  }\n  .table.gx-sm-9 th, .table.gx-sm-9 td {\n    padding-left: 2.25rem;\n    padding-right: 2.25rem;\n  }\n  .table.gx-sm-9 th.dtr-control, .table.gx-sm-9 td.dtr-control {\n    padding-left: 2.25rem !important;\n  }\n  .table.gs-sm-9 th:first-child, .table.gs-sm-9 td:first-child {\n    padding-left: 2.25rem;\n  }\n  .table.gs-sm-9 th:last-child, .table.gs-sm-9 td:last-child {\n    padding-right: 2.25rem;\n  }\n  .table.gs-sm-9 th.dtr-control:first-child, .table.gs-sm-9 td.dtr-control:first-child {\n    padding-left: 2.25rem !important;\n  }\n  .table.g-sm-10 th, .table.g-sm-10 td {\n    padding: 2.5rem;\n  }\n  .table.g-sm-10 th.dtr-control, .table.g-sm-10 td.dtr-control {\n    padding-left: 2.5rem !important;\n  }\n  .table.gy-sm-10 th, .table.gy-sm-10 td {\n    padding-top: 2.5rem;\n    padding-bottom: 2.5rem;\n  }\n  .table.gx-sm-10 th, .table.gx-sm-10 td {\n    padding-left: 2.5rem;\n    padding-right: 2.5rem;\n  }\n  .table.gx-sm-10 th.dtr-control, .table.gx-sm-10 td.dtr-control {\n    padding-left: 2.5rem !important;\n  }\n  .table.gs-sm-10 th:first-child, .table.gs-sm-10 td:first-child {\n    padding-left: 2.5rem;\n  }\n  .table.gs-sm-10 th:last-child, .table.gs-sm-10 td:last-child {\n    padding-right: 2.5rem;\n  }\n  .table.gs-sm-10 th.dtr-control:first-child, .table.gs-sm-10 td.dtr-control:first-child {\n    padding-left: 2.5rem !important;\n  }\n}\n@media (min-width: 768px) {\n  .table.g-md-0 th, .table.g-md-0 td {\n    padding: 0rem;\n  }\n  .table.g-md-0 th.dtr-control, .table.g-md-0 td.dtr-control {\n    padding-left: 0rem !important;\n  }\n  .table.gy-md-0 th, .table.gy-md-0 td {\n    padding-top: 0rem;\n    padding-bottom: 0rem;\n  }\n  .table.gx-md-0 th, .table.gx-md-0 td {\n    padding-left: 0rem;\n    padding-right: 0rem;\n  }\n  .table.gx-md-0 th.dtr-control, .table.gx-md-0 td.dtr-control {\n    padding-left: 0rem !important;\n  }\n  .table.gs-md-0 th:first-child, .table.gs-md-0 td:first-child {\n    padding-left: 0rem;\n  }\n  .table.gs-md-0 th:last-child, .table.gs-md-0 td:last-child {\n    padding-right: 0rem;\n  }\n  .table.gs-md-0 th.dtr-control:first-child, .table.gs-md-0 td.dtr-control:first-child {\n    padding-left: 0rem !important;\n  }\n  .table.g-md-1 th, .table.g-md-1 td {\n    padding: 0.25rem;\n  }\n  .table.g-md-1 th.dtr-control, .table.g-md-1 td.dtr-control {\n    padding-left: 0.25rem !important;\n  }\n  .table.gy-md-1 th, .table.gy-md-1 td {\n    padding-top: 0.25rem;\n    padding-bottom: 0.25rem;\n  }\n  .table.gx-md-1 th, .table.gx-md-1 td {\n    padding-left: 0.25rem;\n    padding-right: 0.25rem;\n  }\n  .table.gx-md-1 th.dtr-control, .table.gx-md-1 td.dtr-control {\n    padding-left: 0.25rem !important;\n  }\n  .table.gs-md-1 th:first-child, .table.gs-md-1 td:first-child {\n    padding-left: 0.25rem;\n  }\n  .table.gs-md-1 th:last-child, .table.gs-md-1 td:last-child {\n    padding-right: 0.25rem;\n  }\n  .table.gs-md-1 th.dtr-control:first-child, .table.gs-md-1 td.dtr-control:first-child {\n    padding-left: 0.25rem !important;\n  }\n  .table.g-md-2 th, .table.g-md-2 td {\n    padding: 0.5rem;\n  }\n  .table.g-md-2 th.dtr-control, .table.g-md-2 td.dtr-control {\n    padding-left: 0.5rem !important;\n  }\n  .table.gy-md-2 th, .table.gy-md-2 td {\n    padding-top: 0.5rem;\n    padding-bottom: 0.5rem;\n  }\n  .table.gx-md-2 th, .table.gx-md-2 td {\n    padding-left: 0.5rem;\n    padding-right: 0.5rem;\n  }\n  .table.gx-md-2 th.dtr-control, .table.gx-md-2 td.dtr-control {\n    padding-left: 0.5rem !important;\n  }\n  .table.gs-md-2 th:first-child, .table.gs-md-2 td:first-child {\n    padding-left: 0.5rem;\n  }\n  .table.gs-md-2 th:last-child, .table.gs-md-2 td:last-child {\n    padding-right: 0.5rem;\n  }\n  .table.gs-md-2 th.dtr-control:first-child, .table.gs-md-2 td.dtr-control:first-child {\n    padding-left: 0.5rem !important;\n  }\n  .table.g-md-3 th, .table.g-md-3 td {\n    padding: 0.75rem;\n  }\n  .table.g-md-3 th.dtr-control, .table.g-md-3 td.dtr-control {\n    padding-left: 0.75rem !important;\n  }\n  .table.gy-md-3 th, .table.gy-md-3 td {\n    padding-top: 0.75rem;\n    padding-bottom: 0.75rem;\n  }\n  .table.gx-md-3 th, .table.gx-md-3 td {\n    padding-left: 0.75rem;\n    padding-right: 0.75rem;\n  }\n  .table.gx-md-3 th.dtr-control, .table.gx-md-3 td.dtr-control {\n    padding-left: 0.75rem !important;\n  }\n  .table.gs-md-3 th:first-child, .table.gs-md-3 td:first-child {\n    padding-left: 0.75rem;\n  }\n  .table.gs-md-3 th:last-child, .table.gs-md-3 td:last-child {\n    padding-right: 0.75rem;\n  }\n  .table.gs-md-3 th.dtr-control:first-child, .table.gs-md-3 td.dtr-control:first-child {\n    padding-left: 0.75rem !important;\n  }\n  .table.g-md-4 th, .table.g-md-4 td {\n    padding: 1rem;\n  }\n  .table.g-md-4 th.dtr-control, .table.g-md-4 td.dtr-control {\n    padding-left: 1rem !important;\n  }\n  .table.gy-md-4 th, .table.gy-md-4 td {\n    padding-top: 1rem;\n    padding-bottom: 1rem;\n  }\n  .table.gx-md-4 th, .table.gx-md-4 td {\n    padding-left: 1rem;\n    padding-right: 1rem;\n  }\n  .table.gx-md-4 th.dtr-control, .table.gx-md-4 td.dtr-control {\n    padding-left: 1rem !important;\n  }\n  .table.gs-md-4 th:first-child, .table.gs-md-4 td:first-child {\n    padding-left: 1rem;\n  }\n  .table.gs-md-4 th:last-child, .table.gs-md-4 td:last-child {\n    padding-right: 1rem;\n  }\n  .table.gs-md-4 th.dtr-control:first-child, .table.gs-md-4 td.dtr-control:first-child {\n    padding-left: 1rem !important;\n  }\n  .table.g-md-5 th, .table.g-md-5 td {\n    padding: 1.25rem;\n  }\n  .table.g-md-5 th.dtr-control, .table.g-md-5 td.dtr-control {\n    padding-left: 1.25rem !important;\n  }\n  .table.gy-md-5 th, .table.gy-md-5 td {\n    padding-top: 1.25rem;\n    padding-bottom: 1.25rem;\n  }\n  .table.gx-md-5 th, .table.gx-md-5 td {\n    padding-left: 1.25rem;\n    padding-right: 1.25rem;\n  }\n  .table.gx-md-5 th.dtr-control, .table.gx-md-5 td.dtr-control {\n    padding-left: 1.25rem !important;\n  }\n  .table.gs-md-5 th:first-child, .table.gs-md-5 td:first-child {\n    padding-left: 1.25rem;\n  }\n  .table.gs-md-5 th:last-child, .table.gs-md-5 td:last-child {\n    padding-right: 1.25rem;\n  }\n  .table.gs-md-5 th.dtr-control:first-child, .table.gs-md-5 td.dtr-control:first-child {\n    padding-left: 1.25rem !important;\n  }\n  .table.g-md-6 th, .table.g-md-6 td {\n    padding: 1.5rem;\n  }\n  .table.g-md-6 th.dtr-control, .table.g-md-6 td.dtr-control {\n    padding-left: 1.5rem !important;\n  }\n  .table.gy-md-6 th, .table.gy-md-6 td {\n    padding-top: 1.5rem;\n    padding-bottom: 1.5rem;\n  }\n  .table.gx-md-6 th, .table.gx-md-6 td {\n    padding-left: 1.5rem;\n    padding-right: 1.5rem;\n  }\n  .table.gx-md-6 th.dtr-control, .table.gx-md-6 td.dtr-control {\n    padding-left: 1.5rem !important;\n  }\n  .table.gs-md-6 th:first-child, .table.gs-md-6 td:first-child {\n    padding-left: 1.5rem;\n  }\n  .table.gs-md-6 th:last-child, .table.gs-md-6 td:last-child {\n    padding-right: 1.5rem;\n  }\n  .table.gs-md-6 th.dtr-control:first-child, .table.gs-md-6 td.dtr-control:first-child {\n    padding-left: 1.5rem !important;\n  }\n  .table.g-md-7 th, .table.g-md-7 td {\n    padding: 1.75rem;\n  }\n  .table.g-md-7 th.dtr-control, .table.g-md-7 td.dtr-control {\n    padding-left: 1.75rem !important;\n  }\n  .table.gy-md-7 th, .table.gy-md-7 td {\n    padding-top: 1.75rem;\n    padding-bottom: 1.75rem;\n  }\n  .table.gx-md-7 th, .table.gx-md-7 td {\n    padding-left: 1.75rem;\n    padding-right: 1.75rem;\n  }\n  .table.gx-md-7 th.dtr-control, .table.gx-md-7 td.dtr-control {\n    padding-left: 1.75rem !important;\n  }\n  .table.gs-md-7 th:first-child, .table.gs-md-7 td:first-child {\n    padding-left: 1.75rem;\n  }\n  .table.gs-md-7 th:last-child, .table.gs-md-7 td:last-child {\n    padding-right: 1.75rem;\n  }\n  .table.gs-md-7 th.dtr-control:first-child, .table.gs-md-7 td.dtr-control:first-child {\n    padding-left: 1.75rem !important;\n  }\n  .table.g-md-8 th, .table.g-md-8 td {\n    padding: 2rem;\n  }\n  .table.g-md-8 th.dtr-control, .table.g-md-8 td.dtr-control {\n    padding-left: 2rem !important;\n  }\n  .table.gy-md-8 th, .table.gy-md-8 td {\n    padding-top: 2rem;\n    padding-bottom: 2rem;\n  }\n  .table.gx-md-8 th, .table.gx-md-8 td {\n    padding-left: 2rem;\n    padding-right: 2rem;\n  }\n  .table.gx-md-8 th.dtr-control, .table.gx-md-8 td.dtr-control {\n    padding-left: 2rem !important;\n  }\n  .table.gs-md-8 th:first-child, .table.gs-md-8 td:first-child {\n    padding-left: 2rem;\n  }\n  .table.gs-md-8 th:last-child, .table.gs-md-8 td:last-child {\n    padding-right: 2rem;\n  }\n  .table.gs-md-8 th.dtr-control:first-child, .table.gs-md-8 td.dtr-control:first-child {\n    padding-left: 2rem !important;\n  }\n  .table.g-md-9 th, .table.g-md-9 td {\n    padding: 2.25rem;\n  }\n  .table.g-md-9 th.dtr-control, .table.g-md-9 td.dtr-control {\n    padding-left: 2.25rem !important;\n  }\n  .table.gy-md-9 th, .table.gy-md-9 td {\n    padding-top: 2.25rem;\n    padding-bottom: 2.25rem;\n  }\n  .table.gx-md-9 th, .table.gx-md-9 td {\n    padding-left: 2.25rem;\n    padding-right: 2.25rem;\n  }\n  .table.gx-md-9 th.dtr-control, .table.gx-md-9 td.dtr-control {\n    padding-left: 2.25rem !important;\n  }\n  .table.gs-md-9 th:first-child, .table.gs-md-9 td:first-child {\n    padding-left: 2.25rem;\n  }\n  .table.gs-md-9 th:last-child, .table.gs-md-9 td:last-child {\n    padding-right: 2.25rem;\n  }\n  .table.gs-md-9 th.dtr-control:first-child, .table.gs-md-9 td.dtr-control:first-child {\n    padding-left: 2.25rem !important;\n  }\n  .table.g-md-10 th, .table.g-md-10 td {\n    padding: 2.5rem;\n  }\n  .table.g-md-10 th.dtr-control, .table.g-md-10 td.dtr-control {\n    padding-left: 2.5rem !important;\n  }\n  .table.gy-md-10 th, .table.gy-md-10 td {\n    padding-top: 2.5rem;\n    padding-bottom: 2.5rem;\n  }\n  .table.gx-md-10 th, .table.gx-md-10 td {\n    padding-left: 2.5rem;\n    padding-right: 2.5rem;\n  }\n  .table.gx-md-10 th.dtr-control, .table.gx-md-10 td.dtr-control {\n    padding-left: 2.5rem !important;\n  }\n  .table.gs-md-10 th:first-child, .table.gs-md-10 td:first-child {\n    padding-left: 2.5rem;\n  }\n  .table.gs-md-10 th:last-child, .table.gs-md-10 td:last-child {\n    padding-right: 2.5rem;\n  }\n  .table.gs-md-10 th.dtr-control:first-child, .table.gs-md-10 td.dtr-control:first-child {\n    padding-left: 2.5rem !important;\n  }\n}\n@media (min-width: 992px) {\n  .table.g-lg-0 th, .table.g-lg-0 td {\n    padding: 0rem;\n  }\n  .table.g-lg-0 th.dtr-control, .table.g-lg-0 td.dtr-control {\n    padding-left: 0rem !important;\n  }\n  .table.gy-lg-0 th, .table.gy-lg-0 td {\n    padding-top: 0rem;\n    padding-bottom: 0rem;\n  }\n  .table.gx-lg-0 th, .table.gx-lg-0 td {\n    padding-left: 0rem;\n    padding-right: 0rem;\n  }\n  .table.gx-lg-0 th.dtr-control, .table.gx-lg-0 td.dtr-control {\n    padding-left: 0rem !important;\n  }\n  .table.gs-lg-0 th:first-child, .table.gs-lg-0 td:first-child {\n    padding-left: 0rem;\n  }\n  .table.gs-lg-0 th:last-child, .table.gs-lg-0 td:last-child {\n    padding-right: 0rem;\n  }\n  .table.gs-lg-0 th.dtr-control:first-child, .table.gs-lg-0 td.dtr-control:first-child {\n    padding-left: 0rem !important;\n  }\n  .table.g-lg-1 th, .table.g-lg-1 td {\n    padding: 0.25rem;\n  }\n  .table.g-lg-1 th.dtr-control, .table.g-lg-1 td.dtr-control {\n    padding-left: 0.25rem !important;\n  }\n  .table.gy-lg-1 th, .table.gy-lg-1 td {\n    padding-top: 0.25rem;\n    padding-bottom: 0.25rem;\n  }\n  .table.gx-lg-1 th, .table.gx-lg-1 td {\n    padding-left: 0.25rem;\n    padding-right: 0.25rem;\n  }\n  .table.gx-lg-1 th.dtr-control, .table.gx-lg-1 td.dtr-control {\n    padding-left: 0.25rem !important;\n  }\n  .table.gs-lg-1 th:first-child, .table.gs-lg-1 td:first-child {\n    padding-left: 0.25rem;\n  }\n  .table.gs-lg-1 th:last-child, .table.gs-lg-1 td:last-child {\n    padding-right: 0.25rem;\n  }\n  .table.gs-lg-1 th.dtr-control:first-child, .table.gs-lg-1 td.dtr-control:first-child {\n    padding-left: 0.25rem !important;\n  }\n  .table.g-lg-2 th, .table.g-lg-2 td {\n    padding: 0.5rem;\n  }\n  .table.g-lg-2 th.dtr-control, .table.g-lg-2 td.dtr-control {\n    padding-left: 0.5rem !important;\n  }\n  .table.gy-lg-2 th, .table.gy-lg-2 td {\n    padding-top: 0.5rem;\n    padding-bottom: 0.5rem;\n  }\n  .table.gx-lg-2 th, .table.gx-lg-2 td {\n    padding-left: 0.5rem;\n    padding-right: 0.5rem;\n  }\n  .table.gx-lg-2 th.dtr-control, .table.gx-lg-2 td.dtr-control {\n    padding-left: 0.5rem !important;\n  }\n  .table.gs-lg-2 th:first-child, .table.gs-lg-2 td:first-child {\n    padding-left: 0.5rem;\n  }\n  .table.gs-lg-2 th:last-child, .table.gs-lg-2 td:last-child {\n    padding-right: 0.5rem;\n  }\n  .table.gs-lg-2 th.dtr-control:first-child, .table.gs-lg-2 td.dtr-control:first-child {\n    padding-left: 0.5rem !important;\n  }\n  .table.g-lg-3 th, .table.g-lg-3 td {\n    padding: 0.75rem;\n  }\n  .table.g-lg-3 th.dtr-control, .table.g-lg-3 td.dtr-control {\n    padding-left: 0.75rem !important;\n  }\n  .table.gy-lg-3 th, .table.gy-lg-3 td {\n    padding-top: 0.75rem;\n    padding-bottom: 0.75rem;\n  }\n  .table.gx-lg-3 th, .table.gx-lg-3 td {\n    padding-left: 0.75rem;\n    padding-right: 0.75rem;\n  }\n  .table.gx-lg-3 th.dtr-control, .table.gx-lg-3 td.dtr-control {\n    padding-left: 0.75rem !important;\n  }\n  .table.gs-lg-3 th:first-child, .table.gs-lg-3 td:first-child {\n    padding-left: 0.75rem;\n  }\n  .table.gs-lg-3 th:last-child, .table.gs-lg-3 td:last-child {\n    padding-right: 0.75rem;\n  }\n  .table.gs-lg-3 th.dtr-control:first-child, .table.gs-lg-3 td.dtr-control:first-child {\n    padding-left: 0.75rem !important;\n  }\n  .table.g-lg-4 th, .table.g-lg-4 td {\n    padding: 1rem;\n  }\n  .table.g-lg-4 th.dtr-control, .table.g-lg-4 td.dtr-control {\n    padding-left: 1rem !important;\n  }\n  .table.gy-lg-4 th, .table.gy-lg-4 td {\n    padding-top: 1rem;\n    padding-bottom: 1rem;\n  }\n  .table.gx-lg-4 th, .table.gx-lg-4 td {\n    padding-left: 1rem;\n    padding-right: 1rem;\n  }\n  .table.gx-lg-4 th.dtr-control, .table.gx-lg-4 td.dtr-control {\n    padding-left: 1rem !important;\n  }\n  .table.gs-lg-4 th:first-child, .table.gs-lg-4 td:first-child {\n    padding-left: 1rem;\n  }\n  .table.gs-lg-4 th:last-child, .table.gs-lg-4 td:last-child {\n    padding-right: 1rem;\n  }\n  .table.gs-lg-4 th.dtr-control:first-child, .table.gs-lg-4 td.dtr-control:first-child {\n    padding-left: 1rem !important;\n  }\n  .table.g-lg-5 th, .table.g-lg-5 td {\n    padding: 1.25rem;\n  }\n  .table.g-lg-5 th.dtr-control, .table.g-lg-5 td.dtr-control {\n    padding-left: 1.25rem !important;\n  }\n  .table.gy-lg-5 th, .table.gy-lg-5 td {\n    padding-top: 1.25rem;\n    padding-bottom: 1.25rem;\n  }\n  .table.gx-lg-5 th, .table.gx-lg-5 td {\n    padding-left: 1.25rem;\n    padding-right: 1.25rem;\n  }\n  .table.gx-lg-5 th.dtr-control, .table.gx-lg-5 td.dtr-control {\n    padding-left: 1.25rem !important;\n  }\n  .table.gs-lg-5 th:first-child, .table.gs-lg-5 td:first-child {\n    padding-left: 1.25rem;\n  }\n  .table.gs-lg-5 th:last-child, .table.gs-lg-5 td:last-child {\n    padding-right: 1.25rem;\n  }\n  .table.gs-lg-5 th.dtr-control:first-child, .table.gs-lg-5 td.dtr-control:first-child {\n    padding-left: 1.25rem !important;\n  }\n  .table.g-lg-6 th, .table.g-lg-6 td {\n    padding: 1.5rem;\n  }\n  .table.g-lg-6 th.dtr-control, .table.g-lg-6 td.dtr-control {\n    padding-left: 1.5rem !important;\n  }\n  .table.gy-lg-6 th, .table.gy-lg-6 td {\n    padding-top: 1.5rem;\n    padding-bottom: 1.5rem;\n  }\n  .table.gx-lg-6 th, .table.gx-lg-6 td {\n    padding-left: 1.5rem;\n    padding-right: 1.5rem;\n  }\n  .table.gx-lg-6 th.dtr-control, .table.gx-lg-6 td.dtr-control {\n    padding-left: 1.5rem !important;\n  }\n  .table.gs-lg-6 th:first-child, .table.gs-lg-6 td:first-child {\n    padding-left: 1.5rem;\n  }\n  .table.gs-lg-6 th:last-child, .table.gs-lg-6 td:last-child {\n    padding-right: 1.5rem;\n  }\n  .table.gs-lg-6 th.dtr-control:first-child, .table.gs-lg-6 td.dtr-control:first-child {\n    padding-left: 1.5rem !important;\n  }\n  .table.g-lg-7 th, .table.g-lg-7 td {\n    padding: 1.75rem;\n  }\n  .table.g-lg-7 th.dtr-control, .table.g-lg-7 td.dtr-control {\n    padding-left: 1.75rem !important;\n  }\n  .table.gy-lg-7 th, .table.gy-lg-7 td {\n    padding-top: 1.75rem;\n    padding-bottom: 1.75rem;\n  }\n  .table.gx-lg-7 th, .table.gx-lg-7 td {\n    padding-left: 1.75rem;\n    padding-right: 1.75rem;\n  }\n  .table.gx-lg-7 th.dtr-control, .table.gx-lg-7 td.dtr-control {\n    padding-left: 1.75rem !important;\n  }\n  .table.gs-lg-7 th:first-child, .table.gs-lg-7 td:first-child {\n    padding-left: 1.75rem;\n  }\n  .table.gs-lg-7 th:last-child, .table.gs-lg-7 td:last-child {\n    padding-right: 1.75rem;\n  }\n  .table.gs-lg-7 th.dtr-control:first-child, .table.gs-lg-7 td.dtr-control:first-child {\n    padding-left: 1.75rem !important;\n  }\n  .table.g-lg-8 th, .table.g-lg-8 td {\n    padding: 2rem;\n  }\n  .table.g-lg-8 th.dtr-control, .table.g-lg-8 td.dtr-control {\n    padding-left: 2rem !important;\n  }\n  .table.gy-lg-8 th, .table.gy-lg-8 td {\n    padding-top: 2rem;\n    padding-bottom: 2rem;\n  }\n  .table.gx-lg-8 th, .table.gx-lg-8 td {\n    padding-left: 2rem;\n    padding-right: 2rem;\n  }\n  .table.gx-lg-8 th.dtr-control, .table.gx-lg-8 td.dtr-control {\n    padding-left: 2rem !important;\n  }\n  .table.gs-lg-8 th:first-child, .table.gs-lg-8 td:first-child {\n    padding-left: 2rem;\n  }\n  .table.gs-lg-8 th:last-child, .table.gs-lg-8 td:last-child {\n    padding-right: 2rem;\n  }\n  .table.gs-lg-8 th.dtr-control:first-child, .table.gs-lg-8 td.dtr-control:first-child {\n    padding-left: 2rem !important;\n  }\n  .table.g-lg-9 th, .table.g-lg-9 td {\n    padding: 2.25rem;\n  }\n  .table.g-lg-9 th.dtr-control, .table.g-lg-9 td.dtr-control {\n    padding-left: 2.25rem !important;\n  }\n  .table.gy-lg-9 th, .table.gy-lg-9 td {\n    padding-top: 2.25rem;\n    padding-bottom: 2.25rem;\n  }\n  .table.gx-lg-9 th, .table.gx-lg-9 td {\n    padding-left: 2.25rem;\n    padding-right: 2.25rem;\n  }\n  .table.gx-lg-9 th.dtr-control, .table.gx-lg-9 td.dtr-control {\n    padding-left: 2.25rem !important;\n  }\n  .table.gs-lg-9 th:first-child, .table.gs-lg-9 td:first-child {\n    padding-left: 2.25rem;\n  }\n  .table.gs-lg-9 th:last-child, .table.gs-lg-9 td:last-child {\n    padding-right: 2.25rem;\n  }\n  .table.gs-lg-9 th.dtr-control:first-child, .table.gs-lg-9 td.dtr-control:first-child {\n    padding-left: 2.25rem !important;\n  }\n  .table.g-lg-10 th, .table.g-lg-10 td {\n    padding: 2.5rem;\n  }\n  .table.g-lg-10 th.dtr-control, .table.g-lg-10 td.dtr-control {\n    padding-left: 2.5rem !important;\n  }\n  .table.gy-lg-10 th, .table.gy-lg-10 td {\n    padding-top: 2.5rem;\n    padding-bottom: 2.5rem;\n  }\n  .table.gx-lg-10 th, .table.gx-lg-10 td {\n    padding-left: 2.5rem;\n    padding-right: 2.5rem;\n  }\n  .table.gx-lg-10 th.dtr-control, .table.gx-lg-10 td.dtr-control {\n    padding-left: 2.5rem !important;\n  }\n  .table.gs-lg-10 th:first-child, .table.gs-lg-10 td:first-child {\n    padding-left: 2.5rem;\n  }\n  .table.gs-lg-10 th:last-child, .table.gs-lg-10 td:last-child {\n    padding-right: 2.5rem;\n  }\n  .table.gs-lg-10 th.dtr-control:first-child, .table.gs-lg-10 td.dtr-control:first-child {\n    padding-left: 2.5rem !important;\n  }\n}\n@media (min-width: 1200px) {\n  .table.g-xl-0 th, .table.g-xl-0 td {\n    padding: 0rem;\n  }\n  .table.g-xl-0 th.dtr-control, .table.g-xl-0 td.dtr-control {\n    padding-left: 0rem !important;\n  }\n  .table.gy-xl-0 th, .table.gy-xl-0 td {\n    padding-top: 0rem;\n    padding-bottom: 0rem;\n  }\n  .table.gx-xl-0 th, .table.gx-xl-0 td {\n    padding-left: 0rem;\n    padding-right: 0rem;\n  }\n  .table.gx-xl-0 th.dtr-control, .table.gx-xl-0 td.dtr-control {\n    padding-left: 0rem !important;\n  }\n  .table.gs-xl-0 th:first-child, .table.gs-xl-0 td:first-child {\n    padding-left: 0rem;\n  }\n  .table.gs-xl-0 th:last-child, .table.gs-xl-0 td:last-child {\n    padding-right: 0rem;\n  }\n  .table.gs-xl-0 th.dtr-control:first-child, .table.gs-xl-0 td.dtr-control:first-child {\n    padding-left: 0rem !important;\n  }\n  .table.g-xl-1 th, .table.g-xl-1 td {\n    padding: 0.25rem;\n  }\n  .table.g-xl-1 th.dtr-control, .table.g-xl-1 td.dtr-control {\n    padding-left: 0.25rem !important;\n  }\n  .table.gy-xl-1 th, .table.gy-xl-1 td {\n    padding-top: 0.25rem;\n    padding-bottom: 0.25rem;\n  }\n  .table.gx-xl-1 th, .table.gx-xl-1 td {\n    padding-left: 0.25rem;\n    padding-right: 0.25rem;\n  }\n  .table.gx-xl-1 th.dtr-control, .table.gx-xl-1 td.dtr-control {\n    padding-left: 0.25rem !important;\n  }\n  .table.gs-xl-1 th:first-child, .table.gs-xl-1 td:first-child {\n    padding-left: 0.25rem;\n  }\n  .table.gs-xl-1 th:last-child, .table.gs-xl-1 td:last-child {\n    padding-right: 0.25rem;\n  }\n  .table.gs-xl-1 th.dtr-control:first-child, .table.gs-xl-1 td.dtr-control:first-child {\n    padding-left: 0.25rem !important;\n  }\n  .table.g-xl-2 th, .table.g-xl-2 td {\n    padding: 0.5rem;\n  }\n  .table.g-xl-2 th.dtr-control, .table.g-xl-2 td.dtr-control {\n    padding-left: 0.5rem !important;\n  }\n  .table.gy-xl-2 th, .table.gy-xl-2 td {\n    padding-top: 0.5rem;\n    padding-bottom: 0.5rem;\n  }\n  .table.gx-xl-2 th, .table.gx-xl-2 td {\n    padding-left: 0.5rem;\n    padding-right: 0.5rem;\n  }\n  .table.gx-xl-2 th.dtr-control, .table.gx-xl-2 td.dtr-control {\n    padding-left: 0.5rem !important;\n  }\n  .table.gs-xl-2 th:first-child, .table.gs-xl-2 td:first-child {\n    padding-left: 0.5rem;\n  }\n  .table.gs-xl-2 th:last-child, .table.gs-xl-2 td:last-child {\n    padding-right: 0.5rem;\n  }\n  .table.gs-xl-2 th.dtr-control:first-child, .table.gs-xl-2 td.dtr-control:first-child {\n    padding-left: 0.5rem !important;\n  }\n  .table.g-xl-3 th, .table.g-xl-3 td {\n    padding: 0.75rem;\n  }\n  .table.g-xl-3 th.dtr-control, .table.g-xl-3 td.dtr-control {\n    padding-left: 0.75rem !important;\n  }\n  .table.gy-xl-3 th, .table.gy-xl-3 td {\n    padding-top: 0.75rem;\n    padding-bottom: 0.75rem;\n  }\n  .table.gx-xl-3 th, .table.gx-xl-3 td {\n    padding-left: 0.75rem;\n    padding-right: 0.75rem;\n  }\n  .table.gx-xl-3 th.dtr-control, .table.gx-xl-3 td.dtr-control {\n    padding-left: 0.75rem !important;\n  }\n  .table.gs-xl-3 th:first-child, .table.gs-xl-3 td:first-child {\n    padding-left: 0.75rem;\n  }\n  .table.gs-xl-3 th:last-child, .table.gs-xl-3 td:last-child {\n    padding-right: 0.75rem;\n  }\n  .table.gs-xl-3 th.dtr-control:first-child, .table.gs-xl-3 td.dtr-control:first-child {\n    padding-left: 0.75rem !important;\n  }\n  .table.g-xl-4 th, .table.g-xl-4 td {\n    padding: 1rem;\n  }\n  .table.g-xl-4 th.dtr-control, .table.g-xl-4 td.dtr-control {\n    padding-left: 1rem !important;\n  }\n  .table.gy-xl-4 th, .table.gy-xl-4 td {\n    padding-top: 1rem;\n    padding-bottom: 1rem;\n  }\n  .table.gx-xl-4 th, .table.gx-xl-4 td {\n    padding-left: 1rem;\n    padding-right: 1rem;\n  }\n  .table.gx-xl-4 th.dtr-control, .table.gx-xl-4 td.dtr-control {\n    padding-left: 1rem !important;\n  }\n  .table.gs-xl-4 th:first-child, .table.gs-xl-4 td:first-child {\n    padding-left: 1rem;\n  }\n  .table.gs-xl-4 th:last-child, .table.gs-xl-4 td:last-child {\n    padding-right: 1rem;\n  }\n  .table.gs-xl-4 th.dtr-control:first-child, .table.gs-xl-4 td.dtr-control:first-child {\n    padding-left: 1rem !important;\n  }\n  .table.g-xl-5 th, .table.g-xl-5 td {\n    padding: 1.25rem;\n  }\n  .table.g-xl-5 th.dtr-control, .table.g-xl-5 td.dtr-control {\n    padding-left: 1.25rem !important;\n  }\n  .table.gy-xl-5 th, .table.gy-xl-5 td {\n    padding-top: 1.25rem;\n    padding-bottom: 1.25rem;\n  }\n  .table.gx-xl-5 th, .table.gx-xl-5 td {\n    padding-left: 1.25rem;\n    padding-right: 1.25rem;\n  }\n  .table.gx-xl-5 th.dtr-control, .table.gx-xl-5 td.dtr-control {\n    padding-left: 1.25rem !important;\n  }\n  .table.gs-xl-5 th:first-child, .table.gs-xl-5 td:first-child {\n    padding-left: 1.25rem;\n  }\n  .table.gs-xl-5 th:last-child, .table.gs-xl-5 td:last-child {\n    padding-right: 1.25rem;\n  }\n  .table.gs-xl-5 th.dtr-control:first-child, .table.gs-xl-5 td.dtr-control:first-child {\n    padding-left: 1.25rem !important;\n  }\n  .table.g-xl-6 th, .table.g-xl-6 td {\n    padding: 1.5rem;\n  }\n  .table.g-xl-6 th.dtr-control, .table.g-xl-6 td.dtr-control {\n    padding-left: 1.5rem !important;\n  }\n  .table.gy-xl-6 th, .table.gy-xl-6 td {\n    padding-top: 1.5rem;\n    padding-bottom: 1.5rem;\n  }\n  .table.gx-xl-6 th, .table.gx-xl-6 td {\n    padding-left: 1.5rem;\n    padding-right: 1.5rem;\n  }\n  .table.gx-xl-6 th.dtr-control, .table.gx-xl-6 td.dtr-control {\n    padding-left: 1.5rem !important;\n  }\n  .table.gs-xl-6 th:first-child, .table.gs-xl-6 td:first-child {\n    padding-left: 1.5rem;\n  }\n  .table.gs-xl-6 th:last-child, .table.gs-xl-6 td:last-child {\n    padding-right: 1.5rem;\n  }\n  .table.gs-xl-6 th.dtr-control:first-child, .table.gs-xl-6 td.dtr-control:first-child {\n    padding-left: 1.5rem !important;\n  }\n  .table.g-xl-7 th, .table.g-xl-7 td {\n    padding: 1.75rem;\n  }\n  .table.g-xl-7 th.dtr-control, .table.g-xl-7 td.dtr-control {\n    padding-left: 1.75rem !important;\n  }\n  .table.gy-xl-7 th, .table.gy-xl-7 td {\n    padding-top: 1.75rem;\n    padding-bottom: 1.75rem;\n  }\n  .table.gx-xl-7 th, .table.gx-xl-7 td {\n    padding-left: 1.75rem;\n    padding-right: 1.75rem;\n  }\n  .table.gx-xl-7 th.dtr-control, .table.gx-xl-7 td.dtr-control {\n    padding-left: 1.75rem !important;\n  }\n  .table.gs-xl-7 th:first-child, .table.gs-xl-7 td:first-child {\n    padding-left: 1.75rem;\n  }\n  .table.gs-xl-7 th:last-child, .table.gs-xl-7 td:last-child {\n    padding-right: 1.75rem;\n  }\n  .table.gs-xl-7 th.dtr-control:first-child, .table.gs-xl-7 td.dtr-control:first-child {\n    padding-left: 1.75rem !important;\n  }\n  .table.g-xl-8 th, .table.g-xl-8 td {\n    padding: 2rem;\n  }\n  .table.g-xl-8 th.dtr-control, .table.g-xl-8 td.dtr-control {\n    padding-left: 2rem !important;\n  }\n  .table.gy-xl-8 th, .table.gy-xl-8 td {\n    padding-top: 2rem;\n    padding-bottom: 2rem;\n  }\n  .table.gx-xl-8 th, .table.gx-xl-8 td {\n    padding-left: 2rem;\n    padding-right: 2rem;\n  }\n  .table.gx-xl-8 th.dtr-control, .table.gx-xl-8 td.dtr-control {\n    padding-left: 2rem !important;\n  }\n  .table.gs-xl-8 th:first-child, .table.gs-xl-8 td:first-child {\n    padding-left: 2rem;\n  }\n  .table.gs-xl-8 th:last-child, .table.gs-xl-8 td:last-child {\n    padding-right: 2rem;\n  }\n  .table.gs-xl-8 th.dtr-control:first-child, .table.gs-xl-8 td.dtr-control:first-child {\n    padding-left: 2rem !important;\n  }\n  .table.g-xl-9 th, .table.g-xl-9 td {\n    padding: 2.25rem;\n  }\n  .table.g-xl-9 th.dtr-control, .table.g-xl-9 td.dtr-control {\n    padding-left: 2.25rem !important;\n  }\n  .table.gy-xl-9 th, .table.gy-xl-9 td {\n    padding-top: 2.25rem;\n    padding-bottom: 2.25rem;\n  }\n  .table.gx-xl-9 th, .table.gx-xl-9 td {\n    padding-left: 2.25rem;\n    padding-right: 2.25rem;\n  }\n  .table.gx-xl-9 th.dtr-control, .table.gx-xl-9 td.dtr-control {\n    padding-left: 2.25rem !important;\n  }\n  .table.gs-xl-9 th:first-child, .table.gs-xl-9 td:first-child {\n    padding-left: 2.25rem;\n  }\n  .table.gs-xl-9 th:last-child, .table.gs-xl-9 td:last-child {\n    padding-right: 2.25rem;\n  }\n  .table.gs-xl-9 th.dtr-control:first-child, .table.gs-xl-9 td.dtr-control:first-child {\n    padding-left: 2.25rem !important;\n  }\n  .table.g-xl-10 th, .table.g-xl-10 td {\n    padding: 2.5rem;\n  }\n  .table.g-xl-10 th.dtr-control, .table.g-xl-10 td.dtr-control {\n    padding-left: 2.5rem !important;\n  }\n  .table.gy-xl-10 th, .table.gy-xl-10 td {\n    padding-top: 2.5rem;\n    padding-bottom: 2.5rem;\n  }\n  .table.gx-xl-10 th, .table.gx-xl-10 td {\n    padding-left: 2.5rem;\n    padding-right: 2.5rem;\n  }\n  .table.gx-xl-10 th.dtr-control, .table.gx-xl-10 td.dtr-control {\n    padding-left: 2.5rem !important;\n  }\n  .table.gs-xl-10 th:first-child, .table.gs-xl-10 td:first-child {\n    padding-left: 2.5rem;\n  }\n  .table.gs-xl-10 th:last-child, .table.gs-xl-10 td:last-child {\n    padding-right: 2.5rem;\n  }\n  .table.gs-xl-10 th.dtr-control:first-child, .table.gs-xl-10 td.dtr-control:first-child {\n    padding-left: 2.5rem !important;\n  }\n}\n@media (min-width: 1400px) {\n  .table.g-xxl-0 th, .table.g-xxl-0 td {\n    padding: 0rem;\n  }\n  .table.g-xxl-0 th.dtr-control, .table.g-xxl-0 td.dtr-control {\n    padding-left: 0rem !important;\n  }\n  .table.gy-xxl-0 th, .table.gy-xxl-0 td {\n    padding-top: 0rem;\n    padding-bottom: 0rem;\n  }\n  .table.gx-xxl-0 th, .table.gx-xxl-0 td {\n    padding-left: 0rem;\n    padding-right: 0rem;\n  }\n  .table.gx-xxl-0 th.dtr-control, .table.gx-xxl-0 td.dtr-control {\n    padding-left: 0rem !important;\n  }\n  .table.gs-xxl-0 th:first-child, .table.gs-xxl-0 td:first-child {\n    padding-left: 0rem;\n  }\n  .table.gs-xxl-0 th:last-child, .table.gs-xxl-0 td:last-child {\n    padding-right: 0rem;\n  }\n  .table.gs-xxl-0 th.dtr-control:first-child, .table.gs-xxl-0 td.dtr-control:first-child {\n    padding-left: 0rem !important;\n  }\n  .table.g-xxl-1 th, .table.g-xxl-1 td {\n    padding: 0.25rem;\n  }\n  .table.g-xxl-1 th.dtr-control, .table.g-xxl-1 td.dtr-control {\n    padding-left: 0.25rem !important;\n  }\n  .table.gy-xxl-1 th, .table.gy-xxl-1 td {\n    padding-top: 0.25rem;\n    padding-bottom: 0.25rem;\n  }\n  .table.gx-xxl-1 th, .table.gx-xxl-1 td {\n    padding-left: 0.25rem;\n    padding-right: 0.25rem;\n  }\n  .table.gx-xxl-1 th.dtr-control, .table.gx-xxl-1 td.dtr-control {\n    padding-left: 0.25rem !important;\n  }\n  .table.gs-xxl-1 th:first-child, .table.gs-xxl-1 td:first-child {\n    padding-left: 0.25rem;\n  }\n  .table.gs-xxl-1 th:last-child, .table.gs-xxl-1 td:last-child {\n    padding-right: 0.25rem;\n  }\n  .table.gs-xxl-1 th.dtr-control:first-child, .table.gs-xxl-1 td.dtr-control:first-child {\n    padding-left: 0.25rem !important;\n  }\n  .table.g-xxl-2 th, .table.g-xxl-2 td {\n    padding: 0.5rem;\n  }\n  .table.g-xxl-2 th.dtr-control, .table.g-xxl-2 td.dtr-control {\n    padding-left: 0.5rem !important;\n  }\n  .table.gy-xxl-2 th, .table.gy-xxl-2 td {\n    padding-top: 0.5rem;\n    padding-bottom: 0.5rem;\n  }\n  .table.gx-xxl-2 th, .table.gx-xxl-2 td {\n    padding-left: 0.5rem;\n    padding-right: 0.5rem;\n  }\n  .table.gx-xxl-2 th.dtr-control, .table.gx-xxl-2 td.dtr-control {\n    padding-left: 0.5rem !important;\n  }\n  .table.gs-xxl-2 th:first-child, .table.gs-xxl-2 td:first-child {\n    padding-left: 0.5rem;\n  }\n  .table.gs-xxl-2 th:last-child, .table.gs-xxl-2 td:last-child {\n    padding-right: 0.5rem;\n  }\n  .table.gs-xxl-2 th.dtr-control:first-child, .table.gs-xxl-2 td.dtr-control:first-child {\n    padding-left: 0.5rem !important;\n  }\n  .table.g-xxl-3 th, .table.g-xxl-3 td {\n    padding: 0.75rem;\n  }\n  .table.g-xxl-3 th.dtr-control, .table.g-xxl-3 td.dtr-control {\n    padding-left: 0.75rem !important;\n  }\n  .table.gy-xxl-3 th, .table.gy-xxl-3 td {\n    padding-top: 0.75rem;\n    padding-bottom: 0.75rem;\n  }\n  .table.gx-xxl-3 th, .table.gx-xxl-3 td {\n    padding-left: 0.75rem;\n    padding-right: 0.75rem;\n  }\n  .table.gx-xxl-3 th.dtr-control, .table.gx-xxl-3 td.dtr-control {\n    padding-left: 0.75rem !important;\n  }\n  .table.gs-xxl-3 th:first-child, .table.gs-xxl-3 td:first-child {\n    padding-left: 0.75rem;\n  }\n  .table.gs-xxl-3 th:last-child, .table.gs-xxl-3 td:last-child {\n    padding-right: 0.75rem;\n  }\n  .table.gs-xxl-3 th.dtr-control:first-child, .table.gs-xxl-3 td.dtr-control:first-child {\n    padding-left: 0.75rem !important;\n  }\n  .table.g-xxl-4 th, .table.g-xxl-4 td {\n    padding: 1rem;\n  }\n  .table.g-xxl-4 th.dtr-control, .table.g-xxl-4 td.dtr-control {\n    padding-left: 1rem !important;\n  }\n  .table.gy-xxl-4 th, .table.gy-xxl-4 td {\n    padding-top: 1rem;\n    padding-bottom: 1rem;\n  }\n  .table.gx-xxl-4 th, .table.gx-xxl-4 td {\n    padding-left: 1rem;\n    padding-right: 1rem;\n  }\n  .table.gx-xxl-4 th.dtr-control, .table.gx-xxl-4 td.dtr-control {\n    padding-left: 1rem !important;\n  }\n  .table.gs-xxl-4 th:first-child, .table.gs-xxl-4 td:first-child {\n    padding-left: 1rem;\n  }\n  .table.gs-xxl-4 th:last-child, .table.gs-xxl-4 td:last-child {\n    padding-right: 1rem;\n  }\n  .table.gs-xxl-4 th.dtr-control:first-child, .table.gs-xxl-4 td.dtr-control:first-child {\n    padding-left: 1rem !important;\n  }\n  .table.g-xxl-5 th, .table.g-xxl-5 td {\n    padding: 1.25rem;\n  }\n  .table.g-xxl-5 th.dtr-control, .table.g-xxl-5 td.dtr-control {\n    padding-left: 1.25rem !important;\n  }\n  .table.gy-xxl-5 th, .table.gy-xxl-5 td {\n    padding-top: 1.25rem;\n    padding-bottom: 1.25rem;\n  }\n  .table.gx-xxl-5 th, .table.gx-xxl-5 td {\n    padding-left: 1.25rem;\n    padding-right: 1.25rem;\n  }\n  .table.gx-xxl-5 th.dtr-control, .table.gx-xxl-5 td.dtr-control {\n    padding-left: 1.25rem !important;\n  }\n  .table.gs-xxl-5 th:first-child, .table.gs-xxl-5 td:first-child {\n    padding-left: 1.25rem;\n  }\n  .table.gs-xxl-5 th:last-child, .table.gs-xxl-5 td:last-child {\n    padding-right: 1.25rem;\n  }\n  .table.gs-xxl-5 th.dtr-control:first-child, .table.gs-xxl-5 td.dtr-control:first-child {\n    padding-left: 1.25rem !important;\n  }\n  .table.g-xxl-6 th, .table.g-xxl-6 td {\n    padding: 1.5rem;\n  }\n  .table.g-xxl-6 th.dtr-control, .table.g-xxl-6 td.dtr-control {\n    padding-left: 1.5rem !important;\n  }\n  .table.gy-xxl-6 th, .table.gy-xxl-6 td {\n    padding-top: 1.5rem;\n    padding-bottom: 1.5rem;\n  }\n  .table.gx-xxl-6 th, .table.gx-xxl-6 td {\n    padding-left: 1.5rem;\n    padding-right: 1.5rem;\n  }\n  .table.gx-xxl-6 th.dtr-control, .table.gx-xxl-6 td.dtr-control {\n    padding-left: 1.5rem !important;\n  }\n  .table.gs-xxl-6 th:first-child, .table.gs-xxl-6 td:first-child {\n    padding-left: 1.5rem;\n  }\n  .table.gs-xxl-6 th:last-child, .table.gs-xxl-6 td:last-child {\n    padding-right: 1.5rem;\n  }\n  .table.gs-xxl-6 th.dtr-control:first-child, .table.gs-xxl-6 td.dtr-control:first-child {\n    padding-left: 1.5rem !important;\n  }\n  .table.g-xxl-7 th, .table.g-xxl-7 td {\n    padding: 1.75rem;\n  }\n  .table.g-xxl-7 th.dtr-control, .table.g-xxl-7 td.dtr-control {\n    padding-left: 1.75rem !important;\n  }\n  .table.gy-xxl-7 th, .table.gy-xxl-7 td {\n    padding-top: 1.75rem;\n    padding-bottom: 1.75rem;\n  }\n  .table.gx-xxl-7 th, .table.gx-xxl-7 td {\n    padding-left: 1.75rem;\n    padding-right: 1.75rem;\n  }\n  .table.gx-xxl-7 th.dtr-control, .table.gx-xxl-7 td.dtr-control {\n    padding-left: 1.75rem !important;\n  }\n  .table.gs-xxl-7 th:first-child, .table.gs-xxl-7 td:first-child {\n    padding-left: 1.75rem;\n  }\n  .table.gs-xxl-7 th:last-child, .table.gs-xxl-7 td:last-child {\n    padding-right: 1.75rem;\n  }\n  .table.gs-xxl-7 th.dtr-control:first-child, .table.gs-xxl-7 td.dtr-control:first-child {\n    padding-left: 1.75rem !important;\n  }\n  .table.g-xxl-8 th, .table.g-xxl-8 td {\n    padding: 2rem;\n  }\n  .table.g-xxl-8 th.dtr-control, .table.g-xxl-8 td.dtr-control {\n    padding-left: 2rem !important;\n  }\n  .table.gy-xxl-8 th, .table.gy-xxl-8 td {\n    padding-top: 2rem;\n    padding-bottom: 2rem;\n  }\n  .table.gx-xxl-8 th, .table.gx-xxl-8 td {\n    padding-left: 2rem;\n    padding-right: 2rem;\n  }\n  .table.gx-xxl-8 th.dtr-control, .table.gx-xxl-8 td.dtr-control {\n    padding-left: 2rem !important;\n  }\n  .table.gs-xxl-8 th:first-child, .table.gs-xxl-8 td:first-child {\n    padding-left: 2rem;\n  }\n  .table.gs-xxl-8 th:last-child, .table.gs-xxl-8 td:last-child {\n    padding-right: 2rem;\n  }\n  .table.gs-xxl-8 th.dtr-control:first-child, .table.gs-xxl-8 td.dtr-control:first-child {\n    padding-left: 2rem !important;\n  }\n  .table.g-xxl-9 th, .table.g-xxl-9 td {\n    padding: 2.25rem;\n  }\n  .table.g-xxl-9 th.dtr-control, .table.g-xxl-9 td.dtr-control {\n    padding-left: 2.25rem !important;\n  }\n  .table.gy-xxl-9 th, .table.gy-xxl-9 td {\n    padding-top: 2.25rem;\n    padding-bottom: 2.25rem;\n  }\n  .table.gx-xxl-9 th, .table.gx-xxl-9 td {\n    padding-left: 2.25rem;\n    padding-right: 2.25rem;\n  }\n  .table.gx-xxl-9 th.dtr-control, .table.gx-xxl-9 td.dtr-control {\n    padding-left: 2.25rem !important;\n  }\n  .table.gs-xxl-9 th:first-child, .table.gs-xxl-9 td:first-child {\n    padding-left: 2.25rem;\n  }\n  .table.gs-xxl-9 th:last-child, .table.gs-xxl-9 td:last-child {\n    padding-right: 2.25rem;\n  }\n  .table.gs-xxl-9 th.dtr-control:first-child, .table.gs-xxl-9 td.dtr-control:first-child {\n    padding-left: 2.25rem !important;\n  }\n  .table.g-xxl-10 th, .table.g-xxl-10 td {\n    padding: 2.5rem;\n  }\n  .table.g-xxl-10 th.dtr-control, .table.g-xxl-10 td.dtr-control {\n    padding-left: 2.5rem !important;\n  }\n  .table.gy-xxl-10 th, .table.gy-xxl-10 td {\n    padding-top: 2.5rem;\n    padding-bottom: 2.5rem;\n  }\n  .table.gx-xxl-10 th, .table.gx-xxl-10 td {\n    padding-left: 2.5rem;\n    padding-right: 2.5rem;\n  }\n  .table.gx-xxl-10 th.dtr-control, .table.gx-xxl-10 td.dtr-control {\n    padding-left: 2.5rem !important;\n  }\n  .table.gs-xxl-10 th:first-child, .table.gs-xxl-10 td:first-child {\n    padding-left: 2.5rem;\n  }\n  .table.gs-xxl-10 th:last-child, .table.gs-xxl-10 td:last-child {\n    padding-right: 2.5rem;\n  }\n  .table.gs-xxl-10 th.dtr-control:first-child, .table.gs-xxl-10 td.dtr-control:first-child {\n    padding-left: 2.5rem !important;\n  }\n}\n.popover {\n  --bs-popover-header-border-color: #F4F4F4;\n}\n.popover .popover-header {\n  font-size: 1rem;\n  font-weight: 500;\n  border-bottom: 1px solid var(--bs-popover-header-border-color);\n}\n.popover .popover-dismiss {\n  position: absolute;\n  top: 0.85rem;\n  right: 0.85rem;\n  height: 1.25rem;\n  width: 1.25rem;\n  mask-repeat: no-repeat;\n  mask-position: center;\n  -webkit-mask-repeat: no-repeat;\n  -webkit-mask-position: center;\n  background-color: var(--bs-gray-500);\n  -webkit-mask-image: url(\"data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 16 16' fill='var%28--bs-gray-500%29'%3e%3cpath d='M.293.293a1 1 0 011.414 0L8 6.586 14.293.293a1 1 0 111.414 1.414L9.414 8l6.293 6.293a1 1 0 01-1.414 1.414L8 9.414l-6.293 6.293a1 1 0 01-1.414-1.414L6.586 8 .293 1.707a1 1 0 010-1.414z'/%3e%3c/svg%3e\");\n  mask-image: url(\"data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 16 16' fill='var%28--bs-gray-500%29'%3e%3cpath d='M.293.293a1 1 0 011.414 0L8 6.586 14.293.293a1 1 0 111.414 1.414L9.414 8l6.293 6.293a1 1 0 01-1.414 1.414L8 9.414l-6.293 6.293a1 1 0 01-1.414-1.414L6.586 8 .293 1.707a1 1 0 010-1.414z'/%3e%3c/svg%3e\");\n  mask-size: 50%;\n  -webkit-mask-size: 50%;\n}\n.popover .popover-dismiss:hover {\n  background-color: var(--bs-primary);\n}\n.popover .popover-dismiss + .popover-header {\n  padding-right: 2.5rem;\n}\n\n.popover-inverse {\n  --bs-popover-bg: var(--bs-gray-900);\n  --bs-popover-border-color: var(--bs-gray-900);\n  --bs-popover-box-shadow: 0px 0px 30px rgba(0, 0, 0, 0.3);\n  --bs-popover-header-color: var(--bs-gray-200);\n  --bs-popover-header-bg: var(--bs-gray-900);\n  --bs-popover-body-color: var(--bs-gray-400);\n  --bs-popover-arrow-border: transparent;\n  --bs-popover-header-border-color: var(--bs-gray-800);\n}\n\n[data-bs-theme=dark] .popover:not(.popover-inverse) {\n  --bs-popover-bg: #2B2B40;\n  --bs-popover-border-color: #2B2B40;\n  --bs-popover-header-bg: #2B2B40;\n  --bs-popover-box-shadow: 0px 0px 30px rgba(0, 0, 0, 0.3);\n  --bs-popover-header-border-color: #323248;\n}\n\n.tooltip .tooltip-inner {\n  box-shadow: var(--bs-tooltip-box-shadow);\n}\n.tooltip.tooltop-auto-width .tooltip-inner {\n  white-space: nowrap;\n  max-width: none;\n}\n.tooltip.tooltip-inverse {\n  --bs-tooltip-color: var(--bs-dark-inverse);\n  --bs-tooltip-bg: var(--bs-dark);\n}\n\n[data-bs-theme=dark] .tooltip:not(.tooltip-inverse) {\n  --bs-tooltip-bg: #2B2B40;\n  --bs-tooltip-box-shadow: 0px 0px 30px rgba(0, 0, 0, 0.15);\n}\n\n.accordion .accordion-header {\n  cursor: pointer;\n}\n.accordion.accordion-icon-toggle .accordion-icon {\n  display: flex;\n  flex-shrink: 0;\n  transition: all 0.2s ease-in-out;\n  transform: rotate(90deg);\n  align-items: center;\n  justify-content: center;\n}\n.accordion.accordion-icon-toggle .accordion-icon i,\n.accordion.accordion-icon-toggle .accordion-icon .svg-icon {\n  color: var(--bs-primary);\n}\n.accordion.accordion-icon-toggle .collapsed .accordion-icon {\n  transition: all 0.2s ease-in-out;\n  transform: rotate(0);\n}\n.accordion.accordion-icon-toggle .collapsed .accordion-icon i,\n.accordion.accordion-icon-toggle .collapsed .accordion-icon .svg-icon {\n  color: var(--bs-text-muted);\n}\n.accordion.accordion-icon-collapse .accordion-icon {\n  display: flex;\n  flex-shrink: 0;\n  align-items: center;\n  justify-content: center;\n  transition: all 0.2s ease-in-out;\n}\n.accordion.accordion-icon-collapse .accordion-icon .accordion-icon-on {\n  display: inline-flex;\n}\n.accordion.accordion-icon-collapse .accordion-icon .accordion-icon-off {\n  display: none;\n}\n.accordion.accordion-icon-collapse .accordion-icon i,\n.accordion.accordion-icon-collapse .accordion-icon .svg-icon {\n  color: var(--bs-primary);\n}\n.accordion.accordion-icon-collapse .collapsed .accordion-icon {\n  transition: all 0.2s ease-in-out;\n}\n.accordion.accordion-icon-collapse .collapsed .accordion-icon .accordion-icon-on {\n  display: none;\n}\n.accordion.accordion-icon-collapse .collapsed .accordion-icon .accordion-icon-off {\n  display: inline-flex;\n}\n.accordion.accordion-icon-collapse .collapsed .accordion-icon i,\n.accordion.accordion-icon-collapse .collapsed .accordion-icon .svg-icon {\n  color: var(--bs-text-muted);\n}\n.accordion.accordion-borderless .accordion-item {\n  border: 0;\n}\n.accordion.accordion-flush .accordion-item {\n  background-color: transparent;\n  border: 0;\n  border-radius: 0;\n  padding-left: 0;\n  padding-right: 0;\n}\n\n.image-input {\n  position: relative;\n  display: inline-block;\n  border-radius: 0.475rem;\n  background-repeat: no-repeat;\n  background-size: cover;\n}\n.image-input:not(.image-input-empty) {\n  background-image: none !important;\n}\n.image-input .image-input-wrapper {\n  width: 120px;\n  height: 120px;\n  border-radius: 0.475rem;\n  background-repeat: no-repeat;\n  background-size: cover;\n}\n.image-input [data-kt-image-input-action] {\n  cursor: pointer;\n  position: absolute;\n  transform: translate(-50%, -50%);\n}\n.image-input [data-kt-image-input-action=change] {\n  left: 100%;\n  top: 0;\n}\n.image-input [data-kt-image-input-action=change] input {\n  width: 0 !important;\n  height: 0 !important;\n  overflow: hidden;\n  opacity: 0;\n}\n.image-input [data-kt-image-input-action=cancel],\n.image-input [data-kt-image-input-action=remove] {\n  position: absolute;\n  left: 100%;\n  top: 100%;\n}\n.image-input [data-kt-image-input-action=cancel] {\n  display: none;\n}\n.image-input.image-input-changed [data-kt-image-input-action=cancel] {\n  display: flex;\n}\n.image-input.image-input-changed [data-kt-image-input-action=remove] {\n  display: none;\n}\n.image-input.image-input-empty [data-kt-image-input-action=remove],\n.image-input.image-input-empty [data-kt-image-input-action=cancel] {\n  display: none;\n}\n.image-input.image-input-circle {\n  border-radius: 50%;\n}\n.image-input.image-input-circle .image-input-wrapper {\n  border-radius: 50%;\n}\n.image-input.image-input-circle [data-kt-image-input-action=change] {\n  left: 100%;\n  top: 0;\n  transform: translate(-100%, 0%);\n}\n.image-input.image-input-circle [data-kt-image-input-action=cancel],\n.image-input.image-input-circle [data-kt-image-input-action=remove] {\n  left: 100%;\n  top: 100%;\n  transform: translate(-100%, -100%);\n}\n.image-input.image-input-outline .image-input-wrapper {\n  border: 3px solid var(--bs-body-bg);\n  box-shadow: var(--bs-box-shadow);\n}\n\n.symbol {\n  display: inline-block;\n  flex-shrink: 0;\n  position: relative;\n  border-radius: 0.475rem;\n}\n.symbol .symbol-label {\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  font-weight: 500;\n  color: var(--bs-symbol-label-color);\n  background-color: var(--bs-symbol-label-bg);\n  background-repeat: no-repeat;\n  background-position: center center;\n  background-size: cover;\n  border-radius: 0.475rem;\n}\n.symbol .symbol-label:after {\n  border-radius: 0.475rem;\n}\n.symbol .symbol-badge {\n  position: absolute;\n  border-radius: 100%;\n  top: 0;\n  left: 50%;\n  transform: translateX(-50%) translateY(-50%) !important;\n}\n.symbol > img {\n  width: 100%;\n  flex-shrink: 0;\n  display: inline-block;\n  border-radius: 0.475rem;\n}\n.symbol.symbol-square,\n.symbol.symbol-square > img,\n.symbol.symbol-square .symbol-label {\n  border-radius: 0 !important;\n}\n.symbol.symbol-circle,\n.symbol.symbol-circle > img,\n.symbol.symbol-circle .symbol-label {\n  border-radius: 50%;\n}\n.symbol.symbol-circle:after,\n.symbol.symbol-circle > img:after,\n.symbol.symbol-circle .symbol-label:after {\n  border-radius: 50%;\n}\n.symbol > img {\n  width: 50px;\n  height: 50px;\n}\n.symbol .symbol-label {\n  width: 50px;\n  height: 50px;\n}\n.symbol.symbol-fixed .symbol-label {\n  width: 50px;\n  height: 50px;\n}\n.symbol.symbol-fixed > img {\n  width: 50px;\n  height: 50px;\n  max-width: none;\n}\n.symbol.symbol-2by3 .symbol-label {\n  height: 50px;\n  width: 75px;\n}\n.symbol.symbol-2by3 > img {\n  height: 50px;\n  width: 75px;\n  max-width: none;\n}\n.symbol.symbol-20px > img {\n  width: 20px;\n  height: 20px;\n}\n.symbol.symbol-20px .symbol-label {\n  width: 20px;\n  height: 20px;\n}\n.symbol.symbol-20px.symbol-fixed .symbol-label {\n  width: 20px;\n  height: 20px;\n}\n.symbol.symbol-20px.symbol-fixed > img {\n  width: 20px;\n  height: 20px;\n  max-width: none;\n}\n.symbol.symbol-20px.symbol-2by3 .symbol-label {\n  height: 20px;\n  width: 30px;\n}\n.symbol.symbol-20px.symbol-2by3 > img {\n  height: 20px;\n  width: 30px;\n  max-width: none;\n}\n.symbol.symbol-25px > img {\n  width: 25px;\n  height: 25px;\n}\n.symbol.symbol-25px .symbol-label {\n  width: 25px;\n  height: 25px;\n}\n.symbol.symbol-25px.symbol-fixed .symbol-label {\n  width: 25px;\n  height: 25px;\n}\n.symbol.symbol-25px.symbol-fixed > img {\n  width: 25px;\n  height: 25px;\n  max-width: none;\n}\n.symbol.symbol-25px.symbol-2by3 .symbol-label {\n  height: 25px;\n  width: 37.5px;\n}\n.symbol.symbol-25px.symbol-2by3 > img {\n  height: 25px;\n  width: 37.5px;\n  max-width: none;\n}\n.symbol.symbol-30px > img {\n  width: 30px;\n  height: 30px;\n}\n.symbol.symbol-30px .symbol-label {\n  width: 30px;\n  height: 30px;\n}\n.symbol.symbol-30px.symbol-fixed .symbol-label {\n  width: 30px;\n  height: 30px;\n}\n.symbol.symbol-30px.symbol-fixed > img {\n  width: 30px;\n  height: 30px;\n  max-width: none;\n}\n.symbol.symbol-30px.symbol-2by3 .symbol-label {\n  height: 30px;\n  width: 45px;\n}\n.symbol.symbol-30px.symbol-2by3 > img {\n  height: 30px;\n  width: 45px;\n  max-width: none;\n}\n.symbol.symbol-35px > img {\n  width: 35px;\n  height: 35px;\n}\n.symbol.symbol-35px .symbol-label {\n  width: 35px;\n  height: 35px;\n}\n.symbol.symbol-35px.symbol-fixed .symbol-label {\n  width: 35px;\n  height: 35px;\n}\n.symbol.symbol-35px.symbol-fixed > img {\n  width: 35px;\n  height: 35px;\n  max-width: none;\n}\n.symbol.symbol-35px.symbol-2by3 .symbol-label {\n  height: 35px;\n  width: 52.5px;\n}\n.symbol.symbol-35px.symbol-2by3 > img {\n  height: 35px;\n  width: 52.5px;\n  max-width: none;\n}\n.symbol.symbol-40px > img {\n  width: 40px;\n  height: 40px;\n}\n.symbol.symbol-40px .symbol-label {\n  width: 40px;\n  height: 40px;\n}\n.symbol.symbol-40px.symbol-fixed .symbol-label {\n  width: 40px;\n  height: 40px;\n}\n.symbol.symbol-40px.symbol-fixed > img {\n  width: 40px;\n  height: 40px;\n  max-width: none;\n}\n.symbol.symbol-40px.symbol-2by3 .symbol-label {\n  height: 40px;\n  width: 60px;\n}\n.symbol.symbol-40px.symbol-2by3 > img {\n  height: 40px;\n  width: 60px;\n  max-width: none;\n}\n.symbol.symbol-45px > img {\n  width: 45px;\n  height: 45px;\n}\n.symbol.symbol-45px .symbol-label {\n  width: 45px;\n  height: 45px;\n}\n.symbol.symbol-45px.symbol-fixed .symbol-label {\n  width: 45px;\n  height: 45px;\n}\n.symbol.symbol-45px.symbol-fixed > img {\n  width: 45px;\n  height: 45px;\n  max-width: none;\n}\n.symbol.symbol-45px.symbol-2by3 .symbol-label {\n  height: 45px;\n  width: 67.5px;\n}\n.symbol.symbol-45px.symbol-2by3 > img {\n  height: 45px;\n  width: 67.5px;\n  max-width: none;\n}\n.symbol.symbol-50px > img {\n  width: 50px;\n  height: 50px;\n}\n.symbol.symbol-50px .symbol-label {\n  width: 50px;\n  height: 50px;\n}\n.symbol.symbol-50px.symbol-fixed .symbol-label {\n  width: 50px;\n  height: 50px;\n}\n.symbol.symbol-50px.symbol-fixed > img {\n  width: 50px;\n  height: 50px;\n  max-width: none;\n}\n.symbol.symbol-50px.symbol-2by3 .symbol-label {\n  height: 50px;\n  width: 75px;\n}\n.symbol.symbol-50px.symbol-2by3 > img {\n  height: 50px;\n  width: 75px;\n  max-width: none;\n}\n.symbol.symbol-55px > img {\n  width: 55px;\n  height: 55px;\n}\n.symbol.symbol-55px .symbol-label {\n  width: 55px;\n  height: 55px;\n}\n.symbol.symbol-55px.symbol-fixed .symbol-label {\n  width: 55px;\n  height: 55px;\n}\n.symbol.symbol-55px.symbol-fixed > img {\n  width: 55px;\n  height: 55px;\n  max-width: none;\n}\n.symbol.symbol-55px.symbol-2by3 .symbol-label {\n  height: 55px;\n  width: 82.5px;\n}\n.symbol.symbol-55px.symbol-2by3 > img {\n  height: 55px;\n  width: 82.5px;\n  max-width: none;\n}\n.symbol.symbol-60px > img {\n  width: 60px;\n  height: 60px;\n}\n.symbol.symbol-60px .symbol-label {\n  width: 60px;\n  height: 60px;\n}\n.symbol.symbol-60px.symbol-fixed .symbol-label {\n  width: 60px;\n  height: 60px;\n}\n.symbol.symbol-60px.symbol-fixed > img {\n  width: 60px;\n  height: 60px;\n  max-width: none;\n}\n.symbol.symbol-60px.symbol-2by3 .symbol-label {\n  height: 60px;\n  width: 90px;\n}\n.symbol.symbol-60px.symbol-2by3 > img {\n  height: 60px;\n  width: 90px;\n  max-width: none;\n}\n.symbol.symbol-65px > img {\n  width: 65px;\n  height: 65px;\n}\n.symbol.symbol-65px .symbol-label {\n  width: 65px;\n  height: 65px;\n}\n.symbol.symbol-65px.symbol-fixed .symbol-label {\n  width: 65px;\n  height: 65px;\n}\n.symbol.symbol-65px.symbol-fixed > img {\n  width: 65px;\n  height: 65px;\n  max-width: none;\n}\n.symbol.symbol-65px.symbol-2by3 .symbol-label {\n  height: 65px;\n  width: 97.5px;\n}\n.symbol.symbol-65px.symbol-2by3 > img {\n  height: 65px;\n  width: 97.5px;\n  max-width: none;\n}\n.symbol.symbol-70px > img {\n  width: 70px;\n  height: 70px;\n}\n.symbol.symbol-70px .symbol-label {\n  width: 70px;\n  height: 70px;\n}\n.symbol.symbol-70px.symbol-fixed .symbol-label {\n  width: 70px;\n  height: 70px;\n}\n.symbol.symbol-70px.symbol-fixed > img {\n  width: 70px;\n  height: 70px;\n  max-width: none;\n}\n.symbol.symbol-70px.symbol-2by3 .symbol-label {\n  height: 70px;\n  width: 105px;\n}\n.symbol.symbol-70px.symbol-2by3 > img {\n  height: 70px;\n  width: 105px;\n  max-width: none;\n}\n.symbol.symbol-75px > img {\n  width: 75px;\n  height: 75px;\n}\n.symbol.symbol-75px .symbol-label {\n  width: 75px;\n  height: 75px;\n}\n.symbol.symbol-75px.symbol-fixed .symbol-label {\n  width: 75px;\n  height: 75px;\n}\n.symbol.symbol-75px.symbol-fixed > img {\n  width: 75px;\n  height: 75px;\n  max-width: none;\n}\n.symbol.symbol-75px.symbol-2by3 .symbol-label {\n  height: 75px;\n  width: 112.5px;\n}\n.symbol.symbol-75px.symbol-2by3 > img {\n  height: 75px;\n  width: 112.5px;\n  max-width: none;\n}\n.symbol.symbol-90px > img {\n  width: 90px;\n  height: 90px;\n}\n.symbol.symbol-90px .symbol-label {\n  width: 90px;\n  height: 90px;\n}\n.symbol.symbol-90px.symbol-fixed .symbol-label {\n  width: 90px;\n  height: 90px;\n}\n.symbol.symbol-90px.symbol-fixed > img {\n  width: 90px;\n  height: 90px;\n  max-width: none;\n}\n.symbol.symbol-90px.symbol-2by3 .symbol-label {\n  height: 90px;\n  width: 135px;\n}\n.symbol.symbol-90px.symbol-2by3 > img {\n  height: 90px;\n  width: 135px;\n  max-width: none;\n}\n.symbol.symbol-100px > img {\n  width: 100px;\n  height: 100px;\n}\n.symbol.symbol-100px .symbol-label {\n  width: 100px;\n  height: 100px;\n}\n.symbol.symbol-100px.symbol-fixed .symbol-label {\n  width: 100px;\n  height: 100px;\n}\n.symbol.symbol-100px.symbol-fixed > img {\n  width: 100px;\n  height: 100px;\n  max-width: none;\n}\n.symbol.symbol-100px.symbol-2by3 .symbol-label {\n  height: 100px;\n  width: 150px;\n}\n.symbol.symbol-100px.symbol-2by3 > img {\n  height: 100px;\n  width: 150px;\n  max-width: none;\n}\n.symbol.symbol-125px > img {\n  width: 125px;\n  height: 125px;\n}\n.symbol.symbol-125px .symbol-label {\n  width: 125px;\n  height: 125px;\n}\n.symbol.symbol-125px.symbol-fixed .symbol-label {\n  width: 125px;\n  height: 125px;\n}\n.symbol.symbol-125px.symbol-fixed > img {\n  width: 125px;\n  height: 125px;\n  max-width: none;\n}\n.symbol.symbol-125px.symbol-2by3 .symbol-label {\n  height: 125px;\n  width: 187.5px;\n}\n.symbol.symbol-125px.symbol-2by3 > img {\n  height: 125px;\n  width: 187.5px;\n  max-width: none;\n}\n.symbol.symbol-150px > img {\n  width: 150px;\n  height: 150px;\n}\n.symbol.symbol-150px .symbol-label {\n  width: 150px;\n  height: 150px;\n}\n.symbol.symbol-150px.symbol-fixed .symbol-label {\n  width: 150px;\n  height: 150px;\n}\n.symbol.symbol-150px.symbol-fixed > img {\n  width: 150px;\n  height: 150px;\n  max-width: none;\n}\n.symbol.symbol-150px.symbol-2by3 .symbol-label {\n  height: 150px;\n  width: 225px;\n}\n.symbol.symbol-150px.symbol-2by3 > img {\n  height: 150px;\n  width: 225px;\n  max-width: none;\n}\n.symbol.symbol-160px > img {\n  width: 160px;\n  height: 160px;\n}\n.symbol.symbol-160px .symbol-label {\n  width: 160px;\n  height: 160px;\n}\n.symbol.symbol-160px.symbol-fixed .symbol-label {\n  width: 160px;\n  height: 160px;\n}\n.symbol.symbol-160px.symbol-fixed > img {\n  width: 160px;\n  height: 160px;\n  max-width: none;\n}\n.symbol.symbol-160px.symbol-2by3 .symbol-label {\n  height: 160px;\n  width: 240px;\n}\n.symbol.symbol-160px.symbol-2by3 > img {\n  height: 160px;\n  width: 240px;\n  max-width: none;\n}\n.symbol.symbol-175px > img {\n  width: 175px;\n  height: 175px;\n}\n.symbol.symbol-175px .symbol-label {\n  width: 175px;\n  height: 175px;\n}\n.symbol.symbol-175px.symbol-fixed .symbol-label {\n  width: 175px;\n  height: 175px;\n}\n.symbol.symbol-175px.symbol-fixed > img {\n  width: 175px;\n  height: 175px;\n  max-width: none;\n}\n.symbol.symbol-175px.symbol-2by3 .symbol-label {\n  height: 175px;\n  width: 262.5px;\n}\n.symbol.symbol-175px.symbol-2by3 > img {\n  height: 175px;\n  width: 262.5px;\n  max-width: none;\n}\n.symbol.symbol-200px > img {\n  width: 200px;\n  height: 200px;\n}\n.symbol.symbol-200px .symbol-label {\n  width: 200px;\n  height: 200px;\n}\n.symbol.symbol-200px.symbol-fixed .symbol-label {\n  width: 200px;\n  height: 200px;\n}\n.symbol.symbol-200px.symbol-fixed > img {\n  width: 200px;\n  height: 200px;\n  max-width: none;\n}\n.symbol.symbol-200px.symbol-2by3 .symbol-label {\n  height: 200px;\n  width: 300px;\n}\n.symbol.symbol-200px.symbol-2by3 > img {\n  height: 200px;\n  width: 300px;\n  max-width: none;\n}\n@media (min-width: 576px) {\n  .symbol.symbol-sm-20px > img {\n    width: 20px;\n    height: 20px;\n  }\n  .symbol.symbol-sm-20px .symbol-label {\n    width: 20px;\n    height: 20px;\n  }\n  .symbol.symbol-sm-20px.symbol-fixed .symbol-label {\n    width: 20px;\n    height: 20px;\n  }\n  .symbol.symbol-sm-20px.symbol-fixed > img {\n    width: 20px;\n    height: 20px;\n    max-width: none;\n  }\n  .symbol.symbol-sm-20px.symbol-2by3 .symbol-label {\n    height: 20px;\n    width: 30px;\n  }\n  .symbol.symbol-sm-20px.symbol-2by3 > img {\n    height: 20px;\n    width: 30px;\n    max-width: none;\n  }\n  .symbol.symbol-sm-25px > img {\n    width: 25px;\n    height: 25px;\n  }\n  .symbol.symbol-sm-25px .symbol-label {\n    width: 25px;\n    height: 25px;\n  }\n  .symbol.symbol-sm-25px.symbol-fixed .symbol-label {\n    width: 25px;\n    height: 25px;\n  }\n  .symbol.symbol-sm-25px.symbol-fixed > img {\n    width: 25px;\n    height: 25px;\n    max-width: none;\n  }\n  .symbol.symbol-sm-25px.symbol-2by3 .symbol-label {\n    height: 25px;\n    width: 37.5px;\n  }\n  .symbol.symbol-sm-25px.symbol-2by3 > img {\n    height: 25px;\n    width: 37.5px;\n    max-width: none;\n  }\n  .symbol.symbol-sm-30px > img {\n    width: 30px;\n    height: 30px;\n  }\n  .symbol.symbol-sm-30px .symbol-label {\n    width: 30px;\n    height: 30px;\n  }\n  .symbol.symbol-sm-30px.symbol-fixed .symbol-label {\n    width: 30px;\n    height: 30px;\n  }\n  .symbol.symbol-sm-30px.symbol-fixed > img {\n    width: 30px;\n    height: 30px;\n    max-width: none;\n  }\n  .symbol.symbol-sm-30px.symbol-2by3 .symbol-label {\n    height: 30px;\n    width: 45px;\n  }\n  .symbol.symbol-sm-30px.symbol-2by3 > img {\n    height: 30px;\n    width: 45px;\n    max-width: none;\n  }\n  .symbol.symbol-sm-35px > img {\n    width: 35px;\n    height: 35px;\n  }\n  .symbol.symbol-sm-35px .symbol-label {\n    width: 35px;\n    height: 35px;\n  }\n  .symbol.symbol-sm-35px.symbol-fixed .symbol-label {\n    width: 35px;\n    height: 35px;\n  }\n  .symbol.symbol-sm-35px.symbol-fixed > img {\n    width: 35px;\n    height: 35px;\n    max-width: none;\n  }\n  .symbol.symbol-sm-35px.symbol-2by3 .symbol-label {\n    height: 35px;\n    width: 52.5px;\n  }\n  .symbol.symbol-sm-35px.symbol-2by3 > img {\n    height: 35px;\n    width: 52.5px;\n    max-width: none;\n  }\n  .symbol.symbol-sm-40px > img {\n    width: 40px;\n    height: 40px;\n  }\n  .symbol.symbol-sm-40px .symbol-label {\n    width: 40px;\n    height: 40px;\n  }\n  .symbol.symbol-sm-40px.symbol-fixed .symbol-label {\n    width: 40px;\n    height: 40px;\n  }\n  .symbol.symbol-sm-40px.symbol-fixed > img {\n    width: 40px;\n    height: 40px;\n    max-width: none;\n  }\n  .symbol.symbol-sm-40px.symbol-2by3 .symbol-label {\n    height: 40px;\n    width: 60px;\n  }\n  .symbol.symbol-sm-40px.symbol-2by3 > img {\n    height: 40px;\n    width: 60px;\n    max-width: none;\n  }\n  .symbol.symbol-sm-45px > img {\n    width: 45px;\n    height: 45px;\n  }\n  .symbol.symbol-sm-45px .symbol-label {\n    width: 45px;\n    height: 45px;\n  }\n  .symbol.symbol-sm-45px.symbol-fixed .symbol-label {\n    width: 45px;\n    height: 45px;\n  }\n  .symbol.symbol-sm-45px.symbol-fixed > img {\n    width: 45px;\n    height: 45px;\n    max-width: none;\n  }\n  .symbol.symbol-sm-45px.symbol-2by3 .symbol-label {\n    height: 45px;\n    width: 67.5px;\n  }\n  .symbol.symbol-sm-45px.symbol-2by3 > img {\n    height: 45px;\n    width: 67.5px;\n    max-width: none;\n  }\n  .symbol.symbol-sm-50px > img {\n    width: 50px;\n    height: 50px;\n  }\n  .symbol.symbol-sm-50px .symbol-label {\n    width: 50px;\n    height: 50px;\n  }\n  .symbol.symbol-sm-50px.symbol-fixed .symbol-label {\n    width: 50px;\n    height: 50px;\n  }\n  .symbol.symbol-sm-50px.symbol-fixed > img {\n    width: 50px;\n    height: 50px;\n    max-width: none;\n  }\n  .symbol.symbol-sm-50px.symbol-2by3 .symbol-label {\n    height: 50px;\n    width: 75px;\n  }\n  .symbol.symbol-sm-50px.symbol-2by3 > img {\n    height: 50px;\n    width: 75px;\n    max-width: none;\n  }\n  .symbol.symbol-sm-55px > img {\n    width: 55px;\n    height: 55px;\n  }\n  .symbol.symbol-sm-55px .symbol-label {\n    width: 55px;\n    height: 55px;\n  }\n  .symbol.symbol-sm-55px.symbol-fixed .symbol-label {\n    width: 55px;\n    height: 55px;\n  }\n  .symbol.symbol-sm-55px.symbol-fixed > img {\n    width: 55px;\n    height: 55px;\n    max-width: none;\n  }\n  .symbol.symbol-sm-55px.symbol-2by3 .symbol-label {\n    height: 55px;\n    width: 82.5px;\n  }\n  .symbol.symbol-sm-55px.symbol-2by3 > img {\n    height: 55px;\n    width: 82.5px;\n    max-width: none;\n  }\n  .symbol.symbol-sm-60px > img {\n    width: 60px;\n    height: 60px;\n  }\n  .symbol.symbol-sm-60px .symbol-label {\n    width: 60px;\n    height: 60px;\n  }\n  .symbol.symbol-sm-60px.symbol-fixed .symbol-label {\n    width: 60px;\n    height: 60px;\n  }\n  .symbol.symbol-sm-60px.symbol-fixed > img {\n    width: 60px;\n    height: 60px;\n    max-width: none;\n  }\n  .symbol.symbol-sm-60px.symbol-2by3 .symbol-label {\n    height: 60px;\n    width: 90px;\n  }\n  .symbol.symbol-sm-60px.symbol-2by3 > img {\n    height: 60px;\n    width: 90px;\n    max-width: none;\n  }\n  .symbol.symbol-sm-65px > img {\n    width: 65px;\n    height: 65px;\n  }\n  .symbol.symbol-sm-65px .symbol-label {\n    width: 65px;\n    height: 65px;\n  }\n  .symbol.symbol-sm-65px.symbol-fixed .symbol-label {\n    width: 65px;\n    height: 65px;\n  }\n  .symbol.symbol-sm-65px.symbol-fixed > img {\n    width: 65px;\n    height: 65px;\n    max-width: none;\n  }\n  .symbol.symbol-sm-65px.symbol-2by3 .symbol-label {\n    height: 65px;\n    width: 97.5px;\n  }\n  .symbol.symbol-sm-65px.symbol-2by3 > img {\n    height: 65px;\n    width: 97.5px;\n    max-width: none;\n  }\n  .symbol.symbol-sm-70px > img {\n    width: 70px;\n    height: 70px;\n  }\n  .symbol.symbol-sm-70px .symbol-label {\n    width: 70px;\n    height: 70px;\n  }\n  .symbol.symbol-sm-70px.symbol-fixed .symbol-label {\n    width: 70px;\n    height: 70px;\n  }\n  .symbol.symbol-sm-70px.symbol-fixed > img {\n    width: 70px;\n    height: 70px;\n    max-width: none;\n  }\n  .symbol.symbol-sm-70px.symbol-2by3 .symbol-label {\n    height: 70px;\n    width: 105px;\n  }\n  .symbol.symbol-sm-70px.symbol-2by3 > img {\n    height: 70px;\n    width: 105px;\n    max-width: none;\n  }\n  .symbol.symbol-sm-75px > img {\n    width: 75px;\n    height: 75px;\n  }\n  .symbol.symbol-sm-75px .symbol-label {\n    width: 75px;\n    height: 75px;\n  }\n  .symbol.symbol-sm-75px.symbol-fixed .symbol-label {\n    width: 75px;\n    height: 75px;\n  }\n  .symbol.symbol-sm-75px.symbol-fixed > img {\n    width: 75px;\n    height: 75px;\n    max-width: none;\n  }\n  .symbol.symbol-sm-75px.symbol-2by3 .symbol-label {\n    height: 75px;\n    width: 112.5px;\n  }\n  .symbol.symbol-sm-75px.symbol-2by3 > img {\n    height: 75px;\n    width: 112.5px;\n    max-width: none;\n  }\n  .symbol.symbol-sm-90px > img {\n    width: 90px;\n    height: 90px;\n  }\n  .symbol.symbol-sm-90px .symbol-label {\n    width: 90px;\n    height: 90px;\n  }\n  .symbol.symbol-sm-90px.symbol-fixed .symbol-label {\n    width: 90px;\n    height: 90px;\n  }\n  .symbol.symbol-sm-90px.symbol-fixed > img {\n    width: 90px;\n    height: 90px;\n    max-width: none;\n  }\n  .symbol.symbol-sm-90px.symbol-2by3 .symbol-label {\n    height: 90px;\n    width: 135px;\n  }\n  .symbol.symbol-sm-90px.symbol-2by3 > img {\n    height: 90px;\n    width: 135px;\n    max-width: none;\n  }\n  .symbol.symbol-sm-100px > img {\n    width: 100px;\n    height: 100px;\n  }\n  .symbol.symbol-sm-100px .symbol-label {\n    width: 100px;\n    height: 100px;\n  }\n  .symbol.symbol-sm-100px.symbol-fixed .symbol-label {\n    width: 100px;\n    height: 100px;\n  }\n  .symbol.symbol-sm-100px.symbol-fixed > img {\n    width: 100px;\n    height: 100px;\n    max-width: none;\n  }\n  .symbol.symbol-sm-100px.symbol-2by3 .symbol-label {\n    height: 100px;\n    width: 150px;\n  }\n  .symbol.symbol-sm-100px.symbol-2by3 > img {\n    height: 100px;\n    width: 150px;\n    max-width: none;\n  }\n  .symbol.symbol-sm-125px > img {\n    width: 125px;\n    height: 125px;\n  }\n  .symbol.symbol-sm-125px .symbol-label {\n    width: 125px;\n    height: 125px;\n  }\n  .symbol.symbol-sm-125px.symbol-fixed .symbol-label {\n    width: 125px;\n    height: 125px;\n  }\n  .symbol.symbol-sm-125px.symbol-fixed > img {\n    width: 125px;\n    height: 125px;\n    max-width: none;\n  }\n  .symbol.symbol-sm-125px.symbol-2by3 .symbol-label {\n    height: 125px;\n    width: 187.5px;\n  }\n  .symbol.symbol-sm-125px.symbol-2by3 > img {\n    height: 125px;\n    width: 187.5px;\n    max-width: none;\n  }\n  .symbol.symbol-sm-150px > img {\n    width: 150px;\n    height: 150px;\n  }\n  .symbol.symbol-sm-150px .symbol-label {\n    width: 150px;\n    height: 150px;\n  }\n  .symbol.symbol-sm-150px.symbol-fixed .symbol-label {\n    width: 150px;\n    height: 150px;\n  }\n  .symbol.symbol-sm-150px.symbol-fixed > img {\n    width: 150px;\n    height: 150px;\n    max-width: none;\n  }\n  .symbol.symbol-sm-150px.symbol-2by3 .symbol-label {\n    height: 150px;\n    width: 225px;\n  }\n  .symbol.symbol-sm-150px.symbol-2by3 > img {\n    height: 150px;\n    width: 225px;\n    max-width: none;\n  }\n  .symbol.symbol-sm-160px > img {\n    width: 160px;\n    height: 160px;\n  }\n  .symbol.symbol-sm-160px .symbol-label {\n    width: 160px;\n    height: 160px;\n  }\n  .symbol.symbol-sm-160px.symbol-fixed .symbol-label {\n    width: 160px;\n    height: 160px;\n  }\n  .symbol.symbol-sm-160px.symbol-fixed > img {\n    width: 160px;\n    height: 160px;\n    max-width: none;\n  }\n  .symbol.symbol-sm-160px.symbol-2by3 .symbol-label {\n    height: 160px;\n    width: 240px;\n  }\n  .symbol.symbol-sm-160px.symbol-2by3 > img {\n    height: 160px;\n    width: 240px;\n    max-width: none;\n  }\n  .symbol.symbol-sm-175px > img {\n    width: 175px;\n    height: 175px;\n  }\n  .symbol.symbol-sm-175px .symbol-label {\n    width: 175px;\n    height: 175px;\n  }\n  .symbol.symbol-sm-175px.symbol-fixed .symbol-label {\n    width: 175px;\n    height: 175px;\n  }\n  .symbol.symbol-sm-175px.symbol-fixed > img {\n    width: 175px;\n    height: 175px;\n    max-width: none;\n  }\n  .symbol.symbol-sm-175px.symbol-2by3 .symbol-label {\n    height: 175px;\n    width: 262.5px;\n  }\n  .symbol.symbol-sm-175px.symbol-2by3 > img {\n    height: 175px;\n    width: 262.5px;\n    max-width: none;\n  }\n  .symbol.symbol-sm-200px > img {\n    width: 200px;\n    height: 200px;\n  }\n  .symbol.symbol-sm-200px .symbol-label {\n    width: 200px;\n    height: 200px;\n  }\n  .symbol.symbol-sm-200px.symbol-fixed .symbol-label {\n    width: 200px;\n    height: 200px;\n  }\n  .symbol.symbol-sm-200px.symbol-fixed > img {\n    width: 200px;\n    height: 200px;\n    max-width: none;\n  }\n  .symbol.symbol-sm-200px.symbol-2by3 .symbol-label {\n    height: 200px;\n    width: 300px;\n  }\n  .symbol.symbol-sm-200px.symbol-2by3 > img {\n    height: 200px;\n    width: 300px;\n    max-width: none;\n  }\n}\n@media (min-width: 768px) {\n  .symbol.symbol-md-20px > img {\n    width: 20px;\n    height: 20px;\n  }\n  .symbol.symbol-md-20px .symbol-label {\n    width: 20px;\n    height: 20px;\n  }\n  .symbol.symbol-md-20px.symbol-fixed .symbol-label {\n    width: 20px;\n    height: 20px;\n  }\n  .symbol.symbol-md-20px.symbol-fixed > img {\n    width: 20px;\n    height: 20px;\n    max-width: none;\n  }\n  .symbol.symbol-md-20px.symbol-2by3 .symbol-label {\n    height: 20px;\n    width: 30px;\n  }\n  .symbol.symbol-md-20px.symbol-2by3 > img {\n    height: 20px;\n    width: 30px;\n    max-width: none;\n  }\n  .symbol.symbol-md-25px > img {\n    width: 25px;\n    height: 25px;\n  }\n  .symbol.symbol-md-25px .symbol-label {\n    width: 25px;\n    height: 25px;\n  }\n  .symbol.symbol-md-25px.symbol-fixed .symbol-label {\n    width: 25px;\n    height: 25px;\n  }\n  .symbol.symbol-md-25px.symbol-fixed > img {\n    width: 25px;\n    height: 25px;\n    max-width: none;\n  }\n  .symbol.symbol-md-25px.symbol-2by3 .symbol-label {\n    height: 25px;\n    width: 37.5px;\n  }\n  .symbol.symbol-md-25px.symbol-2by3 > img {\n    height: 25px;\n    width: 37.5px;\n    max-width: none;\n  }\n  .symbol.symbol-md-30px > img {\n    width: 30px;\n    height: 30px;\n  }\n  .symbol.symbol-md-30px .symbol-label {\n    width: 30px;\n    height: 30px;\n  }\n  .symbol.symbol-md-30px.symbol-fixed .symbol-label {\n    width: 30px;\n    height: 30px;\n  }\n  .symbol.symbol-md-30px.symbol-fixed > img {\n    width: 30px;\n    height: 30px;\n    max-width: none;\n  }\n  .symbol.symbol-md-30px.symbol-2by3 .symbol-label {\n    height: 30px;\n    width: 45px;\n  }\n  .symbol.symbol-md-30px.symbol-2by3 > img {\n    height: 30px;\n    width: 45px;\n    max-width: none;\n  }\n  .symbol.symbol-md-35px > img {\n    width: 35px;\n    height: 35px;\n  }\n  .symbol.symbol-md-35px .symbol-label {\n    width: 35px;\n    height: 35px;\n  }\n  .symbol.symbol-md-35px.symbol-fixed .symbol-label {\n    width: 35px;\n    height: 35px;\n  }\n  .symbol.symbol-md-35px.symbol-fixed > img {\n    width: 35px;\n    height: 35px;\n    max-width: none;\n  }\n  .symbol.symbol-md-35px.symbol-2by3 .symbol-label {\n    height: 35px;\n    width: 52.5px;\n  }\n  .symbol.symbol-md-35px.symbol-2by3 > img {\n    height: 35px;\n    width: 52.5px;\n    max-width: none;\n  }\n  .symbol.symbol-md-40px > img {\n    width: 40px;\n    height: 40px;\n  }\n  .symbol.symbol-md-40px .symbol-label {\n    width: 40px;\n    height: 40px;\n  }\n  .symbol.symbol-md-40px.symbol-fixed .symbol-label {\n    width: 40px;\n    height: 40px;\n  }\n  .symbol.symbol-md-40px.symbol-fixed > img {\n    width: 40px;\n    height: 40px;\n    max-width: none;\n  }\n  .symbol.symbol-md-40px.symbol-2by3 .symbol-label {\n    height: 40px;\n    width: 60px;\n  }\n  .symbol.symbol-md-40px.symbol-2by3 > img {\n    height: 40px;\n    width: 60px;\n    max-width: none;\n  }\n  .symbol.symbol-md-45px > img {\n    width: 45px;\n    height: 45px;\n  }\n  .symbol.symbol-md-45px .symbol-label {\n    width: 45px;\n    height: 45px;\n  }\n  .symbol.symbol-md-45px.symbol-fixed .symbol-label {\n    width: 45px;\n    height: 45px;\n  }\n  .symbol.symbol-md-45px.symbol-fixed > img {\n    width: 45px;\n    height: 45px;\n    max-width: none;\n  }\n  .symbol.symbol-md-45px.symbol-2by3 .symbol-label {\n    height: 45px;\n    width: 67.5px;\n  }\n  .symbol.symbol-md-45px.symbol-2by3 > img {\n    height: 45px;\n    width: 67.5px;\n    max-width: none;\n  }\n  .symbol.symbol-md-50px > img {\n    width: 50px;\n    height: 50px;\n  }\n  .symbol.symbol-md-50px .symbol-label {\n    width: 50px;\n    height: 50px;\n  }\n  .symbol.symbol-md-50px.symbol-fixed .symbol-label {\n    width: 50px;\n    height: 50px;\n  }\n  .symbol.symbol-md-50px.symbol-fixed > img {\n    width: 50px;\n    height: 50px;\n    max-width: none;\n  }\n  .symbol.symbol-md-50px.symbol-2by3 .symbol-label {\n    height: 50px;\n    width: 75px;\n  }\n  .symbol.symbol-md-50px.symbol-2by3 > img {\n    height: 50px;\n    width: 75px;\n    max-width: none;\n  }\n  .symbol.symbol-md-55px > img {\n    width: 55px;\n    height: 55px;\n  }\n  .symbol.symbol-md-55px .symbol-label {\n    width: 55px;\n    height: 55px;\n  }\n  .symbol.symbol-md-55px.symbol-fixed .symbol-label {\n    width: 55px;\n    height: 55px;\n  }\n  .symbol.symbol-md-55px.symbol-fixed > img {\n    width: 55px;\n    height: 55px;\n    max-width: none;\n  }\n  .symbol.symbol-md-55px.symbol-2by3 .symbol-label {\n    height: 55px;\n    width: 82.5px;\n  }\n  .symbol.symbol-md-55px.symbol-2by3 > img {\n    height: 55px;\n    width: 82.5px;\n    max-width: none;\n  }\n  .symbol.symbol-md-60px > img {\n    width: 60px;\n    height: 60px;\n  }\n  .symbol.symbol-md-60px .symbol-label {\n    width: 60px;\n    height: 60px;\n  }\n  .symbol.symbol-md-60px.symbol-fixed .symbol-label {\n    width: 60px;\n    height: 60px;\n  }\n  .symbol.symbol-md-60px.symbol-fixed > img {\n    width: 60px;\n    height: 60px;\n    max-width: none;\n  }\n  .symbol.symbol-md-60px.symbol-2by3 .symbol-label {\n    height: 60px;\n    width: 90px;\n  }\n  .symbol.symbol-md-60px.symbol-2by3 > img {\n    height: 60px;\n    width: 90px;\n    max-width: none;\n  }\n  .symbol.symbol-md-65px > img {\n    width: 65px;\n    height: 65px;\n  }\n  .symbol.symbol-md-65px .symbol-label {\n    width: 65px;\n    height: 65px;\n  }\n  .symbol.symbol-md-65px.symbol-fixed .symbol-label {\n    width: 65px;\n    height: 65px;\n  }\n  .symbol.symbol-md-65px.symbol-fixed > img {\n    width: 65px;\n    height: 65px;\n    max-width: none;\n  }\n  .symbol.symbol-md-65px.symbol-2by3 .symbol-label {\n    height: 65px;\n    width: 97.5px;\n  }\n  .symbol.symbol-md-65px.symbol-2by3 > img {\n    height: 65px;\n    width: 97.5px;\n    max-width: none;\n  }\n  .symbol.symbol-md-70px > img {\n    width: 70px;\n    height: 70px;\n  }\n  .symbol.symbol-md-70px .symbol-label {\n    width: 70px;\n    height: 70px;\n  }\n  .symbol.symbol-md-70px.symbol-fixed .symbol-label {\n    width: 70px;\n    height: 70px;\n  }\n  .symbol.symbol-md-70px.symbol-fixed > img {\n    width: 70px;\n    height: 70px;\n    max-width: none;\n  }\n  .symbol.symbol-md-70px.symbol-2by3 .symbol-label {\n    height: 70px;\n    width: 105px;\n  }\n  .symbol.symbol-md-70px.symbol-2by3 > img {\n    height: 70px;\n    width: 105px;\n    max-width: none;\n  }\n  .symbol.symbol-md-75px > img {\n    width: 75px;\n    height: 75px;\n  }\n  .symbol.symbol-md-75px .symbol-label {\n    width: 75px;\n    height: 75px;\n  }\n  .symbol.symbol-md-75px.symbol-fixed .symbol-label {\n    width: 75px;\n    height: 75px;\n  }\n  .symbol.symbol-md-75px.symbol-fixed > img {\n    width: 75px;\n    height: 75px;\n    max-width: none;\n  }\n  .symbol.symbol-md-75px.symbol-2by3 .symbol-label {\n    height: 75px;\n    width: 112.5px;\n  }\n  .symbol.symbol-md-75px.symbol-2by3 > img {\n    height: 75px;\n    width: 112.5px;\n    max-width: none;\n  }\n  .symbol.symbol-md-90px > img {\n    width: 90px;\n    height: 90px;\n  }\n  .symbol.symbol-md-90px .symbol-label {\n    width: 90px;\n    height: 90px;\n  }\n  .symbol.symbol-md-90px.symbol-fixed .symbol-label {\n    width: 90px;\n    height: 90px;\n  }\n  .symbol.symbol-md-90px.symbol-fixed > img {\n    width: 90px;\n    height: 90px;\n    max-width: none;\n  }\n  .symbol.symbol-md-90px.symbol-2by3 .symbol-label {\n    height: 90px;\n    width: 135px;\n  }\n  .symbol.symbol-md-90px.symbol-2by3 > img {\n    height: 90px;\n    width: 135px;\n    max-width: none;\n  }\n  .symbol.symbol-md-100px > img {\n    width: 100px;\n    height: 100px;\n  }\n  .symbol.symbol-md-100px .symbol-label {\n    width: 100px;\n    height: 100px;\n  }\n  .symbol.symbol-md-100px.symbol-fixed .symbol-label {\n    width: 100px;\n    height: 100px;\n  }\n  .symbol.symbol-md-100px.symbol-fixed > img {\n    width: 100px;\n    height: 100px;\n    max-width: none;\n  }\n  .symbol.symbol-md-100px.symbol-2by3 .symbol-label {\n    height: 100px;\n    width: 150px;\n  }\n  .symbol.symbol-md-100px.symbol-2by3 > img {\n    height: 100px;\n    width: 150px;\n    max-width: none;\n  }\n  .symbol.symbol-md-125px > img {\n    width: 125px;\n    height: 125px;\n  }\n  .symbol.symbol-md-125px .symbol-label {\n    width: 125px;\n    height: 125px;\n  }\n  .symbol.symbol-md-125px.symbol-fixed .symbol-label {\n    width: 125px;\n    height: 125px;\n  }\n  .symbol.symbol-md-125px.symbol-fixed > img {\n    width: 125px;\n    height: 125px;\n    max-width: none;\n  }\n  .symbol.symbol-md-125px.symbol-2by3 .symbol-label {\n    height: 125px;\n    width: 187.5px;\n  }\n  .symbol.symbol-md-125px.symbol-2by3 > img {\n    height: 125px;\n    width: 187.5px;\n    max-width: none;\n  }\n  .symbol.symbol-md-150px > img {\n    width: 150px;\n    height: 150px;\n  }\n  .symbol.symbol-md-150px .symbol-label {\n    width: 150px;\n    height: 150px;\n  }\n  .symbol.symbol-md-150px.symbol-fixed .symbol-label {\n    width: 150px;\n    height: 150px;\n  }\n  .symbol.symbol-md-150px.symbol-fixed > img {\n    width: 150px;\n    height: 150px;\n    max-width: none;\n  }\n  .symbol.symbol-md-150px.symbol-2by3 .symbol-label {\n    height: 150px;\n    width: 225px;\n  }\n  .symbol.symbol-md-150px.symbol-2by3 > img {\n    height: 150px;\n    width: 225px;\n    max-width: none;\n  }\n  .symbol.symbol-md-160px > img {\n    width: 160px;\n    height: 160px;\n  }\n  .symbol.symbol-md-160px .symbol-label {\n    width: 160px;\n    height: 160px;\n  }\n  .symbol.symbol-md-160px.symbol-fixed .symbol-label {\n    width: 160px;\n    height: 160px;\n  }\n  .symbol.symbol-md-160px.symbol-fixed > img {\n    width: 160px;\n    height: 160px;\n    max-width: none;\n  }\n  .symbol.symbol-md-160px.symbol-2by3 .symbol-label {\n    height: 160px;\n    width: 240px;\n  }\n  .symbol.symbol-md-160px.symbol-2by3 > img {\n    height: 160px;\n    width: 240px;\n    max-width: none;\n  }\n  .symbol.symbol-md-175px > img {\n    width: 175px;\n    height: 175px;\n  }\n  .symbol.symbol-md-175px .symbol-label {\n    width: 175px;\n    height: 175px;\n  }\n  .symbol.symbol-md-175px.symbol-fixed .symbol-label {\n    width: 175px;\n    height: 175px;\n  }\n  .symbol.symbol-md-175px.symbol-fixed > img {\n    width: 175px;\n    height: 175px;\n    max-width: none;\n  }\n  .symbol.symbol-md-175px.symbol-2by3 .symbol-label {\n    height: 175px;\n    width: 262.5px;\n  }\n  .symbol.symbol-md-175px.symbol-2by3 > img {\n    height: 175px;\n    width: 262.5px;\n    max-width: none;\n  }\n  .symbol.symbol-md-200px > img {\n    width: 200px;\n    height: 200px;\n  }\n  .symbol.symbol-md-200px .symbol-label {\n    width: 200px;\n    height: 200px;\n  }\n  .symbol.symbol-md-200px.symbol-fixed .symbol-label {\n    width: 200px;\n    height: 200px;\n  }\n  .symbol.symbol-md-200px.symbol-fixed > img {\n    width: 200px;\n    height: 200px;\n    max-width: none;\n  }\n  .symbol.symbol-md-200px.symbol-2by3 .symbol-label {\n    height: 200px;\n    width: 300px;\n  }\n  .symbol.symbol-md-200px.symbol-2by3 > img {\n    height: 200px;\n    width: 300px;\n    max-width: none;\n  }\n}\n@media (min-width: 992px) {\n  .symbol.symbol-lg-20px > img {\n    width: 20px;\n    height: 20px;\n  }\n  .symbol.symbol-lg-20px .symbol-label {\n    width: 20px;\n    height: 20px;\n  }\n  .symbol.symbol-lg-20px.symbol-fixed .symbol-label {\n    width: 20px;\n    height: 20px;\n  }\n  .symbol.symbol-lg-20px.symbol-fixed > img {\n    width: 20px;\n    height: 20px;\n    max-width: none;\n  }\n  .symbol.symbol-lg-20px.symbol-2by3 .symbol-label {\n    height: 20px;\n    width: 30px;\n  }\n  .symbol.symbol-lg-20px.symbol-2by3 > img {\n    height: 20px;\n    width: 30px;\n    max-width: none;\n  }\n  .symbol.symbol-lg-25px > img {\n    width: 25px;\n    height: 25px;\n  }\n  .symbol.symbol-lg-25px .symbol-label {\n    width: 25px;\n    height: 25px;\n  }\n  .symbol.symbol-lg-25px.symbol-fixed .symbol-label {\n    width: 25px;\n    height: 25px;\n  }\n  .symbol.symbol-lg-25px.symbol-fixed > img {\n    width: 25px;\n    height: 25px;\n    max-width: none;\n  }\n  .symbol.symbol-lg-25px.symbol-2by3 .symbol-label {\n    height: 25px;\n    width: 37.5px;\n  }\n  .symbol.symbol-lg-25px.symbol-2by3 > img {\n    height: 25px;\n    width: 37.5px;\n    max-width: none;\n  }\n  .symbol.symbol-lg-30px > img {\n    width: 30px;\n    height: 30px;\n  }\n  .symbol.symbol-lg-30px .symbol-label {\n    width: 30px;\n    height: 30px;\n  }\n  .symbol.symbol-lg-30px.symbol-fixed .symbol-label {\n    width: 30px;\n    height: 30px;\n  }\n  .symbol.symbol-lg-30px.symbol-fixed > img {\n    width: 30px;\n    height: 30px;\n    max-width: none;\n  }\n  .symbol.symbol-lg-30px.symbol-2by3 .symbol-label {\n    height: 30px;\n    width: 45px;\n  }\n  .symbol.symbol-lg-30px.symbol-2by3 > img {\n    height: 30px;\n    width: 45px;\n    max-width: none;\n  }\n  .symbol.symbol-lg-35px > img {\n    width: 35px;\n    height: 35px;\n  }\n  .symbol.symbol-lg-35px .symbol-label {\n    width: 35px;\n    height: 35px;\n  }\n  .symbol.symbol-lg-35px.symbol-fixed .symbol-label {\n    width: 35px;\n    height: 35px;\n  }\n  .symbol.symbol-lg-35px.symbol-fixed > img {\n    width: 35px;\n    height: 35px;\n    max-width: none;\n  }\n  .symbol.symbol-lg-35px.symbol-2by3 .symbol-label {\n    height: 35px;\n    width: 52.5px;\n  }\n  .symbol.symbol-lg-35px.symbol-2by3 > img {\n    height: 35px;\n    width: 52.5px;\n    max-width: none;\n  }\n  .symbol.symbol-lg-40px > img {\n    width: 40px;\n    height: 40px;\n  }\n  .symbol.symbol-lg-40px .symbol-label {\n    width: 40px;\n    height: 40px;\n  }\n  .symbol.symbol-lg-40px.symbol-fixed .symbol-label {\n    width: 40px;\n    height: 40px;\n  }\n  .symbol.symbol-lg-40px.symbol-fixed > img {\n    width: 40px;\n    height: 40px;\n    max-width: none;\n  }\n  .symbol.symbol-lg-40px.symbol-2by3 .symbol-label {\n    height: 40px;\n    width: 60px;\n  }\n  .symbol.symbol-lg-40px.symbol-2by3 > img {\n    height: 40px;\n    width: 60px;\n    max-width: none;\n  }\n  .symbol.symbol-lg-45px > img {\n    width: 45px;\n    height: 45px;\n  }\n  .symbol.symbol-lg-45px .symbol-label {\n    width: 45px;\n    height: 45px;\n  }\n  .symbol.symbol-lg-45px.symbol-fixed .symbol-label {\n    width: 45px;\n    height: 45px;\n  }\n  .symbol.symbol-lg-45px.symbol-fixed > img {\n    width: 45px;\n    height: 45px;\n    max-width: none;\n  }\n  .symbol.symbol-lg-45px.symbol-2by3 .symbol-label {\n    height: 45px;\n    width: 67.5px;\n  }\n  .symbol.symbol-lg-45px.symbol-2by3 > img {\n    height: 45px;\n    width: 67.5px;\n    max-width: none;\n  }\n  .symbol.symbol-lg-50px > img {\n    width: 50px;\n    height: 50px;\n  }\n  .symbol.symbol-lg-50px .symbol-label {\n    width: 50px;\n    height: 50px;\n  }\n  .symbol.symbol-lg-50px.symbol-fixed .symbol-label {\n    width: 50px;\n    height: 50px;\n  }\n  .symbol.symbol-lg-50px.symbol-fixed > img {\n    width: 50px;\n    height: 50px;\n    max-width: none;\n  }\n  .symbol.symbol-lg-50px.symbol-2by3 .symbol-label {\n    height: 50px;\n    width: 75px;\n  }\n  .symbol.symbol-lg-50px.symbol-2by3 > img {\n    height: 50px;\n    width: 75px;\n    max-width: none;\n  }\n  .symbol.symbol-lg-55px > img {\n    width: 55px;\n    height: 55px;\n  }\n  .symbol.symbol-lg-55px .symbol-label {\n    width: 55px;\n    height: 55px;\n  }\n  .symbol.symbol-lg-55px.symbol-fixed .symbol-label {\n    width: 55px;\n    height: 55px;\n  }\n  .symbol.symbol-lg-55px.symbol-fixed > img {\n    width: 55px;\n    height: 55px;\n    max-width: none;\n  }\n  .symbol.symbol-lg-55px.symbol-2by3 .symbol-label {\n    height: 55px;\n    width: 82.5px;\n  }\n  .symbol.symbol-lg-55px.symbol-2by3 > img {\n    height: 55px;\n    width: 82.5px;\n    max-width: none;\n  }\n  .symbol.symbol-lg-60px > img {\n    width: 60px;\n    height: 60px;\n  }\n  .symbol.symbol-lg-60px .symbol-label {\n    width: 60px;\n    height: 60px;\n  }\n  .symbol.symbol-lg-60px.symbol-fixed .symbol-label {\n    width: 60px;\n    height: 60px;\n  }\n  .symbol.symbol-lg-60px.symbol-fixed > img {\n    width: 60px;\n    height: 60px;\n    max-width: none;\n  }\n  .symbol.symbol-lg-60px.symbol-2by3 .symbol-label {\n    height: 60px;\n    width: 90px;\n  }\n  .symbol.symbol-lg-60px.symbol-2by3 > img {\n    height: 60px;\n    width: 90px;\n    max-width: none;\n  }\n  .symbol.symbol-lg-65px > img {\n    width: 65px;\n    height: 65px;\n  }\n  .symbol.symbol-lg-65px .symbol-label {\n    width: 65px;\n    height: 65px;\n  }\n  .symbol.symbol-lg-65px.symbol-fixed .symbol-label {\n    width: 65px;\n    height: 65px;\n  }\n  .symbol.symbol-lg-65px.symbol-fixed > img {\n    width: 65px;\n    height: 65px;\n    max-width: none;\n  }\n  .symbol.symbol-lg-65px.symbol-2by3 .symbol-label {\n    height: 65px;\n    width: 97.5px;\n  }\n  .symbol.symbol-lg-65px.symbol-2by3 > img {\n    height: 65px;\n    width: 97.5px;\n    max-width: none;\n  }\n  .symbol.symbol-lg-70px > img {\n    width: 70px;\n    height: 70px;\n  }\n  .symbol.symbol-lg-70px .symbol-label {\n    width: 70px;\n    height: 70px;\n  }\n  .symbol.symbol-lg-70px.symbol-fixed .symbol-label {\n    width: 70px;\n    height: 70px;\n  }\n  .symbol.symbol-lg-70px.symbol-fixed > img {\n    width: 70px;\n    height: 70px;\n    max-width: none;\n  }\n  .symbol.symbol-lg-70px.symbol-2by3 .symbol-label {\n    height: 70px;\n    width: 105px;\n  }\n  .symbol.symbol-lg-70px.symbol-2by3 > img {\n    height: 70px;\n    width: 105px;\n    max-width: none;\n  }\n  .symbol.symbol-lg-75px > img {\n    width: 75px;\n    height: 75px;\n  }\n  .symbol.symbol-lg-75px .symbol-label {\n    width: 75px;\n    height: 75px;\n  }\n  .symbol.symbol-lg-75px.symbol-fixed .symbol-label {\n    width: 75px;\n    height: 75px;\n  }\n  .symbol.symbol-lg-75px.symbol-fixed > img {\n    width: 75px;\n    height: 75px;\n    max-width: none;\n  }\n  .symbol.symbol-lg-75px.symbol-2by3 .symbol-label {\n    height: 75px;\n    width: 112.5px;\n  }\n  .symbol.symbol-lg-75px.symbol-2by3 > img {\n    height: 75px;\n    width: 112.5px;\n    max-width: none;\n  }\n  .symbol.symbol-lg-90px > img {\n    width: 90px;\n    height: 90px;\n  }\n  .symbol.symbol-lg-90px .symbol-label {\n    width: 90px;\n    height: 90px;\n  }\n  .symbol.symbol-lg-90px.symbol-fixed .symbol-label {\n    width: 90px;\n    height: 90px;\n  }\n  .symbol.symbol-lg-90px.symbol-fixed > img {\n    width: 90px;\n    height: 90px;\n    max-width: none;\n  }\n  .symbol.symbol-lg-90px.symbol-2by3 .symbol-label {\n    height: 90px;\n    width: 135px;\n  }\n  .symbol.symbol-lg-90px.symbol-2by3 > img {\n    height: 90px;\n    width: 135px;\n    max-width: none;\n  }\n  .symbol.symbol-lg-100px > img {\n    width: 100px;\n    height: 100px;\n  }\n  .symbol.symbol-lg-100px .symbol-label {\n    width: 100px;\n    height: 100px;\n  }\n  .symbol.symbol-lg-100px.symbol-fixed .symbol-label {\n    width: 100px;\n    height: 100px;\n  }\n  .symbol.symbol-lg-100px.symbol-fixed > img {\n    width: 100px;\n    height: 100px;\n    max-width: none;\n  }\n  .symbol.symbol-lg-100px.symbol-2by3 .symbol-label {\n    height: 100px;\n    width: 150px;\n  }\n  .symbol.symbol-lg-100px.symbol-2by3 > img {\n    height: 100px;\n    width: 150px;\n    max-width: none;\n  }\n  .symbol.symbol-lg-125px > img {\n    width: 125px;\n    height: 125px;\n  }\n  .symbol.symbol-lg-125px .symbol-label {\n    width: 125px;\n    height: 125px;\n  }\n  .symbol.symbol-lg-125px.symbol-fixed .symbol-label {\n    width: 125px;\n    height: 125px;\n  }\n  .symbol.symbol-lg-125px.symbol-fixed > img {\n    width: 125px;\n    height: 125px;\n    max-width: none;\n  }\n  .symbol.symbol-lg-125px.symbol-2by3 .symbol-label {\n    height: 125px;\n    width: 187.5px;\n  }\n  .symbol.symbol-lg-125px.symbol-2by3 > img {\n    height: 125px;\n    width: 187.5px;\n    max-width: none;\n  }\n  .symbol.symbol-lg-150px > img {\n    width: 150px;\n    height: 150px;\n  }\n  .symbol.symbol-lg-150px .symbol-label {\n    width: 150px;\n    height: 150px;\n  }\n  .symbol.symbol-lg-150px.symbol-fixed .symbol-label {\n    width: 150px;\n    height: 150px;\n  }\n  .symbol.symbol-lg-150px.symbol-fixed > img {\n    width: 150px;\n    height: 150px;\n    max-width: none;\n  }\n  .symbol.symbol-lg-150px.symbol-2by3 .symbol-label {\n    height: 150px;\n    width: 225px;\n  }\n  .symbol.symbol-lg-150px.symbol-2by3 > img {\n    height: 150px;\n    width: 225px;\n    max-width: none;\n  }\n  .symbol.symbol-lg-160px > img {\n    width: 160px;\n    height: 160px;\n  }\n  .symbol.symbol-lg-160px .symbol-label {\n    width: 160px;\n    height: 160px;\n  }\n  .symbol.symbol-lg-160px.symbol-fixed .symbol-label {\n    width: 160px;\n    height: 160px;\n  }\n  .symbol.symbol-lg-160px.symbol-fixed > img {\n    width: 160px;\n    height: 160px;\n    max-width: none;\n  }\n  .symbol.symbol-lg-160px.symbol-2by3 .symbol-label {\n    height: 160px;\n    width: 240px;\n  }\n  .symbol.symbol-lg-160px.symbol-2by3 > img {\n    height: 160px;\n    width: 240px;\n    max-width: none;\n  }\n  .symbol.symbol-lg-175px > img {\n    width: 175px;\n    height: 175px;\n  }\n  .symbol.symbol-lg-175px .symbol-label {\n    width: 175px;\n    height: 175px;\n  }\n  .symbol.symbol-lg-175px.symbol-fixed .symbol-label {\n    width: 175px;\n    height: 175px;\n  }\n  .symbol.symbol-lg-175px.symbol-fixed > img {\n    width: 175px;\n    height: 175px;\n    max-width: none;\n  }\n  .symbol.symbol-lg-175px.symbol-2by3 .symbol-label {\n    height: 175px;\n    width: 262.5px;\n  }\n  .symbol.symbol-lg-175px.symbol-2by3 > img {\n    height: 175px;\n    width: 262.5px;\n    max-width: none;\n  }\n  .symbol.symbol-lg-200px > img {\n    width: 200px;\n    height: 200px;\n  }\n  .symbol.symbol-lg-200px .symbol-label {\n    width: 200px;\n    height: 200px;\n  }\n  .symbol.symbol-lg-200px.symbol-fixed .symbol-label {\n    width: 200px;\n    height: 200px;\n  }\n  .symbol.symbol-lg-200px.symbol-fixed > img {\n    width: 200px;\n    height: 200px;\n    max-width: none;\n  }\n  .symbol.symbol-lg-200px.symbol-2by3 .symbol-label {\n    height: 200px;\n    width: 300px;\n  }\n  .symbol.symbol-lg-200px.symbol-2by3 > img {\n    height: 200px;\n    width: 300px;\n    max-width: none;\n  }\n}\n@media (min-width: 1200px) {\n  .symbol.symbol-xl-20px > img {\n    width: 20px;\n    height: 20px;\n  }\n  .symbol.symbol-xl-20px .symbol-label {\n    width: 20px;\n    height: 20px;\n  }\n  .symbol.symbol-xl-20px.symbol-fixed .symbol-label {\n    width: 20px;\n    height: 20px;\n  }\n  .symbol.symbol-xl-20px.symbol-fixed > img {\n    width: 20px;\n    height: 20px;\n    max-width: none;\n  }\n  .symbol.symbol-xl-20px.symbol-2by3 .symbol-label {\n    height: 20px;\n    width: 30px;\n  }\n  .symbol.symbol-xl-20px.symbol-2by3 > img {\n    height: 20px;\n    width: 30px;\n    max-width: none;\n  }\n  .symbol.symbol-xl-25px > img {\n    width: 25px;\n    height: 25px;\n  }\n  .symbol.symbol-xl-25px .symbol-label {\n    width: 25px;\n    height: 25px;\n  }\n  .symbol.symbol-xl-25px.symbol-fixed .symbol-label {\n    width: 25px;\n    height: 25px;\n  }\n  .symbol.symbol-xl-25px.symbol-fixed > img {\n    width: 25px;\n    height: 25px;\n    max-width: none;\n  }\n  .symbol.symbol-xl-25px.symbol-2by3 .symbol-label {\n    height: 25px;\n    width: 37.5px;\n  }\n  .symbol.symbol-xl-25px.symbol-2by3 > img {\n    height: 25px;\n    width: 37.5px;\n    max-width: none;\n  }\n  .symbol.symbol-xl-30px > img {\n    width: 30px;\n    height: 30px;\n  }\n  .symbol.symbol-xl-30px .symbol-label {\n    width: 30px;\n    height: 30px;\n  }\n  .symbol.symbol-xl-30px.symbol-fixed .symbol-label {\n    width: 30px;\n    height: 30px;\n  }\n  .symbol.symbol-xl-30px.symbol-fixed > img {\n    width: 30px;\n    height: 30px;\n    max-width: none;\n  }\n  .symbol.symbol-xl-30px.symbol-2by3 .symbol-label {\n    height: 30px;\n    width: 45px;\n  }\n  .symbol.symbol-xl-30px.symbol-2by3 > img {\n    height: 30px;\n    width: 45px;\n    max-width: none;\n  }\n  .symbol.symbol-xl-35px > img {\n    width: 35px;\n    height: 35px;\n  }\n  .symbol.symbol-xl-35px .symbol-label {\n    width: 35px;\n    height: 35px;\n  }\n  .symbol.symbol-xl-35px.symbol-fixed .symbol-label {\n    width: 35px;\n    height: 35px;\n  }\n  .symbol.symbol-xl-35px.symbol-fixed > img {\n    width: 35px;\n    height: 35px;\n    max-width: none;\n  }\n  .symbol.symbol-xl-35px.symbol-2by3 .symbol-label {\n    height: 35px;\n    width: 52.5px;\n  }\n  .symbol.symbol-xl-35px.symbol-2by3 > img {\n    height: 35px;\n    width: 52.5px;\n    max-width: none;\n  }\n  .symbol.symbol-xl-40px > img {\n    width: 40px;\n    height: 40px;\n  }\n  .symbol.symbol-xl-40px .symbol-label {\n    width: 40px;\n    height: 40px;\n  }\n  .symbol.symbol-xl-40px.symbol-fixed .symbol-label {\n    width: 40px;\n    height: 40px;\n  }\n  .symbol.symbol-xl-40px.symbol-fixed > img {\n    width: 40px;\n    height: 40px;\n    max-width: none;\n  }\n  .symbol.symbol-xl-40px.symbol-2by3 .symbol-label {\n    height: 40px;\n    width: 60px;\n  }\n  .symbol.symbol-xl-40px.symbol-2by3 > img {\n    height: 40px;\n    width: 60px;\n    max-width: none;\n  }\n  .symbol.symbol-xl-45px > img {\n    width: 45px;\n    height: 45px;\n  }\n  .symbol.symbol-xl-45px .symbol-label {\n    width: 45px;\n    height: 45px;\n  }\n  .symbol.symbol-xl-45px.symbol-fixed .symbol-label {\n    width: 45px;\n    height: 45px;\n  }\n  .symbol.symbol-xl-45px.symbol-fixed > img {\n    width: 45px;\n    height: 45px;\n    max-width: none;\n  }\n  .symbol.symbol-xl-45px.symbol-2by3 .symbol-label {\n    height: 45px;\n    width: 67.5px;\n  }\n  .symbol.symbol-xl-45px.symbol-2by3 > img {\n    height: 45px;\n    width: 67.5px;\n    max-width: none;\n  }\n  .symbol.symbol-xl-50px > img {\n    width: 50px;\n    height: 50px;\n  }\n  .symbol.symbol-xl-50px .symbol-label {\n    width: 50px;\n    height: 50px;\n  }\n  .symbol.symbol-xl-50px.symbol-fixed .symbol-label {\n    width: 50px;\n    height: 50px;\n  }\n  .symbol.symbol-xl-50px.symbol-fixed > img {\n    width: 50px;\n    height: 50px;\n    max-width: none;\n  }\n  .symbol.symbol-xl-50px.symbol-2by3 .symbol-label {\n    height: 50px;\n    width: 75px;\n  }\n  .symbol.symbol-xl-50px.symbol-2by3 > img {\n    height: 50px;\n    width: 75px;\n    max-width: none;\n  }\n  .symbol.symbol-xl-55px > img {\n    width: 55px;\n    height: 55px;\n  }\n  .symbol.symbol-xl-55px .symbol-label {\n    width: 55px;\n    height: 55px;\n  }\n  .symbol.symbol-xl-55px.symbol-fixed .symbol-label {\n    width: 55px;\n    height: 55px;\n  }\n  .symbol.symbol-xl-55px.symbol-fixed > img {\n    width: 55px;\n    height: 55px;\n    max-width: none;\n  }\n  .symbol.symbol-xl-55px.symbol-2by3 .symbol-label {\n    height: 55px;\n    width: 82.5px;\n  }\n  .symbol.symbol-xl-55px.symbol-2by3 > img {\n    height: 55px;\n    width: 82.5px;\n    max-width: none;\n  }\n  .symbol.symbol-xl-60px > img {\n    width: 60px;\n    height: 60px;\n  }\n  .symbol.symbol-xl-60px .symbol-label {\n    width: 60px;\n    height: 60px;\n  }\n  .symbol.symbol-xl-60px.symbol-fixed .symbol-label {\n    width: 60px;\n    height: 60px;\n  }\n  .symbol.symbol-xl-60px.symbol-fixed > img {\n    width: 60px;\n    height: 60px;\n    max-width: none;\n  }\n  .symbol.symbol-xl-60px.symbol-2by3 .symbol-label {\n    height: 60px;\n    width: 90px;\n  }\n  .symbol.symbol-xl-60px.symbol-2by3 > img {\n    height: 60px;\n    width: 90px;\n    max-width: none;\n  }\n  .symbol.symbol-xl-65px > img {\n    width: 65px;\n    height: 65px;\n  }\n  .symbol.symbol-xl-65px .symbol-label {\n    width: 65px;\n    height: 65px;\n  }\n  .symbol.symbol-xl-65px.symbol-fixed .symbol-label {\n    width: 65px;\n    height: 65px;\n  }\n  .symbol.symbol-xl-65px.symbol-fixed > img {\n    width: 65px;\n    height: 65px;\n    max-width: none;\n  }\n  .symbol.symbol-xl-65px.symbol-2by3 .symbol-label {\n    height: 65px;\n    width: 97.5px;\n  }\n  .symbol.symbol-xl-65px.symbol-2by3 > img {\n    height: 65px;\n    width: 97.5px;\n    max-width: none;\n  }\n  .symbol.symbol-xl-70px > img {\n    width: 70px;\n    height: 70px;\n  }\n  .symbol.symbol-xl-70px .symbol-label {\n    width: 70px;\n    height: 70px;\n  }\n  .symbol.symbol-xl-70px.symbol-fixed .symbol-label {\n    width: 70px;\n    height: 70px;\n  }\n  .symbol.symbol-xl-70px.symbol-fixed > img {\n    width: 70px;\n    height: 70px;\n    max-width: none;\n  }\n  .symbol.symbol-xl-70px.symbol-2by3 .symbol-label {\n    height: 70px;\n    width: 105px;\n  }\n  .symbol.symbol-xl-70px.symbol-2by3 > img {\n    height: 70px;\n    width: 105px;\n    max-width: none;\n  }\n  .symbol.symbol-xl-75px > img {\n    width: 75px;\n    height: 75px;\n  }\n  .symbol.symbol-xl-75px .symbol-label {\n    width: 75px;\n    height: 75px;\n  }\n  .symbol.symbol-xl-75px.symbol-fixed .symbol-label {\n    width: 75px;\n    height: 75px;\n  }\n  .symbol.symbol-xl-75px.symbol-fixed > img {\n    width: 75px;\n    height: 75px;\n    max-width: none;\n  }\n  .symbol.symbol-xl-75px.symbol-2by3 .symbol-label {\n    height: 75px;\n    width: 112.5px;\n  }\n  .symbol.symbol-xl-75px.symbol-2by3 > img {\n    height: 75px;\n    width: 112.5px;\n    max-width: none;\n  }\n  .symbol.symbol-xl-90px > img {\n    width: 90px;\n    height: 90px;\n  }\n  .symbol.symbol-xl-90px .symbol-label {\n    width: 90px;\n    height: 90px;\n  }\n  .symbol.symbol-xl-90px.symbol-fixed .symbol-label {\n    width: 90px;\n    height: 90px;\n  }\n  .symbol.symbol-xl-90px.symbol-fixed > img {\n    width: 90px;\n    height: 90px;\n    max-width: none;\n  }\n  .symbol.symbol-xl-90px.symbol-2by3 .symbol-label {\n    height: 90px;\n    width: 135px;\n  }\n  .symbol.symbol-xl-90px.symbol-2by3 > img {\n    height: 90px;\n    width: 135px;\n    max-width: none;\n  }\n  .symbol.symbol-xl-100px > img {\n    width: 100px;\n    height: 100px;\n  }\n  .symbol.symbol-xl-100px .symbol-label {\n    width: 100px;\n    height: 100px;\n  }\n  .symbol.symbol-xl-100px.symbol-fixed .symbol-label {\n    width: 100px;\n    height: 100px;\n  }\n  .symbol.symbol-xl-100px.symbol-fixed > img {\n    width: 100px;\n    height: 100px;\n    max-width: none;\n  }\n  .symbol.symbol-xl-100px.symbol-2by3 .symbol-label {\n    height: 100px;\n    width: 150px;\n  }\n  .symbol.symbol-xl-100px.symbol-2by3 > img {\n    height: 100px;\n    width: 150px;\n    max-width: none;\n  }\n  .symbol.symbol-xl-125px > img {\n    width: 125px;\n    height: 125px;\n  }\n  .symbol.symbol-xl-125px .symbol-label {\n    width: 125px;\n    height: 125px;\n  }\n  .symbol.symbol-xl-125px.symbol-fixed .symbol-label {\n    width: 125px;\n    height: 125px;\n  }\n  .symbol.symbol-xl-125px.symbol-fixed > img {\n    width: 125px;\n    height: 125px;\n    max-width: none;\n  }\n  .symbol.symbol-xl-125px.symbol-2by3 .symbol-label {\n    height: 125px;\n    width: 187.5px;\n  }\n  .symbol.symbol-xl-125px.symbol-2by3 > img {\n    height: 125px;\n    width: 187.5px;\n    max-width: none;\n  }\n  .symbol.symbol-xl-150px > img {\n    width: 150px;\n    height: 150px;\n  }\n  .symbol.symbol-xl-150px .symbol-label {\n    width: 150px;\n    height: 150px;\n  }\n  .symbol.symbol-xl-150px.symbol-fixed .symbol-label {\n    width: 150px;\n    height: 150px;\n  }\n  .symbol.symbol-xl-150px.symbol-fixed > img {\n    width: 150px;\n    height: 150px;\n    max-width: none;\n  }\n  .symbol.symbol-xl-150px.symbol-2by3 .symbol-label {\n    height: 150px;\n    width: 225px;\n  }\n  .symbol.symbol-xl-150px.symbol-2by3 > img {\n    height: 150px;\n    width: 225px;\n    max-width: none;\n  }\n  .symbol.symbol-xl-160px > img {\n    width: 160px;\n    height: 160px;\n  }\n  .symbol.symbol-xl-160px .symbol-label {\n    width: 160px;\n    height: 160px;\n  }\n  .symbol.symbol-xl-160px.symbol-fixed .symbol-label {\n    width: 160px;\n    height: 160px;\n  }\n  .symbol.symbol-xl-160px.symbol-fixed > img {\n    width: 160px;\n    height: 160px;\n    max-width: none;\n  }\n  .symbol.symbol-xl-160px.symbol-2by3 .symbol-label {\n    height: 160px;\n    width: 240px;\n  }\n  .symbol.symbol-xl-160px.symbol-2by3 > img {\n    height: 160px;\n    width: 240px;\n    max-width: none;\n  }\n  .symbol.symbol-xl-175px > img {\n    width: 175px;\n    height: 175px;\n  }\n  .symbol.symbol-xl-175px .symbol-label {\n    width: 175px;\n    height: 175px;\n  }\n  .symbol.symbol-xl-175px.symbol-fixed .symbol-label {\n    width: 175px;\n    height: 175px;\n  }\n  .symbol.symbol-xl-175px.symbol-fixed > img {\n    width: 175px;\n    height: 175px;\n    max-width: none;\n  }\n  .symbol.symbol-xl-175px.symbol-2by3 .symbol-label {\n    height: 175px;\n    width: 262.5px;\n  }\n  .symbol.symbol-xl-175px.symbol-2by3 > img {\n    height: 175px;\n    width: 262.5px;\n    max-width: none;\n  }\n  .symbol.symbol-xl-200px > img {\n    width: 200px;\n    height: 200px;\n  }\n  .symbol.symbol-xl-200px .symbol-label {\n    width: 200px;\n    height: 200px;\n  }\n  .symbol.symbol-xl-200px.symbol-fixed .symbol-label {\n    width: 200px;\n    height: 200px;\n  }\n  .symbol.symbol-xl-200px.symbol-fixed > img {\n    width: 200px;\n    height: 200px;\n    max-width: none;\n  }\n  .symbol.symbol-xl-200px.symbol-2by3 .symbol-label {\n    height: 200px;\n    width: 300px;\n  }\n  .symbol.symbol-xl-200px.symbol-2by3 > img {\n    height: 200px;\n    width: 300px;\n    max-width: none;\n  }\n}\n@media (min-width: 1400px) {\n  .symbol.symbol-xxl-20px > img {\n    width: 20px;\n    height: 20px;\n  }\n  .symbol.symbol-xxl-20px .symbol-label {\n    width: 20px;\n    height: 20px;\n  }\n  .symbol.symbol-xxl-20px.symbol-fixed .symbol-label {\n    width: 20px;\n    height: 20px;\n  }\n  .symbol.symbol-xxl-20px.symbol-fixed > img {\n    width: 20px;\n    height: 20px;\n    max-width: none;\n  }\n  .symbol.symbol-xxl-20px.symbol-2by3 .symbol-label {\n    height: 20px;\n    width: 30px;\n  }\n  .symbol.symbol-xxl-20px.symbol-2by3 > img {\n    height: 20px;\n    width: 30px;\n    max-width: none;\n  }\n  .symbol.symbol-xxl-25px > img {\n    width: 25px;\n    height: 25px;\n  }\n  .symbol.symbol-xxl-25px .symbol-label {\n    width: 25px;\n    height: 25px;\n  }\n  .symbol.symbol-xxl-25px.symbol-fixed .symbol-label {\n    width: 25px;\n    height: 25px;\n  }\n  .symbol.symbol-xxl-25px.symbol-fixed > img {\n    width: 25px;\n    height: 25px;\n    max-width: none;\n  }\n  .symbol.symbol-xxl-25px.symbol-2by3 .symbol-label {\n    height: 25px;\n    width: 37.5px;\n  }\n  .symbol.symbol-xxl-25px.symbol-2by3 > img {\n    height: 25px;\n    width: 37.5px;\n    max-width: none;\n  }\n  .symbol.symbol-xxl-30px > img {\n    width: 30px;\n    height: 30px;\n  }\n  .symbol.symbol-xxl-30px .symbol-label {\n    width: 30px;\n    height: 30px;\n  }\n  .symbol.symbol-xxl-30px.symbol-fixed .symbol-label {\n    width: 30px;\n    height: 30px;\n  }\n  .symbol.symbol-xxl-30px.symbol-fixed > img {\n    width: 30px;\n    height: 30px;\n    max-width: none;\n  }\n  .symbol.symbol-xxl-30px.symbol-2by3 .symbol-label {\n    height: 30px;\n    width: 45px;\n  }\n  .symbol.symbol-xxl-30px.symbol-2by3 > img {\n    height: 30px;\n    width: 45px;\n    max-width: none;\n  }\n  .symbol.symbol-xxl-35px > img {\n    width: 35px;\n    height: 35px;\n  }\n  .symbol.symbol-xxl-35px .symbol-label {\n    width: 35px;\n    height: 35px;\n  }\n  .symbol.symbol-xxl-35px.symbol-fixed .symbol-label {\n    width: 35px;\n    height: 35px;\n  }\n  .symbol.symbol-xxl-35px.symbol-fixed > img {\n    width: 35px;\n    height: 35px;\n    max-width: none;\n  }\n  .symbol.symbol-xxl-35px.symbol-2by3 .symbol-label {\n    height: 35px;\n    width: 52.5px;\n  }\n  .symbol.symbol-xxl-35px.symbol-2by3 > img {\n    height: 35px;\n    width: 52.5px;\n    max-width: none;\n  }\n  .symbol.symbol-xxl-40px > img {\n    width: 40px;\n    height: 40px;\n  }\n  .symbol.symbol-xxl-40px .symbol-label {\n    width: 40px;\n    height: 40px;\n  }\n  .symbol.symbol-xxl-40px.symbol-fixed .symbol-label {\n    width: 40px;\n    height: 40px;\n  }\n  .symbol.symbol-xxl-40px.symbol-fixed > img {\n    width: 40px;\n    height: 40px;\n    max-width: none;\n  }\n  .symbol.symbol-xxl-40px.symbol-2by3 .symbol-label {\n    height: 40px;\n    width: 60px;\n  }\n  .symbol.symbol-xxl-40px.symbol-2by3 > img {\n    height: 40px;\n    width: 60px;\n    max-width: none;\n  }\n  .symbol.symbol-xxl-45px > img {\n    width: 45px;\n    height: 45px;\n  }\n  .symbol.symbol-xxl-45px .symbol-label {\n    width: 45px;\n    height: 45px;\n  }\n  .symbol.symbol-xxl-45px.symbol-fixed .symbol-label {\n    width: 45px;\n    height: 45px;\n  }\n  .symbol.symbol-xxl-45px.symbol-fixed > img {\n    width: 45px;\n    height: 45px;\n    max-width: none;\n  }\n  .symbol.symbol-xxl-45px.symbol-2by3 .symbol-label {\n    height: 45px;\n    width: 67.5px;\n  }\n  .symbol.symbol-xxl-45px.symbol-2by3 > img {\n    height: 45px;\n    width: 67.5px;\n    max-width: none;\n  }\n  .symbol.symbol-xxl-50px > img {\n    width: 50px;\n    height: 50px;\n  }\n  .symbol.symbol-xxl-50px .symbol-label {\n    width: 50px;\n    height: 50px;\n  }\n  .symbol.symbol-xxl-50px.symbol-fixed .symbol-label {\n    width: 50px;\n    height: 50px;\n  }\n  .symbol.symbol-xxl-50px.symbol-fixed > img {\n    width: 50px;\n    height: 50px;\n    max-width: none;\n  }\n  .symbol.symbol-xxl-50px.symbol-2by3 .symbol-label {\n    height: 50px;\n    width: 75px;\n  }\n  .symbol.symbol-xxl-50px.symbol-2by3 > img {\n    height: 50px;\n    width: 75px;\n    max-width: none;\n  }\n  .symbol.symbol-xxl-55px > img {\n    width: 55px;\n    height: 55px;\n  }\n  .symbol.symbol-xxl-55px .symbol-label {\n    width: 55px;\n    height: 55px;\n  }\n  .symbol.symbol-xxl-55px.symbol-fixed .symbol-label {\n    width: 55px;\n    height: 55px;\n  }\n  .symbol.symbol-xxl-55px.symbol-fixed > img {\n    width: 55px;\n    height: 55px;\n    max-width: none;\n  }\n  .symbol.symbol-xxl-55px.symbol-2by3 .symbol-label {\n    height: 55px;\n    width: 82.5px;\n  }\n  .symbol.symbol-xxl-55px.symbol-2by3 > img {\n    height: 55px;\n    width: 82.5px;\n    max-width: none;\n  }\n  .symbol.symbol-xxl-60px > img {\n    width: 60px;\n    height: 60px;\n  }\n  .symbol.symbol-xxl-60px .symbol-label {\n    width: 60px;\n    height: 60px;\n  }\n  .symbol.symbol-xxl-60px.symbol-fixed .symbol-label {\n    width: 60px;\n    height: 60px;\n  }\n  .symbol.symbol-xxl-60px.symbol-fixed > img {\n    width: 60px;\n    height: 60px;\n    max-width: none;\n  }\n  .symbol.symbol-xxl-60px.symbol-2by3 .symbol-label {\n    height: 60px;\n    width: 90px;\n  }\n  .symbol.symbol-xxl-60px.symbol-2by3 > img {\n    height: 60px;\n    width: 90px;\n    max-width: none;\n  }\n  .symbol.symbol-xxl-65px > img {\n    width: 65px;\n    height: 65px;\n  }\n  .symbol.symbol-xxl-65px .symbol-label {\n    width: 65px;\n    height: 65px;\n  }\n  .symbol.symbol-xxl-65px.symbol-fixed .symbol-label {\n    width: 65px;\n    height: 65px;\n  }\n  .symbol.symbol-xxl-65px.symbol-fixed > img {\n    width: 65px;\n    height: 65px;\n    max-width: none;\n  }\n  .symbol.symbol-xxl-65px.symbol-2by3 .symbol-label {\n    height: 65px;\n    width: 97.5px;\n  }\n  .symbol.symbol-xxl-65px.symbol-2by3 > img {\n    height: 65px;\n    width: 97.5px;\n    max-width: none;\n  }\n  .symbol.symbol-xxl-70px > img {\n    width: 70px;\n    height: 70px;\n  }\n  .symbol.symbol-xxl-70px .symbol-label {\n    width: 70px;\n    height: 70px;\n  }\n  .symbol.symbol-xxl-70px.symbol-fixed .symbol-label {\n    width: 70px;\n    height: 70px;\n  }\n  .symbol.symbol-xxl-70px.symbol-fixed > img {\n    width: 70px;\n    height: 70px;\n    max-width: none;\n  }\n  .symbol.symbol-xxl-70px.symbol-2by3 .symbol-label {\n    height: 70px;\n    width: 105px;\n  }\n  .symbol.symbol-xxl-70px.symbol-2by3 > img {\n    height: 70px;\n    width: 105px;\n    max-width: none;\n  }\n  .symbol.symbol-xxl-75px > img {\n    width: 75px;\n    height: 75px;\n  }\n  .symbol.symbol-xxl-75px .symbol-label {\n    width: 75px;\n    height: 75px;\n  }\n  .symbol.symbol-xxl-75px.symbol-fixed .symbol-label {\n    width: 75px;\n    height: 75px;\n  }\n  .symbol.symbol-xxl-75px.symbol-fixed > img {\n    width: 75px;\n    height: 75px;\n    max-width: none;\n  }\n  .symbol.symbol-xxl-75px.symbol-2by3 .symbol-label {\n    height: 75px;\n    width: 112.5px;\n  }\n  .symbol.symbol-xxl-75px.symbol-2by3 > img {\n    height: 75px;\n    width: 112.5px;\n    max-width: none;\n  }\n  .symbol.symbol-xxl-90px > img {\n    width: 90px;\n    height: 90px;\n  }\n  .symbol.symbol-xxl-90px .symbol-label {\n    width: 90px;\n    height: 90px;\n  }\n  .symbol.symbol-xxl-90px.symbol-fixed .symbol-label {\n    width: 90px;\n    height: 90px;\n  }\n  .symbol.symbol-xxl-90px.symbol-fixed > img {\n    width: 90px;\n    height: 90px;\n    max-width: none;\n  }\n  .symbol.symbol-xxl-90px.symbol-2by3 .symbol-label {\n    height: 90px;\n    width: 135px;\n  }\n  .symbol.symbol-xxl-90px.symbol-2by3 > img {\n    height: 90px;\n    width: 135px;\n    max-width: none;\n  }\n  .symbol.symbol-xxl-100px > img {\n    width: 100px;\n    height: 100px;\n  }\n  .symbol.symbol-xxl-100px .symbol-label {\n    width: 100px;\n    height: 100px;\n  }\n  .symbol.symbol-xxl-100px.symbol-fixed .symbol-label {\n    width: 100px;\n    height: 100px;\n  }\n  .symbol.symbol-xxl-100px.symbol-fixed > img {\n    width: 100px;\n    height: 100px;\n    max-width: none;\n  }\n  .symbol.symbol-xxl-100px.symbol-2by3 .symbol-label {\n    height: 100px;\n    width: 150px;\n  }\n  .symbol.symbol-xxl-100px.symbol-2by3 > img {\n    height: 100px;\n    width: 150px;\n    max-width: none;\n  }\n  .symbol.symbol-xxl-125px > img {\n    width: 125px;\n    height: 125px;\n  }\n  .symbol.symbol-xxl-125px .symbol-label {\n    width: 125px;\n    height: 125px;\n  }\n  .symbol.symbol-xxl-125px.symbol-fixed .symbol-label {\n    width: 125px;\n    height: 125px;\n  }\n  .symbol.symbol-xxl-125px.symbol-fixed > img {\n    width: 125px;\n    height: 125px;\n    max-width: none;\n  }\n  .symbol.symbol-xxl-125px.symbol-2by3 .symbol-label {\n    height: 125px;\n    width: 187.5px;\n  }\n  .symbol.symbol-xxl-125px.symbol-2by3 > img {\n    height: 125px;\n    width: 187.5px;\n    max-width: none;\n  }\n  .symbol.symbol-xxl-150px > img {\n    width: 150px;\n    height: 150px;\n  }\n  .symbol.symbol-xxl-150px .symbol-label {\n    width: 150px;\n    height: 150px;\n  }\n  .symbol.symbol-xxl-150px.symbol-fixed .symbol-label {\n    width: 150px;\n    height: 150px;\n  }\n  .symbol.symbol-xxl-150px.symbol-fixed > img {\n    width: 150px;\n    height: 150px;\n    max-width: none;\n  }\n  .symbol.symbol-xxl-150px.symbol-2by3 .symbol-label {\n    height: 150px;\n    width: 225px;\n  }\n  .symbol.symbol-xxl-150px.symbol-2by3 > img {\n    height: 150px;\n    width: 225px;\n    max-width: none;\n  }\n  .symbol.symbol-xxl-160px > img {\n    width: 160px;\n    height: 160px;\n  }\n  .symbol.symbol-xxl-160px .symbol-label {\n    width: 160px;\n    height: 160px;\n  }\n  .symbol.symbol-xxl-160px.symbol-fixed .symbol-label {\n    width: 160px;\n    height: 160px;\n  }\n  .symbol.symbol-xxl-160px.symbol-fixed > img {\n    width: 160px;\n    height: 160px;\n    max-width: none;\n  }\n  .symbol.symbol-xxl-160px.symbol-2by3 .symbol-label {\n    height: 160px;\n    width: 240px;\n  }\n  .symbol.symbol-xxl-160px.symbol-2by3 > img {\n    height: 160px;\n    width: 240px;\n    max-width: none;\n  }\n  .symbol.symbol-xxl-175px > img {\n    width: 175px;\n    height: 175px;\n  }\n  .symbol.symbol-xxl-175px .symbol-label {\n    width: 175px;\n    height: 175px;\n  }\n  .symbol.symbol-xxl-175px.symbol-fixed .symbol-label {\n    width: 175px;\n    height: 175px;\n  }\n  .symbol.symbol-xxl-175px.symbol-fixed > img {\n    width: 175px;\n    height: 175px;\n    max-width: none;\n  }\n  .symbol.symbol-xxl-175px.symbol-2by3 .symbol-label {\n    height: 175px;\n    width: 262.5px;\n  }\n  .symbol.symbol-xxl-175px.symbol-2by3 > img {\n    height: 175px;\n    width: 262.5px;\n    max-width: none;\n  }\n  .symbol.symbol-xxl-200px > img {\n    width: 200px;\n    height: 200px;\n  }\n  .symbol.symbol-xxl-200px .symbol-label {\n    width: 200px;\n    height: 200px;\n  }\n  .symbol.symbol-xxl-200px.symbol-fixed .symbol-label {\n    width: 200px;\n    height: 200px;\n  }\n  .symbol.symbol-xxl-200px.symbol-fixed > img {\n    width: 200px;\n    height: 200px;\n    max-width: none;\n  }\n  .symbol.symbol-xxl-200px.symbol-2by3 .symbol-label {\n    height: 200px;\n    width: 300px;\n  }\n  .symbol.symbol-xxl-200px.symbol-2by3 > img {\n    height: 200px;\n    width: 300px;\n    max-width: none;\n  }\n}\n\n.symbol-group {\n  display: flex;\n  flex-wrap: wrap;\n  align-items: center;\n  margin-left: 10px;\n}\n.symbol-group .symbol {\n  position: relative;\n  z-index: 0;\n  margin-left: -10px;\n  transition: all 0.3s ease;\n}\n.symbol-group .symbol:hover {\n  transition: all 0.3s ease;\n  z-index: 1;\n}\n.symbol-group .symbol-badge {\n  border: 2px solid var(--bs-body-bg);\n}\n.symbol-group .symbol-label {\n  position: relative;\n}\n.symbol-group .symbol-label:after {\n  display: block;\n  content: \" \";\n  border-radius: inherit;\n  position: absolute;\n  top: 0;\n  right: 0;\n  left: 0;\n  bottom: 0;\n  border: 2px solid var(--bs-symbol-border-color);\n  -webkit-background-clip: padding-box; /* for Safari */\n  background-clip: padding-box; /* for IE9+, Firefox 4+, Opera, Chrome */\n}\n.symbol-group.symbol-hover .symbol {\n  cursor: pointer;\n}\n\n.pulse {\n  position: relative;\n}\n.pulse.pulse-light .pulse-ring {\n  border-color: var(--bs-light);\n}\n.pulse.pulse-primary .pulse-ring {\n  border-color: var(--bs-primary);\n}\n.pulse.pulse-secondary .pulse-ring {\n  border-color: var(--bs-secondary);\n}\n.pulse.pulse-success .pulse-ring {\n  border-color: var(--bs-success);\n}\n.pulse.pulse-info .pulse-ring {\n  border-color: var(--bs-info);\n}\n.pulse.pulse-warning .pulse-ring {\n  border-color: var(--bs-warning);\n}\n.pulse.pulse-danger .pulse-ring {\n  border-color: var(--bs-danger);\n}\n.pulse.pulse-dark .pulse-ring {\n  border-color: var(--bs-dark);\n}\n\n.pulse-ring {\n  display: block;\n  border-radius: 40px;\n  height: 40px;\n  width: 40px;\n  position: absolute;\n  animation: animation-pulse 3.5s ease-out;\n  animation-iteration-count: infinite;\n  opacity: 0;\n  border-width: 3px;\n  border-style: solid;\n  border-color: var(--bs-gray-500);\n}\n\n@keyframes animation-pulse {\n  0% {\n    -webkit-transform: scale(0.1, 0.1);\n    opacity: 0;\n  }\n  60% {\n    -webkit-transform: scale(0.1, 0.1);\n    opacity: 0;\n  }\n  65% {\n    opacity: 1;\n  }\n  100% {\n    -webkit-transform: scale(1.2, 1.2);\n    opacity: 0;\n  }\n}\n[data-kt-app-page-loading=on] *,\n.page-loading * {\n  transition: none !important;\n}\n\n.page-loader {\n  background-color: var(--bs-body-bg);\n  position: fixed;\n  top: 0;\n  bottom: 0;\n  left: 0;\n  right: 0;\n  z-index: 10000;\n  display: none;\n}\n[data-kt-app-page-loading=on] .page-loader, .page-loading .page-loader {\n  display: flex;\n  justify-content: center;\n  align-items: center;\n}\n\n.scrolltop {\n  position: fixed;\n  display: none;\n  cursor: pointer;\n  z-index: 105;\n  justify-content: center;\n  align-items: center;\n  width: 36px;\n  height: 36px;\n  bottom: 43px;\n  right: 7px;\n  background-color: var(--bs-scrolltop-bg-color);\n  box-shadow: var(--bs-scrolltop-box-shadow);\n  opacity: 0;\n  transition: color 0.2s ease;\n  border-radius: 0.475rem;\n}\n.scrolltop .svg-icon {\n  color: var(--bs-scrolltop-icon-color);\n}\n.scrolltop .svg-icon svg {\n  height: 24px;\n  width: 24px;\n}\n.scrolltop > i {\n  font-size: 1.3rem;\n  color: var(--bs-scrolltop-icon-color);\n}\n.scrolltop:hover {\n  background-color: var(--bs-scrolltop-bg-color-hover);\n}\n.scrolltop:hover .svg-icon,\n.scrolltop:hover i {\n  color: var(--bs-scrolltop-icon-color-hover);\n}\n[data-kt-scrolltop=on] .scrolltop {\n  opacity: var(--bs-scrolltop-opacity-on);\n  animation: animation-scrolltop 0.4s ease-out 1;\n  display: flex;\n}\n[data-kt-scrolltop=on] .scrolltop:hover {\n  transition: color 0.2s ease;\n  opacity: var(--bs-scrolltop-opacity-hover);\n}\n\n@media (max-width: 991.98px) {\n  .scrolltop {\n    bottom: 23px;\n    right: 5px;\n    width: 30px;\n    height: 30px;\n  }\n}\n@keyframes animation-scrolltop {\n  from {\n    margin-bottom: -15px;\n  }\n  to {\n    margin-bottom: 0;\n  }\n}\n.svg-icon {\n  line-height: 1;\n  color: var(--bs-text-muted);\n}\n.svg-icon svg {\n  height: 1.15rem;\n  width: 1.15rem;\n}\n.svg-icon.svg-icon-white {\n  color: var(--bs-text-white);\n}\n.svg-icon.svg-icon-primary {\n  color: var(--bs-text-primary);\n}\n.svg-icon.svg-icon-secondary {\n  color: var(--bs-text-secondary);\n}\n.svg-icon.svg-icon-light {\n  color: var(--bs-text-light);\n}\n.svg-icon.svg-icon-success {\n  color: var(--bs-text-success);\n}\n.svg-icon.svg-icon-info {\n  color: var(--bs-text-info);\n}\n.svg-icon.svg-icon-warning {\n  color: var(--bs-text-warning);\n}\n.svg-icon.svg-icon-danger {\n  color: var(--bs-text-danger);\n}\n.svg-icon.svg-icon-dark {\n  color: var(--bs-text-dark);\n}\n.svg-icon.svg-icon-muted {\n  color: var(--bs-text-muted);\n}\n.svg-icon.svg-icon-gray-100 {\n  color: var(--bs-text-gray-100);\n}\n.svg-icon.svg-icon-gray-200 {\n  color: var(--bs-text-gray-200);\n}\n.svg-icon.svg-icon-gray-300 {\n  color: var(--bs-text-gray-300);\n}\n.svg-icon.svg-icon-gray-400 {\n  color: var(--bs-text-gray-400);\n}\n.svg-icon.svg-icon-gray-500 {\n  color: var(--bs-text-gray-500);\n}\n.svg-icon.svg-icon-gray-600 {\n  color: var(--bs-text-gray-600);\n}\n.svg-icon.svg-icon-gray-700 {\n  color: var(--bs-text-gray-700);\n}\n.svg-icon.svg-icon-gray-800 {\n  color: var(--bs-text-gray-800);\n}\n.svg-icon.svg-icon-gray-900 {\n  color: var(--bs-text-gray-900);\n}\n.svg-icon.svg-icon-1 svg {\n  height: 1.75rem !important;\n  width: 1.75rem !important;\n}\n.svg-icon.svg-icon-2 svg {\n  height: 1.5rem !important;\n  width: 1.5rem !important;\n}\n.svg-icon.svg-icon-3 svg {\n  height: 1.35rem !important;\n  width: 1.35rem !important;\n}\n.svg-icon.svg-icon-4 svg {\n  height: 1.25rem !important;\n  width: 1.25rem !important;\n}\n.svg-icon.svg-icon-5 svg {\n  height: 1.15rem !important;\n  width: 1.15rem !important;\n}\n.svg-icon.svg-icon-6 svg {\n  height: 1.075rem !important;\n  width: 1.075rem !important;\n}\n.svg-icon.svg-icon-7 svg {\n  height: 0.95rem !important;\n  width: 0.95rem !important;\n}\n.svg-icon.svg-icon-8 svg {\n  height: 0.85rem !important;\n  width: 0.85rem !important;\n}\n.svg-icon.svg-icon-9 svg {\n  height: 0.75rem !important;\n  width: 0.75rem !important;\n}\n.svg-icon.svg-icon-10 svg {\n  height: 0.5rem !important;\n  width: 0.5rem !important;\n}\n.svg-icon.svg-icon-base svg {\n  height: 1rem !important;\n  width: 1rem !important;\n}\n.svg-icon.svg-icon-fluid svg {\n  height: 100% !important;\n  width: 100% !important;\n}\n.svg-icon.svg-icon-2x svg {\n  height: 2rem !important;\n  width: 2rem !important;\n}\n.svg-icon.svg-icon-2qx svg {\n  height: 2.25rem !important;\n  width: 2.25rem !important;\n}\n.svg-icon.svg-icon-2hx svg {\n  height: 2.5rem !important;\n  width: 2.5rem !important;\n}\n.svg-icon.svg-icon-2tx svg {\n  height: 2.75rem !important;\n  width: 2.75rem !important;\n}\n.svg-icon.svg-icon-3x svg {\n  height: 3rem !important;\n  width: 3rem !important;\n}\n.svg-icon.svg-icon-3qx svg {\n  height: 3.25rem !important;\n  width: 3.25rem !important;\n}\n.svg-icon.svg-icon-3hx svg {\n  height: 3.5rem !important;\n  width: 3.5rem !important;\n}\n.svg-icon.svg-icon-3tx svg {\n  height: 3.75rem !important;\n  width: 3.75rem !important;\n}\n.svg-icon.svg-icon-4x svg {\n  height: 4rem !important;\n  width: 4rem !important;\n}\n.svg-icon.svg-icon-4qx svg {\n  height: 4.25rem !important;\n  width: 4.25rem !important;\n}\n.svg-icon.svg-icon-4hx svg {\n  height: 4.5rem !important;\n  width: 4.5rem !important;\n}\n.svg-icon.svg-icon-4tx svg {\n  height: 4.75rem !important;\n  width: 4.75rem !important;\n}\n.svg-icon.svg-icon-5x svg {\n  height: 5rem !important;\n  width: 5rem !important;\n}\n.svg-icon.svg-icon-5qx svg {\n  height: 5.25rem !important;\n  width: 5.25rem !important;\n}\n.svg-icon.svg-icon-5hx svg {\n  height: 5.5rem !important;\n  width: 5.5rem !important;\n}\n.svg-icon.svg-icon-5tx svg {\n  height: 5.75rem !important;\n  width: 5.75rem !important;\n}\n.svg-icon.svg-icon-6x svg {\n  height: 6rem !important;\n  width: 6rem !important;\n}\n.svg-icon.svg-icon-6qx svg {\n  height: 6.25rem !important;\n  width: 6.25rem !important;\n}\n.svg-icon.svg-icon-6hx svg {\n  height: 6.5rem !important;\n  width: 6.5rem !important;\n}\n.svg-icon.svg-icon-6tx svg {\n  height: 6.75rem !important;\n  width: 6.75rem !important;\n}\n.svg-icon.svg-icon-7x svg {\n  height: 7rem !important;\n  width: 7rem !important;\n}\n.svg-icon.svg-icon-7qx svg {\n  height: 7.25rem !important;\n  width: 7.25rem !important;\n}\n.svg-icon.svg-icon-7hx svg {\n  height: 7.5rem !important;\n  width: 7.5rem !important;\n}\n.svg-icon.svg-icon-7tx svg {\n  height: 7.75rem !important;\n  width: 7.75rem !important;\n}\n@media (min-width: 576px) {\n  .svg-icon.svg-icon-sm-1 svg {\n    height: 1.75rem !important;\n    width: 1.75rem !important;\n  }\n  .svg-icon.svg-icon-sm-2 svg {\n    height: 1.5rem !important;\n    width: 1.5rem !important;\n  }\n  .svg-icon.svg-icon-sm-3 svg {\n    height: 1.35rem !important;\n    width: 1.35rem !important;\n  }\n  .svg-icon.svg-icon-sm-4 svg {\n    height: 1.25rem !important;\n    width: 1.25rem !important;\n  }\n  .svg-icon.svg-icon-sm-5 svg {\n    height: 1.15rem !important;\n    width: 1.15rem !important;\n  }\n  .svg-icon.svg-icon-sm-6 svg {\n    height: 1.075rem !important;\n    width: 1.075rem !important;\n  }\n  .svg-icon.svg-icon-sm-7 svg {\n    height: 0.95rem !important;\n    width: 0.95rem !important;\n  }\n  .svg-icon.svg-icon-sm-8 svg {\n    height: 0.85rem !important;\n    width: 0.85rem !important;\n  }\n  .svg-icon.svg-icon-sm-9 svg {\n    height: 0.75rem !important;\n    width: 0.75rem !important;\n  }\n  .svg-icon.svg-icon-sm-10 svg {\n    height: 0.5rem !important;\n    width: 0.5rem !important;\n  }\n  .svg-icon.svg-icon-sm-base svg {\n    height: 1rem !important;\n    width: 1rem !important;\n  }\n  .svg-icon.svg-icon-sm-fluid svg {\n    height: 100% !important;\n    width: 100% !important;\n  }\n  .svg-icon.svg-icon-sm-2x svg {\n    height: 2rem !important;\n    width: 2rem !important;\n  }\n  .svg-icon.svg-icon-sm-2qx svg {\n    height: 2.25rem !important;\n    width: 2.25rem !important;\n  }\n  .svg-icon.svg-icon-sm-2hx svg {\n    height: 2.5rem !important;\n    width: 2.5rem !important;\n  }\n  .svg-icon.svg-icon-sm-2tx svg {\n    height: 2.75rem !important;\n    width: 2.75rem !important;\n  }\n  .svg-icon.svg-icon-sm-3x svg {\n    height: 3rem !important;\n    width: 3rem !important;\n  }\n  .svg-icon.svg-icon-sm-3qx svg {\n    height: 3.25rem !important;\n    width: 3.25rem !important;\n  }\n  .svg-icon.svg-icon-sm-3hx svg {\n    height: 3.5rem !important;\n    width: 3.5rem !important;\n  }\n  .svg-icon.svg-icon-sm-3tx svg {\n    height: 3.75rem !important;\n    width: 3.75rem !important;\n  }\n  .svg-icon.svg-icon-sm-4x svg {\n    height: 4rem !important;\n    width: 4rem !important;\n  }\n  .svg-icon.svg-icon-sm-4qx svg {\n    height: 4.25rem !important;\n    width: 4.25rem !important;\n  }\n  .svg-icon.svg-icon-sm-4hx svg {\n    height: 4.5rem !important;\n    width: 4.5rem !important;\n  }\n  .svg-icon.svg-icon-sm-4tx svg {\n    height: 4.75rem !important;\n    width: 4.75rem !important;\n  }\n  .svg-icon.svg-icon-sm-5x svg {\n    height: 5rem !important;\n    width: 5rem !important;\n  }\n  .svg-icon.svg-icon-sm-5qx svg {\n    height: 5.25rem !important;\n    width: 5.25rem !important;\n  }\n  .svg-icon.svg-icon-sm-5hx svg {\n    height: 5.5rem !important;\n    width: 5.5rem !important;\n  }\n  .svg-icon.svg-icon-sm-5tx svg {\n    height: 5.75rem !important;\n    width: 5.75rem !important;\n  }\n  .svg-icon.svg-icon-sm-6x svg {\n    height: 6rem !important;\n    width: 6rem !important;\n  }\n  .svg-icon.svg-icon-sm-6qx svg {\n    height: 6.25rem !important;\n    width: 6.25rem !important;\n  }\n  .svg-icon.svg-icon-sm-6hx svg {\n    height: 6.5rem !important;\n    width: 6.5rem !important;\n  }\n  .svg-icon.svg-icon-sm-6tx svg {\n    height: 6.75rem !important;\n    width: 6.75rem !important;\n  }\n  .svg-icon.svg-icon-sm-7x svg {\n    height: 7rem !important;\n    width: 7rem !important;\n  }\n  .svg-icon.svg-icon-sm-7qx svg {\n    height: 7.25rem !important;\n    width: 7.25rem !important;\n  }\n  .svg-icon.svg-icon-sm-7hx svg {\n    height: 7.5rem !important;\n    width: 7.5rem !important;\n  }\n  .svg-icon.svg-icon-sm-7tx svg {\n    height: 7.75rem !important;\n    width: 7.75rem !important;\n  }\n}\n@media (min-width: 768px) {\n  .svg-icon.svg-icon-md-1 svg {\n    height: 1.75rem !important;\n    width: 1.75rem !important;\n  }\n  .svg-icon.svg-icon-md-2 svg {\n    height: 1.5rem !important;\n    width: 1.5rem !important;\n  }\n  .svg-icon.svg-icon-md-3 svg {\n    height: 1.35rem !important;\n    width: 1.35rem !important;\n  }\n  .svg-icon.svg-icon-md-4 svg {\n    height: 1.25rem !important;\n    width: 1.25rem !important;\n  }\n  .svg-icon.svg-icon-md-5 svg {\n    height: 1.15rem !important;\n    width: 1.15rem !important;\n  }\n  .svg-icon.svg-icon-md-6 svg {\n    height: 1.075rem !important;\n    width: 1.075rem !important;\n  }\n  .svg-icon.svg-icon-md-7 svg {\n    height: 0.95rem !important;\n    width: 0.95rem !important;\n  }\n  .svg-icon.svg-icon-md-8 svg {\n    height: 0.85rem !important;\n    width: 0.85rem !important;\n  }\n  .svg-icon.svg-icon-md-9 svg {\n    height: 0.75rem !important;\n    width: 0.75rem !important;\n  }\n  .svg-icon.svg-icon-md-10 svg {\n    height: 0.5rem !important;\n    width: 0.5rem !important;\n  }\n  .svg-icon.svg-icon-md-base svg {\n    height: 1rem !important;\n    width: 1rem !important;\n  }\n  .svg-icon.svg-icon-md-fluid svg {\n    height: 100% !important;\n    width: 100% !important;\n  }\n  .svg-icon.svg-icon-md-2x svg {\n    height: 2rem !important;\n    width: 2rem !important;\n  }\n  .svg-icon.svg-icon-md-2qx svg {\n    height: 2.25rem !important;\n    width: 2.25rem !important;\n  }\n  .svg-icon.svg-icon-md-2hx svg {\n    height: 2.5rem !important;\n    width: 2.5rem !important;\n  }\n  .svg-icon.svg-icon-md-2tx svg {\n    height: 2.75rem !important;\n    width: 2.75rem !important;\n  }\n  .svg-icon.svg-icon-md-3x svg {\n    height: 3rem !important;\n    width: 3rem !important;\n  }\n  .svg-icon.svg-icon-md-3qx svg {\n    height: 3.25rem !important;\n    width: 3.25rem !important;\n  }\n  .svg-icon.svg-icon-md-3hx svg {\n    height: 3.5rem !important;\n    width: 3.5rem !important;\n  }\n  .svg-icon.svg-icon-md-3tx svg {\n    height: 3.75rem !important;\n    width: 3.75rem !important;\n  }\n  .svg-icon.svg-icon-md-4x svg {\n    height: 4rem !important;\n    width: 4rem !important;\n  }\n  .svg-icon.svg-icon-md-4qx svg {\n    height: 4.25rem !important;\n    width: 4.25rem !important;\n  }\n  .svg-icon.svg-icon-md-4hx svg {\n    height: 4.5rem !important;\n    width: 4.5rem !important;\n  }\n  .svg-icon.svg-icon-md-4tx svg {\n    height: 4.75rem !important;\n    width: 4.75rem !important;\n  }\n  .svg-icon.svg-icon-md-5x svg {\n    height: 5rem !important;\n    width: 5rem !important;\n  }\n  .svg-icon.svg-icon-md-5qx svg {\n    height: 5.25rem !important;\n    width: 5.25rem !important;\n  }\n  .svg-icon.svg-icon-md-5hx svg {\n    height: 5.5rem !important;\n    width: 5.5rem !important;\n  }\n  .svg-icon.svg-icon-md-5tx svg {\n    height: 5.75rem !important;\n    width: 5.75rem !important;\n  }\n  .svg-icon.svg-icon-md-6x svg {\n    height: 6rem !important;\n    width: 6rem !important;\n  }\n  .svg-icon.svg-icon-md-6qx svg {\n    height: 6.25rem !important;\n    width: 6.25rem !important;\n  }\n  .svg-icon.svg-icon-md-6hx svg {\n    height: 6.5rem !important;\n    width: 6.5rem !important;\n  }\n  .svg-icon.svg-icon-md-6tx svg {\n    height: 6.75rem !important;\n    width: 6.75rem !important;\n  }\n  .svg-icon.svg-icon-md-7x svg {\n    height: 7rem !important;\n    width: 7rem !important;\n  }\n  .svg-icon.svg-icon-md-7qx svg {\n    height: 7.25rem !important;\n    width: 7.25rem !important;\n  }\n  .svg-icon.svg-icon-md-7hx svg {\n    height: 7.5rem !important;\n    width: 7.5rem !important;\n  }\n  .svg-icon.svg-icon-md-7tx svg {\n    height: 7.75rem !important;\n    width: 7.75rem !important;\n  }\n}\n@media (min-width: 992px) {\n  .svg-icon.svg-icon-lg-1 svg {\n    height: 1.75rem !important;\n    width: 1.75rem !important;\n  }\n  .svg-icon.svg-icon-lg-2 svg {\n    height: 1.5rem !important;\n    width: 1.5rem !important;\n  }\n  .svg-icon.svg-icon-lg-3 svg {\n    height: 1.35rem !important;\n    width: 1.35rem !important;\n  }\n  .svg-icon.svg-icon-lg-4 svg {\n    height: 1.25rem !important;\n    width: 1.25rem !important;\n  }\n  .svg-icon.svg-icon-lg-5 svg {\n    height: 1.15rem !important;\n    width: 1.15rem !important;\n  }\n  .svg-icon.svg-icon-lg-6 svg {\n    height: 1.075rem !important;\n    width: 1.075rem !important;\n  }\n  .svg-icon.svg-icon-lg-7 svg {\n    height: 0.95rem !important;\n    width: 0.95rem !important;\n  }\n  .svg-icon.svg-icon-lg-8 svg {\n    height: 0.85rem !important;\n    width: 0.85rem !important;\n  }\n  .svg-icon.svg-icon-lg-9 svg {\n    height: 0.75rem !important;\n    width: 0.75rem !important;\n  }\n  .svg-icon.svg-icon-lg-10 svg {\n    height: 0.5rem !important;\n    width: 0.5rem !important;\n  }\n  .svg-icon.svg-icon-lg-base svg {\n    height: 1rem !important;\n    width: 1rem !important;\n  }\n  .svg-icon.svg-icon-lg-fluid svg {\n    height: 100% !important;\n    width: 100% !important;\n  }\n  .svg-icon.svg-icon-lg-2x svg {\n    height: 2rem !important;\n    width: 2rem !important;\n  }\n  .svg-icon.svg-icon-lg-2qx svg {\n    height: 2.25rem !important;\n    width: 2.25rem !important;\n  }\n  .svg-icon.svg-icon-lg-2hx svg {\n    height: 2.5rem !important;\n    width: 2.5rem !important;\n  }\n  .svg-icon.svg-icon-lg-2tx svg {\n    height: 2.75rem !important;\n    width: 2.75rem !important;\n  }\n  .svg-icon.svg-icon-lg-3x svg {\n    height: 3rem !important;\n    width: 3rem !important;\n  }\n  .svg-icon.svg-icon-lg-3qx svg {\n    height: 3.25rem !important;\n    width: 3.25rem !important;\n  }\n  .svg-icon.svg-icon-lg-3hx svg {\n    height: 3.5rem !important;\n    width: 3.5rem !important;\n  }\n  .svg-icon.svg-icon-lg-3tx svg {\n    height: 3.75rem !important;\n    width: 3.75rem !important;\n  }\n  .svg-icon.svg-icon-lg-4x svg {\n    height: 4rem !important;\n    width: 4rem !important;\n  }\n  .svg-icon.svg-icon-lg-4qx svg {\n    height: 4.25rem !important;\n    width: 4.25rem !important;\n  }\n  .svg-icon.svg-icon-lg-4hx svg {\n    height: 4.5rem !important;\n    width: 4.5rem !important;\n  }\n  .svg-icon.svg-icon-lg-4tx svg {\n    height: 4.75rem !important;\n    width: 4.75rem !important;\n  }\n  .svg-icon.svg-icon-lg-5x svg {\n    height: 5rem !important;\n    width: 5rem !important;\n  }\n  .svg-icon.svg-icon-lg-5qx svg {\n    height: 5.25rem !important;\n    width: 5.25rem !important;\n  }\n  .svg-icon.svg-icon-lg-5hx svg {\n    height: 5.5rem !important;\n    width: 5.5rem !important;\n  }\n  .svg-icon.svg-icon-lg-5tx svg {\n    height: 5.75rem !important;\n    width: 5.75rem !important;\n  }\n  .svg-icon.svg-icon-lg-6x svg {\n    height: 6rem !important;\n    width: 6rem !important;\n  }\n  .svg-icon.svg-icon-lg-6qx svg {\n    height: 6.25rem !important;\n    width: 6.25rem !important;\n  }\n  .svg-icon.svg-icon-lg-6hx svg {\n    height: 6.5rem !important;\n    width: 6.5rem !important;\n  }\n  .svg-icon.svg-icon-lg-6tx svg {\n    height: 6.75rem !important;\n    width: 6.75rem !important;\n  }\n  .svg-icon.svg-icon-lg-7x svg {\n    height: 7rem !important;\n    width: 7rem !important;\n  }\n  .svg-icon.svg-icon-lg-7qx svg {\n    height: 7.25rem !important;\n    width: 7.25rem !important;\n  }\n  .svg-icon.svg-icon-lg-7hx svg {\n    height: 7.5rem !important;\n    width: 7.5rem !important;\n  }\n  .svg-icon.svg-icon-lg-7tx svg {\n    height: 7.75rem !important;\n    width: 7.75rem !important;\n  }\n}\n@media (min-width: 1200px) {\n  .svg-icon.svg-icon-xl-1 svg {\n    height: 1.75rem !important;\n    width: 1.75rem !important;\n  }\n  .svg-icon.svg-icon-xl-2 svg {\n    height: 1.5rem !important;\n    width: 1.5rem !important;\n  }\n  .svg-icon.svg-icon-xl-3 svg {\n    height: 1.35rem !important;\n    width: 1.35rem !important;\n  }\n  .svg-icon.svg-icon-xl-4 svg {\n    height: 1.25rem !important;\n    width: 1.25rem !important;\n  }\n  .svg-icon.svg-icon-xl-5 svg {\n    height: 1.15rem !important;\n    width: 1.15rem !important;\n  }\n  .svg-icon.svg-icon-xl-6 svg {\n    height: 1.075rem !important;\n    width: 1.075rem !important;\n  }\n  .svg-icon.svg-icon-xl-7 svg {\n    height: 0.95rem !important;\n    width: 0.95rem !important;\n  }\n  .svg-icon.svg-icon-xl-8 svg {\n    height: 0.85rem !important;\n    width: 0.85rem !important;\n  }\n  .svg-icon.svg-icon-xl-9 svg {\n    height: 0.75rem !important;\n    width: 0.75rem !important;\n  }\n  .svg-icon.svg-icon-xl-10 svg {\n    height: 0.5rem !important;\n    width: 0.5rem !important;\n  }\n  .svg-icon.svg-icon-xl-base svg {\n    height: 1rem !important;\n    width: 1rem !important;\n  }\n  .svg-icon.svg-icon-xl-fluid svg {\n    height: 100% !important;\n    width: 100% !important;\n  }\n  .svg-icon.svg-icon-xl-2x svg {\n    height: 2rem !important;\n    width: 2rem !important;\n  }\n  .svg-icon.svg-icon-xl-2qx svg {\n    height: 2.25rem !important;\n    width: 2.25rem !important;\n  }\n  .svg-icon.svg-icon-xl-2hx svg {\n    height: 2.5rem !important;\n    width: 2.5rem !important;\n  }\n  .svg-icon.svg-icon-xl-2tx svg {\n    height: 2.75rem !important;\n    width: 2.75rem !important;\n  }\n  .svg-icon.svg-icon-xl-3x svg {\n    height: 3rem !important;\n    width: 3rem !important;\n  }\n  .svg-icon.svg-icon-xl-3qx svg {\n    height: 3.25rem !important;\n    width: 3.25rem !important;\n  }\n  .svg-icon.svg-icon-xl-3hx svg {\n    height: 3.5rem !important;\n    width: 3.5rem !important;\n  }\n  .svg-icon.svg-icon-xl-3tx svg {\n    height: 3.75rem !important;\n    width: 3.75rem !important;\n  }\n  .svg-icon.svg-icon-xl-4x svg {\n    height: 4rem !important;\n    width: 4rem !important;\n  }\n  .svg-icon.svg-icon-xl-4qx svg {\n    height: 4.25rem !important;\n    width: 4.25rem !important;\n  }\n  .svg-icon.svg-icon-xl-4hx svg {\n    height: 4.5rem !important;\n    width: 4.5rem !important;\n  }\n  .svg-icon.svg-icon-xl-4tx svg {\n    height: 4.75rem !important;\n    width: 4.75rem !important;\n  }\n  .svg-icon.svg-icon-xl-5x svg {\n    height: 5rem !important;\n    width: 5rem !important;\n  }\n  .svg-icon.svg-icon-xl-5qx svg {\n    height: 5.25rem !important;\n    width: 5.25rem !important;\n  }\n  .svg-icon.svg-icon-xl-5hx svg {\n    height: 5.5rem !important;\n    width: 5.5rem !important;\n  }\n  .svg-icon.svg-icon-xl-5tx svg {\n    height: 5.75rem !important;\n    width: 5.75rem !important;\n  }\n  .svg-icon.svg-icon-xl-6x svg {\n    height: 6rem !important;\n    width: 6rem !important;\n  }\n  .svg-icon.svg-icon-xl-6qx svg {\n    height: 6.25rem !important;\n    width: 6.25rem !important;\n  }\n  .svg-icon.svg-icon-xl-6hx svg {\n    height: 6.5rem !important;\n    width: 6.5rem !important;\n  }\n  .svg-icon.svg-icon-xl-6tx svg {\n    height: 6.75rem !important;\n    width: 6.75rem !important;\n  }\n  .svg-icon.svg-icon-xl-7x svg {\n    height: 7rem !important;\n    width: 7rem !important;\n  }\n  .svg-icon.svg-icon-xl-7qx svg {\n    height: 7.25rem !important;\n    width: 7.25rem !important;\n  }\n  .svg-icon.svg-icon-xl-7hx svg {\n    height: 7.5rem !important;\n    width: 7.5rem !important;\n  }\n  .svg-icon.svg-icon-xl-7tx svg {\n    height: 7.75rem !important;\n    width: 7.75rem !important;\n  }\n}\n@media (min-width: 1400px) {\n  .svg-icon.svg-icon-xxl-1 svg {\n    height: 1.75rem !important;\n    width: 1.75rem !important;\n  }\n  .svg-icon.svg-icon-xxl-2 svg {\n    height: 1.5rem !important;\n    width: 1.5rem !important;\n  }\n  .svg-icon.svg-icon-xxl-3 svg {\n    height: 1.35rem !important;\n    width: 1.35rem !important;\n  }\n  .svg-icon.svg-icon-xxl-4 svg {\n    height: 1.25rem !important;\n    width: 1.25rem !important;\n  }\n  .svg-icon.svg-icon-xxl-5 svg {\n    height: 1.15rem !important;\n    width: 1.15rem !important;\n  }\n  .svg-icon.svg-icon-xxl-6 svg {\n    height: 1.075rem !important;\n    width: 1.075rem !important;\n  }\n  .svg-icon.svg-icon-xxl-7 svg {\n    height: 0.95rem !important;\n    width: 0.95rem !important;\n  }\n  .svg-icon.svg-icon-xxl-8 svg {\n    height: 0.85rem !important;\n    width: 0.85rem !important;\n  }\n  .svg-icon.svg-icon-xxl-9 svg {\n    height: 0.75rem !important;\n    width: 0.75rem !important;\n  }\n  .svg-icon.svg-icon-xxl-10 svg {\n    height: 0.5rem !important;\n    width: 0.5rem !important;\n  }\n  .svg-icon.svg-icon-xxl-base svg {\n    height: 1rem !important;\n    width: 1rem !important;\n  }\n  .svg-icon.svg-icon-xxl-fluid svg {\n    height: 100% !important;\n    width: 100% !important;\n  }\n  .svg-icon.svg-icon-xxl-2x svg {\n    height: 2rem !important;\n    width: 2rem !important;\n  }\n  .svg-icon.svg-icon-xxl-2qx svg {\n    height: 2.25rem !important;\n    width: 2.25rem !important;\n  }\n  .svg-icon.svg-icon-xxl-2hx svg {\n    height: 2.5rem !important;\n    width: 2.5rem !important;\n  }\n  .svg-icon.svg-icon-xxl-2tx svg {\n    height: 2.75rem !important;\n    width: 2.75rem !important;\n  }\n  .svg-icon.svg-icon-xxl-3x svg {\n    height: 3rem !important;\n    width: 3rem !important;\n  }\n  .svg-icon.svg-icon-xxl-3qx svg {\n    height: 3.25rem !important;\n    width: 3.25rem !important;\n  }\n  .svg-icon.svg-icon-xxl-3hx svg {\n    height: 3.5rem !important;\n    width: 3.5rem !important;\n  }\n  .svg-icon.svg-icon-xxl-3tx svg {\n    height: 3.75rem !important;\n    width: 3.75rem !important;\n  }\n  .svg-icon.svg-icon-xxl-4x svg {\n    height: 4rem !important;\n    width: 4rem !important;\n  }\n  .svg-icon.svg-icon-xxl-4qx svg {\n    height: 4.25rem !important;\n    width: 4.25rem !important;\n  }\n  .svg-icon.svg-icon-xxl-4hx svg {\n    height: 4.5rem !important;\n    width: 4.5rem !important;\n  }\n  .svg-icon.svg-icon-xxl-4tx svg {\n    height: 4.75rem !important;\n    width: 4.75rem !important;\n  }\n  .svg-icon.svg-icon-xxl-5x svg {\n    height: 5rem !important;\n    width: 5rem !important;\n  }\n  .svg-icon.svg-icon-xxl-5qx svg {\n    height: 5.25rem !important;\n    width: 5.25rem !important;\n  }\n  .svg-icon.svg-icon-xxl-5hx svg {\n    height: 5.5rem !important;\n    width: 5.5rem !important;\n  }\n  .svg-icon.svg-icon-xxl-5tx svg {\n    height: 5.75rem !important;\n    width: 5.75rem !important;\n  }\n  .svg-icon.svg-icon-xxl-6x svg {\n    height: 6rem !important;\n    width: 6rem !important;\n  }\n  .svg-icon.svg-icon-xxl-6qx svg {\n    height: 6.25rem !important;\n    width: 6.25rem !important;\n  }\n  .svg-icon.svg-icon-xxl-6hx svg {\n    height: 6.5rem !important;\n    width: 6.5rem !important;\n  }\n  .svg-icon.svg-icon-xxl-6tx svg {\n    height: 6.75rem !important;\n    width: 6.75rem !important;\n  }\n  .svg-icon.svg-icon-xxl-7x svg {\n    height: 7rem !important;\n    width: 7rem !important;\n  }\n  .svg-icon.svg-icon-xxl-7qx svg {\n    height: 7.25rem !important;\n    width: 7.25rem !important;\n  }\n  .svg-icon.svg-icon-xxl-7hx svg {\n    height: 7.5rem !important;\n    width: 7.5rem !important;\n  }\n  .svg-icon.svg-icon-xxl-7tx svg {\n    height: 7.75rem !important;\n    width: 7.75rem !important;\n  }\n}\n\n.fixed-top {\n  position: fixed;\n  z-index: 101;\n  top: 0;\n  left: 0;\n  right: 0;\n}\n\n@media (min-width: 576px) {\n  .fixed-top-sm {\n    position: fixed;\n    z-index: 101;\n    top: 0;\n    left: 0;\n    right: 0;\n  }\n}\n@media (min-width: 768px) {\n  .fixed-top-md {\n    position: fixed;\n    z-index: 101;\n    top: 0;\n    left: 0;\n    right: 0;\n  }\n}\n@media (min-width: 992px) {\n  .fixed-top-lg {\n    position: fixed;\n    z-index: 101;\n    top: 0;\n    left: 0;\n    right: 0;\n  }\n}\n@media (min-width: 1200px) {\n  .fixed-top-xl {\n    position: fixed;\n    z-index: 101;\n    top: 0;\n    left: 0;\n    right: 0;\n  }\n}\n@media (min-width: 1400px) {\n  .fixed-top-xxl {\n    position: fixed;\n    z-index: 101;\n    top: 0;\n    left: 0;\n    right: 0;\n  }\n}\n.timeline .timeline-item {\n  position: relative;\n  padding: 0;\n  margin: 0;\n  display: flex;\n  align-items: flex-start;\n}\n.timeline .timeline-item:last-child .timeline-line {\n  bottom: 100%;\n}\n.timeline .timeline-line {\n  display: block;\n  content: \" \";\n  justify-content: center;\n  position: absolute;\n  z-index: 0;\n  left: 0;\n  top: 0;\n  bottom: 0;\n  transform: translate(50%);\n  border-left-width: 1px;\n  border-left-style: dashed;\n  border-left-color: var(--bs-gray-300);\n}\n.timeline .timeline-icon {\n  z-index: 1;\n  flex-shrink: 0;\n  margin-right: 1rem;\n}\n.timeline .timeline-content {\n  width: 100%;\n  overflow: auto;\n  margin-bottom: 1.5rem;\n}\n.timeline.timeline-center .timeline-item {\n  align-items: center;\n}\n.timeline.timeline-center .timeline-item:first-child .timeline-line {\n  top: 50%;\n}\n.timeline.timeline-center .timeline-item:last-child .timeline-line {\n  bottom: 50%;\n}\n\n.timeline-label {\n  position: relative;\n}\n.timeline-label:before {\n  content: \"\";\n  position: absolute;\n  left: 51px;\n  width: 3px;\n  top: 0;\n  bottom: 0;\n  background-color: var(--bs-gray-200);\n}\n.timeline-label .timeline-item {\n  display: flex;\n  align-items: flex-start;\n  position: relative;\n  margin-bottom: 1.7rem;\n}\n.timeline-label .timeline-item:last-child {\n  margin-bottom: 0;\n}\n.timeline-label .timeline-label {\n  width: 50px;\n  flex-shrink: 0;\n  position: relative;\n  color: var(--bs-gray-800);\n}\n.timeline-label .timeline-badge {\n  flex-shrink: 0;\n  background-color: var(--bs-body-bg);\n  width: 1rem;\n  height: 1rem;\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  z-index: 1;\n  position: relative;\n  margin-top: 1px;\n  margin-left: -0.5rem;\n  padding: 3px !important;\n  border: 6px solid var(--bs-body-bg) !important;\n}\n.timeline-label .timeline-content {\n  flex-grow: 1;\n}\n\n.overlay {\n  position: relative;\n}\n.overlay .overlay-layer {\n  position: absolute;\n  top: 0;\n  bottom: 0;\n  left: 0;\n  right: 0;\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  background-color: var(--bs-overlay-bg);\n  transition: all 0.3s ease;\n  opacity: 0;\n}\n.overlay.overlay-show .overlay-layer, .overlay.overlay-block .overlay-layer, .overlay:hover .overlay-layer {\n  transition: all 0.3s ease;\n  opacity: 1;\n}\n.overlay.overlay-block {\n  cursor: wait;\n}\n\n.bullet {\n  display: inline-block;\n  background-color: var(--bs-bullet-bg-color);\n  border-radius: 6px;\n  width: 8px;\n  height: 4px;\n  flex-shrink: 0;\n}\n\n.bullet-dot {\n  width: 4px;\n  height: 4px;\n  border-radius: 100% !important;\n}\n\n.bullet-vertical {\n  width: 4px;\n  height: 8px;\n}\n\n.bullet-line {\n  width: 5px;\n  height: 1px;\n  border-radius: 0;\n}\n\n.drawer {\n  display: flex !important;\n  overflow: auto;\n  z-index: 110;\n  position: fixed;\n  top: 0;\n  bottom: 0;\n  background-color: var(--bs-drawer-bg-color);\n  transition: transform 0.3s ease-in-out !important;\n}\n.drawer.drawer-start {\n  left: 0;\n  transform: translateX(-100%);\n}\n.drawer.drawer-end {\n  right: 0;\n  transform: translateX(100%);\n}\n.drawer.drawer-on {\n  transform: none;\n  box-shadow: var(--bs-drawer-box-shadow);\n  transition: transform 0.3s ease-in-out !important;\n}\n\n.drawer-overlay {\n  position: fixed;\n  top: 0;\n  left: 0;\n  bottom: 0;\n  right: 0;\n  overflow: hidden;\n  z-index: 109;\n  background-color: var(--bs-drawer-overlay-bg-color);\n  animation: animation-drawer-fade-in 0.3s ease-in-out 1;\n}\n\n[data-kt-drawer=true] {\n  display: none;\n}\n\n@keyframes animation-drawer-fade-in {\n  from {\n    opacity: 0;\n  }\n  to {\n    opacity: 1;\n  }\n}\n@media (max-width: 991.98px) {\n  body[data-kt-drawer=on] {\n    overflow: hidden;\n  }\n}\n.badge {\n  display: inline-flex;\n  align-items: center;\n}\n.badge.badge-circle, .badge.badge-square {\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  height: 1.75rem;\n  min-width: 1.75rem;\n  padding: 0 0.1rem;\n  line-height: 0;\n}\n.badge.badge-circle {\n  border-radius: 50%;\n  padding: 0;\n  min-width: unset;\n  width: 1.75rem;\n}\n.badge.badge-sm {\n  min-width: 1.5rem;\n  font-size: 0.8rem;\n}\n.badge.badge-sm.badge-square {\n  height: 1.5rem;\n}\n.badge.badge-sm.badge-circle {\n  width: 1.5rem;\n  height: 1.5rem;\n}\n.badge.badge-lg {\n  min-width: 2rem;\n  font-size: 1rem;\n}\n.badge.badge-lg.badge-square {\n  height: 2rem;\n}\n.badge.badge-lg.badge-circle {\n  width: 2rem;\n  height: 2rem;\n}\n\n.badge-light {\n  color: var(--bs-light-inverse);\n  background-color: var(--bs-light);\n}\n.badge-light.badge-outline {\n  border: 1px solid var(--bs-light);\n  color: var(--bs-light);\n  background-color: transparent;\n}\n\n.badge-light-light {\n  color: var(--bs-light);\n  background-color: var(--bs-light-light);\n}\n\n.badge-primary {\n  color: var(--bs-primary-inverse);\n  background-color: var(--bs-primary);\n}\n.badge-primary.badge-outline {\n  border: 1px solid var(--bs-primary);\n  color: var(--bs-primary);\n  background-color: transparent;\n}\n\n.badge-light-primary {\n  color: var(--bs-primary);\n  background-color: var(--bs-primary-light);\n}\n\n.badge-secondary {\n  color: var(--bs-secondary-inverse);\n  background-color: var(--bs-secondary);\n}\n.badge-secondary.badge-outline {\n  border: 1px solid var(--bs-secondary);\n  color: var(--bs-secondary);\n  background-color: transparent;\n}\n\n.badge-light-secondary {\n  color: var(--bs-secondary);\n  background-color: var(--bs-secondary-light);\n}\n\n.badge-success {\n  color: var(--bs-success-inverse);\n  background-color: var(--bs-success);\n}\n.badge-success.badge-outline {\n  border: 1px solid var(--bs-success);\n  color: var(--bs-success);\n  background-color: transparent;\n}\n\n.badge-light-success {\n  color: var(--bs-success);\n  background-color: var(--bs-success-light);\n}\n\n.badge-info {\n  color: var(--bs-info-inverse);\n  background-color: var(--bs-info);\n}\n.badge-info.badge-outline {\n  border: 1px solid var(--bs-info);\n  color: var(--bs-info);\n  background-color: transparent;\n}\n\n.badge-light-info {\n  color: var(--bs-info);\n  background-color: var(--bs-info-light);\n}\n\n.badge-warning {\n  color: var(--bs-warning-inverse);\n  background-color: var(--bs-warning);\n}\n.badge-warning.badge-outline {\n  border: 1px solid var(--bs-warning);\n  color: var(--bs-warning);\n  background-color: transparent;\n}\n\n.badge-light-warning {\n  color: var(--bs-warning);\n  background-color: var(--bs-warning-light);\n}\n\n.badge-danger {\n  color: var(--bs-danger-inverse);\n  background-color: var(--bs-danger);\n}\n.badge-danger.badge-outline {\n  border: 1px solid var(--bs-danger);\n  color: var(--bs-danger);\n  background-color: transparent;\n}\n\n.badge-light-danger {\n  color: var(--bs-danger);\n  background-color: var(--bs-danger-light);\n}\n\n.badge-dark {\n  color: var(--bs-dark-inverse);\n  background-color: var(--bs-dark);\n}\n.badge-dark.badge-outline {\n  border: 1px solid var(--bs-dark);\n  color: var(--bs-dark);\n  background-color: transparent;\n}\n\n.badge-light-dark {\n  color: var(--bs-dark);\n  background-color: var(--bs-dark-light);\n}\n\n.indicator-progress {\n  display: none;\n}\n[data-kt-indicator=on] > .indicator-progress {\n  display: inline-block;\n}\n\n[data-kt-indicator=on] > .indicator-label {\n  display: none;\n}\n\n.hover-elevate-up {\n  transition: transform 0.3s ease;\n}\n.hover-elevate-up:hover {\n  transform: translateY(-2.5%);\n  transition: transform 0.3s ease;\n  will-change: transform;\n}\n\n.hover-elevate-down {\n  transition: transform 0.3s ease;\n}\n.hover-elevate-down:hover {\n  transform: translateY(2.5%);\n  transition: transform 0.3s ease;\n  will-change: transform;\n}\n\n.hover-scale {\n  transition: transform 0.3s ease;\n}\n.hover-scale:hover {\n  transform: scale(1.1);\n  transition: transform 0.3s ease;\n  will-change: transform;\n}\n\n.hover-rotate-end {\n  transition: transform 0.3s ease;\n}\n.hover-rotate-end:hover {\n  transform: rotate(4deg);\n  transition: transform 0.3s ease;\n  will-change: transform;\n}\n\n.hover-rotate-start {\n  transition: transform 0.3s ease;\n}\n.hover-rotate-start:hover {\n  transform: rotate(-4deg);\n  transition: transform 0.3s ease;\n  will-change: transform;\n}\n\n.rotate {\n  display: inline-flex;\n  align-items: center;\n}\n\n.rotate-90 {\n  transition: transform 0.3s ease;\n  backface-visibility: hidden;\n  will-change: transform;\n}\n.collapsible:not(.collapsed) > .rotate-90, .show > .rotate-90, .active > .rotate-90 {\n  transform: rotateZ(90deg);\n  transition: transform 0.3s ease;\n}\n[direction=rtl] .collapsible:not(.collapsed) > .rotate-90, [direction=rtl] .show > .rotate-90, [direction=rtl] .active > .rotate-90 {\n  transform: rotateZ(-90deg);\n}\n\n.rotate-n90 {\n  transition: transform 0.3s ease;\n  backface-visibility: hidden;\n  will-change: transform;\n}\n.collapsible:not(.collapsed) > .rotate-n90, .show > .rotate-n90, .active > .rotate-n90 {\n  transform: rotateZ(-90deg);\n  transition: transform 0.3s ease;\n}\n[direction=rtl] .collapsible:not(.collapsed) > .rotate-n90, [direction=rtl] .show > .rotate-n90, [direction=rtl] .active > .rotate-n90 {\n  transform: rotateZ(90deg);\n}\n\n.rotate-180 {\n  transition: transform 0.3s ease;\n  backface-visibility: hidden;\n  will-change: transform;\n}\n.collapsible:not(.collapsed) > .rotate-180, .show > .rotate-180, .active > .rotate-180 {\n  transform: rotateZ(180deg);\n  transition: transform 0.3s ease;\n}\n[direction=rtl] .collapsible:not(.collapsed) > .rotate-180, [direction=rtl] .show > .rotate-180, [direction=rtl] .active > .rotate-180 {\n  transform: rotateZ(-180deg);\n}\n\n.rotate-n180 {\n  transition: transform 0.3s ease;\n  backface-visibility: hidden;\n  will-change: transform;\n}\n.collapsible:not(.collapsed) > .rotate-n180, .show > .rotate-n180, .active > .rotate-n180 {\n  transform: rotateZ(-180deg);\n  transition: transform 0.3s ease;\n}\n[direction=rtl] .collapsible:not(.collapsed) > .rotate-n180, [direction=rtl] .show > .rotate-n180, [direction=rtl] .active > .rotate-n180 {\n  transform: rotateZ(180deg);\n}\n\n.rotate-270 {\n  transition: transform 0.3s ease;\n  backface-visibility: hidden;\n  will-change: transform;\n}\n.collapsible:not(.collapsed) > .rotate-270, .show > .rotate-270, .active > .rotate-270 {\n  transform: rotateZ(270deg);\n  transition: transform 0.3s ease;\n}\n[direction=rtl] .collapsible:not(.collapsed) > .rotate-270, [direction=rtl] .show > .rotate-270, [direction=rtl] .active > .rotate-270 {\n  transform: rotateZ(-270deg);\n}\n\n.rotate-n270 {\n  transition: transform 0.3s ease;\n  backface-visibility: hidden;\n  will-change: transform;\n}\n.collapsible:not(.collapsed) > .rotate-n270, .show > .rotate-n270, .active > .rotate-n270 {\n  transform: rotateZ(-270deg);\n  transition: transform 0.3s ease;\n}\n[direction=rtl] .collapsible:not(.collapsed) > .rotate-n270, [direction=rtl] .show > .rotate-n270, [direction=rtl] .active > .rotate-n270 {\n  transform: rotateZ(270deg);\n}\n\n@media (min-width: 992px) {\n  main,\nspan,\nol,\nul,\npre,\ndiv {\n    scrollbar-width: thin;\n    scrollbar-color: var(--bs-scrollbar-color) transparent;\n  }\n  main::-webkit-scrollbar,\nspan::-webkit-scrollbar,\nol::-webkit-scrollbar,\nul::-webkit-scrollbar,\npre::-webkit-scrollbar,\ndiv::-webkit-scrollbar {\n    width: var(--bs-scrollbar-size);\n    height: var(--bs-scrollbar-size);\n  }\n  main ::-webkit-scrollbar-track,\nspan ::-webkit-scrollbar-track,\nol ::-webkit-scrollbar-track,\nul ::-webkit-scrollbar-track,\npre ::-webkit-scrollbar-track,\ndiv ::-webkit-scrollbar-track {\n    background-color: transparent;\n  }\n  main ::-webkit-scrollbar-thumb,\nspan ::-webkit-scrollbar-thumb,\nol ::-webkit-scrollbar-thumb,\nul ::-webkit-scrollbar-thumb,\npre ::-webkit-scrollbar-thumb,\ndiv ::-webkit-scrollbar-thumb {\n    border-radius: var(--bs-scrollbar-size);\n  }\n  main::-webkit-scrollbar-thumb,\nspan::-webkit-scrollbar-thumb,\nol::-webkit-scrollbar-thumb,\nul::-webkit-scrollbar-thumb,\npre::-webkit-scrollbar-thumb,\ndiv::-webkit-scrollbar-thumb {\n    background-color: var(--bs-scrollbar-color);\n  }\n  main::-webkit-scrollbar-corner,\nspan::-webkit-scrollbar-corner,\nol::-webkit-scrollbar-corner,\nul::-webkit-scrollbar-corner,\npre::-webkit-scrollbar-corner,\ndiv::-webkit-scrollbar-corner {\n    background-color: transparent;\n  }\n  main:hover,\nspan:hover,\nol:hover,\nul:hover,\npre:hover,\ndiv:hover {\n    scrollbar-color: var(--bs-scrollbar-hover-color) transparent;\n  }\n  main:hover::-webkit-scrollbar-thumb,\nspan:hover::-webkit-scrollbar-thumb,\nol:hover::-webkit-scrollbar-thumb,\nul:hover::-webkit-scrollbar-thumb,\npre:hover::-webkit-scrollbar-thumb,\ndiv:hover::-webkit-scrollbar-thumb {\n    background-color: var(--bs-scrollbar-hover-color);\n  }\n  main:hover::-webkit-scrollbar-corner,\nspan:hover::-webkit-scrollbar-corner,\nol:hover::-webkit-scrollbar-corner,\nul:hover::-webkit-scrollbar-corner,\npre:hover::-webkit-scrollbar-corner,\ndiv:hover::-webkit-scrollbar-corner {\n    background-color: transparent;\n  }\n}\n.scroll {\n  overflow: scroll;\n  position: relative;\n}\n@media (max-width: 991.98px) {\n  .scroll {\n    overflow: auto;\n  }\n}\n\n.scroll-x {\n  overflow-x: scroll;\n  position: relative;\n}\n@media (max-width: 991.98px) {\n  .scroll-x {\n    overflow-x: auto;\n  }\n}\n\n.scroll-y {\n  overflow-y: scroll;\n  position: relative;\n}\n@media (max-width: 991.98px) {\n  .scroll-y {\n    overflow-y: auto;\n  }\n}\n\n.hover-scroll,\n.hover-scroll-overlay {\n  position: relative;\n}\n@media (min-width: 992px) {\n  .hover-scroll,\n.hover-scroll-overlay {\n    overflow: hidden;\n  }\n  @-moz-document url-prefix() {\n    .hover-scroll,\n.hover-scroll-overlay {\n      overflow: scroll;\n    }\n  }\n  .safari-mode .hover-scroll,\n.safari-mode .hover-scroll-overlay {\n    overflow: scroll;\n  }\n  .hover-scroll::-webkit-scrollbar,\n.hover-scroll-overlay::-webkit-scrollbar {\n    width: var(--bs-scrollbar-overlay-size);\n    height: var(--bs-scrollbar-overlay-size);\n  }\n  .hover-scroll::-webkit-scrollbar-thumb,\n.hover-scroll-overlay::-webkit-scrollbar-thumb {\n    background-clip: content-box;\n    border: var(--bs-scrollbar-overlay-space) solid transparent;\n    border-radius: var(--bs-scrollbar-overlay-size);\n  }\n  .hover-scroll:hover,\n.hover-scroll-overlay:hover {\n    overflow: overlay;\n  }\n}\n@media (max-width: 991.98px) {\n  .hover-scroll,\n.hover-scroll-overlay {\n    overflow: auto;\n  }\n}\n\n.hover-scroll-y,\n.hover-scroll-overlay-y {\n  position: relative;\n}\n@media (min-width: 992px) {\n  .hover-scroll-y,\n.hover-scroll-overlay-y {\n    overflow-y: hidden;\n  }\n  @-moz-document url-prefix() {\n    .hover-scroll-y,\n.hover-scroll-overlay-y {\n      overflow-y: scroll;\n    }\n  }\n  .safari-mode .hover-scroll-y,\n.safari-mode .hover-scroll-overlay-y {\n    overflow-y: scroll;\n  }\n  .hover-scroll-y::-webkit-scrollbar,\n.hover-scroll-overlay-y::-webkit-scrollbar {\n    width: var(--bs-scrollbar-overlay-size);\n  }\n  .hover-scroll-y::-webkit-scrollbar-thumb,\n.hover-scroll-overlay-y::-webkit-scrollbar-thumb {\n    background-clip: content-box;\n    border: var(--bs-scrollbar-overlay-space) solid transparent;\n    border-radius: var(--bs-scrollbar-overlay-size);\n  }\n  .hover-scroll-y:hover,\n.hover-scroll-overlay-y:hover {\n    overflow-y: overlay;\n  }\n}\n@media (max-width: 991.98px) {\n  .hover-scroll-y,\n.hover-scroll-overlay-y {\n    overflow-y: auto;\n  }\n}\n\n.hover-scroll-x,\n.hover-scroll-overlay-x {\n  position: relative;\n}\n@media (min-width: 992px) {\n  .hover-scroll-x,\n.hover-scroll-overlay-x {\n    overflow-x: hidden;\n  }\n  @-moz-document url-prefix() {\n    .hover-scroll-x,\n.hover-scroll-overlay-x {\n      overflow-x: scroll;\n    }\n  }\n  .safari-mode .hover-scroll-x,\n.safari-mode .hover-scroll-overlay-x {\n    overflow-x: scroll;\n  }\n  .hover-scroll-x::-webkit-scrollbar,\n.hover-scroll-overlay-x::-webkit-scrollbar {\n    height: var(--bs-scrollbar-overlay-size);\n  }\n  .hover-scroll-x::-webkit-scrollbar-thumb,\n.hover-scroll-overlay-x::-webkit-scrollbar-thumb {\n    background-clip: content-box;\n    border: var(--bs-scrollbar-overlay-space) solid transparent;\n    border-radius: var(--bs-scrollbar-overlay-size);\n  }\n  .hover-scroll-x:hover,\n.hover-scroll-overlay-x:hover {\n    overflow-x: overlay;\n  }\n}\n@media (max-width: 991.98px) {\n  .hover-scroll-x,\n.hover-scroll-overlay-x {\n    overflow-x: auto;\n  }\n}\n\n.scroll-ps {\n  padding-left: var(--bs-scrollbar-size) !important;\n}\n\n.scroll-ms {\n  margin-left: var(--bs-scrollbar-size) !important;\n}\n\n.scroll-mb {\n  margin-bottom: var(--bs-scrollbar-size) !important;\n}\n\n.scroll-pe {\n  padding-right: var(--bs-scrollbar-size) !important;\n}\n\n.scroll-me {\n  margin-right: var(--bs-scrollbar-size) !important;\n}\n\n.scroll-px {\n  padding-left: var(--bs-scrollbar-size) !important;\n  padding-right: var(--bs-scrollbar-size) !important;\n}\n\n.scroll-mx {\n  margin-left: var(--bs-scrollbar-size) !important;\n  margin-right: var(--bs-scrollbar-size) !important;\n}\n\n.rating {\n  display: flex;\n  align-items: center;\n}\n\n.rating-input {\n  position: absolute !important;\n  left: -9999px !important;\n}\n.rating-input[disabled] {\n  display: none;\n}\n\n.rating-label {\n  padding: 0;\n  margin: 0;\n}\n.rating-label > i, .rating-label > .svg-icon {\n  line-height: 1;\n  color: var(--bs-rating-color-default);\n}\n\nlabel.rating-label {\n  cursor: pointer;\n}\n\ndiv.rating-label.checked > i, div.rating-label.checked > .svg-icon,\nlabel.rating-label > i,\nlabel.rating-label > .svg-icon {\n  color: var(--bs-rating-color-active);\n}\n\n.rating-input:checked ~ .rating-label > i, .rating-input:checked ~ .rating-label > .svg-icon {\n  color: var(--bs-rating-color-default);\n}\n\n.rating:hover label.rating-label > i, .rating:hover label.rating-label > .svg-icon {\n  color: var(--bs-rating-color-active);\n}\n\nlabel.rating-label:hover ~ .rating-label {\n  color: var(--bs-rating-color-default);\n}\nlabel.rating-label:hover ~ .rating-label > i, label.rating-label:hover ~ .rating-label > .svg-icon {\n  color: var(--bs-rating-color-default);\n}\n\n.stepper [data-kt-stepper-element=info],\n.stepper [data-kt-stepper-element=content] {\n  display: none;\n}\n.stepper [data-kt-stepper-element=info].current,\n.stepper [data-kt-stepper-element=content].current {\n  display: flex;\n}\n.stepper .stepper-item[data-kt-stepper-action=step] {\n  cursor: pointer;\n}\n.stepper [data-kt-stepper-action=final] {\n  display: none;\n}\n.stepper [data-kt-stepper-action=previous] {\n  display: none;\n}\n.stepper [data-kt-stepper-action=next] {\n  display: inline-block;\n}\n.stepper [data-kt-stepper-action=submit] {\n  display: none;\n}\n.stepper.first [data-kt-stepper-action=previous] {\n  display: none;\n}\n.stepper.first [data-kt-stepper-action=next] {\n  display: inline-block;\n}\n.stepper.first [data-kt-stepper-action=submit] {\n  display: none;\n}\n.stepper.between [data-kt-stepper-action=previous] {\n  display: inline-block;\n}\n.stepper.between [data-kt-stepper-action=next] {\n  display: inline-block;\n}\n.stepper.between [data-kt-stepper-action=submit] {\n  display: none;\n}\n.stepper.last [data-kt-stepper-action=final] {\n  display: inline-block;\n}\n.stepper.last [data-kt-stepper-action=final].btn-flex {\n  display: flex;\n}\n.stepper.last [data-kt-stepper-action=previous] {\n  display: inline-block;\n}\n.stepper.last [data-kt-stepper-action=previous].btn-flex {\n  display: flex;\n}\n.stepper.last [data-kt-stepper-action=next] {\n  display: none;\n}\n.stepper.last [data-kt-stepper-action=next].btn-flex {\n  display: flex;\n}\n.stepper.last [data-kt-stepper-action=submit] {\n  display: inline-block;\n}\n.stepper.last [data-kt-stepper-action=submit].btn-flex {\n  display: flex;\n}\n\n.stepper.stepper-pills {\n  --bs-stepper-pills-size: 40px;\n  --bs-stepper-icon-border-radius: 9px;\n  --bs-stepper-icon-check-size: 1rem;\n  --bs-stepper-icon-bg-color: var(--bs-primary-light);\n  --bs-stepper-icon-bg-color-current: var(--bs-primary);\n  --bs-stepper-icon-bg-color-completed: var(--bs-primary-light);\n  --bs-stepper-icon-border: 0;\n  --bs-stepper-icon-border-current: 0;\n  --bs-stepper-icon-border-completed: 0;\n  --bs-stepper-icon-number-color: var(--bs-primary);\n  --bs-stepper-icon-number-color-current: var(--bs-white);\n  --bs-stepper-icon-check-color-completed: var(--bs-primary);\n  --bs-stepper-label-title-opacity: 1;\n  --bs-stepper-label-title-opacity-current: 1;\n  --bs-stepper-label-title-opacity-completed: 1;\n  --bs-stepper-label-title-color: var(--bs-gray-800);\n  --bs-stepper-label-title-color-current: var(--bs-gray-600);\n  --bs-stepper-label-title-color-completed: var(--bs-text-muted);\n  --bs-stepper-label-desc-opacity: 1;\n  --bs-stepper-label-desc-opacity-current: 1;\n  --bs-stepper-label-desc-opacity-completed: 1;\n  --bs-stepper-label-desc-color: var(--bs-text-muted);\n  --bs-stepper-label-desc-color-current: var(--bs-gray-400);\n  --bs-stepper-label-desc-color-completed: var(--bs-gray-400);\n  --bs-stepper-line-border: 1px dashed var(--bs-gray-300);\n}\n.stepper.stepper-pills .stepper-nav {\n  display: flex;\n}\n.stepper.stepper-pills .stepper-item {\n  display: flex;\n  align-items: center;\n  transition: color 0.2s ease;\n}\n.stepper.stepper-pills .stepper-item .stepper-icon {\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  flex-shrink: 0;\n  transition: color 0.2s ease;\n  width: var(--bs-stepper-pills-size);\n  height: var(--bs-stepper-pills-size);\n  border-radius: var(--bs-stepper-icon-border-radius);\n  background-color: var(--bs-stepper-icon-bg-color);\n  border: var(--bs-stepper-icon-border);\n  margin-right: 1.5rem;\n}\n.stepper.stepper-pills .stepper-item .stepper-icon .stepper-check {\n  display: none;\n  font-size: var(--bs-stepper-icon-check-size);\n}\n.stepper.stepper-pills .stepper-item .stepper-icon .stepper-number {\n  font-weight: 600;\n  color: var(--bs-stepper-icon-number-color);\n  font-size: 1.25rem;\n}\n.stepper.stepper-pills .stepper-item .stepper-label {\n  display: flex;\n  flex-direction: column;\n  justify-content: center;\n}\n.stepper.stepper-pills .stepper-item .stepper-label .stepper-title {\n  color: var(--bs-stepper-label-title-color);\n  opacity: var(--bs-stepper-label-title-opacity);\n  font-weight: 600;\n  font-size: 1.25rem;\n  margin-bottom: 0.3rem;\n}\n.stepper.stepper-pills .stepper-item .stepper-label .stepper-desc {\n  opacity: var(--bs-stepper-label-desc-opacity);\n  color: var(--bs-stepper-label-desc-color);\n}\n.stepper.stepper-pills .stepper-item.current {\n  transition: color 0.2s ease;\n}\n.stepper.stepper-pills .stepper-item.current .stepper-icon {\n  transition: color 0.2s ease;\n  background-color: var(--bs-stepper-icon-bg-color-current);\n  border: var(--bs-stepper-icon-border-current);\n}\n.stepper.stepper-pills .stepper-item.current .stepper-icon .stepper-check {\n  display: none;\n}\n.stepper.stepper-pills .stepper-item.current .stepper-icon .stepper-number {\n  color: var(--bs-stepper-icon-number-color-current);\n  font-size: 1.35rem;\n}\n.stepper.stepper-pills .stepper-item.current .stepper-label .stepper-title {\n  opacity: var(--bs-stepper-label-title-opacity-current);\n  color: var(--bs-stepper-label-title-color-current);\n}\n.stepper.stepper-pills .stepper-item.current .stepper-label .stepper-desc {\n  opacity: var(--bs-stepper-label-desc-opacity-current);\n  color: var(--bs-stepper-label-desc-color-current);\n}\n.stepper.stepper-pills .stepper-item.current.mark-completed:last-child .stepper-icon, .stepper.stepper-pills .stepper-item.completed .stepper-icon {\n  transition: color 0.2s ease;\n  background-color: var(--bs-stepper-icon-bg-color-completed);\n  border: var(--bs-stepper-icon-border-completed);\n}\n.stepper.stepper-pills .stepper-item.current.mark-completed:last-child .stepper-icon .stepper-check, .stepper.stepper-pills .stepper-item.completed .stepper-icon .stepper-check {\n  color: var(--bs-stepper-icon-check-color-completed);\n  display: inline-block;\n}\n.stepper.stepper-pills .stepper-item.current.mark-completed:last-child .stepper-icon .stepper-number, .stepper.stepper-pills .stepper-item.completed .stepper-icon .stepper-number {\n  display: none;\n}\n.stepper.stepper-pills .stepper-item.current.mark-completed:last-child .stepper-label .stepper-title, .stepper.stepper-pills .stepper-item.completed .stepper-label .stepper-title {\n  opacity: var(--bs-stepper-label-title-opacity-completed);\n  color: var(--bs-stepper-label-title-color-completed);\n}\n.stepper.stepper-pills .stepper-item.current.mark-completed:last-child .stepper-label .stepper-desc, .stepper.stepper-pills .stepper-item.completed .stepper-label .stepper-desc {\n  opacity: var(--bs-stepper-label-desc-opacity-completed);\n  color: var(--bs-stepper-label-desc-color-completed);\n}\n.stepper.stepper-pills.stepper-column .stepper-nav {\n  flex-direction: column;\n  align-items: start;\n}\n.stepper.stepper-pills.stepper-column .stepper-item {\n  flex-direction: column;\n  justify-content: start;\n  align-items: stretch;\n  padding: 0;\n  margin: 0;\n}\n.stepper.stepper-pills.stepper-column .stepper-wrapper {\n  display: flex;\n  align-items: center;\n}\n.stepper.stepper-pills.stepper-column .stepper-icon {\n  z-index: 1;\n}\n.stepper.stepper-pills.stepper-column .stepper-line {\n  display: block;\n  flex-grow: 1;\n  margin-left: calc(var(--bs-stepper-pills-size) / 2);\n  border-left: var(--bs-stepper-line-border);\n  margin-top: 2px;\n  margin-bottom: 2px;\n}\n\n.stepper.stepper-links .stepper-nav {\n  display: flex;\n  margin: 0 auto;\n  justify-content: center;\n  align-items: center;\n  flex-wrap: wrap;\n}\n.stepper.stepper-links .stepper-nav .stepper-item {\n  position: relative;\n  flex-shrink: 0;\n  margin: 1rem 1.5rem;\n}\n.stepper.stepper-links .stepper-nav .stepper-item:after {\n  content: \" \";\n  position: absolute;\n  top: 2.3rem;\n  left: 0;\n  height: 2px;\n  width: 100%;\n  background-color: transparent;\n  transition: color 0.2s ease;\n}\n.stepper.stepper-links .stepper-nav .stepper-item .stepper-title {\n  color: var(--bs-dark);\n  font-weight: 600;\n  font-size: 1.25rem;\n}\n.stepper.stepper-links .stepper-nav .stepper-item.current {\n  transition: color 0.2s ease;\n}\n.stepper.stepper-links .stepper-nav .stepper-item.current .stepper-title {\n  color: var(--bs-primary);\n}\n.stepper.stepper-links .stepper-nav .stepper-item.current:after {\n  background-color: var(--bs-primary);\n}\n.stepper.stepper-links .stepper-nav .stepper-item.current.mark-completed:last-child .stepper-title, .stepper.stepper-links .stepper-nav .stepper-item.completed .stepper-title {\n  color: var(--bs-gray-400);\n}\n\n.toggle.collapsible:not(.collapsed) .toggle-off, .toggle.active .toggle-off {\n  display: none;\n}\n.toggle.collapsible.collapsed .toggle-on, .toggle:not(.collapsible):not(.active) .toggle-on {\n  display: none;\n}\n\n.xehagon {\n  clip-path: polygon(45% 1.3397459622%, 46.5797985667% 0.6030737921%, 48.2635182233% 0.1519224699%, 50% 0%, 51.7364817767% 0.1519224699%, 53.4202014333% 0.6030737921%, 55% 1.3397459622%, 89.6410161514% 21.3397459622%, 91.0688922482% 22.3395555688%, 92.3014605826% 23.5721239031%, 93.3012701892% 25%, 94.0379423592% 26.5797985667%, 94.4890936815% 28.2635182233%, 94.6410161514% 30%, 94.6410161514% 70%, 94.4890936815% 71.7364817767%, 94.0379423592% 73.4202014333%, 93.3012701892% 75%, 92.3014605826% 76.4278760969%, 91.0688922482% 77.6604444312%, 89.6410161514% 78.6602540378%, 55% 98.6602540378%, 53.4202014333% 99.3969262079%, 51.7364817767% 99.8480775301%, 50% 100%, 48.2635182233% 99.8480775301%, 46.5797985667% 99.3969262079%, 45% 98.6602540378%, 10.3589838486% 78.6602540378%, 8.9311077518% 77.6604444312%, 7.6985394174% 76.4278760969%, 6.6987298108% 75%, 5.9620576408% 73.4202014333%, 5.5109063185% 71.7364817767%, 5.3589838486% 70%, 5.3589838486% 30%, 5.5109063185% 28.2635182233%, 5.9620576408% 26.5797985667%, 6.6987298108% 25%, 7.6985394174% 23.5721239031%, 8.9311077518% 22.3395555688%, 10.3589838486% 21.3397459622%);\n}\n\n.octagon {\n  clip-path: polygon(46.1731656763% 0.7612046749%, 47.411809549% 0.3407417371%, 48.6947380778% 0.0855513863%, 50% 0%, 51.3052619222% 0.0855513863%, 52.588190451% 0.3407417371%, 53.8268343237% 0.7612046749%, 82.1111055711% 12.4769334274%, 83.2842712475% 13.0554747147%, 84.3718855375% 13.7821953496%, 85.3553390593% 14.6446609407%, 86.2178046504% 15.6281144625%, 86.9445252853% 16.7157287525%, 87.5230665726% 17.8888944289%, 99.2387953251% 46.1731656763%, 99.6592582629% 47.411809549%, 99.9144486137% 48.6947380778%, 100% 50%, 99.9144486137% 51.3052619222%, 99.6592582629% 52.588190451%, 99.2387953251% 53.8268343237%, 87.5230665726% 82.1111055711%, 86.9445252853% 83.2842712475%, 86.2178046504% 84.3718855375%, 85.3553390593% 85.3553390593%, 84.3718855375% 86.2178046504%, 83.2842712475% 86.9445252853%, 82.1111055711% 87.5230665726%, 53.8268343237% 99.2387953251%, 52.588190451% 99.6592582629%, 51.3052619222% 99.9144486137%, 50% 100%, 48.6947380778% 99.9144486137%, 47.411809549% 99.6592582629%, 46.1731656763% 99.2387953251%, 17.8888944289% 87.5230665726%, 16.7157287525% 86.9445252853%, 15.6281144625% 86.2178046504%, 14.6446609407% 85.3553390593%, 13.7821953496% 84.3718855375%, 13.0554747147% 83.2842712475%, 12.4769334274% 82.1111055711%, 0.7612046749% 53.8268343237%, 0.3407417371% 52.588190451%, 0.0855513863% 51.3052619222%, 0% 50%, 0.0855513863% 48.6947380778%, 0.3407417371% 47.411809549%, 0.7612046749% 46.1731656763%, 12.4769334274% 17.8888944289%, 13.0554747147% 16.7157287525%, 13.7821953496% 15.6281144625%, 14.6446609407% 14.6446609407%, 15.6281144625% 13.7821953496%, 16.7157287525% 13.0554747147%, 17.8888944289% 12.4769334274%);\n}\n\n.ribbon {\n  position: relative;\n}\n.ribbon .ribbon-label {\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  padding: 5px 10px;\n  position: absolute;\n  z-index: 1;\n  background-color: var(--bs-ribbon-label-bg);\n  box-shadow: var(--bs-ribbon-label-box-shadow);\n  color: var(--bs-primary-inverse);\n  top: 50%;\n  right: 0;\n  transform: translateX(5px) translateY(-50%);\n}\n.ribbon .ribbon-label > .ribbon-inner {\n  z-index: -1;\n  position: absolute;\n  padding: 0;\n  width: 100%;\n  height: 100%;\n  top: 0;\n  left: 0;\n}\n.ribbon .ribbon-label:after {\n  border-color: var(--bs-ribbon-label-border-color);\n}\n.ribbon-vertical .ribbon-label {\n  padding: 5px 10px;\n  min-width: 36px;\n  min-height: 46px;\n  text-align: center;\n}\n.ribbon.ribbon-top .ribbon-label {\n  top: 0;\n  transform: translateX(-15px) translateY(-4px);\n  border-bottom-right-radius: 0.475rem;\n  border-bottom-left-radius: 0.475rem;\n}\n.ribbon.ribbon-bottom .ribbon-label {\n  border-top-right-radius: 0.475rem;\n  border-top-left-radius: 0.475rem;\n}\n.ribbon.ribbon-start .ribbon-label {\n  top: 50%;\n  left: 0;\n  right: auto;\n  transform: translateX(-5px) translateY(-50%);\n  border-top-right-radius: 0.475rem;\n  border-bottom-right-radius: 0.475rem;\n}\n.ribbon.ribbon-end .ribbon-label {\n  border-top-left-radius: 0.475rem;\n  border-bottom-left-radius: 0.475rem;\n}\n\n.ribbon.ribbon-clip.ribbon-start .ribbon-label {\n  left: -5px;\n}\n.ribbon.ribbon-clip.ribbon-start .ribbon-label .ribbon-inner {\n  border-top-right-radius: 0.475rem;\n  border-bottom-right-radius: 0.475rem;\n}\n.ribbon.ribbon-clip.ribbon-start .ribbon-label .ribbon-inner:before, .ribbon.ribbon-clip.ribbon-start .ribbon-label .ribbon-inner:after {\n  content: \"\";\n  position: absolute;\n  border-style: solid;\n  border-color: transparent !important;\n  bottom: -10px;\n}\n.ribbon.ribbon-clip.ribbon-start .ribbon-label .ribbon-inner:before {\n  border-width: 0 10px 10px 0;\n  border-right-color: var(--bs-ribbon-clip-bg) !important;\n  left: 0;\n}\n.ribbon.ribbon-clip.ribbon-end .ribbon-label {\n  right: -5px;\n}\n.ribbon.ribbon-clip.ribbon-end .ribbon-label .ribbon-inner {\n  border-top-left-radius: 0.475rem;\n  border-bottom-left-radius: 0.475rem;\n}\n.ribbon.ribbon-clip.ribbon-end .ribbon-label .ribbon-inner:before, .ribbon.ribbon-clip.ribbon-end .ribbon-label .ribbon-inner:after {\n  content: \"\";\n  position: absolute;\n  border-style: solid;\n  border-color: transparent !important;\n  bottom: -10px;\n}\n.ribbon.ribbon-clip.ribbon-end .ribbon-label .ribbon-inner:before {\n  border-width: 0 0 10px 10px;\n  border-left-color: var(--bs-ribbon-clip-bg) !important;\n  right: 0;\n}\n\n.ribbon.ribbon-triangle {\n  position: absolute;\n  z-index: 1;\n  display: flex;\n  align-items: flex-start;\n  justify-content: flex-start;\n}\n.ribbon.ribbon-triangle.ribbon-top-start {\n  top: 0;\n  left: 0;\n  width: 4rem;\n  height: 4rem;\n  border-bottom: solid 2rem transparent !important;\n  border-left: solid 2rem transparent;\n  border-right: solid 2rem transparent !important;\n  border-top: solid 2rem transparent;\n}\n.ribbon.ribbon-triangle.ribbon-top-end {\n  top: 0;\n  right: 0;\n  width: 4rem;\n  height: 4rem;\n  border-bottom: solid 2rem transparent !important;\n  border-left: solid 2rem transparent !important;\n  border-right: solid 2rem transparent;\n  border-top: solid 2rem transparent;\n}\n.ribbon.ribbon-triangle.ribbon-bottom-start {\n  bottom: 0;\n  left: 0;\n  width: 4rem;\n  height: 4rem;\n  border-bottom: solid 2rem transparent;\n  border-left: solid 2rem transparent;\n  border-right: solid 2rem transparent !important;\n  border-top: solid 2rem transparent !important;\n}\n.ribbon.ribbon-triangle.ribbon-bottom-end {\n  bottom: 0;\n  right: 0;\n  width: 4rem;\n  height: 4rem;\n  border-bottom: solid 2rem transparent;\n  border-right: solid 2rem transparent;\n  border-left: solid 2rem transparent !important;\n  border-top: solid 2rem transparent !important;\n}\n\n.blockui {\n  position: relative;\n}\n.blockui .blockui-overlay {\n  transition: all 0.3s ease;\n  position: absolute;\n  top: 0;\n  bottom: 0;\n  left: 0;\n  right: 0;\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  background-color: var(--bs-blockui-overlay-bg);\n}\n.blockui .blockui-overlay .spinner-border {\n  height: 1.35rem;\n  width: 1.35rem;\n}\n.blockui .blockui-message {\n  display: flex;\n  align-items: center;\n  border-radius: 0.475rem;\n  box-shadow: var(--bs-blockui-message-box-shadow);\n  background-color: var(--bs-blockui-message-bg);\n  color: var(--bs-gray-700);\n  font-weight: 600;\n  margin: 0 !important;\n  width: auto;\n  padding: 0.85rem 1.75rem !important;\n}\n.blockui .blockui-message .spinner-border {\n  margin-right: 0.65rem;\n}\n\n[data-bs-theme=dark] .blockui {\n  --bs-blockui-overlay-bg: rgba(255, 255, 255, 0.05);\n  --bs-blockui-message-bg: #2B2B40;\n  --bs-blockui-message-box-shadow: 0px 0px 30px rgba(0, 0, 0, 0.15);\n}\n\n.explore-btn-toggle {\n  color: var(--bs-gray-600);\n  background-color: #ffffff;\n}\n.explore-btn-toggle:hover, .explore-btn-toggle:focus, .explore-btn-toggle:active {\n  color: #ffffff;\n  background-color: #00B2FF;\n}\n\n.explore-btn-dismiss {\n  border: 0;\n}\n.explore-btn-dismiss:hover i,\n.explore-btn-dismiss:hover .svg-icon {\n  color: #00B2FF;\n}\n\n.explore-btn-primary {\n  border: 0;\n  color: #ffffff;\n  background-color: #00B2FF;\n}\n.explore-btn-primary:hover {\n  color: #ffffff;\n  background-color: #0098DA;\n}\n\n.explore-btn-secondary {\n  border: 0;\n  color: var(--bs-gray-600);\n  background-color: var(--bs-gray-100);\n}\n.explore-btn-secondary:hover {\n  color: var(--bs-gray-800);\n  background-color: var(--bs-gray-200);\n}\n\n.explore-btn-outline {\n  border: 1px dashed var(--bs-gray-300) !important;\n}\n.explore-btn-outline:hover, .explore-btn-outline.active {\n  border: 1px dashed #50CD89 !important;\n  background-color: #E8FFF3;\n}\n\n.explore-link {\n  color: #00B2FF;\n}\n.explore-link:hover {\n  color: #0098DA;\n}\n\n.explore-link-hover:hover {\n  color: #00B2FF !important;\n}\n\n.explore-icon-success {\n  color: #50CD89;\n}\n\n.explore-icon-danger {\n  color: #F1416C;\n}\n\n.explore-label-free {\n  color: #ffffff;\n  background-color: #FFC700;\n}\n\n.explore-label-pro {\n  color: #ffffff;\n  background-color: #50CD89;\n}\n\n.app-engage {\n  position: fixed;\n  right: 0;\n  top: 50%;\n  transform: translateY(-50%);\n  display: flex;\n  flex-direction: column;\n  align-items: flex-end;\n  z-index: 5;\n  padding-right: 12px;\n}\n.app-engage .app-engage-btn {\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  flex-direction: column;\n  box-shadow: var(--bs-engage-btn-box-shadow);\n  border-width: 1px;\n  border-style: solid;\n  font-size: 12px;\n  font-weight: 600;\n  margin-bottom: 8px;\n  border-radius: 6px;\n  width: 66px;\n  height: 70px;\n  color: var(--bs-engage-btn-color);\n  border-color: var(--bs-engage-btn-border-color);\n  background-color: var(--bs-engage-btn-bg);\n}\n.app-engage .app-engage-btn i,\n.app-engage .app-engage-btn .svg-icon {\n  color: var(--bs-engage-btn-icon-color);\n}\n.app-engage .app-engage-btn.dropdown-toggle:after {\n  color: var(--bs-engage-btn-icon-color);\n}\n.app-engage .app-engage-btn.hover-dark:hover {\n  color: var(--bs-dark-inverse);\n  border-color: var(--bs-dark);\n  background-color: var(--bs-dark);\n}\n.app-engage .app-engage-btn.hover-dark:hover i,\n.app-engage .app-engage-btn.hover-dark:hover .svg-icon {\n  color: var(--bs-dark-inverse);\n}\n.app-engage .app-engage-btn.hover-primary:hover {\n  color: var(--bs-primary-inverse);\n  border-color: var(--bs-primary);\n  background-color: var(--bs-primary);\n}\n.app-engage .app-engage-btn.hover-primary:hover i,\n.app-engage .app-engage-btn.hover-primary:hover .svg-icon {\n  color: var(--bs-primary-inverse);\n}\n.app-engage .app-engage-btn.hover-success:hover {\n  color: var(--bs-success-inverse);\n  border-color: var(--bs-success);\n  background-color: var(--bs-success);\n}\n.app-engage .app-engage-btn.hover-success:hover i,\n.app-engage .app-engage-btn.hover-success:hover .svg-icon {\n  color: var(--bs-success-inverse);\n}\n.app-engage .app-engage-btn.app-engage-btn-toggle-off {\n  width: 35px;\n  height: 35px;\n}\n.app-engage .app-engage-btn.app-engage-btn-toggle-on {\n  width: 35px;\n  height: 35px;\n  display: none;\n}\n.app-engage.app-engage-hide .app-engage-btn {\n  visibility: hidden;\n}\n.app-engage.app-engage-hide .app-engage-btn.app-engage-btn-toggle-off {\n  display: none;\n}\n.app-engage.app-engage-hide .app-engage-btn.app-engage-btn-toggle-on {\n  visibility: visible;\n  display: flex;\n}\n\n.engage-btn {\n  display: flex;\n  align-items: center;\n  height: 35px !important;\n  color: var(--bs-engage-btn-color);\n  border-color: var(--bs-engage-btn-bg);\n  background-color: var(--bs-engage-btn-bg);\n}\n.engage-btn i,\n.engage-btn .svg-icon {\n  color: var(--bs-engage-btn-color);\n}\n.engage-btn.dropdown-toggle:after {\n  color: var(--bs-engage-btn-color);\n}\n.btn-check:checked + .engage-btn, .btn-check:active + .engage-btn, .engage-btn:focus:not(.btn-active), .engage-btn:hover:not(.btn-active), .engage-btn:active:not(.btn-active), .engage-btn.active, .engage-btn.show, .show > .engage-btn {\n  color: var(--bs-engage-btn-color-active);\n  border-color: var(--bs-engage-btn-bg);\n  background-color: var(--bs-engage-btn-bg) !important;\n}\n.btn-check:checked + .engage-btn i,\n.btn-check:checked + .engage-btn .svg-icon, .btn-check:active + .engage-btn i,\n.btn-check:active + .engage-btn .svg-icon, .engage-btn:focus:not(.btn-active) i,\n.engage-btn:focus:not(.btn-active) .svg-icon, .engage-btn:hover:not(.btn-active) i,\n.engage-btn:hover:not(.btn-active) .svg-icon, .engage-btn:active:not(.btn-active) i,\n.engage-btn:active:not(.btn-active) .svg-icon, .engage-btn.active i,\n.engage-btn.active .svg-icon, .engage-btn.show i,\n.engage-btn.show .svg-icon, .show > .engage-btn i,\n.show > .engage-btn .svg-icon {\n  color: var(--bs-engage-btn-color-active);\n}\n.btn-check:checked + .engage-btn.dropdown-toggle:after, .btn-check:active + .engage-btn.dropdown-toggle:after, .engage-btn:focus:not(.btn-active).dropdown-toggle:after, .engage-btn:hover:not(.btn-active).dropdown-toggle:after, .engage-btn:active:not(.btn-active).dropdown-toggle:after, .engage-btn.active.dropdown-toggle:after, .engage-btn.show.dropdown-toggle:after, .show > .engage-btn.dropdown-toggle:after {\n  color: var(--bs-engage-btn-color-active);\n}\n\n.cookiealert {\n  background: inherit;\n  color: inherit;\n}\n\n@media print {\n  .print-content-only {\n    padding: 0 !important;\n    background: none !important;\n  }\n  .print-content-only .wrapper,\n.print-content-only .page,\n.print-content-only .page-title .content,\n.print-content-only .container,\n.print-content-only .container-xxl,\n.print-content-only .container-fluid,\n.print-content-only .container-sm,\n.print-content-only .container-md,\n.print-content-only .container-lg,\n.print-content-only .container-xl {\n    background: none !important;\n    padding: 0 !important;\n    margin: 0 !important;\n  }\n  .print-content-only .aside,\n.print-content-only .sidebar,\n.print-content-only .scrolltop,\n.print-content-only .header,\n.print-content-only .footer,\n.print-content-only .toolbar,\n.print-content-only .drawer,\n.print-content-only .btn {\n    display: none !important;\n  }\n}\n.bg-white {\n  --bs-bg-rgb-color: var(--bs-white-bg-rgb);\n  background-color: #ffffff !important;\n}\n\n.bg-black {\n  --bs-bg-rgb-color: var(--bs-black-bg-rgb);\n  background-color: #000000 !important;\n}\n\n.bg-body {\n  --bs-bg-rgb-color: var(--bs-body-bg-rgb);\n  background-color: var(--bs-body-bg) !important;\n}\n\n.bg-hover-body {\n  cursor: pointer;\n}\n.bg-hover-body:hover {\n  background-color: var(--bs-body-bg) !important;\n}\n\n.bg-active-body.active {\n  background-color: var(--bs-body-bg) !important;\n}\n\n.bg-state-body {\n  cursor: pointer;\n}\n.bg-state-body.active, .bg-state-body:hover {\n  background-color: var(--bs-body-bg) !important;\n}\n\n.bg-hover-white {\n  cursor: pointer;\n}\n.bg-hover-white:hover {\n  --bs-bg-rgb-color: var(--bs-white-bg-rgb);\n  background-color: #ffffff !important;\n}\n\n.bg-active-white.active {\n  --bs-bg-rgb-color: var(--bs-white-bg-rgb);\n  background-color: #ffffff !important;\n}\n\n.bg-state-white {\n  cursor: pointer;\n}\n.bg-state-white.active, .bg-state-white:hover {\n  --bs-bg-rgb-color: var(--bs-white-bg-rgb);\n  background-color: #ffffff !important;\n}\n\n.bg-light {\n  --bs-bg-rgb-color: var(--bs-light-rgb);\n  background-color: var(--bs-light) !important;\n}\n\n.bg-light-active {\n  --bs-bg-rgb-color: var(--bs-light-active-rgb);\n  background-color: var(--bs-light-active) !important;\n}\n\n.bg-hover-light {\n  cursor: pointer;\n}\n.bg-hover-light:hover {\n  background-color: var(--bs-light) !important;\n}\n\n.bg-active-light.active {\n  background-color: var(--bs-light) !important;\n}\n\n.bg-state-light {\n  cursor: pointer;\n}\n.bg-state-light.active, .bg-state-light:hover {\n  background-color: var(--bs-light) !important;\n}\n\n.bg-light-primary {\n  background-color: var(--bs-primary-light) !important;\n}\n\n.bg-primary {\n  --bs-bg-rgb-color: var(--bs-primary-rgb);\n  background-color: var(--bs-primary) !important;\n}\n\n.bg-primary-active {\n  --bs-bg-rgb-color: var(--bs-primary-active-rgb);\n  background-color: var(--bs-primary-active) !important;\n}\n\n.bg-hover-light-primary {\n  cursor: pointer;\n}\n.bg-hover-light-primary:hover {\n  background-color: var(--bs-primary-light) !important;\n}\n\n.bg-state-light-primary {\n  cursor: pointer;\n}\n.bg-state-light-primary.active, .bg-state-light-primary:hover {\n  background-color: var(--bs-primary-light) !important;\n}\n\n.bg-hover-primary {\n  cursor: pointer;\n}\n.bg-hover-primary:hover {\n  background-color: var(--bs-primary) !important;\n}\n\n.bg-active-primary.active {\n  background-color: var(--bs-primary) !important;\n}\n\n.bg-state-primary {\n  cursor: pointer;\n}\n.bg-state-primary.active, .bg-state-primary:hover {\n  background-color: var(--bs-primary) !important;\n}\n\n.bg-light-secondary {\n  background-color: var(--bs-secondary-light) !important;\n}\n\n.bg-secondary {\n  --bs-bg-rgb-color: var(--bs-secondary-rgb);\n  background-color: var(--bs-secondary) !important;\n}\n\n.bg-secondary-active {\n  --bs-bg-rgb-color: var(--bs-secondary-active-rgb);\n  background-color: var(--bs-secondary-active) !important;\n}\n\n.bg-hover-light-secondary {\n  cursor: pointer;\n}\n.bg-hover-light-secondary:hover {\n  background-color: var(--bs-secondary-light) !important;\n}\n\n.bg-state-light-secondary {\n  cursor: pointer;\n}\n.bg-state-light-secondary.active, .bg-state-light-secondary:hover {\n  background-color: var(--bs-secondary-light) !important;\n}\n\n.bg-hover-secondary {\n  cursor: pointer;\n}\n.bg-hover-secondary:hover {\n  background-color: var(--bs-secondary) !important;\n}\n\n.bg-active-secondary.active {\n  background-color: var(--bs-secondary) !important;\n}\n\n.bg-state-secondary {\n  cursor: pointer;\n}\n.bg-state-secondary.active, .bg-state-secondary:hover {\n  background-color: var(--bs-secondary) !important;\n}\n\n.bg-light-success {\n  background-color: var(--bs-success-light) !important;\n}\n\n.bg-success {\n  --bs-bg-rgb-color: var(--bs-success-rgb);\n  background-color: var(--bs-success) !important;\n}\n\n.bg-success-active {\n  --bs-bg-rgb-color: var(--bs-success-active-rgb);\n  background-color: var(--bs-success-active) !important;\n}\n\n.bg-hover-light-success {\n  cursor: pointer;\n}\n.bg-hover-light-success:hover {\n  background-color: var(--bs-success-light) !important;\n}\n\n.bg-state-light-success {\n  cursor: pointer;\n}\n.bg-state-light-success.active, .bg-state-light-success:hover {\n  background-color: var(--bs-success-light) !important;\n}\n\n.bg-hover-success {\n  cursor: pointer;\n}\n.bg-hover-success:hover {\n  background-color: var(--bs-success) !important;\n}\n\n.bg-active-success.active {\n  background-color: var(--bs-success) !important;\n}\n\n.bg-state-success {\n  cursor: pointer;\n}\n.bg-state-success.active, .bg-state-success:hover {\n  background-color: var(--bs-success) !important;\n}\n\n.bg-light-info {\n  background-color: var(--bs-info-light) !important;\n}\n\n.bg-info {\n  --bs-bg-rgb-color: var(--bs-info-rgb);\n  background-color: var(--bs-info) !important;\n}\n\n.bg-info-active {\n  --bs-bg-rgb-color: var(--bs-info-active-rgb);\n  background-color: var(--bs-info-active) !important;\n}\n\n.bg-hover-light-info {\n  cursor: pointer;\n}\n.bg-hover-light-info:hover {\n  background-color: var(--bs-info-light) !important;\n}\n\n.bg-state-light-info {\n  cursor: pointer;\n}\n.bg-state-light-info.active, .bg-state-light-info:hover {\n  background-color: var(--bs-info-light) !important;\n}\n\n.bg-hover-info {\n  cursor: pointer;\n}\n.bg-hover-info:hover {\n  background-color: var(--bs-info) !important;\n}\n\n.bg-active-info.active {\n  background-color: var(--bs-info) !important;\n}\n\n.bg-state-info {\n  cursor: pointer;\n}\n.bg-state-info.active, .bg-state-info:hover {\n  background-color: var(--bs-info) !important;\n}\n\n.bg-light-warning {\n  background-color: var(--bs-warning-light) !important;\n}\n\n.bg-warning {\n  --bs-bg-rgb-color: var(--bs-warning-rgb);\n  background-color: var(--bs-warning) !important;\n}\n\n.bg-warning-active {\n  --bs-bg-rgb-color: var(--bs-warning-active-rgb);\n  background-color: var(--bs-warning-active) !important;\n}\n\n.bg-hover-light-warning {\n  cursor: pointer;\n}\n.bg-hover-light-warning:hover {\n  background-color: var(--bs-warning-light) !important;\n}\n\n.bg-state-light-warning {\n  cursor: pointer;\n}\n.bg-state-light-warning.active, .bg-state-light-warning:hover {\n  background-color: var(--bs-warning-light) !important;\n}\n\n.bg-hover-warning {\n  cursor: pointer;\n}\n.bg-hover-warning:hover {\n  background-color: var(--bs-warning) !important;\n}\n\n.bg-active-warning.active {\n  background-color: var(--bs-warning) !important;\n}\n\n.bg-state-warning {\n  cursor: pointer;\n}\n.bg-state-warning.active, .bg-state-warning:hover {\n  background-color: var(--bs-warning) !important;\n}\n\n.bg-light-danger {\n  background-color: var(--bs-danger-light) !important;\n}\n\n.bg-danger {\n  --bs-bg-rgb-color: var(--bs-danger-rgb);\n  background-color: var(--bs-danger) !important;\n}\n\n.bg-danger-active {\n  --bs-bg-rgb-color: var(--bs-danger-active-rgb);\n  background-color: var(--bs-danger-active) !important;\n}\n\n.bg-hover-light-danger {\n  cursor: pointer;\n}\n.bg-hover-light-danger:hover {\n  background-color: var(--bs-danger-light) !important;\n}\n\n.bg-state-light-danger {\n  cursor: pointer;\n}\n.bg-state-light-danger.active, .bg-state-light-danger:hover {\n  background-color: var(--bs-danger-light) !important;\n}\n\n.bg-hover-danger {\n  cursor: pointer;\n}\n.bg-hover-danger:hover {\n  background-color: var(--bs-danger) !important;\n}\n\n.bg-active-danger.active {\n  background-color: var(--bs-danger) !important;\n}\n\n.bg-state-danger {\n  cursor: pointer;\n}\n.bg-state-danger.active, .bg-state-danger:hover {\n  background-color: var(--bs-danger) !important;\n}\n\n.bg-light-dark {\n  background-color: var(--bs-dark-light) !important;\n}\n\n.bg-dark {\n  --bs-bg-rgb-color: var(--bs-dark-rgb);\n  background-color: var(--bs-dark) !important;\n}\n\n.bg-dark-active {\n  --bs-bg-rgb-color: var(--bs-dark-active-rgb);\n  background-color: var(--bs-dark-active) !important;\n}\n\n.bg-hover-light-dark {\n  cursor: pointer;\n}\n.bg-hover-light-dark:hover {\n  background-color: var(--bs-dark-light) !important;\n}\n\n.bg-state-light-dark {\n  cursor: pointer;\n}\n.bg-state-light-dark.active, .bg-state-light-dark:hover {\n  background-color: var(--bs-dark-light) !important;\n}\n\n.bg-hover-dark {\n  cursor: pointer;\n}\n.bg-hover-dark:hover {\n  background-color: var(--bs-dark) !important;\n}\n\n.bg-active-dark.active {\n  background-color: var(--bs-dark) !important;\n}\n\n.bg-state-dark {\n  cursor: pointer;\n}\n.bg-state-dark.active, .bg-state-dark:hover {\n  background-color: var(--bs-dark) !important;\n}\n\n.bg-gray-100 {\n  --bs-bg-rgb-color: var(--bs-gray-100-rgb);\n  background-color: var(--bs-gray-100);\n}\n\n.bg-gray-100i {\n  --bs-bg-rgb-color: var(--bs-gray-100-rgb);\n  background-color: var(--bs-gray-100) !important;\n}\n\n.bg-gray-200 {\n  --bs-bg-rgb-color: var(--bs-gray-200-rgb);\n  background-color: var(--bs-gray-200);\n}\n\n.bg-gray-200i {\n  --bs-bg-rgb-color: var(--bs-gray-200-rgb);\n  background-color: var(--bs-gray-200) !important;\n}\n\n.bg-gray-300 {\n  --bs-bg-rgb-color: var(--bs-gray-300-rgb);\n  background-color: var(--bs-gray-300);\n}\n\n.bg-gray-300i {\n  --bs-bg-rgb-color: var(--bs-gray-300-rgb);\n  background-color: var(--bs-gray-300) !important;\n}\n\n.bg-gray-400 {\n  --bs-bg-rgb-color: var(--bs-gray-400-rgb);\n  background-color: var(--bs-gray-400);\n}\n\n.bg-gray-400i {\n  --bs-bg-rgb-color: var(--bs-gray-400-rgb);\n  background-color: var(--bs-gray-400) !important;\n}\n\n.bg-gray-500 {\n  --bs-bg-rgb-color: var(--bs-gray-500-rgb);\n  background-color: var(--bs-gray-500);\n}\n\n.bg-gray-500i {\n  --bs-bg-rgb-color: var(--bs-gray-500-rgb);\n  background-color: var(--bs-gray-500) !important;\n}\n\n.bg-gray-600 {\n  --bs-bg-rgb-color: var(--bs-gray-600-rgb);\n  background-color: var(--bs-gray-600);\n}\n\n.bg-gray-600i {\n  --bs-bg-rgb-color: var(--bs-gray-600-rgb);\n  background-color: var(--bs-gray-600) !important;\n}\n\n.bg-gray-700 {\n  --bs-bg-rgb-color: var(--bs-gray-700-rgb);\n  background-color: var(--bs-gray-700);\n}\n\n.bg-gray-700i {\n  --bs-bg-rgb-color: var(--bs-gray-700-rgb);\n  background-color: var(--bs-gray-700) !important;\n}\n\n.bg-gray-800 {\n  --bs-bg-rgb-color: var(--bs-gray-800-rgb);\n  background-color: var(--bs-gray-800);\n}\n\n.bg-gray-800i {\n  --bs-bg-rgb-color: var(--bs-gray-800-rgb);\n  background-color: var(--bs-gray-800) !important;\n}\n\n.bg-gray-900 {\n  --bs-bg-rgb-color: var(--bs-gray-900-rgb);\n  background-color: var(--bs-gray-900);\n}\n\n.bg-gray-900i {\n  --bs-bg-rgb-color: var(--bs-gray-900-rgb);\n  background-color: var(--bs-gray-900) !important;\n}\n\n.bg-opacity-0 {\n  background-color: rgba(var(--bs-bg-rgb-color), 0) !important;\n}\n\n.bg-hover-opacity-0:hover {\n  background-color: rgba(var(--bs-bg-rgb-color), 0) !important;\n}\n\n.bg-active-opacity-0.active {\n  background-color: rgba(var(--bs-bg-rgb-color), 0) !important;\n}\n\n.bg-state-opacity-0 .active, .bg-state-opacity-0:hover {\n  background-color: rgba(var(--bs-bg-rgb-color), 0) !important;\n}\n\n.bg-opacity-5 {\n  background-color: rgba(var(--bs-bg-rgb-color), 0.05) !important;\n}\n\n.bg-hover-opacity-5:hover {\n  background-color: rgba(var(--bs-bg-rgb-color), 0.05) !important;\n}\n\n.bg-active-opacity-5.active {\n  background-color: rgba(var(--bs-bg-rgb-color), 0.05) !important;\n}\n\n.bg-state-opacity-5 .active, .bg-state-opacity-5:hover {\n  background-color: rgba(var(--bs-bg-rgb-color), 0.05) !important;\n}\n\n.bg-opacity-10 {\n  background-color: rgba(var(--bs-bg-rgb-color), 0.1) !important;\n}\n\n.bg-hover-opacity-10:hover {\n  background-color: rgba(var(--bs-bg-rgb-color), 0.1) !important;\n}\n\n.bg-active-opacity-10.active {\n  background-color: rgba(var(--bs-bg-rgb-color), 0.1) !important;\n}\n\n.bg-state-opacity-10 .active, .bg-state-opacity-10:hover {\n  background-color: rgba(var(--bs-bg-rgb-color), 0.1) !important;\n}\n\n.bg-opacity-15 {\n  background-color: rgba(var(--bs-bg-rgb-color), 0.15) !important;\n}\n\n.bg-hover-opacity-15:hover {\n  background-color: rgba(var(--bs-bg-rgb-color), 0.15) !important;\n}\n\n.bg-active-opacity-15.active {\n  background-color: rgba(var(--bs-bg-rgb-color), 0.15) !important;\n}\n\n.bg-state-opacity-15 .active, .bg-state-opacity-15:hover {\n  background-color: rgba(var(--bs-bg-rgb-color), 0.15) !important;\n}\n\n.bg-opacity-20 {\n  background-color: rgba(var(--bs-bg-rgb-color), 0.2) !important;\n}\n\n.bg-hover-opacity-20:hover {\n  background-color: rgba(var(--bs-bg-rgb-color), 0.2) !important;\n}\n\n.bg-active-opacity-20.active {\n  background-color: rgba(var(--bs-bg-rgb-color), 0.2) !important;\n}\n\n.bg-state-opacity-20 .active, .bg-state-opacity-20:hover {\n  background-color: rgba(var(--bs-bg-rgb-color), 0.2) !important;\n}\n\n.bg-opacity-25 {\n  background-color: rgba(var(--bs-bg-rgb-color), 0.25) !important;\n}\n\n.bg-hover-opacity-25:hover {\n  background-color: rgba(var(--bs-bg-rgb-color), 0.25) !important;\n}\n\n.bg-active-opacity-25.active {\n  background-color: rgba(var(--bs-bg-rgb-color), 0.25) !important;\n}\n\n.bg-state-opacity-25 .active, .bg-state-opacity-25:hover {\n  background-color: rgba(var(--bs-bg-rgb-color), 0.25) !important;\n}\n\n.bg-opacity-50 {\n  background-color: rgba(var(--bs-bg-rgb-color), 0.5) !important;\n}\n\n.bg-hover-opacity-50:hover {\n  background-color: rgba(var(--bs-bg-rgb-color), 0.5) !important;\n}\n\n.bg-active-opacity-50.active {\n  background-color: rgba(var(--bs-bg-rgb-color), 0.5) !important;\n}\n\n.bg-state-opacity-50 .active, .bg-state-opacity-50:hover {\n  background-color: rgba(var(--bs-bg-rgb-color), 0.5) !important;\n}\n\n.bg-opacity-75 {\n  background-color: rgba(var(--bs-bg-rgb-color), 0.75) !important;\n}\n\n.bg-hover-opacity-75:hover {\n  background-color: rgba(var(--bs-bg-rgb-color), 0.75) !important;\n}\n\n.bg-active-opacity-75.active {\n  background-color: rgba(var(--bs-bg-rgb-color), 0.75) !important;\n}\n\n.bg-state-opacity-75 .active, .bg-state-opacity-75:hover {\n  background-color: rgba(var(--bs-bg-rgb-color), 0.75) !important;\n}\n\n.bg-opacity-100 {\n  background-color: rgba(var(--bs-bg-rgb-color), 1) !important;\n}\n\n.bg-hover-opacity-100:hover {\n  background-color: rgba(var(--bs-bg-rgb-color), 1) !important;\n}\n\n.bg-active-opacity-100.active {\n  background-color: rgba(var(--bs-bg-rgb-color), 1) !important;\n}\n\n.bg-state-opacity-100 .active, .bg-state-opacity-100:hover {\n  background-color: rgba(var(--bs-bg-rgb-color), 1) !important;\n}\n\n.bgi-no-repeat {\n  background-repeat: no-repeat;\n}\n\n.bgi-position-y-top {\n  background-position-y: top;\n}\n\n.bgi-position-y-bottom {\n  background-position-y: bottom;\n}\n\n.bgi-position-y-center {\n  background-position-y: center;\n}\n\n.bgi-position-x-start {\n  background-position-x: left;\n}\n\n.bgi-position-x-end {\n  background-position-x: right;\n}\n\n.bgi-position-x-center {\n  background-position-x: center;\n}\n\n.bgi-position-top {\n  background-position: 0 top;\n}\n\n.bgi-position-bottom {\n  background-position: 0 bottom;\n}\n\n.bgi-position-center {\n  background-position: center;\n}\n\n.bgi-size-auto {\n  background-size: auto;\n}\n\n.bgi-size-cover {\n  background-size: cover;\n}\n\n.bgi-size-contain {\n  background-size: contain;\n}\n\n.bgi-attachment-fixed {\n  background-attachment: fixed;\n}\n\n.bgi-attachment-scroll {\n  background-attachment: scroll;\n}\n\n@media (min-width: 576px) {\n  .bgi-size-sm-auto {\n    background-size: auto;\n  }\n  .bgi-size-sm-cover {\n    background-size: cover;\n  }\n  .bgi-size-sm-contain {\n    background-size: contain;\n  }\n  .bgi-attachment-sm-fixed {\n    background-attachment: fixed;\n  }\n  .bgi-attachment-sm-scroll {\n    background-attachment: scroll;\n  }\n}\n@media (min-width: 768px) {\n  .bgi-size-md-auto {\n    background-size: auto;\n  }\n  .bgi-size-md-cover {\n    background-size: cover;\n  }\n  .bgi-size-md-contain {\n    background-size: contain;\n  }\n  .bgi-attachment-md-fixed {\n    background-attachment: fixed;\n  }\n  .bgi-attachment-md-scroll {\n    background-attachment: scroll;\n  }\n}\n@media (min-width: 992px) {\n  .bgi-size-lg-auto {\n    background-size: auto;\n  }\n  .bgi-size-lg-cover {\n    background-size: cover;\n  }\n  .bgi-size-lg-contain {\n    background-size: contain;\n  }\n  .bgi-attachment-lg-fixed {\n    background-attachment: fixed;\n  }\n  .bgi-attachment-lg-scroll {\n    background-attachment: scroll;\n  }\n}\n@media (min-width: 1200px) {\n  .bgi-size-xl-auto {\n    background-size: auto;\n  }\n  .bgi-size-xl-cover {\n    background-size: cover;\n  }\n  .bgi-size-xl-contain {\n    background-size: contain;\n  }\n  .bgi-attachment-xl-fixed {\n    background-attachment: fixed;\n  }\n  .bgi-attachment-xl-scroll {\n    background-attachment: scroll;\n  }\n}\n@media (min-width: 1400px) {\n  .bgi-size-xxl-auto {\n    background-size: auto;\n  }\n  .bgi-size-xxl-cover {\n    background-size: cover;\n  }\n  .bgi-size-xxl-contain {\n    background-size: contain;\n  }\n  .bgi-attachment-xxl-fixed {\n    background-attachment: fixed;\n  }\n  .bgi-attachment-xxl-scroll {\n    background-attachment: scroll;\n  }\n}\n.border-active:not(.active):not(:active):not(:hover):not(:focus) {\n  border-color: transparent !important;\n}\n\n.border-hover:not(:hover):not(:focus):not(.active):not(:active) {\n  cursor: pointer;\n  border-color: transparent !important;\n}\n\n.border-gray-100 {\n  border-color: var(--bs-gray-100) !important;\n}\n\n.border-gray-200 {\n  border-color: var(--bs-gray-200) !important;\n}\n\n.border-gray-300 {\n  border-color: var(--bs-gray-300) !important;\n}\n\n.border-gray-400 {\n  border-color: var(--bs-gray-400) !important;\n}\n\n.border-gray-500 {\n  border-color: var(--bs-gray-500) !important;\n}\n\n.border-gray-600 {\n  border-color: var(--bs-gray-600) !important;\n}\n\n.border-gray-700 {\n  border-color: var(--bs-gray-700) !important;\n}\n\n.border-gray-800 {\n  border-color: var(--bs-gray-800) !important;\n}\n\n.border-gray-900 {\n  border-color: var(--bs-gray-900) !important;\n}\n\n.border-hover-light:hover {\n  border-color: var(--bs-light) !important;\n}\n\n.border-active-light.active {\n  border-color: var(--bs-light) !important;\n}\n\n.border-hover-primary:hover {\n  border-color: var(--bs-primary) !important;\n}\n\n.border-active-primary.active {\n  border-color: var(--bs-primary) !important;\n}\n\n.border-hover-secondary:hover {\n  border-color: var(--bs-secondary) !important;\n}\n\n.border-active-secondary.active {\n  border-color: var(--bs-secondary) !important;\n}\n\n.border-hover-success:hover {\n  border-color: var(--bs-success) !important;\n}\n\n.border-active-success.active {\n  border-color: var(--bs-success) !important;\n}\n\n.border-hover-info:hover {\n  border-color: var(--bs-info) !important;\n}\n\n.border-active-info.active {\n  border-color: var(--bs-info) !important;\n}\n\n.border-hover-warning:hover {\n  border-color: var(--bs-warning) !important;\n}\n\n.border-active-warning.active {\n  border-color: var(--bs-warning) !important;\n}\n\n.border-hover-danger:hover {\n  border-color: var(--bs-danger) !important;\n}\n\n.border-active-danger.active {\n  border-color: var(--bs-danger) !important;\n}\n\n.border-hover-dark:hover {\n  border-color: var(--bs-dark) !important;\n}\n\n.border-active-dark.active {\n  border-color: var(--bs-dark) !important;\n}\n\n.border-hover-transparent:hover {\n  border-color: transparent !important;\n}\n\n.border-dashed {\n  border-style: dashed !important;\n  border-color: var(--bs-border-dashed-color);\n}\n\n.border-top-dashed {\n  border-top-style: dashed !important;\n}\n\n.border-bottom-dashed {\n  border-bottom-style: dashed !important;\n}\n\n.border-start-dashed {\n  border-left-style: dashed !important;\n}\n\n.border-end-dashed {\n  border-right-style: dashed !important;\n}\n\n.border-dotted {\n  border-style: dotted !important;\n}\n\n.border-top-dotted {\n  border-top-style: dotted !important;\n}\n\n.border-bottom-dotted {\n  border-bottom-style: dotted !important;\n}\n\n.border-start-dotted {\n  border-left-style: dotted !important;\n}\n\n.border-end-dotted {\n  border-right-style: dotted !important;\n}\n\n.border-transparent {\n  border-color: transparent !important;\n}\n\n.border-body {\n  border-color: var(--bs-body-bg) !important;\n}\n\n.rounded-top-0 {\n  border-top-left-radius: 0 !important;\n  border-top-right-radius: 0 !important;\n}\n\n.rounded-bottom-0 {\n  border-bottom-left-radius: 0 !important;\n  border-bottom-right-radius: 0 !important;\n}\n\n.rounded-start-0 {\n  border-top-left-radius: 0 !important;\n  border-bottom-left-radius: 0 !important;\n}\n\n.rounded-end-0 {\n  border-top-right-radius: 0 !important;\n  border-bottom-right-radius: 0 !important;\n}\n\n.rounded-circle {\n  border-radius: 50% !important;\n}\n\n.flex-root {\n  flex: 1;\n}\n\n.flex-column-auto {\n  flex: none;\n}\n\n.flex-column-fluid {\n  flex: 1 0 auto;\n}\n\n.flex-row-auto {\n  flex: 0 0 auto;\n}\n\n.flex-row-fluid {\n  flex: 1 auto;\n  min-width: 0;\n}\n\n.flex-center {\n  justify-content: center;\n  align-items: center;\n}\n\n.flex-start {\n  justify-content: start;\n  align-items: start;\n}\n\n.flex-end {\n  justify-content: flex-end;\n  align-items: flex-end;\n}\n\n.flex-stack {\n  justify-content: space-between;\n  align-items: center;\n}\n\n@media (min-width: 576px) {\n  .flex-sm-root {\n    flex: 1;\n  }\n  .flex-sm-column-auto {\n    flex: none;\n  }\n  .flex-sm-column-fluid {\n    flex: 1 0 auto;\n  }\n  .flex-sm-row-auto {\n    flex: 0 0 auto;\n  }\n  .flex-sm-row-fluid {\n    flex: 1 auto;\n    min-width: 0;\n  }\n  .flex-sm-center {\n    justify-content: center;\n    align-items: center;\n  }\n  .flex-sm-start {\n    justify-content: start;\n    align-items: start;\n  }\n  .flex-sm-end {\n    justify-content: flex-end;\n    align-items: flex-end;\n  }\n  .flex-sm-stack {\n    justify-content: space-between;\n    align-items: center;\n  }\n}\n@media (min-width: 768px) {\n  .flex-md-root {\n    flex: 1;\n  }\n  .flex-md-column-auto {\n    flex: none;\n  }\n  .flex-md-column-fluid {\n    flex: 1 0 auto;\n  }\n  .flex-md-row-auto {\n    flex: 0 0 auto;\n  }\n  .flex-md-row-fluid {\n    flex: 1 auto;\n    min-width: 0;\n  }\n  .flex-md-center {\n    justify-content: center;\n    align-items: center;\n  }\n  .flex-md-start {\n    justify-content: start;\n    align-items: start;\n  }\n  .flex-md-end {\n    justify-content: flex-end;\n    align-items: flex-end;\n  }\n  .flex-md-stack {\n    justify-content: space-between;\n    align-items: center;\n  }\n}\n@media (min-width: 992px) {\n  .flex-lg-root {\n    flex: 1;\n  }\n  .flex-lg-column-auto {\n    flex: none;\n  }\n  .flex-lg-column-fluid {\n    flex: 1 0 auto;\n  }\n  .flex-lg-row-auto {\n    flex: 0 0 auto;\n  }\n  .flex-lg-row-fluid {\n    flex: 1 auto;\n    min-width: 0;\n  }\n  .flex-lg-center {\n    justify-content: center;\n    align-items: center;\n  }\n  .flex-lg-start {\n    justify-content: start;\n    align-items: start;\n  }\n  .flex-lg-end {\n    justify-content: flex-end;\n    align-items: flex-end;\n  }\n  .flex-lg-stack {\n    justify-content: space-between;\n    align-items: center;\n  }\n}\n@media (min-width: 1200px) {\n  .flex-xl-root {\n    flex: 1;\n  }\n  .flex-xl-column-auto {\n    flex: none;\n  }\n  .flex-xl-column-fluid {\n    flex: 1 0 auto;\n  }\n  .flex-xl-row-auto {\n    flex: 0 0 auto;\n  }\n  .flex-xl-row-fluid {\n    flex: 1 auto;\n    min-width: 0;\n  }\n  .flex-xl-center {\n    justify-content: center;\n    align-items: center;\n  }\n  .flex-xl-start {\n    justify-content: start;\n    align-items: start;\n  }\n  .flex-xl-end {\n    justify-content: flex-end;\n    align-items: flex-end;\n  }\n  .flex-xl-stack {\n    justify-content: space-between;\n    align-items: center;\n  }\n}\n@media (min-width: 1400px) {\n  .flex-xxl-root {\n    flex: 1;\n  }\n  .flex-xxl-column-auto {\n    flex: none;\n  }\n  .flex-xxl-column-fluid {\n    flex: 1 0 auto;\n  }\n  .flex-xxl-row-auto {\n    flex: 0 0 auto;\n  }\n  .flex-xxl-row-fluid {\n    flex: 1 auto;\n    min-width: 0;\n  }\n  .flex-xxl-center {\n    justify-content: center;\n    align-items: center;\n  }\n  .flex-xxl-start {\n    justify-content: start;\n    align-items: start;\n  }\n  .flex-xxl-end {\n    justify-content: flex-end;\n    align-items: flex-end;\n  }\n  .flex-xxl-stack {\n    justify-content: space-between;\n    align-items: center;\n  }\n}\n.flex-equal {\n  flex-grow: 1;\n  flex-basis: 0;\n  flex-shrink: 0;\n}\n\n.shadow-xs {\n  box-shadow: var(--bs-box-shadow-xs);\n}\n\n.shadow-sm {\n  box-shadow: var(--bs-box-shadow-sm);\n}\n\n.shadow {\n  box-shadow: var(--bs-box-shadow);\n}\n\n.shadow-lg {\n  box-shadow: var(--bs-box-shadow-lg);\n}\n\n.text-white {\n  color: var(--bs-text-white) !important;\n}\n\n.text-hover-white {\n  transition: color 0.2s ease;\n}\n.text-hover-white i {\n  transition: color 0.2s ease;\n}\n.text-hover-white:hover {\n  transition: color 0.2s ease;\n  color: var(--bs-text-white) !important;\n}\n.text-hover-white:hover i {\n  transition: color 0.2s ease;\n  color: var(--bs-text-white) !important;\n}\n.text-hover-white:hover .svg-icon {\n  color: var(--bs-text-white) !important;\n}\n\n.text-active-white {\n  transition: color 0.2s ease;\n}\n.text-active-white i {\n  transition: color 0.2s ease;\n}\n.text-active-white.active {\n  transition: color 0.2s ease;\n  color: var(--bs-text-white) !important;\n}\n.text-active-white.active i {\n  transition: color 0.2s ease;\n  color: var(--bs-text-white) !important;\n}\n.text-active-white.active .svg-icon {\n  color: var(--bs-text-white) !important;\n}\n\n.text-primary {\n  color: var(--bs-text-primary) !important;\n}\n\n.text-inverse-primary {\n  color: var(--bs-primary-inverse) !important;\n}\n\n.text-light-primary {\n  color: var(--bs-primary-light) !important;\n}\n\n.text-hover-primary {\n  transition: color 0.2s ease;\n}\n.text-hover-primary i {\n  transition: color 0.2s ease;\n}\n.text-hover-primary:hover {\n  transition: color 0.2s ease;\n  color: var(--bs-text-primary) !important;\n}\n.text-hover-primary:hover i {\n  transition: color 0.2s ease;\n  color: var(--bs-text-primary) !important;\n}\n.text-hover-primary:hover .svg-icon {\n  color: var(--bs-text-primary) !important;\n}\n\n.text-active-primary {\n  transition: color 0.2s ease;\n}\n.text-active-primary i {\n  transition: color 0.2s ease;\n}\n.text-active-primary.active {\n  transition: color 0.2s ease;\n  color: var(--bs-text-primary) !important;\n}\n.text-active-primary.active i {\n  transition: color 0.2s ease;\n  color: var(--bs-text-primary) !important;\n}\n.text-active-primary.active .svg-icon {\n  color: var(--bs-text-primary) !important;\n}\n\n.text-secondary {\n  color: var(--bs-text-secondary) !important;\n}\n\n.text-inverse-secondary {\n  color: var(--bs-secondary-inverse) !important;\n}\n\n.text-light-secondary {\n  color: var(--bs-secondary-light) !important;\n}\n\n.text-hover-secondary {\n  transition: color 0.2s ease;\n}\n.text-hover-secondary i {\n  transition: color 0.2s ease;\n}\n.text-hover-secondary:hover {\n  transition: color 0.2s ease;\n  color: var(--bs-text-secondary) !important;\n}\n.text-hover-secondary:hover i {\n  transition: color 0.2s ease;\n  color: var(--bs-text-secondary) !important;\n}\n.text-hover-secondary:hover .svg-icon {\n  color: var(--bs-text-secondary) !important;\n}\n\n.text-active-secondary {\n  transition: color 0.2s ease;\n}\n.text-active-secondary i {\n  transition: color 0.2s ease;\n}\n.text-active-secondary.active {\n  transition: color 0.2s ease;\n  color: var(--bs-text-secondary) !important;\n}\n.text-active-secondary.active i {\n  transition: color 0.2s ease;\n  color: var(--bs-text-secondary) !important;\n}\n.text-active-secondary.active .svg-icon {\n  color: var(--bs-text-secondary) !important;\n}\n\n.text-light {\n  color: var(--bs-text-light) !important;\n}\n\n.text-inverse-light {\n  color: var(--bs-light-inverse) !important;\n}\n\n.text-hover-light {\n  transition: color 0.2s ease;\n}\n.text-hover-light i {\n  transition: color 0.2s ease;\n}\n.text-hover-light:hover {\n  transition: color 0.2s ease;\n  color: var(--bs-text-light) !important;\n}\n.text-hover-light:hover i {\n  transition: color 0.2s ease;\n  color: var(--bs-text-light) !important;\n}\n.text-hover-light:hover .svg-icon {\n  color: var(--bs-text-light) !important;\n}\n\n.text-active-light {\n  transition: color 0.2s ease;\n}\n.text-active-light i {\n  transition: color 0.2s ease;\n}\n.text-active-light.active {\n  transition: color 0.2s ease;\n  color: var(--bs-text-light) !important;\n}\n.text-active-light.active i {\n  transition: color 0.2s ease;\n  color: var(--bs-text-light) !important;\n}\n.text-active-light.active .svg-icon {\n  color: var(--bs-text-light) !important;\n}\n\n.text-success {\n  color: var(--bs-text-success) !important;\n}\n\n.text-inverse-success {\n  color: var(--bs-success-inverse) !important;\n}\n\n.text-light-success {\n  color: var(--bs-success-light) !important;\n}\n\n.text-hover-success {\n  transition: color 0.2s ease;\n}\n.text-hover-success i {\n  transition: color 0.2s ease;\n}\n.text-hover-success:hover {\n  transition: color 0.2s ease;\n  color: var(--bs-text-success) !important;\n}\n.text-hover-success:hover i {\n  transition: color 0.2s ease;\n  color: var(--bs-text-success) !important;\n}\n.text-hover-success:hover .svg-icon {\n  color: var(--bs-text-success) !important;\n}\n\n.text-active-success {\n  transition: color 0.2s ease;\n}\n.text-active-success i {\n  transition: color 0.2s ease;\n}\n.text-active-success.active {\n  transition: color 0.2s ease;\n  color: var(--bs-text-success) !important;\n}\n.text-active-success.active i {\n  transition: color 0.2s ease;\n  color: var(--bs-text-success) !important;\n}\n.text-active-success.active .svg-icon {\n  color: var(--bs-text-success) !important;\n}\n\n.text-info {\n  color: var(--bs-text-info) !important;\n}\n\n.text-inverse-info {\n  color: var(--bs-info-inverse) !important;\n}\n\n.text-light-info {\n  color: var(--bs-info-light) !important;\n}\n\n.text-hover-info {\n  transition: color 0.2s ease;\n}\n.text-hover-info i {\n  transition: color 0.2s ease;\n}\n.text-hover-info:hover {\n  transition: color 0.2s ease;\n  color: var(--bs-text-info) !important;\n}\n.text-hover-info:hover i {\n  transition: color 0.2s ease;\n  color: var(--bs-text-info) !important;\n}\n.text-hover-info:hover .svg-icon {\n  color: var(--bs-text-info) !important;\n}\n\n.text-active-info {\n  transition: color 0.2s ease;\n}\n.text-active-info i {\n  transition: color 0.2s ease;\n}\n.text-active-info.active {\n  transition: color 0.2s ease;\n  color: var(--bs-text-info) !important;\n}\n.text-active-info.active i {\n  transition: color 0.2s ease;\n  color: var(--bs-text-info) !important;\n}\n.text-active-info.active .svg-icon {\n  color: var(--bs-text-info) !important;\n}\n\n.text-warning {\n  color: var(--bs-text-warning) !important;\n}\n\n.text-inverse-warning {\n  color: var(--bs-warning-inverse) !important;\n}\n\n.text-light-warning {\n  color: var(--bs-warning-light) !important;\n}\n\n.text-hover-warning {\n  transition: color 0.2s ease;\n}\n.text-hover-warning i {\n  transition: color 0.2s ease;\n}\n.text-hover-warning:hover {\n  transition: color 0.2s ease;\n  color: var(--bs-text-warning) !important;\n}\n.text-hover-warning:hover i {\n  transition: color 0.2s ease;\n  color: var(--bs-text-warning) !important;\n}\n.text-hover-warning:hover .svg-icon {\n  color: var(--bs-text-warning) !important;\n}\n\n.text-active-warning {\n  transition: color 0.2s ease;\n}\n.text-active-warning i {\n  transition: color 0.2s ease;\n}\n.text-active-warning.active {\n  transition: color 0.2s ease;\n  color: var(--bs-text-warning) !important;\n}\n.text-active-warning.active i {\n  transition: color 0.2s ease;\n  color: var(--bs-text-warning) !important;\n}\n.text-active-warning.active .svg-icon {\n  color: var(--bs-text-warning) !important;\n}\n\n.text-danger {\n  color: var(--bs-text-danger) !important;\n}\n\n.text-inverse-danger {\n  color: var(--bs-danger-inverse) !important;\n}\n\n.text-light-danger {\n  color: var(--bs-danger-light) !important;\n}\n\n.text-hover-danger {\n  transition: color 0.2s ease;\n}\n.text-hover-danger i {\n  transition: color 0.2s ease;\n}\n.text-hover-danger:hover {\n  transition: color 0.2s ease;\n  color: var(--bs-text-danger) !important;\n}\n.text-hover-danger:hover i {\n  transition: color 0.2s ease;\n  color: var(--bs-text-danger) !important;\n}\n.text-hover-danger:hover .svg-icon {\n  color: var(--bs-text-danger) !important;\n}\n\n.text-active-danger {\n  transition: color 0.2s ease;\n}\n.text-active-danger i {\n  transition: color 0.2s ease;\n}\n.text-active-danger.active {\n  transition: color 0.2s ease;\n  color: var(--bs-text-danger) !important;\n}\n.text-active-danger.active i {\n  transition: color 0.2s ease;\n  color: var(--bs-text-danger) !important;\n}\n.text-active-danger.active .svg-icon {\n  color: var(--bs-text-danger) !important;\n}\n\n.text-dark {\n  color: var(--bs-text-dark) !important;\n}\n\n.text-inverse-dark {\n  color: var(--bs-dark-inverse) !important;\n}\n\n.text-light-dark {\n  color: var(--bs-dark-light) !important;\n}\n\n.text-hover-dark {\n  transition: color 0.2s ease;\n}\n.text-hover-dark i {\n  transition: color 0.2s ease;\n}\n.text-hover-dark:hover {\n  transition: color 0.2s ease;\n  color: var(--bs-text-dark) !important;\n}\n.text-hover-dark:hover i {\n  transition: color 0.2s ease;\n  color: var(--bs-text-dark) !important;\n}\n.text-hover-dark:hover .svg-icon {\n  color: var(--bs-text-dark) !important;\n}\n\n.text-active-dark {\n  transition: color 0.2s ease;\n}\n.text-active-dark i {\n  transition: color 0.2s ease;\n}\n.text-active-dark.active {\n  transition: color 0.2s ease;\n  color: var(--bs-text-dark) !important;\n}\n.text-active-dark.active i {\n  transition: color 0.2s ease;\n  color: var(--bs-text-dark) !important;\n}\n.text-active-dark.active .svg-icon {\n  color: var(--bs-text-dark) !important;\n}\n\n.text-muted {\n  /* color: var(--bs-text-muted) !important; */\n}\n\n.text-hover-muted {\n  transition: color 0.2s ease;\n}\n.text-hover-muted i {\n  transition: color 0.2s ease;\n}\n.text-hover-muted:hover {\n  transition: color 0.2s ease;\n  color: var(--bs-text-muted) !important;\n}\n.text-hover-muted:hover i {\n  transition: color 0.2s ease;\n  color: var(--bs-text-muted) !important;\n}\n.text-hover-muted:hover .svg-icon {\n  color: var(--bs-text-muted) !important;\n}\n\n.text-active-muted {\n  transition: color 0.2s ease;\n}\n.text-active-muted i {\n  transition: color 0.2s ease;\n}\n.text-active-muted.active {\n  transition: color 0.2s ease;\n  color: var(--bs-text-muted) !important;\n}\n.text-active-muted.active i {\n  transition: color 0.2s ease;\n  color: var(--bs-text-muted) !important;\n}\n.text-active-muted.active .svg-icon {\n  color: var(--bs-text-muted) !important;\n}\n\n.text-gray-100 {\n  color: var(--bs-text-gray-100) !important;\n}\n\n.text-hover-gray-100 {\n  transition: color 0.2s ease;\n}\n.text-hover-gray-100 i {\n  transition: color 0.2s ease;\n}\n.text-hover-gray-100:hover {\n  transition: color 0.2s ease;\n  color: var(--bs-text-gray-100) !important;\n}\n.text-hover-gray-100:hover i {\n  transition: color 0.2s ease;\n  color: var(--bs-text-gray-100) !important;\n}\n.text-hover-gray-100:hover .svg-icon {\n  color: var(--bs-text-gray-100) !important;\n}\n\n.text-active-gray-100 {\n  transition: color 0.2s ease;\n}\n.text-active-gray-100 i {\n  transition: color 0.2s ease;\n}\n.text-active-gray-100.active {\n  transition: color 0.2s ease;\n  color: var(--bs-text-gray-100) !important;\n}\n.text-active-gray-100.active i {\n  transition: color 0.2s ease;\n  color: var(--bs-text-gray-100) !important;\n}\n.text-active-gray-100.active .svg-icon {\n  color: var(--bs-text-gray-100) !important;\n}\n\n.text-gray-200 {\n  color: var(--bs-text-gray-200) !important;\n}\n\n.text-hover-gray-200 {\n  transition: color 0.2s ease;\n}\n.text-hover-gray-200 i {\n  transition: color 0.2s ease;\n}\n.text-hover-gray-200:hover {\n  transition: color 0.2s ease;\n  color: var(--bs-text-gray-200) !important;\n}\n.text-hover-gray-200:hover i {\n  transition: color 0.2s ease;\n  color: var(--bs-text-gray-200) !important;\n}\n.text-hover-gray-200:hover .svg-icon {\n  color: var(--bs-text-gray-200) !important;\n}\n\n.text-active-gray-200 {\n  transition: color 0.2s ease;\n}\n.text-active-gray-200 i {\n  transition: color 0.2s ease;\n}\n.text-active-gray-200.active {\n  transition: color 0.2s ease;\n  color: var(--bs-text-gray-200) !important;\n}\n.text-active-gray-200.active i {\n  transition: color 0.2s ease;\n  color: var(--bs-text-gray-200) !important;\n}\n.text-active-gray-200.active .svg-icon {\n  color: var(--bs-text-gray-200) !important;\n}\n\n.text-gray-300 {\n  color: var(--bs-text-gray-300) !important;\n}\n\n.text-hover-gray-300 {\n  transition: color 0.2s ease;\n}\n.text-hover-gray-300 i {\n  transition: color 0.2s ease;\n}\n.text-hover-gray-300:hover {\n  transition: color 0.2s ease;\n  color: var(--bs-text-gray-300) !important;\n}\n.text-hover-gray-300:hover i {\n  transition: color 0.2s ease;\n  color: var(--bs-text-gray-300) !important;\n}\n.text-hover-gray-300:hover .svg-icon {\n  color: var(--bs-text-gray-300) !important;\n}\n\n.text-active-gray-300 {\n  transition: color 0.2s ease;\n}\n.text-active-gray-300 i {\n  transition: color 0.2s ease;\n}\n.text-active-gray-300.active {\n  transition: color 0.2s ease;\n  color: var(--bs-text-gray-300) !important;\n}\n.text-active-gray-300.active i {\n  transition: color 0.2s ease;\n  color: var(--bs-text-gray-300) !important;\n}\n.text-active-gray-300.active .svg-icon {\n  color: var(--bs-text-gray-300) !important;\n}\n\n.text-gray-400 {\n  color: var(--bs-text-gray-400) !important;\n}\n\n.text-hover-gray-400 {\n  transition: color 0.2s ease;\n}\n.text-hover-gray-400 i {\n  transition: color 0.2s ease;\n}\n.text-hover-gray-400:hover {\n  transition: color 0.2s ease;\n  color: var(--bs-text-gray-400) !important;\n}\n.text-hover-gray-400:hover i {\n  transition: color 0.2s ease;\n  color: var(--bs-text-gray-400) !important;\n}\n.text-hover-gray-400:hover .svg-icon {\n  color: var(--bs-text-gray-400) !important;\n}\n\n.text-active-gray-400 {\n  transition: color 0.2s ease;\n}\n.text-active-gray-400 i {\n  transition: color 0.2s ease;\n}\n.text-active-gray-400.active {\n  transition: color 0.2s ease;\n  color: var(--bs-text-gray-400) !important;\n}\n.text-active-gray-400.active i {\n  transition: color 0.2s ease;\n  color: var(--bs-text-gray-400) !important;\n}\n.text-active-gray-400.active .svg-icon {\n  color: var(--bs-text-gray-400) !important;\n}\n\n.text-gray-500 {\n  color: var(--bs-text-gray-500) !important;\n}\n\n.text-hover-gray-500 {\n  transition: color 0.2s ease;\n}\n.text-hover-gray-500 i {\n  transition: color 0.2s ease;\n}\n.text-hover-gray-500:hover {\n  transition: color 0.2s ease;\n  color: var(--bs-text-gray-500) !important;\n}\n.text-hover-gray-500:hover i {\n  transition: color 0.2s ease;\n  color: var(--bs-text-gray-500) !important;\n}\n.text-hover-gray-500:hover .svg-icon {\n  color: var(--bs-text-gray-500) !important;\n}\n\n.text-active-gray-500 {\n  transition: color 0.2s ease;\n}\n.text-active-gray-500 i {\n  transition: color 0.2s ease;\n}\n.text-active-gray-500.active {\n  transition: color 0.2s ease;\n  color: var(--bs-text-gray-500) !important;\n}\n.text-active-gray-500.active i {\n  transition: color 0.2s ease;\n  color: var(--bs-text-gray-500) !important;\n}\n.text-active-gray-500.active .svg-icon {\n  color: var(--bs-text-gray-500) !important;\n}\n\n.text-gray-600 {\n  color: var(--bs-text-gray-600) !important;\n}\n\n.text-hover-gray-600 {\n  transition: color 0.2s ease;\n}\n.text-hover-gray-600 i {\n  transition: color 0.2s ease;\n}\n.text-hover-gray-600:hover {\n  transition: color 0.2s ease;\n  color: var(--bs-text-gray-600) !important;\n}\n.text-hover-gray-600:hover i {\n  transition: color 0.2s ease;\n  color: var(--bs-text-gray-600) !important;\n}\n.text-hover-gray-600:hover .svg-icon {\n  color: var(--bs-text-gray-600) !important;\n}\n\n.text-active-gray-600 {\n  transition: color 0.2s ease;\n}\n.text-active-gray-600 i {\n  transition: color 0.2s ease;\n}\n.text-active-gray-600.active {\n  transition: color 0.2s ease;\n  color: var(--bs-text-gray-600) !important;\n}\n.text-active-gray-600.active i {\n  transition: color 0.2s ease;\n  color: var(--bs-text-gray-600) !important;\n}\n.text-active-gray-600.active .svg-icon {\n  color: var(--bs-text-gray-600) !important;\n}\n\n.text-gray-700 {\n  color: var(--bs-text-gray-700) !important;\n}\n\n.text-hover-gray-700 {\n  transition: color 0.2s ease;\n}\n.text-hover-gray-700 i {\n  transition: color 0.2s ease;\n}\n.text-hover-gray-700:hover {\n  transition: color 0.2s ease;\n  color: var(--bs-text-gray-700) !important;\n}\n.text-hover-gray-700:hover i {\n  transition: color 0.2s ease;\n  color: var(--bs-text-gray-700) !important;\n}\n.text-hover-gray-700:hover .svg-icon {\n  color: var(--bs-text-gray-700) !important;\n}\n\n.text-active-gray-700 {\n  transition: color 0.2s ease;\n}\n.text-active-gray-700 i {\n  transition: color 0.2s ease;\n}\n.text-active-gray-700.active {\n  transition: color 0.2s ease;\n  color: var(--bs-text-gray-700) !important;\n}\n.text-active-gray-700.active i {\n  transition: color 0.2s ease;\n  color: var(--bs-text-gray-700) !important;\n}\n.text-active-gray-700.active .svg-icon {\n  color: var(--bs-text-gray-700) !important;\n}\n\n.text-gray-800 {\n  color: var(--bs-text-gray-800) !important;\n}\n\n.text-hover-gray-800 {\n  transition: color 0.2s ease;\n}\n.text-hover-gray-800 i {\n  transition: color 0.2s ease;\n}\n.text-hover-gray-800:hover {\n  transition: color 0.2s ease;\n  color: var(--bs-text-gray-800) !important;\n}\n.text-hover-gray-800:hover i {\n  transition: color 0.2s ease;\n  color: var(--bs-text-gray-800) !important;\n}\n.text-hover-gray-800:hover .svg-icon {\n  color: var(--bs-text-gray-800) !important;\n}\n\n.text-active-gray-800 {\n  transition: color 0.2s ease;\n}\n.text-active-gray-800 i {\n  transition: color 0.2s ease;\n}\n.text-active-gray-800.active {\n  transition: color 0.2s ease;\n  color: var(--bs-text-gray-800) !important;\n}\n.text-active-gray-800.active i {\n  transition: color 0.2s ease;\n  color: var(--bs-text-gray-800) !important;\n}\n.text-active-gray-800.active .svg-icon {\n  color: var(--bs-text-gray-800) !important;\n}\n\n.text-gray-900 {\n  color: var(--bs-text-gray-900) !important;\n}\n\n.text-hover-gray-900 {\n  transition: color 0.2s ease;\n}\n.text-hover-gray-900 i {\n  transition: color 0.2s ease;\n}\n.text-hover-gray-900:hover {\n  transition: color 0.2s ease;\n  color: var(--bs-text-gray-900) !important;\n}\n.text-hover-gray-900:hover i {\n  transition: color 0.2s ease;\n  color: var(--bs-text-gray-900) !important;\n}\n.text-hover-gray-900:hover .svg-icon {\n  color: var(--bs-text-gray-900) !important;\n}\n\n.text-active-gray-900 {\n  transition: color 0.2s ease;\n}\n.text-active-gray-900 i {\n  transition: color 0.2s ease;\n}\n.text-active-gray-900.active {\n  transition: color 0.2s ease;\n  color: var(--bs-text-gray-900) !important;\n}\n.text-active-gray-900.active i {\n  transition: color 0.2s ease;\n  color: var(--bs-text-gray-900) !important;\n}\n.text-active-gray-900.active .svg-icon {\n  color: var(--bs-text-gray-900) !important;\n}\n\n.parent-hover .parent-hover-white {\n  transition: color 0.2s ease;\n}\n.parent-hover:hover .parent-hover-white {\n  transition: color 0.2s ease;\n  color: var(--bs-text-white) !important;\n}\n.parent-hover .parent-hover-primary {\n  transition: color 0.2s ease;\n}\n.parent-hover:hover .parent-hover-primary {\n  transition: color 0.2s ease;\n  color: var(--bs-text-primary) !important;\n}\n.parent-hover .parent-hover-secondary {\n  transition: color 0.2s ease;\n}\n.parent-hover:hover .parent-hover-secondary {\n  transition: color 0.2s ease;\n  color: var(--bs-text-secondary) !important;\n}\n.parent-hover .parent-hover-light {\n  transition: color 0.2s ease;\n}\n.parent-hover:hover .parent-hover-light {\n  transition: color 0.2s ease;\n  color: var(--bs-text-light) !important;\n}\n.parent-hover .parent-hover-success {\n  transition: color 0.2s ease;\n}\n.parent-hover:hover .parent-hover-success {\n  transition: color 0.2s ease;\n  color: var(--bs-text-success) !important;\n}\n.parent-hover .parent-hover-info {\n  transition: color 0.2s ease;\n}\n.parent-hover:hover .parent-hover-info {\n  transition: color 0.2s ease;\n  color: var(--bs-text-info) !important;\n}\n.parent-hover .parent-hover-warning {\n  transition: color 0.2s ease;\n}\n.parent-hover:hover .parent-hover-warning {\n  transition: color 0.2s ease;\n  color: var(--bs-text-warning) !important;\n}\n.parent-hover .parent-hover-danger {\n  transition: color 0.2s ease;\n}\n.parent-hover:hover .parent-hover-danger {\n  transition: color 0.2s ease;\n  color: var(--bs-text-danger) !important;\n}\n.parent-hover .parent-hover-dark {\n  transition: color 0.2s ease;\n}\n.parent-hover:hover .parent-hover-dark {\n  transition: color 0.2s ease;\n  color: var(--bs-text-dark) !important;\n}\n.parent-hover .parent-hover-muted {\n  transition: color 0.2s ease;\n}\n.parent-hover:hover .parent-hover-muted {\n  transition: color 0.2s ease;\n  color: var(--bs-text-muted) !important;\n}\n.parent-hover .parent-hover-gray-100 {\n  transition: color 0.2s ease;\n}\n.parent-hover:hover .parent-hover-gray-100 {\n  transition: color 0.2s ease;\n  color: var(--bs-text-gray-100) !important;\n}\n.parent-hover .parent-hover-gray-200 {\n  transition: color 0.2s ease;\n}\n.parent-hover:hover .parent-hover-gray-200 {\n  transition: color 0.2s ease;\n  color: var(--bs-text-gray-200) !important;\n}\n.parent-hover .parent-hover-gray-300 {\n  transition: color 0.2s ease;\n}\n.parent-hover:hover .parent-hover-gray-300 {\n  transition: color 0.2s ease;\n  color: var(--bs-text-gray-300) !important;\n}\n.parent-hover .parent-hover-gray-400 {\n  transition: color 0.2s ease;\n}\n.parent-hover:hover .parent-hover-gray-400 {\n  transition: color 0.2s ease;\n  color: var(--bs-text-gray-400) !important;\n}\n.parent-hover .parent-hover-gray-500 {\n  transition: color 0.2s ease;\n}\n.parent-hover:hover .parent-hover-gray-500 {\n  transition: color 0.2s ease;\n  color: var(--bs-text-gray-500) !important;\n}\n.parent-hover .parent-hover-gray-600 {\n  transition: color 0.2s ease;\n}\n.parent-hover:hover .parent-hover-gray-600 {\n  transition: color 0.2s ease;\n  color: var(--bs-text-gray-600) !important;\n}\n.parent-hover .parent-hover-gray-700 {\n  transition: color 0.2s ease;\n}\n.parent-hover:hover .parent-hover-gray-700 {\n  transition: color 0.2s ease;\n  color: var(--bs-text-gray-700) !important;\n}\n.parent-hover .parent-hover-gray-800 {\n  transition: color 0.2s ease;\n}\n.parent-hover:hover .parent-hover-gray-800 {\n  transition: color 0.2s ease;\n  color: var(--bs-text-gray-800) !important;\n}\n.parent-hover .parent-hover-gray-900 {\n  transition: color 0.2s ease;\n}\n.parent-hover:hover .parent-hover-gray-900 {\n  transition: color 0.2s ease;\n  color: var(--bs-text-gray-900) !important;\n}\n\n.parent-active .parent-active-white {\n  transition: color 0.2s ease;\n}\n.parent-active.active .parent-active-white {\n  transition: color 0.2s ease;\n  color: var(--bs-text-white) !important;\n}\n.parent-active .parent-active-primary {\n  transition: color 0.2s ease;\n}\n.parent-active.active .parent-active-primary {\n  transition: color 0.2s ease;\n  color: var(--bs-text-primary) !important;\n}\n.parent-active .parent-active-secondary {\n  transition: color 0.2s ease;\n}\n.parent-active.active .parent-active-secondary {\n  transition: color 0.2s ease;\n  color: var(--bs-text-secondary) !important;\n}\n.parent-active .parent-active-light {\n  transition: color 0.2s ease;\n}\n.parent-active.active .parent-active-light {\n  transition: color 0.2s ease;\n  color: var(--bs-text-light) !important;\n}\n.parent-active .parent-active-success {\n  transition: color 0.2s ease;\n}\n.parent-active.active .parent-active-success {\n  transition: color 0.2s ease;\n  color: var(--bs-text-success) !important;\n}\n.parent-active .parent-active-info {\n  transition: color 0.2s ease;\n}\n.parent-active.active .parent-active-info {\n  transition: color 0.2s ease;\n  color: var(--bs-text-info) !important;\n}\n.parent-active .parent-active-warning {\n  transition: color 0.2s ease;\n}\n.parent-active.active .parent-active-warning {\n  transition: color 0.2s ease;\n  color: var(--bs-text-warning) !important;\n}\n.parent-active .parent-active-danger {\n  transition: color 0.2s ease;\n}\n.parent-active.active .parent-active-danger {\n  transition: color 0.2s ease;\n  color: var(--bs-text-danger) !important;\n}\n.parent-active .parent-active-dark {\n  transition: color 0.2s ease;\n}\n.parent-active.active .parent-active-dark {\n  transition: color 0.2s ease;\n  color: var(--bs-text-dark) !important;\n}\n.parent-active .parent-active-muted {\n  transition: color 0.2s ease;\n}\n.parent-active.active .parent-active-muted {\n  transition: color 0.2s ease;\n  color: var(--bs-text-muted) !important;\n}\n.parent-active .parent-active-gray-100 {\n  transition: color 0.2s ease;\n}\n.parent-active.active .parent-active-gray-100 {\n  transition: color 0.2s ease;\n  color: var(--bs-text-gray-100) !important;\n}\n.parent-active .parent-active-gray-200 {\n  transition: color 0.2s ease;\n}\n.parent-active.active .parent-active-gray-200 {\n  transition: color 0.2s ease;\n  color: var(--bs-text-gray-200) !important;\n}\n.parent-active .parent-active-gray-300 {\n  transition: color 0.2s ease;\n}\n.parent-active.active .parent-active-gray-300 {\n  transition: color 0.2s ease;\n  color: var(--bs-text-gray-300) !important;\n}\n.parent-active .parent-active-gray-400 {\n  transition: color 0.2s ease;\n}\n.parent-active.active .parent-active-gray-400 {\n  transition: color 0.2s ease;\n  color: var(--bs-text-gray-400) !important;\n}\n.parent-active .parent-active-gray-500 {\n  transition: color 0.2s ease;\n}\n.parent-active.active .parent-active-gray-500 {\n  transition: color 0.2s ease;\n  color: var(--bs-text-gray-500) !important;\n}\n.parent-active .parent-active-gray-600 {\n  transition: color 0.2s ease;\n}\n.parent-active.active .parent-active-gray-600 {\n  transition: color 0.2s ease;\n  color: var(--bs-text-gray-600) !important;\n}\n.parent-active .parent-active-gray-700 {\n  transition: color 0.2s ease;\n}\n.parent-active.active .parent-active-gray-700 {\n  transition: color 0.2s ease;\n  color: var(--bs-text-gray-700) !important;\n}\n.parent-active .parent-active-gray-800 {\n  transition: color 0.2s ease;\n}\n.parent-active.active .parent-active-gray-800 {\n  transition: color 0.2s ease;\n  color: var(--bs-text-gray-800) !important;\n}\n.parent-active .parent-active-gray-900 {\n  transition: color 0.2s ease;\n}\n.parent-active.active .parent-active-gray-900 {\n  transition: color 0.2s ease;\n  color: var(--bs-text-gray-900) !important;\n}\n\n.text-transparent {\n  color: transparent;\n}\n\n.cursor-pointer {\n  cursor: pointer;\n}\n\n.cursor-default {\n  cursor: default;\n}\n\n.cursor-move {\n  cursor: move;\n}\n\ni.bi, i[class^=fonticon-], i[class*=\" fonticon-\"], i[class^=fa-], i[class*=\" fa-\"], i[class^=la-], i[class*=\" la-\"] {\n  line-height: 1;\n  font-size: 1rem;\n  color: var(--bs-text-muted);\n}\n\na {\n  transition: color 0.2s ease;\n}\na:hover {\n  transition: color 0.2s ease;\n}\n\n.opacity-active-0.active {\n  opacity: 0 !important;\n}\n\n.opacity-state-0:hover, .opacity-state-0.active {\n  opacity: 0 !important;\n}\n\n.opacity-active-5.active {\n  opacity: 0.05 !important;\n}\n\n.opacity-state-5:hover, .opacity-state-5.active {\n  opacity: 0.05 !important;\n}\n\n.opacity-active-10.active {\n  opacity: 0.1 !important;\n}\n\n.opacity-state-10:hover, .opacity-state-10.active {\n  opacity: 0.1 !important;\n}\n\n.opacity-active-15.active {\n  opacity: 0.15 !important;\n}\n\n.opacity-state-15:hover, .opacity-state-15.active {\n  opacity: 0.15 !important;\n}\n\n.opacity-active-20.active {\n  opacity: 0.2 !important;\n}\n\n.opacity-state-20:hover, .opacity-state-20.active {\n  opacity: 0.2 !important;\n}\n\n.opacity-active-25.active {\n  opacity: 0.25 !important;\n}\n\n.opacity-state-25:hover, .opacity-state-25.active {\n  opacity: 0.25 !important;\n}\n\n.opacity-active-50.active {\n  opacity: 0.5 !important;\n}\n\n.opacity-state-50:hover, .opacity-state-50.active {\n  opacity: 0.5 !important;\n}\n\n.opacity-active-75.active {\n  opacity: 0.75 !important;\n}\n\n.opacity-state-75:hover, .opacity-state-75.active {\n  opacity: 0.75 !important;\n}\n\n.opacity-active-100.active {\n  opacity: 1 !important;\n}\n\n.opacity-state-100:hover, .opacity-state-100.active {\n  opacity: 1 !important;\n}\n\n.transform-90 {\n  transform: rotate(90deg);\n  transform-origin: right top;\n}\n\n.stepper.stepper-pills.stepper-multistep {\n  --bs-stepper-pills-size: 46px;\n  --bs-stepper-icon-border-radius: 9px;\n  --bs-stepper-icon-check-size: 1.25rem;\n  --bs-stepper-icon-bg-color: rgba(255, 255, 255, 0.03);\n  --bs-stepper-icon-bg-color-current: var(--bs-success);\n  --bs-stepper-icon-bg-color-completed: rgba(255, 255, 255, 0.03);\n  --bs-stepper-icon-border: 1px dashed rgba(255, 255, 255, 0.3);\n  --bs-stepper-icon-border-current: 0;\n  --bs-stepper-icon-border-completed: 1px dashed rgba(255, 255, 255, 0.3);\n  --bs-stepper-icon-number-color: var(--bs-white);\n  --bs-stepper-icon-number-color-current: var(--bs-white);\n  --bs-stepper-icon-number-color-completed: var(--bs-white);\n  --bs-stepper-icon-check-color-completed: var(--bs-success);\n  --bs-stepper-label-title-opacity: 0.7;\n  --bs-stepper-label-title-opacity-current: 1;\n  --bs-stepper-label-title-opacity-completed: 1;\n  --bs-stepper-label-title-color: var(--bs-white);\n  --bs-stepper-label-title-color-current: var(--bs-white);\n  --bs-stepper-label-title-color-completed: var(--bs-white);\n  --bs-stepper-label-desc-opacity: 0.7;\n  --bs-stepper-label-desc-opacity-current: 0.7;\n  --bs-stepper-label-desc-opacity-completed: 0.7;\n  --bs-stepper-label-desc-color: var(--bs-white);\n  --bs-stepper-label-desc-color-current: var(--bs-white);\n  --bs-stepper-label-desc-color-completed: var(--bs-white);\n  --bs-stepper-line-border: 1px dashed rgba(255, 255, 255, 0.3);\n}\n\n.landing-dark-bg {\n  background-color: #13263C;\n}\n\n.landing-dark-color {\n  color: #13263C;\n}\n\n.landing-dark-border {\n  border: 1px dashed #2C3F5B;\n}\n\n.landing-dark-separator {\n  border-top: 1px dashed #2C3F5B;\n}\n\n.landing-curve {\n  position: relative;\n}\n.landing-curve svg {\n  position: relative;\n  top: 0;\n  display: block;\n}\n\n.landing-header {\n  display: flex;\n  align-items: center;\n  height: 100px;\n}\n.landing-header .logo-default {\n  display: block;\n}\n.landing-header .logo-sticky {\n  display: none;\n}\n.landing-header .menu .menu-link.active {\n  color: #ffffff;\n}\n[data-kt-sticky-landing-header=on] .landing-header .menu .menu-link.active {\n  color: #009ef7;\n  background-color: rgba(239, 242, 245, 0.4);\n}\n[data-kt-sticky-landing-header=on] .landing-header {\n  padding: 0;\n  position: fixed;\n  top: 0;\n  right: 0;\n  left: 0;\n  z-index: 100;\n  background-color: #ffffff;\n  box-shadow: 0px 10px 30px 0px rgba(82, 63, 105, 0.05);\n  height: 70px;\n}\n[data-kt-sticky-landing-header=on] .landing-header .logo-sticky {\n  display: block;\n}\n[data-kt-sticky-landing-header=on] .landing-header .logo-default {\n  display: none;\n}\n\nbody[data-kt-sticky-landing-header=on] {\n  padding-top: 100px;\n}\n\n@media (max-width: 991.98px) {\n  .landing-header {\n    height: 70px;\n  }\n  .landing-header .landing-menu-wrapper {\n    position: relative;\n    overflow: auto;\n  }\n  [data-kt-sticky-landing-header=on] .landing-header {\n    height: 70px;\n  }\n  .landing-header .menu .menu-link.active {\n    color: #009ef7;\n    background-color: rgba(239, 242, 245, 0.4);\n  }\n  body[data-kt-sticky-landing-header=on] {\n    padding-top: 70px;\n  }\n}\n[data-bs-theme=light] {\n  --bs-app-bg-color: #f5f8fa;\n  --bs-app-blank-bg-color: #ffffff;\n  --bs-app-header-base-bg-color: #ffffff;\n  --bs-app-header-base-box-shadow: 0px 10px 30px 0px rgba(82, 63, 105, 0.05);\n  --bs-app-toolbar-base-bg-color: #ffffff;\n  --bs-app-toolbar-base-box-shadow: 0px 10px 30px 0px rgba(82, 63, 105, 0.05);\n  --bs-app-toolbar-base-border-top: 1px solid #F4F4F4;\n  --bs-app-footer-bg-color: #ffffff;\n  --bs-app-footer-box-shadow: 0px 10px 30px 0px rgba(82, 63, 105, 0.05);\n}\n\n[data-bs-theme=dark] {\n  --bs-app-bg-color: #151521;\n  --bs-app-blank-bg-color: #151521;\n  --bs-app-header-base-bg-color: #1e1e2d;\n  --bs-app-header-base-box-shadow: none;\n  --bs-app-toolbar-base-bg-color: #1a1a27;\n  --bs-app-toolbar-base-box-shadow: none;\n  --bs-app-toolbar-base-border-top: 0;\n  --bs-app-footer-bg-color: #1e1e2d;\n  --bs-app-footer-box-shadow: none;\n}\n\nhtml {\n  font-family: sans-serif;\n  text-size-adjust: 100%;\n}\n\nhtml,\nbody {\n  height: 100%;\n  margin: 0px;\n  padding: 0px;\n  -webkit-font-smoothing: antialiased;\n  -moz-osx-font-smoothing: grayscale;\n  font-size: 13px !important;\n  font-weight: 400;\n  font-family: Inter, Helvetica, \"sans-serif\";\n}\n@media (max-width: 991.98px) {\n  html,\nbody {\n    font-size: 12px !important;\n  }\n}\n@media (max-width: 767.98px) {\n  html,\nbody {\n    font-size: 12px !important;\n  }\n}\n\nbody {\n  display: flex;\n  flex-direction: column;\n}\nbody a:hover,\nbody a:active,\nbody a:focus {\n  text-decoration: none !important;\n}\n\ncanvas {\n  user-select: none;\n}\n\nrouter-outlet {\n  display: none;\n}\n\nbody,\n.app-default {\n  background-color: var(--bs-app-bg-color);\n}\n\n.app-blank {\n  background-color: var(--bs-app-blank-bg-color);\n}\n\n[data-kt-app-reset-transition=true] * {\n  transition: none !important;\n}\n\n.app-page {\n  display: flex;\n}\n\n[data-kt-app-page-loading=on] {\n  overflow: hidden;\n}\n\n[data-kt-app-page-loading=on] * {\n  transition: none !important;\n}\n\n.app-page-loader {\n  background: var(--bs-body-bg);\n  color: var(--bs-body-color);\n  position: fixed;\n  top: 0;\n  bottom: 0;\n  left: 0;\n  right: 0;\n  z-index: 10000;\n  display: none;\n}\n[data-kt-app-page-loading=on] .app-page-loader {\n  display: flex;\n  justify-content: center;\n  align-items: center;\n}\n\n@media (min-width: 992px) {\n  .app-container {\n    padding-left: 30px !important;\n    padding-right: 30px !important;\n  }\n  .app-container-fit-desktop {\n    padding-left: 0 !important;\n    padding-right: 0 !important;\n  }\n}\n@media (max-width: 991.98px) {\n  .app-container {\n    max-width: none;\n    padding-left: 20px !important;\n    padding-right: 20px !important;\n  }\n  .app-container-fit-mobile {\n    padding-left: 0 !important;\n    padding-right: 0 !important;\n  }\n}\n@media print {\n  .app-print-content-only {\n    padding: 0 !important;\n    background: none !important;\n  }\n  .app-print-content-only .app-wrapper,\n.app-print-content-only .app-page,\n.app-print-content-only .app-page-title,\n.app-print-content-only .app-content,\n.app-print-content-only .app-container {\n    background: none !important;\n    padding: 0 !important;\n    margin: 0 !important;\n  }\n  .app-print-content-only .app-aside,\n.app-print-content-only .app-aside-panel,\n.app-print-content-only .app-sidebar,\n.app-print-content-only .app-sidebar-panel,\n.app-print-content-only .app-header,\n.app-print-content-only .app-footer,\n.app-print-content-only .app-toolbar,\n.app-print-content-only .drawer,\n.app-print-content-only .scrolltop,\n.app-print-content-only .btn {\n    display: none !important;\n  }\n}\n.app-navbar {\n  display: flex;\n  align-items: stretch;\n}\n.app-navbar .app-navbar-item {\n  display: flex;\n  align-items: center;\n}\n.app-navbar.app-navbar-stretch .app-navbar-item {\n  align-items: stretch;\n}\n\n.app-header {\n  transition: none;\n  display: flex;\n  align-items: stretch;\n  background-color: var(--bs-app-header-base-bg-color);\n  box-shadow: var(--bs-app-header-base-box-shadow);\n  border-bottom: var(--bs-app-header-base-border-bottom);\n}\n\n@media (min-width: 992px) {\n  :root {\n    --bs-app-header-height: 70px;\n    --bs-app-header-height-actual: 70px;\n  }\n  [data-kt-app-header-sticky=on] {\n    --bs-app-header-height: 70px;\n    --bs-app-header-height-actual: 70px;\n  }\n  [data-kt-app-header-sticky=on][data-kt-app-header-stacked=true] {\n    --bs-app-header-height: calc(var(--bs-app-header-primary-height, 0px) + var(--bs-app-header-secondary-height, 0px) + var(--bs-app-header-tertiary-height, 0px));\n    --bs-app-header-height-actual: calc(70px + 70px + 70px);\n  }\n  [data-kt-app-header-minimize=on] {\n    --bs-app-header-height: 70px;\n  }\n  .app-header {\n    height: var(--bs-app-header-height);\n  }\n  [data-kt-app-header-fixed=true] .app-header {\n    z-index: 100;\n    position: fixed;\n    left: 0;\n    right: 0;\n    top: 0;\n  }\n  [data-kt-app-header-static=true] .app-header {\n    position: relative;\n  }\n  [data-kt-app-header-stacked=true] .app-header {\n    flex-direction: column;\n    height: calc(var(--bs-app-header-primary-height) + var(--bs-app-header-secondary-height, 0px) + var(--bs-app-header-tertiary-height, 0px));\n  }\n  [data-kt-app-header-sticky=on] .app-header {\n    position: fixed;\n    left: 0;\n    right: 0;\n    top: 0;\n    z-index: 100;\n    background-color: var(--bs-app-header-sticky-bg-color);\n    box-shadow: var(--bs-app-header-sticky-box-shadow);\n    border-bottom: var(--bs-app-header-sticky-border-bottom);\n  }\n  [data-kt-app-header-minimize=on] .app-header {\n    transition: none;\n    z-index: 100;\n    background-color: var(--bs-app-header-minimize-bg-color);\n    box-shadow: var(--bs-app-header-minimize-box-shadow);\n    border-bottom: var(--bs-app-header-minimize-border-bottom);\n  }\n  .app-header .app-header-mobile-drawer {\n    display: flex;\n  }\n  [data-kt-app-header-fixed=true][data-kt-app-sidebar-fixed=true][data-kt-app-sidebar-push-header=true] .app-header, [data-kt-app-header-fixed=true][data-kt-app-sidebar-sticky=on][data-kt-app-sidebar-push-header=true] .app-header {\n    left: calc(var(--bs-app-sidebar-width) + var(--bs-app-sidebar-gap-start, 0px) + var(--bs-app-sidebar-gap-end, 0px));\n  }\n  body:not([data-kt-app-header-fixed=true])[data-kt-app-sidebar-fixed=true][data-kt-app-sidebar-push-header=true] .app-header, body:not([data-kt-app-header-fixed=true])[data-kt-app-sidebar-sticky=on][data-kt-app-sidebar-push-header=true] .app-header {\n    margin-left: calc(var(--bs-app-sidebar-width) + var(--bs-app-sidebar-gap-start, 0px) + var(--bs-app-sidebar-gap-end, 0px));\n  }\n  [data-kt-app-header-fixed=true][data-kt-app-sidebar-panel-fixed=true][data-kt-app-sidebar-panel-push-header=true] .app-header, [data-kt-app-header-fixed=true][data-kt-app-sidebar-panel-sticky=on][data-kt-app-sidebar-panel-push-header=true] .app-header {\n    left: calc(var(--bs-app-sidebar-width) + var(--bs-app-sidebar-gap-start, 0px) + var(--bs-app-sidebar-gap-end, 0px) + var(--bs-app-sidebar-panel-width) + var(--bs-app-sidebar-panel-gap-start, 0px) + var(--bs-app-sidebar-panel-gap-end, 0px));\n  }\n  body:not([data-kt-app-header-fixed=true])[data-kt-app-sidebar-panel-fixed=true][data-kt-app-sidebar-panel-push-header=true] .app-header, body:not([data-kt-app-header-fixed=true])[data-kt-app-sidebar-panel-sticky=on][data-kt-app-sidebar-panel-push-header=true] .app-header {\n    margin-left: calc(var(--bs-app-sidebar-width) + var(--bs-app-sidebar-gap-start, 0px) + var(--bs-app-sidebar-gap-end, 0px) + var(--bs-app-sidebar-panel-width) + var(--bs-app-sidebar-panel-gap-start, 0px) + var(--bs-app-sidebar-panel-gap-end, 0px));\n  }\n  [data-kt-app-header-fixed=true][data-kt-app-toolbar-fixed=true] .app-header {\n    box-shadow: none;\n  }\n}\n@media (max-width: 991.98px) {\n  :root {\n    --bs-app-header-height: 60px;\n  }\n  [data-kt-app-header-sticky=on] {\n    --bs-app-header-height: 70px;\n    --bs-app-header-height-actual: 70px;\n  }\n  [data-kt-app-header-minimize=on] {\n    --bs-app-header-height: 70px;\n    --bs-app-header-height-actual: 70px;\n  }\n  .app-header {\n    height: var(--bs-app-header-height);\n    align-items: stretch;\n  }\n  .app-header .app-header-mobile-drawer {\n    display: none;\n  }\n  [data-kt-app-header-stacked=true] .app-header {\n    flex-direction: column;\n    height: calc(var(--bs-app-header-primary-height) + var(--bs-app-header-secondary-height, 0px) + var(--bs-app-header-tertiary-height, 0px));\n  }\n  [data-kt-app-header-fixed-mobile=true] .app-header {\n    z-index: 100;\n    transition: none;\n    position: fixed;\n    left: 0;\n    right: 0;\n    top: 0;\n  }\n  [data-kt-app-header-sticky=on] .app-header {\n    position: fixed;\n    left: 0;\n    right: 0;\n    top: 0;\n    z-index: 100;\n    background-color: var(--bs-app-header-sticky-bg-color);\n    box-shadow: var(--bs-app-header-sticky-box-shadow);\n    border-bottom: var(--bs-app-header-sticky-border-bottom);\n  }\n  [data-kt-app-header-minimize=on] .app-header {\n    z-index: 100;\n    transition: none;\n    background-color: var(--bs-app-header-minimize-bg-color);\n    box-shadow: var(--bs-app-header-minimize-box-shadow);\n    border-bottom: var(--bs-app-header-minimize-border-bottom);\n  }\n  [data-kt-app-header-fixed-mobile=true][data-kt-app-toolbar-fixed-mobile=true] .app-header {\n    box-shadow: none;\n  }\n  [data-kt-app-header-fixed-mobile=true][data-kt-app-toolbar-sticky=on] .app-header {\n    box-shadow: none;\n  }\n}\n.app-header-primary {\n  transition: none;\n  display: flex;\n  align-items: stretch;\n}\n\n@media (min-width: 992px) {\n  .app-header-primary {\n    background-color: var(--bs-app-header-primary-base-bg-color);\n    box-shadow: var(--bs-app-header-primary-base-box-shadow);\n    border-bottom: var(--bs-app-header-primary-base-border-bottom);\n  }\n  [data-kt-app-header-primary-enabled=true] {\n    --bs-app-header-primary-height: 70px;\n  }\n  [data-kt-app-header-primary-enabled=true][data-kt-app-header-sticky=on] {\n    --bs-app-header-primary-height: 70px;\n  }\n  [data-kt-app-header-primary-enabled=true][data-kt-app-header-minimize=on] {\n    --bs-app-header-primary-height: 70px;\n  }\n  [data-kt-app-header-primary-enabled=true][data-kt-app-header-sticky=on][data-kt-app-header-primary-sticky-hide=true] {\n    --bs-app-header-primary-height: 0;\n  }\n  .app-header-primary {\n    height: var(--bs-app-header-primary-height);\n  }\n  [data-kt-app-header-primary-fixed=true] .app-header-primary {\n    z-index: 100;\n    position: fixed;\n    left: 0;\n    right: 0;\n    top: 0;\n  }\n  [data-kt-app-header-primary-static=true] .app-header-primary {\n    position: relative;\n  }\n  [data-kt-app-header-primary-sticky=on] .app-header-primary {\n    position: fixed;\n    left: 0;\n    right: 0;\n    top: 0;\n    height: 70px;\n    z-index: 100;\n    background-color: var(--bs-app-header-primary-sticky-bg-color);\n    box-shadow: var(--bs-app-header-primary-sticky-box-shadow);\n    border-bottom: var(--bs-app-header-primary-sticky-border-bottom);\n  }\n  [data-kt-app-header-primary-minimize=on] .app-header-primary {\n    transition: none;\n    height: 70px;\n    z-index: 100;\n    background-color: var(--bs-app-header-primary-minimize-bg-color);\n    box-shadow: var(--bs-app-header-primary-minimize-box-shadow);\n    border-bottom: var(--bs-app-header-primary-minimize-border-bottom);\n  }\n  [data-kt-app-header-sticky=on][data-kt-app-header-primary-sticky-hide=true] .app-header-primary {\n    display: none !important;\n  }\n  [data-kt-app-header-primary-enabled=true][data-kt-app-sidebar-fixed=true][data-kt-app-sidebar-push-header=true] .app-header-primary {\n    left: calc(var(--bs-app-sidebar-width) + var(--bs-app-sidebar-gap-start, 0px) + var(--bs-app-sidebar-gap-end, 0px));\n  }\n  [data-kt-app-header-primary-enabled=true][data-kt-app-sidebar-panel-fixed=true][data-kt-app-sidebar-panel-push-header=true] .app-header-primary {\n    left: calc(var(--bs-app-sidebar-width) + var(--bs-app-sidebar-gap-start, 0px) + var(--bs-app-sidebar-gap-end, 0px) + var(--bs-app-sidebar-panel-width) + var(--bs-app-sidebar-panel-gap-start, 0px) + var(--bs-app-sidebar-panel-gap-end, 0px));\n  }\n}\n@media (max-width: 991.98px) {\n  .app-header .app-header-primary {\n    flex-grow: 1;\n    height: var(--bs-app-header-primary-height);\n    border-bottom: var(--bs-app-header-primary-base-border-bottom);\n    box-shadow: var(--bs-app-header-primary-base-box-shadow);\n  }\n  .app-header-primary {\n    background-color: var(--bs-app-header-primary-base-bg-color);\n  }\n  [data-kt-app-header-primary-enabled=true] {\n    --bs-app-header-primary-height: 60px;\n  }\n  [data-kt-app-header-primary-enabled=true][data-kt-app-header-sticky=on] {\n    --bs-app-header-primary-height: 60px;\n  }\n  [data-kt-app-header-primary-enabled=true][data-kt-app-header-minimize=on] {\n    --bs-app-header-primary-height: 60px;\n  }\n}\n.app-header-secondary {\n  transition: none;\n  display: flex;\n  align-items: stretch;\n}\n\n@media (min-width: 992px) {\n  .app-header-secondary {\n    background-color: var(--bs-app-header-secondary-base-bg-color);\n    box-shadow: var(--bs-app-header-secondary-base-box-shadow);\n    border-top: var(--bs-app-header-secondary-base-border-top);\n    border-bottom: var(--bs-app-header-secondary-base-border-bottom);\n  }\n  [data-kt-app-header-secondary-enabled=true] {\n    --bs-app-header-secondary-height: 70px;\n  }\n  [data-kt-app-header-secondary-enabled=true][data-kt-app-header-sticky=on] {\n    --bs-app-header-secondary-height: 70px;\n  }\n  [data-kt-app-header-secondary-enabled=true][data-kt-app-header-minimize=on] {\n    --bs-app-header-secondary-height: 70px;\n  }\n  [data-kt-app-header-secondary-enabled=true][data-kt-app-header-sticky=on][data-kt-app-header-secondary-sticky-hide=true] {\n    --bs-app-header-secondary-height: 0;\n  }\n  .app-header-secondary {\n    height: var(--bs-app-header-secondary-height);\n  }\n  [data-kt-app-header-secondary-fixed=true] .app-header-secondary {\n    z-index: 100;\n    position: fixed;\n    left: 0;\n    right: 0;\n    top: 0;\n  }\n  [data-kt-app-header-secondary-static=true] .app-header-secondary {\n    position: static;\n  }\n  [data-kt-app-header-secondary-sticky=on] .app-header-secondary {\n    transition: none;\n    position: fixed;\n    left: 0;\n    right: 0;\n    top: 0;\n    height: 70px;\n    z-index: 100;\n    background-color: var(--bs-app-header-secondary-sticky-bg-color);\n    box-shadow: var(--bs-app-header-secondary-sticky-box-shadow);\n    border-bottom: var(--bs-app-header-secondary-sticky-border-bottom);\n  }\n  [data-kt-app-header-secondary-minimize=on] .app-header-secondary {\n    transition: none;\n    height: 70px;\n    z-index: 100;\n    background-color: var(--bs-app-header-secondary-minimize-bg-color);\n    box-shadow: var(--bs-app-header-secondary-minimize-box-shadow);\n    border-bottom: var(--bs-app-header-secondary-minimize-border-bottom);\n  }\n  [data-kt-app-header-sticky=on][data-kt-app-header-secondary-sticky-hide=true] .app-header-secondary {\n    display: none !important;\n  }\n  [data-kt-app-header-secondary-enabled=true][data-kt-app-sidebar-fixed=true][data-kt-app-sidebar-push-header=true] .app-header-secondary {\n    left: calc(var(--bs-app-sidebar-width) + var(--bs-app-sidebar-gap-start, 0px) + var(--bs-app-sidebar-gap-end, 0px));\n  }\n  [data-kt-app-header-secondary-enabled=true][data-kt-app-sidebar-panel-fixed=true][data-kt-app-sidebar-panel-push-header=true] .app-header-secondary {\n    left: calc(var(--bs-app-sidebar-width) + var(--bs-app-sidebar-gap-start, 0px) + var(--bs-app-sidebar-gap-end, 0px) + var(--bs-app-sidebar-panel-width) + var(--bs-app-sidebar-panel-gap-start, 0px) + var(--bs-app-sidebar-panel-gap-end, 0px));\n  }\n}\n@media (max-width: 991.98px) {\n  .app-header .app-header-secondary {\n    flex-grow: 1;\n    height: var(--bs-app-header-secondary-height);\n    box-shadow: var(--bs-app-header-secondary-base-box-shadow);\n    border-top: var(--bs-app-header-secondary-base-border-top);\n    border-bottom: var(--bs-app-header-secondary-base-border-bottom);\n  }\n  .app-header-secondary {\n    background-color: var(--bs-app-header-secondary-base-bg-color);\n  }\n  [data-kt-app-header-secondary-enabled=true] {\n    --bs-app-header-secondary-height: 60px;\n  }\n  [data-kt-app-header-secondary-enabled=true][data-kt-app-header-sticky=on] {\n    --bs-app-header-secondary-height: 60px;\n  }\n  [data-kt-app-header-secondary-enabled=true][data-kt-app-header-minimize=on] {\n    --bs-app-header-secondary-height: 60px;\n  }\n}\n.app-header-tertiary {\n  transition: none;\n  display: flex;\n  align-items: stretch;\n}\n\n@media (min-width: 992px) {\n  .app-header-tertiary {\n    background-color: var(--bs-app-header-tertiary-base-bg-color);\n    box-shadow: var(--bs-app-header-tertiary-base-box-shadow);\n    border-top: var(--bs-app-header-tertiary-base-border-top);\n    border-bottom: var(--bs-app-header-tertiary-base-border-bottom);\n  }\n  [data-kt-app-header-tertiary-enabled=true] {\n    --bs-app-header-tertiary-height: 70px;\n  }\n  [data-kt-app-header-tertiary-enabled=true][data-kt-app-header-sticky=on] {\n    --bs-app-header-tertiary-height: 70px;\n  }\n  [data-kt-app-header-tertiary-enabled=true][data-kt-app-header-minimize=on] {\n    --bs-app-header-tertiary-height: 70px;\n  }\n  [data-kt-app-header-tertiary-enabled=true][data-kt-app-header-sticky=on][data-kt-app-header-tertiary-sticky-hide=true] {\n    --bs-app-header-tertiary-height: 0;\n  }\n  .app-header-tertiary {\n    height: var(--bs-app-header-tertiary-height);\n  }\n  [data-kt-app-header-tertiary-fixed=true] .app-header-tertiary {\n    z-index: 100;\n    position: fixed;\n    left: 0;\n    right: 0;\n    top: 0;\n  }\n  [data-kt-app-header-tertiary-static=true] .app-header-tertiary {\n    position: static;\n  }\n  [data-kt-app-header-tertiary-sticky=on] .app-header-tertiary {\n    transition: none;\n    position: fixed;\n    left: 0;\n    right: 0;\n    top: 0;\n    height: 70px;\n    z-index: 100;\n    background-color: var(--bs-app-header-tertiary-sticky-bg-color);\n    box-shadow: var(--bs-app-header-tertiary-sticky-box-shadow);\n    border-bottom: var(--bs-app-header-tertiary-sticky-border-bottom);\n  }\n  [data-kt-app-header-tertiary-minimize=on] .app-header-tertiary {\n    transition: none;\n    height: 70px;\n    z-index: 100;\n    background-color: var(--bs-app-header-tertiary-minimize-bg-color);\n    box-shadow: var(--bs-app-header-tertiary-minimize-box-shadow);\n    border-bottom: var(--bs-app-header-tertiary-minimize-border-bottom);\n  }\n  [data-kt-app-header-sticky=on][data-kt-app-header-tertiary-sticky-hide=true] .app-header-tertiary {\n    display: none !important;\n  }\n  [data-kt-app-header-tertiary-enabled=true][data-kt-app-sidebar-fixed=true][data-kt-app-sidebar-push-header=true] .app-header-tertiary {\n    left: calc(var(--bs-app-sidebar-width) + var(--bs-app-sidebar-gap-start, 0px) + var(--bs-app-sidebar-gap-end, 0px));\n  }\n  [data-kt-app-header-tertiary-enabled=true][data-kt-app-sidebar-panel-fixed=true][data-kt-app-sidebar-panel-push-header=true] .app-header-tertiary {\n    left: calc(var(--bs-app-sidebar-width) + var(--bs-app-sidebar-gap-start, 0px) + var(--bs-app-sidebar-gap-end, 0px) + var(--bs-app-sidebar-panel-width) + var(--bs-app-sidebar-panel-gap-start, 0px) + var(--bs-app-sidebar-panel-gap-end, 0px));\n  }\n}\n@media (max-width: 991.98px) {\n  .app-header .app-header-tertiary {\n    flex-grow: 1;\n    height: var(--bs-app-header-tertiary-height);\n    border-top: var(--bs-app-header-tertiary-base-border-top);\n    box-shadow: var(--bs-app-header-tertiary-base-box-shadow);\n  }\n  .app-header-tertiary {\n    background-color: var(--bs-app-header-tertiary-base-bg-color);\n  }\n  [data-kt-app-header-tertiary-enabled=true] {\n    --bs-app-header-tertiary-height: 70px;\n  }\n  [data-kt-app-header-tertiary-enabled=true][data-kt-app-header-sticky=on] {\n    --bs-app-header-tertiary-height: 60px;\n  }\n  [data-kt-app-header-secondary-enabled=true][data-kt-app-header-minimize=on] {\n    --bs-app-header-tertiary-height: 60px;\n  }\n}\n.app-toolbar {\n  display: flex;\n  align-items: stretch;\n  background-color: var(--bs-app-toolbar-base-bg-color);\n  box-shadow: var(--bs-app-toolbar-base-box-shadow);\n  border-top: var(--bs-app-toolbar-base-border-top);\n  border-bottom: var(--bs-app-toolbar-base-border-bottom);\n}\n.app-toolbar.app-toolbar-minimize {\n  transition: none;\n}\n\n@media (min-width: 992px) {\n  :root {\n    --bs-app-toolbar-height: 55px;\n    --bs-app-toolbar-height-actual: 55px;\n  }\n  [data-kt-app-toolbar-sticky=on] {\n    --bs-app-toolbar-height: 70px;\n  }\n  [data-kt-app-toolbar-minimize=on] {\n    --bs-app-toolbar-height: 70px;\n  }\n  .app-toolbar {\n    height: var(--bs-app-toolbar-height);\n  }\n  [data-kt-app-header-fixed=true][data-kt-app-toolbar-fixed=true] .app-toolbar {\n    z-index: 99;\n    position: fixed;\n    left: 0;\n    right: 0;\n    top: 0;\n  }\n  [data-kt-app-toolbar-sticky=on] .app-toolbar {\n    position: fixed;\n    left: 0;\n    right: 0;\n    top: 0;\n    box-shadow: var(--bs-app-toolbar-sticky-box-shadow);\n    background-color: var(--bs-app-toolbar-sticky-bg-color);\n    border-top: var(--bs-app-toolbar-sticky-border-top);\n    border-bottom: var(--bs-app-toolbar-sticky-border-bottom);\n    z-index: 99;\n  }\n  [data-kt-app-toolbar-minimize=on] .app-toolbar {\n    transition: none;\n    box-shadow: var(--bs-app-toolbar-minimize-box-shadow);\n    background-color: var(--bs-app-toolbar-minimize-bg-color);\n    border-top: var(--bs-app-toolbar-minimize-border-top);\n    border-bottom: var(--bs-app-toolbar-minimize-border-bottom);\n    z-index: 99;\n  }\n  [data-kt-app-toolbar-fixed=true][data-kt-app-header-fixed=true] .app-toolbar {\n    top: var(--bs-app-header-height);\n  }\n  [data-kt-app-toolbar-sticky=on][data-kt-app-sidebar-fixed=true][data-kt-app-sidebar-push-toolbar=true] .app-toolbar, [data-kt-app-toolbar-fixed=true][data-kt-app-sidebar-fixed=true][data-kt-app-sidebar-push-toolbar=true] .app-toolbar {\n    left: calc(var(--bs-app-sidebar-width) + var(--bs-app-sidebar-gap-start, 0px) + var(--bs-app-sidebar-gap-end, 0px));\n  }\n  [data-kt-app-toolbar-sticky=on][data-kt-app-sidebar-panel-fixed=true][data-kt-app-sidebar-panel-push-toolbar=true] .app-toolbar, [data-kt-app-toolbar-fixed=true][data-kt-app-sidebar-panel-fixed=true][data-kt-app-sidebar-panel-push-toolbar=true] .app-toolbar {\n    left: calc(var(--bs-app-sidebar-width) + var(--bs-app-sidebar-gap-start, 0px) + var(--bs-app-sidebar-gap-end, 0px) + var(--bs-app-sidebar-panel-width) + var(--bs-app-sidebar-panel-gap-start, 0px) + var(--bs-app-sidebar-panel-gap-end, 0px));\n  }\n  [data-kt-app-toolbar-sticky=on][data-kt-app-aside-fixed=true][data-kt-app-aside-push-toolbar=true] .app-toolbar, [data-kt-app-toolbar-fixed=true][data-kt-app-aside-fixed=true][data-kt-app-aside-push-toolbar=true] .app-toolbar {\n    right: calc(var(--bs-app-aside-width) + var(--bs-app-aside-gap-start, 0px) + var(--bs-app-aside-gap-end, 0px));\n  }\n}\n@media (max-width: 991.98px) {\n  :root {\n    --bs-app-toolbar-height: ;\n  }\n  [data-kt-app-toolbar-sticky=on] {\n    --bs-app-toolbar-height: 70px;\n  }\n  [data-kt-app-toolbar-minimize=on] {\n    --bs-app-toolbar-height: 70px;\n  }\n  .app-toolbar {\n    height: var(--bs-app-toolbar-height);\n  }\n  [data-kt-app-header-fixed-mobile=true][data-kt-app-toolbar-fixed-mobile=true] .app-toolbar {\n    z-index: 99;\n    position: fixed;\n    top: calc(var(--bs-app-header-height, 0px) + var(--bs-app-header-mobile-height, 0px));\n    left: 0;\n    right: 0;\n  }\n  [data-kt-app-toolbar-sticky=on] .app-toolbar {\n    position: fixed;\n    left: 0;\n    right: 0;\n    top: var(--bs-app-header-height, 0px);\n    box-shadow: var(--bs-app-toolbar-sticky-box-shadow);\n    background-color: var(--bs-app-toolbar-sticky-bg-color);\n    border-top: var(--bs-app-toolbar-sticky-border-top);\n    border-bottom: var(--bs-app-toolbar-sticky-border-bottom);\n    z-index: 99;\n  }\n  [data-kt-app-toolbar-minimize=on] .app-toolbar {\n    transition: none;\n    box-shadow: var(--bs-app-toolbar-minimize-box-shadow);\n    background-color: var(--bs-app-toolbar-minimize-bg-color);\n    border-top: var(--bs-app-toolbar-minimize-border-top);\n    border-bottom: var(--bs-app-toolbar-minimize-border-bottom);\n    z-index: 99;\n  }\n}\n.app-hero {\n  display: flex;\n  align-items: stretch;\n  background-color: var(--bs-app-hero-bg-color);\n  box-shadow: var(--bs-app-hero-box-shadow);\n  border-top: var(--bs-app-hero-border-top);\n  border-bottom: var(--bs-app-hero-border-bottom);\n}\n\n.app-sidebar {\n  transition: width 0.3s ease;\n  background-color: var(--bs-app-sidebar-base-bg-color);\n  box-shadow: var(--bs-app-sidebar-base-box-shadow);\n  border-left: var(--bs-app-sidebar-base-border-start);\n  border-right: var(--bs-app-sidebar-base-border-end);\n}\n\n.app-sidebar-minimize-d-flex,\n.app-sidebar-sticky-d-flex,\n.app-sidebar-collapse-d-flex,\n.app-sidebar-minimize-mobile-d-flex,\n.app-sidebar-collapse-mobile-d-flex {\n  display: none;\n}\n\n@media (min-width: 992px) {\n  .app-sidebar {\n    display: flex;\n    flex-shrink: 0;\n    width: var(--bs-app-sidebar-width);\n    margin-left: 0px;\n    margin-right: 0px;\n    margin-top: 0px;\n    margin-bottom: 0px;\n  }\n  :root {\n    --bs-app-sidebar-width: 265px;\n    --bs-app-sidebar-width-actual: 265px;\n    --bs-app-sidebar-gap-start: 0px;\n    --bs-app-sidebar-gap-end: 0px;\n    --bs-app-sidebar-gap-top: 0px;\n    --bs-app-sidebar-gap-bottom: 0px;\n  }\n  [data-kt-app-sidebar-stacked=true] {\n    --bs-app-sidebar-width: calc(var(--bs-app-sidebar-primary-width) + var(--bs-app-sidebar-secondary-width, 0px));\n  }\n  [data-kt-app-sidebar-minimize=on] {\n    --bs-app-sidebar-width: 75px;\n    --bs-app-sidebar-gap-start: 0px;\n    --bs-app-sidebar-gap-end: 0px;\n    --bs-app-sidebar-gap-top: 0px;\n    --bs-app-sidebar-gap-bottom: 0px;\n  }\n  [data-kt-app-sidebar-sticky=on] {\n    --bs-app-sidebar-width: 300px;\n    --bs-app-sidebar-gap-start: 0px;\n    --bs-app-sidebar-gap-end: 0px;\n    --bs-app-sidebar-gap-top: 0px;\n    --bs-app-sidebar-gap-bottom: 0px;\n  }\n  [data-kt-app-sidebar-collapse=on] {\n    --bs-app-sidebar-width: 0px;\n  }\n  [data-kt-app-sidebar-static=true] .app-sidebar {\n    position: relative;\n  }\n  [data-kt-app-sidebar-offcanvas=true] .app-sidebar {\n    display: none;\n  }\n  [data-kt-app-sidebar-fixed=true] .app-sidebar {\n    position: fixed;\n    z-index: 105;\n    top: 0;\n    bottom: 0;\n    left: 0;\n  }\n  [data-kt-app-sidebar-stacked=true] .app-sidebar {\n    align-items: stretch;\n  }\n  [data-kt-app-sidebar-sticky=on] .app-sidebar {\n    position: fixed;\n    transition: width 0.3s ease;\n    top: auto;\n    bottom: auto;\n    left: auto;\n    z-index: 105;\n    box-shadow: var(--bs-app-sidebar-sticky-box-shadow);\n    border-left: var(--bs-app-sidebar-sticky-border-start);\n    border-right: var(--bs-app-sidebar-sticky-border-end);\n    margin-left: 0px;\n    margin-right: 0px;\n    margin-top: 0px;\n    margin-bottom: 0px;\n  }\n  [data-kt-app-sidebar-minimize=on] .app-sidebar {\n    transition: width 0.3s ease;\n    margin-left: 0px;\n    margin-right: 0px;\n    margin-top: 0px;\n    margin-bottom: 0px;\n  }\n  [data-kt-app-sidebar-hoverable=true] .app-sidebar .app-sidebar-wrapper {\n    width: var(--bs-app-sidebar-width-actual);\n  }\n  [data-kt-app-sidebar-hoverable=true][data-kt-app-sidebar-minimize=on] .app-sidebar:hover:not(.animating) {\n    transition: width 0.3s ease;\n    width: var(--bs-app-sidebar-width-actual);\n  }\n  [data-kt-app-sidebar-collapse=on] .app-sidebar {\n    transition: width 0.3s ease;\n    width: var(--bs-app-sidebar-width-actual);\n    margin-left: calc(-1 * var(--bs-app-sidebar-width-actual));\n  }\n  [data-kt-app-sidebar-minimize=on] .app-sidebar-minimize-d-none {\n    display: none !important;\n  }\n  [data-kt-app-sidebar-minimize=on] .app-sidebar-minimize-d-flex {\n    display: flex !important;\n  }\n  [data-kt-app-sidebar-sticky=on] .app-sidebar-sticky-d-none {\n    display: none !important;\n  }\n  [data-kt-app-sidebar-sticky=on] .app-sidebar-sticky-d-flex {\n    display: flex !important;\n  }\n  [data-kt-app-sidebar-collapse=on] .app-sidebar-collapse-d-none {\n    display: none !important;\n  }\n  [data-kt-app-sidebar-collapse=on] .app-sidebar-collapse-d-flex {\n    display: flex !important;\n  }\n  [data-kt-app-sidebar-fixed=true][data-kt-app-header-fixed=true]:not([data-kt-app-sidebar-push-header=true]) .app-sidebar {\n    top: var(--bs-app-header-height);\n  }\n  [data-kt-app-sidebar-fixed=true][data-kt-app-header-fixed=true][data-kt-app-toolbar-fixed=true]:not([data-kt-app-sidebar-push-toolbar=true]) .app-sidebar {\n    top: calc(var(--bs-app-header-height) + var(--bs-app-toolbar-height, 0px));\n  }\n}\n@media (max-width: 991.98px) {\n  .app-sidebar {\n    display: none;\n    width: var(--bs-app-sidebar-width);\n    z-index: 106;\n    margin-left: 0px;\n    margin-right: 0px;\n    margin-top: 0px;\n    margin-bottom: 0px;\n  }\n  :root {\n    --bs-app-sidebar-width: 250px;\n    --bs-app-sidebar-width-actual: 250px;\n    --bs-app-sidebar-gap-start: 0px;\n    --bs-app-sidebar-gap-end: 0px;\n    --bs-app-sidebar-gap-top: 0px;\n    --bs-app-sidebar-gap-bottom: 0px;\n  }\n  [data-kt-app-sidebar-stacked=true] {\n    --bs-app-sidebar-width: calc(var(--bs-app-sidebar-primary-width) + var(--bs-app-sidebar-secondary-width, 0));\n  }\n  [data-kt-app-sidebar-minimize-mobile=on] {\n    --bs-app-sidebar-width: 75px;\n    --bs-app-sidebar-gap-start: 0px;\n    --bs-app-sidebar-gap-end: 0px;\n    --bs-app-sidebar-gap-top: 0px;\n    --bs-app-sidebar-gap-bottom: 0px;\n  }\n  [data-kt-app-sidebar-collapse-mobile=on] {\n    --bs-app-sidebar-width: 0px;\n  }\n  [data-kt-app-sidebar-stacked=true] .app-sidebar {\n    align-items: stretch;\n  }\n  [data-kt-app-sidebar-minimize-mobile=on] .app-sidebar {\n    transition: width 0.3s ease;\n    margin-left: 0px;\n    margin-right: 0px;\n    margin-top: 0px;\n    margin-bottom: 0px;\n  }\n  [data-kt-app-sidebar-hoverable-mobile=true] .app-sidebar .app-sidebar-wrapper {\n    width: var(--bs-app-sidebar-width-actual);\n  }\n  [data-kt-app-sidebar-hoverable-mobile=true][data-kt-app-sidebar-minimize-mobile=on] .app-sidebar:hover:not(.animating) {\n    transition: width 0.3s ease;\n    width: var(--bs-app-sidebar-width-actual);\n    box-shadow: var(--bs-app-sidebar-minimize-hover-box-shadow-mobile);\n  }\n  [data-kt-app-sidebar-collapse-mobile=on] .app-sidebar {\n    transition: width 0.3s ease;\n    width: var(--bs-app-sidebar-width-actual);\n    margin-left: calc(-1 * var(--bs-app-sidebar-width-actual));\n  }\n  [data-kt-app-sidebar-minimize-mobile=on] .app-sidebar-minimize-mobile-d-none {\n    display: none !important;\n  }\n  [data-kt-app-sidebar-minimize-mobile=on] .app-sidebar-minimize-mobile-d-flex {\n    display: flex !important;\n  }\n  [data-kt-app-sidebar-collapse-mobile=on] .app-sidebar-collapse-mobile-d-none {\n    display: none !important;\n  }\n  [data-kt-app-sidebar-collapse-mobile=on] .app-sidebar-collapse-mobile-d-flex {\n    display: flex !important;\n  }\n}\n.app-sidebar-primary {\n  transition: none;\n  position: relative;\n  flex-shrink: 0;\n  background-color: var(--bs-app-sidebar-primary-base-bg-color);\n  box-shadow: var(--bs-app-sidebar-primary-base-box-shadow);\n  border-left: var(--bs-app-sidebar-primary-base-border-start);\n  border-right: var(--bs-app-sidebar-primary-base-border-end);\n}\n\n.app-sidebar-primary-collapse-d-flex,\n.app-sidebar-primary-minimize-d-flex,\n.app-sidebar-primary-collapse-mobile-d-flex,\n.app-sidebar-primary-minimize-mobile-d-flex {\n  display: none;\n}\n\n@media (min-width: 992px) {\n  .app-sidebar-primary {\n    z-index: 1;\n    margin-left: 0px;\n    margin-right: 0px;\n    margin-top: 0px;\n    margin-bottom: 0px;\n  }\n  :root {\n    --bs-app-sidebar-primary-width-actual: 100px;\n  }\n  [data-kt-app-sidebar-stacked=true] {\n    --bs-app-sidebar-primary-width: 100px;\n    --bs-app-sidebar-primary-gap-start: 0px;\n    --bs-app-sidebar-primary-gap-end: 0px;\n    --bs-app-sidebar-primary-gap-top: 0px;\n    --bs-app-sidebar-primary-gap-bottom: 0px;\n  }\n  [data-kt-app-sidebar-primary-minimize=on] {\n    --bs-app-sidebar-primary-width: 75px;\n    --bs-app-sidebar-primary-gap-start: 0px;\n    --bs-app-sidebar-primary-gap-end: 0px;\n    --bs-app-sidebar-primary-gap-top: 0px;\n    --bs-app-sidebar-primary-gap-bottom: 0px;\n  }\n  [data-kt-app-sidebar-primary-collapse=on] {\n    --bs-app-sidebar-primary-width: 0px;\n  }\n  .app-sidebar-primary {\n    width: var(--bs-app-sidebar-primary-width);\n  }\n  [data-kt-app-sidebar-primary-collapse=on] .app-sidebar-primary {\n    transition: none;\n    width: var(--bs-app-sidebar-primary-width-actual);\n    margin-left: calc(-1 * var(--bs-app-sidebar-primary-width-actual));\n  }\n  [data-kt-app-sidebar-primary-minimize=on] .app-sidebar-primary {\n    transition: none;\n    margin-left: 0px;\n    margin-right: 0px;\n    margin-top: 0px;\n    margin-bottom: 0px;\n  }\n  [data-kt-app-sidebar-primary-hoverable=true] .app-sidebar-primary .app-sidebar-primary-hoverable {\n    width: var(--bs-app-sidebar-primary-width-actual);\n  }\n  [data-kt-app-sidebar-primary-hoverable=true][data-kt-app-sidebar-primary-minimize=on] .app-sidebar-primary:hover:not(.animating) {\n    transition: none;\n    width: var(--bs-app-sidebar-primary-width-actual);\n    box-shadow: var(--bs-app-sidebar-primary-minimize-hover-box-shadow);\n  }\n  [data-kt-app-sidebar-fixed=true][data-kt-app-header-fixed=true][data-kt-app-sidebar-primary-below-header=true] .app-sidebar-primary {\n    top: var(--bs-app-header-height);\n  }\n  [data-kt-app-sidebar-fixed=true][data-kt-app-header-fixed=true][data-kt-app-toolbar-fixed=true][data-kt-app-sidebar-primary-below-toolbar=true] .app-sidebar-primary {\n    top: calc(var(--bs-app-header-height) + var(--bs-app-toolbar-height, 0));\n  }\n  [data-kt-app-sidebar-primary-minimize=on] .app-sidebar-primary-minimize-d-none {\n    display: none !important;\n  }\n  [data-kt-app-sidebar-primary-minimize=on] .app-sidebar-primary-minimize-d-flex {\n    display: flex !important;\n  }\n  [data-kt-app-sidebar-primary-collapse=on] .app-sidebar-primary-collapse-d-none {\n    display: none !important;\n  }\n  [data-kt-app-sidebar-primary-collapse=on] .app-sidebar-primary-collapse-d-flex {\n    display: flex !important;\n  }\n}\n@media (max-width: 991.98px) {\n  .app-sidebar-primary {\n    z-index: 1;\n    margin-left: 0px;\n    margin-right: 0px;\n    margin-top: 0px;\n    margin-bottom: 0px;\n  }\n  :root {\n    --bs-app-sidebar-primary-width-actual: 100px;\n  }\n  [data-kt-app-sidebar-stacked=true] {\n    --bs-app-sidebar-primary-width: 100px;\n    --bs-app-sidebar-primary-gap-start: 0px;\n    --bs-app-sidebar-primary-gap-end: 0px;\n    --bs-app-sidebar-primary-gap-top: 0px;\n    --bs-app-sidebar-primary-gap-bottom: 0px;\n  }\n  [data-kt-app-sidebar-primary-minimize-mobile=on] {\n    --bs-app-sidebar-primary-width: 75px;\n    --bs-app-sidebar-primary-gap-start: 0px;\n    --bs-app-sidebar-primary-gap-end: 0px;\n    --bs-app-sidebar-primary-gap-top: 0px;\n    --bs-app-sidebar-primary-gap-bottom: 0px;\n  }\n  [data-kt-app-sidebar-primary-collapse-mobile=on] {\n    --bs-app-sidebar-primary-width: 0px;\n  }\n  .app-sidebar-primary {\n    width: var(--bs-app-sidebar-primary-width);\n  }\n  [data-kt-app-sidebar-primary-collapse-mobile=on] .app-sidebar-primary {\n    transition: none;\n    width: var(--bs-app-sidebar-primary-width-actual);\n    margin-left: calc(-1 * var(--bs-app-sidebar-primary-width-actual));\n  }\n  [data-kt-app-sidebar-primary-minimize-mobile=on] .app-sidebar-primary {\n    transition: none;\n    margin-left: 0px;\n    margin-right: 0px;\n    margin-top: 0px;\n    margin-bottom: 0px;\n  }\n  [data-kt-app-sidebar-primary-hoverable-mobile=true] .app-sidebar-primary .app-sidebar-primary-hoverable {\n    width: var(--bs-app-sidebar-primary-width-actual);\n  }\n  [data-kt-app-sidebar-primary-hoverable-mobile=true][data-kt-app-sidebar-primary-minimize-mobile=on] .app-sidebar-primary:hover:not(.animating) {\n    transition: none;\n    width: var(--bs-app-sidebar-primary-width-actual);\n    box-shadow: var(--bs-app-sidebar-primary-minimize-hover-box-shadow-mobile);\n  }\n  [data-kt-app-sidebar-primary-minimize-mobile=on] .app-sidebar-primary-minimize-mobile-d-none {\n    display: none !important;\n  }\n  [data-kt-app-sidebar-primary-minimize-mobile=on] .app-sidebar-primary-minimize-mobile-d-flex {\n    display: flex !important;\n  }\n  [data-kt-app-sidebar-primary-collapse-mobile=on] .app-sidebar-primary-collapse-mobile-d-none {\n    display: none !important;\n  }\n  [data-kt-app-sidebar-primary-collapse-mobile=on] .app-sidebar-primary-collapse-mobile-d-flex {\n    display: flex !important;\n  }\n}\n.app-sidebar-secondary {\n  transition: width 0.3s ease, margin 0.3s ease;\n  position: relative;\n  flex-shrink: 0;\n  background-color: var(--bs-app-sidebar-secondary-base-bg-color);\n  box-shadow: var(--bs-app-sidebar-secondary-base-box-shadow);\n  border-left: var(--bs-app-sidebar-secondary-base-border-start);\n  border-right: var(--bs-app-sidebar-secondary-base-border-end);\n}\n\n.app-sidebar-secondary-collapse-d-flex,\n.app-sidebar-secondary-minimize-d-flex,\n.app-sidebar-secondary-collapse-mobile-d-flex,\n.app-sidebar-secondary-minimize-mobile-d-flex {\n  display: none;\n}\n\n@media (min-width: 992px) {\n  .app-sidebar-secondary {\n    margin-left: 0px;\n    margin-right: 0px;\n    margin-top: 0px;\n    margin-bottom: 0px;\n  }\n  [data-kt-app-sidebar-secondary-enabled=true] {\n    --bs-app-sidebar-secondary-width-actual: calc(\n        265px -\n        100px -\n        0px -\n        0px -\n        0px -\n        0px\n    );\n  }\n  [data-kt-app-sidebar-secondary-enabled=true][data-kt-app-sidebar-stacked=true] {\n    --bs-app-sidebar-secondary-width: calc(\n        265px -\n        100px -\n        0px -\n        0px -\n        0px -\n        0px\n    );\n    --bs-app-sidebar-secondary-gap-start: 0px;\n    --bs-app-sidebar-secondary-gap-end: 0px;\n    --bs-app-sidebar-secondary-gap-top: 0px;\n    --bs-app-sidebar-secondary-gap-bottom: 0px;\n  }\n  [data-kt-app-sidebar-secondary-enabled=true][data-kt-app-sidebar-secondary-minimize=on] {\n    --bs-app-sidebar-secondary-width: 75px;\n    --bs-app-sidebar-secondary-gap-start: 0px;\n    --bs-app-sidebar-secondary-gap-end: 0px;\n    --bs-app-sidebar-secondary-gap-top: 0px;\n    --bs-app-sidebar-secondary-gap-bottom: 0px;\n  }\n  [data-kt-app-sidebar-secondary-enabled=true][data-kt-app-sidebar-secondary-collapse=on] {\n    --bs-app-sidebar-secondary-width-actual: calc(\n        265px -\n        100px -\n        0px -\n        0px -\n        0px -\n        0px\n    );\n    --bs-app-sidebar-secondary-width: 0px;\n  }\n  .app-sidebar-secondary {\n    width: var(--bs-app-sidebar-secondary-width);\n  }\n  [data-kt-app-sidebar-secondary-collapse=on] .app-sidebar-secondary {\n    transition: width 0.3s ease, margin 0.3s ease;\n    width: var(--bs-app-sidebar-secondary-width-actual);\n    margin-left: calc(-1 * var(--bs-app-sidebar-secondary-width-actual));\n  }\n  [data-kt-app-sidebar-secondary-minimize=on] .app-sidebar-secondary {\n    transition: width 0.3s ease, margin 0.3s ease;\n    margin-left: 0px;\n    margin-right: 0px;\n    margin-top: 0px;\n    margin-bottom: 0px;\n  }\n  [data-kt-app-sidebar-secondary-hoverable=true] .app-sidebar-secondary .app-sidebar-secondary-hoverable {\n    width: var(--bs-app-sidebar-secondary-width-actual);\n  }\n  [data-kt-app-sidebar-secondary-hoverable=true][data-kt-app-sidebar-secondary-minimize=on] .app-sidebar-secondary:hover:not(.animating) {\n    transition: width 0.3s ease, margin 0.3s ease;\n    width: var(--bs-app-sidebar-secondary-width-actual);\n    box-shadow: var(--bs-app-sidebar-secondary-minimize-hover-box-shadow);\n  }\n  [data-kt-app-sidebar-fixed=true][data-kt-app-header-fixed=true][data-kt-app-sidebar-secondary-below-header=true] .app-sidebar-secondary {\n    top: var(--bs-app-header-height);\n  }\n  [data-kt-app-sidebar-fixed=true][data-kt-app-header-fixed=true][data-kt-app-toolbar-fixed=true][data-kt-app-sidebar-secondary-below-toolbar=true] .app-sidebar-secondary {\n    top: calc(var(--bs-app-header-height) + var(--bs-app-toolbar-height, 0));\n  }\n  [data-kt-app-sidebar-secondary-enabled=true][data-kt-app-sidebar-secondary-minimize=on] .app-sidebar-secondary-minimize-d-none {\n    display: none !important;\n  }\n  [data-kt-app-sidebar-secondary-enabled=true][data-kt-app-sidebar-secondary-minimize=on] .app-sidebar-secondary-minimize-d-flex {\n    display: flex !important;\n  }\n  [data-kt-app-sidebar-secondary-enabled=true][data-kt-app-sidebar-secondary-collapse=on] .app-sidebar-secondary-collapse-d-none {\n    display: none !important;\n  }\n  [data-kt-app-sidebar-secondary-enabled=true][data-kt-app-sidebar-secondary-collapse=on] .app-sidebar-secondary-collapse-d-flex {\n    display: flex !important;\n  }\n}\n@media (max-width: 991.98px) {\n  .app-sidebar-secondary {\n    margin-left: 0px;\n    margin-right: 0px;\n    margin-top: 0px;\n    margin-bottom: 0px;\n  }\n  [data-kt-app-sidebar-secondary-enabled=true] {\n    --bs-app-sidebar-secondary-width-actual: calc(\n        250px -\n        100px -\n        0px -\n        0px -\n        0px -\n        0px\n    );\n  }\n  [data-kt-app-sidebar-secondary-enabled=true][data-kt-app-sidebar-stacked=true] {\n    --bs-app-sidebar-secondary-width: calc(\n        250px -\n        100px -\n        0px -\n        0px -\n        0px -\n        0px\n    );\n    --bs-app-sidebar-secondary-gap-start: 0px;\n    --bs-app-sidebar-secondary-gap-end: 0px;\n    --bs-app-sidebar-secondary-gap-top: 0px;\n    --bs-app-sidebar-secondary-gap-bottom: 0px;\n  }\n  [data-kt-app-sidebar-secondary-enabled=true][data-kt-app-sidebar-secondary-minimize-mobile=on] {\n    --bs-app-sidebar-secondary-width: 75px;\n    --bs-app-sidebar-secondary-gap-start: 0px;\n    --bs-app-sidebar-secondary-gap-end: 0px;\n    --bs-app-sidebar-secondary-gap-top: 0px;\n    --bs-app-sidebar-secondary-gap-bottom: 0px;\n  }\n  [data-kt-app-sidebar-secondary-enabled=true][data-kt-app-sidebar-secondary-collapse-mobile=on] {\n    --bs-app-sidebar-secondary-width-actual: calc(\n        250px -\n        100px -\n        0px -\n        0px -\n        0px -\n        0px\n    );\n    --bs-app-sidebar-secondary-width: 0px;\n  }\n  .app-sidebar-secondary {\n    width: var(--bs-app-sidebar-secondary-width);\n  }\n  [data-kt-app-sidebar-secondary-collapse-mobile=on] .app-sidebar-secondary {\n    transition: width 0.3s ease, margin 0.3s ease;\n    width: var(--bs-app-sidebar-secondary-width-actual);\n    margin-left: calc(-1 * var(--bs-app-sidebar-secondary-width-actual));\n  }\n  [data-kt-app-sidebar-secondary-minimize-mobile=on] .app-sidebar-secondary {\n    transition: width 0.3s ease, margin 0.3s ease;\n    background-color: var(--bs-app-sidebar-secondary-minimize-bg-color-mobile);\n    box-shadow: var(--bs-app-sidebar-secondary-minimize-box-shadow-mobile);\n    border-left: var(--bs-app-sidebar-secondary-minimize-border-start-mobile);\n    border-right: var(--bs-app-sidebar-secondary-minimize-border-end-mobile);\n  }\n  [data-kt-app-sidebar-secondary-hoverable-mobile=true] .app-sidebar-secondary .app-sidebar-secondary-hoverable {\n    width: var(--bs-app-sidebar-secondary-width-actual);\n  }\n  [data-kt-app-sidebar-secondary-hoverable-mobile=true][data-kt-app-sidebar-secondary-minimize-mobile=on] .app-sidebar-secondary:hover:not(.animating) {\n    transition: width 0.3s ease, margin 0.3s ease;\n    width: var(--bs-app-sidebar-secondary-width-actual);\n    box-shadow: var(--bs-app-sidebar-secondary-minimize-hover-box-shadow-mobile);\n  }\n  [data-kt-app-sidebar-secondary-enabled=true][data-kt-app-sidebar-secondary-minimize-mobile=on] .app-sidebar-secondary-minimize-mobile-d-none {\n    display: none !important;\n  }\n  [data-kt-app-sidebar-secondary-enabled=true][data-kt-app-sidebar-secondary-minimize-mobile=on] .app-sidebar-secondary-minimize-mobile-d-flex {\n    display: flex !important;\n  }\n  [data-kt-app-sidebar-secondary-enabled=true][data-kt-app-sidebar-secondary-collapse=on] .app-sidebar-secondary-collapse-mobile-d-none {\n    display: none !important;\n  }\n  [data-kt-app-sidebar-secondary-enabled=true][data-kt-app-sidebar-secondary-collapse=on] .app-sidebar-secondary-collapse-mobile-d-flex {\n    display: flex !important;\n  }\n}\n.app-sidebar-panel {\n  transition: none;\n  background-color: var(--bs-app-sidebar-panel-base-bg-color);\n  box-shadow: var(--bs-app-sidebar-panel-base-box-shadow);\n  border-left: var(--bs-app-sidebar-panel-base-border-start);\n  border-right: var(--bs-app-sidebar-panel-base-border-end);\n}\n\n.app-sidebar-panel-minimize-d-flex,\n.app-sidebar-panel-sticky-d-flex,\n.app-sidebar-panel-collapse-d-flex,\n.app-sidebar-panel-minimize-mobile-d-flex,\n.app-sidebar-panel-collapse-mobile-d-flex {\n  display: none;\n}\n\n@media (min-width: 992px) {\n  .app-sidebar-panel {\n    display: flex;\n    flex-shrink: 0;\n    width: var(--bs-app-sidebar-panel-width);\n    margin-left: 0px;\n    margin-right: 0px;\n    margin-top: 0px;\n    margin-bottom: 0px;\n  }\n  :root {\n    --bs-app-sidebar-panel-width: 300px;\n    --bs-app-sidebar-panel-width-actual: 300px;\n    --bs-app-sidebar-panel-gap-start: 0px;\n    --bs-app-sidebar-panel-gap-end: 0px;\n    --bs-app-sidebar-panel-gap-top: 0px;\n    --bs-app-sidebar-panel-gap-bottom: 0px;\n  }\n  [data-kt-app-sidebar-panel-minimize=on] {\n    --bs-app-sidebar-panel-width: 75px;\n    --bs-app-sidebar-panel-gap-start: 0px;\n    --bs-app-sidebar-panel-gap-end: 0px;\n    --bs-app-sidebar-panel-gap-top: 0px;\n    --bs-app-sidebar-panel-gap-bottom: 0px;\n  }\n  [data-kt-app-sidebar-panel-sticky=on] {\n    --bs-app-sidebar-panel-width: 300px;\n    --bs-app-sidebar-panel-gap-start: 0px;\n    --bs-app-sidebar-panel-gap-end: 0px;\n    --bs-app-sidebar-panel-gap-top: 0px;\n    --bs-app-sidebar-panel-gap-bottom: 0px;\n  }\n  [data-kt-app-sidebar-panel-collapse=on] {\n    --bs-app-sidebar-panel-width-actual: 300px;\n    --bs-app-sidebar-panel-width: 0px;\n  }\n  [data-kt-app-sidebar-panel-static=true] .app-sidebar-panel {\n    position: relative;\n  }\n  [data-kt-app-sidebar-panel-offcanvas=true] .app-sidebar-panel {\n    display: none;\n  }\n  [data-kt-app-sidebar-panel-fixed=true] .app-sidebar-panel {\n    z-index: 104;\n    position: fixed;\n    left: calc(var(--bs-app-sidebar-width) + var(--bs-app-sidebar-gap-start, 0px) + var(--bs-app-sidebar-gap-end, 0px));\n    top: 0;\n    bottom: 0;\n  }\n  [data-kt-app-sidebar-panel-sticky=on] .app-sidebar-panel {\n    position: fixed;\n    left: calc(var(--bs-app-sidebar-width) + var(--bs-app-sidebar-gap-start, 0px) + var(--bs-app-sidebar-gap-end, 0px));\n    top: 0;\n    bottom: 0;\n    transition: none;\n    z-index: 104;\n    margin-left: 0px;\n    margin-right: 0px;\n    margin-top: 0px;\n    margin-bottom: 0px;\n  }\n  [data-kt-app-sidebar-panel-minimize=on] .app-sidebar-panel {\n    transition: none;\n    margin-left: 0px;\n    margin-right: 0px;\n    margin-top: 0px;\n    margin-bottom: 0px;\n  }\n  [data-kt-app-sidebar-panel-hoverable=true] .app-sidebar-panel .app-sidebar-panel-hoverable {\n    width: var(--bs-app-sidebar-panel-width-actual);\n  }\n  [data-kt-app-sidebar-panel-hoverable=true][data-kt-app-sidebar-panel-minimize=on] .app-sidebar-panel:hover:not(.animating) {\n    transition: none;\n    width: var(--bs-app-sidebar-panel-width-actual);\n    box-shadow: var(--bs-app-sidebar-panel-minimize-hover-box-shadow);\n  }\n  [data-kt-app-sidebar-panel-collapse=on] .app-sidebar-panel {\n    transition: none;\n    width: var(--bs-app-sidebar-panel-width-actual);\n    margin-left: calc(-1 * (var(--bs-app-sidebar-panel-width-actual) + var(--bs-app-sidebar-gap-start, 0px) + var(--bs-app-sidebar-gap-end, 0px)));\n  }\n  [data-kt-app-sidebar-panel-fixed=true][data-kt-app-header-fixed=true]:not([data-kt-app-sidebar-panel-push-header=true]) .app-sidebar-panel {\n    top: var(--bs-app-header-height);\n  }\n  [data-kt-app-sidebar-panel-fixed=true][data-kt-app-header-fixed=true][data-kt-app-toolbar-fixed=true]:not([data-kt-app-sidebar-panel-push-toolbar=true]) .app-sidebar-panel {\n    top: calc(var(--bs-app-header-height) + var(--bs-app-toolbar-height, 0));\n  }\n  [data-kt-app-sidebar-panel-minimize=on] .app-sidebar-panel-minimize-d-none {\n    display: none !important;\n  }\n  [data-kt-app-sidebar-panel-minimize=on] .app-sidebar-panel-minimize-d-flex {\n    display: flex !important;\n  }\n  [data-kt-app-sidebar-panel-sticky=on] .app-sidebar-panel-sticky-d-none {\n    display: none !important;\n  }\n  [data-kt-app-sidebar-panel-sticky=on] .app-sidebar-panel-sticky-d-flex {\n    display: flex !important;\n  }\n  [data-kt-app-sidebar-panel-collapse=on] .app-sidebar-panel-collapse-d-none {\n    display: none !important;\n  }\n  [data-kt-app-sidebar-panel-collapse=on] .app-sidebar-panel-collapse-d-flex {\n    display: flex !important;\n  }\n}\n@media (max-width: 991.98px) {\n  .app-sidebar-panel {\n    display: none;\n    width: var(--bs-app-sidebar-panel-width);\n    margin-left: 0px;\n    margin-right: 0px;\n    margin-top: 0px;\n    margin-bottom: 0px;\n  }\n  :root {\n    --bs-app-sidebar-panel-gap-start: 0px;\n    --bs-app-sidebar-panel-gap-end: 0px;\n    --bs-app-sidebar-panel-gap-top: 0px;\n    --bs-app-sidebar-panel-gap-bottom: 0px;\n  }\n  [data-kt-app-sidebar-panel-minimize-mobile=on] {\n    --bs-app-sidebar-panel-width: 75px;\n    --bs-app-sidebar-panel-gap-start: 0px;\n    --bs-app-sidebar-panel-gap-end: 0px;\n    --bs-app-sidebar-panel-gap-top: 0px;\n    --bs-app-sidebar-panel-gap-bottom: 0px;\n  }\n  [data-kt-app-sidebar-panel-collapse-mobile=on] {\n    --bs-app-sidebar-panel-width-actual: 300px;\n    --bs-app-sidebar-panel-width: 0px;\n  }\n  [data-kt-app-sidebar-panel-minimize-mobile=on] .app-sidebar-panel {\n    transition: none;\n    background-color: var(--bs-app-sidebar-panel-minimize-bg-color-mobile);\n    box-shadow: var(--bs-app-sidebar-panel-minimize-box-shadow-mobile);\n    border-left: var(--bs-app-sidebar-panel-minimize-border-start-mobile);\n    border-right: var(--bs-app-sidebar-panel-minimize-border-end-mobile);\n    margin-left: 0px;\n    margin-right: 0px;\n    margin-top: 0px;\n    margin-bottom: 0px;\n  }\n  [data-kt-app-sidebar-panel-hoverable-mobile=true] .app-sidebar-panel .app-sidebar-panel-hoverable {\n    width: var(--bs-app-sidebar-panel-width-actual);\n  }\n  [data-kt-app-sidebar-panel-hoverable-mobile=true][data-kt-app-sidebar-panel-minimize-mobile=on] .app-sidebar-panel:hover:not(.animating) {\n    transition: none;\n    width: var(--bs-app-sidebar-panel-width-actual);\n    box-shadow: var(--bs-app-sidebar-panel-minimize-hover-box-shadow-mobile);\n  }\n  [data-kt-app-sidebar-panel-collapse-mobile=on] .app-sidebar-panel {\n    transition: none;\n    width: var(--bs-app-sidebar-panel-width-actual);\n    margin-left: calc(-1 * var(--bs-app-sidebar-panel-width-actual));\n  }\n  [data-kt-app-sidebar-panel-minimize-mobile=on] .app-sidebar-panel-minimize-mobile-d-none {\n    display: none !important;\n  }\n  [data-kt-app-sidebar-panel-minimize-mobile=on] .app-sidebar-panel-minimize-mobile-d-flex {\n    display: flex !important;\n  }\n  [data-kt-app-sidebar-panel-collapse-mobile=on] .app-sidebar-panel-collapse-mobile-d-none {\n    display: none !important;\n  }\n  [data-kt-app-sidebar-panel-collapse-mobile=on] .app-sidebar-panel-collapse-mobile-d-flex {\n    display: flex !important;\n  }\n}\n.app-aside {\n  transition: none;\n  background-color: var(--bs-app-aside-base-bg-color);\n  box-shadow: var(--bs-app-aside-base-box-shadow);\n  border-left: var(--bs-app-aside-base-border-left);\n  border-right: var(--bs-app-aside-base-border-right);\n}\n\n.app-aside-minimize-d-flex,\n.app-aside-sticky-d-flex,\n.app-aside-collapse-d-flex,\n.app-aside-minimize-mobile-d-flex,\n.app-aside-collapse-mobile-d-flex {\n  display: none;\n}\n\n@media (min-width: 992px) {\n  .app-aside {\n    display: flex;\n    flex-shrink: 0;\n    width: var(--bs-app-aside-width);\n    margin-left: 0px;\n    margin-right: 0px;\n    margin-top: 0px;\n    margin-bottom: 0px;\n  }\n  :root {\n    --bs-app-aside-width: 300px;\n    --bs-app-aside-width-actual: 300px;\n    --bs-app-aside-gap-start: 0px;\n    --bs-app-aside-gap-end: 0px;\n    --bs-app-aside-gap-top: 0px;\n    --bs-app-aside-gap-bottom: 0px;\n  }\n  [data-kt-app-aside-stacked=true] {\n    --bs-app-aside-width: calc(var(--bs-app-aside-primary-width) + var(--bs-app-aside-secondary-width));\n  }\n  [data-kt-app-aside-minimize=on] {\n    --bs-app-aside-width: 75px;\n    --bs-app-aside-gap-start: 0px;\n    --bs-app-aside-gap-end: 0px;\n    --bs-app-aside-gap-top: 0px;\n    --bs-app-aside-gap-bottom: 0px;\n  }\n  [data-kt-app-aside-sticky=on] {\n    --bs-app-aside-width: 300px;\n    --bs-app-aside-gap-start: 0px;\n    --bs-app-aside-gap-end: 0px;\n    --bs-app-aside-gap-top: 0px;\n    --bs-app-aside-gap-bottom: 0px;\n  }\n  [data-kt-app-aside-collapse=on] {\n    --bs-app-aside-width: 0px;\n  }\n  [data-kt-app-aside-static=true] .app-aside {\n    position: relative;\n  }\n  [data-kt-app-aside-offcanvas=true] .app-aside {\n    display: none;\n  }\n  [data-kt-app-aside-fixed=true] .app-aside {\n    position: fixed;\n    z-index: 105;\n    top: 0;\n    bottom: 0;\n    right: 0;\n  }\n  [data-kt-app-aside-stacked=true] .app-aside {\n    align-items: stretch;\n  }\n  [data-kt-app-aside-sticky=on] .app-aside {\n    position: fixed;\n    transition: none;\n    box-shadow: var(--bs-app-aside-sticky-box-shadow);\n    border-left: var(--bs-aside-sticky-border-start);\n    border-right: var(--bs-app-aside-sticky-border-end);\n    top: auto;\n    bottom: auto;\n    left: auto;\n    z-index: 105;\n    margin-left: 0px;\n    margin-right: 0px;\n    margin-top: 0px;\n    margin-bottom: 0px;\n  }\n  [data-kt-app-aside-minimize=on] .app-aside {\n    transition: none;\n    margin-left: 0px;\n    margin-right: 0px;\n    margin-top: 0px;\n    margin-bottom: 0px;\n  }\n  [data-kt-app-aside-hoverable=true] .app-aside .app-aside-wrapper {\n    width: var(--bs-app-aside-width-actual);\n  }\n  [data-kt-app-aside-hoverable=true][data-kt-app-aside-minimize=on] .app-aside:hover:not(.animating) {\n    transition: none;\n    width: var(--bs-app-aside-width-actual);\n    box-shadow: var(--bs-app-aside-minimize-hover-box-shadow);\n  }\n  [data-kt-app-aside-collapse=on] .app-aside {\n    transition: none;\n    width: var(--bs-app-aside-width-actual);\n    margin-right: calc(-1 * var(--bs-app-aside-width-actual));\n  }\n  [data-kt-app-aside-minimize=on] .app-aside-minimize-d-none {\n    display: none !important;\n  }\n  [data-kt-app-aside-minimize=on] .app-aside-minimize-d-flex {\n    display: flex !important;\n  }\n  [data-kt-app-aside-sticky=on] .app-aside-sticky-d-none {\n    display: none !important;\n  }\n  [data-kt-app-aside-sticky=on] .app-aside-sticky-d-flex {\n    display: flex !important;\n  }\n  [data-kt-app-aside-collapse=on] .app-aside-collapse-d-none {\n    display: none !important;\n  }\n  [data-kt-app-aside-collapse=on] .app-aside-collapse-d-flex {\n    display: flex !important;\n  }\n  [data-kt-app-aside-fixed=true][data-kt-app-header-fixed=true]:not([data-kt-app-aside-push-header=true]) .app-aside {\n    top: var(--bs-app-header-height);\n  }\n  [data-kt-app-aside-fixed=true][data-kt-app-header-fixed=true][data-kt-app-toolbar-fixed=true]:not([data-kt-app-aside-push-toolbar=true]) .app-aside {\n    top: calc(var(--bs-app-header-height) + var(--bs-app-toolbar-height, 0px));\n  }\n}\n@media (max-width: 991.98px) {\n  .app-aside {\n    display: none;\n    width: var(--bs-app-aside-width);\n    z-index: 106;\n    margin-left: 0px;\n    margin-right: 0px;\n    margin-top: 0px;\n    margin-bottom: 0px;\n  }\n  :root {\n    --bs-app-aside-width: 275px;\n    --bs-app-aside-width-actual: 275px;\n    --bs-app-aside-gap-start: 0px;\n    --bs-app-aside-gap-end: 0px;\n    --bs-app-aside-gap-top: 0px;\n    --bs-app-aside-gap-bottom: 0px;\n  }\n  [data-kt-app-aside-minimize-mobile=on] {\n    --bs-app-aside-width: 75px;\n    --bs-app-aside-gap-start: 0px;\n    --bs-app-aside-gap-end: 0px;\n    --bs-app-aside-gap-top: 0px;\n    --bs-app-aside-gap-bottom: 0px;\n  }\n  [data-kt-app-aside-collapse-mobile=on] {\n    --bs-app-aside-width: 0px;\n  }\n  [data-kt-app-aside-stacked=true] .app-aside {\n    align-items: stretch;\n  }\n  [data-kt-app-aside-minimize-mobile=on] .app-aside {\n    transition: none;\n    margin-left: 0px;\n    margin-right: 0px;\n    margin-top: 0px;\n    margin-bottom: 0px;\n  }\n  [data-kt-app-aside-hoverable-mobile=true] .app-aside .app-aside-wrapper {\n    width: var(--bs-app-aside-width-actual);\n  }\n  [data-kt-app-aside-hoverable-mobile=true][data-kt-app-aside-minimize-mobile=on] .app-aside:hover:not(.animating) {\n    transition: none;\n    width: var(--bs-app-aside-width-actual);\n    box-shadow: var(--bs-app-aside-minimize-hover-box-shadow-mobile);\n  }\n  [data-kt-app-aside-collapse-mobile=on] .app-aside {\n    transition: none;\n    width: var(--bs-app-aside-width-actual);\n    margin-right: calc(-1 * var(--bs-app-aside-width-actual));\n  }\n  [data-kt-app-aside-minimize-mobile=on] .app-aside-minimize-mobile-d-none {\n    display: none !important;\n  }\n  [data-kt-app-aside-minimize-mobile=on] .app-aside-minimize-mobile-d-flex {\n    display: flex !important;\n  }\n  [data-kt-app-aside-collapse-mobile=on] .app-aside-collapse-mobile-d-none {\n    display: none !important;\n  }\n  [data-kt-app-aside-collapse-mobile=on] .app-aside-collapse-mobile-d-flex {\n    display: flex !important;\n  }\n}\n.app-wrapper {\n  display: flex;\n}\n\n@media (min-width: 992px) {\n  .app-wrapper {\n    transition: margin-left 0.3s ease, margin-right 0.3s ease;\n  }\n  [data-kt-app-header-sticky=on] .app-wrapper {\n    margin-top: var(--bs-app-header-height-actual);\n  }\n  [data-kt-app-header-fixed=true] .app-wrapper {\n    margin-top: var(--bs-app-header-height);\n  }\n  [data-kt-app-toolbar-sticky=on] .app-wrapper {\n    margin-top: var(--bs-app-toolbar-height);\n  }\n  [data-kt-app-header-fixed=true][data-kt-app-toolbar-sticky=on] .app-wrapper {\n    margin-top: calc(var(--bs-app-header-height-actual) + var(--bs-app-toolbar-height-actual));\n  }\n  [data-kt-app-header-fixed=true][data-kt-app-toolbar-fixed=true] .app-wrapper {\n    margin-top: calc(var(--bs-app-header-height) + var(--bs-app-toolbar-height));\n  }\n  [data-kt-app-sidebar-fixed=true] .app-wrapper {\n    margin-left: calc(var(--bs-app-sidebar-width) + var(--bs-app-sidebar-gap-start, 0px) + var(--bs-app-sidebar-gap-end, 0px));\n  }\n  [data-kt-app-sidebar-panel-fixed=true] .app-wrapper {\n    margin-left: calc(var(--bs-app-sidebar-width) + var(--bs-app-sidebar-gap-start, 0px) + var(--bs-app-sidebar-gap-end, 0px) + var(--bs-app-sidebar-panel-width) + var(--bs-app-sidebar-panel-gap-start, 0px) + var(--bs-app-sidebar-panel-gap-end, 0px));\n  }\n  [data-kt-app-aside-fixed=true] .app-wrapper {\n    margin-right: calc(var(--bs-app-aside-width) + var(--bs-app-aside-gap-start, 0px) + var(--bs-app-aside-gap-end, 0px));\n  }\n  [data-kt-app-footer-fixed=true] .app-wrapper {\n    margin-bottom: var(--bs-app-footer-height);\n  }\n}\n@media (max-width: 991.98px) {\n  .app-wrapper {\n    transition: margin-left 0.3s ease, margin-right 0.3s ease;\n  }\n  [data-kt-app-header-sticky=on] .app-wrapper {\n    margin-top: var(--bs-app-header-height-actual);\n  }\n  [data-kt-app-header-fixed-mobile=true] .app-wrapper {\n    margin-top: var(--bs-app-header-height);\n  }\n  [data-kt-app-header-fixed-mobile=true][data-kt-app-toolbar-sticky=on] .app-wrapper {\n    margin-top: calc(var(--bs-app-header-height-actual) + var(--bs-app-toolbar-height-actual));\n  }\n  [data-kt-app-footer-fixed-mobile=true] .app-wrapper {\n    margin-bottom: var(--bs-app-footer-height);\n  }\n}\n.app-main {\n  display: flex;\n}\n\n@media (min-width: 992px) {\n  .app-main {\n    transition: margin 0.3s ease;\n  }\n  [data-kt-app-sidebar-sticky=true] .app-main {\n    margin-left: calc(var(--bs-app-sidebar-width) + var(--bs-app-sidebar-gap-start, 0px) + var(--bs-app-sidebar-gap-end, 0px));\n  }\n  [data-kt-app-sidebar-panel-sticky=true] .app-main {\n    margin-left: calc(var(--bs-app-sidebar-width) + var(--bs-app-sidebar-gap-start, 0px) + var(--bs-app-sidebar-gap-end, 0px) + var(--bs-app-sidebar-panel-width) + var(--bs-app-sidebar-panel-gap-start, 0px) + var(--bs-app-sidebar-panel-gap-end, 0px));\n  }\n  [data-kt-app-aside-sticky=true] .app-main {\n    margin-right: calc(var(--bs-app-aside-width) + var(--bs-app-aside-gap-start, 0px) + var(--bs-app-aside-gap-end, 0px));\n  }\n}\n@media (max-width: 991.98px) {\n  .app-main {\n    padding-left: 0;\n    padding-right: 0;\n  }\n}\n@media (min-width: 992px) {\n  .app-content {\n    padding-top: 30px;\n    padding-bottom: 30px;\n    padding-left: 0;\n    padding-right: 0;\n  }\n}\n@media (max-width: 991.98px) {\n  .app-content {\n    max-width: none;\n    padding-top: 20px;\n    padding-bottom: 20px;\n    padding-left: 0;\n    padding-right: 0;\n  }\n}\n.app-footer {\n  transition: left 0.3s ease, right 0.3s ease;\n  display: flex;\n  align-items: center;\n  background-color: var(--bs-app-footer-bg-color);\n  border-top: var(--bs-app-footer-border-top);\n}\n\n@media (min-width: 992px) {\n  :root {\n    --bs-app-footer-height: 60px;\n  }\n  .app-footer {\n    height: var(--bs-app-footer-height);\n  }\n  [data-kt-app-footer-fixed=true] .app-footer {\n    z-index: 100;\n    box-shadow: var(--bs-app-footer-box-shadow);\n    position: fixed;\n    left: 0;\n    right: 0;\n    bottom: 0;\n  }\n  [data-kt-app-sidebar-fixed=true][data-kt-app-sidebar-push-footer=true] .app-footer {\n    left: calc(var(--bs-app-sidebar-width) + var(--bs-app-sidebar-gap-start, 0px) + var(--bs-app-sidebar-gap-end, 0px));\n  }\n  [data-kt-app-sidebar-panel-fixed=true][data-kt-app-sidebar-panel-push-footer=true] .app-footer {\n    left: calc(var(--bs-app-sidebar-width) + var(--bs-app-sidebar-gap-start, 0px) + var(--bs-app-sidebar-gap-end, 0px) + var(--bs-app-sidebar-panel-width) + var(--bs-app-sidebar-panel-gap-start, 0px) + var(--bs-app-sidebar-panel-gap-end, 0px));\n  }\n  [data-kt-app-aside-fixed=true][data-kt-app-aside-push-footer=true] .app-footer {\n    right: calc(var(--bs-app-aside-width) + var(--bs-app-aside-gap-start, 0px) + var(--bs-app-aside-gap-end, 0px));\n  }\n}\n@media (max-width: 991.98px) {\n  body {\n    --bs-app-footer-height: auto;\n  }\n  .app-footer {\n    height: var(--bs-app-footer-height);\n  }\n  [data-kt-app-footer-fixed-mobile=true] .app-footer {\n    z-index: 100;\n    box-shadow: var(--bs-app-footer-box-shadow);\n    position: fixed;\n    left: 0;\n    right: 0;\n    bottom: 0;\n  }\n}\n.app-layout-builder-toggle {\n  position: fixed;\n  z-index: 105;\n  bottom: 40px;\n  right: 50px;\n}\n\n@media (max-width: 991.98px) {\n  .app-layout-builder-toggle {\n    bottom: 20px;\n    right: 40px;\n  }\n}\n[data-bs-theme=light] {\n  --bs-app-header-base-menu-link-bg-color-active: #F9F9F9;\n  --bs-app-header-light-separator-color: #E4E6EF;\n  --bs-app-sidebar-base-toggle-btn-box-shadow: 0px 0px 10px rgba(113, 121, 136, 0.1);\n  --bs-app-sidebar-base-toggle-btn-bg-color: #ffffff;\n  --bs-app-sidebar-light-bg-color: #ffffff;\n  --bs-app-sidebar-light-box-shadow: 0 0 28px 0 rgba(82, 63, 105, 0.05);\n  --bs-app-sidebar-light-separator-color: #E4E6EF;\n  --bs-app-sidebar-light-scrollbar-color: #F4F4F4;\n  --bs-app-sidebar-light-scrollbar-color-hover: #F4F4F4;\n  --bs-app-sidebar-light-menu-heading-color: #B5B5C3;\n  --bs-app-sidebar-light-menu-link-bg-color-active: #F4F6FA;\n  --bs-app-sidebar-light-header-menu-link-bg-color-active: #EAEEF2;\n}\n\n[data-bs-theme=dark] {\n  --bs-app-header-base-menu-link-bg-color-active: #2A2A3C;\n  --bs-app-header-light-separator-color: #2B2B40;\n  --bs-app-sidebar-base-toggle-btn-box-shadow: none;\n  --bs-app-sidebar-base-toggle-btn-bg-color: #2A2A3C;\n  --bs-app-sidebar-light-bg-color: #1e1e2d;\n  --bs-app-sidebar-light-box-shadow: none;\n  --bs-app-sidebar-light-separator-color: #2B2B40;\n  --bs-app-sidebar-light-scrollbar-color: #2B2B40;\n  --bs-app-sidebar-light-scrollbar-color-hover: #2B2B40;\n  --bs-app-sidebar-light-menu-heading-color: #565674;\n  --bs-app-sidebar-light-menu-link-bg-color-active: #2A2A3C;\n  --bs-app-sidebar-light-header-menu-link-bg-color-active: #1b1b29;\n}\n\n@media (min-width: 992px) {\n  .app-sidebar-toggle {\n    box-shadow: var(--bs-app-sidebar-base-toggle-btn-box-shadow) !important;\n    background-color: var(--bs-app-sidebar-base-toggle-btn-bg-color) !important;\n  }\n  .app-sidebar-toggle .active .svg-icon {\n    transform: rotateZ(0deg) !important;\n  }\n  [dir=rtl] .app-sidebar-toggle .svg-icon {\n    transform: rotateZ(180deg);\n  }\n  [dir=rtl] .app-sidebar-toggle.active .svg-icon {\n    transform: rotateZ(0deg) !important;\n  }\n  .app-sidebar-logo {\n    height: var(--bs-app-header-height);\n    display: flex;\n    align-items: center;\n    justify-content: space-between;\n    position: relative;\n    flex-shrink: 0;\n  }\n  .app-sidebar-menu .menu > .menu-item {\n    margin-left: 0.115rem;\n  }\n}\n@media (max-width: 991.98px) {\n  .app-sidebar-logo {\n    display: none;\n  }\n}\n.app-sidebar-logo-minimize {\n  display: none;\n}\n\n.app-sidebar-footer .btn-custom .btn-icon {\n  display: none;\n}\n\n@media (min-width: 992px) {\n  [data-kt-app-sidebar-minimize=on]:not([data-kt-app-sidebar-hoverable=true]) .app-sidebar .app-sidebar-logo .app-sidebar-logo-default {\n    display: none;\n  }\n  [data-kt-app-sidebar-minimize=on]:not([data-kt-app-sidebar-hoverable=true]) .app-sidebar .app-sidebar-logo .app-sidebar-logo-minimize {\n    display: inline-block;\n  }\n  [data-kt-app-sidebar-minimize=on]:not([data-kt-app-sidebar-hoverable=true]) .app-sidebar .app-sidebar-wrapper {\n    width: var(--bs-app-sidebar-width-actual);\n  }\n  [data-kt-app-sidebar-minimize=on]:not([data-kt-app-sidebar-hoverable=true]) .app-sidebar .app-sidebar-menu .menu-content,\n[data-kt-app-sidebar-minimize=on]:not([data-kt-app-sidebar-hoverable=true]) .app-sidebar .app-sidebar-menu .menu-title {\n    opacity: 0;\n    transition: opacity 0.3s ease !important;\n  }\n  [data-kt-app-sidebar-minimize=on]:not([data-kt-app-sidebar-hoverable=true]) .app-sidebar .app-sidebar-menu .menu-item.show > .menu-sub {\n    height: 0;\n    overflow: hidden;\n    transition: height 0.3s ease !important;\n  }\n  [data-kt-app-sidebar-minimize=on]:not([data-kt-app-sidebar-hoverable=true]) .app-sidebar .app-sidebar-footer .btn-custom {\n    padding-left: 0 !important;\n    padding-right: 0 !important;\n  }\n  [data-kt-app-sidebar-minimize=on]:not([data-kt-app-sidebar-hoverable=true]) .app-sidebar .app-sidebar-footer .btn-custom .btn-label {\n    width: 0;\n    display: none;\n  }\n  [data-kt-app-sidebar-minimize=on]:not([data-kt-app-sidebar-hoverable=true]) .app-sidebar .app-sidebar-footer .btn-custom .btn-icon {\n    width: auto;\n    display: block;\n  }\n  [data-kt-app-sidebar-minimize=on][data-kt-app-sidebar-hoverable=true] .app-sidebar:not(:hover) .app-sidebar-logo .app-sidebar-logo-default {\n    display: none;\n  }\n  [data-kt-app-sidebar-minimize=on][data-kt-app-sidebar-hoverable=true] .app-sidebar:not(:hover) .app-sidebar-logo .app-sidebar-logo-minimize {\n    display: inline-block;\n  }\n  [data-kt-app-sidebar-minimize=on][data-kt-app-sidebar-hoverable=true] .app-sidebar:not(:hover) .app-sidebar-wrapper {\n    width: var(--bs-app-sidebar-width-actual);\n  }\n  [data-kt-app-sidebar-minimize=on][data-kt-app-sidebar-hoverable=true] .app-sidebar:not(:hover) .app-sidebar-menu .menu-content,\n[data-kt-app-sidebar-minimize=on][data-kt-app-sidebar-hoverable=true] .app-sidebar:not(:hover) .app-sidebar-menu .menu-title {\n    opacity: 0;\n    transition: opacity 0.3s ease !important;\n  }\n  [data-kt-app-sidebar-minimize=on][data-kt-app-sidebar-hoverable=true] .app-sidebar:not(:hover) .app-sidebar-menu .menu-item.show > .menu-sub {\n    height: 0;\n    overflow: hidden;\n    transition: height 0.3s ease !important;\n  }\n  [data-kt-app-sidebar-minimize=on][data-kt-app-sidebar-hoverable=true] .app-sidebar:not(:hover) .app-sidebar-footer .btn-custom {\n    padding-left: 0 !important;\n    padding-right: 0 !important;\n  }\n  [data-kt-app-sidebar-minimize=on][data-kt-app-sidebar-hoverable=true] .app-sidebar:not(:hover) .app-sidebar-footer .btn-custom .btn-label {\n    width: 0;\n    display: none;\n  }\n  [data-kt-app-sidebar-minimize=on][data-kt-app-sidebar-hoverable=true] .app-sidebar:not(:hover) .app-sidebar-footer .btn-custom .btn-icon {\n    width: auto;\n    display: block;\n  }\n}\n[data-kt-app-layout=dark-sidebar] .app-sidebar {\n  background-color: #1e1e2d;\n  border-right: 0 !important;\n}\n[data-kt-app-layout=dark-sidebar] .app-sidebar .hover-scroll-overlay-y {\n  scrollbar-color: #323248 transparent;\n}\n[data-kt-app-layout=dark-sidebar] .app-sidebar .hover-scroll-overlay-y::-webkit-scrollbar-thumb {\n  background-color: #323248;\n}\n[data-kt-app-layout=dark-sidebar] .app-sidebar .hover-scroll-overlay-y::-webkit-scrollbar-corner {\n  background-color: transparent;\n}\n[data-kt-app-layout=dark-sidebar] .app-sidebar .hover-scroll-overlay-y:hover {\n  scrollbar-color: #323248 transparent;\n}\n[data-kt-app-layout=dark-sidebar] .app-sidebar .hover-scroll-overlay-y:hover::-webkit-scrollbar-thumb {\n  background-color: #323248;\n}\n[data-kt-app-layout=dark-sidebar] .app-sidebar .hover-scroll-overlay-y:hover::-webkit-scrollbar-corner {\n  background-color: transparent;\n}\n[data-kt-app-layout=dark-sidebar] .app-sidebar .app-sidebar-logo {\n  border-bottom: 1px dashed #393945;\n}\n[data-kt-app-layout=dark-sidebar] .app-sidebar .btn-custom {\n  color: #B5B5C3;\n  background-color: rgba(63, 66, 84, 0.35);\n}\n[data-kt-app-layout=dark-sidebar] .app-sidebar .btn-custom i,\n[data-kt-app-layout=dark-sidebar] .app-sidebar .btn-custom .svg-icon {\n  color: #B5B5C3;\n}\n[data-kt-app-layout=dark-sidebar] .app-sidebar .btn-custom.dropdown-toggle:after {\n  color: #B5B5C3;\n}\n.btn-check:checked + [data-kt-app-layout=dark-sidebar] .app-sidebar .btn-custom, .btn-check:active + [data-kt-app-layout=dark-sidebar] .app-sidebar .btn-custom, [data-kt-app-layout=dark-sidebar] .app-sidebar .btn-custom:focus:not(.btn-active), [data-kt-app-layout=dark-sidebar] .app-sidebar .btn-custom:hover:not(.btn-active), [data-kt-app-layout=dark-sidebar] .app-sidebar .btn-custom:active:not(.btn-active), [data-kt-app-layout=dark-sidebar] .app-sidebar .btn-custom.active, [data-kt-app-layout=dark-sidebar] .app-sidebar .btn-custom.show, .show > [data-kt-app-layout=dark-sidebar] .app-sidebar .btn-custom {\n  color: #B5B5C3;\n  background-color: rgba(63, 66, 84, 0.35) !important;\n}\n[data-kt-app-layout=dark-sidebar] .app-sidebar .menu .menu-item .menu-heading {\n  color: #646477 !important;\n}\n[data-kt-app-layout=dark-sidebar] .app-sidebar .menu .menu-item .menu-link {\n  color: #9D9DA6;\n}\n[data-kt-app-layout=dark-sidebar] .app-sidebar .menu .menu-item .menu-link .menu-title {\n  color: #9D9DA6;\n}\n[data-kt-app-layout=dark-sidebar] .app-sidebar .menu .menu-item .menu-link .menu-icon,\n[data-kt-app-layout=dark-sidebar] .app-sidebar .menu .menu-item .menu-link .menu-icon .svg-icon,\n[data-kt-app-layout=dark-sidebar] .app-sidebar .menu .menu-item .menu-link .menu-icon i {\n  color: #C5C5D8;\n}\n[data-kt-app-layout=dark-sidebar] .app-sidebar .menu .menu-item .menu-link .menu-bullet .bullet {\n  background-color: #787887;\n}\n[data-kt-app-layout=dark-sidebar] .app-sidebar .menu .menu-item .menu-link .menu-arrow:after {\n  mask-repeat: no-repeat;\n  mask-position: center;\n  -webkit-mask-repeat: no-repeat;\n  -webkit-mask-position: center;\n  background-color: #787887;\n  -webkit-mask-image: url(\"data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 6 6' fill='%23787887'%3e%3cpath d='M2.72011 2.76429L4.46358 1.02083C4.63618 0.848244 4.63617 0.568419 4.46358 0.395831C4.29099 0.223244 4.01118 0.223244 3.83861 0.395831L1.52904 2.70537C1.36629 2.86808 1.36629 3.13191 1.52904 3.29462L3.83861 5.60419C4.01117 5.77675 4.29099 5.77675 4.46358 5.60419C4.63617 5.43156 4.63617 5.15175 4.46358 4.97919L2.72011 3.23571C2.58994 3.10554 2.58994 2.89446 2.72011 2.76429Z'/%3e%3c/svg%3e\");\n  mask-image: url(\"data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 6 6' fill='%23787887'%3e%3cpath d='M2.72011 2.76429L4.46358 1.02083C4.63618 0.848244 4.63617 0.568419 4.46358 0.395831C4.29099 0.223244 4.01118 0.223244 3.83861 0.395831L1.52904 2.70537C1.36629 2.86808 1.36629 3.13191 1.52904 3.29462L3.83861 5.60419C4.01117 5.77675 4.29099 5.77675 4.46358 5.60419C4.63617 5.43156 4.63617 5.15175 4.46358 4.97919L2.72011 3.23571C2.58994 3.10554 2.58994 2.89446 2.72011 2.76429Z'/%3e%3c/svg%3e\");\n  /*rtl:begin:remove*/\n  mask-repeat: no-repeat;\n  mask-position: center;\n  -webkit-mask-repeat: no-repeat;\n  -webkit-mask-position: center;\n  background-color: #787887;\n  -webkit-mask-image: url(\"data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 6 6' fill='%23787887'%3e%3cpath d='M3.27989 3.23571L1.53642 4.97917C1.36382 5.15176 1.36383 5.43158 1.53642 5.60417C1.70901 5.77676 1.98882 5.77676 2.16139 5.60417L4.47096 3.29463C4.63371 3.13192 4.63371 2.86809 4.47096 2.70538L2.16139 0.395812C1.98883 0.22325 1.70901 0.22325 1.53642 0.395812C1.36383 0.568437 1.36383 0.84825 1.53642 1.02081L3.27989 2.76429C3.41006 2.89446 3.41006 3.10554 3.27989 3.23571Z'/%3e%3c/svg%3e\");\n  mask-image: url(\"data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 6 6' fill='%23787887'%3e%3cpath d='M3.27989 3.23571L1.53642 4.97917C1.36382 5.15176 1.36383 5.43158 1.53642 5.60417C1.70901 5.77676 1.98882 5.77676 2.16139 5.60417L4.47096 3.29463C4.63371 3.13192 4.63371 2.86809 4.47096 2.70538L2.16139 0.395812C1.98883 0.22325 1.70901 0.22325 1.53642 0.395812C1.36383 0.568437 1.36383 0.84825 1.53642 1.02081L3.27989 2.76429C3.41006 2.89446 3.41006 3.10554 3.27989 3.23571Z'/%3e%3c/svg%3e\");\n  /*rtl:end:remove*/\n}\n[data-kt-app-layout=dark-sidebar] .app-sidebar .menu .menu-item.hover:not(.here) > .menu-link:not(.disabled):not(.active):not(.here), [data-kt-app-layout=dark-sidebar] .app-sidebar .menu .menu-item:not(.here) .menu-link:hover:not(.disabled):not(.active):not(.here) {\n  transition: color 0.2s ease;\n  color: var(--bs-primary-inverse);\n}\n[data-kt-app-layout=dark-sidebar] .app-sidebar .menu .menu-item.hover:not(.here) > .menu-link:not(.disabled):not(.active):not(.here) .menu-title, [data-kt-app-layout=dark-sidebar] .app-sidebar .menu .menu-item:not(.here) .menu-link:hover:not(.disabled):not(.active):not(.here) .menu-title {\n  color: var(--bs-primary-inverse);\n}\n[data-kt-app-layout=dark-sidebar] .app-sidebar .menu .menu-item.hover:not(.here) > .menu-link:not(.disabled):not(.active):not(.here) .menu-icon,\n[data-kt-app-layout=dark-sidebar] .app-sidebar .menu .menu-item.hover:not(.here) > .menu-link:not(.disabled):not(.active):not(.here) .menu-icon .svg-icon,\n[data-kt-app-layout=dark-sidebar] .app-sidebar .menu .menu-item.hover:not(.here) > .menu-link:not(.disabled):not(.active):not(.here) .menu-icon i, [data-kt-app-layout=dark-sidebar] .app-sidebar .menu .menu-item:not(.here) .menu-link:hover:not(.disabled):not(.active):not(.here) .menu-icon,\n[data-kt-app-layout=dark-sidebar] .app-sidebar .menu .menu-item:not(.here) .menu-link:hover:not(.disabled):not(.active):not(.here) .menu-icon .svg-icon,\n[data-kt-app-layout=dark-sidebar] .app-sidebar .menu .menu-item:not(.here) .menu-link:hover:not(.disabled):not(.active):not(.here) .menu-icon i {\n  color: var(--bs-primary-inverse);\n}\n[data-kt-app-layout=dark-sidebar] .app-sidebar .menu .menu-item.hover:not(.here) > .menu-link:not(.disabled):not(.active):not(.here) .menu-bullet .bullet, [data-kt-app-layout=dark-sidebar] .app-sidebar .menu .menu-item:not(.here) .menu-link:hover:not(.disabled):not(.active):not(.here) .menu-bullet .bullet {\n  background-color: var(--bs-primary-inverse);\n}\n[data-kt-app-layout=dark-sidebar] .app-sidebar .menu .menu-item.hover:not(.here) > .menu-link:not(.disabled):not(.active):not(.here) .menu-arrow:after, [data-kt-app-layout=dark-sidebar] .app-sidebar .menu .menu-item:not(.here) .menu-link:hover:not(.disabled):not(.active):not(.here) .menu-arrow:after {\n  mask-repeat: no-repeat;\n  mask-position: center;\n  -webkit-mask-repeat: no-repeat;\n  -webkit-mask-position: center;\n  background-color: var(--bs-primary-inverse);\n  -webkit-mask-image: url(\"data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 6 6' fill='var%28--bs-primary-inverse%29'%3e%3cpath d='M2.72011 2.76429L4.46358 1.02083C4.63618 0.848244 4.63617 0.568419 4.46358 0.395831C4.29099 0.223244 4.01118 0.223244 3.83861 0.395831L1.52904 2.70537C1.36629 2.86808 1.36629 3.13191 1.52904 3.29462L3.83861 5.60419C4.01117 5.77675 4.29099 5.77675 4.46358 5.60419C4.63617 5.43156 4.63617 5.15175 4.46358 4.97919L2.72011 3.23571C2.58994 3.10554 2.58994 2.89446 2.72011 2.76429Z'/%3e%3c/svg%3e\");\n  mask-image: url(\"data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 6 6' fill='var%28--bs-primary-inverse%29'%3e%3cpath d='M2.72011 2.76429L4.46358 1.02083C4.63618 0.848244 4.63617 0.568419 4.46358 0.395831C4.29099 0.223244 4.01118 0.223244 3.83861 0.395831L1.52904 2.70537C1.36629 2.86808 1.36629 3.13191 1.52904 3.29462L3.83861 5.60419C4.01117 5.77675 4.29099 5.77675 4.46358 5.60419C4.63617 5.43156 4.63617 5.15175 4.46358 4.97919L2.72011 3.23571C2.58994 3.10554 2.58994 2.89446 2.72011 2.76429Z'/%3e%3c/svg%3e\");\n  /*rtl:begin:remove*/\n  mask-repeat: no-repeat;\n  mask-position: center;\n  -webkit-mask-repeat: no-repeat;\n  -webkit-mask-position: center;\n  background-color: var(--bs-primary-inverse);\n  -webkit-mask-image: url(\"data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 6 6' fill='var%28--bs-primary-inverse%29'%3e%3cpath d='M3.27989 3.23571L1.53642 4.97917C1.36382 5.15176 1.36383 5.43158 1.53642 5.60417C1.70901 5.77676 1.98882 5.77676 2.16139 5.60417L4.47096 3.29463C4.63371 3.13192 4.63371 2.86809 4.47096 2.70538L2.16139 0.395812C1.98883 0.22325 1.70901 0.22325 1.53642 0.395812C1.36383 0.568437 1.36383 0.84825 1.53642 1.02081L3.27989 2.76429C3.41006 2.89446 3.41006 3.10554 3.27989 3.23571Z'/%3e%3c/svg%3e\");\n  mask-image: url(\"data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 6 6' fill='var%28--bs-primary-inverse%29'%3e%3cpath d='M3.27989 3.23571L1.53642 4.97917C1.36382 5.15176 1.36383 5.43158 1.53642 5.60417C1.70901 5.77676 1.98882 5.77676 2.16139 5.60417L4.47096 3.29463C4.63371 3.13192 4.63371 2.86809 4.47096 2.70538L2.16139 0.395812C1.98883 0.22325 1.70901 0.22325 1.53642 0.395812C1.36383 0.568437 1.36383 0.84825 1.53642 1.02081L3.27989 2.76429C3.41006 2.89446 3.41006 3.10554 3.27989 3.23571Z'/%3e%3c/svg%3e\");\n  /*rtl:end:remove*/\n}\n[data-kt-app-layout=dark-sidebar] .app-sidebar .menu .menu-item.here > .menu-link {\n  transition: color 0.2s ease;\n  color: var(--bs-primary-inverse);\n}\n[data-kt-app-layout=dark-sidebar] .app-sidebar .menu .menu-item.here > .menu-link .menu-title {\n  color: var(--bs-primary-inverse);\n}\n[data-kt-app-layout=dark-sidebar] .app-sidebar .menu .menu-item.here > .menu-link .menu-icon,\n[data-kt-app-layout=dark-sidebar] .app-sidebar .menu .menu-item.here > .menu-link .menu-icon .svg-icon,\n[data-kt-app-layout=dark-sidebar] .app-sidebar .menu .menu-item.here > .menu-link .menu-icon i {\n  color: var(--bs-primary-inverse);\n}\n[data-kt-app-layout=dark-sidebar] .app-sidebar .menu .menu-item.here > .menu-link .menu-bullet .bullet {\n  background-color: var(--bs-primary-inverse);\n}\n[data-kt-app-layout=dark-sidebar] .app-sidebar .menu .menu-item.here > .menu-link .menu-arrow:after {\n  mask-repeat: no-repeat;\n  mask-position: center;\n  -webkit-mask-repeat: no-repeat;\n  -webkit-mask-position: center;\n  background-color: var(--bs-primary-inverse);\n  -webkit-mask-image: url(\"data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 6 6' fill='var%28--bs-primary-inverse%29'%3e%3cpath d='M2.72011 2.76429L4.46358 1.02083C4.63618 0.848244 4.63617 0.568419 4.46358 0.395831C4.29099 0.223244 4.01118 0.223244 3.83861 0.395831L1.52904 2.70537C1.36629 2.86808 1.36629 3.13191 1.52904 3.29462L3.83861 5.60419C4.01117 5.77675 4.29099 5.77675 4.46358 5.60419C4.63617 5.43156 4.63617 5.15175 4.46358 4.97919L2.72011 3.23571C2.58994 3.10554 2.58994 2.89446 2.72011 2.76429Z'/%3e%3c/svg%3e\");\n  mask-image: url(\"data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 6 6' fill='var%28--bs-primary-inverse%29'%3e%3cpath d='M2.72011 2.76429L4.46358 1.02083C4.63618 0.848244 4.63617 0.568419 4.46358 0.395831C4.29099 0.223244 4.01118 0.223244 3.83861 0.395831L1.52904 2.70537C1.36629 2.86808 1.36629 3.13191 1.52904 3.29462L3.83861 5.60419C4.01117 5.77675 4.29099 5.77675 4.46358 5.60419C4.63617 5.43156 4.63617 5.15175 4.46358 4.97919L2.72011 3.23571C2.58994 3.10554 2.58994 2.89446 2.72011 2.76429Z'/%3e%3c/svg%3e\");\n  /*rtl:begin:remove*/\n  mask-repeat: no-repeat;\n  mask-position: center;\n  -webkit-mask-repeat: no-repeat;\n  -webkit-mask-position: center;\n  background-color: var(--bs-primary-inverse);\n  -webkit-mask-image: url(\"data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 6 6' fill='var%28--bs-primary-inverse%29'%3e%3cpath d='M3.27989 3.23571L1.53642 4.97917C1.36382 5.15176 1.36383 5.43158 1.53642 5.60417C1.70901 5.77676 1.98882 5.77676 2.16139 5.60417L4.47096 3.29463C4.63371 3.13192 4.63371 2.86809 4.47096 2.70538L2.16139 0.395812C1.98883 0.22325 1.70901 0.22325 1.53642 0.395812C1.36383 0.568437 1.36383 0.84825 1.53642 1.02081L3.27989 2.76429C3.41006 2.89446 3.41006 3.10554 3.27989 3.23571Z'/%3e%3c/svg%3e\");\n  mask-image: url(\"data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 6 6' fill='var%28--bs-primary-inverse%29'%3e%3cpath d='M3.27989 3.23571L1.53642 4.97917C1.36382 5.15176 1.36383 5.43158 1.53642 5.60417C1.70901 5.77676 1.98882 5.77676 2.16139 5.60417L4.47096 3.29463C4.63371 3.13192 4.63371 2.86809 4.47096 2.70538L2.16139 0.395812C1.98883 0.22325 1.70901 0.22325 1.53642 0.395812C1.36383 0.568437 1.36383 0.84825 1.53642 1.02081L3.27989 2.76429C3.41006 2.89446 3.41006 3.10554 3.27989 3.23571Z'/%3e%3c/svg%3e\");\n  /*rtl:end:remove*/\n}\n[data-kt-app-layout=dark-sidebar] .app-sidebar .menu .menu-item.show > .menu-link {\n  transition: color 0.2s ease;\n  color: var(--bs-primary-inverse);\n}\n[data-kt-app-layout=dark-sidebar] .app-sidebar .menu .menu-item.show > .menu-link .menu-title {\n  color: var(--bs-primary-inverse);\n}\n[data-kt-app-layout=dark-sidebar] .app-sidebar .menu .menu-item.show > .menu-link .menu-icon,\n[data-kt-app-layout=dark-sidebar] .app-sidebar .menu .menu-item.show > .menu-link .menu-icon .svg-icon,\n[data-kt-app-layout=dark-sidebar] .app-sidebar .menu .menu-item.show > .menu-link .menu-icon i {\n  color: var(--bs-primary-inverse);\n}\n[data-kt-app-layout=dark-sidebar] .app-sidebar .menu .menu-item.show > .menu-link .menu-bullet .bullet {\n  background-color: var(--bs-primary-inverse);\n}\n[data-kt-app-layout=dark-sidebar] .app-sidebar .menu .menu-item.show > .menu-link .menu-arrow:after {\n  mask-repeat: no-repeat;\n  mask-position: center;\n  -webkit-mask-repeat: no-repeat;\n  -webkit-mask-position: center;\n  background-color: var(--bs-primary-inverse);\n  -webkit-mask-image: url(\"data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 6 6' fill='var%28--bs-primary-inverse%29'%3e%3cpath d='M2.72011 2.76429L4.46358 1.02083C4.63618 0.848244 4.63617 0.568419 4.46358 0.395831C4.29099 0.223244 4.01118 0.223244 3.83861 0.395831L1.52904 2.70537C1.36629 2.86808 1.36629 3.13191 1.52904 3.29462L3.83861 5.60419C4.01117 5.77675 4.29099 5.77675 4.46358 5.60419C4.63617 5.43156 4.63617 5.15175 4.46358 4.97919L2.72011 3.23571C2.58994 3.10554 2.58994 2.89446 2.72011 2.76429Z'/%3e%3c/svg%3e\");\n  mask-image: url(\"data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 6 6' fill='var%28--bs-primary-inverse%29'%3e%3cpath d='M2.72011 2.76429L4.46358 1.02083C4.63618 0.848244 4.63617 0.568419 4.46358 0.395831C4.29099 0.223244 4.01118 0.223244 3.83861 0.395831L1.52904 2.70537C1.36629 2.86808 1.36629 3.13191 1.52904 3.29462L3.83861 5.60419C4.01117 5.77675 4.29099 5.77675 4.46358 5.60419C4.63617 5.43156 4.63617 5.15175 4.46358 4.97919L2.72011 3.23571C2.58994 3.10554 2.58994 2.89446 2.72011 2.76429Z'/%3e%3c/svg%3e\");\n  /*rtl:begin:remove*/\n  mask-repeat: no-repeat;\n  mask-position: center;\n  -webkit-mask-repeat: no-repeat;\n  -webkit-mask-position: center;\n  background-color: var(--bs-primary-inverse);\n  -webkit-mask-image: url(\"data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 6 6' fill='var%28--bs-primary-inverse%29'%3e%3cpath d='M3.27989 3.23571L1.53642 4.97917C1.36382 5.15176 1.36383 5.43158 1.53642 5.60417C1.70901 5.77676 1.98882 5.77676 2.16139 5.60417L4.47096 3.29463C4.63371 3.13192 4.63371 2.86809 4.47096 2.70538L2.16139 0.395812C1.98883 0.22325 1.70901 0.22325 1.53642 0.395812C1.36383 0.568437 1.36383 0.84825 1.53642 1.02081L3.27989 2.76429C3.41006 2.89446 3.41006 3.10554 3.27989 3.23571Z'/%3e%3c/svg%3e\");\n  mask-image: url(\"data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 6 6' fill='var%28--bs-primary-inverse%29'%3e%3cpath d='M3.27989 3.23571L1.53642 4.97917C1.36382 5.15176 1.36383 5.43158 1.53642 5.60417C1.70901 5.77676 1.98882 5.77676 2.16139 5.60417L4.47096 3.29463C4.63371 3.13192 4.63371 2.86809 4.47096 2.70538L2.16139 0.395812C1.98883 0.22325 1.70901 0.22325 1.53642 0.395812C1.36383 0.568437 1.36383 0.84825 1.53642 1.02081L3.27989 2.76429C3.41006 2.89446 3.41006 3.10554 3.27989 3.23571Z'/%3e%3c/svg%3e\");\n  /*rtl:end:remove*/\n}\n[data-kt-app-layout=dark-sidebar] .app-sidebar .menu .menu-item .menu-link.active {\n  transition: color 0.2s ease;\n  background-color: #2A2A3C;\n  color: var(--bs-primary-inverse);\n}\n[data-kt-app-layout=dark-sidebar] .app-sidebar .menu .menu-item .menu-link.active .menu-title {\n  color: var(--bs-primary-inverse);\n}\n[data-kt-app-layout=dark-sidebar] .app-sidebar .menu .menu-item .menu-link.active .menu-icon,\n[data-kt-app-layout=dark-sidebar] .app-sidebar .menu .menu-item .menu-link.active .menu-icon .svg-icon,\n[data-kt-app-layout=dark-sidebar] .app-sidebar .menu .menu-item .menu-link.active .menu-icon i {\n  color: var(--bs-primary-inverse);\n}\n[data-kt-app-layout=dark-sidebar] .app-sidebar .menu .menu-item .menu-link.active .menu-bullet .bullet {\n  background-color: var(--bs-primary-inverse);\n}\n[data-kt-app-layout=dark-sidebar] .app-sidebar .menu .menu-item .menu-link.active .menu-arrow:after {\n  mask-repeat: no-repeat;\n  mask-position: center;\n  -webkit-mask-repeat: no-repeat;\n  -webkit-mask-position: center;\n  background-color: var(--bs-primary-inverse);\n  -webkit-mask-image: url(\"data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 6 6' fill='var%28--bs-primary-inverse%29'%3e%3cpath d='M2.72011 2.76429L4.46358 1.02083C4.63618 0.848244 4.63617 0.568419 4.46358 0.395831C4.29099 0.223244 4.01118 0.223244 3.83861 0.395831L1.52904 2.70537C1.36629 2.86808 1.36629 3.13191 1.52904 3.29462L3.83861 5.60419C4.01117 5.77675 4.29099 5.77675 4.46358 5.60419C4.63617 5.43156 4.63617 5.15175 4.46358 4.97919L2.72011 3.23571C2.58994 3.10554 2.58994 2.89446 2.72011 2.76429Z'/%3e%3c/svg%3e\");\n  mask-image: url(\"data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 6 6' fill='var%28--bs-primary-inverse%29'%3e%3cpath d='M2.72011 2.76429L4.46358 1.02083C4.63618 0.848244 4.63617 0.568419 4.46358 0.395831C4.29099 0.223244 4.01118 0.223244 3.83861 0.395831L1.52904 2.70537C1.36629 2.86808 1.36629 3.13191 1.52904 3.29462L3.83861 5.60419C4.01117 5.77675 4.29099 5.77675 4.46358 5.60419C4.63617 5.43156 4.63617 5.15175 4.46358 4.97919L2.72011 3.23571C2.58994 3.10554 2.58994 2.89446 2.72011 2.76429Z'/%3e%3c/svg%3e\");\n  /*rtl:begin:remove*/\n  mask-repeat: no-repeat;\n  mask-position: center;\n  -webkit-mask-repeat: no-repeat;\n  -webkit-mask-position: center;\n  background-color: var(--bs-primary-inverse);\n  -webkit-mask-image: url(\"data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 6 6' fill='var%28--bs-primary-inverse%29'%3e%3cpath d='M3.27989 3.23571L1.53642 4.97917C1.36382 5.15176 1.36383 5.43158 1.53642 5.60417C1.70901 5.77676 1.98882 5.77676 2.16139 5.60417L4.47096 3.29463C4.63371 3.13192 4.63371 2.86809 4.47096 2.70538L2.16139 0.395812C1.98883 0.22325 1.70901 0.22325 1.53642 0.395812C1.36383 0.568437 1.36383 0.84825 1.53642 1.02081L3.27989 2.76429C3.41006 2.89446 3.41006 3.10554 3.27989 3.23571Z'/%3e%3c/svg%3e\");\n  mask-image: url(\"data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 6 6' fill='var%28--bs-primary-inverse%29'%3e%3cpath d='M3.27989 3.23571L1.53642 4.97917C1.36382 5.15176 1.36383 5.43158 1.53642 5.60417C1.70901 5.77676 1.98882 5.77676 2.16139 5.60417L4.47096 3.29463C4.63371 3.13192 4.63371 2.86809 4.47096 2.70538L2.16139 0.395812C1.98883 0.22325 1.70901 0.22325 1.53642 0.395812C1.36383 0.568437 1.36383 0.84825 1.53642 1.02081L3.27989 2.76429C3.41006 2.89446 3.41006 3.10554 3.27989 3.23571Z'/%3e%3c/svg%3e\");\n  /*rtl:end:remove*/\n}\n\n@media (min-width: 992px) {\n  [data-kt-app-layout=dark-sidebar] .app-sidebar .menu-sub-lg-dropdown {\n    background-color: #1e1e2d;\n  }\n}\n[data-kt-app-layout=light-sidebar] .app-sidebar {\n  background-color: var(--bs-app-sidebar-light-bg-color);\n  border-right: 0 !important;\n}\n[data-kt-app-layout=light-sidebar] .app-sidebar .hover-scroll-overlay-y {\n  scrollbar-color: var(--bs-app-sidebar-light-scrollbar-color) transparent;\n}\n[data-kt-app-layout=light-sidebar] .app-sidebar .hover-scroll-overlay-y::-webkit-scrollbar-thumb {\n  background-color: var(--bs-app-sidebar-light-scrollbar-color);\n}\n[data-kt-app-layout=light-sidebar] .app-sidebar .hover-scroll-overlay-y::-webkit-scrollbar-corner {\n  background-color: transparent;\n}\n[data-kt-app-layout=light-sidebar] .app-sidebar .hover-scroll-overlay-y:hover {\n  scrollbar-color: var(--bs-app-sidebar-light-scrollbar-color-hover) transparent;\n}\n[data-kt-app-layout=light-sidebar] .app-sidebar .hover-scroll-overlay-y:hover::-webkit-scrollbar-thumb {\n  background-color: var(--bs-app-sidebar-light-scrollbar-color-hover);\n}\n[data-kt-app-layout=light-sidebar] .app-sidebar .hover-scroll-overlay-y:hover::-webkit-scrollbar-corner {\n  background-color: transparent;\n}\n[data-kt-app-layout=light-sidebar] .app-sidebar .app-sidebar-logo {\n  border-bottom: 1px solid var(--bs-app-sidebar-light-separator-color);\n}\n[data-kt-app-layout=light-sidebar] .app-sidebar .menu {\n  font-weight: 500;\n}\n[data-kt-app-layout=light-sidebar] .app-sidebar .menu .menu-item .menu-heading {\n  color: var(--bs-app-sidebar-light-menu-heading-color) !important;\n}\n[data-kt-app-layout=light-sidebar] .app-sidebar .menu .menu-item .menu-link {\n  color: var(--bs-gray-700);\n}\n[data-kt-app-layout=light-sidebar] .app-sidebar .menu .menu-item .menu-link .menu-title {\n  color: var(--bs-gray-700);\n}\n[data-kt-app-layout=light-sidebar] .app-sidebar .menu .menu-item .menu-link .menu-icon,\n[data-kt-app-layout=light-sidebar] .app-sidebar .menu .menu-item .menu-link .menu-icon .svg-icon,\n[data-kt-app-layout=light-sidebar] .app-sidebar .menu .menu-item .menu-link .menu-icon i {\n  color: var(--bs-gray-500);\n}\n[data-kt-app-layout=light-sidebar] .app-sidebar .menu .menu-item .menu-link .menu-bullet .bullet {\n  background-color: var(--bs-gray-500);\n}\n[data-kt-app-layout=light-sidebar] .app-sidebar .menu .menu-item .menu-link .menu-arrow:after {\n  mask-repeat: no-repeat;\n  mask-position: center;\n  -webkit-mask-repeat: no-repeat;\n  -webkit-mask-position: center;\n  background-color: var(--bs-gray-500);\n  -webkit-mask-image: url(\"data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 6 6' fill='var%28--bs-gray-500%29'%3e%3cpath d='M2.72011 2.76429L4.46358 1.02083C4.63618 0.848244 4.63617 0.568419 4.46358 0.395831C4.29099 0.223244 4.01118 0.223244 3.83861 0.395831L1.52904 2.70537C1.36629 2.86808 1.36629 3.13191 1.52904 3.29462L3.83861 5.60419C4.01117 5.77675 4.29099 5.77675 4.46358 5.60419C4.63617 5.43156 4.63617 5.15175 4.46358 4.97919L2.72011 3.23571C2.58994 3.10554 2.58994 2.89446 2.72011 2.76429Z'/%3e%3c/svg%3e\");\n  mask-image: url(\"data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 6 6' fill='var%28--bs-gray-500%29'%3e%3cpath d='M2.72011 2.76429L4.46358 1.02083C4.63618 0.848244 4.63617 0.568419 4.46358 0.395831C4.29099 0.223244 4.01118 0.223244 3.83861 0.395831L1.52904 2.70537C1.36629 2.86808 1.36629 3.13191 1.52904 3.29462L3.83861 5.60419C4.01117 5.77675 4.29099 5.77675 4.46358 5.60419C4.63617 5.43156 4.63617 5.15175 4.46358 4.97919L2.72011 3.23571C2.58994 3.10554 2.58994 2.89446 2.72011 2.76429Z'/%3e%3c/svg%3e\");\n  /*rtl:begin:remove*/\n  mask-repeat: no-repeat;\n  mask-position: center;\n  -webkit-mask-repeat: no-repeat;\n  -webkit-mask-position: center;\n  background-color: var(--bs-gray-500);\n  -webkit-mask-image: url(\"data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 6 6' fill='var%28--bs-gray-500%29'%3e%3cpath d='M3.27989 3.23571L1.53642 4.97917C1.36382 5.15176 1.36383 5.43158 1.53642 5.60417C1.70901 5.77676 1.98882 5.77676 2.16139 5.60417L4.47096 3.29463C4.63371 3.13192 4.63371 2.86809 4.47096 2.70538L2.16139 0.395812C1.98883 0.22325 1.70901 0.22325 1.53642 0.395812C1.36383 0.568437 1.36383 0.84825 1.53642 1.02081L3.27989 2.76429C3.41006 2.89446 3.41006 3.10554 3.27989 3.23571Z'/%3e%3c/svg%3e\");\n  mask-image: url(\"data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 6 6' fill='var%28--bs-gray-500%29'%3e%3cpath d='M3.27989 3.23571L1.53642 4.97917C1.36382 5.15176 1.36383 5.43158 1.53642 5.60417C1.70901 5.77676 1.98882 5.77676 2.16139 5.60417L4.47096 3.29463C4.63371 3.13192 4.63371 2.86809 4.47096 2.70538L2.16139 0.395812C1.98883 0.22325 1.70901 0.22325 1.53642 0.395812C1.36383 0.568437 1.36383 0.84825 1.53642 1.02081L3.27989 2.76429C3.41006 2.89446 3.41006 3.10554 3.27989 3.23571Z'/%3e%3c/svg%3e\");\n  /*rtl:end:remove*/\n}\n[data-kt-app-layout=light-sidebar] .app-sidebar .menu .menu-item.hover:not(.here) > .menu-link:not(.disabled):not(.active):not(.here), [data-kt-app-layout=light-sidebar] .app-sidebar .menu .menu-item:not(.here) .menu-link:hover:not(.disabled):not(.active):not(.here) {\n  transition: color 0.2s ease;\n  color: var(--bs-gray-900);\n}\n[data-kt-app-layout=light-sidebar] .app-sidebar .menu .menu-item.hover:not(.here) > .menu-link:not(.disabled):not(.active):not(.here) .menu-title, [data-kt-app-layout=light-sidebar] .app-sidebar .menu .menu-item:not(.here) .menu-link:hover:not(.disabled):not(.active):not(.here) .menu-title {\n  color: var(--bs-gray-900);\n}\n[data-kt-app-layout=light-sidebar] .app-sidebar .menu .menu-item.hover:not(.here) > .menu-link:not(.disabled):not(.active):not(.here) .menu-icon,\n[data-kt-app-layout=light-sidebar] .app-sidebar .menu .menu-item.hover:not(.here) > .menu-link:not(.disabled):not(.active):not(.here) .menu-icon .svg-icon,\n[data-kt-app-layout=light-sidebar] .app-sidebar .menu .menu-item.hover:not(.here) > .menu-link:not(.disabled):not(.active):not(.here) .menu-icon i, [data-kt-app-layout=light-sidebar] .app-sidebar .menu .menu-item:not(.here) .menu-link:hover:not(.disabled):not(.active):not(.here) .menu-icon,\n[data-kt-app-layout=light-sidebar] .app-sidebar .menu .menu-item:not(.here) .menu-link:hover:not(.disabled):not(.active):not(.here) .menu-icon .svg-icon,\n[data-kt-app-layout=light-sidebar] .app-sidebar .menu .menu-item:not(.here) .menu-link:hover:not(.disabled):not(.active):not(.here) .menu-icon i {\n  color: var(--bs-gray-700);\n}\n[data-kt-app-layout=light-sidebar] .app-sidebar .menu .menu-item.hover:not(.here) > .menu-link:not(.disabled):not(.active):not(.here) .menu-bullet .bullet, [data-kt-app-layout=light-sidebar] .app-sidebar .menu .menu-item:not(.here) .menu-link:hover:not(.disabled):not(.active):not(.here) .menu-bullet .bullet {\n  background-color: var(--bs-gray-700);\n}\n[data-kt-app-layout=light-sidebar] .app-sidebar .menu .menu-item.hover:not(.here) > .menu-link:not(.disabled):not(.active):not(.here) .menu-arrow:after, [data-kt-app-layout=light-sidebar] .app-sidebar .menu .menu-item:not(.here) .menu-link:hover:not(.disabled):not(.active):not(.here) .menu-arrow:after {\n  mask-repeat: no-repeat;\n  mask-position: center;\n  -webkit-mask-repeat: no-repeat;\n  -webkit-mask-position: center;\n  background-color: var(--bs-gray-700);\n  -webkit-mask-image: url(\"data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 6 6' fill='var%28--bs-gray-700%29'%3e%3cpath d='M2.72011 2.76429L4.46358 1.02083C4.63618 0.848244 4.63617 0.568419 4.46358 0.395831C4.29099 0.223244 4.01118 0.223244 3.83861 0.395831L1.52904 2.70537C1.36629 2.86808 1.36629 3.13191 1.52904 3.29462L3.83861 5.60419C4.01117 5.77675 4.29099 5.77675 4.46358 5.60419C4.63617 5.43156 4.63617 5.15175 4.46358 4.97919L2.72011 3.23571C2.58994 3.10554 2.58994 2.89446 2.72011 2.76429Z'/%3e%3c/svg%3e\");\n  mask-image: url(\"data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 6 6' fill='var%28--bs-gray-700%29'%3e%3cpath d='M2.72011 2.76429L4.46358 1.02083C4.63618 0.848244 4.63617 0.568419 4.46358 0.395831C4.29099 0.223244 4.01118 0.223244 3.83861 0.395831L1.52904 2.70537C1.36629 2.86808 1.36629 3.13191 1.52904 3.29462L3.83861 5.60419C4.01117 5.77675 4.29099 5.77675 4.46358 5.60419C4.63617 5.43156 4.63617 5.15175 4.46358 4.97919L2.72011 3.23571C2.58994 3.10554 2.58994 2.89446 2.72011 2.76429Z'/%3e%3c/svg%3e\");\n  /*rtl:begin:remove*/\n  mask-repeat: no-repeat;\n  mask-position: center;\n  -webkit-mask-repeat: no-repeat;\n  -webkit-mask-position: center;\n  background-color: var(--bs-gray-700);\n  -webkit-mask-image: url(\"data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 6 6' fill='var%28--bs-gray-700%29'%3e%3cpath d='M3.27989 3.23571L1.53642 4.97917C1.36382 5.15176 1.36383 5.43158 1.53642 5.60417C1.70901 5.77676 1.98882 5.77676 2.16139 5.60417L4.47096 3.29463C4.63371 3.13192 4.63371 2.86809 4.47096 2.70538L2.16139 0.395812C1.98883 0.22325 1.70901 0.22325 1.53642 0.395812C1.36383 0.568437 1.36383 0.84825 1.53642 1.02081L3.27989 2.76429C3.41006 2.89446 3.41006 3.10554 3.27989 3.23571Z'/%3e%3c/svg%3e\");\n  mask-image: url(\"data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 6 6' fill='var%28--bs-gray-700%29'%3e%3cpath d='M3.27989 3.23571L1.53642 4.97917C1.36382 5.15176 1.36383 5.43158 1.53642 5.60417C1.70901 5.77676 1.98882 5.77676 2.16139 5.60417L4.47096 3.29463C4.63371 3.13192 4.63371 2.86809 4.47096 2.70538L2.16139 0.395812C1.98883 0.22325 1.70901 0.22325 1.53642 0.395812C1.36383 0.568437 1.36383 0.84825 1.53642 1.02081L3.27989 2.76429C3.41006 2.89446 3.41006 3.10554 3.27989 3.23571Z'/%3e%3c/svg%3e\");\n  /*rtl:end:remove*/\n}\n[data-kt-app-layout=light-sidebar] .app-sidebar .menu .menu-item.show > .menu-link {\n  transition: color 0.2s ease;\n  color: var(--bs-gray-900);\n}\n[data-kt-app-layout=light-sidebar] .app-sidebar .menu .menu-item.show > .menu-link .menu-title {\n  color: var(--bs-gray-900);\n}\n[data-kt-app-layout=light-sidebar] .app-sidebar .menu .menu-item.show > .menu-link .menu-icon,\n[data-kt-app-layout=light-sidebar] .app-sidebar .menu .menu-item.show > .menu-link .menu-icon .svg-icon,\n[data-kt-app-layout=light-sidebar] .app-sidebar .menu .menu-item.show > .menu-link .menu-icon i {\n  color: var(--bs-gray-700);\n}\n[data-kt-app-layout=light-sidebar] .app-sidebar .menu .menu-item.show > .menu-link .menu-bullet .bullet {\n  background-color: var(--bs-gray-700);\n}\n[data-kt-app-layout=light-sidebar] .app-sidebar .menu .menu-item.show > .menu-link .menu-arrow:after {\n  mask-repeat: no-repeat;\n  mask-position: center;\n  -webkit-mask-repeat: no-repeat;\n  -webkit-mask-position: center;\n  background-color: var(--bs-gray-700);\n  -webkit-mask-image: url(\"data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 6 6' fill='var%28--bs-gray-700%29'%3e%3cpath d='M2.72011 2.76429L4.46358 1.02083C4.63618 0.848244 4.63617 0.568419 4.46358 0.395831C4.29099 0.223244 4.01118 0.223244 3.83861 0.395831L1.52904 2.70537C1.36629 2.86808 1.36629 3.13191 1.52904 3.29462L3.83861 5.60419C4.01117 5.77675 4.29099 5.77675 4.46358 5.60419C4.63617 5.43156 4.63617 5.15175 4.46358 4.97919L2.72011 3.23571C2.58994 3.10554 2.58994 2.89446 2.72011 2.76429Z'/%3e%3c/svg%3e\");\n  mask-image: url(\"data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 6 6' fill='var%28--bs-gray-700%29'%3e%3cpath d='M2.72011 2.76429L4.46358 1.02083C4.63618 0.848244 4.63617 0.568419 4.46358 0.395831C4.29099 0.223244 4.01118 0.223244 3.83861 0.395831L1.52904 2.70537C1.36629 2.86808 1.36629 3.13191 1.52904 3.29462L3.83861 5.60419C4.01117 5.77675 4.29099 5.77675 4.46358 5.60419C4.63617 5.43156 4.63617 5.15175 4.46358 4.97919L2.72011 3.23571C2.58994 3.10554 2.58994 2.89446 2.72011 2.76429Z'/%3e%3c/svg%3e\");\n  /*rtl:begin:remove*/\n  mask-repeat: no-repeat;\n  mask-position: center;\n  -webkit-mask-repeat: no-repeat;\n  -webkit-mask-position: center;\n  background-color: var(--bs-gray-700);\n  -webkit-mask-image: url(\"data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 6 6' fill='var%28--bs-gray-700%29'%3e%3cpath d='M3.27989 3.23571L1.53642 4.97917C1.36382 5.15176 1.36383 5.43158 1.53642 5.60417C1.70901 5.77676 1.98882 5.77676 2.16139 5.60417L4.47096 3.29463C4.63371 3.13192 4.63371 2.86809 4.47096 2.70538L2.16139 0.395812C1.98883 0.22325 1.70901 0.22325 1.53642 0.395812C1.36383 0.568437 1.36383 0.84825 1.53642 1.02081L3.27989 2.76429C3.41006 2.89446 3.41006 3.10554 3.27989 3.23571Z'/%3e%3c/svg%3e\");\n  mask-image: url(\"data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 6 6' fill='var%28--bs-gray-700%29'%3e%3cpath d='M3.27989 3.23571L1.53642 4.97917C1.36382 5.15176 1.36383 5.43158 1.53642 5.60417C1.70901 5.77676 1.98882 5.77676 2.16139 5.60417L4.47096 3.29463C4.63371 3.13192 4.63371 2.86809 4.47096 2.70538L2.16139 0.395812C1.98883 0.22325 1.70901 0.22325 1.53642 0.395812C1.36383 0.568437 1.36383 0.84825 1.53642 1.02081L3.27989 2.76429C3.41006 2.89446 3.41006 3.10554 3.27989 3.23571Z'/%3e%3c/svg%3e\");\n  /*rtl:end:remove*/\n}\n[data-kt-app-layout=light-sidebar] .app-sidebar .menu .menu-item.here > .menu-link {\n  transition: color 0.2s ease;\n  color: var(--bs-gray-900);\n}\n[data-kt-app-layout=light-sidebar] .app-sidebar .menu .menu-item.here > .menu-link .menu-title {\n  color: var(--bs-gray-900);\n}\n[data-kt-app-layout=light-sidebar] .app-sidebar .menu .menu-item.here > .menu-link .menu-icon,\n[data-kt-app-layout=light-sidebar] .app-sidebar .menu .menu-item.here > .menu-link .menu-icon .svg-icon,\n[data-kt-app-layout=light-sidebar] .app-sidebar .menu .menu-item.here > .menu-link .menu-icon i {\n  color: var(--bs-gray-700);\n}\n[data-kt-app-layout=light-sidebar] .app-sidebar .menu .menu-item.here > .menu-link .menu-bullet .bullet {\n  background-color: var(--bs-gray-700);\n}\n[data-kt-app-layout=light-sidebar] .app-sidebar .menu .menu-item.here > .menu-link .menu-arrow:after {\n  mask-repeat: no-repeat;\n  mask-position: center;\n  -webkit-mask-repeat: no-repeat;\n  -webkit-mask-position: center;\n  background-color: var(--bs-gray-700);\n  -webkit-mask-image: url(\"data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 6 6' fill='var%28--bs-gray-700%29'%3e%3cpath d='M2.72011 2.76429L4.46358 1.02083C4.63618 0.848244 4.63617 0.568419 4.46358 0.395831C4.29099 0.223244 4.01118 0.223244 3.83861 0.395831L1.52904 2.70537C1.36629 2.86808 1.36629 3.13191 1.52904 3.29462L3.83861 5.60419C4.01117 5.77675 4.29099 5.77675 4.46358 5.60419C4.63617 5.43156 4.63617 5.15175 4.46358 4.97919L2.72011 3.23571C2.58994 3.10554 2.58994 2.89446 2.72011 2.76429Z'/%3e%3c/svg%3e\");\n  mask-image: url(\"data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 6 6' fill='var%28--bs-gray-700%29'%3e%3cpath d='M2.72011 2.76429L4.46358 1.02083C4.63618 0.848244 4.63617 0.568419 4.46358 0.395831C4.29099 0.223244 4.01118 0.223244 3.83861 0.395831L1.52904 2.70537C1.36629 2.86808 1.36629 3.13191 1.52904 3.29462L3.83861 5.60419C4.01117 5.77675 4.29099 5.77675 4.46358 5.60419C4.63617 5.43156 4.63617 5.15175 4.46358 4.97919L2.72011 3.23571C2.58994 3.10554 2.58994 2.89446 2.72011 2.76429Z'/%3e%3c/svg%3e\");\n  /*rtl:begin:remove*/\n  mask-repeat: no-repeat;\n  mask-position: center;\n  -webkit-mask-repeat: no-repeat;\n  -webkit-mask-position: center;\n  background-color: var(--bs-gray-700);\n  -webkit-mask-image: url(\"data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 6 6' fill='var%28--bs-gray-700%29'%3e%3cpath d='M3.27989 3.23571L1.53642 4.97917C1.36382 5.15176 1.36383 5.43158 1.53642 5.60417C1.70901 5.77676 1.98882 5.77676 2.16139 5.60417L4.47096 3.29463C4.63371 3.13192 4.63371 2.86809 4.47096 2.70538L2.16139 0.395812C1.98883 0.22325 1.70901 0.22325 1.53642 0.395812C1.36383 0.568437 1.36383 0.84825 1.53642 1.02081L3.27989 2.76429C3.41006 2.89446 3.41006 3.10554 3.27989 3.23571Z'/%3e%3c/svg%3e\");\n  mask-image: url(\"data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 6 6' fill='var%28--bs-gray-700%29'%3e%3cpath d='M3.27989 3.23571L1.53642 4.97917C1.36382 5.15176 1.36383 5.43158 1.53642 5.60417C1.70901 5.77676 1.98882 5.77676 2.16139 5.60417L4.47096 3.29463C4.63371 3.13192 4.63371 2.86809 4.47096 2.70538L2.16139 0.395812C1.98883 0.22325 1.70901 0.22325 1.53642 0.395812C1.36383 0.568437 1.36383 0.84825 1.53642 1.02081L3.27989 2.76429C3.41006 2.89446 3.41006 3.10554 3.27989 3.23571Z'/%3e%3c/svg%3e\");\n  /*rtl:end:remove*/\n}\n[data-kt-app-layout=light-sidebar] .app-sidebar .menu .menu-item .menu-link.active {\n  transition: color 0.2s ease;\n  background-color: var(--bs-app-sidebar-light-menu-link-bg-color-active);\n  color: var(--bs-primary);\n}\n[data-kt-app-layout=light-sidebar] .app-sidebar .menu .menu-item .menu-link.active .menu-title {\n  color: var(--bs-primary);\n}\n[data-kt-app-layout=light-sidebar] .app-sidebar .menu .menu-item .menu-link.active .menu-icon,\n[data-kt-app-layout=light-sidebar] .app-sidebar .menu .menu-item .menu-link.active .menu-icon .svg-icon,\n[data-kt-app-layout=light-sidebar] .app-sidebar .menu .menu-item .menu-link.active .menu-icon i {\n  color: var(--bs-primary);\n}\n[data-kt-app-layout=light-sidebar] .app-sidebar .menu .menu-item .menu-link.active .menu-bullet .bullet {\n  background-color: var(--bs-primary);\n}\n[data-kt-app-layout=light-sidebar] .app-sidebar .menu .menu-item .menu-link.active .menu-arrow:after {\n  mask-repeat: no-repeat;\n  mask-position: center;\n  -webkit-mask-repeat: no-repeat;\n  -webkit-mask-position: center;\n  background-color: var(--bs-primary);\n  -webkit-mask-image: url(\"data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 6 6' fill='var%28--bs-primary%29'%3e%3cpath d='M2.72011 2.76429L4.46358 1.02083C4.63618 0.848244 4.63617 0.568419 4.46358 0.395831C4.29099 0.223244 4.01118 0.223244 3.83861 0.395831L1.52904 2.70537C1.36629 2.86808 1.36629 3.13191 1.52904 3.29462L3.83861 5.60419C4.01117 5.77675 4.29099 5.77675 4.46358 5.60419C4.63617 5.43156 4.63617 5.15175 4.46358 4.97919L2.72011 3.23571C2.58994 3.10554 2.58994 2.89446 2.72011 2.76429Z'/%3e%3c/svg%3e\");\n  mask-image: url(\"data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 6 6' fill='var%28--bs-primary%29'%3e%3cpath d='M2.72011 2.76429L4.46358 1.02083C4.63618 0.848244 4.63617 0.568419 4.46358 0.395831C4.29099 0.223244 4.01118 0.223244 3.83861 0.395831L1.52904 2.70537C1.36629 2.86808 1.36629 3.13191 1.52904 3.29462L3.83861 5.60419C4.01117 5.77675 4.29099 5.77675 4.46358 5.60419C4.63617 5.43156 4.63617 5.15175 4.46358 4.97919L2.72011 3.23571C2.58994 3.10554 2.58994 2.89446 2.72011 2.76429Z'/%3e%3c/svg%3e\");\n  /*rtl:begin:remove*/\n  mask-repeat: no-repeat;\n  mask-position: center;\n  -webkit-mask-repeat: no-repeat;\n  -webkit-mask-position: center;\n  background-color: var(--bs-primary);\n  -webkit-mask-image: url(\"data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 6 6' fill='var%28--bs-primary%29'%3e%3cpath d='M3.27989 3.23571L1.53642 4.97917C1.36382 5.15176 1.36383 5.43158 1.53642 5.60417C1.70901 5.77676 1.98882 5.77676 2.16139 5.60417L4.47096 3.29463C4.63371 3.13192 4.63371 2.86809 4.47096 2.70538L2.16139 0.395812C1.98883 0.22325 1.70901 0.22325 1.53642 0.395812C1.36383 0.568437 1.36383 0.84825 1.53642 1.02081L3.27989 2.76429C3.41006 2.89446 3.41006 3.10554 3.27989 3.23571Z'/%3e%3c/svg%3e\");\n  mask-image: url(\"data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 6 6' fill='var%28--bs-primary%29'%3e%3cpath d='M3.27989 3.23571L1.53642 4.97917C1.36382 5.15176 1.36383 5.43158 1.53642 5.60417C1.70901 5.77676 1.98882 5.77676 2.16139 5.60417L4.47096 3.29463C4.63371 3.13192 4.63371 2.86809 4.47096 2.70538L2.16139 0.395812C1.98883 0.22325 1.70901 0.22325 1.53642 0.395812C1.36383 0.568437 1.36383 0.84825 1.53642 1.02081L3.27989 2.76429C3.41006 2.89446 3.41006 3.10554 3.27989 3.23571Z'/%3e%3c/svg%3e\");\n  /*rtl:end:remove*/\n}\n\n[data-kt-app-layout=light-sidebar][data-kt-app-header-fixed=true] .app-header {\n  background-color: var(--bs-app-bg-color);\n  box-shadow: none;\n  border-bottom: 1px dashed var(--bs-app-sidebar-light-separator-color);\n}\n[data-kt-app-layout=light-sidebar][data-kt-app-header-fixed=true] .app-sidebar .app-sidebar-logo {\n  border-bottom: 1px dashed var(--bs-app-sidebar-light-separator-color);\n}\n\n.app-header-menu .menu .menu-item .menu-link {\n  color: var(--bs-gray-700);\n}\n.app-header-menu .menu .menu-item .menu-link .menu-title {\n  color: var(--bs-gray-700);\n}\n.app-header-menu .menu .menu-item .menu-link .menu-icon,\n.app-header-menu .menu .menu-item .menu-link .menu-icon .svg-icon,\n.app-header-menu .menu .menu-item .menu-link .menu-icon i {\n  color: var(--bs-gray-500);\n}\n.app-header-menu .menu .menu-item .menu-link .menu-bullet .bullet {\n  background-color: var(--bs-gray-500);\n}\n.app-header-menu .menu .menu-item .menu-link .menu-arrow:after {\n  mask-repeat: no-repeat;\n  mask-position: center;\n  -webkit-mask-repeat: no-repeat;\n  -webkit-mask-position: center;\n  background-color: var(--bs-gray-500);\n  -webkit-mask-image: url(\"data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 6 6' fill='var%28--bs-gray-500%29'%3e%3cpath d='M2.72011 2.76429L4.46358 1.02083C4.63618 0.848244 4.63617 0.568419 4.46358 0.395831C4.29099 0.223244 4.01118 0.223244 3.83861 0.395831L1.52904 2.70537C1.36629 2.86808 1.36629 3.13191 1.52904 3.29462L3.83861 5.60419C4.01117 5.77675 4.29099 5.77675 4.46358 5.60419C4.63617 5.43156 4.63617 5.15175 4.46358 4.97919L2.72011 3.23571C2.58994 3.10554 2.58994 2.89446 2.72011 2.76429Z'/%3e%3c/svg%3e\");\n  mask-image: url(\"data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 6 6' fill='var%28--bs-gray-500%29'%3e%3cpath d='M2.72011 2.76429L4.46358 1.02083C4.63618 0.848244 4.63617 0.568419 4.46358 0.395831C4.29099 0.223244 4.01118 0.223244 3.83861 0.395831L1.52904 2.70537C1.36629 2.86808 1.36629 3.13191 1.52904 3.29462L3.83861 5.60419C4.01117 5.77675 4.29099 5.77675 4.46358 5.60419C4.63617 5.43156 4.63617 5.15175 4.46358 4.97919L2.72011 3.23571C2.58994 3.10554 2.58994 2.89446 2.72011 2.76429Z'/%3e%3c/svg%3e\");\n  /*rtl:begin:remove*/\n  mask-repeat: no-repeat;\n  mask-position: center;\n  -webkit-mask-repeat: no-repeat;\n  -webkit-mask-position: center;\n  background-color: var(--bs-gray-500);\n  -webkit-mask-image: url(\"data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 6 6' fill='var%28--bs-gray-500%29'%3e%3cpath d='M3.27989 3.23571L1.53642 4.97917C1.36382 5.15176 1.36383 5.43158 1.53642 5.60417C1.70901 5.77676 1.98882 5.77676 2.16139 5.60417L4.47096 3.29463C4.63371 3.13192 4.63371 2.86809 4.47096 2.70538L2.16139 0.395812C1.98883 0.22325 1.70901 0.22325 1.53642 0.395812C1.36383 0.568437 1.36383 0.84825 1.53642 1.02081L3.27989 2.76429C3.41006 2.89446 3.41006 3.10554 3.27989 3.23571Z'/%3e%3c/svg%3e\");\n  mask-image: url(\"data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 6 6' fill='var%28--bs-gray-500%29'%3e%3cpath d='M3.27989 3.23571L1.53642 4.97917C1.36382 5.15176 1.36383 5.43158 1.53642 5.60417C1.70901 5.77676 1.98882 5.77676 2.16139 5.60417L4.47096 3.29463C4.63371 3.13192 4.63371 2.86809 4.47096 2.70538L2.16139 0.395812C1.98883 0.22325 1.70901 0.22325 1.53642 0.395812C1.36383 0.568437 1.36383 0.84825 1.53642 1.02081L3.27989 2.76429C3.41006 2.89446 3.41006 3.10554 3.27989 3.23571Z'/%3e%3c/svg%3e\");\n  /*rtl:end:remove*/\n}\n.app-header-menu .menu .menu-item.hover:not(.here) > .menu-link:not(.disabled):not(.active):not(.here), .app-header-menu .menu .menu-item:not(.here) .menu-link:hover:not(.disabled):not(.active):not(.here) {\n  transition: color 0.2s ease;\n  background-color: var(--bs-menu-link-bg-color-active);\n  color: var(--bs-primary);\n}\n.app-header-menu .menu .menu-item.hover:not(.here) > .menu-link:not(.disabled):not(.active):not(.here) .menu-title, .app-header-menu .menu .menu-item:not(.here) .menu-link:hover:not(.disabled):not(.active):not(.here) .menu-title {\n  color: var(--bs-primary);\n}\n.app-header-menu .menu .menu-item.hover:not(.here) > .menu-link:not(.disabled):not(.active):not(.here) .menu-icon,\n.app-header-menu .menu .menu-item.hover:not(.here) > .menu-link:not(.disabled):not(.active):not(.here) .menu-icon .svg-icon,\n.app-header-menu .menu .menu-item.hover:not(.here) > .menu-link:not(.disabled):not(.active):not(.here) .menu-icon i, .app-header-menu .menu .menu-item:not(.here) .menu-link:hover:not(.disabled):not(.active):not(.here) .menu-icon,\n.app-header-menu .menu .menu-item:not(.here) .menu-link:hover:not(.disabled):not(.active):not(.here) .menu-icon .svg-icon,\n.app-header-menu .menu .menu-item:not(.here) .menu-link:hover:not(.disabled):not(.active):not(.here) .menu-icon i {\n  color: var(--bs-primary);\n}\n.app-header-menu .menu .menu-item.hover:not(.here) > .menu-link:not(.disabled):not(.active):not(.here) .menu-bullet .bullet, .app-header-menu .menu .menu-item:not(.here) .menu-link:hover:not(.disabled):not(.active):not(.here) .menu-bullet .bullet {\n  background-color: var(--bs-primary);\n}\n.app-header-menu .menu .menu-item.hover:not(.here) > .menu-link:not(.disabled):not(.active):not(.here) .menu-arrow:after, .app-header-menu .menu .menu-item:not(.here) .menu-link:hover:not(.disabled):not(.active):not(.here) .menu-arrow:after {\n  mask-repeat: no-repeat;\n  mask-position: center;\n  -webkit-mask-repeat: no-repeat;\n  -webkit-mask-position: center;\n  background-color: var(--bs-primary);\n  -webkit-mask-image: url(\"data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 6 6' fill='var%28--bs-primary%29'%3e%3cpath d='M2.72011 2.76429L4.46358 1.02083C4.63618 0.848244 4.63617 0.568419 4.46358 0.395831C4.29099 0.223244 4.01118 0.223244 3.83861 0.395831L1.52904 2.70537C1.36629 2.86808 1.36629 3.13191 1.52904 3.29462L3.83861 5.60419C4.01117 5.77675 4.29099 5.77675 4.46358 5.60419C4.63617 5.43156 4.63617 5.15175 4.46358 4.97919L2.72011 3.23571C2.58994 3.10554 2.58994 2.89446 2.72011 2.76429Z'/%3e%3c/svg%3e\");\n  mask-image: url(\"data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 6 6' fill='var%28--bs-primary%29'%3e%3cpath d='M2.72011 2.76429L4.46358 1.02083C4.63618 0.848244 4.63617 0.568419 4.46358 0.395831C4.29099 0.223244 4.01118 0.223244 3.83861 0.395831L1.52904 2.70537C1.36629 2.86808 1.36629 3.13191 1.52904 3.29462L3.83861 5.60419C4.01117 5.77675 4.29099 5.77675 4.46358 5.60419C4.63617 5.43156 4.63617 5.15175 4.46358 4.97919L2.72011 3.23571C2.58994 3.10554 2.58994 2.89446 2.72011 2.76429Z'/%3e%3c/svg%3e\");\n  /*rtl:begin:remove*/\n  mask-repeat: no-repeat;\n  mask-position: center;\n  -webkit-mask-repeat: no-repeat;\n  -webkit-mask-position: center;\n  background-color: var(--bs-primary);\n  -webkit-mask-image: url(\"data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 6 6' fill='var%28--bs-primary%29'%3e%3cpath d='M3.27989 3.23571L1.53642 4.97917C1.36382 5.15176 1.36383 5.43158 1.53642 5.60417C1.70901 5.77676 1.98882 5.77676 2.16139 5.60417L4.47096 3.29463C4.63371 3.13192 4.63371 2.86809 4.47096 2.70538L2.16139 0.395812C1.98883 0.22325 1.70901 0.22325 1.53642 0.395812C1.36383 0.568437 1.36383 0.84825 1.53642 1.02081L3.27989 2.76429C3.41006 2.89446 3.41006 3.10554 3.27989 3.23571Z'/%3e%3c/svg%3e\");\n  mask-image: url(\"data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 6 6' fill='var%28--bs-primary%29'%3e%3cpath d='M3.27989 3.23571L1.53642 4.97917C1.36382 5.15176 1.36383 5.43158 1.53642 5.60417C1.70901 5.77676 1.98882 5.77676 2.16139 5.60417L4.47096 3.29463C4.63371 3.13192 4.63371 2.86809 4.47096 2.70538L2.16139 0.395812C1.98883 0.22325 1.70901 0.22325 1.53642 0.395812C1.36383 0.568437 1.36383 0.84825 1.53642 1.02081L3.27989 2.76429C3.41006 2.89446 3.41006 3.10554 3.27989 3.23571Z'/%3e%3c/svg%3e\");\n  /*rtl:end:remove*/\n}\n.app-header-menu .menu .menu-item.show > .menu-link {\n  transition: color 0.2s ease;\n  color: var(--bs-primary);\n}\n.app-header-menu .menu .menu-item.show > .menu-link .menu-title {\n  color: var(--bs-primary);\n}\n.app-header-menu .menu .menu-item.show > .menu-link .menu-icon,\n.app-header-menu .menu .menu-item.show > .menu-link .menu-icon .svg-icon,\n.app-header-menu .menu .menu-item.show > .menu-link .menu-icon i {\n  color: var(--bs-primary);\n}\n.app-header-menu .menu .menu-item.show > .menu-link .menu-bullet .bullet {\n  background-color: var(--bs-primary);\n}\n.app-header-menu .menu .menu-item.show > .menu-link .menu-arrow:after {\n  mask-repeat: no-repeat;\n  mask-position: center;\n  -webkit-mask-repeat: no-repeat;\n  -webkit-mask-position: center;\n  background-color: var(--bs-primary);\n  -webkit-mask-image: url(\"data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 6 6' fill='var%28--bs-primary%29'%3e%3cpath d='M2.72011 2.76429L4.46358 1.02083C4.63618 0.848244 4.63617 0.568419 4.46358 0.395831C4.29099 0.223244 4.01118 0.223244 3.83861 0.395831L1.52904 2.70537C1.36629 2.86808 1.36629 3.13191 1.52904 3.29462L3.83861 5.60419C4.01117 5.77675 4.29099 5.77675 4.46358 5.60419C4.63617 5.43156 4.63617 5.15175 4.46358 4.97919L2.72011 3.23571C2.58994 3.10554 2.58994 2.89446 2.72011 2.76429Z'/%3e%3c/svg%3e\");\n  mask-image: url(\"data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 6 6' fill='var%28--bs-primary%29'%3e%3cpath d='M2.72011 2.76429L4.46358 1.02083C4.63618 0.848244 4.63617 0.568419 4.46358 0.395831C4.29099 0.223244 4.01118 0.223244 3.83861 0.395831L1.52904 2.70537C1.36629 2.86808 1.36629 3.13191 1.52904 3.29462L3.83861 5.60419C4.01117 5.77675 4.29099 5.77675 4.46358 5.60419C4.63617 5.43156 4.63617 5.15175 4.46358 4.97919L2.72011 3.23571C2.58994 3.10554 2.58994 2.89446 2.72011 2.76429Z'/%3e%3c/svg%3e\");\n  /*rtl:begin:remove*/\n  mask-repeat: no-repeat;\n  mask-position: center;\n  -webkit-mask-repeat: no-repeat;\n  -webkit-mask-position: center;\n  background-color: var(--bs-primary);\n  -webkit-mask-image: url(\"data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 6 6' fill='var%28--bs-primary%29'%3e%3cpath d='M3.27989 3.23571L1.53642 4.97917C1.36382 5.15176 1.36383 5.43158 1.53642 5.60417C1.70901 5.77676 1.98882 5.77676 2.16139 5.60417L4.47096 3.29463C4.63371 3.13192 4.63371 2.86809 4.47096 2.70538L2.16139 0.395812C1.98883 0.22325 1.70901 0.22325 1.53642 0.395812C1.36383 0.568437 1.36383 0.84825 1.53642 1.02081L3.27989 2.76429C3.41006 2.89446 3.41006 3.10554 3.27989 3.23571Z'/%3e%3c/svg%3e\");\n  mask-image: url(\"data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 6 6' fill='var%28--bs-primary%29'%3e%3cpath d='M3.27989 3.23571L1.53642 4.97917C1.36382 5.15176 1.36383 5.43158 1.53642 5.60417C1.70901 5.77676 1.98882 5.77676 2.16139 5.60417L4.47096 3.29463C4.63371 3.13192 4.63371 2.86809 4.47096 2.70538L2.16139 0.395812C1.98883 0.22325 1.70901 0.22325 1.53642 0.395812C1.36383 0.568437 1.36383 0.84825 1.53642 1.02081L3.27989 2.76429C3.41006 2.89446 3.41006 3.10554 3.27989 3.23571Z'/%3e%3c/svg%3e\");\n  /*rtl:end:remove*/\n}\n.app-header-menu .menu .menu-item.here > .menu-link {\n  transition: color 0.2s ease;\n  background-color: var(--bs-menu-link-bg-color-active);\n  color: var(--bs-primary);\n}\n.app-header-menu .menu .menu-item.here > .menu-link .menu-title {\n  color: var(--bs-primary);\n}\n.app-header-menu .menu .menu-item.here > .menu-link .menu-icon,\n.app-header-menu .menu .menu-item.here > .menu-link .menu-icon .svg-icon,\n.app-header-menu .menu .menu-item.here > .menu-link .menu-icon i {\n  color: var(--bs-primary);\n}\n.app-header-menu .menu .menu-item.here > .menu-link .menu-bullet .bullet {\n  background-color: var(--bs-primary);\n}\n.app-header-menu .menu .menu-item.here > .menu-link .menu-arrow:after {\n  mask-repeat: no-repeat;\n  mask-position: center;\n  -webkit-mask-repeat: no-repeat;\n  -webkit-mask-position: center;\n  background-color: var(--bs-primary);\n  -webkit-mask-image: url(\"data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 6 6' fill='var%28--bs-primary%29'%3e%3cpath d='M2.72011 2.76429L4.46358 1.02083C4.63618 0.848244 4.63617 0.568419 4.46358 0.395831C4.29099 0.223244 4.01118 0.223244 3.83861 0.395831L1.52904 2.70537C1.36629 2.86808 1.36629 3.13191 1.52904 3.29462L3.83861 5.60419C4.01117 5.77675 4.29099 5.77675 4.46358 5.60419C4.63617 5.43156 4.63617 5.15175 4.46358 4.97919L2.72011 3.23571C2.58994 3.10554 2.58994 2.89446 2.72011 2.76429Z'/%3e%3c/svg%3e\");\n  mask-image: url(\"data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 6 6' fill='var%28--bs-primary%29'%3e%3cpath d='M2.72011 2.76429L4.46358 1.02083C4.63618 0.848244 4.63617 0.568419 4.46358 0.395831C4.29099 0.223244 4.01118 0.223244 3.83861 0.395831L1.52904 2.70537C1.36629 2.86808 1.36629 3.13191 1.52904 3.29462L3.83861 5.60419C4.01117 5.77675 4.29099 5.77675 4.46358 5.60419C4.63617 5.43156 4.63617 5.15175 4.46358 4.97919L2.72011 3.23571C2.58994 3.10554 2.58994 2.89446 2.72011 2.76429Z'/%3e%3c/svg%3e\");\n  /*rtl:begin:remove*/\n  mask-repeat: no-repeat;\n  mask-position: center;\n  -webkit-mask-repeat: no-repeat;\n  -webkit-mask-position: center;\n  background-color: var(--bs-primary);\n  -webkit-mask-image: url(\"data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 6 6' fill='var%28--bs-primary%29'%3e%3cpath d='M3.27989 3.23571L1.53642 4.97917C1.36382 5.15176 1.36383 5.43158 1.53642 5.60417C1.70901 5.77676 1.98882 5.77676 2.16139 5.60417L4.47096 3.29463C4.63371 3.13192 4.63371 2.86809 4.47096 2.70538L2.16139 0.395812C1.98883 0.22325 1.70901 0.22325 1.53642 0.395812C1.36383 0.568437 1.36383 0.84825 1.53642 1.02081L3.27989 2.76429C3.41006 2.89446 3.41006 3.10554 3.27989 3.23571Z'/%3e%3c/svg%3e\");\n  mask-image: url(\"data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 6 6' fill='var%28--bs-primary%29'%3e%3cpath d='M3.27989 3.23571L1.53642 4.97917C1.36382 5.15176 1.36383 5.43158 1.53642 5.60417C1.70901 5.77676 1.98882 5.77676 2.16139 5.60417L4.47096 3.29463C4.63371 3.13192 4.63371 2.86809 4.47096 2.70538L2.16139 0.395812C1.98883 0.22325 1.70901 0.22325 1.53642 0.395812C1.36383 0.568437 1.36383 0.84825 1.53642 1.02081L3.27989 2.76429C3.41006 2.89446 3.41006 3.10554 3.27989 3.23571Z'/%3e%3c/svg%3e\");\n  /*rtl:end:remove*/\n}\n.app-header-menu .menu .menu-item .menu-link.active {\n  transition: color 0.2s ease;\n  background-color: var(--bs-menu-link-bg-color-active);\n  color: var(--bs-primary);\n}\n.app-header-menu .menu .menu-item .menu-link.active .menu-title {\n  color: var(--bs-primary);\n}\n.app-header-menu .menu .menu-item .menu-link.active .menu-icon,\n.app-header-menu .menu .menu-item .menu-link.active .menu-icon .svg-icon,\n.app-header-menu .menu .menu-item .menu-link.active .menu-icon i {\n  color: var(--bs-primary);\n}\n.app-header-menu .menu .menu-item .menu-link.active .menu-bullet .bullet {\n  background-color: var(--bs-primary);\n}\n.app-header-menu .menu .menu-item .menu-link.active .menu-arrow:after {\n  mask-repeat: no-repeat;\n  mask-position: center;\n  -webkit-mask-repeat: no-repeat;\n  -webkit-mask-position: center;\n  background-color: var(--bs-primary);\n  -webkit-mask-image: url(\"data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 6 6' fill='var%28--bs-primary%29'%3e%3cpath d='M2.72011 2.76429L4.46358 1.02083C4.63618 0.848244 4.63617 0.568419 4.46358 0.395831C4.29099 0.223244 4.01118 0.223244 3.83861 0.395831L1.52904 2.70537C1.36629 2.86808 1.36629 3.13191 1.52904 3.29462L3.83861 5.60419C4.01117 5.77675 4.29099 5.77675 4.46358 5.60419C4.63617 5.43156 4.63617 5.15175 4.46358 4.97919L2.72011 3.23571C2.58994 3.10554 2.58994 2.89446 2.72011 2.76429Z'/%3e%3c/svg%3e\");\n  mask-image: url(\"data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 6 6' fill='var%28--bs-primary%29'%3e%3cpath d='M2.72011 2.76429L4.46358 1.02083C4.63618 0.848244 4.63617 0.568419 4.46358 0.395831C4.29099 0.223244 4.01118 0.223244 3.83861 0.395831L1.52904 2.70537C1.36629 2.86808 1.36629 3.13191 1.52904 3.29462L3.83861 5.60419C4.01117 5.77675 4.29099 5.77675 4.46358 5.60419C4.63617 5.43156 4.63617 5.15175 4.46358 4.97919L2.72011 3.23571C2.58994 3.10554 2.58994 2.89446 2.72011 2.76429Z'/%3e%3c/svg%3e\");\n  /*rtl:begin:remove*/\n  mask-repeat: no-repeat;\n  mask-position: center;\n  -webkit-mask-repeat: no-repeat;\n  -webkit-mask-position: center;\n  background-color: var(--bs-primary);\n  -webkit-mask-image: url(\"data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 6 6' fill='var%28--bs-primary%29'%3e%3cpath d='M3.27989 3.23571L1.53642 4.97917C1.36382 5.15176 1.36383 5.43158 1.53642 5.60417C1.70901 5.77676 1.98882 5.77676 2.16139 5.60417L4.47096 3.29463C4.63371 3.13192 4.63371 2.86809 4.47096 2.70538L2.16139 0.395812C1.98883 0.22325 1.70901 0.22325 1.53642 0.395812C1.36383 0.568437 1.36383 0.84825 1.53642 1.02081L3.27989 2.76429C3.41006 2.89446 3.41006 3.10554 3.27989 3.23571Z'/%3e%3c/svg%3e\");\n  mask-image: url(\"data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 6 6' fill='var%28--bs-primary%29'%3e%3cpath d='M3.27989 3.23571L1.53642 4.97917C1.36382 5.15176 1.36383 5.43158 1.53642 5.60417C1.70901 5.77676 1.98882 5.77676 2.16139 5.60417L4.47096 3.29463C4.63371 3.13192 4.63371 2.86809 4.47096 2.70538L2.16139 0.395812C1.98883 0.22325 1.70901 0.22325 1.53642 0.395812C1.36383 0.568437 1.36383 0.84825 1.53642 1.02081L3.27989 2.76429C3.41006 2.89446 3.41006 3.10554 3.27989 3.23571Z'/%3e%3c/svg%3e\");\n  /*rtl:end:remove*/\n}\n.app-header-menu .menu-extended {\n  --bs-menu-link-bg-color-active: rgba(var(--bs-gray-100-rgb), 0.7);\n  --bs-menu-link-bg-color-hover: rgba(var(--bs-gray-100-rgb), 0.7);\n}\n.app-header-menu .menu-extended .menu-custom-icon {\n  background-color: var(--bs-gray-100);\n}\n.app-header-menu .menu-extended .menu-link.active .menu-custom-icon, .app-header-menu .menu-extended .menu-link:hover .menu-custom-icon {\n  background-color: var(--bs-gray-200);\n}\n\n@media (min-width: 992px) {\n  .app-header-menu .menu > .menu-item {\n    margin-right: 0.5rem;\n  }\n  .app-header-menu .menu > .menu-item > .menu-link {\n    padding-top: 0.775rem;\n    padding-bottom: 0.775rem;\n    font-weight: 500;\n  }\n  .app-header-menu .menu > .menu-item.here > .menu-link {\n    transition: color 0.2s ease;\n    background-color: var(--bs-app-header-base-menu-link-bg-color-active);\n    color: var(--bs-primary);\n  }\n  .app-header-menu .menu > .menu-item.here > .menu-link .menu-title {\n    color: var(--bs-primary);\n  }\n  .app-header-menu .menu > .menu-item.here > .menu-link .menu-icon,\n.app-header-menu .menu > .menu-item.here > .menu-link .menu-icon .svg-icon,\n.app-header-menu .menu > .menu-item.here > .menu-link .menu-icon i {\n    color: var(--bs-primary);\n  }\n  .app-header-menu .menu > .menu-item.here > .menu-link .menu-bullet .bullet {\n    background-color: var(--bs-primary);\n  }\n  .app-header-menu .menu > .menu-item.here > .menu-link .menu-arrow:after {\n    mask-repeat: no-repeat;\n    mask-position: center;\n    -webkit-mask-repeat: no-repeat;\n    -webkit-mask-position: center;\n    background-color: var(--bs-primary);\n    -webkit-mask-image: url(\"data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 6 6' fill='var%28--bs-primary%29'%3e%3cpath d='M2.72011 2.76429L4.46358 1.02083C4.63618 0.848244 4.63617 0.568419 4.46358 0.395831C4.29099 0.223244 4.01118 0.223244 3.83861 0.395831L1.52904 2.70537C1.36629 2.86808 1.36629 3.13191 1.52904 3.29462L3.83861 5.60419C4.01117 5.77675 4.29099 5.77675 4.46358 5.60419C4.63617 5.43156 4.63617 5.15175 4.46358 4.97919L2.72011 3.23571C2.58994 3.10554 2.58994 2.89446 2.72011 2.76429Z'/%3e%3c/svg%3e\");\n    mask-image: url(\"data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 6 6' fill='var%28--bs-primary%29'%3e%3cpath d='M2.72011 2.76429L4.46358 1.02083C4.63618 0.848244 4.63617 0.568419 4.46358 0.395831C4.29099 0.223244 4.01118 0.223244 3.83861 0.395831L1.52904 2.70537C1.36629 2.86808 1.36629 3.13191 1.52904 3.29462L3.83861 5.60419C4.01117 5.77675 4.29099 5.77675 4.46358 5.60419C4.63617 5.43156 4.63617 5.15175 4.46358 4.97919L2.72011 3.23571C2.58994 3.10554 2.58994 2.89446 2.72011 2.76429Z'/%3e%3c/svg%3e\");\n    /*rtl:begin:remove*/\n    mask-repeat: no-repeat;\n    mask-position: center;\n    -webkit-mask-repeat: no-repeat;\n    -webkit-mask-position: center;\n    background-color: var(--bs-primary);\n    -webkit-mask-image: url(\"data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 6 6' fill='var%28--bs-primary%29'%3e%3cpath d='M3.27989 3.23571L1.53642 4.97917C1.36382 5.15176 1.36383 5.43158 1.53642 5.60417C1.70901 5.77676 1.98882 5.77676 2.16139 5.60417L4.47096 3.29463C4.63371 3.13192 4.63371 2.86809 4.47096 2.70538L2.16139 0.395812C1.98883 0.22325 1.70901 0.22325 1.53642 0.395812C1.36383 0.568437 1.36383 0.84825 1.53642 1.02081L3.27989 2.76429C3.41006 2.89446 3.41006 3.10554 3.27989 3.23571Z'/%3e%3c/svg%3e\");\n    mask-image: url(\"data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 6 6' fill='var%28--bs-primary%29'%3e%3cpath d='M3.27989 3.23571L1.53642 4.97917C1.36382 5.15176 1.36383 5.43158 1.53642 5.60417C1.70901 5.77676 1.98882 5.77676 2.16139 5.60417L4.47096 3.29463C4.63371 3.13192 4.63371 2.86809 4.47096 2.70538L2.16139 0.395812C1.98883 0.22325 1.70901 0.22325 1.53642 0.395812C1.36383 0.568437 1.36383 0.84825 1.53642 1.02081L3.27989 2.76429C3.41006 2.89446 3.41006 3.10554 3.27989 3.23571Z'/%3e%3c/svg%3e\");\n    /*rtl:end:remove*/\n  }\n}\n@media (max-width: 991.98px) {\n  .app-header .page-title {\n    display: none !important;\n  }\n}\n[data-kt-app-layout=dark-header] .app-header {\n  background-color: #1e1e2d;\n  border-bottom: 0 !important;\n}\n[data-kt-app-layout=dark-header] .app-header .btn-custom {\n  color: #B5B5C3;\n}\n[data-kt-app-layout=dark-header] .app-header .btn-custom i,\n[data-kt-app-layout=dark-header] .app-header .btn-custom .svg-icon {\n  color: #B5B5C3;\n}\n[data-kt-app-layout=dark-header] .app-header .btn-custom.dropdown-toggle:after {\n  color: #B5B5C3;\n}\n.btn-check:checked + [data-kt-app-layout=dark-header] .app-header .btn-custom, .btn-check:active + [data-kt-app-layout=dark-header] .app-header .btn-custom, [data-kt-app-layout=dark-header] .app-header .btn-custom:focus:not(.btn-active), [data-kt-app-layout=dark-header] .app-header .btn-custom:hover:not(.btn-active), [data-kt-app-layout=dark-header] .app-header .btn-custom:active:not(.btn-active), [data-kt-app-layout=dark-header] .app-header .btn-custom.active, [data-kt-app-layout=dark-header] .app-header .btn-custom.show, .show > [data-kt-app-layout=dark-header] .app-header .btn-custom {\n  color: #B5B5C3;\n  background-color: rgba(63, 66, 84, 0.35) !important;\n}\n.btn-check:checked + [data-kt-app-layout=dark-header] .app-header .btn-custom i,\n.btn-check:checked + [data-kt-app-layout=dark-header] .app-header .btn-custom .svg-icon, .btn-check:active + [data-kt-app-layout=dark-header] .app-header .btn-custom i,\n.btn-check:active + [data-kt-app-layout=dark-header] .app-header .btn-custom .svg-icon, [data-kt-app-layout=dark-header] .app-header .btn-custom:focus:not(.btn-active) i,\n[data-kt-app-layout=dark-header] .app-header .btn-custom:focus:not(.btn-active) .svg-icon, [data-kt-app-layout=dark-header] .app-header .btn-custom:hover:not(.btn-active) i,\n[data-kt-app-layout=dark-header] .app-header .btn-custom:hover:not(.btn-active) .svg-icon, [data-kt-app-layout=dark-header] .app-header .btn-custom:active:not(.btn-active) i,\n[data-kt-app-layout=dark-header] .app-header .btn-custom:active:not(.btn-active) .svg-icon, [data-kt-app-layout=dark-header] .app-header .btn-custom.active i,\n[data-kt-app-layout=dark-header] .app-header .btn-custom.active .svg-icon, [data-kt-app-layout=dark-header] .app-header .btn-custom.show i,\n[data-kt-app-layout=dark-header] .app-header .btn-custom.show .svg-icon, .show > [data-kt-app-layout=dark-header] .app-header .btn-custom i,\n.show > [data-kt-app-layout=dark-header] .app-header .btn-custom .svg-icon {\n  color: var(--bs-primary);\n}\n.btn-check:checked + [data-kt-app-layout=dark-header] .app-header .btn-custom.dropdown-toggle:after, .btn-check:active + [data-kt-app-layout=dark-header] .app-header .btn-custom.dropdown-toggle:after, [data-kt-app-layout=dark-header] .app-header .btn-custom:focus:not(.btn-active).dropdown-toggle:after, [data-kt-app-layout=dark-header] .app-header .btn-custom:hover:not(.btn-active).dropdown-toggle:after, [data-kt-app-layout=dark-header] .app-header .btn-custom:active:not(.btn-active).dropdown-toggle:after, [data-kt-app-layout=dark-header] .app-header .btn-custom.active.dropdown-toggle:after, [data-kt-app-layout=dark-header] .app-header .btn-custom.show.dropdown-toggle:after, .show > [data-kt-app-layout=dark-header] .app-header .btn-custom.dropdown-toggle:after {\n  color: var(--bs-primary);\n}\n@media (min-width: 992px) {\n  [data-kt-app-layout=dark-header] .app-header-menu .menu > .menu-item > .menu-link {\n    color: #9D9DA6;\n  }\n  [data-kt-app-layout=dark-header] .app-header-menu .menu > .menu-item > .menu-link .menu-title {\n    color: #9D9DA6;\n  }\n  [data-kt-app-layout=dark-header] .app-header-menu .menu > .menu-item > .menu-link .menu-icon,\n[data-kt-app-layout=dark-header] .app-header-menu .menu > .menu-item > .menu-link .menu-icon .svg-icon,\n[data-kt-app-layout=dark-header] .app-header-menu .menu > .menu-item > .menu-link .menu-icon i {\n    color: #C5C5D8;\n  }\n  [data-kt-app-layout=dark-header] .app-header-menu .menu > .menu-item > .menu-link .menu-bullet .bullet {\n    background-color: #787887;\n  }\n  [data-kt-app-layout=dark-header] .app-header-menu .menu > .menu-item > .menu-link .menu-arrow:after {\n    mask-repeat: no-repeat;\n    mask-position: center;\n    -webkit-mask-repeat: no-repeat;\n    -webkit-mask-position: center;\n    background-color: #787887;\n    -webkit-mask-image: url(\"data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 6 6' fill='%23787887'%3e%3cpath d='M2.72011 2.76429L4.46358 1.02083C4.63618 0.848244 4.63617 0.568419 4.46358 0.395831C4.29099 0.223244 4.01118 0.223244 3.83861 0.395831L1.52904 2.70537C1.36629 2.86808 1.36629 3.13191 1.52904 3.29462L3.83861 5.60419C4.01117 5.77675 4.29099 5.77675 4.46358 5.60419C4.63617 5.43156 4.63617 5.15175 4.46358 4.97919L2.72011 3.23571C2.58994 3.10554 2.58994 2.89446 2.72011 2.76429Z'/%3e%3c/svg%3e\");\n    mask-image: url(\"data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 6 6' fill='%23787887'%3e%3cpath d='M2.72011 2.76429L4.46358 1.02083C4.63618 0.848244 4.63617 0.568419 4.46358 0.395831C4.29099 0.223244 4.01118 0.223244 3.83861 0.395831L1.52904 2.70537C1.36629 2.86808 1.36629 3.13191 1.52904 3.29462L3.83861 5.60419C4.01117 5.77675 4.29099 5.77675 4.46358 5.60419C4.63617 5.43156 4.63617 5.15175 4.46358 4.97919L2.72011 3.23571C2.58994 3.10554 2.58994 2.89446 2.72011 2.76429Z'/%3e%3c/svg%3e\");\n    /*rtl:begin:remove*/\n    mask-repeat: no-repeat;\n    mask-position: center;\n    -webkit-mask-repeat: no-repeat;\n    -webkit-mask-position: center;\n    background-color: #787887;\n    -webkit-mask-image: url(\"data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 6 6' fill='%23787887'%3e%3cpath d='M3.27989 3.23571L1.53642 4.97917C1.36382 5.15176 1.36383 5.43158 1.53642 5.60417C1.70901 5.77676 1.98882 5.77676 2.16139 5.60417L4.47096 3.29463C4.63371 3.13192 4.63371 2.86809 4.47096 2.70538L2.16139 0.395812C1.98883 0.22325 1.70901 0.22325 1.53642 0.395812C1.36383 0.568437 1.36383 0.84825 1.53642 1.02081L3.27989 2.76429C3.41006 2.89446 3.41006 3.10554 3.27989 3.23571Z'/%3e%3c/svg%3e\");\n    mask-image: url(\"data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 6 6' fill='%23787887'%3e%3cpath d='M3.27989 3.23571L1.53642 4.97917C1.36382 5.15176 1.36383 5.43158 1.53642 5.60417C1.70901 5.77676 1.98882 5.77676 2.16139 5.60417L4.47096 3.29463C4.63371 3.13192 4.63371 2.86809 4.47096 2.70538L2.16139 0.395812C1.98883 0.22325 1.70901 0.22325 1.53642 0.395812C1.36383 0.568437 1.36383 0.84825 1.53642 1.02081L3.27989 2.76429C3.41006 2.89446 3.41006 3.10554 3.27989 3.23571Z'/%3e%3c/svg%3e\");\n    /*rtl:end:remove*/\n  }\n  [data-kt-app-layout=dark-header] .app-header-menu .menu > .menu-item.hover:not(.here) > .menu-link:not(.disabled):not(.active):not(.here), [data-kt-app-layout=dark-header] .app-header-menu .menu > .menu-item:not(.here) > .menu-link:hover:not(.disabled):not(.active):not(.here) {\n    transition: color 0.2s ease;\n    background-color: #2A2A3C;\n    color: var(--bs-primary-inverse);\n  }\n  [data-kt-app-layout=dark-header] .app-header-menu .menu > .menu-item.hover:not(.here) > .menu-link:not(.disabled):not(.active):not(.here) .menu-title, [data-kt-app-layout=dark-header] .app-header-menu .menu > .menu-item:not(.here) > .menu-link:hover:not(.disabled):not(.active):not(.here) .menu-title {\n    color: var(--bs-primary-inverse);\n  }\n  [data-kt-app-layout=dark-header] .app-header-menu .menu > .menu-item.hover:not(.here) > .menu-link:not(.disabled):not(.active):not(.here) .menu-icon,\n[data-kt-app-layout=dark-header] .app-header-menu .menu > .menu-item.hover:not(.here) > .menu-link:not(.disabled):not(.active):not(.here) .menu-icon .svg-icon,\n[data-kt-app-layout=dark-header] .app-header-menu .menu > .menu-item.hover:not(.here) > .menu-link:not(.disabled):not(.active):not(.here) .menu-icon i, [data-kt-app-layout=dark-header] .app-header-menu .menu > .menu-item:not(.here) > .menu-link:hover:not(.disabled):not(.active):not(.here) .menu-icon,\n[data-kt-app-layout=dark-header] .app-header-menu .menu > .menu-item:not(.here) > .menu-link:hover:not(.disabled):not(.active):not(.here) .menu-icon .svg-icon,\n[data-kt-app-layout=dark-header] .app-header-menu .menu > .menu-item:not(.here) > .menu-link:hover:not(.disabled):not(.active):not(.here) .menu-icon i {\n    color: var(--bs-primary-inverse);\n  }\n  [data-kt-app-layout=dark-header] .app-header-menu .menu > .menu-item.hover:not(.here) > .menu-link:not(.disabled):not(.active):not(.here) .menu-bullet .bullet, [data-kt-app-layout=dark-header] .app-header-menu .menu > .menu-item:not(.here) > .menu-link:hover:not(.disabled):not(.active):not(.here) .menu-bullet .bullet {\n    background-color: var(--bs-primary-inverse);\n  }\n  [data-kt-app-layout=dark-header] .app-header-menu .menu > .menu-item.hover:not(.here) > .menu-link:not(.disabled):not(.active):not(.here) .menu-arrow:after, [data-kt-app-layout=dark-header] .app-header-menu .menu > .menu-item:not(.here) > .menu-link:hover:not(.disabled):not(.active):not(.here) .menu-arrow:after {\n    mask-repeat: no-repeat;\n    mask-position: center;\n    -webkit-mask-repeat: no-repeat;\n    -webkit-mask-position: center;\n    background-color: var(--bs-primary-inverse);\n    -webkit-mask-image: url(\"data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 6 6' fill='var%28--bs-primary-inverse%29'%3e%3cpath d='M2.72011 2.76429L4.46358 1.02083C4.63618 0.848244 4.63617 0.568419 4.46358 0.395831C4.29099 0.223244 4.01118 0.223244 3.83861 0.395831L1.52904 2.70537C1.36629 2.86808 1.36629 3.13191 1.52904 3.29462L3.83861 5.60419C4.01117 5.77675 4.29099 5.77675 4.46358 5.60419C4.63617 5.43156 4.63617 5.15175 4.46358 4.97919L2.72011 3.23571C2.58994 3.10554 2.58994 2.89446 2.72011 2.76429Z'/%3e%3c/svg%3e\");\n    mask-image: url(\"data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 6 6' fill='var%28--bs-primary-inverse%29'%3e%3cpath d='M2.72011 2.76429L4.46358 1.02083C4.63618 0.848244 4.63617 0.568419 4.46358 0.395831C4.29099 0.223244 4.01118 0.223244 3.83861 0.395831L1.52904 2.70537C1.36629 2.86808 1.36629 3.13191 1.52904 3.29462L3.83861 5.60419C4.01117 5.77675 4.29099 5.77675 4.46358 5.60419C4.63617 5.43156 4.63617 5.15175 4.46358 4.97919L2.72011 3.23571C2.58994 3.10554 2.58994 2.89446 2.72011 2.76429Z'/%3e%3c/svg%3e\");\n    /*rtl:begin:remove*/\n    mask-repeat: no-repeat;\n    mask-position: center;\n    -webkit-mask-repeat: no-repeat;\n    -webkit-mask-position: center;\n    background-color: var(--bs-primary-inverse);\n    -webkit-mask-image: url(\"data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 6 6' fill='var%28--bs-primary-inverse%29'%3e%3cpath d='M3.27989 3.23571L1.53642 4.97917C1.36382 5.15176 1.36383 5.43158 1.53642 5.60417C1.70901 5.77676 1.98882 5.77676 2.16139 5.60417L4.47096 3.29463C4.63371 3.13192 4.63371 2.86809 4.47096 2.70538L2.16139 0.395812C1.98883 0.22325 1.70901 0.22325 1.53642 0.395812C1.36383 0.568437 1.36383 0.84825 1.53642 1.02081L3.27989 2.76429C3.41006 2.89446 3.41006 3.10554 3.27989 3.23571Z'/%3e%3c/svg%3e\");\n    mask-image: url(\"data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 6 6' fill='var%28--bs-primary-inverse%29'%3e%3cpath d='M3.27989 3.23571L1.53642 4.97917C1.36382 5.15176 1.36383 5.43158 1.53642 5.60417C1.70901 5.77676 1.98882 5.77676 2.16139 5.60417L4.47096 3.29463C4.63371 3.13192 4.63371 2.86809 4.47096 2.70538L2.16139 0.395812C1.98883 0.22325 1.70901 0.22325 1.53642 0.395812C1.36383 0.568437 1.36383 0.84825 1.53642 1.02081L3.27989 2.76429C3.41006 2.89446 3.41006 3.10554 3.27989 3.23571Z'/%3e%3c/svg%3e\");\n    /*rtl:end:remove*/\n  }\n  [data-kt-app-layout=dark-header] .app-header-menu .menu > .menu-item.show > .menu-link {\n    transition: color 0.2s ease;\n    color: var(--bs-primary-inverse);\n  }\n  [data-kt-app-layout=dark-header] .app-header-menu .menu > .menu-item.show > .menu-link .menu-title {\n    color: var(--bs-primary-inverse);\n  }\n  [data-kt-app-layout=dark-header] .app-header-menu .menu > .menu-item.show > .menu-link .menu-icon,\n[data-kt-app-layout=dark-header] .app-header-menu .menu > .menu-item.show > .menu-link .menu-icon .svg-icon,\n[data-kt-app-layout=dark-header] .app-header-menu .menu > .menu-item.show > .menu-link .menu-icon i {\n    color: var(--bs-primary-inverse);\n  }\n  [data-kt-app-layout=dark-header] .app-header-menu .menu > .menu-item.show > .menu-link .menu-bullet .bullet {\n    background-color: var(--bs-primary-inverse);\n  }\n  [data-kt-app-layout=dark-header] .app-header-menu .menu > .menu-item.show > .menu-link .menu-arrow:after {\n    mask-repeat: no-repeat;\n    mask-position: center;\n    -webkit-mask-repeat: no-repeat;\n    -webkit-mask-position: center;\n    background-color: var(--bs-primary-inverse);\n    -webkit-mask-image: url(\"data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 6 6' fill='var%28--bs-primary-inverse%29'%3e%3cpath d='M2.72011 2.76429L4.46358 1.02083C4.63618 0.848244 4.63617 0.568419 4.46358 0.395831C4.29099 0.223244 4.01118 0.223244 3.83861 0.395831L1.52904 2.70537C1.36629 2.86808 1.36629 3.13191 1.52904 3.29462L3.83861 5.60419C4.01117 5.77675 4.29099 5.77675 4.46358 5.60419C4.63617 5.43156 4.63617 5.15175 4.46358 4.97919L2.72011 3.23571C2.58994 3.10554 2.58994 2.89446 2.72011 2.76429Z'/%3e%3c/svg%3e\");\n    mask-image: url(\"data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 6 6' fill='var%28--bs-primary-inverse%29'%3e%3cpath d='M2.72011 2.76429L4.46358 1.02083C4.63618 0.848244 4.63617 0.568419 4.46358 0.395831C4.29099 0.223244 4.01118 0.223244 3.83861 0.395831L1.52904 2.70537C1.36629 2.86808 1.36629 3.13191 1.52904 3.29462L3.83861 5.60419C4.01117 5.77675 4.29099 5.77675 4.46358 5.60419C4.63617 5.43156 4.63617 5.15175 4.46358 4.97919L2.72011 3.23571C2.58994 3.10554 2.58994 2.89446 2.72011 2.76429Z'/%3e%3c/svg%3e\");\n    /*rtl:begin:remove*/\n    mask-repeat: no-repeat;\n    mask-position: center;\n    -webkit-mask-repeat: no-repeat;\n    -webkit-mask-position: center;\n    background-color: var(--bs-primary-inverse);\n    -webkit-mask-image: url(\"data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 6 6' fill='var%28--bs-primary-inverse%29'%3e%3cpath d='M3.27989 3.23571L1.53642 4.97917C1.36382 5.15176 1.36383 5.43158 1.53642 5.60417C1.70901 5.77676 1.98882 5.77676 2.16139 5.60417L4.47096 3.29463C4.63371 3.13192 4.63371 2.86809 4.47096 2.70538L2.16139 0.395812C1.98883 0.22325 1.70901 0.22325 1.53642 0.395812C1.36383 0.568437 1.36383 0.84825 1.53642 1.02081L3.27989 2.76429C3.41006 2.89446 3.41006 3.10554 3.27989 3.23571Z'/%3e%3c/svg%3e\");\n    mask-image: url(\"data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 6 6' fill='var%28--bs-primary-inverse%29'%3e%3cpath d='M3.27989 3.23571L1.53642 4.97917C1.36382 5.15176 1.36383 5.43158 1.53642 5.60417C1.70901 5.77676 1.98882 5.77676 2.16139 5.60417L4.47096 3.29463C4.63371 3.13192 4.63371 2.86809 4.47096 2.70538L2.16139 0.395812C1.98883 0.22325 1.70901 0.22325 1.53642 0.395812C1.36383 0.568437 1.36383 0.84825 1.53642 1.02081L3.27989 2.76429C3.41006 2.89446 3.41006 3.10554 3.27989 3.23571Z'/%3e%3c/svg%3e\");\n    /*rtl:end:remove*/\n  }\n  [data-kt-app-layout=dark-header] .app-header-menu .menu > .menu-item.here > .menu-link {\n    transition: color 0.2s ease;\n    background-color: #2A2A3C;\n    color: var(--bs-primary-inverse);\n  }\n  [data-kt-app-layout=dark-header] .app-header-menu .menu > .menu-item.here > .menu-link .menu-title {\n    color: var(--bs-primary-inverse);\n  }\n  [data-kt-app-layout=dark-header] .app-header-menu .menu > .menu-item.here > .menu-link .menu-icon,\n[data-kt-app-layout=dark-header] .app-header-menu .menu > .menu-item.here > .menu-link .menu-icon .svg-icon,\n[data-kt-app-layout=dark-header] .app-header-menu .menu > .menu-item.here > .menu-link .menu-icon i {\n    color: var(--bs-primary-inverse);\n  }\n  [data-kt-app-layout=dark-header] .app-header-menu .menu > .menu-item.here > .menu-link .menu-bullet .bullet {\n    background-color: var(--bs-primary-inverse);\n  }\n  [data-kt-app-layout=dark-header] .app-header-menu .menu > .menu-item.here > .menu-link .menu-arrow:after {\n    mask-repeat: no-repeat;\n    mask-position: center;\n    -webkit-mask-repeat: no-repeat;\n    -webkit-mask-position: center;\n    background-color: var(--bs-primary-inverse);\n    -webkit-mask-image: url(\"data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 6 6' fill='var%28--bs-primary-inverse%29'%3e%3cpath d='M2.72011 2.76429L4.46358 1.02083C4.63618 0.848244 4.63617 0.568419 4.46358 0.395831C4.29099 0.223244 4.01118 0.223244 3.83861 0.395831L1.52904 2.70537C1.36629 2.86808 1.36629 3.13191 1.52904 3.29462L3.83861 5.60419C4.01117 5.77675 4.29099 5.77675 4.46358 5.60419C4.63617 5.43156 4.63617 5.15175 4.46358 4.97919L2.72011 3.23571C2.58994 3.10554 2.58994 2.89446 2.72011 2.76429Z'/%3e%3c/svg%3e\");\n    mask-image: url(\"data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 6 6' fill='var%28--bs-primary-inverse%29'%3e%3cpath d='M2.72011 2.76429L4.46358 1.02083C4.63618 0.848244 4.63617 0.568419 4.46358 0.395831C4.29099 0.223244 4.01118 0.223244 3.83861 0.395831L1.52904 2.70537C1.36629 2.86808 1.36629 3.13191 1.52904 3.29462L3.83861 5.60419C4.01117 5.77675 4.29099 5.77675 4.46358 5.60419C4.63617 5.43156 4.63617 5.15175 4.46358 4.97919L2.72011 3.23571C2.58994 3.10554 2.58994 2.89446 2.72011 2.76429Z'/%3e%3c/svg%3e\");\n    /*rtl:begin:remove*/\n    mask-repeat: no-repeat;\n    mask-position: center;\n    -webkit-mask-repeat: no-repeat;\n    -webkit-mask-position: center;\n    background-color: var(--bs-primary-inverse);\n    -webkit-mask-image: url(\"data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 6 6' fill='var%28--bs-primary-inverse%29'%3e%3cpath d='M3.27989 3.23571L1.53642 4.97917C1.36382 5.15176 1.36383 5.43158 1.53642 5.60417C1.70901 5.77676 1.98882 5.77676 2.16139 5.60417L4.47096 3.29463C4.63371 3.13192 4.63371 2.86809 4.47096 2.70538L2.16139 0.395812C1.98883 0.22325 1.70901 0.22325 1.53642 0.395812C1.36383 0.568437 1.36383 0.84825 1.53642 1.02081L3.27989 2.76429C3.41006 2.89446 3.41006 3.10554 3.27989 3.23571Z'/%3e%3c/svg%3e\");\n    mask-image: url(\"data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 6 6' fill='var%28--bs-primary-inverse%29'%3e%3cpath d='M3.27989 3.23571L1.53642 4.97917C1.36382 5.15176 1.36383 5.43158 1.53642 5.60417C1.70901 5.77676 1.98882 5.77676 2.16139 5.60417L4.47096 3.29463C4.63371 3.13192 4.63371 2.86809 4.47096 2.70538L2.16139 0.395812C1.98883 0.22325 1.70901 0.22325 1.53642 0.395812C1.36383 0.568437 1.36383 0.84825 1.53642 1.02081L3.27989 2.76429C3.41006 2.89446 3.41006 3.10554 3.27989 3.23571Z'/%3e%3c/svg%3e\");\n    /*rtl:end:remove*/\n  }\n  [data-kt-app-layout=dark-header] .app-header-menu .menu > .menu-item > .menu-link.active {\n    transition: color 0.2s ease;\n    background-color: #2A2A3C;\n    color: var(--bs-primary-inverse);\n  }\n  [data-kt-app-layout=dark-header] .app-header-menu .menu > .menu-item > .menu-link.active .menu-title {\n    color: var(--bs-primary-inverse);\n  }\n  [data-kt-app-layout=dark-header] .app-header-menu .menu > .menu-item > .menu-link.active .menu-icon,\n[data-kt-app-layout=dark-header] .app-header-menu .menu > .menu-item > .menu-link.active .menu-icon .svg-icon,\n[data-kt-app-layout=dark-header] .app-header-menu .menu > .menu-item > .menu-link.active .menu-icon i {\n    color: var(--bs-primary-inverse);\n  }\n  [data-kt-app-layout=dark-header] .app-header-menu .menu > .menu-item > .menu-link.active .menu-bullet .bullet {\n    background-color: var(--bs-primary-inverse);\n  }\n  [data-kt-app-layout=dark-header] .app-header-menu .menu > .menu-item > .menu-link.active .menu-arrow:after {\n    mask-repeat: no-repeat;\n    mask-position: center;\n    -webkit-mask-repeat: no-repeat;\n    -webkit-mask-position: center;\n    background-color: var(--bs-primary-inverse);\n    -webkit-mask-image: url(\"data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 6 6' fill='var%28--bs-primary-inverse%29'%3e%3cpath d='M2.72011 2.76429L4.46358 1.02083C4.63618 0.848244 4.63617 0.568419 4.46358 0.395831C4.29099 0.223244 4.01118 0.223244 3.83861 0.395831L1.52904 2.70537C1.36629 2.86808 1.36629 3.13191 1.52904 3.29462L3.83861 5.60419C4.01117 5.77675 4.29099 5.77675 4.46358 5.60419C4.63617 5.43156 4.63617 5.15175 4.46358 4.97919L2.72011 3.23571C2.58994 3.10554 2.58994 2.89446 2.72011 2.76429Z'/%3e%3c/svg%3e\");\n    mask-image: url(\"data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 6 6' fill='var%28--bs-primary-inverse%29'%3e%3cpath d='M2.72011 2.76429L4.46358 1.02083C4.63618 0.848244 4.63617 0.568419 4.46358 0.395831C4.29099 0.223244 4.01118 0.223244 3.83861 0.395831L1.52904 2.70537C1.36629 2.86808 1.36629 3.13191 1.52904 3.29462L3.83861 5.60419C4.01117 5.77675 4.29099 5.77675 4.46358 5.60419C4.63617 5.43156 4.63617 5.15175 4.46358 4.97919L2.72011 3.23571C2.58994 3.10554 2.58994 2.89446 2.72011 2.76429Z'/%3e%3c/svg%3e\");\n    /*rtl:begin:remove*/\n    mask-repeat: no-repeat;\n    mask-position: center;\n    -webkit-mask-repeat: no-repeat;\n    -webkit-mask-position: center;\n    background-color: var(--bs-primary-inverse);\n    -webkit-mask-image: url(\"data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 6 6' fill='var%28--bs-primary-inverse%29'%3e%3cpath d='M3.27989 3.23571L1.53642 4.97917C1.36382 5.15176 1.36383 5.43158 1.53642 5.60417C1.70901 5.77676 1.98882 5.77676 2.16139 5.60417L4.47096 3.29463C4.63371 3.13192 4.63371 2.86809 4.47096 2.70538L2.16139 0.395812C1.98883 0.22325 1.70901 0.22325 1.53642 0.395812C1.36383 0.568437 1.36383 0.84825 1.53642 1.02081L3.27989 2.76429C3.41006 2.89446 3.41006 3.10554 3.27989 3.23571Z'/%3e%3c/svg%3e\");\n    mask-image: url(\"data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 6 6' fill='var%28--bs-primary-inverse%29'%3e%3cpath d='M3.27989 3.23571L1.53642 4.97917C1.36382 5.15176 1.36383 5.43158 1.53642 5.60417C1.70901 5.77676 1.98882 5.77676 2.16139 5.60417L4.47096 3.29463C4.63371 3.13192 4.63371 2.86809 4.47096 2.70538L2.16139 0.395812C1.98883 0.22325 1.70901 0.22325 1.53642 0.395812C1.36383 0.568437 1.36383 0.84825 1.53642 1.02081L3.27989 2.76429C3.41006 2.89446 3.41006 3.10554 3.27989 3.23571Z'/%3e%3c/svg%3e\");\n    /*rtl:end:remove*/\n  }\n}\n\n@media (min-width: 992px) {\n  [data-kt-app-layout=light-sidebar] .app-header-menu .menu > .menu-item.here > .menu-link {\n    transition: color 0.2s ease;\n    background-color: var(--bs-app-sidebar-light-header-menu-link-bg-color-active);\n    color: var(--bs-primary);\n  }\n  [data-kt-app-layout=light-sidebar] .app-header-menu .menu > .menu-item.here > .menu-link .menu-title {\n    color: var(--bs-primary);\n  }\n  [data-kt-app-layout=light-sidebar] .app-header-menu .menu > .menu-item.here > .menu-link .menu-icon,\n[data-kt-app-layout=light-sidebar] .app-header-menu .menu > .menu-item.here > .menu-link .menu-icon .svg-icon,\n[data-kt-app-layout=light-sidebar] .app-header-menu .menu > .menu-item.here > .menu-link .menu-icon i {\n    color: var(--bs-primary);\n  }\n  [data-kt-app-layout=light-sidebar] .app-header-menu .menu > .menu-item.here > .menu-link .menu-bullet .bullet {\n    background-color: var(--bs-primary);\n  }\n  [data-kt-app-layout=light-sidebar] .app-header-menu .menu > .menu-item.here > .menu-link .menu-arrow:after {\n    mask-repeat: no-repeat;\n    mask-position: center;\n    -webkit-mask-repeat: no-repeat;\n    -webkit-mask-position: center;\n    background-color: var(--bs-primary);\n    -webkit-mask-image: url(\"data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 6 6' fill='var%28--bs-primary%29'%3e%3cpath d='M2.72011 2.76429L4.46358 1.02083C4.63618 0.848244 4.63617 0.568419 4.46358 0.395831C4.29099 0.223244 4.01118 0.223244 3.83861 0.395831L1.52904 2.70537C1.36629 2.86808 1.36629 3.13191 1.52904 3.29462L3.83861 5.60419C4.01117 5.77675 4.29099 5.77675 4.46358 5.60419C4.63617 5.43156 4.63617 5.15175 4.46358 4.97919L2.72011 3.23571C2.58994 3.10554 2.58994 2.89446 2.72011 2.76429Z'/%3e%3c/svg%3e\");\n    mask-image: url(\"data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 6 6' fill='var%28--bs-primary%29'%3e%3cpath d='M2.72011 2.76429L4.46358 1.02083C4.63618 0.848244 4.63617 0.568419 4.46358 0.395831C4.29099 0.223244 4.01118 0.223244 3.83861 0.395831L1.52904 2.70537C1.36629 2.86808 1.36629 3.13191 1.52904 3.29462L3.83861 5.60419C4.01117 5.77675 4.29099 5.77675 4.46358 5.60419C4.63617 5.43156 4.63617 5.15175 4.46358 4.97919L2.72011 3.23571C2.58994 3.10554 2.58994 2.89446 2.72011 2.76429Z'/%3e%3c/svg%3e\");\n    /*rtl:begin:remove*/\n    mask-repeat: no-repeat;\n    mask-position: center;\n    -webkit-mask-repeat: no-repeat;\n    -webkit-mask-position: center;\n    background-color: var(--bs-primary);\n    -webkit-mask-image: url(\"data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 6 6' fill='var%28--bs-primary%29'%3e%3cpath d='M3.27989 3.23571L1.53642 4.97917C1.36382 5.15176 1.36383 5.43158 1.53642 5.60417C1.70901 5.77676 1.98882 5.77676 2.16139 5.60417L4.47096 3.29463C4.63371 3.13192 4.63371 2.86809 4.47096 2.70538L2.16139 0.395812C1.98883 0.22325 1.70901 0.22325 1.53642 0.395812C1.36383 0.568437 1.36383 0.84825 1.53642 1.02081L3.27989 2.76429C3.41006 2.89446 3.41006 3.10554 3.27989 3.23571Z'/%3e%3c/svg%3e\");\n    mask-image: url(\"data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 6 6' fill='var%28--bs-primary%29'%3e%3cpath d='M3.27989 3.23571L1.53642 4.97917C1.36382 5.15176 1.36383 5.43158 1.53642 5.60417C1.70901 5.77676 1.98882 5.77676 2.16139 5.60417L4.47096 3.29463C4.63371 3.13192 4.63371 2.86809 4.47096 2.70538L2.16139 0.395812C1.98883 0.22325 1.70901 0.22325 1.53642 0.395812C1.36383 0.568437 1.36383 0.84825 1.53642 1.02081L3.27989 2.76429C3.41006 2.89446 3.41006 3.10554 3.27989 3.23571Z'/%3e%3c/svg%3e\");\n    /*rtl:end:remove*/\n  }\n  [data-kt-app-layout=light-sidebar] .app-header-menu .menu > .menu-item > .menu-link.active {\n    transition: color 0.2s ease;\n    background-color: var(--bs-app-sidebar-light-header-menu-link-bg-color-active);\n    color: var(--bs-primary);\n  }\n  [data-kt-app-layout=light-sidebar] .app-header-menu .menu > .menu-item > .menu-link.active .menu-title {\n    color: var(--bs-primary);\n  }\n  [data-kt-app-layout=light-sidebar] .app-header-menu .menu > .menu-item > .menu-link.active .menu-icon,\n[data-kt-app-layout=light-sidebar] .app-header-menu .menu > .menu-item > .menu-link.active .menu-icon .svg-icon,\n[data-kt-app-layout=light-sidebar] .app-header-menu .menu > .menu-item > .menu-link.active .menu-icon i {\n    color: var(--bs-primary);\n  }\n  [data-kt-app-layout=light-sidebar] .app-header-menu .menu > .menu-item > .menu-link.active .menu-bullet .bullet {\n    background-color: var(--bs-primary);\n  }\n  [data-kt-app-layout=light-sidebar] .app-header-menu .menu > .menu-item > .menu-link.active .menu-arrow:after {\n    mask-repeat: no-repeat;\n    mask-position: center;\n    -webkit-mask-repeat: no-repeat;\n    -webkit-mask-position: center;\n    background-color: var(--bs-primary);\n    -webkit-mask-image: url(\"data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 6 6' fill='var%28--bs-primary%29'%3e%3cpath d='M2.72011 2.76429L4.46358 1.02083C4.63618 0.848244 4.63617 0.568419 4.46358 0.395831C4.29099 0.223244 4.01118 0.223244 3.83861 0.395831L1.52904 2.70537C1.36629 2.86808 1.36629 3.13191 1.52904 3.29462L3.83861 5.60419C4.01117 5.77675 4.29099 5.77675 4.46358 5.60419C4.63617 5.43156 4.63617 5.15175 4.46358 4.97919L2.72011 3.23571C2.58994 3.10554 2.58994 2.89446 2.72011 2.76429Z'/%3e%3c/svg%3e\");\n    mask-image: url(\"data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 6 6' fill='var%28--bs-primary%29'%3e%3cpath d='M2.72011 2.76429L4.46358 1.02083C4.63618 0.848244 4.63617 0.568419 4.46358 0.395831C4.29099 0.223244 4.01118 0.223244 3.83861 0.395831L1.52904 2.70537C1.36629 2.86808 1.36629 3.13191 1.52904 3.29462L3.83861 5.60419C4.01117 5.77675 4.29099 5.77675 4.46358 5.60419C4.63617 5.43156 4.63617 5.15175 4.46358 4.97919L2.72011 3.23571C2.58994 3.10554 2.58994 2.89446 2.72011 2.76429Z'/%3e%3c/svg%3e\");\n    /*rtl:begin:remove*/\n    mask-repeat: no-repeat;\n    mask-position: center;\n    -webkit-mask-repeat: no-repeat;\n    -webkit-mask-position: center;\n    background-color: var(--bs-primary);\n    -webkit-mask-image: url(\"data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 6 6' fill='var%28--bs-primary%29'%3e%3cpath d='M3.27989 3.23571L1.53642 4.97917C1.36382 5.15176 1.36383 5.43158 1.53642 5.60417C1.70901 5.77676 1.98882 5.77676 2.16139 5.60417L4.47096 3.29463C4.63371 3.13192 4.63371 2.86809 4.47096 2.70538L2.16139 0.395812C1.98883 0.22325 1.70901 0.22325 1.53642 0.395812C1.36383 0.568437 1.36383 0.84825 1.53642 1.02081L3.27989 2.76429C3.41006 2.89446 3.41006 3.10554 3.27989 3.23571Z'/%3e%3c/svg%3e\");\n    mask-image: url(\"data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 6 6' fill='var%28--bs-primary%29'%3e%3cpath d='M3.27989 3.23571L1.53642 4.97917C1.36382 5.15176 1.36383 5.43158 1.53642 5.60417C1.70901 5.77676 1.98882 5.77676 2.16139 5.60417L4.47096 3.29463C4.63371 3.13192 4.63371 2.86809 4.47096 2.70538L2.16139 0.395812C1.98883 0.22325 1.70901 0.22325 1.53642 0.395812C1.36383 0.568437 1.36383 0.84825 1.53642 1.02081L3.27989 2.76429C3.41006 2.89446 3.41006 3.10554 3.27989 3.23571Z'/%3e%3c/svg%3e\");\n    /*rtl:end:remove*/\n  }\n}\n\n@media (min-width: 992px) {\n  [data-kt-app-layout=light-sidebar]:not([data-kt-app-header-fixed=true]) .app-header {\n    background-color: transparent;\n    box-shadow: none;\n    border-bottom: 1px solid var(--bs-app-sidebar-light-separator-color);\n  }\n}\n@media (max-width: 991.98px) {\n  [data-kt-app-layout=light-sidebar]:not([data-kt-app-header-fixed-mobile=true]) .app-header {\n    background-color: transparent;\n    box-shadow: none;\n    border-bottom: 1px solid var(--bs-app-sidebar-light-separator-color);\n  }\n}\n@media (min-width: 992px) {\n  [data-kt-app-toolbar-enabled=true]:not([data-kt-app-toolbar-fixed=true]) .app-content {\n    padding-top: 0;\n  }\n}\n@media (max-width: 991.98px) {\n  [data-kt-app-toolbar-enabled=true]:not([data-kt-app-toolbar-fixed-mobile=true]) .app-content {\n    padding-top: 0;\n  }\n}\n:is([data-kt-app-layout=light-sidebar], [data-kt-app-layout=light-header], [data-kt-app-layout=dark-header]) .app-toolbar .form-select.form-select {\n  background-color: var(--bs-body-bg) !important;\n}\n\n@media (min-width: 992px) {\n  body:not([data-kt-app-toolbar-fixed=true]) .app-toolbar {\n    height: auto;\n    background-color: transparent;\n    border-top: 0;\n    border-bottom: 0;\n    box-shadow: none;\n  }\n}\n@media (max-width: 991.98px) {\n  body:not([data-kt-app-toolbar-fixed-mobile=true]) .app-toolbar {\n    height: auto;\n    background-color: transparent;\n    border-top: 0;\n    border-bottom: 0;\n    box-shadow: none;\n  }\n}\n@media (min-width: 992px) {\n  [data-kt-app-layout=dark-header] .app-header .page-heading {\n    color: #ffffff !important;\n  }\n}\n","$white: #fff !default;\r\n\r\n// Khaki Shades\r\n$gray-50: #f0ead6 !default; // Very light khaki\r\n$gray-100: #000000 !default; // Lightest khaki\r\n$gray-150: #000000 !default; // Calendar Dates\r\n$gray-200: #000000 !default; // Calendar Title\r\n$gray-300: #b6b261 !default; // Light khaki\r\n$gray-400: #a8a545 !default;\r\n$gray-500: #999829 !default;\r\n$gray-600: #8b8b0d !default; // Standard khaki\r\n$gray-700: #7d7d00 !default;\r\n$gray-800: #6f6f00 !default; // Dark khaki\r\n$gray-900: #616100 !default; // Darkest khaki\r\n\r\n// Keeping black as is\r\n$black: #22292f !default;\r\n\r\n// Navy Green Accents\r\n$body-color: #987d5d !default; // \r\n$border-color: #425b4e !default; // borders\r\n$body-bg: #ce7d22 !important !default; // Header Color \r\n$text-muted: #3a5044 !default; // Muted navy green for less important text\r\n$card-bg: #987d5d; // Light navy green for card backgrounds\r\n$card-body: #b79e82; // BODY WHERE MESSAGES TRANSMIT\r\n$headings-color: #465c50 !default; // Darker navy green for headings\r\n$hover-btn: rgb(70, 92, 80) !important; // Dark navy green for button hover\r\n$hover-btn-border: #3d544b !important; // Darker navy green for button hover border\r\n$event-bg: #5a6f67 !default; // Translucent navy green for event backgrounds\r\n\r\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
